{
  "icons": [
    {
      "name": "3D-Cursor",
      "friendlyName": "3D cursor",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "3D cursor",
        "cursor",
        "health",
        "cube",
        "3D cube"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-Cursor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>3D-Cursor</title><polygon points=\"13 4 4 4 4 13.01 6 13.01 6 6 13 6 13 4\"/><path d=\"M29.49,13.12l-9-5a1,1,0,0,0-1,0l-9,5A1,1,0,0,0,10,14V24a1,1,0,0,0,.52.87l9,5A1,1,0,0,0,20,30a1.05,1.05,0,0,0,.49-.13l9-5A1,1,0,0,0,30,24V14A1,1,0,0,0,29.49,13.12ZM19,27.3l-7-3.89V15.69l7,3.89Zm1-9.45L13.06,14,20,10.14,26.94,14Zm8,5.56L21,27.3V19.58l7-3.89Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-Cursor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DCursor32",
          "filepath": "watson-health/3D-Cursor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z"
                }
              }
            ],
            "name": "3D-Cursor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DCursor24",
          "filepath": "watson-health/3D-Cursor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z"
                }
              }
            ],
            "name": "3D-Cursor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DCursor20",
          "filepath": "watson-health/3D-Cursor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z"
                }
              }
            ],
            "name": "3D-Cursor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DCursor16",
          "filepath": "watson-health/3D-Cursor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z"
                }
              }
            ],
            "name": "3D-Cursor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DCursor",
        "global": "WatsonHealth3DCursor",
        "filepath": "watson-health/3DCursor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-cursor--alt",
      "friendlyName": "3D cursor alt",
      "aliases": [
        "3D-cursor",
        "Watson",
        "IBM Watson",
        "Watson Health",
        "health",
        "crosshair",
        "circle",
        "cross"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-cursor--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>3D-cursor--alt</title><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/><rect x=\"15\" y=\"7\" width=\"2\" height=\"7\"/><rect x=\"7\" y=\"15\" width=\"7\" height=\"2\"/><rect x=\"15\" y=\"18\" width=\"2\" height=\"7\"/><rect x=\"18\" y=\"15\" width=\"7\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/><path d=\"M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-cursor--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DCursorAlt32",
          "filepath": "watson-health/3D-cursor--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z"
                }
              }
            ],
            "name": "3D-cursor--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DCursorAlt24",
          "filepath": "watson-health/3D-cursor--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z"
                }
              }
            ],
            "name": "3D-cursor--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DCursorAlt20",
          "filepath": "watson-health/3D-cursor--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z"
                }
              }
            ],
            "name": "3D-cursor--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DCursorAlt16",
          "filepath": "watson-health/3D-cursor--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z"
                }
              }
            ],
            "name": "3D-cursor--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DCursorAlt",
        "global": "WatsonHealth3DCursorAlt",
        "filepath": "watson-health/3DCursorAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-curve--auto-colon",
      "friendlyName": "3D curve auto colon",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "health",
        "curve",
        "3D curve",
        "auto colon",
        "health",
        "spline",
        "s curve",
        "lineage",
        "data",
        "governance"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-curve--auto-colon.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--3D-curve--auto-colon</title><path d=\"M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-curve--auto-colon.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DCurveAutoColon32",
          "filepath": "watson-health/3D-curve--auto-colon/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-colon",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DCurveAutoColon24",
          "filepath": "watson-health/3D-curve--auto-colon/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-colon",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DCurveAutoColon20",
          "filepath": "watson-health/3D-curve--auto-colon/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-colon",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DCurveAutoColon16",
          "filepath": "watson-health/3D-curve--auto-colon/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-colon",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DCurveAutoColon",
        "global": "WatsonHealth3DCurveAutoColon",
        "filepath": "watson-health/3DCurveAutoColon.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-curve--auto-vessels",
      "friendlyName": "3D curve auto vessels",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "curve",
        "3D curve",
        "auto vessels",
        "spline"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-curve--auto-vessels.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--3D-curve--auto-vessels</title><path d=\"M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-curve--auto-vessels.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DCurveAutoVessels32",
          "filepath": "watson-health/3D-curve--auto-vessels/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-vessels",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DCurveAutoVessels24",
          "filepath": "watson-health/3D-curve--auto-vessels/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-vessels",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DCurveAutoVessels20",
          "filepath": "watson-health/3D-curve--auto-vessels/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-vessels",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DCurveAutoVessels16",
          "filepath": "watson-health/3D-curve--auto-vessels/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                }
              }
            ],
            "name": "3D-curve--auto-vessels",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DCurveAutoVessels",
        "global": "WatsonHealth3DCurveAutoVessels",
        "filepath": "watson-health/3DCurveAutoVessels.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-curve--manual",
      "friendlyName": "3D curve manual",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "health",
        "curve",
        "3D curve",
        "manual curve",
        "3D manual curve",
        "spline"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-curve--manual.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--3D-curve--manual</title><path d=\"M15,21a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z\"/><rect x=\"15\" y=\"13\" width=\"2\" height=\"6\"/><path d=\"M25,2a5,5,0,0,0-4.9,4H20a5,5,0,0,0-5,5h2a3,3,0,0,1,3-3h.1A5,5,0,1,0,25,2Zm0,8a3,3,0,1,1,3-3A3,3,0,0,1,25,10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-curve--manual.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DCurveManual32",
          "filepath": "watson-health/3D-curve--manual/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z"
                }
              }
            ],
            "name": "3D-curve--manual",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DCurveManual24",
          "filepath": "watson-health/3D-curve--manual/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z"
                }
              }
            ],
            "name": "3D-curve--manual",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DCurveManual20",
          "filepath": "watson-health/3D-curve--manual/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z"
                }
              }
            ],
            "name": "3D-curve--manual",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DCurveManual16",
          "filepath": "watson-health/3D-curve--manual/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z"
                }
              }
            ],
            "name": "3D-curve--manual",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DCurveManual",
        "global": "WatsonHealth3DCurveManual",
        "filepath": "watson-health/3DCurveManual.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-iCa",
      "friendlyName": "3D ICA",
      "aliases": [
        "iCA",
        "3D iCA",
        "dimension",
        "cube",
        "3D cube",
        "space",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-iCa.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--iCA-3D</title><path d=\"M15,14H10a2,2,0,0,1-2-2V4a2,2,0,0,1,.59-1.42A3.57,3.57,0,0,1,10,2h5V4H10v8h5Z\"/><rect x=\"4\" y=\"6\" width=\"2\" height=\"8\"/><rect x=\"4\" y=\"2\" width=\"2\" height=\"2\"/><path d=\"M27.45,19.11l-6-3a1,1,0,0,0-.9,0l-6,3A1,1,0,0,0,14,20v7a1,1,0,0,0,.55.89l6,3a1,1,0,0,0,.9,0l6-3A1,1,0,0,0,28,27V20A1,1,0,0,0,27.45,19.11Zm-6.45-1L24.76,20,21,21.88,17.24,20Zm-5,3.5,4,2v4.76l-4-2Zm6,6.76V23.62l4-2v4.76Z\"/><path d=\"M23,2H19a2,2,0,0,0-2,2V14h2V10h4v4h2V4A2,2,0,0,0,23,2ZM19,8V4h4V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-iCa.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DICa32",
          "filepath": "watson-health/3D-iCa/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z"
                }
              }
            ],
            "name": "3D-iCa",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DICa24",
          "filepath": "watson-health/3D-iCa/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z"
                }
              }
            ],
            "name": "3D-iCa",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DICa20",
          "filepath": "watson-health/3D-iCa/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z"
                }
              }
            ],
            "name": "3D-iCa",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DICa16",
          "filepath": "watson-health/3D-iCa/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z"
                }
              }
            ],
            "name": "3D-iCa",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DICa",
        "global": "WatsonHealth3DICa",
        "filepath": "watson-health/3DICa.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-MPR-Toggle",
      "friendlyName": "3D MPR toggle",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "mpr toggle",
        "health",
        "3D mpr toggle",
        "Carbon 3D mpr toggle"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-MPR-Toggle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--3D-MPR-Toggle</title><polygon points=\"11 2 2 2 2 11 4 11 4 4 11 4 11 2\"/><polygon points=\"2 21 2 30 11 30 11 28 4 28 4 21 2 21\"/><polygon points=\"30 11 30 2 21 2 21 4 28 4 28 11 30 11\"/><polygon points=\"21 30 30 30 30 21 28 21 28 28 21 28 21 30\"/><path d=\"M25.49,10.13l-9-5a1,1,0,0,0-1,0l-9,5A1,1,0,0,0,6,11V21a1,1,0,0,0,.51.87l9,5a1,1,0,0,0,1,0l9-5A1,1,0,0,0,26,21V11A1,1,0,0,0,25.49,10.13ZM16,7.14,22.94,11,16,14.86,9.06,11ZM8,12.7l7,3.89V24.3L8,20.41Zm9,11.6V16.59l7-3.89v7.71Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-MPR-Toggle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DMprToggle32",
          "filepath": "watson-health/3D-MPR-Toggle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z"
                }
              }
            ],
            "name": "3D-MPR-Toggle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DMprToggle24",
          "filepath": "watson-health/3D-MPR-Toggle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z"
                }
              }
            ],
            "name": "3D-MPR-Toggle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DMprToggle20",
          "filepath": "watson-health/3D-MPR-Toggle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z"
                }
              }
            ],
            "name": "3D-MPR-Toggle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DMprToggle16",
          "filepath": "watson-health/3D-MPR-Toggle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z"
                }
              }
            ],
            "name": "3D-MPR-Toggle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DMprToggle",
        "global": "WatsonHealth3DMprToggle",
        "filepath": "watson-health/3DMprToggle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-print-mesh",
      "friendlyName": "3D print mesh",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "3D print mesh",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-print-mesh.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-print-mesh.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DPrintMesh32",
          "filepath": "watson-health/3D-print-mesh/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
                }
              }
            ],
            "name": "3D-print-mesh",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DPrintMesh24",
          "filepath": "watson-health/3D-print-mesh/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
                }
              }
            ],
            "name": "3D-print-mesh",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DPrintMesh20",
          "filepath": "watson-health/3D-print-mesh/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
                }
              }
            ],
            "name": "3D-print-mesh",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DPrintMesh16",
          "filepath": "watson-health/3D-print-mesh/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
                }
              }
            ],
            "name": "3D-print-mesh",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DPrintMesh",
        "global": "WatsonHealth3DPrintMesh",
        "filepath": "watson-health/3DPrintMesh.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3D-software",
      "friendlyName": "3D software",
      "aliases": [
        "3D software",
        "cube",
        "health",
        "cube plus",
        "cube plus sign",
        "health software"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3D-software.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>3D-software</title><path d=\"M21.49,13.1151l-9-5a1,1,0,0,0-1,0l-9,5A1.0078,1.0078,0,0,0,2,14v9.9951a1,1,0,0,0,.52.87l9,5A1.0045,1.0045,0,0,0,12,30a1.0559,1.0559,0,0,0,.49-.1349l9-5A.9923.9923,0,0,0,22,24V14A1.0079,1.0079,0,0,0,21.49,13.1151ZM11,27.2951l-7-3.89v-7.72l7,3.89Zm1-9.45L5.06,14,12,10.1351l6.94,3.86Zm8,5.56-7,3.89v-7.72l7-3.89Z\"/><polygon points=\"30 6 26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3D-software.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3DSoftware32",
          "filepath": "watson-health/3D-software/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              }
            ],
            "name": "3D-software",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3DSoftware24",
          "filepath": "watson-health/3D-software/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              }
            ],
            "name": "3D-software",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3DSoftware20",
          "filepath": "watson-health/3D-software/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              }
            ],
            "name": "3D-software",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3DSoftware16",
          "filepath": "watson-health/3D-software/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              }
            ],
            "name": "3D-software",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3DSoftware",
        "global": "WatsonHealth3DSoftware",
        "filepath": "watson-health/3DSoftware.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "3rd-party-connected",
      "friendlyName": "Third-party connect",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "health",
        "third-party connect",
        "dots",
        "connection",
        "communication",
        "lattice",
        "group",
        "dependent"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/3rd-party-connected.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--3rd-party-connected</title><path d=\"M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/3rd-party-connected.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealth3rdPartyConnected32",
          "filepath": "watson-health/3rd-party-connected/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              }
            ],
            "name": "3rd-party-connected",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealth3rdPartyConnected24",
          "filepath": "watson-health/3rd-party-connected/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              }
            ],
            "name": "3rd-party-connected",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealth3rdPartyConnected20",
          "filepath": "watson-health/3rd-party-connected/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              }
            ],
            "name": "3rd-party-connected",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealth3rdPartyConnected16",
          "filepath": "watson-health/3rd-party-connected/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              }
            ],
            "name": "3rd-party-connected",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "_3rdPartyConnected",
        "global": "WatsonHealth3rdPartyConnected",
        "filepath": "watson-health/3rdPartyConnected.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "4K",
      "friendlyName": "4K",
      "aliases": [
        "four k",
        "resolution",
        "pixels",
        "HD",
        "high definition",
        "file size",
        "4K file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/4K.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>4K</title><polygon points=\"12 11.03 12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03\"/><polygon points=\"24.19 11.03 22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03\"/><path d=\"M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z\"/><path d=\"M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z\"/></svg>",
            "info": {},
            "path": "32/4K.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "_4K32",
          "filepath": "4K/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "4K",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "_4K24",
          "filepath": "4K/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "4K",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "_4K20",
          "filepath": "4K/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "4K",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "_4K16",
          "filepath": "4K/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "4K",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "_4K",
        "global": "_4K",
        "filepath": "4K.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "4K--filled",
      "friendlyName": "4K filled",
      "aliases": [
        "four k",
        "four K filled",
        "4K",
        "4K filled",
        "4K file",
        "resolution",
        "pixels",
        "HD",
        "high definition",
        "file size"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/4K--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>4K--filled</title><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z\"/></svg>",
            "info": {},
            "path": "32/4K--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "_4KFilled32",
          "filepath": "4K--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
                }
              }
            ],
            "name": "4K--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "_4KFilled24",
          "filepath": "4K--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
                }
              }
            ],
            "name": "4K--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "_4KFilled20",
          "filepath": "4K--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
                }
              }
            ],
            "name": "4K--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "_4KFilled16",
          "filepath": "4K--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
                }
              }
            ],
            "name": "4K--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "_4KFilled",
        "global": "_4KFilled",
        "filepath": "4KFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accessibility",
      "friendlyName": "Accessibility",
      "aliases": [
        "wheelchair",
        "convenience",
        "accessible"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accessibility.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>accessibility</title><path d=\"M29.55,26.11,26.5,27.63,23.66,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,4,0v4h7V15H19V13a4,4,0,0,0-8,0v1a9,9,0,1,0,8.77,11H17.71A7,7,0,1,1,11,16v3a4,4,0,0,0,4,4h7.34l3.16,7.37,4.95-2.48Z\"/><path d=\"M15.5,8A3.5,3.5,0,1,1,19,4.5,3.5,3.5,0,0,1,15.5,8Zm0-5A1.5,1.5,0,1,0,17,4.5,1.5,1.5,0,0,0,15.5,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z\"/></svg>",
            "info": {},
            "path": "32/accessibility.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Accessibility32",
          "filepath": "accessibility/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z"
                }
              }
            ],
            "name": "accessibility",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Accessibility24",
          "filepath": "accessibility/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z"
                }
              }
            ],
            "name": "accessibility",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Accessibility20",
          "filepath": "accessibility/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z"
                }
              }
            ],
            "name": "accessibility",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Accessibility16",
          "filepath": "accessibility/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z"
                }
              }
            ],
            "name": "accessibility",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Accessibility",
        "global": "Accessibility",
        "filepath": "Accessibility.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accessibility--alt",
      "friendlyName": "Accessibility alt",
      "aliases": [
        "wheelchair",
        "convenience",
        "accessible",
        "user accessibility",
        "handicap",
        "handicapped",
        "handicap accessibility",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accessibility--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>accessibility--alt</title><polygon points=\"23 14 23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14\"/><circle cx=\"16\" cy=\"9\" r=\"2\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z\"/><circle cx=\"16\" cy=\"9\" r=\"2\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/accessibility--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AccessibilityAlt32",
          "filepath": "accessibility--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AccessibilityAlt24",
          "filepath": "accessibility--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AccessibilityAlt20",
          "filepath": "accessibility--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AccessibilityAlt16",
          "filepath": "accessibility--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "AccessibilityAlt",
        "global": "AccessibilityAlt",
        "filepath": "AccessibilityAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "9",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accessibility--color",
      "friendlyName": "Accessibility color",
      "aliases": [
        "wheelchair",
        "wheelchair accessible",
        "convenience",
        "accessible",
        "accessibility color",
        "user accessibility",
        "handicap",
        "handicapped",
        "handicap accessibility",
        "handicap accessible",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accessibility--color.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>accessibility--color</title><path d=\"M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z\"/><path d=\"M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z\"/><path d=\"M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/accessibility--color.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AccessibilityColor32",
          "filepath": "accessibility--color/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--color",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AccessibilityColor24",
          "filepath": "accessibility--color/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--color",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AccessibilityColor20",
          "filepath": "accessibility--color/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--color",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AccessibilityColor16",
          "filepath": "accessibility--color/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "accessibility--color",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "AccessibilityColor",
        "global": "AccessibilityColor",
        "filepath": "AccessibilityColor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accessibility--color--filled",
      "friendlyName": "Accessibility color filled",
      "aliases": [
        "wheelchair",
        "wheelchair acessible",
        "convenience",
        "accessible",
        "accessiblity color filled",
        "user accessibility",
        "handicap",
        "handicapped",
        "handicap accessibility",
        "handicap accessible",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accessibility--color--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>accessibility--color--filled</title><path d=\"M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><path id=\"inner-path_2\" data-name=\"inner-path 2\" class=\"cls-1\" d=\"M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z\"/><path id=\"inner-path_1\" data-name=\"inner-path 1\" class=\"cls-1\" d=\"M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><path fill=\"none\" d=\"M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z\"/><path fill=\"none\" d=\"M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z\"/></svg>",
            "info": {},
            "path": "32/accessibility--color--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AccessibilityColorFilled32",
          "filepath": "accessibility--color--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              }
            ],
            "name": "accessibility--color--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AccessibilityColorFilled24",
          "filepath": "accessibility--color--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              }
            ],
            "name": "accessibility--color--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AccessibilityColorFilled20",
          "filepath": "accessibility--color--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              }
            ],
            "name": "accessibility--color--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AccessibilityColorFilled16",
          "filepath": "accessibility--color--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                }
              }
            ],
            "name": "accessibility--color--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "AccessibilityColorFilled",
        "global": "AccessibilityColorFilled",
        "filepath": "AccessibilityColorFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "account",
      "friendlyName": "Account",
      "aliases": [
        "account",
        "commerce",
        "report",
        "narrative",
        "record",
        "documentation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/account.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>account</title><path d=\"M8,14H19v2H8Zm0,5H21v2H8Z\"/><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8,14H19v2H8Zm0,5H21v2H8Z\"/><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z\"/></svg>",
            "info": {},
            "path": "32/account.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Account32",
          "filepath": "account/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,14H19v2H8Zm0,5H21v2H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "account",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Account24",
          "filepath": "account/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,14H19v2H8Zm0,5H21v2H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "account",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Account20",
          "filepath": "account/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,14H19v2H8Zm0,5H21v2H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "account",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Account16",
          "filepath": "account/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,14H19v2H8Zm0,5H21v2H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "account",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Account",
        "global": "Account",
        "filepath": "Account.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,14H19v2H8Zm0,5H21v2H8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accumulation--ice",
      "friendlyName": "Accumulation ice",
      "aliases": [
        "gauge",
        "measurement",
        "quantity",
        "accumulation",
        "ice",
        "weather",
        "record",
        "measure",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accumulation--ice.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 8 22 16 23 18 24 16 24 8 22 8\"/>\n  <polygon points=\"18 8 18 18 19 20 20 18 20 8 18 8\"/>\n  <path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z\"/><path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z\"/></svg>",
            "info": {},
            "path": "32/accumulation--ice.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AccumulationIce32",
          "filepath": "accumulation--ice/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--ice",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AccumulationIce24",
          "filepath": "accumulation--ice/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--ice",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AccumulationIce20",
          "filepath": "accumulation--ice/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--ice",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AccumulationIce16",
          "filepath": "accumulation--ice/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--ice",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "AccumulationIce",
        "global": "AccumulationIce",
        "filepath": "AccumulationIce.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accumulation--precipitation",
      "friendlyName": "Accumulation precipitation",
      "aliases": [
        "gauge",
        "measurement",
        "quantity",
        "accumulation",
        "precipitation",
        "weather",
        "record",
        "measure"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accumulation--precipitation.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"16\" y=\"16\" width=\"2\" height=\"2\"/>\n  <rect x=\"18\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"20\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"16\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"20\" width=\"2\" height=\"2\"/>\n  <path d=\"M20,12a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L19.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L23.3154,6.11A3.9693,3.9693,0,0,1,24,8.223,3.8978,3.8978,0,0,1,20,12Zm0-7.2368L18.3438,7.2257A1.89,1.89,0,0,0,18,8.223,1.9,1.9,0,0,0,20,10a1.9,1.9,0,0,0,2-1.777,1.98,1.98,0,0,0-.375-1.0466Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z\"/><path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z\"/></svg>",
            "info": {},
            "path": "32/accumulation--precipitation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AccumulationPrecipitation32",
          "filepath": "accumulation--precipitation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--precipitation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AccumulationPrecipitation24",
          "filepath": "accumulation--precipitation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--precipitation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AccumulationPrecipitation20",
          "filepath": "accumulation--precipitation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--precipitation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AccumulationPrecipitation16",
          "filepath": "accumulation--precipitation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--precipitation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "AccumulationPrecipitation",
        "global": "AccumulationPrecipitation",
        "filepath": "AccumulationPrecipitation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accumulation--rain",
      "friendlyName": "Accumulation rain",
      "aliases": [
        "gauge",
        "measurement",
        "quantity",
        "accumulation",
        "precipitation",
        "weather",
        "record",
        "measure",
        "rain"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accumulation--rain.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z\"/></svg>",
            "info": {},
            "path": "32/accumulation--rain.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AccumulationRain32",
          "filepath": "accumulation--rain/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
                }
              }
            ],
            "name": "accumulation--rain",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AccumulationRain24",
          "filepath": "accumulation--rain/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
                }
              }
            ],
            "name": "accumulation--rain",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AccumulationRain20",
          "filepath": "accumulation--rain/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
                }
              }
            ],
            "name": "accumulation--rain",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AccumulationRain16",
          "filepath": "accumulation--rain/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
                }
              }
            ],
            "name": "accumulation--rain",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "AccumulationRain",
        "global": "AccumulationRain",
        "filepath": "AccumulationRain.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "accumulation--snow",
      "friendlyName": "Accumulation snow",
      "aliases": [
        "gauge",
        "measurement",
        "quantity",
        "accumulation",
        "precipitation",
        "weather",
        "record",
        "measure",
        "snow"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/accumulation--snow.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"12\" y=\"2\" width=\"2\" height=\"2\"/>\n  <rect x=\"14\" y=\"4\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"6\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"2\" width=\"2\" height=\"2\"/>\n  <rect x=\"12\" y=\"6\" width=\"2\" height=\"2\"/>\n  <rect x=\"14\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"20\" width=\"2\" height=\"2\"/>\n  <rect x=\"18\" y=\"22\" width=\"2\" height=\"2\"/>\n  <rect x=\"18\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"14\" y=\"22\" width=\"2\" height=\"2\"/>\n  <rect x=\"18\" y=\"10\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"12\" width=\"2\" height=\"2\"/>\n  <rect x=\"22\" y=\"14\" width=\"2\" height=\"2\"/>\n  <rect x=\"22\" y=\"10\" width=\"2\" height=\"2\"/>\n  <rect x=\"18\" y=\"14\" width=\"2\" height=\"2\"/>\n  <path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z\"/><path d=\"M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z\"/></svg>",
            "info": {},
            "path": "32/accumulation--snow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AccumulationSnow32",
          "filepath": "accumulation--snow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--snow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AccumulationSnow24",
          "filepath": "accumulation--snow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--snow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AccumulationSnow20",
          "filepath": "accumulation--snow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--snow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AccumulationSnow16",
          "filepath": "accumulation--snow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                }
              }
            ],
            "name": "accumulation--snow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "AccumulationSnow",
        "global": "AccumulationSnow",
        "filepath": "AccumulationSnow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "activity",
      "friendlyName": "Activity",
      "aliases": [
        "line chart",
        "vital",
        "action",
        "heartbeat",
        "activity",
        "data",
        "data analytics",
        "data activity",
        "data tracking",
        "tracking"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/activity.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>activity</title><path d=\"M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z\"/></svg>",
            "info": {},
            "path": "32/activity.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Activity32",
          "filepath": "activity/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
                }
              }
            ],
            "name": "activity",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Activity24",
          "filepath": "activity/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
                }
              }
            ],
            "name": "activity",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Activity20",
          "filepath": "activity/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
                }
              }
            ],
            "name": "activity",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Activity16",
          "filepath": "activity/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
                }
              }
            ],
            "name": "activity",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Activity",
        "global": "Activity",
        "filepath": "Activity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "add",
      "friendlyName": "Add",
      "aliases": [
        "plus",
        "positive",
        "addition",
        "increase",
        "navigation",
        "include",
        "plus sign"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/add.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"17,15 17,8 15,8 15,15 8,15 8,17 15,17 15,24 17,24 17,17 24,17 24,15 \"/>\n<rect class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z\"/></svg>",
            "info": {},
            "path": "32/add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Add32",
          "filepath": "add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
                }
              }
            ],
            "name": "add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Add24",
          "filepath": "add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
                }
              }
            ],
            "name": "add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Add20",
          "filepath": "add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
                }
              }
            ],
            "name": "add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Add16",
          "filepath": "add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
                }
              }
            ],
            "name": "add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Add",
        "global": "Add",
        "filepath": "Add.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "add--alt",
      "friendlyName": "Add alt",
      "aliases": [
        "plus",
        "positive",
        "addition",
        "increase",
        "navigation",
        "include",
        "plus sign"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/add--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\n\tS23.7,2,16,2z\"/>\n<polygon points=\"24,15 17,15 17,8 15,8 15,15 8,15 8,17 15,17 15,24 17,24 17,17 24,17 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z\"/><path d=\"M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z\"/></svg>",
            "info": {},
            "path": "32/add--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AddAlt32",
          "filepath": "add--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
                }
              }
            ],
            "name": "add--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AddAlt24",
          "filepath": "add--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
                }
              }
            ],
            "name": "add--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AddAlt20",
          "filepath": "add--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
                }
              }
            ],
            "name": "add--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AddAlt16",
          "filepath": "add--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
                }
              }
            ],
            "name": "add--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "AddAlt",
        "global": "AddAlt",
        "filepath": "AddAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14 S23.7,2,16,2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "add--filled",
      "friendlyName": "Add filled",
      "aliases": [
        "plus",
        "positive",
        "addition",
        "increase",
        "navigation",
        "include",
        "plus sign",
        "plus sign filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/add--filled.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #fff;\n        fill-opacity: 0;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>add--filled</title>\n  <path d=\"M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z\" transform=\"translate(0 0)\"/>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"24 17 17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z\"/><path fill=\"none\" d=\"M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/add--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AddFilled32",
          "filepath": "add--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "add--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AddFilled24",
          "filepath": "add--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "add--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AddFilled20",
          "filepath": "add--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "add--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AddFilled16",
          "filepath": "add--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "add--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "AddFilled",
        "global": "AddFilled",
        "filepath": "AddFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "add-comment",
      "friendlyName": "Add comment",
      "aliases": [
        "add",
        "comment",
        "chat",
        "bubble",
        "operations",
        "comment bubble",
        "add comment",
        "remark",
        "add remark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/add-comment.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>add-comment</title><path d=\"M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z\" transform=\"translate(0 0)\"/><polygon points=\"17 9 15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z\"/><path d=\"M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z\"/></svg>",
            "info": {},
            "path": "32/add-comment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AddComment32",
          "filepath": "add-comment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
                }
              }
            ],
            "name": "add-comment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AddComment24",
          "filepath": "add-comment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
                }
              }
            ],
            "name": "add-comment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AddComment20",
          "filepath": "add-comment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
                }
              }
            ],
            "name": "add-comment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AddComment16",
          "filepath": "add-comment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
                }
              }
            ],
            "name": "add-comment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "AddComment",
        "global": "AddComment",
        "filepath": "AddComment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "agriculture-analytics",
      "friendlyName": "Agriculture analytics",
      "aliases": [
        "agriculture",
        "analytics",
        "farming",
        "food",
        "production",
        "analysis",
        "charts",
        "record"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/agriculture-analytics.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24.251,21.3691l2.1943,1.4629A1,1,0,0,0,27.8,22.6l3-4-1.6-1.2-2.4326,3.2437L24.5547,19.168a1,1,0,0,0-1.3687.2509L20,23.8789V16H18V26a2.0023,2.0023,0,0,0,2,2H30V26H20.9434Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"21\" width=\"14\" height=\"2\"/>\n  <rect x=\"2\" y=\"26\" width=\"14\" height=\"2\"/>\n  <path d=\"M11,16V11h1a4.0046,4.0046,0,0,0,4-4V4H13a3.9782,3.9782,0,0,0-2.7468,1.1066A6.0033,6.0033,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.0019,2.0019,0,0,1,13,6ZM8,9A4.0046,4.0046,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z\"/></svg>",
            "info": {},
            "path": "32/agriculture-analytics.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AgricultureAnalytics32",
          "filepath": "agriculture-analytics/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "agriculture-analytics",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AgricultureAnalytics24",
          "filepath": "agriculture-analytics/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "agriculture-analytics",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AgricultureAnalytics20",
          "filepath": "agriculture-analytics/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "agriculture-analytics",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AgricultureAnalytics16",
          "filepath": "agriculture-analytics/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "agriculture-analytics",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "AgricultureAnalytics",
        "global": "AgricultureAnalytics",
        "filepath": "AgricultureAnalytics.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-results",
      "friendlyName": "AI results",
      "aliases": [
        "ai",
        "results",
        "health",
        "watson"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-results.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,8a5.9908,5.9908,0,0,0,9.4712,4.8853L28.586,16,30,14.586l-3.115-3.1148A5.997,5.997,0,1,0,16,8Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,18,8Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0055,8.0055,0,0,1,6-7.7373L13.6138,2.3A10.0088,10.0088,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.0493,16a9.5991,9.5991,0,0,1-1.8716,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857a10.9664,10.9664,0,0,0,2.3686-2.8331Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-results.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiResults32",
          "filepath": "watson-health/ai-results/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z"
                }
              }
            ],
            "name": "ai-results",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiResults24",
          "filepath": "watson-health/ai-results/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z"
                }
              }
            ],
            "name": "ai-results",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiResults20",
          "filepath": "watson-health/ai-results/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z"
                }
              }
            ],
            "name": "ai-results",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiResults16",
          "filepath": "watson-health/ai-results/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z"
                }
              }
            ],
            "name": "ai-results",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiResults",
        "global": "WatsonHealthAiResults",
        "filepath": "watson-health/AiResults.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-results--high",
      "friendlyName": "AI results high",
      "aliases": [
        "ai",
        "results",
        "health",
        "watson",
        "high"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-results--high.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M23.0488,16a9.6136,9.6136,0,0,1-1.8711,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9886,9.9886,0,0,0,25.2815,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,4a7.9279,7.9279,0,0,1,3.69.9106l.8958-1.791A9.99,9.99,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851,7.1851,0,0,1,8,12,8.0092,8.0092,0,0,1,16,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29,14H19a1,1,0,0,1-.8945-1.4473l5-10a1,1,0,0,1,1.7888,0l5,10A1,1,0,0,1,29,14Zm-8.3818-2h6.7636L24,5.2361Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-results--high.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiResultsHigh32",
          "filepath": "watson-health/ai-results--high/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z"
                }
              }
            ],
            "name": "ai-results--high",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiResultsHigh24",
          "filepath": "watson-health/ai-results--high/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z"
                }
              }
            ],
            "name": "ai-results--high",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiResultsHigh20",
          "filepath": "watson-health/ai-results--high/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z"
                }
              }
            ],
            "name": "ai-results--high",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiResultsHigh16",
          "filepath": "watson-health/ai-results--high/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z"
                }
              }
            ],
            "name": "ai-results--high",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiResultsHigh",
        "global": "WatsonHealthAiResultsHigh",
        "filepath": "watson-health/AiResultsHigh.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-results--low",
      "friendlyName": "AI results low",
      "aliases": [
        "ai",
        "results",
        "health",
        "watson",
        "low"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-results--low.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24,14a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,14ZM24,4a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-results--low.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiResultsLow32",
          "filepath": "watson-health/ai-results--low/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--low",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiResultsLow24",
          "filepath": "watson-health/ai-results--low/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--low",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiResultsLow20",
          "filepath": "watson-health/ai-results--low/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--low",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiResultsLow16",
          "filepath": "watson-health/ai-results--low/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--low",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiResultsLow",
        "global": "WatsonHealthAiResultsLow",
        "filepath": "watson-health/AiResultsLow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-results--medium",
      "friendlyName": "AI results medium",
      "aliases": [
        "ai",
        "results",
        "health",
        "watson",
        "medium"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-results--medium.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,14H20a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,14ZM20,4v8h8V4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-results--medium.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiResultsMedium32",
          "filepath": "watson-health/ai-results--medium/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--medium",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiResultsMedium24",
          "filepath": "watson-health/ai-results--medium/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--medium",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiResultsMedium20",
          "filepath": "watson-health/ai-results--medium/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--medium",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiResultsMedium16",
          "filepath": "watson-health/ai-results--medium/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--medium",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiResultsMedium",
        "global": "WatsonHealthAiResultsMedium",
        "filepath": "watson-health/AiResultsMedium.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-results--urgent",
      "friendlyName": "AI results urgent",
      "aliases": [
        "ai",
        "results",
        "health",
        "watson",
        "urgent"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-results--urgent.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"20\" y=\"2\" width=\"2\" height=\"7\"/>\n  <path d=\"M21,11a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,21,11Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"26\" y=\"2\" width=\"2\" height=\"7\"/>\n  <path d=\"M27,11a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,27,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-results--urgent.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiResultsUrgent32",
          "filepath": "watson-health/ai-results--urgent/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--urgent",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiResultsUrgent24",
          "filepath": "watson-health/ai-results--urgent/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--urgent",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiResultsUrgent20",
          "filepath": "watson-health/ai-results--urgent/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--urgent",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiResultsUrgent16",
          "filepath": "watson-health/ai-results--urgent/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                }
              }
            ],
            "name": "ai-results--urgent",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiResultsUrgent",
        "global": "WatsonHealthAiResultsUrgent",
        "filepath": "watson-health/AiResultsUrgent.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-results--very-high",
      "friendlyName": "AI results very high",
      "aliases": [
        "ai",
        "results",
        "health",
        "watson",
        "very high"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-results--very-high.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"24\" y=\"2\" width=\"2\" height=\"7\"/>\n  <path d=\"M25,11a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,25,11Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M23.0488,16a9.6136,9.6136,0,0,1-1.8711,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9886,9.9886,0,0,0,25.2815,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,4a7.94,7.94,0,0,1,4,1.0825V2.8408A9.9887,9.9887,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851,7.1851,0,0,1,8,12,8.0092,8.0092,0,0,1,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-results--very-high.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiResultsVeryHigh32",
          "filepath": "watson-health/ai-results--very-high/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z"
                }
              }
            ],
            "name": "ai-results--very-high",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiResultsVeryHigh24",
          "filepath": "watson-health/ai-results--very-high/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z"
                }
              }
            ],
            "name": "ai-results--very-high",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiResultsVeryHigh20",
          "filepath": "watson-health/ai-results--very-high/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z"
                }
              }
            ],
            "name": "ai-results--very-high",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiResultsVeryHigh16",
          "filepath": "watson-health/ai-results--very-high/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z"
                }
              }
            ],
            "name": "ai-results--very-high",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiResultsVeryHigh",
        "global": "WatsonHealthAiResultsVeryHigh",
        "filepath": "watson-health/AiResultsVeryHigh.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-status",
      "friendlyName": "AI status",
      "aliases": [
        "ai",
        "status",
        "health",
        "watson"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-status.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,14a1,1,0,0,1-.8945-.5527L17.3818,10H14V8h4a1,1,0,0,1,.8945.5527L20,10.7639l3.1055-6.2112a1.0416,1.0416,0,0,1,1.789,0L26.6182,8H30v2H26a1,1,0,0,1-.8945-.5527L24,7.2361l-3.1055,6.2112A1,1,0,0,1,20,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z\"/><path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-status.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiStatus32",
          "filepath": "watson-health/ai-status/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
                }
              }
            ],
            "name": "ai-status",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiStatus24",
          "filepath": "watson-health/ai-status/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
                }
              }
            ],
            "name": "ai-status",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiStatus20",
          "filepath": "watson-health/ai-status/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
                }
              }
            ],
            "name": "ai-status",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiStatus16",
          "filepath": "watson-health/ai-status/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
                }
              }
            ],
            "name": "ai-status",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiStatus",
        "global": "WatsonHealthAiStatus",
        "filepath": "watson-health/AiStatus.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-status--complete",
      "friendlyName": "AI status complete",
      "aliases": [
        "ai",
        "status complete",
        "health",
        "watson"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-status--complete.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"21 9.59 17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59\"/>\n  <path d=\"M23.8,14a7.28,7.28,0,0,1-2.6219,4.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.1426,9.1426,0,0,0,25.8389,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-status--complete.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiStatusComplete32",
          "filepath": "watson-health/ai-status--complete/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z"
                }
              }
            ],
            "name": "ai-status--complete",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiStatusComplete24",
          "filepath": "watson-health/ai-status--complete/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z"
                }
              }
            ],
            "name": "ai-status--complete",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiStatusComplete20",
          "filepath": "watson-health/ai-status--complete/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z"
                }
              }
            ],
            "name": "ai-status--complete",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiStatusComplete16",
          "filepath": "watson-health/ai-status--complete/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z"
                }
              }
            ],
            "name": "ai-status--complete",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiStatusComplete",
        "global": "WatsonHealthAiStatusComplete",
        "filepath": "watson-health/AiStatusComplete.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-status--failed",
      "friendlyName": "AI status failed",
      "aliases": [
        "ai",
        "status failed",
        "health",
        "watson"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-status--failed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.8,14a7.28,7.28,0,0,1-2.6219,4.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.1426,9.1426,0,0,0,25.8389,14Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-status--failed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiStatusFailed32",
          "filepath": "watson-health/ai-status--failed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              }
            ],
            "name": "ai-status--failed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiStatusFailed24",
          "filepath": "watson-health/ai-status--failed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              }
            ],
            "name": "ai-status--failed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiStatusFailed20",
          "filepath": "watson-health/ai-status--failed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              }
            ],
            "name": "ai-status--failed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiStatusFailed16",
          "filepath": "watson-health/ai-status--failed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              }
            ],
            "name": "ai-status--failed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiStatusFailed",
        "global": "WatsonHealthAiStatusFailed",
        "filepath": "watson-health/AiStatusFailed.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-status--in-progress",
      "friendlyName": "AI status in progress",
      "aliases": [
        "ai",
        "status in progress",
        "health",
        "watson"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-status--in-progress.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M21.1777,18.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.193,9.193,0,0,0,26,12H24A7.2032,7.2032,0,0,1,21.1777,18.1426Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"18.5\" cy=\"7.5\" r=\"1.5\"/>\n  <circle cx=\"28.5\" cy=\"7.5\" r=\"1.5\"/>\n  <circle cx=\"23.5\" cy=\"7.5\" r=\"1.5\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z\"/><circle cx=\"18.5\" cy=\"7.5\" r=\"1.5\"/><circle cx=\"28.5\" cy=\"7.5\" r=\"1.5\"/><circle cx=\"23.5\" cy=\"7.5\" r=\"1.5\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-status--in-progress.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiStatusInProgress32",
          "filepath": "watson-health/ai-status--in-progress/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "ai-status--in-progress",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiStatusInProgress24",
          "filepath": "watson-health/ai-status--in-progress/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "ai-status--in-progress",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiStatusInProgress20",
          "filepath": "watson-health/ai-status--in-progress/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "ai-status--in-progress",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiStatusInProgress16",
          "filepath": "watson-health/ai-status--in-progress/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "ai-status--in-progress",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiStatusInProgress",
        "global": "WatsonHealthAiStatusInProgress",
        "filepath": "watson-health/AiStatusInProgress.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18.5",
                    "cy": "7.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28.5",
                    "cy": "7.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23.5",
                    "cy": "7.5",
                    "r": "1.5"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-status--queued",
      "friendlyName": "AI status queued",
      "aliases": [
        "ai",
        "status queued",
        "health",
        "watson"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-status--queued.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #272425;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M21.1777,18.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.193,9.193,0,0,0,26,12H24A7.2032,7.2032,0,0,1,21.1777,18.1426Z\" transform=\"translate(0 0)\"/>\n  <rect class=\"cls-1\" x=\"18\" y=\"6\" width=\"10\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-status--queued.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiStatusQueued32",
          "filepath": "watson-health/ai-status--queued/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z"
                }
              }
            ],
            "name": "ai-status--queued",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiStatusQueued24",
          "filepath": "watson-health/ai-status--queued/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z"
                }
              }
            ],
            "name": "ai-status--queued",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiStatusQueued20",
          "filepath": "watson-health/ai-status--queued/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z"
                }
              }
            ],
            "name": "ai-status--queued",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiStatusQueued16",
          "filepath": "watson-health/ai-status--queued/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z"
                }
              }
            ],
            "name": "ai-status--queued",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiStatusQueued",
        "global": "WatsonHealthAiStatusQueued",
        "filepath": "watson-health/AiStatusQueued.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ai-status--rejected",
      "friendlyName": "AI status rejected",
      "aliases": [
        "ai",
        "status rejected",
        "health",
        "watson"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/ai-status--rejected.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.04,16a9.4858,9.4858,0,0,1-1.8623,2.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.9838,9.9838,0,0,0,25.2756,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,8a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,8ZM28,8a3.9521,3.9521,0,0,1-.5669,2.019L21.981,4.5669A3.9529,3.9529,0,0,1,24,4,4.0045,4.0045,0,0,1,28,8ZM20,8a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,12,4.0045,4.0045,0,0,1,20,8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/ai-status--rejected.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAiStatusRejected32",
          "filepath": "watson-health/ai-status--rejected/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z"
                }
              }
            ],
            "name": "ai-status--rejected",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAiStatusRejected24",
          "filepath": "watson-health/ai-status--rejected/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z"
                }
              }
            ],
            "name": "ai-status--rejected",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAiStatusRejected20",
          "filepath": "watson-health/ai-status--rejected/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z"
                }
              }
            ],
            "name": "ai-status--rejected",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAiStatusRejected16",
          "filepath": "watson-health/ai-status--rejected/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z"
                }
              }
            ],
            "name": "ai-status--rejected",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AiStatusRejected",
        "global": "WatsonHealthAiStatusRejected",
        "filepath": "watson-health/AiStatusRejected.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airline--digital-gate",
      "friendlyName": "Airline digital gate",
      "aliases": [
        "airline",
        "gate",
        "boarding",
        "customer service",
        "representative",
        "agent",
        "attendant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airline--digital-gate.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0058,5.0058,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"26.0001\" width=\"28\" height=\"2\"/>\n  <path d=\"M31.9658,11.7413a1.0007,1.0007,0,0,0-1.2246-.707l-3.0861.826L24,7l-1,.2676,1.4584,5.4483-2.7663.7405L20,11.2066l-1,.2676.9337,3.4883a.9993.9993,0,0,0,1.2246.707l10.1005-2.7036A1,1,0,0,0,31.9658,11.7413Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z\"/></svg>",
            "info": {},
            "path": "32/airline--digital-gate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AirlineDigitalGate32",
          "filepath": "airline--digital-gate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z"
                }
              }
            ],
            "name": "airline--digital-gate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AirlineDigitalGate24",
          "filepath": "airline--digital-gate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z"
                }
              }
            ],
            "name": "airline--digital-gate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AirlineDigitalGate20",
          "filepath": "airline--digital-gate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z"
                }
              }
            ],
            "name": "airline--digital-gate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AirlineDigitalGate16",
          "filepath": "airline--digital-gate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z"
                }
              }
            ],
            "name": "airline--digital-gate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "AirlineDigitalGate",
        "global": "AirlineDigitalGate",
        "filepath": "AirlineDigitalGate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airline--manage-gates",
      "friendlyName": "Airline manage gates",
      "aliases": [
        "airline",
        "gate",
        "manage",
        "customer service",
        "representative",
        "agent",
        "boarding",
        "attendant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airline--manage-gates.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"26.0001\" width=\"28\" height=\"2\"/>\n  <polygon points=\"22 4 22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z\"/></svg>",
            "info": {},
            "path": "32/airline--manage-gates.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AirlineManageGates32",
          "filepath": "airline--manage-gates/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
                }
              }
            ],
            "name": "airline--manage-gates",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AirlineManageGates24",
          "filepath": "airline--manage-gates/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
                }
              }
            ],
            "name": "airline--manage-gates",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AirlineManageGates20",
          "filepath": "airline--manage-gates/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
                }
              }
            ],
            "name": "airline--manage-gates",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AirlineManageGates16",
          "filepath": "airline--manage-gates/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
                }
              }
            ],
            "name": "airline--manage-gates",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "AirlineManageGates",
        "global": "AirlineManageGates",
        "filepath": "AirlineManageGates.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airline--passenger-care",
      "friendlyName": "Airline passenger care",
      "aliases": [
        "airline",
        "customer service",
        "representative",
        "agent",
        "flight",
        "attendant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airline--passenger-care.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"26\" width=\"28\" height=\"2\"/>\n  <path d=\"M27.303,8a2.6616,2.6616,0,0,0-1.9079.8058L25,9.2112l-.3951-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L25,17l4.2108-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,27.303,8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z\"/></svg>",
            "info": {},
            "path": "32/airline--passenger-care.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AirlinePassengerCare32",
          "filepath": "airline--passenger-care/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z"
                }
              }
            ],
            "name": "airline--passenger-care",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AirlinePassengerCare24",
          "filepath": "airline--passenger-care/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z"
                }
              }
            ],
            "name": "airline--passenger-care",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AirlinePassengerCare20",
          "filepath": "airline--passenger-care/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z"
                }
              }
            ],
            "name": "airline--passenger-care",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AirlinePassengerCare16",
          "filepath": "airline--passenger-care/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z"
                }
              }
            ],
            "name": "airline--passenger-care",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "AirlinePassengerCare",
        "global": "AirlinePassengerCare",
        "filepath": "AirlinePassengerCare.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airline--rapid-board",
      "friendlyName": "Airline rapid board",
      "aliases": [
        "airline",
        "gate",
        "manage",
        "customer service",
        "representative",
        "agent",
        "board",
        "attendant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airline--rapid-board.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"26.0001\" width=\"28\" height=\"2\"/>\n  <polygon points=\"30 8 28 8 28 6 26 6 26 4 30 4 30 8\"/>\n  <polygon points=\"19 4 23 4 23 6 21 6 21 8 19 8 19 4\"/>\n  <rect x=\"28\" y=\"13.0001\" width=\"2\" height=\"2\"/>\n  <rect x=\"26\" y=\"11.0001\" width=\"2\" height=\"2\"/>\n  <polygon points=\"19 11 21 11 21 13 23 13 23 15 19 15 19 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z\"/></svg>",
            "info": {},
            "path": "32/airline--rapid-board.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AirlineRapidBoard32",
          "filepath": "airline--rapid-board/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
                }
              }
            ],
            "name": "airline--rapid-board",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AirlineRapidBoard24",
          "filepath": "airline--rapid-board/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
                }
              }
            ],
            "name": "airline--rapid-board",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AirlineRapidBoard20",
          "filepath": "airline--rapid-board/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
                }
              }
            ],
            "name": "airline--rapid-board",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AirlineRapidBoard16",
          "filepath": "airline--rapid-board/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
                }
              }
            ],
            "name": "airline--rapid-board",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "AirlineRapidBoard",
        "global": "AirlineRapidBoard",
        "filepath": "AirlineRapidBoard.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airplay",
      "friendlyName": "Airplay",
      "aliases": [
        "technology",
        "podcast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airplay.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z\"/>\n  <path d=\"M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z\"/><path d=\"M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z\"/></svg>",
            "info": {},
            "path": "32/airplay.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Airplay32",
          "filepath": "airplay/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Airplay24",
          "filepath": "airplay/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Airplay20",
          "filepath": "airplay/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Airplay16",
          "filepath": "airplay/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Airplay",
        "global": "Airplay",
        "filepath": "Airplay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airplay--filled",
      "friendlyName": "Airplay filled",
      "aliases": [
        "technology",
        "podcast",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airplay--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z\"/>\n  <path d=\"M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z\"/><path d=\"M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z\"/></svg>",
            "info": {},
            "path": "32/airplay--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AirplayFilled32",
          "filepath": "airplay--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AirplayFilled24",
          "filepath": "airplay--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AirplayFilled20",
          "filepath": "airplay--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AirplayFilled16",
          "filepath": "airplay--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                }
              }
            ],
            "name": "airplay--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "AirplayFilled",
        "global": "AirplayFilled",
        "filepath": "AirplayFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airport--01",
      "friendlyName": "Airport 01",
      "aliases": [
        "airport",
        "transportation",
        "airline",
        "plane"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airport--01.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/airport--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Airport_0132",
          "filepath": "airport--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Airport_0124",
          "filepath": "airport--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Airport_0120",
          "filepath": "airport--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Airport_0116",
          "filepath": "airport--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Airport_01",
        "global": "Airport_01",
        "filepath": "Airport_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airport--02",
      "friendlyName": "Airport 02",
      "aliases": [
        "airport",
        "transportation",
        "airline",
        "plane"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airport--02.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/airport--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Airport_0232",
          "filepath": "airport--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Airport_0224",
          "filepath": "airport--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Airport_0220",
          "filepath": "airport--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Airport_0216",
          "filepath": "airport--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "airport--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Airport_02",
        "global": "Airport_02",
        "filepath": "Airport_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "airport-location",
      "friendlyName": "Airport location",
      "aliases": [
        "airport",
        "transportation",
        "airline",
        "plane",
        "navigation",
        "map",
        "wayfinding"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/airport-location.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z\"/></svg>",
            "info": {},
            "path": "32/airport-location.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AirportLocation32",
          "filepath": "airport-location/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
                }
              }
            ],
            "name": "airport-location",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AirportLocation24",
          "filepath": "airport-location/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
                }
              }
            ],
            "name": "airport-location",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AirportLocation20",
          "filepath": "airport-location/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
                }
              }
            ],
            "name": "airport-location",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AirportLocation16",
          "filepath": "airport-location/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
                }
              }
            ],
            "name": "airport-location",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "AirportLocation",
        "global": "AirportLocation",
        "filepath": "AirportLocation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "alarm",
      "friendlyName": "Alarm",
      "aliases": [
        "clock",
        "timer",
        "time",
        "alert",
        "warning",
        "notification",
        "notice"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/alarm.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>alarm</title><path d=\"M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z\"/><polygon points=\"18.59 21 15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21\"/><rect class=\"cls-1\" x=\"3.96\" y=\"5.5\" width=\"5.07\" height=\"2\" transform=\"translate(-2.69 6.51) rotate(-45.06)\"/><rect class=\"cls-1\" x=\"24.5\" y=\"3.96\" width=\"2\" height=\"5.07\" transform=\"translate(2.86 19.91) rotate(-44.94)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z\"/><path d=\"M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z\"/><path d=\"M3.96 5.5H9.030000000000001V7.5H3.96z\" transform=\"rotate(-45.06 6.502 6.497)\"/><path d=\"M24.5 3.96H26.5V9.030000000000001H24.5z\" transform=\"rotate(-44.94 25.5 6.498)\"/></svg>",
            "info": {},
            "path": "32/alarm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Alarm32",
          "filepath": "alarm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              }
            ],
            "name": "alarm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Alarm24",
          "filepath": "alarm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              }
            ],
            "name": "alarm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Alarm20",
          "filepath": "alarm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              }
            ],
            "name": "alarm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Alarm16",
          "filepath": "alarm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              }
            ],
            "name": "alarm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Alarm",
        "global": "Alarm",
        "filepath": "Alarm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                    "transform": "rotate(-45.06 6.502 6.497)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                    "transform": "rotate(-44.94 25.5 6.498)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "alarm--add",
      "friendlyName": "Alarm add",
      "aliases": [
        "clock",
        "timer",
        "time",
        "alert",
        "warning",
        "notification",
        "notice",
        "plus sign",
        "alarm add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/alarm--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>alarm--add</title><path d=\"M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z\"/><rect class=\"cls-1\" x=\"3.96\" y=\"5.5\" width=\"5.07\" height=\"2\" transform=\"translate(-2.69 6.51) rotate(-45.06)\"/><rect class=\"cls-1\" x=\"24.5\" y=\"3.96\" width=\"2\" height=\"5.07\" transform=\"translate(2.86 19.91) rotate(-44.94)\"/><polygon points=\"21 16 17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z\"/><path d=\"M3.96 5.5H9.030000000000001V7.5H3.96z\" transform=\"rotate(-45.06 6.502 6.497)\"/><path d=\"M24.5 3.96H26.5V9.030000000000001H24.5z\" transform=\"rotate(-44.94 25.5 6.498)\"/><path d=\"M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z\"/></svg>",
            "info": {},
            "path": "32/alarm--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlarmAdd32",
          "filepath": "alarm--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
                }
              }
            ],
            "name": "alarm--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlarmAdd24",
          "filepath": "alarm--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
                }
              }
            ],
            "name": "alarm--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlarmAdd20",
          "filepath": "alarm--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
                }
              }
            ],
            "name": "alarm--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlarmAdd16",
          "filepath": "alarm--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
                }
              }
            ],
            "name": "alarm--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "AlarmAdd",
        "global": "AlarmAdd",
        "filepath": "AlarmAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                    "transform": "rotate(-45.06 6.502 6.497)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                    "transform": "rotate(-44.94 25.5 6.498)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "alarm--subtract",
      "friendlyName": "Alarm subtract",
      "aliases": [
        "clock",
        "timer",
        "time",
        "alert",
        "warning",
        "notification",
        "notice",
        "minus sign",
        "alarm subtract",
        "alarm minus"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/alarm--subtract.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>alarm--subtract</title><path d=\"M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z\"/><rect class=\"cls-1\" x=\"3.96\" y=\"5.5\" width=\"5.07\" height=\"2\" transform=\"translate(-2.69 6.51) rotate(-45.06)\"/><rect class=\"cls-1\" x=\"24.5\" y=\"3.96\" width=\"2\" height=\"5.07\" transform=\"translate(2.86 19.91) rotate(-44.94)\"/><rect x=\"11\" y=\"16\" width=\"10\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z\"/><path d=\"M3.96 5.5H9.030000000000001V7.5H3.96z\" transform=\"rotate(-45.06 6.502 6.497)\"/><path d=\"M24.5 3.96H26.5V9.030000000000001H24.5z\" transform=\"rotate(-44.94 25.5 6.498)\"/><path d=\"M11 16H21V18H11z\"/></svg>",
            "info": {},
            "path": "32/alarm--subtract.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlarmSubtract32",
          "filepath": "alarm--subtract/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16H21V18H11z"
                }
              }
            ],
            "name": "alarm--subtract",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlarmSubtract24",
          "filepath": "alarm--subtract/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16H21V18H11z"
                }
              }
            ],
            "name": "alarm--subtract",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlarmSubtract20",
          "filepath": "alarm--subtract/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16H21V18H11z"
                }
              }
            ],
            "name": "alarm--subtract",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlarmSubtract16",
          "filepath": "alarm--subtract/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                  "transform": "rotate(-45.06 6.502 6.497)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                  "transform": "rotate(-44.94 25.5 6.498)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16H21V18H11z"
                }
              }
            ],
            "name": "alarm--subtract",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "AlarmSubtract",
        "global": "AlarmSubtract",
        "filepath": "AlarmSubtract.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.96 5.5H9.030000000000001V7.5H3.96z",
                    "transform": "rotate(-45.06 6.502 6.497)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5 3.96H26.5V9.030000000000001H24.5z",
                    "transform": "rotate(-44.94 25.5 6.498)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 16H21V18H11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align--horizontal-center",
      "friendlyName": "Align horizontal center",
      "aliases": [
        "align",
        "alignment",
        "align horizontal",
        "align horizontal center",
        "formatting",
        "horizontal formatting",
        "center formatting",
        "horizontal center align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align--horizontal-center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--horizontal-center</title><path d=\"M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z\"/></svg>",
            "info": {},
            "path": "32/align--horizontal-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignHorizontalCenter32",
          "filepath": "align--horizontal-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
                }
              }
            ],
            "name": "align--horizontal-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignHorizontalCenter24",
          "filepath": "align--horizontal-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
                }
              }
            ],
            "name": "align--horizontal-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignHorizontalCenter20",
          "filepath": "align--horizontal-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
                }
              }
            ],
            "name": "align--horizontal-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignHorizontalCenter16",
          "filepath": "align--horizontal-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
                }
              }
            ],
            "name": "align--horizontal-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignHorizontalCenter",
        "global": "AlignHorizontalCenter",
        "filepath": "AlignHorizontalCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align--horizontal-left",
      "friendlyName": "Align horizontal left",
      "aliases": [
        "align",
        "alignment",
        "align horizontal",
        "align horizontal left",
        "left alignment",
        "formatting",
        "left formatting",
        "horizontal left align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align--horizontal-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--horizontal-left</title><path d=\"M26,26H11a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,26Zm0-6.0012L11,20v4H26Z\"/><path d=\"M18,14H11a2.0023,2.0023,0,0,1-2-2V8a2.0023,2.0023,0,0,1,2-2h7a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,18,14Zm0-6.0012L11,8v4h7Z\"/><rect x=\"4\" y=\"2\" width=\"2\" height=\"28\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z\"/></svg>",
            "info": {},
            "path": "32/align--horizontal-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignHorizontalLeft32",
          "filepath": "align--horizontal-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z"
                }
              }
            ],
            "name": "align--horizontal-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignHorizontalLeft24",
          "filepath": "align--horizontal-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z"
                }
              }
            ],
            "name": "align--horizontal-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignHorizontalLeft20",
          "filepath": "align--horizontal-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z"
                }
              }
            ],
            "name": "align--horizontal-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignHorizontalLeft16",
          "filepath": "align--horizontal-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z"
                }
              }
            ],
            "name": "align--horizontal-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignHorizontalLeft",
        "global": "AlignHorizontalLeft",
        "filepath": "AlignHorizontalLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align--horizontal-right",
      "friendlyName": "Align horizontal right",
      "aliases": [
        "align",
        "alignment",
        "align horizontal",
        "align horizontal right",
        "right alignment",
        "formatting",
        "right formatting",
        "horizontal right align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align--horizontal-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--horizontal-right</title><path d=\"M4,24V20a2.0023,2.0023,0,0,1,2-2H21a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H6A2.0023,2.0023,0,0,1,4,24Zm2,0H21V20L6,19.9988Z\" transform=\"translate(0 0)\"/><path d=\"M12,12V8a2.0023,2.0023,0,0,1,2-2h7a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H14A2.0023,2.0023,0,0,1,12,12Zm2,0h7V8l-7-.0012Z\" transform=\"translate(0 0)\"/><rect x=\"26\" y=\"2\" width=\"2\" height=\"28\" transform=\"translate(54 32) rotate(-180)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z\"/><path d=\"M26 2H28V30H26z\" transform=\"rotate(-180 27 16)\"/></svg>",
            "info": {},
            "path": "32/align--horizontal-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignHorizontalRight32",
          "filepath": "align--horizontal-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H28V30H26z",
                  "transform": "rotate(-180 27 16)"
                }
              }
            ],
            "name": "align--horizontal-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignHorizontalRight24",
          "filepath": "align--horizontal-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H28V30H26z",
                  "transform": "rotate(-180 27 16)"
                }
              }
            ],
            "name": "align--horizontal-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignHorizontalRight20",
          "filepath": "align--horizontal-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H28V30H26z",
                  "transform": "rotate(-180 27 16)"
                }
              }
            ],
            "name": "align--horizontal-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignHorizontalRight16",
          "filepath": "align--horizontal-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H28V30H26z",
                  "transform": "rotate(-180 27 16)"
                }
              }
            ],
            "name": "align--horizontal-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignHorizontalRight",
        "global": "AlignHorizontalRight",
        "filepath": "AlignHorizontalRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 2H28V30H26z",
                    "transform": "rotate(-180 27 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align--vertical-bottom",
      "friendlyName": "Align vertical bottom",
      "aliases": [
        "align",
        "alignment",
        "align vertical",
        "align vertical bottom",
        "vertical alignment",
        "formatting",
        "bottom formatting",
        "vertical bottom align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align--vertical-bottom.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--bottom-vertical</title><rect x=\"2\" y=\"26\" width=\"28\" height=\"2\"/><path d=\"M24,23H20a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v7A2.0023,2.0023,0,0,1,24,23Zm-4-9v7h4.0012L24,14Z\"/><path d=\"M12,23H8a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,8,4h4a2.0023,2.0023,0,0,1,2,2V21A2.0023,2.0023,0,0,1,12,23ZM8,6V21h4.0012L12,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z\"/></svg>",
            "info": {},
            "path": "32/align--vertical-bottom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignVerticalBottom32",
          "filepath": "align--vertical-bottom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z"
                }
              }
            ],
            "name": "align--vertical-bottom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignVerticalBottom24",
          "filepath": "align--vertical-bottom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z"
                }
              }
            ],
            "name": "align--vertical-bottom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignVerticalBottom20",
          "filepath": "align--vertical-bottom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z"
                }
              }
            ],
            "name": "align--vertical-bottom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignVerticalBottom16",
          "filepath": "align--vertical-bottom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z"
                }
              }
            ],
            "name": "align--vertical-bottom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignVerticalBottom",
        "global": "AlignVerticalBottom",
        "filepath": "AlignVerticalBottom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align--vertical-center",
      "friendlyName": "Align vertical center",
      "aliases": [
        "align",
        "alignment",
        "align center",
        "align vertical center",
        "vertical alignment",
        "formatting",
        "center formatting",
        "vertical center align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align--vertical-center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--center-vertical</title><path d=\"M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z\"/></svg>",
            "info": {},
            "path": "32/align--vertical-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignVerticalCenter32",
          "filepath": "align--vertical-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
                }
              }
            ],
            "name": "align--vertical-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignVerticalCenter24",
          "filepath": "align--vertical-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
                }
              }
            ],
            "name": "align--vertical-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignVerticalCenter20",
          "filepath": "align--vertical-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
                }
              }
            ],
            "name": "align--vertical-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignVerticalCenter16",
          "filepath": "align--vertical-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
                }
              }
            ],
            "name": "align--vertical-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignVerticalCenter",
        "global": "AlignVerticalCenter",
        "filepath": "AlignVerticalCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align--vertical-top",
      "friendlyName": "Align vertical top",
      "aliases": [
        "align",
        "alignment",
        "align vertical",
        "align vertical top",
        "formatting",
        "top formatting",
        "vertical top align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align--vertical-top.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--vertical-top</title><path d=\"M24,20H20a2.0023,2.0023,0,0,1-2-2V11a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v7A2.0023,2.0023,0,0,1,24,20Zm-4-9v7h4.0012L24,11Z\"/><path d=\"M12,28H8a2.0023,2.0023,0,0,1-2-2V11A2.0023,2.0023,0,0,1,8,9h4a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,12,28ZM8,11V26h4.0012L12,11Z\"/><rect x=\"2\" y=\"4\" width=\"28\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z\"/></svg>",
            "info": {},
            "path": "32/align--vertical-top.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignVerticalTop32",
          "filepath": "align--vertical-top/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z"
                }
              }
            ],
            "name": "align--vertical-top",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignVerticalTop24",
          "filepath": "align--vertical-top/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z"
                }
              }
            ],
            "name": "align--vertical-top",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignVerticalTop20",
          "filepath": "align--vertical-top/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z"
                }
              }
            ],
            "name": "align--vertical-top",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignVerticalTop16",
          "filepath": "align--vertical-top/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z"
                }
              }
            ],
            "name": "align--vertical-top",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignVerticalTop",
        "global": "AlignVerticalTop",
        "filepath": "AlignVerticalTop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--bottom-center",
      "friendlyName": "Align box bottom center",
      "aliases": [
        "align",
        "alignment",
        "align bottom",
        "align bottom center",
        "formatting",
        "bottom formatting",
        "center align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--bottom-center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"10\" y=\"18\" width=\"12\" height=\"2\" transform=\"translate(32 38) rotate(-180)\"/>\n  <rect x=\"12\" y=\"23\" width=\"8\" height=\"2\" transform=\"translate(32 48) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M10 18H22V20H10z\" transform=\"rotate(-180 16 19)\"/><path d=\"M12 23H20V25H12z\" transform=\"rotate(-180 16 24)\"/></svg>",
            "info": {},
            "path": "32/align-box--bottom-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxBottomCenter32",
          "filepath": "align-box--bottom-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H22V20H10z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 23H20V25H12z",
                  "transform": "rotate(-180 16 24)"
                }
              }
            ],
            "name": "align-box--bottom-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxBottomCenter24",
          "filepath": "align-box--bottom-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H22V20H10z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 23H20V25H12z",
                  "transform": "rotate(-180 16 24)"
                }
              }
            ],
            "name": "align-box--bottom-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxBottomCenter20",
          "filepath": "align-box--bottom-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H22V20H10z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 23H20V25H12z",
                  "transform": "rotate(-180 16 24)"
                }
              }
            ],
            "name": "align-box--bottom-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxBottomCenter16",
          "filepath": "align-box--bottom-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H22V20H10z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 23H20V25H12z",
                  "transform": "rotate(-180 16 24)"
                }
              }
            ],
            "name": "align-box--bottom-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxBottomCenter",
        "global": "AlignBoxBottomCenter",
        "filepath": "AlignBoxBottomCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 18H22V20H10z",
                    "transform": "rotate(-180 16 19)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 23H20V25H12z",
                    "transform": "rotate(-180 16 24)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--bottom-left",
      "friendlyName": "Align box bottom left",
      "aliases": [
        "align",
        "alignment",
        "align bottom",
        "align bottom left",
        "formatting",
        "bottom formatting",
        "left align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--bottom-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"9\" y=\"18\" width=\"11\" height=\"2\"/>\n  <rect x=\"9\" y=\"23\" width=\"7\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M9 18H20V20H9zM9 23H16V25H9z\"/></svg>",
            "info": {},
            "path": "32/align-box--bottom-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxBottomLeft32",
          "filepath": "align-box--bottom-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 18H20V20H9zM9 23H16V25H9z"
                }
              }
            ],
            "name": "align-box--bottom-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxBottomLeft24",
          "filepath": "align-box--bottom-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 18H20V20H9zM9 23H16V25H9z"
                }
              }
            ],
            "name": "align-box--bottom-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxBottomLeft20",
          "filepath": "align-box--bottom-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 18H20V20H9zM9 23H16V25H9z"
                }
              }
            ],
            "name": "align-box--bottom-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxBottomLeft16",
          "filepath": "align-box--bottom-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 18H20V20H9zM9 23H16V25H9z"
                }
              }
            ],
            "name": "align-box--bottom-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxBottomLeft",
        "global": "AlignBoxBottomLeft",
        "filepath": "AlignBoxBottomLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 18H20V20H9zM9 23H16V25H9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--bottom-right",
      "friendlyName": "Align box bottom right",
      "aliases": [
        "align",
        "alignment",
        "align bottom",
        "align bottom right",
        "formatting",
        "bottom formatting",
        "right align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--bottom-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"12\" y=\"18\" width=\"11\" height=\"2\" transform=\"translate(35 38) rotate(-180)\"/>\n  <rect x=\"16\" y=\"23\" width=\"7\" height=\"2\" transform=\"translate(39 48) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M12 18H23V20H12z\" transform=\"rotate(-180 17.5 19)\"/><path d=\"M16 23H23V25H16z\" transform=\"rotate(-180 19.5 24)\"/></svg>",
            "info": {},
            "path": "32/align-box--bottom-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxBottomRight32",
          "filepath": "align-box--bottom-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H23V20H12z",
                  "transform": "rotate(-180 17.5 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23H23V25H16z",
                  "transform": "rotate(-180 19.5 24)"
                }
              }
            ],
            "name": "align-box--bottom-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxBottomRight24",
          "filepath": "align-box--bottom-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H23V20H12z",
                  "transform": "rotate(-180 17.5 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23H23V25H16z",
                  "transform": "rotate(-180 19.5 24)"
                }
              }
            ],
            "name": "align-box--bottom-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxBottomRight20",
          "filepath": "align-box--bottom-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H23V20H12z",
                  "transform": "rotate(-180 17.5 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23H23V25H16z",
                  "transform": "rotate(-180 19.5 24)"
                }
              }
            ],
            "name": "align-box--bottom-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxBottomRight16",
          "filepath": "align-box--bottom-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H23V20H12z",
                  "transform": "rotate(-180 17.5 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23H23V25H16z",
                  "transform": "rotate(-180 19.5 24)"
                }
              }
            ],
            "name": "align-box--bottom-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxBottomRight",
        "global": "AlignBoxBottomRight",
        "filepath": "AlignBoxBottomRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 18H23V20H12z",
                    "transform": "rotate(-180 17.5 19)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 23H23V25H16z",
                    "transform": "rotate(-180 19.5 24)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--middle-center",
      "friendlyName": "Align box middle center",
      "aliases": [
        "align",
        "alignment",
        "align middle",
        "align middle center",
        "formatting",
        "center formatting",
        "center align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--middle-center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"10\" y=\"13\" width=\"12\" height=\"2\" transform=\"translate(32 28) rotate(-180)\"/>\n  <rect x=\"12\" y=\"18\" width=\"8\" height=\"2\" transform=\"translate(32 38) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M10 13H22V15H10z\" transform=\"rotate(-180 16 14)\"/><path d=\"M12 18H20V20H12z\" transform=\"rotate(-180 16 19)\"/></svg>",
            "info": {},
            "path": "32/align-box--middle-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxMiddleCenter32",
          "filepath": "align-box--middle-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10z",
                  "transform": "rotate(-180 16 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H20V20H12z",
                  "transform": "rotate(-180 16 19)"
                }
              }
            ],
            "name": "align-box--middle-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxMiddleCenter24",
          "filepath": "align-box--middle-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10z",
                  "transform": "rotate(-180 16 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H20V20H12z",
                  "transform": "rotate(-180 16 19)"
                }
              }
            ],
            "name": "align-box--middle-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxMiddleCenter20",
          "filepath": "align-box--middle-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10z",
                  "transform": "rotate(-180 16 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H20V20H12z",
                  "transform": "rotate(-180 16 19)"
                }
              }
            ],
            "name": "align-box--middle-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxMiddleCenter16",
          "filepath": "align-box--middle-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10z",
                  "transform": "rotate(-180 16 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 18H20V20H12z",
                  "transform": "rotate(-180 16 19)"
                }
              }
            ],
            "name": "align-box--middle-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxMiddleCenter",
        "global": "AlignBoxMiddleCenter",
        "filepath": "AlignBoxMiddleCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 13H22V15H10z",
                    "transform": "rotate(-180 16 14)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 18H20V20H12z",
                    "transform": "rotate(-180 16 19)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--middle-left",
      "friendlyName": "Align box middle left",
      "aliases": [
        "align",
        "alignment",
        "align middle",
        "align middle left",
        "formatting",
        "middle formatting",
        "left align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--middle-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"9\" y=\"13\" width=\"11\" height=\"2\"/>\n  <rect x=\"9\" y=\"18\" width=\"7\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M9 13H20V15H9zM9 18H16V20H9z\"/></svg>",
            "info": {},
            "path": "32/align-box--middle-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxMiddleLeft32",
          "filepath": "align-box--middle-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 13H20V15H9zM9 18H16V20H9z"
                }
              }
            ],
            "name": "align-box--middle-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxMiddleLeft24",
          "filepath": "align-box--middle-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 13H20V15H9zM9 18H16V20H9z"
                }
              }
            ],
            "name": "align-box--middle-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxMiddleLeft20",
          "filepath": "align-box--middle-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 13H20V15H9zM9 18H16V20H9z"
                }
              }
            ],
            "name": "align-box--middle-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxMiddleLeft16",
          "filepath": "align-box--middle-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 13H20V15H9zM9 18H16V20H9z"
                }
              }
            ],
            "name": "align-box--middle-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxMiddleLeft",
        "global": "AlignBoxMiddleLeft",
        "filepath": "AlignBoxMiddleLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 13H20V15H9zM9 18H16V20H9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--middle-right",
      "friendlyName": "Align box middle right",
      "aliases": [
        "align",
        "alignment",
        "align middle",
        "align middle right",
        "formatting",
        "middle formatting",
        "right align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--middle-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"12\" y=\"13\" width=\"11\" height=\"2\" transform=\"translate(35 28) rotate(-180)\"/>\n  <rect x=\"16\" y=\"18\" width=\"7\" height=\"2\" transform=\"translate(39 38) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M12 13H23V15H12z\" transform=\"rotate(-180 17.5 14)\"/><path d=\"M16 18H23V20H16z\" transform=\"rotate(-180 19.5 19)\"/></svg>",
            "info": {},
            "path": "32/align-box--middle-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxMiddleRight32",
          "filepath": "align-box--middle-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H23V15H12z",
                  "transform": "rotate(-180 17.5 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H23V20H16z",
                  "transform": "rotate(-180 19.5 19)"
                }
              }
            ],
            "name": "align-box--middle-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxMiddleRight24",
          "filepath": "align-box--middle-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H23V15H12z",
                  "transform": "rotate(-180 17.5 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H23V20H16z",
                  "transform": "rotate(-180 19.5 19)"
                }
              }
            ],
            "name": "align-box--middle-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxMiddleRight20",
          "filepath": "align-box--middle-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H23V15H12z",
                  "transform": "rotate(-180 17.5 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H23V20H16z",
                  "transform": "rotate(-180 19.5 19)"
                }
              }
            ],
            "name": "align-box--middle-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxMiddleRight16",
          "filepath": "align-box--middle-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H23V15H12z",
                  "transform": "rotate(-180 17.5 14)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H23V20H16z",
                  "transform": "rotate(-180 19.5 19)"
                }
              }
            ],
            "name": "align-box--middle-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxMiddleRight",
        "global": "AlignBoxMiddleRight",
        "filepath": "AlignBoxMiddleRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 13H23V15H12z",
                    "transform": "rotate(-180 17.5 14)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 18H23V20H16z",
                    "transform": "rotate(-180 19.5 19)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--top-center",
      "friendlyName": "Align box top center",
      "aliases": [
        "align",
        "alignment",
        "align top",
        "align top center",
        "formatting",
        "top formatting",
        "center align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--top-center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"10\" y=\"7\" width=\"12\" height=\"2\" transform=\"translate(32 16) rotate(-180)\"/>\n  <rect x=\"12\" y=\"12\" width=\"8\" height=\"2\" transform=\"translate(32 26) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M10 7H22V9H10z\" transform=\"rotate(-180 16 8)\"/><path d=\"M12 12H20V14H12z\" transform=\"rotate(-180 16 13)\"/></svg>",
            "info": {},
            "path": "32/align-box--top-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxTopCenter32",
          "filepath": "align-box--top-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 7H22V9H10z",
                  "transform": "rotate(-180 16 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H20V14H12z",
                  "transform": "rotate(-180 16 13)"
                }
              }
            ],
            "name": "align-box--top-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxTopCenter24",
          "filepath": "align-box--top-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 7H22V9H10z",
                  "transform": "rotate(-180 16 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H20V14H12z",
                  "transform": "rotate(-180 16 13)"
                }
              }
            ],
            "name": "align-box--top-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxTopCenter20",
          "filepath": "align-box--top-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 7H22V9H10z",
                  "transform": "rotate(-180 16 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H20V14H12z",
                  "transform": "rotate(-180 16 13)"
                }
              }
            ],
            "name": "align-box--top-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxTopCenter16",
          "filepath": "align-box--top-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 7H22V9H10z",
                  "transform": "rotate(-180 16 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H20V14H12z",
                  "transform": "rotate(-180 16 13)"
                }
              }
            ],
            "name": "align-box--top-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxTopCenter",
        "global": "AlignBoxTopCenter",
        "filepath": "AlignBoxTopCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 7H22V9H10z",
                    "transform": "rotate(-180 16 8)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 12H20V14H12z",
                    "transform": "rotate(-180 16 13)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--top-left",
      "friendlyName": "Align box top left",
      "aliases": [
        "align",
        "alignment",
        "align top",
        "align top left",
        "formatting",
        "top formatting",
        "left align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--top-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"9\" y=\"7\" width=\"11\" height=\"2\"/>\n  <rect x=\"9\" y=\"12\" width=\"7\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M9 7H20V9H9zM9 12H16V14H9z\"/></svg>",
            "info": {},
            "path": "32/align-box--top-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxTopLeft32",
          "filepath": "align-box--top-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 7H20V9H9zM9 12H16V14H9z"
                }
              }
            ],
            "name": "align-box--top-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxTopLeft24",
          "filepath": "align-box--top-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 7H20V9H9zM9 12H16V14H9z"
                }
              }
            ],
            "name": "align-box--top-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxTopLeft20",
          "filepath": "align-box--top-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 7H20V9H9zM9 12H16V14H9z"
                }
              }
            ],
            "name": "align-box--top-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxTopLeft16",
          "filepath": "align-box--top-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 7H20V9H9zM9 12H16V14H9z"
                }
              }
            ],
            "name": "align-box--top-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxTopLeft",
        "global": "AlignBoxTopLeft",
        "filepath": "AlignBoxTopLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 7H20V9H9zM9 12H16V14H9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "align-box--top-right",
      "friendlyName": "Align box top right",
      "aliases": [
        "align",
        "alignment",
        "align top",
        "align top right",
        "formatting",
        "top formatting",
        "right align"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/align-box--top-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/>\n  <rect x=\"12\" y=\"7\" width=\"11\" height=\"2\" transform=\"translate(35 16) rotate(-180)\"/>\n  <rect x=\"16\" y=\"12\" width=\"7\" height=\"2\" transform=\"translate(39 26) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z\"/><path d=\"M12 7H23V9H12z\" transform=\"rotate(-180 17.5 8)\"/><path d=\"M16 12H23V14H16z\" transform=\"rotate(-180 19.5 13)\"/></svg>",
            "info": {},
            "path": "32/align-box--top-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AlignBoxTopRight32",
          "filepath": "align-box--top-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 7H23V9H12z",
                  "transform": "rotate(-180 17.5 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12H23V14H16z",
                  "transform": "rotate(-180 19.5 13)"
                }
              }
            ],
            "name": "align-box--top-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AlignBoxTopRight24",
          "filepath": "align-box--top-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 7H23V9H12z",
                  "transform": "rotate(-180 17.5 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12H23V14H16z",
                  "transform": "rotate(-180 19.5 13)"
                }
              }
            ],
            "name": "align-box--top-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AlignBoxTopRight20",
          "filepath": "align-box--top-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 7H23V9H12z",
                  "transform": "rotate(-180 17.5 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12H23V14H16z",
                  "transform": "rotate(-180 19.5 13)"
                }
              }
            ],
            "name": "align-box--top-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AlignBoxTopRight16",
          "filepath": "align-box--top-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 7H23V9H12z",
                  "transform": "rotate(-180 17.5 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12H23V14H16z",
                  "transform": "rotate(-180 19.5 13)"
                }
              }
            ],
            "name": "align-box--top-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "AlignBoxTopRight",
        "global": "AlignBoxTopRight",
        "filepath": "AlignBoxTopRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 7H23V9H12z",
                    "transform": "rotate(-180 17.5 8)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 12H23V14H16z",
                    "transform": "rotate(-180 19.5 13)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "analytics",
      "friendlyName": "Analytics",
      "aliases": [
        "line chart",
        "trend",
        "graph",
        "analyze",
        "data",
        "data analytics",
        "arrow graph"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/analytics.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>analytics</title><path d=\"M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z\"/><path d=\"M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z\"/><path d=\"M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z\"/></svg>",
            "info": {},
            "path": "32/analytics.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Analytics32",
          "filepath": "analytics/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
                }
              }
            ],
            "name": "analytics",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Analytics24",
          "filepath": "analytics/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
                }
              }
            ],
            "name": "analytics",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Analytics20",
          "filepath": "analytics/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
                }
              }
            ],
            "name": "analytics",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Analytics16",
          "filepath": "analytics/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
                }
              }
            ],
            "name": "analytics",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Analytics",
        "global": "Analytics",
        "filepath": "Analytics.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "analytics--custom",
      "friendlyName": "Analytics custom",
      "aliases": [
        "line chart",
        "trend",
        "graph",
        "analyze",
        "data",
        "data analytics",
        "arrow graph",
        "custom",
        "edit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/analytics--custom.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z\"/>\n  <path d=\"M30,4H23V6h3.5859L19,13.5859,14.707,9.293a1,1,0,0,0-1.414,0L6,16.5859,7.4141,18,14,11.4141l4.293,4.2929a1,1,0,0,0,1.414,0L28,7.4141V11h2Z\"/>\n  <path d=\"M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z\"/><path d=\"M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z\"/></svg>",
            "info": {},
            "path": "32/analytics--custom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AnalyticsCustom32",
          "filepath": "analytics--custom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
                }
              }
            ],
            "name": "analytics--custom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AnalyticsCustom24",
          "filepath": "analytics--custom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
                }
              }
            ],
            "name": "analytics--custom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AnalyticsCustom20",
          "filepath": "analytics--custom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
                }
              }
            ],
            "name": "analytics--custom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AnalyticsCustom16",
          "filepath": "analytics--custom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
                }
              }
            ],
            "name": "analytics--custom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "AnalyticsCustom",
        "global": "AnalyticsCustom",
        "filepath": "AnalyticsCustom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "analytics--reference",
      "friendlyName": "Analytics reference",
      "aliases": [
        "analytics reference",
        "data",
        "citation",
        "source",
        "line chart",
        "trend",
        "graph",
        "analyze",
        "data",
        "data analytics",
        "arrow graph"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/analytics--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M30,4H23V6h3.5859L19,13.5859,14.707,9.293a1,1,0,0,0-1.414,0L8,14.5858,9.4142,16,14,11.4141l4.293,4.2929a1,1,0,0,0,1.414,0L28,7.4141V11h2Z\"/>\n  <rect x=\"16\" y=\"28\" width=\"14\" height=\"2\"/>\n  <rect x=\"2\" y=\"2\" width=\"2\" height=\"14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z\"/></svg>",
            "info": {},
            "path": "32/analytics--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AnalyticsReference32",
          "filepath": "analytics--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z"
                }
              }
            ],
            "name": "analytics--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AnalyticsReference24",
          "filepath": "analytics--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z"
                }
              }
            ],
            "name": "analytics--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AnalyticsReference20",
          "filepath": "analytics--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z"
                }
              }
            ],
            "name": "analytics--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AnalyticsReference16",
          "filepath": "analytics--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z"
                }
              }
            ],
            "name": "analytics--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "AnalyticsReference",
        "global": "AnalyticsReference",
        "filepath": "AnalyticsReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "angle",
      "friendlyName": "Angle",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "health",
        "tilt",
        "meter",
        "gauge",
        "angle",
        "axis"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/angle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--angle</title><path d=\"M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z\" transform=\"translate(0 0)\"/><path d=\"M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z\"/><path d=\"M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/angle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAngle32",
          "filepath": "watson-health/angle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
                }
              }
            ],
            "name": "angle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAngle24",
          "filepath": "watson-health/angle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
                }
              }
            ],
            "name": "angle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAngle20",
          "filepath": "watson-health/angle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
                }
              }
            ],
            "name": "angle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAngle16",
          "filepath": "watson-health/angle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
                }
              }
            ],
            "name": "angle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Angle",
        "global": "WatsonHealthAngle",
        "filepath": "watson-health/Angle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "annotation-visibility",
      "friendlyName": "Annotation visibility",
      "aliases": [
        "meter",
        "instrument",
        "annotate",
        "diagram",
        "comment",
        "health",
        "axis",
        "notation"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/annotation-visibility.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--annotation-visibility</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z\"/><path d=\"M21,20H13a3.51,3.51,0,0,0-.88-1.86l3.8-6.64-1.74-1-3.78,6.62A3.35,3.35,0,0,0,9.5,17a3.5,3.5,0,1,0,3.15,5H21ZM9.5,22A1.5,1.5,0,1,1,11,20.5,1.5,1.5,0,0,1,9.5,22Z\"/><rect x=\"19\" y=\"8\" width=\"7\" height=\"2\"/><rect x=\"19\" y=\"12\" width=\"4\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z\"/><path d=\"M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z\"/></svg>",
            "info": {},
            "path": "32/watson-health/annotation-visibility.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAnnotationVisibility32",
          "filepath": "watson-health/annotation-visibility/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z"
                }
              }
            ],
            "name": "annotation-visibility",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAnnotationVisibility24",
          "filepath": "watson-health/annotation-visibility/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z"
                }
              }
            ],
            "name": "annotation-visibility",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAnnotationVisibility20",
          "filepath": "watson-health/annotation-visibility/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z"
                }
              }
            ],
            "name": "annotation-visibility",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAnnotationVisibility16",
          "filepath": "watson-health/annotation-visibility/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z"
                }
              }
            ],
            "name": "annotation-visibility",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AnnotationVisibility",
        "global": "WatsonHealthAnnotationVisibility",
        "filepath": "watson-health/AnnotationVisibility.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "aperture",
      "friendlyName": "Aperture",
      "aliases": [
        "eye",
        "camera",
        "pinhole",
        "pinwheel",
        "lense",
        "opening",
        "hole"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/aperture.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>aperture</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z\"/></svg>",
            "info": {},
            "path": "32/aperture.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Aperture32",
          "filepath": "aperture/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
                }
              }
            ],
            "name": "aperture",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Aperture24",
          "filepath": "aperture/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
                }
              }
            ],
            "name": "aperture",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Aperture20",
          "filepath": "aperture/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
                }
              }
            ],
            "name": "aperture",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Aperture16",
          "filepath": "aperture/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
                }
              }
            ],
            "name": "aperture",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Aperture",
        "global": "Aperture",
        "filepath": "Aperture.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "api",
      "friendlyName": "API",
      "aliases": [
        "program",
        "tool",
        "application",
        "format",
        "interface",
        "protocol",
        "connect",
        "group",
        "network",
        "application programming interface",
        "programming interface",
        "computing interface",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/api.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>api</title><path d=\"M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\" transform=\"translate(0 0)\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/api.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Api32",
          "filepath": "api/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "api",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Api24",
          "filepath": "api/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "api",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Api20",
          "filepath": "api/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "api",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Api16",
          "filepath": "api/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "api",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Api",
        "global": "Api",
        "filepath": "Api.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "API--1",
      "friendlyName": "API 1",
      "aliases": [
        "Application programming interface",
        "tool",
        "application",
        "programming",
        "interface",
        "file",
        "file type",
        "program",
        "tool",
        "format",
        "protocol",
        "connect",
        "group",
        "network",
        "programming interface",
        "computing interface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/API--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>API</title><path d=\"M8,9H4a2,2,0,0,0-2,2V23H4V18H8v5h2V11A2,2,0,0,0,8,9ZM4,16V11H8v5Z\" transform=\"translate(0 0)\"/><polygon points=\"22 11 25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11\"/><path d=\"M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z\"/></svg>",
            "info": {},
            "path": "32/API--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Api_132",
          "filepath": "API--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z"
                }
              }
            ],
            "name": "API--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Api_124",
          "filepath": "API--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z"
                }
              }
            ],
            "name": "API--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Api_120",
          "filepath": "API--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z"
                }
              }
            ],
            "name": "API--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Api_116",
          "filepath": "API--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z"
                }
              }
            ],
            "name": "API--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Api_1",
        "global": "Api_1",
        "filepath": "Api_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "app",
      "friendlyName": "App",
      "aliases": [
        "app",
        "file",
        "application",
        "software"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/app.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>app</title><path d=\"M28,10H22V24h2V20h4a2.0027,2.0027,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10Zm-4,8V12h4v6Z\"/><path d=\"M18,10H12V24h2V20h4a2.0027,2.0027,0,0,0,2-2V12A2.0023,2.0023,0,0,0,18,10Zm-4,8V12h4v6Z\"/><path d=\"M8,10H3v2H8v2H4a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V12A2.0023,2.0023,0,0,0,8,10Zm0,8H4V16H8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z\"/></svg>",
            "info": {},
            "path": "32/app.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "App32",
          "filepath": "app/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z"
                }
              }
            ],
            "name": "app",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "App24",
          "filepath": "app/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z"
                }
              }
            ],
            "name": "app",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "App20",
          "filepath": "app/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z"
                }
              }
            ],
            "name": "app",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "App16",
          "filepath": "app/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z"
                }
              }
            ],
            "name": "app",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "App",
        "global": "App",
        "filepath": "App.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "app-connectivity",
      "friendlyName": "App connectivity",
      "aliases": [
        "data",
        "app",
        "connectivity",
        "app connectivity",
        "interconnection",
        "connection",
        "integration",
        "network",
        "network connection",
        "relational"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/app-connectivity.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>app-connectivity</title>\n  <path d=\"M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z\"/></svg>",
            "info": {},
            "path": "32/app-connectivity.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AppConnectivity32",
          "filepath": "app-connectivity/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
                }
              }
            ],
            "name": "app-connectivity",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AppConnectivity24",
          "filepath": "app-connectivity/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
                }
              }
            ],
            "name": "app-connectivity",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AppConnectivity20",
          "filepath": "app-connectivity/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
                }
              }
            ],
            "name": "app-connectivity",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AppConnectivity16",
          "filepath": "app-connectivity/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
                }
              }
            ],
            "name": "app-connectivity",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "AppConnectivity",
        "global": "AppConnectivity",
        "filepath": "AppConnectivity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "apple",
      "friendlyName": "Apple",
      "aliases": [
        "apple",
        "commerce",
        "fruit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/apple.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>apple</title><path d=\"M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z\"/><path d=\"M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z\"/><path d=\"M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z\"/></svg>",
            "info": {},
            "path": "32/apple.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Apple32",
          "filepath": "apple/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
                }
              }
            ],
            "name": "apple",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Apple24",
          "filepath": "apple/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
                }
              }
            ],
            "name": "apple",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Apple20",
          "filepath": "apple/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
                }
              }
            ],
            "name": "apple",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Apple16",
          "filepath": "apple/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
                }
              }
            ],
            "name": "apple",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Apple",
        "global": "Apple",
        "filepath": "Apple.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "apple--dash",
      "friendlyName": "apple--dash",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/apple--dash.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M7.0825,11.6714l-1.6748-1.0928c-.9062,1.3887-1.3928,3.2305-1.4072,5.3267l2,.0137c.0117-1.7119,.3857-3.1807,1.082-4.2476Z\"/>\n  <path d=\"M6.0852,17.8164l-1.9907,.1934c.1887,1.938,.6592,3.6738,1.3982,5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614Z\"/>\n  <path d=\"M8.2378,23.7964l-1.5688,1.2402c1.333,1.6865,3.0972,2.7573,4.8396,2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885Z\"/>\n  <path d=\"M16,25c-.7334,0-1.4783,.271-2.1987,.5332-.1809,.0654-.3635,.1318-.5469,.1943l.6426,1.894c.197-.0669,.3936-.1382,.5879-.209,.5576-.2026,1.134-.4126,1.5151-.4126,.3809,0,.9575,.21,1.5149,.4121,.1809,.0659,.3635,.1323,.5466,.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327Z\"/>\n  <path d=\"M20.2546,25.9878l.1855,1.9917c1.7456-.1631,3.5178-1.2227,4.8621-2.9072l-1.5632-1.2476c-.9924,1.2437-2.2949,2.0522-3.4844,2.1631Z\"/>\n  <path d=\"M24.7004,22.3115l1.7871,.8975c.7449-1.4834,1.2205-3.2178,1.4138-5.1558l-1.9902-.1987c-.1689,1.6938-.5762,3.1934-1.2107,4.457Z\"/>\n  <path d=\"M28,15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821,1.082c.6897,1.0728,1.0576,2.5444,1.064,4.2559l2-.0068Z\"/>\n  <path d=\"M20,4h-1c-1.1046,0-2,.8954-2,2v1h1c1.1046,0,2-.8954,2-2v-1Z\"/>\n  <path d=\"M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7.0825 11.6714l-1.6748-1.0928c-.9062 1.3887-1.3928 3.2305-1.4072 5.3267l2 .0137c.0117-1.7119.3857-3.1807 1.082-4.2476zM6.0852 17.8164l-1.9907.1934c.1887 1.938.6592 3.6738 1.3982 5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614zM8.2378 23.7964l-1.5688 1.2402c1.333 1.6865 3.0972 2.7573 4.8396 2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885zM16 25c-.7334 0-1.4783.271-2.1987.5332-.1809.0654-.3635.1318-.5469.1943l.6426 1.894c.197-.0669.3936-.1382.5879-.209.5576-.2026 1.134-.4126 1.5151-.4126.3809 0 .9575.21 1.5149.4121.1809.0659.3635.1323.5466.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327zM20.2546 25.9878l.1855 1.9917c1.7456-.1631 3.5178-1.2227 4.8621-2.9072l-1.5632-1.2476c-.9924 1.2437-2.2949 2.0522-3.4844 2.1631zM24.7004 22.3115l1.7871.8975c.7449-1.4834 1.2205-3.2178 1.4138-5.1558l-1.9902-.1987c-.1689 1.6938-.5762 3.1934-1.2107 4.457zM28 15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821 1.082c.6897 1.0728 1.0576 2.5444 1.064 4.2559l2-.0068zM20 4h-1c-1.1046 0-2 .8954-2 2v1h1c1.1046 0 2-.8954 2-2v-1z\"/><path d=\"M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z\"/></svg>",
            "info": {},
            "path": "32/apple--dash.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AppleDash32",
          "filepath": "apple--dash/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0825 11.6714l-1.6748-1.0928c-.9062 1.3887-1.3928 3.2305-1.4072 5.3267l2 .0137c.0117-1.7119.3857-3.1807 1.082-4.2476zM6.0852 17.8164l-1.9907.1934c.1887 1.938.6592 3.6738 1.3982 5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614zM8.2378 23.7964l-1.5688 1.2402c1.333 1.6865 3.0972 2.7573 4.8396 2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885zM16 25c-.7334 0-1.4783.271-2.1987.5332-.1809.0654-.3635.1318-.5469.1943l.6426 1.894c.197-.0669.3936-.1382.5879-.209.5576-.2026 1.134-.4126 1.5151-.4126.3809 0 .9575.21 1.5149.4121.1809.0659.3635.1323.5466.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327zM20.2546 25.9878l.1855 1.9917c1.7456-.1631 3.5178-1.2227 4.8621-2.9072l-1.5632-1.2476c-.9924 1.2437-2.2949 2.0522-3.4844 2.1631zM24.7004 22.3115l1.7871.8975c.7449-1.4834 1.2205-3.2178 1.4138-5.1558l-1.9902-.1987c-.1689 1.6938-.5762 3.1934-1.2107 4.457zM28 15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821 1.082c.6897 1.0728 1.0576 2.5444 1.064 4.2559l2-.0068zM20 4h-1c-1.1046 0-2 .8954-2 2v1h1c1.1046 0 2-.8954 2-2v-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z"
                }
              }
            ],
            "name": "apple--dash",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AppleDash24",
          "filepath": "apple--dash/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0825 11.6714l-1.6748-1.0928c-.9062 1.3887-1.3928 3.2305-1.4072 5.3267l2 .0137c.0117-1.7119.3857-3.1807 1.082-4.2476zM6.0852 17.8164l-1.9907.1934c.1887 1.938.6592 3.6738 1.3982 5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614zM8.2378 23.7964l-1.5688 1.2402c1.333 1.6865 3.0972 2.7573 4.8396 2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885zM16 25c-.7334 0-1.4783.271-2.1987.5332-.1809.0654-.3635.1318-.5469.1943l.6426 1.894c.197-.0669.3936-.1382.5879-.209.5576-.2026 1.134-.4126 1.5151-.4126.3809 0 .9575.21 1.5149.4121.1809.0659.3635.1323.5466.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327zM20.2546 25.9878l.1855 1.9917c1.7456-.1631 3.5178-1.2227 4.8621-2.9072l-1.5632-1.2476c-.9924 1.2437-2.2949 2.0522-3.4844 2.1631zM24.7004 22.3115l1.7871.8975c.7449-1.4834 1.2205-3.2178 1.4138-5.1558l-1.9902-.1987c-.1689 1.6938-.5762 3.1934-1.2107 4.457zM28 15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821 1.082c.6897 1.0728 1.0576 2.5444 1.064 4.2559l2-.0068zM20 4h-1c-1.1046 0-2 .8954-2 2v1h1c1.1046 0 2-.8954 2-2v-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z"
                }
              }
            ],
            "name": "apple--dash",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AppleDash20",
          "filepath": "apple--dash/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0825 11.6714l-1.6748-1.0928c-.9062 1.3887-1.3928 3.2305-1.4072 5.3267l2 .0137c.0117-1.7119.3857-3.1807 1.082-4.2476zM6.0852 17.8164l-1.9907.1934c.1887 1.938.6592 3.6738 1.3982 5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614zM8.2378 23.7964l-1.5688 1.2402c1.333 1.6865 3.0972 2.7573 4.8396 2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885zM16 25c-.7334 0-1.4783.271-2.1987.5332-.1809.0654-.3635.1318-.5469.1943l.6426 1.894c.197-.0669.3936-.1382.5879-.209.5576-.2026 1.134-.4126 1.5151-.4126.3809 0 .9575.21 1.5149.4121.1809.0659.3635.1323.5466.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327zM20.2546 25.9878l.1855 1.9917c1.7456-.1631 3.5178-1.2227 4.8621-2.9072l-1.5632-1.2476c-.9924 1.2437-2.2949 2.0522-3.4844 2.1631zM24.7004 22.3115l1.7871.8975c.7449-1.4834 1.2205-3.2178 1.4138-5.1558l-1.9902-.1987c-.1689 1.6938-.5762 3.1934-1.2107 4.457zM28 15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821 1.082c.6897 1.0728 1.0576 2.5444 1.064 4.2559l2-.0068zM20 4h-1c-1.1046 0-2 .8954-2 2v1h1c1.1046 0 2-.8954 2-2v-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z"
                }
              }
            ],
            "name": "apple--dash",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AppleDash16",
          "filepath": "apple--dash/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0825 11.6714l-1.6748-1.0928c-.9062 1.3887-1.3928 3.2305-1.4072 5.3267l2 .0137c.0117-1.7119.3857-3.1807 1.082-4.2476zM6.0852 17.8164l-1.9907.1934c.1887 1.938.6592 3.6738 1.3982 5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614zM8.2378 23.7964l-1.5688 1.2402c1.333 1.6865 3.0972 2.7573 4.8396 2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885zM16 25c-.7334 0-1.4783.271-2.1987.5332-.1809.0654-.3635.1318-.5469.1943l.6426 1.894c.197-.0669.3936-.1382.5879-.209.5576-.2026 1.134-.4126 1.5151-.4126.3809 0 .9575.21 1.5149.4121.1809.0659.3635.1323.5466.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327zM20.2546 25.9878l.1855 1.9917c1.7456-.1631 3.5178-1.2227 4.8621-2.9072l-1.5632-1.2476c-.9924 1.2437-2.2949 2.0522-3.4844 2.1631zM24.7004 22.3115l1.7871.8975c.7449-1.4834 1.2205-3.2178 1.4138-5.1558l-1.9902-.1987c-.1689 1.6938-.5762 3.1934-1.2107 4.457zM28 15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821 1.082c.6897 1.0728 1.0576 2.5444 1.064 4.2559l2-.0068zM20 4h-1c-1.1046 0-2 .8954-2 2v1h1c1.1046 0 2-.8954 2-2v-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z"
                }
              }
            ],
            "name": "apple--dash",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "AppleDash",
        "global": "AppleDash",
        "filepath": "AppleDash.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.0825 11.6714l-1.6748-1.0928c-.9062 1.3887-1.3928 3.2305-1.4072 5.3267l2 .0137c.0117-1.7119.3857-3.1807 1.082-4.2476zM6.0852 17.8164l-1.9907.1934c.1887 1.938.6592 3.6738 1.3982 5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614zM8.2378 23.7964l-1.5688 1.2402c1.333 1.6865 3.0972 2.7573 4.8396 2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885zM16 25c-.7334 0-1.4783.271-2.1987.5332-.1809.0654-.3635.1318-.5469.1943l.6426 1.894c.197-.0669.3936-.1382.5879-.209.5576-.2026 1.134-.4126 1.5151-.4126.3809 0 .9575.21 1.5149.4121.1809.0659.3635.1323.5466.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327zM20.2546 25.9878l.1855 1.9917c1.7456-.1631 3.5178-1.2227 4.8621-2.9072l-1.5632-1.2476c-.9924 1.2437-2.2949 2.0522-3.4844 2.1631zM24.7004 22.3115l1.7871.8975c.7449-1.4834 1.2205-3.2178 1.4138-5.1558l-1.9902-.1987c-.1689 1.6938-.5762 3.1934-1.2107 4.457zM28 15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821 1.082c.6897 1.0728 1.0576 2.5444 1.064 4.2559l2-.0068zM20 4h-1c-1.1046 0-2 .8954-2 2v1h1c1.1046 0 2-.8954 2-2v-1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "application",
      "friendlyName": "Application",
      "aliases": [
        "box",
        "app",
        "interface",
        "software",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/application.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>application</title><path d=\"M16,18H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H16a2,2,0,0,1,2,2V16A2,2,0,0,1,16,18ZM6,6V16H16V6Z\" transform=\"translate(0 0)\"/><path d=\"M26,12v4H22V12h4m0-2H22a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z\" transform=\"translate(0 0)\"/><path d=\"M26,22v4H22V22h4m0-2H22a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z\" transform=\"translate(0 0)\"/><path d=\"M16,22v4H12V22h4m0-2H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z\" transform=\"translate(0 0)\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/application.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Application32",
          "filepath": "application/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "application",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Application24",
          "filepath": "application/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "application",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Application20",
          "filepath": "application/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "application",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Application16",
          "filepath": "application/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "application",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Application",
        "global": "Application",
        "filepath": "Application.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "application--mobile",
      "friendlyName": "Application mobile",
      "aliases": [
        "application",
        "mobile",
        "systems",
        "app",
        "phone",
        "tablet",
        "software",
        "interface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/application--mobile.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"23\" y=\"7\" width=\"4\" height=\"4\"/>\n  <rect x=\"23\" y=\"13\" width=\"4\" height=\"4\"/>\n  <rect x=\"17\" y=\"7\" width=\"4\" height=\"4\"/>\n  <rect x=\"17\" y=\"13\" width=\"4\" height=\"4\"/>\n  <circle cx=\"14.5\" cy=\"24.5\" r=\"1.5\"/>\n  <path d=\"M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z\"/><circle cx=\"14.5\" cy=\"24.5\" r=\"1.5\"/><path d=\"M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z\"/></svg>",
            "info": {},
            "path": "32/application--mobile.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ApplicationMobile32",
          "filepath": "application--mobile/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
                }
              }
            ],
            "name": "application--mobile",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ApplicationMobile24",
          "filepath": "application--mobile/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
                }
              }
            ],
            "name": "application--mobile",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ApplicationMobile20",
          "filepath": "application--mobile/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
                }
              }
            ],
            "name": "application--mobile",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ApplicationMobile16",
          "filepath": "application--mobile/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
                }
              }
            ],
            "name": "application--mobile",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ApplicationMobile",
        "global": "ApplicationMobile",
        "filepath": "ApplicationMobile.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14.5",
                    "cy": "24.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "application--virtual",
      "friendlyName": "Application virtual",
      "aliases": [
        "application",
        "virtual",
        "systems",
        "app",
        "software",
        "interface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/application--virtual.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"17\" y=\"19\" width=\"4\" height=\"4\"/>\n  <rect x=\"11\" y=\"19\" width=\"4\" height=\"4\"/>\n  <rect x=\"17\" y=\"25\" width=\"4\" height=\"4\"/>\n  <rect x=\"11\" y=\"25\" width=\"4\" height=\"4\"/>\n  <path d=\"M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z\"/><path d=\"M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z\"/></svg>",
            "info": {},
            "path": "32/application--virtual.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ApplicationVirtual32",
          "filepath": "application--virtual/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "application--virtual",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ApplicationVirtual24",
          "filepath": "application--virtual/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "application--virtual",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ApplicationVirtual20",
          "filepath": "application--virtual/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "application--virtual",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ApplicationVirtual16",
          "filepath": "application--virtual/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "application--virtual",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ApplicationVirtual",
        "global": "ApplicationVirtual",
        "filepath": "ApplicationVirtual.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "application--web",
      "friendlyName": "Application web",
      "aliases": [
        "application",
        "web",
        "systems",
        "app",
        "software",
        "interface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/application--web.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"26\" y=\"2\" width=\"4\" height=\"4\"/>\n  <rect x=\"26\" y=\"8\" width=\"4\" height=\"4\"/>\n  <rect x=\"20\" y=\"2\" width=\"4\" height=\"4\"/>\n  <rect x=\"20\" y=\"8\" width=\"4\" height=\"4\"/>\n  <path d=\"M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z\"/><path d=\"M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z\"/></svg>",
            "info": {},
            "path": "32/application--web.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ApplicationWeb32",
          "filepath": "application--web/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "application--web",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ApplicationWeb24",
          "filepath": "application--web/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "application--web",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ApplicationWeb20",
          "filepath": "application--web/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "application--web",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ApplicationWeb16",
          "filepath": "application--web/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "application--web",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ApplicationWeb",
        "global": "ApplicationWeb",
        "filepath": "ApplicationWeb.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "apps",
      "friendlyName": "Apps",
      "aliases": [
        "application",
        "drawer",
        "9 dot",
        "9 squares",
        "applications",
        "software",
        "programs"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/apps.svg",
          "source": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\"><path d=\"M4 2v2H2V2h2zm1-1H1v4h4V1zM9 2v2H7V2h2zm1-1H6v4h4V1zM14 2v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zM9 7v2H7V7h2zm1-1H6v4h4V6zM14 7v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zM9 12v2H7v-2h2zm1-1H6v4h4v-4zM14 12v2h-2v-2h2zm1-1h-4v4h4v-4z\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4 2v2H2V2h2zm1-1H1v4h4V1zM9 2v2H7V2h2zm1-1H6v4h4V1zM14 2v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zM9 7v2H7V7h2zm1-1H6v4h4V6zM14 7v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zM9 12v2H7v-2h2zm1-1H6v4h4v-4zM14 12v2h-2v-2h2zm1-1h-4v4h4v-4z\"/></svg>",
            "info": {},
            "path": "16/apps.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/apps.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z\"/></svg>",
            "info": {},
            "path": "32/apps.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Apps32",
          "filepath": "apps/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z"
                }
              }
            ],
            "name": "apps",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Apps24",
          "filepath": "apps/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z"
                }
              }
            ],
            "name": "apps",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Apps20",
          "filepath": "apps/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z"
                }
              }
            ],
            "name": "apps",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Apps16",
          "filepath": "apps/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2v2H2V2h2zm1-1H1v4h4V1zM9 2v2H7V2h2zm1-1H6v4h4V1zM14 2v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zM9 7v2H7V7h2zm1-1H6v4h4V6zM14 7v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zM9 12v2H7v-2h2zm1-1H6v4h4v-4zM14 12v2h-2v-2h2zm1-1h-4v4h4v-4z"
                }
              }
            ],
            "name": "apps",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Apps",
        "global": "Apps",
        "filepath": "Apps.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 2v2H2V2h2zm1-1H1v4h4V1zM9 2v2H7V2h2zm1-1H6v4h4V1zM14 2v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zM9 7v2H7V7h2zm1-1H6v4h4V6zM14 7v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zM9 12v2H7v-2h2zm1-1H6v4h4v-4zM14 12v2h-2v-2h2zm1-1h-4v4h4v-4z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "archive",
      "friendlyName": "Archive",
      "aliases": [
        "drawer",
        "server",
        "stack",
        "tower",
        "file cabinet",
        "data",
        "record",
        "document",
        "log",
        "catalog",
        "store"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/archive.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>archive</title><rect x=\"14\" y=\"19\" width=\"4\" height=\"2\"/><path d=\"M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 19H18V21H14z\"/><path d=\"M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z\"/></svg>",
            "info": {},
            "path": "32/archive.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Archive32",
          "filepath": "archive/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 19H18V21H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "archive",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Archive24",
          "filepath": "archive/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 19H18V21H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "archive",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Archive20",
          "filepath": "archive/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 19H18V21H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "archive",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Archive16",
          "filepath": "archive/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 19H18V21H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "archive",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Archive",
        "global": "Archive",
        "filepath": "Archive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 19H18V21H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "area",
      "friendlyName": "Area",
      "aliases": [
        "area",
        "boundary",
        "field",
        "range",
        "space"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/area.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/area.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Area32",
          "filepath": "area/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "area",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Area24",
          "filepath": "area/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "area",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Area20",
          "filepath": "area/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "area",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Area16",
          "filepath": "area/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "area",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Area",
        "global": "Area",
        "filepath": "Area.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "area--custom",
      "friendlyName": "Area custom",
      "aliases": [
        "area",
        "custom",
        "boundary",
        "field",
        "range",
        "space"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/area--custom.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z\"/></svg>",
            "info": {},
            "path": "32/area--custom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AreaCustom32",
          "filepath": "area--custom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
                }
              }
            ],
            "name": "area--custom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AreaCustom24",
          "filepath": "area--custom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
                }
              }
            ],
            "name": "area--custom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AreaCustom20",
          "filepath": "area--custom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
                }
              }
            ],
            "name": "area--custom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AreaCustom16",
          "filepath": "area--custom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
                }
              }
            ],
            "name": "area--custom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "AreaCustom",
        "global": "AreaCustom",
        "filepath": "AreaCustom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrival",
      "friendlyName": "Arrival",
      "aliases": [
        "plane",
        "landing",
        "descend",
        "travel",
        "descent",
        "land",
        "airplane",
        "aircraft",
        "airline"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrival.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>arrival</title><rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/><path d=\"M17.21,5.23l1.39.38,1,11.29,5.87,1.57A2,2,0,0,1,27,20.62a1.88,1.88,0,0,1-1.37,1.52,2,2,0,0,1-1,0l-18.7-5a1.89,1.89,0,0,1-1.33-2.3L6.35,8.34l1.44.38L8.4,13.9l6,1.62L17.21,5.23m-1-2.2a1,1,0,0,0-.68.69L13,13.07l-2.81-.75L9.69,7.79A1,1,0,0,0,9,7L5.87,6.14a.94.94,0,0,0-.5,0,1,1,0,0,0-.68.68l-2,7.49a3.87,3.87,0,0,0,2.74,4.74l18.71,5A3.87,3.87,0,0,0,29,21a4,4,0,0,0-3-4.42l-4.52-1.21L20.53,4.71a1,1,0,0,0-.72-.85L16.73,3a1.06,1.06,0,0,0-.5,0Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z\"/></svg>",
            "info": {},
            "path": "32/arrival.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Arrival32",
          "filepath": "arrival/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z"
                }
              }
            ],
            "name": "arrival",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Arrival24",
          "filepath": "arrival/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z"
                }
              }
            ],
            "name": "arrival",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Arrival20",
          "filepath": "arrival/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z"
                }
              }
            ],
            "name": "arrival",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Arrival16",
          "filepath": "arrival/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z"
                }
              }
            ],
            "name": "arrival",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Arrival",
        "global": "Arrival",
        "filepath": "Arrival.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--annotation",
      "friendlyName": "Arrow annotation",
      "aliases": [
        "direction",
        "point",
        "health",
        "pointer"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/arrow--annotation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--arrow-annotation</title><polygon points=\"13.71 12.29 7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29\"/><path d=\"M28,10H18v2H28V28H12V18H10V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z\" transform=\"translate(0 0)\"/><polygon points=\"19 25 21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z\"/><path d=\"M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z\"/></svg>",
            "info": {},
            "path": "32/watson-health/arrow--annotation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthArrowAnnotation32",
          "filepath": "watson-health/arrow--annotation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
                }
              }
            ],
            "name": "arrow--annotation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthArrowAnnotation24",
          "filepath": "watson-health/arrow--annotation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
                }
              }
            ],
            "name": "arrow--annotation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthArrowAnnotation20",
          "filepath": "watson-health/arrow--annotation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
                }
              }
            ],
            "name": "arrow--annotation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthArrowAnnotation16",
          "filepath": "watson-health/arrow--annotation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
                }
              }
            ],
            "name": "arrow--annotation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ArrowAnnotation",
        "global": "WatsonHealthArrowAnnotation",
        "filepath": "watson-health/ArrowAnnotation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--down",
      "friendlyName": "Arrow down",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "down",
        "down arrow",
        "arrow down"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/arrow--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>arrow--down</title>\n<polygon points=\"12.3,9.3 8.5,13.1 8.5,1 7.5,1 7.5,13.1 3.7,9.3 3,10 8,15 13,10 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12.3 9.3L8.5 13.1 8.5 1 7.5 1 7.5 13.1 3.7 9.3 3 10 8 15 13 10z\"/></svg>",
            "info": {},
            "path": "16/arrow--down.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/arrow--down.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"24.59 16.59 17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z\"/></svg>",
            "info": {},
            "path": "32/arrow--down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowDown32",
          "filepath": "arrow--down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"
                }
              }
            ],
            "name": "arrow--down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowDown24",
          "filepath": "arrow--down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"
                }
              }
            ],
            "name": "arrow--down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowDown20",
          "filepath": "arrow--down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"
                }
              }
            ],
            "name": "arrow--down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowDown16",
          "filepath": "arrow--down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.3 9.3L8.5 13.1 8.5 1 7.5 1 7.5 13.1 3.7 9.3 3 10 8 15 13 10z"
                }
              }
            ],
            "name": "arrow--down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowDown",
        "global": "ArrowDown",
        "filepath": "ArrowDown.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.3 9.3L8.5 13.1 8.5 1 7.5 1 7.5 13.1 3.7 9.3 3 10 8 15 13 10z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--down-left",
      "friendlyName": "Arrow down left",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "left",
        "left arrow",
        "arrow left",
        "down arrow"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrow--down-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>arrow--down-left</title><polygon points=\"22 26 22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z\"/></svg>",
            "info": {},
            "path": "32/arrow--down-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowDownLeft32",
          "filepath": "arrow--down-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
                }
              }
            ],
            "name": "arrow--down-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowDownLeft24",
          "filepath": "arrow--down-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
                }
              }
            ],
            "name": "arrow--down-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowDownLeft20",
          "filepath": "arrow--down-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
                }
              }
            ],
            "name": "arrow--down-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowDownLeft16",
          "filepath": "arrow--down-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
                }
              }
            ],
            "name": "arrow--down-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowDownLeft",
        "global": "ArrowDownLeft",
        "filepath": "ArrowDownLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--down-right",
      "friendlyName": "Arrow down right",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "right",
        "right arrow",
        "right arrow down",
        "arrow right",
        "down arrow"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrow--down-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>arrow--down-right</title><polygon points=\"10 26 10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z\"/></svg>",
            "info": {},
            "path": "32/arrow--down-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowDownRight32",
          "filepath": "arrow--down-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
                }
              }
            ],
            "name": "arrow--down-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowDownRight24",
          "filepath": "arrow--down-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
                }
              }
            ],
            "name": "arrow--down-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowDownRight20",
          "filepath": "arrow--down-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
                }
              }
            ],
            "name": "arrow--down-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowDownRight16",
          "filepath": "arrow--down-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
                }
              }
            ],
            "name": "arrow--down-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowDownRight",
        "global": "ArrowDownRight",
        "filepath": "ArrowDownRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--left",
      "friendlyName": "Arrow left",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "left",
        "left arrow",
        "arrow left"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/arrow--left.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>arrow--down</title>\n<polygon points=\"6.7,12.3 2.9,8.5 15,8.5 15,7.5 2.9,7.5 6.7,3.7 6,3 1,8 6,13 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z\"/></svg>",
            "info": {},
            "path": "16/arrow--left.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/arrow--left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 26 15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z\"/></svg>",
            "info": {},
            "path": "32/arrow--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowLeft32",
          "filepath": "arrow--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"
                }
              }
            ],
            "name": "arrow--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowLeft24",
          "filepath": "arrow--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"
                }
              }
            ],
            "name": "arrow--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowLeft20",
          "filepath": "arrow--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"
                }
              }
            ],
            "name": "arrow--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowLeft16",
          "filepath": "arrow--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z"
                }
              }
            ],
            "name": "arrow--left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowLeft",
        "global": "ArrowLeft",
        "filepath": "ArrowLeft.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--right",
      "friendlyName": "Arrow right",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "right",
        "right arrow",
        "arrow right"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/arrow--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>arrow--down</title>\n<polygon points=\"9.3,3.7 13.1,7.5 1,7.5 1,8.5 13.1,8.5 9.3,12.3 10,13 15,8 10,3 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z\"/></svg>",
            "info": {},
            "path": "16/arrow--right.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/arrow--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"20\" height=\"20\"/>\n<polygon points=\"11.8,2.8 10.8,3.8 16.2,9.3 1,9.3 1,10.7 16.2,10.7 10.8,16.2 11.8,17.2 19,10 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z\"/></svg>",
            "info": {},
            "path": "20/arrow--right.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/arrow--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"24\" height=\"24\"/>\n<polygon points=\"14,4 12.9,5.1 18.9,11.2 2,11.2 2,12.8 18.9,12.8 12.9,18.9 14,20 22,12 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M14 4L12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12z\"/></svg>",
            "info": {},
            "path": "24/arrow--right.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/arrow--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"18 6 16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z\"/></svg>",
            "info": {},
            "path": "32/arrow--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowRight32",
          "filepath": "arrow--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z"
                }
              }
            ],
            "name": "arrow--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowRight24",
          "filepath": "arrow--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4L12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12z"
                }
              }
            ],
            "name": "arrow--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowRight20",
          "filepath": "arrow--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"
                }
              }
            ],
            "name": "arrow--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowRight16",
          "filepath": "arrow--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z"
                }
              }
            ],
            "name": "arrow--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowRight",
        "global": "ArrowRight",
        "filepath": "ArrowRight.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 4L12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--up",
      "friendlyName": "Arrow up",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "up arrow",
        "arrow up"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/arrow--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>arrow--down</title>\n<polygon points=\"3.7,6.7 7.5,2.9 7.5,15 8.5,15 8.5,2.9 12.3,6.7 13,6 8,1 3,6 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M3.7 6.7L7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z\"/></svg>",
            "info": {},
            "path": "16/arrow--up.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/arrow--up.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 4 6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z\"/></svg>",
            "info": {},
            "path": "32/arrow--up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowUp32",
          "filepath": "arrow--up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"
                }
              }
            ],
            "name": "arrow--up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowUp24",
          "filepath": "arrow--up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"
                }
              }
            ],
            "name": "arrow--up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowUp20",
          "filepath": "arrow--up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"
                }
              }
            ],
            "name": "arrow--up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowUp16",
          "filepath": "arrow--up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.7 6.7L7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z"
                }
              }
            ],
            "name": "arrow--up",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowUp",
        "global": "ArrowUp",
        "filepath": "ArrowUp.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.7 6.7L7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--up-left",
      "friendlyName": "Arrow up left",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "up arrow left",
        "arrow up left"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrow--up-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>arrow--up-left</title><polygon points=\"22 6 22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z\"/></svg>",
            "info": {},
            "path": "32/arrow--up-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowUpLeft32",
          "filepath": "arrow--up-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
                }
              }
            ],
            "name": "arrow--up-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowUpLeft24",
          "filepath": "arrow--up-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
                }
              }
            ],
            "name": "arrow--up-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowUpLeft20",
          "filepath": "arrow--up-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
                }
              }
            ],
            "name": "arrow--up-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowUpLeft16",
          "filepath": "arrow--up-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
                }
              }
            ],
            "name": "arrow--up-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowUpLeft",
        "global": "ArrowUpLeft",
        "filepath": "ArrowUpLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow--up-right",
      "friendlyName": "Arrow up right",
      "aliases": [
        "direction",
        "point",
        "pointer",
        "up arrow right",
        "arrow up right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrow--up-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>arrow--up-right</title><polygon points=\"10 6 10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z\"/></svg>",
            "info": {},
            "path": "32/arrow--up-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowUpRight32",
          "filepath": "arrow--up-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
                }
              }
            ],
            "name": "arrow--up-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowUpRight24",
          "filepath": "arrow--up-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
                }
              }
            ],
            "name": "arrow--up-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowUpRight20",
          "filepath": "arrow--up-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
                }
              }
            ],
            "name": "arrow--up-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowUpRight16",
          "filepath": "arrow--up-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
                }
              }
            ],
            "name": "arrow--up-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ArrowUpRight",
        "global": "ArrowUpRight",
        "filepath": "ArrowUpRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrow-shift-down",
      "friendlyName": "Arrow shift down",
      "aliases": [
        "arrow-shift-down",
        "shift down arrow",
        "direction",
        "point",
        "pointer",
        "down arrow",
        "arrow down"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrow-shift-down.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>arrow-shift-down</title>\n  <path d=\"M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z\"/></svg>",
            "info": {},
            "path": "32/arrow-shift-down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowShiftDown32",
          "filepath": "arrow-shift-down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
                }
              }
            ],
            "name": "arrow-shift-down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowShiftDown24",
          "filepath": "arrow-shift-down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
                }
              }
            ],
            "name": "arrow-shift-down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowShiftDown20",
          "filepath": "arrow-shift-down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
                }
              }
            ],
            "name": "arrow-shift-down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowShiftDown16",
          "filepath": "arrow-shift-down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
                }
              }
            ],
            "name": "arrow-shift-down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ArrowShiftDown",
        "global": "ArrowShiftDown",
        "filepath": "ArrowShiftDown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrows--horizontal",
      "friendlyName": "Arrows horizontal",
      "aliases": [
        "direction",
        "point",
        "pointers",
        "horizontal arrows",
        "directional arrows"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrows--horizontal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>arrows--horizontal</title><polygon points=\"11.41 26.59 7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59\"/><polygon points=\"28 10 22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32) rotate(90)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z\"/></svg>",
            "info": {},
            "path": "32/arrows--horizontal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowsHorizontal32",
          "filepath": "arrows--horizontal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
                }
              }
            ],
            "name": "arrows--horizontal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowsHorizontal24",
          "filepath": "arrows--horizontal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
                }
              }
            ],
            "name": "arrows--horizontal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowsHorizontal20",
          "filepath": "arrows--horizontal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
                }
              }
            ],
            "name": "arrows--horizontal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowsHorizontal16",
          "filepath": "arrows--horizontal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
                }
              }
            ],
            "name": "arrows--horizontal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ArrowsHorizontal",
        "global": "ArrowsHorizontal",
        "filepath": "ArrowsHorizontal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "arrows--vertical",
      "friendlyName": "Arrows vertical",
      "aliases": [
        "direction",
        "point",
        "pointers",
        "vertical arrows",
        "directional arrows"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/arrows--vertical.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>arrows--vertical</title>\n<polygon points=\"27.6,20.6 24,24.2 24,4 22,4 22,24.2 18.4,20.6 17,22 23,28 29,22 \"/>\n<polygon points=\"9,4 3,10 4.4,11.4 8,7.8 8,28 10,28 10,7.8 13.6,11.4 15,10 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z\"/></svg>",
            "info": {},
            "path": "32/arrows--vertical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ArrowsVertical32",
          "filepath": "arrows--vertical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"
                }
              }
            ],
            "name": "arrows--vertical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ArrowsVertical24",
          "filepath": "arrows--vertical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"
                }
              }
            ],
            "name": "arrows--vertical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ArrowsVertical20",
          "filepath": "arrows--vertical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"
                }
              }
            ],
            "name": "arrows--vertical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ArrowsVertical16",
          "filepath": "arrows--vertical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"
                }
              }
            ],
            "name": "arrows--vertical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ArrowsVertical",
        "global": "ArrowsVertical",
        "filepath": "ArrowsVertical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "asleep",
      "friendlyName": "Asleep",
      "aliases": [
        "night",
        "moon",
        "sleep",
        "rest",
        "dark",
        "new moon",
        "cresent",
        "cresent moon",
        "cresent moon light",
        "cresent moon outline",
        "light moon",
        "cresent light",
        "cresent outline"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/asleep.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>asleep</title>\n<path d=\"M7.2,2.3c-1,4.4,1.7,8.7,6.1,9.8c0.1,0,0.1,0,0.2,0c-1.1,1.2-2.7,1.8-4.3,1.8c-0.1,0-0.2,0-0.2,0C5.6,13.8,3,11,3.2,7.7\n\tC3.2,5.3,4.8,3.1,7.2,2.3 M8,1L8,1C4.1,1.6,1.5,5.3,2.1,9.1c0.6,3.3,3.4,5.8,6.8,5.9c0.1,0,0.2,0,0.3,0c2.3,0,4.4-1.1,5.8-3\n\tc0.2-0.2,0.1-0.6-0.1-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c-3.9-0.3-6.7-3.8-6.4-7.6C8.3,3,8.4,2.4,8.6,1.8c0.1-0.3,0-0.6-0.3-0.7\n\tC8.1,1,8.1,1,8,1z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M7.2,2.3c-1,4.4,1.7,8.7,6.1,9.8c0.1,0,0.1,0,0.2,0c-1.1,1.2-2.7,1.8-4.3,1.8c-0.1,0-0.2,0-0.2,0C5.6,13.8,3,11,3.2,7.7\tC3.2,5.3,4.8,3.1,7.2,2.3 M8,1L8,1C4.1,1.6,1.5,5.3,2.1,9.1c0.6,3.3,3.4,5.8,6.8,5.9c0.1,0,0.2,0,0.3,0c2.3,0,4.4-1.1,5.8-3\tc0.2-0.2,0.1-0.6-0.1-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c-3.9-0.3-6.7-3.8-6.4-7.6C8.3,3,8.4,2.4,8.6,1.8c0.1-0.3,0-0.6-0.3-0.7\tC8.1,1,8.1,1,8,1z\"/></svg>",
            "info": {},
            "path": "16/asleep.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/asleep.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>asleep</title><path d=\"M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z\"/></svg>",
            "info": {},
            "path": "32/asleep.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Asleep32",
          "filepath": "asleep/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "asleep",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Asleep24",
          "filepath": "asleep/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "asleep",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Asleep20",
          "filepath": "asleep/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "asleep",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Asleep16",
          "filepath": "asleep/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.2,2.3c-1,4.4,1.7,8.7,6.1,9.8c0.1,0,0.1,0,0.2,0c-1.1,1.2-2.7,1.8-4.3,1.8c-0.1,0-0.2,0-0.2,0C5.6,13.8,3,11,3.2,7.7\tC3.2,5.3,4.8,3.1,7.2,2.3 M8,1L8,1C4.1,1.6,1.5,5.3,2.1,9.1c0.6,3.3,3.4,5.8,6.8,5.9c0.1,0,0.2,0,0.3,0c2.3,0,4.4-1.1,5.8-3\tc0.2-0.2,0.1-0.6-0.1-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c-3.9-0.3-6.7-3.8-6.4-7.6C8.3,3,8.4,2.4,8.6,1.8c0.1-0.3,0-0.6-0.3-0.7\tC8.1,1,8.1,1,8,1z"
                }
              }
            ],
            "name": "asleep",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Asleep",
        "global": "Asleep",
        "filepath": "Asleep.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.2,2.3c-1,4.4,1.7,8.7,6.1,9.8c0.1,0,0.1,0,0.2,0c-1.1,1.2-2.7,1.8-4.3,1.8c-0.1,0-0.2,0-0.2,0C5.6,13.8,3,11,3.2,7.7 C3.2,5.3,4.8,3.1,7.2,2.3 M8,1L8,1C4.1,1.6,1.5,5.3,2.1,9.1c0.6,3.3,3.4,5.8,6.8,5.9c0.1,0,0.2,0,0.3,0c2.3,0,4.4-1.1,5.8-3 c0.2-0.2,0.1-0.6-0.1-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c-3.9-0.3-6.7-3.8-6.4-7.6C8.3,3,8.4,2.4,8.6,1.8c0.1-0.3,0-0.6-0.3-0.7 C8.1,1,8.1,1,8,1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "asleep--filled",
      "friendlyName": "Asleep filled",
      "aliases": [
        "night",
        "moon",
        "sleep",
        "rest",
        "dark",
        "new moon",
        "cresent",
        "cresent moon",
        "cresent moon dark",
        "cresent moon filled",
        "dark moon",
        "cresent dark",
        "cresent filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/asleep--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>asleep--filled</title><path d=\"M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z\"/></svg>",
            "info": {},
            "path": "32/asleep--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AsleepFilled32",
          "filepath": "asleep--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "asleep--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AsleepFilled24",
          "filepath": "asleep--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "asleep--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AsleepFilled20",
          "filepath": "asleep--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "asleep--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AsleepFilled16",
          "filepath": "asleep--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "asleep--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "AsleepFilled",
        "global": "AsleepFilled",
        "filepath": "AsleepFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "assembly",
      "friendlyName": "Assembly",
      "aliases": [
        "systems",
        "assembly",
        "hexagon"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/assembly.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z\"/>\n<path d=\"M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9\n\tc0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9\n\tV22.1z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z\"/><path d=\"M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9\tc0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9\tV22.1z\"/></svg>",
            "info": {},
            "path": "32/assembly.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Assembly32",
          "filepath": "assembly/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9\tc0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9\tV22.1z"
                }
              }
            ],
            "name": "assembly",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Assembly24",
          "filepath": "assembly/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9\tc0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9\tV22.1z"
                }
              }
            ],
            "name": "assembly",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Assembly20",
          "filepath": "assembly/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9\tc0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9\tV22.1z"
                }
              }
            ],
            "name": "assembly",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Assembly16",
          "filepath": "assembly/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9\tc0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9\tV22.1z"
                }
              }
            ],
            "name": "assembly",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Assembly",
        "global": "Assembly",
        "filepath": "Assembly.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9 c0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9 V22.1z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "assembly--cluster",
      "friendlyName": "Assembly cluster",
      "aliases": [
        "systems",
        "assembly",
        "hexagon",
        "multiple"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/assembly--cluster.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M21.3,4.9l-4.5-2.7C16.5,2.1,16.3,2,16,2s-0.5,0.1-0.7,0.2l-4.5,2.7C10.3,5.2,10,5.7,10,6.2v5.6c0,0.5,0.3,1,0.7,1.3\n\tl4.5,2.7c0.2,0.1,0.5,0.2,0.7,0.2s0.5-0.1,0.7-0.2l4.5-2.7c0.4-0.3,0.7-0.7,0.7-1.3V6.2C22,5.7,21.7,5.2,21.3,4.9z M20,11.5l-4,2.4\n\tl-4-2.4v-5l4-2.4l4,2.4V11.5z\"/>\n<path d=\"M29.3,18.9l-4.5-2.7C24.5,16.1,24.3,16,24,16s-0.5,0.1-0.7,0.2l-4.5,2.7c-0.4,0.3-0.7,0.7-0.7,1.3v5.6c0,0.5,0.3,1,0.7,1.3\n\tl4.5,2.7c0.2,0.1,0.5,0.2,0.7,0.2s0.5-0.1,0.7-0.2l4.5-2.7c0.4-0.3,0.7-0.7,0.7-1.3v-5.6C30,19.7,29.7,19.2,29.3,18.9z M28,25.5\n\tl-4,2.4l-4-2.4v-5l4-2.4l4,2.4V25.5z\"/>\n<path d=\"M13.3,18.9l-4.5-2.7C8.5,16.1,8.3,16,8,16s-0.5,0.1-0.7,0.2l-4.5,2.7C2.3,19.2,2,19.7,2,20.2v5.6c0,0.5,0.3,1,0.7,1.3\n\tl4.5,2.7C7.5,29.9,7.7,30,8,30s0.5-0.1,0.7-0.2l4.5-2.7c0.4-0.3,0.7-0.7,0.7-1.3v-5.6C14,19.7,13.7,19.2,13.3,18.9z M12,25.5l-4,2.4\n\tl-4-2.4v-5l4-2.4l4,2.4V25.5z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.3 4.9l-4.5-2.7C16.5 2.1 16.3 2 16 2s-.5.1-.7.2l-4.5 2.7C10.3 5.2 10 5.7 10 6.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3V6.2C22 5.7 21.7 5.2 21.3 4.9zM20 11.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V11.5zM29.3 18.9l-4.5-2.7C24.5 16.1 24.3 16 24 16s-.5.1-.7.2l-4.5 2.7c-.4.3-.7.7-.7 1.3v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C30 19.7 29.7 19.2 29.3 18.9zM28 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5zM13.3 18.9l-4.5-2.7C8.5 16.1 8.3 16 8 16s-.5.1-.7.2l-4.5 2.7C2.3 19.2 2 19.7 2 20.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7C7.5 29.9 7.7 30 8 30s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C14 19.7 13.7 19.2 13.3 18.9zM12 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5z\"/></svg>",
            "info": {},
            "path": "32/assembly--cluster.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AssemblyCluster32",
          "filepath": "assembly--cluster/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.3 4.9l-4.5-2.7C16.5 2.1 16.3 2 16 2s-.5.1-.7.2l-4.5 2.7C10.3 5.2 10 5.7 10 6.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3V6.2C22 5.7 21.7 5.2 21.3 4.9zM20 11.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V11.5zM29.3 18.9l-4.5-2.7C24.5 16.1 24.3 16 24 16s-.5.1-.7.2l-4.5 2.7c-.4.3-.7.7-.7 1.3v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C30 19.7 29.7 19.2 29.3 18.9zM28 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5zM13.3 18.9l-4.5-2.7C8.5 16.1 8.3 16 8 16s-.5.1-.7.2l-4.5 2.7C2.3 19.2 2 19.7 2 20.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7C7.5 29.9 7.7 30 8 30s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C14 19.7 13.7 19.2 13.3 18.9zM12 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5z"
                }
              }
            ],
            "name": "assembly--cluster",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AssemblyCluster24",
          "filepath": "assembly--cluster/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.3 4.9l-4.5-2.7C16.5 2.1 16.3 2 16 2s-.5.1-.7.2l-4.5 2.7C10.3 5.2 10 5.7 10 6.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3V6.2C22 5.7 21.7 5.2 21.3 4.9zM20 11.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V11.5zM29.3 18.9l-4.5-2.7C24.5 16.1 24.3 16 24 16s-.5.1-.7.2l-4.5 2.7c-.4.3-.7.7-.7 1.3v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C30 19.7 29.7 19.2 29.3 18.9zM28 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5zM13.3 18.9l-4.5-2.7C8.5 16.1 8.3 16 8 16s-.5.1-.7.2l-4.5 2.7C2.3 19.2 2 19.7 2 20.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7C7.5 29.9 7.7 30 8 30s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C14 19.7 13.7 19.2 13.3 18.9zM12 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5z"
                }
              }
            ],
            "name": "assembly--cluster",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AssemblyCluster20",
          "filepath": "assembly--cluster/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.3 4.9l-4.5-2.7C16.5 2.1 16.3 2 16 2s-.5.1-.7.2l-4.5 2.7C10.3 5.2 10 5.7 10 6.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3V6.2C22 5.7 21.7 5.2 21.3 4.9zM20 11.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V11.5zM29.3 18.9l-4.5-2.7C24.5 16.1 24.3 16 24 16s-.5.1-.7.2l-4.5 2.7c-.4.3-.7.7-.7 1.3v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C30 19.7 29.7 19.2 29.3 18.9zM28 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5zM13.3 18.9l-4.5-2.7C8.5 16.1 8.3 16 8 16s-.5.1-.7.2l-4.5 2.7C2.3 19.2 2 19.7 2 20.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7C7.5 29.9 7.7 30 8 30s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C14 19.7 13.7 19.2 13.3 18.9zM12 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5z"
                }
              }
            ],
            "name": "assembly--cluster",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AssemblyCluster16",
          "filepath": "assembly--cluster/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.3 4.9l-4.5-2.7C16.5 2.1 16.3 2 16 2s-.5.1-.7.2l-4.5 2.7C10.3 5.2 10 5.7 10 6.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3V6.2C22 5.7 21.7 5.2 21.3 4.9zM20 11.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V11.5zM29.3 18.9l-4.5-2.7C24.5 16.1 24.3 16 24 16s-.5.1-.7.2l-4.5 2.7c-.4.3-.7.7-.7 1.3v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C30 19.7 29.7 19.2 29.3 18.9zM28 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5zM13.3 18.9l-4.5-2.7C8.5 16.1 8.3 16 8 16s-.5.1-.7.2l-4.5 2.7C2.3 19.2 2 19.7 2 20.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7C7.5 29.9 7.7 30 8 30s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C14 19.7 13.7 19.2 13.3 18.9zM12 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5z"
                }
              }
            ],
            "name": "assembly--cluster",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "AssemblyCluster",
        "global": "AssemblyCluster",
        "filepath": "AssemblyCluster.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.3 4.9l-4.5-2.7C16.5 2.1 16.3 2 16 2s-.5.1-.7.2l-4.5 2.7C10.3 5.2 10 5.7 10 6.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3V6.2C22 5.7 21.7 5.2 21.3 4.9zM20 11.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V11.5zM29.3 18.9l-4.5-2.7C24.5 16.1 24.3 16 24 16s-.5.1-.7.2l-4.5 2.7c-.4.3-.7.7-.7 1.3v5.6c0 .5.3 1 .7 1.3l4.5 2.7c.2.1.5.2.7.2s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C30 19.7 29.7 19.2 29.3 18.9zM28 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5zM13.3 18.9l-4.5-2.7C8.5 16.1 8.3 16 8 16s-.5.1-.7.2l-4.5 2.7C2.3 19.2 2 19.7 2 20.2v5.6c0 .5.3 1 .7 1.3l4.5 2.7C7.5 29.9 7.7 30 8 30s.5-.1.7-.2l4.5-2.7c.4-.3.7-.7.7-1.3v-5.6C14 19.7 13.7 19.2 13.3 18.9zM12 25.5l-4 2.4-4-2.4v-5l4-2.4 4 2.4V25.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "assembly--reference",
      "friendlyName": "Assembly reference",
      "aliases": [
        "systems",
        "assembly",
        "hexagon",
        "dotted"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/assembly--reference.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"8.7\" y=\"5.1\" transform=\"matrix(0.8609 -0.5088 0.5088 0.8609 -1.6464 6.1809)\" width=\"3.5\" height=\"2\"/>\n<path d=\"M6,12H4V9.9c0-0.7,0.4-1.4,1-1.7l1.5-0.9l1,1.7L6,9.9V12z\"/>\n<rect x=\"4\" y=\"14\" width=\"2\" height=\"4\"/>\n<path d=\"M6.5,24.7L5,23.8c-0.6-0.4-1-1-1-1.7V20h2v2.1L7.5,23L6.5,24.7z\"/>\n<rect x=\"9.5\" y=\"24.1\" transform=\"matrix(0.5087 -0.8609 0.8609 0.5087 -17.1488 21.7453)\" width=\"2\" height=\"3.5\"/>\n<path d=\"M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z\"/>\n<rect x=\"19.8\" y=\"24.9\" transform=\"matrix(0.8609 -0.5088 0.5088 0.8609 -10.1928 14.5447)\" width=\"3.5\" height=\"2\"/>\n<path d=\"M25.2,24.9l-1-1.7l1.8-1V20h2v2.1c0,0.7-0.4,1.4-1,1.7L25.2,24.9z\"/>\n<rect x=\"26\" y=\"14\" width=\"2\" height=\"4\"/>\n<path d=\"M28,12h-2V9.9l-1.8-1l1-1.7l1.8,1c0.6,0.4,1,1,1,1.7V12z\"/>\n<rect x=\"20.5\" y=\"4.3\" transform=\"matrix(0.5087 -0.8609 0.8609 0.5087 5.321 21.5017)\" width=\"2\" height=\"3.5\"/>\n<path d=\"M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.7 5.1H12.2V7.1H8.7z\" transform=\"rotate(-30.582 10.48 6.101)\"/><path d=\"M6 12H4V9.9c0-.7.4-1.4 1-1.7l1.5-.9 1 1.7L6 9.9V12zM4 14H6V18H4zM6.5 24.7L5 23.8c-.6-.4-1-1-1-1.7V20h2v2.1L7.5 23 6.5 24.7z\"/><path d=\"M9.5 24.1H11.5V27.6H9.5z\" transform=\"rotate(-59.421 10.48 25.9)\"/><path d=\"M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z\"/><path d=\"M19.8 24.9H23.3V26.9H19.8z\" transform=\"rotate(-30.582 21.502 25.912)\"/><path d=\"M25.2 24.9l-1-1.7 1.8-1V20h2v2.1c0 .7-.4 1.4-1 1.7L25.2 24.9zM26 14H28V18H26zM28 12h-2V9.9l-1.8-1 1-1.7 1.8 1c.6.4 1 1 1 1.7V12z\"/><path d=\"M20.5 4.3H22.5V7.8H20.5z\" transform=\"rotate(-59.421 21.501 6.089)\"/><path d=\"M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z\"/></svg>",
            "info": {},
            "path": "32/assembly--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AssemblyReference32",
          "filepath": "assembly--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7 5.1H12.2V7.1H8.7z",
                  "transform": "rotate(-30.582 10.48 6.101)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H4V9.9c0-.7.4-1.4 1-1.7l1.5-.9 1 1.7L6 9.9V12zM4 14H6V18H4zM6.5 24.7L5 23.8c-.6-.4-1-1-1-1.7V20h2v2.1L7.5 23 6.5 24.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 24.1H11.5V27.6H9.5z",
                  "transform": "rotate(-59.421 10.48 25.9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8 24.9H23.3V26.9H19.8z",
                  "transform": "rotate(-30.582 21.502 25.912)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2 24.9l-1-1.7 1.8-1V20h2v2.1c0 .7-.4 1.4-1 1.7L25.2 24.9zM26 14H28V18H26zM28 12h-2V9.9l-1.8-1 1-1.7 1.8 1c.6.4 1 1 1 1.7V12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 4.3H22.5V7.8H20.5z",
                  "transform": "rotate(-59.421 21.501 6.089)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z"
                }
              }
            ],
            "name": "assembly--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AssemblyReference24",
          "filepath": "assembly--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7 5.1H12.2V7.1H8.7z",
                  "transform": "rotate(-30.582 10.48 6.101)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H4V9.9c0-.7.4-1.4 1-1.7l1.5-.9 1 1.7L6 9.9V12zM4 14H6V18H4zM6.5 24.7L5 23.8c-.6-.4-1-1-1-1.7V20h2v2.1L7.5 23 6.5 24.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 24.1H11.5V27.6H9.5z",
                  "transform": "rotate(-59.421 10.48 25.9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8 24.9H23.3V26.9H19.8z",
                  "transform": "rotate(-30.582 21.502 25.912)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2 24.9l-1-1.7 1.8-1V20h2v2.1c0 .7-.4 1.4-1 1.7L25.2 24.9zM26 14H28V18H26zM28 12h-2V9.9l-1.8-1 1-1.7 1.8 1c.6.4 1 1 1 1.7V12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 4.3H22.5V7.8H20.5z",
                  "transform": "rotate(-59.421 21.501 6.089)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z"
                }
              }
            ],
            "name": "assembly--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AssemblyReference20",
          "filepath": "assembly--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7 5.1H12.2V7.1H8.7z",
                  "transform": "rotate(-30.582 10.48 6.101)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H4V9.9c0-.7.4-1.4 1-1.7l1.5-.9 1 1.7L6 9.9V12zM4 14H6V18H4zM6.5 24.7L5 23.8c-.6-.4-1-1-1-1.7V20h2v2.1L7.5 23 6.5 24.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 24.1H11.5V27.6H9.5z",
                  "transform": "rotate(-59.421 10.48 25.9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8 24.9H23.3V26.9H19.8z",
                  "transform": "rotate(-30.582 21.502 25.912)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2 24.9l-1-1.7 1.8-1V20h2v2.1c0 .7-.4 1.4-1 1.7L25.2 24.9zM26 14H28V18H26zM28 12h-2V9.9l-1.8-1 1-1.7 1.8 1c.6.4 1 1 1 1.7V12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 4.3H22.5V7.8H20.5z",
                  "transform": "rotate(-59.421 21.501 6.089)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z"
                }
              }
            ],
            "name": "assembly--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AssemblyReference16",
          "filepath": "assembly--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7 5.1H12.2V7.1H8.7z",
                  "transform": "rotate(-30.582 10.48 6.101)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H4V9.9c0-.7.4-1.4 1-1.7l1.5-.9 1 1.7L6 9.9V12zM4 14H6V18H4zM6.5 24.7L5 23.8c-.6-.4-1-1-1-1.7V20h2v2.1L7.5 23 6.5 24.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 24.1H11.5V27.6H9.5z",
                  "transform": "rotate(-59.421 10.48 25.9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8 24.9H23.3V26.9H19.8z",
                  "transform": "rotate(-30.582 21.502 25.912)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2 24.9l-1-1.7 1.8-1V20h2v2.1c0 .7-.4 1.4-1 1.7L25.2 24.9zM26 14H28V18H26zM28 12h-2V9.9l-1.8-1 1-1.7 1.8 1c.6.4 1 1 1 1.7V12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 4.3H22.5V7.8H20.5z",
                  "transform": "rotate(-59.421 21.501 6.089)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z"
                }
              }
            ],
            "name": "assembly--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "AssemblyReference",
        "global": "AssemblyReference",
        "filepath": "AssemblyReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.7 5.1H12.2V7.1H8.7z",
                    "transform": "rotate(-30.582 10.48 6.101)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 12H4V9.9c0-.7.4-1.4 1-1.7l1.5-.9 1 1.7L6 9.9V12zM4 14H6V18H4zM6.5 24.7L5 23.8c-.6-.4-1-1-1-1.7V20h2v2.1L7.5 23 6.5 24.7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.5 24.1H11.5V27.6H9.5z",
                    "transform": "rotate(-59.421 10.48 25.9)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.8 24.9H23.3V26.9H19.8z",
                    "transform": "rotate(-30.582 21.502 25.912)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.2 24.9l-1-1.7 1.8-1V20h2v2.1c0 .7-.4 1.4-1 1.7L25.2 24.9zM26 14H28V18H26zM28 12h-2V9.9l-1.8-1 1-1.7 1.8 1c.6.4 1 1 1 1.7V12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.5 4.3H22.5V7.8H20.5z",
                    "transform": "rotate(-59.421 21.501 6.089)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "asset",
      "friendlyName": "Asset",
      "aliases": [
        "runtime",
        "wheel",
        "tape",
        "roll",
        "technology",
        "benefit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/asset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z\"/>\n  <path d=\"M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z\"/><path d=\"M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z\"/></svg>",
            "info": {},
            "path": "32/asset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Asset32",
          "filepath": "asset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z"
                }
              }
            ],
            "name": "asset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Asset24",
          "filepath": "asset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z"
                }
              }
            ],
            "name": "asset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Asset20",
          "filepath": "asset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z"
                }
              }
            ],
            "name": "asset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Asset16",
          "filepath": "asset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z"
                }
              }
            ],
            "name": "asset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Asset",
        "global": "Asset",
        "filepath": "Asset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "asset--confirm",
      "friendlyName": "Asset confirm",
      "aliases": [
        "technology",
        "confirmation",
        "confirm",
        "asset"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/asset--confirm.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"21 27.18 18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18\"/>\n  <path d=\"M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z\"/>\n  <path d=\"M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18zM12 24a4 4 0 114-4A4.0042 4.0042 0 0112 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0012 18z\"/><path d=\"M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z\"/></svg>",
            "info": {},
            "path": "32/asset--confirm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AssetConfirm32",
          "filepath": "asset--confirm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18zM12 24a4 4 0 114-4A4.0042 4.0042 0 0112 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0012 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--confirm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AssetConfirm24",
          "filepath": "asset--confirm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18zM12 24a4 4 0 114-4A4.0042 4.0042 0 0112 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0012 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--confirm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AssetConfirm20",
          "filepath": "asset--confirm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18zM12 24a4 4 0 114-4A4.0042 4.0042 0 0112 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0012 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--confirm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AssetConfirm16",
          "filepath": "asset--confirm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18zM12 24a4 4 0 114-4A4.0042 4.0042 0 0112 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0012 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--confirm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "AssetConfirm",
        "global": "AssetConfirm",
        "filepath": "AssetConfirm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18zM12 24a4 4 0 114-4A4.0042 4.0042 0 0112 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0012 18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "asset--digital-twin",
      "friendlyName": "Asset digital twin",
      "aliases": [
        "technology",
        "twin",
        "digital",
        "asset"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/asset--digital-twin.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"25\" cy=\"7\" r=\"2\"/>\n  <path d=\"M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z\"/>\n  <circle cx=\"12\" cy=\"14\" r=\"1\"/>\n  <circle cx=\"17.9088\" cy=\"5.7046\" r=\"1\"/>\n  <circle cx=\"9.7875\" cy=\"9.9068\" r=\"1\"/>\n  <circle cx=\"12.4947\" cy=\"8.5061\" r=\"1\"/>\n  <circle cx=\"15.2014\" cy=\"7.1051\" r=\"1\"/>\n  <circle cx=\"4.6962\" cy=\"13.1871\" r=\"1\"/>\n  <circle cx=\"2.1327\" cy=\"21.631\" r=\"1\"/>\n  <circle cx=\"3.0787\" cy=\"24.5159\" r=\"1\"/>\n  <circle cx=\"4.8485\" cy=\"26.9824\" r=\"1\"/>\n  <circle cx=\"7.2722\" cy=\"28.8098\" r=\"1\"/>\n  <circle cx=\"2.0982\" cy=\"18.5962\" r=\"1\"/>\n  <circle cx=\"2.9794\" cy=\"15.691\" r=\"1\"/>\n  <circle cx=\"7.081\" cy=\"11.3081\" r=\"1\"/>\n  <circle cx=\"20.6162\" cy=\"4.3038\" r=\"1\"/>\n  <circle cx=\"23.3232\" cy=\"2.9027\" r=\"1\"/>\n  <circle cx=\"28.9882\" cy=\"8.8898\" r=\"1\"/>\n  <circle cx=\"27.5868\" cy=\"11.5963\" r=\"1\"/>\n  <circle cx=\"26.1856\" cy=\"14.3031\" r=\"1\"/>\n  <circle cx=\"24.7842\" cy=\"17.0101\" r=\"1\"/>\n  <circle cx=\"23.383\" cy=\"19.7166\" r=\"1\"/>\n  <circle cx=\"21.982\" cy=\"22.4239\" r=\"1\"/>\n  <circle cx=\"18.6365\" cy=\"27.4643\" r=\"1\"/>\n  <circle cx=\"16.0919\" cy=\"29.1215\" r=\"1\"/>\n  <circle cx=\"13.1661\" cy=\"29.9322\" r=\"1\"/>\n  <circle cx=\"10.1327\" cy=\"29.8249\" r=\"1\"/>\n  <circle cx=\"20.5715\" cy=\"25.125\" r=\"1\"/>\n  <circle cx=\"28.8927\" cy=\"3.2401\" r=\"1\"/>\n  <circle cx=\"26.1882\" cy=\"2.0041\" r=\"1\"/>\n  <circle cx=\"12\" cy=\"26\" r=\"1\"/>\n  <circle cx=\"6\" cy=\"20\" r=\"1\"/>\n  <circle cx=\"18\" cy=\"20\" r=\"1\"/>\n  <circle cx=\"6.8038\" cy=\"17\" r=\"1\"/>\n  <circle cx=\"17.1962\" cy=\"23\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"25.1962\" r=\"1\"/>\n  <circle cx=\"15\" cy=\"14.8038\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"14.8038\" r=\"1\"/>\n  <circle cx=\"15\" cy=\"25.1962\" r=\"1\"/>\n  <circle cx=\"6.8038\" cy=\"23\" r=\"1\"/>\n  <circle cx=\"17.1962\" cy=\"17\" r=\"1\"/>\n  <circle cx=\"30.0002\" cy=\"6.0256\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"25\" cy=\"7\" r=\"2\"/><path d=\"M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z\"/><circle cx=\"12\" cy=\"14\" r=\"1\"/><circle cx=\"17.909\" cy=\"5.705\" r=\"1\"/><circle cx=\"9.787\" cy=\"9.907\" r=\"1\"/><circle cx=\"12.495\" cy=\"8.506\" r=\"1\"/><circle cx=\"15.201\" cy=\"7.105\" r=\"1\"/><circle cx=\"4.696\" cy=\"13.187\" r=\"1\"/><circle cx=\"2.133\" cy=\"21.631\" r=\"1\"/><circle cx=\"3.079\" cy=\"24.516\" r=\"1\"/><circle cx=\"4.848\" cy=\"26.982\" r=\"1\"/><circle cx=\"7.272\" cy=\"28.81\" r=\"1\"/><circle cx=\"2.098\" cy=\"18.596\" r=\"1\"/><circle cx=\"2.979\" cy=\"15.691\" r=\"1\"/><circle cx=\"7.081\" cy=\"11.308\" r=\"1\"/><circle cx=\"20.616\" cy=\"4.304\" r=\"1\"/><circle cx=\"23.323\" cy=\"2.903\" r=\"1\"/><circle cx=\"28.988\" cy=\"8.89\" r=\"1\"/><circle cx=\"27.587\" cy=\"11.596\" r=\"1\"/><circle cx=\"26.186\" cy=\"14.303\" r=\"1\"/><circle cx=\"24.784\" cy=\"17.01\" r=\"1\"/><circle cx=\"23.383\" cy=\"19.717\" r=\"1\"/><circle cx=\"21.982\" cy=\"22.424\" r=\"1\"/><circle cx=\"18.637\" cy=\"27.464\" r=\"1\"/><circle cx=\"16.092\" cy=\"29.122\" r=\"1\"/><circle cx=\"13.166\" cy=\"29.932\" r=\"1\"/><circle cx=\"10.133\" cy=\"29.825\" r=\"1\"/><circle cx=\"20.572\" cy=\"25.125\" r=\"1\"/><circle cx=\"28.893\" cy=\"3.24\" r=\"1\"/><circle cx=\"26.188\" cy=\"2.004\" r=\"1\"/><circle cx=\"12\" cy=\"26\" r=\"1\"/><circle cx=\"6\" cy=\"20\" r=\"1\"/><circle cx=\"18\" cy=\"20\" r=\"1\"/><circle cx=\"6.804\" cy=\"17\" r=\"1\"/><circle cx=\"17.196\" cy=\"23\" r=\"1\"/><circle cx=\"9\" cy=\"25.196\" r=\"1\"/><circle cx=\"15\" cy=\"14.804\" r=\"1\"/><circle cx=\"9\" cy=\"14.804\" r=\"1\"/><circle cx=\"15\" cy=\"25.196\" r=\"1\"/><circle cx=\"6.804\" cy=\"23\" r=\"1\"/><circle cx=\"17.196\" cy=\"17\" r=\"1\"/><circle cx=\"30\" cy=\"6.026\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/asset--digital-twin.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AssetDigitalTwin32",
          "filepath": "asset--digital-twin/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.909",
                  "cy": "5.705",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.787",
                  "cy": "9.907",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12.495",
                  "cy": "8.506",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.201",
                  "cy": "7.105",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.696",
                  "cy": "13.187",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.133",
                  "cy": "21.631",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3.079",
                  "cy": "24.516",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.848",
                  "cy": "26.982",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.272",
                  "cy": "28.81",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.098",
                  "cy": "18.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.979",
                  "cy": "15.691",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.081",
                  "cy": "11.308",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.616",
                  "cy": "4.304",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.323",
                  "cy": "2.903",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.988",
                  "cy": "8.89",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27.587",
                  "cy": "11.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.186",
                  "cy": "14.303",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.784",
                  "cy": "17.01",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.383",
                  "cy": "19.717",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.982",
                  "cy": "22.424",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.637",
                  "cy": "27.464",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.092",
                  "cy": "29.122",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.166",
                  "cy": "29.932",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.133",
                  "cy": "29.825",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.572",
                  "cy": "25.125",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.893",
                  "cy": "3.24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.188",
                  "cy": "2.004",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "30",
                  "cy": "6.026",
                  "r": "1"
                }
              }
            ],
            "name": "asset--digital-twin",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AssetDigitalTwin24",
          "filepath": "asset--digital-twin/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.909",
                  "cy": "5.705",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.787",
                  "cy": "9.907",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12.495",
                  "cy": "8.506",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.201",
                  "cy": "7.105",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.696",
                  "cy": "13.187",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.133",
                  "cy": "21.631",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3.079",
                  "cy": "24.516",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.848",
                  "cy": "26.982",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.272",
                  "cy": "28.81",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.098",
                  "cy": "18.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.979",
                  "cy": "15.691",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.081",
                  "cy": "11.308",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.616",
                  "cy": "4.304",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.323",
                  "cy": "2.903",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.988",
                  "cy": "8.89",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27.587",
                  "cy": "11.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.186",
                  "cy": "14.303",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.784",
                  "cy": "17.01",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.383",
                  "cy": "19.717",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.982",
                  "cy": "22.424",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.637",
                  "cy": "27.464",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.092",
                  "cy": "29.122",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.166",
                  "cy": "29.932",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.133",
                  "cy": "29.825",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.572",
                  "cy": "25.125",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.893",
                  "cy": "3.24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.188",
                  "cy": "2.004",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "30",
                  "cy": "6.026",
                  "r": "1"
                }
              }
            ],
            "name": "asset--digital-twin",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AssetDigitalTwin20",
          "filepath": "asset--digital-twin/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.909",
                  "cy": "5.705",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.787",
                  "cy": "9.907",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12.495",
                  "cy": "8.506",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.201",
                  "cy": "7.105",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.696",
                  "cy": "13.187",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.133",
                  "cy": "21.631",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3.079",
                  "cy": "24.516",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.848",
                  "cy": "26.982",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.272",
                  "cy": "28.81",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.098",
                  "cy": "18.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.979",
                  "cy": "15.691",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.081",
                  "cy": "11.308",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.616",
                  "cy": "4.304",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.323",
                  "cy": "2.903",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.988",
                  "cy": "8.89",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27.587",
                  "cy": "11.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.186",
                  "cy": "14.303",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.784",
                  "cy": "17.01",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.383",
                  "cy": "19.717",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.982",
                  "cy": "22.424",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.637",
                  "cy": "27.464",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.092",
                  "cy": "29.122",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.166",
                  "cy": "29.932",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.133",
                  "cy": "29.825",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.572",
                  "cy": "25.125",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.893",
                  "cy": "3.24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.188",
                  "cy": "2.004",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "30",
                  "cy": "6.026",
                  "r": "1"
                }
              }
            ],
            "name": "asset--digital-twin",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AssetDigitalTwin16",
          "filepath": "asset--digital-twin/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.909",
                  "cy": "5.705",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.787",
                  "cy": "9.907",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12.495",
                  "cy": "8.506",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.201",
                  "cy": "7.105",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.696",
                  "cy": "13.187",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.133",
                  "cy": "21.631",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3.079",
                  "cy": "24.516",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.848",
                  "cy": "26.982",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.272",
                  "cy": "28.81",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.098",
                  "cy": "18.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "2.979",
                  "cy": "15.691",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.081",
                  "cy": "11.308",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.616",
                  "cy": "4.304",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.323",
                  "cy": "2.903",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.988",
                  "cy": "8.89",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27.587",
                  "cy": "11.596",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.186",
                  "cy": "14.303",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.784",
                  "cy": "17.01",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.383",
                  "cy": "19.717",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.982",
                  "cy": "22.424",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.637",
                  "cy": "27.464",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.092",
                  "cy": "29.122",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.166",
                  "cy": "29.932",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.133",
                  "cy": "29.825",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.572",
                  "cy": "25.125",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.893",
                  "cy": "3.24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26.188",
                  "cy": "2.004",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "14.804",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25.196",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6.804",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.196",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "30",
                  "cy": "6.026",
                  "r": "1"
                }
              }
            ],
            "name": "asset--digital-twin",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "AssetDigitalTwin",
        "global": "AssetDigitalTwin",
        "filepath": "AssetDigitalTwin.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "7",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "12",
                    "cy": "14",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17.909",
                    "cy": "5.705",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9.787",
                    "cy": "9.907",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "12.495",
                    "cy": "8.506",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15.201",
                    "cy": "7.105",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4.696",
                    "cy": "13.187",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "2.133",
                    "cy": "21.631",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3.079",
                    "cy": "24.516",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4.848",
                    "cy": "26.982",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7.272",
                    "cy": "28.81",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "2.098",
                    "cy": "18.596",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "2.979",
                    "cy": "15.691",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7.081",
                    "cy": "11.308",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20.616",
                    "cy": "4.304",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23.323",
                    "cy": "2.903",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28.988",
                    "cy": "8.89",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "27.587",
                    "cy": "11.596",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26.186",
                    "cy": "14.303",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24.784",
                    "cy": "17.01",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23.383",
                    "cy": "19.717",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21.982",
                    "cy": "22.424",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18.637",
                    "cy": "27.464",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16.092",
                    "cy": "29.122",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13.166",
                    "cy": "29.932",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10.133",
                    "cy": "29.825",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20.572",
                    "cy": "25.125",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28.893",
                    "cy": "3.24",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26.188",
                    "cy": "2.004",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "12",
                    "cy": "26",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6.804",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17.196",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "25.196",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15",
                    "cy": "14.804",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "14.804",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15",
                    "cy": "25.196",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6.804",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17.196",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "30",
                    "cy": "6.026",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "asset--view",
      "friendlyName": "Asset view",
      "aliases": [
        "technology",
        "view",
        "asset"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/asset--view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"22\" cy=\"24\" r=\"2\"/>\n  <path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/>\n  <path d=\"M12,24a4,4,0,1,1,2.981-6.667l-1.49,1.334A2,2,0,1,0,12,22Z\"/>\n  <path d=\"M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22\" cy=\"24\" r=\"2\"/><path d=\"M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM12 24a4 4 0 112.981-6.667l-1.49 1.334A2 2 0 1012 22z\"/><path d=\"M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z\"/></svg>",
            "info": {},
            "path": "32/asset--view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AssetView32",
          "filepath": "asset--view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM12 24a4 4 0 112.981-6.667l-1.49 1.334A2 2 0 1012 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AssetView24",
          "filepath": "asset--view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM12 24a4 4 0 112.981-6.667l-1.49 1.334A2 2 0 1012 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AssetView20",
          "filepath": "asset--view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM12 24a4 4 0 112.981-6.667l-1.49 1.334A2 2 0 1012 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AssetView16",
          "filepath": "asset--view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM12 24a4 4 0 112.981-6.667l-1.49 1.334A2 2 0 1012 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                }
              }
            ],
            "name": "asset--view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "AssetView",
        "global": "AssetView",
        "filepath": "AssetView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM12 24a4 4 0 112.981-6.667l-1.49 1.334A2 2 0 1012 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "asterisk",
      "friendlyName": "Asterisk",
      "aliases": [
        "formatting",
        "star",
        "asterisk"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/asterisk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"28.316 13.949 27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z\"/></svg>",
            "info": {},
            "path": "32/asterisk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Asterisk32",
          "filepath": "asterisk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z"
                }
              }
            ],
            "name": "asterisk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Asterisk24",
          "filepath": "asterisk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z"
                }
              }
            ],
            "name": "asterisk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Asterisk20",
          "filepath": "asterisk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z"
                }
              }
            ],
            "name": "asterisk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Asterisk16",
          "filepath": "asterisk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z"
                }
              }
            ],
            "name": "asterisk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Asterisk",
        "global": "Asterisk",
        "filepath": "Asterisk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "at",
      "friendlyName": "At",
      "aliases": [
        "at",
        "\\@",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/at.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>at</title><path d=\"M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z\"/></svg>",
            "info": {},
            "path": "32/at.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "At32",
          "filepath": "at/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z"
                }
              }
            ],
            "name": "at",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "At24",
          "filepath": "at/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z"
                }
              }
            ],
            "name": "at",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "At20",
          "filepath": "at/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z"
                }
              }
            ],
            "name": "at",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "At16",
          "filepath": "at/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z"
                }
              }
            ],
            "name": "at",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "At",
        "global": "At",
        "filepath": "At.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "attachment",
      "friendlyName": "Attachment",
      "aliases": [
        "paper clip",
        "attach",
        "file",
        "affix",
        "add",
        "attachment",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/attachment.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>attachment</title>\n<path d=\"M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9\n\tC3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1\n\tc0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2\n\tc-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9\tC3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1\tc0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2\tc-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z\"/></svg>",
            "info": {},
            "path": "32/attachment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Attachment32",
          "filepath": "attachment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9\tC3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1\tc0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2\tc-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z"
                }
              }
            ],
            "name": "attachment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Attachment24",
          "filepath": "attachment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9\tC3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1\tc0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2\tc-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z"
                }
              }
            ],
            "name": "attachment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Attachment20",
          "filepath": "attachment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9\tC3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1\tc0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2\tc-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z"
                }
              }
            ],
            "name": "attachment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Attachment16",
          "filepath": "attachment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9\tC3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1\tc0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2\tc-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z"
                }
              }
            ],
            "name": "attachment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Attachment",
        "global": "Attachment",
        "filepath": "Attachment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9 C3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1 c0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2 c-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "audio-console",
      "friendlyName": "Audio console",
      "aliases": [
        "audio-console",
        "audio",
        "soundboard",
        "audio",
        "sound",
        "audio mixer",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/audio-console.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,14H27V2H25V14H24a2.0019,2.0019,0,0,0-2,2v2a2.0023,2.0023,0,0,0,2,2h1V30h2V20h1a2.0027,2.0027,0,0,0,2-2V16A2.0023,2.0023,0,0,0,28,14Zm0,4H24V16h4Z\" transform=\"translate(0 0.0049)\"/>\n  <path d=\"M18,6H17V2H15V6H14a2.0019,2.0019,0,0,0-2,2v2a2.0019,2.0019,0,0,0,2,2h1V30h2V12h1a2.002,2.002,0,0,0,2-2V8A2.002,2.002,0,0,0,18,6Zm0,4H14V8h4Z\" transform=\"translate(0 0.0049)\"/>\n  <path d=\"M8,20H7V2H5V20H4a2.0023,2.0023,0,0,0-2,2v2a2.0023,2.0023,0,0,0,2,2H5v4H7V26H8a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,8,20Zm0,4H4V22H8Z\" transform=\"translate(0 0.0049)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 14H27V2H25V14H24a2.0019 2.0019 0 00-2 2v2a2.0023 2.0023 0 002 2h1V30h2V20h1a2.0027 2.0027 0 002-2V16A2.0023 2.0023 0 0028 14zm0 4H24V16h4zM18 6H17V2H15V6H14a2.0019 2.0019 0 00-2 2v2a2.0019 2.0019 0 002 2h1V30h2V12h1a2.002 2.002 0 002-2V8A2.002 2.002 0 0018 6zm0 4H14V8h4zM8 20H7V2H5V20H4a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2H5v4H7V26H8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 008 20zm0 4H4V22H8z\" transform=\"translate(0 .005)\"/></svg>",
            "info": {},
            "path": "32/audio-console.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AudioConsole32",
          "filepath": "audio-console/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14H27V2H25V14H24a2.0019 2.0019 0 00-2 2v2a2.0023 2.0023 0 002 2h1V30h2V20h1a2.0027 2.0027 0 002-2V16A2.0023 2.0023 0 0028 14zm0 4H24V16h4zM18 6H17V2H15V6H14a2.0019 2.0019 0 00-2 2v2a2.0019 2.0019 0 002 2h1V30h2V12h1a2.002 2.002 0 002-2V8A2.002 2.002 0 0018 6zm0 4H14V8h4zM8 20H7V2H5V20H4a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2H5v4H7V26H8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 008 20zm0 4H4V22H8z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "audio-console",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AudioConsole24",
          "filepath": "audio-console/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14H27V2H25V14H24a2.0019 2.0019 0 00-2 2v2a2.0023 2.0023 0 002 2h1V30h2V20h1a2.0027 2.0027 0 002-2V16A2.0023 2.0023 0 0028 14zm0 4H24V16h4zM18 6H17V2H15V6H14a2.0019 2.0019 0 00-2 2v2a2.0019 2.0019 0 002 2h1V30h2V12h1a2.002 2.002 0 002-2V8A2.002 2.002 0 0018 6zm0 4H14V8h4zM8 20H7V2H5V20H4a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2H5v4H7V26H8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 008 20zm0 4H4V22H8z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "audio-console",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AudioConsole20",
          "filepath": "audio-console/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14H27V2H25V14H24a2.0019 2.0019 0 00-2 2v2a2.0023 2.0023 0 002 2h1V30h2V20h1a2.0027 2.0027 0 002-2V16A2.0023 2.0023 0 0028 14zm0 4H24V16h4zM18 6H17V2H15V6H14a2.0019 2.0019 0 00-2 2v2a2.0019 2.0019 0 002 2h1V30h2V12h1a2.002 2.002 0 002-2V8A2.002 2.002 0 0018 6zm0 4H14V8h4zM8 20H7V2H5V20H4a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2H5v4H7V26H8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 008 20zm0 4H4V22H8z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "audio-console",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AudioConsole16",
          "filepath": "audio-console/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14H27V2H25V14H24a2.0019 2.0019 0 00-2 2v2a2.0023 2.0023 0 002 2h1V30h2V20h1a2.0027 2.0027 0 002-2V16A2.0023 2.0023 0 0028 14zm0 4H24V16h4zM18 6H17V2H15V6H14a2.0019 2.0019 0 00-2 2v2a2.0019 2.0019 0 002 2h1V30h2V12h1a2.002 2.002 0 002-2V8A2.002 2.002 0 0018 6zm0 4H14V8h4zM8 20H7V2H5V20H4a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2H5v4H7V26H8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 008 20zm0 4H4V22H8z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "audio-console",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "AudioConsole",
        "global": "AudioConsole",
        "filepath": "AudioConsole.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 14H27V2H25V14H24a2.0019 2.0019 0 00-2 2v2a2.0023 2.0023 0 002 2h1V30h2V20h1a2.0027 2.0027 0 002-2V16A2.0023 2.0023 0 0028 14zm0 4H24V16h4zM18 6H17V2H15V6H14a2.0019 2.0019 0 00-2 2v2a2.0019 2.0019 0 002 2h1V30h2V12h1a2.002 2.002 0 002-2V8A2.002 2.002 0 0018 6zm0 4H14V8h4zM8 20H7V2H5V20H4a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2H5v4H7V26H8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 008 20zm0 4H4V22H8z",
                    "transform": "translate(0 .005)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "augmented-reality",
      "friendlyName": "Augmented reality",
      "aliases": [
        "augmented-reality",
        "technology",
        "computer enhancement",
        "AR",
        "enhanced reality",
        "interactive",
        "interactive experience",
        "image enhancement"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/augmented-reality.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>augmented-reality</title><path d=\"M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z\"/><circle cx=\"13.5\" cy=\"24.5\" r=\"1.5\"/><path d=\"M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z\"/><circle cx=\"13.5\" cy=\"24.5\" r=\"1.5\"/><path d=\"M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z\"/></svg>",
            "info": {},
            "path": "32/augmented-reality.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "AugmentedReality32",
          "filepath": "augmented-reality/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "augmented-reality",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "AugmentedReality24",
          "filepath": "augmented-reality/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "augmented-reality",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "AugmentedReality20",
          "filepath": "augmented-reality/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "augmented-reality",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "AugmentedReality16",
          "filepath": "augmented-reality/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "augmented-reality",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "AugmentedReality",
        "global": "AugmentedReality",
        "filepath": "AugmentedReality.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13.5",
                    "cy": "24.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "auto-scroll",
      "friendlyName": "Auto scroll",
      "aliases": [
        "scrolling",
        "slide",
        "control",
        "auto scroll",
        "highlighting",
        "virtual screen movement",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/auto-scroll.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>auto-scroll</title><path d=\"M12,16a4,4,0,1,0,4-4A4,4,0,0,0,12,16Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,18,16Z\"/><polygon points=\"16 27.17 10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17\"/><polygon points=\"16 4.83 21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 16a4 4 0 104-4A4 4 0 0012 16zm6 0a2 2 0 11-2-2A2 2 0 0118 16zM16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17zM16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z\"/></svg>",
            "info": {},
            "path": "32/watson-health/auto-scroll.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthAutoScroll32",
          "filepath": "watson-health/auto-scroll/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 16a4 4 0 104-4A4 4 0 0012 16zm6 0a2 2 0 11-2-2A2 2 0 0118 16zM16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17zM16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z"
                }
              }
            ],
            "name": "auto-scroll",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthAutoScroll24",
          "filepath": "watson-health/auto-scroll/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 16a4 4 0 104-4A4 4 0 0012 16zm6 0a2 2 0 11-2-2A2 2 0 0118 16zM16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17zM16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z"
                }
              }
            ],
            "name": "auto-scroll",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthAutoScroll20",
          "filepath": "watson-health/auto-scroll/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 16a4 4 0 104-4A4 4 0 0012 16zm6 0a2 2 0 11-2-2A2 2 0 0118 16zM16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17zM16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z"
                }
              }
            ],
            "name": "auto-scroll",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthAutoScroll16",
          "filepath": "watson-health/auto-scroll/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 16a4 4 0 104-4A4 4 0 0012 16zm6 0a2 2 0 11-2-2A2 2 0 0118 16zM16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17zM16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z"
                }
              }
            ],
            "name": "auto-scroll",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "AutoScroll",
        "global": "WatsonHealthAutoScroll",
        "filepath": "watson-health/AutoScroll.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 16a4 4 0 104-4A4 4 0 0012 16zm6 0a2 2 0 11-2-2A2 2 0 0118 16zM16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17zM16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "automatic",
      "friendlyName": "automatic",
      "aliases": [
        "auto",
        "automatic"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/automatic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,16H22a2.002,2.002,0,0,0-2,2V30h2V25h4v5h2V18A2.002,2.002,0,0,0,26,16Zm-4,7V18h4v5Z\"/>\n  <path d=\"M16,27a10.9862,10.9862,0,0,1-9.2156-5H12V20H4v8H6V24.3149A13.0239,13.0239,0,0,0,16,29Z\"/>\n  <path d=\"M20,10h5.2155A10.9973,10.9973,0,0,0,5,16H3A13.0048,13.0048,0,0,1,26,7.6849V4h2v8H20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 16H22a2.002 2.002 0 00-2 2V30h2V25h4v5h2V18A2.002 2.002 0 0026 16zm-4 7V18h4v5zM16 27a10.9862 10.9862 0 01-9.2156-5H12V20H4v8H6V24.3149A13.0239 13.0239 0 0016 29zM20 10h5.2155A10.9973 10.9973 0 005 16H3A13.0048 13.0048 0 0126 7.6849V4h2v8H20z\"/></svg>",
            "info": {},
            "path": "32/automatic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Automatic32",
          "filepath": "automatic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16H22a2.002 2.002 0 00-2 2V30h2V25h4v5h2V18A2.002 2.002 0 0026 16zm-4 7V18h4v5zM16 27a10.9862 10.9862 0 01-9.2156-5H12V20H4v8H6V24.3149A13.0239 13.0239 0 0016 29zM20 10h5.2155A10.9973 10.9973 0 005 16H3A13.0048 13.0048 0 0126 7.6849V4h2v8H20z"
                }
              }
            ],
            "name": "automatic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Automatic24",
          "filepath": "automatic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16H22a2.002 2.002 0 00-2 2V30h2V25h4v5h2V18A2.002 2.002 0 0026 16zm-4 7V18h4v5zM16 27a10.9862 10.9862 0 01-9.2156-5H12V20H4v8H6V24.3149A13.0239 13.0239 0 0016 29zM20 10h5.2155A10.9973 10.9973 0 005 16H3A13.0048 13.0048 0 0126 7.6849V4h2v8H20z"
                }
              }
            ],
            "name": "automatic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Automatic20",
          "filepath": "automatic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16H22a2.002 2.002 0 00-2 2V30h2V25h4v5h2V18A2.002 2.002 0 0026 16zm-4 7V18h4v5zM16 27a10.9862 10.9862 0 01-9.2156-5H12V20H4v8H6V24.3149A13.0239 13.0239 0 0016 29zM20 10h5.2155A10.9973 10.9973 0 005 16H3A13.0048 13.0048 0 0126 7.6849V4h2v8H20z"
                }
              }
            ],
            "name": "automatic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Automatic16",
          "filepath": "automatic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16H22a2.002 2.002 0 00-2 2V30h2V25h4v5h2V18A2.002 2.002 0 0026 16zm-4 7V18h4v5zM16 27a10.9862 10.9862 0 01-9.2156-5H12V20H4v8H6V24.3149A13.0239 13.0239 0 0016 29zM20 10h5.2155A10.9973 10.9973 0 005 16H3A13.0048 13.0048 0 0126 7.6849V4h2v8H20z"
                }
              }
            ],
            "name": "automatic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Automatic",
        "global": "Automatic",
        "filepath": "Automatic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 16H22a2.002 2.002 0 00-2 2V30h2V25h4v5h2V18A2.002 2.002 0 0026 16zm-4 7V18h4v5zM16 27a10.9862 10.9862 0 01-9.2156-5H12V20H4v8H6V24.3149A13.0239 13.0239 0 0016 29zM20 10h5.2155A10.9973 10.9973 0 005 16H3A13.0048 13.0048 0 0126 7.6849V4h2v8H20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "autoscaling",
      "friendlyName": "IBM Cloud® autoscaling",
      "aliases": [
        "auto scaling",
        "increase",
        "decrease",
        "compute",
        "networking",
        "memory",
        "resources",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/autoscaling.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"10 14 10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z\"/><path d=\"M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z\"/><path d=\"M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z\"/></svg>",
            "info": {},
            "path": "32/autoscaling.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Autoscaling32",
          "filepath": "autoscaling/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z"
                }
              }
            ],
            "name": "autoscaling",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Autoscaling24",
          "filepath": "autoscaling/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z"
                }
              }
            ],
            "name": "autoscaling",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Autoscaling20",
          "filepath": "autoscaling/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z"
                }
              }
            ],
            "name": "autoscaling",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Autoscaling16",
          "filepath": "autoscaling/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z"
                }
              }
            ],
            "name": "autoscaling",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "Autoscaling",
        "global": "Autoscaling",
        "filepath": "Autoscaling.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "awake",
      "friendlyName": "Awake",
      "aliases": [
        "sun",
        "active",
        "day",
        "bright",
        "toggle",
        "activate",
        "brightness",
        "computer screen",
        "active screen",
        "active computer screen"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/awake.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>light</title>\n<rect x=\"7.5\" y=\"1\" width=\"1\" height=\"2.5\"/>\n<rect x=\"10.8\" y=\"3.4\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 0.763 9.6862)\" width=\"2.5\" height=\"1\"/>\n<rect x=\"12.5\" y=\"7.5\" width=\"2.5\" height=\"1\"/>\n<rect x=\"11.6\" y=\"10.8\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -5.0012 12.0762)\" width=\"1\" height=\"2.5\"/>\n<rect x=\"7.5\" y=\"12.5\" width=\"1\" height=\"2.5\"/>\n<rect x=\"2.7\" y=\"11.6\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -7.3897 6.3156)\" width=\"2.5\" height=\"1\"/>\n<rect x=\"1\" y=\"7.5\" width=\"2.5\" height=\"1\"/>\n<rect x=\"3.4\" y=\"2.7\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -1.6256 3.9256)\" width=\"1\" height=\"2.5\"/>\n<path d=\"M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M7.5 1H8.5V3.5H7.5z\"/><path d=\"M10.8 3.4H13.3V4.4H10.8z\" transform=\"rotate(-45.001 12.074 3.922)\"/><path d=\"M12.5 7.5H15V8.5H12.5z\"/><path d=\"M11.6 10.8H12.6V13.3H11.6z\" transform=\"rotate(-45.001 12.077 12.075)\"/><path d=\"M7.5 12.5H8.5V15H7.5z\"/><path d=\"M2.7 11.6H5.2V12.6H2.7z\" transform=\"rotate(-45.001 3.929 12.078)\"/><path d=\"M1 7.5H3.5V8.5H1z\"/><path d=\"M3.4 2.7H4.4V5.2H3.4z\" transform=\"rotate(-45.001 3.926 3.925)\"/><path d=\"M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z\"/></svg>",
            "info": {},
            "path": "16/awake.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/awake.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>light</title><rect x=\"15\" y=\"2\" width=\"2\" height=\"4.96\"/><rect x=\"21.67\" y=\"6.85\" width=\"4.96\" height=\"2\" transform=\"translate(1.52 19.37) rotate(-45)\"/><rect x=\"25.04\" y=\"15\" width=\"4.96\" height=\"2\"/><rect x=\"23.15\" y=\"21.67\" width=\"2\" height=\"4.96\" transform=\"translate(-10 24.15) rotate(-45)\"/><rect x=\"15\" y=\"25.04\" width=\"2\" height=\"4.96\"/><rect x=\"5.37\" y=\"23.15\" width=\"4.96\" height=\"2\" transform=\"translate(-14.77 12.63) rotate(-45)\"/><rect x=\"2\" y=\"15\" width=\"4.96\" height=\"2\"/><rect x=\"6.85\" y=\"5.37\" width=\"2\" height=\"4.96\" transform=\"translate(-3.25 7.85) rotate(-45)\"/><path d=\"M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 2H17V6.96H15z\"/><path d=\"M21.67 6.85H26.630000000000003V8.85H21.67z\" transform=\"rotate(-45 24.142 7.85)\"/><path d=\"M25.04 15H30V17H25.04z\"/><path d=\"M23.15 21.67H25.15V26.630000000000003H23.15z\" transform=\"rotate(-45 24.152 24.146)\"/><path d=\"M15 25.04H17V30H15z\"/><path d=\"M5.37 23.15H10.33V25.15H5.37z\" transform=\"rotate(-45 7.86 24.144)\"/><path d=\"M2 15H6.96V17H2z\"/><path d=\"M6.85 5.37H8.85V10.33H6.85z\" transform=\"rotate(-45 7.85 7.848)\"/><path d=\"M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/></svg>",
            "info": {},
            "path": "32/awake.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Awake32",
          "filepath": "awake/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V6.96H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.67 6.85H26.630000000000003V8.85H21.67z",
                  "transform": "rotate(-45 24.142 7.85)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.04 15H30V17H25.04z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.15 21.67H25.15V26.630000000000003H23.15z",
                  "transform": "rotate(-45 24.152 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25.04H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.37 23.15H10.33V25.15H5.37z",
                  "transform": "rotate(-45 7.86 24.144)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H6.96V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.85 5.37H8.85V10.33H6.85z",
                  "transform": "rotate(-45 7.85 7.848)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "awake",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Awake24",
          "filepath": "awake/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V6.96H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.67 6.85H26.630000000000003V8.85H21.67z",
                  "transform": "rotate(-45 24.142 7.85)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.04 15H30V17H25.04z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.15 21.67H25.15V26.630000000000003H23.15z",
                  "transform": "rotate(-45 24.152 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25.04H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.37 23.15H10.33V25.15H5.37z",
                  "transform": "rotate(-45 7.86 24.144)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H6.96V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.85 5.37H8.85V10.33H6.85z",
                  "transform": "rotate(-45 7.85 7.848)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "awake",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Awake20",
          "filepath": "awake/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V6.96H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.67 6.85H26.630000000000003V8.85H21.67z",
                  "transform": "rotate(-45 24.142 7.85)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.04 15H30V17H25.04z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.15 21.67H25.15V26.630000000000003H23.15z",
                  "transform": "rotate(-45 24.152 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25.04H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.37 23.15H10.33V25.15H5.37z",
                  "transform": "rotate(-45 7.86 24.144)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H6.96V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.85 5.37H8.85V10.33H6.85z",
                  "transform": "rotate(-45 7.85 7.848)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "awake",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Awake16",
          "filepath": "awake/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 1H8.5V3.5H7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8 3.4H13.3V4.4H10.8z",
                  "transform": "rotate(-45.001 12.074 3.922)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.5 7.5H15V8.5H12.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.6 10.8H12.6V13.3H11.6z",
                  "transform": "rotate(-45.001 12.077 12.075)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 12.5H8.5V15H7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.7 11.6H5.2V12.6H2.7z",
                  "transform": "rotate(-45.001 3.929 12.078)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 7.5H3.5V8.5H1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.4 2.7H4.4V5.2H3.4z",
                  "transform": "rotate(-45.001 3.926 3.925)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
                }
              }
            ],
            "name": "awake",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Awake",
        "global": "Awake",
        "filepath": "Awake.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 1H8.5V3.5H7.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.8 3.4H13.3V4.4H10.8z",
                    "transform": "rotate(-45.001 12.074 3.922)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.5 7.5H15V8.5H12.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.6 10.8H12.6V13.3H11.6z",
                    "transform": "rotate(-45.001 12.077 12.075)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 12.5H8.5V15H7.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.7 11.6H5.2V12.6H2.7z",
                    "transform": "rotate(-45.001 3.929 12.078)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M1 7.5H3.5V8.5H1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.4 2.7H4.4V5.2H3.4z",
                    "transform": "rotate(-45.001 3.926 3.925)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V6.96H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.67 6.85H26.630000000000003V8.85H21.67z",
                    "transform": "rotate(-45 24.142 7.85)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.04 15H30V17H25.04z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.15 21.67H25.15V26.630000000000003H23.15z",
                    "transform": "rotate(-45 24.152 24.146)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 25.04H17V30H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.37 23.15H10.33V25.15H5.37z",
                    "transform": "rotate(-45 7.86 24.144)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 15H6.96V17H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.85 5.37H8.85V10.33H6.85z",
                    "transform": "rotate(-45 7.85 7.848)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "badge",
      "friendlyName": "Badge",
      "aliases": [
        "badge",
        "ID",
        "identification",
        "user",
        "file",
        "award",
        "ribbon",
        "recognition"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/badge.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>badge</title><polygon points=\"23 2 24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2\"/><path d=\"M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z\"/><path d=\"M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z\"/></svg>",
            "info": {},
            "path": "32/badge.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Badge32",
          "filepath": "badge/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z"
                }
              }
            ],
            "name": "badge",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Badge24",
          "filepath": "badge/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z"
                }
              }
            ],
            "name": "badge",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Badge20",
          "filepath": "badge/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z"
                }
              }
            ],
            "name": "badge",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Badge16",
          "filepath": "badge/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z"
                }
              }
            ],
            "name": "badge",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Badge",
        "global": "Badge",
        "filepath": "Badge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "baggage-claim",
      "friendlyName": "Baggage claim",
      "aliases": [
        "baggage",
        "claim",
        "suitcase",
        "travel",
        "airport"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/baggage-claim.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"6\" cy=\"26\" r=\"2\"/>\n  <path d=\"M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"6\" cy=\"26\" r=\"2\"/><path d=\"M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z\"/><path d=\"M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z\"/></svg>",
            "info": {},
            "path": "32/baggage-claim.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BaggageClaim32",
          "filepath": "baggage-claim/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z"
                }
              }
            ],
            "name": "baggage-claim",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BaggageClaim24",
          "filepath": "baggage-claim/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z"
                }
              }
            ],
            "name": "baggage-claim",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BaggageClaim20",
          "filepath": "baggage-claim/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z"
                }
              }
            ],
            "name": "baggage-claim",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BaggageClaim16",
          "filepath": "baggage-claim/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z"
                }
              }
            ],
            "name": "baggage-claim",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "BaggageClaim",
        "global": "BaggageClaim",
        "filepath": "BaggageClaim.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "26",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bar",
      "friendlyName": "Bar",
      "aliases": [
        "drink",
        "alcohol",
        "cocktail",
        "wine",
        "travel",
        "bottle",
        "glass",
        "wine bottle",
        "wine glass"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bar.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bar</title><path d=\"M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z\" transform=\"translate(0 0)\"/><path d=\"M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z\"/><path d=\"M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z\"/></svg>",
            "info": {},
            "path": "32/bar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bar32",
          "filepath": "bar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z"
                }
              }
            ],
            "name": "bar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bar24",
          "filepath": "bar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z"
                }
              }
            ],
            "name": "bar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bar20",
          "filepath": "bar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z"
                }
              }
            ],
            "name": "bar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bar16",
          "filepath": "bar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z"
                }
              }
            ],
            "name": "bar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Bar",
        "global": "Bar",
        "filepath": "Bar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "barcode",
      "friendlyName": "Barcode",
      "aliases": [
        "barcode",
        "technology",
        "tracking",
        "UPC",
        "inventory",
        "item"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/barcode.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"6\" width=\"2\" height=\"22\"/>\n  <rect x=\"12\" y=\"6\" width=\"2\" height=\"20\"/>\n  <rect x=\"6\" y=\"6\" width=\"4\" height=\"20\"/>\n  <rect x=\"16\" y=\"6\" width=\"4\" height=\"20\"/>\n  <rect x=\"22\" y=\"6\" width=\"4\" height=\"20\"/>\n  <rect x=\"28\" y=\"6\" width=\"2\" height=\"22\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 6H4V28H2zM12 6H14V26H12zM6 6H10V26H6zM16 6H20V26H16zM22 6H26V26H22zM28 6H30V28H28z\"/></svg>",
            "info": {},
            "path": "32/barcode.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Barcode32",
          "filepath": "barcode/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H4V28H2zM12 6H14V26H12zM6 6H10V26H6zM16 6H20V26H16zM22 6H26V26H22zM28 6H30V28H28z"
                }
              }
            ],
            "name": "barcode",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Barcode24",
          "filepath": "barcode/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H4V28H2zM12 6H14V26H12zM6 6H10V26H6zM16 6H20V26H16zM22 6H26V26H22zM28 6H30V28H28z"
                }
              }
            ],
            "name": "barcode",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Barcode20",
          "filepath": "barcode/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H4V28H2zM12 6H14V26H12zM6 6H10V26H6zM16 6H20V26H16zM22 6H26V26H22zM28 6H30V28H28z"
                }
              }
            ],
            "name": "barcode",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Barcode16",
          "filepath": "barcode/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H4V28H2zM12 6H14V26H12zM6 6H10V26H6zM16 6H20V26H16zM22 6H26V26H22zM28 6H30V28H28z"
                }
              }
            ],
            "name": "barcode",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Barcode",
        "global": "Barcode",
        "filepath": "Barcode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 6H4V28H2zM12 6H14V26H12zM6 6H10V26H6zM16 6H20V26H16zM22 6H26V26H22zM28 6H30V28H28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bare-metal-server",
      "friendlyName": "Bare metal server",
      "aliases": [
        "systems",
        "bare metal",
        "server"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bare-metal-server.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"9\" cy=\"6\" r=\"1\"/>\n  <path d=\"M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"9\" cy=\"16\" r=\"1\"/>\n  <path d=\"M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"9\" cy=\"26\" r=\"1\"/>\n  <path d=\"M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"6\" r=\"1\"/><path d=\"M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z\"/><circle cx=\"9\" cy=\"16\" r=\"1\"/><path d=\"M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z\"/><circle cx=\"9\" cy=\"26\" r=\"1\"/><path d=\"M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z\"/></svg>",
            "info": {},
            "path": "32/bare-metal-server.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BareMetalServer32",
          "filepath": "bare-metal-server/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z"
                }
              }
            ],
            "name": "bare-metal-server",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BareMetalServer24",
          "filepath": "bare-metal-server/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z"
                }
              }
            ],
            "name": "bare-metal-server",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BareMetalServer20",
          "filepath": "bare-metal-server/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z"
                }
              }
            ],
            "name": "bare-metal-server",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BareMetalServer16",
          "filepath": "bare-metal-server/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z"
                }
              }
            ],
            "name": "bare-metal-server",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BareMetalServer",
        "global": "BareMetalServer",
        "filepath": "BareMetalServer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "6",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "26",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bare-metal-server--01",
      "friendlyName": "Bare metal server 01",
      "aliases": [
        "systems",
        "bare metal",
        "server"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bare-metal-server--01.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17 28 17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28\"/>\n  <circle cx=\"9\" cy=\"16\" r=\"1\"/>\n  <path d=\"M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z\"/><circle cx=\"9\" cy=\"16\" r=\"1\"/><path d=\"M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z\"/></svg>",
            "info": {},
            "path": "32/bare-metal-server--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BareMetalServer_0132",
          "filepath": "bare-metal-server--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              }
            ],
            "name": "bare-metal-server--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BareMetalServer_0124",
          "filepath": "bare-metal-server--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              }
            ],
            "name": "bare-metal-server--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BareMetalServer_0120",
          "filepath": "bare-metal-server--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              }
            ],
            "name": "bare-metal-server--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BareMetalServer_0116",
          "filepath": "bare-metal-server--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              }
            ],
            "name": "bare-metal-server--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BareMetalServer_01",
        "global": "BareMetalServer_01",
        "filepath": "BareMetalServer_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bare-metal-server--02",
      "friendlyName": "Bare metal server 02",
      "aliases": [
        "systems",
        "bare metal",
        "server"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bare-metal-server--02.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17 28 17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28\"/>\n  <circle cx=\"9\" cy=\"16\" r=\"1\"/>\n  <path d=\"M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z\"/>\n  <circle cx=\"9\" cy=\"6\" r=\"1\"/>\n  <path d=\"M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z\"/><circle cx=\"9\" cy=\"16\" r=\"1\"/><path d=\"M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z\"/><circle cx=\"9\" cy=\"6\" r=\"1\"/><path d=\"M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z\"/></svg>",
            "info": {},
            "path": "32/bare-metal-server--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BareMetalServer_0232",
          "filepath": "bare-metal-server--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              }
            ],
            "name": "bare-metal-server--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BareMetalServer_0224",
          "filepath": "bare-metal-server--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              }
            ],
            "name": "bare-metal-server--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BareMetalServer_0220",
          "filepath": "bare-metal-server--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              }
            ],
            "name": "bare-metal-server--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BareMetalServer_0216",
          "filepath": "bare-metal-server--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z"
                }
              }
            ],
            "name": "bare-metal-server--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BareMetalServer_02",
        "global": "BareMetalServer_02",
        "filepath": "BareMetalServer_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "6",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "barrier",
      "friendlyName": "Barrier",
      "aliases": [
        "wall",
        "fence",
        "block",
        "stop",
        "divide",
        "research",
        "dotted line"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/barrier.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>Q-research--barrier</title><rect class=\"cls-1\" x=\"15\" y=\"5\" width=\"2\" height=\"4\"/><rect class=\"cls-1\" x=\"15\" y=\"11\" width=\"2\" height=\"4\"/><rect class=\"cls-1\" x=\"15\" y=\"17\" width=\"2\" height=\"4\"/><rect class=\"cls-1\" x=\"15\" y=\"23\" width=\"2\" height=\"4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 5H17V9H15zM15 11H17V15H15zM15 17H17V21H15zM15 23H17V27H15z\"/></svg>",
            "info": {},
            "path": "32/Q/barrier.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QBarrier32",
          "filepath": "Q/barrier/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 5H17V9H15zM15 11H17V15H15zM15 17H17V21H15zM15 23H17V27H15z"
                }
              }
            ],
            "name": "barrier",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QBarrier24",
          "filepath": "Q/barrier/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 5H17V9H15zM15 11H17V15H15zM15 17H17V21H15zM15 23H17V27H15z"
                }
              }
            ],
            "name": "barrier",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QBarrier20",
          "filepath": "Q/barrier/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 5H17V9H15zM15 11H17V15H15zM15 17H17V21H15zM15 23H17V27H15z"
                }
              }
            ],
            "name": "barrier",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QBarrier16",
          "filepath": "Q/barrier/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 5H17V9H15zM15 11H17V15H15zM15 17H17V21H15zM15 23H17V27H15z"
                }
              }
            ],
            "name": "barrier",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "Barrier",
        "global": "QBarrier",
        "filepath": "Q/Barrier.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 5H17V9H15zM15 11H17V15H15zM15 17H17V21H15zM15 23H17V27H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "basketball",
      "friendlyName": "Basketball",
      "aliases": [
        "basketball",
        "commerce",
        "b-ball",
        "sport",
        "ball",
        "sports ball"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/basketball.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>basketball</title><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z\"/></svg>",
            "info": {},
            "path": "32/basketball.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Basketball32",
          "filepath": "basketball/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
                }
              }
            ],
            "name": "basketball",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Basketball24",
          "filepath": "basketball/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
                }
              }
            ],
            "name": "basketball",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Basketball20",
          "filepath": "basketball/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
                }
              }
            ],
            "name": "basketball",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Basketball16",
          "filepath": "basketball/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
                }
              }
            ],
            "name": "basketball",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Basketball",
        "global": "Basketball",
        "filepath": "Basketball.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bastion-host",
      "friendlyName": "Bastion-Host",
      "aliases": [
        "bastion",
        "host",
        "castle",
        "rook",
        "turret",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bastion-host.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z\"/></svg>",
            "info": {},
            "path": "32/bastion-host.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BastionHost32",
          "filepath": "bastion-host/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z"
                }
              }
            ],
            "name": "bastion-host",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BastionHost24",
          "filepath": "bastion-host/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z"
                }
              }
            ],
            "name": "bastion-host",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BastionHost20",
          "filepath": "bastion-host/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z"
                }
              }
            ],
            "name": "bastion-host",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BastionHost16",
          "filepath": "bastion-host/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z"
                }
              }
            ],
            "name": "bastion-host",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BastionHost",
        "global": "BastionHost",
        "filepath": "BastionHost.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bat",
      "friendlyName": "bat",
      "aliases": [
        "bat",
        "mammal",
        "animal"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bat.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z\"/></svg>",
            "info": {},
            "path": "32/bat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bat32",
          "filepath": "bat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z"
                }
              }
            ],
            "name": "bat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bat24",
          "filepath": "bat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z"
                }
              }
            ],
            "name": "bat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bat20",
          "filepath": "bat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z"
                }
              }
            ],
            "name": "bat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bat16",
          "filepath": "bat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z"
                }
              }
            ],
            "name": "bat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Bat",
        "global": "Bat",
        "filepath": "Bat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "batch-job",
      "friendlyName": "batch-job",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/batch-job.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M32,26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897,1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372,.1299-1.2285,.3843-1.7529,.7319l-1.4897-1.4897-1.4141,1.4141,1.4897,1.4897c-.3477,.5244-.6021,1.1157-.7319,1.7529h-2.1011v2h2.1011c.1299,.6372,.3843,1.2285,.7319,1.7529l-1.4897,1.4897,1.4141,1.4141,1.4897-1.4897c.5244,.3477,1.1157,.6021,1.7529,.7319v2.1011h2v-2.1011c.6372-.1299,1.2285-.3843,1.7529-.7319l1.4897,1.4897,1.4141-1.4141-1.4897-1.4897c.3477-.5244,.6021-1.1157,.7319-1.7529h2.1011Zm-7,2c-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3-1.3457,3-3,3Z\"/>\n  <path d=\"M20,17H12c-1.1046,0-2-.8954-2-2V4c0-1.1046,.8954-2,2-2h8c1.1046,0,2,.8954,2,2V15c0,1.1046-.8954,2-2,2Zm-8-2h8V4H12V15Z\"/>\n  <path d=\"M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z\"/>\n  <path d=\"M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897 1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141 1.4141 1.4897 1.4897c-.3477.5244-.6021 1.1157-.7319 1.7529h-2.1011v2h2.1011c.1299.6372.3843 1.2285.7319 1.7529l-1.4897 1.4897 1.4141 1.4141 1.4897-1.4897c.5244.3477 1.1157.6021 1.7529.7319v2.1011h2v-2.1011c.6372-.1299 1.2285-.3843 1.7529-.7319l1.4897 1.4897 1.4141-1.4141-1.4897-1.4897c.3477-.5244.6021-1.1157.7319-1.7529h2.1011zm-7 2c-1.6543 0-3-1.3457-3-3s1.3457-3 3-3 3 1.3457 3 3-1.3457 3-3 3zM20 17H12c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2V15c0 1.1046-.8954 2-2 2zm-8-2h8V4H12V15z\"/><path d=\"M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z\"/><path d=\"M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z\"/></svg>",
            "info": {},
            "path": "32/batch-job.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatchJob32",
          "filepath": "batch-job/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897 1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141 1.4141 1.4897 1.4897c-.3477.5244-.6021 1.1157-.7319 1.7529h-2.1011v2h2.1011c.1299.6372.3843 1.2285.7319 1.7529l-1.4897 1.4897 1.4141 1.4141 1.4897-1.4897c.5244.3477 1.1157.6021 1.7529.7319v2.1011h2v-2.1011c.6372-.1299 1.2285-.3843 1.7529-.7319l1.4897 1.4897 1.4141-1.4141-1.4897-1.4897c.3477-.5244.6021-1.1157.7319-1.7529h2.1011zm-7 2c-1.6543 0-3-1.3457-3-3s1.3457-3 3-3 3 1.3457 3 3-1.3457 3-3 3zM20 17H12c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2V15c0 1.1046-.8954 2-2 2zm-8-2h8V4H12V15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z"
                }
              }
            ],
            "name": "batch-job",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatchJob24",
          "filepath": "batch-job/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897 1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141 1.4141 1.4897 1.4897c-.3477.5244-.6021 1.1157-.7319 1.7529h-2.1011v2h2.1011c.1299.6372.3843 1.2285.7319 1.7529l-1.4897 1.4897 1.4141 1.4141 1.4897-1.4897c.5244.3477 1.1157.6021 1.7529.7319v2.1011h2v-2.1011c.6372-.1299 1.2285-.3843 1.7529-.7319l1.4897 1.4897 1.4141-1.4141-1.4897-1.4897c.3477-.5244.6021-1.1157.7319-1.7529h2.1011zm-7 2c-1.6543 0-3-1.3457-3-3s1.3457-3 3-3 3 1.3457 3 3-1.3457 3-3 3zM20 17H12c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2V15c0 1.1046-.8954 2-2 2zm-8-2h8V4H12V15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z"
                }
              }
            ],
            "name": "batch-job",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatchJob20",
          "filepath": "batch-job/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897 1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141 1.4141 1.4897 1.4897c-.3477.5244-.6021 1.1157-.7319 1.7529h-2.1011v2h2.1011c.1299.6372.3843 1.2285.7319 1.7529l-1.4897 1.4897 1.4141 1.4141 1.4897-1.4897c.5244.3477 1.1157.6021 1.7529.7319v2.1011h2v-2.1011c.6372-.1299 1.2285-.3843 1.7529-.7319l1.4897 1.4897 1.4141-1.4141-1.4897-1.4897c.3477-.5244.6021-1.1157.7319-1.7529h2.1011zm-7 2c-1.6543 0-3-1.3457-3-3s1.3457-3 3-3 3 1.3457 3 3-1.3457 3-3 3zM20 17H12c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2V15c0 1.1046-.8954 2-2 2zm-8-2h8V4H12V15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z"
                }
              }
            ],
            "name": "batch-job",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatchJob16",
          "filepath": "batch-job/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897 1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141 1.4141 1.4897 1.4897c-.3477.5244-.6021 1.1157-.7319 1.7529h-2.1011v2h2.1011c.1299.6372.3843 1.2285.7319 1.7529l-1.4897 1.4897 1.4141 1.4141 1.4897-1.4897c.5244.3477 1.1157.6021 1.7529.7319v2.1011h2v-2.1011c.6372-.1299 1.2285-.3843 1.7529-.7319l1.4897 1.4897 1.4141-1.4141-1.4897-1.4897c.3477-.5244.6021-1.1157.7319-1.7529h2.1011zm-7 2c-1.6543 0-3-1.3457-3-3s1.3457-3 3-3 3 1.3457 3 3-1.3457 3-3 3zM20 17H12c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2V15c0 1.1046-.8954 2-2 2zm-8-2h8V4H12V15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z"
                }
              }
            ],
            "name": "batch-job",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BatchJob",
        "global": "BatchJob",
        "filepath": "BatchJob.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897 1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141 1.4141 1.4897 1.4897c-.3477.5244-.6021 1.1157-.7319 1.7529h-2.1011v2h2.1011c.1299.6372.3843 1.2285.7319 1.7529l-1.4897 1.4897 1.4141 1.4141 1.4897-1.4897c.5244.3477 1.1157.6021 1.7529.7319v2.1011h2v-2.1011c.6372-.1299 1.2285-.3843 1.7529-.7319l1.4897 1.4897 1.4141-1.4141-1.4897-1.4897c.3477-.5244.6021-1.1157.7319-1.7529h2.1011zm-7 2c-1.6543 0-3-1.3457-3-3s1.3457-3 3-3 3 1.3457 3 3-1.3457 3-3 3zM20 17H12c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2V15c0 1.1046-.8954 2-2 2zm-8-2h8V4H12V15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "batch-job--step",
      "friendlyName": "batch-job--step",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/batch-job--step.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"24 20 24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20\"/>\n  <path d=\"M8,4h8v6c0,1.1025,.8972,2,2,2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028,0-2,.8975-2,2V28c0,1.1025,.8972,2,2,2h4v-2h-4V4Zm15.5857,6h-5.5857V4.4141l5.5857,5.5859Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20zM8 4h8v6c0 1.1025.8972 2 2 2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028 0-2 .8975-2 2V28c0 1.1025.8972 2 2 2h4v-2h-4V4zm15.5857 6h-5.5857V4.4141l5.5857 5.5859z\"/></svg>",
            "info": {},
            "path": "32/batch-job--step.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatchJobStep32",
          "filepath": "batch-job--step/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20zM8 4h8v6c0 1.1025.8972 2 2 2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028 0-2 .8975-2 2V28c0 1.1025.8972 2 2 2h4v-2h-4V4zm15.5857 6h-5.5857V4.4141l5.5857 5.5859z"
                }
              }
            ],
            "name": "batch-job--step",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatchJobStep24",
          "filepath": "batch-job--step/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20zM8 4h8v6c0 1.1025.8972 2 2 2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028 0-2 .8975-2 2V28c0 1.1025.8972 2 2 2h4v-2h-4V4zm15.5857 6h-5.5857V4.4141l5.5857 5.5859z"
                }
              }
            ],
            "name": "batch-job--step",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatchJobStep20",
          "filepath": "batch-job--step/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20zM8 4h8v6c0 1.1025.8972 2 2 2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028 0-2 .8975-2 2V28c0 1.1025.8972 2 2 2h4v-2h-4V4zm15.5857 6h-5.5857V4.4141l5.5857 5.5859z"
                }
              }
            ],
            "name": "batch-job--step",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatchJobStep16",
          "filepath": "batch-job--step/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20zM8 4h8v6c0 1.1025.8972 2 2 2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028 0-2 .8975-2 2V28c0 1.1025.8972 2 2 2h4v-2h-4V4zm15.5857 6h-5.5857V4.4141l5.5857 5.5859z"
                }
              }
            ],
            "name": "batch-job--step",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BatchJobStep",
        "global": "BatchJobStep",
        "filepath": "BatchJobStep.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20zM8 4h8v6c0 1.1025.8972 2 2 2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028 0-2 .8975-2 2V28c0 1.1025.8972 2 2 2h4v-2h-4V4zm15.5857 6h-5.5857V4.4141l5.5857 5.5859z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "battery--charging",
      "friendlyName": "Battery charging",
      "aliases": [
        "charging",
        "power",
        "battery charging",
        "charging battery",
        "battery",
        "battery indicator",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/battery--charging.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>battery--charging</title><path class=\"cls-1\" d=\"M27,11H26V10a2,2,0,0,0-2-2H20v2h4v3h3v6H24v3H19v2h5a2,2,0,0,0,2-2V21h1a2,2,0,0,0,2-2V13A2,2,0,0,0,27,11Z\"/><path class=\"cls-1\" d=\"M11,22H6V10h6V8H6a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h5Z\"/><polygon points=\"14.81 23.58 13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 11H26V10a2 2 0 00-2-2H20v2h4v3h3v6H24v3H19v2h5a2 2 0 002-2V21h1a2 2 0 002-2V13A2 2 0 0027 11zM11 22H6V10h6V8H6a2 2 0 00-2 2V22a2 2 0 002 2h5z\"/><path d=\"M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z\"/></svg>",
            "info": {},
            "path": "32/battery--charging.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatteryCharging32",
          "filepath": "battery--charging/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H26V10a2 2 0 00-2-2H20v2h4v3h3v6H24v3H19v2h5a2 2 0 002-2V21h1a2 2 0 002-2V13A2 2 0 0027 11zM11 22H6V10h6V8H6a2 2 0 00-2 2V22a2 2 0 002 2h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z"
                }
              }
            ],
            "name": "battery--charging",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatteryCharging24",
          "filepath": "battery--charging/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H26V10a2 2 0 00-2-2H20v2h4v3h3v6H24v3H19v2h5a2 2 0 002-2V21h1a2 2 0 002-2V13A2 2 0 0027 11zM11 22H6V10h6V8H6a2 2 0 00-2 2V22a2 2 0 002 2h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z"
                }
              }
            ],
            "name": "battery--charging",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatteryCharging20",
          "filepath": "battery--charging/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H26V10a2 2 0 00-2-2H20v2h4v3h3v6H24v3H19v2h5a2 2 0 002-2V21h1a2 2 0 002-2V13A2 2 0 0027 11zM11 22H6V10h6V8H6a2 2 0 00-2 2V22a2 2 0 002 2h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z"
                }
              }
            ],
            "name": "battery--charging",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatteryCharging16",
          "filepath": "battery--charging/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H26V10a2 2 0 00-2-2H20v2h4v3h3v6H24v3H19v2h5a2 2 0 002-2V21h1a2 2 0 002-2V13A2 2 0 0027 11zM11 22H6V10h6V8H6a2 2 0 00-2 2V22a2 2 0 002 2h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z"
                }
              }
            ],
            "name": "battery--charging",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BatteryCharging",
        "global": "BatteryCharging",
        "filepath": "BatteryCharging.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 11H26V10a2 2 0 00-2-2H20v2h4v3h3v6H24v3H19v2h5a2 2 0 002-2V21h1a2 2 0 002-2V13A2 2 0 0027 11zM11 22H6V10h6V8H6a2 2 0 00-2 2V22a2 2 0 002 2h5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "battery--empty",
      "friendlyName": "Battery empty",
      "aliases": [
        "charging",
        "power",
        "no power",
        "battery empty",
        "empty battery",
        "battery indicator",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/battery--empty.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>battery--empty</title><path class=\"cls-1\" d=\"M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/></svg>",
            "info": {},
            "path": "32/battery--empty.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatteryEmpty32",
          "filepath": "battery--empty/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              }
            ],
            "name": "battery--empty",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatteryEmpty24",
          "filepath": "battery--empty/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              }
            ],
            "name": "battery--empty",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatteryEmpty20",
          "filepath": "battery--empty/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              }
            ],
            "name": "battery--empty",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatteryEmpty16",
          "filepath": "battery--empty/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              }
            ],
            "name": "battery--empty",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BatteryEmpty",
        "global": "BatteryEmpty",
        "filepath": "BatteryEmpty.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "battery--full",
      "friendlyName": "Battery full",
      "aliases": [
        "charging",
        "power",
        "battery full",
        "full battery",
        "technology",
        "battery indicator",
        "battery",
        "battery charged"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/battery--full.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>battery--full</title><path class=\"cls-1\" d=\"M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><rect class=\"cls-1\" x=\"11\" y=\"9\" width=\"8\" height=\"14\" transform=\"translate(31 1) rotate(90)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><path d=\"M11 9H19V23H11z\" transform=\"rotate(90 15 16)\"/></svg>",
            "info": {},
            "path": "32/battery--full.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatteryFull32",
          "filepath": "battery--full/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 9H19V23H11z",
                  "transform": "rotate(90 15 16)"
                }
              }
            ],
            "name": "battery--full",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatteryFull24",
          "filepath": "battery--full/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 9H19V23H11z",
                  "transform": "rotate(90 15 16)"
                }
              }
            ],
            "name": "battery--full",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatteryFull20",
          "filepath": "battery--full/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 9H19V23H11z",
                  "transform": "rotate(90 15 16)"
                }
              }
            ],
            "name": "battery--full",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatteryFull16",
          "filepath": "battery--full/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 9H19V23H11z",
                  "transform": "rotate(90 15 16)"
                }
              }
            ],
            "name": "battery--full",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BatteryFull",
        "global": "BatteryFull",
        "filepath": "BatteryFull.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 9H19V23H11z",
                    "transform": "rotate(90 15 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "battery--half",
      "friendlyName": "Battery half",
      "aliases": [
        "charging",
        "power",
        "battery half charged",
        "half charged battery",
        "battery half full",
        "technology",
        "battery indicator",
        "battery"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/battery--half.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>battery--half-full</title><path class=\"cls-1\" d=\"M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><rect class=\"cls-1\" x=\"8\" y=\"12\" width=\"8\" height=\"8\" transform=\"translate(28 4) rotate(90)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><path d=\"M8 12H16V20H8z\" transform=\"rotate(90 12 16)\"/></svg>",
            "info": {},
            "path": "32/battery--half.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatteryHalf32",
          "filepath": "battery--half/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H16V20H8z",
                  "transform": "rotate(90 12 16)"
                }
              }
            ],
            "name": "battery--half",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatteryHalf24",
          "filepath": "battery--half/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H16V20H8z",
                  "transform": "rotate(90 12 16)"
                }
              }
            ],
            "name": "battery--half",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatteryHalf20",
          "filepath": "battery--half/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H16V20H8z",
                  "transform": "rotate(90 12 16)"
                }
              }
            ],
            "name": "battery--half",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatteryHalf16",
          "filepath": "battery--half/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H16V20H8z",
                  "transform": "rotate(90 12 16)"
                }
              }
            ],
            "name": "battery--half",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BatteryHalf",
        "global": "BatteryHalf",
        "filepath": "BatteryHalf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 12H16V20H8z",
                    "transform": "rotate(90 12 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "battery--low",
      "friendlyName": "Battery low",
      "aliases": [
        "charging",
        "power",
        "battery low",
        "low battery",
        "technology",
        "battery indicator",
        "battery"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/battery--low.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>battery--low</title><path class=\"cls-1\" d=\"M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><rect class=\"cls-1\" x=\"5\" y=\"15\" width=\"8\" height=\"2\" transform=\"translate(25 7) rotate(90)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><path d=\"M5 15H13V17H5z\" transform=\"rotate(90 9 16)\"/></svg>",
            "info": {},
            "path": "32/battery--low.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatteryLow32",
          "filepath": "battery--low/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 15H13V17H5z",
                  "transform": "rotate(90 9 16)"
                }
              }
            ],
            "name": "battery--low",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatteryLow24",
          "filepath": "battery--low/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 15H13V17H5z",
                  "transform": "rotate(90 9 16)"
                }
              }
            ],
            "name": "battery--low",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatteryLow20",
          "filepath": "battery--low/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 15H13V17H5z",
                  "transform": "rotate(90 9 16)"
                }
              }
            ],
            "name": "battery--low",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatteryLow16",
          "filepath": "battery--low/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 15H13V17H5z",
                  "transform": "rotate(90 9 16)"
                }
              }
            ],
            "name": "battery--low",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BatteryLow",
        "global": "BatteryLow",
        "filepath": "BatteryLow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 15H13V17H5z",
                    "transform": "rotate(90 9 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "battery--quarter",
      "friendlyName": "Battery quarter",
      "aliases": [
        "charging",
        "power",
        "battery quarter",
        "quartery battery",
        "technology",
        "battery indicator",
        "battery"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/battery--quarter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>battery--quarter</title><path class=\"cls-1\" d=\"M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><rect class=\"cls-1\" x=\"6\" y=\"14\" width=\"8\" height=\"4\" transform=\"translate(26 6) rotate(90)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z\"/><path d=\"M6 14H14V18H6z\" transform=\"rotate(90 10 16)\"/></svg>",
            "info": {},
            "path": "32/battery--quarter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BatteryQuarter32",
          "filepath": "battery--quarter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 14H14V18H6z",
                  "transform": "rotate(90 10 16)"
                }
              }
            ],
            "name": "battery--quarter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BatteryQuarter24",
          "filepath": "battery--quarter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 14H14V18H6z",
                  "transform": "rotate(90 10 16)"
                }
              }
            ],
            "name": "battery--quarter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BatteryQuarter20",
          "filepath": "battery--quarter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 14H14V18H6z",
                  "transform": "rotate(90 10 16)"
                }
              }
            ],
            "name": "battery--quarter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BatteryQuarter16",
          "filepath": "battery--quarter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 14H14V18H6z",
                  "transform": "rotate(90 10 16)"
                }
              }
            ],
            "name": "battery--quarter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BatteryQuarter",
        "global": "BatteryQuarter",
        "filepath": "BatteryQuarter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 14H14V18H6z",
                    "transform": "rotate(90 10 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bee",
      "friendlyName": "Bee",
      "aliases": [
        "ibm",
        "fly",
        "honey",
        "bumblebee",
        "drone",
        "insect",
        "bee",
        "IBM",
        "IBM bee"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bee.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bee</title><path d=\"M16,10a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0V16A6,6,0,0,0,16,10Zm-4.25,7.87h8.5v4.25h-8.5ZM16,28.25A4.27,4.27,0,0,1,11.75,24v-.13h8.5V24A4.27,4.27,0,0,1,16,28.25Zm4.25-12.13h-8.5V16a4.25,4.25,0,0,1,8.5,0Z\"/><path d=\"M30.66,19.21,24,13v9.1a4,4,0,0,0,8,0A3.83,3.83,0,0,0,30.66,19.21ZM28,24.35a2.25,2.25,0,0,1-2.25-2.25V17l3.72,3.47h0A2.05,2.05,0,0,1,30.2,22,2.25,2.25,0,0,1,28,24.35Z\"/><path d=\"M0,22.1a4,4,0,0,0,8,0V13L1.34,19.21A3.88,3.88,0,0,0,0,22.1Zm2.48-1.56h0L6.25,17v5.1a2.25,2.25,0,0,1-4.5,0A2.05,2.05,0,0,1,2.48,20.54Z\"/><path d=\"M15,5.5A3.5,3.5,0,1,0,11.5,9,3.5,3.5,0,0,0,15,5.5Zm-5.25,0A1.75,1.75,0,1,1,11.5,7.25,1.77,1.77,0,0,1,9.75,5.5Z\"/><path d=\"M20.5,2A3.5,3.5,0,1,0,24,5.5,3.5,3.5,0,0,0,20.5,2Zm0,5.25A1.75,1.75,0,1,1,22.25,5.5,1.77,1.77,0,0,1,20.5,7.25Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 10a6 6 0 00-6 6v8a6 6 0 0012 0V16A6 6 0 0016 10zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0111.75 24v-.13h8.5V24A4.27 4.27 0 0116 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 018.5 0zM30.66 19.21L24 13v9.1a4 4 0 008 0A3.83 3.83 0 0030.66 19.21zM28 24.35a2.25 2.25 0 01-2.25-2.25V17l3.72 3.47h0A2.05 2.05 0 0130.2 22 2.25 2.25 0 0128 24.35zM0 22.1a4 4 0 008 0V13L1.34 19.21A3.88 3.88 0 000 22.1zm2.48-1.56h0L6.25 17v5.1a2.25 2.25 0 01-4.5 0A2.05 2.05 0 012.48 20.54zM15 5.5A3.5 3.5 0 1011.5 9 3.5 3.5 0 0015 5.5zm-5.25 0A1.75 1.75 0 1111.5 7.25 1.77 1.77 0 019.75 5.5zM20.5 2A3.5 3.5 0 1024 5.5 3.5 3.5 0 0020.5 2zm0 5.25A1.75 1.75 0 1122.25 5.5 1.77 1.77 0 0120.5 7.25z\"/></svg>",
            "info": {},
            "path": "32/bee.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bee32",
          "filepath": "bee/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 10a6 6 0 00-6 6v8a6 6 0 0012 0V16A6 6 0 0016 10zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0111.75 24v-.13h8.5V24A4.27 4.27 0 0116 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 018.5 0zM30.66 19.21L24 13v9.1a4 4 0 008 0A3.83 3.83 0 0030.66 19.21zM28 24.35a2.25 2.25 0 01-2.25-2.25V17l3.72 3.47h0A2.05 2.05 0 0130.2 22 2.25 2.25 0 0128 24.35zM0 22.1a4 4 0 008 0V13L1.34 19.21A3.88 3.88 0 000 22.1zm2.48-1.56h0L6.25 17v5.1a2.25 2.25 0 01-4.5 0A2.05 2.05 0 012.48 20.54zM15 5.5A3.5 3.5 0 1011.5 9 3.5 3.5 0 0015 5.5zm-5.25 0A1.75 1.75 0 1111.5 7.25 1.77 1.77 0 019.75 5.5zM20.5 2A3.5 3.5 0 1024 5.5 3.5 3.5 0 0020.5 2zm0 5.25A1.75 1.75 0 1122.25 5.5 1.77 1.77 0 0120.5 7.25z"
                }
              }
            ],
            "name": "bee",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bee24",
          "filepath": "bee/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 10a6 6 0 00-6 6v8a6 6 0 0012 0V16A6 6 0 0016 10zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0111.75 24v-.13h8.5V24A4.27 4.27 0 0116 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 018.5 0zM30.66 19.21L24 13v9.1a4 4 0 008 0A3.83 3.83 0 0030.66 19.21zM28 24.35a2.25 2.25 0 01-2.25-2.25V17l3.72 3.47h0A2.05 2.05 0 0130.2 22 2.25 2.25 0 0128 24.35zM0 22.1a4 4 0 008 0V13L1.34 19.21A3.88 3.88 0 000 22.1zm2.48-1.56h0L6.25 17v5.1a2.25 2.25 0 01-4.5 0A2.05 2.05 0 012.48 20.54zM15 5.5A3.5 3.5 0 1011.5 9 3.5 3.5 0 0015 5.5zm-5.25 0A1.75 1.75 0 1111.5 7.25 1.77 1.77 0 019.75 5.5zM20.5 2A3.5 3.5 0 1024 5.5 3.5 3.5 0 0020.5 2zm0 5.25A1.75 1.75 0 1122.25 5.5 1.77 1.77 0 0120.5 7.25z"
                }
              }
            ],
            "name": "bee",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bee20",
          "filepath": "bee/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 10a6 6 0 00-6 6v8a6 6 0 0012 0V16A6 6 0 0016 10zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0111.75 24v-.13h8.5V24A4.27 4.27 0 0116 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 018.5 0zM30.66 19.21L24 13v9.1a4 4 0 008 0A3.83 3.83 0 0030.66 19.21zM28 24.35a2.25 2.25 0 01-2.25-2.25V17l3.72 3.47h0A2.05 2.05 0 0130.2 22 2.25 2.25 0 0128 24.35zM0 22.1a4 4 0 008 0V13L1.34 19.21A3.88 3.88 0 000 22.1zm2.48-1.56h0L6.25 17v5.1a2.25 2.25 0 01-4.5 0A2.05 2.05 0 012.48 20.54zM15 5.5A3.5 3.5 0 1011.5 9 3.5 3.5 0 0015 5.5zm-5.25 0A1.75 1.75 0 1111.5 7.25 1.77 1.77 0 019.75 5.5zM20.5 2A3.5 3.5 0 1024 5.5 3.5 3.5 0 0020.5 2zm0 5.25A1.75 1.75 0 1122.25 5.5 1.77 1.77 0 0120.5 7.25z"
                }
              }
            ],
            "name": "bee",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bee16",
          "filepath": "bee/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 10a6 6 0 00-6 6v8a6 6 0 0012 0V16A6 6 0 0016 10zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0111.75 24v-.13h8.5V24A4.27 4.27 0 0116 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 018.5 0zM30.66 19.21L24 13v9.1a4 4 0 008 0A3.83 3.83 0 0030.66 19.21zM28 24.35a2.25 2.25 0 01-2.25-2.25V17l3.72 3.47h0A2.05 2.05 0 0130.2 22 2.25 2.25 0 0128 24.35zM0 22.1a4 4 0 008 0V13L1.34 19.21A3.88 3.88 0 000 22.1zm2.48-1.56h0L6.25 17v5.1a2.25 2.25 0 01-4.5 0A2.05 2.05 0 012.48 20.54zM15 5.5A3.5 3.5 0 1011.5 9 3.5 3.5 0 0015 5.5zm-5.25 0A1.75 1.75 0 1111.5 7.25 1.77 1.77 0 019.75 5.5zM20.5 2A3.5 3.5 0 1024 5.5 3.5 3.5 0 0020.5 2zm0 5.25A1.75 1.75 0 1122.25 5.5 1.77 1.77 0 0120.5 7.25z"
                }
              }
            ],
            "name": "bee",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "Bee",
        "global": "Bee",
        "filepath": "Bee.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 10a6 6 0 00-6 6v8a6 6 0 0012 0V16A6 6 0 0016 10zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0111.75 24v-.13h8.5V24A4.27 4.27 0 0116 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 018.5 0zM30.66 19.21L24 13v9.1a4 4 0 008 0A3.83 3.83 0 0030.66 19.21zM28 24.35a2.25 2.25 0 01-2.25-2.25V17l3.72 3.47h0A2.05 2.05 0 0130.2 22 2.25 2.25 0 0128 24.35zM0 22.1a4 4 0 008 0V13L1.34 19.21A3.88 3.88 0 000 22.1zm2.48-1.56h0L6.25 17v5.1a2.25 2.25 0 01-4.5 0A2.05 2.05 0 012.48 20.54zM15 5.5A3.5 3.5 0 1011.5 9 3.5 3.5 0 0015 5.5zm-5.25 0A1.75 1.75 0 1111.5 7.25 1.77 1.77 0 019.75 5.5zM20.5 2A3.5 3.5 0 1024 5.5 3.5 3.5 0 0020.5 2zm0 5.25A1.75 1.75 0 1122.25 5.5 1.77 1.77 0 0120.5 7.25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bee-bat",
      "friendlyName": "Bee bat",
      "aliases": [
        "ibm",
        "fly",
        "bee",
        "bat",
        "IBM",
        "IBM bee bat"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bee-bat.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"13\" cy=\"8\" r=\"2\"/>\n  <circle cx=\"19\" cy=\"8\" r=\"2\"/>\n  <path d=\"M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"13\" cy=\"8\" r=\"2\"/><circle cx=\"19\" cy=\"8\" r=\"2\"/><path d=\"M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z\"/></svg>",
            "info": {},
            "path": "32/bee-bat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BeeBat32",
          "filepath": "bee-bat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z"
                }
              }
            ],
            "name": "bee-bat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BeeBat24",
          "filepath": "bee-bat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z"
                }
              }
            ],
            "name": "bee-bat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BeeBat20",
          "filepath": "bee-bat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z"
                }
              }
            ],
            "name": "bee-bat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BeeBat16",
          "filepath": "bee-bat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z"
                }
              }
            ],
            "name": "bee-bat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "BeeBat",
        "global": "BeeBat",
        "filepath": "BeeBat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13",
                    "cy": "8",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "19",
                    "cy": "8",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "beta",
      "friendlyName": "Beta",
      "aliases": [
        "beta",
        "symbol"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/beta.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z\"/></svg>",
            "info": {},
            "path": "32/beta.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Beta32",
          "filepath": "beta/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z"
                }
              }
            ],
            "name": "beta",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Beta24",
          "filepath": "beta/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z"
                }
              }
            ],
            "name": "beta",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Beta20",
          "filepath": "beta/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z"
                }
              }
            ],
            "name": "beta",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Beta16",
          "filepath": "beta/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z"
                }
              }
            ],
            "name": "beta",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Beta",
        "global": "Beta",
        "filepath": "Beta.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bicycle",
      "friendlyName": "Bicycle",
      "aliases": [
        "bike",
        "cycle",
        "wheels",
        "transport",
        "transportation",
        "bicycle",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bicycle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bicycle</title><path d=\"M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z\"/></svg>",
            "info": {},
            "path": "32/bicycle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bicycle32",
          "filepath": "bicycle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z"
                }
              }
            ],
            "name": "bicycle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bicycle24",
          "filepath": "bicycle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z"
                }
              }
            ],
            "name": "bicycle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bicycle20",
          "filepath": "bicycle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z"
                }
              }
            ],
            "name": "bicycle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bicycle16",
          "filepath": "bicycle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z"
                }
              }
            ],
            "name": "bicycle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Bicycle",
        "global": "Bicycle",
        "filepath": "Bicycle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "binoculars",
      "friendlyName": "Binoculars",
      "aliases": [
        "search",
        "vision",
        "field",
        "glasses",
        "zoom",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/binoculars.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>binoculars</title><path d=\"M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z\"/></svg>",
            "info": {},
            "path": "32/binoculars.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Binoculars32",
          "filepath": "binoculars/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z"
                }
              }
            ],
            "name": "binoculars",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Binoculars24",
          "filepath": "binoculars/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z"
                }
              }
            ],
            "name": "binoculars",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Binoculars20",
          "filepath": "binoculars/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z"
                }
              }
            ],
            "name": "binoculars",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Binoculars16",
          "filepath": "binoculars/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z"
                }
              }
            ],
            "name": "binoculars",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Binoculars",
        "global": "Binoculars",
        "filepath": "Binoculars.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bloch-sphere",
      "friendlyName": "Bloch sphere",
      "aliases": [
        "Q",
        "bloch",
        "sphere",
        "research"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/bloch-sphere.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>research--bloch-sphere</title><path d=\"M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/Q/bloch-sphere.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QBlochSphere32",
          "filepath": "Q/bloch-sphere/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "bloch-sphere",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QBlochSphere24",
          "filepath": "Q/bloch-sphere/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "bloch-sphere",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QBlochSphere20",
          "filepath": "Q/bloch-sphere/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "bloch-sphere",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QBlochSphere16",
          "filepath": "Q/bloch-sphere/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "bloch-sphere",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "BlochSphere",
        "global": "QBlochSphere",
        "filepath": "Q/BlochSphere.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "block-storage",
      "friendlyName": "IBM Cloud® Block Storage for VPC",
      "aliases": [
        "block storage",
        "storage",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/block-storage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12\" transform=\"translate(0 0)\"/>\n  <path d=\"M22,12H14V4h8ZM12,4v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H14A2,2,0,0,0,12,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,18v4H10V18h4M8,18v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H10A2,2,0,0,0,8,18Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,17v2H26V17h2m-4-1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1H25A1,1,0,0,0,24,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12\"/><path d=\"M22 12H14V4h8zM12 4v8a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H14A2 2 0 0012 4zM14 18v4H10V18h4M8 18v4a2 2 0 002 2h4a2 2 0 002-2V18a2 2 0 00-2-2H10A2 2 0 008 18zM28 17v2H26V17h2m-4-1v4a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1H25A1 1 0 0024 16z\"/></svg>",
            "info": {},
            "path": "32/block-storage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BlockStorage32",
          "filepath": "block-storage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 12H14V4h8zM12 4v8a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H14A2 2 0 0012 4zM14 18v4H10V18h4M8 18v4a2 2 0 002 2h4a2 2 0 002-2V18a2 2 0 00-2-2H10A2 2 0 008 18zM28 17v2H26V17h2m-4-1v4a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1H25A1 1 0 0024 16z"
                }
              }
            ],
            "name": "block-storage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BlockStorage24",
          "filepath": "block-storage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 12H14V4h8zM12 4v8a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H14A2 2 0 0012 4zM14 18v4H10V18h4M8 18v4a2 2 0 002 2h4a2 2 0 002-2V18a2 2 0 00-2-2H10A2 2 0 008 18zM28 17v2H26V17h2m-4-1v4a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1H25A1 1 0 0024 16z"
                }
              }
            ],
            "name": "block-storage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BlockStorage20",
          "filepath": "block-storage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 12H14V4h8zM12 4v8a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H14A2 2 0 0012 4zM14 18v4H10V18h4M8 18v4a2 2 0 002 2h4a2 2 0 002-2V18a2 2 0 00-2-2H10A2 2 0 008 18zM28 17v2H26V17h2m-4-1v4a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1H25A1 1 0 0024 16z"
                }
              }
            ],
            "name": "block-storage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BlockStorage16",
          "filepath": "block-storage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 12H14V4h8zM12 4v8a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H14A2 2 0 0012 4zM14 18v4H10V18h4M8 18v4a2 2 0 002 2h4a2 2 0 002-2V18a2 2 0 00-2-2H10A2 2 0 008 18zM28 17v2H26V17h2m-4-1v4a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1H25A1 1 0 0024 16z"
                }
              }
            ],
            "name": "block-storage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "BlockStorage",
        "global": "BlockStorage",
        "filepath": "BlockStorage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 12H14V4h8zM12 4v8a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H14A2 2 0 0012 4zM14 18v4H10V18h4M8 18v4a2 2 0 002 2h4a2 2 0 002-2V18a2 2 0 00-2-2H10A2 2 0 008 18zM28 17v2H26V17h2m-4-1v4a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1H25A1 1 0 0024 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "block-storage--alt",
      "friendlyName": "Block storage alt",
      "aliases": [
        "block storage",
        "storage",
        "alternate"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/block-storage--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <path d=\"M15,20H8V13h7Zm-5-2h3V15H10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24,20H17V13h7Zm-5-2h3V15H19Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M15,11H8V4h7ZM10,9h3V6H10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24,11H17V4h7ZM19,9h3V6H19Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M15 20H8V13h7zm-5-2h3V15H10zM24 20H17V13h7zm-5-2h3V15H19zM15 11H8V4h7zM10 9h3V6H10zM24 11H17V4h7zM19 9h3V6H19z\"/></svg>",
            "info": {},
            "path": "32/block-storage--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BlockStorageAlt32",
          "filepath": "block-storage--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H8V13h7zm-5-2h3V15H10zM24 20H17V13h7zm-5-2h3V15H19zM15 11H8V4h7zM10 9h3V6H10zM24 11H17V4h7zM19 9h3V6H19z"
                }
              }
            ],
            "name": "block-storage--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BlockStorageAlt24",
          "filepath": "block-storage--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H8V13h7zm-5-2h3V15H10zM24 20H17V13h7zm-5-2h3V15H19zM15 11H8V4h7zM10 9h3V6H10zM24 11H17V4h7zM19 9h3V6H19z"
                }
              }
            ],
            "name": "block-storage--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BlockStorageAlt20",
          "filepath": "block-storage--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H8V13h7zm-5-2h3V15H10zM24 20H17V13h7zm-5-2h3V15H19zM15 11H8V4h7zM10 9h3V6H10zM24 11H17V4h7zM19 9h3V6H19z"
                }
              }
            ],
            "name": "block-storage--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BlockStorageAlt16",
          "filepath": "block-storage--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H8V13h7zm-5-2h3V15H10zM24 20H17V13h7zm-5-2h3V15H19zM15 11H8V4h7zM10 9h3V6H10zM24 11H17V4h7zM19 9h3V6H19z"
                }
              }
            ],
            "name": "block-storage--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BlockStorageAlt",
        "global": "BlockStorageAlt",
        "filepath": "BlockStorageAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 20H8V13h7zm-5-2h3V15H10zM24 20H17V13h7zm-5-2h3V15H19zM15 11H8V4h7zM10 9h3V6H10zM24 11H17V4h7zM19 9h3V6H19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "blockchain",
      "friendlyName": "Blockchain",
      "aliases": [
        "blockchain",
        "data",
        "supply chain"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/blockchain.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>blockchain</title><path d=\"M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z\"/></svg>",
            "info": {},
            "path": "32/blockchain.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Blockchain32",
          "filepath": "blockchain/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z"
                }
              }
            ],
            "name": "blockchain",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Blockchain24",
          "filepath": "blockchain/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z"
                }
              }
            ],
            "name": "blockchain",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Blockchain20",
          "filepath": "blockchain/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z"
                }
              }
            ],
            "name": "blockchain",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Blockchain16",
          "filepath": "blockchain/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z"
                }
              }
            ],
            "name": "blockchain",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Blockchain",
        "global": "Blockchain",
        "filepath": "Blockchain.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "blog",
      "friendlyName": "Blog",
      "aliases": [
        "writing",
        "journal",
        "site",
        "layout",
        "page",
        "technology",
        "article",
        "story"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/blog.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>blog</title><rect x=\"4\" y=\"24\" width=\"10\" height=\"2\"/><rect x=\"4\" y=\"18\" width=\"10\" height=\"2\"/><path d=\"M26,14H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2v6A2,2,0,0,1,26,14ZM6,6v6H26V6Z\" transform=\"translate(0 0)\"/><path d=\"M26,28H20a2,2,0,0,1-2-2V20a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2v6A2,2,0,0,1,26,28Zm-6-8v6h6V20Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 24H14V26H4zM4 18H14V20H4zM26 14H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2v6A2 2 0 0126 14zM6 6v6H26V6zM26 28H20a2 2 0 01-2-2V20a2 2 0 012-2h6a2 2 0 012 2v6A2 2 0 0126 28zm-6-8v6h6V20z\"/></svg>",
            "info": {},
            "path": "32/blog.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Blog32",
          "filepath": "blog/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H14V26H4zM4 18H14V20H4zM26 14H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2v6A2 2 0 0126 14zM6 6v6H26V6zM26 28H20a2 2 0 01-2-2V20a2 2 0 012-2h6a2 2 0 012 2v6A2 2 0 0126 28zm-6-8v6h6V20z"
                }
              }
            ],
            "name": "blog",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Blog24",
          "filepath": "blog/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H14V26H4zM4 18H14V20H4zM26 14H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2v6A2 2 0 0126 14zM6 6v6H26V6zM26 28H20a2 2 0 01-2-2V20a2 2 0 012-2h6a2 2 0 012 2v6A2 2 0 0126 28zm-6-8v6h6V20z"
                }
              }
            ],
            "name": "blog",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Blog20",
          "filepath": "blog/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H14V26H4zM4 18H14V20H4zM26 14H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2v6A2 2 0 0126 14zM6 6v6H26V6zM26 28H20a2 2 0 01-2-2V20a2 2 0 012-2h6a2 2 0 012 2v6A2 2 0 0126 28zm-6-8v6h6V20z"
                }
              }
            ],
            "name": "blog",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Blog16",
          "filepath": "blog/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H14V26H4zM4 18H14V20H4zM26 14H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2v6A2 2 0 0126 14zM6 6v6H26V6zM26 28H20a2 2 0 01-2-2V20a2 2 0 012-2h6a2 2 0 012 2v6A2 2 0 0126 28zm-6-8v6h6V20z"
                }
              }
            ],
            "name": "blog",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Blog",
        "global": "Blog",
        "filepath": "Blog.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 24H14V26H4zM4 18H14V20H4zM26 14H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2v6A2 2 0 0126 14zM6 6v6H26V6zM26 28H20a2 2 0 01-2-2V20a2 2 0 012-2h6a2 2 0 012 2v6A2 2 0 0126 28zm-6-8v6h6V20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bluetooth",
      "friendlyName": "Bluetooth",
      "aliases": [
        "wireless",
        "connect",
        "blue",
        "tooth",
        "Bluetooth",
        "technology",
        "communication",
        "wireless communication"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bluetooth.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bluetooth</title><path d=\"M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z\"/></svg>",
            "info": {},
            "path": "32/bluetooth.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bluetooth32",
          "filepath": "bluetooth/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z"
                }
              }
            ],
            "name": "bluetooth",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bluetooth24",
          "filepath": "bluetooth/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z"
                }
              }
            ],
            "name": "bluetooth",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bluetooth20",
          "filepath": "bluetooth/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z"
                }
              }
            ],
            "name": "bluetooth",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bluetooth16",
          "filepath": "bluetooth/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z"
                }
              }
            ],
            "name": "bluetooth",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Bluetooth",
        "global": "Bluetooth",
        "filepath": "Bluetooth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bluetooth--off",
      "friendlyName": "Bluetooth off",
      "aliases": [
        "wireless",
        "connect",
        "blue",
        "tooth",
        "Bluetooth",
        "Bluetooth off",
        "technology",
        "communication",
        "wireless communication"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bluetooth--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bluetooth--off</title><path d=\"M28,26.59,5.41,4,4,5.41,14.59,16,7,23.59,8.41,25,15,18.41V29a1,1,0,0,0,.58.91A1.06,1.06,0,0,0,16,30a1,1,0,0,0,.65-.24l6.3-5.4L26.59,28Zm-11,.24V18.41l4.53,4.53Z\"/><path d=\"M17,12.75V5.17l4.53,3.89-4.11,4.11,1.41,1.41,4.88-4.87A1,1,0,0,0,24,9a1,1,0,0,0-.35-.72l-7-6a1,1,0,0,0-1.07-.15A1,1,0,0,0,15,3v7.75Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 00.58.91A1.06 1.06 0 0016 30a1 1 0 00.65-.24l6.3-5.4L26.59 28zm-11 .24V18.41l4.53 4.53zM17 12.75V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0024 9a1 1 0 00-.35-.72l-7-6a1 1 0 00-1.07-.15A1 1 0 0015 3v7.75z\"/></svg>",
            "info": {},
            "path": "32/bluetooth--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BluetoothOff32",
          "filepath": "bluetooth--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 00.58.91A1.06 1.06 0 0016 30a1 1 0 00.65-.24l6.3-5.4L26.59 28zm-11 .24V18.41l4.53 4.53zM17 12.75V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0024 9a1 1 0 00-.35-.72l-7-6a1 1 0 00-1.07-.15A1 1 0 0015 3v7.75z"
                }
              }
            ],
            "name": "bluetooth--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BluetoothOff24",
          "filepath": "bluetooth--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 00.58.91A1.06 1.06 0 0016 30a1 1 0 00.65-.24l6.3-5.4L26.59 28zm-11 .24V18.41l4.53 4.53zM17 12.75V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0024 9a1 1 0 00-.35-.72l-7-6a1 1 0 00-1.07-.15A1 1 0 0015 3v7.75z"
                }
              }
            ],
            "name": "bluetooth--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BluetoothOff20",
          "filepath": "bluetooth--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 00.58.91A1.06 1.06 0 0016 30a1 1 0 00.65-.24l6.3-5.4L26.59 28zm-11 .24V18.41l4.53 4.53zM17 12.75V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0024 9a1 1 0 00-.35-.72l-7-6a1 1 0 00-1.07-.15A1 1 0 0015 3v7.75z"
                }
              }
            ],
            "name": "bluetooth--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BluetoothOff16",
          "filepath": "bluetooth--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 00.58.91A1.06 1.06 0 0016 30a1 1 0 00.65-.24l6.3-5.4L26.59 28zm-11 .24V18.41l4.53 4.53zM17 12.75V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0024 9a1 1 0 00-.35-.72l-7-6a1 1 0 00-1.07-.15A1 1 0 0015 3v7.75z"
                }
              }
            ],
            "name": "bluetooth--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BluetoothOff",
        "global": "BluetoothOff",
        "filepath": "BluetoothOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 00.58.91A1.06 1.06 0 0016 30a1 1 0 00.65-.24l6.3-5.4L26.59 28zm-11 .24V18.41l4.53 4.53zM17 12.75V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0024 9a1 1 0 00-.35-.72l-7-6a1 1 0 00-1.07-.15A1 1 0 0015 3v7.75z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "book",
      "friendlyName": "Book",
      "aliases": [
        "book",
        "read",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/book.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"19\" y=\"10\" width=\"7\" height=\"2\"/>\n  <rect x=\"19\" y=\"15\" width=\"7\" height=\"2\"/>\n  <rect x=\"19\" y=\"20\" width=\"7\" height=\"2\"/>\n  <rect x=\"6\" y=\"10\" width=\"7\" height=\"2\"/>\n  <rect x=\"6\" y=\"15\" width=\"7\" height=\"2\"/>\n  <rect x=\"6\" y=\"20\" width=\"7\" height=\"2\"/>\n  <path d=\"M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19zM6 10H13V12H6zM6 15H13V17H6zM6 20H13V22H6z\"/><path d=\"M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z\"/></svg>",
            "info": {},
            "path": "32/book.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Book32",
          "filepath": "book/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19zM6 10H13V12H6zM6 15H13V17H6zM6 20H13V22H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"
                }
              }
            ],
            "name": "book",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Book24",
          "filepath": "book/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19zM6 10H13V12H6zM6 15H13V17H6zM6 20H13V22H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"
                }
              }
            ],
            "name": "book",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Book20",
          "filepath": "book/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19zM6 10H13V12H6zM6 15H13V17H6zM6 20H13V22H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"
                }
              }
            ],
            "name": "book",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Book16",
          "filepath": "book/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19zM6 10H13V12H6zM6 15H13V17H6zM6 20H13V22H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"
                }
              }
            ],
            "name": "book",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Book",
        "global": "Book",
        "filepath": "Book.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19zM6 10H13V12H6zM6 15H13V17H6zM6 20H13V22H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bookmark",
      "friendlyName": "Bookmark",
      "aliases": [
        "flag",
        "marker",
        "operations",
        "bookmark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bookmark.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bookmark</title><path d=\"M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z\"/></svg>",
            "info": {},
            "path": "32/bookmark.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bookmark32",
          "filepath": "bookmark/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bookmark24",
          "filepath": "bookmark/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bookmark20",
          "filepath": "bookmark/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bookmark16",
          "filepath": "bookmark/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Bookmark",
        "global": "Bookmark",
        "filepath": "Bookmark.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bookmark--add",
      "friendlyName": "Bookmark add",
      "aliases": [
        "flag",
        "marker",
        "operations",
        "bookmark",
        "plus",
        "add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bookmark--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z\"/>\n  <polygon points=\"26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z\"/><path d=\"M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z\"/></svg>",
            "info": {},
            "path": "32/bookmark--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BookmarkAdd32",
          "filepath": "bookmark--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                }
              }
            ],
            "name": "bookmark--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BookmarkAdd24",
          "filepath": "bookmark--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                }
              }
            ],
            "name": "bookmark--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BookmarkAdd20",
          "filepath": "bookmark--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                }
              }
            ],
            "name": "bookmark--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BookmarkAdd16",
          "filepath": "bookmark--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                }
              }
            ],
            "name": "bookmark--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "BookmarkAdd",
        "global": "BookmarkAdd",
        "filepath": "BookmarkAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bookmark--filled",
      "friendlyName": "Bookmark filled",
      "aliases": [
        "bookmark",
        "filled",
        "operations",
        "flag",
        "marker"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bookmark--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z\"/></svg>",
            "info": {},
            "path": "32/bookmark--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BookmarkFilled32",
          "filepath": "bookmark--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BookmarkFilled24",
          "filepath": "bookmark--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BookmarkFilled20",
          "filepath": "bookmark--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BookmarkFilled16",
          "filepath": "bookmark--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z"
                }
              }
            ],
            "name": "bookmark--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "BookmarkFilled",
        "global": "BookmarkFilled",
        "filepath": "BookmarkFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "boolean",
      "friendlyName": "boolean",
      "aliases": [
        "boolean",
        "search",
        "parameter",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/boolean.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z\"/>\n  <circle cx=\"9\" cy=\"16\" r=\"7\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z\"/><circle cx=\"9\" cy=\"16\" r=\"7\"/></svg>",
            "info": {},
            "path": "32/boolean.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Boolean32",
          "filepath": "boolean/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "7"
                }
              }
            ],
            "name": "boolean",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Boolean24",
          "filepath": "boolean/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "7"
                }
              }
            ],
            "name": "boolean",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Boolean20",
          "filepath": "boolean/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "7"
                }
              }
            ],
            "name": "boolean",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Boolean16",
          "filepath": "boolean/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "7"
                }
              }
            ],
            "name": "boolean",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Boolean",
        "global": "Boolean",
        "filepath": "Boolean.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "16",
                    "r": "7"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "boot",
      "friendlyName": "Boot",
      "aliases": [
        "travel",
        "boot",
        "hiking"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/boot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z\"/></svg>",
            "info": {},
            "path": "32/boot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Boot32",
          "filepath": "boot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z"
                }
              }
            ],
            "name": "boot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Boot24",
          "filepath": "boot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z"
                }
              }
            ],
            "name": "boot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Boot20",
          "filepath": "boot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z"
                }
              }
            ],
            "name": "boot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Boot16",
          "filepath": "boot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z"
                }
              }
            ],
            "name": "boot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Boot",
        "global": "Boot",
        "filepath": "Boot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "boot-volume",
      "friendlyName": "boot-volume",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/boot-volume.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M32,22v-2h-3v-2h-2v2h-1v2h1v6c0,1.1025,.8975,2,2,2h3v-2h-3v-6h3Z\"/>\n  <path d=\"M23,30h-3c-1.1025,0-2-.8975-2-2v-6c0-1.103,.8975-2,2-2h3c1.1025,0,2,.897,2,2v6c0,1.1025-.8975,2-2,2Zm-3-8v6h3v-6h-3Z\"/>\n  <path d=\"M14,30h-3c-1.1025,0-2-.8975-2-2v-6c0-1.103,.8975-2,2-2h3c1.1025,0,2,.897,2,2v6c0,1.1025-.8975,2-2,2Zm-3-8v6h3v-6h-3Z\"/>\n  <path d=\"M5,20H2v-4H0v14H5c1.1025,0,2-.8975,2-2v-6c0-1.103-.8975-2-2-2Zm-3,8v-6h3v6H2Z\"/>\n  <path d=\"M4,14V5h7.5857l4,4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041,.0013-1.9987,.8959-2,2V14h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 22v-2h-3v-2h-2v2h-1v2h1v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM23 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM14 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM5 20H2v-4H0v14H5c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-3 8v-6h3v6H2zM4 14V5h7.5857l4 4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z\"/></svg>",
            "info": {},
            "path": "32/boot-volume.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BootVolume32",
          "filepath": "boot-volume/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 22v-2h-3v-2h-2v2h-1v2h1v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM23 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM14 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM5 20H2v-4H0v14H5c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-3 8v-6h3v6H2zM4 14V5h7.5857l4 4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "boot-volume",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BootVolume24",
          "filepath": "boot-volume/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 22v-2h-3v-2h-2v2h-1v2h1v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM23 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM14 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM5 20H2v-4H0v14H5c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-3 8v-6h3v6H2zM4 14V5h7.5857l4 4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "boot-volume",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BootVolume20",
          "filepath": "boot-volume/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 22v-2h-3v-2h-2v2h-1v2h1v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM23 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM14 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM5 20H2v-4H0v14H5c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-3 8v-6h3v6H2zM4 14V5h7.5857l4 4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "boot-volume",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BootVolume16",
          "filepath": "boot-volume/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 22v-2h-3v-2h-2v2h-1v2h1v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM23 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM14 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM5 20H2v-4H0v14H5c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-3 8v-6h3v6H2zM4 14V5h7.5857l4 4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "boot-volume",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "BootVolume",
        "global": "BootVolume",
        "filepath": "BootVolume.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 22v-2h-3v-2h-2v2h-1v2h1v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM23 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM14 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM5 20H2v-4H0v14H5c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-3 8v-6h3v6H2zM4 14V5h7.5857l4 4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "boot-volume--alt",
      "friendlyName": "boot-volume--alt",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/boot-volume--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z\"/>\n  <polygon points=\"12 24 14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24\"/>\n  <path d=\"M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z\"/><path d=\"M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z\"/><path d=\"M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z\"/></svg>",
            "info": {},
            "path": "32/boot-volume--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BootVolumeAlt32",
          "filepath": "boot-volume--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z"
                }
              }
            ],
            "name": "boot-volume--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BootVolumeAlt24",
          "filepath": "boot-volume--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z"
                }
              }
            ],
            "name": "boot-volume--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BootVolumeAlt20",
          "filepath": "boot-volume--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z"
                }
              }
            ],
            "name": "boot-volume--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BootVolumeAlt16",
          "filepath": "boot-volume--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z"
                }
              }
            ],
            "name": "boot-volume--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "BootVolumeAlt",
        "global": "BootVolumeAlt",
        "filepath": "BootVolumeAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "border--bottom",
      "friendlyName": "Border bottom",
      "aliases": [
        "border",
        "bottom",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/border--bottom.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"3\" y=\"27\" width=\"26\" height=\"2\" transform=\"translate(32 56) rotate(180)\"/>\n  <rect x=\"27\" y=\"23\" width=\"2\" height=\"2\" transform=\"translate(56 48) rotate(180)\"/>\n  <rect x=\"27\" y=\"19\" width=\"2\" height=\"2\" transform=\"translate(56 40) rotate(180)\"/>\n  <rect x=\"27\" y=\"15\" width=\"2\" height=\"2\" transform=\"translate(56 32) rotate(180)\"/>\n  <rect x=\"27\" y=\"11\" width=\"2\" height=\"2\" transform=\"translate(56 24) rotate(180)\"/>\n  <rect x=\"27\" y=\"7\" width=\"2\" height=\"2\" transform=\"translate(56 16) rotate(180)\"/>\n  <rect x=\"27\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(56 8) rotate(180)\"/>\n  <rect x=\"23\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(48 8) rotate(180)\"/>\n  <rect x=\"19\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(40 8) rotate(180)\"/>\n  <rect x=\"15\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(32 8) rotate(180)\"/>\n  <rect x=\"7\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(16 8) rotate(180)\"/>\n  <rect x=\"11\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(24 8) rotate(180)\"/>\n  <rect x=\"3\" y=\"23\" width=\"2\" height=\"2\" transform=\"translate(8 48) rotate(180)\"/>\n  <rect x=\"3\" y=\"19\" width=\"2\" height=\"2\" transform=\"translate(8 40) rotate(180)\"/>\n  <rect x=\"3\" y=\"15\" width=\"2\" height=\"2\" transform=\"translate(8 32) rotate(180)\"/>\n  <rect x=\"3\" y=\"11\" width=\"2\" height=\"2\" transform=\"translate(8 24) rotate(180)\"/>\n  <rect x=\"3\" y=\"7\" width=\"2\" height=\"2\" transform=\"translate(8 16) rotate(180)\"/>\n  <rect x=\"3\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(8 8) rotate(180)\"/>\n  <rect x=\"8\" y=\"10\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"15\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M3 27H29V29H3z\" transform=\"rotate(180 16 28)\"/><path d=\"M27 23H29V25H27z\" transform=\"rotate(180 28 24)\"/><path d=\"M27 19H29V21H27z\" transform=\"rotate(180 28 20)\"/><path d=\"M27 15H29V17H27z\" transform=\"rotate(180 28 16)\"/><path d=\"M27 11H29V13H27z\" transform=\"rotate(180 28 12)\"/><path d=\"M27 7H29V9H27z\" transform=\"rotate(180 28 8)\"/><path d=\"M27 3H29V5H27z\" transform=\"rotate(180 28 4)\"/><path d=\"M23 3H25V5H23z\" transform=\"rotate(180 24 4)\"/><path d=\"M19 3H21V5H19z\" transform=\"rotate(180 20 4)\"/><path d=\"M15 3H17V5H15z\" transform=\"rotate(180 16 4)\"/><path d=\"M7 3H9V5H7z\" transform=\"rotate(180 8 4)\"/><path d=\"M11 3H13V5H11z\" transform=\"rotate(180 12 4)\"/><path d=\"M3 23H5V25H3z\" transform=\"rotate(180 4 24)\"/><path d=\"M3 19H5V21H3z\" transform=\"rotate(180 4 20)\"/><path d=\"M3 15H5V17H3z\" transform=\"rotate(180 4 16)\"/><path d=\"M3 11H5V13H3z\" transform=\"rotate(180 4 12)\"/><path d=\"M3 7H5V9H3z\" transform=\"rotate(180 4 8)\"/><path d=\"M3 3H5V5H3z\" transform=\"rotate(180 4 4)\"/><path d=\"M8 10H18V12H8zM8 15H14V17H8z\"/></svg>",
            "info": {},
            "path": "32/border--bottom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BorderBottom32",
          "filepath": "border--bottom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H29V29H3z",
                  "transform": "rotate(180 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(180 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(180 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(180 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(180 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(180 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(180 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(180 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(180 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(180 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(180 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(180 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(180 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(180 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(180 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(180 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(180 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(180 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--bottom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BorderBottom24",
          "filepath": "border--bottom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H29V29H3z",
                  "transform": "rotate(180 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(180 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(180 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(180 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(180 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(180 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(180 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(180 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(180 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(180 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(180 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(180 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(180 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(180 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(180 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(180 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(180 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(180 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--bottom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BorderBottom20",
          "filepath": "border--bottom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H29V29H3z",
                  "transform": "rotate(180 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(180 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(180 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(180 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(180 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(180 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(180 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(180 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(180 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(180 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(180 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(180 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(180 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(180 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(180 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(180 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(180 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(180 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--bottom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BorderBottom16",
          "filepath": "border--bottom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H29V29H3z",
                  "transform": "rotate(180 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(180 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(180 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(180 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(180 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(180 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(180 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(180 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(180 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(180 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(180 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(180 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(180 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(180 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(180 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(180 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(180 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(180 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--bottom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BorderBottom",
        "global": "BorderBottom",
        "filepath": "BorderBottom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 27H29V29H3z",
                    "transform": "rotate(180 16 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 23H29V25H27z",
                    "transform": "rotate(180 28 24)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 19H29V21H27z",
                    "transform": "rotate(180 28 20)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 15H29V17H27z",
                    "transform": "rotate(180 28 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 11H29V13H27z",
                    "transform": "rotate(180 28 12)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 7H29V9H27z",
                    "transform": "rotate(180 28 8)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 3H29V5H27z",
                    "transform": "rotate(180 28 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 3H25V5H23z",
                    "transform": "rotate(180 24 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 3H21V5H19z",
                    "transform": "rotate(180 20 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 3H17V5H15z",
                    "transform": "rotate(180 16 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 3H9V5H7z",
                    "transform": "rotate(180 8 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 3H13V5H11z",
                    "transform": "rotate(180 12 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 23H5V25H3z",
                    "transform": "rotate(180 4 24)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 19H5V21H3z",
                    "transform": "rotate(180 4 20)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 15H5V17H3z",
                    "transform": "rotate(180 4 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 11H5V13H3z",
                    "transform": "rotate(180 4 12)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 7H5V9H3z",
                    "transform": "rotate(180 4 8)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 3H5V5H3z",
                    "transform": "rotate(180 4 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 10H18V12H8zM8 15H14V17H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "border--full",
      "friendlyName": "Border full",
      "aliases": [
        "border",
        "full",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/border--full.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"10\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"15\" width=\"6\" height=\"2\"/>\n  <path d=\"M29,29H3V3H29ZM5,27H27V5H5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 10H18V12H8zM8 15H14V17H8z\"/><path d=\"M29,29H3V3H29ZM5,27H27V5H5Z\"/></svg>",
            "info": {},
            "path": "32/border--full.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BorderFull32",
          "filepath": "border--full/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,29H3V3H29ZM5,27H27V5H5Z"
                }
              }
            ],
            "name": "border--full",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BorderFull24",
          "filepath": "border--full/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,29H3V3H29ZM5,27H27V5H5Z"
                }
              }
            ],
            "name": "border--full",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BorderFull20",
          "filepath": "border--full/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,29H3V3H29ZM5,27H27V5H5Z"
                }
              }
            ],
            "name": "border--full",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BorderFull16",
          "filepath": "border--full/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,29H3V3H29ZM5,27H27V5H5Z"
                }
              }
            ],
            "name": "border--full",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BorderFull",
        "global": "BorderFull",
        "filepath": "BorderFull.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 10H18V12H8zM8 15H14V17H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,29H3V3H29ZM5,27H27V5H5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "border--left",
      "friendlyName": "Border left",
      "aliases": [
        "border",
        "left",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/border--left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"-9\" y=\"15\" width=\"26\" height=\"2\" transform=\"translate(-12 20) rotate(-90)\"/>\n  <rect x=\"7\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(-20 36) rotate(-90)\"/>\n  <rect x=\"11\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(-16 40) rotate(-90)\"/>\n  <rect x=\"15\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(-12 44) rotate(-90)\"/>\n  <rect x=\"19\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(-8 48) rotate(-90)\"/>\n  <rect x=\"23\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(-4 52) rotate(-90)\"/>\n  <rect x=\"27\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(0 56) rotate(-90)\"/>\n  <rect x=\"27\" y=\"23\" width=\"2\" height=\"2\" transform=\"translate(4 52) rotate(-90)\"/>\n  <rect x=\"27\" y=\"19\" width=\"2\" height=\"2\" transform=\"translate(8 48) rotate(-90)\"/>\n  <rect x=\"27\" y=\"15\" width=\"2\" height=\"2\" transform=\"translate(12 44) rotate(-90)\"/>\n  <rect x=\"27\" y=\"7\" width=\"2\" height=\"2\" transform=\"translate(20 36) rotate(-90)\"/>\n  <rect x=\"27\" y=\"11\" width=\"2\" height=\"2\" transform=\"translate(16 40) rotate(-90)\"/>\n  <rect x=\"7\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(4 12) rotate(-90)\"/>\n  <rect x=\"11\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(8 16) rotate(-90)\"/>\n  <rect x=\"15\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(12 20) rotate(-90)\"/>\n  <rect x=\"19\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(16 24) rotate(-90)\"/>\n  <rect x=\"23\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(20 28) rotate(-90)\"/>\n  <rect x=\"27\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(24 32) rotate(-90)\"/>\n  <rect x=\"8\" y=\"10\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"15\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M-9 15H17V17H-9z\" transform=\"rotate(-90 4 16)\"/><path d=\"M7 27H9V29H7z\" transform=\"rotate(-90 8 28)\"/><path d=\"M11 27H13V29H11z\" transform=\"rotate(-90 12 28)\"/><path d=\"M15 27H17V29H15z\" transform=\"rotate(-90 16 28)\"/><path d=\"M19 27H21V29H19z\" transform=\"rotate(-90 20 28)\"/><path d=\"M23 27H25V29H23z\" transform=\"rotate(-90 24 28)\"/><path d=\"M27 27H29V29H27z\" transform=\"rotate(-90 28 28)\"/><path d=\"M27 23H29V25H27z\" transform=\"rotate(-90 28 24)\"/><path d=\"M27 19H29V21H27z\" transform=\"rotate(-90 28 20)\"/><path d=\"M27 15H29V17H27z\" transform=\"rotate(-90 28 16)\"/><path d=\"M27 7H29V9H27z\" transform=\"rotate(-90 28 8)\"/><path d=\"M27 11H29V13H27z\" transform=\"rotate(-90 28 12)\"/><path d=\"M7 3H9V5H7z\" transform=\"rotate(-90 8 4)\"/><path d=\"M11 3H13V5H11z\" transform=\"rotate(-90 12 4)\"/><path d=\"M15 3H17V5H15z\" transform=\"rotate(-90 16 4)\"/><path d=\"M19 3H21V5H19z\" transform=\"rotate(-90 20 4)\"/><path d=\"M23 3H25V5H23z\" transform=\"rotate(-90 24 4)\"/><path d=\"M27 3H29V5H27z\" transform=\"rotate(-90 28 4)\"/><path d=\"M8 10H18V12H8zM8 15H14V17H8z\"/></svg>",
            "info": {},
            "path": "32/border--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BorderLeft32",
          "filepath": "border--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M-9 15H17V17H-9z",
                  "transform": "rotate(-90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(-90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(-90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(-90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(-90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(-90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 27H29V29H27z",
                  "transform": "rotate(-90 28 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(-90 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(-90 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(-90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(-90 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(-90 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(-90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(-90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(-90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(-90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(-90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(-90 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BorderLeft24",
          "filepath": "border--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M-9 15H17V17H-9z",
                  "transform": "rotate(-90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(-90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(-90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(-90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(-90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(-90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 27H29V29H27z",
                  "transform": "rotate(-90 28 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(-90 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(-90 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(-90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(-90 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(-90 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(-90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(-90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(-90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(-90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(-90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(-90 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BorderLeft20",
          "filepath": "border--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M-9 15H17V17H-9z",
                  "transform": "rotate(-90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(-90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(-90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(-90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(-90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(-90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 27H29V29H27z",
                  "transform": "rotate(-90 28 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(-90 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(-90 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(-90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(-90 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(-90 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(-90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(-90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(-90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(-90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(-90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(-90 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BorderLeft16",
          "filepath": "border--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M-9 15H17V17H-9z",
                  "transform": "rotate(-90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(-90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(-90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(-90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(-90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(-90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 27H29V29H27z",
                  "transform": "rotate(-90 28 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 23H29V25H27z",
                  "transform": "rotate(-90 28 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 19H29V21H27z",
                  "transform": "rotate(-90 28 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H29V17H27z",
                  "transform": "rotate(-90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 7H29V9H27z",
                  "transform": "rotate(-90 28 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27z",
                  "transform": "rotate(-90 28 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(-90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(-90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(-90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(-90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(-90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3H29V5H27z",
                  "transform": "rotate(-90 28 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BorderLeft",
        "global": "BorderLeft",
        "filepath": "BorderLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M-9 15H17V17H-9z",
                    "transform": "rotate(-90 4 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 27H9V29H7z",
                    "transform": "rotate(-90 8 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 27H13V29H11z",
                    "transform": "rotate(-90 12 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 27H17V29H15z",
                    "transform": "rotate(-90 16 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 27H21V29H19z",
                    "transform": "rotate(-90 20 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 27H25V29H23z",
                    "transform": "rotate(-90 24 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 27H29V29H27z",
                    "transform": "rotate(-90 28 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 23H29V25H27z",
                    "transform": "rotate(-90 28 24)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 19H29V21H27z",
                    "transform": "rotate(-90 28 20)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 15H29V17H27z",
                    "transform": "rotate(-90 28 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 7H29V9H27z",
                    "transform": "rotate(-90 28 8)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 11H29V13H27z",
                    "transform": "rotate(-90 28 12)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 3H9V5H7z",
                    "transform": "rotate(-90 8 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 3H13V5H11z",
                    "transform": "rotate(-90 12 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 3H17V5H15z",
                    "transform": "rotate(-90 16 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 3H21V5H19z",
                    "transform": "rotate(-90 20 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 3H25V5H23z",
                    "transform": "rotate(-90 24 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 3H29V5H27z",
                    "transform": "rotate(-90 28 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 10H18V12H8zM8 15H14V17H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "border--none",
      "friendlyName": "Border none",
      "aliases": [
        "border",
        "none",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/border--none.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"3\" y=\"3\" width=\"2\" height=\"2\"/>\n  <rect x=\"7\" y=\"3\" width=\"2\" height=\"2\"/>\n  <rect x=\"11\" y=\"3\" width=\"2\" height=\"2\"/>\n  <rect x=\"15\" y=\"3\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"7\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"11\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"19\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"23\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"3\" width=\"2\" height=\"2\"/>\n  <rect x=\"23\" y=\"3\" width=\"2\" height=\"2\"/>\n  <rect x=\"19\" y=\"3\" width=\"2\" height=\"2\"/>\n  <rect x=\"7\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"11\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"15\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"23\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"19\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"7\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"11\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"19\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"23\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"15\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M3 3H5V5H3zM7 3H9V5H7zM11 3H13V5H11zM15 3H17V5H15zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z\"/></svg>",
            "info": {},
            "path": "32/border--none.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BorderNone32",
          "filepath": "border--none/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3zM7 3H9V5H7zM11 3H13V5H11zM15 3H17V5H15zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--none",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BorderNone24",
          "filepath": "border--none/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3zM7 3H9V5H7zM11 3H13V5H11zM15 3H17V5H15zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--none",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BorderNone20",
          "filepath": "border--none/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3zM7 3H9V5H7zM11 3H13V5H11zM15 3H17V5H15zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--none",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BorderNone16",
          "filepath": "border--none/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3zM7 3H9V5H7zM11 3H13V5H11zM15 3H17V5H15zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--none",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BorderNone",
        "global": "BorderNone",
        "filepath": "BorderNone.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 3H5V5H3zM7 3H9V5H7zM11 3H13V5H11zM15 3H17V5H15zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "border--right",
      "friendlyName": "Border right",
      "aliases": [
        "border",
        "right",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/border--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15\" y=\"15\" width=\"26\" height=\"2\" transform=\"translate(44 -12) rotate(90)\"/>\n  <rect x=\"23\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(28 -20) rotate(90)\"/>\n  <rect x=\"19\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(24 -16) rotate(90)\"/>\n  <rect x=\"15\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(20 -12) rotate(90)\"/>\n  <rect x=\"11\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(16 -8) rotate(90)\"/>\n  <rect x=\"7\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(12 -4) rotate(90)\"/>\n  <rect x=\"3\" y=\"3\" width=\"2\" height=\"2\" transform=\"translate(8 0) rotate(90)\"/>\n  <rect x=\"3\" y=\"7\" width=\"2\" height=\"2\" transform=\"translate(12 4) rotate(90)\"/>\n  <rect x=\"3\" y=\"11\" width=\"2\" height=\"2\" transform=\"translate(16 8) rotate(90)\"/>\n  <rect x=\"3\" y=\"15\" width=\"2\" height=\"2\" transform=\"translate(20 12) rotate(90)\"/>\n  <rect x=\"3\" y=\"23\" width=\"2\" height=\"2\" transform=\"translate(28 20) rotate(90)\"/>\n  <rect x=\"3\" y=\"19\" width=\"2\" height=\"2\" transform=\"translate(24 16) rotate(90)\"/>\n  <rect x=\"23\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(52 4) rotate(90)\"/>\n  <rect x=\"19\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(48 8) rotate(90)\"/>\n  <rect x=\"15\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(44 12) rotate(90)\"/>\n  <rect x=\"11\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(40 16) rotate(90)\"/>\n  <rect x=\"7\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(36 20) rotate(90)\"/>\n  <rect x=\"3\" y=\"27\" width=\"2\" height=\"2\" transform=\"translate(32 24) rotate(90)\"/>\n  <rect x=\"8\" y=\"10\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"15\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 15H41V17H15z\" transform=\"rotate(90 28 16)\"/><path d=\"M23 3H25V5H23z\" transform=\"rotate(90 24 4)\"/><path d=\"M19 3H21V5H19z\" transform=\"rotate(90 20 4)\"/><path d=\"M15 3H17V5H15z\" transform=\"rotate(90 16 4)\"/><path d=\"M11 3H13V5H11z\" transform=\"rotate(90 12 4)\"/><path d=\"M7 3H9V5H7z\" transform=\"rotate(90 8 4)\"/><path d=\"M3 3H5V5H3z\" transform=\"rotate(90 4 4)\"/><path d=\"M3 7H5V9H3z\" transform=\"rotate(90 4 8)\"/><path d=\"M3 11H5V13H3z\" transform=\"rotate(90 4 12)\"/><path d=\"M3 15H5V17H3z\" transform=\"rotate(90 4 16)\"/><path d=\"M3 23H5V25H3z\" transform=\"rotate(90 4 24)\"/><path d=\"M3 19H5V21H3z\" transform=\"rotate(90 4 20)\"/><path d=\"M23 27H25V29H23z\" transform=\"rotate(90 24 28)\"/><path d=\"M19 27H21V29H19z\" transform=\"rotate(90 20 28)\"/><path d=\"M15 27H17V29H15z\" transform=\"rotate(90 16 28)\"/><path d=\"M11 27H13V29H11z\" transform=\"rotate(90 12 28)\"/><path d=\"M7 27H9V29H7z\" transform=\"rotate(90 8 28)\"/><path d=\"M3 27H5V29H3z\" transform=\"rotate(90 4 28)\"/><path d=\"M8 10H18V12H8zM8 15H14V17H8z\"/></svg>",
            "info": {},
            "path": "32/border--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BorderRight32",
          "filepath": "border--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H41V17H15z",
                  "transform": "rotate(90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(90 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(90 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(90 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(90 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(90 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H5V29H3z",
                  "transform": "rotate(90 4 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BorderRight24",
          "filepath": "border--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H41V17H15z",
                  "transform": "rotate(90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(90 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(90 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(90 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(90 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(90 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H5V29H3z",
                  "transform": "rotate(90 4 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BorderRight20",
          "filepath": "border--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H41V17H15z",
                  "transform": "rotate(90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(90 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(90 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(90 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(90 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(90 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H5V29H3z",
                  "transform": "rotate(90 4 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BorderRight16",
          "filepath": "border--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H41V17H15z",
                  "transform": "rotate(90 28 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 3H25V5H23z",
                  "transform": "rotate(90 24 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 3H21V5H19z",
                  "transform": "rotate(90 20 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 3H17V5H15z",
                  "transform": "rotate(90 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 3H13V5H11z",
                  "transform": "rotate(90 12 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 3H9V5H7z",
                  "transform": "rotate(90 8 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H5V5H3z",
                  "transform": "rotate(90 4 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 7H5V9H3z",
                  "transform": "rotate(90 4 8)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11H5V13H3z",
                  "transform": "rotate(90 4 12)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 15H5V17H3z",
                  "transform": "rotate(90 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 23H5V25H3z",
                  "transform": "rotate(90 4 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 19H5V21H3z",
                  "transform": "rotate(90 4 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27H25V29H23z",
                  "transform": "rotate(90 24 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 27H21V29H19z",
                  "transform": "rotate(90 20 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 27H17V29H15z",
                  "transform": "rotate(90 16 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27H13V29H11z",
                  "transform": "rotate(90 12 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H9V29H7z",
                  "transform": "rotate(90 8 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 27H5V29H3z",
                  "transform": "rotate(90 4 28)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BorderRight",
        "global": "BorderRight",
        "filepath": "BorderRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 15H41V17H15z",
                    "transform": "rotate(90 28 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 3H25V5H23z",
                    "transform": "rotate(90 24 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 3H21V5H19z",
                    "transform": "rotate(90 20 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 3H17V5H15z",
                    "transform": "rotate(90 16 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 3H13V5H11z",
                    "transform": "rotate(90 12 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 3H9V5H7z",
                    "transform": "rotate(90 8 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 3H5V5H3z",
                    "transform": "rotate(90 4 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 7H5V9H3z",
                    "transform": "rotate(90 4 8)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 11H5V13H3z",
                    "transform": "rotate(90 4 12)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 15H5V17H3z",
                    "transform": "rotate(90 4 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 23H5V25H3z",
                    "transform": "rotate(90 4 24)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 19H5V21H3z",
                    "transform": "rotate(90 4 20)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 27H25V29H23z",
                    "transform": "rotate(90 24 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 27H21V29H19z",
                    "transform": "rotate(90 20 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 27H17V29H15z",
                    "transform": "rotate(90 16 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 27H13V29H11z",
                    "transform": "rotate(90 12 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 27H9V29H7z",
                    "transform": "rotate(90 8 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 27H5V29H3z",
                    "transform": "rotate(90 4 28)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 10H18V12H8zM8 15H14V17H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "border--top",
      "friendlyName": "Border top",
      "aliases": [
        "border",
        "top",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/border--top.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"3\" y=\"3\" width=\"26\" height=\"2\"/>\n  <rect x=\"3\" y=\"7\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"11\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"19\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"23\" width=\"2\" height=\"2\"/>\n  <rect x=\"3\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"7\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"11\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"15\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"23\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"19\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"7\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"11\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"19\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"23\" width=\"2\" height=\"2\"/>\n  <rect x=\"27\" y=\"27\" width=\"2\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"15\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M3 3H29V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z\"/></svg>",
            "info": {},
            "path": "32/border--top.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BorderTop32",
          "filepath": "border--top/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H29V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--top",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BorderTop24",
          "filepath": "border--top/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H29V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--top",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BorderTop20",
          "filepath": "border--top/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H29V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--top",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BorderTop16",
          "filepath": "border--top/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H29V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                }
              }
            ],
            "name": "border--top",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BorderTop",
        "global": "BorderTop",
        "filepath": "BorderTop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 3H29V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bot",
      "friendlyName": "Bot",
      "aliases": [
        "bot",
        "robot",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>bot</title>\n  <rect x=\"18\" y=\"10\" width=\"2\" height=\"2\"/>\n  <rect x=\"12\" y=\"10\" width=\"2\" height=\"2\"/>\n  <path d=\"M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 10H20V12H18zM12 10H14V12H12z\"/><path d=\"M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z\"/></svg>",
            "info": {},
            "path": "32/bot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bot32",
          "filepath": "bot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 10H20V12H18zM12 10H14V12H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z"
                }
              }
            ],
            "name": "bot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bot24",
          "filepath": "bot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 10H20V12H18zM12 10H14V12H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z"
                }
              }
            ],
            "name": "bot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bot20",
          "filepath": "bot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 10H20V12H18zM12 10H14V12H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z"
                }
              }
            ],
            "name": "bot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bot16",
          "filepath": "bot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 10H20V12H18zM12 10H14V12H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z"
                }
              }
            ],
            "name": "bot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Bot",
        "global": "Bot",
        "filepath": "Bot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 10H20V12H18zM12 10H14V12H12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bottles--01",
      "friendlyName": "bottles--01",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bottles--01.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z\"/>\n  <path d=\"M19,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z\"/>\n  <path d=\"M12,9.3706V3c0-.5522-.4478-1-1-1H7c-.5522,0-1,.4478-1,1v6.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5522,.4478,1,1,1H14c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Zm1,18.6294H5V15c0-3.7725,3-4.2793,3-4.2793V4h2v6.7207s3,.5068,3,4.2793v13Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v14c0 .5522.4478 1 1 1H14c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zm1 18.6294H5V15c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v13z\"/></svg>",
            "info": {},
            "path": "32/bottles--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bottles_0132",
          "filepath": "bottles--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v14c0 .5522.4478 1 1 1H14c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zm1 18.6294H5V15c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v13z"
                }
              }
            ],
            "name": "bottles--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bottles_0124",
          "filepath": "bottles--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v14c0 .5522.4478 1 1 1H14c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zm1 18.6294H5V15c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v13z"
                }
              }
            ],
            "name": "bottles--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bottles_0120",
          "filepath": "bottles--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v14c0 .5522.4478 1 1 1H14c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zm1 18.6294H5V15c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v13z"
                }
              }
            ],
            "name": "bottles--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bottles_0116",
          "filepath": "bottles--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v14c0 .5522.4478 1 1 1H14c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zm1 18.6294H5V15c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v13z"
                }
              }
            ],
            "name": "bottles--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Bottles_01",
        "global": "Bottles_01",
        "filepath": "Bottles_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v14c0 .5522.4478 1 1 1H14c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zm1 18.6294H5V15c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bottles--01--dash",
      "friendlyName": "bottles--01--dash",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bottles--01--dash.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z\"/>\n  <path d=\"M19,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z\"/>\n  <path d=\"M13,28h-3v2h4c.5522,0,1-.4478,1-1v-4h-2v3Z\"/>\n  <path d=\"M5,25H3v4c0,.5522,.4478,1,1,1h4v-2h-3v-3Z\"/>\n  <rect x=\"13\" y=\"18\" width=\"2\" height=\"5\"/>\n  <rect x=\"3\" y=\"18\" width=\"2\" height=\"5\"/>\n  <path d=\"M12,9.3706V3c0-.5522-.4478-1-1-1H7c-.5522,0-1,.4478-1,1v6.3706c-1.0674,.6055-3,2.1777-3,5.6294v1h2v-1c0-3.7725,3-4.2793,3-4.2793V4h2v6.7207s3,.5068,3,4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM13 28h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM5 25H3v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM13 18H15V23H13zM3 18H5V23H3zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v1h2v-1c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294z\"/></svg>",
            "info": {},
            "path": "32/bottles--01--dash.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bottles_01Dash32",
          "filepath": "bottles--01--dash/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM13 28h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM5 25H3v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM13 18H15V23H13zM3 18H5V23H3zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v1h2v-1c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294z"
                }
              }
            ],
            "name": "bottles--01--dash",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bottles_01Dash24",
          "filepath": "bottles--01--dash/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM13 28h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM5 25H3v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM13 18H15V23H13zM3 18H5V23H3zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v1h2v-1c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294z"
                }
              }
            ],
            "name": "bottles--01--dash",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bottles_01Dash20",
          "filepath": "bottles--01--dash/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM13 28h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM5 25H3v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM13 18H15V23H13zM3 18H5V23H3zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v1h2v-1c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294z"
                }
              }
            ],
            "name": "bottles--01--dash",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bottles_01Dash16",
          "filepath": "bottles--01--dash/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM13 28h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM5 25H3v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM13 18H15V23H13zM3 18H5V23H3zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v1h2v-1c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294z"
                }
              }
            ],
            "name": "bottles--01--dash",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Bottles_01Dash",
        "global": "Bottles_01Dash",
        "filepath": "Bottles_01Dash.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM13 28h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM5 25H3v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM13 18H15V23H13zM3 18H5V23H3zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v1h2v-1c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bottles--02",
      "friendlyName": "bottles--02",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bottles--02.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2,1.1238,2,3.48v11.5h-4v2h5c.5522,0,1-.4478,1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487Z\"/>\n  <path d=\"M16,9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487v12.5c0,.5522,.4478,1,1,1h10c.5522,0,1-.4478,1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487Zm0,15.9487H8V13.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v11.5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v12.5c0 .5522.4478 1 1 1h10c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zm0 15.9487H8V13.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v11.5z\"/></svg>",
            "info": {},
            "path": "32/bottles--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bottles_0232",
          "filepath": "bottles--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v12.5c0 .5522.4478 1 1 1h10c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zm0 15.9487H8V13.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v11.5z"
                }
              }
            ],
            "name": "bottles--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bottles_0224",
          "filepath": "bottles--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v12.5c0 .5522.4478 1 1 1h10c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zm0 15.9487H8V13.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v11.5z"
                }
              }
            ],
            "name": "bottles--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bottles_0220",
          "filepath": "bottles--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v12.5c0 .5522.4478 1 1 1h10c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zm0 15.9487H8V13.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v11.5z"
                }
              }
            ],
            "name": "bottles--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bottles_0216",
          "filepath": "bottles--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v12.5c0 .5522.4478 1 1 1h10c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zm0 15.9487H8V13.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v11.5z"
                }
              }
            ],
            "name": "bottles--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Bottles_02",
        "global": "Bottles_02",
        "filepath": "Bottles_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v12.5c0 .5522.4478 1 1 1h10c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zm0 15.9487H8V13.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v11.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bottles--02--dash",
      "friendlyName": "bottles--02--dash",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bottles--02--dash.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2,1.1238,2,3.48v11.5h-4v2h5c.5522,0,1-.4478,1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487Z\"/>\n  <path d=\"M16,25h-3v2h4c.5522,0,1-.4478,1-1v-4h-2v3Z\"/>\n  <path d=\"M8,22h-2v4c0,.5522,.4478,1,1,1h4v-2h-3v-3Z\"/>\n  <rect x=\"16\" y=\"16\" width=\"2\" height=\"4\"/>\n  <rect x=\"6\" y=\"16\" width=\"2\" height=\"4\"/>\n  <path d=\"M16,9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487v.5h2v-.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 25h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM8 22h-2v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM16 16H18V20H16zM6 16H8V20H6zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v.5h2v-.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487z\"/></svg>",
            "info": {},
            "path": "32/bottles--02--dash.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bottles_02Dash32",
          "filepath": "bottles--02--dash/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 25h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM8 22h-2v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM16 16H18V20H16zM6 16H8V20H6zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v.5h2v-.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487z"
                }
              }
            ],
            "name": "bottles--02--dash",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bottles_02Dash24",
          "filepath": "bottles--02--dash/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 25h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM8 22h-2v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM16 16H18V20H16zM6 16H8V20H6zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v.5h2v-.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487z"
                }
              }
            ],
            "name": "bottles--02--dash",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bottles_02Dash20",
          "filepath": "bottles--02--dash/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 25h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM8 22h-2v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM16 16H18V20H16zM6 16H8V20H6zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v.5h2v-.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487z"
                }
              }
            ],
            "name": "bottles--02--dash",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bottles_02Dash16",
          "filepath": "bottles--02--dash/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 25h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM8 22h-2v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM16 16H18V20H16zM6 16H8V20H6zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v.5h2v-.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487z"
                }
              }
            ],
            "name": "bottles--02--dash",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Bottles_02Dash",
        "global": "Bottles_02Dash",
        "filepath": "Bottles_02Dash.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 25h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM8 22h-2v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM16 16H18V20H16zM6 16H8V20H6zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v.5h2v-.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bottles--container",
      "friendlyName": "bottles--container",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bottles--container.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2,1.1238,2,3.48v8.5513h-4v2h5c.5522,0,1-.4478,1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487Z\"/>\n  <path d=\"M15,10v-2c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v2c-1.2771,1.1411-2,2.7358-2,4.4487v9.5513c0,.5522,.4478,1,1,1h8c.5522,0,1-.4478,1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487Zm0,13h-6V14.4487c0-2.356,2-3.48,2-3.48v-1.9688h2v1.9688s2,1.124,2,3.48v8.5513Z\"/>\n  <path d=\"M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2 1.1238 2 3.48v8.5513h-4v2h5c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zM15 10v-2c0-.5522-.4478-1-1-1h-4c-.5522 0-1 .4478-1 1v2c-1.2771 1.1411-2 2.7358-2 4.4487v9.5513c0 .5522.4478 1 1 1h8c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zm0 13h-6V14.4487c0-2.356 2-3.48 2-3.48v-1.9688h2v1.9688s2 1.124 2 3.48v8.5513z\"/><path d=\"M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z\"/></svg>",
            "info": {},
            "path": "32/bottles--container.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BottlesContainer32",
          "filepath": "bottles--container/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2 1.1238 2 3.48v8.5513h-4v2h5c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zM15 10v-2c0-.5522-.4478-1-1-1h-4c-.5522 0-1 .4478-1 1v2c-1.2771 1.1411-2 2.7358-2 4.4487v9.5513c0 .5522.4478 1 1 1h8c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zm0 13h-6V14.4487c0-2.356 2-3.48 2-3.48v-1.9688h2v1.9688s2 1.124 2 3.48v8.5513z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z"
                }
              }
            ],
            "name": "bottles--container",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BottlesContainer24",
          "filepath": "bottles--container/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2 1.1238 2 3.48v8.5513h-4v2h5c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zM15 10v-2c0-.5522-.4478-1-1-1h-4c-.5522 0-1 .4478-1 1v2c-1.2771 1.1411-2 2.7358-2 4.4487v9.5513c0 .5522.4478 1 1 1h8c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zm0 13h-6V14.4487c0-2.356 2-3.48 2-3.48v-1.9688h2v1.9688s2 1.124 2 3.48v8.5513z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z"
                }
              }
            ],
            "name": "bottles--container",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BottlesContainer20",
          "filepath": "bottles--container/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2 1.1238 2 3.48v8.5513h-4v2h5c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zM15 10v-2c0-.5522-.4478-1-1-1h-4c-.5522 0-1 .4478-1 1v2c-1.2771 1.1411-2 2.7358-2 4.4487v9.5513c0 .5522.4478 1 1 1h8c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zm0 13h-6V14.4487c0-2.356 2-3.48 2-3.48v-1.9688h2v1.9688s2 1.124 2 3.48v8.5513z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z"
                }
              }
            ],
            "name": "bottles--container",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BottlesContainer16",
          "filepath": "bottles--container/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2 1.1238 2 3.48v8.5513h-4v2h5c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zM15 10v-2c0-.5522-.4478-1-1-1h-4c-.5522 0-1 .4478-1 1v2c-1.2771 1.1411-2 2.7358-2 4.4487v9.5513c0 .5522.4478 1 1 1h8c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zm0 13h-6V14.4487c0-2.356 2-3.48 2-3.48v-1.9688h2v1.9688s2 1.124 2 3.48v8.5513z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z"
                }
              }
            ],
            "name": "bottles--container",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "BottlesContainer",
        "global": "BottlesContainer",
        "filepath": "BottlesContainer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2 1.1238 2 3.48v8.5513h-4v2h5c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zM15 10v-2c0-.5522-.4478-1-1-1h-4c-.5522 0-1 .4478-1 1v2c-1.2771 1.1411-2 2.7358-2 4.4487v9.5513c0 .5522.4478 1 1 1h8c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zm0 13h-6V14.4487c0-2.356 2-3.48 2-3.48v-1.9688h2v1.9688s2 1.124 2 3.48v8.5513z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "box",
      "friendlyName": "Box",
      "aliases": [
        "file",
        "archive",
        "office",
        "instruments",
        "box",
        "file box"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/box.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>box</title><path d=\"M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z\"/><path d=\"M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z\"/><path d=\"M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z\"/></svg>",
            "info": {},
            "path": "32/box.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Box32",
          "filepath": "box/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z"
                }
              }
            ],
            "name": "box",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Box24",
          "filepath": "box/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z"
                }
              }
            ],
            "name": "box",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Box20",
          "filepath": "box/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z"
                }
              }
            ],
            "name": "box",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Box16",
          "filepath": "box/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z"
                }
              }
            ],
            "name": "box",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Box",
        "global": "Box",
        "filepath": "Box.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "box--extra-large",
      "friendlyName": "Box extra large",
      "aliases": [
        "systems",
        "box",
        "extra large"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/box--extra-large.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/>\n  <polygon points=\"19 21 19 9 17 9 17 23 24 23 24 21 19 21\"/>\n  <polygon points=\"16 9 14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9\"/>\n  <rect x=\"4\" y=\"4\" width=\"24\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/><path d=\"M19 21L19 9 17 9 17 23 24 23 24 21 19 21zM16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9zM4 4H28V6H4z\"/></svg>",
            "info": {},
            "path": "32/box--extra-large.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BoxExtraLarge32",
          "filepath": "box--extra-large/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21L19 9 17 9 17 23 24 23 24 21 19 21zM16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--extra-large",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BoxExtraLarge24",
          "filepath": "box--extra-large/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21L19 9 17 9 17 23 24 23 24 21 19 21zM16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--extra-large",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BoxExtraLarge20",
          "filepath": "box--extra-large/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21L19 9 17 9 17 23 24 23 24 21 19 21zM16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--extra-large",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BoxExtraLarge16",
          "filepath": "box--extra-large/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21L19 9 17 9 17 23 24 23 24 21 19 21zM16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--extra-large",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BoxExtraLarge",
        "global": "BoxExtraLarge",
        "filepath": "BoxExtraLarge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 21L19 9 17 9 17 23 24 23 24 21 19 21zM16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9zM4 4H28V6H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "box--large",
      "friendlyName": "Box extra large",
      "aliases": [
        "systems",
        "box",
        "large"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/box--large.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/>\n  <polygon points=\"14 21 14 9 12 9 12 23 20 23 20 21 14 21\"/>\n  <rect x=\"4\" y=\"4\" width=\"24\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/><path d=\"M14 21L14 9 12 9 12 23 20 23 20 21 14 21zM4 4H28V6H4z\"/></svg>",
            "info": {},
            "path": "32/box--large.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BoxLarge32",
          "filepath": "box--large/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21L14 9 12 9 12 23 20 23 20 21 14 21zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--large",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BoxLarge24",
          "filepath": "box--large/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21L14 9 12 9 12 23 20 23 20 21 14 21zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--large",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BoxLarge20",
          "filepath": "box--large/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21L14 9 12 9 12 23 20 23 20 21 14 21zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--large",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BoxLarge16",
          "filepath": "box--large/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21L14 9 12 9 12 23 20 23 20 21 14 21zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--large",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BoxLarge",
        "global": "BoxLarge",
        "filepath": "BoxLarge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 21L14 9 12 9 12 23 20 23 20 21 14 21zM4 4H28V6H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "box--medium",
      "friendlyName": "Box medium",
      "aliases": [
        "systems",
        "box",
        "medium"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/box--medium.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/>\n  <polygon points=\"18 9 16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9\"/>\n  <rect x=\"4\" y=\"4\" width=\"24\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/><path d=\"M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9zM4 4H28V6H4z\"/></svg>",
            "info": {},
            "path": "32/box--medium.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BoxMedium32",
          "filepath": "box--medium/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--medium",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BoxMedium24",
          "filepath": "box--medium/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--medium",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BoxMedium20",
          "filepath": "box--medium/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--medium",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BoxMedium16",
          "filepath": "box--medium/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--medium",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BoxMedium",
        "global": "BoxMedium",
        "filepath": "BoxMedium.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9zM4 4H28V6H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "box--small",
      "friendlyName": "Box small",
      "aliases": [
        "systems",
        "box",
        "small"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/box--small.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/>\n  <path d=\"M18,23H12V21h6V17H14a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H14v4h4a2.002,2.002,0,0,1,2,2v4A2.0023,2.0023,0,0,1,18,23Z\"/>\n  <rect x=\"4\" y=\"4\" width=\"24\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z\"/><path d=\"M18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0118 23zM4 4H28V6H4z\"/></svg>",
            "info": {},
            "path": "32/box--small.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BoxSmall32",
          "filepath": "box--small/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0118 23zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--small",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BoxSmall24",
          "filepath": "box--small/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0118 23zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--small",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BoxSmall20",
          "filepath": "box--small/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0118 23zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--small",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BoxSmall16",
          "filepath": "box--small/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0118 23zM4 4H28V6H4z"
                }
              }
            ],
            "name": "box--small",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "BoxSmall",
        "global": "BoxSmall",
        "filepath": "BoxSmall.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0118 23zM4 4H28V6H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "box-plot",
      "friendlyName": "Box plot",
      "aliases": [
        "box plot",
        "boxplot",
        "data",
        "statistics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/box-plot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>box-plot</title>\n  <path d=\"M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z\"/>\n  <path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z\"/><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/></svg>",
            "info": {},
            "path": "32/box-plot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BoxPlot32",
          "filepath": "box-plot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "box-plot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BoxPlot24",
          "filepath": "box-plot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "box-plot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BoxPlot20",
          "filepath": "box-plot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "box-plot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BoxPlot16",
          "filepath": "box-plot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "box-plot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "BoxPlot",
        "global": "BoxPlot",
        "filepath": "BoxPlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "branch",
      "friendlyName": "Branch",
      "aliases": [
        "branch",
        "operations",
        "instruction"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/branch.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fork</title><path d=\"M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z\"/></svg>",
            "info": {},
            "path": "32/branch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Branch32",
          "filepath": "branch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z"
                }
              }
            ],
            "name": "branch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Branch24",
          "filepath": "branch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z"
                }
              }
            ],
            "name": "branch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Branch20",
          "filepath": "branch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z"
                }
              }
            ],
            "name": "branch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Branch16",
          "filepath": "branch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z"
                }
              }
            ],
            "name": "branch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Branch",
        "global": "Branch",
        "filepath": "Branch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "breaking-change",
      "friendlyName": "Breaking change",
      "aliases": [
        "breaking",
        "change"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/breaking-change.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M31,25a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,31,25Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L22.981,21.5669A3.9529,3.9529,0,0,1,25,21,4.0045,4.0045,0,0,1,29,25Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,25,29,4.0045,4.0045,0,0,1,21,25Z\"/>\n  <polygon points=\"19.59 16 17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16\"/>\n  <polygon points=\"10.41 16 13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16\"/>\n  <path d=\"M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 25a6 6 0 10-6 6A6.0066 6.0066 0 0031 25zm-2 0a3.9521 3.9521 0 01-.5669 2.019L22.981 21.5669A3.9529 3.9529 0 0125 21 4.0045 4.0045 0 0129 25zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0125 29 4.0045 4.0045 0 0121 25zM19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16zM10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z\"/><path d=\"M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z\"/></svg>",
            "info": {},
            "path": "32/breaking-change.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BreakingChange32",
          "filepath": "breaking-change/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 25a6 6 0 10-6 6A6.0066 6.0066 0 0031 25zm-2 0a3.9521 3.9521 0 01-.5669 2.019L22.981 21.5669A3.9529 3.9529 0 0125 21 4.0045 4.0045 0 0129 25zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0125 29 4.0045 4.0045 0 0121 25zM19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16zM10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z"
                }
              }
            ],
            "name": "breaking-change",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BreakingChange24",
          "filepath": "breaking-change/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 25a6 6 0 10-6 6A6.0066 6.0066 0 0031 25zm-2 0a3.9521 3.9521 0 01-.5669 2.019L22.981 21.5669A3.9529 3.9529 0 0125 21 4.0045 4.0045 0 0129 25zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0125 29 4.0045 4.0045 0 0121 25zM19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16zM10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z"
                }
              }
            ],
            "name": "breaking-change",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BreakingChange20",
          "filepath": "breaking-change/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 25a6 6 0 10-6 6A6.0066 6.0066 0 0031 25zm-2 0a3.9521 3.9521 0 01-.5669 2.019L22.981 21.5669A3.9529 3.9529 0 0125 21 4.0045 4.0045 0 0129 25zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0125 29 4.0045 4.0045 0 0121 25zM19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16zM10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z"
                }
              }
            ],
            "name": "breaking-change",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BreakingChange16",
          "filepath": "breaking-change/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 25a6 6 0 10-6 6A6.0066 6.0066 0 0031 25zm-2 0a3.9521 3.9521 0 01-.5669 2.019L22.981 21.5669A3.9529 3.9529 0 0125 21 4.0045 4.0045 0 0129 25zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0125 29 4.0045 4.0045 0 0121 25zM19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16zM10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z"
                }
              }
            ],
            "name": "breaking-change",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BreakingChange",
        "global": "BreakingChange",
        "filepath": "BreakingChange.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 25a6 6 0 10-6 6A6.0066 6.0066 0 0031 25zm-2 0a3.9521 3.9521 0 01-.5669 2.019L22.981 21.5669A3.9529 3.9529 0 0125 21 4.0045 4.0045 0 0129 25zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0125 29 4.0045 4.0045 0 0121 25zM19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16zM10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "brightness-contrast",
      "friendlyName": "Brightness contrast",
      "aliases": [
        "sun",
        "bright",
        "light",
        "dark",
        "contrast",
        "opposite",
        "formatting",
        "brightness",
        "brightness contrast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/brightness-contrast.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>brightness-contrast</title><rect x=\"15\" y=\"2\" width=\"2\" height=\"3\"/><rect x=\"27\" y=\"15\" width=\"3\" height=\"2\"/><rect x=\"15\" y=\"27\" width=\"2\" height=\"3\"/><rect x=\"2\" y=\"15\" width=\"3\" height=\"2\"/><rect x=\"6.22\" y=\"5.73\" width=\"2\" height=\"3\" transform=\"translate(-3 7.23) rotate(-45)\"/><rect x=\"23.27\" y=\"6.23\" width=\"3\" height=\"2\" transform=\"translate(2.14 19.63) rotate(-45)\"/><rect x=\"23.77\" y=\"23.27\" width=\"2\" height=\"3\" transform=\"translate(-10.26 24.77) rotate(-45)\"/><polygon points=\"5.47 25.13 7.59 23 9 24.42 6.88 26.54 5.47 25.13\"/><path d=\"M16,8a8,8,0,1,0,8,8A8,8,0,0,0,16,8Zm0,14a6,6,0,0,1,0-12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z\"/><path d=\"M6.22 5.73H8.219999999999999V8.73H6.22z\" transform=\"rotate(-45 7.227 7.236)\"/><path d=\"M23.27 6.23H26.27V8.23H23.27z\" transform=\"rotate(-45 24.766 7.232)\"/><path d=\"M23.77 23.27H25.77V26.27H23.77z\" transform=\"rotate(-45 24.77 24.77)\"/><path d=\"M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13zM16 8a8 8 0 108 8A8 8 0 0016 8zm0 14a6 6 0 010-12z\"/></svg>",
            "info": {},
            "path": "32/brightness-contrast.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BrightnessContrast32",
          "filepath": "brightness-contrast/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.22 5.73H8.219999999999999V8.73H6.22z",
                  "transform": "rotate(-45 7.227 7.236)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.27 6.23H26.27V8.23H23.27z",
                  "transform": "rotate(-45 24.766 7.232)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.77 23.27H25.77V26.27H23.77z",
                  "transform": "rotate(-45 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13zM16 8a8 8 0 108 8A8 8 0 0016 8zm0 14a6 6 0 010-12z"
                }
              }
            ],
            "name": "brightness-contrast",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BrightnessContrast24",
          "filepath": "brightness-contrast/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.22 5.73H8.219999999999999V8.73H6.22z",
                  "transform": "rotate(-45 7.227 7.236)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.27 6.23H26.27V8.23H23.27z",
                  "transform": "rotate(-45 24.766 7.232)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.77 23.27H25.77V26.27H23.77z",
                  "transform": "rotate(-45 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13zM16 8a8 8 0 108 8A8 8 0 0016 8zm0 14a6 6 0 010-12z"
                }
              }
            ],
            "name": "brightness-contrast",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BrightnessContrast20",
          "filepath": "brightness-contrast/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.22 5.73H8.219999999999999V8.73H6.22z",
                  "transform": "rotate(-45 7.227 7.236)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.27 6.23H26.27V8.23H23.27z",
                  "transform": "rotate(-45 24.766 7.232)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.77 23.27H25.77V26.27H23.77z",
                  "transform": "rotate(-45 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13zM16 8a8 8 0 108 8A8 8 0 0016 8zm0 14a6 6 0 010-12z"
                }
              }
            ],
            "name": "brightness-contrast",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BrightnessContrast16",
          "filepath": "brightness-contrast/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.22 5.73H8.219999999999999V8.73H6.22z",
                  "transform": "rotate(-45 7.227 7.236)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.27 6.23H26.27V8.23H23.27z",
                  "transform": "rotate(-45 24.766 7.232)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.77 23.27H25.77V26.27H23.77z",
                  "transform": "rotate(-45 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13zM16 8a8 8 0 108 8A8 8 0 0016 8zm0 14a6 6 0 010-12z"
                }
              }
            ],
            "name": "brightness-contrast",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BrightnessContrast",
        "global": "BrightnessContrast",
        "filepath": "BrightnessContrast.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.22 5.73H8.219999999999999V8.73H6.22z",
                    "transform": "rotate(-45 7.227 7.236)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.27 6.23H26.27V8.23H23.27z",
                    "transform": "rotate(-45 24.766 7.232)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.77 23.27H25.77V26.27H23.77z",
                    "transform": "rotate(-45 24.77 24.77)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13zM16 8a8 8 0 108 8A8 8 0 0016 8zm0 14a6 6 0 010-12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bring-forward",
      "friendlyName": "Bring forward",
      "aliases": [
        "bring",
        "forward",
        "layer",
        "arrange",
        "formatting",
        "order"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bring-forward.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,15H10V12a2.0023,2.0023,0,0,1,2-2h3v2H12Z\"/>\n  <path d=\"M15,30H12a2.0023,2.0023,0,0,1-2-2V25h2v3h3Z\"/>\n  <rect x=\"18\" y=\"28\" width=\"4\" height=\"2\"/>\n  <path d=\"M28,30H25V28h3V25h2v3A2.0023,2.0023,0,0,1,28,30Z\"/>\n  <rect x=\"10\" y=\"18\" width=\"2\" height=\"4\"/>\n  <rect x=\"28\" y=\"18\" width=\"2\" height=\"4\"/>\n  <path d=\"M30,15H28V12H25V10h3a2.0023,2.0023,0,0,1,2,2Z\"/>\n  <rect x=\"18\" y=\"10\" width=\"4\" height=\"2\"/>\n  <path d=\"M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 15H10V12a2.0023 2.0023 0 012-2h3v2H12zM15 30H12a2.0023 2.0023 0 01-2-2V25h2v3h3zM18 28H22V30H18zM28 30H25V28h3V25h2v3A2.0023 2.0023 0 0128 30zM10 18H12V22H10zM28 18H30V22H28zM30 15H28V12H25V10h3a2.0023 2.0023 0 012 2zM18 10H22V12H18z\"/><path d=\"M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z\"/></svg>",
            "info": {},
            "path": "32/bring-forward.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BringForward32",
          "filepath": "bring-forward/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H10V12a2.0023 2.0023 0 012-2h3v2H12zM15 30H12a2.0023 2.0023 0 01-2-2V25h2v3h3zM18 28H22V30H18zM28 30H25V28h3V25h2v3A2.0023 2.0023 0 0128 30zM10 18H12V22H10zM28 18H30V22H28zM30 15H28V12H25V10h3a2.0023 2.0023 0 012 2zM18 10H22V12H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z"
                }
              }
            ],
            "name": "bring-forward",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BringForward24",
          "filepath": "bring-forward/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H10V12a2.0023 2.0023 0 012-2h3v2H12zM15 30H12a2.0023 2.0023 0 01-2-2V25h2v3h3zM18 28H22V30H18zM28 30H25V28h3V25h2v3A2.0023 2.0023 0 0128 30zM10 18H12V22H10zM28 18H30V22H28zM30 15H28V12H25V10h3a2.0023 2.0023 0 012 2zM18 10H22V12H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z"
                }
              }
            ],
            "name": "bring-forward",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BringForward20",
          "filepath": "bring-forward/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H10V12a2.0023 2.0023 0 012-2h3v2H12zM15 30H12a2.0023 2.0023 0 01-2-2V25h2v3h3zM18 28H22V30H18zM28 30H25V28h3V25h2v3A2.0023 2.0023 0 0128 30zM10 18H12V22H10zM28 18H30V22H28zM30 15H28V12H25V10h3a2.0023 2.0023 0 012 2zM18 10H22V12H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z"
                }
              }
            ],
            "name": "bring-forward",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BringForward16",
          "filepath": "bring-forward/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H10V12a2.0023 2.0023 0 012-2h3v2H12zM15 30H12a2.0023 2.0023 0 01-2-2V25h2v3h3zM18 28H22V30H18zM28 30H25V28h3V25h2v3A2.0023 2.0023 0 0128 30zM10 18H12V22H10zM28 18H30V22H28zM30 15H28V12H25V10h3a2.0023 2.0023 0 012 2zM18 10H22V12H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z"
                }
              }
            ],
            "name": "bring-forward",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BringForward",
        "global": "BringForward",
        "filepath": "BringForward.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 15H10V12a2.0023 2.0023 0 012-2h3v2H12zM15 30H12a2.0023 2.0023 0 01-2-2V25h2v3h3zM18 28H22V30H18zM28 30H25V28h3V25h2v3A2.0023 2.0023 0 0128 30zM10 18H12V22H10zM28 18H30V22H28zM30 15H28V12H25V10h3a2.0023 2.0023 0 012 2zM18 10H22V12H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bring-to-front",
      "friendlyName": "Bring to front",
      "aliases": [
        "bring",
        "front",
        "formatting",
        "group",
        "layer",
        "order",
        "arrange"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bring-to-front.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z\"/></svg>",
            "info": {},
            "path": "32/bring-to-front.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BringToFront32",
          "filepath": "bring-to-front/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z"
                }
              }
            ],
            "name": "bring-to-front",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BringToFront24",
          "filepath": "bring-to-front/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z"
                }
              }
            ],
            "name": "bring-to-front",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BringToFront20",
          "filepath": "bring-to-front/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z"
                }
              }
            ],
            "name": "bring-to-front",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BringToFront16",
          "filepath": "bring-to-front/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z"
                }
              }
            ],
            "name": "bring-to-front",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "BringToFront",
        "global": "BringToFront",
        "filepath": "BringToFront.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "brush-freehand",
      "friendlyName": "Brush freehand",
      "aliases": [
        "watson health",
        "watson",
        "health",
        "brush",
        "freehand"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/brush-freehand.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9669,4.9669,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z\"/>\n  <path d=\"M6.5,15A3.4994,3.4994,0,0,1,4.0249,9.026l3.5005-3.5a1.5019,1.5019,0,0,0,0-2.121,1.537,1.537,0,0,0-2.1216,0L3.415,5.3936,2,3.98,3.99,1.9915a3.5849,3.5849,0,0,1,4.95,0,3.5039,3.5039,0,0,1,0,4.949L5.439,10.44a1.5019,1.5019,0,0,0,0,2.121,1.5369,1.5369,0,0,0,2.1215,0l4.0249-4.0243L13,9.9507,8.9746,13.975A3.4754,3.4754,0,0,1,6.5,15Z\"/>\n  <rect id=\"_Transparent_Rectangle\" data-name=\" Transparent Rectangle\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM6.5 15A3.4994 3.4994 0 014.0249 9.026l3.5005-3.5a1.5019 1.5019 0 000-2.121 1.537 1.537 0 00-2.1216 0L3.415 5.3936 2 3.98 3.99 1.9915a3.5849 3.5849 0 014.95 0 3.5039 3.5039 0 010 4.949L5.439 10.44a1.5019 1.5019 0 000 2.121 1.5369 1.5369 0 002.1215 0l4.0249-4.0243L13 9.9507 8.9746 13.975A3.4754 3.4754 0 016.5 15z\"/></svg>",
            "info": {},
            "path": "32/watson-health/brush-freehand.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthBrushFreehand32",
          "filepath": "watson-health/brush-freehand/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM6.5 15A3.4994 3.4994 0 014.0249 9.026l3.5005-3.5a1.5019 1.5019 0 000-2.121 1.537 1.537 0 00-2.1216 0L3.415 5.3936 2 3.98 3.99 1.9915a3.5849 3.5849 0 014.95 0 3.5039 3.5039 0 010 4.949L5.439 10.44a1.5019 1.5019 0 000 2.121 1.5369 1.5369 0 002.1215 0l4.0249-4.0243L13 9.9507 8.9746 13.975A3.4754 3.4754 0 016.5 15z"
                }
              }
            ],
            "name": "brush-freehand",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthBrushFreehand24",
          "filepath": "watson-health/brush-freehand/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM6.5 15A3.4994 3.4994 0 014.0249 9.026l3.5005-3.5a1.5019 1.5019 0 000-2.121 1.537 1.537 0 00-2.1216 0L3.415 5.3936 2 3.98 3.99 1.9915a3.5849 3.5849 0 014.95 0 3.5039 3.5039 0 010 4.949L5.439 10.44a1.5019 1.5019 0 000 2.121 1.5369 1.5369 0 002.1215 0l4.0249-4.0243L13 9.9507 8.9746 13.975A3.4754 3.4754 0 016.5 15z"
                }
              }
            ],
            "name": "brush-freehand",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthBrushFreehand20",
          "filepath": "watson-health/brush-freehand/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM6.5 15A3.4994 3.4994 0 014.0249 9.026l3.5005-3.5a1.5019 1.5019 0 000-2.121 1.537 1.537 0 00-2.1216 0L3.415 5.3936 2 3.98 3.99 1.9915a3.5849 3.5849 0 014.95 0 3.5039 3.5039 0 010 4.949L5.439 10.44a1.5019 1.5019 0 000 2.121 1.5369 1.5369 0 002.1215 0l4.0249-4.0243L13 9.9507 8.9746 13.975A3.4754 3.4754 0 016.5 15z"
                }
              }
            ],
            "name": "brush-freehand",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthBrushFreehand16",
          "filepath": "watson-health/brush-freehand/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM6.5 15A3.4994 3.4994 0 014.0249 9.026l3.5005-3.5a1.5019 1.5019 0 000-2.121 1.537 1.537 0 00-2.1216 0L3.415 5.3936 2 3.98 3.99 1.9915a3.5849 3.5849 0 014.95 0 3.5039 3.5039 0 010 4.949L5.439 10.44a1.5019 1.5019 0 000 2.121 1.5369 1.5369 0 002.1215 0l4.0249-4.0243L13 9.9507 8.9746 13.975A3.4754 3.4754 0 016.5 15z"
                }
              }
            ],
            "name": "brush-freehand",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "BrushFreehand",
        "global": "WatsonHealthBrushFreehand",
        "filepath": "watson-health/BrushFreehand.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM6.5 15A3.4994 3.4994 0 014.0249 9.026l3.5005-3.5a1.5019 1.5019 0 000-2.121 1.537 1.537 0 00-2.1216 0L3.415 5.3936 2 3.98 3.99 1.9915a3.5849 3.5849 0 014.95 0 3.5039 3.5039 0 010 4.949L5.439 10.44a1.5019 1.5019 0 000 2.121 1.5369 1.5369 0 002.1215 0l4.0249-4.0243L13 9.9507 8.9746 13.975A3.4754 3.4754 0 016.5 15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "brush-polygon",
      "friendlyName": "Brush polygon",
      "aliases": [
        "watson health",
        "watson",
        "health",
        "brush",
        "polygon"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/brush-polygon.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9669,4.9669,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z\"/>\n  <path d=\"M14,2a2.9948,2.9948,0,0,0-2.8157,2H7.8157A2.9925,2.9925,0,1,0,4,7.8154v3.3687a3,3,0,1,0,2,0V7.8159A2.9959,2.9959,0,0,0,7.8157,6h3.3686A2.9947,2.9947,0,1,0,14,2ZM5,15a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,5,15ZM5,6A1,1,0,1,1,6,5,1.0008,1.0008,0,0,1,5,6Zm9,0a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,6Z\"/>\n  <rect id=\"_Transparent_Rectangle\" data-name=\" Transparent Rectangle\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM14 2a2.9948 2.9948 0 00-2.8157 2H7.8157A2.9925 2.9925 0 104 7.8154v3.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8157 6h3.3686A2.9947 2.9947 0 1014 2zM5 15a1 1 0 111-1A1.0008 1.0008 0 015 15zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zm9 0a1 1 0 111-1A1.0008 1.0008 0 0114 6z\"/></svg>",
            "info": {},
            "path": "32/watson-health/brush-polygon.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthBrushPolygon32",
          "filepath": "watson-health/brush-polygon/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM14 2a2.9948 2.9948 0 00-2.8157 2H7.8157A2.9925 2.9925 0 104 7.8154v3.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8157 6h3.3686A2.9947 2.9947 0 1014 2zM5 15a1 1 0 111-1A1.0008 1.0008 0 015 15zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zm9 0a1 1 0 111-1A1.0008 1.0008 0 0114 6z"
                }
              }
            ],
            "name": "brush-polygon",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthBrushPolygon24",
          "filepath": "watson-health/brush-polygon/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM14 2a2.9948 2.9948 0 00-2.8157 2H7.8157A2.9925 2.9925 0 104 7.8154v3.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8157 6h3.3686A2.9947 2.9947 0 1014 2zM5 15a1 1 0 111-1A1.0008 1.0008 0 015 15zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zm9 0a1 1 0 111-1A1.0008 1.0008 0 0114 6z"
                }
              }
            ],
            "name": "brush-polygon",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthBrushPolygon20",
          "filepath": "watson-health/brush-polygon/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM14 2a2.9948 2.9948 0 00-2.8157 2H7.8157A2.9925 2.9925 0 104 7.8154v3.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8157 6h3.3686A2.9947 2.9947 0 1014 2zM5 15a1 1 0 111-1A1.0008 1.0008 0 015 15zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zm9 0a1 1 0 111-1A1.0008 1.0008 0 0114 6z"
                }
              }
            ],
            "name": "brush-polygon",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthBrushPolygon16",
          "filepath": "watson-health/brush-polygon/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM14 2a2.9948 2.9948 0 00-2.8157 2H7.8157A2.9925 2.9925 0 104 7.8154v3.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8157 6h3.3686A2.9947 2.9947 0 1014 2zM5 15a1 1 0 111-1A1.0008 1.0008 0 015 15zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zm9 0a1 1 0 111-1A1.0008 1.0008 0 0114 6z"
                }
              }
            ],
            "name": "brush-polygon",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "BrushPolygon",
        "global": "WatsonHealthBrushPolygon",
        "filepath": "watson-health/BrushPolygon.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM14 2a2.9948 2.9948 0 00-2.8157 2H7.8157A2.9925 2.9925 0 104 7.8154v3.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8157 6h3.3686A2.9947 2.9947 0 1014 2zM5 15a1 1 0 111-1A1.0008 1.0008 0 015 15zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zm9 0a1 1 0 111-1A1.0008 1.0008 0 0114 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "build-tool",
      "friendlyName": "build-tool",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/build-tool.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5\n\tl-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4\n\tc1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5\tl-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4\tc1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z\"/></svg>",
            "info": {},
            "path": "32/build-tool.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BuildTool32",
          "filepath": "build-tool/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5\tl-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4\tc1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z"
                }
              }
            ],
            "name": "build-tool",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BuildTool24",
          "filepath": "build-tool/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5\tl-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4\tc1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z"
                }
              }
            ],
            "name": "build-tool",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BuildTool20",
          "filepath": "build-tool/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5\tl-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4\tc1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z"
                }
              }
            ],
            "name": "build-tool",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BuildTool16",
          "filepath": "build-tool/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5\tl-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4\tc1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z"
                }
              }
            ],
            "name": "build-tool",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "BuildTool",
        "global": "BuildTool",
        "filepath": "BuildTool.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5 l-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4 c1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "building",
      "friendlyName": "Building",
      "aliases": [
        "factory",
        "architecture",
        "office",
        "commerce",
        "highrise",
        "building"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/building.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>building</title><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><rect x=\"18\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"19.9996\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"19.9996\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><path d=\"M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z\"/></svg>",
            "info": {},
            "path": "32/building.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Building32",
          "filepath": "building/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z"
                }
              }
            ],
            "name": "building",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Building24",
          "filepath": "building/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z"
                }
              }
            ],
            "name": "building",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Building20",
          "filepath": "building/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z"
                }
              }
            ],
            "name": "building",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Building16",
          "filepath": "building/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z"
                }
              }
            ],
            "name": "building",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Building",
        "global": "Building",
        "filepath": "Building.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "building--insights-1",
      "friendlyName": "Building insights 1",
      "aliases": [
        "factory",
        "architecture",
        "office",
        "building",
        "building insights",
        "building insights 1",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/building--insights-1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>building--insights-1</title><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><rect x=\"18\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"19.9996\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"19.9996\" width=\"2\" height=\"2\"/><path d=\"M9,12H7a5.0059,5.0059,0,0,1,5-5V9A3.0033,3.0033,0,0,0,9,12Z\"/><path d=\"M4,12H2A10.0114,10.0114,0,0,1,12,2V4A8.0092,8.0092,0,0,0,4,12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><path d=\"M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM9 12H7a5.0059 5.0059 0 015-5V9A3.0033 3.0033 0 009 12zM4 12H2A10.0114 10.0114 0 0112 2V4A8.0092 8.0092 0 004 12z\"/></svg>",
            "info": {},
            "path": "32/building--insights-1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BuildingInsights_132",
          "filepath": "building--insights-1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM9 12H7a5.0059 5.0059 0 015-5V9A3.0033 3.0033 0 009 12zM4 12H2A10.0114 10.0114 0 0112 2V4A8.0092 8.0092 0 004 12z"
                }
              }
            ],
            "name": "building--insights-1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BuildingInsights_124",
          "filepath": "building--insights-1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM9 12H7a5.0059 5.0059 0 015-5V9A3.0033 3.0033 0 009 12zM4 12H2A10.0114 10.0114 0 0112 2V4A8.0092 8.0092 0 004 12z"
                }
              }
            ],
            "name": "building--insights-1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BuildingInsights_120",
          "filepath": "building--insights-1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM9 12H7a5.0059 5.0059 0 015-5V9A3.0033 3.0033 0 009 12zM4 12H2A10.0114 10.0114 0 0112 2V4A8.0092 8.0092 0 004 12z"
                }
              }
            ],
            "name": "building--insights-1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BuildingInsights_116",
          "filepath": "building--insights-1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM9 12H7a5.0059 5.0059 0 015-5V9A3.0033 3.0033 0 009 12zM4 12H2A10.0114 10.0114 0 0112 2V4A8.0092 8.0092 0 004 12z"
                }
              }
            ],
            "name": "building--insights-1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BuildingInsights_1",
        "global": "BuildingInsights_1",
        "filepath": "BuildingInsights_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM9 12H7a5.0059 5.0059 0 015-5V9A3.0033 3.0033 0 009 12zM4 12H2A10.0114 10.0114 0 0112 2V4A8.0092 8.0092 0 004 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "building--insights-2",
      "friendlyName": "Building insights 2",
      "aliases": [
        "factory",
        "architecture",
        "office",
        "building",
        "building insights",
        "building insights 2",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/building--insights-2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>building--insights-2</title><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><rect x=\"18\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"19.9996\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"19.9996\" width=\"2\" height=\"2\"/><path d=\"M5.5,12a3.5,3.5,0,0,1,0-7h.627A4.0062,4.0062,0,0,1,10,2h2V4L10,4A2.0023,2.0023,0,0,0,8,6V7H5.5a1.5,1.5,0,0,0,0,3H12v2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><path d=\"M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM5.5 12a3.5 3.5 0 010-7h.627A4.0062 4.0062 0 0110 2h2V4L10 4A2.0023 2.0023 0 008 6V7H5.5a1.5 1.5 0 000 3H12v2z\"/></svg>",
            "info": {},
            "path": "32/building--insights-2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BuildingInsights_232",
          "filepath": "building--insights-2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM5.5 12a3.5 3.5 0 010-7h.627A4.0062 4.0062 0 0110 2h2V4L10 4A2.0023 2.0023 0 008 6V7H5.5a1.5 1.5 0 000 3H12v2z"
                }
              }
            ],
            "name": "building--insights-2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BuildingInsights_224",
          "filepath": "building--insights-2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM5.5 12a3.5 3.5 0 010-7h.627A4.0062 4.0062 0 0110 2h2V4L10 4A2.0023 2.0023 0 008 6V7H5.5a1.5 1.5 0 000 3H12v2z"
                }
              }
            ],
            "name": "building--insights-2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BuildingInsights_220",
          "filepath": "building--insights-2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM5.5 12a3.5 3.5 0 010-7h.627A4.0062 4.0062 0 0110 2h2V4L10 4A2.0023 2.0023 0 008 6V7H5.5a1.5 1.5 0 000 3H12v2z"
                }
              }
            ],
            "name": "building--insights-2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BuildingInsights_216",
          "filepath": "building--insights-2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM5.5 12a3.5 3.5 0 010-7h.627A4.0062 4.0062 0 0110 2h2V4L10 4A2.0023 2.0023 0 008 6V7H5.5a1.5 1.5 0 000 3H12v2z"
                }
              }
            ],
            "name": "building--insights-2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BuildingInsights_2",
        "global": "BuildingInsights_2",
        "filepath": "BuildingInsights_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM5.5 12a3.5 3.5 0 010-7h.627A4.0062 4.0062 0 0110 2h2V4L10 4A2.0023 2.0023 0 008 6V7H5.5a1.5 1.5 0 000 3H12v2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "building--insights-3",
      "friendlyName": "Building insights 3",
      "aliases": [
        "factory",
        "architecture",
        "office",
        "building",
        "building insights",
        "building insights 3",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/building--insights-3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>building--insights-3</title><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><rect x=\"18\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"19.9996\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"19.9996\" width=\"2\" height=\"2\"/><rect x=\"2\" y=\"10.0002\" width=\"5\" height=\"1.9995\"/><rect x=\"10\" y=\"2\" width=\"2\" height=\"5\"/><rect x=\"5.5001\" y=\"3.9644\" width=\"1.9998\" height=\"5.0713\" transform=\"translate(-2.6924 6.5) rotate(-45)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z\"/><path d=\"M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM2 10H7V12H2zM10 2H12V7H10z\"/><path d=\"M5.5 3.964H7.5V9.035H5.5z\" transform=\"rotate(-45 6.5 6.5)\"/></svg>",
            "info": {},
            "path": "32/building--insights-3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "BuildingInsights_332",
          "filepath": "building--insights-3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM2 10H7V12H2zM10 2H12V7H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.5 3.964H7.5V9.035H5.5z",
                  "transform": "rotate(-45 6.5 6.5)"
                }
              }
            ],
            "name": "building--insights-3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "BuildingInsights_324",
          "filepath": "building--insights-3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM2 10H7V12H2zM10 2H12V7H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.5 3.964H7.5V9.035H5.5z",
                  "transform": "rotate(-45 6.5 6.5)"
                }
              }
            ],
            "name": "building--insights-3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "BuildingInsights_320",
          "filepath": "building--insights-3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM2 10H7V12H2zM10 2H12V7H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.5 3.964H7.5V9.035H5.5z",
                  "transform": "rotate(-45 6.5 6.5)"
                }
              }
            ],
            "name": "building--insights-3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "BuildingInsights_316",
          "filepath": "building--insights-3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM2 10H7V12H2zM10 2H12V7H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.5 3.964H7.5V9.035H5.5z",
                  "transform": "rotate(-45 6.5 6.5)"
                }
              }
            ],
            "name": "building--insights-3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "BuildingInsights_3",
        "global": "BuildingInsights_3",
        "filepath": "BuildingInsights_3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM2 10H7V12H2zM10 2H12V7H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.5 3.964H7.5V9.035H5.5z",
                    "transform": "rotate(-45 6.5 6.5)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bullhorn",
      "friendlyName": "Bullhorn",
      "aliases": [
        "announcement",
        "announce",
        "broadcast",
        "news",
        "release",
        "notify",
        "decare",
        "blast",
        "speaker",
        "bullhorn",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bullhorn.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>bullhorn</title><path class=\"cls-1\" d=\"M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z\"/></svg>",
            "info": {},
            "path": "32/bullhorn.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bullhorn32",
          "filepath": "bullhorn/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z"
                }
              }
            ],
            "name": "bullhorn",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bullhorn24",
          "filepath": "bullhorn/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z"
                }
              }
            ],
            "name": "bullhorn",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bullhorn20",
          "filepath": "bullhorn/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z"
                }
              }
            ],
            "name": "bullhorn",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bullhorn16",
          "filepath": "bullhorn/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z"
                }
              }
            ],
            "name": "bullhorn",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Bullhorn",
        "global": "Bullhorn",
        "filepath": "Bullhorn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "buoy",
      "friendlyName": "Buoy",
      "aliases": [
        "weather",
        "buoy",
        "forecast",
        "marker"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/buoy.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z\"/><path d=\"M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z\"/></svg>",
            "info": {},
            "path": "32/buoy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Buoy32",
          "filepath": "buoy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z"
                }
              }
            ],
            "name": "buoy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Buoy24",
          "filepath": "buoy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z"
                }
              }
            ],
            "name": "buoy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Buoy20",
          "filepath": "buoy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z"
                }
              }
            ],
            "name": "buoy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Buoy16",
          "filepath": "buoy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z"
                }
              }
            ],
            "name": "buoy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Buoy",
        "global": "Buoy",
        "filepath": "Buoy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "bus",
      "friendlyName": "Bus",
      "aliases": [
        "transport",
        "transportation",
        "travel",
        "public",
        "bus"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/bus.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bus</title><rect x=\"27\" y=\"11\" width=\"2\" height=\"4\"/><rect x=\"3\" y=\"11\" width=\"2\" height=\"4\"/><rect x=\"20\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"20\" width=\"2\" height=\"2\"/><path d=\"M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 11H29V15H27zM3 11H5V15H3zM20 20H22V22H20zM10 20H12V22H10z\"/><path d=\"M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z\"/></svg>",
            "info": {},
            "path": "32/bus.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Bus32",
          "filepath": "bus/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V15H27zM3 11H5V15H3zM20 20H22V22H20zM10 20H12V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z"
                }
              }
            ],
            "name": "bus",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Bus24",
          "filepath": "bus/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V15H27zM3 11H5V15H3zM20 20H22V22H20zM10 20H12V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z"
                }
              }
            ],
            "name": "bus",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Bus20",
          "filepath": "bus/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V15H27zM3 11H5V15H3zM20 20H22V22H20zM10 20H12V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z"
                }
              }
            ],
            "name": "bus",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Bus16",
          "filepath": "bus/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V15H27zM3 11H5V15H3zM20 20H22V22H20zM10 20H12V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z"
                }
              }
            ],
            "name": "bus",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Bus",
        "global": "Bus",
        "filepath": "Bus.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 11H29V15H27zM3 11H5V15H3zM20 20H22V22H20zM10 20H12V22H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "button--centered",
      "friendlyName": "Button centered",
      "aliases": [
        "formatting",
        "button",
        "centered"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/button--centered.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"9\" y=\"15\" width=\"14\" height=\"2\"/>\n  <path d=\"M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9 15H23V17H9z\"/><path d=\"M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z\"/></svg>",
            "info": {},
            "path": "32/button--centered.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ButtonCentered32",
          "filepath": "button--centered/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 15H23V17H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z"
                }
              }
            ],
            "name": "button--centered",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ButtonCentered24",
          "filepath": "button--centered/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 15H23V17H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z"
                }
              }
            ],
            "name": "button--centered",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ButtonCentered20",
          "filepath": "button--centered/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 15H23V17H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z"
                }
              }
            ],
            "name": "button--centered",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ButtonCentered16",
          "filepath": "button--centered/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 15H23V17H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z"
                }
              }
            ],
            "name": "button--centered",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ButtonCentered",
        "global": "ButtonCentered",
        "filepath": "ButtonCentered.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 15H23V17H9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "button--flush-left",
      "friendlyName": "Button flush-left",
      "aliases": [
        "formatting",
        "button",
        "flush-left"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/button--flush-left.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"6\" y=\"15\" width=\"14\" height=\"2\"/>\n<path d=\"M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8\n\tH4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 15H20V17H6z\"/><path d=\"M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8\tH4z\"/></svg>",
            "info": {},
            "path": "32/button--flush-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ButtonFlushLeft32",
          "filepath": "button--flush-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8\tH4z"
                }
              }
            ],
            "name": "button--flush-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ButtonFlushLeft24",
          "filepath": "button--flush-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8\tH4z"
                }
              }
            ],
            "name": "button--flush-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ButtonFlushLeft20",
          "filepath": "button--flush-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8\tH4z"
                }
              }
            ],
            "name": "button--flush-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ButtonFlushLeft16",
          "filepath": "button--flush-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8\tH4z"
                }
              }
            ],
            "name": "button--flush-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ButtonFlushLeft",
        "global": "ButtonFlushLeft",
        "filepath": "ButtonFlushLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 15H20V17H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8 H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cabin-care",
      "friendlyName": "Cabin care",
      "aliases": [
        "cabin",
        "care",
        "transportation",
        "airline",
        "flight",
        "customer service",
        "attendant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cabin-care.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27.3022,2a2.6617,2.6617,0,0,0-1.9079.8059l-.3931.4053-.397-.4053a2.6613,2.6613,0,0,0-3.8158,0,2.7992,2.7992,0,0,0,0,3.8963L25.0012,11,29.21,6.7022a2.7992,2.7992,0,0,0,0-3.8963A2.6613,2.6613,0,0,0,27.3022,2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1214,4.1214,0,0,0,23.8218,18ZM24,24H10.4776L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.3022 2a2.6617 2.6617 0 00-1.9079.8059l-.3931.4053-.397-.4053a2.6613 2.6613 0 00-3.8158 0 2.7992 2.7992 0 000 3.8963L25.0012 11 29.21 6.7022a2.7992 2.7992 0 000-3.8963A2.6613 2.6613 0 0027.3022 2zM23.8218 18H15.083L11.8643 5.9653a4 4 0 00-7.7276 2.07L8.5454 24.5168A2 2 0 0010.4775 26H19v2H4v2H19a2 2 0 002-2V26h3a4.0046 4.0046 0 003.98-4.4A4.1214 4.1214 0 0023.8218 18zM24 24H10.4776L6.0686 7.5181A2 2 0 119.9324 6.4829L13.5466 20H24a2 2 0 010 4z\"/></svg>",
            "info": {},
            "path": "32/cabin-care.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CabinCare32",
          "filepath": "cabin-care/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3022 2a2.6617 2.6617 0 00-1.9079.8059l-.3931.4053-.397-.4053a2.6613 2.6613 0 00-3.8158 0 2.7992 2.7992 0 000 3.8963L25.0012 11 29.21 6.7022a2.7992 2.7992 0 000-3.8963A2.6613 2.6613 0 0027.3022 2zM23.8218 18H15.083L11.8643 5.9653a4 4 0 00-7.7276 2.07L8.5454 24.5168A2 2 0 0010.4775 26H19v2H4v2H19a2 2 0 002-2V26h3a4.0046 4.0046 0 003.98-4.4A4.1214 4.1214 0 0023.8218 18zM24 24H10.4776L6.0686 7.5181A2 2 0 119.9324 6.4829L13.5466 20H24a2 2 0 010 4z"
                }
              }
            ],
            "name": "cabin-care",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CabinCare24",
          "filepath": "cabin-care/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3022 2a2.6617 2.6617 0 00-1.9079.8059l-.3931.4053-.397-.4053a2.6613 2.6613 0 00-3.8158 0 2.7992 2.7992 0 000 3.8963L25.0012 11 29.21 6.7022a2.7992 2.7992 0 000-3.8963A2.6613 2.6613 0 0027.3022 2zM23.8218 18H15.083L11.8643 5.9653a4 4 0 00-7.7276 2.07L8.5454 24.5168A2 2 0 0010.4775 26H19v2H4v2H19a2 2 0 002-2V26h3a4.0046 4.0046 0 003.98-4.4A4.1214 4.1214 0 0023.8218 18zM24 24H10.4776L6.0686 7.5181A2 2 0 119.9324 6.4829L13.5466 20H24a2 2 0 010 4z"
                }
              }
            ],
            "name": "cabin-care",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CabinCare20",
          "filepath": "cabin-care/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3022 2a2.6617 2.6617 0 00-1.9079.8059l-.3931.4053-.397-.4053a2.6613 2.6613 0 00-3.8158 0 2.7992 2.7992 0 000 3.8963L25.0012 11 29.21 6.7022a2.7992 2.7992 0 000-3.8963A2.6613 2.6613 0 0027.3022 2zM23.8218 18H15.083L11.8643 5.9653a4 4 0 00-7.7276 2.07L8.5454 24.5168A2 2 0 0010.4775 26H19v2H4v2H19a2 2 0 002-2V26h3a4.0046 4.0046 0 003.98-4.4A4.1214 4.1214 0 0023.8218 18zM24 24H10.4776L6.0686 7.5181A2 2 0 119.9324 6.4829L13.5466 20H24a2 2 0 010 4z"
                }
              }
            ],
            "name": "cabin-care",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CabinCare16",
          "filepath": "cabin-care/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3022 2a2.6617 2.6617 0 00-1.9079.8059l-.3931.4053-.397-.4053a2.6613 2.6613 0 00-3.8158 0 2.7992 2.7992 0 000 3.8963L25.0012 11 29.21 6.7022a2.7992 2.7992 0 000-3.8963A2.6613 2.6613 0 0027.3022 2zM23.8218 18H15.083L11.8643 5.9653a4 4 0 00-7.7276 2.07L8.5454 24.5168A2 2 0 0010.4775 26H19v2H4v2H19a2 2 0 002-2V26h3a4.0046 4.0046 0 003.98-4.4A4.1214 4.1214 0 0023.8218 18zM24 24H10.4776L6.0686 7.5181A2 2 0 119.9324 6.4829L13.5466 20H24a2 2 0 010 4z"
                }
              }
            ],
            "name": "cabin-care",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "CabinCare",
        "global": "CabinCare",
        "filepath": "CabinCare.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.3022 2a2.6617 2.6617 0 00-1.9079.8059l-.3931.4053-.397-.4053a2.6613 2.6613 0 00-3.8158 0 2.7992 2.7992 0 000 3.8963L25.0012 11 29.21 6.7022a2.7992 2.7992 0 000-3.8963A2.6613 2.6613 0 0027.3022 2zM23.8218 18H15.083L11.8643 5.9653a4 4 0 00-7.7276 2.07L8.5454 24.5168A2 2 0 0010.4775 26H19v2H4v2H19a2 2 0 002-2V26h3a4.0046 4.0046 0 003.98-4.4A4.1214 4.1214 0 0023.8218 18zM24 24H10.4776L6.0686 7.5181A2 2 0 119.9324 6.4829L13.5466 20H24a2 2 0 010 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cabin-care--alert",
      "friendlyName": "Cabin care alert",
      "aliases": [
        "cabin",
        "care",
        "transportation",
        "airline",
        "flight",
        "customer service",
        "alert",
        "call button",
        "attendant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cabin-care--alert.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"24\" y=\"2\" width=\"2\" height=\"7\"/>\n  <rect x=\"23.5\" y=\"11\" width=\"3\" height=\"3\" rx=\"1.5\"/>\n  <path d=\"M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 2H26V9H24z\"/><rect width=\"3\" height=\"3\" x=\"23.5\" y=\"11\" rx=\"1.5\"/><path d=\"M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z\"/></svg>",
            "info": {},
            "path": "32/cabin-care--alert.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CabinCareAlert32",
          "filepath": "cabin-care--alert/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "3",
                  "height": "3",
                  "x": "23.5",
                  "y": "11",
                  "rx": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
                }
              }
            ],
            "name": "cabin-care--alert",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CabinCareAlert24",
          "filepath": "cabin-care--alert/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "3",
                  "height": "3",
                  "x": "23.5",
                  "y": "11",
                  "rx": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
                }
              }
            ],
            "name": "cabin-care--alert",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CabinCareAlert20",
          "filepath": "cabin-care--alert/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "3",
                  "height": "3",
                  "x": "23.5",
                  "y": "11",
                  "rx": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
                }
              }
            ],
            "name": "cabin-care--alert",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CabinCareAlert16",
          "filepath": "cabin-care--alert/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H26V9H24z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "3",
                  "height": "3",
                  "x": "23.5",
                  "y": "11",
                  "rx": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
                }
              }
            ],
            "name": "cabin-care--alert",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "CabinCareAlert",
        "global": "CabinCareAlert",
        "filepath": "CabinCareAlert.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 2H26V9H24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "rect",
                  "attributes": {
                    "width": "3",
                    "height": "3",
                    "x": "23.5",
                    "y": "11",
                    "rx": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cabin-care--alt",
      "friendlyName": "Cabin care alt",
      "aliases": [
        "cabin",
        "care",
        "transportation",
        "airline",
        "flight",
        "customer service",
        "attendant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cabin-care--alt.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156,3.8017,14.2568A2.0037,2.0037,0,0,0,20.77,25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658,8.7422l-1.9316.5156L4.8359,23.5146A2.0037,2.0037,0,0,0,6.77,25H8v3H2v2H30V28H24V25Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M27.303,2a2.6613,2.6613,0,0,0-1.9079.8059L25,3.2112l-.3951-.4053a2.6612,2.6612,0,0,0-3.8157,0,2.7991,2.7991,0,0,0,0,3.8963L25,11l4.2108-4.2978a2.7991,2.7991,0,0,0,0-3.8963A2.6613,2.6613,0,0,0,27.303,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156 3.8017 14.2568A2.0037 2.0037 0 0020.77 25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658 8.7422l-1.9316.5156L4.8359 23.5146A2.0037 2.0037 0 006.77 25H8v3H2v2H30V28H24V25zM27.303 2a2.6613 2.6613 0 00-1.9079.8059L25 3.2112l-.3951-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25 11l4.2108-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2z\"/></svg>",
            "info": {},
            "path": "32/cabin-care--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CabinCareAlt32",
          "filepath": "cabin-care--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156 3.8017 14.2568A2.0037 2.0037 0 0020.77 25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658 8.7422l-1.9316.5156L4.8359 23.5146A2.0037 2.0037 0 006.77 25H8v3H2v2H30V28H24V25zM27.303 2a2.6613 2.6613 0 00-1.9079.8059L25 3.2112l-.3951-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25 11l4.2108-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2z"
                }
              }
            ],
            "name": "cabin-care--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CabinCareAlt24",
          "filepath": "cabin-care--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156 3.8017 14.2568A2.0037 2.0037 0 0020.77 25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658 8.7422l-1.9316.5156L4.8359 23.5146A2.0037 2.0037 0 006.77 25H8v3H2v2H30V28H24V25zM27.303 2a2.6613 2.6613 0 00-1.9079.8059L25 3.2112l-.3951-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25 11l4.2108-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2z"
                }
              }
            ],
            "name": "cabin-care--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CabinCareAlt20",
          "filepath": "cabin-care--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156 3.8017 14.2568A2.0037 2.0037 0 0020.77 25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658 8.7422l-1.9316.5156L4.8359 23.5146A2.0037 2.0037 0 006.77 25H8v3H2v2H30V28H24V25zM27.303 2a2.6613 2.6613 0 00-1.9079.8059L25 3.2112l-.3951-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25 11l4.2108-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2z"
                }
              }
            ],
            "name": "cabin-care--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CabinCareAlt16",
          "filepath": "cabin-care--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156 3.8017 14.2568A2.0037 2.0037 0 0020.77 25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658 8.7422l-1.9316.5156L4.8359 23.5146A2.0037 2.0037 0 006.77 25H8v3H2v2H30V28H24V25zM27.303 2a2.6613 2.6613 0 00-1.9079.8059L25 3.2112l-.3951-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25 11l4.2108-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2z"
                }
              }
            ],
            "name": "cabin-care--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "CabinCareAlt",
        "global": "CabinCareAlt",
        "filepath": "CabinCareAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156 3.8017 14.2568A2.0037 2.0037 0 0020.77 25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658 8.7422l-1.9316.5156L4.8359 23.5146A2.0037 2.0037 0 006.77 25H8v3H2v2H30V28H24V25zM27.303 2a2.6613 2.6613 0 00-1.9079.8059L25 3.2112l-.3951-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25 11l4.2108-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "CAD",
      "friendlyName": "CAD",
      "aliases": [
        "computer aided design",
        "CAD",
        "canada",
        "canadian dollar",
        "dollar",
        "money",
        "design",
        "print",
        "file",
        "file type"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/CAD.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>CAD</title><path d=\"M18,9H14a2,2,0,0,0-2,2V23h2V18h4v5h2V11A2,2,0,0,0,18,9Zm-4,7V11h4v5Z\"/><path d=\"M26,23H22V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,26,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H24Z\"/><path d=\"M10,23H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9h6v2H4V21h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM26 23H22V9h4a4 4 0 014 4v6A4 4 0 0126 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H24zM10 23H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4V21h6z\"/></svg>",
            "info": {},
            "path": "32/CAD.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cad32",
          "filepath": "CAD/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM26 23H22V9h4a4 4 0 014 4v6A4 4 0 0126 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H24zM10 23H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CAD",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cad24",
          "filepath": "CAD/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM26 23H22V9h4a4 4 0 014 4v6A4 4 0 0126 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H24zM10 23H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CAD",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cad20",
          "filepath": "CAD/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM26 23H22V9h4a4 4 0 014 4v6A4 4 0 0126 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H24zM10 23H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CAD",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cad16",
          "filepath": "CAD/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM26 23H22V9h4a4 4 0 014 4v6A4 4 0 0126 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H24zM10 23H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CAD",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Cad",
        "global": "Cad",
        "filepath": "Cad.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM26 23H22V9h4a4 4 0 014 4v6A4 4 0 0126 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H24zM10 23H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4V21h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cafe",
      "friendlyName": "Cafe",
      "aliases": [
        "coffee",
        "caffine",
        "drink",
        "espresso",
        "brew",
        "mocha",
        "travel",
        "coffee shop",
        "cafe"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cafe.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>coffee</title><rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/><path d=\"M24.5,11H8a2.002,2.002,0,0,0-2,2v8a5.0059,5.0059,0,0,0,5,5h8a5.0059,5.0059,0,0,0,5-5V20h.5a4.5,4.5,0,0,0,0-9ZM22,21a3.0033,3.0033,0,0,1-3,3H11a3.0033,3.0033,0,0,1-3-3V13H22Zm2.5-3H24V13h.5a2.5,2.5,0,0,1,0,5Z\" transform=\"translate(0 0)\"/><path d=\"M19,9H17V8.854a1.9883,1.9883,0,0,0-1.1055-1.7886L13.2109,5.7236A3.9788,3.9788,0,0,1,11,2.146V1h2V2.146a1.9892,1.9892,0,0,0,1.1055,1.7886l2.6836,1.3418A3.9792,3.9792,0,0,1,19,8.854Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM24.5 11H8a2.002 2.002 0 00-2 2v8a5.0059 5.0059 0 005 5h8a5.0059 5.0059 0 005-5V20h.5a4.5 4.5 0 000-9zM22 21a3.0033 3.0033 0 01-3 3H11a3.0033 3.0033 0 01-3-3V13H22zm2.5-3H24V13h.5a2.5 2.5 0 010 5zM19 9H17V8.854a1.9883 1.9883 0 00-1.1055-1.7886L13.2109 5.7236A3.9788 3.9788 0 0111 2.146V1h2V2.146a1.9892 1.9892 0 001.1055 1.7886l2.6836 1.3418A3.9792 3.9792 0 0119 8.854z\"/></svg>",
            "info": {},
            "path": "32/cafe.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cafe32",
          "filepath": "cafe/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24.5 11H8a2.002 2.002 0 00-2 2v8a5.0059 5.0059 0 005 5h8a5.0059 5.0059 0 005-5V20h.5a4.5 4.5 0 000-9zM22 21a3.0033 3.0033 0 01-3 3H11a3.0033 3.0033 0 01-3-3V13H22zm2.5-3H24V13h.5a2.5 2.5 0 010 5zM19 9H17V8.854a1.9883 1.9883 0 00-1.1055-1.7886L13.2109 5.7236A3.9788 3.9788 0 0111 2.146V1h2V2.146a1.9892 1.9892 0 001.1055 1.7886l2.6836 1.3418A3.9792 3.9792 0 0119 8.854z"
                }
              }
            ],
            "name": "cafe",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cafe24",
          "filepath": "cafe/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24.5 11H8a2.002 2.002 0 00-2 2v8a5.0059 5.0059 0 005 5h8a5.0059 5.0059 0 005-5V20h.5a4.5 4.5 0 000-9zM22 21a3.0033 3.0033 0 01-3 3H11a3.0033 3.0033 0 01-3-3V13H22zm2.5-3H24V13h.5a2.5 2.5 0 010 5zM19 9H17V8.854a1.9883 1.9883 0 00-1.1055-1.7886L13.2109 5.7236A3.9788 3.9788 0 0111 2.146V1h2V2.146a1.9892 1.9892 0 001.1055 1.7886l2.6836 1.3418A3.9792 3.9792 0 0119 8.854z"
                }
              }
            ],
            "name": "cafe",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cafe20",
          "filepath": "cafe/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24.5 11H8a2.002 2.002 0 00-2 2v8a5.0059 5.0059 0 005 5h8a5.0059 5.0059 0 005-5V20h.5a4.5 4.5 0 000-9zM22 21a3.0033 3.0033 0 01-3 3H11a3.0033 3.0033 0 01-3-3V13H22zm2.5-3H24V13h.5a2.5 2.5 0 010 5zM19 9H17V8.854a1.9883 1.9883 0 00-1.1055-1.7886L13.2109 5.7236A3.9788 3.9788 0 0111 2.146V1h2V2.146a1.9892 1.9892 0 001.1055 1.7886l2.6836 1.3418A3.9792 3.9792 0 0119 8.854z"
                }
              }
            ],
            "name": "cafe",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cafe16",
          "filepath": "cafe/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24.5 11H8a2.002 2.002 0 00-2 2v8a5.0059 5.0059 0 005 5h8a5.0059 5.0059 0 005-5V20h.5a4.5 4.5 0 000-9zM22 21a3.0033 3.0033 0 01-3 3H11a3.0033 3.0033 0 01-3-3V13H22zm2.5-3H24V13h.5a2.5 2.5 0 010 5zM19 9H17V8.854a1.9883 1.9883 0 00-1.1055-1.7886L13.2109 5.7236A3.9788 3.9788 0 0111 2.146V1h2V2.146a1.9892 1.9892 0 001.1055 1.7886l2.6836 1.3418A3.9792 3.9792 0 0119 8.854z"
                }
              }
            ],
            "name": "cafe",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Cafe",
        "global": "Cafe",
        "filepath": "Cafe.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM24.5 11H8a2.002 2.002 0 00-2 2v8a5.0059 5.0059 0 005 5h8a5.0059 5.0059 0 005-5V20h.5a4.5 4.5 0 000-9zM22 21a3.0033 3.0033 0 01-3 3H11a3.0033 3.0033 0 01-3-3V13H22zm2.5-3H24V13h.5a2.5 2.5 0 010 5zM19 9H17V8.854a1.9883 1.9883 0 00-1.1055-1.7886L13.2109 5.7236A3.9788 3.9788 0 0111 2.146V1h2V2.146a1.9892 1.9892 0 001.1055 1.7886l2.6836 1.3418A3.9792 3.9792 0 0119 8.854z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calculation",
      "friendlyName": "Calculation",
      "aliases": [
        "data",
        "calculation",
        "math",
        "functions"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calculation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 8 10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8\"/>\n  <rect x=\"4\" y=\"19\" width=\"10\" height=\"2\"/>\n  <rect x=\"4\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"18\" y=\"8\" width=\"10\" height=\"2\"/>\n  <polygon points=\"24.41 22 28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8zM4 19H14V21H4zM4 24H14V26H4zM18 8H28V10H18zM24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z\"/></svg>",
            "info": {},
            "path": "32/calculation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Calculation32",
          "filepath": "calculation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8zM4 19H14V21H4zM4 24H14V26H4zM18 8H28V10H18zM24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z"
                }
              }
            ],
            "name": "calculation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Calculation24",
          "filepath": "calculation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8zM4 19H14V21H4zM4 24H14V26H4zM18 8H28V10H18zM24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z"
                }
              }
            ],
            "name": "calculation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Calculation20",
          "filepath": "calculation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8zM4 19H14V21H4zM4 24H14V26H4zM18 8H28V10H18zM24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z"
                }
              }
            ],
            "name": "calculation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Calculation16",
          "filepath": "calculation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8zM4 19H14V21H4zM4 24H14V26H4zM18 8H28V10H18zM24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z"
                }
              }
            ],
            "name": "calculation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Calculation",
        "global": "Calculation",
        "filepath": "Calculation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8zM4 19H14V21H4zM4 24H14V26H4zM18 8H28V10H18zM24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calculation--alt",
      "friendlyName": "Calculation--alt",
      "aliases": [
        "data",
        "calculation",
        "math",
        "functions"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calculation--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"19\" y=\"13\" width=\"6\" height=\"2\"/>\n  <polygon points=\"13 21 11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21\"/>\n  <rect x=\"7\" y=\"9\" width=\"6\" height=\"2\"/>\n  <rect x=\"19\" y=\"17\" width=\"6\" height=\"2\"/>\n  <path d=\"M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 13H25V15H19zM13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21zM7 9H13V11H7zM19 17H25V19H19z\"/><path d=\"M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z\"/></svg>",
            "info": {},
            "path": "32/calculation--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CalculationAlt32",
          "filepath": "calculation--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H25V15H19zM13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21zM7 9H13V11H7zM19 17H25V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z"
                }
              }
            ],
            "name": "calculation--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CalculationAlt24",
          "filepath": "calculation--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H25V15H19zM13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21zM7 9H13V11H7zM19 17H25V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z"
                }
              }
            ],
            "name": "calculation--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CalculationAlt20",
          "filepath": "calculation--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H25V15H19zM13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21zM7 9H13V11H7zM19 17H25V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z"
                }
              }
            ],
            "name": "calculation--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CalculationAlt16",
          "filepath": "calculation--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H25V15H19zM13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21zM7 9H13V11H7zM19 17H25V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z"
                }
              }
            ],
            "name": "calculation--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "CalculationAlt",
        "global": "CalculationAlt",
        "filepath": "CalculationAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 13H25V15H19zM13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21zM7 9H13V11H7zM19 17H25V19H19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calculator",
      "friendlyName": "Calculator",
      "aliases": [
        "calculate",
        "PDA",
        "computer",
        "technology",
        "calculator",
        "adding machine",
        "add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calculator.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>calculator</title><path d=\"M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z\"/><rect x=\"9\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"21\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"21\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"13\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"13\" width=\"2\" height=\"2\"/><rect x=\"21\" y=\"13\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"7\" width=\"14\" height=\"3\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z\"/><path d=\"M9 23H11V25H9zM21 23H23V25H21zM9 18H11V20H9zM21 18H23V20H21zM9 13H11V15H9zM15 23H17V25H15zM15 18H17V20H15zM15 13H17V15H15zM21 13H23V15H21zM9 7H23V10H9z\"/></svg>",
            "info": {},
            "path": "32/calculator.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Calculator32",
          "filepath": "calculator/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 23H11V25H9zM21 23H23V25H21zM9 18H11V20H9zM21 18H23V20H21zM9 13H11V15H9zM15 23H17V25H15zM15 18H17V20H15zM15 13H17V15H15zM21 13H23V15H21zM9 7H23V10H9z"
                }
              }
            ],
            "name": "calculator",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Calculator24",
          "filepath": "calculator/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 23H11V25H9zM21 23H23V25H21zM9 18H11V20H9zM21 18H23V20H21zM9 13H11V15H9zM15 23H17V25H15zM15 18H17V20H15zM15 13H17V15H15zM21 13H23V15H21zM9 7H23V10H9z"
                }
              }
            ],
            "name": "calculator",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Calculator20",
          "filepath": "calculator/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 23H11V25H9zM21 23H23V25H21zM9 18H11V20H9zM21 18H23V20H21zM9 13H11V15H9zM15 23H17V25H15zM15 18H17V20H15zM15 13H17V15H15zM21 13H23V15H21zM9 7H23V10H9z"
                }
              }
            ],
            "name": "calculator",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Calculator16",
          "filepath": "calculator/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 23H11V25H9zM21 23H23V25H21zM9 18H11V20H9zM21 18H23V20H21zM9 13H11V15H9zM15 23H17V25H15zM15 18H17V20H15zM15 13H17V15H15zM21 13H23V15H21zM9 7H23V10H9z"
                }
              }
            ],
            "name": "calculator",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Calculator",
        "global": "Calculator",
        "filepath": "Calculator.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 23H11V25H9zM21 23H23V25H21zM9 18H11V20H9zM21 18H23V20H21zM9 13H11V15H9zM15 23H17V25H15zM15 18H17V20H15zM15 13H17V15H15zM21 13H23V15H21zM9 7H23V10H9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calculator--check",
      "friendlyName": "Calculator check",
      "aliases": [
        "calculate",
        "PDA",
        "computer",
        "technology",
        "calculator",
        "calculator check",
        "adding machine",
        "add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calculator--check.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>calculator--check</title><polygon points=\"24 26.59 21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59\"/><rect x=\"15\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"21\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"21\" y=\"13\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"13\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"13\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"7\" width=\"14\" height=\"3\"/><path d=\"M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59zM15 23H17V25H15zM9 23H11V25H9zM21 18H23V20H21zM15 18H17V20H15zM9 18H11V20H9zM21 13H23V15H21zM15 13H17V15H15zM9 13H11V15H9zM9 7H23V10H9z\"/><path d=\"M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z\"/></svg>",
            "info": {},
            "path": "32/calculator--check.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CalculatorCheck32",
          "filepath": "calculator--check/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59zM15 23H17V25H15zM9 23H11V25H9zM21 18H23V20H21zM15 18H17V20H15zM9 18H11V20H9zM21 13H23V15H21zM15 13H17V15H15zM9 13H11V15H9zM9 7H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z"
                }
              }
            ],
            "name": "calculator--check",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CalculatorCheck24",
          "filepath": "calculator--check/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59zM15 23H17V25H15zM9 23H11V25H9zM21 18H23V20H21zM15 18H17V20H15zM9 18H11V20H9zM21 13H23V15H21zM15 13H17V15H15zM9 13H11V15H9zM9 7H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z"
                }
              }
            ],
            "name": "calculator--check",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CalculatorCheck20",
          "filepath": "calculator--check/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59zM15 23H17V25H15zM9 23H11V25H9zM21 18H23V20H21zM15 18H17V20H15zM9 18H11V20H9zM21 13H23V15H21zM15 13H17V15H15zM9 13H11V15H9zM9 7H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z"
                }
              }
            ],
            "name": "calculator--check",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CalculatorCheck16",
          "filepath": "calculator--check/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59zM15 23H17V25H15zM9 23H11V25H9zM21 18H23V20H21zM15 18H17V20H15zM9 18H11V20H9zM21 13H23V15H21zM15 13H17V15H15zM9 13H11V15H9zM9 7H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z"
                }
              }
            ],
            "name": "calculator--check",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CalculatorCheck",
        "global": "CalculatorCheck",
        "filepath": "CalculatorCheck.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59zM15 23H17V25H15zM9 23H11V25H9zM21 18H23V20H21zM15 18H17V20H15zM9 18H11V20H9zM21 13H23V15H21zM15 13H17V15H15zM9 13H11V15H9zM9 7H23V10H9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calendar",
      "friendlyName": "Calendar",
      "aliases": [
        "date",
        "schedule",
        "day",
        "time",
        "month",
        "year",
        "scheduler",
        "agenda",
        "docket",
        "timetable"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calendar.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>calendar</title>\n<path d=\"M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20\n\tV26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20\tV26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z\"/></svg>",
            "info": {},
            "path": "32/calendar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Calendar32",
          "filepath": "calendar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20\tV26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"
                }
              }
            ],
            "name": "calendar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Calendar24",
          "filepath": "calendar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20\tV26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"
                }
              }
            ],
            "name": "calendar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Calendar20",
          "filepath": "calendar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20\tV26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"
                }
              }
            ],
            "name": "calendar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Calendar16",
          "filepath": "calendar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20\tV26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"
                }
              }
            ],
            "name": "calendar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Calendar",
        "global": "Calendar",
        "filepath": "Calendar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20 V26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calendar--add",
      "friendlyName": "Calendar add",
      "aliases": [
        "date",
        "schedule",
        "day",
        "time",
        "month",
        "year",
        "scheduler",
        "agenda",
        "docket",
        "timetable",
        "add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calendar--add.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<polygon points=\"30,22 24,22 24,16 22,16 22,22 16,22 16,24 22,24 22,30 24,30 24,24 30,24 \t\t\"/>\n\t\t<path d=\"M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYVJkErvyFnAwqsNhQCm1AhxN98quMDxxL1wnE461trWYzkyK7e2dpirmsIOg/6HCzswMO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\n\t]]>\n\t<![CDATA[\n\tEjS4MMECDhwcLAjAsGCDCRQoMAwMIFigUEERgHGBhQoNlfO4gEKFCRtYkICBB8kAhAMHh5HysIAC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\n\t]]>\n\t<![CDATA[\n\tk3Znchx4I6PeL7P3WDm0HJgziBbKOv8bPPGNUmXv/2iO1qL5fihXoyh3aJh/Yg3WTaLh9Wqka3YF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\n\t]]>\n\t<![CDATA[\n\tsZKw7GjDOtY2ipRXd0SUWpWcULJG8fMqSazhz8sSbW4rCyWxzStEq6LK5pQt8zXSDsn2wZpk+jf7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\n\t]]>\n\t<![CDATA[\n\t3RZMdA9aPpfJ3Ee8P+cT8S2OpnZV4XJWIme/DFRJgKTqy/b87hBTGxanWCFBZrsnHQK2G+oIZ0ox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\n\t]]>\n\t<![CDATA[\n\tvpWBDXmVOEaSgfBUAPI57AmfrMuS7UFVVV2pNA6ZgIoaq0xrQAyYVxGMoFHg1ik0qU4Br1MMAowj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\n\t]]>\n\t<![CDATA[\n\tK6JL+GeIl+ST/HjsvT5tDVUxFOcG5JoNbqvu7j71VQ/FU4/GjsFA4uwDFtWirskVDGmxfaCf9V9G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\n\t]]>\n\t<![CDATA[\n\tyQQodN5z4hmplBN9JJ9hA1gue7y1QftAiBz5baI3Tmd6w+zlHnq6gyObVQ5EdAmwTKgQtPInC5sn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\n\t]]>\n\t<![CDATA[\n\t/35qUv5BUwL9Mj0z/TzLFIoikAZtWgRbY2ZR+rgioqI4KqO19JfW7qgU9RN4z3SFXS4JVs8/IVPG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\n\t]]>\n\t<![CDATA[\n\tsOyCzwduELCu/r+nmpI97qhOQ6V6Z/5SWzFOHMEj1Go6DgU1V+IVgSsLlwpdlF0oMY64g9+9TzCj\nCOe5oH1ByQrQ2ZJOSokrQSRkilohrqQ20DIB5GFqLdrOUpSn1Soin2NFT5QCVDlPGZ0tk24Aeu2n\nbGMjCAFOY4EKbTceER1DvYecWJEsx1Ylvdeypa/2poGCTCM4HYMqMsC6gl42QaOUYWFubhuzH1kZ\ntsZEOsYE4COFo6pM7P7abj2/LYvlDj5nSOfkQXw3Fej4V9MCC6/UfdpyfmQx++OG9f4O96yCf91P\niIboNLm4lPcvnQnurGHdv1uanVwsOnrg36wVTaMpB1zZjnWkKPyj5nqNo8Y1+i7IigyjWMjITUwl\nh31uY9zYFqj8jSK07KRlJAbq9KiIxvJLFSXctZz3a99Wwy5PNICGUjkfnNpLb5v9GscZ8WD8JV/C\nGZLqm3t82k569ai2cLJq3m7vbXvX5zP8Y8kSCb9aS0FRc5jlwdkmWeEEuWdppAVpdqAU9dAo1RjC\n10SiftKy19DgGPJBXvzQfB+Q3T0sdEUKtnSTx9NmHPQsZOeMcJoeuFub15YgMqS1QSZh3kxwcOKA\nL9N/u3Wnuf44jcQqPfogJOgDFyiBmrceIG9DQMnvaIfTkTqguCp7YcU4gRUek0ZTpF29PAFKEuEm\nmHwt/vMfop/fgrwgZsahuguyBPPJ1VsYuqcVpkh1wn2ddYRl7F7p1NDDKXoVU0x/LXiUDqUX9cq0\n4Ve3qsRb5GgPRsMAg1NKj1G2V2zSH+muRRXuUaSrOtrzrTGhWuQOWsk0yhXEdoG4DFRi8i+yqiWk\nFYcGhoNL771ot66YkdYI2bL8AP6mkKAs8jv9sQvEu+DpvAbCVWYsy3ceQbk7h8IeMptkdew3Z/SV\nsEKgcXNjUQuNmtRXrsEUAgwLU3YWg7UQHVAww0VWtQlSE4SG/2Hi9dFXf2TdaDWJWkgnYHtBadjt\nkRNDsBJz4358pSeWu34W7Yhx/w8FnTxD/BkMDSAVaYRGgdfOFsYMsNRgvji6OIp3OBdT/WCLLVEv\nYaIv6W9Etn4mvPaAC32m7HUCe+wVfLUE6ty2Ux9QTZJCB6s2PDzlnAN0sVIGVaWUKSWZSvBB+W52\ndyoELgUbBRoF5Ksr8EtoWiKV4vX2beL2Pg69mr5kFJyLFKrXTKuPEyERNaKC9CjSFCGaM0cxMpmF\nXjlo1E44FZsYCqlatBNjO4sR6zY6PaVaelVLJZnRUSITK06n3gpVqOLE6J2KkiFiMm+M84pMCY24\naJ0Y1UaG38wn2ihF+GE/ntJLfrWKxqoqh6qqWqXzCs8dIraesDBK2+yyqNBtrIrZGJuOlqJ4h+YL\noYxjUq2RThh6COosNtWqer3qKoqJvRKBPPWPyeORHcZlvh7G9Kr9UId6r+0QdzTCTxRsDk0fiScU\nptNppSRhvOiDZ4QSOP+MvEJeeUyQL/hQ9/gRRuPhTPhsxvOZCDSuMpDKKQlDYwPr1VVbfus6jFDy\nzToM0oSpqZXDq2CuCiEZiZ1oFsPfN9y+b/WELF6Fm4jSHo2XYryNxDT7gipmglZBPyeuU+12lLGS\n20T8xHgqdjuLdlrVcygmMxxTiN3INneLUj0xVQknTuLAEmrV5lgIhyRkJhvKYzJVcsljIpPOYlUS\nhKJcUqZgKplCqeQXPZyoZsEFMmbgREHF52kv/xYbypc/jIuz758zdIGXmRZ42uwxMZ+YzaoibDY1\nkhDjIVGJIYhEo4SgMd2d8JlOkA0N0d36bFqfWRr6kNA/Qh96ConQ8zJCK3qQRyGBRUEjptUETVAM\nDaOM1askRvlXUzXKMVOcxyb2KXGEOTLhCZpSvPaFV3m7k+w/ZfKN6hPMsfxYL94a+9ZYrJ5Hyt1N\nUUfCoxlr6Kl8OJyV4wklw5c7Mn34ko5odJHuYyGNE2JdZHI6+PBCihjBkPFe8OGokI3p5HNewslD\n5tUZxTIvNjayE4nwRBeurta/xzHf/Bmaw2EQY2b7PIkpbkVWYuQrN76pkRhVMd2mU7PMY3Wi6PDC\nWuvOlrgZM5nTirUfiZktJtip2BajIDVBqvIg9T5IPUhJ9RSkXuLH1XlGApGQShGESsEgJLSwClWW\nytTEGqMIVMXgmtWCiwyuuRpcb+2Y+p9tMd4qo0lj9WJE1NB0REXRVt4WUVVTMdWT3ZBZ9SI1Qn21\n+mdOHC3mWZFUdTrtJ0rmxYnIfcrEvEKqRCyKX5SxZv3L6l+2Eb/u+UVc0V/7QLLpZRVIVlWdlHgd\new7l+Fg8nZYuIkJCFCiUCRQKMZAMG6ISKKZJEcybIl4wHSglnPgaHCiNVhiSkISKCYVmQnBCFMiQ\nTCFKaoUQirBAoUhiCJ7hESRCvGSEGIQgiTNEQ0iLLCWYY5WL4X6FmQol/BaCwUYITkiFChUiUOjq\nEOVDzMhDREOYJEQ7DBHulyzEQzxChNoYLuF00MESRPhLuIhYKBSJC0W7KBQpISLsJhJIwhrYyqwq\nuNVQr3bUoa7rmuyH8MwQtme7fINNcQm2TfvBEF6ngTpqoE1ToE1XdepZcKU0G8Y0UrApMXYFO8It\ntHATSyacD1M4L12gSGjDGq0+REP0ZYN0vofq+F9HPHKoJV6UQLbJ4wgK5BcplHtPZ3qQkrBJ4mGK\nLBOmpsipMEVF5agJrHAqqAOrZhSmFgAAAgUoSG7cnYiSRk1QuLMY0WYxS0jLqkPRGROqWFQh47hb\nryRKnFgNWSNiinnYaTeyTQQDVYUa7gxC4cSZ09+asGpRWHlWYVUNorCqzoRVX8FE06GhUDNFDTWr\nRqjxIkKNTC0SZM55uG0xG+qyeEG8IDYFm8K4I7Nwj6eGkyBlkHJBGqQzFRXYlmkmUKOcmT2XoThj\nKJY1FUYCfVmFOL0e5pJwUjhnE055PZwUDq7V3AsSpE+1RlrMpcSR14S2EXEJjS6aw9WqUWsyDg4O\nNVg0khytGo+BQYs4XK8HqeXgfMXxPCzkjUPpOK4pcR4ouPMM+tKJkjeXlXgvlDl98kDjfPewo/GX\nVtTQDR8vrcaQVCAprQ8n5EESTE5CanJGihRMbjpuI0tkjIaERSTVcipKKkIkrHSUFIkUDCvpnlKI\nkiV8zVSJzclaSxYVipyhzUdxrxPKSBK1cCcLldSUrNVJ046KDo5UEFJe4+wmaQUZbJE0EY1oyjMJ\nJCRhOGqhkJTsyRm+w5ZJoYyUZKVDbOk1Z4V6dbI2p6MQnMwy8zCsqnmNijjzK2NhyKF5zWdheNK5\nUp3TRgzdHylnFhtJ2GdG4yGHyRZGJmKRmr+M/BIKIlZ4dweJvq1idzQZjdOHkrGGxFfdhelmQsl6\nNmJOfV3vyGuXhLDMNW+GXKYGJThfFo1yyaEbbqJMQ8hDmbyKRooIjujEYWNkbCPhS40/S5SuhSv0\nWyiBX7lo9trl2fjWQWvnLUvtwa0cZBdNpEZoL5mRLMxe6pOyQ2eU2XTyqIZaJDdZctUVs5BzRItf\nufw1CtKN1OXF1oN0VMLXRClQF30b8SJLF8KTjV8xE6Gy3vvr9Qoio/0iq3h8iKTgP5PsGzu0c0le\nQSg7T5r5i2qKgi5Ef01UhMnk9GqcFibjDH0yVlpxXUJCaZ+iYLfXQx7bqwYnVZabE6gWv9ZyTpm5\nHSNW1CI4hqI9hqzJNLgmY8iI7NyDSjJ8YxduWKOKejQLfSg4DUGTm0Gm+38WX7ACZybeMiM/ROG0\nEZIHoon3O6gNNZvITMlEajFPkUSVdEsmdoSL7ijEWNTCphlVPePEat98vYiMfKoODbIPVpTjlhqK\nB2VGKj7TCqIJD9Jsxem9Uz5rXMag6UWvpqQxSGyg8UKnsTPjdvylMn5LhGZ9hI8k/Uh5W/YnBEkO\nOclsIncNQQY5mtNIF4KkGoXa+pAEGj/WBNFCjJ5wFPsWjW/N3GQSKTk/8/pWhVKqoX4e4khLiUc3\ntWp6mv1VmohOYI2UhWwmuUZX9whEI0o86nSiIgUpywaWZdn4Jx/TpVbf1e38f0xDTIscYmg89bMz\nKqAEIQ9RcQWURWhJSZHLRNEJrrHCFEekokFKioiIVJ9oYjIJlccyQ48Ez4RRiTAEvSZ8hh40vMtA\ntKJVWIXVK6yKRpwK5Ah23S7TrmqNQhxouiiOhYiFCIaohGAZwS0jLIbCGW4QckRpOYSRcAnSNjhE\nCJo8XGhhzJkwPAMtUASKQBFo1WCg2ROmKwmemDJ4wSbOghdc4BKaoaGsRoTzNM4XTjOcRUpDRUpi\noSSMsDalBRIJJGWpjEsHlzovgpgvYRCLo6Rf6qTkE66wVy0U9r1u3xBm3SmFusSH/zKc8oEzrmrg\nDKcPNy1yxxviJNEQdzwulQnV1iq8rVkTSiQaRMRECyIiLC+IiFBUgkiIJ1hqwoVaDyUhuqk7XPhQ\nDsPHZSqcrArneVJMODdyOOcmA4PZWTaB9kBE4UCBHMNA9PB4+ITaLHQivKQmSuzH3baZED7mm1S9\ntqonioo8RRMTQX9xKCpqMVuQKDYT06jEYhhzmWMeMhLuwmh5do6cImrEshkuY3m/f1bQULwuUdST\nilV4lnqo61lYFe5GLqq+JmgCybt43HNMjEjtQ4qPzc5a1b+Gq9zz8ctz1NM6/sz4llHNJ06ezQSF\nqkWNzvy1NmQRVo3EY767JK/oCgNEIeoStQrRmNUUPyLiT6gOcc0oD+MUjUJa0FYHBAsQHFjcgCt8\neoR9CkrOsKJWCAMUUDBZiIUooOpqgiIY7SqkD8EiUUz0EAVSjzQIDCAOmD9CFQ9MdRAFDOmA4AAK\nKIhCgCACCigIggEUBEEAhgowAAB0I3KJIozMJkydypF19H5oyDUiPj9VZIlSdGIVz6B6PnNS2OEY\noqp2HhJVDHfGqnOUGMUcjl2FRIjEIlERytrNIrvdcUaqUZJm2TylNSSbM6RILBQTZFDaW6pYEmV9\n8TEteuEYvdBltILmMBgtKl5oWdwRsVjQsEUNh5OkL2qNGkZtFu1iMqzWqKQVw3NCU6XySCNlRhpV\ncGK1mC5co5piVc8lZDGJ37km/2jr2M1GwpdqBDeupqIl40dodyUoODO35rNHjatpcyqD0lXitJKr\nYshDJrJrZOSzNqNsFhjxxEo+0XRexLc07MxQ7I3i5jwU3yoSOl2kDJrsU1UMKuGlX0cuMjtkV9MM\nyescazMKshTsDIcfE82F55vP/FOXP//8m+Cno5q9mfJ97CCJjn2oPOOqrOrjhPkcI6GxYqGMMMpS\n6sW9CJ7jWVa1pPa8e3QeS7Qij0YnHdYXj1U2vrD4b+RPMO5d5o9PzfnTP5oh0Zgkc8YK3WzIjG6u\nGEjFmJoMsSS+TIwzKNN+nEnMuAVV1WuEUed0FRgsPc1dKR5DXhT1mkCk0qyvlKiNVxzFVDfSWTIJ\nJR2m3TFJKEsyRIlO5LOgcGGRHDFL5i4iIi3pjUSXEUpLyMZbQ6ydKty65dyaDjW2xQ==\n\t]]>\n\t<![CDATA[\n\t8QwqU5CxasLRr6q9JsoLHTsKXU9MSamKXKaKqRLsQjZ+1ZRP8nejFAUrNnaFK1zz3griSt6wi8oS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\n\t]]>\n\t<![CDATA[\n\trxdHsSG/KKmrRBBdv3AGj/zow00gyBwm2Btyf7x5CpRgyccGyDwo274/FM4ueFDhM4SCB6Yia1Qn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\n\t]]>\n\t<![CDATA[\n\tYZhxlzg0RemTRUMgfR2BXxPdILyPW1RbESuNkWVvbuhUXoPuD/5hj9+3nfq4n3eGOr/wc9Ti0SpU\nukzY+fKP/ne/B/niBX8BZ1zSJMvlwynHpWWyQ9eOn8CKY+M8iVkq6vMoEm0NvMXm3P6CgQ6/hJBF\nUyasi2Z9F/h1AgYB8vVFu9eeoqCpO2Rbsm6WqLwxPzjBqbD1rNY5gSELO+J6cEK83jeQWhRSORlK\n6pMq8bvJXok2EGGFDpH+da471Syc1AdfIyOHp0QSm78zotab8dwbrQygOBgb7iK9DCuNoPILOixa\nctCQLjqo+gS3an1tSDsB82+LfLTFXg8o0MI7jVTZkfNpIWdgGIZL4n3rIxfN2JPAt3fWiFpvW9DV\n3WDShIUVCOxGh3EeT0J2iE0HupkvO6r1wmAM4NMdZwHKgObDOfi4rbim6dlUbzqfgF7cC7B3Hdv5\nc4uyPMAP0ekHvAUUPbrcqL2EwJykHfvUqambDdIQAgXbIVaASJiEJB8f6Kc6kk4bRuJoL/NfvBpu\nJpidpYboI9XNj81kh3nhuMzJECZgM1DoPGqgV/fUoV9cUfztykG4f+lXDh1PztowWiPljExGFKiS\n5DO4ZAOjYVKo2odFKOLW9de8ggynkFzfyutZWvlEIqpJFdOx+BEmenwKKzEow1heiGDOfXSCEKVT\nN1D3r9Xes5x7QUQGIjfEtDOBPZtlSzSDLrRBOQk5AttdNkrWSQ2dGVBqTeZluRFCkmMgDImrDXMg\nUZwk6NtFtkeSzW3DEHug0Bqk6qW1Vv1DHBivvFoU7SXCG4lFuEHxYp3IIoP8yytA0Ijb+CQBBl3g\niWDB6HnTJYM+dKAJ4ghZVv9XfqMle+oNt4Pd5Pb2TRnlKGwU3ewvO8S2ljm6X0sutBu74NqSvj0p\neHmLD1RZPL9/dU1u8oOkkscPnfLtoPW0rmaScwJe+MINLMsRJZ8OEVSgLO0wmvgxyzP4RcNeqHbE\nUiI0fkyauplRtnQXe5Xr3L9ajPpupmsdaBIhX9RIIUinJgtBbCFFW0rUn+Y1TlmdKMxdS1jBYQul\ngSThSjlRQHOZN/I6KonIwWj9yHL1E92Okk8yH5NPR1bY2Yeu1eZpnquPC29z9vOB6QO9D4I6gkKA\naOpYUO724o7k+JykbETHB+ulypJ9wEKoBi7kz7c6SQ0xKa7SjBP5PC4P1+JDGs/5Z+5bWLc22jLa\nkugCzymPC3bxH2dZT/h87yVn4iYB7fggxYzqXGHoXzeNSrnXqfYI7/KSp+lMzkhg0jglw7RoKFih\n9t0Jm0+Bba/yjvuUs5h67Fm0AJalIJgRV6KeLA1BX1or+NbY0MWKU/6E/YxIcJlj4VIYlQM76gA4\nZkZp5WMOlW9kD2RLdZM+3pVmk1yhVJP4fotn8rN3SLcdwss9Kis6w/lJfBcfcCR3LZz6G5a4+mtJ\nsPxmaD1ZI94K9gzCaMS7BLRKaOogCUow+WynqVFnw5RAO6FFv9gKI54GLF55JbpZGbg2XRb+HRnL\njoQ0UVF0zJaZlM0+azfuFrPGwlsXPdZx0b0NZYccN0b8efMRXZ6KZVQgUEesIeT/j1lKyPPMzXot\nJm+ENn6plUgYdBKVvCUosEaA4Vbvz+9Ks6FHIOusPuLzgD++CkMFKYvStZZf94ERFncYh2Ph2JwV\nh1BpY8zAWQij8Mk5GuWAfdKDFYJnbANBDKacSnIHCXj78rzRsa5kZvRGD5JdiAt0FolILL3EUJFu\n87fUYrG///rTjfSVfeHBgq5ysOprL8fsst5qK7KxEdnkwJRidtHT6MPnbQr8B4ajpN+xjWyawNdX\nu5GZoP2mS/aDVa8jY2Y0JZNguyYc85kQGlgWCMRNxA+xkEOD+Ay2cudQqvzXZslqQ3x4gG+02lxO\nJCD99uVmhhXGHsPi+zjKV9hVRdJU7atpxsXQGcXwQN9gqnpneBtKoxDeTRR2pW6E3wPKbxDn2qkc\nAe4FeyqgTmkq/+qc6k0CeJDA/Nf83uCvarHgNYEj2PSX8EX+TMVmiLJzjhRpXaa0LamEXyHGgmpS\nzhVJiE+WLWDkqfggsOBjx4qtxNG99biQKcQ+QlxeHyzFI3ZYa4q0dcm2cji4d6ZjjCIBVSCx+loi\nlSF3LqxYDEAeAu53o85+q+60C4NXSD/XgNq31QQjkm5wQEkKCRh0N15F3heJsy3wfu71OIkoyM7R\nys8FehhLTNi1u8nSnLM6ILf1j8I2VqROpe00C6/6K9EbkRxYDhWhVnDPDhlDOgZ8jHUZGUGJi28n\nA/pvCAxqR/men3PvRvL4+KLcSB/PFs5CBuKDs5s8gKL1eGCWx45R8rTmlRz3buQaCLtE8oeFRgWu\nU8X5lAuhcd/0m1MJa8G8WEwQGZWiAIY+YmRkrJrYrFo1xl+2JJ7F6N8MZOKNtXaNH58hsCGeQTiw\nMbrvvP/I0O+O3LhmDoMWb4UzVUxnGtbNnFLpHWFw3liiAr70oTHSsHNigUUpkkLqwIt5KsCCG4mF\nykSd4UoVg/S4BGA4kB6x3+QJCNRqy7zhfiB/WORR1Znl6DP1cOzHsULGsidCSETg480hDSOykv7G\nVGKEiiAdkXZ5BdA8x1BezQH/i6pDqptnrvWYUXjyJyNk6bXlNHSSQPJOrTvHrhmM5Rp4POFEasMB\nc9xBwKs50c12+dowps92et90GyZiYeoQPRIkKFsvOUFS/5UgVgPQD7SpjmRh/lrHwpMoK+3Bpsga\nknaCl1ucUTGgNmbwwxo5pdC9wTktot1IwGg96twN3aAFcexwhUfwIn9eWjQSyk5qngDX4Oaut+25\n7zl1abxHI+2Bt/ynck2RA29llKgyJTHnsk5TExUcOQNiLn2dQEvFcu2c/oB6l+poBwtf8JxeA1GR\nEiLMetm0G8FGGxe9s2UifQ4hZqtMS/zl6IT1DvP7Ed5iBvlJOiG8WEZ/QTGy0mHUQedeYQ41+uEp\nf8x8D50vPAFtSO2jVWo0x+mEsbWNuT7mGl2hB4L5DfLWce7qs7oWGJJdD9kMNi3Trjwo2MPvajuG\njY/vbpTIiRyApFi1MANvGbrQpMDjyeeftpWHMLV0hFruCZBaxIOvKcEA0rgLCGhjpszW6ougliBz\nGCbhpe9BVYzA+969kEppETXh2oYC1kLBYJUuCCWsf1X0+Jrz3yTQMHkbQNp9xlSERdpXDHEznKUz\nIozpPZFIWXx3WhRQXWgswjAqTASh+fbQWXw57/8y95+PEdYllUgI8WPGkGGdzx5mrKKUV+S9ZAKw\ny9v4zDFYnZjKC9HcM3ZCSPv6RwciKB9F3f6Q8yHvV6nGbLP3hAD1WF4a2z9p6fC9aKrGOD+6YVhZ\n96veQu1DySOixQoSp/mJDiV3kTqvSO8NoEcbqwXOh5THnAJWjUYLpw+XaYGS1Paxyp/rt+UDf5dG\nSNPDtjbnfT6CcBhyTyeuoSkEGTQJAzuGAy5ehfMqe32IkSnJHlsXBFjOD53bAxXGPof00ircdn7v\noBX68U9ijDmtOB1YiCHMuCLjTnFMknsMOESoXQMIJ8DqslMEaeYeEQljoZbi30ER1DJ2Po0jRF36\nN+aHKtJobT8xSTI/aaJiYX9RKwjSDDD8plJWFHMF7SycmFY5T/QmIiIaOs0oBxVyKQ4wnu7NLQMU\nSo5/SkCNQaqldCrqFMj/LUyrGiVs6ZRY2rbf/gLJLgF6xCH+lGuRezSxBarPx3qO3WKla2LmGD5O\nFjKWX2IzG/B3TPnx1yhKEJ1UKK2xbhVWEx5d5e0qiTOkjHZksFxIkErerAYoI1h25CAaJOtOAuFk\nX5u6SDvtJol33KrrChBXuz6PMJ9Ha+9z0aUbjNHe4ckaEus2TRL/CGK+9MEyirgKHCTTjgulz6Zx\nyi29Q+s6njcoVoqxSgAxov+auzpcOMtd90QOdGYFXzdbHHSb/wSsq8/H3+DKB/D5dXY8DhSdacl+\ng0t+WQb1+yKNWf4G5QtYDLohif8/MUC8vp+pikDykcWwQs1XKzzuETBzBWV6BCRf4TnozwB8ekSx\nsNDlORYk/bLgkB5R+yz0ySMKqIWmpeCVZYMtZG9HYOcW6uCRWLhQn2UuHNnVhSPBuwDEzgtXHHzB\nUZZfELgEDA68ggGGOwImDJ2Nw3CT0cRwcSq3I4UvhuYNBjiGByHI8ABKBgjsU4Zv3TL4AsgMrnQE\nSJth5hzZdgaudGT5GUgoDg2X60gE0mDUB9ap4FjpCIcxP2dXDTdxjnBxx8raTUOqOAIyNvRynQ1f\nFLbhEjiihRvapNQNMH/ecNX1G7zqRoAKDn6o4YBoWhzOsI+DKUU5eH4jEDGHqxv51DnwsTGSS66A\nktgIgehwyRrRMB1am6rDQo0Aeh3M0Qiss8PiMzK5HciakXvQ5t3BagAeXJaRQ+KhEFt+GXmIpebB\nzxh5jh7ahxFC1oMrZ3sADUZ2vgdK8fDn+KDVL7KiqBdJVbSLJEQf2uQitPbBocYPaLZF7mBfWqRy\nTB/KoNr4HyjAIpIDRPNWROG4igwgEE2piFYGosIpIokgykkR3wqiAbCCBgE2kDLG+18i60FTT0SJ\n9J8s4kTqIzSROhYi5qMNQxyNNTXEpSJSVRZVJEJxBg/wED0I44wITCPCImssKuz2XUvEChGBZj4Y\nIoRDRRyiNSQ3PA2hxEAk3kU0/CEvMaI+H4LYjPDUQ3prhIXU6Tg7PXQXcSKjYwMeIq+PaK5DigOJ\nKmBIjM4hECoS/uIQ6Edi84asURKEbMhYTIKUGkJ1Ej3QkMRQol2GfGBKlBxDaFXCH1knvBIsmgZ5\nii+kvs47MPoTII6XwFEt5Asw0R0WIt2/RC1WiMthopCnEIFhopxRiD0cE7U9Ia6WicJMiMtnoqxN\nAAvUBJtISBeb6GqEjLmJZprDCSkiBMOcGAgh4+oEQyrvxOUfpNh5wsQepAc+4bAdpAnyE25ykK6A\nwuMGycig8J4GyXCFwl0ZpJseCjPr15UoeINBsMUuilcPmm8U7bAgJEAK7ykIa5OksLhBJjolCDml\nsBZBgnApXEGQliMPxIJM4ZQDiQfZFKYcMOwUQzAQqHyvQNj+FHd1+cEhosK0j1R4i0Agayo8D0hi\nVGGaAZG1WEEFRKZW0YWARIgYILKvovAAMnOs6A1AEGiFGf9Hn2yFNf9hK64oqH8Y64r2+odAr+iI\nf4j2K0rZHxo9WBQNVwgQi+L4w92MRXk2J2g/rFRRfj/klQWj9mNKsyCyfhA9i9LoR260qDQ/5p8W\nzcgPAmvhHn4Ewxa++K97tUVc9yHOLRxsH21vYRv7SCRceFofvcaFBfWRWS4cRx9pnwvf5yPhdGHY\nfNStC7vlowrtkg/NdmHl+Gh+F/7ER0PkhVf46EUvLKm98EU0vtABH2D2xb73eNAvOO4eo/4FqdwD\newNGHWav48BY1B7gLhi2ZY8QhOE3ITpSGFmuhz8yDH8NeSoehu/UIyBieD09RJoYZQ==\n\t]]>\n\t<![CDATA[\n\tpYduxegZPRxejGLQQ+yMUdbzsOAYPZyHch6jQvPwCWSUvzy0IqNv5eGcZJQmD7GcjDJuyoCmV8aR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\n\t]]>\n\t<![CDATA[\n\tsWQgRPoaAwKhP7CxDhAyYti4W0TSS74BdJHliR+bkP4AQ17Grx/8YDaU+MGWs2GSfQAb2pRCH2Sb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\n\t]]>\n\t<![CDATA[\n\twjfxlsGFw5AHCX8rCAUIOzagT0YbfKbJfIYkccgR/KDmqHJUEIYI/KaE4gj8gPJ1J3hpgv/7B03A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\n\t]]>\n\t<![CDATA[\n\ttLdMYCoxWYjSkfaez0nyTmmlvTeNbK8phI8f097U6vKYato7zPzEG7AXNN38aW8Oq9Q9UFiQ9jYe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\n\t]]>\n\t<![CDATA[\n\thF/AIJ5pPXsH7apWNFiN3Wt141MZOVtBH7ZpcKvv6U70VokMiZ7BNcXBwjGux77g+GpyFSjnqqIX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\n\t]]>\n\t<![CDATA[\n\tzJgfOyYR6CfGY8vGRmHNOUx6LJWHeSjRUW8VPCP2ML72LIt9qnX8kDiW9ECIqxKB8S22VFE4ReMU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\n\t]]>\n\t<![CDATA[\n\t+ycx7+8YwsnUldFcBgO7usliTKbdvsEA1WzWD05ZKdP7jSgDvw2fW7+mbeWcLpydtClo5wzGfZq9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\n\t]]>\n\t<![CDATA[\n\t9tlFj4K2ESXgrdOl6zeBb73nsM4WguT7R5h+9xAkn63jpes6XjmbSLxnE1H6fSRLQRspc/ATUfp9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\n\t]]>\n\t<![CDATA[\n\toWTxg1as0IdYBlBnok6B86Rc4hVdbMIo+tmql+kCixpmjyxnlEa6bDULwKLmuemkr7L7I8YluIeJ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\n\t]]>\n\t<![CDATA[\n\tqFIqRxhySTegMUlLlTDsCFQkfisakR6BigQnFG0JPDbnryaon8MS0Z6h9bMGkSWV5qJyOmNgHZUb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\n\t]]>\n\t<![CDATA[\n\tt7A6KnuggkpXqaCsgRL3vB3aXLMHR58W/h9EPX9N22ZhyjqW29ksTBmN5bbYFw9hoQO/YpDFv7a2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\n\t]]>\n\t<![CDATA[\n\tItjGBnzRYy0gFIxZcKg5QVeB03kt4BsSMHEEPkR8ht/syAhxC1cOdCzxvAyYYMxiEdGUOVxBlbFS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\n\t]]>\n\t<![CDATA[\n\tNfPDjfgOD+I53IbbyHCZGB5Tw2s4zZXHzPAaHsNnOOc3/Ibr8J6rEY/AoMH1T21LCIUhV4Rxjg55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\n\t]]>\n\t<![CDATA[\n\tM1bT17FecxFdX3xDhQ9XNluGgIOyg9BSQt5iJZWtaEx2BS0au5SJQ06upzpx+KFOC4MU//ySJREj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\n\t]]>\n\t<![CDATA[\n\tk4BfadNLRaKxawXplDdsOZW1mHDKUyUSafjSaN61YFwrQsTM3prWSNPvK30OeqDFvZ5DGFfnEM7N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\n\t]]>\n\t<![CDATA[\n\togZYYyk3kYC8cQSDlYN0Cn8fUDS7iPGvIr91kIFj2ZluPJzVAoVqAVjg7355U2NPPt85qHx9Mbg0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\n\t]]>\n\t<![CDATA[\n\t3zYFWF8lyWB0H2EjFZbFiPnA8kEQJJbuYnSLZYEi7CuIuZcaBD7mgoBLLY64uVYy+Q6pAhUY/+Mi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\n\t]]>\n\t<![CDATA[\n\tAgAAAADUrN29yk3lh3SvsKzCKqzKKizDMizDMvr5M73nrjirsFrp9K8y////r7IKuxZfPbGtmfrM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\n\t]]>\n\t<![CDATA[\n\tOE+okFFKnKNnmt0oZpPpE0+hhsJayOZNEexKc/RMIQh+SPjNUviB4keaYUf6Ru8bvY80RZAzfSET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\n\t]]>\n\t<![CDATA[\n\tlHNtCghXmoxCwJZxBW7jYBlZOjL4jQJRaEgWMPj9aBh78P0K/E1ZU8r8vaEgsPiqtZRq5U8C9WSa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\n\t]]>\n\t<![CDATA[\n\tDUdmNuHNLehPGon+nU9Wz4N/GW/V4e/NylMxiDSe6LBXTxwcC24DmjNb1YnVteyvrfTtJGYrRS+q\n4IssiZDMKclJEifcl8x3i+uiyImJe2d6hWsXIV5/OAZl7N60aegjx17ZTHopD+L/NK7IgU8BN4WJ\ne/HFzgrVDKCaKlT5NbACR3VnFIfVK+ssBelfGjUhA/uV5wRAdl/ShnmjvtxzYWpqzXlbLiPtUG/p\nH1Z2I03zuZqNL1VguZst3c783GS098Rd3I6JUrOK8souHrO5xYt6u9I4jOau4/4s1hpRu/1y1A/D\nAoFTq+XiVzrNVyTOsEgnLZszWI2L9KiSaqoVo2kPdFs0heDDRCFHyrE9U+NtvT+GR3CpaxW2w6X2\n7KxWtnQ6ScdQ6vqb2Av1NQ5pY5jZUeIYzx5Y5s4nqJzkmz4PeApiZWcEX5AxZYRCrsX1WxAVLjlQ\nuFquz5GBB1RDDr26vwO6xMvvNfmFoz7P0MJspckkt8DwyMzJw1WS07ezv8aXt17bN0nGTzBzZv2/\nTRiYiEOCgmH2f9yglWHY+EDcO0u3q4MON+lUtYfgn7ltm0t4VchiW1uMZDYGLPo04gSaDnIRbLQS\nCYdzpVpnmp7gmxiLDHPadmJACVKNrxcjpx1kBBvrzDMf+KOqcbKSA0lq/qtRxAIlYycXWOpdrlEj\ncFKYKhjCsBIX8Be2WtCUCLi8d2TPx1jQWz7BsJRVbsKNB7xgaNCgRJwMVE8Dgw68DQ+S+29o95KB\ntxR7wJj0nB0Js5mQ5UEyeZjbEAKHtVAQZXsTBwCfkzQjQwDw7NY2GMNON+ehSDM8ow8o2Xme/uXv\nczIX0wbT+JaZrY6n6V5Zu0zru4cIYjERMS8VKFpa52chvvSAlgRrxEeKqQYd2Y3iPBXtJGaUnhbt\nFgStLIRUp93f+CHctXwGXZS3uWZJfEDBaR78PYGto9c/PJ9UYEZIz9YZtwWaDs9SZXJgqDAuEqyT\nNOFfK2OoFiKN9tYMGMJ2ZFbaIOIDw57LQLeRV6ZStURYWjxDs1MYKFUgreMkDnU8PNaUZRqcWBul\nfRJySBZuCi1XM56h3wxL8+4Uhc9HYgfFhnxRQHom3zXh9QgKA8fTVSxpBhT4wrUPRu5iKF0S4AWK\nMKr+trKxJ25QA+lBi+qn8c7xStnD0ThiYeEryapkumkfeglvHg1+wUenrNF3lruvTMTelxryg/H0\nPiMF7rkoAVJIEi7wSQ+REall6POlG0DQstg1cmEkRfcjszYYa6ipJkDum7oVD4idazB/RBHaBqYp\nRNUsoigiGnBDwoG2Zk1EbQ2M0M95ReLqGr+LCvqVH191W+XNUP9TYC8Ijl+jIakHTbd+kSLX8kEl\nQEtBLfOCcoDZPkoHpHwrChk2bhoCz1qyDwBhZlwHGAeHbU4vUYRtX3HmdV33ILvE1DYX7uHDpArJ\niMKfLSxjZc9pJFXBJkTnxN+O5piKG89xPbL/6qAddB9E6obYktkzgZcAJNdj8Pk8nDIn9ORPryf3\nf4xIFQw3Rbm+nNB3IgvyaMBtX8xtiFuoF3CypO8VWDcPEfPJjILCnE2VOGnpd/UH4/l1Tm0AJA/x\nubAXGe6gkp4j6BvbOiR4LH0ml3F7bV1wpIvWw1n19wcgTkEbS2dkeRQMqgGlkYwHcL+y8VTPzqrq\nWitpdTQfMpJzLTCpaOrQnVTYEgqpK40cmbaBTc7BY8rn69TOxfVerW8oS9V4ecwum+XoYchVLekX\n19qBG58LA95CmGV+YJVkwgeZ1bfkmpgTFSjSRhpqTAnHX17oJs03EfPP3JmgCiOY1fKRFkzjJWON\nYxk1mB6GYPlXn6t+0Gyg2NhH1P3O+cfQDjiPgLXOpz3d0+TBZy54hOtwO+MremHFi1NPtDmd87an\noSGuFhMsB7Da55DncuDce95W31U/FzTAr5tq2i8FEZWgs4mJgirQMbs1BfAIxMkwbPlALmkB5JLe\nAcWz87UCL8nVjV7MwWIeAoBsPKdB3pz81GFLbAbssz2FDEf3HNZZlu8M8mslk9BsIsy/orOXohrd\nEbDcX8HyN54kREZA2c0t+/nyZh+dPpIaTcat7k1HO3nS6wv3DZkALGoPXBQ/10geHLUswKGaeutq\nsj+z57sJGZl5hnvNA693mXsDqOSpQ0zQKgBooIVPGRPTMEVD0KGUTdSvNpVQvoIj9cgSRNMzLSGv\nwS1Dn5QR81D6IAKaTPINRn0fxt2I2XC0xlv9smdNkKPEilMZXwXw8uXPvCdTPP+7Uh4x03FhkUYD\na3WREd3T6cQr5Zmdq+kcHFyfdS6b/Mr15QfqyDq6nCXBXd1UfORVZY170zZIJxRYe05VcgQNEOnE\nr37+Uw1Lv8awGv/i5n9FwJUXTZ5da5BpyB3blOEJhQZhEibtKPl+l+CTfCH8jiGKKmI8hEJfdnIz\nILTENbiZisaSjJ+tXr0jB54CmGJtkuQas9Cxz9J2xXcKtmchQrJTSc1Kfc+GXK/HK2YGAawh4KMF\nvH/rwClO3gyO8VTSoX4AWrQSI2ybeyNTeYblSOVzGv3acX0WKzu5Ea0p7fypmmVLZ3Z8dvVlrpAg\nr5MBltIG5kIM5FQ4hkXItvtSmhykybLnwmwhzTml025rYbP/CF4HK6l1FEpHO4pAX/K0VFn2H2gw\nw8N1ZmUeEI39OttswEe1cAfJO41xSrUmQuc4SSPTrPzLyqEhB588VMwXDcs2hfFEpi3nMZ6AqN16\n+o6dcTwnpKq91rUYOuRxup445LGW3W/Dze2NC+cNbN69heMoDEcVNgjHUI/b92RVlEsgso+57Jae\nO8F+a1NeYL4wdAXi68XCwrq1+S9ZIht5xT3QJdyAH8RKHQIUjuJuDzbQWu31nKBAKppuf43uPRld\ntWKESRn7d7m4NunJpx+2itpfTdYiq1EESa0L9x5ONAhVwJc23lsJYg3T4GfIxBphKC7N2nJBKjS5\nGHpXKlfgoPCTvfwUIA3cPLVA5gGY+1aQ2jazszWD+L63+KvBSdBqmBiIwJ6ukRaFEuVPs2qwuo+W\n5LtRa4bxaeXCjOVVCRJv1VNuYDSIDmivFpA2DPm6xuJshIbQgW7GaInguCVJwlxdvgco/+S5cvMw\npZDva42HsB7gnvfw23AvmQ+SnYSU9s2yz5mA+XY8+P+CznyBF4OXTQF+n30VxZiq8grAkGn2BGYX\ne4ItcHUrNNAD/4AC3DbCreFO5QL+l1lqSx44OtGI8G4AG39xCBsEK+RPPYmS9jUHAPmStVKwQjXG\nr5LRW27QNfM/rbZASGleJCvH7n8P5C4cGyrYO6I8z6qzOVgCzGGD8G5aQWOMhepsKAsK9IT11b/8\nuBm9SxwPYc+RTPdRfZIsU5CcqWq9K10WtVQHtY7HFKsVgPHheBI1TlVbPRl6YFiRBGZ2YzFwtZIF\n7OwCjNfe5TEY5Go2i87ATP7/e5yUXO+zBeExNwSFAk/3i3gkHCjheKmC8MZf+0LiCwXGmQaoF5jD\nXQJeCTRGPAXdvmQ/8NishzZHv6XFHcf+FlASlC884K6S5IXqFE5W2HxnfIMl6Fkq2Lvc1V6oDoNV\nxCbg0mgUWfuLs5NSdcQ2RRWYxXWDdR8tDzfmejf9hVB7mTWJNkAIt3ZqZtwcz/LJp2tzfwPbEmOa\nLrEVsUE/KaHd/YFW8AAi+taNAydobaFmZ4Jwz4iq9y80CphN78Hca5C/9EolmF+oRr6UJtKs9VWJ\nMrABgwTVMT9yxBJZjBZW7z/WoZ3Ag54bY8sWnbZndrpgI6QM3C0sdXQ10h+ymylkFbsKKntaowj2\nHT31eDO8lnAOnofBx6qiEgDNspRdB0MMpaUbzT0AZab0iLmyFXyhUH5HKTyVOTs0XCpuDxYc/AR7\nvBmUYSK1wrKrLvy3f69TBosXeGlbE3K7d+g01GsZGffDU6dxLro3VSjnlbKQvHrroFhUIQSOwBlo\nixKAGlJDiwr5dM7gKYEWV2IyAQHBlSELWs0+Uvs9oCZSlkVWRaqOauV8maSj6xWU96mdrHJFza19\nQXzA8BiR8giL6yfrk7vbHEw0+WiLsfZCMKLF5vDr6Yid7bCFiaz06wmvwmMjweRLfr8LFtNqs1WY\nuRHqv6HJg+r6BmlJRKgx7u6IO/Vj7xsdOwgJWKRByoRURp5Bvv+RPZO3S5eSpINVIqBTgAOwIe4i\nBmac5chYyaZEoyvJd04AOsORlFgPgi+QGLIn5g69T7kkjAvhkz+iUouAao+01/QCjr8Bd2aheCAs\nLps3cByefpmfxzjApwAxzqfP4fi/pIr8EbmwbxGUC8ybWDLMlcEDs1bWQZS8toCqj/IuKCO6jo1k\nkR3AOAC1Vm9RpE/IwENgo2yb6ESToImJaMsQLjk1aR51Kz4fS8agU6g7/xoFPw0jCjIZ0LC6XACX\nUHc/zt5RL9rUrTDqtviFivikKDG64DRpqY8Mko+LAayeWnD+a8m5exx+RFMzph1b2Sgimsv17/D4\n4b/BEkHs9KunNAqQGi45/wnGH4A2b6e0Yh8Gq01afJUZCVoR0oP1gBafQzkOIFUSW+RDHrGADRIk\n0DH4jxyBsmeUjGMbUR1wfbIDtZldMKKPhyme49t3jUkLE7h8hYIvmjNbtISHzH7oe132dXzKjj/8\nZxe2cynqfUtPHXasnRDiY993jsj7z5kqnNOfAkr7x0VuLrVBfdgMQ6eCHOQ/pvpXSirQZB2XS02s\n20CnJ2FDVBmCYwQKiM4horBeVGu0xvD81idGn4CGYkp0HXgVTOEdVmETq34k4hVHC19+0vp9hdSY\nIvEpa2r0eVmIKEjjDPoQiglCmC43f0IWdQ0C6J2ePlBo6giX9CYRS9JglMbUr5YLx607GfbJ5u3T\nhAMaygp39ga0LqUsAgp3QaBkhz4m9oDo0OSP8SDisQBJ6g63oUGLbv1rijof+v2QQcLhxfjR3GX8\nXz473Otf9RA8j1kN0KY3ktBgaCtBz5//8U6hfCq5Ky1eNrGXHWrpdVhbMJkyrXaFEA/cqbgE1A28\nRfihpimrOMKYg0Zh60VBsrC6UvEV0Hh43aoxCdEyWcpFgQIioIFuBNSP02eoRddWo2DYiAvKs4xM\neSz32sDBRhro2gemlefNYN1E3iaN5qeAti1zK8fxIOLdF0FOuz5vwkXVIeB+3Wpjrn+FNFtjuQwU\n6XSMTsOviH1gMbcnYtchzzO7+9gYlVaDcMN5HN7v9i8etSb39X5ZhOgzSVBNIO92uouO9XximB5w\n03WeSoFEi+eq3kIT61Goy7sK3EEQtVUJ6V9EgimmLK1I/0k7MMZxjvuIFmMFmDzQMHGAWkxqNJdx\na25OraQpEOvG458FLF59SpW+yFQSJ2lKEPdYItGR7n5ubrPAk1PhjJkApMPnx2e5IqaI2BEDIxCh\n6l8MRB1fi/p/f4g91m/4GJEPuDu02RdxVk/FN/tS6oLdB8ZVEETJUS+XAjVS93MSnA==\n\t]]>\n\t<![CDATA[\n\tmNwnfbc93xQwkUtiaqA+re6F1HkMBZbyiVuNJ13R6iZ22ad/iKWdXq6hOLKlHbz5UONocCoUh5cN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\n\t]]>\n\t<![CDATA[\n\tZLW6r283R7S88wUWBB+iJ62Yms2x0L+uZpGKgiuB6Mt6H6rwQOfDfaabhJc759Cv186UG7tODuOC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\n\t]]>\n\t<![CDATA[\n\t4Xu8xmW/bDRz8BTiwVSDmSOsilu13TQ3L66ALkhwfBgcshmN8J2uuLXUOVRY6f/LdJZqfIRHpjZq\nAM/98pZcNCm6RWG1Y2mLVuV0K0RtHc9epMJqqoT8It6d2edZy98NHmqfg5zLS7ZVeXL4USKXT0Ko\nxbYZz2Bes3gEidmeYOGLd34VrBHsSJSPJBgXs6bY7PIdy1A57TvpOyLdJ9E4o8aiYMMjTr1MLSQE\novX5tMmwk4LtVqgiDJNdYgTIPDfzqahGVS8dDQuIexsWoAUr/G3YNdK5oRmPdY22PpsBctW5FJWt\nTHA9sJ9r5Tm+Jl65YAAYRXlD9fLi77ZD/c2J9HTWJMA+TQkBOvi8MSaQRMT5AADG0SDZ+RKoY929\nEz+GutyITamUtwZBeyMSAQAQAQAABBwDDQMHA9ygpGkC7VCarQYMFE1mZqEQvO1VIE5PjWszQYmS\nRZwEVteC5+OaJ8Oc1kQJBikOkYukX0KWtgQNLrtskNhJd2WDx5epMQrvVJb3sADVpXobXA/C/4E7\n2WcoLIvHRyyaGyNtV7dbBPEQ0fx+q9MwLzDpd2k3ezxJNh0C1cSft1VK5ie0nIYN0g2oI7jMnwwe\nvufgULjPkF5iqgK3MmQYKYdMUIdoaI2OEGI1bRitNf2NFZoOSYu4e5lC3GFjpNQ9JG3UJy3LqD9M\njYHubQOJrNNnsK/TUSYBnO5olDT9/BSaTtYFSj+BQnAPOQ5wz9REt7+jUdtVSKLtpawC6d9qwtkq\nzUi3A3UpNkWDfg6jiRW4tqMfZx5gHudt4GfESbkBxwAENlnJT5t9VusuDXDUVuSy9BkiBr/km1G4\nRURXnhNT4a+JEqdKoNSjr0C8wDgjmrvU8s6acKqTJpzq+0N66JLHgzG+D6KpboJoCkRTHWPxeAqk\nCKLf23onUzpZPDufmolmIjediQY8nU/tzss+sk/3YVkOpxDGG88uYRqYxtW4mq2mxm9n5bnLcy/J\nc39d3PQFxm/JYdCJx2mUE1nI4DTKciKbeE6jnMgwaKOmzhKDsibxDclL8meJQVmT+IZk4huSl2Ti\nG97GsbiJNCJgVY8iAsoVBGxAwAYsQprqUUr776v6KS3dfiOm+1X9V1WnNPoQm+QY+6a9qbMbI1zS\nGCFGuLwu7iP0Xf4j9PiPUGFGuKQxwgW247e7am1aMVxCExaZCpRbiKgA8zFfhBuqQDyYCmJGrWaY\nsNnEXm1Xhz6mwPBSLDbp4xoNdgp45THrjdZ0YnRjjGPDUZ5PjFt4hdX5KZaTYl9QTIhbvIiKy5Np\nznTvCXew7Il0sJKN4V1VGgJ6bD4t6PE5NDatt3m+QdcMhfgXXu38QZbO8EpMr6VL95VXPeikd2DI\nKzWiErYuQDkGo3yy5HF8kq1NtcmtTSSb6t7Gmjz7YwcGcyd7s/Opznc+NRO57Pe2P/tS4uxLyT6d\njsdNpGCHjoggso/s4/69W3UZ63A8HA8HkgZgQb3wXuM4jZLkM+7MKxyVub5ypnskSa53hCx3niDH\n9R5BQHVKbGmYqLUVs2/nkO4+H0ii97YW1rkcLVM9+iCb8i6LdLIfMdJReEg5KFCWTiqdRimBKAbl\nRkUWJ9A8LC6SbKqPOPX7X+wTzgLmPktpL610ppsEabyD5mXu9OdM9ziTZZqz8GHwhAgDG7nUxQq5\nTSMUuRetgaBKyHkGKKKn1o4KLfE1d1ZGRc+ZqNJPSV707+YrX3tI4F8tboV72yZdoWoX62IZI908\nPtONUGlzP9Q0gscilBg33efoTLegeyar6Wks1E3tpR6u9wUyQPbH8UsVbUtEEE8KCuta8KQgfjsP\n0RbwJ2A8rgATsmg5H0yFEhYyf4wgQ7oRb8tplKYTZKoaHJDjm77cYrADGVxFED8K4rd/iLXgvdvJ\nnuS0eHd546kyRRa10f+gQFn6liDHL2gY3x87nezFhwjiRUH8djJj4v1FElBdFmGTt8UDA5P19XQg\nu9ywPKfwkwohx0/AvzYHYOtmlU0OKzZWEDgrizI4hs7hmQ9CgHA5LK1hxaZC0qxAlAhHSVo+WxC/\nXYx8eA/JQfhhm0bpufBeo+rR96aeufBeexjfJ+EL77UxcuFdPNeC3+wlQZPf/jku3+da8N3icg67\nvHvb2C5QEsSTtoqCIKqHgvjtIeo6ZJ1GCae8M1Si9zYS5TmiyWNFH4m8YFvzxMcuTGJYF/0kFJZa\nT8T09tHAwGSt4dhr7ZGTd29LzFonCA3lpEx4HEF0v2e69+xLhe+Z7sIsACzJc+ck2DvtlRiUZNfi\n3dtmnTPdqUolegTlQ1qagxVqqdTy7rnMYhWeLfjBY17xVoyRImYy77RgVuBeD0XkUOU6cg3EY8BV\nyNPmvK3SYTYn+fjIqWoochzxGHCPVrq5zsdHzqwsQo5A+2Q5QCgFAuS2JKyPiyqjEB7/4XErHJR9\nKy9ABbL0F4WhPifFWsuS9VF27HKmGzUPurfZtCsXV0yZWOMkIRZNURzKJaipVmfNSXQWxcyQYFUL\nI5FQyjO4YDkI9PwQFLztiyDIv2ev1UoLGGj4ZUOvJe25a+ltC5hk8pEBAWWt3e9UHT4Gm2e6jaFg\nHMUmCmzpAAXMme4y03i9r5zp9u34Cvh4HD8kI27Iurxv1eV9h8bHJzvY9Q5Tp+FqJQYl2aa899hC\n8uAMlTg50z1uWPTeNjnTvWkJ0YeTM9189YmeLYysSCWlQign1ReHy0x3xHSDTDjVQxODxUf1nIFo\nqmtkjLXgQX+KuCB+O0iKBFSfdbakk31Yanl/SU7HLIJ4PuCm+zAyyGgLdTRBPtEms54616MdbVjL\n+uoQynLEkh+E8gwpCKXJ+YSyFWOMIjWvdBBYDReZPODU6bIWVKTLkaFtGiXLDcQmUwBKEX+QJ4wz\ntVKHXaUf+6Z0k6Az3aQKKp0Dp+qX5BDySaHa57ge/7ScHj8CepADZ7pJxvv4Ay1ULfzeFi8WgzL+\noQ+nAYUfRI0Oa8XkpAZawdmLWsB955szHXS6QiWFCRHiaVy/IwZhJzeoIfzi5kx32dJQ+G59CHSy\nvCffMWe6P2s4eW8jMWc6GDFnukcvM22MRzL5ypnuDxte3ysdlbneNp5IkrvlDnZ9ZRUZjBMeSUds\n+lp9/eXtyTsd8jj+JzLO73CC/iNP3gmkKCBdl3THJRiF9GHw/h1a24Mke57wr00BEpXMvhXDu3ob\niCTREBDa2LSsTErT7CwyTt7P+O3n2c/4PM/4jN8fvz/un3/yj1/8ppIO7V+eKb1ZCsN8y+9tnnM+\nepvIt827GL99LISeh5cCZyduVwsMX/SWhiyKW+xkzC28ccehj4OG8Bjn8bXfshxK2dseMC82YxuD\nAgkFYkNv86ippEOF7bGEaiJN/fC21iN2iWs0R0BHjt5J6ICJn3R/QYIrtaHa5LgEXJJcDbbj1zU7\n2X+G3M0W3imWk6JL0Eq16Ex3WapHZMfj+N7GKSTXi49O9j6kIJSjQgTxoCB+u8sFWevF4+FnN3ev\njTFo+gHzUN1tpF1XfhLgfyGNAbshLDGsf6f+NE3LmLx3K9vFToJaf5qu4VtrgXie522zSpYNiK1q\ngZmO0eqZVgnMKlk202SBGQC5Vm307GLJ9GYcYXp2oWDy+5Jp+YKis0xeaWYAWLDiwxrQOsVc3UPP\nNNjMlt2X5ZdplFzDuGQWjQWL+N9R1KtgrI+is0yAjUsGABYBURRFWTLiLJUgZQCl2aWCybTTnCnR\nSmwZQAm2weV/HfxpQCQMBoTBAJd+YwUQAoj//z98AXMUQJgdkSgRBoNpfm/6DRYwf+L78jwT/puH\nE2H+bYBA/4myl+bpN1jgf2/w8P+joSf+AI9A3yCrgN9gsEAIi51Y4GaCBbpAPwX8Rs8CyPCGgkFK\n3m/pACt3wobXNyams3PYDcfW9TZv87ZVZDD2FEMl+oK3xbAuTlQqKdW/uR79WYbx/Q89eY+pIoj/\nzJP3TxB/HadRrurRH2cy7yLqLf2x5YHNFnAVrQWRevIuSEhGLOzKtYentBsP88SNCNCfvK8czEm1\nvCffiDROnDWcvI1kjCc/HgYn0cv2Vpl8wSOZFhySZr4p/TON13vY8Hpbb8eXq4OXRGWuqXK9t4kk\naYMc98EZKpE8kMQNh7AOrr6ukkgT/kry3FuPcOZwZyUdKggMjtftah8ZjN7WWRnCu0JlZSFvjxV9\ngZYQPUc5qd56eBuNUTBpGtZCG9wsVRBG9Umht5He22iZDbOw+Kwj06SoyOIQTsri4IfhXU/ruYNw\noowLmn6tr0m6BfNSgzRugjiNmPokQQaOHa8qxaDsFlcdvL5ymirXV850W1Te5m2xljb3zagS/xkI\noqzdasCo9Otf+qwFXe+yMQqnfWr4P27IWr3N22Jv8zZvU0m10fe2FG58fySq6aiApiPQTN+TJElW\nFDtfaNUz+L5nOpY8jj84P4xP9BrIpJfk80gEPnKXch05RSvdnKSTR5D8zFrqi+K4qAXJg7VWZAeM\nOuCuv9IK2VQFs1HDaQIajw86yI766NIPQ54yIhWH3OgDbW5tv8iZMLCRe9U/I0iF31tVUHUsH6jq\nbSzZb/VXSOX6moBG6VtGr8JnJJ/qrWwQDsCUDak5AogkqOSTNvJgFjIzIwIDMwLAAAMTaEAYLByR\nysQi0qRqZRSAA1FGLEpOQDY2HhXKgmFAJAxHYhyGURgGQRRGQYkcUrcBSM7+VlM0xZtHNjuKqTYD\nw8+4J1BZuDwxdccVPGGth176GE4kJ5JfLm8JEjRHalpwk5bMG1xv8clBinAHYoAlGzJhh4LSfHOw\nVVYPOKrIkCcOj1xo62ikropcVfj88016Eb5Yh8DDI6dbbgw1UYVXr5vhQ9ILlUZ4deKNqQx+DMWi\nJ4lcPcflZgnSsWR5GRRYVLbcCxH/zs423xVZDYtrNDHu3ZyiaA+95IoWRUuHMvyBxvzsoVdD48Dx\n8huiiXdDujT10HVF0iLi3q/U3i45KGilOkKop7FR+x/PnI1FdlZc35D2hZ/N6mG9L2g4DVY9CUVo\n/bYDs+bCpi48POnVpgCOGduiS5qTCXK8oR8dllZbiXQJDItfBYN08AXB2F57F+mmORutAPp3XKbU\ngrMpkANIS2pPL1nwm6mN0T9+fIrZlt1SVwOoo+jA6ISuSexZ6uJEjOi8aWXu0VEqZMCDHNoOZKG7\nXgK/yjH7WSwUtAdxTQOwS7/Iw8Ej6H5wutEZrxgDHWGsqW7SF44uDAku8D6gI9Cmf2i6hUzXD3dA\nJzR+/V/xl80d3GpH//BR9v/h4gY6qistea4qKHX0dXOQnZGRiBZ/bnmsR0vFpbilLDLCBZ7xrbqv\nYWFqN9b323C3BIj5ZhfelON7TvO9XA7aG99YPN9QFGI3vgHqfKOGpFuf7sZ3NM3324YrPL7hPt/I\n9DO+3Z/7br47onDN+N6C8712s8D4NnjzzYlLp2h8c+l8U2AjylLOZL6zhuYz33CN7w==\n\t]]>\n\t<![CDATA[\n\tdzLfdp1eEQodzylwQjEh6VOp2qWd9iqcNXYqX4LRMPZkvX0A46VfYAIh9uzt579DICOvpmUVNOHt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\n\t]]>\n\t<![CDATA[\n\twMReHXwh2RzGhD50SXghXCD4jcWTESUqOQa5gl8/QSXZzIRLMkRmdIm83ZvfoUaJhbUN04GQocaI\n5qJXoDetHfodKNT89JRkf7AWfX5UphzKZqj3TetaGw/tESNzMzRAvRbAIS3xUGcaX0G9f563c6lX\nNDIOtso1mgPUCybIotvTlDXqQb1g9kMpG9pVWtFxkHofryRwhjxue94c05feTndsB8maJ1DvswtZ\nEoLdaglyufZVyibYOOPos77+GWy8PUVK7DVSO9tXjH+ublsIAzYsYkKJ+0N9XHFh8UTlEUJ17clW\nJB8v64OfUMh/LbNGrTfvM0CfQyzXfKm2kW9o+TxQ6rj59HjyZ0SnDhwkXKtK7h7LiEwi2khhC/j7\n11zAgnCsDFjC9mcAyhj0cC+t91oIk326ZcpgVr684+sBZMT3EmdZcZ+lsO78LBR8FNOIc1JF7uCH\nKL9UKNab0DQts5pdMRNypzvyVqAFsZT8EcWCTSwPDmKMKWZlPsmbckbB2HmwanhEX886Ld8iCUSi\nBd+uIl9B5EJYk1354RTyoE7G2tT/a1ZQ6cg0EoOa1ovQM7yQwhaVwju9baqIkDfXeRH2mcF5Bs67\ncrZJIlojqcAg8l4/mDXh5BfmloVb4CEInNcHPHHuISTN1VD/mfQsD3ZbCVfv/sx68ObKFMaa23x2\n9RINyDzfXhsTGucEWAagwVeQ4u5isanqVWL+eOfqlV+8y1WvOjeVwTSMKv1dy3MF\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z\"/><path d=\"M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z\"/></g></switch></svg>",
            "info": {},
            "path": "32/calendar--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CalendarAdd32",
          "filepath": "calendar--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CalendarAdd24",
          "filepath": "calendar--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CalendarAdd20",
          "filepath": "calendar--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CalendarAdd16",
          "filepath": "calendar--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "CalendarAdd",
        "global": "CalendarAdd",
        "filepath": "CalendarAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calendar--add--alt",
      "friendlyName": "Calendar add alt",
      "aliases": [
        "date",
        "schedule",
        "day",
        "time",
        "month",
        "year",
        "scheduler",
        "agenda",
        "docket",
        "timetable",
        "add",
        "alternative"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calendar--add--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<polygon points=\"26,21 23,21 23,18 21,18 21,21 18,21 18,23 21,23 21,26 23,26 23,23 26,23 \t\t\"/>\n\t\t<path d=\"M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z\n\t\t\t\"/>\n\t\t<path d=\"M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYTJkEzvyFmwwqwNZQCm2UADcFGkK2ET22eQqL4PLWtlYkn0mR3b0zccDy6fJXFAUMRdGB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\n\t]]>\n\t<![CDATA[\n\twIGDQwUBGBVsMIECBYZxAQQLFCooAjAssFChoXIeFlCoMGEDCxIw8CAZgHDg4DBSHhVQIAAWKlyA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\n\t]]>\n\t<![CDATA[\n\tRka9X2bvsXJoOTBnEC2Udf43eOIbpcre/9EcrUXz/VCuRlHu0DD/xBqsm0TD69VI1+wKXkewRhFi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\n\t]]>\n\t<![CDATA[\n\tYR1rG0XKqzsiSq1KTihZo/h5lSTW8OdliTa3lYWS2OYVolVRZXPKlvkaaYdk+2BNMv2bfZJZ5ETL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\n\t]]>\n\t<![CDATA[\n\tdA8tn0tk7hPfn+OJuAFH07qqTDgrkTNeBvI+QGL1ZVt+d4ipDYtTtJAgs92jDgHbDZGEM0cMmKx0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\n\t]]>\n\t<![CDATA[\n\t2pB3E8cYGSjaFYAyhz38ybpAsj1cVWVLKvKQyVZRo5RpLcQA86rACPIEbg2FJukUcDvFRoAxMsdy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\n\t]]>\n\t<![CDATA[\n\tekd0ZX+GDEk/yZfH3gS/1lDthuLkgFw5wG3V3d2nvupRPP3R2DEYSJx9wKBa1JW6giUt1g+8sv5L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\n\t]]>\n\t<![CDATA[\n\to2QCFELs+fEMVMqJTJJvsAEMlz3k2qB9IETu+zbRG6czvWH2ag89vcANyioHIoIEWCxUCLTyk4VN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\n\t]]>\n\t<![CDATA[\n\t9d+vJuXfaEqgX/xnps+znEJRANKATYt8a8RypY9TRFQUB2V0lP7y2h1JUT8E73FXmMwl1upZEjKN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\n\t]]>\n\t<![CDATA[\n\tli74YOBeAWso/2eqqdkjjOolVBp25mS1ZfHEYTzC1qbjUFByhV4JuDLhMqKL2gUTI4i78936BGeK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\n\t]]>\n\t<![CDATA[\n\tGVSmIGPVhKNfVXtNlBc6dhS6npiSUhW5TBVTJdiFbPyqKZ/k70YpClZs7ApXuOa9FcSVvGEXlSXI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\n\t]]>\n\t<![CDATA[\n\tFBvyi5K6SgTR9Qtn8MiPPtwEgsxhgr0h98ebp0AJlnxsgMyDsu37Q+HsggcVPkMoeGAqskZ10tKL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\n\t]]>\n\t<![CDATA[\n\td4lDU5Q+WTQE0tcR+DXRDcL7uEW1FbHSGFn25oZO5TXo/uAf9vh926mP+3lnqPMLP0ctHq1CpcuE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\n\t]]>\n\t<![CDATA[\n\tVoye0cPhxSgGPcTOGGU9DwuO0cN5KOcxKjQPn0BG+ctDKzL6Vh7OSUZp8hDLySjjpgxoemUciTya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\n\t]]>\n\t<![CDATA[\n\tQqSvMSAQ+gMb6wAhI4aNu0UkveQbQBdZnvixCekPMORl/PrBD2ZDiR9sORsm2QewoU0p9EG2aVP2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\n\t]]>\n\t<![CDATA[\n\tfFNvGYw4DHmQ8DeCUKCwYxf0ybjBZ6rMZzgShxTBD3mO6kYFYYbAb0goDoEfSL7ugJem+L9/wAS4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\n\t]]>\n\t<![CDATA[\n\tqcRkIUpH2ns+J8k7pZX23jSyvaYQPn5Me1Ory2Oqae8w8xNvwF7QdPOnvTmsUvdAYUHa23jMcw/q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\n\t]]>\n\t<![CDATA[\n\teKb17B20q1rRYDV2r9WNT2XkbAV92KbBrb6nO9FbJTIkegbXFAcLx7ge+4Ljq8lVoJyril4kKCpw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\n\t]]>\n\t<![CDATA[\n\tmESgnxiPLRsbhTXnMOmxVB7moURHvVXwjNjD+NqzLPap1vFD4ljSAyGuSgTGt9hSReEUjVPQYkeb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\n\t]]>\n\t<![CDATA[\n\t7xjCydSV0VwGA7u6yWJMpt2+wQDVbNYPTlkp0/uNKAO/DZ9bv6Zt5ZwunJ20KWjnDMZ9mr20WWiS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\n\t]]>\n\t<![CDATA[\n\tgrYRJeCt06XrN4FvveewzhaC5PtHmH73ECSfreOl6zpeOZtIvGcTUfp9JEtBGylz8BNR+n2iSj47\n6XLQVsrs2keRg7dQI9/3MbwjogxS3LNzuHE2H5w95Mh3S40i2kmZgXdNnpqXmSujY9LueaaOrM75\nuv0cL5y/ptXZq5qNFYrc+0SYeV9ocs8raXJtp0/v2NMo+CNxCvobQbc+g3dGD1HufaoVhv+AisTe\nROr9Oody9AxfmjyTdybb/LX1H8W92kgs6I8yAb+OIR19XdveAL7VN4BvdQ0eW7/5e/M3gG49h0vX\na/Te6mubLV/b7tmmr83b+Kl5Gj+zLoM3RsvMlc04g27e5q+thimjsTDbOlvTx0YPSfb5mjw1v0NY\n54ce/eLG5Bg2W5ahK5N1vnQdqDHv/yTi+ZtAuBrnb66+AZSjdwjrfJG4j6fwrvcc3vWgRz4f9MjX\neQrpPM3eGm3j91YXUfr9J9Hvdukz8JZKNbwbxIDsUaWI38Co4Y9CPfRHldyv06XrOt66esnz66te\nPNZSqoZ/qZNrO4mCP5Om9zaaHPxOouDvQEYlDQEHZU+QotEvWMH4DZCGbSNx4B969PtAi3qeiNLv\n6BLQ5jGk6z1hPP/I95EyB7+TJ+EtpWr4p1AR7SNx4A9a7Ps8YTrbJxHPE1Xy2UOSff5n8e4PLf7Z\nO167XnPX5nW4craP4d230YPrM3RqNY5fnAdC3LuZPLs2VQlEm8EKx79ABaMtRYpoL2V27SVN7x1F\namg3fR5dAtpJm4L2VIlCe+q0cJuUOfiFIvdsGz63bgO41oEU8/5SptdOyuT+JMyuD3LUs3EG3/zQ\no9+fSjW0EaBAtKFAD+2gRr5/E+hW3wC6eaHGvbsHbPdt8to8jt+b/WOoZyddDtpLmF8bBxDuX9O+\nNibOlmXqyGQc75rNczj3r3C2zD1wAMFtLRiQI97vSazzNHxpNI7XzQc16n2d8FytA66rexjpug7h\nnCfC5PtCk3v+JxHP64Dj+gwf2Rwzd8sxdFttzmDc71HEq2+4bTTNXxp9RavFuBbMKyaOTCsTlzbH\nuJVpafLQahtBNV/Dt9Zl5M7o69qtvard2hm7s5mGT62OmfNavg0hgs8fRFzdaq3MXBnNsSG6OFiH\nrqvax+6E7WokTkE/E7dW1+iteR1u3C0UyfdzBuO+DBxZHTO3nXW8ch9Ice/rcOm6Tpeu3/y9/Z5v\n3i+SFPRFk4B/idP7lTS5ds53rsYZhKt1wHX0TiFdH5L880eVg/9pFPyjTg+/gVHDL3V6+KNOwbfS\nZtfrcOs+zp/cT9oUtKFOv1ulzcBbiZNrN4mGPRQq+EOhgr+TJ/imIpH4o0oL7SQx15ZSDd9Spok/\n6hTRM3V+7SFHwB/EuPeDHPXsHcI6r+OV+ztdu/9ziGcHMerdQ5B89k8h3/8xzPtGk4E/aVPQNlBK\naCMYsWhLoRbaRpV+9w94784ZjPMzdWi1jd9b7XOY13cI6zyOIJzX8c55HsM630N4Z/N862yaOzVP\nU7dW63TpvpFk4D1VanhDhRbaCEgk3g9gQN5UJAxvpkxCG8lS0B569PtBjH1/iLHvZsokvK1mONoN\nZDh6I3HgJ6rss4cq9X6Nnhtdg9dWAyni2UKMfHdPod33Mbz7OYBzNs5gnFfCHNxOmSb+AyYUPRFk\nYMcJhOs0fmgzzd5ZJ3L02w458t03fW92TmCcDcRodw9F8tk5X7cvMzdGX9fsbAydrc0Ju32bvrc6\nZs7WwphpwWDMsmExc7d8M+hW43Dfvo2gms/xvn0aPDX62tbFrm4eG2N3Z2++az2IUq/fCLr5K1vP\nwqR5MZg1WgwGTQ6TwdtqccJvtI5hHD3TdybXDKLVMnZm2mvbnb2qfSzfymEwZ3OWZi9tvvmLq2Pk\ntlqYMq0Yr72+uP8ScXXzWBm8rSyDt9Ve37w2hs5jZfTu7FWNxvIOHDrwrgwdrmk+LIcwrieBBvYZ\nOLUvA0dG63Dj7qDFvh/EuPdt9ty6z2Feb/L03kBhv3/TF1fjBMp1n7CeX8rs3gZGCz8TqPf/JOJ5\nG0G2+srWs9e2O6tDWEcDNeZ9I/FgP1CCsa6wqukl8LDsUKeFvym0a/8o5n0dMJz3Mbz7RJV99lSq\noS1ViviZPLs2U+fX9kG88ziCc3XOYJwnsty7Gaxw/ApMKN5Fkn73j6Ge/VPI93nCc/dMXVotI7c2\n+yTieR9EPG/z59Zp7thoHEE4L+TIZzN9cu8ky67NY0j3bwTVPg8hnj+iDLyVLgW3RZGAts6gXY3D\nffs3fnF+Ru6Mjmkbm2PYtvIMHZo8c1dGy8ydyTzfOy+k2HcTMQLeQot8dw6f3b0TWLc9mvQbc9r8\nbps2v9unzvAWKrTwfvIk3PYc1tk2enD9hk+u09St9Zs9uH7kOHhfzZD8WjjEthLm4H3z9/aTxFwb\nafPPptlrm2/24HoPod0tpNh3J2UG3kSNfrdQ496ddDloO4V676ROQVsoku9f3bba69qt1fnKdSJJ\nwN+0+d0iSQ6O+RjmfR1u3J3TdbNp+NRoGbqbltEby17bvBwT97M0gGozDJkcxsE2gOBeBIgYvK3Y\nFe6LXedqrU44rv6BxOs9jnKepq+shjHDiuBgHjRwL6Irpu5M7Ofxrr662Vme/eq6vm2xMW5bLS8D\nA4NR04Jd4Tx2hs9Mi3PYJuMUttE23TYZxiwbxkNw4OI9LMSVrWdp/M7mmbwzbUzcz17ZehjXfvDi\ndpcI/kOIgDmTw65wXY65u7Myd/bM7TAvmDJsGIyaGBi3xb5g0mqw69oddlX7YVeyPse8jc06Xjlb\np0v3ewrrbJo8tNpnEa9Gwux6I8nBn8K9H7TY55HEXPsIU9ATif+6Dpeux8yVYWPkbjGb7hotJNnX\ngyTz/s8jXs1jmEcjbQ72p1PCv+Q5eP8o5v2fRLtbxyv3db5w9k0gmzeq/LulTg91vnF/Ju+Mhmmz\nxWz63Oom0e6NYISiXfQYaOP4zfkavbeaRg+thjHzWRgybfaqNqblCdPZN4FvfeYubZ7BU6Nn7NZm\nmry22Qfxzv9A2vUYuDKZdxl7RdvKNHZpvSavzdPUrdUzdWh0TV7al3kzq69nX4bZzloYtDlL45dG\n8xjW+RxBOtonEc8DLebZPYR2N09Ybktzp+Zt+NjsIUg++yiS+40oA+0mUO9dNBn4cwbp/o2f28cR\njPM3f3AdRzDO83zrbKdP7+1gxaN9FMm1bfrYPA4g3D/KBPQ9hHdfps5s1vnC2UaTgHaTJvh22vxu\nkSwFbSZN772E+bV/GO9sHa6c3UN4Z+d44XyNXltds9dWH1lyO9Nmd1vk+LcdavS7dbxyNk2f2gzT\n1sXIQoSIubu1NYFr9HWti3Fshw8cBAYunu3wgd9iXWNiXjJ8ZNgacJpWBu8se3X7YNwMTAQfw3rN\n+KWB4RS6aXG+cXIMXZnYzF0a9sp2h/EOBoKHdfjAxbY48Lqrw/VN+3Wt237BvM1fvHcAwT9UwMDB\ntriudXbYjB4aliZQTUsjqKatGVSbabhpWRg2LZZ/ry6O5dCBe68PMGpgImDOxL5gymSwq5kXcV2j\nw65rdBgMWlYEp0WA4CI2cHEaxAccEPVOVoQIVldOE8rwyjg4XUmwcrJyunKS4MDJAVvt5MDpQQQn\nCRGsnO6qKicHTg6c/s5X7eTVRWxIO2vTS+PQYMdD7WTlhIBqxy4N764MO4GOgRZWBAlVO3FOD7Cw\nrBhcQbCSQLflZIVXFuaEJse1I++o7YS4yrrKioDFAAIWBCwHVlYMIlzFRbjScgAhzgGEB1pxEB5o\nPXiQ9SCLQZaV1QMJWBIeRMiyunIQgUGWA6wIDh44sJKA5SCCVZYECQyurCJcWUHAigDBysoqy8rK\nygpLAgOrLKs4LQZWVhAiaD3AgvDgQdaDBw4eQMjKsoKQZZVlJcHKSoKVFtYDBw+0IDh4IAErawOD\nKwgBNPyG5/AbrsNneA2/8hhew3O4DvfhQByJUx1RcbcxC19jLB8wu6yYkntSdkj2tebIxIyy9z0g\nALKiEwS8ohUAdM5GJImUgas/LLtAWoi9QlKIvT5UVH5zyKj08ngh9vKwYUm4Y4VlmIepZWEP0kvE\nHpqWh0EwLRV5YIoVeYgtGQvQFDfeEIOBcPEKxik4XBlnCvw/cMAR7DBxHa7DZfgMj+EynIbXcBye\nw3X4DZfhM1yGy/Arh+ExPIbf8Bkuw2W4DJ/hNdyG83Af7tQkFfPXxiV0Cu4iUi0Eca0r4+JUVQu4\n09QBvmGCFYyfbSFIR3gD1tgHh7fxAL4oQ63ANd5xCcCn35QEJOmwjB31Wls3DY9YXhIWEaUcHNKD\nsttDh7jrowAxV0gNS0IhppSCQ3SIuUJkXBb2OLUMAyEVg32QEId5jFoa/uDcdExymHmiSlsjlSy2\nYRbWD/4CxTNi2fIjbXQZ8xsHACs3TiDMw5i1w9IXzi2dAvgyxEySXeBiWQ24U1AUH4px4kK8iO/w\nHn7DcfgN1+E5fIcPyRjxKCInDmVkgDdwiuJt2AxTTTK7JoxhdGEhwAUIBwmM6HIK4uhFtIIrwqfU\nrwuoxOAHBgEY8QFs/KSLkEsBZE4wFEnIvShOIvlYl2ROQgn8buFC8wXAiiymscUME3EIZeZhkE0x\nIRAT4u8PFJmGPz47I5EQejYiQdQ0XMXEJDTyWTkYhMYk4CoPykEhPygHf/TIDP9IFQexQkaHwA+P\nNv4x5xngitaPk4igMLbxYehIogZOF4bFMSBAwK+UDHAGQU58ykaJO8kYcaSrDyeK2eFHPIgf8SSu\n9DPF6QoTYgi3Hq6BNgj+NWjgUkgNOJJNAk7EnXgQR+JBXIkT8SZOJGOAOykp4N9rg4+4DwzrgBEi\nEp8UoFP2UUkh2SclxWQflBqSfk1wXHqPkE7uMGDsDQFQso+sB9iahUYwLb1ERlwSDiHVNPwh2qm4\nKsnp6SRPU8UUNsojWMYUtWzxmqhQ5jIdjRxiNvKQFId7jF4q7tC8XOxBaRnWYeISEQdp5eQqt0sl\ngbnDuEkHBAdA5fqZEcgFMyhj4GARHPAMEaq4hSsHfCvCA65BKwK/MOGKd2mQwO2shSseGYcYOjYP\nPZCCXxnGBXjpCaBLVuzjSxnmjS1ojUgW+I5FFvighqyQloBPXIgBn8yQ5GMFksl9Ynp54spa3ngB\nMew4CoiuAQTQZjI2CUv2MQHyuMdqwOMe65dIPyRELL+rqZOCQniIuUFoaDIeWRTD0HJGCYTLmOWK\nK2mY4SCk4u4PGuIvEBPi748Ul18fLioFh+AQe32s8HxUEuZUQaWNawVKX/vSo047IEf9p8VJD3vp\nUleWsKJWWcoaV9m4aigmBGJCDB5CKiYUMprJeATxEUkAvtwCV7BbYyEglEZAehlpSobQ+sLC62sM\n5OtszAQLqICVORABLPNi6wG+k7GJoSahk0xNzVa9zdQpcZkvsqhRGvkyZgglix+0Yg==\n\t]]>\n\t<![CDATA[\n\thT7EMoA6E3UKnCflEq/oYhNG0c9WvUwXWNQwe2Q5ozTSZatZABY1z00nfZXdHzEuwT1MdGoi+fOs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\n\t]]>\n\t<![CDATA[\n\tS7oBjUlaqoRhR6Ai8VvRiPQIVCQ4oWhL4LE5fzVB/RyWiPYMrZ81iCypNBeV0xkD66jcQAZk1zKy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\n\t]]>\n\t<![CDATA[\n\tVSooa6DEPW+HNtfswdGnhf8HUc9f07ZZmLKO5XY2C1NGY7kt9sVDWOjArxhk8a+traBMPq2BFofZ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\n\t]]>\n\t<![CDATA[\n\tCAVjFhxqTtBV4HReC/iGBEwcgQ8Rn+E3OzJC3MKVAx1LPC8DJhizWEQ0ZQ5XUGWslBHepuLCyzGx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\n\t]]>\n\t<![CDATA[\n\tDrfhNjJcJobH1PAaTnPlMTO8hsfwGc75Db/hOrznasQjMGhw/VPbEkJhyBVhnKND3hgA2Mvw6mdl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\n\t]]>\n\t<![CDATA[\n\tEV1ffEOFD1c2W4aAg7KD0FJC3mIlla1oTHYFLRq7lIlDTq6nOnH4oU4LgxT//JIlESPgHbO2pTn2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\n\t]]>\n\t<![CDATA[\n\torFrBemUN2w5lbWYcMpTJRJp+NJo3rVgXCtCxMzemtZI0+8rfQ56oMW9nkMYV+cQzs03XLmsz2Oe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\n\t]]>\n\t<![CDATA[\n\t3UjA3zgiYMUgneLfBxDNLmH8q9JvHWTgWFKm2x/OuEBhWgCW9ne/vKlxks/jDFQ+uBjQGk0c/T1g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\n\t]]>\n\t<![CDATA[\n\thPptJ4h1VJMKRvfxFlJgWYybDy8fDIJsdRcjtTEULEK8gphTqEHYYx4IONbiSJtrXaYvyCp8kfE/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\n\t]]>\n\t<![CDATA[\n\tNdcnfQIAAAAA1KzdvcpN5Yd0r7CswiqsyioswzIswzL6+TO95644q7Ba6fSvMv///6+yCrsWXz2x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\n\t]]>\n\t<![CDATA[\n\tGaXEOXqm2Y1iNpk+8RRqKKyFbN4Uwa40R88UguCHhN8shR8ofqQZdqRv9L7R+0hTBDnTFzJBBeFW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\n\t]]>\n\t<![CDATA[\n\t0iQUAraMaeA2BgvI0lHBbRRIhYaygOHTR8PYg+9X4G/KmlLnbyoKAsVXjaVUKn8SqCfThBR3Sqse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\n\t]]>\n\t<![CDATA[\n\tMegrG4n+nU9Wz4N/GXsN4O87yl8xi4Je6rDXTxwTy1oDmjN31YnV3eyvrfTtJGYrRS+q4IssiZDM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\n\t]]>\n\t<![CDATA[\n\tziVxEqhP6wor5TybAuf7xFXjAVe0lolV/Okfqlinv2sobghpQ24+1zgenAr9wssDb6djTVOpXqjo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\n\t]]>\n\t<![CDATA[\n\tpJ5sYuo3x0J7XQ0jFVWuBKUv6zAw4YGqD/ecbpFf7pyhX6+bVW7sOBnGBGsNzgtytVcgAaebzzH0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\n\t]]>\n\t<![CDATA[\n\tZq1+TcFVMTfRTzYVVBIfrBxyG03Kf1fytSyaDVai5wYgSzJ+RD7TLQvQiDM+l1KaLNlWYYV8AoNW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\n\t]]>\n\t<![CDATA[\n\tl5/jSCg0vS4V/a3kOoqjuwkJXnofsERq07+cZCET/cIduIyMX/d75IS5g2uD5h9+yf4/LFKgo3q1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\n\t]]>\n\t<![CDATA[\n\t0j6Cx+auFUAWf3P8ElkO/O2Tna5icMIMyr3xYVBSw1BjDd/mXCxX86HgIsmvF43tVaNGa14qt8Gn\nnM8wVmizWnxdFfC3Ex2mH7ZsjD3TnztrvJ5WO2PqkP4BDxsxFfPG5JvgPRfnj1avXt2tGPj79Uop\n9DbIQ6EJwVF6ZPI1VVILfLV65qx3V5/cNjgzJga+fWBz1d5O3Z0Tei0Y5xNZnclNZ5oW2rAmFkar\niuw1A9UAYI4ajzlxxLBBzHTCwsi7xriePG2xORuN9hKCb2Cbg1Poy5QENuEzmL6xFRJR8soxjDhW\n+Alpks1LuDxBZBaTyNvfrHBOFJCt7YIdMDDUM99c0A+01rWTSAd2NG/9kqy4rkXsjwqXQxwX6h2M\nusbXQ4DFQN3kHqDeIHJoMR6ylMogqBfG89ZJ6pWNzL0e2hopgnp9DLKE7FFxTUBQb89+a5aNRBU6\naMtIvQtXAowhO7WdJ8f0EItON2idZKMdqFfsQjaJYGq0RKtcgyNtD2ycdfTavC4BNtCdohXwGtmd\nfXeMW7i17SOAjcYxPcD7IwOuOGJRkf8IEQztyVwkzsv6Lp8wf7+Wp1Hrv/choA/PVxlfpr2RT2o+\n90zq4Nx67MKZY1AH0yR0YiVHAssUixFdrbCFoPavTLEgBigDiKFrZ4D2GGHmnqT3criG7HRrfR6T\nfDnk9QAnxL4lla245tJc3fkUCkGKyYhzTEXu/SPi/E4ozk1omC8Taq1YKLnLvmoruBoxLIk8iv8m\nvnERcRMrrmLN4E2JQMEM2fdq0qKvcJ1Ib/FbxzJf8PWWwRUELb2Z8M8PUZD3YMJVpv4OswJDR9B1\nO6iIvCw902VA2xIgvHXBuYoKe/NGFnH6PjiPf96hsw0SoqyQ6gyR3/VrTRMc/QKyrEkAntXBua6B\nh+49RNxch+Y/2pxlidtk5upFNPNjb36FwsDXTTVXr0kAMsi012FCMzxqlgE6+E5R3KNYy1a9Os2f\nj7p6pRf/RdUrwE2EWkXdxg==\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z\"/><path d=\"M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z\"/><path d=\"M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z\"/></g></switch></svg>",
            "info": {},
            "path": "32/calendar--add--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CalendarAddAlt32",
          "filepath": "calendar--add--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CalendarAddAlt24",
          "filepath": "calendar--add--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CalendarAddAlt20",
          "filepath": "calendar--add--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CalendarAddAlt16",
          "filepath": "calendar--add--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "calendar--add--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "CalendarAddAlt",
        "global": "CalendarAddAlt",
        "filepath": "CalendarAddAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calendar--heat-map",
      "friendlyName": "Calendar heat map",
      "aliases": [
        "heat map",
        "date",
        "schedule",
        "day",
        "time",
        "month",
        "year",
        "scheduler",
        "agenda",
        "docket",
        "timetable",
        "calendar"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calendar--heat-map.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z\"/></svg>",
            "info": {},
            "path": "32/calendar--heat-map.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CalendarHeatMap32",
          "filepath": "calendar--heat-map/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z"
                }
              }
            ],
            "name": "calendar--heat-map",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CalendarHeatMap24",
          "filepath": "calendar--heat-map/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z"
                }
              }
            ],
            "name": "calendar--heat-map",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CalendarHeatMap20",
          "filepath": "calendar--heat-map/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z"
                }
              }
            ],
            "name": "calendar--heat-map",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CalendarHeatMap16",
          "filepath": "calendar--heat-map/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z"
                }
              }
            ],
            "name": "calendar--heat-map",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "CalendarHeatMap",
        "global": "CalendarHeatMap",
        "filepath": "CalendarHeatMap.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calendar--settings",
      "friendlyName": "Calendar settings",
      "aliases": [
        "date",
        "schedule",
        "day",
        "time",
        "month",
        "year",
        "scheduler",
        "agenda",
        "docket",
        "timetable",
        "calendar settings"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calendar--settings.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>calendar--settings</title>\n  <path d=\"M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z\"/>\n  <path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z\"/><path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/></svg>",
            "info": {},
            "path": "32/calendar--settings.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CalendarSettings32",
          "filepath": "calendar--settings/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "calendar--settings",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CalendarSettings24",
          "filepath": "calendar--settings/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "calendar--settings",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CalendarSettings20",
          "filepath": "calendar--settings/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "calendar--settings",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CalendarSettings16",
          "filepath": "calendar--settings/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "calendar--settings",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "CalendarSettings",
        "global": "CalendarSettings",
        "filepath": "CalendarSettings.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calendar--tools",
      "friendlyName": "Calendar tools",
      "aliases": [
        "date",
        "schedule",
        "day",
        "time",
        "month",
        "year",
        "scheduler",
        "agenda",
        "docket",
        "timetable",
        "calendar settings",
        "tools",
        "maintenance"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calendar--tools.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z\"/><path fill-rule=\"evenodd\" d=\"M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z\"/></svg>",
            "info": {},
            "path": "32/calendar--tools.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CalendarTools32",
          "filepath": "calendar--tools/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "calendar--tools",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CalendarTools24",
          "filepath": "calendar--tools/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "calendar--tools",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CalendarTools20",
          "filepath": "calendar--tools/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "calendar--tools",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CalendarTools16",
          "filepath": "calendar--tools/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "calendar--tools",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "CalendarTools",
        "global": "CalendarTools",
        "filepath": "CalendarTools.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "calibrate",
      "friendlyName": "Calibrate",
      "aliases": [
        "caliper",
        "measure",
        "measurement",
        "adjust",
        "gauge",
        "calibrate",
        "instruments",
        "wrench"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/calibrate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>calibrate</title><path d=\"M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z\"/></svg>",
            "info": {},
            "path": "32/calibrate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Calibrate32",
          "filepath": "calibrate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z"
                }
              }
            ],
            "name": "calibrate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Calibrate24",
          "filepath": "calibrate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z"
                }
              }
            ],
            "name": "calibrate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Calibrate20",
          "filepath": "calibrate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z"
                }
              }
            ],
            "name": "calibrate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Calibrate16",
          "filepath": "calibrate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z"
                }
              }
            ],
            "name": "calibrate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Calibrate",
        "global": "Calibrate",
        "filepath": "Calibrate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "camera",
      "friendlyName": "Camera",
      "aliases": [
        "photo",
        "photography",
        "image",
        "record",
        "picture",
        "snapshot",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/camera.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>camera</title><path d=\"M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z\"/><path d=\"M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z\"/><path d=\"M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z\"/></svg>",
            "info": {},
            "path": "32/camera.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Camera32",
          "filepath": "camera/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              }
            ],
            "name": "camera",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Camera24",
          "filepath": "camera/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              }
            ],
            "name": "camera",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Camera20",
          "filepath": "camera/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              }
            ],
            "name": "camera",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Camera16",
          "filepath": "camera/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              }
            ],
            "name": "camera",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Camera",
        "global": "Camera",
        "filepath": "Camera.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "camera--action",
      "friendlyName": "Camera action",
      "aliases": [
        "photo",
        "photography",
        "image",
        "record",
        "picture",
        "snapshot",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/camera--action.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>camera-action</title><path d=\"M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z\" transform=\"translate(0)\"/><path d=\"M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z\" transform=\"translate(0)\"/><rect x=\"19\" y=\"9\" width=\"7\" height=\"2\"/><circle cx=\"12\" cy=\"17\" r=\"1\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z\"/><path d=\"M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z\"/><path d=\"M19 9H26V11H19z\"/><circle cx=\"12\" cy=\"17\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/camera--action.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CameraAction32",
          "filepath": "camera--action/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 9H26V11H19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "17",
                  "r": "1"
                }
              }
            ],
            "name": "camera--action",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CameraAction24",
          "filepath": "camera--action/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 9H26V11H19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "17",
                  "r": "1"
                }
              }
            ],
            "name": "camera--action",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CameraAction20",
          "filepath": "camera--action/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 9H26V11H19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "17",
                  "r": "1"
                }
              }
            ],
            "name": "camera--action",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CameraAction16",
          "filepath": "camera--action/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 9H26V11H19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "17",
                  "r": "1"
                }
              }
            ],
            "name": "camera--action",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CameraAction",
        "global": "CameraAction",
        "filepath": "CameraAction.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 9H26V11H19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "12",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "campsite",
      "friendlyName": "Campsite",
      "aliases": [
        "campsite",
        "tent",
        "teepee",
        "travel",
        "camp",
        "camping"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/campsite.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>campsite</title>\n  <path d=\"M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z\"/></svg>",
            "info": {},
            "path": "32/campsite.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Campsite32",
          "filepath": "campsite/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z"
                }
              }
            ],
            "name": "campsite",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Campsite24",
          "filepath": "campsite/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z"
                }
              }
            ],
            "name": "campsite",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Campsite20",
          "filepath": "campsite/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z"
                }
              }
            ],
            "name": "campsite",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Campsite16",
          "filepath": "campsite/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z"
                }
              }
            ],
            "name": "campsite",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Campsite",
        "global": "Campsite",
        "filepath": "Campsite.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "car",
      "friendlyName": "Car",
      "aliases": [
        "transport",
        "private",
        "automobile",
        "jeep",
        "ride",
        "pickup",
        "car",
        "travel",
        "transporation",
        "vehicle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/car.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z\"/></svg>",
            "info": {},
            "path": "32/car.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Car32",
          "filepath": "car/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z"
                }
              }
            ],
            "name": "car",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Car24",
          "filepath": "car/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z"
                }
              }
            ],
            "name": "car",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Car20",
          "filepath": "car/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z"
                }
              }
            ],
            "name": "car",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Car16",
          "filepath": "car/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z"
                }
              }
            ],
            "name": "car",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Car",
        "global": "Car",
        "filepath": "Car.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "car--front",
      "friendlyName": "Car front",
      "aliases": [
        "transport",
        "private",
        "automobile",
        "jeep",
        "ride",
        "pickup",
        "car",
        "car front",
        "car grill",
        "travel",
        "transporation",
        "vehicle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/car--front.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"13\" y=\"19\" width=\"6\" height=\"2\"/>\n  <path d=\"M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 19H19V21H13z\"/><path d=\"M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z\"/></svg>",
            "info": {},
            "path": "32/car--front.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CarFront32",
          "filepath": "car--front/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 19H19V21H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z"
                }
              }
            ],
            "name": "car--front",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CarFront24",
          "filepath": "car--front/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 19H19V21H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z"
                }
              }
            ],
            "name": "car--front",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CarFront20",
          "filepath": "car--front/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 19H19V21H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z"
                }
              }
            ],
            "name": "car--front",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CarFront16",
          "filepath": "car--front/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 19H19V21H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z"
                }
              }
            ],
            "name": "car--front",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "CarFront",
        "global": "CarFront",
        "filepath": "CarFront.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 19H19V21H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "carbon",
      "friendlyName": "Carbon",
      "aliases": [
        "carbon",
        "IBM",
        "IBM Carbon",
        "design system",
        "IBM design system",
        "design"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/carbon.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>carbon</title><path d=\"M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z\"/><path d=\"M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z\"/><path d=\"M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z\"/></svg>",
            "info": {},
            "path": "32/carbon.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Carbon32",
          "filepath": "carbon/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z"
                }
              }
            ],
            "name": "carbon",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Carbon24",
          "filepath": "carbon/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z"
                }
              }
            ],
            "name": "carbon",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Carbon20",
          "filepath": "carbon/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z"
                }
              }
            ],
            "name": "carbon",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Carbon16",
          "filepath": "carbon/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z"
                }
              }
            ],
            "name": "carbon",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "Carbon",
        "global": "Carbon",
        "filepath": "Carbon.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "carbon--ui-builder",
      "friendlyName": "carbon--ui-builder",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/carbon--ui-builder.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"24\" y=\"28\" width=\"6\" height=\"2\"/>\n  <circle cx=\"21\" cy=\"29\" r=\"1\"/>\n  <circle cx=\"29\" cy=\"25\" r=\"1\"/>\n  <rect x=\"20\" y=\"24\" width=\"6\" height=\"2\" transform=\"translate(46 50) rotate(-180)\"/>\n  <rect x=\"24\" y=\"20\" width=\"6\" height=\"2\"/>\n  <circle cx=\"21\" cy=\"21\" r=\"1\"/>\n  <path d=\"M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z\"/>\n  <path d=\"M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 28H30V30H24z\"/><circle cx=\"21\" cy=\"29\" r=\"1\"/><circle cx=\"29\" cy=\"25\" r=\"1\"/><path d=\"M20 24H26V26H20z\" transform=\"rotate(-180 23 25)\"/><path d=\"M24 20H30V22H24z\"/><circle cx=\"21\" cy=\"21\" r=\"1\"/><path d=\"M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z\"/><path d=\"M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z\"/></svg>",
            "info": {},
            "path": "32/carbon--ui-builder.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CarbonUiBuilder32",
          "filepath": "carbon--ui-builder/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 28H30V30H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H26V26H20z",
                  "transform": "rotate(-180 23 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H30V22H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z"
                }
              }
            ],
            "name": "carbon--ui-builder",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CarbonUiBuilder24",
          "filepath": "carbon--ui-builder/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 28H30V30H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H26V26H20z",
                  "transform": "rotate(-180 23 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H30V22H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z"
                }
              }
            ],
            "name": "carbon--ui-builder",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CarbonUiBuilder20",
          "filepath": "carbon--ui-builder/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 28H30V30H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H26V26H20z",
                  "transform": "rotate(-180 23 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H30V22H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z"
                }
              }
            ],
            "name": "carbon--ui-builder",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CarbonUiBuilder16",
          "filepath": "carbon--ui-builder/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 28H30V30H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H26V26H20z",
                  "transform": "rotate(-180 23 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 20H30V22H24z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z"
                }
              }
            ],
            "name": "carbon--ui-builder",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "CarbonUiBuilder",
        "global": "CarbonUiBuilder",
        "filepath": "CarbonUiBuilder.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 28H30V30H24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "29",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "29",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 24H26V26H20z",
                    "transform": "rotate(-180 23 25)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 20H30V22H24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "21",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "carbon-accounting",
      "friendlyName": "Carbon accounting",
      "aliases": [
        "carbon",
        "accounting",
        "CO2",
        "footprint",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/carbon-accounting.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,26H23V22a2.002,2.002,0,0,1,2-2h2V18H23V16h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H25v2h4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M19,22H15a2.0023,2.0023,0,0,1-2-2V10a2.002,2.002,0,0,1,2-2h4a2.002,2.002,0,0,1,2,2V20A2.0023,2.0023,0,0,1,19,22ZM15,10V20h4V10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,22H5a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,5,8h6v2H5V20h6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 26H23V22a2.002 2.002 0 012-2h2V18H23V16h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H25v2h4zM19 22H15a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V20A2.0023 2.0023 0 0119 22zM15 10V20h4V10zM11 22H5a2.0023 2.0023 0 01-2-2V10A2.002 2.002 0 015 8h6v2H5V20h6z\"/></svg>",
            "info": {},
            "path": "32/carbon-accounting.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CarbonAccounting32",
          "filepath": "carbon-accounting/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 26H23V22a2.002 2.002 0 012-2h2V18H23V16h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H25v2h4zM19 22H15a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V20A2.0023 2.0023 0 0119 22zM15 10V20h4V10zM11 22H5a2.0023 2.0023 0 01-2-2V10A2.002 2.002 0 015 8h6v2H5V20h6z"
                }
              }
            ],
            "name": "carbon-accounting",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CarbonAccounting24",
          "filepath": "carbon-accounting/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 26H23V22a2.002 2.002 0 012-2h2V18H23V16h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H25v2h4zM19 22H15a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V20A2.0023 2.0023 0 0119 22zM15 10V20h4V10zM11 22H5a2.0023 2.0023 0 01-2-2V10A2.002 2.002 0 015 8h6v2H5V20h6z"
                }
              }
            ],
            "name": "carbon-accounting",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CarbonAccounting20",
          "filepath": "carbon-accounting/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 26H23V22a2.002 2.002 0 012-2h2V18H23V16h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H25v2h4zM19 22H15a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V20A2.0023 2.0023 0 0119 22zM15 10V20h4V10zM11 22H5a2.0023 2.0023 0 01-2-2V10A2.002 2.002 0 015 8h6v2H5V20h6z"
                }
              }
            ],
            "name": "carbon-accounting",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CarbonAccounting16",
          "filepath": "carbon-accounting/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 26H23V22a2.002 2.002 0 012-2h2V18H23V16h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H25v2h4zM19 22H15a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V20A2.0023 2.0023 0 0119 22zM15 10V20h4V10zM11 22H5a2.0023 2.0023 0 01-2-2V10A2.002 2.002 0 015 8h6v2H5V20h6z"
                }
              }
            ],
            "name": "carbon-accounting",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "CarbonAccounting",
        "global": "CarbonAccounting",
        "filepath": "CarbonAccounting.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 26H23V22a2.002 2.002 0 012-2h2V18H23V16h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H25v2h4zM19 22H15a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V20A2.0023 2.0023 0 0119 22zM15 10V20h4V10zM11 22H5a2.0023 2.0023 0 01-2-2V10A2.002 2.002 0 015 8h6v2H5V20h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "carbon-for-ibm-dotcom",
      "friendlyName": "Carbon for IBM dotcom",
      "aliases": [
        "carbon",
        "IBM",
        "digital",
        "web",
        "IBM Carbon",
        "web design system",
        "IBM digital design system",
        "design",
        "hexagon"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/carbon-for-ibm-dotcom.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55\n\tv6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55\n\tC29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\n\tV24.88z\"/>\n<circle cx=\"6\" cy=\"6\" r=\"1\"/>\n<circle cx=\"9\" cy=\"6\" r=\"1\"/>\n<path d=\"M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55\tv6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55\tC29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV24.88z\"/><circle cx=\"6\" cy=\"6\" r=\"1\"/><circle cx=\"9\" cy=\"6\" r=\"1\"/><path d=\"M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z\"/></svg>",
            "info": {},
            "path": "32/carbon-for-ibm-dotcom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CarbonForIbmDotcom32",
          "filepath": "carbon-for-ibm-dotcom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55\tv6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55\tC29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV24.88z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z"
                }
              }
            ],
            "name": "carbon-for-ibm-dotcom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CarbonForIbmDotcom24",
          "filepath": "carbon-for-ibm-dotcom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55\tv6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55\tC29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV24.88z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z"
                }
              }
            ],
            "name": "carbon-for-ibm-dotcom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CarbonForIbmDotcom20",
          "filepath": "carbon-for-ibm-dotcom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55\tv6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55\tC29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV24.88z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z"
                }
              }
            ],
            "name": "carbon-for-ibm-dotcom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CarbonForIbmDotcom16",
          "filepath": "carbon-for-ibm-dotcom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55\tv6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55\tC29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV24.88z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z"
                }
              }
            ],
            "name": "carbon-for-ibm-dotcom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "CarbonForIbmDotcom",
        "global": "CarbonForIbmDotcom",
        "filepath": "CarbonForIbmDotcom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55 v6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55 C29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958 V24.88z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "6",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "6",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "carbon-for-ibm-product",
      "friendlyName": "Carbon for IBM product",
      "aliases": [
        "carbon",
        "IBM",
        "digital",
        "product",
        "IBM Carbon",
        "product design system",
        "IBM product design system",
        "design",
        "hexagon"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/carbon-for-ibm-product.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9\n\tc0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55\n\tC22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\n\tV19.88z\"/>\n<path d=\"M6,20.184V11.07l6.2-3.664l-1.017-1.722L4.491,9.639C4.187,9.819,4,10.146,4,10.5v9.684C2.839,20.598,2,21.698,2,23\n\tc0,1.654,1.346,3,3,3s3-1.346,3-3C8,21.698,7.161,20.598,6,20.184z M5,24c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1\n\tS5.551,24,5,24z\"/>\n<path d=\"M27,20c-1.654,0-3,1.346-3,3c0,0.353,0.072,0.687,0.185,1.002L16,28.838l-6.404-3.784l-1.017,1.722l6.912,4.084\n\tC15.648,30.954,15.824,31,16,31s0.352-0.046,0.509-0.139l8.96-5.295C25.919,25.835,26.439,26,27,26c1.654,0,3-1.346,3-3\n\tS28.654,20,27,20z M27,24c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S27.551,24,27,24z\"/>\n<path d=\"M16,7c0.731,0,1.392-0.273,1.913-0.708L26,11.071V18h2v-7.5c0-0.354-0.187-0.681-0.491-0.861l-8.567-5.062\n\tC18.978,4.39,19,4.198,19,4c0-1.654-1.346-3-3-3s-3,1.346-3,3S14.346,7,16,7z M16,3c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1\n\tS15.449,3,16,3z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9\tc0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55\tC22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV19.88z\"/><path d=\"M6 20.184V11.07l6.2-3.664-1.017-1.722L4.491 9.639C4.187 9.819 4 10.146 4 10.5v9.684C2.839 20.598 2 21.698 2 23c0 1.654 1.346 3 3 3s3-1.346 3-3C8 21.698 7.161 20.598 6 20.184zM5 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S5.551 24 5 24zM27 20c-1.654 0-3 1.346-3 3 0 .353.072.687.185 1.002L16 28.838l-6.404-3.784-1.017 1.722 6.912 4.084C15.648 30.954 15.824 31 16 31s.352-.046.509-.139l8.96-5.295C25.919 25.835 26.439 26 27 26c1.654 0 3-1.346 3-3S28.654 20 27 20zM27 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S27.551 24 27 24zM16 7c.731 0 1.392-.273 1.913-.708L26 11.071V18h2v-7.5c0-.354-.187-.681-.491-.861l-8.567-5.062C18.978 4.39 19 4.198 19 4c0-1.654-1.346-3-3-3s-3 1.346-3 3S14.346 7 16 7zM16 3c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1S15.449 3 16 3z\"/></svg>",
            "info": {},
            "path": "32/carbon-for-ibm-product.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CarbonForIbmProduct32",
          "filepath": "carbon-for-ibm-product/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9\tc0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55\tC22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV19.88z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20.184V11.07l6.2-3.664-1.017-1.722L4.491 9.639C4.187 9.819 4 10.146 4 10.5v9.684C2.839 20.598 2 21.698 2 23c0 1.654 1.346 3 3 3s3-1.346 3-3C8 21.698 7.161 20.598 6 20.184zM5 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S5.551 24 5 24zM27 20c-1.654 0-3 1.346-3 3 0 .353.072.687.185 1.002L16 28.838l-6.404-3.784-1.017 1.722 6.912 4.084C15.648 30.954 15.824 31 16 31s.352-.046.509-.139l8.96-5.295C25.919 25.835 26.439 26 27 26c1.654 0 3-1.346 3-3S28.654 20 27 20zM27 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S27.551 24 27 24zM16 7c.731 0 1.392-.273 1.913-.708L26 11.071V18h2v-7.5c0-.354-.187-.681-.491-.861l-8.567-5.062C18.978 4.39 19 4.198 19 4c0-1.654-1.346-3-3-3s-3 1.346-3 3S14.346 7 16 7zM16 3c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1S15.449 3 16 3z"
                }
              }
            ],
            "name": "carbon-for-ibm-product",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CarbonForIbmProduct24",
          "filepath": "carbon-for-ibm-product/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9\tc0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55\tC22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV19.88z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20.184V11.07l6.2-3.664-1.017-1.722L4.491 9.639C4.187 9.819 4 10.146 4 10.5v9.684C2.839 20.598 2 21.698 2 23c0 1.654 1.346 3 3 3s3-1.346 3-3C8 21.698 7.161 20.598 6 20.184zM5 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S5.551 24 5 24zM27 20c-1.654 0-3 1.346-3 3 0 .353.072.687.185 1.002L16 28.838l-6.404-3.784-1.017 1.722 6.912 4.084C15.648 30.954 15.824 31 16 31s.352-.046.509-.139l8.96-5.295C25.919 25.835 26.439 26 27 26c1.654 0 3-1.346 3-3S28.654 20 27 20zM27 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S27.551 24 27 24zM16 7c.731 0 1.392-.273 1.913-.708L26 11.071V18h2v-7.5c0-.354-.187-.681-.491-.861l-8.567-5.062C18.978 4.39 19 4.198 19 4c0-1.654-1.346-3-3-3s-3 1.346-3 3S14.346 7 16 7zM16 3c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1S15.449 3 16 3z"
                }
              }
            ],
            "name": "carbon-for-ibm-product",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CarbonForIbmProduct20",
          "filepath": "carbon-for-ibm-product/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9\tc0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55\tC22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV19.88z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20.184V11.07l6.2-3.664-1.017-1.722L4.491 9.639C4.187 9.819 4 10.146 4 10.5v9.684C2.839 20.598 2 21.698 2 23c0 1.654 1.346 3 3 3s3-1.346 3-3C8 21.698 7.161 20.598 6 20.184zM5 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S5.551 24 5 24zM27 20c-1.654 0-3 1.346-3 3 0 .353.072.687.185 1.002L16 28.838l-6.404-3.784-1.017 1.722 6.912 4.084C15.648 30.954 15.824 31 16 31s.352-.046.509-.139l8.96-5.295C25.919 25.835 26.439 26 27 26c1.654 0 3-1.346 3-3S28.654 20 27 20zM27 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S27.551 24 27 24zM16 7c.731 0 1.392-.273 1.913-.708L26 11.071V18h2v-7.5c0-.354-.187-.681-.491-.861l-8.567-5.062C18.978 4.39 19 4.198 19 4c0-1.654-1.346-3-3-3s-3 1.346-3 3S14.346 7 16 7zM16 3c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1S15.449 3 16 3z"
                }
              }
            ],
            "name": "carbon-for-ibm-product",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CarbonForIbmProduct16",
          "filepath": "carbon-for-ibm-product/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9\tc0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55\tC22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958\tV19.88z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20.184V11.07l6.2-3.664-1.017-1.722L4.491 9.639C4.187 9.819 4 10.146 4 10.5v9.684C2.839 20.598 2 21.698 2 23c0 1.654 1.346 3 3 3s3-1.346 3-3C8 21.698 7.161 20.598 6 20.184zM5 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S5.551 24 5 24zM27 20c-1.654 0-3 1.346-3 3 0 .353.072.687.185 1.002L16 28.838l-6.404-3.784-1.017 1.722 6.912 4.084C15.648 30.954 15.824 31 16 31s.352-.046.509-.139l8.96-5.295C25.919 25.835 26.439 26 27 26c1.654 0 3-1.346 3-3S28.654 20 27 20zM27 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S27.551 24 27 24zM16 7c.731 0 1.392-.273 1.913-.708L26 11.071V18h2v-7.5c0-.354-.187-.681-.491-.861l-8.567-5.062C18.978 4.39 19 4.198 19 4c0-1.654-1.346-3-3-3s-3 1.346-3 3S14.346 7 16 7zM16 3c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1S15.449 3 16 3z"
                }
              }
            ],
            "name": "carbon-for-ibm-product",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "CarbonForIbmProduct",
        "global": "CarbonForIbmProduct",
        "filepath": "CarbonForIbmProduct.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9 c0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55 C22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958 V19.88z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 20.184V11.07l6.2-3.664-1.017-1.722L4.491 9.639C4.187 9.819 4 10.146 4 10.5v9.684C2.839 20.598 2 21.698 2 23c0 1.654 1.346 3 3 3s3-1.346 3-3C8 21.698 7.161 20.598 6 20.184zM5 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S5.551 24 5 24zM27 20c-1.654 0-3 1.346-3 3 0 .353.072.687.185 1.002L16 28.838l-6.404-3.784-1.017 1.722 6.912 4.084C15.648 30.954 15.824 31 16 31s.352-.046.509-.139l8.96-5.295C25.919 25.835 26.439 26 27 26c1.654 0 3-1.346 3-3S28.654 20 27 20zM27 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S27.551 24 27 24zM16 7c.731 0 1.392-.273 1.913-.708L26 11.071V18h2v-7.5c0-.354-.187-.681-.491-.861l-8.567-5.062C18.978 4.39 19 4.198 19 4c0-1.654-1.346-3-3-3s-3 1.346-3 3S14.346 7 16 7zM16 3c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1S15.449 3 16 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caret--down",
      "friendlyName": "Caret down",
      "aliases": [
        "pointer",
        "open",
        "close",
        "expand",
        "collapse",
        "daret",
        "down caret",
        "down arrow",
        "down triangle"
      ],
      "sizes": [
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "caret--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"8px\" height=\"4px\" viewBox=\"0 0 8 4\" style=\"enable-background:new 0 0 8 4;\" xml:space=\"preserve\">\n<polygon points=\"8,0 4,4 0,0 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 4\"><path d=\"M8 0L4 4 0 0z\"/></svg>",
            "info": {},
            "path": "caret--down.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/caret--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>caret--down</title>\n<polygon points=\"24,12 16,22 8,12 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 12L16 22 8 12z\"/></svg>",
            "info": {},
            "path": "32/caret--down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CaretDown32",
          "filepath": "caret--down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12L16 22 8 12z"
                }
              }
            ],
            "name": "caret--down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CaretDown24",
          "filepath": "caret--down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12L16 22 8 12z"
                }
              }
            ],
            "name": "caret--down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CaretDown20",
          "filepath": "caret--down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12L16 22 8 12z"
                }
              }
            ],
            "name": "caret--down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CaretDown16",
          "filepath": "caret--down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12L16 22 8 12z"
                }
              }
            ],
            "name": "caret--down",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 8 4",
              "fill": "currentColor",
              "width": "8",
              "height": "4"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 0L4 4 0 0z"
                }
              }
            ],
            "name": "caret--down",
            "size": "glyph"
          },
          "moduleName": "CaretDownGlyph",
          "filepath": "caret--down/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "CaretDown",
        "global": "CaretDown",
        "filepath": "CaretDown.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 8 4",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 0L4 4 0 0z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 12L16 22 8 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caret--left",
      "friendlyName": "Caret left",
      "aliases": [
        "pointer",
        "open",
        "close",
        "expand",
        "collapse",
        "caret",
        "left caret",
        "left arrow",
        "left triangle"
      ],
      "sizes": [
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "caret--left.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"5px\" height=\"8px\" viewBox=\"0 0 5 8\" style=\"enable-background:new 0 0 5 8;\" xml:space=\"preserve\">\n<polygon points=\"5,8 0,4 5,0 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 8\"><path d=\"M5 8L0 4 5 0z\"/></svg>",
            "info": {},
            "path": "caret--left.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/caret--left.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>caret--right</title>\n<polygon points=\"20,24 10,16 20,8 \"/>\n<rect class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 24L10 16 20 8z\"/></svg>",
            "info": {},
            "path": "32/caret--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CaretLeft32",
          "filepath": "caret--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24L10 16 20 8z"
                }
              }
            ],
            "name": "caret--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CaretLeft24",
          "filepath": "caret--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24L10 16 20 8z"
                }
              }
            ],
            "name": "caret--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CaretLeft20",
          "filepath": "caret--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24L10 16 20 8z"
                }
              }
            ],
            "name": "caret--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CaretLeft16",
          "filepath": "caret--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24L10 16 20 8z"
                }
              }
            ],
            "name": "caret--left",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 5 8",
              "fill": "currentColor",
              "width": "5",
              "height": "8"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 8L0 4 5 0z"
                }
              }
            ],
            "name": "caret--left",
            "size": "glyph"
          },
          "moduleName": "CaretLeftGlyph",
          "filepath": "caret--left/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "CaretLeft",
        "global": "CaretLeft",
        "filepath": "CaretLeft.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 5 8",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 8L0 4 5 0z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 24L10 16 20 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caret--right",
      "friendlyName": "Caret right",
      "aliases": [
        "pointer",
        "open",
        "close",
        "expand",
        "collapse",
        "caret",
        "right caret",
        "right arrow",
        "right triangle"
      ],
      "sizes": [
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "caret--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"5px\" height=\"8px\" viewBox=\"0 0 5 8\" style=\"enable-background:new 0 0 5 8;\" xml:space=\"preserve\">\n<polygon points=\"0,0 5,4 0,8 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 8\"><path d=\"M0 0L5 4 0 8z\"/></svg>",
            "info": {},
            "path": "caret--right.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/caret--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>caret--right</title>\n<polygon points=\"12,8 22,16 12,24 \"/>\n<rect class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 8L22 16 12 24z\"/></svg>",
            "info": {},
            "path": "32/caret--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CaretRight32",
          "filepath": "caret--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 8L22 16 12 24z"
                }
              }
            ],
            "name": "caret--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CaretRight24",
          "filepath": "caret--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 8L22 16 12 24z"
                }
              }
            ],
            "name": "caret--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CaretRight20",
          "filepath": "caret--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 8L22 16 12 24z"
                }
              }
            ],
            "name": "caret--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CaretRight16",
          "filepath": "caret--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 8L22 16 12 24z"
                }
              }
            ],
            "name": "caret--right",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 5 8",
              "fill": "currentColor",
              "width": "5",
              "height": "8"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M0 0L5 4 0 8z"
                }
              }
            ],
            "name": "caret--right",
            "size": "glyph"
          },
          "moduleName": "CaretRightGlyph",
          "filepath": "caret--right/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "CaretRight",
        "global": "CaretRight",
        "filepath": "CaretRight.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 5 8",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M0 0L5 4 0 8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 8L22 16 12 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caret--sort",
      "friendlyName": "Caret sort",
      "aliases": [
        "pointer",
        "open",
        "close",
        "expand",
        "collapse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/caret--sort.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>caret--sort</title>\n<polygon points=\"24,24 16,32 8,24 \"/>\n<polygon points=\"8,8 16,0 24,8 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 24L16 32 8 24zM8 8L16 0 24 8z\"/></svg>",
            "info": {},
            "path": "32/caret--sort.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CaretSort32",
          "filepath": "caret--sort/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24zM8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CaretSort24",
          "filepath": "caret--sort/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24zM8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CaretSort20",
          "filepath": "caret--sort/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24zM8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CaretSort16",
          "filepath": "caret--sort/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24zM8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CaretSort",
        "global": "CaretSort",
        "filepath": "CaretSort.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 24L16 32 8 24zM8 8L16 0 24 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caret--sort--down",
      "friendlyName": "Caret sort down",
      "aliases": [
        "pointer",
        "open",
        "close",
        "expand",
        "collapse",
        "caret sort down",
        "sort down",
        "caret down",
        "sort arrow down",
        "arrow down",
        "down arrow",
        "down triangle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/caret--sort--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>caret--sort</title>\n<polygon points=\"24,24 16,32 8,24 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 24L16 32 8 24z\"/></svg>",
            "info": {},
            "path": "32/caret--sort--down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CaretSortDown32",
          "filepath": "caret--sort--down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24z"
                }
              }
            ],
            "name": "caret--sort--down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CaretSortDown24",
          "filepath": "caret--sort--down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24z"
                }
              }
            ],
            "name": "caret--sort--down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CaretSortDown20",
          "filepath": "caret--sort--down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24z"
                }
              }
            ],
            "name": "caret--sort--down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CaretSortDown16",
          "filepath": "caret--sort--down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24L16 32 8 24z"
                }
              }
            ],
            "name": "caret--sort--down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CaretSortDown",
        "global": "CaretSortDown",
        "filepath": "CaretSortDown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 24L16 32 8 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caret--sort--up",
      "friendlyName": "Caret sort up",
      "aliases": [
        "pointer",
        "open",
        "close",
        "expand",
        "collapse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/caret--sort--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>caret--sort</title>\n<polygon points=\"8,8 16,0 24,8 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 8L16 0 24 8z\"/></svg>",
            "info": {},
            "path": "32/caret--sort--up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CaretSortUp32",
          "filepath": "caret--sort--up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort--up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CaretSortUp24",
          "filepath": "caret--sort--up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort--up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CaretSortUp20",
          "filepath": "caret--sort--up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort--up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CaretSortUp16",
          "filepath": "caret--sort--up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8L16 0 24 8z"
                }
              }
            ],
            "name": "caret--sort--up",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CaretSortUp",
        "global": "CaretSortUp",
        "filepath": "CaretSortUp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 8L16 0 24 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caret--up",
      "friendlyName": "Caret up",
      "aliases": [
        "pointer",
        "open",
        "close",
        "expand",
        "collapse",
        "caret sort up",
        "sort up",
        "caret up",
        "sort arrow up",
        "arrow up",
        "up arrow",
        "up triangle"
      ],
      "sizes": [
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "caret--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"8px\" height=\"4px\" viewBox=\"0 0 8 4\" style=\"enable-background:new 0 0 8 4;\" xml:space=\"preserve\">\n<polygon points=\"0,4 4,0 8,4 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 4\"><path d=\"M0 4L4 0 8 4z\"/></svg>",
            "info": {},
            "path": "caret--up.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/caret--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>caret--right</title>\n<polygon points=\"8,20 16,10 24,20 \"/>\n<rect class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 20L16 10 24 20z\"/></svg>",
            "info": {},
            "path": "32/caret--up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CaretUp32",
          "filepath": "caret--up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20L16 10 24 20z"
                }
              }
            ],
            "name": "caret--up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CaretUp24",
          "filepath": "caret--up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20L16 10 24 20z"
                }
              }
            ],
            "name": "caret--up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CaretUp20",
          "filepath": "caret--up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20L16 10 24 20z"
                }
              }
            ],
            "name": "caret--up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CaretUp16",
          "filepath": "caret--up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20L16 10 24 20z"
                }
              }
            ],
            "name": "caret--up",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 8 4",
              "fill": "currentColor",
              "width": "8",
              "height": "4"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M0 4L4 0 8 4z"
                }
              }
            ],
            "name": "caret--up",
            "size": "glyph"
          },
          "moduleName": "CaretUpGlyph",
          "filepath": "caret--up/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "CaretUp",
        "global": "CaretUp",
        "filepath": "CaretUp.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 8 4",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M0 4L4 0 8 4z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 20L16 10 24 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "carousel--horizontal",
      "friendlyName": "Carousel horizontal",
      "aliases": [
        "roundabout",
        "ride",
        "image",
        "gallery",
        "sequence",
        "carousel horizontal",
        "horizontal carousel",
        "scroll"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/carousel--horizontal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>carousel--horizontal</title><path d=\"M22,26H10a2,2,0,0,1-2-2V8a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2V24A2,2,0,0,1,22,26ZM10,8V24H22V8Z\"/><path d=\"M4,24H0V22H4V10H0V8H4a2,2,0,0,1,2,2V22A2,2,0,0,1,4,24Z\"/><path d=\"M32,24H28a2,2,0,0,1-2-2V10a2,2,0,0,1,2-2h4v2H28V22h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z\"/></svg>",
            "info": {},
            "path": "32/carousel--horizontal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CarouselHorizontal32",
          "filepath": "carousel--horizontal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z"
                }
              }
            ],
            "name": "carousel--horizontal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CarouselHorizontal24",
          "filepath": "carousel--horizontal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z"
                }
              }
            ],
            "name": "carousel--horizontal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CarouselHorizontal20",
          "filepath": "carousel--horizontal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z"
                }
              }
            ],
            "name": "carousel--horizontal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CarouselHorizontal16",
          "filepath": "carousel--horizontal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z"
                }
              }
            ],
            "name": "carousel--horizontal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "CarouselHorizontal",
        "global": "CarouselHorizontal",
        "filepath": "CarouselHorizontal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "carousel--vertical",
      "friendlyName": "Carousel vertical",
      "aliases": [
        "roundabout",
        "ride",
        "image",
        "gallery",
        "sequence",
        "carousel vertical",
        "vertical carousel",
        "scroll"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/carousel--vertical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>carousel--vertical</title><path d=\"M26,10V22a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V10A2,2,0,0,1,8,8H24A2,2,0,0,1,26,10ZM8,22H24V10H8Z\" transform=\"translate(0 0)\"/><path d=\"M24,28v4H22V28H10v4H8V28a2,2,0,0,1,2-2H22A2,2,0,0,1,24,28Z\" transform=\"translate(0 0)\"/><path d=\"M24,0V4a2,2,0,0,1-2,2H10A2,2,0,0,1,8,4V0h2V4H22V0Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(0 32) rotate(-90)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z\"/></svg>",
            "info": {},
            "path": "32/carousel--vertical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CarouselVertical32",
          "filepath": "carousel--vertical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z"
                }
              }
            ],
            "name": "carousel--vertical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CarouselVertical24",
          "filepath": "carousel--vertical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z"
                }
              }
            ],
            "name": "carousel--vertical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CarouselVertical20",
          "filepath": "carousel--vertical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z"
                }
              }
            ],
            "name": "carousel--vertical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CarouselVertical16",
          "filepath": "carousel--vertical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z"
                }
              }
            ],
            "name": "carousel--vertical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "CarouselVertical",
        "global": "CarouselVertical",
        "filepath": "CarouselVertical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "catalog",
      "friendlyName": "Catalog",
      "aliases": [
        "notebook",
        "book",
        "list",
        "schedule",
        "catagorize",
        "catalog",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/catalog.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>catalog</title><path d=\"M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z\" transform=\"translate(0 0)\"/><rect x=\"14\" y=\"8\" width=\"8\" height=\"2\"/><rect x=\"14\" y=\"15\" width=\"8\" height=\"2\"/><rect x=\"14\" y=\"22\" width=\"8\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z\"/><path d=\"M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z\"/></svg>",
            "info": {},
            "path": "32/catalog.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Catalog32",
          "filepath": "catalog/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z"
                }
              }
            ],
            "name": "catalog",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Catalog24",
          "filepath": "catalog/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z"
                }
              }
            ],
            "name": "catalog",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Catalog20",
          "filepath": "catalog/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z"
                }
              }
            ],
            "name": "catalog",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Catalog16",
          "filepath": "catalog/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z"
                }
              }
            ],
            "name": "catalog",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Catalog",
        "global": "Catalog",
        "filepath": "Catalog.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "catalog--publish",
      "friendlyName": "catalog--publish",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/catalog--publish.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"20,20 21.4,21.4 18.8,24 28,24 28,26 18.8,26 21.4,28.6 20,30 15,25 \"/>\n<rect x=\"14\" y=\"15\" width=\"8\" height=\"2\"/>\n<rect x=\"14\" y=\"8\" width=\"8\" height=\"2\"/>\n<path d=\"M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4\n\tc0,1.1,0.9,2,2,2h5V28z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z\"/><path d=\"M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4\tc0,1.1,0.9,2,2,2h5V28z\"/></svg>",
            "info": {},
            "path": "32/catalog--publish.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CatalogPublish32",
          "filepath": "catalog--publish/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4\tc0,1.1,0.9,2,2,2h5V28z"
                }
              }
            ],
            "name": "catalog--publish",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CatalogPublish24",
          "filepath": "catalog--publish/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4\tc0,1.1,0.9,2,2,2h5V28z"
                }
              }
            ],
            "name": "catalog--publish",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CatalogPublish20",
          "filepath": "catalog--publish/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4\tc0,1.1,0.9,2,2,2h5V28z"
                }
              }
            ],
            "name": "catalog--publish",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CatalogPublish16",
          "filepath": "catalog--publish/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4\tc0,1.1,0.9,2,2,2h5V28z"
                }
              }
            ],
            "name": "catalog--publish",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CatalogPublish",
        "global": "CatalogPublish",
        "filepath": "CatalogPublish.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4 c0,1.1,0.9,2,2,2h5V28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "categories",
      "friendlyName": "Categories",
      "aliases": [
        "group",
        "section",
        "class",
        "department"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/categories.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>categories</title><path d=\"M6.76,6l.45.89L7.76,8H12v5H4V6H6.76m.62-2H3A1,1,0,0,0,2,5v9a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H9L8.28,4.55A1,1,0,0,0,7.38,4Z\" transform=\"translate(0 0)\"/><path d=\"M22.76,6l.45.89L23.76,8H28v5H20V6h2.76m.62-2H19a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H25l-.72-1.45a1,1,0,0,0-.9-.55Z\" transform=\"translate(0 0)\"/><path d=\"M6.76,19l.45.89L7.76,21H12v5H4V19H6.76m.62-2H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V20a1,1,0,0,0-1-1H9l-.72-1.45a1,1,0,0,0-.9-.55Z\" transform=\"translate(0 0)\"/><path d=\"M22.76,19l.45.89L23.76,21H28v5H20V19h2.76m.62-2H19a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V20a1,1,0,0,0-1-1H25l-.72-1.45a1,1,0,0,0-.9-.55Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z\"/></svg>",
            "info": {},
            "path": "32/categories.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Categories32",
          "filepath": "categories/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z"
                }
              }
            ],
            "name": "categories",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Categories24",
          "filepath": "categories/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z"
                }
              }
            ],
            "name": "categories",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Categories20",
          "filepath": "categories/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z"
                }
              }
            ],
            "name": "categories",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Categories16",
          "filepath": "categories/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z"
                }
              }
            ],
            "name": "categories",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Categories",
        "global": "Categories",
        "filepath": "Categories.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "category",
      "friendlyName": "Category",
      "aliases": [
        "category",
        "file",
        "categorize"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/category.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>category</title><path d=\"M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/category.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Category32",
          "filepath": "category/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "category",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Category24",
          "filepath": "category/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "category",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Category20",
          "filepath": "category/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "category",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Category16",
          "filepath": "category/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "category",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Category",
        "global": "Category",
        "filepath": "Category.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "category--add",
      "friendlyName": "Category add",
      "aliases": [
        "category",
        "file",
        "categorize",
        "list",
        "category add",
        "add category"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/category--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>category--add</title><polygon points=\"15 6 13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6\"/><path d=\"M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z\"/><path d=\"M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z\"/></svg>",
            "info": {},
            "path": "32/category--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CategoryAdd32",
          "filepath": "category--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CategoryAdd24",
          "filepath": "category--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CategoryAdd20",
          "filepath": "category--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CategoryAdd16",
          "filepath": "category--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CategoryAdd",
        "global": "CategoryAdd",
        "filepath": "CategoryAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "category--and",
      "friendlyName": "Category and",
      "aliases": [
        "category",
        "file",
        "categorize",
        "category and"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/category--and.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>category--and</title><path d=\"M4,30V26H15v4h2V26H28v4h2V26a2,2,0,0,0-2-2H17V19H15v5H4a2,2,0,0,0-2,2v4Z\"/><path d=\"M20.6953,13.9858A10.08,10.08,0,0,0,21.9463,10H23V8H20V9a9.2634,9.2634,0,0,1-.6641,3.2705L16.6511,8.8816a5.1261,5.1261,0,0,0,2.1436-2.3694A3.2522,3.2522,0,0,0,18.6062,3.81a3.38,3.38,0,0,0-2.2391-1.7056,3.4688,3.4688,0,0,0-4.2223,2.1186c-.5044,1.5518.4406,3.1158,1.2612,4.1077A4.7255,4.7255,0,0,0,11.06,13.1587,4.4526,4.4526,0,0,0,15.4268,17h.0058a5.7844,5.7844,0,0,0,3.9717-1.4233L20.532,17h2.5519ZM14.047,4.8413A1.3224,1.3224,0,0,1,15.4141,4a2.41,2.41,0,0,1,.5214.0581,1.4018,1.4018,0,0,1,.9111.7022,1.2493,1.2493,0,0,1,.0791,1.042A3.6871,3.6871,0,0,1,15.2441,7.395C14.5831,6.6816,13.8087,5.5732,14.047,4.8413ZM15.4316,15h-.0039a2.4432,2.4432,0,0,1-2.3916-2.1509,2.8261,2.8261,0,0,1,1.81-3.0249l3.3115,4.1787A3.8853,3.8853,0,0,1,15.4316,15Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z\"/></svg>",
            "info": {},
            "path": "32/category--and.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CategoryAnd32",
          "filepath": "category--and/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z"
                }
              }
            ],
            "name": "category--and",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CategoryAnd24",
          "filepath": "category--and/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z"
                }
              }
            ],
            "name": "category--and",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CategoryAnd20",
          "filepath": "category--and/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z"
                }
              }
            ],
            "name": "category--and",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CategoryAnd16",
          "filepath": "category--and/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z"
                }
              }
            ],
            "name": "category--and",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CategoryAnd",
        "global": "CategoryAnd",
        "filepath": "CategoryAnd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "category--new",
      "friendlyName": "Category new",
      "aliases": [
        "category",
        "file",
        "categorize",
        "list",
        "category new",
        "new category"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/category--new.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>category--new</title><polygon points=\"21 10 17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10\"/><path d=\"M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z\"/><path d=\"M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z\"/></svg>",
            "info": {},
            "path": "32/category--new.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CategoryNew32",
          "filepath": "category--new/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--new",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CategoryNew24",
          "filepath": "category--new/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--new",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CategoryNew20",
          "filepath": "category--new/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--new",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CategoryNew16",
          "filepath": "category--new/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                }
              }
            ],
            "name": "category--new",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CategoryNew",
        "global": "CategoryNew",
        "filepath": "CategoryNew.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "category--new-each",
      "friendlyName": "Category new each",
      "aliases": [
        "category",
        "file",
        "categorize",
        "list",
        "category new each",
        "each new category"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/category--new-each.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>category--new-each</title><path d=\"M29,10H24v2h5v6H22v2h3v2.142a4,4,0,1,0,2,0V20h2a2.0027,2.0027,0,0,0,2-2V12A2.0023,2.0023,0,0,0,29,10ZM28,26a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,28,26Z\"/><path d=\"M19,6H14V8h5v6H12v2h3v6.142a4,4,0,1,0,2,0V16h2a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,19,6ZM18,26a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Z\"/><path d=\"M9,2H3A2.002,2.002,0,0,0,1,4v6a2.002,2.002,0,0,0,2,2H5V22.142a4,4,0,1,0,2,0V12H9a2.002,2.002,0,0,0,2-2V4A2.002,2.002,0,0,0,9,2ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26ZM3,10V4H9l.0015,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z\"/></svg>",
            "info": {},
            "path": "32/category--new-each.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CategoryNewEach32",
          "filepath": "category--new-each/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z"
                }
              }
            ],
            "name": "category--new-each",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CategoryNewEach24",
          "filepath": "category--new-each/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z"
                }
              }
            ],
            "name": "category--new-each",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CategoryNewEach20",
          "filepath": "category--new-each/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z"
                }
              }
            ],
            "name": "category--new-each",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CategoryNewEach16",
          "filepath": "category--new-each/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z"
                }
              }
            ],
            "name": "category--new-each",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CategoryNewEach",
        "global": "CategoryNewEach",
        "filepath": "CategoryNewEach.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caution",
      "friendlyName": "Caution",
      "aliases": [
        "caution",
        "warning",
        "triangle",
        "filled"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "caution.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_Outer_Path_\" data-name=\"&lt;Outer Path&gt;\" d=\"M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z\"/>\n  <polygon points=\"12.315 12 3.685 12 8 4.088 12.315 12\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z\"/><path d=\"M12.315 12L3.685 12 8 4.088 12.315 12z\"/></svg>",
            "info": {},
            "path": "caution.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.315 12L3.685 12 8 4.088 12.315 12z"
                }
              }
            ],
            "name": "caution",
            "size": "glyph"
          },
          "moduleName": "CautionGlyph",
          "filepath": "caution/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Caution",
        "global": "Caution",
        "filepath": "Caution.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.315 12L3.685 12 8 4.088 12.315 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "caution-inverted",
      "friendlyName": "Caution inverted",
      "aliases": [
        "caution",
        "warning",
        "inverted",
        "triangle",
        "filled"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "caution-inverted.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"8 14 2 3 14 3 8 14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 14L2 3 14 3 8 14z\"/></svg>",
            "info": {},
            "path": "caution-inverted.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14L2 3 14 3 8 14z"
                }
              }
            ],
            "name": "caution-inverted",
            "size": "glyph"
          },
          "moduleName": "CautionInvertedGlyph",
          "filepath": "caution-inverted/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CautionInverted",
        "global": "CautionInverted",
        "filepath": "CautionInverted.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 14L2 3 14 3 8 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ccX",
      "friendlyName": "ccX",
      "aliases": [
        "Q",
        "cc",
        "c",
        "X",
        "core complex",
        "CPU complex"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/ccX.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--ccX</title><path d=\"M10,23H5a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H5v6h5Z\"/><path d=\"M19,23H14a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H14v6h5Z\"/><polygon points=\"29 9 27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z\"/></svg>",
            "info": {},
            "path": "32/Q/ccX.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QCcX32",
          "filepath": "Q/ccX/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
                }
              }
            ],
            "name": "ccX",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QCcX24",
          "filepath": "Q/ccX/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
                }
              }
            ],
            "name": "ccX",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QCcX20",
          "filepath": "Q/ccX/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
                }
              }
            ],
            "name": "ccX",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QCcX16",
          "filepath": "Q/ccX/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
                }
              }
            ],
            "name": "ccX",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "CcX",
        "global": "QCcX",
        "filepath": "Q/CcX.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cd--archive",
      "friendlyName": "CD archive",
      "aliases": [
        "target",
        "mark",
        "spot",
        "bull's eye",
        "archive-CD",
        "archive",
        "copy"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/cd--archive.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--cd--archive</title><path d=\"M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z\"/><path d=\"M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z\"/><path d=\"M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/watson-health/cd--archive.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthCdArchive32",
          "filepath": "watson-health/cd--archive/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "cd--archive",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthCdArchive24",
          "filepath": "watson-health/cd--archive/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "cd--archive",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthCdArchive20",
          "filepath": "watson-health/cd--archive/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "cd--archive",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthCdArchive16",
          "filepath": "watson-health/cd--archive/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "cd--archive",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "CdArchive",
        "global": "WatsonHealthCdArchive",
        "filepath": "watson-health/CdArchive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cd--create-archive",
      "friendlyName": "CD create archive",
      "aliases": [
        "target",
        "mark",
        "spot",
        "bull's eye",
        "CD create archive",
        "create CD archive",
        "archive",
        "copy"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/cd--create-archive.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--cd--create-archive</title><path d=\"M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z\"/><circle cx=\"14\" cy=\"14\" r=\"2\"/><path d=\"M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z\"/><path d=\"M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z\"/><circle cx=\"14\" cy=\"14\" r=\"2\"/><path d=\"M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z\"/><path d=\"M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/cd--create-archive.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthCdCreateArchive32",
          "filepath": "watson-health/cd--create-archive/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
                }
              }
            ],
            "name": "cd--create-archive",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthCdCreateArchive24",
          "filepath": "watson-health/cd--create-archive/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
                }
              }
            ],
            "name": "cd--create-archive",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthCdCreateArchive20",
          "filepath": "watson-health/cd--create-archive/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
                }
              }
            ],
            "name": "cd--create-archive",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthCdCreateArchive16",
          "filepath": "watson-health/cd--create-archive/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
                }
              }
            ],
            "name": "cd--create-archive",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "CdCreateArchive",
        "global": "WatsonHealthCdCreateArchive",
        "filepath": "watson-health/CdCreateArchive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cd--create-exchange",
      "friendlyName": "CD create exchange",
      "aliases": [
        "target",
        "mark",
        "spot",
        "bull's eye",
        "CD create exchange",
        "create CD exchange",
        "exchange",
        "CD exchange",
        "copy"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/cd--create-exchange.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--cd--creat-exchange</title><circle cx=\"14\" cy=\"14\" r=\"2\"/><path d=\"M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z\"/><polygon points=\"17 24 26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24\"/><path d=\"M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"14\" cy=\"14\" r=\"2\"/><path d=\"M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z\"/><path d=\"M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z\"/></svg>",
            "info": {},
            "path": "32/watson-health/cd--create-exchange.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthCdCreateExchange32",
          "filepath": "watson-health/cd--create-exchange/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z"
                }
              }
            ],
            "name": "cd--create-exchange",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthCdCreateExchange24",
          "filepath": "watson-health/cd--create-exchange/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z"
                }
              }
            ],
            "name": "cd--create-exchange",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthCdCreateExchange20",
          "filepath": "watson-health/cd--create-exchange/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z"
                }
              }
            ],
            "name": "cd--create-exchange",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthCdCreateExchange16",
          "filepath": "watson-health/cd--create-exchange/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z"
                }
              }
            ],
            "name": "cd--create-exchange",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "CdCreateExchange",
        "global": "WatsonHealthCdCreateExchange",
        "filepath": "watson-health/CdCreateExchange.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "CDA",
      "friendlyName": "CDA",
      "aliases": [
        "CDA",
        "compact disc audio",
        "filename extension",
        "extension"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/CDA.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>CDA</title><path d=\"M28,9H24a2.002,2.002,0,0,0-2,2V23h2V18h4v5h2V11A2.0023,2.0023,0,0,0,28,9Zm-4,7V11h4v5Z\"/><path d=\"M16,23H12V9h4a4.0042,4.0042,0,0,1,4,4v6A4.0039,4.0039,0,0,1,16,23Zm-2-2h2a2.0027,2.0027,0,0,0,2-2V13a2.0023,2.0023,0,0,0-2-2H14Z\"/><path d=\"M10,23H4a2.0023,2.0023,0,0,1-2-2V11A2.002,2.002,0,0,1,4,9h6v2H4V21h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z\"/></svg>",
            "info": {},
            "path": "32/CDA.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cda32",
          "filepath": "CDA/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CDA",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cda24",
          "filepath": "CDA/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CDA",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cda20",
          "filepath": "CDA/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CDA",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cda16",
          "filepath": "CDA/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CDA",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Cda",
        "global": "Cda",
        "filepath": "Cda.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cell-tower",
      "friendlyName": "Cell tower",
      "aliases": [
        "cell",
        "tower",
        "mobile carrier",
        "telecommunications",
        "signal",
        "microwave"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cell-tower.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.2.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"25,11 25,16 17,16 17,11 15,11 15,16 7,16 7,11 5,11 5,23 7,23 7,18 10,18 10,30 12,30 12,18 15,18 15,23 17,23 \n\t17,18 20,18 20,30 22,30 22,18 25,18 25,23 27,23 27,11 \"/>\n<path d=\"M16,6c-1.7,0-3.2,0.7-4.2,1.8l1.4,1.4C13.9,8.4,14.9,8,16,8s2.1,0.4,2.8,1.2l1.4-1.4C19.2,6.7,17.7,6,16,6z\"/>\n<path d=\"M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z\"/><path d=\"M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z\"/></svg>",
            "info": {},
            "path": "32/cell-tower.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CellTower32",
          "filepath": "cell-tower/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
                }
              }
            ],
            "name": "cell-tower",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CellTower24",
          "filepath": "cell-tower/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
                }
              }
            ],
            "name": "cell-tower",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CellTower20",
          "filepath": "cell-tower/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
                }
              }
            ],
            "name": "cell-tower",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CellTower16",
          "filepath": "cell-tower/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
                }
              }
            ],
            "name": "cell-tower",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CellTower",
        "global": "CellTower",
        "filepath": "CellTower.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "center--circle",
      "friendlyName": "Center circle",
      "aliases": [
        "center circle",
        "crosshairs",
        "circle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/center--circle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>center--circle</title><path class=\"cls-1\" d=\"M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z\"/></svg>",
            "info": {},
            "path": "32/center--circle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CenterCircle32",
          "filepath": "center--circle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "center--circle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CenterCircle24",
          "filepath": "center--circle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "center--circle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CenterCircle20",
          "filepath": "center--circle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "center--circle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CenterCircle16",
          "filepath": "center--circle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "center--circle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CenterCircle",
        "global": "CenterCircle",
        "filepath": "CenterCircle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "center--square",
      "friendlyName": "Center square",
      "aliases": [
        "center square",
        "cross",
        "square",
        "focus"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/center--square.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>center--square</title><polygon points=\"6 12 4 12 4 4 12 4 12 6 6 6 6 12\"/><polygon points=\"28 12 26 12 26 6 20 6 20 4 28 4 28 12\"/><polygon points=\"12 28 4 28 4 20 6 20 6 26 12 26 12 28\"/><polygon points=\"28 28 20 28 20 26 26 26 26 20 28 20 28 28\"/><rect x=\"15\" y=\"10\" width=\"2\" height=\"4\"/><rect x=\"10\" y=\"15\" width=\"4\" height=\"2\"/><rect x=\"18\" y=\"15\" width=\"4\" height=\"2\"/><rect x=\"15\" y=\"18\" width=\"2\" height=\"4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z\"/></svg>",
            "info": {},
            "path": "32/center--square.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CenterSquare32",
          "filepath": "center--square/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z"
                }
              }
            ],
            "name": "center--square",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CenterSquare24",
          "filepath": "center--square/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z"
                }
              }
            ],
            "name": "center--square",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CenterSquare20",
          "filepath": "center--square/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z"
                }
              }
            ],
            "name": "center--square",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CenterSquare16",
          "filepath": "center--square/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z"
                }
              }
            ],
            "name": "center--square",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CenterSquare",
        "global": "CenterSquare",
        "filepath": "CenterSquare.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "center-to-fit",
      "friendlyName": "Center to fit",
      "aliases": [
        "center",
        "fit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/center-to-fit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"8 2 2 2 2 8 4 8 4 4 8 4 8 2\"/>\n  <polygon points=\"24 2 30 2 30 8 28 8 28 4 24 4 24 2\"/>\n  <polygon points=\"8 30 2 30 2 24 4 24 4 28 8 28 8 30\"/>\n  <polygon points=\"24 30 30 30 30 24 28 24 28 28 24 28 24 30\"/>\n  <path d=\"M24,24H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,24,24ZM8,10V22H24V10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z\"/></svg>",
            "info": {},
            "path": "32/center-to-fit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CenterToFit32",
          "filepath": "center-to-fit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z"
                }
              }
            ],
            "name": "center-to-fit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CenterToFit24",
          "filepath": "center-to-fit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z"
                }
              }
            ],
            "name": "center-to-fit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CenterToFit20",
          "filepath": "center-to-fit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z"
                }
              }
            ],
            "name": "center-to-fit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CenterToFit16",
          "filepath": "center-to-fit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z"
                }
              }
            ],
            "name": "center-to-fit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "CenterToFit",
        "global": "CenterToFit",
        "filepath": "CenterToFit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "certificate",
      "friendlyName": "Certificate",
      "aliases": [
        "certificate",
        "certificate star",
        "star",
        "diploma"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/certificate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>certificate</title><polygon points=\"24 17 25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17\"/><rect x=\"6\" y=\"16\" width=\"6\" height=\"2\"/><rect x=\"6\" y=\"12\" width=\"10\" height=\"2\"/><rect x=\"6\" y=\"8\" width=\"10\" height=\"2\"/><path d=\"M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z\"/><path d=\"M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z\"/></svg>",
            "info": {},
            "path": "32/certificate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Certificate32",
          "filepath": "certificate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
                }
              }
            ],
            "name": "certificate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Certificate24",
          "filepath": "certificate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
                }
              }
            ],
            "name": "certificate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Certificate20",
          "filepath": "certificate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
                }
              }
            ],
            "name": "certificate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Certificate16",
          "filepath": "certificate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
                }
              }
            ],
            "name": "certificate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Certificate",
        "global": "Certificate",
        "filepath": "Certificate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "certificate--check",
      "friendlyName": "Certificate check",
      "aliases": [
        "certificate",
        "certificate check",
        "checkmark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/certificate--check.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>certificate--check</title><rect x=\"6\" y=\"16\" width=\"6\" height=\"2\"/><rect x=\"6\" y=\"12\" width=\"10\" height=\"2\"/><rect x=\"6\" y=\"8\" width=\"10\" height=\"2\"/><path d=\"M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/><polygon points=\"22 25.59 19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z\"/><path d=\"M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/><path d=\"M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z\"/></svg>",
            "info": {},
            "path": "32/certificate--check.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CertificateCheck32",
          "filepath": "certificate--check/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
                }
              }
            ],
            "name": "certificate--check",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CertificateCheck24",
          "filepath": "certificate--check/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
                }
              }
            ],
            "name": "certificate--check",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CertificateCheck20",
          "filepath": "certificate--check/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
                }
              }
            ],
            "name": "certificate--check",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CertificateCheck16",
          "filepath": "certificate--check/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
                }
              }
            ],
            "name": "certificate--check",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CertificateCheck",
        "global": "CertificateCheck",
        "filepath": "CertificateCheck.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "change-catalog",
      "friendlyName": "Change catalog",
      "aliases": [
        "change-catalog",
        "change catalog",
        "edit",
        "edit catalog"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/change-catalog.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>change-catalog</title><path d=\"M24,24v2h2.4592A5.94,5.94,0,0,1,22,28a6.0066,6.0066,0,0,1-6-6H14a7.9841,7.9841,0,0,0,14,5.2651V30h2V24Z\"/><path d=\"M22,14a8.04,8.04,0,0,0-6,2.7349V14H14v6h6V18H17.5408A5.94,5.94,0,0,1,22,16a6.0066,6.0066,0,0,1,6,6h2A8.0092,8.0092,0,0,0,22,14Z\"/><path d=\"M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z\"/><path d=\"M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z\"/></svg>",
            "info": {},
            "path": "32/change-catalog.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChangeCatalog32",
          "filepath": "change-catalog/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "change-catalog",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChangeCatalog24",
          "filepath": "change-catalog/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "change-catalog",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChangeCatalog20",
          "filepath": "change-catalog/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "change-catalog",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChangeCatalog16",
          "filepath": "change-catalog/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "change-catalog",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChangeCatalog",
        "global": "ChangeCatalog",
        "filepath": "ChangeCatalog.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--decimal",
      "friendlyName": "Character decimal",
      "aliases": [
        "alphanumeric",
        "decimal",
        "numeral"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--decimal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"21\" y=\"15\" width=\"2\" height=\"2\"/>\n  <path d=\"M24,23H20a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2V21A2.0027,2.0027,0,0,1,24,23ZM20,11h0V21h4V11Z\"/>\n  <rect x=\"11\" y=\"15\" width=\"2\" height=\"2\"/>\n  <path d=\"M14,23H10a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2V21A2.0027,2.0027,0,0,1,14,23ZM10,11h0V21h4V11Z\"/>\n  <rect x=\"4\" y=\"21\" width=\"2\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 15H23V17H21z\"/><path d=\"M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z\"/><path d=\"M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z\"/></svg>",
            "info": {},
            "path": "32/character--decimal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterDecimal32",
          "filepath": "character--decimal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H23V17H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z"
                }
              }
            ],
            "name": "character--decimal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterDecimal24",
          "filepath": "character--decimal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H23V17H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z"
                }
              }
            ],
            "name": "character--decimal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterDecimal20",
          "filepath": "character--decimal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H23V17H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z"
                }
              }
            ],
            "name": "character--decimal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterDecimal16",
          "filepath": "character--decimal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H23V17H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z"
                }
              }
            ],
            "name": "character--decimal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterDecimal",
        "global": "CharacterDecimal",
        "filepath": "CharacterDecimal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 15H23V17H21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--fraction",
      "friendlyName": "Character fraction",
      "aliases": [
        "alphanumeric",
        "fraction",
        "numeral",
        "number"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--fraction.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z\"/>\n  <rect x=\"4.4791\" y=\"15.5001\" width=\"22.0418\" height=\"1.9998\" transform=\"translate(-7.1274 15.7929) rotate(-45)\"/>\n  <g>\n    <polygon class=\"cls-1\" points=\"4.5 15.5 4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5\"/>\n    <path d=\"M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z\"/>\n  </g>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z\"/><path d=\"M4.479 15.5H26.521V17.5H4.479z\" transform=\"rotate(-45 15.5 16.5)\"/><path d=\"M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z\"/><path d=\"M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z\"/></svg>",
            "info": {},
            "path": "32/character--fraction.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterFraction32",
          "filepath": "character--fraction/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.479 15.5H26.521V17.5H4.479z",
                  "transform": "rotate(-45 15.5 16.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
                }
              }
            ],
            "name": "character--fraction",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterFraction24",
          "filepath": "character--fraction/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.479 15.5H26.521V17.5H4.479z",
                  "transform": "rotate(-45 15.5 16.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
                }
              }
            ],
            "name": "character--fraction",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterFraction20",
          "filepath": "character--fraction/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.479 15.5H26.521V17.5H4.479z",
                  "transform": "rotate(-45 15.5 16.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
                }
              }
            ],
            "name": "character--fraction",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterFraction16",
          "filepath": "character--fraction/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.479 15.5H26.521V17.5H4.479z",
                  "transform": "rotate(-45 15.5 16.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
                }
              }
            ],
            "name": "character--fraction",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterFraction",
        "global": "CharacterFraction",
        "filepath": "CharacterFraction.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.479 15.5H26.521V17.5H4.479z",
                    "transform": "rotate(-45 15.5 16.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--integer",
      "friendlyName": "Character integer",
      "aliases": [
        "alphanumeric",
        "integer",
        "numeral",
        "number"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--integer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <g>\n    <polygon class=\"cls-1\" points=\"19.5 22.5 19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5\"/>\n    <path d=\"M23,10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9Z\"/>\n  </g>\n  <rect x=\"5\" y=\"21\" width=\"10\" height=\"2\"/>\n  <polygon points=\"15 13 11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z\"/><path d=\"M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 21H15V23H5zM15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z\"/></svg>",
            "info": {},
            "path": "32/character--integer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterInteger32",
          "filepath": "character--integer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 21H15V23H5zM15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z"
                }
              }
            ],
            "name": "character--integer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterInteger24",
          "filepath": "character--integer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 21H15V23H5zM15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z"
                }
              }
            ],
            "name": "character--integer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterInteger20",
          "filepath": "character--integer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 21H15V23H5zM15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z"
                }
              }
            ],
            "name": "character--integer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterInteger16",
          "filepath": "character--integer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 21H15V23H5zM15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z"
                }
              }
            ],
            "name": "character--integer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterInteger",
        "global": "CharacterInteger",
        "filepath": "CharacterInteger.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 21H15V23H5zM15 13L11 13 11 9 9 9 9 13 5 13 5 15 9 15 9 19 11 19 11 15 15 15 15 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--lower-case",
      "friendlyName": "Character lowercase",
      "aliases": [
        "alphanumeric",
        "letter",
        "lowercase"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--lower-case.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,23H24a2.0027,2.0027,0,0,1-2-2V15a2.0023,2.0023,0,0,1,2-2h5v2H24v6h5Z\"/>\n  <path d=\"M18,13H14V9H12V23h6a2.0027,2.0027,0,0,0,2-2V15A2.0023,2.0023,0,0,0,18,13Zm-4,8V15h4v6Z\"/>\n  <path d=\"M8,13H3v2H8v2H4a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V15A2.0023,2.0023,0,0,0,8,13Zm0,8H4V19H8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 13H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 008 13zm0 8H4V19H8z\"/></svg>",
            "info": {},
            "path": "32/character--lower-case.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterLowerCase32",
          "filepath": "character--lower-case/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 13H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 008 13zm0 8H4V19H8z"
                }
              }
            ],
            "name": "character--lower-case",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterLowerCase24",
          "filepath": "character--lower-case/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 13H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 008 13zm0 8H4V19H8z"
                }
              }
            ],
            "name": "character--lower-case",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterLowerCase20",
          "filepath": "character--lower-case/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 13H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 008 13zm0 8H4V19H8z"
                }
              }
            ],
            "name": "character--lower-case",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterLowerCase16",
          "filepath": "character--lower-case/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 13H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 008 13zm0 8H4V19H8z"
                }
              }
            ],
            "name": "character--lower-case",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterLowerCase",
        "global": "CharacterLowerCase",
        "filepath": "CharacterLowerCase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 13H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 008 13zm0 8H4V19H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--negative-number",
      "friendlyName": "Character negative number",
      "aliases": [
        "alphanumeric",
        "negative",
        "number",
        "numeral"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--negative-number.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <g>\n    <polygon class=\"cls-1\" points=\"19.5 22.5 19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5\"/>\n    <path d=\"M23,10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9Z\"/>\n  </g>\n  <rect x=\"5\" y=\"15\" width=\"10\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z\"/><path d=\"M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 15H15V17H5z\"/></svg>",
            "info": {},
            "path": "32/character--negative-number.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterNegativeNumber32",
          "filepath": "character--negative-number/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 15H15V17H5z"
                }
              }
            ],
            "name": "character--negative-number",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterNegativeNumber24",
          "filepath": "character--negative-number/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 15H15V17H5z"
                }
              }
            ],
            "name": "character--negative-number",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterNegativeNumber20",
          "filepath": "character--negative-number/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 15H15V17H5z"
                }
              }
            ],
            "name": "character--negative-number",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterNegativeNumber16",
          "filepath": "character--negative-number/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 15H15V17H5z"
                }
              }
            ],
            "name": "character--negative-number",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterNegativeNumber",
        "global": "CharacterNegativeNumber",
        "filepath": "CharacterNegativeNumber.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.5 22.5L19.5 21.5 22.5 21.5 22.5 10.5 19.5 10.5 19.5 9.5 23.5 9.5 23.5 21.5 26.5 21.5 26.5 22.5 19.5 22.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 10V22h0V10m1-1H19v2h3V21H19v2h8V21H24V9zM5 15H15V17H5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--sentence-case",
      "friendlyName": "Character sentence case",
      "aliases": [
        "alphanumeric",
        "letter",
        "sentence case"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--sentence-case.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,23H24a2.0027,2.0027,0,0,1-2-2V15a2.0023,2.0023,0,0,1,2-2h5v2H24v6h5Z\"/>\n  <path d=\"M18,13H14V9H12V23h6a2.0027,2.0027,0,0,0,2-2V15A2.0023,2.0023,0,0,0,18,13Zm-4,8V15h4v6Z\"/>\n  <path d=\"M8,9H4a2.002,2.002,0,0,0-2,2V23H4V18H8v5h2V11A2.002,2.002,0,0,0,8,9ZM4,16V11H8v5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z\"/></svg>",
            "info": {},
            "path": "32/character--sentence-case.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterSentenceCase32",
          "filepath": "character--sentence-case/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--sentence-case",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterSentenceCase24",
          "filepath": "character--sentence-case/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--sentence-case",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterSentenceCase20",
          "filepath": "character--sentence-case/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--sentence-case",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterSentenceCase16",
          "filepath": "character--sentence-case/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--sentence-case",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterSentenceCase",
        "global": "CharacterSentenceCase",
        "filepath": "CharacterSentenceCase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 23H24a2.0027 2.0027 0 01-2-2V15a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 13H14V9H12V23h6a2.0027 2.0027 0 002-2V15A2.0023 2.0023 0 0018 13zm-4 8V15h4v6zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--upper-case",
      "friendlyName": "Character uppercase",
      "aliases": [
        "alphanumeric",
        "uppercase",
        "letter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--upper-case.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,23H24a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H24V21h6Z\"/>\n  <path d=\"M20,12a3.0033,3.0033,0,0,0-3-3H12V23h5a3.0033,3.0033,0,0,0,3-3V18a2.977,2.977,0,0,0-.78-2A2.9768,2.9768,0,0,0,20,14Zm-6-1h3a1.0013,1.0013,0,0,1,1,1v2a1.0013,1.0013,0,0,1-1,1H14Zm4,9a1.0009,1.0009,0,0,1-1,1H14V17h3a1.0009,1.0009,0,0,1,1,1Z\"/>\n  <path d=\"M8,9H4a2.002,2.002,0,0,0-2,2V23H4V18H8v5h2V11A2.002,2.002,0,0,0,8,9ZM4,16V11H8v5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM20 12a3.0033 3.0033 0 00-3-3H12V23h5a3.0033 3.0033 0 003-3V18a2.977 2.977 0 00-.78-2A2.9768 2.9768 0 0020 14zm-6-1h3a1.0013 1.0013 0 011 1v2a1.0013 1.0013 0 01-1 1H14zm4 9a1.0009 1.0009 0 01-1 1H14V17h3a1.0009 1.0009 0 011 1zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z\"/></svg>",
            "info": {},
            "path": "32/character--upper-case.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterUpperCase32",
          "filepath": "character--upper-case/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM20 12a3.0033 3.0033 0 00-3-3H12V23h5a3.0033 3.0033 0 003-3V18a2.977 2.977 0 00-.78-2A2.9768 2.9768 0 0020 14zm-6-1h3a1.0013 1.0013 0 011 1v2a1.0013 1.0013 0 01-1 1H14zm4 9a1.0009 1.0009 0 01-1 1H14V17h3a1.0009 1.0009 0 011 1zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--upper-case",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterUpperCase24",
          "filepath": "character--upper-case/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM20 12a3.0033 3.0033 0 00-3-3H12V23h5a3.0033 3.0033 0 003-3V18a2.977 2.977 0 00-.78-2A2.9768 2.9768 0 0020 14zm-6-1h3a1.0013 1.0013 0 011 1v2a1.0013 1.0013 0 01-1 1H14zm4 9a1.0009 1.0009 0 01-1 1H14V17h3a1.0009 1.0009 0 011 1zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--upper-case",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterUpperCase20",
          "filepath": "character--upper-case/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM20 12a3.0033 3.0033 0 00-3-3H12V23h5a3.0033 3.0033 0 003-3V18a2.977 2.977 0 00-.78-2A2.9768 2.9768 0 0020 14zm-6-1h3a1.0013 1.0013 0 011 1v2a1.0013 1.0013 0 01-1 1H14zm4 9a1.0009 1.0009 0 01-1 1H14V17h3a1.0009 1.0009 0 011 1zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--upper-case",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterUpperCase16",
          "filepath": "character--upper-case/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM20 12a3.0033 3.0033 0 00-3-3H12V23h5a3.0033 3.0033 0 003-3V18a2.977 2.977 0 00-.78-2A2.9768 2.9768 0 0020 14zm-6-1h3a1.0013 1.0013 0 011 1v2a1.0013 1.0013 0 01-1 1H14zm4 9a1.0009 1.0009 0 01-1 1H14V17h3a1.0009 1.0009 0 011 1zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                }
              }
            ],
            "name": "character--upper-case",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterUpperCase",
        "global": "CharacterUpperCase",
        "filepath": "CharacterUpperCase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM20 12a3.0033 3.0033 0 00-3-3H12V23h5a3.0033 3.0033 0 003-3V18a2.977 2.977 0 00-.78-2A2.9768 2.9768 0 0020 14zm-6-1h3a1.0013 1.0013 0 011 1v2a1.0013 1.0013 0 01-1 1H14zm4 9a1.0009 1.0009 0 01-1 1H14V17h3a1.0009 1.0009 0 011 1zM8 9H4a2.002 2.002 0 00-2 2V23H4V18H8v5h2V11A2.002 2.002 0 008 9zM4 16V11H8v5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character--whole-number",
      "friendlyName": "Character whole number",
      "aliases": [
        "alphanumeric",
        "whole number",
        "numeral"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character--whole-number.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,9H22v2h6v4H24v2h4v4H22v2h6a2.0027,2.0027,0,0,0,2-2V11A2.0023,2.0023,0,0,0,28,9Z\"/>\n  <path d=\"M20,23H12V17a2.002,2.002,0,0,1,2-2h4V11H12V9h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H14v4h6Z\"/>\n  <g>\n    <polygon class=\"cls-1\" points=\"2.5 22.5 2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5\"/>\n    <path d=\"M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z\"/>\n  </g>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9H22v2h6v4H24v2h4v4H22v2h6a2.0027 2.0027 0 002-2V11A2.0023 2.0023 0 0028 9zM20 23H12V17a2.002 2.002 0 012-2h4V11H12V9h6a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14v4h6zM2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z\"/><path d=\"M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z\"/></svg>",
            "info": {},
            "path": "32/character--whole-number.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterWholeNumber32",
          "filepath": "character--whole-number/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2.0027 2.0027 0 002-2V11A2.0023 2.0023 0 0028 9zM20 23H12V17a2.002 2.002 0 012-2h4V11H12V9h6a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14v4h6zM2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z"
                }
              }
            ],
            "name": "character--whole-number",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterWholeNumber24",
          "filepath": "character--whole-number/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2.0027 2.0027 0 002-2V11A2.0023 2.0023 0 0028 9zM20 23H12V17a2.002 2.002 0 012-2h4V11H12V9h6a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14v4h6zM2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z"
                }
              }
            ],
            "name": "character--whole-number",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterWholeNumber20",
          "filepath": "character--whole-number/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2.0027 2.0027 0 002-2V11A2.0023 2.0023 0 0028 9zM20 23H12V17a2.002 2.002 0 012-2h4V11H12V9h6a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14v4h6zM2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z"
                }
              }
            ],
            "name": "character--whole-number",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterWholeNumber16",
          "filepath": "character--whole-number/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2.0027 2.0027 0 002-2V11A2.0023 2.0023 0 0028 9zM20 23H12V17a2.002 2.002 0 012-2h4V11H12V9h6a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14v4h6zM2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z"
                }
              }
            ],
            "name": "character--whole-number",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "CharacterWholeNumber",
        "global": "CharacterWholeNumber",
        "filepath": "CharacterWholeNumber.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2.0027 2.0027 0 002-2V11A2.0023 2.0023 0 0028 9zM20 23H12V17a2.002 2.002 0 012-2h4V11H12V9h6a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14v4h6zM2.5 22.5L2.5 21.5 5.5 21.5 5.5 10.5 2.5 10.5 2.5 9.5 6.5 9.5 6.5 21.5 9.5 21.5 9.5 22.5 2.5 22.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,10V22H6V10M7,9H2v2H5V21H2v2h8V21H7V9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "character-patterns",
      "friendlyName": "Character patterns",
      "aliases": [
        "letters",
        "swap",
        "data",
        "character patterns",
        "characters",
        "patterns"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/character-patterns.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>character-patterns</title><path d=\"M6,26V17.8281l-3.5859,3.586L1,20l6-6,6,6-1.4141,1.4141L8,17.8281V26H18v2H8A2.0024,2.0024,0,0,1,6,26Z\" transform=\"translate(0)\"/><polygon points=\"30 22 30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22\"/><path d=\"M26,6v8.1719l3.5859-3.586L31,12l-6,6-6-6,1.4141-1.4141L24,14.1719V6H14V4H24A2.0024,2.0024,0,0,1,26,6Z\" transform=\"translate(0)\"/><path d=\"M8,2H3V4H8V6H4A2,2,0,0,0,2,8v2a2,2,0,0,0,2,2h6V4A2.0023,2.0023,0,0,0,8,2Zm0,8H4V8H8Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 26V17.8281l-3.5859 3.586L1 20l6-6 6 6-1.4141 1.4141L8 17.8281V26H18v2H8A2.0024 2.0024 0 016 26zM30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22zM26 6v8.1719l3.5859-3.586L31 12l-6 6-6-6 1.4141-1.4141L24 14.1719V6H14V4H24A2.0024 2.0024 0 0126 6zM8 2H3V4H8V6H4A2 2 0 002 8v2a2 2 0 002 2h6V4A2.0023 2.0023 0 008 2zm0 8H4V8H8z\"/></svg>",
            "info": {},
            "path": "32/character-patterns.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CharacterPatterns32",
          "filepath": "character-patterns/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 26V17.8281l-3.5859 3.586L1 20l6-6 6 6-1.4141 1.4141L8 17.8281V26H18v2H8A2.0024 2.0024 0 016 26zM30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22zM26 6v8.1719l3.5859-3.586L31 12l-6 6-6-6 1.4141-1.4141L24 14.1719V6H14V4H24A2.0024 2.0024 0 0126 6zM8 2H3V4H8V6H4A2 2 0 002 8v2a2 2 0 002 2h6V4A2.0023 2.0023 0 008 2zm0 8H4V8H8z"
                }
              }
            ],
            "name": "character-patterns",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CharacterPatterns24",
          "filepath": "character-patterns/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 26V17.8281l-3.5859 3.586L1 20l6-6 6 6-1.4141 1.4141L8 17.8281V26H18v2H8A2.0024 2.0024 0 016 26zM30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22zM26 6v8.1719l3.5859-3.586L31 12l-6 6-6-6 1.4141-1.4141L24 14.1719V6H14V4H24A2.0024 2.0024 0 0126 6zM8 2H3V4H8V6H4A2 2 0 002 8v2a2 2 0 002 2h6V4A2.0023 2.0023 0 008 2zm0 8H4V8H8z"
                }
              }
            ],
            "name": "character-patterns",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CharacterPatterns20",
          "filepath": "character-patterns/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 26V17.8281l-3.5859 3.586L1 20l6-6 6 6-1.4141 1.4141L8 17.8281V26H18v2H8A2.0024 2.0024 0 016 26zM30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22zM26 6v8.1719l3.5859-3.586L31 12l-6 6-6-6 1.4141-1.4141L24 14.1719V6H14V4H24A2.0024 2.0024 0 0126 6zM8 2H3V4H8V6H4A2 2 0 002 8v2a2 2 0 002 2h6V4A2.0023 2.0023 0 008 2zm0 8H4V8H8z"
                }
              }
            ],
            "name": "character-patterns",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CharacterPatterns16",
          "filepath": "character-patterns/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 26V17.8281l-3.5859 3.586L1 20l6-6 6 6-1.4141 1.4141L8 17.8281V26H18v2H8A2.0024 2.0024 0 016 26zM30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22zM26 6v8.1719l3.5859-3.586L31 12l-6 6-6-6 1.4141-1.4141L24 14.1719V6H14V4H24A2.0024 2.0024 0 0126 6zM8 2H3V4H8V6H4A2 2 0 002 8v2a2 2 0 002 2h6V4A2.0023 2.0023 0 008 2zm0 8H4V8H8z"
                }
              }
            ],
            "name": "character-patterns",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "CharacterPatterns",
        "global": "CharacterPatterns",
        "filepath": "CharacterPatterns.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 26V17.8281l-3.5859 3.586L1 20l6-6 6 6-1.4141 1.4141L8 17.8281V26H18v2H8A2.0024 2.0024 0 016 26zM30 22L30 20 22 20 22 22 27.5 22 22 28 22 30 30 30 30 28 24.507 28 30 22zM26 6v8.1719l3.5859-3.586L31 12l-6 6-6-6 1.4141-1.4141L24 14.1719V6H14V4H24A2.0024 2.0024 0 0126 6zM8 2H3V4H8V6H4A2 2 0 002 8v2a2 2 0 002 2h6V4A2.0023 2.0023 0 008 2zm0 8H4V8H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "charging-station",
      "friendlyName": "Charging station",
      "aliases": [
        "charging-station",
        "charging station",
        "travel",
        "power",
        "gas pump"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/charging-station.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>charging-station</title><polygon class=\"cls-1\" points=\"11.857 21.514 10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514\"/><path class=\"cls-1\" d=\"M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z\"/><path d=\"M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z\"/></svg>",
            "info": {},
            "path": "32/charging-station.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChargingStation32",
          "filepath": "charging-station/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "charging-station",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChargingStation24",
          "filepath": "charging-station/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "charging-station",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChargingStation20",
          "filepath": "charging-station/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "charging-station",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChargingStation16",
          "filepath": "charging-station/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "charging-station",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "ChargingStation",
        "global": "ChargingStation",
        "filepath": "ChargingStation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,7H29V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1ZM17,26H6V6H17Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "charging-station--filled",
      "friendlyName": "Charging station filled",
      "aliases": [
        "charging station",
        "charging station filled",
        "travel",
        "power",
        "gas pump"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/charging-station--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>charging-station--filled</title><path class=\"cls-1\" d=\"M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z\"/><polygon id=\"inner-path\" class=\"cls-2\" points=\"11.857 21.514 10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z\"/><path fill=\"none\" d=\"M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/charging-station--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChargingStationFilled32",
          "filepath": "charging-station--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "charging-station--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChargingStationFilled24",
          "filepath": "charging-station--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "charging-station--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChargingStationFilled20",
          "filepath": "charging-station--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "charging-station--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChargingStationFilled16",
          "filepath": "charging-station--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "charging-station--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "ChargingStationFilled",
        "global": "ChargingStationFilled",
        "filepath": "ChargingStationFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,7V4H27V7H26v6h1V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.5a3.5,3.5,0,0,0,7,0V13h1V7ZM11.8574,21.5146l-1.7148-1.0292L12.2339,17h-5l3.9087-6.5146,1.7148,1.0292L10.7661,15h5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M11.857 21.514L10.143 20.486 12.234 17 7.234 17 11.143 10.486 12.857 11.514 10.766 15 15.766 15 11.857 21.514z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--3D",
      "friendlyName": "Chart 3D",
      "aliases": [
        "chart 3D",
        "3D chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--3D.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--3D</title>\n  <path d=\"M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z\"/></svg>",
            "info": {},
            "path": "32/chart--3D.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Chart_3D32",
          "filepath": "chart--3D/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z"
                }
              }
            ],
            "name": "chart--3D",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Chart_3D24",
          "filepath": "chart--3D/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z"
                }
              }
            ],
            "name": "chart--3D",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Chart_3D20",
          "filepath": "chart--3D/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z"
                }
              }
            ],
            "name": "chart--3D",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Chart_3D16",
          "filepath": "chart--3D/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z"
                }
              }
            ],
            "name": "chart--3D",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Chart_3D",
        "global": "Chart_3D",
        "filepath": "Chart_3D.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--area",
      "friendlyName": "Chart area",
      "aliases": [
        "chart area",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--area.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--area</title>\n  <path d=\"M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z\"/></svg>",
            "info": {},
            "path": "32/chart--area.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartArea32",
          "filepath": "chart--area/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z"
                }
              }
            ],
            "name": "chart--area",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartArea24",
          "filepath": "chart--area/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z"
                }
              }
            ],
            "name": "chart--area",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartArea20",
          "filepath": "chart--area/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z"
                }
              }
            ],
            "name": "chart--area",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartArea16",
          "filepath": "chart--area/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z"
                }
              }
            ],
            "name": "chart--area",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartArea",
        "global": "ChartArea",
        "filepath": "ChartArea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.4761,8.0151,13.4473,4.2109a2.0076,2.0076,0,0,0-2.1158.2051L4,10.001V2H2V28a2,2,0,0,0,2,2H30V5.7354ZM28,20.209l-7.62,1.8022-7.0288-2.8838a1.99,1.99,0,0,0-2.022.37L4,25.8359v-4.455l8.375-9.4,7.0186,5.62a2.0155,2.0155,0,0,0,2.0459.2119L28,14.6025ZM12.5239,5.9849l7.03,3.8042a2.012,2.012,0,0,0,1.3408.16L28,8.2646v4.1138L20.6187,16.02,13.6,10.4a1.99,1.99,0,0,0-2.6885.2642L4,18.3838v-5.87ZM4.5513,28,12.62,20.9888l7.0288,2.8838a1.9977,1.9977,0,0,0,1.147.0771L28,22.2612V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--area-smooth",
      "friendlyName": "Chart area smooth",
      "aliases": [
        "chart area smooth",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--area-smooth.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z\"/></svg>",
            "info": {},
            "path": "32/chart--area-smooth.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartAreaSmooth32",
          "filepath": "chart--area-smooth/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z"
                }
              }
            ],
            "name": "chart--area-smooth",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartAreaSmooth24",
          "filepath": "chart--area-smooth/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z"
                }
              }
            ],
            "name": "chart--area-smooth",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartAreaSmooth20",
          "filepath": "chart--area-smooth/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z"
                }
              }
            ],
            "name": "chart--area-smooth",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartAreaSmooth16",
          "filepath": "chart--area-smooth/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z"
                }
              }
            ],
            "name": "chart--area-smooth",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartAreaSmooth",
        "global": "ChartAreaSmooth",
        "filepath": "ChartAreaSmooth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,6.6143l-1.3152.4365A20.9218,20.9218,0,0,1,23,8c-1.7344,0-3.3225-.9072-5.0039-1.8682C16.1621,5.084,14.2656,4,12,4,9.123,4,5.9146,6.2061,4,7.772V2H2V28a2.0025,2.0025,0,0,0,2,2H30ZM4,20.2944C5.874,17.3765,9.56,13,12,13c1.6379,0,2.96,1.1016,4.36,2.2686C17.8965,16.5488,19.6379,18,22,18a9.4686,9.4686,0,0,0,6-2.5288v4.9556A13.0026,13.0026,0,0,1,22,22a13.8619,13.8619,0,0,1-4.6838-.9487A15.682,15.682,0,0,0,12,20c-2.927,0-6.0676,2.959-8,5.1577ZM12,6c1.7344,0,3.3225.9072,5.0039,1.8682C18.8379,8.916,20.7344,10,23,10a21.432,21.432,0,0,0,5-.6782v3.3213C27.3167,13.4463,24.9155,16,22,16c-1.6379,0-2.96-1.1016-4.36-2.2686C16.1035,12.4512,14.3621,11,12,11c-2.9358,0-6.0632,3.3394-8,5.8447V10.4238C5.5461,8.9658,9.2588,6,12,6ZM4.249,28C5.8623,25.9087,9.41,22,12,22a13.8619,13.8619,0,0,1,4.6838.9487A15.682,15.682,0,0,0,22,24a14.7362,14.7362,0,0,0,6-1.34V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--area-stepper",
      "friendlyName": "Chart area stepper",
      "aliases": [
        "chart area stepper",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--area-stepper.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z\"/></svg>",
            "info": {},
            "path": "32/chart--area-stepper.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartAreaStepper32",
          "filepath": "chart--area-stepper/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z"
                }
              }
            ],
            "name": "chart--area-stepper",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartAreaStepper24",
          "filepath": "chart--area-stepper/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z"
                }
              }
            ],
            "name": "chart--area-stepper",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartAreaStepper20",
          "filepath": "chart--area-stepper/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z"
                }
              }
            ],
            "name": "chart--area-stepper",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartAreaStepper16",
          "filepath": "chart--area-stepper/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z"
                }
              }
            ],
            "name": "chart--area-stepper",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartAreaStepper",
        "global": "ChartAreaStepper",
        "filepath": "ChartAreaStepper.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,10V6H10v6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V10ZM12,14V8h8v4h8V22H22V16H12v6H4V14ZM4,28V24H14V18h6v6h8v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--average",
      "friendlyName": "Chart average",
      "aliases": [
        "chart average",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--average.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z\"/>\n  <path d=\"M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z\"/>\n  <rect x=\"8\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"12\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"24\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"28\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z\"/><path d=\"M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z\"/><path d=\"M8 15H10V17H8zM12 15H14V17H12zM20 15H22V17H20zM24 15H26V17H24zM28 15H30V17H28z\"/></svg>",
            "info": {},
            "path": "32/chart--average.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartAverage32",
          "filepath": "chart--average/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H10V17H8zM12 15H14V17H12zM20 15H22V17H20zM24 15H26V17H24zM28 15H30V17H28z"
                }
              }
            ],
            "name": "chart--average",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartAverage24",
          "filepath": "chart--average/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H10V17H8zM12 15H14V17H12zM20 15H22V17H20zM24 15H26V17H24zM28 15H30V17H28z"
                }
              }
            ],
            "name": "chart--average",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartAverage20",
          "filepath": "chart--average/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H10V17H8zM12 15H14V17H12zM20 15H22V17H20zM24 15H26V17H24zM28 15H30V17H28z"
                }
              }
            ],
            "name": "chart--average",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartAverage16",
          "filepath": "chart--average/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H10V17H8zM12 15H14V17H12zM20 15H22V17H20zM24 15H26V17H24zM28 15H30V17H28z"
                }
              }
            ],
            "name": "chart--average",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartAverage",
        "global": "ChartAverage",
        "filepath": "ChartAverage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 15H10V17H8zM12 15H14V17H12zM20 15H22V17H20zM24 15H26V17H24zM28 15H30V17H28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bar",
      "friendlyName": "Chart bar",
      "aliases": [
        "graph",
        "bar",
        "data",
        "bar chart",
        "chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bar.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z\"/></svg>",
            "info": {},
            "path": "32/chart--bar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBar32",
          "filepath": "chart--bar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBar24",
          "filepath": "chart--bar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBar20",
          "filepath": "chart--bar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBar16",
          "filepath": "chart--bar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBar",
        "global": "ChartBar",
        "filepath": "ChartBar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bar-floating",
      "friendlyName": "Chart bar floating",
      "aliases": [
        "chart bar floating",
        "graph",
        "bar chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bar-floating.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,24H14V16H28ZM16,22H26V18H16Z\"/>\n  <path d=\"M26,12H8V4H26ZM10,10H24V6H10Z\"/>\n  <path d=\"M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 24H14V16H28zM16 22H26V18H16zM26 12H8V4H26zM10 10H24V6H10z\"/><path d=\"M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z\"/></svg>",
            "info": {},
            "path": "32/chart--bar-floating.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBarFloating32",
          "filepath": "chart--bar-floating/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24H14V16H28zM16 22H26V18H16zM26 12H8V4H26zM10 10H24V6H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--bar-floating",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBarFloating24",
          "filepath": "chart--bar-floating/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24H14V16H28zM16 22H26V18H16zM26 12H8V4H26zM10 10H24V6H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--bar-floating",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBarFloating20",
          "filepath": "chart--bar-floating/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24H14V16H28zM16 22H26V18H16zM26 12H8V4H26zM10 10H24V6H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--bar-floating",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBarFloating16",
          "filepath": "chart--bar-floating/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24H14V16H28zM16 22H26V18H16zM26 12H8V4H26zM10 10H24V6H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--bar-floating",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBarFloating",
        "global": "ChartBarFloating",
        "filepath": "ChartBarFloating.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 24H14V16H28zM16 22H26V18H16zM26 12H8V4H26zM10 10H24V6H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bar-overlay",
      "friendlyName": "Chart bar overlay",
      "aliases": [
        "chart bar overlay",
        "graph",
        "bar chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bar-overlay.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z\"/></svg>",
            "info": {},
            "path": "32/chart--bar-overlay.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBarOverlay32",
          "filepath": "chart--bar-overlay/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z"
                }
              }
            ],
            "name": "chart--bar-overlay",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBarOverlay24",
          "filepath": "chart--bar-overlay/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z"
                }
              }
            ],
            "name": "chart--bar-overlay",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBarOverlay20",
          "filepath": "chart--bar-overlay/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z"
                }
              }
            ],
            "name": "chart--bar-overlay",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBarOverlay16",
          "filepath": "chart--bar-overlay/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z"
                }
              }
            ],
            "name": "chart--bar-overlay",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBarOverlay",
        "global": "ChartBarOverlay",
        "filepath": "ChartBarOverlay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,28V26H26V16H4V14H18V4H4V2H2V28a2,2,0,0,0,2,2H30V28ZM24,18v6H4V22H20V20H4V18ZM16,6v6H4V10h8V8H4V6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bar-stacked",
      "friendlyName": "Chart bar stacked",
      "aliases": [
        "chart bar stacked",
        "graph",
        "bar chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bar-stacked.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z\"/></svg>",
            "info": {},
            "path": "32/chart--bar-stacked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBarStacked32",
          "filepath": "chart--bar-stacked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z"
                }
              }
            ],
            "name": "chart--bar-stacked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBarStacked24",
          "filepath": "chart--bar-stacked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z"
                }
              }
            ],
            "name": "chart--bar-stacked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBarStacked20",
          "filepath": "chart--bar-stacked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z"
                }
              }
            ],
            "name": "chart--bar-stacked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBarStacked16",
          "filepath": "chart--bar-stacked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z"
                }
              }
            ],
            "name": "chart--bar-stacked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBarStacked",
        "global": "ChartBarStacked",
        "filepath": "ChartBarStacked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,28V25H26V17H4V13H18V5H4V2H2V28a2,2,0,0,0,2,2H30V28Zm20-5H14V19H24ZM16,11H10V7h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bar-target",
      "friendlyName": "Chart bar target",
      "aliases": [
        "chart bar target",
        "graph",
        "bar chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bar-target.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"28\" y=\"17\" width=\"2\" height=\"8\"/>\n  <rect x=\"20\" y=\"5\" width=\"2\" height=\"8\"/>\n  <path d=\"M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 17H30V25H28zM20 5H22V13H20z\"/><path d=\"M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z\"/></svg>",
            "info": {},
            "path": "32/chart--bar-target.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBarTarget32",
          "filepath": "chart--bar-target/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H30V25H28zM20 5H22V13H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar-target",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBarTarget24",
          "filepath": "chart--bar-target/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H30V25H28zM20 5H22V13H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar-target",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBarTarget20",
          "filepath": "chart--bar-target/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H30V25H28zM20 5H22V13H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar-target",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBarTarget16",
          "filepath": "chart--bar-target/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H30V25H28zM20 5H22V13H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                }
              }
            ],
            "name": "chart--bar-target",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBarTarget",
        "global": "ChartBarTarget",
        "filepath": "ChartBarTarget.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 17H30V25H28zM20 5H22V13H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,2H2V28a2,2,0,0,0,2,2H30V28H4V25H26V17H4V13H18V5H4ZM24,19v4H4V19ZM16,7v4H4V7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bubble",
      "friendlyName": "Chart bubble",
      "aliases": [
        "graph",
        "bar",
        "data",
        "bubble chart",
        "chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bubble.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chart--bubble</title><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/><path d=\"M10,16a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z\"/><path d=\"M21,6a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/><path d=\"M24.5,21A1.5,1.5,0,1,1,23,22.5,1.5,1.5,0,0,1,24.5,21m0-2A3.5,3.5,0,1,0,28,22.5,3.5,3.5,0,0,0,24.5,19Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/><path d=\"M10 16a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4zM21 6a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6zM24.5 21A1.5 1.5 0 1123 22.5 1.5 1.5 0 0124.5 21m0-2A3.5 3.5 0 1028 22.5 3.5 3.5 0 0024.5 19z\"/></svg>",
            "info": {},
            "path": "32/chart--bubble.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBubble32",
          "filepath": "chart--bubble/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4zM21 6a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6zM24.5 21A1.5 1.5 0 1123 22.5 1.5 1.5 0 0124.5 21m0-2A3.5 3.5 0 1028 22.5 3.5 3.5 0 0024.5 19z"
                }
              }
            ],
            "name": "chart--bubble",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBubble24",
          "filepath": "chart--bubble/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4zM21 6a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6zM24.5 21A1.5 1.5 0 1123 22.5 1.5 1.5 0 0124.5 21m0-2A3.5 3.5 0 1028 22.5 3.5 3.5 0 0024.5 19z"
                }
              }
            ],
            "name": "chart--bubble",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBubble20",
          "filepath": "chart--bubble/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4zM21 6a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6zM24.5 21A1.5 1.5 0 1123 22.5 1.5 1.5 0 0124.5 21m0-2A3.5 3.5 0 1028 22.5 3.5 3.5 0 0024.5 19z"
                }
              }
            ],
            "name": "chart--bubble",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBubble16",
          "filepath": "chart--bubble/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4zM21 6a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6zM24.5 21A1.5 1.5 0 1123 22.5 1.5 1.5 0 0124.5 21m0-2A3.5 3.5 0 1028 22.5 3.5 3.5 0 0024.5 19z"
                }
              }
            ],
            "name": "chart--bubble",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBubble",
        "global": "ChartBubble",
        "filepath": "ChartBubble.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 16a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4 4 4 0 00-4-4zM21 6a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6zM24.5 21A1.5 1.5 0 1123 22.5 1.5 1.5 0 0124.5 21m0-2A3.5 3.5 0 1028 22.5 3.5 3.5 0 0024.5 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bubble-packed",
      "friendlyName": "Chart Bubble-packed",
      "aliases": [
        "graph",
        "bar",
        "data",
        "bubble chart",
        "packed",
        "chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bubble-packed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z\"/></svg>",
            "info": {},
            "path": "32/chart--bubble-packed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBubblePacked32",
          "filepath": "chart--bubble-packed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z"
                }
              }
            ],
            "name": "chart--bubble-packed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBubblePacked24",
          "filepath": "chart--bubble-packed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z"
                }
              }
            ],
            "name": "chart--bubble-packed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBubblePacked20",
          "filepath": "chart--bubble-packed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z"
                }
              }
            ],
            "name": "chart--bubble-packed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBubblePacked16",
          "filepath": "chart--bubble-packed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z"
                }
              }
            ],
            "name": "chart--bubble-packed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBubblePacked",
        "global": "ChartBubblePacked",
        "filepath": "ChartBubblePacked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.5322,17.1724A8.99,8.99,0,1,0,13.6074,5.88,5.9969,5.9969,0,1,0,5.051,13.2217a6.9967,6.9967,0,1,0,7.9942,11.4844A5.9981,5.9981,0,0,0,25,24c0-.1216-.011-.24-.0181-.3594a3.4873,3.4873,0,1,0,2.55-6.4682ZM21,4a7,7,0,1,1-7,7A7.0078,7.0078,0,0,1,21,4ZM8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4ZM19,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--bullet",
      "friendlyName": "Chart bullet",
      "aliases": [
        "graph",
        "bar",
        "data",
        "bullet chart",
        "chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--bullet.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,22H16V21H14v1H2v6H14v1h2V28H30ZM4,26V24H14v2Zm24,0H16V24H28Z\"/>\n  <path d=\"M30,13H24V12H22v1H2v6H22v1h2V19h6ZM4,17V15H22v2Zm24,0H24V15h4Z\"/>\n  <path d=\"M30,4H10V3H8V4H2v6H8v1h2V10H30ZM4,8V6H8V8ZM28,8H10V6H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 22H16V21H14v1H2v6H14v1h2V28H30zM4 26V24H14v2zm24 0H16V24H28zM30 13H24V12H22v1H2v6H22v1h2V19h6zM4 17V15H22v2zm24 0H24V15h4zM30 4H10V3H8V4H2v6H8v1h2V10H30zM4 8V6H8V8zM28 8H10V6H28z\"/></svg>",
            "info": {},
            "path": "32/chart--bullet.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartBullet32",
          "filepath": "chart--bullet/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22H16V21H14v1H2v6H14v1h2V28H30zM4 26V24H14v2zm24 0H16V24H28zM30 13H24V12H22v1H2v6H22v1h2V19h6zM4 17V15H22v2zm24 0H24V15h4zM30 4H10V3H8V4H2v6H8v1h2V10H30zM4 8V6H8V8zM28 8H10V6H28z"
                }
              }
            ],
            "name": "chart--bullet",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartBullet24",
          "filepath": "chart--bullet/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22H16V21H14v1H2v6H14v1h2V28H30zM4 26V24H14v2zm24 0H16V24H28zM30 13H24V12H22v1H2v6H22v1h2V19h6zM4 17V15H22v2zm24 0H24V15h4zM30 4H10V3H8V4H2v6H8v1h2V10H30zM4 8V6H8V8zM28 8H10V6H28z"
                }
              }
            ],
            "name": "chart--bullet",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartBullet20",
          "filepath": "chart--bullet/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22H16V21H14v1H2v6H14v1h2V28H30zM4 26V24H14v2zm24 0H16V24H28zM30 13H24V12H22v1H2v6H22v1h2V19h6zM4 17V15H22v2zm24 0H24V15h4zM30 4H10V3H8V4H2v6H8v1h2V10H30zM4 8V6H8V8zM28 8H10V6H28z"
                }
              }
            ],
            "name": "chart--bullet",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartBullet16",
          "filepath": "chart--bullet/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22H16V21H14v1H2v6H14v1h2V28H30zM4 26V24H14v2zm24 0H16V24H28zM30 13H24V12H22v1H2v6H22v1h2V19h6zM4 17V15H22v2zm24 0H24V15h4zM30 4H10V3H8V4H2v6H8v1h2V10H30zM4 8V6H8V8zM28 8H10V6H28z"
                }
              }
            ],
            "name": "chart--bullet",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartBullet",
        "global": "ChartBullet",
        "filepath": "ChartBullet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 22H16V21H14v1H2v6H14v1h2V28H30zM4 26V24H14v2zm24 0H16V24H28zM30 13H24V12H22v1H2v6H22v1h2V19h6zM4 17V15H22v2zm24 0H24V15h4zM30 4H10V3H8V4H2v6H8v1h2V10H30zM4 8V6H8V8zM28 8H10V6H28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--candlestick",
      "friendlyName": "Chart candlestick",
      "aliases": [
        "chart candlestick",
        "candlestick chart",
        "chart",
        "graph"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--candlestick.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--candlestick</title>\n  <path d=\"M26,10H24V6H22v4H20V22h2v4h2V22h2ZM24,20H22V12h2Z\"/>\n  <path d=\"M14,8H12V4H10V8H8V18h2v4h2V18h2Zm-2,8H10V10h2Z\"/>\n  <path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 10H24V6H22v4H20V22h2v4h2V22h2zM24 20H22V12h2zM14 8H12V4H10V8H8V18h2v4h2V18h2zm-2 8H10V10h2z\"/><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/></svg>",
            "info": {},
            "path": "32/chart--candlestick.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartCandlestick32",
          "filepath": "chart--candlestick/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H24V6H22v4H20V22h2v4h2V22h2zM24 20H22V12h2zM14 8H12V4H10V8H8V18h2v4h2V18h2zm-2 8H10V10h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--candlestick",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartCandlestick24",
          "filepath": "chart--candlestick/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H24V6H22v4H20V22h2v4h2V22h2zM24 20H22V12h2zM14 8H12V4H10V8H8V18h2v4h2V18h2zm-2 8H10V10h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--candlestick",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartCandlestick20",
          "filepath": "chart--candlestick/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H24V6H22v4H20V22h2v4h2V22h2zM24 20H22V12h2zM14 8H12V4H10V8H8V18h2v4h2V18h2zm-2 8H10V10h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--candlestick",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartCandlestick16",
          "filepath": "chart--candlestick/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H24V6H22v4H20V22h2v4h2V22h2zM24 20H22V12h2zM14 8H12V4H10V8H8V18h2v4h2V18h2zm-2 8H10V10h2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--candlestick",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartCandlestick",
        "global": "ChartCandlestick",
        "filepath": "ChartCandlestick.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 10H24V6H22v4H20V22h2v4h2V22h2zM24 20H22V12h2zM14 8H12V4H10V8H8V18h2v4h2V18h2zm-2 8H10V10h2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--cluster-bar",
      "friendlyName": "Chart cluster bar",
      "aliases": [
        "chart cluster bar",
        "cluster bar chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--cluster-bar.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--cluster-bar</title>\n  <path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/>\n  <rect x=\"10\" y=\"16\" width=\"2\" height=\"10\"/>\n  <rect x=\"7\" y=\"22\" width=\"2\" height=\"4\"/>\n  <rect x=\"26\" y=\"8\" width=\"2\" height=\"18\"/>\n  <rect x=\"23\" y=\"14\" width=\"2\" height=\"12\"/>\n  <rect x=\"15\" y=\"12\" width=\"2\" height=\"14\" transform=\"translate(32 38) rotate(-180)\"/>\n  <rect x=\"18\" y=\"18\" width=\"2\" height=\"8\" transform=\"translate(38 44) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/><path d=\"M10 16H12V26H10zM7 22H9V26H7zM26 8H28V26H26zM23 14H25V26H23z\"/><path d=\"M15 12H17V26H15z\" transform=\"rotate(-180 16 19)\"/><path d=\"M18 18H20V26H18z\" transform=\"rotate(-180 19 22)\"/></svg>",
            "info": {},
            "path": "32/chart--cluster-bar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartClusterBar32",
          "filepath": "chart--cluster-bar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H12V26H10zM7 22H9V26H7zM26 8H28V26H26zM23 14H25V26H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V26H15z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 18H20V26H18z",
                  "transform": "rotate(-180 19 22)"
                }
              }
            ],
            "name": "chart--cluster-bar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartClusterBar24",
          "filepath": "chart--cluster-bar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H12V26H10zM7 22H9V26H7zM26 8H28V26H26zM23 14H25V26H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V26H15z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 18H20V26H18z",
                  "transform": "rotate(-180 19 22)"
                }
              }
            ],
            "name": "chart--cluster-bar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartClusterBar20",
          "filepath": "chart--cluster-bar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H12V26H10zM7 22H9V26H7zM26 8H28V26H26zM23 14H25V26H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V26H15z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 18H20V26H18z",
                  "transform": "rotate(-180 19 22)"
                }
              }
            ],
            "name": "chart--cluster-bar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartClusterBar16",
          "filepath": "chart--cluster-bar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H12V26H10zM7 22H9V26H7zM26 8H28V26H26zM23 14H25V26H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V26H15z",
                  "transform": "rotate(-180 16 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 18H20V26H18z",
                  "transform": "rotate(-180 19 22)"
                }
              }
            ],
            "name": "chart--cluster-bar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartClusterBar",
        "global": "ChartClusterBar",
        "filepath": "ChartClusterBar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 16H12V26H10zM7 22H9V26H7zM26 8H28V26H26zM23 14H25V26H23z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 12H17V26H15z",
                    "transform": "rotate(-180 16 19)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 18H20V26H18z",
                    "transform": "rotate(-180 19 22)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--column",
      "friendlyName": "Chart column",
      "aliases": [
        "chart column",
        "column chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--column.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z\"/></svg>",
            "info": {},
            "path": "32/chart--column.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartColumn32",
          "filepath": "chart--column/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
                }
              }
            ],
            "name": "chart--column",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartColumn24",
          "filepath": "chart--column/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
                }
              }
            ],
            "name": "chart--column",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartColumn20",
          "filepath": "chart--column/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
                }
              }
            ],
            "name": "chart--column",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartColumn16",
          "filepath": "chart--column/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
                }
              }
            ],
            "name": "chart--column",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartColumn",
        "global": "ChartColumn",
        "filepath": "ChartColumn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--column-floating",
      "friendlyName": "Chart column floating",
      "aliases": [
        "chart column floating",
        "floating column chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--column-floating.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,22H20V4h8Zm-6-2h4V6H22Z\"/>\n  <path d=\"M16,24H8V10h8Zm-6-2h4V12H10Z\"/>\n  <path d=\"M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 22H20V4h8zm-6-2h4V6H22zM16 24H8V10h8zm-6-2h4V12H10z\"/><path d=\"M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z\"/></svg>",
            "info": {},
            "path": "32/chart--column-floating.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartColumnFloating32",
          "filepath": "chart--column-floating/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H20V4h8zm-6-2h4V6H22zM16 24H8V10h8zm-6-2h4V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--column-floating",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartColumnFloating24",
          "filepath": "chart--column-floating/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H20V4h8zm-6-2h4V6H22zM16 24H8V10h8zm-6-2h4V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--column-floating",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartColumnFloating20",
          "filepath": "chart--column-floating/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H20V4h8zm-6-2h4V6H22zM16 24H8V10h8zm-6-2h4V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--column-floating",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartColumnFloating16",
          "filepath": "chart--column-floating/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H20V4h8zm-6-2h4V6H22zM16 24H8V10h8zm-6-2h4V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--column-floating",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartColumnFloating",
        "global": "ChartColumnFloating",
        "filepath": "ChartColumnFloating.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 22H20V4h8zm-6-2h4V6H22zM16 24H8V10h8zm-6-2h4V12H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2.0021,2.0021,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--column-target",
      "friendlyName": "Chart column target",
      "aliases": [
        "chart column target",
        "target column chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--column-target.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,28V6H19V28H15V14H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V16h4Zm12,0H21V8h4Z\"/>\n  <rect x=\"19\" y=\"2\" width=\"8\" height=\"2\"/>\n  <rect x=\"7\" y=\"10\" width=\"8\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 28V6H19V28H15V14H7V28H4V2H2V28a2 2 0 002 2H30V28zM13 28H9V16h4zm12 0H21V8h4zM19 2H27V4H19z\"/><path d=\"M7 10H15V12H7z\"/></svg>",
            "info": {},
            "path": "32/chart--column-target.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartColumnTarget32",
          "filepath": "chart--column-target/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28V6H19V28H15V14H7V28H4V2H2V28a2 2 0 002 2H30V28zM13 28H9V16h4zm12 0H21V8h4zM19 2H27V4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 10H15V12H7z"
                }
              }
            ],
            "name": "chart--column-target",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartColumnTarget24",
          "filepath": "chart--column-target/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28V6H19V28H15V14H7V28H4V2H2V28a2 2 0 002 2H30V28zM13 28H9V16h4zm12 0H21V8h4zM19 2H27V4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 10H15V12H7z"
                }
              }
            ],
            "name": "chart--column-target",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartColumnTarget20",
          "filepath": "chart--column-target/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28V6H19V28H15V14H7V28H4V2H2V28a2 2 0 002 2H30V28zM13 28H9V16h4zm12 0H21V8h4zM19 2H27V4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 10H15V12H7z"
                }
              }
            ],
            "name": "chart--column-target",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartColumnTarget16",
          "filepath": "chart--column-target/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28V6H19V28H15V14H7V28H4V2H2V28a2 2 0 002 2H30V28zM13 28H9V16h4zm12 0H21V8h4zM19 2H27V4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 10H15V12H7z"
                }
              }
            ],
            "name": "chart--column-target",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartColumnTarget",
        "global": "ChartColumnTarget",
        "filepath": "ChartColumnTarget.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 28V6H19V28H15V14H7V28H4V2H2V28a2 2 0 002 2H30V28zM13 28H9V16h4zm12 0H21V8h4zM19 2H27V4H19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 10H15V12H7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--combo",
      "friendlyName": "Chart combo",
      "aliases": [
        "chart combo",
        "combo chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--combo.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z\"/>\n  <path d=\"M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z\"/><path d=\"M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z\"/></svg>",
            "info": {},
            "path": "32/chart--combo.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartCombo32",
          "filepath": "chart--combo/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartCombo24",
          "filepath": "chart--combo/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartCombo20",
          "filepath": "chart--combo/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartCombo16",
          "filepath": "chart--combo/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartCombo",
        "global": "ChartCombo",
        "filepath": "ChartCombo.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V14h4Zm12,0H21V18h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--combo-stacked",
      "friendlyName": "Chart combo stacked",
      "aliases": [
        "chart combo stacked",
        "combo stacked chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--combo-stacked.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z\"/>\n  <path d=\"M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z\"/><path d=\"M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z\"/></svg>",
            "info": {},
            "path": "32/chart--combo-stacked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartComboStacked32",
          "filepath": "chart--combo-stacked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo-stacked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartComboStacked24",
          "filepath": "chart--combo-stacked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo-stacked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartComboStacked20",
          "filepath": "chart--combo-stacked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo-stacked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartComboStacked16",
          "filepath": "chart--combo-stacked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                }
              }
            ],
            "name": "chart--combo-stacked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartComboStacked",
        "global": "ChartComboStacked",
        "filepath": "ChartComboStacked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,28V16H19V28H15V12H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,14v6H9V14Zm12,4v6H21V18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.7856,14a1.9877,1.9877,0,0,1-1.1787-.3865L11.2041,5.987,8.2419,10,6.6374,8.8065l2.9812-4a1.9978,1.9978,0,0,1,2.749-.446l10.4214,7.64,3.6045-4.8613L28,8.3306l-3.6045,4.8611A2.0014,2.0014,0,0,1,22.7856,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--custom",
      "friendlyName": "Chart custom",
      "aliases": [
        "chart custom",
        "custom chart",
        "chart",
        "pencil",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--custom.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--custom</title>\n  <path d=\"M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z\"/>\n  <rect x=\"17\" y=\"15\" width=\"4\" height=\"2\" transform=\"translate(3 35) rotate(-90)\"/>\n  <rect x=\"12\" y=\"14\" width=\"6\" height=\"2\" transform=\"translate(0 30) rotate(-90)\"/>\n  <rect x=\"6\" y=\"12\" width=\"10\" height=\"2\" transform=\"translate(-2 24) rotate(-90)\"/>\n  <path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z\"/><path d=\"M17 15H21V17H17z\" transform=\"rotate(-90 19 16)\"/><path d=\"M12 14H18V16H12z\" transform=\"rotate(-90 15 15)\"/><path d=\"M6 12H16V14H6z\" transform=\"rotate(-90 11 13)\"/><path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z\"/></svg>",
            "info": {},
            "path": "32/chart--custom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartCustom32",
          "filepath": "chart--custom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15H21V17H17z",
                  "transform": "rotate(-90 19 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 14H18V16H12z",
                  "transform": "rotate(-90 15 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H16V14H6z",
                  "transform": "rotate(-90 11 13)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "chart--custom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartCustom24",
          "filepath": "chart--custom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15H21V17H17z",
                  "transform": "rotate(-90 19 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 14H18V16H12z",
                  "transform": "rotate(-90 15 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H16V14H6z",
                  "transform": "rotate(-90 11 13)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "chart--custom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartCustom20",
          "filepath": "chart--custom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15H21V17H17z",
                  "transform": "rotate(-90 19 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 14H18V16H12z",
                  "transform": "rotate(-90 15 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H16V14H6z",
                  "transform": "rotate(-90 11 13)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "chart--custom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartCustom16",
          "filepath": "chart--custom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15H21V17H17z",
                  "transform": "rotate(-90 19 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 14H18V16H12z",
                  "transform": "rotate(-90 15 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H16V14H6z",
                  "transform": "rotate(-90 11 13)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "chart--custom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartCustom",
        "global": "ChartCustom",
        "filepath": "ChartCustom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 15H21V17H17z",
                    "transform": "rotate(-90 19 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 14H18V16H12z",
                    "transform": "rotate(-90 15 15)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 12H16V14H6z",
                    "transform": "rotate(-90 11 13)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--error-bar",
      "friendlyName": "Chart error bar",
      "aliases": [
        "chart error bar",
        "error bar chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--error-bar.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--error-bar</title>\n  <path d=\"M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z\"/></svg>",
            "info": {},
            "path": "32/chart--error-bar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartErrorBar32",
          "filepath": "chart--error-bar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z"
                }
              }
            ],
            "name": "chart--error-bar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartErrorBar24",
          "filepath": "chart--error-bar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z"
                }
              }
            ],
            "name": "chart--error-bar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartErrorBar20",
          "filepath": "chart--error-bar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z"
                }
              }
            ],
            "name": "chart--error-bar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartErrorBar16",
          "filepath": "chart--error-bar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z"
                }
              }
            ],
            "name": "chart--error-bar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartErrorBar",
        "global": "ChartErrorBar",
        "filepath": "ChartErrorBar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,28V12H18V8h2V6H14V8h2v4H12V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM14,14h2v4H14Zm6,14H14V20h6Zm0-10H18V14h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--error-bar--alt",
      "friendlyName": "Chart error bar alt",
      "aliases": [
        "chart error bar alt",
        "alt error bar chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--error-bar--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--error-bar-alt</title>\n  <path d=\"M14,10V8H8v2h2v4.1836a2.983,2.983,0,0,0,0,5.6328V24H8v2h6V24H12V19.8164a2.983,2.983,0,0,0,0-5.6328V10Z\"/>\n  <path d=\"M26,6V4H20V6h2V8.1836a2.983,2.983,0,0,0,0,5.6328V18H20v2h6V18H24V13.8164a2.983,2.983,0,0,0,0-5.6328V6Z\"/>\n  <path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 10V8H8v2h2v4.1836a2.983 2.983 0 000 5.6328V24H8v2h6V24H12V19.8164a2.983 2.983 0 000-5.6328V10zM26 6V4H20V6h2V8.1836a2.983 2.983 0 000 5.6328V18H20v2h6V18H24V13.8164a2.983 2.983 0 000-5.6328V6z\"/><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/></svg>",
            "info": {},
            "path": "32/chart--error-bar--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartErrorBarAlt32",
          "filepath": "chart--error-bar--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10V8H8v2h2v4.1836a2.983 2.983 0 000 5.6328V24H8v2h6V24H12V19.8164a2.983 2.983 0 000-5.6328V10zM26 6V4H20V6h2V8.1836a2.983 2.983 0 000 5.6328V18H20v2h6V18H24V13.8164a2.983 2.983 0 000-5.6328V6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--error-bar--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartErrorBarAlt24",
          "filepath": "chart--error-bar--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10V8H8v2h2v4.1836a2.983 2.983 0 000 5.6328V24H8v2h6V24H12V19.8164a2.983 2.983 0 000-5.6328V10zM26 6V4H20V6h2V8.1836a2.983 2.983 0 000 5.6328V18H20v2h6V18H24V13.8164a2.983 2.983 0 000-5.6328V6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--error-bar--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartErrorBarAlt20",
          "filepath": "chart--error-bar--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10V8H8v2h2v4.1836a2.983 2.983 0 000 5.6328V24H8v2h6V24H12V19.8164a2.983 2.983 0 000-5.6328V10zM26 6V4H20V6h2V8.1836a2.983 2.983 0 000 5.6328V18H20v2h6V18H24V13.8164a2.983 2.983 0 000-5.6328V6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--error-bar--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartErrorBarAlt16",
          "filepath": "chart--error-bar--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10V8H8v2h2v4.1836a2.983 2.983 0 000 5.6328V24H8v2h6V24H12V19.8164a2.983 2.983 0 000-5.6328V10zM26 6V4H20V6h2V8.1836a2.983 2.983 0 000 5.6328V18H20v2h6V18H24V13.8164a2.983 2.983 0 000-5.6328V6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--error-bar--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartErrorBarAlt",
        "global": "ChartErrorBarAlt",
        "filepath": "ChartErrorBarAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 10V8H8v2h2v4.1836a2.983 2.983 0 000 5.6328V24H8v2h6V24H12V19.8164a2.983 2.983 0 000-5.6328V10zM26 6V4H20V6h2V8.1836a2.983 2.983 0 000 5.6328V18H20v2h6V18H24V13.8164a2.983 2.983 0 000-5.6328V6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--evaluation",
      "friendlyName": "Chart evaluation",
      "aliases": [
        "chart evaluation",
        "evaluation chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--evaluation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--evaluation</title>\n  <rect x=\"25.6716\" y=\"6.207\" width=\"4.2426\" height=\"1.9991\" transform=\"translate(3.0496 21.7719) rotate(-45.0198)\"/>\n  <polygon points=\"16 20.5 11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5\"/>\n  <path d=\"M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.672 6.207H29.915V8.206H25.672z\" transform=\"rotate(-45.02 27.793 7.207)\"/><path d=\"M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z\"/><path d=\"M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z\"/></svg>",
            "info": {},
            "path": "32/chart--evaluation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartEvaluation32",
          "filepath": "chart--evaluation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.672 6.207H29.915V8.206H25.672z",
                  "transform": "rotate(-45.02 27.793 7.207)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--evaluation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartEvaluation24",
          "filepath": "chart--evaluation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.672 6.207H29.915V8.206H25.672z",
                  "transform": "rotate(-45.02 27.793 7.207)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--evaluation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartEvaluation20",
          "filepath": "chart--evaluation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.672 6.207H29.915V8.206H25.672z",
                  "transform": "rotate(-45.02 27.793 7.207)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--evaluation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartEvaluation16",
          "filepath": "chart--evaluation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.672 6.207H29.915V8.206H25.672z",
                  "transform": "rotate(-45.02 27.793 7.207)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--evaluation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartEvaluation",
        "global": "ChartEvaluation",
        "filepath": "ChartEvaluation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.672 6.207H29.915V8.206H25.672z",
                    "transform": "rotate(-45.02 27.793 7.207)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 20.5L11 15.539 12.59 13.969 16 17.349 23.41 10 25 11.579 16 20.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,28V25.4131L10.4141,19,9,17.585l-5,5V2H2V28a2,2,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--high-low",
      "friendlyName": "Chart high low",
      "aliases": [
        "chart high low",
        "high low chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--high-low.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--high-low</title>\n  <polygon points=\"15 8 12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8\"/>\n  <polygon points=\"27 10 24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10\"/>\n  <path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8zM27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z\"/><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/></svg>",
            "info": {},
            "path": "32/chart--high-low.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartHighLow32",
          "filepath": "chart--high-low/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8zM27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--high-low",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartHighLow24",
          "filepath": "chart--high-low/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8zM27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--high-low",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartHighLow20",
          "filepath": "chart--high-low/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8zM27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--high-low",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartHighLow16",
          "filepath": "chart--high-low/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8zM27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              }
            ],
            "name": "chart--high-low",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartHighLow",
        "global": "ChartHighLow",
        "filepath": "ChartHighLow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 8L12 8 12 6 10 6 10 20 7 20 7 22 10 22 10 24 12 24 12 10 15 10 15 8zM27 10L24 10 24 6 22 6 22 18 19 18 19 20 22 20 22 24 24 24 24 12 27 12 27 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--histogram",
      "friendlyName": "Chart histogram",
      "aliases": [
        "chart histogram",
        "histogram chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--histogram.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--histogram</title>\n  <path d=\"M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z\"/></svg>",
            "info": {},
            "path": "32/chart--histogram.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartHistogram32",
          "filepath": "chart--histogram/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z"
                }
              }
            ],
            "name": "chart--histogram",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartHistogram24",
          "filepath": "chart--histogram/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z"
                }
              }
            ],
            "name": "chart--histogram",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartHistogram20",
          "filepath": "chart--histogram/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z"
                }
              }
            ],
            "name": "chart--histogram",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartHistogram16",
          "filepath": "chart--histogram/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z"
                }
              }
            ],
            "name": "chart--histogram",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartHistogram",
        "global": "ChartHistogram",
        "filepath": "ChartHistogram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--line",
      "friendlyName": "Chart line",
      "aliases": [
        "graph",
        "chart line",
        "line chart",
        "bar",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--line.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chart--line</title><path d=\"M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z\"/></svg>",
            "info": {},
            "path": "32/chart--line.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartLine32",
          "filepath": "chart--line/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--line",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartLine24",
          "filepath": "chart--line/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--line",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartLine20",
          "filepath": "chart--line/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--line",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartLine16",
          "filepath": "chart--line/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--line",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartLine",
        "global": "ChartLine",
        "filepath": "ChartLine.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.67,28l6.39-12,7.3,6.49a2,2,0,0,0,1.7.47,2,2,0,0,0,1.42-1.07L27,10.9,25.18,10,19.69,21l-7.3-6.49A2,2,0,0,0,10.71,14a2,2,0,0,0-1.42,1L4,25V2H2V28a2,2,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--line--data",
      "friendlyName": "Chart line data",
      "aliases": [
        "graph",
        "chart line data",
        "line data chart",
        "bar",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--line--data.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chart--line</title><path d=\"M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z\"/></svg>",
            "info": {},
            "path": "32/chart--line--data.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartLineData32",
          "filepath": "chart--line--data/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z"
                }
              }
            ],
            "name": "chart--line--data",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartLineData24",
          "filepath": "chart--line--data/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z"
                }
              }
            ],
            "name": "chart--line--data",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartLineData20",
          "filepath": "chart--line--data/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z"
                }
              }
            ],
            "name": "chart--line--data",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartLineData16",
          "filepath": "chart--line--data/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z"
                }
              }
            ],
            "name": "chart--line--data",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartLineData",
        "global": "ChartLineData",
        "filepath": "ChartLineData.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.06,17.88A4.25,4.25,0,0,0,11,18a4,4,0,0,0,2.23-.68l3.22,2.87a3.88,3.88,0,0,0-.2,3.17A4,4,0,1,0,22.62,19l2.54-5.09a3.78,3.78,0,0,0,2.91-.53A4,4,0,1,0,23.38,13l-2.54,5.09A3.86,3.86,0,0,0,20,18a4,4,0,0,0-2.23.68l-3.22-2.87a3.88,3.88,0,0,0,.2-3.17A4,4,0,1,0,8.3,16.93L4,25V2H2V28a2,2,0,0,0,2,2H30V28H4.67ZM26,8a2,2,0,1,1-2,2A2,2,0,0,1,26,8ZM22,22a2,2,0,1,1-2-2A2,2,0,0,1,22,22ZM11,12a2,2,0,1,1-2,2A2,2,0,0,1,11,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--line-smooth",
      "friendlyName": "Chart line smooth",
      "aliases": [
        "chart line smooth",
        "line smooth chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--line-smooth.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z\"/></svg>",
            "info": {},
            "path": "32/chart--line-smooth.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartLineSmooth32",
          "filepath": "chart--line-smooth/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z"
                }
              }
            ],
            "name": "chart--line-smooth",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartLineSmooth24",
          "filepath": "chart--line-smooth/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z"
                }
              }
            ],
            "name": "chart--line-smooth",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartLineSmooth20",
          "filepath": "chart--line-smooth/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z"
                }
              }
            ],
            "name": "chart--line-smooth",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartLineSmooth16",
          "filepath": "chart--line-smooth/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z"
                }
              }
            ],
            "name": "chart--line-smooth",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartLineSmooth",
        "global": "ChartLineSmooth",
        "filepath": "ChartLineSmooth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,15c1.4854,0,2.5544,1.4966,3.6863,3.0811C17.9983,19.918,19.4854,22,22,22c5.6709,0,7.78-10.79,8-12l-1.9678-.3584C27.55,12.2827,25.3938,20,22,20c-1.4854,0-2.5544-1.4966-3.6863-3.0811C17.0017,15.082,15.5146,13,13,13c-4.186,0-7.4448,7.4043-9,11.7617V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H5.0439C6.5544,22.8574,9.9634,15,13,15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--marimekko",
      "friendlyName": "Chart Marimekko",
      "aliases": [
        "chart Marimekko",
        "Marimekko chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--marimekko.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z\"/></svg>",
            "info": {},
            "path": "32/chart--marimekko.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartMarimekko32",
          "filepath": "chart--marimekko/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
                }
              }
            ],
            "name": "chart--marimekko",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartMarimekko24",
          "filepath": "chart--marimekko/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
                }
              }
            ],
            "name": "chart--marimekko",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartMarimekko20",
          "filepath": "chart--marimekko/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
                }
              }
            ],
            "name": "chart--marimekko",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartMarimekko16",
          "filepath": "chart--marimekko/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
                }
              }
            ],
            "name": "chart--marimekko",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartMarimekko",
        "global": "ChartMarimekko",
        "filepath": "ChartMarimekko.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--maximum",
      "friendlyName": "Chart maximum",
      "aliases": [
        "chart maximum",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--maximum.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"6\" width=\"2\" height=\"2\"/>\n  <rect x=\"12\" y=\"6\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"6\" width=\"2\" height=\"2\"/>\n  <rect x=\"24\" y=\"6\" width=\"2\" height=\"2\"/>\n  <rect x=\"28\" y=\"6\" width=\"2\" height=\"2\"/>\n  <path d=\"M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 6H10V8H8zM12 6H14V8H12zM20 6H22V8H20zM24 6H26V8H24zM28 6H30V8H28z\"/><path d=\"M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z\"/></svg>",
            "info": {},
            "path": "32/chart--maximum.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartMaximum32",
          "filepath": "chart--maximum/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H10V8H8zM12 6H14V8H12zM20 6H22V8H20zM24 6H26V8H24zM28 6H30V8H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
                }
              }
            ],
            "name": "chart--maximum",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartMaximum24",
          "filepath": "chart--maximum/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H10V8H8zM12 6H14V8H12zM20 6H22V8H20zM24 6H26V8H24zM28 6H30V8H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
                }
              }
            ],
            "name": "chart--maximum",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartMaximum20",
          "filepath": "chart--maximum/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H10V8H8zM12 6H14V8H12zM20 6H22V8H20zM24 6H26V8H24zM28 6H30V8H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
                }
              }
            ],
            "name": "chart--maximum",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartMaximum16",
          "filepath": "chart--maximum/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H10V8H8zM12 6H14V8H12zM20 6H22V8H20zM24 6H26V8H24zM28 6H30V8H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
                }
              }
            ],
            "name": "chart--maximum",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartMaximum",
        "global": "ChartMaximum",
        "filepath": "ChartMaximum.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 6H10V8H8zM12 6H14V8H12zM20 6H22V8H20zM24 6H26V8H24zM28 6H30V8H28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--median",
      "friendlyName": "Chart median",
      "aliases": [
        "chart median",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--median.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"16\" y=\"22\" width=\"2\" height=\"2\" transform=\"translate(-6 40) rotate(-90)\"/>\n  <path d=\"M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z\"/>\n  <path d=\"M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z\"/>\n  <rect x=\"16\" y=\"6\" width=\"2\" height=\"2\" transform=\"translate(10 24) rotate(-90)\"/>\n  <rect x=\"16\" y=\"2\" width=\"2\" height=\"2\" transform=\"translate(14 20) rotate(-90)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22H18V24H16z\" transform=\"rotate(-90 17 23)\"/><path d=\"M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z\"/><path d=\"M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z\"/><path d=\"M16 6H18V8H16z\" transform=\"rotate(-90 17 7)\"/><path d=\"M16 2H18V4H16z\" transform=\"rotate(-90 17 3)\"/></svg>",
            "info": {},
            "path": "32/chart--median.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartMedian32",
          "filepath": "chart--median/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H18V24H16z",
                  "transform": "rotate(-90 17 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H18V8H16z",
                  "transform": "rotate(-90 17 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2H18V4H16z",
                  "transform": "rotate(-90 17 3)"
                }
              }
            ],
            "name": "chart--median",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartMedian24",
          "filepath": "chart--median/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H18V24H16z",
                  "transform": "rotate(-90 17 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H18V8H16z",
                  "transform": "rotate(-90 17 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2H18V4H16z",
                  "transform": "rotate(-90 17 3)"
                }
              }
            ],
            "name": "chart--median",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartMedian20",
          "filepath": "chart--median/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H18V24H16z",
                  "transform": "rotate(-90 17 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H18V8H16z",
                  "transform": "rotate(-90 17 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2H18V4H16z",
                  "transform": "rotate(-90 17 3)"
                }
              }
            ],
            "name": "chart--median",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartMedian16",
          "filepath": "chart--median/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H18V24H16z",
                  "transform": "rotate(-90 17 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H18V8H16z",
                  "transform": "rotate(-90 17 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2H18V4H16z",
                  "transform": "rotate(-90 17 3)"
                }
              }
            ],
            "name": "chart--median",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartMedian",
        "global": "ChartMedian",
        "filepath": "ChartMedian.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22H18V24H16z",
                    "transform": "rotate(-90 17 23)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 6H18V8H16z",
                    "transform": "rotate(-90 17 7)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 2H18V4H16z",
                    "transform": "rotate(-90 17 3)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--minimum",
      "friendlyName": "Chart minimum",
      "aliases": [
        "chart minimum",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--minimum.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z\"/>\n  <rect x=\"8\" y=\"24\" width=\"2\" height=\"2\"/>\n  <rect x=\"12\" y=\"24\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"24\" width=\"2\" height=\"2\"/>\n  <rect x=\"24\" y=\"24\" width=\"2\" height=\"2\"/>\n  <rect x=\"28\" y=\"24\" width=\"2\" height=\"2\"/>\n  <path d=\"M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z\"/><path d=\"M8 24H10V26H8zM12 24H14V26H12zM20 24H22V26H20zM24 24H26V26H24zM28 24H30V26H28z\"/><path d=\"M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z\"/></svg>",
            "info": {},
            "path": "32/chart--minimum.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartMinimum32",
          "filepath": "chart--minimum/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H10V26H8zM12 24H14V26H12zM20 24H22V26H20zM24 24H26V26H24zM28 24H30V26H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
                }
              }
            ],
            "name": "chart--minimum",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartMinimum24",
          "filepath": "chart--minimum/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H10V26H8zM12 24H14V26H12zM20 24H22V26H20zM24 24H26V26H24zM28 24H30V26H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
                }
              }
            ],
            "name": "chart--minimum",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartMinimum20",
          "filepath": "chart--minimum/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H10V26H8zM12 24H14V26H12zM20 24H22V26H20zM24 24H26V26H24zM28 24H30V26H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
                }
              }
            ],
            "name": "chart--minimum",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartMinimum16",
          "filepath": "chart--minimum/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H10V26H8zM12 24H14V26H12zM20 24H22V26H20zM24 24H26V26H24zM28 24H30V26H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
                }
              }
            ],
            "name": "chart--minimum",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartMinimum",
        "global": "ChartMinimum",
        "filepath": "ChartMinimum.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 24H10V26H8zM12 24H14V26H12zM20 24H22V26H20zM24 24H26V26H24zM28 24H30V26H28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--multi-line",
      "friendlyName": "Chart multi-line",
      "aliases": [
        "chart multi-line",
        "multi-line chart",
        "multiline chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--multi-line.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--multi-line</title>\n  <path d=\"M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z\"/></svg>",
            "info": {},
            "path": "32/chart--multi-line.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartMultiLine32",
          "filepath": "chart--multi-line/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--multi-line",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartMultiLine24",
          "filepath": "chart--multi-line/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--multi-line",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartMultiLine20",
          "filepath": "chart--multi-line/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--multi-line",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartMultiLine16",
          "filepath": "chart--multi-line/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "chart--multi-line",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartMultiLine",
        "global": "ChartMultiLine",
        "filepath": "ChartMultiLine.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--multitype",
      "friendlyName": "Chart multitype",
      "aliases": [
        "chart multitype",
        "multitype chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--multitype.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"28\" y=\"22\" width=\"2\" height=\"8\"/>\n  <rect x=\"24\" y=\"18\" width=\"2\" height=\"12\"/>\n  <rect x=\"20\" y=\"26\" width=\"2\" height=\"4\"/>\n  <path d=\"M9,16a7,7,0,1,0,7,7A7.0078,7.0078,0,0,0,9,16Zm4.8989,6H10V18.1011A5.0145,5.0145,0,0,1,13.8989,22ZM9,28a5,5,0,0,1-1-9.8989V22a2,2,0,0,0,2,2h3.8989A5.0081,5.0081,0,0,1,9,28Z\"/>\n  <path d=\"M22.5352,12l4-6H30V4H25.4648l-4,6H18V2H16V14a2,2,0,0,0,2,2H30V14H18V12Z\"/>\n  <circle cx=\"11\" cy=\"7\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"11\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"5\" r=\"1\"/>\n  <circle cx=\"5\" cy=\"9\" r=\"1\"/>\n  <circle cx=\"3\" cy=\"13\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 22H30V30H28zM24 18H26V30H24zM20 26H22V30H20zM9 16a7 7 0 107 7A7.0078 7.0078 0 009 16zm4.8989 6H10V18.1011A5.0145 5.0145 0 0113.8989 22zM9 28a5 5 0 01-1-9.8989V22a2 2 0 002 2h3.8989A5.0081 5.0081 0 019 28zM22.5352 12l4-6H30V4H25.4648l-4 6H18V2H16V14a2 2 0 002 2H30V14H18V12z\"/><circle cx=\"11\" cy=\"7\" r=\"1\"/><circle cx=\"9\" cy=\"11\" r=\"1\"/><circle cx=\"7\" cy=\"5\" r=\"1\"/><circle cx=\"5\" cy=\"9\" r=\"1\"/><circle cx=\"3\" cy=\"13\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/chart--multitype.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartMultitype32",
          "filepath": "chart--multitype/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H30V30H28zM24 18H26V30H24zM20 26H22V30H20zM9 16a7 7 0 107 7A7.0078 7.0078 0 009 16zm4.8989 6H10V18.1011A5.0145 5.0145 0 0113.8989 22zM9 28a5 5 0 01-1-9.8989V22a2 2 0 002 2h3.8989A5.0081 5.0081 0 019 28zM22.5352 12l4-6H30V4H25.4648l-4 6H18V2H16V14a2 2 0 002 2H30V14H18V12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "13",
                  "r": "1"
                }
              }
            ],
            "name": "chart--multitype",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartMultitype24",
          "filepath": "chart--multitype/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H30V30H28zM24 18H26V30H24zM20 26H22V30H20zM9 16a7 7 0 107 7A7.0078 7.0078 0 009 16zm4.8989 6H10V18.1011A5.0145 5.0145 0 0113.8989 22zM9 28a5 5 0 01-1-9.8989V22a2 2 0 002 2h3.8989A5.0081 5.0081 0 019 28zM22.5352 12l4-6H30V4H25.4648l-4 6H18V2H16V14a2 2 0 002 2H30V14H18V12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "13",
                  "r": "1"
                }
              }
            ],
            "name": "chart--multitype",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartMultitype20",
          "filepath": "chart--multitype/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H30V30H28zM24 18H26V30H24zM20 26H22V30H20zM9 16a7 7 0 107 7A7.0078 7.0078 0 009 16zm4.8989 6H10V18.1011A5.0145 5.0145 0 0113.8989 22zM9 28a5 5 0 01-1-9.8989V22a2 2 0 002 2h3.8989A5.0081 5.0081 0 019 28zM22.5352 12l4-6H30V4H25.4648l-4 6H18V2H16V14a2 2 0 002 2H30V14H18V12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "13",
                  "r": "1"
                }
              }
            ],
            "name": "chart--multitype",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartMultitype16",
          "filepath": "chart--multitype/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H30V30H28zM24 18H26V30H24zM20 26H22V30H20zM9 16a7 7 0 107 7A7.0078 7.0078 0 009 16zm4.8989 6H10V18.1011A5.0145 5.0145 0 0113.8989 22zM9 28a5 5 0 01-1-9.8989V22a2 2 0 002 2h3.8989A5.0081 5.0081 0 019 28zM22.5352 12l4-6H30V4H25.4648l-4 6H18V2H16V14a2 2 0 002 2H30V14H18V12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "13",
                  "r": "1"
                }
              }
            ],
            "name": "chart--multitype",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartMultitype",
        "global": "ChartMultitype",
        "filepath": "ChartMultitype.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 22H30V30H28zM24 18H26V30H24zM20 26H22V30H20zM9 16a7 7 0 107 7A7.0078 7.0078 0 009 16zm4.8989 6H10V18.1011A5.0145 5.0145 0 0113.8989 22zM9 28a5 5 0 01-1-9.8989V22a2 2 0 002 2h3.8989A5.0081 5.0081 0 019 28zM22.5352 12l4-6H30V4H25.4648l-4 6H18V2H16V14a2 2 0 002 2H30V14H18V12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "5",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "5",
                    "cy": "9",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "13",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--network",
      "friendlyName": "Chart network",
      "aliases": [
        "graph",
        "chart network",
        "network chart",
        "chart",
        "bar",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--network.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chart-network</title><path d=\"M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z\"/></svg>",
            "info": {},
            "path": "32/chart--network.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartNetwork32",
          "filepath": "chart--network/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
                }
              }
            ],
            "name": "chart--network",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartNetwork24",
          "filepath": "chart--network/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
                }
              }
            ],
            "name": "chart--network",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartNetwork20",
          "filepath": "chart--network/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
                }
              }
            ],
            "name": "chart--network",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartNetwork16",
          "filepath": "chart--network/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
                }
              }
            ],
            "name": "chart--network",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartNetwork",
        "global": "ChartNetwork",
        "filepath": "ChartNetwork.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--parallel",
      "friendlyName": "Chart parallel",
      "aliases": [
        "chart parallel",
        "parallel chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--parallel.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--parallel</title>\n  <path d=\"M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z\"/></svg>",
            "info": {},
            "path": "32/chart--parallel.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartParallel32",
          "filepath": "chart--parallel/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
                }
              }
            ],
            "name": "chart--parallel",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartParallel24",
          "filepath": "chart--parallel/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
                }
              }
            ],
            "name": "chart--parallel",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartParallel20",
          "filepath": "chart--parallel/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
                }
              }
            ],
            "name": "chart--parallel",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartParallel16",
          "filepath": "chart--parallel/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
                }
              }
            ],
            "name": "chart--parallel",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartParallel",
        "global": "ChartParallel",
        "filepath": "ChartParallel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--pie",
      "friendlyName": "Chart pie",
      "aliases": [
        "bar",
        "chart pie",
        "chart",
        "data",
        "pie chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--pie.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chart--pie</title><path d=\"M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z\"/></svg>",
            "info": {},
            "path": "32/chart--pie.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartPie32",
          "filepath": "chart--pie/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
                }
              }
            ],
            "name": "chart--pie",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartPie24",
          "filepath": "chart--pie/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
                }
              }
            ],
            "name": "chart--pie",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartPie20",
          "filepath": "chart--pie/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
                }
              }
            ],
            "name": "chart--pie",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartPie16",
          "filepath": "chart--pie/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
                }
              }
            ],
            "name": "chart--pie",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartPie",
        "global": "ChartPie",
        "filepath": "ChartPie.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--point",
      "friendlyName": "Chart point",
      "aliases": [
        "bar",
        "chart point",
        "chart",
        "data",
        "point chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--point.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z\"/>\n  <circle cx=\"9\" cy=\"6\" r=\"3\"/>\n  <circle cx=\"9\" cy=\"22\" r=\"3\"/>\n  <circle cx=\"18\" cy=\"14\" r=\"3\"/>\n  <path d=\"M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z\"/>\n  <circle cx=\"27\" cy=\"6\" r=\"3\"/>\n  <circle cx=\"27\" cy=\"22\" r=\"3\"/>\n  <path d=\"M27,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,27,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,27,13Z\"/>\n  <path d=\"M18,26a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,18,26Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,18,22Z\"/>\n  <path d=\"M18,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,18,8Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,18,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z\"/><circle cx=\"9\" cy=\"6\" r=\"3\"/><circle cx=\"9\" cy=\"22\" r=\"3\"/><circle cx=\"18\" cy=\"14\" r=\"3\"/><path d=\"M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z\"/><circle cx=\"27\" cy=\"6\" r=\"3\"/><circle cx=\"27\" cy=\"22\" r=\"3\"/><path d=\"M27 17a3 3 0 113-3A3.0033 3.0033 0 0127 17zm0-4a1 1 0 101 1A1.001 1.001 0 0027 13zM18 26a3 3 0 113-3A3.0033 3.0033 0 0118 26zm0-4a1 1 0 101 1A1.001 1.001 0 0018 22zM18 8a3 3 0 113-3A3.0033 3.0033 0 0118 8zm0-4a1 1 0 101 1A1.001 1.001 0 0018 4z\"/></svg>",
            "info": {},
            "path": "32/chart--point.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartPoint32",
          "filepath": "chart--point/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "14",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 17a3 3 0 113-3A3.0033 3.0033 0 0127 17zm0-4a1 1 0 101 1A1.001 1.001 0 0027 13zM18 26a3 3 0 113-3A3.0033 3.0033 0 0118 26zm0-4a1 1 0 101 1A1.001 1.001 0 0018 22zM18 8a3 3 0 113-3A3.0033 3.0033 0 0118 8zm0-4a1 1 0 101 1A1.001 1.001 0 0018 4z"
                }
              }
            ],
            "name": "chart--point",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartPoint24",
          "filepath": "chart--point/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "14",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 17a3 3 0 113-3A3.0033 3.0033 0 0127 17zm0-4a1 1 0 101 1A1.001 1.001 0 0027 13zM18 26a3 3 0 113-3A3.0033 3.0033 0 0118 26zm0-4a1 1 0 101 1A1.001 1.001 0 0018 22zM18 8a3 3 0 113-3A3.0033 3.0033 0 0118 8zm0-4a1 1 0 101 1A1.001 1.001 0 0018 4z"
                }
              }
            ],
            "name": "chart--point",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartPoint20",
          "filepath": "chart--point/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "14",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 17a3 3 0 113-3A3.0033 3.0033 0 0127 17zm0-4a1 1 0 101 1A1.001 1.001 0 0027 13zM18 26a3 3 0 113-3A3.0033 3.0033 0 0118 26zm0-4a1 1 0 101 1A1.001 1.001 0 0018 22zM18 8a3 3 0 113-3A3.0033 3.0033 0 0118 8zm0-4a1 1 0 101 1A1.001 1.001 0 0018 4z"
                }
              }
            ],
            "name": "chart--point",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartPoint16",
          "filepath": "chart--point/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "14",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "6",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "22",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 17a3 3 0 113-3A3.0033 3.0033 0 0127 17zm0-4a1 1 0 101 1A1.001 1.001 0 0027 13zM18 26a3 3 0 113-3A3.0033 3.0033 0 0118 26zm0-4a1 1 0 101 1A1.001 1.001 0 0018 22zM18 8a3 3 0 113-3A3.0033 3.0033 0 0118 8zm0-4a1 1 0 101 1A1.001 1.001 0 0018 4z"
                }
              }
            ],
            "name": "chart--point",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartPoint",
        "global": "ChartPoint",
        "filepath": "ChartPoint.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "6",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "22",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18",
                    "cy": "14",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "27",
                    "cy": "6",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "27",
                    "cy": "22",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 17a3 3 0 113-3A3.0033 3.0033 0 0127 17zm0-4a1 1 0 101 1A1.001 1.001 0 0027 13zM18 26a3 3 0 113-3A3.0033 3.0033 0 0118 26zm0-4a1 1 0 101 1A1.001 1.001 0 0018 22zM18 8a3 3 0 113-3A3.0033 3.0033 0 0118 8zm0-4a1 1 0 101 1A1.001 1.001 0 0018 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--population",
      "friendlyName": "Chart population",
      "aliases": [
        "chart population",
        "population chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--population.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--population</title>\n  <path d=\"M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z\"/></svg>",
            "info": {},
            "path": "32/chart--population.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartPopulation32",
          "filepath": "chart--population/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
                }
              }
            ],
            "name": "chart--population",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartPopulation24",
          "filepath": "chart--population/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
                }
              }
            ],
            "name": "chart--population",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartPopulation20",
          "filepath": "chart--population/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
                }
              }
            ],
            "name": "chart--population",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartPopulation16",
          "filepath": "chart--population/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
                }
              }
            ],
            "name": "chart--population",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartPopulation",
        "global": "ChartPopulation",
        "filepath": "ChartPopulation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--radar",
      "friendlyName": "Chart radar",
      "aliases": [
        "chart radar",
        "radar chart",
        "radar",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--radar.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--radar</title>\n  <path d=\"M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z\"/></svg>",
            "info": {},
            "path": "32/chart--radar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartRadar32",
          "filepath": "chart--radar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
                }
              }
            ],
            "name": "chart--radar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartRadar24",
          "filepath": "chart--radar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
                }
              }
            ],
            "name": "chart--radar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartRadar20",
          "filepath": "chart--radar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
                }
              }
            ],
            "name": "chart--radar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartRadar16",
          "filepath": "chart--radar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
                }
              }
            ],
            "name": "chart--radar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartRadar",
        "global": "ChartRadar",
        "filepath": "ChartRadar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--radial",
      "friendlyName": "Chart radial",
      "aliases": [
        "chart radial",
        "radial chart",
        "radial",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--radial.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z\"/>\n  <path d=\"M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z\"/>\n  <path d=\"M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z\"/><path d=\"M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z\"/><path d=\"M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z\"/></svg>",
            "info": {},
            "path": "32/chart--radial.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartRadial32",
          "filepath": "chart--radial/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
                }
              }
            ],
            "name": "chart--radial",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartRadial24",
          "filepath": "chart--radial/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
                }
              }
            ],
            "name": "chart--radial",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartRadial20",
          "filepath": "chart--radial/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
                }
              }
            ],
            "name": "chart--radial",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartRadial16",
          "filepath": "chart--radial/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
                }
              }
            ],
            "name": "chart--radial",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartRadial",
        "global": "ChartRadial",
        "filepath": "ChartRadial.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--relationship",
      "friendlyName": "Chart relationship",
      "aliases": [
        "chart relationship",
        "relationship chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--relationship.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--relationship</title>\n  <path d=\"M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z\"/></svg>",
            "info": {},
            "path": "32/chart--relationship.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartRelationship32",
          "filepath": "chart--relationship/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
                }
              }
            ],
            "name": "chart--relationship",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartRelationship24",
          "filepath": "chart--relationship/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
                }
              }
            ],
            "name": "chart--relationship",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartRelationship20",
          "filepath": "chart--relationship/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
                }
              }
            ],
            "name": "chart--relationship",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartRelationship16",
          "filepath": "chart--relationship/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
                }
              }
            ],
            "name": "chart--relationship",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartRelationship",
        "global": "ChartRelationship",
        "filepath": "ChartRelationship.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--ring",
      "friendlyName": "Chart ring",
      "aliases": [
        "chart ring",
        "ring chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--ring.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--ring</title>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z\"/></svg>",
            "info": {},
            "path": "32/chart--ring.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartRing32",
          "filepath": "chart--ring/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
                }
              }
            ],
            "name": "chart--ring",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartRing24",
          "filepath": "chart--ring/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
                }
              }
            ],
            "name": "chart--ring",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartRing20",
          "filepath": "chart--ring/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
                }
              }
            ],
            "name": "chart--ring",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartRing16",
          "filepath": "chart--ring/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
                }
              }
            ],
            "name": "chart--ring",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartRing",
        "global": "ChartRing",
        "filepath": "ChartRing.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--river",
      "friendlyName": "Chart river",
      "aliases": [
        "chart river",
        "river chart",
        "chart",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--river.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--river</title>\n  <path d=\"M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z\"/></svg>",
            "info": {},
            "path": "32/chart--river.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartRiver32",
          "filepath": "chart--river/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
                }
              }
            ],
            "name": "chart--river",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartRiver24",
          "filepath": "chart--river/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
                }
              }
            ],
            "name": "chart--river",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartRiver20",
          "filepath": "chart--river/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
                }
              }
            ],
            "name": "chart--river",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartRiver16",
          "filepath": "chart--river/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
                }
              }
            ],
            "name": "chart--river",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartRiver",
        "global": "ChartRiver",
        "filepath": "ChartRiver.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--rose",
      "friendlyName": "Chart rose",
      "aliases": [
        "chart rose",
        "rose chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--rose.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--rose</title>\n  <path d=\"M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z\"/></svg>",
            "info": {},
            "path": "32/chart--rose.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartRose32",
          "filepath": "chart--rose/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
                }
              }
            ],
            "name": "chart--rose",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartRose24",
          "filepath": "chart--rose/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
                }
              }
            ],
            "name": "chart--rose",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartRose20",
          "filepath": "chart--rose/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
                }
              }
            ],
            "name": "chart--rose",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartRose16",
          "filepath": "chart--rose/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
                }
              }
            ],
            "name": "chart--rose",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartRose",
        "global": "ChartRose",
        "filepath": "ChartRose.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--scatter",
      "friendlyName": "Chart scatter",
      "aliases": [
        "graph",
        "bar",
        "data",
        "chart scatter",
        "scatter chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--scatter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chart--scatter</title><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/><circle cx=\"10\" cy=\"22\" r=\"2\"/><circle cx=\"14\" cy=\"15\" r=\"2\"/><circle cx=\"22\" cy=\"15\" r=\"2\"/><circle cx=\"26\" cy=\"6\" r=\"2\"/><circle cx=\"14\" cy=\"8\" r=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/><circle cx=\"10\" cy=\"22\" r=\"2\"/><circle cx=\"14\" cy=\"15\" r=\"2\"/><circle cx=\"22\" cy=\"15\" r=\"2\"/><circle cx=\"26\" cy=\"6\" r=\"2\"/><circle cx=\"14\" cy=\"8\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/chart--scatter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartScatter32",
          "filepath": "chart--scatter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              }
            ],
            "name": "chart--scatter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartScatter24",
          "filepath": "chart--scatter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              }
            ],
            "name": "chart--scatter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartScatter20",
          "filepath": "chart--scatter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              }
            ],
            "name": "chart--scatter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartScatter16",
          "filepath": "chart--scatter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "15",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              }
            ],
            "name": "chart--scatter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartScatter",
        "global": "ChartScatter",
        "filepath": "ChartScatter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "22",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "15",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "15",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "6",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "8",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--spiral",
      "friendlyName": "Chart spiral",
      "aliases": [
        "chart spiral",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--spiral.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z\"/></svg>",
            "info": {},
            "path": "32/chart--spiral.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartSpiral32",
          "filepath": "chart--spiral/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
                }
              }
            ],
            "name": "chart--spiral",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartSpiral24",
          "filepath": "chart--spiral/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
                }
              }
            ],
            "name": "chart--spiral",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartSpiral20",
          "filepath": "chart--spiral/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
                }
              }
            ],
            "name": "chart--spiral",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartSpiral16",
          "filepath": "chart--spiral/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
                }
              }
            ],
            "name": "chart--spiral",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartSpiral",
        "global": "ChartSpiral",
        "filepath": "ChartSpiral.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--stacked",
      "friendlyName": "Chart stacked",
      "aliases": [
        "chart stacked",
        "stacked chart",
        "chart",
        "bar chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--stacked.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--stacked</title>\n  <path d=\"M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z\"/></svg>",
            "info": {},
            "path": "32/chart--stacked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartStacked32",
          "filepath": "chart--stacked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
                }
              }
            ],
            "name": "chart--stacked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartStacked24",
          "filepath": "chart--stacked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
                }
              }
            ],
            "name": "chart--stacked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartStacked20",
          "filepath": "chart--stacked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
                }
              }
            ],
            "name": "chart--stacked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartStacked16",
          "filepath": "chart--stacked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
                }
              }
            ],
            "name": "chart--stacked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartStacked",
        "global": "ChartStacked",
        "filepath": "ChartStacked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--stepper",
      "friendlyName": "Chart stepper",
      "aliases": [
        "chart stepper",
        "stepper chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--stepper.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z\"/></svg>",
            "info": {},
            "path": "32/chart--stepper.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartStepper32",
          "filepath": "chart--stepper/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
                }
              }
            ],
            "name": "chart--stepper",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartStepper24",
          "filepath": "chart--stepper/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
                }
              }
            ],
            "name": "chart--stepper",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartStepper20",
          "filepath": "chart--stepper/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
                }
              }
            ],
            "name": "chart--stepper",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartStepper16",
          "filepath": "chart--stepper/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
                }
              }
            ],
            "name": "chart--stepper",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartStepper",
        "global": "ChartStepper",
        "filepath": "ChartStepper.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--sunburst",
      "friendlyName": "Chart sunburst",
      "aliases": [
        "chart sunburst",
        "sunburst chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--sunburst.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z\"/></svg>",
            "info": {},
            "path": "32/chart--sunburst.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartSunburst32",
          "filepath": "chart--sunburst/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
                }
              }
            ],
            "name": "chart--sunburst",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartSunburst24",
          "filepath": "chart--sunburst/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
                }
              }
            ],
            "name": "chart--sunburst",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartSunburst20",
          "filepath": "chart--sunburst/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
                }
              }
            ],
            "name": "chart--sunburst",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartSunburst16",
          "filepath": "chart--sunburst/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
                }
              }
            ],
            "name": "chart--sunburst",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartSunburst",
        "global": "ChartSunburst",
        "filepath": "ChartSunburst.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--t-sne",
      "friendlyName": "Chart t-sne",
      "aliases": [
        "chart t-sne",
        "t-sne chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--t-sne.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--t-sne</title>\n  <circle cx=\"10\" cy=\"20\" r=\"2\"/>\n  <circle cx=\"10\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"10\" cy=\"14\" r=\"2\"/>\n  <circle cx=\"28\" cy=\"4\" r=\"2\"/>\n  <circle cx=\"22\" cy=\"6\" r=\"2\"/>\n  <circle cx=\"28\" cy=\"10\" r=\"2\"/>\n  <circle cx=\"20\" cy=\"12\" r=\"2\"/>\n  <circle cx=\"28\" cy=\"22\" r=\"2\"/>\n  <circle cx=\"26\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"20\" cy=\"26\" r=\"2\"/>\n  <circle cx=\"22\" cy=\"20\" r=\"2\"/>\n  <circle cx=\"16\" cy=\"4\" r=\"2\"/>\n  <circle cx=\"4\" cy=\"24\" r=\"2\"/>\n  <circle cx=\"4\" cy=\"16\" r=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"20\" r=\"2\"/><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"10\" cy=\"14\" r=\"2\"/><circle cx=\"28\" cy=\"4\" r=\"2\"/><circle cx=\"22\" cy=\"6\" r=\"2\"/><circle cx=\"28\" cy=\"10\" r=\"2\"/><circle cx=\"20\" cy=\"12\" r=\"2\"/><circle cx=\"28\" cy=\"22\" r=\"2\"/><circle cx=\"26\" cy=\"28\" r=\"2\"/><circle cx=\"20\" cy=\"26\" r=\"2\"/><circle cx=\"22\" cy=\"20\" r=\"2\"/><circle cx=\"16\" cy=\"4\" r=\"2\"/><circle cx=\"4\" cy=\"24\" r=\"2\"/><circle cx=\"4\" cy=\"16\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/chart--t-sne.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartTSne32",
          "filepath": "chart--t-sne/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "chart--t-sne",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartTSne24",
          "filepath": "chart--t-sne/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "chart--t-sne",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartTSne20",
          "filepath": "chart--t-sne/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "chart--t-sne",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartTSne16",
          "filepath": "chart--t-sne/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "chart--t-sne",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartTSne",
        "global": "ChartTSne",
        "filepath": "ChartTSne.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "4",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "6",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "10",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "22",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "26",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "4",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--treemap",
      "friendlyName": "Chart treemap",
      "aliases": [
        "chart treemap",
        "treemap chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--treemap.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>chart--treemap</title>\n  <path d=\"M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z\"/></svg>",
            "info": {},
            "path": "32/chart--treemap.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartTreemap32",
          "filepath": "chart--treemap/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
                }
              }
            ],
            "name": "chart--treemap",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartTreemap24",
          "filepath": "chart--treemap/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
                }
              }
            ],
            "name": "chart--treemap",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartTreemap20",
          "filepath": "chart--treemap/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
                }
              }
            ],
            "name": "chart--treemap",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartTreemap16",
          "filepath": "chart--treemap/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
                }
              }
            ],
            "name": "chart--treemap",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartTreemap",
        "global": "ChartTreemap",
        "filepath": "ChartTreemap.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--venn-diagram",
      "friendlyName": "Chart Venn diagram",
      "aliases": [
        "graph",
        "bar",
        "data",
        "Venn diagram chart",
        "chart Venn diagram",
        "Venn diagram"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--venn-diagram.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chart--venn-diagram</title><path d=\"M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z\"/></svg>",
            "info": {},
            "path": "32/chart--venn-diagram.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartVennDiagram32",
          "filepath": "chart--venn-diagram/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "chart--venn-diagram",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartVennDiagram24",
          "filepath": "chart--venn-diagram/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "chart--venn-diagram",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartVennDiagram20",
          "filepath": "chart--venn-diagram/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "chart--venn-diagram",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartVennDiagram16",
          "filepath": "chart--venn-diagram/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "chart--venn-diagram",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartVennDiagram",
        "global": "ChartVennDiagram",
        "filepath": "ChartVennDiagram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--violin-plot",
      "friendlyName": "Chart violin-plot",
      "aliases": [
        "chart violin plot",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--violin-plot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/>\n  <path d=\"M14.86,7.8232,13,4.7231V2H11V4.7231l-1.86,3.1A7.9986,7.9986,0,0,0,8,11.939v.122a7.9961,7.9961,0,0,0,1.14,4.1158l1.86,3.1V26h2V19.2769l1.86-3.1A7.9986,7.9986,0,0,0,16,12.061v-.122A7.9961,7.9961,0,0,0,14.86,7.8232ZM12,6.9434l1.145,1.9087A6.0027,6.0027,0,0,1,13.9185,11h-3.837a6.0086,6.0086,0,0,1,.7735-2.1484Zm0,10.1132-1.145-1.9087A6.0027,6.0027,0,0,1,10.0815,13h3.837a6.0086,6.0086,0,0,1-.7735,2.1484Z\"/>\n  <path d=\"M27.86,11.8232,26,8.7231V2H24V8.7231l-1.86,3.1A7.9986,7.9986,0,0,0,21,15.939v.122a7.9961,7.9961,0,0,0,1.14,4.1158l1.86,3.1V26h2V23.2769l1.86-3.1A7.9986,7.9986,0,0,0,29,16.061v-.122A7.9961,7.9961,0,0,0,27.86,11.8232Zm-2.86-.88,1.145,1.9087A6.0027,6.0027,0,0,1,26.9185,15h-3.837a6.0086,6.0086,0,0,1,.7735-2.1484Zm0,10.1132-1.145-1.9087A6.0027,6.0027,0,0,1,23.0815,17h3.837a6.0086,6.0086,0,0,1-.7735,2.1484Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z\"/><path d=\"M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z\"/></svg>",
            "info": {},
            "path": "32/chart--violin-plot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartViolinPlot32",
          "filepath": "chart--violin-plot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
                }
              }
            ],
            "name": "chart--violin-plot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartViolinPlot24",
          "filepath": "chart--violin-plot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
                }
              }
            ],
            "name": "chart--violin-plot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartViolinPlot20",
          "filepath": "chart--violin-plot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
                }
              }
            ],
            "name": "chart--violin-plot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartViolinPlot16",
          "filepath": "chart--violin-plot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
                }
              }
            ],
            "name": "chart--violin-plot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartViolinPlot",
        "global": "ChartViolinPlot",
        "filepath": "ChartViolinPlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--waterfall",
      "friendlyName": "Chart waterfall",
      "aliases": [
        "chart waterfall",
        "waterfall chart",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--waterfall.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z\"/>\n  <rect x=\"14\" y=\"4\" width=\"2\" height=\"14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z\"/><path d=\"M14 4H16V18H14z\"/></svg>",
            "info": {},
            "path": "32/chart--waterfall.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartWaterfall32",
          "filepath": "chart--waterfall/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H16V18H14z"
                }
              }
            ],
            "name": "chart--waterfall",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartWaterfall24",
          "filepath": "chart--waterfall/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H16V18H14z"
                }
              }
            ],
            "name": "chart--waterfall",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartWaterfall20",
          "filepath": "chart--waterfall/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H16V18H14z"
                }
              }
            ],
            "name": "chart--waterfall",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartWaterfall16",
          "filepath": "chart--waterfall/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H16V18H14z"
                }
              }
            ],
            "name": "chart--waterfall",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartWaterfall",
        "global": "ChartWaterfall",
        "filepath": "ChartWaterfall.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 4H16V18H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chart--win-loss",
      "friendlyName": "Chart win-loss",
      "aliases": [
        "chart win-loss",
        "win",
        "loss",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chart--win-loss.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z\"/></svg>",
            "info": {},
            "path": "32/chart--win-loss.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChartWinLoss32",
          "filepath": "chart--win-loss/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
                }
              }
            ],
            "name": "chart--win-loss",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChartWinLoss24",
          "filepath": "chart--win-loss/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
                }
              }
            ],
            "name": "chart--win-loss",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChartWinLoss20",
          "filepath": "chart--win-loss/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
                }
              }
            ],
            "name": "chart--win-loss",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChartWinLoss16",
          "filepath": "chart--win-loss/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
                }
              }
            ],
            "name": "chart--win-loss",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChartWinLoss",
        "global": "ChartWinLoss",
        "filepath": "ChartWinLoss.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chat",
      "friendlyName": "Chat",
      "aliases": [
        "sms",
        "text",
        "bubble",
        "bot",
        "speak",
        "comment",
        "chat",
        "instant message",
        "instant messaging",
        "talk",
        "operations",
        "communication"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chat.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chat</title><path d=\"M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z\" transform=\"translate(0 0)\"/><rect x=\"8\" y=\"10\" width=\"16\" height=\"2\"/><rect x=\"8\" y=\"16\" width=\"10\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z\"/><path d=\"M8 10H24V12H8zM8 16H18V18H8z\"/></svg>",
            "info": {},
            "path": "32/chat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Chat32",
          "filepath": "chat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H24V12H8zM8 16H18V18H8z"
                }
              }
            ],
            "name": "chat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Chat24",
          "filepath": "chat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H24V12H8zM8 16H18V18H8z"
                }
              }
            ],
            "name": "chat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Chat20",
          "filepath": "chat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H24V12H8zM8 16H18V18H8z"
                }
              }
            ],
            "name": "chat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Chat16",
          "filepath": "chat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H24V12H8zM8 16H18V18H8z"
                }
              }
            ],
            "name": "chat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Chat",
        "global": "Chat",
        "filepath": "Chat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 10H24V12H8zM8 16H18V18H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chat--launch",
      "friendlyName": "Chat launch",
      "aliases": [
        "chat",
        "operations",
        "launch",
        "begin",
        "initiate",
        "start",
        "message",
        "text",
        "instant message",
        "communications"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chat--launch.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 4 22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4\"/>\n  <path d=\"M28,16v4a1.9965,1.9965,0,0,1-2,2H20l-4,7,1.7358,1,3.4288-6H26a3.9992,3.9992,0,0,0,4-4V16Z\"/>\n  <path d=\"M4,20V8A1.9965,1.9965,0,0,1,6,6H18V4H6A3.9986,3.9986,0,0,0,2,8V20a3.9992,3.9992,0,0,0,4,4h9V22H6A1.9965,1.9965,0,0,1,4,20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4zM28 16v4a1.9965 1.9965 0 01-2 2H20l-4 7 1.7358 1 3.4288-6H26a3.9992 3.9992 0 004-4V16zM4 20V8A1.9965 1.9965 0 016 6H18V4H6A3.9986 3.9986 0 002 8V20a3.9992 3.9992 0 004 4h9V22H6A1.9965 1.9965 0 014 20z\"/></svg>",
            "info": {},
            "path": "32/chat--launch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChatLaunch32",
          "filepath": "chat--launch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4zM28 16v4a1.9965 1.9965 0 01-2 2H20l-4 7 1.7358 1 3.4288-6H26a3.9992 3.9992 0 004-4V16zM4 20V8A1.9965 1.9965 0 016 6H18V4H6A3.9986 3.9986 0 002 8V20a3.9992 3.9992 0 004 4h9V22H6A1.9965 1.9965 0 014 20z"
                }
              }
            ],
            "name": "chat--launch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChatLaunch24",
          "filepath": "chat--launch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4zM28 16v4a1.9965 1.9965 0 01-2 2H20l-4 7 1.7358 1 3.4288-6H26a3.9992 3.9992 0 004-4V16zM4 20V8A1.9965 1.9965 0 016 6H18V4H6A3.9986 3.9986 0 002 8V20a3.9992 3.9992 0 004 4h9V22H6A1.9965 1.9965 0 014 20z"
                }
              }
            ],
            "name": "chat--launch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChatLaunch20",
          "filepath": "chat--launch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4zM28 16v4a1.9965 1.9965 0 01-2 2H20l-4 7 1.7358 1 3.4288-6H26a3.9992 3.9992 0 004-4V16zM4 20V8A1.9965 1.9965 0 016 6H18V4H6A3.9986 3.9986 0 002 8V20a3.9992 3.9992 0 004 4h9V22H6A1.9965 1.9965 0 014 20z"
                }
              }
            ],
            "name": "chat--launch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChatLaunch16",
          "filepath": "chat--launch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4zM28 16v4a1.9965 1.9965 0 01-2 2H20l-4 7 1.7358 1 3.4288-6H26a3.9992 3.9992 0 004-4V16zM4 20V8A1.9965 1.9965 0 016 6H18V4H6A3.9986 3.9986 0 002 8V20a3.9992 3.9992 0 004 4h9V22H6A1.9965 1.9965 0 014 20z"
                }
              }
            ],
            "name": "chat--launch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChatLaunch",
        "global": "ChatLaunch",
        "filepath": "ChatLaunch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4zM28 16v4a1.9965 1.9965 0 01-2 2H20l-4 7 1.7358 1 3.4288-6H26a3.9992 3.9992 0 004-4V16zM4 20V8A1.9965 1.9965 0 016 6H18V4H6A3.9986 3.9986 0 002 8V20a3.9992 3.9992 0 004 4h9V22H6A1.9965 1.9965 0 014 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chat--off",
      "friendlyName": "Chat off",
      "aliases": [
        "chat",
        "operations",
        "off",
        "message",
        "text",
        "instant message",
        "communications"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chat--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,8V21h2V8a3.9986,3.9986,0,0,0-4-4H8.2429l2,2H26A1.9965,1.9965,0,0,1,28,8Z\"/>\n  <path d=\"M30,28.5859,3.4141,2,2,3.4141,3.5039,4.918A3.9181,3.9181,0,0,0,2,8V20a3.9992,3.9992,0,0,0,4,4h6V22H6a1.9965,1.9965,0,0,1-2-2V8a1.9814,1.9814,0,0,1,.9194-1.6665L20.5859,22H17l-4,7,1.7358,1,3.4288-6h4.4213l6,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 8V21h2V8a3.9986 3.9986 0 00-4-4H8.2429l2 2H26A1.9965 1.9965 0 0128 8zM30 28.5859L3.4141 2 2 3.4141 3.5039 4.918A3.9181 3.9181 0 002 8V20a3.9992 3.9992 0 004 4h6V22H6a1.9965 1.9965 0 01-2-2V8a1.9814 1.9814 0 01.9194-1.6665L20.5859 22H17l-4 7 1.7358 1 3.4288-6h4.4213l6 6z\"/></svg>",
            "info": {},
            "path": "32/chat--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChatOff32",
          "filepath": "chat--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8V21h2V8a3.9986 3.9986 0 00-4-4H8.2429l2 2H26A1.9965 1.9965 0 0128 8zM30 28.5859L3.4141 2 2 3.4141 3.5039 4.918A3.9181 3.9181 0 002 8V20a3.9992 3.9992 0 004 4h6V22H6a1.9965 1.9965 0 01-2-2V8a1.9814 1.9814 0 01.9194-1.6665L20.5859 22H17l-4 7 1.7358 1 3.4288-6h4.4213l6 6z"
                }
              }
            ],
            "name": "chat--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChatOff24",
          "filepath": "chat--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8V21h2V8a3.9986 3.9986 0 00-4-4H8.2429l2 2H26A1.9965 1.9965 0 0128 8zM30 28.5859L3.4141 2 2 3.4141 3.5039 4.918A3.9181 3.9181 0 002 8V20a3.9992 3.9992 0 004 4h6V22H6a1.9965 1.9965 0 01-2-2V8a1.9814 1.9814 0 01.9194-1.6665L20.5859 22H17l-4 7 1.7358 1 3.4288-6h4.4213l6 6z"
                }
              }
            ],
            "name": "chat--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChatOff20",
          "filepath": "chat--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8V21h2V8a3.9986 3.9986 0 00-4-4H8.2429l2 2H26A1.9965 1.9965 0 0128 8zM30 28.5859L3.4141 2 2 3.4141 3.5039 4.918A3.9181 3.9181 0 002 8V20a3.9992 3.9992 0 004 4h6V22H6a1.9965 1.9965 0 01-2-2V8a1.9814 1.9814 0 01.9194-1.6665L20.5859 22H17l-4 7 1.7358 1 3.4288-6h4.4213l6 6z"
                }
              }
            ],
            "name": "chat--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChatOff16",
          "filepath": "chat--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8V21h2V8a3.9986 3.9986 0 00-4-4H8.2429l2 2H26A1.9965 1.9965 0 0128 8zM30 28.5859L3.4141 2 2 3.4141 3.5039 4.918A3.9181 3.9181 0 002 8V20a3.9992 3.9992 0 004 4h6V22H6a1.9965 1.9965 0 01-2-2V8a1.9814 1.9814 0 01.9194-1.6665L20.5859 22H17l-4 7 1.7358 1 3.4288-6h4.4213l6 6z"
                }
              }
            ],
            "name": "chat--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChatOff",
        "global": "ChatOff",
        "filepath": "ChatOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 8V21h2V8a3.9986 3.9986 0 00-4-4H8.2429l2 2H26A1.9965 1.9965 0 0128 8zM30 28.5859L3.4141 2 2 3.4141 3.5039 4.918A3.9181 3.9181 0 002 8V20a3.9992 3.9992 0 004 4h6V22H6a1.9965 1.9965 0 01-2-2V8a1.9814 1.9814 0 01.9194-1.6665L20.5859 22H17l-4 7 1.7358 1 3.4288-6h4.4213l6 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chat--operational",
      "friendlyName": "Chat operational",
      "aliases": [
        "chat",
        "operational"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chat--operational.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"15.586 10.414 19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414\"/>\n  <polygon points=\"20.586 10.414 24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414\"/>\n  <polygon points=\"10 9 11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9\"/>\n  <path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z\"/><path d=\"M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414zM10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/></svg>",
            "info": {},
            "path": "32/chat--operational.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChatOperational32",
          "filepath": "chat--operational/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414zM10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat--operational",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChatOperational24",
          "filepath": "chat--operational/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414zM10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat--operational",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChatOperational20",
          "filepath": "chat--operational/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414zM10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat--operational",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChatOperational16",
          "filepath": "chat--operational/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414zM10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat--operational",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ChatOperational",
        "global": "ChatOperational",
        "filepath": "ChatOperational.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414zM10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chat-bot",
      "friendlyName": "Chat bot",
      "aliases": [
        "chat-bot",
        "sms",
        "text",
        "bubble",
        "bot",
        "speak",
        "comment",
        "chat",
        "instant message",
        "instant messaging",
        "talk",
        "operations",
        "communication"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chat-bot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chat-bot</title><path d=\"M16,19a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,19Z\"/><path d=\"M20,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,8Z\"/><path d=\"M12,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,8Z\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/></svg>",
            "info": {},
            "path": "32/chat-bot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChatBot32",
          "filepath": "chat-bot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat-bot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChatBot24",
          "filepath": "chat-bot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat-bot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChatBot20",
          "filepath": "chat-bot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat-bot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChatBot16",
          "filepath": "chat-bot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "chat-bot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "ChatBot",
        "global": "ChatBot",
        "filepath": "ChatBot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkbox",
      "friendlyName": "Checkbox",
      "aliases": [
        "check",
        "box",
        "checkbox"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkbox.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>checkbox</title><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z\"/></svg>",
            "info": {},
            "path": "32/checkbox.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Checkbox32",
          "filepath": "checkbox/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Checkbox24",
          "filepath": "checkbox/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Checkbox20",
          "filepath": "checkbox/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Checkbox16",
          "filepath": "checkbox/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Checkbox",
        "global": "Checkbox",
        "filepath": "Checkbox.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkbox--checked",
      "friendlyName": "Checkbox checked",
      "aliases": [
        "check",
        "box",
        "checkbox checked",
        "checked checkbox"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkbox--checked.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>checkbox--checked</title><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z\"/><polygon points=\"14 21.5 9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z\"/><path d=\"M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z\"/></svg>",
            "info": {},
            "path": "32/checkbox--checked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckboxChecked32",
          "filepath": "checkbox--checked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
                }
              }
            ],
            "name": "checkbox--checked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckboxChecked24",
          "filepath": "checkbox--checked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
                }
              }
            ],
            "name": "checkbox--checked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckboxChecked20",
          "filepath": "checkbox--checked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
                }
              }
            ],
            "name": "checkbox--checked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckboxChecked16",
          "filepath": "checkbox--checked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
                }
              }
            ],
            "name": "checkbox--checked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "CheckboxChecked",
        "global": "CheckboxChecked",
        "filepath": "CheckboxChecked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkbox--checked--filled",
      "friendlyName": "Checkbox checked filled",
      "aliases": [
        "check",
        "box",
        "checkbox checked filled",
        "checked checkbox",
        "filled checked checkbox"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkbox--checked--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>checkbox--checked--filled</title>\n  <path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z\" transform=\"translate(0 0)\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z\"/><path fill=\"none\" d=\"M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/checkbox--checked--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckboxCheckedFilled32",
          "filepath": "checkbox--checked--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--checked--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckboxCheckedFilled24",
          "filepath": "checkbox--checked--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--checked--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckboxCheckedFilled20",
          "filepath": "checkbox--checked--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--checked--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckboxCheckedFilled16",
          "filepath": "checkbox--checked--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--checked--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "CheckboxCheckedFilled",
        "global": "CheckboxCheckedFilled",
        "filepath": "CheckboxCheckedFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkbox--indeterminate",
      "friendlyName": "Checkbox indeterminate",
      "aliases": [
        "check",
        "box",
        "checkbox indeterminate",
        "indeterminate checkbox"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkbox--indeterminate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>checkbox--indeterminate</title><rect x=\"10\" y=\"14\" width=\"12\" height=\"4\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 14H22V18H10z\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z\"/></svg>",
            "info": {},
            "path": "32/checkbox--indeterminate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckboxIndeterminate32",
          "filepath": "checkbox--indeterminate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14H22V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox--indeterminate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckboxIndeterminate24",
          "filepath": "checkbox--indeterminate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14H22V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox--indeterminate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckboxIndeterminate20",
          "filepath": "checkbox--indeterminate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14H22V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox--indeterminate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckboxIndeterminate16",
          "filepath": "checkbox--indeterminate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 14H22V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "checkbox--indeterminate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "CheckboxIndeterminate",
        "global": "CheckboxIndeterminate",
        "filepath": "CheckboxIndeterminate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 14H22V18H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkbox--indeterminate--filled",
      "friendlyName": "Checkbox indeterminate filled",
      "aliases": [
        "check",
        "box",
        "checkbox indeterminate filled",
        "filled indeterminate checkbox"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkbox--indeterminate--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>checkbox--indeterminate--filled</title>\n  <path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M22,18H10V14H22Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z\"/><path fill=\"none\" d=\"M22,18H10V14H22Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/checkbox--indeterminate--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckboxIndeterminateFilled32",
          "filepath": "checkbox--indeterminate--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,18H10V14H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--indeterminate--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckboxIndeterminateFilled24",
          "filepath": "checkbox--indeterminate--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,18H10V14H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--indeterminate--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckboxIndeterminateFilled20",
          "filepath": "checkbox--indeterminate--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,18H10V14H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--indeterminate--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckboxIndeterminateFilled16",
          "filepath": "checkbox--indeterminate--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,18H10V14H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkbox--indeterminate--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "CheckboxIndeterminateFilled",
        "global": "CheckboxIndeterminateFilled",
        "filepath": "CheckboxIndeterminateFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M22,18H10V14H22Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkmark",
      "friendlyName": "Checkmark",
      "aliases": [
        "approved",
        "yes",
        "valid",
        "validation",
        "status",
        "checkmark",
        "file",
        "task",
        "check",
        "tick",
        "tick mark"
      ],
      "sizes": [
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 20,
          "filepath": "20/checkmark.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<g id=\"_x32_0_px\">\n\t<g>\n\t\t<rect x=\"0\" y=\"0\" class=\"st0\" width=\"20\" height=\"20\"/>\n\t</g>\n\t<g>\n\t\t<polygon points=\"8,13.2 3.6,8.8 2.7,9.7 7.1,14.1 8,15 16.5,6.5 15.6,5.6 \t\t\"/>\n\t\t<polygon points=\"15.6,5.6 8,13.2 3.6,8.8 2.7,9.7 7.1,14.1 8,15 16.5,6.5 15.6,5.6 \t\t\"/>\n\t</g>\n</g>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z\"/><path d=\"M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z\"/></svg>",
            "info": {},
            "path": "20/checkmark.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/checkmark.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{}\n</style>\n<g id=\"_x32_4_px\">\n\t<g>\n\t\t<rect y=\"0\" class=\"st0\" width=\"24\" height=\"24\"/>\n\t</g>\n\t<polygon points=\"10,15.9 4.7,10.6 3.6,11.6 8.9,16.9 10,18 20.6,7.4 19.5,6.3 \t\"/>\n</g>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z\"/></svg>",
            "info": {},
            "path": "24/checkmark.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/checkmark.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"13 24 4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z\"/></svg>",
            "info": {},
            "path": "32/checkmark.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Checkmark32",
          "filepath": "checkmark/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
                }
              }
            ],
            "name": "checkmark",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Checkmark24",
          "filepath": "checkmark/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
                }
              }
            ],
            "name": "checkmark",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Checkmark20",
          "filepath": "checkmark/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
                }
              }
            ],
            "name": "checkmark",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Checkmark16",
          "filepath": "checkmark/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
                }
              }
            ],
            "name": "checkmark",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Checkmark",
        "global": "Checkmark",
        "filepath": "Checkmark.js",
        "sizes": [
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkmark--filled",
      "friendlyName": "Checkmark filled",
      "aliases": [
        "approved",
        "yes",
        "valid",
        "validation",
        "status",
        "checkmark",
        "checkmark filled",
        "filled checkmark",
        "file",
        "task",
        "check",
        "tick",
        "tick mark",
        "tick mark filled",
        "filled tick mark"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/checkmark--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{display:none;fill:none;}\n\t.st1{opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n<path d=\"M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z\"/><path d=\"M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "16/checkmark--filled.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/checkmark--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n<path d=\"M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z\"/><path fill=\"none\" d=\"M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "20/checkmark--filled.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/checkmark--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"24\" height=\"24\"/>\n<path d=\"M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z\"\n\t/>\n<path id=\"inner-path\" class=\"st1\" d=\"M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z\"/><path fill=\"none\" d=\"M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "24/checkmark--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/checkmark--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z\"/>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"14 21.591 9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z\"/><path fill=\"none\" d=\"M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/checkmark--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckmarkFilled32",
          "filepath": "checkmark--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckmarkFilled24",
          "filepath": "checkmark--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "checkmark--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckmarkFilled20",
          "filepath": "checkmark--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "checkmark--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckmarkFilled16",
          "filepath": "checkmark--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "checkmark--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CheckmarkFilled",
        "global": "CheckmarkFilled",
        "filepath": "CheckmarkFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkmark--filled--error",
      "friendlyName": "Checkmark filled error",
      "aliases": [
        "not approved",
        "no",
        "invalid",
        "status",
        "checkmark",
        "checkmark filled error",
        "filled checkmark error",
        "file",
        "task",
        "check",
        "tick",
        "tick mark",
        "tick mark filled error",
        "filled error tick mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkmark--filled--error.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z\" transform=\"translate(0 0)\"/>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"12 18.591 8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z\"/><path d=\"M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z\"/><path fill=\"none\" d=\"M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/checkmark--filled--error.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckmarkFilledError32",
          "filepath": "checkmark--filled--error/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--error",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckmarkFilledError24",
          "filepath": "checkmark--filled--error/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--error",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckmarkFilledError20",
          "filepath": "checkmark--filled--error/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--error",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckmarkFilledError16",
          "filepath": "checkmark--filled--error/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--error",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CheckmarkFilledError",
        "global": "CheckmarkFilledError",
        "filepath": "CheckmarkFilledError.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkmark--filled--warning",
      "friendlyName": "Checkmark filled warning",
      "aliases": [
        "warning",
        "no",
        "caution",
        "status",
        "checkmark",
        "checkmark filled warning",
        "filled checkmark warning",
        "file",
        "task",
        "check",
        "tick",
        "tick mark",
        "tick mark filled warning",
        "filled warning tick mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkmark--filled--warning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z\" transform=\"translate(0 0)\"/>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"12 18.591 8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z\"/><path d=\"M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z\"/><path fill=\"none\" d=\"M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/checkmark--filled--warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckmarkFilledWarning32",
          "filepath": "checkmark--filled--warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckmarkFilledWarning24",
          "filepath": "checkmark--filled--warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckmarkFilledWarning20",
          "filepath": "checkmark--filled--warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckmarkFilledWarning16",
          "filepath": "checkmark--filled--warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "checkmark--filled--warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CheckmarkFilledWarning",
        "global": "CheckmarkFilledWarning",
        "filepath": "CheckmarkFilledWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkmark--outline",
      "friendlyName": "Checkmark outline",
      "aliases": [
        "approved",
        "yes",
        "valid",
        "validation",
        "status",
        "checkmark",
        "checkmark outline",
        "outlined checkmark",
        "file",
        "task",
        "check",
        "tick",
        "tick mark",
        "tick mark outline",
        "outlined tick mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkmark--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 21.414 9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414\"/>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/checkmark--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckmarkOutline32",
          "filepath": "checkmark--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "checkmark--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckmarkOutline24",
          "filepath": "checkmark--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "checkmark--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckmarkOutline20",
          "filepath": "checkmark--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "checkmark--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckmarkOutline16",
          "filepath": "checkmark--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "checkmark--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CheckmarkOutline",
        "global": "CheckmarkOutline",
        "filepath": "CheckmarkOutline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkmark--outline--error",
      "friendlyName": "Checkmark outline error",
      "aliases": [
        "not approved",
        "no",
        "error",
        "status",
        "checkmark",
        "checkmark outline error",
        "outline checkmark error",
        "file",
        "task",
        "check",
        "tick",
        "tick mark",
        "tick mark outline error",
        "outline error tick mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkmark--outline--error.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"12 15.59 9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59\"/>\n  <path d=\"M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z\"/><path d=\"M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z\"/></svg>",
            "info": {},
            "path": "32/checkmark--outline--error.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckmarkOutlineError32",
          "filepath": "checkmark--outline--error/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "checkmark--outline--error",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckmarkOutlineError24",
          "filepath": "checkmark--outline--error/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "checkmark--outline--error",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckmarkOutlineError20",
          "filepath": "checkmark--outline--error/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "checkmark--outline--error",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckmarkOutlineError16",
          "filepath": "checkmark--outline--error/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "checkmark--outline--error",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CheckmarkOutlineError",
        "global": "CheckmarkOutlineError",
        "filepath": "CheckmarkOutlineError.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "checkmark--outline--warning",
      "friendlyName": "Checkmark outline warning",
      "aliases": [
        "not approved",
        "no",
        "warning",
        "status",
        "checkmark",
        "checkmark outline warning",
        "outline checkmark warning",
        "file",
        "task",
        "check",
        "tick",
        "tick mark",
        "tick mark outline warning",
        "outline warning tick mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/checkmark--outline--warning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"12 15.59 9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59\"/>\n  <path d=\"M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z\"/><path d=\"M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z\"/></svg>",
            "info": {},
            "path": "32/checkmark--outline--warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CheckmarkOutlineWarning32",
          "filepath": "checkmark--outline--warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "checkmark--outline--warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CheckmarkOutlineWarning24",
          "filepath": "checkmark--outline--warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "checkmark--outline--warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CheckmarkOutlineWarning20",
          "filepath": "checkmark--outline--warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "checkmark--outline--warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CheckmarkOutlineWarning16",
          "filepath": "checkmark--outline--warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "checkmark--outline--warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CheckmarkOutlineWarning",
        "global": "CheckmarkOutlineWarning",
        "filepath": "CheckmarkOutlineWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chemistry",
      "friendlyName": "Chemistry",
      "aliases": [
        "science",
        "flask",
        "glass"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chemistry.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chemistry</title><path d=\"M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z\"/></svg>",
            "info": {},
            "path": "32/chemistry.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Chemistry32",
          "filepath": "chemistry/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
                }
              }
            ],
            "name": "chemistry",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Chemistry24",
          "filepath": "chemistry/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
                }
              }
            ],
            "name": "chemistry",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Chemistry20",
          "filepath": "chemistry/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
                }
              }
            ],
            "name": "chemistry",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Chemistry16",
          "filepath": "chemistry/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
                }
              }
            ],
            "name": "chemistry",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Chemistry",
        "global": "Chemistry",
        "filepath": "Chemistry.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chemistry--reference",
      "friendlyName": "Chemistry reference",
      "aliases": [
        "chemistry reference",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chemistry--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z\"/><path d=\"M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z\"/></svg>",
            "info": {},
            "path": "32/chemistry--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChemistryReference32",
          "filepath": "chemistry--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
                }
              }
            ],
            "name": "chemistry--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChemistryReference24",
          "filepath": "chemistry--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
                }
              }
            ],
            "name": "chemistry--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChemistryReference20",
          "filepath": "chemistry--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
                }
              }
            ],
            "name": "chemistry--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChemistryReference16",
          "filepath": "chemistry--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
                }
              }
            ],
            "name": "chemistry--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ChemistryReference",
        "global": "ChemistryReference",
        "filepath": "ChemistryReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--down",
      "friendlyName": "Chevron down",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron",
        "chevron down",
        "down chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "chevron--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"10px\" height=\"6px\" viewBox=\"0 0 10 6\" style=\"enable-background:new 0 0 10 6;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"5,6 0,1 0.7,0.3 5,4.6 9.3,0.3 10,1 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"10\" height=\"6\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\"><path d=\"M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z\"/></svg>",
            "info": {},
            "path": "chevron--down.svg"
          }
        },
        {
          "size": 16,
          "filepath": "16/chevron--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"8,11 3,6 3.7,5.3 8,9.6 12.3,5.3 13,6 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z\"/></svg>",
            "info": {},
            "path": "16/chevron--down.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"16,22 6,12 7.4,10.6 16,19.2 24.6,10.6 26,12 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z\"/></svg>",
            "info": {},
            "path": "32/chevron--down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronDown32",
          "filepath": "chevron--down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
                }
              }
            ],
            "name": "chevron--down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronDown24",
          "filepath": "chevron--down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
                }
              }
            ],
            "name": "chevron--down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronDown20",
          "filepath": "chevron--down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
                }
              }
            ],
            "name": "chevron--down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronDown16",
          "filepath": "chevron--down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
                }
              }
            ],
            "name": "chevron--down",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 10 6",
              "fill": "currentColor",
              "width": "10",
              "height": "6"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
                }
              }
            ],
            "name": "chevron--down",
            "size": "glyph"
          },
          "moduleName": "ChevronDownGlyph",
          "filepath": "chevron--down/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ChevronDown",
        "global": "ChevronDown",
        "filepath": "ChevronDown.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 10 6",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--left",
      "friendlyName": "Chevron left",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron",
        "chevron left",
        "left chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "chevron--left.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"6px\" height=\"10px\" viewBox=\"0 0 6 10\" style=\"enable-background:new 0 0 6 10;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"0,5 5,0 5.7,0.7 1.4,5 5.7,9.3 5,10 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"6\" height=\"10\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 10\"><path d=\"M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z\"/></svg>",
            "info": {},
            "path": "chevron--left.svg"
          }
        },
        {
          "size": 16,
          "filepath": "16/chevron--left.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"5,8 10,3 10.7,3.7 6.4,8 10.7,12.3 10,13 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z\"/></svg>",
            "info": {},
            "path": "16/chevron--left.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--left.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"10,16 20,6 21.4,7.4 12.8,16 21.4,24.6 20,26 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z\"/></svg>",
            "info": {},
            "path": "32/chevron--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronLeft32",
          "filepath": "chevron--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
                }
              }
            ],
            "name": "chevron--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronLeft24",
          "filepath": "chevron--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
                }
              }
            ],
            "name": "chevron--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronLeft20",
          "filepath": "chevron--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
                }
              }
            ],
            "name": "chevron--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronLeft16",
          "filepath": "chevron--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
                }
              }
            ],
            "name": "chevron--left",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 6 10",
              "fill": "currentColor",
              "width": "6",
              "height": "10"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z"
                }
              }
            ],
            "name": "chevron--left",
            "size": "glyph"
          },
          "moduleName": "ChevronLeftGlyph",
          "filepath": "chevron--left/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ChevronLeft",
        "global": "ChevronLeft",
        "filepath": "ChevronLeft.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 6 10",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--mini",
      "friendlyName": "Chevron mini",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron",
        "chevron mini",
        "mini chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/chevron--mini.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\r\n<polygon id=\"XMLID_1_\" points=\"15,9 15,15 9,15 \"/>\r\n</svg>\r\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15 9L15 15 9 15z\"/></svg>",
            "info": {},
            "path": "16/chevron--mini.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--mini.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"31 19 31 31 19 31 31 19\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 19L31 31 19 31 31 19z\"/></svg>",
            "info": {},
            "path": "32/chevron--mini.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronMini32",
          "filepath": "chevron--mini/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 19L31 31 19 31 31 19z"
                }
              }
            ],
            "name": "chevron--mini",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronMini24",
          "filepath": "chevron--mini/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 19L31 31 19 31 31 19z"
                }
              }
            ],
            "name": "chevron--mini",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronMini20",
          "filepath": "chevron--mini/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 19L31 31 19 31 31 19z"
                }
              }
            ],
            "name": "chevron--mini",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronMini16",
          "filepath": "chevron--mini/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L15 15 9 15z"
                }
              }
            ],
            "name": "chevron--mini",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChevronMini",
        "global": "ChevronMini",
        "filepath": "ChevronMini.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 9L15 15 9 15z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 19L31 31 19 31 31 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--right",
      "friendlyName": "Chevron right",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron",
        "chevron right",
        "right chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "chevron--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"6px\" height=\"10px\" viewBox=\"0 0 6 10\" style=\"enable-background:new 0 0 6 10;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"6,5 1,10 0.3,9.3 4.6,5 0.3,0.7 1,0 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"6\" height=\"10\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 10\"><path d=\"M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z\"/></svg>",
            "info": {},
            "path": "chevron--right.svg"
          }
        },
        {
          "size": 16,
          "filepath": "16/chevron--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"11,8 6,13 5.3,12.3 9.6,8 5.3,3.7 6,3 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z\"/></svg>",
            "info": {},
            "path": "16/chevron--right.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--right.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"22,16 12,26 10.6,24.6 19.2,16 10.6,7.4 12,6 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z\"/></svg>",
            "info": {},
            "path": "32/chevron--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronRight32",
          "filepath": "chevron--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
                }
              }
            ],
            "name": "chevron--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronRight24",
          "filepath": "chevron--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
                }
              }
            ],
            "name": "chevron--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronRight20",
          "filepath": "chevron--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
                }
              }
            ],
            "name": "chevron--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronRight16",
          "filepath": "chevron--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
                }
              }
            ],
            "name": "chevron--right",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 6 10",
              "fill": "currentColor",
              "width": "6",
              "height": "10"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
                }
              }
            ],
            "name": "chevron--right",
            "size": "glyph"
          },
          "moduleName": "ChevronRightGlyph",
          "filepath": "chevron--right/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ChevronRight",
        "global": "ChevronRight",
        "filepath": "ChevronRight.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 6 10",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--sort",
      "friendlyName": "Chevron sort",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron",
        "chevron sort",
        "sort chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/chevron--sort.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>chevron--sort</title>\n<polygon points=\"8,14 4.5,10.5 5.2,9.8 8,12.6 10.8,9.8 11.5,10.5 \"/>\n<polygon points=\"8,2 11.5,5.5 10.8,6.2 8,3.4 5.2,6.2 4.5,5.5 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5zM8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z\"/></svg>",
            "info": {},
            "path": "16/chevron--sort.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--sort.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chevron--sort</title><polygon points=\"16 28 9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28\"/><polygon points=\"16 4 23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z\"/></svg>",
            "info": {},
            "path": "32/chevron--sort.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronSort32",
          "filepath": "chevron--sort/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
                }
              }
            ],
            "name": "chevron--sort",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronSort24",
          "filepath": "chevron--sort/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
                }
              }
            ],
            "name": "chevron--sort",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronSort20",
          "filepath": "chevron--sort/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
                }
              }
            ],
            "name": "chevron--sort",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronSort16",
          "filepath": "chevron--sort/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5zM8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
                }
              }
            ],
            "name": "chevron--sort",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChevronSort",
        "global": "ChevronSort",
        "filepath": "ChevronSort.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5zM8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--sort--down",
      "friendlyName": "Chevron sort down",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron",
        "chevron sort",
        "chevron sort down",
        "chevron down",
        "sort down chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/chevron--sort--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>chevron--sort</title>\n<polygon points=\"8,14 4.5,10.5 5.2,9.8 8,12.6 10.8,9.8 11.5,10.5 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z\"/></svg>",
            "info": {},
            "path": "16/chevron--sort--down.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--sort--down.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>chevron--sort</title>\n<polygon points=\"16,28 9,21 10.4,19.6 16,25.2 21.6,19.6 23,21 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z\"/></svg>",
            "info": {},
            "path": "32/chevron--sort--down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronSortDown32",
          "filepath": "chevron--sort--down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
                }
              }
            ],
            "name": "chevron--sort--down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronSortDown24",
          "filepath": "chevron--sort--down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
                }
              }
            ],
            "name": "chevron--sort--down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronSortDown20",
          "filepath": "chevron--sort--down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
                }
              }
            ],
            "name": "chevron--sort--down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronSortDown16",
          "filepath": "chevron--sort--down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
                }
              }
            ],
            "name": "chevron--sort--down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChevronSortDown",
        "global": "ChevronSortDown",
        "filepath": "ChevronSortDown.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--sort--up",
      "friendlyName": "Chevron sort up",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron",
        "chevron sort",
        "chevron sort up",
        "chevron up",
        "sort up chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/chevron--sort--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>chevron--sort</title>\n<polygon points=\"8,2 11.5,5.5 10.8,6.2 8,3.4 5.2,6.2 4.5,5.5 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z\"/></svg>",
            "info": {},
            "path": "16/chevron--sort--up.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--sort--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>chevron--sort</title>\n<polygon points=\"16,4 23,11 21.6,12.4 16,6.8 10.4,12.4 9,11 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z\"/></svg>",
            "info": {},
            "path": "32/chevron--sort--up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronSortUp32",
          "filepath": "chevron--sort--up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
                }
              }
            ],
            "name": "chevron--sort--up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronSortUp24",
          "filepath": "chevron--sort--up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
                }
              }
            ],
            "name": "chevron--sort--up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronSortUp20",
          "filepath": "chevron--sort--up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
                }
              }
            ],
            "name": "chevron--sort--up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronSortUp16",
          "filepath": "chevron--sort--up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
                }
              }
            ],
            "name": "chevron--sort--up",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChevronSortUp",
        "global": "ChevronSortUp",
        "filepath": "ChevronSortUp.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chevron--up",
      "friendlyName": "Chevron up",
      "aliases": [
        "open",
        "close",
        "expand",
        "collapse",
        "chevron up",
        "up chevron",
        "navigation"
      ],
      "sizes": [
        16,
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "chevron--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"10px\" height=\"6px\" viewBox=\"0 0 10 6\" style=\"enable-background:new 0 0 10 6;\" xml:space=\"preserve\">\n<polygon points=\"5,0 10,5 9.3,5.7 5,1.4 0.7,5.7 0,5 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\"><path d=\"M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z\"/></svg>",
            "info": {},
            "path": "chevron--up.svg"
          }
        },
        {
          "size": 16,
          "filepath": "16/chevron--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"8,5 13,10 12.3,10.7 8,6.4 3.7,10.7 3,10 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z\"/></svg>",
            "info": {},
            "path": "16/chevron--up.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/chevron--up.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"16,10 26,20 24.6,21.4 16,12.8 7.4,21.4 6,20 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z\"/></svg>",
            "info": {},
            "path": "32/chevron--up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChevronUp32",
          "filepath": "chevron--up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
                }
              }
            ],
            "name": "chevron--up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChevronUp24",
          "filepath": "chevron--up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
                }
              }
            ],
            "name": "chevron--up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChevronUp20",
          "filepath": "chevron--up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
                }
              }
            ],
            "name": "chevron--up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChevronUp16",
          "filepath": "chevron--up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
                }
              }
            ],
            "name": "chevron--up",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 10 6",
              "fill": "currentColor",
              "width": "10",
              "height": "6"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z"
                }
              }
            ],
            "name": "chevron--up",
            "size": "glyph"
          },
          "moduleName": "ChevronUpGlyph",
          "filepath": "chevron--up/index.js",
          "size": "glyph"
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ChevronUp",
        "global": "ChevronUp",
        "filepath": "ChevronUp.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 10 6",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "chip",
      "friendlyName": "Chip",
      "aliases": [
        "microchip",
        "computer chip"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/chip.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>chip</title><path d=\"M11,11V21H21V11Zm8,8H13V13h6Z\" transform=\"translate(0)\"/><path d=\"M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11,11V21H21V11Zm8,8H13V13h6Z\"/><path d=\"M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z\"/></svg>",
            "info": {},
            "path": "32/chip.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Chip32",
          "filepath": "chip/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11V21H21V11Zm8,8H13V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
                }
              }
            ],
            "name": "chip",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Chip24",
          "filepath": "chip/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11V21H21V11Zm8,8H13V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
                }
              }
            ],
            "name": "chip",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Chip20",
          "filepath": "chip/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11V21H21V11Zm8,8H13V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
                }
              }
            ],
            "name": "chip",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Chip16",
          "filepath": "chip/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11V21H21V11Zm8,8H13V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
                }
              }
            ],
            "name": "chip",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Chip",
        "global": "Chip",
        "filepath": "Chip.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,11V21H21V11Zm8,8H13V13h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "choices",
      "friendlyName": "Choices",
      "aliases": [
        "choices",
        "forked arrows",
        "arrows",
        "variety"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/choices.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z\"/></svg>",
            "info": {},
            "path": "32/choices.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Choices32",
          "filepath": "choices/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
                }
              }
            ],
            "name": "choices",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Choices24",
          "filepath": "choices/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
                }
              }
            ],
            "name": "choices",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Choices20",
          "filepath": "choices/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
                }
              }
            ],
            "name": "choices",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Choices16",
          "filepath": "choices/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
                }
              }
            ],
            "name": "choices",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Choices",
        "global": "Choices",
        "filepath": "Choices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "choose-item",
      "friendlyName": "Choose item",
      "aliases": [
        "operations",
        "choose",
        "item",
        "select",
        "pick"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/choose-item.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"28\" y=\"6\" width=\"2\" height=\"20\"/>\n  <polygon points=\"17 6 15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z\"/></svg>",
            "info": {},
            "path": "32/choose-item.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChooseItem32",
          "filepath": "choose-item/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
                }
              }
            ],
            "name": "choose-item",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChooseItem24",
          "filepath": "choose-item/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
                }
              }
            ],
            "name": "choose-item",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChooseItem20",
          "filepath": "choose-item/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
                }
              }
            ],
            "name": "choose-item",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChooseItem16",
          "filepath": "choose-item/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
                }
              }
            ],
            "name": "choose-item",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ChooseItem",
        "global": "ChooseItem",
        "filepath": "ChooseItem.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "choropleth-map",
      "friendlyName": "Chart choropleth-map",
      "aliases": [
        "chart choropleth-map",
        "map",
        "graph",
        "chart",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/choropleth-map.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z\"/></svg>",
            "info": {},
            "path": "32/choropleth-map.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ChoroplethMap32",
          "filepath": "choropleth-map/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
                }
              }
            ],
            "name": "choropleth-map",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ChoroplethMap24",
          "filepath": "choropleth-map/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
                }
              }
            ],
            "name": "choropleth-map",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ChoroplethMap20",
          "filepath": "choropleth-map/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
                }
              }
            ],
            "name": "choropleth-map",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ChoroplethMap16",
          "filepath": "choropleth-map/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
                }
              }
            ],
            "name": "choropleth-map",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ChoroplethMap",
        "global": "ChoroplethMap",
        "filepath": "ChoroplethMap.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--cmas",
      "friendlyName": "CICS® CMAS",
      "aliases": [
        "CICS®",
        "CMAS",
        "CICSPlex®",
        "address space"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--cmas.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30.3335,30H26V28h4V26H28a2.002,2.002,0,0,1-2-2V21.6665A1.6684,1.6684,0,0,1,27.6665,20H32v2H28v2h2a2.002,2.002,0,0,1,2,2v2.3335A1.6684,1.6684,0,0,1,30.3335,30Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22.3335,20h-2.667A1.6665,1.6665,0,0,0,18,21.6665V30h2V26h2v4h2V21.6665A1.6665,1.6665,0,0,0,22.3335,20ZM20,24V22h2v2Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"12.5 24 11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24\"/>\n  <path d=\"M1,22v6.5A1.4727,1.4727,0,0,0,2.5,30H7V28H3V22H7V20H3A2.0059,2.0059,0,0,0,1,22Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8\"/>\n  <path d=\"M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z\"/><path d=\"M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z\"/></svg>",
            "info": {},
            "path": "32/cics--cmas.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsCmas32",
          "filepath": "cics--cmas/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
                }
              }
            ],
            "name": "cics--cmas",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsCmas24",
          "filepath": "cics--cmas/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
                }
              }
            ],
            "name": "cics--cmas",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsCmas20",
          "filepath": "cics--cmas/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
                }
              }
            ],
            "name": "cics--cmas",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsCmas16",
          "filepath": "cics--cmas/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
                }
              }
            ],
            "name": "cics--cmas",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsCmas",
        "global": "CicsCmas",
        "filepath": "CicsCmas.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--db2-connection",
      "friendlyName": "cics--db2-connection",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--db2-connection.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z\"/>\n  <path d=\"M16.5,31c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9348,.364-1.8137,1.0249-2.4749l4.9998-4.9996c.6609-.6613,1.54-1.0255,2.4753-1.0255,1.9299,0,3.5,1.5701,3.5,3.5,0,.9346-.3638,1.8134-1.0244,2.4742l-1.4146-1.4138c.283-.2832,.439-.6598,.439-1.0604,0-.8271-.6729-1.5-1.5-1.5-.4009,0-.7776,.1561-1.061,.4396l-4.9998,4.9998c-.2832,.2833-.4392,.66-.4392,1.0607,0,.8271,.6729,1.5,1.5,1.5,.4011,0,.7783-.1564,1.0618-.4404l1.4155,1.4131c-.6616,.6625-1.5413,1.0273-2.4773,1.0273Z\"/>\n  <path d=\"M16,2c-5.2979,0-11,1.252-11,4V24c0,1.6797,2.134,2.7979,5,3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937,.749,3.6738,1.2153,6,1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723,5.2979,0,11-1.252,11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995ZM6.9985,6.0151c.1523-.5552,3.1514-2.0151,9.0015-2.0151,5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8501,0-8.8491-1.46-9.0015-1.9849Zm18.0015,5.9722c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z\"/><path d=\"M16.5 31c-1.9299 0-3.5-1.5701-3.5-3.5 0-.9348.364-1.8137 1.0249-2.4749l4.9998-4.9996c.6609-.6613 1.54-1.0255 2.4753-1.0255 1.9299 0 3.5 1.5701 3.5 3.5 0 .9346-.3638 1.8134-1.0244 2.4742l-1.4146-1.4138c.283-.2832.439-.6598.439-1.0604 0-.8271-.6729-1.5-1.5-1.5-.4009 0-.7776.1561-1.061.4396l-4.9998 4.9998c-.2832.2833-.4392.66-.4392 1.0607 0 .8271.6729 1.5 1.5 1.5.4011 0 .7783-.1564 1.0618-.4404l1.4155 1.4131c-.6616.6625-1.5413 1.0273-2.4773 1.0273zM16 2c-5.2979 0-11 1.252-11 4V24c0 1.6797 2.134 2.7979 5 3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937.749 3.6738 1.2153 6 1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723 5.2979 0 11-1.252 11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995zM6.9985 6.0151c.1523-.5552 3.1514-2.0151 9.0015-2.0151 5.7976 0 8.7949 1.4341 8.9968 2-.2019.5659-3.1992 2-8.9968 2-5.8501 0-8.8491-1.46-9.0015-1.9849zm18.0015 5.9722c-.1606.5571-3.1587 2.0127-9 2.0127-5.8501 0-8.8491-1.46-9-2v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723s6.8721-.5049 9-1.5723v3.5596z\"/></svg>",
            "info": {},
            "path": "32/cics--db2-connection.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsDb2Connection32",
          "filepath": "cics--db2-connection/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5 31c-1.9299 0-3.5-1.5701-3.5-3.5 0-.9348.364-1.8137 1.0249-2.4749l4.9998-4.9996c.6609-.6613 1.54-1.0255 2.4753-1.0255 1.9299 0 3.5 1.5701 3.5 3.5 0 .9346-.3638 1.8134-1.0244 2.4742l-1.4146-1.4138c.283-.2832.439-.6598.439-1.0604 0-.8271-.6729-1.5-1.5-1.5-.4009 0-.7776.1561-1.061.4396l-4.9998 4.9998c-.2832.2833-.4392.66-.4392 1.0607 0 .8271.6729 1.5 1.5 1.5.4011 0 .7783-.1564 1.0618-.4404l1.4155 1.4131c-.6616.6625-1.5413 1.0273-2.4773 1.0273zM16 2c-5.2979 0-11 1.252-11 4V24c0 1.6797 2.134 2.7979 5 3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937.749 3.6738 1.2153 6 1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723 5.2979 0 11-1.252 11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995zM6.9985 6.0151c.1523-.5552 3.1514-2.0151 9.0015-2.0151 5.7976 0 8.7949 1.4341 8.9968 2-.2019.5659-3.1992 2-8.9968 2-5.8501 0-8.8491-1.46-9.0015-1.9849zm18.0015 5.9722c-.1606.5571-3.1587 2.0127-9 2.0127-5.8501 0-8.8491-1.46-9-2v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723s6.8721-.5049 9-1.5723v3.5596z"
                }
              }
            ],
            "name": "cics--db2-connection",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsDb2Connection24",
          "filepath": "cics--db2-connection/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5 31c-1.9299 0-3.5-1.5701-3.5-3.5 0-.9348.364-1.8137 1.0249-2.4749l4.9998-4.9996c.6609-.6613 1.54-1.0255 2.4753-1.0255 1.9299 0 3.5 1.5701 3.5 3.5 0 .9346-.3638 1.8134-1.0244 2.4742l-1.4146-1.4138c.283-.2832.439-.6598.439-1.0604 0-.8271-.6729-1.5-1.5-1.5-.4009 0-.7776.1561-1.061.4396l-4.9998 4.9998c-.2832.2833-.4392.66-.4392 1.0607 0 .8271.6729 1.5 1.5 1.5.4011 0 .7783-.1564 1.0618-.4404l1.4155 1.4131c-.6616.6625-1.5413 1.0273-2.4773 1.0273zM16 2c-5.2979 0-11 1.252-11 4V24c0 1.6797 2.134 2.7979 5 3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937.749 3.6738 1.2153 6 1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723 5.2979 0 11-1.252 11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995zM6.9985 6.0151c.1523-.5552 3.1514-2.0151 9.0015-2.0151 5.7976 0 8.7949 1.4341 8.9968 2-.2019.5659-3.1992 2-8.9968 2-5.8501 0-8.8491-1.46-9.0015-1.9849zm18.0015 5.9722c-.1606.5571-3.1587 2.0127-9 2.0127-5.8501 0-8.8491-1.46-9-2v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723s6.8721-.5049 9-1.5723v3.5596z"
                }
              }
            ],
            "name": "cics--db2-connection",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsDb2Connection20",
          "filepath": "cics--db2-connection/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5 31c-1.9299 0-3.5-1.5701-3.5-3.5 0-.9348.364-1.8137 1.0249-2.4749l4.9998-4.9996c.6609-.6613 1.54-1.0255 2.4753-1.0255 1.9299 0 3.5 1.5701 3.5 3.5 0 .9346-.3638 1.8134-1.0244 2.4742l-1.4146-1.4138c.283-.2832.439-.6598.439-1.0604 0-.8271-.6729-1.5-1.5-1.5-.4009 0-.7776.1561-1.061.4396l-4.9998 4.9998c-.2832.2833-.4392.66-.4392 1.0607 0 .8271.6729 1.5 1.5 1.5.4011 0 .7783-.1564 1.0618-.4404l1.4155 1.4131c-.6616.6625-1.5413 1.0273-2.4773 1.0273zM16 2c-5.2979 0-11 1.252-11 4V24c0 1.6797 2.134 2.7979 5 3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937.749 3.6738 1.2153 6 1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723 5.2979 0 11-1.252 11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995zM6.9985 6.0151c.1523-.5552 3.1514-2.0151 9.0015-2.0151 5.7976 0 8.7949 1.4341 8.9968 2-.2019.5659-3.1992 2-8.9968 2-5.8501 0-8.8491-1.46-9.0015-1.9849zm18.0015 5.9722c-.1606.5571-3.1587 2.0127-9 2.0127-5.8501 0-8.8491-1.46-9-2v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723s6.8721-.5049 9-1.5723v3.5596z"
                }
              }
            ],
            "name": "cics--db2-connection",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsDb2Connection16",
          "filepath": "cics--db2-connection/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5 31c-1.9299 0-3.5-1.5701-3.5-3.5 0-.9348.364-1.8137 1.0249-2.4749l4.9998-4.9996c.6609-.6613 1.54-1.0255 2.4753-1.0255 1.9299 0 3.5 1.5701 3.5 3.5 0 .9346-.3638 1.8134-1.0244 2.4742l-1.4146-1.4138c.283-.2832.439-.6598.439-1.0604 0-.8271-.6729-1.5-1.5-1.5-.4009 0-.7776.1561-1.061.4396l-4.9998 4.9998c-.2832.2833-.4392.66-.4392 1.0607 0 .8271.6729 1.5 1.5 1.5.4011 0 .7783-.1564 1.0618-.4404l1.4155 1.4131c-.6616.6625-1.5413 1.0273-2.4773 1.0273zM16 2c-5.2979 0-11 1.252-11 4V24c0 1.6797 2.134 2.7979 5 3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937.749 3.6738 1.2153 6 1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723 5.2979 0 11-1.252 11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995zM6.9985 6.0151c.1523-.5552 3.1514-2.0151 9.0015-2.0151 5.7976 0 8.7949 1.4341 8.9968 2-.2019.5659-3.1992 2-8.9968 2-5.8501 0-8.8491-1.46-9.0015-1.9849zm18.0015 5.9722c-.1606.5571-3.1587 2.0127-9 2.0127-5.8501 0-8.8491-1.46-9-2v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723s6.8721-.5049 9-1.5723v3.5596z"
                }
              }
            ],
            "name": "cics--db2-connection",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsDb2Connection",
        "global": "CicsDb2Connection",
        "filepath": "CicsDb2Connection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.5 31c-1.9299 0-3.5-1.5701-3.5-3.5 0-.9348.364-1.8137 1.0249-2.4749l4.9998-4.9996c.6609-.6613 1.54-1.0255 2.4753-1.0255 1.9299 0 3.5 1.5701 3.5 3.5 0 .9346-.3638 1.8134-1.0244 2.4742l-1.4146-1.4138c.283-.2832.439-.6598.439-1.0604 0-.8271-.6729-1.5-1.5-1.5-.4009 0-.7776.1561-1.061.4396l-4.9998 4.9998c-.2832.2833-.4392.66-.4392 1.0607 0 .8271.6729 1.5 1.5 1.5.4011 0 .7783-.1564 1.0618-.4404l1.4155 1.4131c-.6616.6625-1.5413 1.0273-2.4773 1.0273zM16 2c-5.2979 0-11 1.252-11 4V24c0 1.6797 2.134 2.7979 5 3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937.749 3.6738 1.2153 6 1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723 5.2979 0 11-1.252 11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995zM6.9985 6.0151c.1523-.5552 3.1514-2.0151 9.0015-2.0151 5.7976 0 8.7949 1.4341 8.9968 2-.2019.5659-3.1992 2-8.9968 2-5.8501 0-8.8491-1.46-9.0015-1.9849zm18.0015 5.9722c-.1606.5571-3.1587 2.0127-9 2.0127-5.8501 0-8.8491-1.46-9-2v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723s6.8721-.5049 9-1.5723v3.5596z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--explorer",
      "friendlyName": "CICS Explorer®",
      "aliases": [
        "CICS Explorer®",
        "system management"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--explorer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"24 16 19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/cics--explorer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsExplorer32",
          "filepath": "cics--explorer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "cics--explorer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsExplorer24",
          "filepath": "cics--explorer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "cics--explorer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsExplorer20",
          "filepath": "cics--explorer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "cics--explorer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsExplorer16",
          "filepath": "cics--explorer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "cics--explorer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsExplorer",
        "global": "CicsExplorer",
        "filepath": "CicsExplorer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--program",
      "friendlyName": "cics--program",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--program.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"20.17 19 17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19\"/>\n  <polygon points=\"11.83 19 14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19\"/>\n  <circle cx=\"9\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"6\" cy=\"8\" r=\"1\"/>\n  <path d=\"M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z\"/><circle cx=\"9\" cy=\"8\" r=\"1\"/><circle cx=\"6\" cy=\"8\" r=\"1\"/><path d=\"M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z\"/></svg>",
            "info": {},
            "path": "32/cics--program.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsProgram32",
          "filepath": "cics--program/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
                }
              }
            ],
            "name": "cics--program",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsProgram24",
          "filepath": "cics--program/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
                }
              }
            ],
            "name": "cics--program",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsProgram20",
          "filepath": "cics--program/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
                }
              }
            ],
            "name": "cics--program",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsProgram16",
          "filepath": "cics--program/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
                }
              }
            ],
            "name": "cics--program",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsProgram",
        "global": "CicsProgram",
        "filepath": "CicsProgram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--sit",
      "friendlyName": "cics--sit",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--sit.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"23 22 30 27 23 32 23 22\"/>\n  <path d=\"M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 22L30 27 23 32 23 22z\"/><path d=\"M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z\"/></svg>",
            "info": {},
            "path": "32/cics--sit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsSit32",
          "filepath": "cics--sit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L30 27 23 32 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
                }
              }
            ],
            "name": "cics--sit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsSit24",
          "filepath": "cics--sit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L30 27 23 32 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
                }
              }
            ],
            "name": "cics--sit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsSit20",
          "filepath": "cics--sit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L30 27 23 32 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
                }
              }
            ],
            "name": "cics--sit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsSit16",
          "filepath": "cics--sit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L30 27 23 32 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
                }
              }
            ],
            "name": "cics--sit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsSit",
        "global": "CicsSit",
        "filepath": "CicsSit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 22L30 27 23 32 23 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--sit-overrides",
      "friendlyName": "cics--sit-overrides",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--sit-overrides.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M31.707,20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141,0l-9.293,9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906,.3906-1.0234,0-1.4141Zm-7.4141,6l-2.7073,2.707h-1.5857v-1.5859l2.707-2.707,2.293-2.293,1.5859,1.5859-2.293,2.293Zm3.707-3.707l-1.5859-1.5859,1.5859-1.5859,1.5857,1.5859-1.5857,1.5859Z\"/>\n  <path d=\"M20,20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h4Zm-6-2H4v-7H14v7ZM5,5H25c.5515,0,1,.4482,1,1v3H4v-3c0-.5518,.4485-1,1-1ZM14,27H5c-.5515,0-1-.4482-1-1v-6H14v7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31.707 20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141 0l-9.293 9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-7.4141 6l-2.7073 2.707h-1.5857v-1.5859l2.707-2.707 2.293-2.293 1.5859 1.5859-2.293 2.293zm3.707-3.707l-1.5859-1.5859 1.5859-1.5859 1.5857 1.5859-1.5857 1.5859zM20 20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543 0-3 1.3457-3 3V26c0 1.6543 1.3457 3 3 3h11v-9h4zm-6-2H4v-7H14v7zM5 5H25c.5515 0 1 .4482 1 1v3H4v-3c0-.5518.4485-1 1-1zM14 27H5c-.5515 0-1-.4482-1-1v-6H14v7z\"/></svg>",
            "info": {},
            "path": "32/cics--sit-overrides.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsSitOverrides32",
          "filepath": "cics--sit-overrides/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.707 20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141 0l-9.293 9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-7.4141 6l-2.7073 2.707h-1.5857v-1.5859l2.707-2.707 2.293-2.293 1.5859 1.5859-2.293 2.293zm3.707-3.707l-1.5859-1.5859 1.5859-1.5859 1.5857 1.5859-1.5857 1.5859zM20 20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543 0-3 1.3457-3 3V26c0 1.6543 1.3457 3 3 3h11v-9h4zm-6-2H4v-7H14v7zM5 5H25c.5515 0 1 .4482 1 1v3H4v-3c0-.5518.4485-1 1-1zM14 27H5c-.5515 0-1-.4482-1-1v-6H14v7z"
                }
              }
            ],
            "name": "cics--sit-overrides",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsSitOverrides24",
          "filepath": "cics--sit-overrides/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.707 20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141 0l-9.293 9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-7.4141 6l-2.7073 2.707h-1.5857v-1.5859l2.707-2.707 2.293-2.293 1.5859 1.5859-2.293 2.293zm3.707-3.707l-1.5859-1.5859 1.5859-1.5859 1.5857 1.5859-1.5857 1.5859zM20 20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543 0-3 1.3457-3 3V26c0 1.6543 1.3457 3 3 3h11v-9h4zm-6-2H4v-7H14v7zM5 5H25c.5515 0 1 .4482 1 1v3H4v-3c0-.5518.4485-1 1-1zM14 27H5c-.5515 0-1-.4482-1-1v-6H14v7z"
                }
              }
            ],
            "name": "cics--sit-overrides",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsSitOverrides20",
          "filepath": "cics--sit-overrides/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.707 20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141 0l-9.293 9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-7.4141 6l-2.7073 2.707h-1.5857v-1.5859l2.707-2.707 2.293-2.293 1.5859 1.5859-2.293 2.293zm3.707-3.707l-1.5859-1.5859 1.5859-1.5859 1.5857 1.5859-1.5857 1.5859zM20 20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543 0-3 1.3457-3 3V26c0 1.6543 1.3457 3 3 3h11v-9h4zm-6-2H4v-7H14v7zM5 5H25c.5515 0 1 .4482 1 1v3H4v-3c0-.5518.4485-1 1-1zM14 27H5c-.5515 0-1-.4482-1-1v-6H14v7z"
                }
              }
            ],
            "name": "cics--sit-overrides",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsSitOverrides16",
          "filepath": "cics--sit-overrides/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.707 20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141 0l-9.293 9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-7.4141 6l-2.7073 2.707h-1.5857v-1.5859l2.707-2.707 2.293-2.293 1.5859 1.5859-2.293 2.293zm3.707-3.707l-1.5859-1.5859 1.5859-1.5859 1.5857 1.5859-1.5857 1.5859zM20 20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543 0-3 1.3457-3 3V26c0 1.6543 1.3457 3 3 3h11v-9h4zm-6-2H4v-7H14v7zM5 5H25c.5515 0 1 .4482 1 1v3H4v-3c0-.5518.4485-1 1-1zM14 27H5c-.5515 0-1-.4482-1-1v-6H14v7z"
                }
              }
            ],
            "name": "cics--sit-overrides",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsSitOverrides",
        "global": "CicsSitOverrides",
        "filepath": "CicsSitOverrides.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31.707 20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141 0l-9.293 9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-7.4141 6l-2.7073 2.707h-1.5857v-1.5859l2.707-2.707 2.293-2.293 1.5859 1.5859-2.293 2.293zm3.707-3.707l-1.5859-1.5859 1.5859-1.5859 1.5857 1.5859-1.5857 1.5859zM20 20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543 0-3 1.3457-3 3V26c0 1.6543 1.3457 3 3 3h11v-9h4zm-6-2H4v-7H14v7zM5 5H25c.5515 0 1 .4482 1 1v3H4v-3c0-.5518.4485-1 1-1zM14 27H5c-.5515 0-1-.4482-1-1v-6H14v7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--system-group",
      "friendlyName": "CICS® system group",
      "aliases": [
        "CICS®",
        "System group"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--system-group.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,2H23V4h5V28H23v2h5a2.0059,2.0059,0,0,0,2-2V4A2.0059,2.0059,0,0,0,28,2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,17H8a.9448.9448,0,0,0-1,1v6a.9448.9448,0,0,0,1,1h6a.9448.9448,0,0,0,1-1V18A.9448.9448,0,0,0,14,17Zm-1,6H9V19h4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25,24V18a.9448.9448,0,0,0-1-1H18a.9448.9448,0,0,0-1,1v6a.9448.9448,0,0,0,1,1h6A1.0021,1.0021,0,0,0,25,24Zm-2-1H19V19h4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,7H8A.9448.9448,0,0,0,7,8v6a.9448.9448,0,0,0,1,1h6a.9448.9448,0,0,0,1-1V8A.9448.9448,0,0,0,14,7Zm-1,6H9V9h4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M18,15h6a.9448.9448,0,0,0,1-1V8a.9448.9448,0,0,0-1-1H18a.9448.9448,0,0,0-1,1v6A1.0021,1.0021,0,0,0,18,15Zm1-6h4v4H19Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z\"/><path d=\"M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z\"/><path d=\"M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z\"/></svg>",
            "info": {},
            "path": "32/cics--system-group.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsSystemGroup32",
          "filepath": "cics--system-group/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
                }
              }
            ],
            "name": "cics--system-group",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsSystemGroup24",
          "filepath": "cics--system-group/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
                }
              }
            ],
            "name": "cics--system-group",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsSystemGroup20",
          "filepath": "cics--system-group/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
                }
              }
            ],
            "name": "cics--system-group",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsSystemGroup16",
          "filepath": "cics--system-group/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
                }
              }
            ],
            "name": "cics--system-group",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsSystemGroup",
        "global": "CicsSystemGroup",
        "filepath": "CicsSystemGroup.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--transaction-server-zos",
      "friendlyName": "cics--transaction-server-zos",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--transaction-server-zos.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"28\" cy=\"10\" r=\"2\"/>\n  <path d=\"M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z\"/>\n  <path d=\"M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z\"/>\n  <circle cx=\"4\" cy=\"22\" r=\"2\"/>\n  <path d=\"M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"28\" cy=\"10\" r=\"2\"/><path d=\"M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z\"/><path d=\"M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z\"/><circle cx=\"4\" cy=\"22\" r=\"2\"/><path d=\"M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z\"/></svg>",
            "info": {},
            "path": "32/cics--transaction-server-zos.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsTransactionServerZos32",
          "filepath": "cics--transaction-server-zos/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
                }
              }
            ],
            "name": "cics--transaction-server-zos",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsTransactionServerZos24",
          "filepath": "cics--transaction-server-zos/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
                }
              }
            ],
            "name": "cics--transaction-server-zos",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsTransactionServerZos20",
          "filepath": "cics--transaction-server-zos/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
                }
              }
            ],
            "name": "cics--transaction-server-zos",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsTransactionServerZos16",
          "filepath": "cics--transaction-server-zos/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
                }
              }
            ],
            "name": "cics--transaction-server-zos",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CicsTransactionServerZos",
        "global": "CicsTransactionServerZos",
        "filepath": "CicsTransactionServerZos.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "10",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4",
                    "cy": "22",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics--wui-region",
      "friendlyName": "CICS® WUI region",
      "aliases": [
        "CICS®",
        "WUI region"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics--wui-region.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 22 24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22\"/>\n  <path d=\"M18,28H16V20H14v8.6A1.4529,1.4529,0,0,0,15.5,30h3A1.4529,1.4529,0,0,0,20,28.6V20H18Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"10.2 20 10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20\"/>\n  <polygon points=\"16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11\"/>\n  <path d=\"M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z\"/><path d=\"M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z\"/></svg>",
            "info": {},
            "path": "32/cics--wui-region.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsWuiRegion32",
          "filepath": "cics--wui-region/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
                }
              }
            ],
            "name": "cics--wui-region",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsWuiRegion24",
          "filepath": "cics--wui-region/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
                }
              }
            ],
            "name": "cics--wui-region",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsWuiRegion20",
          "filepath": "cics--wui-region/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
                }
              }
            ],
            "name": "cics--wui-region",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsWuiRegion16",
          "filepath": "cics--wui-region/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
                }
              }
            ],
            "name": "cics--wui-region",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsWuiRegion",
        "global": "CicsWuiRegion",
        "filepath": "CicsWuiRegion.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics-region",
      "friendlyName": "CICS® region",
      "aliases": [
        "CICS®",
        "region"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics-region.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"23.5 18 21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18\"/>\n  <polygon points=\"16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13\"/>\n  <path d=\"M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z\"/><path d=\"M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z\"/></svg>",
            "info": {},
            "path": "32/cics-region.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsRegion32",
          "filepath": "cics-region/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "cics-region",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsRegion24",
          "filepath": "cics-region/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "cics-region",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsRegion20",
          "filepath": "cics-region/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "cics-region",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsRegion16",
          "filepath": "cics-region/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
                }
              }
            ],
            "name": "cics-region",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsRegion",
        "global": "CicsRegion",
        "filepath": "CicsRegion.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics-region--alt",
      "friendlyName": "cics-region--alt",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics-region--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M31,13v-2h-4c-1.1028,0-2,.8975-2,2v2c0,1.1025,.8972,2,2,2h2v2h-4v2h4c1.1028,0,2-.8975,2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4Z\"/>\n  <path d=\"M17,13v6c0,1.1025,.8972,2,2,2h4v-2h-4v-6h4v-2h-4c-1.1028,0-2,.8975-2,2Z\"/>\n  <polygon points=\"9 13 11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13\"/>\n  <path d=\"M1,13v6c0,1.1025,.8972,2,2,2H7v-2H3v-6H7v-2H3c-1.1028,0-2,.8975-2,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 13v-2h-4c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h2v2h-4v2h4c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4zM17 13v6c0 1.1025.8972 2 2 2h4v-2h-4v-6h4v-2h-4c-1.1028 0-2 .8975-2 2zM9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13zM1 13v6c0 1.1025.8972 2 2 2H7v-2H3v-6H7v-2H3c-1.1028 0-2 .8975-2 2z\"/></svg>",
            "info": {},
            "path": "32/cics-region--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsRegionAlt32",
          "filepath": "cics-region--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 13v-2h-4c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h2v2h-4v2h4c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4zM17 13v6c0 1.1025.8972 2 2 2h4v-2h-4v-6h4v-2h-4c-1.1028 0-2 .8975-2 2zM9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13zM1 13v6c0 1.1025.8972 2 2 2H7v-2H3v-6H7v-2H3c-1.1028 0-2 .8975-2 2z"
                }
              }
            ],
            "name": "cics-region--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsRegionAlt24",
          "filepath": "cics-region--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 13v-2h-4c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h2v2h-4v2h4c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4zM17 13v6c0 1.1025.8972 2 2 2h4v-2h-4v-6h4v-2h-4c-1.1028 0-2 .8975-2 2zM9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13zM1 13v6c0 1.1025.8972 2 2 2H7v-2H3v-6H7v-2H3c-1.1028 0-2 .8975-2 2z"
                }
              }
            ],
            "name": "cics-region--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsRegionAlt20",
          "filepath": "cics-region--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 13v-2h-4c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h2v2h-4v2h4c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4zM17 13v6c0 1.1025.8972 2 2 2h4v-2h-4v-6h4v-2h-4c-1.1028 0-2 .8975-2 2zM9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13zM1 13v6c0 1.1025.8972 2 2 2H7v-2H3v-6H7v-2H3c-1.1028 0-2 .8975-2 2z"
                }
              }
            ],
            "name": "cics-region--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsRegionAlt16",
          "filepath": "cics-region--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 13v-2h-4c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h2v2h-4v2h4c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4zM17 13v6c0 1.1025.8972 2 2 2h4v-2h-4v-6h4v-2h-4c-1.1028 0-2 .8975-2 2zM9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13zM1 13v6c0 1.1025.8972 2 2 2H7v-2H3v-6H7v-2H3c-1.1028 0-2 .8975-2 2z"
                }
              }
            ],
            "name": "cics-region--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsRegionAlt",
        "global": "CicsRegionAlt",
        "filepath": "CicsRegionAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 13v-2h-4c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h2v2h-4v2h4c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4zM17 13v6c0 1.1025.8972 2 2 2h4v-2h-4v-6h4v-2h-4c-1.1028 0-2 .8975-2 2zM9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13zM1 13v6c0 1.1025.8972 2 2 2H7v-2H3v-6H7v-2H3c-1.1028 0-2 .8975-2 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics-region--routing",
      "friendlyName": "CICS® region routing",
      "aliases": [
        "CICS®",
        "region",
        "routing"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics-region--routing.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 2 22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2\"/>\n  <polygon points=\"19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16\"/>\n  <polygon points=\"13 16 13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16\"/>\n  <path d=\"M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z\"/><path d=\"M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z\"/></svg>",
            "info": {},
            "path": "32/cics-region--routing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsRegionRouting32",
          "filepath": "cics-region--routing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--routing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsRegionRouting24",
          "filepath": "cics-region--routing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--routing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsRegionRouting20",
          "filepath": "cics-region--routing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--routing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsRegionRouting16",
          "filepath": "cics-region--routing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--routing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsRegionRouting",
        "global": "CicsRegionRouting",
        "filepath": "CicsRegionRouting.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cics-region--target",
      "friendlyName": "CICS® region target",
      "aliases": [
        "CICS®",
        "region",
        "target"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cics-region--target.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"26\" y=\"7\" width=\"2\" height=\"3\"/>\n  <rect x=\"29\" y=\"4\" width=\"3\" height=\"2\"/>\n  <rect x=\"26\" width=\"2\" height=\"3\"/>\n  <rect x=\"22\" y=\"4\" width=\"3\" height=\"2\"/>\n  <polygon points=\"19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16\"/>\n  <polygon points=\"13 16 13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16\"/>\n  <path d=\"M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z\"/><path d=\"M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z\"/></svg>",
            "info": {},
            "path": "32/cics-region--target.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CicsRegionTarget32",
          "filepath": "cics-region--target/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--target",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CicsRegionTarget24",
          "filepath": "cics-region--target/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--target",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CicsRegionTarget20",
          "filepath": "cics-region--target/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--target",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CicsRegionTarget16",
          "filepath": "cics-region--target/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                }
              }
            ],
            "name": "cics-region--target",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CicsRegionTarget",
        "global": "CicsRegionTarget",
        "filepath": "CicsRegionTarget.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cicsplex",
      "friendlyName": "CICSPlex®",
      "aliases": [
        "CICSPlex®"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cicsplex.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,18.6V17H6v1.6A7.3833,7.3833,0,0,0,13.4,26H15V24H13.4A5.3775,5.3775,0,0,1,8,18.6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,18H20a2.0059,2.0059,0,0,0-2,2v8a2.0059,2.0059,0,0,0,2,2h8a2.0059,2.0059,0,0,0,2-2V20A2.0059,2.0059,0,0,0,28,18ZM20,28V20h8v8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24,13.4V15h2V13.4A7.3833,7.3833,0,0,0,18.6,6H17V8h1.6A5.3775,5.3775,0,0,1,24,13.4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M12,2H4A2.0059,2.0059,0,0,0,2,4v8a2.0059,2.0059,0,0,0,2,2h8a2.0059,2.0059,0,0,0,2-2V4A2.0059,2.0059,0,0,0,12,2ZM4,12V4h8v8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z\"/></svg>",
            "info": {},
            "path": "32/cicsplex.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cicsplex32",
          "filepath": "cicsplex/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
                }
              }
            ],
            "name": "cicsplex",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cicsplex24",
          "filepath": "cicsplex/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
                }
              }
            ],
            "name": "cicsplex",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cicsplex20",
          "filepath": "cicsplex/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
                }
              }
            ],
            "name": "cicsplex",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cicsplex16",
          "filepath": "cicsplex/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
                }
              }
            ],
            "name": "cicsplex",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Cicsplex",
        "global": "Cicsplex",
        "filepath": "Cicsplex.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circle--filled",
      "friendlyName": "Circle filled",
      "aliases": [
        "circle filled",
        "filled circle",
        "circle",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/circle--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>circle--filled</title>\n  <circle cx=\"16\" cy=\"16\" r=\"10\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"10\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/circle--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CircleFilled32",
          "filepath": "circle--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "10"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "circle--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CircleFilled24",
          "filepath": "circle--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "10"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "circle--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CircleFilled20",
          "filepath": "circle--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "10"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "circle--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CircleFilled16",
          "filepath": "circle--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "10"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "circle--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "CircleFilled",
        "global": "CircleFilled",
        "filepath": "CircleFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "10"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circle--solid",
      "friendlyName": "Circle solid",
      "aliases": [
        "circle filled",
        "filled circle",
        "circle",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/circle--solid.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"16\" r=\"14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"14\"/></svg>",
            "info": {},
            "path": "32/circle--solid.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CircleSolid32",
          "filepath": "circle--solid/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "14"
                }
              }
            ],
            "name": "circle--solid",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CircleSolid24",
          "filepath": "circle--solid/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "14"
                }
              }
            ],
            "name": "circle--solid",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CircleSolid20",
          "filepath": "circle--solid/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "14"
                }
              }
            ],
            "name": "circle--solid",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CircleSolid16",
          "filepath": "circle--solid/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "14"
                }
              }
            ],
            "name": "circle--solid",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "CircleSolid",
        "global": "CircleSolid",
        "filepath": "CircleSolid.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "14"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circle-dash",
      "friendlyName": "Circle dash",
      "aliases": [
        "circle",
        "dash",
        "dashed line",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/circle-dash.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>circle--dash</title><path class=\"cls-1\" d=\"M7.7,4.7a14.7,14.7,0,0,0-3,3.1L6.3,9A13.26,13.26,0,0,1,8.9,6.3Z\"/><path class=\"cls-1\" d=\"M4.6,12.3l-1.9-.6A12.51,12.51,0,0,0,2,16H4A11.48,11.48,0,0,1,4.6,12.3Z\"/><path class=\"cls-1\" d=\"M2.7,20.4a14.4,14.4,0,0,0,2,3.9l1.6-1.2a12.89,12.89,0,0,1-1.7-3.3Z\"/><path class=\"cls-1\" d=\"M7.8,27.3a14.4,14.4,0,0,0,3.9,2l.6-1.9A12.89,12.89,0,0,1,9,25.7Z\"/><path class=\"cls-1\" d=\"M11.7,2.7l.6,1.9A11.48,11.48,0,0,1,16,4V2A12.51,12.51,0,0,0,11.7,2.7Z\"/><path class=\"cls-1\" d=\"M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.53,11.53,0,0,1,23,25.7Z\"/><path class=\"cls-1\" d=\"M27.4,19.7l1.9.6A15.47,15.47,0,0,0,30,16H28A11.48,11.48,0,0,1,27.4,19.7Z\"/><path class=\"cls-1\" d=\"M29.2,11.6a14.4,14.4,0,0,0-2-3.9L25.6,8.9a12.89,12.89,0,0,1,1.7,3.3Z\"/><path class=\"cls-1\" d=\"M24.1,4.6a14.4,14.4,0,0,0-3.9-2l-.6,1.9a12.89,12.89,0,0,1,3.3,1.7Z\"/><path class=\"cls-1\" d=\"M20.3,29.3l-.6-1.9A11.48,11.48,0,0,1,16,28v2A21.42,21.42,0,0,0,20.3,29.3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z\"/></svg>",
            "info": {},
            "path": "32/circle-dash.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CircleDash32",
          "filepath": "circle-dash/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
                }
              }
            ],
            "name": "circle-dash",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CircleDash24",
          "filepath": "circle-dash/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
                }
              }
            ],
            "name": "circle-dash",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CircleDash20",
          "filepath": "circle-dash/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
                }
              }
            ],
            "name": "circle-dash",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CircleDash16",
          "filepath": "circle-dash/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
                }
              }
            ],
            "name": "circle-dash",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CircleDash",
        "global": "CircleDash",
        "filepath": "CircleDash.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circle-fill",
      "friendlyName": "Circle fill",
      "aliases": [
        "circle",
        "filled",
        "solid",
        "round"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "circle-fill.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"8\" cy=\"8\" r=\"6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><circle cx=\"8\" cy=\"8\" r=\"6\"/></svg>",
            "info": {},
            "path": "circle-fill.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "8",
                  "r": "6"
                }
              }
            ],
            "name": "circle-fill",
            "size": "glyph"
          },
          "moduleName": "CircleFillGlyph",
          "filepath": "circle-fill/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CircleFill",
        "global": "CircleFill",
        "filepath": "CircleFill.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "8",
                    "r": "6"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circle-measurement",
      "friendlyName": "Circle measurement",
      "aliases": [
        "pan",
        "scan",
        "track"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/circle-measurement.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--circle-measurement</title><path d=\"M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z\"/><path d=\"M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z\"/><path d=\"M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/circle-measurement.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthCircleMeasurement32",
          "filepath": "watson-health/circle-measurement/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
                }
              }
            ],
            "name": "circle-measurement",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthCircleMeasurement24",
          "filepath": "watson-health/circle-measurement/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
                }
              }
            ],
            "name": "circle-measurement",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthCircleMeasurement20",
          "filepath": "watson-health/circle-measurement/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
                }
              }
            ],
            "name": "circle-measurement",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthCircleMeasurement16",
          "filepath": "watson-health/circle-measurement/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
                }
              }
            ],
            "name": "circle-measurement",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "CircleMeasurement",
        "global": "WatsonHealthCircleMeasurement",
        "filepath": "watson-health/CircleMeasurement.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circle-packing",
      "friendlyName": "Circle packing",
      "aliases": [
        "circlec packing",
        "circle",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/circle-packing.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>circle-packing</title>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z\"/></svg>",
            "info": {},
            "path": "32/circle-packing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CirclePacking32",
          "filepath": "circle-packing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
                }
              }
            ],
            "name": "circle-packing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CirclePacking24",
          "filepath": "circle-packing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
                }
              }
            ],
            "name": "circle-packing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CirclePacking20",
          "filepath": "circle-packing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
                }
              }
            ],
            "name": "circle-packing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CirclePacking16",
          "filepath": "circle-packing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
                }
              }
            ],
            "name": "circle-packing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "CirclePacking",
        "global": "CirclePacking",
        "filepath": "CirclePacking.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circle-stroke",
      "friendlyName": "Circle stroke",
      "aliases": [
        "stroke",
        "circle",
        "round",
        "outlined"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "circle-stroke.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z\"/></svg>",
            "info": {},
            "path": "circle-stroke.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
                }
              }
            ],
            "name": "circle-stroke",
            "size": "glyph"
          },
          "moduleName": "CircleStrokeGlyph",
          "filepath": "circle-stroke/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CircleStroke",
        "global": "CircleStroke",
        "filepath": "CircleStroke.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "circuit-composer",
      "friendlyName": "Circuit composer",
      "aliases": [
        "Q",
        "H",
        "circuit",
        "composer"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/circuit-composer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>curcuit-composer--2</title><polygon points=\"18 9 18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9\"/><path d=\"M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z\"/><path d=\"M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z\"/></svg>",
            "info": {},
            "path": "32/Q/circuit-composer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QCircuitComposer32",
          "filepath": "Q/circuit-composer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
                }
              }
            ],
            "name": "circuit-composer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QCircuitComposer24",
          "filepath": "Q/circuit-composer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
                }
              }
            ],
            "name": "circuit-composer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QCircuitComposer20",
          "filepath": "Q/circuit-composer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
                }
              }
            ],
            "name": "circuit-composer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QCircuitComposer16",
          "filepath": "Q/circuit-composer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
                }
              }
            ],
            "name": "circuit-composer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "CircuitComposer",
        "global": "QCircuitComposer",
        "filepath": "Q/CircuitComposer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "classification",
      "friendlyName": "Classification",
      "aliases": [
        "classification",
        "catagory",
        "classify"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/classification.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>classification</title><circle cx=\"15\" cy=\"19\" r=\"1\"/><path d=\"M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"15\" cy=\"19\" r=\"1\"/><path d=\"M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z\"/></svg>",
            "info": {},
            "path": "32/classification.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Classification32",
          "filepath": "classification/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "classification",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Classification24",
          "filepath": "classification/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "classification",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Classification20",
          "filepath": "classification/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "classification",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Classification16",
          "filepath": "classification/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "classification",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Classification",
        "global": "Classification",
        "filepath": "Classification.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15",
                    "cy": "19",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "classifier--language",
      "friendlyName": "Classifier language",
      "aliases": [
        "measure word",
        "counter word"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/classifier--language.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>classifier--language</title><path d=\"M30,10V2H22v8h3v4H23v2h7V14H27V10ZM24,4h4V8H24Z\"/><polygon points=\"20 23.41 18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41\"/><polygon points=\"20 14 12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14\"/><path d=\"M7,9.86a4,4,0,1,0-2,0V14H2v2H9V14H7ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\" &lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z\"/></svg>",
            "info": {},
            "path": "32/classifier--language.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ClassifierLanguage32",
          "filepath": "classifier--language/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
                }
              }
            ],
            "name": "classifier--language",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ClassifierLanguage24",
          "filepath": "classifier--language/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
                }
              }
            ],
            "name": "classifier--language",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ClassifierLanguage20",
          "filepath": "classifier--language/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
                }
              }
            ],
            "name": "classifier--language",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ClassifierLanguage16",
          "filepath": "classifier--language/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
                }
              }
            ],
            "name": "classifier--language",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ClassifierLanguage",
        "global": "ClassifierLanguage",
        "filepath": "ClassifierLanguage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "clean",
      "friendlyName": "Clean",
      "aliases": [
        "clean",
        "sweep",
        "broom"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/clean.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>clean</title>\n  <rect x=\"20\" y=\"18\" width=\"6\" height=\"2\" transform=\"translate(46 38) rotate(-180)\"/>\n  <rect x=\"24\" y=\"26\" width=\"6\" height=\"2\" transform=\"translate(54 54) rotate(-180)\"/>\n  <rect x=\"22\" y=\"22\" width=\"6\" height=\"2\" transform=\"translate(50 46) rotate(-180)\"/>\n  <path d=\"M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 18H26V20H20z\" transform=\"rotate(-180 23 19)\"/><path d=\"M24 26H30V28H24z\" transform=\"rotate(-180 27 27)\"/><path d=\"M22 22H28V24H22z\" transform=\"rotate(-180 25 23)\"/><path d=\"M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z\"/></svg>",
            "info": {},
            "path": "32/clean.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Clean32",
          "filepath": "clean/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H26V20H20z",
                  "transform": "rotate(-180 23 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H30V28H24z",
                  "transform": "rotate(-180 27 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22H28V24H22z",
                  "transform": "rotate(-180 25 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
                }
              }
            ],
            "name": "clean",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Clean24",
          "filepath": "clean/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H26V20H20z",
                  "transform": "rotate(-180 23 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H30V28H24z",
                  "transform": "rotate(-180 27 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22H28V24H22z",
                  "transform": "rotate(-180 25 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
                }
              }
            ],
            "name": "clean",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Clean20",
          "filepath": "clean/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H26V20H20z",
                  "transform": "rotate(-180 23 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H30V28H24z",
                  "transform": "rotate(-180 27 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22H28V24H22z",
                  "transform": "rotate(-180 25 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
                }
              }
            ],
            "name": "clean",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Clean16",
          "filepath": "clean/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H26V20H20z",
                  "transform": "rotate(-180 23 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H30V28H24z",
                  "transform": "rotate(-180 27 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 22H28V24H22z",
                  "transform": "rotate(-180 25 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
                }
              }
            ],
            "name": "clean",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Clean",
        "global": "Clean",
        "filepath": "Clean.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 18H26V20H20z",
                    "transform": "rotate(-180 23 19)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 26H30V28H24z",
                    "transform": "rotate(-180 27 27)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 22H28V24H22z",
                    "transform": "rotate(-180 25 23)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "close",
      "friendlyName": "Close",
      "aliases": [
        "X",
        "dismiss",
        "deny",
        "denied",
        "ex"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/close.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>close</title><polygon class=\"cls-1\" points=\"24 9.4 22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4\"/><rect class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z\"/></svg>",
            "info": {},
            "path": "32/close.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Close32",
          "filepath": "close/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
                }
              }
            ],
            "name": "close",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Close24",
          "filepath": "close/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
                }
              }
            ],
            "name": "close",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Close20",
          "filepath": "close/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
                }
              }
            ],
            "name": "close",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Close16",
          "filepath": "close/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
                }
              }
            ],
            "name": "close",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Close",
        "global": "Close",
        "filepath": "Close.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "close--filled",
      "friendlyName": "Close filled",
      "aliases": [
        "X",
        "dismiss",
        "deny",
        "denied",
        "ex"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/close--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>misuse</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\n\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z\"/></svg>",
            "info": {},
            "path": "16/close--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/close--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{opacity:0;}\n\t.st1{fill:none;}\n</style>\n<path d=\"M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\n\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z\"/>\n<polyline id=\"inner-path\" class=\"st0\" points=\"14.4,16 9,10.6 10.6,9 16,14.4 21.4,9 23,10.6 17.6,16 23,21.4 21.4,23 16,17.6 \n\t10.6,23 9,21.4 14.4,16 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z\"/><path d=\"M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "32/close--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloseFilled32",
          "filepath": "close--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "close--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloseFilled24",
          "filepath": "close--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "close--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloseFilled20",
          "filepath": "close--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "close--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloseFilled16",
          "filepath": "close--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
                }
              }
            ],
            "name": "close--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "CloseFilled",
        "global": "CloseFilled",
        "filepath": "CloseFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2 l2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "close--outline",
      "friendlyName": "Close outline",
      "aliases": [
        "X",
        "dismiss",
        "deny",
        "denied",
        "ex"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/close--outline.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>checkmark</title>\n<path d=\"M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\n\tS22.6,28,16,28z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n<polygon points=\"21.4,23 16,17.6 10.6,23 9,21.4 14.4,16 9,10.6 10.6,9 16,14.4 21.4,9 23,10.6 17.6,16 23,21.4 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z\"/><path d=\"M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z\"/></svg>",
            "info": {},
            "path": "32/close--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloseOutline32",
          "filepath": "close--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                }
              }
            ],
            "name": "close--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloseOutline24",
          "filepath": "close--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                }
              }
            ],
            "name": "close--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloseOutline20",
          "filepath": "close--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                }
              }
            ],
            "name": "close--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloseOutline16",
          "filepath": "close--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                }
              }
            ],
            "name": "close--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "CloseOutline",
        "global": "CloseOutline",
        "filepath": "CloseOutline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "closed-caption",
      "friendlyName": "Closed caption",
      "aliases": [
        "caption",
        "closed",
        "cc"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/closed-caption.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>closed-caption</title><path d=\"M15,21H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H10v6h5Z\"/><path d=\"M25,21H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H20v6h5Z\"/><path d=\"M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z\"/><path d=\"M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z\"/></svg>",
            "info": {},
            "path": "32/closed-caption.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ClosedCaption32",
          "filepath": "closed-caption/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "closed-caption",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ClosedCaption24",
          "filepath": "closed-caption/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "closed-caption",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ClosedCaption20",
          "filepath": "closed-caption/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "closed-caption",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ClosedCaption16",
          "filepath": "closed-caption/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "closed-caption",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ClosedCaption",
        "global": "ClosedCaption",
        "filepath": "ClosedCaption.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "closed-caption--alt",
      "friendlyName": "Closed caption alt",
      "aliases": [
        "caption",
        "closed",
        "cc"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/closed-caption--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>closed-caption--alt</title><rect x=\"19\" y=\"17\" width=\"6\" height=\"2\"/><rect x=\"11\" y=\"17\" width=\"6\" height=\"2\"/><rect x=\"6\" y=\"17\" width=\"3\" height=\"2\"/><rect x=\"22\" y=\"13\" width=\"4\" height=\"2\"/><rect x=\"13\" y=\"13\" width=\"7\" height=\"2\"/><rect x=\"6\" y=\"13\" width=\"5\" height=\"2\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/></svg>",
            "info": {},
            "path": "32/closed-caption--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ClosedCaptionAlt32",
          "filepath": "closed-caption--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "closed-caption--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ClosedCaptionAlt24",
          "filepath": "closed-caption--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "closed-caption--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ClosedCaptionAlt20",
          "filepath": "closed-caption--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "closed-caption--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ClosedCaptionAlt16",
          "filepath": "closed-caption--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "closed-caption--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ClosedCaptionAlt",
        "global": "ClosedCaptionAlt",
        "filepath": "ClosedCaptionAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "closed-caption--filled",
      "friendlyName": "Closed caption filled",
      "aliases": [
        "caption",
        "closed",
        "cc"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/closed-caption--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>closed-caption--filled</title><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z\"/></svg>",
            "info": {},
            "path": "32/closed-caption--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ClosedCaptionFilled32",
          "filepath": "closed-caption--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
                }
              }
            ],
            "name": "closed-caption--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ClosedCaptionFilled24",
          "filepath": "closed-caption--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
                }
              }
            ],
            "name": "closed-caption--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ClosedCaptionFilled20",
          "filepath": "closed-caption--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
                }
              }
            ],
            "name": "closed-caption--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ClosedCaptionFilled16",
          "filepath": "closed-caption--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
                }
              }
            ],
            "name": "closed-caption--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ClosedCaptionFilled",
        "global": "ClosedCaptionFilled",
        "filepath": "ClosedCaptionFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud",
      "friendlyName": "Cloud",
      "aliases": [
        "weather",
        "cloud",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud</title><path d=\"M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z\" transform=\"translate(0)\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z\"/></svg>",
            "info": {},
            "path": "32/cloud.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cloud32",
          "filepath": "cloud/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              }
            ],
            "name": "cloud",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cloud24",
          "filepath": "cloud/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              }
            ],
            "name": "cloud",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cloud20",
          "filepath": "cloud/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              }
            ],
            "name": "cloud",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cloud16",
          "filepath": "cloud/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              }
            ],
            "name": "cloud",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Cloud",
        "global": "Cloud",
        "filepath": "Cloud.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--alerting",
      "friendlyName": "Cloud alerting",
      "aliases": [
        "cloud",
        "alerting",
        "alert",
        "interface",
        "app",
        "software",
        "triangle",
        "warning",
        "caution",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--alerting.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z\"/><path d=\"M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z\"/></svg>",
            "info": {},
            "path": "32/cloud--alerting.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudAlerting32",
          "filepath": "cloud--alerting/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
                }
              }
            ],
            "name": "cloud--alerting",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudAlerting24",
          "filepath": "cloud--alerting/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
                }
              }
            ],
            "name": "cloud--alerting",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudAlerting20",
          "filepath": "cloud--alerting/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
                }
              }
            ],
            "name": "cloud--alerting",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudAlerting16",
          "filepath": "cloud--alerting/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
                }
              }
            ],
            "name": "cloud--alerting",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CloudAlerting",
        "global": "CloudAlerting",
        "filepath": "CloudAlerting.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--auditing",
      "friendlyName": "IBM Cloud® Activity Tracker",
      "aliases": [
        "cloud",
        "auditing",
        "review",
        "interface",
        "app",
        "software",
        "audit",
        "checkmark",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--auditing.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"21 15 16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z\"/><path d=\"M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z\"/></svg>",
            "info": {},
            "path": "32/cloud--auditing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudAuditing32",
          "filepath": "cloud--auditing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
                }
              }
            ],
            "name": "cloud--auditing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudAuditing24",
          "filepath": "cloud--auditing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
                }
              }
            ],
            "name": "cloud--auditing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudAuditing20",
          "filepath": "cloud--auditing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
                }
              }
            ],
            "name": "cloud--auditing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudAuditing16",
          "filepath": "cloud--auditing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
                }
              }
            ],
            "name": "cloud--auditing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudAuditing",
        "global": "CloudAuditing",
        "filepath": "CloudAuditing.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--data-ops",
      "friendlyName": "Cloud data-ops",
      "aliases": [
        "cloud data-ops",
        "data ops",
        "data operations",
        "cloud",
        "hybrid",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--data-ops.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"28\" y=\"18\" width=\"2\" height=\"10\"/>\n  <rect x=\"24\" y=\"14\" width=\"2\" height=\"14\"/>\n  <rect x=\"20\" y=\"22\" width=\"2\" height=\"6\"/>\n  <path d=\"M22.175,10,23.76,8.7339A9.9522,9.9522,0,0,0,17.89,5.1816,10.0025,10.0025,0,0,0,6.17,13.1152,7.5054,7.5054,0,0,0,.0544,21.4087,7.6843,7.6843,0,0,0,7.7692,28H16V26H7.6945a5.632,5.632,0,0,1-5.6023-4.4858,5.5064,5.5064,0,0,1,4.4339-6.4307l1.3486-.2441.2139-1.11a8.206,8.206,0,0,1,6.7426-6.6426,7.9666,7.9666,0,0,1,3.0137.13A7.8037,7.8037,0,0,1,22.175,10Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z\"/></svg>",
            "info": {},
            "path": "32/cloud--data-ops.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudDataOps32",
          "filepath": "cloud--data-ops/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
                }
              }
            ],
            "name": "cloud--data-ops",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudDataOps24",
          "filepath": "cloud--data-ops/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
                }
              }
            ],
            "name": "cloud--data-ops",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudDataOps20",
          "filepath": "cloud--data-ops/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
                }
              }
            ],
            "name": "cloud--data-ops",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudDataOps16",
          "filepath": "cloud--data-ops/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
                }
              }
            ],
            "name": "cloud--data-ops",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CloudDataOps",
        "global": "CloudDataOps",
        "filepath": "CloudDataOps.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--download",
      "friendlyName": "Cloud download",
      "aliases": [
        "donwload",
        "compute",
        "data",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--download.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud--download</title><path d=\"M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z\"/><polygon points=\"17 26.17 17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z\"/><path d=\"M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z\"/></svg>",
            "info": {},
            "path": "32/cloud--download.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudDownload32",
          "filepath": "cloud--download/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
                }
              }
            ],
            "name": "cloud--download",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudDownload24",
          "filepath": "cloud--download/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
                }
              }
            ],
            "name": "cloud--download",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudDownload20",
          "filepath": "cloud--download/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
                }
              }
            ],
            "name": "cloud--download",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudDownload16",
          "filepath": "cloud--download/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
                }
              }
            ],
            "name": "cloud--download",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CloudDownload",
        "global": "CloudDownload",
        "filepath": "CloudDownload.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--logging",
      "friendlyName": "IBM Cloud® Log Analysis",
      "aliases": [
        "cloud",
        "logging",
        "log",
        "app",
        "interface",
        "software",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--logging.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,16v6H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"18\" y=\"4\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"8\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"12\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z\"/><path d=\"M18 8H30V10H18zM18 12H24V14H18z\"/></svg>",
            "info": {},
            "path": "32/cloud--logging.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudLogging32",
          "filepath": "cloud--logging/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H30V10H18zM18 12H24V14H18z"
                }
              }
            ],
            "name": "cloud--logging",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudLogging24",
          "filepath": "cloud--logging/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H30V10H18zM18 12H24V14H18z"
                }
              }
            ],
            "name": "cloud--logging",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudLogging20",
          "filepath": "cloud--logging/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H30V10H18zM18 12H24V14H18z"
                }
              }
            ],
            "name": "cloud--logging",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudLogging16",
          "filepath": "cloud--logging/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 8H30V10H18zM18 12H24V14H18z"
                }
              }
            ],
            "name": "cloud--logging",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudLogging",
        "global": "CloudLogging",
        "filepath": "CloudLogging.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 8H30V10H18zM18 12H24V14H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--monitoring",
      "friendlyName": "IBM Cloud® Monitoring",
      "aliases": [
        "cloud",
        "monitoring",
        "monitor",
        "health",
        "interface",
        "app",
        "software",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--monitoring.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z\"/><path d=\"M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z\"/></svg>",
            "info": {},
            "path": "32/cloud--monitoring.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudMonitoring32",
          "filepath": "cloud--monitoring/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
                }
              }
            ],
            "name": "cloud--monitoring",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudMonitoring24",
          "filepath": "cloud--monitoring/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
                }
              }
            ],
            "name": "cloud--monitoring",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudMonitoring20",
          "filepath": "cloud--monitoring/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
                }
              }
            ],
            "name": "cloud--monitoring",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudMonitoring16",
          "filepath": "cloud--monitoring/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
                }
              }
            ],
            "name": "cloud--monitoring",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudMonitoring",
        "global": "CloudMonitoring",
        "filepath": "CloudMonitoring.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--offline",
      "friendlyName": "Cloud offline",
      "aliases": [
        "technology",
        "cloud",
        "offline",
        "unavailable",
        "down",
        "disconnected"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--offline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24.8008,12.1362a8.8694,8.8694,0,0,0-.9795-2.5434L30,3.4142,28.5872,2,2,28.5872,3.4142,30l5-5H23.5a6.4974,6.4974,0,0,0,1.3008-12.8638ZM23.5,23H10.4141L22.3418,11.0723a6.9049,6.9049,0,0,1,.6006,2.0708l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,23Z\"/>\n  <path d=\"M4.2964,23.4487l1.4313-1.4311A4.4774,4.4774,0,0,1,8.144,14.019l.8155-.0639.0991-.812a6.9867,6.9867,0,0,1,10.63-5.0865l1.4431-1.4428A8.9859,8.9859,0,0,0,7.2,12.1362,6.4891,6.4891,0,0,0,4.2964,23.4487Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z\"/></svg>",
            "info": {},
            "path": "32/cloud--offline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudOffline32",
          "filepath": "cloud--offline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
                }
              }
            ],
            "name": "cloud--offline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudOffline24",
          "filepath": "cloud--offline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
                }
              }
            ],
            "name": "cloud--offline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudOffline20",
          "filepath": "cloud--offline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
                }
              }
            ],
            "name": "cloud--offline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudOffline16",
          "filepath": "cloud--offline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
                }
              }
            ],
            "name": "cloud--offline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CloudOffline",
        "global": "CloudOffline",
        "filepath": "CloudOffline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--service-management",
      "friendlyName": "Cloud service management",
      "aliases": [
        "cloud",
        "service",
        "management",
        "app",
        "software",
        "interface",
        "settings",
        "preferences",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--service-management.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z\"/><path d=\"M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z\"/></svg>",
            "info": {},
            "path": "32/cloud--service-management.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudServiceManagement32",
          "filepath": "cloud--service-management/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              }
            ],
            "name": "cloud--service-management",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudServiceManagement24",
          "filepath": "cloud--service-management/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              }
            ],
            "name": "cloud--service-management",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudServiceManagement20",
          "filepath": "cloud--service-management/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              }
            ],
            "name": "cloud--service-management",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudServiceManagement16",
          "filepath": "cloud--service-management/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              }
            ],
            "name": "cloud--service-management",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CloudServiceManagement",
        "global": "CloudServiceManagement",
        "filepath": "CloudServiceManagement.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud--upload",
      "friendlyName": "Cloud upload",
      "aliases": [
        "upload",
        "compute",
        "data",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud--upload.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud--upload</title><polygon points=\"11 18 12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18\"/><path d=\"M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z\"/><path d=\"M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z\"/></svg>",
            "info": {},
            "path": "32/cloud--upload.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudUpload32",
          "filepath": "cloud--upload/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "cloud--upload",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudUpload24",
          "filepath": "cloud--upload/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "cloud--upload",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudUpload20",
          "filepath": "cloud--upload/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "cloud--upload",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudUpload16",
          "filepath": "cloud--upload/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "cloud--upload",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CloudUpload",
        "global": "CloudUpload",
        "filepath": "CloudUpload.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-app",
      "friendlyName": "Cloud app",
      "aliases": [
        "cloud app",
        "cloud",
        "IBM",
        "IBM Cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-app.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fog</title><path d=\"M25.8289,13.1155A10.02,10.02,0,0,0,16,5.0005V7a8.0233,8.0233,0,0,1,7.8649,6.4934l.2591,1.346,1.3488.2441A5.5019,5.5019,0,0,1,24.5076,26H16v2h8.5076a7.5019,7.5019,0,0,0,1.3213-14.8845Z\"/><rect x=\"8\" y=\"24\" width=\"6\" height=\"2\"/><rect x=\"4\" y=\"24\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"20\" width=\"8\" height=\"2\"/><rect x=\"2\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"16\" width=\"6\" height=\"2\"/><rect x=\"4\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"12\" width=\"4\" height=\"2\"/><rect x=\"6\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"12\" y=\"8\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z\"/></svg>",
            "info": {},
            "path": "32/cloud-app.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudApp32",
          "filepath": "cloud-app/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
                }
              }
            ],
            "name": "cloud-app",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudApp24",
          "filepath": "cloud-app/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
                }
              }
            ],
            "name": "cloud-app",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudApp20",
          "filepath": "cloud-app/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
                }
              }
            ],
            "name": "cloud-app",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudApp16",
          "filepath": "cloud-app/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
                }
              }
            ],
            "name": "cloud-app",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "CloudApp",
        "global": "CloudApp",
        "filepath": "CloudApp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-ceiling",
      "friendlyName": "Cloud ceiling",
      "aliases": [
        "weather",
        "cloud",
        "rain",
        "precipitation",
        "forecast",
        "sky"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-ceiling.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"28\" width=\"9\" height=\"2\"/>\n  <rect x=\"21\" y=\"28\" width=\"9\" height=\"2\"/>\n  <polygon points=\"17 26.167 17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167\"/>\n  <path d=\"M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z\"/><path d=\"M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z\"/></svg>",
            "info": {},
            "path": "32/cloud-ceiling.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudCeiling32",
          "filepath": "cloud-ceiling/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
                }
              }
            ],
            "name": "cloud-ceiling",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudCeiling24",
          "filepath": "cloud-ceiling/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
                }
              }
            ],
            "name": "cloud-ceiling",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudCeiling20",
          "filepath": "cloud-ceiling/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
                }
              }
            ],
            "name": "cloud-ceiling",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudCeiling16",
          "filepath": "cloud-ceiling/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
                }
              }
            ],
            "name": "cloud-ceiling",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "CloudCeiling",
        "global": "CloudCeiling",
        "filepath": "CloudCeiling.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-foundry--1",
      "friendlyName": "IBM Cloud® Foundry",
      "aliases": [
        "platform",
        "multi cloud",
        "multicloud",
        "cloud",
        "foundry"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-foundry--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud-foundry--1</title><path d=\"M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z\"/><path d=\"M14,24H11a2,2,0,0,1-2-2V19a2,2,0,0,1,2-2h3v2H11v3h3Z\"/><path d=\"M21,15V13H19a2,2,0,0,0-2,2v2H16v2h1v5h2V19h2V17H19V15Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z\"/><path d=\"M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z\"/></svg>",
            "info": {},
            "path": "32/cloud-foundry--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudFoundry_132",
          "filepath": "cloud-foundry--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
                }
              }
            ],
            "name": "cloud-foundry--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudFoundry_124",
          "filepath": "cloud-foundry--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
                }
              }
            ],
            "name": "cloud-foundry--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudFoundry_120",
          "filepath": "cloud-foundry--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
                }
              }
            ],
            "name": "cloud-foundry--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudFoundry_116",
          "filepath": "cloud-foundry--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
                }
              }
            ],
            "name": "cloud-foundry--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudFoundry_1",
        "global": "CloudFoundry_1",
        "filepath": "CloudFoundry_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-foundry--2",
      "friendlyName": "IBM Cloud® Foundry 2",
      "aliases": [
        "platform",
        "multi cloud",
        "multicloud",
        "cloud",
        "foundry"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-foundry--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud-foundry--2</title><polygon points=\"25 11 25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11\"/><path d=\"M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z\"/></svg>",
            "info": {},
            "path": "32/cloud-foundry--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudFoundry_232",
          "filepath": "cloud-foundry--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "cloud-foundry--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudFoundry_224",
          "filepath": "cloud-foundry--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "cloud-foundry--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudFoundry_220",
          "filepath": "cloud-foundry--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "cloud-foundry--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudFoundry_216",
          "filepath": "cloud-foundry--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "cloud-foundry--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CloudFoundry_2",
        "global": "CloudFoundry_2",
        "filepath": "CloudFoundry_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-registry",
      "friendlyName": "IBM Cloud® Container Registry",
      "aliases": [
        "cloud",
        "container",
        "registry",
        "data",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-registry.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H23a2.0023,2.0023,0,0,1-2-2V23a2.0023,2.0023,0,0,1,2-2h5a2.0023,2.0023,0,0,1,2,2v5A2.0023,2.0023,0,0,1,28,30Zm-5-7h-.0012L23,28h5V23Z\"/>\n  <path d=\"M16,23H11a2.0023,2.0023,0,0,1-2-2V11a2.0023,2.0023,0,0,1,2-2H21a2.0023,2.0023,0,0,1,2,2v5H21V11H11V21h5Z\"/>\n  <path d=\"M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z\"/><path d=\"M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z\"/></svg>",
            "info": {},
            "path": "32/cloud-registry.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudRegistry32",
          "filepath": "cloud-registry/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
                }
              }
            ],
            "name": "cloud-registry",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudRegistry24",
          "filepath": "cloud-registry/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
                }
              }
            ],
            "name": "cloud-registry",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudRegistry20",
          "filepath": "cloud-registry/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
                }
              }
            ],
            "name": "cloud-registry",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudRegistry16",
          "filepath": "cloud-registry/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
                }
              }
            ],
            "name": "cloud-registry",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudRegistry",
        "global": "CloudRegistry",
        "filepath": "CloudRegistry.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-satellite",
      "friendlyName": "IBM Cloud Satellite®",
      "aliases": [
        "cloud",
        "satellite",
        "hybrid",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-satellite.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #1c1c1c;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle id=\"circle-bottom\" class=\"cls-1\" cx=\"9\" cy=\"20\" r=\"2\"/>\n  <path id=\"circle-center\" class=\"cls-1\" d=\"M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z\"/>\n  <circle id=\"circle-top\" class=\"cls-1\" cx=\"23\" cy=\"12\" r=\"2\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"20\" r=\"2\"/><path d=\"M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z\"/><circle cx=\"23\" cy=\"12\" r=\"2\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/cloud-satellite.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudSatellite32",
          "filepath": "cloud-satellite/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "cloud-satellite",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudSatellite24",
          "filepath": "cloud-satellite/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "cloud-satellite",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudSatellite20",
          "filepath": "cloud-satellite/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "cloud-satellite",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudSatellite16",
          "filepath": "cloud-satellite/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "cloud-satellite",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudSatellite",
        "global": "CloudSatellite",
        "filepath": "CloudSatellite.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-satellite--config",
      "friendlyName": "IBM Cloud Satellite® config",
      "aliases": [
        "cloud",
        "satellite",
        "hybrid",
        "config",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-satellite--config.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z\"/>\n  <circle id=\"circle-bottom\" cx=\"7\" cy=\"20\" r=\"2\"/>\n  <path id=\"circle-center\" d=\"M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z\"/>\n  <circle id=\"circle-top\" cx=\"21\" cy=\"12\" r=\"2\"/>\n  <path d=\"M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z\"/><circle cx=\"7\" cy=\"20\" r=\"2\"/><path d=\"M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z\"/><circle cx=\"21\" cy=\"12\" r=\"2\"/><path d=\"M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z\"/></svg>",
            "info": {},
            "path": "32/cloud-satellite--config.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudSatelliteConfig32",
          "filepath": "cloud-satellite--config/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--config",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudSatelliteConfig24",
          "filepath": "cloud-satellite--config/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--config",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudSatelliteConfig20",
          "filepath": "cloud-satellite--config/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--config",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudSatelliteConfig16",
          "filepath": "cloud-satellite--config/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--config",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudSatelliteConfig",
        "global": "CloudSatelliteConfig",
        "filepath": "CloudSatelliteConfig.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-satellite--link",
      "friendlyName": "IBM Cloud Satellite® link",
      "aliases": [
        "cloud",
        "satellite",
        "hybrid",
        "link",
        "aoo"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-satellite--link.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z\"/>\n  <path d=\"M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z\"/>\n  <circle id=\"circle-bottom\" cx=\"7\" cy=\"20\" r=\"2\"/>\n  <path id=\"circle-center\" d=\"M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z\"/>\n  <circle id=\"circle-top\" cx=\"21\" cy=\"12\" r=\"2\"/>\n  <path d=\"M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z\"/><path d=\"M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z\"/><circle cx=\"7\" cy=\"20\" r=\"2\"/><path d=\"M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z\"/><circle cx=\"21\" cy=\"12\" r=\"2\"/><path d=\"M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z\"/></svg>",
            "info": {},
            "path": "32/cloud-satellite--link.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudSatelliteLink32",
          "filepath": "cloud-satellite--link/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
                }
              }
            ],
            "name": "cloud-satellite--link",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudSatelliteLink24",
          "filepath": "cloud-satellite--link/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
                }
              }
            ],
            "name": "cloud-satellite--link",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudSatelliteLink20",
          "filepath": "cloud-satellite--link/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
                }
              }
            ],
            "name": "cloud-satellite--link",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudSatelliteLink16",
          "filepath": "cloud-satellite--link/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
                }
              }
            ],
            "name": "cloud-satellite--link",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudSatelliteLink",
        "global": "CloudSatelliteLink",
        "filepath": "CloudSatelliteLink.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-satellite--services",
      "friendlyName": "IBM Cloud Satellite® services",
      "aliases": [
        "cloud",
        "satellite",
        "hybrid",
        "services",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-satellite--services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z\"/>\n  <circle id=\"circle-bottom\" cx=\"7\" cy=\"20\" r=\"2\"/>\n  <path id=\"circle-center\" d=\"M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z\"/>\n  <circle id=\"circle-top\" cx=\"21\" cy=\"12\" r=\"2\"/>\n  <path d=\"M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z\"/><circle cx=\"7\" cy=\"20\" r=\"2\"/><path d=\"M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z\"/><circle cx=\"21\" cy=\"12\" r=\"2\"/><path d=\"M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z\"/></svg>",
            "info": {},
            "path": "32/cloud-satellite--services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudSatelliteServices32",
          "filepath": "cloud-satellite--services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudSatelliteServices24",
          "filepath": "cloud-satellite--services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudSatelliteServices20",
          "filepath": "cloud-satellite--services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudSatelliteServices16",
          "filepath": "cloud-satellite--services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                }
              }
            ],
            "name": "cloud-satellite--services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "CloudSatelliteServices",
        "global": "CloudSatelliteServices",
        "filepath": "CloudSatelliteServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloud-services",
      "friendlyName": "Cloud services",
      "aliases": [
        "cloud",
        "settings",
        "preferences",
        "services",
        "app",
        "interface",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloud-services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z\"/><path d=\"M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z\"/></svg>",
            "info": {},
            "path": "32/cloud-services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CloudServices32",
          "filepath": "cloud-services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
                }
              }
            ],
            "name": "cloud-services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CloudServices24",
          "filepath": "cloud-services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
                }
              }
            ],
            "name": "cloud-services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CloudServices20",
          "filepath": "cloud-services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
                }
              }
            ],
            "name": "cloud-services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CloudServices16",
          "filepath": "cloud-services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
                }
              }
            ],
            "name": "cloud-services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CloudServices",
        "global": "CloudServices",
        "filepath": "CloudServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cloudy",
      "friendlyName": "Cloudy",
      "aliases": [
        "cloudy",
        "weather",
        "cloudy weather",
        "forecast",
        "sky"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cloudy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloudy</title><path d=\"M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z\"/></svg>",
            "info": {},
            "path": "32/cloudy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cloudy32",
          "filepath": "cloudy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
                }
              }
            ],
            "name": "cloudy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cloudy24",
          "filepath": "cloudy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
                }
              }
            ],
            "name": "cloudy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cloudy20",
          "filepath": "cloudy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
                }
              }
            ],
            "name": "cloudy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cloudy16",
          "filepath": "cloudy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
                }
              }
            ],
            "name": "cloudy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Cloudy",
        "global": "Cloudy",
        "filepath": "Cloudy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cobb-angle",
      "friendlyName": "Cobb angle",
      "aliases": [
        "corner",
        "slant",
        "twist",
        "bend",
        "crook",
        "stack"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/cobb-angle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--cobb-angle</title><path d=\"M20,17V15a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h8A2,2,0,0,0,20,17ZM10,15h8v2H10Z\" transform=\"translate(0 0)\"/><path d=\"M23.42,24.48A2,2,0,0,0,21,23.06l-7.73,2.07a2,2,0,0,0-1.42,2.44h0l.52,1.93A2,2,0,0,0,14.27,31a3,3,0,0,0,.52-.07l7.73-2.07h0a2,2,0,0,0,1.41-2.45ZM14.27,29l-.51-1.94L21.48,25,22,26.92Z\" transform=\"translate(0 0)\"/><path d=\"M13.24,6.86,21,8.93h0a2.24,2.24,0,0,0,.51.07,2,2,0,0,0,1.94-1.48L24,5.58a2,2,0,0,0-1.41-2.45L14.79,1.06a2,2,0,0,0-2.45,1.41h0l-.52,1.93a2,2,0,0,0,1.42,2.44Zm1-3.86L22,5.07,21.48,7,13.76,4.93Z\" transform=\"translate(0 0)\"/><rect x=\"14\" y=\"21\" width=\"2\" height=\"2\"/><rect x=\"14\" y=\"9\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z\"/></svg>",
            "info": {},
            "path": "32/watson-health/cobb-angle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthCobbAngle32",
          "filepath": "watson-health/cobb-angle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
                }
              }
            ],
            "name": "cobb-angle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthCobbAngle24",
          "filepath": "watson-health/cobb-angle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
                }
              }
            ],
            "name": "cobb-angle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthCobbAngle20",
          "filepath": "watson-health/cobb-angle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
                }
              }
            ],
            "name": "cobb-angle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthCobbAngle16",
          "filepath": "watson-health/cobb-angle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
                }
              }
            ],
            "name": "cobb-angle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "CobbAngle",
        "global": "WatsonHealthCobbAngle",
        "filepath": "watson-health/CobbAngle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "code",
      "friendlyName": "Code",
      "aliases": [
        "</>",
        "html",
        "java",
        "css",
        "dev",
        "development"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/code.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>code</title><polygon points=\"31 16 24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16\"/><polygon points=\"1 16 8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16\"/><rect x=\"5.91\" y=\"15\" width=\"20.17\" height=\"2\" transform=\"translate(-3.6 27.31) rotate(-75)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(0 32) rotate(-90)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z\"/><path d=\"M5.91 15H26.080000000000002V17H5.91z\" transform=\"rotate(-75 15.996 16)\"/></svg>",
            "info": {},
            "path": "32/code.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Code32",
          "filepath": "code/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.91 15H26.080000000000002V17H5.91z",
                  "transform": "rotate(-75 15.996 16)"
                }
              }
            ],
            "name": "code",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Code24",
          "filepath": "code/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.91 15H26.080000000000002V17H5.91z",
                  "transform": "rotate(-75 15.996 16)"
                }
              }
            ],
            "name": "code",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Code20",
          "filepath": "code/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.91 15H26.080000000000002V17H5.91z",
                  "transform": "rotate(-75 15.996 16)"
                }
              }
            ],
            "name": "code",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Code16",
          "filepath": "code/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.91 15H26.080000000000002V17H5.91z",
                  "transform": "rotate(-75 15.996 16)"
                }
              }
            ],
            "name": "code",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Code",
        "global": "Code",
        "filepath": "Code.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.91 15H26.080000000000002V17H5.91z",
                    "transform": "rotate(-75 15.996 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "code--hide",
      "friendlyName": "Code hide",
      "aliases": [
        "</>",
        "html",
        "java",
        "css",
        "dev",
        "development",
        "hide",
        "hidden"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/code--hide.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17.713 13.471 19.576 6.518 17.645 6 16.08 11.838 17.713 13.471\"/>\n  <polygon points=\"24.207 19.965 25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965\"/>\n  <polygon points=\"30 28.586 3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z\"/></svg>",
            "info": {},
            "path": "32/code--hide.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CodeHide32",
          "filepath": "code--hide/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
                }
              }
            ],
            "name": "code--hide",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CodeHide24",
          "filepath": "code--hide/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
                }
              }
            ],
            "name": "code--hide",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CodeHide20",
          "filepath": "code--hide/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
                }
              }
            ],
            "name": "code--hide",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CodeHide16",
          "filepath": "code--hide/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
                }
              }
            ],
            "name": "code--hide",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CodeHide",
        "global": "CodeHide",
        "filepath": "CodeHide.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "code--reference",
      "friendlyName": "Code reference",
      "aliases": [
        "</>",
        "dev",
        "development",
        "citation",
        "source",
        "reference",
        "code"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/code--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <polygon points=\"30 10 24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10\"/>\n  <rect x=\"8.9443\" y=\"9.0005\" width=\"16.0297\" height=\"1.9997\" transform=\"translate(2.909 23.7922) rotate(-74.9952)\"/>\n  <polygon points=\"4 10 10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z\"/><path d=\"M8.944 9.001H24.974000000000004V11.001H8.944z\" transform=\"rotate(-74.995 16.96 10)\"/><path d=\"M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z\"/></svg>",
            "info": {},
            "path": "32/code--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CodeReference32",
          "filepath": "code--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.944 9.001H24.974000000000004V11.001H8.944z",
                  "transform": "rotate(-74.995 16.96 10)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
                }
              }
            ],
            "name": "code--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CodeReference24",
          "filepath": "code--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.944 9.001H24.974000000000004V11.001H8.944z",
                  "transform": "rotate(-74.995 16.96 10)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
                }
              }
            ],
            "name": "code--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CodeReference20",
          "filepath": "code--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.944 9.001H24.974000000000004V11.001H8.944z",
                  "transform": "rotate(-74.995 16.96 10)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
                }
              }
            ],
            "name": "code--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CodeReference16",
          "filepath": "code--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.944 9.001H24.974000000000004V11.001H8.944z",
                  "transform": "rotate(-74.995 16.96 10)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
                }
              }
            ],
            "name": "code--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "CodeReference",
        "global": "CodeReference",
        "filepath": "CodeReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.944 9.001H24.974000000000004V11.001H8.944z",
                    "transform": "rotate(-74.995 16.96 10)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "code-signing-service",
      "friendlyName": "Code signing service",
      "aliases": [
        "systems",
        "code",
        "signing",
        "service",
        "key",
        "encryption"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/code-signing-service.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"25\" cy=\"20\" r=\"1\"/>\n  <path d=\"M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"6\" y=\"8\" width=\"2\" height=\"8\"/>\n  <rect x=\"2\" y=\"8\" width=\"2\" height=\"8\"/>\n  <rect x=\"18\" y=\"8\" width=\"2\" height=\"6\"/>\n  <path d=\"M14,16H12a2,2,0,0,1-2-2V10a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v4A2,2,0,0,1,14,16Zm-2-2h2V10H12Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"18\" width=\"2\" height=\"8\"/>\n  <rect x=\"14\" y=\"18\" width=\"2\" height=\"4\"/>\n  <path d=\"M10,26H8a2,2,0,0,1-2-2V20a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v4A2,2,0,0,1,10,26ZM8,24h2V20H8Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"18\" y=\"2\" width=\"2\" height=\"4\"/>\n  <path d=\"M10,6H8A2,2,0,0,1,6,4V2H8V4h2V2h2V4A2,2,0,0,1,10,6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"25\" cy=\"20\" r=\"1\"/><path d=\"M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z\"/></svg>",
            "info": {},
            "path": "32/code-signing-service.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CodeSigningService32",
          "filepath": "code-signing-service/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
                }
              }
            ],
            "name": "code-signing-service",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CodeSigningService24",
          "filepath": "code-signing-service/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
                }
              }
            ],
            "name": "code-signing-service",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CodeSigningService20",
          "filepath": "code-signing-service/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
                }
              }
            ],
            "name": "code-signing-service",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CodeSigningService16",
          "filepath": "code-signing-service/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
                }
              }
            ],
            "name": "code-signing-service",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CodeSigningService",
        "global": "CodeSigningService",
        "filepath": "CodeSigningService.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cognitive",
      "friendlyName": "Cognitive",
      "aliases": [
        "brain",
        "idea",
        "think",
        "mind"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cognitive.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cognitive</title><path d=\"M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z\"/></svg>",
            "info": {},
            "path": "32/cognitive.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cognitive32",
          "filepath": "cognitive/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
                }
              }
            ],
            "name": "cognitive",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cognitive24",
          "filepath": "cognitive/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
                }
              }
            ],
            "name": "cognitive",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cognitive20",
          "filepath": "cognitive/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
                }
              }
            ],
            "name": "cognitive",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cognitive16",
          "filepath": "cognitive/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
                }
              }
            ],
            "name": "cognitive",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Cognitive",
        "global": "Cognitive",
        "filepath": "Cognitive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "collaborate",
      "friendlyName": "Collaborate",
      "aliases": [
        "people",
        "cooperate",
        "relation",
        "coworker",
        "rotate",
        "shift"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/collaborate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>collaborate</title><path d=\"M6,21V20H4v1a7,7,0,0,0,7,7h3V26H11A5,5,0,0,1,6,21Z\" transform=\"translate(0)\"/><path d=\"M24,11v1h2V11a7,7,0,0,0-7-7H16V6h3A5,5,0,0,1,24,11Z\" transform=\"translate(0)\"/><path d=\"M11,11H5a3,3,0,0,0-3,3v2H4V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V14A3,3,0,0,0,11,11Z\" transform=\"translate(0)\"/><path d=\"M8,10A4,4,0,1,0,4,6,4,4,0,0,0,8,10ZM8,4A2,2,0,1,1,6,6,2,2,0,0,1,8,4Z\" transform=\"translate(0)\"/><path d=\"M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z\" transform=\"translate(0)\"/><path d=\"M20,20a4,4,0,1,0,4-4A4,4,0,0,0,20,20Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,26,20Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z\"/></svg>",
            "info": {},
            "path": "32/collaborate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Collaborate32",
          "filepath": "collaborate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
                }
              }
            ],
            "name": "collaborate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Collaborate24",
          "filepath": "collaborate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
                }
              }
            ],
            "name": "collaborate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Collaborate20",
          "filepath": "collaborate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
                }
              }
            ],
            "name": "collaborate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Collaborate16",
          "filepath": "collaborate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
                }
              }
            ],
            "name": "collaborate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Collaborate",
        "global": "Collaborate",
        "filepath": "Collaborate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "collapse-all",
      "friendlyName": "Collapse all",
      "aliases": [
        "collapse-all",
        "collapse windows",
        "collapse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/collapse-all.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>collapse-all</title><path d=\"M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z\"/><path d=\"M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z\"/><path d=\"M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z\"/><path d=\"M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z\"/><path d=\"M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z\"/></svg>",
            "info": {},
            "path": "32/collapse-all.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CollapseAll32",
          "filepath": "collapse-all/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
                }
              }
            ],
            "name": "collapse-all",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CollapseAll24",
          "filepath": "collapse-all/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
                }
              }
            ],
            "name": "collapse-all",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CollapseAll20",
          "filepath": "collapse-all/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
                }
              }
            ],
            "name": "collapse-all",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CollapseAll16",
          "filepath": "collapse-all/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
                }
              }
            ],
            "name": "collapse-all",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CollapseAll",
        "global": "CollapseAll",
        "filepath": "CollapseAll.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "collapse-categories",
      "friendlyName": "Collapse categories",
      "aliases": [
        "collapse categories",
        "collapse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/collapse-categories.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>collapse-categories</title><rect x=\"14\" y=\"25\" width=\"14\" height=\"2\"/><polygon points=\"7.17 26 4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26\"/><rect x=\"14\" y=\"15\" width=\"14\" height=\"2\"/><polygon points=\"7.17 16 4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16\"/><rect x=\"14\" y=\"5\" width=\"14\" height=\"2\"/><polygon points=\"7.17 6 4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z\"/></svg>",
            "info": {},
            "path": "32/collapse-categories.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CollapseCategories32",
          "filepath": "collapse-categories/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
                }
              }
            ],
            "name": "collapse-categories",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CollapseCategories24",
          "filepath": "collapse-categories/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
                }
              }
            ],
            "name": "collapse-categories",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CollapseCategories20",
          "filepath": "collapse-categories/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
                }
              }
            ],
            "name": "collapse-categories",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CollapseCategories16",
          "filepath": "collapse-categories/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
                }
              }
            ],
            "name": "collapse-categories",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "CollapseCategories",
        "global": "CollapseCategories",
        "filepath": "CollapseCategories.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "color-palette",
      "friendlyName": "Color palette",
      "aliases": [
        "paint palette",
        "paint",
        "palette"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/color-palette.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>color palette</title><circle cx=\"10\" cy=\"12\" r=\"2\"/><circle cx=\"16\" cy=\"9\" r=\"2\"/><circle cx=\"22\" cy=\"12\" r=\"2\"/><circle cx=\"23\" cy=\"18\" r=\"2\"/><circle cx=\"19\" cy=\"23\" r=\"2\"/><path d=\"M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"12\" r=\"2\"/><circle cx=\"16\" cy=\"9\" r=\"2\"/><circle cx=\"22\" cy=\"12\" r=\"2\"/><circle cx=\"23\" cy=\"18\" r=\"2\"/><circle cx=\"19\" cy=\"23\" r=\"2\"/><path d=\"M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z\"/></svg>",
            "info": {},
            "path": "32/color-palette.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ColorPalette32",
          "filepath": "color-palette/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
                }
              }
            ],
            "name": "color-palette",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ColorPalette24",
          "filepath": "color-palette/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
                }
              }
            ],
            "name": "color-palette",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ColorPalette20",
          "filepath": "color-palette/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
                }
              }
            ],
            "name": "color-palette",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ColorPalette16",
          "filepath": "color-palette/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
                }
              }
            ],
            "name": "color-palette",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ColorPalette",
        "global": "ColorPalette",
        "filepath": "ColorPalette.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "9",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "18",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "19",
                    "cy": "23",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "color-switch",
      "friendlyName": "Color switch",
      "aliases": [
        "color-switch",
        "black and white box",
        "switch color"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/color-switch.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>color-toggle</title><path d=\"M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z\"/></svg>",
            "info": {},
            "path": "32/color-switch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ColorSwitch32",
          "filepath": "color-switch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
                }
              }
            ],
            "name": "color-switch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ColorSwitch24",
          "filepath": "color-switch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
                }
              }
            ],
            "name": "color-switch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ColorSwitch20",
          "filepath": "color-switch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
                }
              }
            ],
            "name": "color-switch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ColorSwitch16",
          "filepath": "color-switch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
                }
              }
            ],
            "name": "color-switch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ColorSwitch",
        "global": "ColorSwitch",
        "filepath": "ColorSwitch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "column",
      "friendlyName": "Column",
      "aliases": [
        "grid",
        "lines",
        "structure"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/column.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>column</title><rect x=\"24\" y=\"4\" width=\"2\" height=\"24\"/><path d=\"M18,6V26H14V6h4m0-2H14a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><rect x=\"6\" y=\"4\" width=\"2\" height=\"24\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z\"/></svg>",
            "info": {},
            "path": "32/column.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Column32",
          "filepath": "column/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z"
                }
              }
            ],
            "name": "column",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Column24",
          "filepath": "column/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z"
                }
              }
            ],
            "name": "column",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Column20",
          "filepath": "column/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z"
                }
              }
            ],
            "name": "column",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Column16",
          "filepath": "column/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z"
                }
              }
            ],
            "name": "column",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Column",
        "global": "Column",
        "filepath": "Column.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "column--delete",
      "friendlyName": "Column delete",
      "aliases": [
        "column",
        "delete",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/column--delete.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41\"/>\n  <path d=\"M24,14V28H18V6H16V28a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V14Z\"/>\n  <path d=\"M10,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,10,30ZM4,8V28h6V8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z\"/><path d=\"M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z\"/></svg>",
            "info": {},
            "path": "32/column--delete.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ColumnDelete32",
          "filepath": "column--delete/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z"
                }
              }
            ],
            "name": "column--delete",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ColumnDelete24",
          "filepath": "column--delete/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z"
                }
              }
            ],
            "name": "column--delete",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ColumnDelete20",
          "filepath": "column--delete/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z"
                }
              }
            ],
            "name": "column--delete",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ColumnDelete16",
          "filepath": "column--delete/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z"
                }
              }
            ],
            "name": "column--delete",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ColumnDelete",
        "global": "ColumnDelete",
        "filepath": "ColumnDelete.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "column--insert",
      "friendlyName": "Column insert",
      "aliases": [
        "column",
        "insert",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/column--insert.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H22a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM22,10V28h6V10Z\"/>\n  <polygon points=\"16 9 21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9\"/>\n  <path d=\"M10,30H4a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,4,8h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,10,30ZM4,10V28h6V10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z\"/></svg>",
            "info": {},
            "path": "32/column--insert.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ColumnInsert32",
          "filepath": "column--insert/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z"
                }
              }
            ],
            "name": "column--insert",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ColumnInsert24",
          "filepath": "column--insert/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z"
                }
              }
            ],
            "name": "column--insert",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ColumnInsert20",
          "filepath": "column--insert/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z"
                }
              }
            ],
            "name": "column--insert",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ColumnInsert16",
          "filepath": "column--insert/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z"
                }
              }
            ],
            "name": "column--insert",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ColumnInsert",
        "global": "ColumnInsert",
        "filepath": "ColumnInsert.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "column-dependency",
      "friendlyName": "Column dependency",
      "aliases": [
        "column",
        "dependency",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/column-dependency.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z\"/></svg>",
            "info": {},
            "path": "32/column-dependency.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ColumnDependency32",
          "filepath": "column-dependency/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
                }
              }
            ],
            "name": "column-dependency",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ColumnDependency24",
          "filepath": "column-dependency/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
                }
              }
            ],
            "name": "column-dependency",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ColumnDependency20",
          "filepath": "column-dependency/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
                }
              }
            ],
            "name": "column-dependency",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ColumnDependency16",
          "filepath": "column-dependency/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
                }
              }
            ],
            "name": "column-dependency",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ColumnDependency",
        "global": "ColumnDependency",
        "filepath": "ColumnDependency.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "commit",
      "friendlyName": "Commit",
      "aliases": [
        "commit",
        "operation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/commit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z\"/></svg>",
            "info": {},
            "path": "32/commit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Commit32",
          "filepath": "commit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              }
            ],
            "name": "commit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Commit24",
          "filepath": "commit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              }
            ],
            "name": "commit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Commit20",
          "filepath": "commit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              }
            ],
            "name": "commit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Commit16",
          "filepath": "commit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              }
            ],
            "name": "commit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Commit",
        "global": "Commit",
        "filepath": "Commit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "communication--unified",
      "friendlyName": "Communication unified",
      "aliases": [
        "systems",
        "communication",
        "unified",
        "chat",
        "video",
        "email",
        "phone",
        "voice"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/communication--unified.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,17H18a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h4V25H18V19H28v6H25.4648l-2.5937,3.8906L24.5352,30l2-3H28a2.0025,2.0025,0,0,0,2-2V19A2.0025,2.0025,0,0,0,28,17Z\"/>\n  <path d=\"M8.6667,24.1086l.8614-.8615a.8334.8334,0,0,1,.8988-.1844l1.0493.42A.8334.8334,0,0,1,12,24.2561v1.9082a.8334.8334,0,0,1-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316,0,0,1,2.8343,17H4.7085a.8335.8335,0,0,1,.7737.5238l.42,1.0493a.8332.8332,0,0,1-.1845.8988l-.8614.8614A4.5267,4.5267,0,0,0,8.6667,24.1086Z\"/>\n  <rect x=\"21\" y=\"9\" width=\"7\" height=\"2\"/>\n  <rect x=\"21\" y=\"5\" width=\"9\" height=\"2\"/>\n  <path d=\"M17,6,14,8.2V6a2.0024,2.0024,0,0,0-2-2H4A2.0024,2.0024,0,0,0,2,6v6a2.0024,2.0024,0,0,0,2,2h8a2.0024,2.0024,0,0,0,2-2V9.8L17,12ZM4,12V6h8v6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z\"/></svg>",
            "info": {},
            "path": "32/communication--unified.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CommunicationUnified32",
          "filepath": "communication--unified/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z"
                }
              }
            ],
            "name": "communication--unified",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CommunicationUnified24",
          "filepath": "communication--unified/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z"
                }
              }
            ],
            "name": "communication--unified",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CommunicationUnified20",
          "filepath": "communication--unified/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z"
                }
              }
            ],
            "name": "communication--unified",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CommunicationUnified16",
          "filepath": "communication--unified/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z"
                }
              }
            ],
            "name": "communication--unified",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "CommunicationUnified",
        "global": "CommunicationUnified",
        "filepath": "CommunicationUnified.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "compare",
      "friendlyName": "Compare",
      "aliases": [
        "arrows",
        "exchange",
        "merge",
        "match",
        "files",
        "documents"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/compare.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>compare</title><path d=\"M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z\"/></svg>",
            "info": {},
            "path": "32/compare.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Compare32",
          "filepath": "compare/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
                }
              }
            ],
            "name": "compare",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Compare24",
          "filepath": "compare/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
                }
              }
            ],
            "name": "compare",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Compare20",
          "filepath": "compare/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
                }
              }
            ],
            "name": "compare",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Compare16",
          "filepath": "compare/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
                }
              }
            ],
            "name": "compare",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Compare",
        "global": "Compare",
        "filepath": "Compare.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "compass",
      "friendlyName": "Compass",
      "aliases": [
        "direction",
        "navigation",
        "explore",
        "navigate",
        "destination",
        "guide"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/compass.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>compass</title><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/><path d=\"M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z\"/><circle cx=\"16\" cy=\"7.5\" r=\"1.5\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/><path d=\"M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z\"/><circle cx=\"16\" cy=\"7.5\" r=\"1.5\"/></svg>",
            "info": {},
            "path": "32/compass.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Compass32",
          "filepath": "compass/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "compass",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Compass24",
          "filepath": "compass/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "compass",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Compass20",
          "filepath": "compass/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "compass",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Compass16",
          "filepath": "compass/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7.5",
                  "r": "1.5"
                }
              }
            ],
            "name": "compass",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Compass",
        "global": "Compass",
        "filepath": "Compass.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "7.5",
                    "r": "1.5"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "composer-edit",
      "friendlyName": "Composer edit",
      "aliases": [
        "Q",
        "circuit",
        "composer",
        "edit"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/composer-edit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>composer-edit</title><path d=\"M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z\"/></svg>",
            "info": {},
            "path": "32/Q/composer-edit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QComposerEdit32",
          "filepath": "Q/composer-edit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
                }
              }
            ],
            "name": "composer-edit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QComposerEdit24",
          "filepath": "Q/composer-edit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
                }
              }
            ],
            "name": "composer-edit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QComposerEdit20",
          "filepath": "Q/composer-edit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
                }
              }
            ],
            "name": "composer-edit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QComposerEdit16",
          "filepath": "Q/composer-edit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
                }
              }
            ],
            "name": "composer-edit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "ComposerEdit",
        "global": "QComposerEdit",
        "filepath": "Q/ComposerEdit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "concept",
      "friendlyName": "Concept",
      "aliases": [
        "concept",
        "idea"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/concept.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>concept</title><path d=\"M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z\"/></svg>",
            "info": {},
            "path": "32/concept.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Concept32",
          "filepath": "concept/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
                }
              }
            ],
            "name": "concept",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Concept24",
          "filepath": "concept/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
                }
              }
            ],
            "name": "concept",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Concept20",
          "filepath": "concept/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
                }
              }
            ],
            "name": "concept",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Concept16",
          "filepath": "concept/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
                }
              }
            ],
            "name": "concept",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Concept",
        "global": "Concept",
        "filepath": "Concept.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "condition--point",
      "friendlyName": "Condition point",
      "aliases": [
        "point",
        "condition",
        "status",
        "state"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/condition--point.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"10.3431\" y=\"10.3431\" width=\"11.3137\" height=\"11.3137\" transform=\"translate(-6.6274 16) rotate(-45)\"/>\n  <path d=\"M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10.343 10.343H21.657V21.657H10.343z\" transform=\"rotate(-45 16 16)\"/><path d=\"M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z\"/></svg>",
            "info": {},
            "path": "32/condition--point.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConditionPoint32",
          "filepath": "condition--point/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
                }
              }
            ],
            "name": "condition--point",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConditionPoint24",
          "filepath": "condition--point/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
                }
              }
            ],
            "name": "condition--point",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConditionPoint20",
          "filepath": "condition--point/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
                }
              }
            ],
            "name": "condition--point",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConditionPoint16",
          "filepath": "condition--point/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
                }
              }
            ],
            "name": "condition--point",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "ConditionPoint",
        "global": "ConditionPoint",
        "filepath": "ConditionPoint.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.343 10.343H21.657V21.657H10.343z",
                    "transform": "rotate(-45 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "condition--wait-point",
      "friendlyName": "Condition wait point",
      "aliases": [
        "condition",
        "point",
        "wait",
        "status",
        "waiting",
        "state"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/condition--wait-point.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"10.3431\" y=\"10.3431\" width=\"11.3137\" height=\"11.3137\" transform=\"translate(-6.6274 16) rotate(-45)\"/>\n  <path d=\"M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10.343 10.343H21.657V21.657H10.343z\" transform=\"rotate(-45 16 16)\"/><path d=\"M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/condition--wait-point.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConditionWaitPoint32",
          "filepath": "condition--wait-point/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "condition--wait-point",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConditionWaitPoint24",
          "filepath": "condition--wait-point/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "condition--wait-point",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConditionWaitPoint20",
          "filepath": "condition--wait-point/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "condition--wait-point",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConditionWaitPoint16",
          "filepath": "condition--wait-point/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.343 10.343H21.657V21.657H10.343z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "condition--wait-point",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "ConditionWaitPoint",
        "global": "ConditionWaitPoint",
        "filepath": "ConditionWaitPoint.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.343 10.343H21.657V21.657H10.343z",
                    "transform": "rotate(-45 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connect",
      "friendlyName": "Connect",
      "aliases": [
        "network",
        "link",
        "join",
        "attach",
        "associate"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connect.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>connect</title><path d=\"M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z\" transform=\"translate(0 0.01)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z\" transform=\"translate(0 .01)\"/></svg>",
            "info": {},
            "path": "32/connect.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Connect32",
          "filepath": "connect/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
                  "transform": "translate(0 .01)"
                }
              }
            ],
            "name": "connect",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Connect24",
          "filepath": "connect/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
                  "transform": "translate(0 .01)"
                }
              }
            ],
            "name": "connect",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Connect20",
          "filepath": "connect/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
                  "transform": "translate(0 .01)"
                }
              }
            ],
            "name": "connect",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Connect16",
          "filepath": "connect/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
                  "transform": "translate(0 .01)"
                }
              }
            ],
            "name": "connect",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Connect",
        "global": "Connect",
        "filepath": "Connect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
                    "transform": "translate(0 .01)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connect--recursive",
      "friendlyName": "Connect recursive",
      "aliases": [
        "connection",
        "recursive"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connect--recursive.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z\"/></svg>",
            "info": {},
            "path": "32/connect--recursive.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectRecursive32",
          "filepath": "connect--recursive/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
                }
              }
            ],
            "name": "connect--recursive",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectRecursive24",
          "filepath": "connect--recursive/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
                }
              }
            ],
            "name": "connect--recursive",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectRecursive20",
          "filepath": "connect--recursive/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
                }
              }
            ],
            "name": "connect--recursive",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectRecursive16",
          "filepath": "connect--recursive/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
                }
              }
            ],
            "name": "connect--recursive",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ConnectRecursive",
        "global": "ConnectRecursive",
        "filepath": "ConnectRecursive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connect--reference",
      "friendlyName": "connect--reference",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connect--reference.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z\"/><path d=\"M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z\"/></svg>",
            "info": {},
            "path": "32/connect--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectReference32",
          "filepath": "connect--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
                }
              }
            ],
            "name": "connect--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectReference24",
          "filepath": "connect--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
                }
              }
            ],
            "name": "connect--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectReference20",
          "filepath": "connect--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
                }
              }
            ],
            "name": "connect--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectReference16",
          "filepath": "connect--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
                }
              }
            ],
            "name": "connect--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ConnectReference",
        "global": "ConnectReference",
        "filepath": "ConnectReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connect--source",
      "friendlyName": "Connect source",
      "aliases": [
        "connection",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connect--source.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z\"/></svg>",
            "info": {},
            "path": "32/connect--source.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectSource32",
          "filepath": "connect--source/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
                }
              }
            ],
            "name": "connect--source",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectSource24",
          "filepath": "connect--source/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
                }
              }
            ],
            "name": "connect--source",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectSource20",
          "filepath": "connect--source/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
                }
              }
            ],
            "name": "connect--source",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectSource16",
          "filepath": "connect--source/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
                }
              }
            ],
            "name": "connect--source",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ConnectSource",
        "global": "ConnectSource",
        "filepath": "ConnectSource.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connect--target",
      "friendlyName": "Connect target",
      "aliases": [
        "connection",
        "target"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connect--target.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"28\" y=\"2\" width=\"2\" height=\"28\"/>\n  <path d=\"M20,10l-1.4141,1.4141L22.1719,15H11.8989a5,5,0,1,0,0,2h10.273l-3.586,3.5859L20,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z\"/></svg>",
            "info": {},
            "path": "32/connect--target.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectTarget32",
          "filepath": "connect--target/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z"
                }
              }
            ],
            "name": "connect--target",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectTarget24",
          "filepath": "connect--target/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z"
                }
              }
            ],
            "name": "connect--target",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectTarget20",
          "filepath": "connect--target/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z"
                }
              }
            ],
            "name": "connect--target",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectTarget16",
          "filepath": "connect--target/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z"
                }
              }
            ],
            "name": "connect--target",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ConnectTarget",
        "global": "ConnectTarget",
        "filepath": "ConnectTarget.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connection--receive",
      "friendlyName": "Connection receive",
      "aliases": [
        "connection",
        "receive",
        "incoming",
        "input"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connection--receive.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"8\" width=\"2\" height=\"4\"/>\n  <rect x=\"8\" y=\"14\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"8\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"14\" width=\"2\" height=\"4\"/>\n  <rect x=\"8\" y=\"20\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"20\" width=\"2\" height=\"4\"/>\n  <polygon points=\"30 14 21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14\"/>\n  <path d=\"M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z\"/><path d=\"M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z\"/></svg>",
            "info": {},
            "path": "32/connection--receive.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectionReceive32",
          "filepath": "connection--receive/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--receive",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectionReceive24",
          "filepath": "connection--receive/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--receive",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectionReceive20",
          "filepath": "connection--receive/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--receive",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectionReceive16",
          "filepath": "connection--receive/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--receive",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "ConnectionReceive",
        "global": "ConnectionReceive",
        "filepath": "ConnectionReceive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connection--send",
      "friendlyName": "Connection send",
      "aliases": [
        "connection",
        "send",
        "outgoing",
        "output"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connection--send.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"8\" width=\"2\" height=\"4\"/>\n  <rect x=\"8\" y=\"14\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"8\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"14\" width=\"2\" height=\"4\"/>\n  <rect x=\"8\" y=\"20\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"20\" width=\"2\" height=\"4\"/>\n  <polygon points=\"18 14 26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14\"/>\n  <path d=\"M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z\"/><path d=\"M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z\"/></svg>",
            "info": {},
            "path": "32/connection--send.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectionSend32",
          "filepath": "connection--send/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--send",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectionSend24",
          "filepath": "connection--send/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--send",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectionSend20",
          "filepath": "connection--send/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--send",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectionSend16",
          "filepath": "connection--send/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                }
              }
            ],
            "name": "connection--send",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "ConnectionSend",
        "global": "ConnectionSend",
        "filepath": "ConnectionSend.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connection--two-way",
      "friendlyName": "Connection two-way",
      "aliases": [
        "connection",
        "input",
        "output"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connection--two-way.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"8\" width=\"2\" height=\"4\"/>\n  <rect x=\"8\" y=\"14\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"8\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"14\" width=\"2\" height=\"4\"/>\n  <rect x=\"8\" y=\"20\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"20\" width=\"2\" height=\"4\"/>\n  <polygon points=\"30 22 21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22\"/>\n  <polygon points=\"19 12 27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12\"/>\n  <path d=\"M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z\"/><path d=\"M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z\"/></svg>",
            "info": {},
            "path": "32/connection--two-way.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectionTwoWay32",
          "filepath": "connection--two-way/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
                }
              }
            ],
            "name": "connection--two-way",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectionTwoWay24",
          "filepath": "connection--two-way/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
                }
              }
            ],
            "name": "connection--two-way",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectionTwoWay20",
          "filepath": "connection--two-way/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
                }
              }
            ],
            "name": "connection--two-way",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectionTwoWay16",
          "filepath": "connection--two-way/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
                }
              }
            ],
            "name": "connection--two-way",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "ConnectionTwoWay",
        "global": "ConnectionTwoWay",
        "filepath": "ConnectionTwoWay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connection-signal",
      "friendlyName": "Connection signal",
      "aliases": [
        "signal",
        "tower",
        "service",
        "station",
        "radio",
        "connection",
        "wireless",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connection-signal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mobile-data</title><rect x=\"15\" y=\"12\" width=\"2\" height=\"18\"/><path d=\"M11.33,18.22a7,7,0,0,1,0-10.44l1.34,1.49a5,5,0,0,0,0,7.46Z\"/><path d=\"M20.67,18.22l-1.34-1.49a5,5,0,0,0,0-7.46l1.34-1.49a7,7,0,0,1,0,10.44Z\"/><path d=\"M8.4,21.8a11,11,0,0,1,0-17.6L9.6,5.8a9,9,0,0,0,0,14.4Z\"/><path d=\"M23.6,21.8l-1.2-1.6a9,9,0,0,0,0-14.4l1.2-1.6a11,11,0,0,1,0,17.6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z\"/><path d=\"M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z\"/></svg>",
            "info": {},
            "path": "32/connection-signal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectionSignal32",
          "filepath": "connection-signal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z"
                }
              }
            ],
            "name": "connection-signal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectionSignal24",
          "filepath": "connection-signal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z"
                }
              }
            ],
            "name": "connection-signal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectionSignal20",
          "filepath": "connection-signal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z"
                }
              }
            ],
            "name": "connection-signal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectionSignal16",
          "filepath": "connection-signal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z"
                }
              }
            ],
            "name": "connection-signal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "ConnectionSignal",
        "global": "ConnectionSignal",
        "filepath": "ConnectionSignal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "connection-signal--off",
      "friendlyName": "Connection signal off",
      "aliases": [
        "signal",
        "tower",
        "service",
        "station",
        "radio",
        "connection",
        "wireless",
        "network",
        "off",
        "signal loss"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/connection-signal--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z\"/>\n  <path d=\"M21,13a5.0022,5.0022,0,0,1-.9023,2.8564l1.4277,1.4278a6.9831,6.9831,0,0,0-.8584-9.5015l-1.334,1.49A5.0077,5.0077,0,0,1,21,13Z\"/>\n  <path d=\"M30,28.5859,3.4143,2,2,3.4141l3.71,3.71A10.9824,10.9824,0,0,0,8.3994,21.8008l1.2012-1.6A8.9678,8.9678,0,0,1,7.1714,8.5854l2.1963,2.1963a6.9664,6.9664,0,0,0,1.9648,7.4351l1.334-1.49A5.0072,5.0072,0,0,1,11,13a4.8854,4.8854,0,0,1,.0393-.5464L15,16.4141V30h2V18.4141L28.5857,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z\"/><path d=\"M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z\"/></svg>",
            "info": {},
            "path": "32/connection-signal--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConnectionSignalOff32",
          "filepath": "connection-signal--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z"
                }
              }
            ],
            "name": "connection-signal--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConnectionSignalOff24",
          "filepath": "connection-signal--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z"
                }
              }
            ],
            "name": "connection-signal--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConnectionSignalOff20",
          "filepath": "connection-signal--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z"
                }
              }
            ],
            "name": "connection-signal--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConnectionSignalOff16",
          "filepath": "connection-signal--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z"
                }
              }
            ],
            "name": "connection-signal--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "ConnectionSignalOff",
        "global": "ConnectionSignalOff",
        "filepath": "ConnectionSignalOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "construction",
      "friendlyName": "Construction",
      "aliases": [
        "construction",
        "transportation",
        "travel",
        "roadwork"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/construction.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.34,16.06a1.0007,1.0007,0,0,0-1.1084.3L24.46,20.8857l-5.4355-.9882-3.602-8.9512A3.014,3.014,0,0,0,12.6138,9h-4.06A3.0018,3.0018,0,0,0,7.01,9.4277L2,12.4336v6.4009l5,.9092V30H9V20.1074l3.5652.648L14,24.2V30h2V23.8l-1.0911-2.6182L22.99,22.6509,18.2319,28.36A1,1,0,0,0,19,30H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.34,16.06ZM4,17.1655V13.5664l3-1.8v5.9448Zm5,.9092V11h3.6138a1.0141,1.0141,0,0,1,.9453.6709l3.14,7.8037ZM28,28H21.1353L28,19.7617Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M12.5,8A3.5,3.5,0,1,1,16,4.5,3.5042,3.5042,0,0,1,12.5,8Zm0-5A1.5,1.5,0,1,0,14,4.5,1.5017,1.5017,0,0,0,12.5,3Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z\"/></svg>",
            "info": {},
            "path": "32/construction.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Construction32",
          "filepath": "construction/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z"
                }
              }
            ],
            "name": "construction",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Construction24",
          "filepath": "construction/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z"
                }
              }
            ],
            "name": "construction",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Construction20",
          "filepath": "construction/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z"
                }
              }
            ],
            "name": "construction",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Construction16",
          "filepath": "construction/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z"
                }
              }
            ],
            "name": "construction",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Construction",
        "global": "Construction",
        "filepath": "Construction.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "container-registry",
      "friendlyName": "Container registry",
      "aliases": [
        "container",
        "registry",
        "Kubernetes",
        "cloud",
        "directory"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/container-registry.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,11H19V2h9ZM21,9h5V4H21Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z\"/><path d=\"M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/container-registry.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContainerRegistry32",
          "filepath": "container-registry/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "container-registry",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContainerRegistry24",
          "filepath": "container-registry/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "container-registry",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContainerRegistry20",
          "filepath": "container-registry/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "container-registry",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContainerRegistry16",
          "filepath": "container-registry/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "container-registry",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ContainerRegistry",
        "global": "ContainerRegistry",
        "filepath": "ContainerRegistry.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "container-services",
      "friendlyName": "Container services",
      "aliases": [
        "container",
        "registry",
        "Kubernetes",
        "cloud",
        "services",
        "network",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/container-services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z\"/></svg>",
            "info": {},
            "path": "32/container-services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContainerServices32",
          "filepath": "container-services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
                }
              }
            ],
            "name": "container-services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContainerServices24",
          "filepath": "container-services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
                }
              }
            ],
            "name": "container-services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContainerServices20",
          "filepath": "container-services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
                }
              }
            ],
            "name": "container-services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContainerServices16",
          "filepath": "container-services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
                }
              }
            ],
            "name": "container-services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ContainerServices",
        "global": "ContainerServices",
        "filepath": "ContainerServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "container-software",
      "friendlyName": "Container software",
      "aliases": [
        "container-software",
        "software container"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/container-software.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>container-software</title><path d=\"M28,12H20V4h8Zm-6-2h4V6H22Z\"/><path d=\"M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,12H20V4h8Zm-6-2h4V6H22Z\"/><path d=\"M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/container-software.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContainerSoftware32",
          "filepath": "container-software/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H20V4h8Zm-6-2h4V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "container-software",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContainerSoftware24",
          "filepath": "container-software/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H20V4h8Zm-6-2h4V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "container-software",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContainerSoftware20",
          "filepath": "container-software/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H20V4h8Zm-6-2h4V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "container-software",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContainerSoftware16",
          "filepath": "container-software/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H20V4h8Zm-6-2h4V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z"
                }
              }
            ],
            "name": "container-software",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ContainerSoftware",
        "global": "ContainerSoftware",
        "filepath": "ContainerSoftware.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12H20V4h8Zm-6-2h4V6H22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "content-delivery-network",
      "friendlyName": "IBM Cloud® Content Delivery Network",
      "aliases": [
        "content",
        "cloud",
        "delivery",
        "network",
        "app",
        "application",
        "interface",
        "software"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/content-delivery-network.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"21\" cy=\"21\" r=\"2\"/>\n  <circle cx=\"7\" cy=\"7\" r=\"2\"/>\n  <path d=\"M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"21\" cy=\"21\" r=\"2\"/><circle cx=\"7\" cy=\"7\" r=\"2\"/><path d=\"M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z\"/><path d=\"M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z\"/></svg>",
            "info": {},
            "path": "32/content-delivery-network.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContentDeliveryNetwork32",
          "filepath": "content-delivery-network/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z"
                }
              }
            ],
            "name": "content-delivery-network",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContentDeliveryNetwork24",
          "filepath": "content-delivery-network/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z"
                }
              }
            ],
            "name": "content-delivery-network",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContentDeliveryNetwork20",
          "filepath": "content-delivery-network/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z"
                }
              }
            ],
            "name": "content-delivery-network",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContentDeliveryNetwork16",
          "filepath": "content-delivery-network/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z"
                }
              }
            ],
            "name": "content-delivery-network",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "ContentDeliveryNetwork",
        "global": "ContentDeliveryNetwork",
        "filepath": "ContentDeliveryNetwork.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "21",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "7",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "content-view",
      "friendlyName": "Content view",
      "aliases": [
        "content",
        "view",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/content-view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"19\" r=\"2\"/>\n  <path d=\"M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z\"/>\n  <path d=\"M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"19\" r=\"2\"/><path d=\"M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z\"/><path d=\"M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z\"/></svg>",
            "info": {},
            "path": "32/content-view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContentView32",
          "filepath": "content-view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z"
                }
              }
            ],
            "name": "content-view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContentView24",
          "filepath": "content-view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z"
                }
              }
            ],
            "name": "content-view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContentView20",
          "filepath": "content-view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z"
                }
              }
            ],
            "name": "content-view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContentView16",
          "filepath": "content-view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z"
                }
              }
            ],
            "name": "content-view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ContentView",
        "global": "ContentView",
        "filepath": "ContentView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "19",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "continue",
      "friendlyName": "Continue",
      "aliases": [
        "actions",
        "continue",
        "resume"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/continue.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.501-.8652l19,11a1,1,0,0,1,0,1.73l-19,11A.9975.9975,0,0,1,10,28ZM11,6.7344V25.2656L27,16Z\"/>\n  <rect x=\"4\" y=\"4\" width=\"2\" height=\"24\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z\"/></svg>",
            "info": {},
            "path": "32/continue.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Continue32",
          "filepath": "continue/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Continue24",
          "filepath": "continue/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Continue20",
          "filepath": "continue/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Continue16",
          "filepath": "continue/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Continue",
        "global": "Continue",
        "filepath": "Continue.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "continue--filled",
      "friendlyName": "Continue filled",
      "aliases": [
        "actions",
        "continue",
        "resume",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/continue--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.501-.8652l19,11a1,1,0,0,1,0,1.73l-19,11A.9975.9975,0,0,1,10,28Z\"/>\n  <rect x=\"4\" y=\"4\" width=\"2\" height=\"24\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z\"/></svg>",
            "info": {},
            "path": "32/continue--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContinueFilled32",
          "filepath": "continue--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContinueFilled24",
          "filepath": "continue--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContinueFilled20",
          "filepath": "continue--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContinueFilled16",
          "filepath": "continue--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z"
                }
              }
            ],
            "name": "continue--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "ContinueFilled",
        "global": "ContinueFilled",
        "filepath": "ContinueFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "continuous-deployment",
      "friendlyName": "continuous-deployment",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/continuous-deployment.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8\n\ts-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6\n\ts-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8\ts-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6\ts-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z\"/></svg>",
            "info": {},
            "path": "32/continuous-deployment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContinuousDeployment32",
          "filepath": "continuous-deployment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8\ts-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6\ts-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z"
                }
              }
            ],
            "name": "continuous-deployment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContinuousDeployment24",
          "filepath": "continuous-deployment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8\ts-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6\ts-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z"
                }
              }
            ],
            "name": "continuous-deployment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContinuousDeployment20",
          "filepath": "continuous-deployment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8\ts-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6\ts-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z"
                }
              }
            ],
            "name": "continuous-deployment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContinuousDeployment16",
          "filepath": "continuous-deployment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8\ts-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6\ts-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z"
                }
              }
            ],
            "name": "continuous-deployment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ContinuousDeployment",
        "global": "ContinuousDeployment",
        "filepath": "ContinuousDeployment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8 s-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6 s-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "continuous-integration",
      "friendlyName": "continuous-integration",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/continuous-integration.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10\n\tC6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z\n\t M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z\n\t M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10\tC6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z\"/></svg>",
            "info": {},
            "path": "32/continuous-integration.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ContinuousIntegration32",
          "filepath": "continuous-integration/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10\tC6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z"
                }
              }
            ],
            "name": "continuous-integration",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ContinuousIntegration24",
          "filepath": "continuous-integration/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10\tC6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z"
                }
              }
            ],
            "name": "continuous-integration",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ContinuousIntegration20",
          "filepath": "continuous-integration/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10\tC6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z"
                }
              }
            ],
            "name": "continuous-integration",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ContinuousIntegration16",
          "filepath": "continuous-integration/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10\tC6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z"
                }
              }
            ],
            "name": "continuous-integration",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ContinuousIntegration",
        "global": "ContinuousIntegration",
        "filepath": "ContinuousIntegration.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10 C6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "contour--draw",
      "friendlyName": "Contour draw",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "contour",
        "outline",
        "imaging",
        "drawing",
        "draw"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/contour--draw.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #090909;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M7.7,4.7a14.7029,14.7029,0,0,0-3,3.1L6.3,9A13.2634,13.2634,0,0,1,8.9,6.3Z\"/>\n  <path class=\"cls-1\" d=\"M4.6,12.3l-1.9-.6A12.5111,12.5111,0,0,0,2,16H4A11.4756,11.4756,0,0,1,4.6,12.3Z\"/>\n  <path class=\"cls-1\" d=\"M11.7,2.7l.6,1.9A11.4756,11.4756,0,0,1,16,4V2A12.5111,12.5111,0,0,0,11.7,2.7Z\"/>\n  <path class=\"cls-1\" d=\"M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.526,11.526,0,0,1,23,25.7Z\"/>\n  <path class=\"cls-1\" d=\"M27.4,19.7l1.9.6A15.4747,15.4747,0,0,0,30,16H28A11.4756,11.4756,0,0,1,27.4,19.7Z\"/>\n  <path class=\"cls-1\" d=\"M29.2,11.6a14.4029,14.4029,0,0,0-2-3.9L25.6,8.9a12.8867,12.8867,0,0,1,1.7,3.3Z\"/>\n  <path class=\"cls-1\" d=\"M24.1,4.6a14.4029,14.4029,0,0,0-3.9-2l-.6,1.9a12.8867,12.8867,0,0,1,3.3,1.7Z\"/>\n  <path class=\"cls-1\" d=\"M20.3,29.3l-.6-1.9A11.4756,11.4756,0,0,1,16,28v2A21.4206,21.4206,0,0,0,20.3,29.3Z\"/>\n  <path d=\"M15.4023,24.248a11.9488,11.9488,0,0,0-1.7182-3.3354L15.2974,19.73a13.9486,13.9486,0,0,1,2.0044,3.893Z\"/>\n  <path d=\"M11.02,18.2668a11.9215,11.9215,0,0,0-3.3467-1.6943l.6114-1.9043a13.9242,13.9242,0,0,1,3.9072,1.978Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z\"/></svg>",
            "info": {},
            "path": "32/watson-health/contour--draw.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthContourDraw32",
          "filepath": "watson-health/contour--draw/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--draw",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthContourDraw24",
          "filepath": "watson-health/contour--draw/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--draw",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthContourDraw20",
          "filepath": "watson-health/contour--draw/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--draw",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthContourDraw16",
          "filepath": "watson-health/contour--draw/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--draw",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ContourDraw",
        "global": "WatsonHealthContourDraw",
        "filepath": "watson-health/ContourDraw.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "contour--edit",
      "friendlyName": "Contour edit",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "contour",
        "outline",
        "imaging",
        "editing",
        "edit"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/contour--edit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #090909;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,30V28A12.0021,12.0021,0,0,0,19.6924,4.5786l.6152-1.9033A14.0022,14.0022,0,0,1,16,30Z\"/>\n  <path class=\"cls-1\" d=\"M7.7,4.7a14.7029,14.7029,0,0,0-3,3.1L6.3,9A13.2634,13.2634,0,0,1,8.9,6.3Z\"/>\n  <path class=\"cls-1\" d=\"M4.6,12.3l-1.9-.6A12.5111,12.5111,0,0,0,2,16H4A11.4756,11.4756,0,0,1,4.6,12.3Z\"/>\n  <path class=\"cls-1\" d=\"M11.7,2.7l.6,1.9A11.4756,11.4756,0,0,1,16,4V2A12.5111,12.5111,0,0,0,11.7,2.7Z\"/>\n  <path d=\"M15.4023,24.248a11.9488,11.9488,0,0,0-1.7182-3.3354L15.2974,19.73a13.9486,13.9486,0,0,1,2.0044,3.893Z\"/>\n  <path d=\"M11.02,18.2668a11.9215,11.9215,0,0,0-3.3467-1.6943l.6114-1.9043a13.9242,13.9242,0,0,1,3.9072,1.978Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z\"/><path d=\"M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z\"/></svg>",
            "info": {},
            "path": "32/watson-health/contour--edit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthContourEdit32",
          "filepath": "watson-health/contour--edit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--edit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthContourEdit24",
          "filepath": "watson-health/contour--edit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--edit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthContourEdit20",
          "filepath": "watson-health/contour--edit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--edit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthContourEdit16",
          "filepath": "watson-health/contour--edit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                }
              }
            ],
            "name": "contour--edit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ContourEdit",
        "global": "WatsonHealthContourEdit",
        "filepath": "watson-health/ContourEdit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "contour-finding",
      "friendlyName": "Contour finding",
      "aliases": [
        "watson health",
        "watson",
        "health",
        "contour",
        "finding"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/contour-finding.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #090909;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M7.7,4.7a14.7029,14.7029,0,0,0-3,3.1L6.3,9A13.2634,13.2634,0,0,1,8.9,6.3Z\"/>\n  <path class=\"cls-1\" d=\"M4.6,12.3l-1.9-.6A12.5111,12.5111,0,0,0,2,16H4A11.4756,11.4756,0,0,1,4.6,12.3Z\"/>\n  <path class=\"cls-1\" d=\"M2.7,20.4a14.4029,14.4029,0,0,0,2,3.9l1.6-1.2a12.8867,12.8867,0,0,1-1.7-3.3Z\"/>\n  <path class=\"cls-1\" d=\"M7.8,27.3a14.4029,14.4029,0,0,0,3.9,2l.6-1.9A12.8867,12.8867,0,0,1,9,25.7Z\"/>\n  <path class=\"cls-1\" d=\"M11.7,2.7l.6,1.9A11.4756,11.4756,0,0,1,16,4V2A12.5111,12.5111,0,0,0,11.7,2.7Z\"/>\n  <path class=\"cls-1\" d=\"M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.526,11.526,0,0,1,23,25.7Z\"/>\n  <path class=\"cls-1\" d=\"M27.4,19.7l1.9.6A15.4747,15.4747,0,0,0,30,16H28A11.4756,11.4756,0,0,1,27.4,19.7Z\"/>\n  <path class=\"cls-1\" d=\"M29.2,11.6a14.4029,14.4029,0,0,0-2-3.9L25.6,8.9a12.8867,12.8867,0,0,1,1.7,3.3Z\"/>\n  <path class=\"cls-1\" d=\"M24.1,4.6a14.4029,14.4029,0,0,0-3.9-2l-.6,1.9a12.8867,12.8867,0,0,1,3.3,1.7Z\"/>\n  <path class=\"cls-1\" d=\"M20.3,29.3l-.6-1.9A11.4756,11.4756,0,0,1,16,28v2A21.4206,21.4206,0,0,0,20.3,29.3Z\"/>\n  <path class=\"cls-1\" d=\"M16,26A10,10,0,1,1,26,16,10.0115,10.0115,0,0,1,16,26ZM16,8a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,8Z\"/>\n  <rect id=\"_Transparent_Rectangle\" data-name=\" Transparent Rectangle\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/contour-finding.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthContourFinding32",
          "filepath": "watson-health/contour-finding/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z"
                }
              }
            ],
            "name": "contour-finding",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthContourFinding24",
          "filepath": "watson-health/contour-finding/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z"
                }
              }
            ],
            "name": "contour-finding",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthContourFinding20",
          "filepath": "watson-health/contour-finding/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z"
                }
              }
            ],
            "name": "contour-finding",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthContourFinding16",
          "filepath": "watson-health/contour-finding/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z"
                }
              }
            ],
            "name": "contour-finding",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ContourFinding",
        "global": "WatsonHealthContourFinding",
        "filepath": "watson-health/ContourFinding.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "contrast",
      "friendlyName": "Contrast",
      "aliases": [
        "brightness",
        "darkness",
        "sun",
        "light",
        "dark",
        "comparison"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/contrast.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>contrast</title><path d=\"M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z\"/></svg>",
            "info": {},
            "path": "32/contrast.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Contrast32",
          "filepath": "contrast/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z"
                }
              }
            ],
            "name": "contrast",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Contrast24",
          "filepath": "contrast/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z"
                }
              }
            ],
            "name": "contrast",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Contrast20",
          "filepath": "contrast/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z"
                }
              }
            ],
            "name": "contrast",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Contrast16",
          "filepath": "contrast/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z"
                }
              }
            ],
            "name": "contrast",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Contrast",
        "global": "Contrast",
        "filepath": "Contrast.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "convert-to-cloud",
      "friendlyName": "Convert to cloud",
      "aliases": [
        "convert",
        "push",
        "send"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/convert-to-cloud.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26.5,12H19a4,4,0,0,1,0-8h.0835A4.7864,4.7864,0,0,1,23,2a4.9816,4.9816,0,0,1,4.6543,3.2034A3.4667,3.4667,0,0,1,30,8.5,3.5041,3.5041,0,0,1,26.5,12ZM19,6a2,2,0,0,0,0,4h7.5A1.5017,1.5017,0,0,0,28,8.5a1.4855,1.4855,0,0,0-1.2778-1.4739L26.061,6.927l-.1616-.6487a2.9568,2.9568,0,0,0-5.4873-.7121L20.1143,6Z\"/>\n  <path d=\"M23,14l-5,5,1.4141,1.4141L22,17.8325V24H16v2h6a2.0025,2.0025,0,0,0,2-2V17.8325l2.5874,2.583L28,19Z\"/>\n  <rect x=\"2\" y=\"20\" width=\"10\" height=\"2\"/>\n  <rect x=\"2\" y=\"24\" width=\"10\" height=\"2\"/>\n  <rect x=\"2\" y=\"28\" width=\"10\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z\"/></svg>",
            "info": {},
            "path": "32/convert-to-cloud.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ConvertToCloud32",
          "filepath": "convert-to-cloud/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z"
                }
              }
            ],
            "name": "convert-to-cloud",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ConvertToCloud24",
          "filepath": "convert-to-cloud/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z"
                }
              }
            ],
            "name": "convert-to-cloud",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ConvertToCloud20",
          "filepath": "convert-to-cloud/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z"
                }
              }
            ],
            "name": "convert-to-cloud",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ConvertToCloud16",
          "filepath": "convert-to-cloud/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z"
                }
              }
            ],
            "name": "convert-to-cloud",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ConvertToCloud",
        "global": "ConvertToCloud",
        "filepath": "ConvertToCloud.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cookie",
      "friendlyName": "Cookie",
      "aliases": [
        "technology",
        "cookie",
        "tracking",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cookie.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<circle cx=\"10\" cy=\"21\" r=\"2\"/>\n<circle cx=\"23\" cy=\"20\" r=\"2\"/>\n<circle cx=\"13\" cy=\"10\" r=\"2\"/>\n<circle cx=\"14\" cy=\"15\" r=\"1\"/>\n<circle cx=\"23\" cy=\"5\" r=\"2\"/>\n<circle cx=\"29\" cy=\"3\" r=\"1\"/>\n<circle cx=\"16\" cy=\"23\" r=\"1\"/>\n<path d=\"M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5\n\tc1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16\n\tC30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4\n\tc0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"21\" r=\"2\"/><circle cx=\"23\" cy=\"20\" r=\"2\"/><circle cx=\"13\" cy=\"10\" r=\"2\"/><circle cx=\"14\" cy=\"15\" r=\"1\"/><circle cx=\"23\" cy=\"5\" r=\"2\"/><circle cx=\"29\" cy=\"3\" r=\"1\"/><circle cx=\"16\" cy=\"23\" r=\"1\"/><path d=\"M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5\tc1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16\tC30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4\tc0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z\"/></svg>",
            "info": {},
            "path": "32/cookie.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cookie32",
          "filepath": "cookie/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "5",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5\tc1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16\tC30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4\tc0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z"
                }
              }
            ],
            "name": "cookie",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cookie24",
          "filepath": "cookie/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "5",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5\tc1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16\tC30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4\tc0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z"
                }
              }
            ],
            "name": "cookie",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cookie20",
          "filepath": "cookie/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "5",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5\tc1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16\tC30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4\tc0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z"
                }
              }
            ],
            "name": "cookie",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cookie16",
          "filepath": "cookie/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "5",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5\tc1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16\tC30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4\tc0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z"
                }
              }
            ],
            "name": "cookie",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Cookie",
        "global": "Cookie",
        "filepath": "Cookie.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "21",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13",
                    "cy": "10",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "15",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "5",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "29",
                    "cy": "3",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5 c1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16 C30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4 c0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "copy",
      "friendlyName": "Copy",
      "aliases": [
        "duplicate",
        "clipboard",
        "copied"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/copy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>copy</title><path d=\"M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z\" transform=\"translate(0)\"/><path d=\"M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z\"/><path d=\"M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z\"/></svg>",
            "info": {},
            "path": "32/copy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Copy32",
          "filepath": "copy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"
                }
              }
            ],
            "name": "copy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Copy24",
          "filepath": "copy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"
                }
              }
            ],
            "name": "copy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Copy20",
          "filepath": "copy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"
                }
              }
            ],
            "name": "copy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Copy16",
          "filepath": "copy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"
                }
              }
            ],
            "name": "copy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Copy",
        "global": "Copy",
        "filepath": "Copy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "copy--file",
      "friendlyName": "Copy file",
      "aliases": [
        "duplicate",
        "clipboard",
        "copied"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/copy--file.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>copy--file</title>\n<path d=\"M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1\n\tC28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z\"/>\n<path d=\"M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1\tC28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z\"/><path d=\"M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z\"/></svg>",
            "info": {},
            "path": "32/copy--file.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CopyFile32",
          "filepath": "copy--file/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1\tC28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z"
                }
              }
            ],
            "name": "copy--file",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CopyFile24",
          "filepath": "copy--file/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1\tC28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z"
                }
              }
            ],
            "name": "copy--file",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CopyFile20",
          "filepath": "copy--file/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1\tC28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z"
                }
              }
            ],
            "name": "copy--file",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CopyFile16",
          "filepath": "copy--file/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1\tC28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z"
                }
              }
            ],
            "name": "copy--file",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CopyFile",
        "global": "CopyFile",
        "filepath": "CopyFile.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1 C28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "copy--link",
      "friendlyName": "Copy link",
      "aliases": [
        "copy",
        "link",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/copy--link.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z\"/>\n  <path d=\"M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z\"/>\n  <path d=\"M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z\"/><path d=\"M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z\"/><path d=\"M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z\"/></svg>",
            "info": {},
            "path": "32/copy--link.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CopyLink32",
          "filepath": "copy--link/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z"
                }
              }
            ],
            "name": "copy--link",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CopyLink24",
          "filepath": "copy--link/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z"
                }
              }
            ],
            "name": "copy--link",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CopyLink20",
          "filepath": "copy--link/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z"
                }
              }
            ],
            "name": "copy--link",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CopyLink16",
          "filepath": "copy--link/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z"
                }
              }
            ],
            "name": "copy--link",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CopyLink",
        "global": "CopyLink",
        "filepath": "CopyLink.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "corn",
      "friendlyName": "Corn",
      "aliases": [
        "corn",
        "food",
        "vegetable"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/corn.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>corn</title><path d=\"M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z\"/></svg>",
            "info": {},
            "path": "32/corn.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Corn32",
          "filepath": "corn/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "corn",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Corn24",
          "filepath": "corn/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "corn",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Corn20",
          "filepath": "corn/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "corn",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Corn16",
          "filepath": "corn/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "corn",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Corn",
        "global": "Corn",
        "filepath": "Corn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "corner",
      "friendlyName": "Corner",
      "aliases": [
        "frame",
        "flourish",
        "squares",
        "connection",
        "edge",
        "intersection",
        "decoration"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/corner.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>corner</title><path d=\"M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z\"/></svg>",
            "info": {},
            "path": "32/corner.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Corner32",
          "filepath": "corner/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z"
                }
              }
            ],
            "name": "corner",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Corner24",
          "filepath": "corner/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z"
                }
              }
            ],
            "name": "corner",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Corner20",
          "filepath": "corner/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z"
                }
              }
            ],
            "name": "corner",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Corner16",
          "filepath": "corner/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z"
                }
              }
            ],
            "name": "corner",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Corner",
        "global": "Corner",
        "filepath": "Corner.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "coronavirus",
      "friendlyName": "Coronavirus",
      "aliases": [
        "health",
        "coronavirus",
        "virus"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/coronavirus.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"15.5\" cy=\"11.5\" r=\"1.5\"/>\n  <circle cx=\"20.5\" cy=\"15.5\" r=\"1.5\"/>\n  <circle cx=\"16\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"16.5\" cy=\"20.5\" r=\"1.5\"/>\n  <circle cx=\"11.5\" cy=\"16.5\" r=\"1.5\"/>\n  <path d=\"M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"15.5\" cy=\"11.5\" r=\"1.5\"/><circle cx=\"20.5\" cy=\"15.5\" r=\"1.5\"/><circle cx=\"16\" cy=\"16\" r=\"1\"/><circle cx=\"16.5\" cy=\"20.5\" r=\"1.5\"/><circle cx=\"11.5\" cy=\"16.5\" r=\"1.5\"/><path d=\"M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z\"/></svg>",
            "info": {},
            "path": "32/coronavirus.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Coronavirus32",
          "filepath": "coronavirus/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "11.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.5",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "16.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z"
                }
              }
            ],
            "name": "coronavirus",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Coronavirus24",
          "filepath": "coronavirus/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "11.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.5",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "16.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z"
                }
              }
            ],
            "name": "coronavirus",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Coronavirus20",
          "filepath": "coronavirus/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "11.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.5",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "16.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z"
                }
              }
            ],
            "name": "coronavirus",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Coronavirus16",
          "filepath": "coronavirus/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "11.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20.5",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "16.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z"
                }
              }
            ],
            "name": "coronavirus",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Coronavirus",
        "global": "Coronavirus",
        "filepath": "Coronavirus.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15.5",
                    "cy": "11.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20.5",
                    "cy": "15.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16.5",
                    "cy": "20.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11.5",
                    "cy": "16.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cost",
      "friendlyName": "Cost",
      "aliases": [
        "data",
        "cost",
        "expense",
        "price"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cost.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z\"/>\n  <path d=\"M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z\"/><path d=\"M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/></svg>",
            "info": {},
            "path": "32/cost.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cost32",
          "filepath": "cost/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cost24",
          "filepath": "cost/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cost20",
          "filepath": "cost/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cost16",
          "filepath": "cost/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Cost",
        "global": "Cost",
        "filepath": "Cost.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cost--total",
      "friendlyName": "Cost total",
      "aliases": [
        "data",
        "cost",
        "expense",
        "price",
        "total",
        "aggregate"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cost--total.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"10\" y=\"13\" width=\"12\" height=\"2\"/>\n  <rect x=\"10\" y=\"18\" width=\"12\" height=\"2\"/>\n  <path d=\"M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 13H22V15H10zM10 18H22V20H10z\"/><path d=\"M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/></svg>",
            "info": {},
            "path": "32/cost--total.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CostTotal32",
          "filepath": "cost--total/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10zM10 18H22V20H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost--total",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CostTotal24",
          "filepath": "cost--total/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10zM10 18H22V20H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost--total",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CostTotal20",
          "filepath": "cost--total/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10zM10 18H22V20H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost--total",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CostTotal16",
          "filepath": "cost--total/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H22V15H10zM10 18H22V20H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "cost--total",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "CostTotal",
        "global": "CostTotal",
        "filepath": "CostTotal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 13H22V15H10zM10 18H22V20H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cough",
      "friendlyName": "Cough",
      "aliases": [
        "cough",
        "user",
        "person",
        "coughing"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cough.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z\"/>\n  <circle cx=\"9\" cy=\"23\" r=\"1\"/>\n  <circle cx=\"6\" cy=\"20\" r=\"1\"/>\n  <circle cx=\"6\" cy=\"26\" r=\"1\"/>\n  <circle cx=\"3\" cy=\"17\" r=\"1\"/>\n  <circle cx=\"3\" cy=\"29\" r=\"1\"/>\n  <circle cx=\"3\" cy=\"23\" r=\"1\"/>\n  <rect x=\"19\" y=\"12\" width=\"4\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z\"/><circle cx=\"9\" cy=\"23\" r=\"1\"/><circle cx=\"6\" cy=\"20\" r=\"1\"/><circle cx=\"6\" cy=\"26\" r=\"1\"/><circle cx=\"3\" cy=\"17\" r=\"1\"/><circle cx=\"3\" cy=\"29\" r=\"1\"/><circle cx=\"3\" cy=\"23\" r=\"1\"/><path d=\"M19 12H23V14H19z\"/></svg>",
            "info": {},
            "path": "32/cough.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cough32",
          "filepath": "cough/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "cough",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cough24",
          "filepath": "cough/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "cough",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cough20",
          "filepath": "cough/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "cough",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cough16",
          "filepath": "cough/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "cough",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Cough",
        "global": "Cough",
        "filepath": "Cough.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "26",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "29",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 12H23V14H19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "course",
      "friendlyName": "Course",
      "aliases": [
        "course",
        "class"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/course.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>course</title><path d=\"M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z\"/></svg>",
            "info": {},
            "path": "32/course.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Course32",
          "filepath": "course/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z"
                }
              }
            ],
            "name": "course",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Course24",
          "filepath": "course/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z"
                }
              }
            ],
            "name": "course",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Course20",
          "filepath": "course/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z"
                }
              }
            ],
            "name": "course",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Course16",
          "filepath": "course/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z"
                }
              }
            ],
            "name": "course",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Course",
        "global": "Course",
        "filepath": "Course.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "covariate",
      "friendlyName": "Covariate",
      "aliases": [
        "data",
        "covariate",
        "variable"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/covariate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>covariate</title><circle cx=\"8\" cy=\"16\" r=\"2\"/><circle cx=\"14\" cy=\"8\" r=\"2\"/><circle cx=\"28\" cy=\"12\" r=\"2\"/><circle cx=\"21\" cy=\"18\" r=\"2\"/><path d=\"M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"8\" cy=\"16\" r=\"2\"/><circle cx=\"14\" cy=\"8\" r=\"2\"/><circle cx=\"28\" cy=\"12\" r=\"2\"/><circle cx=\"21\" cy=\"18\" r=\"2\"/><path d=\"M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z\"/></svg>",
            "info": {},
            "path": "32/covariate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Covariate32",
          "filepath": "covariate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z"
                }
              }
            ],
            "name": "covariate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Covariate24",
          "filepath": "covariate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z"
                }
              }
            ],
            "name": "covariate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Covariate20",
          "filepath": "covariate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z"
                }
              }
            ],
            "name": "covariate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Covariate16",
          "filepath": "covariate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z"
                }
              }
            ],
            "name": "covariate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Covariate",
        "global": "Covariate",
        "filepath": "Covariate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "8",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "18",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "credentials",
      "friendlyName": "Credentials",
      "aliases": [
        "credentials",
        "documents",
        "indentification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/credentials.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>credentials</title><path d=\"M16,22a4,4,0,1,0-4-4A4,4,0,0,0,16,22Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,16Z\"/><rect x=\"14\" y=\"6\" width=\"4\" height=\"2\"/><path d=\"M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z\"/><path d=\"M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z\"/></svg>",
            "info": {},
            "path": "32/credentials.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Credentials32",
          "filepath": "credentials/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z"
                }
              }
            ],
            "name": "credentials",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Credentials24",
          "filepath": "credentials/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z"
                }
              }
            ],
            "name": "credentials",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Credentials20",
          "filepath": "credentials/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z"
                }
              }
            ],
            "name": "credentials",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Credentials16",
          "filepath": "credentials/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z"
                }
              }
            ],
            "name": "credentials",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Credentials",
        "global": "Credentials",
        "filepath": "Credentials.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "critical",
      "friendlyName": "Critical",
      "aliases": [
        "critical",
        "warning",
        "caution",
        "slash"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "critical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12.887,11.4727a5.9936,5.9936,0,0,0-8.36-8.3594Z\"/>\n  <path d=\"M3.113,4.5273a5.9936,5.9936,0,0,0,8.36,8.3594Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12.887 11.4727a5.9936 5.9936 0 00-8.36-8.3594zM3.113 4.5273a5.9936 5.9936 0 008.36 8.3594z\"/></svg>",
            "info": {},
            "path": "critical.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.887 11.4727a5.9936 5.9936 0 00-8.36-8.3594zM3.113 4.5273a5.9936 5.9936 0 008.36 8.3594z"
                }
              }
            ],
            "name": "critical",
            "size": "glyph"
          },
          "moduleName": "CriticalGlyph",
          "filepath": "critical/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Critical",
        "global": "Critical",
        "filepath": "Critical.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.887 11.4727a5.9936 5.9936 0 00-8.36-8.3594zM3.113 4.5273a5.9936 5.9936 0 008.36 8.3594z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "critical-severity",
      "friendlyName": "Critical severity",
      "aliases": [
        "critical",
        "severe",
        "warning"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "critical-severity.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"13 13 3 13 3 3 13 13\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13 13L3 13 3 3 13 13z\"/></svg>",
            "info": {},
            "path": "critical-severity.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 13L3 13 3 3 13 13z"
                }
              }
            ],
            "name": "critical-severity",
            "size": "glyph"
          },
          "moduleName": "CriticalSeverityGlyph",
          "filepath": "critical-severity/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "CriticalSeverity",
        "global": "CriticalSeverity",
        "filepath": "CriticalSeverity.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 13L3 13 3 3 13 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "crop",
      "friendlyName": "Crop",
      "aliases": [
        "cut",
        "trim",
        "picture",
        "tool",
        "cropping",
        "editing",
        "photo"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/crop.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>crop</title><path d=\"M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z\"/><path d=\"M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z\"/><path d=\"M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z\"/></svg>",
            "info": {},
            "path": "32/crop.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Crop32",
          "filepath": "crop/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z"
                }
              }
            ],
            "name": "crop",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Crop24",
          "filepath": "crop/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z"
                }
              }
            ],
            "name": "crop",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Crop20",
          "filepath": "crop/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z"
                }
              }
            ],
            "name": "crop",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Crop16",
          "filepath": "crop/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z"
                }
              }
            ],
            "name": "crop",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Crop",
        "global": "Crop",
        "filepath": "Crop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "crop-growth",
      "friendlyName": "Crop growth",
      "aliases": [
        "crop",
        "growth",
        "agriculture",
        "food",
        "production"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/crop-growth.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z\"/></svg>",
            "info": {},
            "path": "32/crop-growth.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CropGrowth32",
          "filepath": "crop-growth/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "crop-growth",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CropGrowth24",
          "filepath": "crop-growth/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "crop-growth",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CropGrowth20",
          "filepath": "crop-growth/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "crop-growth",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CropGrowth16",
          "filepath": "crop-growth/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "crop-growth",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "CropGrowth",
        "global": "CropGrowth",
        "filepath": "CropGrowth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "crop-health",
      "friendlyName": "Crop health",
      "aliases": [
        "crop",
        "health",
        "agriculture",
        "food",
        "production"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/crop-health.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"28\" width=\"8\" height=\"2\"/>\n  <path d=\"M17,29a1,1,0,0,1-.7808-.3752L12.52,24H2V22H13a1,1,0,0,1,.7808.3752l3.146,3.9322,5.2412-7.8621A1,1,0,0,1,23.8,18.4L26.5,22H30v2H26a.9991.9991,0,0,1-.8-.4l-2.1523-2.8694-5.2159,7.824a.9986.9986,0,0,1-.7885.4443Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,16V11h1a4.0045,4.0045,0,0,0,4-4V4H13a3.9779,3.9779,0,0,0-2.7468,1.1067A6.0034,6.0034,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.002,2.002,0,0,1,13,6ZM8,9A4.0045,4.0045,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z\"/></svg>",
            "info": {},
            "path": "32/crop-health.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CropHealth32",
          "filepath": "crop-health/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "crop-health",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CropHealth24",
          "filepath": "crop-health/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "crop-health",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CropHealth20",
          "filepath": "crop-health/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "crop-health",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CropHealth16",
          "filepath": "crop-health/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                }
              }
            ],
            "name": "crop-health",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "CropHealth",
        "global": "CropHealth",
        "filepath": "CropHealth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cross-reference",
      "friendlyName": "Cross reference",
      "aliases": [
        "read",
        "research",
        "refer",
        "reference",
        "source",
        "citation"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/cross-reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--cross-reference</title><rect x=\"11\" y=\"24\" width=\"4\" height=\"2\"/><rect x=\"5\" y=\"24\" width=\"4\" height=\"2\"/><rect x=\"23\" y=\"24\" width=\"4\" height=\"2\"/><rect x=\"17\" y=\"24\" width=\"4\" height=\"2\"/><path d=\"M9,22a4.92,4.92,0,0,1,4-2h6a5.22,5.22,0,0,1,4,2h2.3A6.87,6.87,0,0,0,19,18H13a6.87,6.87,0,0,0-6.3,4Z\"/><rect x=\"24\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"28\" width=\"2\" height=\"2\"/><path d=\"M16,16a7,7,0,1,1,7-7A7,7,0,0,1,16,16ZM16,4a5,5,0,0,0-5,5A5,5,0,0,0,21,9,5,5,0,0,0,16,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z\"/></svg>",
            "info": {},
            "path": "32/watson-health/cross-reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthCrossReference32",
          "filepath": "watson-health/cross-reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z"
                }
              }
            ],
            "name": "cross-reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthCrossReference24",
          "filepath": "watson-health/cross-reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z"
                }
              }
            ],
            "name": "cross-reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthCrossReference20",
          "filepath": "watson-health/cross-reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z"
                }
              }
            ],
            "name": "cross-reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthCrossReference16",
          "filepath": "watson-health/cross-reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z"
                }
              }
            ],
            "name": "cross-reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "CrossReference",
        "global": "WatsonHealthCrossReference",
        "filepath": "watson-health/CrossReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cross-tab",
      "friendlyName": "Cross tab",
      "aliases": [
        "cross tab",
        "data",
        "tabulate"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cross-tab.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z\"/></svg>",
            "info": {},
            "path": "32/cross-tab.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CrossTab32",
          "filepath": "cross-tab/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z"
                }
              }
            ],
            "name": "cross-tab",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CrossTab24",
          "filepath": "cross-tab/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z"
                }
              }
            ],
            "name": "cross-tab",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CrossTab20",
          "filepath": "cross-tab/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z"
                }
              }
            ],
            "name": "cross-tab",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CrossTab16",
          "filepath": "cross-tab/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z"
                }
              }
            ],
            "name": "cross-tab",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "CrossTab",
        "global": "CrossTab",
        "filepath": "CrossTab.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "crossroads",
      "friendlyName": "Crossroads",
      "aliases": [
        "crossroads",
        "travel",
        "map",
        "wayfinding"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/crossroads.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z\"/></svg>",
            "info": {},
            "path": "32/crossroads.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Crossroads32",
          "filepath": "crossroads/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z"
                }
              }
            ],
            "name": "crossroads",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Crossroads24",
          "filepath": "crossroads/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z"
                }
              }
            ],
            "name": "crossroads",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Crossroads20",
          "filepath": "crossroads/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z"
                }
              }
            ],
            "name": "crossroads",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Crossroads16",
          "filepath": "crossroads/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z"
                }
              }
            ],
            "name": "crossroads",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Crossroads",
        "global": "Crossroads",
        "filepath": "Crossroads.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "crowd-report",
      "friendlyName": "Crowd report",
      "aliases": [
        "crowd",
        "report",
        "travel",
        "groups"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/crowd-report.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z\"/><path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/></svg>",
            "info": {},
            "path": "32/crowd-report.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CrowdReport32",
          "filepath": "crowd-report/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "crowd-report",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CrowdReport24",
          "filepath": "crowd-report/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "crowd-report",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CrowdReport20",
          "filepath": "crowd-report/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "crowd-report",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CrowdReport16",
          "filepath": "crowd-report/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "crowd-report",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "CrowdReport",
        "global": "CrowdReport",
        "filepath": "CrowdReport.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "crowd-report--filled",
      "friendlyName": "Crowd report filled",
      "aliases": [
        "crowd",
        "report",
        "travel",
        "groups",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/crowd-report--filled.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z\"/><path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/crowd-report--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CrowdReportFilled32",
          "filepath": "crowd-report--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "crowd-report--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CrowdReportFilled24",
          "filepath": "crowd-report--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "crowd-report--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CrowdReportFilled20",
          "filepath": "crowd-report--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "crowd-report--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CrowdReportFilled16",
          "filepath": "crowd-report--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "crowd-report--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "CrowdReportFilled",
        "global": "CrowdReportFilled",
        "filepath": "CrowdReportFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "CSV",
      "friendlyName": "CSV",
      "aliases": [
        "file",
        "file type",
        "comma",
        "separated",
        "variable",
        "spreadsheet",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/CSV.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>CSV</title><polygon points=\"28 9 26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9\"/><path d=\"M18,23H12V21h6V17H14a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H14v4h4a2.002,2.002,0,0,1,2,2v4A2.002,2.002,0,0,1,18,23Z\"/><path d=\"M10,23H4a2.0023,2.0023,0,0,1-2-2V11A2.002,2.002,0,0,1,4,9h6v2H4V21h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z\"/></svg>",
            "info": {},
            "path": "32/CSV.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Csv32",
          "filepath": "CSV/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CSV",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Csv24",
          "filepath": "CSV/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CSV",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Csv20",
          "filepath": "CSV/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CSV",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Csv16",
          "filepath": "CSV/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                }
              }
            ],
            "name": "CSV",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Csv",
        "global": "Csv",
        "filepath": "Csv.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cU1",
      "friendlyName": "cU1",
      "aliases": [
        "Q",
        "c",
        "u",
        "one"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/cU1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--cU1</title><path d=\"M10,23H5a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H5v6h5Z\" transform=\"translate(0 0)\"/><path d=\"M18,23H14a2,2,0,0,1-2-2V9h2V21h4V9h2V21A2,2,0,0,1,18,23Z\" transform=\"translate(0 0)\"/><polygon points=\"27 21 27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z\"/></svg>",
            "info": {},
            "path": "32/Q/cU1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QCU132",
          "filepath": "Q/cU1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z"
                }
              }
            ],
            "name": "cU1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QCU124",
          "filepath": "Q/cU1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z"
                }
              }
            ],
            "name": "cU1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QCU120",
          "filepath": "Q/cU1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z"
                }
              }
            ],
            "name": "cU1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QCU116",
          "filepath": "Q/cU1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z"
                }
              }
            ],
            "name": "cU1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "CU1",
        "global": "QCU1",
        "filepath": "Q/CU1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cU3",
      "friendlyName": "cU3",
      "aliases": [
        "q",
        "c",
        "u",
        "three"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/cU3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--cU3</title><path d=\"M10,23H5a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H5v6h5Z\" transform=\"translate(0 0)\"/><path d=\"M18,23H14a2,2,0,0,1-2-2V9h2V21h4V9h2V21A2,2,0,0,1,18,23Z\" transform=\"translate(0 0)\"/><path d=\"M28,9H22v2h6v4H23v2h5v4H22v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z\"/></svg>",
            "info": {},
            "path": "32/Q/cU3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QCU332",
          "filepath": "Q/cU3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z"
                }
              }
            ],
            "name": "cU3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QCU324",
          "filepath": "Q/cU3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z"
                }
              }
            ],
            "name": "cU3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QCU320",
          "filepath": "Q/cU3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z"
                }
              }
            ],
            "name": "cU3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QCU316",
          "filepath": "Q/cU3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z"
                }
              }
            ],
            "name": "cU3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "CU3",
        "global": "QCU3",
        "filepath": "Q/CU3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cube",
      "friendlyName": "Cube",
      "aliases": [
        "file",
        "cube"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cube.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z\"/></svg>",
            "info": {},
            "path": "32/cube.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cube32",
          "filepath": "cube/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z"
                }
              }
            ],
            "name": "cube",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cube24",
          "filepath": "cube/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z"
                }
              }
            ],
            "name": "cube",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cube20",
          "filepath": "cube/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z"
                }
              }
            ],
            "name": "cube",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cube16",
          "filepath": "cube/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z"
                }
              }
            ],
            "name": "cube",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Cube",
        "global": "Cube",
        "filepath": "Cube.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cube-view",
      "friendlyName": "Cube view",
      "aliases": [
        "file",
        "cube view"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cube-view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <path d=\"M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z\"/>\n  <path d=\"M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z\"/><path d=\"M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z\"/></svg>",
            "info": {},
            "path": "32/cube-view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CubeView32",
          "filepath": "cube-view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z"
                }
              }
            ],
            "name": "cube-view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CubeView24",
          "filepath": "cube-view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z"
                }
              }
            ],
            "name": "cube-view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CubeView20",
          "filepath": "cube-view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z"
                }
              }
            ],
            "name": "cube-view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CubeView16",
          "filepath": "cube-view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z"
                }
              }
            ],
            "name": "cube-view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "CubeView",
        "global": "CubeView",
        "filepath": "CubeView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency",
      "friendlyName": "currency",
      "aliases": [
        "currency",
        "money",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z\"/>\n  <path d=\"M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z\"/><path d=\"M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/currency.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Currency32",
          "filepath": "currency/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
                }
              }
            ],
            "name": "currency",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Currency24",
          "filepath": "currency/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
                }
              }
            ],
            "name": "currency",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Currency20",
          "filepath": "currency/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
                }
              }
            ],
            "name": "currency",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Currency16",
          "filepath": "currency/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
                }
              }
            ],
            "name": "currency",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Currency",
        "global": "Currency",
        "filepath": "Currency.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--baht",
      "friendlyName": "Currency baht",
      "aliases": [
        "currency",
        "money",
        "baht",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--baht.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z\"/></svg>",
            "info": {},
            "path": "32/currency--baht.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyBaht32",
          "filepath": "currency--baht/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
                }
              }
            ],
            "name": "currency--baht",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyBaht24",
          "filepath": "currency--baht/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
                }
              }
            ],
            "name": "currency--baht",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyBaht20",
          "filepath": "currency--baht/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
                }
              }
            ],
            "name": "currency--baht",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyBaht16",
          "filepath": "currency--baht/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
                }
              }
            ],
            "name": "currency--baht",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyBaht",
        "global": "CurrencyBaht",
        "filepath": "CurrencyBaht.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--dollar",
      "friendlyName": "Currency dollar",
      "aliases": [
        "currency",
        "money",
        "dollar",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--dollar.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z\"/></svg>",
            "info": {},
            "path": "32/currency--dollar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyDollar32",
          "filepath": "currency--dollar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
                }
              }
            ],
            "name": "currency--dollar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyDollar24",
          "filepath": "currency--dollar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
                }
              }
            ],
            "name": "currency--dollar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyDollar20",
          "filepath": "currency--dollar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
                }
              }
            ],
            "name": "currency--dollar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyDollar16",
          "filepath": "currency--dollar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
                }
              }
            ],
            "name": "currency--dollar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyDollar",
        "global": "CurrencyDollar",
        "filepath": "CurrencyDollar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--euro",
      "friendlyName": "Currency euro",
      "aliases": [
        "currency",
        "money",
        "euro",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--euro.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z\"/></svg>",
            "info": {},
            "path": "32/currency--euro.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyEuro32",
          "filepath": "currency--euro/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
                }
              }
            ],
            "name": "currency--euro",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyEuro24",
          "filepath": "currency--euro/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
                }
              }
            ],
            "name": "currency--euro",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyEuro20",
          "filepath": "currency--euro/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
                }
              }
            ],
            "name": "currency--euro",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyEuro16",
          "filepath": "currency--euro/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
                }
              }
            ],
            "name": "currency--euro",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyEuro",
        "global": "CurrencyEuro",
        "filepath": "CurrencyEuro.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--lira",
      "friendlyName": "Currency lira",
      "aliases": [
        "currency",
        "money",
        "lira",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--lira.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z\"/></svg>",
            "info": {},
            "path": "32/currency--lira.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyLira32",
          "filepath": "currency--lira/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
                }
              }
            ],
            "name": "currency--lira",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyLira24",
          "filepath": "currency--lira/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
                }
              }
            ],
            "name": "currency--lira",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyLira20",
          "filepath": "currency--lira/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
                }
              }
            ],
            "name": "currency--lira",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyLira16",
          "filepath": "currency--lira/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
                }
              }
            ],
            "name": "currency--lira",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyLira",
        "global": "CurrencyLira",
        "filepath": "CurrencyLira.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--pound",
      "friendlyName": "Currency pound",
      "aliases": [
        "currency",
        "money",
        "pound",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--pound.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z\"/></svg>",
            "info": {},
            "path": "32/currency--pound.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyPound32",
          "filepath": "currency--pound/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
                }
              }
            ],
            "name": "currency--pound",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyPound24",
          "filepath": "currency--pound/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
                }
              }
            ],
            "name": "currency--pound",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyPound20",
          "filepath": "currency--pound/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
                }
              }
            ],
            "name": "currency--pound",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyPound16",
          "filepath": "currency--pound/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
                }
              }
            ],
            "name": "currency--pound",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyPound",
        "global": "CurrencyPound",
        "filepath": "CurrencyPound.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--ruble",
      "friendlyName": "Currency ruble",
      "aliases": [
        "currency",
        "money",
        "ruble",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--ruble.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z\"/></svg>",
            "info": {},
            "path": "32/currency--ruble.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyRuble32",
          "filepath": "currency--ruble/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "currency--ruble",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyRuble24",
          "filepath": "currency--ruble/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "currency--ruble",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyRuble20",
          "filepath": "currency--ruble/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "currency--ruble",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyRuble16",
          "filepath": "currency--ruble/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
                }
              }
            ],
            "name": "currency--ruble",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyRuble",
        "global": "CurrencyRuble",
        "filepath": "CurrencyRuble.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--rupee",
      "friendlyName": "Currency rupee",
      "aliases": [
        "currency",
        "money",
        "rupee",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--rupee.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z\"/></svg>",
            "info": {},
            "path": "32/currency--rupee.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyRupee32",
          "filepath": "currency--rupee/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
                }
              }
            ],
            "name": "currency--rupee",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyRupee24",
          "filepath": "currency--rupee/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
                }
              }
            ],
            "name": "currency--rupee",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyRupee20",
          "filepath": "currency--rupee/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
                }
              }
            ],
            "name": "currency--rupee",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyRupee16",
          "filepath": "currency--rupee/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
                }
              }
            ],
            "name": "currency--rupee",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyRupee",
        "global": "CurrencyRupee",
        "filepath": "CurrencyRupee.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--shekel",
      "friendlyName": "Currency shekel",
      "aliases": [
        "currency",
        "money",
        "shekel",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--shekel.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z\"/><path d=\"M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z\"/></svg>",
            "info": {},
            "path": "32/currency--shekel.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyShekel32",
          "filepath": "currency--shekel/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
                }
              }
            ],
            "name": "currency--shekel",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyShekel24",
          "filepath": "currency--shekel/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
                }
              }
            ],
            "name": "currency--shekel",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyShekel20",
          "filepath": "currency--shekel/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
                }
              }
            ],
            "name": "currency--shekel",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyShekel16",
          "filepath": "currency--shekel/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
                }
              }
            ],
            "name": "currency--shekel",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyShekel",
        "global": "CurrencyShekel",
        "filepath": "CurrencyShekel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--won",
      "friendlyName": "Currency won",
      "aliases": [
        "currency",
        "money",
        "won",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--won.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"28 14 28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z\"/></svg>",
            "info": {},
            "path": "32/currency--won.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyWon32",
          "filepath": "currency--won/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
                }
              }
            ],
            "name": "currency--won",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyWon24",
          "filepath": "currency--won/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
                }
              }
            ],
            "name": "currency--won",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyWon20",
          "filepath": "currency--won/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
                }
              }
            ],
            "name": "currency--won",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyWon16",
          "filepath": "currency--won/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
                }
              }
            ],
            "name": "currency--won",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyWon",
        "global": "CurrencyWon",
        "filepath": "CurrencyWon.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "currency--yen",
      "friendlyName": "Currency yen",
      "aliases": [
        "currency",
        "money",
        "yen",
        "finance",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/currency--yen.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n  <polygon points=\"24.271 5 22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5\"/>\n  <rect class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z\"/></svg>",
            "info": {},
            "path": "32/currency--yen.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CurrencyYen32",
          "filepath": "currency--yen/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
                }
              }
            ],
            "name": "currency--yen",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CurrencyYen24",
          "filepath": "currency--yen/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
                }
              }
            ],
            "name": "currency--yen",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CurrencyYen20",
          "filepath": "currency--yen/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
                }
              }
            ],
            "name": "currency--yen",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CurrencyYen16",
          "filepath": "currency--yen/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
                }
              }
            ],
            "name": "currency--yen",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "CurrencyYen",
        "global": "CurrencyYen",
        "filepath": "CurrencyYen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cursor--1",
      "friendlyName": "Cursor 1",
      "aliases": [
        "mouse",
        "arrow",
        "direction",
        "mouse",
        "click",
        "pointer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cursor--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cursor--1</title><path d=\"M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z\"/></svg>",
            "info": {},
            "path": "32/cursor--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cursor_132",
          "filepath": "cursor--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
                }
              }
            ],
            "name": "cursor--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cursor_124",
          "filepath": "cursor--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
                }
              }
            ],
            "name": "cursor--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cursor_120",
          "filepath": "cursor--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
                }
              }
            ],
            "name": "cursor--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cursor_116",
          "filepath": "cursor--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
                }
              }
            ],
            "name": "cursor--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Cursor_1",
        "global": "Cursor_1",
        "filepath": "Cursor_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cursor--2",
      "friendlyName": "Cursor 2",
      "aliases": [
        "mouse",
        "arrow",
        "direction",
        "mouse",
        "click",
        "pointer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cursor--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cursor--2</title><path d=\"M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z\"/></svg>",
            "info": {},
            "path": "32/cursor--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cursor_232",
          "filepath": "cursor--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
                }
              }
            ],
            "name": "cursor--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cursor_224",
          "filepath": "cursor--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
                }
              }
            ],
            "name": "cursor--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cursor_220",
          "filepath": "cursor--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
                }
              }
            ],
            "name": "cursor--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cursor_216",
          "filepath": "cursor--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
                }
              }
            ],
            "name": "cursor--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Cursor_2",
        "global": "Cursor_2",
        "filepath": "Cursor_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cut",
      "friendlyName": "Cut",
      "aliases": [
        "scissors",
        "cutting",
        "snip",
        "trim",
        "shear",
        "clippers"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cut.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cut</title><path d=\"M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z\"/></svg>",
            "info": {},
            "path": "32/cut.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cut32",
          "filepath": "cut/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
                }
              }
            ],
            "name": "cut",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cut24",
          "filepath": "cut/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
                }
              }
            ],
            "name": "cut",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cut20",
          "filepath": "cut/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
                }
              }
            ],
            "name": "cut",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cut16",
          "filepath": "cut/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
                }
              }
            ],
            "name": "cut",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Cut",
        "global": "Cut",
        "filepath": "Cut.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cut-in-half",
      "friendlyName": "Cut in half",
      "aliases": [
        "cut",
        "split",
        "half",
        "halve"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/cut-in-half.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>cut-in-half</title>\n  <path d=\"M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/cut-in-half.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthCutInHalf32",
          "filepath": "watson-health/cut-in-half/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
                }
              }
            ],
            "name": "cut-in-half",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthCutInHalf24",
          "filepath": "watson-health/cut-in-half/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
                }
              }
            ],
            "name": "cut-in-half",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthCutInHalf20",
          "filepath": "watson-health/cut-in-half/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
                }
              }
            ],
            "name": "cut-in-half",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthCutInHalf16",
          "filepath": "watson-health/cut-in-half/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
                }
              }
            ],
            "name": "cut-in-half",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "CutInHalf",
        "global": "WatsonHealthCutInHalf",
        "filepath": "watson-health/CutInHalf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cut-out",
      "friendlyName": "Cut out",
      "aliases": [
        "formatting",
        "cut out",
        "clip",
        "clipping",
        "coupon"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cut-out.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19.05,13.7326,18.05,12,7.928,17.8457,6.9312,17.27a2.9524,2.9524,0,0,0,.6672-.769A3,3,0,1,0,3.5,17.5986l2.428,1.4019L3.5,20.4023a3.0342,3.0342,0,1,0,3.4407.3223l.987-.5693L14.5914,24l1-1.7294-5.6634-3.27ZM4.0344,15.26a1,1,0,1,1,.4658.6069A.9929.9929,0,0,1,4.0344,15.26ZM4.9988,22a1,1,0,1,1-.8645,1.5A1,1,0,0,1,4.9988,22Z\"/>\n  <rect x=\"17\" y=\"26\" width=\"4\" height=\"2\"/>\n  <rect x=\"10\" y=\"26\" width=\"4\" height=\"2\"/>\n  <path d=\"M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z\"/><path d=\"M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z\"/></svg>",
            "info": {},
            "path": "32/cut-out.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "CutOut32",
          "filepath": "cut-out/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
                }
              }
            ],
            "name": "cut-out",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "CutOut24",
          "filepath": "cut-out/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
                }
              }
            ],
            "name": "cut-out",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "CutOut20",
          "filepath": "cut-out/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
                }
              }
            ],
            "name": "cut-out",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "CutOut16",
          "filepath": "cut-out/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
                }
              }
            ],
            "name": "cut-out",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "CutOut",
        "global": "CutOut",
        "filepath": "CutOut.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cY",
      "friendlyName": "cY",
      "aliases": [
        "Q",
        "c",
        "y"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/cY.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--cY</title><path d=\"M15,23H10a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H10v6h5Z\"/><polygon points=\"24 9 22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z\"/></svg>",
            "info": {},
            "path": "32/Q/cY.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QCY32",
          "filepath": "Q/cY/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
                }
              }
            ],
            "name": "cY",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QCY24",
          "filepath": "Q/cY/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
                }
              }
            ],
            "name": "cY",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QCY20",
          "filepath": "Q/cY/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
                }
              }
            ],
            "name": "cY",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QCY16",
          "filepath": "Q/cY/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
                }
              }
            ],
            "name": "cY",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "CY",
        "global": "QCY",
        "filepath": "Q/CY.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cyclist",
      "friendlyName": "Cyclist",
      "aliases": [
        "cyclist",
        "travel",
        "bicyclist",
        "bicycle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/cyclist.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bike-riding</title><path d=\"M25,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,25,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,25,20Z\"/><path d=\"M7,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,7,30ZM7,20a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,7,20Z\"/><path d=\"M17,27H15V20.4139L9.5849,15a2.003,2.003,0,0,1,0-2.8292l4.5859-4.5859a2.0024,2.0024,0,0,1,2.8286,0L21.414,12H27v1.9993L20.5853,14l-5-5L11,13.5849l6,6Z\"/><path d=\"M21.5,8A3.5,3.5,0,1,1,25,4.5,3.5042,3.5042,0,0,1,21.5,8Zm0-5A1.5,1.5,0,1,0,23,4.5,1.5017,1.5017,0,0,0,21.5,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z\"/><path d=\"M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z\"/></svg>",
            "info": {},
            "path": "32/cyclist.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Cyclist32",
          "filepath": "cyclist/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
                }
              }
            ],
            "name": "cyclist",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Cyclist24",
          "filepath": "cyclist/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
                }
              }
            ],
            "name": "cyclist",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Cyclist20",
          "filepath": "cyclist/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
                }
              }
            ],
            "name": "cyclist",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Cyclist16",
          "filepath": "cyclist/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
                }
              }
            ],
            "name": "cyclist",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Cyclist",
        "global": "Cyclist",
        "filepath": "Cyclist.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "cZ",
      "friendlyName": "cZ",
      "aliases": [
        "Q",
        "c",
        "z"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/cZ.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--cZ</title><path d=\"M14,23H9a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H9v6h5Z\"/><polygon points=\"24 9 16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z\"/></svg>",
            "info": {},
            "path": "32/Q/cZ.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QCZ32",
          "filepath": "Q/cZ/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
                }
              }
            ],
            "name": "cZ",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QCZ24",
          "filepath": "Q/cZ/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
                }
              }
            ],
            "name": "cZ",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QCZ20",
          "filepath": "Q/cZ/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
                }
              }
            ],
            "name": "cZ",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QCZ16",
          "filepath": "Q/cZ/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
                }
              }
            ],
            "name": "cZ",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "CZ",
        "global": "QCZ",
        "filepath": "Q/CZ.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dashboard",
      "friendlyName": "Dashboard",
      "aliases": [
        "gauge",
        "ui",
        "control panel",
        "analytics",
        "metrics",
        "interface",
        "overview",
        "wireframe"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/dashboard.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>dashboard</title><rect x=\"24\" y=\"21\" width=\"2\" height=\"5\"/><rect x=\"20\" y=\"16\" width=\"2\" height=\"10\"/><path d=\"M11,26a5.0059,5.0059,0,0,1-5-5H8a3,3,0,1,0,3-3V16a5,5,0,0,1,0,10Z\"/><path d=\"M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z\"/><path d=\"M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z\"/></svg>",
            "info": {},
            "path": "32/dashboard.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Dashboard32",
          "filepath": "dashboard/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
                }
              }
            ],
            "name": "dashboard",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Dashboard24",
          "filepath": "dashboard/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
                }
              }
            ],
            "name": "dashboard",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Dashboard20",
          "filepath": "dashboard/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
                }
              }
            ],
            "name": "dashboard",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Dashboard16",
          "filepath": "dashboard/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
                }
              }
            ],
            "name": "dashboard",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Dashboard",
        "global": "Dashboard",
        "filepath": "Dashboard.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dashboard--reference",
      "friendlyName": "Dashboard reference",
      "aliases": [
        "dashboard",
        "reference"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/dashboard--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <rect x=\"24.0001\" y=\"21\" width=\"2\" height=\"5\"/>\n  <rect x=\"20.0001\" y=\"16\" width=\"2\" height=\"10\"/>\n  <rect x=\"16\" y=\"18\" width=\"2\" height=\"8\"/>\n  <path d=\"M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z\"/><path d=\"M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z\"/></svg>",
            "info": {},
            "path": "32/dashboard--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DashboardReference32",
          "filepath": "dashboard--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
                }
              }
            ],
            "name": "dashboard--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DashboardReference24",
          "filepath": "dashboard--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
                }
              }
            ],
            "name": "dashboard--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DashboardReference20",
          "filepath": "dashboard--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
                }
              }
            ],
            "name": "dashboard--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DashboardReference16",
          "filepath": "dashboard--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
                }
              }
            ],
            "name": "dashboard--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "DashboardReference",
        "global": "DashboardReference",
        "filepath": "DashboardReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--1",
      "friendlyName": "Data 1",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data--1</title><rect x=\"15\" y=\"6\" width=\"13\" height=\"2\"/><rect x=\"15\" y=\"24\" width=\"13\" height=\"2\"/><rect x=\"4\" y=\"15\" width=\"13\" height=\"2\"/><path d=\"M7,11a4,4,0,1,1,4-4A4,4,0,0,1,7,11ZM7,5A2,2,0,1,0,9,7,2,2,0,0,0,7,5Z\" transform=\"translate(0 0)\"/><path d=\"M7,29a4,4,0,1,1,4-4A4,4,0,0,1,7,29Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,7,23Z\" transform=\"translate(0 0)\"/><path d=\"M25,20a4,4,0,1,1,4-4A4,4,0,0,1,25,20Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,25,14Z\" transform=\"translate(0 0)\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z\"/></svg>",
            "info": {},
            "path": "32/data--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Data_132",
          "filepath": "data--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
                }
              }
            ],
            "name": "data--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Data_124",
          "filepath": "data--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
                }
              }
            ],
            "name": "data--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Data_120",
          "filepath": "data--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
                }
              }
            ],
            "name": "data--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Data_116",
          "filepath": "data--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
                }
              }
            ],
            "name": "data--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Data_1",
        "global": "Data_1",
        "filepath": "Data_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--2",
      "friendlyName": "Data 2",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-2</title><rect x=\"4\" y=\"6\" width=\"11\" height=\"2\"/><rect x=\"18\" y=\"6\" width=\"10\" height=\"2\"/><rect x=\"21\" y=\"12\" width=\"7\" height=\"2\"/><rect x=\"11\" y=\"12\" width=\"7\" height=\"2\"/><rect x=\"4\" y=\"12\" width=\"4\" height=\"2\"/><rect x=\"4\" y=\"18\" width=\"24\" height=\"2\"/><rect x=\"4\" y=\"24\" width=\"17\" height=\"2\"/><rect id=\"_Path_\" data-name=\"&lt;Path&gt;\" x=\"24\" y=\"24\" width=\"4\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z\"/></svg>",
            "info": {},
            "path": "32/data--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Data_232",
          "filepath": "data--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
                }
              }
            ],
            "name": "data--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Data_224",
          "filepath": "data--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
                }
              }
            ],
            "name": "data--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Data_220",
          "filepath": "data--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
                }
              }
            ],
            "name": "data--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Data_216",
          "filepath": "data--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
                }
              }
            ],
            "name": "data--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Data_2",
        "global": "Data_2",
        "filepath": "Data_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--base",
      "friendlyName": "Data base",
      "aliases": [
        "connection",
        "data base",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--base.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-base</title><path d=\"M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z\"/><circle cx=\"11\" cy=\"8\" r=\"1\"/><circle cx=\"11\" cy=\"16\" r=\"1\"/><circle cx=\"11\" cy=\"24\" r=\"1\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z\"/><circle cx=\"11\" cy=\"8\" r=\"1\"/><circle cx=\"11\" cy=\"16\" r=\"1\"/><circle cx=\"11\" cy=\"24\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/data--base.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataBase32",
          "filepath": "data--base/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              }
            ],
            "name": "data--base",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataBase24",
          "filepath": "data--base/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              }
            ],
            "name": "data--base",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataBase20",
          "filepath": "data--base/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              }
            ],
            "name": "data--base",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataBase16",
          "filepath": "data--base/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              }
            ],
            "name": "data--base",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataBase",
        "global": "DataBase",
        "filepath": "DataBase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "24",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--base--alt",
      "friendlyName": "Data base alt",
      "aliases": [
        "connection",
        "data base alt",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--base--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"7\" y=\"8\" width=\"5\" height=\"2\"/>\n  <rect x=\"7\" y=\"12\" width=\"5\" height=\"2\"/>\n  <rect x=\"7\" y=\"16\" width=\"5\" height=\"2\"/>\n  <rect x=\"20\" y=\"8\" width=\"5\" height=\"2\"/>\n  <rect x=\"20\" y=\"12\" width=\"5\" height=\"2\"/>\n  <rect x=\"20\" y=\"16\" width=\"5\" height=\"2\"/>\n  <path d=\"M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z\"/><path d=\"M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z\"/></svg>",
            "info": {},
            "path": "32/data--base--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataBaseAlt32",
          "filepath": "data--base--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
                }
              }
            ],
            "name": "data--base--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataBaseAlt24",
          "filepath": "data--base--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
                }
              }
            ],
            "name": "data--base--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataBaseAlt20",
          "filepath": "data--base--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
                }
              }
            ],
            "name": "data--base--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataBaseAlt16",
          "filepath": "data--base--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
                }
              }
            ],
            "name": "data--base--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataBaseAlt",
        "global": "DataBaseAlt",
        "filepath": "DataBaseAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--center",
      "friendlyName": "Data center",
      "aliases": [
        "data",
        "center",
        "systems",
        "physical",
        "location",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"14\" y=\"8\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"12\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"16\" width=\"4\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z\"/><path d=\"M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z\"/></svg>",
            "info": {},
            "path": "32/data--center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataCenter32",
          "filepath": "data--center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
                }
              }
            ],
            "name": "data--center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataCenter24",
          "filepath": "data--center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
                }
              }
            ],
            "name": "data--center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataCenter20",
          "filepath": "data--center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
                }
              }
            ],
            "name": "data--center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataCenter16",
          "filepath": "data--center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
                }
              }
            ],
            "name": "data--center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DataCenter",
        "global": "DataCenter",
        "filepath": "DataCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--check",
      "friendlyName": "Data check",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--check.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-check</title><polygon points=\"23 27.18 20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18\"/><circle cx=\"11\" cy=\"8\" r=\"1\"/><circle cx=\"11\" cy=\"16\" r=\"1\"/><circle cx=\"11\" cy=\"24\" r=\"1\"/><path d=\"M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z\"/><circle cx=\"11\" cy=\"8\" r=\"1\"/><circle cx=\"11\" cy=\"16\" r=\"1\"/><circle cx=\"11\" cy=\"24\" r=\"1\"/><path d=\"M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z\"/></svg>",
            "info": {},
            "path": "32/data--check.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataCheck32",
          "filepath": "data--check/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              }
            ],
            "name": "data--check",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataCheck24",
          "filepath": "data--check/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              }
            ],
            "name": "data--check",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataCheck20",
          "filepath": "data--check/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              }
            ],
            "name": "data--check",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataCheck16",
          "filepath": "data--check/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              }
            ],
            "name": "data--check",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataCheck",
        "global": "DataCheck",
        "filepath": "DataCheck.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "24",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--connected",
      "friendlyName": "Data connected",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--connected.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data--connected</title><polygon points=\"30 30 24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30\"/><path d=\"M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z\"/><polygon points=\"8 30 2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z\"/><path d=\"M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z\"/><path d=\"M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z\"/></svg>",
            "info": {},
            "path": "32/data--connected.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataConnected32",
          "filepath": "data--connected/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
                }
              }
            ],
            "name": "data--connected",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataConnected24",
          "filepath": "data--connected/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
                }
              }
            ],
            "name": "data--connected",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataConnected20",
          "filepath": "data--connected/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
                }
              }
            ],
            "name": "data--connected",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataConnected16",
          "filepath": "data--connected/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
                }
              }
            ],
            "name": "data--connected",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataConnected",
        "global": "DataConnected",
        "filepath": "DataConnected.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--error",
      "friendlyName": "Data error",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--error.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"11\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"11\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"11\" cy=\"24\" r=\"1\"/>\n  <path d=\"M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z\"/>\n  <polygon points=\"29 24.415 27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"11\" cy=\"8\" r=\"1\"/><circle cx=\"11\" cy=\"16\" r=\"1\"/><circle cx=\"11\" cy=\"24\" r=\"1\"/><path d=\"M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z\"/><path d=\"M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z\"/></svg>",
            "info": {},
            "path": "32/data--error.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataError32",
          "filepath": "data--error/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
                }
              }
            ],
            "name": "data--error",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataError24",
          "filepath": "data--error/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
                }
              }
            ],
            "name": "data--error",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataError20",
          "filepath": "data--error/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
                }
              }
            ],
            "name": "data--error",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataError16",
          "filepath": "data--error/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
                }
              }
            ],
            "name": "data--error",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataError",
        "global": "DataError",
        "filepath": "DataError.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "24",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--format",
      "friendlyName": "Data format",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--format.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"18\" y=\"11\" width=\"8\" height=\"2\"/>\n  <rect x=\"6\" y=\"19\" width=\"8\" height=\"2\"/>\n  <path d=\"M10,16a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,16Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,10,10Z\"/>\n  <path d=\"M22,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,24Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,22,18Z\"/>\n  <path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z\"/><path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/></svg>",
            "info": {},
            "path": "32/data--format.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataFormat32",
          "filepath": "data--format/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "data--format",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataFormat24",
          "filepath": "data--format/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "data--format",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataFormat20",
          "filepath": "data--format/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "data--format",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataFormat16",
          "filepath": "data--format/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "data--format",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataFormat",
        "global": "DataFormat",
        "filepath": "DataFormat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--reference",
      "friendlyName": "Data reference",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data--reference</title><polygon points=\"25 13 25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13\"/><path d=\"M8.5,6A3.5,3.5,0,1,1,5,9.5,3.504,3.504,0,0,1,8.5,6m0-2A5.5,5.5,0,1,0,14,9.5,5.5,5.5,0,0,0,8.5,4Z\"/><path d=\"M23.5,20A3.5,3.5,0,1,1,20,23.5,3.504,3.504,0,0,1,23.5,20m0-2A5.5,5.5,0,1,0,29,23.5,5.5,5.5,0,0,0,23.5,18Z\"/><polygon points=\"6 19 6 21 9.586 21 4 26.586 5.414 28 11 22.414 11 26 13 26 13 19 6 19\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.504 3.504 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM23.5 20A3.5 3.5 0 1120 23.5 3.504 3.504 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18zM6 19L6 21 9.586 21 4 26.586 5.414 28 11 22.414 11 26 13 26 13 19 6 19z\"/></svg>",
            "info": {},
            "path": "32/data--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataReference32",
          "filepath": "data--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.504 3.504 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM23.5 20A3.5 3.5 0 1120 23.5 3.504 3.504 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18zM6 19L6 21 9.586 21 4 26.586 5.414 28 11 22.414 11 26 13 26 13 19 6 19z"
                }
              }
            ],
            "name": "data--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataReference24",
          "filepath": "data--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.504 3.504 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM23.5 20A3.5 3.5 0 1120 23.5 3.504 3.504 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18zM6 19L6 21 9.586 21 4 26.586 5.414 28 11 22.414 11 26 13 26 13 19 6 19z"
                }
              }
            ],
            "name": "data--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataReference20",
          "filepath": "data--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.504 3.504 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM23.5 20A3.5 3.5 0 1120 23.5 3.504 3.504 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18zM6 19L6 21 9.586 21 4 26.586 5.414 28 11 22.414 11 26 13 26 13 19 6 19z"
                }
              }
            ],
            "name": "data--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataReference16",
          "filepath": "data--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.504 3.504 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM23.5 20A3.5 3.5 0 1120 23.5 3.504 3.504 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18zM6 19L6 21 9.586 21 4 26.586 5.414 28 11 22.414 11 26 13 26 13 19 6 19z"
                }
              }
            ],
            "name": "data--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataReference",
        "global": "DataReference",
        "filepath": "DataReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.504 3.504 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM23.5 20A3.5 3.5 0 1120 23.5 3.504 3.504 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18zM6 19L6 21 9.586 21 4 26.586 5.414 28 11 22.414 11 26 13 26 13 19 6 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--set",
      "friendlyName": "Data set",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--set.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-set</title><polygon points=\"25 13 25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13\"/><path d=\"M8.5,6A3.5,3.5,0,1,1,5,9.5,3.5,3.5,0,0,1,8.5,6m0-2A5.5,5.5,0,1,0,14,9.5,5.5,5.5,0,0,0,8.5,4Z\"/><path d=\"M8.5,20A3.5,3.5,0,1,1,5,23.5,3.5,3.5,0,0,1,8.5,20m0-2A5.5,5.5,0,1,0,14,23.5,5.5,5.5,0,0,0,8.5,18Z\"/><path d=\"M23.5,20A3.5,3.5,0,1,1,20,23.5,3.5,3.5,0,0,1,23.5,20m0-2A5.5,5.5,0,1,0,29,23.5,5.5,5.5,0,0,0,23.5,18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.5 3.5 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM8.5 20A3.5 3.5 0 115 23.5 3.5 3.5 0 018.5 20m0-2A5.5 5.5 0 1014 23.5 5.5 5.5 0 008.5 18zM23.5 20A3.5 3.5 0 1120 23.5 3.5 3.5 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18z\"/></svg>",
            "info": {},
            "path": "32/data--set.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataSet32",
          "filepath": "data--set/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.5 3.5 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM8.5 20A3.5 3.5 0 115 23.5 3.5 3.5 0 018.5 20m0-2A5.5 5.5 0 1014 23.5 5.5 5.5 0 008.5 18zM23.5 20A3.5 3.5 0 1120 23.5 3.5 3.5 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18z"
                }
              }
            ],
            "name": "data--set",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataSet24",
          "filepath": "data--set/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.5 3.5 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM8.5 20A3.5 3.5 0 115 23.5 3.5 3.5 0 018.5 20m0-2A5.5 5.5 0 1014 23.5 5.5 5.5 0 008.5 18zM23.5 20A3.5 3.5 0 1120 23.5 3.5 3.5 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18z"
                }
              }
            ],
            "name": "data--set",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataSet20",
          "filepath": "data--set/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.5 3.5 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM8.5 20A3.5 3.5 0 115 23.5 3.5 3.5 0 018.5 20m0-2A5.5 5.5 0 1014 23.5 5.5 5.5 0 008.5 18zM23.5 20A3.5 3.5 0 1120 23.5 3.5 3.5 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18z"
                }
              }
            ],
            "name": "data--set",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataSet16",
          "filepath": "data--set/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.5 3.5 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM8.5 20A3.5 3.5 0 115 23.5 3.5 3.5 0 018.5 20m0-2A5.5 5.5 0 1014 23.5 5.5 5.5 0 008.5 18zM23.5 20A3.5 3.5 0 1120 23.5 3.5 3.5 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18z"
                }
              }
            ],
            "name": "data--set",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataSet",
        "global": "DataSet",
        "filepath": "DataSet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 13L25 4 23 4 23 6 20 6 20 8 23 8 23 13 20 13 20 15 28 15 28 13 25 13zM8.5 6A3.5 3.5 0 115 9.5 3.5 3.5 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zM8.5 20A3.5 3.5 0 115 23.5 3.5 3.5 0 018.5 20m0-2A5.5 5.5 0 1014 23.5 5.5 5.5 0 008.5 18zM23.5 20A3.5 3.5 0 1120 23.5 3.5 3.5 0 0123.5 20m0-2A5.5 5.5 0 1029 23.5 5.5 5.5 0 0023.5 18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--structured",
      "friendlyName": "Data structured",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--structured.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-structured</title><circle cx=\"9\" cy=\"7\" r=\"1\"/><path d=\"M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"7\" r=\"1\"/><path d=\"M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/data--structured.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataStructured32",
          "filepath": "data--structured/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--structured",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataStructured24",
          "filepath": "data--structured/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--structured",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataStructured20",
          "filepath": "data--structured/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--structured",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataStructured16",
          "filepath": "data--structured/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--structured",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataStructured",
        "global": "DataStructured",
        "filepath": "DataStructured.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--unstructured",
      "friendlyName": "Data unstructured",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--unstructured.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data--unstructured</title><path d=\"M6,24a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4A4,4,0,0,0,6,22Z\"/><path d=\"M16,4a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4A4,4,0,0,0,16,2Z\"/><path d=\"M26,4a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4A4,4,0,0,0,26,2Z\"/><path d=\"M18,24v4H14V24h4m2-2H12v8h8Z\"/><path d=\"M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z\"/><path d=\"M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/data--unstructured.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataUnstructured32",
          "filepath": "data--unstructured/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--unstructured",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataUnstructured24",
          "filepath": "data--unstructured/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--unstructured",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataUnstructured20",
          "filepath": "data--unstructured/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--unstructured",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataUnstructured16",
          "filepath": "data--unstructured/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data--unstructured",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataUnstructured",
        "global": "DataUnstructured",
        "filepath": "DataUnstructured.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--view",
      "friendlyName": "Data view",
      "aliases": [
        "connection",
        "dot",
        "numbers",
        "metrics",
        "characters",
        "view"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"22\" cy=\"24\" r=\"2\"/>\n  <path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/>\n  <circle cx=\"8\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"8\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"8\" cy=\"24\" r=\"1\"/>\n  <path d=\"M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22\" cy=\"24\" r=\"2\"/><path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/><circle cx=\"8\" cy=\"8\" r=\"1\"/><circle cx=\"8\" cy=\"16\" r=\"1\"/><circle cx=\"8\" cy=\"24\" r=\"1\"/><path d=\"M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z\"/></svg>",
            "info": {},
            "path": "32/data--view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataView32",
          "filepath": "data--view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
                }
              }
            ],
            "name": "data--view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataView24",
          "filepath": "data--view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
                }
              }
            ],
            "name": "data--view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataView20",
          "filepath": "data--view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
                }
              }
            ],
            "name": "data--view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataView16",
          "filepath": "data--view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
                }
              }
            ],
            "name": "data--view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataView",
        "global": "DataView",
        "filepath": "DataView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "24",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data--view--alt",
      "friendlyName": "Data view alt",
      "aliases": [
        "data",
        "view",
        "alternative"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data--view--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"22\" cy=\"24\" r=\"2\"/>\n  <path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/>\n  <rect x=\"7\" y=\"17\" width=\"5\" height=\"2\"/>\n  <rect x=\"7\" y=\"12\" width=\"12\" height=\"2\"/>\n  <rect x=\"7\" y=\"7\" width=\"12\" height=\"2\"/>\n  <path d=\"M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22\" cy=\"24\" r=\"2\"/><path d=\"M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z\"/><path d=\"M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z\"/></svg>",
            "info": {},
            "path": "32/data--view--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataViewAlt32",
          "filepath": "data--view--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
                }
              }
            ],
            "name": "data--view--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataViewAlt24",
          "filepath": "data--view--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
                }
              }
            ],
            "name": "data--view--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataViewAlt20",
          "filepath": "data--view--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
                }
              }
            ],
            "name": "data--view--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataViewAlt16",
          "filepath": "data--view--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
                }
              }
            ],
            "name": "data--view--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataViewAlt",
        "global": "DataViewAlt",
        "filepath": "DataViewAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-accessor",
      "friendlyName": "Data accessor",
      "aliases": [
        "systems",
        "data",
        "accessor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-accessor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <path d=\"M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z\"/></svg>",
            "info": {},
            "path": "32/data-accessor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataAccessor32",
          "filepath": "data-accessor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
                }
              }
            ],
            "name": "data-accessor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataAccessor24",
          "filepath": "data-accessor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
                }
              }
            ],
            "name": "data-accessor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataAccessor20",
          "filepath": "data-accessor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
                }
              }
            ],
            "name": "data-accessor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataAccessor16",
          "filepath": "data-accessor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
                }
              }
            ],
            "name": "data-accessor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DataAccessor",
        "global": "DataAccessor",
        "filepath": "DataAccessor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-backup",
      "friendlyName": "Data backup",
      "aliases": [
        "systems",
        "data",
        "backup",
        "server",
        "redundant"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-backup.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"7\" cy=\"7\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"15\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"23\" r=\"1\"/>\n  <path d=\"M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"7\" cy=\"7\" r=\"1\"/><circle cx=\"7\" cy=\"15\" r=\"1\"/><circle cx=\"7\" cy=\"23\" r=\"1\"/><path d=\"M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z\"/><path d=\"M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z\"/></svg>",
            "info": {},
            "path": "32/data-backup.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataBackup32",
          "filepath": "data-backup/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
                }
              }
            ],
            "name": "data-backup",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataBackup24",
          "filepath": "data-backup/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
                }
              }
            ],
            "name": "data-backup",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataBackup20",
          "filepath": "data-backup/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
                }
              }
            ],
            "name": "data-backup",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataBackup16",
          "filepath": "data-backup/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
                }
              }
            ],
            "name": "data-backup",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DataBackup",
        "global": "DataBackup",
        "filepath": "DataBackup.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "15",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-bin",
      "friendlyName": "Data bin",
      "aliases": [
        "data-bin",
        "data",
        "containers"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-bin.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,2H20a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2v7H20V4Zm0,9v6H20V13ZM20,28V21h8v7Z\"/>\n  <polygon points=\"12 15 10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15\"/>\n  <path d=\"M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z\"/><path d=\"M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z\"/></svg>",
            "info": {},
            "path": "32/data-bin.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataBin32",
          "filepath": "data-bin/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
                }
              }
            ],
            "name": "data-bin",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataBin24",
          "filepath": "data-bin/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
                }
              }
            ],
            "name": "data-bin",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataBin20",
          "filepath": "data-bin/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
                }
              }
            ],
            "name": "data-bin",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataBin16",
          "filepath": "data-bin/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
                }
              }
            ],
            "name": "data-bin",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataBin",
        "global": "DataBin",
        "filepath": "DataBin.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-blob",
      "friendlyName": "Data blob",
      "aliases": [
        "systems",
        "data",
        "blob"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-blob.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"13\" y=\"7\" width=\"2\" height=\"7\"/>\n  <rect x=\"8\" y=\"7\" width=\"2\" height=\"7\"/>\n  <path d=\"M22,14H20a2.0021,2.0021,0,0,1-2-2V9a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v3A2.0021,2.0021,0,0,1,22,14ZM20,9v3h2V9Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"22\" y=\"18\" width=\"2\" height=\"7\"/>\n  <rect x=\"8\" y=\"18\" width=\"2\" height=\"7\"/>\n  <path d=\"M17,25H15a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v3A2.0021,2.0021,0,0,1,17,25Zm-2-5v3h2V20Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/><path d=\"M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z\"/></svg>",
            "info": {},
            "path": "32/data-blob.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataBlob32",
          "filepath": "data-blob/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
                }
              }
            ],
            "name": "data-blob",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataBlob24",
          "filepath": "data-blob/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
                }
              }
            ],
            "name": "data-blob",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataBlob20",
          "filepath": "data-blob/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
                }
              }
            ],
            "name": "data-blob",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataBlob16",
          "filepath": "data-blob/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
                }
              }
            ],
            "name": "data-blob",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DataBlob",
        "global": "DataBlob",
        "filepath": "DataBlob.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-class",
      "friendlyName": "Data class",
      "aliases": [
        "data-class",
        "data",
        "containers"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-class.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-class</title><path d=\"M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z\"/></svg>",
            "info": {},
            "path": "32/data-class.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataClass32",
          "filepath": "data-class/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
                }
              }
            ],
            "name": "data-class",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataClass24",
          "filepath": "data-class/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
                }
              }
            ],
            "name": "data-class",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataClass20",
          "filepath": "data-class/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
                }
              }
            ],
            "name": "data-class",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataClass16",
          "filepath": "data-class/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
                }
              }
            ],
            "name": "data-class",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataClass",
        "global": "DataClass",
        "filepath": "DataClass.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-collection",
      "friendlyName": "Data collection",
      "aliases": [
        "data collection",
        "input",
        "aggregate",
        "combine",
        "gather",
        "repository"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-collection.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <polygon points=\"30 17 30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17\"/>\n  <polygon points=\"15 23.83 15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83\"/>\n  <polygon points=\"7 11 5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11\"/>\n  <polygon points=\"17 8.17 17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z\"/></svg>",
            "info": {},
            "path": "32/data-collection.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataCollection32",
          "filepath": "data-collection/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
                }
              }
            ],
            "name": "data-collection",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataCollection24",
          "filepath": "data-collection/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
                }
              }
            ],
            "name": "data-collection",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataCollection20",
          "filepath": "data-collection/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
                }
              }
            ],
            "name": "data-collection",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataCollection16",
          "filepath": "data-collection/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
                }
              }
            ],
            "name": "data-collection",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataCollection",
        "global": "DataCollection",
        "filepath": "DataCollection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-definition",
      "friendlyName": "Data definition",
      "aliases": [
        "data",
        "definition",
        "tag",
        "label"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-definition.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"14\" cy=\"14\" r=\"2\"/>\n  <path d=\"M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z\"/>\n  <path d=\"M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"14\" cy=\"14\" r=\"2\"/><path d=\"M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z\"/><path d=\"M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z\"/></svg>",
            "info": {},
            "path": "32/data-definition.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataDefinition32",
          "filepath": "data-definition/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
                }
              }
            ],
            "name": "data-definition",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataDefinition24",
          "filepath": "data-definition/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
                }
              }
            ],
            "name": "data-definition",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataDefinition20",
          "filepath": "data-definition/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
                }
              }
            ],
            "name": "data-definition",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataDefinition16",
          "filepath": "data-definition/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
                }
              }
            ],
            "name": "data-definition",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataDefinition",
        "global": "DataDefinition",
        "filepath": "DataDefinition.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-diode",
      "friendlyName": "Data diode",
      "aliases": [
        "data",
        "diode"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-diode.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z\"/></svg>",
            "info": {},
            "path": "32/data-diode.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataDiode32",
          "filepath": "data-diode/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
                }
              }
            ],
            "name": "data-diode",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataDiode24",
          "filepath": "data-diode/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
                }
              }
            ],
            "name": "data-diode",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataDiode20",
          "filepath": "data-diode/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
                }
              }
            ],
            "name": "data-diode",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataDiode16",
          "filepath": "data-diode/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
                }
              }
            ],
            "name": "data-diode",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DataDiode",
        "global": "DataDiode",
        "filepath": "DataDiode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-enrichment",
      "friendlyName": "Data enrichment",
      "aliases": [
        "data",
        "enrichment",
        "lightbulb",
        "expanded"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-enrichment.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<rect x=\"28\" y=\"13\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"24.2\" y=\"3.8\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 3.9792 19.2218)\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"15\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"5.8\" y=\"3.8\" transform=\"matrix(-0.7071 -0.7071 0.7071 -0.7071 8.2218 13.0208)\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"2\" y=\"13\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"13\" y=\"30\" width=\"6\" height=\"2\"/>\n\t\t<rect x=\"11\" y=\"26\" width=\"10\" height=\"2\"/>\n\t\t<path d=\"M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14\n\t\t\tc0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14\n\t\t\tC26,8.5,21.5,4,16,4z\"/>\n\t\t\n\t\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__00000071558510725025777340000005803497171471724209_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYZJkE7v3FnAwrwNZQCm1kKtwUaAjZRvTY5iksgstb21qRfCZFdvfOxGH3p+NVFMUZiqID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\n\t]]>\n\t<![CDATA[\n\tUKDBBAoUGIYFECxQqKAIwKjAQoUGBw4OFct5VEChwgQNLEi4wINcAMKBg8NIeVAwgQBYqHABgoUL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\n\t]]>\n\t<![CDATA[\n\teSbtzuQ48EZGvV9m77FyaDkwZxAtlHX+N3jiG6XK3v/RHK1F8/1QrkYvLxHlDg3zT6zBukk0vF6N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\n\t]]>\n\t<![CDATA[\n\tbNWhMWIdKwnLjjasY22jSHl1R0SpVckJJWsUP6+SxBr+vCzR5rayUBLbvEK0KqpsTtkyXyPtkGwf\nrEmmf7NPMoucaHkNsymyZZbmyJbZ1zjNyeaeylRoKWWXqaTOlJ0sR5ylxESjLXuEtR/ODbNSEqws\noqPW6C0ZYe+OLOYzs7pNonuS0Znxl3RmrLnW3eys6saGy1dnxrFxVmeUuYFzNznptPZG13l77yk5\nNK5OZozlwsox2dUU7/7Te3Rkdrtr4u1aNLkbSCVtzlnhjG2zqu2oLnLajBBlU+jSmYhGuudQaMiK\nVElE1Skritsiuk2a0JEVT/2Jq4g+5oGZVzu75x508XZGobaXYqM2K30aEtbRlSRrNRbi01dZqpoy\nyg/fLaeeN74K+lRVJx6NeT4lM4RESJ+7cv8jMh7JlLCsxhePyNdWplUfG2VKfFcbX5OXj+VbdKKl\nUWFvQ3rNLVhOupmjEebNzuQyq0qvCDtYLaPb3D2PsPA5SUa/Jor1bv7Dg2QeJKPTUYqZ/5PRe09r\n42wV6VfGpCbSWR5xzopnOzR60Smv6CXDtPnwfK3pipo0Uh/UorNWL3RFWauTtEmhD5ukmV5Gx5En\n/FwQrT+Rk45khr/bT3eTQvgT0hRZEgddMdNoXD/TS87xaZqLBqspZcLhehm65q7zzfgu803ornyZ\nEBrFXDZDZfaVXK7hU6nGiWNV8pou9qMi+6NOklhLKY/x6oeUY5iIv6E8FxImXn1cZ23OIF5Nh9Wx\nvcI7s8h3SPXpnNiXNB0qe/GEVVnbR81K9Or8cO454qPkBxnis+ZWSflRcmU964Q54vkH0fssjwdR\nDVKramZIyHCuhNqjpgOm+KiE7gtlqkhSYw4hpYhIAgAA0xGAMEA0Eg1FwlHhmFx+FAAHtJxEWjIQ\nBoIcSxM5iJAxAAAAAAAAAAAiDIMAmoE4APc/vUggtcwkO6rXFPzAi0MXjNOzPQ9jHf75Pljyl7YP\nmmUrRb8DxESzIDqxxtw8qMdZ9tdWzi88+5B4W7rI5iLzpbvTo1NgoamtdgCD3H8TQ+0+sMmAyK/X\nNoL8WrWIQUH5VmzSG8nds5JmApg5znXsA1RKRH2p8WTN6OcXdF8Rtn4PxZHe+6auXxUX56dEhxtL\nN7uelm1Dt9kClYyRybUaQg5D7RIBG0ff+tp0FFFbozIDeh57+FyWU5QWeHifElDjX3gDJwWRIYO/\nyMXtHPeztKvB5iJNHYqzkRbimcrx6tyfxzPV7OOa3Ukl0tsWfnJHKDu9NFNRv9tBIeqHPGX+27Y+\nVjm0xK/BJkzZ81w7HKavc/gtycDpmFhV/AUzKbVh1sfXU6Pb0ISFKt4ivWDV3lUkYpMLAHawkLg0\n2CSjr0SPwvc0BkgEubXXAGtV3b3v2nzG9ddJ/8ZibovVOiYf4ap43gIWNaDUmCt3sTD6tAE3yim2\nUXD4YVDbwiqy/ASwWUeJJIRW/CxmCPTgDD8YqOPTrAc+FQVZGSluRmYp/q7cWYOVwIAIqR1YWgBw\nYFhVt0tyQPKSTP3GuuE8enL60oUb8/RBIdXUoAS0eSsTHtJAdyAriyR1vV7TM3/LjNnEunn4FMsZ\nj7x3sQPzSgpiiRG9eABQlraNWCYh+cxFyiZdRBfiV3hGlQJGNH+n+AEbuiifnTsWRuG5/w458Rzy\nVo1qBRfXQR5vT7A1DHK7o6aZBE20vOEKXbJw0kj04Jcr+IrXUtGBidTo8GyPs5vuaqKfJ8Kfr2qX\n8t/QHEXngnnTXPi7791kRpE9PJJN5FU3BY4T6EX6sLgsnUCN8nb85qegh82+sYFLeS1hPjTt8+xy\nToz9gIFoG00+eBXALMJm41LkMvEa9jKlpCG/+MEENjT4cbmWxFuIwYk8Qq0Zhth/AW+BVdofGYhg\nJZBtO4PoSjA5m53CLEGIiD4JF+1rmKZCOglfpVCMZXz28fF889UNECOkJAgxUn8ywpqsQdGaHcTr\n7x9Kt6kzbJBXHU2nmP0DJBXMrg/Z4qthfZsP8tAarwVKQI86x5NKDLUHDP0UA6FjYE1LN8uoeFzZ\nJMe8fc//uJbDlJ0LDY5sEDwfq1w2BAbCoa1BCAgzqGwPqtvnKkchYKnH16AsEnJC7+vzMSBzCEEu\n20SCd1bEKA9IuJVB6PtX3w3nzKpc0hrgU1psVp2jtWwnQXQu7p0J0R2d5zCLKl+Bv/OYTnbg1iln\nb62CbQHoj7GMkUDehZ98YGp5qDaTPR7iLQgKzlwwvRXQVUUq0bI2MooP35iN+6OQUa8ehDNCjaC8\njE1n9t8WLCV1MvDUocMs6cm69DHe5G2CT3Sm/7CGtF9aJqPZIwlAeN0vWRc5bifmxQI0flBTDu5i\nzn1Uq4uQmBKru/0yqgcSK9zZS/p/rbN1YyVdvbsoqOZZQmrkOezb6V9JkhsMApN/nOBtXPrOltDl\nASf+jazJNedjF+e1SyXTwMI1Pz5JfbfbaCxnNb+CqgzaRTcJwgWV108hGR/YLOtDuOkRptLHz0aQ\nyQe58QHou0xUfTXPUPNTxb3ZwpJVIWSczwO6oowOjPK5P/1RLAa1+eesVrXdea8kctBR+IsG2pbT\n1q/jLFvnIT4NERr0JPCmWEeHyeZjWWqDY1hbP3VHP8IDboHCAuKSDyx+BV3dFHHzRsboiwqWh5dD\nWk6ST8B931tTnuTSR4QsT6C++ohQXWK6Espd3ew3n3hclL4qAINuGjJlCg1SAc1axwvtFBq0OveT\nTvctW1OBGg/+lLgjxadReVpkeEo5CU+NQixbsNktrNd+XrXQOLudDZf4nKSUk3ZQNG5n42BEvOMz\nc1QiQvPMMke4qx6NHznOIBdAzPsZ+4L4+3Zo60vQ2PstZ50+TFS21i4wJ3vLlsIvJB9IKYCs2iOS\naK4wGiwEdAJw9FUxy/Ktl+lFfgTHVXiTcpkD7RRSXhSaY25hzvbcukww+seOdn5+ChNMgNQaPpso\n77qQnHaaMDWb0aWOnW+hCr6iauoN7aAam9HAmpLqob6nLUQqZUMLpY3N7KITq2rAJPPJ2yYbUVRC\nFDznt9VFZ3JEZFNIifh3iDQn3BLBfpu8hicoQKa0fdgpHjZzUwMPHEjBFUf8HupKpjeAIAnkxWEa\ngkNAPAWhKpSNM6emCwUQRzY0B1VafQH4mZg25+nUjSAPyKYkS0JFFYLcCp1w5wfrGw4etsCAPV+f\n39ZTytIhbib8CxjqqBCkPjI9oVMaKN7J6m6zTlUIwjIkdE5KeBI1Qw33LowubyFTtv0vo1gAjwRo\nLQfQEhohwmy6Kt8WyjcYO91+KwRDZhTTJQTqUQRHuUrpEr1lKdTrXcbwuTjfdiacLDkKoUVgBrCO\nWM96ckmPN1VsJWAePkoHePyD0JzSAk3718J0SGXIfywk1JU/KEcUdDwI/OyYUX6bCt6+0zmIqwTf\n4i10eV0bP5JWFCaeSf+kjnnPQ6QdSIkmwAAoll0+fl77LulwkjIlnzqvTZxTvcoaZ9RF6GDC9ZWG\nItop2HXWz7E+skhdMdukTFQROqV26UUTZJMViU7ybKyXu5WqHglbplCzrMgvahoZBJ6JZ2DWqScd\noEi7ANhSIW14T39CJl2OwYhEb5Bzr4iqh5IjBwDPOS3dhPf+wPfq0wUwkgc3i5o4qZivkvNrKaAp\nTEZD5QngnC3hpBh4k8ALvbVspzggv00WAz+B7e8qzqI89aDvwfAWROqcuvW+8Mu6dxCmRiYxtXwA\n9O0y7YhMm14WlTZIQkO54/37SuYfwqrf9hBr/sLNfNW4BTIvjDDRWI3Mv7wsEC4WUnp2eUdXj8EO\n9VigTsM3LtMf1VQHSZQSJf0gaImDqBaVQrA6wuodEgRkZHe3dfaYow5p5QPiafESMlGjvLVpeD3B\n6GfkYIH48XPg5xQYTxZZszjR7EYdl3pj2gFSFB3pJ1tI/j6x8saAH2vVnrhCgDxdj8RiFgQiiouq\nZzqkA7YRrzbPNhmbSm3AojRZIDUku6mSsJdu3qpxCAAQDYLrPhKv2+D1kfGXE01CNrXaU1jm8TKq\nmlsVqx8HM1l66w+F0ylrHrIgNNXMYYPjmR/IXnUm1nLXKzQHDem274kZhKiL5Cv2uip0TUrPdTID\nGjgNb1v8xc7fg4xv24FWt0Fi+gJCseQOF8rB9H4QWxIUW7Wh5rjioP0/kvoSkeVShz/dC+HR84SJ\nwFl2roQ8Ys4QPYU/WjovL4LornKJ1k8HJzEnXFmlOVshEe7ti+o2oJEFcr8SQX1iE427riIaYRnT\nt1p40BCGWVmEliKRPvzw2wkfL2Rn728UB0/1UusUOYIwYkymKMoguwEy0GE2e8SIx32SvX0nYVL/\nVdKZqZ4VvOS1tYWlgaga7pA3m4U/1eEQVGN5ZeyyDmIXfXhFNjcUBx0Zih3AoEe604lEp6ImN/JH\ne+2SUv/v2yCtwrZ0ZE/n8uhIvY0kf7Xg2mtpXIJACoYJuJ6d7NfwHqk9BMxkyK9He+fN5ITiHc8s\nne+bYeWAaiSxhsITY8Kn3LKgEups1v8Ke1nQ1wZd1Ed1jS7SfDl/HIRQ3Dc0ZYIPxkDeLU9arHlF\nihKbwUzjV7Zob+otYxNULqbRLtR1166XCtH0lxHPlUMozSs+1Fj0ZSRszm3xxH0vA/lS1OTtFiYu\nFVdm7WL2fQVXdezIa4zyT1HvN8KwWOeRbFubXCAF60Ob+BAcrv4EeUj0mEq7c2h7ldUxa2IQVX4H\nWpxGPR0toB/N2obQ25e5t/oXkem5vh3LmViRUPGpwSKhm4+lBF8DxiMNsgG6Y1nFdHA0UV1JcNtk\nZRUCt1PNEuCuANaQ7JX3mDiOfTpS3UnhYdXwrIiCwZBsXqAA4THnz9TrVj8fhLcwX3MAnNfRb0WE\n6aDlVrtXLFZupTAzhwvsBfaG5TBod/MqhrHPpppty9KBgGclm69u17kvTxR/7dtFAmjd3wTCPUEA\nMM5+7AKxBix1+G7/NrVhBajm3RxLwuu2qIozNcwPVgn3ftKvGX2T3ZOvkBy1QWqXOZJ1ewIbY9s7\nB3COttmpv9tv+iyoDMo71sJPTiVqLO21VQStvIfIDbsKABVhpB+2qG//sC6L0z5oU8K/0GsV/FSF\nwCmxYhoQZSihyU3GGwCYuQW77MjOn0CRhDlaCpShkcqKyP1Ntr7stjqTUULkgduBFciguljJ2WAT\nW7DprNI3wNyAigsPUf0eYj/9DJNMvMXPvXlfP+UvtJafoD2pOen2P534QfirCuTtvBLmP5uANCoH\nZ9X6itUD0It0weFCBKzTx5r8g9cM8vVDRd4yf6mS9+1OqXKxbXoAHtcM2/OaWfcNEy7uoPTh8TxU\nctTLscRgYegErw2ylRo6cwyfR6J+WAl20Q9fKSvsueC75QOtqi0Xv9KeaWpYhWFZoIBb0yUyeacj\nZdMtJfFZLff1UQFDczzzhAqRxvTyaP7MaVzfPAbOKvI6LcaPF3cKNxhkm/0/nP8r0w==\n\t]]>\n\t<![CDATA[\n\tQ4V9eHNbN9EdcPlUJHMf+v6cTsQzHE3NVYXDWYmY9TJS4QCSqi/b87tDTG1YnGKBBBntnnQIyG6g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\n\t]]>\n\t<![CDATA[\n\tzpQQT4EMoP6lIzCGb0W8IRqcOM1kQFcrAD4cdtqTdQHJNllVXlKqnEPWr6LmlYmsCPrMz8AIZA3c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\n\t]]>\n\t<![CDATA[\n\tIPQkXQYpelRUXNnwiqe00S2gszqC6Gn/jOMlepKPx+b3Yayh9IdiHAH5s8FtPf1dQXWls0DqYdgx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\n\t]]>\n\t<![CDATA[\n\tiN1huYIYNdSE6AkmSW6FVyURUPi41ILng1JO8JM2+AaoYvb11gbxgRD+7Nvk6j0dqF6zVz30vJ6Y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\n\t]]>\n\t<![CDATA[\n\t5XqutQQI+pcbCdV/v5qUf9GUQH+Znpk2z3WFugikgjbd4taoGZQ+rgjtKIDLMC396bUr0qO+DN76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\n\t]]>\n\t<![CDATA[\n\tengByUCYyQ1OEuzwBaYWHM3AhwH3lr8wVdbs50aNJNTrdP5HtRjxRHc8tla7MSilORFPaJy4sKjS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\n\t]]>\n\t<![CDATA[\n\toDIFGasmHP2q2muivNCxo9D1xJSUqshlqpgqwS5k41dN+SR/N0pRsGJjV7jCNe+tIK7kDbuoLEEO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\n\t]]>\n\t<![CDATA[\n\tkp00Y3HcBfnlkLpTwt/1l2aw6Uc33ASkzKGJoJD7Q5inrGyWfHiAzMbZtmWhcJaBuQqfRij4eDyy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\n\t]]>\n\t<![CDATA[\n\tS/NuZ81hdwlWU2Q3WagKvNVx7DWREsz7+HWzFTGwMfrl7YbOmWsQw+Cf/PjB26kP9nlnIPCLJUdj\nPCCcSsuE3Vv+9f/u41BSvPIXcItLmrVcxsBy9lqm2HS9+gQRcUSZpxlLxcFzRXLTwHNszghfMLjn\nFwo7NJWAdTmX7xq8TvAjzFtftA7tNAqVukMuSy7NEu0M5scnOGVYz3SdIxiy9yKuJCeU13sGUqtB\nICdjGH3Son6J2SutBiKs8CHQv851pxqBk/Hga2TklpRI0uaXRtT1Znxzc5XBFAdbw12klWGlKKh+\nQYVFSwwaEkcH1TjBDa2vDRMhQNltaI2m2OsBxbYQppGoO+J8WrQM7F3hEiTf+n+hGWMS+OKdGlHL\nbRN0dQfMNWFhAYGNy2HO41nLDrHtQHfmy6ZqvRiMAfj0wS7APKC51gYfuxXXVz0LX01nH9CzewH3\nrs92/sWiLCfwQ3z64beARI+OJHAvfZeTuGE/dWrqskF6n0DxdogYIJInUcjHF/1Ud9LpwUgc2mP+\nm1bDnQlmN9TQ+kg182Mf2WEoHCxzLsIE1AwUTlsNt9U9hDQRV4h/u2EQO0f2K4fbyb82bMrIOSMz\nEQXCSvLJULJptKoUqu5gUZ249a5rZEGGjUguRnnCLI11ItFoUnU6Fm6EoR7fmpV4uGE4FgKDcx+f\nIETp1D3U/XO29zznJojIisgNM+2MsclmGRPNgAttKU5CjmC7K42StamhZS5KrRm6LMdNSCoDhAni\navMciBUnB30/yPZIZnPZMGAPFIoGqdq11or/EAXilVcfRXu08EaSCBcoXlxnssiQf9cKECTiGp8k\ng0EgeAIsGFHedGXQDx2IQxwhj9T/xd9ocU+9zO1gmdy9fQNVOcobRTf72w6xrYWS7teTC+3GLviu\npE9ICt7eogNVEM/vV12TmvyAqeRyQqe8M2gdrKuZ5ByBV75wm8pyPOQTRowVKKsvjNJ++XnGv2jA\nGKp3WUooicZEpW6Olo3uYo/mOj2uFobezbFa103C04tKK8Tm12SRiy3E6EuJ8tH8xim7E4X5bYsV\n5GzhNJgkXBknCkAu/0YeQiWRHBjBGVnefaIYUZJJ5kvyXc4KIPtQSbX1zbn66OFNxH4aMH1A60Ek\nQlAQIFIdy0S6fbkjCT7nkQ3v+GB6qbJsH7Bw1cB1/HlQJylATMpSGnQin9nlYV58qCM5/8RwC9+p\njUAEtSTqwjPnccG6/ePo6wkN33HJWbNJeB0fGKZRsWsN/Ztao3LzOkkf4dq8tGk674wENRulZJgp\nDIUu1Ow5YetfYHt43nHE5aymHj+LVseywAdz4krOk+VI0J/WWrk1CXSxZpe/sx8RElxGdLi0RuXc\nSB0A+swYWvmfQ+Uu2TPd0h7Sj3f1bJKIkWoGq99uovzszdGNgMByj8qKzmx+Et/NABzB7Qun/YYl\nrf4aEiy/GdpP1oi3glUGIRpwXQKcEto7SLoSTC7baWLUs2FO0E7I0S9GxIinAYtXXoluVgauTZd1\nfkfGsoMkTVQUHbNlJmWzzxqMu8WssfTWRbd1XHRvQ9khx40RP+t8RLenYik9CPQQewjZ72OWEvK8\nd7Rem8cb4Y0nYiVyC71EJW4JCqoRYLh1/PNzYzbQEB50oP/4eGCNr0LSQfpDfa1lr33Qh8UdxsFY\nODZnvSFU2hg0cRbCCHxykkY5YJ/kwUrgEdtAFoMpp5KcQALefXmebKwLWzN6SwKVXbAHOg4CJJZ6\nMFS83OgttZuY77++7UZ6xr7QsKD7CKzla48xO6a3WgfZOIxsUiZKkV30wPjhEDZV/1HlKBFvx7a7\nZuDrCt2IT9C86Tq7wErryPgfTYEv2FgTznkmhAKWpQJ5E0FDPOTQK3ymodz5FlU+tVkytwEfHuQ3\nmi2XCwlIf/vumGF9sa+w+D8e5evGqpo0bftqNuM6dIBiONDngKreHd5G0ijs9xMFW6kbN/aA1hvE\nqXYmR4B+wT2Vn1O643+ZTPXGAfwkMPk1OTb4Q10siE/gNGz8NfwiX1NRM0T/nAMiWxclzUoqEEb4\nvKB2mnOFE+JDy1YZ81Q6CBzwsaNCK3EcZL08CBRi8xEvr09/IRk1X6shDb/kCTk/3DtzMYYgASAg\n8f1rAsqQOy6cLAZADgGEd4uz3yp97SL7GqSfu4FayVXDiDw3gEtJfAkYGDReDeyLwJQt2Hzu9XiK\nKMjO0crPBXoYb0TYtbfJQpyzOiA09Y/uNqJIfRLtNHNd9TPQHpFMtlwJoQrhniMyhirH9Rh6GRnC\nEpfYTjb63xMM1o4y8j7z6obD489fuZEiniic2wZCg3O8POCC63GGrBQ7RvW09r55SN5INSDsEvUf\nFoo6XKeO8SmXQ2O/qTenKtYmf7EqIHIURT0MfcTAyFg9sVm1Doz2bEn8xeg9GQjDI2vtEj88Q2BD\nOIZwQGJ0v/P+kZHfHboxzRwELU4KV6qYzzSsmzml0WvC4LixRAV8aU1jpGH/xIKIUiSEtAMv5lSE\nBTcuFpKJKsORKgbVcSn1cBQ4grTJJyBQq7W84dZIf1gnUtXZ+dG3UyEIHsdjGUtLhNgugc+RQ5pE\npEr6IqnBCC2CdEXa5QoAc44BoroH/BaqidRvnrnWY6bg6a+MkKXVltPSKYGkPbVuHLt2MJZr4PHC\niasNJ8xxFwGv5sTB3c3dxv58ttN8U2TIxMIggqiSILdsjegEmf5XKrCajn7MHnOGBRVrjQtP4iXA\nB9Maa0gzCF5u8VPFAKaYkR1r/JTCWwb/s7h2I9FO9ChZN3RdEJSfDi88VhaZ8tI+UbjsGHkCdIMb\ndf1sp391qQvuQDTsCO/JP4810TOgsEbJKT8bc654mpqux5GzIOaIvwVCW/S1M9IHCVwqXTu49ILi\n9NrVRWeFoALLpnT4G23KtAdbJrpy0Jitz1p8L0cH0TvhKx+BCAnIT6gI4eVupBcUmSodOhU0x4Wz\nUEsOY/iN5mPtPOF4qMa4PvJSoTmOYxjmYJL18cfoimsqGJ6U8Y3zicfVKWGT7PKQzTCwTAjlQakP\n5662s9r4fHcjEidC6CRdyQIUqMnQRbc6i1c/4hSuPGSn9hBSdG+BvSIZfG0LZkQpLuxAGwNltr9S\npJCENYehCwP6HqtuBJ733YRUSp+oyVc2FOgsBAardMFdYf2qosbXnOMmh4bP20Ck7jOuIizSvGJI\nMsNZmiHCuOqJQMrid6ehgDooY2gVo3IiyM2/h85Wy/T+L7l/fpywrmiJhKgfM4QM0/lsMWMVoryi\n7CUHgN3YRs0c0+rEtLwQ5p6zEyKir3/0EUH9KOoCh5wDeb9KasxevH0EUo890Aj/kxbd31teQY3z\nQ3fDeigYhS3UCpU8iiM+N1EbRnT0cee684qub0DctLHuQ/+Q8sPZAtVoroH/ADItoEftPFaZuX6W\nfPB3aY/Md7zWUu/zoRTGkHtu4hpAQDCKmNCxY04BN6twrGXDh5gYjuyxdX2G5fzQuT1QM/ZxMK+t\nwrLj9w5awRnnpMK404rThYUcAowrNu4UqCS7x8AghCY/aHcCrK47Rahm4FGRMHZDKf4cGHEt4+HT\nGA30079xP1Qxjdb2a0qSuUOTbRbeF5WCgOaD4XcrtaKYS9HO4JxpyXlKNvER0fxsRjmrkLtwgOB0\nbt+yQaFw/FMCKg4SVUqnOqLifG3DtMpRwjanxPJ2++0WCOwSoPsO8Ztck/yjEytQJX2Ac+ouVoYm\nJu7h43gha/kQ27CBv2OUHH8N6IKoSYUSGOtGtZrw6Clv0ZK4Qcpod4PlSIJV8j50cBnBsyNX0SBH\n9wQIT/a1yY+0U2iSpONW3VOAuNrp8+jzebT+Phfdv8EY5R2e0DCxHlEJ8Y8g5usfCKOMq0BhMu24\naPpsGqfk0Du0Lv95g2KlGL0EEDf6r7mrw1Wz3HVP5EB3VvBlZouDTsCfgHX1IX+DOx/B5z3as55Q\ndJgd+w2u+H0aVD+SNJ0f/A26+Pwc6PoQBu9sa1FFgHwkMayw79UKKveI21xhmR7phK8A6LXLgJse\nGV9YEHOOBUe7LNClRxR9FnbyiGjUwmopcsoChS2Y25HScwtw8EhFuIBqMBdY8NUFdu9dcLDzQg0R\nvsCnyC/YDAFDh6dgIOOObBOGOZPDYCY2MRQZ4tuRuxeDSIHLOAYPCjJUqJKBobApgwPfMjQAmYFS\nOrJvM0w4R1g7wywdofwME7ZDg+A64oA0jEyBh5LjVDrSZkif61VDh5wjEpi6Muam4VMc4Y0Nkyxn\ng6MW20AEjriHG0aE6oa0nDcQwfoNnLqRrQWHKaXhYAEWhw7Gx4HVQDmY34hdzOGpG6npHCDbGElL\nripgsZFKdGhkjTgwHYqy6sCBGrFeh+HRiOHZYfMZUbodxpoRfVHM3SFXAA9klhF+4oGOLauNPKBE\n80DLGDFGD8vDiC3Wwzhne0gMRkq+B5J4+P34ANEvIq6rFzkF2kUURB9UcpFY+zAAxw/ebovYMF5a\nZPmnD9WguvwPT2ARlwPEciui2FxF7hCIaamIMwMx5RSRiCDGpIjoCmID1EeD4A9LM8brl0j4gEpP\n5F76R9ZxIqcAmsgdCwHl8QpDFMemGsJREbEjy1EkUpXxAjzePYhsRsRaI4K6NRYLuz2YJYIKESmZ\nRwwRmaAiNKJVyA0kDeE1EOHsIjb8IZwYsZwPYW1GLOohRGvEBOoQGDvqsYvgaUfHCx7Cp4/gXIek\nAwk6YUhQziGUFYnp4hDoI7HkDWEoiblsCOKYxE4NAeskJtAQeigxvAwhZErsjiGIqsQYWXteiWMs\ng5wFX4jtyDsw+hIgDi9hVC0EEDBBIiyEnr8EbawQ1mGC+KcQsGGCjVEIJR0TtHpCWJYJ4pkQ6GcC\n1ibQetREWiTkH5tYGiG03MRorOGEHRHiypxYhJDC1QnEsneC8h+E+DxBag/CDT5BaQeht/wEmxyE\nJ6BgcYOAMyhIpkG4qULBVgbhi4eCnfWuJQq8wSAooYuiqQeZG8UILMgQIMV2CvJaJilmbrADQgkC\nnFKwRZC8XAqWIEhpyAORIVMw5ED6QTYFoxxwO0UAGAgrflcgK38KwVl+4BpRMcSJVJhFIDI0FT0P\niDKqKM+A+LUYoAICs1axQ0AgRBgg3FcxfACZcazYBiBIaMWY/wNMtmIy/0ETVwzVPwjrinX9A0iv\n2MQ/ePoVo9kfuDxYLIYrCIjF4viDRcbifDYPtB9Bqnj/ftCVBbP2oyLNgrN+JHsW5OhHb7Qgan7E\nPC34yI8E1oI8/OiFLej4Lxq1RaruA84tCmwfsr1FHfsQSrhoaX3IxkUR6kO2XNRHH0I/F63Ph/x0\nUbP5kFoXZcuHUa2Sj5/tQuP4mH4XgomPB+SFrvAxRi8kRntBJzW+yAM+SvYFdu/RoV8w7h59+hew\n3KN2BgwizN5xYCCoPSwuGNuyxwIIYzkhWlMYT64HwDIM1g15fB7G5tRDImIMnh4Pmw==\n\t]]>\n\t<![CDATA[\n\tGFulB2jFmDJ6UC/GYNCD8Blj63kg4RhjOA8+jzFH84AMZOxfHkhFxmjlwU8yBk0eMJyMeciU4SCv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\n\t]]>\n\t<![CDATA[\n\tnuI1kwyESV8zQCCMBzbTAcJNDJvtFlV6yTCA1mR59mMjpz9Aycvo6wcimE0lfmDlbAplH8iGNqXQ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\n\t]]>\n\t<![CDATA[\n\thu/cg88qVlHftPBfvWU84jCcRsL/BKGAwo5S0Kd0g49fmV97JM4qgo/kOfqNCsoMgQ+TUBgEPkm+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\n\t]]>\n\t<![CDATA[\n\t9n4gUL+tpb01gSnd5IaoRtobPycpO4We9u4a2UonED7aTHuDmctjvGlvNPOTbMBS0HS/pr0DVmnx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\n\t]]>\n\t<![CDATA[\n\t5zU0hcIigAKGQaY17B0UXbVKwWpqr9WNTwXW2Sr6sB2FWz8296G3MjIkvA6uCgfLinEd9gWNqsnV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\n\t]]>\n\t<![CDATA[\n\tEDDHfuxKIvCRGA8MG1vCmvMx6UFUnvZQ0sa4VXBGbMr4WpgsdqjWsWQ7M/DMF2cEY/YWu/QoXGDG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\n\t]]>\n\t<![CDATA[\n\tMe/vGMLJ1JXRXAYDu7rJYkym3b7BANVs1g9OWSnT+40oA78Nn1u/pm3lnC6cnbQpaOcMxn2avbRZ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\n\t]]>\n\t<![CDATA[\n\tRY+CthEl4K3Tpes3gW+957DOFoLk+0eYfvcQJJ+t46XrOl45m0i8ZxNR+n0kS0EbKXPwE1H6faJK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\n\t]]>\n\t<![CDATA[\n\tlCx+0IoV+hDLAOpM1ClwnpRLvKKLTRhFP1v1Ml1gUcPskeWM0kiXrWYBWNQ8N530VXZ/xLgE9zDR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\n\t]]>\n\t<![CDATA[\n\tVUrlCEMu6QY0JmmpEoYdgYrEb0Uj0iNQkeCEoi2Bx+b81QT1c1gi2jO0ftYgsqTSXFROZwyso3ID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\n\t]]>\n\t<![CDATA[\n\t5y2sjsoeqKDSVSooa6DEPW+HNtfswdGnhf8HUc9f07ZZmLKO5XY2C1NGY7kt9sVDWOjArxhk8a+t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\n\t]]>\n\t<![CDATA[\n\tgAi2sQFf9FgLCAVjFhxqTtBV4HReC/iGBEwcgQ8Rn+E3OzJC3MKVAx1LPC8DJhizWEQ0ZQ5XUGWs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\n\t]]>\n\t<![CDATA[\n\tR838cCO+w4N4DrfhNjJcJobH1PAaTnPlMTO8hsfwGc75Db/hOrznasQjMGhw/VPbEkJhyBVhnKND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\n\t]]>\n\t<![CDATA[\n\tndG801qYsZq+jvWai+j64hsqfLiy2TIEHJQdhJYS8hYrqWxFY7IraNHYpUwccnI91YnDD3VaGKT4\n55csiRgB75i1Lc2xXyE4HUIELwsT2zmc81c/JmurHZK1EWZgn8Erk7md/dpDw8Ko9TD+syKuaR6M\ne1lE14LJyJXNOYRwtYzdlGniv6qhST+gIa6lVBF3wHQ/5yvXqVwUfjAtqL4DF1N6CgVi0uWgfUQZ\neBM5Bv4EJA7HNuj4vLV0iIEa8wyAFtpOouAfA3fTNHponghyb4wnPFfjd+aFFPtuI0m/+yhScHsk\n/tseWQraTJmENxPn1yaa5LuBHO/smry1LhO3rWn00PzQo96WJzx3y8CRzTN5W0Kv4FaoEdAHReZ9\nmbwxmSgTcP6gZNRrSAK6863zNHlotczcmdyTmEcvjXIh3BDXT6NhnjCdncOFs3G6bX8Bi8YftgTV\n3kri2X8M8/6N3xwN9KjXp1Qc9gxTSGUwKCN6hySmdNNmYYITjL8KBeTPmiG2E4xwtJEku/bSZXcL\ntJhnILTQzsKB2R/QoMzh0vUbv7nax3CvL2V6baRKbg0fW5+5O+s2fmq+Ji/t3/S13TeAa7eNX9p9\n8/fmr2pe5liuL779AlP6HPRPtBbG7tkPXCG41gvsJ1HPVyjiOVtgQprNCqI5b4hSKnOAMkonWJH4\niSD/JPfupcyuT2He7wnfycSddf6xWBgyOkvzhzbrfOO+D+KdRwoF9FQoGLuEIpMeigT4z9ShaWHI\nZjAYM/nrCmdjc8BzM9BjXq/5c9Ne3cjEaPjWtE2k3q/UKWjX8Ll9KSs+GxIZWw1OsKwk5iSjX0k6\ny7pWP8emSBPvn0M+n+Odq5HEXPsBDcq+JCro7Vmk+1MjCLcRbkjaTaHcOwfc9ncM5brSZuDN1Nm1\nl8TeG2hRzwstAiJtAto2f20d5+vms0hnT40g3F7ZkPxMoIJbm8A0Ixy+OBsHUK5z5X7N3lrNbbAw\nvt3rH7Sk0l5NUuslypzAOXsmjq3rdN+2fjd/cfWROPBXwWjsWj406aoUj/4oE5BI/DfhyGabzwnL\n0UaYgbSFKKZZ/6SFB1Nyaj+YIa4PqC52CTsqPZVqoo0kGTj2E867fQ7nxoQi92yhyD17CJIP68Zl\nEmbX3/zBdRm3NrnHEA+pMhCo0e7O8brZMnHbWiaurJ6JO+sxZmN0DNtdX9H6zLUcRMCYabE5hXC1\nT+IEvKNKEb0S5tfe8dJ9okdGJs7CLsEHqFZE6+mX0GNzFnrk+zreuE+Dh+Zx/OJ2vnM2TR0bmp29\nqtl0zNsYbePXRoYVi0JN7GBNRu8MUEBpIUo9f10bw8rkpWGLNv9qrByX9AIXjkCTenPTabiOOnGI\n4IRjDdbk1O7i6HF21uri7nCFNGlSjqwxQPGkNbSK0h6kjHYQUEo9V5LPf0WjsisY4ajDtetTqYq+\nCkYjDFqdvcLV2BrAtVnq9NDuICXUc1iyeRsw9d41gWn9hrvWkTQDf1Mo4W8CBf+hxz+PJObaUKeF\nX4dwzl/bvPYaV2NrANVmDq2gnoMTTnsmr4weotz7TKRdJs6vjdM353e4eJ8I8s8ulEN8Xd3mMCZT\nb99gwAitjXZrkTQD/8we2gzHmquKaM86MR0LgzLCe2gt7RukiB44sVhDlYZtJc2ubZTJwzh0xcyR\naWkpLfpgDiFka0FkbD1IUZWnThV/1GjiF1Lsu3m4cmRDjXpjUafg22hyQ5LQWgQT0G2FIp8zk2fX\n9jHc6z6FeN+IUtBHoSbqeOVsmbiyTrNn9pNod+d4226e8Nx9fau1MXBdO4OXppXRO8vigNkorIZq\nu6qg1jMUFB67RPV7SCL6pVSjTg/9AhWOvseLZ8/cnfWbwLYkSsLv1Bm2fxrr5tRoHkI6si/GO/aL\ng+DywLu4QAAp8nkOUkZrCUA45aTOwZ/zlaN7Gu3opc9vTYVC0SttervnX92gByTNwIbkvOFLCSzb\nKo1bz4aNM7XVGXeGJ6YyghWLNZWKxXoBjkd6qoUhbfVjcrYgxXOWOlHokz4Fr4RYzhmgkMoakoTW\nXEpI664kpP/rSOgYiCWfNxaNyx4wnj1TV1Zf27zMZzERV7M6u/Ot8wxmKNpeUDrHOizxtJ1MCT8N\noNoskzcmA0HieReTdBULyG40GTiTV0bDlM1iMGldu0NY5xe8ULRBQPHccinptJlGv14mz0x7letZ\nHEK32qiS2xOsgIwyNfxJmN1/gMThEwnvfxpB+HfCcT9mjkw7s3eW1VmMm6dWJNIUknjOEoJszlGj\n4Zsmb62eoUObn0bBNHxpdIybmczjvbOZPL++yoZj/QCIeMbAGiqDuIJKAYioLGKJ6Rczcnp3WB2d\nQ3zxri0Qc0JubNuO5PhhTE50BKqRdd8NtLh3wxfnhRzxxqZSDW0GLhZvJEvALY9hnVfS5NoZVjV/\nVxLOsQ5LOu2sH5T+x9Avh0vXdbhzP4p5n2iS717CHNwmXQ7eRZN8N9Pn4G2E+eeLNvv8Tpiux8Rt\ntTJ39lwDqDYvgX7RmsCww6agoCHgwJS7Dteu83zvZN7MiiIB7asfk/WHJKE2hiWe9ZFm4PdZpPs/\njHl9yrRw68BF452UGXjb/Ln17IcQ17Uay4NYV0+VSIQqEfZB4rxOk6cmw7B1MG5rwWLizMRywHOz\nDiKd7CNpRxtxBtIMdkTOY1BY2GlGXGzBpIzoG6SI0lCqhzXSJrdLpTDsF6aIylwHlNJhVVS91xXS\nj4DF4TfC/PNQJcKdAQzIXrVismMBoay1hmzOXEg+P60EdSwsCaq9dUSUtnIRad/wwf0Ytq08c3fW\nixz/theOdPYNraI1hyqiNAgnoPeFVk8aisRh7dOYR3T5V1e9iKwtMCHVYigCSitler+NIFttE8jm\nkSoD7wtGOGsNraK1himidAcmnreWkc35CbWw7lm0o2u4anMPYh4NhYpYT0ACqt3QhDTpE9APVfp1\np1Rw11pyWW9pEZ0Z0Gj0Pop49ZXtxtL8qWmRRv/qpxFh2sqGZL2AhaNP4ux6p1JwT+DikWYa/foc\n7lzNA8arfcJ5Nw8Yr+4p3Kt3wHqzgheQdRiTEp1DE1J6wg/NugsJ6a+JqJJtWPX8Qo18dszbthaK\n3PNhS1BtGUqKjpXDM8vghWQNFarYlzgJa/Tc6Bm6M7oJ1HtXEKLZKejA/FKqiH4HPPdn6tJmHG5c\nHVUavhOcULSfSsMeiDHvw5B1LRcRwgtmbM7O4JnNQIl7fumyu3X67G6VLAfHZuTU+pXNZ2+4brXP\nIl4/oAKxblBAZO3TmEfT2KvbB4uRI8MKRQLSGxAggZ23tKDBuKRg6gR3HL+5z+PN60ud4M7E+bV5\nwnj9BtCtI112vYQfl3WII6T2BSOg9F3aDNSYl3Vj0nb6DNszcWkzr7FhMGl1hieicwYooLSTKaHH\nCb/RMGvyFweBgQPHQKEC52BhC6asBqPxY5N3GulkIEq9OQdRTss0gktTaNIpS5FA7DpeuyZRQ3qH\n8I42wuTSFVhDtSK2qHavLqi1hSefs9DknudRlEPgQrF+MjWknUAPO9UJxp61I5PesOrpNQgJrR+4\nmPxIkt2baZPwM1AB+Snw4Ky9kpR+LBJSMjAlo3fXlFHPocqnjyDEsk7wYrEvkXrpp1RwlzAkk9aw\nZHS+ulHZm0TBXcix7zuBgv8FI6B0iCahdwjW0NvDlFCfIUpnZ1DAY1Iot0byFKyVQLs1lo9L2kOV\n01pDFNA6agRiTdOnJl/j7qxQ5V7PWp30FZ5wzlUzHPuQmK/P7KFhaQDXZBzuW41j2FZHkTDsWkY2\n5y1WUq8tqnTXFtSaApNPrQJVyG+g0/AOWuz7MnBmWp7DO9rDFdQZqyTV1uqxOS9Y4egXqGC8E4xo\n/E+gYTtp0nsvYAHZKwwJnSX0yCR6HOwKVjB+DEI+ay0gmLURZaA9g6dG53TleoMYkV5DDs+7Qg/O\nfqCEor8BdPMzeWXyDR9d1wmcu2vw2LqM3Nl8NfNZbstiMWxb+Vq21crMleV44brQ416PYZ3nYB8+\ncK0HDzdcuSwDHJXaDVFI5yRNb+ezmAie9fK60t1ZHkY62shysE+Ywin/A2TQZVts1P5JCz+hyKdW\nR9DOwYvJviFJaOewRLRTlWDsRpXc7vRZ6KVQE2XsyGb+v8Bm6NDkH0c8byQpaAMp7v1r2tdyGxt2\nbdtmfxz16CgTiTTQ5N4cA1cWBmOmBeMhtrh4hCotjjWVxTdgUeAdDMTMHpo2xxBOpulTk69yX+zG\n6ybnFL7RvA774h04gFDSBPckTq5/UkWctVo/syC+pNIdEEiVtZ54ahOwYOxClHkfaVOwY4AyKn9J\nQf1gVUzUW0RAawk7MmkKq56zlY3JuooFpK9iAdkf0BDXHZSA/rAlp3aHI6O+wYvK2kkUTHXi0F76\n9H4hST4fRMlH9yTe0T6Mdp2mjy0L9LhXGxg1/Eia3d6DaGdEOdiVNMGdCdT7oVQJbaZQrh0kuecT\naUfrGNLROIRudQwdGZbH8I52Cg3T9LnJMGY9TEbOLMuDWFcfYQp6IUq9PqOHNs/koWlzDONoIUo/\neqfQjo6JG5Nj5LbyjqGcbxr9eglBNue6CYrvlmTG9j9J8S0w6aSTMLv/xi/O9xTi/QYxKOkNSEbr\nCUI85yfRwk/U6Hf7INrZOlwkMfcrMOHotX5o1k2g4E8z11bb/L3NRJV9dhUKR7uBi0ev06XrM3Rm\nNRAj3ocaNfxVKiC/AxeVNYMZkXTSJrf3INrVPmE9r8O18zJvZjT3WbCr25g2qJEvpyvXZeDS5po8\nNY/DnZuHJAPrJE1v3wnb1Ve1H8axIDzQAK5hKbR2yhyykM49ing1x4aFmMFjk400AeujzUCpFohz\nh3EKsR4AGvOYFBneywqJuYkzbPsU5v0FLBw93Uri9kxM3FhCLGclzq6nOsHYD5xgpIUe+/zMndl8\nXZuzM3hns1Ajn+3ESbgNUtyzY+S2M0yZNqzti/GtWBcP+7CB32AgYuju7AwfGpaLwMDFJRzQ4iEq\nZIA504aw8bbJRJmAM08i3tzjaEcrgXbrIMo9OsZtTBtTRkYLOfr1BQU01n/LjHouChBv1lqAB8NS\nor7SoalV4vR2CDkqaQ+sp/X2iImxvho20vJ0FGCmXULChnBDXDeIAdmrWEBawaDsGYyE0h+YlNZc\nrKIdw6roHGWq2IsoB7uOd67LzJ1pr289WwO4Rv845tE0gGhaGDQb7Prmw2r+2uabwLj5qvax17ct\nNsdLRx9Ndj1RpKDnQayrZ+rMZu7DvngtwqsGUG1eEiW8upGJwbDVYXFo2bixsB5FvflIc7A2ugzs\nNX5qNUwajb2y1WLXuA8mhLlXSzjSqX0qDfsbvzgPRybHtJFpdb52c5QVHUzLCRoCjkp6p5Cu7xDW\neQk9NukLTka1JSBpIUe9n0M924hS0DZgurUklN5CAlofKKHoB+HqHsS7HtTI94MU/w==\n\t]]>\n\t<![CDATA[\n\tfA/hXi+aBPxKm14qEo1dK0invGHLqazFhFOeKpFIw5dG864F41oRImb21rRGmn5f6XPQAy3u9RzC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\n\t]]>\n\t<![CDATA[\n\tcvMIiBFHMFiZTafQ9AEls4uP/iqqWIdMHMue58barCgolDKABX/3A5wae2byBV3l68LgSqOJmLm3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\n\t]]>\n\t<![CDATA[\n\t1OuZHACNM6qZRn88zOgpFPFouEvjEDQCNqpBwWfK8ZsdnEKC1uFVU2BQcSivilGEcAoYXBcuC7DF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\n\t]]>\n\t<![CDATA[\n\tWvPGrudTXTP7l6y1/qS0Qklb99d5L1m9or4InWEZhqGwDMsykSWyqiwTWVkmsipMZGntIktkVamF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\n\t]]>\n\t<![CDATA[\n\tBCNZ2jzOtGkMmCEIfiEzBMEZgqAHwolbaURFbY4+ER99ImFH8g8Muxl23saFNIsskOtMsxSSZikk\ngYQfSLh12icgdaBHIokdN85SSApBMEGtCzcE3yyFJB+5cfSJbB7XmbYSnSHJ5HEbiAaGoTZyN23d\nGH6mEOxKc/RMo5Q4R8/UcaMpghrI5k0RRH2kKYKj95E0EPWRvtvCraSFiOMmThEEQ5AJHvCBXEea\n4AEaN3raR9rEVAn8JngA+IkTPMDbSF7KJHqeJpliWApRE0XiTF8ITjr03i/pkJnOZxs97pQARfom\nikT6NJuYEk+hhsLTZPpK29aN5gkFAoaghhq50Rx9IpWKh9oGgpiuS3E2UILtxJG20HPAlgFqG50Q\nyATi6YRA/5G8TScE0mRoOiGQF24U35jCdEKgJ33Z6H2cbYTadEKgkqdtHpe5BEYCI+lLYECejahx\nHUZyo4fB/pEHbB3IddiDMi5Ank0mVAF5NvKlx8nPkxszilpWkQ4hxxHHTRQxWzfSKiOJ00ikw2fv\nI22gA7aSJ7HxZRhBIB4XInKeFrqXdPDLMG1Z123Y5mmdB3/Vo2nL7sUgHmfAxoXsh8Rptm6kZWwo\nzaLTSF8maiTCbfQkSJ9m1CK6DSSRDqNpy55imvqwrtuwCylFcQtBMAWSORxBXZfiSGBOPn3al2S2\n8YDNaNoyfUXWRtI4o2nLbPh9HSfrazOjacteb93JONPadRtWvS8AXPhFUG20VnOexktRiQs7NASE\n+3QpcPt02ujrOuCXUdq2LiNHjgcqxZW2CgOSEHGruC/HFDimLuSWwHgFP4/cQLQUiKdlEkyNG0jK\nHz0uBMMNwQd+HMgWygO2DkR9JAlyHYnkaZ02kgiuMI9cx420kStt5HjAliG30CP/v+qKP9LkwFIW\nWRqI6/iBosh1GgpEjqnvRPq809aN5DZq3SdyUv5LYDhRhhuogXKLssSFIDIBydtCDRQ9LRzllsBQ\nTS294Ui+1OSu92KRdcA2uijKzeO6MfX5S2C6DcGWyQQj12kpDAnicd42blHjOk1yo6fJcPO2cdQ6\nk8QvgakYPxAkoi+BCY2mLSttW5fRthADfiEmSnwwHkrpxb7pplUn1ctLdl+knO1FcylfVbN7RLVS\nuHWpj8iqKIXaNxpDjERkeR83cuLn+XwZ3fYxwCSOpi1DfeP4jQ44IMGVgNaSl/oyJK57A0wi6ese\nxONKHjcaN1CoIUB9o5giUQcx1BCIRC9BgqBB9DrUAdqoabYORGliAwIHkSWOGyibC2ijsy+TbGk8\n1AKMhgcKkMLSeKi1AKPhgQKj4YECpDjAaHgosDQe6uhpeJi4IxshNfETqImNMIFS+AYEip9AGRg0\nINSJymkj1BDRg1pVBIh98ZLwMD6MESCSj4iIqHRa+0Q5I5mBZlUfHW0ObEAGjsvmgFXVzYHNRcfm\nNwcYOGaHzUzuGgMaAw4UB8zCSy4OjYEFhQSPxkCY4Lk0YBYeleCxTqJUWGC5MNgOLkqp6zUY3iAU\nRSRIMGg0eEfjsKpRqHKyHITDggsFIBZCroVG50CBwNDixsCjgEBHCo8c1FvQOcAhcqgewgG+DnAM\nOib29EEYSUIu+CEoeMUjKSBw0pw+y4VyRRSekoihAGMyFgoySiKGAtCBEENBgY+GoeAdKBYKRJe+\nCrLThVIAEglhKMgIH0nBqLM6DSQFstcAlTLmwMz4YKzqC3GdP0jA6CBEHDQL4WBhsKhUzM3JN+hX\nfEUhIVMZRJyKiyMOA44MxRMz+Z2YySdmsiqOysRM18RMPiUNU9IQijY2NkJRxyUN12TyAb5XpqZj\no+nYPKZgcpAD5AA5QgwjCqaFEQVThVJOYgVbcMAsPHYS6xfqfKHOF+pobCycxM0nJ3Hzy4hhEoaE\nkitUUCo+EWlbnYi0zVGezgW0AdqwKtDGNz8iHKMUwAkUPmY81AnUhB3ZCLWmJiYkFP8wIX6Z2YBQ\nESj+YaJOoCaVEJlUYDQ8SIhIjBJWNWokD2KDeBm/CvEyusgDdS6UCKuKAIkAifg4QD/oH6Afp40M\nDdnI0IiLYyNDw1CfLhSMGmraKXX2KaVPF9opdTQsChTUpxE6qjDQ3qCOLhxthI7A32w0DJsDm4PL\nqjahjs1nPhoDx4XSuTgulM3mwMQBs/AOC5KRxUGzkBItcBQ8F4rmq2DQGJCkOBJMB2bhMyH3YmNz\nYMRDpQ6gSgVgkwi9N11RsaqTJuPygCg4wAUXDTFUyDgGs4BASJZsCqEPho4VOQYcByjqg3CALXxz\nnFo+UiHHxKIQRi71s4UcJCSUQBkLLZY4LEk08QkHGGRh4viLcAzEAjisgQ7UOEBNYIBQApRrJhgQ\n2A3UwIbWi2ECws7qLPDRMBRgHw1DAed0oRRY1RQJYSjIEAlhKODYE1cBdrpQCjZ74io4UDFXweZA\niKFAhOFdBSAi5cCWUiUKoQaIzSgl4p0G0WM8CmFR+UQYIL0lcrDAGKQ6HcTIhkbnK05hoVgVhmgj\nQ7GKOMoo/oHCscHBsUFhqJBkGMRR5ycmjsRRKOpcpqTB5KHIqjYQThYFilnVQYhFgY4sChSLqKML\nxao2QtHGZVUFRjpGOkY6RjoKHIwMtN8w0B6rGLxppGOko3OhhA46OjaVjiiYRhRMDnJ0QhuUyQeo\nsUHBuLCqL/SFvtAX0tgo8GAWPpVh10n8Ql+oc6F4oIVNZHPfRDavNpHNJZvI5gVIGlCeDsrTAW2M\nlo8Ix6wGzH5EOGZVFJG2OcrT+YBsxVGezoUCWxoPtRZgNDxQKECKtzQeqkoBNmg8VKtSwGh4oFCA\nBxSNh1opwM6+WFUlNfEPBUgaTD6BGunoXCgTIxuhZj41NfEPFKuaQElsA0K1qmoCQdKAUCdQCylw\nI1Rx4u2okTxQrArbGFEw+RfqXCgSIaIHrcgIPVQJkQTJ6CF5kBCZjIgeNPPRJERGENGDYgYUSh5q\nJA8fBksZdS6UCNFGhlpV9VYl2sjQSkOkbZ7wMI4bGYSHsUaAFDyMFwpGqrSRoRtNoeQRIAyVvodC\nFgWa+VyhfbpQMD4XHfHLQBhs1UJK1EkdsCjQUZ8oRySz8J2SR6NjoXwhFauiFZM6qmiMm0NYVSjq\nXCicj4HIQPvMR0so6FwYGg64SoqOrIpD6RhoE7uADB1pqFRYJBkGkIHD4E2+OfDRbCGVBJCjc6ku\nTcfmEyg6FWTQbCRMPiowGh4ujkqRSXnQzQEJQ4VFgSqkRBL7dKFsEqZnc6vqOiEDx2bh0rExMDGT\nawyEomo6dESPzX8FTuLmC6FNZPMK5elcRhauYqBgbS4ZhQNCtSrNhkaxkTxQNBcGXoPhGV6D4SuR\n81UwWJvLJUIBQXur0hjo7AvGwoFmC6lYmi2kkhG/DIWOQGAW3qoyShLwYll3wiFAYILnQsFYSIki\n3Er4iHCPRmdfCjoXikb8MpOLWXgMbOHCGDYMFwpGRQXZikv4gwLFNjr7omA5LBXfjF8DxaowDQsf\n7lhNhRXLQupi8FgUKALlaGw2IQoL/eGwYWhVWgV3YUXoAg4wOo4ROgYijg+NhbUOsIcABcc1joFo\nVR4T2xl4kExCbg0TssJBAr0ejQCykwICXQdkjiQUDrBGAQcdt6oKcgzEDg6PyScjHGCrqlhwjn/D\nRyokYMrq3JjYMExtWCqu4OmKCocBrOFiVRFarEyFenDxcIQOxMtjUaAG4efBQosbA8zCT0YWrnKg\ncPAR4RqDiwItcTo2OJjCWIHwdCgPmlRCwaUzQJQHDWhiO9AUmKhksD9pMiwRIhjUhGOUJCowmIsA\nplp8BxjiAhdg6ojlq6gUcBQeCIzCJP3H0SGiViWpED1oRjHPR4SLIETsCzjBCm5Fo+BRIKJEmDCs\noDIYFxIZagnDKZFgQFQMkSUMHywKJKESRgHLQEJEIcTDTduFwcix2Ng4mcHAQjc0qwqNiAwseHg8\nOAwuvZ2ubwRlQStiRYlsUDYiUSTkY3FN6sQiwsFUdGRgTMQQkeFChAILGYgCBLCQhMBlY0DTsKoE\nnBmIF4JnDB4GHiSTL8BCU65QbvCYKCgMRIXUBcJChFOXQsk8nMJApIgHExIUDqOEgYixKXABUZAg\nkQu4vB7HG+FxkUOvYgUPWxUYEmEgUh6Bk7E3ijAQFzQIGauAgcMxEA88ovYXBW2kdEg4gQItNdGR\naXAo6AyBalE0vBEmDCc0oeQSGOOGQcK20O4xMLqigQMCWabxUAkkWBmNiDsxGh4mD1wYWlWKk1By\nkYQsX6/xkQorE5YIB4rGxE40jB5U4YKDKTjAVsWwkTzsr0MMRYiEknPwQUfBzDgG18EEiBjOCMlF\ngVZ4glWF3IV9QvgsfISWhJKLUKkDE4eDC02xBgqkwocCAlbVGQ20zC0KFERofIlsMBFjIJxAXBgQ\nGMEQuVVxNhIoHhTGHD0WCGg2REAuLAxEq5pkXHi47SgwYkSihdFDAcxHgQMhq5o8QNSbwqhE0whU\nkaBkHVKIZgQAAADzEgAwcCQeEYmkkqmkdkbUAxSABFtMLnZWRi4VR8OxQCCOxDCOAjGKoijIIKSQ\nUgipsaEC/hNkljfddqxXLz6Z8/PmuVAYPmCTwat324Bs+dprLUMTR2iWQXHwxUWxtlg7q3rJO38W\nqKtXePHxV70huOnXmZvIMGThMmWX60lw7eq9BQntL1W9HLfifmMKr+qlGOpt4+pVY2jot37dV1/9\nseo1gMC5egF9Bny46qUG2dkDQYqLB6JV79nTfUHdBlQlv5C36p1EYbcj3YUh76nxccMEzNl1hxKs\nEPnAVCtC9rU3NCJ1WHq3PlrMdOhcoyvCeUks0OKnVfX5RvEHZqzyCgocvGMj6XFBBAfX91aybBFy\nb+kqh6qID26s+/TKVzGfrVr0sElUZwWIX+JYBDoEPH4lttvNyFDHA3P0pSGBNBjr26TpLUPiY/0E\nVcxdKAi5nj5QQGPCwjW0Cu7kInt3ZXvJvUnjXragW6kqek04JWAYI+H4/vcIDkW4a7VLRU0Zai0j\n4X+5bXQzQZrwAsKXb/wEVkOxi4GBS76HE/gsAjE04xukvOXd+9bw/dGLsKAUCzCATr4TfIJnEdbd\nly+5FlYM/AKzPRVRnyDFcguiXBZWsCG9K3LKVqub9kuwfyJF2pf0vBmb6Xj+xRuBNycYan/Rp+1/\nuulKYf4UiTPc6uy4JBZ40rFvxLuTDmbku5vHuTIUWVzUdAMc33pITD3Pc7SpLIyRNdKXzOzUtHOE\noP+n43t3D+vRR/kt+c9NEwAxD2tcFu82MJseA9cs7iUbZv18A1LPxZXKybtLI8sdTfTgeLc2s6G3\n4FJSDgDHCCHxri5iclQOxGbeXcfBCJxGcs5d5AFsUNirZGp5sZT10o48NuK7u5Lop+sA8WK8y01Z\nsMWRr1jCM8yvVGzIvNEuy1i60/jkPry72rJN2G6G4fO2qwL41KdiFKRdWnJxs4MRFA==\n\t]]>\n\t<![CDATA[\n\tdY49c7tWf4/ikDIEcQxuqBpLTKK/pnAPvIIGGvotvIUerNcncABdu37mG5jo3VyNQ5C39lG9CGKE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\n\t]]>\n\t<![CDATA[\n\tCvI4BoN3h3WXo/O7Z/inMKyv2V8Xfbiyd0JKO/KfCAOM7M6oZ1t5EgBwelUd834ANcF/aiN+5xJW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\n\t]]>\n\t<![CDATA[\n\tQYirpIS0X8yAsZisGMj8hGiv1zhj4hHFtMaHDimfuLpaIsGOJ789XnxtFigQBi3kv5UgftQMy7fn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\n\t]]>\n\t<![CDATA[\n\tGQNQOFbsPqRHTePOhnAdo5QLhjp8TYXWP+yhNE84GwiJfEGI5nn139DLFIBOO9yLTAcH2kG89rN7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\n\t]]>\n\t<![CDATA[\n\tjXuy4anSQ/3SfW0DTZD3CMv/sz4aEikx3N1fcH0owzVImTKD8WR+hwm5DsnOP3Xj10Lh7VSiurBE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\n\t]]>\n\t<![CDATA[\n\tYY/qgurlKqrwGZxW6Fuv05Qc0Kfoi5n0TDBXr/iIh7oWc+YR0nIuog3Dkq92Hy6VBMIPtBLdlp6F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\n\t]]>\n\t<![CDATA[\n\tBqU88x2lfSgDt92yLxGza7Z9autTCQdlxuhkT8AUm66pASgX3RLLVX+eiI2/9N71H6cLyUnRMOD9\n1ltLnMNKFMtPo/DmYC8EVyWIXGqvApecv22wB8mJ2MPkOL8ifxpjawiJfgeiF7A6t097QDwrwJhq\nCV7EmqvlVR+M96JjJQZBD+ZV+HJKT057chnSZ5ByYsnPQwRD/WOZP/Akitm7xtBoMnscUeO7aVZw\nGgYChjSi/D3IP0SCdYd5NIyI0mQFVXyyB0SaXZ0MphpwiX9v1b+LC690b+Zpbqr6CZManUcMG4fI\nCdGDbReUuf+M+zhLgxJ0eIBpwS23MQyk5iYvKz6937IZ//4Rgv7Fpkrt8oZLxL9k6d9o1CQuPOG/\nxjPw7xur+q6wrYf495TUv+EGbkmqAalP/DibMoCNpn+Nslg++eF+/Ot0JxHYB+L3PZCaI0goF73f\nSUtXEthflivxrx/oX3Vy/j9KiiQ7sPi/i+fr3wUqA+FHo8gTwd5/+4Ki2QtCOh9YKIiKNRMZcWTK\nW8Dj3/CXeET/enVRxpi2Bf61PSomL22icKPxr1y+HL/690ylJkTQC+YN8KC+mxqsxjKGjn9PfQkm\nolcB6V/K/m43XULhyXDrX5su/DgB/6pAqt8XLti1j/bXluNfP2QJPpUYuxvjpxXtrLiAM4mxpVi2\nLWUCBmN68o8L1dQHLL7CUDBTrif3fRzT6srIUwv6W75gbDyZEigpPZ4sfyF1LIGdZkSuaGferevT\nb3ApV11BUtrRpU87TuNlLl/AReMOZcwoEAV6WcEWhm9DTYF7RHsSenNzDWY6ZdbGwt8sosv+gUCP\nDfOzT5aprB7BXXfXPCBTvCd+iSEHjP6T1aoYqKkM3qD4GK2kxECNRdvm7Cuuvl7BhZVfxxyyV+Gy\nNQGrPAWfDATBXKYxtZhWvVdvJ9AwrIxFLfbcASoA4klGo/pGSTSwE2jEbObrk6+e94ZzPdooXpJC\nYuCe6hUCQm8Mfy4FYI7Stsk3imNYYDxJMptCu6vukerxZTBwyXebKzJz6oYRoVdjcBpu1Zlsdqbp\noGGoMq2EvmaXvWZDNUSwo+SYs4/YFRBHm7BwaTcxtpMnXGzuet1eevD9T3NYEPp0JXFD+LA7Nra/\nR5T8cQwLxhV+AoBkFRE+gBLZ0yXySDY3/R0l19a2TQdAhDpnmwvTgaK0dlbgAKTmMLgkixJr0edH\nqXMI7kK9tl3XyvWQ1mI0NnEIqJeBOASxHkqTUlJQb57nNaHUyxwZbr3VNVwE9f4IssjtYe41G6De\npv3QUTZCVD/QppB6WV0JGkP+33buHOO5IJ1ufaOT1SFQb9ILGQuCaWqJhnIN+XRxsFHE0ad1/SSw\nUe4URYzXuHQ29WAciNK26CzYEI+JFt4fG+SK7ws/E0cIgNGeACNGe1mf+YQf/msZG7UJfx8Y+gCc\n4+TLtYy8X+dzfVIHwEGPs3BGtDqeRcJxquTis8zeENGMELZwsn8NByyI3GXAH5n6DFgyZiLcY/ae\nLc2Okm4ZSiCQLzvweuAI8cOk7lZMuyysO8UJfRfFMnE+mSLX4INuxSUUw0lodsvACK44gdxZB+xW\nwIWY/y2N4vYmVvmPmCYUixWMyZtyuIL5P6RqikXfWnWSbpFEx2L7gm/x2a4wXapiUjQ/BYQ8rGQ+\nMPVTzQq0HInO9qCW2nL6zM1s1eYu4V3auyryzZt7YhFZ3cG5++YNf7bRTkQPqfmQO1q/q2sC1C+w\nlX0RwNM6OHcu8CS/h+iaK5WlK+Mi\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M28 13H30V15H28z\"/><path d=\"M24.2 3.8H26.2V5.8H24.2z\" transform=\"rotate(-45.001 25.192 4.808)\"/><path d=\"M15 0H17V2H15z\"/><path d=\"M5.8 3.8H7.8V5.8H5.8z\" transform=\"rotate(-134.999 6.808 4.808)\"/><path d=\"M2 13H4V15H2zM13 30H19V32H13zM11 26H21V28H11zM16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14 26 8.5 21.5 4 16 4z\"/></g></switch></svg>",
            "info": {},
            "path": "32/data-enrichment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataEnrichment32",
          "filepath": "data-enrichment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM13 30H19V32H13zM11 26H21V28H11zM16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14 26 8.5 21.5 4 16 4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataEnrichment24",
          "filepath": "data-enrichment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM13 30H19V32H13zM11 26H21V28H11zM16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14 26 8.5 21.5 4 16 4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataEnrichment20",
          "filepath": "data-enrichment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM13 30H19V32H13zM11 26H21V28H11zM16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14 26 8.5 21.5 4 16 4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataEnrichment16",
          "filepath": "data-enrichment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM13 30H19V32H13zM11 26H21V28H11zM16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14 26 8.5 21.5 4 16 4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataEnrichment",
        "global": "DataEnrichment",
        "filepath": "DataEnrichment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M28 13H30V15H28z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M24.2 3.8H26.2V5.8H24.2z",
                            "transform": "rotate(-45.001 25.192 4.808)"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M15 0H17V2H15z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M5.8 3.8H7.8V5.8H5.8z",
                            "transform": "rotate(-134.999 6.808 4.808)"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M2 13H4V15H2zM13 30H19V32H13zM11 26H21V28H11zM16 4C10.5 4 6 8.5 6 14c0 4.4 2 6.3 3.5 7.6 1 .9 1.5 1.5 1.5 2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4 18.9 8 17.5 8 14c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.5-1.4 4.9-2.8 6.1-1.1 1-2.2 2-2.2 3.9h2c0-.9.5-1.5 1.5-2.4C24 20.3 26 18.4 26 14 26 8.5 21.5 4 16 4z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-enrichment--add",
      "friendlyName": "Data enrichment add",
      "aliases": [
        "data",
        "enrichment",
        "lightbulb",
        "expanded",
        "add",
        "plus symbol",
        "plus sign"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-enrichment--add.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<rect x=\"28\" y=\"13\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"24.2\" y=\"3.8\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 3.9792 19.2218)\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"15\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"5.8\" y=\"3.8\" transform=\"matrix(-0.7071 -0.7071 0.7071 -0.7071 8.2218 13.0208)\" width=\"2\" height=\"2\"/>\n\t\t<rect x=\"2\" y=\"13\" width=\"2\" height=\"2\"/>\n\t\t<polygon points=\"20,13 17,13 17,10 15,10 15,13 12,13 12,15 15,15 15,18 17,18 17,15 20,15 \t\t\"/>\n\t\t<rect x=\"13\" y=\"30\" width=\"6\" height=\"2\"/>\n\t\t<rect x=\"11\" y=\"26\" width=\"10\" height=\"2\"/>\n\t\t<path d=\"M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14\n\t\t\tc0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14\n\t\t\tC26,8.5,21.5,4,16,4z\"/>\n\t\t\n\t\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__00000071558510725025777340000005803497171471724209_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYRJkEfv3FnAwrwNZQCm1kKtwUaAjZRvTY5iksgstb21qRfCZFdvfOxGH3p+NVFMUZiqID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\n\t]]>\n\t<![CDATA[\n\toCAAgwINJlCgwDAsgGCBQgVFAEYFFio0OHBwqFjOowIKFSZoYEHCBR7kAhAOHBxGyoOCCQTAQoUL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\n\t]]>\n\t<![CDATA[\n\teSbtzuQ48EZGvV9m77FyaDkwZxAtlHX+N3jiG6XK3v/RHK1F8/1QrkYvLxHlDg3zT6zBukk0vF6N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\n\t]]>\n\t<![CDATA[\n\tOjRGrGMlYdnRhnWsbRQpr+6IKLUqOaFkjeLnVZJYw5+XJdrcVhZKYptXiFZFlc0pW+ZrpB2S7YM1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\n\t]]>\n\t<![CDATA[\n\tD0X24d1tXUR3kOVTkcx9yPtzPhEvcTRFVxUSZyVy9stI5QUkYV+29++ONbVhcYoVEmTbPekQsN1A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\n\t]]>\n\t<![CDATA[\n\tMyXEUyADqH/pCIzxWxFviEYlTjMZ0NUKgA+HnbRkXXiyTVWVl5cq/5D1qqj5ykQ6gj7zYzACWQO3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\n\t]]>\n\t<![CDATA[\n\tugxS9Ki3uL7hEZ7SoFvAYnUE0fP+GcdL9CQ/j83PwVtD6RCKcQPyZ4Pberq7gvpKR4H0h2HHcCDN\n7OOTakFX6vqGtN883sz6KSMZIC5gpMFrCQXO9jCT92cvUGIxIGsc/K5MF0MyUX7G7GwI98fjUgD/\nE+2JeGIKy8BIGYH8ASFoxIBiR2UqrvTfWhmwAOqJsD09UrA90FPSK2721qJI601mNAiYPIsmxGbH\nmMiARKgIIifzwYi5kBGVTmQNViYhNE4hjq3SL8Q62H2YBwkjO3qRpCGsDRzCOZBRBHbgypYfIQPx\nymEcRVyRzybCa5E8F8GOTBpDBTiEs6uIoWqV1NjsBBJimXkie2NCfzORhy1hTiUyEC7BLyRSnQkj\n6rRLeB4iYh8T+g0i68ZVMT+0/IPDYsLMeQhwmCBQh9ANIA6ZQ03wy4a26QQbNGTVJ0gdQwBpKMh9\nIbyPQkYLscYUUquQg8CKQnlABR0TQpUqZDxCPJQVggwhn3aFqQ+yREgQGusgN8RCmm4QaVdgHYPy\nyCt0tSDexULzKMgn5lGYswB6tIqggUoQkf+AjDwL9OJHAxLhFYCEgEK8K/APoAyL/s8KCPVPBdTH\n/sClM/7E2dV+7kAsnNf3vrggP7+w/D5ZHhbMbB8gh7Q+osKCMelzG8WxG5/sv/m8dzkL1nuVqXyW\nQzEaMwgDIKVoWHEk8EhRja9CwsH6WiJ+0WlJYZEBtUUFI4ybVo83yBJzB7EL9iDJRnW4SjFV1Rym\nTFOdMmq9pebJkP/QTHACqdmWh3q4Yqhcnlz+4TNQXoXm8Y9uoSao87yMELQ8nQQRkpbnOfKrTAbR\nvUOFrvSp2y1IzIksPEhBmKKOvkRLJoDYILcQLLTKo5DDQX/9KAZuefhPVOfEQM8VAnPR8uRcYbzJ\na013xRXomOOPPFpANizPfATF3idncxJZ/36fR/TU0rYnMKMNtEgNeGS21soDwXOSPEDQZ5Gn1bhv\nyM94Eh0ncHOWwYV4bMp4riZNO8ZlRWU88fhQgS9sWD88FCdoiR+e17aKFJ1gZIhHTY6IeAPrIB55\njiE4VjEyxNNKbW9aDRCIp2unRV5ukIN4zvn89pQQrWeGSKebd+4aGs2QGDqsCMs5VP5hPA2dB92b\nuyfGE6ng4+BoDYxwbXYxNQQ5EfjOvwbrU+Phok+XraZYRTzdqUTbNvUQHpnXmlBtOylrTJSSgJQj\n2Q4WNJwVADp+6wyM4D5yMF0i3rYz419DIO30qINE9vheMGyy07fd8rrr/sc6TMAOU23Ynrh1Hlky\nzvVXZ2UA4wIfpc7bPTVGzzRbiYJwyyY1PDMTQbBKYK1emRmHdwdIDyJ+8AXbx62UCRkwm12w8IR3\nWwzXaGTG1y7ZZmKhERJ8KvubVISa5p/xGQwDa1ltj6DseEtdSKXhx4xFrUV/Z8JDCu42xQ2plvle\nxCgloxETWcHPY1BqY8RJddRknFe8iGRQTTs0Rw2gpT9ERoilOxfd/I05jJlecZGjEY3CqtgkhLTg\n28zFZhvDRFdBJmV+CrQZ2WLCBgcBEp2a6rDFJh2oJpiboUP+MN0qFJuL3i6P4IRL+JUV5qgrwtDL\n9mGVK1dUUhyIu1JyzGM9jtSdzFWPA4bjx/L+i13QcBspmvVLC4yuktSmlPYlUSlLQaXli3XhgDt0\n3Evlm14g32nHlZcmK54xHPAS5K8QvN0uRl3XRRLlC2KL4jI3RtAHAsHx6+N+3X1MJWUDDRyo8oBP\nKy7LpaktN57AwWGwAMDqCUgxEL/ZeME8Gt6ApB889cvPLpv1gJKmX56IvSuPN4EjEYg0vAEZByKG\nsKVw6unR4dGApjUDUVafz/cxXMb6SAf9YwoClkXJ6wy/U7ceevnB8F68Pu1o63xlTjneo+8KMfqM\n9/5KqR0rfP4CpsCoPpGwBH1QDEx2ifJDOBFll1SXsHVCJ2ZulK0XkTFRTqIiiGaB1zp9hcTlSCtK\nexGbfpwGadZ8MesEPI41W19wJoXT70fKugAo0nV8V04tsVvX/j0eOc6oyqhStiVhnhM5NhtnzTd/\ntS9lZbKc1dHLYXBPytjhCYJA2VqN04hKH3zz6/Uk8ac0ocmaaGVbjlG0eRVKBN1U1ZQL3XZ8NGJK\n2m8WSb0kGdp0yRbo0JQQXU9k0+xKPa14tazQCe/4J0elFoGYw/IvfE0z5rhmumBBfXNP+jzjGdY7\nwqH8FQWbRDUXiYGX40LSKoPo4AsKW/YNqSSVMVFLoJ98AviU5RNMDkEUJehZ4fNs33cAcWX8KFeC\nu1wyyzK2cQCYSfdAeypMzKYAgwjtAWoQ8CmLvm2SoBMQsdiuRLf+WXPRl0a9LDYD1yAUPZUJ/HgV\nGoB7oTZ8LBj30u9+ScdYtnBu1hJQ50Lg5IVOIgHWoAzrgK4eWEah5MgX7/3gES1AFrYHUBIsV0ad\nYY3GtSAweB5vT2BsSaiDCUmeSVqaYq/tFSKfK4dQyKsR87RDGtRgpPpAKZqcWVHWwlyhEDpmdcZZ\nhJTiLzh4D8vu9Jhf4GTqY8yt7YvsmDbcAtdHBzxHQyTJUPBksXLTcEJ4kTBaIx6JowRMHDxyDsv9\nHY9WuGO/fEEcKEoFLu1fpWzcMXXcBo+hTsnYJoCDUlCkvkKBrmIgOCSIgMcvMVXTaO/immuhTcar\nJPuFLi1V2JibN5bJ/Kz6OqO3kU2dCvHVUQa89wrbhXx4IE3YGADdkM6eY4rSgFwSVsK6z3Qh0+D1\nLVVHrjBOPxRhuZ3780p+gc3DWmPYS/P7eOR5QU67/r7vIzwenCNukudiYvN5nUWx5IM9KtBvV4oG\ndO51uCBLxqqFko1AqNZYagDjOJB9QS1RCLk95cxwOL9NmJne2GbVOkUc7XrgJbPRA9ziU/1cEEsW\nwQYMiJ+p6qlOLSPqUcgvlGYvr98zuITM9Oyyd2HKprFeCqkvEZMc2b2BQh2IDBIEbxn9JJARFIQP\niwEUo6PpEtnthFhaHiwSsFaJbO/9ZAHeMvQIcKxprJF2Hf88HPwwA4+4KjZQvI6MuLmD2KiYFxVL\nJ7GIdhcIfXm3sqFrhE8N86gHxVw/mz1EvcHohn831Ae8Qw8CIu/aYI3azZop0GCFrWVD1a4ILzT3\nDayJWAfdXJqqgjAyHScEf6C3sYpUgzUpvVM2TxY9WRGjUetUoOsw5xb20ZRiHEkpONxGHyFRlZ0W\nYLBZnAnqpIke+3VnjBWT16i5aUdXK9aMQpaWIPSULh3FySYTo2Q9MRUTdBLqz8m9BfKfb9ItJ29R\n6sKH3yQKZyved/TPITwnpXf4AirwUXWfgJs4JMhXaY0BLah3rCWFtNkmDodjLiE5jmU3YkoLmMrz\n9atHHN/cyeOORPHfUaBF2BBOyfemcP9Oz0CWQjXFoooLLF1bNLd8cgGTVtv7SjjOxTyFF54CzoUj\nz8W0eutH4WIVp5tX1E/qnf9VcDKUSCJA5aHQIYvJ8HM4+yLD6yuAhEkCYqYUmvbTx/A9zWMznXUU\n6BjMjcIO4T7yxysfs+MskP5dWWDH0k+ETlNoOm3VfiI9yZyzFKsbiN++P1NOt77+czzEcx3GqZr5\nmIIxoQRRS2i6wHmv9kT6Et2aCVqCZr/XTiSOSnj42s+nYVxLrbykSGzOgZTstY3VgxTTioMvWJ/s\nLcs9bSeyB2LrlsBXPhsLFkZRgcR87b+ptxUdoUrAzDYGKb1q0vkz/m79oFdP0/h5OoDzfvytys0T\nJi9vDS43e2vF8tAP9DbgmNp8n8XpZm8s4VUUPkhwp228eRS7VdbEClaWJxRfeLA/IKUSmeGkldo4\nn1g0kiHj0XFp36cTv6Pdgm5KITInzhMori7BpZAKrTRF3HPW5y6XToCgUFVr0D9jEdqyVeoN0kSn\nbWIGo5lyCRvMN2bf/8ZlgKZ7+XwlQab1IZcoklwl772zFDu0sbGFcvvRB0Nr1aduefKj5R5Ja2Fb\nsaPXACxcsW2nUz8yuHeX+u2RZZuBlZpfwQycus+oJwJSW489xHArr9b1nUKRuHbdQ4uVnM5oEgJ6\nXzn7mdEIW61aR0DFn9WWxjShrqPQKptC/A62m8o4FNLe4plS2nStzWp+7jE9s2s5QxPSFk6siS/r\ndMxHUt0mtNOp3T/EXBKMc6LHNd+AqU9QQT8nSwF6K2NeIjBpKqjjyi85q4qUYoxHNSMF6hlFGZT7\nxE6Cq6j5kpJYfPgNhKhFMdSa/nBa1wd1+XwGChWoz3YUI3bypzXAbKDMJ43gS6bm5Xri2FHJJ0Y8\nUT87nfFQlBZ06sTp2ESm4xRz05vAorRJmQqz+Xg1wfkJBl5oejYxQcoGU8w0fSPeGCse084Nkwyl\nj5/yS2MgvdF+qSpWgOsSYAcf8bX3L1vag1mRRucAHEu0JWGjUyvhWllQlsQQLQ+OGSUoLa8/9KQ3\nEMQxAmm5fKg8Kwl2J5k+9ZHEY0by0Ef5JM86AUQ6So8TD5LePp2v3fNHl7ge5fAvx9jROx/C9c+A\njiOoFVtAOrJYlEgtGqVLwPoZCBlN/BeJZrBrZLFF0ojVivinDzvQ1JzNpJu4yqMQ5cEwiR5IePwo\n1FfajXat4CHkp/pTSpxZ4sCNa2MLMunjHPNDTkzacICKVeTZDGo8Mi3EB6Hyjo1CFsLhhAsu6F14\nScFu7vte/oH///QSoleOlX9GcqscSwv7806uB/iU/28tK189A/rt/8iTA2X0cJGamE4QRa42+s+5\nrM+AAjxhjNMaLTaK47TSpqPCD74763bz/Y832V8IEcV/COAxvw15S8ox20tb2uNVIIff51XPp2zp\n2mxiZx+m81kOkQkUkEE1OhOarf1DBTCroKuav7oGbBRZ5cJPZzEyT/YfiMOAUaAM0WjtS8tWsC0f\nAVAO5hll4PDOgdLPTKsOCAkEJloqi6Ldanp4blZ1qmjBOhpYMWpHPlxuDnqH/LNpJdwLGmmwu2r/\nCOu1YJOBEFGNauAAh4EPr7A3sO0fnWydc2U72scHvBLXbHULbPviv5u5I29xo3zX1nrSeHRtdUh+\nuqntwNyOtVn1jmYNNrdeW98OBMMd4R4XdWEuwQhdEW5BeGqlLm0uu4Li7uIo4r22AUascPMKsc0Z\nHPHyQMWLdN4rDap1H89OrW9cvOXpUFMVr1/NvGDJiUK3HRcv57kvURHvSIDvNm9MJICRfcod6wAy\nYWne25myGiGIPQDdNO+EMi+6NvtQ7IQJHfNKywv0Oj6a1jR5eRk7ppc7gfiij77HRXZU2YtmSAsi\nrdelS/CS0X/9RGVBrZA8rMHJMUJA7XKhl8iDX8uBId31ViVga0sA4o3uOJvspzxtQLjo2ZfOHK/d\nbmGloa01CLvQwcIeXiV0uD6+6LJHouELkpT+Idxqt85RdCWwpoajk9nIUB3FFDhVL3MjR5IHshMJ\nbZZlZQ0sRthhmPmpqsPkqdQSyDcM4IQDaeYnPqkSdDN/OIVUoEqASI/22ITIV2J3WA==\n\t]]>\n\t<![CDATA[\n\tviCuDjUheoJJklvhVUkEFD4yNeL5oJQT/KTNvgGqmH29tUF8IITv+za5ek8HqtfsVQ89rycm1SoS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\n\t]]>\n\t<![CDATA[\n\tABD0lRsJ1X//mpR/0ESBf5memTbPNYW6CEgFNt3i1hgzlD6+CO0ogJVhKv3ptSvSor4M3ppc6c9l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\n\t]]>\n\t<![CDATA[\n\tjjCTDE4T7PAFphUczcBHAfdyvyBVltnPR40k1Cvo/He1GO9EN3hsrXcjKKVzop4QnDiwqNBCbIET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\n\t]]>\n\t<![CDATA[\n\tpiBj1YSjX1V7TZQXOnYUup6YklIVuUwVUyXYhWz8qimf5O9GKQpWbOwKV7jmvRXElbxhF5UlyKGR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\n\t]]>\n\t<![CDATA[\n\tFsddkF8OqTsl/F1/aQabfnTDTUDKHJoICrk/hHnKymbJhwfIbJxtWxYKZxmYq/BphIKPxyNrvCct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\n\t]]>\n\t<![CDATA[\n\t1hx2l2A1RXaTharAWx3HXhMpwbyPXzdbEQMbo1/ebuicuQYxDP7Jjx+8nfpgn3cGAr9YcjTGA8Kp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\n\t]]>\n\t<![CDATA[\n\tgFaMKaMH9WIMBj0InzG2ngcSjjGG8+DzGHM0D8hAxv7lgVRkjFYe/CRj0OQBw8mYh0wZDvLK6Ig8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\n\t]]>\n\t<![CDATA[\n\tyUCY9DUDBMJ4YDMdINzEsNluUaWXDANoTZZnPzZy+gOUvIy+fiCC2VTiB1bOplD2gWxoUwp9oG/a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\n\t]]>\n\t<![CDATA[\n\t+KxiFfVNC//VW8YjDsNpJPxPEAoo7CgFfUo3+PiV+bVH4qwi+Eieo9+ooMwQ+DAJhUHgk+TrCtnF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\n\t]]>\n\t<![CDATA[\n\tez8QqN/W0t6awJRuckNUI+2Nn5OUnUJPe3eNbKUTCB9tpr3BzOUx3rQ3mvlJNmApaLpf094Bq7R4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\n\t]]>\n\t<![CDATA[\n\t8xqaQmERQAHDINMa9g6KrlqlYDW11+rGpwLrbBV92I7CrR+b+9BbGRkSXgdXhYNlxbgO+4JG1eRq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\n\t]]>\n\t<![CDATA[\n\tCJhjP3YlEfhIjAeGjS1hzfmY9CAqT3soaWPcKjgjNmV8LUwWO1TrWLKdGXjmizOCMXuLXXoULjDj\n5LbYjrxW7JmwMt6lVostQi474pSaKhsDjxB2DyoSZmzaYjsSphF3IrNFt9gMlfApvxbbKFPfmqhI\nuiR2+CBukesk9mjgB+5lwz5qYGR8DTfs6xwYuXjD7nEZo0GzowvcsEsf6jPWsH0wG84Z2xo2R3aC\nFqkB16+G/WwTndYatiL3OXu3mERRJIQbSZLD4LRhr2ELj6gWCRu/fDRsRNfwTw9thH06dzDgolvm\nJGz4zYdAvjOjZTyTGqCHyc+sgtcU2vkXj1yOqFJrlc5hhN2MlTuPWMQ3F2EvR+hr5I6wtwn5tUqS\nsOvCgO7/Ci4EEmyTL/pgEiaUL1eCbVxo3/m91BJsKcLEqnjVP+MlkWC/3jpf5gD2mGDnPk0uMSXs\nxOWGjS6x3cnN6i42xLwXfplmRVSZCGTnWPKp0kb6kwkgG0jlX0EVqgMSZNf/n/t4qzM/B9nbjAo1\nuyD7yTSbR1Cytwu7NmUvi7H+o2UXj3Rox+wCTO0XXLN30zC5dHYm38JaffY3eAp3aANV4sGEtC3w\nxePItCtqB0eaE45Me+GdcA12OaSjkGlDpdsHRtTmS6Ux11Vbv8mrtWdrArR7qJ1jm9bmEINdBVSd\nPBJyuNj27WZ5y9mm0q/WgQpBSlvPtl61XhuCFNT/2XaFmT5bKoJx+Hi2mxDIsFSMoGfb4gtzmBAG\no7NtWsjAkOCFCxfbceUZlLmSYnuUEbxrSXS2MU8SsPd0ir2zXSzw546g27hQznZyl1+ZrgFn24GY\nj6gzZo0PnG1wMPhcAxgYunG2D5cXXk69to8S9+8DvGt7ZPO+Chl9hkZ6tuVioMtb4Be0nSjhHr8i\nNm1REYW2sXY9cv1zWNTHAElA292LhzdqjipzG9B2QYP+KlV64n+EtjvMCya9DrMd2k6iEaZNQdsr\nxtPsJKNNaFslJGT9KI0/MtC2rW3cd5FPqolsD2ea4YiUEIrHNmROpfp5KZlQss1IbFd5aznUk+30\n3eGlOEVQ7lYrXEb+Xsp2qIDKr+M/G1dBF2yHsLMvJw22vzGEiliBQ4NtKcgtgMqdrTiDbcpzJgkr\nBPtgexEeAZbj6PzBNlVDhvdRFECDbW2pjY1Qg+YdQLqyDdE5gFpJtkUClM3BIUpKZFuPttOdxEMr\nILZo20U5D1uHtl2XJo8JFGrbE5X3V4/dX9BFbbsESp6yqmY1mK06bdsVJ8ho3Bb2LmO3B+dTbw9B\nNbfueEg14+DWI0pDvrdhVSg2wbi9R9RVQ27TwktWufW2i+jJ4FLsVCFx2+S5jfU+n9FtlUky2E93\nalg3XyUbD7tJ/1JjtbumX6wcwAefFkTxf/RzKhqg8GY5OB+Ot8vlbbUQA0Dvm8Ccd+p9urlByt7B\nP6HZvWF1xfbk1uT/CZDeFGi+SVEozoP+0Tmtb//3PdU+A3X02wpGbbDx92PvkQU4J2kfwMkuA+5S\ngUds24HigTuxz8/jE/x8wbOHM17nzlyDibTBqXtTkAZs08MBzfzc2x3/T7gncnO/ArfzFgvPGAzf\nsPp0Gu7Fp0/K4WQr3PU9XM7/OKrIIL7sy2kUKgObv4LEi2hEh4mDu0LfoDjuU+frE08i+vpP8bdS\nL15XPAyEKpCrW6n7qEYDGHdIhkvGie54aXyIOXQbH7ikGiAPeo0mVTvOAn5ICuMBkgXdH9d8Nw7y\nEfNCQuT31ozcskiOFuQ07/jjgI5/rZJz3+vONFMn58kBVrCjHDASEUDlSoWmEb1vVy5ZeXylZcVy\n0EMmozrZe+q3lqtV6vJu5S9/hJgjk86LlNuikn22ac38w8dovtb/UaA0AOapzYc410xv7jam+mJd\nq+zsbX5J2VwPeUOVDXwNzy3U8+8U39Y4nzt/7l3GTkhQoId60L9Mlwy9KYdEVUQnKOzAkSt6Thrd\nWhybwR59GKjH3EhXKZt40nGQMq0RS0+H6esK+1HTRxmgnyFOD5f6dc7TgYK6iONIX1F3QYI+Bp5L\nD4bKX53UpUxsBOHUy1J9neaFuupkvGt0rbpGVXZft/rpDaynnKxvN5jo0nr2DgqR1qXRm6RzW7dv\ncv1nx3As1t+uR30F12Cvm9yl/+tXijeEPX51j9ixKKnEGjsyyrNvZA+VHxTLbsuJym6zI88Vba72\nbhXqE2YXqpf8iNrN/cxda+fbryQ9tgsSd4FF2XZb6Paw5T2Y3Z+9E+3WmjbcfzpintXaH+uJlLkD\nzhay16K7kFb3BlE27Y68uStxznq9O8SsfRjvgQWL+J93BTiQ4iP2fhGN3fxpuVjZ+/AdI9maRn1n\nlEHd+X3h3ys9DgIV8G3Pom/ee7LqwHuyxHTBi9m16oLwYPJGIvk7N04pPAMSx2X4ej81rR0e2Yp4\nlog3tiZgPkAAQ6UirXixvviKQKE/Gh/2zHQcn9NtxWI1th4vAbpCZYS8whUE60b+zrFj9PxC7z15\n55RPJIQkxfK3fr/uLu/+OILEPKkArzfzMDd6JbE1737zsHqucKHzti9UD3me/Feu5OelekH/VbSB\nQlYPWBe9s4/e1IvAvih9HtMX6gPdOn15pYhmqE9hj/q0qX+y6oNKPO05jqRbiJBm/af4BIiX8USq\nzVxVZui6EpgRjpnSYA/aVGjq1ttZ5+9rMIP0Qxj7/MXS5s7TlJNYxYFgufXdcnt7L3Z6WS+2qX1c\nlfWrgHAp67e0bHWw3PqOvuuvZsWhAvp3/f9D/2Sy2Xd9ZBGN7dS7XivXteLd9VMAjqzw7/oRRaLs\nT8PrtwpsH4RBpygUSQNVCt7zLhmvr7ysdMsPA6N4vb/AHqEAcr8VezSyX++PGyC1Lw2k+i0NzdrX\nfbb9+Ld3jjMpZci9lB66r9Wz+x/Ee1SCx+B6T/Mw3/req/uT0P6e6wyeARv4RbUXefBrNfyZ0iKK\nZfhucwZmEV/wJ8IyVlf8s0vwN/Cg8e32+PpWDALYyFfVJ79K4PHH8kFNxVnMN60Smi0Zv+Zn97OX\nzh8MTkGR9vnEIUN/o8n1P/o567/lTP+Ejm1tor4cHTW2XPVDjfG4af0FthH9WU7o9e0+9Eza8ca+\n+KS+t7NfHIt+dr32fXbOCOB+aYq5SPdpOkSDJe8j+aXT+z6pLMkT/LmhYxv+4Cn8+gc+wOJns6/y\nP36CaOOwo/zJ1kBVxPzmQcp3GC3D+UsOJIyC/p+RMhil/039FyEN5B7XT6loh6rsX9x+hR5Cmu5+\n9UWtB/5fyBknTq5Bn/JucW/yl6A5f1elvyM/gmDrL96YTJ6El5suwu8/OBKSJJD/647+f6VZMczU\n/tOcXob4b3QWzWArm01/Cuh/CccEA2zABC4ACYQiPxAQgu05AAAAAADgXnDvA5T+PQFEO8v2b7r+\n/6/8rJ2fp9/f/fl55efpt5QpJSlF9mcFUs5+XmBlsbfN3pZbpGohMCMcI02g3i/UCNinSBzaEXBc\n1g9oUHajycCeQrsKOTQ/lgxKvbU5J3DO63Dn7ps+uG+j91bP0KnNyJ3RMW5lM40eWm3Dx+Zx/t4+\nUKKeTTTJt7UJZOt89grB6a4QNoJqforE4Wfy9N4ycmcz73QWZqymYcZqmoOBAOMbKnyIibNnLB3i\nGgSXE9oNUUplBzMmawOlhp3p0/ubOgntqhaOPquHuE+pInqlze6HGjX8UaWINHlo9ZXNZ28A3XoQ\n4x4R5J8d8zZGw5jVWZm5sjnIka8fQLFYE2X69Zm6tmyMnK3ltQgv/sGCBu41gQOnPXy4tn2xnC9c\nzcNYN9sAttExdFutjaCbjEPoVsOY1VkeFuKLg4WBXdlmmYbvzOd44fxUqqLPoGR0lvD1PYV7NY2f\n2ixTZzbb6L3VNn1s3sfwzi6itHH+5D7O31y9483rClQ4eg5XTOcew7xeVBnYrXJM0ltWQukMWEJl\nKxqRHqgx7/MozkWZCCtpfr2BUsN+YETin0o1vJtAvTR2abXN39ovouzb/iTa3TJyZLOMHVmtMzhn\n84Dp7qNHQbInzi9Z0mTXFlLsu3u8eTdSZeA95Aj4ew7rYvC2Whg07dc1zg4rygSkQSgZ/RuShNZH\nkoK2TqDd7yG8s3W+dJ1GD62WoUOTgRr5aAOqYY/l45KWEERznhph+IEY87pOl+5pNGxj3bisFbB4\nrI8qB3kM524cvziv0537QIp83qkzbCdQsWijBzcUyWdHiRreU6WHd5wXcuSzmzjD9oHUxBuBauM3\nYBr2QpB9XsdL13e4eD9HcO7f+LX9Gj22eidM56hn83zvvJ5aT9ju9jm8s38IMX6DfdHwpdFMo13v\n1Am+Z+bOOgzZnIWxu5aDdYVxEB6+uNYrDChx71co8jlbYB3NahXhlLdaS2UKRDhppk/u9shS0GYw\ng/FXOLJZU5lI/EqcXKZPQu9zeGfT5J3RMndj9E447iNVCm6dOAm3Qop990zeGX1t22Zj5LYzzV4a\nLVNXloWzsTWAbfNOod18ffNaTnN1wahlwWb40rQ9i3Y1kfhvJ3GuJhL/9SDJvX7zB9dn4tj6znfO\nProEvKFMwTcCFIj2lQ5xvVVFdAbxpNRL6LE55wzG+Zm+MlqJk/sVuFj0CVI0dgcwJH2UaeFtmPeF\nHPlsI8lBqNSwvfQZrhXAeKS1jGzOWUky5QQwFjtTKNcWksz7SJqBv8GLyZoCkU5awpBMOsGIxk9F\nIvEbQAV/oEa9oEa/LiSZ9w+UCN9XBUR+pk/ubROo5mn60mihyLutkmbXjgIt3B5JCto8XLx/wwf3\nafDa6hvAuDqH+/ZzBuO4HRbGb7EQRJ18IZyk1kuVhh7IkG9Gjq3reOG2Poh1ts1fW5+xQ5tzuHEN\nbDz2BzPE9RKngVLDvrTp/UeW3O5TeLflygEt7ilYwfgVqHD0SpxcnD+5r8Od82C77xPe+0SOgEma\n3O/0GU7QgrFHlTDsSprdP7ee05XrPod5PchR7/HP3vnK2TeCbzVOIFzHAZTrOINvf/sldmXrWZ1w\nXBeyxPOcgEuY3yFHvi3ViEXf4EXjZ9oEf6dPxC7BB6i2Q6toX8ACsvsY3n2gxjyrGZN96NHv4wDC\nfR1unQda1LOBEvXsoEc8G0gxzyqGI5EkoK/pS+sxc9t5xq9MzvnC1TaBbjQNH5sc1NjXn0bDttPo\n184By9HXNjl7ZetiOoVzs1Oqt1fZcKynSiT2AygS+wETiv6ACcWrHJc0F6toF3OCanNgAuqfQsG3\n02fhr3rx2CHEqOxMnd8kTe6nEGSzxmDks876cVk7cBH5iyT97pu+t88DprudPAm3UyXCPeE7O4IR\nTS0XAqpaDlxQ5QpJPOWpEYlfSJLPt3D0E4ZszhqShNYWlnzOC1Y8+iZQ8AdizPs0e2o1Dd8ZnUMI\nV0eZGv4NrJ9+awnnbwrl3jN6ZrUMHtk8RMn3mUa7Huq08C9ten/OH93f4eL9okjA+w==\n\t]]>\n\t<![CDATA[\n\tJzHv7xjCydSV0VwGA7u6yWJMpt2+wQDVbNYPTlkp0/uNKAO/DZ9bv6Zt5ZwunJ20KWjnDMZ9mr20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\n\t]]>\n\t<![CDATA[\n\t2UWPgrYRJeCt06XrN4FvveewzhaC5PtHmH73ECSfreOl6zpeOZtIvGcTUfp9JEtBGylz8BNR+n2i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\n\t]]>\n\t<![CDATA[\n\tIZQsftCKFfoQywDqTNQpcJ6US7yii00YRT9b9TJdYFHD7JHljNJIl61mAVjUPDed9FV2f8S4BPcw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\n\t]]>\n\t<![CDATA[\n\tDVVK5QhDLukGNCZpqRKGHYGKxG9FI9IjUJHghKItgcfm/NUE9XNYItoztH7WILKk0lxUTmcMrKNy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\n\t]]>\n\t<![CDATA[\n\teM9bWB2VPVBBpatUUNZAiXveDm2u2YOjTwv/D6Kev6ZtszBlHcvtbBamjMZyW+yLh7DQgV8xyOJf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\n\t]]>\n\t<![CDATA[\n\tGAERbGMDvuixFhAKxiw41Jygq8DpvBbwDQmYOAIfIj7Db3ZkhLiFKwc6lnheBkwwZrGIaMocrqDK\nWCkjvE3FhZdjYmNbCGSVzI+Ijy3dBHWswqpmnxpdtJlAC7vRJleLpSRTm+Wygu7QJVV+sCNT6zRa\n2HkW+bANgnCGeUjAjLCrVU4skWTfzetszbUmgOBeW15En3+y7eVF77au3mAoTGy5L0BqewA55DQF\nfsx7XJjQ4ShdeuaLLGqVN7yULToZQAdPMcAcWKUA2u1YAF0Xxk42LBjb2ELKcpkBpnErgWuzDnAI\nRko8KcaHz8jwmKujJ24nooKOpV0IoM0+sRzEOS2FL6HZvSU9tntQdGy/FCBRU3jCSS+FertPWC8G\nbitzrZhXjN1YNihzTwYxgBRaMS4s5JpKjflDAWKETdGgDHtgRfTra5wDLMM4hoglHYpeDAw47fLj\nI2BfLwbMly+2oIFqsvaJokap6waB8j9saSE2g0f3xa20InAPGST8qP6B6OMoIcBfFJgJFUhgfhtv\nCbPHrCHGxl1C2I0RENuODfDKMEbCoefG4BbMYtfi2gYLuJEMEL9w4Ckn9Y5DhrENL7MEdsxmVWZ4\nLgNM5w1WUGUuBUhoL3hJFdtbHWLDtQLpZ1Nu9DjWHPa/ssJLaEJZzwCaaXke6bQgCkBCvnAAEmEy\nfWZf/GNBMKk4DBOMAqUXQsHiu8ZAQkC9uAzBU9gFo8m7A5NhmwMrslwEAxv3+PrbwkULhuKlhuTx\nZctZosoboBHWusM4R4iiFt4QOKJxH4psFH6wMMbxAWzcpIvCGMkGJgScqKBjBDFL5gRcFvcT0YB7\nJXjiWERI/IkHiC/Z+HClmB4OxHFmClb1eBXMsUiWuxEHa1nN+qJu4MOxzjpCWXP48tnLrszwjTyc\nlAUCKXLbQV58sSUr6Ag3POUFNiRlKyKZ2f4lBv0BAdUZi0kn1smFYlgEA4wI8Taegu0bG5D1auFC\npxHgSPYqiyjYkopwWNUUcdiHsY2vPi4CBje+IgY49qI9GzsJEzEeEkIeF/mSx0xCaMdPvNLGB3zR\njQMQFjdeIMwMAQ5U4xoYgqY8Vrh+jl1xjxXFqXqEeA/X4TF8JmoniYc9WFDjqOZVhAqYfToBpj0g\ngDqPeXnhvQiQSkO96PqfSTlbqRTwW+WgpDNAGZUlDMmka/jWOufq0MUlQNi6vo19ZRjDEIFYJYH+\nqEQBO9AAXrR1YyzYsjErWIdxkQ9XYxgessY4Ovhxlq7BKwjIhDi+/MpHJV4x4RHNym6REeJKJn5s\nYwKI4Bpn4YIwLrI1YcyqwR4v0JU2LkAItLEAQsxjBD5IGCPRUDQOncBDZVHCTI64LI6IbcCzVVM8\nq4iJ+3CeGV7DKSCIyvHM64B1wGiYvYVGPTsZYVvZmKxn3tBqLiLsyzMFlTfQUSh4mimsrG2WmPLm\n7WKFFhvDyBqR6IZJMMCIL7RxkWzXuEcImkc1DzeVcV5KPBw/kI2xiAhjOaBGGwMgxD1ewAs7RsAD\n2HiBDm5jAnz1sRoA66eEANo7ACRADPCIAGQvjQP+3ZdxGHZcgA4Jxj4w/ASh1JLxhKPABWctHpaz\neJyHB1wMghSPkJTEo3KC+JONEEeqCeI/PIdfIzgZePryuQHz8Ug48m/1iGdkEnBYypXuVgAk2ns8\nBNvnhQndSMWAf4kDyxlmjS1oXyVVuiATKH3OyxNt2fgIlh4TAQsbr4q4GpfwWoAFtGuBAFA/9HEU\nL8ACIKDtU0CB7GEQBP6kCSpq3AUSkMvGW0SIjZt0bRgn6WAAAaMacID8adXIwJMA0yhH4D7CAt6B\niopzLTjA5ysFvM0CA573YQEvxFZxvw5THC4LipMpeOJYJyb+AIiIP9kAyXCkGKGYRjuD2BjI1+AB\nUWq7KDzsNiUytvcWF74MARq9bAEYXywBI/rWAUi1XwZAMbMpUMDHy0LEhxlgxUwFJDKMitUyxBKR\nxg9+nMULDCSBrvelAFiycQC8PoyrcD0Yy+CgBIDMraAoihd4Vr0WZkjEacFYbq84428Qg9oW4adJ\nIwUDYxQXtMZINGCNkWxRjW9gWBqrVuBZ8pgVQ+INApf8DfihvIAbygx4nYYDPIyqiHM1EfEMRkVc\nQtEQb5BTdOUzFg5Awex5DEgowmDaBFzMnrXEbVTJ7VyDCBA8jAbLnETStQT/SBV3f8i4NPzBWZmp\nZI9v/CXrx6wh/nhKCO3YiZeHMRMPB8YjNhC1PmaAGpvAUGHMREPVWIaGnSPhCTU7+iLYBBnE0nGi\niKXTyoiFU8QQa+bGYAOZGXwNbH6EIdwMWXxA80OxSuaF4AI+qXaA+81UvM5DFfdSYIAz+FHiSTVF\nHIgHydwYyQQFDeluEGRNQN7kDlny2T3ixVJwCCtlIJHVysEgBVx6e8gQd3/IqOT6oFHJ9REDU3EV\nUswJxQ4yBpcyQyAJ+LnxAWF24wPEtsZMOCAYv9j6MbJowUYGn5ZOEa/WD5ZICUFbxBOODgBa4cBY\nBoYGYx5bVOMaGJrGJCwMcZG0IGOjDgLfwwDFvZ6OeBWPEHeaAeJFM0C8SCaIK8kM8aUZISDOk5NT\nxH12aOpCWM1jLh8sw0I4Jf2OcIn8K1JEtJKJ11KIlrJOVVY5zUQdn5qIOUQ1U6HEVba4goaJ2iRu\n8kTrWiEXLf1tvAVMbfzlS8O4ygYM4y5bSOMYEnSsSD6IqcF2xTVpBtzxiwG325ri38ETpxc8cbAD\nT1wCkhKHEJTEGQAl8SqgJM4AaIlbaDLAsQik+FmWFO/rkICrWUlxDkpJfEEPEWeK+eFIOTQ0MXzG\nwE5REBDEDBfGRDrEja2IEUqh0s0W6DF/GLcQ6xoXAGa2wGr2klDHDMxuDyCkhTuMiB9vQFJS6ig0\nhDFlDLAVAS3YGIuHB+MeGpAKMFqBaSxjAk6rpJVNEcIH1xdsDXiolgH/clHxtgcGOH1giYMZUOIZ\nipb4BaQkXuFIiUc4OuIRjJJ4ltER1zIi4hiajPiGpiOeIeqIg3B64ltMThyBThIHugZxHt7DayQ4\nQYGNo4AQg3uY6Bw8YiW0iyTLZ2ATBEAFm2z5FFxypXMwSStmF8gQzC+PHJneHjIuD3lwUjICUUxU\nhaIGZwAAhGWNj2w9GB/BcDRWnbDzJBIrRsXbA+4ohoDHTWjiZA6KeIenIr6FVMS7opL4V4IkXjtg\n4vcDJv4VhcS9oo74hqWiBj1FnClG6OgaxIU4EM/hPPyG58xc+36VXpYCiFWCiXx6CiopAgrY2oUT\nkMkBkn5JqlQKEqFB2d1B5NK7w8nlN8cRcdgGCkvHHJKQo0rmCm1QuePGXMIyjJ9sMDBGcSGHiWHW\nFYVaFW/seuKVX1G8ayGKw1k9cTUGTrysyol3QSFxCEJEPIGPEH/SEeJPOUEcKseIP90UcaKrEA/i\nQUP8hzfVCHEDMkUcyqaIO+UMcSOZIL7DGxwdSY1TZDjEYcAXe42cVgYWcUIZuNpDkxNKnqZiEUix\nl4eNS++OHaSFOpqAFhaQxDMRRo3Jyh1gR1Ahd1wfWDzbuAsYgvGMDD1SFLWupWMOeCWWigNyMfE/\nriXuh6GJezdI8W+HKN53YYq/QYDisoEmfoEoiV8FHfEGOUU8gQ4Rp7op4kpXId6jw3c4DhfiPBzp\nGsSfaIp4UYwQDQy/IvUcURj/4KrkVIKH2fWxQ1PwyBTNQSNYMgdXp1wOClm97P6QcckdAsOy6yOJ\nZRfIkEpHH4uUlD7CkaA99viEbKGtxqsYhgQQWeFK48yKf84IOGdHwBm/pPighidOF2GJkz1A4l9R\nR3xL6YhHOCLiD4aK+AKdIQ5VE8SNrj3c6MrDm65AvClGiC/FBPGkaxBHigHiR1cgmSsIBVIWxkw2\nTCoiQdTkrv4ADXQyJZSbZMroIBMqodwlWzi5q1MsBVeVWHZ9OMn88lCiGb5RgCVjAZqKqk3W1sYG\nfEUYC9FANXaR4QcLpFbMCrQrrtiFgMc1MMBtKCVORqV0IUiIVwgq4hWAjrjWUBGv+iHiCHaGOAOg\nIp5A54hL5STxIxoi/sOB+A7vufKYGE7Tw304EO+B4VcxLKh7XIAuyzAQ0k4ukSWegky8aAIu6ZIp\neMRLJpdIFfEgEB2ahDlydBLyENIJ1uFkM1wAEUvGGp2OokboDldAOUsbc/nyMK7CtcOEW4FjYht8\nQELiXEVDHKzJiMtTRnw2kMR/giT+dmWAq10Z4HISDvC7SopfMEriDX6OOBXOETe6DvEeHBkbfr36\n2AzxCRCgrpBvWmZjBUKIuUFwWHKB+LDs+mBiOThkiLjrw4YlIY8UYkIho5iGPz7FYSGZl4Y/OMXe\nHjIsE31gWirywLR8tEHJtVHFbjD+kWEnyiAFLulVxesDShzE0xDnSiriYVFHPAt1xMOgljiXVBK/\noHTEr4iU+FVQEmeQg8QNzBTxH+5zY8NxanB4DbfZapBgazxlg7hwyKUml4iRS24QHJjdIDwsvUFW\naHp9+NDs9giiySVipPPrw4imt0cRze+OIJuHNVhYLuLQ5OrI4s/GCYj4ydJI4SrqsWBA+wPe7aCA\nf6onzkHJiD/QEeJVN0F8QU0Qp5IZ4k0zPzzp6sOBOA/34Tm8h+/wIpkf7jRTtMN7+Ay/iemJMDai\nQbMr5IYnd3W1UxBJayh3yRZSL5Iupd8iWkzDQbaIfoNQKS3k0UoK9iHlErFHp2WhjRWXijs0JU2T\nxDmigKLWNrYCRjUewSEmdSyLoz2I4ltESByCDhG3whHiDnaAOIMcIN6gRog72BHiWEBEPGuoiEsI\nOuIThJA4BB4jLmVT9MN3ZngN5zBXnhgjfndRmKoy2iFtvICIy8rWvkpBJiYq+VhbxYJCeliCf5ha\nhoGcWhb2IBWDgYRWcn3QsCzscSouZYV7vOFlrHHVABtT0ojXErGHpiViD03xYg9KLo8tvcGYx9aM\nDrYJ3IshAf9AZMQX3PxwqBgeHiXTw6VmgnjT1YcncSAexHc4EUwPX4oZ4kYwPzyH53AajsNjuEzM\ngwMKvMarXZEosKCJwUgwxYRDSC0fjxBaVhoZtKw0Migu7BFq6e3xQvPbo4DPrpDVUEIeRTq/PH5o\nEuq4gVl4A8Wloo1PxBNP0tTGCIhYGp9agPG0IfC9DAi49sATvwIy4ki8h/fYcBpOc8Nj+EzQzhC/\nMVjd4y9el4ZAOi+/PWZcdn/QwPT+yIE5WGRJZ3cIKyihD9ZOLxAnm10gTTC9PYZ0Eu5YYin6ZC7x\nhxiTFImdJIsoaX3jLNqqsYkOMyjcJvA3rQT8gQ/RTQyf0eE5fIfrcB/ew3E4DtfhODRXHgPDr9cY\no6OlGkm+LXvcxUvsgsuZ5peJp2TfZN8SJ5N/SYxUeoeM0JQ0AhaPmNKGabnkD5ORiKKlIRBNTEYi\ni5qSRsCXok/oLlOlvFmeRoG7XBTyWPkFMsIxRpaywSsIyB3GTjpcR8si8DcKVJxDUQ==\n\t]]>\n\t<![CDATA[\n\tEo+a+eFGfIcH8Rxuw21kuEwMj6nhNZzmymNmeA2P4TOc8xt+w3V4z9WIR2DQ4PqntiWEwpArwjhH\nh7wxALCX4dXPyu6qCfGgkRWW3iOnl4hGHjEVVyEzJY98xYpBIi2/O3JgEuLwgfnlcQOzG6TFZhfI\njEzCHTMuvTxoYIZ1pLhcxNEJ+UkkD7DIAfOHMRauniTfC5yvAwP+ZcAAl6ohmuGcw1z5lcfo8B+u\n9jWhw3gICL/xAlm4MZewPrYSQm3s5YtRiAF2pWARK5hcIU8svTxkiLs/aFh2gbQQd3vguAzncGEZ\n5mF6iehD07KwB+llYY9TTMIcOTIvmfRpai7huxwRpa2ygChnj0iobA21WOlsYy9fCcYmuIakLGbg\ncBcU8CmbIW7DcbgMn+EwHObKY2BgdjgQ7+FC/IbvxHAazjkMt+E5fEjHiYewAEFJxyWHuPEAwCq7\nrZSQeVWSbEJC4S5CGUBvjBIAb4k65c2yUIimuBtERSXXRwzx9weKTcgihZIztJRpPh4JTw4CuUEp\nOASHJWGQVEvwj1PKLo8eluEdqZokorw1tnKx08ZMsNzxF3lv7AVLlMSQA0fDYsAX/BjxIb7Dea40\nnIfX8B+YGr7Da7gNl+E0V8455/zKYzjnnHPOOecBWU5iO3I79A4bXIQsKwlOWA6sHjDAgmAlocrK\ngQQJD67SsCSkRTCrkgABglaVltrZVRWWWgS1KqwyB2oQriJYYWFFeKD1QC3ClVWEs6oHECBIqLp6\ncHVVlWb2QKsKTSsLLS3rQZoDq6wsBxAYPIhQF0JCBAZXELCyrCQ4YWVhOTnBlV09YOCgjI0ObusB\nmhqWmgOsCFkO1MqqrtQiSKiycqB1VWVmpXZWpaV2hYWFZqUll+GVcdgrw6atlcWBcLp6AGIrDW3u\nrE1ObuCEwIEDB1cR0LTSyrCyzKqusNLMqsy0zq6qHJhZnVVZoWmdWWVFQKPiAELGs9sac2AFYovK\niYITgrGrMQdjVE4TnDiAkEOIqBt87dil4d2VYT/UO2V4ZRzQ5LikpMYNXvggyD0EJhg/1g3LWsrE\nIc0e2kyzt0YfMPE4e0VB7SKqqPavKiy0F6ioYoUaAfsM3ZqROHADklFaadMrVMlXI4DROCuYATlD\nnSoaAE3sRpODH8r00FepaGTy7N5EkH920iaXaZPwC0H2fZ7Eua4Dlqt/IvXmqBKLClpA0kmYXROJ\nVSccbaFFwP/DmIdgxKI9NSLxR6Eafkc+mgKTUK2IJqUfgo1Leumz+3PIx5RJaAs59n0hyD4FJh79\nghWPPkIBm7QEHZq1AxmVtFUBlTQEG5V0i8Z+VQClT3jv6wzS/SjmQaBhWVvFkIQR2aVUEb/R5OBP\nwuxaxQhS/PM+hnc7XrqkzcEpVcRfZPnniSr9uhMo+CtwseilTBO/ECSfzckFWsz7NnpwXcc7551E\nwUSYfF/IsY8oUtAnbXI7FGmhLUWqaFQJaCsw8eixZFR+BSgabZxAOb9TSNeZPgl/FOohTR5afeMn\n13e+d0KNfJ/KhKJ3+gzbO+C5L9NmRnM5K8axXmAzdGp00qagreBE41Fm4M/5wnklz65vGiX0QY17\nn+fwrs7xo/tMn97vBOq9fcJ5t0437gcx7n0FJxr/VGljbwIFK3UO/qLLPjvnG+dxBt28gdTv1Y3K\nLlWK+G/64m4C4Wom0MJ+tQNTjtBDU54Q5FOmMhE5O5EW9iRM70/y7HajS0EHMirprB+bslNp2NPw\nsckwbh2MRvCM7jm861k5xP2CkM/a6oU4Sfy1pVIVu1NooTeSHPRF4j8/FAlYP5ES2k2gYf/TeOdp\n+tTkmLtbO9N3JkehHnoHMippCT88ZQcuKmumTfCRZSCXLmlT0D4wIvEvcXqDIvke4BDPEoZ4ai0k\nETUSB/qnUbATqGFTKCGQop7WD836qwnqzyZJtbegiM5VKiD/0yhYgQrGX6GI50whSed8gfVzxtpB\n2RWkgOxMm4QfqDFvQQtHv8UklJ4gxNOIMvA/iRZ+G5Y1VGmhLfTIx+Q5eFelkPQLWjgmZQ4CPep1\nI0xAfyQOLKoM7FUtHD1WAZQ+6hR85wjO+Z7wHRKnoPdBxIPs+ziDcXWNn1o9RNnXEaw4tBGkUPRS\nqoafykTij2Cj8h9QNdQZpPs8hnU8hHa/Rq+t7jGs80mdgx9BCcbPIEYQJB+dhNn1O987z/+M5SC6\nRMi4qdFXNyq7lQzIn9WjshtdAo5hszN3ZLXOd67eCdP1IEm9emYujSaSBPRBjHt/5u6sx6SVTehx\n6beAeH4EKRR9jhcuUtADJerZSZZdW0oVEQINcR0ZeKVjsqadmLC1TEp4DU9AayjSxVr06yHkENcV\njHTSEHBgzhJ2dMofWk9rD1RQaQQoGntN4BoNgzaLXdM6tieMZ0EIZ01lwrE2MFoYdXro4vEfKMHY\nnTwNqUos0vil0de4n6XpS6OXPL9+wQrI3kCGpYyFQ3OeUkV08gTfSJaCP+G+fzQpaFelePQJTDDm\nhOEuAWusH5ryBlbTGQINy9oAadhOwvR+Isk/T2WisSNA0QhVGraJIP8OpCLaF4ZwdgtDPGsHLnK8\nbhSOaNZgTkz/d4Li/ppSYmhy78/YmdU3gG1+x2vXGbRw9F1LRj2GIqA00ybhP7oEvI0mAScEwayr\nWDDeU6g4xP1AiUPbCdR7L3F6vxSJsJ0AxuFHyhz0Poh3SJiD/+qGpK+wqtkXsHD0SJhd38QZthes\ngJRSRfwHUBh+I02/P9NXRsvU3fLNYFttZAnokS67XgELx7pBjMcPZQqegVurZ/DU6Ju/uFqHcK7e\nAd/VTqjejzXkcmYwo9HAaeGHIjW0oUYRf4MXkDC3nK3Ba6ubQgk/lg9MGutGZXcSBf8aPzWab7FZ\nnu364mNa7bWt1uZ44bzPIl4NxLj3nUi/NpBi3peBI6OvbtssEaXfn4BD0zd40finThh+G+5at5rh\naEuNItoNXkB+Biwg+5LnoL20yb2tZED+LSegtQYjpLTYkdOt2g8UZ3QzXqi5AYFRllVywvd0+xjA\nYLQlCNmcI+jApCesfspeVU7Mc5ITH0MS0Vnq1LE2Egf+HsM7BCkWfRTpoT2VamhHlSL6KhSRHYFq\nI4ITilo8OucsHJp11QrJfiC1cQiSzz7KBPxMolCmYNtGZl2FIrI/kX7tp89wb8okvJU2vYe/qfTr\niTb5apo/NC2Nn5qWydTbtZJ4aisU8ZytYEh6Jc0vhBuVtQ44DilzEImyW5On5rnHamXkxroGJKL1\n9oiK23aiwuYgZbResAKy7zCBer9Rpd+NAAViCcbaKbTwG4kFkcRcu8GLxo+VY9Jn4cDsT6KFQ4x9\nd89h3VSJQhurx6SnUoHoDZQS2kqYhEOPf56HZbeiMVlHkSr6pMuvNzBa+KtYQPYJQTDrAyoMf1Bk\n3rcJTPM0fGj1zlfOwKjhV4Ci8U+hHu5867xOt87jDM7VPot4UKqE9tWPyfrBjcnawGmhP9Ic7Euf\nXS91emhPkTj8SpqDN04gXM/pyhlVcofEfD0mjkzLb1qM11ox3sPErml/lrG7ZSLJvzAjomMbiIB2\nocW9G6fvzfY5vLN5vnV2USSgTcNX1mX0tjMvw4JtJfHsE3pc+gtBNv2CFos5XrgIPDjlDKyksogl\nph8Myog+Kylhixk5vRWYePQzcWr0UabfzQDGov0k+t0+mYb9gRKMXYGLR1oCj87ZwmrozIUk1G+t\nfnYqVUWmTe72xxBvG6S4Z0uZJn4JOTA71oxKWwq10G4K9U+hh96BC0l/RQOT1vKhSUvgcVkjOKG4\npMm9eQjpDoxI/BJ0aNZYMSw9FQnFqVRFz8QJ/lGjh7ZUKCMjHwIbNE8jnawkyu0GUgu702hhR2AC\nsp5AJFSbQUqpln4y4u7QKtojCMmcrQqgpIsmAT+O4Bx9A/hW53zh6p7DO98EGr6q1TQHEwGG0xdn\na1gN7R4JapnXklEbxBPS/gHLaKcwxHPOUITTTwV+JlBvAxiTdRWKSG80Ofh9wHr+aLLrq1I8eq0e\nlt6BC3HtU5j3aerWaho8NVrHO+eJJPtuJ1DwjzpF9FOoh7YCFY6eqsSiJ4L86wTfD2RM+qsZkzlc\nIEemUK69oIWjP0Di8Ddo0WhvGo4xZRLeS5vcO4hx7xtZ+t1UJxBtBzIqaQlAOOWsH5g0AxmRNBTq\nYReq3Os/jnp0ESZgbUA13J0+C3nCdEyeg7fOl67b+LXVMnlj8pWth8GYZcNi5m55h7DO8xza9Rq/\nM28jyFYbXQaKYDJqK0gB2Y8oA+8pVURvFAl4z9Sh1TyHcTfN31kNY4YV43UHLyFHvw8KvqKNaa9p\ndfYG8K12EjWsLygJlWUnKDwHKaO01YzJDiWq6J08v9svnJAknm0k9ruPJL1+KlVRQo9MOgOTzzqL\nhmZXwhy8afDUaJk2M9omr+3rDM4lSJF4O3DhaEuJJv6ly+7WSHLwO3EaXhXwAIZl7fTpvW8A3bqM\n3Bltk9fmdQbpvpHk4F+gQvG+KoDyKygR2Z02v1sjSUE7KfJrV51wtKVCETcF7QpPOGcbwjZ5hm8N\nWzOoNut46XpU6qHP8MRU9uBFdRZrVf1eVkr9hSU0FhDKrqFVlK4gJLMrYQ5ucQDdtjJwZ3VQ4d4Y\nVg2x/1piakOIUdkXtFC0L0AJlSkM8Zwf1KDsQYt93gkUbEVj8oKSUDlCDs35QhBPmusIqK8QZLO+\nsiH5o0aA/1Dknzeq/Fu6BNtPo2ExdwKQTSNLQEK8sajQ8NgCEo81em21TNzYDLM2Y2HKtFmfQzz7\niobkZ2Bie5PHl73pg+sJVjiGaDX1W6yl8oEUjLSBPm+E+eepUCD+BSwaPdMm+Ghy0KZKXbSPJgXt\nmr22GqZsFuNaEF5c28ErBu7LSpuDPwELx36EKehl7NDkq5udpelTk48yA79PYx49Y4c274TtaiHH\nP38122a5HPYVA7eVawTTaJi1Gcs/iBAxZ2WzTV6cTSCbj4HbzjFwWzlmjUzuSazzFKCAar2wjKgh\n8LCcjzIDv02fW12T15bTjYs6PaQMVOCi0Stw0TijZ1Zf2b4WBm2WY9zI6Bq9NU+Tp6aU2bWTKrtb\noMO92whS0IYqDdtUJRY9ghSLfqmzS8OX1mPibPnKVssxbWN0jd7cXdQYeDNdEm6jRA1vqNDC+4mz\n8KZKTXRQgGS9ZNrt1zn7i2+/vGI0BycQ0ax5bMpTJJpQwXQWkk0tl5XSOSzK6f9LSGy1RlBvKtRF\nO2kycOyoso8sp/t2K4kHtxpWQ2suI6N96jTxAy3ydaVOb58ycegRnFD8WDku6a0jobQBz8QsHpc1\nFo3L7qEIaQ9LgmpzFQn1VjIgv5Nod0tUyfedQAlvC0I4+4UjnP3AiMQewjt76NHvR5EqeqoRjF5p\ns/tzBuX+zBxaTUOH5m/63v4OuI0spw9uzIdQzw5izLtr+tQ8p0GE4DSIEYZ/KbN7yw==\n\t]]>\n\t<![CDATA[\n\tyJ3RvNNamLGavo71movo+uIbKny4stkyBByUHYSWEvIWK6lsRWOyK2jR2KVMHHJyPdWJww91Whik\n+OeXLIkYAe+YtS3NsV8hOB1CBC8LE9s5nPNXPyZrqx2StRFmYJ/BK5O5nf3aQ8PCqPUw/rMirmke\njHtZRNeCyciVzTmEcLWM3ZRp4r+qoUk/oCGupVQRd8B0P+cr16lcFH4wLai+AxdTegoFYtLloH1E\nGXgTOQb+BCQOxzbo+Ly1dIiBGvMMgBbaTqLgHwN30zR6aJ4Icm+MJzxX43fmhRT7biNJv/soUnB7\nJP7bHlkK2kyZhDcT59cmmuS7gRzv7Jq8tS4Tt61p9ND80KPelic8d8vAkc0zeVtCr+BWqBHQB0Xm\nfZm8MZkoE3D+oGTUa0gCuvOt8zR5aLXM3Jnck5hHL41yIdwQ10+jYZ4wnZ3DhbNxum1/AYvGH7YE\n1d5K4tl/DPP+jd8cDfSo16dUHPYMU0hlMCgjeockpnTTZmGCE4y/CgXkz5ohthOMcLSRJLv20mV3\nC7SYZyC00M7Cgdkf0KDM4dL1G7+52sdwry9lem2kSm4NH1ufuTvrNn5qviYv7d/0td03gGu3jV/a\nffP35q9qXuZYri++/QJT+hz0T7QWxu7ZD1whuNYL7CdRz1co4jlbYEKazQqiOW+IUipzgDJKJ1iR\n+Ikg/yT37qXMrk9h3u8J38nEnXX+sVgYMjpL84c263zjvg/inUcKBfRUKBi7hCKTHooE+M/UoWlh\nyGYwGDP56wpnY3PAczPQY16v+XPTXt3IxGj41rRNpN6v1Clo1/C5fSkrPhsSGVsNTrCsJOYko19J\nOsu6Vj/HpkgT759DPp/jnauRxFz7AQ3KviQq6O1ZpPtTIwi3EW5I2k2h3DsH3PZ3DOW60mbgzdTZ\ntZfE3htoUc8LLQIibQLaNn9tHefr5rNIZ0+NINxe2ZD8TKCCW5vANCMcvjgbB1Cuc+V+zd5azW2w\nML7d6x+0pNJeTVLrJcqcwDl7Jo6t63Tftn43f3H1kTjwV8Fo7Fo+NOmqFI/+KBOQSPw34chmm88J\ny9FGmIG0hSimWf+khQdTcmo/mCGuD6gudgk7Kj2VaqKNJBk49hPOu30O58aEIvdsocg9ewiSD+vG\nZRJm19/8wXUZtza5xxAPqTIQqNHuzvG62TJx21omrqyeiTvrMWZjdAzbXV/R+sy1HETAmGmxOYVw\ntU/iBLyjShG9EubX3vHSfaJHRibOwi7BB6hWROvpl9BjcxZ65Ps63rhPg4fmcfzidr5zNk0dG5qd\nvarZdMzbGG3j10aGFYtCTexgTUbvDFBAaSFKPX9dG8PK5KVhizb/aqwcl/QCF45Ak3pz02m4jjpx\niOCEYw3W5NTu4uhxdtbq4u5whTRpUo6sMUDxpDW0itIepIx2EFBKPVeSz39Fo7IrGOGow7XrU6mK\nvgpGIwxanb3C1dgawLVZ6vTQ7iAl1HNYsnkbMPXeNYFp/Ya71pE0A39TKOFvAgX/occ/jyTm2lCn\nhV+HcM5f27z2GldjawDVZg6toJ6DE057Jq+MHqLc+0ykXSbOr43TN+d3uHifCPLPLpRDfF3d5jAm\nU2/fYMAIrY12a5E0A//MHtoMx5qrimjPOjEdC4MywntoLe0bpIgeOLFYQ5WGbSXNrm2UycM4dMXM\nkWlpKS36YA4hZGtBZGw9SFGVp04Vf9Ro4hdS7Lt5uHJkQ416Y1Gn4NtockOS0FoEE9BthSKfM5Nn\n1/Yx3Os+hXjfiFLQR6Em6njlbJm4sk6zZ/aTaHfneNtunvDcfX2rtTFwXTuDl6aV0TvL4oDZKKyG\naruqoNYzFBQeu0T1e0gi+qVUo04P/QIVjr7Hi2fP3J31m8C2JErC79QZtn8a6+bUaB5COrIvxjv2\ni4Pg8sC7uEAAKfJ5DlJGawlAOOWkzsGf85Wjexrt6KXPb02FQtErbXq751/doAckzcCG5LzhSwks\n2yqNW8+GjTO11Rl3hiemMoIVizWVisV6AY5HeqqFIW31Y3K2IMVzljpR6JM+Ba+EWM4ZoJDKGpKE\n1lxKSOuuJKT/60joGIglnzcWjcseMJ49U1dWX9u8zGcxEVezOrvzrfMMZijaXlA6xzos8bSdTAk/\nDaDaLJM3JgNB4nkXk3QVC8huNBk4k1dGw5TNYjBpXbtDWOcXvFC0QUDx3HIp6bSZRr9eJs9Me5Xr\nWRxCt9qoktsTrICMMjX8SZjdf4DE4RMJ738aQfh3wnE/Zo5MO7N3ltVZjJunViTSFJJ4zhKCbM5R\no+GbJm+tnqFDm59GwTR8aXSMm5nM472zmTy/vsqGY/0AiHjGwBoqg7iCSgGIqCxiiekXM3J6d1gd\nnUN88a4tEHNCbmzbjuT4YUxOdASqkXXfDbS4d8MX54Uc8camUg1tBi4WbyRLwC2PYZ1X0uTaGVY1\nf1cSzrEOSzrtrB+U/sfQL4dL13W4cz+KeZ9oku9ewhzcJl0O3kWTfDfT5+BthPnnizb7/E6YrsfE\nbbUyd/ZcA6g2L4F+0ZrAsMOmoKAh4MCUuw7XrvN872TezIoiAe2rH5P1hyShNoYlnvWRZuD3WaT7\nP4x5fcq0cOvAReOdlBl42/y59eyHENe1GsuDWFdPlUiEKhH2QeK8TpOnJsOwdTBua8Fi4szEcsBz\nsw4inewjaUcbcQbSDHZEzmNQWNhpRlxswaSM6BukiNJQqoc10ia3S6Uw7BemiMpcB5TSYVVUvdcV\n0o+AxeE3wvzzUCXCnQEMyF61YrJjAaGstYZszlxIPj+tBHUsLAmqvXVElLZyEWnf8MH9GLatPHN3\n1osc/7YXjnT2Da2iNYcqojQIJ6D3hVZPGorEYe3TmEd0+VdXvYisLTAh1WIoAkorZXq/jSBbbRPI\n5pEqA+8LRjhrDa2itYYponQHJp63lpHN+Qm1sO5ZtKNruGpzD2IeDYWKWE9AAqrd0IQ06RPQD1X6\ndadUcNdacllvaRGdGdBo9D6KePWV7cbS/KlpkUb/6qcRYdrKhmS9gIWjT+LseqdScE/g4pFmGv36\nHO5czQPGq33CeTcPGK/uKdyrd8B6s4IXkHUYkxKdQxNSesIPzboLCemviaiSbVj1/EKNfHbM27YW\nitzzYUtQbRlKio6VwzPL4IVkDRWq2Jc4CWv03OgZujO6CdR7VxCi2SnowPxSqoh+Bzz3Z+rSZhxu\nXB1VGr4TnFC0n0rDHogx78OQdS0XEcILZmzOzuCZzUCJe37psrt1+uxulSwHx2bk1PqVzWdvuG61\nzyJeP6ACsW5QQGTt05hH09ir2weLkSPDCkUC0hsQIIGdt7SgwbikYOoEdxy/uc/jzetLneDOxPm1\necJ4/QbQrSNddr2EH5d1iCOk9gUjoPRd2gzUmJd1Y9J2+gzbM3FpM6+xYTBpdYYnonMGKKC0kymh\nxwm/0TBr8hcHgYEDx0ChAudgYQumrAaj8WOTdxrpZCBKvTkHUU7LNIJLU2jSKUuRQOw6XrsmUUN6\nh/CONsLk0hVYQ7Uitqh2ry6otYUnn7PQ5J7nUZRD4EKxfjI1pJ1ADzvVCcaetSOT3rDq6TUICa0f\nuJj8SJLdm2mT8DNQAfkp8OCsvZKUfiwSUjIwJaN315RRz6HKp48gxLJO8GKxL5F66adUcJcwJJPW\nsGR0vrpR2ZtEwV3Ise87gYL/BSOgdIgmoXcI1tDbw5RQnyFKZ2dQwGNSKLdG8hSslUC7NZaPS9pD\nldNaQxTQOmoEYk3TpyZf4+6sUOVez1qd9BWecM5VMxz7kJivz+yhYWkA12Qc7luNY9hWR5Ew7FpG\nNuctVlKvLap01xbUmgKTT60CVchvoNPwDlrs+zJwZlqewzvawxXUGask1dbqsTkvWOHoF6hgvBOM\naPxPoGE7adJ7L2AB2SsMCZ0l9MgkehzsClYwfgxCPmstIJi1EWWgPYOnRud05XqDGJFeQw7Pu0IP\nzn6ghKK/AXTzM3ll8g0fXdcJnLtr8Ni6jNzZfDXzWW7LYjFsW/lattXKzJXleOG60ONej2Gd52Af\nPnCtBw83XLksAxyV2g1RSOckTW/ns5gInvXyutLdWR5GOtrIcrBPmMIp/wNk0GVbbNT+SQs/ocin\nVkfQzsGLyb4hSWjnsES0U5Vg7EaV3O70WeilUBNl7Mhm/r/AZujQ5B9HPG8kKWgDKe79a9rXchsb\ndm3bZn8c9egoE4k00OTeHANXFgZjpgXjIba4eIQqLY41lcU3YFHgHQzEzB6aNscQTqbpU5Ovcl/s\nxusm5xS+0bwO++IdOIBQ0gT3JE6uf1JFnLVaP7MgvqTSHRBIlbWeeGoTsGDsQpR5H2lTsGOAMip/\nSUH9YFVM1FtEQGsJOzJpCques5WNybqKBaSvYgHZH9AQ1x2UgP6wJad2hyOjvsGLytpJFEx14tBe\n+vR+IUk+H0TJR/ck3tE+jHadpo8tC/S4VxsYNfxImt3eg2hnRDnYlTTBnQnU+6FUCW2mUK4dJLnn\nE2lH6xjS0TiEbnUMHRmWx/COdgoN0/S5yTBmPUxGzizLg1hXH2EKeiFKvT6jhzbP5KFpcwzjaCFK\nP3qn0I6OiRuTY+S28o6hnG8a/XoJQTbnugmK75ZkxvY/SfEtMOmkkzC7/8YvzvcU4v0GMSjpDUhG\n6wlCPOcn0cJP1Oh3+yDa2TpcJDH3KzDh6LV+aNZNoOBPM9dW2/y9zUSVfXYVCke7gYtHr9Ol6zN0\nZjUQI96HGjX8VSogvwMXlTWDGZF00ia39yDa1T5hPa/DtfMyb2Y091mwq9uYNqiRL6cr12Xg0uaa\nPDWPw52bhyQD6yRNb98J29VXtR/GsSA80ACuYSm0dsocspDOPYp4NceGhZjBY5ONNAHro81AqRaI\nc4dxCrEeABrzmBQZ3ssKibmJM2z7FOb9BSwcPd1K4vZMTNxYQixnJc6upzrB2A+cYKSFHvv8zJ3Z\nfF2bszN4Z7NQI5/txEm4DVLcs2PktjNMmTas7YvxrVgXD/uwgd9gIGLo7uwMHxqWi8DAxSUc0OIh\nKmSAOdOGsPG2yUSZgDNPIt7c42hHK4F26yDKPTrGbUwbU0ZGCzn69QUFNNZ/y4x6LgoQb9ZagAfD\nUqK+0qGpVeL0dgg5KmkPrKf19oiJsb4aNtLydBRgpl1CwoZwQ1w3iAHZq1hAWsGg7BmMhNIfmJTW\nXKyiHcOq6BxlqtiLKAe7jneuy8ydaa9vPVsDuEb/OObRNIBoWhg0G+z65sNq/trmm8C4+ar2sde3\nLTbHS0cfTXY9UaSg50Gsq2fqzGbuw754LcKrBlBtXhIlvLqRicGw1WFxaNm4sbAeRb35SHOwNroM\n7DV+ajVMGo29stVi17gPJoS5V0s40ql9Kg37G784D0cmx7SRaXW+dnOUFR1MywkaAo5KeqeQru8Q\n1nkJPTbpC05GtSUgaSFHvZ9DPduIUtA2YLq1JJTeQgJaHyih6Afh6h7Eux7UyPeDFA==\n\t]]>\n\t<![CDATA[\n\t/3wP4V4vmgT8SpteKhKNXStIp7xhy6msxYRTniqRSMOXRvOuBeNaESJm9ta0Rpp+X+lz0AMt7vUc\nwrg6h3BuvuHKZX0e82QhMR+9g3gny9iZaWXkzLI/kntaKheKNZQJw/qGCyfDpNliQZJ6tYMalDRV\nikaaydTboVQU0hMSMA3LJrCCxnpRQUPIoSn3gPV8Td5b7UDGZH8b0sJsa4TFveQJpmv03GYhyb66\nafTriy79fhCkns8Bv3HYsTnWpUMTzemz8NP0ndX8TOyLn4F5yeCZhV3nbjAYNW0InXCdFArEmpNh\nQXAJCirwsK0NNoVu2AMFNGotaBnNZg3p1Fr9EGsZ1BBrIwDZ1HL4MiJbK0FhayXhlOme4Lgld0wp\nQyQy5aZz0sOmWVt0rVVOuYEMyA7iCWlPG7KiDM8GDLU2HizOZCYlbA9WSq1uWMoHUiwqSNHopUgV\n/ZQq4tMouOrFY6206f0ydmUzDqFbfQDFYr0ESthh2moRvHt5mNFTy+4c0tE1fWz01c3G5njlaCbP\nr28AQ7Jm6gT7Gb0zmXuxENzDBS5+FvZ1YAViz3DlNMs04jvbcN+0NHtu2pg5Mu21rGP5jf26GZST\noUgYdgutoloDp4r1Fe7O8jsb4lpni9l022SoE4U1hyymMoUmn/ISJ2HX6dp1HG5c7zHM60uk35pC\nFNGshy8jZBBeRsxVMChnJU5vhzot9A9yiGcEKBq7E+hhTVWCcWiyz0+VSOwfopTWWSYm+u1khW1D\ngeFDUDFBL4DR6HvCevWNIBxN08cmx8yVYa9qY1ohyL6fFURzbmDjkQmUsDeQIVlnmEIqb3UhlRXA\neKSFJvvqq5ydhUnzYmo/7IYLN+8U1s06hHL+RzKPBorUo38g9WakTq9MZBlIC0H6dSJxID1k+Vcb\ncQbSTKiEdBKol+Y5rKtvAOFoIkrATnWCsT/QQUlnNcmUtZZszltbTrNdXEjMWqucso8hX49ZM6OP\nKgd/dskJvxbkxVZDaygd9MjXt1oi8Z9PY52vEUybSjXM8cJ5PiaHcTANHWDQwkIAYeppo1woapFE\nvfIVEEwZxBXUWsOVUFqHMU7LMWRd4LMHriPVwaxXAUzMdxQVP8SWEvTVkEyt0eUgDYWqWP8nL3rf\njR1lcpUVdfgHky2jkChbQCVJ/BiVGf3rCor5g5ZUmgtJKe2hCGnPMlG9u5SUegqrnrMEHpq1lYxL\negIRUG0FKKNZCD02swpcPE6NMPxNo16bv7V/oMSh/aCGZE+g2virXDT+CUY65QlHOOehScA6Ru4M\nK5M3lrURhMsKSf7RQpV8negSsG4iBXelze43QIrYfRbxOvdeIXiHDFzce+iyAa/JAYUOqNNkYVQI\nBAKjEAplEAZlOATDQNJRbqUxcxGgQDAYDg3EItPhUL5XHhPAQWNGuZZSDhFCiCIiIiISiAQiQaQk\nSVKPDikWgNPqQu3/AKc3f+fscxEkISD6zdkcAWfuZ6VzydGsIUCIUrJm5sJzeIAHhI4YahLwu6k0\nO76Gwr/5ZoV/OstVkZVy9jnwyygn12WVf8TknPzSkCNnx+HJxMcZat2R01/FlTYnS2Y4GtOEabT3\nNqSZs8fkzKmNcn5UrJz9bKmcnEsxQzqJv6YLPVjTNfpoOgfoZ419Km6j5omJEIIqvMX3MKQtNH4h\nHapZTac6cAkWBYHtKB2WsCLQtxu9ZQkJJlu2jwjhbM05JwnnheDnKkE2BfYJMEwwi/8r6X0GZJpl\nc/VN4X3pQCu3zhS7h9NZyqdkNv3jrqsH0iTz9Zo/LPc1Zddt93XBicyi5VcpN9yRBZeUM48KentI\ngXqmh/FDSPydI/XrP9aRAPTvG/0/m/HDy6IvYnJ/WAwLzP4j3HXa2MvLcRwBv0rY/wnn7+v6W+mH\n+c58PFmOjvZdvXDIFrvkYL+tDxYFY+8BSGqPgptcrB58miezL2LkTw867fv+GQ6cXFSI1057WL8u\nC+on/u6Iy72n4quSz4VisorApYR33FhzjvBWalzz23s66O3ZqR8u2qy0YUsN4ZdUfw/ztO8IQ99p\nSi7R1eV5bus7ad9Zsu9Wvl0jOFzUU2IbR2d94P+s29LH2dTdbuRnjU4BzWJ25yswp6YtX/dW86Pj\nLpu5wxy1RwVyNxoa3oo472cOTAg3m9A4DJH/cujckxl9Y3YZT912DCI9Bhcu35Rwrk4+UdUed+fP\n6k7c2aEs6Ft4tHnLJz08ibSkWFxVjosqHbrCG/cRqGs3r5/8yIVsZT5nDE4Ilnc/5jgH+91H7/sE\nt2MauaNj746l2jYX588q74/JmFEP1R6mc4bX8gHiMwuaJzt88qXHded8QAi7i7D275814M8GhNct\nEX8rrIzhpZvD7vZ34tV4YuD3TwU8wPPjp8JI8bM69VNHfjHc+LPWnIZ7PB+FT/zPcaY/K0k92HW+\naSGMv4yvCzsU3qvAe/1IOaz7YOu9IS7Tg9CXgTD8rZSA/GeF/g484Fmt+W1/1lhPxvq/M+9jJfu2\nJRv1qJ0XETmqH4iRXpX+WUE22556u3i9Fmvx3DDmfAXelfjc8zC80/B4ARtARzHZxS8kn6VQAyy+\nxAjA3fBc9rNazke4uWCFdS1as+IgWh5yqxB73HD2NbSLaHHkrRZDkb78s6LOmv9z64L3xFm8h+8U\ns0Vw3yEkeC/Ua8+zX4iKmeFS0AP+z4oaVye/gFs/XlJTZPUXkULXflbqJ/a9WU170uPW1v9if+P2\nVxnsKwtvLRfvZ43d3LCOwbuz+uXh8JbkJvM2SvKzot8I4elwMm2f07lXFVtCfs5lmv/FEST3G8Zz\nHjezL+wVH1433I3UflZarhqW/LNS5rVrPmRGzGPesyWp1TMYwubXgeH/Ksdbh5k4+wDiScgHbbSG\nE27bn8pMPSTNw0yz87C8n+p6i+VyWvdxSNufQJ6jLaJNKRFe1wX4/GA/oXv4xmHWMCuDcHsCKgb3\n7Hvv8FwbwF/Q/5He8oj8yYt7b5GobxQdO1kg+7ghXUtYRmcty3+ay3Xn4SsS+6Xonw646/hB/kcI\nGV7R6b8+y3kr9XsPs8m49LMjtXjatMwLD//6WAPQoHNHgifJCro66HkQ0FqqUD1+ueOeFwPvanHr\nccgdt6Cn//JKTyfm2XfIPaL2JC3e8zBqPb7LVXx6dfrNTmP9OG9rXmjz5VZyNN+XSS7ajIRBxyDP\n5g9wvqnukU75dMTMSsIUM7zp2ousLXmQU7HONNKrPT6IZUZ3UJ5Ne8khyN3ctgsvcGP8Z/hW6/op\ndlyPOvqfRuXmtu1nPLgzNTSq9xMNwfo83+l85DFKWs3SU8+1yJZ5Q3WXS0uoR8gtCbNMAQMovy73\n+FgizBZgmmwQHGsspIPr07utbazNet9i4xBx9E5Grbo1yFHWZSN2WsdqvOyYw6c8/7ZlwHIyd3fD\nwoMklDxJUeVvR0LGYTwOsueuO7h85wQn3hbIWfYeljjeYnfntFNguN16B1/Myi8U+mKYkXpekVs9\nNLYyreJDVYbNFQ1XR9qNcquLyLk/tLyEoLgBd5jrHl4Qu7b0b2txp6T9auxFyQ0egLfFLbyhI2rZ\nF/FOnDLznVXS+pBkvGECJd9l6Wl0S9DIj3wjaeslW56Kxx/NPnGYfOPuV0VHyJLwB4l4WYiFT4Er\nJ0mODSn0sNHTBgGbk76I45wnxVS5VsSMWnlPhenrAObOkNecqdyqzh3E+yXLmdi4N0d9P2+nOaiD\nZt/0/0NyrSDOu5V29bKhRPd43QVhf5SIDVPNDXgXYjn39FYcfwK2/KfB2PRxC3bWQzJOD86ZnSWs\n1DB59czLhQx3kHz87/y/sh3ZN3aT8w6jXH9J0+UakF5X2LJpe349ar+pNUX6s0kwdZ1vvmgpsec3\ntiF112/kw4zUpVQ1x9enOmeZmzcTshcTPPnz95oADxpb32pw+1+9S/T1O79ycB9xHGZtmzHw16fl\nnQC4+yiDV5U/mrwfsIuD3SNoTgHBb/azQX9EuLs19LYcqSPE9CpBrQJ+cC/Zq1Huk/e9GbiDPNvL\nsErXPhvHyoNd0WxDBfawYafWBhO3Dv0Oe9DHsvBgneVHq+gWO3ysxBdc5GmQDsW6LxS5BpN6a8Dv\njBLSFa61VBO4UXR+JnHOjxA8Hdd5zhwD2LPD6u+6xDXQ+BAw+d4YPg0m1mm47J41b2Rpft4/Z+dy\nCtbCIC/GV4LfMlNhmsQaYFLi73bPiUbcLj+ZqazfG3Pny97AxWpeMsZK+N8e1zvt2Uh+Qfi+btzB\nyB5ocjxsIHzxPS0S6R5dB1bdj0Gb5UYKCxtxaHQT+BbjKjXeReRjAvAzGN+kXdqoP+kcaWgBnIQG\nofgptf4MzwwXzeFKGkM6e7cPTILwxAiNeX97mgEEeorUj5Z7Pn4jOIyeo2OwqaF/VVYfJNSA8ceQ\n6jeN+Y4s/Hyfea/2Rkn5686cg7h4V+iZ8XnykN0KCvu1d0fFphh3c6c1+/A5JeDX5KvPXJuxncTQ\nk82e0M9G9z8N3XF9sdre8QZ9nIEj+OZVcM5eseQFpsJlVGdP20LRt+BwK9s8jusRGqq3dyx+1AxD\nQvU5XLu+Z27rp5qn1/A6ZtrXwiyfcRiZ7E2ZYVtmjeAEUn5mwI6S9/2J2HaV0K90yFHl+kQMjDae\nDawbSbEPlbiF/VnkvERBPg3DItD8kuDYX68n4fOBRviWoVnPabkxsA9tZ2wxrsaLPlUjeAV86HsV\n5Eex+LqZw2fay2W/ZNG4aMYdJLdrkz8MqL+Y0MGX+Ezg82ih5Dsnh7xe+5UJR/eyS7FLL8XqhmSS\nhmfjHQhT7U8YFsRre4dup17vJLe43iwmPFkPlVeMuoGi3i5aBdE/px+p6n68IROBnluvanGD+3lp\nMjsPJYFRkdo9qGS8/9yLpLrrF19tL9DIAEL8ZE8cvtwGQ7MO1UwTn7ZBw1WR5tZIju2KABx7H03K\nkggQysSlIsAI0IasNR9A5+IEwEgBhM7GToUSda1EwtUBmSmwrJpJZYNp3QdwLj5G83Fqsjbozr3X\nocC7mandXSrrzonl59rgRvBSY9kYBadrgsng0DjuPx5iiA2ZQg5wwkH44WrPbeOBtiPSAvajFUhS\n9068wahsciR0RqnZWs7MEsFFSykoW8W/ClpHovIJ5YnvmUEkcAsndm0MPr2TU7HednsG5hV37YDw\n+pbkyw4eFroO6JcxNXd77kjYkJuEvfhg/Ao8X3FsAzU4V6Lw/gn8Q9lwuQT1AFMh+AcaOB5DhG3L\nuheSc4tOjECGfv8Y8OU0YGTLGQWubWUC7T/bdT2YpzI24kjg7E+Hg/kU+P/SJq6GKubxNqfkqxBs\n1S4B/TT0Jgr0mLE41TrXc2M8Lo3AuMgvgQXJdn2/fQz+aqSeyVgK9vJaR6YOQPpIywpNdeeGg2xF\nj2bvEUm4Ubn9Fc5cLUcV3RaaCzs6dF4C0qZG71sA1VKlTB3fOxxcJbjkfRwqvbQVcg==\n\t]]>\n\t<![CDATA[\n\tExEwThwRsCqbTqHoA0RmFw/9VU2wDg1yLBfEXd2ziaCwYAAL190P4NT4JcgxyCrfHAY0Gk0c6x5A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\n\t]]>\n\t<![CDATA[\n\t4w+Y1OuZHACNM6qZRn88zOgpFPFouEvjEDQCNqpBwWfK8ZsdnEKC1uFVU2BQcSivilGEcAoYXBcu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\n\t]]>\n\t<![CDATA[\n\t/t70qa01b+x6PtU1s3/JWutPSiuUtHV/nfeS1Svqk9AZlmEYCsuwLBtZI6vKspGVZSOrwkaW1j6y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\n\t]]>\n\t<![CDATA[\n\tzeNOm6aAGYLgBzJDEJwhCHofnLiZSFTUJukLcdIXEnYl/8Cwm2HnbVxI88gCue40TWFpmsLSR/h9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\n\t]]>\n\t<![CDATA[\n\tpCdCC4hxM/yGaTper9DQZdOk3WU1JNZolXxm27DZSrFaTGl+hcPkPdgiy8AdaZtFllgkv1EoFdo4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\n\t]]>\n\t<![CDATA[\n\tT1DtBFvGafcXY4aMeKiMLx1OJpQck3NR2PmKhehb79Ee8FcoK0rQRzH0BRCyNsh56D/XN2XLnafv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\n\t]]>\n\t<![CDATA[\n\tUlYzwPWxOAskQjPPZIAijJoYJwwU+Nkn7h2LqUjPJtbbcICoXmAmdU3tuTQpYkHTA28k1IiknBX9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\n\t]]>\n\t<![CDATA[\n\tZ03xbg1eUv44re76kcsRjSvAAmWCj6yHcEzKEVj0r6veSEWEq+2lr6SQFx5Qw6Gxp2ORyyUy9Csu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\n\t]]>\n\t<![CDATA[\n\tNIensfXL+iUlIA+PLB6Gs5MC0WqXMvxVc5MWBlBBsuFD55Bb9ur77pp1y37NxEoXsTRgSYaP2DPZ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\n\t]]>\n\t<![CDATA[\n\t1KUgdZ43jS6w7eqkU4aod4r0oiNlG7nnOMBE928P7ldwZBcnqlikgfLQ/SyEAEMZOYtoRUybyc5L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\n\t]]>\n\t<![CDATA[\n\t2uGBK9Zv29lDciDmMDHeL/ieRpSaHZqxA1FBWLnaj8MNz5ZgZFtiCZHmajXoB8+x6DTXQbCDeRW8\nnOqT0x4uU7KgpJxq+bGKIO5/LFw+VIxrduk2biWz3sd6fPWZVathLyL8Iwr+HkkJkZG6x3CrIwK9\nU0GpD/e2p6MxDt1Uczfxrx30b6j/lZZzpOYmZZkw0SCnCsNmCtlce9jjBeH2/y82B/WQhWcIMBm9\nZYzDQqm5CU3FgPZbpsG/MMlG/4ZWiUPe+Jr4l5r694iapAJP5l/fA/59Y1WnHbZ/Iv7lifoX2sAJ\nezUg9YkfZ9MiWNL0L1AW+5sfY4x/ke4kA32AXt+nrnkECX6hizupGiXB8WVTEv9eoX/pJOeTo0Kf\nZB8Wg3Bxcv1LtDJO+mhKKxHy+t/pEMK9gB7nPQuV74BmQhIHvLxjZPx7f4nq9C+jLuqNKW3gX4qj\n+vbSNArjhH+z4sufU/8eq9SBBL1QuQGm1GfYYP1Vxm7490mXIAJ6FZD+JdnfcdIldJ4Mbf1LkMNP\nBuDf8KS6XeHyfftkf10F/mVfFthAJWKwMeK3soOKizaTkLG0AtvSRMBwmZ5TGaCa+oDFVzDMZ8r1\n1NaPY1pdOXlqQX8DWDCCp3eCEtaPp7NfiB4ksLsYkczbPXZr4/QbTgp6Vk5kwOgS+jsu/zKf71fR\ncC4xZvZOgV5WvofhKwJToB7RHqbeGGqDtU1Z7WNRbBagOWhA0CN/+WGPZZBlHcG93a0CyOC8Bb8k\nkAOl/GTjohgkGIMfaHwIKuliUmMy0+aQlatBUnCp4pf50O1Vk01znlUXgk/HEMNc0DNqcWTVkN9O\ndFheiXVt9hz9X+DxGSK6qJqhhwKe0ohHqKOTbyrvaU4/2i7bE+dh4HbqlbVCr7JdiMNXjpLKyTeX\nNFrgSNzzh7NXaBDN8ohqYOAiLm2umfjUVZJDbzvgfG+vM3F3pkmXY6hKrYS+lpu9llE1pOFRrDEt\nHzEFiGyasLDDSJjFJ9+52Bx/3F588OWl5oAJfc2SEJDwb4405nwjSoHuGOXACn5CtWSvEJ6eE1nF\nJfLyN0mEG8UU1vYqB1qECvebC1KBHmvtKOcAh+Y2tCT7EmvR96M0cciAQ71VU9eJ8pCGYtSbfwvU\nS9wcspiH1EwpFdS7/LyvkXo9RiaJBncN8YF6oQFZdPd0Ro3uUK+t/Y/Lxi5VFPQ3pN7iK4mLId9s\ne2uOuXF5px9X4mTlHKhXpoWsj2C7t0T2ci1jWnGw4eTofL6uA2xcPEX0yWv8O7tSGK8p2LalADYo\nx3SS++N1uKJ8Oe/FEYKRtSfsyKgu66OfUKd/LXOjFtPv40ef/pkyvgy1kc+0fF4r6iCc9NgEzzSg\njoFIaOSVjCeW6bEigllhCxT1r/XCgthwGVAprzgD5GLkxj0x3muXCgjSrd1y5/lS/a8HeCLul5Bl\nxZoX0bqzs9BmpRgT5yMrchw+MOlMQvGdhDa3zI34il/InX+otgJ+xKWcXRRbN7FuFcSORjGV6SRv\nSqwUTN32VqMh+g7U6XCLcDuWig2+L09zhfCydxPh8yMG8vokYG7qDzErCMMRaeAHdTEvpGd0NL82\nOQlv6fZVUT3enBKLuBUMzoU7L4ezzTtEl6Q6Agmr9duAJrB+wbns4AMPBsE5fAGP4h7ir7lCxn8s\nPcu1buuWq3dC5lq9uVwKgyJsGr96lwOyMm2v3YamUxqWwVXwRas4pFiprXrPMH/WuXqPLn6pqvcL\nN1nR40QqhDQto3Ku54VlVy/zElrNVb24ZAWQMU2pekVCPZpevf2FhoX1i7rhImXVayv7vnqJP1MH\nV73fgrY/ELBe/GFVTscG\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M28 13H30V15H28z\"/><path d=\"M24.2 3.8H26.2V5.8H24.2z\" transform=\"rotate(-45.001 25.192 4.808)\"/><path d=\"M15 0H17V2H15z\"/><path d=\"M5.8 3.8H7.8V5.8H5.8z\" transform=\"rotate(-134.999 6.808 4.808)\"/><path d=\"M2 13H4V15H2zM20 13L17 13 17 10 15 10 15 13 12 13 12 15 15 15 15 18 17 18 17 15 20 15zM13 30H19V32H13zM11 26H21V28H11z\"/><path d=\"M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14 c0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14 C26,8.5,21.5,4,16,4z\"/></g></switch></svg>",
            "info": {},
            "path": "32/data-enrichment--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataEnrichmentAdd32",
          "filepath": "data-enrichment--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM20 13L17 13 17 10 15 10 15 13 12 13 12 15 15 15 15 18 17 18 17 15 20 15zM13 30H19V32H13zM11 26H21V28H11z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14 c0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14 C26,8.5,21.5,4,16,4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataEnrichmentAdd24",
          "filepath": "data-enrichment--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM20 13L17 13 17 10 15 10 15 13 12 13 12 15 15 15 15 18 17 18 17 15 20 15zM13 30H19V32H13zM11 26H21V28H11z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14 c0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14 C26,8.5,21.5,4,16,4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataEnrichmentAdd20",
          "filepath": "data-enrichment--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM20 13L17 13 17 10 15 10 15 13 12 13 12 15 15 15 15 18 17 18 17 15 20 15zM13 30H19V32H13zM11 26H21V28H11z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14 c0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14 C26,8.5,21.5,4,16,4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataEnrichmentAdd16",
          "filepath": "data-enrichment--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M28 13H30V15H28z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.2 3.8H26.2V5.8H24.2z",
                          "transform": "rotate(-45.001 25.192 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M15 0H17V2H15z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M5.8 3.8H7.8V5.8H5.8z",
                          "transform": "rotate(-134.999 6.808 4.808)"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M2 13H4V15H2zM20 13L17 13 17 10 15 10 15 13 12 13 12 15 15 15 15 18 17 18 17 15 20 15zM13 30H19V32H13zM11 26H21V28H11z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14 c0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14 C26,8.5,21.5,4,16,4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-enrichment--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataEnrichmentAdd",
        "global": "DataEnrichmentAdd",
        "filepath": "DataEnrichmentAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M28 13H30V15H28z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M24.2 3.8H26.2V5.8H24.2z",
                            "transform": "rotate(-45.001 25.192 4.808)"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M15 0H17V2H15z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M5.8 3.8H7.8V5.8H5.8z",
                            "transform": "rotate(-134.999 6.808 4.808)"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M2 13H4V15H2zM20 13L17 13 17 10 15 10 15 13 12 13 12 15 15 15 15 18 17 18 17 15 20 15zM13 30H19V32H13zM11 26H21V28H11z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M16,4C10.5,4,6,8.5,6,14c0,4.4,2,6.3,3.5,7.6c1,0.9,1.5,1.5,1.5,2.4h2c0-1.8-1.1-2.9-2.2-3.9C9.4,18.9,8,17.5,8,14 c0-4.4,3.6-8,8-8s8,3.6,8,8c0,3.5-1.4,4.9-2.8,6.1c-1.1,1-2.2,2-2.2,3.9h2c0-0.9,0.5-1.5,1.5-2.4C24,20.3,26,18.4,26,14 C26,8.5,21.5,4,16,4z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-player",
      "friendlyName": "Data player",
      "aliases": [
        "data",
        "player",
        "control"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-player.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,24v2H15.8164a2.983,2.983,0,0,0-5.6328,0H4V24H2v6H4V28h6.1836a2.983,2.983,0,0,0,5.6328,0H28v2h2V24Z\"/>\n  <polygon points=\"13 7.5 13 16.499 13 16.499 21 12 13 7.5\"/>\n  <path d=\"M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z\"/><path d=\"M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/data-player.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataPlayer32",
          "filepath": "data-player/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
                }
              }
            ],
            "name": "data-player",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataPlayer24",
          "filepath": "data-player/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
                }
              }
            ],
            "name": "data-player",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataPlayer20",
          "filepath": "data-player/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
                }
              }
            ],
            "name": "data-player",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataPlayer16",
          "filepath": "data-player/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
                }
              }
            ],
            "name": "data-player",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataPlayer",
        "global": "DataPlayer",
        "filepath": "DataPlayer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-quality-definition",
      "friendlyName": "Data quality definition",
      "aliases": [
        "data quality",
        "definition",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-quality-definition.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<polygon points=\"24.6,24.4 27.2,27 27.2,27 24.6,29.6 26,31 30,27 26,23 \t\t\"/>\n\t\t<polygon points=\"22.4,24.4 19.8,27 19.8,27 22.4,29.6 21,31 17,27 21,23 \t\t\"/>\n\t\t<circle cx=\"11\" cy=\"8\" r=\"1\"/>\n\t\t<circle cx=\"11\" cy=\"16\" r=\"1\"/>\n\t\t<circle cx=\"11\" cy=\"24\" r=\"1\"/>\n\t\t<path d=\"M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBY9JkE7vzFnQwqsNhQCm1AhxN98quMDxxL1wnE461trWYzkyK7e2dpirmsIOg/6HCzswMO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\n\t]]>\n\t<![CDATA[\n\tXCBBgwsTLODAwcGCAAwLNphAgQLDwACCBQoVFAEYF1io0FA5jwsoVJiwgQUJGHiQDEA4cHAYKQ8L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\n\t]]>\n\t<![CDATA[\n\tdybHgTcy6v0ye4+VQ8uBOYNooazzv8ET3yhV9v6P5mgtmu+HcjWKcoeG+SfWYN0kGl6vRrpmV/A6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\n\t]]>\n\t<![CDATA[\n\t1rGSsOxowzrWNoqUV3dElFqVnFCyRvHzKkms4c/LEm1uKwslsc0rRKuiyuaULfM10g7J9sGaZPo3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\n\t]]>\n\t<![CDATA[\n\teBWmcIlB5rP/5/l/Nz3ysA8Bt4UhugeXz3ky91Hen8OJuIyjqbiqYpyV6HMvA00ckED6ssV+946p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\n\t]]>\n\t<![CDATA[\n\t73fXbtUyXSBhCU0rkBP1VwoCg38rAxvycuIYTAaCWgHI4bAnLVmXT7aHqqo6pZI5ZEIqauwyrRYx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\n\t]]>\n\t<![CDATA[\n\tSsEQOkmXjxW96yhTNkzFU0x1C95ZvSC6tH+GeEmc5M9j74UT11C9oTh3QK7Z4Lbq7u5TXfUonn40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\n\t]]>\n\t<![CDATA[\n\to30mpZGV2F2WL6TDhgqwlCAk6e3wTTIBCp30zHhGKuVEH8kn2ACWyx5vbdA+ECKffZvojdOZ3jB7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\n\t]]>\n\t<![CDATA[\n\toT9WXNk/ujEBMgZojGsvAEL+ckOB+u9Xk/IvmirwL9Mz0+ZZplAUA2nApkXaGm2G0scVES2K4zJa\nr7987Y7lqJ/Be5IrbOeStXpOCZlKrKSw3/cAMIXYC32ybh8OEw3WYos6YuX7y7libjP/Nnicy1Oq\n0EeZkQ8Jqun8wEJ0UhJgJA3MC2giqvmdWI44RRCikcyi2sXoXQRIQowi+0M3kvz+aP1i4ANZ/G9+\nSUJFmQryb+1vaCLSZRgsKRrapuRkZpxlECcM+XVxRq/oMyy0uwVccxSZgv3BoQL0a+JT+ZujwXtJ\n5pcm4SfzUsxjjrKY22jRxlJEbqVoPkRwT5r2rOaSBKNUFTcCKyc5UR0hSRijATELuzclqCq3rjbW\nabFDkK841Sii9y9GiV0qpXDcwwQohVglNP2uHYiOLJTVXFSXA4slGxokUAoxAVl0t0VloaFwTHqF\nSqJZnKQZuACFrzq9HJ0AwWah1F2Dkw5mltUhXt1Ss9dEpNMwRZAiHogPg3g7FuLSymlYdo4TMVIj\nrqamah/MHNQmSiegDydkBMGkZxhRK0PQghENv2ekaIIwS4pN44gT3PokuhJFAjHq7GbRruTRmR/J\nvNgSzuulPjkhZ3G8mn5wVobSshqqHoSMkkz4dtlr8N7utHkrVGhsP3ev/HYLy7tvb+raAkGxDnS6\ne2ALNTaWStPwaHmQZdrC2h0sF6AjCWg1M6W+QA8FGnegU4R4UtCy9IC9RxcsbY9pXqF/kycQHWmU\nEDsiWhmPbDbFg84eI2IRtj4SlTsRSZCitmiZMQ54ts58sWnvb+h/fhbAZGwTljB63Bo+UA1zOTHG\nzbgP1KbPhKqGoRX7v1+3xGz6CHd+ZOzA8+2Xz4WDBUUFs77AygoycF/T1prFTsALCicxVm5SZZc7\nNxNm0BKHQmZTOm2wX5p8kErDBwvEdeL/dM2/GN4SgkxXgwcEKNZyvUyQRvnF3CU6Zas/QK169h+J\ndttql1jnrwJgIrfziRB3kRB8m+FTLkYellZoIPIsb2cMEaWhtga0wi37/4N/xWXDAgud/yevlQYZ\nPirjmiILeAHi4wwe2gVfOUXwqmpCJ8dZcMT//h86kvBhZTSiODIuXHJtab+lztT1coIVyuep1mFI\n8p9VLkyKQVZnA+8yrCRNRS5yaVXFvq9qU0M2pAxqq88mPsoWlT9T/+ZhYeZrTlNKOUeb0w2nxDo2\ndcuMgC7VbZBEqf4tQTpoGEjVDRAn0qj2ExV93HmMhrERtK+EglDX5p3qeBd8d5B2b/+X36+ICPOa\nUSkxd1wokfsKo2puEFL1G+QHyWaqMB+oEwZTEvdACXOXEs0DIckDITy4voPKugOOR1JxKfDDFCtX\neGmKHnsp4jlojbh5sRxkmhx8dBzUuOlsxSCwVEia3rTUjzT1SDA4UKD777beQ4A1/Jy7LneF5Zf4\nC9pA2bljPxzoqHwFSOSP8kqII4NKAHgDwApC2SEkRZCO6b5S3z7kbUYgTQFqMXzRZxz8Qnv9rWG/\nlOp9IML0SPaJXrHnq72kQEtoND+Czm151kR2LXl6G2nfdcdb+shAZqK4AmIR05cQCCbZqfKe7/P6\n2EJ91WQMRPshKsjKJZmS+0NkWeYw81Vz+Ih63YCmm2tbtEqlaEFVXiL6B0vzzNbfi/3Nc7jt/ozg\nPzzHXwJnNz1B0DtLcSx0KCta5ZKZxZseJlwpsmS2iElONwP9fHU6kXEEslO9LFa4ef43yjQ9BFpw\nb3FdlT/EoI6TPKdqLyrdpilKVV+jRWYTnUW9mCZCcNCDiC9g9fklhCB1nIyaII9zeiFIqhAFE+K7\nYNFuem8hiCoPJIgAeJuYIdYOkYC2mrfgb1lcRxFsVcRuItKQiKmeUdRfbUV4Nu8hsMCAGlFcFimU\nOyQjvtRwkakvp4WEJCheQE26NMKjiRdj6bUR5y5nbjNvlRTPxcGmwxGLEWyEvp2lpbPuyn7C9YOB\n0JF8gH7NQh8EU/Jv1Q/NPnyfeM0tC1Qr+ug1y9LTKKbcmnIy5Qxdfow3V/ZS6JmAE7CrRPp4P52p\n/ba/6BcukJ2qgmNft5aznevMqzvBi1TXn2yQrzrievn0wAx8dAmRXB9YGIipQv9P2KMX9rzHsP4H\njBYakrbCsRJtmYCG7VFf8/U1LEYBwPqnTRovYKlU2wC4C1XQzEaE2Ug0DjGcgYdJ9988KmAA1AKa\nFDBowqq7uo17dq9IFSAC4TlbAEY4SgB9Cd0flGxen+FtvS13n12O0JcjLMxZKXMG6Ro1HjfOByOD\nR+R8kejwkDGEh0Nn23NSVBaDVrMjGscilla3s5Pz/X6OYoLZoXsyDP7KqwuLWTtEgM+OYdhOaJxW\nNeQRp+x5yi4EQLTJBDewEapFUtdXttmSKrY3Vw7e3YrNtNFI3xNFtx9pBmP51LZPJ1lBj3SQamTE\nlQBiVm0fomNtLGJ5VaSHLdG9JlBvFhnrxqN8vIBJM7QHJrl+icO9ZJdAQMXDplu3E4vYfaTsvFSv\nPb4Ii4M7jWi2832gUqIImOFuRJRPwCduJTZWivF2mjwxtFKXKYwLY2fT0cwr/1jUbc+X9jVoMMUs\nuS8HvdUm1xnE61SAgkAtxxdc4+Dr1+k3DLyo5UbZcGe/H5M9Mm/B8OILw8Q0WkdAxFuoZbXdheV6\nsxpLQLsvFFl8eN+OgEoFNnYc/IzDOZ/yIqtKzkoRNfv2vd1AZOVXLPju7XxPLBJQZqFTTEnxsZki\nuWblr5r9m2Z56SJtfcRo1p5n9mQzy3GZrSOZaXzMqqaY3Qj7w6wTzFh/GUIvo9tlxFzmVd92LWPO\nsuNYFnRlY1YmSwoUlQHnCYd32AGUDjcLxJ+mGqxK+ORDVLQn53oX6fUH0gjGo7g0UloESRxs6u/m\n51t2nlRxeUyxloi0fKrDCyI6puqx55Wzkj0WscJ+x2uWhVUi0YoH7W3LlRcIWB5BiVGuuk7WymQc\ny5lZY1RWtVsTbe9Gbh15UGOiRweSpJgjJyZxUmBSlM3EwHR8dSuifh6OwUQPlbw/LTpUo2y0VbcN\nAEeESr9uW7PR4GxIvCZGIQBsAalcgG0p+RyRbYiAILmPqVa5x+WKEHFBywQ2lg/hijNhqySxnG77\n4cuhpHI1eCEaExlSBLyVNC2gPhh3AvCSH7DsGzQ2EbbYDvkDwd9qduuO8dX86Gyu9X9H0Olt7k/H\nfYKUwxyfg6kxjM1vAaz4vUCm9zEoRXaQZESFyt9brvkyAws7oISLBIIGhuihId3huGzLoDri6vJh\njStcR8Fu0sqoko1t9ig8u91zZmeyNsTe9ijcVccdE05cdblBJI/sx9/dyfbrTfdzbo38w5iMezi4\nq2bMNT+F6ChJLAiL8B6CLQcB2X3pSUHUVKAG8jQwchpG0yEYJmIEIYC0U3Q0H6PJ+cNcKifvLZ8P\ncBEZWNMF7HybhuFpsWvDi1zCDpABAqvI27bFMUXw9/fmulOAm2TmTrXQcUqJOtW1BfH50yw8jDJo\nlIWjuL2j0JIU2yVFnlKGGIEKXgFg1L3MVvSQAe6fjNXNRTn1HACJLsyGCzVotG0SiKUF4k8YCGSl\nzsLucAbfzejWjHNmpGLG/mVIWkb5yriUEToZo5Ihk+C0xQKpoLxeM/arKWmUdtgeaQNf7DGisEfa\n6VHllTZbdMQT0ACCKnNQuq/yg+GW3iEdhHc6No1YcChSdDdjd69h8WiAo8rvYpDFoek28xKYUhB/\nrYYLywXErH1pkZiH46h7X1gcQmq9F1XkGHUOKCYqhnueuin/ywvv7Jcujs9cxX5CPuatXvfQbiN1\nhMMk0J8DyNQAR4qnfGAJc1+eTELbywjoHJ7Mj8WSAVmDMCcuiMyySPCJ092PwqsbZwyZaYG9guu1\nkOu+dZjMJORvheo4SgdtIpf/GzZY6jnG4sDJQfL3TtkrsxB2MbRIabFQ3A7OGbTvQ/aGnHwNHosE\ngO0nBEBFYpl5zxYwwlj1ZQYnDVpYKdBa8OclzHosbJkgDn8qHj5EZ6LNSDYhHZtSE8ekUSeo1w0L\noxgyk0RVzlqxiu6HWQDAlptzT+l6hTNpUOKWsxALVcMf3WDOwWexbQUDV6V/Q/SbtvjNbc58jXNf\n74XnPVC8seOWTudZBqpNuhHfufuSe5a7mQc3wmN/ZX9teG0VHGqDKmk3+9lrhVL9ZVdUZdMjG5Ae\nuy/E3gFPM0wqEPhRkZsdsUIg8otvt+XL108jO03PjhJy4P8PEDL3QI6TRYqlqJEiDPT4D/KPFCKe\nvwQd5RWiR8G3ogJIKo3oM0yC9kqzb8brlonWiZB1qBlDgoDSgfOLoY/ojxwnDksSRde8mGopJ9ew\nhwr2fv2aqV6b2oUXVhCOSG8L51OrlyCCYs3YipHWPQZa/4PZd6rOUryGUNgtp3bzxo6bOj4KRLal\nAVTCyqsM3gAO2Df0lQSGEFsHfFbJGwlX2Rcxf826Y31shciXHlDSJxh/U9aOrlx+kL8ZupfNYyUc\n2JnH56Lii9MF/wIuCO5MJ3vZf09oVbRaM9B9WRaiD5Qd9UETOy1pTHLowBu0fhSpw3SbGk+prZdR\n+hnf2x1+hKNausRxxagS4z7yZeSWckKFh68saL4QeX8cucj0/3H00HOgYcciOLM8CGZEQ6KdnhRD\nV5roU2JemhUGejQbrqaV64pX+Kpxh/VYmYJDTR0+Db8J79XkEdttO+WmyzkdjKW7GY0+iMTnfLqJ\nzQeEMHHMU4B0OmLTLhysIdOShWnsLZ2ktAoLT7uZdIAirQ6MzZ3LmvkBsQVtZencyaibyL9YFDv5\n2Jl9YXTC//aisiraU14TfX2MysljuBRdZfTm24JE7sxEa0sm8okgp1GsKWLnaF2QYlSdNltSZepa\nHBSKr+r2f1ruKaybacSlExabBC0mcjxpUYUFspq+vI/Fjup70QQRnqQQeDcgTdh6FMkAPxK7LoZQ\nUYjz50eUHuznNw9hUz9750CniQBoJSzkqHAgBOIBkzF0f4RmD7DBaSLIDy9CAlrz0B0BDrQ/mhuG\nwUjy+2igGCH1P+iH+cm/+ax3D2ZXwnoZ0jHUeRBj1zCG06SFspKwjHkQZXNZZxH1zI0vOaN4g/Dd\n7xUr7eDSb6IQ5BPRiKW8A2rbTTHUH8RJYFVniA2FEaxqf5RK5QgWhvUxq1vN71fxjNunX0QaB+xH\nC8XjU4tbb7ktksBZxQsTJ+OPMisIa3eZuxEujI1Dey5UgRIONElnQgg0l5bK2yQTSCLWMHpcwW5R\n0l6CV0t2BVG3rxNbA06qRYRd1mkCghKhOSyEMwiHjZqh02WJpyFOCrm8IpcUMf2RcR8J6JIYApon\nrT+e1gcle8gnjzu9o586dM0B/IFKCgi2F1D8njsmUFDKQrFJAvkXGm2wMIggm8iIONxRbZUy8Xm6\n7gMJv43rXPPTEwomgekObpzuuJlAFFO+19eO4YdRnOyKQEUCLN4+XJvegNkHl/Agmg==\n\t]]>\n\t<![CDATA[\n\tOqgxB3h8g6geBeBnRDglg50JJliBZRV8NnCbgHX2/yXVFOzxozoJlWI681ltBTtxNB6h1tMBFFS5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\n\t]]>\n\t<![CDATA[\n\tFxGRlvRGossIpSVk460h1k4Vbt1ybk2HGtvieAaVKchYNeHoV9VeE+WFjh2FriempFRFLlPFVAl2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\n\t]]>\n\t<![CDATA[\n\tdLcZcRhb/GJfmyLmHtliq31OaWVabgbYSe8XR7GQX5Soq0gQXL9oBo/86MFNIMkcZtgTcn+seQq8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\n\t]]>\n\t<![CDATA[\n\tr3OcUV4u4cFVeM9Of6CNjKv/BFju6N/NKTNjLnF0irIsi8ZHio5AvSZ6UrKPm56viJU2Iwtv7tCp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\n\t]]>\n\t<![CDATA[\n\tyJPlYVinHhkRw+fpodLE6Co9/FaMitHD8mIUgx6SzhidnocJxyjBefjyGC2ah5tARv/y8CkyKlYe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\n\t]]>\n\t<![CDATA[\n\tMGsQsJ4Py4IQoGucIgj18RorA6GtrzEgEPqBjeUAoSbDxrlFRL3kGkCHLE/1scnoDxDxMt76wQ+z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\n\t]]>\n\t<![CDATA[\n\t5CG34XupoA1/XA9eaB1R/9zCt3jLgIXDsIOEvxSEIgg7BtAnqQ0+w2Q+c5I4ygh+oOaoOCqIQAR+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\n\t]]>\n\t<![CDATA[\n\taFja20/TlNm0dwYS9Vsm7a0SmMpLNkQppL3Hc5K8U7pp71sj20tKwsfDtDe1vjwmm/YOMz+xDdgF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\n\t]]>\n\t<![CDATA[\n\tdXAFmcM3GpJre+djaMrDIrwCBr9M69o7aFO14sFq7F6rjE/l6GwF+rBtg1s1rbugtwpkSPQOrgkO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\n\t]]>\n\t<![CDATA[\n\tj91sccuyP7bqA9Iu9wgCZviPHZMINBLj8WNjo7DmFCY9jspDPZTIaLcKlhF7GV+7mcU+1Tp+SBwL\neyDENYnAwBZbqyicpnEqW+wIk1bBMyEf6VJHix1CLjvllBohG4OOEPYHFSlmrLDFdiRMnztJcrNb\nbJXI+PRqLfaWqW+eqIi8JPZ7Fbf4dRL7N/BD5bJhKzWwEj6FG/Z0DoxcuWH3uIy5QbOTBG7YlQ/1\nE2vYLpiN54xrDZsjO4wWYQGbV8PubAKdXA27kvscZrOYuCiCw40gksP0tMHRsIlHVHMNGw8+Grai\na9CnB2mEXTp3SOCiJ3ISdvXmwzLfptGyn0mN5oPiJ1TB6w/t7ItnLEc0u5Gq5DDCbmPlnEcs5KuL\nsNcR9PV9R9h7Qn6tQiTscmHA+7+iCxkJts0XHTAJA+X7I8E2FNrb/F6eBFsowoy3z5R4Z0gk2Nlb\nB3YOYB8T7N2nSRamhE1cbtjXJTaa3EzdxWbMewEs00BElXmBbB1LPlTaaH5SAWQ7qeQVlLi6KIJs\n/v8Nz7c6gHOQvc2tUGMLsp1Ms3cFJXu7sGlTNrEY6z9atvFIx3DMLsDUPsM1ezcNM0tnZ/ItTNVn\nf4OncIc2UiUeZki7AV88hUy7oXZwoDnhy7QX3onXYJBDOgqZNli6faxEbbJUGsNdtbUbsFp7tiZI\ntofaOalpbQ4x2FlA1a4j4YaL7d5ulqmc7Sr9ehyoYKTE8GzLVevloUlBIZ9tU5jpY0tFGEeOZ7sI\ngRxKxUh7tiW+MJ+F2DA526qFjBwSvFrGYjuWPIMilyq2LzKCoXaeznb4JAH6HqoEdraPBX7eReg2\nI8rZHne5kOkK5GxTIOaDOoOwIZ+zfQ5GnmsAAkNNznbI5QUTUK9tosTp+6Dl2mbZvFshw5yhL55t\nshjofwukB20vSrjtV+SgLc9EoW2tXTNc/9xW+zGABNB29+KhRs2hyjwftG3QoGelSpL49KHtCPMy\noNexZIe2t2ikbn1ou43xvDvK+BnanhoJGT9K608BtG1rG/dd5JOKI9vDmWYyIiUE+rGNmFOpfl5K\njpRsMxLbNd5aDvVkO313eCpOoZS73QrXkb+/sh0roNLr+PfGVdgF26ks7cvxg+0/hlBxVuDAYFsN\ncguncm8U42Ab8pzJwAphPNh+hEfQ5Tj6e7DN1JDhOYoCdbCtW2pzI9SweQfsV3YhOgehqpNtTYCy\nOjjEW4ls36JtuJN4aAXEFW0rKOfh8tC249JkMIFzbVtH5Z3rMf0LCqptJ4GSVVbV3OayFau2/eIE\nSRi3N78j2O3h3OrtGajm1h0PqcYc3GpEaaTubagKxTIYt+8R9WjI7bXwcip3gu0iPRlbil1kSNwO\neW673mcyut0ySW776Y4G62ZSyRbDbuhfKlXtZvILmQdwxadlKH6Ofk5FAxfebA7Nw/HWcXl7LcQK\n6P0nMMdJvY9vbpCyd+AnZLs3XF2BPTkL/M8DpNcPzfcpCiEwo3+ATuvb8n0vtc8gHP1uwag3Nv5+\n2HtkAOcE7QM4jsuAW1TggW073HjgPvb5bHyCjy948nDGK7zza7DDNjhtbwqqAWt6OKCZn3q74/4J\n90Ruzivgdt5i4amC4RtWn07Dtfh0Vjm8bYUbvIfL+R9HFRnEl305jUJkYGNUkDiPRnwwcXVXaAcU\nj3vqAn3iUURfxyn+Vurl64qngVBVcnUtdfdqZIBxp8mgZJzIXZbGB5trt/ERl5QB8kCv0XC141zg\nhyxhPEayIPrjmvf8IB80V0iIfGDNyF0VydGDnPqO/xzA8a9Vcg563V8z9XKeHGuFc5QDRiIOqFxV\naGrj9+2qkpXHV5qtWA48ZJKUT/Ye/9ZyC6Uuz6r85bgQcw/p/J1y2y/ZJ0RaMz95jObf/QcqlNqA\ngNr8Eufa6s1fY6rnjGiV1d5mk5TNNyFv07KBruG5hXp+TvEtjPO548+9y9hhCQr0Vg/6x+TJ0Avl\nkE1F9IrCjiy5oidIo7vFsQXaow8B9Ygb6ZqygScdCVKmMGLpcZg+rrAfavqVAboO4vR1qV/nPH0u\nqAs4jnQVdRMk6MbAu/RgqPzXk3raxEYgnHot1VfQvIirTsS7BtCqq6jK0utW/7iB9cST9a0GU1xa\nz95BJWldNnpzdW7ryk2uPzQMx4Lv7fqor4AY7HXDPfC/DrxoQ9jjro6IHTsllVxjR6M8C0f2rPKD\nsOy+nKg4NjvwXNHqas9WodZh9qJ6iY2o3dzPxLX2vv1K3mN7JnEXWZRt74duT1veu9n92zuBbq1y\nw/2rI2aq1v6xnoHMHeFsYXItuktodS+IMtLuwJu7iXPu17tDzNqb8T6wYJH2eQfAgSh1xN4Z0diN\nn3bNlSUP370kG9eo78gZ1p3fEf6drcfBUAH/9iwSjL0nBR14LYtfF/yZXWtfED4nbxzP37mvLYU3\nIPFdht/vp2zt8ImtyE+J+GNrYuYDBDBUXtKKv+eLpwgU+qPxYc9MxvE13dYuVrPr8RbQFT4j5B9c\nAblu5I+PHQPPL3bvybdO+VRCSF4sf/f7Ne/yrsfRJOaJCvBmM49zo9cQW/Pum4eo54oJOl98oTqQ\n54l/JUp+XqgX9L+iDSpk9di66PX46K1eBP5F6aOYvkwfqNbpi1eKYEN9IvboTpv6Qas+VOJpx3FA\nuoUNadZ/ySdAvownUm1yVRlE15WXjDDUlAZ1UFNxU7dezzq7r+kapK/C2O8vlnB3vqec/BoK/Mqt\n75Yb4r2Y7GV9tE3tc6mslwWEWVmf0rLV2HLrM/RdL2rWDRUActfXH9pzmsu+6zurNLZT73rVXNca\nd9fvwXJkxX/XDxWJsncaXr8qsGUQRp2iVyQNQin4zrtRvL7wstIjP4yL4vXuAnuEAsj6VuzhyH69\nP+6G1L60kCq3NDRr3/7Z9uvfXjnO5JQh99976B5Ez+6PEO+xBI/I9Z7Ow5zqe7PuT3b6+9wZvLw2\n8ItqLPLg12r4S6VFFMvw3eYMzCK+4E+GZVyu+GeX4E/hQePb7fH1rRixsJEvr09+l8Dzj+VjTcWp\nmG9bJTxbcnPNz+5nF50/GJwCIu3zCUKG/kaTK3/0Y6z/1pn+DR3beER9aXRUrLrqhzXGQ9P6W9hG\n+7Ps0uvrfeg1aW+NfftJfcvOfjgWfc977ffsnB2A+9QUs5Duy3SIpkreX/NL0/s+UFnmJ/gTQ8c0\n/NFT+PEPjNPib2RfZX78BNHGS0f5k62Baoj5zYO07zAKhfNvAUgYBf0/I6UxSv+c+t9CGhg2rj9S\n0Y5V2T+5/T49hFzc/e+LGg/8v5AzQpzchz5l3Mbe5K9Fc/62Sn9PfgTW1l+wMbmehJ+bLsrvP3Ak\nxEog/+Md/f9bs2IAqf2POb0A8d91Fu3HVjeb/i9o+r+lGdjOpANkB2zABD7/yH8iPxAQgu05AAAA\nAADgXnDvA5T+PQFEO8v2b7r+/6/8rJ2fp9/f/fl55efpt5QpJSlF9mcFUs5+XmBlsbfN3pZbpGYh\nLSMWI0KNgH2KxKEdAcdl/YAGZTeaDOwptKuQQ/NjyaDUW5tzAue8DnfuvumD+zZ6b/UMndqM3Bkd\n41Y20+ih1TZ8bB7n7+0DJerZRJN8W5tAts5nrxCc7gphI6jmp0gcfiZP7y0jdzbzTmdhxmoaZqym\nORgIML6hwoeYOHvG0iGuQXA5od0QpVR2MGOyNlBq2Jk+vb+pk9CuauHos3qI+5Qqolfa7H6oUcMf\nVYpIk4dWX9l89gbQrQcx7hFB/tkxb2M0jFmdlZkrm4Mc+foBFIs1UaZfn6lry8bI2Vpei/DiHyxo\n4F4TOHDaw4dr2xfL+cLVPIx1sw1gGx1Dt9XaCLrJOIRuNYxZneVhIb44WBjYlW2WafjOfI4Xzk+l\nKvoMSkZnCV/fU7hX0/ipzTJ1ZrON3ltt08fmfQzv7CJKG+dP7uP8zdU73ryuQIWj53DFdO4xzOtF\nlYHdKsckvWUllM6AJVS2ohHpgRrzPo/iXJSJsJLm1xsoNewHRiT+qVTDuwnUS2OXVtv8rf0iyr7t\nT6LdLSNHNsvYkdU6g3M2D5juPnoUJHvi/JIlTXZtIcW+u8ebdyNVBt5DjoC/57AuBm+rhUHTfl3j\n7LCiTEAahJLRvyFJaH0kKWjrBNr9HsI7W+dL12n00GoZOjQZqJGPNqAa9lg+LmkJQTTnqRGGH4gx\nr+t06Z5GwzbWjctaAYvH+qhykMdw7sbxi/M63bkPpMjnnTrDdgIVizZ6cEORfHaUqOE9VXp4x3kh\nRz67iTNsH0hNvBGoNn4DpmEvBNnndbx0fYeL93ME5/6NX9uv0WOrd8J0jno2z/fO66n1hO1un8M7\n+4cQ4zfYFw1fGs002vVOneB7Zu6sw5DNWRi7azlYVxgH4eGLa73CgBL3foUin7MF1tGsVhFOeau1\nVKZAhJNm+uRujywFbQYzGH+FI5s1lYnEr8TJZfok9D6HdzZN3hktczdG74TjPlKl4NaJk3ArpNh3\nz+Sd0de2bTZGbjvT7KXRMnVlWTgbWwPYNu8U2s3XN6/lNFcXjFoWbIYvTduzaFcTif92EudqIvFf\nD5Lc6zd/cH0mjq3vfOfso0vAG8oUfCNAgWhf6RDXW1VEZxBPSr2EHptzzmCcn+kro5U4uV+Bi0Wf\nIEVjdwBD0keZFt6GeV/Ikc82khyESg3bS5/hWgGMR1rLyOaclSRTTgBjsTOFcm0hybyPpBn4G7yY\nrCkQ6aQlDMmkE4xo/FQkEr8BVPAHatQLavTrQpJ5/0CJ8H1VQORn+uTeNoFqnqYvjRaKvNsqaXbt\nKNDC7ZGkoM3Dxfs3fHCfBq+tvgGMq3O4bz9nMI7bYWH8FgtB1MkXwklqvVRp6IEM+Wbk2LqOF27r\ng1hn2/y19Rk7tDmHG9fAxmN/MENcL3EaKDXsS5vef2TJ7T6Fd1uuHNDinoIVjF+BCkevxMnF+ZP7\nOtw5D7b7PuG9T+QImKTJ/U6f4QQtGHtUCcOupNn9c+s5Xbnuc5jXgxz1Hv/sna+cfSP4VuMEwnUc\nQLmOM/j2t19iV7ae1QnHdSFLPM8JuIT5HXLk21KNWPQNXjR+pk3wd/pE7BJ8gGo7tIr2BSwgu4/h\n3QdqzLOaMdmHHv0+DiDc1+HWeaBFPRsoUc8OesSzgRTzrGI4EkkC+pq+tB4zt51n/MrknC9cbRPo\nRtPwsclBjX39aTRsO41+7RywHH1tk7NXti6mUzg3O6V6e5UNx3qqRGI/gCKxHzCh6A+YULzKcUlz\nsYp2MSeoNgcmoP4pFHw7fRb+qhePHUKMys7U+U3S5H4KQTZrDEY+66wfl7UDF5G/SNLvvul7+zxg\nutvJk3A7VSLcE76zIxjR1HIhoKrlwAVVrpDEU54akfiFJPl8C0c/YcjmrCFJaG1hyee8YMWjbwIF\nfyDGvE+zp1bT8J3ROYRwdZSp4d/A+um3lnD+plDuPaNnVsvgkc1DlHyfabTroU4L/w==\n\t]]>\n\t<![CDATA[\n\t0qb35/zR/R0u3i+KBLx/EvP+jiGcTF0ZzWUwsKubLMZk2u0bDFDNZv3glJUyvd+IMvDb8Ln1a9pW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\n\t]]>\n\t<![CDATA[\n\tO0hRz/YJ591BiX02kWSfXfQoaBtRAt46Xbp+E/jWew7rbCFIvn+E6XcPQfLZOl66ruOVs4nEezYR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\n\t]]>\n\t<![CDATA[\n\tiyxqlEa+jBlCyeIHrVihD7EMoM5EnQLnSbnEK7rYhFH0s1Uv0wUWNcweWc4ojXTZahaARc1z00lf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\n\t]]>\n\t<![CDATA[\n\tA+sprYF1dNZQpVSOMOSSbkBjkpYqYdgRqEj8VjQiPQIVCU4o2hJ4bM5fTVA/hyWiPUPrZw0iSyrN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\n\t]]>\n\t<![CDATA[\n\t5y2sjsoeqKDSVSooa6DEPW+HNtfswdGnhf8HUc9f07ZZmLKO5XY2C1NGY7kt9sVDWOjArxhk8a+t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\n\t]]>\n\t<![CDATA[\n\tgAi2sQFf9FgLCAVjFhxqTtBV4HReC/iGBEwcgQ8Rn+E3OzJC3MKVAx1LPC8DJhizWEQ0ZQ5XUGWs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\n\t]]>\n\t<![CDATA[\n\tR838cCO+w4N4DrfhNjJcJobH1PAaTnPlMTO8hsfwGc75Db/hOrznasQjMGhw/VPbEkJhyBVhnKND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\n\t]]>\n\t<![CDATA[\n\t1msuouuLb6jw4cpmyxBwUHYQWkrIW6ykshWNya6gRWOXMnHIyfVUJw4/1GlhkOKfX7IkYgS8Y9a2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\n\t]]>\n\t<![CDATA[\n\teqlINHatIJ3yhi2nshYTTnmqRCINXxrNuxaMa0WImNlb0xpp+n2lz0EPtLjXcwjj6hzCufmGK5f1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\n\t]]>\n\t<![CDATA[\n\tZf187wFxccAlyuODxKxNlruLgOdxRMAKFDrFpA/AmV2q469KwTpk87Gkqbd/yyiBwmIBlq53P5BT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\n\t]]>\n\t<![CDATA[\n\tSkVGDZgSuEJTrEA5B/RHY9XE3UmD2RyuIFhnnczSGItaRCZJsxgji75GKi7a6sbt/loMnT5HETlT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\n\t]]>\n\t<![CDATA[\n\tqxqjjuVMbwtlZZnOfV1vK5MWW0p9PiYr1fP3pk9trXlj1/Oprpl9TNZaf1JqqaSt++u8mKxeVR+E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\n\t]]>\n\t<![CDATA[\n\tSmkjIMNt9Liw206f6gSCsxvFbhRBsBvFEARPMwTBxzv/vnMD0VRcDsEDXMiRCUrytHkcauMUMEMQ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\n\t]]>\n\t<![CDATA[\n\tadOSAjSjPEFZc9z527HqeyALqUAaR+VC1U5jotQrFvCBD1Cgkd/CrbHB+MIEBeiIJWW+IWsvuaos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\n\t]]>\n\t<![CDATA[\n\t4vImnrNOX9VgvCIvzW8wIm3cdItcskghWzbA/WD94U4hbmAwME9HI25hWJLD7OQ70m3IKk7EZ3ho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\n\t]]>\n\t<![CDATA[\n\tOEvTuOoEoaAHv11OEvsFUVwGJVB60SOmgWQhqctP97C7xr7MR+6ftd5vFf5EGWrFRHT8weZxXrUA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\n\t]]>\n\t<![CDATA[\n\tFgfYl/gmK3CNjGiKKSv2hNLhTLNvZFzvackCtJ3UabpKR04S72l6AoE9XxDs+bwiakg9CgBgB5Ai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\n\t]]>\n\t<![CDATA[\n\t44ca3D2MBpqQVDOV/wc/pgTqYFiyvxT7sMM1eG5lWuEp5A+fd12CnX9Syq9FkbdTEX7GRFAJhVqs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\n\t]]>\n\t<![CDATA[\n\tS+AXcEsHkqhGHn7bmCWBybi2utaS5ndp0f1SpQ7uTIW/XP1MCD/VWZP9IDLzR7g9Z41Onj5wmtx8\nSZ7D53jWtQ3GXfDSFcRxaBPWUhaVrGUBPSiv5yGd7DEna0agEEnoVCXBEtSU41IjRLqqXJVXRCmM\n9Ohz1CtGv4bIX5E9YMe/lnZ0YBGhuXT7nqwgoxSA7mdfaa7MsKeEgB0pHNGhqapssQF+gQlenKfb\nFI+mdVbqECzWmOo8+TYhiwTdguqtXHWgxO0Y2OJKUHRvyGqEI0LfhjA/eAHalwdOMvBhmcElcQPe\nA51wHwCqn1EAB6VnD4shOhS6rEmjhYLyhBNGKCkljmsoFyx2q0pSukunmR6bK1xcxxfVT+EX60+f\nCZ6mD5hnZ3hJS2RxgDqLB+jTKNf/FafaeLB4VKKJt9D/h1xiaFTnljyxT4XqFsZEkL2JTSSDPzco\n1qOl41LIURZZxAXn+Ja837CQNWGC/Y1ft8SF+T4XnsXj21TNt18OvDG+6Xq+mSjka3xTw/nmGZJe\nz+CP7ziab+WGqzK+hfx8a+KG+H7yXLn5HkQhteObF843q821x/cWm2/aXDqp8U1K55uJjei6Qyjz\nXTk1nvmOO763zHxPUynCF8UposAJzfpA16KKru10teFk26ncBPu5MRf39oHHS3PABKrv2S/If0dA\nNnVN+yE1of5TY02GqqJOBacs5tGNQZWFQkrGM8WCUZufKMj0deUsFcJWCW8YCknLBMulsHKC9RQe\nIT4bJWxR47Ajx6vWyqGO6R4yuZ94xVTu+OBIUMmUQY+JQc0qBmCZj+ar9R54XIG/0hlgCA6yWWST\nMkv0AwBGR6lV4ACqbVI1tH/N9cfcjUzRKULQZNxK1qnAy2Ey2RDRJlGFqTKu8iNiiD7YdvPP2HOa\nuM0YWTfIqqwOKWxUoXKndrTO5e85ULDQcD2sG9EZtZwjPloNFTU9Aiiu/vSvXgM15IM3R6G8IjGk\nsp04V9+vBMxxYr5BbC6Ua9d4okppugbaBp5siNS4vdZ8lmgiKWcZBhtkbSpH0BWxzwh0VIQ+XSoS\nb4Nqzon+04bSIV5TCa4HuWAfqTCwnpemFwf1OvabSX8UD4A/Iw214PIDKAWhmM6txfZHU4BF7LKt\nAz/9DQJJ4yBPoM2BQ3lqFVwa1J2M1I4ha+xnd4YISNDjXwlJGT3wDkHfBDIpejEJdEwa1SRxG5QI\nfeBz7K7DBXpGNrwc+ECAa8DGER8rGQhgkOBdvWdZKI/LEy7T8r3a3QJ6Fj7cKCPMUbdPQ/vshnxm\nSfhOdRCECXM0Rz+UODUQIGXItckFEnGn+klEFjSXN+rZFKPwstO1zaKIZ9hZxwMZc8NGyokrqWE2\nqSSEu79lIyRQRXlak1/7ctja9J6AdB1JH+16xki6SLqvCqS/Jf0QtqMWdEp6L5DuBg5FTFYRt1sg\n/Srpr8soY0lXSeeVQnodRoGS7u85BgLpa5JOmDBEXe9YIKaPQfpixJ3eOEKkRN0l3VcE0t+Sfvzq\nUQmkqyV9UiwMWZDeZ4Y4MAeuNh77C3A9Xiz8orDe+9BuIulhU7W6Z15/GWRX6eAoY4mIpJy6hQhl\nHMT2A31i9G3pRLOxZVOTUNfTGXcPC3mJ0JC2VZ3svZBgwS2VlDRkrlUgVBAsJAkYAhKhvd+H6Lua\nwULIUg0SA1v77l5OrCt7I7AcBR2snoAOPIfKTheO6b2UB/sw5IGfcByx7W+RaRpOX7hPMq2vcm3c\nuAjeFi4MhikmVHIeFmmfkzZQeicGE/UIol8jd7E8pBMXEAMuY70H78m23REFCkpCFkWtmkUx5AWA\nO3gxySqfnyWK2lWR4hG+OdPrvLmPzuZK3Bq4XPyjln7Tu5+0EeWrxaX0f/8t8lSp5wymkb3yMGFr\nNdnd7ZUDlRiEahOI0BPizJB2dQImA4XkZ7MT8nzSzD0aN8HIB+LUwK/yaLAZBuo1wvD78fjHJvVx\n+4gIeww5maTve2HO/68hxYdo1kUUGBhekGrFZl2h0SSeq26aEki+erJ2RJYK7GLc1tQjPb2qIWlg\nXFiHxU+7gohKI5sMy2RzDYBUnJ6mYGMrvo4u0MLwS0SgRVLrP5QmxsmyA+oGnAkPIyxbSByLN3P9\ncS7q7gUJmRRWi2Dnj1hFM7g/IjpFDrfii73SGGKU3qpWyVCIjy4svBpPcSJD5bDU6jO+ugOKxYgs\nvP5WjY8bN/ofUL/n2Eba2gszCI/vyBFxPPXkWEX3y8SBjvHxktQ0mQ73HIYDlIGa3zF65QJCkNTX\nwvb6HmCcZNcPFvc9VwcrCfP/Y8KMRTWk3Ac/K2dR4T1AXvh4g2eYK7f0IYikMcYEatRnWGan8iP6\n3u9NdCctr6GSY7r6AO8cdEo6UpUGpaxTpI8qQfbvMG7HQfXBqPUnamBhvrPCEXGi644i1/D3vfqw\no4FiZZRxQSFxXyLjAMIa6tWZaY8TAKiN46j6EnKm0Pn64Vfa8vujV9aHodI7U1XEkv9oOKOVB3r0\nIUhHUyA8v6+HlrFc8kFQo/yDvfCwM1lcJbbFDbPysA3//hiA3LiuU+xec+Ye6W/INZqCYJFazaJa\nct608pX/KlY3VyKweR4eSRwWKay8gjh7FPkwDBed9G29D/huxAuBnq4FFwaoWv2xXRGBvTCOBrS+\nKa2/WOMh6HlB6pIX36N3CLx2PgaBAnizM9qtEq6RogEhI+zqP1JS61IQci1FBpEPD29DB4X3L3S/\nCDrzAhnLVoMugoxht6Y66r7O2VETrffO/1z/ntctbsm/wtvVpnVkOggw3i0z0COSFop6a+0zjMYP\n2QnyhmPuAE8/RuoNOGdBywLx3PXP5Z0NACVo0COEXgATOE5B7MG+cAx/RvqtBDbvsNW8akxJDrfE\ndIHAOD/ujiOMDgbmn6m4O8/zq4fs4cjhScpMy3y1quoGAUszKbAgp+m1k/pfjM/EWianRsW0Y/cA\n+Hy5Wrbu92VZYpYTsVZpbtOxWuYHrAbG8BkAjgoBIDFROdc4OJ/1JQvTFzkkUTV+VKa0c3kpEroW\nMdUaXg+M3oSgbd3MCbPSEPxpgMgcshUOY+G4bO+O+YDEYGOHw+Bj2NtkdebO8vEmArdEltmHNWDv\nYmOX7ZuR6z9Kl2wQtCMM9ZreHZRT+sDT7j8aZfEkKU5EawEBY5DSqYa7y8Dhp4Ay4xgysrRlpFau\nL+HJpONruG2/UOrt1WumFaDlbEk0t5ofri2GA11ke2bl6MkFO1XSqLZjHEkpgssDFarUqHw4yLz0\njTYAxIu57ZVmQq0UC9qmvElTBVeBnSyO48579qfcffmy6A+fxarVF0JQ5wr9YKGVAJ2Sz1Gt5qtV\n3fCppTvmIWu4hUXXxFWoipogRHdiRg3s6WNRZwKMWFYZM/U9KwOI65oPdRmH0+AfIAn350ic/Ztm\neClbuIBXDK3YMpEzvl696TUE3lofaPmgcqF2IBgDiI/yARiNKnplrENFLjj/xNwk1hH5Lf/Xlqn8\n4A26izK49FXyv/xLyX3yv8WLyNlpBkOIQa2hNRPH1e2tCS+5a6VFrrCNjEpnhFnq8j0Ofsy6Dqia\nWZbnLnX0SGIVzQx54+ybWk4DlwfxCzFBS16uAhODWuGBb+IoH+Ip5NHvWFxNMgYQffgu2dkruKKE\n8YonMH6MYOYxzgCV5T7F0zEqWPRjcB3i6QpVYLA3CyOeAD2FiwUAFU9tKt/wddziCSkHitoxuBCm\n4qlumBHT3KP3STvco80LzLbwAKugq6BGsLqbDYxthYkXzGQGsLWnIdnFqmSkxfjXtmUJWNZ1YuxS\ngGnm2jV3YtQ7yBpn0D0v0abHxyVfied71VwFwA6G2m4dAKtsrXW8SNXx2DIfoTie9k+7ofAC/N+L\nwHsqRmCv7uyYlp0XyfpwH4w3x9S/fTsm1IhpB84TwdITrzKY+lhShAC9wU7OuS/N+ilYDxIEWOGf\nslPaat37pLvxSkKedOse3QWJaJjlb+U2cqc6vpYoZiO0yP0z0WTiVE8OZmJ5B7gStGy64Kl2UYj8\n+ir3GsArYy5K4FAAxd8sVVsQMJINIbugOKJbVO3SbQOoe3I8FcQBLAQ/jeRalp6p2aNAi6f4fWwW\nVzqNM7az4uOR2KfW7JTiow3jR4Sn05jF4Wh4MBJflk7H/spZFdHFxp8Y4O4FSI8nePmZVLzK6V3E\nVparLJMOit9secPnj6ffFb8C8WeZFh41yGs6WeiCiY8n5UuuHYk4RcUFrn6k9ccTkEshazEIaDxJ\n+fCW9McT/V+tKSA4mbVozrVqkp/wvjWeZNyERSc0Pzee8pUleh9P9I8srCINkI5q6Djm9SU58fan\nUEAjQ45TrsmCZJrXSQOgydyv7Xg5/lD4EBcVD3XAm0rq5uqIK/aCPkvRzoWUr7GXUaTvMAgW7hmY\npdC3LXttL/eAMQfJzcE/NMHyltLEkl9ktpWahVG9mlMwJsTnmys+cy7My3LJJ0Uo7eknq41g7HIa\nJHKfdnhddaUYdQCZs2yM1yK6vABP9opMBgnYvW5Pld3I7cSsoqVIeTZi8aTSpwliujboIFhHhfXL\nI1TTo8o+xiHFe6RaxcgbXUgjIX9IAiZjQjJ7yMNj94UNdYk86Us5Y7xLHNpeEY8uEob+vN4/CvlZ\nDWdW+piDpca8/Q7IKWuqYBTPSkEKhC1XG9qlYlBpGgVELlIKjXHLaATwZ2wdDmvwlQ1oshkoPt02\nWwGBxeGEHdl/mXHxkIM5LePx1GAfMucOV7QKn836/n0YXwqiPwflWygIxAYcm2L45crRVhCHyQAG\nE59I9onjURim1tS82I91UTSbSS6r/pKcTIuqp2KIoIu5NP9UcW/Kk3pJngRI9x6uhVMHA+aK+80C\nLrRIImoq5o7Tua4Q5IRkG1lyyhLGwi7mx5borE7hnZ0Qv5Wy48GGxQCPrTsVcZqJVlxXf5J4ptPM\nTVPkr0Cv78TX1ml//aqZaviQCWetffrwSqQvMX2+hkGIQUnafQlqH0rEbWnRl5DvumyfGrJc/kFh\nDbo3E+qKQWv6AJSUt+RycZwnCON9ep+Yj1OrZVIkBXgd6uEShyoSkPk5FN4gIgthgxIuMrWZgdvd\ntx3vcXIz7zAZ0S8sPI3gGrJCtwPhF1gt2wHBDc8WYMhaYjdBc7XR3QfzuuhAwyAYx7zrXhbgyake\nLnMYDSknk/zIiiBBfyy5D0AxnT10jb+S2fsDMb4SZWXdMNmc8xHlv4dqQgTY+yVf7IjiYCvotKi9\nieO7cecgqvFF/NtQ/WuMz5XuOKe5Sd5PmGzH+TRsLiGncA+OXXD0/u397jANiW/EAJOxLUs2rB3N\nTZperLvfmhP+LVlO/YtcpQ/yBr7Ev6TUv5moST08zb8WJvBvOKv6xWE7hfj3metfagNXi2qgwCcE\nnE1VwdbXv+Oy2AT5QW38K1knYewDn/qesWYMJOyKTu+k2CsJ6pcdnvhXCv37k5xJjw==\n\t]]>\n\t<![CDATA[\n\tajfJZrCYy8W26N/jlBHyR/OiRJjVfwyCavcCVpwbLRR+zzSLnTiuyvvX8a/rJRjWv+S6KHVMYIB/\niQ/1gJfsKIw7/k2JL3+x/vVUqWUOeqG/Aea+D0yDfVJG0+NfyC/BEPQyI/2739/JpUukOhl2+teg\nhB8Dw78qSPX7wgWY9q3+2jL866csz6QSQ7wxxrtChIorM7MdLMCabQkGYEhMz8HHUU0AbMExxoKZ\nRTzh6ONRVidGnirob/IF/vOUKVC0//EU9gtBswQWGiPySrsLbr6efgUpqXIlDDCBLqHuOD0vm3xh\nisaNF2NmBinA2pVHGK6xdArwLNpz0RsGbjDWKeM1FsRn4VU5AgScVpEfEVowk90I/r67OkBm6g3s\nS2I5wLhPFjTFoMcZ9PfGR0BJFYAaU7U2Z8u5+nAFlyK/wB1sr6LMmvlXKQ0+XWBdvVZfrMWpyuHe\nTrZhjTvtGPasGFJ44NepSa3KojcvYa4RQ/z2k28n76njP1r6/4Pzw8B4P2UPodfNz89ENkfJ78mX\nq/Is8EKwGuZbmOGvE9gXZjBwooQ0VxDg1I2U0MvucLpV1JnMOtP0pw2L62G0SsteU6kGbXyUyZjn\nj5gAxGkkLEgtcIy8k4suNsYWb285+OqyOdwIfdGSQBC+WsA2Jt4RJa86hgsAOX4CLNmYCA+vROZ3\niTx5myUgRqkBa1vQgblCtcWZCz2Bbr12XOiARnPhtSRb61q0/KhzcogtoV61q+srHjJCjP9NQgP1\n/o5DIuahNulWgnqzP6+Rpd7lyHAri63RIlCvjSFLyB6VqQmFejnsN+yyoVOpoHNc6jW+knEMOaPt\n7+UYunZ0OvB6n2ySgHpVL2RMCDa+JdnKNRCpd8FGGkf/wHXJYOPTU7QHXkO/sy/HuO2gtiULYGMz\nptO7Px6YK0oWRfAdIaygPXmPmOqy/uQTvvBrGTFqBfw+KfTJnWKNL9k28maXz+NLHaCmHqf9DIDq\ncDMJY6mSycMyyE5EMhO24Oz+9WcsSN7LAGCY2hlAIaZa7pX0Hl5uDpduIU3GlS+LeD2ACfGVJBQr\nRliiVXd0hPYPxS9xrp8il/2xQFQOxUMlNO3LLNgr5kXu6BSwFRhHjKYpj+K+iceLi3i4il15SO6m\nnK9gbjqyGo7o66xO2lvk3bHALfgqFvIVqIvSJonmZ1CR15dMEVM/4axg3iLUQTio/ix7zrR7F7ZE\nEN7Qq62iKLx5toqYGAbnHphX8dmGEVHLpM5CQnj9Bq8JpF8wLiu3wIN4cH5f4LW8h9w013z6z7Fm\n2XGbLV+9RPbIkm8o\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z\"/><circle cx=\"11\" cy=\"8\" r=\"1\"/><circle cx=\"11\" cy=\"16\" r=\"1\"/><circle cx=\"11\" cy=\"24\" r=\"1\"/><path d=\"M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z\"/></g></switch></svg>",
            "info": {},
            "path": "32/data-quality-definition.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataQualityDefinition32",
          "filepath": "data-quality-definition/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "8",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "16",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "24",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-quality-definition",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataQualityDefinition24",
          "filepath": "data-quality-definition/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "8",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "16",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "24",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-quality-definition",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataQualityDefinition20",
          "filepath": "data-quality-definition/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "8",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "16",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "24",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-quality-definition",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataQualityDefinition16",
          "filepath": "data-quality-definition/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "8",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "16",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "circle",
                        "attrs": {
                          "cx": "11",
                          "cy": "24",
                          "r": "1"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "data-quality-definition",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataQualityDefinition",
        "global": "DataQualityDefinition",
        "filepath": "DataQualityDefinition.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "circle",
                          "attributes": {
                            "cx": "11",
                            "cy": "8",
                            "r": "1"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "circle",
                          "attributes": {
                            "cx": "11",
                            "cy": "16",
                            "r": "1"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "circle",
                          "attributes": {
                            "cx": "11",
                            "cy": "24",
                            "r": "1"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-refinery",
      "friendlyName": "Data refinery",
      "aliases": [
        "data collection",
        "data refinery",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-refinery.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>data-refinery</title>\n  <path d=\"M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z\"/>\n  <path d=\"M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z\"/>\n  <path d=\"M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z\"/><path d=\"M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z\"/><path d=\"M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z\"/></svg>",
            "info": {},
            "path": "32/data-refinery.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataRefinery32",
          "filepath": "data-refinery/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
                }
              }
            ],
            "name": "data-refinery",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataRefinery24",
          "filepath": "data-refinery/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
                }
              }
            ],
            "name": "data-refinery",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataRefinery20",
          "filepath": "data-refinery/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
                }
              }
            ],
            "name": "data-refinery",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataRefinery16",
          "filepath": "data-refinery/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
                }
              }
            ],
            "name": "data-refinery",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataRefinery",
        "global": "DataRefinery",
        "filepath": "DataRefinery.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-refinery--reference",
      "friendlyName": "Data refinery reference",
      "aliases": [
        "data collection",
        "data refinery reference",
        "reference",
        "data",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-refinery--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z\"/>\n  <path d=\"M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z\"/><path d=\"M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z\"/></svg>",
            "info": {},
            "path": "32/data-refinery--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataRefineryReference32",
          "filepath": "data-refinery--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              }
            ],
            "name": "data-refinery--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataRefineryReference24",
          "filepath": "data-refinery--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              }
            ],
            "name": "data-refinery--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataRefineryReference20",
          "filepath": "data-refinery--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              }
            ],
            "name": "data-refinery--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataRefineryReference16",
          "filepath": "data-refinery--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                }
              }
            ],
            "name": "data-refinery--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataRefineryReference",
        "global": "DataRefineryReference",
        "filepath": "DataRefineryReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-share",
      "friendlyName": "Data share",
      "aliases": [
        "data",
        "share",
        "link",
        "compare",
        "transfer",
        "exchange"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-share.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-share</title><path d=\"M5,25V15.8281l-3.5859,3.586L0,18l6-6,6,6-1.4141,1.4141L7,15.8281V25H19v2H7A2.0024,2.0024,0,0,1,5,25Z\" transform=\"translate(0 0)\"/><path d=\"M24,22h4a2.002,2.002,0,0,1,2,2v4a2.002,2.002,0,0,1-2,2H24a2.002,2.002,0,0,1-2-2V24A2.002,2.002,0,0,1,24,22Zm4,6V24H23.9985L24,28Z\" transform=\"translate(0 0)\"/><path d=\"M27,6v9.1719l3.5859-3.586L32,13l-6,6-6-6,1.4141-1.4141L25,15.1719V6H13V4H25A2.0024,2.0024,0,0,1,27,6Z\" transform=\"translate(0 0)\"/><rect x=\"2\" y=\"6\" width=\"6\" height=\"2\"/><rect x=\"2\" y=\"2\" width=\"8\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z\"/></svg>",
            "info": {},
            "path": "32/data-share.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataShare32",
          "filepath": "data-share/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "data-share",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataShare24",
          "filepath": "data-share/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "data-share",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataShare20",
          "filepath": "data-share/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "data-share",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataShare16",
          "filepath": "data-share/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "data-share",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataShare",
        "global": "DataShare",
        "filepath": "DataShare.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-table",
      "friendlyName": "Data table",
      "aliases": [
        "data table",
        "data",
        "table"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-table.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>data-table</title>\n  <rect x=\"8\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"8\" y=\"14\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"22\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"14\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"22\" width=\"4\" height=\"2\"/>\n  <path d=\"M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z\"/><path d=\"M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z\"/></svg>",
            "info": {},
            "path": "32/data-table.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataTable32",
          "filepath": "data-table/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
                }
              }
            ],
            "name": "data-table",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataTable24",
          "filepath": "data-table/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
                }
              }
            ],
            "name": "data-table",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataTable20",
          "filepath": "data-table/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
                }
              }
            ],
            "name": "data-table",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataTable16",
          "filepath": "data-table/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
                }
              }
            ],
            "name": "data-table",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataTable",
        "global": "DataTable",
        "filepath": "DataTable.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-table--reference",
      "friendlyName": "Data table reference",
      "aliases": [
        "data table",
        "data table reference",
        "reference",
        "data",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-table--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <rect x=\"20\" y=\"22\" width=\"4\" height=\"2\"/>\n  <rect x=\"16\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"14\" width=\"4\" height=\"2\"/>\n  <rect x=\"8\" y=\"14\" width=\"4\" height=\"2\"/>\n  <path d=\"M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z\"/><path d=\"M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z\"/></svg>",
            "info": {},
            "path": "32/data-table--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataTableReference32",
          "filepath": "data-table--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "data-table--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataTableReference24",
          "filepath": "data-table--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "data-table--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataTableReference20",
          "filepath": "data-table--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "data-table--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataTableReference16",
          "filepath": "data-table--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "data-table--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataTableReference",
        "global": "DataTableReference",
        "filepath": "DataTableReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-vis--1",
      "friendlyName": "Data visualization 1",
      "aliases": [
        "vis",
        "graph",
        "chart",
        "infographic",
        "analytics",
        "metrics",
        "stats",
        "web"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-vis--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-vis--1</title><path d=\"M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/data-vis--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataVis_132",
          "filepath": "data-vis--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data-vis--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataVis_124",
          "filepath": "data-vis--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data-vis--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataVis_120",
          "filepath": "data-vis--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data-vis--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataVis_116",
          "filepath": "data-vis--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "data-vis--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataVis_1",
        "global": "DataVis_1",
        "filepath": "DataVis_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-vis--2",
      "friendlyName": "Data visualization 2",
      "aliases": [
        "vis",
        "graph",
        "chart",
        "infographic",
        "analytics",
        "metrics",
        "stats",
        "web"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-vis--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-vis--2</title><path d=\"M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z\"/></svg>",
            "info": {},
            "path": "32/data-vis--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataVis_232",
          "filepath": "data-vis--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
                }
              }
            ],
            "name": "data-vis--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataVis_224",
          "filepath": "data-vis--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
                }
              }
            ],
            "name": "data-vis--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataVis_220",
          "filepath": "data-vis--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
                }
              }
            ],
            "name": "data-vis--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataVis_216",
          "filepath": "data-vis--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
                }
              }
            ],
            "name": "data-vis--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataVis_2",
        "global": "DataVis_2",
        "filepath": "DataVis_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-vis--3",
      "friendlyName": "Data visualization 3",
      "aliases": [
        "vis",
        "graph",
        "chart",
        "infographic",
        "analytics",
        "metrics",
        "stats",
        "web"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-vis--3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-vis--3</title><path d=\"M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z\"/></svg>",
            "info": {},
            "path": "32/data-vis--3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataVis_332",
          "filepath": "data-vis--3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
                }
              }
            ],
            "name": "data-vis--3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataVis_324",
          "filepath": "data-vis--3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
                }
              }
            ],
            "name": "data-vis--3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataVis_320",
          "filepath": "data-vis--3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
                }
              }
            ],
            "name": "data-vis--3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataVis_316",
          "filepath": "data-vis--3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
                }
              }
            ],
            "name": "data-vis--3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataVis_3",
        "global": "DataVis_3",
        "filepath": "DataVis_3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-vis--4",
      "friendlyName": "Data visualization 4",
      "aliases": [
        "vis",
        "graph",
        "chart",
        "infographic",
        "analytics",
        "metrics",
        "stats",
        "web"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-vis--4.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>data-vis--4</title><path d=\"M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z\"/></svg>",
            "info": {},
            "path": "32/data-vis--4.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataVis_432",
          "filepath": "data-vis--4/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
                }
              }
            ],
            "name": "data-vis--4",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataVis_424",
          "filepath": "data-vis--4/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
                }
              }
            ],
            "name": "data-vis--4",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataVis_420",
          "filepath": "data-vis--4/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
                }
              }
            ],
            "name": "data-vis--4",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataVis_416",
          "filepath": "data-vis--4/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
                }
              }
            ],
            "name": "data-vis--4",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataVis_4",
        "global": "DataVis_4",
        "filepath": "DataVis_4.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-volume",
      "friendlyName": "data-volume",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-volume.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,20h-4v2h4v2h-3c-1.1046,0-2,.8954-2,2v2c0,1.1046,.8954,2,2,2h5v-8c0-1.103-.8975-2-2-2Zm0,8h-3v-2h3v2Z\"/>\n  <path d=\"M24,22v-2h-3v-2h-2v2h-2v2h2v6c0,1.1025,.8975,2,2,2h3v-2h-3v-6h3Z\"/>\n  <path d=\"M14,20h-4v2h4v2h-3c-1.1046,0-2,.8954-2,2v2c0,1.1046,.8954,2,2,2h5v-8c0-1.103-.8975-2-2-2Zm0,8h-3v-2h3v2Z\"/>\n  <path d=\"M5,16.0005v4H2c-1.1025,0-2,.897-2,2v5.9995c0,1.1025,.8975,2,2,2H7v-13.9995h-2Zm-3,5.9995h3v6H2v-6Z\"/>\n  <path d=\"M4,14V5h7.5857l4,4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041,.0013-1.9987,.8959-2,2V14h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM24 22v-2h-3v-2h-2v2h-2v2h2v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM14 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM5 16.0005v4H2c-1.1025 0-2 .897-2 2v5.9995c0 1.1025.8975 2 2 2H7v-13.9995h-2zm-3 5.9995h3v6H2v-6zM4 14V5h7.5857l4 4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z\"/></svg>",
            "info": {},
            "path": "32/data-volume.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataVolume32",
          "filepath": "data-volume/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM24 22v-2h-3v-2h-2v2h-2v2h2v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM14 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM5 16.0005v4H2c-1.1025 0-2 .897-2 2v5.9995c0 1.1025.8975 2 2 2H7v-13.9995h-2zm-3 5.9995h3v6H2v-6zM4 14V5h7.5857l4 4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "data-volume",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataVolume24",
          "filepath": "data-volume/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM24 22v-2h-3v-2h-2v2h-2v2h2v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM14 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM5 16.0005v4H2c-1.1025 0-2 .897-2 2v5.9995c0 1.1025.8975 2 2 2H7v-13.9995h-2zm-3 5.9995h3v6H2v-6zM4 14V5h7.5857l4 4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "data-volume",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataVolume20",
          "filepath": "data-volume/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM24 22v-2h-3v-2h-2v2h-2v2h2v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM14 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM5 16.0005v4H2c-1.1025 0-2 .897-2 2v5.9995c0 1.1025.8975 2 2 2H7v-13.9995h-2zm-3 5.9995h3v6H2v-6zM4 14V5h7.5857l4 4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "data-volume",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataVolume16",
          "filepath": "data-volume/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM24 22v-2h-3v-2h-2v2h-2v2h2v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM14 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM5 16.0005v4H2c-1.1025 0-2 .897-2 2v5.9995c0 1.1025.8975 2 2 2H7v-13.9995h-2zm-3 5.9995h3v6H2v-6zM4 14V5h7.5857l4 4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                }
              }
            ],
            "name": "data-volume",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataVolume",
        "global": "DataVolume",
        "filepath": "DataVolume.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM24 22v-2h-3v-2h-2v2h-2v2h2v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM14 20h-4v2h4v2h-3c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h5v-8c0-1.103-.8975-2-2-2zm0 8h-3v-2h3v2zM5 16.0005v4H2c-1.1025 0-2 .897-2 2v5.9995c0 1.1025.8975 2 2 2H7v-13.9995h-2zm-3 5.9995h3v6H2v-6zM4 14V5h7.5857l4 4h12.4143v8h2V9c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "data-volume--alt",
      "friendlyName": "data-volume--alt",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/data-volume--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z\"/>\n  <circle cx=\"20\" cy=\"21\" r=\"2\"/>\n  <path d=\"M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z\"/>\n  <path d=\"M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z\"/><circle cx=\"20\" cy=\"21\" r=\"2\"/><path d=\"M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z\"/><path d=\"M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z\"/></svg>",
            "info": {},
            "path": "32/data-volume--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DataVolumeAlt32",
          "filepath": "data-volume--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z"
                }
              }
            ],
            "name": "data-volume--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DataVolumeAlt24",
          "filepath": "data-volume--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z"
                }
              }
            ],
            "name": "data-volume--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DataVolumeAlt20",
          "filepath": "data-volume--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z"
                }
              }
            ],
            "name": "data-volume--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DataVolumeAlt16",
          "filepath": "data-volume--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z"
                }
              }
            ],
            "name": "data-volume--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DataVolumeAlt",
        "global": "DataVolumeAlt",
        "filepath": "DataVolumeAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,29c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "21",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,19c-1.6543,0-3-1.3458-3-3s1.3457-3,3-3,3,1.3458,3,3-1.3457,3-3,3Zm0-4c-.5515,0-1,.4486-1,1s.4485,1,1,1,1-.4486,1-1-.4485-1-1-1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25H13v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--datastax",
      "friendlyName": "IBM Cloud® Databases for DataStax",
      "aliases": [
        "enterprise",
        "datastax",
        "database",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--datastax.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18.8684,22.0684l1.7937-1.7476A4.2184,4.2184,0,0,0,23.95,21.9534c1.4026,0,2.0005-.5288,2.0005-1.38,0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633,0-2.3225,1.8166-3.7942,4.5529-3.7942a5.7221,5.7221,0,0,1,4.691,1.8855l-1.7246,1.7246a3.9649,3.9649,0,0,0-2.8743-1.2876c-1.2649,0-1.8167.5059-1.8167,1.2417,0,.8049.4368,1.1726,1.5638,1.3567l1.2187.1609c2.6213.3679,3.886,1.5408,3.886,3.5412,0,2.3226-1.9546,3.9322-4.9439,3.9322A6.0942,6.0942,0,0,1,18.8684,22.0684Z\"/>\n  <path d=\"M4.24,7.95h5.8409c4.185,0,6.9213,2.69,6.9213,8.0254S14.2661,24,10.0811,24H4.24Zm5.8409,13.36c2.2534,0,3.7021-1.3338,3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z\"/></svg>",
            "info": {},
            "path": "32/database--datastax.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabaseDatastax32",
          "filepath": "database--datastax/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z"
                }
              }
            ],
            "name": "database--datastax",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabaseDatastax24",
          "filepath": "database--datastax/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z"
                }
              }
            ],
            "name": "database--datastax",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabaseDatastax20",
          "filepath": "database--datastax/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z"
                }
              }
            ],
            "name": "database--datastax",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabaseDatastax16",
          "filepath": "database--datastax/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z"
                }
              }
            ],
            "name": "database--datastax",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabaseDatastax",
        "global": "DatabaseDatastax",
        "filepath": "DatabaseDatastax.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--elastic",
      "friendlyName": "IBM Cloud® Databases for Elasticsearch",
      "aliases": [
        "enterprise",
        "elastic",
        "database",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--elastic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17.8281,22.0684l1.7937-1.7476A4.2185,4.2185,0,0,0,22.91,21.9534c1.4025,0,2-.5288,2-1.38,0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633,0-2.3225,1.8166-3.7942,4.553-3.7942a5.722,5.722,0,0,1,4.6909,1.8855l-1.7246,1.7246a3.9643,3.9643,0,0,0-2.8743-1.2876c-1.2649,0-1.8166.5059-1.8166,1.2417,0,.8049.4367,1.1726,1.5637,1.3567l1.2187.1609c2.6214.3679,3.886,1.5408,3.886,3.5413,0,2.3225-1.9546,3.9321-4.9438,3.9321A6.0944,6.0944,0,0,1,17.8281,22.0684Z\"/>\n  <path d=\"M5.2471,24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z\"/></svg>",
            "info": {},
            "path": "32/database--elastic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabaseElastic32",
          "filepath": "database--elastic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z"
                }
              }
            ],
            "name": "database--elastic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabaseElastic24",
          "filepath": "database--elastic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z"
                }
              }
            ],
            "name": "database--elastic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabaseElastic20",
          "filepath": "database--elastic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z"
                }
              }
            ],
            "name": "database--elastic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabaseElastic16",
          "filepath": "database--elastic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z"
                }
              }
            ],
            "name": "database--elastic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabaseElastic",
        "global": "DatabaseElastic",
        "filepath": "DatabaseElastic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--enterprise-db2",
      "friendlyName": "IBM Cloud® Databases for EnterpriseDB",
      "aliases": [
        "enterprise",
        "database",
        "Db",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--enterprise-db2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17.84,24V11.9966H20.783v2h.1149a3.3115,3.3115,0,0,1,3.3572-2.2764c2.46,0,3.84,1.7017,3.84,4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187,0-2.3913.6438-2.3913,1.9314V24Z\"/>\n  <path d=\"M4.2236,24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z\"/></svg>",
            "info": {},
            "path": "32/database--enterprise-db2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabaseEnterpriseDb232",
          "filepath": "database--enterprise-db2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
                }
              }
            ],
            "name": "database--enterprise-db2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabaseEnterpriseDb224",
          "filepath": "database--enterprise-db2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
                }
              }
            ],
            "name": "database--enterprise-db2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabaseEnterpriseDb220",
          "filepath": "database--enterprise-db2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
                }
              }
            ],
            "name": "database--enterprise-db2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabaseEnterpriseDb216",
          "filepath": "database--enterprise-db2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
                }
              }
            ],
            "name": "database--enterprise-db2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabaseEnterpriseDb2",
        "global": "DatabaseEnterpriseDb2",
        "filepath": "DatabaseEnterpriseDb2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--etcd",
      "friendlyName": "IBM Cloud® Databases for etcd",
      "aliases": [
        "enterprise",
        "database",
        "etcd",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--etcd.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.9443,20.9417v-6.6h-1.77V11.9966h.92c.8735,0,1.1494-.4138,1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778,2.778,0,0,1,20.9443,20.9417Z\"/>\n  <path d=\"M6.6846,24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z\"/></svg>",
            "info": {},
            "path": "32/database--etcd.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabaseEtcd32",
          "filepath": "database--etcd/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z"
                }
              }
            ],
            "name": "database--etcd",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabaseEtcd24",
          "filepath": "database--etcd/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z"
                }
              }
            ],
            "name": "database--etcd",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabaseEtcd20",
          "filepath": "database--etcd/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z"
                }
              }
            ],
            "name": "database--etcd",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabaseEtcd16",
          "filepath": "database--etcd/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z"
                }
              }
            ],
            "name": "database--etcd",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabaseEtcd",
        "global": "DatabaseEtcd",
        "filepath": "DatabaseEtcd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--mongodb",
      "friendlyName": "IBM Cloud® Databases for MongoDB",
      "aliases": [
        "enterprise",
        "database",
        "MongoDB",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--mongodb.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.3481,28.875c-4.0473,0-5.5878-1.0579-5.5878-2.8284a2.2115,2.2115,0,0,1,2.1386-2.3v-.253a1.9726,1.9726,0,0,1-1.5405-2c0-1.242,1.0576-1.8628,2.207-2.1158v-.0918a3.6228,3.6228,0,0,1-2.1845-3.4953c0-2.4375,1.7246-4.07,4.9672-4.07A6.6717,6.6717,0,0,1,27.44,12.02v-.3908a1.5343,1.5343,0,0,1,1.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917,3.5917,0,0,1,1.8628,3.3343c0,2.4145-1.7016,4.0241-4.9668,4.0241a7.3662,7.3662,0,0,1-1.8393-.207,1.23,1.23,0,0,0-.8511,1.0808c0,.5979.5059.8967,1.564.8967H27.44c2.9434,0,4.208,1.2649,4.208,3.4263C31.6484,27.5183,29.9473,28.875,25.3481,28.875Zm1.4947-4.7371H22.75a1.473,1.473,0,0,0-.6211,1.2417c0,.92.6895,1.4717,2.5293,1.4717H26.13c1.9087,0,2.76-.4829,2.76-1.4946C28.89,24.5979,28.3374,24.1379,26.8428,24.1379Zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616,1.84v.3912c0,1.1955.7588,1.84,2.1616,1.84S27.51,17.17,27.51,15.9749Z\"/>\n  <path d=\"M2.2344,7.95H5.66l4.1162,7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186,15.032l-3.2881,6.07-3.2881-6.07L5.2007,12.48H5.1084V24H2.2344Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z\"/></svg>",
            "info": {},
            "path": "32/database--mongodb.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabaseMongodb32",
          "filepath": "database--mongodb/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z"
                }
              }
            ],
            "name": "database--mongodb",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabaseMongodb24",
          "filepath": "database--mongodb/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z"
                }
              }
            ],
            "name": "database--mongodb",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabaseMongodb20",
          "filepath": "database--mongodb/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z"
                }
              }
            ],
            "name": "database--mongodb",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabaseMongodb16",
          "filepath": "database--mongodb/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z"
                }
              }
            ],
            "name": "database--mongodb",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabaseMongodb",
        "global": "DatabaseMongodb",
        "filepath": "DatabaseMongodb.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--postgreSQL",
      "friendlyName": "IBM Cloud® Databases for PostgreSQL",
      "aliases": [
        "enterprise",
        "database",
        "PostgreSQL",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--postgreSQL.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.98,28.875c-4.0474,0-5.5879-1.0579-5.5879-2.8284a2.2112,2.2112,0,0,1,2.1387-2.3v-.253a1.9725,1.9725,0,0,1-1.541-2c0-1.242,1.0576-1.8628,2.2075-2.1158v-.0918a3.622,3.622,0,0,1-2.1846-3.4953c0-2.4375,1.7246-4.07,4.9673-4.07a6.6768,6.6768,0,0,1,2.0923.2988v-.3908a1.5341,1.5341,0,0,1,1.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926,3.5926,0,0,1,1.8628,3.3343c0,2.4145-1.7022,4.0241-4.9668,4.0241a7.3717,7.3717,0,0,1-1.84-.207,1.23,1.23,0,0,0-.8505,1.0808c0,.5979.5058.8967,1.5634.8967h3.2193c2.9433,0,4.208,1.2649,4.208,3.4263C29.28,27.5183,27.5781,28.875,22.98,28.875Zm1.4941-4.7371H20.3809A1.474,1.474,0,0,0,19.76,25.38c0,.92.69,1.4717,2.5293,1.4717h1.4716c1.9092,0,2.76-.4829,2.76-1.4946C26.5205,24.5979,25.9688,24.1379,24.4736,24.1379Zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621,1.84v.3912c0,1.1955.7588,1.84,2.1621,1.84S25.1406,17.17,25.1406,15.9749Z\"/>\n  <path d=\"M4.603,24V7.95h7.22c2.9668,0,4.76,2,4.76,4.967,0,2.9893-1.7935,4.9668-4.76,4.9668H7.6387V24Zm3.0357-8.738h3.9092a1.6886,1.6886,0,0,0,1.8852-1.8167V12.3875a1.672,1.672,0,0,0-1.8852-1.7935H7.6387Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z\"/></svg>",
            "info": {},
            "path": "32/database--postgreSQL.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabasePostgreSql32",
          "filepath": "database--postgreSQL/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z"
                }
              }
            ],
            "name": "database--postgreSQL",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabasePostgreSql24",
          "filepath": "database--postgreSQL/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z"
                }
              }
            ],
            "name": "database--postgreSQL",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabasePostgreSql20",
          "filepath": "database--postgreSQL/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z"
                }
              }
            ],
            "name": "database--postgreSQL",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabasePostgreSql16",
          "filepath": "database--postgreSQL/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z"
                }
              }
            ],
            "name": "database--postgreSQL",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabasePostgreSql",
        "global": "DatabasePostgreSql",
        "filepath": "DatabasePostgreSql.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--rabbit",
      "friendlyName": "IBM Cloud® Databases for Rabbit",
      "aliases": [
        "enterprise",
        "database",
        "Rabbit",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--rabbit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17.9434,20.7346c0-2.46,1.8623-3.6792,5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249,3.1249,0,0,0-2.7363,1.5175L18.4033,14.02a5.0544,5.0544,0,0,1,4.6909-2.3c3.2422,0,4.9668,1.54,4.9668,4.2771v5.6567h1.1958V24H27.624a2.184,2.184,0,0,1-2.23-2.07h-.1377c-.3912,1.5408-1.7017,2.3455-3.4952,2.3455C19.3232,24.2759,17.9434,22.8733,17.9434,20.7346Zm7.1743-.3218V18.8262H23.2324c-1.541,0-2.3.5288-2.3,1.4717v.3908c0,.9658.667,1.4488,1.8164,1.4488C24.06,22.1375,25.1177,21.54,25.1177,20.4128Z\"/>\n  <path d=\"M6.9717,24H3.9365V7.95H11.18c2.92,0,4.7373,1.9316,4.7373,4.967a4.4237,4.4237,0,0,1-2.9893,4.553L16.2158,24h-3.38L9.8462,17.8145H6.9717Zm3.9092-8.738a1.689,1.689,0,0,0,1.8857-1.8167V12.3875a1.6723,1.6723,0,0,0-1.8857-1.7935H6.9717v4.668Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z\"/></svg>",
            "info": {},
            "path": "32/database--rabbit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabaseRabbit32",
          "filepath": "database--rabbit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z"
                }
              }
            ],
            "name": "database--rabbit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabaseRabbit24",
          "filepath": "database--rabbit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z"
                }
              }
            ],
            "name": "database--rabbit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabaseRabbit20",
          "filepath": "database--rabbit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z"
                }
              }
            ],
            "name": "database--rabbit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabaseRabbit16",
          "filepath": "database--rabbit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z"
                }
              }
            ],
            "name": "database--rabbit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabaseRabbit",
        "global": "DatabaseRabbit",
        "filepath": "DatabaseRabbit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "database--redis",
      "friendlyName": "IBM Cloud® Databases for Redis",
      "aliases": [
        "enterprise",
        "database",
        "Redis",
        "app",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/database--redis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.7156,22h-.115a3.371,3.371,0,0,1-3.3113,2.2764c-3.0124,0-4.6912-2.2764-4.6912-6.3006,0-4.0012,1.6788-6.2546,4.6912-6.2546a3.3049,3.3049,0,0,1,3.3113,2.2534h.115v-6.99h2.9433V24H25.7156Zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556,2.556,0,0,0,20.68,16.9636v2.07a2.5365,2.5365,0,0,0,2.5522,2.8052C24.6348,21.8384,25.7156,21.1257,25.7156,19.8838Z\"/>\n  <path d=\"M6.5576,24H3.5222V7.95h7.2434c2.92,0,4.7371,1.9316,4.7371,4.967a4.4237,4.4237,0,0,1-2.9893,4.553L15.8018,24h-3.38L9.4321,17.8145H6.5576Zm3.9092-8.738a1.6888,1.6888,0,0,0,1.8855-1.8167V12.3875a1.6722,1.6722,0,0,0-1.8855-1.7935H6.5576v4.668Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z\"/></svg>",
            "info": {},
            "path": "32/database--redis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DatabaseRedis32",
          "filepath": "database--redis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z"
                }
              }
            ],
            "name": "database--redis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DatabaseRedis24",
          "filepath": "database--redis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z"
                }
              }
            ],
            "name": "database--redis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DatabaseRedis20",
          "filepath": "database--redis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z"
                }
              }
            ],
            "name": "database--redis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DatabaseRedis16",
          "filepath": "database--redis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z"
                }
              }
            ],
            "name": "database--redis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DatabaseRedis",
        "global": "DatabaseRedis",
        "filepath": "DatabaseRedis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "datastore",
      "friendlyName": "Data store",
      "aliases": [
        "datastore",
        "data store",
        "repository"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/datastore.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>datastore</title><circle cx=\"23\" cy=\"23\" r=\"1\"/><rect x=\"8\" y=\"22\" width=\"12\" height=\"2\"/><circle cx=\"23\" cy=\"9\" r=\"1\"/><rect x=\"8\" y=\"8\" width=\"12\" height=\"2\"/><path d=\"M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"23\" r=\"1\"/><path d=\"M8 22H20V24H8z\"/><circle cx=\"23\" cy=\"9\" r=\"1\"/><path d=\"M8 8H20V10H8z\"/><path d=\"M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z\"/></svg>",
            "info": {},
            "path": "32/datastore.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Datastore32",
          "filepath": "datastore/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H20V24H8z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H20V10H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
                }
              }
            ],
            "name": "datastore",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Datastore24",
          "filepath": "datastore/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H20V24H8z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H20V10H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
                }
              }
            ],
            "name": "datastore",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Datastore20",
          "filepath": "datastore/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H20V24H8z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H20V10H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
                }
              }
            ],
            "name": "datastore",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Datastore16",
          "filepath": "datastore/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H20V24H8z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "9",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H20V10H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
                }
              }
            ],
            "name": "datastore",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Datastore",
        "global": "Datastore",
        "filepath": "Datastore.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 22H20V24H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "9",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 8H20V10H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "db2--buffer-pool",
      "friendlyName": "db2--buffer-pool",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/db2--buffer-pool.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26.338 31 24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31\"/>\n  <rect x=\"8\" y=\"14\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"14\" width=\"4\" height=\"2\"/>\n  <rect x=\"8\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"22\" width=\"4\" height=\"2\"/>\n  <path d=\"M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31zM8 14H12V16H8zM20 14H24V16H20zM8 18H12V20H8zM14 18H18V20H14zM14 22H18V24H14z\"/><path d=\"M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z\"/></svg>",
            "info": {},
            "path": "32/db2--buffer-pool.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Db2BufferPool32",
          "filepath": "db2--buffer-pool/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31zM8 14H12V16H8zM20 14H24V16H20zM8 18H12V20H8zM14 18H18V20H14zM14 22H18V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z"
                }
              }
            ],
            "name": "db2--buffer-pool",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Db2BufferPool24",
          "filepath": "db2--buffer-pool/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31zM8 14H12V16H8zM20 14H24V16H20zM8 18H12V20H8zM14 18H18V20H14zM14 22H18V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z"
                }
              }
            ],
            "name": "db2--buffer-pool",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Db2BufferPool20",
          "filepath": "db2--buffer-pool/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31zM8 14H12V16H8zM20 14H24V16H20zM8 18H12V20H8zM14 18H18V20H14zM14 22H18V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z"
                }
              }
            ],
            "name": "db2--buffer-pool",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Db2BufferPool16",
          "filepath": "db2--buffer-pool/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31zM8 14H12V16H8zM20 14H24V16H20zM8 18H12V20H8zM14 18H18V20H14zM14 22H18V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z"
                }
              }
            ],
            "name": "db2--buffer-pool",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Db2BufferPool",
        "global": "Db2BufferPool",
        "filepath": "Db2BufferPool.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31zM8 14H12V16H8zM20 14H24V16H20zM8 18H12V20H8zM14 18H18V20H14zM14 22H18V24H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "db2--data-sharing-group",
      "friendlyName": "db2--data-sharing-group",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/db2--data-sharing-group.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,28v-6.1699l2.5898,2.5801,1.4102-1.4102-5-5-5,5,1.4102,1.4102,2.5898-2.5801v6.1699c0,1.1025,.8972,2,2,2h9v-2H8Z\"/>\n  <path d=\"M25,17c-2.8506,0-5,1.29-5,3v7c0,1.71,2.1494,3,5,3s5-1.29,5-3v-7c0-1.71-2.1494-3-5-3Zm0,2c1.936,0,3,.751,3,1s-1.064,1-3,1-3-.751-3-1,1.064-1,3-1Zm0,9c-1.936,0-3-.751-3-1v-4.5796c.8264,.3623,1.8508,.5796,3,.5796s2.1736-.2173,3-.5796v4.5796c0,.249-1.064,1-3,1Z\"/>\n  <path d=\"M28.5898,7.5898l-2.5898,2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102,1.4102,5,5,5-5-1.4102-1.4102Z\"/>\n  <path d=\"M7,15c2.8506,0,5-1.29,5-3V5c0-1.71-2.1494-3-5-3S2,3.29,2,5v7c0,1.71,2.1494,3,5,3Zm0-11c1.936,0,3,.751,3,1s-1.064,1-3,1-3-.751-3-1,1.064-1,3-1Zm-3,3.4204c.8264,.3623,1.8508,.5796,3,.5796s2.1736-.2173,3-.5796v4.5796c0,.249-1.064,1-3,1s-3-.751-3-1V7.4204Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 28v-6.1699l2.5898 2.5801 1.4102-1.4102-5-5-5 5 1.4102 1.4102 2.5898-2.5801v6.1699c0 1.1025.8972 2 2 2h9v-2H8zM25 17c-2.8506 0-5 1.29-5 3v7c0 1.71 2.1494 3 5 3s5-1.29 5-3v-7c0-1.71-2.1494-3-5-3zm0 2c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm0 9c-1.936 0-3-.751-3-1v-4.5796c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1zM28.5898 7.5898l-2.5898 2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102 1.4102 5 5 5-5-1.4102-1.4102zM7 15c2.8506 0 5-1.29 5-3V5c0-1.71-2.1494-3-5-3S2 3.29 2 5v7c0 1.71 2.1494 3 5 3zm0-11c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm-3 3.4204c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1s-3-.751-3-1V7.4204z\"/></svg>",
            "info": {},
            "path": "32/db2--data-sharing-group.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Db2DataSharingGroup32",
          "filepath": "db2--data-sharing-group/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 28v-6.1699l2.5898 2.5801 1.4102-1.4102-5-5-5 5 1.4102 1.4102 2.5898-2.5801v6.1699c0 1.1025.8972 2 2 2h9v-2H8zM25 17c-2.8506 0-5 1.29-5 3v7c0 1.71 2.1494 3 5 3s5-1.29 5-3v-7c0-1.71-2.1494-3-5-3zm0 2c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm0 9c-1.936 0-3-.751-3-1v-4.5796c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1zM28.5898 7.5898l-2.5898 2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102 1.4102 5 5 5-5-1.4102-1.4102zM7 15c2.8506 0 5-1.29 5-3V5c0-1.71-2.1494-3-5-3S2 3.29 2 5v7c0 1.71 2.1494 3 5 3zm0-11c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm-3 3.4204c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1s-3-.751-3-1V7.4204z"
                }
              }
            ],
            "name": "db2--data-sharing-group",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Db2DataSharingGroup24",
          "filepath": "db2--data-sharing-group/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 28v-6.1699l2.5898 2.5801 1.4102-1.4102-5-5-5 5 1.4102 1.4102 2.5898-2.5801v6.1699c0 1.1025.8972 2 2 2h9v-2H8zM25 17c-2.8506 0-5 1.29-5 3v7c0 1.71 2.1494 3 5 3s5-1.29 5-3v-7c0-1.71-2.1494-3-5-3zm0 2c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm0 9c-1.936 0-3-.751-3-1v-4.5796c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1zM28.5898 7.5898l-2.5898 2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102 1.4102 5 5 5-5-1.4102-1.4102zM7 15c2.8506 0 5-1.29 5-3V5c0-1.71-2.1494-3-5-3S2 3.29 2 5v7c0 1.71 2.1494 3 5 3zm0-11c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm-3 3.4204c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1s-3-.751-3-1V7.4204z"
                }
              }
            ],
            "name": "db2--data-sharing-group",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Db2DataSharingGroup20",
          "filepath": "db2--data-sharing-group/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 28v-6.1699l2.5898 2.5801 1.4102-1.4102-5-5-5 5 1.4102 1.4102 2.5898-2.5801v6.1699c0 1.1025.8972 2 2 2h9v-2H8zM25 17c-2.8506 0-5 1.29-5 3v7c0 1.71 2.1494 3 5 3s5-1.29 5-3v-7c0-1.71-2.1494-3-5-3zm0 2c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm0 9c-1.936 0-3-.751-3-1v-4.5796c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1zM28.5898 7.5898l-2.5898 2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102 1.4102 5 5 5-5-1.4102-1.4102zM7 15c2.8506 0 5-1.29 5-3V5c0-1.71-2.1494-3-5-3S2 3.29 2 5v7c0 1.71 2.1494 3 5 3zm0-11c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm-3 3.4204c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1s-3-.751-3-1V7.4204z"
                }
              }
            ],
            "name": "db2--data-sharing-group",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Db2DataSharingGroup16",
          "filepath": "db2--data-sharing-group/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 28v-6.1699l2.5898 2.5801 1.4102-1.4102-5-5-5 5 1.4102 1.4102 2.5898-2.5801v6.1699c0 1.1025.8972 2 2 2h9v-2H8zM25 17c-2.8506 0-5 1.29-5 3v7c0 1.71 2.1494 3 5 3s5-1.29 5-3v-7c0-1.71-2.1494-3-5-3zm0 2c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm0 9c-1.936 0-3-.751-3-1v-4.5796c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1zM28.5898 7.5898l-2.5898 2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102 1.4102 5 5 5-5-1.4102-1.4102zM7 15c2.8506 0 5-1.29 5-3V5c0-1.71-2.1494-3-5-3S2 3.29 2 5v7c0 1.71 2.1494 3 5 3zm0-11c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm-3 3.4204c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1s-3-.751-3-1V7.4204z"
                }
              }
            ],
            "name": "db2--data-sharing-group",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Db2DataSharingGroup",
        "global": "Db2DataSharingGroup",
        "filepath": "Db2DataSharingGroup.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 28v-6.1699l2.5898 2.5801 1.4102-1.4102-5-5-5 5 1.4102 1.4102 2.5898-2.5801v6.1699c0 1.1025.8972 2 2 2h9v-2H8zM25 17c-2.8506 0-5 1.29-5 3v7c0 1.71 2.1494 3 5 3s5-1.29 5-3v-7c0-1.71-2.1494-3-5-3zm0 2c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm0 9c-1.936 0-3-.751-3-1v-4.5796c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1zM28.5898 7.5898l-2.5898 2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102 1.4102 5 5 5-5-1.4102-1.4102zM7 15c2.8506 0 5-1.29 5-3V5c0-1.71-2.1494-3-5-3S2 3.29 2 5v7c0 1.71 2.1494 3 5 3zm0-11c1.936 0 3 .751 3 1s-1.064 1-3 1-3-.751-3-1 1.064-1 3-1zm-3 3.4204c.8264.3623 1.8508.5796 3 .5796s2.1736-.2173 3-.5796v4.5796c0 .249-1.064 1-3 1s-3-.751-3-1V7.4204z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "db2--database",
      "friendlyName": "db2--database",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/db2--database.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z\"/></svg>",
            "info": {},
            "path": "32/db2--database.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Db2Database32",
          "filepath": "db2--database/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z"
                }
              }
            ],
            "name": "db2--database",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Db2Database24",
          "filepath": "db2--database/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z"
                }
              }
            ],
            "name": "db2--database",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Db2Database20",
          "filepath": "db2--database/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z"
                }
              }
            ],
            "name": "db2--database",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Db2Database16",
          "filepath": "db2--database/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z"
                }
              }
            ],
            "name": "db2--database",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Db2Database",
        "global": "Db2Database",
        "filepath": "Db2Database.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "debug",
      "friendlyName": "Debug",
      "aliases": [
        "bug",
        "beetle",
        "insect",
        "code bug"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/debug.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>debug</title><path d=\"M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z\"/></svg>",
            "info": {},
            "path": "32/debug.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Debug32",
          "filepath": "debug/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
                }
              }
            ],
            "name": "debug",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Debug24",
          "filepath": "debug/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
                }
              }
            ],
            "name": "debug",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Debug20",
          "filepath": "debug/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
                }
              }
            ],
            "name": "debug",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Debug16",
          "filepath": "debug/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
                }
              }
            ],
            "name": "debug",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Debug",
        "global": "Debug",
        "filepath": "Debug.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "decision-tree",
      "friendlyName": "Decision tree",
      "aliases": [
        "decision",
        "tree",
        "hierarchy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/decision-tree.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z\"/></svg>",
            "info": {},
            "path": "32/decision-tree.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DecisionTree32",
          "filepath": "decision-tree/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z"
                }
              }
            ],
            "name": "decision-tree",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DecisionTree24",
          "filepath": "decision-tree/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z"
                }
              }
            ],
            "name": "decision-tree",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DecisionTree20",
          "filepath": "decision-tree/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z"
                }
              }
            ],
            "name": "decision-tree",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DecisionTree16",
          "filepath": "decision-tree/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z"
                }
              }
            ],
            "name": "decision-tree",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DecisionTree",
        "global": "DecisionTree",
        "filepath": "DecisionTree.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "delivery",
      "friendlyName": "Delivery",
      "aliases": [
        "truck",
        "delivery",
        "transportation",
        "shopping",
        "van",
        "shipping",
        "ecommerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/delivery.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"4\" y=\"16\" width=\"12\" height=\"2\"/>\n  <rect x=\"2\" y=\"11\" width=\"10\" height=\"2\"/>\n  <path d=\"M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 16H16V18H4zM2 11H12V13H2z\"/><path d=\"M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z\"/></svg>",
            "info": {},
            "path": "32/delivery.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Delivery32",
          "filepath": "delivery/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 16H16V18H4zM2 11H12V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Delivery24",
          "filepath": "delivery/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 16H16V18H4zM2 11H12V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Delivery20",
          "filepath": "delivery/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 16H16V18H4zM2 11H12V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Delivery16",
          "filepath": "delivery/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 16H16V18H4zM2 11H12V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Delivery",
        "global": "Delivery",
        "filepath": "Delivery.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 16H16V18H4zM2 11H12V13H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "delivery--add",
      "friendlyName": "Delivery add",
      "aliases": [
        "truck",
        "delivery",
        "transportation",
        "shopping",
        "van",
        "shipping",
        "ecommerce",
        "plus",
        "add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/delivery--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"12 6 8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6\"/>\n  <path d=\"M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z\"/><path d=\"M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z\"/></svg>",
            "info": {},
            "path": "32/delivery--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeliveryAdd32",
          "filepath": "delivery--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeliveryAdd24",
          "filepath": "delivery--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeliveryAdd20",
          "filepath": "delivery--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeliveryAdd16",
          "filepath": "delivery--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "DeliveryAdd",
        "global": "DeliveryAdd",
        "filepath": "DeliveryAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "delivery--parcel",
      "friendlyName": "Delivery parcel",
      "aliases": [
        "delivery",
        "transportation",
        "shopping",
        "parcel",
        "shipping",
        "ecommerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/delivery--parcel.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z\"/>\n  <rect x=\"2\" y=\"14\" width=\"8\" height=\"2\" transform=\"translate(12 30) rotate(-180)\"/>\n  <rect x=\"4\" y=\"22\" width=\"8\" height=\"2\" transform=\"translate(16 46) rotate(-180)\"/>\n  <rect x=\"6\" y=\"18\" width=\"8\" height=\"2\" transform=\"translate(20 38) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z\"/><path d=\"M2 14H10V16H2z\" transform=\"rotate(-180 6 15)\"/><path d=\"M4 22H12V24H4z\" transform=\"rotate(-180 8 23)\"/><path d=\"M6 18H14V20H6z\" transform=\"rotate(-180 10 19)\"/></svg>",
            "info": {},
            "path": "32/delivery--parcel.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeliveryParcel32",
          "filepath": "delivery--parcel/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 14H10V16H2z",
                  "transform": "rotate(-180 6 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H12V24H4z",
                  "transform": "rotate(-180 8 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H14V20H6z",
                  "transform": "rotate(-180 10 19)"
                }
              }
            ],
            "name": "delivery--parcel",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeliveryParcel24",
          "filepath": "delivery--parcel/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 14H10V16H2z",
                  "transform": "rotate(-180 6 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H12V24H4z",
                  "transform": "rotate(-180 8 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H14V20H6z",
                  "transform": "rotate(-180 10 19)"
                }
              }
            ],
            "name": "delivery--parcel",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeliveryParcel20",
          "filepath": "delivery--parcel/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 14H10V16H2z",
                  "transform": "rotate(-180 6 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H12V24H4z",
                  "transform": "rotate(-180 8 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H14V20H6z",
                  "transform": "rotate(-180 10 19)"
                }
              }
            ],
            "name": "delivery--parcel",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeliveryParcel16",
          "filepath": "delivery--parcel/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 14H10V16H2z",
                  "transform": "rotate(-180 6 15)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H12V24H4z",
                  "transform": "rotate(-180 8 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H14V20H6z",
                  "transform": "rotate(-180 10 19)"
                }
              }
            ],
            "name": "delivery--parcel",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "DeliveryParcel",
        "global": "DeliveryParcel",
        "filepath": "DeliveryParcel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 14H10V16H2z",
                    "transform": "rotate(-180 6 15)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 22H12V24H4z",
                    "transform": "rotate(-180 8 23)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 18H14V20H6z",
                    "transform": "rotate(-180 10 19)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "delivery-truck",
      "friendlyName": "Delivery truck",
      "aliases": [
        "truck",
        "delivery",
        "transportation",
        "shopping",
        "van",
        "shipping",
        "ecommerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/delivery-truck.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>delivery-truck</title><path d=\"M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z\"/></svg>",
            "info": {},
            "path": "32/delivery-truck.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeliveryTruck32",
          "filepath": "delivery-truck/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery-truck",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeliveryTruck24",
          "filepath": "delivery-truck/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery-truck",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeliveryTruck20",
          "filepath": "delivery-truck/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery-truck",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeliveryTruck16",
          "filepath": "delivery-truck/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z"
                }
              }
            ],
            "name": "delivery-truck",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DeliveryTruck",
        "global": "DeliveryTruck",
        "filepath": "DeliveryTruck.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "denominate",
      "friendlyName": "Denominate",
      "aliases": [
        "denominate",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/denominate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>denominate</title><path d=\"M25,23H19a3,3,0,0,0-3,3v2h2V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V26A3,3,0,0,0,25,23Z\"/><path d=\"M18,18a4,4,0,1,0,4-4A4,4,0,0,0,18,18Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,24,18Z\"/><polygon points=\"15 15.415 13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415\"/><path d=\"M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z\"/><path d=\"M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/denominate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthDenominate32",
          "filepath": "watson-health/denominate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "denominate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthDenominate24",
          "filepath": "watson-health/denominate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "denominate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthDenominate20",
          "filepath": "watson-health/denominate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "denominate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthDenominate16",
          "filepath": "watson-health/denominate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "denominate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Denominate",
        "global": "WatsonHealthDenominate",
        "filepath": "watson-health/Denominate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "departure",
      "friendlyName": "Departure",
      "aliases": [
        "plane",
        "airplane",
        "vacation",
        "travel",
        "journey",
        "leave"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/departure.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>departure</title><rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/><path d=\"M13.48,5.15l5.69,8.14.8,1.15,1.35-.36,4.52-1.21a2.13,2.13,0,0,1,1.12,0A1.84,1.84,0,0,1,28.23,14,1.87,1.87,0,0,1,27,16.45l-18.71,5a1.78,1.78,0,0,1-1,0A1.87,1.87,0,0,1,6,20.12l-.25-.93L5,16.38l-.74-2.74,1.44-.39L8,16.35l.81,1.08,1.31-.35,2.8-.75,1.94-.52-.52-1.93L12.08,5.52l1.4-.37M14.16,3a1.06,1.06,0,0,0-.5,0l-3.09.83A1,1,0,0,0,9.89,5l2.5,9.36-2.81.75L6.85,11.5a1,1,0,0,0-.52-.36,1.06,1.06,0,0,0-.5,0L2.72,12A1,1,0,0,0,2,13.16L3,16.9l.75,2.8.25.94a3.87,3.87,0,0,0,2.74,2.74,3.91,3.91,0,0,0,2,0l18.7-5a3.84,3.84,0,0,0,0-7.44,4.27,4.27,0,0,0-2.16,0l-4.51,1.21L14.7,3.41A1,1,0,0,0,14.16,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 011.12 0A1.84 1.84 0 0128.23 14 1.87 1.87 0 0127 16.45l-18.71 5a1.78 1.78 0 01-1 0A1.87 1.87 0 016 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39L8 16.35l.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93L12.08 5.52l1.4-.37M14.16 3a1.06 1.06 0 00-.5 0l-3.09.83A1 1 0 009.89 5l2.5 9.36-2.81.75L6.85 11.5a1 1 0 00-.52-.36 1.06 1.06 0 00-.5 0L2.72 12A1 1 0 002 13.16L3 16.9l.75 2.8.25.94a3.87 3.87 0 002.74 2.74 3.91 3.91 0 002 0l18.7-5a3.84 3.84 0 000-7.44 4.27 4.27 0 00-2.16 0l-4.51 1.21L14.7 3.41A1 1 0 0014.16 3z\"/></svg>",
            "info": {},
            "path": "32/departure.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Departure32",
          "filepath": "departure/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 011.12 0A1.84 1.84 0 0128.23 14 1.87 1.87 0 0127 16.45l-18.71 5a1.78 1.78 0 01-1 0A1.87 1.87 0 016 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39L8 16.35l.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93L12.08 5.52l1.4-.37M14.16 3a1.06 1.06 0 00-.5 0l-3.09.83A1 1 0 009.89 5l2.5 9.36-2.81.75L6.85 11.5a1 1 0 00-.52-.36 1.06 1.06 0 00-.5 0L2.72 12A1 1 0 002 13.16L3 16.9l.75 2.8.25.94a3.87 3.87 0 002.74 2.74 3.91 3.91 0 002 0l18.7-5a3.84 3.84 0 000-7.44 4.27 4.27 0 00-2.16 0l-4.51 1.21L14.7 3.41A1 1 0 0014.16 3z"
                }
              }
            ],
            "name": "departure",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Departure24",
          "filepath": "departure/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 011.12 0A1.84 1.84 0 0128.23 14 1.87 1.87 0 0127 16.45l-18.71 5a1.78 1.78 0 01-1 0A1.87 1.87 0 016 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39L8 16.35l.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93L12.08 5.52l1.4-.37M14.16 3a1.06 1.06 0 00-.5 0l-3.09.83A1 1 0 009.89 5l2.5 9.36-2.81.75L6.85 11.5a1 1 0 00-.52-.36 1.06 1.06 0 00-.5 0L2.72 12A1 1 0 002 13.16L3 16.9l.75 2.8.25.94a3.87 3.87 0 002.74 2.74 3.91 3.91 0 002 0l18.7-5a3.84 3.84 0 000-7.44 4.27 4.27 0 00-2.16 0l-4.51 1.21L14.7 3.41A1 1 0 0014.16 3z"
                }
              }
            ],
            "name": "departure",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Departure20",
          "filepath": "departure/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 011.12 0A1.84 1.84 0 0128.23 14 1.87 1.87 0 0127 16.45l-18.71 5a1.78 1.78 0 01-1 0A1.87 1.87 0 016 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39L8 16.35l.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93L12.08 5.52l1.4-.37M14.16 3a1.06 1.06 0 00-.5 0l-3.09.83A1 1 0 009.89 5l2.5 9.36-2.81.75L6.85 11.5a1 1 0 00-.52-.36 1.06 1.06 0 00-.5 0L2.72 12A1 1 0 002 13.16L3 16.9l.75 2.8.25.94a3.87 3.87 0 002.74 2.74 3.91 3.91 0 002 0l18.7-5a3.84 3.84 0 000-7.44 4.27 4.27 0 00-2.16 0l-4.51 1.21L14.7 3.41A1 1 0 0014.16 3z"
                }
              }
            ],
            "name": "departure",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Departure16",
          "filepath": "departure/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 011.12 0A1.84 1.84 0 0128.23 14 1.87 1.87 0 0127 16.45l-18.71 5a1.78 1.78 0 01-1 0A1.87 1.87 0 016 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39L8 16.35l.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93L12.08 5.52l1.4-.37M14.16 3a1.06 1.06 0 00-.5 0l-3.09.83A1 1 0 009.89 5l2.5 9.36-2.81.75L6.85 11.5a1 1 0 00-.52-.36 1.06 1.06 0 00-.5 0L2.72 12A1 1 0 002 13.16L3 16.9l.75 2.8.25.94a3.87 3.87 0 002.74 2.74 3.91 3.91 0 002 0l18.7-5a3.84 3.84 0 000-7.44 4.27 4.27 0 00-2.16 0l-4.51 1.21L14.7 3.41A1 1 0 0014.16 3z"
                }
              }
            ],
            "name": "departure",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Departure",
        "global": "Departure",
        "filepath": "Departure.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 011.12 0A1.84 1.84 0 0128.23 14 1.87 1.87 0 0127 16.45l-18.71 5a1.78 1.78 0 01-1 0A1.87 1.87 0 016 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39L8 16.35l.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93L12.08 5.52l1.4-.37M14.16 3a1.06 1.06 0 00-.5 0l-3.09.83A1 1 0 009.89 5l2.5 9.36-2.81.75L6.85 11.5a1 1 0 00-.52-.36 1.06 1.06 0 00-.5 0L2.72 12A1 1 0 002 13.16L3 16.9l.75 2.8.25.94a3.87 3.87 0 002.74 2.74 3.91 3.91 0 002 0l18.7-5a3.84 3.84 0 000-7.44 4.27 4.27 0 00-2.16 0l-4.51 1.21L14.7 3.41A1 1 0 0014.16 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deploy",
      "friendlyName": "Deploy",
      "aliases": [
        "deploy",
        "launch",
        "utilize"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deploy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z\"/>\n  <path d=\"M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z\"/>\n  <rect id=\"_Transparent_Rectangle\" data-name=\" Transparent Rectangle\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z\"/><path d=\"M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z\"/></svg>",
            "info": {},
            "path": "32/deploy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Deploy32",
          "filepath": "deploy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z"
                }
              }
            ],
            "name": "deploy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Deploy24",
          "filepath": "deploy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z"
                }
              }
            ],
            "name": "deploy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Deploy20",
          "filepath": "deploy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z"
                }
              }
            ],
            "name": "deploy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Deploy16",
          "filepath": "deploy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z"
                }
              }
            ],
            "name": "deploy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Deploy",
        "global": "Deploy",
        "filepath": "Deploy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deploy-rules",
      "friendlyName": "Deploy rules",
      "aliases": [
        "rules",
        "deploy",
        "document",
        "instruction",
        "deploy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deploy-rules.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>deploy-rules</title><polygon points=\"18 4 12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4\"/><rect x=\"8\" y=\"18\" width=\"7\" height=\"2\"/><rect x=\"8\" y=\"22\" width=\"16\" height=\"2\"/><rect x=\"8\" y=\"26\" width=\"16\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4zM8 18H15V20H8zM8 22H24V24H8zM8 26H24V28H8z\"/></svg>",
            "info": {},
            "path": "32/deploy-rules.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeployRules32",
          "filepath": "deploy-rules/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4zM8 18H15V20H8zM8 22H24V24H8zM8 26H24V28H8z"
                }
              }
            ],
            "name": "deploy-rules",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeployRules24",
          "filepath": "deploy-rules/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4zM8 18H15V20H8zM8 22H24V24H8zM8 26H24V28H8z"
                }
              }
            ],
            "name": "deploy-rules",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeployRules20",
          "filepath": "deploy-rules/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4zM8 18H15V20H8zM8 22H24V24H8zM8 26H24V28H8z"
                }
              }
            ],
            "name": "deploy-rules",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeployRules16",
          "filepath": "deploy-rules/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4zM8 18H15V20H8zM8 22H24V24H8zM8 26H24V28H8z"
                }
              }
            ],
            "name": "deploy-rules",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "DeployRules",
        "global": "DeployRules",
        "filepath": "DeployRules.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4zM8 18H15V20H8zM8 22H24V24H8zM8 26H24V28H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-pattern",
      "friendlyName": "Deployment pattern",
      "aliases": [
        "deployment",
        "pattern"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-pattern.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,20H4.73A1.9735,1.9735,0,0,0,3,19a2,2,0,0,0,0,4A1.9735,1.9735,0,0,0,4.73,22H8Z\"/>\n  <path d=\"M29,9a1.9735,1.9735,0,0,0-1.73,1H24v2h3.27A1.9991,1.9991,0,1,0,29,9Z\"/>\n  <path d=\"M25.4141,5,21,.5859,16.5859,5,20,8.4141V18h2V8.4141ZM21,3.4141,22.5859,5,21,6.5859,19.4141,5Z\"/>\n  <path d=\"M12,23.5859V14H10v9.5859L6.5859,27,11,31.4141,15.4141,27ZM9.4141,27,11,25.4141,12.5859,27,11,28.5859Z\"/>\n  <path d=\"M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z\"/>\n  <path d=\"M13,3A2,2,0,0,0,9,3,1.9733,1.9733,0,0,0,10,4.73V8h2V4.73A1.9733,1.9733,0,0,0,13,3Z\"/>\n  <path d=\"M22,27.2705V24H20v3.27a2,2,0,1,0,2,0Z\"/>\n  <path d=\"M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 20H4.73A1.9735 1.9735 0 003 19a2 2 0 000 4A1.9735 1.9735 0 004.73 22H8zM29 9a1.9735 1.9735 0 00-1.73 1H24v2h3.27A1.9991 1.9991 0 1029 9z\"/><path d=\"M25.4141 5L21 .5859 16.5859 5 20 8.4141V18h2V8.4141zM21 3.4141L22.5859 5 21 6.5859 19.4141 5zM12 23.5859V14H10v9.5859L6.5859 27 11 31.4141 15.4141 27zM9.4141 27L11 25.4141 12.5859 27 11 28.5859z\"/><path d=\"M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z\"/><path d=\"M13 3A2 2 0 009 3 1.9733 1.9733 0 0010 4.73V8h2V4.73A1.9733 1.9733 0 0013 3zM22 27.2705V24H20v3.27a2 2 0 102 0z\"/><path d=\"M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z\"/></svg>",
            "info": {},
            "path": "32/deployment-pattern.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentPattern32",
          "filepath": "deployment-pattern/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H4.73A1.9735 1.9735 0 003 19a2 2 0 000 4A1.9735 1.9735 0 004.73 22H8zM29 9a1.9735 1.9735 0 00-1.73 1H24v2h3.27A1.9991 1.9991 0 1029 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4141 5L21 .5859 16.5859 5 20 8.4141V18h2V8.4141zM21 3.4141L22.5859 5 21 6.5859 19.4141 5zM12 23.5859V14H10v9.5859L6.5859 27 11 31.4141 15.4141 27zM9.4141 27L11 25.4141 12.5859 27 11 28.5859z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 3A2 2 0 009 3 1.9733 1.9733 0 0010 4.73V8h2V4.73A1.9733 1.9733 0 0013 3zM22 27.2705V24H20v3.27a2 2 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z"
                }
              }
            ],
            "name": "deployment-pattern",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentPattern24",
          "filepath": "deployment-pattern/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H4.73A1.9735 1.9735 0 003 19a2 2 0 000 4A1.9735 1.9735 0 004.73 22H8zM29 9a1.9735 1.9735 0 00-1.73 1H24v2h3.27A1.9991 1.9991 0 1029 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4141 5L21 .5859 16.5859 5 20 8.4141V18h2V8.4141zM21 3.4141L22.5859 5 21 6.5859 19.4141 5zM12 23.5859V14H10v9.5859L6.5859 27 11 31.4141 15.4141 27zM9.4141 27L11 25.4141 12.5859 27 11 28.5859z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 3A2 2 0 009 3 1.9733 1.9733 0 0010 4.73V8h2V4.73A1.9733 1.9733 0 0013 3zM22 27.2705V24H20v3.27a2 2 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z"
                }
              }
            ],
            "name": "deployment-pattern",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentPattern20",
          "filepath": "deployment-pattern/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H4.73A1.9735 1.9735 0 003 19a2 2 0 000 4A1.9735 1.9735 0 004.73 22H8zM29 9a1.9735 1.9735 0 00-1.73 1H24v2h3.27A1.9991 1.9991 0 1029 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4141 5L21 .5859 16.5859 5 20 8.4141V18h2V8.4141zM21 3.4141L22.5859 5 21 6.5859 19.4141 5zM12 23.5859V14H10v9.5859L6.5859 27 11 31.4141 15.4141 27zM9.4141 27L11 25.4141 12.5859 27 11 28.5859z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 3A2 2 0 009 3 1.9733 1.9733 0 0010 4.73V8h2V4.73A1.9733 1.9733 0 0013 3zM22 27.2705V24H20v3.27a2 2 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z"
                }
              }
            ],
            "name": "deployment-pattern",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentPattern16",
          "filepath": "deployment-pattern/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H4.73A1.9735 1.9735 0 003 19a2 2 0 000 4A1.9735 1.9735 0 004.73 22H8zM29 9a1.9735 1.9735 0 00-1.73 1H24v2h3.27A1.9991 1.9991 0 1029 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4141 5L21 .5859 16.5859 5 20 8.4141V18h2V8.4141zM21 3.4141L22.5859 5 21 6.5859 19.4141 5zM12 23.5859V14H10v9.5859L6.5859 27 11 31.4141 15.4141 27zM9.4141 27L11 25.4141 12.5859 27 11 28.5859z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 3A2 2 0 009 3 1.9733 1.9733 0 0010 4.73V8h2V4.73A1.9733 1.9733 0 0013 3zM22 27.2705V24H20v3.27a2 2 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z"
                }
              }
            ],
            "name": "deployment-pattern",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "DeploymentPattern",
        "global": "DeploymentPattern",
        "filepath": "DeploymentPattern.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 20H4.73A1.9735 1.9735 0 003 19a2 2 0 000 4A1.9735 1.9735 0 004.73 22H8zM29 9a1.9735 1.9735 0 00-1.73 1H24v2h3.27A1.9991 1.9991 0 1029 9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.4141 5L21 .5859 16.5859 5 20 8.4141V18h2V8.4141zM21 3.4141L22.5859 5 21 6.5859 19.4141 5zM12 23.5859V14H10v9.5859L6.5859 27 11 31.4141 15.4141 27zM9.4141 27L11 25.4141 12.5859 27 11 28.5859z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 3A2 2 0 009 3 1.9733 1.9733 0 0010 4.73V8h2V4.73A1.9733 1.9733 0 0013 3zM22 27.2705V24H20v3.27a2 2 0 102 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-policy",
      "friendlyName": "Deployment policy",
      "aliases": [
        "deployment",
        "policy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-policy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"19 16 19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16\"/>\n  <polygon points=\"17 12 15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12\"/>\n  <path d=\"M17,20.1011V18a4.0045,4.0045,0,0,0-4-4H5.8281l2.293-2.293L6.707,10.293,2,15l4.707,4.707,1.4141-1.414L5.8281,16H13a2.0025,2.0025,0,0,1,2,2v2.1011a5,5,0,1,0,2,0ZM16,28a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16zM17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12zM17 20.1011V18a4.0045 4.0045 0 00-4-4H5.8281l2.293-2.293L6.707 10.293 2 15l4.707 4.707 1.4141-1.414L5.8281 16H13a2.0025 2.0025 0 012 2v2.1011a5 5 0 102 0zM16 28a3 3 0 113-3A3.0033 3.0033 0 0116 28z\"/></svg>",
            "info": {},
            "path": "32/deployment-policy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentPolicy32",
          "filepath": "deployment-policy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16zM17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12zM17 20.1011V18a4.0045 4.0045 0 00-4-4H5.8281l2.293-2.293L6.707 10.293 2 15l4.707 4.707 1.4141-1.414L5.8281 16H13a2.0025 2.0025 0 012 2v2.1011a5 5 0 102 0zM16 28a3 3 0 113-3A3.0033 3.0033 0 0116 28z"
                }
              }
            ],
            "name": "deployment-policy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentPolicy24",
          "filepath": "deployment-policy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16zM17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12zM17 20.1011V18a4.0045 4.0045 0 00-4-4H5.8281l2.293-2.293L6.707 10.293 2 15l4.707 4.707 1.4141-1.414L5.8281 16H13a2.0025 2.0025 0 012 2v2.1011a5 5 0 102 0zM16 28a3 3 0 113-3A3.0033 3.0033 0 0116 28z"
                }
              }
            ],
            "name": "deployment-policy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentPolicy20",
          "filepath": "deployment-policy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16zM17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12zM17 20.1011V18a4.0045 4.0045 0 00-4-4H5.8281l2.293-2.293L6.707 10.293 2 15l4.707 4.707 1.4141-1.414L5.8281 16H13a2.0025 2.0025 0 012 2v2.1011a5 5 0 102 0zM16 28a3 3 0 113-3A3.0033 3.0033 0 0116 28z"
                }
              }
            ],
            "name": "deployment-policy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentPolicy16",
          "filepath": "deployment-policy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16zM17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12zM17 20.1011V18a4.0045 4.0045 0 00-4-4H5.8281l2.293-2.293L6.707 10.293 2 15l4.707 4.707 1.4141-1.414L5.8281 16H13a2.0025 2.0025 0 012 2v2.1011a5 5 0 102 0zM16 28a3 3 0 113-3A3.0033 3.0033 0 0116 28z"
                }
              }
            ],
            "name": "deployment-policy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "DeploymentPolicy",
        "global": "DeploymentPolicy",
        "filepath": "DeploymentPolicy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16zM17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12zM17 20.1011V18a4.0045 4.0045 0 00-4-4H5.8281l2.293-2.293L6.707 10.293 2 15l4.707 4.707 1.4141-1.414L5.8281 16H13a2.0025 2.0025 0 012 2v2.1011a5 5 0 102 0zM16 28a3 3 0 113-3A3.0033 3.0033 0 0116 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--data",
      "friendlyName": "Deployment unit data",
      "aliases": [
        "systems",
        "deployment",
        "data",
        "D"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--data.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--data.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitData32",
          "filepath": "deployment-unit--data/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z"
                }
              }
            ],
            "name": "deployment-unit--data",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitData24",
          "filepath": "deployment-unit--data/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z"
                }
              }
            ],
            "name": "deployment-unit--data",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitData20",
          "filepath": "deployment-unit--data/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z"
                }
              }
            ],
            "name": "deployment-unit--data",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitData16",
          "filepath": "deployment-unit--data/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z"
                }
              }
            ],
            "name": "deployment-unit--data",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitData",
        "global": "DeploymentUnitData",
        "filepath": "DeploymentUnitData.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--execution",
      "friendlyName": "Deployment unit execution",
      "aliases": [
        "systems",
        "deployment",
        "execution",
        "E"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--execution.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"20 11 20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--execution.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitExecution32",
          "filepath": "deployment-unit--execution/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              }
            ],
            "name": "deployment-unit--execution",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitExecution24",
          "filepath": "deployment-unit--execution/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              }
            ],
            "name": "deployment-unit--execution",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitExecution20",
          "filepath": "deployment-unit--execution/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              }
            ],
            "name": "deployment-unit--execution",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitExecution16",
          "filepath": "deployment-unit--execution/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              }
            ],
            "name": "deployment-unit--execution",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitExecution",
        "global": "DeploymentUnitExecution",
        "filepath": "DeploymentUnitExecution.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--installation",
      "friendlyName": "Deployment unit installation",
      "aliases": [
        "systems",
        "deployment",
        "installation",
        "I"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--installation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--installation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitInstallation32",
          "filepath": "deployment-unit--installation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "deployment-unit--installation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitInstallation24",
          "filepath": "deployment-unit--installation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "deployment-unit--installation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitInstallation20",
          "filepath": "deployment-unit--installation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "deployment-unit--installation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitInstallation16",
          "filepath": "deployment-unit--installation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "deployment-unit--installation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitInstallation",
        "global": "DeploymentUnitInstallation",
        "filepath": "DeploymentUnitInstallation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--presentation",
      "friendlyName": "Deployment unit presentation",
      "aliases": [
        "systems",
        "deployment",
        "presentation",
        "P"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--presentation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--presentation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitPresentation32",
          "filepath": "deployment-unit--presentation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z"
                }
              }
            ],
            "name": "deployment-unit--presentation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitPresentation24",
          "filepath": "deployment-unit--presentation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z"
                }
              }
            ],
            "name": "deployment-unit--presentation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitPresentation20",
          "filepath": "deployment-unit--presentation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z"
                }
              }
            ],
            "name": "deployment-unit--presentation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitPresentation16",
          "filepath": "deployment-unit--presentation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z"
                }
              }
            ],
            "name": "deployment-unit--presentation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitPresentation",
        "global": "DeploymentUnitPresentation",
        "filepath": "DeploymentUnitPresentation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--technical--data",
      "friendlyName": "Deployment unit technical data",
      "aliases": [
        "systems",
        "deployment",
        "technical",
        "data",
        "TD"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--technical--data.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,23H17V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,21,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H19Z\"/>\n  <polygon points=\"7 11 10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 23H17V9h4a4.0045 4.0045 0 014 4v6A4.0042 4.0042 0 0121 23zm-2-2h2a2.0023 2.0023 0 002-2V13a2.002 2.002 0 00-2-2H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--technical--data.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitTechnicalData32",
          "filepath": "deployment-unit--technical--data/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 23H17V9h4a4.0045 4.0045 0 014 4v6A4.0042 4.0042 0 0121 23zm-2-2h2a2.0023 2.0023 0 002-2V13a2.002 2.002 0 00-2-2H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--data",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitTechnicalData24",
          "filepath": "deployment-unit--technical--data/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 23H17V9h4a4.0045 4.0045 0 014 4v6A4.0042 4.0042 0 0121 23zm-2-2h2a2.0023 2.0023 0 002-2V13a2.002 2.002 0 00-2-2H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--data",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitTechnicalData20",
          "filepath": "deployment-unit--technical--data/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 23H17V9h4a4.0045 4.0045 0 014 4v6A4.0042 4.0042 0 0121 23zm-2-2h2a2.0023 2.0023 0 002-2V13a2.002 2.002 0 00-2-2H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--data",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitTechnicalData16",
          "filepath": "deployment-unit--technical--data/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 23H17V9h4a4.0045 4.0045 0 014 4v6A4.0042 4.0042 0 0121 23zm-2-2h2a2.0023 2.0023 0 002-2V13a2.002 2.002 0 00-2-2H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--data",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitTechnicalData",
        "global": "DeploymentUnitTechnicalData",
        "filepath": "DeploymentUnitTechnicalData.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 23H17V9h4a4.0045 4.0045 0 014 4v6A4.0042 4.0042 0 0121 23zm-2-2h2a2.0023 2.0023 0 002-2V13a2.002 2.002 0 00-2-2H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--technical--execution",
      "friendlyName": "Deployment unit technical execution",
      "aliases": [
        "systems",
        "deployment",
        "technical",
        "execution",
        "TE"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--technical--execution.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"25 11 25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11\"/>\n  <polygon points=\"7 11 10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--technical--execution.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitTechnicalExecution32",
          "filepath": "deployment-unit--technical--execution/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--execution",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitTechnicalExecution24",
          "filepath": "deployment-unit--technical--execution/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--execution",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitTechnicalExecution20",
          "filepath": "deployment-unit--technical--execution/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--execution",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitTechnicalExecution16",
          "filepath": "deployment-unit--technical--execution/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--execution",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitTechnicalExecution",
        "global": "DeploymentUnitTechnicalExecution",
        "filepath": "DeploymentUnitTechnicalExecution.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--technical--installation",
      "friendlyName": "Deployment unit technical installation",
      "aliases": [
        "systems",
        "deployment",
        "technical",
        "installation",
        "TI"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--technical--installation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11\"/>\n  <polygon points=\"7 11 10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--technical--installation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitTechnicalInstallation32",
          "filepath": "deployment-unit--technical--installation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--installation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitTechnicalInstallation24",
          "filepath": "deployment-unit--technical--installation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--installation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitTechnicalInstallation20",
          "filepath": "deployment-unit--technical--installation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--installation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitTechnicalInstallation16",
          "filepath": "deployment-unit--technical--installation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--installation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitTechnicalInstallation",
        "global": "DeploymentUnitTechnicalInstallation",
        "filepath": "DeploymentUnitTechnicalInstallation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "deployment-unit--technical--presentation",
      "friendlyName": "Deployment unit technical presentation",
      "aliases": [
        "systems",
        "deployment",
        "technical",
        "presentation",
        "TP"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/deployment-unit--technical--presentation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19,23H17V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H19Zm0-7h4V10.9985H19Z\"/>\n  <polygon points=\"7 11 10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 23H17V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H19zm0-7h4V10.9985H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z\"/></svg>",
            "info": {},
            "path": "32/deployment-unit--technical--presentation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeploymentUnitTechnicalPresentation32",
          "filepath": "deployment-unit--technical--presentation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H17V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H19zm0-7h4V10.9985H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--presentation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeploymentUnitTechnicalPresentation24",
          "filepath": "deployment-unit--technical--presentation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H17V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H19zm0-7h4V10.9985H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--presentation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeploymentUnitTechnicalPresentation20",
          "filepath": "deployment-unit--technical--presentation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H17V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H19zm0-7h4V10.9985H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--presentation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeploymentUnitTechnicalPresentation16",
          "filepath": "deployment-unit--technical--presentation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H17V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H19zm0-7h4V10.9985H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                }
              }
            ],
            "name": "deployment-unit--technical--presentation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DeploymentUnitTechnicalPresentation",
        "global": "DeploymentUnitTechnicalPresentation",
        "filepath": "DeploymentUnitTechnicalPresentation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 23H17V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H19zm0-7h4V10.9985H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "desk--adjustable",
      "friendlyName": "Desk adjustable",
      "aliases": [
        "desk",
        "adjustable",
        "standing desk",
        "stand up",
        "technology",
        "workplace"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/desk--adjustable.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17 27.172 17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172\"/>\n  <path d=\"M30,12H2v8H4V30H6V20H26V30h2V20h2Zm-2,6H4V14H28Z\"/>\n  <polygon points=\"15 4.828 15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z\"/><path d=\"M30 12H2v8H4V30H6V20H26V30h2V20h2zm-2 6H4V14H28zM15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z\"/></svg>",
            "info": {},
            "path": "32/desk--adjustable.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DeskAdjustable32",
          "filepath": "desk--adjustable/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 12H2v8H4V30H6V20H26V30h2V20h2zm-2 6H4V14H28zM15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z"
                }
              }
            ],
            "name": "desk--adjustable",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DeskAdjustable24",
          "filepath": "desk--adjustable/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 12H2v8H4V30H6V20H26V30h2V20h2zm-2 6H4V14H28zM15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z"
                }
              }
            ],
            "name": "desk--adjustable",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DeskAdjustable20",
          "filepath": "desk--adjustable/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 12H2v8H4V30H6V20H26V30h2V20h2zm-2 6H4V14H28zM15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z"
                }
              }
            ],
            "name": "desk--adjustable",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DeskAdjustable16",
          "filepath": "desk--adjustable/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 12H2v8H4V30H6V20H26V30h2V20h2zm-2 6H4V14H28zM15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z"
                }
              }
            ],
            "name": "desk--adjustable",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "DeskAdjustable",
        "global": "DeskAdjustable",
        "filepath": "DeskAdjustable.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 12H2v8H4V30H6V20H26V30h2V20h2zm-2 6H4V14H28zM15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "development",
      "friendlyName": "Development",
      "aliases": [
        "build",
        "pixels",
        "squares",
        "structure",
        "code",
        "html",
        "code",
        "grid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/development.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>development</title><path d=\"M8,4V8H4V4H8M2,2v8h8V2Z\"/><path d=\"M18,7v4H14V7h4M12,5v8h8V5Z\"/><path d=\"M8,16v4H4V16H8M2,14v8h8V14Z\"/><path d=\"M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 4V8H4V4H8M2 2v8h8V2zM18 7v4H14V7h4M12 5v8h8V5zM8 16v4H4V16H8M2 14v8h8V14z\"/><path d=\"M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z\"/></svg>",
            "info": {},
            "path": "32/development.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Development32",
          "filepath": "development/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 4V8H4V4H8M2 2v8h8V2zM18 7v4H14V7h4M12 5v8h8V5zM8 16v4H4V16H8M2 14v8h8V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z"
                }
              }
            ],
            "name": "development",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Development24",
          "filepath": "development/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 4V8H4V4H8M2 2v8h8V2zM18 7v4H14V7h4M12 5v8h8V5zM8 16v4H4V16H8M2 14v8h8V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z"
                }
              }
            ],
            "name": "development",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Development20",
          "filepath": "development/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 4V8H4V4H8M2 2v8h8V2zM18 7v4H14V7h4M12 5v8h8V5zM8 16v4H4V16H8M2 14v8h8V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z"
                }
              }
            ],
            "name": "development",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Development16",
          "filepath": "development/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 4V8H4V4H8M2 2v8h8V2zM18 7v4H14V7h4M12 5v8h8V5zM8 16v4H4V16H8M2 14v8h8V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z"
                }
              }
            ],
            "name": "development",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Development",
        "global": "Development",
        "filepath": "Development.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 4V8H4V4H8M2 2v8h8V2zM18 7v4H14V7h4M12 5v8h8V5zM8 16v4H4V16H8M2 14v8h8V14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "devices",
      "friendlyName": "Devices",
      "aliases": [
        "monitor",
        "screen",
        "devices",
        "compatibility"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/devices.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>devices</title><path d=\"M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z\"/><path class=\"cls-1\" d=\"M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z\"/><path d=\"M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z\"/></svg>",
            "info": {},
            "path": "32/devices.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Devices32",
          "filepath": "devices/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z"
                }
              }
            ],
            "name": "devices",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Devices24",
          "filepath": "devices/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z"
                }
              }
            ],
            "name": "devices",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Devices20",
          "filepath": "devices/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z"
                }
              }
            ],
            "name": "devices",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Devices16",
          "filepath": "devices/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z"
                }
              }
            ],
            "name": "devices",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Devices",
        "global": "Devices",
        "filepath": "Devices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dew-point",
      "friendlyName": "Dew point",
      "aliases": [
        "dew point",
        "temperature",
        "water",
        "water droplet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/dew-point.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>dew-point</title>\n  <path d=\"M24,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,10Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,4Z\"/>\n  <path d=\"M14.5,30A5.4962,5.4962,0,0,1,9,24.52c0-3.4426,4.3442-21.0141,4.5293-21.76a1,1,0,0,1,1.9414,0C15.6558,3.5059,20,21.0774,20,24.52A5.4962,5.4962,0,0,1,14.5,30Zm0-22.7561C13.0391,13.38,11,22.4089,11,24.52a3.5,3.5,0,0,0,7,0C18,22.4089,15.9609,13.38,14.5,7.2439Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30zm0-22.7561C13.0391 13.38 11 22.4089 11 24.52a3.5 3.5 0 007 0C18 22.4089 15.9609 13.38 14.5 7.2439z\"/></svg>",
            "info": {},
            "path": "32/dew-point.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DewPoint32",
          "filepath": "dew-point/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30zm0-22.7561C13.0391 13.38 11 22.4089 11 24.52a3.5 3.5 0 007 0C18 22.4089 15.9609 13.38 14.5 7.2439z"
                }
              }
            ],
            "name": "dew-point",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DewPoint24",
          "filepath": "dew-point/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30zm0-22.7561C13.0391 13.38 11 22.4089 11 24.52a3.5 3.5 0 007 0C18 22.4089 15.9609 13.38 14.5 7.2439z"
                }
              }
            ],
            "name": "dew-point",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DewPoint20",
          "filepath": "dew-point/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30zm0-22.7561C13.0391 13.38 11 22.4089 11 24.52a3.5 3.5 0 007 0C18 22.4089 15.9609 13.38 14.5 7.2439z"
                }
              }
            ],
            "name": "dew-point",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DewPoint16",
          "filepath": "dew-point/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30zm0-22.7561C13.0391 13.38 11 22.4089 11 24.52a3.5 3.5 0 007 0C18 22.4089 15.9609 13.38 14.5 7.2439z"
                }
              }
            ],
            "name": "dew-point",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "DewPoint",
        "global": "DewPoint",
        "filepath": "DewPoint.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30zm0-22.7561C13.0391 13.38 11 22.4089 11 24.52a3.5 3.5 0 007 0C18 22.4089 15.9609 13.38 14.5 7.2439z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dew-point--filled",
      "friendlyName": "Dew point filled",
      "aliases": [
        "dew point filled",
        "temperature",
        "water",
        "water droplet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/dew-point--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>dew-point--filled</title>\n  <path d=\"M24,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,10Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,4Z\"/>\n  <path d=\"M14.5,30A5.4962,5.4962,0,0,1,9,24.52c0-3.4426,4.3442-21.0141,4.5293-21.76a1,1,0,0,1,1.9414,0C15.6558,3.5059,20,21.0774,20,24.52A5.4962,5.4962,0,0,1,14.5,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30z\"/></svg>",
            "info": {},
            "path": "32/dew-point--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DewPointFilled32",
          "filepath": "dew-point--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30z"
                }
              }
            ],
            "name": "dew-point--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DewPointFilled24",
          "filepath": "dew-point--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30z"
                }
              }
            ],
            "name": "dew-point--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DewPointFilled20",
          "filepath": "dew-point--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30z"
                }
              }
            ],
            "name": "dew-point--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DewPointFilled16",
          "filepath": "dew-point--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30z"
                }
              }
            ],
            "name": "dew-point--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "DewPointFilled",
        "global": "DewPointFilled",
        "filepath": "DewPointFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "diagram",
      "friendlyName": "Diagram",
      "aliases": [
        "pie chart",
        "pie",
        "chart",
        "infographic",
        "data vis"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/diagram.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>diagram</title><path d=\"M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z\"/><path d=\"M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z\"/><path d=\"M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z\"/></svg>",
            "info": {},
            "path": "32/diagram.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Diagram32",
          "filepath": "diagram/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z"
                }
              }
            ],
            "name": "diagram",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Diagram24",
          "filepath": "diagram/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z"
                }
              }
            ],
            "name": "diagram",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Diagram20",
          "filepath": "diagram/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z"
                }
              }
            ],
            "name": "diagram",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Diagram16",
          "filepath": "diagram/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z"
                }
              }
            ],
            "name": "diagram",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Diagram",
        "global": "Diagram",
        "filepath": "Diagram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "diagram--reference",
      "friendlyName": "Diagram reference",
      "aliases": [
        "diagram",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/diagram--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z\"/>\n  <path d=\"M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z\"/><path d=\"M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z\"/><path d=\"M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z\"/></svg>",
            "info": {},
            "path": "32/diagram--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DiagramReference32",
          "filepath": "diagram--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z"
                }
              }
            ],
            "name": "diagram--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DiagramReference24",
          "filepath": "diagram--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z"
                }
              }
            ],
            "name": "diagram--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DiagramReference20",
          "filepath": "diagram--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z"
                }
              }
            ],
            "name": "diagram--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DiagramReference16",
          "filepath": "diagram--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z"
                }
              }
            ],
            "name": "diagram--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DiagramReference",
        "global": "DiagramReference",
        "filepath": "DiagramReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "diamond-fill",
      "friendlyName": "Diamond fill",
      "aliases": [
        "diamond",
        "fill",
        "status"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "diamond-fill.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142M8,1,1,8l7,7,7-7L8,1Z\"/>\n  <path d=\"M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142M8,1,1,8l7,7,7-7L8,1Z\"/><path d=\"M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142\"/></svg>",
            "info": {},
            "path": "diamond-fill.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142M8,1,1,8l7,7,7-7L8,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142"
                }
              }
            ],
            "name": "diamond-fill",
            "size": "glyph"
          },
          "moduleName": "DiamondFillGlyph",
          "filepath": "diamond-fill/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "DiamondFill",
        "global": "DiamondFill",
        "filepath": "DiamondFill.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142M8,1,1,8l7,7,7-7L8,1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dicom--6000",
      "friendlyName": "DICOM 6000",
      "aliases": [
        "digital",
        "imaging",
        "communication",
        "DICOM 6000"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/dicom--6000.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--dicom--6000</title><path d=\"M13,11H7a3,3,0,0,0-3,3v2H6V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V14A3,3,0,0,0,13,11Z\"/><path d=\"M10,10A4,4,0,1,0,6,6,4,4,0,0,0,10,10Zm0-6A2,2,0,1,1,8,6,2,2,0,0,1,10,4Z\"/><rect x=\"20\" y=\"4\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"8\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"12\" width=\"6\" height=\"2\"/><path d=\"M5,30H3a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2H6v2H3v2H5a2,2,0,0,1,2,2v2A2,2,0,0,1,5,30ZM3,26v2H5V26Z\"/><path d=\"M13,30H11a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,13,30Zm-2-8v6h2V22Z\"/><path d=\"M21,30H19a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,21,30Zm-2-8v6h2V22Z\"/><path d=\"M29,30H27a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,29,30Zm-2-8v6h2V22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 11H7a3 3 0 00-3 3v2H6V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0013 11zM10 10A4 4 0 106 6 4 4 0 0010 10zm0-6A2 2 0 118 6 2 2 0 0110 4zM20 4H30V6H20zM20 8H30V10H20zM20 12H26V14H20zM5 30H3a2 2 0 01-2-2V22a2 2 0 012-2H6v2H3v2H5a2 2 0 012 2v2A2 2 0 015 30zM3 26v2H5V26zM13 30H11a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0113 30zm-2-8v6h2V22zM21 30H19a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0121 30zm-2-8v6h2V22zM29 30H27a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0129 30zm-2-8v6h2V22z\"/></svg>",
            "info": {},
            "path": "32/watson-health/dicom--6000.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthDicom_600032",
          "filepath": "watson-health/dicom--6000/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H7a3 3 0 00-3 3v2H6V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0013 11zM10 10A4 4 0 106 6 4 4 0 0010 10zm0-6A2 2 0 118 6 2 2 0 0110 4zM20 4H30V6H20zM20 8H30V10H20zM20 12H26V14H20zM5 30H3a2 2 0 01-2-2V22a2 2 0 012-2H6v2H3v2H5a2 2 0 012 2v2A2 2 0 015 30zM3 26v2H5V26zM13 30H11a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0113 30zm-2-8v6h2V22zM21 30H19a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0121 30zm-2-8v6h2V22zM29 30H27a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0129 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "dicom--6000",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthDicom_600024",
          "filepath": "watson-health/dicom--6000/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H7a3 3 0 00-3 3v2H6V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0013 11zM10 10A4 4 0 106 6 4 4 0 0010 10zm0-6A2 2 0 118 6 2 2 0 0110 4zM20 4H30V6H20zM20 8H30V10H20zM20 12H26V14H20zM5 30H3a2 2 0 01-2-2V22a2 2 0 012-2H6v2H3v2H5a2 2 0 012 2v2A2 2 0 015 30zM3 26v2H5V26zM13 30H11a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0113 30zm-2-8v6h2V22zM21 30H19a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0121 30zm-2-8v6h2V22zM29 30H27a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0129 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "dicom--6000",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthDicom_600020",
          "filepath": "watson-health/dicom--6000/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H7a3 3 0 00-3 3v2H6V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0013 11zM10 10A4 4 0 106 6 4 4 0 0010 10zm0-6A2 2 0 118 6 2 2 0 0110 4zM20 4H30V6H20zM20 8H30V10H20zM20 12H26V14H20zM5 30H3a2 2 0 01-2-2V22a2 2 0 012-2H6v2H3v2H5a2 2 0 012 2v2A2 2 0 015 30zM3 26v2H5V26zM13 30H11a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0113 30zm-2-8v6h2V22zM21 30H19a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0121 30zm-2-8v6h2V22zM29 30H27a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0129 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "dicom--6000",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthDicom_600016",
          "filepath": "watson-health/dicom--6000/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H7a3 3 0 00-3 3v2H6V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0013 11zM10 10A4 4 0 106 6 4 4 0 0010 10zm0-6A2 2 0 118 6 2 2 0 0110 4zM20 4H30V6H20zM20 8H30V10H20zM20 12H26V14H20zM5 30H3a2 2 0 01-2-2V22a2 2 0 012-2H6v2H3v2H5a2 2 0 012 2v2A2 2 0 015 30zM3 26v2H5V26zM13 30H11a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0113 30zm-2-8v6h2V22zM21 30H19a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0121 30zm-2-8v6h2V22zM29 30H27a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0129 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "dicom--6000",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Dicom_6000",
        "global": "WatsonHealthDicom_6000",
        "filepath": "watson-health/Dicom_6000.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 11H7a3 3 0 00-3 3v2H6V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0013 11zM10 10A4 4 0 106 6 4 4 0 0010 10zm0-6A2 2 0 118 6 2 2 0 0110 4zM20 4H30V6H20zM20 8H30V10H20zM20 12H26V14H20zM5 30H3a2 2 0 01-2-2V22a2 2 0 012-2H6v2H3v2H5a2 2 0 012 2v2A2 2 0 015 30zM3 26v2H5V26zM13 30H11a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0113 30zm-2-8v6h2V22zM21 30H19a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0121 30zm-2-8v6h2V22zM29 30H27a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0129 30zm-2-8v6h2V22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dicom--overlay",
      "friendlyName": "DICOM overlay",
      "aliases": [
        "digital",
        "imaging",
        "communication"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/dicom--overlay.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--dicom--overlay</title><path d=\"M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><rect x=\"6\" y=\"8\" width=\"10\" height=\"2\"/><rect x=\"6\" y=\"12\" width=\"10\" height=\"2\"/><rect x=\"6\" y=\"16\" width=\"6\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><path d=\"M6 8H16V10H6zM6 12H16V14H6zM6 16H12V18H6z\"/></svg>",
            "info": {},
            "path": "32/watson-health/dicom--overlay.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthDicomOverlay32",
          "filepath": "watson-health/dicom--overlay/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H16V14H6zM6 16H12V18H6z"
                }
              }
            ],
            "name": "dicom--overlay",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthDicomOverlay24",
          "filepath": "watson-health/dicom--overlay/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H16V14H6zM6 16H12V18H6z"
                }
              }
            ],
            "name": "dicom--overlay",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthDicomOverlay20",
          "filepath": "watson-health/dicom--overlay/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H16V14H6zM6 16H12V18H6z"
                }
              }
            ],
            "name": "dicom--overlay",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthDicomOverlay16",
          "filepath": "watson-health/dicom--overlay/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H16V14H6zM6 16H12V18H6z"
                }
              }
            ],
            "name": "dicom--overlay",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "DicomOverlay",
        "global": "WatsonHealthDicomOverlay",
        "filepath": "watson-health/DicomOverlay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 8H16V10H6zM6 12H16V14H6zM6 16H12V18H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direct-link",
      "friendlyName": "IBM Cloud® Direct Link 2.0",
      "aliases": [
        "app",
        "application",
        "direct",
        "link",
        "connection",
        "catalog",
        "catalogue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direct-link.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z\"/><path d=\"M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z\"/></svg>",
            "info": {},
            "path": "32/direct-link.svg"
          }
        }
      ],
      "deprecated": true,
      "reason": "The current icon has been replaced with the correct version of the App icon, use the most appropriate ibm-cloud--direct-link icon variant instead",
      "output": [
        {
          "moduleName": "DirectLink32",
          "filepath": "direct-link/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              }
            ],
            "name": "direct-link",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectLink24",
          "filepath": "direct-link/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              }
            ],
            "name": "direct-link",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectLink20",
          "filepath": "direct-link/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              }
            ],
            "name": "direct-link",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectLink16",
          "filepath": "direct-link/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z"
                }
              }
            ],
            "name": "direct-link",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DirectLink",
        "global": "DirectLink",
        "filepath": "DirectLink.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--bear-right--01",
      "friendlyName": "Direction bear right 01",
      "aliases": [
        "bear right",
        "direction bear right 01",
        "bear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--bear-right--01.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--bear-right</title>\n  <path d=\"M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z\"/></svg>",
            "info": {},
            "path": "32/direction--bear-right--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionBearRight_0132",
          "filepath": "direction--bear-right--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z"
                }
              }
            ],
            "name": "direction--bear-right--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionBearRight_0124",
          "filepath": "direction--bear-right--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z"
                }
              }
            ],
            "name": "direction--bear-right--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionBearRight_0120",
          "filepath": "direction--bear-right--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z"
                }
              }
            ],
            "name": "direction--bear-right--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionBearRight_0116",
          "filepath": "direction--bear-right--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z"
                }
              }
            ],
            "name": "direction--bear-right--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionBearRight_01",
        "global": "DirectionBearRight_01",
        "filepath": "DirectionBearRight_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--bear-right--01--filled",
      "friendlyName": "Direction bear right 01 filled",
      "aliases": [
        "bear right",
        "direction bear right 01 filled",
        "bear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--bear-right--01--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--bear-right--01--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z\"/><path fill=\"none\" d=\"M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--bear-right--01--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionBearRight_01Filled32",
          "filepath": "direction--bear-right--01--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--01--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionBearRight_01Filled24",
          "filepath": "direction--bear-right--01--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--01--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionBearRight_01Filled20",
          "filepath": "direction--bear-right--01--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--01--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionBearRight_01Filled16",
          "filepath": "direction--bear-right--01--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--01--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionBearRight_01Filled",
        "global": "DirectionBearRight_01Filled",
        "filepath": "DirectionBearRight_01Filled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--bear-right--02",
      "friendlyName": "Direction bear right 02",
      "aliases": [
        "bear right",
        "direction bear right 02",
        "bear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--bear-right--02.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--bear-right--02</title>\n  <path d=\"M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z\"/>\n  <rect x=\"8.5001\" y=\"5.5501\" width=\"1.9998\" height=\"7.8997\" transform=\"translate(-3.935 9.5) rotate(-45)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z\"/><path d=\"M8.5 5.55H10.5V13.45H8.5z\" transform=\"rotate(-45 9.5 9.5)\"/></svg>",
            "info": {},
            "path": "32/direction--bear-right--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionBearRight_0232",
          "filepath": "direction--bear-right--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5 5.55H10.5V13.45H8.5z",
                  "transform": "rotate(-45 9.5 9.5)"
                }
              }
            ],
            "name": "direction--bear-right--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionBearRight_0224",
          "filepath": "direction--bear-right--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5 5.55H10.5V13.45H8.5z",
                  "transform": "rotate(-45 9.5 9.5)"
                }
              }
            ],
            "name": "direction--bear-right--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionBearRight_0220",
          "filepath": "direction--bear-right--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5 5.55H10.5V13.45H8.5z",
                  "transform": "rotate(-45 9.5 9.5)"
                }
              }
            ],
            "name": "direction--bear-right--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionBearRight_0216",
          "filepath": "direction--bear-right--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5 5.55H10.5V13.45H8.5z",
                  "transform": "rotate(-45 9.5 9.5)"
                }
              }
            ],
            "name": "direction--bear-right--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionBearRight_02",
        "global": "DirectionBearRight_02",
        "filepath": "DirectionBearRight_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.5 5.55H10.5V13.45H8.5z",
                    "transform": "rotate(-45 9.5 9.5)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--bear-right--02--filled",
      "friendlyName": "Direction bear right 02 filled",
      "aliases": [
        "bear right",
        "direction bear right 02 filled",
        "bear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--bear-right--02--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--bear-right--02--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z\"/><path fill=\"none\" d=\"M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--bear-right--02--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionBearRight_02Filled32",
          "filepath": "direction--bear-right--02--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--02--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionBearRight_02Filled24",
          "filepath": "direction--bear-right--02--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--02--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionBearRight_02Filled20",
          "filepath": "direction--bear-right--02--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--02--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionBearRight_02Filled16",
          "filepath": "direction--bear-right--02--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--bear-right--02--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionBearRight_02Filled",
        "global": "DirectionBearRight_02Filled",
        "filepath": "DirectionBearRight_02Filled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--curve",
      "friendlyName": "Direction curve",
      "aliases": [
        "direction",
        "direction curve"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--curve.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--curve</title>\n  <path d=\"M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z\"/></svg>",
            "info": {},
            "path": "32/direction--curve.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionCurve32",
          "filepath": "direction--curve/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z"
                }
              }
            ],
            "name": "direction--curve",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionCurve24",
          "filepath": "direction--curve/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z"
                }
              }
            ],
            "name": "direction--curve",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionCurve20",
          "filepath": "direction--curve/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z"
                }
              }
            ],
            "name": "direction--curve",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionCurve16",
          "filepath": "direction--curve/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z"
                }
              }
            ],
            "name": "direction--curve",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionCurve",
        "global": "DirectionCurve",
        "filepath": "DirectionCurve.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--curve--filled",
      "friendlyName": "Direction curve filled",
      "aliases": [
        "direction",
        "direction curve filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--curve--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--curve--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z\"/><path fill=\"none\" d=\"M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--curve--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionCurveFilled32",
          "filepath": "direction--curve--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--curve--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionCurveFilled24",
          "filepath": "direction--curve--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--curve--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionCurveFilled20",
          "filepath": "direction--curve--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--curve--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionCurveFilled16",
          "filepath": "direction--curve--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--curve--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionCurveFilled",
        "global": "DirectionCurveFilled",
        "filepath": "DirectionCurveFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--fork",
      "friendlyName": "Direction fork",
      "aliases": [
        "direction",
        "direction fork"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--fork.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"6 13 6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z\"/></svg>",
            "info": {},
            "path": "32/direction--fork.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionFork32",
          "filepath": "direction--fork/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z"
                }
              }
            ],
            "name": "direction--fork",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionFork24",
          "filepath": "direction--fork/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z"
                }
              }
            ],
            "name": "direction--fork",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionFork20",
          "filepath": "direction--fork/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z"
                }
              }
            ],
            "name": "direction--fork",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionFork16",
          "filepath": "direction--fork/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z"
                }
              }
            ],
            "name": "direction--fork",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionFork",
        "global": "DirectionFork",
        "filepath": "DirectionFork.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--fork--filled",
      "friendlyName": "Direction fork filled",
      "aliases": [
        "direction",
        "direction fork",
        "direction fork filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--fork--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"8 14 8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14\"/>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z\" data-icon-path=\"inner-path\"/><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z\"/></svg>",
            "info": {},
            "path": "32/direction--fork--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionForkFilled32",
          "filepath": "direction--fork--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z"
                }
              }
            ],
            "name": "direction--fork--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionForkFilled24",
          "filepath": "direction--fork--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z"
                }
              }
            ],
            "name": "direction--fork--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionForkFilled20",
          "filepath": "direction--fork--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z"
                }
              }
            ],
            "name": "direction--fork--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionForkFilled16",
          "filepath": "direction--fork--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z"
                }
              }
            ],
            "name": "direction--fork--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionForkFilled",
        "global": "DirectionForkFilled",
        "filepath": "DirectionForkFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--loop-left",
      "friendlyName": "Direction loop left",
      "aliases": [
        "direction",
        "direction loop left"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--loop-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"16\" y=\"20\" width=\"2\" height=\"8\"/>\n  <path d=\"M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 20H18V28H16z\"/><path d=\"M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z\"/></svg>",
            "info": {},
            "path": "32/direction--loop-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionLoopLeft32",
          "filepath": "direction--loop-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H18V28H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z"
                }
              }
            ],
            "name": "direction--loop-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionLoopLeft24",
          "filepath": "direction--loop-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H18V28H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z"
                }
              }
            ],
            "name": "direction--loop-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionLoopLeft20",
          "filepath": "direction--loop-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H18V28H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z"
                }
              }
            ],
            "name": "direction--loop-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionLoopLeft16",
          "filepath": "direction--loop-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H18V28H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z"
                }
              }
            ],
            "name": "direction--loop-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionLoopLeft",
        "global": "DirectionLoopLeft",
        "filepath": "DirectionLoopLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 20H18V28H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--loop-left--filled",
      "friendlyName": "Direction loop left filled",
      "aliases": [
        "direction",
        "direction loop left filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--loop-left--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z\" data-icon-path=\"inner-path\"/><path d=\"M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z\"/></svg>",
            "info": {},
            "path": "32/direction--loop-left--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionLoopLeftFilled32",
          "filepath": "direction--loop-left--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z"
                }
              }
            ],
            "name": "direction--loop-left--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionLoopLeftFilled24",
          "filepath": "direction--loop-left--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z"
                }
              }
            ],
            "name": "direction--loop-left--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionLoopLeftFilled20",
          "filepath": "direction--loop-left--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z"
                }
              }
            ],
            "name": "direction--loop-left--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionLoopLeftFilled16",
          "filepath": "direction--loop-left--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z"
                }
              }
            ],
            "name": "direction--loop-left--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionLoopLeftFilled",
        "global": "DirectionLoopLeftFilled",
        "filepath": "DirectionLoopLeftFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--loop-right",
      "friendlyName": "Direction loop right",
      "aliases": [
        "direction",
        "direction loop right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--loop-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"14\" y=\"20\" width=\"2\" height=\"8\"/>\n  <path d=\"M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 20H16V28H14z\"/><path d=\"M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z\"/></svg>",
            "info": {},
            "path": "32/direction--loop-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionLoopRight32",
          "filepath": "direction--loop-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20H16V28H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z"
                }
              }
            ],
            "name": "direction--loop-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionLoopRight24",
          "filepath": "direction--loop-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20H16V28H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z"
                }
              }
            ],
            "name": "direction--loop-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionLoopRight20",
          "filepath": "direction--loop-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20H16V28H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z"
                }
              }
            ],
            "name": "direction--loop-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionLoopRight16",
          "filepath": "direction--loop-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20H16V28H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z"
                }
              }
            ],
            "name": "direction--loop-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionLoopRight",
        "global": "DirectionLoopRight",
        "filepath": "DirectionLoopRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 20H16V28H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--loop-right--filled",
      "friendlyName": "Direction loop right filled",
      "aliases": [
        "direction",
        "direction loop right filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--loop-right--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z\" transform=\"translate(0)\"/>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z\" data-icon-path=\"inner-path\"/><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z\"/></svg>",
            "info": {},
            "path": "32/direction--loop-right--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionLoopRightFilled32",
          "filepath": "direction--loop-right--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z"
                }
              }
            ],
            "name": "direction--loop-right--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionLoopRightFilled24",
          "filepath": "direction--loop-right--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z"
                }
              }
            ],
            "name": "direction--loop-right--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionLoopRightFilled20",
          "filepath": "direction--loop-right--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z"
                }
              }
            ],
            "name": "direction--loop-right--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionLoopRightFilled16",
          "filepath": "direction--loop-right--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z"
                }
              }
            ],
            "name": "direction--loop-right--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionLoopRightFilled",
        "global": "DirectionLoopRightFilled",
        "filepath": "DirectionLoopRightFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--merge",
      "friendlyName": "Direction merge",
      "aliases": [
        "direction",
        "direction merge"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--merge.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--merge</title>\n  <path d=\"M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z\"/></svg>",
            "info": {},
            "path": "32/direction--merge.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionMerge32",
          "filepath": "direction--merge/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z"
                }
              }
            ],
            "name": "direction--merge",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionMerge24",
          "filepath": "direction--merge/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z"
                }
              }
            ],
            "name": "direction--merge",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionMerge20",
          "filepath": "direction--merge/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z"
                }
              }
            ],
            "name": "direction--merge",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionMerge16",
          "filepath": "direction--merge/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z"
                }
              }
            ],
            "name": "direction--merge",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionMerge",
        "global": "DirectionMerge",
        "filepath": "DirectionMerge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--merge--filled",
      "friendlyName": "Direction merge filled",
      "aliases": [
        "direction",
        "directin merge",
        "direction merge filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--merge--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--merge--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z\"/><path fill=\"none\" d=\"M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--merge--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionMergeFilled32",
          "filepath": "direction--merge--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--merge--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionMergeFilled24",
          "filepath": "direction--merge--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--merge--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionMergeFilled20",
          "filepath": "direction--merge--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--merge--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionMergeFilled16",
          "filepath": "direction--merge--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--merge--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionMergeFilled",
        "global": "DirectionMergeFilled",
        "filepath": "DirectionMergeFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--right--01",
      "friendlyName": "Direction right 01",
      "aliases": [
        "direction",
        "direction right 01",
        "direction right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--right--01.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--right--01</title>\n  <path d=\"M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z\"/></svg>",
            "info": {},
            "path": "32/direction--right--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRight_0132",
          "filepath": "direction--right--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z"
                }
              }
            ],
            "name": "direction--right--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRight_0124",
          "filepath": "direction--right--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z"
                }
              }
            ],
            "name": "direction--right--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRight_0120",
          "filepath": "direction--right--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z"
                }
              }
            ],
            "name": "direction--right--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRight_0116",
          "filepath": "direction--right--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z"
                }
              }
            ],
            "name": "direction--right--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRight_01",
        "global": "DirectionRight_01",
        "filepath": "DirectionRight_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--right--01--filled",
      "friendlyName": "Direction right 01 filled",
      "aliases": [
        "direction",
        "direction right 01 filled",
        "direction right filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--right--01--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--right--01--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z\"/><path fill=\"none\" d=\"M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--right--01--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRight_01Filled32",
          "filepath": "direction--right--01--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--01--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRight_01Filled24",
          "filepath": "direction--right--01--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--01--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRight_01Filled20",
          "filepath": "direction--right--01--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--01--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRight_01Filled16",
          "filepath": "direction--right--01--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--01--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRight_01Filled",
        "global": "DirectionRight_01Filled",
        "filepath": "DirectionRight_01Filled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--right--02",
      "friendlyName": "Direction right 02",
      "aliases": [
        "direction",
        "direction right 02",
        "direction right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--right--02.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--right--02</title>\n  <path d=\"M19,8,17.5859,9.4141,22.1719,14H10a2,2,0,0,0-2,2V28h2V16H22.1719l-4.586,4.5859L19,22l7-7Z\"/>\n  <rect x=\"8\" y=\"4\" width=\"2\" height=\"8\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 8L17.5859 9.4141 22.1719 14H10a2 2 0 00-2 2V28h2V16H22.1719l-4.586 4.5859L19 22l7-7zM8 4H10V12H8z\"/></svg>",
            "info": {},
            "path": "32/direction--right--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRight_0232",
          "filepath": "direction--right--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 8L17.5859 9.4141 22.1719 14H10a2 2 0 00-2 2V28h2V16H22.1719l-4.586 4.5859L19 22l7-7zM8 4H10V12H8z"
                }
              }
            ],
            "name": "direction--right--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRight_0224",
          "filepath": "direction--right--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 8L17.5859 9.4141 22.1719 14H10a2 2 0 00-2 2V28h2V16H22.1719l-4.586 4.5859L19 22l7-7zM8 4H10V12H8z"
                }
              }
            ],
            "name": "direction--right--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRight_0220",
          "filepath": "direction--right--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 8L17.5859 9.4141 22.1719 14H10a2 2 0 00-2 2V28h2V16H22.1719l-4.586 4.5859L19 22l7-7zM8 4H10V12H8z"
                }
              }
            ],
            "name": "direction--right--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRight_0216",
          "filepath": "direction--right--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 8L17.5859 9.4141 22.1719 14H10a2 2 0 00-2 2V28h2V16H22.1719l-4.586 4.5859L19 22l7-7zM8 4H10V12H8z"
                }
              }
            ],
            "name": "direction--right--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRight_02",
        "global": "DirectionRight_02",
        "filepath": "DirectionRight_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 8L17.5859 9.4141 22.1719 14H10a2 2 0 00-2 2V28h2V16H22.1719l-4.586 4.5859L19 22l7-7zM8 4H10V12H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--right--02--filled",
      "friendlyName": "Direction right 02 filled",
      "aliases": [
        "direction",
        "direction right 02 filled",
        "direction right filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--right--02--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--right--02--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z\"/><path fill=\"none\" d=\"M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--right--02--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRight_02Filled32",
          "filepath": "direction--right--02--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--02--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRight_02Filled24",
          "filepath": "direction--right--02--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--02--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRight_02Filled20",
          "filepath": "direction--right--02--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--02--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRight_02Filled16",
          "filepath": "direction--right--02--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--right--02--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRight_02Filled",
        "global": "DirectionRight_02Filled",
        "filepath": "DirectionRight_02Filled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--rotary--first-right",
      "friendlyName": "Direction rotary first right",
      "aliases": [
        "rotary",
        "direction",
        "direction rotary first right",
        "rotary first right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--rotary--first-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--rotary--first-right</title>\n  <path d=\"M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z\"/></svg>",
            "info": {},
            "path": "32/direction--rotary--first-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRotaryFirstRight32",
          "filepath": "direction--rotary--first-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--first-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRotaryFirstRight24",
          "filepath": "direction--rotary--first-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--first-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRotaryFirstRight20",
          "filepath": "direction--rotary--first-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--first-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRotaryFirstRight16",
          "filepath": "direction--rotary--first-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--first-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRotaryFirstRight",
        "global": "DirectionRotaryFirstRight",
        "filepath": "DirectionRotaryFirstRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--rotary--first-right--filled",
      "friendlyName": "Direction rotary first right filled",
      "aliases": [
        "rotary",
        "direction",
        "direction rotary first right filled",
        "rotary first right filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--rotary--first-right--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--rotary--first-right--filled</title>\n  <circle cx=\"11\" cy=\"11\" r=\"3\"/>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"11\" cy=\"11\" r=\"3\"/><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z\"/><path fill=\"none\" d=\"M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--rotary--first-right--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRotaryFirstRightFilled32",
          "filepath": "direction--rotary--first-right--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--first-right--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRotaryFirstRightFilled24",
          "filepath": "direction--rotary--first-right--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--first-right--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRotaryFirstRightFilled20",
          "filepath": "direction--rotary--first-right--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--first-right--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRotaryFirstRightFilled16",
          "filepath": "direction--rotary--first-right--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--first-right--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRotaryFirstRightFilled",
        "global": "DirectionRotaryFirstRightFilled",
        "filepath": "DirectionRotaryFirstRightFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "11",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--rotary--right",
      "friendlyName": "Direction rotary right",
      "aliases": [
        "rotary",
        "direction",
        "direction rotary right",
        "rotary right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--rotary--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--rotary--right</title>\n  <path d=\"M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z\"/></svg>",
            "info": {},
            "path": "32/direction--rotary--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRotaryRight32",
          "filepath": "direction--rotary--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRotaryRight24",
          "filepath": "direction--rotary--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRotaryRight20",
          "filepath": "direction--rotary--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRotaryRight16",
          "filepath": "direction--rotary--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                }
              }
            ],
            "name": "direction--rotary--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRotaryRight",
        "global": "DirectionRotaryRight",
        "filepath": "DirectionRotaryRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--rotary--right--filled",
      "friendlyName": "Direction rotary right filled",
      "aliases": [
        "rotary",
        "direction",
        "direction rotary right filled",
        "rotary right filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--rotary--right--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--rotary--right--filled</title>\n  <circle cx=\"11\" cy=\"11\" r=\"3\"/>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"11\" cy=\"11\" r=\"3\"/><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z\"/><path fill=\"none\" d=\"M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--rotary--right--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRotaryRightFilled32",
          "filepath": "direction--rotary--right--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--right--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRotaryRightFilled24",
          "filepath": "direction--rotary--right--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--right--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRotaryRightFilled20",
          "filepath": "direction--rotary--right--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--right--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRotaryRightFilled16",
          "filepath": "direction--rotary--right--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--right--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRotaryRightFilled",
        "global": "DirectionRotaryRightFilled",
        "filepath": "DirectionRotaryRightFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "11",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--rotary--straight",
      "friendlyName": "Direction rotary straight",
      "aliases": [
        "rotary",
        "direction",
        "direction rotary straight",
        "rotary straight"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--rotary--straight.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--rotary--straight</title>\n  <path d=\"M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z\"/></svg>",
            "info": {},
            "path": "32/direction--rotary--straight.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRotaryStraight32",
          "filepath": "direction--rotary--straight/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
                }
              }
            ],
            "name": "direction--rotary--straight",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRotaryStraight24",
          "filepath": "direction--rotary--straight/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
                }
              }
            ],
            "name": "direction--rotary--straight",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRotaryStraight20",
          "filepath": "direction--rotary--straight/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
                }
              }
            ],
            "name": "direction--rotary--straight",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRotaryStraight16",
          "filepath": "direction--rotary--straight/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
                }
              }
            ],
            "name": "direction--rotary--straight",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRotaryStraight",
        "global": "DirectionRotaryStraight",
        "filepath": "DirectionRotaryStraight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--rotary--straight--filled",
      "friendlyName": "Direction rotary straight filled",
      "aliases": [
        "rotary",
        "direction",
        "direction rotary straight filled",
        "rotary straight filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--rotary--straight--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--rotary--straight--filled</title>\n  <circle cx=\"16\" cy=\"19\" r=\"3\"/>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"19\" r=\"3\"/><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z\"/><path fill=\"none\" d=\"M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--rotary--straight--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionRotaryStraightFilled32",
          "filepath": "direction--rotary--straight--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--straight--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionRotaryStraightFilled24",
          "filepath": "direction--rotary--straight--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--straight--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionRotaryStraightFilled20",
          "filepath": "direction--rotary--straight--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--straight--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionRotaryStraightFilled16",
          "filepath": "direction--rotary--straight--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "19",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--rotary--straight--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionRotaryStraightFilled",
        "global": "DirectionRotaryStraightFilled",
        "filepath": "DirectionRotaryStraightFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "19",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--sharp-turn",
      "friendlyName": "Direction sharp turn",
      "aliases": [
        "rotary",
        "direction",
        "direction rotary straight filled",
        "rotary straight filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--sharp-turn.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--sharp-turn</title>\n  <path d=\"M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z\"/></svg>",
            "info": {},
            "path": "32/direction--sharp-turn.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionSharpTurn32",
          "filepath": "direction--sharp-turn/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
                }
              }
            ],
            "name": "direction--sharp-turn",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionSharpTurn24",
          "filepath": "direction--sharp-turn/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
                }
              }
            ],
            "name": "direction--sharp-turn",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionSharpTurn20",
          "filepath": "direction--sharp-turn/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
                }
              }
            ],
            "name": "direction--sharp-turn",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionSharpTurn16",
          "filepath": "direction--sharp-turn/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
                }
              }
            ],
            "name": "direction--sharp-turn",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionSharpTurn",
        "global": "DirectionSharpTurn",
        "filepath": "DirectionSharpTurn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--sharp-turn--filled",
      "friendlyName": "Direction sharp turn filled",
      "aliases": [
        "direction",
        "direction sharp turn filled",
        "sharp turn filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--sharp-turn--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--sharp-turn--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z\"/><path fill=\"none\" d=\"M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--sharp-turn--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionSharpTurnFilled32",
          "filepath": "direction--sharp-turn--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--sharp-turn--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionSharpTurnFilled24",
          "filepath": "direction--sharp-turn--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--sharp-turn--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionSharpTurnFilled20",
          "filepath": "direction--sharp-turn--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--sharp-turn--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionSharpTurnFilled16",
          "filepath": "direction--sharp-turn--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--sharp-turn--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionSharpTurnFilled",
        "global": "DirectionSharpTurnFilled",
        "filepath": "DirectionSharpTurnFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--straight",
      "friendlyName": "Direction straight",
      "aliases": [
        "direction straight",
        "direction",
        "straight"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--straight.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--straight</title>\n  <polygon points=\"16 4 9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z\"/></svg>",
            "info": {},
            "path": "32/direction--straight.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionStraight32",
          "filepath": "direction--straight/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
                }
              }
            ],
            "name": "direction--straight",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionStraight24",
          "filepath": "direction--straight/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
                }
              }
            ],
            "name": "direction--straight",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionStraight20",
          "filepath": "direction--straight/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
                }
              }
            ],
            "name": "direction--straight",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionStraight16",
          "filepath": "direction--straight/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
                }
              }
            ],
            "name": "direction--straight",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionStraight",
        "global": "DirectionStraight",
        "filepath": "DirectionStraight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--straight--filled",
      "friendlyName": "Direction straight filled",
      "aliases": [
        "direction straight filled",
        "direction straight",
        "direction",
        "straight"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--straight--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--straight--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z\"/><path fill=\"none\" d=\"M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--straight--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionStraightFilled32",
          "filepath": "direction--straight--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionStraightFilled24",
          "filepath": "direction--straight--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionStraightFilled20",
          "filepath": "direction--straight--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionStraightFilled16",
          "filepath": "direction--straight--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionStraightFilled",
        "global": "DirectionStraightFilled",
        "filepath": "DirectionStraightFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--straight--right",
      "friendlyName": "Direction straight right",
      "aliases": [
        "direction straight right",
        "direction right",
        "direction",
        "straight right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--straight--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--straight--right</title>\n  <polygon points=\"28 16 21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z\"/></svg>",
            "info": {},
            "path": "32/direction--straight--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionStraightRight32",
          "filepath": "direction--straight--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
                }
              }
            ],
            "name": "direction--straight--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionStraightRight24",
          "filepath": "direction--straight--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
                }
              }
            ],
            "name": "direction--straight--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionStraightRight20",
          "filepath": "direction--straight--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
                }
              }
            ],
            "name": "direction--straight--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionStraightRight16",
          "filepath": "direction--straight--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
                }
              }
            ],
            "name": "direction--straight--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionStraightRight",
        "global": "DirectionStraightRight",
        "filepath": "DirectionStraightRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--straight--right--filled",
      "friendlyName": "Direction straight right filled",
      "aliases": [
        "direction straight right filled",
        "direction straight right",
        "direction right",
        "straight right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--straight--right--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>direction--straight--right--filled</title>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z\"/><path fill=\"none\" d=\"M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/direction--straight--right--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionStraightRightFilled32",
          "filepath": "direction--straight--right--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--right--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionStraightRightFilled24",
          "filepath": "direction--straight--right--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--right--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionStraightRightFilled20",
          "filepath": "direction--straight--right--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--right--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionStraightRightFilled16",
          "filepath": "direction--straight--right--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "direction--straight--right--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionStraightRightFilled",
        "global": "DirectionStraightRightFilled",
        "filepath": "DirectionStraightRightFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--u-turn",
      "friendlyName": "Direction U-turn",
      "aliases": [
        "direction U-turn",
        "U-turn"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--u-turn.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z\"/></svg>",
            "info": {},
            "path": "32/direction--u-turn.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionUTurn32",
          "filepath": "direction--u-turn/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
                }
              }
            ],
            "name": "direction--u-turn",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionUTurn24",
          "filepath": "direction--u-turn/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
                }
              }
            ],
            "name": "direction--u-turn",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionUTurn20",
          "filepath": "direction--u-turn/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
                }
              }
            ],
            "name": "direction--u-turn",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionUTurn16",
          "filepath": "direction--u-turn/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
                }
              }
            ],
            "name": "direction--u-turn",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionUTurn",
        "global": "DirectionUTurn",
        "filepath": "DirectionUTurn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "direction--u-turn--filled",
      "friendlyName": "Direction U-turn filled",
      "aliases": [
        "direction U-turn filled",
        "U-turn filled",
        "U-turn"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/direction--u-turn--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z\"/>\n  <path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z\" data-icon-path=\"inner-path\"/><path d=\"M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z\"/></svg>",
            "info": {},
            "path": "32/direction--u-turn--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectionUTurnFilled32",
          "filepath": "direction--u-turn--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
                }
              }
            ],
            "name": "direction--u-turn--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectionUTurnFilled24",
          "filepath": "direction--u-turn--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
                }
              }
            ],
            "name": "direction--u-turn--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectionUTurnFilled20",
          "filepath": "direction--u-turn--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
                }
              }
            ],
            "name": "direction--u-turn--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectionUTurnFilled16",
          "filepath": "direction--u-turn--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
                }
              }
            ],
            "name": "direction--u-turn--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "DirectionUTurnFilled",
        "global": "DirectionUTurnFilled",
        "filepath": "DirectionUTurnFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "directory-domain",
      "friendlyName": "Directory domain",
      "aliases": [
        "systems",
        "directory",
        "domain"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/directory-domain.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/directory-domain.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DirectoryDomain32",
          "filepath": "directory-domain/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
                }
              }
            ],
            "name": "directory-domain",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DirectoryDomain24",
          "filepath": "directory-domain/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
                }
              }
            ],
            "name": "directory-domain",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DirectoryDomain20",
          "filepath": "directory-domain/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
                }
              }
            ],
            "name": "directory-domain",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DirectoryDomain16",
          "filepath": "directory-domain/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
                }
              }
            ],
            "name": "directory-domain",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "DirectoryDomain",
        "global": "DirectoryDomain",
        "filepath": "DirectoryDomain.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "distribute--horizontal-center",
      "friendlyName": "Distribute horizontal center",
      "aliases": [
        "distribute",
        "distrubute horizontal center",
        "distrubute horizontal"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/distribute--horizontal-center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>distribute--horizontal-center</title><path d=\"M24,10H23V2H21v8H20a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2h1v8h2V22h1a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,24,10Zm0,10H20V12h4Z\"/><path d=\"M12,6H11V2H9V6H8A2.0023,2.0023,0,0,0,6,8V24a2.0023,2.0023,0,0,0,2,2H9v4h2V26h1a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,12,6Zm0,18H8V8h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z\"/></svg>",
            "info": {},
            "path": "32/distribute--horizontal-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DistributeHorizontalCenter32",
          "filepath": "distribute--horizontal-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z"
                }
              }
            ],
            "name": "distribute--horizontal-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DistributeHorizontalCenter24",
          "filepath": "distribute--horizontal-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z"
                }
              }
            ],
            "name": "distribute--horizontal-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DistributeHorizontalCenter20",
          "filepath": "distribute--horizontal-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z"
                }
              }
            ],
            "name": "distribute--horizontal-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DistributeHorizontalCenter16",
          "filepath": "distribute--horizontal-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z"
                }
              }
            ],
            "name": "distribute--horizontal-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DistributeHorizontalCenter",
        "global": "DistributeHorizontalCenter",
        "filepath": "DistributeHorizontalCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "distribute--horizontal-left",
      "friendlyName": "Distribute horizontal left",
      "aliases": [
        "distribute",
        "distribute horizontal left",
        "horizontal left"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/distribute--horizontal-left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>distribute--horizontal-left</title><path d=\"M28,22H24a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM24,12v8h4V12Z\"/><rect x=\"18\" y=\"2\" width=\"2\" height=\"28\"/><path d=\"M12,26H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6h4a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,12,26ZM8,8V24h4V8Z\"/><rect x=\"2\" y=\"2\" width=\"2\" height=\"28\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z\"/></svg>",
            "info": {},
            "path": "32/distribute--horizontal-left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DistributeHorizontalLeft32",
          "filepath": "distribute--horizontal-left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z"
                }
              }
            ],
            "name": "distribute--horizontal-left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DistributeHorizontalLeft24",
          "filepath": "distribute--horizontal-left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z"
                }
              }
            ],
            "name": "distribute--horizontal-left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DistributeHorizontalLeft20",
          "filepath": "distribute--horizontal-left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z"
                }
              }
            ],
            "name": "distribute--horizontal-left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DistributeHorizontalLeft16",
          "filepath": "distribute--horizontal-left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z"
                }
              }
            ],
            "name": "distribute--horizontal-left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DistributeHorizontalLeft",
        "global": "DistributeHorizontalLeft",
        "filepath": "DistributeHorizontalLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "distribute--horizontal-right",
      "friendlyName": "Distribute horizontal right",
      "aliases": [
        "distribute",
        "distribute horizontal right",
        "horizontal right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/distribute--horizontal-right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>distribute--horizontal-right</title><rect x=\"28\" y=\"2\" width=\"2\" height=\"28\"/><path d=\"M24,22H20a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,24,22ZM20,12h-.0015L20,20h4V12Z\"/><rect x=\"12\" y=\"2\" width=\"2\" height=\"28\"/><path d=\"M8,26H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,8,26ZM4,8H3.9985L4,24H8V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z\"/></svg>",
            "info": {},
            "path": "32/distribute--horizontal-right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DistributeHorizontalRight32",
          "filepath": "distribute--horizontal-right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z"
                }
              }
            ],
            "name": "distribute--horizontal-right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DistributeHorizontalRight24",
          "filepath": "distribute--horizontal-right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z"
                }
              }
            ],
            "name": "distribute--horizontal-right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DistributeHorizontalRight20",
          "filepath": "distribute--horizontal-right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z"
                }
              }
            ],
            "name": "distribute--horizontal-right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DistributeHorizontalRight16",
          "filepath": "distribute--horizontal-right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z"
                }
              }
            ],
            "name": "distribute--horizontal-right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DistributeHorizontalRight",
        "global": "DistributeHorizontalRight",
        "filepath": "DistributeHorizontalRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "distribute--vertical-bottom",
      "friendlyName": "Distribute vertical bottom",
      "aliases": [
        "distribute",
        "distribute vertical bottom",
        "vertical bottom"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/distribute--vertical-bottom.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>distribute--vertical-bottom</title><rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/><path d=\"M24,26H8a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,24,26Zm0-6.0012L8,20v4H24Z\"/><rect x=\"2\" y=\"12\" width=\"28\" height=\"2\"/><path d=\"M20,10H12a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,20,10Zm0-6.0012L12,4V8h8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z\"/></svg>",
            "info": {},
            "path": "32/distribute--vertical-bottom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DistributeVerticalBottom32",
          "filepath": "distribute--vertical-bottom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z"
                }
              }
            ],
            "name": "distribute--vertical-bottom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DistributeVerticalBottom24",
          "filepath": "distribute--vertical-bottom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z"
                }
              }
            ],
            "name": "distribute--vertical-bottom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DistributeVerticalBottom20",
          "filepath": "distribute--vertical-bottom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z"
                }
              }
            ],
            "name": "distribute--vertical-bottom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DistributeVerticalBottom16",
          "filepath": "distribute--vertical-bottom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z"
                }
              }
            ],
            "name": "distribute--vertical-bottom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DistributeVerticalBottom",
        "global": "DistributeVerticalBottom",
        "filepath": "DistributeVerticalBottom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "distribute--vertical-center",
      "friendlyName": "Distribute vertical center",
      "aliases": [
        "distribute",
        "distribute vertical center",
        "vertical center"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/distribute--vertical-center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>distribute--vertical-center</title><path d=\"M30,21H26V20a2.0023,2.0023,0,0,0-2-2H8a2.0023,2.0023,0,0,0-2,2v1H2v2H6v1a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V23h4Zm-6,3H8V20l16-.001Z\"/><path d=\"M30,9H22V8a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V9H2v2h8v1a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V11h8ZM20,12H12V8l8-.001Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z\"/></svg>",
            "info": {},
            "path": "32/distribute--vertical-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DistributeVerticalCenter32",
          "filepath": "distribute--vertical-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z"
                }
              }
            ],
            "name": "distribute--vertical-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DistributeVerticalCenter24",
          "filepath": "distribute--vertical-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z"
                }
              }
            ],
            "name": "distribute--vertical-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DistributeVerticalCenter20",
          "filepath": "distribute--vertical-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z"
                }
              }
            ],
            "name": "distribute--vertical-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DistributeVerticalCenter16",
          "filepath": "distribute--vertical-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z"
                }
              }
            ],
            "name": "distribute--vertical-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DistributeVerticalCenter",
        "global": "DistributeVerticalCenter",
        "filepath": "DistributeVerticalCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "distribute--vertical-top",
      "friendlyName": "Distribute vertical top",
      "aliases": [
        "distribute",
        "distribute vertical top",
        "vertical top"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/distribute--vertical-top.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>distribute--vertical-top</title><path d=\"M24,30H8a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,24,30ZM8,24v4H24V24Z\"/><rect x=\"2\" y=\"18\" width=\"28\" height=\"2\"/><path d=\"M20,14H12a2.0021,2.0021,0,0,1-2-2V8a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,20,14ZM12,8v4h8V8Z\"/><rect x=\"2\" y=\"2\" width=\"28\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z\"/></svg>",
            "info": {},
            "path": "32/distribute--vertical-top.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DistributeVerticalTop32",
          "filepath": "distribute--vertical-top/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z"
                }
              }
            ],
            "name": "distribute--vertical-top",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DistributeVerticalTop24",
          "filepath": "distribute--vertical-top/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z"
                }
              }
            ],
            "name": "distribute--vertical-top",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DistributeVerticalTop20",
          "filepath": "distribute--vertical-top/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z"
                }
              }
            ],
            "name": "distribute--vertical-top",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DistributeVerticalTop16",
          "filepath": "distribute--vertical-top/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z"
                }
              }
            ],
            "name": "distribute--vertical-top",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DistributeVerticalTop",
        "global": "DistributeVerticalTop",
        "filepath": "DistributeVerticalTop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dna",
      "friendlyName": "DNA",
      "aliases": [
        "DNA",
        "health",
        "DNA chain"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/dna.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>dna</title><path d=\"M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/dna.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthDna32",
          "filepath": "watson-health/dna/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
                }
              }
            ],
            "name": "dna",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthDna24",
          "filepath": "watson-health/dna/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
                }
              }
            ],
            "name": "dna",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthDna20",
          "filepath": "watson-health/dna/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
                }
              }
            ],
            "name": "dna",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthDna16",
          "filepath": "watson-health/dna/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
                }
              }
            ],
            "name": "dna",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Dna",
        "global": "WatsonHealthDna",
        "filepath": "watson-health/Dna.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dns-services",
      "friendlyName": "IBM Cloud® DNS services",
      "aliases": [
        "app",
        "application",
        "catalogue",
        "catalog",
        "DNS",
        "services",
        "domain",
        "name"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/dns-services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"20\" y=\"20\" width=\"10\" height=\"2\"/>\n  <rect x=\"20\" y=\"24\" width=\"6\" height=\"2\"/>\n  <path d=\"M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 20H30V22H20zM20 24H26V26H20z\"/><path d=\"M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z\"/></svg>",
            "info": {},
            "path": "32/dns-services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DnsServices32",
          "filepath": "dns-services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H26V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
                }
              }
            ],
            "name": "dns-services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DnsServices24",
          "filepath": "dns-services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H26V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
                }
              }
            ],
            "name": "dns-services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DnsServices20",
          "filepath": "dns-services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H26V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
                }
              }
            ],
            "name": "dns-services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DnsServices16",
          "filepath": "dns-services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H26V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
                }
              }
            ],
            "name": "dns-services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "DnsServices",
        "global": "DnsServices",
        "filepath": "DnsServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20H30V22H20zM20 24H26V26H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "DOC",
      "friendlyName": "DOC",
      "aliases": [
        "DOC"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/DOC.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>DOC</title><path d=\"M30,23H24a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H24V21h6Z\"/><path d=\"M18,23H14a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h4a2.002,2.002,0,0,1,2,2V21A2.0023,2.0023,0,0,1,18,23ZM14,11V21h4V11Z\"/><path d=\"M6,23H2V9H6a4.0045,4.0045,0,0,1,4,4v6A4.0045,4.0045,0,0,1,6,23ZM4,21H6a2.002,2.002,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z\"/></svg>",
            "info": {},
            "path": "32/DOC.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Doc32",
          "filepath": "DOC/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z"
                }
              }
            ],
            "name": "DOC",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Doc24",
          "filepath": "DOC/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z"
                }
              }
            ],
            "name": "DOC",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Doc20",
          "filepath": "DOC/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z"
                }
              }
            ],
            "name": "DOC",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Doc16",
          "filepath": "DOC/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z"
                }
              }
            ],
            "name": "DOC",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Doc",
        "global": "Doc",
        "filepath": "Doc.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document",
      "friendlyName": "Document",
      "aliases": [
        "file",
        "doc",
        "paper"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>document</title>\n<path d=\"M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3\n\tz M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z\"/>\n<rect x=\"10\" y=\"22\" width=\"12\" height=\"2\"/>\n<rect x=\"10\" y=\"16\" width=\"12\" height=\"2\"/>\n<rect class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3\tz M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z\"/><path d=\"M10 22H22V24H10zM10 16H22V18H10z\"/></svg>",
            "info": {},
            "path": "32/document.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Document32",
          "filepath": "document/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3\tz M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 22H22V24H10zM10 16H22V18H10z"
                }
              }
            ],
            "name": "document",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Document24",
          "filepath": "document/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3\tz M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 22H22V24H10zM10 16H22V18H10z"
                }
              }
            ],
            "name": "document",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Document20",
          "filepath": "document/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3\tz M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 22H22V24H10zM10 16H22V18H10z"
                }
              }
            ],
            "name": "document",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Document16",
          "filepath": "document/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3\tz M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 22H22V24H10zM10 16H22V18H10z"
                }
              }
            ],
            "name": "document",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Document",
        "global": "Document",
        "filepath": "Document.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3 z M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 22H22V24H10zM10 16H22V18H10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--add",
      "friendlyName": "Document add",
      "aliases": [
        "file",
        "doc",
        "paper"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 24 26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24\"/>\n  <path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z\"/><path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentAdd32",
          "filepath": "document--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentAdd24",
          "filepath": "document--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentAdd20",
          "filepath": "document--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentAdd16",
          "filepath": "document--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentAdd",
        "global": "DocumentAdd",
        "filepath": "DocumentAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--attachment",
      "friendlyName": "Document attachment",
      "aliases": [
        "file",
        "doc",
        "paper",
        "attachment",
        "paper clip",
        "attach"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--attachment.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z\"/>\n  <rect x=\"17\" y=\"10\" width=\"7\" height=\"2\"/>\n  <rect x=\"16\" y=\"15\" width=\"8\" height=\"2\"/>\n  <rect x=\"15\" y=\"20\" width=\"9\" height=\"2\"/>\n  <path d=\"M9,19a5.0055,5.0055,0,0,1-5-5V3H6V14a3,3,0,0,0,6,0V5a1,1,0,0,0-2,0V15H8V5a3,3,0,0,1,6,0v9A5.0055,5.0055,0,0,1,9,19Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z\"/><path d=\"M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z\"/></svg>",
            "info": {},
            "path": "32/document--attachment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentAttachment32",
          "filepath": "document--attachment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z"
                }
              }
            ],
            "name": "document--attachment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentAttachment24",
          "filepath": "document--attachment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z"
                }
              }
            ],
            "name": "document--attachment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentAttachment20",
          "filepath": "document--attachment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z"
                }
              }
            ],
            "name": "document--attachment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentAttachment16",
          "filepath": "document--attachment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z"
                }
              }
            ],
            "name": "document--attachment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentAttachment",
        "global": "DocumentAttachment",
        "filepath": "DocumentAttachment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--audio",
      "friendlyName": "Document audio",
      "aliases": [
        "doc",
        "file",
        "audio"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--audio.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z\"/>\n  <path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z\"/><path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--audio.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentAudio32",
          "filepath": "document--audio/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--audio",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentAudio24",
          "filepath": "document--audio/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--audio",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentAudio20",
          "filepath": "document--audio/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--audio",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentAudio16",
          "filepath": "document--audio/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--audio",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentAudio",
        "global": "DocumentAudio",
        "filepath": "DocumentAudio.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--blank",
      "friendlyName": "Document blank",
      "aliases": [
        "file",
        "doc",
        "paper"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--blank.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>document--blank</title><path d=\"M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z\"/></svg>",
            "info": {},
            "path": "32/document--blank.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentBlank32",
          "filepath": "document--blank/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document--blank",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentBlank24",
          "filepath": "document--blank/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document--blank",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentBlank20",
          "filepath": "document--blank/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document--blank",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentBlank16",
          "filepath": "document--blank/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document--blank",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentBlank",
        "global": "DocumentBlank",
        "filepath": "DocumentBlank.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--download",
      "friendlyName": "Document download",
      "aliases": [
        "document download",
        "download",
        "document",
        "file",
        "doc",
        "paper"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--download.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>document--download</title>\n  <polygon points=\"30 25 28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25\"/>\n  <path d=\"M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z\"/><path d=\"M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--download.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentDownload32",
          "filepath": "document--download/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--download",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentDownload24",
          "filepath": "document--download/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--download",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentDownload20",
          "filepath": "document--download/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--download",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentDownload16",
          "filepath": "document--download/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--download",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentDownload",
        "global": "DocumentDownload",
        "filepath": "DocumentDownload.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--epdf",
      "friendlyName": "Document ePDF",
      "aliases": [
        "file",
        "PDF",
        "ePDF",
        "electronic",
        "digital",
        "interactive",
        "publication"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--epdf.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z\"/>\n  <path d=\"M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z\"/><path d=\"M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--epdf.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentEpdf32",
          "filepath": "document--epdf/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--epdf",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentEpdf24",
          "filepath": "document--epdf/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--epdf",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentEpdf20",
          "filepath": "document--epdf/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--epdf",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentEpdf16",
          "filepath": "document--epdf/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--epdf",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentEpdf",
        "global": "DocumentEpdf",
        "filepath": "DocumentEpdf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--export",
      "friendlyName": "Document export",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document export"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--export.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>document--export</title><polygon points=\"13 21 26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21\"/><path d=\"M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z\"/><path d=\"M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z\"/></svg>",
            "info": {},
            "path": "32/document--export.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentExport32",
          "filepath": "document--export/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
                }
              }
            ],
            "name": "document--export",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentExport24",
          "filepath": "document--export/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
                }
              }
            ],
            "name": "document--export",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentExport20",
          "filepath": "document--export/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
                }
              }
            ],
            "name": "document--export",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentExport16",
          "filepath": "document--export/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
                }
              }
            ],
            "name": "document--export",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentExport",
        "global": "DocumentExport",
        "filepath": "DocumentExport.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--horizontal",
      "friendlyName": "Document horizontal",
      "aliases": [
        "file",
        "doc",
        "paper",
        "horizontal",
        "document",
        "orientation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--horizontal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z\"/>\n  <path d=\"M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z\"/><path d=\"M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z\"/></svg>",
            "info": {},
            "path": "32/document--horizontal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentHorizontal32",
          "filepath": "document--horizontal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
                }
              }
            ],
            "name": "document--horizontal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentHorizontal24",
          "filepath": "document--horizontal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
                }
              }
            ],
            "name": "document--horizontal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentHorizontal20",
          "filepath": "document--horizontal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
                }
              }
            ],
            "name": "document--horizontal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentHorizontal16",
          "filepath": "document--horizontal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
                }
              }
            ],
            "name": "document--horizontal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DocumentHorizontal",
        "global": "DocumentHorizontal",
        "filepath": "DocumentHorizontal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--import",
      "friendlyName": "Document import",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document import"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--import.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>document--import</title><polygon points=\"28 19 14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19\"/><path d=\"M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z\"/><path d=\"M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z\"/></svg>",
            "info": {},
            "path": "32/document--import.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentImport32",
          "filepath": "document--import/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
                }
              }
            ],
            "name": "document--import",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentImport24",
          "filepath": "document--import/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
                }
              }
            ],
            "name": "document--import",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentImport20",
          "filepath": "document--import/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
                }
              }
            ],
            "name": "document--import",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentImport16",
          "filepath": "document--import/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
                }
              }
            ],
            "name": "document--import",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentImport",
        "global": "DocumentImport",
        "filepath": "DocumentImport.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--pdf",
      "friendlyName": "Document pdf",
      "aliases": [
        "document pdf",
        "pdf",
        "document format",
        "portable document format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--pdf.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>document--pdf</title>\n  <polygon points=\"30 18 30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18\"/>\n  <path d=\"M19,26H15V16h4a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,19,26Zm-2-2h2a1.0011,1.0011,0,0,0,1-1V19a1.0011,1.0011,0,0,0-1-1H17Z\"/>\n  <path d=\"M11,16H6V26H8V23h3a2.0027,2.0027,0,0,0,2-2V18A2.0023,2.0023,0,0,0,11,16ZM8,21V18h3l.001,3Z\"/>\n  <path d=\"M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z\"/><path d=\"M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z\"/></svg>",
            "info": {},
            "path": "32/document--pdf.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentPdf32",
          "filepath": "document--pdf/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
                }
              }
            ],
            "name": "document--pdf",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentPdf24",
          "filepath": "document--pdf/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
                }
              }
            ],
            "name": "document--pdf",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentPdf20",
          "filepath": "document--pdf/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
                }
              }
            ],
            "name": "document--pdf",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentPdf16",
          "filepath": "document--pdf/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
                }
              }
            ],
            "name": "document--pdf",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentPdf",
        "global": "DocumentPdf",
        "filepath": "DocumentPdf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--preliminary",
      "friendlyName": "Document preliminary",
      "aliases": [
        "document",
        "preliminary",
        "file",
        "draft"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--preliminary.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,30a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z\"/>\n  <rect x=\"8\" y=\"22\" width=\"8\" height=\"2\"/>\n  <rect x=\"8\" y=\"16\" width=\"10\" height=\"2\"/>\n  <path d=\"M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z\"/><path d=\"M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z\"/></svg>",
            "info": {},
            "path": "32/document--preliminary.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentPreliminary32",
          "filepath": "document--preliminary/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--preliminary",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentPreliminary24",
          "filepath": "document--preliminary/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--preliminary",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentPreliminary20",
          "filepath": "document--preliminary/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--preliminary",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentPreliminary16",
          "filepath": "document--preliminary/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--preliminary",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentPreliminary",
        "global": "DocumentPreliminary",
        "filepath": "DocumentPreliminary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--protected",
      "friendlyName": "Document protected",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document protected",
        "lock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--protected.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z\"/><path d=\"M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z\"/></svg>",
            "info": {},
            "path": "32/document--protected.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentProtected32",
          "filepath": "document--protected/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              }
            ],
            "name": "document--protected",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentProtected24",
          "filepath": "document--protected/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              }
            ],
            "name": "document--protected",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentProtected20",
          "filepath": "document--protected/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              }
            ],
            "name": "document--protected",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentProtected16",
          "filepath": "document--protected/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              }
            ],
            "name": "document--protected",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentProtected",
        "global": "DocumentProtected",
        "filepath": "DocumentProtected.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--security",
      "friendlyName": "Document security",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document security",
        "shield"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--security.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z\"/><path d=\"M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z\"/></svg>",
            "info": {},
            "path": "32/document--security.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentSecurity32",
          "filepath": "document--security/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--security",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentSecurity24",
          "filepath": "document--security/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--security",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentSecurity20",
          "filepath": "document--security/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--security",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentSecurity16",
          "filepath": "document--security/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                }
              }
            ],
            "name": "document--security",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentSecurity",
        "global": "DocumentSecurity",
        "filepath": "DocumentSecurity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--signed",
      "friendlyName": "Document signed",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document signed",
        "key",
        "encryption"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--signed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"25\" cy=\"20\" r=\"1\"/>\n  <rect x=\"8\" y=\"6\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"14\" width=\"6\" height=\"2\"/>\n  <rect x=\"8\" y=\"24\" width=\"4\" height=\"2\"/>\n  <path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z\"/><circle cx=\"25\" cy=\"20\" r=\"1\"/><path d=\"M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z\"/><path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z\"/></svg>",
            "info": {},
            "path": "32/document--signed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentSigned32",
          "filepath": "document--signed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
                }
              }
            ],
            "name": "document--signed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentSigned24",
          "filepath": "document--signed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
                }
              }
            ],
            "name": "document--signed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentSigned20",
          "filepath": "document--signed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
                }
              }
            ],
            "name": "document--signed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentSigned16",
          "filepath": "document--signed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
                }
              }
            ],
            "name": "document--signed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentSigned",
        "global": "DocumentSigned",
        "filepath": "DocumentSigned.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--sketch",
      "friendlyName": "Document Sketch",
      "aliases": [
        "doc",
        "file",
        "Sketch",
        "wireframe"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--sketch.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z\"/>\n  <path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z\"/><path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--sketch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentSketch32",
          "filepath": "document--sketch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--sketch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentSketch24",
          "filepath": "document--sketch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--sketch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentSketch20",
          "filepath": "document--sketch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--sketch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentSketch16",
          "filepath": "document--sketch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--sketch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentSketch",
        "global": "DocumentSketch",
        "filepath": "DocumentSketch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--subtract",
      "friendlyName": "Document subtract",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document subtract"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--subtract.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"20\" y=\"24\" width=\"10\" height=\"2\"/>\n  <path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 24H30V26H20z\"/><path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--subtract.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentSubtract32",
          "filepath": "document--subtract/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H30V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--subtract",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentSubtract24",
          "filepath": "document--subtract/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H30V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--subtract",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentSubtract20",
          "filepath": "document--subtract/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H30V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--subtract",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentSubtract16",
          "filepath": "document--subtract/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H30V26H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--subtract",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentSubtract",
        "global": "DocumentSubtract",
        "filepath": "DocumentSubtract.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 24H30V26H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--tasks",
      "friendlyName": "Document tasks",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document tasks"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--tasks.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 27.18 19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18\"/>\n  <path d=\"M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z\"/><path d=\"M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--tasks.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentTasks32",
          "filepath": "document--tasks/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--tasks",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentTasks24",
          "filepath": "document--tasks/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--tasks",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentTasks20",
          "filepath": "document--tasks/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--tasks",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentTasks16",
          "filepath": "document--tasks/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--tasks",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentTasks",
        "global": "DocumentTasks",
        "filepath": "DocumentTasks.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--unknown",
      "friendlyName": "Document unknown",
      "aliases": [
        "document unknown",
        "document",
        "unknown"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--unknown.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>document--unknown</title>\n  <circle cx=\"8.9999\" cy=\"28.5\" r=\"1.5\"/>\n  <path d=\"M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z\"/>\n  <path d=\"M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"28.5\" r=\"1.5\"/><path d=\"M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z\"/><path d=\"M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z\"/></svg>",
            "info": {},
            "path": "32/document--unknown.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentUnknown32",
          "filepath": "document--unknown/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "28.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
                }
              }
            ],
            "name": "document--unknown",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentUnknown24",
          "filepath": "document--unknown/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "28.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
                }
              }
            ],
            "name": "document--unknown",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentUnknown20",
          "filepath": "document--unknown/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "28.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
                }
              }
            ],
            "name": "document--unknown",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentUnknown16",
          "filepath": "document--unknown/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "28.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
                }
              }
            ],
            "name": "document--unknown",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentUnknown",
        "global": "DocumentUnknown",
        "filepath": "DocumentUnknown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "28.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--unprotected",
      "friendlyName": "Document unprotected",
      "aliases": [
        "file",
        "doc",
        "paper",
        "document unprotected",
        "unlocked",
        "lock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--unprotected.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z\"/><path d=\"M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z\"/></svg>",
            "info": {},
            "path": "32/document--unprotected.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentUnprotected32",
          "filepath": "document--unprotected/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
                }
              }
            ],
            "name": "document--unprotected",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentUnprotected24",
          "filepath": "document--unprotected/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
                }
              }
            ],
            "name": "document--unprotected",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentUnprotected20",
          "filepath": "document--unprotected/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
                }
              }
            ],
            "name": "document--unprotected",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentUnprotected16",
          "filepath": "document--unprotected/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
                }
              }
            ],
            "name": "document--unprotected",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentUnprotected",
        "global": "DocumentUnprotected",
        "filepath": "DocumentUnprotected.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--vertical",
      "friendlyName": "Document vertical",
      "aliases": [
        "file",
        "doc",
        "paper",
        "horizontal",
        "document",
        "orientation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--vertical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z\"/>\n  <path d=\"M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z\"/><path d=\"M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z\"/></svg>",
            "info": {},
            "path": "32/document--vertical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentVertical32",
          "filepath": "document--vertical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
                }
              }
            ],
            "name": "document--vertical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentVertical24",
          "filepath": "document--vertical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
                }
              }
            ],
            "name": "document--vertical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentVertical20",
          "filepath": "document--vertical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
                }
              }
            ],
            "name": "document--vertical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentVertical16",
          "filepath": "document--vertical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
                }
              }
            ],
            "name": "document--vertical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DocumentVertical",
        "global": "DocumentVertical",
        "filepath": "DocumentVertical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--video",
      "friendlyName": "Document video",
      "aliases": [
        "doc",
        "file",
        "video",
        "movie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--video.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z\"/>\n  <path d=\"M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z\"/><path d=\"M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--video.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentVideo32",
          "filepath": "document--video/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--video",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentVideo24",
          "filepath": "document--video/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--video",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentVideo20",
          "filepath": "document--video/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--video",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentVideo16",
          "filepath": "document--video/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--video",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentVideo",
        "global": "DocumentVideo",
        "filepath": "DocumentVideo.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--view",
      "friendlyName": "Document view",
      "aliases": [
        "document view",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>document--view</title><circle cx=\"22\" cy=\"24\" r=\"2\"/><path id=\"_inner_path_\" data-name=\"&lt;inner path&gt;\" class=\"cls-1\" d=\"M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z\"/><path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/><path d=\"M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22\" cy=\"24\" r=\"2\"/><path fill=\"none\" d=\"M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z\"/><path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/><path d=\"M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentView32",
          "filepath": "document--view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentView24",
          "filepath": "document--view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentView20",
          "filepath": "document--view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentView16",
          "filepath": "document--view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "document--view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentView",
        "global": "DocumentView",
        "filepath": "DocumentView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--word-processor",
      "friendlyName": "Document word processor",
      "aliases": [
        "document word processor",
        "word processor",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--word-processor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"28.3 20 27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20\"/>\n  <path d=\"M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z\"/><path d=\"M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z\"/></svg>",
            "info": {},
            "path": "32/document--word-processor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentWordProcessor32",
          "filepath": "document--word-processor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--word-processor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentWordProcessor24",
          "filepath": "document--word-processor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--word-processor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentWordProcessor20",
          "filepath": "document--word-processor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--word-processor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentWordProcessor16",
          "filepath": "document--word-processor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                }
              }
            ],
            "name": "document--word-processor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentWordProcessor",
        "global": "DocumentWordProcessor",
        "filepath": "DocumentWordProcessor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document--word-processor--reference",
      "friendlyName": "Document word processor reference",
      "aliases": [
        "document",
        "document word processor",
        "word processor",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document--word-processor--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"28.3 20 27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20\"/>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V16H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,10V4.4141L23.5859,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z\"/></svg>",
            "info": {},
            "path": "32/document--word-processor--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentWordProcessorReference32",
          "filepath": "document--word-processor--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z"
                }
              }
            ],
            "name": "document--word-processor--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentWordProcessorReference24",
          "filepath": "document--word-processor--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z"
                }
              }
            ],
            "name": "document--word-processor--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentWordProcessorReference20",
          "filepath": "document--word-processor--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z"
                }
              }
            ],
            "name": "document--word-processor--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentWordProcessorReference16",
          "filepath": "document--word-processor--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z"
                }
              }
            ],
            "name": "document--word-processor--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "DocumentWordProcessorReference",
        "global": "DocumentWordProcessorReference",
        "filepath": "DocumentWordProcessorReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "document-sentiment",
      "friendlyName": "Document sentiment",
      "aliases": [
        "emotion",
        "meaning",
        "understanding",
        "document sentiment",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/document-sentiment.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>document-sentiment</title><path d=\"M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z\" transform=\"translate(0)\"/><path d=\"M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z\"/><path d=\"M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z\"/></svg>",
            "info": {},
            "path": "32/document-sentiment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DocumentSentiment32",
          "filepath": "document-sentiment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document-sentiment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DocumentSentiment24",
          "filepath": "document-sentiment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document-sentiment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DocumentSentiment20",
          "filepath": "document-sentiment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document-sentiment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DocumentSentiment16",
          "filepath": "document-sentiment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "document-sentiment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DocumentSentiment",
        "global": "DocumentSentiment",
        "filepath": "DocumentSentiment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dog-walker",
      "friendlyName": "Dog walker",
      "aliases": [
        "user",
        "person",
        "pet",
        "dog",
        "walker",
        "human",
        "people",
        "recreation",
        "exercise"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/dog-walker.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"20\" y=\"20\" width=\"2\" height=\"10\"/>\n  <rect x=\"4\" y=\"23\" width=\"2\" height=\"7\"/>\n  <path d=\"M16,30H14V26a1.0011,1.0011,0,0,0-1-1H11v5H9V23h4a3.0033,3.0033,0,0,1,3,3Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M7.5,22A3.5041,3.5041,0,0,1,4,18.5V17H2V15H6v3.5a1.5,1.5,0,0,0,3,0V15h4v2H11v1.5A3.5041,3.5041,0,0,1,7.5,22Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M27,10H21.354a2.9861,2.9861,0,0,0-2.7856,1.8857l-1.4419,3.6055-3.6079,4.51,1.562,1.249,3.7-4.625,1.645-3.9961A.9949.9949,0,0,1,21.354,12H27a1.0009,1.0009,0,0,1,1,1v7H25V30h2V22h1a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,27,10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,3Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 20H22V30H20zM4 23H6V30H4z\"/><path d=\"M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z\"/></svg>",
            "info": {},
            "path": "32/dog-walker.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DogWalker32",
          "filepath": "dog-walker/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H22V30H20zM4 23H6V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z"
                }
              }
            ],
            "name": "dog-walker",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DogWalker24",
          "filepath": "dog-walker/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H22V30H20zM4 23H6V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z"
                }
              }
            ],
            "name": "dog-walker",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DogWalker20",
          "filepath": "dog-walker/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H22V30H20zM4 23H6V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z"
                }
              }
            ],
            "name": "dog-walker",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DogWalker16",
          "filepath": "dog-walker/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H22V30H20zM4 23H6V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z"
                }
              }
            ],
            "name": "dog-walker",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "DogWalker",
        "global": "DogWalker",
        "filepath": "DogWalker.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20H22V30H20zM4 23H6V30H4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "dot-mark",
      "friendlyName": "Dot mark",
      "aliases": [
        "dot mark",
        "dot",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/dot-mark.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>dot-mark</title><circle cx=\"16\" cy=\"16\" r=\"8\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"8\"/></svg>",
            "info": {},
            "path": "32/dot-mark.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DotMark32",
          "filepath": "dot-mark/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "8"
                }
              }
            ],
            "name": "dot-mark",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DotMark24",
          "filepath": "dot-mark/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "8"
                }
              }
            ],
            "name": "dot-mark",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DotMark20",
          "filepath": "dot-mark/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "8"
                }
              }
            ],
            "name": "dot-mark",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DotMark16",
          "filepath": "dot-mark/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "8"
                }
              }
            ],
            "name": "dot-mark",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DotMark",
        "global": "DotMark",
        "filepath": "DotMark.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "8"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "double-integer",
      "friendlyName": "Double integer",
      "aliases": [
        "integer",
        "double integer",
        "hashtag"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/double-integer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>double-integer</title>\n  <path d=\"M17,8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8Zm-6,3H8V8h3Z\"/>\n  <path d=\"M30,21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21Zm-6,3H21V21h3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z\"/></svg>",
            "info": {},
            "path": "32/double-integer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DoubleInteger32",
          "filepath": "double-integer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z"
                }
              }
            ],
            "name": "double-integer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DoubleInteger24",
          "filepath": "double-integer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z"
                }
              }
            ],
            "name": "double-integer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DoubleInteger20",
          "filepath": "double-integer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z"
                }
              }
            ],
            "name": "double-integer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DoubleInteger16",
          "filepath": "double-integer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z"
                }
              }
            ],
            "name": "double-integer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DoubleInteger",
        "global": "DoubleInteger",
        "filepath": "DoubleInteger.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "down-to-bottom",
      "friendlyName": "Down to bottom",
      "aliases": [
        "jump to bottom",
        "down",
        "footer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/down-to-bottom.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>down-to-bottom</title>\n<polygon points=\"16,18 6,8 7.4,6.6 16,15.2 24.6,6.6 26,8 \"/>\n<rect x=\"4\" y=\"22\" width=\"24\" height=\"2\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z\"/></svg>",
            "info": {},
            "path": "32/down-to-bottom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DownToBottom32",
          "filepath": "down-to-bottom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z"
                }
              }
            ],
            "name": "down-to-bottom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DownToBottom24",
          "filepath": "down-to-bottom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z"
                }
              }
            ],
            "name": "down-to-bottom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DownToBottom20",
          "filepath": "down-to-bottom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z"
                }
              }
            ],
            "name": "down-to-bottom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DownToBottom16",
          "filepath": "down-to-bottom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z"
                }
              }
            ],
            "name": "down-to-bottom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "DownToBottom",
        "global": "DownToBottom",
        "filepath": "DownToBottom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "download",
      "friendlyName": "Download",
      "aliases": [
        "install",
        "download"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/download.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>download</title>\n<polygon points=\"13,7 12.3,6.3 8.5,10.1 8.5,1 7.5,1 7.5,10.1 3.7,6.3 3,7 8,12 \"/>\n<path d=\"M13,12v2H3v-2H2v2l0,0c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1l0,0v-2H13z\"/>\n<rect class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13 7L12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12zM13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13z\"/></svg>",
            "info": {},
            "path": "16/download.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/download.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,24v4H6V24H4v4H4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2h0V24Z\"/>\n  <polygon points=\"26 14 24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14\"/>\n  <g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\">\n    <rect class=\"cls-1\" width=\"32\" height=\"32\"/>\n  </g>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z\"/></svg>",
            "info": {},
            "path": "32/download.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Download32",
          "filepath": "download/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
                }
              }
            ],
            "name": "download",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Download24",
          "filepath": "download/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
                }
              }
            ],
            "name": "download",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Download20",
          "filepath": "download/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
                }
              }
            ],
            "name": "download",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Download16",
          "filepath": "download/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 7L12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12zM13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13z"
                }
              }
            ],
            "name": "download",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Download",
        "global": "Download",
        "filepath": "Download.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 7L12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12zM13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "download-study",
      "friendlyName": "Download study",
      "aliases": [
        "download study",
        "download",
        "learn"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/download-study.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>download-study</title>\n  <polygon points=\"30 25 28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25\"/>\n  <rect x=\"19\" y=\"14\" width=\"4\" height=\"2\"/>\n  <rect x=\"19\" y=\"10\" width=\"7\" height=\"2\"/>\n  <path d=\"M9,18h6a3,3,0,0,1,3,3v2H16V21a1,1,0,0,0-1-1H9a1,1,0,0,0-1,1v2H6V21A3,3,0,0,1,9,18Z\"/>\n  <path d=\"M16,13a4,4,0,1,0-4,4A4,4,0,0,0,16,13Zm-2,0a2,2,0,1,1-2-2A2,2,0,0,1,14,13Z\"/>\n  <path d=\"M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z\"/><path d=\"M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/download-study.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthDownloadStudy32",
          "filepath": "watson-health/download-study/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
                }
              }
            ],
            "name": "download-study",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthDownloadStudy24",
          "filepath": "watson-health/download-study/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
                }
              }
            ],
            "name": "download-study",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthDownloadStudy20",
          "filepath": "watson-health/download-study/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
                }
              }
            ],
            "name": "download-study",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthDownloadStudy16",
          "filepath": "watson-health/download-study/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
                }
              }
            ],
            "name": "download-study",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "DownloadStudy",
        "global": "WatsonHealthDownloadStudy",
        "filepath": "watson-health/DownloadStudy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drag--horizontal",
      "friendlyName": "Drag horizontal",
      "aliases": [
        "expand",
        "drop",
        "move",
        "expand",
        "drop",
        "move"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drag--horizontal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>drag--horizontal</title><polygon points=\"12 4 12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4\"/><polygon points=\"25 11 23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z\"/></svg>",
            "info": {},
            "path": "32/drag--horizontal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DragHorizontal32",
          "filepath": "drag--horizontal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "drag--horizontal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DragHorizontal24",
          "filepath": "drag--horizontal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "drag--horizontal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DragHorizontal20",
          "filepath": "drag--horizontal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "drag--horizontal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DragHorizontal16",
          "filepath": "drag--horizontal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "drag--horizontal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "DragHorizontal",
        "global": "DragHorizontal",
        "filepath": "DragHorizontal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drag--vertical",
      "friendlyName": "Drag vertical",
      "aliases": [
        "expand",
        "drop",
        "move",
        "expand",
        "drop",
        "move"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drag--vertical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>drag--vertical</title><polygon points=\"4 20 15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20\"/><polygon points=\"11 7 12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z\"/></svg>",
            "info": {},
            "path": "32/drag--vertical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DragVertical32",
          "filepath": "drag--vertical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
                }
              }
            ],
            "name": "drag--vertical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DragVertical24",
          "filepath": "drag--vertical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
                }
              }
            ],
            "name": "drag--vertical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DragVertical20",
          "filepath": "drag--vertical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
                }
              }
            ],
            "name": "drag--vertical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DragVertical16",
          "filepath": "drag--vertical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
                }
              }
            ],
            "name": "drag--vertical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "DragVertical",
        "global": "DragVertical",
        "filepath": "DragVertical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "draggable",
      "friendlyName": "Draggable",
      "aliases": [
        "handle",
        "drag"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/draggable.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>draggable</title>\n<rect x=\"10\" y=\"6\" width=\"4\" height=\"4\"/>\n<rect x=\"18\" y=\"6\" width=\"4\" height=\"4\"/>\n<rect x=\"10\" y=\"14\" width=\"4\" height=\"4\"/>\n<rect x=\"18\" y=\"14\" width=\"4\" height=\"4\"/>\n<rect x=\"10\" y=\"22\" width=\"4\" height=\"4\"/>\n<rect x=\"18\" y=\"22\" width=\"4\" height=\"4\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z\"/></svg>",
            "info": {},
            "path": "32/draggable.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Draggable32",
          "filepath": "draggable/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z"
                }
              }
            ],
            "name": "draggable",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Draggable24",
          "filepath": "draggable/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z"
                }
              }
            ],
            "name": "draggable",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Draggable20",
          "filepath": "draggable/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z"
                }
              }
            ],
            "name": "draggable",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Draggable16",
          "filepath": "draggable/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z"
                }
              }
            ],
            "name": "draggable",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Draggable",
        "global": "Draggable",
        "filepath": "Draggable.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "draw",
      "friendlyName": "Draw",
      "aliases": [
        "squiggle",
        "drawing",
        "graphic",
        "line",
        "doodle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/draw.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>draw</title><path d=\"M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z\"/></svg>",
            "info": {},
            "path": "32/draw.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Draw32",
          "filepath": "draw/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
                }
              }
            ],
            "name": "draw",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Draw24",
          "filepath": "draw/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
                }
              }
            ],
            "name": "draw",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Draw20",
          "filepath": "draw/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
                }
              }
            ],
            "name": "draw",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Draw16",
          "filepath": "draw/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
                }
              }
            ],
            "name": "draw",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Draw",
        "global": "Draw",
        "filepath": "Draw.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drill-back",
      "friendlyName": "Drill back",
      "aliases": [
        "drill",
        "back",
        "operation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drill-back.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"6 22 7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22\"/>\n  <path d=\"M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z\"/>\n  <path d=\"M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z\"/><path d=\"M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z\"/><path d=\"M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/drill-back.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DrillBack32",
          "filepath": "drill-back/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
                }
              }
            ],
            "name": "drill-back",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DrillBack24",
          "filepath": "drill-back/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
                }
              }
            ],
            "name": "drill-back",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DrillBack20",
          "filepath": "drill-back/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
                }
              }
            ],
            "name": "drill-back",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DrillBack16",
          "filepath": "drill-back/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
                }
              }
            ],
            "name": "drill-back",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "DrillBack",
        "global": "DrillBack",
        "filepath": "DrillBack.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drill-down",
      "friendlyName": "Drill down",
      "aliases": [
        "drill",
        "down",
        "operation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drill-down.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"10 6 11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6\"/>\n  <path d=\"M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z\"/>\n  <path d=\"M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z\"/><path d=\"M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z\"/><path d=\"M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z\"/></svg>",
            "info": {},
            "path": "32/drill-down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DrillDown32",
          "filepath": "drill-down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
                }
              }
            ],
            "name": "drill-down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DrillDown24",
          "filepath": "drill-down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
                }
              }
            ],
            "name": "drill-down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DrillDown20",
          "filepath": "drill-down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
                }
              }
            ],
            "name": "drill-down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DrillDown16",
          "filepath": "drill-down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
                }
              }
            ],
            "name": "drill-down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "DrillDown",
        "global": "DrillDown",
        "filepath": "DrillDown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drill-through",
      "friendlyName": "Drill through",
      "aliases": [
        "drill",
        "through",
        "operation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drill-through.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z\"/>\n  <polygon points=\"4 12 4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12\"/>\n  <path d=\"M16,10v6H10a6,6,0,1,0,6-6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z\"/><path d=\"M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12zM16 10v6H10a6 6 0 106-6z\"/></svg>",
            "info": {},
            "path": "32/drill-through.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DrillThrough32",
          "filepath": "drill-through/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12zM16 10v6H10a6 6 0 106-6z"
                }
              }
            ],
            "name": "drill-through",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DrillThrough24",
          "filepath": "drill-through/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12zM16 10v6H10a6 6 0 106-6z"
                }
              }
            ],
            "name": "drill-through",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DrillThrough20",
          "filepath": "drill-through/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12zM16 10v6H10a6 6 0 106-6z"
                }
              }
            ],
            "name": "drill-through",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DrillThrough16",
          "filepath": "drill-through/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12zM16 10v6H10a6 6 0 106-6z"
                }
              }
            ],
            "name": "drill-through",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "DrillThrough",
        "global": "DrillThrough",
        "filepath": "DrillThrough.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12zM16 10v6H10a6 6 0 106-6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drink--01",
      "friendlyName": "drink--01",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drink--01.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z\"/>\n  <path d=\"M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z\"/><path d=\"M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z\"/></svg>",
            "info": {},
            "path": "32/drink--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Drink_0132",
          "filepath": "drink--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
                }
              }
            ],
            "name": "drink--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Drink_0124",
          "filepath": "drink--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
                }
              }
            ],
            "name": "drink--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Drink_0120",
          "filepath": "drink--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
                }
              }
            ],
            "name": "drink--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Drink_0116",
          "filepath": "drink--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
                }
              }
            ],
            "name": "drink--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Drink_01",
        "global": "Drink_01",
        "filepath": "Drink_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drink--02",
      "friendlyName": "drink--02",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drink--02.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z\"/>\n  <path d=\"M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z\"/><path d=\"M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z\"/></svg>",
            "info": {},
            "path": "32/drink--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Drink_0232",
          "filepath": "drink--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
                }
              }
            ],
            "name": "drink--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Drink_0224",
          "filepath": "drink--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
                }
              }
            ],
            "name": "drink--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Drink_0220",
          "filepath": "drink--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
                }
              }
            ],
            "name": "drink--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Drink_0216",
          "filepath": "drink--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
                }
              }
            ],
            "name": "drink--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Drink_02",
        "global": "Drink_02",
        "filepath": "Drink_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "driver-analysis",
      "friendlyName": "Driver analysis",
      "aliases": [
        "driver analysis",
        "analysis",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/driver-analysis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"22\" cy=\"16\" r=\"2\"/>\n  <path d=\"M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22\" cy=\"16\" r=\"2\"/><path d=\"M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z\"/></svg>",
            "info": {},
            "path": "32/driver-analysis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DriverAnalysis32",
          "filepath": "driver-analysis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
                }
              }
            ],
            "name": "driver-analysis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DriverAnalysis24",
          "filepath": "driver-analysis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
                }
              }
            ],
            "name": "driver-analysis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DriverAnalysis20",
          "filepath": "driver-analysis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
                }
              }
            ],
            "name": "driver-analysis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DriverAnalysis16",
          "filepath": "driver-analysis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
                }
              }
            ],
            "name": "driver-analysis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "DriverAnalysis",
        "global": "DriverAnalysis",
        "filepath": "DriverAnalysis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drone",
      "friendlyName": "Drone",
      "aliases": [
        "drone",
        "robot",
        "remote control",
        "unmanned"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drone.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M7,12a5,5,0,1,1,5-5H10a3,3,0,1,0-3,3Z\"/>\n  <path d=\"M25,12V10a3,3,0,1,0-3-3H20a5,5,0,1,1,5,5Z\"/>\n  <path d=\"M7,30A5,5,0,0,1,7,20v2a3,3,0,1,0,3,3h2A5.0055,5.0055,0,0,1,7,30Z\"/>\n  <path d=\"M25,30a5.0055,5.0055,0,0,1-5-5h2a3,3,0,1,0,3-3V20a5,5,0,0,1,0,10Z\"/>\n  <path d=\"M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z\"/><path d=\"M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z\"/></svg>",
            "info": {},
            "path": "32/drone.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Drone32",
          "filepath": "drone/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
                }
              }
            ],
            "name": "drone",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Drone24",
          "filepath": "drone/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
                }
              }
            ],
            "name": "drone",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Drone20",
          "filepath": "drone/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
                }
              }
            ],
            "name": "drone",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Drone16",
          "filepath": "drone/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
                }
              }
            ],
            "name": "drone",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Drone",
        "global": "Drone",
        "filepath": "Drone.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drone--delivery",
      "friendlyName": "Drone delivery",
      "aliases": [
        "drone",
        "delivery",
        "technology",
        "commerce",
        "retail",
        "robot",
        "remote control",
        "unmanned"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drone--delivery.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,30H12V22h8Zm-6-2h4V24H14Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"32 11 22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11\"/>\n  <path d=\"M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,30H12V22h8Zm-6-2h4V24H14Z\"/><path d=\"M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z\"/><path d=\"M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z\"/></svg>",
            "info": {},
            "path": "32/drone--delivery.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DroneDelivery32",
          "filepath": "drone--delivery/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H12V22h8Zm-6-2h4V24H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--delivery",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DroneDelivery24",
          "filepath": "drone--delivery/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H12V22h8Zm-6-2h4V24H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--delivery",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DroneDelivery20",
          "filepath": "drone--delivery/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H12V22h8Zm-6-2h4V24H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--delivery",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DroneDelivery16",
          "filepath": "drone--delivery/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H12V22h8Zm-6-2h4V24H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--delivery",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "DroneDelivery",
        "global": "DroneDelivery",
        "filepath": "DroneDelivery.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,30H12V22h8Zm-6-2h4V24H14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drone--front",
      "friendlyName": "Drone front",
      "aliases": [
        "drone",
        "technology",
        "robot",
        "remote control",
        "unmanned"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drone--front.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,19V15H26v2H6V15H4v4h7v4.4116L7,25.6367V30H9V26.8125L12.26,25h7.481L23,26.8125V30h2V25.6367l-4-2.2251V19Zm-9,4H13V19h6Z\" transform=\"translate(0 0)\"/>\n  <rect y=\"11\" width=\"10\" height=\"2\"/>\n  <rect x=\"22\" y=\"11\" width=\"10\" height=\"2\"/>\n  <path d=\"M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z\"/><path d=\"M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z\"/></svg>",
            "info": {},
            "path": "32/drone--front.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DroneFront32",
          "filepath": "drone--front/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--front",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DroneFront24",
          "filepath": "drone--front/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--front",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DroneFront20",
          "filepath": "drone--front/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--front",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DroneFront16",
          "filepath": "drone--front/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--front",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "DroneFront",
        "global": "DroneFront",
        "filepath": "DroneFront.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drone--video",
      "friendlyName": "Drone video",
      "aliases": [
        "drone",
        "video",
        "technology",
        "monitoring",
        "camera",
        "robot",
        "remote control",
        "unmanned",
        "visual"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drone--video.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"21\" r=\"1\"/>\n  <path d=\"M28,19V15H26v2H6V15H4v4h7v4.4116L7,25.6367V30H9V26.8125L12.26,25h7.481L23,26.8125V30h2V25.6367l-4-2.2251V19Zm-9,4H13V19h6Z\" transform=\"translate(0 0)\"/>\n  <rect y=\"11\" width=\"10\" height=\"2\"/>\n  <rect x=\"22\" y=\"11\" width=\"10\" height=\"2\"/>\n  <path d=\"M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"21\" r=\"1\"/><path d=\"M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z\"/><path d=\"M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z\"/></svg>",
            "info": {},
            "path": "32/drone--video.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DroneVideo32",
          "filepath": "drone--video/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--video",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DroneVideo24",
          "filepath": "drone--video/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--video",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DroneVideo20",
          "filepath": "drone--video/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--video",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DroneVideo16",
          "filepath": "drone--video/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                }
              }
            ],
            "name": "drone--video",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "DroneVideo",
        "global": "DroneVideo",
        "filepath": "DroneVideo.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "21",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drop-photo",
      "friendlyName": "Drop photo",
      "aliases": [
        "drop photo",
        "photo dropping",
        "photo sharing",
        "camera"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drop-photo.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>drop-photo</title><path class=\"cls-1\" d=\"M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z\"/><path class=\"cls-1\" d=\"M27,29H11a2,2,0,0,1-2-2V18a2,2,0,0,1,2-2h3.2793l.5441-1.6324A2,2,0,0,1,16.7208,13h4.5584a2,2,0,0,1,1.8974,1.3676L23.7207,16H27a2,2,0,0,1,2,2v9A2,2,0,0,1,27,29ZM11,27H27V18H22.2792l-1-3H16.7207l-1,3H11Z\"/><rect class=\"cls-1\" x=\"27\" y=\"11\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"27\" y=\"7\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"27\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"23\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"19\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"15\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"11\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"7\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"7\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"11\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"15\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"19\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"23\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"27\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z\"/><path d=\"M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z\"/></svg>",
            "info": {},
            "path": "32/drop-photo.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DropPhoto32",
          "filepath": "drop-photo/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DropPhoto24",
          "filepath": "drop-photo/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DropPhoto20",
          "filepath": "drop-photo/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DropPhoto16",
          "filepath": "drop-photo/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DropPhoto",
        "global": "DropPhoto",
        "filepath": "DropPhoto.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drop-photo--filled",
      "friendlyName": "Drop photo filled",
      "aliases": [
        "drop photo filled",
        "photo dropping filled",
        "photo sharing",
        "camera"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drop-photo--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>drop-photo--filled</title><circle class=\"cls-1\" cx=\"19\" cy=\"22\" r=\"2\"/><path class=\"cls-1\" d=\"M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z\"/><path id=\"inner-path\" class=\"cls-2\" d=\"M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z\"/><rect class=\"cls-1\" x=\"27\" y=\"11\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"27\" y=\"7\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"27\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"23\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"19\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"15\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"11\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"7\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"3\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"7\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"11\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"15\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"19\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"23\" width=\"2\" height=\"2\"/><rect class=\"cls-1\" x=\"3\" y=\"27\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"19\" cy=\"22\" r=\"2\"/><path d=\"M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z\"/><path fill=\"none\" d=\"M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z\" data-icon-path=\"inner-path\"/><path d=\"M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z\"/></svg>",
            "info": {},
            "path": "32/drop-photo--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "DropPhotoFilled32",
          "filepath": "drop-photo--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "DropPhotoFilled24",
          "filepath": "drop-photo--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "DropPhotoFilled20",
          "filepath": "drop-photo--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "DropPhotoFilled16",
          "filepath": "drop-photo--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                }
              }
            ],
            "name": "drop-photo--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "DropPhotoFilled",
        "global": "DropPhotoFilled",
        "filepath": "DropPhotoFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "19",
                    "cy": "22",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "drought",
      "friendlyName": "Drought",
      "aliases": [
        "drought",
        "precipitation",
        "weather",
        "agriculture",
        "food",
        "production"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/drought.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z\"/></svg>",
            "info": {},
            "path": "32/drought.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Drought32",
          "filepath": "drought/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
                }
              }
            ],
            "name": "drought",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Drought24",
          "filepath": "drought/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
                }
              }
            ],
            "name": "drought",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Drought20",
          "filepath": "drought/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
                }
              }
            ],
            "name": "drought",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Drought16",
          "filepath": "drought/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
                }
              }
            ],
            "name": "drought",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Drought",
        "global": "Drought",
        "filepath": "Drought.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "DVR",
      "friendlyName": "DVR",
      "aliases": [
        "record",
        "digital",
        "video",
        "recorder",
        "cable",
        "TV"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/DVR.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>DVR</title><path d=\"M30,15V11a2,2,0,0,0-2-2H22V23h2V17h1.48l2.34,6H30l-2.33-6H28A2,2,0,0,0,30,15Zm-6-4h4v4H24Z\"/><polygon points=\"18 9 16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9\"/><path d=\"M6,23H2V9H6a4,4,0,0,1,4,4v6A4,4,0,0,1,6,23ZM4,21H6a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z\"/></svg>",
            "info": {},
            "path": "32/DVR.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Dvr32",
          "filepath": "DVR/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z"
                }
              }
            ],
            "name": "DVR",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Dvr24",
          "filepath": "DVR/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z"
                }
              }
            ],
            "name": "DVR",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Dvr20",
          "filepath": "DVR/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z"
                }
              }
            ],
            "name": "DVR",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Dvr16",
          "filepath": "DVR/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z"
                }
              }
            ],
            "name": "DVR",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Dvr",
        "global": "Dvr",
        "filepath": "Dvr.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth",
      "friendlyName": "Earth",
      "aliases": [
        "earth",
        "world",
        "globe"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>earth</title><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z\"/></svg>",
            "info": {},
            "path": "32/earth.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Earth32",
          "filepath": "earth/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
                }
              }
            ],
            "name": "earth",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Earth24",
          "filepath": "earth/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
                }
              }
            ],
            "name": "earth",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Earth20",
          "filepath": "earth/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
                }
              }
            ],
            "name": "earth",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Earth16",
          "filepath": "earth/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
                }
              }
            ],
            "name": "earth",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Earth",
        "global": "Earth",
        "filepath": "Earth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth--americas",
      "friendlyName": "Earth Americas",
      "aliases": [
        "earth",
        "earth Americas",
        "Americas"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth--americas.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>americas</title><path d=\"M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z\"/></svg>",
            "info": {},
            "path": "32/earth--americas.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EarthAmericas32",
          "filepath": "earth--americas/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
                }
              }
            ],
            "name": "earth--americas",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EarthAmericas24",
          "filepath": "earth--americas/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
                }
              }
            ],
            "name": "earth--americas",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EarthAmericas20",
          "filepath": "earth--americas/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
                }
              }
            ],
            "name": "earth--americas",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EarthAmericas16",
          "filepath": "earth--americas/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
                }
              }
            ],
            "name": "earth--americas",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "EarthAmericas",
        "global": "EarthAmericas",
        "filepath": "EarthAmericas.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth--americas--filled",
      "friendlyName": "Earth Americas filled",
      "aliases": [
        "earth",
        "earth Americas filled",
        "Americas filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth--americas--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>earth--americas--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z\"/></svg>",
            "info": {},
            "path": "32/earth--americas--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EarthAmericasFilled32",
          "filepath": "earth--americas--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
                }
              }
            ],
            "name": "earth--americas--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EarthAmericasFilled24",
          "filepath": "earth--americas--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
                }
              }
            ],
            "name": "earth--americas--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EarthAmericasFilled20",
          "filepath": "earth--americas--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
                }
              }
            ],
            "name": "earth--americas--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EarthAmericasFilled16",
          "filepath": "earth--americas--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
                }
              }
            ],
            "name": "earth--americas--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "EarthAmericasFilled",
        "global": "EarthAmericasFilled",
        "filepath": "EarthAmericasFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth--europe-africa",
      "friendlyName": "Earth Europe Africa",
      "aliases": [
        "earth",
        "earth Europe Africa",
        "Europe Africa"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth--europe-africa.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>europe-africa</title><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z\"/></svg>",
            "info": {},
            "path": "32/earth--europe-africa.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EarthEuropeAfrica32",
          "filepath": "earth--europe-africa/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--europe-africa",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EarthEuropeAfrica24",
          "filepath": "earth--europe-africa/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--europe-africa",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EarthEuropeAfrica20",
          "filepath": "earth--europe-africa/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--europe-africa",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EarthEuropeAfrica16",
          "filepath": "earth--europe-africa/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--europe-africa",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "EarthEuropeAfrica",
        "global": "EarthEuropeAfrica",
        "filepath": "EarthEuropeAfrica.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth--europe-africa--filled",
      "friendlyName": "Earth Europe Africa filled",
      "aliases": [
        "earth",
        "earth Europe Africa filled",
        "Europe Africa filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth--europe-africa--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>earth--europe-africa--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z\"/></svg>",
            "info": {},
            "path": "32/earth--europe-africa--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EarthEuropeAfricaFilled32",
          "filepath": "earth--europe-africa--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
                }
              }
            ],
            "name": "earth--europe-africa--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EarthEuropeAfricaFilled24",
          "filepath": "earth--europe-africa--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
                }
              }
            ],
            "name": "earth--europe-africa--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EarthEuropeAfricaFilled20",
          "filepath": "earth--europe-africa--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
                }
              }
            ],
            "name": "earth--europe-africa--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EarthEuropeAfricaFilled16",
          "filepath": "earth--europe-africa--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
                }
              }
            ],
            "name": "earth--europe-africa--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "EarthEuropeAfricaFilled",
        "global": "EarthEuropeAfricaFilled",
        "filepath": "EarthEuropeAfricaFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth--filled",
      "friendlyName": "Earth filled",
      "aliases": [
        "earth",
        "earth filled",
        "globe",
        "globe filled",
        "world filled",
        "world"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>earth--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/earth--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EarthFilled32",
          "filepath": "earth--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
                }
              }
            ],
            "name": "earth--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EarthFilled24",
          "filepath": "earth--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
                }
              }
            ],
            "name": "earth--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EarthFilled20",
          "filepath": "earth--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
                }
              }
            ],
            "name": "earth--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EarthFilled16",
          "filepath": "earth--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
                }
              }
            ],
            "name": "earth--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "EarthFilled",
        "global": "EarthFilled",
        "filepath": "EarthFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth--southeast-asia",
      "friendlyName": "Earth Southeast Asia",
      "aliases": [
        "earth",
        "earth Southeast Asia",
        "Southeast Asia",
        "globe Southeast Asia",
        "world Southeast Asia"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth--southeast-asia.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>earth--southeast-asia</title><rect x=\"14\" y=\"24\" width=\"3\" height=\"2\"/><rect x=\"17\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"18\" width=\"2\" height=\"2\"/><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z\"/></svg>",
            "info": {},
            "path": "32/earth--southeast-asia.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EarthSoutheastAsia32",
          "filepath": "earth--southeast-asia/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--southeast-asia",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EarthSoutheastAsia24",
          "filepath": "earth--southeast-asia/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--southeast-asia",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EarthSoutheastAsia20",
          "filepath": "earth--southeast-asia/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--southeast-asia",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EarthSoutheastAsia16",
          "filepath": "earth--southeast-asia/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
                }
              }
            ],
            "name": "earth--southeast-asia",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "EarthSoutheastAsia",
        "global": "EarthSoutheastAsia",
        "filepath": "EarthSoutheastAsia.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earth--southeast-asia--filled",
      "friendlyName": "Earth Southeast Asia filled",
      "aliases": [
        "earth",
        "earth Southeast Asia filled",
        "Southeast Asia filled",
        "globe Southeast Asia filled",
        "world Southeast Asia filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earth--southeast-asia--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>earth--southeast-asia--filled</title><rect x=\"17\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"14\" y=\"24\" width=\"3\" height=\"2\"/><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z\"/></svg>",
            "info": {},
            "path": "32/earth--southeast-asia--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EarthSoutheastAsiaFilled32",
          "filepath": "earth--southeast-asia--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
                }
              }
            ],
            "name": "earth--southeast-asia--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EarthSoutheastAsiaFilled24",
          "filepath": "earth--southeast-asia--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
                }
              }
            ],
            "name": "earth--southeast-asia--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EarthSoutheastAsiaFilled20",
          "filepath": "earth--southeast-asia--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
                }
              }
            ],
            "name": "earth--southeast-asia--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EarthSoutheastAsiaFilled16",
          "filepath": "earth--southeast-asia--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
                }
              }
            ],
            "name": "earth--southeast-asia--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "EarthSoutheastAsiaFilled",
        "global": "EarthSoutheastAsiaFilled",
        "filepath": "EarthSoutheastAsiaFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "earthquake",
      "friendlyName": "Earthquake",
      "aliases": [
        "weather",
        "earthquake",
        "forecast",
        "disaster"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/earthquake.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z\"/></svg>",
            "info": {},
            "path": "32/earthquake.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Earthquake32",
          "filepath": "earthquake/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
                }
              }
            ],
            "name": "earthquake",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Earthquake24",
          "filepath": "earthquake/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
                }
              }
            ],
            "name": "earthquake",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Earthquake20",
          "filepath": "earthquake/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
                }
              }
            ],
            "name": "earthquake",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Earthquake16",
          "filepath": "earthquake/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
                }
              }
            ],
            "name": "earthquake",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Earthquake",
        "global": "Earthquake",
        "filepath": "Earthquake.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-cluster",
      "friendlyName": "Edge cluster",
      "aliases": [
        "edge",
        "cluster",
        "edge cluster",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edge-cluster.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,7a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,7Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,16,3Z\"/>\n  <path d=\"M11,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,11,26Z\"/>\n  <path d=\"M7,11a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,11ZM7,7A1,1,0,1,0,8,8,1.001,1.001,0,0,0,7,7Z\"/>\n  <path d=\"M21,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,21,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,21,26Z\"/>\n  <path d=\"M25,11a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,11Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,25,7Z\"/>\n  <path d=\"M4,21a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,4,21Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,4,17Z\"/>\n  <path d=\"M28,21a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,28,21Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,28,17Z\"/>\n  <path d=\"M16,22a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z\"/></svg>",
            "info": {},
            "path": "32/edge-cluster.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EdgeCluster32",
          "filepath": "edge-cluster/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              }
            ],
            "name": "edge-cluster",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EdgeCluster24",
          "filepath": "edge-cluster/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              }
            ],
            "name": "edge-cluster",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EdgeCluster20",
          "filepath": "edge-cluster/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              }
            ],
            "name": "edge-cluster",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EdgeCluster16",
          "filepath": "edge-cluster/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              }
            ],
            "name": "edge-cluster",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "EdgeCluster",
        "global": "EdgeCluster",
        "filepath": "EdgeCluster.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-device",
      "friendlyName": "Edge device",
      "aliases": [
        "edge",
        "edge device",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edge-device.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"9\" y=\"21\" width=\"14\" height=\"2\"/>\n  <path d=\"M11,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,11,14Z\"/>\n  <path d=\"M21,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,21,14Z\"/>\n  <path d=\"M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z\"/><path d=\"M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z\"/></svg>",
            "info": {},
            "path": "32/edge-device.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EdgeDevice32",
          "filepath": "edge-device/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "edge-device",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EdgeDevice24",
          "filepath": "edge-device/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "edge-device",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EdgeDevice20",
          "filepath": "edge-device/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "edge-device",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EdgeDevice16",
          "filepath": "edge-device/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
                }
              }
            ],
            "name": "edge-device",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "EdgeDevice",
        "global": "EdgeDevice",
        "filepath": "EdgeDevice.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-enhancement",
      "friendlyName": "Edge enhancement",
      "aliases": [
        "edge enhancement",
        "edge",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/edge-enhancement.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>edge-enhancement</title><path d=\"M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z\"/><path d=\"M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z\"/><path d=\"M16,26A10,10,0,0,0,16,6h0Z\"/><path d=\"M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z\"/><path d=\"M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/edge-enhancement.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthEdgeEnhancement32",
          "filepath": "watson-health/edge-enhancement/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
                }
              }
            ],
            "name": "edge-enhancement",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement24",
          "filepath": "watson-health/edge-enhancement/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
                }
              }
            ],
            "name": "edge-enhancement",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement20",
          "filepath": "watson-health/edge-enhancement/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
                }
              }
            ],
            "name": "edge-enhancement",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement16",
          "filepath": "watson-health/edge-enhancement/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
                }
              }
            ],
            "name": "edge-enhancement",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "EdgeEnhancement",
        "global": "WatsonHealthEdgeEnhancement",
        "filepath": "watson-health/EdgeEnhancement.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-enhancement--01",
      "friendlyName": "Edge enhancement 01",
      "aliases": [
        "edge enhancement 01",
        "edge",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/edge-enhancement--01.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26 28 26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28\"/>\n  <path d=\"M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z\"/>\n  <path d=\"M26,16A10,10,0,0,0,16,6V16Z\"/>\n  <path d=\"M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z\"/>\n  <path d=\"M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z\"/>\n  <path d=\"M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z\"/><path d=\"M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z\"/></svg>",
            "info": {},
            "path": "32/watson-health/edge-enhancement--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0132",
          "filepath": "watson-health/edge-enhancement--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0124",
          "filepath": "watson-health/edge-enhancement--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0120",
          "filepath": "watson-health/edge-enhancement--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0116",
          "filepath": "watson-health/edge-enhancement--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "EdgeEnhancement_01",
        "global": "WatsonHealthEdgeEnhancement_01",
        "filepath": "watson-health/EdgeEnhancement_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-enhancement--02",
      "friendlyName": "Edge enhancement 02",
      "aliases": [
        "edge enhancement 02",
        "edge",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/edge-enhancement--02.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H22V26a2.002,2.002,0,0,1,2-2h2V22H22V20h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H24v2h4Z\"/>\n  <path d=\"M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z\"/>\n  <path d=\"M26,16A10,10,0,0,0,16,6V16Z\"/>\n  <path d=\"M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z\"/>\n  <path d=\"M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z\"/>\n  <path d=\"M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z\"/><path d=\"M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z\"/></svg>",
            "info": {},
            "path": "32/watson-health/edge-enhancement--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0232",
          "filepath": "watson-health/edge-enhancement--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0224",
          "filepath": "watson-health/edge-enhancement--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0220",
          "filepath": "watson-health/edge-enhancement--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0216",
          "filepath": "watson-health/edge-enhancement--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "EdgeEnhancement_02",
        "global": "WatsonHealthEdgeEnhancement_02",
        "filepath": "watson-health/EdgeEnhancement_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-enhancement--03",
      "friendlyName": "Edge enhancement 03",
      "aliases": [
        "edge enhancement 03",
        "edge",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/edge-enhancement--03.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,20H22v2h4v2H23v2h3v2H22v2h4a2.0027,2.0027,0,0,0,2-2V22A2.0023,2.0023,0,0,0,26,20Z\"/>\n  <path d=\"M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z\"/>\n  <path d=\"M26,16A10,10,0,0,0,16,6V16Z\"/>\n  <path d=\"M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z\"/>\n  <path d=\"M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z\"/>\n  <path d=\"M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z\"/><path d=\"M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z\"/></svg>",
            "info": {},
            "path": "32/watson-health/edge-enhancement--03.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0332",
          "filepath": "watson-health/edge-enhancement--03/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--03",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0324",
          "filepath": "watson-health/edge-enhancement--03/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--03",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0320",
          "filepath": "watson-health/edge-enhancement--03/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--03",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthEdgeEnhancement_0316",
          "filepath": "watson-health/edge-enhancement--03/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                }
              }
            ],
            "name": "edge-enhancement--03",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "EdgeEnhancement_03",
        "global": "WatsonHealthEdgeEnhancement_03",
        "filepath": "watson-health/EdgeEnhancement_03.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-node",
      "friendlyName": "Edge node",
      "aliases": [
        "edge node",
        "edge",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edge-node.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"22\" y=\"6\" width=\"4\" height=\"4\"/>\n  <circle cx=\"7\" cy=\"7\" r=\"1\"/>\n  <circle cx=\"25\" cy=\"25\" r=\"1\"/>\n  <circle cx=\"25\" cy=\"21\" r=\"1\"/>\n  <circle cx=\"25\" cy=\"17\" r=\"1\"/>\n  <path d=\"M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z\"/>\n  <path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 6H26V10H22z\"/><circle cx=\"7\" cy=\"7\" r=\"1\"/><circle cx=\"25\" cy=\"25\" r=\"1\"/><circle cx=\"25\" cy=\"21\" r=\"1\"/><circle cx=\"25\" cy=\"17\" r=\"1\"/><path d=\"M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z\"/><path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/></svg>",
            "info": {},
            "path": "32/edge-node.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EdgeNode32",
          "filepath": "edge-node/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6H26V10H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "edge-node",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EdgeNode24",
          "filepath": "edge-node/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6H26V10H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "edge-node",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EdgeNode20",
          "filepath": "edge-node/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6H26V10H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "edge-node",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EdgeNode16",
          "filepath": "edge-node/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 6H26V10H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "edge-node",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "EdgeNode",
        "global": "EdgeNode",
        "filepath": "EdgeNode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 6H26V10H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "21",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-node--alt",
      "friendlyName": "Edge node alt",
      "aliases": [
        "edge node",
        "edge",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edge-node--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"24\" r=\"1\"/>\n  <path d=\"M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z\"/><circle cx=\"7\" cy=\"8\" r=\"1\"/><circle cx=\"7\" cy=\"16\" r=\"1\"/><circle cx=\"7\" cy=\"24\" r=\"1\"/><path d=\"M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z\"/></svg>",
            "info": {},
            "path": "32/edge-node--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EdgeNodeAlt32",
          "filepath": "edge-node--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
                }
              }
            ],
            "name": "edge-node--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EdgeNodeAlt24",
          "filepath": "edge-node--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
                }
              }
            ],
            "name": "edge-node--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EdgeNodeAlt20",
          "filepath": "edge-node--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
                }
              }
            ],
            "name": "edge-node--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EdgeNodeAlt16",
          "filepath": "edge-node--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
                }
              }
            ],
            "name": "edge-node--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "EdgeNodeAlt",
        "global": "EdgeNodeAlt",
        "filepath": "EdgeNodeAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "24",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edge-service",
      "friendlyName": "Edge service",
      "aliases": [
        "edge",
        "edge service",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edge-service.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"7\" y=\"11\" width=\"2\" height=\"10\"/>\n  <rect x=\"11\" y=\"11\" width=\"2\" height=\"10\"/>\n  <rect x=\"15\" y=\"11\" width=\"2\" height=\"10\"/>\n  <rect x=\"19\" y=\"11\" width=\"2\" height=\"10\"/>\n  <rect x=\"23\" y=\"11\" width=\"2\" height=\"10\"/>\n  <path d=\"M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z\"/><path d=\"M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z\"/></svg>",
            "info": {},
            "path": "32/edge-service.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EdgeService32",
          "filepath": "edge-service/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "edge-service",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EdgeService24",
          "filepath": "edge-service/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "edge-service",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EdgeService20",
          "filepath": "edge-service/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "edge-service",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EdgeService16",
          "filepath": "edge-service/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
                }
              }
            ],
            "name": "edge-service",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "EdgeService",
        "global": "EdgeService",
        "filepath": "EdgeService.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edit",
      "friendlyName": "Edit",
      "aliases": [
        "modify",
        "pencil",
        "change"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edit.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>edit</title>\n<rect x=\"2\" y=\"26\" width=\"28\" height=\"2\"/>\n<path d=\"M25.4,9c0.8-0.8,0.8-2,0-2.8c0,0,0,0,0,0l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0c0,0,0,0,0,0l-15,15V24h6.4L25.4,9z M20.4,4L24,7.6\n\tl-3,3L17.4,7L20.4,4z M6,22v-3.6l10-10l3.6,3.6l-10,10H6z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z\"/></svg>",
            "info": {},
            "path": "32/edit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Edit32",
          "filepath": "edit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"
                }
              }
            ],
            "name": "edit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Edit24",
          "filepath": "edit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"
                }
              }
            ],
            "name": "edit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Edit20",
          "filepath": "edit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"
                }
              }
            ],
            "name": "edit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Edit16",
          "filepath": "edit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"
                }
              }
            ],
            "name": "edit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Edit",
        "global": "Edit",
        "filepath": "Edit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edit--off",
      "friendlyName": "Edit off",
      "aliases": [
        "modify",
        "pencil",
        "change"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edit--off.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>Asset 2</title>\n<path d=\"M30,28.6L3.4,2L2,3.4l10.1,10.1L4,21.6V28h6.4l8.1-8.1L28.6,30L30,28.6z M9.6,26H6v-3.6l7.5-7.5l3.6,3.6L9.6,26z\"/>\n<path d=\"M29.4,6.2L29.4,6.2l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0l0,0l0,0l-8,8l1.4,1.4L20,8.4l3.6,3.6L20,15.6l1.4,1.4l8-8\n\tC30.2,8.2,30.2,7,29.4,6.2L29.4,6.2z M25,10.6L21.4,7l3-3L28,7.6L25,10.6z\"/>\n<rect class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z\"/></svg>",
            "info": {},
            "path": "32/edit--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EditOff32",
          "filepath": "edit--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z"
                }
              }
            ],
            "name": "edit--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EditOff24",
          "filepath": "edit--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z"
                }
              }
            ],
            "name": "edit--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EditOff20",
          "filepath": "edit--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z"
                }
              }
            ],
            "name": "edit--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EditOff16",
          "filepath": "edit--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z"
                }
              }
            ],
            "name": "edit--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "EditOff",
        "global": "EditOff",
        "filepath": "EditOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "edt-loop",
      "friendlyName": "EDT loop",
      "aliases": [
        "version",
        "iteration",
        "repeat",
        "loop",
        "editing",
        "recycle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/edt-loop.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>edt-loop</title><path d=\"M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z\"/></svg>",
            "info": {},
            "path": "32/edt-loop.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EdtLoop32",
          "filepath": "edt-loop/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
                }
              }
            ],
            "name": "edt-loop",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EdtLoop24",
          "filepath": "edt-loop/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
                }
              }
            ],
            "name": "edt-loop",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EdtLoop20",
          "filepath": "edt-loop/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
                }
              }
            ],
            "name": "edt-loop",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EdtLoop16",
          "filepath": "edt-loop/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
                }
              }
            ],
            "name": "edt-loop",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "EdtLoop",
        "global": "EdtLoop",
        "filepath": "EdtLoop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "education",
      "friendlyName": "Education",
      "aliases": [
        "graduation",
        "scholarship",
        "student",
        "university",
        "study",
        "school",
        "college"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/education.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>education</title><path d=\"M26,30H24V27a5.0059,5.0059,0,0,0-5-5H13a5.0059,5.0059,0,0,0-5,5v3H6V27a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z\"/><path d=\"M5,6A1,1,0,0,0,4,7v9H6V7A1,1,0,0,0,5,6Z\"/><path d=\"M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z\"/><path d=\"M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z\"/></svg>",
            "info": {},
            "path": "32/education.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Education32",
          "filepath": "education/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
                }
              }
            ],
            "name": "education",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Education24",
          "filepath": "education/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
                }
              }
            ],
            "name": "education",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Education20",
          "filepath": "education/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
                }
              }
            ],
            "name": "education",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Education16",
          "filepath": "education/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
                }
              }
            ],
            "name": "education",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Education",
        "global": "Education",
        "filepath": "Education.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "email",
      "friendlyName": "Email",
      "aliases": [
        "mail",
        "contact",
        "envelope",
        "post",
        "send"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/email.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>email</title><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z\"/></svg>",
            "info": {},
            "path": "32/email.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Email32",
          "filepath": "email/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
                }
              }
            ],
            "name": "email",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Email24",
          "filepath": "email/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
                }
              }
            ],
            "name": "email",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Email20",
          "filepath": "email/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
                }
              }
            ],
            "name": "email",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Email16",
          "filepath": "email/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
                }
              }
            ],
            "name": "email",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Email",
        "global": "Email",
        "filepath": "Email.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "email--new",
      "friendlyName": "Email new",
      "aliases": [
        "email new",
        "new email",
        "mail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/email--new.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>email--new</title><path d=\"M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z\"/><circle cx=\"26\" cy=\"24\" r=\"4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z\"/><circle cx=\"26\" cy=\"24\" r=\"4\"/></svg>",
            "info": {},
            "path": "32/email--new.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EmailNew32",
          "filepath": "email--new/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "24",
                  "r": "4"
                }
              }
            ],
            "name": "email--new",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EmailNew24",
          "filepath": "email--new/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "24",
                  "r": "4"
                }
              }
            ],
            "name": "email--new",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EmailNew20",
          "filepath": "email--new/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "24",
                  "r": "4"
                }
              }
            ],
            "name": "email--new",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EmailNew16",
          "filepath": "email--new/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "24",
                  "r": "4"
                }
              }
            ],
            "name": "email--new",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "EmailNew",
        "global": "EmailNew",
        "filepath": "EmailNew.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "24",
                    "r": "4"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "encryption",
      "friendlyName": "Encryption",
      "aliases": [
        "systems",
        "encryption",
        "data",
        "lock",
        "secure"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/encryption.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,21.2783V19a4,4,0,0,0-8,0v2.2783A1.9935,1.9935,0,0,0,20,23v5a2.0025,2.0025,0,0,0,2,2h6a2.0025,2.0025,0,0,0,2-2V23A1.9935,1.9935,0,0,0,29,21.2783ZM25,17a2.0025,2.0025,0,0,1,2,2v2H23V19A2.0025,2.0025,0,0,1,25,17ZM22,28V23h6v5Z\"/>\n  <rect x=\"2\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"14\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"18\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"2\" y=\"8\" width=\"2\" height=\"8\"/>\n  <rect x=\"2\" y=\"18\" width=\"2\" height=\"8\"/>\n  <rect x=\"14\" y=\"18\" width=\"2\" height=\"8\"/>\n  <rect x=\"6\" y=\"8\" width=\"2\" height=\"8\"/>\n  <rect x=\"18\" y=\"8\" width=\"2\" height=\"6\"/>\n  <path d=\"M10,26H8a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2h2a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,10,26ZM8,20v4h2V20Z\"/>\n  <path d=\"M14,16H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h2a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,14,16Zm-2-6v4h2V10Z\"/>\n  <path d=\"M10,6H8A2.0023,2.0023,0,0,1,6,4V2H8V4h2V2h2V4A2.0023,2.0023,0,0,1,10,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z\"/></svg>",
            "info": {},
            "path": "32/encryption.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Encryption32",
          "filepath": "encryption/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z"
                }
              }
            ],
            "name": "encryption",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Encryption24",
          "filepath": "encryption/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z"
                }
              }
            ],
            "name": "encryption",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Encryption20",
          "filepath": "encryption/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z"
                }
              }
            ],
            "name": "encryption",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Encryption16",
          "filepath": "encryption/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z"
                }
              }
            ],
            "name": "encryption",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Encryption",
        "global": "Encryption",
        "filepath": "Encryption.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "energy--renewable",
      "friendlyName": "Energy renewable",
      "aliases": [
        "energy",
        "renewable",
        "conservation",
        "weather",
        "green",
        "resource"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/energy--renewable.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z\"/></svg>",
            "info": {},
            "path": "32/energy--renewable.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EnergyRenewable32",
          "filepath": "energy--renewable/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
                }
              }
            ],
            "name": "energy--renewable",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EnergyRenewable24",
          "filepath": "energy--renewable/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
                }
              }
            ],
            "name": "energy--renewable",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EnergyRenewable20",
          "filepath": "energy--renewable/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
                }
              }
            ],
            "name": "energy--renewable",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EnergyRenewable16",
          "filepath": "energy--renewable/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
                }
              }
            ],
            "name": "energy--renewable",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "EnergyRenewable",
        "global": "EnergyRenewable",
        "filepath": "EnergyRenewable.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "enterprise",
      "friendlyName": "Enterprise",
      "aliases": [
        "enterprise",
        "building",
        "company"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/enterprise.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>enterprise</title><rect x=\"8\" y=\"8\" width=\"2\" height=\"4\"/><rect x=\"8\" y=\"14\" width=\"2\" height=\"4\"/><rect x=\"14\" y=\"8\" width=\"2\" height=\"4\"/><rect x=\"14\" y=\"14\" width=\"2\" height=\"4\"/><rect x=\"8\" y=\"20\" width=\"2\" height=\"4\"/><rect x=\"14\" y=\"20\" width=\"2\" height=\"4\"/><path d=\"M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z\"/><path d=\"M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z\"/></svg>",
            "info": {},
            "path": "32/enterprise.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Enterprise32",
          "filepath": "enterprise/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
                }
              }
            ],
            "name": "enterprise",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Enterprise24",
          "filepath": "enterprise/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
                }
              }
            ],
            "name": "enterprise",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Enterprise20",
          "filepath": "enterprise/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
                }
              }
            ],
            "name": "enterprise",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Enterprise16",
          "filepath": "enterprise/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
                }
              }
            ],
            "name": "enterprise",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Enterprise",
        "global": "Enterprise",
        "filepath": "Enterprise.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "equalizer",
      "friendlyName": "Equalizer",
      "aliases": [
        "equalizer",
        "sound",
        "audio",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/equalizer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"28\" width=\"8\" height=\"2\"/>\n  <rect x=\"2\" y=\"24\" width=\"8\" height=\"2\"/>\n  <rect x=\"12\" y=\"28\" width=\"8\" height=\"2\"/>\n  <rect x=\"12\" y=\"24\" width=\"8\" height=\"2\"/>\n  <rect x=\"2\" y=\"20\" width=\"8\" height=\"2\"/>\n  <rect x=\"12\" y=\"20\" width=\"8\" height=\"2\"/>\n  <rect x=\"2\" y=\"16\" width=\"8\" height=\"2\"/>\n  <rect x=\"12\" y=\"16\" width=\"8\" height=\"2\"/>\n  <rect x=\"12\" y=\"12\" width=\"8\" height=\"2\"/>\n  <rect x=\"12\" y=\"8\" width=\"8\" height=\"2\"/>\n  <rect x=\"12\" y=\"4\" width=\"8\" height=\"2\"/>\n  <rect x=\"22\" y=\"28\" width=\"8\" height=\"2\"/>\n  <rect x=\"22\" y=\"24\" width=\"8\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z\"/></svg>",
            "info": {},
            "path": "32/equalizer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Equalizer32",
          "filepath": "equalizer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z"
                }
              }
            ],
            "name": "equalizer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Equalizer24",
          "filepath": "equalizer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z"
                }
              }
            ],
            "name": "equalizer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Equalizer20",
          "filepath": "equalizer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z"
                }
              }
            ],
            "name": "equalizer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Equalizer16",
          "filepath": "equalizer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z"
                }
              }
            ],
            "name": "equalizer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Equalizer",
        "global": "Equalizer",
        "filepath": "Equalizer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "erase",
      "friendlyName": "Erase",
      "aliases": [
        "eraser",
        "remove",
        "clear",
        "rubber",
        "change",
        "edit",
        "rubber",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/erase.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>erase</title><rect x=\"7\" y=\"27\" width=\"23\" height=\"2\"/><path d=\"M27.38,10.51,19.45,2.59a2,2,0,0,0-2.83,0l-14,14a2,2,0,0,0,0,2.83L7.13,24h9.59L27.38,13.34A2,2,0,0,0,27.38,10.51ZM15.89,22H8L4,18l6.31-6.31,7.93,7.92Zm3.76-3.76-7.92-7.93L18,4,26,11.93Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z\"/></svg>",
            "info": {},
            "path": "32/erase.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Erase32",
          "filepath": "erase/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z"
                }
              }
            ],
            "name": "erase",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Erase24",
          "filepath": "erase/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z"
                }
              }
            ],
            "name": "erase",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Erase20",
          "filepath": "erase/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z"
                }
              }
            ],
            "name": "erase",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Erase16",
          "filepath": "erase/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z"
                }
              }
            ],
            "name": "erase",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Erase",
        "global": "Erase",
        "filepath": "Erase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "erase--3D",
      "friendlyName": "Erase 3D",
      "aliases": [
        "eraser",
        "remove",
        "clear",
        "rubber",
        "change",
        "edit",
        "rubber",
        "format",
        "erase 3D"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/erase--3D.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>erase--3D</title><path d=\"M30.4148,16.5132,22.488,8.5859a2.0014,2.0014,0,0,0-2.8291,0L5.6208,22.624a2.0024,2.0024,0,0,0,0,2.8291L10.1663,30h9.5908L30.4148,19.3413A2.001,2.001,0,0,0,30.4148,16.5132ZM18.929,28H10.9949l-3.96-3.9619,6.3123-6.3118,7.9276,7.9276Zm3.76-3.76-7.9276-7.9276L21.074,10l7.9267,7.9272Z\"/><path d=\"M11,12H8V2h3a3.0033,3.0033,0,0,1,3,3V9A3.0033,3.0033,0,0,1,11,12Zm-1-2h1a1.0009,1.0009,0,0,0,1-1V5a1.0009,1.0009,0,0,0-1-1H10Z\"/><path d=\"M4,2H0V4H4V6H1V8H4v2H0v2H4a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,4,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z\"/></svg>",
            "info": {},
            "path": "32/watson-health/erase--3D.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthErase_3D32",
          "filepath": "watson-health/erase--3D/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z"
                }
              }
            ],
            "name": "erase--3D",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthErase_3D24",
          "filepath": "watson-health/erase--3D/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z"
                }
              }
            ],
            "name": "erase--3D",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthErase_3D20",
          "filepath": "watson-health/erase--3D/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z"
                }
              }
            ],
            "name": "erase--3D",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthErase_3D16",
          "filepath": "watson-health/erase--3D/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z"
                }
              }
            ],
            "name": "erase--3D",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Erase_3D",
        "global": "WatsonHealthErase_3D",
        "filepath": "watson-health/Erase_3D.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "error",
      "friendlyName": "Error",
      "aliases": [
        "state",
        "stop",
        "alert",
        "issue"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/error.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>error</title><g id=\"Icon-2\" data-name=\"Icon\"><path d=\"M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z\" transform=\"translate(0)\"/></g><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z\"/></svg>",
            "info": {},
            "path": "32/error.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Error32",
          "filepath": "error/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
                }
              }
            ],
            "name": "error",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Error24",
          "filepath": "error/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
                }
              }
            ],
            "name": "error",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Error20",
          "filepath": "error/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
                }
              }
            ],
            "name": "error",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Error16",
          "filepath": "error/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
                }
              }
            ],
            "name": "error",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Error",
        "global": "Error",
        "filepath": "Error.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "error--filled",
      "friendlyName": "Error filled",
      "aliases": [
        "state",
        "stop",
        "alert",
        "issue"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/error--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z\"/><path fill=\"none\" d=\"M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "16/error--filled.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/error--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"20\" height=\"20\"/>\n<path d=\"M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z\"/><path d=\"M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "20/error--filled.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/error--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"24\" height=\"24\"/>\n<path d=\"M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z\"/><path fill=\"none\" d=\"M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "24/error--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/error--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect id=\"inner-path\" class=\"cls-1\" x=\"14.9004\" y=\"7.2004\" width=\"2.1996\" height=\"17.5994\" transform=\"translate(-6.6275 16.0001) rotate(-45)\"/>\n  <path d=\"M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M14.9 7.2H17.1V24.799H14.9z\" data-icon-path=\"inner-path\" transform=\"rotate(-45 16 16)\"/><path d=\"M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z\"/></svg>",
            "info": {},
            "path": "32/error--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ErrorFilled32",
          "filepath": "error--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.9 7.2H17.1V24.799H14.9z",
                  "data-icon-path": "inner-path",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z"
                }
              }
            ],
            "name": "error--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ErrorFilled24",
          "filepath": "error--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "error--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ErrorFilled20",
          "filepath": "error--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "error--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ErrorFilled16",
          "filepath": "error--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "error--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "ErrorFilled",
        "global": "ErrorFilled",
        "filepath": "ErrorFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M14.9 7.2H17.1V24.799H14.9z",
                    "data-icon-path": "inner-path",
                    "transform": "rotate(-45 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "error--outline",
      "friendlyName": "Error outline",
      "aliases": [
        "state",
        "stop",
        "alert",
        "issue"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/error--outline.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>checkmark</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n<rect x=\"7.4\" y=\"3.6\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -3.3137 8)\" width=\"1.1\" height=\"8.8\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/><path d=\"M7.4 3.6H8.5V12.4H7.4z\" transform=\"rotate(-45.001 8 8)\"/></svg>",
            "info": {},
            "path": "16/error--outline.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/error--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"14.9004\" y=\"7.2004\" width=\"2.1996\" height=\"17.5994\" transform=\"translate(-6.6275 16.0001) rotate(-45)\"/>\n  <path d=\"M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14.9 7.2H17.1V24.799H14.9z\" transform=\"rotate(-45 16 16)\"/><path d=\"M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/error--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ErrorOutline32",
          "filepath": "error--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.9 7.2H17.1V24.799H14.9z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
                }
              }
            ],
            "name": "error--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ErrorOutline24",
          "filepath": "error--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.9 7.2H17.1V24.799H14.9z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
                }
              }
            ],
            "name": "error--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ErrorOutline20",
          "filepath": "error--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.9 7.2H17.1V24.799H14.9z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
                }
              }
            ],
            "name": "error--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ErrorOutline16",
          "filepath": "error--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.4 3.6H8.5V12.4H7.4z",
                  "transform": "rotate(-45.001 8 8)"
                }
              }
            ],
            "name": "error--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "ErrorOutline",
        "global": "ErrorOutline",
        "filepath": "ErrorOutline.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.4 3.6H8.5V12.4H7.4z",
                    "transform": "rotate(-45.001 8 8)"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.9 7.2H17.1V24.799H14.9z",
                    "transform": "rotate(-45 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "event",
      "friendlyName": "Event",
      "aliases": [
        "calendar",
        "star",
        "date",
        "favorite",
        "schedule"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/event.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>event</title><path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/><polygon points=\"21 15 23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/><path d=\"M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z\"/></svg>",
            "info": {},
            "path": "32/event.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Event32",
          "filepath": "event/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
                }
              }
            ],
            "name": "event",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Event24",
          "filepath": "event/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
                }
              }
            ],
            "name": "event",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Event20",
          "filepath": "event/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
                }
              }
            ],
            "name": "event",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Event16",
          "filepath": "event/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
                }
              }
            ],
            "name": "event",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Event",
        "global": "Event",
        "filepath": "Event.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "event--schedule",
      "friendlyName": "Event schedule",
      "aliases": [
        "calendar",
        "star",
        "date",
        "favorite",
        "schedule"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/event--schedule.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>event-schedule</title><path d=\"M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z\"/><polygon points=\"22.59 25 20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25\"/><path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z\"/><path d=\"M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z\"/><path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/></svg>",
            "info": {},
            "path": "32/event--schedule.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EventSchedule32",
          "filepath": "event--schedule/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "event--schedule",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EventSchedule24",
          "filepath": "event--schedule/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "event--schedule",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EventSchedule20",
          "filepath": "event--schedule/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "event--schedule",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EventSchedule16",
          "filepath": "event--schedule/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "event--schedule",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "EventSchedule",
        "global": "EventSchedule",
        "filepath": "EventSchedule.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "events",
      "friendlyName": "Events",
      "aliases": [
        "people",
        "team",
        "group",
        "organization",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/events.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>events</title><path d=\"M26,14H24v2h2a3.0033,3.0033,0,0,1,3,3v4h2V19A5.0058,5.0058,0,0,0,26,14Z\" transform=\"translate(0 0)\"/><path d=\"M24,4a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,24,2Z\" transform=\"translate(0 0)\"/><path d=\"M23,30H21V28a3.0033,3.0033,0,0,0-3-3H14a3.0033,3.0033,0,0,0-3,3v2H9V28a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/><path d=\"M16,13a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,16,11Z\" transform=\"translate(0 0)\"/><path d=\"M8,14H6a5.0059,5.0059,0,0,0-5,5v4H3V19a3.0033,3.0033,0,0,1,3-3H8Z\" transform=\"translate(0 0)\"/><path d=\"M8,4A3,3,0,1,1,5,7,3,3,0,0,1,8,4M8,2a5,5,0,1,0,5,5A5,5,0,0,0,8,2Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z\"/></svg>",
            "info": {},
            "path": "32/events.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Events32",
          "filepath": "events/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "events",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Events24",
          "filepath": "events/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "events",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Events20",
          "filepath": "events/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "events",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Events16",
          "filepath": "events/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "events",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Events",
        "global": "Events",
        "filepath": "Events.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "events--alt",
      "friendlyName": "Events alt",
      "aliases": [
        "people",
        "team",
        "group",
        "organization",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/events--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>events--alt</title><path d=\"M18,31h2V29a1.0006,1.0006,0,0,1,1-1h6a1.0006,1.0006,0,0,1,1,1v2h2V29a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z\" transform=\"translate(0 0)\"/><path d=\"M24,25a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,24,25Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,24,19Z\" transform=\"translate(0 0)\"/><path d=\"M2,31H4V29a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V29a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3Z\" transform=\"translate(0 0)\"/><path d=\"M8,25a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,8,25Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,8,19Z\" transform=\"translate(0 0)\"/><path d=\"M18,16h2V14a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V14a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z\" transform=\"translate(0 0)\"/><path d=\"M24,10a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,24,10Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,24,4Z\" transform=\"translate(0 0)\"/><path d=\"M2,16H4V14a1.0013,1.0013,0,0,1,1-1h6a1.0013,1.0013,0,0,1,1,1v2h2V14a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3Z\" transform=\"translate(0 0)\"/><path d=\"M8,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,8,10ZM8,4a2,2,0,1,0,2,2A2.002,2.002,0,0,0,8,4Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z\"/></svg>",
            "info": {},
            "path": "32/events--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "EventsAlt32",
          "filepath": "events--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z"
                }
              }
            ],
            "name": "events--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "EventsAlt24",
          "filepath": "events--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z"
                }
              }
            ],
            "name": "events--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "EventsAlt20",
          "filepath": "events--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z"
                }
              }
            ],
            "name": "events--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "EventsAlt16",
          "filepath": "events--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z"
                }
              }
            ],
            "name": "events--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "EventsAlt",
        "global": "EventsAlt",
        "filepath": "EventsAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "exam-mode",
      "friendlyName": "Exam mode",
      "aliases": [
        "dev test",
        "testing",
        "test",
        "exam"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/exam-mode.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>exam-mode</title><path d=\"M25,23v3H7V16.83l3.59,3.58L12,19,6,13,0,19l1.41,1.41L5,16.83V26a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V23Z\"/><path d=\"M27,7v9.17l3.59-3.58L32,14l-6,6-6-6,1.41-1.41L25,16.17V7H13V5H25A2,2,0,0,1,27,7Z\"/><path d=\"M8,10H4A2,2,0,0,1,2,8V4A2,2,0,0,1,4,2H8a2,2,0,0,1,2,2V8A2,2,0,0,1,8,10ZM4,4V8H8V4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z\"/></svg>",
            "info": {},
            "path": "32/exam-mode.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ExamMode32",
          "filepath": "exam-mode/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "exam-mode",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ExamMode24",
          "filepath": "exam-mode/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "exam-mode",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ExamMode20",
          "filepath": "exam-mode/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "exam-mode",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ExamMode16",
          "filepath": "exam-mode/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "exam-mode",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ExamMode",
        "global": "ExamMode",
        "filepath": "ExamMode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "executable-program",
      "friendlyName": "executable-program",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/executable-program.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <polygon id=\"_Path_\" data-name=\"&amp;lt;Path&amp;gt;\" class=\"cls-2\" points=\"25 21 32 26 25 31 25 21\"/>\n  <polygon points=\"20.17 19 17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19\"/>\n  <polygon points=\"11.83 19 14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19\"/>\n  <circle cx=\"9\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"6\" cy=\"8\" r=\"1\"/>\n  <path d=\"M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M25 21L32 26 25 31 25 21z\"/><path d=\"M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z\"/><circle cx=\"9\" cy=\"8\" r=\"1\"/><circle cx=\"6\" cy=\"8\" r=\"1\"/><path d=\"M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z\"/></svg>",
            "info": {},
            "path": "32/executable-program.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ExecutableProgram32",
          "filepath": "executable-program/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25 21L32 26 25 31 25 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
                }
              }
            ],
            "name": "executable-program",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ExecutableProgram24",
          "filepath": "executable-program/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25 21L32 26 25 31 25 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
                }
              }
            ],
            "name": "executable-program",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ExecutableProgram20",
          "filepath": "executable-program/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25 21L32 26 25 31 25 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
                }
              }
            ],
            "name": "executable-program",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ExecutableProgram16",
          "filepath": "executable-program/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25 21L32 26 25 31 25 21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
                }
              }
            ],
            "name": "executable-program",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ExecutableProgram",
        "global": "ExecutableProgram",
        "filepath": "ExecutableProgram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M25 21L32 26 25 31 25 21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "exit",
      "friendlyName": "Exit",
      "aliases": [
        "leave",
        "quit",
        "escape"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/exit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>exit</title><rect x=\"26\" y=\"4\" width=\"2\" height=\"24\"/><polygon points=\"11.414 20.586 7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z\"/></svg>",
            "info": {},
            "path": "32/exit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Exit32",
          "filepath": "exit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
                }
              }
            ],
            "name": "exit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Exit24",
          "filepath": "exit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
                }
              }
            ],
            "name": "exit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Exit20",
          "filepath": "exit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
                }
              }
            ],
            "name": "exit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Exit16",
          "filepath": "exit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
                }
              }
            ],
            "name": "exit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Exit",
        "global": "Exit",
        "filepath": "Exit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "expand-all",
      "friendlyName": "Expand all",
      "aliases": [
        "expand all",
        "operations",
        "expand everything"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/expand-all.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>expand-all</title><path d=\"M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z\"/></svg>",
            "info": {},
            "path": "32/expand-all.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ExpandAll32",
          "filepath": "expand-all/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
                }
              }
            ],
            "name": "expand-all",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ExpandAll24",
          "filepath": "expand-all/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
                }
              }
            ],
            "name": "expand-all",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ExpandAll20",
          "filepath": "expand-all/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
                }
              }
            ],
            "name": "expand-all",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ExpandAll16",
          "filepath": "expand-all/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
                }
              }
            ],
            "name": "expand-all",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ExpandAll",
        "global": "ExpandAll",
        "filepath": "ExpandAll.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "expand-categories",
      "friendlyName": "Expand categories",
      "aliases": [
        "expand categories",
        "opertions",
        "expand",
        "categories"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/expand-categories.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>expand-categories</title><rect x=\"20\" y=\"26\" width=\"6\" height=\"2\"/><rect x=\"20\" y=\"18\" width=\"8\" height=\"2\"/><rect x=\"20\" y=\"10\" width=\"10\" height=\"2\"/><rect x=\"15\" y=\"4\" width=\"2\" height=\"24\"/><polygon points=\"10.586 3.959 7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z\"/></svg>",
            "info": {},
            "path": "32/expand-categories.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ExpandCategories32",
          "filepath": "expand-categories/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
                }
              }
            ],
            "name": "expand-categories",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ExpandCategories24",
          "filepath": "expand-categories/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
                }
              }
            ],
            "name": "expand-categories",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ExpandCategories20",
          "filepath": "expand-categories/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
                }
              }
            ],
            "name": "expand-categories",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ExpandCategories16",
          "filepath": "expand-categories/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
                }
              }
            ],
            "name": "expand-categories",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ExpandCategories",
        "global": "ExpandCategories",
        "filepath": "ExpandCategories.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "explore",
      "friendlyName": "Explore",
      "aliases": [
        "explore",
        "action"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/explore.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/explore.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Explore32",
          "filepath": "explore/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "explore",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Explore24",
          "filepath": "explore/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "explore",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Explore20",
          "filepath": "explore/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "explore",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Explore16",
          "filepath": "explore/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "explore",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Explore",
        "global": "Explore",
        "filepath": "Explore.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "export",
      "friendlyName": "Export",
      "aliases": [
        "ship",
        "send",
        "out",
        "export"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/export.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>export</title>\n<path d=\"M13,12v2H3v-2H2v2l0,0c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1l0,0v-2H13z\"/>\n<polygon points=\"3,6 3.7,6.7 7.5,2.9 7.5,12 8.5,12 8.5,2.9 12.3,6.7 13,6 8,1 \"/>\n<rect class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13zM3 6L3.7 6.7 7.5 2.9 7.5 12 8.5 12 8.5 2.9 12.3 6.7 13 6 8 1z\"/></svg>",
            "info": {},
            "path": "16/export.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/export.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,24v4H6V24H4v4l.0076-.0049A1.9977,1.9977,0,0,0,6,30H26a2,2,0,0,0,2-2h0V24Z\"/>\n  <polygon points=\"6 12 7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12\"/>\n  <g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\">\n    <rect class=\"cls-1\" width=\"32\" height=\"32\"/>\n  </g>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 24v4H6V24H4v4l.0076-.0049A1.9977 1.9977 0 006 30H26a2 2 0 002-2h0V24zM6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z\"/></svg>",
            "info": {},
            "path": "32/export.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Export32",
          "filepath": "export/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24v4H6V24H4v4l.0076-.0049A1.9977 1.9977 0 006 30H26a2 2 0 002-2h0V24zM6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
                }
              }
            ],
            "name": "export",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Export24",
          "filepath": "export/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24v4H6V24H4v4l.0076-.0049A1.9977 1.9977 0 006 30H26a2 2 0 002-2h0V24zM6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
                }
              }
            ],
            "name": "export",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Export20",
          "filepath": "export/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24v4H6V24H4v4l.0076-.0049A1.9977 1.9977 0 006 30H26a2 2 0 002-2h0V24zM6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
                }
              }
            ],
            "name": "export",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Export16",
          "filepath": "export/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13zM3 6L3.7 6.7 7.5 2.9 7.5 12 8.5 12 8.5 2.9 12.3 6.7 13 6 8 1z"
                }
              }
            ],
            "name": "export",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Export",
        "global": "Export",
        "filepath": "Export.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13zM3 6L3.7 6.7 7.5 2.9 7.5 12 8.5 12 8.5 2.9 12.3 6.7 13 6 8 1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 24v4H6V24H4v4l.0076-.0049A1.9977 1.9977 0 006 30H26a2 2 0 002-2h0V24zM6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "eyedropper",
      "friendlyName": "Eyedropper",
      "aliases": [
        "dropper",
        "pipette",
        "tester",
        "drop",
        "fill",
        "eyedropper"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/eyedropper.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>eyedropper</title><rect x=\"2\" y=\"27\" width=\"3\" height=\"3\"/><path d=\"M29.71,7.29l-5-5a1,1,0,0,0-1.41,0h0L20,5.59l-1.29-1.3L17.29,5.71,18.59,7,8.29,17.29A1,1,0,0,0,8,18v1.59l-2.71,2.7a1,1,0,0,0,0,1.41h0l3,3a1,1,0,0,0,1.41,0h0L12.41,24H14a1,1,0,0,0,.71-.29L25,13.41l1.29,1.3,1.42-1.42L26.41,12l3.3-3.29a1,1,0,0,0,0-1.41ZM13.59,22h-2L9,24.59,7.41,23,10,20.41v-2l10-10L23.59,12ZM25,10.59,21.41,7,24,4.41,27.59,8Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 27H5V30H2zM29.71 7.29l-5-5a1 1 0 00-1.41 0h0L20 5.59l-1.29-1.3L17.29 5.71 18.59 7 8.29 17.29A1 1 0 008 18v1.59l-2.71 2.7a1 1 0 000 1.41h0l3 3a1 1 0 001.41 0h0L12.41 24H14a1 1 0 00.71-.29L25 13.41l1.29 1.3 1.42-1.42L26.41 12l3.3-3.29a1 1 0 000-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z\"/></svg>",
            "info": {},
            "path": "32/eyedropper.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Eyedropper32",
          "filepath": "eyedropper/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H5V30H2zM29.71 7.29l-5-5a1 1 0 00-1.41 0h0L20 5.59l-1.29-1.3L17.29 5.71 18.59 7 8.29 17.29A1 1 0 008 18v1.59l-2.71 2.7a1 1 0 000 1.41h0l3 3a1 1 0 001.41 0h0L12.41 24H14a1 1 0 00.71-.29L25 13.41l1.29 1.3 1.42-1.42L26.41 12l3.3-3.29a1 1 0 000-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z"
                }
              }
            ],
            "name": "eyedropper",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Eyedropper24",
          "filepath": "eyedropper/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H5V30H2zM29.71 7.29l-5-5a1 1 0 00-1.41 0h0L20 5.59l-1.29-1.3L17.29 5.71 18.59 7 8.29 17.29A1 1 0 008 18v1.59l-2.71 2.7a1 1 0 000 1.41h0l3 3a1 1 0 001.41 0h0L12.41 24H14a1 1 0 00.71-.29L25 13.41l1.29 1.3 1.42-1.42L26.41 12l3.3-3.29a1 1 0 000-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z"
                }
              }
            ],
            "name": "eyedropper",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Eyedropper20",
          "filepath": "eyedropper/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H5V30H2zM29.71 7.29l-5-5a1 1 0 00-1.41 0h0L20 5.59l-1.29-1.3L17.29 5.71 18.59 7 8.29 17.29A1 1 0 008 18v1.59l-2.71 2.7a1 1 0 000 1.41h0l3 3a1 1 0 001.41 0h0L12.41 24H14a1 1 0 00.71-.29L25 13.41l1.29 1.3 1.42-1.42L26.41 12l3.3-3.29a1 1 0 000-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z"
                }
              }
            ],
            "name": "eyedropper",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Eyedropper16",
          "filepath": "eyedropper/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H5V30H2zM29.71 7.29l-5-5a1 1 0 00-1.41 0h0L20 5.59l-1.29-1.3L17.29 5.71 18.59 7 8.29 17.29A1 1 0 008 18v1.59l-2.71 2.7a1 1 0 000 1.41h0l3 3a1 1 0 001.41 0h0L12.41 24H14a1 1 0 00.71-.29L25 13.41l1.29 1.3 1.42-1.42L26.41 12l3.3-3.29a1 1 0 000-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z"
                }
              }
            ],
            "name": "eyedropper",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Eyedropper",
        "global": "Eyedropper",
        "filepath": "Eyedropper.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 27H5V30H2zM29.71 7.29l-5-5a1 1 0 00-1.41 0h0L20 5.59l-1.29-1.3L17.29 5.71 18.59 7 8.29 17.29A1 1 0 008 18v1.59l-2.71 2.7a1 1 0 000 1.41h0l3 3a1 1 0 001.41 0h0L12.41 24H14a1 1 0 00.71-.29L25 13.41l1.29 1.3 1.42-1.42L26.41 12l3.3-3.29a1 1 0 000-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--activated",
      "friendlyName": "Face activated",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--activated.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--activated</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\" transform=\"translate(0)\"/><path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z\" transform=\"translate(0)\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z\" transform=\"translate(0)\"/><path d=\"M9,20a8.13,8.13,0,0,0,14,0Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z\"/></svg>",
            "info": {},
            "path": "32/face--activated.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceActivated32",
          "filepath": "face--activated/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              }
            ],
            "name": "face--activated",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceActivated24",
          "filepath": "face--activated/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              }
            ],
            "name": "face--activated",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceActivated20",
          "filepath": "face--activated/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              }
            ],
            "name": "face--activated",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceActivated16",
          "filepath": "face--activated/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              }
            ],
            "name": "face--activated",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceActivated",
        "global": "FaceActivated",
        "filepath": "FaceActivated.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--activated--add",
      "friendlyName": "Face activated add",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--activated--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--activated--add</title><polygon points=\"30 4 26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4\"/><path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z\"/><path d=\"M9,20a8.13,8.13,0,0,0,14,0Z\"/><path d=\"M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z\"/><path d=\"M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z\"/></svg>",
            "info": {},
            "path": "32/face--activated--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceActivatedAdd32",
          "filepath": "face--activated--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
                }
              }
            ],
            "name": "face--activated--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceActivatedAdd24",
          "filepath": "face--activated--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
                }
              }
            ],
            "name": "face--activated--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceActivatedAdd20",
          "filepath": "face--activated--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
                }
              }
            ],
            "name": "face--activated--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceActivatedAdd16",
          "filepath": "face--activated--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
                }
              }
            ],
            "name": "face--activated--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceActivatedAdd",
        "global": "FaceActivatedAdd",
        "filepath": "FaceActivatedAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--activated--filled",
      "friendlyName": "Face activated filled",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--activated--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--activated--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z\"/></svg>",
            "info": {},
            "path": "32/face--activated--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceActivatedFilled32",
          "filepath": "face--activated--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--activated--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceActivatedFilled24",
          "filepath": "face--activated--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--activated--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceActivatedFilled20",
          "filepath": "face--activated--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--activated--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceActivatedFilled16",
          "filepath": "face--activated--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--activated--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceActivatedFilled",
        "global": "FaceActivatedFilled",
        "filepath": "FaceActivatedFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--add",
      "friendlyName": "Face add",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--add</title><path d=\"M16,22a6,6,0,0,1-5.14-2.92l-1.71,1a8,8,0,0,0,13.7,0l-1.71-1A6,6,0,0,1,16,22Z\"/><polygon points=\"30 4 26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4\"/><path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z\"/><path d=\"M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22a6 6 0 01-5.14-2.92l-1.71 1a8 8 0 0013.7 0l-1.71-1A6 6 0 0116 22zM30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z\"/><path d=\"M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z\"/></svg>",
            "info": {},
            "path": "32/face--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceAdd32",
          "filepath": "face--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a6 6 0 01-5.14-2.92l-1.71 1a8 8 0 0013.7 0l-1.71-1A6 6 0 0116 22zM30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z"
                }
              }
            ],
            "name": "face--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceAdd24",
          "filepath": "face--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a6 6 0 01-5.14-2.92l-1.71 1a8 8 0 0013.7 0l-1.71-1A6 6 0 0116 22zM30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z"
                }
              }
            ],
            "name": "face--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceAdd20",
          "filepath": "face--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a6 6 0 01-5.14-2.92l-1.71 1a8 8 0 0013.7 0l-1.71-1A6 6 0 0116 22zM30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z"
                }
              }
            ],
            "name": "face--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceAdd16",
          "filepath": "face--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a6 6 0 01-5.14-2.92l-1.71 1a8 8 0 0013.7 0l-1.71-1A6 6 0 0116 22zM30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z"
                }
              }
            ],
            "name": "face--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceAdd",
        "global": "FaceAdd",
        "filepath": "FaceAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22a6 6 0 01-5.14-2.92l-1.71 1a8 8 0 0013.7 0l-1.71-1A6 6 0 0116 22zM30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--cool",
      "friendlyName": "Face cool",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--cool.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--cool</title><path d=\"M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z\" transform=\"translate(0)\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/face--cool.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceCool32",
          "filepath": "face--cool/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "face--cool",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceCool24",
          "filepath": "face--cool/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "face--cool",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceCool20",
          "filepath": "face--cool/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "face--cool",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceCool16",
          "filepath": "face--cool/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "face--cool",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceCool",
        "global": "FaceCool",
        "filepath": "FaceCool.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--dissatisfied",
      "friendlyName": "Face dissatisfied",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face dissatisfied",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--dissatisfied.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--dissatisfied</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\" transform=\"translate(0)\"/><path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.5,2.5,0,0,0,11.5,11Z\" transform=\"translate(0)\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z\" transform=\"translate(0)\"/><path d=\"M16,19a8,8,0,0,0-6.85,3.89l1.71,1a6,6,0,0,1,10.28,0l1.71-1A8,8,0,0,0,16,19Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM16 19a8 8 0 00-6.85 3.89l1.71 1a6 6 0 0110.28 0l1.71-1A8 8 0 0016 19z\"/></svg>",
            "info": {},
            "path": "32/face--dissatisfied.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceDissatisfied32",
          "filepath": "face--dissatisfied/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM16 19a8 8 0 00-6.85 3.89l1.71 1a6 6 0 0110.28 0l1.71-1A8 8 0 0016 19z"
                }
              }
            ],
            "name": "face--dissatisfied",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceDissatisfied24",
          "filepath": "face--dissatisfied/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM16 19a8 8 0 00-6.85 3.89l1.71 1a6 6 0 0110.28 0l1.71-1A8 8 0 0016 19z"
                }
              }
            ],
            "name": "face--dissatisfied",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceDissatisfied20",
          "filepath": "face--dissatisfied/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM16 19a8 8 0 00-6.85 3.89l1.71 1a6 6 0 0110.28 0l1.71-1A8 8 0 0016 19z"
                }
              }
            ],
            "name": "face--dissatisfied",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceDissatisfied16",
          "filepath": "face--dissatisfied/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM16 19a8 8 0 00-6.85 3.89l1.71 1a6 6 0 0110.28 0l1.71-1A8 8 0 0016 19z"
                }
              }
            ],
            "name": "face--dissatisfied",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceDissatisfied",
        "global": "FaceDissatisfied",
        "filepath": "FaceDissatisfied.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM16 19a8 8 0 00-6.85 3.89l1.71 1a6 6 0 0110.28 0l1.71-1A8 8 0 0016 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--dissatisfied--filled",
      "friendlyName": "Face dissatisfied filled",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face dissatisfied filled",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--dissatisfied--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--dissatisfied--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z\"/></svg>",
            "info": {},
            "path": "32/face--dissatisfied--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceDissatisfiedFilled32",
          "filepath": "face--dissatisfied--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--dissatisfied--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceDissatisfiedFilled24",
          "filepath": "face--dissatisfied--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--dissatisfied--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceDissatisfiedFilled20",
          "filepath": "face--dissatisfied--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--dissatisfied--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceDissatisfiedFilled16",
          "filepath": "face--dissatisfied--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--dissatisfied--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceDissatisfiedFilled",
        "global": "FaceDissatisfiedFilled",
        "filepath": "FaceDissatisfiedFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--dizzy",
      "friendlyName": "Face dizzy",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face dizzy",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--dizzy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--dizzy</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\" transform=\"translate(0)\"/><polygon points=\"24.41 11 23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11\"/><polygon points=\"14.41 11 13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11\"/><path d=\"M16,19a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11zM14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11zM16 19a3 3 0 103 3 3 3 0 00-3-3z\"/></svg>",
            "info": {},
            "path": "32/face--dizzy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceDizzy32",
          "filepath": "face--dizzy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11zM14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11zM16 19a3 3 0 103 3 3 3 0 00-3-3z"
                }
              }
            ],
            "name": "face--dizzy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceDizzy24",
          "filepath": "face--dizzy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11zM14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11zM16 19a3 3 0 103 3 3 3 0 00-3-3z"
                }
              }
            ],
            "name": "face--dizzy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceDizzy20",
          "filepath": "face--dizzy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11zM14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11zM16 19a3 3 0 103 3 3 3 0 00-3-3z"
                }
              }
            ],
            "name": "face--dizzy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceDizzy16",
          "filepath": "face--dizzy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11zM14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11zM16 19a3 3 0 103 3 3 3 0 00-3-3z"
                }
              }
            ],
            "name": "face--dizzy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceDizzy",
        "global": "FaceDizzy",
        "filepath": "FaceDizzy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11zM14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11zM16 19a3 3 0 103 3 3 3 0 00-3-3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--dizzy--filled",
      "friendlyName": "Face dizzy filled",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face dizzy filled",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--dizzy--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--dizzy--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z\"/></svg>",
            "info": {},
            "path": "32/face--dizzy--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceDizzyFilled32",
          "filepath": "face--dizzy--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z"
                }
              }
            ],
            "name": "face--dizzy--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceDizzyFilled24",
          "filepath": "face--dizzy--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z"
                }
              }
            ],
            "name": "face--dizzy--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceDizzyFilled20",
          "filepath": "face--dizzy--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z"
                }
              }
            ],
            "name": "face--dizzy--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceDizzyFilled16",
          "filepath": "face--dizzy--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z"
                }
              }
            ],
            "name": "face--dizzy--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceDizzyFilled",
        "global": "FaceDizzyFilled",
        "filepath": "FaceDizzyFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--mask",
      "friendlyName": "Face mask",
      "aliases": [
        "health",
        "face mask",
        "mask",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--mask.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.5,2.5,0,0,0,11.5,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11z\"/><path d=\"M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z\"/></svg>",
            "info": {},
            "path": "32/face--mask.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceMask32",
          "filepath": "face--mask/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z"
                }
              }
            ],
            "name": "face--mask",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceMask24",
          "filepath": "face--mask/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z"
                }
              }
            ],
            "name": "face--mask",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceMask20",
          "filepath": "face--mask/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z"
                }
              }
            ],
            "name": "face--mask",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceMask16",
          "filepath": "face--mask/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z"
                }
              }
            ],
            "name": "face--mask",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceMask",
        "global": "FaceMask",
        "filepath": "FaceMask.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--neutral",
      "friendlyName": "Face neutral",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face neutral",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--neutral.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--neutral</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.5,2.5,0,0,0,11.5,11Z\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z\"/><rect x=\"10\" y=\"20\" width=\"12\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM10 20H22V22H10z\"/></svg>",
            "info": {},
            "path": "32/face--neutral.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceNeutral32",
          "filepath": "face--neutral/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM10 20H22V22H10z"
                }
              }
            ],
            "name": "face--neutral",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceNeutral24",
          "filepath": "face--neutral/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM10 20H22V22H10z"
                }
              }
            ],
            "name": "face--neutral",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceNeutral20",
          "filepath": "face--neutral/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM10 20H22V22H10z"
                }
              }
            ],
            "name": "face--neutral",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceNeutral16",
          "filepath": "face--neutral/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM10 20H22V22H10z"
                }
              }
            ],
            "name": "face--neutral",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceNeutral",
        "global": "FaceNeutral",
        "filepath": "FaceNeutral.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM10 20H22V22H10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--neutral--filled",
      "friendlyName": "Face neutral filled",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face neutral filled",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--neutral--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--neutral--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z\"/></svg>",
            "info": {},
            "path": "32/face--neutral--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceNeutralFilled32",
          "filepath": "face--neutral--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--neutral--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceNeutralFilled24",
          "filepath": "face--neutral--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--neutral--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceNeutralFilled20",
          "filepath": "face--neutral--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--neutral--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceNeutralFilled16",
          "filepath": "face--neutral--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--neutral--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceNeutralFilled",
        "global": "FaceNeutralFilled",
        "filepath": "FaceNeutralFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--pending",
      "friendlyName": "Face pending",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face pending",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--pending.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--pending</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\" transform=\"translate(0)\"/><path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z\" transform=\"translate(0)\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z\"/></svg>",
            "info": {},
            "path": "32/face--pending.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FacePending32",
          "filepath": "face--pending/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              }
            ],
            "name": "face--pending",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FacePending24",
          "filepath": "face--pending/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              }
            ],
            "name": "face--pending",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FacePending20",
          "filepath": "face--pending/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              }
            ],
            "name": "face--pending",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FacePending16",
          "filepath": "face--pending/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                }
              }
            ],
            "name": "face--pending",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FacePending",
        "global": "FacePending",
        "filepath": "FacePending.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--pending--filled",
      "friendlyName": "Face pending filled",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face pending filled",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--pending--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--pending--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z\"/></svg>",
            "info": {},
            "path": "32/face--pending--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FacePendingFilled32",
          "filepath": "face--pending--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--pending--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FacePendingFilled24",
          "filepath": "face--pending--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--pending--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FacePendingFilled20",
          "filepath": "face--pending--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--pending--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FacePendingFilled16",
          "filepath": "face--pending--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--pending--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FacePendingFilled",
        "global": "FacePendingFilled",
        "filepath": "FacePendingFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--satisfied",
      "friendlyName": "Face satisfied",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face satisfied",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--satisfied.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--satisfied</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z\"/><path d=\"M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z\"/></svg>",
            "info": {},
            "path": "32/face--satisfied.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceSatisfied32",
          "filepath": "face--satisfied/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--satisfied",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceSatisfied24",
          "filepath": "face--satisfied/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--satisfied",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceSatisfied20",
          "filepath": "face--satisfied/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--satisfied",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceSatisfied16",
          "filepath": "face--satisfied/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--satisfied",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceSatisfied",
        "global": "FaceSatisfied",
        "filepath": "FaceSatisfied.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--satisfied--filled",
      "friendlyName": "Face satisfied filled",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face satisfied filled",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--satisfied--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--satisfied--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z\"/></svg>",
            "info": {},
            "path": "32/face--satisfied--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceSatisfiedFilled32",
          "filepath": "face--satisfied--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--satisfied--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceSatisfiedFilled24",
          "filepath": "face--satisfied--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--satisfied--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceSatisfiedFilled20",
          "filepath": "face--satisfied--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--satisfied--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceSatisfiedFilled16",
          "filepath": "face--satisfied--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                }
              }
            ],
            "name": "face--satisfied--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceSatisfiedFilled",
        "global": "FaceSatisfiedFilled",
        "filepath": "FaceSatisfiedFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--wink",
      "friendlyName": "Face wink",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face wink",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--wink.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--wink</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z\"/><rect x=\"8\" y=\"13\" width=\"6\" height=\"2\"/><path d=\"M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM8 13H14V15H8zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z\"/></svg>",
            "info": {},
            "path": "32/face--wink.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceWink32",
          "filepath": "face--wink/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM8 13H14V15H8zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--wink",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceWink24",
          "filepath": "face--wink/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM8 13H14V15H8zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--wink",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceWink20",
          "filepath": "face--wink/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM8 13H14V15H8zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--wink",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceWink16",
          "filepath": "face--wink/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM8 13H14V15H8zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                }
              }
            ],
            "name": "face--wink",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceWink",
        "global": "FaceWink",
        "filepath": "FaceWink.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM8 13H14V15H8zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "face--wink--filled",
      "friendlyName": "Face wink filled",
      "aliases": [
        "smiley",
        "smile",
        "smiley face",
        "emoji",
        "head",
        "emotion",
        "face wink filled",
        "person",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/face--wink--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>face--wink--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z\"/></svg>",
            "info": {},
            "path": "32/face--wink--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FaceWinkFilled32",
          "filepath": "face--wink--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--wink--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FaceWinkFilled24",
          "filepath": "face--wink--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--wink--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FaceWinkFilled20",
          "filepath": "face--wink--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--wink--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FaceWinkFilled16",
          "filepath": "face--wink--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                }
              }
            ],
            "name": "face--wink--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "FaceWinkFilled",
        "global": "FaceWinkFilled",
        "filepath": "FaceWinkFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "factor",
      "friendlyName": "Factor",
      "aliases": [
        "factor",
        "form factor",
        "configuration"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/factor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>factor</title><path d=\"M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z\"/></svg>",
            "info": {},
            "path": "32/factor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Factor32",
          "filepath": "factor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z"
                }
              }
            ],
            "name": "factor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Factor24",
          "filepath": "factor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z"
                }
              }
            ],
            "name": "factor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Factor20",
          "filepath": "factor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z"
                }
              }
            ],
            "name": "factor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Factor16",
          "filepath": "factor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z"
                }
              }
            ],
            "name": "factor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Factor",
        "global": "Factor",
        "filepath": "Factor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fade",
      "friendlyName": "Fade",
      "aliases": [
        "dim",
        "vanish",
        "remove",
        "dissolve",
        "disappear"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/fade.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>fade</title>\n<path d=\"M4.1,12.6l-0.6,0.8c0.6,0.5,1.3,0.9,2.1,1.2l0.3-0.9C5.3,13.4,4.7,13,4.1,12.6z\"/>\n<path d=\"M2.1,9l-1,0.2c0.1,0.8,0.4,1.6,0.8,2.3L2.8,11C2.4,10.4,2.2,9.7,2.1,9z\"/>\n<path d=\"M5.9,2.4L5.6,1.4C4.8,1.7,4.1,2.1,3.5,2.7l0.6,0.8C4.7,3,5.3,2.6,5.9,2.4z\"/>\n<path d=\"M2.8,5L1.9,4.5C1.5,5.2,1.3,6,1.1,6.8l1,0.2C2.2,6.3,2.5,5.6,2.8,5z\"/>\n<path d=\"M8,1v1c3.3,0,6,2.7,6,6s-2.7,6-6,6v1c3.9,0,7-3.1,7-7S11.9,1,8,1z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4.1 12.6l-.6.8c.6.5 1.3.9 2.1 1.2l.3-.9C5.3 13.4 4.7 13 4.1 12.6zM2.1 9l-1 .2c.1.8.4 1.6.8 2.3L2.8 11C2.4 10.4 2.2 9.7 2.1 9zM5.9 2.4L5.6 1.4C4.8 1.7 4.1 2.1 3.5 2.7l.6.8C4.7 3 5.3 2.6 5.9 2.4zM2.8 5L1.9 4.5C1.5 5.2 1.3 6 1.1 6.8l1 .2C2.2 6.3 2.5 5.6 2.8 5zM8 1v1c3.3 0 6 2.7 6 6s-2.7 6-6 6v1c3.9 0 7-3.1 7-7S11.9 1 8 1z\"/></svg>",
            "info": {},
            "path": "16/fade.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/fade.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fade</title><path d=\"M8.24,25.14,7,26.67a13.79,13.79,0,0,0,4.18,2.44l.69-1.87A12,12,0,0,1,8.24,25.14Z\"/><path d=\"M4.19,18l-2,.41A14.09,14.09,0,0,0,3.86,23L5.59,22A12.44,12.44,0,0,1,4.19,18Z\"/><path d=\"M11.82,4.76l-.69-1.87A13.79,13.79,0,0,0,7,5.33L8.24,6.86A12,12,0,0,1,11.82,4.76Z\"/><path d=\"M5.59,10,3.86,9a14.37,14.37,0,0,0-1.64,4.59l2,.34A12.05,12.05,0,0,1,5.59,10Z\"/><path d=\"M16,2V4a12,12,0,0,1,0,24v2A14,14,0,0,0,16,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.24 25.14L7 26.67a13.79 13.79 0 004.18 2.44l.69-1.87A12 12 0 018.24 25.14zM4.19 18l-2 .41A14.09 14.09 0 003.86 23L5.59 22A12.44 12.44 0 014.19 18zM11.82 4.76l-.69-1.87A13.79 13.79 0 007 5.33L8.24 6.86A12 12 0 0111.82 4.76zM5.59 10L3.86 9a14.37 14.37 0 00-1.64 4.59l2 .34A12.05 12.05 0 015.59 10zM16 2V4a12 12 0 010 24v2A14 14 0 0016 2z\"/></svg>",
            "info": {},
            "path": "32/fade.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Fade32",
          "filepath": "fade/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.24 25.14L7 26.67a13.79 13.79 0 004.18 2.44l.69-1.87A12 12 0 018.24 25.14zM4.19 18l-2 .41A14.09 14.09 0 003.86 23L5.59 22A12.44 12.44 0 014.19 18zM11.82 4.76l-.69-1.87A13.79 13.79 0 007 5.33L8.24 6.86A12 12 0 0111.82 4.76zM5.59 10L3.86 9a14.37 14.37 0 00-1.64 4.59l2 .34A12.05 12.05 0 015.59 10zM16 2V4a12 12 0 010 24v2A14 14 0 0016 2z"
                }
              }
            ],
            "name": "fade",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Fade24",
          "filepath": "fade/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.24 25.14L7 26.67a13.79 13.79 0 004.18 2.44l.69-1.87A12 12 0 018.24 25.14zM4.19 18l-2 .41A14.09 14.09 0 003.86 23L5.59 22A12.44 12.44 0 014.19 18zM11.82 4.76l-.69-1.87A13.79 13.79 0 007 5.33L8.24 6.86A12 12 0 0111.82 4.76zM5.59 10L3.86 9a14.37 14.37 0 00-1.64 4.59l2 .34A12.05 12.05 0 015.59 10zM16 2V4a12 12 0 010 24v2A14 14 0 0016 2z"
                }
              }
            ],
            "name": "fade",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Fade20",
          "filepath": "fade/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.24 25.14L7 26.67a13.79 13.79 0 004.18 2.44l.69-1.87A12 12 0 018.24 25.14zM4.19 18l-2 .41A14.09 14.09 0 003.86 23L5.59 22A12.44 12.44 0 014.19 18zM11.82 4.76l-.69-1.87A13.79 13.79 0 007 5.33L8.24 6.86A12 12 0 0111.82 4.76zM5.59 10L3.86 9a14.37 14.37 0 00-1.64 4.59l2 .34A12.05 12.05 0 015.59 10zM16 2V4a12 12 0 010 24v2A14 14 0 0016 2z"
                }
              }
            ],
            "name": "fade",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Fade16",
          "filepath": "fade/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.1 12.6l-.6.8c.6.5 1.3.9 2.1 1.2l.3-.9C5.3 13.4 4.7 13 4.1 12.6zM2.1 9l-1 .2c.1.8.4 1.6.8 2.3L2.8 11C2.4 10.4 2.2 9.7 2.1 9zM5.9 2.4L5.6 1.4C4.8 1.7 4.1 2.1 3.5 2.7l.6.8C4.7 3 5.3 2.6 5.9 2.4zM2.8 5L1.9 4.5C1.5 5.2 1.3 6 1.1 6.8l1 .2C2.2 6.3 2.5 5.6 2.8 5zM8 1v1c3.3 0 6 2.7 6 6s-2.7 6-6 6v1c3.9 0 7-3.1 7-7S11.9 1 8 1z"
                }
              }
            ],
            "name": "fade",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Fade",
        "global": "Fade",
        "filepath": "Fade.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.1 12.6l-.6.8c.6.5 1.3.9 2.1 1.2l.3-.9C5.3 13.4 4.7 13 4.1 12.6zM2.1 9l-1 .2c.1.8.4 1.6.8 2.3L2.8 11C2.4 10.4 2.2 9.7 2.1 9zM5.9 2.4L5.6 1.4C4.8 1.7 4.1 2.1 3.5 2.7l.6.8C4.7 3 5.3 2.6 5.9 2.4zM2.8 5L1.9 4.5C1.5 5.2 1.3 6 1.1 6.8l1 .2C2.2 6.3 2.5 5.6 2.8 5zM8 1v1c3.3 0 6 2.7 6 6s-2.7 6-6 6v1c3.9 0 7-3.1 7-7S11.9 1 8 1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.24 25.14L7 26.67a13.79 13.79 0 004.18 2.44l.69-1.87A12 12 0 018.24 25.14zM4.19 18l-2 .41A14.09 14.09 0 003.86 23L5.59 22A12.44 12.44 0 014.19 18zM11.82 4.76l-.69-1.87A13.79 13.79 0 007 5.33L8.24 6.86A12 12 0 0111.82 4.76zM5.59 10L3.86 9a14.37 14.37 0 00-1.64 4.59l2 .34A12.05 12.05 0 015.59 10zM16 2V4a12 12 0 010 24v2A14 14 0 0016 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "favorite",
      "friendlyName": "Favorite",
      "aliases": [
        "heart",
        "save",
        "like",
        "fave",
        "bookmark",
        "favorite"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/favorite.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>favorite</title><path d=\"M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z\"/></svg>",
            "info": {},
            "path": "32/favorite.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Favorite32",
          "filepath": "favorite/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z"
                }
              }
            ],
            "name": "favorite",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Favorite24",
          "filepath": "favorite/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z"
                }
              }
            ],
            "name": "favorite",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Favorite20",
          "filepath": "favorite/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z"
                }
              }
            ],
            "name": "favorite",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Favorite16",
          "filepath": "favorite/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z"
                }
              }
            ],
            "name": "favorite",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Favorite",
        "global": "Favorite",
        "filepath": "Favorite.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "favorite--filled",
      "friendlyName": "Favorite filled",
      "aliases": [
        "heart",
        "save",
        "like",
        "fave",
        "bookmark",
        "favorite filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/favorite--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>favorite--filled</title>\n<path d=\"M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29\n\tl11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29\tl11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z\"/></svg>",
            "info": {},
            "path": "32/favorite--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FavoriteFilled32",
          "filepath": "favorite--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29\tl11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z"
                }
              }
            ],
            "name": "favorite--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FavoriteFilled24",
          "filepath": "favorite--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29\tl11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z"
                }
              }
            ],
            "name": "favorite--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FavoriteFilled20",
          "filepath": "favorite--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29\tl11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z"
                }
              }
            ],
            "name": "favorite--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FavoriteFilled16",
          "filepath": "favorite--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29\tl11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z"
                }
              }
            ],
            "name": "favorite--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "FavoriteFilled",
        "global": "FavoriteFilled",
        "filepath": "FavoriteFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29 l11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "favorite--half",
      "friendlyName": "Favorite half",
      "aliases": [
        "heart",
        "save",
        "like",
        "fave",
        "bookmark",
        "favorite half"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/favorite--half.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z\"/></svg>",
            "info": {},
            "path": "32/favorite--half.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FavoriteHalf32",
          "filepath": "favorite--half/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z"
                }
              }
            ],
            "name": "favorite--half",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FavoriteHalf24",
          "filepath": "favorite--half/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z"
                }
              }
            ],
            "name": "favorite--half",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FavoriteHalf20",
          "filepath": "favorite--half/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z"
                }
              }
            ],
            "name": "favorite--half",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FavoriteHalf16",
          "filepath": "favorite--half/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z"
                }
              }
            ],
            "name": "favorite--half",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "FavoriteHalf",
        "global": "FavoriteHalf",
        "filepath": "FavoriteHalf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fetch-upload",
      "friendlyName": "Fetch upload",
      "aliases": [
        "fetch upload",
        "fetch",
        "FTP",
        "upload"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fetch-upload.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fetch-upload</title><path d=\"M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z\"/><path d=\"M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z\"/><path d=\"M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z\"/></svg>",
            "info": {},
            "path": "32/fetch-upload.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FetchUpload32",
          "filepath": "fetch-upload/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
                }
              }
            ],
            "name": "fetch-upload",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FetchUpload24",
          "filepath": "fetch-upload/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
                }
              }
            ],
            "name": "fetch-upload",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FetchUpload20",
          "filepath": "fetch-upload/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
                }
              }
            ],
            "name": "fetch-upload",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FetchUpload16",
          "filepath": "fetch-upload/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
                }
              }
            ],
            "name": "fetch-upload",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "FetchUpload",
        "global": "FetchUpload",
        "filepath": "FetchUpload.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fetch-upload--cloud",
      "friendlyName": "Fetch upload cloud",
      "aliases": [
        "fetch upload cloud",
        "fetch upload",
        "cloud upload"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fetch-upload--cloud.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fetch-upload--cloud</title><path d=\"M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z\"/><path d=\"M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z\"/><path d=\"M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z\"/></svg>",
            "info": {},
            "path": "32/fetch-upload--cloud.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FetchUploadCloud32",
          "filepath": "fetch-upload--cloud/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "fetch-upload--cloud",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FetchUploadCloud24",
          "filepath": "fetch-upload--cloud/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "fetch-upload--cloud",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FetchUploadCloud20",
          "filepath": "fetch-upload--cloud/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "fetch-upload--cloud",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FetchUploadCloud16",
          "filepath": "fetch-upload--cloud/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "fetch-upload--cloud",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "FetchUploadCloud",
        "global": "FetchUploadCloud",
        "filepath": "FetchUploadCloud.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "file-storage",
      "friendlyName": "File storage",
      "aliases": [
        "file",
        "storage",
        "repository",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/file-storage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <path d=\"M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z\"/></svg>",
            "info": {},
            "path": "32/file-storage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FileStorage32",
          "filepath": "file-storage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z"
                }
              }
            ],
            "name": "file-storage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FileStorage24",
          "filepath": "file-storage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z"
                }
              }
            ],
            "name": "file-storage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FileStorage20",
          "filepath": "file-storage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z"
                }
              }
            ],
            "name": "file-storage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FileStorage16",
          "filepath": "file-storage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z"
                }
              }
            ],
            "name": "file-storage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "FileStorage",
        "global": "FileStorage",
        "filepath": "FileStorage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "filter",
      "friendlyName": "Filter",
      "aliases": [
        "refine",
        "funnel",
        "filter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/filter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>filter</title><path d=\"M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z\"/></svg>",
            "info": {},
            "path": "32/filter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Filter32",
          "filepath": "filter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z"
                }
              }
            ],
            "name": "filter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Filter24",
          "filepath": "filter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z"
                }
              }
            ],
            "name": "filter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Filter20",
          "filepath": "filter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z"
                }
              }
            ],
            "name": "filter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Filter16",
          "filepath": "filter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z"
                }
              }
            ],
            "name": "filter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Filter",
        "global": "Filter",
        "filepath": "Filter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "filter--edit",
      "friendlyName": "Filter edit",
      "aliases": [
        "refine",
        "funnel",
        "filter edit",
        "filter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/filter--edit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>filter--edit</title><path d=\"M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z\"/><path d=\"M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z\"/><path d=\"M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z\"/></svg>",
            "info": {},
            "path": "32/filter--edit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FilterEdit32",
          "filepath": "filter--edit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z"
                }
              }
            ],
            "name": "filter--edit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FilterEdit24",
          "filepath": "filter--edit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z"
                }
              }
            ],
            "name": "filter--edit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FilterEdit20",
          "filepath": "filter--edit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z"
                }
              }
            ],
            "name": "filter--edit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FilterEdit16",
          "filepath": "filter--edit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z"
                }
              }
            ],
            "name": "filter--edit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "FilterEdit",
        "global": "FilterEdit",
        "filepath": "FilterEdit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "filter--remove",
      "friendlyName": "Filter remove",
      "aliases": [
        "refine",
        "funnel",
        "filter remove",
        "filter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/filter--remove.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 11.414 28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414\"/>\n  <path d=\"M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z\"/><path d=\"M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z\"/></svg>",
            "info": {},
            "path": "32/filter--remove.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FilterRemove32",
          "filepath": "filter--remove/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "filter--remove",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FilterRemove24",
          "filepath": "filter--remove/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "filter--remove",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FilterRemove20",
          "filepath": "filter--remove/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "filter--remove",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FilterRemove16",
          "filepath": "filter--remove/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "filter--remove",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "FilterRemove",
        "global": "FilterRemove",
        "filepath": "FilterRemove.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "filter--reset",
      "friendlyName": "Filter reset",
      "aliases": [
        "refine",
        "funnel",
        "filter reset",
        "filter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/filter--reset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z\"/>\n  <path d=\"M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z\"/><path d=\"M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z\"/></svg>",
            "info": {},
            "path": "32/filter--reset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FilterReset32",
          "filepath": "filter--reset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"
                }
              }
            ],
            "name": "filter--reset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FilterReset24",
          "filepath": "filter--reset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"
                }
              }
            ],
            "name": "filter--reset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FilterReset20",
          "filepath": "filter--reset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"
                }
              }
            ],
            "name": "filter--reset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FilterReset16",
          "filepath": "filter--reset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"
                }
              }
            ],
            "name": "filter--reset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "FilterReset",
        "global": "FilterReset",
        "filepath": "FilterReset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "finance",
      "friendlyName": "Finance",
      "aliases": [
        "bank",
        "columns",
        "money",
        "business",
        "corporation",
        "business"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/finance.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>finance</title><rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/><path d=\"M27,11a1,1,0,0,0,1-1V7a1,1,0,0,0-.66-.94l-11-4a1,1,0,0,0-.68,0l-11,4A1,1,0,0,0,4,7v3a1,1,0,0,0,1,1H6V24H4v2H28V24H26V11ZM6,7.7,16,4.06,26,7.7V9H6ZM18,24H14V11h4ZM8,11h4V24H8ZM24,24H20V11h4Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM27 11a1 1 0 001-1V7a1 1 0 00-.66-.94l-11-4a1 1 0 00-.68 0l-11 4A1 1 0 004 7v3a1 1 0 001 1H6V24H4v2H28V24H26V11zM6 7.7L16 4.06 26 7.7V9H6zM18 24H14V11h4zM8 11h4V24H8zM24 24H20V11h4z\"/></svg>",
            "info": {},
            "path": "32/finance.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Finance32",
          "filepath": "finance/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM27 11a1 1 0 001-1V7a1 1 0 00-.66-.94l-11-4a1 1 0 00-.68 0l-11 4A1 1 0 004 7v3a1 1 0 001 1H6V24H4v2H28V24H26V11zM6 7.7L16 4.06 26 7.7V9H6zM18 24H14V11h4zM8 11h4V24H8zM24 24H20V11h4z"
                }
              }
            ],
            "name": "finance",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Finance24",
          "filepath": "finance/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM27 11a1 1 0 001-1V7a1 1 0 00-.66-.94l-11-4a1 1 0 00-.68 0l-11 4A1 1 0 004 7v3a1 1 0 001 1H6V24H4v2H28V24H26V11zM6 7.7L16 4.06 26 7.7V9H6zM18 24H14V11h4zM8 11h4V24H8zM24 24H20V11h4z"
                }
              }
            ],
            "name": "finance",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Finance20",
          "filepath": "finance/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM27 11a1 1 0 001-1V7a1 1 0 00-.66-.94l-11-4a1 1 0 00-.68 0l-11 4A1 1 0 004 7v3a1 1 0 001 1H6V24H4v2H28V24H26V11zM6 7.7L16 4.06 26 7.7V9H6zM18 24H14V11h4zM8 11h4V24H8zM24 24H20V11h4z"
                }
              }
            ],
            "name": "finance",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Finance16",
          "filepath": "finance/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM27 11a1 1 0 001-1V7a1 1 0 00-.66-.94l-11-4a1 1 0 00-.68 0l-11 4A1 1 0 004 7v3a1 1 0 001 1H6V24H4v2H28V24H26V11zM6 7.7L16 4.06 26 7.7V9H6zM18 24H14V11h4zM8 11h4V24H8zM24 24H20V11h4z"
                }
              }
            ],
            "name": "finance",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Finance",
        "global": "Finance",
        "filepath": "Finance.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM27 11a1 1 0 001-1V7a1 1 0 00-.66-.94l-11-4a1 1 0 00-.68 0l-11 4A1 1 0 004 7v3a1 1 0 001 1H6V24H4v2H28V24H26V11zM6 7.7L16 4.06 26 7.7V9H6zM18 24H14V11h4zM8 11h4V24H8zM24 24H20V11h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fingerprint-recognition",
      "friendlyName": "Fingerprint recognition",
      "aliases": [
        "identification",
        "fingerprint",
        "finger",
        "dna",
        "security",
        "touch",
        "identity",
        "mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fingerprint-recognition.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fingerprint-recognition</title><path d=\"M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z\" transform=\"translate(0)\"/><path d=\"M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z\" transform=\"translate(0)\"/><path d=\"M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z\" transform=\"translate(0)\"/><path d=\"M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z\" transform=\"translate(0)\"/><path d=\"M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z\"/><path d=\"M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z\"/><path d=\"M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z\"/><path d=\"M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z\"/><path d=\"M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z\"/></svg>",
            "info": {},
            "path": "32/fingerprint-recognition.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FingerprintRecognition32",
          "filepath": "fingerprint-recognition/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z"
                }
              }
            ],
            "name": "fingerprint-recognition",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FingerprintRecognition24",
          "filepath": "fingerprint-recognition/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z"
                }
              }
            ],
            "name": "fingerprint-recognition",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FingerprintRecognition20",
          "filepath": "fingerprint-recognition/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z"
                }
              }
            ],
            "name": "fingerprint-recognition",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FingerprintRecognition16",
          "filepath": "fingerprint-recognition/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z"
                }
              }
            ],
            "name": "fingerprint-recognition",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "FingerprintRecognition",
        "global": "FingerprintRecognition",
        "filepath": "FingerprintRecognition.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fire",
      "friendlyName": "Fire",
      "aliases": [
        "fire",
        "flames",
        "code"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fire.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>fire</title>\n  <path d=\"M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z\"/></svg>",
            "info": {},
            "path": "32/fire.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Fire32",
          "filepath": "fire/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z"
                }
              }
            ],
            "name": "fire",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Fire24",
          "filepath": "fire/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z"
                }
              }
            ],
            "name": "fire",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Fire20",
          "filepath": "fire/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z"
                }
              }
            ],
            "name": "fire",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Fire16",
          "filepath": "fire/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z"
                }
              }
            ],
            "name": "fire",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Fire",
        "global": "Fire",
        "filepath": "Fire.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "firewall",
      "friendlyName": "Firewall",
      "aliases": [
        "firewall",
        "security",
        "protect",
        "flame",
        "fire"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/firewall.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,20.3972v3c-1,0-2-1.5-2-4v-3c-4,5-5,7-5,9A5.0008,5.0008,0,0,0,23.0458,30,7.5281,7.5281,0,0,1,25,26.3972,7.5281,7.5281,0,0,1,26.9542,30,5.0008,5.0008,0,0,0,30,25.3972C30,23.3972,28.875,21.8258,27,20.3972Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M17,28H4V24H17V22H4a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H17Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H17V18H7V14H28l.0011,2H30V14A2.0023,2.0023,0,0,0,28,12Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25,10H4A2.0021,2.0021,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H25a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,25,10ZM4,4V8H25V4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 20.3972v3c-1 0-2-1.5-2-4v-3c-4 5-5 7-5 9A5.0008 5.0008 0 0023.0458 30 7.5281 7.5281 0 0125 26.3972 7.5281 7.5281 0 0126.9542 30 5.0008 5.0008 0 0030 25.3972C30 23.3972 28.875 21.8258 27 20.3972zM17 28H4V24H17V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17z\"/><path d=\"M28 12H7a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17V18H7V14H28l.0011 2H30V14A2.0023 2.0023 0 0028 12zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4z\"/></svg>",
            "info": {},
            "path": "32/firewall.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Firewall32",
          "filepath": "firewall/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.3972v3c-1 0-2-1.5-2-4v-3c-4 5-5 7-5 9A5.0008 5.0008 0 0023.0458 30 7.5281 7.5281 0 0125 26.3972 7.5281 7.5281 0 0126.9542 30 5.0008 5.0008 0 0030 25.3972C30 23.3972 28.875 21.8258 27 20.3972zM17 28H4V24H17V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H7a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17V18H7V14H28l.0011 2H30V14A2.0023 2.0023 0 0028 12zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4z"
                }
              }
            ],
            "name": "firewall",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Firewall24",
          "filepath": "firewall/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.3972v3c-1 0-2-1.5-2-4v-3c-4 5-5 7-5 9A5.0008 5.0008 0 0023.0458 30 7.5281 7.5281 0 0125 26.3972 7.5281 7.5281 0 0126.9542 30 5.0008 5.0008 0 0030 25.3972C30 23.3972 28.875 21.8258 27 20.3972zM17 28H4V24H17V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H7a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17V18H7V14H28l.0011 2H30V14A2.0023 2.0023 0 0028 12zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4z"
                }
              }
            ],
            "name": "firewall",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Firewall20",
          "filepath": "firewall/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.3972v3c-1 0-2-1.5-2-4v-3c-4 5-5 7-5 9A5.0008 5.0008 0 0023.0458 30 7.5281 7.5281 0 0125 26.3972 7.5281 7.5281 0 0126.9542 30 5.0008 5.0008 0 0030 25.3972C30 23.3972 28.875 21.8258 27 20.3972zM17 28H4V24H17V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H7a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17V18H7V14H28l.0011 2H30V14A2.0023 2.0023 0 0028 12zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4z"
                }
              }
            ],
            "name": "firewall",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Firewall16",
          "filepath": "firewall/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.3972v3c-1 0-2-1.5-2-4v-3c-4 5-5 7-5 9A5.0008 5.0008 0 0023.0458 30 7.5281 7.5281 0 0125 26.3972 7.5281 7.5281 0 0126.9542 30 5.0008 5.0008 0 0030 25.3972C30 23.3972 28.875 21.8258 27 20.3972zM17 28H4V24H17V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H7a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17V18H7V14H28l.0011 2H30V14A2.0023 2.0023 0 0028 12zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4z"
                }
              }
            ],
            "name": "firewall",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Firewall",
        "global": "Firewall",
        "filepath": "Firewall.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 20.3972v3c-1 0-2-1.5-2-4v-3c-4 5-5 7-5 9A5.0008 5.0008 0 0023.0458 30 7.5281 7.5281 0 0125 26.3972 7.5281 7.5281 0 0126.9542 30 5.0008 5.0008 0 0030 25.3972C30 23.3972 28.875 21.8258 27 20.3972zM17 28H4V24H17V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 12H7a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17V18H7V14H28l.0011 2H30V14A2.0023 2.0023 0 0028 12zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "firewall--classic",
      "friendlyName": "Firewall classic",
      "aliases": [
        "firewall",
        "security",
        "protect",
        "lock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/firewall--classic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #1c1c1c;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M28,20V17a4,4,0,0,0-8,0v3a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Zm-6-3a2,2,0,0,1,4,0v3H22Zm6,11H20V22h8Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M15,27H4a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2H15v2H4v3H15Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M17,18H8a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2H19v2H8v3h9Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M22,9H4A2,2,0,0,1,2,7V4A2,2,0,0,1,4,2H22a2,2,0,0,1,2,2V7A2,2,0,0,1,22,9ZM4,7H22V4H4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 20V17a4 4 0 00-8 0v3a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 0028 20zm-6-3a2 2 0 014 0v3H22zm6 11H20V22h8zM15 27H4a2 2 0 01-2-2V22a2 2 0 012-2H15v2H4v3H15zM17 18H8a2 2 0 01-2-2V13a2 2 0 012-2H19v2H8v3h9zM22 9H4A2 2 0 012 7V4A2 2 0 014 2H22a2 2 0 012 2V7A2 2 0 0122 9zM4 7H22V4H4z\"/></svg>",
            "info": {},
            "path": "32/firewall--classic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FirewallClassic32",
          "filepath": "firewall--classic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20V17a4 4 0 00-8 0v3a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 0028 20zm-6-3a2 2 0 014 0v3H22zm6 11H20V22h8zM15 27H4a2 2 0 01-2-2V22a2 2 0 012-2H15v2H4v3H15zM17 18H8a2 2 0 01-2-2V13a2 2 0 012-2H19v2H8v3h9zM22 9H4A2 2 0 012 7V4A2 2 0 014 2H22a2 2 0 012 2V7A2 2 0 0122 9zM4 7H22V4H4z"
                }
              }
            ],
            "name": "firewall--classic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FirewallClassic24",
          "filepath": "firewall--classic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20V17a4 4 0 00-8 0v3a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 0028 20zm-6-3a2 2 0 014 0v3H22zm6 11H20V22h8zM15 27H4a2 2 0 01-2-2V22a2 2 0 012-2H15v2H4v3H15zM17 18H8a2 2 0 01-2-2V13a2 2 0 012-2H19v2H8v3h9zM22 9H4A2 2 0 012 7V4A2 2 0 014 2H22a2 2 0 012 2V7A2 2 0 0122 9zM4 7H22V4H4z"
                }
              }
            ],
            "name": "firewall--classic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FirewallClassic20",
          "filepath": "firewall--classic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20V17a4 4 0 00-8 0v3a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 0028 20zm-6-3a2 2 0 014 0v3H22zm6 11H20V22h8zM15 27H4a2 2 0 01-2-2V22a2 2 0 012-2H15v2H4v3H15zM17 18H8a2 2 0 01-2-2V13a2 2 0 012-2H19v2H8v3h9zM22 9H4A2 2 0 012 7V4A2 2 0 014 2H22a2 2 0 012 2V7A2 2 0 0122 9zM4 7H22V4H4z"
                }
              }
            ],
            "name": "firewall--classic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FirewallClassic16",
          "filepath": "firewall--classic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20V17a4 4 0 00-8 0v3a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 0028 20zm-6-3a2 2 0 014 0v3H22zm6 11H20V22h8zM15 27H4a2 2 0 01-2-2V22a2 2 0 012-2H15v2H4v3H15zM17 18H8a2 2 0 01-2-2V13a2 2 0 012-2H19v2H8v3h9zM22 9H4A2 2 0 012 7V4A2 2 0 014 2H22a2 2 0 012 2V7A2 2 0 0122 9zM4 7H22V4H4z"
                }
              }
            ],
            "name": "firewall--classic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "FirewallClassic",
        "global": "FirewallClassic",
        "filepath": "FirewallClassic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 20V17a4 4 0 00-8 0v3a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 0028 20zm-6-3a2 2 0 014 0v3H22zm6 11H20V22h8zM15 27H4a2 2 0 01-2-2V22a2 2 0 012-2H15v2H4v3H15zM17 18H8a2 2 0 01-2-2V13a2 2 0 012-2H19v2H8v3h9zM22 9H4A2 2 0 012 7V4A2 2 0 014 2H22a2 2 0 012 2V7A2 2 0 0122 9zM4 7H22V4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fish",
      "friendlyName": "Fish",
      "aliases": [
        "fish",
        "marine life",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fish.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fish</title><circle cx=\"24\" cy=\"6.9998\" r=\"1\"/><path d=\"M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"24\" cy=\"7\" r=\"1\"/><path d=\"M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z\"/></svg>",
            "info": {},
            "path": "32/fish.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Fish32",
          "filepath": "fish/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z"
                }
              }
            ],
            "name": "fish",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Fish24",
          "filepath": "fish/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z"
                }
              }
            ],
            "name": "fish",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Fish20",
          "filepath": "fish/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z"
                }
              }
            ],
            "name": "fish",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Fish16",
          "filepath": "fish/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z"
                }
              }
            ],
            "name": "fish",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Fish",
        "global": "Fish",
        "filepath": "Fish.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fish--multiple",
      "friendlyName": "Fish multiple",
      "aliases": [
        "fish",
        "fish multiple",
        "school",
        "school of fish"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fish--multiple.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fish--multiple</title><path d=\"M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z\"/><circle cx=\"17\" cy=\"10.9998\" r=\"1\"/><path d=\"M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z\"/><circle cx=\"25\" cy=\"10.9998\" r=\"1\"/><circle cx=\"9\" cy=\"10.9998\" r=\"1\"/><path d=\"M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z\"/><circle cx=\"17\" cy=\"11\" r=\"1\"/><path d=\"M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z\"/><circle cx=\"25\" cy=\"11\" r=\"1\"/><circle cx=\"9\" cy=\"11\" r=\"1\"/><path d=\"M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z\"/></svg>",
            "info": {},
            "path": "32/fish--multiple.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FishMultiple32",
          "filepath": "fish--multiple/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z"
                }
              }
            ],
            "name": "fish--multiple",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FishMultiple24",
          "filepath": "fish--multiple/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z"
                }
              }
            ],
            "name": "fish--multiple",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FishMultiple20",
          "filepath": "fish--multiple/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z"
                }
              }
            ],
            "name": "fish--multiple",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FishMultiple16",
          "filepath": "fish--multiple/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z"
                }
              }
            ],
            "name": "fish--multiple",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "FishMultiple",
        "global": "FishMultiple",
        "filepath": "FishMultiple.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fit-to-height",
      "friendlyName": "Fit-to-height",
      "aliases": [
        "controls",
        "height",
        "fit",
        "expand",
        "vertical",
        "stretch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fit-to-height.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"11 10 12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10\"/>\n  <path d=\"M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z\"/><path d=\"M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/></svg>",
            "info": {},
            "path": "32/fit-to-height.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FitToHeight32",
          "filepath": "fit-to-height/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-height",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FitToHeight24",
          "filepath": "fit-to-height/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-height",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FitToHeight20",
          "filepath": "fit-to-height/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-height",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FitToHeight16",
          "filepath": "fit-to-height/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-height",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "FitToHeight",
        "global": "FitToHeight",
        "filepath": "FitToHeight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fit-to-screen",
      "friendlyName": "Fit to screen",
      "aliases": [
        "fit to screen",
        "full screen",
        "enlarge screen"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fit-to-screen.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fit-to-screen</title><polygon points=\"22 16 24 16 24 8 16 8 16 10 22 10 22 16\"/><polygon points=\"8 24 16 24 16 22 10 22 10 16 8 16 8 24\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 16L24 16 24 8 16 8 16 10 22 10 22 16zM8 24L16 24 16 22 10 22 10 16 8 16 8 24z\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z\"/></svg>",
            "info": {},
            "path": "32/fit-to-screen.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FitToScreen32",
          "filepath": "fit-to-screen/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L24 16 24 8 16 8 16 10 22 10 22 16zM8 24L16 24 16 22 10 22 10 16 8 16 8 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "fit-to-screen",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FitToScreen24",
          "filepath": "fit-to-screen/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L24 16 24 8 16 8 16 10 22 10 22 16zM8 24L16 24 16 22 10 22 10 16 8 16 8 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "fit-to-screen",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FitToScreen20",
          "filepath": "fit-to-screen/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L24 16 24 8 16 8 16 10 22 10 22 16zM8 24L16 24 16 22 10 22 10 16 8 16 8 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "fit-to-screen",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FitToScreen16",
          "filepath": "fit-to-screen/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L24 16 24 8 16 8 16 10 22 10 22 16zM8 24L16 24 16 22 10 22 10 16 8 16 8 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "fit-to-screen",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "FitToScreen",
        "global": "FitToScreen",
        "filepath": "FitToScreen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 16L24 16 24 8 16 8 16 10 22 10 22 16zM8 24L16 24 16 22 10 22 10 16 8 16 8 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fit-to-width",
      "friendlyName": "Fit-to-width",
      "aliases": [
        "controls",
        "width",
        "fit",
        "expand",
        "horizontal",
        "stretch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fit-to-width.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 11 20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11\"/>\n  <path d=\"M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z\"/><path d=\"M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/></svg>",
            "info": {},
            "path": "32/fit-to-width.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FitToWidth32",
          "filepath": "fit-to-width/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-width",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FitToWidth24",
          "filepath": "fit-to-width/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-width",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FitToWidth20",
          "filepath": "fit-to-width/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-width",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FitToWidth16",
          "filepath": "fit-to-width/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "fit-to-width",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "FitToWidth",
        "global": "FitToWidth",
        "filepath": "FitToWidth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flag",
      "friendlyName": "Flag",
      "aliases": [
        "country",
        "location",
        "nation",
        "banner",
        "notification",
        "marker",
        "flag",
        "mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flag.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>flag</title><path d=\"M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z\"/></svg>",
            "info": {},
            "path": "32/flag.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Flag32",
          "filepath": "flag/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z"
                }
              }
            ],
            "name": "flag",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Flag24",
          "filepath": "flag/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z"
                }
              }
            ],
            "name": "flag",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Flag20",
          "filepath": "flag/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z"
                }
              }
            ],
            "name": "flag",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Flag16",
          "filepath": "flag/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z"
                }
              }
            ],
            "name": "flag",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Flag",
        "global": "Flag",
        "filepath": "Flag.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flag--filled",
      "friendlyName": "Flag filled",
      "aliases": [
        "country",
        "location",
        "nation",
        "banner",
        "notification",
        "marker",
        "flag filled",
        "mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flag--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M6,30H4V2H28l-5.8,9L28,20H6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6,30H4V2H28l-5.8,9L28,20H6Z\"/></svg>",
            "info": {},
            "path": "32/flag--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlagFilled32",
          "filepath": "flag--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6Z"
                }
              }
            ],
            "name": "flag--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlagFilled24",
          "filepath": "flag--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6Z"
                }
              }
            ],
            "name": "flag--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlagFilled20",
          "filepath": "flag--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6Z"
                }
              }
            ],
            "name": "flag--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlagFilled16",
          "filepath": "flag--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H4V2H28l-5.8,9L28,20H6Z"
                }
              }
            ],
            "name": "flag--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "FlagFilled",
        "global": "FlagFilled",
        "filepath": "FlagFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,30H4V2H28l-5.8,9L28,20H6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flagging-taxi",
      "friendlyName": "Flagging taxi",
      "aliases": [
        "flagging taxi",
        "hail taxi",
        "get taxi"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flagging-taxi.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>flagging-taxi</title><path d=\"M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z\"/><path d=\"M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z\"/><path d=\"M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z\"/></svg>",
            "info": {},
            "path": "32/flagging-taxi.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlaggingTaxi32",
          "filepath": "flagging-taxi/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z"
                }
              }
            ],
            "name": "flagging-taxi",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlaggingTaxi24",
          "filepath": "flagging-taxi/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z"
                }
              }
            ],
            "name": "flagging-taxi",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlaggingTaxi20",
          "filepath": "flagging-taxi/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z"
                }
              }
            ],
            "name": "flagging-taxi",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlaggingTaxi16",
          "filepath": "flagging-taxi/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z"
                }
              }
            ],
            "name": "flagging-taxi",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "FlaggingTaxi",
        "global": "FlaggingTaxi",
        "filepath": "FlaggingTaxi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flash",
      "friendlyName": "Flash",
      "aliases": [
        "battery",
        "lightning",
        "energy",
        "charge",
        "power",
        "camera",
        "electricity",
        "storm",
        "flash"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flash.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bolt</title><path d=\"M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z\"/></svg>",
            "info": {},
            "path": "32/flash.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Flash32",
          "filepath": "flash/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "flash",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Flash24",
          "filepath": "flash/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "flash",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Flash20",
          "filepath": "flash/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "flash",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Flash16",
          "filepath": "flash/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "flash",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Flash",
        "global": "Flash",
        "filepath": "Flash.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flash--filled",
      "friendlyName": "Flash filled",
      "aliases": [
        "battery",
        "lightning",
        "energy",
        "charge",
        "power",
        "camera",
        "electricity",
        "storm",
        "flash filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flash--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>flash--filled</title><path d=\"M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z\"/></svg>",
            "info": {},
            "path": "32/flash--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlashFilled32",
          "filepath": "flash--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"
                }
              }
            ],
            "name": "flash--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlashFilled24",
          "filepath": "flash--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"
                }
              }
            ],
            "name": "flash--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlashFilled20",
          "filepath": "flash--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"
                }
              }
            ],
            "name": "flash--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlashFilled16",
          "filepath": "flash--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"
                }
              }
            ],
            "name": "flash--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "FlashFilled",
        "global": "FlashFilled",
        "filepath": "FlashFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flash--off",
      "friendlyName": "Flash off",
      "aliases": [
        "battery",
        "lightning",
        "energy",
        "charge",
        "power",
        "camera",
        "electricity",
        "storm",
        "flash off"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flash--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>flash--off</title><path d=\"M11.13,6.89,11.8,4h8l-2,9H23l-2.49,3.25,1.43,1.43,3.87-5.07a1,1,0,0,0,.11-1A1,1,0,0,0,25,11H20.25L22,3.22a1,1,0,0,0-.2-.85A1,1,0,0,0,21,2H11a1,1,0,0,0-1,.77L9.46,5.22Z\"/><path d=\"M30,28.59l-9.31-9.31h0l-1.42-1.43h0L10.6,9.19h0L8.93,7.52h0L3.41,2,2,3.41,8.4,9.82,7,15.77A1,1,0,0,0,8,17h4.83L11,28.85a1,1,0,0,0,.6,1.07A1.09,1.09,0,0,0,12,30a1,1,0,0,0,.79-.39l6.68-8.73L28.59,30ZM9.26,15l.81-3.52L13.59,15Zm4.32,10.28L15,16.37,18,19.45Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77L9.46 5.22zM30 28.59l-9.31-9.31h0l-1.42-1.43h0L10.6 9.19h0L8.93 7.52h0L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37 18 19.45z\"/></svg>",
            "info": {},
            "path": "32/flash--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlashOff32",
          "filepath": "flash--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77L9.46 5.22zM30 28.59l-9.31-9.31h0l-1.42-1.43h0L10.6 9.19h0L8.93 7.52h0L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37 18 19.45z"
                }
              }
            ],
            "name": "flash--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlashOff24",
          "filepath": "flash--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77L9.46 5.22zM30 28.59l-9.31-9.31h0l-1.42-1.43h0L10.6 9.19h0L8.93 7.52h0L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37 18 19.45z"
                }
              }
            ],
            "name": "flash--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlashOff20",
          "filepath": "flash--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77L9.46 5.22zM30 28.59l-9.31-9.31h0l-1.42-1.43h0L10.6 9.19h0L8.93 7.52h0L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37 18 19.45z"
                }
              }
            ],
            "name": "flash--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlashOff16",
          "filepath": "flash--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77L9.46 5.22zM30 28.59l-9.31-9.31h0l-1.42-1.43h0L10.6 9.19h0L8.93 7.52h0L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37 18 19.45z"
                }
              }
            ],
            "name": "flash--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "FlashOff",
        "global": "FlashOff",
        "filepath": "FlashOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77L9.46 5.22zM30 28.59l-9.31-9.31h0l-1.42-1.43h0L10.6 9.19h0L8.93 7.52h0L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37 18 19.45z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flash--off--filled",
      "friendlyName": "Flash off filled",
      "aliases": [
        "battery",
        "lightning",
        "energy",
        "charge",
        "power",
        "camera",
        "electricity",
        "storm",
        "flash off filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flash--off--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>flash--off--filled</title><path d=\"M30,28.59,3.41,2,2,3.41,8.4,9.82,7,15.77A1,1,0,0,0,8,17h4.83L11,28.85a1,1,0,0,0,.6,1.07A1.09,1.09,0,0,0,12,30a1,1,0,0,0,.79-.39l6.68-8.73L28.59,30Z\"/><path d=\"M22.53,16.87l3.26-4.26a1,1,0,0,0,.11-1A1,1,0,0,0,25,11H20.25L22,3.22a1,1,0,0,0-.2-.85A1,1,0,0,0,21,2H11a1,1,0,0,0-1,.77l-.3,1.3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 28.59L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM22.53 16.87l3.26-4.26a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77l-.3 1.3z\"/></svg>",
            "info": {},
            "path": "32/flash--off--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlashOffFilled32",
          "filepath": "flash--off--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM22.53 16.87l3.26-4.26a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77l-.3 1.3z"
                }
              }
            ],
            "name": "flash--off--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlashOffFilled24",
          "filepath": "flash--off--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM22.53 16.87l3.26-4.26a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77l-.3 1.3z"
                }
              }
            ],
            "name": "flash--off--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlashOffFilled20",
          "filepath": "flash--off--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM22.53 16.87l3.26-4.26a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77l-.3 1.3z"
                }
              }
            ],
            "name": "flash--off--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlashOffFilled16",
          "filepath": "flash--off--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM22.53 16.87l3.26-4.26a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77l-.3 1.3z"
                }
              }
            ],
            "name": "flash--off--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "FlashOffFilled",
        "global": "FlashOffFilled",
        "filepath": "FlashOffFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 28.59L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM22.53 16.87l3.26-4.26a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77l-.3 1.3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flight--international",
      "friendlyName": "Flight international",
      "aliases": [
        "flight",
        "international",
        "travel",
        "airline",
        "plane"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flight--international.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z\"/><path fill-rule=\"evenodd\" d=\"M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z\"/></svg>",
            "info": {},
            "path": "32/flight--international.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlightInternational32",
          "filepath": "flight--international/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z"
                }
              }
            ],
            "name": "flight--international",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlightInternational24",
          "filepath": "flight--international/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z"
                }
              }
            ],
            "name": "flight--international",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlightInternational20",
          "filepath": "flight--international/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z"
                }
              }
            ],
            "name": "flight--international",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlightInternational16",
          "filepath": "flight--international/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z"
                }
              }
            ],
            "name": "flight--international",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "FlightInternational",
        "global": "FlightInternational",
        "filepath": "FlightInternational.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flight--roster",
      "friendlyName": "Flight roster",
      "aliases": [
        "flight",
        "roster",
        "manifest",
        "passenger list",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flight--roster.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"10\" y=\"18\" width=\"6\" height=\"2\"/>\n  <rect x=\"10\" y=\"14\" width=\"12\" height=\"2\"/>\n  <path class=\"cls-1\" d=\"M22,10v2H10V10Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z\"/><path d=\"M10 18H16V20H10zM10 14H22V16H10z\"/><path fill-rule=\"evenodd\" d=\"M22 10v2H10V10zM25 23l5 2V23l-5-2.5V18a1 1 0 00-2 0v2.5L18 23v2l5-2v3.5L21 28v1l3-1 3 1V28l-2-1.5z\"/></svg>",
            "info": {},
            "path": "32/flight--roster.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlightRoster32",
          "filepath": "flight--roster/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H16V20H10zM10 14H22V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M22 10v2H10V10zM25 23l5 2V23l-5-2.5V18a1 1 0 00-2 0v2.5L18 23v2l5-2v3.5L21 28v1l3-1 3 1V28l-2-1.5z"
                }
              }
            ],
            "name": "flight--roster",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlightRoster24",
          "filepath": "flight--roster/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H16V20H10zM10 14H22V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M22 10v2H10V10zM25 23l5 2V23l-5-2.5V18a1 1 0 00-2 0v2.5L18 23v2l5-2v3.5L21 28v1l3-1 3 1V28l-2-1.5z"
                }
              }
            ],
            "name": "flight--roster",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlightRoster20",
          "filepath": "flight--roster/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H16V20H10zM10 14H22V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M22 10v2H10V10zM25 23l5 2V23l-5-2.5V18a1 1 0 00-2 0v2.5L18 23v2l5-2v3.5L21 28v1l3-1 3 1V28l-2-1.5z"
                }
              }
            ],
            "name": "flight--roster",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlightRoster16",
          "filepath": "flight--roster/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H16V20H10zM10 14H22V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M22 10v2H10V10zM25 23l5 2V23l-5-2.5V18a1 1 0 00-2 0v2.5L18 23v2l5-2v3.5L21 28v1l3-1 3 1V28l-2-1.5z"
                }
              }
            ],
            "name": "flight--roster",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "FlightRoster",
        "global": "FlightRoster",
        "filepath": "FlightRoster.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 18H16V20H10zM10 14H22V16H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M22 10v2H10V10zM25 23l5 2V23l-5-2.5V18a1 1 0 00-2 0v2.5L18 23v2l5-2v3.5L21 28v1l3-1 3 1V28l-2-1.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flight--schedule",
      "friendlyName": "Flight schedule",
      "aliases": [
        "flight",
        "schedule",
        "travel",
        "calendar"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flight--schedule.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z\"/><path fill-rule=\"evenodd\" d=\"M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z\"/></svg>",
            "info": {},
            "path": "32/flight--schedule.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlightSchedule32",
          "filepath": "flight--schedule/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "flight--schedule",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlightSchedule24",
          "filepath": "flight--schedule/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "flight--schedule",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlightSchedule20",
          "filepath": "flight--schedule/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "flight--schedule",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlightSchedule16",
          "filepath": "flight--schedule/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "flight--schedule",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "FlightSchedule",
        "global": "FlightSchedule",
        "filepath": "FlightSchedule.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "floating-ip",
      "friendlyName": "Floating IP",
      "aliases": [
        "floating",
        "IP",
        "routable",
        "IP address"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/floating-ip.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z\"/></svg>",
            "info": {},
            "path": "32/floating-ip.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FloatingIp32",
          "filepath": "floating-ip/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z"
                }
              }
            ],
            "name": "floating-ip",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FloatingIp24",
          "filepath": "floating-ip/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z"
                }
              }
            ],
            "name": "floating-ip",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FloatingIp20",
          "filepath": "floating-ip/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z"
                }
              }
            ],
            "name": "floating-ip",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FloatingIp16",
          "filepath": "floating-ip/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z"
                }
              }
            ],
            "name": "floating-ip",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "FloatingIp",
        "global": "FloatingIp",
        "filepath": "FloatingIp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flood",
      "friendlyName": "Flood",
      "aliases": [
        "flood",
        "weather",
        "forecast",
        "warning",
        "disaster"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flood.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,13.63,29.7573,15,31,13.4282,16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6907,3.6907,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21H28Zm-6.0513,5.0532a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.37,3.37,0,0,1-3.0021-2.19L6,12.0615l9.991-7.79L26,12.0718,26.0017,21H25A3.4376,3.4376,0,0,1,21.9487,18.6836Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 28a2.8828 2.8828 0 01-1-.1816v-.0059a3.7662 3.7662 0 01-2.0532-2.1338A.971.971 0 0025 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0121 28a3.44 3.44 0 01-3.0532-2.3213A.9894.9894 0 0017 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0113 28a3.44 3.44 0 01-3.0532-2.3213 1 1 0 00-1.8955.0049A3.4376 3.4376 0 015 28H2v2H5a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0 5.1433 5.1433 0 002.1379 1.62A4.8374 4.8374 0 0029 30h1V28zM28 13.63L29.7573 15 31 13.4282 16.6123 2.2139a1.0094 1.0094 0 00-1.2427 0L1 13.4194l1.2427 1.5718L4 13.6211v5.1875a3.6907 3.6907 0 01-2 2.0039V22.896a4.9958 4.9958 0 003-1.8833 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0025 23h5V21H28zm-6.0513 5.0532a1 1 0 00-1.8955-.0049A3.44 3.44 0 0117 21a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0013 18a.9894.9894 0 00-.9468.6787A3.44 3.44 0 019 21a3.37 3.37 0 01-3.0021-2.19L6 12.0615l9.991-7.79L26 12.0718 26.0017 21H25A3.4376 3.4376 0 0121.9487 18.6836z\"/></svg>",
            "info": {},
            "path": "32/flood.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Flood32",
          "filepath": "flood/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 28a2.8828 2.8828 0 01-1-.1816v-.0059a3.7662 3.7662 0 01-2.0532-2.1338A.971.971 0 0025 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0121 28a3.44 3.44 0 01-3.0532-2.3213A.9894.9894 0 0017 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0113 28a3.44 3.44 0 01-3.0532-2.3213 1 1 0 00-1.8955.0049A3.4376 3.4376 0 015 28H2v2H5a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0 5.1433 5.1433 0 002.1379 1.62A4.8374 4.8374 0 0029 30h1V28zM28 13.63L29.7573 15 31 13.4282 16.6123 2.2139a1.0094 1.0094 0 00-1.2427 0L1 13.4194l1.2427 1.5718L4 13.6211v5.1875a3.6907 3.6907 0 01-2 2.0039V22.896a4.9958 4.9958 0 003-1.8833 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0025 23h5V21H28zm-6.0513 5.0532a1 1 0 00-1.8955-.0049A3.44 3.44 0 0117 21a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0013 18a.9894.9894 0 00-.9468.6787A3.44 3.44 0 019 21a3.37 3.37 0 01-3.0021-2.19L6 12.0615l9.991-7.79L26 12.0718 26.0017 21H25A3.4376 3.4376 0 0121.9487 18.6836z"
                }
              }
            ],
            "name": "flood",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Flood24",
          "filepath": "flood/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 28a2.8828 2.8828 0 01-1-.1816v-.0059a3.7662 3.7662 0 01-2.0532-2.1338A.971.971 0 0025 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0121 28a3.44 3.44 0 01-3.0532-2.3213A.9894.9894 0 0017 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0113 28a3.44 3.44 0 01-3.0532-2.3213 1 1 0 00-1.8955.0049A3.4376 3.4376 0 015 28H2v2H5a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0 5.1433 5.1433 0 002.1379 1.62A4.8374 4.8374 0 0029 30h1V28zM28 13.63L29.7573 15 31 13.4282 16.6123 2.2139a1.0094 1.0094 0 00-1.2427 0L1 13.4194l1.2427 1.5718L4 13.6211v5.1875a3.6907 3.6907 0 01-2 2.0039V22.896a4.9958 4.9958 0 003-1.8833 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0025 23h5V21H28zm-6.0513 5.0532a1 1 0 00-1.8955-.0049A3.44 3.44 0 0117 21a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0013 18a.9894.9894 0 00-.9468.6787A3.44 3.44 0 019 21a3.37 3.37 0 01-3.0021-2.19L6 12.0615l9.991-7.79L26 12.0718 26.0017 21H25A3.4376 3.4376 0 0121.9487 18.6836z"
                }
              }
            ],
            "name": "flood",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Flood20",
          "filepath": "flood/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 28a2.8828 2.8828 0 01-1-.1816v-.0059a3.7662 3.7662 0 01-2.0532-2.1338A.971.971 0 0025 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0121 28a3.44 3.44 0 01-3.0532-2.3213A.9894.9894 0 0017 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0113 28a3.44 3.44 0 01-3.0532-2.3213 1 1 0 00-1.8955.0049A3.4376 3.4376 0 015 28H2v2H5a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0 5.1433 5.1433 0 002.1379 1.62A4.8374 4.8374 0 0029 30h1V28zM28 13.63L29.7573 15 31 13.4282 16.6123 2.2139a1.0094 1.0094 0 00-1.2427 0L1 13.4194l1.2427 1.5718L4 13.6211v5.1875a3.6907 3.6907 0 01-2 2.0039V22.896a4.9958 4.9958 0 003-1.8833 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0025 23h5V21H28zm-6.0513 5.0532a1 1 0 00-1.8955-.0049A3.44 3.44 0 0117 21a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0013 18a.9894.9894 0 00-.9468.6787A3.44 3.44 0 019 21a3.37 3.37 0 01-3.0021-2.19L6 12.0615l9.991-7.79L26 12.0718 26.0017 21H25A3.4376 3.4376 0 0121.9487 18.6836z"
                }
              }
            ],
            "name": "flood",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Flood16",
          "filepath": "flood/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 28a2.8828 2.8828 0 01-1-.1816v-.0059a3.7662 3.7662 0 01-2.0532-2.1338A.971.971 0 0025 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0121 28a3.44 3.44 0 01-3.0532-2.3213A.9894.9894 0 0017 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0113 28a3.44 3.44 0 01-3.0532-2.3213 1 1 0 00-1.8955.0049A3.4376 3.4376 0 015 28H2v2H5a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0 5.1433 5.1433 0 002.1379 1.62A4.8374 4.8374 0 0029 30h1V28zM28 13.63L29.7573 15 31 13.4282 16.6123 2.2139a1.0094 1.0094 0 00-1.2427 0L1 13.4194l1.2427 1.5718L4 13.6211v5.1875a3.6907 3.6907 0 01-2 2.0039V22.896a4.9958 4.9958 0 003-1.8833 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0025 23h5V21H28zm-6.0513 5.0532a1 1 0 00-1.8955-.0049A3.44 3.44 0 0117 21a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0013 18a.9894.9894 0 00-.9468.6787A3.44 3.44 0 019 21a3.37 3.37 0 01-3.0021-2.19L6 12.0615l9.991-7.79L26 12.0718 26.0017 21H25A3.4376 3.4376 0 0121.9487 18.6836z"
                }
              }
            ],
            "name": "flood",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Flood",
        "global": "Flood",
        "filepath": "Flood.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 28a2.8828 2.8828 0 01-1-.1816v-.0059a3.7662 3.7662 0 01-2.0532-2.1338A.971.971 0 0025 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0121 28a3.44 3.44 0 01-3.0532-2.3213A.9894.9894 0 0017 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0113 28a3.44 3.44 0 01-3.0532-2.3213 1 1 0 00-1.8955.0049A3.4376 3.4376 0 015 28H2v2H5a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0 5.1433 5.1433 0 002.1379 1.62A4.8374 4.8374 0 0029 30h1V28zM28 13.63L29.7573 15 31 13.4282 16.6123 2.2139a1.0094 1.0094 0 00-1.2427 0L1 13.4194l1.2427 1.5718L4 13.6211v5.1875a3.6907 3.6907 0 01-2 2.0039V22.896a4.9958 4.9958 0 003-1.8833 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0025 23h5V21H28zm-6.0513 5.0532a1 1 0 00-1.8955-.0049A3.44 3.44 0 0117 21a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0013 18a.9894.9894 0 00-.9468.6787A3.44 3.44 0 019 21a3.37 3.37 0 01-3.0021-2.19L6 12.0615l9.991-7.79L26 12.0718 26.0017 21H25A3.4376 3.4376 0 0121.9487 18.6836z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flood--warning",
      "friendlyName": "Flood warning",
      "aliases": [
        "flood",
        "warning",
        "disaster"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flood--warning.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z\" transform=\"translate(0 0)\"/>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z\"/><path fill=\"none\" d=\"M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z\"/><path d=\"M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z\"/><path d=\"M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z\"/></svg>",
            "info": {},
            "path": "32/flood--warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FloodWarning32",
          "filepath": "flood--warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z"
                }
              }
            ],
            "name": "flood--warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FloodWarning24",
          "filepath": "flood--warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z"
                }
              }
            ],
            "name": "flood--warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FloodWarning20",
          "filepath": "flood--warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z"
                }
              }
            ],
            "name": "flood--warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FloodWarning16",
          "filepath": "flood--warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z"
                }
              }
            ],
            "name": "flood--warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "FloodWarning",
        "global": "FloodWarning",
        "filepath": "FloodWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "floorplan",
      "friendlyName": "Floorplan",
      "aliases": [
        "floorplan",
        "file",
        "blueprint",
        "layout"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/floorplan.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4\n\th14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4\th14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z\"/></svg>",
            "info": {},
            "path": "32/floorplan.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Floorplan32",
          "filepath": "floorplan/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4\th14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z"
                }
              }
            ],
            "name": "floorplan",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Floorplan24",
          "filepath": "floorplan/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4\th14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z"
                }
              }
            ],
            "name": "floorplan",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Floorplan20",
          "filepath": "floorplan/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4\th14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z"
                }
              }
            ],
            "name": "floorplan",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Floorplan16",
          "filepath": "floorplan/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4\th14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z"
                }
              }
            ],
            "name": "floorplan",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Floorplan",
        "global": "Floorplan",
        "filepath": "Floorplan.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4 h14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow",
      "friendlyName": "Flow",
      "aliases": [
        "flow chart",
        "chart",
        "graph",
        "diagram",
        "outline",
        "flow"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>flow</title><path d=\"M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/flow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Flow32",
          "filepath": "flow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "flow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Flow24",
          "filepath": "flow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "flow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Flow20",
          "filepath": "flow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "flow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Flow16",
          "filepath": "flow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              }
            ],
            "name": "flow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Flow",
        "global": "Flow",
        "filepath": "Flow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow--connection",
      "friendlyName": "Flow connection",
      "aliases": [
        "flow connection",
        "flow",
        "connections"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow--connection.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>flow--connection</title>\n  <path d=\"M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z\"/></svg>",
            "info": {},
            "path": "32/flow--connection.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlowConnection32",
          "filepath": "flow--connection/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"
                }
              }
            ],
            "name": "flow--connection",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlowConnection24",
          "filepath": "flow--connection/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"
                }
              }
            ],
            "name": "flow--connection",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlowConnection20",
          "filepath": "flow--connection/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"
                }
              }
            ],
            "name": "flow--connection",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlowConnection16",
          "filepath": "flow--connection/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"
                }
              }
            ],
            "name": "flow--connection",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "FlowConnection",
        "global": "FlowConnection",
        "filepath": "FlowConnection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow--data",
      "friendlyName": "Flow data",
      "aliases": [
        "flow chart",
        "chart",
        "graph",
        "diagram",
        "outline",
        "flow data",
        "data flow"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow--data.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>flow--data</title><path class=\"cls-1\" d=\"M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z\"/></svg>",
            "info": {},
            "path": "32/flow--data.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlowData32",
          "filepath": "flow--data/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z"
                }
              }
            ],
            "name": "flow--data",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlowData24",
          "filepath": "flow--data/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z"
                }
              }
            ],
            "name": "flow--data",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlowData20",
          "filepath": "flow--data/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z"
                }
              }
            ],
            "name": "flow--data",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlowData16",
          "filepath": "flow--data/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z"
                }
              }
            ],
            "name": "flow--data",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "FlowData",
        "global": "FlowData",
        "filepath": "FlowData.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow--modeler",
      "friendlyName": "Flow modeler",
      "aliases": [
        "flow chart",
        "chart",
        "graph",
        "diagram",
        "outline",
        "flow modeler"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow--modeler.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,10H2V2h8ZM4,8H8V4H4Z\"/>\n  <path d=\"M30,30H22V22h8Zm-6-2h4V24H24Z\"/>\n  <path d=\"M20,27H8A6,6,0,0,1,8,15v2a4,4,0,0,0,0,8H20Z\"/>\n  <path d=\"M24,17V15a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z\"/>\n  <path d=\"M19,11H13l-3,4,6,6,6-6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 10H2V2h8zM4 8H8V4H4zM30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15v2a4 4 0 000 8H20zM24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12z\"/><path d=\"M19,11H13l-3,4,6,6,6-6Z\"/></svg>",
            "info": {},
            "path": "32/flow--modeler.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlowModeler32",
          "filepath": "flow--modeler/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 10H2V2h8zM4 8H8V4H4zM30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15v2a4 4 0 000 8H20zM24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,11H13l-3,4,6,6,6-6Z"
                }
              }
            ],
            "name": "flow--modeler",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlowModeler24",
          "filepath": "flow--modeler/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 10H2V2h8zM4 8H8V4H4zM30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15v2a4 4 0 000 8H20zM24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,11H13l-3,4,6,6,6-6Z"
                }
              }
            ],
            "name": "flow--modeler",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlowModeler20",
          "filepath": "flow--modeler/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 10H2V2h8zM4 8H8V4H4zM30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15v2a4 4 0 000 8H20zM24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,11H13l-3,4,6,6,6-6Z"
                }
              }
            ],
            "name": "flow--modeler",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlowModeler16",
          "filepath": "flow--modeler/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 10H2V2h8zM4 8H8V4H4zM30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15v2a4 4 0 000 8H20zM24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,11H13l-3,4,6,6,6-6Z"
                }
              }
            ],
            "name": "flow--modeler",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "FlowModeler",
        "global": "FlowModeler",
        "filepath": "FlowModeler.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 10H2V2h8zM4 8H8V4H4zM30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15v2a4 4 0 000 8H20zM24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,11H13l-3,4,6,6,6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow--modeler--reference",
      "friendlyName": "Flow modeler reference",
      "aliases": [
        "flow chart",
        "chart",
        "graph",
        "diagram",
        "outline",
        "flow modeler",
        "reference"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow--modeler--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,30H22V22h8Zm-6-2h4V24H24Z\"/>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M19,11H13l-3,4,6,6,6-6Z\"/>\n  <path d=\"M24,17V15a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z\"/>\n  <path d=\"M10,10H2V2h8ZM4,8H8V4H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H22V22h8zm-6-2h4V24H24zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 11H13l-3 4 6 6 6-6z\"/><path d=\"M24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z\"/></svg>",
            "info": {},
            "path": "32/flow--modeler--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlowModelerReference32",
          "filepath": "flow--modeler--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 11H13l-3 4 6 6 6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "flow--modeler--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlowModelerReference24",
          "filepath": "flow--modeler--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 11H13l-3 4 6 6 6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "flow--modeler--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlowModelerReference20",
          "filepath": "flow--modeler--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 11H13l-3 4 6 6 6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "flow--modeler--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlowModelerReference16",
          "filepath": "flow--modeler--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 11H13l-3 4 6 6 6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "flow--modeler--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "FlowModelerReference",
        "global": "FlowModelerReference",
        "filepath": "FlowModelerReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H22V22h8zm-6-2h4V24H24zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 11H13l-3 4 6 6 6-6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow--stream",
      "friendlyName": "Flow stream",
      "aliases": [
        "flow chart",
        "chart",
        "graph",
        "diagram",
        "outline",
        "flow stream"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow--stream.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #090909;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M20,24H11.8625a4.13,4.13,0,0,0-.4284-1.02L21.98,12.4343A3.9943,3.9943,0,1,0,20.1414,8H14v2h6.1414a3.96,3.96,0,0,0,.4243,1.02L10.02,21.5656A3.9943,3.9943,0,1,0,11.8587,26H20v3h8V21H20ZM24,7a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,24,7ZM8,27a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,27Zm14-4h4v4H22Z\"/>\n  <path d=\"M9.6929,12.7505a5,5,0,0,1-.0005-7.5L11.0166,6.75a3,3,0,0,0-.0005,4.501Z\"/>\n  <path d=\"M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 24H11.8625a4.13 4.13 0 00-.4284-1.02L21.98 12.4343A3.9943 3.9943 0 1020.1414 8H14v2h6.1414a3.96 3.96 0 00.4243 1.02L10.02 21.5656A3.9943 3.9943 0 1011.8587 26H20v3h8V21H20zM24 7a2 2 0 11-2 2A2.0023 2.0023 0 0124 7zM8 27a2 2 0 112-2A2.0023 2.0023 0 018 27zm14-4h4v4H22zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z\"/><path d=\"M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z\"/></svg>",
            "info": {},
            "path": "32/flow--stream.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlowStream32",
          "filepath": "flow--stream/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H11.8625a4.13 4.13 0 00-.4284-1.02L21.98 12.4343A3.9943 3.9943 0 1020.1414 8H14v2h6.1414a3.96 3.96 0 00.4243 1.02L10.02 21.5656A3.9943 3.9943 0 1011.8587 26H20v3h8V21H20zM24 7a2 2 0 11-2 2A2.0023 2.0023 0 0124 7zM8 27a2 2 0 112-2A2.0023 2.0023 0 018 27zm14-4h4v4H22zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlowStream24",
          "filepath": "flow--stream/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H11.8625a4.13 4.13 0 00-.4284-1.02L21.98 12.4343A3.9943 3.9943 0 1020.1414 8H14v2h6.1414a3.96 3.96 0 00.4243 1.02L10.02 21.5656A3.9943 3.9943 0 1011.8587 26H20v3h8V21H20zM24 7a2 2 0 11-2 2A2.0023 2.0023 0 0124 7zM8 27a2 2 0 112-2A2.0023 2.0023 0 018 27zm14-4h4v4H22zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlowStream20",
          "filepath": "flow--stream/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H11.8625a4.13 4.13 0 00-.4284-1.02L21.98 12.4343A3.9943 3.9943 0 1020.1414 8H14v2h6.1414a3.96 3.96 0 00.4243 1.02L10.02 21.5656A3.9943 3.9943 0 1011.8587 26H20v3h8V21H20zM24 7a2 2 0 11-2 2A2.0023 2.0023 0 0124 7zM8 27a2 2 0 112-2A2.0023 2.0023 0 018 27zm14-4h4v4H22zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlowStream16",
          "filepath": "flow--stream/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H11.8625a4.13 4.13 0 00-.4284-1.02L21.98 12.4343A3.9943 3.9943 0 1020.1414 8H14v2h6.1414a3.96 3.96 0 00.4243 1.02L10.02 21.5656A3.9943 3.9943 0 1011.8587 26H20v3h8V21H20zM24 7a2 2 0 11-2 2A2.0023 2.0023 0 0124 7zM8 27a2 2 0 112-2A2.0023 2.0023 0 018 27zm14-4h4v4H22zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "FlowStream",
        "global": "FlowStream",
        "filepath": "FlowStream.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 24H11.8625a4.13 4.13 0 00-.4284-1.02L21.98 12.4343A3.9943 3.9943 0 1020.1414 8H14v2h6.1414a3.96 3.96 0 00.4243 1.02L10.02 21.5656A3.9943 3.9943 0 1011.8587 26H20v3h8V21H20zM24 7a2 2 0 11-2 2A2.0023 2.0023 0 0124 7zM8 27a2 2 0 112-2A2.0023 2.0023 0 018 27zm14-4h4v4H22zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow--stream--reference",
      "friendlyName": "Flow stream reference",
      "aliases": [
        "flow chart",
        "chart",
        "graph",
        "diagram",
        "outline",
        "flow stream",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow--stream--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #090909;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M20,24H16v2h4v3h8V21H20Zm2-1h4v4H22Z\"/>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path class=\"cls-1\" d=\"M24,5a3.9962,3.9962,0,0,0-3.8579,3H14v2h6.1421a3.94,3.94,0,0,0,.4248,1.019L14,17.5862,15.4138,19l6.5672-6.5669A3.9521,3.9521,0,0,0,24,13a4,4,0,0,0,0-8Zm0,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,11Z\"/>\n  <path d=\"M9.6929,12.7505a5,5,0,0,1-.0005-7.5L11.0166,6.75a3,3,0,0,0-.0005,4.501Z\"/>\n  <path d=\"M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 24H16v2h4v3h8V21H20zm2-1h4v4H22zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 5a3.9962 3.9962 0 00-3.8579 3H14v2h6.1421a3.94 3.94 0 00.4248 1.019L14 17.5862 15.4138 19l6.5672-6.5669A3.9521 3.9521 0 0024 13a4 4 0 000-8zm0 6a2 2 0 112-2A2.0023 2.0023 0 0124 11zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z\"/><path d=\"M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z\"/></svg>",
            "info": {},
            "path": "32/flow--stream--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlowStreamReference32",
          "filepath": "flow--stream--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H16v2h4v3h8V21H20zm2-1h4v4H22zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 5a3.9962 3.9962 0 00-3.8579 3H14v2h6.1421a3.94 3.94 0 00.4248 1.019L14 17.5862 15.4138 19l6.5672-6.5669A3.9521 3.9521 0 0024 13a4 4 0 000-8zm0 6a2 2 0 112-2A2.0023 2.0023 0 0124 11zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlowStreamReference24",
          "filepath": "flow--stream--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H16v2h4v3h8V21H20zm2-1h4v4H22zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 5a3.9962 3.9962 0 00-3.8579 3H14v2h6.1421a3.94 3.94 0 00.4248 1.019L14 17.5862 15.4138 19l6.5672-6.5669A3.9521 3.9521 0 0024 13a4 4 0 000-8zm0 6a2 2 0 112-2A2.0023 2.0023 0 0124 11zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlowStreamReference20",
          "filepath": "flow--stream--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H16v2h4v3h8V21H20zm2-1h4v4H22zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 5a3.9962 3.9962 0 00-3.8579 3H14v2h6.1421a3.94 3.94 0 00.4248 1.019L14 17.5862 15.4138 19l6.5672-6.5669A3.9521 3.9521 0 0024 13a4 4 0 000-8zm0 6a2 2 0 112-2A2.0023 2.0023 0 0124 11zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlowStreamReference16",
          "filepath": "flow--stream--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 24H16v2h4v3h8V21H20zm2-1h4v4H22zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 5a3.9962 3.9962 0 00-3.8579 3H14v2h6.1421a3.94 3.94 0 00.4248 1.019L14 17.5862 15.4138 19l6.5672-6.5669A3.9521 3.9521 0 0024 13a4 4 0 000-8zm0 6a2 2 0 112-2A2.0023 2.0023 0 0124 11zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                }
              }
            ],
            "name": "flow--stream--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "FlowStreamReference",
        "global": "FlowStreamReference",
        "filepath": "FlowStreamReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 24H16v2h4v3h8V21H20zm2-1h4v4H22zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 5a3.9962 3.9962 0 00-3.8579 3H14v2h6.1421a3.94 3.94 0 00.4248 1.019L14 17.5862 15.4138 19l6.5672-6.5669A3.9521 3.9521 0 0024 13a4 4 0 000-8zm0 6a2 2 0 112-2A2.0023 2.0023 0 0124 11zM9.6929 12.7505a5 5 0 01-.0005-7.5L11.0166 6.75a3 3 0 00-.0005 4.501z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "flow-logs-vpc",
      "friendlyName": "IBM Cloud® Flow Logs for VPC",
      "aliases": [
        "flow",
        "logs",
        "vpc",
        "virtual private cloud",
        "cloud",
        "app",
        "catalog",
        "catalogue",
        "software",
        "interface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/flow-logs-vpc.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"18\" y=\"19\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"23\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"27\" width=\"8\" height=\"2\"/>\n  <path d=\"M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 19H30V21H18zM18 23H30V25H18zM18 27H26V29H18z\"/><path d=\"M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z\"/></svg>",
            "info": {},
            "path": "32/flow-logs-vpc.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FlowLogsVpc32",
          "filepath": "flow-logs-vpc/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H30V21H18zM18 23H30V25H18zM18 27H26V29H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
                }
              }
            ],
            "name": "flow-logs-vpc",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FlowLogsVpc24",
          "filepath": "flow-logs-vpc/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H30V21H18zM18 23H30V25H18zM18 27H26V29H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
                }
              }
            ],
            "name": "flow-logs-vpc",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FlowLogsVpc20",
          "filepath": "flow-logs-vpc/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H30V21H18zM18 23H30V25H18zM18 27H26V29H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
                }
              }
            ],
            "name": "flow-logs-vpc",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FlowLogsVpc16",
          "filepath": "flow-logs-vpc/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H30V21H18zM18 23H30V25H18zM18 27H26V29H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
                }
              }
            ],
            "name": "flow-logs-vpc",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "FlowLogsVpc",
        "global": "FlowLogsVpc",
        "filepath": "FlowLogsVpc.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 19H30V21H18zM18 23H30V25H18zM18 27H26V29H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fog",
      "friendlyName": "Fog",
      "aliases": [
        "fog",
        "mist",
        "mistly",
        "precipitation",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fog.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fog</title><path d=\"M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z\"/><rect x=\"2\" y=\"26\" width=\"18\" height=\"2\" rx=\"1\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z\"/><rect width=\"18\" height=\"2\" x=\"2\" y=\"26\" rx=\"1\"/></svg>",
            "info": {},
            "path": "32/fog.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Fog32",
          "filepath": "fog/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "18",
                  "height": "2",
                  "x": "2",
                  "y": "26",
                  "rx": "1"
                }
              }
            ],
            "name": "fog",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Fog24",
          "filepath": "fog/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "18",
                  "height": "2",
                  "x": "2",
                  "y": "26",
                  "rx": "1"
                }
              }
            ],
            "name": "fog",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Fog20",
          "filepath": "fog/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "18",
                  "height": "2",
                  "x": "2",
                  "y": "26",
                  "rx": "1"
                }
              }
            ],
            "name": "fog",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Fog16",
          "filepath": "fog/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "18",
                  "height": "2",
                  "x": "2",
                  "y": "26",
                  "rx": "1"
                }
              }
            ],
            "name": "fog",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Fog",
        "global": "Fog",
        "filepath": "Fog.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "rect",
                  "attributes": {
                    "width": "18",
                    "height": "2",
                    "x": "2",
                    "y": "26",
                    "rx": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder",
      "friendlyName": "Folder",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>folder</title><path d=\"M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z\"/></svg>",
            "info": {},
            "path": "32/folder.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Folder32",
          "filepath": "folder/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z"
                }
              }
            ],
            "name": "folder",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Folder24",
          "filepath": "folder/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z"
                }
              }
            ],
            "name": "folder",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Folder20",
          "filepath": "folder/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z"
                }
              }
            ],
            "name": "folder",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Folder16",
          "filepath": "folder/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z"
                }
              }
            ],
            "name": "folder",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Folder",
        "global": "Folder",
        "filepath": "Folder.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--add",
      "friendlyName": "Folder add",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder add",
        "folder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--add.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>folder--add</title>\n<polygon points=\"26,20 24,20 24,24 20,24 20,26 24,26 24,30 26,30 26,26 30,26 30,24 26,24 \"/>\n<path d=\"M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\n\tC30,8.9,29.1,8,28,8z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 20L24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24 26 24z\"/><path d=\"M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z\"/></svg>",
            "info": {},
            "path": "32/folder--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderAdd32",
          "filepath": "folder--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20L24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24 26 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "folder--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderAdd24",
          "filepath": "folder--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20L24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24 26 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "folder--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderAdd20",
          "filepath": "folder--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20L24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24 26 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "folder--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderAdd16",
          "filepath": "folder--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20L24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24 26 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "folder--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderAdd",
        "global": "FolderAdd",
        "filepath": "FolderAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 20L24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24 26 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8 C30,8.9,29.1,8,28,8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--details",
      "friendlyName": "Folder details",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder details",
        "folder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--details.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>folder--details</title><rect x=\"16\" y=\"20\" width=\"14\" height=\"2\"/><rect x=\"16\" y=\"24\" width=\"14\" height=\"2\"/><rect x=\"16\" y=\"28\" width=\"7\" height=\"2\"/><path d=\"M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 20H30V22H16zM16 24H30V26H16zM16 28H23V30H16z\"/><path d=\"M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/></svg>",
            "info": {},
            "path": "32/folder--details.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderDetails32",
          "filepath": "folder--details/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H30V22H16zM16 24H30V26H16zM16 28H23V30H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "folder--details",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderDetails24",
          "filepath": "folder--details/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H30V22H16zM16 24H30V26H16zM16 28H23V30H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "folder--details",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderDetails20",
          "filepath": "folder--details/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H30V22H16zM16 24H30V26H16zM16 28H23V30H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "folder--details",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderDetails16",
          "filepath": "folder--details/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20H30V22H16zM16 24H30V26H16zM16 28H23V30H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "folder--details",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderDetails",
        "global": "FolderDetails",
        "filepath": "FolderDetails.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 20H30V22H16zM16 24H30V26H16zM16 28H23V30H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--details--reference",
      "friendlyName": "Folder details reference",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder details",
        "folder",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--details--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"16\" y=\"28\" width=\"7\" height=\"2\"/>\n  <rect x=\"16\" y=\"24\" width=\"14\" height=\"2\"/>\n  <rect x=\"16\" y=\"20\" width=\"14\" height=\"2\"/>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M28,8H16L12.5859,4.5859A2.0007,2.0007,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V18H4V6h7.1716l3.4141,3.4141L15.1716,10H28v8h2V10A2,2,0,0,0,28,8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 28H23V30H16zM16 24H30V26H16zM16 20H30V22H16zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V18H4V6h7.1716l3.4141 3.4141L15.1716 10H28v8h2V10A2 2 0 0028 8z\"/></svg>",
            "info": {},
            "path": "32/folder--details--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderDetailsReference32",
          "filepath": "folder--details--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H23V30H16zM16 24H30V26H16zM16 20H30V22H16zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V18H4V6h7.1716l3.4141 3.4141L15.1716 10H28v8h2V10A2 2 0 0028 8z"
                }
              }
            ],
            "name": "folder--details--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderDetailsReference24",
          "filepath": "folder--details--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H23V30H16zM16 24H30V26H16zM16 20H30V22H16zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V18H4V6h7.1716l3.4141 3.4141L15.1716 10H28v8h2V10A2 2 0 0028 8z"
                }
              }
            ],
            "name": "folder--details--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderDetailsReference20",
          "filepath": "folder--details--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H23V30H16zM16 24H30V26H16zM16 20H30V22H16zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V18H4V6h7.1716l3.4141 3.4141L15.1716 10H28v8h2V10A2 2 0 0028 8z"
                }
              }
            ],
            "name": "folder--details--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderDetailsReference16",
          "filepath": "folder--details--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H23V30H16zM16 24H30V26H16zM16 20H30V22H16zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V18H4V6h7.1716l3.4141 3.4141L15.1716 10H28v8h2V10A2 2 0 0028 8z"
                }
              }
            ],
            "name": "folder--details--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderDetailsReference",
        "global": "FolderDetailsReference",
        "filepath": "FolderDetailsReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 28H23V30H16zM16 24H30V26H16zM16 20H30V22H16zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V18H4V6h7.1716l3.4141 3.4141L15.1716 10H28v8h2V10A2 2 0 0028 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--move-to",
      "friendlyName": "Folder move to",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder",
        "folder move to"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--move-to.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"18 13 16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13\"/>\n  <path d=\"M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 13L16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13z\"/><path d=\"M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z\"/></svg>",
            "info": {},
            "path": "32/folder--move-to.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderMoveTo32",
          "filepath": "folder--move-to/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z"
                }
              }
            ],
            "name": "folder--move-to",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderMoveTo24",
          "filepath": "folder--move-to/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z"
                }
              }
            ],
            "name": "folder--move-to",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderMoveTo20",
          "filepath": "folder--move-to/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z"
                }
              }
            ],
            "name": "folder--move-to",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderMoveTo16",
          "filepath": "folder--move-to/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z"
                }
              }
            ],
            "name": "folder--move-to",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderMoveTo",
        "global": "FolderMoveTo",
        "filepath": "FolderMoveTo.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 13L16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--off",
      "friendlyName": "Folder off",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder",
        "folder off"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>folder--off</title><path d=\"M28,8H25.4141L30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Zm0,18H7.4141l16-16H28Z\"/><path d=\"M4,6h7.1716l3.4141,3.4141L15.1716,10H18V8H16L12.5859,4.5859A2.0007,2.0007,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V24H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 8H25.4141L30 3.4141 28.5859 2 2 28.5859 3.4141 30l2-2H28a2 2 0 002-2V10A2 2 0 0028 8zm0 18H7.4141l16-16H28zM4 6h7.1716l3.4141 3.4141L15.1716 10H18V8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V24H4z\"/></svg>",
            "info": {},
            "path": "32/folder--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderOff32",
          "filepath": "folder--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H25.4141L30 3.4141 28.5859 2 2 28.5859 3.4141 30l2-2H28a2 2 0 002-2V10A2 2 0 0028 8zm0 18H7.4141l16-16H28zM4 6h7.1716l3.4141 3.4141L15.1716 10H18V8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V24H4z"
                }
              }
            ],
            "name": "folder--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderOff24",
          "filepath": "folder--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H25.4141L30 3.4141 28.5859 2 2 28.5859 3.4141 30l2-2H28a2 2 0 002-2V10A2 2 0 0028 8zm0 18H7.4141l16-16H28zM4 6h7.1716l3.4141 3.4141L15.1716 10H18V8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V24H4z"
                }
              }
            ],
            "name": "folder--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderOff20",
          "filepath": "folder--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H25.4141L30 3.4141 28.5859 2 2 28.5859 3.4141 30l2-2H28a2 2 0 002-2V10A2 2 0 0028 8zm0 18H7.4141l16-16H28zM4 6h7.1716l3.4141 3.4141L15.1716 10H18V8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V24H4z"
                }
              }
            ],
            "name": "folder--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderOff16",
          "filepath": "folder--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H25.4141L30 3.4141 28.5859 2 2 28.5859 3.4141 30l2-2H28a2 2 0 002-2V10A2 2 0 0028 8zm0 18H7.4141l16-16H28zM4 6h7.1716l3.4141 3.4141L15.1716 10H18V8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V24H4z"
                }
              }
            ],
            "name": "folder--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderOff",
        "global": "FolderOff",
        "filepath": "FolderOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 8H25.4141L30 3.4141 28.5859 2 2 28.5859 3.4141 30l2-2H28a2 2 0 002-2V10A2 2 0 0028 8zm0 18H7.4141l16-16H28zM4 6h7.1716l3.4141 3.4141L15.1716 10H18V8H16L12.5859 4.5859A2.0007 2.0007 0 0011.1716 4H4A2 2 0 002 6V24H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--open",
      "friendlyName": "Folder open",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder",
        "folder open"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--open.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z\"/></svg>",
            "info": {},
            "path": "32/folder--open.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderOpen32",
          "filepath": "folder--open/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z"
                }
              }
            ],
            "name": "folder--open",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderOpen24",
          "filepath": "folder--open/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z"
                }
              }
            ],
            "name": "folder--open",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderOpen20",
          "filepath": "folder--open/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z"
                }
              }
            ],
            "name": "folder--open",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderOpen16",
          "filepath": "folder--open/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z"
                }
              }
            ],
            "name": "folder--open",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderOpen",
        "global": "FolderOpen",
        "filepath": "FolderOpen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--parent",
      "friendlyName": "Folder parent",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder",
        "folder parent"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--parent.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z\"/></svg>",
            "info": {},
            "path": "32/folder--parent.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderParent32",
          "filepath": "folder--parent/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z"
                }
              }
            ],
            "name": "folder--parent",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderParent24",
          "filepath": "folder--parent/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z"
                }
              }
            ],
            "name": "folder--parent",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderParent20",
          "filepath": "folder--parent/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z"
                }
              }
            ],
            "name": "folder--parent",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderParent16",
          "filepath": "folder--parent/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z"
                }
              }
            ],
            "name": "folder--parent",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderParent",
        "global": "FolderParent",
        "filepath": "FolderParent.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folder--shared",
      "friendlyName": "Folder shared",
      "aliases": [
        "file",
        "save",
        "document",
        "organize",
        "folder shared",
        "folder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folder--shared.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>folder--shared</title><path d=\"M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z\"/><path d=\"M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z\"/><path d=\"M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z\"/></svg>",
            "info": {},
            "path": "32/folder--shared.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FolderShared32",
          "filepath": "folder--shared/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z"
                }
              }
            ],
            "name": "folder--shared",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FolderShared24",
          "filepath": "folder--shared/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z"
                }
              }
            ],
            "name": "folder--shared",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FolderShared20",
          "filepath": "folder--shared/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z"
                }
              }
            ],
            "name": "folder--shared",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FolderShared16",
          "filepath": "folder--shared/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z"
                }
              }
            ],
            "name": "folder--shared",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "FolderShared",
        "global": "FolderShared",
        "filepath": "FolderShared.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "folders",
      "friendlyName": "Folders",
      "aliases": [
        "files",
        "collection",
        "folders"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/folders.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>folders</title><path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V11A2.0021,2.0021,0,0,1,6,9h5.6665a2.0119,2.0119,0,0,1,1.2007.4L16.3335,12H26a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28ZM11.6665,11H5.9985L6,26H26V14H15.6665Z\"/><path d=\"M28,9H17.6665l-4-3H6V4h7.6665a2.0119,2.0119,0,0,1,1.2007.4L18.3335,7H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 28H6a2.0021 2.0021 0 01-2-2V11A2.0021 2.0021 0 016 9h5.6665a2.0119 2.0119 0 011.2007.4L16.3335 12H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM11.6665 11H5.9985L6 26H26V14H15.6665zM28 9H17.6665l-4-3H6V4h7.6665a2.0119 2.0119 0 011.2007.4L18.3335 7H28z\"/></svg>",
            "info": {},
            "path": "32/folders.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Folders32",
          "filepath": "folders/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V11A2.0021 2.0021 0 016 9h5.6665a2.0119 2.0119 0 011.2007.4L16.3335 12H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM11.6665 11H5.9985L6 26H26V14H15.6665zM28 9H17.6665l-4-3H6V4h7.6665a2.0119 2.0119 0 011.2007.4L18.3335 7H28z"
                }
              }
            ],
            "name": "folders",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Folders24",
          "filepath": "folders/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V11A2.0021 2.0021 0 016 9h5.6665a2.0119 2.0119 0 011.2007.4L16.3335 12H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM11.6665 11H5.9985L6 26H26V14H15.6665zM28 9H17.6665l-4-3H6V4h7.6665a2.0119 2.0119 0 011.2007.4L18.3335 7H28z"
                }
              }
            ],
            "name": "folders",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Folders20",
          "filepath": "folders/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V11A2.0021 2.0021 0 016 9h5.6665a2.0119 2.0119 0 011.2007.4L16.3335 12H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM11.6665 11H5.9985L6 26H26V14H15.6665zM28 9H17.6665l-4-3H6V4h7.6665a2.0119 2.0119 0 011.2007.4L18.3335 7H28z"
                }
              }
            ],
            "name": "folders",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Folders16",
          "filepath": "folders/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V11A2.0021 2.0021 0 016 9h5.6665a2.0119 2.0119 0 011.2007.4L16.3335 12H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM11.6665 11H5.9985L6 26H26V14H15.6665zM28 9H17.6665l-4-3H6V4h7.6665a2.0119 2.0119 0 011.2007.4L18.3335 7H28z"
                }
              }
            ],
            "name": "folders",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Folders",
        "global": "Folders",
        "filepath": "Folders.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 28H6a2.0021 2.0021 0 01-2-2V11A2.0021 2.0021 0 016 9h5.6665a2.0119 2.0119 0 011.2007.4L16.3335 12H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM11.6665 11H5.9985L6 26H26V14H15.6665zM28 9H17.6665l-4-3H6V4h7.6665a2.0119 2.0119 0 011.2007.4L18.3335 7H28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forecast--hail",
      "friendlyName": "Forecast hail",
      "aliases": [
        "weather",
        "forecast",
        "hail",
        "precipitation",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forecast--hail.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"14.5\" cy=\"23.5\" r=\"1.5\"/>\n  <circle cx=\"11.5\" cy=\"19.5\" r=\"1.5\"/>\n  <circle cx=\"17.5\" cy=\"19.5\" r=\"1.5\"/>\n  <rect x=\"12.9644\" y=\"14.5001\" width=\"5.0716\" height=\"1.9994\" transform=\"translate(-6.4201 15.5001) rotate(-45)\"/>\n  <rect x=\"18.9644\" y=\"14.5001\" width=\"5.0716\" height=\"1.9994\" transform=\"translate(-4.6627 19.7427) rotate(-45)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\"/><circle cx=\"14.5\" cy=\"23.5\" r=\"1.5\"/><circle cx=\"11.5\" cy=\"19.5\" r=\"1.5\"/><circle cx=\"17.5\" cy=\"19.5\" r=\"1.5\"/><path d=\"M12.964 14.5H18.036V16.499H12.964z\" transform=\"rotate(-45 15.5 15.5)\"/><path d=\"M18.964 14.5H24.035999999999998V16.499H18.964z\" transform=\"rotate(-45 21.5 15.5)\"/></svg>",
            "info": {},
            "path": "32/forecast--hail.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ForecastHail32",
          "filepath": "forecast--hail/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.964 14.5H18.036V16.499H12.964z",
                  "transform": "rotate(-45 15.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.964 14.5H24.035999999999998V16.499H18.964z",
                  "transform": "rotate(-45 21.5 15.5)"
                }
              }
            ],
            "name": "forecast--hail",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ForecastHail24",
          "filepath": "forecast--hail/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.964 14.5H18.036V16.499H12.964z",
                  "transform": "rotate(-45 15.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.964 14.5H24.035999999999998V16.499H18.964z",
                  "transform": "rotate(-45 21.5 15.5)"
                }
              }
            ],
            "name": "forecast--hail",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ForecastHail20",
          "filepath": "forecast--hail/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.964 14.5H18.036V16.499H12.964z",
                  "transform": "rotate(-45 15.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.964 14.5H24.035999999999998V16.499H18.964z",
                  "transform": "rotate(-45 21.5 15.5)"
                }
              }
            ],
            "name": "forecast--hail",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ForecastHail16",
          "filepath": "forecast--hail/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.964 14.5H18.036V16.499H12.964z",
                  "transform": "rotate(-45 15.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.964 14.5H24.035999999999998V16.499H18.964z",
                  "transform": "rotate(-45 21.5 15.5)"
                }
              }
            ],
            "name": "forecast--hail",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ForecastHail",
        "global": "ForecastHail",
        "filepath": "ForecastHail.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14.5",
                    "cy": "23.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11.5",
                    "cy": "19.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.964 14.5H18.036V16.499H12.964z",
                    "transform": "rotate(-45 15.5 15.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.964 14.5H24.035999999999998V16.499H18.964z",
                    "transform": "rotate(-45 21.5 15.5)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forecast--hail-30",
      "friendlyName": "Forecast hail 30",
      "aliases": [
        "weather",
        "forecast",
        "hail",
        "precipitation",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forecast--hail-30.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8.9644\" y=\"13.5001\" width=\"5.0716\" height=\"1.9994\" transform=\"translate(-6.8846 12.3788) rotate(-45)\"/>\n  <rect x=\"15.3786\" y=\"14.5002\" width=\"2.2432\" height=\"1.9994\" transform=\"translate(-6.1273 16.2053) rotate(-44.9951)\"/>\n  <circle cx=\"10.5\" cy=\"22.5\" r=\"1.5\"/>\n  <circle cx=\"7.5\" cy=\"18.5\" r=\"1.5\"/>\n  <circle cx=\"13.5\" cy=\"18.5\" r=\"1.5\"/>\n  <path d=\"M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,20H16v2h4v2H17v2h3v2H16v2h4a2.0027,2.0027,0,0,0,2-2V22A2.0023,2.0023,0,0,0,20,20Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,30H26a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30Zm-2-8v6h2V22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.964 13.5H14.036000000000001V15.499H8.964z\" transform=\"rotate(-45 11.5 14.5)\"/><path d=\"M15.379 14.5H17.622V16.499H15.379z\" transform=\"rotate(-44.995 16.5 15.5)\"/><circle cx=\"10.5\" cy=\"22.5\" r=\"1.5\"/><circle cx=\"7.5\" cy=\"18.5\" r=\"1.5\"/><circle cx=\"13.5\" cy=\"18.5\" r=\"1.5\"/><path d=\"M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z\"/><path d=\"M20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z\"/></svg>",
            "info": {},
            "path": "32/forecast--hail-30.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ForecastHail_3032",
          "filepath": "forecast--hail-30/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.964 13.5H14.036000000000001V15.499H8.964z",
                  "transform": "rotate(-45 11.5 14.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.379 14.5H17.622V16.499H15.379z",
                  "transform": "rotate(-44.995 16.5 15.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--hail-30",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ForecastHail_3024",
          "filepath": "forecast--hail-30/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.964 13.5H14.036000000000001V15.499H8.964z",
                  "transform": "rotate(-45 11.5 14.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.379 14.5H17.622V16.499H15.379z",
                  "transform": "rotate(-44.995 16.5 15.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--hail-30",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ForecastHail_3020",
          "filepath": "forecast--hail-30/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.964 13.5H14.036000000000001V15.499H8.964z",
                  "transform": "rotate(-45 11.5 14.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.379 14.5H17.622V16.499H15.379z",
                  "transform": "rotate(-44.995 16.5 15.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--hail-30",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ForecastHail_3016",
          "filepath": "forecast--hail-30/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.964 13.5H14.036000000000001V15.499H8.964z",
                  "transform": "rotate(-45 11.5 14.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.379 14.5H17.622V16.499H15.379z",
                  "transform": "rotate(-44.995 16.5 15.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "18.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--hail-30",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ForecastHail_30",
        "global": "ForecastHail_30",
        "filepath": "ForecastHail_30.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.964 13.5H14.036000000000001V15.499H8.964z",
                    "transform": "rotate(-45 11.5 14.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.379 14.5H17.622V16.499H15.379z",
                    "transform": "rotate(-44.995 16.5 15.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10.5",
                    "cy": "22.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7.5",
                    "cy": "18.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13.5",
                    "cy": "18.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forecast--lightning",
      "friendlyName": "Forecast lightning",
      "aliases": [
        "forecast",
        "lightning",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forecast--lightning.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"15.67 24 13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24\"/>\n  <path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z\"/><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\"/></svg>",
            "info": {},
            "path": "32/forecast--lightning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ForecastLightning32",
          "filepath": "forecast--lightning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              }
            ],
            "name": "forecast--lightning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ForecastLightning24",
          "filepath": "forecast--lightning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              }
            ],
            "name": "forecast--lightning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ForecastLightning20",
          "filepath": "forecast--lightning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              }
            ],
            "name": "forecast--lightning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ForecastLightning16",
          "filepath": "forecast--lightning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              }
            ],
            "name": "forecast--lightning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ForecastLightning",
        "global": "ForecastLightning",
        "filepath": "ForecastLightning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forecast--lightning-30",
      "friendlyName": "Forecast lightning 30",
      "aliases": [
        "forecast",
        "lightning",
        "weather",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forecast--lightning-30.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"11.67 24 9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24\"/>\n  <path d=\"M20,20H16v2h4v2H17v2h3v2H16v2h4a2.0027,2.0027,0,0,0,2-2V22A2.0023,2.0023,0,0,0,20,20Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,30H26a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30Zm-2-8v6h2V22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z\"/><path d=\"M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z\"/></svg>",
            "info": {},
            "path": "32/forecast--lightning-30.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ForecastLightning_3032",
          "filepath": "forecast--lightning-30/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--lightning-30",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ForecastLightning_3024",
          "filepath": "forecast--lightning-30/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--lightning-30",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ForecastLightning_3020",
          "filepath": "forecast--lightning-30/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--lightning-30",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ForecastLightning_3016",
          "filepath": "forecast--lightning-30/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                }
              }
            ],
            "name": "forecast--lightning-30",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ForecastLightning_30",
        "global": "ForecastLightning_30",
        "filepath": "ForecastLightning_30.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fork",
      "friendlyName": "Fork",
      "aliases": [
        "fork",
        "operations",
        "split"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fork.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fork</title><path d=\"M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z\"/></svg>",
            "info": {},
            "path": "32/fork.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Fork32",
          "filepath": "fork/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
                }
              }
            ],
            "name": "fork",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Fork24",
          "filepath": "fork/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
                }
              }
            ],
            "name": "fork",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Fork20",
          "filepath": "fork/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
                }
              }
            ],
            "name": "fork",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Fork16",
          "filepath": "fork/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
                }
              }
            ],
            "name": "fork",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Fork",
        "global": "Fork",
        "filepath": "Fork.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forum",
      "friendlyName": "Forum",
      "aliases": [
        "chat",
        "talk",
        "discuss",
        "conference",
        "forum"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forum.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\n\tC30,6.8,29.2,6,28,6z\"/>\n<path d=\"M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z\"/><path d=\"M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z\"/></svg>",
            "info": {},
            "path": "32/forum.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Forum32",
          "filepath": "forum/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
                }
              }
            ],
            "name": "forum",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Forum24",
          "filepath": "forum/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
                }
              }
            ],
            "name": "forum",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Forum20",
          "filepath": "forum/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
                }
              }
            ],
            "name": "forum",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Forum16",
          "filepath": "forum/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
                }
              }
            ],
            "name": "forum",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Forum",
        "global": "Forum",
        "filepath": "Forum.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8 C30,6.8,29.2,6,28,6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forward--10",
      "friendlyName": "Forward 10",
      "aliases": [
        "ahead",
        "future",
        "fast forward",
        "skip",
        "next",
        "fast",
        "forward",
        "forward 10"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forward--10.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>forward--10</title><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\" transform=\"translate(0 0)\"/><path d=\"M19.63,22.13a2.84,2.84,0,0,1-1.28-.27,2.44,2.44,0,0,1-.89-.77,3.57,3.57,0,0,1-.52-1.25,7.69,7.69,0,0,1-.17-1.68,7.83,7.83,0,0,1,.17-1.68,3.65,3.65,0,0,1,.52-1.25,2.44,2.44,0,0,1,.89-.77,2.84,2.84,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.23,5.23,0,0,1,.7,2.93,5.23,5.23,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.63,22.13Zm0-1.22a1.07,1.07,0,0,0,1-.55A3.38,3.38,0,0,0,21,18.85V17.47a3.31,3.31,0,0,0-.29-1.5,1.23,1.23,0,0,0-2.06,0,3.31,3.31,0,0,0-.29,1.5v1.38a3.38,3.38,0,0,0,.29,1.51A1.06,1.06,0,0,0,19.63,20.91Z\" transform=\"translate(0 0)\"/><path d=\"M10.63,22V20.82h2V15.63l-1.86,1-.55-1.06,2.32-1.3H14v6.5h1.78V22Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\"/><path d=\"M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z\"/></svg>",
            "info": {},
            "path": "32/forward--10.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Forward_1032",
          "filepath": "forward--10/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "forward--10",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Forward_1024",
          "filepath": "forward--10/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "forward--10",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Forward_1020",
          "filepath": "forward--10/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "forward--10",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Forward_1016",
          "filepath": "forward--10/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "forward--10",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Forward_10",
        "global": "Forward_10",
        "filepath": "Forward_10.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forward--30",
      "friendlyName": "Forward 30",
      "aliases": [
        "ahead",
        "future",
        "fast forward",
        "skip",
        "next",
        "fast",
        "forward 10",
        "forward"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forward--30.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>forward--30</title><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\"/><path d=\"M19.64,22.13a2.81,2.81,0,0,1-1.28-.27,2.36,2.36,0,0,1-.89-.77A3.39,3.39,0,0,1,17,19.84a7.12,7.12,0,0,1-.17-1.68A7.24,7.24,0,0,1,17,16.48a3.46,3.46,0,0,1,.52-1.25,2.36,2.36,0,0,1,.89-.77,2.81,2.81,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.31,5.31,0,0,1,.7,2.93,5.31,5.31,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.64,22.13Zm0-1.22a1,1,0,0,0,1-.55,3.24,3.24,0,0,0,.3-1.51V17.47a3.17,3.17,0,0,0-.3-1.5,1.22,1.22,0,0,0-2.05,0,3.18,3.18,0,0,0-.29,1.5v1.38a3.25,3.25,0,0,0,.29,1.51A1,1,0,0,0,19.64,20.91Z\"/><path d=\"M12.62,17.42a1.46,1.46,0,0,0,1-.27.84.84,0,0,0,.31-.68v-.08a.94.94,0,0,0-.3-.74,1.2,1.2,0,0,0-.83-.27,1.65,1.65,0,0,0-.89.24,2.1,2.1,0,0,0-.68.68l-.93-.83a5.37,5.37,0,0,1,.44-.51,2.7,2.7,0,0,1,.54-.4,2.55,2.55,0,0,1,.7-.27,3.25,3.25,0,0,1,.87-.1,3.94,3.94,0,0,1,1.06.14,2.33,2.33,0,0,1,.82.4,1.91,1.91,0,0,1,.54.63,1.87,1.87,0,0,1,.18.83,2,2,0,0,1-.11.67,1.82,1.82,0,0,1-.32.52,1.79,1.79,0,0,1-.47.36,2.27,2.27,0,0,1-.57.2V18a2.34,2.34,0,0,1,.63.21,1.7,1.7,0,0,1,.51.38,1.89,1.89,0,0,1,.34.55,2.07,2.07,0,0,1,.12.73,2,2,0,0,1-.2.92,2,2,0,0,1-.58.72,2.66,2.66,0,0,1-.89.45,3.76,3.76,0,0,1-1.15.16,4.1,4.1,0,0,1-1-.11A3.1,3.1,0,0,1,11,21.7a2.76,2.76,0,0,1-.56-.45A4.22,4.22,0,0,1,10,20.7l1.07-.81a3.07,3.07,0,0,0,.28.42,1.94,1.94,0,0,0,.36.34,1.57,1.57,0,0,0,.45.22,2,2,0,0,0,.57.07,1.45,1.45,0,0,0,1-.3,1.12,1.12,0,0,0,.34-.85v-.08a1,1,0,0,0-.37-.8,1.78,1.78,0,0,0-1.06-.28h-.76V17.42Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\"/><path d=\"M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z\"/></svg>",
            "info": {},
            "path": "32/forward--30.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Forward_3032",
          "filepath": "forward--30/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "forward--30",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Forward_3024",
          "filepath": "forward--30/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "forward--30",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Forward_3020",
          "filepath": "forward--30/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "forward--30",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Forward_3016",
          "filepath": "forward--30/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "forward--30",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Forward_30",
        "global": "Forward_30",
        "filepath": "Forward_30.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "forward--5",
      "friendlyName": "Forward 5",
      "aliases": [
        "ahead",
        "future",
        "fast forward",
        "skip",
        "next",
        "fast",
        "forward 5",
        "forward"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/forward--5.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>forward--5</title><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\"/><path d=\"M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z\"/><path d=\"M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z\"/></svg>",
            "info": {},
            "path": "32/forward--5.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Forward_532",
          "filepath": "forward--5/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "forward--5",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Forward_524",
          "filepath": "forward--5/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "forward--5",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Forward_520",
          "filepath": "forward--5/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "forward--5",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Forward_516",
          "filepath": "forward--5/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "forward--5",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Forward_5",
        "global": "Forward_5",
        "filepath": "Forward_5.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fragile",
      "friendlyName": "Fragile",
      "aliases": [
        "fragile",
        "breakable",
        "use care",
        "caution",
        "packaging",
        "handling",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fragile.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z\"/></svg>",
            "info": {},
            "path": "32/fragile.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Fragile32",
          "filepath": "fragile/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
                }
              }
            ],
            "name": "fragile",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Fragile24",
          "filepath": "fragile/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
                }
              }
            ],
            "name": "fragile",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Fragile20",
          "filepath": "fragile/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
                }
              }
            ],
            "name": "fragile",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Fragile16",
          "filepath": "fragile/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
                }
              }
            ],
            "name": "fragile",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Fragile",
        "global": "Fragile",
        "filepath": "Fragile.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "friendship",
      "friendlyName": "friendship",
      "aliases": [
        "people",
        "friends",
        "friendship",
        "relationship",
        "partner",
        "human",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/friendship.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,10H7a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H12V28H8V19H6V13a1.0009,1.0009,0,0,1,1-1H25a1.0009,1.0009,0,0,1,1,1v6H24v9H20V16H18V28a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,25,10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,10,9Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,10,3Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,22,9Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,22,3Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 10H7a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V16H12V28H8V19H6V13a1.0009 1.0009 0 011-1H25a1.0009 1.0009 0 011 1v6H24v9H20V16H18V28a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0025 10zM10 9a4 4 0 114-4A4.0042 4.0042 0 0110 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0010 3zM22 9a4 4 0 114-4A4.0042 4.0042 0 0122 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0022 3z\"/></svg>",
            "info": {},
            "path": "32/friendship.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Friendship32",
          "filepath": "friendship/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10H7a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V16H12V28H8V19H6V13a1.0009 1.0009 0 011-1H25a1.0009 1.0009 0 011 1v6H24v9H20V16H18V28a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0025 10zM10 9a4 4 0 114-4A4.0042 4.0042 0 0110 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0010 3zM22 9a4 4 0 114-4A4.0042 4.0042 0 0122 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0022 3z"
                }
              }
            ],
            "name": "friendship",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Friendship24",
          "filepath": "friendship/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10H7a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V16H12V28H8V19H6V13a1.0009 1.0009 0 011-1H25a1.0009 1.0009 0 011 1v6H24v9H20V16H18V28a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0025 10zM10 9a4 4 0 114-4A4.0042 4.0042 0 0110 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0010 3zM22 9a4 4 0 114-4A4.0042 4.0042 0 0122 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0022 3z"
                }
              }
            ],
            "name": "friendship",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Friendship20",
          "filepath": "friendship/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10H7a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V16H12V28H8V19H6V13a1.0009 1.0009 0 011-1H25a1.0009 1.0009 0 011 1v6H24v9H20V16H18V28a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0025 10zM10 9a4 4 0 114-4A4.0042 4.0042 0 0110 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0010 3zM22 9a4 4 0 114-4A4.0042 4.0042 0 0122 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0022 3z"
                }
              }
            ],
            "name": "friendship",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Friendship16",
          "filepath": "friendship/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10H7a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V16H12V28H8V19H6V13a1.0009 1.0009 0 011-1H25a1.0009 1.0009 0 011 1v6H24v9H20V16H18V28a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0025 10zM10 9a4 4 0 114-4A4.0042 4.0042 0 0110 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0010 3zM22 9a4 4 0 114-4A4.0042 4.0042 0 0122 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0022 3z"
                }
              }
            ],
            "name": "friendship",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Friendship",
        "global": "Friendship",
        "filepath": "Friendship.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 10H7a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V16H12V28H8V19H6V13a1.0009 1.0009 0 011-1H25a1.0009 1.0009 0 011 1v6H24v9H20V16H18V28a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0025 10zM10 9a4 4 0 114-4A4.0042 4.0042 0 0110 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0010 3zM22 9a4 4 0 114-4A4.0042 4.0042 0 0122 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0022 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fruit-bowl",
      "friendlyName": "Fruit bowl",
      "aliases": [
        "fruit bowl",
        "commerce",
        "fruit",
        "bowl"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/fruit-bowl.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>fruit-bowl</title><path d=\"M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/fruit-bowl.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FruitBowl32",
          "filepath": "fruit-bowl/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              }
            ],
            "name": "fruit-bowl",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FruitBowl24",
          "filepath": "fruit-bowl/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              }
            ],
            "name": "fruit-bowl",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FruitBowl20",
          "filepath": "fruit-bowl/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              }
            ],
            "name": "fruit-bowl",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FruitBowl16",
          "filepath": "fruit-bowl/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              }
            ],
            "name": "fruit-bowl",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "FruitBowl",
        "global": "FruitBowl",
        "filepath": "FruitBowl.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "function",
      "friendlyName": "Function",
      "aliases": [
        "action",
        "behavior",
        "duty",
        "purpose",
        "role",
        "responsibility",
        "objective",
        "function"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/function.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z\"/>\n  <path d=\"M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z\"/>\n  <path d=\"M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z\"/><path d=\"M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z\"/><path d=\"M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z\"/></svg>",
            "info": {},
            "path": "32/function.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Function32",
          "filepath": "function/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
                }
              }
            ],
            "name": "function",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Function24",
          "filepath": "function/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
                }
              }
            ],
            "name": "function",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Function20",
          "filepath": "function/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
                }
              }
            ],
            "name": "function",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Function16",
          "filepath": "function/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
                }
              }
            ],
            "name": "function",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Function",
        "global": "Function",
        "filepath": "Function.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "function-math",
      "friendlyName": "Function math",
      "aliases": [
        "function math",
        "function",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/function-math.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #1c1c1c;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26 18 24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18\"/>\n  <path class=\"cls-1\" d=\"M19,6V4H13.9133a1.9906,1.9906,0,0,0-1.9919,1.8188L11.2686,13H7v2h4.0867l-1,11H5v2h5.0867a1.9906,1.9906,0,0,0,1.9919-1.8188L13.0952,15H18V13H13.2769l.6364-7Z\"/>\n  <rect id=\"_Transparent_Rectangle\" data-name=\" Transparent Rectangle\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z\"/></svg>",
            "info": {},
            "path": "32/function-math.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "FunctionMath32",
          "filepath": "function-math/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
                }
              }
            ],
            "name": "function-math",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "FunctionMath24",
          "filepath": "function-math/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
                }
              }
            ],
            "name": "function-math",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "FunctionMath20",
          "filepath": "function-math/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
                }
              }
            ],
            "name": "function-math",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "FunctionMath16",
          "filepath": "function-math/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
                }
              }
            ],
            "name": "function-math",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "FunctionMath",
        "global": "FunctionMath",
        "filepath": "FunctionMath.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "fusion-blender",
      "friendlyName": "Fusion blender",
      "aliases": [
        "bar",
        "box",
        "plot",
        "fusion blender",
        "fushion",
        "blender"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/fusion-blender.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--fusion-blender</title><path d=\"M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/fusion-blender.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthFusionBlender32",
          "filepath": "watson-health/fusion-blender/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
                }
              }
            ],
            "name": "fusion-blender",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthFusionBlender24",
          "filepath": "watson-health/fusion-blender/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
                }
              }
            ],
            "name": "fusion-blender",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthFusionBlender20",
          "filepath": "watson-health/fusion-blender/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
                }
              }
            ],
            "name": "fusion-blender",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthFusionBlender16",
          "filepath": "watson-health/fusion-blender/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
                }
              }
            ],
            "name": "fusion-blender",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "FusionBlender",
        "global": "WatsonHealthFusionBlender",
        "filepath": "watson-health/FusionBlender.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "game--console",
      "friendlyName": "Game console",
      "aliases": [
        "play",
        "match",
        "activity",
        "ballgame",
        "energy",
        "spirit",
        "game console",
        "game",
        "console"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/game--console.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>game--console</title><path d=\"M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z\" transform=\"translate(0)\"/><path d=\"M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z\" transform=\"translate(0)\"/><circle cx=\"22\" cy=\"12\" r=\"1\"/><circle cx=\"22\" cy=\"16\" r=\"1\"/><circle cx=\"20\" cy=\"14\" r=\"1\"/><circle cx=\"24\" cy=\"14\" r=\"1\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z\"/><path d=\"M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z\"/><circle cx=\"22\" cy=\"12\" r=\"1\"/><circle cx=\"22\" cy=\"16\" r=\"1\"/><circle cx=\"20\" cy=\"14\" r=\"1\"/><circle cx=\"24\" cy=\"14\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/game--console.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GameConsole32",
          "filepath": "game--console/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "14",
                  "r": "1"
                }
              }
            ],
            "name": "game--console",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GameConsole24",
          "filepath": "game--console/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "14",
                  "r": "1"
                }
              }
            ],
            "name": "game--console",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GameConsole20",
          "filepath": "game--console/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "14",
                  "r": "1"
                }
              }
            ],
            "name": "game--console",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GameConsole16",
          "filepath": "game--console/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "14",
                  "r": "1"
                }
              }
            ],
            "name": "game--console",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "GameConsole",
        "global": "GameConsole",
        "filepath": "GameConsole.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "12",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "14",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "14",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "game--wireless",
      "friendlyName": "Game wireless",
      "aliases": [
        "play",
        "match",
        "activity",
        "ballgame",
        "energy",
        "spirit",
        "wireless game",
        "game wireless"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/game--wireless.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>game--wireless</title><path d=\"M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z\" transform=\"translate(0)\"/><path d=\"M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z\" transform=\"translate(0)\"/><circle cx=\"22\" cy=\"16\" r=\"1\"/><circle cx=\"22\" cy=\"20\" r=\"1\"/><circle cx=\"20\" cy=\"18\" r=\"1\"/><circle cx=\"24\" cy=\"18\" r=\"1\"/><path d=\"M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z\" transform=\"translate(0)\"/><path d=\"M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z\"/><path d=\"M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z\"/><circle cx=\"22\" cy=\"16\" r=\"1\"/><circle cx=\"22\" cy=\"20\" r=\"1\"/><circle cx=\"20\" cy=\"18\" r=\"1\"/><circle cx=\"24\" cy=\"18\" r=\"1\"/><path d=\"M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z\"/><path d=\"M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z\"/></svg>",
            "info": {},
            "path": "32/game--wireless.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GameWireless32",
          "filepath": "game--wireless/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
                }
              }
            ],
            "name": "game--wireless",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GameWireless24",
          "filepath": "game--wireless/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
                }
              }
            ],
            "name": "game--wireless",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GameWireless20",
          "filepath": "game--wireless/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
                }
              }
            ],
            "name": "game--wireless",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GameWireless16",
          "filepath": "game--wireless/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
                }
              }
            ],
            "name": "game--wireless",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "GameWireless",
        "global": "GameWireless",
        "filepath": "GameWireless.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "18",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "18",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gamification",
      "friendlyName": "Gamification",
      "aliases": [
        "gamification",
        "game design",
        "game principles"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gamification.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>gamification</title><path d=\"M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z\"/></svg>",
            "info": {},
            "path": "32/gamification.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Gamification32",
          "filepath": "gamification/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
                }
              }
            ],
            "name": "gamification",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Gamification24",
          "filepath": "gamification/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
                }
              }
            ],
            "name": "gamification",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Gamification20",
          "filepath": "gamification/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
                }
              }
            ],
            "name": "gamification",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Gamification16",
          "filepath": "gamification/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
                }
              }
            ],
            "name": "gamification",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Gamification",
        "global": "Gamification",
        "filepath": "Gamification.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gas-station",
      "friendlyName": "Gas station",
      "aliases": [
        "gas station",
        "gas",
        "fueling station",
        "fuel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gas-station.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #000000;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>gas-station</title>\n  <rect class=\"cls-1\" x=\"8\" y=\"10\" width=\"7\" height=\"2\"/>\n  <path class=\"cls-1\" d=\"M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 10H15V12H8z\"/><path d=\"M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z\"/></svg>",
            "info": {},
            "path": "32/gas-station.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GasStation32",
          "filepath": "gas-station/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H15V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "gas-station",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GasStation24",
          "filepath": "gas-station/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H15V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "gas-station",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GasStation20",
          "filepath": "gas-station/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H15V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "gas-station",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GasStation16",
          "filepath": "gas-station/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H15V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
                }
              }
            ],
            "name": "gas-station",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "GasStation",
        "global": "GasStation",
        "filepath": "GasStation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 10H15V12H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gas-station--filled",
      "friendlyName": "Gas station filled",
      "aliases": [
        "gas station filled",
        "gas",
        "fueling station",
        "fuel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gas-station--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect id=\"inner-path\" class=\"cls-1\" x=\"8\" y=\"10\" width=\"7\" height=\"2\"/>\n  <path d=\"M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M8 10H15V12H8z\" data-icon-path=\"inner-path\"/><path d=\"M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z\"/></svg>",
            "info": {},
            "path": "32/gas-station--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GasStationFilled32",
          "filepath": "gas-station--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H15V12H8z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
                }
              }
            ],
            "name": "gas-station--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GasStationFilled24",
          "filepath": "gas-station--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H15V12H8z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
                }
              }
            ],
            "name": "gas-station--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GasStationFilled20",
          "filepath": "gas-station--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H15V12H8z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
                }
              }
            ],
            "name": "gas-station--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GasStationFilled16",
          "filepath": "gas-station--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H15V12H8z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
                }
              }
            ],
            "name": "gas-station--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "GasStationFilled",
        "global": "GasStationFilled",
        "filepath": "GasStationFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M8 10H15V12H8z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gateway",
      "friendlyName": "Gateway",
      "aliases": [
        "gateway",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gateway.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z\"/></svg>",
            "info": {},
            "path": "32/gateway.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Gateway32",
          "filepath": "gateway/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z"
                }
              }
            ],
            "name": "gateway",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Gateway24",
          "filepath": "gateway/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z"
                }
              }
            ],
            "name": "gateway",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Gateway20",
          "filepath": "gateway/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z"
                }
              }
            ],
            "name": "gateway",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Gateway16",
          "filepath": "gateway/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z"
                }
              }
            ],
            "name": "gateway",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Gateway",
        "global": "Gateway",
        "filepath": "Gateway.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gateway--api",
      "friendlyName": "Gateway api",
      "aliases": [
        "gateway",
        "systems",
        "api",
        "application programming interface",
        "interface",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gateway--api.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/gateway--api.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GatewayApi32",
          "filepath": "gateway--api/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--api",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GatewayApi24",
          "filepath": "gateway--api/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--api",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GatewayApi20",
          "filepath": "gateway--api/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--api",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GatewayApi16",
          "filepath": "gateway--api/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--api",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GatewayApi",
        "global": "GatewayApi",
        "filepath": "GatewayApi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gateway--mail",
      "friendlyName": "Gateway mail",
      "aliases": [
        "gateway",
        "systems",
        "mail",
        "send",
        "message"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gateway--mail.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/gateway--mail.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GatewayMail32",
          "filepath": "gateway--mail/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--mail",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GatewayMail24",
          "filepath": "gateway--mail/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--mail",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GatewayMail20",
          "filepath": "gateway--mail/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--mail",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GatewayMail16",
          "filepath": "gateway--mail/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--mail",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GatewayMail",
        "global": "GatewayMail",
        "filepath": "GatewayMail.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gateway--public",
      "friendlyName": "Gateway public",
      "aliases": [
        "gateway",
        "systems",
        "public",
        "open",
        "unlock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gateway--public.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/gateway--public.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GatewayPublic32",
          "filepath": "gateway--public/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--public",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GatewayPublic24",
          "filepath": "gateway--public/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--public",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GatewayPublic20",
          "filepath": "gateway--public/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--public",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GatewayPublic16",
          "filepath": "gateway--public/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--public",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GatewayPublic",
        "global": "GatewayPublic",
        "filepath": "GatewayPublic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gateway--security",
      "friendlyName": "Gateway security",
      "aliases": [
        "gateway",
        "systems",
        "security",
        "shield",
        "protect"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gateway--security.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/gateway--security.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GatewaySecurity32",
          "filepath": "gateway--security/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--security",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GatewaySecurity24",
          "filepath": "gateway--security/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--security",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GatewaySecurity20",
          "filepath": "gateway--security/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--security",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GatewaySecurity16",
          "filepath": "gateway--security/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--security",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GatewaySecurity",
        "global": "GatewaySecurity",
        "filepath": "GatewaySecurity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gateway--user-access",
      "friendlyName": "Gateway user access",
      "aliases": [
        "gateway",
        "systems",
        "user",
        "access",
        "ID",
        "identity"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gateway--user-access.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,22H19V20a1.0011,1.0011,0,0,0-1-1H14a1.0011,1.0011,0,0,0-1,1v2H11V20a3.0033,3.0033,0,0,1,3-3h4a3.0033,3.0033,0,0,1,3,3Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,16a3.5,3.5,0,1,1,3.5-3.5A3.5041,3.5041,0,0,1,16,16Zm0-5a1.5,1.5,0,1,0,1.5,1.5A1.5017,1.5017,0,0,0,16,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 22H19V20a1.0011 1.0011 0 00-1-1H14a1.0011 1.0011 0 00-1 1v2H11V20a3.0033 3.0033 0 013-3h4a3.0033 3.0033 0 013 3zM16 16a3.5 3.5 0 113.5-3.5A3.5041 3.5041 0 0116 16zm0-5a1.5 1.5 0 101.5 1.5A1.5017 1.5017 0 0016 11z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/gateway--user-access.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GatewayUserAccess32",
          "filepath": "gateway--user-access/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V20a1.0011 1.0011 0 00-1-1H14a1.0011 1.0011 0 00-1 1v2H11V20a3.0033 3.0033 0 013-3h4a3.0033 3.0033 0 013 3zM16 16a3.5 3.5 0 113.5-3.5A3.5041 3.5041 0 0116 16zm0-5a1.5 1.5 0 101.5 1.5A1.5017 1.5017 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--user-access",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GatewayUserAccess24",
          "filepath": "gateway--user-access/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V20a1.0011 1.0011 0 00-1-1H14a1.0011 1.0011 0 00-1 1v2H11V20a3.0033 3.0033 0 013-3h4a3.0033 3.0033 0 013 3zM16 16a3.5 3.5 0 113.5-3.5A3.5041 3.5041 0 0116 16zm0-5a1.5 1.5 0 101.5 1.5A1.5017 1.5017 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--user-access",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GatewayUserAccess20",
          "filepath": "gateway--user-access/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V20a1.0011 1.0011 0 00-1-1H14a1.0011 1.0011 0 00-1 1v2H11V20a3.0033 3.0033 0 013-3h4a3.0033 3.0033 0 013 3zM16 16a3.5 3.5 0 113.5-3.5A3.5041 3.5041 0 0116 16zm0-5a1.5 1.5 0 101.5 1.5A1.5017 1.5017 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--user-access",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GatewayUserAccess16",
          "filepath": "gateway--user-access/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V20a1.0011 1.0011 0 00-1-1H14a1.0011 1.0011 0 00-1 1v2H11V20a3.0033 3.0033 0 013-3h4a3.0033 3.0033 0 013 3zM16 16a3.5 3.5 0 113.5-3.5A3.5041 3.5041 0 0116 16zm0-5a1.5 1.5 0 101.5 1.5A1.5017 1.5017 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--user-access",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GatewayUserAccess",
        "global": "GatewayUserAccess",
        "filepath": "GatewayUserAccess.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 22H19V20a1.0011 1.0011 0 00-1-1H14a1.0011 1.0011 0 00-1 1v2H11V20a3.0033 3.0033 0 013-3h4a3.0033 3.0033 0 013 3zM16 16a3.5 3.5 0 113.5-3.5A3.5041 3.5041 0 0116 16zm0-5a1.5 1.5 0 101.5 1.5A1.5017 1.5017 0 0016 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gateway--vpn",
      "friendlyName": "Gateway VPN",
      "aliases": [
        "gateway",
        "systems",
        "VPN",
        "virtual",
        "private",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gateway--vpn.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/gateway--vpn.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GatewayVpn32",
          "filepath": "gateway--vpn/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--vpn",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GatewayVpn24",
          "filepath": "gateway--vpn/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--vpn",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GatewayVpn20",
          "filepath": "gateway--vpn/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--vpn",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GatewayVpn16",
          "filepath": "gateway--vpn/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "gateway--vpn",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GatewayVpn",
        "global": "GatewayVpn",
        "filepath": "GatewayVpn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gender--female",
      "friendlyName": "Gender female",
      "aliases": [
        "gender female",
        "gender",
        "female",
        "person",
        "people",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gender--female.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z\"/></svg>",
            "info": {},
            "path": "32/gender--female.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GenderFemale32",
          "filepath": "gender--female/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
                }
              }
            ],
            "name": "gender--female",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GenderFemale24",
          "filepath": "gender--female/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
                }
              }
            ],
            "name": "gender--female",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GenderFemale20",
          "filepath": "gender--female/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
                }
              }
            ],
            "name": "gender--female",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GenderFemale16",
          "filepath": "gender--female/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
                }
              }
            ],
            "name": "gender--female",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "GenderFemale",
        "global": "GenderFemale",
        "filepath": "GenderFemale.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gender--male",
      "friendlyName": "Gender male",
      "aliases": [
        "gender male",
        "gender",
        "male",
        "person",
        "people",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gender--male.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z\"/></svg>",
            "info": {},
            "path": "32/gender--male.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GenderMale32",
          "filepath": "gender--male/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
                }
              }
            ],
            "name": "gender--male",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GenderMale24",
          "filepath": "gender--male/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
                }
              }
            ],
            "name": "gender--male",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GenderMale20",
          "filepath": "gender--male/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
                }
              }
            ],
            "name": "gender--male",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GenderMale16",
          "filepath": "gender--male/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
                }
              }
            ],
            "name": "gender--male",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "GenderMale",
        "global": "GenderMale",
        "filepath": "GenderMale.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "generate-pdf",
      "friendlyName": "Generate pdf",
      "aliases": [
        "generate pdf",
        "create pdf",
        "export pdf"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/generate-pdf.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>generate-pdf</title>\n  <path d=\"M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z\"/>\n  <polygon points=\"21 21 19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21\"/>\n  <polygon points=\"28 4 28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4\"/>\n  <path d=\"M17,12H13V2h4a3.0033,3.0033,0,0,1,3,3V9A3.0033,3.0033,0,0,1,17,12Zm-2-2h2a1.0011,1.0011,0,0,0,1-1V5a1.0011,1.0011,0,0,0-1-1H15Z\"/>\n  <path d=\"M9,2H4V12H6V9H9a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,9,2ZM6,7V4H9l.001,3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z\"/><path d=\"M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z\"/></svg>",
            "info": {},
            "path": "32/generate-pdf.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GeneratePdf32",
          "filepath": "generate-pdf/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
                }
              }
            ],
            "name": "generate-pdf",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GeneratePdf24",
          "filepath": "generate-pdf/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
                }
              }
            ],
            "name": "generate-pdf",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GeneratePdf20",
          "filepath": "generate-pdf/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
                }
              }
            ],
            "name": "generate-pdf",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GeneratePdf16",
          "filepath": "generate-pdf/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
                }
              }
            ],
            "name": "generate-pdf",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "GeneratePdf",
        "global": "GeneratePdf",
        "filepath": "GeneratePdf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "GIF",
      "friendlyName": "GIF",
      "aliases": [
        "file",
        "file type",
        "move",
        "GIF"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/GIF.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>GIF</title><path d=\"M2,12v8a3,3,0,0,0,3,3h5V15H6v2H8v4H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h5V9H5A3,3,0,0,0,2,12Z\"/><polygon points=\"30 11 30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11\"/><polygon points=\"12 9 12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z\"/></svg>",
            "info": {},
            "path": "32/GIF.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Gif32",
          "filepath": "GIF/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
                }
              }
            ],
            "name": "GIF",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Gif24",
          "filepath": "GIF/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
                }
              }
            ],
            "name": "GIF",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Gif20",
          "filepath": "GIF/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
                }
              }
            ],
            "name": "GIF",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Gif16",
          "filepath": "GIF/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
                }
              }
            ],
            "name": "GIF",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Gif",
        "global": "Gif",
        "filepath": "Gif.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gift",
      "friendlyName": "Gift",
      "aliases": [
        "gift",
        "present",
        "box",
        "wrapped box"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gift.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>gift</title><path d=\"M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z\"/></svg>",
            "info": {},
            "path": "32/gift.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Gift32",
          "filepath": "gift/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
                }
              }
            ],
            "name": "gift",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Gift24",
          "filepath": "gift/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
                }
              }
            ],
            "name": "gift",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Gift20",
          "filepath": "gift/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
                }
              }
            ],
            "name": "gift",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Gift16",
          "filepath": "gift/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
                }
              }
            ],
            "name": "gift",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Gift",
        "global": "Gift",
        "filepath": "Gift.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "globe",
      "friendlyName": "Globe",
      "aliases": [
        "planet",
        "earth",
        "world",
        "map",
        "orb",
        "globe"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/globe.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>globe</title>\n  <path d=\"M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z\"/>\n  <path d=\"M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z\"/><path d=\"M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z\"/></svg>",
            "info": {},
            "path": "32/globe.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Globe32",
          "filepath": "globe/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
                }
              }
            ],
            "name": "globe",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Globe24",
          "filepath": "globe/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
                }
              }
            ],
            "name": "globe",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Globe20",
          "filepath": "globe/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
                }
              }
            ],
            "name": "globe",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Globe16",
          "filepath": "globe/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
                }
              }
            ],
            "name": "globe",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Globe",
        "global": "Globe",
        "filepath": "Globe.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gradient",
      "friendlyName": "Gradient",
      "aliases": [
        "gradient",
        "fade",
        "blend"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gradient.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z\"/>\n  <rect x=\"14\" y=\"10\" width=\"4\" height=\"4\"/>\n  <rect x=\"14\" y=\"18\" width=\"4\" height=\"4\"/>\n  <rect x=\"18\" y=\"14\" width=\"4\" height=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z\"/><path d=\"M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z\"/></svg>",
            "info": {},
            "path": "32/gradient.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Gradient32",
          "filepath": "gradient/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
                }
              }
            ],
            "name": "gradient",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Gradient24",
          "filepath": "gradient/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
                }
              }
            ],
            "name": "gradient",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Gradient20",
          "filepath": "gradient/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
                }
              }
            ],
            "name": "gradient",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Gradient16",
          "filepath": "gradient/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
                }
              }
            ],
            "name": "gradient",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Gradient",
        "global": "Gradient",
        "filepath": "Gradient.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "graphical-data-flow",
      "friendlyName": "Graphical data flow",
      "aliases": [
        "graphical data flow",
        "data flow",
        "graphics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/graphical-data-flow.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>graphical-data-flow</title>\n  <path d=\"M28,30H22a2.0023,2.0023,0,0,1-2-2V22a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,30Zm-6-8h-.0012L22,28h6V22Z\"/>\n  <path d=\"M18,26H12a3.0033,3.0033,0,0,1-3-3V19h2v4a1.001,1.001,0,0,0,1,1h6Z\"/>\n  <path d=\"M26,18H24V15a1.001,1.001,0,0,0-1-1H18V12h5a3.0033,3.0033,0,0,1,3,3Z\"/>\n  <path d=\"M15,18a.9986.9986,0,0,1-.4971-.1323L10,15.2886,5.4968,17.8677a1,1,0,0,1-1.4712-1.0938l1.0618-4.572L2.269,9.1824a1,1,0,0,1,.5662-1.6687l4.2-.7019L9.1006,2.5627a1,1,0,0,1,1.7881-.0214l2.2046,4.271,4.0764.7021a1,1,0,0,1,.5613,1.668l-2.8184,3.02,1.0613,4.5718A1,1,0,0,1,15,18Zm-5-5s.343.18.4971.2686l3.01,1.7241-.7837-3.3763,2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829,8.6144l-3.3809.565,2.2745,2.437-.7841,3.3763,3.0105-1.7241C9.657,13.18,10,13,10,13Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z\"/></svg>",
            "info": {},
            "path": "32/graphical-data-flow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GraphicalDataFlow32",
          "filepath": "graphical-data-flow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
                }
              }
            ],
            "name": "graphical-data-flow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GraphicalDataFlow24",
          "filepath": "graphical-data-flow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
                }
              }
            ],
            "name": "graphical-data-flow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GraphicalDataFlow20",
          "filepath": "graphical-data-flow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
                }
              }
            ],
            "name": "graphical-data-flow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GraphicalDataFlow16",
          "filepath": "graphical-data-flow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
                }
              }
            ],
            "name": "graphical-data-flow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "GraphicalDataFlow",
        "global": "GraphicalDataFlow",
        "filepath": "GraphicalDataFlow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "grid",
      "friendlyName": "Grid",
      "aliases": [
        "align",
        "boxes",
        "4 boxes",
        "2x grid",
        "pattern",
        "grid",
        "tile"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/grid.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>grid</title><path d=\"M12,4H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6A2,2,0,0,0,12,4Zm0,8H6V6h6Z\"/><path d=\"M26,4H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,8H20V6h6Z\"/><path d=\"M12,18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V20A2,2,0,0,0,12,18Zm0,8H6V20h6Z\"/><path d=\"M26,18H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V20A2,2,0,0,0,26,18Zm0,8H20V20h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z\"/></svg>",
            "info": {},
            "path": "32/grid.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Grid32",
          "filepath": "grid/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
                }
              }
            ],
            "name": "grid",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Grid24",
          "filepath": "grid/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
                }
              }
            ],
            "name": "grid",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Grid20",
          "filepath": "grid/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
                }
              }
            ],
            "name": "grid",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Grid16",
          "filepath": "grid/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
                }
              }
            ],
            "name": "grid",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Grid",
        "global": "Grid",
        "filepath": "Grid.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group",
      "friendlyName": "Group",
      "aliases": [
        "category",
        "band",
        "bucket",
        "club",
        "association",
        "bunch",
        "organization",
        "cluster",
        "group"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>group</title><path d=\"M31,30H29V27a3,3,0,0,0-3-3H22a3,3,0,0,0-3,3v3H17V27a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5Z\" transform=\"translate(0)\"/><path d=\"M24,12a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,24,10Z\" transform=\"translate(0)\"/><path d=\"M15,22H13V19a3,3,0,0,0-3-3H6a3,3,0,0,0-3,3v3H1V19a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5Z\" transform=\"translate(0)\"/><path d=\"M8,4A3,3,0,1,1,5,7,3,3,0,0,1,8,4M8,2a5,5,0,1,0,5,5A5,5,0,0,0,8,2Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z\"/></svg>",
            "info": {},
            "path": "32/group.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Group32",
          "filepath": "group/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "group",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Group24",
          "filepath": "group/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "group",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Group20",
          "filepath": "group/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "group",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Group16",
          "filepath": "group/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                }
              }
            ],
            "name": "group",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Group",
        "global": "Group",
        "filepath": "Group.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group--access",
      "friendlyName": "Group access",
      "aliases": [
        "group",
        "systems",
        "access",
        "open"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group--access.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,19H6V17a3.0033,3.0033,0,0,1,3-3h5v2H9a1.0011,1.0011,0,0,0-1,1Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M12,13a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,12,13Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,12,7Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,20,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,20,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,26H24V24a1.0011,1.0011,0,0,0-1-1H17a1.0011,1.0011,0,0,0-1,1v2H14V24a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H8V4H4V28H8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,30H24V28h4V4H24V2h4a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 19H6V17a3.0033 3.0033 0 013-3h5v2H9a1.0011 1.0011 0 00-1 1zM12 13a4 4 0 114-4A4.0045 4.0045 0 0112 13zm0-6a2 2 0 102 2A2.0021 2.0021 0 0012 7zM20 20a4 4 0 114-4A4.0045 4.0045 0 0120 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0020 14zM26 26H24V24a1.0011 1.0011 0 00-1-1H17a1.0011 1.0011 0 00-1 1v2H14V24a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z\"/><path d=\"M8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z\"/></svg>",
            "info": {},
            "path": "32/group--access.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupAccess32",
          "filepath": "group--access/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 19H6V17a3.0033 3.0033 0 013-3h5v2H9a1.0011 1.0011 0 00-1 1zM12 13a4 4 0 114-4A4.0045 4.0045 0 0112 13zm0-6a2 2 0 102 2A2.0021 2.0021 0 0012 7zM20 20a4 4 0 114-4A4.0045 4.0045 0 0120 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0020 14zM26 26H24V24a1.0011 1.0011 0 00-1-1H17a1.0011 1.0011 0 00-1 1v2H14V24a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--access",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupAccess24",
          "filepath": "group--access/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 19H6V17a3.0033 3.0033 0 013-3h5v2H9a1.0011 1.0011 0 00-1 1zM12 13a4 4 0 114-4A4.0045 4.0045 0 0112 13zm0-6a2 2 0 102 2A2.0021 2.0021 0 0012 7zM20 20a4 4 0 114-4A4.0045 4.0045 0 0120 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0020 14zM26 26H24V24a1.0011 1.0011 0 00-1-1H17a1.0011 1.0011 0 00-1 1v2H14V24a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--access",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupAccess20",
          "filepath": "group--access/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 19H6V17a3.0033 3.0033 0 013-3h5v2H9a1.0011 1.0011 0 00-1 1zM12 13a4 4 0 114-4A4.0045 4.0045 0 0112 13zm0-6a2 2 0 102 2A2.0021 2.0021 0 0012 7zM20 20a4 4 0 114-4A4.0045 4.0045 0 0120 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0020 14zM26 26H24V24a1.0011 1.0011 0 00-1-1H17a1.0011 1.0011 0 00-1 1v2H14V24a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--access",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupAccess16",
          "filepath": "group--access/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 19H6V17a3.0033 3.0033 0 013-3h5v2H9a1.0011 1.0011 0 00-1 1zM12 13a4 4 0 114-4A4.0045 4.0045 0 0112 13zm0-6a2 2 0 102 2A2.0021 2.0021 0 0012 7zM20 20a4 4 0 114-4A4.0045 4.0045 0 0120 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0020 14zM26 26H24V24a1.0011 1.0011 0 00-1-1H17a1.0011 1.0011 0 00-1 1v2H14V24a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--access",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GroupAccess",
        "global": "GroupAccess",
        "filepath": "GroupAccess.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 19H6V17a3.0033 3.0033 0 013-3h5v2H9a1.0011 1.0011 0 00-1 1zM12 13a4 4 0 114-4A4.0045 4.0045 0 0112 13zm0-6a2 2 0 102 2A2.0021 2.0021 0 0012 7zM20 20a4 4 0 114-4A4.0045 4.0045 0 0120 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0020 14zM26 26H24V24a1.0011 1.0011 0 00-1-1H17a1.0011 1.0011 0 00-1 1v2H14V24a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group--account",
      "friendlyName": "Group account",
      "aliases": [
        "group",
        "systems",
        "account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group--account.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,11H11a3,3,0,0,0-3,3v4h2V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v1h2V14A3,3,0,0,0,17,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10,6a4,4,0,1,0,4-4A4,4,0,0,0,10,6Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,16,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22,27H16a2.0021,2.0021,0,0,1-2-2V19a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,22,27Zm-6-8v6h6V19Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H8V4H4V28H8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,30H24V28h4V4H24V2h4a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 11H11a3 3 0 00-3 3v4h2V14a1 1 0 011-1h6a1 1 0 011 1v1h2V14A3 3 0 0017 11zM10 6a4 4 0 104-4A4 4 0 0010 6zm6 0a2 2 0 11-2-2A2 2 0 0116 6zM22 27H16a2.0021 2.0021 0 01-2-2V19a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0122 27zm-6-8v6h6V19zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z\"/></svg>",
            "info": {},
            "path": "32/group--account.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupAccount32",
          "filepath": "group--account/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11H11a3 3 0 00-3 3v4h2V14a1 1 0 011-1h6a1 1 0 011 1v1h2V14A3 3 0 0017 11zM10 6a4 4 0 104-4A4 4 0 0010 6zm6 0a2 2 0 11-2-2A2 2 0 0116 6zM22 27H16a2.0021 2.0021 0 01-2-2V19a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0122 27zm-6-8v6h6V19zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--account",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupAccount24",
          "filepath": "group--account/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11H11a3 3 0 00-3 3v4h2V14a1 1 0 011-1h6a1 1 0 011 1v1h2V14A3 3 0 0017 11zM10 6a4 4 0 104-4A4 4 0 0010 6zm6 0a2 2 0 11-2-2A2 2 0 0116 6zM22 27H16a2.0021 2.0021 0 01-2-2V19a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0122 27zm-6-8v6h6V19zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--account",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupAccount20",
          "filepath": "group--account/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11H11a3 3 0 00-3 3v4h2V14a1 1 0 011-1h6a1 1 0 011 1v1h2V14A3 3 0 0017 11zM10 6a4 4 0 104-4A4 4 0 0010 6zm6 0a2 2 0 11-2-2A2 2 0 0116 6zM22 27H16a2.0021 2.0021 0 01-2-2V19a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0122 27zm-6-8v6h6V19zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--account",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupAccount16",
          "filepath": "group--account/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11H11a3 3 0 00-3 3v4h2V14a1 1 0 011-1h6a1 1 0 011 1v1h2V14A3 3 0 0017 11zM10 6a4 4 0 104-4A4 4 0 0010 6zm6 0a2 2 0 11-2-2A2 2 0 0116 6zM22 27H16a2.0021 2.0021 0 01-2-2V19a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0122 27zm-6-8v6h6V19zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--account",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GroupAccount",
        "global": "GroupAccount",
        "filepath": "GroupAccount.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 11H11a3 3 0 00-3 3v4h2V14a1 1 0 011-1h6a1 1 0 011 1v1h2V14A3 3 0 0017 11zM10 6a4 4 0 104-4A4 4 0 0010 6zm6 0a2 2 0 11-2-2A2 2 0 0116 6zM22 27H16a2.0021 2.0021 0 01-2-2V19a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0122 27zm-6-8v6h6V19zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group--presentation",
      "friendlyName": "Group presentation",
      "aliases": [
        "group",
        "presentation",
        "meeting",
        "conference",
        "audience",
        "presenter",
        "users"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group--presentation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,30H8V27H4v3H2V27a2.0023,2.0023,0,0,1,2-2H8a2.0023,2.0023,0,0,1,2,2Z\"/>\n  <path d=\"M30,30H28V27H24v3H22V27a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z\"/>\n  <path d=\"M20,30H18V27H14v3H12V27a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z\"/>\n  <circle cx=\"16\" cy=\"22\" r=\"2\"/>\n  <circle cx=\"6\" cy=\"22\" r=\"2\"/>\n  <circle cx=\"26\" cy=\"22\" r=\"2\"/>\n  <circle cx=\"21\" cy=\"18\" r=\"2\"/>\n  <circle cx=\"11\" cy=\"18\" r=\"2\"/>\n  <path d=\"M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z\"/><circle cx=\"16\" cy=\"22\" r=\"2\"/><circle cx=\"6\" cy=\"22\" r=\"2\"/><circle cx=\"26\" cy=\"22\" r=\"2\"/><circle cx=\"21\" cy=\"18\" r=\"2\"/><circle cx=\"11\" cy=\"18\" r=\"2\"/><path d=\"M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z\"/></svg>",
            "info": {},
            "path": "32/group--presentation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupPresentation32",
          "filepath": "group--presentation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
                }
              }
            ],
            "name": "group--presentation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupPresentation24",
          "filepath": "group--presentation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
                }
              }
            ],
            "name": "group--presentation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupPresentation20",
          "filepath": "group--presentation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
                }
              }
            ],
            "name": "group--presentation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupPresentation16",
          "filepath": "group--presentation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "6",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "22",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "18",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
                }
              }
            ],
            "name": "group--presentation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "GroupPresentation",
        "global": "GroupPresentation",
        "filepath": "GroupPresentation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "22",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "6",
                    "cy": "22",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "22",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "18",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "18",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group--resource",
      "friendlyName": "Group resource",
      "aliases": [
        "group",
        "systems",
        "resource"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group--resource.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,24H10a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2H22a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,22,24ZM10,10V22H22V10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H8V4H4V28H8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,30H24V28h4V4H24V2h4a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 24H10a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2H22a2.0021 2.0021 0 012 2V22A2.0021 2.0021 0 0122 24zM10 10V22H22V10zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z\"/></svg>",
            "info": {},
            "path": "32/group--resource.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupResource32",
          "filepath": "group--resource/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2H22a2.0021 2.0021 0 012 2V22A2.0021 2.0021 0 0122 24zM10 10V22H22V10zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--resource",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupResource24",
          "filepath": "group--resource/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2H22a2.0021 2.0021 0 012 2V22A2.0021 2.0021 0 0122 24zM10 10V22H22V10zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--resource",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupResource20",
          "filepath": "group--resource/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2H22a2.0021 2.0021 0 012 2V22A2.0021 2.0021 0 0122 24zM10 10V22H22V10zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--resource",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupResource16",
          "filepath": "group--resource/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2H22a2.0021 2.0021 0 012 2V22A2.0021 2.0021 0 0122 24zM10 10V22H22V10zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              }
            ],
            "name": "group--resource",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GroupResource",
        "global": "GroupResource",
        "filepath": "GroupResource.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 24H10a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2H22a2.0021 2.0021 0 012 2V22A2.0021 2.0021 0 0122 24zM10 10V22H22V10zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group--security",
      "friendlyName": "Group security",
      "aliases": [
        "group",
        "systems",
        "security",
        "ID",
        "identity",
        "shield"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group--security.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M11,21H9V19a3.0033,3.0033,0,0,1,3-3h6v2H12a1.0011,1.0011,0,0,0-1,1Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M15,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,15,15Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,15,9Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,22Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,28H28V26a1.0011,1.0011,0,0,0-1-1H21a1.0011,1.0011,0,0,0-1,1v2H18V26a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 21H9V19a3.0033 3.0033 0 013-3h6v2H12a1.0011 1.0011 0 00-1 1zM15 15a4 4 0 114-4A4.0045 4.0045 0 0115 15zm0-6a2 2 0 102 2A2.0021 2.0021 0 0015 9zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 16zM30 28H28V26a1.0011 1.0011 0 00-1-1H21a1.0011 1.0011 0 00-1 1v2H18V26a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z\"/><path d=\"M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z\"/></svg>",
            "info": {},
            "path": "32/group--security.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupSecurity32",
          "filepath": "group--security/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H9V19a3.0033 3.0033 0 013-3h6v2H12a1.0011 1.0011 0 00-1 1zM15 15a4 4 0 114-4A4.0045 4.0045 0 0115 15zm0-6a2 2 0 102 2A2.0021 2.0021 0 0015 9zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 16zM30 28H28V26a1.0011 1.0011 0 00-1-1H21a1.0011 1.0011 0 00-1 1v2H18V26a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "group--security",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupSecurity24",
          "filepath": "group--security/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H9V19a3.0033 3.0033 0 013-3h6v2H12a1.0011 1.0011 0 00-1 1zM15 15a4 4 0 114-4A4.0045 4.0045 0 0115 15zm0-6a2 2 0 102 2A2.0021 2.0021 0 0015 9zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 16zM30 28H28V26a1.0011 1.0011 0 00-1-1H21a1.0011 1.0011 0 00-1 1v2H18V26a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "group--security",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupSecurity20",
          "filepath": "group--security/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H9V19a3.0033 3.0033 0 013-3h6v2H12a1.0011 1.0011 0 00-1 1zM15 15a4 4 0 114-4A4.0045 4.0045 0 0115 15zm0-6a2 2 0 102 2A2.0021 2.0021 0 0015 9zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 16zM30 28H28V26a1.0011 1.0011 0 00-1-1H21a1.0011 1.0011 0 00-1 1v2H18V26a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "group--security",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupSecurity16",
          "filepath": "group--security/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H9V19a3.0033 3.0033 0 013-3h6v2H12a1.0011 1.0011 0 00-1 1zM15 15a4 4 0 114-4A4.0045 4.0045 0 0115 15zm0-6a2 2 0 102 2A2.0021 2.0021 0 0015 9zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 16zM30 28H28V26a1.0011 1.0011 0 00-1-1H21a1.0011 1.0011 0 00-1 1v2H18V26a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "group--security",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GroupSecurity",
        "global": "GroupSecurity",
        "filepath": "GroupSecurity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 21H9V19a3.0033 3.0033 0 013-3h6v2H12a1.0011 1.0011 0 00-1 1zM15 15a4 4 0 114-4A4.0045 4.0045 0 0115 15zm0-6a2 2 0 102 2A2.0021 2.0021 0 0015 9zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 16zM30 28H28V26a1.0011 1.0011 0 00-1-1H21a1.0011 1.0011 0 00-1 1v2H18V26a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group-objects",
      "friendlyName": "Group objects",
      "aliases": [
        "formatting",
        "group",
        "objects"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group-objects.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z\"/>\n  <path d=\"M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z\"/><path d=\"M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z\"/></svg>",
            "info": {},
            "path": "32/group-objects.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupObjects32",
          "filepath": "group-objects/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupObjects24",
          "filepath": "group-objects/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupObjects20",
          "filepath": "group-objects/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupObjects16",
          "filepath": "group-objects/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "GroupObjects",
        "global": "GroupObjects",
        "filepath": "GroupObjects.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group-objects--new",
      "friendlyName": "Group objects new",
      "aliases": [
        "formatting",
        "group",
        "objects",
        "new"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group-objects--new.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17 10 15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10\"/>\n  <path d=\"M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z\"/><path d=\"M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z\"/></svg>",
            "info": {},
            "path": "32/group-objects--new.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupObjectsNew32",
          "filepath": "group-objects--new/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--new",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupObjectsNew24",
          "filepath": "group-objects--new/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--new",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupObjectsNew20",
          "filepath": "group-objects--new/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--new",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupObjectsNew16",
          "filepath": "group-objects--new/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--new",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "GroupObjectsNew",
        "global": "GroupObjectsNew",
        "filepath": "GroupObjectsNew.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "group-objects--save",
      "friendlyName": "Group objects save",
      "aliases": [
        "formatting",
        "group",
        "objects",
        "save"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/group-objects--save.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 18.18 10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18\"/>\n  <path d=\"M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z\"/><path d=\"M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z\"/></svg>",
            "info": {},
            "path": "32/group-objects--save.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GroupObjectsSave32",
          "filepath": "group-objects--save/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--save",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GroupObjectsSave24",
          "filepath": "group-objects--save/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--save",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GroupObjectsSave20",
          "filepath": "group-objects--save/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--save",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GroupObjectsSave16",
          "filepath": "group-objects--save/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                }
              }
            ],
            "name": "group-objects--save",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "GroupObjectsSave",
        "global": "GroupObjectsSave",
        "filepath": "GroupObjectsSave.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "growth",
      "friendlyName": "Growth",
      "aliases": [
        "growth",
        "chart",
        "data",
        "uptick",
        "rising",
        "improving"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/growth.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z\"/></svg>",
            "info": {},
            "path": "32/growth.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Growth32",
          "filepath": "growth/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
                }
              }
            ],
            "name": "growth",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Growth24",
          "filepath": "growth/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
                }
              }
            ],
            "name": "growth",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Growth20",
          "filepath": "growth/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
                }
              }
            ],
            "name": "growth",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Growth16",
          "filepath": "growth/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
                }
              }
            ],
            "name": "growth",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Growth",
        "global": "Growth",
        "filepath": "Growth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gui",
      "friendlyName": "GUI",
      "aliases": [
        "graphical user interface",
        "interface",
        "GUI",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gui.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"20\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"23\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"26\" cy=\"8\" r=\"1\"/>\n  <path d=\"M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"20\" cy=\"8\" r=\"1\"/><circle cx=\"23\" cy=\"8\" r=\"1\"/><circle cx=\"26\" cy=\"8\" r=\"1\"/><path d=\"M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z\"/></svg>",
            "info": {},
            "path": "32/gui.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Gui32",
          "filepath": "gui/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z"
                }
              }
            ],
            "name": "gui",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Gui24",
          "filepath": "gui/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z"
                }
              }
            ],
            "name": "gui",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Gui20",
          "filepath": "gui/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z"
                }
              }
            ],
            "name": "gui",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Gui16",
          "filepath": "gui/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z"
                }
              }
            ],
            "name": "gui",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Gui",
        "global": "Gui",
        "filepath": "Gui.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "gui--management",
      "friendlyName": "GUI management",
      "aliases": [
        "graphical user interface",
        "interface",
        "GUI",
        "systems",
        "settings",
        "preferences",
        "gear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/gui--management.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"20\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"23\" cy=\"8\" r=\"1\"/>\n  <circle cx=\"26\" cy=\"8\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z\"/><path d=\"M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z\"/><circle cx=\"20\" cy=\"8\" r=\"1\"/><circle cx=\"23\" cy=\"8\" r=\"1\"/><circle cx=\"26\" cy=\"8\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/gui--management.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "GuiManagement32",
          "filepath": "gui--management/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              }
            ],
            "name": "gui--management",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "GuiManagement24",
          "filepath": "gui--management/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              }
            ],
            "name": "gui--management",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "GuiManagement20",
          "filepath": "gui--management/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              }
            ],
            "name": "gui--management",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "GuiManagement16",
          "filepath": "gui--management/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "1"
                }
              }
            ],
            "name": "gui--management",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "GuiManagement",
        "global": "GuiManagement",
        "filepath": "GuiManagement.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "H",
      "friendlyName": "H",
      "aliases": [
        "letter",
        "alphabet",
        "h"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/H.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--H</title><polygon points=\"18 9 18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z\"/></svg>",
            "info": {},
            "path": "32/Q/H.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QH32",
          "filepath": "Q/H/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              }
            ],
            "name": "H",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QH24",
          "filepath": "Q/H/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              }
            ],
            "name": "H",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QH20",
          "filepath": "Q/H/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              }
            ],
            "name": "H",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QH16",
          "filepath": "Q/H/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              }
            ],
            "name": "H",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "H",
        "global": "QH",
        "filepath": "Q/H.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hail",
      "friendlyName": "Hail",
      "aliases": [
        "hail",
        "ice",
        "ice ball",
        "hail stone",
        "weather",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hail.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hail</title><circle cx=\"21.4995\" cy=\"29.5\" r=\"1.5\"/><circle cx=\"24.4995\" cy=\"25.5\" r=\"1.5\"/><circle cx=\"7.5\" cy=\"25.5\" r=\"1.5\"/><circle cx=\"4.4995\" cy=\"29.5\" r=\"1.5\"/><circle cx=\"10.4995\" cy=\"29.5\" r=\"1.5\"/><polygon points=\"15.868 30.496 14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496\"/><path d=\"M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"21.5\" cy=\"29.5\" r=\"1.5\"/><circle cx=\"24.5\" cy=\"25.5\" r=\"1.5\"/><circle cx=\"7.5\" cy=\"25.5\" r=\"1.5\"/><circle cx=\"4.5\" cy=\"29.5\" r=\"1.5\"/><circle cx=\"10.499\" cy=\"29.5\" r=\"1.5\"/><path d=\"M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z\"/><path d=\"M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z\"/></svg>",
            "info": {},
            "path": "32/hail.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hail32",
          "filepath": "hail/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.499",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "hail",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hail24",
          "filepath": "hail/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.499",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "hail",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hail20",
          "filepath": "hail/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.499",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "hail",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hail16",
          "filepath": "hail/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.499",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                }
              }
            ],
            "name": "hail",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Hail",
        "global": "Hail",
        "filepath": "Hail.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21.5",
                    "cy": "29.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24.5",
                    "cy": "25.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7.5",
                    "cy": "25.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4.5",
                    "cy": "29.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10.499",
                    "cy": "29.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hanging-protocol",
      "friendlyName": "Hanging protocol",
      "aliases": [
        "hanger",
        "clothes",
        "suspended",
        "swing",
        "hanging protocol"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/hanging-protocol.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>watson-health--hanging-protocol</title><path class=\"cls-1\" d=\"M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/hanging-protocol.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthHangingProtocol32",
          "filepath": "watson-health/hanging-protocol/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
                }
              }
            ],
            "name": "hanging-protocol",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthHangingProtocol24",
          "filepath": "watson-health/hanging-protocol/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
                }
              }
            ],
            "name": "hanging-protocol",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthHangingProtocol20",
          "filepath": "watson-health/hanging-protocol/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
                }
              }
            ],
            "name": "hanging-protocol",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthHangingProtocol16",
          "filepath": "watson-health/hanging-protocol/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
                }
              }
            ],
            "name": "hanging-protocol",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "HangingProtocol",
        "global": "WatsonHealthHangingProtocol",
        "filepath": "watson-health/HangingProtocol.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "harbor",
      "friendlyName": "Harbor",
      "aliases": [
        "harbor",
        "anchor",
        "port"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/harbor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z\"/></svg>",
            "info": {},
            "path": "32/harbor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Harbor32",
          "filepath": "harbor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
                }
              }
            ],
            "name": "harbor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Harbor24",
          "filepath": "harbor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
                }
              }
            ],
            "name": "harbor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Harbor20",
          "filepath": "harbor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
                }
              }
            ],
            "name": "harbor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Harbor16",
          "filepath": "harbor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
                }
              }
            ],
            "name": "harbor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Harbor",
        "global": "Harbor",
        "filepath": "Harbor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hardware-security-module",
      "friendlyName": "Hardware security module",
      "aliases": [
        "hardware",
        "secure",
        "key",
        "software",
        "interface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hardware-security-module.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"21.5\" cy=\"7.5\" r=\"1.5\"/>\n  <path d=\"M14.4143,20H9V14.5857l6.03-6.03A5.3518,5.3518,0,0,1,15,8a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM11,18h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,21,12a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L11,15.4143Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,20H19v2h9v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"21.5\" cy=\"7.5\" r=\"1.5\"/><path d=\"M14.4143 20H9V14.5857l6.03-6.03A5.3518 5.3518 0 0115 8a6 6 0 116 6 5.3583 5.3583 0 01-.5559-.03zM11 18h2.5857l6.1706-6.1709.5174.0957A3.935 3.935 0 0021 12a4.0507 4.0507 0 10-3.925-3.2729l.0952.5166L11 15.4143zM28 20H19v2h9v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/hardware-security-module.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HardwareSecurityModule32",
          "filepath": "hardware-security-module/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4143 20H9V14.5857l6.03-6.03A5.3518 5.3518 0 0115 8a6 6 0 116 6 5.3583 5.3583 0 01-.5559-.03zM11 18h2.5857l6.1706-6.1709.5174.0957A3.935 3.935 0 0021 12a4.0507 4.0507 0 10-3.925-3.2729l.0952.5166L11 15.4143zM28 20H19v2h9v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "hardware-security-module",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HardwareSecurityModule24",
          "filepath": "hardware-security-module/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4143 20H9V14.5857l6.03-6.03A5.3518 5.3518 0 0115 8a6 6 0 116 6 5.3583 5.3583 0 01-.5559-.03zM11 18h2.5857l6.1706-6.1709.5174.0957A3.935 3.935 0 0021 12a4.0507 4.0507 0 10-3.925-3.2729l.0952.5166L11 15.4143zM28 20H19v2h9v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "hardware-security-module",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HardwareSecurityModule20",
          "filepath": "hardware-security-module/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4143 20H9V14.5857l6.03-6.03A5.3518 5.3518 0 0115 8a6 6 0 116 6 5.3583 5.3583 0 01-.5559-.03zM11 18h2.5857l6.1706-6.1709.5174.0957A3.935 3.935 0 0021 12a4.0507 4.0507 0 10-3.925-3.2729l.0952.5166L11 15.4143zM28 20H19v2h9v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "hardware-security-module",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HardwareSecurityModule16",
          "filepath": "hardware-security-module/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "7.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4143 20H9V14.5857l6.03-6.03A5.3518 5.3518 0 0115 8a6 6 0 116 6 5.3583 5.3583 0 01-.5559-.03zM11 18h2.5857l6.1706-6.1709.5174.0957A3.935 3.935 0 0021 12a4.0507 4.0507 0 10-3.925-3.2729l.0952.5166L11 15.4143zM28 20H19v2h9v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "hardware-security-module",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "HardwareSecurityModule",
        "global": "HardwareSecurityModule",
        "filepath": "HardwareSecurityModule.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21.5",
                    "cy": "7.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.4143 20H9V14.5857l6.03-6.03A5.3518 5.3518 0 0115 8a6 6 0 116 6 5.3583 5.3583 0 01-.5559-.03zM11 18h2.5857l6.1706-6.1709.5174.0957A3.935 3.935 0 0021 12a4.0507 4.0507 0 10-3.925-3.2729l.0952.5166L11 15.4143zM28 20H19v2h9v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hashtag",
      "friendlyName": "Hashtag",
      "aliases": [
        "hashtag",
        "number symbol",
        "crossed lines"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hashtag.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>hashtag</title>\n  <path d=\"M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z\"/></svg>",
            "info": {},
            "path": "32/hashtag.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hashtag32",
          "filepath": "hashtag/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
                }
              }
            ],
            "name": "hashtag",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hashtag24",
          "filepath": "hashtag/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
                }
              }
            ],
            "name": "hashtag",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hashtag20",
          "filepath": "hashtag/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
                }
              }
            ],
            "name": "hashtag",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hashtag16",
          "filepath": "hashtag/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
                }
              }
            ],
            "name": "hashtag",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Hashtag",
        "global": "Hashtag",
        "filepath": "Hashtag.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "haze",
      "friendlyName": "Haze",
      "aliases": [
        "haze",
        "fog",
        "weather",
        "overcast",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/haze.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>haze</title><path d=\"M19,28H3a1,1,0,0,1,0-2H19a1,1,0,0,1,0,2Z\"/><path d=\"M15,20H3a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z\"/><rect x=\"24.5\" y=\"23.5\" width=\"4\" height=\"2\" transform=\"translate(25.0858 -11.5624) rotate(45)\"/><rect x=\"28\" y=\"15\" width=\"4\" height=\"2\"/><rect x=\"24.5\" y=\"6.5\" width=\"4\" height=\"2\" transform=\"translate(2.4584 20.935) rotate(-45)\"/><rect x=\"17\" y=\"2\" width=\"2\" height=\"4\"/><rect x=\"7.5\" y=\"6.5\" width=\"4\" height=\"2\" transform=\"translate(10.9142 19.5208) rotate(-135)\"/><path d=\"M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z\"/><path d=\"M24.5 23.5H28.5V25.5H24.5z\" transform=\"rotate(45 26.5 24.5)\"/><path d=\"M28 15H32V17H28z\"/><path d=\"M24.5 6.5H28.5V8.5H24.5z\" transform=\"rotate(-45 26.5 7.5)\"/><path d=\"M17 2H19V6H17z\"/><path d=\"M7.5 6.5H11.5V8.5H7.5z\" transform=\"rotate(-135 9.5 7.5)\"/><path d=\"M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z\"/></svg>",
            "info": {},
            "path": "32/haze.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Haze32",
          "filepath": "haze/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 23.5H28.5V25.5H24.5z",
                  "transform": "rotate(45 26.5 24.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 15H32V17H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 6.5H28.5V8.5H24.5z",
                  "transform": "rotate(-45 26.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 6.5H11.5V8.5H7.5z",
                  "transform": "rotate(-135 9.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
                }
              }
            ],
            "name": "haze",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Haze24",
          "filepath": "haze/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 23.5H28.5V25.5H24.5z",
                  "transform": "rotate(45 26.5 24.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 15H32V17H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 6.5H28.5V8.5H24.5z",
                  "transform": "rotate(-45 26.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 6.5H11.5V8.5H7.5z",
                  "transform": "rotate(-135 9.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
                }
              }
            ],
            "name": "haze",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Haze20",
          "filepath": "haze/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 23.5H28.5V25.5H24.5z",
                  "transform": "rotate(45 26.5 24.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 15H32V17H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 6.5H28.5V8.5H24.5z",
                  "transform": "rotate(-45 26.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 6.5H11.5V8.5H7.5z",
                  "transform": "rotate(-135 9.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
                }
              }
            ],
            "name": "haze",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Haze16",
          "filepath": "haze/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 23.5H28.5V25.5H24.5z",
                  "transform": "rotate(45 26.5 24.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 15H32V17H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 6.5H28.5V8.5H24.5z",
                  "transform": "rotate(-45 26.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 6.5H11.5V8.5H7.5z",
                  "transform": "rotate(-135 9.5 7.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
                }
              }
            ],
            "name": "haze",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Haze",
        "global": "Haze",
        "filepath": "Haze.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5 23.5H28.5V25.5H24.5z",
                    "transform": "rotate(45 26.5 24.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 15H32V17H28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5 6.5H28.5V8.5H24.5z",
                    "transform": "rotate(-45 26.5 7.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 2H19V6H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 6.5H11.5V8.5H7.5z",
                    "transform": "rotate(-135 9.5 7.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "haze--night",
      "friendlyName": "Haze night",
      "aliases": [
        "haze night",
        "fog",
        "weather",
        "overcast",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/haze--night.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>haze--night</title><path d=\"M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z\"/><path d=\"M27,20H17a1,1,0,0,1,0-2H27a1,1,0,0,1,0,2Z\"/><path d=\"M25,16H13a1,1,0,0,1,0-2H25a1,1,0,0,1,0,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z\"/><path d=\"M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z\"/></svg>",
            "info": {},
            "path": "32/haze--night.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HazeNight32",
          "filepath": "haze--night/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
                }
              }
            ],
            "name": "haze--night",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HazeNight24",
          "filepath": "haze--night/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
                }
              }
            ],
            "name": "haze--night",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HazeNight20",
          "filepath": "haze--night/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
                }
              }
            ],
            "name": "haze--night",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HazeNight16",
          "filepath": "haze--night/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
                }
              }
            ],
            "name": "haze--night",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "HazeNight",
        "global": "HazeNight",
        "filepath": "HazeNight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "HD",
      "friendlyName": "HD",
      "aliases": [
        "high",
        "def",
        "definition",
        "high quality",
        "4K",
        "HD",
        "high definition"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/HD.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>HD</title><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z\"/><path d=\"M22,11H18V21h4a3,3,0,0,0,3-3V14A3,3,0,0,0,22,11Zm1,7a1,1,0,0,1-1,1H20V13h2a1,1,0,0,1,1,1Z\"/><polygon points=\"13 11 13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z\"/><path d=\"M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z\"/></svg>",
            "info": {},
            "path": "32/HD.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hd32",
          "filepath": "HD/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
                }
              }
            ],
            "name": "HD",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hd24",
          "filepath": "HD/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
                }
              }
            ],
            "name": "HD",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hd20",
          "filepath": "HD/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
                }
              }
            ],
            "name": "HD",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hd16",
          "filepath": "HD/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
                }
              }
            ],
            "name": "HD",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Hd",
        "global": "Hd",
        "filepath": "Hd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "HD--filled",
      "friendlyName": "HD filled",
      "aliases": [
        "high",
        "def",
        "definition",
        "high quality",
        "4K",
        "HD filled",
        "high definition filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/HD--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>HD--filled</title><path d=\"M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z\" transform=\"translate(0 0)\"/><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z\"/><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z\"/></svg>",
            "info": {},
            "path": "32/HD--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HdFilled32",
          "filepath": "HD--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "HD--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HdFilled24",
          "filepath": "HD--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "HD--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HdFilled20",
          "filepath": "HD--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "HD--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HdFilled16",
          "filepath": "HD--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "HD--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "HdFilled",
        "global": "HdFilled",
        "filepath": "HdFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "HDR",
      "friendlyName": "HDR",
      "aliases": [
        "high",
        "dynamic",
        "range",
        "color",
        "HD",
        "HDR"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/HDR.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>HDR</title><path d=\"M30,15V11a2,2,0,0,0-2-2H22V23h2V17h1.48l2.34,6H30l-2.33-6H28A2,2,0,0,0,30,15Zm-6-4h4v4H24Z\"/><path d=\"M16,23H12V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,16,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H14Z\"/><polygon points=\"8 9 8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z\"/></svg>",
            "info": {},
            "path": "32/HDR.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hdr32",
          "filepath": "HDR/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HDR",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hdr24",
          "filepath": "HDR/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HDR",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hdr20",
          "filepath": "HDR/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HDR",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hdr16",
          "filepath": "HDR/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HDR",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Hdr",
        "global": "Hdr",
        "filepath": "Hdr.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "headphones",
      "friendlyName": "Headphones",
      "aliases": [
        "headset",
        "listening device",
        "listening",
        "ear buds",
        "hearing",
        "transceiver",
        "headphones"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/headphones.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>headphones</title><path d=\"M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z\"/></svg>",
            "info": {},
            "path": "32/headphones.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Headphones32",
          "filepath": "headphones/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headphones",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Headphones24",
          "filepath": "headphones/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headphones",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Headphones20",
          "filepath": "headphones/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headphones",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Headphones16",
          "filepath": "headphones/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headphones",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Headphones",
        "global": "Headphones",
        "filepath": "Headphones.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "headset",
      "friendlyName": "Headset",
      "aliases": [
        "headphones",
        "listening device",
        "listening",
        "ear buds",
        "hearing",
        "console",
        "transceiver",
        "headset"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/headset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>headset</title><path d=\"M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z\"/></svg>",
            "info": {},
            "path": "32/headset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Headset32",
          "filepath": "headset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Headset24",
          "filepath": "headset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Headset20",
          "filepath": "headset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Headset16",
          "filepath": "headset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
                }
              }
            ],
            "name": "headset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Headset",
        "global": "Headset",
        "filepath": "Headset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "health-cross",
      "friendlyName": "Health cross",
      "aliases": [
        "Red Cross",
        "medicine",
        "healthcare",
        "medical",
        "ambulance",
        "health cross",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/health-cross.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>health-cross</title><path d=\"M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z\"/></svg>",
            "info": {},
            "path": "32/health-cross.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HealthCross32",
          "filepath": "health-cross/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
                }
              }
            ],
            "name": "health-cross",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HealthCross24",
          "filepath": "health-cross/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
                }
              }
            ],
            "name": "health-cross",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HealthCross20",
          "filepath": "health-cross/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
                }
              }
            ],
            "name": "health-cross",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HealthCross16",
          "filepath": "health-cross/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
                }
              }
            ],
            "name": "health-cross",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "HealthCross",
        "global": "HealthCross",
        "filepath": "HealthCross.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hearing",
      "friendlyName": "Hearing",
      "aliases": [
        "detecting",
        "ear",
        "headphones",
        "headset",
        "listen",
        "auditory",
        "perception",
        "senses",
        "hearing"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hearing.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hearing</title><path d=\"M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z\"/><path d=\"M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z\"/><path d=\"M18,22V20a2.0023,2.0023,0,0,0,2-2h2A4.0042,4.0042,0,0,1,18,22Z\"/><path d=\"M10,2a9.01,9.01,0,0,0-9,9H3a7,7,0,0,1,14,0,7.09,7.09,0,0,1-3.501,6.1348L13,17.4229v3.0732a2.9354,2.9354,0,0,1-.9009,2.1514,4.1824,4.1824,0,0,1-4.6318,1.03A4.0918,4.0918,0,0,1,5,20H3a6.1156,6.1156,0,0,0,3.6694,5.5117,5.7822,5.7822,0,0,0,2.3145.4863A6.5854,6.5854,0,0,0,13.4624,24.11,4.94,4.94,0,0,0,15,20.4961V18.5537A9.1077,9.1077,0,0,0,19,11,9.01,9.01,0,0,0,10,2Z\"/><path d=\"M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z\"/><path d=\"M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z\"/><path d=\"M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z\"/><path d=\"M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z\"/></svg>",
            "info": {},
            "path": "32/hearing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hearing32",
          "filepath": "hearing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
                }
              }
            ],
            "name": "hearing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hearing24",
          "filepath": "hearing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
                }
              }
            ],
            "name": "hearing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hearing20",
          "filepath": "hearing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
                }
              }
            ],
            "name": "hearing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hearing16",
          "filepath": "hearing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
                }
              }
            ],
            "name": "hearing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Hearing",
        "global": "Hearing",
        "filepath": "Hearing.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "heat-map",
      "friendlyName": "Heat map",
      "aliases": [
        "heat map",
        "data visualization",
        "map",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/heat-map.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>heat-map</title>\n  <rect x=\"20\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"28\" y=\"16\" width=\"2\" height=\"2\"/>\n  <rect x=\"14\" y=\"6\" width=\"2\" height=\"2\"/>\n  <path d=\"M16,22H12V16a2.0023,2.0023,0,0,0-2-2H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h6v4a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V24A2.0023,2.0023,0,0,0,16,22ZM4,22V16h6v6Zm8,6V24h4v4Z\"/>\n  <path d=\"M28,30H24a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,28,30Zm-4-6v4h4V24Z\"/>\n  <path d=\"M28,2H22a2.0023,2.0023,0,0,0-2,2v6H18a2.0023,2.0023,0,0,0-2,2v2a2.0023,2.0023,0,0,0,2,2h2a2.0023,2.0023,0,0,0,2-2V12h6a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM18,14V12h2v2Zm4-4V4h6v6Z\"/>\n  <path d=\"M8,10H4A2.0021,2.0021,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H8a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,8,10ZM4,4V8H8V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z\"/></svg>",
            "info": {},
            "path": "32/heat-map.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HeatMap32",
          "filepath": "heat-map/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "heat-map",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HeatMap24",
          "filepath": "heat-map/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "heat-map",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HeatMap20",
          "filepath": "heat-map/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "heat-map",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HeatMap16",
          "filepath": "heat-map/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
                }
              }
            ],
            "name": "heat-map",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "HeatMap",
        "global": "HeatMap",
        "filepath": "HeatMap.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "heat-map--02",
      "friendlyName": "Heat map 02",
      "aliases": [
        "heat map 02",
        "heat map",
        "data visualization",
        "map",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/heat-map--02.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>heat-map--02</title>\n  <circle cx=\"21\" cy=\"20\" r=\"2\"/>\n  <circle cx=\"14\" cy=\"12\" r=\"2\"/>\n  <circle cx=\"29\" cy=\"19\" r=\"1\"/>\n  <path d=\"M26.5,30A3.5,3.5,0,1,1,30,26.5,3.5041,3.5041,0,0,1,26.5,30Zm0-5A1.5,1.5,0,1,0,28,26.5,1.5017,1.5017,0,0,0,26.5,25Z\"/>\n  <path d=\"M14,30a3.958,3.958,0,0,1-2.126-.6211,6.9977,6.9977,0,1,1,4.1109-6.8384A3.9916,3.9916,0,0,1,14,30Zm-1.8843-3.0278.5391.4946a1.9915,1.9915,0,1,0,2.0039-3.343l-.6909-.2432.03-.8467a5.0085,5.0085,0,1,0-2.5166,4.3023Z\"/>\n  <path d=\"M24,16a6.0067,6.0067,0,0,1-6-6,5.3246,5.3246,0,0,1,.0269-.5327A3.9564,3.9564,0,0,1,16,6a4.0045,4.0045,0,0,1,4-4,3.9564,3.9564,0,0,1,3.4673,2.0271C23.6484,4.009,23.8252,4,24,4a6,6,0,0,1,0,12ZM20,4a2.0021,2.0021,0,0,0-2,2,1.9805,1.9805,0,0,0,1.43,1.9023l.9018.2706-.2153.9162A3.9938,3.9938,0,1,0,24,6a4.0064,4.0064,0,0,0-.9121.1162l-.9155.2141-.27-.9006A1.9807,1.9807,0,0,0,20,4Z\"/>\n  <path d=\"M6.5,11A4.5,4.5,0,1,1,11,6.5,4.5051,4.5051,0,0,1,6.5,11Zm0-7A2.5,2.5,0,1,0,9,6.5,2.503,2.503,0,0,0,6.5,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"21\" cy=\"20\" r=\"2\"/><circle cx=\"14\" cy=\"12\" r=\"2\"/><circle cx=\"29\" cy=\"19\" r=\"1\"/><path d=\"M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z\"/></svg>",
            "info": {},
            "path": "32/heat-map--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HeatMap_0232",
          "filepath": "heat-map--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
                }
              }
            ],
            "name": "heat-map--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HeatMap_0224",
          "filepath": "heat-map--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
                }
              }
            ],
            "name": "heat-map--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HeatMap_0220",
          "filepath": "heat-map--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
                }
              }
            ],
            "name": "heat-map--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HeatMap_0216",
          "filepath": "heat-map--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "20",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
                }
              }
            ],
            "name": "heat-map--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "HeatMap_02",
        "global": "HeatMap_02",
        "filepath": "HeatMap_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "20",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "29",
                    "cy": "19",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "heat-map--03",
      "friendlyName": "Heat map 03",
      "aliases": [
        "heat map 03",
        "heat map",
        "data visualization",
        "map",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/heat-map--03.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>heat-map--03</title>\n  <path d=\"M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z\"/></svg>",
            "info": {},
            "path": "32/heat-map--03.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HeatMap_0332",
          "filepath": "heat-map--03/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
                }
              }
            ],
            "name": "heat-map--03",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HeatMap_0324",
          "filepath": "heat-map--03/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
                }
              }
            ],
            "name": "heat-map--03",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HeatMap_0320",
          "filepath": "heat-map--03/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
                }
              }
            ],
            "name": "heat-map--03",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HeatMap_0316",
          "filepath": "heat-map--03/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
                }
              }
            ],
            "name": "heat-map--03",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "HeatMap_03",
        "global": "HeatMap_03",
        "filepath": "HeatMap_03.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "heat-map--stocks",
      "friendlyName": "Heat map stocks",
      "aliases": [
        "heat map stocks",
        "heat map",
        "data visualization",
        "map",
        "data",
        "stocks"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/heat-map--stocks.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z\"/></svg>",
            "info": {},
            "path": "32/heat-map--stocks.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HeatMapStocks32",
          "filepath": "heat-map--stocks/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
                }
              }
            ],
            "name": "heat-map--stocks",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HeatMapStocks24",
          "filepath": "heat-map--stocks/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
                }
              }
            ],
            "name": "heat-map--stocks",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HeatMapStocks20",
          "filepath": "heat-map--stocks/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
                }
              }
            ],
            "name": "heat-map--stocks",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HeatMapStocks16",
          "filepath": "heat-map--stocks/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
                }
              }
            ],
            "name": "heat-map--stocks",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "HeatMapStocks",
        "global": "HeatMapStocks",
        "filepath": "HeatMapStocks.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "helicopter",
      "friendlyName": "Helicopter",
      "aliases": [
        "helicopter",
        "chopper",
        "airplane"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/helicopter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>helicopter</title>\n  <path d=\"M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z\"/></svg>",
            "info": {},
            "path": "32/helicopter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Helicopter32",
          "filepath": "helicopter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
                }
              }
            ],
            "name": "helicopter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Helicopter24",
          "filepath": "helicopter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
                }
              }
            ],
            "name": "helicopter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Helicopter20",
          "filepath": "helicopter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
                }
              }
            ],
            "name": "helicopter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Helicopter16",
          "filepath": "helicopter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
                }
              }
            ],
            "name": "helicopter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Helicopter",
        "global": "Helicopter",
        "filepath": "Helicopter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "help",
      "friendlyName": "Help",
      "aliases": [
        "support",
        "question",
        "assist",
        "more info",
        "help",
        "question mark"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/help.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>help</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/>\n<circle cx=\"8\" cy=\"11.8\" r=\"0.8\"/>\n<path d=\"M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1\n\tv2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z\"/>\n<rect class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/><circle cx=\"8\" cy=\"11.8\" r=\".8\"/><path d=\"M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1\tv2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z\"/></svg>",
            "info": {},
            "path": "16/help.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/help.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>help</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><circle cx=\"16\" cy=\"23.5\" r=\"1.5\"/><path d=\"M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><circle cx=\"16\" cy=\"23.5\" r=\"1.5\"/><path d=\"M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z\"/></svg>",
            "info": {},
            "path": "32/help.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Help32",
          "filepath": "help/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
                }
              }
            ],
            "name": "help",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Help24",
          "filepath": "help/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
                }
              }
            ],
            "name": "help",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Help20",
          "filepath": "help/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
                }
              }
            ],
            "name": "help",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Help16",
          "filepath": "help/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "11.8",
                  "r": ".8"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1\tv2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z"
                }
              }
            ],
            "name": "help",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Help",
        "global": "Help",
        "filepath": "Help.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "11.8",
                    "r": ".8"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1 v2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "23.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "help--filled",
      "friendlyName": "Help filled",
      "aliases": [
        "support",
        "question",
        "assist",
        "more info",
        "help filled",
        "question mark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/help--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>help--filled</title>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z\" transform=\"translate(0)\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z\"/><path fill=\"none\" d=\"M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/help--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HelpFilled32",
          "filepath": "help--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "help--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HelpFilled24",
          "filepath": "help--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "help--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HelpFilled20",
          "filepath": "help--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "help--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HelpFilled16",
          "filepath": "help--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "help--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "HelpFilled",
        "global": "HelpFilled",
        "filepath": "HelpFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "help-desk",
      "friendlyName": "Help desk",
      "aliases": [
        "help desk",
        "tech support",
        "help"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/help-desk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>help-desk</title><path d=\"M27,10H21a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,27,10Zm1,9H26v9H22V19H20V13a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Z\"/><path d=\"M20,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,20,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,22,5Z\"/><path d=\"M14,16V13a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3v3H0v2H16V16ZM4,13a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v3H4Z\"/><path d=\"M4,5A4,4,0,1,1,8,9,4.0042,4.0042,0,0,1,4,5ZM6,5A2,2,0,1,0,8,3,2.0023,2.0023,0,0,0,6,5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z\"/></svg>",
            "info": {},
            "path": "32/help-desk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HelpDesk32",
          "filepath": "help-desk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
                }
              }
            ],
            "name": "help-desk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HelpDesk24",
          "filepath": "help-desk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
                }
              }
            ],
            "name": "help-desk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HelpDesk20",
          "filepath": "help-desk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
                }
              }
            ],
            "name": "help-desk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HelpDesk16",
          "filepath": "help-desk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
                }
              }
            ],
            "name": "help-desk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "HelpDesk",
        "global": "HelpDesk",
        "filepath": "HelpDesk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hinton-plot",
      "friendlyName": "Hinton plot",
      "aliases": [
        "Q",
        "hinton",
        "plot",
        "grid",
        "Hinton plot"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/hinton-plot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>research--hinton-plot</title><rect x=\"2\" y=\"2\" width=\"4\" height=\"4\"/><rect x=\"10\" y=\"2\" width=\"4\" height=\"4\"/><rect x=\"18\" y=\"2\" width=\"4\" height=\"4\"/><rect x=\"26\" y=\"2\" width=\"4\" height=\"4\"/><rect x=\"2\" y=\"10\" width=\"4\" height=\"4\"/><rect x=\"10\" y=\"10\" width=\"4\" height=\"4\"/><rect x=\"18\" y=\"10\" width=\"4\" height=\"4\"/><rect x=\"26\" y=\"10\" width=\"4\" height=\"4\"/><rect x=\"2\" y=\"18\" width=\"4\" height=\"4\"/><rect x=\"10\" y=\"18\" width=\"4\" height=\"4\"/><rect x=\"18\" y=\"18\" width=\"4\" height=\"4\"/><rect x=\"26\" y=\"18\" width=\"4\" height=\"4\"/><rect x=\"2\" y=\"26\" width=\"4\" height=\"4\"/><rect x=\"10\" y=\"26\" width=\"4\" height=\"4\"/><rect x=\"18\" y=\"26\" width=\"4\" height=\"4\"/><rect x=\"26\" y=\"26\" width=\"4\" height=\"4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z\"/></svg>",
            "info": {},
            "path": "32/Q/hinton-plot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QHintonPlot32",
          "filepath": "Q/hinton-plot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
                }
              }
            ],
            "name": "hinton-plot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QHintonPlot24",
          "filepath": "Q/hinton-plot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
                }
              }
            ],
            "name": "hinton-plot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QHintonPlot20",
          "filepath": "Q/hinton-plot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
                }
              }
            ],
            "name": "hinton-plot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QHintonPlot16",
          "filepath": "Q/hinton-plot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
                }
              }
            ],
            "name": "hinton-plot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "HintonPlot",
        "global": "QHintonPlot",
        "filepath": "Q/HintonPlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "HL7-attributes",
      "friendlyName": "HL7 attributes",
      "aliases": [
        "attributes",
        "HL7",
        "interoperability",
        "message",
        "standards",
        "electronic health information",
        "Watson Health®"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/HL7-attributes.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"29 9 21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9\"/>\n  <polygon points=\"14 21 14 9 12 9 12 23 20 23 20 21 14 21\"/>\n  <polygon points=\"8 9 8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z\"/></svg>",
            "info": {},
            "path": "32/watson-health/HL7-attributes.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthHl7Attributes32",
          "filepath": "watson-health/HL7-attributes/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HL7-attributes",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthHl7Attributes24",
          "filepath": "watson-health/HL7-attributes/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HL7-attributes",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthHl7Attributes20",
          "filepath": "watson-health/HL7-attributes/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HL7-attributes",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthHl7Attributes16",
          "filepath": "watson-health/HL7-attributes/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "HL7-attributes",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Hl7Attributes",
        "global": "WatsonHealthHl7Attributes",
        "filepath": "watson-health/Hl7Attributes.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hole-filling",
      "friendlyName": "Hole filling",
      "aliases": [
        "hole filling",
        "health",
        "digital imaging"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/hole-filling.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hole-filling</title><circle cx=\"16\" cy=\"16\" r=\"5\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"5\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/hole-filling.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthHoleFilling32",
          "filepath": "watson-health/hole-filling/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "hole-filling",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthHoleFilling24",
          "filepath": "watson-health/hole-filling/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "hole-filling",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthHoleFilling20",
          "filepath": "watson-health/hole-filling/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "hole-filling",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthHoleFilling16",
          "filepath": "watson-health/hole-filling/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "hole-filling",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "HoleFilling",
        "global": "WatsonHealthHoleFilling",
        "filepath": "watson-health/HoleFilling.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hole-filling--cursor",
      "friendlyName": "Hole-filling cursor",
      "aliases": [
        "hole-filling cursor",
        "cursor",
        "hole filling",
        "health",
        "digital imaging"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/hole-filling--cursor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hole-filling--cursor</title><circle cx=\"19\" cy=\"19\" r=\"4\"/><path d=\"M28,30H10a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM10,10V28H28V10Z\"/><polygon points=\"11 2 2 2 2 11 4 11 4 4 11 4 11 2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"19\" cy=\"19\" r=\"4\"/><path d=\"M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z\"/></svg>",
            "info": {},
            "path": "32/watson-health/hole-filling--cursor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthHoleFillingCursor32",
          "filepath": "watson-health/hole-filling--cursor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "19",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "hole-filling--cursor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthHoleFillingCursor24",
          "filepath": "watson-health/hole-filling--cursor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "19",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "hole-filling--cursor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthHoleFillingCursor20",
          "filepath": "watson-health/hole-filling--cursor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "19",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "hole-filling--cursor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthHoleFillingCursor16",
          "filepath": "watson-health/hole-filling--cursor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "19",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "hole-filling--cursor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "HoleFillingCursor",
        "global": "WatsonHealthHoleFillingCursor",
        "filepath": "watson-health/HoleFillingCursor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "19",
                    "cy": "19",
                    "r": "4"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "home",
      "friendlyName": "Home",
      "aliases": [
        "home",
        "start",
        "main"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/home.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n  <path d=\"M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z\" transform=\"translate(0 0)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z\"/></svg>",
            "info": {},
            "path": "32/home.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Home32",
          "filepath": "home/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
                }
              }
            ],
            "name": "home",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Home24",
          "filepath": "home/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
                }
              }
            ],
            "name": "home",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Home20",
          "filepath": "home/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
                }
              }
            ],
            "name": "home",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Home16",
          "filepath": "home/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
                }
              }
            ],
            "name": "home",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Home",
        "global": "Home",
        "filepath": "Home.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "horizontal-view",
      "friendlyName": "Horizontal view",
      "aliases": [
        "formatting",
        "horizontal",
        "view"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/horizontal-view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,30ZM4,20H3.9985L4,28H28V20Z\"/>\n  <path d=\"M28,14H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,14ZM4,4H3.9985L4,12H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z\"/></svg>",
            "info": {},
            "path": "32/horizontal-view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HorizontalView32",
          "filepath": "horizontal-view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z"
                }
              }
            ],
            "name": "horizontal-view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HorizontalView24",
          "filepath": "horizontal-view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z"
                }
              }
            ],
            "name": "horizontal-view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HorizontalView20",
          "filepath": "horizontal-view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z"
                }
              }
            ],
            "name": "horizontal-view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HorizontalView16",
          "filepath": "horizontal-view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z"
                }
              }
            ],
            "name": "horizontal-view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "HorizontalView",
        "global": "HorizontalView",
        "filepath": "HorizontalView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hospital",
      "friendlyName": "Hospital",
      "aliases": [
        "hospital",
        "healthcare",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hospital.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>hospital</title>\n  <polygon points=\"21 10 17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10\"/>\n  <path d=\"M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z\"/><path d=\"M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z\"/></svg>",
            "info": {},
            "path": "32/hospital.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hospital32",
          "filepath": "hospital/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
                }
              }
            ],
            "name": "hospital",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hospital24",
          "filepath": "hospital/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
                }
              }
            ],
            "name": "hospital",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hospital20",
          "filepath": "hospital/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
                }
              }
            ],
            "name": "hospital",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hospital16",
          "filepath": "hospital/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
                }
              }
            ],
            "name": "hospital",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Hospital",
        "global": "Hospital",
        "filepath": "Hospital.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hospital-bed",
      "friendlyName": "Hospital bed",
      "aliases": [
        "hospital bed",
        "hospital",
        "bed"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hospital-bed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>hospital-bed</title>\n  <path d=\"M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z\"/>\n  <path d=\"M9.5,17A1.5,1.5,0,1,1,8,18.5,1.5017,1.5017,0,0,1,9.5,17m0-2A3.5,3.5,0,1,0,13,18.5,3.5,3.5,0,0,0,9.5,15Z\"/>\n  <polygon points=\"21 6 17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z\"/><path d=\"M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z\"/></svg>",
            "info": {},
            "path": "32/hospital-bed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HospitalBed32",
          "filepath": "hospital-bed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
                }
              }
            ],
            "name": "hospital-bed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HospitalBed24",
          "filepath": "hospital-bed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
                }
              }
            ],
            "name": "hospital-bed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HospitalBed20",
          "filepath": "hospital-bed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
                }
              }
            ],
            "name": "hospital-bed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HospitalBed16",
          "filepath": "hospital-bed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
                }
              }
            ],
            "name": "hospital-bed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "HospitalBed",
        "global": "HospitalBed",
        "filepath": "HospitalBed.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hotel",
      "friendlyName": "Hotel",
      "aliases": [
        "hostel",
        "motel",
        "house",
        "inn",
        "lodging",
        "resort",
        "hotel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hotel.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hotel</title><path d=\"M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z\"/><path d=\"M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z\"/><path d=\"M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z\"/></svg>",
            "info": {},
            "path": "32/hotel.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hotel32",
          "filepath": "hotel/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
                }
              }
            ],
            "name": "hotel",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hotel24",
          "filepath": "hotel/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
                }
              }
            ],
            "name": "hotel",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hotel20",
          "filepath": "hotel/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
                }
              }
            ],
            "name": "hotel",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hotel16",
          "filepath": "hotel/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
                }
              }
            ],
            "name": "hotel",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Hotel",
        "global": "Hotel",
        "filepath": "Hotel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hourglass",
      "friendlyName": "Hourglass",
      "aliases": [
        "clock",
        "metronome",
        "timepiece",
        "timer",
        "time",
        "duration",
        "hourglass",
        "expiry"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hourglass.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hourglass</title><rect x=\"15\" y=\"19\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"23\" width=\"2\" height=\"2\"/><path d=\"M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 19H17V21H15zM15 23H17V25H15z\"/><path d=\"M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z\"/></svg>",
            "info": {},
            "path": "32/hourglass.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hourglass32",
          "filepath": "hourglass/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V21H15zM15 23H17V25H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
                }
              }
            ],
            "name": "hourglass",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hourglass24",
          "filepath": "hourglass/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V21H15zM15 23H17V25H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
                }
              }
            ],
            "name": "hourglass",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hourglass20",
          "filepath": "hourglass/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V21H15zM15 23H17V25H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
                }
              }
            ],
            "name": "hourglass",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hourglass16",
          "filepath": "hourglass/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V21H15zM15 23H17V25H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
                }
              }
            ],
            "name": "hourglass",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Hourglass",
        "global": "Hourglass",
        "filepath": "Hourglass.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 19H17V21H15zM15 23H17V25H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "HTML",
      "friendlyName": "HTML",
      "aliases": [
        "HTML",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/HTML.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"28 19 28 11 26 11 26 21 32 21 32 19 28 19\"/>\n  <polygon points=\"24 11 22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11\"/>\n  <polygon points=\"9 13 11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13\"/>\n  <polygon points=\"5 11 5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z\"/></svg>",
            "info": {},
            "path": "32/HTML.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Html32",
          "filepath": "HTML/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
                }
              }
            ],
            "name": "HTML",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Html24",
          "filepath": "HTML/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
                }
              }
            ],
            "name": "HTML",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Html20",
          "filepath": "HTML/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
                }
              }
            ],
            "name": "HTML",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Html16",
          "filepath": "HTML/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
                }
              }
            ],
            "name": "HTML",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Html",
        "global": "Html",
        "filepath": "Html.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "HTML--reference",
      "friendlyName": "HTML reference",
      "aliases": [
        "HTML reference",
        "file",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/HTML--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <polygon points=\"28 14 28 6 26 6 26 16 32 16 32 14 28 14\"/>\n  <polygon points=\"24 6 22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6\"/>\n  <polygon points=\"9 8 11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8\"/>\n  <polygon points=\"5 6 5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z\"/></svg>",
            "info": {},
            "path": "32/HTML--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HtmlReference32",
          "filepath": "HTML--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
                }
              }
            ],
            "name": "HTML--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HtmlReference24",
          "filepath": "HTML--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
                }
              }
            ],
            "name": "HTML--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HtmlReference20",
          "filepath": "HTML--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
                }
              }
            ],
            "name": "HTML--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HtmlReference16",
          "filepath": "HTML--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
                }
              }
            ],
            "name": "HTML--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "HtmlReference",
        "global": "HtmlReference",
        "filepath": "HtmlReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "HTTP",
      "friendlyName": "HTTP",
      "aliases": [
        "internet",
        "web",
        "cert",
        "certificate",
        "website",
        "site",
        "URL",
        "HTTP"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/HTTP.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>HTTP</title><path d=\"M30,11H25V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,30,11Zm-3,5V13h3l.001,3Z\" transform=\"translate(0 0)\"/><polygon points=\"10 13 12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13\"/><polygon points=\"23 11 17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11\"/><polygon points=\"6 11 6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z\"/></svg>",
            "info": {},
            "path": "32/HTTP.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Http32",
          "filepath": "HTTP/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
                }
              }
            ],
            "name": "HTTP",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Http24",
          "filepath": "HTTP/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
                }
              }
            ],
            "name": "HTTP",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Http20",
          "filepath": "HTTP/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
                }
              }
            ],
            "name": "HTTP",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Http16",
          "filepath": "HTTP/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
                }
              }
            ],
            "name": "HTTP",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Http",
        "global": "Http",
        "filepath": "Http.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "humidity",
      "friendlyName": "Humidity",
      "aliases": [
        "weather",
        "damp",
        "dampness",
        "moisture",
        "dew",
        "muggy",
        "mugginess",
        "steaminess",
        "steam",
        "drop",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/humidity.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>humidity</title>\n  <path d=\"M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z\"/></svg>",
            "info": {},
            "path": "32/humidity.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Humidity32",
          "filepath": "humidity/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
                }
              }
            ],
            "name": "humidity",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Humidity24",
          "filepath": "humidity/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
                }
              }
            ],
            "name": "humidity",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Humidity20",
          "filepath": "humidity/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
                }
              }
            ],
            "name": "humidity",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Humidity16",
          "filepath": "humidity/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
                }
              }
            ],
            "name": "humidity",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Humidity",
        "global": "Humidity",
        "filepath": "Humidity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "humidity--alt",
      "friendlyName": "Humidity alt",
      "aliases": [
        "weather",
        "damp",
        "dampness",
        "moisture",
        "dew",
        "muggy",
        "mugginess",
        "steaminess",
        "steam",
        "humidity alt",
        "cloud",
        "cloudy",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/humidity--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>humidity--alt</title>\n  <path d=\"M26,12a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L25.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L29.3154,6.11A3.9693,3.9693,0,0,1,30,8.223,3.8978,3.8978,0,0,1,26,12Zm0-7.2368L24.3438,7.2257A1.89,1.89,0,0,0,24,8.223a2.0139,2.0139,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z\" transform=\"translate(0)\"/>\n  <path d=\"M23.5,30H8.5A6.4962,6.4962,0,0,1,7.2,17.1381a8.9938,8.9938,0,0,1,17.6006,0A6.4964,6.4964,0,0,1,23.5,30ZM16,12a7,7,0,0,0-6.9414,6.1452l-.0991.8122-.8155.064A4.4962,4.4962,0,0,0,8.5,28h15a4.4962,4.4962,0,0,0,.3564-8.9786l-.8154-.064-.0986-.8122A7.0022,7.0022,0,0,0,16,12Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z\"/></svg>",
            "info": {},
            "path": "32/humidity--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HumidityAlt32",
          "filepath": "humidity--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
                }
              }
            ],
            "name": "humidity--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HumidityAlt24",
          "filepath": "humidity--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
                }
              }
            ],
            "name": "humidity--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HumidityAlt20",
          "filepath": "humidity--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
                }
              }
            ],
            "name": "humidity--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HumidityAlt16",
          "filepath": "humidity--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
                }
              }
            ],
            "name": "humidity--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "HumidityAlt",
        "global": "HumidityAlt",
        "filepath": "HumidityAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hurricane",
      "friendlyName": "Hurricane",
      "aliases": [
        "hurricane",
        "storm",
        "weather",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hurricane.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hurricane</title><path d=\"M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z\"/></svg>",
            "info": {},
            "path": "32/hurricane.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Hurricane32",
          "filepath": "hurricane/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "hurricane",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Hurricane24",
          "filepath": "hurricane/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "hurricane",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Hurricane20",
          "filepath": "hurricane/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "hurricane",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Hurricane16",
          "filepath": "hurricane/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "hurricane",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Hurricane",
        "global": "Hurricane",
        "filepath": "Hurricane.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hybrid-networking",
      "friendlyName": "Hybrid networking",
      "aliases": [
        "hybrid networking",
        "networking",
        "linking",
        "interactive"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hybrid-networking.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>hybrid-networking</title><path d=\"M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z\"/><path d=\"M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z\"/><path d=\"M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z\"/><path d=\"M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z\"/><path d=\"M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z\"/></svg>",
            "info": {},
            "path": "32/hybrid-networking.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HybridNetworking32",
          "filepath": "hybrid-networking/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
                }
              }
            ],
            "name": "hybrid-networking",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HybridNetworking24",
          "filepath": "hybrid-networking/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
                }
              }
            ],
            "name": "hybrid-networking",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HybridNetworking20",
          "filepath": "hybrid-networking/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
                }
              }
            ],
            "name": "hybrid-networking",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HybridNetworking16",
          "filepath": "hybrid-networking/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
                }
              }
            ],
            "name": "hybrid-networking",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "HybridNetworking",
        "global": "HybridNetworking",
        "filepath": "HybridNetworking.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "hybrid-networking--alt",
      "friendlyName": "Hybrid networking alt",
      "aliases": [
        "hybrid networking",
        "networking",
        "linking",
        "interactive"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/hybrid-networking--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z\"/></svg>",
            "info": {},
            "path": "32/hybrid-networking--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "HybridNetworkingAlt32",
          "filepath": "hybrid-networking--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
                }
              }
            ],
            "name": "hybrid-networking--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "HybridNetworkingAlt24",
          "filepath": "hybrid-networking--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
                }
              }
            ],
            "name": "hybrid-networking--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "HybridNetworkingAlt20",
          "filepath": "hybrid-networking--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
                }
              }
            ],
            "name": "hybrid-networking--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "HybridNetworkingAlt16",
          "filepath": "hybrid-networking--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
                }
              }
            ],
            "name": "hybrid-networking--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "HybridNetworkingAlt",
        "global": "HybridNetworkingAlt",
        "filepath": "HybridNetworkingAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--bluepay",
      "friendlyName": "ibm--bluepay",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--bluepay.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M5,26V15.8281l-3.5859,3.586L0,18l6-6,6,6-1.4141,1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2Z\"/>\n  <path d=\"M31,18h-3v-2h-2v2h-1c-1.1046,0-2,.8954-2,2v2c0,1.1046,.8954,2,2,2h4v2h-6s0,2,0,2h3v2h2v-2h1c1.1046,0,2-.8954,2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2Z\"/>\n  <path d=\"M28,12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6\"/>\n  <rect x=\"2\" y=\"6\" width=\"5\" height=\"2\"/>\n  <rect x=\"2\" y=\"2\" width=\"8\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z\"/></svg>",
            "info": {},
            "path": "32/ibm--bluepay.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmBluepay32",
          "filepath": "ibm--bluepay/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "ibm--bluepay",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmBluepay24",
          "filepath": "ibm--bluepay/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "ibm--bluepay",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmBluepay20",
          "filepath": "ibm--bluepay/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "ibm--bluepay",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmBluepay16",
          "filepath": "ibm--bluepay/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z"
                }
              }
            ],
            "name": "ibm--bluepay",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmBluepay",
        "global": "IbmBluepay",
        "filepath": "IbmBluepay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--content-services",
      "friendlyName": "ibm--content-services",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--content-services.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z\"/>\n  <path d=\"M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z\"/>\n  <path d=\"M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z\"/><path d=\"M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z\"/><path d=\"M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z\"/></svg>",
            "info": {},
            "path": "32/ibm--content-services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmContentServices32",
          "filepath": "ibm--content-services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
                }
              }
            ],
            "name": "ibm--content-services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmContentServices24",
          "filepath": "ibm--content-services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
                }
              }
            ],
            "name": "ibm--content-services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmContentServices20",
          "filepath": "ibm--content-services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
                }
              }
            ],
            "name": "ibm--content-services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmContentServices16",
          "filepath": "ibm--content-services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
                }
              }
            ],
            "name": "ibm--content-services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmContentServices",
        "global": "IbmContentServices",
        "filepath": "IbmContentServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--data-replication",
      "friendlyName": "IBM® Data Replication",
      "aliases": [
        "data",
        "replication"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--data-replication.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,20v2h5.22a11.0163,11.0163,0,0,1-11.97,4.6533l-.4986,1.937A13,13,0,0,0,26,24.293V28h2V20Z\"/>\n  <path d=\"M25,3a4.0045,4.0045,0,0,0-4,4,3.954,3.954,0,0,0,.5669,2.019L9.019,21.5669A3.9521,3.9521,0,0,0,7,21a4,4,0,1,0,4,4,3.954,3.954,0,0,0-.5669-2.019L22.981,10.4331A3.9518,3.9518,0,0,0,25,11a4,4,0,0,0,0-8ZM7,27a2,2,0,1,1,2-2A2.002,2.002,0,0,1,7,27ZM25,9a2,2,0,1,1,2-2A2.002,2.002,0,0,1,25,9Z\"/>\n  <path d=\"M16,3A13.04,13.04,0,0,0,6,7.707V4H4v8h8V10H6.78a11.0163,11.0163,0,0,1,11.97-4.6533l.4986-1.937A13.0358,13.0358,0,0,0,16,3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z\"/></svg>",
            "info": {},
            "path": "32/ibm--data-replication.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmDataReplication32",
          "filepath": "ibm--data-replication/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z"
                }
              }
            ],
            "name": "ibm--data-replication",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmDataReplication24",
          "filepath": "ibm--data-replication/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z"
                }
              }
            ],
            "name": "ibm--data-replication",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmDataReplication20",
          "filepath": "ibm--data-replication/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z"
                }
              }
            ],
            "name": "ibm--data-replication",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmDataReplication16",
          "filepath": "ibm--data-replication/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z"
                }
              }
            ],
            "name": "ibm--data-replication",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmDataReplication",
        "global": "IbmDataReplication",
        "filepath": "IbmDataReplication.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--datastage",
      "friendlyName": "ibm--datastage",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--datastage.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,22.1V13h-2v9.1c-1.4,0.4-2.5,1.5-2.9,2.9H13v2h9.1c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4C30,24.1,28.7,22.6,27,22.1z\n\t M26,28c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S27.1,28,26,28z\"/>\n<path d=\"M10,30H2v-8h8V30z M4,28h4v-4H4V28z\"/>\n<path d=\"M9.9,7H19V5H9.9C9.4,3.3,7.9,2,6,2C3.8,2,2,3.8,2,6c0,1.9,1.3,3.4,3,3.9V19h2V9.9C8.4,9.5,9.5,8.4,9.9,7z M6,8\n\tC4.9,8,4,7.1,4,6s0.9-2,2-2s2,0.9,2,2S7.1,8,6,8z\"/>\n<polygon points=\"22,2 22,4 26.6,4 11,19.6 12.4,21 28,5.4 28,10 30,10 30,2 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z\"/><path d=\"M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z\"/></svg>",
            "info": {},
            "path": "32/ibm--datastage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmDatastage32",
          "filepath": "ibm--datastage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
                }
              }
            ],
            "name": "ibm--datastage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmDatastage24",
          "filepath": "ibm--datastage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
                }
              }
            ],
            "name": "ibm--datastage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmDatastage20",
          "filepath": "ibm--datastage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
                }
              }
            ],
            "name": "ibm--datastage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmDatastage16",
          "filepath": "ibm--datastage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
                }
              }
            ],
            "name": "ibm--datastage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmDatastage",
        "global": "IbmDatastage",
        "filepath": "IbmDatastage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--db2",
      "friendlyName": "ibm--db2",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--db2.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"23\" cy=\"26\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"6\" r=\"1\"/>\n  <path d=\"M12,17h8c2.2056,0,4-1.7944,4-4v-3h2c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2H6c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H22v3c0,1.1025-.8972,2-2,2H12c-2.2056,0-4,1.7944-4,4v3h-2c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H26c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2H10v-3c0-1.1025,.8972-2,2-2ZM6,4H26v4H6V4ZM26,28H6v-4H26v4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"26\" r=\"1\"/><circle cx=\"9\" cy=\"6\" r=\"1\"/><path d=\"M12,17h8c2.2056,0,4-1.7944,4-4v-3h2c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2H6c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H22v3c0,1.1025-.8972,2-2,2H12c-2.2056,0-4,1.7944-4,4v3h-2c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H26c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2H10v-3c0-1.1025,.8972-2,2-2ZM6,4H26v4H6V4ZM26,28H6v-4H26v4Z\"/></svg>",
            "info": {},
            "path": "32/ibm--db2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmDb232",
          "filepath": "ibm--db2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,17h8c2.2056,0,4-1.7944,4-4v-3h2c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2H6c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H22v3c0,1.1025-.8972,2-2,2H12c-2.2056,0-4,1.7944-4,4v3h-2c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H26c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2H10v-3c0-1.1025,.8972-2,2-2ZM6,4H26v4H6V4ZM26,28H6v-4H26v4Z"
                }
              }
            ],
            "name": "ibm--db2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmDb224",
          "filepath": "ibm--db2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,17h8c2.2056,0,4-1.7944,4-4v-3h2c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2H6c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H22v3c0,1.1025-.8972,2-2,2H12c-2.2056,0-4,1.7944-4,4v3h-2c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H26c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2H10v-3c0-1.1025,.8972-2,2-2ZM6,4H26v4H6V4ZM26,28H6v-4H26v4Z"
                }
              }
            ],
            "name": "ibm--db2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmDb220",
          "filepath": "ibm--db2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,17h8c2.2056,0,4-1.7944,4-4v-3h2c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2H6c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H22v3c0,1.1025-.8972,2-2,2H12c-2.2056,0-4,1.7944-4,4v3h-2c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H26c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2H10v-3c0-1.1025,.8972-2,2-2ZM6,4H26v4H6V4ZM26,28H6v-4H26v4Z"
                }
              }
            ],
            "name": "ibm--db2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmDb216",
          "filepath": "ibm--db2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,17h8c2.2056,0,4-1.7944,4-4v-3h2c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2H6c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H22v3c0,1.1025-.8972,2-2,2H12c-2.2056,0-4,1.7944-4,4v3h-2c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H26c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2H10v-3c0-1.1025,.8972-2,2-2ZM6,4H26v4H6V4ZM26,28H6v-4H26v4Z"
                }
              }
            ],
            "name": "ibm--db2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmDb2",
        "global": "IbmDb2",
        "filepath": "IbmDb2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "26",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "6",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,17h8c2.2056,0,4-1.7944,4-4v-3h2c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2H6c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H22v3c0,1.1025-.8972,2-2,2H12c-2.2056,0-4,1.7944-4,4v3h-2c-1.1028,0-2,.8975-2,2v4c0,1.1025,.8972,2,2,2H26c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2H10v-3c0-1.1025,.8972-2,2-2ZM6,4H26v4H6V4ZM26,28H6v-4H26v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--db2--alt",
      "friendlyName": "ibm--db2--alt",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--db2--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M31.3579,22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389,1.7849-1.8019,1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218,0-1.6658,.7649-1.9038,1.6658l-2.2268-.8499c.5271-1.6488,1.9038-3.0256,4.3687-3.0256,2.5667,0,4.0457,1.5128,4.0457,3.5696,0,2.0398-1.4619,3.2806-3.1619,4.6235l-2.2097,1.7339h5.6094v2.1417Z\"/>\n  <path d=\"M12.8291,9.4212h2.5159v5.1505h.085c.2549-.986,1.2407-1.6998,2.3967-1.6998,2.2607,0,3.4336,1.6318,3.4336,4.6575s-1.1729,4.6746-3.4336,4.6746c-1.156,0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212Zm5.8135,8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487,.4929-1.6487,1.3088v2.6348c0,.8159,.6968,1.3088,1.6487,1.3088s1.6489-.731,1.6489-1.8528Z\"/>\n  <path d=\"M1.1163,10.1351H5.5867c3.1448,0,5.2185,1.9889,5.2185,5.9325s-2.0737,5.9324-5.2185,5.9324H1.1163V10.1351Zm4.4704,9.5687c1.53,0,2.4819-.8329,2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z\"/></svg>",
            "info": {},
            "path": "32/ibm--db2--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmDb2Alt32",
          "filepath": "ibm--db2--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z"
                }
              }
            ],
            "name": "ibm--db2--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmDb2Alt24",
          "filepath": "ibm--db2--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z"
                }
              }
            ],
            "name": "ibm--db2--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmDb2Alt20",
          "filepath": "ibm--db2--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z"
                }
              }
            ],
            "name": "ibm--db2--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmDb2Alt16",
          "filepath": "ibm--db2--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z"
                }
              }
            ],
            "name": "ibm--db2--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmDb2Alt",
        "global": "IbmDb2Alt",
        "filepath": "IbmDb2Alt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--match-360",
      "friendlyName": "IBM® Match 360",
      "aliases": [
        "Match 360"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--match-360.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"circle_1\" data-name=\"circle 1\" d=\"M5,25a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,5,25Z\"/>\n  <path id=\"circle_2\" data-name=\"circle 2\" d=\"M16,25a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,25Z\"/>\n  <path id=\"circle_3\" data-name=\"circle 3\" d=\"M27,25a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z\"/>\n  <path id=\"_Line\" data-name=\" Line\" d=\"M28,23H26V11a2.0059,2.0059,0,0,0-2-2H22V7h2a4.0118,4.0118,0,0,1,4,4Z\"/>\n  <rect id=\"_Line-2\" data-name=\" Line\" x=\"15\" y=\"12\" width=\"2\" height=\"11\"/>\n  <path id=\"_Line-3\" data-name=\" Line\" d=\"M6,23H4V11A4.0118,4.0118,0,0,1,8,7h2V9H8a2.0059,2.0059,0,0,0-2,2Z\"/>\n  <path d=\"M16,2,14.7,4.6343l-2.9057.42,2.1029,2.0514L13.4,10,16,8.6343,18.6,10l-.4972-2.8943,2.1029-2.0486L17.3,4.6343Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z\"/></svg>",
            "info": {},
            "path": "32/ibm--match-360.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmMatch_36032",
          "filepath": "ibm--match-360/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
                }
              }
            ],
            "name": "ibm--match-360",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmMatch_36024",
          "filepath": "ibm--match-360/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
                }
              }
            ],
            "name": "ibm--match-360",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmMatch_36020",
          "filepath": "ibm--match-360/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
                }
              }
            ],
            "name": "ibm--match-360",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmMatch_36016",
          "filepath": "ibm--match-360/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
                }
              }
            ],
            "name": "ibm--match-360",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmMatch_360",
        "global": "IbmMatch_360",
        "filepath": "IbmMatch_360.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--mq",
      "friendlyName": "ibm--mq",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--mq.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\n\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z\"/>\n<path d=\"M20.5,23.8l-1-1.7c2.2-1.2,3.5-3.6,3.5-6.1c0-3.9-3.1-7-7-7c-0.6,0-1.2,0.1-1.8,0.2l-0.5-1.9C14.5,7.1,15.2,7,16,7\n\tc5,0,9,4,9,9C25,19.2,23.3,22.2,20.5,23.8z\"/>\n<path d=\"M9.5,28.4C4.9,26,2,21.2,2,16c0-1.5,0.2-2.9,0.7-4.3l1.9,0.6C4.2,13.5,4,14.7,4,16c0,4.5,2.5,8.6,6.5,10.6L9.5,28.4z\"/>\n<path d=\"M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z\"/>\n<path d=\"M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\n\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\n\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z\"/><path d=\"M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z\"/><path d=\"M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z\"/><path d=\"M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z\"/></svg>",
            "info": {},
            "path": "32/ibm--mq.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmMq32",
          "filepath": "ibm--mq/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
                }
              }
            ],
            "name": "ibm--mq",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmMq24",
          "filepath": "ibm--mq/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
                }
              }
            ],
            "name": "ibm--mq",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmMq20",
          "filepath": "ibm--mq/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
                }
              }
            ],
            "name": "ibm--mq",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmMq16",
          "filepath": "ibm--mq/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
                }
              }
            ],
            "name": "ibm--mq",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmMq",
        "global": "IbmMq",
        "filepath": "IbmMq.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2 c7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2 c0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2 c0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--open-enterprise-languages",
      "friendlyName": "IBM® Open Enterprise Languages",
      "aliases": [
        "Open Enterprise Languages",
        "z16"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--open-enterprise-languages.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"23.586,21.414 27.166,25 27.166,25 23.584,28.587 25,30 30,25 25,20 \"/>\n<polygon points=\"20.414,21.414 16.834,25 16.834,25 20.416,28.587 19,30 14,25 19,20 \"/>\n<rect x=\"22\" y=\"6\" width=\"2\" height=\"8\"/>\n<rect x=\"18\" y=\"6\" width=\"2\" height=\"8\"/>\n<path d=\"M14,14h-2c-1.103,0-2-0.897-2-2V8c0-1.103,0.897-2,2-2h2c1.103,0,2,0.897,2,2v4C16,13.103,15.103,14,14,14z M12,8v4h2V8H12z\n\t\"/>\n<rect x=\"6\" y=\"6\" width=\"2\" height=\"8\"/>\n<path d=\"M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z\"/><path d=\"M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z\"/></svg>",
            "info": {},
            "path": "32/ibm--open-enterprise-languages.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmOpenEnterpriseLanguages32",
          "filepath": "ibm--open-enterprise-languages/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
                }
              }
            ],
            "name": "ibm--open-enterprise-languages",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmOpenEnterpriseLanguages24",
          "filepath": "ibm--open-enterprise-languages/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
                }
              }
            ],
            "name": "ibm--open-enterprise-languages",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmOpenEnterpriseLanguages20",
          "filepath": "ibm--open-enterprise-languages/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
                }
              }
            ],
            "name": "ibm--open-enterprise-languages",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmOpenEnterpriseLanguages16",
          "filepath": "ibm--open-enterprise-languages/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
                }
              }
            ],
            "name": "ibm--open-enterprise-languages",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmOpenEnterpriseLanguages",
        "global": "IbmOpenEnterpriseLanguages",
        "filepath": "IbmOpenEnterpriseLanguages.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--power-vs",
      "friendlyName": "ibm--power-vs",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--power-vs.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16,25c-2,0-4-0.7-5.6-2l1.3-1.6c1.3,1,2.8,1.5,4.4,1.5c3.9,0,7-3.1,7-7c0-0.3,0-0.7-0.1-1l2-0.3C25,15.1,25,15.6,25,16\n\tC25,21,21,25,16,25z\"/>\n<path d=\"M7.1,17.3C7,16.9,7,16.4,7,16c0-5,4-9,9-9c2,0,4,0.7,5.6,2l-1.3,1.6C19.1,9.5,17.6,9,16,9c-3.9,0-7,3.1-7,7\n\tc0,0.3,0,0.7,0.1,1L7.1,17.3z\"/>\n<circle cx=\"23\" cy=\"27\" r=\"1\"/>\n<circle cx=\"9\" cy=\"20\" r=\"1\"/>\n<circle cx=\"23\" cy=\"12\" r=\"1\"/>\n<circle cx=\"16\" cy=\"16\" r=\"2\"/>\n<circle cx=\"9\" cy=\"5\" r=\"1\"/>\n<path d=\"M16,30C8.3,30,2,23.7,2,16c0-3.7,1.5-7.3,4.1-9.9l1.4,1.4C5.2,9.8,4,12.8,4,16c0,6.6,5.4,12,12,12c1.4,0,2.8-0.2,4.1-0.7\n\tl0.7,1.9C19.3,29.7,17.6,30,16,30z\"/>\n<path d=\"M25.9,25.9l-1.4-1.4c2.3-2.3,3.5-5.3,3.5-8.5c0-6.6-5.4-12-12-12c-1.4,0-2.8,0.2-4.1,0.7l-0.7-1.9C12.7,2.3,14.4,2,16,2\n\tc7.7,0,14,6.3,14,14C30,19.7,28.5,23.3,25.9,25.9z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z\"/><circle cx=\"23\" cy=\"27\" r=\"1\"/><circle cx=\"9\" cy=\"20\" r=\"1\"/><circle cx=\"23\" cy=\"12\" r=\"1\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><circle cx=\"9\" cy=\"5\" r=\"1\"/><path d=\"M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z\"/></svg>",
            "info": {},
            "path": "32/ibm--power-vs.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmPowerVs32",
          "filepath": "ibm--power-vs/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
                }
              }
            ],
            "name": "ibm--power-vs",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmPowerVs24",
          "filepath": "ibm--power-vs/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
                }
              }
            ],
            "name": "ibm--power-vs",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmPowerVs20",
          "filepath": "ibm--power-vs/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
                }
              }
            ],
            "name": "ibm--power-vs",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmPowerVs16",
          "filepath": "ibm--power-vs/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
                }
              }
            ],
            "name": "ibm--power-vs",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmPowerVs",
        "global": "IbmPowerVs",
        "filepath": "IbmPowerVs.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "27",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "12",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "5",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--telehealth",
      "friendlyName": "ibm--telehealth",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--telehealth.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"18 25 15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25\"/>\n  <path d=\"M22,30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8,0-5,2.2-5,5v5H2v-5c0-3.9,3.1-7,7-7h6c3.9,0,7,3.1,7,7v5Z\"/>\n  <path d=\"M28,5.2V3c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v6c0,1.1,.9,2,2,2h8c1.1,0,2-.9,2-2v-2.2l3,2.2V3l-3,2.2Zm-2,3.8h-8V3h8v6Z\"/>\n  <path d=\"M15.5,12.5c-.9,.9-2.1,1.5-3.5,1.5-2.8,0-5-2.2-5-5s2.2-5,5-5c.5,0,.9,.1,1.3,.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9,0-7,3.1-7,7s3.1,7,7,7c1.9,0,3.7-.8,5-2l-1.5-1.5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z\"/><path d=\"M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z\"/></svg>",
            "info": {},
            "path": "32/ibm--telehealth.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmTelehealth32",
          "filepath": "ibm--telehealth/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
                }
              }
            ],
            "name": "ibm--telehealth",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmTelehealth24",
          "filepath": "ibm--telehealth/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
                }
              }
            ],
            "name": "ibm--telehealth",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmTelehealth20",
          "filepath": "ibm--telehealth/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
                }
              }
            ],
            "name": "ibm--telehealth",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmTelehealth16",
          "filepath": "ibm--telehealth/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
                }
              }
            ],
            "name": "ibm--telehealth",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmTelehealth",
        "global": "IbmTelehealth",
        "filepath": "IbmTelehealth.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--tenet",
      "friendlyName": "ibm--tenet",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--tenet.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z\"/>\n  <path d=\"M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z\"/>\n  <circle cx=\"23\" cy=\"12\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"20\" r=\"1\"/>\n  <path d=\"M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z\"/>\n  <path d=\"M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z\"/><path d=\"M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z\"/><circle cx=\"23\" cy=\"12\" r=\"1\"/><circle cx=\"9\" cy=\"20\" r=\"1\"/><path d=\"M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z\"/><path d=\"M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z\"/></svg>",
            "info": {},
            "path": "32/ibm--tenet.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmTenet32",
          "filepath": "ibm--tenet/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "ibm--tenet",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmTenet24",
          "filepath": "ibm--tenet/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "ibm--tenet",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmTenet20",
          "filepath": "ibm--tenet/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "ibm--tenet",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmTenet16",
          "filepath": "ibm--tenet/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "ibm--tenet",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmTenet",
        "global": "IbmTenet",
        "filepath": "IbmTenet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "12",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm--toolchain",
      "friendlyName": "ibm--toolchain",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm--toolchain.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,21c-.7396,0-1.4241,.2155-2.0191,.5669l-2.0314-2.0314-1.4141,1.4141,2.0314,2.0314c-.3514,.595-.5668,1.2795-.5668,2.019,0,2.2056,1.7944,4,4,4,.3557,0,.6943-.0615,1.0228-.1492l-2.4368-2.4368,.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136,0-1.103,.897-2,2-2,.5515,0,1.0515,.2242,1.4136,.5864l.0004-.0005,2.4368,2.4368c.0875-.3284,.1491-.667,.1491-1.0227,0-2.2056-1.7944-4-4-4Z\"/>\n  <path d=\"M20.9495,12.4644l3.7645-3.7645c.3911,.1868,.8237,.3,1.2861,.3,1.6569,0,3-1.3431,3-3s-1.3431-3-3-3-3,1.3431-3,3c0,.4622,.1132,.8948,.2999,1.2859l-3.7645,3.7645,1.4141,1.4141Zm5.0505-7.4644c.5514,0,1,.4486,1,1s-.4486,1-1,1-1-.4486-1-1,.4486-1,1-1Z\"/>\n  <path d=\"M16,12c-2.2092,0-4,1.7908-4,4,0,.7405,.215,1.4254,.5657,2.0201l-5.2795,5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569,0-3,1.3431-3,3s1.3431,3,3,3,3-1.3431,3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948,.3507,1.2795,.5657,2.02,.5657,2.2091,0,4-1.7909,4-4s-1.7909-4-4-4ZM6,27c-.5514,0-1-.4486-1-1s.4486-1,1-1,1,.4486,1,1-.4486,1-1,1Zm10-9c-1.1028,0-2-.8972-2-2s.8972-2,2-2,2,.8972,2,2-.8972,2-2,2Z\"/>\n  <path d=\"M7,11c.7396,0,1.4241-.2155,2.0191-.5669l2.0311,2.0311,1.4141-1.4141-2.0311-2.0311c.3514-.595,.5668-1.2795,.5668-2.019,0-2.2056-1.7944-4-4-4-.3557,0-.6943,.0615-1.0228,.1492l2.4368,2.4368-.0004,.0005c.3621,.3621,.5864,.8621,.5864,1.4136,0,1.103-.897,2-2,2-.5515,0-1.0515-.2242-1.4136-.5864l-.0004,.0005-2.4368-2.4368c-.0875,.3284-.1491,.667-.1491,1.0227,0,2.2056,1.7944,4,4,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z\"/></svg>",
            "info": {},
            "path": "32/ibm--toolchain.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmToolchain32",
          "filepath": "ibm--toolchain/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
                }
              }
            ],
            "name": "ibm--toolchain",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmToolchain24",
          "filepath": "ibm--toolchain/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
                }
              }
            ],
            "name": "ibm--toolchain",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmToolchain20",
          "filepath": "ibm--toolchain/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
                }
              }
            ],
            "name": "ibm--toolchain",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmToolchain16",
          "filepath": "ibm--toolchain/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
                }
              }
            ],
            "name": "ibm--toolchain",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmToolchain",
        "global": "IbmToolchain",
        "filepath": "IbmToolchain.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud",
      "friendlyName": "IBM Cloud®",
      "aliases": [
        "product",
        "cloud",
        "hybrid",
        "service",
        "offering",
        "online",
        "internet",
        "brand",
        "smart rays",
        "IBM Cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ibm-cloud</title><path d=\"M24.5805,13.65A9.7327,9.7327,0,0,0,6.286,17.5387,6.75,6.75,0,0,0,7,31H23a8.7465,8.7465,0,0,0,1.5805-17.35ZM23,29.5H7a5.2373,5.2373,0,0,1-.6993-10.4293,9.7265,9.7265,0,0,0,1.1036,3.7838.75.75,0,1,0,1.3213-.709A8.25,8.25,0,0,1,22.752,13.5133a8.754,8.754,0,0,0-6.315,2.95.75.75,0,1,0,1.1245.9922A7.25,7.25,0,1,1,23,29.5Z\" transform=\"translate(0)\"/><path d=\"M31.8983,10.2548a.7582.7582,0,0,0-1.0364-.2776l-3.02,1.7438A.7587.7587,0,1,0,28.6,13.035l3.02-1.7438A.7589.7589,0,0,0,31.8983,10.2548Z\" transform=\"translate(0)\"/><path d=\"M22.6764,7.87a.7583.7583,0,0,0,1.0364-.2776l1.7438-3.02a.7587.7587,0,0,0-1.314-.7588l-1.7438,3.02A.7588.7588,0,0,0,22.6764,7.87Z\" transform=\"translate(0)\"/><path d=\"M16,6.0811a.759.759,0,0,0,.7588-.7588V1.8347a.7588.7588,0,1,0-1.5175,0V5.3223A.7589.7589,0,0,0,16,6.0811Z\" transform=\"translate(0)\"/><path d=\"M8.2873,7.5922a.7587.7587,0,0,0,1.314-.7588l-1.7438-3.02a.7587.7587,0,1,0-1.314.7588Z\" transform=\"translate(0)\"/><path d=\"M4.1585,11.721l-3.02-1.7438a.7587.7587,0,1,0-.7588,1.314L3.4,13.035a.7587.7587,0,1,0,.7588-1.314Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloud32",
          "filepath": "ibm-cloud/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
                }
              }
            ],
            "name": "ibm-cloud",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloud24",
          "filepath": "ibm-cloud/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
                }
              }
            ],
            "name": "ibm-cloud",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloud20",
          "filepath": "ibm-cloud/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
                }
              }
            ],
            "name": "ibm-cloud",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloud16",
          "filepath": "ibm-cloud/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
                }
              }
            ],
            "name": "ibm-cloud",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "IbmCloud",
        "global": "IbmCloud",
        "filepath": "IbmCloud.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--app-id",
      "friendlyName": "ibm-cloud--app-id",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--app-id.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,18h-6c-1.6569,0-3,1.3431-3,3v2h2v-2c0-.5523,.4477-1,1-1h6c.5523,0,1,.4477,1,1v2h2v-2c0-1.6569-1.3431-3-3-3Z\"/>\n  <path d=\"M17,17c2.2091,0,4-1.7909,4-4s-1.7909-4-4-4-4,1.7909-4,4,1.7909,4,4,4Zm0-6c1.1046,0,2,.8954,2,2s-.8954,2-2,2-2-.8954-2-2,.8954-2,2-2Z\"/>\n  <path d=\"M17,30c-7.7197,0-14-6.2804-14-14h2c0,6.6168,5.3831,12,12,12,5.2263,0,9.8162-3.3385,11.4214-8.3074l1.9033,.6147c-1.873,5.7975-7.2278,9.6926-13.3247,9.6926Z\"/>\n  <path d=\"M31,16h-2c0-6.6168-5.3833-12-12-12V2c7.7197,0,14,6.2804,14,14Z\"/>\n  <path d=\"M6,14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0,1.9229-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127ZM3,4v4.4678c0,1.1533,.6738,2.2178,1.7168,2.7109l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7109V4H3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z\"/><path d=\"M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--app-id.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudAppId32",
          "filepath": "ibm-cloud--app-id/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
                }
              }
            ],
            "name": "ibm-cloud--app-id",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudAppId24",
          "filepath": "ibm-cloud--app-id/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
                }
              }
            ],
            "name": "ibm-cloud--app-id",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudAppId20",
          "filepath": "ibm-cloud--app-id/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
                }
              }
            ],
            "name": "ibm-cloud--app-id",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudAppId16",
          "filepath": "ibm-cloud--app-id/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
                }
              }
            ],
            "name": "ibm-cloud--app-id",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudAppId",
        "global": "IbmCloudAppId",
        "filepath": "IbmCloudAppId.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--citrix-daas",
      "friendlyName": "ibm-cloud--citrix-daas",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--citrix-daas.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"19\" y=\"23\" width=\"4\" height=\"4\"/>\n<rect x=\"26\" y=\"23\" width=\"4\" height=\"4\"/>\n<rect x=\"19\" y=\"16\" width=\"4\" height=\"4\"/>\n<rect x=\"26\" y=\"16\" width=\"4\" height=\"4\"/>\n<path d=\"M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\n\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z\"/><path d=\"M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--citrix-daas.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudCitrixDaas32",
          "filepath": "ibm-cloud--citrix-daas/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud--citrix-daas",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudCitrixDaas24",
          "filepath": "ibm-cloud--citrix-daas/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud--citrix-daas",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudCitrixDaas20",
          "filepath": "ibm-cloud--citrix-daas/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud--citrix-daas",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudCitrixDaas16",
          "filepath": "ibm-cloud--citrix-daas/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud--citrix-daas",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudCitrixDaas",
        "global": "IbmCloudCitrixDaas",
        "filepath": "IbmCloudCitrixDaas.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5 L9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--continuous-delivery",
      "friendlyName": "ibm-cloud--continuous-delivery",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--continuous-delivery.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z\"/>\n  <path d=\"M18.5,19h-5c-.8271,0-1.5-.6729-1.5-1.5v-5c0-.8271,.6729-1.5,1.5-1.5h5c.8271,0,1.5,.6729,1.5,1.5v5c0,.8271-.6729,1.5-1.5,1.5Zm-4.5-2h4v-4h-4v4Z\"/>\n  <path d=\"M16,31v-2c7.1682,0,13-5.8318,13-13,0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124,1.3855,.6213,2.8273,.6213,4.2853,0,8.271-6.729,15-15,15Z\"/>\n  <path d=\"M1.6213,20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1,7.729,7.729,1,16,1V3c-7.1682,0-13,5.8318-13,13,0,1.2648,.1812,2.5145,.5383,3.7147l-1.917,.5706Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z\"/><path d=\"M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--continuous-delivery.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudContinuousDelivery32",
          "filepath": "ibm-cloud--continuous-delivery/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
                }
              }
            ],
            "name": "ibm-cloud--continuous-delivery",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudContinuousDelivery24",
          "filepath": "ibm-cloud--continuous-delivery/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
                }
              }
            ],
            "name": "ibm-cloud--continuous-delivery",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudContinuousDelivery20",
          "filepath": "ibm-cloud--continuous-delivery/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
                }
              }
            ],
            "name": "ibm-cloud--continuous-delivery",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudContinuousDelivery16",
          "filepath": "ibm-cloud--continuous-delivery/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
                }
              }
            ],
            "name": "ibm-cloud--continuous-delivery",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudContinuousDelivery",
        "global": "IbmCloudContinuousDelivery",
        "filepath": "IbmCloudContinuousDelivery.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--dedicated-host",
      "friendlyName": "IBM Cloud® Dedicated Host",
      "aliases": [
        "product",
        "cloud",
        "hybrid",
        "IBM Cloud®",
        "dedicated",
        "host",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--dedicated-host.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"9\" cy=\"6\" r=\"1\"/>\n  <path d=\"M26,2H6A2,2,0,0,0,4,4V8a2,2,0,0,0,2,2h9v4h2V10h9a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,6H6V4H26Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"17 28 17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28\"/>\n  <circle id=\"machine\" cx=\"9\" cy=\"20\" r=\"1\"/>\n  <path id=\"dedicated_host\" data-name=\"dedicated host\" d=\"M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"6\" r=\"1\"/><path d=\"M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z\"/><circle cx=\"9\" cy=\"20\" r=\"1\"/><path d=\"M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--dedicated-host.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDedicatedHost32",
          "filepath": "ibm-cloud--dedicated-host/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
                }
              }
            ],
            "name": "ibm-cloud--dedicated-host",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDedicatedHost24",
          "filepath": "ibm-cloud--dedicated-host/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
                }
              }
            ],
            "name": "ibm-cloud--dedicated-host",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDedicatedHost20",
          "filepath": "ibm-cloud--dedicated-host/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
                }
              }
            ],
            "name": "ibm-cloud--dedicated-host",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDedicatedHost16",
          "filepath": "ibm-cloud--dedicated-host/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "6",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "20",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
                }
              }
            ],
            "name": "ibm-cloud--dedicated-host",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDedicatedHost",
        "global": "IbmCloudDedicatedHost",
        "filepath": "IbmCloudDedicatedHost.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "6",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--direct-link-1--connect",
      "friendlyName": "ibm-cloud--direct-link-1--connect",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--direct-link-1--connect.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/>\n<path d=\"M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\n\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\n\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z\"/>\n<path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/><path d=\"M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z\"/><path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--direct-link-1--connect.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDirectLink_1Connect32",
          "filepath": "ibm-cloud--direct-link-1--connect/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--connect",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDirectLink_1Connect24",
          "filepath": "ibm-cloud--direct-link-1--connect/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--connect",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDirectLink_1Connect20",
          "filepath": "ibm-cloud--direct-link-1--connect/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--connect",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDirectLink_1Connect16",
          "filepath": "ibm-cloud--direct-link-1--connect/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--connect",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDirectLink_1Connect",
        "global": "IbmCloudDirectLink_1Connect",
        "filepath": "IbmCloudDirectLink_1Connect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3 l4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12 z M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--direct-link-1--dedicated",
      "friendlyName": "ibm-cloud--direct-link-1--dedicated",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--direct-link-1--dedicated.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/>\n<path d=\"M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z\"/>\n<path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/><path d=\"M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z\"/><path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--direct-link-1--dedicated.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDirectLink_1Dedicated32",
          "filepath": "ibm-cloud--direct-link-1--dedicated/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDirectLink_1Dedicated24",
          "filepath": "ibm-cloud--direct-link-1--dedicated/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDirectLink_1Dedicated20",
          "filepath": "ibm-cloud--direct-link-1--dedicated/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDirectLink_1Dedicated16",
          "filepath": "ibm-cloud--direct-link-1--dedicated/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDirectLink_1Dedicated",
        "global": "IbmCloudDirectLink_1Dedicated",
        "filepath": "IbmCloudDirectLink_1Dedicated.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--direct-link-1--dedicated-hosting",
      "friendlyName": "ibm-cloud--direct-link-1--dedicated-hosting",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--direct-link-1--dedicated-hosting.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/>\n<rect x=\"11\" y=\"19\" width=\"10\" height=\"2\"/>\n<rect x=\"11\" y=\"15\" width=\"10\" height=\"2\"/>\n<rect x=\"11\" y=\"11\" width=\"10\" height=\"2\"/>\n<path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/><path d=\"M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z\"/><path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--direct-link-1--dedicated-hosting.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDirectLink_1DedicatedHosting32",
          "filepath": "ibm-cloud--direct-link-1--dedicated-hosting/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated-hosting",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDirectLink_1DedicatedHosting24",
          "filepath": "ibm-cloud--direct-link-1--dedicated-hosting/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated-hosting",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDirectLink_1DedicatedHosting20",
          "filepath": "ibm-cloud--direct-link-1--dedicated-hosting/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated-hosting",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDirectLink_1DedicatedHosting16",
          "filepath": "ibm-cloud--direct-link-1--dedicated-hosting/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--dedicated-hosting",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDirectLink_1DedicatedHosting",
        "global": "IbmCloudDirectLink_1DedicatedHosting",
        "filepath": "IbmCloudDirectLink_1DedicatedHosting.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--direct-link-1--exchange",
      "friendlyName": "ibm-cloud--direct-link-1--exchange",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--direct-link-1--exchange.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/>\n<polygon points=\"19,15 19,19 15,19 15,21 21,21 21,15 \"/>\n<polygon points=\"17,11 11,11 11,17 13,17 13,13 17,13 \"/>\n<path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z\"/><path d=\"M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z\"/><path d=\"M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--direct-link-1--exchange.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDirectLink_1Exchange32",
          "filepath": "ibm-cloud--direct-link-1--exchange/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--exchange",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDirectLink_1Exchange24",
          "filepath": "ibm-cloud--direct-link-1--exchange/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--exchange",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDirectLink_1Exchange20",
          "filepath": "ibm-cloud--direct-link-1--exchange/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--exchange",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDirectLink_1Exchange16",
          "filepath": "ibm-cloud--direct-link-1--exchange/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-1--exchange",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDirectLink_1Exchange",
        "global": "IbmCloudDirectLink_1Exchange",
        "filepath": "IbmCloudDirectLink_1Exchange.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--direct-link-2--connect",
      "friendlyName": "ibm-cloud--direct-link-2--connect",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--direct-link-2--connect.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\n\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z\"/>\n<path d=\"M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\n\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z\"/><path d=\"M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--direct-link-2--connect.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDirectLink_2Connect32",
          "filepath": "ibm-cloud--direct-link-2--connect/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--connect",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDirectLink_2Connect24",
          "filepath": "ibm-cloud--direct-link-2--connect/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--connect",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDirectLink_2Connect20",
          "filepath": "ibm-cloud--direct-link-2--connect/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--connect",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDirectLink_2Connect16",
          "filepath": "ibm-cloud--direct-link-2--connect/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--connect",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDirectLink_2Connect",
        "global": "IbmCloudDirectLink_2Connect",
        "filepath": "IbmCloudDirectLink_2Connect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6 c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3 c1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--direct-link-2--dedicated",
      "friendlyName": "ibm-cloud--direct-link-2--dedicated",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--direct-link-2--dedicated.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z\"/>\n<path d=\"M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z\"/><path d=\"M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--direct-link-2--dedicated.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDirectLink_2Dedicated32",
          "filepath": "ibm-cloud--direct-link-2--dedicated/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDirectLink_2Dedicated24",
          "filepath": "ibm-cloud--direct-link-2--dedicated/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDirectLink_2Dedicated20",
          "filepath": "ibm-cloud--direct-link-2--dedicated/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDirectLink_2Dedicated16",
          "filepath": "ibm-cloud--direct-link-2--dedicated/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDirectLink_2Dedicated",
        "global": "IbmCloudDirectLink_2Dedicated",
        "filepath": "IbmCloudDirectLink_2Dedicated.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--direct-link-2--dedicated-hosting",
      "friendlyName": "ibm-cloud--direct-link-2--dedicated-hosting",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--direct-link-2--dedicated-hosting.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z\"/>\n<rect x=\"11\" y=\"19\" width=\"10\" height=\"2\"/>\n<rect x=\"11\" y=\"15\" width=\"10\" height=\"2\"/>\n<rect x=\"11\" y=\"11\" width=\"10\" height=\"2\"/>\n<path d=\"M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z\"/><path d=\"M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z\"/><path d=\"M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--direct-link-2--dedicated-hosting.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudDirectLink_2DedicatedHosting32",
          "filepath": "ibm-cloud--direct-link-2--dedicated-hosting/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated-hosting",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudDirectLink_2DedicatedHosting24",
          "filepath": "ibm-cloud--direct-link-2--dedicated-hosting/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated-hosting",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudDirectLink_2DedicatedHosting20",
          "filepath": "ibm-cloud--direct-link-2--dedicated-hosting/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated-hosting",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudDirectLink_2DedicatedHosting16",
          "filepath": "ibm-cloud--direct-link-2--dedicated-hosting/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
                }
              }
            ],
            "name": "ibm-cloud--direct-link-2--dedicated-hosting",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudDirectLink_2DedicatedHosting",
        "global": "IbmCloudDirectLink_2DedicatedHosting",
        "filepath": "IbmCloudDirectLink_2DedicatedHosting.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--event-notification",
      "friendlyName": "ibm-cloud--event-notification",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--event-notification.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\n\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\n\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\n\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\n\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\n\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\n\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z\n\t M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\n\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--event-notification.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudEventNotification32",
          "filepath": "ibm-cloud--event-notification/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
                }
              }
            ],
            "name": "ibm-cloud--event-notification",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudEventNotification24",
          "filepath": "ibm-cloud--event-notification/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
                }
              }
            ],
            "name": "ibm-cloud--event-notification",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudEventNotification20",
          "filepath": "ibm-cloud--event-notification/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
                }
              }
            ],
            "name": "ibm-cloud--event-notification",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudEventNotification16",
          "filepath": "ibm-cloud--event-notification/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
                }
              }
            ],
            "name": "ibm-cloud--event-notification",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudEventNotification",
        "global": "IbmCloudEventNotification",
        "filepath": "IbmCloudEventNotification.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7 c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8 C10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8 c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23 c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6 c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6 c0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23 c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--event-streams",
      "friendlyName": "ibm-cloud--event-streams",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--event-streams.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\n\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z\"/>\n<path d=\"M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\n\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\n\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\n\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\n\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z\"\n\t/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z\"/><path d=\"M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--event-streams.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudEventStreams32",
          "filepath": "ibm-cloud--event-streams/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
                }
              }
            ],
            "name": "ibm-cloud--event-streams",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudEventStreams24",
          "filepath": "ibm-cloud--event-streams/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
                }
              }
            ],
            "name": "ibm-cloud--event-streams",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudEventStreams20",
          "filepath": "ibm-cloud--event-streams/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
                }
              }
            ],
            "name": "ibm-cloud--event-streams",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudEventStreams16",
          "filepath": "ibm-cloud--event-streams/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
                }
              }
            ],
            "name": "ibm-cloud--event-streams",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudEventStreams",
        "global": "IbmCloudEventStreams",
        "filepath": "IbmCloudEventStreams.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6 V29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3 C11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8 c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4 C23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1 S9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--for-education",
      "friendlyName": "ibm-cloud--for-education",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--for-education.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543,0-3,1.3458-3,3h-2c0-2.757,2.2429-5,5-5h4c2.7571,0,5,2.243,5,5Z\"/>\n  <path d=\"M15,16c-.5522,0-1,.4478-1,1v6h2v-6c0-.5522-.4478-1-1-1Z\"/>\n  <path d=\"M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z\"/>\n  <path d=\"M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z\"/><path d=\"M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z\"/><path d=\"M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--for-education.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudForEducation32",
          "filepath": "ibm-cloud--for-education/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
                }
              }
            ],
            "name": "ibm-cloud--for-education",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudForEducation24",
          "filepath": "ibm-cloud--for-education/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
                }
              }
            ],
            "name": "ibm-cloud--for-education",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudForEducation20",
          "filepath": "ibm-cloud--for-education/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
                }
              }
            ],
            "name": "ibm-cloud--for-education",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudForEducation16",
          "filepath": "ibm-cloud--for-education/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
                }
              }
            ],
            "name": "ibm-cloud--for-education",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudForEducation",
        "global": "IbmCloudForEducation",
        "filepath": "IbmCloudForEducation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--HSM",
      "friendlyName": "ibm-cloud--HSM",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--HSM.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z\"/>\n  <circle cx=\"9\" cy=\"24\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"8\" r=\"1\"/>\n  <path d=\"M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z\"/><circle cx=\"9\" cy=\"24\" r=\"1\"/><circle cx=\"9\" cy=\"8\" r=\"1\"/><path d=\"M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--HSM.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudHsm32",
          "filepath": "ibm-cloud--HSM/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
                }
              }
            ],
            "name": "ibm-cloud--HSM",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudHsm24",
          "filepath": "ibm-cloud--HSM/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
                }
              }
            ],
            "name": "ibm-cloud--HSM",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudHsm20",
          "filepath": "ibm-cloud--HSM/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
                }
              }
            ],
            "name": "ibm-cloud--HSM",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudHsm16",
          "filepath": "ibm-cloud--HSM/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "24",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
                }
              }
            ],
            "name": "ibm-cloud--HSM",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudHsm",
        "global": "IbmCloudHsm",
        "filepath": "IbmCloudHsm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "24",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--hyper-protect-crypto-services",
      "friendlyName": "ibm-cloud--hyper-protect-crypto-services",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--hyper-protect-crypto-services.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\n\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z\"/>\n<circle cx=\"22\" cy=\"10\" r=\"2\"/>\n<path d=\"M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\n\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\n\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z\"/><circle cx=\"22\" cy=\"10\" r=\"2\"/><path d=\"M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--hyper-protect-crypto-services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudHyperProtectCryptoServices32",
          "filepath": "ibm-cloud--hyper-protect-crypto-services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-crypto-services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudHyperProtectCryptoServices24",
          "filepath": "ibm-cloud--hyper-protect-crypto-services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-crypto-services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudHyperProtectCryptoServices20",
          "filepath": "ibm-cloud--hyper-protect-crypto-services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-crypto-services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudHyperProtectCryptoServices16",
          "filepath": "ibm-cloud--hyper-protect-crypto-services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-crypto-services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudHyperProtectCryptoServices",
        "global": "IbmCloudHyperProtectCryptoServices",
        "filepath": "IbmCloudHyperProtectCryptoServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "10",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23 L8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3 c0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--hyper-protect-dbaas",
      "friendlyName": "ibm-cloud--hyper-protect-dbaas",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--hyper-protect-dbaas.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\n\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z\"/>\n<circle cx=\"10\" cy=\"23\" r=\"1\"/>\n<circle cx=\"10\" cy=\"15\" r=\"1\"/>\n<circle cx=\"10\" cy=\"7\" r=\"1\"/>\n<path d=\"M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z\"/><circle cx=\"10\" cy=\"23\" r=\"1\"/><circle cx=\"10\" cy=\"15\" r=\"1\"/><circle cx=\"10\" cy=\"7\" r=\"1\"/><path d=\"M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--hyper-protect-dbaas.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudHyperProtectDbaas32",
          "filepath": "ibm-cloud--hyper-protect-dbaas/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-dbaas",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudHyperProtectDbaas24",
          "filepath": "ibm-cloud--hyper-protect-dbaas/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-dbaas",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudHyperProtectDbaas20",
          "filepath": "ibm-cloud--hyper-protect-dbaas/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-dbaas",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudHyperProtectDbaas16",
          "filepath": "ibm-cloud--hyper-protect-dbaas/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-dbaas",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudHyperProtectDbaas",
        "global": "IbmCloudHyperProtectDbaas",
        "filepath": "IbmCloudHyperProtectDbaas.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "15",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--hyper-protect-vs",
      "friendlyName": "ibm-cloud--hyper-protect-vs",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--hyper-protect-vs.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\n\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z\"/>\n<path d=\"M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\n\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z\"/><path d=\"M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--hyper-protect-vs.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudHyperProtectVs32",
          "filepath": "ibm-cloud--hyper-protect-vs/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-vs",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudHyperProtectVs24",
          "filepath": "ibm-cloud--hyper-protect-vs/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-vs",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudHyperProtectVs20",
          "filepath": "ibm-cloud--hyper-protect-vs/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-vs",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudHyperProtectVs16",
          "filepath": "ibm-cloud--hyper-protect-vs/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
                }
              }
            ],
            "name": "ibm-cloud--hyper-protect-vs",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudHyperProtectVs",
        "global": "IbmCloudHyperProtectVs",
        "filepath": "IbmCloudHyperProtectVs.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8 l-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26 l8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--internet-services",
      "friendlyName": "IBM Cloud® Internet Services",
      "aliases": [
        "services",
        "cloud",
        "hybrid",
        "IBM Cloud®",
        "internet",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--internet-services.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\n\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\n\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\n\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\n\ts1,0.4,1,1S27.6,26,27,26z\"/>\n<path d=\"M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\n\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\n\tC1,23.6,4.3,27,8.5,27H19V25z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z\"/><path d=\"M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--internet-services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudInternetServices32",
          "filepath": "ibm-cloud--internet-services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
                }
              }
            ],
            "name": "ibm-cloud--internet-services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudInternetServices24",
          "filepath": "ibm-cloud--internet-services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
                }
              }
            ],
            "name": "ibm-cloud--internet-services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudInternetServices20",
          "filepath": "ibm-cloud--internet-services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
                }
              }
            ],
            "name": "ibm-cloud--internet-services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudInternetServices16",
          "filepath": "ibm-cloud--internet-services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
                }
              }
            ],
            "name": "ibm-cloud--internet-services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudInternetServices",
        "global": "IbmCloudInternetServices",
        "filepath": "IbmCloudInternetServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7 c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3 c0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1 s-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,26,27,26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1 c1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5 C1,23.6,4.3,27,8.5,27H19V25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--ipsec-vpn",
      "friendlyName": "ibm-cloud--ipsec-vpn",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--ipsec-vpn.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,29c-.373,0-.7151-.2076-.8872-.5386l-2.0801-4,1.7744-.9229,1.1929,2.2939,4.3127-8.2938,1.7744,.9226-5.2,10c-.1721,.3311-.5142,.5387-.8872,.5387Z\"/>\n  <path d=\"M11,15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4,1.7944-4,4v2.2783c-.595,.3467-1,.9849-1,1.7217v5c0,1.1025,.897,2,2,2h6c1.103,0,2-.8975,2-2v-5c0-.7368-.405-1.375-1-1.7217Zm-4-4.2783c1.103,0,2,.8975,2,2v2H5v-2c0-1.1025,.897-2,2-2Zm3,11H4v-5h6v5Z\"/>\n  <path d=\"M29,2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045,0-2,.8955-2,2s.8955,2,2,2c.7385,0,1.3762-.4048,1.7227-1h7.6304l-4.1697,8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872,3.4614c.02-.0439,.1128-.2104,.1128-.4614,0-.5522-.4478-1-1-1Z\"/>\n  <path d=\"M3,2c-.5522,0-1,.4478-1,1,0,.2509,.0929,.4177,.1128,.4614l1.8401,3.5386h2.2542l-1.5601-3H14V2H3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--ipsec-vpn.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudIpsecVpn32",
          "filepath": "ibm-cloud--ipsec-vpn/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
                }
              }
            ],
            "name": "ibm-cloud--ipsec-vpn",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudIpsecVpn24",
          "filepath": "ibm-cloud--ipsec-vpn/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
                }
              }
            ],
            "name": "ibm-cloud--ipsec-vpn",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudIpsecVpn20",
          "filepath": "ibm-cloud--ipsec-vpn/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
                }
              }
            ],
            "name": "ibm-cloud--ipsec-vpn",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudIpsecVpn16",
          "filepath": "ibm-cloud--ipsec-vpn/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
                }
              }
            ],
            "name": "ibm-cloud--ipsec-vpn",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudIpsecVpn",
        "global": "IbmCloudIpsecVpn",
        "filepath": "IbmCloudIpsecVpn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--key-protect",
      "friendlyName": "ibm-cloud--key-protect",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--key-protect.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\n\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z\"/>\n<path d=\"M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\n\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z\"/><path d=\"M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--key-protect.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudKeyProtect32",
          "filepath": "ibm-cloud--key-protect/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
                }
              }
            ],
            "name": "ibm-cloud--key-protect",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudKeyProtect24",
          "filepath": "ibm-cloud--key-protect/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
                }
              }
            ],
            "name": "ibm-cloud--key-protect",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudKeyProtect20",
          "filepath": "ibm-cloud--key-protect/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
                }
              }
            ],
            "name": "ibm-cloud--key-protect",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudKeyProtect16",
          "filepath": "ibm-cloud--key-protect/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
                }
              }
            ],
            "name": "ibm-cloud--key-protect",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudKeyProtect",
        "global": "IbmCloudKeyProtect",
        "filepath": "IbmCloudKeyProtect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20 c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7 c1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--kubernetes-service",
      "friendlyName": "IBM Cloud® Kubernetes Service",
      "aliases": [
        "services",
        "cloud",
        "hybrid",
        "IBM Cloud®",
        "Kubernetes"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--kubernetes-service.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\n\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\n\tl-4-2.4l-4,2.4V18.4z\"/>\n<path d=\"M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\n\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z\"/><path d=\"M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--kubernetes-service.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudKubernetesService32",
          "filepath": "ibm-cloud--kubernetes-service/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                }
              }
            ],
            "name": "ibm-cloud--kubernetes-service",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudKubernetesService24",
          "filepath": "ibm-cloud--kubernetes-service/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                }
              }
            ],
            "name": "ibm-cloud--kubernetes-service",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudKubernetesService20",
          "filepath": "ibm-cloud--kubernetes-service/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                }
              }
            ],
            "name": "ibm-cloud--kubernetes-service",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudKubernetesService16",
          "filepath": "ibm-cloud--kubernetes-service/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                }
              }
            ],
            "name": "ibm-cloud--kubernetes-service",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudKubernetesService",
        "global": "IbmCloudKubernetesService",
        "filepath": "IbmCloudKubernetesService.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9 c0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9 l-4-2.4l-4,2.4V18.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1 c0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--logging",
      "friendlyName": "ibm-cloud--logging",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--logging.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\n\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z\"/>\n<rect x=\"16\" y=\"6\" width=\"8\" height=\"2\"/>\n<rect x=\"16\" y=\"2\" width=\"8\" height=\"2\"/>\n<path d=\"M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z\"\n\t/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z\"/><path d=\"M16 6H24V8H16zM16 2H24V4H16z\"/><path d=\"M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--logging.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudLogging32",
          "filepath": "ibm-cloud--logging/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H24V8H16zM16 2H24V4H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--logging",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudLogging24",
          "filepath": "ibm-cloud--logging/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H24V8H16zM16 2H24V4H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--logging",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudLogging20",
          "filepath": "ibm-cloud--logging/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H24V8H16zM16 2H24V4H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--logging",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudLogging16",
          "filepath": "ibm-cloud--logging/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H24V8H16zM16 2H24V4H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--logging",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudLogging",
        "global": "IbmCloudLogging",
        "filepath": "IbmCloudLogging.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1 c-1.3-0.6-2.2-1.7-2.6-3H24.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 6H24V8H16zM16 2H24V4H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--mass-data-migration",
      "friendlyName": "ibm-cloud--mass-data-migration",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--mass-data-migration.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M22,30H10c-1.1,0-2-0.9-2-2v-3h2v3h12v-3h2v3C24,29.1,23.1,30,22,30z\"/>\n<polygon points=\"15,14.8 15,25 17,25 17,14.8 19.6,17.4 21,16 16,11 11,16 12.4,17.4 \"/>\n<path d=\"M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\n\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\n\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z\"/><path d=\"M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--mass-data-migration.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudMassDataMigration32",
          "filepath": "ibm-cloud--mass-data-migration/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-cloud--mass-data-migration",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudMassDataMigration24",
          "filepath": "ibm-cloud--mass-data-migration/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-cloud--mass-data-migration",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudMassDataMigration20",
          "filepath": "ibm-cloud--mass-data-migration/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-cloud--mass-data-migration",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudMassDataMigration16",
          "filepath": "ibm-cloud--mass-data-migration/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-cloud--mass-data-migration",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudMassDataMigration",
        "global": "IbmCloudMassDataMigration",
        "filepath": "IbmCloudMassDataMigration.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--pal",
      "friendlyName": "ibm-cloud--pal",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--pal.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5\n\tC23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8\n\tl5-3l5,3V24.9z\"/>\n<path d=\"M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\n\tc-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5\tC23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8\tl5-3l5,3V24.9z\"/><path d=\"M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--pal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPal32",
          "filepath": "ibm-cloud--pal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5\tC23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8\tl5-3l5,3V24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z"
                }
              }
            ],
            "name": "ibm-cloud--pal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPal24",
          "filepath": "ibm-cloud--pal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5\tC23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8\tl5-3l5,3V24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z"
                }
              }
            ],
            "name": "ibm-cloud--pal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPal20",
          "filepath": "ibm-cloud--pal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5\tC23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8\tl5-3l5,3V24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z"
                }
              }
            ],
            "name": "ibm-cloud--pal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPal16",
          "filepath": "ibm-cloud--pal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5\tC23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8\tl5-3l5,3V24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z"
                }
              }
            ],
            "name": "ibm-cloud--pal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPal",
        "global": "IbmCloudPal",
        "filepath": "IbmCloudPal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5 C23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8 l5-3l5,3V24.9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8 c-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--privileged-access-gateway",
      "friendlyName": "ibm-cloud--privileged-access-gateway",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--privileged-access-gateway.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"32,23 27,28 25.6,26.6 28.2,24 20,24 20,22 28.2,22 25.6,19.4 27,18 \"/>\n<path d=\"M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\n\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\n\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\n\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\n\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z\"/><path d=\"M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--privileged-access-gateway.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPrivilegedAccessGateway32",
          "filepath": "ibm-cloud--privileged-access-gateway/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
                }
              }
            ],
            "name": "ibm-cloud--privileged-access-gateway",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPrivilegedAccessGateway24",
          "filepath": "ibm-cloud--privileged-access-gateway/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
                }
              }
            ],
            "name": "ibm-cloud--privileged-access-gateway",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPrivilegedAccessGateway20",
          "filepath": "ibm-cloud--privileged-access-gateway/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
                }
              }
            ],
            "name": "ibm-cloud--privileged-access-gateway",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPrivilegedAccessGateway16",
          "filepath": "ibm-cloud--privileged-access-gateway/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
                }
              }
            ],
            "name": "ibm-cloud--privileged-access-gateway",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPrivilegedAccessGateway",
        "global": "IbmCloudPrivilegedAccessGateway",
        "filepath": "IbmCloudPrivilegedAccessGateway.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4 H8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3 v4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4 C26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7 c-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--secrets-manager",
      "friendlyName": "ibm-cloud--secrets-manager",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--secrets-manager.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\n\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\n\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z\"/>\n<path d=\"M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\n\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z\"/><path d=\"M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--secrets-manager.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudSecretsManager32",
          "filepath": "ibm-cloud--secrets-manager/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
                }
              }
            ],
            "name": "ibm-cloud--secrets-manager",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudSecretsManager24",
          "filepath": "ibm-cloud--secrets-manager/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
                }
              }
            ],
            "name": "ibm-cloud--secrets-manager",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudSecretsManager20",
          "filepath": "ibm-cloud--secrets-manager/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
                }
              }
            ],
            "name": "ibm-cloud--secrets-manager",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudSecretsManager16",
          "filepath": "ibm-cloud--secrets-manager/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
                }
              }
            ],
            "name": "ibm-cloud--secrets-manager",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudSecretsManager",
        "global": "IbmCloudSecretsManager",
        "filepath": "IbmCloudSecretsManager.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4 l3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3 l1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6 C9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--security-compliance-center",
      "friendlyName": "IBM Cloud® Security and Compliance Center",
      "aliases": [
        "IBM Cloud®",
        "security",
        "compliance",
        "center",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--security-compliance-center.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path id=\"_x3C_Path_x3E__00000043425793413296290420000018093581292944339895_\" d=\"M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\n\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z\"/>\n<path d=\"M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\n\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z\"/><path d=\"M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--security-compliance-center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudSecurityComplianceCenter32",
          "filepath": "ibm-cloud--security-compliance-center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
                }
              }
            ],
            "name": "ibm-cloud--security-compliance-center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudSecurityComplianceCenter24",
          "filepath": "ibm-cloud--security-compliance-center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
                }
              }
            ],
            "name": "ibm-cloud--security-compliance-center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudSecurityComplianceCenter20",
          "filepath": "ibm-cloud--security-compliance-center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
                }
              }
            ],
            "name": "ibm-cloud--security-compliance-center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudSecurityComplianceCenter16",
          "filepath": "ibm-cloud--security-compliance-center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
                }
              }
            ],
            "name": "ibm-cloud--security-compliance-center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudSecurityComplianceCenter",
        "global": "IbmCloudSecurityComplianceCenter",
        "filepath": "IbmCloudSecurityComplianceCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8 L24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8 c-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--subnets",
      "friendlyName": "IBM Cloud® subnets",
      "aliases": [
        "subnets",
        "cloud",
        "hybrid",
        "IBM Cloud®",
        "internet",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--subnets.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #1c1c1c;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--subnets.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudSubnets32",
          "filepath": "ibm-cloud--subnets/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
                }
              }
            ],
            "name": "ibm-cloud--subnets",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudSubnets24",
          "filepath": "ibm-cloud--subnets/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
                }
              }
            ],
            "name": "ibm-cloud--subnets",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudSubnets20",
          "filepath": "ibm-cloud--subnets/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
                }
              }
            ],
            "name": "ibm-cloud--subnets",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudSubnets16",
          "filepath": "ibm-cloud--subnets/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
                }
              }
            ],
            "name": "ibm-cloud--subnets",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudSubnets",
        "global": "IbmCloudSubnets",
        "filepath": "IbmCloudSubnets.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--sysdig-secure",
      "friendlyName": "ibm-cloud--sysdig-secure",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--sysdig-secure.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\n\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z\"/>\n<path d=\"M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z\"\n\t/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z\"/><path d=\"M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--sysdig-secure.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudSysdigSecure32",
          "filepath": "ibm-cloud--sysdig-secure/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--sysdig-secure",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudSysdigSecure24",
          "filepath": "ibm-cloud--sysdig-secure/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--sysdig-secure",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudSysdigSecure20",
          "filepath": "ibm-cloud--sysdig-secure/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--sysdig-secure",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudSysdigSecure16",
          "filepath": "ibm-cloud--sysdig-secure/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                }
              }
            ],
            "name": "ibm-cloud--sysdig-secure",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudSysdigSecure",
        "global": "IbmCloudSysdigSecure",
        "filepath": "IbmCloudSysdigSecure.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--transit-gateway",
      "friendlyName": "IBM Cloud® Transit Gateway",
      "aliases": [
        "IBM Cloud®",
        "transit",
        "gateway"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--transit-gateway.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--transit-gateway.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudTransitGateway32",
          "filepath": "ibm-cloud--transit-gateway/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z"
                }
              }
            ],
            "name": "ibm-cloud--transit-gateway",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudTransitGateway24",
          "filepath": "ibm-cloud--transit-gateway/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z"
                }
              }
            ],
            "name": "ibm-cloud--transit-gateway",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudTransitGateway20",
          "filepath": "ibm-cloud--transit-gateway/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z"
                }
              }
            ],
            "name": "ibm-cloud--transit-gateway",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudTransitGateway16",
          "filepath": "ibm-cloud--transit-gateway/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z"
                }
              }
            ],
            "name": "ibm-cloud--transit-gateway",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudTransitGateway",
        "global": "IbmCloudTransitGateway",
        "filepath": "IbmCloudTransitGateway.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud--vpc-endpoints",
      "friendlyName": "IBM Cloud® VPC endpoints",
      "aliases": [
        "virtual private cloud",
        "VPC",
        "endpoints",
        "cloud",
        "hybrid",
        "IBM Cloud®",
        "internet",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud--vpc-endpoints.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_Path_\" data-name=\"&lt;Path&gt;\" d=\"M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z\" transform=\"translate(0 0)\"/>\n  <path id=\"_Compound_Path_\" data-name=\"&lt;Compound Path&gt;\" d=\"M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z\" transform=\"translate(0 0)\"/>\n  <path id=\"_Path_2\" data-name=\"&lt;Path&gt;\" d=\"M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z\"/><path d=\"M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z\"/><path d=\"M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud--vpc-endpoints.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudVpcEndpoints32",
          "filepath": "ibm-cloud--vpc-endpoints/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
                }
              }
            ],
            "name": "ibm-cloud--vpc-endpoints",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudVpcEndpoints24",
          "filepath": "ibm-cloud--vpc-endpoints/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
                }
              }
            ],
            "name": "ibm-cloud--vpc-endpoints",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudVpcEndpoints20",
          "filepath": "ibm-cloud--vpc-endpoints/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
                }
              }
            ],
            "name": "ibm-cloud--vpc-endpoints",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudVpcEndpoints16",
          "filepath": "ibm-cloud--vpc-endpoints/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
                }
              }
            ],
            "name": "ibm-cloud--vpc-endpoints",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudVpcEndpoints",
        "global": "IbmCloudVpcEndpoints",
        "filepath": "IbmCloudVpcEndpoints.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--applications",
      "friendlyName": "IBM Cloud Pak® for Applications",
      "aliases": [
        "enterprise",
        "app",
        "applications",
        "IBM Cloud Pak®",
        "cloud",
        "hybrid",
        "internet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--applications.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z\"/>\n  <path d=\"M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z\"/><path d=\"M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--applications.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakApplications32",
          "filepath": "ibm-cloud-pak--applications/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--applications",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakApplications24",
          "filepath": "ibm-cloud-pak--applications/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--applications",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakApplications20",
          "filepath": "ibm-cloud-pak--applications/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--applications",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakApplications16",
          "filepath": "ibm-cloud-pak--applications/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--applications",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakApplications",
        "global": "IbmCloudPakApplications",
        "filepath": "IbmCloudPakApplications.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--business-automation",
      "friendlyName": "IBM Cloud Pak® for Business Automation",
      "aliases": [
        "enterprise",
        "app",
        "automation",
        "IBM Cloud Pak®",
        "cloud",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--business-automation.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<path d=\"M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3\n\t\t\tc0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1\n\t\t\tc0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1\n\t\t\tS12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4\n\t\t\tC11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16\n\t\t\ts0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z\"/>\n\t\t<path d=\"M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7\n\t\t\tL16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBY7JkEnv1FnwwrwNZQCm1kKtwUaAjZRvTY5iksgstb21qRfCal5Mre1mH3p+NVFMUZiqID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\n\t]]>\n\t<![CDATA[\n\tEIBRgQQMLkyogAMHBwoCMCjQYAIFCgzDAggWKFRQBGBUYKFCgwMHhwqJaVRAocIEDSxIuMCDXADC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\n\t]]>\n\t<![CDATA[\n\tzhjvcFDRTJ59chz4q6uebnfvsWK8HJgziCSVpfw9aCGPlmVPv2uO1+KRbxTbqNOJKDYe5p9og+ZJ\nPHRtI6lHVEF3BG1YITard4MKDV3Ju6CHp1ZOIfQI4ajnuYys9Guh1AcH4ZNohIYos5mJWfjCo93U\njlYpj2yPNK6biUeS8rCTE81DY1IeT3Qah0iKg8zcJDISxL7HkXOcs3fqXHPFOOyhox3vKi5XCS1z\nhmYK76K9kto75R615/M+RfsMPQftaDN5qzI4XiYfS+JAu5vbhdOZO1Fmc9yZjY3klCQO2xSe2fPy\nLkO59KFcSaKdXV1VszO5Hk7tzFSmPJrEco4cxMHykf/LOvFQjY4+8tf7/OdCE3+cWV2VM3txrmMX\nmd3oUPyBHSx63ZFM/sZuiJ8hu8nYKvhxNJa9lqYfV1uNJC0t+GHzZJ2hjJMui1VzZkOSOPk649zR\nYdId1R3doaTgkd0oOWO67KWrTHf7TdDqCCXHpjsZ5aCp8r/rTd17lmZWTbup3anQ0jQhGR7bYXMt\nMvGM3RlbwhONzaF9RbPWoCmRmh0zpEqbaRRyrTQ2QrvxfPiZuTyf1MWTzWU6lDWizJhNijaErzTL\ntPR7jU16OISfZn8+Tw71ZO6aliLWqnR5R7+WdIQfG47R5BmrWmi9Od6JyuInFj7vUGo6ekmIhP/Z\n5cesJ2af/MPp2yfrbGNfnlXT5VvDk82Epq6lnzuhaQ/H8L1aaAbrW/Okrhx7ubCeMfNhS3rN2oxk\nJYSJ9edM9WHuse5d6OMf3cWXt16d+ZxyK2gk1TRyVt2xZyz7yUXBMqkclM5P5TjfKk+wJJUja47y\nc0VnrMpRxKHz5wgFq3Icfta0xNMsEpFUMdAW50ArIyS5TRLvV0ySw2Hk4yTJVQ7H8S6vZ663vpEr\ne2Hm+apG6dvZHedhFdZDaFgoM4rmgMm0sdnfevzMpxxNEfpAgYQRTGCABRQYGERQoQIfuGDBBAwc\nBhUUGkiYIIIKigcZTFhoQIIKE3hwH7hgggQFPJCAwYQKENrm/CKXZPUChQoWGh5QmPDgggckOODB\nBQoSIliQIIEHGUxYQJAwgQKMORNIaMCDCBUcIAGDDkC4MMEChgsUFlCAYa8TJ2Et/QMHhwiYgr8r\nNu18jPCYJfl0RppIJpTHiqWrLpd1JZg/sTvJ3QMHhwh1WB3B+xQFj2Tq0hGriqv8FPdFCyJZsmSo\nJUthhQbvGdgIuv6U4elu6RTTsD0h13mJrUGhTDskSUwpH5qJmbnohKpSho7ymakTI7nK9MVpJz8x\nk10hLEzBU6n1JEk8yfGBg0OEYp1MojRRKEfmktPaN9V4Cn9jFk/RvRn+DC8zRcvR0C2TtGnkN1JX\nSZuLGSLK2QnayZcf0U3OSVkyKIN1lMJCkqbNWSpHnClNqhq59IBxKI9XJEMRjld361GKXnWW2MLW\nHcslV3Y7PYM/vEnaWT7r4uzRjPlezxNCu7TzUYRpDrquXvf1fnvfe3cy1ULfMZGKZu6PzSXesZRi\nyrrmPdEsFyE9Ri9i+nUtRUfZX9XYpH2ZSX4v7/4rZkHqJCIWodV5hCK0yCYtrSmlctm9JD1V9hoy\netHkLtsd0U8vTLqn0TBCYk2mqHaqcls0pzo6sSJjxe4mfe78Vqk0M6EISFTp/2rOdqsZmY+zM/rd\npjoPyhye9KMSPUc0sdGopo45xhO0uuMxK5XDSHPPM6oYyeUwO9NnDn0jO8mR/mBHMMLvjF5bVu9Y\nZkKn491tVOhXHUllVvo0ZBHoVqy9JZQposTr1KVV8+eWiWNUKhrzh15Cl1XTVqpEA+tK93GcEejO\nLctZq58pv0kmNjfJzaOinHz3rapkkHLsfvGDaRulIdHkUea113u/R8CP2yHPZT1Wp6ucZzbdSO0l\nm1O63/GutxsSuqbPbp2RI6sIebUW1ZDcqRVRzZ2QpictOqxMK5Qrytb4Ln94lYvQurGiZxbR7elm\n0ZTvg3ghmsmzz+p78Sd1dxyXGEYw1eymNnaNUHSnEcxS6y57U16hVNauVVhHIkTDqRG832MdZZlR\n1s9qUkaZNjLDnisC/mzGV6eji81vXM9PpY7yeiVLohPVuPYrV1rUKmpesijHWVhGR1S+o7Q6uvLR\n54VYYkc/LDR62W250dT1K5IWVakIawqpMJOahDh1TBoxpHp6Kmmc6a+OXmplmdFtWkVGpVI7WEKy\ni/U0i5LwUpcG7TV0dludXInOcyZWaiZiGRElPm+W670RjJKwNkV2ZmM/G8qVr5xZp5y5tCO2JI0G\npXvnW+fEZTWjT/1I0n/1SSupI8M5u0kakzjCZdmeVSRUKuV/SNT2DEsZgc7O+pi9NiUl6vjMrHTp\nuXtr/kp7ySQ29JKWaLDklu2uxEQ9c63onmJFzfzYJ39SRWg0qh0HT6ionSNDIh/P7NQseelw7M6C\nQ3j+0N2OLM/i3FiPXpQbwgg2plbliJAM7Uk0yowukvkqY8aMjvnwIXp8d2Z4/F1NV/S8fh1SZY5O\nPeFnLOvaIGE22yvOsWRX26BzDM88Y5eUR3i3s0zG+9H40oM0hx1PLUZjvN51Zgd7N0WzKe15dkhT\n+zpXpsyyk0lCKs1g5QvpPL7Co1viHTpPaZd46P5ol0mJ5Guh3WtljyQZzS45b1KVZ/jSHaLRWZT/\ne2per33V6n9lJhoxMyubmfap/Zk1OE+y9mk0efQpLQsPsS2ib9Ys3o1Gspt7j2gkpNLRBk/lFNcs\nzYbOM8x0zFHWyZG1mWPN7XeG0qGbd4o3Nxw8dM3rUny83VTIbVbhp1hyf/HyRErTzNWHqHc69ejH\nUYdUujOpR+r5KnV39Nj2qtdT9egwS4dWOT4f17113W/IxpmjMH91leSr7FyRDjPHeO/NayQXnbVF\nddmrM0u8YYclSktEulO2cBj9mVVzfulzzyG821/SvP9t3p/jn+vU3I1+w9d/b/JsiPWUzXX7bquV\nIdqvafSex22jX6+2n35HuqmScc/jWtfvCOuH6LKx+Oz0qy3HhJOSHS/7IMyzETvCnOyhq1itLe27\npjJRWjSur1TN+VhXySo0Dl6w9FISUWeqkgjPbMIkwqFE+VzRSA1+epUD82RpKjTik9InK43ZDRrl\nv6waD972/cukIxKqQddn/tDVpEnWwJ41TRfXTWTiGoj1DiKlIeWgFNalqYrVYRtV8dXJuzbbtaw5\npaDHflHZ2Kcpjf26OdlVvJ+fYzarrLMZVoteWSPTNrNV+ZT+IfmIZnmbsg3z8qqoUzaSPMk7eXIk\nb9jWG+ReqZU5cquavAbeisZ4rSupi3LolzMlr9doEfsa6WJ/dfWX9Kt7H9+FJ+Y7esk/U9jJ+Kyh\nvmrgDVZaL5OohpklIuY9Haw5cyaZZOYvz4PHPDEaJpyymxRMspu8uSS7SbJ7ZgmV3SRR2Z2yKJNE\n48qw7CbLyimERGa8qWKz4o47V2KHibDwCi9dw6yxnBmm7UwqC3XGiOPftYzQahkCjGfikU+tSpqV\n75qniK4yo9BM6JfMOMMis9V2Q+bac17jslWVz05u2NW46oM8NXLnZNtYGVPwZR6bjnRemX22q5Ia\n1GqebzW9ImPNMs8jNc41Dqt+zmy9jlylIBrvyOeVLaVJuwambfJmTEe/zBcPvDvmvTN+nbRH6TTp\n1025POr5UlGWNo4eYgezKJZYbLPDhNmqFT9XaTesnZz3MU/y9mNOI14hzR17N93n61yaRLMSWaGV\n9bCMFepR2VBS8b6PkKqm+On9s2u362VqalZueYpv1ZHVPrWOe1bXWtaWxCZxbh9jpdQUaeyqqKY0\nnbVVU3xl3RTJoF85JSvmEI2fiYnnmxJdFRu72v2xj75q6GPLc1Q9+6uaqXGZ7ZdVJWdEWZ1r4V3n\n1f1js0pdif0+2SOys1/IM64ikxXd7lI6RDWHVZ8xS2FSmfEIDwstY8sqslji2c9cxbQcNldZDqJ6\nVf3IljKZ3BqrWjKH1Zj6gU/DK7Nf5jWc6i9Pjok+MnxVm5hZ9xDmVFZOjiQzw7rL1k6srMI0u5zb\nWNbrSbGsrLJ5ZZURubLuvqfKQUyTMgmhneUOPVBuNMeyH0lzWN3kHEfzX81NO64667jq8pOUv8r7\nVd24Fv2q7rIQ84iuyHDgHa3qOFRSRo+T1Snl+hQZ1su+pylniizptaMUj+zFNztVd+acYVaXYzlm\nNTkelcccsxqPvekqqtGKZtjdjNmRTCXzYTmdOqKi80ip9V97HuQsWumqBo14gycfEvK4vJy8G6JM\n6xC1ih+aUtE+aVTbB305PERjqXpcaDUT/EDD1lxollVoOUP4gZToPB8lSh7hdGytPM2oSCr7QVdD\n55JtZ/fM1u2S5/LONrYVBce2ou+1P0l4pLLg5K/wR0/rT2iS7sRYKZ7Cd2zx9AyrSne2Gc0nE3xv\nVfy0iWa8mykZ5uTQybSGltOszBpa2so2dkREmdRXCg65hkgypbpQYQIZbBAhAiKRCMC4gMIECxco\nUIBBQf1qlSJAAG56lDOeFkewSH55aEmmwbHRPfBuTIhInHhVUje8orIictm5UnQuO82NFFFWuuhq\nRPg6z6z0G7fvKHRppwvaZsRvHqXQ2cdYd2SetM3H5KbUtNuPrmk3ZNm0m0I3m3aI1c4UXWbzT7vE\ny3i07Ih1eDwbz65tQpu0rxAnz9bxOLRVGt3TEX3MkztnnaGniPKuNeaVpV+T63GITrIVCfNe7afw\n0jZaab/bbtbLM5vUjbskGn+uTPB8Nraxj2zjK095IPbG7pQZb3x54ypXM+vPPGXu5qpJI/FS2YFn\nKa5hU5dZJq8IMc2Hg66kq4FZwyQ8q8pL0WM1EtvzPfFllkdl6RErrLEadfMpq7m6GquiuifZ1Ill\nXojyQjSeRlVnWWfZSqqLJQrOydlxGnh12XthKm7P/W7OvZLSOJQZLDPTkQWvMMlmnMrz5BC6NjSu\n0tDTQptJK0nRPCSdtE0px+pon9OrEmnUTVHaZA9xKEs2W0vjeFd6Ty18ZZPMPnNEJiKzsanXjORk\nNkRWAwtdyzqSVw6dlRKtinDsRDe0tGEv4ZjdFceqxs6SZjU4PawTK6KzzLmls2F3xbQqqRtZzLLV\n7FV5d4hqOvapbwxrzsUZwzKZMXc2c148tOewTBRXNDWS/jKbmp5uTMbMChHrlkmJUIrGKimL1hNJ\na9hdr86yM95UWiOfv7aVpFFIWTbKlyD6rEbH4pndCBaeWWnUB/Ew8cRKg/Yhq9sx6WTmEM0mb/kX\nS6yvOcy8tPId37OSvB3WMNVdUuPy1179J+YhqbeG7dleWSFKjcK7PecdSXbwf+Hc7/75kFS+Tm5Q\nIpbdZGcGUvrs7JcjHWPtxqlThWKDEAcvxcTGD21wZLAjNzrOXi92kwxeatDL9WWm1OiJ0YZh03aY\nmWIdzuphJW3mybMJp625Dt7x6vQyDpPRTXPf4EzNfUX3zSnTZ3KYZnmzrqqFbNSYzg==\n\t]]>\n\t<![CDATA[\n\tOjWEaEfLQrsjHdqxdKNYafMRUXpm8kJJG8XPzSTRBn1ul0hHraWhJLZpQzyzsmyO0WXeRp6x6D7Y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\n\t]]>\n\t<![CDATA[\n\tDDLE/h/F/+Xpkcc+xLotKNE9tHwuk7lPf38OJ+IYHE3tqrLlrETMeBnIh4BE6cs2/91BUxsuTtFA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\n\t]]>\n\t<![CDATA[\n\tAqmT8Jd3N74qMV1ApoQmCmQB9VcdgcF+K+MNeVzimJKBQlwBKOawx5isC0m2h1VVFqUCHjJ5FTVq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\n\t]]>\n\t<![CDATA[\n\tyMPKFodOBLy4mOPj+bEpCEJ36fJd0VsOynLDjPEUX7fgL6t3RFf4Z8iQ9Cf5eOxN/WsN1W4oTg7I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\n\t]]>\n\t<![CDATA[\n\tPLOaHYNCtgRISbREpCZSIA6ejQq1f6gEo9OCJAk0RiUOQEH0vx9PS6WciiEphg24ltgzhA2EWyF8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\n\t]]>\n\t<![CDATA[\n\t9I+mOLgboC92XOkf3ZgGMgZu2LUsAEL+ckOB+u9Xk/IvmibQL/4z0+dZplAUB2nQpkXYGm+50scX\nETWKgzI6rr907Y6kqB/Be7wrTOcStXpGCZlKrKSwn/cADYWYCX1ibp8KEzXWQsh1xOf7G3NFbLPm\nNricy6smoY+WkacJqunswMJ1UkphJM3PC2giqj+aQY54hJwekcyi2sXoVQRIUowi+0M3kPz+aL1i\n4ENY/G9+SUJFmQnyT+1vaDJSZRgsaTS0papkZhzKIC4M+XdxRq/oAyy0uwVccxSdgt2DwxXEN/EG\n+JvX4Dkn8yOT8Cbz8p7HHFrMHWnRillErqVoP0TybZr2reayBKNUFXIEFid5Wh0hSRirAcEW9jAl\nsCqnrvbWadFD0Kw491xE71+MEjsqrXDcwwSIhVglfPqtfYiODJTXfFQtBwZLNhwkUAhxAll2s0XH\nQnvhGH2FeaLZvKRZuACVpzq9Ep0QzGZx6t6CkzbMrO8Qr7mltK+JueNUzIh7PhC/g3j8LcTlyumx\n7MwSMcxG3E1NnQeYuWsTRU7ADSfwBIGiZ5CiVkbQkhENuWck1AQJS4JN4xInqPWJXolCuhh1drMo\nruSxzJ/kv9gS5PVSn5wQZhm8mnxwVkBpswJVz4RQyUxwu+U1WFVriuQrVD62X7pX7nYLy5Nvb3Rt\nAEFBDnS8ewALtS2WSlN4tCzYMm3G7w5qCtDVBLS7mdJYoDsFmnSgUyFeUdDa9IDeoxGW9se0WqH3\n5EmOjnQkxISiiRmPTFnFg/qPkbEIWx9J4E4ISZC6tpRmjG1ztv5gsWnvN+Q/fwugZGwTljB63Ro+\nrIb5OefjZpwYasdnQjbD0Iq93697YjZ9hBs/Mnbk+fbL5wKDBaWCUV9gywoysK9pK81iB/ALapAd\nKTepsgucmwEzaYlDIbMpnzZIXpp8WKVhwuqBdeJ/uuZfDNgSYkVXgwcE6AtyPU6Qgvxi7hKdsNWf\nq1Z99t+Jdptql1jn7wJgntt5RIhbSQh2m+FzLkYOSys00HqWt2UMUaWhvga04i37/cH/4rJhHAvg\n/5PLlwYZPirjmiILeAFi4gye7YKfOEWwu2oSk+OcG/GX/4eOJHxcGY1oHBg4l1lk2u9Nb+p6gWCF\nsvL0dTTk/GSdC9MCkNXZ0BcMR1pTkZRcvlWx81c1/pANlkGd0WcbHxWLymDqp3lImNmb0y2lwNHm\ndFNRYqdNXTAjdJfqDeJRqmlLkAiaBamqBohwa1THiQqEO1dGIzaC/iupQ6gD805AvCveHVO7N//l\n1VfEYH5iVJKYOyByyX2FURUahML6TflB9kyl5gOFBsCUxz1QQb5LefNAPfJADg8+30Gd7oDgkWRc\nCuRhiqUryDTFZC/Few4aRdwULgc5Sg6ejoOObzq9YhAslYqm1y717U09mA4OFOn+u633FmANr3Ot\ny129/Cz+gh5Qdl7hzwcqqq8AHfmnvBLoyKASAN4AsIpQdhCJEadhuq/mNw55mxFKc0BaDC30FQe/\n0l5/btgvpXofiDA9oo2iF+r5Ai/p0RJWzY/DE7Q8Jz9eSJ6cjdR3XQWXPl6oESlS0VjE9yVkg8nv\nVILnK3l9lKC+Fhnjp/0oCLKQkszC/VGyrG2YMdXcP6JaNyDXza1YtFApCtCQd4v+u6V5rfX3Y3/F\nORx3f1Twn+3xV8DZvp0g9sZSnBY62IpWuWRm8aYJE64UWTJbxLSTzYF+njpMTDgCCYkniyXcPP0b\nBVMPgTa4t7quyh9ioOMkx6naF5Vu0xSlyq/XIk9EZyFeTBMhOPRBxBewfjwJIZM6DqPm0cc5XwhO\nK0TBCfFdsFg3TbEQxMrDAkSA3iZkiGuHyEdb1S34uyzGUATtKmIzEelIxEzP+OqvtiI8mxMQWGNA\nTSh+xAnlnpIRT2r4ytTf0kJHErinoCYuGuFh4o+xdNmIdZez2sxxJa3nYmDT4YgVKxuh3s6y0Fkv\nZT/o+oFW6EA+QLZmkQfBRPLP6ofM/r5PzueWHKq17OgdwdLbKHZuvXIz5YZQfo6bV/ZS6k3ACbK7\nRPp5Px2p/ba/8BdOkL2pnGOf0a9DkN8M1d3B0FRXnGwoVx3iehn0wAY+3oQInA8sGMBU/f5PmNER\n9txjmPgHTDcNSbTCMYm2gIDG7FGu+fQ1TKIA1sbTIE0uJqlU2wBGF6rTzHKE8Ug0CzGcgYdO98c8\nKjAAzQJaFDAgYau7Yht3uVfMChA14ZksAMuoJYBwCf0PytK8qvA2hS039C7H5cvRXphTlDmTdLka\nDzrOpzODL3K+huigkTH4h8Nl2zMoKliDltgROcfyl1ZKZ6fg+zVHMabZP/RkGPyVV48Ws36IAIwd\n/7BdAjmtFcEjWdnzyi44QbQpCQ5xI9RPUqGvzLMl1bU/V364u5WVaeOQvq1FNx9pSmf5VLRrJ1lh\nj3SYaqTBlQDoVnEfos/aqGB59aYPW6J7TWhvFln6xqN7vOBKM7QHJrl+ieO9ZJOAQMXdplu3E0vY\nfaTsnFShLZ4Ii4M7j8hs8/2gUqIImKFugCifgE/cJDbWFePtNHkCtFKXKQyKxs6mo9Er9bGob893\n6mvQMMX0c1+W3upM7AzS1skBBZEvxxm4yuDrm9MXDISpZY2ywc7eH5MfmVfB8JwJg8A0jo6A0S2k\nZaG72+V6Z7VLpLsvIrKg8r5lo57lFgg8+BnHc4GB7bvRmuZhKH/7zvrl/NBbXMgu2/k+LRLkzKKA\nmJJisJkiec3KfzX7N80y6SLR+kDRrL3P7Ekzy3GZrcNkJiL2q1DM5q7PDzOBYCb8y3p72dMuS+ey\nGfpGa5k2yyrGso4rW1lZAim6qGxbT2S8Yw4gB9zoEB8a1dB2wicOMaO9y+s1pqccSNs/nmRBSGmC\nJPG3qWw3v27ZcNLM5UGKVThIy58Or4notOLDnlfOSv5YRAk7Ha9RFlYdCVY8iLc9V14gYHkEJYZy\n2zpZUabjWG5mjVNZld2KaHs3uHXegxoXPRxIkmKOXDGJQ4JJcXAGCrbjq7042n44EmY8MPL+wNGh\nsrLRqLpdALgqVAp1W8pGC7Ih4Zr4CwFjC4DmAjRLyXVEZkOEA8F9zFrlDpfThIgLWnawsWsIP5kD\nWySJc/TbDFIOJcu1wQuRuGacIuCtpGkB/WCME0CX5OCd36CxiTDAduQfCH5Ws3V3jK+mR2Nzrf87\nwk7vcz867hOkHOb4HUyHYYh8C+CKLwQytY/BKrLDJAMiVC7dci2XGSDYQSlcBBc04IieC+nywGVL\nANUJV1cMa6zgOhzsplZGnWxwsyf/2YWes/KitZHutsfhrjLuqHBiCssNqX5kP/7uQjVearqfcyv1\nH8Zy3OPAXTVjHvmxRMdJYrKwyPcQ0TwRiO5jT+qipgpquKdBgdMwmg6hYeIjCDmknYKjGRlNzB+m\nU515b/n8gItIwJpvYCfaNExPyyc/XuRjO4AMEMBS3vYsBiGCr783350DWCYzE6oFilMK16muPZjP\nn20hYJRNo3wcRdc7CpakuF1S/JRyhRFY8AocRhHKbkUKGeD+yXjdnJRTzwGk6cJsuDAIjTImgVhe\nIP6EgUBWilrYG2eQ34yumjFmRjxm7F+G3DLKrYxPGfEnYykZigpOX5gQAFxqDmJfmpLG0E7skSbw\nRR4jGHukHT2qSGlzSUccAU0hqPgOChorP/hn6T3YQfimE9yIBY8iRX0zdncaFh0NaVb5XQKyODTl\nhcuAKSECphVjYTn5zNq0tsRsN46648XuEVITf1F1jlFXRAGhYqzvqYjys194bb+w4vjMFfQT8jFv\n9b6HdhGpIRxOAh0cQM4G8FM8xUZLmPjyhBIaYEaATsBofkSXDJBFhtniAmOWcwSfmO41FF76cgbQ\nmBb1H0wvB7k+rJMwJyF/K1Tn0A6+Z4u7jev6hn07PRexcQDioPl7p+6VWQiLGFqktFgobgv3DNr1\nITtDTroGj0UCwOYTCqMiY5mZbQtcYcz7MsORBh6sVGotCPISQD2WsEzQDn8q/h6iMAFlJNuQjk2p\nSWPSoBPU6waaUQwyk6sqJ61oRfeRWSBly8i5d1q9gpkUU+KWUoilquFv3GDq4BPYNrmBC9K/QfpN\nE/xmNmeCxpmv98LzHijeyHGLp/NgA1Um3fDv3G3JPdjd7IMb57G/0r826GoVKmojmLS78dmrh1LN\nZTdoZVMiG8OP3S5iT4enUUoqEPhRkRuP2EMg8se327Ll66WRmabLjhJy4P8HCJl7IMeURcdSlEgR\nBnrUD/JDaiKevwQd5QrRRyGwovkklUb8H0yC9kSzDwMoy0TWQcg6rhlDgoDagfPTkEf0jjwnDiUT\nRddcSG0pJ2rY4wr2vX7Nr17b2oUUVjaOCG8L+KnVnyCYYg3dirnWXQGt9MGYdqpkKQ4Wydp1U7p5\nxY5LHR8FAm1pKiqhwqsgb2Bm9g19JSFDiM0Bn+XkjaRV9sWYv1bdsQ62IvJPFyjpk4yf6fWDu20x\ny78M3WvzGDUO7Mzjc1HxxO2C/4CzBHem017vv6faKlqNGei+jGVRBcoOfaGJvZY0Ijl04A2qP4rU\nYdpNjanURvv4/cz5vQ8vwlGdXOKoYlSJcR/5EnJPOaDCw18WNFeIvD+OHMj03zh6+DnQYscSnFkd\nBCOiId5+T4qhK03wKTUvzQsDPZoNVtMK64pXaNX4wzqtTMGhphafBt+EwmryiO12XXNT95wOx1Lc\njEYjuMXnIk3p5wMSMLHkKXx0OrZpKxxskWn9hWnQlk6ntAQLz/mYdEGRVg6M5c4lkvkh2AKesjRw\nRn1yXhTeouvk68hLi1FTxoWLPq6oHuyZqDwwWiEPm1C0sNGTbzsZudUmGsuU20jEQaMBU1QTRzGD\nNFZ1DWRJLW9qISgovira8/NyTG//TB8flXmsJHBBEfNJj5bykaH0cj8A6pQHIyMI8UjFwL+Lh3L3\n+3hA/IjYNXGEikoMnR+R9GA8u3k4m/rZKwc6TQQAq2AhJ4UDIQAPmIih+yM0MYINzhJBPLx0ElCL\nhxIEOL39EW4YBmaQ30UDzQj5/IMS5qf8zYR69zW7KtbrkY6kzjNbfpfhnCQtRJWEMOaBK5vIOlfU\n02x8cRjFG4Xvf69YyQ4m/SaFoJ+IRizNO6D27oqh/kFKDnM1QGwoifCqdkSpckewJKwfs7pper+K\nZ7x9/jRKNmA/Xig8PqW49Z7bIhnOql+YLBt/lFhBeLvL3Y1waWwctOdBCZSwQElyJoRRufQS3iSp\nQBKxhtFjA3aLlnansFpyKoha+9KzNalSLYZYsiZTCEozzeFAOIZwaKkZgy5rPQ01UcjlNXJJEdUf\nGfeRgJbEENA86f7jfX1Qsod887jTHf3WodscQB+opYAqYwHF+LlrAoVSIRQLJRBroR0NJoPIsK2M\nCMANqvUpEzhP8z4w+23jzrU1vSVhEmh3cIHpjp4JFDHku33FGL4NxamuCECkk8Xsww==\n\t]]>\n\t<![CDATA[\n\taejNuH1wHA+So4OSc4CHbhDqUQ58IYQzNdiBYLIUWFLBRwP3CVjz/l9STcEeOaqXUOmwM4fVlrET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\n\t]]>\n\t<![CDATA[\n\tRJcRSkvIxltDrJ0q3Lrl3JoONbbF8QwqU5CxasLRr6q9JsoLHTsKXU9MSamKXKaKqRLsQjZ+1ZRP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\n\t]]>\n\t<![CDATA[\n\tWT39bUYcxh6/2OymiLojW9Rvn1NEmZibQXbSi8VRHOQXReoqEmTXL5rBQz/6cBOIMocp9oTcH2Oe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\n\t]]>\n\t<![CDATA[\n\tmIDHS45jlJdbeHAJ3rPZHwgj4+oHAZa//ruZzQybS9xOUZ5l0eqRpiMwr4lOXPZx0+crYmXNyNKb\nHTpV0qALC//wx+8XoT62zztDgV84OWrxaHEqXRN2bvnH/7ufg0zxwl/AOS5pouXyAZbj1zLZpmvX\nJzDEsWWeZCwVBdkViUwDb2FzLnzBQJ9fQsihKQPWRV++C/A6AY8A2fqiXbSnUZDUHbIsWTVLVDKY\nH5zgVMB6VuucwJCFF3E9OCFe7xtILQaJnAwh9EmV+t1mr7QaiLDCh0D/OtedagROxoOvkZFbUiJJ\nm18aUdeb8czNVQZTHIwNd5FWhpWioPoFFRYtMWhIHB1U4wQ3tL42pIWAabdFNZpirwcU2MKbRqru\niPNpoTIwvMIlkXzro4VmjEngi3dqRC23TdDVHTDXhIUFBHYrhzmPJy07xLYD3Zkvm6r1YjAG4NMN\nvwDlgOZDG3zsVlxT9Wy+NZ1PQM/uBdy7Ptv5E4uynMAP8emH3wISPbpI1L2EQU7Shv3UqanLBml4\nAsXbIWKASJ5EIR9f9FPdSacHI3Foj/kvWg13JpjdUEPrI9XMj31kh6FwsMzJCBNQM1BofTXQVvcU\n0kdcUf7tikH4fO1XDl0n99owKiN1RiZHFKiU5DOgZAPRoFKo2sEidOLWVdf8ggynkVwf5ZVZWutE\nIqJJFelYvBGmenw6KzFww1hYiADOfXyCEKVT91D3r9ne85ybICIrIjfMtDPGJptlTDQDLrShOAk5\ngu2uNErWpoaWuSi1Jumy3DQhyQkQJoirzXMgVpwc9P0g2yOZzWXDgD1QKBqkatdaK/5DFIhXXn0U\n7dHCG0kiXKB4cZ3JIkP+ZStAkIhrfJIABt3gCbBgRHnTlUE/dKANcYQsUv8Xf6PFPfUyt4Nlcvf2\nTVHlKG8U3exvO8S2lkm6X08utBu74LuSviEpeHuLDlRBPL9/dU1q8gOmkssJnfLNoHWwrmaScwRe\n+cINKsuRIZ8OEVSgLL0wmvqxzzP4RcNmqHbLUqI0NiaVuplbtnQXe5nr3LhajPRuxmodbBKBXtRY\nITi/JgtRbCFGX0rUj+Y3TtmdKMxvW6wgZwunwSThyjhRAHL5N/IaKonowGjNyHLtE92Ikk8yH5JP\nc1YY2Ycu1cZpztXHDW8j9vOB6QNdD4ISgkKAaOpYEOn24o7k+JykbETHB+ulypJ9wEKoBi7kz7c6\nSQ0xKa7SrBP5/C4P1+JDGs/5Z4ZbWE9tNDGqJdENzymPC3btH2dfT/h8zyVnwiYB6/ggMI3qXGHo\nX2+NSpnXqfoIb/OSpulMZyQw2Tglw1RhKFih9s8Jm3+BbafzjvuXs5h67Fm0OJalPJgRV6KeLA1B\nf1or6NYY0MWKXf6E/UxIcJnR4VIalQM76gC4Z0Zp5WMOla9kD3RL9ZA+3pVmk1yMVJP4fotp8rN3\nSLcNAss9Kis6s/lJfBcDcAS3L5z2G5a0+mtIsPxmaD9ZI94KVhmEaMB1CWhKaO8g6UowuWyniVHP\nhilBOyFHvxgRI54GLF55JbpZGbg2XRb6HRnLDpI0UVF0zJaZlM0+azDuFrPG0lsX3dZx0b0NZYcc\nN0b8rPMRXZ6KZfQg0EPsIWS/j1lKyPPe0XotHm+EN56IlUgo9BKVvCUoqEaA4Vb3z++O2dBDIOis\nPuLzgDe+CkMHKYfytZaf9oEZFncYB2Ph2Jz1hlBpY8zEWQgj8MlJGuWAfZIHK4FHbANZDKacSnIC\nCXj35XmzsS5szeiNBhK7EA90FoiQWPrEUJFys7fUYmK///rbjfSNfeHDgq4isMrXXs7skt5qC7Kx\nGdnkwSjFdtHT4IdPbAr9B5ajpLwDG+maga8vdCM+QfOm6+wCK60jY340JbtgY00455kQCliWCuRN\nBA3xkEOD8JmGcudQVPnUZsncBnx4kN9otVwuJCD97ctjhvXFvsLi/3iUrxCratK07avZjOvQAYrh\nQJ8Dqnp3eBtJo7DfTxRspW6E2ANabxCn2pkcAfoF91RATmmK/9Uz1RsH8JPA5Nfk2OAvdbHgPYHT\nsPHX8It8TUXNEOVzjgxpXZa0K6kkXCH2gmpozhVOiA8tW2XMU+kgcMDHjgqtxNGV9fggUIh9RJy8\nPvjFM3a+1pS0/ZJt5HC4d6bDGEECSkBi+9pElCF3XFiyGIAcAg7vRs1+q+61C+8vSD/XA7Wvqwkj\nkm5wlpLUEjBoaLyK2BeJKVuw+dzr8RRRkJ2jlZ8L9DDWiLBrb5OFOGd1QGjqH4VtRJE6KtppFrrq\nr6A/Ijm2HBpCLeGePTKGVA70GPMyMsISF9tOBvjfEBjUjvL1PufVjcLjy125kSKeKZyFDcQGZ3d5\nAIHr8YAsFztG6WnNvzlO3kg1IOwSyR8Wijpcp4rxKZdDY7+pN6cS1gJ/sRggMhpFPQx9xMDIWD2x\nWbUKjPZsSbyL0T8ZyMI7a+0SPzxDYEM4hnBAYnS/8/6Rkd8dujHNHAQtTgpXqpjPNKybOaXRa8Lg\nuLFEBXxpTWOkYf/EAotSJIS0Ay/mVIQFNy4Wkokqw5EqBslxCfBwIDhit8knIFCrVXnD3YD+sKil\nqjPro8/TI9gfx2oZy06EkC6Bj5dDmkSkSvojqcEILYJ0RdrlCgBzjqGgugf8F6qJ1G+eudZjpuDp\nr4yQpdWW09IpgeQ9tW4cu3Ywlmvg8cKJqw0nzHEXAa/mRNfd5W5DXz7bab7pZpjEwhRB9EiQsGy9\n6ARJ/ysBWA1EP8AGO4aFGWudC0+iksQH2yJrSBoIXm5xVsWAupjBHWv0lEJXBueyiHYjYaf1qFM3\ndEMQxE+HFx4Bi/zy0ppIXHZSeQJcg5t1/Wyvf2+pS/cmGrEI/OQ/jzXlGXhUo8SUnYw5FzRNTVbj\nyBkQc8GrBVot9rVz0gcUXKqvHSx6wXF6DdRFSoUwA8umfYgbbdz0hi0TaTnEmK3yWnIvRyfRO+Sf\nj/AKA8hP6gjhxTb6C4pRlQ6jCjrHhVmoUQ5v+IPme+x84XloI1UfrVLTHKczjOVgjPUxZ3SFPhXM\nn5T3jXOL3+paYZDseshmMLBMi/KgYA9/V9txbXx8d6MUJ3LoJEXJwgy8ZehCtwKLp59/WlcewtPy\nEGq6J0BKEQy+pgUDRGMucKCNmTJbSymCSIKaw7CFB32PVTcC7/tuQiqlT9TkKxsKdBYCg1W6IKyw\nflVR42vOcZNDw+dtIFL3GVcRFmleMcSZ4SzNEGFM9UQgZfG701BAdZSxqIpRORHk5t9DZ6llev+X\n3D8/TliXtERC1I8ZQobpfPaYsQpRXlH2kgPAbmyjZo5pdWJaXghzz9kJIdHXP/qIoH4UdYFDzoG8\nXyU1ZjveOwKpx3JobP9JS/f3oq+axvnRuWEFuo/KFmpfJY/IESubuM0nOvS4S955Rdo3gH7aWO3w\nP6S84ZSQajRqOH+YTAuUozaPVX6u3yYf+Ls0Iv0dtrWp9/kIhWPIPT1xDRUQhKIpzNgxVPDJKpxn\n2fMhRkYpe2xdn2E5P3RuD9SMfRzMa6uw7Pi9g1ZoxjmpMO604nRhIYcA44qNO8Upye4x4IRQyw8g\nnQCr604Rqhl4VCSMhVCKPwdGXMvY+TSOAv30b9wPVUyjtf2EkmTu0GSbhfdFpSCg+WD4zUqtKOZS\ntDM4Z1pynuhNZEQ0NJtRzirkLhwgOJ3bt2xQKBz/lICKg0SV0qmIKDhf2zCtapSwzSmxvN1++wUC\nuwTovkP8Jtck/+jEClRJH+CcuouVoYmJe/g4XshaPsQ2bODvGCXHX6O4IGpSoTTGulWtJjx6ylu0\nJG6QMtrdYDmSYJW8CQ1cRvDsyFU0yNE9AcKTfW3yI+0UmiTpuFX3FCCudvo8+nwerb/PRZdvMEZ5\nhyc0TKxHVEL8I4j5+gfCKOMqcJhMOy6aPpvGKTf0Dq3Lf96gw6Y30CUAqtF/zV0drprlrnsiB7qz\ngi8zWxx0Av4ErKsP+Rvc+Qg+79GO9YSiw+zYb3DF79Og+pGk6fzgb9DF5+dA14cweGdbiyoC5COL\nYYU6r1ZYuUfQ5grK9AgmfIVD7F8G0PSI+MJCnXMsKNxlwS49ouiz0JNHRKMWUkvBU5YVtpDcjkDP\nLZSDRxLhQlWCufCCry7cvHcBgp0XbonwBZ9EfkF2CBg8PAUDGHcEmzD0mxyGM7GJ4cgQ347UvRga\nClzGMXxQkOFClQwAhE0ZnviWwQWQGZTSEfg2w8I58toZaOnI5WegsB0aDq4jBaTBVAs4VB2n0hE2\nQ/pcrxo+5BzhwN2VNTcNmeIIb2zobDkbHrHYhiNwxD3cUBCqG6DhvOEo1m/w1I1gLTi4lIYDKrA4\nfDI+DlYGysH8RuBiDk/dyKZz4NvGSC65AoHFRijR4ZE14sB0aJRVhwdqBPU6iEcjCM8Oz2dk6XYg\na0bugTN3Bz8BPJhZRv6Jhzq2vDbykBLNgy1j5Bg9NA8jtFgPZs72ADEYmXwPTOLh9+ODRL/IeK9e\nJKpoF0kQfWjJRWDtgwGOH7DdFrnDvrRI5Z8+VINq8j8wgUVcDhDNrYiicxW5QyCqpSLODESVU0Qi\ngiiTIqIriAZgHw0CPCzNGK9fIuuDKj0RZekfWceJlAJoInUsRJTHKwxxHJtqiEdFpI4sR5EIVcYL\n8HD3ILwZEWqNCOvWWCzs9mGWiCtEBGIeMURggor4iNYgN5A0hNZApLOL6PCHfGJEcz6EtRnhqIcU\nrRGOrFPgdLrBLuLHjo4VPMRPH9G5DkkHEmWEIbGcQ1BWJNTFIaCPxMkb8lASdNmQxTEJnhoC1klU\noCH1UKJ4GXLIlOgdQxBVCTOy7rwSxFoGeQq+kNqRd2D0JUAcXgKoWsggYKJEWIg9f4naWCGuw0Tx\nTyFiw0QboxBLOiZq9YS4LBPFMyHSz0SsTYD1qAm2SEg/NtE0Qm65iepYwwk7IgSVObEIIcPVCU5l\n78TlP0jxecLUHqQbfMLSDlJv+Qk3OUhPQOHiBglnUJhMg3RThcKtDNIXD4Wd9VtLFLzBIFBCF8VT\nDzo3ihJYECBACu8UhLVMUtjcIAeEEgQ4pXCLIHm5FC5BkNKQByJDpnDIgfSDbAqjHPB2igEYCFR8\nVyAof4q7s/zgNaLC1IlUmEUgMDQVPg9IMqowz4D4tVihAiKzVtFDQCJEGCDeV1F8AJlxrOgGIEho\nhZn/I0y2wjL/YRNXFNU/DOuKdv1DSK/oxD98+hWl2R+6PFg0hisMiEXj+MNFxqJ8Nie0H0aqqH8/\n7MqCWftxkWbBWT+QPYty9KM3WhQ1P2aeFn3kBwJrYR5+9MIWdvxXjdoiVfch5xYGto/Y3sKOfQQl\nXLi0PmLjwgj1EVsu7KOPoJ8L1+cjfrqw2XxErQuz5aOoVsmHz3bhcXxEvwvDxEcD8sJX+AijF5ai\nvbCTGl/oAR8g+2K793joFxx3j5/+BVnugZ0BoxFmrzgwFtQeFBcMb9kjAYThnBCtKQ==\n\t]]>\n\t<![CDATA[\n\tjCTXQ2AZhu+GPD0Pw3PqERExDE8Ph02MrtJDtGJUGT2sF6Mw6GH4jNH1PJRwjDKch5/HqKN5SAYy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\n\t]]>\n\t<![CDATA[\n\thNVmDd8H4dpaw9QgIHo+jAWhjq6xiiA04zXWDISIvsZAIIQGNtYBQk0MG+cWMfWSM4Dusjz1xybT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\n\t]]>\n\t<![CDATA[\n\ttR388F2LB1FzCIgBPH02fI/UZsN/7sFrFVfUb1r4rt4yGHEYTiPhb4JQQGHHKOiTusHnr8znPRJH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\n\t]]>\n\t<![CDATA[\n\t7efr8hqR8FVbY2lvP02TZNPeGUjUb7W0t0xgKjfZEKWR9p7PSdJOqae9v0a21ymEjzfT3mTl8phv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\n\t]]>\n\t<![CDATA[\n\t1/exGp6sbN7mKGYdXEHm8I2W5Nrd+RqasrAIp4DBINM69g5aV61YsBq31+rGp5J1toI+bEPhVo/N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\n\t]]>\n\t<![CDATA[\n\tJKIG86FxQM/j8MC08mM3W9y6/I+t/ID0yz2CgBn2Y6ckAo3EeGzY2CCsOY9Jj6PyYA8lMsqtgmfE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\n\t]]>\n\t<![CDATA[\n\twSObhyj5PtNo10OdFv6lTe/P+aP7O1y8XxQJeP8k5v0dQziZujKay2BgVzdZjMm02zcYoJrN+sEp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\n\t]]>\n\t<![CDATA[\n\tkyy7dlRpoW2ANGwfUQbeQYp6tk847w5K7LOJJPvsokdB24gS8Nbp0vWbwLfec1hnC0Hy/SNMv3sI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\n\t]]>\n\t<![CDATA[\n\tgO9kbGKoSegkU1OzVW8zdUpc5ossapRGvowZQsniB61YoQ+xDKDORJ0C50m5xCu62IRR9LNVL9MF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\n\t]]>\n\t<![CDATA[\n\tQcnnbMEJqKyhVZQO8eTUg7Gm/g+sp7QG1tFZQ5VSOcKQS7oBjUlaqoRhR6Ai8VvRiPQIVCQ4oWhr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\n\t]]>\n\t<![CDATA[\n\tLJcBqtqrIOKZwYzIugGNynkpM+xzAOm6T3jPW1gdlT1QQaWrVFDWQIl73g5trtmDo08L/w+inr+m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\n\t]]>\n\t<![CDATA[\n\tD5wsBIiZwbQQEw6AQgTZeEmYH2MJ0cdeutTGCIhgGxvwRY+1gFAwZsGh5gRdBU7ntYBvSMDEEfgQ\n8Rl+syMjxC1cOdCxxPMyYIIxi0VEU+ZwBVXGShnhbSouvBwTG9tCIKtkfkR8bOkmqGMVVjX71Oii\nzQRa2I02uVosJZnaLJcVdIcuqfKDHZlap9HCzrPIh20QhDPMQwJmhF2tcmKJJPtuXmdrLmECCO61\n5UX0+SfbXl70buvqDYbCxJb7AqS2B5BDTlPgx7zHhQkdjtKlZ77IolZ5w0vZopMBdPAUA8yBVQqg\n3Y4F0HVh7GTDgrGNLaQslxlgGrdaXJt1gEMwUuJJMT58RobHXB09cTsRFXQs7UIAbfaJ5SDOaSl8\nCc3uLemx3YOiY/ulAImawhNOeinU233CejFwW5lrxbxi7MayQZl7MogBpNCKcWEh11RqzB8KECNs\nigZl2AMrol9f4xxgGcYxRCzpUPRiYMBplx8fAft6MWC+fLEFDVSTtU8UNUpdNwiU/2FLC7EZPLov\nbiUhAveQQetH9Q9EH0cJAf6iwEyoQALz23hLmD1mDTE27hLCboyA2HZsgFeGMRIOPTcGt2AWuwSu\nbbCAG8kA8QsHnnJS7zhkGNvwMktgx2xWZYbnMsB03mAFVeZSgIT2gpdUsb3VITZcK5B+NuVGj2PN\nYf8rK7xWE8p6BtBMy/NIpwVRABLyhQOQCJPpM/viHwuCScVhmGAUKL0QChbfNQYSAurFZQiewi4Y\nTd4dmAzbHFiR5SIY2LjH198WLlowFC81JI8vW84SVd4AjbDWHcY5QhS18IbAEY37UGSj8IOFMY4P\nYOMmXRTGSDYwIeBEBR0jiFkyJ+CyuJ+IBtwrwRPHIkLiTzxAfMnGhyvF9HAgjjNTsKrHq2CORbLc\njThYy2rWF3UDH4511hHKmsOXz152ZYZv5OGkLBBIkdsO8uKLLVlBR7jhKS+wISlbEcnM9i8x6A8I\nqM5YTDqxTi4UwyIYYESIt/EUbN/YgKxXCxc6jQBHsldZRMGWVITDqqaIwz6MbXz1cREwuPEVMcCx\nF+3Z2EmYiPGQEPK4yJc8ZhJCO37ilTY+4ItuHICwuPECYWYIcKAa18AQNOWxwvVz7Ip7rChO1SPE\ne7gOj+EzUTtJPOzBghpHNa8iVMDs0wkw7QEB1HnMywvvRYBUGupF1/9MytlKpYDfKgclnQHKqKw1\nJJOu4VvrnKtDF9eCsHV9G/vKMIYhArFKAv1RiQJ2oAG8aOvGWLBlY1awDuMiH67GMDxkjXF08OMs\nXYNXEJAJcXz5lY9KvGLCI5qV3SIjxJVM/NjGBBDBNc7CBWFcZGvCmFWDPV6gK21cgBBoYwGEmMcI\nfNAaI9FQNA6dwENlUWsmR1wWR8Q24NmqKZ5VxMR9OM8Mr+EUEETleOZ1wDpgNMzeQqOenYywrWxM\n1jNvaDUXEfblmYLKG+goFDzNFFbWNktMefN2sUKLjWFkjUh0w7QMMOILbVwk2zXuEYLmUc3DTWWc\nlxIPxw9kYywiwlgOqNHGAAhxjxfwwo4R8AA2XqCD25gAX32sBsD6KSGA9g4ACRADPCIA2UvjgH/3\nZRyGHRegQ4KxDww/QSglyHjCUeCCswQelrN4nIcHXAyCFI+QlMSjcoL4k40QR6oJ4j88h18jOBl4\n+vK5AfPxSDjyb/WIZ2QScFjKle5WACTaezwE2+eFCd1IxYB/iQPLGWaNLWhfJVW6IBMofc7LE23Z\n+AiWHhMBCxuvirgal/BagAW0a4EAUD/0cRQvwAIgoO1TQIHsYRAE/qQJKmrcBRKQy8ZbRIiNm3Rt\nGCfpYAABoxpwgPxJqJGBpwXTKEfgPsIC3oGKinMtOMDnKwW8zQIDnvdhAS/EVnG/DlMcLguKkyl4\n4lgnJv4AiIg/2QDJcKQYoZhGO4PYGMjX4AFRarsoPOw2JTK29xYXvgwBGr1sARhfLAEj+tYBSLVf\nBkAxsylQwMfLQsSHGWDFTAUkMoyK1TLEEpHGD36cxQsMJIGu96UAWLJxALw+jKtwPRjL4KAEgMyt\noCiKF3hWvRZmSMRJgLHcXnHG3yAGtS3CT5NGCgbGKC5IGCPRgDVGskU1voFhaaxagWfJY1YMiTcI\nXPI34IfyAm4oM+B1Gg7wMKoiztVExDMYFXGtoiHeIKfoymcsHICC2fMYkFCEwbQJuJg9a4nbqJLb\nuQYRIHgYDZY5iaRrCf6RKu7+kHFp+IOzMlPJHt/4S9aPWUP88ZQQ2rETLw9jJh4OjEdsIGp9zAA1\nNoGhwpiJhqqxDA07R8ITanb0RbAJMoil40QRS6eVEQuniCHWzI3BBjIz+BrY/AhDuBmy+IDmh2KV\nzAvBBXxS7QD3m6l4nYcq7qXAAGfwo8STaoo4EA+SuTGSCQoa0t0gyJqAvMkdsuSze8SLpeAQVspA\nIquVg0EKuPT2kCHu/pBRyfVBo5LrIwam4iqkmBOKHWQMLmWGQBLwc+MDwuzGB4htjZlwQDB+sfVj\nZNGCjQw+CTpFvBJ+sERqBW0RTzg6AGiFA2MZGBqMeWxRjWtgaBqTsDDERdKCjI06CHwPAxT3ejri\nVTxC3GkGiBfNAPEimSCuJDPEl2aEgDhPTk4R99mhqQthNY+5fLAMC+GU9DvCJfKvSBHRSiZeSyFa\nyjpVWeU0E3V8aiLmENVMhRJX2eIKGiZqk7jJE61rhVy09LfxFjC18ZcvDeMqGzCMu2whjWNo6ViR\nfBBTg+2Ka9IMuOMXA263NcW/gydOL3jiYAeeuBaSEocQlMQZACXxKqAkzgBoiVtoMsCxCKT4WZYU\n7+uQgKtZSXEOSkl8QQ8RZ4r54Ug5NDQxfMbATlEQEMQMF8ZEOsSNrYgRSqHSzRboMX8YtxDrGhcA\nZrbAavaSUMcMzG4PIKSFO4yIH29AUlLqKDSEMWUMsBUBLdgYi4cH4x4akAowWoFpLGMCTquklU0R\nwgfXF2wNeKiWAf9yUfG2BwY4fWCJgxlQ4hmKlvgFpCRe4UiJRzg64hGMkniW0RGXYETEMTQZ8Q1N\nRzxD1BEH4fTEt5icOAKdJA50DeI8vIfXaDlBgY2jgBCDe5joHDxiJbSLJMtnYBMEQAWbbPkUXHKl\nczBJK2YXyBDML48cmd4eMi4PeXBSMgJRTFSFogZnAACEZY2PbD0YH8FwNFadsPMkEitGxdsD7iiG\ngMdNaOJkDop4h6civoVUxLuikvhXgiReO2Di9wMm/hWFxL2ijviGpaIGPUWcKUbo6BrEhTgQz+E8\n/IbnzFz7fpVelgKIVYKJfHoKKikCCtjahROQyQGSfkmqVAoSoUHZ3UHk0rvDyeU3xxFx2AYKS8cc\nkpCjSuYKbVC548ZcwjKMn2wwMEZxIYeJYdYVhVoVb+x64pVfUbxrIYrDWT1xNQZOvKzKiXdBIXEI\nQkQ8gY8Qf9IR4k85QRwqx4g/3RRxoqsQD+JBQ/yHN9UIcQMyRRzKpog75QxxI5kgvsMbHB1JjVNk\nOMRhwBd7jZxWBhZxQhm42kOTE0qepmIRSLGXh41L744dpIU6moAWFpDEMxFGjcnKHWBHUCF3XB9Y\nPNu4CxiC8YwMPVIUJVxLxxzwSiwVB+Ri4n9cS9wPQxP3bpDi3w5RvO/CFH+DAMVlA038AlESvwo6\n4g1yingCHSJOdVPEla5CvEeH73AcLsR5ONI1iD/RFPGiGCEaGH5F6jmiMP7BVcmpBA+z62OHpuCR\nKZqDRrBkDq5OuRwUsnrZ/SHjkjsEhmXXRxLLLpAhlY4+FikpfYQjQXvs8QnZQluNVzEMCSCywpXG\nmRX/nBFwzo6AM35J8UENT5wuwhIne4DEv6KO+JbSEY9wRMQfDBXxBTpDHKomiBtde7jRlYc3XYF4\nU4wQX4oJ4knXII4UA8SPrkAyVxAKpCyMmWyYVESCqMld/QEa6GRKKDfJlNFBJlRCuUu2cHJXp1gK\nriqx7PpwkvnloUQzfKMAS8YCNBVVm6ytjQ34ijAWooFq7CLDDxZICTEr0K64YhcCHtfAALehlDgZ\nldKFICFeIaiIVwA64hKGinjVDxFHsDPEGQAV8QQ6R1wqJ4kf0RDxHw7Ed3jPlcfEcJoe7sOBeA8M\nv4phQd3jAnRZhoGQdnKJLPEUZOJFE3BJl0zBI14yuUSqiAeB6NAkzJGjk5CHkE6wDieb4QKIWDLW\n6HQUNUJ3uALKWdqYy5eHcRWuHSbcChwT2+ADEhLnKhriYE1GXJ4y4rOBJP4TJPG3KwNc7coAl9M6\nwO8qKX7BKIk3+DniVDhH3Og6xHtwZGz49epjM8QnQIC6Qr5JMBsrEELMDYLDkgvEh2XXBxPLwSFD\nxF0fNiwJeaQQEwoZxTT88SkOC8m8NPzBKfb2kGGZ6APTUpEHpuWjDUqujSp2g/GPDDtRBilwSa8q\nXh9Q4iCehjhXUhEPizriWagjHga1xLmkkvgFpSN+RaTEr4KSOIMcJG5gpoj/cJ8bG45Tg8NruM1W\ngwRb4ykbxIVDLjW5RIxccoPgwOwG4WHpDbJC0+vDh2a3RxBNLhEjnV8fRjS9PYpofncE2TyswcJy\nEYcmV0cWfzZOQMRPlkYKV1GPBQPaH/BuBwX8Uz1xDkpG/IGOEK+6CeILaoI4lcwQb5r54UlXHw7E\nebgPz+E9fIcXyfxwp5miHd7DZ/hNTE+EsRENml0hNzy5q6udgkhaQ7lLtpB6kXQp/RbRYhoOskX0\nG4RKaSGPVlKwDymXiD06LQttrLhU3KEpaZokzhEFFLW2sRUwqvEIDjGpY1kc7UEU3yJC4hB0iLgV\njhB3sAPEGeQA8QY1QtzBjhDHAiLiWUNFXCvoiE8QQuIQeIy4lE3RD9+Z4TWcw1x5Yoz43UVhqspo\nh7TxAiIuK1v7KgWZmKjkY20VCwrpYQn+YWoZBnJqWdiDVAwGElrJ9UHDsrDHqbiUFe7xhpexxlUD\nbExJI15LxB6alog9NMWLPSi5PLb0BmMeWzM62CZwL4YE/AOREV9w88OhYnh4lEwPl5oJ4k1XH57E\ngXgQ3+FEMD18KWaIG8H88Byew2k4Do/hMjEPDijwGq92RaLAgiYGI8EUEw4htXw8QmhZaWTQstLI\noLiwR6ilt8cLzW+PAj67QlZDCXkU6fzy+KFJqOMGZuENFJeKNj4RTzxJUxsjIGJpfGoBxtOGwPcy\nIODaA0/8CsiII/Ee3mPDaTjNDY/hM0E7Q/zGYHWPv3hdGgLpvPz2mHHZ/UED0/sjB+ZgkSWd3SGs\noIQ+WDu9QJxsdoE0wfT2GNJJuGOJpeiTucQfYkxSJHaSLKKk9Y2zaKvGJjrMoHCbwN8kJOAPfIhu\nYviMDs/hO1yH+/AejsNxuA7HobnyGBh+vcYYHS3VSPJt2eMuXmIXXM40v0w8Jfsm+5Y4mfxLYqTS\nO2SEpqQRsHjElDZMyyV/mIxEFC0NgWhiMhJZ1JQ0Ar4UfUJ3mSrlzfI0CtzlopDHyg==\n\t]]>\n\t<![CDATA[\n\tL5ARjjGylA1eQUDuMHbS4TpaFoG/UaDiHIqSeNTMDzfiOzyI53AbbiPDZWJ4TA2v4TRXHjPDa3gM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\n\t]]>\n\t<![CDATA[\n\tDmLMu2v61DynQYTgNIgRhn8ps3vLyJ3RvNNamLGavo71movo+uIbKny4stkyBByUHYSWEvIWK6ls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\n\t]]>\n\t<![CDATA[\n\tSm8hAa0PlFD0g3B1D+JdD2rk+0GKf76HcK8XTQJ+pU0vFYnGLiFIp7xhy6ksgQmnPFUikYYvjeZd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\n\t]]>\n\t<![CDATA[\n\tOm9i0q5u7zux3qFStp7vvV0cBbhE7hzGb1pKuQEJqB9HAFgZpFOo+4CgZxdO/qoSrOMGH8sE8t43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\n\t]]>\n\t<![CDATA[\n\tqjZJfOZUjnS/o+/ZWPtlvehXBaofw0VuYB+Pn49JfWByANDNaFo0uvMwI01BEY/GXI2joRGwaQUF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\n\t]]>\n\t<![CDATA[\n\tk/ut02mxqjHqWM70tlBWlunc1/W2MmmxpdTnY7JSPV9ez3TuTZ/aWvPGrudTXTP7mKy1/qTUUklb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\n\t]]>\n\t<![CDATA[\n\tDLfR48JuO32qEwjObhS7UQTBbhRDEDzNEAQf7/z7bh+aisshiIALNzJBSZ42j0NtGwNmCIIfyAxB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\n\t]]>\n\t<![CDATA[\n\tGDu5j3cXHLc5W5xhcdNWqqAA+pQbBb1PS7tqxmAEbY0jzt4mne/BHFKNN45vDlUjjknb1y+UAx+g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\n\t]]>\n\t<![CDATA[\n\tEGAkWZ418k5POz6GVKuPSKqV5uSVZPLGSq5052tIdQCog/WGmpwYC7J5D2avD4Muoia0ZEDweDJf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\n\t]]>\n\t<![CDATA[\n\t1gcnAr1wD9Qu5k1M70XHJq6oCAMSBpKnHyJn8VNX0SIb9HDt8m8tYBCAVKeEjC8mxNhdVkjJ/ITs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\n\t]]>\n\t<![CDATA[\n\tf6J/cZyZVghoWK+GozirhbZv9QqgBNc2pLhwvxeXRd5OYRhBgcWB6gWoyQleL2MwhWPFbn56lGlk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\n\t]]>\n\t<![CDATA[\n\t3ksDOkyvDz3dd7h/jmBwmPZ5ASa8l6nAGfmjGvCb+U16ykZtJvMU5aHS1l4KA02QMNbL/1Mg6n8p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\n\t]]>\n\t<![CDATA[\n\tJLp01h2N5VKLVsuQPc5GQAt3nuAiqV5nVzj43HjokJYVZpTyDsQhHYl4FN/RbA+nnXvTPm6DKMqK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\n\t]]>\n\t<![CDATA[\n\tXQelWOuAOWTZjKFF8LyG2OzFOpke2L2RStpuJHJiltuliMZs1PLkMdYmxLw36PGCjoqSl+mr+U1l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\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z\"/><path d=\"M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z\"/></g></switch></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--business-automation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakBusinessAutomation32",
          "filepath": "ibm-cloud-pak--business-automation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "ibm-cloud-pak--business-automation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakBusinessAutomation24",
          "filepath": "ibm-cloud-pak--business-automation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "ibm-cloud-pak--business-automation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakBusinessAutomation20",
          "filepath": "ibm-cloud-pak--business-automation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "ibm-cloud-pak--business-automation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakBusinessAutomation16",
          "filepath": "ibm-cloud-pak--business-automation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "ibm-cloud-pak--business-automation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakBusinessAutomation",
        "global": "IbmCloudPakBusinessAutomation",
        "filepath": "IbmCloudPakBusinessAutomation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--data",
      "friendlyName": "IBM Cloud Pak® for Data",
      "aliases": [
        "enterprise",
        "app catalog",
        "catalogue",
        "data",
        "IBM Cloud Pak®"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--data.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"23\" cy=\"15\" r=\"1\"/>\n  <circle cx=\"8\" cy=\"15\" r=\"1\"/>\n  <circle cx=\"21\" cy=\"10\" r=\"1\"/>\n  <circle cx=\"15\" cy=\"23\" r=\"1\"/>\n  <path d=\"M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"15\" r=\"1\"/><circle cx=\"8\" cy=\"15\" r=\"1\"/><circle cx=\"21\" cy=\"10\" r=\"1\"/><circle cx=\"15\" cy=\"23\" r=\"1\"/><path d=\"M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--data.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakData32",
          "filepath": "ibm-cloud-pak--data/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--data",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakData24",
          "filepath": "ibm-cloud-pak--data/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--data",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakData20",
          "filepath": "ibm-cloud-pak--data/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--data",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakData16",
          "filepath": "ibm-cloud-pak--data/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--data",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakData",
        "global": "IbmCloudPakData",
        "filepath": "IbmCloudPakData.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "15",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "15",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "10",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--integration",
      "friendlyName": "IBM Cloud Pak® for Integration",
      "aliases": [
        "enterprise",
        "app catalog",
        "catalogue",
        "integration",
        "IBM Cloud Pak®"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--integration.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.1213,9.8787a3,3,0,0,0-4.2426,0l-.4645.4644,1.4142,1.4142.4645-.4645a1,1,0,0,1,1.4142,1.4144L17.4142,16l1.4143,1.4142,3.2928-3.2929A3,3,0,0,0,22.1213,9.8787Z\"/>\n  <path d=\"M12.7071,20.7072a1,1,0,0,1-1.4142-1.4144L14.5858,16l-1.4142-1.4142L9.8787,17.8787a3,3,0,1,0,4.2426,4.2426l.4645-.4644-1.4142-1.4143Z\"/>\n  <path d=\"M14.1213,9.8787a3,3,0,0,0-4.2426,4.2426l.4645.4645,1.4142-1.4142-.4645-.4645a1,1,0,0,1,1.4142-1.4143L16,14.5858l1.4142-1.4143Z\"/>\n  <path d=\"M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z\"/><path d=\"M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--integration.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakIntegration32",
          "filepath": "ibm-cloud-pak--integration/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--integration",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakIntegration24",
          "filepath": "ibm-cloud-pak--integration/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--integration",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakIntegration20",
          "filepath": "ibm-cloud-pak--integration/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--integration",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakIntegration16",
          "filepath": "ibm-cloud-pak--integration/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--integration",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakIntegration",
        "global": "IbmCloudPakIntegration",
        "filepath": "IbmCloudPakIntegration.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--MANTA-automated-data-lineage",
      "friendlyName": "MANTA Automated Data Lineage for IBM Cloud Pak® for Data",
      "aliases": [
        "data",
        "IBM Cloud Pak® for Data",
        "data lineage",
        "automation",
        "MANTA",
        "data fabric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--MANTA-automated-data-lineage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--MANTA-automated-data-lineage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakMantaAutomatedDataLineage32",
          "filepath": "ibm-cloud-pak--MANTA-automated-data-lineage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--MANTA-automated-data-lineage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakMantaAutomatedDataLineage24",
          "filepath": "ibm-cloud-pak--MANTA-automated-data-lineage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--MANTA-automated-data-lineage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakMantaAutomatedDataLineage20",
          "filepath": "ibm-cloud-pak--MANTA-automated-data-lineage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--MANTA-automated-data-lineage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakMantaAutomatedDataLineage16",
          "filepath": "ibm-cloud-pak--MANTA-automated-data-lineage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--MANTA-automated-data-lineage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakMantaAutomatedDataLineage",
        "global": "IbmCloudPakMantaAutomatedDataLineage",
        "filepath": "IbmCloudPakMantaAutomatedDataLineage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--multicloud-mgmt",
      "friendlyName": "IBM Cloud Pak® for Multicloud Management",
      "aliases": [
        "enterprise",
        "app catalog",
        "catalogue",
        "applications",
        "IBM Cloud Pak®"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--multicloud-mgmt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--multicloud-mgmt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakMulticloudMgmt32",
          "filepath": "ibm-cloud-pak--multicloud-mgmt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--multicloud-mgmt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakMulticloudMgmt24",
          "filepath": "ibm-cloud-pak--multicloud-mgmt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--multicloud-mgmt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakMulticloudMgmt20",
          "filepath": "ibm-cloud-pak--multicloud-mgmt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--multicloud-mgmt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakMulticloudMgmt16",
          "filepath": "ibm-cloud-pak--multicloud-mgmt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--multicloud-mgmt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakMulticloudMgmt",
        "global": "IbmCloudPakMulticloudMgmt",
        "filepath": "IbmCloudPakMulticloudMgmt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--netezza",
      "friendlyName": "ibm-cloud-pak--netezza",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--netezza.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"19,10 19,19.2 13.5,10 11,10 11,22 13,22 13,12.8 18.5,22 21,22 21,10 \"/>\n<path d=\"M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\n\tS22.6,4,16,4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z\"/><path d=\"M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--netezza.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakNetezza32",
          "filepath": "ibm-cloud-pak--netezza/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud-pak--netezza",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakNetezza24",
          "filepath": "ibm-cloud-pak--netezza/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud-pak--netezza",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakNetezza20",
          "filepath": "ibm-cloud-pak--netezza/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud-pak--netezza",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakNetezza16",
          "filepath": "ibm-cloud-pak--netezza/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
                }
              }
            ],
            "name": "ibm-cloud-pak--netezza",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakNetezza",
        "global": "IbmCloudPakNetezza",
        "filepath": "IbmCloudPakNetezza.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12 S22.6,4,16,4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--network-automation",
      "friendlyName": "IBM Cloud Pak® Network Automation",
      "aliases": [
        "IBM Cloud Pak®",
        "network",
        "automation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--network-automation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z\"/>\n  <path d=\"M19.5356,18.5354l-1.414-1.4141a3.0039,3.0039,0,0,0,0-4.2426l1.414-1.4141A5.0048,5.0048,0,0,1,19.5356,18.5354Z\"/>\n  <path d=\"M17,26H15V15a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1Z\"/>\n  <path d=\"M12.4644,18.5354a5.0048,5.0048,0,0,1,0-7.0708l1.414,1.4141a3.0039,3.0039,0,0,0,0,4.2426Z\"/>\n  <path d=\"M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z\"/><path d=\"M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z\"/><path d=\"M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--network-automation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakNetworkAutomation32",
          "filepath": "ibm-cloud-pak--network-automation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--network-automation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakNetworkAutomation24",
          "filepath": "ibm-cloud-pak--network-automation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--network-automation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakNetworkAutomation20",
          "filepath": "ibm-cloud-pak--network-automation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--network-automation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakNetworkAutomation16",
          "filepath": "ibm-cloud-pak--network-automation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--network-automation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakNetworkAutomation",
        "global": "IbmCloudPakNetworkAutomation",
        "filepath": "IbmCloudPakNetworkAutomation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--security",
      "friendlyName": "IBM Cloud Pak® for Security",
      "aliases": [
        "enterprise",
        "app catalog",
        "catalogue",
        "security",
        "IBM Cloud Pak®"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--security.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--security.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakSecurity32",
          "filepath": "ibm-cloud-pak--security/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--security",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakSecurity24",
          "filepath": "ibm-cloud-pak--security/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--security",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakSecurity20",
          "filepath": "ibm-cloud-pak--security/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--security",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakSecurity16",
          "filepath": "ibm-cloud-pak--security/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--security",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakSecurity",
        "global": "IbmCloudPakSecurity",
        "filepath": "IbmCloudPakSecurity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--system",
      "friendlyName": "IBM Cloud Pak® System",
      "aliases": [
        "enterprise",
        "app catalog",
        "catalogue",
        "system",
        "IBM Cloud Pak®"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--system.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15.0001\" y=\"11.6715\" width=\"1.9998\" height=\"3.6571\" transform=\"translate(-4.8597 15.2678) rotate(-45)\"/>\n  <rect x=\"15.0001\" y=\"16.6715\" width=\"1.9998\" height=\"3.6571\" transform=\"translate(-8.3952 16.7322) rotate(-45)\"/>\n  <path d=\"M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 11.671H17V15.328H15z\" transform=\"rotate(-45 16 13.5)\"/><path d=\"M15 16.672H17V20.329H15z\" transform=\"rotate(-45 16 18.5)\"/><path d=\"M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--system.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakSystem32",
          "filepath": "ibm-cloud-pak--system/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11.671H17V15.328H15z",
                  "transform": "rotate(-45 16 13.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16.672H17V20.329H15z",
                  "transform": "rotate(-45 16 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--system",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakSystem24",
          "filepath": "ibm-cloud-pak--system/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11.671H17V15.328H15z",
                  "transform": "rotate(-45 16 13.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16.672H17V20.329H15z",
                  "transform": "rotate(-45 16 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--system",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakSystem20",
          "filepath": "ibm-cloud-pak--system/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11.671H17V15.328H15z",
                  "transform": "rotate(-45 16 13.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16.672H17V20.329H15z",
                  "transform": "rotate(-45 16 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--system",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakSystem16",
          "filepath": "ibm-cloud-pak--system/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11.671H17V15.328H15z",
                  "transform": "rotate(-45 16 13.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16.672H17V20.329H15z",
                  "transform": "rotate(-45 16 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--system",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakSystem",
        "global": "IbmCloudPakSystem",
        "filepath": "IbmCloudPakSystem.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 11.671H17V15.328H15z",
                    "transform": "rotate(-45 16 13.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 16.672H17V20.329H15z",
                    "transform": "rotate(-45 16 18.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-cloud-pak--watson-aiops",
      "friendlyName": "IBM Cloud Pak® Watson AIOps",
      "aliases": [
        "IBM Cloud Pak®",
        "Watson",
        "AIOps",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-cloud-pak--watson-aiops.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z\"/>\n  <path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z\"/><path d=\"M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-cloud-pak--watson-aiops.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmCloudPakWatsonAiops32",
          "filepath": "ibm-cloud-pak--watson-aiops/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--watson-aiops",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmCloudPakWatsonAiops24",
          "filepath": "ibm-cloud-pak--watson-aiops/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--watson-aiops",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmCloudPakWatsonAiops20",
          "filepath": "ibm-cloud-pak--watson-aiops/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--watson-aiops",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmCloudPakWatsonAiops16",
          "filepath": "ibm-cloud-pak--watson-aiops/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-cloud-pak--watson-aiops",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmCloudPakWatsonAiops",
        "global": "IbmCloudPakWatsonAiops",
        "filepath": "IbmCloudPakWatsonAiops.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-security",
      "friendlyName": "IBM Security™",
      "aliases": [
        "safe",
        "cyber security",
        "hacking",
        "data security",
        "offering",
        "product",
        "protection",
        "cyber crime",
        "cyber",
        "secure",
        "IBM Security"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-security.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ibm-security</title><path id=\"IBM_Security_Shield\" data-name=\"IBM Security Shield\" d=\"M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z\"/></svg>",
            "info": {},
            "path": "32/ibm-security.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmSecurity32",
          "filepath": "ibm-security/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
                }
              }
            ],
            "name": "ibm-security",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmSecurity24",
          "filepath": "ibm-security/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
                }
              }
            ],
            "name": "ibm-security",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmSecurity20",
          "filepath": "ibm-security/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
                }
              }
            ],
            "name": "ibm-security",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmSecurity16",
          "filepath": "ibm-security/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
                }
              }
            ],
            "name": "ibm-security",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "IbmSecurity",
        "global": "IbmSecurity",
        "filepath": "IbmSecurity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-security--services",
      "friendlyName": "IBM Security™ Services",
      "aliases": [
        "IBM Security™",
        "services",
        "app",
        "applications",
        "cybersecurity",
        "security"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-security--services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z\"/><path d=\"M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z\"/></svg>",
            "info": {},
            "path": "32/ibm-security--services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmSecurityServices32",
          "filepath": "ibm-security--services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-security--services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmSecurityServices24",
          "filepath": "ibm-security--services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-security--services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmSecurityServices20",
          "filepath": "ibm-security--services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-security--services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmSecurityServices16",
          "filepath": "ibm-security--services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
                }
              }
            ],
            "name": "ibm-security--services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmSecurityServices",
        "global": "IbmSecurityServices",
        "filepath": "IbmSecurityServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--assistant",
      "friendlyName": "ibm-watson--assistant",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--assistant.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,2H18c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h2.4l1.7,3l1.7-1l-2.3-4H18V4h10v6h-3v2h3c1.1,0,2-0.9,2-2V4\n\tC30,2.9,29.1,2,28,2z\"/>\n<path d=\"M14.7,31L13,30l3.5-6H22c1.1,0,2-0.9,2-2v-5h2v5c0,2.2-1.8,4-4,4h-4.4L14.7,31z\"/>\n<circle cx=\"10\" cy=\"17\" r=\"1\"/>\n<circle cx=\"14\" cy=\"17\" r=\"1\"/>\n<circle cx=\"18\" cy=\"17\" r=\"1\"/>\n<path d=\"M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z\"/><circle cx=\"10\" cy=\"17\" r=\"1\"/><circle cx=\"14\" cy=\"17\" r=\"1\"/><circle cx=\"18\" cy=\"17\" r=\"1\"/><path d=\"M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--assistant.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonAssistant32",
          "filepath": "ibm-watson--assistant/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
                }
              }
            ],
            "name": "ibm-watson--assistant",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonAssistant24",
          "filepath": "ibm-watson--assistant/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
                }
              }
            ],
            "name": "ibm-watson--assistant",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonAssistant20",
          "filepath": "ibm-watson--assistant/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
                }
              }
            ],
            "name": "ibm-watson--assistant",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonAssistant16",
          "filepath": "ibm-watson--assistant/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "17",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
                }
              }
            ],
            "name": "ibm-watson--assistant",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonAssistant",
        "global": "IbmWatsonAssistant",
        "filepath": "IbmWatsonAssistant.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18",
                    "cy": "17",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--discovery",
      "friendlyName": "ibm-watson--discovery",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--discovery.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"6\" y=\"17\" width=\"8\" height=\"2\"/>\n<circle cx=\"3\" cy=\"18\" r=\"1\"/>\n<circle cx=\"13\" cy=\"14\" r=\"1\"/>\n<rect x=\"2\" y=\"13\" width=\"8\" height=\"2\"/>\n<rect x=\"6\" y=\"9\" width=\"8\" height=\"2\"/>\n<circle cx=\"3\" cy=\"10\" r=\"1\"/>\n<path d=\"M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\n\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 17H14V19H6z\"/><circle cx=\"3\" cy=\"18\" r=\"1\"/><circle cx=\"13\" cy=\"14\" r=\"1\"/><path d=\"M2 13H10V15H2zM6 9H14V11H6z\"/><circle cx=\"3\" cy=\"10\" r=\"1\"/><path d=\"M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--discovery.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonDiscovery32",
          "filepath": "ibm-watson--discovery/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 17H14V19H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 13H10V15H2zM6 9H14V11H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
                }
              }
            ],
            "name": "ibm-watson--discovery",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonDiscovery24",
          "filepath": "ibm-watson--discovery/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 17H14V19H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 13H10V15H2zM6 9H14V11H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
                }
              }
            ],
            "name": "ibm-watson--discovery",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonDiscovery20",
          "filepath": "ibm-watson--discovery/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 17H14V19H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 13H10V15H2zM6 9H14V11H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
                }
              }
            ],
            "name": "ibm-watson--discovery",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonDiscovery16",
          "filepath": "ibm-watson--discovery/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 17H14V19H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "18",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "14",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 13H10V15H2zM6 9H14V11H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "10",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
                }
              }
            ],
            "name": "ibm-watson--discovery",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonDiscovery",
        "global": "IbmWatsonDiscovery",
        "filepath": "IbmWatsonDiscovery.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 17H14V19H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "18",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13",
                    "cy": "14",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 13H10V15H2zM6 9H14V11H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "10",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4 c5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--knowledge-catalog",
      "friendlyName": "ibm-watson--knowledge-catalog",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--knowledge-catalog.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"23,27.2 20.4,24.6 19,26 23,30 30,23 28.6,21.6 \"/>\n<rect x=\"12\" y=\"18\" width=\"8\" height=\"2\"/>\n<rect x=\"12\" y=\"13\" width=\"8\" height=\"2\"/>\n<rect x=\"12\" y=\"8\" width=\"8\" height=\"2\"/>\n<path d=\"M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\n\tc0,1.1,0.9,2,2,2h10V28z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z\"/><path d=\"M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--knowledge-catalog.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonKnowledgeCatalog32",
          "filepath": "ibm-watson--knowledge-catalog/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-catalog",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonKnowledgeCatalog24",
          "filepath": "ibm-watson--knowledge-catalog/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-catalog",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonKnowledgeCatalog20",
          "filepath": "ibm-watson--knowledge-catalog/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-catalog",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonKnowledgeCatalog16",
          "filepath": "ibm-watson--knowledge-catalog/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-catalog",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonKnowledgeCatalog",
        "global": "IbmWatsonKnowledgeCatalog",
        "filepath": "IbmWatsonKnowledgeCatalog.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4 c0,1.1,0.9,2,2,2h10V28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--knowledge-studio",
      "friendlyName": "ibm-watson--knowledge-studio",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--knowledge-studio.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"20\" y=\"25\" width=\"7\" height=\"2\"/>\n<rect x=\"22\" y=\"29\" width=\"3\" height=\"2\"/>\n<path d=\"M27,23h-2c0-1.1,0.4-2,1.2-2.8l0.5-0.5c0.8-0.8,1.3-2,1.3-3.2c0-2.5-2-4.5-4.5-4.5S19,14,19,16.5c0,1.2,0.5,2.3,1.3,3.2\n\tl0.5,0.5C21.6,21,22,21.9,22,23h-2c0-0.5-0.2-1-0.6-1.4l-0.5-0.5c-1.2-1.2-1.9-2.9-1.9-4.6c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5\n\tc0,1.7-0.7,3.4-1.9,4.6l-0.5,0.5C27.2,22,27,22.5,27,23z\"/>\n<rect x=\"6\" y=\"22\" width=\"8\" height=\"2\"/>\n<circle cx=\"12\" cy=\"19\" r=\"1\"/>\n<rect x=\"6\" y=\"18\" width=\"3\" height=\"2\"/>\n<rect x=\"6\" y=\"14\" width=\"7\" height=\"2\"/>\n<rect x=\"10\" y=\"10\" width=\"7\" height=\"2\"/>\n<circle cx=\"7\" cy=\"11\" r=\"1\"/>\n<rect x=\"16\" y=\"6\" width=\"4\" height=\"2\"/>\n<circle cx=\"13\" cy=\"7\" r=\"1\"/>\n<rect x=\"6\" y=\"6\" width=\"4\" height=\"2\"/>\n<path d=\"M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z\"/><circle cx=\"12\" cy=\"19\" r=\"1\"/><path d=\"M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z\"/><circle cx=\"7\" cy=\"11\" r=\"1\"/><path d=\"M16 6H20V8H16z\"/><circle cx=\"13\" cy=\"7\" r=\"1\"/><path d=\"M6 6H10V8H6z\"/><path d=\"M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--knowledge-studio.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonKnowledgeStudio32",
          "filepath": "ibm-watson--knowledge-studio/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H20V8H16z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V8H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-studio",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonKnowledgeStudio24",
          "filepath": "ibm-watson--knowledge-studio/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H20V8H16z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V8H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-studio",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonKnowledgeStudio20",
          "filepath": "ibm-watson--knowledge-studio/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H20V8H16z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V8H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-studio",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonKnowledgeStudio16",
          "filepath": "ibm-watson--knowledge-studio/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "12",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H20V8H16z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V8H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
                }
              }
            ],
            "name": "ibm-watson--knowledge-studio",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonKnowledgeStudio",
        "global": "IbmWatsonKnowledgeStudio",
        "filepath": "IbmWatsonKnowledgeStudio.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "12",
                    "cy": "19",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 6H20V8H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H10V8H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--language-translator",
      "friendlyName": "ibm-watson--language-translator",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--language-translator.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16,28h-3c-3.9,0-7-3.1-7-7v-4h2v4c0,2.8,2.2,5,5,5h3V28z\"/>\n<path d=\"M28,30h2.2l-4.6-11h-2.2l-4.6,11H21l0.8-2h5.3L28,30z M22.7,26l1.8-4.4l1.8,4.4H22.7z\"/>\n<path d=\"M28,15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9,0,7,3.1,7,7V15z\"/>\n<path d=\"M14,5V3H9V1H7v2H2v2h8.2C10,5.9,9.4,7.5,8,9C7.4,8.3,6.9,7.6,6.6,7H4.3c0.4,1,1.1,2.2,2.1,3.3C5.6,11,4.4,11.6,3,12.1\n\tL3.7,14c1.8-0.7,3.2-1.5,4.3-2.3c1.1,0.9,2.5,1.7,4.3,2.3l0.7-1.9c-1.4-0.5-2.6-1.2-3.5-1.8c1.9-2,2.5-4.1,2.7-5.3H14z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--language-translator.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonLanguageTranslator32",
          "filepath": "ibm-watson--language-translator/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
                }
              }
            ],
            "name": "ibm-watson--language-translator",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonLanguageTranslator24",
          "filepath": "ibm-watson--language-translator/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
                }
              }
            ],
            "name": "ibm-watson--language-translator",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonLanguageTranslator20",
          "filepath": "ibm-watson--language-translator/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
                }
              }
            ],
            "name": "ibm-watson--language-translator",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonLanguageTranslator16",
          "filepath": "ibm-watson--language-translator/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
                }
              }
            ],
            "name": "ibm-watson--language-translator",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonLanguageTranslator",
        "global": "IbmWatsonLanguageTranslator",
        "filepath": "IbmWatsonLanguageTranslator.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--machine-learning",
      "friendlyName": "ibm-watson--machine-learning",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--machine-learning.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M3.6,22.5c-1-2-1.6-4.2-1.6-6.5C2,8.3,8.3,2,16,2v2C9.4,4,4,9.4,4,16c0,2,0.5,3.8,1.4,5.5L3.6,22.5z\"/>\n<path d=\"M28,16c0,6.6-5.4,12-12,12c-2.9,0-5.6-1-7.7-2.8l5.7-5.7L12.6,18l-6.5,6.5c-0.4,0.4-0.4,1,0,1.4C8.7,28.5,12.3,30,16,30\n\tc7.7,0,14-6.3,14-14H28z\"/>\n<path d=\"M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\n\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\n\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\n\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z\"/><path d=\"M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--machine-learning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonMachineLearning32",
          "filepath": "ibm-watson--machine-learning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
                }
              }
            ],
            "name": "ibm-watson--machine-learning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonMachineLearning24",
          "filepath": "ibm-watson--machine-learning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
                }
              }
            ],
            "name": "ibm-watson--machine-learning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonMachineLearning20",
          "filepath": "ibm-watson--machine-learning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
                }
              }
            ],
            "name": "ibm-watson--machine-learning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonMachineLearning16",
          "filepath": "ibm-watson--machine-learning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
                }
              }
            ],
            "name": "ibm-watson--machine-learning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonMachineLearning",
        "global": "IbmWatsonMachineLearning",
        "filepath": "IbmWatsonMachineLearning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2 c0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7 c-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5 c0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--natural-language-classifier",
      "friendlyName": "ibm-watson--natural-language-classifier",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--natural-language-classifier.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,12c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h1v4h-3v2h8v-2h-3v-4H28z M24,4h4v6h-4V4z\"\n\t/>\n<polygon points=\"21,22.4 19.6,21 16,24.6 12.4,21 11,22.4 14.6,26 11,29.6 12.4,31 16,27.4 19.6,31 21,29.6 17.4,26 \"/>\n<polygon points=\"12,18 15,18 15,21 17,21 17,18 20,18 20,16 12,16 \"/>\n<path d=\"M10,12V4c0-1.1-0.9-2-2-2H3v2h5v2H4C2.9,6,2,6.9,2,8v2c0,1.1,0.9,2,2,2h1v4H2v2h8v-2H7v-4H10z M4,8h4v2H4V8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--natural-language-classifier.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonNaturalLanguageClassifier32",
          "filepath": "ibm-watson--natural-language-classifier/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-classifier",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonNaturalLanguageClassifier24",
          "filepath": "ibm-watson--natural-language-classifier/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-classifier",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonNaturalLanguageClassifier20",
          "filepath": "ibm-watson--natural-language-classifier/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-classifier",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonNaturalLanguageClassifier16",
          "filepath": "ibm-watson--natural-language-classifier/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-classifier",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonNaturalLanguageClassifier",
        "global": "IbmWatsonNaturalLanguageClassifier",
        "filepath": "IbmWatsonNaturalLanguageClassifier.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--natural-language-understanding",
      "friendlyName": "ibm-watson--natural-language-understanding",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--natural-language-understanding.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"6\" y=\"23\" width=\"5\" height=\"2\"/>\n<rect x=\"6\" y=\"19\" width=\"5\" height=\"2\"/>\n<path d=\"M13,30H4c-1.1,0-2-0.9-2-2V17c0-1.1,0.9-2,2-2h9c1.1,0,2,0.9,2,2v11C15,29.1,14.1,30,13,30z M4,17v11h9V17H4z\"/>\n<rect x=\"19\" y=\"2\" width=\"8\" height=\"2\"/>\n<rect x=\"22\" y=\"6\" width=\"8\" height=\"2\"/>\n<rect x=\"22\" y=\"10\" width=\"8\" height=\"2\"/>\n<rect x=\"19\" y=\"14\" width=\"8\" height=\"2\"/>\n<rect x=\"22\" y=\"18\" width=\"8\" height=\"2\"/>\n<path d=\"M12,1l-1.4,1.4L13.2,5H4C2.9,5,2,5.9,2,7v5h2V7h9.2l-2.6,2.6L12,11l5-5L12,1z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 23H11V25H6zM6 19H11V21H6z\"/><path d=\"M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--natural-language-understanding.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonNaturalLanguageUnderstanding32",
          "filepath": "ibm-watson--natural-language-understanding/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 23H11V25H6zM6 19H11V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-understanding",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonNaturalLanguageUnderstanding24",
          "filepath": "ibm-watson--natural-language-understanding/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 23H11V25H6zM6 19H11V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-understanding",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonNaturalLanguageUnderstanding20",
          "filepath": "ibm-watson--natural-language-understanding/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 23H11V25H6zM6 19H11V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-understanding",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonNaturalLanguageUnderstanding16",
          "filepath": "ibm-watson--natural-language-understanding/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 23H11V25H6zM6 19H11V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
                }
              }
            ],
            "name": "ibm-watson--natural-language-understanding",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonNaturalLanguageUnderstanding",
        "global": "IbmWatsonNaturalLanguageUnderstanding",
        "filepath": "IbmWatsonNaturalLanguageUnderstanding.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 23H11V25H6zM6 19H11V21H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--openscale",
      "friendlyName": "ibm-watson--openscale",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--openscale.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M4,28c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S5.7,28,4,28z M4,24c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S4.6,24,4,24z\"/>\n<path d=\"M28,28c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S29.7,28,28,28z M28,24c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S28.6,24,28,24z\"\n\t/>\n<path d=\"M22.4,4.4l-0.9,1.8C26.1,8.4,29,13,29,18c0,0.7-0.1,1.4-0.2,2.1l2,0.3c0.1-0.8,0.2-1.6,0.2-2.5C31,12.2,27.6,6.9,22.4,4.4z\"\n\t/>\n<path d=\"M16,7c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,7,16,7z M16,3c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S16.6,3,16,3z\"/>\n<path d=\"M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\n\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z\"/><path d=\"M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--openscale.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonOpenscale32",
          "filepath": "ibm-watson--openscale/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
                }
              }
            ],
            "name": "ibm-watson--openscale",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonOpenscale24",
          "filepath": "ibm-watson--openscale/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
                }
              }
            ],
            "name": "ibm-watson--openscale",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonOpenscale20",
          "filepath": "ibm-watson--openscale/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
                }
              }
            ],
            "name": "ibm-watson--openscale",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonOpenscale16",
          "filepath": "ibm-watson--openscale/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
                }
              }
            ],
            "name": "ibm-watson--openscale",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonOpenscale",
        "global": "IbmWatsonOpenscale",
        "filepath": "IbmWatsonOpenscale.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30 c0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--orders",
      "friendlyName": "IBM Watson® Orders",
      "aliases": [
        "IBM Watson®",
        "enterprise",
        "app",
        "orders"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--orders.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9,0,7,3.1,7,7V13z\"/>\n<rect x=\"22\" y=\"20\" width=\"3\" height=\"2\"/>\n<rect x=\"22\" y=\"24\" width=\"3\" height=\"2\"/>\n<path d=\"M27,30h-5v-2h5V18h-7v9c0,1.7-1.3,3-3,3s-3-1.3-3-3v-3h2v3c0,0.6,0.4,1,1,1s1-0.4,1-1V16h11v12C29,29.1,28.1,30,27,30z\"/>\n<path d=\"M12,28h-1c-3.9,0-7-3.1-7-7v-4h2v4c0,2.8,2.2,5,5,5h1V28z\"/>\n<path d=\"M11,10v2h3c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v6c0,1.1,0.9,2,2,2h2.4l1.7,3l1.7-1l-2.3-4H4V4h10v6H11z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z\"/><path d=\"M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--orders.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonOrders32",
          "filepath": "ibm-watson--orders/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
                }
              }
            ],
            "name": "ibm-watson--orders",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonOrders24",
          "filepath": "ibm-watson--orders/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
                }
              }
            ],
            "name": "ibm-watson--orders",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonOrders20",
          "filepath": "ibm-watson--orders/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
                }
              }
            ],
            "name": "ibm-watson--orders",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonOrders16",
          "filepath": "ibm-watson--orders/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
                }
              }
            ],
            "name": "ibm-watson--orders",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonOrders",
        "global": "IbmWatsonOrders",
        "filepath": "IbmWatsonOrders.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--query",
      "friendlyName": "ibm-watson--query",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--query.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\n\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\n\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z\n\t M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z\"/>\n<path d=\"M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\n\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\n\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z\"/><path d=\"M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--query.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonQuery32",
          "filepath": "ibm-watson--query/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-watson--query",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonQuery24",
          "filepath": "ibm-watson--query/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-watson--query",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonQuery20",
          "filepath": "ibm-watson--query/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-watson--query",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonQuery16",
          "filepath": "ibm-watson--query/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                }
              }
            ],
            "name": "ibm-watson--query",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonQuery",
        "global": "IbmWatsonQuery",
        "filepath": "IbmWatsonQuery.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24 c-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1 c-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--speech-to-text",
      "friendlyName": "ibm-watson--speech-to-text",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--speech-to-text.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M14,18H4c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h2.4l1.7,3l1.7-1l-2.3-4H4v-6h10v6h-3v2h3c1.1,0,2-0.9,2-2v-6\n\tC16,18.9,15.1,18,14,18z\"/>\n<path d=\"M19,26h2c3.9,0,7-3.1,7-7v-2h-2v2c0,2.8-2.2,5-5,5h-2V26z\"/>\n<rect x=\"18\" y=\"11\" width=\"6\" height=\"2\"/>\n<rect x=\"18\" y=\"7\" width=\"12\" height=\"2\"/>\n<rect x=\"18\" y=\"3\" width=\"12\" height=\"2\"/>\n<path d=\"M4,14h2v-2c0-2.8,2.2-5,5-5h4V5h-4c-3.9,0-7,3.1-7,7V14z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--speech-to-text.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonSpeechToText32",
          "filepath": "ibm-watson--speech-to-text/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
                }
              }
            ],
            "name": "ibm-watson--speech-to-text",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonSpeechToText24",
          "filepath": "ibm-watson--speech-to-text/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
                }
              }
            ],
            "name": "ibm-watson--speech-to-text",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonSpeechToText20",
          "filepath": "ibm-watson--speech-to-text/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
                }
              }
            ],
            "name": "ibm-watson--speech-to-text",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonSpeechToText16",
          "filepath": "ibm-watson--speech-to-text/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
                }
              }
            ],
            "name": "ibm-watson--speech-to-text",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonSpeechToText",
        "global": "IbmWatsonSpeechToText",
        "filepath": "IbmWatsonSpeechToText.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--studio",
      "friendlyName": "ibm-watson--studio",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--studio.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M25,21c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S27.8,21,25,21z M25,13c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S26.7,13,25,13z\"\n\t/>\n<path d=\"M14,11V6c0-1.1-0.9-2-2-2h-2v2h2v5c0,2.1,1.1,3.9,2.7,5c-1.6,1.1-2.7,2.9-2.7,5v5h-2v2h2c1.1,0,2-0.9,2-2v-5\n\tc0-2.2,1.8-4,4-4v-2C15.8,15,14,13.2,14,11z\"/>\n<path d=\"M2,30v-6h6v6H2z M4,26v2h2v-2H4z\"/>\n<path d=\"M2,19v-6h6v6H2z M4,15v2h2v-2H4z\"/>\n<path d=\"M2,8V2h6v6H2z M4,4v2h2V4H4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--studio.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonStudio32",
          "filepath": "ibm-watson--studio/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
                }
              }
            ],
            "name": "ibm-watson--studio",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonStudio24",
          "filepath": "ibm-watson--studio/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
                }
              }
            ],
            "name": "ibm-watson--studio",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonStudio20",
          "filepath": "ibm-watson--studio/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
                }
              }
            ],
            "name": "ibm-watson--studio",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonStudio16",
          "filepath": "ibm-watson--studio/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
                }
              }
            ],
            "name": "ibm-watson--studio",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonStudio",
        "global": "IbmWatsonStudio",
        "filepath": "IbmWatsonStudio.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--text-to-speech",
      "friendlyName": "ibm-watson--text-to-speech",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--text-to-speech.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M13,26h-2c-3.9,0-7-3.1-7-7v-2h2v2c0,2.8,2.2,5,5,5h2V26z\"/>\n<path d=\"M18,18h10c1.1,0,2,0.9,2,2v6c0,1.1-0.9,2-2,2h-2.4l-1.7,3l-1.7-1l2.3-4H28v-6H18v6h3v2h-3c-1.1,0-2-0.9-2-2v-6\n\tC16,18.9,16.9,18,18,18z\"/>\n<path d=\"M28,14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9,0,7,3.1,7,7V14z\"/>\n<rect x=\"2\" y=\"11\" width=\"6\" height=\"2\"/>\n<rect x=\"2\" y=\"7\" width=\"12\" height=\"2\"/>\n<rect x=\"2\" y=\"3\" width=\"12\" height=\"2\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--text-to-speech.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonTextToSpeech32",
          "filepath": "ibm-watson--text-to-speech/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
                }
              }
            ],
            "name": "ibm-watson--text-to-speech",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonTextToSpeech24",
          "filepath": "ibm-watson--text-to-speech/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
                }
              }
            ],
            "name": "ibm-watson--text-to-speech",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonTextToSpeech20",
          "filepath": "ibm-watson--text-to-speech/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
                }
              }
            ],
            "name": "ibm-watson--text-to-speech",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonTextToSpeech16",
          "filepath": "ibm-watson--text-to-speech/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
                }
              }
            ],
            "name": "ibm-watson--text-to-speech",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonTextToSpeech",
        "global": "IbmWatsonTextToSpeech",
        "filepath": "IbmWatsonTextToSpeech.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-watson--tone-analyzer",
      "friendlyName": "ibm-watson--tone-analyzer",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-watson--tone-analyzer.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z\"/>\n<circle cx=\"24\" cy=\"5\" r=\"1\"/>\n<circle cx=\"19\" cy=\"5\" r=\"1\"/>\n<path d=\"M15,0l13,0c1.1,0,2,0.9,2,2v10c0,1.1-0.9,2-2,2h-3.5l-1.7,3L21,16l2.3-4H28V2H15v10h5v2h-5c-1.1,0-2-0.9-2-2V2\n\tC13,0.9,13.9,0,15,0z\"/>\n<path d=\"M20,19v6c0,0.6-0.4,1-1,1h-5v2h5c1.7,0,3-1.3,3-3v-6H20z\"/>\n<path d=\"M15.4,20.4c-0.8,1-2.1,1.6-3.4,1.6s-2.6-0.6-3.4-1.6L7,21.6c1.2,1.4,3,2.4,5,2.4s3.8-0.9,5-2.4L15.4,20.4z\"/>\n<circle cx=\"15.5\" cy=\"17.5\" r=\"1.5\"/>\n<circle cx=\"8.5\" cy=\"17.5\" r=\"1.5\"/>\n<path d=\"M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z\"/><circle cx=\"24\" cy=\"5\" r=\"1\"/><circle cx=\"19\" cy=\"5\" r=\"1\"/><path d=\"M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z\"/><circle cx=\"15.5\" cy=\"17.5\" r=\"1.5\"/><circle cx=\"8.5\" cy=\"17.5\" r=\"1.5\"/><path d=\"M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z\"/></svg>",
            "info": {},
            "path": "32/ibm-watson--tone-analyzer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmWatsonToneAnalyzer32",
          "filepath": "ibm-watson--tone-analyzer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
                }
              }
            ],
            "name": "ibm-watson--tone-analyzer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmWatsonToneAnalyzer24",
          "filepath": "ibm-watson--tone-analyzer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
                }
              }
            ],
            "name": "ibm-watson--tone-analyzer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmWatsonToneAnalyzer20",
          "filepath": "ibm-watson--tone-analyzer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
                }
              }
            ],
            "name": "ibm-watson--tone-analyzer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmWatsonToneAnalyzer16",
          "filepath": "ibm-watson--tone-analyzer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "19",
                  "cy": "5",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8.5",
                  "cy": "17.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
                }
              }
            ],
            "name": "ibm-watson--tone-analyzer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmWatsonToneAnalyzer",
        "global": "IbmWatsonToneAnalyzer",
        "filepath": "IbmWatsonToneAnalyzer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "5",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "19",
                    "cy": "5",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15.5",
                    "cy": "17.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8.5",
                    "cy": "17.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-z--cloud-mod-stack",
      "friendlyName": "IBM Z® Cloud Modernization Stack",
      "aliases": [
        "cloud",
        "modernization",
        "IBM Z®",
        "mainframe",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-z--cloud-mod-stack.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\n\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\n\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z\"/>\n<path d=\"M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\n\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\n\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z\"/>\n<path d=\"M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\n\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\n\tC24,18.262,23.595,17.624,23,17.277z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z\"/><path d=\"M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z\"/><path d=\"M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z\"/></svg>",
            "info": {},
            "path": "32/ibm-z--cloud-mod-stack.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmZCloudModStack32",
          "filepath": "ibm-z--cloud-mod-stack/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
                }
              }
            ],
            "name": "ibm-z--cloud-mod-stack",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmZCloudModStack24",
          "filepath": "ibm-z--cloud-mod-stack/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
                }
              }
            ],
            "name": "ibm-z--cloud-mod-stack",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmZCloudModStack20",
          "filepath": "ibm-z--cloud-mod-stack/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
                }
              }
            ],
            "name": "ibm-z--cloud-mod-stack",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmZCloudModStack16",
          "filepath": "ibm-z--cloud-mod-stack/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
                }
              }
            ],
            "name": "ibm-z--cloud-mod-stack",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmZCloudModStack",
        "global": "IbmZCloudModStack",
        "filepath": "IbmZCloudModStack.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2 s-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7 C15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19 c0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137 c0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7 C3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2 C24,18.262,23.595,17.624,23,17.277z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-z-cloud--provisioning",
      "friendlyName": "IBM Z® and Cloud Modernization Stack Provisioning",
      "aliases": [
        "IBM Z®",
        "cloud",
        "provisioning",
        "mainframe",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-z-cloud--provisioning.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"10\" y=\"17\" width=\"4\" height=\"4\"/>\n<rect x=\"17\" y=\"10\" width=\"4\" height=\"4\"/>\n<rect x=\"17\" y=\"17\" width=\"4\" height=\"4\"/>\n<path d=\"M19.758,26.65L16,28.842L5,22.426V18H3v5c0,0.355,0.189,0.685,0.496,0.864l12,7C15.652,30.955,15.826,31,16,31\n\ts0.348-0.045,0.504-0.136l4.282-2.498L19.758,26.65z\"/>\n<path d=\"M28.504,8.136l-4.269-2.49l-1.029,1.715L27,9.574v12.852l-3.787,2.209l1.029,1.715l4.262-2.486\n\tC28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z\"/>\n<path d=\"M5,9.574l11-6.417l3.751,2.188L20.78,3.63l-4.276-2.494C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\n\tC3.189,8.315,3,8.645,3,9v5h2V9.574z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z\"/><path d=\"M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z\"/></svg>",
            "info": {},
            "path": "32/ibm-z-cloud--provisioning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmZCloudProvisioning32",
          "filepath": "ibm-z-cloud--provisioning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-cloud--provisioning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmZCloudProvisioning24",
          "filepath": "ibm-z-cloud--provisioning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-cloud--provisioning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmZCloudProvisioning20",
          "filepath": "ibm-z-cloud--provisioning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-cloud--provisioning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmZCloudProvisioning16",
          "filepath": "ibm-z-cloud--provisioning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-cloud--provisioning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmZCloudProvisioning",
        "global": "IbmZCloudProvisioning",
        "filepath": "IbmZCloudProvisioning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ibm-z-os--package-manager",
      "friendlyName": "IBM® z/OS Package Manager",
      "aliases": [
        "IBM Z®",
        "cloud",
        "mainframe",
        "modernization",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ibm-z-os--package-manager.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M15,9v10.172l-2.586-2.586L11,18l5,5l5-5l-1.414-1.414L17,19.172V9H15z\"/>\n<path d=\"M19.758,26.65L16,28.842L5,22.426V18H3v5c0,0.355,0.189,0.685,0.496,0.864l12,7C15.652,30.955,15.826,31,16,31\n\ts0.348-0.045,0.504-0.136l4.282-2.498L19.758,26.65z\"/>\n<path d=\"M28.504,8.136l-4.269-2.49l-1.029,1.715L27,9.574v12.852l-3.787,2.209l1.029,1.715l4.262-2.486\n\tC28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z\"/>\n<path d=\"M5,9.574l11-6.417l3.751,2.188L20.78,3.63l-4.276-2.494C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\n\tC3.189,8.315,3,8.645,3,9v5h2V9.574z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z\"/></svg>",
            "info": {},
            "path": "32/ibm-z-os--package-manager.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IbmZOsPackageManager32",
          "filepath": "ibm-z-os--package-manager/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-os--package-manager",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IbmZOsPackageManager24",
          "filepath": "ibm-z-os--package-manager/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-os--package-manager",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IbmZOsPackageManager20",
          "filepath": "ibm-z-os--package-manager/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-os--package-manager",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IbmZOsPackageManager16",
          "filepath": "ibm-z-os--package-manager/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                }
              }
            ],
            "name": "ibm-z-os--package-manager",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "IbmZOsPackageManager",
        "global": "IbmZOsPackageManager",
        "filepath": "IbmZOsPackageManager.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "iCA-2D",
      "friendlyName": "ICA 2D",
      "aliases": [
        "ICA 2D",
        "component",
        "analysis",
        "independent"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/iCA-2D.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,24H10a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2H22a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,22,24ZM10,10V22H22V10Z\"/>\n  <polygon points=\"11 2 2 2 2 11 4 11 4 4 11 4 11 2\"/>\n  <polygon points=\"2 21 2 30 11 30 11 28 4 28 4 21 2 21\"/>\n  <polygon points=\"30 11 30 2 21 2 21 4 28 4 28 11 30 11\"/>\n  <polygon points=\"21 30 30 30 30 21 28 21 28 28 21 28 21 30\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z\"/></svg>",
            "info": {},
            "path": "32/watson-health/iCA-2D.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthICa_2D32",
          "filepath": "watson-health/iCA-2D/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
                }
              }
            ],
            "name": "iCA-2D",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthICa_2D24",
          "filepath": "watson-health/iCA-2D/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
                }
              }
            ],
            "name": "iCA-2D",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthICa_2D20",
          "filepath": "watson-health/iCA-2D/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
                }
              }
            ],
            "name": "iCA-2D",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthICa_2D16",
          "filepath": "watson-health/iCA-2D/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
                }
              }
            ],
            "name": "iCA-2D",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ICa_2D",
        "global": "WatsonHealthICa_2D",
        "filepath": "watson-health/ICa_2D.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ice--accretion",
      "friendlyName": "Ice accretion",
      "aliases": [
        "ice",
        "accretion",
        "ice dam",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ice--accretion.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,2A2,2,0,0,0,2,4V20l1,2,1-2V4H8V14l1,2,1-2V2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,2H14v8l1,2,1-2V4h2V17l1,2,1-2V4h4V14l1,2,1-2V4h2V24l1,2,1-2V4A2,2,0,0,0,28,2Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"14 28 13 30 12 28 12 16 14 16 14 28\"/>\n  <polygon points=\"24 26 23 28 22 26 22 20 24 20 24 26\"/>\n  <polygon points=\"8 24 7 26 6 24 6 18 8 18 8 24\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z\"/><path d=\"M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z\"/></svg>",
            "info": {},
            "path": "32/ice--accretion.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IceAccretion32",
          "filepath": "ice--accretion/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
                }
              }
            ],
            "name": "ice--accretion",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IceAccretion24",
          "filepath": "ice--accretion/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
                }
              }
            ],
            "name": "ice--accretion",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IceAccretion20",
          "filepath": "ice--accretion/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
                }
              }
            ],
            "name": "ice--accretion",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IceAccretion16",
          "filepath": "ice--accretion/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
                }
              }
            ],
            "name": "ice--accretion",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "IceAccretion",
        "global": "IceAccretion",
        "filepath": "IceAccretion.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ice--vision",
      "friendlyName": "Ice vision",
      "aliases": [
        "ice",
        "vision",
        "visibility",
        "weather",
        "forecast",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ice--vision.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"19 14 19 21 20 23 21 21 21 14 19 14\"/>\n  <path d=\"M17,14H13a2,2,0,0,0-2,2v4l1,2,1-2V16h2v7l1,2,1-2Z\"/>\n  <path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z\"/><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/></svg>",
            "info": {},
            "path": "32/ice--vision.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IceVision32",
          "filepath": "ice--vision/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "ice--vision",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IceVision24",
          "filepath": "ice--vision/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "ice--vision",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IceVision20",
          "filepath": "ice--vision/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "ice--vision",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IceVision16",
          "filepath": "ice--vision/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "ice--vision",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "IceVision",
        "global": "IceVision",
        "filepath": "IceVision.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "iD",
      "friendlyName": "ID",
      "aliases": [
        "identification",
        "identity",
        "user ID",
        "name tag",
        "badge"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/iD.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--iD</title><rect x=\"10\" y=\"9\" width=\"2\" height=\"2\"/><path d=\"M18,23H14V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,18,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H16Z\" transform=\"translate(0)\"/><rect x=\"10\" y=\"13\" width=\"2\" height=\"10\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z\"/></svg>",
            "info": {},
            "path": "32/Q/iD.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QID32",
          "filepath": "Q/iD/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
                }
              }
            ],
            "name": "iD",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QID24",
          "filepath": "Q/iD/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
                }
              }
            ],
            "name": "iD",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QID20",
          "filepath": "Q/iD/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
                }
              }
            ],
            "name": "iD",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QID16",
          "filepath": "Q/iD/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
                }
              }
            ],
            "name": "iD",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "ID",
        "global": "QID",
        "filepath": "Q/ID.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "id-management",
      "friendlyName": "ID management",
      "aliases": [
        "ID",
        "identity",
        "settings",
        "gear",
        "password",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/id-management.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M15,20H9a3,3,0,0,0-3,3v2H8V23a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V23A3,3,0,0,0,15,20Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M12,19a4,4,0,1,0-4-4A4,4,0,0,0,12,19Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,12,13Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"20\" y=\"19\" width=\"6\" height=\"2\"/>\n  <rect x=\"22\" y=\"23\" width=\"4\" height=\"2\"/>\n  <path d=\"M32,10V8H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,4.1011V2H24V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,8H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,12Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z\"/><path d=\"M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z\"/><path d=\"M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z\"/></svg>",
            "info": {},
            "path": "32/id-management.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IdManagement32",
          "filepath": "id-management/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
                }
              }
            ],
            "name": "id-management",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IdManagement24",
          "filepath": "id-management/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
                }
              }
            ],
            "name": "id-management",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IdManagement20",
          "filepath": "id-management/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
                }
              }
            ],
            "name": "id-management",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IdManagement16",
          "filepath": "id-management/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
                }
              }
            ],
            "name": "id-management",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IdManagement",
        "global": "IdManagement",
        "filepath": "IdManagement.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "idea",
      "friendlyName": "Idea",
      "aliases": [
        "thought",
        "notion",
        "belief",
        "concept",
        "light bulb",
        "inspiration",
        "opinion",
        "intention",
        "design",
        "idea"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/idea.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>idea</title><rect x=\"11\" y=\"24\" width=\"10\" height=\"2\"/><rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/><path d=\"M16,2A10,10,0,0,0,6,12a9.19,9.19,0,0,0,3.46,7.62c1,.93,1.54,1.46,1.54,2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2,7.2,0,0,1,8,12a8,8,0,0,1,16,0,7.2,7.2,0,0,1-2.82,6.14c-1.07,1-2.18,2-2.18,3.86h2c0-.92.53-1.45,1.54-2.39A9.18,9.18,0,0,0,26,12,10,10,0,0,0,16,2Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z\"/></svg>",
            "info": {},
            "path": "32/idea.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Idea32",
          "filepath": "idea/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
                }
              }
            ],
            "name": "idea",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Idea24",
          "filepath": "idea/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
                }
              }
            ],
            "name": "idea",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Idea20",
          "filepath": "idea/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
                }
              }
            ],
            "name": "idea",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Idea16",
          "filepath": "idea/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
                }
              }
            ],
            "name": "idea",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Idea",
        "global": "Idea",
        "filepath": "Idea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "identification",
      "friendlyName": "Identification",
      "aliases": [
        "id",
        "passport",
        "drivers license",
        "recognition",
        "badge",
        "papers",
        "avatar",
        "user",
        "name"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/identification.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>identification</title><path d=\"M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><rect x=\"6\" y=\"10\" width=\"7\" height=\"2\"/><rect x=\"6\" y=\"14\" width=\"4\" height=\"2\"/><path d=\"M23,18H17a3,3,0,0,0-3,3v2h2V21a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V21A3,3,0,0,0,23,18Z\"/><path d=\"M20,17a4,4,0,1,0-4-4A4,4,0,0,0,20,17Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><path d=\"M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z\"/></svg>",
            "info": {},
            "path": "32/identification.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Identification32",
          "filepath": "identification/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
                }
              }
            ],
            "name": "identification",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Identification24",
          "filepath": "identification/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
                }
              }
            ],
            "name": "identification",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Identification20",
          "filepath": "identification/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
                }
              }
            ],
            "name": "identification",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Identification16",
          "filepath": "identification/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
                }
              }
            ],
            "name": "identification",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Identification",
        "global": "Identification",
        "filepath": "Identification.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image",
      "friendlyName": "Image",
      "aliases": [
        "appearance",
        "form",
        "drawing",
        "illustration",
        "picture",
        "portrait",
        "likeness",
        "avatar",
        "photograph",
        "photo",
        "image"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/image.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>image</title><path d=\"M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z\"/></svg>",
            "info": {},
            "path": "32/image.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Image32",
          "filepath": "image/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
                }
              }
            ],
            "name": "image",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Image24",
          "filepath": "image/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
                }
              }
            ],
            "name": "image",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Image20",
          "filepath": "image/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
                }
              }
            ],
            "name": "image",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Image16",
          "filepath": "image/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
                }
              }
            ],
            "name": "image",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Image",
        "global": "Image",
        "filepath": "Image.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image--copy",
      "friendlyName": "Image copy",
      "aliases": [
        "image",
        "copy",
        "duplicate",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/image--copy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,22H2V4A2.0023,2.0023,0,0,1,4,2H22V4H4Z\"/>\n  <path d=\"M21,17a3,3,0,1,0-3-3A3.0033,3.0033,0,0,0,21,17Zm0-4a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,13Z\"/>\n  <path d=\"M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z\"/><path d=\"M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z\"/></svg>",
            "info": {},
            "path": "32/image--copy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImageCopy32",
          "filepath": "image--copy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
                }
              }
            ],
            "name": "image--copy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImageCopy24",
          "filepath": "image--copy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
                }
              }
            ],
            "name": "image--copy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImageCopy20",
          "filepath": "image--copy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
                }
              }
            ],
            "name": "image--copy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImageCopy16",
          "filepath": "image--copy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
                }
              }
            ],
            "name": "image--copy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ImageCopy",
        "global": "ImageCopy",
        "filepath": "ImageCopy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image--medical",
      "friendlyName": "Image medical",
      "aliases": [
        "appearance",
        "form",
        "drawing",
        "illustration",
        "picture",
        "portrait",
        "likeness",
        "avatar",
        "xray",
        "MRI",
        "CT scan",
        "image",
        "medical"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/image--medical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>medical-image</title><path d=\"M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><polygon points=\"22 16 22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><path d=\"M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z\"/></svg>",
            "info": {},
            "path": "32/image--medical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImageMedical32",
          "filepath": "image--medical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
                }
              }
            ],
            "name": "image--medical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImageMedical24",
          "filepath": "image--medical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
                }
              }
            ],
            "name": "image--medical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImageMedical20",
          "filepath": "image--medical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
                }
              }
            ],
            "name": "image--medical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImageMedical16",
          "filepath": "image--medical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
                }
              }
            ],
            "name": "image--medical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ImageMedical",
        "global": "ImageMedical",
        "filepath": "ImageMedical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image--reference",
      "friendlyName": "Image reference",
      "aliases": [
        "image",
        "photograph",
        "photo",
        "picture",
        "reference",
        "source",
        "citation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/image--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z\"/>\n  <path d=\"M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z\"/></svg>",
            "info": {},
            "path": "32/image--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImageReference32",
          "filepath": "image--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "image--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImageReference24",
          "filepath": "image--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "image--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImageReference20",
          "filepath": "image--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "image--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImageReference16",
          "filepath": "image--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "image--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ImageReference",
        "global": "ImageReference",
        "filepath": "ImageReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image--search",
      "friendlyName": "Image search",
      "aliases": [
        "review",
        "find",
        "study",
        "detail",
        "search",
        "image",
        "photograph",
        "photo",
        "picture"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/image--search.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>image--search</title>\n  <path d=\"M24,14a5.99,5.99,0,0,0-4.885,9.4712L14,28.5859,15.4141,30l5.1147-5.1147A5.9971,5.9971,0,1,0,24,14Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z\"/>\n  <path d=\"M17,12a3,3,0,1,0-3-3A3.0033,3.0033,0,0,0,17,12Zm0-4a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,17,8Z\"/>\n  <path d=\"M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z\"/><path d=\"M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z\"/></svg>",
            "info": {},
            "path": "32/image--search.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImageSearch32",
          "filepath": "image--search/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
                }
              }
            ],
            "name": "image--search",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImageSearch24",
          "filepath": "image--search/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
                }
              }
            ],
            "name": "image--search",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImageSearch20",
          "filepath": "image--search/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
                }
              }
            ],
            "name": "image--search",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImageSearch16",
          "filepath": "image--search/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
                }
              }
            ],
            "name": "image--search",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ImageSearch",
        "global": "ImageSearch",
        "filepath": "ImageSearch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image--search--alt",
      "friendlyName": "Image search alt",
      "aliases": [
        "search",
        "camera",
        "magnifying glass",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/image--search--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z\"/>\n  <path d=\"M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z\"/><path d=\"M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z\"/></svg>",
            "info": {},
            "path": "32/image--search--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImageSearchAlt32",
          "filepath": "image--search--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
                }
              }
            ],
            "name": "image--search--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImageSearchAlt24",
          "filepath": "image--search--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
                }
              }
            ],
            "name": "image--search--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImageSearchAlt20",
          "filepath": "image--search--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
                }
              }
            ],
            "name": "image--search--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImageSearchAlt16",
          "filepath": "image--search--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
                }
              }
            ],
            "name": "image--search--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ImageSearchAlt",
        "global": "ImageSearchAlt",
        "filepath": "ImageSearchAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image-availability--local",
      "friendlyName": "image-availability--local",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/image-availability--local.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z\"/>\n<path d=\"M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\n\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\n\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z\"/><path d=\"M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z\"/></svg>",
            "info": {},
            "path": "32/watson-health/image-availability--local.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthImageAvailabilityLocal32",
          "filepath": "watson-health/image-availability--local/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--local",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityLocal24",
          "filepath": "watson-health/image-availability--local/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--local",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityLocal20",
          "filepath": "watson-health/image-availability--local/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--local",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityLocal16",
          "filepath": "watson-health/image-availability--local/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--local",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ImageAvailabilityLocal",
        "global": "WatsonHealthImageAvailabilityLocal",
        "filepath": "watson-health/ImageAvailabilityLocal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image-availability--retrieving",
      "friendlyName": "image-availability--retrieving",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/image-availability--retrieving.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"10,13 11.4,11.6 15,15.2 15,2 17,2 17,15.2 20.6,11.6 22,13 16,19 \"/>\n<path d=\"M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\n\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\n\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z\"/><path d=\"M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/image-availability--retrieving.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthImageAvailabilityRetrieving32",
          "filepath": "watson-health/image-availability--retrieving/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
                }
              }
            ],
            "name": "image-availability--retrieving",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityRetrieving24",
          "filepath": "watson-health/image-availability--retrieving/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
                }
              }
            ],
            "name": "image-availability--retrieving",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityRetrieving20",
          "filepath": "watson-health/image-availability--retrieving/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
                }
              }
            ],
            "name": "image-availability--retrieving",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityRetrieving16",
          "filepath": "watson-health/image-availability--retrieving/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
                }
              }
            ],
            "name": "image-availability--retrieving",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ImageAvailabilityRetrieving",
        "global": "WatsonHealthImageAvailabilityRetrieving",
        "filepath": "watson-health/ImageAvailabilityRetrieving.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4 C7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10 c0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image-availability--unavailable",
      "friendlyName": "image-availability--unavailable",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/image-availability--unavailable.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<circle cx=\"16\" cy=\"20.5\" r=\"1.5\"/>\n<path d=\"M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\n\tz\"/>\n<path d=\"M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\n\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\n\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"20.5\" r=\"1.5\"/><path d=\"M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz\"/><path d=\"M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z\"/></svg>",
            "info": {},
            "path": "32/watson-health/image-availability--unavailable.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthImageAvailabilityUnavailable32",
          "filepath": "watson-health/image-availability--unavailable/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--unavailable",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityUnavailable24",
          "filepath": "watson-health/image-availability--unavailable/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--unavailable",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityUnavailable20",
          "filepath": "watson-health/image-availability--unavailable/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--unavailable",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthImageAvailabilityUnavailable16",
          "filepath": "watson-health/image-availability--unavailable/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                }
              }
            ],
            "name": "image-availability--unavailable",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ImageAvailabilityUnavailable",
        "global": "WatsonHealthImageAvailabilityUnavailable",
        "filepath": "watson-health/ImageAvailabilityUnavailable.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "20.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17 z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "image-service",
      "friendlyName": "Image service",
      "aliases": [
        "image",
        "service"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/image-service.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <rect x=\"13\" y=\"4\" width=\"2\" height=\"8\"/>\n  <rect x=\"9\" y=\"4\" width=\"2\" height=\"8\"/>\n  <path d=\"M21,12H19a2.0021,2.0021,0,0,1-2-2V6a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,21,12ZM19,6v4h2V6Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"21\" y=\"14\" width=\"2\" height=\"8\"/>\n  <rect x=\"9\" y=\"14\" width=\"2\" height=\"8\"/>\n  <path d=\"M17,22H15a2.0021,2.0021,0,0,1-2-2V16a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,17,22Zm-2-6v4h2V16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z\"/></svg>",
            "info": {},
            "path": "32/image-service.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImageService32",
          "filepath": "image-service/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
                }
              }
            ],
            "name": "image-service",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImageService24",
          "filepath": "image-service/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
                }
              }
            ],
            "name": "image-service",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImageService20",
          "filepath": "image-service/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
                }
              }
            ],
            "name": "image-service",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImageService16",
          "filepath": "image-service/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
                }
              }
            ],
            "name": "image-service",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ImageService",
        "global": "ImageService",
        "filepath": "ImageService.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "import-export",
      "friendlyName": "Import export",
      "aliases": [
        "import",
        "export",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/import-export.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,24v4H4V24H2v4l.0076-.0049A1.9977,1.9977,0,0,0,4,30H28a2,2,0,0,0,2-2h0V24Z\"/>\n  <polygon points=\"27.6 14.6 24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6\"/>\n  <polygon points=\"9 4 3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z\"/></svg>",
            "info": {},
            "path": "32/import-export.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImportExport32",
          "filepath": "import-export/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
                }
              }
            ],
            "name": "import-export",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImportExport24",
          "filepath": "import-export/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
                }
              }
            ],
            "name": "import-export",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImportExport20",
          "filepath": "import-export/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
                }
              }
            ],
            "name": "import-export",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImportExport16",
          "filepath": "import-export/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
                }
              }
            ],
            "name": "import-export",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ImportExport",
        "global": "ImportExport",
        "filepath": "ImportExport.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "improve-relevance",
      "friendlyName": "Improve relevance",
      "aliases": [
        "target",
        "bullseye",
        "relevant",
        "improve",
        "relevance"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/improve-relevance.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>improve-relevance</title><polygon points=\"22 26.59 19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z\"/><path d=\"M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z\"/><path d=\"M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z\"/></svg>",
            "info": {},
            "path": "32/improve-relevance.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ImproveRelevance32",
          "filepath": "improve-relevance/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
                }
              }
            ],
            "name": "improve-relevance",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ImproveRelevance24",
          "filepath": "improve-relevance/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
                }
              }
            ],
            "name": "improve-relevance",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ImproveRelevance20",
          "filepath": "improve-relevance/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
                }
              }
            ],
            "name": "improve-relevance",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ImproveRelevance16",
          "filepath": "improve-relevance/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
                }
              }
            ],
            "name": "improve-relevance",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ImproveRelevance",
        "global": "ImproveRelevance",
        "filepath": "ImproveRelevance.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "in-progress",
      "friendlyName": "In progress",
      "aliases": [
        "processing",
        "searching",
        "wait",
        "timer",
        "timing",
        "time",
        "in progress"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/in-progress.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>in-progress</title><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/in-progress.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InProgress32",
          "filepath": "in-progress/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
                }
              }
            ],
            "name": "in-progress",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InProgress24",
          "filepath": "in-progress/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
                }
              }
            ],
            "name": "in-progress",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InProgress20",
          "filepath": "in-progress/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
                }
              }
            ],
            "name": "in-progress",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InProgress16",
          "filepath": "in-progress/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
                }
              }
            ],
            "name": "in-progress",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "InProgress",
        "global": "InProgress",
        "filepath": "InProgress.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "in-progress--error",
      "friendlyName": "In progress error",
      "aliases": [
        "processing error",
        "searching error",
        "wait",
        "timer",
        "timing",
        "time",
        "in progress",
        "error"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/in-progress--error.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z\"/><path d=\"M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z\"/></svg>",
            "info": {},
            "path": "32/in-progress--error.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InProgressError32",
          "filepath": "in-progress--error/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
                }
              }
            ],
            "name": "in-progress--error",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InProgressError24",
          "filepath": "in-progress--error/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
                }
              }
            ],
            "name": "in-progress--error",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InProgressError20",
          "filepath": "in-progress--error/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
                }
              }
            ],
            "name": "in-progress--error",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InProgressError16",
          "filepath": "in-progress--error/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
                }
              }
            ],
            "name": "in-progress--error",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "InProgressError",
        "global": "InProgressError",
        "filepath": "InProgressError.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "in-progress--warning",
      "friendlyName": "In progress warning",
      "aliases": [
        "processing warning",
        "searching warning",
        "wait",
        "timer",
        "timing",
        "time",
        "in progress",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/in-progress--warning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z\"/><path d=\"M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z\"/></svg>",
            "info": {},
            "path": "32/in-progress--warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InProgressWarning32",
          "filepath": "in-progress--warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
                }
              }
            ],
            "name": "in-progress--warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InProgressWarning24",
          "filepath": "in-progress--warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
                }
              }
            ],
            "name": "in-progress--warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InProgressWarning20",
          "filepath": "in-progress--warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
                }
              }
            ],
            "name": "in-progress--warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InProgressWarning16",
          "filepath": "in-progress--warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
                }
              }
            ],
            "name": "in-progress--warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "InProgressWarning",
        "global": "InProgressWarning",
        "filepath": "InProgressWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "incomplete",
      "friendlyName": "Incomplete",
      "aliases": [
        "incomplete",
        "status"
      ],
      "sizes": [
        32,
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "incomplete.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,4a4.0045,4.0045,0,0,1,4,4H4A4.0045,4.0045,0,0,1,8,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,4a4.0045,4.0045,0,0,1,4,4H4A4.0045,4.0045,0,0,1,8,4Z\"/></svg>",
            "info": {},
            "path": "incomplete.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/incomplete.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23.7642,6.8593l1.2851-1.5315A13.976,13.976,0,0,0,20.8672,2.887l-.6836,1.8776A11.9729,11.9729,0,0,1,23.7642,6.8593Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M27.81,14l1.9677-.4128A13.8888,13.8888,0,0,0,28.14,9.0457L26.4087,10A12.52,12.52,0,0,1,27.81,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20.1836,27.2354l.6836,1.8776a13.976,13.976,0,0,0,4.1821-2.4408l-1.2851-1.5315A11.9729,11.9729,0,0,1,20.1836,27.2354Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26.4087,22,28.14,23a14.14,14.14,0,0,0,1.6382-4.5872L27.81,18.0659A12.1519,12.1519,0,0,1,26.4087,22Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30V2a14,14,0,0,0,0,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z\"/></svg>",
            "info": {},
            "path": "32/incomplete.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Incomplete32",
          "filepath": "incomplete/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
                }
              }
            ],
            "name": "incomplete",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Incomplete24",
          "filepath": "incomplete/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
                }
              }
            ],
            "name": "incomplete",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Incomplete20",
          "filepath": "incomplete/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
                }
              }
            ],
            "name": "incomplete",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Incomplete16",
          "filepath": "incomplete/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
                }
              }
            ],
            "name": "incomplete",
            "size": 16
          },
          "size": 16
        },
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,4a4.0045,4.0045,0,0,1,4,4H4A4.0045,4.0045,0,0,1,8,4Z"
                }
              }
            ],
            "name": "incomplete",
            "size": "glyph"
          },
          "moduleName": "IncompleteGlyph",
          "filepath": "incomplete/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Incomplete",
        "global": "Incomplete",
        "filepath": "Incomplete.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,4a4.0045,4.0045,0,0,1,4,4H4A4.0045,4.0045,0,0,1,8,4Z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "incomplete--cancel",
      "friendlyName": "Incomplete cancel",
      "aliases": [
        "incomplete cancel",
        "status",
        "cancel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/incomplete--cancel.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41\"/>\n  <path d=\"M14,26A12,12,0,0,1,14,2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M17.8257,4.7642a10.0288,10.0288,0,0,1,3.2422,2.1679l1.4133-1.4135a12.0359,12.0359,0,0,0-3.89-2.6016Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,14a11.93,11.93,0,0,0-.9167-4.5908l-1.8472.7651A9.9428,9.9428,0,0,1,24,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z\"/></svg>",
            "info": {},
            "path": "32/incomplete--cancel.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IncompleteCancel32",
          "filepath": "incomplete--cancel/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
                }
              }
            ],
            "name": "incomplete--cancel",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IncompleteCancel24",
          "filepath": "incomplete--cancel/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
                }
              }
            ],
            "name": "incomplete--cancel",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IncompleteCancel20",
          "filepath": "incomplete--cancel/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
                }
              }
            ],
            "name": "incomplete--cancel",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IncompleteCancel16",
          "filepath": "incomplete--cancel/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
                }
              }
            ],
            "name": "incomplete--cancel",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "IncompleteCancel",
        "global": "IncompleteCancel",
        "filepath": "IncompleteCancel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "incomplete--error",
      "friendlyName": "Incomplete error",
      "aliases": [
        "incomplete error",
        "status",
        "error"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/incomplete--error.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,26A12,12,0,0,1,14,2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M17.8257,4.7642a10.0288,10.0288,0,0,1,3.2422,2.1679l1.4133-1.4135a12.0359,12.0359,0,0,0-3.89-2.6016Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,14a11.93,11.93,0,0,0-.9167-4.5908l-1.8472.7651A9.9428,9.9428,0,0,1,24,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z\"/></svg>",
            "info": {},
            "path": "32/incomplete--error.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IncompleteError32",
          "filepath": "incomplete--error/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "incomplete--error",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IncompleteError24",
          "filepath": "incomplete--error/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "incomplete--error",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IncompleteError20",
          "filepath": "incomplete--error/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "incomplete--error",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IncompleteError16",
          "filepath": "incomplete--error/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                }
              }
            ],
            "name": "incomplete--error",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "IncompleteError",
        "global": "IncompleteError",
        "filepath": "IncompleteError.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "incomplete--warning",
      "friendlyName": "Incomplete warning",
      "aliases": [
        "incomplete warning",
        "status",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/incomplete--warning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,26A12,12,0,0,1,14,2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M17.8257,4.7642a10.0288,10.0288,0,0,1,3.2422,2.1679l1.4133-1.4135a12.0359,12.0359,0,0,0-3.89-2.6016Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,14a11.93,11.93,0,0,0-.9167-4.5908l-1.8472.7651A9.9428,9.9428,0,0,1,24,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z\"/></svg>",
            "info": {},
            "path": "32/incomplete--warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IncompleteWarning32",
          "filepath": "incomplete--warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "incomplete--warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IncompleteWarning24",
          "filepath": "incomplete--warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "incomplete--warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IncompleteWarning20",
          "filepath": "incomplete--warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "incomplete--warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IncompleteWarning16",
          "filepath": "incomplete--warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                }
              }
            ],
            "name": "incomplete--warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "IncompleteWarning",
        "global": "IncompleteWarning",
        "filepath": "IncompleteWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "increase-level",
      "friendlyName": "Increase level",
      "aliases": [
        "increase level",
        "rise",
        "rising"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/increase-level.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>increase-level</title><polygon points=\"23 4 18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z\"/></svg>",
            "info": {},
            "path": "32/increase-level.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IncreaseLevel32",
          "filepath": "increase-level/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
                }
              }
            ],
            "name": "increase-level",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IncreaseLevel24",
          "filepath": "increase-level/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
                }
              }
            ],
            "name": "increase-level",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IncreaseLevel20",
          "filepath": "increase-level/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
                }
              }
            ],
            "name": "increase-level",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IncreaseLevel16",
          "filepath": "increase-level/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
                }
              }
            ],
            "name": "increase-level",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "IncreaseLevel",
        "global": "IncreaseLevel",
        "filepath": "IncreaseLevel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "industry",
      "friendlyName": "Industry",
      "aliases": [
        "field",
        "business",
        "commerce",
        "corporation",
        "trade",
        "line of work",
        "job",
        "career",
        "factory",
        "manufacturing",
        "industry"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/industry.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>industry</title><path d=\"M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z\"/></svg>",
            "info": {},
            "path": "32/industry.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Industry32",
          "filepath": "industry/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
                }
              }
            ],
            "name": "industry",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Industry24",
          "filepath": "industry/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
                }
              }
            ],
            "name": "industry",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Industry20",
          "filepath": "industry/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
                }
              }
            ],
            "name": "industry",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Industry16",
          "filepath": "industry/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
                }
              }
            ],
            "name": "industry",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Industry",
        "global": "Industry",
        "filepath": "Industry.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "information",
      "friendlyName": "Information",
      "aliases": [
        "info",
        "learn",
        "more",
        "tip",
        "help",
        "information"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/information.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>information</title>\n<polygon points=\"8.5,11 8.5,6.5 6.5,6.5 6.5,7.5 7.5,7.5 7.5,11 6,11 6,12 10,12 10,11 \"/>\n<path d=\"M8,3.5c-0.4,0-0.8,0.3-0.8,0.8S7.6,5,8,5c0.4,0,0.8-0.3,0.8-0.8S8.4,3.5,8,3.5z\"/>\n<path d=\"M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z\"/><path d=\"M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z\"/></svg>",
            "info": {},
            "path": "16/information.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/information.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17 22 17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22\"/>\n  <path d=\"M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/information.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Information32",
          "filepath": "information/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              }
            ],
            "name": "information",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Information24",
          "filepath": "information/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              }
            ],
            "name": "information",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Information20",
          "filepath": "information/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              }
            ],
            "name": "information",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Information16",
          "filepath": "information/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"
                }
              }
            ],
            "name": "information",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Information",
        "global": "Information",
        "filepath": "Information.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "information--disabled",
      "friendlyName": "Information disabled",
      "aliases": [
        "information",
        "disabled",
        "no access",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/information--disabled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,3.4141,28.5859,2,2,28.5859,3.4141,30l3.4433-3.4434A13.9614,13.9614,0,0,0,26.5565,6.8574ZM28,16A11.9734,11.9734,0,0,1,8.2678,25.146L15,18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967,11.8967,0,0,1,28,16Z\"/>\n  <path d=\"M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z\"/>\n  <path d=\"M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z\"/><path d=\"M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z\"/></svg>",
            "info": {},
            "path": "32/information--disabled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InformationDisabled32",
          "filepath": "information--disabled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
                }
              }
            ],
            "name": "information--disabled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InformationDisabled24",
          "filepath": "information--disabled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
                }
              }
            ],
            "name": "information--disabled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InformationDisabled20",
          "filepath": "information--disabled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
                }
              }
            ],
            "name": "information--disabled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InformationDisabled16",
          "filepath": "information--disabled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
                }
              }
            ],
            "name": "information--disabled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "InformationDisabled",
        "global": "InformationDisabled",
        "filepath": "InformationDisabled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "information--filled",
      "friendlyName": "Information filled",
      "aliases": [
        "info",
        "learn",
        "more",
        "tip",
        "help",
        "information filled",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/information--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z\" data-icon-path=\"inner-path\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z\"/></svg>",
            "info": {},
            "path": "32/information--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InformationFilled32",
          "filepath": "information--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InformationFilled24",
          "filepath": "information--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InformationFilled20",
          "filepath": "information--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InformationFilled16",
          "filepath": "information--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "InformationFilled",
        "global": "InformationFilled",
        "filepath": "InformationFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "information--square",
      "friendlyName": "Information square",
      "aliases": [
        "info",
        "learn",
        "more",
        "tip",
        "help",
        "information square",
        "information",
        "square"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/information--square.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"17 22 17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22\"/>\n  <path d=\"M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z\"/>\n  <path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z\"/></svg>",
            "info": {},
            "path": "32/information--square.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InformationSquare32",
          "filepath": "information--square/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
                }
              }
            ],
            "name": "information--square",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InformationSquare24",
          "filepath": "information--square/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
                }
              }
            ],
            "name": "information--square",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InformationSquare20",
          "filepath": "information--square/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
                }
              }
            ],
            "name": "information--square",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InformationSquare16",
          "filepath": "information--square/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
                }
              }
            ],
            "name": "information--square",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "InformationSquare",
        "global": "InformationSquare",
        "filepath": "InformationSquare.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "information--square--filled",
      "friendlyName": "Information square filled",
      "aliases": [
        "info",
        "learn",
        "more",
        "tip",
        "help",
        "information square filled",
        "information",
        "square",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/information--square--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z\"/>\n  <path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z\" data-icon-path=\"inner-path\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z\"/></svg>",
            "info": {},
            "path": "32/information--square--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InformationSquareFilled32",
          "filepath": "information--square--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--square--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InformationSquareFilled24",
          "filepath": "information--square--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--square--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InformationSquareFilled20",
          "filepath": "information--square--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--square--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InformationSquareFilled16",
          "filepath": "information--square--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                }
              }
            ],
            "name": "information--square--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "InformationSquareFilled",
        "global": "InformationSquareFilled",
        "filepath": "InformationSquareFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "infrastructure--classic",
      "friendlyName": "IBM Cloud® Classic Infrastructure",
      "aliases": [
        "infrastructure",
        "classic infrastructure",
        "app",
        "catalogue",
        "catalog",
        "cloud",
        "application"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/infrastructure--classic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"18\" y=\"26\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"21\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"16\" width=\"12\" height=\"2\"/>\n  <path d=\"M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z\"/><path d=\"M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z\"/></svg>",
            "info": {},
            "path": "32/infrastructure--classic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InfrastructureClassic32",
          "filepath": "infrastructure--classic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
                }
              }
            ],
            "name": "infrastructure--classic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InfrastructureClassic24",
          "filepath": "infrastructure--classic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
                }
              }
            ],
            "name": "infrastructure--classic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InfrastructureClassic20",
          "filepath": "infrastructure--classic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
                }
              }
            ],
            "name": "infrastructure--classic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InfrastructureClassic16",
          "filepath": "infrastructure--classic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
                }
              }
            ],
            "name": "infrastructure--classic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "InfrastructureClassic",
        "global": "InfrastructureClassic",
        "filepath": "InfrastructureClassic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "insert",
      "friendlyName": "Insert",
      "aliases": [
        "embed",
        "enter",
        "fill in",
        "paste",
        "inject",
        "include",
        "infuse",
        "insert"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/insert.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>insert</title><path d=\"M2,9h9V2H2ZM4,4H9V7H4Z\"/><path d=\"M2,19h9V12H2Zm2-5H9v3H4Z\"/><path d=\"M2,29h9V22H2Zm2-5H9v3H4Z\"/><path d=\"M27,9H18l3.41-3.59L20,4l-6,6,6,6,1.41-1.41L18,11h9a1,1,0,0,1,1,1V24a1,1,0,0,1-1,1H15v2H27a3,3,0,0,0,3-3V12A3,3,0,0,0,27,9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z\"/></svg>",
            "info": {},
            "path": "32/insert.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Insert32",
          "filepath": "insert/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
                }
              }
            ],
            "name": "insert",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Insert24",
          "filepath": "insert/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
                }
              }
            ],
            "name": "insert",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Insert20",
          "filepath": "insert/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
                }
              }
            ],
            "name": "insert",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Insert16",
          "filepath": "insert/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
                }
              }
            ],
            "name": "insert",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Insert",
        "global": "Insert",
        "filepath": "Insert.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "insert--page",
      "friendlyName": "Insert page",
      "aliases": [
        "add page",
        "include",
        "insert page",
        "page",
        "insert"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/insert--page.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>insert--page</title>\n  <path d=\"M26,30H24V20H12V30H10V20a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2Z\"/>\n  <polygon points=\"5.17 16 2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16\"/>\n  <path d=\"M24,14H12a2.0021,2.0021,0,0,1-2-2V2h2V12H24V2h2V12A2.0021,2.0021,0,0,1,24,14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z\"/></svg>",
            "info": {},
            "path": "32/insert--page.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InsertPage32",
          "filepath": "insert--page/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
                }
              }
            ],
            "name": "insert--page",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InsertPage24",
          "filepath": "insert--page/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
                }
              }
            ],
            "name": "insert--page",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InsertPage20",
          "filepath": "insert--page/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
                }
              }
            ],
            "name": "insert--page",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InsertPage16",
          "filepath": "insert--page/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
                }
              }
            ],
            "name": "insert--page",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "InsertPage",
        "global": "InsertPage",
        "filepath": "InsertPage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "insert-syntax",
      "friendlyName": "Insert syntax",
      "aliases": [
        "insert syntax"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/insert-syntax.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"20.17 16 17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16\"/>\n  <polygon points=\"11.83 16 14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16\"/>\n  <path d=\"M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z\"/><path d=\"M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z\"/></svg>",
            "info": {},
            "path": "32/insert-syntax.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InsertSyntax32",
          "filepath": "insert-syntax/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "insert-syntax",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InsertSyntax24",
          "filepath": "insert-syntax/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "insert-syntax",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InsertSyntax20",
          "filepath": "insert-syntax/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "insert-syntax",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InsertSyntax16",
          "filepath": "insert-syntax/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                }
              }
            ],
            "name": "insert-syntax",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "InsertSyntax",
        "global": "InsertSyntax",
        "filepath": "InsertSyntax.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "inspection",
      "friendlyName": "Inspection",
      "aliases": [
        "inspection",
        "inspect",
        "operations",
        "review"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/inspection.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"15 17.18 12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18\"/>\n  <path d=\"M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z\"/><path d=\"M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z\"/></svg>",
            "info": {},
            "path": "32/inspection.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Inspection32",
          "filepath": "inspection/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "inspection",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Inspection24",
          "filepath": "inspection/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "inspection",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Inspection20",
          "filepath": "inspection/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "inspection",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Inspection16",
          "filepath": "inspection/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
                }
              }
            ],
            "name": "inspection",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Inspection",
        "global": "Inspection",
        "filepath": "Inspection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "instance--bx",
      "friendlyName": "Instance Bx",
      "aliases": [
        "instance",
        "bx",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/instance--bx.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,5A3.0033,3.0033,0,0,0,9,2H4V15H9a3.0033,3.0033,0,0,0,3-3V10.5a2.977,2.977,0,0,0-.78-2,2.9768,2.9768,0,0,0,.78-2ZM6,4H9a1.0013,1.0013,0,0,1,1,1V6.5513A.9587.9587,0,0,1,9,7.5H6Zm4,8a1.0009,1.0009,0,0,1-1,1H6V9.5H9a1.0009,1.0009,0,0,1,1,1Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"22 5 20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5\"/>\n  <circle cx=\"9\" cy=\"27\" r=\"1\"/>\n  <rect x=\"2\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"8\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"26\" y=\"18\" width=\"4\" height=\"2\"/>\n  <path d=\"M26,31H6a2.0021,2.0021,0,0,1-2-2V25a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,31ZM6,25v4H26V25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z\"/><circle cx=\"9\" cy=\"27\" r=\"1\"/><path d=\"M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z\"/></svg>",
            "info": {},
            "path": "32/instance--bx.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InstanceBx32",
          "filepath": "instance--bx/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--bx",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InstanceBx24",
          "filepath": "instance--bx/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--bx",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InstanceBx20",
          "filepath": "instance--bx/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--bx",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InstanceBx16",
          "filepath": "instance--bx/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--bx",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "InstanceBx",
        "global": "InstanceBx",
        "filepath": "InstanceBx.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "27",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "instance--classic",
      "friendlyName": "Instance classic",
      "aliases": [
        "instance",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/instance--classic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"9\" cy=\"27\" r=\"1\"/>\n  <path d=\"M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z\"/><circle cx=\"9\" cy=\"27\" r=\"1\"/><path d=\"M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z\"/></svg>",
            "info": {},
            "path": "32/instance--classic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InstanceClassic32",
          "filepath": "instance--classic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
                }
              }
            ],
            "name": "instance--classic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InstanceClassic24",
          "filepath": "instance--classic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
                }
              }
            ],
            "name": "instance--classic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InstanceClassic20",
          "filepath": "instance--classic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
                }
              }
            ],
            "name": "instance--classic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InstanceClassic16",
          "filepath": "instance--classic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
                }
              }
            ],
            "name": "instance--classic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "InstanceClassic",
        "global": "InstanceClassic",
        "filepath": "InstanceClassic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "27",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "instance--cx",
      "friendlyName": "Instance Cx",
      "aliases": [
        "instance",
        "Cx",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/instance--cx.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"9\" cy=\"27\" r=\"1\"/>\n  <polygon points=\"22 5 20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5\"/>\n  <path d=\"M12,15H6a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,6,2h6V4H6v9h6Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"8\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"26\" y=\"18\" width=\"4\" height=\"2\"/>\n  <path d=\"M26,31H6a2.0021,2.0021,0,0,1-2-2V25a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,31ZM6,25v4H26V25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"27\" r=\"1\"/><path d=\"M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z\"/></svg>",
            "info": {},
            "path": "32/instance--cx.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InstanceCx32",
          "filepath": "instance--cx/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--cx",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InstanceCx24",
          "filepath": "instance--cx/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--cx",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InstanceCx20",
          "filepath": "instance--cx/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--cx",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InstanceCx16",
          "filepath": "instance--cx/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--cx",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "InstanceCx",
        "global": "InstanceCx",
        "filepath": "InstanceCx.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "27",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "instance--mx",
      "friendlyName": "Instance Mx",
      "aliases": [
        "instance",
        "Mx",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/instance--mx.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 5 20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5\"/>\n  <polygon points=\"10 2 8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2\"/>\n  <circle cx=\"9\" cy=\"27\" r=\"1\"/>\n  <rect x=\"2\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"8\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"26\" y=\"18\" width=\"4\" height=\"2\"/>\n  <path d=\"M26,31H6a2.0021,2.0021,0,0,1-2-2V25a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,31ZM6,25v4H26V25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z\"/><circle cx=\"9\" cy=\"27\" r=\"1\"/><path d=\"M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z\"/></svg>",
            "info": {},
            "path": "32/instance--mx.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InstanceMx32",
          "filepath": "instance--mx/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--mx",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InstanceMx24",
          "filepath": "instance--mx/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--mx",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InstanceMx20",
          "filepath": "instance--mx/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--mx",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InstanceMx16",
          "filepath": "instance--mx/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                }
              }
            ],
            "name": "instance--mx",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "InstanceMx",
        "global": "InstanceMx",
        "filepath": "InstanceMx.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "27",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "instance--virtual",
      "friendlyName": "Instance virtual",
      "aliases": [
        "instance",
        "virtual",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/instance--virtual.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"7\" cy=\"23\" r=\"1\"/>\n  <rect x=\"2\" y=\"6\" width=\"4\" height=\"2\"/>\n  <rect x=\"8\" y=\"6\" width=\"4\" height=\"2\"/>\n  <rect x=\"14\" y=\"6\" width=\"4\" height=\"2\"/>\n  <rect x=\"20\" y=\"6\" width=\"4\" height=\"2\"/>\n  <rect x=\"26\" y=\"6\" width=\"4\" height=\"2\"/>\n  <path d=\"M28,28H4a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,28ZM4,20v6H28V20Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"12\" width=\"28\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"7\" cy=\"23\" r=\"1\"/><path d=\"M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z\"/></svg>",
            "info": {},
            "path": "32/instance--virtual.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InstanceVirtual32",
          "filepath": "instance--virtual/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z"
                }
              }
            ],
            "name": "instance--virtual",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InstanceVirtual24",
          "filepath": "instance--virtual/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z"
                }
              }
            ],
            "name": "instance--virtual",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InstanceVirtual20",
          "filepath": "instance--virtual/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z"
                }
              }
            ],
            "name": "instance--virtual",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InstanceVirtual16",
          "filepath": "instance--virtual/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z"
                }
              }
            ],
            "name": "instance--virtual",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "InstanceVirtual",
        "global": "InstanceVirtual",
        "filepath": "InstanceVirtual.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "23",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "integration",
      "friendlyName": "Integration",
      "aliases": [
        "assimilate",
        "assimilation",
        "amalgamation",
        "synthesis",
        "combination",
        "combine",
        "union",
        "join",
        "integration"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/integration.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>integration</title><path d=\"M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z\"/></svg>",
            "info": {},
            "path": "32/integration.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Integration32",
          "filepath": "integration/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
                }
              }
            ],
            "name": "integration",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Integration24",
          "filepath": "integration/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
                }
              }
            ],
            "name": "integration",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Integration20",
          "filepath": "integration/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
                }
              }
            ],
            "name": "integration",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Integration16",
          "filepath": "integration/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
                }
              }
            ],
            "name": "integration",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Integration",
        "global": "Integration",
        "filepath": "Integration.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--active",
      "friendlyName": "Intent request active",
      "aliases": [
        "systems",
        "intent",
        "request",
        "hexagon",
        "checkmark"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--active.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"23,27.2 20.4,24.6 19,26 23,30 31,22 29.6,20.6 \"/>\n<path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\n\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z\"/><path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/></svg>",
            "info": {},
            "path": "32/intent-request--active.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestActive32",
          "filepath": "intent-request--active/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--active",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestActive24",
          "filepath": "intent-request--active/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--active",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestActive20",
          "filepath": "intent-request--active/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--active",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestActive16",
          "filepath": "intent-request--active/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--active",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestActive",
        "global": "IntentRequestActive",
        "filepath": "IntentRequestActive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--create",
      "friendlyName": "Intent request create",
      "aliases": [
        "systems",
        "intent",
        "request",
        "hexagon",
        "plus sign"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--create.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"30,24 26,24 26,20 24,20 24,24 20,24 20,26 24,26 24,30 26,30 26,26 30,26 \"/>\n<path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\n\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z\"/><path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/></svg>",
            "info": {},
            "path": "32/intent-request--create.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestCreate32",
          "filepath": "intent-request--create/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--create",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestCreate24",
          "filepath": "intent-request--create/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--create",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestCreate20",
          "filepath": "intent-request--create/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--create",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestCreate16",
          "filepath": "intent-request--create/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--create",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestCreate",
        "global": "IntentRequestCreate",
        "filepath": "IntentRequestCreate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--heal",
      "friendlyName": "Intent request heal",
      "aliases": [
        "systems",
        "intent",
        "request",
        "diamond",
        "heart",
        "heal"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--heal.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8\n\tl4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z\"/>\n<path d=\"M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30\n\tL16.6,28.6z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8\tl4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z\"/><path d=\"M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30\tL16.6,28.6z\"/></svg>",
            "info": {},
            "path": "32/intent-request--heal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestHeal32",
          "filepath": "intent-request--heal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8\tl4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30\tL16.6,28.6z"
                }
              }
            ],
            "name": "intent-request--heal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestHeal24",
          "filepath": "intent-request--heal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8\tl4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30\tL16.6,28.6z"
                }
              }
            ],
            "name": "intent-request--heal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestHeal20",
          "filepath": "intent-request--heal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8\tl4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30\tL16.6,28.6z"
                }
              }
            ],
            "name": "intent-request--heal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestHeal16",
          "filepath": "intent-request--heal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8\tl4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30\tL16.6,28.6z"
                }
              }
            ],
            "name": "intent-request--heal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestHeal",
        "global": "IntentRequestHeal",
        "filepath": "IntentRequestHeal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8 l4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30 L16.6,28.6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--inactive",
      "friendlyName": "Intent request inactive",
      "aliases": [
        "systems",
        "intent",
        "request",
        "hexagon",
        "ellipsis"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--inactive.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<circle cx=\"18.5\" cy=\"22.5\" r=\"1.5\"/>\n<circle cx=\"23.5\" cy=\"22.5\" r=\"1.5\"/>\n<circle cx=\"28.5\" cy=\"22.5\" r=\"1.5\"/>\n<path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\n\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"18.5\" cy=\"22.5\" r=\"1.5\"/><circle cx=\"23.5\" cy=\"22.5\" r=\"1.5\"/><circle cx=\"28.5\" cy=\"22.5\" r=\"1.5\"/><path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/></svg>",
            "info": {},
            "path": "32/intent-request--inactive.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestInactive32",
          "filepath": "intent-request--inactive/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--inactive",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestInactive24",
          "filepath": "intent-request--inactive/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--inactive",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestInactive20",
          "filepath": "intent-request--inactive/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--inactive",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestInactive16",
          "filepath": "intent-request--inactive/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28.5",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--inactive",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestInactive",
        "global": "IntentRequestInactive",
        "filepath": "IntentRequestInactive.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18.5",
                    "cy": "22.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23.5",
                    "cy": "22.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28.5",
                    "cy": "22.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--scale-in",
      "friendlyName": "Intent request scale-in",
      "aliases": [
        "systems",
        "intent",
        "request",
        "square",
        "arrows",
        "scale in"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--scale-in.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"28.6,30 30,28.6 22.4,21 29,21 29,19 19,19 19,29 21,29 21,22.4 \"/>\n<polygon points=\"2,28.6 3.4,30 11,22.4 11,29 13,29 13,19 3,19 3,21 9.6,21 \"/>\n<polygon points=\"17,2 15,2 15,12.2 10.4,7.6 9,9 16,16 23,9 21.6,7.6 17,12.2 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z\"/></svg>",
            "info": {},
            "path": "32/intent-request--scale-in.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestScaleIn32",
          "filepath": "intent-request--scale-in/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
                }
              }
            ],
            "name": "intent-request--scale-in",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestScaleIn24",
          "filepath": "intent-request--scale-in/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
                }
              }
            ],
            "name": "intent-request--scale-in",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestScaleIn20",
          "filepath": "intent-request--scale-in/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
                }
              }
            ],
            "name": "intent-request--scale-in",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestScaleIn16",
          "filepath": "intent-request--scale-in/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
                }
              }
            ],
            "name": "intent-request--scale-in",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestScaleIn",
        "global": "IntentRequestScaleIn",
        "filepath": "IntentRequestScaleIn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--scale-out",
      "friendlyName": "Intent request scale-out",
      "aliases": [
        "systems",
        "intent",
        "request",
        "square",
        "arrows",
        "scale out"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--scale-out.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"19,20.4 20.4,19 28,26.6 28,20 30,20 30,30 20,30 20,28 26.6,28 \"/>\n<polygon points=\"13,20.4 11.6,19 4,26.6 4,20 2,20 2,30 12,30 12,28 5.4,28 \"/>\n<polygon points=\"17,16 15,16 15,5.8 10.4,10.4 9,9 16,2 23,9 21.6,10.4 17,5.8 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z\"/></svg>",
            "info": {},
            "path": "32/intent-request--scale-out.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestScaleOut32",
          "filepath": "intent-request--scale-out/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
                }
              }
            ],
            "name": "intent-request--scale-out",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestScaleOut24",
          "filepath": "intent-request--scale-out/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
                }
              }
            ],
            "name": "intent-request--scale-out",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestScaleOut20",
          "filepath": "intent-request--scale-out/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
                }
              }
            ],
            "name": "intent-request--scale-out",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestScaleOut16",
          "filepath": "intent-request--scale-out/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
                }
              }
            ],
            "name": "intent-request--scale-out",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestScaleOut",
        "global": "IntentRequestScaleOut",
        "filepath": "IntentRequestScaleOut.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--uninstall",
      "friendlyName": "Intent request uninstall",
      "aliases": [
        "systems",
        "intent",
        "request",
        "hexagon",
        "x"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--uninstall.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"30,21.4 28.6,20 25,23.6 21.4,20 20,21.4 23.6,25 20,28.6 21.4,30 25,26.4 28.6,30 30,28.6 26.4,25 \"/>\n<path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\n\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z\"/><path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/></svg>",
            "info": {},
            "path": "32/intent-request--uninstall.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestUninstall32",
          "filepath": "intent-request--uninstall/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--uninstall",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestUninstall24",
          "filepath": "intent-request--uninstall/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--uninstall",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestUninstall20",
          "filepath": "intent-request--uninstall/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--uninstall",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestUninstall16",
          "filepath": "intent-request--uninstall/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--uninstall",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestUninstall",
        "global": "IntentRequestUninstall",
        "filepath": "IntentRequestUninstall.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intent-request--upgrade",
      "friendlyName": "Intent request upgrade",
      "aliases": [
        "systems",
        "intent",
        "request",
        "hexagon",
        "up arrow",
        "upgrade"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intent-request--upgrade.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"28,23 26.6,24.4 24,21.8 24,30 22,30 22,21.8 19.4,24.4 18,23 23,18 \"/>\n<path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\n\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z\"/><path d=\"M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z\"/></svg>",
            "info": {},
            "path": "32/intent-request--upgrade.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntentRequestUpgrade32",
          "filepath": "intent-request--upgrade/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--upgrade",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntentRequestUpgrade24",
          "filepath": "intent-request--upgrade/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--upgrade",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntentRequestUpgrade20",
          "filepath": "intent-request--upgrade/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--upgrade",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntentRequestUpgrade16",
          "filepath": "intent-request--upgrade/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9\tc0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                }
              }
            ],
            "name": "intent-request--upgrade",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntentRequestUpgrade",
        "global": "IntentRequestUpgrade",
        "filepath": "IntentRequestUpgrade.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "interactions",
      "friendlyName": "Interactions",
      "aliases": [
        "statistics interactions",
        "statistic",
        "interactions"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/interactions.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 61 (89581) - https://sketch.com -->\n    <title>Interactions 16</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"Interactions-16\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z\" id=\"Combined-Shape\" fill=\"#000000\"></path>\n    </g>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z\"/></svg>",
            "info": {},
            "path": "16/interactions.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/interactions.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>interactions</title><path d=\"M26,18H22V14H20V28h6a2.0027,2.0027,0,0,0,2-2V20A2.0023,2.0023,0,0,0,26,18Zm-4,8V20h4v6Z\"/><polygon points=\"20 6.076 19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076\"/><path d=\"M10,18H5v2h5v2H6a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V20A2.0023,2.0023,0,0,0,10,18Zm0,8H6V24h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z\"/></svg>",
            "info": {},
            "path": "32/interactions.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Interactions32",
          "filepath": "interactions/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
                }
              }
            ],
            "name": "interactions",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Interactions24",
          "filepath": "interactions/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
                }
              }
            ],
            "name": "interactions",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Interactions20",
          "filepath": "interactions/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
                }
              }
            ],
            "name": "interactions",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Interactions16",
          "filepath": "interactions/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z"
                }
              }
            ],
            "name": "interactions",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Interactions",
        "global": "Interactions",
        "filepath": "Interactions.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "interactive-segmentation-cursor",
      "friendlyName": "Interactive segmentation cursor",
      "aliases": [
        "interactive segmentation cursor",
        "healthcare",
        "segmentation",
        "cursor"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/interactive-segmentation-cursor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>interactive-segmentation-cursor</title><path d=\"M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z\"/><rect x=\"7.5858\" y=\"18.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(-11.5061 12.2218) rotate(-45)\"/><rect x=\"18.5858\" y=\"7.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(-0.5061 16.7782) rotate(-45)\"/><rect x=\"7.5858\" y=\"7.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(-3.7279 9) rotate(-45)\"/><polygon points=\"11 2 2 2 2 11 4 11 4 4 11 4 11 2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z\"/><path d=\"M7.586 18.586H10.414V21.413999999999998H7.586z\" transform=\"rotate(-45 9 20)\"/><path d=\"M18.586 7.586H21.413999999999998V10.414H18.586z\" transform=\"rotate(-45 20 9)\"/><path d=\"M7.586 7.586H10.414V10.414H7.586z\" transform=\"rotate(-45 9 9)\"/><path d=\"M11 2L2 2 2 11 4 11 4 4 11 4 11 2z\"/></svg>",
            "info": {},
            "path": "32/watson-health/interactive-segmentation-cursor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthInteractiveSegmentationCursor32",
          "filepath": "watson-health/interactive-segmentation-cursor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 18.586H10.414V21.413999999999998H7.586z",
                  "transform": "rotate(-45 9 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.586 7.586H21.413999999999998V10.414H18.586z",
                  "transform": "rotate(-45 20 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 7.586H10.414V10.414H7.586z",
                  "transform": "rotate(-45 9 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "interactive-segmentation-cursor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthInteractiveSegmentationCursor24",
          "filepath": "watson-health/interactive-segmentation-cursor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 18.586H10.414V21.413999999999998H7.586z",
                  "transform": "rotate(-45 9 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.586 7.586H21.413999999999998V10.414H18.586z",
                  "transform": "rotate(-45 20 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 7.586H10.414V10.414H7.586z",
                  "transform": "rotate(-45 9 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "interactive-segmentation-cursor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthInteractiveSegmentationCursor20",
          "filepath": "watson-health/interactive-segmentation-cursor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 18.586H10.414V21.413999999999998H7.586z",
                  "transform": "rotate(-45 9 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.586 7.586H21.413999999999998V10.414H18.586z",
                  "transform": "rotate(-45 20 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 7.586H10.414V10.414H7.586z",
                  "transform": "rotate(-45 9 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "interactive-segmentation-cursor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthInteractiveSegmentationCursor16",
          "filepath": "watson-health/interactive-segmentation-cursor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 18.586H10.414V21.413999999999998H7.586z",
                  "transform": "rotate(-45 9 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.586 7.586H21.413999999999998V10.414H18.586z",
                  "transform": "rotate(-45 20 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.586 7.586H10.414V10.414H7.586z",
                  "transform": "rotate(-45 9 9)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "interactive-segmentation-cursor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "InteractiveSegmentationCursor",
        "global": "WatsonHealthInteractiveSegmentationCursor",
        "filepath": "watson-health/InteractiveSegmentationCursor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.586 18.586H10.414V21.413999999999998H7.586z",
                    "transform": "rotate(-45 9 20)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.586 7.586H21.413999999999998V10.414H18.586z",
                    "transform": "rotate(-45 20 9)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.586 7.586H10.414V10.414H7.586z",
                    "transform": "rotate(-45 9 9)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intersect",
      "friendlyName": "Intersect",
      "aliases": [
        "intersect",
        "operations",
        "converge"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intersect.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,24H18V22h4V18h2v4A2.0021,2.0021,0,0,1,22,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10,14H8V10a2.0022,2.0022,0,0,1,2-2h4v2H10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z\"/><path d=\"M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z\"/></svg>",
            "info": {},
            "path": "32/intersect.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Intersect32",
          "filepath": "intersect/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
                }
              }
            ],
            "name": "intersect",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Intersect24",
          "filepath": "intersect/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
                }
              }
            ],
            "name": "intersect",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Intersect20",
          "filepath": "intersect/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
                }
              }
            ],
            "name": "intersect",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Intersect16",
          "filepath": "intersect/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
                }
              }
            ],
            "name": "intersect",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Intersect",
        "global": "Intersect",
        "filepath": "Intersect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "intrusion-prevention",
      "friendlyName": "Intrusion prevention",
      "aliases": [
        "intrustion",
        "prevent",
        "protect",
        "monitoring",
        "watch",
        "eye",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/intrusion-prevention.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"22\" cy=\"23.8872\" r=\"2\"/>\n  <path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25,10H4A2.0021,2.0021,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H25a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,25,10ZM4,4V8H25V4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M12,28H4V24h8V22H4a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22\" cy=\"23.887\" r=\"2\"/><path d=\"M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z\"/><path d=\"M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z\"/></svg>",
            "info": {},
            "path": "32/intrusion-prevention.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IntrusionPrevention32",
          "filepath": "intrusion-prevention/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "23.887",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
                }
              }
            ],
            "name": "intrusion-prevention",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IntrusionPrevention24",
          "filepath": "intrusion-prevention/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "23.887",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
                }
              }
            ],
            "name": "intrusion-prevention",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IntrusionPrevention20",
          "filepath": "intrusion-prevention/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "23.887",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
                }
              }
            ],
            "name": "intrusion-prevention",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IntrusionPrevention16",
          "filepath": "intrusion-prevention/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "23.887",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
                }
              }
            ],
            "name": "intrusion-prevention",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "IntrusionPrevention",
        "global": "IntrusionPrevention",
        "filepath": "IntrusionPrevention.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "23.887",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "inventory-management",
      "friendlyName": "Inventory management",
      "aliases": [
        "supervision",
        "asset management",
        "inventory",
        "dashboard",
        "supply chain",
        "analytics",
        "administration",
        "oversight",
        "count"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/inventory-management.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>inventory-management</title><rect x=\"19\" y=\"24\" width=\"4\" height=\"4\"/><rect x=\"26\" y=\"24\" width=\"4\" height=\"4\"/><rect x=\"19\" y=\"17\" width=\"4\" height=\"4\"/><rect x=\"26\" y=\"17\" width=\"4\" height=\"4\"/><path d=\"M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z\"/><path d=\"M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z\"/></svg>",
            "info": {},
            "path": "32/inventory-management.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "InventoryManagement32",
          "filepath": "inventory-management/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "inventory-management",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "InventoryManagement24",
          "filepath": "inventory-management/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "inventory-management",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "InventoryManagement20",
          "filepath": "inventory-management/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "inventory-management",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "InventoryManagement16",
          "filepath": "inventory-management/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "inventory-management",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "InventoryManagement",
        "global": "InventoryManagement",
        "filepath": "InventoryManagement.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "iot--connect",
      "friendlyName": "IoT connect",
      "aliases": [
        "internet of things",
        "smart objects",
        "connectivity",
        "connected",
        "network",
        "communication",
        "wireless",
        "sensors",
        "analytics",
        "machine learning",
        "smart devices",
        "connect",
        "platform",
        "ML"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/iot--connect.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>iot--connect</title><path d=\"M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z\"/><path d=\"M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z\"/><path d=\"M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z\"/></svg>",
            "info": {},
            "path": "32/iot--connect.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IotConnect32",
          "filepath": "iot--connect/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
                }
              }
            ],
            "name": "iot--connect",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IotConnect24",
          "filepath": "iot--connect/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
                }
              }
            ],
            "name": "iot--connect",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IotConnect20",
          "filepath": "iot--connect/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
                }
              }
            ],
            "name": "iot--connect",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IotConnect16",
          "filepath": "iot--connect/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
                }
              }
            ],
            "name": "iot--connect",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "IotConnect",
        "global": "IotConnect",
        "filepath": "IotConnect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "iot--platform",
      "friendlyName": "IoT platform",
      "aliases": [
        "internet of things",
        "smart objects",
        "connectivity",
        "connected",
        "network",
        "communication",
        "wireless",
        "sensors",
        "analytics",
        "machine learning",
        "smart devices",
        "connect",
        "platform",
        "ML"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/iot--platform.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>iot--platform</title><path d=\"M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z\"/><path d=\"M21,21H11V11H21Zm-8-2h6V13H13Z\"/><path d=\"M31,13H29A10.0117,10.0117,0,0,0,19,3V1A12.0131,12.0131,0,0,1,31,13Z\"/><path d=\"M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z\"/><path d=\"M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z\"/><path d=\"M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z\"/></svg>",
            "info": {},
            "path": "32/iot--platform.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IotPlatform32",
          "filepath": "iot--platform/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
                }
              }
            ],
            "name": "iot--platform",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IotPlatform24",
          "filepath": "iot--platform/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
                }
              }
            ],
            "name": "iot--platform",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IotPlatform20",
          "filepath": "iot--platform/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
                }
              }
            ],
            "name": "iot--platform",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IotPlatform16",
          "filepath": "iot--platform/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
                }
              }
            ],
            "name": "iot--platform",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "IotPlatform",
        "global": "IotPlatform",
        "filepath": "IotPlatform.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ISO",
      "friendlyName": "ISO",
      "aliases": [
        "photo",
        "sensitivity",
        "light",
        "camera",
        "archive",
        "backup",
        "file set",
        "ISO"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ISO.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ISO</title><path d=\"M28,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,28,23ZM24,11V21h4V11Z\"/><path d=\"M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z\"/><polygon points=\"2 11 5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z\"/></svg>",
            "info": {},
            "path": "32/ISO.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Iso32",
          "filepath": "ISO/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "ISO",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Iso24",
          "filepath": "ISO/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "ISO",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Iso20",
          "filepath": "ISO/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "ISO",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Iso16",
          "filepath": "ISO/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "ISO",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Iso",
        "global": "Iso",
        "filepath": "Iso.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ISO--filled",
      "friendlyName": "ISO filled",
      "aliases": [
        "photo",
        "sensitivity",
        "light",
        "camera",
        "archive",
        "backup",
        "file set",
        "ISO",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ISO--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ISO--filled</title><rect x=\"21\" y=\"13\" width=\"3\" height=\"6\"/><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 13H24V19H21z\"/><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/ISO--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IsoFilled32",
          "filepath": "ISO--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13H24V19H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "ISO--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IsoFilled24",
          "filepath": "ISO--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13H24V19H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "ISO--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IsoFilled20",
          "filepath": "ISO--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13H24V19H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "ISO--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IsoFilled16",
          "filepath": "ISO--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 13H24V19H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "ISO--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "IsoFilled",
        "global": "IsoFilled",
        "filepath": "IsoFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 13H24V19H21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ISO--outline",
      "friendlyName": "ISO outline",
      "aliases": [
        "photo",
        "sensitivity",
        "light",
        "camera",
        "archive",
        "backup",
        "file set",
        "ISO",
        "outline"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ISO--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ISO--outline</title><path d=\"M24,21H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2v6A2,2,0,0,1,24,21Zm-3-8v6h3V13Z\"/><path d=\"M15,21H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H12v2h3a2,2,0,0,1,2,2v2A2,2,0,0,1,15,21Z\"/><rect x=\"6\" y=\"11\" width=\"2\" height=\"10\"/><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z\"/><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z\"/></svg>",
            "info": {},
            "path": "32/ISO--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "IsoOutline32",
          "filepath": "ISO--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              }
            ],
            "name": "ISO--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "IsoOutline24",
          "filepath": "ISO--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              }
            ],
            "name": "ISO--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "IsoOutline20",
          "filepath": "ISO--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              }
            ],
            "name": "ISO--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "IsoOutline16",
          "filepath": "ISO--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                }
              }
            ],
            "name": "ISO--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "IsoOutline",
        "global": "IsoOutline",
        "filepath": "IsoOutline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "join--full",
      "friendlyName": "Join full",
      "aliases": [
        "join",
        "full"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/join--full.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z\"/>\n  <path d=\"M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z\"/>\n  <path d=\"M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z\"/>\n  <path d=\"M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z\" data-icon-path=\"inner-path\"/><path d=\"M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z\"/><path d=\"M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z\"/><path d=\"M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z\"/></svg>",
            "info": {},
            "path": "32/join--full.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "JoinFull32",
          "filepath": "join--full/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
                }
              }
            ],
            "name": "join--full",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "JoinFull24",
          "filepath": "join--full/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
                }
              }
            ],
            "name": "join--full",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "JoinFull20",
          "filepath": "join--full/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
                }
              }
            ],
            "name": "join--full",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "JoinFull16",
          "filepath": "join--full/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
                }
              }
            ],
            "name": "join--full",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "JoinFull",
        "global": "JoinFull",
        "filepath": "JoinFull.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "join--inner",
      "friendlyName": "Join inner",
      "aliases": [
        "join",
        "inner"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/join--inner.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>join--inner</title>\n  <path d=\"M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z\"/></svg>",
            "info": {},
            "path": "32/join--inner.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "JoinInner32",
          "filepath": "join--inner/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
                }
              }
            ],
            "name": "join--inner",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "JoinInner24",
          "filepath": "join--inner/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
                }
              }
            ],
            "name": "join--inner",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "JoinInner20",
          "filepath": "join--inner/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
                }
              }
            ],
            "name": "join--inner",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "JoinInner16",
          "filepath": "join--inner/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
                }
              }
            ],
            "name": "join--inner",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "JoinInner",
        "global": "JoinInner",
        "filepath": "JoinInner.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "join--left",
      "friendlyName": "Join left",
      "aliases": [
        "join",
        "left"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/join--left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>join--left</title>\n  <path d=\"M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z\"/>\n  <path d=\"M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z\"/>\n  <path d=\"M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z\"/><path d=\"M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z\"/><path fill=\"none\" d=\"M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z\" data-icon-path=\"inner-path\"/><path d=\"M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z\"/></svg>",
            "info": {},
            "path": "32/join--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "JoinLeft32",
          "filepath": "join--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
                }
              }
            ],
            "name": "join--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "JoinLeft24",
          "filepath": "join--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
                }
              }
            ],
            "name": "join--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "JoinLeft20",
          "filepath": "join--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
                }
              }
            ],
            "name": "join--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "JoinLeft16",
          "filepath": "join--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
                }
              }
            ],
            "name": "join--left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "JoinLeft",
        "global": "JoinLeft",
        "filepath": "JoinLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "join--outer",
      "friendlyName": "Join outer",
      "aliases": [
        "join",
        "outer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/join--outer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>join--outter</title>\n  <path d=\"M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z\"/>\n  <path d=\"M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z\"/></svg>",
            "info": {},
            "path": "32/join--outer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "JoinOuter32",
          "filepath": "join--outer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
                }
              }
            ],
            "name": "join--outer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "JoinOuter24",
          "filepath": "join--outer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
                }
              }
            ],
            "name": "join--outer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "JoinOuter20",
          "filepath": "join--outer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
                }
              }
            ],
            "name": "join--outer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "JoinOuter16",
          "filepath": "join--outer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
                }
              }
            ],
            "name": "join--outer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "JoinOuter",
        "global": "JoinOuter",
        "filepath": "JoinOuter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "join--right",
      "friendlyName": "Join right",
      "aliases": [
        "join",
        "right"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/join--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>join--right</title>\n  <path d=\"M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z\"/>\n  <path d=\"M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z\"/>\n  <path d=\"M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z\"/><path fill=\"none\" d=\"M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z\" data-icon-path=\"inner-path\"/><path d=\"M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z\"/><path d=\"M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z\"/></svg>",
            "info": {},
            "path": "32/join--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "JoinRight32",
          "filepath": "join--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
                }
              }
            ],
            "name": "join--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "JoinRight24",
          "filepath": "join--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
                }
              }
            ],
            "name": "join--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "JoinRight20",
          "filepath": "join--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
                }
              }
            ],
            "name": "join--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "JoinRight16",
          "filepath": "join--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
                }
              }
            ],
            "name": "join--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "JoinRight",
        "global": "JoinRight",
        "filepath": "JoinRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "JPG",
      "friendlyName": "JPG",
      "aliases": [
        "file",
        "type",
        "format",
        "pic",
        "picture",
        "photo",
        "image",
        "compress",
        "JPG",
        "photograph",
        "compression"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/JPG.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>JPG</title><path d=\"M30,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H24V21h4V17H26V15h4Z\"/><path d=\"M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z\"/><path d=\"M8,23H4a2,2,0,0,1-2-2V19H4v2H8V9h2V21A2,2,0,0,1,8,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z\"/></svg>",
            "info": {},
            "path": "32/JPG.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Jpg32",
          "filepath": "JPG/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
                }
              }
            ],
            "name": "JPG",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Jpg24",
          "filepath": "JPG/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
                }
              }
            ],
            "name": "JPG",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Jpg20",
          "filepath": "JPG/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
                }
              }
            ],
            "name": "JPG",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Jpg16",
          "filepath": "JPG/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
                }
              }
            ],
            "name": "JPG",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Jpg",
        "global": "Jpg",
        "filepath": "Jpg.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "JSON",
      "friendlyName": "JSON",
      "aliases": [
        "javascript",
        "object",
        "notation",
        "file",
        "type",
        "format",
        "data",
        "JSON"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/JSON.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>JSON</title><polygon points=\"31 11 31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11\"/><path d=\"M21.3335,21h-2.667A1.6684,1.6684,0,0,1,17,19.3335v-6.667A1.6684,1.6684,0,0,1,18.6665,11h2.667A1.6684,1.6684,0,0,1,23,12.6665v6.667A1.6684,1.6684,0,0,1,21.3335,21ZM19,19h2V13H19Z\"/><path d=\"M13.3335,21H9V19h4V17H11a2.002,2.002,0,0,1-2-2V12.6665A1.6684,1.6684,0,0,1,10.6665,11H15v2H11v2h2a2.002,2.002,0,0,1,2,2v2.3335A1.6684,1.6684,0,0,1,13.3335,21Z\"/><path d=\"M5.3335,21H2.6665A1.6684,1.6684,0,0,1,1,19.3335V17H3v2H5V11H7v8.3335A1.6684,1.6684,0,0,1,5.3335,21Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z\"/></svg>",
            "info": {},
            "path": "32/JSON.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Json32",
          "filepath": "JSON/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
                }
              }
            ],
            "name": "JSON",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Json24",
          "filepath": "JSON/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
                }
              }
            ],
            "name": "JSON",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Json20",
          "filepath": "JSON/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
                }
              }
            ],
            "name": "JSON",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Json16",
          "filepath": "JSON/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
                }
              }
            ],
            "name": "JSON",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Json",
        "global": "Json",
        "filepath": "Json.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "JSON--reference",
      "friendlyName": "JSON reference",
      "aliases": [
        "javascript",
        "object",
        "notation",
        "file",
        "type",
        "format",
        "data",
        "JSON reference",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/JSON--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <polygon points=\"29 12 27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12\"/>\n  <path d=\"M21.3335,6h-2.667A1.6683,1.6683,0,0,0,17,7.6665v6.667A1.6684,1.6684,0,0,0,18.6665,16h2.667A1.6683,1.6683,0,0,0,23,14.3335V7.6665A1.6683,1.6683,0,0,0,21.3335,6ZM21,14H19V8h2Z\"/>\n  <path d=\"M9,7.6665V10a2.002,2.002,0,0,0,2,2h2v2H9v2h4.3335A1.6683,1.6683,0,0,0,15,14.3335V12a2.002,2.002,0,0,0-2-2H11V8h4V6H10.6665A1.6683,1.6683,0,0,0,9,7.6665Z\"/>\n  <path d=\"M5,14H3V12H1v2.3335A1.6684,1.6684,0,0,0,2.6665,16h2.667A1.6683,1.6683,0,0,0,7,14.3335V6H5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z\"/></svg>",
            "info": {},
            "path": "32/JSON--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "JsonReference32",
          "filepath": "JSON--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
                }
              }
            ],
            "name": "JSON--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "JsonReference24",
          "filepath": "JSON--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
                }
              }
            ],
            "name": "JSON--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "JsonReference20",
          "filepath": "JSON--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
                }
              }
            ],
            "name": "JSON--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "JsonReference16",
          "filepath": "JSON--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
                }
              }
            ],
            "name": "JSON--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "JsonReference",
        "global": "JsonReference",
        "filepath": "JsonReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "jump-link",
      "friendlyName": "Jump link",
      "aliases": [
        "jump link",
        "link",
        "go",
        "open"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/jump-link.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>jump-link</title><path d=\"M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z\"/></svg>",
            "info": {},
            "path": "32/jump-link.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "JumpLink32",
          "filepath": "jump-link/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
                }
              }
            ],
            "name": "jump-link",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "JumpLink24",
          "filepath": "jump-link/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
                }
              }
            ],
            "name": "jump-link",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "JumpLink20",
          "filepath": "jump-link/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
                }
              }
            ],
            "name": "jump-link",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "JumpLink16",
          "filepath": "jump-link/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
                }
              }
            ],
            "name": "jump-link",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "JumpLink",
        "global": "JumpLink",
        "filepath": "JumpLink.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "keep-dry",
      "friendlyName": "Keep dry",
      "aliases": [
        "keep dry",
        "protect",
        "commerce",
        "product label",
        "packaging",
        "handling"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/keep-dry.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z\"/><path d=\"M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z\"/></svg>",
            "info": {},
            "path": "32/keep-dry.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "KeepDry32",
          "filepath": "keep-dry/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
                }
              }
            ],
            "name": "keep-dry",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "KeepDry24",
          "filepath": "keep-dry/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
                }
              }
            ],
            "name": "keep-dry",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "KeepDry20",
          "filepath": "keep-dry/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
                }
              }
            ],
            "name": "keep-dry",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "KeepDry16",
          "filepath": "keep-dry/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
                }
              }
            ],
            "name": "keep-dry",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "KeepDry",
        "global": "KeepDry",
        "filepath": "KeepDry.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "keyboard",
      "friendlyName": "Keyboard",
      "aliases": [
        "console",
        "typing",
        "type",
        "key commands",
        "computer",
        "word processor",
        "write"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/keyboard.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>keyboard</title><path d=\"M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z\"/><rect x=\"10\" y=\"20\" width=\"11\" height=\"2\"/><rect x=\"6\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"14\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"14\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"22\" y=\"12\" width=\"4\" height=\"2\"/><rect x=\"22\" y=\"16\" width=\"4\" height=\"2\"/><rect x=\"18\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"23\" y=\"20\" width=\"3\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z\"/><path d=\"M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z\"/></svg>",
            "info": {},
            "path": "32/keyboard.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Keyboard32",
          "filepath": "keyboard/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
                }
              }
            ],
            "name": "keyboard",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Keyboard24",
          "filepath": "keyboard/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
                }
              }
            ],
            "name": "keyboard",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Keyboard20",
          "filepath": "keyboard/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
                }
              }
            ],
            "name": "keyboard",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Keyboard16",
          "filepath": "keyboard/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
                }
              }
            ],
            "name": "keyboard",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Keyboard",
        "global": "Keyboard",
        "filepath": "Keyboard.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "keyboard--off",
      "friendlyName": "keyboard--off",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/keyboard--off.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"6\" y=\"12\" width=\"2\" height=\"2\"/>\n<rect x=\"18\" y=\"12\" width=\"2\" height=\"2\"/>\n<rect x=\"6\" y=\"20\" width=\"2\" height=\"2\"/>\n<rect x=\"6\" y=\"16\" width=\"2\" height=\"2\"/>\n<rect x=\"10\" y=\"16\" width=\"2\" height=\"2\"/>\n<rect x=\"22\" y=\"12\" width=\"4\" height=\"2\"/>\n<rect x=\"22\" y=\"16\" width=\"4\" height=\"2\"/>\n<path d=\"M14.2,10H28v13h2V10c0-1.1-0.9-2-2-2H12.2L14.2,10z\"/>\n<path d=\"M30,28.6L3.4,2L2,3.4L6.6,8H4c-1.1,0-2,0.9-2,2v14c0,1.1,0.9,2,2,2h20.6l4,4L30,28.6z M4,24V10h4.6l2,2H10v2h2.6l2,2H14v2\n\th2.6l2,2H10v2h10.6l2,2H4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z\"/><path d=\"M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z\"/></svg>",
            "info": {},
            "path": "32/keyboard--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "KeyboardOff32",
          "filepath": "keyboard--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z"
                }
              }
            ],
            "name": "keyboard--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "KeyboardOff24",
          "filepath": "keyboard--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z"
                }
              }
            ],
            "name": "keyboard--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "KeyboardOff20",
          "filepath": "keyboard--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z"
                }
              }
            ],
            "name": "keyboard--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "KeyboardOff16",
          "filepath": "keyboard--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z"
                }
              }
            ],
            "name": "keyboard--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "KeyboardOff",
        "global": "KeyboardOff",
        "filepath": "KeyboardOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "kubernetes",
      "friendlyName": "Kubernetes",
      "aliases": [
        "Kubernetes",
        "container",
        "cloud",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/kubernetes.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z\"/></svg>",
            "info": {},
            "path": "32/kubernetes.svg"
          }
        }
      ],
      "deprecated": true,
      "reason": "The current kubernetes icon has been replaced by logo--kubernetes",
      "output": [
        {
          "moduleName": "Kubernetes32",
          "filepath": "kubernetes/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
                }
              }
            ],
            "name": "kubernetes",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Kubernetes24",
          "filepath": "kubernetes/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
                }
              }
            ],
            "name": "kubernetes",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Kubernetes20",
          "filepath": "kubernetes/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
                }
              }
            ],
            "name": "kubernetes",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Kubernetes16",
          "filepath": "kubernetes/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
                }
              }
            ],
            "name": "kubernetes",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Kubernetes",
        "global": "Kubernetes",
        "filepath": "Kubernetes.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "label",
      "friendlyName": "Label",
      "aliases": [
        "information",
        "label",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/label.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,13H18v2h5v2H19a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V15A2.0023,2.0023,0,0,0,23,13Zm0,8H19V19h4Z\"/>\n  <path d=\"M13,9H9a2.002,2.002,0,0,0-2,2V23H9V18h4v5h2V11A2.002,2.002,0,0,0,13,9ZM9,16V11h4v5Z\"/>\n  <path d=\"M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z\"/><path d=\"M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z\"/></svg>",
            "info": {},
            "path": "32/label.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Label32",
          "filepath": "label/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "label",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Label24",
          "filepath": "label/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "label",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Label20",
          "filepath": "label/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "label",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Label16",
          "filepath": "label/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "label",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Label",
        "global": "Label",
        "filepath": "Label.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "language",
      "friendlyName": "Language",
      "aliases": [
        "language"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/language.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>language</title><rect x=\"18\" y=\"19\" width=\"6\" height=\"2\"/><rect x=\"18\" y=\"15\" width=\"12\" height=\"2\"/><rect x=\"18\" y=\"11\" width=\"12\" height=\"2\"/><path d=\"M14,21V19H9V17H7v2H2v2h8.2148a8.5914,8.5914,0,0,1-2.2159,3.9771A9.2731,9.2731,0,0,1,6.5521,23H4.3334a10.8553,10.8553,0,0,0,2.1451,3.2966A14.6584,14.6584,0,0,1,3,28.127L3.7021,30a16.42,16.42,0,0,0,4.2907-2.3362A16.4883,16.4883,0,0,0,12.2979,30L13,28.127A14.664,14.664,0,0,1,9.5228,26.3,10.3132,10.3132,0,0,0,12.2516,21Z\"/><path d=\"M11.1666,13H13.333L8.75,2H6.5832L2,13H4.1664L5,11h5.3335ZM5.8331,9,7.6665,4.6,9.5,9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z\"/></svg>",
            "info": {},
            "path": "32/language.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Language32",
          "filepath": "language/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
                }
              }
            ],
            "name": "language",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Language24",
          "filepath": "language/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
                }
              }
            ],
            "name": "language",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Language20",
          "filepath": "language/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
                }
              }
            ],
            "name": "language",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Language16",
          "filepath": "language/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
                }
              }
            ],
            "name": "language",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Language",
        "global": "Language",
        "filepath": "Language.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "laptop",
      "friendlyName": "Laptop",
      "aliases": [
        "laptop",
        "notebook",
        "computer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/laptop.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>laptop</title><path d=\"M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z\" transform=\"translate(0 0.0049)\"/><rect x=\"2\" y=\"26.0049\" width=\"28\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z\" transform=\"translate(0 .005)\"/><path d=\"M2 26.005H30V28.005H2z\"/></svg>",
            "info": {},
            "path": "32/laptop.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Laptop32",
          "filepath": "laptop/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26.005H30V28.005H2z"
                }
              }
            ],
            "name": "laptop",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Laptop24",
          "filepath": "laptop/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26.005H30V28.005H2z"
                }
              }
            ],
            "name": "laptop",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Laptop20",
          "filepath": "laptop/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26.005H30V28.005H2z"
                }
              }
            ],
            "name": "laptop",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Laptop16",
          "filepath": "laptop/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26.005H30V28.005H2z"
                }
              }
            ],
            "name": "laptop",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Laptop",
        "global": "Laptop",
        "filepath": "Laptop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
                    "transform": "translate(0 .005)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 26.005H30V28.005H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "lasso",
      "friendlyName": "Lasso",
      "aliases": [
        "lasso",
        "formatting",
        "tool"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/lasso.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z\"/></svg>",
            "info": {},
            "path": "32/lasso.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Lasso32",
          "filepath": "lasso/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "lasso",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Lasso24",
          "filepath": "lasso/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "lasso",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Lasso20",
          "filepath": "lasso/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "lasso",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Lasso16",
          "filepath": "lasso/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
                }
              }
            ],
            "name": "lasso",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Lasso",
        "global": "Lasso",
        "filepath": "Lasso.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "lasso--polygon",
      "friendlyName": "Lasso polygon",
      "aliases": [
        "lasso polygon",
        "formatting",
        "tool"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/lasso--polygon.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z\"/></svg>",
            "info": {},
            "path": "32/lasso--polygon.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LassoPolygon32",
          "filepath": "lasso--polygon/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
                }
              }
            ],
            "name": "lasso--polygon",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LassoPolygon24",
          "filepath": "lasso--polygon/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
                }
              }
            ],
            "name": "lasso--polygon",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LassoPolygon20",
          "filepath": "lasso--polygon/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
                }
              }
            ],
            "name": "lasso--polygon",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LassoPolygon16",
          "filepath": "lasso--polygon/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
                }
              }
            ],
            "name": "lasso--polygon",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "LassoPolygon",
        "global": "LassoPolygon",
        "filepath": "LassoPolygon.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "launch",
      "friendlyName": "Launch",
      "aliases": [
        "open",
        "new window",
        "window",
        "expand",
        "link",
        "external link",
        "outbound"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/launch.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>launch</title>\n<path d=\"M13,14H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5v1H3v10h10V8h1v5C14,13.6,13.6,14,13,14z\"/>\n<polygon points=\"10,1 10,2 13.3,2 9,6.3 9.7,7 14,2.7 14,6 15,6 15,1 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13,14H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5v1H3v10h10V8h1v5C14,13.6,13.6,14,13,14z\"/><path d=\"M10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z\"/></svg>",
            "info": {},
            "path": "16/launch.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/launch.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z\"/>\n  <polygon points=\"20 2 20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z\"/><path d=\"M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z\"/></svg>",
            "info": {},
            "path": "32/launch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Launch32",
          "filepath": "launch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
                }
              }
            ],
            "name": "launch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Launch24",
          "filepath": "launch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
                }
              }
            ],
            "name": "launch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Launch20",
          "filepath": "launch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
                }
              }
            ],
            "name": "launch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Launch16",
          "filepath": "launch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,14H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5v1H3v10h10V8h1v5C14,13.6,13.6,14,13,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
                }
              }
            ],
            "name": "launch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Launch",
        "global": "Launch",
        "filepath": "Launch.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,14H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5v1H3v10h10V8h1v5C14,13.6,13.6,14,13,14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "launch-study--1",
      "friendlyName": "Launch study 1",
      "aliases": [
        "push",
        "pull",
        "server",
        "drive"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/launch-study--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--launch-study-1</title><circle cx=\"23\" cy=\"25\" r=\"1\"/><path d=\"M26,22v6H6V22H26m0-2H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z\"/><polygon points=\"20.59 10.59 17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59\"/><rect x=\"8\" y=\"24\" width=\"12\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"25\" r=\"1\"/><path d=\"M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z\"/><path d=\"M8 24H20V26H8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/launch-study--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthLaunchStudy_132",
          "filepath": "watson-health/launch-study--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_124",
          "filepath": "watson-health/launch-study--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_120",
          "filepath": "watson-health/launch-study--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_116",
          "filepath": "watson-health/launch-study--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "LaunchStudy_1",
        "global": "WatsonHealthLaunchStudy_1",
        "filepath": "watson-health/LaunchStudy_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 24H20V26H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "launch-study--2",
      "friendlyName": "Launch study 2",
      "aliases": [
        "push",
        "pull",
        "server",
        "drive"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/launch-study--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--launch-study-2</title><circle cx=\"23\" cy=\"7\" r=\"1\"/><path d=\"M26,4v6H6V4H26m0-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z\"/><polygon points=\"20.59 21.41 17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41\"/><rect x=\"8\" y=\"6\" width=\"12\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"7\" r=\"1\"/><path d=\"M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z\"/><path d=\"M8 6H20V8H8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/launch-study--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthLaunchStudy_232",
          "filepath": "watson-health/launch-study--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8z"
                }
              }
            ],
            "name": "launch-study--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_224",
          "filepath": "watson-health/launch-study--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8z"
                }
              }
            ],
            "name": "launch-study--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_220",
          "filepath": "watson-health/launch-study--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8z"
                }
              }
            ],
            "name": "launch-study--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_216",
          "filepath": "watson-health/launch-study--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8z"
                }
              }
            ],
            "name": "launch-study--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "LaunchStudy_2",
        "global": "WatsonHealthLaunchStudy_2",
        "filepath": "watson-health/LaunchStudy_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 6H20V8H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "launch-study--3",
      "friendlyName": "Launch study 3",
      "aliases": [
        "push",
        "pull",
        "server",
        "drive"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/launch-study--3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--launch-study--3</title><circle cx=\"23\" cy=\"25\" r=\"1\"/><path d=\"M26,22v6H6V22H26m0-2H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z\"/><polygon points=\"20.59 4.59 17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59\"/><polygon points=\"20.59 10.59 16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59\"/><rect x=\"8\" y=\"24\" width=\"12\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"25\" r=\"1\"/><path d=\"M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z\"/><path d=\"M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/launch-study--3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthLaunchStudy_332",
          "filepath": "watson-health/launch-study--3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_324",
          "filepath": "watson-health/launch-study--3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_320",
          "filepath": "watson-health/launch-study--3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthLaunchStudy_316",
          "filepath": "watson-health/launch-study--3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z"
                }
              }
            ],
            "name": "launch-study--3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "LaunchStudy_3",
        "global": "WatsonHealthLaunchStudy_3",
        "filepath": "watson-health/LaunchStudy_3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "layers",
      "friendlyName": "Layers",
      "aliases": [
        "operations",
        "layers"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/layers.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,21.12,16,27.8643,28.5259,21.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,30Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,18a.9967.9967,0,0,1-.4741-.12l-13-7a1,1,0,0,1,0-1.7607l13-7a.9982.9982,0,0,1,.9482,0l13,7a1,1,0,0,1,0,1.7607l-13,7A.9967.9967,0,0,1,16,18ZM5.1094,10,16,15.8643,26.8906,10,16,4.1358Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z\"/><path d=\"M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z\"/></svg>",
            "info": {},
            "path": "32/layers.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Layers32",
          "filepath": "layers/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z"
                }
              }
            ],
            "name": "layers",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Layers24",
          "filepath": "layers/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z"
                }
              }
            ],
            "name": "layers",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Layers20",
          "filepath": "layers/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z"
                }
              }
            ],
            "name": "layers",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Layers16",
          "filepath": "layers/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z"
                }
              }
            ],
            "name": "layers",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Layers",
        "global": "Layers",
        "filepath": "Layers.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "legend",
      "friendlyName": "Legend",
      "aliases": [
        "legend",
        "map",
        "markings",
        "interpret"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/legend.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>legend</title><rect x=\"16\" y=\"22\" width=\"14\" height=\"2\"/><rect x=\"4\" y=\"20\" width=\"6\" height=\"6\" rx=\"1\"/><rect x=\"16\" y=\"8\" width=\"14\" height=\"2\"/><path d=\"M9.5,12h-5a.5.5,0,0,1-.4473-.7236l2.5-5.0224a.5206.5206,0,0,1,.8945,0l2.5,5.0225A.5.5,0,0,1,9.5,12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22H30V24H16z\"/><rect width=\"6\" height=\"6\" x=\"4\" y=\"20\" rx=\"1\"/><path d=\"M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z\"/></svg>",
            "info": {},
            "path": "32/legend.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Legend32",
          "filepath": "legend/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "6",
                  "height": "6",
                  "x": "4",
                  "y": "20",
                  "rx": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z"
                }
              }
            ],
            "name": "legend",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Legend24",
          "filepath": "legend/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "6",
                  "height": "6",
                  "x": "4",
                  "y": "20",
                  "rx": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z"
                }
              }
            ],
            "name": "legend",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Legend20",
          "filepath": "legend/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "6",
                  "height": "6",
                  "x": "4",
                  "y": "20",
                  "rx": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z"
                }
              }
            ],
            "name": "legend",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Legend16",
          "filepath": "legend/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16z"
                }
              },
              {
                "elem": "rect",
                "attrs": {
                  "width": "6",
                  "height": "6",
                  "x": "4",
                  "y": "20",
                  "rx": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z"
                }
              }
            ],
            "name": "legend",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Legend",
        "global": "Legend",
        "filepath": "Legend.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22H30V24H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "rect",
                  "attributes": {
                    "width": "6",
                    "height": "6",
                    "x": "4",
                    "y": "20",
                    "rx": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Aa",
      "friendlyName": "Letter Aa",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Aa.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Aa</title><path d=\"M23,13H18v2h5v2H19a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V15A2,2,0,0,0,23,13Zm0,8H19V19h4Z\"/><path d=\"M13,9H9a2,2,0,0,0-2,2V23H9V18h4v5h2V11A2,2,0,0,0,13,9ZM9,16V11h4v5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z\"/></svg>",
            "info": {},
            "path": "32/letter--Aa.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterAa32",
          "filepath": "letter--Aa/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z"
                }
              }
            ],
            "name": "letter--Aa",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterAa24",
          "filepath": "letter--Aa/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z"
                }
              }
            ],
            "name": "letter--Aa",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterAa20",
          "filepath": "letter--Aa/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z"
                }
              }
            ],
            "name": "letter--Aa",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterAa16",
          "filepath": "letter--Aa/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z"
                }
              }
            ],
            "name": "letter--Aa",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterAa",
        "global": "LetterAa",
        "filepath": "LetterAa.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Bb",
      "friendlyName": "Letter Bb",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Bb.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Bb</title><path d=\"M23,13H19V9H17V23h6a2,2,0,0,0,2-2V15A2,2,0,0,0,23,13Zm-4,8V15h4v6Z\"/><path d=\"M15,12a3,3,0,0,0-3-3H7V23h5a3,3,0,0,0,3-3V18a3,3,0,0,0-.78-2A3,3,0,0,0,15,14ZM9,11h3a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H9Zm4,9a1,1,0,0,1-1,1H9V17h3a1,1,0,0,1,1,1Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 13H19V9H17V23h6a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM15 12a3 3 0 00-3-3H7V23h5a3 3 0 003-3V18a3 3 0 00-.78-2A3 3 0 0015 14zM9 11h3a1 1 0 011 1v2a1 1 0 01-1 1H9zm4 9a1 1 0 01-1 1H9V17h3a1 1 0 011 1z\"/></svg>",
            "info": {},
            "path": "32/letter--Bb.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterBb32",
          "filepath": "letter--Bb/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H19V9H17V23h6a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM15 12a3 3 0 00-3-3H7V23h5a3 3 0 003-3V18a3 3 0 00-.78-2A3 3 0 0015 14zM9 11h3a1 1 0 011 1v2a1 1 0 01-1 1H9zm4 9a1 1 0 01-1 1H9V17h3a1 1 0 011 1z"
                }
              }
            ],
            "name": "letter--Bb",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterBb24",
          "filepath": "letter--Bb/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H19V9H17V23h6a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM15 12a3 3 0 00-3-3H7V23h5a3 3 0 003-3V18a3 3 0 00-.78-2A3 3 0 0015 14zM9 11h3a1 1 0 011 1v2a1 1 0 01-1 1H9zm4 9a1 1 0 01-1 1H9V17h3a1 1 0 011 1z"
                }
              }
            ],
            "name": "letter--Bb",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterBb20",
          "filepath": "letter--Bb/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H19V9H17V23h6a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM15 12a3 3 0 00-3-3H7V23h5a3 3 0 003-3V18a3 3 0 00-.78-2A3 3 0 0015 14zM9 11h3a1 1 0 011 1v2a1 1 0 01-1 1H9zm4 9a1 1 0 01-1 1H9V17h3a1 1 0 011 1z"
                }
              }
            ],
            "name": "letter--Bb",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterBb16",
          "filepath": "letter--Bb/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H19V9H17V23h6a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM15 12a3 3 0 00-3-3H7V23h5a3 3 0 003-3V18a3 3 0 00-.78-2A3 3 0 0015 14zM9 11h3a1 1 0 011 1v2a1 1 0 01-1 1H9zm4 9a1 1 0 01-1 1H9V17h3a1 1 0 011 1z"
                }
              }
            ],
            "name": "letter--Bb",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterBb",
        "global": "LetterBb",
        "filepath": "LetterBb.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 13H19V9H17V23h6a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM15 12a3 3 0 00-3-3H7V23h5a3 3 0 003-3V18a3 3 0 00-.78-2A3 3 0 0015 14zM9 11h3a1 1 0 011 1v2a1 1 0 01-1 1H9zm4 9a1 1 0 01-1 1H9V17h3a1 1 0 011 1z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Cc",
      "friendlyName": "Letter Cc",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Cc.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Cc</title><path d=\"M24,23H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H19v6h5Z\"/><path d=\"M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h6Z\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 23H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v6h5zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z\"/></svg>",
            "info": {},
            "path": "32/letter--Cc.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterCc32",
          "filepath": "letter--Cc/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v6h5zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "letter--Cc",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterCc24",
          "filepath": "letter--Cc/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v6h5zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "letter--Cc",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterCc20",
          "filepath": "letter--Cc/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v6h5zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "letter--Cc",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterCc16",
          "filepath": "letter--Cc/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 23H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v6h5zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                }
              }
            ],
            "name": "letter--Cc",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterCc",
        "global": "LetterCc",
        "filepath": "LetterCc.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 23H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v6h5zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Dd",
      "friendlyName": "Letter Dd",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Dd.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Dd</title><path d=\"M23,9v4H19a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6V9Zm-4,6h4v6H19Z\"/><path d=\"M11,23H7V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,11,23ZM9,21h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 9v4H19a2 2 0 00-2 2v6a2 2 0 002 2h6V9zm-4 6h4v6H19zM11 23H7V9h4a4 4 0 014 4v6A4 4 0 0111 23zM9 21h2a2 2 0 002-2V13a2 2 0 00-2-2H9z\"/></svg>",
            "info": {},
            "path": "32/letter--Dd.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterDd32",
          "filepath": "letter--Dd/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9v4H19a2 2 0 00-2 2v6a2 2 0 002 2h6V9zm-4 6h4v6H19zM11 23H7V9h4a4 4 0 014 4v6A4 4 0 0111 23zM9 21h2a2 2 0 002-2V13a2 2 0 00-2-2H9z"
                }
              }
            ],
            "name": "letter--Dd",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterDd24",
          "filepath": "letter--Dd/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9v4H19a2 2 0 00-2 2v6a2 2 0 002 2h6V9zm-4 6h4v6H19zM11 23H7V9h4a4 4 0 014 4v6A4 4 0 0111 23zM9 21h2a2 2 0 002-2V13a2 2 0 00-2-2H9z"
                }
              }
            ],
            "name": "letter--Dd",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterDd20",
          "filepath": "letter--Dd/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9v4H19a2 2 0 00-2 2v6a2 2 0 002 2h6V9zm-4 6h4v6H19zM11 23H7V9h4a4 4 0 014 4v6A4 4 0 0111 23zM9 21h2a2 2 0 002-2V13a2 2 0 00-2-2H9z"
                }
              }
            ],
            "name": "letter--Dd",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterDd16",
          "filepath": "letter--Dd/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9v4H19a2 2 0 00-2 2v6a2 2 0 002 2h6V9zm-4 6h4v6H19zM11 23H7V9h4a4 4 0 014 4v6A4 4 0 0111 23zM9 21h2a2 2 0 002-2V13a2 2 0 00-2-2H9z"
                }
              }
            ],
            "name": "letter--Dd",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterDd",
        "global": "LetterDd",
        "filepath": "LetterDd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 9v4H19a2 2 0 00-2 2v6a2 2 0 002 2h6V9zm-4 6h4v6H19zM11 23H7V9h4a4 4 0 014 4v6A4 4 0 0111 23zM9 21h2a2 2 0 002-2V13a2 2 0 00-2-2H9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Ee",
      "friendlyName": "Letter Ee",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Ee.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,19V15a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V21H19V19Zm-6-4h4v2H19Z\"/>\n  <polygon points=\"15 11 15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 19V15a2.0023 2.0023 0 00-2-2H19a2.0023 2.0023 0 00-2 2v6a2.0077 2.0077 0 002 2h5V21H19V19zm-6-4h4v2H19zM15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z\"/></svg>",
            "info": {},
            "path": "32/letter--Ee.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterEe32",
          "filepath": "letter--Ee/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 19V15a2.0023 2.0023 0 00-2-2H19a2.0023 2.0023 0 00-2 2v6a2.0077 2.0077 0 002 2h5V21H19V19zm-6-4h4v2H19zM15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
                }
              }
            ],
            "name": "letter--Ee",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterEe24",
          "filepath": "letter--Ee/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 19V15a2.0023 2.0023 0 00-2-2H19a2.0023 2.0023 0 00-2 2v6a2.0077 2.0077 0 002 2h5V21H19V19zm-6-4h4v2H19zM15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
                }
              }
            ],
            "name": "letter--Ee",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterEe20",
          "filepath": "letter--Ee/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 19V15a2.0023 2.0023 0 00-2-2H19a2.0023 2.0023 0 00-2 2v6a2.0077 2.0077 0 002 2h5V21H19V19zm-6-4h4v2H19zM15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
                }
              }
            ],
            "name": "letter--Ee",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterEe16",
          "filepath": "letter--Ee/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 19V15a2.0023 2.0023 0 00-2-2H19a2.0023 2.0023 0 00-2 2v6a2.0077 2.0077 0 002 2h5V21H19V19zm-6-4h4v2H19zM15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
                }
              }
            ],
            "name": "letter--Ee",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterEe",
        "global": "LetterEe",
        "filepath": "LetterEe.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 19V15a2.0023 2.0023 0 00-2-2H19a2.0023 2.0023 0 00-2 2v6a2.0077 2.0077 0 002 2h5V21H19V19zm-6-4h4v2H19zM15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Ff",
      "friendlyName": "Letter Ff",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Ff.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Ff</title><polygon points=\"16 11 16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11\"/><path d=\"M24,11V9H21a2,2,0,0,0-2,2v2H17v2h2v8h2V15h3V13H21V11Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11zM24 11V9H21a2 2 0 00-2 2v2H17v2h2v8h2V15h3V13H21V11z\"/></svg>",
            "info": {},
            "path": "32/letter--Ff.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterFf32",
          "filepath": "letter--Ff/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11zM24 11V9H21a2 2 0 00-2 2v2H17v2h2v8h2V15h3V13H21V11z"
                }
              }
            ],
            "name": "letter--Ff",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterFf24",
          "filepath": "letter--Ff/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11zM24 11V9H21a2 2 0 00-2 2v2H17v2h2v8h2V15h3V13H21V11z"
                }
              }
            ],
            "name": "letter--Ff",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterFf20",
          "filepath": "letter--Ff/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11zM24 11V9H21a2 2 0 00-2 2v2H17v2h2v8h2V15h3V13H21V11z"
                }
              }
            ],
            "name": "letter--Ff",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterFf16",
          "filepath": "letter--Ff/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11zM24 11V9H21a2 2 0 00-2 2v2H17v2h2v8h2V15h3V13H21V11z"
                }
              }
            ],
            "name": "letter--Ff",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterFf",
        "global": "LetterFf",
        "filepath": "LetterFf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11zM24 11V9H21a2 2 0 00-2 2v2H17v2h2v8h2V15h3V13H21V11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Gg",
      "friendlyName": "Letter Gg",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Gg.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Gg</title><path d=\"M19,13a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h4v2H18v2h5a2,2,0,0,0,2-2V13Zm4,8H19V15h4Z\"/><path d=\"M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h4V17H11V15h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v2H18v2h5a2 2 0 002-2V13zm4 8H19V15h4zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h4V17H11V15h4z\"/></svg>",
            "info": {},
            "path": "32/letter--Gg.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterGg32",
          "filepath": "letter--Gg/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v2H18v2h5a2 2 0 002-2V13zm4 8H19V15h4zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h4V17H11V15h4z"
                }
              }
            ],
            "name": "letter--Gg",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterGg24",
          "filepath": "letter--Gg/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v2H18v2h5a2 2 0 002-2V13zm4 8H19V15h4zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h4V17H11V15h4z"
                }
              }
            ],
            "name": "letter--Gg",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterGg20",
          "filepath": "letter--Gg/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v2H18v2h5a2 2 0 002-2V13zm4 8H19V15h4zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h4V17H11V15h4z"
                }
              }
            ],
            "name": "letter--Gg",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterGg16",
          "filepath": "letter--Gg/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v2H18v2h5a2 2 0 002-2V13zm4 8H19V15h4zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h4V17H11V15h4z"
                }
              }
            ],
            "name": "letter--Gg",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterGg",
        "global": "LetterGg",
        "filepath": "LetterGg.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v2H18v2h5a2 2 0 002-2V13zm4 8H19V15h4zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h4V17H11V15h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Hh",
      "friendlyName": "Letter Hh",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Hh.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Hh</title><polygon points=\"13 9 13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9\"/><path d=\"M23,13H19V9H17V23h2V15h4v8h2V15A2,2,0,0,0,23,13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9zM23 13H19V9H17V23h2V15h4v8h2V15A2 2 0 0023 13z\"/></svg>",
            "info": {},
            "path": "32/letter--Hh.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterHh32",
          "filepath": "letter--Hh/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9zM23 13H19V9H17V23h2V15h4v8h2V15A2 2 0 0023 13z"
                }
              }
            ],
            "name": "letter--Hh",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterHh24",
          "filepath": "letter--Hh/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9zM23 13H19V9H17V23h2V15h4v8h2V15A2 2 0 0023 13z"
                }
              }
            ],
            "name": "letter--Hh",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterHh20",
          "filepath": "letter--Hh/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9zM23 13H19V9H17V23h2V15h4v8h2V15A2 2 0 0023 13z"
                }
              }
            ],
            "name": "letter--Hh",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterHh16",
          "filepath": "letter--Hh/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9zM23 13H19V9H17V23h2V15h4v8h2V15A2 2 0 0023 13z"
                }
              }
            ],
            "name": "letter--Hh",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterHh",
        "global": "LetterHh",
        "filepath": "LetterHh.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9zM23 13H19V9H17V23h2V15h4v8h2V15A2 2 0 0023 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Ii",
      "friendlyName": "Letter Ii",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Ii.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Ii</title><polygon points=\"10 11 13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11\"/><rect x=\"20\" y=\"13\" width=\"2\" height=\"10\"/><rect x=\"20\" y=\"9\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11zM20 13H22V23H20zM20 9H22V11H20z\"/></svg>",
            "info": {},
            "path": "32/letter--Ii.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterIi32",
          "filepath": "letter--Ii/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11zM20 13H22V23H20zM20 9H22V11H20z"
                }
              }
            ],
            "name": "letter--Ii",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterIi24",
          "filepath": "letter--Ii/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11zM20 13H22V23H20zM20 9H22V11H20z"
                }
              }
            ],
            "name": "letter--Ii",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterIi20",
          "filepath": "letter--Ii/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11zM20 13H22V23H20zM20 9H22V11H20z"
                }
              }
            ],
            "name": "letter--Ii",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterIi16",
          "filepath": "letter--Ii/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11zM20 13H22V23H20zM20 9H22V11H20z"
                }
              }
            ],
            "name": "letter--Ii",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterIi",
        "global": "LetterIi",
        "filepath": "LetterIi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11zM20 13H22V23H20zM20 9H22V11H20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Jj",
      "friendlyName": "Letter Jj",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Jj.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Jj</title><rect x=\"20\" y=\"9\" width=\"2\" height=\"2\"/><path d=\"M20,25H17v2h3a2,2,0,0,0,2-2V13H20Z\"/><path d=\"M14,23H10a2,2,0,0,1-2-2V19h2v2h4V9h2V21A2,2,0,0,1,14,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 9H22V11H20zM20 25H17v2h3a2 2 0 002-2V13H20zM14 23H10a2 2 0 01-2-2V19h2v2h4V9h2V21A2 2 0 0114 23z\"/></svg>",
            "info": {},
            "path": "32/letter--Jj.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterJj32",
          "filepath": "letter--Jj/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9H22V11H20zM20 25H17v2h3a2 2 0 002-2V13H20zM14 23H10a2 2 0 01-2-2V19h2v2h4V9h2V21A2 2 0 0114 23z"
                }
              }
            ],
            "name": "letter--Jj",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterJj24",
          "filepath": "letter--Jj/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9H22V11H20zM20 25H17v2h3a2 2 0 002-2V13H20zM14 23H10a2 2 0 01-2-2V19h2v2h4V9h2V21A2 2 0 0114 23z"
                }
              }
            ],
            "name": "letter--Jj",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterJj20",
          "filepath": "letter--Jj/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9H22V11H20zM20 25H17v2h3a2 2 0 002-2V13H20zM14 23H10a2 2 0 01-2-2V19h2v2h4V9h2V21A2 2 0 0114 23z"
                }
              }
            ],
            "name": "letter--Jj",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterJj16",
          "filepath": "letter--Jj/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9H22V11H20zM20 25H17v2h3a2 2 0 002-2V13H20zM14 23H10a2 2 0 01-2-2V19h2v2h4V9h2V21A2 2 0 0114 23z"
                }
              }
            ],
            "name": "letter--Jj",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterJj",
        "global": "LetterJj",
        "filepath": "LetterJj.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 9H22V11H20zM20 25H17v2h3a2 2 0 002-2V13H20zM14 23H10a2 2 0 01-2-2V19h2v2h4V9h2V21A2 2 0 0114 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Kk",
      "friendlyName": "Letter Kk",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Kk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Kk</title><polygon points=\"15 9 12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9\"/><polygon points=\"22.78 23 25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9zM22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z\"/></svg>",
            "info": {},
            "path": "32/letter--Kk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterKk32",
          "filepath": "letter--Kk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9zM22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
                }
              }
            ],
            "name": "letter--Kk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterKk24",
          "filepath": "letter--Kk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9zM22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
                }
              }
            ],
            "name": "letter--Kk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterKk20",
          "filepath": "letter--Kk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9zM22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
                }
              }
            ],
            "name": "letter--Kk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterKk16",
          "filepath": "letter--Kk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9zM22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
                }
              }
            ],
            "name": "letter--Kk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterKk",
        "global": "LetterKk",
        "filepath": "LetterKk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9zM22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Ll",
      "friendlyName": "Letter Ll",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Ll.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Ll</title><polygon points=\"11 21 11 9 9 9 9 23 17 23 17 21 11 21\"/><path d=\"M23,23H21a2,2,0,0,1-2-2V9h2V21h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 21L11 9 9 9 9 23 17 23 17 21 11 21zM23 23H21a2 2 0 01-2-2V9h2V21h2z\"/></svg>",
            "info": {},
            "path": "32/letter--Ll.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterLl32",
          "filepath": "letter--Ll/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21L11 9 9 9 9 23 17 23 17 21 11 21zM23 23H21a2 2 0 01-2-2V9h2V21h2z"
                }
              }
            ],
            "name": "letter--Ll",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterLl24",
          "filepath": "letter--Ll/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21L11 9 9 9 9 23 17 23 17 21 11 21zM23 23H21a2 2 0 01-2-2V9h2V21h2z"
                }
              }
            ],
            "name": "letter--Ll",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterLl20",
          "filepath": "letter--Ll/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21L11 9 9 9 9 23 17 23 17 21 11 21zM23 23H21a2 2 0 01-2-2V9h2V21h2z"
                }
              }
            ],
            "name": "letter--Ll",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterLl16",
          "filepath": "letter--Ll/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21L11 9 9 9 9 23 17 23 17 21 11 21zM23 23H21a2 2 0 01-2-2V9h2V21h2z"
                }
              }
            ],
            "name": "letter--Ll",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterLl",
        "global": "LetterLl",
        "filepath": "LetterLl.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 21L11 9 9 9 9 23 17 23 17 21 11 21zM23 23H21a2 2 0 01-2-2V9h2V21h2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Mm",
      "friendlyName": "Letter Mm",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Mm.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Mm</title><path d=\"M24,13H16V23h2V15h2v8h2V15h2v8h2V15A2,2,0,0,0,24,13Z\"/><polygon points=\"12 9 10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 13H16V23h2V15h2v8h2V15h2v8h2V15A2 2 0 0024 13zM12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z\"/></svg>",
            "info": {},
            "path": "32/letter--Mm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterMm32",
          "filepath": "letter--Mm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H16V23h2V15h2v8h2V15h2v8h2V15A2 2 0 0024 13zM12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
                }
              }
            ],
            "name": "letter--Mm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterMm24",
          "filepath": "letter--Mm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H16V23h2V15h2v8h2V15h2v8h2V15A2 2 0 0024 13zM12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
                }
              }
            ],
            "name": "letter--Mm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterMm20",
          "filepath": "letter--Mm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H16V23h2V15h2v8h2V15h2v8h2V15A2 2 0 0024 13zM12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
                }
              }
            ],
            "name": "letter--Mm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterMm16",
          "filepath": "letter--Mm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H16V23h2V15h2v8h2V15h2v8h2V15A2 2 0 0024 13zM12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
                }
              }
            ],
            "name": "letter--Mm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterMm",
        "global": "LetterMm",
        "filepath": "LetterMm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 13H16V23h2V15h2v8h2V15h2v8h2V15A2 2 0 0024 13zM12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Nn",
      "friendlyName": "Letter Nn",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Nn.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Nn</title><path d=\"M25,23H23V15H19v8H17V13h6a2,2,0,0,1,2,2Z\"/><polygon points=\"13 19 9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 23H23V15H19v8H17V13h6a2 2 0 012 2zM13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z\"/></svg>",
            "info": {},
            "path": "32/letter--Nn.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterNn32",
          "filepath": "letter--Nn/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H23V15H19v8H17V13h6a2 2 0 012 2zM13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
                }
              }
            ],
            "name": "letter--Nn",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterNn24",
          "filepath": "letter--Nn/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H23V15H19v8H17V13h6a2 2 0 012 2zM13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
                }
              }
            ],
            "name": "letter--Nn",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterNn20",
          "filepath": "letter--Nn/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H23V15H19v8H17V13h6a2 2 0 012 2zM13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
                }
              }
            ],
            "name": "letter--Nn",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterNn16",
          "filepath": "letter--Nn/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H23V15H19v8H17V13h6a2 2 0 012 2zM13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
                }
              }
            ],
            "name": "letter--Nn",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterNn",
        "global": "LetterNn",
        "filepath": "LetterNn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 23H23V15H19v8H17V13h6a2 2 0 012 2zM13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Oo",
      "friendlyName": "Letter Oo",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Oo.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Oo</title><path d=\"M23,23H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v6A2,2,0,0,1,23,23Zm-4-8v6h4V15Z\"/><path d=\"M13,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h4a2,2,0,0,1,2,2V21A2,2,0,0,1,13,23ZM9,11V21h4V11Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 23H19a2 2 0 01-2-2V15a2 2 0 012-2h4a2 2 0 012 2v6A2 2 0 0123 23zm-4-8v6h4V15zM13 23H9a2 2 0 01-2-2V11A2 2 0 019 9h4a2 2 0 012 2V21A2 2 0 0113 23zM9 11V21h4V11z\"/></svg>",
            "info": {},
            "path": "32/letter--Oo.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterOo32",
          "filepath": "letter--Oo/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V15a2 2 0 012-2h4a2 2 0 012 2v6A2 2 0 0123 23zm-4-8v6h4V15zM13 23H9a2 2 0 01-2-2V11A2 2 0 019 9h4a2 2 0 012 2V21A2 2 0 0113 23zM9 11V21h4V11z"
                }
              }
            ],
            "name": "letter--Oo",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterOo24",
          "filepath": "letter--Oo/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V15a2 2 0 012-2h4a2 2 0 012 2v6A2 2 0 0123 23zm-4-8v6h4V15zM13 23H9a2 2 0 01-2-2V11A2 2 0 019 9h4a2 2 0 012 2V21A2 2 0 0113 23zM9 11V21h4V11z"
                }
              }
            ],
            "name": "letter--Oo",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterOo20",
          "filepath": "letter--Oo/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V15a2 2 0 012-2h4a2 2 0 012 2v6A2 2 0 0123 23zm-4-8v6h4V15zM13 23H9a2 2 0 01-2-2V11A2 2 0 019 9h4a2 2 0 012 2V21A2 2 0 0113 23zM9 11V21h4V11z"
                }
              }
            ],
            "name": "letter--Oo",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterOo16",
          "filepath": "letter--Oo/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V15a2 2 0 012-2h4a2 2 0 012 2v6A2 2 0 0123 23zm-4-8v6h4V15zM13 23H9a2 2 0 01-2-2V11A2 2 0 019 9h4a2 2 0 012 2V21A2 2 0 0113 23zM9 11V21h4V11z"
                }
              }
            ],
            "name": "letter--Oo",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterOo",
        "global": "LetterOo",
        "filepath": "LetterOo.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 23H19a2 2 0 01-2-2V15a2 2 0 012-2h4a2 2 0 012 2v6A2 2 0 0123 23zm-4-8v6h4V15zM13 23H9a2 2 0 01-2-2V11A2 2 0 019 9h4a2 2 0 012 2V21A2 2 0 0113 23zM9 11V21h4V11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Pp",
      "friendlyName": "Letter Pp",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Pp.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Pp</title><path d=\"M23,13H17V27h2V23h4a2,2,0,0,0,2-2V15A2,2,0,0,0,23,13Zm-4,8V15h4v6Z\"/><path d=\"M9,23H7V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H9Zm0-7h4V11H9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 13H17V27h2V23h4a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM9 23H7V9h6a2 2 0 012 2v5a2 2 0 01-2 2H9zm0-7h4V11H9z\"/></svg>",
            "info": {},
            "path": "32/letter--Pp.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterPp32",
          "filepath": "letter--Pp/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H17V27h2V23h4a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM9 23H7V9h6a2 2 0 012 2v5a2 2 0 01-2 2H9zm0-7h4V11H9z"
                }
              }
            ],
            "name": "letter--Pp",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterPp24",
          "filepath": "letter--Pp/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H17V27h2V23h4a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM9 23H7V9h6a2 2 0 012 2v5a2 2 0 01-2 2H9zm0-7h4V11H9z"
                }
              }
            ],
            "name": "letter--Pp",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterPp20",
          "filepath": "letter--Pp/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H17V27h2V23h4a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM9 23H7V9h6a2 2 0 012 2v5a2 2 0 01-2 2H9zm0-7h4V11H9z"
                }
              }
            ],
            "name": "letter--Pp",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterPp16",
          "filepath": "letter--Pp/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 13H17V27h2V23h4a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM9 23H7V9h6a2 2 0 012 2v5a2 2 0 01-2 2H9zm0-7h4V11H9z"
                }
              }
            ],
            "name": "letter--Pp",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterPp",
        "global": "LetterPp",
        "filepath": "LetterPp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 13H17V27h2V23h4a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM9 23H7V9h6a2 2 0 012 2v5a2 2 0 01-2 2H9zm0-7h4V11H9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Qq",
      "friendlyName": "Letter Qq",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Qq.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Qq</title><path d=\"M19,13a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h4v4h2V13Zm4,8H19V15h4Z\"/><path d=\"M13,9H9a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h1v2a2,2,0,0,0,2,2h2V25H12V23h1a2,2,0,0,0,2-2V11A2,2,0,0,0,13,9ZM9,21V11h4V21Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v4h2V13zm4 8H19V15h4zM13 9H9a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H12V23h1a2 2 0 002-2V11A2 2 0 0013 9zM9 21V11h4V21z\"/></svg>",
            "info": {},
            "path": "32/letter--Qq.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterQq32",
          "filepath": "letter--Qq/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v4h2V13zm4 8H19V15h4zM13 9H9a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H12V23h1a2 2 0 002-2V11A2 2 0 0013 9zM9 21V11h4V21z"
                }
              }
            ],
            "name": "letter--Qq",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterQq24",
          "filepath": "letter--Qq/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v4h2V13zm4 8H19V15h4zM13 9H9a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H12V23h1a2 2 0 002-2V11A2 2 0 0013 9zM9 21V11h4V21z"
                }
              }
            ],
            "name": "letter--Qq",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterQq20",
          "filepath": "letter--Qq/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v4h2V13zm4 8H19V15h4zM13 9H9a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H12V23h1a2 2 0 002-2V11A2 2 0 0013 9zM9 21V11h4V21z"
                }
              }
            ],
            "name": "letter--Qq",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterQq16",
          "filepath": "letter--Qq/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v4h2V13zm4 8H19V15h4zM13 9H9a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H12V23h1a2 2 0 002-2V11A2 2 0 0013 9zM9 21V11h4V21z"
                }
              }
            ],
            "name": "letter--Qq",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterQq",
        "global": "LetterQq",
        "filepath": "LetterQq.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v4h2V13zm4 8H19V15h4zM13 9H9a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H12V23h1a2 2 0 002-2V11A2 2 0 0013 9zM9 21V11h4V21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Rr",
      "friendlyName": "Letter Rr",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Rr.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Rr</title><path d=\"M16,15V11a2,2,0,0,0-2-2H8V23h2V17h1.48l2.34,6H16l-2.33-6H14A2,2,0,0,0,16,15Zm-6-4h4v4H10Z\"/><polygon points=\"24 13 18 13 18 23 20 23 20 15 24 15 24 13\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 15V11a2 2 0 00-2-2H8V23h2V17h1.48l2.34 6H16l-2.33-6H14A2 2 0 0016 15zm-6-4h4v4H10zM24 13L18 13 18 23 20 23 20 15 24 15 24 13z\"/></svg>",
            "info": {},
            "path": "32/letter--Rr.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterRr32",
          "filepath": "letter--Rr/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 15V11a2 2 0 00-2-2H8V23h2V17h1.48l2.34 6H16l-2.33-6H14A2 2 0 0016 15zm-6-4h4v4H10zM24 13L18 13 18 23 20 23 20 15 24 15 24 13z"
                }
              }
            ],
            "name": "letter--Rr",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterRr24",
          "filepath": "letter--Rr/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 15V11a2 2 0 00-2-2H8V23h2V17h1.48l2.34 6H16l-2.33-6H14A2 2 0 0016 15zm-6-4h4v4H10zM24 13L18 13 18 23 20 23 20 15 24 15 24 13z"
                }
              }
            ],
            "name": "letter--Rr",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterRr20",
          "filepath": "letter--Rr/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 15V11a2 2 0 00-2-2H8V23h2V17h1.48l2.34 6H16l-2.33-6H14A2 2 0 0016 15zm-6-4h4v4H10zM24 13L18 13 18 23 20 23 20 15 24 15 24 13z"
                }
              }
            ],
            "name": "letter--Rr",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterRr16",
          "filepath": "letter--Rr/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 15V11a2 2 0 00-2-2H8V23h2V17h1.48l2.34 6H16l-2.33-6H14A2 2 0 0016 15zm-6-4h4v4H10zM24 13L18 13 18 23 20 23 20 15 24 15 24 13z"
                }
              }
            ],
            "name": "letter--Rr",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterRr",
        "global": "LetterRr",
        "filepath": "LetterRr.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 15V11a2 2 0 00-2-2H8V23h2V17h1.48l2.34 6H16l-2.33-6H14A2 2 0 0016 15zm-6-4h4v4H10zM24 13L18 13 18 23 20 23 20 15 24 15 24 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Ss",
      "friendlyName": "Letter Ss",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Ss.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Ss</title><path d=\"M22,23H17V21h5V19H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H19v2h3a2,2,0,0,1,2,2v2A2,2,0,0,1,22,23Z\"/><path d=\"M13,23H7V21h6V17H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,13,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 23H17V21h5V19H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v2h3a2 2 0 012 2v2A2 2 0 0122 23zM13 23H7V21h6V17H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9v4h4a2 2 0 012 2v4A2 2 0 0113 23z\"/></svg>",
            "info": {},
            "path": "32/letter--Ss.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterSs32",
          "filepath": "letter--Ss/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23H17V21h5V19H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v2h3a2 2 0 012 2v2A2 2 0 0122 23zM13 23H7V21h6V17H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9v4h4a2 2 0 012 2v4A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Ss",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterSs24",
          "filepath": "letter--Ss/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23H17V21h5V19H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v2h3a2 2 0 012 2v2A2 2 0 0122 23zM13 23H7V21h6V17H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9v4h4a2 2 0 012 2v4A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Ss",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterSs20",
          "filepath": "letter--Ss/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23H17V21h5V19H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v2h3a2 2 0 012 2v2A2 2 0 0122 23zM13 23H7V21h6V17H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9v4h4a2 2 0 012 2v4A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Ss",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterSs16",
          "filepath": "letter--Ss/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23H17V21h5V19H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v2h3a2 2 0 012 2v2A2 2 0 0122 23zM13 23H7V21h6V17H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9v4h4a2 2 0 012 2v4A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Ss",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterSs",
        "global": "LetterSs",
        "filepath": "LetterSs.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 23H17V21h5V19H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v2h3a2 2 0 012 2v2A2 2 0 0122 23zM13 23H7V21h6V17H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9v4h4a2 2 0 012 2v4A2 2 0 0113 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Tt",
      "friendlyName": "Letter Tt",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Tt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Tt</title><polygon points=\"8 11 11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11\"/><path d=\"M23,15V13H20V11H18v2H16v2h2v6a2,2,0,0,0,2,2h3V21H20V15Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM23 15V13H20V11H18v2H16v2h2v6a2 2 0 002 2h3V21H20V15z\"/></svg>",
            "info": {},
            "path": "32/letter--Tt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterTt32",
          "filepath": "letter--Tt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM23 15V13H20V11H18v2H16v2h2v6a2 2 0 002 2h3V21H20V15z"
                }
              }
            ],
            "name": "letter--Tt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterTt24",
          "filepath": "letter--Tt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM23 15V13H20V11H18v2H16v2h2v6a2 2 0 002 2h3V21H20V15z"
                }
              }
            ],
            "name": "letter--Tt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterTt20",
          "filepath": "letter--Tt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM23 15V13H20V11H18v2H16v2h2v6a2 2 0 002 2h3V21H20V15z"
                }
              }
            ],
            "name": "letter--Tt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterTt16",
          "filepath": "letter--Tt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM23 15V13H20V11H18v2H16v2h2v6a2 2 0 002 2h3V21H20V15z"
                }
              }
            ],
            "name": "letter--Tt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterTt",
        "global": "LetterTt",
        "filepath": "LetterTt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM23 15V13H20V11H18v2H16v2h2v6a2 2 0 002 2h3V21H20V15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Uu",
      "friendlyName": "Letter Uu",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Uu.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Uu</title><path d=\"M23,23H19a2,2,0,0,1-2-2V13h2v8h4V13h2v8A2,2,0,0,1,23,23Z\"/><path d=\"M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 23H19a2 2 0 01-2-2V13h2v8h4V13h2v8A2 2 0 0123 23zM13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23z\"/></svg>",
            "info": {},
            "path": "32/letter--Uu.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterUu32",
          "filepath": "letter--Uu/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V13h2v8h4V13h2v8A2 2 0 0123 23zM13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Uu",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterUu24",
          "filepath": "letter--Uu/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V13h2v8h4V13h2v8A2 2 0 0123 23zM13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Uu",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterUu20",
          "filepath": "letter--Uu/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V13h2v8h4V13h2v8A2 2 0 0123 23zM13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Uu",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterUu16",
          "filepath": "letter--Uu/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 23H19a2 2 0 01-2-2V13h2v8h4V13h2v8A2 2 0 0123 23zM13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23z"
                }
              }
            ],
            "name": "letter--Uu",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterUu",
        "global": "LetterUu",
        "filepath": "LetterUu.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 23H19a2 2 0 01-2-2V13h2v8h4V13h2v8A2 2 0 0123 23zM13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Vv",
      "friendlyName": "Letter Vv",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Vv.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Vv</title><polygon points=\"25 13 23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13\"/><polygon points=\"13 9 11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13zM13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z\"/></svg>",
            "info": {},
            "path": "32/letter--Vv.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterVv32",
          "filepath": "letter--Vv/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13zM13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
                }
              }
            ],
            "name": "letter--Vv",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterVv24",
          "filepath": "letter--Vv/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13zM13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
                }
              }
            ],
            "name": "letter--Vv",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterVv20",
          "filepath": "letter--Vv/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13zM13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
                }
              }
            ],
            "name": "letter--Vv",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterVv16",
          "filepath": "letter--Vv/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13zM13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
                }
              }
            ],
            "name": "letter--Vv",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterVv",
        "global": "LetterVv",
        "filepath": "LetterVv.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13zM13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Ww",
      "friendlyName": "Letter Ww",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Ww.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Ww</title><polygon points=\"24.3 13 23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13\"/><polygon points=\"12.21 9 11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13zM12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z\"/></svg>",
            "info": {},
            "path": "32/letter--Ww.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterWw32",
          "filepath": "letter--Ww/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13zM12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
                }
              }
            ],
            "name": "letter--Ww",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterWw24",
          "filepath": "letter--Ww/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13zM12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
                }
              }
            ],
            "name": "letter--Ww",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterWw20",
          "filepath": "letter--Ww/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13zM12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
                }
              }
            ],
            "name": "letter--Ww",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterWw16",
          "filepath": "letter--Ww/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13zM12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
                }
              }
            ],
            "name": "letter--Ww",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterWw",
        "global": "LetterWw",
        "filepath": "LetterWw.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13zM12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Xx",
      "friendlyName": "Letter Xx",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Xx.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Xx</title><polygon points=\"15 9 13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9\"/><polygon points=\"25 13 23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9zM25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z\"/></svg>",
            "info": {},
            "path": "32/letter--Xx.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterXx32",
          "filepath": "letter--Xx/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9zM25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
                }
              }
            ],
            "name": "letter--Xx",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterXx24",
          "filepath": "letter--Xx/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9zM25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
                }
              }
            ],
            "name": "letter--Xx",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterXx20",
          "filepath": "letter--Xx/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9zM25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
                }
              }
            ],
            "name": "letter--Xx",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterXx16",
          "filepath": "letter--Xx/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9zM25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
                }
              }
            ],
            "name": "letter--Xx",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterXx",
        "global": "LetterXx",
        "filepath": "LetterXx.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9zM25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Yy",
      "friendlyName": "Letter Yy",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Yy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Yy</title><polygon points=\"15 9 13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9\"/><path d=\"M23,13l-2,7.52L19.08,13H17l3.15,9.87L19.53,25H17v2h2.26a2,2,0,0,0,1.91-1.42L25,13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9zM23 13l-2 7.52L19.08 13H17l3.15 9.87L19.53 25H17v2h2.26a2 2 0 001.91-1.42L25 13z\"/></svg>",
            "info": {},
            "path": "32/letter--Yy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterYy32",
          "filepath": "letter--Yy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9zM23 13l-2 7.52L19.08 13H17l3.15 9.87L19.53 25H17v2h2.26a2 2 0 001.91-1.42L25 13z"
                }
              }
            ],
            "name": "letter--Yy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterYy24",
          "filepath": "letter--Yy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9zM23 13l-2 7.52L19.08 13H17l3.15 9.87L19.53 25H17v2h2.26a2 2 0 001.91-1.42L25 13z"
                }
              }
            ],
            "name": "letter--Yy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterYy20",
          "filepath": "letter--Yy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9zM23 13l-2 7.52L19.08 13H17l3.15 9.87L19.53 25H17v2h2.26a2 2 0 001.91-1.42L25 13z"
                }
              }
            ],
            "name": "letter--Yy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterYy16",
          "filepath": "letter--Yy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9zM23 13l-2 7.52L19.08 13H17l3.15 9.87L19.53 25H17v2h2.26a2 2 0 001.91-1.42L25 13z"
                }
              }
            ],
            "name": "letter--Yy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterYy",
        "global": "LetterYy",
        "filepath": "LetterYy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9zM23 13l-2 7.52L19.08 13H17l3.15 9.87L19.53 25H17v2h2.26a2 2 0 001.91-1.42L25 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "letter--Zz",
      "friendlyName": "Letter Zz",
      "aliases": [
        "alphabet",
        "language",
        "english"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/letter--Zz.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>letter--Zz</title><polygon points=\"25 15 25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15\"/><polygon points=\"15 9 7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15zM15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z\"/></svg>",
            "info": {},
            "path": "32/letter--Zz.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LetterZz32",
          "filepath": "letter--Zz/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15zM15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
                }
              }
            ],
            "name": "letter--Zz",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LetterZz24",
          "filepath": "letter--Zz/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15zM15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
                }
              }
            ],
            "name": "letter--Zz",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LetterZz20",
          "filepath": "letter--Zz/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15zM15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
                }
              }
            ],
            "name": "letter--Zz",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LetterZz16",
          "filepath": "letter--Zz/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15zM15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
                }
              }
            ],
            "name": "letter--Zz",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "LetterZz",
        "global": "LetterZz",
        "filepath": "LetterZz.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15zM15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "license",
      "friendlyName": "License",
      "aliases": [
        "license",
        "document",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/license.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"10\" y=\"6\" width=\"12\" height=\"2\"/>\n  <rect x=\"10\" y=\"10\" width=\"12\" height=\"2\"/>\n  <rect x=\"10\" y=\"24\" width=\"6\" height=\"2\"/>\n  <rect x=\"10\" y=\"14\" width=\"6\" height=\"2\"/>\n  <path d=\"M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 6H22V8H10zM10 10H22V12H10zM10 24H16V26H10zM10 14H16V16H10z\"/><path d=\"M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z\"/></svg>",
            "info": {},
            "path": "32/license.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "License32",
          "filepath": "license/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H22V8H10zM10 10H22V12H10zM10 24H16V26H10zM10 14H16V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
                }
              }
            ],
            "name": "license",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "License24",
          "filepath": "license/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H22V8H10zM10 10H22V12H10zM10 24H16V26H10zM10 14H16V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
                }
              }
            ],
            "name": "license",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "License20",
          "filepath": "license/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H22V8H10zM10 10H22V12H10zM10 24H16V26H10zM10 14H16V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
                }
              }
            ],
            "name": "license",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "License16",
          "filepath": "license/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H22V8H10zM10 10H22V12H10zM10 24H16V26H10zM10 14H16V16H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
                }
              }
            ],
            "name": "license",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "License",
        "global": "License",
        "filepath": "License.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 6H22V8H10zM10 10H22V12H10zM10 24H16V26H10zM10 14H16V16H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "license--draft",
      "friendlyName": "License draft",
      "aliases": [
        "license",
        "draft",
        "file",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/license--draft.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"6\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"14\" width=\"6\" height=\"2\"/>\n  <rect x=\"8\" y=\"24\" width=\"4\" height=\"2\"/>\n  <path d=\"M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z\"/>\n  <path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z\"/><path d=\"M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM12 30H6a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 016 2H22a2.0021 2.0021 0 012 2V14H22V4H6V28h6z\"/></svg>",
            "info": {},
            "path": "32/license--draft.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LicenseDraft32",
          "filepath": "license--draft/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM12 30H6a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 016 2H22a2.0021 2.0021 0 012 2V14H22V4H6V28h6z"
                }
              }
            ],
            "name": "license--draft",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LicenseDraft24",
          "filepath": "license--draft/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM12 30H6a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 016 2H22a2.0021 2.0021 0 012 2V14H22V4H6V28h6z"
                }
              }
            ],
            "name": "license--draft",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LicenseDraft20",
          "filepath": "license--draft/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM12 30H6a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 016 2H22a2.0021 2.0021 0 012 2V14H22V4H6V28h6z"
                }
              }
            ],
            "name": "license--draft",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LicenseDraft16",
          "filepath": "license--draft/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM12 30H6a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 016 2H22a2.0021 2.0021 0 012 2V14H22V4H6V28h6z"
                }
              }
            ],
            "name": "license--draft",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "LicenseDraft",
        "global": "LicenseDraft",
        "filepath": "LicenseDraft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM12 30H6a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 016 2H22a2.0021 2.0021 0 012 2V14H22V4H6V28h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "license--global",
      "friendlyName": "License global",
      "aliases": [
        "license",
        "global",
        "file",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/license--global.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,14a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,22,14Zm5.91,7H25.9563a12.03,12.03,0,0,0-1.2183-4.3325A6.01,6.01,0,0,1,27.91,21Zm-7.8545,0A10.0135,10.0135,0,0,1,22,16.0146,10.0121,10.0121,0,0,1,23.9448,21Zm3.89,2A10.01,10.01,0,0,1,22,27.9854,10.0121,10.0121,0,0,1,20.0552,23Zm-4.6831-6.332A12.0265,12.0265,0,0,0,18.0435,21H16.09A6.01,6.01,0,0,1,19.2617,16.668ZM16.09,23h1.9532a12.0265,12.0265,0,0,0,1.2182,4.332A6.01,6.01,0,0,1,16.09,23Zm8.6482,4.332A12.0242,12.0242,0,0,0,25.9565,23H27.91A6.0088,6.0088,0,0,1,24.7385,27.332Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"6\" y=\"14\" width=\"6\" height=\"2\"/>\n  <rect x=\"6\" y=\"6\" width=\"12\" height=\"2\"/>\n  <rect x=\"6\" y=\"10\" width=\"12\" height=\"2\"/>\n  <rect x=\"6\" y=\"24\" width=\"6\" height=\"2\"/>\n  <path d=\"M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 14a8 8 0 108 8A8.0092 8.0092 0 0022 14zm5.91 7H25.9563a12.03 12.03 0 00-1.2183-4.3325A6.01 6.01 0 0127.91 21zm-7.8545 0A10.0135 10.0135 0 0122 16.0146 10.0121 10.0121 0 0123.9448 21zm3.89 2A10.01 10.01 0 0122 27.9854 10.0121 10.0121 0 0120.0552 23zm-4.6831-6.332A12.0265 12.0265 0 0018.0435 21H16.09A6.01 6.01 0 0119.2617 16.668zM16.09 23h1.9532a12.0265 12.0265 0 001.2182 4.332A6.01 6.01 0 0116.09 23zm8.6482 4.332A12.0242 12.0242 0 0025.9565 23H27.91A6.0088 6.0088 0 0124.7385 27.332zM6 14H12V16H6zM6 6H18V8H6zM6 10H18V12H6zM6 24H12V26H6z\"/><path d=\"M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z\"/></svg>",
            "info": {},
            "path": "32/license--global.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LicenseGlobal32",
          "filepath": "license--global/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 14a8 8 0 108 8A8.0092 8.0092 0 0022 14zm5.91 7H25.9563a12.03 12.03 0 00-1.2183-4.3325A6.01 6.01 0 0127.91 21zm-7.8545 0A10.0135 10.0135 0 0122 16.0146 10.0121 10.0121 0 0123.9448 21zm3.89 2A10.01 10.01 0 0122 27.9854 10.0121 10.0121 0 0120.0552 23zm-4.6831-6.332A12.0265 12.0265 0 0018.0435 21H16.09A6.01 6.01 0 0119.2617 16.668zM16.09 23h1.9532a12.0265 12.0265 0 001.2182 4.332A6.01 6.01 0 0116.09 23zm8.6482 4.332A12.0242 12.0242 0 0025.9565 23H27.91A6.0088 6.0088 0 0124.7385 27.332zM6 14H12V16H6zM6 6H18V8H6zM6 10H18V12H6zM6 24H12V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
                }
              }
            ],
            "name": "license--global",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LicenseGlobal24",
          "filepath": "license--global/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 14a8 8 0 108 8A8.0092 8.0092 0 0022 14zm5.91 7H25.9563a12.03 12.03 0 00-1.2183-4.3325A6.01 6.01 0 0127.91 21zm-7.8545 0A10.0135 10.0135 0 0122 16.0146 10.0121 10.0121 0 0123.9448 21zm3.89 2A10.01 10.01 0 0122 27.9854 10.0121 10.0121 0 0120.0552 23zm-4.6831-6.332A12.0265 12.0265 0 0018.0435 21H16.09A6.01 6.01 0 0119.2617 16.668zM16.09 23h1.9532a12.0265 12.0265 0 001.2182 4.332A6.01 6.01 0 0116.09 23zm8.6482 4.332A12.0242 12.0242 0 0025.9565 23H27.91A6.0088 6.0088 0 0124.7385 27.332zM6 14H12V16H6zM6 6H18V8H6zM6 10H18V12H6zM6 24H12V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
                }
              }
            ],
            "name": "license--global",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LicenseGlobal20",
          "filepath": "license--global/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 14a8 8 0 108 8A8.0092 8.0092 0 0022 14zm5.91 7H25.9563a12.03 12.03 0 00-1.2183-4.3325A6.01 6.01 0 0127.91 21zm-7.8545 0A10.0135 10.0135 0 0122 16.0146 10.0121 10.0121 0 0123.9448 21zm3.89 2A10.01 10.01 0 0122 27.9854 10.0121 10.0121 0 0120.0552 23zm-4.6831-6.332A12.0265 12.0265 0 0018.0435 21H16.09A6.01 6.01 0 0119.2617 16.668zM16.09 23h1.9532a12.0265 12.0265 0 001.2182 4.332A6.01 6.01 0 0116.09 23zm8.6482 4.332A12.0242 12.0242 0 0025.9565 23H27.91A6.0088 6.0088 0 0124.7385 27.332zM6 14H12V16H6zM6 6H18V8H6zM6 10H18V12H6zM6 24H12V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
                }
              }
            ],
            "name": "license--global",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LicenseGlobal16",
          "filepath": "license--global/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 14a8 8 0 108 8A8.0092 8.0092 0 0022 14zm5.91 7H25.9563a12.03 12.03 0 00-1.2183-4.3325A6.01 6.01 0 0127.91 21zm-7.8545 0A10.0135 10.0135 0 0122 16.0146 10.0121 10.0121 0 0123.9448 21zm3.89 2A10.01 10.01 0 0122 27.9854 10.0121 10.0121 0 0120.0552 23zm-4.6831-6.332A12.0265 12.0265 0 0018.0435 21H16.09A6.01 6.01 0 0119.2617 16.668zM16.09 23h1.9532a12.0265 12.0265 0 001.2182 4.332A6.01 6.01 0 0116.09 23zm8.6482 4.332A12.0242 12.0242 0 0025.9565 23H27.91A6.0088 6.0088 0 0124.7385 27.332zM6 14H12V16H6zM6 6H18V8H6zM6 10H18V12H6zM6 24H12V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
                }
              }
            ],
            "name": "license--global",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "LicenseGlobal",
        "global": "LicenseGlobal",
        "filepath": "LicenseGlobal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 14a8 8 0 108 8A8.0092 8.0092 0 0022 14zm5.91 7H25.9563a12.03 12.03 0 00-1.2183-4.3325A6.01 6.01 0 0127.91 21zm-7.8545 0A10.0135 10.0135 0 0122 16.0146 10.0121 10.0121 0 0123.9448 21zm3.89 2A10.01 10.01 0 0122 27.9854 10.0121 10.0121 0 0120.0552 23zm-4.6831-6.332A12.0265 12.0265 0 0018.0435 21H16.09A6.01 6.01 0 0119.2617 16.668zM16.09 23h1.9532a12.0265 12.0265 0 001.2182 4.332A6.01 6.01 0 0116.09 23zm8.6482 4.332A12.0242 12.0242 0 0025.9565 23H27.91A6.0088 6.0088 0 0124.7385 27.332zM6 14H12V16H6zM6 6H18V8H6zM6 10H18V12H6zM6 24H12V26H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "license--maintenance",
      "friendlyName": "License maintenance",
      "aliases": [
        "license",
        "maintenance",
        "file",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/license--maintenance.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"14\" width=\"6\" height=\"2\"/>\n  <rect x=\"8\" y=\"6\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"24\" width=\"6\" height=\"2\"/>\n  <path d=\"M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z\"/>\n  <path d=\"M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM30 24V22H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 18.1011V16H22v2.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 22H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 27.8989V30h2V27.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 24zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 26z\"/><path d=\"M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z\"/></svg>",
            "info": {},
            "path": "32/license--maintenance.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LicenseMaintenance32",
          "filepath": "license--maintenance/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM30 24V22H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 18.1011V16H22v2.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 22H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 27.8989V30h2V27.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 24zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--maintenance",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LicenseMaintenance24",
          "filepath": "license--maintenance/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM30 24V22H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 18.1011V16H22v2.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 22H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 27.8989V30h2V27.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 24zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--maintenance",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LicenseMaintenance20",
          "filepath": "license--maintenance/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM30 24V22H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 18.1011V16H22v2.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 22H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 27.8989V30h2V27.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 24zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--maintenance",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LicenseMaintenance16",
          "filepath": "license--maintenance/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM30 24V22H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 18.1011V16H22v2.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 22H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 27.8989V30h2V27.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 24zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--maintenance",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "LicenseMaintenance",
        "global": "LicenseMaintenance",
        "filepath": "LicenseMaintenance.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM30 24V22H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 18.1011V16H22v2.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 22H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 27.8989V30h2V27.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 24zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "license--maintenance-draft",
      "friendlyName": "License maintenance draft",
      "aliases": [
        "license",
        "maintenance",
        "draft",
        "file",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/license--maintenance-draft.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z\"/>\n  <path d=\"M20,13V11H17.8579a3.94,3.94,0,0,0-.4248-1.019L18.95,8.4644,17.5356,7.05,16.019,8.5669A3.9443,3.9443,0,0,0,15,8.1421V6H13V8.1421a3.9443,3.9443,0,0,0-1.019.4248L10.4644,7.05,9.05,8.4644,10.5669,9.981A3.94,3.94,0,0,0,10.1421,11H8v2h2.1421a3.94,3.94,0,0,0,.4248,1.019L9.05,15.5356,10.4644,16.95l1.5166-1.5166A3.9443,3.9443,0,0,0,13,15.8579V18h2V15.8579a3.9443,3.9443,0,0,0,1.019-.4248L17.5356,16.95,18.95,15.5356,17.4331,14.019A3.94,3.94,0,0,0,17.8579,13Zm-6,1a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,14,14Z\"/>\n  <path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM20 13V11H17.8579a3.94 3.94 0 00-.4248-1.019L18.95 8.4644 17.5356 7.05 16.019 8.5669A3.9443 3.9443 0 0015 8.1421V6H13V8.1421a3.9443 3.9443 0 00-1.019.4248L10.4644 7.05 9.05 8.4644 10.5669 9.981A3.94 3.94 0 0010.1421 11H8v2h2.1421a3.94 3.94 0 00.4248 1.019L9.05 15.5356 10.4644 16.95l1.5166-1.5166A3.9443 3.9443 0 0013 15.8579V18h2V15.8579a3.9443 3.9443 0 001.019-.4248L17.5356 16.95 18.95 15.5356 17.4331 14.019A3.94 3.94 0 0017.8579 13zm-6 1a2 2 0 112-2A2.0025 2.0025 0 0114 14z\"/><path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z\"/></svg>",
            "info": {},
            "path": "32/license--maintenance-draft.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LicenseMaintenanceDraft32",
          "filepath": "license--maintenance-draft/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM20 13V11H17.8579a3.94 3.94 0 00-.4248-1.019L18.95 8.4644 17.5356 7.05 16.019 8.5669A3.9443 3.9443 0 0015 8.1421V6H13V8.1421a3.9443 3.9443 0 00-1.019.4248L10.4644 7.05 9.05 8.4644 10.5669 9.981A3.94 3.94 0 0010.1421 11H8v2h2.1421a3.94 3.94 0 00.4248 1.019L9.05 15.5356 10.4644 16.95l1.5166-1.5166A3.9443 3.9443 0 0013 15.8579V18h2V15.8579a3.9443 3.9443 0 001.019-.4248L17.5356 16.95 18.95 15.5356 17.4331 14.019A3.94 3.94 0 0017.8579 13zm-6 1a2 2 0 112-2A2.0025 2.0025 0 0114 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--maintenance-draft",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LicenseMaintenanceDraft24",
          "filepath": "license--maintenance-draft/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM20 13V11H17.8579a3.94 3.94 0 00-.4248-1.019L18.95 8.4644 17.5356 7.05 16.019 8.5669A3.9443 3.9443 0 0015 8.1421V6H13V8.1421a3.9443 3.9443 0 00-1.019.4248L10.4644 7.05 9.05 8.4644 10.5669 9.981A3.94 3.94 0 0010.1421 11H8v2h2.1421a3.94 3.94 0 00.4248 1.019L9.05 15.5356 10.4644 16.95l1.5166-1.5166A3.9443 3.9443 0 0013 15.8579V18h2V15.8579a3.9443 3.9443 0 001.019-.4248L17.5356 16.95 18.95 15.5356 17.4331 14.019A3.94 3.94 0 0017.8579 13zm-6 1a2 2 0 112-2A2.0025 2.0025 0 0114 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--maintenance-draft",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LicenseMaintenanceDraft20",
          "filepath": "license--maintenance-draft/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM20 13V11H17.8579a3.94 3.94 0 00-.4248-1.019L18.95 8.4644 17.5356 7.05 16.019 8.5669A3.9443 3.9443 0 0015 8.1421V6H13V8.1421a3.9443 3.9443 0 00-1.019.4248L10.4644 7.05 9.05 8.4644 10.5669 9.981A3.94 3.94 0 0010.1421 11H8v2h2.1421a3.94 3.94 0 00.4248 1.019L9.05 15.5356 10.4644 16.95l1.5166-1.5166A3.9443 3.9443 0 0013 15.8579V18h2V15.8579a3.9443 3.9443 0 001.019-.4248L17.5356 16.95 18.95 15.5356 17.4331 14.019A3.94 3.94 0 0017.8579 13zm-6 1a2 2 0 112-2A2.0025 2.0025 0 0114 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--maintenance-draft",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LicenseMaintenanceDraft16",
          "filepath": "license--maintenance-draft/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM20 13V11H17.8579a3.94 3.94 0 00-.4248-1.019L18.95 8.4644 17.5356 7.05 16.019 8.5669A3.9443 3.9443 0 0015 8.1421V6H13V8.1421a3.9443 3.9443 0 00-1.019.4248L10.4644 7.05 9.05 8.4644 10.5669 9.981A3.94 3.94 0 0010.1421 11H8v2h2.1421a3.94 3.94 0 00.4248 1.019L9.05 15.5356 10.4644 16.95l1.5166-1.5166A3.9443 3.9443 0 0013 15.8579V18h2V15.8579a3.9443 3.9443 0 001.019-.4248L17.5356 16.95 18.95 15.5356 17.4331 14.019A3.94 3.94 0 0017.8579 13zm-6 1a2 2 0 112-2A2.0025 2.0025 0 0114 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--maintenance-draft",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "LicenseMaintenanceDraft",
        "global": "LicenseMaintenanceDraft",
        "filepath": "LicenseMaintenanceDraft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM20 13V11H17.8579a3.94 3.94 0 00-.4248-1.019L18.95 8.4644 17.5356 7.05 16.019 8.5669A3.9443 3.9443 0 0015 8.1421V6H13V8.1421a3.9443 3.9443 0 00-1.019.4248L10.4644 7.05 9.05 8.4644 10.5669 9.981A3.94 3.94 0 0010.1421 11H8v2h2.1421a3.94 3.94 0 00.4248 1.019L9.05 15.5356 10.4644 16.95l1.5166-1.5166A3.9443 3.9443 0 0013 15.8579V18h2V15.8579a3.9443 3.9443 0 001.019-.4248L17.5356 16.95 18.95 15.5356 17.4331 14.019A3.94 3.94 0 0017.8579 13zm-6 1a2 2 0 112-2A2.0025 2.0025 0 0114 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "license--third-party",
      "friendlyName": "License third-party",
      "aliases": [
        "license",
        "third-party",
        "file",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/license--third-party.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"14\" width=\"6\" height=\"2\"/>\n  <rect x=\"8\" y=\"6\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n  <rect x=\"8\" y=\"24\" width=\"6\" height=\"2\"/>\n  <path d=\"M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z\"/>\n  <path d=\"M24,24a4,4,0,1,0-4-4A4,4,0,0,0,24,24Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,24,18Z\"/>\n  <path d=\"M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM24 24a4 4 0 10-4-4A4 4 0 0024 24zm0-6a2 2 0 11-2 2A2 2 0 0124 18z\"/><path d=\"M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z\"/></svg>",
            "info": {},
            "path": "32/license--third-party.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LicenseThirdParty32",
          "filepath": "license--third-party/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM24 24a4 4 0 10-4-4A4 4 0 0024 24zm0-6a2 2 0 11-2 2A2 2 0 0124 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--third-party",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LicenseThirdParty24",
          "filepath": "license--third-party/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM24 24a4 4 0 10-4-4A4 4 0 0024 24zm0-6a2 2 0 11-2 2A2 2 0 0124 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--third-party",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LicenseThirdParty20",
          "filepath": "license--third-party/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM24 24a4 4 0 10-4-4A4 4 0 0024 24zm0-6a2 2 0 11-2 2A2 2 0 0124 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--third-party",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LicenseThirdParty16",
          "filepath": "license--third-party/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM24 24a4 4 0 10-4-4A4 4 0 0024 24zm0-6a2 2 0 11-2 2A2 2 0 0124 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                }
              }
            ],
            "name": "license--third-party",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "LicenseThirdParty",
        "global": "LicenseThirdParty",
        "filepath": "LicenseThirdParty.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM24 24a4 4 0 10-4-4A4 4 0 0024 24zm0-6a2 2 0 11-2 2A2 2 0 0124 18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "license--third-party-draft",
      "friendlyName": "License third-party draft",
      "aliases": [
        "license",
        "third-party",
        "draft",
        "file",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/license--third-party-draft.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z\"/>\n  <path d=\"M17,15H11a3,3,0,0,0-3,3v1h2V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v1h2V18A3,3,0,0,0,17,15Z\"/>\n  <path d=\"M14,14a4,4,0,1,0-4-4A4,4,0,0,0,14,14Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,14,8Z\"/>\n  <path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM17 15H11a3 3 0 00-3 3v1h2V18a1 1 0 011-1h6a1 1 0 011 1v1h2V18A3 3 0 0017 15zM14 14a4 4 0 10-4-4A4 4 0 0014 14zm0-6a2 2 0 11-2 2A2 2 0 0114 8z\"/><path d=\"M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z\"/></svg>",
            "info": {},
            "path": "32/license--third-party-draft.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LicenseThirdPartyDraft32",
          "filepath": "license--third-party-draft/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM17 15H11a3 3 0 00-3 3v1h2V18a1 1 0 011-1h6a1 1 0 011 1v1h2V18A3 3 0 0017 15zM14 14a4 4 0 10-4-4A4 4 0 0014 14zm0-6a2 2 0 11-2 2A2 2 0 0114 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--third-party-draft",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LicenseThirdPartyDraft24",
          "filepath": "license--third-party-draft/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM17 15H11a3 3 0 00-3 3v1h2V18a1 1 0 011-1h6a1 1 0 011 1v1h2V18A3 3 0 0017 15zM14 14a4 4 0 10-4-4A4 4 0 0014 14zm0-6a2 2 0 11-2 2A2 2 0 0114 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--third-party-draft",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LicenseThirdPartyDraft20",
          "filepath": "license--third-party-draft/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM17 15H11a3 3 0 00-3 3v1h2V18a1 1 0 011-1h6a1 1 0 011 1v1h2V18A3 3 0 0017 15zM14 14a4 4 0 10-4-4A4 4 0 0014 14zm0-6a2 2 0 11-2 2A2 2 0 0114 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--third-party-draft",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LicenseThirdPartyDraft16",
          "filepath": "license--third-party-draft/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM17 15H11a3 3 0 00-3 3v1h2V18a1 1 0 011-1h6a1 1 0 011 1v1h2V18A3 3 0 0017 15zM14 14a4 4 0 10-4-4A4 4 0 0014 14zm0-6a2 2 0 11-2 2A2 2 0 0114 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                }
              }
            ],
            "name": "license--third-party-draft",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "LicenseThirdPartyDraft",
        "global": "LicenseThirdPartyDraft",
        "filepath": "LicenseThirdPartyDraft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM17 15H11a3 3 0 00-3 3v1h2V18a1 1 0 011-1h6a1 1 0 011 1v1h2V18A3 3 0 0017 15zM14 14a4 4 0 10-4-4A4 4 0 0014 14zm0-6a2 2 0 11-2 2A2 2 0 0114 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "lifesaver",
      "friendlyName": "lifesaver",
      "aliases": [
        "life preserver",
        "help",
        "boating",
        "travel",
        "recreation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/lifesaver.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z\"/></svg>",
            "info": {},
            "path": "32/lifesaver.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Lifesaver32",
          "filepath": "lifesaver/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
                }
              }
            ],
            "name": "lifesaver",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Lifesaver24",
          "filepath": "lifesaver/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
                }
              }
            ],
            "name": "lifesaver",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Lifesaver20",
          "filepath": "lifesaver/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
                }
              }
            ],
            "name": "lifesaver",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Lifesaver16",
          "filepath": "lifesaver/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
                }
              }
            ],
            "name": "lifesaver",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Lifesaver",
        "global": "Lifesaver",
        "filepath": "Lifesaver.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "light",
      "friendlyName": "Light",
      "aliases": [
        "bright",
        "sun",
        "sunny",
        "lightbulb",
        "glow",
        "luminous",
        "lamp"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/light.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>light</title>\n<rect x=\"7.5\" y=\"1\" width=\"1\" height=\"2.5\"/>\n<rect x=\"10.8\" y=\"3.4\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 0.7526 9.6636)\" width=\"2.5\" height=\"1\"/>\n<rect x=\"12.5\" y=\"7.5\" width=\"2.5\" height=\"1\"/>\n<rect x=\"11.6\" y=\"10.8\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -4.9774 12.0652)\" width=\"1\" height=\"2.5\"/>\n<rect x=\"7.5\" y=\"12.5\" width=\"1\" height=\"2.5\"/>\n<rect x=\"2.7\" y=\"11.6\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -7.3811 6.3373)\" width=\"2.5\" height=\"1\"/>\n<rect x=\"1\" y=\"7.5\" width=\"2.5\" height=\"1\"/>\n<rect x=\"3.4\" y=\"2.7\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -1.6512 3.9356)\" width=\"1\" height=\"2.5\"/>\n<path d=\"M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M7.5 1H8.5V3.5H7.5z\"/><path d=\"M10.8 3.4H13.3V4.4H10.8z\" transform=\"rotate(-45.001 12.041 3.923)\"/><path d=\"M12.5 7.5H15V8.5H12.5z\"/><path d=\"M11.6 10.8H12.6V13.3H11.6z\" transform=\"rotate(-45.001 12.075 12.041)\"/><path d=\"M7.5 12.5H8.5V15H7.5z\"/><path d=\"M2.7 11.6H5.2V12.6H2.7z\" transform=\"rotate(-45.001 3.96 12.079)\"/><path d=\"M1 7.5H3.5V8.5H1z\"/><path d=\"M3.4 2.7H4.4V5.2H3.4z\" transform=\"rotate(-45.001 3.925 3.961)\"/><path d=\"M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z\"/></svg>",
            "info": {},
            "path": "16/light.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/light.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15\" y=\"2\" width=\"2\" height=\"5\"/>\n  <rect x=\"21.6675\" y=\"6.8536\" width=\"4.958\" height=\"1.9998\" transform=\"translate(1.5191 19.3744) rotate(-45)\"/>\n  <rect x=\"25\" y=\"15\" width=\"5\" height=\"2\"/>\n  <rect x=\"23.1466\" y=\"21.6675\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-10.0018 24.1465) rotate(-45)\"/>\n  <rect x=\"15\" y=\"25\" width=\"2\" height=\"5\"/>\n  <rect x=\"5.3745\" y=\"23.1466\" width=\"4.958\" height=\"1.9998\" transform=\"translate(-14.7739 12.6256) rotate(-45)\"/>\n  <rect x=\"2\" y=\"15\" width=\"5\" height=\"2\"/>\n  <rect x=\"6.8536\" y=\"5.3745\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-3.253 7.8535) rotate(-45)\"/>\n  <path d=\"M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 2H17V7H15z\"/><path d=\"M21.668 6.854H26.625999999999998V8.854H21.668z\" transform=\"rotate(-45 24.147 7.853)\"/><path d=\"M25 15H30V17H25z\"/><path d=\"M23.147 21.668H25.147V26.625999999999998H23.147z\" transform=\"rotate(-45 24.147 24.146)\"/><path d=\"M15 25H17V30H15z\"/><path d=\"M5.375 23.147H10.333V25.147H5.375z\" transform=\"rotate(-45 7.853 24.146)\"/><path d=\"M2 15H7V17H2z\"/><path d=\"M6.854 5.375H8.854V10.333H6.854z\" transform=\"rotate(-45 7.854 7.853)\"/><path d=\"M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/></svg>",
            "info": {},
            "path": "32/light.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Light32",
          "filepath": "light/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.147 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.853 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "light",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Light24",
          "filepath": "light/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.147 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.853 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "light",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Light20",
          "filepath": "light/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.147 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.853 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "light",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Light16",
          "filepath": "light/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 1H8.5V3.5H7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8 3.4H13.3V4.4H10.8z",
                  "transform": "rotate(-45.001 12.041 3.923)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.5 7.5H15V8.5H12.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.6 10.8H12.6V13.3H11.6z",
                  "transform": "rotate(-45.001 12.075 12.041)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 12.5H8.5V15H7.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.7 11.6H5.2V12.6H2.7z",
                  "transform": "rotate(-45.001 3.96 12.079)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 7.5H3.5V8.5H1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.4 2.7H4.4V5.2H3.4z",
                  "transform": "rotate(-45.001 3.925 3.961)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
                }
              }
            ],
            "name": "light",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Light",
        "global": "Light",
        "filepath": "Light.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 1H8.5V3.5H7.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.8 3.4H13.3V4.4H10.8z",
                    "transform": "rotate(-45.001 12.041 3.923)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.5 7.5H15V8.5H12.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.6 10.8H12.6V13.3H11.6z",
                    "transform": "rotate(-45.001 12.075 12.041)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 12.5H8.5V15H7.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.7 11.6H5.2V12.6H2.7z",
                    "transform": "rotate(-45.001 3.96 12.079)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M1 7.5H3.5V8.5H1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.4 2.7H4.4V5.2H3.4z",
                    "transform": "rotate(-45.001 3.925 3.961)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V7H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                    "transform": "rotate(-45 24.147 7.853)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 15H30V17H25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                    "transform": "rotate(-45 24.147 24.146)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 25H17V30H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.375 23.147H10.333V25.147H5.375z",
                    "transform": "rotate(-45 7.853 24.146)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 15H7V17H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.854 5.375H8.854V10.333H6.854z",
                    "transform": "rotate(-45 7.854 7.853)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "light--filled",
      "friendlyName": "Light filled",
      "aliases": [
        "bright",
        "sun",
        "sunny",
        "lightbulb",
        "glow",
        "luminous",
        "lamp",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/light--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15\" y=\"2\" width=\"2\" height=\"5\"/>\n  <rect x=\"21.6675\" y=\"6.8536\" width=\"4.958\" height=\"1.9998\" transform=\"translate(1.5191 19.3744) rotate(-45)\"/>\n  <rect x=\"25\" y=\"15\" width=\"5\" height=\"2\"/>\n  <rect x=\"23.1466\" y=\"21.6675\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-10.0018 24.1465) rotate(-45)\"/>\n  <rect x=\"15\" y=\"25\" width=\"2\" height=\"5\"/>\n  <rect x=\"5.3745\" y=\"23.1466\" width=\"4.958\" height=\"1.9998\" transform=\"translate(-14.7739 12.6256) rotate(-45)\"/>\n  <rect x=\"2\" y=\"15\" width=\"5\" height=\"2\"/>\n  <rect x=\"6.8536\" y=\"5.3745\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-3.253 7.8535) rotate(-45)\"/>\n  <path d=\"M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 2H17V7H15z\"/><path d=\"M21.668 6.854H26.625999999999998V8.854H21.668z\" transform=\"rotate(-45 24.147 7.853)\"/><path d=\"M25 15H30V17H25z\"/><path d=\"M23.147 21.668H25.147V26.625999999999998H23.147z\" transform=\"rotate(-45 24.147 24.146)\"/><path d=\"M15 25H17V30H15z\"/><path d=\"M5.375 23.147H10.333V25.147H5.375z\" transform=\"rotate(-45 7.853 24.146)\"/><path d=\"M2 15H7V17H2z\"/><path d=\"M6.854 5.375H8.854V10.333H6.854z\" transform=\"rotate(-45 7.854 7.853)\"/><path d=\"M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/></svg>",
            "info": {},
            "path": "32/light--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LightFilled32",
          "filepath": "light--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.147 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.853 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "light--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LightFilled24",
          "filepath": "light--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.147 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.853 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "light--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LightFilled20",
          "filepath": "light--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.147 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.853 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "light--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LightFilled16",
          "filepath": "light--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.147 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25H17V30H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.853 24.146)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "light--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "LightFilled",
        "global": "LightFilled",
        "filepath": "LightFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V7H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                    "transform": "rotate(-45 24.147 7.853)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 15H30V17H25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                    "transform": "rotate(-45 24.147 24.146)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 25H17V30H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.375 23.147H10.333V25.147H5.375z",
                    "transform": "rotate(-45 7.853 24.146)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 15H7V17H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.854 5.375H8.854V10.333H6.854z",
                    "transform": "rotate(-45 7.854 7.853)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "lightning",
      "friendlyName": "Lightning",
      "aliases": [
        "lightning",
        "flash",
        "electricity",
        "power"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/lightning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>bolt</title><path d=\"M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z\"/></svg>",
            "info": {},
            "path": "32/lightning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Lightning32",
          "filepath": "lightning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "lightning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Lightning24",
          "filepath": "lightning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "lightning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Lightning20",
          "filepath": "lightning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "lightning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Lightning16",
          "filepath": "lightning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                }
              }
            ],
            "name": "lightning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Lightning",
        "global": "Lightning",
        "filepath": "Lightning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "link",
      "friendlyName": "Link",
      "aliases": [
        "associate",
        "association",
        "network",
        "connect",
        "join",
        "hookup"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/link.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>link</title><path d=\"M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z\"/><path d=\"M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z\"/><path d=\"M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z\"/></svg>",
            "info": {},
            "path": "32/link.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Link32",
          "filepath": "link/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
                }
              }
            ],
            "name": "link",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Link24",
          "filepath": "link/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
                }
              }
            ],
            "name": "link",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Link20",
          "filepath": "link/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
                }
              }
            ],
            "name": "link",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Link16",
          "filepath": "link/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
                }
              }
            ],
            "name": "link",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Link",
        "global": "Link",
        "filepath": "Link.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "linux",
      "friendlyName": "Linux®",
      "aliases": [
        "linux",
        "OS"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/linux.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z\"/></svg>",
            "info": {},
            "path": "32/linux.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Linux32",
          "filepath": "linux/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
                }
              }
            ],
            "name": "linux",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Linux24",
          "filepath": "linux/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
                }
              }
            ],
            "name": "linux",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Linux20",
          "filepath": "linux/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
                }
              }
            ],
            "name": "linux",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Linux16",
          "filepath": "linux/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
                }
              }
            ],
            "name": "linux",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Linux",
        "global": "Linux",
        "filepath": "Linux.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "linux--alt",
      "friendlyName": "Linux® alt",
      "aliases": [
        "linux",
        "OS"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/linux--alt.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z\"/><path d=\"M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z\"/></svg>",
            "info": {},
            "path": "32/linux--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LinuxAlt32",
          "filepath": "linux--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
                }
              }
            ],
            "name": "linux--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LinuxAlt24",
          "filepath": "linux--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
                }
              }
            ],
            "name": "linux--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LinuxAlt20",
          "filepath": "linux--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
                }
              }
            ],
            "name": "linux--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LinuxAlt16",
          "filepath": "linux--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
                }
              }
            ],
            "name": "linux--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "LinuxAlt",
        "global": "LinuxAlt",
        "filepath": "LinuxAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list",
      "friendlyName": "List",
      "aliases": [
        "bullet",
        "agenda",
        "checklist",
        "file",
        "index",
        "inventory",
        "table",
        "tally"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/list.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>list</title><rect x=\"10\" y=\"6\" width=\"18\" height=\"2\"/><rect x=\"10\" y=\"24\" width=\"18\" height=\"2\"/><rect x=\"10\" y=\"15\" width=\"18\" height=\"2\"/><rect x=\"4\" y=\"15\" width=\"2\" height=\"2\"/><rect x=\"4\" y=\"6\" width=\"2\" height=\"2\"/><rect x=\"4\" y=\"24\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 6H28V8H10zM10 24H28V26H10zM10 15H28V17H10zM4 15H6V17H4zM4 6H6V8H4zM4 24H6V26H4z\"/></svg>",
            "info": {},
            "path": "32/list.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "List32",
          "filepath": "list/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 24H28V26H10zM10 15H28V17H10zM4 15H6V17H4zM4 6H6V8H4zM4 24H6V26H4z"
                }
              }
            ],
            "name": "list",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "List24",
          "filepath": "list/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 24H28V26H10zM10 15H28V17H10zM4 15H6V17H4zM4 6H6V8H4zM4 24H6V26H4z"
                }
              }
            ],
            "name": "list",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "List20",
          "filepath": "list/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 24H28V26H10zM10 15H28V17H10zM4 15H6V17H4zM4 6H6V8H4zM4 24H6V26H4z"
                }
              }
            ],
            "name": "list",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "List16",
          "filepath": "list/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 24H28V26H10zM10 15H28V17H10zM4 15H6V17H4zM4 6H6V8H4zM4 24H6V26H4z"
                }
              }
            ],
            "name": "list",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "List",
        "global": "List",
        "filepath": "List.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 6H28V8H10zM10 24H28V26H10zM10 15H28V17H10zM4 15H6V17H4zM4 6H6V8H4zM4 24H6V26H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list--boxes",
      "friendlyName": "List boxes",
      "aliases": [
        "bullet",
        "agenda",
        "checklist",
        "file",
        "index",
        "inventory",
        "table",
        "tally"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/list--boxes.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>list--checked</title><rect x=\"16\" y=\"8\" width=\"14\" height=\"2\"/><rect x=\"16\" y=\"22\" width=\"14\" height=\"2\"/><path d=\"M10,14H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,10,14ZM4,6v6h6.0012L10,6Z\"/><path d=\"M10,28H4a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,10,28ZM4,20v6h6.0012L10,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 8H30V10H16zM16 22H30V24H16zM10 14H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 14zM4 6v6h6.0012L10 6zM10 28H4a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 28zM4 20v6h6.0012L10 20z\"/></svg>",
            "info": {},
            "path": "32/list--boxes.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ListBoxes32",
          "filepath": "list--boxes/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM16 22H30V24H16zM10 14H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 14zM4 6v6h6.0012L10 6zM10 28H4a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 28zM4 20v6h6.0012L10 20z"
                }
              }
            ],
            "name": "list--boxes",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ListBoxes24",
          "filepath": "list--boxes/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM16 22H30V24H16zM10 14H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 14zM4 6v6h6.0012L10 6zM10 28H4a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 28zM4 20v6h6.0012L10 20z"
                }
              }
            ],
            "name": "list--boxes",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ListBoxes20",
          "filepath": "list--boxes/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM16 22H30V24H16zM10 14H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 14zM4 6v6h6.0012L10 6zM10 28H4a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 28zM4 20v6h6.0012L10 20z"
                }
              }
            ],
            "name": "list--boxes",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ListBoxes16",
          "filepath": "list--boxes/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8H30V10H16zM16 22H30V24H16zM10 14H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 14zM4 6v6h6.0012L10 6zM10 28H4a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 28zM4 20v6h6.0012L10 20z"
                }
              }
            ],
            "name": "list--boxes",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ListBoxes",
        "global": "ListBoxes",
        "filepath": "ListBoxes.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 8H30V10H16zM16 22H30V24H16zM10 14H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 14zM4 6v6h6.0012L10 6zM10 28H4a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 28zM4 20v6h6.0012L10 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list--bulleted",
      "friendlyName": "List bulleted",
      "aliases": [
        "bullet",
        "agenda",
        "checklist",
        "file",
        "index",
        "inventory",
        "table",
        "tally"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/list--bulleted.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>list--bulleted</title>\n<circle cx=\"3.5\" cy=\"4.5\" r=\"1.5\"/>\n<circle cx=\"3.5\" cy=\"11.5\" r=\"1.5\"/>\n<rect x=\"8\" y=\"11\" width=\"7\" height=\"1\"/>\n<rect x=\"8\" y=\"4\" width=\"7\" height=\"1\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><circle cx=\"3.5\" cy=\"4.5\" r=\"1.5\"/><circle cx=\"3.5\" cy=\"11.5\" r=\"1.5\"/><path d=\"M8 11H15V12H8zM8 4H15V5H8z\"/></svg>",
            "info": {},
            "path": "16/list--bulleted.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/list--bulleted.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>list--bulleted</title><circle cx=\"7\" cy=\"9\" r=\"3\"/><circle cx=\"7\" cy=\"23\" r=\"3\"/><rect x=\"16\" y=\"22\" width=\"14\" height=\"2\"/><rect x=\"16\" y=\"8\" width=\"14\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"7\" cy=\"9\" r=\"3\"/><circle cx=\"7\" cy=\"23\" r=\"3\"/><path d=\"M16 22H30V24H16zM16 8H30V10H16z\"/></svg>",
            "info": {},
            "path": "32/list--bulleted.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ListBulleted32",
          "filepath": "list--bulleted/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "9",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM16 8H30V10H16z"
                }
              }
            ],
            "name": "list--bulleted",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ListBulleted24",
          "filepath": "list--bulleted/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "9",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM16 8H30V10H16z"
                }
              }
            ],
            "name": "list--bulleted",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ListBulleted20",
          "filepath": "list--bulleted/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "9",
                  "r": "3"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "23",
                  "r": "3"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM16 8H30V10H16z"
                }
              }
            ],
            "name": "list--bulleted",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ListBulleted16",
          "filepath": "list--bulleted/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3.5",
                  "cy": "4.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3.5",
                  "cy": "11.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11H15V12H8zM8 4H15V5H8z"
                }
              }
            ],
            "name": "list--bulleted",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ListBulleted",
        "global": "ListBulleted",
        "filepath": "ListBulleted.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3.5",
                    "cy": "4.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3.5",
                    "cy": "11.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 11H15V12H8zM8 4H15V5H8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "9",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "23",
                    "r": "3"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22H30V24H16zM16 8H30V10H16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list--checked",
      "friendlyName": "List checked",
      "aliases": [
        "bullet",
        "agenda",
        "checklist",
        "file",
        "index",
        "inventory",
        "table",
        "tally"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/list--checked.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"16\" y=\"22\" width=\"14\" height=\"2\"/>\n<polygon points=\"14,19.4 12.6,18 6,24.6 3.4,22 2,23.4 6,27.4 \"/>\n<rect x=\"16\" y=\"8\" width=\"14\" height=\"2\"/>\n<polygon points=\"14,5.4 12.6,4 6,10.6 3.4,8 2,9.4 6,13.4 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22H30V24H16zM14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4zM16 8H30V10H16zM14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z\"/></svg>",
            "info": {},
            "path": "32/list--checked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ListChecked32",
          "filepath": "list--checked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4zM16 8H30V10H16zM14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
                }
              }
            ],
            "name": "list--checked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ListChecked24",
          "filepath": "list--checked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4zM16 8H30V10H16zM14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
                }
              }
            ],
            "name": "list--checked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ListChecked20",
          "filepath": "list--checked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4zM16 8H30V10H16zM14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
                }
              }
            ],
            "name": "list--checked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ListChecked16",
          "filepath": "list--checked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4zM16 8H30V10H16zM14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
                }
              }
            ],
            "name": "list--checked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ListChecked",
        "global": "ListChecked",
        "filepath": "ListChecked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22H30V24H16zM14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4zM16 8H30V10H16zM14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list--checked--mirror",
      "friendlyName": "list--checked--mirror",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/list--checked--mirror.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"30,19.4 28.6,18 22,24.6 19.4,22 18,23.4 22,27.4 \"/>\n<rect x=\"2\" y=\"22\" width=\"14\" height=\"2\"/>\n<polygon points=\"30,5.4 28.6,4 22,10.6 19.4,8 18,9.4 22,13.4 \"/>\n<rect x=\"2\" y=\"8\" width=\"14\" height=\"2\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4zM2 22H16V24H2zM30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4zM2 8H16V10H2z\"/></svg>",
            "info": {},
            "path": "32/list--checked--mirror.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ListCheckedMirror32",
          "filepath": "list--checked--mirror/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4zM2 22H16V24H2zM30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--checked--mirror",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ListCheckedMirror24",
          "filepath": "list--checked--mirror/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4zM2 22H16V24H2zM30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--checked--mirror",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ListCheckedMirror20",
          "filepath": "list--checked--mirror/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4zM2 22H16V24H2zM30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--checked--mirror",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ListCheckedMirror16",
          "filepath": "list--checked--mirror/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4zM2 22H16V24H2zM30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--checked--mirror",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ListCheckedMirror",
        "global": "ListCheckedMirror",
        "filepath": "ListCheckedMirror.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4zM2 22H16V24H2zM30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4zM2 8H16V10H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list--dropdown",
      "friendlyName": "List dropdown",
      "aliases": [
        "bullet",
        "agenda",
        "checklist",
        "file",
        "index",
        "inventory",
        "table",
        "tally"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/list--dropdown.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>dropdown-list</title><path d=\"M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z\"/><rect x=\"15\" y=\"11\" width=\"2\" height=\"2\"/><rect x=\"19\" y=\"11\" width=\"7\" height=\"2\"/><rect x=\"15\" y=\"17\" width=\"2\" height=\"2\"/><rect x=\"19\" y=\"17\" width=\"7\" height=\"2\"/><rect x=\"15\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"19\" y=\"23\" width=\"7\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z\"/><path d=\"M15 11H17V13H15zM19 11H26V13H19zM15 17H17V19H15zM19 17H26V19H19zM15 23H17V25H15zM19 23H26V25H19z\"/></svg>",
            "info": {},
            "path": "32/list--dropdown.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ListDropdown32",
          "filepath": "list--dropdown/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V13H15zM19 11H26V13H19zM15 17H17V19H15zM19 17H26V19H19zM15 23H17V25H15zM19 23H26V25H19z"
                }
              }
            ],
            "name": "list--dropdown",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ListDropdown24",
          "filepath": "list--dropdown/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V13H15zM19 11H26V13H19zM15 17H17V19H15zM19 17H26V19H19zM15 23H17V25H15zM19 23H26V25H19z"
                }
              }
            ],
            "name": "list--dropdown",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ListDropdown20",
          "filepath": "list--dropdown/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V13H15zM19 11H26V13H19zM15 17H17V19H15zM19 17H26V19H19zM15 23H17V25H15zM19 23H26V25H19z"
                }
              }
            ],
            "name": "list--dropdown",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ListDropdown16",
          "filepath": "list--dropdown/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V13H15zM19 11H26V13H19zM15 17H17V19H15zM19 17H26V19H19zM15 23H17V25H15zM19 23H26V25H19z"
                }
              }
            ],
            "name": "list--dropdown",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ListDropdown",
        "global": "ListDropdown",
        "filepath": "ListDropdown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 11H17V13H15zM19 11H26V13H19zM15 17H17V19H15zM19 17H26V19H19zM15 23H17V25H15zM19 23H26V25H19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list--numbered",
      "friendlyName": "List numbered",
      "aliases": [
        "bullet",
        "agenda",
        "checklist",
        "file",
        "index",
        "inventory",
        "table",
        "tally"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/list--numbered.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>list--numbered</title><rect x=\"16\" y=\"22\" width=\"14\" height=\"2\"/><rect x=\"16\" y=\"8\" width=\"14\" height=\"2\"/><polygon points=\"8 12 8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12\"/><path d=\"M10,28H4V24a2,2,0,0,1,2-2H8V20H4V18H8a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H6v2h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22H30V24H16zM16 8H30V10H16zM8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12zM10 28H4V24a2 2 0 012-2H8V20H4V18H8a2 2 0 012 2v2a2 2 0 01-2 2H6v2h4z\"/></svg>",
            "info": {},
            "path": "32/list--numbered.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ListNumbered32",
          "filepath": "list--numbered/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM16 8H30V10H16zM8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12zM10 28H4V24a2 2 0 012-2H8V20H4V18H8a2 2 0 012 2v2a2 2 0 01-2 2H6v2h4z"
                }
              }
            ],
            "name": "list--numbered",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ListNumbered24",
          "filepath": "list--numbered/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM16 8H30V10H16zM8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12zM10 28H4V24a2 2 0 012-2H8V20H4V18H8a2 2 0 012 2v2a2 2 0 01-2 2H6v2h4z"
                }
              }
            ],
            "name": "list--numbered",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ListNumbered20",
          "filepath": "list--numbered/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM16 8H30V10H16zM8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12zM10 28H4V24a2 2 0 012-2H8V20H4V18H8a2 2 0 012 2v2a2 2 0 01-2 2H6v2h4z"
                }
              }
            ],
            "name": "list--numbered",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ListNumbered16",
          "filepath": "list--numbered/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22H30V24H16zM16 8H30V10H16zM8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12zM10 28H4V24a2 2 0 012-2H8V20H4V18H8a2 2 0 012 2v2a2 2 0 01-2 2H6v2h4z"
                }
              }
            ],
            "name": "list--numbered",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ListNumbered",
        "global": "ListNumbered",
        "filepath": "ListNumbered.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22H30V24H16zM16 8H30V10H16zM8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12zM10 28H4V24a2 2 0 012-2H8V20H4V18H8a2 2 0 012 2v2a2 2 0 01-2 2H6v2h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "list--numbered--mirror",
      "friendlyName": "list--numbered--mirror",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/list--numbered--mirror.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,28h-6v-4c0-1.1,0.9-2,2-2h2v-2h-4v-2h4c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2h-2v2h4V28z\"/>\n<rect x=\"2\" y=\"22\" width=\"14\" height=\"2\"/>\n<polygon points=\"26,12 26,4 24,4 24,5 22,5 22,7 24,7 24,12 22,12 22,14 24,14 26,14 28,14 28,12 \"/>\n<rect x=\"2\" y=\"8\" width=\"14\" height=\"2\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 28h-6v-4c0-1.1.9-2 2-2h2v-2h-4v-2h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V28zM2 22H16V24H2zM26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12zM2 8H16V10H2z\"/></svg>",
            "info": {},
            "path": "32/list--numbered--mirror.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ListNumberedMirror32",
          "filepath": "list--numbered--mirror/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28h-6v-4c0-1.1.9-2 2-2h2v-2h-4v-2h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V28zM2 22H16V24H2zM26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--numbered--mirror",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ListNumberedMirror24",
          "filepath": "list--numbered--mirror/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28h-6v-4c0-1.1.9-2 2-2h2v-2h-4v-2h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V28zM2 22H16V24H2zM26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--numbered--mirror",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ListNumberedMirror20",
          "filepath": "list--numbered--mirror/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28h-6v-4c0-1.1.9-2 2-2h2v-2h-4v-2h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V28zM2 22H16V24H2zM26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--numbered--mirror",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ListNumberedMirror16",
          "filepath": "list--numbered--mirror/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28h-6v-4c0-1.1.9-2 2-2h2v-2h-4v-2h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V28zM2 22H16V24H2zM26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12zM2 8H16V10H2z"
                }
              }
            ],
            "name": "list--numbered--mirror",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ListNumberedMirror",
        "global": "ListNumberedMirror",
        "filepath": "ListNumberedMirror.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 28h-6v-4c0-1.1.9-2 2-2h2v-2h-4v-2h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V28zM2 22H16V24H2zM26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12zM2 8H16V10H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--application",
      "friendlyName": "Load balancer application",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--application.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"4\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"14\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"24\" y=\"26\" width=\"4\" height=\"4\"/>\n  <path d=\"M25,16H17V14H15v2H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9,2V12H23V2Zm2,2h2v6H11Zm10,6H15V4h6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V14H15v2H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM9 2V12H23V2zm2 2h2v6H11zm10 6H15V4h6z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--application.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerApplication32",
          "filepath": "load-balancer--application/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V14H15v2H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM9 2V12H23V2zm2 2h2v6H11zm10 6H15V4h6z"
                }
              }
            ],
            "name": "load-balancer--application",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerApplication24",
          "filepath": "load-balancer--application/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V14H15v2H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM9 2V12H23V2zm2 2h2v6H11zm10 6H15V4h6z"
                }
              }
            ],
            "name": "load-balancer--application",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerApplication20",
          "filepath": "load-balancer--application/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V14H15v2H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM9 2V12H23V2zm2 2h2v6H11zm10 6H15V4h6z"
                }
              }
            ],
            "name": "load-balancer--application",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerApplication16",
          "filepath": "load-balancer--application/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V14H15v2H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM9 2V12H23V2zm2 2h2v6H11zm10 6H15V4h6z"
                }
              }
            ],
            "name": "load-balancer--application",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LoadBalancerApplication",
        "global": "LoadBalancerApplication",
        "filepath": "LoadBalancerApplication.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V14H15v2H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM9 2V12H23V2zm2 2h2v6H11zm10 6H15V4h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--classic",
      "friendlyName": "Load balancer classic",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--classic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"4\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"14\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"24\" y=\"26\" width=\"4\" height=\"4\"/>\n  <path d=\"M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,10V2H12v8ZM14,8V4h4V8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8zM14 8V4h4V8z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--classic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerClassic32",
          "filepath": "load-balancer--classic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8zM14 8V4h4V8z"
                }
              }
            ],
            "name": "load-balancer--classic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerClassic24",
          "filepath": "load-balancer--classic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8zM14 8V4h4V8z"
                }
              }
            ],
            "name": "load-balancer--classic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerClassic20",
          "filepath": "load-balancer--classic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8zM14 8V4h4V8z"
                }
              }
            ],
            "name": "load-balancer--classic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerClassic16",
          "filepath": "load-balancer--classic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8zM14 8V4h4V8z"
                }
              }
            ],
            "name": "load-balancer--classic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LoadBalancerClassic",
        "global": "LoadBalancerClassic",
        "filepath": "LoadBalancerClassic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8zM14 8V4h4V8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--global",
      "friendlyName": "Load balancer global",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application",
        "global"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--global.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"4\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"14\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"24\" y=\"26\" width=\"4\" height=\"4\"/>\n  <path d=\"M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,10Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 4z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--global.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerGlobal32",
          "filepath": "load-balancer--global/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 4z"
                }
              }
            ],
            "name": "load-balancer--global",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerGlobal24",
          "filepath": "load-balancer--global/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 4z"
                }
              }
            ],
            "name": "load-balancer--global",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerGlobal20",
          "filepath": "load-balancer--global/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 4z"
                }
              }
            ],
            "name": "load-balancer--global",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerGlobal16",
          "filepath": "load-balancer--global/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 4z"
                }
              }
            ],
            "name": "load-balancer--global",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LoadBalancerGlobal",
        "global": "LoadBalancerGlobal",
        "filepath": "LoadBalancerGlobal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--listener",
      "friendlyName": "Load balancer listener",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application",
        "listener"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--listener.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15\" y=\"8\" width=\"2\" height=\"2\"/>\n  <rect x=\"19\" y=\"8\" width=\"2\" height=\"2\"/>\n  <rect x=\"11\" y=\"8\" width=\"2\" height=\"2\"/>\n  <path d=\"M25,16H17V13H15v3H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"4\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"14\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"24\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"11\" y=\"3\" width=\"10\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 8H17V10H15zM19 8H21V10H19zM11 8H13V10H11zM25 16H17V13H15v3H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 3H21V5H11z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--listener.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerListener32",
          "filepath": "load-balancer--listener/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V10H15zM19 8H21V10H19zM11 8H13V10H11zM25 16H17V13H15v3H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 3H21V5H11z"
                }
              }
            ],
            "name": "load-balancer--listener",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerListener24",
          "filepath": "load-balancer--listener/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V10H15zM19 8H21V10H19zM11 8H13V10H11zM25 16H17V13H15v3H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 3H21V5H11z"
                }
              }
            ],
            "name": "load-balancer--listener",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerListener20",
          "filepath": "load-balancer--listener/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V10H15zM19 8H21V10H19zM11 8H13V10H11zM25 16H17V13H15v3H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 3H21V5H11z"
                }
              }
            ],
            "name": "load-balancer--listener",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerListener16",
          "filepath": "load-balancer--listener/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V10H15zM19 8H21V10H19zM11 8H13V10H11zM25 16H17V13H15v3H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 3H21V5H11z"
                }
              }
            ],
            "name": "load-balancer--listener",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LoadBalancerListener",
        "global": "LoadBalancerListener",
        "filepath": "LoadBalancerListener.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 8H17V10H15zM19 8H21V10H19zM11 8H13V10H11zM25 16H17V13H15v3H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 3H21V5H11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--local",
      "friendlyName": "Load balancer local",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application",
        "local"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--local.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,16H17V10H15v6H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"4\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"14\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"24\" y=\"26\" width=\"4\" height=\"4\"/>\n  <rect x=\"11\" y=\"5\" width=\"10\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 16H17V10H15v6H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 5H21V7H11z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--local.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerLocal32",
          "filepath": "load-balancer--local/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V10H15v6H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 5H21V7H11z"
                }
              }
            ],
            "name": "load-balancer--local",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerLocal24",
          "filepath": "load-balancer--local/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V10H15v6H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 5H21V7H11z"
                }
              }
            ],
            "name": "load-balancer--local",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerLocal20",
          "filepath": "load-balancer--local/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V10H15v6H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 5H21V7H11z"
                }
              }
            ],
            "name": "load-balancer--local",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerLocal16",
          "filepath": "load-balancer--local/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V10H15v6H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 5H21V7H11z"
                }
              }
            ],
            "name": "load-balancer--local",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LoadBalancerLocal",
        "global": "LoadBalancerLocal",
        "filepath": "LoadBalancerLocal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 16H17V10H15v6H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 5H21V7H11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--network",
      "friendlyName": "Load balancer network",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--network.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v4H7V18h8v4h2V18h8v4h2V18A2.0023,2.0023,0,0,0,25,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,10V2H12v8h8ZM14,8V4h4V8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,24a2.9948,2.9948,0,0,0-2.8157,2H18.8157a2.982,2.982,0,0,0-5.6314,0H8.8157a3,3,0,1,0,0,2h4.3686a2.982,2.982,0,0,0,5.6314,0h4.3686A2.9947,2.9947,0,1,0,26,24ZM6,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,28Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,28Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v4H7V18h8v4h2V18h8v4h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8h8zM14 8V4h4V8zM26 24a2.9948 2.9948 0 00-2.8157 2H18.8157a2.982 2.982 0 00-5.6314 0H8.8157a3 3 0 100 2h4.3686a2.982 2.982 0 005.6314 0h4.3686A2.9947 2.9947 0 1026 24zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0116 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0126 28z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--network.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerNetwork32",
          "filepath": "load-balancer--network/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v4H7V18h8v4h2V18h8v4h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8h8zM14 8V4h4V8zM26 24a2.9948 2.9948 0 00-2.8157 2H18.8157a2.982 2.982 0 00-5.6314 0H8.8157a3 3 0 100 2h4.3686a2.982 2.982 0 005.6314 0h4.3686A2.9947 2.9947 0 1026 24zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0116 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--network",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerNetwork24",
          "filepath": "load-balancer--network/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v4H7V18h8v4h2V18h8v4h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8h8zM14 8V4h4V8zM26 24a2.9948 2.9948 0 00-2.8157 2H18.8157a2.982 2.982 0 00-5.6314 0H8.8157a3 3 0 100 2h4.3686a2.982 2.982 0 005.6314 0h4.3686A2.9947 2.9947 0 1026 24zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0116 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--network",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerNetwork20",
          "filepath": "load-balancer--network/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v4H7V18h8v4h2V18h8v4h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8h8zM14 8V4h4V8zM26 24a2.9948 2.9948 0 00-2.8157 2H18.8157a2.982 2.982 0 00-5.6314 0H8.8157a3 3 0 100 2h4.3686a2.982 2.982 0 005.6314 0h4.3686A2.9947 2.9947 0 1026 24zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0116 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--network",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerNetwork16",
          "filepath": "load-balancer--network/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v4H7V18h8v4h2V18h8v4h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8h8zM14 8V4h4V8zM26 24a2.9948 2.9948 0 00-2.8157 2H18.8157a2.982 2.982 0 00-5.6314 0H8.8157a3 3 0 100 2h4.3686a2.982 2.982 0 005.6314 0h4.3686A2.9947 2.9947 0 1026 24zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0116 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--network",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LoadBalancerNetwork",
        "global": "LoadBalancerNetwork",
        "filepath": "LoadBalancerNetwork.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v4H7V18h8v4h2V18h8v4h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8h8zM14 8V4h4V8zM26 24a2.9948 2.9948 0 00-2.8157 2H18.8157a2.982 2.982 0 00-5.6314 0H8.8157a3 3 0 100 2h4.3686a2.982 2.982 0 005.6314 0h4.3686A2.9947 2.9947 0 1026 24zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0116 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--pool",
      "friendlyName": "Load balancer--pool",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application",
        "pool"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--pool.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"10\" y=\"15\" width=\"12\" height=\"2\"/>\n  <path d=\"M8.7,6.2852A2.9665,2.9665,0,0,0,9,5,3,3,0,1,0,6,8a2.96,2.96,0,0,0,1.2852-.3008L10,10.4141V13h2V9.5859ZM6,6A1,1,0,1,1,7,5,1.0009,1.0009,0,0,1,6,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M19,5a3,3,0,1,0-4,2.8154V13h2V7.8159A2.9957,2.9957,0,0,0,19,5ZM16,6a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,2a3.0033,3.0033,0,0,0-3,3,2.9665,2.9665,0,0,0,.3,1.2852L20,9.5859V13h2V10.4141l2.7148-2.7149A2.96,2.96,0,0,0,26,8a3,3,0,0,0,0-6Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M12,19H10v2.5859L7.2854,24.3008A2.9609,2.9609,0,0,0,6,24a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L12,22.4141ZM6,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M17,24.1841V19H15v5.1841a3,3,0,1,0,2,0ZM16,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,24a2.9609,2.9609,0,0,0-1.2854.3008L22,21.5859V19H20v3.4141l3.3,3.3007A2.9665,2.9665,0,0,0,23,27a3,3,0,1,0,3-3Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 15H22V17H10zM8.7 6.2852A2.9665 2.9665 0 009 5 3 3 0 106 8a2.96 2.96 0 001.2852-.3008L10 10.4141V13h2V9.5859zM6 6A1 1 0 117 5 1.0009 1.0009 0 016 6zM19 5a3 3 0 10-4 2.8154V13h2V7.8159A2.9957 2.9957 0 0019 5zM16 6a1 1 0 111-1A1.0009 1.0009 0 0116 6zM26 2a3.0033 3.0033 0 00-3 3 2.9665 2.9665 0 00.3 1.2852L20 9.5859V13h2V10.4141l2.7148-2.7149A2.96 2.96 0 0026 8a3 3 0 000-6zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 6zM12 19H10v2.5859L7.2854 24.3008A2.9609 2.9609 0 006 24a3 3 0 103 3 2.9665 2.9665 0 00-.3-1.2852L12 22.4141zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zM17 24.1841V19H15v5.1841a3 3 0 102 0zM16 28a1 1 0 111-1A1.0009 1.0009 0 0116 28zM26 24a2.9609 2.9609 0 00-1.2854.3008L22 21.5859V19H20v3.4141l3.3 3.3007A2.9665 2.9665 0 0023 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 28z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--pool.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerPool32",
          "filepath": "load-balancer--pool/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 15H22V17H10zM8.7 6.2852A2.9665 2.9665 0 009 5 3 3 0 106 8a2.96 2.96 0 001.2852-.3008L10 10.4141V13h2V9.5859zM6 6A1 1 0 117 5 1.0009 1.0009 0 016 6zM19 5a3 3 0 10-4 2.8154V13h2V7.8159A2.9957 2.9957 0 0019 5zM16 6a1 1 0 111-1A1.0009 1.0009 0 0116 6zM26 2a3.0033 3.0033 0 00-3 3 2.9665 2.9665 0 00.3 1.2852L20 9.5859V13h2V10.4141l2.7148-2.7149A2.96 2.96 0 0026 8a3 3 0 000-6zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 6zM12 19H10v2.5859L7.2854 24.3008A2.9609 2.9609 0 006 24a3 3 0 103 3 2.9665 2.9665 0 00-.3-1.2852L12 22.4141zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zM17 24.1841V19H15v5.1841a3 3 0 102 0zM16 28a1 1 0 111-1A1.0009 1.0009 0 0116 28zM26 24a2.9609 2.9609 0 00-1.2854.3008L22 21.5859V19H20v3.4141l3.3 3.3007A2.9665 2.9665 0 0023 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--pool",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerPool24",
          "filepath": "load-balancer--pool/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 15H22V17H10zM8.7 6.2852A2.9665 2.9665 0 009 5 3 3 0 106 8a2.96 2.96 0 001.2852-.3008L10 10.4141V13h2V9.5859zM6 6A1 1 0 117 5 1.0009 1.0009 0 016 6zM19 5a3 3 0 10-4 2.8154V13h2V7.8159A2.9957 2.9957 0 0019 5zM16 6a1 1 0 111-1A1.0009 1.0009 0 0116 6zM26 2a3.0033 3.0033 0 00-3 3 2.9665 2.9665 0 00.3 1.2852L20 9.5859V13h2V10.4141l2.7148-2.7149A2.96 2.96 0 0026 8a3 3 0 000-6zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 6zM12 19H10v2.5859L7.2854 24.3008A2.9609 2.9609 0 006 24a3 3 0 103 3 2.9665 2.9665 0 00-.3-1.2852L12 22.4141zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zM17 24.1841V19H15v5.1841a3 3 0 102 0zM16 28a1 1 0 111-1A1.0009 1.0009 0 0116 28zM26 24a2.9609 2.9609 0 00-1.2854.3008L22 21.5859V19H20v3.4141l3.3 3.3007A2.9665 2.9665 0 0023 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--pool",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerPool20",
          "filepath": "load-balancer--pool/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 15H22V17H10zM8.7 6.2852A2.9665 2.9665 0 009 5 3 3 0 106 8a2.96 2.96 0 001.2852-.3008L10 10.4141V13h2V9.5859zM6 6A1 1 0 117 5 1.0009 1.0009 0 016 6zM19 5a3 3 0 10-4 2.8154V13h2V7.8159A2.9957 2.9957 0 0019 5zM16 6a1 1 0 111-1A1.0009 1.0009 0 0116 6zM26 2a3.0033 3.0033 0 00-3 3 2.9665 2.9665 0 00.3 1.2852L20 9.5859V13h2V10.4141l2.7148-2.7149A2.96 2.96 0 0026 8a3 3 0 000-6zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 6zM12 19H10v2.5859L7.2854 24.3008A2.9609 2.9609 0 006 24a3 3 0 103 3 2.9665 2.9665 0 00-.3-1.2852L12 22.4141zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zM17 24.1841V19H15v5.1841a3 3 0 102 0zM16 28a1 1 0 111-1A1.0009 1.0009 0 0116 28zM26 24a2.9609 2.9609 0 00-1.2854.3008L22 21.5859V19H20v3.4141l3.3 3.3007A2.9665 2.9665 0 0023 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--pool",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerPool16",
          "filepath": "load-balancer--pool/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 15H22V17H10zM8.7 6.2852A2.9665 2.9665 0 009 5 3 3 0 106 8a2.96 2.96 0 001.2852-.3008L10 10.4141V13h2V9.5859zM6 6A1 1 0 117 5 1.0009 1.0009 0 016 6zM19 5a3 3 0 10-4 2.8154V13h2V7.8159A2.9957 2.9957 0 0019 5zM16 6a1 1 0 111-1A1.0009 1.0009 0 0116 6zM26 2a3.0033 3.0033 0 00-3 3 2.9665 2.9665 0 00.3 1.2852L20 9.5859V13h2V10.4141l2.7148-2.7149A2.96 2.96 0 0026 8a3 3 0 000-6zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 6zM12 19H10v2.5859L7.2854 24.3008A2.9609 2.9609 0 006 24a3 3 0 103 3 2.9665 2.9665 0 00-.3-1.2852L12 22.4141zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zM17 24.1841V19H15v5.1841a3 3 0 102 0zM16 28a1 1 0 111-1A1.0009 1.0009 0 0116 28zM26 24a2.9609 2.9609 0 00-1.2854.3008L22 21.5859V19H20v3.4141l3.3 3.3007A2.9665 2.9665 0 0023 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                }
              }
            ],
            "name": "load-balancer--pool",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LoadBalancerPool",
        "global": "LoadBalancerPool",
        "filepath": "LoadBalancerPool.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 15H22V17H10zM8.7 6.2852A2.9665 2.9665 0 009 5 3 3 0 106 8a2.96 2.96 0 001.2852-.3008L10 10.4141V13h2V9.5859zM6 6A1 1 0 117 5 1.0009 1.0009 0 016 6zM19 5a3 3 0 10-4 2.8154V13h2V7.8159A2.9957 2.9957 0 0019 5zM16 6a1 1 0 111-1A1.0009 1.0009 0 0116 6zM26 2a3.0033 3.0033 0 00-3 3 2.9665 2.9665 0 00.3 1.2852L20 9.5859V13h2V10.4141l2.7148-2.7149A2.96 2.96 0 0026 8a3 3 0 000-6zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 6zM12 19H10v2.5859L7.2854 24.3008A2.9609 2.9609 0 006 24a3 3 0 103 3 2.9665 2.9665 0 00-.3-1.2852L12 22.4141zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zM17 24.1841V19H15v5.1841a3 3 0 102 0zM16 28a1 1 0 111-1A1.0009 1.0009 0 0116 28zM26 24a2.9609 2.9609 0 00-1.2854.3008L22 21.5859V19H20v3.4141l3.3 3.3007A2.9665 2.9665 0 0023 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "load-balancer--vpc",
      "friendlyName": "IBM Cloud® Load Balancer for VPC",
      "aliases": [
        "load",
        "balancer",
        "app",
        "application",
        "VPC",
        "virtual private cloud",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/load-balancer--vpc.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,30H2V24H8ZM4,28H6V26H4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M19,30H13V24h6Zm-4-2h2V26H15Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,30H24V24h6Zm-4-2h2V26H26Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,10Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,16H21a4.0045,4.0045,0,0,1-4-4H15a4.0045,4.0045,0,0,1-4,4H6a2.0023,2.0023,0,0,0-2,2v4H6V18h5A5.9694,5.9694,0,0,0,15,16.46V22h2V16.46A5.9694,5.9694,0,0,0,21,18h5v4h2V18A2.0023,2.0023,0,0,0,26,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 30H2V24H8zM4 28H6V26H4zM19 30H13V24h6zm-4-2h2V26H15zM30 30H24V24h6zm-4-2h2V26H26zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.002 2.002 0 0016 4zM26 16H21a4.0045 4.0045 0 01-4-4H15a4.0045 4.0045 0 01-4 4H6a2.0023 2.0023 0 00-2 2v4H6V18h5A5.9694 5.9694 0 0015 16.46V22h2V16.46A5.9694 5.9694 0 0021 18h5v4h2V18A2.0023 2.0023 0 0026 16z\"/></svg>",
            "info": {},
            "path": "32/load-balancer--vpc.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LoadBalancerVpc32",
          "filepath": "load-balancer--vpc/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2V24H8zM4 28H6V26H4zM19 30H13V24h6zm-4-2h2V26H15zM30 30H24V24h6zm-4-2h2V26H26zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.002 2.002 0 0016 4zM26 16H21a4.0045 4.0045 0 01-4-4H15a4.0045 4.0045 0 01-4 4H6a2.0023 2.0023 0 00-2 2v4H6V18h5A5.9694 5.9694 0 0015 16.46V22h2V16.46A5.9694 5.9694 0 0021 18h5v4h2V18A2.0023 2.0023 0 0026 16z"
                }
              }
            ],
            "name": "load-balancer--vpc",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LoadBalancerVpc24",
          "filepath": "load-balancer--vpc/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2V24H8zM4 28H6V26H4zM19 30H13V24h6zm-4-2h2V26H15zM30 30H24V24h6zm-4-2h2V26H26zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.002 2.002 0 0016 4zM26 16H21a4.0045 4.0045 0 01-4-4H15a4.0045 4.0045 0 01-4 4H6a2.0023 2.0023 0 00-2 2v4H6V18h5A5.9694 5.9694 0 0015 16.46V22h2V16.46A5.9694 5.9694 0 0021 18h5v4h2V18A2.0023 2.0023 0 0026 16z"
                }
              }
            ],
            "name": "load-balancer--vpc",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LoadBalancerVpc20",
          "filepath": "load-balancer--vpc/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2V24H8zM4 28H6V26H4zM19 30H13V24h6zm-4-2h2V26H15zM30 30H24V24h6zm-4-2h2V26H26zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.002 2.002 0 0016 4zM26 16H21a4.0045 4.0045 0 01-4-4H15a4.0045 4.0045 0 01-4 4H6a2.0023 2.0023 0 00-2 2v4H6V18h5A5.9694 5.9694 0 0015 16.46V22h2V16.46A5.9694 5.9694 0 0021 18h5v4h2V18A2.0023 2.0023 0 0026 16z"
                }
              }
            ],
            "name": "load-balancer--vpc",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LoadBalancerVpc16",
          "filepath": "load-balancer--vpc/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2V24H8zM4 28H6V26H4zM19 30H13V24h6zm-4-2h2V26H15zM30 30H24V24h6zm-4-2h2V26H26zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.002 2.002 0 0016 4zM26 16H21a4.0045 4.0045 0 01-4-4H15a4.0045 4.0045 0 01-4 4H6a2.0023 2.0023 0 00-2 2v4H6V18h5A5.9694 5.9694 0 0015 16.46V22h2V16.46A5.9694 5.9694 0 0021 18h5v4h2V18A2.0023 2.0023 0 0026 16z"
                }
              }
            ],
            "name": "load-balancer--vpc",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "LoadBalancerVpc",
        "global": "LoadBalancerVpc",
        "filepath": "LoadBalancerVpc.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 30H2V24H8zM4 28H6V26H4zM19 30H13V24h6zm-4-2h2V26H15zM30 30H24V24h6zm-4-2h2V26H26zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.002 2.002 0 0016 4zM26 16H21a4.0045 4.0045 0 01-4-4H15a4.0045 4.0045 0 01-4 4H6a2.0023 2.0023 0 00-2 2v4H6V18h5A5.9694 5.9694 0 0015 16.46V22h2V16.46A5.9694 5.9694 0 0021 18h5v4h2V18A2.0023 2.0023 0 0026 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location",
      "friendlyName": "Location",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>location</title>\n  <path d=\"M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z\"/>\n  <path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(0 32) rotate(-90)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z\"/><path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/></svg>",
            "info": {},
            "path": "32/location.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Location32",
          "filepath": "location/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Location24",
          "filepath": "location/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Location20",
          "filepath": "location/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Location16",
          "filepath": "location/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Location",
        "global": "Location",
        "filepath": "Location.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--company",
      "friendlyName": "Location company",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "company",
        "location",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--company.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"15\" y=\"16\" width=\"2\" height=\"2\"/>\n  <rect x=\"15\" y=\"12\" width=\"2\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/><path d=\"M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z\"/><path d=\"M15 16H17V18H15zM15 12H17V14H15z\"/></svg>",
            "info": {},
            "path": "32/location--company.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationCompany32",
          "filepath": "location--company/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16H17V18H15zM15 12H17V14H15z"
                }
              }
            ],
            "name": "location--company",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationCompany24",
          "filepath": "location--company/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16H17V18H15zM15 12H17V14H15z"
                }
              }
            ],
            "name": "location--company",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationCompany20",
          "filepath": "location--company/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16H17V18H15zM15 12H17V14H15z"
                }
              }
            ],
            "name": "location--company",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationCompany16",
          "filepath": "location--company/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 16H17V18H15zM15 12H17V14H15z"
                }
              }
            ],
            "name": "location--company",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationCompany",
        "global": "LocationCompany",
        "filepath": "LocationCompany.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 16H17V18H15zM15 12H17V14H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--company--filled",
      "friendlyName": "Location company filled",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "company",
        "filled",
        "location",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--company--filled.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z\"/><path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/location--company--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationCompanyFilled32",
          "filepath": "location--company--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--company--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationCompanyFilled24",
          "filepath": "location--company--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--company--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationCompanyFilled20",
          "filepath": "location--company--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--company--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationCompanyFilled16",
          "filepath": "location--company--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--company--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationCompanyFilled",
        "global": "LocationCompanyFilled",
        "filepath": "LocationCompanyFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--current",
      "friendlyName": "Location current",
      "aliases": [
        "place",
        "locate",
        "gps",
        "filled",
        "location"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--current.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z\"/></svg>",
            "info": {},
            "path": "32/location--current.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationCurrent32",
          "filepath": "location--current/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
                }
              }
            ],
            "name": "location--current",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationCurrent24",
          "filepath": "location--current/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
                }
              }
            ],
            "name": "location--current",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationCurrent20",
          "filepath": "location--current/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
                }
              }
            ],
            "name": "location--current",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationCurrent16",
          "filepath": "location--current/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
                }
              }
            ],
            "name": "location--current",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "LocationCurrent",
        "global": "LocationCurrent",
        "filepath": "LocationCurrent.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--filled",
      "friendlyName": "Location filled",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "hazard",
        "travel",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z\"/>\n  <circle id=\"_Inner-Path_\" data-name=\"&lt;Inner-Path&gt;\" class=\"cls-1\" cx=\"16\" cy=\"13\" r=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z\"/><circle cx=\"16\" cy=\"13\" r=\"4\" fill=\"none\"/></svg>",
            "info": {},
            "path": "32/location--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationFilled32",
          "filepath": "location--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "4",
                  "fill": "none"
                }
              }
            ],
            "name": "location--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationFilled24",
          "filepath": "location--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "4",
                  "fill": "none"
                }
              }
            ],
            "name": "location--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationFilled20",
          "filepath": "location--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "4",
                  "fill": "none"
                }
              }
            ],
            "name": "location--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationFilled16",
          "filepath": "location--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "4",
                  "fill": "none"
                }
              }
            ],
            "name": "location--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationFilled",
        "global": "LocationFilled",
        "filepath": "LocationFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "13",
                    "r": "4",
                    "fill": "none"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--hazard",
      "friendlyName": "Location hazard",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "hazard",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--hazard.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"20.5\" r=\"1.5\"/>\n  <rect x=\"15\" y=\"7\" width=\"2\" height=\"9\"/>\n  <path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"20.5\" r=\"1.5\"/><path d=\"M15 7H17V16H15z\"/><path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/></svg>",
            "info": {},
            "path": "32/location--hazard.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationHazard32",
          "filepath": "location--hazard/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V16H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--hazard",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationHazard24",
          "filepath": "location--hazard/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V16H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--hazard",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationHazard20",
          "filepath": "location--hazard/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V16H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--hazard",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationHazard16",
          "filepath": "location--hazard/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "20.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 7H17V16H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--hazard",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationHazard",
        "global": "LocationHazard",
        "filepath": "LocationHazard.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "20.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 7H17V16H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--hazard--filled",
      "friendlyName": "Location hazard filled",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "hazard",
        "travel",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--hazard--filled.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z\"/><path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z\"/></svg>",
            "info": {},
            "path": "32/location--hazard--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationHazardFilled32",
          "filepath": "location--hazard--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
                }
              }
            ],
            "name": "location--hazard--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationHazardFilled24",
          "filepath": "location--hazard--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
                }
              }
            ],
            "name": "location--hazard--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationHazardFilled20",
          "filepath": "location--hazard--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
                }
              }
            ],
            "name": "location--hazard--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationHazardFilled16",
          "filepath": "location--hazard--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
                }
              }
            ],
            "name": "location--hazard--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationHazardFilled",
        "global": "LocationHazardFilled",
        "filepath": "LocationHazardFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--heart",
      "friendlyName": "Location heart",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "heart",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--heart.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z\"/><path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/></svg>",
            "info": {},
            "path": "32/location--heart.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationHeart32",
          "filepath": "location--heart/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--heart",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationHeart24",
          "filepath": "location--heart/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--heart",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationHeart20",
          "filepath": "location--heart/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--heart",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationHeart16",
          "filepath": "location--heart/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--heart",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationHeart",
        "global": "LocationHeart",
        "filepath": "LocationHeart.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--heart--filled",
      "friendlyName": "Location heart filled",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "heart",
        "travel",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--heart--filled.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z\"/><path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z\"/></svg>",
            "info": {},
            "path": "32/location--heart--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationHeartFilled32",
          "filepath": "location--heart--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
                }
              }
            ],
            "name": "location--heart--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationHeartFilled24",
          "filepath": "location--heart--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
                }
              }
            ],
            "name": "location--heart--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationHeartFilled20",
          "filepath": "location--heart--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
                }
              }
            ],
            "name": "location--heart--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationHeartFilled16",
          "filepath": "location--heart--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
                }
              }
            ],
            "name": "location--heart--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationHeartFilled",
        "global": "LocationHeartFilled",
        "filepath": "LocationHeartFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--person",
      "friendlyName": "Location person",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "person",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--person.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #241f20;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M16,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,14Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,16,10Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 19H18V17H14v2H12V17a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2zM16 14a3 3 0 113-3A3.0033 3.0033 0 0116 14zm0-4a1 1 0 101 1A1.0011 1.0011 0 0016 10z\"/><path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/></svg>",
            "info": {},
            "path": "32/location--person.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationPerson32",
          "filepath": "location--person/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H18V17H14v2H12V17a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2zM16 14a3 3 0 113-3A3.0033 3.0033 0 0116 14zm0-4a1 1 0 101 1A1.0011 1.0011 0 0016 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--person",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationPerson24",
          "filepath": "location--person/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H18V17H14v2H12V17a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2zM16 14a3 3 0 113-3A3.0033 3.0033 0 0116 14zm0-4a1 1 0 101 1A1.0011 1.0011 0 0016 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--person",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationPerson20",
          "filepath": "location--person/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H18V17H14v2H12V17a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2zM16 14a3 3 0 113-3A3.0033 3.0033 0 0116 14zm0-4a1 1 0 101 1A1.0011 1.0011 0 0016 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--person",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationPerson16",
          "filepath": "location--person/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19H18V17H14v2H12V17a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2zM16 14a3 3 0 113-3A3.0033 3.0033 0 0116 14zm0-4a1 1 0 101 1A1.0011 1.0011 0 0016 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--person",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationPerson",
        "global": "LocationPerson",
        "filepath": "LocationPerson.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 19H18V17H14v2H12V17a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2zM16 14a3 3 0 113-3A3.0033 3.0033 0 0116 14zm0-4a1 1 0 101 1A1.0011 1.0011 0 0016 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--person--filled",
      "friendlyName": "Location person filled",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "person",
        "travel",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--person--filled.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"16\" cy=\"11\" r=\"1\"/>\n  <path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z\"/><circle cx=\"16\" cy=\"11\" r=\"1\"/><path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/location--person--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationPersonFilled32",
          "filepath": "location--person--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--person--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationPersonFilled24",
          "filepath": "location--person--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--person--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationPersonFilled20",
          "filepath": "location--person--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--person--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationPersonFilled16",
          "filepath": "location--person--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "location--person--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationPersonFilled",
        "global": "LocationPersonFilled",
        "filepath": "LocationPersonFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--save",
      "friendlyName": "Location save",
      "aliases": [
        "save",
        "pointer",
        "travel",
        "person",
        "pin",
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "site",
        "area",
        "legend",
        "location",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--save.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18,30h2V28a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V28a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z\"/>\n  <path d=\"M24,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,24,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,24,18Z\"/>\n  <path d=\"M25.3418,10.06l-22-8A1,1,0,0,0,2.06,3.3415l8,22A1.001,1.001,0,0,0,10.9839,26H11a1,1,0,0,0,.9287-.6289L15.77,15.7692l9.6016-3.8408a1,1,0,0,0-.0293-1.8687ZM14.6284,14.0709v0l-.3979.1591-.1591.3979,0,0-3.0269,7.5678L4.6719,4.6715l17.5244,6.3726Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 30h2V28a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V28a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 24a4 4 0 114-4A4.0042 4.0042 0 0124 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.001 1.001 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6016-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0269 7.5678L4.6719 4.6715l17.5244 6.3726z\"/></svg>",
            "info": {},
            "path": "32/location--save.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationSave32",
          "filepath": "location--save/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30h2V28a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V28a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 24a4 4 0 114-4A4.0042 4.0042 0 0124 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.001 1.001 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6016-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0269 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "location--save",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationSave24",
          "filepath": "location--save/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30h2V28a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V28a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 24a4 4 0 114-4A4.0042 4.0042 0 0124 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.001 1.001 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6016-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0269 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "location--save",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationSave20",
          "filepath": "location--save/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30h2V28a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V28a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 24a4 4 0 114-4A4.0042 4.0042 0 0124 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.001 1.001 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6016-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0269 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "location--save",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationSave16",
          "filepath": "location--save/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30h2V28a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V28a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 24a4 4 0 114-4A4.0042 4.0042 0 0124 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.001 1.001 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6016-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0269 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "location--save",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationSave",
        "global": "LocationSave",
        "filepath": "LocationSave.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 30h2V28a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V28a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 24a4 4 0 114-4A4.0042 4.0042 0 0124 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.001 1.001 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6016-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0269 7.5678L4.6719 4.6715l17.5244 6.3726z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--star",
      "friendlyName": "Location star",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "star",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--star.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 7 17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7\"/>\n  <path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z\"/><path d=\"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z\"/></svg>",
            "info": {},
            "path": "32/location--star.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationStar32",
          "filepath": "location--star/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--star",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationStar24",
          "filepath": "location--star/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--star",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationStar20",
          "filepath": "location--star/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--star",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationStar16",
          "filepath": "location--star/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                }
              }
            ],
            "name": "location--star",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationStar",
        "global": "LocationStar",
        "filepath": "LocationStar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "location--star--filled",
      "friendlyName": "Location star filled",
      "aliases": [
        "place",
        "locate",
        "gps",
        "destination",
        "map",
        "pin",
        "site",
        "area",
        "legend",
        "location",
        "star",
        "travel",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/location--star--filled.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" points=\"16 7 17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7\"/>\n  <path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z\"/><path d=\"M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z\"/></svg>",
            "info": {},
            "path": "32/location--star--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LocationStarFilled32",
          "filepath": "location--star--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
                }
              }
            ],
            "name": "location--star--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LocationStarFilled24",
          "filepath": "location--star--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
                }
              }
            ],
            "name": "location--star--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LocationStarFilled20",
          "filepath": "location--star--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
                }
              }
            ],
            "name": "location--star--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LocationStarFilled16",
          "filepath": "location--star--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
                }
              }
            ],
            "name": "location--star--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "LocationStarFilled",
        "global": "LocationStarFilled",
        "filepath": "LocationStarFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "locked",
      "friendlyName": "Locked",
      "aliases": [
        "lock",
        "seal",
        "hidden",
        "edit",
        "padlock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/locked.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>locked</title><path d=\"M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z\"/></svg>",
            "info": {},
            "path": "32/locked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Locked32",
          "filepath": "locked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
                }
              }
            ],
            "name": "locked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Locked24",
          "filepath": "locked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
                }
              }
            ],
            "name": "locked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Locked20",
          "filepath": "locked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
                }
              }
            ],
            "name": "locked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Locked16",
          "filepath": "locked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
                }
              }
            ],
            "name": "locked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Locked",
        "global": "Locked",
        "filepath": "Locked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logical-partition",
      "friendlyName": "Logical partition",
      "aliases": [
        "logical",
        "partition",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logical-partition.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"9\" cy=\"7\" r=\"1\"/>\n  <path d=\"M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"7\" r=\"1\"/><path d=\"M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z\"/></svg>",
            "info": {},
            "path": "32/logical-partition.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogicalPartition32",
          "filepath": "logical-partition/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
                }
              }
            ],
            "name": "logical-partition",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogicalPartition24",
          "filepath": "logical-partition/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
                }
              }
            ],
            "name": "logical-partition",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogicalPartition20",
          "filepath": "logical-partition/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
                }
              }
            ],
            "name": "logical-partition",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogicalPartition16",
          "filepath": "logical-partition/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
                }
              }
            ],
            "name": "logical-partition",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "LogicalPartition",
        "global": "LogicalPartition",
        "filepath": "LogicalPartition.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "login",
      "friendlyName": "Login",
      "aliases": [
        "log on",
        "password",
        "enter",
        "sign in",
        "sign on",
        "pin",
        "username"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/login.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>login</title><path d=\"M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z\"/><polygon points=\"14.59 20.59 18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z\"/><path d=\"M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z\"/></svg>",
            "info": {},
            "path": "32/login.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Login32",
          "filepath": "login/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
                }
              }
            ],
            "name": "login",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Login24",
          "filepath": "login/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
                }
              }
            ],
            "name": "login",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Login20",
          "filepath": "login/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
                }
              }
            ],
            "name": "login",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Login16",
          "filepath": "login/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
                }
              }
            ],
            "name": "login",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Login",
        "global": "Login",
        "filepath": "Login.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--angular",
      "friendlyName": "logo--angular",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--angular.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M13.5,16h4.9L16,10.8L13.5,16z\"/>\n<path d=\"M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.5,16h4.9L16,10.8L13.5,16z\"/><path d=\"M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z\"/></svg>",
            "info": {},
            "path": "32/logo--angular.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoAngular32",
          "filepath": "logo--angular/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,16h4.9L16,10.8L13.5,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
                }
              }
            ],
            "name": "logo--angular",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoAngular24",
          "filepath": "logo--angular/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,16h4.9L16,10.8L13.5,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
                }
              }
            ],
            "name": "logo--angular",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoAngular20",
          "filepath": "logo--angular/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,16h4.9L16,10.8L13.5,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
                }
              }
            ],
            "name": "logo--angular",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoAngular16",
          "filepath": "logo--angular/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,16h4.9L16,10.8L13.5,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
                }
              }
            ],
            "name": "logo--angular",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoAngular",
        "global": "LogoAngular",
        "filepath": "LogoAngular.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.5,16h4.9L16,10.8L13.5,16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--ansible-community",
      "friendlyName": "logo--ansible-community",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--ansible-community.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6\n\tc1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6\tc1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z\"/></svg>",
            "info": {},
            "path": "32/logo--ansible-community.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoAnsibleCommunity32",
          "filepath": "logo--ansible-community/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6\tc1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
                }
              }
            ],
            "name": "logo--ansible-community",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoAnsibleCommunity24",
          "filepath": "logo--ansible-community/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6\tc1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
                }
              }
            ],
            "name": "logo--ansible-community",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoAnsibleCommunity20",
          "filepath": "logo--ansible-community/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6\tc1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
                }
              }
            ],
            "name": "logo--ansible-community",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoAnsibleCommunity16",
          "filepath": "logo--ansible-community/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6\tc1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
                }
              }
            ],
            "name": "logo--ansible-community",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoAnsibleCommunity",
        "global": "LogoAnsibleCommunity",
        "filepath": "LogoAnsibleCommunity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6 c1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--digg",
      "friendlyName": "Logo Digg",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--digg.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--digg</title><path d=\"M6.48,7.6v3.92H2V21H9.28V7.6Zm0,11.2H4.8v-5H6.48Z\"/><rect x=\"10.4\" y=\"11.52\" width=\"2.8\" height=\"9.52\"/><rect x=\"10.4\" y=\"7.6\" width=\"2.8\" height=\"2.8\"/><path d=\"M14.32,11.52V21H18.8v1.12H14.32V24.4H21.6V11.52ZM18.8,18.8H17.12v-5H18.8Z\"/><path d=\"M22.72,11.52V21H27.2v1.12H22.72V24.4H30V11.52ZM27.2,18.8H25.52v-5H27.2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6.48 7.6v3.92H2V21H9.28V7.6zm0 11.2H4.8v-5H6.48zM10.4 11.52H13.2V21.04H10.4zM10.4 7.6H13.2V10.399999999999999H10.4zM14.32 11.52V21H18.8v1.12H14.32V24.4H21.6V11.52zM18.8 18.8H17.12v-5H18.8zM22.72 11.52V21H27.2v1.12H22.72V24.4H30V11.52zM27.2 18.8H25.52v-5H27.2z\"/></svg>",
            "info": {},
            "path": "32/logo--digg.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoDigg32",
          "filepath": "logo--digg/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.48 7.6v3.92H2V21H9.28V7.6zm0 11.2H4.8v-5H6.48zM10.4 11.52H13.2V21.04H10.4zM10.4 7.6H13.2V10.399999999999999H10.4zM14.32 11.52V21H18.8v1.12H14.32V24.4H21.6V11.52zM18.8 18.8H17.12v-5H18.8zM22.72 11.52V21H27.2v1.12H22.72V24.4H30V11.52zM27.2 18.8H25.52v-5H27.2z"
                }
              }
            ],
            "name": "logo--digg",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoDigg24",
          "filepath": "logo--digg/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.48 7.6v3.92H2V21H9.28V7.6zm0 11.2H4.8v-5H6.48zM10.4 11.52H13.2V21.04H10.4zM10.4 7.6H13.2V10.399999999999999H10.4zM14.32 11.52V21H18.8v1.12H14.32V24.4H21.6V11.52zM18.8 18.8H17.12v-5H18.8zM22.72 11.52V21H27.2v1.12H22.72V24.4H30V11.52zM27.2 18.8H25.52v-5H27.2z"
                }
              }
            ],
            "name": "logo--digg",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoDigg20",
          "filepath": "logo--digg/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.48 7.6v3.92H2V21H9.28V7.6zm0 11.2H4.8v-5H6.48zM10.4 11.52H13.2V21.04H10.4zM10.4 7.6H13.2V10.399999999999999H10.4zM14.32 11.52V21H18.8v1.12H14.32V24.4H21.6V11.52zM18.8 18.8H17.12v-5H18.8zM22.72 11.52V21H27.2v1.12H22.72V24.4H30V11.52zM27.2 18.8H25.52v-5H27.2z"
                }
              }
            ],
            "name": "logo--digg",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoDigg16",
          "filepath": "logo--digg/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.48 7.6v3.92H2V21H9.28V7.6zm0 11.2H4.8v-5H6.48zM10.4 11.52H13.2V21.04H10.4zM10.4 7.6H13.2V10.399999999999999H10.4zM14.32 11.52V21H18.8v1.12H14.32V24.4H21.6V11.52zM18.8 18.8H17.12v-5H18.8zM22.72 11.52V21H27.2v1.12H22.72V24.4H30V11.52zM27.2 18.8H25.52v-5H27.2z"
                }
              }
            ],
            "name": "logo--digg",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoDigg",
        "global": "LogoDigg",
        "filepath": "LogoDigg.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.48 7.6v3.92H2V21H9.28V7.6zm0 11.2H4.8v-5H6.48zM10.4 11.52H13.2V21.04H10.4zM10.4 7.6H13.2V10.399999999999999H10.4zM14.32 11.52V21H18.8v1.12H14.32V24.4H21.6V11.52zM18.8 18.8H17.12v-5H18.8zM22.72 11.52V21H27.2v1.12H22.72V24.4H30V11.52zM27.2 18.8H25.52v-5H27.2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--discord",
      "friendlyName": "Logo Discord",
      "aliases": [
        "brand",
        "emblem",
        "id",
        "symbol",
        "avatar",
        "tag",
        "social",
        "discord"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--discord.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5\n\tc0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5\n\tc0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3\n\tc0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1\n\tc0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1\n\tC25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\n\tC13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\n\tC23.2,18.6,22.1,19.9,20.7,19.9z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5\tc0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5\tc0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3\tc0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1\tc0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1\tC25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC23.2,18.6,22.1,19.9,20.7,19.9z\"/></svg>",
            "info": {},
            "path": "32/logo--discord.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoDiscord32",
          "filepath": "logo--discord/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5\tc0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5\tc0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3\tc0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1\tc0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1\tC25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC23.2,18.6,22.1,19.9,20.7,19.9z"
                }
              }
            ],
            "name": "logo--discord",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoDiscord24",
          "filepath": "logo--discord/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5\tc0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5\tc0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3\tc0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1\tc0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1\tC25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC23.2,18.6,22.1,19.9,20.7,19.9z"
                }
              }
            ],
            "name": "logo--discord",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoDiscord20",
          "filepath": "logo--discord/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5\tc0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5\tc0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3\tc0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1\tc0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1\tC25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC23.2,18.6,22.1,19.9,20.7,19.9z"
                }
              }
            ],
            "name": "logo--discord",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoDiscord16",
          "filepath": "logo--discord/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5\tc0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5\tc0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3\tc0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1\tc0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1\tC25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8\tC23.2,18.6,22.1,19.9,20.7,19.9z"
                }
              }
            ],
            "name": "logo--discord",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoDiscord",
        "global": "LogoDiscord",
        "filepath": "LogoDiscord.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5 c0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5 c0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3 c0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1 c0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1 C25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C23.2,18.6,22.1,19.9,20.7,19.9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--facebook",
      "friendlyName": "Logo Facebook",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--facebook.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--facebook</title><path d=\"M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z\"/></svg>",
            "info": {},
            "path": "32/logo--facebook.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoFacebook32",
          "filepath": "logo--facebook/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
                }
              }
            ],
            "name": "logo--facebook",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoFacebook24",
          "filepath": "logo--facebook/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
                }
              }
            ],
            "name": "logo--facebook",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoFacebook20",
          "filepath": "logo--facebook/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
                }
              }
            ],
            "name": "logo--facebook",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoFacebook16",
          "filepath": "logo--facebook/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
                }
              }
            ],
            "name": "logo--facebook",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoFacebook",
        "global": "LogoFacebook",
        "filepath": "LogoFacebook.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--figma",
      "friendlyName": "logo--figma",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--figma.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2\n\tc-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9\n\tC6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3\n\tc0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1\n\tc1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7\n\tc0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2\n\tc-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2\n\ts0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7\n\tc-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2\n\tc-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2\n\tc0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4\n\tc0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2\n\tc0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5\n\tL20.6,19.5z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2\tc-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9\tC6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3\tc0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1\tc1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7\tc0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2\tc-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2\ts0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7\tc-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2\tc-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2\tc0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4\tc0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2\tc0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5\tL20.6,19.5z\"/></svg>",
            "info": {},
            "path": "32/logo--figma.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoFigma32",
          "filepath": "logo--figma/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2\tc-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9\tC6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3\tc0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1\tc1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7\tc0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2\tc-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2\ts0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7\tc-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2\tc-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2\tc0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4\tc0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2\tc0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5\tL20.6,19.5z"
                }
              }
            ],
            "name": "logo--figma",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoFigma24",
          "filepath": "logo--figma/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2\tc-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9\tC6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3\tc0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1\tc1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7\tc0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2\tc-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2\ts0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7\tc-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2\tc-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2\tc0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4\tc0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2\tc0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5\tL20.6,19.5z"
                }
              }
            ],
            "name": "logo--figma",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoFigma20",
          "filepath": "logo--figma/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2\tc-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9\tC6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3\tc0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1\tc1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7\tc0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2\tc-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2\ts0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7\tc-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2\tc-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2\tc0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4\tc0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2\tc0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5\tL20.6,19.5z"
                }
              }
            ],
            "name": "logo--figma",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoFigma16",
          "filepath": "logo--figma/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2\tc-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9\tC6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3\tc0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1\tc1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7\tc0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2\tc-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2\ts0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7\tc-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2\tc-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2\tc0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4\tc0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2\tc0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5\tL20.6,19.5z"
                }
              }
            ],
            "name": "logo--figma",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoFigma",
        "global": "LogoFigma",
        "filepath": "LogoFigma.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2 c-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9 C6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3 c0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1 c1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7 c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2 c-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2 s0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7 c-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2 c-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2 c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4 c0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2 c0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5 L20.6,19.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--flickr",
      "friendlyName": "Logo Flickr",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--flickr.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--flickr</title><circle id=\"_Path_\" data-name=\"&lt;Path&gt;\" cx=\"8\" cy=\"16\" r=\"6\"/><circle id=\"_Path_2\" data-name=\"&lt;Path&gt;\" cx=\"24\" cy=\"16\" r=\"6\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"8\" cy=\"16\" r=\"6\"/><circle cx=\"24\" cy=\"16\" r=\"6\"/></svg>",
            "info": {},
            "path": "32/logo--flickr.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoFlickr32",
          "filepath": "logo--flickr/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "6"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "6"
                }
              }
            ],
            "name": "logo--flickr",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoFlickr24",
          "filepath": "logo--flickr/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "6"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "6"
                }
              }
            ],
            "name": "logo--flickr",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoFlickr20",
          "filepath": "logo--flickr/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "6"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "6"
                }
              }
            ],
            "name": "logo--flickr",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoFlickr16",
          "filepath": "logo--flickr/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "6"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "6"
                }
              }
            ],
            "name": "logo--flickr",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoFlickr",
        "global": "LogoFlickr",
        "filepath": "LogoFlickr.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "16",
                    "r": "6"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "16",
                    "r": "6"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--github",
      "friendlyName": "Logo GitHub",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--github.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill-rule:evenodd;}.cls-2{fill:none;}</style></defs><title>logo--github</title><path class=\"cls-1\" d=\"M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/logo--github.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoGithub32",
          "filepath": "logo--github/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "logo--github",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoGithub24",
          "filepath": "logo--github/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "logo--github",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoGithub20",
          "filepath": "logo--github/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "logo--github",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoGithub16",
          "filepath": "logo--github/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "logo--github",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoGithub",
        "global": "LogoGithub",
        "filepath": "LogoGithub.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--glassdoor",
      "friendlyName": "Logo Glassdoor",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--glassdoor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>logo--glassdoor</title><path class=\"cls-1\" d=\"M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z\"/><path class=\"cls-1\" d=\"M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z\"/><path d=\"M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z\"/></svg>",
            "info": {},
            "path": "32/logo--glassdoor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoGlassdoor32",
          "filepath": "logo--glassdoor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
                }
              }
            ],
            "name": "logo--glassdoor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoGlassdoor24",
          "filepath": "logo--glassdoor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
                }
              }
            ],
            "name": "logo--glassdoor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoGlassdoor20",
          "filepath": "logo--glassdoor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
                }
              }
            ],
            "name": "logo--glassdoor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoGlassdoor16",
          "filepath": "logo--glassdoor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
                }
              }
            ],
            "name": "logo--glassdoor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoGlassdoor",
        "global": "LogoGlassdoor",
        "filepath": "LogoGlassdoor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--instagram",
      "friendlyName": "Logo Instagram",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--instagram.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--instagram</title><circle cx=\"22.4056\" cy=\"9.5944\" r=\"1.44\"/><path d=\"M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z\"/><path d=\"M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22.406\" cy=\"9.594\" r=\"1.44\"/><path d=\"M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z\"/><path d=\"M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z\"/></svg>",
            "info": {},
            "path": "32/logo--instagram.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoInstagram32",
          "filepath": "logo--instagram/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.406",
                  "cy": "9.594",
                  "r": "1.44"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
                }
              }
            ],
            "name": "logo--instagram",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoInstagram24",
          "filepath": "logo--instagram/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.406",
                  "cy": "9.594",
                  "r": "1.44"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
                }
              }
            ],
            "name": "logo--instagram",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoInstagram20",
          "filepath": "logo--instagram/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.406",
                  "cy": "9.594",
                  "r": "1.44"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
                }
              }
            ],
            "name": "logo--instagram",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoInstagram16",
          "filepath": "logo--instagram/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.406",
                  "cy": "9.594",
                  "r": "1.44"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
                }
              }
            ],
            "name": "logo--instagram",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoInstagram",
        "global": "LogoInstagram",
        "filepath": "LogoInstagram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22.406",
                    "cy": "9.594",
                    "r": "1.44"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--invision",
      "friendlyName": "logo--invision",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--invision.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4\n\tC10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7\n\tc0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1\n\tl1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5\n\tl-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6\n\tc0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4\tC10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7\tc0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1\tl1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5\tl-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6\tc0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z\"/></svg>",
            "info": {},
            "path": "32/logo--invision.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoInvision32",
          "filepath": "logo--invision/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4\tC10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7\tc0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1\tl1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5\tl-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6\tc0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
                }
              }
            ],
            "name": "logo--invision",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoInvision24",
          "filepath": "logo--invision/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4\tC10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7\tc0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1\tl1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5\tl-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6\tc0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
                }
              }
            ],
            "name": "logo--invision",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoInvision20",
          "filepath": "logo--invision/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4\tC10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7\tc0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1\tl1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5\tl-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6\tc0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
                }
              }
            ],
            "name": "logo--invision",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoInvision16",
          "filepath": "logo--invision/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4\tC10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7\tc0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1\tl1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5\tl-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6\tc0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
                }
              }
            ],
            "name": "logo--invision",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoInvision",
        "global": "LogoInvision",
        "filepath": "LogoInvision.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4 C10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7 c0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1 l1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5 l-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6 c0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--jupyter",
      "friendlyName": "Logo Jupyter",
      "aliases": [
        "open source",
        "interactive",
        "programming",
        "application",
        "web",
        "development"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--jupyter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>logo--jupyter</title>\n  <g id=\"path\">\n    <g id=\"path16_fill\" data-name=\"path16 fill\">\n      <path id=\"path7_fill\" data-name=\"path7 fill\" d=\"M26.0766,3.5878a1.69,1.69,0,1,1-1.76-1.5853,1.67,1.67,0,0,1,1.76,1.5853Z\"/>\n    </g>\n  </g>\n  <g id=\"path-2\" data-name=\"path\">\n    <g id=\"path17_fill\" data-name=\"path17 fill\">\n      <path id=\"path8_fill\" data-name=\"path8 fill\" d=\"M16.2191,23.1113c-4.4866,0-8.43-1.61-10.4688-3.9882a11.1618,11.1618,0,0,0,20.9377,0C24.6541,21.5011,20.7257,23.1113,16.2191,23.1113Z\"/>\n    </g>\n  </g>\n  <g id=\"path-3\" data-name=\"path\">\n    <g id=\"path18_fill\" data-name=\"path18 fill\">\n      <path id=\"path9_fill\" data-name=\"path9 fill\" d=\"M16.2191,7.6483c4.4867,0,8.43,1.61,10.4689,3.9881a11.1618,11.1618,0,0,0-20.9377,0C7.7892,9.2535,11.7126,7.6483,16.2191,7.6483Z\"/>\n    </g>\n  </g>\n  <g id=\"path-4\" data-name=\"path\">\n    <g id=\"path19_fill\" data-name=\"path19 fill\">\n      <path id=\"path10_fill\" data-name=\"path10 fill\" d=\"M10.0427,27.7388a2.1085,2.1085,0,1,1-.2031-.7976,2.1278,2.1278,0,0,1,.2031.7976Z\"/>\n    </g>\n  </g>\n  <g id=\"path-5\" data-name=\"path\">\n    <g id=\"path20_fill\" data-name=\"path20 fill\">\n      <path id=\"path11_fill\" data-name=\"path11 fill\" d=\"M6.26,7.1064A1.2263,1.2263,0,1,1,7.4517,5.83,1.2415,1.2415,0,0,1,6.26,7.1064Z\"/>\n    </g>\n  </g>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.0766 3.5878a1.69 1.69 0 11-1.76-1.5853 1.67 1.67 0 011.76 1.5853zM16.2191 23.1113c-4.4866 0-8.43-1.61-10.4688-3.9882a11.1618 11.1618 0 0020.9377 0C24.6541 21.5011 20.7257 23.1113 16.2191 23.1113zM16.2191 7.6483c4.4867 0 8.43 1.61 10.4689 3.9881a11.1618 11.1618 0 00-20.9377 0C7.7892 9.2535 11.7126 7.6483 16.2191 7.6483zM10.0427 27.7388a2.1085 2.1085 0 11-.2031-.7976 2.1278 2.1278 0 01.2031.7976zM6.26 7.1064A1.2263 1.2263 0 117.4517 5.83 1.2415 1.2415 0 016.26 7.1064z\"/></svg>",
            "info": {},
            "path": "32/logo--jupyter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoJupyter32",
          "filepath": "logo--jupyter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0766 3.5878a1.69 1.69 0 11-1.76-1.5853 1.67 1.67 0 011.76 1.5853zM16.2191 23.1113c-4.4866 0-8.43-1.61-10.4688-3.9882a11.1618 11.1618 0 0020.9377 0C24.6541 21.5011 20.7257 23.1113 16.2191 23.1113zM16.2191 7.6483c4.4867 0 8.43 1.61 10.4689 3.9881a11.1618 11.1618 0 00-20.9377 0C7.7892 9.2535 11.7126 7.6483 16.2191 7.6483zM10.0427 27.7388a2.1085 2.1085 0 11-.2031-.7976 2.1278 2.1278 0 01.2031.7976zM6.26 7.1064A1.2263 1.2263 0 117.4517 5.83 1.2415 1.2415 0 016.26 7.1064z"
                }
              }
            ],
            "name": "logo--jupyter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoJupyter24",
          "filepath": "logo--jupyter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0766 3.5878a1.69 1.69 0 11-1.76-1.5853 1.67 1.67 0 011.76 1.5853zM16.2191 23.1113c-4.4866 0-8.43-1.61-10.4688-3.9882a11.1618 11.1618 0 0020.9377 0C24.6541 21.5011 20.7257 23.1113 16.2191 23.1113zM16.2191 7.6483c4.4867 0 8.43 1.61 10.4689 3.9881a11.1618 11.1618 0 00-20.9377 0C7.7892 9.2535 11.7126 7.6483 16.2191 7.6483zM10.0427 27.7388a2.1085 2.1085 0 11-.2031-.7976 2.1278 2.1278 0 01.2031.7976zM6.26 7.1064A1.2263 1.2263 0 117.4517 5.83 1.2415 1.2415 0 016.26 7.1064z"
                }
              }
            ],
            "name": "logo--jupyter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoJupyter20",
          "filepath": "logo--jupyter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0766 3.5878a1.69 1.69 0 11-1.76-1.5853 1.67 1.67 0 011.76 1.5853zM16.2191 23.1113c-4.4866 0-8.43-1.61-10.4688-3.9882a11.1618 11.1618 0 0020.9377 0C24.6541 21.5011 20.7257 23.1113 16.2191 23.1113zM16.2191 7.6483c4.4867 0 8.43 1.61 10.4689 3.9881a11.1618 11.1618 0 00-20.9377 0C7.7892 9.2535 11.7126 7.6483 16.2191 7.6483zM10.0427 27.7388a2.1085 2.1085 0 11-.2031-.7976 2.1278 2.1278 0 01.2031.7976zM6.26 7.1064A1.2263 1.2263 0 117.4517 5.83 1.2415 1.2415 0 016.26 7.1064z"
                }
              }
            ],
            "name": "logo--jupyter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoJupyter16",
          "filepath": "logo--jupyter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0766 3.5878a1.69 1.69 0 11-1.76-1.5853 1.67 1.67 0 011.76 1.5853zM16.2191 23.1113c-4.4866 0-8.43-1.61-10.4688-3.9882a11.1618 11.1618 0 0020.9377 0C24.6541 21.5011 20.7257 23.1113 16.2191 23.1113zM16.2191 7.6483c4.4867 0 8.43 1.61 10.4689 3.9881a11.1618 11.1618 0 00-20.9377 0C7.7892 9.2535 11.7126 7.6483 16.2191 7.6483zM10.0427 27.7388a2.1085 2.1085 0 11-.2031-.7976 2.1278 2.1278 0 01.2031.7976zM6.26 7.1064A1.2263 1.2263 0 117.4517 5.83 1.2415 1.2415 0 016.26 7.1064z"
                }
              }
            ],
            "name": "logo--jupyter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoJupyter",
        "global": "LogoJupyter",
        "filepath": "LogoJupyter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.0766 3.5878a1.69 1.69 0 11-1.76-1.5853 1.67 1.67 0 011.76 1.5853zM16.2191 23.1113c-4.4866 0-8.43-1.61-10.4688-3.9882a11.1618 11.1618 0 0020.9377 0C24.6541 21.5011 20.7257 23.1113 16.2191 23.1113zM16.2191 7.6483c4.4867 0 8.43 1.61 10.4689 3.9881a11.1618 11.1618 0 00-20.9377 0C7.7892 9.2535 11.7126 7.6483 16.2191 7.6483zM10.0427 27.7388a2.1085 2.1085 0 11-.2031-.7976 2.1278 2.1278 0 01.2031.7976zM6.26 7.1064A1.2263 1.2263 0 117.4517 5.83 1.2415 1.2415 0 016.26 7.1064z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--keybase",
      "friendlyName": "Logo keybase",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--keybase.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #2c2c2b;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_Path_\" data-name=\"&lt;Path&gt;\" class=\"cls-1\" d=\"M14.1233,26.9328a1.1122,1.1122,0,1,1-1.1121-1.1122,1.112,1.112,0,0,1,1.1121,1.1122\"/>\n  <path id=\"_Path_2\" data-name=\"&lt;Path&gt;\" class=\"cls-1\" d=\"M21.0257,26.9328a1.1122,1.1122,0,1,1-1.1122-1.1122,1.1121,1.1121,0,0,1,1.1122,1.1122\"/>\n  <rect class=\"cls-1\" x=\"9.9988\" y=\"5.7973\" width=\"0.9741\" height=\"0.9743\" transform=\"translate(3.5662 16.3625) rotate(-86.462)\"/>\n  <path class=\"cls-1\" d=\"M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z\"/>\n  <rect id=\"_Transparent_Rectangle\" data-name=\" Transparent Rectangle\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14.1233 26.9328a1.1122 1.1122 0 11-1.1121-1.1122 1.112 1.112 0 011.1121 1.1122M21.0257 26.9328a1.1122 1.1122 0 11-1.1122-1.1122 1.1121 1.1121 0 011.1122 1.1122\"/><path d=\"M9.999 5.797H10.973V6.771H9.999z\" transform=\"rotate(-86.462 10.486 6.284)\"/><path d=\"M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z\"/></svg>",
            "info": {},
            "path": "32/logo--keybase.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoKeybase32",
          "filepath": "logo--keybase/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.1233 26.9328a1.1122 1.1122 0 11-1.1121-1.1122 1.112 1.112 0 011.1121 1.1122M21.0257 26.9328a1.1122 1.1122 0 11-1.1122-1.1122 1.1121 1.1121 0 011.1122 1.1122"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.999 5.797H10.973V6.771H9.999z",
                  "transform": "rotate(-86.462 10.486 6.284)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
                }
              }
            ],
            "name": "logo--keybase",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoKeybase24",
          "filepath": "logo--keybase/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.1233 26.9328a1.1122 1.1122 0 11-1.1121-1.1122 1.112 1.112 0 011.1121 1.1122M21.0257 26.9328a1.1122 1.1122 0 11-1.1122-1.1122 1.1121 1.1121 0 011.1122 1.1122"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.999 5.797H10.973V6.771H9.999z",
                  "transform": "rotate(-86.462 10.486 6.284)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
                }
              }
            ],
            "name": "logo--keybase",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoKeybase20",
          "filepath": "logo--keybase/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.1233 26.9328a1.1122 1.1122 0 11-1.1121-1.1122 1.112 1.112 0 011.1121 1.1122M21.0257 26.9328a1.1122 1.1122 0 11-1.1122-1.1122 1.1121 1.1121 0 011.1122 1.1122"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.999 5.797H10.973V6.771H9.999z",
                  "transform": "rotate(-86.462 10.486 6.284)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
                }
              }
            ],
            "name": "logo--keybase",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoKeybase16",
          "filepath": "logo--keybase/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.1233 26.9328a1.1122 1.1122 0 11-1.1121-1.1122 1.112 1.112 0 011.1121 1.1122M21.0257 26.9328a1.1122 1.1122 0 11-1.1122-1.1122 1.1121 1.1121 0 011.1122 1.1122"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.999 5.797H10.973V6.771H9.999z",
                  "transform": "rotate(-86.462 10.486 6.284)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
                }
              }
            ],
            "name": "logo--keybase",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoKeybase",
        "global": "LogoKeybase",
        "filepath": "LogoKeybase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.1233 26.9328a1.1122 1.1122 0 11-1.1121-1.1122 1.112 1.112 0 011.1121 1.1122M21.0257 26.9328a1.1122 1.1122 0 11-1.1122-1.1122 1.1121 1.1121 0 011.1122 1.1122"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.999 5.797H10.973V6.771H9.999z",
                    "transform": "rotate(-86.462 10.486 6.284)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--kubernetes",
      "friendlyName": "Logo Kubernetes",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification",
        "Kubernetes",
        "container"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--kubernetes.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"15.134 17.189 15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189\"/>\n  <path d=\"M14.2166,13.88l.0024.0019a.5239.5239,0,0,0,.8321-.4013l0-.003.0127-.0063L15.242,10.33c-.2173.0268-.43.0635-.6333.1094a6.2,6.2,0,0,0-2.9727,1.6176l2.5752,1.8257Z\"/>\n  <path d=\"M12.8347,16.2622l.003-.001a.5241.5241,0,0,0,.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775,6.1775,0,0,0-.8746,3.9l3.0142-.87Z\"/>\n  <path d=\"M13.8645,18.501a.5229.5229,0,0,0-.6059-.3989l-.0034,0-.0049-.0063-3.0908.5249a6.2052,6.2052,0,0,0,2.4863,3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184,0,0,0,13.8645,18.501Z\"/>\n  <path d=\"M16.4622,19.6431l-.0015-.0025a.53.53,0,0,0-.48-.2759.5269.5269,0,0,0-.4434.2769l-.0015.0029H15.533l-1.52,2.7481a6.2277,6.2277,0,0,0,3.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534Z\"/>\n  <path d=\"M18.7371,18.09l-.0034,0a.51.51,0,0,0-.1206-.0088.5263.5263,0,0,0-.4546.7319l.001.0024-.004.0054,1.21,2.9234A6.185,6.185,0,0,0,21.86,18.61l-3.1176-.5269Z\"/>\n  <path d=\"M21.2893,13.2437,18.951,15.3364l.0014.0064-.0024.0019a.5249.5249,0,0,0,.2055.9014l.0035.0005.0024.0132,3.0293.872a6.2915,6.2915,0,0,0-.9014-3.8881Z\"/>\n  <path d=\"M16.9383,13.4673l0,.0029a.5161.5161,0,0,0,.1143.3037.5236.5236,0,0,0,.7192.0967l.0025-.0019.0088.0039,2.5586-1.814a6.2307,6.2307,0,0,0-3.584-1.7285l.1777,3.1357Z\"/>\n  <path d=\"M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189zM14.2166 13.88l.0024.0019a.5239.5239 0 00.8321-.4013l0-.003.0127-.0063L15.242 10.33c-.2173.0268-.43.0635-.6333.1094a6.2 6.2 0 00-2.9727 1.6176l2.5752 1.8257zM12.8347 16.2622l.003-.001a.5241.5241 0 00.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775 6.1775 0 00-.8746 3.9l3.0142-.87zM13.8645 18.501a.5229.5229 0 00-.6059-.3989l-.0034 0-.0049-.0063-3.0908.5249a6.2052 6.2052 0 002.4863 3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184 0 0013.8645 18.501zM16.4622 19.6431l-.0015-.0025a.53.53 0 00-.48-.2759.5269.5269 0 00-.4434.2769l-.0015.0029H15.533l-1.52 2.7481a6.2277 6.2277 0 003.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534zM18.7371 18.09l-.0034 0a.51.51 0 00-.1206-.0088.5263.5263 0 00-.4546.7319l.001.0024-.004.0054 1.21 2.9234A6.185 6.185 0 0021.86 18.61l-3.1176-.5269zM21.2893 13.2437L18.951 15.3364l.0014.0064-.0024.0019a.5249.5249 0 00.2055.9014l.0035.0005.0024.0132 3.0293.872a6.2915 6.2915 0 00-.9014-3.8881zM16.9383 13.4673l0 .0029a.5161.5161 0 00.1143.3037.5236.5236 0 00.7192.0967l.0025-.0019.0088.0039 2.5586-1.814a6.2307 6.2307 0 00-3.584-1.7285l.1777 3.1357z\"/><path d=\"M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z\"/></svg>",
            "info": {},
            "path": "32/logo--kubernetes.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoKubernetes32",
          "filepath": "logo--kubernetes/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189zM14.2166 13.88l.0024.0019a.5239.5239 0 00.8321-.4013l0-.003.0127-.0063L15.242 10.33c-.2173.0268-.43.0635-.6333.1094a6.2 6.2 0 00-2.9727 1.6176l2.5752 1.8257zM12.8347 16.2622l.003-.001a.5241.5241 0 00.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775 6.1775 0 00-.8746 3.9l3.0142-.87zM13.8645 18.501a.5229.5229 0 00-.6059-.3989l-.0034 0-.0049-.0063-3.0908.5249a6.2052 6.2052 0 002.4863 3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184 0 0013.8645 18.501zM16.4622 19.6431l-.0015-.0025a.53.53 0 00-.48-.2759.5269.5269 0 00-.4434.2769l-.0015.0029H15.533l-1.52 2.7481a6.2277 6.2277 0 003.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534zM18.7371 18.09l-.0034 0a.51.51 0 00-.1206-.0088.5263.5263 0 00-.4546.7319l.001.0024-.004.0054 1.21 2.9234A6.185 6.185 0 0021.86 18.61l-3.1176-.5269zM21.2893 13.2437L18.951 15.3364l.0014.0064-.0024.0019a.5249.5249 0 00.2055.9014l.0035.0005.0024.0132 3.0293.872a6.2915 6.2915 0 00-.9014-3.8881zM16.9383 13.4673l0 .0029a.5161.5161 0 00.1143.3037.5236.5236 0 00.7192.0967l.0025-.0019.0088.0039 2.5586-1.814a6.2307 6.2307 0 00-3.584-1.7285l.1777 3.1357z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
                }
              }
            ],
            "name": "logo--kubernetes",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoKubernetes24",
          "filepath": "logo--kubernetes/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189zM14.2166 13.88l.0024.0019a.5239.5239 0 00.8321-.4013l0-.003.0127-.0063L15.242 10.33c-.2173.0268-.43.0635-.6333.1094a6.2 6.2 0 00-2.9727 1.6176l2.5752 1.8257zM12.8347 16.2622l.003-.001a.5241.5241 0 00.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775 6.1775 0 00-.8746 3.9l3.0142-.87zM13.8645 18.501a.5229.5229 0 00-.6059-.3989l-.0034 0-.0049-.0063-3.0908.5249a6.2052 6.2052 0 002.4863 3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184 0 0013.8645 18.501zM16.4622 19.6431l-.0015-.0025a.53.53 0 00-.48-.2759.5269.5269 0 00-.4434.2769l-.0015.0029H15.533l-1.52 2.7481a6.2277 6.2277 0 003.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534zM18.7371 18.09l-.0034 0a.51.51 0 00-.1206-.0088.5263.5263 0 00-.4546.7319l.001.0024-.004.0054 1.21 2.9234A6.185 6.185 0 0021.86 18.61l-3.1176-.5269zM21.2893 13.2437L18.951 15.3364l.0014.0064-.0024.0019a.5249.5249 0 00.2055.9014l.0035.0005.0024.0132 3.0293.872a6.2915 6.2915 0 00-.9014-3.8881zM16.9383 13.4673l0 .0029a.5161.5161 0 00.1143.3037.5236.5236 0 00.7192.0967l.0025-.0019.0088.0039 2.5586-1.814a6.2307 6.2307 0 00-3.584-1.7285l.1777 3.1357z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
                }
              }
            ],
            "name": "logo--kubernetes",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoKubernetes20",
          "filepath": "logo--kubernetes/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189zM14.2166 13.88l.0024.0019a.5239.5239 0 00.8321-.4013l0-.003.0127-.0063L15.242 10.33c-.2173.0268-.43.0635-.6333.1094a6.2 6.2 0 00-2.9727 1.6176l2.5752 1.8257zM12.8347 16.2622l.003-.001a.5241.5241 0 00.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775 6.1775 0 00-.8746 3.9l3.0142-.87zM13.8645 18.501a.5229.5229 0 00-.6059-.3989l-.0034 0-.0049-.0063-3.0908.5249a6.2052 6.2052 0 002.4863 3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184 0 0013.8645 18.501zM16.4622 19.6431l-.0015-.0025a.53.53 0 00-.48-.2759.5269.5269 0 00-.4434.2769l-.0015.0029H15.533l-1.52 2.7481a6.2277 6.2277 0 003.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534zM18.7371 18.09l-.0034 0a.51.51 0 00-.1206-.0088.5263.5263 0 00-.4546.7319l.001.0024-.004.0054 1.21 2.9234A6.185 6.185 0 0021.86 18.61l-3.1176-.5269zM21.2893 13.2437L18.951 15.3364l.0014.0064-.0024.0019a.5249.5249 0 00.2055.9014l.0035.0005.0024.0132 3.0293.872a6.2915 6.2915 0 00-.9014-3.8881zM16.9383 13.4673l0 .0029a.5161.5161 0 00.1143.3037.5236.5236 0 00.7192.0967l.0025-.0019.0088.0039 2.5586-1.814a6.2307 6.2307 0 00-3.584-1.7285l.1777 3.1357z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
                }
              }
            ],
            "name": "logo--kubernetes",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoKubernetes16",
          "filepath": "logo--kubernetes/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189zM14.2166 13.88l.0024.0019a.5239.5239 0 00.8321-.4013l0-.003.0127-.0063L15.242 10.33c-.2173.0268-.43.0635-.6333.1094a6.2 6.2 0 00-2.9727 1.6176l2.5752 1.8257zM12.8347 16.2622l.003-.001a.5241.5241 0 00.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775 6.1775 0 00-.8746 3.9l3.0142-.87zM13.8645 18.501a.5229.5229 0 00-.6059-.3989l-.0034 0-.0049-.0063-3.0908.5249a6.2052 6.2052 0 002.4863 3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184 0 0013.8645 18.501zM16.4622 19.6431l-.0015-.0025a.53.53 0 00-.48-.2759.5269.5269 0 00-.4434.2769l-.0015.0029H15.533l-1.52 2.7481a6.2277 6.2277 0 003.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534zM18.7371 18.09l-.0034 0a.51.51 0 00-.1206-.0088.5263.5263 0 00-.4546.7319l.001.0024-.004.0054 1.21 2.9234A6.185 6.185 0 0021.86 18.61l-3.1176-.5269zM21.2893 13.2437L18.951 15.3364l.0014.0064-.0024.0019a.5249.5249 0 00.2055.9014l.0035.0005.0024.0132 3.0293.872a6.2915 6.2915 0 00-.9014-3.8881zM16.9383 13.4673l0 .0029a.5161.5161 0 00.1143.3037.5236.5236 0 00.7192.0967l.0025-.0019.0088.0039 2.5586-1.814a6.2307 6.2307 0 00-3.584-1.7285l.1777 3.1357z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
                }
              }
            ],
            "name": "logo--kubernetes",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoKubernetes",
        "global": "LogoKubernetes",
        "filepath": "LogoKubernetes.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189zM14.2166 13.88l.0024.0019a.5239.5239 0 00.8321-.4013l0-.003.0127-.0063L15.242 10.33c-.2173.0268-.43.0635-.6333.1094a6.2 6.2 0 00-2.9727 1.6176l2.5752 1.8257zM12.8347 16.2622l.003-.001a.5241.5241 0 00.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775 6.1775 0 00-.8746 3.9l3.0142-.87zM13.8645 18.501a.5229.5229 0 00-.6059-.3989l-.0034 0-.0049-.0063-3.0908.5249a6.2052 6.2052 0 002.4863 3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184 0 0013.8645 18.501zM16.4622 19.6431l-.0015-.0025a.53.53 0 00-.48-.2759.5269.5269 0 00-.4434.2769l-.0015.0029H15.533l-1.52 2.7481a6.2277 6.2277 0 003.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534zM18.7371 18.09l-.0034 0a.51.51 0 00-.1206-.0088.5263.5263 0 00-.4546.7319l.001.0024-.004.0054 1.21 2.9234A6.185 6.185 0 0021.86 18.61l-3.1176-.5269zM21.2893 13.2437L18.951 15.3364l.0014.0064-.0024.0019a.5249.5249 0 00.2055.9014l.0035.0005.0024.0132 3.0293.872a6.2915 6.2915 0 00-.9014-3.8881zM16.9383 13.4673l0 .0029a.5161.5161 0 00.1143.3037.5236.5236 0 00.7192.0967l.0025-.0019.0088.0039 2.5586-1.814a6.2307 6.2307 0 00-3.584-1.7285l.1777 3.1357z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--linkedin",
      "friendlyName": "Logo LinkedIn",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--linkedin.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.2.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4\n\tH7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3\n\tH21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z\n\t\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4\tH7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3\tH21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z\"/></svg>",
            "info": {},
            "path": "32/logo--linkedin.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoLinkedin32",
          "filepath": "logo--linkedin/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4\tH7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3\tH21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
                }
              }
            ],
            "name": "logo--linkedin",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoLinkedin24",
          "filepath": "logo--linkedin/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4\tH7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3\tH21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
                }
              }
            ],
            "name": "logo--linkedin",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoLinkedin20",
          "filepath": "logo--linkedin/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4\tH7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3\tH21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
                }
              }
            ],
            "name": "logo--linkedin",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoLinkedin16",
          "filepath": "logo--linkedin/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4\tH7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3\tH21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
                }
              }
            ],
            "name": "logo--linkedin",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoLinkedin",
        "global": "LogoLinkedin",
        "filepath": "LogoLinkedin.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4 H7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3 H21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--livestream",
      "friendlyName": "Logo Livestream",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--livestream.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--livestream</title><path d=\"M22.49,23.71h-.76c-2.26,0-4.52,0-6.78,0a3.12,3.12,0,0,1-2.41-1A14.91,14.91,0,0,1,10,18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84,7.84,0,0,0,2,5.6c1.24,0,2.41,0,3.57,0a45.63,45.63,0,0,1,7,.61,8.09,8.09,0,0,1,6.34,5.09,48.51,48.51,0,0,1,2.17,7.36A26,26,0,0,0,22.49,23.71Z\"/><path d=\"M28.1,26.38a2.93,2.93,0,0,1-2.74-2.64,42.08,42.08,0,0,1-.14-4.9,48,48,0,0,0-.61-7.58,3.75,3.75,0,0,0-.83-2h2.65c.54,0,.73.37.89.78A12.1,12.1,0,0,1,28,13.28c.29,2.72.31,5.45.33,8.18a10.94,10.94,0,0,0,0,1.15c.09.78.4,1.1,1.17,1.08.5,0,.5-.06.5-.06v2.69A8.62,8.62,0,0,1,28.1,26.38Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.49 23.71h-.76c-2.26 0-4.52 0-6.78 0a3.12 3.12 0 01-2.41-1A14.91 14.91 0 0110 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 002 5.6c1.24 0 2.41 0 3.57 0a45.63 45.63 0 017 .61 8.09 8.09 0 016.34 5.09 48.51 48.51 0 012.17 7.36A26 26 0 0022.49 23.71zM28.1 26.38a2.93 2.93 0 01-2.74-2.64 42.08 42.08 0 01-.14-4.9 48 48 0 00-.61-7.58 3.75 3.75 0 00-.83-2h2.65c.54 0 .73.37.89.78A12.1 12.1 0 0128 13.28c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 000 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69A8.62 8.62 0 0128.1 26.38z\"/></svg>",
            "info": {},
            "path": "32/logo--livestream.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoLivestream32",
          "filepath": "logo--livestream/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.49 23.71h-.76c-2.26 0-4.52 0-6.78 0a3.12 3.12 0 01-2.41-1A14.91 14.91 0 0110 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 002 5.6c1.24 0 2.41 0 3.57 0a45.63 45.63 0 017 .61 8.09 8.09 0 016.34 5.09 48.51 48.51 0 012.17 7.36A26 26 0 0022.49 23.71zM28.1 26.38a2.93 2.93 0 01-2.74-2.64 42.08 42.08 0 01-.14-4.9 48 48 0 00-.61-7.58 3.75 3.75 0 00-.83-2h2.65c.54 0 .73.37.89.78A12.1 12.1 0 0128 13.28c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 000 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69A8.62 8.62 0 0128.1 26.38z"
                }
              }
            ],
            "name": "logo--livestream",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoLivestream24",
          "filepath": "logo--livestream/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.49 23.71h-.76c-2.26 0-4.52 0-6.78 0a3.12 3.12 0 01-2.41-1A14.91 14.91 0 0110 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 002 5.6c1.24 0 2.41 0 3.57 0a45.63 45.63 0 017 .61 8.09 8.09 0 016.34 5.09 48.51 48.51 0 012.17 7.36A26 26 0 0022.49 23.71zM28.1 26.38a2.93 2.93 0 01-2.74-2.64 42.08 42.08 0 01-.14-4.9 48 48 0 00-.61-7.58 3.75 3.75 0 00-.83-2h2.65c.54 0 .73.37.89.78A12.1 12.1 0 0128 13.28c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 000 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69A8.62 8.62 0 0128.1 26.38z"
                }
              }
            ],
            "name": "logo--livestream",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoLivestream20",
          "filepath": "logo--livestream/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.49 23.71h-.76c-2.26 0-4.52 0-6.78 0a3.12 3.12 0 01-2.41-1A14.91 14.91 0 0110 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 002 5.6c1.24 0 2.41 0 3.57 0a45.63 45.63 0 017 .61 8.09 8.09 0 016.34 5.09 48.51 48.51 0 012.17 7.36A26 26 0 0022.49 23.71zM28.1 26.38a2.93 2.93 0 01-2.74-2.64 42.08 42.08 0 01-.14-4.9 48 48 0 00-.61-7.58 3.75 3.75 0 00-.83-2h2.65c.54 0 .73.37.89.78A12.1 12.1 0 0128 13.28c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 000 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69A8.62 8.62 0 0128.1 26.38z"
                }
              }
            ],
            "name": "logo--livestream",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoLivestream16",
          "filepath": "logo--livestream/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.49 23.71h-.76c-2.26 0-4.52 0-6.78 0a3.12 3.12 0 01-2.41-1A14.91 14.91 0 0110 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 002 5.6c1.24 0 2.41 0 3.57 0a45.63 45.63 0 017 .61 8.09 8.09 0 016.34 5.09 48.51 48.51 0 012.17 7.36A26 26 0 0022.49 23.71zM28.1 26.38a2.93 2.93 0 01-2.74-2.64 42.08 42.08 0 01-.14-4.9 48 48 0 00-.61-7.58 3.75 3.75 0 00-.83-2h2.65c.54 0 .73.37.89.78A12.1 12.1 0 0128 13.28c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 000 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69A8.62 8.62 0 0128.1 26.38z"
                }
              }
            ],
            "name": "logo--livestream",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoLivestream",
        "global": "LogoLivestream",
        "filepath": "LogoLivestream.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.49 23.71h-.76c-2.26 0-4.52 0-6.78 0a3.12 3.12 0 01-2.41-1A14.91 14.91 0 0110 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 002 5.6c1.24 0 2.41 0 3.57 0a45.63 45.63 0 017 .61 8.09 8.09 0 016.34 5.09 48.51 48.51 0 012.17 7.36A26 26 0 0022.49 23.71zM28.1 26.38a2.93 2.93 0 01-2.74-2.64 42.08 42.08 0 01-.14-4.9 48 48 0 00-.61-7.58 3.75 3.75 0 00-.83-2h2.65c.54 0 .73.37.89.78A12.1 12.1 0 0128 13.28c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 000 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69A8.62 8.62 0 0128.1 26.38z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--medium",
      "friendlyName": "Logo Medium",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--medium.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M30,16c0,3.7-0.6,6.7-1.4,6.7c-0.8,0-1.4-3-1.4-6.7s0.6-6.7,1.4-6.7C29.4,9.3,30,12.3,30,16\"/>\n<path d=\"M26.5,16c0,4.1-1.8,7.5-3.9,7.5s-3.9-3.4-3.9-7.5s1.8-7.5,3.9-7.5S26.5,11.9,26.5,16\"/>\n<path d=\"M17.8,16c0,4.4-3.5,8-7.9,8S2,20.4,2,16s3.5-8,7.9-8S17.8,11.6,17.8,16\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__155_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 16c0 3.7-.6 6.7-1.4 6.7-.8 0-1.4-3-1.4-6.7s.6-6.7 1.4-6.7C29.4 9.3 30 12.3 30 16M26.5 16c0 4.1-1.8 7.5-3.9 7.5s-3.9-3.4-3.9-7.5 1.8-7.5 3.9-7.5S26.5 11.9 26.5 16M17.8 16c0 4.4-3.5 8-7.9 8S2 20.4 2 16s3.5-8 7.9-8S17.8 11.6 17.8 16\"/></svg>",
            "info": {},
            "path": "32/logo--medium.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoMedium32",
          "filepath": "logo--medium/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16c0 3.7-.6 6.7-1.4 6.7-.8 0-1.4-3-1.4-6.7s.6-6.7 1.4-6.7C29.4 9.3 30 12.3 30 16M26.5 16c0 4.1-1.8 7.5-3.9 7.5s-3.9-3.4-3.9-7.5 1.8-7.5 3.9-7.5S26.5 11.9 26.5 16M17.8 16c0 4.4-3.5 8-7.9 8S2 20.4 2 16s3.5-8 7.9-8S17.8 11.6 17.8 16"
                }
              }
            ],
            "name": "logo--medium",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoMedium24",
          "filepath": "logo--medium/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16c0 3.7-.6 6.7-1.4 6.7-.8 0-1.4-3-1.4-6.7s.6-6.7 1.4-6.7C29.4 9.3 30 12.3 30 16M26.5 16c0 4.1-1.8 7.5-3.9 7.5s-3.9-3.4-3.9-7.5 1.8-7.5 3.9-7.5S26.5 11.9 26.5 16M17.8 16c0 4.4-3.5 8-7.9 8S2 20.4 2 16s3.5-8 7.9-8S17.8 11.6 17.8 16"
                }
              }
            ],
            "name": "logo--medium",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoMedium20",
          "filepath": "logo--medium/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16c0 3.7-.6 6.7-1.4 6.7-.8 0-1.4-3-1.4-6.7s.6-6.7 1.4-6.7C29.4 9.3 30 12.3 30 16M26.5 16c0 4.1-1.8 7.5-3.9 7.5s-3.9-3.4-3.9-7.5 1.8-7.5 3.9-7.5S26.5 11.9 26.5 16M17.8 16c0 4.4-3.5 8-7.9 8S2 20.4 2 16s3.5-8 7.9-8S17.8 11.6 17.8 16"
                }
              }
            ],
            "name": "logo--medium",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoMedium16",
          "filepath": "logo--medium/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16c0 3.7-.6 6.7-1.4 6.7-.8 0-1.4-3-1.4-6.7s.6-6.7 1.4-6.7C29.4 9.3 30 12.3 30 16M26.5 16c0 4.1-1.8 7.5-3.9 7.5s-3.9-3.4-3.9-7.5 1.8-7.5 3.9-7.5S26.5 11.9 26.5 16M17.8 16c0 4.4-3.5 8-7.9 8S2 20.4 2 16s3.5-8 7.9-8S17.8 11.6 17.8 16"
                }
              }
            ],
            "name": "logo--medium",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoMedium",
        "global": "LogoMedium",
        "filepath": "LogoMedium.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 16c0 3.7-.6 6.7-1.4 6.7-.8 0-1.4-3-1.4-6.7s.6-6.7 1.4-6.7C29.4 9.3 30 12.3 30 16M26.5 16c0 4.1-1.8 7.5-3.9 7.5s-3.9-3.4-3.9-7.5 1.8-7.5 3.9-7.5S26.5 11.9 26.5 16M17.8 16c0 4.4-3.5 8-7.9 8S2 20.4 2 16s3.5-8 7.9-8S17.8 11.6 17.8 16"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--npm",
      "friendlyName": "logo--npm",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--npm.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z\"/></svg>",
            "info": {},
            "path": "32/logo--npm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoNpm32",
          "filepath": "logo--npm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
                }
              }
            ],
            "name": "logo--npm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoNpm24",
          "filepath": "logo--npm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
                }
              }
            ],
            "name": "logo--npm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoNpm20",
          "filepath": "logo--npm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
                }
              }
            ],
            "name": "logo--npm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoNpm16",
          "filepath": "logo--npm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
                }
              }
            ],
            "name": "logo--npm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoNpm",
        "global": "LogoNpm",
        "filepath": "LogoNpm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--openshift",
      "friendlyName": "Logo OpenShift®",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--openshift.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--openshift</title><path d=\"M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z\"/></svg>",
            "info": {},
            "path": "32/logo--openshift.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoOpenshift32",
          "filepath": "logo--openshift/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
                }
              }
            ],
            "name": "logo--openshift",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoOpenshift24",
          "filepath": "logo--openshift/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
                }
              }
            ],
            "name": "logo--openshift",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoOpenshift20",
          "filepath": "logo--openshift/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
                }
              }
            ],
            "name": "logo--openshift",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoOpenshift16",
          "filepath": "logo--openshift/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
                }
              }
            ],
            "name": "logo--openshift",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoOpenshift",
        "global": "LogoOpenshift",
        "filepath": "LogoOpenshift.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--pinterest",
      "friendlyName": "Logo Pinterest",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--pinterest.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--pinterest</title><path id=\"_Path_\" data-name=\"&lt;Path&gt;\" d=\"M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2\"/></svg>",
            "info": {},
            "path": "32/logo--pinterest.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoPinterest32",
          "filepath": "logo--pinterest/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
                }
              }
            ],
            "name": "logo--pinterest",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoPinterest24",
          "filepath": "logo--pinterest/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
                }
              }
            ],
            "name": "logo--pinterest",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoPinterest20",
          "filepath": "logo--pinterest/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
                }
              }
            ],
            "name": "logo--pinterest",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoPinterest16",
          "filepath": "logo--pinterest/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
                }
              }
            ],
            "name": "logo--pinterest",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoPinterest",
        "global": "LogoPinterest",
        "filepath": "LogoPinterest.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--python",
      "friendlyName": "Logo Python",
      "aliases": [
        "python",
        "programming",
        "language",
        "logotype",
        "brand",
        "emblem",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--python.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>logo--python</title>\n  <path id=\"compound_path\" data-name=\"compound path\" d=\"M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z\" transform=\"translate(0 0)\"/>\n  <path id=\"inner_path\" data-name=\"inner path\" class=\"cls-1\" d=\"M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z\" transform=\"translate(0 0)\"/>\n  <path id=\"compound_path-2\" data-name=\"compound path\" d=\"M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z\" transform=\"translate(0 0)\"/>\n  <path id=\"inner_path-2\" data-name=\"inner path\" class=\"cls-1\" d=\"M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z\"/><path fill=\"none\" d=\"M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z\"/><path d=\"M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z\"/><path fill=\"none\" d=\"M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z\"/></svg>",
            "info": {},
            "path": "32/logo--python.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoPython32",
          "filepath": "logo--python/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              }
            ],
            "name": "logo--python",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoPython24",
          "filepath": "logo--python/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              }
            ],
            "name": "logo--python",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoPython20",
          "filepath": "logo--python/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              }
            ],
            "name": "logo--python",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoPython16",
          "filepath": "logo--python/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                }
              }
            ],
            "name": "logo--python",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoPython",
        "global": "LogoPython",
        "filepath": "LogoPython.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--quora",
      "friendlyName": "Logo Quora",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--quora.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--quora</title><path id=\"_Compound_Path_\" data-name=\"&lt;Compound Path&gt;\" d=\"M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z\"/></svg>",
            "info": {},
            "path": "32/logo--quora.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoQuora32",
          "filepath": "logo--quora/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
                }
              }
            ],
            "name": "logo--quora",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoQuora24",
          "filepath": "logo--quora/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
                }
              }
            ],
            "name": "logo--quora",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoQuora20",
          "filepath": "logo--quora/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
                }
              }
            ],
            "name": "logo--quora",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoQuora16",
          "filepath": "logo--quora/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
                }
              }
            ],
            "name": "logo--quora",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoQuora",
        "global": "LogoQuora",
        "filepath": "LogoQuora.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--r-script",
      "friendlyName": "Logo R script",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--r-script.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>logo--r-script</title>\n  <path class=\"cls-1\" d=\"M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z\"/></svg>",
            "info": {},
            "path": "32/logo--r-script.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoRScript32",
          "filepath": "logo--r-script/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
                }
              }
            ],
            "name": "logo--r-script",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoRScript24",
          "filepath": "logo--r-script/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
                }
              }
            ],
            "name": "logo--r-script",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoRScript20",
          "filepath": "logo--r-script/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
                }
              }
            ],
            "name": "logo--r-script",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoRScript16",
          "filepath": "logo--r-script/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
                }
              }
            ],
            "name": "logo--r-script",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoRScript",
        "global": "LogoRScript",
        "filepath": "LogoRScript.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--react",
      "friendlyName": "logo--react",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--react.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1\n\tc-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9\n\tc-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1\n\tc-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2\n\tc1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9\n\tc2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3\n\tC17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4\n\tC9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4\n\tC10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1\n\tc0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2\n\tc-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9\n\tc0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6\n\tc-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3\n\tc0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4\n\tc-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6\n\tc-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3\n\tC8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1\n\tc-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7\n\tc-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7\n\tc-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7\n\tC23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5\n\tc0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z\"/>\n<path d=\"M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3\n\tc-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1\n\tc0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1\tc-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9\tc-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1\tc-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2\tc1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9\tc2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3\tC17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4\tC9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4\tC10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1\tc0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2\tc-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9\tc0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6\tc-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3\tc0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4\tc-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6\tc-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3\tC8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1\tc-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7\tc-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7\tc-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7\tC23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5\tc0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z\"/><path d=\"M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3\tc-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1\tc0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z\"/></svg>",
            "info": {},
            "path": "32/logo--react.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoReact32",
          "filepath": "logo--react/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1\tc-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9\tc-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1\tc-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2\tc1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9\tc2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3\tC17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4\tC9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4\tC10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1\tc0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2\tc-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9\tc0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6\tc-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3\tc0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4\tc-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6\tc-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3\tC8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1\tc-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7\tc-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7\tc-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7\tC23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5\tc0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3\tc-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1\tc0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
                }
              }
            ],
            "name": "logo--react",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoReact24",
          "filepath": "logo--react/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1\tc-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9\tc-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1\tc-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2\tc1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9\tc2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3\tC17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4\tC9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4\tC10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1\tc0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2\tc-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9\tc0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6\tc-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3\tc0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4\tc-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6\tc-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3\tC8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1\tc-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7\tc-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7\tc-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7\tC23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5\tc0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3\tc-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1\tc0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
                }
              }
            ],
            "name": "logo--react",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoReact20",
          "filepath": "logo--react/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1\tc-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9\tc-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1\tc-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2\tc1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9\tc2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3\tC17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4\tC9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4\tC10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1\tc0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2\tc-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9\tc0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6\tc-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3\tc0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4\tc-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6\tc-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3\tC8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1\tc-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7\tc-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7\tc-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7\tC23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5\tc0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3\tc-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1\tc0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
                }
              }
            ],
            "name": "logo--react",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoReact16",
          "filepath": "logo--react/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1\tc-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9\tc-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1\tc-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2\tc1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9\tc2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3\tC17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4\tC9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4\tC10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1\tc0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2\tc-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9\tc0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6\tc-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3\tc0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4\tc-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6\tc-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3\tC8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1\tc-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7\tc-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7\tc-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7\tC23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5\tc0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3\tc-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1\tc0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
                }
              }
            ],
            "name": "logo--react",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoReact",
        "global": "LogoReact",
        "filepath": "LogoReact.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1 c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9 c-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1 c-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2 c1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9 c2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3 C17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4 C9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4 C10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1 c0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2 c-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9 c0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6 c-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3 c0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4 c-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6 c-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3 C8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1 c-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7 c-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7 c-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7 C23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5 c0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3 c-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--red-hat-ansible",
      "friendlyName": "logo--red-hat-ansible",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--red-hat-ansible.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z\"/>\n  <path d=\"M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z\"/><path d=\"M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z\"/></svg>",
            "info": {},
            "path": "32/logo--red-hat-ansible.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoRedHatAnsible32",
          "filepath": "logo--red-hat-ansible/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "logo--red-hat-ansible",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoRedHatAnsible24",
          "filepath": "logo--red-hat-ansible/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "logo--red-hat-ansible",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoRedHatAnsible20",
          "filepath": "logo--red-hat-ansible/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "logo--red-hat-ansible",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoRedHatAnsible16",
          "filepath": "logo--red-hat-ansible/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z"
                }
              }
            ],
            "name": "logo--red-hat-ansible",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoRedHatAnsible",
        "global": "LogoRedHatAnsible",
        "filepath": "LogoRedHatAnsible.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--sketch",
      "friendlyName": "logo--sketch",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--sketch.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0\n\tl-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0\n\tc0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1\n\tc-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0\n\tl0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1\n\tc0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9\n\tc0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2\n\tc0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6\n\tc-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2\n\tc-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0\tl-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0\tc0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1\tc-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0\tl0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1\tc0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9\tc0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2\tc0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6\tc-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2\tc-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z\"/></svg>",
            "info": {},
            "path": "32/logo--sketch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoSketch32",
          "filepath": "logo--sketch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0\tl-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0\tc0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1\tc-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0\tl0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1\tc0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9\tc0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2\tc0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6\tc-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2\tc-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z"
                }
              }
            ],
            "name": "logo--sketch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoSketch24",
          "filepath": "logo--sketch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0\tl-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0\tc0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1\tc-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0\tl0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1\tc0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9\tc0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2\tc0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6\tc-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2\tc-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z"
                }
              }
            ],
            "name": "logo--sketch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoSketch20",
          "filepath": "logo--sketch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0\tl-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0\tc0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1\tc-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0\tl0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1\tc0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9\tc0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2\tc0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6\tc-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2\tc-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z"
                }
              }
            ],
            "name": "logo--sketch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoSketch16",
          "filepath": "logo--sketch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0\tl-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0\tc0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1\tc-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0\tl0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1\tc0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9\tc0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2\tc0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6\tc-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2\tc-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z"
                }
              }
            ],
            "name": "logo--sketch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoSketch",
        "global": "LogoSketch",
        "filepath": "LogoSketch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0 l-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0 c0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1 c-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0 l0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1 c0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9 c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2 c0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6 c-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--skype",
      "friendlyName": "Logo Skype",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--skype.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--skype</title><path d=\"M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z\"/></svg>",
            "info": {},
            "path": "32/logo--skype.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoSkype32",
          "filepath": "logo--skype/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z"
                }
              }
            ],
            "name": "logo--skype",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoSkype24",
          "filepath": "logo--skype/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z"
                }
              }
            ],
            "name": "logo--skype",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoSkype20",
          "filepath": "logo--skype/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z"
                }
              }
            ],
            "name": "logo--skype",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoSkype16",
          "filepath": "logo--skype/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z"
                }
              }
            ],
            "name": "logo--skype",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoSkype",
        "global": "LogoSkype",
        "filepath": "LogoSkype.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--slack",
      "friendlyName": "Logo Slack",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--slack.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--slack</title><path d=\"M9.0423,19.1661A2.5212,2.5212,0,1,1,6.5212,16.645H9.0423Z\"/><path d=\"M10.3127,19.1661a2.5212,2.5212,0,0,1,5.0423,0v6.3127a2.5212,2.5212,0,1,1-5.0423,0Z\"/><path d=\"M12.8339,9.0423A2.5212,2.5212,0,1,1,15.355,6.5212V9.0423Z\"/><path d=\"M12.8339,10.3127a2.5212,2.5212,0,0,1,0,5.0423H6.5212a2.5212,2.5212,0,1,1,0-5.0423Z\"/><path d=\"M22.9577,12.8339a2.5212,2.5212,0,1,1,2.5211,2.5211H22.9577Z\"/><path d=\"M21.6873,12.8339a2.5212,2.5212,0,0,1-5.0423,0V6.5212a2.5212,2.5212,0,1,1,5.0423,0Z\"/><path d=\"M19.1661,22.9577a2.5212,2.5212,0,1,1-2.5211,2.5211V22.9577Z\"/><path d=\"M19.1661,21.6873a2.5212,2.5212,0,0,1,0-5.0423h6.3127a2.5212,2.5212,0,1,1,0,5.0423Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9.0423 19.1661A2.5212 2.5212 0 116.5212 16.645H9.0423zM10.3127 19.1661a2.5212 2.5212 0 015.0423 0v6.3127a2.5212 2.5212 0 11-5.0423 0zM12.8339 9.0423A2.5212 2.5212 0 1115.355 6.5212V9.0423zM12.8339 10.3127a2.5212 2.5212 0 010 5.0423H6.5212a2.5212 2.5212 0 110-5.0423zM22.9577 12.8339a2.5212 2.5212 0 112.5211 2.5211H22.9577zM21.6873 12.8339a2.5212 2.5212 0 01-5.0423 0V6.5212a2.5212 2.5212 0 115.0423 0zM19.1661 22.9577a2.5212 2.5212 0 11-2.5211 2.5211V22.9577zM19.1661 21.6873a2.5212 2.5212 0 010-5.0423h6.3127a2.5212 2.5212 0 110 5.0423z\"/></svg>",
            "info": {},
            "path": "32/logo--slack.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoSlack32",
          "filepath": "logo--slack/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.0423 19.1661A2.5212 2.5212 0 116.5212 16.645H9.0423zM10.3127 19.1661a2.5212 2.5212 0 015.0423 0v6.3127a2.5212 2.5212 0 11-5.0423 0zM12.8339 9.0423A2.5212 2.5212 0 1115.355 6.5212V9.0423zM12.8339 10.3127a2.5212 2.5212 0 010 5.0423H6.5212a2.5212 2.5212 0 110-5.0423zM22.9577 12.8339a2.5212 2.5212 0 112.5211 2.5211H22.9577zM21.6873 12.8339a2.5212 2.5212 0 01-5.0423 0V6.5212a2.5212 2.5212 0 115.0423 0zM19.1661 22.9577a2.5212 2.5212 0 11-2.5211 2.5211V22.9577zM19.1661 21.6873a2.5212 2.5212 0 010-5.0423h6.3127a2.5212 2.5212 0 110 5.0423z"
                }
              }
            ],
            "name": "logo--slack",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoSlack24",
          "filepath": "logo--slack/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.0423 19.1661A2.5212 2.5212 0 116.5212 16.645H9.0423zM10.3127 19.1661a2.5212 2.5212 0 015.0423 0v6.3127a2.5212 2.5212 0 11-5.0423 0zM12.8339 9.0423A2.5212 2.5212 0 1115.355 6.5212V9.0423zM12.8339 10.3127a2.5212 2.5212 0 010 5.0423H6.5212a2.5212 2.5212 0 110-5.0423zM22.9577 12.8339a2.5212 2.5212 0 112.5211 2.5211H22.9577zM21.6873 12.8339a2.5212 2.5212 0 01-5.0423 0V6.5212a2.5212 2.5212 0 115.0423 0zM19.1661 22.9577a2.5212 2.5212 0 11-2.5211 2.5211V22.9577zM19.1661 21.6873a2.5212 2.5212 0 010-5.0423h6.3127a2.5212 2.5212 0 110 5.0423z"
                }
              }
            ],
            "name": "logo--slack",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoSlack20",
          "filepath": "logo--slack/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.0423 19.1661A2.5212 2.5212 0 116.5212 16.645H9.0423zM10.3127 19.1661a2.5212 2.5212 0 015.0423 0v6.3127a2.5212 2.5212 0 11-5.0423 0zM12.8339 9.0423A2.5212 2.5212 0 1115.355 6.5212V9.0423zM12.8339 10.3127a2.5212 2.5212 0 010 5.0423H6.5212a2.5212 2.5212 0 110-5.0423zM22.9577 12.8339a2.5212 2.5212 0 112.5211 2.5211H22.9577zM21.6873 12.8339a2.5212 2.5212 0 01-5.0423 0V6.5212a2.5212 2.5212 0 115.0423 0zM19.1661 22.9577a2.5212 2.5212 0 11-2.5211 2.5211V22.9577zM19.1661 21.6873a2.5212 2.5212 0 010-5.0423h6.3127a2.5212 2.5212 0 110 5.0423z"
                }
              }
            ],
            "name": "logo--slack",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoSlack16",
          "filepath": "logo--slack/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.0423 19.1661A2.5212 2.5212 0 116.5212 16.645H9.0423zM10.3127 19.1661a2.5212 2.5212 0 015.0423 0v6.3127a2.5212 2.5212 0 11-5.0423 0zM12.8339 9.0423A2.5212 2.5212 0 1115.355 6.5212V9.0423zM12.8339 10.3127a2.5212 2.5212 0 010 5.0423H6.5212a2.5212 2.5212 0 110-5.0423zM22.9577 12.8339a2.5212 2.5212 0 112.5211 2.5211H22.9577zM21.6873 12.8339a2.5212 2.5212 0 01-5.0423 0V6.5212a2.5212 2.5212 0 115.0423 0zM19.1661 22.9577a2.5212 2.5212 0 11-2.5211 2.5211V22.9577zM19.1661 21.6873a2.5212 2.5212 0 010-5.0423h6.3127a2.5212 2.5212 0 110 5.0423z"
                }
              }
            ],
            "name": "logo--slack",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoSlack",
        "global": "LogoSlack",
        "filepath": "LogoSlack.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.0423 19.1661A2.5212 2.5212 0 116.5212 16.645H9.0423zM10.3127 19.1661a2.5212 2.5212 0 015.0423 0v6.3127a2.5212 2.5212 0 11-5.0423 0zM12.8339 9.0423A2.5212 2.5212 0 1115.355 6.5212V9.0423zM12.8339 10.3127a2.5212 2.5212 0 010 5.0423H6.5212a2.5212 2.5212 0 110-5.0423zM22.9577 12.8339a2.5212 2.5212 0 112.5211 2.5211H22.9577zM21.6873 12.8339a2.5212 2.5212 0 01-5.0423 0V6.5212a2.5212 2.5212 0 115.0423 0zM19.1661 22.9577a2.5212 2.5212 0 11-2.5211 2.5211V22.9577zM19.1661 21.6873a2.5212 2.5212 0 010-5.0423h6.3127a2.5212 2.5212 0 110 5.0423z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--snapchat",
      "friendlyName": "Logo Snapchat",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--snapchat.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--snapchat</title><path d=\"M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z\"/><path id=\"inner-path\" class=\"cls-1\" d=\"M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z\"/><path fill=\"none\" d=\"M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/logo--snapchat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoSnapchat32",
          "filepath": "logo--snapchat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "logo--snapchat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoSnapchat24",
          "filepath": "logo--snapchat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "logo--snapchat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoSnapchat20",
          "filepath": "logo--snapchat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "logo--snapchat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoSnapchat16",
          "filepath": "logo--snapchat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "logo--snapchat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoSnapchat",
        "global": "LogoSnapchat",
        "filepath": "LogoSnapchat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--svelte",
      "friendlyName": "logo--svelte",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--svelte.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8\n\tc-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8\n\tC27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2\n\tc0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1\n\tc0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6\n\tc-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20\n\tl0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2\n\tc0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6\n\tc-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1\n\tC24.2,8.5,24.5,9.8,24.3,11z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8\tc-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8\tC27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2\tc0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1\tc0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6\tc-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20\tl0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2\tc0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6\tc-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1\tC24.2,8.5,24.5,9.8,24.3,11z\"/></svg>",
            "info": {},
            "path": "32/logo--svelte.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoSvelte32",
          "filepath": "logo--svelte/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8\tc-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8\tC27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2\tc0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1\tc0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6\tc-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20\tl0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2\tc0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6\tc-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1\tC24.2,8.5,24.5,9.8,24.3,11z"
                }
              }
            ],
            "name": "logo--svelte",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoSvelte24",
          "filepath": "logo--svelte/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8\tc-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8\tC27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2\tc0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1\tc0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6\tc-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20\tl0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2\tc0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6\tc-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1\tC24.2,8.5,24.5,9.8,24.3,11z"
                }
              }
            ],
            "name": "logo--svelte",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoSvelte20",
          "filepath": "logo--svelte/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8\tc-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8\tC27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2\tc0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1\tc0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6\tc-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20\tl0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2\tc0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6\tc-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1\tC24.2,8.5,24.5,9.8,24.3,11z"
                }
              }
            ],
            "name": "logo--svelte",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoSvelte16",
          "filepath": "logo--svelte/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8\tc-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8\tC27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2\tc0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1\tc0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6\tc-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20\tl0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2\tc0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6\tc-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1\tC24.2,8.5,24.5,9.8,24.3,11z"
                }
              }
            ],
            "name": "logo--svelte",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoSvelte",
        "global": "LogoSvelte",
        "filepath": "LogoSvelte.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8 c-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8 C27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2 c0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1 c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6 c-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20 l0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2 c0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6 c-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1 C24.2,8.5,24.5,9.8,24.3,11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--tumblr",
      "friendlyName": "Logo Tumblr",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--tumblr.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>logo--tumblr</title><path class=\"cls-1\" d=\"M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z\"/></svg>",
            "info": {},
            "path": "32/logo--tumblr.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoTumblr32",
          "filepath": "logo--tumblr/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z"
                }
              }
            ],
            "name": "logo--tumblr",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoTumblr24",
          "filepath": "logo--tumblr/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z"
                }
              }
            ],
            "name": "logo--tumblr",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoTumblr20",
          "filepath": "logo--tumblr/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z"
                }
              }
            ],
            "name": "logo--tumblr",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoTumblr16",
          "filepath": "logo--tumblr/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z"
                }
              }
            ],
            "name": "logo--tumblr",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoTumblr",
        "global": "LogoTumblr",
        "filepath": "LogoTumblr.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--twitter",
      "friendlyName": "Logo Twitter",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--twitter.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208\"/></svg>",
            "info": {},
            "path": "32/logo--twitter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoTwitter32",
          "filepath": "logo--twitter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208"
                }
              }
            ],
            "name": "logo--twitter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoTwitter24",
          "filepath": "logo--twitter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208"
                }
              }
            ],
            "name": "logo--twitter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoTwitter20",
          "filepath": "logo--twitter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208"
                }
              }
            ],
            "name": "logo--twitter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoTwitter16",
          "filepath": "logo--twitter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208"
                }
              }
            ],
            "name": "logo--twitter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoTwitter",
        "global": "LogoTwitter",
        "filepath": "LogoTwitter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--vmware",
      "friendlyName": "Logo VMware",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--vmware.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5\n\tc0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9\n\tV21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8\n\tc0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7\n\tl-2.5,5.9L3.4,11\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5\tc0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9\tV21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8\tc0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7\tl-2.5,5.9L3.4,11\"/></svg>",
            "info": {},
            "path": "32/logo--vmware.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoVmware32",
          "filepath": "logo--vmware/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5\tc0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9\tV21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8\tc0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7\tl-2.5,5.9L3.4,11"
                }
              }
            ],
            "name": "logo--vmware",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoVmware24",
          "filepath": "logo--vmware/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5\tc0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9\tV21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8\tc0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7\tl-2.5,5.9L3.4,11"
                }
              }
            ],
            "name": "logo--vmware",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoVmware20",
          "filepath": "logo--vmware/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5\tc0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9\tV21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8\tc0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7\tl-2.5,5.9L3.4,11"
                }
              }
            ],
            "name": "logo--vmware",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoVmware16",
          "filepath": "logo--vmware/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5\tc0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9\tV21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8\tc0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7\tl-2.5,5.9L3.4,11"
                }
              }
            ],
            "name": "logo--vmware",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoVmware",
        "global": "LogoVmware",
        "filepath": "LogoVmware.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5 c0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9 V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8 c0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7 l-2.5,5.9L3.4,11"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--vmware--alt",
      "friendlyName": "logo--vmware--alt",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--vmware--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.4131,19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415,0-.5114,.4112-1.0128,1.073-1.0128,.5515,0,.9226,.351,1.083,.8624l1.2034,3.9812,1.2335-3.9711c.1604-.5315,.5716-.8925,1.1432-.8925h.1304c.5716,0,.9828,.371,1.1432,.8925l1.2435,3.9812,1.2335-4.0113c.1504-.4713,.4814-.8524,1.073-.8524,.6117,0,1.0429,.4713,1.0429,1.0229,0,.1504-.0401,.351-.0702,.4513l-2.0056,5.6258c-.2306,.6919-.6919,.9928-1.2335,.9928h-.0702c-.5415,0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635,3.9511c-.2006,.6418-.6619,.9527-1.2034,.9527h-.0702c-.5315,0-.9928-.3109-1.2234-.9928Z\"/>\n  <path d=\"M2.0939,12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828,.2568-.7902,.8989-.5334,1.452l2.4299,5.2846c.3852,.8297,.7902,1.2644,1.5409,1.2644,.81,0,1.1656-.4741,1.5409-1.2644,0,0,2.1237-4.6228,2.1435-4.6722,.0198-.0494,.0889-.1976,.3062-.1976,.1877,0,.3358,.1482,.3358,.3457v4.524c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-3.6943c0-.7112,.5136-1.1755,1.2051-1.1755s1.1557,.4741,1.1557,1.1755v3.6943c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-3.6943c0-.7112,.5136-1.1755,1.2051-1.1755s1.1557,.4741,1.1557,1.1755v3.6943c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299,1.0372-2.4299,1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248,0-2.3015,1.0372-2.3015,1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866,0-1.9459,.4741-2.4694,1.6792l-1.5508,3.6647-1.9756-4.7018\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" x=\"0\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.4131 19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415 0-.5114.4112-1.0128 1.073-1.0128.5515 0 .9226.351 1.083.8624l1.2034 3.9812 1.2335-3.9711c.1604-.5315.5716-.8925 1.1432-.8925h.1304c.5716 0 .9828.371 1.1432.8925l1.2435 3.9812 1.2335-4.0113c.1504-.4713.4814-.8524 1.073-.8524.6117 0 1.0429.4713 1.0429 1.0229 0 .1504-.0401.351-.0702.4513l-2.0056 5.6258c-.2306.6919-.6919.9928-1.2335.9928h-.0702c-.5415 0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635 3.9511c-.2006.6418-.6619.9527-1.2034.9527h-.0702c-.5315 0-.9928-.3109-1.2234-.9928zM2.0939 12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828.2568-.7902.8989-.5334 1.452l2.4299 5.2846c.3852.8297.7902 1.2644 1.5409 1.2644.81 0 1.1656-.4741 1.5409-1.2644 0 0 2.1237-4.6228 2.1435-4.6722.0198-.0494.0889-.1976.3062-.1976.1877 0 .3358.1482.3358.3457v4.524c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299 1.0372-2.4299 1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248 0-2.3015 1.0372-2.3015 1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866 0-1.9459.4741-2.4694 1.6792l-1.5508 3.6647-1.9756-4.7018\"/></svg>",
            "info": {},
            "path": "32/logo--vmware--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoVmwareAlt32",
          "filepath": "logo--vmware--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4131 19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415 0-.5114.4112-1.0128 1.073-1.0128.5515 0 .9226.351 1.083.8624l1.2034 3.9812 1.2335-3.9711c.1604-.5315.5716-.8925 1.1432-.8925h.1304c.5716 0 .9828.371 1.1432.8925l1.2435 3.9812 1.2335-4.0113c.1504-.4713.4814-.8524 1.073-.8524.6117 0 1.0429.4713 1.0429 1.0229 0 .1504-.0401.351-.0702.4513l-2.0056 5.6258c-.2306.6919-.6919.9928-1.2335.9928h-.0702c-.5415 0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635 3.9511c-.2006.6418-.6619.9527-1.2034.9527h-.0702c-.5315 0-.9928-.3109-1.2234-.9928zM2.0939 12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828.2568-.7902.8989-.5334 1.452l2.4299 5.2846c.3852.8297.7902 1.2644 1.5409 1.2644.81 0 1.1656-.4741 1.5409-1.2644 0 0 2.1237-4.6228 2.1435-4.6722.0198-.0494.0889-.1976.3062-.1976.1877 0 .3358.1482.3358.3457v4.524c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299 1.0372-2.4299 1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248 0-2.3015 1.0372-2.3015 1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866 0-1.9459.4741-2.4694 1.6792l-1.5508 3.6647-1.9756-4.7018"
                }
              }
            ],
            "name": "logo--vmware--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoVmwareAlt24",
          "filepath": "logo--vmware--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4131 19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415 0-.5114.4112-1.0128 1.073-1.0128.5515 0 .9226.351 1.083.8624l1.2034 3.9812 1.2335-3.9711c.1604-.5315.5716-.8925 1.1432-.8925h.1304c.5716 0 .9828.371 1.1432.8925l1.2435 3.9812 1.2335-4.0113c.1504-.4713.4814-.8524 1.073-.8524.6117 0 1.0429.4713 1.0429 1.0229 0 .1504-.0401.351-.0702.4513l-2.0056 5.6258c-.2306.6919-.6919.9928-1.2335.9928h-.0702c-.5415 0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635 3.9511c-.2006.6418-.6619.9527-1.2034.9527h-.0702c-.5315 0-.9928-.3109-1.2234-.9928zM2.0939 12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828.2568-.7902.8989-.5334 1.452l2.4299 5.2846c.3852.8297.7902 1.2644 1.5409 1.2644.81 0 1.1656-.4741 1.5409-1.2644 0 0 2.1237-4.6228 2.1435-4.6722.0198-.0494.0889-.1976.3062-.1976.1877 0 .3358.1482.3358.3457v4.524c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299 1.0372-2.4299 1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248 0-2.3015 1.0372-2.3015 1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866 0-1.9459.4741-2.4694 1.6792l-1.5508 3.6647-1.9756-4.7018"
                }
              }
            ],
            "name": "logo--vmware--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoVmwareAlt20",
          "filepath": "logo--vmware--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4131 19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415 0-.5114.4112-1.0128 1.073-1.0128.5515 0 .9226.351 1.083.8624l1.2034 3.9812 1.2335-3.9711c.1604-.5315.5716-.8925 1.1432-.8925h.1304c.5716 0 .9828.371 1.1432.8925l1.2435 3.9812 1.2335-4.0113c.1504-.4713.4814-.8524 1.073-.8524.6117 0 1.0429.4713 1.0429 1.0229 0 .1504-.0401.351-.0702.4513l-2.0056 5.6258c-.2306.6919-.6919.9928-1.2335.9928h-.0702c-.5415 0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635 3.9511c-.2006.6418-.6619.9527-1.2034.9527h-.0702c-.5315 0-.9928-.3109-1.2234-.9928zM2.0939 12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828.2568-.7902.8989-.5334 1.452l2.4299 5.2846c.3852.8297.7902 1.2644 1.5409 1.2644.81 0 1.1656-.4741 1.5409-1.2644 0 0 2.1237-4.6228 2.1435-4.6722.0198-.0494.0889-.1976.3062-.1976.1877 0 .3358.1482.3358.3457v4.524c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299 1.0372-2.4299 1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248 0-2.3015 1.0372-2.3015 1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866 0-1.9459.4741-2.4694 1.6792l-1.5508 3.6647-1.9756-4.7018"
                }
              }
            ],
            "name": "logo--vmware--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoVmwareAlt16",
          "filepath": "logo--vmware--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4131 19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415 0-.5114.4112-1.0128 1.073-1.0128.5515 0 .9226.351 1.083.8624l1.2034 3.9812 1.2335-3.9711c.1604-.5315.5716-.8925 1.1432-.8925h.1304c.5716 0 .9828.371 1.1432.8925l1.2435 3.9812 1.2335-4.0113c.1504-.4713.4814-.8524 1.073-.8524.6117 0 1.0429.4713 1.0429 1.0229 0 .1504-.0401.351-.0702.4513l-2.0056 5.6258c-.2306.6919-.6919.9928-1.2335.9928h-.0702c-.5415 0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635 3.9511c-.2006.6418-.6619.9527-1.2034.9527h-.0702c-.5315 0-.9928-.3109-1.2234-.9928zM2.0939 12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828.2568-.7902.8989-.5334 1.452l2.4299 5.2846c.3852.8297.7902 1.2644 1.5409 1.2644.81 0 1.1656-.4741 1.5409-1.2644 0 0 2.1237-4.6228 2.1435-4.6722.0198-.0494.0889-.1976.3062-.1976.1877 0 .3358.1482.3358.3457v4.524c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299 1.0372-2.4299 1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248 0-2.3015 1.0372-2.3015 1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866 0-1.9459.4741-2.4694 1.6792l-1.5508 3.6647-1.9756-4.7018"
                }
              }
            ],
            "name": "logo--vmware--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoVmwareAlt",
        "global": "LogoVmwareAlt",
        "filepath": "LogoVmwareAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.4131 19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415 0-.5114.4112-1.0128 1.073-1.0128.5515 0 .9226.351 1.083.8624l1.2034 3.9812 1.2335-3.9711c.1604-.5315.5716-.8925 1.1432-.8925h.1304c.5716 0 .9828.371 1.1432.8925l1.2435 3.9812 1.2335-4.0113c.1504-.4713.4814-.8524 1.073-.8524.6117 0 1.0429.4713 1.0429 1.0229 0 .1504-.0401.351-.0702.4513l-2.0056 5.6258c-.2306.6919-.6919.9928-1.2335.9928h-.0702c-.5415 0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635 3.9511c-.2006.6418-.6619.9527-1.2034.9527h-.0702c-.5315 0-.9928-.3109-1.2234-.9928zM2.0939 12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828.2568-.7902.8989-.5334 1.452l2.4299 5.2846c.3852.8297.7902 1.2644 1.5409 1.2644.81 0 1.1656-.4741 1.5409-1.2644 0 0 2.1237-4.6228 2.1435-4.6722.0198-.0494.0889-.1976.3062-.1976.1877 0 .3358.1482.3358.3457v4.524c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-3.6943c0-.7112.5136-1.1755 1.2051-1.1755s1.1557.4741 1.1557 1.1755v3.6943c0 .6914.3852 1.2644 1.1261 1.2644s1.1458-.5729 1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299 1.0372-2.4299 1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248 0-2.3015 1.0372-2.3015 1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866 0-1.9459.4741-2.4694 1.6792l-1.5508 3.6647-1.9756-4.7018"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--vue",
      "friendlyName": "logo--vue",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--vue.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z\"/>\n<path d=\"M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z\"/><path d=\"M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z\"/></svg>",
            "info": {},
            "path": "32/logo--vue.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoVue32",
          "filepath": "logo--vue/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z"
                }
              }
            ],
            "name": "logo--vue",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoVue24",
          "filepath": "logo--vue/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z"
                }
              }
            ],
            "name": "logo--vue",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoVue20",
          "filepath": "logo--vue/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z"
                }
              }
            ],
            "name": "logo--vue",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoVue16",
          "filepath": "logo--vue/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z"
                }
              }
            ],
            "name": "logo--vue",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Design and development",
      "moduleInfo": {
        "local": "LogoVue",
        "global": "LogoVue",
        "filepath": "LogoVue.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--wechat",
      "friendlyName": "Logo WeChat",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification",
        "social",
        "WeChat"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--wechat.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z\"/></svg>",
            "info": {},
            "path": "32/logo--wechat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoWechat32",
          "filepath": "logo--wechat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z"
                }
              }
            ],
            "name": "logo--wechat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoWechat24",
          "filepath": "logo--wechat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z"
                }
              }
            ],
            "name": "logo--wechat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoWechat20",
          "filepath": "logo--wechat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z"
                }
              }
            ],
            "name": "logo--wechat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoWechat16",
          "filepath": "logo--wechat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z"
                }
              }
            ],
            "name": "logo--wechat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoWechat",
        "global": "LogoWechat",
        "filepath": "LogoWechat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--xing",
      "friendlyName": "Logo XING",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--xing.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--xing</title><path d=\"M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z\" transform=\"translate(0)\"/><path d=\"M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z\"/><path d=\"M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z\"/></svg>",
            "info": {},
            "path": "32/logo--xing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoXing32",
          "filepath": "logo--xing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z"
                }
              }
            ],
            "name": "logo--xing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoXing24",
          "filepath": "logo--xing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z"
                }
              }
            ],
            "name": "logo--xing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoXing20",
          "filepath": "logo--xing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z"
                }
              }
            ],
            "name": "logo--xing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoXing16",
          "filepath": "logo--xing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z"
                }
              }
            ],
            "name": "logo--xing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoXing",
        "global": "LogoXing",
        "filepath": "LogoXing.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--yelp",
      "friendlyName": "Logo Yelp",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--yelp.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-2\" d=\"M8.5089,15.1845l5.0598,2.4675c.9733,.4747,.8229,1.9059-.2278,2.1679l-5.4618,1.3619c-.6813,.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655,.4564-4.3296,.2227-.6625,.9797-.9764,1.6079-.67Z\"/>\n  <path class=\"cls-2\" d=\"M10.5348,25.6004l3.7659-4.1831c.7245-.8048,2.0589-.2657,2.0211,.8165l-.1964,5.6273c-.0245,.7012-.6613,1.2203-1.3532,1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327Z\"/>\n  <path class=\"cls-2\" d=\"M19.464,20.0339l5.3529,1.7396c.6663,.2165,.9912,.9705,.6894,1.6027-.6279,1.3155-1.5387,2.4909-2.6766,3.4301-.5412,.4466-1.3521,.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184,.3123-2.0524,1.3421-1.7177Z\"/>\n  <path class=\"cls-2\" d=\"M24.9076,16.619l-5.411,1.5515c-1.0409,.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795,1.2034-.6861,1.7275-.2237,1.0791,.9521,1.9628,2.1433,2.56,3.5214,.2792,.6443-.0685,1.3877-.7434,1.5813Z\"/>\n  <path class=\"cls-2\" d=\"M12.2638,3.4886c-.9739,.2609-1.903,.6058-2.7815,1.0247-.6096,.2907-.8399,1.0415-.5022,1.6264l5.2887,9.1604c.5934,1.0277,2.1643,.6067,2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703,.0765-1.9474,.2424-2.9212,.5033Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill-rule=\"evenodd\" d=\"M8.5089 15.1845l5.0598 2.4675c.9733.4747.8229 1.9059-.2278 2.1679l-5.4618 1.3619c-.6813.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655.4564-4.3296.2227-.6625.9797-.9764 1.6079-.67zM10.5348 25.6004l3.7659-4.1831c.7245-.8048 2.0589-.2657 2.0211.8165l-.1964 5.6273c-.0245.7012-.6613 1.2203-1.3532 1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327zM19.464 20.0339l5.3529 1.7396c.6663.2165.9912.9705.6894 1.6027-.6279 1.3155-1.5387 2.4909-2.6766 3.4301-.5412.4466-1.3521.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184.3123-2.0524 1.3421-1.7177zM24.9076 16.619l-5.411 1.5515c-1.0409.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795 1.2034-.6861 1.7275-.2237 1.0791.9521 1.9628 2.1433 2.56 3.5214.2792.6443-.0685 1.3877-.7434 1.5813zM12.2638 3.4886c-.9739.2609-1.903.6058-2.7815 1.0247-.6096.2907-.8399 1.0415-.5022 1.6264l5.2887 9.1604c.5934 1.0277 2.1643.6067 2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703.0765-1.9474.2424-2.9212.5033z\"/></svg>",
            "info": {},
            "path": "32/logo--yelp.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoYelp32",
          "filepath": "logo--yelp/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M8.5089 15.1845l5.0598 2.4675c.9733.4747.8229 1.9059-.2278 2.1679l-5.4618 1.3619c-.6813.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655.4564-4.3296.2227-.6625.9797-.9764 1.6079-.67zM10.5348 25.6004l3.7659-4.1831c.7245-.8048 2.0589-.2657 2.0211.8165l-.1964 5.6273c-.0245.7012-.6613 1.2203-1.3532 1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327zM19.464 20.0339l5.3529 1.7396c.6663.2165.9912.9705.6894 1.6027-.6279 1.3155-1.5387 2.4909-2.6766 3.4301-.5412.4466-1.3521.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184.3123-2.0524 1.3421-1.7177zM24.9076 16.619l-5.411 1.5515c-1.0409.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795 1.2034-.6861 1.7275-.2237 1.0791.9521 1.9628 2.1433 2.56 3.5214.2792.6443-.0685 1.3877-.7434 1.5813zM12.2638 3.4886c-.9739.2609-1.903.6058-2.7815 1.0247-.6096.2907-.8399 1.0415-.5022 1.6264l5.2887 9.1604c.5934 1.0277 2.1643.6067 2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703.0765-1.9474.2424-2.9212.5033z"
                }
              }
            ],
            "name": "logo--yelp",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoYelp24",
          "filepath": "logo--yelp/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M8.5089 15.1845l5.0598 2.4675c.9733.4747.8229 1.9059-.2278 2.1679l-5.4618 1.3619c-.6813.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655.4564-4.3296.2227-.6625.9797-.9764 1.6079-.67zM10.5348 25.6004l3.7659-4.1831c.7245-.8048 2.0589-.2657 2.0211.8165l-.1964 5.6273c-.0245.7012-.6613 1.2203-1.3532 1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327zM19.464 20.0339l5.3529 1.7396c.6663.2165.9912.9705.6894 1.6027-.6279 1.3155-1.5387 2.4909-2.6766 3.4301-.5412.4466-1.3521.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184.3123-2.0524 1.3421-1.7177zM24.9076 16.619l-5.411 1.5515c-1.0409.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795 1.2034-.6861 1.7275-.2237 1.0791.9521 1.9628 2.1433 2.56 3.5214.2792.6443-.0685 1.3877-.7434 1.5813zM12.2638 3.4886c-.9739.2609-1.903.6058-2.7815 1.0247-.6096.2907-.8399 1.0415-.5022 1.6264l5.2887 9.1604c.5934 1.0277 2.1643.6067 2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703.0765-1.9474.2424-2.9212.5033z"
                }
              }
            ],
            "name": "logo--yelp",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoYelp20",
          "filepath": "logo--yelp/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M8.5089 15.1845l5.0598 2.4675c.9733.4747.8229 1.9059-.2278 2.1679l-5.4618 1.3619c-.6813.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655.4564-4.3296.2227-.6625.9797-.9764 1.6079-.67zM10.5348 25.6004l3.7659-4.1831c.7245-.8048 2.0589-.2657 2.0211.8165l-.1964 5.6273c-.0245.7012-.6613 1.2203-1.3532 1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327zM19.464 20.0339l5.3529 1.7396c.6663.2165.9912.9705.6894 1.6027-.6279 1.3155-1.5387 2.4909-2.6766 3.4301-.5412.4466-1.3521.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184.3123-2.0524 1.3421-1.7177zM24.9076 16.619l-5.411 1.5515c-1.0409.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795 1.2034-.6861 1.7275-.2237 1.0791.9521 1.9628 2.1433 2.56 3.5214.2792.6443-.0685 1.3877-.7434 1.5813zM12.2638 3.4886c-.9739.2609-1.903.6058-2.7815 1.0247-.6096.2907-.8399 1.0415-.5022 1.6264l5.2887 9.1604c.5934 1.0277 2.1643.6067 2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703.0765-1.9474.2424-2.9212.5033z"
                }
              }
            ],
            "name": "logo--yelp",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoYelp16",
          "filepath": "logo--yelp/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M8.5089 15.1845l5.0598 2.4675c.9733.4747.8229 1.9059-.2278 2.1679l-5.4618 1.3619c-.6813.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655.4564-4.3296.2227-.6625.9797-.9764 1.6079-.67zM10.5348 25.6004l3.7659-4.1831c.7245-.8048 2.0589-.2657 2.0211.8165l-.1964 5.6273c-.0245.7012-.6613 1.2203-1.3532 1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327zM19.464 20.0339l5.3529 1.7396c.6663.2165.9912.9705.6894 1.6027-.6279 1.3155-1.5387 2.4909-2.6766 3.4301-.5412.4466-1.3521.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184.3123-2.0524 1.3421-1.7177zM24.9076 16.619l-5.411 1.5515c-1.0409.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795 1.2034-.6861 1.7275-.2237 1.0791.9521 1.9628 2.1433 2.56 3.5214.2792.6443-.0685 1.3877-.7434 1.5813zM12.2638 3.4886c-.9739.2609-1.903.6058-2.7815 1.0247-.6096.2907-.8399 1.0415-.5022 1.6264l5.2887 9.1604c.5934 1.0277 2.1643.6067 2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703.0765-1.9474.2424-2.9212.5033z"
                }
              }
            ],
            "name": "logo--yelp",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoYelp",
        "global": "LogoYelp",
        "filepath": "LogoYelp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M8.5089 15.1845l5.0598 2.4675c.9733.4747.8229 1.9059-.2278 2.1679l-5.4618 1.3619c-.6813.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655.4564-4.3296.2227-.6625.9797-.9764 1.6079-.67zM10.5348 25.6004l3.7659-4.1831c.7245-.8048 2.0589-.2657 2.0211.8165l-.1964 5.6273c-.0245.7012-.6613 1.2203-1.3532 1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327zM19.464 20.0339l5.3529 1.7396c.6663.2165.9912.9705.6894 1.6027-.6279 1.3155-1.5387 2.4909-2.6766 3.4301-.5412.4466-1.3521.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184.3123-2.0524 1.3421-1.7177zM24.9076 16.619l-5.411 1.5515c-1.0409.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795 1.2034-.6861 1.7275-.2237 1.0791.9521 1.9628 2.1433 2.56 3.5214.2792.6443-.0685 1.3877-.7434 1.5813zM12.2638 3.4886c-.9739.2609-1.903.6058-2.7815 1.0247-.6096.2907-.8399 1.0415-.5022 1.6264l5.2887 9.1604c.5934 1.0277 2.1643.6067 2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703.0765-1.9474.2424-2.9212.5033z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logo--youtube",
      "friendlyName": "Logo YouTube",
      "aliases": [
        "brand",
        "emblem",
        "logotype",
        "symbol",
        "id",
        "avatar",
        "tag",
        "identification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logo--youtube.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logo--youtube</title><path d=\"M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z\"/></svg>",
            "info": {},
            "path": "32/logo--youtube.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "LogoYoutube32",
          "filepath": "logo--youtube/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z"
                }
              }
            ],
            "name": "logo--youtube",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "LogoYoutube24",
          "filepath": "logo--youtube/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z"
                }
              }
            ],
            "name": "logo--youtube",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "LogoYoutube20",
          "filepath": "logo--youtube/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z"
                }
              }
            ],
            "name": "logo--youtube",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "LogoYoutube16",
          "filepath": "logo--youtube/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z"
                }
              }
            ],
            "name": "logo--youtube",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "Social",
      "moduleInfo": {
        "local": "LogoYoutube",
        "global": "LogoYoutube",
        "filepath": "LogoYoutube.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "logout",
      "friendlyName": "Logout",
      "aliases": [
        "sign off",
        "sign out",
        "log off",
        "quit",
        "exit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/logout.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>logout</title><path d=\"M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z\"/><polygon points=\"20.586 20.586 24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z\"/><path d=\"M20.586 20.586L24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z\"/></svg>",
            "info": {},
            "path": "32/logout.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Logout32",
          "filepath": "logout/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 20.586L24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z"
                }
              }
            ],
            "name": "logout",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Logout24",
          "filepath": "logout/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 20.586L24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z"
                }
              }
            ],
            "name": "logout",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Logout20",
          "filepath": "logout/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 20.586L24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z"
                }
              }
            ],
            "name": "logout",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Logout16",
          "filepath": "logout/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.586 20.586L24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z"
                }
              }
            ],
            "name": "logout",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Logout",
        "global": "Logout",
        "filepath": "Logout.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.586 20.586L24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "loop",
      "friendlyName": "Loop",
      "aliases": [
        "knot",
        "curl",
        "circuit",
        "bend",
        "coil",
        "curve",
        "around",
        "twirl"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/loop.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>health--exam-mode-cine</title><polygon points=\"23.59 19.41 26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41\"/><path d=\"M13,6A9,9,0,0,0,5.52,20l1.66-1.11A7,7,0,1,1,13,22H2v2H13A9,9,0,0,0,13,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.59 19.41L26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41zM13 6A9 9 0 005.52 20l1.66-1.11A7 7 0 1113 22H2v2H13A9 9 0 0013 6z\"/></svg>",
            "info": {},
            "path": "32/loop.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Loop32",
          "filepath": "loop/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.59 19.41L26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41zM13 6A9 9 0 005.52 20l1.66-1.11A7 7 0 1113 22H2v2H13A9 9 0 0013 6z"
                }
              }
            ],
            "name": "loop",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Loop24",
          "filepath": "loop/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.59 19.41L26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41zM13 6A9 9 0 005.52 20l1.66-1.11A7 7 0 1113 22H2v2H13A9 9 0 0013 6z"
                }
              }
            ],
            "name": "loop",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Loop20",
          "filepath": "loop/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.59 19.41L26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41zM13 6A9 9 0 005.52 20l1.66-1.11A7 7 0 1113 22H2v2H13A9 9 0 0013 6z"
                }
              }
            ],
            "name": "loop",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Loop16",
          "filepath": "loop/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.59 19.41L26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41zM13 6A9 9 0 005.52 20l1.66-1.11A7 7 0 1113 22H2v2H13A9 9 0 0013 6z"
                }
              }
            ],
            "name": "loop",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Loop",
        "global": "Loop",
        "filepath": "Loop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.59 19.41L26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41zM13 6A9 9 0 005.52 20l1.66-1.11A7 7 0 1113 22H2v2H13A9 9 0 0013 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "low-severity",
      "friendlyName": "Low severity",
      "aliases": [
        "glyph",
        "severity",
        "status",
        "state"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "low-severity.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"4\" y=\"4\" width=\"8\" height=\"8\"/>\n  <path d=\"M12,4v8H4V4h8m1-1H3V13H13V3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4 4H12V12H4z\"/><path d=\"M12,4v8H4V4h8m1-1H3V13H13V3Z\"/></svg>",
            "info": {},
            "path": "low-severity.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 4H12V12H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4v8H4V4h8m1-1H3V13H13V3Z"
                }
              }
            ],
            "name": "low-severity",
            "size": "glyph"
          },
          "moduleName": "LowSeverityGlyph",
          "filepath": "low-severity/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "LowSeverity",
        "global": "LowSeverity",
        "filepath": "LowSeverity.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 4H12V12H4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,4v8H4V4h8m1-1H3V13H13V3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mac--command",
      "friendlyName": "Mac command",
      "aliases": [
        "command",
        "key command",
        "command key",
        "macintosh",
        "apple",
        "keyboard"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mac--command.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mac-command</title><path d=\"M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z\"/></svg>",
            "info": {},
            "path": "32/mac--command.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MacCommand32",
          "filepath": "mac--command/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z"
                }
              }
            ],
            "name": "mac--command",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MacCommand24",
          "filepath": "mac--command/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z"
                }
              }
            ],
            "name": "mac--command",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MacCommand20",
          "filepath": "mac--command/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z"
                }
              }
            ],
            "name": "mac--command",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MacCommand16",
          "filepath": "mac--command/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z"
                }
              }
            ],
            "name": "mac--command",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "MacCommand",
        "global": "MacCommand",
        "filepath": "MacCommand.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mac--option",
      "friendlyName": "Mac option",
      "aliases": [
        "command",
        "key command",
        "command key",
        "macintosh",
        "apple",
        "keyboard"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mac--option.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"18\" y=\"5\" width=\"10\" height=\"2\"/>\n<polygon points=\"10.6,5 4,5 4,7 9.4,7 18.4,27 28,27 28,25 19.6,25 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 5H28V7H18zM10.6 5L4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z\"/></svg>",
            "info": {},
            "path": "32/mac--option.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MacOption32",
          "filepath": "mac--option/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 5H28V7H18zM10.6 5L4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z"
                }
              }
            ],
            "name": "mac--option",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MacOption24",
          "filepath": "mac--option/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 5H28V7H18zM10.6 5L4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z"
                }
              }
            ],
            "name": "mac--option",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MacOption20",
          "filepath": "mac--option/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 5H28V7H18zM10.6 5L4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z"
                }
              }
            ],
            "name": "mac--option",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MacOption16",
          "filepath": "mac--option/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 5H28V7H18zM10.6 5L4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z"
                }
              }
            ],
            "name": "mac--option",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "MacOption",
        "global": "MacOption",
        "filepath": "MacOption.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 5H28V7H18zM10.6 5L4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mac--shift",
      "friendlyName": "Mac shift",
      "aliases": [
        "command",
        "key command",
        "command key",
        "macintosh",
        "apple",
        "keyboard"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mac--shift.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>mac--shift</title>\n  <path d=\"M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z\"/></svg>",
            "info": {},
            "path": "32/mac--shift.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MacShift32",
          "filepath": "mac--shift/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z"
                }
              }
            ],
            "name": "mac--shift",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MacShift24",
          "filepath": "mac--shift/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z"
                }
              }
            ],
            "name": "mac--shift",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MacShift20",
          "filepath": "mac--shift/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z"
                }
              }
            ],
            "name": "mac--shift",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MacShift16",
          "filepath": "mac--shift/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z"
                }
              }
            ],
            "name": "mac--shift",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "MacShift",
        "global": "MacShift",
        "filepath": "MacShift.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "machine-learning",
      "friendlyName": "Machine learning",
      "aliases": [
        "machine learning",
        "ML"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/machine-learning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>machine-learning</title><path d=\"M16,25a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,25Z\"/><path d=\"M20,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,14Z\"/><path d=\"M12,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,14Z\"/><path d=\"M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 25zM20 14a2 2 0 102 2A1.9806 1.9806 0 0020 14zM12 14a2 2 0 102 2A1.9806 1.9806 0 0012 14z\"/><path d=\"M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/machine-learning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MachineLearning32",
          "filepath": "machine-learning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 25zM20 14a2 2 0 102 2A1.9806 1.9806 0 0020 14zM12 14a2 2 0 102 2A1.9806 1.9806 0 0012 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "machine-learning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MachineLearning24",
          "filepath": "machine-learning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 25zM20 14a2 2 0 102 2A1.9806 1.9806 0 0020 14zM12 14a2 2 0 102 2A1.9806 1.9806 0 0012 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "machine-learning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MachineLearning20",
          "filepath": "machine-learning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 25zM20 14a2 2 0 102 2A1.9806 1.9806 0 0020 14zM12 14a2 2 0 102 2A1.9806 1.9806 0 0012 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "machine-learning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MachineLearning16",
          "filepath": "machine-learning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 25zM20 14a2 2 0 102 2A1.9806 1.9806 0 0020 14zM12 14a2 2 0 102 2A1.9806 1.9806 0 0012 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z"
                }
              }
            ],
            "name": "machine-learning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MachineLearning",
        "global": "MachineLearning",
        "filepath": "MachineLearning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 25zM20 14a2 2 0 102 2A1.9806 1.9806 0 0020 14zM12 14a2 2 0 102 2A1.9806 1.9806 0 0012 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "machine-learning-model",
      "friendlyName": "Machine learning model",
      "aliases": [
        "machine learning model",
        "ML",
        "model"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/machine-learning-model.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,24a2.9609,2.9609,0,0,0-1.2854.3008L21.4141,20H18v2h2.5859l3.7146,3.7148A2.9665,2.9665,0,0,0,24,27a3,3,0,1,0,3-3Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,28Z\"/>\n  <path d=\"M27,13a2.9948,2.9948,0,0,0-2.8157,2H18v2h6.1843A2.9947,2.9947,0,1,0,27,13Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,17Z\"/>\n  <path d=\"M27,2a3.0033,3.0033,0,0,0-3,3,2.9657,2.9657,0,0,0,.3481,1.373L20.5957,10H18v2h3.4043l4.3989-4.2524A2.9987,2.9987,0,1,0,27,2Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,6Z\"/>\n  <path d=\"M18,6h2V4H18a3.9756,3.9756,0,0,0-3,1.3823A3.9756,3.9756,0,0,0,12,4H11a9.01,9.01,0,0,0-9,9v6a9.01,9.01,0,0,0,9,9h1a3.9756,3.9756,0,0,0,3-1.3823A3.9756,3.9756,0,0,0,18,28h2V26H18a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,18,6ZM12,26H11a7.0047,7.0047,0,0,1-6.92-6H6V18H4V14H7a3.0033,3.0033,0,0,0,3-3V9H8v2a1.0009,1.0009,0,0,1-1,1H4.08A7.0047,7.0047,0,0,1,11,6h1a2.0023,2.0023,0,0,1,2,2v4H12v2h2v4H12a3.0033,3.0033,0,0,0-3,3v2h2V21a1.0009,1.0009,0,0,1,1-1h2v4A2.0023,2.0023,0,0,1,12,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 24a2.9609 2.9609 0 00-1.2854.3008L21.4141 20H18v2h2.5859l3.7146 3.7148A2.9665 2.9665 0 0024 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 28zM27 13a2.9948 2.9948 0 00-2.8157 2H18v2h6.1843A2.9947 2.9947 0 1027 13zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 17zM27 2a3.0033 3.0033 0 00-3 3 2.9657 2.9657 0 00.3481 1.373L20.5957 10H18v2h3.4043l4.3989-4.2524A2.9987 2.9987 0 1027 2zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 6z\"/><path d=\"M18,6h2V4H18a3.9756,3.9756,0,0,0-3,1.3823A3.9756,3.9756,0,0,0,12,4H11a9.01,9.01,0,0,0-9,9v6a9.01,9.01,0,0,0,9,9h1a3.9756,3.9756,0,0,0,3-1.3823A3.9756,3.9756,0,0,0,18,28h2V26H18a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,18,6ZM12,26H11a7.0047,7.0047,0,0,1-6.92-6H6V18H4V14H7a3.0033,3.0033,0,0,0,3-3V9H8v2a1.0009,1.0009,0,0,1-1,1H4.08A7.0047,7.0047,0,0,1,11,6h1a2.0023,2.0023,0,0,1,2,2v4H12v2h2v4H12a3.0033,3.0033,0,0,0-3,3v2h2V21a1.0009,1.0009,0,0,1,1-1h2v4A2.0023,2.0023,0,0,1,12,26Z\"/></svg>",
            "info": {},
            "path": "32/machine-learning-model.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MachineLearningModel32",
          "filepath": "machine-learning-model/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 24a2.9609 2.9609 0 00-1.2854.3008L21.4141 20H18v2h2.5859l3.7146 3.7148A2.9665 2.9665 0 0024 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 28zM27 13a2.9948 2.9948 0 00-2.8157 2H18v2h6.1843A2.9947 2.9947 0 1027 13zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 17zM27 2a3.0033 3.0033 0 00-3 3 2.9657 2.9657 0 00.3481 1.373L20.5957 10H18v2h3.4043l4.3989-4.2524A2.9987 2.9987 0 1027 2zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,6h2V4H18a3.9756,3.9756,0,0,0-3,1.3823A3.9756,3.9756,0,0,0,12,4H11a9.01,9.01,0,0,0-9,9v6a9.01,9.01,0,0,0,9,9h1a3.9756,3.9756,0,0,0,3-1.3823A3.9756,3.9756,0,0,0,18,28h2V26H18a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,18,6ZM12,26H11a7.0047,7.0047,0,0,1-6.92-6H6V18H4V14H7a3.0033,3.0033,0,0,0,3-3V9H8v2a1.0009,1.0009,0,0,1-1,1H4.08A7.0047,7.0047,0,0,1,11,6h1a2.0023,2.0023,0,0,1,2,2v4H12v2h2v4H12a3.0033,3.0033,0,0,0-3,3v2h2V21a1.0009,1.0009,0,0,1,1-1h2v4A2.0023,2.0023,0,0,1,12,26Z"
                }
              }
            ],
            "name": "machine-learning-model",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MachineLearningModel24",
          "filepath": "machine-learning-model/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 24a2.9609 2.9609 0 00-1.2854.3008L21.4141 20H18v2h2.5859l3.7146 3.7148A2.9665 2.9665 0 0024 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 28zM27 13a2.9948 2.9948 0 00-2.8157 2H18v2h6.1843A2.9947 2.9947 0 1027 13zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 17zM27 2a3.0033 3.0033 0 00-3 3 2.9657 2.9657 0 00.3481 1.373L20.5957 10H18v2h3.4043l4.3989-4.2524A2.9987 2.9987 0 1027 2zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,6h2V4H18a3.9756,3.9756,0,0,0-3,1.3823A3.9756,3.9756,0,0,0,12,4H11a9.01,9.01,0,0,0-9,9v6a9.01,9.01,0,0,0,9,9h1a3.9756,3.9756,0,0,0,3-1.3823A3.9756,3.9756,0,0,0,18,28h2V26H18a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,18,6ZM12,26H11a7.0047,7.0047,0,0,1-6.92-6H6V18H4V14H7a3.0033,3.0033,0,0,0,3-3V9H8v2a1.0009,1.0009,0,0,1-1,1H4.08A7.0047,7.0047,0,0,1,11,6h1a2.0023,2.0023,0,0,1,2,2v4H12v2h2v4H12a3.0033,3.0033,0,0,0-3,3v2h2V21a1.0009,1.0009,0,0,1,1-1h2v4A2.0023,2.0023,0,0,1,12,26Z"
                }
              }
            ],
            "name": "machine-learning-model",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MachineLearningModel20",
          "filepath": "machine-learning-model/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 24a2.9609 2.9609 0 00-1.2854.3008L21.4141 20H18v2h2.5859l3.7146 3.7148A2.9665 2.9665 0 0024 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 28zM27 13a2.9948 2.9948 0 00-2.8157 2H18v2h6.1843A2.9947 2.9947 0 1027 13zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 17zM27 2a3.0033 3.0033 0 00-3 3 2.9657 2.9657 0 00.3481 1.373L20.5957 10H18v2h3.4043l4.3989-4.2524A2.9987 2.9987 0 1027 2zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,6h2V4H18a3.9756,3.9756,0,0,0-3,1.3823A3.9756,3.9756,0,0,0,12,4H11a9.01,9.01,0,0,0-9,9v6a9.01,9.01,0,0,0,9,9h1a3.9756,3.9756,0,0,0,3-1.3823A3.9756,3.9756,0,0,0,18,28h2V26H18a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,18,6ZM12,26H11a7.0047,7.0047,0,0,1-6.92-6H6V18H4V14H7a3.0033,3.0033,0,0,0,3-3V9H8v2a1.0009,1.0009,0,0,1-1,1H4.08A7.0047,7.0047,0,0,1,11,6h1a2.0023,2.0023,0,0,1,2,2v4H12v2h2v4H12a3.0033,3.0033,0,0,0-3,3v2h2V21a1.0009,1.0009,0,0,1,1-1h2v4A2.0023,2.0023,0,0,1,12,26Z"
                }
              }
            ],
            "name": "machine-learning-model",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MachineLearningModel16",
          "filepath": "machine-learning-model/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 24a2.9609 2.9609 0 00-1.2854.3008L21.4141 20H18v2h2.5859l3.7146 3.7148A2.9665 2.9665 0 0024 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 28zM27 13a2.9948 2.9948 0 00-2.8157 2H18v2h6.1843A2.9947 2.9947 0 1027 13zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 17zM27 2a3.0033 3.0033 0 00-3 3 2.9657 2.9657 0 00.3481 1.373L20.5957 10H18v2h3.4043l4.3989-4.2524A2.9987 2.9987 0 1027 2zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,6h2V4H18a3.9756,3.9756,0,0,0-3,1.3823A3.9756,3.9756,0,0,0,12,4H11a9.01,9.01,0,0,0-9,9v6a9.01,9.01,0,0,0,9,9h1a3.9756,3.9756,0,0,0,3-1.3823A3.9756,3.9756,0,0,0,18,28h2V26H18a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,18,6ZM12,26H11a7.0047,7.0047,0,0,1-6.92-6H6V18H4V14H7a3.0033,3.0033,0,0,0,3-3V9H8v2a1.0009,1.0009,0,0,1-1,1H4.08A7.0047,7.0047,0,0,1,11,6h1a2.0023,2.0023,0,0,1,2,2v4H12v2h2v4H12a3.0033,3.0033,0,0,0-3,3v2h2V21a1.0009,1.0009,0,0,1,1-1h2v4A2.0023,2.0023,0,0,1,12,26Z"
                }
              }
            ],
            "name": "machine-learning-model",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MachineLearningModel",
        "global": "MachineLearningModel",
        "filepath": "MachineLearningModel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 24a2.9609 2.9609 0 00-1.2854.3008L21.4141 20H18v2h2.5859l3.7146 3.7148A2.9665 2.9665 0 0024 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 28zM27 13a2.9948 2.9948 0 00-2.8157 2H18v2h6.1843A2.9947 2.9947 0 1027 13zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 17zM27 2a3.0033 3.0033 0 00-3 3 2.9657 2.9657 0 00.3481 1.373L20.5957 10H18v2h3.4043l4.3989-4.2524A2.9987 2.9987 0 1027 2zm0 4a1 1 0 111-1A1.0009 1.0009 0 0127 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,6h2V4H18a3.9756,3.9756,0,0,0-3,1.3823A3.9756,3.9756,0,0,0,12,4H11a9.01,9.01,0,0,0-9,9v6a9.01,9.01,0,0,0,9,9h1a3.9756,3.9756,0,0,0,3-1.3823A3.9756,3.9756,0,0,0,18,28h2V26H18a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,18,6ZM12,26H11a7.0047,7.0047,0,0,1-6.92-6H6V18H4V14H7a3.0033,3.0033,0,0,0,3-3V9H8v2a1.0009,1.0009,0,0,1-1,1H4.08A7.0047,7.0047,0,0,1,11,6h1a2.0023,2.0023,0,0,1,2,2v4H12v2h2v4H12a3.0033,3.0033,0,0,0-3,3v2h2V21a1.0009,1.0009,0,0,1,1-1h2v4A2.0023,2.0023,0,0,1,12,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "magic-wand",
      "friendlyName": "Magic wand",
      "aliases": [
        "magic wand",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/magic-wand.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>magic-wand</title><path d=\"M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z\"/><rect x=\"2.5858\" y=\"14.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(-10.1421 7.5147) rotate(-45)\"/><rect x=\"14.5858\" y=\"2.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(1.8579 12.4853) rotate(-45)\"/><rect x=\"2.5858\" y=\"2.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(-1.6569 4) rotate(-45)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z\"/><path d=\"M2.586 14.586H5.414V17.414H2.586z\" transform=\"rotate(-45 4 16)\"/><path d=\"M14.586 2.586H17.414V5.414H14.586z\" transform=\"rotate(-45 16 4)\"/><path d=\"M2.586 2.586H5.414V5.414H2.586z\" transform=\"rotate(-45 4 4)\"/></svg>",
            "info": {},
            "path": "32/magic-wand.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MagicWand32",
          "filepath": "magic-wand/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MagicWand24",
          "filepath": "magic-wand/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MagicWand20",
          "filepath": "magic-wand/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MagicWand16",
          "filepath": "magic-wand/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "MagicWand",
        "global": "MagicWand",
        "filepath": "MagicWand.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.586 14.586H5.414V17.414H2.586z",
                    "transform": "rotate(-45 4 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.586 2.586H17.414V5.414H14.586z",
                    "transform": "rotate(-45 16 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.586 2.586H5.414V5.414H2.586z",
                    "transform": "rotate(-45 4 4)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "magic-wand--filled",
      "friendlyName": "Magic wand filled",
      "aliases": [
        "magic wand",
        "filled",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/magic-wand--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>magic-wand--filled</title><path d=\"M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z\"/><rect x=\"2.5858\" y=\"14.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(-10.1421 7.5147) rotate(-45)\"/><rect x=\"14.5858\" y=\"2.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(1.8579 12.4853) rotate(-45)\"/><rect x=\"2.5858\" y=\"2.5858\" width=\"2.8284\" height=\"2.8284\" transform=\"translate(-1.6569 4) rotate(-45)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z\"/><path d=\"M2.586 14.586H5.414V17.414H2.586z\" transform=\"rotate(-45 4 16)\"/><path d=\"M14.586 2.586H17.414V5.414H14.586z\" transform=\"rotate(-45 16 4)\"/><path d=\"M2.586 2.586H5.414V5.414H2.586z\" transform=\"rotate(-45 4 4)\"/></svg>",
            "info": {},
            "path": "32/magic-wand--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MagicWandFilled32",
          "filepath": "magic-wand--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MagicWandFilled24",
          "filepath": "magic-wand--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MagicWandFilled20",
          "filepath": "magic-wand--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MagicWandFilled16",
          "filepath": "magic-wand--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 14.586H5.414V17.414H2.586z",
                  "transform": "rotate(-45 4 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.586 2.586H17.414V5.414H14.586z",
                  "transform": "rotate(-45 16 4)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 2.586H5.414V5.414H2.586z",
                  "transform": "rotate(-45 4 4)"
                }
              }
            ],
            "name": "magic-wand--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "MagicWandFilled",
        "global": "MagicWandFilled",
        "filepath": "MagicWandFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.586 14.586H5.414V17.414H2.586z",
                    "transform": "rotate(-45 4 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.586 2.586H17.414V5.414H14.586z",
                    "transform": "rotate(-45 16 4)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.586 2.586H5.414V5.414H2.586z",
                    "transform": "rotate(-45 4 4)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "magnify",
      "friendlyName": "Magnify",
      "aliases": [
        "expand",
        "zoom",
        "amplify",
        "enhance"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/magnify.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>watson-health--magnify</title><path class=\"cls-1\" d=\"M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z\"/><path class=\"cls-1\" d=\"M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z\"/><path d=\"M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/magnify.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthMagnify32",
          "filepath": "watson-health/magnify/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z"
                }
              }
            ],
            "name": "magnify",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthMagnify24",
          "filepath": "watson-health/magnify/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z"
                }
              }
            ],
            "name": "magnify",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthMagnify20",
          "filepath": "watson-health/magnify/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z"
                }
              }
            ],
            "name": "magnify",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthMagnify16",
          "filepath": "watson-health/magnify/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z"
                }
              }
            ],
            "name": "magnify",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Magnify",
        "global": "WatsonHealthMagnify",
        "filepath": "watson-health/Magnify.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mail--all",
      "friendlyName": "Mail all",
      "aliases": [
        "email",
        "send",
        "letter",
        "reply",
        "envelope",
        "letter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mail--all.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mail--all</title><polygon points=\"16.59 20.41 20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41\"/><polygon points=\"23.59 20.41 27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41\"/><path d=\"M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.59 20.41L20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41zM23.59 20.41L27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z\"/><path d=\"M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z\"/></svg>",
            "info": {},
            "path": "32/mail--all.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MailAll32",
          "filepath": "mail--all/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.59 20.41L20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41zM23.59 20.41L27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z"
                }
              }
            ],
            "name": "mail--all",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MailAll24",
          "filepath": "mail--all/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.59 20.41L20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41zM23.59 20.41L27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z"
                }
              }
            ],
            "name": "mail--all",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MailAll20",
          "filepath": "mail--all/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.59 20.41L20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41zM23.59 20.41L27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z"
                }
              }
            ],
            "name": "mail--all",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MailAll16",
          "filepath": "mail--all/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.59 20.41L20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41zM23.59 20.41L27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z"
                }
              }
            ],
            "name": "mail--all",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MailAll",
        "global": "MailAll",
        "filepath": "MailAll.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.59 20.41L20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41zM23.59 20.41L27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mail--reply",
      "friendlyName": "Mail reply",
      "aliases": [
        "mail",
        "email",
        "reply",
        "response"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mail--reply.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>mail--reply</title>\n  <path d=\"M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z\"/>\n  <path d=\"M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z\"/><path d=\"M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z\"/></svg>",
            "info": {},
            "path": "32/mail--reply.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MailReply32",
          "filepath": "mail--reply/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z"
                }
              }
            ],
            "name": "mail--reply",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MailReply24",
          "filepath": "mail--reply/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z"
                }
              }
            ],
            "name": "mail--reply",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MailReply20",
          "filepath": "mail--reply/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z"
                }
              }
            ],
            "name": "mail--reply",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MailReply16",
          "filepath": "mail--reply/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z"
                }
              }
            ],
            "name": "mail--reply",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MailReply",
        "global": "MailReply",
        "filepath": "MailReply.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mammogram",
      "friendlyName": "Mammogram",
      "aliases": [
        "mammogram",
        "healthcare",
        "health",
        "medical"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/mammogram.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mammogram</title><polygon points=\"25 32 32 32 32 25 30 25 30 30 25 30 25 32\"/><path d=\"M25,27H22V17h3a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,25,27Zm-1-2h1a1.0006,1.0006,0,0,0,1-1V20a1.0006,1.0006,0,0,0-1-1H24Z\" transform=\"translate(0 0)\"/><path d=\"M20,27H14V23a2.002,2.002,0,0,1,2-2h2V19H14V17h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H16v2h4Z\" transform=\"translate(0 0)\"/><path d=\"M25,15H22V5h3a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,25,15Zm-1-2h1a1.0009,1.0009,0,0,0,1-1V8a1.0009,1.0009,0,0,0-1-1H24Z\" transform=\"translate(0 0)\"/><path d=\"M18,5H14V7h4V9H15v2h3v2H14v2h4a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,18,5Z\" transform=\"translate(0 0)\"/><path d=\"M10,27H8V23.9541C3.2847,23.5117,2,19.9443,2,18c0-3.0146,2.082-4.5015,3.9189-5.814C7.5723,11.0054,9,9.9854,9,8V5h2V8c0,3.0146-2.082,4.5015-3.9189,5.814C5.4277,14.9946,4,16.0146,4,18c.0054.4033.1914,4,5,4a1,1,0,0,1,1,1Z\" transform=\"translate(0 0)\"/><polygon points=\"7 0 0 0 0 7 2 7 2 2 7 2 7 0\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 32L32 32 32 25 30 25 30 30 25 30 25 32zM25 27H22V17h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 27zm-1-2h1a1.0006 1.0006 0 001-1V20a1.0006 1.0006 0 00-1-1H24zM20 27H14V23a2.002 2.002 0 012-2h2V19H14V17h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H16v2h4zM25 15H22V5h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 15zm-1-2h1a1.0009 1.0009 0 001-1V8a1.0009 1.0009 0 00-1-1H24zM18 5H14V7h4V9H15v2h3v2H14v2h4a2.0027 2.0027 0 002-2V7A2.0023 2.0023 0 0018 5zM10 27H8V23.9541C3.2847 23.5117 2 19.9443 2 18c0-3.0146 2.082-4.5015 3.9189-5.814C7.5723 11.0054 9 9.9854 9 8V5h2V8c0 3.0146-2.082 4.5015-3.9189 5.814C5.4277 14.9946 4 16.0146 4 18c.0054.4033.1914 4 5 4a1 1 0 011 1zM7 0L0 0 0 7 2 7 2 2 7 2 7 0z\"/></svg>",
            "info": {},
            "path": "32/watson-health/mammogram.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthMammogram32",
          "filepath": "watson-health/mammogram/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 32L32 32 32 25 30 25 30 30 25 30 25 32zM25 27H22V17h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 27zm-1-2h1a1.0006 1.0006 0 001-1V20a1.0006 1.0006 0 00-1-1H24zM20 27H14V23a2.002 2.002 0 012-2h2V19H14V17h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H16v2h4zM25 15H22V5h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 15zm-1-2h1a1.0009 1.0009 0 001-1V8a1.0009 1.0009 0 00-1-1H24zM18 5H14V7h4V9H15v2h3v2H14v2h4a2.0027 2.0027 0 002-2V7A2.0023 2.0023 0 0018 5zM10 27H8V23.9541C3.2847 23.5117 2 19.9443 2 18c0-3.0146 2.082-4.5015 3.9189-5.814C7.5723 11.0054 9 9.9854 9 8V5h2V8c0 3.0146-2.082 4.5015-3.9189 5.814C5.4277 14.9946 4 16.0146 4 18c.0054.4033.1914 4 5 4a1 1 0 011 1zM7 0L0 0 0 7 2 7 2 2 7 2 7 0z"
                }
              }
            ],
            "name": "mammogram",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthMammogram24",
          "filepath": "watson-health/mammogram/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 32L32 32 32 25 30 25 30 30 25 30 25 32zM25 27H22V17h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 27zm-1-2h1a1.0006 1.0006 0 001-1V20a1.0006 1.0006 0 00-1-1H24zM20 27H14V23a2.002 2.002 0 012-2h2V19H14V17h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H16v2h4zM25 15H22V5h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 15zm-1-2h1a1.0009 1.0009 0 001-1V8a1.0009 1.0009 0 00-1-1H24zM18 5H14V7h4V9H15v2h3v2H14v2h4a2.0027 2.0027 0 002-2V7A2.0023 2.0023 0 0018 5zM10 27H8V23.9541C3.2847 23.5117 2 19.9443 2 18c0-3.0146 2.082-4.5015 3.9189-5.814C7.5723 11.0054 9 9.9854 9 8V5h2V8c0 3.0146-2.082 4.5015-3.9189 5.814C5.4277 14.9946 4 16.0146 4 18c.0054.4033.1914 4 5 4a1 1 0 011 1zM7 0L0 0 0 7 2 7 2 2 7 2 7 0z"
                }
              }
            ],
            "name": "mammogram",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthMammogram20",
          "filepath": "watson-health/mammogram/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 32L32 32 32 25 30 25 30 30 25 30 25 32zM25 27H22V17h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 27zm-1-2h1a1.0006 1.0006 0 001-1V20a1.0006 1.0006 0 00-1-1H24zM20 27H14V23a2.002 2.002 0 012-2h2V19H14V17h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H16v2h4zM25 15H22V5h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 15zm-1-2h1a1.0009 1.0009 0 001-1V8a1.0009 1.0009 0 00-1-1H24zM18 5H14V7h4V9H15v2h3v2H14v2h4a2.0027 2.0027 0 002-2V7A2.0023 2.0023 0 0018 5zM10 27H8V23.9541C3.2847 23.5117 2 19.9443 2 18c0-3.0146 2.082-4.5015 3.9189-5.814C7.5723 11.0054 9 9.9854 9 8V5h2V8c0 3.0146-2.082 4.5015-3.9189 5.814C5.4277 14.9946 4 16.0146 4 18c.0054.4033.1914 4 5 4a1 1 0 011 1zM7 0L0 0 0 7 2 7 2 2 7 2 7 0z"
                }
              }
            ],
            "name": "mammogram",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthMammogram16",
          "filepath": "watson-health/mammogram/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 32L32 32 32 25 30 25 30 30 25 30 25 32zM25 27H22V17h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 27zm-1-2h1a1.0006 1.0006 0 001-1V20a1.0006 1.0006 0 00-1-1H24zM20 27H14V23a2.002 2.002 0 012-2h2V19H14V17h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H16v2h4zM25 15H22V5h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 15zm-1-2h1a1.0009 1.0009 0 001-1V8a1.0009 1.0009 0 00-1-1H24zM18 5H14V7h4V9H15v2h3v2H14v2h4a2.0027 2.0027 0 002-2V7A2.0023 2.0023 0 0018 5zM10 27H8V23.9541C3.2847 23.5117 2 19.9443 2 18c0-3.0146 2.082-4.5015 3.9189-5.814C7.5723 11.0054 9 9.9854 9 8V5h2V8c0 3.0146-2.082 4.5015-3.9189 5.814C5.4277 14.9946 4 16.0146 4 18c.0054.4033.1914 4 5 4a1 1 0 011 1zM7 0L0 0 0 7 2 7 2 2 7 2 7 0z"
                }
              }
            ],
            "name": "mammogram",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Mammogram",
        "global": "WatsonHealthMammogram",
        "filepath": "watson-health/Mammogram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 32L32 32 32 25 30 25 30 30 25 30 25 32zM25 27H22V17h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 27zm-1-2h1a1.0006 1.0006 0 001-1V20a1.0006 1.0006 0 00-1-1H24zM20 27H14V23a2.002 2.002 0 012-2h2V19H14V17h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H16v2h4zM25 15H22V5h3a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0125 15zm-1-2h1a1.0009 1.0009 0 001-1V8a1.0009 1.0009 0 00-1-1H24zM18 5H14V7h4V9H15v2h3v2H14v2h4a2.0027 2.0027 0 002-2V7A2.0023 2.0023 0 0018 5zM10 27H8V23.9541C3.2847 23.5117 2 19.9443 2 18c0-3.0146 2.082-4.5015 3.9189-5.814C7.5723 11.0054 9 9.9854 9 8V5h2V8c0 3.0146-2.082 4.5015-3.9189 5.814C5.4277 14.9946 4 16.0146 4 18c.0054.4033.1914 4 5 4a1 1 0 011 1zM7 0L0 0 0 7 2 7 2 2 7 2 7 0z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "manage-protection",
      "friendlyName": "Manage protection",
      "aliases": [
        "manage-protection",
        "security"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/manage-protection.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>manage-protection</title><path d=\"M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z\"/><path d=\"M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z\"/><path d=\"M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z\"/></svg>",
            "info": {},
            "path": "32/manage-protection.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ManageProtection32",
          "filepath": "manage-protection/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z"
                }
              }
            ],
            "name": "manage-protection",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ManageProtection24",
          "filepath": "manage-protection/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z"
                }
              }
            ],
            "name": "manage-protection",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ManageProtection20",
          "filepath": "manage-protection/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z"
                }
              }
            ],
            "name": "manage-protection",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ManageProtection16",
          "filepath": "manage-protection/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z"
                }
              }
            ],
            "name": "manage-protection",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ManageProtection",
        "global": "ManageProtection",
        "filepath": "ManageProtection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "managed-solutions",
      "friendlyName": "Managed solutions",
      "aliases": [
        "managed-solutions",
        "SaaS",
        "cloud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/managed-solutions.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>managed-solutions</title><polygon points=\"30 23 25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23\"/><path d=\"M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 23L25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z\"/><path d=\"M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z\"/></svg>",
            "info": {},
            "path": "32/managed-solutions.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ManagedSolutions32",
          "filepath": "managed-solutions/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23L25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z"
                }
              }
            ],
            "name": "managed-solutions",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ManagedSolutions24",
          "filepath": "managed-solutions/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23L25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z"
                }
              }
            ],
            "name": "managed-solutions",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ManagedSolutions20",
          "filepath": "managed-solutions/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23L25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z"
                }
              }
            ],
            "name": "managed-solutions",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ManagedSolutions16",
          "filepath": "managed-solutions/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23L25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z"
                }
              }
            ],
            "name": "managed-solutions",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ManagedSolutions",
        "global": "ManagedSolutions",
        "filepath": "ManagedSolutions.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 23L25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "map",
      "friendlyName": "Map",
      "aliases": [
        "atlas",
        "locate",
        "gps",
        "location",
        "graph",
        "directions",
        "diagram",
        "plan",
        "legend"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/map.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>map</title><path d=\"M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z\" transform=\"translate(0 0)\"/><circle cx=\"16\" cy=\"9\" r=\"2\"/><path d=\"M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z\"/><circle cx=\"16\" cy=\"9\" r=\"2\"/><path d=\"M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z\"/></svg>",
            "info": {},
            "path": "32/map.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Map32",
          "filepath": "map/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z"
                }
              }
            ],
            "name": "map",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Map24",
          "filepath": "map/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z"
                }
              }
            ],
            "name": "map",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Map20",
          "filepath": "map/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z"
                }
              }
            ],
            "name": "map",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Map16",
          "filepath": "map/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "9",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z"
                }
              }
            ],
            "name": "map",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Map",
        "global": "Map",
        "filepath": "Map.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "9",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "map--center",
      "friendlyName": "Map center",
      "aliases": [
        "map",
        "travel",
        "point",
        "pin",
        "center",
        "atlas",
        "locate",
        "gps",
        "location",
        "graph",
        "directions",
        "diagram",
        "plan",
        "legend"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/map--center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"23\" y=\"26\" width=\"2\" height=\"4\"/>\n  <rect x=\"23\" y=\"18\" width=\"2\" height=\"4\"/>\n  <rect x=\"26\" y=\"23\" width=\"4\" height=\"2\"/>\n  <rect x=\"18\" y=\"23\" width=\"4\" height=\"2\"/>\n  <path d=\"M25.3418,10.06l-22-8A1,1,0,0,0,2.06,3.3415l8,22A1.0011,1.0011,0,0,0,10.9839,26H11a1,1,0,0,0,.9287-.6289L15.77,15.7692l9.6015-3.8408a1,1,0,0,0-.0293-1.8687ZM14.6284,14.0709v0l-.3979.1591-.1591.3979,0,0-3.0268,7.5678L4.6719,4.6715l17.5244,6.3726Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 26H25V30H23zM23 18H25V22H23zM26 23H30V25H26zM18 23H22V25H18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.0011 1.0011 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6015-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0268 7.5678L4.6719 4.6715l17.5244 6.3726z\"/></svg>",
            "info": {},
            "path": "32/map--center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MapCenter32",
          "filepath": "map--center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26H25V30H23zM23 18H25V22H23zM26 23H30V25H26zM18 23H22V25H18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.0011 1.0011 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6015-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0268 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "map--center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MapCenter24",
          "filepath": "map--center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26H25V30H23zM23 18H25V22H23zM26 23H30V25H26zM18 23H22V25H18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.0011 1.0011 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6015-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0268 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "map--center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MapCenter20",
          "filepath": "map--center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26H25V30H23zM23 18H25V22H23zM26 23H30V25H26zM18 23H22V25H18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.0011 1.0011 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6015-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0268 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "map--center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MapCenter16",
          "filepath": "map--center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26H25V30H23zM23 18H25V22H23zM26 23H30V25H26zM18 23H22V25H18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.0011 1.0011 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6015-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0268 7.5678L4.6719 4.6715l17.5244 6.3726z"
                }
              }
            ],
            "name": "map--center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "MapCenter",
        "global": "MapCenter",
        "filepath": "MapCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 26H25V30H23zM23 18H25V22H23zM26 23H30V25H26zM18 23H22V25H18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.0011 1.0011 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6015-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0268 7.5678L4.6719 4.6715l17.5244 6.3726z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "map--identify",
      "friendlyName": "Map identify",
      "aliases": [
        "map",
        "travel",
        "point",
        "identify",
        "target",
        "exact",
        "ID",
        "center",
        "locate",
        "location",
        "graph"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/map--identify.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15\" y=\"8\" width=\"2\" height=\"6\"/>\n  <rect x=\"15\" y=\"18\" width=\"2\" height=\"6\"/>\n  <rect x=\"18\" y=\"15\" width=\"6\" height=\"2\"/>\n  <rect x=\"8\" y=\"15\" width=\"6\" height=\"2\"/>\n  <path d=\"M4,10H2V4A2.0021,2.0021,0,0,1,4,2h6V4H4Z\"/>\n  <path d=\"M10,30H4a2.0021,2.0021,0,0,1-2-2V22H4v6h6Z\"/>\n  <path d=\"M28,30H22V28h6V22h2v6A2.0021,2.0021,0,0,1,28,30Z\"/>\n  <path d=\"M30,10H28V4H22V2h6a2.0021,2.0021,0,0,1,2,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 8H17V14H15zM15 18H17V24H15zM18 15H24V17H18zM8 15H14V17H8zM4 10H2V4A2.0021 2.0021 0 014 2h6V4H4zM10 30H4a2.0021 2.0021 0 01-2-2V22H4v6h6zM28 30H22V28h6V22h2v6A2.0021 2.0021 0 0128 30zM30 10H28V4H22V2h6a2.0021 2.0021 0 012 2z\"/></svg>",
            "info": {},
            "path": "32/map--identify.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MapIdentify32",
          "filepath": "map--identify/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V14H15zM15 18H17V24H15zM18 15H24V17H18zM8 15H14V17H8zM4 10H2V4A2.0021 2.0021 0 014 2h6V4H4zM10 30H4a2.0021 2.0021 0 01-2-2V22H4v6h6zM28 30H22V28h6V22h2v6A2.0021 2.0021 0 0128 30zM30 10H28V4H22V2h6a2.0021 2.0021 0 012 2z"
                }
              }
            ],
            "name": "map--identify",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MapIdentify24",
          "filepath": "map--identify/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V14H15zM15 18H17V24H15zM18 15H24V17H18zM8 15H14V17H8zM4 10H2V4A2.0021 2.0021 0 014 2h6V4H4zM10 30H4a2.0021 2.0021 0 01-2-2V22H4v6h6zM28 30H22V28h6V22h2v6A2.0021 2.0021 0 0128 30zM30 10H28V4H22V2h6a2.0021 2.0021 0 012 2z"
                }
              }
            ],
            "name": "map--identify",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MapIdentify20",
          "filepath": "map--identify/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V14H15zM15 18H17V24H15zM18 15H24V17H18zM8 15H14V17H8zM4 10H2V4A2.0021 2.0021 0 014 2h6V4H4zM10 30H4a2.0021 2.0021 0 01-2-2V22H4v6h6zM28 30H22V28h6V22h2v6A2.0021 2.0021 0 0128 30zM30 10H28V4H22V2h6a2.0021 2.0021 0 012 2z"
                }
              }
            ],
            "name": "map--identify",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MapIdentify16",
          "filepath": "map--identify/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V14H15zM15 18H17V24H15zM18 15H24V17H18zM8 15H14V17H8zM4 10H2V4A2.0021 2.0021 0 014 2h6V4H4zM10 30H4a2.0021 2.0021 0 01-2-2V22H4v6h6zM28 30H22V28h6V22h2v6A2.0021 2.0021 0 0128 30zM30 10H28V4H22V2h6a2.0021 2.0021 0 012 2z"
                }
              }
            ],
            "name": "map--identify",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "MapIdentify",
        "global": "MapIdentify",
        "filepath": "MapIdentify.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 8H17V14H15zM15 18H17V24H15zM18 15H24V17H18zM8 15H14V17H8zM4 10H2V4A2.0021 2.0021 0 014 2h6V4H4zM10 30H4a2.0021 2.0021 0 01-2-2V22H4v6h6zM28 30H22V28h6V22h2v6A2.0021 2.0021 0 0128 30zM30 10H28V4H22V2h6a2.0021 2.0021 0 012 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "map-boundary",
      "friendlyName": "Map boundary",
      "aliases": [
        "place",
        "locate",
        "destination",
        "map",
        "site",
        "area",
        "location",
        "boundary",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/map-boundary.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"12\" y=\"10\" width=\"2\" height=\"4\"/>\n  <rect x=\"18\" y=\"18\" width=\"4\" height=\"2\"/>\n  <polygon points=\"14 18 14 16 12 16 12 20 16 20 16 18 14 18\"/>\n  <rect x=\"16\" y=\"4\" width=\"12\" height=\"12\"/>\n  <polygon points=\"17.885 29.997 11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 10H14V14H12zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM16 4H28V16H16z\"/><path d=\"M17.885 29.997L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z\"/></svg>",
            "info": {},
            "path": "32/map-boundary.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MapBoundary32",
          "filepath": "map-boundary/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H14V14H12zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM16 4H28V16H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 29.997L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z"
                }
              }
            ],
            "name": "map-boundary",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MapBoundary24",
          "filepath": "map-boundary/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H14V14H12zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM16 4H28V16H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 29.997L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z"
                }
              }
            ],
            "name": "map-boundary",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MapBoundary20",
          "filepath": "map-boundary/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H14V14H12zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM16 4H28V16H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 29.997L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z"
                }
              }
            ],
            "name": "map-boundary",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MapBoundary16",
          "filepath": "map-boundary/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H14V14H12zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM16 4H28V16H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 29.997L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z"
                }
              }
            ],
            "name": "map-boundary",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "MapBoundary",
        "global": "MapBoundary",
        "filepath": "MapBoundary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 10H14V14H12zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM16 4H28V16H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.885 29.997L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "map-boundary--vegetation",
      "friendlyName": "Map boundary vegetation",
      "aliases": [
        "place",
        "locate",
        "destination",
        "map",
        "site",
        "area",
        "location",
        "boundary",
        "travel",
        "vegetation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/map-boundary--vegetation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,16H18V14h5V10a2,2,0,0,1,2-2h1.5a1.5,1.5,0,0,0,.2837-2.9734l-.7109-.1355L25.9982,4.32a2.6322,2.6322,0,0,0-1.68-2.1823,2.5051,2.5051,0,0,0-3.0836,1.3042l-.3032.6472-.71-.0771a2.0185,2.0185,0,0,0-2.17,2.4343A2.0976,2.0976,0,0,0,20.1261,8H21v2h-.7817A4.1491,4.1491,0,0,1,16.012,6.3136a4.0047,4.0047,0,0,1,3.7414-4.306A4.5006,4.5006,0,0,1,27.8267,3.26a3.5051,3.5051,0,0,1,2.1422,3.7094A3.6283,3.6283,0,0,1,26.3172,10H25v4h3Z\"/>\n  <rect x=\"18\" y=\"18\" width=\"4\" height=\"2\"/>\n  <polygon points=\"14 18 14 16 12 16 12 20 16 20 16 18 14 18\"/>\n  <rect x=\"12\" y=\"10\" width=\"2\" height=\"4\"/>\n  <polygon points=\"17.885 30 11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 16H18V14h5V10a2 2 0 012-2h1.5a1.5 1.5 0 00.2837-2.9734l-.7109-.1355L25.9982 4.32a2.6322 2.6322 0 00-1.68-2.1823 2.5051 2.5051 0 00-3.0836 1.3042l-.3032.6472-.71-.0771a2.0185 2.0185 0 00-2.17 2.4343A2.0976 2.0976 0 0020.1261 8H21v2h-.7817A4.1491 4.1491 0 0116.012 6.3136a4.0047 4.0047 0 013.7414-4.306A4.5006 4.5006 0 0127.8267 3.26a3.5051 3.5051 0 012.1422 3.7094A3.6283 3.6283 0 0126.3172 10H25v4h3zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM12 10H14V14H12z\"/><path d=\"M17.885 30L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z\"/></svg>",
            "info": {},
            "path": "32/map-boundary--vegetation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MapBoundaryVegetation32",
          "filepath": "map-boundary--vegetation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16H18V14h5V10a2 2 0 012-2h1.5a1.5 1.5 0 00.2837-2.9734l-.7109-.1355L25.9982 4.32a2.6322 2.6322 0 00-1.68-2.1823 2.5051 2.5051 0 00-3.0836 1.3042l-.3032.6472-.71-.0771a2.0185 2.0185 0 00-2.17 2.4343A2.0976 2.0976 0 0020.1261 8H21v2h-.7817A4.1491 4.1491 0 0116.012 6.3136a4.0047 4.0047 0 013.7414-4.306A4.5006 4.5006 0 0127.8267 3.26a3.5051 3.5051 0 012.1422 3.7094A3.6283 3.6283 0 0126.3172 10H25v4h3zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM12 10H14V14H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 30L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z"
                }
              }
            ],
            "name": "map-boundary--vegetation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MapBoundaryVegetation24",
          "filepath": "map-boundary--vegetation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16H18V14h5V10a2 2 0 012-2h1.5a1.5 1.5 0 00.2837-2.9734l-.7109-.1355L25.9982 4.32a2.6322 2.6322 0 00-1.68-2.1823 2.5051 2.5051 0 00-3.0836 1.3042l-.3032.6472-.71-.0771a2.0185 2.0185 0 00-2.17 2.4343A2.0976 2.0976 0 0020.1261 8H21v2h-.7817A4.1491 4.1491 0 0116.012 6.3136a4.0047 4.0047 0 013.7414-4.306A4.5006 4.5006 0 0127.8267 3.26a3.5051 3.5051 0 012.1422 3.7094A3.6283 3.6283 0 0126.3172 10H25v4h3zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM12 10H14V14H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 30L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z"
                }
              }
            ],
            "name": "map-boundary--vegetation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MapBoundaryVegetation20",
          "filepath": "map-boundary--vegetation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16H18V14h5V10a2 2 0 012-2h1.5a1.5 1.5 0 00.2837-2.9734l-.7109-.1355L25.9982 4.32a2.6322 2.6322 0 00-1.68-2.1823 2.5051 2.5051 0 00-3.0836 1.3042l-.3032.6472-.71-.0771a2.0185 2.0185 0 00-2.17 2.4343A2.0976 2.0976 0 0020.1261 8H21v2h-.7817A4.1491 4.1491 0 0116.012 6.3136a4.0047 4.0047 0 013.7414-4.306A4.5006 4.5006 0 0127.8267 3.26a3.5051 3.5051 0 012.1422 3.7094A3.6283 3.6283 0 0126.3172 10H25v4h3zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM12 10H14V14H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 30L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z"
                }
              }
            ],
            "name": "map-boundary--vegetation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MapBoundaryVegetation16",
          "filepath": "map-boundary--vegetation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16H18V14h5V10a2 2 0 012-2h1.5a1.5 1.5 0 00.2837-2.9734l-.7109-.1355L25.9982 4.32a2.6322 2.6322 0 00-1.68-2.1823 2.5051 2.5051 0 00-3.0836 1.3042l-.3032.6472-.71-.0771a2.0185 2.0185 0 00-2.17 2.4343A2.0976 2.0976 0 0020.1261 8H21v2h-.7817A4.1491 4.1491 0 0116.012 6.3136a4.0047 4.0047 0 013.7414-4.306A4.5006 4.5006 0 0127.8267 3.26a3.5051 3.5051 0 012.1422 3.7094A3.6283 3.6283 0 0126.3172 10H25v4h3zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM12 10H14V14H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.885 30L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z"
                }
              }
            ],
            "name": "map-boundary--vegetation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "MapBoundaryVegetation",
        "global": "MapBoundaryVegetation",
        "filepath": "MapBoundaryVegetation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 16H18V14h5V10a2 2 0 012-2h1.5a1.5 1.5 0 00.2837-2.9734l-.7109-.1355L25.9982 4.32a2.6322 2.6322 0 00-1.68-2.1823 2.5051 2.5051 0 00-3.0836 1.3042l-.3032.6472-.71-.0771a2.0185 2.0185 0 00-2.17 2.4343A2.0976 2.0976 0 0020.1261 8H21v2h-.7817A4.1491 4.1491 0 0116.012 6.3136a4.0047 4.0047 0 013.7414-4.306A4.5006 4.5006 0 0127.8267 3.26a3.5051 3.5051 0 012.1422 3.7094A3.6283 3.6283 0 0126.3172 10H25v4h3zM18 18H22V20H18zM14 18L14 16 12 16 12 20 16 20 16 18 14 18zM12 10H14V14H12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.885 30L11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "marine-warning",
      "friendlyName": "Marine warning",
      "aliases": [
        "weather",
        "marine",
        "warning",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/marine-warning.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z\" transform=\"translate(0 0)\"/>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z\"/><path d=\"M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z\"/><path fill=\"none\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\"/><path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\"/></svg>",
            "info": {},
            "path": "32/marine-warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MarineWarning32",
          "filepath": "marine-warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "marine-warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MarineWarning24",
          "filepath": "marine-warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "marine-warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MarineWarning20",
          "filepath": "marine-warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "marine-warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MarineWarning16",
          "filepath": "marine-warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "marine-warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "MarineWarning",
        "global": "MarineWarning",
        "filepath": "MarineWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "math-curve",
      "friendlyName": "Math curve",
      "aliases": [
        "math",
        "curve",
        "plot",
        "chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/math-curve.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>math-curve</title>\n  <path d=\"M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z\"/></svg>",
            "info": {},
            "path": "32/math-curve.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MathCurve32",
          "filepath": "math-curve/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z"
                }
              }
            ],
            "name": "math-curve",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MathCurve24",
          "filepath": "math-curve/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z"
                }
              }
            ],
            "name": "math-curve",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MathCurve20",
          "filepath": "math-curve/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z"
                }
              }
            ],
            "name": "math-curve",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MathCurve16",
          "filepath": "math-curve/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z"
                }
              }
            ],
            "name": "math-curve",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "MathCurve",
        "global": "MathCurve",
        "filepath": "MathCurve.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "matrix",
      "friendlyName": "Matrix",
      "aliases": [
        "cast",
        "grid",
        "model",
        "binary"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/matrix.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>research--matrix</title><polygon points=\"18 13 18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13\"/><path d=\"M16.5,20A3.5,3.5,0,1,1,13,23.5,3.5,3.5,0,0,1,16.5,20m0-2A5.5,5.5,0,1,0,22,23.5,5.5,5.5,0,0,0,16.5,18Z\"/><polygon points=\"8 30 2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30\"/><polygon points=\"30 30 24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z\"/></svg>",
            "info": {},
            "path": "32/Q/matrix.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QMatrix32",
          "filepath": "Q/matrix/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              }
            ],
            "name": "matrix",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QMatrix24",
          "filepath": "Q/matrix/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              }
            ],
            "name": "matrix",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QMatrix20",
          "filepath": "Q/matrix/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              }
            ],
            "name": "matrix",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QMatrix16",
          "filepath": "Q/matrix/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                }
              }
            ],
            "name": "matrix",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "Matrix",
        "global": "QMatrix",
        "filepath": "Q/Matrix.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "maximize",
      "friendlyName": "Maximize",
      "aliases": [
        "enlarge",
        "full screen",
        "expand",
        "magnify",
        "stretch",
        "open",
        "minimize"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/maximize.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.6, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>maximize</title>\n<polygon points=\"6,15 6,14 2.7,14 7,9.7 6.3,9 2,13.3 2,10 1,10 1,15 \"/>\n<polygon points=\"10,1 10,2 13.3,2 9,6.3 9.7,7 14,2.7 14,6 15,6 15,1 \"/>\n<polyline id=\"_Transparent_Rectangle__1_\" class=\"st0\" points=\"-0.2,-0.1 15.8,-0.1 15.8,15.9 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M6 15L6 14 2.7 14 7 9.7 6.3 9 2 13.3 2 10 1 10 1 15zM10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z\"/></svg>",
            "info": {},
            "path": "16/maximize.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/maximize.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"20 2 20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2\"/>\n  <polygon points=\"14 19.416 12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 2L20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2zM14 19.416L12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416z\"/></svg>",
            "info": {},
            "path": "32/maximize.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Maximize32",
          "filepath": "maximize/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 2L20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2zM14 19.416L12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416z"
                }
              }
            ],
            "name": "maximize",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Maximize24",
          "filepath": "maximize/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 2L20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2zM14 19.416L12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416z"
                }
              }
            ],
            "name": "maximize",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Maximize20",
          "filepath": "maximize/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 2L20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2zM14 19.416L12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416z"
                }
              }
            ],
            "name": "maximize",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Maximize16",
          "filepath": "maximize/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15L6 14 2.7 14 7 9.7 6.3 9 2 13.3 2 10 1 10 1 15zM10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
                }
              }
            ],
            "name": "maximize",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Maximize",
        "global": "Maximize",
        "filepath": "Maximize.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 15L6 14 2.7 14 7 9.7 6.3 9 2 13.3 2 10 1 10 1 15zM10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 2L20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2zM14 19.416L12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "media--library",
      "friendlyName": "Media library",
      "aliases": [
        "media",
        "library",
        "file",
        "repository",
        "folder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/media--library.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"13 15 13 23 13 23 20 19 13 15\"/>\n  <path d=\"M26,28H6a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28ZM6,12V26H26V12Z\"/>\n  <rect x=\"6\" y=\"6\" width=\"20\" height=\"2\"/>\n  <rect x=\"8\" y=\"2\" width=\"16\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 15L13 23 13 23 20 19 13 15z\"/><path d=\"M26 28H6a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM6 12V26H26V12zM6 6H26V8H6zM8 2H24V4H8z\"/></svg>",
            "info": {},
            "path": "32/media--library.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MediaLibrary32",
          "filepath": "media--library/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15L13 23 13 23 20 19 13 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM6 12V26H26V12zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MediaLibrary24",
          "filepath": "media--library/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15L13 23 13 23 20 19 13 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM6 12V26H26V12zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MediaLibrary20",
          "filepath": "media--library/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15L13 23 13 23 20 19 13 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM6 12V26H26V12zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MediaLibrary16",
          "filepath": "media--library/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15L13 23 13 23 20 19 13 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H6a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM6 12V26H26V12zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "MediaLibrary",
        "global": "MediaLibrary",
        "filepath": "MediaLibrary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 15L13 23 13 23 20 19 13 15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 28H6a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM6 12V26H26V12zM6 6H26V8H6zM8 2H24V4H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "media--library--filled",
      "friendlyName": "Media library filled",
      "aliases": [
        "media",
        "library",
        "filled",
        "file",
        "repository",
        "folder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/media--library--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"13 15 13 23 13 23 20 19 13 15\"/>\n  <path d=\"M26,10H6a2.0023,2.0023,0,0,0-2,2V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,26,10ZM13,23h0V15l7,4Z\"/>\n  <rect x=\"6\" y=\"6\" width=\"20\" height=\"2\"/>\n  <rect x=\"8\" y=\"2\" width=\"16\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M13 15L13 23 13 23 20 19 13 15z\" data-icon-path=\"inner-path\"/><path d=\"M26 10H6a2.0023 2.0023 0 00-2 2V26a2.0023 2.0023 0 002 2H26a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0026 10zM13 23h0V15l7 4zM6 6H26V8H6zM8 2H24V4H8z\"/></svg>",
            "info": {},
            "path": "32/media--library--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MediaLibraryFilled32",
          "filepath": "media--library--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M13 15L13 23 13 23 20 19 13 15z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H6a2.0023 2.0023 0 00-2 2V26a2.0023 2.0023 0 002 2H26a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0026 10zM13 23h0V15l7 4zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MediaLibraryFilled24",
          "filepath": "media--library--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M13 15L13 23 13 23 20 19 13 15z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H6a2.0023 2.0023 0 00-2 2V26a2.0023 2.0023 0 002 2H26a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0026 10zM13 23h0V15l7 4zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MediaLibraryFilled20",
          "filepath": "media--library--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M13 15L13 23 13 23 20 19 13 15z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H6a2.0023 2.0023 0 00-2 2V26a2.0023 2.0023 0 002 2H26a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0026 10zM13 23h0V15l7 4zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MediaLibraryFilled16",
          "filepath": "media--library--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M13 15L13 23 13 23 20 19 13 15z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 10H6a2.0023 2.0023 0 00-2 2V26a2.0023 2.0023 0 002 2H26a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0026 10zM13 23h0V15l7 4zM6 6H26V8H6zM8 2H24V4H8z"
                }
              }
            ],
            "name": "media--library--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "MediaLibraryFilled",
        "global": "MediaLibraryFilled",
        "filepath": "MediaLibraryFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M13 15L13 23 13 23 20 19 13 15z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 10H6a2.0023 2.0023 0 00-2 2V26a2.0023 2.0023 0 002 2H26a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0026 10zM13 23h0V15l7 4zM6 6H26V8H6zM8 2H24V4H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "media-cast",
      "friendlyName": "Media cast",
      "aliases": [
        "media",
        "broadcast",
        "cast",
        "play",
        "stream"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/media-cast.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M2,26H5a3,3,0,0,0-3-3Z\"/>\n  <path d=\"M9,26H7a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,9,26Z\"/>\n  <path d=\"M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z\"/>\n  <path d=\"M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 26H5a3 3 0 00-3-3zM9 26H7a5.0057 5.0057 0 00-5-5V19A7.0078 7.0078 0 019 26z\"/><path d=\"M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z\"/><path d=\"M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z\"/></svg>",
            "info": {},
            "path": "32/media-cast.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MediaCast32",
          "filepath": "media-cast/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H5a3 3 0 00-3-3zM9 26H7a5.0057 5.0057 0 00-5-5V19A7.0078 7.0078 0 019 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z"
                }
              }
            ],
            "name": "media-cast",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MediaCast24",
          "filepath": "media-cast/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H5a3 3 0 00-3-3zM9 26H7a5.0057 5.0057 0 00-5-5V19A7.0078 7.0078 0 019 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z"
                }
              }
            ],
            "name": "media-cast",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MediaCast20",
          "filepath": "media-cast/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H5a3 3 0 00-3-3zM9 26H7a5.0057 5.0057 0 00-5-5V19A7.0078 7.0078 0 019 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z"
                }
              }
            ],
            "name": "media-cast",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MediaCast16",
          "filepath": "media-cast/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H5a3 3 0 00-3-3zM9 26H7a5.0057 5.0057 0 00-5-5V19A7.0078 7.0078 0 019 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z"
                }
              }
            ],
            "name": "media-cast",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MediaCast",
        "global": "MediaCast",
        "filepath": "MediaCast.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 26H5a3 3 0 00-3-3zM9 26H7a5.0057 5.0057 0 00-5-5V19A7.0078 7.0078 0 019 26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "medication",
      "friendlyName": "Medication",
      "aliases": [
        "medicine",
        "drug",
        "treatment",
        "remedy",
        "medicate",
        "assistance",
        "placebo",
        "pill",
        "antidote",
        "rx",
        "prescription"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/medication.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>medication</title><path d=\"M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z\"/></svg>",
            "info": {},
            "path": "32/medication.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Medication32",
          "filepath": "medication/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "medication",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Medication24",
          "filepath": "medication/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "medication",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Medication20",
          "filepath": "medication/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "medication",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Medication16",
          "filepath": "medication/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z"
                }
              }
            ],
            "name": "medication",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Medication",
        "global": "Medication",
        "filepath": "Medication.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "medication--alert",
      "friendlyName": "Medication alert",
      "aliases": [
        "medicine",
        "drug",
        "treatment",
        "remedy",
        "medicate",
        "assistance",
        "placebo",
        "pill",
        "antidote",
        "rx",
        "prescription"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/medication--alert.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>medication--alert</title><rect x=\"22\" y=\"19\" width=\"2\" height=\"5\"/><path d=\"M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z\"/><circle cx=\"23\" cy=\"26\" r=\"1\"/><path d=\"M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 19H24V24H22z\"/><path d=\"M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z\"/><circle cx=\"23\" cy=\"26\" r=\"1\"/><path d=\"M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z\"/></svg>",
            "info": {},
            "path": "32/medication--alert.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MedicationAlert32",
          "filepath": "medication--alert/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19H24V24H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z"
                }
              }
            ],
            "name": "medication--alert",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MedicationAlert24",
          "filepath": "medication--alert/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19H24V24H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z"
                }
              }
            ],
            "name": "medication--alert",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MedicationAlert20",
          "filepath": "medication--alert/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19H24V24H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z"
                }
              }
            ],
            "name": "medication--alert",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MedicationAlert16",
          "filepath": "medication--alert/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19H24V24H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "26",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z"
                }
              }
            ],
            "name": "medication--alert",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "MedicationAlert",
        "global": "MedicationAlert",
        "filepath": "MedicationAlert.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 19H24V24H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "26",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "medication--reminder",
      "friendlyName": "Medication reminder",
      "aliases": [
        "medicine",
        "drug",
        "treatment",
        "remedy",
        "medicate",
        "assistance",
        "placebo",
        "pill",
        "antidote",
        "rx",
        "prescription"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/medication--reminder.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>medication--reminder</title><path d=\"M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z\" transform=\"translate(0 0)\"/><circle cx=\"26\" cy=\"16\" r=\"4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z\"/><circle cx=\"26\" cy=\"16\" r=\"4\"/></svg>",
            "info": {},
            "path": "32/medication--reminder.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MedicationReminder32",
          "filepath": "medication--reminder/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              }
            ],
            "name": "medication--reminder",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MedicationReminder24",
          "filepath": "medication--reminder/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              }
            ],
            "name": "medication--reminder",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MedicationReminder20",
          "filepath": "medication--reminder/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              }
            ],
            "name": "medication--reminder",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MedicationReminder16",
          "filepath": "medication--reminder/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              }
            ],
            "name": "medication--reminder",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "MedicationReminder",
        "global": "MedicationReminder",
        "filepath": "MedicationReminder.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "16",
                    "r": "4"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "menu",
      "friendlyName": "Menu",
      "aliases": [
        "left nav",
        "drawer",
        "list",
        "nav",
        "navigation"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/menu.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<rect x=\"2\" y=\"12\" width=\"12\" height=\"1\"/>\n<rect x=\"2\" y=\"9\" width=\"12\" height=\"1\"/>\n<rect x=\"2\" y=\"6\" width=\"12\" height=\"1\"/>\n<rect x=\"2\" y=\"3\" width=\"12\" height=\"1\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M2 12H14V13H2zM2 9H14V10H2zM2 6H14V7H2zM2 3H14V4H2z\"/></svg>",
            "info": {},
            "path": "16/menu.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/menu.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<rect x=\"2\" y=\"14.8\" width=\"16\" height=\"1.2\"/>\n<rect x=\"2\" y=\"11.2\" width=\"16\" height=\"1.2\"/>\n<rect x=\"2\" y=\"7.6\" width=\"16\" height=\"1.2\"/>\n<rect x=\"2\" y=\"4\" width=\"16\" height=\"1.2\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 14.8H18V16H2zM2 11.2H18V12.399999999999999H2zM2 7.6H18V8.799999999999999H2zM2 4H18V5.2H2z\"/></svg>",
            "info": {},
            "path": "20/menu.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/menu.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<rect x=\"3\" y=\"18\" width=\"18\" height=\"1.5\"/>\n<rect x=\"3\" y=\"13.5\" width=\"18\" height=\"1.5\"/>\n<rect x=\"3\" y=\"9\" width=\"18\" height=\"1.5\"/>\n<rect x=\"3\" y=\"4.5\" width=\"18\" height=\"1.5\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M3 18H21V19.5H3zM3 13.5H21V15H3zM3 9H21V10.5H3zM3 4.5H21V6H3z\"/></svg>",
            "info": {},
            "path": "24/menu.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/menu.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>menu</title><rect x=\"4\" y=\"6\" width=\"24\" height=\"2\"/><rect x=\"4\" y=\"24\" width=\"24\" height=\"2\"/><rect x=\"4\" y=\"12\" width=\"24\" height=\"2\"/><rect x=\"4\" y=\"18\" width=\"24\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 6H28V8H4zM4 24H28V26H4zM4 12H28V14H4zM4 18H28V20H4z\"/></svg>",
            "info": {},
            "path": "32/menu.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Menu32",
          "filepath": "menu/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H28V8H4zM4 24H28V26H4zM4 12H28V14H4zM4 18H28V20H4z"
                }
              }
            ],
            "name": "menu",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Menu24",
          "filepath": "menu/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 18H21V19.5H3zM3 13.5H21V15H3zM3 9H21V10.5H3zM3 4.5H21V6H3z"
                }
              }
            ],
            "name": "menu",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Menu20",
          "filepath": "menu/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 14.8H18V16H2zM2 11.2H18V12.399999999999999H2zM2 7.6H18V8.799999999999999H2zM2 4H18V5.2H2z"
                }
              }
            ],
            "name": "menu",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Menu16",
          "filepath": "menu/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 12H14V13H2zM2 9H14V10H2zM2 6H14V7H2zM2 3H14V4H2z"
                }
              }
            ],
            "name": "menu",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Menu",
        "global": "Menu",
        "filepath": "Menu.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 12H14V13H2zM2 9H14V10H2zM2 6H14V7H2zM2 3H14V4H2z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 14.8H18V16H2zM2 11.2H18V12.399999999999999H2zM2 7.6H18V8.799999999999999H2zM2 4H18V5.2H2z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 18H21V19.5H3zM3 13.5H21V15H3zM3 9H21V10.5H3zM3 4.5H21V6H3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 6H28V8H4zM4 24H28V26H4zM4 12H28V14H4zM4 18H28V20H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "message-queue",
      "friendlyName": "Message queue",
      "aliases": [
        "message",
        "queue",
        "inbox"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/message-queue.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"7\" y=\"21\" width=\"18\" height=\"2\"/>\n  <rect x=\"7\" y=\"16\" width=\"18\" height=\"2\"/>\n  <rect x=\"7\" y=\"11\" width=\"18\" height=\"2\"/>\n  <rect x=\"7\" y=\"6\" width=\"18\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z\"/><path d=\"M7 21H25V23H7zM7 16H25V18H7zM7 11H25V13H7zM7 6H25V8H7z\"/></svg>",
            "info": {},
            "path": "32/message-queue.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MessageQueue32",
          "filepath": "message-queue/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 21H25V23H7zM7 16H25V18H7zM7 11H25V13H7zM7 6H25V8H7z"
                }
              }
            ],
            "name": "message-queue",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MessageQueue24",
          "filepath": "message-queue/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 21H25V23H7zM7 16H25V18H7zM7 11H25V13H7zM7 6H25V8H7z"
                }
              }
            ],
            "name": "message-queue",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MessageQueue20",
          "filepath": "message-queue/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 21H25V23H7zM7 16H25V18H7zM7 11H25V13H7zM7 6H25V8H7z"
                }
              }
            ],
            "name": "message-queue",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MessageQueue16",
          "filepath": "message-queue/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 21H25V23H7zM7 16H25V18H7zM7 11H25V13H7zM7 6H25V8H7z"
                }
              }
            ],
            "name": "message-queue",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "MessageQueue",
        "global": "MessageQueue",
        "filepath": "MessageQueue.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 21H25V23H7zM7 16H25V18H7zM7 11H25V13H7zM7 6H25V8H7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "meter",
      "friendlyName": "Meter",
      "aliases": [
        "meter",
        "gauge"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/meter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>meter</title><path d=\"M26,16a9.9283,9.9283,0,0,0-1.1392-4.6182l-1.4961,1.4961A7.9483,7.9483,0,0,1,24,16Z\"/><path d=\"M23.4141,10,22,8.5859l-4.7147,4.7147A2.9659,2.9659,0,0,0,16,13a3,3,0,1,0,3,3,2.9659,2.9659,0,0,0-.3006-1.2853ZM16,17a1,1,0,1,1,1-1A1.0013,1.0013,0,0,1,16,17Z\"/><path d=\"M16,8a7.9515,7.9515,0,0,1,3.1223.6353l1.4961-1.4961A9.9864,9.9864,0,0,0,6,16H8A8.0092,8.0092,0,0,1,16,8Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 16a9.9283 9.9283 0 00-1.1392-4.6182l-1.4961 1.4961A7.9483 7.9483 0 0124 16zM23.4141 10L22 8.5859l-4.7147 4.7147A2.9659 2.9659 0 0016 13a3 3 0 103 3 2.9659 2.9659 0 00-.3006-1.2853zM16 17a1 1 0 111-1A1.0013 1.0013 0 0116 17zM16 8a7.9515 7.9515 0 013.1223.6353l1.4961-1.4961A9.9864 9.9864 0 006 16H8A8.0092 8.0092 0 0116 8z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/meter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Meter32",
          "filepath": "meter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16a9.9283 9.9283 0 00-1.1392-4.6182l-1.4961 1.4961A7.9483 7.9483 0 0124 16zM23.4141 10L22 8.5859l-4.7147 4.7147A2.9659 2.9659 0 0016 13a3 3 0 103 3 2.9659 2.9659 0 00-.3006-1.2853zM16 17a1 1 0 111-1A1.0013 1.0013 0 0116 17zM16 8a7.9515 7.9515 0 013.1223.6353l1.4961-1.4961A9.9864 9.9864 0 006 16H8A8.0092 8.0092 0 0116 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "meter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Meter24",
          "filepath": "meter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16a9.9283 9.9283 0 00-1.1392-4.6182l-1.4961 1.4961A7.9483 7.9483 0 0124 16zM23.4141 10L22 8.5859l-4.7147 4.7147A2.9659 2.9659 0 0016 13a3 3 0 103 3 2.9659 2.9659 0 00-.3006-1.2853zM16 17a1 1 0 111-1A1.0013 1.0013 0 0116 17zM16 8a7.9515 7.9515 0 013.1223.6353l1.4961-1.4961A9.9864 9.9864 0 006 16H8A8.0092 8.0092 0 0116 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "meter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Meter20",
          "filepath": "meter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16a9.9283 9.9283 0 00-1.1392-4.6182l-1.4961 1.4961A7.9483 7.9483 0 0124 16zM23.4141 10L22 8.5859l-4.7147 4.7147A2.9659 2.9659 0 0016 13a3 3 0 103 3 2.9659 2.9659 0 00-.3006-1.2853zM16 17a1 1 0 111-1A1.0013 1.0013 0 0116 17zM16 8a7.9515 7.9515 0 013.1223.6353l1.4961-1.4961A9.9864 9.9864 0 006 16H8A8.0092 8.0092 0 0116 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "meter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Meter16",
          "filepath": "meter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16a9.9283 9.9283 0 00-1.1392-4.6182l-1.4961 1.4961A7.9483 7.9483 0 0124 16zM23.4141 10L22 8.5859l-4.7147 4.7147A2.9659 2.9659 0 0016 13a3 3 0 103 3 2.9659 2.9659 0 00-.3006-1.2853zM16 17a1 1 0 111-1A1.0013 1.0013 0 0116 17zM16 8a7.9515 7.9515 0 013.1223.6353l1.4961-1.4961A9.9864 9.9864 0 006 16H8A8.0092 8.0092 0 0116 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "meter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Meter",
        "global": "Meter",
        "filepath": "Meter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 16a9.9283 9.9283 0 00-1.1392-4.6182l-1.4961 1.4961A7.9483 7.9483 0 0124 16zM23.4141 10L22 8.5859l-4.7147 4.7147A2.9659 2.9659 0 0016 13a3 3 0 103 3 2.9659 2.9659 0 00-.3006-1.2853zM16 17a1 1 0 111-1A1.0013 1.0013 0 0116 17zM16 8a7.9515 7.9515 0 013.1223.6353l1.4961-1.4961A9.9864 9.9864 0 006 16H8A8.0092 8.0092 0 0116 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "meter--alt",
      "friendlyName": "Meter alt",
      "aliases": [
        "meter",
        "gauge"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/meter--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>meter--alt</title>\n  <path d=\"M30,20a13.8535,13.8535,0,0,0-2.2291-7.5288l-1.4452,1.4453A11.8917,11.8917,0,0,1,28,20Z\"/>\n  <path d=\"M28,9.414,26.5859,8,18.019,16.5669A3.9521,3.9521,0,0,0,16,16a4,4,0,1,0,4,4,3.9533,3.9533,0,0,0-.5669-2.0191ZM16,22a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,22Z\"/>\n  <path d=\"M16,8a11.9086,11.9086,0,0,1,6.0833,1.6743l1.4536-1.4536A13.9773,13.9773,0,0,0,2,20H4A12.0137,12.0137,0,0,1,16,8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 20a13.8535 13.8535 0 00-2.2291-7.5288l-1.4452 1.4453A11.8917 11.8917 0 0128 20zM28 9.414L26.5859 8 18.019 16.5669A3.9521 3.9521 0 0016 16a4 4 0 104 4 3.9533 3.9533 0 00-.5669-2.0191zM16 22a2 2 0 112-2A2.0023 2.0023 0 0116 22zM16 8a11.9086 11.9086 0 016.0833 1.6743l1.4536-1.4536A13.9773 13.9773 0 002 20H4A12.0137 12.0137 0 0116 8z\"/></svg>",
            "info": {},
            "path": "32/meter--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MeterAlt32",
          "filepath": "meter--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20a13.8535 13.8535 0 00-2.2291-7.5288l-1.4452 1.4453A11.8917 11.8917 0 0128 20zM28 9.414L26.5859 8 18.019 16.5669A3.9521 3.9521 0 0016 16a4 4 0 104 4 3.9533 3.9533 0 00-.5669-2.0191zM16 22a2 2 0 112-2A2.0023 2.0023 0 0116 22zM16 8a11.9086 11.9086 0 016.0833 1.6743l1.4536-1.4536A13.9773 13.9773 0 002 20H4A12.0137 12.0137 0 0116 8z"
                }
              }
            ],
            "name": "meter--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MeterAlt24",
          "filepath": "meter--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20a13.8535 13.8535 0 00-2.2291-7.5288l-1.4452 1.4453A11.8917 11.8917 0 0128 20zM28 9.414L26.5859 8 18.019 16.5669A3.9521 3.9521 0 0016 16a4 4 0 104 4 3.9533 3.9533 0 00-.5669-2.0191zM16 22a2 2 0 112-2A2.0023 2.0023 0 0116 22zM16 8a11.9086 11.9086 0 016.0833 1.6743l1.4536-1.4536A13.9773 13.9773 0 002 20H4A12.0137 12.0137 0 0116 8z"
                }
              }
            ],
            "name": "meter--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MeterAlt20",
          "filepath": "meter--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20a13.8535 13.8535 0 00-2.2291-7.5288l-1.4452 1.4453A11.8917 11.8917 0 0128 20zM28 9.414L26.5859 8 18.019 16.5669A3.9521 3.9521 0 0016 16a4 4 0 104 4 3.9533 3.9533 0 00-.5669-2.0191zM16 22a2 2 0 112-2A2.0023 2.0023 0 0116 22zM16 8a11.9086 11.9086 0 016.0833 1.6743l1.4536-1.4536A13.9773 13.9773 0 002 20H4A12.0137 12.0137 0 0116 8z"
                }
              }
            ],
            "name": "meter--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MeterAlt16",
          "filepath": "meter--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 20a13.8535 13.8535 0 00-2.2291-7.5288l-1.4452 1.4453A11.8917 11.8917 0 0128 20zM28 9.414L26.5859 8 18.019 16.5669A3.9521 3.9521 0 0016 16a4 4 0 104 4 3.9533 3.9533 0 00-.5669-2.0191zM16 22a2 2 0 112-2A2.0023 2.0023 0 0116 22zM16 8a11.9086 11.9086 0 016.0833 1.6743l1.4536-1.4536A13.9773 13.9773 0 002 20H4A12.0137 12.0137 0 0116 8z"
                }
              }
            ],
            "name": "meter--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "MeterAlt",
        "global": "MeterAlt",
        "filepath": "MeterAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 20a13.8535 13.8535 0 00-2.2291-7.5288l-1.4452 1.4453A11.8917 11.8917 0 0128 20zM28 9.414L26.5859 8 18.019 16.5669A3.9521 3.9521 0 0016 16a4 4 0 104 4 3.9533 3.9533 0 00-.5669-2.0191zM16 22a2 2 0 112-2A2.0023 2.0023 0 0116 22zM16 8a11.9086 11.9086 0 016.0833 1.6743l1.4536-1.4536A13.9773 13.9773 0 002 20H4A12.0137 12.0137 0 0116 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "microphone",
      "friendlyName": "Microphone",
      "aliases": [
        "mic",
        "mike",
        "speaker",
        "wire",
        "speaker",
        "MC",
        "presenter",
        "present"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/microphone.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>microphone</title><path d=\"M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z\"/><path d=\"M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z\"/><path d=\"M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z\"/></svg>",
            "info": {},
            "path": "32/microphone.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Microphone32",
          "filepath": "microphone/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"
                }
              }
            ],
            "name": "microphone",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Microphone24",
          "filepath": "microphone/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"
                }
              }
            ],
            "name": "microphone",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Microphone20",
          "filepath": "microphone/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"
                }
              }
            ],
            "name": "microphone",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Microphone16",
          "filepath": "microphone/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"
                }
              }
            ],
            "name": "microphone",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Microphone",
        "global": "Microphone",
        "filepath": "Microphone.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "microphone--filled",
      "friendlyName": "Microphone filled",
      "aliases": [
        "mic",
        "mike",
        "speaker",
        "wire",
        "speaker",
        "MC",
        "presenter",
        "present",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/microphone--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>microphone--filled</title><path d=\"M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z\" transform=\"translate(0)\"/><path d=\"M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z\"/><path d=\"M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z\"/></svg>",
            "info": {},
            "path": "32/microphone--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MicrophoneFilled32",
          "filepath": "microphone--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z"
                }
              }
            ],
            "name": "microphone--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MicrophoneFilled24",
          "filepath": "microphone--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z"
                }
              }
            ],
            "name": "microphone--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MicrophoneFilled20",
          "filepath": "microphone--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z"
                }
              }
            ],
            "name": "microphone--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MicrophoneFilled16",
          "filepath": "microphone--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z"
                }
              }
            ],
            "name": "microphone--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "MicrophoneFilled",
        "global": "MicrophoneFilled",
        "filepath": "MicrophoneFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "microphone--off",
      "friendlyName": "Microphone off",
      "aliases": [
        "mic",
        "mike",
        "speaker",
        "wire",
        "speaker",
        "MC",
        "presenter",
        "present"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/microphone--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>microphone--off</title><path d=\"M9.18,18.57A7.41,7.41,0,0,1,9,17V14H7v3a8.84,8.84,0,0,0,.58,3.18Z\"/><path d=\"M13,15V7a3,3,0,0,1,6,0V8.75l2-2A5,5,0,0,0,11,7v8Z\"/><path d=\"M23,17a7,7,0,0,1-11.73,5.14l1.42-1.41A5,5,0,0,0,21,17V12.42l9-9L28.59,2,2,28.59,3.41,30l6.44-6.44A8.91,8.91,0,0,0,15,25.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14H23Zm-4,0a3,3,0,0,1-4.9,2.31L19,14.42Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9.18 18.57A7.41 7.41 0 019 17V14H7v3a8.84 8.84 0 00.58 3.18zM13 15V7a3 3 0 016 0V8.75l2-2A5 5 0 0011 7v8zM23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zm-4 0a3 3 0 01-4.9 2.31L19 14.42z\"/></svg>",
            "info": {},
            "path": "32/microphone--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MicrophoneOff32",
          "filepath": "microphone--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.18 18.57A7.41 7.41 0 019 17V14H7v3a8.84 8.84 0 00.58 3.18zM13 15V7a3 3 0 016 0V8.75l2-2A5 5 0 0011 7v8zM23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zm-4 0a3 3 0 01-4.9 2.31L19 14.42z"
                }
              }
            ],
            "name": "microphone--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MicrophoneOff24",
          "filepath": "microphone--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.18 18.57A7.41 7.41 0 019 17V14H7v3a8.84 8.84 0 00.58 3.18zM13 15V7a3 3 0 016 0V8.75l2-2A5 5 0 0011 7v8zM23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zm-4 0a3 3 0 01-4.9 2.31L19 14.42z"
                }
              }
            ],
            "name": "microphone--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MicrophoneOff20",
          "filepath": "microphone--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.18 18.57A7.41 7.41 0 019 17V14H7v3a8.84 8.84 0 00.58 3.18zM13 15V7a3 3 0 016 0V8.75l2-2A5 5 0 0011 7v8zM23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zm-4 0a3 3 0 01-4.9 2.31L19 14.42z"
                }
              }
            ],
            "name": "microphone--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MicrophoneOff16",
          "filepath": "microphone--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.18 18.57A7.41 7.41 0 019 17V14H7v3a8.84 8.84 0 00.58 3.18zM13 15V7a3 3 0 016 0V8.75l2-2A5 5 0 0011 7v8zM23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zm-4 0a3 3 0 01-4.9 2.31L19 14.42z"
                }
              }
            ],
            "name": "microphone--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "MicrophoneOff",
        "global": "MicrophoneOff",
        "filepath": "MicrophoneOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.18 18.57A7.41 7.41 0 019 17V14H7v3a8.84 8.84 0 00.58 3.18zM13 15V7a3 3 0 016 0V8.75l2-2A5 5 0 0011 7v8zM23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zm-4 0a3 3 0 01-4.9 2.31L19 14.42z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "microphone--off--filled",
      "friendlyName": "Microphone off filled",
      "aliases": [
        "mic",
        "mike",
        "speaker",
        "wire",
        "speaker",
        "MC",
        "presenter",
        "present",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/microphone--off--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>microphone--off--filled</title><path d=\"M23,17a7,7,0,0,1-11.73,5.14l1.42-1.41A5,5,0,0,0,21,17V12.42l9-9L28.59,2,2,28.59,3.41,30l6.44-6.44A8.91,8.91,0,0,0,15,25.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14H23Z\"/><path d=\"M9,17.32c0-.11,0-.21,0-.32V14H7v3a9,9,0,0,0,.25,2.09Z\"/><path d=\"M20.76,5.58A5,5,0,0,0,11,7v8.34Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zM9 17.32c0-.11 0-.21 0-.32V14H7v3a9 9 0 00.25 2.09zM20.76 5.58A5 5 0 0011 7v8.34z\"/></svg>",
            "info": {},
            "path": "32/microphone--off--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MicrophoneOffFilled32",
          "filepath": "microphone--off--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zM9 17.32c0-.11 0-.21 0-.32V14H7v3a9 9 0 00.25 2.09zM20.76 5.58A5 5 0 0011 7v8.34z"
                }
              }
            ],
            "name": "microphone--off--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MicrophoneOffFilled24",
          "filepath": "microphone--off--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zM9 17.32c0-.11 0-.21 0-.32V14H7v3a9 9 0 00.25 2.09zM20.76 5.58A5 5 0 0011 7v8.34z"
                }
              }
            ],
            "name": "microphone--off--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MicrophoneOffFilled20",
          "filepath": "microphone--off--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zM9 17.32c0-.11 0-.21 0-.32V14H7v3a9 9 0 00.25 2.09zM20.76 5.58A5 5 0 0011 7v8.34z"
                }
              }
            ],
            "name": "microphone--off--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MicrophoneOffFilled16",
          "filepath": "microphone--off--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zM9 17.32c0-.11 0-.21 0-.32V14H7v3a9 9 0 00.25 2.09zM20.76 5.58A5 5 0 0011 7v8.34z"
                }
              }
            ],
            "name": "microphone--off--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "MicrophoneOffFilled",
        "global": "MicrophoneOffFilled",
        "filepath": "MicrophoneOffFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 17a7 7 0 01-11.73 5.14l1.42-1.41A5 5 0 0021 17V12.42l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0015 25.94V28H11v2H21V28H17V25.94A9 9 0 0025 17V14H23zM9 17.32c0-.11 0-.21 0-.32V14H7v3a9 9 0 00.25 2.09zM20.76 5.58A5 5 0 0011 7v8.34z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "microscope",
      "friendlyName": "Microscope",
      "aliases": [
        "microscope",
        "study",
        "research",
        "laboratory",
        "lab"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/microscope.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>microscope</title><path d=\"M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z\"/></svg>",
            "info": {},
            "path": "32/microscope.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Microscope32",
          "filepath": "microscope/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z"
                }
              }
            ],
            "name": "microscope",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Microscope24",
          "filepath": "microscope/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z"
                }
              }
            ],
            "name": "microscope",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Microscope20",
          "filepath": "microscope/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z"
                }
              }
            ],
            "name": "microscope",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Microscope16",
          "filepath": "microscope/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z"
                }
              }
            ],
            "name": "microscope",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Microscope",
        "global": "Microscope",
        "filepath": "Microscope.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "microservices--1",
      "friendlyName": "Microservices 1",
      "aliases": [
        "microservices 1",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/microservices--1.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<path d=\"M11,21l-4-2.2v-4.5l4-2.2l4,2.2v4.5L11,21z M9,17.6l2,1.1l2-1.1v-2.2l-2-1.1l-2,1.1V17.6z\"/>\n\t\t<path d=\"M6,30l-4-2.2v-4.5L6,21l4,2.2v4.5L6,30z M4,26.6l2,1.1l2-1.1v-2.2l-2-1.1l-2,1.1V26.6z\"/>\n\t\t<path d=\"M16,30l-4-2.2v-4.5l4-2.2l4,2.2v4.5L16,30z M14,26.6l2,1.1l2-1.1v-2.2l-2-1.1l-2,1.1V26.6z\"/>\n\t\t<path d=\"M26,30l-4-2.2v-4.5l4-2.2l4,2.2v4.5L26,30z M24,26.6l2,1.1l2-1.1v-2.2l-2-1.1l-2,1.1V26.6z\"/>\n\t\t<path d=\"M24.6,11.6L22,14.2V9.4l3-1.7V3.2L21,1l-4,2.2v4.5l3,1.7v4.7l-2.6-2.6L16,13l5,5l5-5L24.6,11.6z M19,4.4l2-1.1l2,1.1v2.2\n\t\t\tl-2,1.1l-2-1.1V4.4z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYRJkEbvzFmgwqwNZQCm2UADcFGkK2ET22eQqL4PLWtlYkn0mR3b0zccDy6fJXFAUMRdGB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\n\t]]>\n\t<![CDATA[\n\tQQBGBRtMoECBYVwAwQKFCooADAssVGhw4OBQsZyHBRQqTNjAggQMPEgGIBw4OIyURwUUCICFChcg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\n\t]]>\n\t<![CDATA[\n\tHAfeyKj3y+w9Vg4tB+YMooWyzv8GT3yjVNn7P5qjtWi+H8rVKModGuafWIN1k2h4vRrpml3B6wjW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\n\t]]>\n\t<![CDATA[\n\taMM61jaKlFd3RJRalZxQskbx8ypJrOHPyxJtbisLJbHNK0SrosrmlC3zNdIOyfbBmmT6N/sks8iJ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\n\t]]>\n\t<![CDATA[\n\tE5nM/cT7kz4R3+JoalcVLmclcvbLSJUESKq+bM/vDjG1YXGKFRJktnvSIWC7gY5wlhQD4JVOR+So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\n\t]]>\n\t<![CDATA[\n\t2NBXiWOSDAxPBZjPYefwybqXbCuqau1KZeOQAVTUVmX6BoSBOYpgBBsFbpNCp+oU9DolECA4Mq85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\n\t]]>\n\t<![CDATA[\n\tX/hnqJfik/R4bLw+bQ1BMRTDDciTDW5r7O4a9RUcylIPiR2jQDrZx5aohVyTqxrSSvuIn/W7jGSe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\n\t]]>\n\t<![CDATA[\n\tEqD4eZ4Tz6RSTvuRbIYNGLns/9YG5QMhcOS3abxxOusNs4d76MkOkmxWJRDBS4BhQsWnlZosrJ+s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\n\t]]>\n\t<![CDATA[\n\t+6lJ+QdNCfTL9Mz081xTqItAKrTpFmyNmUXp44rQigKoDNPSn1q7oi3qS+Ct05W+XCZYff+ENBlr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\n\t]]>\n\t<![CDATA[\n\tgBMYumDzgRkIOFX/5am6ZG87atNQh95ZvNSKGCeC4Pm02o1DKc2JeELgxMKiQgtlC0pcI87g99kn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\n\t]]>\n\t<![CDATA[\n\tY9WEo19Ve02UFzp2FLqemJJSFblMFVMl2IVs/Kopn+TvRikKVmzsCle45r0VxJW8YReVJcihkQ87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\n\t]]>\n\t<![CDATA[\n\tFBvyi5K6SgTR9Qtn8MiPPtwEgsxhgr0h98ebp0AJlnxsgMyDsu37Q+HsggcVPkMoeGAqskZ10tKL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\n\t]]>\n\t<![CDATA[\n\td4lDU5Q+WTQE0tcR+DXRDcL7uEW1FbHSGFn25oZO5TXo/uAf9vh926mP+3lnqPMLP0ctHq1CpcuE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\n\t]]>\n\t<![CDATA[\n\t3YrRM3o4vBjFoIfYGaOs52HBMXo4D+U8RoXm4RPIKH95aEVG38rDOckoTR5iORll3JQBTa+MI5FH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\n\t]]>\n\t<![CDATA[\n\tQIj0NQYEQn9gYx0gZMSwcbeIpJd8A+giyxM/NiH9AYa8jF8/+MFsKPGDLWfDJPsANrQphT7INm3K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\n\t]]>\n\t<![CDATA[\n\thW/qLYMRhyEPEv5GEAoUduyCPhk3+EyV+QxH4pAi+CHPUd2oIMwQ+A0JxSHwA8nXHfDSFP/3D5gA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\n\t]]>\n\t<![CDATA[\n\tp71lAlOJyUKUjrT3fE6Sd0or7b1pZHtNIXz8mPamVpfHVNPeYeYn3oC9oOnmT3tzWKXugcKCtLfx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\n\t]]>\n\t<![CDATA[\n\tIvwCBvFM69k7aFe1osFq7F6rG5/KyNkK+rBNg1t9T3eit0pkSPQMrikOFo5xPfYFx1eTq0A5VxW9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\n\t]]>\n\t<![CDATA[\n\tYMb82DGJQD8xHls2NgprzmHSY6k8zEOJjnqr4Bmxh/G1Z1nsU63jh8SxpAdCXJUIjG+xpYrCKRqn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\n\t]]>\n\t<![CDATA[\n\tJzHv7xjCydSV0VwGA7u6yWJMpt2+wQDVbNYPTlkp0/uNKAO/DZ9bv6Zt5ZwunJ20KWjnDMZ9mr20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\n\t]]>\n\t<![CDATA[\n\t2UWPgrYRJeCt06XrN4FvveewzhaC5PtHmH73ECSfreOl6zpeOZtIvGcTUfp9JEtBGylz8BNR+n2i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\n\t]]>\n\t<![CDATA[\n\tZPGDVqzQh1gGUGeiToHzpFziFV1swij62aqX6QKLGmaPLGeURrpsNQvAoua56aSvsvsjxiW4h4lO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\n\t]]>\n\t<![CDATA[\n\tUipHGHJJN6AxSUuVMOwIVCR+KxqRHoGKBCcUbQk8NuevJqifwxLRnqH1swaRJZXmonI6Y2AdlRvI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\n\t]]>\n\t<![CDATA[\n\tsDoqe6CCSlepoKyBEve8HdpcswdHnxb+H0Q9f03bZmHKOpbb2SxMGY3lttgXD2GhA79ikMW/traC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\n\t]]>\n\t<![CDATA[\n\t2MYGfNFjLSAUjFlwqDlBV4HTeS3gGxIwcQQ+RHyG3+zICHELVw50LPG8DJhgzGIR0ZQ5XEGVsVJG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\n\t]]>\n\t<![CDATA[\n\t88ON+A4P4jnchtvIcJkYHlPDazjNlcfM8Boew2c45zf8huvwnqsRj8CgwfVPbUsIhSFXhHGODnlj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\n\t]]>\n\t<![CDATA[\n\tVtPXsV5zEV1ffEOFD1c2W4aAg7KD0FJC3mIlla1oTHYFLRq7lIlDTq6nOnH4oU4LgxT//JIlESPg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\n\t]]>\n\t<![CDATA[\n\tgF9p00tForFrBemUN2w5lbWYcMpTJRJp+NJo3rVgXCtCxMzemtZI0+8rfQ56oMW9nkMYV+cQzs03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\n\t]]>\n\t<![CDATA[\n\tIncjAv7FEYEVk+gU3z6AeHYJw1+VXusgg2NJmd3+UMYBhekEsLS7++WnxkluHgeg8sFlQNdo4uju\nASu2n2qIixQd8iaprvq1lJImUiuexsp2+LQWv5rLpZHfTAjP+mwQnR8M81ZGlPI6+NTpY7dH4xib\n3daS0iOjbGYlW+36gKpEECeABuu6/xG6E0rbylv9R2wB2PwR6z4lx6DOoftsxRJvVSKw76E12ZyQ\n0Z4KfRvYhElVnxqzHKKH2GFEh5ot1Ti/vrRW+LUr6lXJLd6GUQQe7qUgrqRqBTKxuoahO0RUsB9m\nptRtfMDoNwPgLO+UyCktkmPScNmO+C7ATDE0O0npTmFJz0spUJkG0tRXc1NJOlZW03AKhwBrKGtv\nowJm2Cl8hUs8wxgq0H2OHzabBwHOU3NuLZvMujNUFTOX1AwIWQe4DYX5nctVICdsCgilw6vPUGQ6\n+LyygwlkJs9aUom/vPW0llskvS0O34bUvqK7+nK8BFeNBS2ID4SJK7hORFptAqf8VObV9+tK4r9n\n7qJdR17qpSsRQXef2hQ8+AadBUCazj0Xjx37zch4Ikfx4G2clQ9/qD0qPu05VkJmeB4FD42t1CzK\nhC1Z1kzyA2wTZeQArsoFZ5UXMcSIymIJsHaD5DrZdOnC6UHFUnqCKzW1tFpNAfQJAJQKgDkxMmM2\nOWI0NC01NTc4LTQ4N2MtYTlmZi0wYzBjZDY1OGNiZjJlNWFlYmE2Mi05NWExLTQ3YmItYjMzMy02\nYjBkMzg4ZDVjMjM3NCA2NjIuMjUyMzhhNzMzZjgyNy01YjMyLTRlMTMtODZiNC03OTVlMzIyNTJj\nYjlkZTBkM2EyNC01NmY1LTQwYTktOTRkNC02NzU2Y2MxZDc4MGM0NzQ2MTI1MjM3My0gMQULISM8\n8HpEuf2m6iALwFpNGlyr8fM8hOGREwinav4FbXMiwbcTBG644Bog+QK1xwmd5Yl1Vu6pmUNoONCs\nzcAxIV2QLkyWHtd8CD345bdT6DHBAdxZD+46HTbu7IaONSzAE5xTFF7MmtH4bxYCbYML1ADxgYVz\nGPDf5AHwksSI3mQLpNLjmw//zdGjrneADbzHAEqB0BY4kCVJG////////w/Ab+1bQhrBlpJ8SKyR\nJbsh1kcIfWj8/w3oWPtt4/l+ubSyd0r5MjKoQs/xTA6DAWwBQwG2kWgPx2yQbIUqnY/j4Sgwz1jb\neIxtMCvSeNvw6czHYRKT+eQwM4o83OdCOKLb4CC/HFxmQjg8NaImOOYiqA9RbZAqBCE50XSmAsl5\nXLvmzRs0+AYNvNrrgBxISHZKD3sXjykBrY4HhAMD0X0uXc8TkR6JSmcTTY8H60TzmWh1OFTIg0R8\nPVgPGJJ1roLa+F+GYeqjaRLUxhtORFVgpMf0JNjpPB7TZHAP5yJ4pkRn1DgFN1WhgAMHkBthHF+W\nARASADBJtycgrPPRlWZUHdc6DoRjRgyVRtN1sE6VnMd1QHdRGxfA4drHWQBBJUd6SM/0qJH0mnUi\nQm2dEKjRQn3MxgvAiipNDSeSpJl41Igp0QTQZL/A9MyICk1bmWsrtfWZGtG0oDYJWyPmcSCoIjKj\nCKGAIyJV5tpVmWsfCOLKAFfmImA0MCigDHABFVXpcRYYDHBof6BmVtcojzaYRrPm67meNuBSXmwm\nNpT5/vYaZxqyrea1XLPfLfoNX+4hbWXKl0Dv7rlr7r2H7kUlytdaxpZqqpIT3Yi5wAyDkFDPbUAR\n5wMgJIw9kLye0QNz7wHPEd4jZyGqDQMHdBfNw85ogWSr9YRmhTFQOy28AfVpTInaaaE27gui6Ulw\nQHeRYEEiM2Jof39n7L/mzOJhrYGI5NDpuKxoQOfTYO59mnufhcu4x7oh79KUWLN2B4n4f/MYIVMj\nyL+3e3u/e42ed+tMfUxN4yjAiPrUOEHOg+ko2BldBVMjhVSf60Qo7oPDWEdRp6ehsLVGDwoH93lq\n5Lmin/sVkfkoeCrEUfC4nz915j3iQjViZ1f083NWdD93v+I59yucPUGA8zgebp2mMtZJKEizOmqk\nJBYHmRsdiGqDcFFwyFsr4bl30bBOKaWUOqWURkqpUxqfc3vtBE2Uzkc/1MaDWqPmeRzoRk2NJIdh\nZmQ6eGY0pUeNEMxqnSfRQJ9JX4K50pUgx053rQG5E0mzASFCAK1PdXiqtRNiAWkBjWkPNO8lWZL4\nGAyV5hKyVozI3BVDMrcgfjJCZ5Dfq8mAHUbZXndL1hxdOsma4Uu21yIk2JVdkiVZkiVZkiVZkiVZ\nkiVZkiVZkiVZkiVZkiVZkiVZkiVR0JIsCVQMA25uVYBq1KI1yU36/2OuGKy0bqzf83vOJYMMZTPH\n8JX3+tmrhXOOT4HelmKoxbflbb1fzTWLvhRfUDJlsVtq8eu515jy67H2GuxmiqIKfM6e84PNQVe0\n22KKy3esfftuisHOo7LYSaUxfwpzi3WDTkomXzEa++Xk4ig/ysccfE06hlp8e4+5VxQYWfvYHHPP\nv0nmXNH3zHlr2azdvcaiYjzFYNheYe5rRfb+F5NLsval6HOvvaKs/VJ8sYOxWXvpuln/+vfokMnF\nDTrH3vs71otjW+z8OWtn5+7J+Goy4HforyNsivzPFz/mFnv054t98YNPMfgthmvxUw3sIFRYWQpi\nyFBRDIaL4YJLiawha37ZuqMrzZqbbE9GRSreYHzHmltLKTu+P+aYpzoLVZoKHB1Db4ZaMFSMJX1B\n8tdSDOdXIIbO8pUC94L/F1QL/mf4i/+jbK0xXx6lfCZ/KcZSEPxnorlgyWFqtGgcnRuy8wc99r+H\ncHE/5fa12ClQLR5u5/iMF1mzdFVAACohgVs1DnoCTWD3f7/4IQYMo0d2Bxf/L3b1kMDecnG7aiQo\nBuT2Xqt9sfLvQRa9LQUu/pZSMsmvPMhkN7fLj+xNQaywN6XA3aiFbMVJxWBl8fM3fuzOsp91Y6gF\nu3P8xVJK1v5M8rMSZexfSzHiK4jdV3z1wN2upgCiGnEXeyVpSniMEzE8WMd5HOSSqHfPXoTw/xdI\n0XVAloRxJob6BIbWqIOKak4xREMykiSlDtMRQFBAIA6nCCVToZzmGckHE0CBRiMBWSQUBcOAMBgQ\nBgKBYCAQCAQEQYEwCEJhGEcxKIb2JKrTAbTxbJPkozAw2lx7GK84yF5qGivXRIgr7JvE1xt+YoNp\nSTy7rEXhcasxy1dMXEDLR4/Z5O77EdOK9muHytr7NS+kESuXE07KMcJa75YSlUR030ApV2E5CDor\nKQOF+iHAdag5/e0V7H3rrfhn5BVO02bUWu/C9vcW/uXXSp2AwbvGkGjZZ7cFBpxg4okhEDNz0wZf\nImGR8L0VtHi9dPc6wFbUMskEtmvug7YcBAMhVCq4e5m3uYll2Y6sdtc/bmaojn4mIZxjG9E6oh82\n/FslSvtJAzvBhfrnKO0ILuR/X7Kg61Tnf1QxERSDgJJo1nwSqTZvn/uGkpiQ5BUIIf6HUAlZNZbm\nPofpxgzs8zm9jQ2uyJOrgEipVY26KWYkMzZUVI2If3KPdU3ONYGOXKMmtOkofKDPjyhopL0gRVSA\njx7W6ste/hIxuAstKS8CLbdcsIFoU3iqvZe+gU58y4OHpeJPub1xwryIwRBhbjwwoZ/Tst9kk4mW\nhpq5qU6+SUVRfF+NU/krZ1586BPjJIIZ2zQjEqFYyQLhDNxbBMSxgVLDywqs/7wMNMtAn8zpT+KJ\n0FQz5SAgPn1POKyTPYL3JPmH+/n1mcXVZu3Q4zoDhr2ZJZ/2oR/6onSrsjnhWAY+babv9tNa17FT\nNPgPLu6IIXq6FpCHzhwHASSMCwYKzo0QqKTDekw+M+RorZc5WGTBjwpP6Fo0ugF/u73ARTN+/6vJ\n6JggHc7jc2/9fMbHdYiK4LmVTxK1oC4oyDSjhblUQw51a26GHc5p+6bfCdF0ZjiGBEWqOTzhPlco\nI7E1eqS6zeBousx0rebUz7wJWgm7Nx6RdP6b8mRNaiqkSSftANPXJnynWFAQzBtK80sA9s07uapN\nF7YMS/0W4S7jziu5xV3AD7IM4Y4yK1VduwInjla5sJ6zw07aoo3Rcux2FXncgWYW294eE9sDexBN\nrK34alIC3x7dQUcSubBwVOjEg8OhXQGrLfx+BOD9DsPjzocRO1NGnTiD6NBwmZMHIeetiLNcVRXA\nyV2c5udNBCA3lFzahDA2X3qWQWsSclFTn0gTKGg+a1LpzEzxZc8MIUiZeC5k/iEaM9MS80eYsVX8\nzoDJH18KGpCyvMgndXnbFJfBGqomTpm2TRHiaCHkjGGHdeTGKmS+3nRJO4GXjHx5dsziC1Gc72gm\n+u/l82EwCf4/ZyP/nmLJZ/fCKWowCYUw7jyA8uwiOKr1ikjayBItJ6kqb+bgXgTAMLxPBtwT78Bd\nNWUIcOSlMjZzCgxUcUTWXTjRaSqbSEonPX0cAHYBaJjqDkX8ZofoQxRWM6aSN6a8J4la4hg3B8XY\n/h/0vngMPqV4hSixZz9W6giDmXk3H8aGwFqshUlgFa3AYUi7k9ymB0AX118Ywiibz9HaG/uD2FYL\nhBwzo0hbWMCx28eR5iPWnBVobdaUDUgmEiZvXUOoMEJIIxgI/IHRX7YtQ9ZVzjd3HnMFLxzs+GXe\nc8qyeRRLi6iIRrST0CLBkgl4KmKcGD/S9c+lTy0Cxi/q0XsjAFx7llJJADC1wikgv/pdIflDBYyL\nn8h23isPrY13+SJICsK4D+blHOBBDIC+a8pjDOB4S0nkc1502/ewZDT+lKfcv8i90KP5lf5Jh9Ff\nj2j3RGRafhzvEvCtTqA3YZy5VLwq6XGgJkXXA8sDfO986MDDdv5YDMDGn1KWhLZxJBcLALUFA/5z\nux3aMLoGkNrpG4+hWXKZ4eJNGCrx/jn5sxYnTxUCA90UktSnv4n7nW/0NNG2EbzCxhOstLE6M+4O\nEcNfaGrgqw8mjbYSPtyxHIxZ7TEgpaq9bRpIxMREWI/5XKRQKamAE/QXnYADl5dM0sQGUhekA+wz\nOArtTJbkxKmDxoLviUPNd1K0JBRHtOmoWaf9cusk7QlYooyCi/hu9gXICTplY1Z5r3JxafpkkxDN\nZS6r2MD+B5D7gVUTOHwtDUOSsx5/XQY0FhywLZJGjkjLqbEPnBf8bb/wEiATeqMeJZoOMHxVW6pM\nAetSZ1FIub+tOtizBSZJCuydD1vKWgHiIodA9MAsjlqM9Y1dZw7yc8je8tAB72kR+pmPDbULHvzN\nNXAN/WVY8ZgbAH5Uaz4z/m5Nxl4Lv8Bg1E1kA1NpyKR+parizxfPiP7S6XRAH+rr10rOUMzAw48s\nbYHbytp7qspW4SMReeQYJas8WhFHRsfpQ5X4cOCi2A7Au3IUchQPuLG+Zj0ECz76klkglXxR+qVK\nguKceo6ly5uuuB9hC3vDoPdLtNECAK1zeAV/5ojxJh+2F4kL+qYyB47gq2hVV+NUyQ==\n\t]]>\n\t<![CDATA[\n\tQiu0ZuORU4Jku0lbvrwAEKg3whgEAgKDkkUIpbuOGlEcsRZ/aGtoHo1tJkTu1i7KptpZMfjVBWoC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\n\t]]>\n\t<![CDATA[\n\tVqrn702f2lrzxq7nU10z+5estf6ktEJJW/fXeS9ZvaI+CJ1hGYahsAzLMpElsqosE1lZJrIqTGRp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\n\t]]>\n\t<![CDATA[\n\t+JFP+jabmJqjT2Truo/ksXXc6KOofFuJC1VGWwEZbqPHhd1W+lAlEJzdKHajCILdKIYgWJohCD7e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\n\t]]>\n\t<![CDATA[\n\tb4ZkMGSOFyw0rH6abI1YjRg2+lSfWeZu8qUwtk4hZGWScgS2IOPANQL2kSUQUW6U9QrNkQXk0oiG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\n\t]]>\n\t<![CDATA[\n\t9pdt4HDHGxz66ZVMEGxMXys1uFM/6FsD3h6faRlnpdmDB/W/xsD8IBP3V+n/hUU7p29SzXK6qQeY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\n\t]]>\n\t<![CDATA[\n\tov8Ah1LnSMfGFHjmhmS4gGHge7KOCxhUnSTmojyECIqG9p0UzUj1iFPVE+WZ+LeSbbNATOjp3AUo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\n\t]]>\n\t<![CDATA[\n\tM7bh5Lh29xpGGUGAtKaSSXkNE4nvwmLab+bUJquUKQPip0hB11xuuICT8pdpVdYvXQ4jXiEWyAWf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\n\t]]>\n\t<![CDATA[\n\tA9bjt5AvAWIGZCkaUlyoEwTGGPEOTL8RVlc68hDn4Q16HauehmswwVPGgzQebZq22pYM68bcMH6Z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\n\t]]>\n\t<![CDATA[\n\tURaCis2ENbbaJTDQTWQ9Ari7aDJWzt4epw6qsOy8Slx9/EyeJmhDWDAifjEUNO4mIF4gSu58Z5Aa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\n\t]]>\n\t<![CDATA[\n\tX1+Of+/IElMqcaAbo5CV/q24I2YayqKK2RZNBAza9ERzI6qJActaMFkw8+dpFD/2bPVn8tTg/oRa\nQAVPhwW1V4+nGL/ATUtgcjEigbdT6PaK6Wd9inpWlDAE6JLsjqv08suXWtHQ+DJmbEAB1FZWC8Nj\nilEA76I9Mb3BzwZDnTLIY3F4FlGGgUDgKirzM6JlbcwfwY3dZQzIQr5pvlSSA+fzyVKnGIAUg2It\nPrwoqXVqjHLbHIjA1ewsuMjl1/lOe1Ug8inHqkLw6Xkf0sohoxa7uYT3dnoN20gnFGbPk/PCHX5M\nm9RmDDxoJwwbccSWbvL98J6o0kfrfq+KLxg4K/QKJvTiXyUsqcVR+nPy9cI8C+ybZ6RtK3Fhx2Yv\nc08YONcczTWsOHWHOfRCAk4l9TqTl8400bVhzFWMVtXZawaq4egcNTrmwhH7BDFLCYs7VorBP7mE\nxSZXXfZaBV9gNYda6JMqCQSEv/1GY0pSRMlux7CAQOEnZEp2EuEDKJFdJ5HXcRP++FG0Zm1/cyBJ\nqASJufgdaBzXDi0HfmuupiXZsq5F/B8FmkNLCPUOqq6R9tDTYgA2+R2oVwkcItRDntMeCOqdet6R\nSr2mkdGgsbrGi0C9GkOWonswqsYV6hW0X3dl46wqjfY9qXd4JWgZMqS2r+UY0kTs9Bzjmux/APWq\ntpBVEEz9lsQu1wKnLgEb147exOsCwQaSU9QbXgO8s2+KcWeItl0rsEEwJke/P77PFQUXPVCOEJ+p\nPVFEgHRZ3/oTquLXMjNqgf0+LfShJSLiy4c38knN5w2mDoGDHrM8w7Q6hkVCAlbyobLMWIuIwQlb\niNm/CgsLwkAZAEZbnwFBxOSAeyO8h3n2g6RbQHW65ctQvB6YEVeV1MeKe4vHdeeGUPEofhLn+Sly\n+I8tYEuheC6hAbiMFmPF7OSuv9Kt4CvESRhWFF+aOAOfiFFSzApYwm5KeQXT9oFXQ4m+reoUfIsb\nHQsqwTd1Xq/ALuE1CTE/kUIehyS7TP2KZgXiG0kc4aC2dYk7U/4c2BAmvHNBoIqg5s3PUcSgNDi/\nM2+ws00rRL1IFQIp+PqNoCbQf8GxLMGAJzXAOaCA13UPgdBcw/KfP2fZ3W32uHpryWy5N5+jMDzC\nJrCrt56A7PPtVajQbB/KMjwcfCUqriuWXKveSefPd1fv/MVjWvVyuum0lp7IH4p5Gfjnel44v3r3\nLKHVrOoFTStyM6bcqncp6nX26v0QGmKvX43Fy6FVb8Bof/XyfuaErnpTQX98IAi++BJXvWE9aQrK\nPLza+AvEqnfSYVeiuPu+DO9aBQ==\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M11 21l-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zM9 17.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V17.6zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zM4 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zM14 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zM24 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM24.6 11.6L22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5L24.6 11.6zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z\"/></g></switch></svg>",
            "info": {},
            "path": "32/microservices--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Microservices_132",
          "filepath": "microservices--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M11 21l-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zM9 17.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V17.6zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zM4 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zM14 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zM24 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM24.6 11.6L22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5L24.6 11.6zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Microservices_124",
          "filepath": "microservices--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M11 21l-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zM9 17.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V17.6zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zM4 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zM14 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zM24 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM24.6 11.6L22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5L24.6 11.6zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Microservices_120",
          "filepath": "microservices--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M11 21l-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zM9 17.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V17.6zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zM4 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zM14 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zM24 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM24.6 11.6L22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5L24.6 11.6zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Microservices_116",
          "filepath": "microservices--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M11 21l-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zM9 17.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V17.6zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zM4 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zM14 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zM24 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM24.6 11.6L22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5L24.6 11.6zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Microservices_1",
        "global": "Microservices_1",
        "filepath": "Microservices_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M11 21l-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zM9 17.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V17.6zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zM4 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zM14 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zM24 26.6l2 1.1 2-1.1v-2.2l-2-1.1-2 1.1V26.6zM24.6 11.6L22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5L24.6 11.6zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "microservices--2",
      "friendlyName": "Microservices 2",
      "aliases": [
        "microservices 2",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/microservices--2.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<path d=\"M16,22v-6h-6v-6H2v20h20v-8H16z M14,18v4h-4h0v-4H14z M4,12h4v4H4V12z M8,18v4H4v-4H8z M4,28v-4h4v4H4z M14,28h-4v-4h4V28\n\t\t\tz M20,28h-4v-4h4V28z\"/>\n\t\t<path d=\"M29.6,13.6L27,16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21,15l5,5l5-5L29.6,13.6z M24,4h4v4h-4V4z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYJJoE/vwFnQwqwNZQCm2UADcFGkK2ET22eQqL4PLWtlYkn0mR3b0zccDy6fJXFAUMRdGB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\n\t]]>\n\t<![CDATA[\n\tEyzgwMGhggCMCjaYQIECw7gAggUKFRQBGBZYqNDgwMGhYjkPCyhUmLCBBQkYeJAMQDhwcBgpjwoo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\n\t]]>\n\t<![CDATA[\n\t2p3JceCNjHq/zN5j5dByYM4gWijr/G/wxDdKlb3/ozlai+b7oVyNotyhYf6JNVg3iYbXq5Gu2RW8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\n\t]]>\n\t<![CDATA[\n\tYyVh2dGGdaxtFCmv7ogotSo5oWSN4udVkljDn5cl2txWFkpim1eIVkWVzSlb5mukHZLtgzXJ9G/2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\n\t]]>\n\t<![CDATA[\n\t+Om2PKJ7evnERub++v5kTsT5OBqxqwrCWYma9TJS1AHJqy/b8rtFTG1InMJCggztXnUIyG4AJJw1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\n\t]]>\n\t<![CDATA[\n\tUP8vERjuW6m5oZcnjiUZWCEVIDyHnV2SdUOyrV3VeiKV5iGDXlEby/R9CBNz1MMIhgncJoVO2Slo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\n\t]]>\n\t<![CDATA[\n\tfsNi8ZSDbhEWqydEf/hnKJ7Sk7R5bJRwfg0hRyimDsjjGm5r1N817RU0ZbUfsjpGfjr3x4LgC3GK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\n\t]]>\n\t<![CDATA[\n\tAnQdKm7o6ZOkgiBIJRIo/hluxzODUk67SeZ7A4Zi7P9ggyKWEHi02zTeOJ31htnDfejJbkkUq1KI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\n\t]]>\n\t<![CDATA[\n\tqky5HtZaAAR95UYC9d+vJuVfNFngX6Znps1zTaEuDFLRpru7NdhBpY8oQi8KgDJspT/x2hXXqK+A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\n\t]]>\n\t<![CDATA[\n\tgnrMATeJ8HEGdyB4gASGXrBpYEYEnF5/pVRd2duO2iDUUeosZLUi7ESw8Xy57kZQSudEPWFyYmBR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\n\t]]>\n\t<![CDATA[\n\tJ21bm/xGIumUdZV0iGuINaGK27e52+dDjXZxFAbVKXSsWjleqmpSE/UFjx7L+xNTNVXR6+Se3KAX\n3Vyqpi5UEW9sUbBi81e84rVPXEFcVRx/Ub1BDk1l6NGidApfo0WNUjGiuVYUj9I6nRgJrQlp7GVW\n9mu0rxTsVtYwzrjUxqh68pXwEWb2Tcm8RhcxFf+IXIaexGwfEVHtUaPSLEav0sSm/tUZnTdR7aqX\nq1LU0yzx2mYcLM0rNG3I+CxybGId1k6Wbd1tUlhxz7jtvifkGgfpG2Ss0EWyk9s19DDxlwopntMi\n9mtMgCzxiiaoq905yUrfhrZ5yYgiLwuNMlHhIq8UvTyt8k2yIGtRrtSiaMaGaYbskOBaAhSviVHc\ntYn+NKJpcpJWInX7lvJUY/2lxE2cm4qcpELZdCMyq3B0FHPQa6LkwfgqRYpDNva/3v1YlOIQBetS\nXe8uia+99qT7tNsxtVhM2U2+RTqpf5IY3103wRE5dauIkVoXUyJSlYfJMqqvRXZ2DF2dQG9oshkk\nYnmEUaZuNtLN8rSnkgLZQfTYfOGPYyro1fqiKHEKotc/lQjSCKIab68VeDaesEHLjJ1n6di/XEvF\nrB1WN1W71MhbIzUWkigj45Hi+1Cp0rFFUqdFMPduHiVSqHLH0JtN6eFIhKvgTDQcToh9m3d7a1yJ\nRXAiRmOUfTA95TdL8Cu6u1boo7aK+9G2YyhO5Z9+UuQzUFarS+zKq082Wc2lGks627cJh/lCpihT\nLwlhqO+Pmnp9JNXro9W9OfgPs6rWIoVwLyvLWMEymRFOiq+QlT1lkfhntjtOqddoQpNtnvnaf9HM\nOPNfM2OQ2Ww36rGcpnHWJlt6qmLjjsSukUK8TDw2PK5wlJcKq1WKjTbHRJbGaV886BSpKHr0kgoV\nFPr3VKIn8Xxt9YUKUsieVnnIf6ncuMEGhQYnUuSSPx52TRCZQZILIqH0Y/n6oaAnZS2DaY6QWAaG\niCYQIAACBQgM7BSXXMhCCyhAYKBhcWJlRJUJLRAEBCgYAiwRcoX5dFV47bWakKJWkDoFGQUpRqCi\nYgUaVdS3qqpKiViWmKjahGyD9kIyGC0DJJU+MFyEqsEnUEU0BNWpavyqVVWFqKiJEFH1EBU1E4pa\nVPSZIYomlBCRiYhCxCwMFUlIiDxUhhka8mgchkNCQUioSEIHKMLTTxQNJxoG3eRxgqlM9GByqWoe\nSjSp9KDySSR6EIG0jmo0D4JKdXoIogdVoYYeNNSMARp6MNN2NiIyH08pHkovdFMqmpcnbKIxo0Di\nkM5IXCbhcrF/CcuBYBmK7U/gBIoD9xqJhGlOIQpD5nFdRF4z31idRGjk//16ffxPxpeZYFPoo32Z\n68j2Z7wNu0R4J2Nn2D6dF/eEqnoyMgN5IgS5Ro7Nh+wpJ0x4QojvRzgCQ+Fgh0niDUmoq6ZQt+aY\nAl114RRF0DzHYmj27AMOTlTrhmqUVCsMVapXXaUHE1M1nSpVVANCMeSY1mw+FWkQN4iUQSq19J55\nYxryR5CivmPbv4T3fP+uniV46uKWPNh0o7TcIu1F6KSHGmyEI7A0CUuIRiUqxaIQgyJQEIlmI6JE\n0RPDFlWG68LQEUbYoTAuNMEtBoNZLIfIT8qWDGJnIEgGybBZcogK5AGzOH4tkKcBkkWxLu4QfHAY\ngtwQo4oQEgWZYfZ6wIaZCSJ7CJlMLDMhs46E1394xyEun5tUdwiD6S4DZB2i85ToHWhNiCDhiv0C\nNxa3xja7RCGzsLCeK/q6qCA3QkDI0nmcIQ9kl2KQOchk66w6szCrTZiRjBNmYwlBLs0GGo0tulUj\ncT1qnE6o1RXCgyi/46NMNximEJwaTQgWg6P3UI7Qg7G1BPNCR8UDEi+BaG4+h33FiGA0oiEa7aTR\nz1/RWAIKOEMUogs+SLYTWKG40B2hdUPbthVKOsKDoOC+4Vw9Vijh7Ur+ihnkd5BOgrQf6Yy0USHE\nMjFTKYllHqaliqlkWgvVeaiKw7STa8uiRplPYaYHESi0PXMPWLvB9oMtNLR8HlS4KQilEhuXiMfj\nQSPQGchUDeSwqVxhLtODT+8Ku5wgAQ/oyw18RBFhvjCfB0Yj1P1QX1FCBD1MRCYLNsxVYUKMSqAM\nPx5iHfwHS3WChR5YpB4sF3rwF21D4SIi9MBBJIjQgwgjjAxJPYzQA5lAeQTOBJKRkpV4wBqHmNJs\nSR8hnhCdoEqIKH1C2HGqPig2ITbyBdITKIFDEaEjtBnOiBc89GBRT2c89CDCU97Dh/OhT5zNRIZB\nZsb5gqaHmZlPvVCzSoWgEBttVQsJoyJpV/qMRAQ6lKaIiKYm1DTBJHKiBxWiDC9EooiFBPlh9TVw\nlDklEL31fgJR/UDEocYD0ZBtKOLCiuhBaSRERZQlRNEsUILFlZRhW7TmL5KE1aoUxnBwYd7CVjGe\nPrNgFD2wJhX1NbSCWq5O3kDiLKwaXHPRQoKLaAIHCEABggR8zNWEtwgSBVMKfc7wEfIvpgp7E6bp\nXu4McIj4EWusrlgriRVEqJ8pCeJGiSn4ktsPxw0F+zW6pzj57agwJSl6IiYCPXcf6AW4QDtckjEC\nBT83RXup3Jm+UD+FOjnUhzJEKYOUUudmqNMDLRe8/on1ENG1QySTfuGmKLJQZdpCqgkckVWmWhFL\n5nmYpaKIWATiNrMFqjvGBRpReBB1YLtwIWry+GZCUGRfPJScPx7UHrZxhG70QAECAyQ1Me/yY6RV\npXiFksmDkdAw3cCSLEp2DqwEhcwFShIoQGBgQsyjYfX7dl5yT8R9CsGFhODwU16F8BmfVggJohAB\ns4OotDTIAl9CBwAAAMMRCHBAGAyFQ4IBsah2/AEUAAekcDiaPotDQkEo1CoVwgQAQEAAgAxJAE4q\nHL/XNo5bpQawEUKs2jdbz/PFDuK+W7MFMLo4u6krCg5KJ9MFNOveJHdn7IT05PoVPWq8+LIZA/zA\ngtl64++0CD6nX5AWRXswd+IolDx4kPV0/YmNmAle4WCCCbVft1nYeCWzSTbd/W3TleE3xjpSlsWg\ngbPs8Lrb0OW+jaaNySWI773YOiJ8eG5hSdowcCQIYRhj0ZhpnLOayt5ETgn/Ga7hFROdsTH08v51\ngYvnoQJVUbSIxdK2jXVDeyL4fl2+cIUg4mq9gjYxfuYmR+Hm2I1bus9rs6gFvvQ7aEpBMhS+eA/F\n+1j1uL3CKUCtbANaQ33S8HPLmP11KeiJa6ipQBBexS6wBwYY5n9R3TlRBMONz/zEeTRYVmPxRRRs\niCFX9H13V5Sbjzbw1rw6YcUiEtOlicsHJsqekJsSLGTarfxynJxxVVzJZjgsbMzAxYkPg45dHn+f\nImA5BhSi3IXn6kLeGcbFAD3Bg2RzCFMzbbQEEApOMCbTKIahfY2GfYK15LAx6ziVtb6nimwl3IGP\nW9+39K58QeIfgfBeYpDRtPLsLCp13f2+kyN+icv2hcibxN2ChYb0Un4BJBXs+lL26I+JihHeXmFl\nawHD6MV3+YTqMbP5UXhUnxpmsQhAWzVsivr7usSK9t9z50874SwnmF0Xhi+iFzxyFlfLG7UYjFMY\nMg71XZKAtChlEixD2FDLs461HADbWIvAK+OcOC03jtKxMFU2VvbNYmUs4rzOT5yJeTGpOeYUoDDA\nxwmWhe9bCebFdFbNRsaaDrB5tfekWwuBVJNWy/oqMbHzOTjmAWxP7v/+qW6f1mszqPdvY7hO7zPH\nuqYEir2CKRyMzEx53UTmKQam9d3ojcS2faPKYfnYTkS96zVb+WnPycIhrJoS0kixaJsPuXAL1Opi\nTnllAUxsbtO49zT+kVvbEq/z2zoassLDBTU34zkN5uV7lUvyApbrNE7fwYdddHJb4OI1TWklNhlT\nneO3fALmRlz38cB8Ozvv5l22AnEXTJbaN34CtGgH3j/ExE7e6vpy3jYFTU2/EHgcEIaP+ORdufRf\nCwCnJNfWRrEanifUHhAdzl3TnclZjlpYzIUb6giPG8uq3MrIho7CLj/oqzBtuam53w7jjcq8buW6\n/4/jO/tqm32GZLFDozJn2LtNq4C8azofomSlKp5jQ86g1BtsYOXVcFObrfhWpON4PGM15bGWk9k6\nprqhD1A8jdGpl+D1CBqQNpAKA1lArVJ6yCHtYFZ0JZSIu44TqQ1mTRiPAJp7mMoT8flR6G/fAwvj\nhsJHiDngRNhPu6iZnSEhOhsZfyrmX6M2QyBK7UI52R9aI9eCTioQD24Y6Ebuc2DKi9Lwy2cWwqMm\nQtZMZMEc85LjkODIyNDu+cp5fAJ7Vy0V1sAHhxigV2GJt8AZt5UsihGuKdzcvCyXIegO5RnJ6eib\nYGsOfrH9Pkn7UVt/W1Ojg0eUeOZ92cp5QlTykMCjaoAUKYsQILu6V+tmq1QtaeqoSbjDFxgdURPH\nvc7KkMqHTHdjrPpAikG7mi9Lps1XGKAxEi7Q/31Ch8duZZ53lcEx9iy2wnBneLc5+jkrEvsDl9z7\nzgXGufEdO+RGSGgVDNpwQiPLaJXEI2134j1X9TKxNkTlTxSE+QYf1JrLEArjXfHhgcgwLuGzYc4F\nm1bj1QuV2j9xYJcZ94SvLgsCV6vcmDC6QY6CBI9uQkfJikcuQrECwmeW2Hyp5HwylkemF1Z7jQJo\nSsDFoFAb1xfS6O0cDaTutwLefgDIPuE7UndaJ9dPJfP1eOD3g8bJ2usBEhO9UOMFJftjMHA3SKvi\nG3I0q0Grxp/23bdUL4DhwdsKu2vgLLl40gapycfWQA32doElDMQyuc3OQHY7EnZ73LHbZXjk5Shm\ntGFFIl8TSVhHJbK8/hFwEhDRFn9NvrJhykCxixsqB4V1wMxmvcnKJeCeiKoFYzbbj9+MtX1vywGa\nfKxLfGD8xBNERIdBHU4Y82xHVKxwadd2PeJTJ9zWPFeJ3ts6wZgLsoCQGJChVLosYI84VG4yaCzd\npXc+i4t59KDrZjNb8CQxFhlCV/0Fv2OUv4piz6WTYQM/3sFIGvbBei/rXvOWAYTyRckJkzaxA/VE\nMRrd1Ma3WIvu8R2lplWWKGA4lp7nNFVU6OeBMqyD+YaZ58zcngrM4pVSQr0nJVeduw5UE5k14sVK\nPMiPQDx2/AE/3HdyY8GWbXXFJxCs8f96Up7jzYqgwUfFudVJLYwgzBnNFy5cOJVJEx+/rQ5QK5QW\nepYhqNrjPiQ08Ll60NOtbNDRR+Q4fDNd5JFWpqMTqAxFqF8Agp5DYg2KR4kigyDzPQ0xxfodlWER\njKxQgBRBHbqJQp/PL2/x0zmkFTfdthoWKPuYCQDvgDTHQDd3gTMm/BTtUTLFa1PJJYK0CsogKjcg\nuBzwcIg185XPREQyOQnIdEShH2LIFd3++A3hcQOYwoCdroJSvBITMi9tKzhC0FDB5sqrj9hZHgiY\nLlRg1vszHvh/S4a+HerQCG1Qd1dhzInazNFrEoKfZmVi/B+JDXePQTZ7nNj9uUBWTw==\n\t]]>\n\t<![CDATA[\n\td5tRh7HDLza3KWLukS302ufUVKblZoCd9HpxFBvyi5K6SgTR9Qtn8MiPPtwEgsxhgr0h98ebp0AJ\nlnxsgMyDsu37Q+HsggcVPkMoeGAqskZ10tKLuOYskgxoG45AsyR0y9uAdkFE0ogD/QGuT9ESN/Sg\n1kWU1hBwxWcI+JF7ixlJaLiisMGm2PG45QxT7M5qJBDM/4mBvEs/CfiLumEOoJBpl7DbuS/j91QE\nHdTdth404lkEM0V+x9+m6p2A85nRG7Mu6cbFBQ9W57ex2vMcQXenAKEuTuYNCbo8pD2Btuaxd0XQ\nXTACHRGUaUE3pHb1SOCEDZjqPEWk/YMWyV/iXQs2gKF8Gmc2O+EGwF92rjdH6h6Rx3VE92zhQHHr\nZINGFHgyIVkUWx9S9H5Y0jbjMbi2XFxWZvGf/YgNW9bWkiwQHEauIE5T5/CEREjX+TucKe5lXijZ\nDyApD2j8+S8fKw2gTcgz0HwHrBk3USSqUI0YMmLMIiwn1NDKyySvM1CFBG2cl9kSjCDYkPImWg9M\nBYIQhdgfZubx5w2MQfo0HQA7WIR1DLFpEiKjrH4Cz9dfbeRGmAvRsKYb9msmwlEiTeWzuTpAtp8B\nVIhiklFeqisti2wD8S2pP00vS/Dhow8MEOo+SKePZ6AdrYd1B8BQMERX8GYS3J8QHna6FZRfyN1w\nVjw3BOlZl/jkjV39nyxvEf+lXVb+fo2VaMGFQ9vGvjiXPeqeCKWBmrDjAYgVApArY/sAwo2bQv1p\nlBDSa2JDUEMz7IVmyNvBhY8J1JZoGAUC54z5BHXT75kI9Tk/gnJ6SpvQGVW+g7ScjNkiwUA/C5Dm\nzcJWAGRNqBQjJGF+D94mpIcc7+Q7xtUDwSPzz+5qc47BI2tQlyHR+qgELRCtz9XHd3vShmtmx4qH\n7/yx/yifq9xiHC0gRdENsD0Ls/sdnrLtLu6EXho5lrYDChvrisDLsdkEd+GVnYwpa80ffovJGTpg\ne3XH15McpLPVQdlsGqOOkyvknEoBq6T9CmEBf7FG/c0FubTBBYMXEufaAfssvQ+OAb2p8cBz/MQY\n5ZY2h++oJXB4MrDxzDARMCZEsCRjiqHrIO4F08kBKEdhcw+BjWt3AVQQkxvPPVFZyFZAZ12S+mn3\ny6ZDZYFJkmsuRkWfo+jvd2uzMjYfUbTkbhajfN/TKYFsE0OkeZiIChnoAy8xHE/tcYMFeczONVW4\nDPBxCP+4Te4QV4G0rBF+e0bZuKfgXZvJ/DMCr3G/yGF3CHOZ9scmTa/PsciyArp6CCE38lMRnzBC\nQmdZfNxfaYYEoEkaU7tE455BlDOhLsRo4QzLQewrivTSJPaUiRtqruYywFtlsQG9gPAIDe+UeOC5\nI95K0e3xhTEm1CQbzTXAYg220p684fu6RBnbcu2wog7P5mBBpJmyYEzx48yYWksOCVQIN3TxYEup\nifFtW3nOPhetmCzMFBoGDy+hETapAmdKWqEHZtTxovGeQjzAxtqKNOh3JPxmQLUUe2Ib+ZIfxBWQ\nHjnFwClt3z41U6abneETa9O0Wi84p96HwNsFkmVs15AKW8D/BgtGGGhkWg/qU/oA6XW363ckb+B3\nySHTNNQvfKaQtrh6kiMbutuLn4GfcaEAzKcunnR7YtQIp+Cw8Lz9cV9VjZg1Q7XdgNgv2wGf4/HN\nL7+QARz4lK/4LGKBg4aNrRLTs7bXQwQaDJqlX6Xp8TxtpgtwwZFAqjGOXOxsq6UwCMfH6dY9vJbS\nThOaewAKfVnMv61od0SyBdTtsMgMZjD0MTE+Zgb9G0nNaIBXM/B3FIHcsxPDquhbmwBOyB20KTYx\n5tJ+2DABDmLaBOg4wmaTmG/0kdNgzP44T6a6JzU+Twzq+kMw6GF+GmmgNqsAOfYJ3NP4Pz8wQwkd\nLxi/qNckb2QG9Ji6jbvPRPjByBlPnXaGYgTu2LAEMbBQf8zE3MAO+zclp0eNB7XtveFwUIv4JZGz\nIHefY3EyYPhorGZfx8/BD2Btt9Wk25u3crovCIMa7tr2rNex+EmrkRpNiWELsHC/GoTqIglkRzWN\nwt7M1MdLv30bq2EcqFW19qguxo0hcyYEnvxbEMb6Eciwgj1OnGH+CwOmiBzl9kuZBqAjyoEKEFvc\n4ZcapM9N9pU5xNaj5WAEg0qO6kP7jTunfQynLIsRUBjnH8UaNxUxwuQzVuz0FleyywLcDFLhxWQv\nHzzDebbeI6BZKg4SnwxSjipkJe0AsDgjdz3UOdtVAIVUPZGoFg8GhMU67Qk+V8stYwKk6rMFDt+S\nLAwvJHEAkXkCrlCGWtYN93U+Mk1y0QdhNuSHVrNx3n21WH21/ADVPAiK4crBa91+LZm6GIAtlfkl\ncbLUn4en2c07JBAkMdf8W8K+QK42RBlhWuzSrrYWGsNNkDTuzefopv195L8rLswlmEZQUahIj4Bz\nORBHF089F21BEyPauGTP0dYyiRSvsyW6gn1Y1XZYbe85G+md+qQi0j+NShjdR3HZo5oyKPT0iZ0H\nF5nL6N65gVan+om43SN1bBrtVQuQr22WTRAgqerO0n6EG7KaFj7jFURjIYwnYs1EDgroPUtluGEq\nArC0YRR+hDLMTWHOhnLfqxNnTkGorcsr42eTIE9Li0Y04YuHfOyAYgx8zG7rBckj7ZheaVfAGS2A\nJqNk/0YHlIYqj3ZdoSp15zX3yhrAj4PQmoP9yqsG1Dl8VGCOZWrZKRLGK3S4W5SuObBc2mRudHY0\nCrTV3sJdj1T1YdoNw2ROxRSbSkCxa25nfa4YcD2B3ODRaFeSf6Ikjh6FAQ3MItd3xGwAbiMd4ksu\ntQYafFWCoHD3P2b4mwkf4rSckTICVAG7F88On2bVcXBciAOGMmgybNcYHFy6d3NKO5Pg0hxqMlaG\nCCBYtP1NeOQFcNqWdiG9juZdqYA/DohtC20gj0gcn2p8Hm6A2I2y6GSZRuBpLcJhTMJzW9Ncrsbp\nlcQS2V3P+R/VNaw7l2k3SXtThIMnztO0+nMFZO95UFd0MGcY0OQEGN+MR/uJuJ2ltASdsyYjDZEm\nht0fygBa7CBfdqF3cQRrg8g/rpKseuK1hunY9pYQpOz/6sW5jYGSOy4je0W0aPkqLT9fmoSz92J0\nH5AVLYz0ZsTOuDBh4UaMf6wTqpLaDB9cppdrBfkJztIghl8J7aoB5cOa2JkmuHQYa3Wte6DeuL/D\nqpYLX/9tWE0uMlqnCl62xggSw7fFmmkfo7V2/IjLVXH6MaV4sgMEpA/5/3p70FQ/34RpmJYZrzZG\n1e/2JilZqbKy0T90/VZfItpFE4+eWPUujAePERKFs1L/DyjTqiIK+4fcfWgVYyWZlx9YFROnPY/w\nKAybPr3jsYqtoM9mJcWnTQF/OaOylI0jQgaWm+VSWqKmEAeZrAU0N/BAYLBinTI8oznnO6Xz02j7\nC+bPu3xt0zqM4W8kwojAJA4oMjr1+0RDiNleb94KQFbyK2IK+BR0RmwGxGV1bQQdAj6JNyND69s+\nUtulu8XKiq2PD8vKb6gZLKh1xSQs9BTFQS+xj6o21Yj+rg4mgbD0ME0WoS/Y+vPAfmK83TTAzHVP\nlI6xyIAdFDsZbtNH3UfG8XofZnRocjbQRY8ZAt9OuzPshUM5uXpSv6h3NksR+Alzp3BPn/kkGUi5\n+fNq3i/g0y3Rnbwk+Xigja3IVVSmQhsDVp9NzjKLXa3ZJ7UA2y6Bwi0Ybg4Yx9J/eSCKfLZFnbCu\nTsE1oJFJWPifRigqPiISEAjldMJFALu+a33TuaYB75mg06O1ooOQ6Wdm9aKxU3tpCX1P6KjflmTM\nFQ99Tqk69F3tt+WHAxvv4cZlHr/PasV6dwfw1b7BVboY1ibypqujqqEmzVhjYdLeRk38o6U2eDSX\njLNhSUGKBcegxF3eqP9qu/RMX0uOVGfBRD9qjjMZwYE1JR+ZDyrlAveNj5+0HSV1ypdKT7pbQrS9\nxq19Sbl+w3anIuPWXdFRoQKVMxEvJqZF+6jRRHwCagQTw9CpYQjx+gYIp5vxw/qeRQknM7Vb9Cpp\nHSy1jVFcKaqiyuXK8F5pWzT7VxPBZsUzGD/OxfRyjoYt9HjIREnYsTkSUhmsThS7zEioCWHcYB7z\na0RrKUkqizzDx/sgXSjtLDadJtSBDbQNPVYloSxlkU7olPtPjuPsOYCKB24A5UKVpS1IJ2mTxAnn\nfqyEg0KAiYTOs69/GCXbXo6/UX6SNHMIGeqeYizXeSJBFmUZn+DnwQvTCLfHgAKuWhX6Uq6WhSHk\nWYeyXSNG+s25urGON44gWAYTEkr3Bd7lSFYIcfImLM+5fM0yy/4k7EgrYtq2oEJHbT3w5u9TEQLl\nHASYDa5C2jpWnEKQTMuwERLKfMMzFLQG4O91IgLsQjnjfPz/1rXP5vzugXaHbO4uXgkbtCF2ORc1\nzRxa9gbbV78i0+lxdDVPQxcYlRipSlJPYJW9fYf/Wim8Rtd0x06mMyF5PTCVf9fkTiDTLqxmPLZ5\nSUA+jWPzr4C1cXqst7/tUM90CarIUJWO63pSFQaS2HDCjy0+2gED48HoIGoYlmq6LXo+LAhu66aw\nuGCiLg6TJ7Q0iazwhGIWQrNcaC92Sx/+qSvermjMBRF9mDbsLkBLkCRWpfYBfJBKe6rHP2VZ7V9i\nQgPU1C4dKxbr5nDxCrwOxRTZWryQ/X4Dvxb+/g8nRrIlQzf9aDZVyQXIga7haMMOk8G4EE/XxYFN\n9bgiNeUXsZV/tp/KIjtwRx7cm6G62nKKqCdvOZ2LhQmS1RVYobXnRRgKFONj2Wjp6FVDARFHO3A5\nhrs/WoGhzY4cXqYb3dO2Grj6l4wXpwwq7DPMl1rwqcj9mxDoqa6t5/b/sEJGruQ7D4vlYVNIDFex\nJhIoMaQzT2EUCCVixyh48AbciG0usWRqhjhUz9H7GfSoSOBK/xjFQvN8Vaj6LIzcXuysFGodkkGJ\nqVyMLYAQzcMphc8AoShko4KamRXArgtWaC2Q+z2OTxQaYbM9rXApwNQ2U5QUAF6RqwtdchNhFxUc\nwZPcrIThNtrGIgecPJjB+1y6ZDV13BKRY49+uZhEiN2V9qlm1R6PHRs0gm1B+eR2RvNiwbcT6OBs\nxiUlJiqOwi1CBsU+guVewu8Vv8YjcYB6ExAJNue00MzM1I14TDzcAOJLkUaZA9dll8OBMOKwZHNW\n0kBWMcuhgcmJkOKSk+fIQtMaxE58X46Flw6x3o2WMvuSG9UCXhMyP161L4C1Y6H30UX6TJ1s+OqI\nsIMng1MVsv7ilyLTtfMJVZA/7G1WA9YunkWgG+gkTOU6ug38HxHN0Y9ae+rDlZFl1Tmnme89pe4j\nO6MkAcFTHzKGa7N7mEyGHLM5U4KXjCICPxxopwJqJzM9250Yk9dNO6rQ5PHLXLeSZtj1qXoGE/2V\nuBKz/iVBgb//xtVY4t8rttygIo76lpn5Z0zZIin9h2tWip5/VErLjUR5YGrFDRATnA==\n\t]]>\n\t<![CDATA[\n\teCfHjfLyFA8uM3u24gdy5Lj6wcByr/NuFoYZd4lDU5Q+WTQE0tcR+DXRDcL7uEW1FbHSGFn25oZO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\n\t]]>\n\t<![CDATA[\n\tkeV6+CPD8NeQp+Jh+E49AiKG19NDpIlRVnroVoye0cPhxSgGPcTOGGU9DwuO0cN5KOcxKjQPn0BG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\n\t]]>\n\t<![CDATA[\n\tVbOG54NwtdYwahAQPB/GghBE1zgiCFnxGksGQqSvMSAQ+gMb6wAhI4aNu0UkveQbQBdZnvixCekP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\n\t]]>\n\t<![CDATA[\n\tfvguxYOoOQJiYP46G75H6tvwt/bg5cQt6h8tfFNvGYw4DHmQ8DeCUKCwYxf0ybjBZ6rMZzgShxTB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\n\t]]>\n\t<![CDATA[\n\t2c+35TViwleVhaW9/TRNkk17ZyBRv/XT3jKBqcRkIUpH2ns+J8k7pZX23jSyvaYQPn5Me1Ory2Oq\nae8w8xNvwF7QdPOnvTmsUvdAYUHa23jMcw/qpL0Hq5bOyx+UezcpszsvsQ9yb39FIvsI2y2oULk3\n+rzieYDeiXuPUgAX8ySE3JtRN0zS7g55i7qQe08QU7s/9RYLuffxeUygtXp9uXfxqIvjCVYAuLe2\nNcIj0yLZT4NuSWnsAxR577siQY3c1CLuHUa5WeA0CdR7E33pNDaAnVfvnThZFQS99/0vHM8OWgpr\nLqFT712V2djKOxTHaHrv9LeOpt67n4BgwhiwhX35Zr03i7whjH+f671h8OoO0L903LF6bzCIkhoH\n35a8xuFCnmnpPfgeprGhIGOHDr4ZerYzw4ymtgiDbzF0ZOw143WW/+BbPJSOEcQUIrYNvkWDVk0v\nwrX/pvcuGNJKJzSiShAHoPeOPtHuhcXfNsl7t+WT1Tpw72BYvMbh+wciuPfELrSAvDfEOZkSeW8x\n5jLK1kWhYzzce6cbMY8ioF6493RiP++NcZFFGDRF+wKqO0aQZbomUeQv720JOpgWkrtaLnlvICTb\nNPWLqjwvee/rBUaVnveuaGfbv6qqhHtblz1hbT3RKsC9Ewc0CffGh+CsE4Tj4N5C8YqWmAdaTsG9\nvYm0ZOA4qvf+n4TItX5cdgq994+UB9//l3Xq/Z0MvvuNmJguvlOB8RANGQ4VfKcermMbgm8i8EMJ\n3RF09d6ehtF+d7d203uT0gSmzSrTDCLuXb88Sci4AUUBKQMhnjIQLjBnyc7r/ee1EMUjZfnEDzBb\n7LjU3yncu1Chu13lHUja6LztJiTHvG3EdyEp+3YO5R1OM9gMNFuIAgM1f7xjAhPKXAKODMriTVQC\njZFhX6rhvRGoJj6TQUzsUaUSvJE5767dAGzfTaT3s27hUqtSy7tDtAEqB/tUALl096vhb59decO+\nwN0hZlS9Xb6ATGl37R60oUNwzm4tZg8MzVkhvsXu+DJNWVQCDTepFO5G+ZkIxkln3agB/Sd2X2mp\nuonmkbKvAH6CUHfxHofHPrF4uHTj/t3Naw0MFiqxfBzd75jIO7ohjOMFJWTAcL3QPXbHEDNSKznH\nw2T0Ns6bZpsEvpwbbKWItCaJ+DT3zVbcJ29ZBXNTBW5P3avse2mu3Efyn63JNHGZ/qeTuxg+HHOt\nFPJrpx7KRG41L5DXpuGSKXncM05vJYZ6bXfpZtxwVJkqT8Cn4tZaqeFITatWRiFuZZzg7ekWAYYb\ni4uxx35wZ1yzHPwsEIaB2yA7QogneGXqbz8oTRlL+/ZPOIbwt7erQAcWQb2aMRIveVsmFf/oSvIi\nQyN+xQhy6kptt/NLtyPGFoMiWzqQ7Ca3bSeUTCWT3IF74fZw8d62EK9Ey9z2QTgBbpOxMl3Atk+K\nh/942j60L9xq4QiNadJ5to+6lAOM17a5lm0AbDFftgnl66LXXDUYObZPdEGdyWfhuvgK28e8p1LY\n5hgL2ULCSOKrBM8dHlrHHTLX3k5i1uiV4g0+DLW2FDTCVFm0qpYjkIE5Uhs0uozV1o01ZBtvT+2Z\nOzKto8TukZJR+70Pe4RGSsGupw1nDLzsU247IPeb2uEei2sUFKtn76Fi6NlpV9qGM3inMxDtnk+y\nbu2oE/qqJT0PVROX0f4nYgKDQ/65UCHa/ZreHLQhI+RmP392bjay3/Qmu8Q5k0Sn0TxRpmFnKzI9\nsobPhXH2rLsW1/zo0aXJoDMjjsl9vkIm4xTNJoZMUFe/v1hSQWa76QhOAnUy2A4xeCJC4SaomZk5\nbdkxaWuHbAvMVvYtAXHHN/9zLlJ2WIRuS4/LbW2y93mzBwQXvCQb6co3aqQ4H4ns+a2giYXT9dw3\nAdkAKnMMZKvdvhHFubIhi4LCFoMyWnWhcWMrmk2oXX4Pq4zNUHLkYoNRXjDFPp8lQdTEOexxh2MN\niMXdkB+9ndYaiE0BMuWh7clGlhy8YQs2bcrocvLcwg7ETpawEtNDwqZ4DxP/tbbaYGM5VZOITVoi\nvEywbU/b4iKwBTkFNmac41bL5BfACmDj7tEaK/4aUIpPl6gO9t7XENaK4PUMsvmad7Jk9SK0UirG\n4LJ7HT+j9fZDn6mp1zxb7MuAg7+85uXNRi3viUVxHtAVXufpIXs10YtNnty1lh2L1O/LbrBrvnH1\nurNAEYlu03Xut355luwy2rm2R/iYo8FyyvVeEIltxufktrgeHIVD5qoYI2AF172EgmFMC6lp1pq3\n5uLKmj59COiVcEK7kzDR1kV38V4hHz+dX+ua9iNYmwuAvdWaQYANTcqv0W1ahws3njC+JMD16s/+\n6BjCxck764W8sx1ZO2uA7Iceufpl0Mx6GxR/sIeTorI2OyudH80W3uoxZcj6UABJLhjrub4H50IF\nJSO+uLiMp8sn5nK5d/P5RPC68quz7h5SzW0e0ebVt1Odt5dMF/3V1SnhavZOwhFo3RBiq4dC2hKG\nsYZntRULxaZYLZ6Awdpzd1etZ66KE8mvh7GcWXXj4E1Wklmagb2qmp3tKR+j6YSqec5SSsdQqzi5\nTyezQYZWyHFUTyAx2EK17MVdPvU+GwmhO1rE2pzaLXcg4xwwUlMTA4+x/MxIhKnPlozTMO7PxcdS\nj2dpjkAx3bzFivaXKaMQWEZq/BJNUJ5wXFZWj3rXKWx4xM2onb8VSLrV19fr1LGBxn4woUrdAZq4\niruEqBtDzbd9oDXGSdPmoLYLKa5SXaAmo0D0rM3wp4erNooP/cB7mk9fBeKS+bRmZmuXcDDOEO/T\nLYcWU7XZrnh3nryzBhyOrtOf3p35oGrtnMa6qPvNcVzZyJMws7fKx7xcZKVXCn3PgoZHZtP/mjvG\nWdMIup8ifU/Wir3RtNIr9mbdc2vN9GUUs7v7AJdtBmT6Qk95+KEs3sfDNNsXJrEtDO+Xjg7RTCOz\n83Vp+qX9Wd53Lb0jAX0qj1iS08I4QpjF0qaCC3Jr3BRmpS/adtwo1QIoVDpZfcpINi1H6T++QU7c\nLP190pt+go8QVvZ5TXosubht0jwnNSdSZgeDTQFDSzrGN4TnWcy6xpIkHXIqFCGKqfRvpBsLoCpW\nOTW5W4l0XPSoF/Hr/yOk+Ub/wfyjafN8qpiDZrG7hmo9+i8hSFGkyo8dfWsLrRZURBz93H+K2NOf\nio2mS4RB1gfjE3W4PKP5IWOcATqyjdEBM4MykcC7XvSAlOQ0BDZ+tGiC84tSk4u8iib1I5v88sRl\nmj32GzCiaI4iKC86Ex2Db84XGSHRUkUOkegXjRy6BiEi+vtoB6+EO8nuK+wP/eKQxB4QzRBjHNdP\nVb7+Dg0rnjkZJ9Za3ySmHin+TXE7iGVoqxIni3ctRdN52m4hiO1leMuck0LTriuSrqsmoSkSQmet\n6nxcIHTgD4q9vfCSZP3fG/RgG1WkHYYu6NtsSRUJ+qGFFidj47iB/soTeYjj6pMEmu4UJEFNz1VA\nB58DiHjcOEwA+lWtkbMZPuOfC9DAkKuHHL2ff9/PqJIHrCEB87PMkvHy7z7TPcddqYGSUp8XPRjm\nEN+MmM+3iNs9DCupR/h8HNCMjId7bs8iwYlIOJ/x7nxTr+eoZkAVrhAjKpLp+TQQHnN0nslb4llL\njBzASnnObw85Ootn7pVgeyPS/094JoJjREIu8C+N8Gzes4QBrY4Jz7Cz/ugmQB2mBAlfCc/F9TWt\nbWe1Ep4fqw4Kghp9vTP2zioQp6jb9M63OYKx3jk08D5NeXXUxNc7Z+htAWmabbg1BL1zkHrv5c64\ns/2eHKM7ijsPIkkD/NIRjjuTMMtyYEuKjjsbikcqwRJpxp3bNyhJyGlPxJ1/LdEDMCbtMaHk4s63\nWjLwcCgN6NDOLXvNJpxCFu0sBaX3Dy+VLdqZbS6YHfQWEgWVP7QzB49kJu4MBkU3iPfOpBCW5PfO\nV/Tjj7SbnMvfO9sJM/DdnPaRH8qDxt45jDDgmfAsfHJC2wrLODRphOd2Gw6mO3tdJDx3hBqPYnII\nzwUc75yCTK7emaudFjOIyf2FAXdmuclLV9ZgSLgzRgBMTqzGRv3+dlZ7wzS/nd2XI2O05h2Yk9Lg\n7TzazCrNByyGMcKlGgFMC1N1c4fKs89Q0Xa9MmChEyLp7I/HQL1bKgY8DWRjYs8TsbEZ+aQa3wqv\nXPIS4l7iwNRZWAEaKt+OFqRzWN0v1te4f84lYWp3yCimNuf9ZhCiyx1ly9kpXxJArmKN/VmuR3IW\n+Qkrd5tEG8sMG2fO0URIgZFhtMR5TUqxN7iYIgln/V2mTHJFhe5RAM6RIS+mhIUbg3LuzUrBBHlv\ntt7J8NzJdti/jHZzAspZH0JuJkRqwQELs0XiYea4CJSarN6Ieakpbd63g89lkzbvcWbkRkyiJdlM\nfHWSuLb8kJHvyllfxmbGF+xGzC8tao+Bz2bjlSDVsU2n4aZNnxyIjHFMpW4GUiPFxbzptDov+c3p\nFMyu4NSuY81oOHe33p4QaVuYvjHmcS6p8PpIJ2dOs8jBnH921SDpnMFXZz90LtqLNWjBzHQ6CgfB\nqzr1+OkQVWmvU2OYYVCenZLpbQR3hvjCKk+Twzv9IRWqo9oz8NRrQM/AFE/A3ewFKM9jXSBh6GBV\n6Ty/fNGZnp1w2OtZxoWsgXuv4J5Z4nG54LM0W/k0+Uz5aQi2L32C6PZZP7pPyE/rbgfL0imzn3Gu\nZ3n9WWBVtlIKFlSZP3tOZ+F09nq0IlMmX7AXfTKoGTsISewSwBFBi7EJvxWN7xa3iRuNBo3nQiTk\nQY3WxTRCfbG7x/D/vFiooVRXQxhqZy9BeQ1F/PTOWu6cQxeqwLSHGiuczEGIPuiyVEEjujeMZIlG\nxHzXP1Gh57TaoaL/IYCURdW2MlmUpUyZHU1Ari7K3s+MAg6jxIxeNVH08axG1VBqZG40xeg3KeDm\n3VJEVL8cpUURj9zRw58sfI9O6dbZf3SHZYhDSHOGwTsivdkHBBrpWJ8RLkn6M66BJfWMWV1aTTpd\nh/Envbl238l8a6y3f1LYEPciUmrDi39RqRSQMSE7mYcMAacLpdTflmKypeXYmU/UpS+0i7S0N/J+\nqYv9EwaHqTc3yEKmLA53VqpPZvr1AoumnZy4mlazxFqkPSn63jQS3NJWxim2E/qcxhwHOw0qRcK6\nzq+hmo3ak3CNNiK9KSCJyt37KRaB6vc9cG5Q19Cfvu1Gv/B9wOh/qMg+HEeKypNgh6GMiiX8S+2o\n0qfWFH6UUgv4AyCVoWKlZgAZAFPU90pebFg8XEdaWTSVj5uSOLU66zxcT/UVKRcaVJ3gAp8aVZvB\nfG2pvlKq+fpUZ+dzH6o6A8sUO1atjK4aeaNYDKv+foYEs2rWQ46oVr9vvclbxfkSak5vXarD9hhg\nbefeXnc1Yr8ib1f9MpohB6X6dboQfQp6NQhJ+mP5VfSCnwQrHfYyOBvWKAGLVfP7WA==\n\t]]>\n\t<![CDATA[\n\tfU9WMm9zEbN+riDj8I1Ocu3sfA9NSViEX8Agnmk9ewftqlY0WI3da3XjUxk5W0Eftmlwq+/pTvRW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\n\t]]>\n\t<![CDATA[\n\trgN6vsMDN5Ufu9niluV/bM0HpF/uEQTMmB87JhHoJ8Zjy8ZGYc05THoslYd5KNFRbxU8I/YwvvYs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\n\t]]>\n\t<![CDATA[\n\ttOuhTgv/0qb35/zR/R0u3i+KBLx/EvP+jiGcTF0ZzWUwsKubLMZk2u0bDFDNZv3glJUyvd+IMvDb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\n\t]]>\n\t<![CDATA[\n\tkIbtI8rAO0hRz/YJ591BiX02kWSfXfQoaBtRAt46Xbp+E/jWew7rbCFIvn+E6XcPQfLZOl66ruOV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\n\t]]>\n\t<![CDATA[\n\tamq26m2mTonLfJFFjdLIlzFDKFn8oBUr9CGWAdSZqFPgPCmXeEUXmzCKfrbqZbrAoobZI8sZpZEu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\n\t]]>\n\t<![CDATA[\n\tonSIJ6cejDX1f2A9pTWwjs4aqpTKEYZc0g1oTNJSJQw7AhWJ34pGpEegIsEJRVsCj835qwnq57BE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\n\t]]>\n\t<![CDATA[\n\tugGNynkpM+xzAOm6T3jPW1gdlT1QQaWrVFDWQIl73g5trtmDo08L/w+inr+mbbMwZR3L7WwWpozG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\n\t]]>\n\t<![CDATA[\n\tIBsvCfNjLCH62EuX2hgBEWxjA77osRYQCsYsONScoKvA6bwW8A0JmDgCHyI+w292ZIS4hSsHOpZ4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\n\t]]>\n\t<![CDATA[\n\tTjpcR8si8DcKVJxDURKPmvnhRnyHB/EcbsNtZLhMDI+p4TWc5spjZngNj+EznPMbfsN1eM/ViEdg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\n\t]]>\n\t<![CDATA[\n\t+Jcyu7eM3BnNO62FGavp61ivuYiuL76hwocrmy1DwEHZQWgpIW+xkspWNCa7ghaNXcrEISfXU504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\n\t]]>\n\t<![CDATA[\n\tQY18P0jxz/cQ7vWiScCvtOmlItHYtYJ0yhu2nMpaTDjlqRKJNHxpNO9aMK4VIWJmb01rpOn3lT4H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\n\t]]>\n\t<![CDATA[\n\tHm/ve2jVQKXMn+/tR5wCXGLQQWyANJZyEwnIH0cwWElIp/D3AcGzi1j+KvJYh9oeyzrz9jUyCqCw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\n\t]]>\n\t<![CDATA[\n\tVcrLsnZRENWj2cKu9yKr3hgmVle7VYOE8TKQMIe1l7rIxWOufTRITcAn+lmTIoTWpjIonElnhsyC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\n\t]]>\n\t<![CDATA[\n\tOtNkGo1Kk2myjHSRLivLSFeWkS5LQ7q0dtJFuqzVwm9/ev+fPmaqqI1lbC2mN8qE5X2vLbnpZuu6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\n\t]]>\n\t<![CDATA[\n\tnLidZukDKVHVyJVEbZY+EC99IDPsTP6BYWcKTSiP2zw0MJwplUeoldxP29aVUFs3hhOF+sRUqKlm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\n\t]]>\n\t<![CDATA[\n\tZL8+0h747wo00RaOyw5+wyfYgy70a+absXrJC2YBx1uTphebC+GfY8ukrRYZuTYrHa95zjZ1FdpK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\n\t]]>\n\t<![CDATA[\n\t8hX112FF2aBgkKWOzRPDAHwH5Gmz0DHYdZztbsBKEjOHX+RmE7/DiRU5vDSig8MHijddaJZ8TRTg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\n\t]]>\n\t<![CDATA[\n\t2vc8BHj5CjIuyKQVU4LdF4XCpJdFnyh+6uRzNablPkLBWIWs+ogldK31ejnjlY6NC6w98Apc2Xgc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\n\t]]>\n\t<![CDATA[\n\tVVnksKQwDGtYHEA1GWrCQaLLnKWAWrFdT98xbXEzcbFETRZqdxiX7vY6FAdVT+0fCCXyBeGC51VN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\n\t]]>\n\t<![CDATA[\n\tk5eNyjcOpjZPQQzVA/c7HmjC7DpU/t/kkYkKmGHV/i7tow1cgwYos8VTGDhc33Wh7/xTlX4tEN9O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\n\t]]>\n\t<![CDATA[\n\tQJdu78PHIg/o3C7X/y7ycfJAR2AAii+4gRBdAKNRvnLLW9YUqV6UZQTpq8SJ8PDnZrF7tDi7FBNl\noWq4IBLf8n8dFq4W5gK/YXbLrpjvrPBiGd8BNd8xywEe49ua57uNwtKM7zqc76IhaedJeXz7ovmm\n3nD+xje1zzdNDcd3oGfZzfdBFHYa371yvkvddDu+T9l893/p9RnfdTjfRWxE6xfUme+Vp4HMN1zj\n+9TMt/+kWs0OR5oFThI8ZLz5qwpvp+cLp+9ONU3wVIjluLdPzXj5EUywVs/+XvyHA3J8alpBRhNA\nnxohMgTP6gQ6JSqPbr6osvBNSdcpBg/azFgDmU0X6lLZt0pZwZBZWkbHLmmfE8ykgNE40ihni57B\njmrM6FYeQ5r20MAtEzYmXrgHg4NKsI1FSAhq5kBDE9E0f3PkQOwKHZWMAMl3ILveQCktph9aDAGH\nGoFDZ21rEesODa7fMDeRuJzgvyajPlmyPuUPIpINA239KhQqw48/IuYJEmk37sx9J6rcGsF1paCK\nmVaFUC3uzWtZ0ojRpIOy7y7xsAaozjS3OKar1VCtsV1JcQ1e/vpaBHAOzDHKlBlpRs7RFpsubkru\nHMf4DfqxwGWNxiJW/vea7TYgZvNQM+ka3lbticwEyTDsIfFX6V9XBKQZQVxR93RZDKEVVGkl+hEw\n9g4x1UqAPMj+f0SVgbWkND071KvcjSf9Nn0A6Iz0wgLjHwChhfo+t3baHzVfFnFBaQe+8De4KY3D\n2VCfB275qbMiMRA4GWcWQ6LYmQ+ZEK6gR2QJRRqHLhmCznOZtFqGFGhBBtWE9BiUgXDgCNddGwp0\nXzYUOnB3gWsaxvERCw8EVEhQpd6wLPTYZgn109pejf0COoYP/J0RCIHjqKEf2Q2OZUkgUz2mhQkV\nNIerlTj8GsZmyLRJ3k+sUj1+iSx+ywvpWbxGIXGn/WdhVGc4oeNZjbmrRirB1eWYTT5ISAkFZyOq\nVdFfWFPCfdFcbTZdQLpO0lF2PVylnpIOHIH0N0kXCFvwBN0lHXhIP6awiPVbxF8SSG9L+iRlZFDS\nLenBqZAOh5FT0vl9vqBAerqkAyYMeFYH3BUTwCDdYuLuNY4IMpF+SX+3QHqbpBe/ajyB9DVJj1QL\nExak/8MQy8CBsR0PVpaxZNIWLglZah8mXyQVtKn6+YfWNswpVnp4yxhFIrGoIyVCq4NYeeBZjD7G\nOtFCtnBiUv16ytGJtZD5IA0JuaqT4haSjq+lEp6G9GoVWFDLQpKHIXUiZDp9iJRWM9BibKBBwlLW\nXtlLH+tCbIThX9BBBBDQIX6esNPVsr0v5cF9hzyg5wxnaQ9g1AIPpz7cp6fWp0ZgbhwDbjsTBr4p\nUmByrkXaZ0EbnN9p2KSekFJrRPyRR8BqgdyDF/V6eF+34QAUqNYSzBVqtRkVA26A+YQX3VZ5+ywR\n8Kx6FI+E2Rli5wV1dF1X2ojR4qLktPT33iWkzQVfDV/9/z5skfclPecjRnYijz+vSdCdhV4BucTc\nVpsSgp6AygxN1QmObxTins32zXNXMocJDBKRn8fx6r9as4GeMAqqQWar0vH/1a+Y9nE19ujXMmnQ\n9/6mfxyHlKazgotSNDDKiVRVyHUFOBOdrvralCDp6llrR4ZUYPPitrZLKQZVjXONcbo4rC7aTybz\nmmx6FYY/NQBErHsqpRnL+HbjgRaOvcQFLVyj/1EyMY3Ei3fEIdc/NGJZ6XEo00wE0rkIuxfAMSmX\nFqkxf1cVDeD+lekU792Kxu+VZ4iRC6isr/0hnoGw9DbeQkSGOV/v1euSuwOinhHhgP5KGB8D0OhJ\njH4z2EYD2wtfhMfP4RNxkPXk7KP7hYmfmWFXSUaxOg6ZGAY2koE06piq4YIOS+q3wfZYBLCZz673\nE/e9fgeXxFxhY+KbRQ+mvMt7rTyvgqgwtsBDDVPWqZx2DnWQzl8c26kdY4lZ5aUaBRIWaSfd9UIF\nxyzeB+mv0ZTYSMvHS4nXyCBUQrx/BLjpeuRD3Nc/rWHa+dEK7+jE/UFyLkNrNDkH/g1ulSLPBW7E\nLxAZQ0BFqNjPEE+c9kBlfK/KPbAzpeQLK79sVOevS51QEdWCjKq63/5VwpmKPBAqHYKYNgXUUGp6\n1DMWXB42MgpAsBkeyLNaQLS2eFKVeG8I768qJow7doryNTLuSP0pXiOW8YsUugObJd+6fYDSsWJ9\ncxsIN5UHowTDIoXvV+CIR3QNoUHqZGXW+yLvBmchCN21yDMoqdV3ZYEQBAtPNKDlTGnXi7WEFdUF\noy5v4bsbhYDZzk8iHMKbDbfdGuCaOjVQCEG+/qmSWueAIAV7N8j1LelueKiXLf24Q1AhL5BRtlrC\nkaANO/yqa9Xrsqc167x3m9oH8HndYUseK5xUbfYl0yEH482agTcinlD0VmsvYeRyyO5uOE5jAHh6\nf6SuyDnjLguL536vkreeyZxdII/cWAGIgeNPG1lJQ2WQM9JV7Wzen9X8vIiSvGqJkTUY4ybunk+Y\nDsb4p7rcnaPN6pHp4QjxJK3SMlasGrtB/PKSFOD508J2guzPhzOdTeSEV7FY7PaIzwtVyzaPuyzp\nw3Ka3iox22Qby+CyVWA3fHDEXRDwMyY6ERqn+TMoWWj6KjyJ0paP3kuLLK8lQtcrpNaQ9UBDbQgU\n3A33YAYGwVoGWM1llXCY+ZXLfO6Y2wgNBuNwGGtvjI1VZ54sH9cV5EtkcRB8wJ4tNgn539z2/1zX\ns+HTjgTPm2W309njA0/jf9S84ikAgITWsgLGceGp/r3LgNhnHmZ+jHERP6NIqnVdwpOByxZyfyNR\n9dTmbtURYPts48vcPUk4Je5lukh2lCu+k3tiWo+iuonxAiUWHA5Us1K/m+Gg5aW9cgFKXrxYr0IS\nastH0JaJG/NWUJnZyUER7nxK+07flyfr/qhYrBK/EFoBl+BvEVqP7o1/js4832rrf6yMkwqHedot\nrG1NhGB+hfElsCfmjmEVaUg7E8iJy6qQU4NFMgC4rjl2k3E4If4zknAtR2L53xSS174IFzd/0Ipp\nG5zxqdSbGA14W32gZT0SF+8ywRhm+JmZgdFX0RejNyNy5fwTcz6xjsjw/F9bvvKDN2h1ymCaU8ke\n5d8FCpP/pS4ihqaZF+cM6rvWbB5XD5omHOquZRpyJT8yinkSZpfM9/DIMVs8oNpn2Yq7StEjsU40\nUcHGaXFqlQM3HESoYg5KVk8FEhhXhwfkxLlWiKcsoy2yOHbPGMzwhV2y/1cciJLoFE+K9RhbzGvN\noJql6YqnGSrY5mMkAuKpCFWgsTbVI574hqOLBaoonlyVz/Z10uKJLwew24FYSKV4mmTMCNHcAxDN\nXqTR2iiYLzwcqaAAqRGu3M0vhq9CxAsMmV9r7WmQ3GdV5lZkfMix5YvIw3WTd4nNNTOKmtsWVe5X\nzSt0jx36j/BxvCuBbK+CVUAV/FBbVvXEKs+0DnVedSi/TPopViBcIOVbeAz/N1lgZRUn26uAp7ay\no0TiAGYc4yAq/Vt/x2RXMRW9HUdsY8KkjLHeihQhLSWw0zD3FV2/TdUDhQCb/2kNSVva8T4w63gk\nrDm6ddFdRD6GWY5ebguUqA6pJSrBiCtydEk0TZnqF3gDsdsA7DPIpjl4qrwQwrp+rl8DgTIgnRJ4\nLKx4QNZ1FgRlshPLFhVv2ZadXTp/gPaWoMuBOJkLoU4jS8sqIDF7LtPqHr8gmz6le3TG2lKsNBLt\nYtmOWXwkOT8iAX0ak6yMhk1GQpnl8NjHPqu+utjSiYHLvfrS4yk5P3OKRz05mdiCuorpuKvY6pY3\n5PzN+D3yK6zv7HDhdYu8picaXXr6eMK/5HIj/lPEz8BRHtn5eMqEFAaLQV6NJ9IO72x/PE39T48C\n4ih8izZ6q+b1Cfui8TTjTWCUhAZw42kgWe7U48l+xGUVcR7XyIb+ZR49yWl1f6oEGj3kOM0xDiSf\nf522FJrV/VKh18qHwoGYIuJRALxJpR5ujvx/L4hnKaLCUPAzNiOK7A0DA8I9sxKFTtiydu2FDYy5\nnISayUMzLd2UYkHSPLGt7C5yzFdogTFIfJ4o4DO+Yh5AjXzC2dJ+ZrJ6GIyBpiE392nprDNUCmsH\nUGmWrTwtUsiriGcv42REi9100lHYjaxOzNIvRdRkI4+e7BqiELN3g7LYdlQGXx5FNUsqdzSOyN8f\nazUTbxQ5jaz9QfqZnEvJbCa+6u4LMuqiSrJr5hzZLhH8vLkeXXgYOLwkKnLk1yJnNtIxQVqNtfUO\n4qKcdYNRn5UaRQiVmpW008ag0tco6EKkjhujzdEI/vVtfRFrcPc3QLUZG3K6Rb4C3MvBwjuyVJmZ\ngJFDPzpux++eHzIQK1zBFT6B9Vn7MGwtiKUclAOhABabi2iKwckVg60EGSbLDeZIImkkx4NWTG1R\nA4ofQy1t/uBcYsNLEjst8pzK50KnZ2nYqcIiUJ7akjw9lu48XGvLDpTMFQeeBfxqAXlqms47Lnhd\nmZE3ybYHckoHjDldhAEtTludkJSdsFkrZaeDDZgBHrfu2Mhp/ljBQD+z8UxNMttK4bsyVx9LX1un\n/verz9ZgRUa3tXb04fcIfQnBcyAMXQ1Kyfsm7H2ogdsuYV+yetewfT4D77wJymL01iayFePXlBgo\n/7eE5CI0T+LGf3on9I9T6GdS9AF4kPVcMU5sJez4zRSe6roA4cgSXpLav4Fb0Lctbz85mvwwxcGv\n6Z7G/Rp5xrIDIQGsENt7AcMzJBhFWpKW6F5tOvCDnVl0psQgSNi8jy+/9OQ0Dy7j3JiUE4j86ERw\n8T9WewDrCcx+gUazySycrhnf3rNSNcy2++KI6u8RIyGqG/cgtnREu2krKKzYvUwCbt6LKdXMRfwb\nqP41IOVKX3quuUlZJkwoda40bIpFvrMHDrmgiv29/cQhgb5XuQBTpy0/MCwsmpumLp6z38JI/GvF\nq/7dokqqeUP7xL856l8XNWkDHu2/9gX8C+uqvjRsJyL+dWP9q9HA9V8NNPnEybOpIVjK9G9KLPY5\nPzmOfyPbSRd9AELf16/pgATb6HSdxCslQekymIl/+0j/ppOzwVFfJdmRxQZcnFP/dnwZJj9aUU3E\nQP+/BrTdC3TmkGGhN0rb7DriOCzv+sa/lZfQU/0b0sWfmD4H/iXE1Hq9VEVh4fAvgL6ciPq3a6XO\nLuiF4waYz76DBktgGZXAv5m7BMfo5eL0L9T+AJUuwXwy1+jf4BB+ToR/UZDqOYUL+/bp/PWI+Fcz\nWcqLSnTAxuh0BfAqbvDM1G3hBrflWIChOj0lY0U1wQSL9zCjmQnmidAfW7U6VPKURH8gXCAqT7wA\n6iePJ0u/cN0nMOgZkYvaXbuRcPqRJuUMV5COAboEbsetebniC6hoxMoZM06gwKcrAsIQJH8pgB7R\nXqTe3F+DmU+Z9VhkMwvueQkQaOOo/Hihxf+XQnBS3M0Csurfhi8hckCJP1kAVgyazQ==\n\t]]>\n\t<![CDATA[\n\t4GiJDxUlhfbUGMy2OSHm6hIVXEj5dbcde5UubVDuKkDwaazr8wXvqcV7Lo++ndDDDAGr6NnzDNWp\nVPgoZ/r3E3VeWJVGDCQlnXx73gOI+9EuskMcJwaWySnzE3pRIHKdKnOU0Ey+n5trgR8u23SJ7LYO\n2Gtb9MLAk5FuriylU9dVCL0Bi1N/rs5E0ZmmuzZMCYPRKkL2mkE1eLSj1GOKHjEoEGGYsDD62jBl\nJ3dbbNr3Bntj8O2W5pAa+lwlsYRwsfU3hvNFlMbtGAtGF/yE+2QBEB5MEhnpJPIUN1vhF6X6rO3Y\nDowLtUbBXOQHuuHaQYcDaTUXzCXZxq5F848yiUNLG+qVrbr22kPfxHTYnAxAveDjkAB6iHGqoKBe\n/M9bTqlXODKC6jFrkg/qrXHIAnNPZmpwhnrH9g+obERX16D9RuqlXskThoy97cQcA7CeTs9kHZLN\nc6Be1RcyC4LpaQlf5ZpUevBgQ8fRXb1OCNiIfors0mvoO/v0GFcOblvgADa8YlLb94eYXNF36ejJ\nEYIk2hNDZCwv60efcBa/ljmjNtrex6BPW+3rfLncyFflfI5G6riZ9TgRzyCpDntJGJeVvDaWUVlE\npJ3CFmD2r8iDBSFJGVDIS58BfMSUxD1f7wnsVufpFgCKqfnyoa8HohGHJOhrxd/ltLqjRahSpLgT\nZ1orcqE+dIJ/oXiphKa2zETaitnJnYDMt4LXiLmm3yh2b2JN/YhdVnHeOVXclBYUDMFrq+Yl+qLU\naeUW23csOgRfd85fAc5Cp8m6+eEDecYmC8jU/25WUGxkxoEHFf+LwDMQGJA2A4X3/WhXUUxvDuxF\nrMcG5+A7L8DZhh+RLaTKQkht/TijCWy/UCmrKIFHMnCOe+CVvocENFft859vzLLNbYlw9QKZd/80\nJw==\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M16 22v-6h-6v-6H2v20h20v-8H16zM14 18v4h-4 0v-4H14zM4 12h4v4H4V12zM8 18v4H4v-4H8zM4 28v-4h4v4H4zM14 28h-4v-4h4V28zM20 28h-4v-4h4V28zM29.6 13.6L27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5L29.6 13.6zM24 4h4v4h-4V4z\"/></g></switch></svg>",
            "info": {},
            "path": "32/microservices--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Microservices_232",
          "filepath": "microservices--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 22v-6h-6v-6H2v20h20v-8H16zM14 18v4h-4 0v-4H14zM4 12h4v4H4V12zM8 18v4H4v-4H8zM4 28v-4h4v4H4zM14 28h-4v-4h4V28zM20 28h-4v-4h4V28zM29.6 13.6L27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5L29.6 13.6zM24 4h4v4h-4V4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Microservices_224",
          "filepath": "microservices--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 22v-6h-6v-6H2v20h20v-8H16zM14 18v4h-4 0v-4H14zM4 12h4v4H4V12zM8 18v4H4v-4H8zM4 28v-4h4v4H4zM14 28h-4v-4h4V28zM20 28h-4v-4h4V28zM29.6 13.6L27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5L29.6 13.6zM24 4h4v4h-4V4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Microservices_220",
          "filepath": "microservices--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 22v-6h-6v-6H2v20h20v-8H16zM14 18v4h-4 0v-4H14zM4 12h4v4H4V12zM8 18v4H4v-4H8zM4 28v-4h4v4H4zM14 28h-4v-4h4V28zM20 28h-4v-4h4V28zM29.6 13.6L27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5L29.6 13.6zM24 4h4v4h-4V4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Microservices_216",
          "filepath": "microservices--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 22v-6h-6v-6H2v20h20v-8H16zM14 18v4h-4 0v-4H14zM4 12h4v4H4V12zM8 18v4H4v-4H8zM4 28v-4h4v4H4zM14 28h-4v-4h4V28zM20 28h-4v-4h4V28zM29.6 13.6L27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5L29.6 13.6zM24 4h4v4h-4V4z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "microservices--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Microservices_2",
        "global": "Microservices_2",
        "filepath": "Microservices_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M16 22v-6h-6v-6H2v20h20v-8H16zM14 18v4h-4 0v-4H14zM4 12h4v4H4V12zM8 18v4H4v-4H8zM4 28v-4h4v4H4zM14 28h-4v-4h4V28zM20 28h-4v-4h4V28zM29.6 13.6L27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5L29.6 13.6zM24 4h4v4h-4V4z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "migrate",
      "friendlyName": "Migrate",
      "aliases": [
        "drift",
        "roam",
        "shift",
        "emigrate",
        "immigrate",
        "journey",
        "transfer",
        "move"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/migrate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>migrate</title><path d=\"M26,2H6A2,2,0,0,0,4,4V8a2,2,0,0,0,2,2h9v6.17l-2.59-2.58L11,15l5,5,5-5-1.41-1.41L17,16.17V10h9a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2ZM6,4h4V8H6ZM26,8H12V4H26Z\"/><path d=\"M26,22H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V24A2,2,0,0,0,26,22ZM6,24H20v4H6Zm20,4H22V24h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 002-2V4A2 2 0 0026 2zM6 4h4V8H6zM26 8H12V4H26zM26 22H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V24A2 2 0 0026 22zM6 24H20v4H6zm20 4H22V24h4z\"/></svg>",
            "info": {},
            "path": "32/migrate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Migrate32",
          "filepath": "migrate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 002-2V4A2 2 0 0026 2zM6 4h4V8H6zM26 8H12V4H26zM26 22H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V24A2 2 0 0026 22zM6 24H20v4H6zm20 4H22V24h4z"
                }
              }
            ],
            "name": "migrate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Migrate24",
          "filepath": "migrate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 002-2V4A2 2 0 0026 2zM6 4h4V8H6zM26 8H12V4H26zM26 22H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V24A2 2 0 0026 22zM6 24H20v4H6zm20 4H22V24h4z"
                }
              }
            ],
            "name": "migrate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Migrate20",
          "filepath": "migrate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 002-2V4A2 2 0 0026 2zM6 4h4V8H6zM26 8H12V4H26zM26 22H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V24A2 2 0 0026 22zM6 24H20v4H6zm20 4H22V24h4z"
                }
              }
            ],
            "name": "migrate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Migrate16",
          "filepath": "migrate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 002-2V4A2 2 0 0026 2zM6 4h4V8H6zM26 8H12V4H26zM26 22H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V24A2 2 0 0026 22zM6 24H20v4H6zm20 4H22V24h4z"
                }
              }
            ],
            "name": "migrate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Migrate",
        "global": "Migrate",
        "filepath": "Migrate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 002-2V4A2 2 0 0026 2zM6 4h4V8H6zM26 8H12V4H26zM26 22H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V24A2 2 0 0026 22zM6 24H20v4H6zm20 4H22V24h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "migrate--alt",
      "friendlyName": "Migrate alt",
      "aliases": [
        "drift",
        "roam",
        "shift",
        "emigrate",
        "immigrate",
        "journey",
        "transfer",
        "move"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/migrate--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>migrate--alt</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z\"/></svg>",
            "info": {},
            "path": "32/migrate--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MigrateAlt32",
          "filepath": "migrate--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z"
                }
              }
            ],
            "name": "migrate--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MigrateAlt24",
          "filepath": "migrate--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z"
                }
              }
            ],
            "name": "migrate--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MigrateAlt20",
          "filepath": "migrate--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z"
                }
              }
            ],
            "name": "migrate--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MigrateAlt16",
          "filepath": "migrate--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z"
                }
              }
            ],
            "name": "migrate--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "MigrateAlt",
        "global": "MigrateAlt",
        "filepath": "MigrateAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "milestone",
      "friendlyName": "Milestone",
      "aliases": [
        "marker",
        "map",
        "legend"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/milestone.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>milestone</title>\n  <path d=\"M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z\"/></svg>",
            "info": {},
            "path": "32/milestone.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Milestone32",
          "filepath": "milestone/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z"
                }
              }
            ],
            "name": "milestone",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Milestone24",
          "filepath": "milestone/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z"
                }
              }
            ],
            "name": "milestone",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Milestone20",
          "filepath": "milestone/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z"
                }
              }
            ],
            "name": "milestone",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Milestone16",
          "filepath": "milestone/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z"
                }
              }
            ],
            "name": "milestone",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Milestone",
        "global": "Milestone",
        "filepath": "Milestone.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "military-camp",
      "friendlyName": "Military camp",
      "aliases": [
        "military",
        "camp",
        "command post",
        "field operations",
        "tent"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/military-camp.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z\"/></svg>",
            "info": {},
            "path": "32/military-camp.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MilitaryCamp32",
          "filepath": "military-camp/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z"
                }
              }
            ],
            "name": "military-camp",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MilitaryCamp24",
          "filepath": "military-camp/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z"
                }
              }
            ],
            "name": "military-camp",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MilitaryCamp20",
          "filepath": "military-camp/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z"
                }
              }
            ],
            "name": "military-camp",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MilitaryCamp16",
          "filepath": "military-camp/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z"
                }
              }
            ],
            "name": "military-camp",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "MilitaryCamp",
        "global": "MilitaryCamp",
        "filepath": "MilitaryCamp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "minimize",
      "friendlyName": "Minimize",
      "aliases": [
        "close",
        "small",
        "shrink",
        "maximize"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/minimize.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.6, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>minimize</title>\n<polygon points=\"2,9 2,10 5.3,10 1,14.3 1.7,15 6,10.7 6,14 7,14 7,9 \"/>\n<polygon points=\"14,7 14,6 10.7,6 15,1.7 14.3,1 10,5.3 10,2 9,2 9,7 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M2 9L2 10 5.3 10 1 14.3 1.7 15 6 10.7 6 14 7 14 7 9zM14 7L14 6 10.7 6 15 1.7 14.3 1 10 5.3 10 2 9 2 9 7z\"/></svg>",
            "info": {},
            "path": "16/minimize.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/minimize.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 18 4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18\"/>\n  <polygon points=\"30 3.416 28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 18L4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18zM30 3.416L28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416z\"/></svg>",
            "info": {},
            "path": "32/minimize.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Minimize32",
          "filepath": "minimize/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 18L4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18zM30 3.416L28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416z"
                }
              }
            ],
            "name": "minimize",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Minimize24",
          "filepath": "minimize/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 18L4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18zM30 3.416L28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416z"
                }
              }
            ],
            "name": "minimize",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Minimize20",
          "filepath": "minimize/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 18L4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18zM30 3.416L28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416z"
                }
              }
            ],
            "name": "minimize",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Minimize16",
          "filepath": "minimize/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 9L2 10 5.3 10 1 14.3 1.7 15 6 10.7 6 14 7 14 7 9zM14 7L14 6 10.7 6 15 1.7 14.3 1 10 5.3 10 2 9 2 9 7z"
                }
              }
            ],
            "name": "minimize",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Minimize",
        "global": "Minimize",
        "filepath": "Minimize.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 9L2 10 5.3 10 1 14.3 1.7 15 6 10.7 6 14 7 14 7 9zM14 7L14 6 10.7 6 15 1.7 14.3 1 10 5.3 10 2 9 2 9 7z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 18L4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18zM30 3.416L28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "misuse",
      "friendlyName": "Misuse",
      "aliases": [
        "X",
        "close",
        "error",
        "don't"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/misuse.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\n\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2l2.7-2.7l0.8,0.8L8.8,8\n\tl2.7,2.7L10.7,11.5z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z\"/><path d=\"M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2l2.7-2.7l0.8,0.8L8.8,8\tl2.7,2.7L10.7,11.5z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "16/misuse.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/misuse.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"20\" height=\"20\"/>\n<path d=\"M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1\n\tL11,10l3.5,3.5L13.5,14.5z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1L11,10l3.5,3.5L13.5,14.5z\"\n\t/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1\tL11,10l3.5,3.5L13.5,14.5z\"/><path fill=\"none\" d=\"M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1L11,10l3.5,3.5L13.5,14.5z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "20/misuse.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/misuse.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"24\" height=\"24\"/>\n<path d=\"M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3\n\tl4.2,4.2l4.2-4.2l1.3,1.3L13.3,12l4.2,4.2L16.2,17.5z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3l4.2,4.2l4.2-4.2l1.3,1.3\n\tL13.3,12l4.2,4.2L16.2,17.5z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3\tl4.2,4.2l4.2-4.2l1.3,1.3L13.3,12l4.2,4.2L16.2,17.5z\"/><path fill=\"none\" d=\"M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3l4.2,4.2l4.2-4.2l1.3,1.3\tL13.3,12l4.2,4.2L16.2,17.5z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "24/misuse.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/misuse.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n<path d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\n\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9l5.4,5.4L21.4,9l1.6,1.6L17.6,16\n\tl5.4,5.4L21.4,23z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z\"/><path fill=\"none\" d=\"M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9l5.4,5.4L21.4,9l1.6,1.6L17.6,16\tl5.4,5.4L21.4,23z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "32/misuse.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Misuse32",
          "filepath": "misuse/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9l5.4,5.4L21.4,9l1.6,1.6L17.6,16\tl5.4,5.4L21.4,23z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "misuse",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Misuse24",
          "filepath": "misuse/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3\tl4.2,4.2l4.2-4.2l1.3,1.3L13.3,12l4.2,4.2L16.2,17.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3l4.2,4.2l4.2-4.2l1.3,1.3\tL13.3,12l4.2,4.2L16.2,17.5z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "misuse",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Misuse20",
          "filepath": "misuse/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1\tL11,10l3.5,3.5L13.5,14.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1L11,10l3.5,3.5L13.5,14.5z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "misuse",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Misuse16",
          "filepath": "misuse/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2l2.7-2.7l0.8,0.8L8.8,8\tl2.7,2.7L10.7,11.5z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "misuse",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Misuse",
        "global": "Misuse",
        "filepath": "Misuse.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2 l2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2l2.7-2.7l0.8,0.8L8.8,8 l2.7,2.7L10.7,11.5z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1 L11,10l3.5,3.5L13.5,14.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1L11,10l3.5,3.5L13.5,14.5z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3 l4.2,4.2l4.2-4.2l1.3,1.3L13.3,12l4.2,4.2L16.2,17.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3l4.2,4.2l4.2-4.2l1.3,1.3 L13.3,12l4.2,4.2L16.2,17.5z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9l5.4,5.4L21.4,9l1.6,1.6L17.6,16 l5.4,5.4L21.4,23z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "misuse--outline",
      "friendlyName": "Misuse outline",
      "aliases": [
        "X",
        "close",
        "error",
        "don't"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/misuse--outline.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>checkmark</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n<polygon points=\"10.7,11.5 8,8.8 5.3,11.5 4.5,10.7 7.2,8 4.5,5.3 5.3,4.5 8,7.2 10.7,4.5 11.5,5.3 8.8,8 11.5,10.7 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/><path d=\"M10.7 11.5L8 8.8 5.3 11.5 4.5 10.7 7.2 8 4.5 5.3 5.3 4.5 8 7.2 10.7 4.5 11.5 5.3 8.8 8 11.5 10.7z\"/></svg>",
            "info": {},
            "path": "16/misuse--outline.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/misuse--outline.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>checkmark</title>\n<path d=\"M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\n\tS22.6,28,16,28z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n<polygon points=\"21.4,23 16,17.6 10.6,23 9,21.4 14.4,16 9,10.6 10.6,9 16,14.4 21.4,9 23,10.6 17.6,16 23,21.4 \"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z\"/><path d=\"M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z\"/></svg>",
            "info": {},
            "path": "32/misuse--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MisuseOutline32",
          "filepath": "misuse--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                }
              }
            ],
            "name": "misuse--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MisuseOutline24",
          "filepath": "misuse--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                }
              }
            ],
            "name": "misuse--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MisuseOutline20",
          "filepath": "misuse--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                }
              }
            ],
            "name": "misuse--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MisuseOutline16",
          "filepath": "misuse--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7 11.5L8 8.8 5.3 11.5 4.5 10.7 7.2 8 4.5 5.3 5.3 4.5 8 7.2 10.7 4.5 11.5 5.3 8.8 8 11.5 10.7z"
                }
              }
            ],
            "name": "misuse--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "MisuseOutline",
        "global": "MisuseOutline",
        "filepath": "MisuseOutline.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.7 11.5L8 8.8 5.3 11.5 4.5 10.7 7.2 8 4.5 5.3 5.3 4.5 8 7.2 10.7 4.5 11.5 5.3 8.8 8 11.5 10.7z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mixed-rain-hail",
      "friendlyName": "Mixed rain hail",
      "aliases": [
        "mixed-rain-hail",
        "precipitation",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mixed-rain-hail.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mixed-rain-hail</title><circle cx=\"24.5\" cy=\"25.5\" r=\"1.5\"/><circle cx=\"21.5\" cy=\"29.5\" r=\"1.5\"/><polygon points=\"15.868 30.496 14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496\"/><path d=\"M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,9,32Z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"24.5\" cy=\"25.5\" r=\"1.5\"/><circle cx=\"21.5\" cy=\"29.5\" r=\"1.5\"/><path d=\"M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z\"/><path d=\"M9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0 6.4929 6.4929 0 00.23 12.7681L6.106 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.447-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20H23v2h.5A6.4974 6.4974 0 0024.8008 9.1362z\"/></svg>",
            "info": {},
            "path": "32/mixed-rain-hail.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MixedRainHail32",
          "filepath": "mixed-rain-hail/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0 6.4929 6.4929 0 00.23 12.7681L6.106 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.447-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20H23v2h.5A6.4974 6.4974 0 0024.8008 9.1362z"
                }
              }
            ],
            "name": "mixed-rain-hail",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MixedRainHail24",
          "filepath": "mixed-rain-hail/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0 6.4929 6.4929 0 00.23 12.7681L6.106 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.447-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20H23v2h.5A6.4974 6.4974 0 0024.8008 9.1362z"
                }
              }
            ],
            "name": "mixed-rain-hail",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MixedRainHail20",
          "filepath": "mixed-rain-hail/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0 6.4929 6.4929 0 00.23 12.7681L6.106 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.447-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20H23v2h.5A6.4974 6.4974 0 0024.8008 9.1362z"
                }
              }
            ],
            "name": "mixed-rain-hail",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MixedRainHail16",
          "filepath": "mixed-rain-hail/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "25.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "29.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0 6.4929 6.4929 0 00.23 12.7681L6.106 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.447-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20H23v2h.5A6.4974 6.4974 0 0024.8008 9.1362z"
                }
              }
            ],
            "name": "mixed-rain-hail",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "MixedRainHail",
        "global": "MixedRainHail",
        "filepath": "MixedRainHail.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24.5",
                    "cy": "25.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21.5",
                    "cy": "29.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0 6.4929 6.4929 0 00.23 12.7681L6.106 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.447-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20H23v2h.5A6.4974 6.4974 0 0024.8008 9.1362z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mobile",
      "friendlyName": "Mobile",
      "aliases": [
        "phone",
        "iphone",
        "responsive",
        "view port",
        "telephone",
        "roaming",
        "ux",
        "portable",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mobile.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mobile</title><path d=\"M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z\"/></svg>",
            "info": {},
            "path": "32/mobile.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Mobile32",
          "filepath": "mobile/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"
                }
              }
            ],
            "name": "mobile",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Mobile24",
          "filepath": "mobile/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"
                }
              }
            ],
            "name": "mobile",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Mobile20",
          "filepath": "mobile/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"
                }
              }
            ],
            "name": "mobile",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Mobile16",
          "filepath": "mobile/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"
                }
              }
            ],
            "name": "mobile",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Mobile",
        "global": "Mobile",
        "filepath": "Mobile.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mobile--add",
      "friendlyName": "Mobile add",
      "aliases": [
        "phone",
        "iphone",
        "responsive",
        "view port",
        "telephone",
        "roaming",
        "ux",
        "portable",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mobile--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mobile--add</title><polygon points=\"28 24 24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24\"/><path d=\"M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 24L24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z\"/><path d=\"M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z\"/></svg>",
            "info": {},
            "path": "32/mobile--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MobileAdd32",
          "filepath": "mobile--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24L24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MobileAdd24",
          "filepath": "mobile--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24L24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MobileAdd20",
          "filepath": "mobile--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24L24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MobileAdd16",
          "filepath": "mobile--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 24L24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MobileAdd",
        "global": "MobileAdd",
        "filepath": "MobileAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 24L24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mobile--audio",
      "friendlyName": "Mobile audio",
      "aliases": [
        "phone",
        "iphone",
        "responsive",
        "view port",
        "telephone",
        "roaming",
        "ux",
        "portable",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mobile--audio.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>mobile--audio</title><rect class=\"cls-1\" x=\"28\" y=\"12\" width=\"2\" height=\"3\"/><rect class=\"cls-1\" x=\"24\" y=\"7\" width=\"2\" height=\"13\"/><rect class=\"cls-1\" x=\"20\" y=\"11\" width=\"2\" height=\"5\"/><rect class=\"cls-1\" x=\"16\" y=\"9\" width=\"2\" height=\"9\"/><rect class=\"cls-1\" x=\"12\" y=\"12\" width=\"2\" height=\"3\"/><circle cx=\"13.5\" cy=\"24.5\" r=\"1.5\"/><path d=\"M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 12H30V15H28zM24 7H26V20H24zM20 11H22V16H20zM16 9H18V18H16zM12 12H14V15H12z\"/><circle cx=\"13.5\" cy=\"24.5\" r=\"1.5\"/><path d=\"M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z\"/></svg>",
            "info": {},
            "path": "32/mobile--audio.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MobileAudio32",
          "filepath": "mobile--audio/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H30V15H28zM24 7H26V20H24zM20 11H22V16H20zM16 9H18V18H16zM12 12H14V15H12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "mobile--audio",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MobileAudio24",
          "filepath": "mobile--audio/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H30V15H28zM24 7H26V20H24zM20 11H22V16H20zM16 9H18V18H16zM12 12H14V15H12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "mobile--audio",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MobileAudio20",
          "filepath": "mobile--audio/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H30V15H28zM24 7H26V20H24zM20 11H22V16H20zM16 9H18V18H16zM12 12H14V15H12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "mobile--audio",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MobileAudio16",
          "filepath": "mobile--audio/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H30V15H28zM24 7H26V20H24zM20 11H22V16H20zM16 9H18V18H16zM12 12H14V15H12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                }
              }
            ],
            "name": "mobile--audio",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MobileAudio",
        "global": "MobileAudio",
        "filepath": "MobileAudio.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 12H30V15H28zM24 7H26V20H24zM20 11H22V16H20zM16 9H18V18H16zM12 12H14V15H12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13.5",
                    "cy": "24.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mobile--check",
      "friendlyName": "Mobile check",
      "aliases": [
        "phone",
        "iphone",
        "responsive",
        "view port",
        "telephone",
        "roaming",
        "ux",
        "portable",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mobile--check.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mobile--check</title><polygon points=\"20 27.18 17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18\"/><path d=\"M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 27.18L17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z\"/><path d=\"M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z\"/></svg>",
            "info": {},
            "path": "32/mobile--check.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MobileCheck32",
          "filepath": "mobile--check/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 27.18L17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--check",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MobileCheck24",
          "filepath": "mobile--check/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 27.18L17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--check",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MobileCheck20",
          "filepath": "mobile--check/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 27.18L17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--check",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MobileCheck16",
          "filepath": "mobile--check/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 27.18L17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--check",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MobileCheck",
        "global": "MobileCheck",
        "filepath": "MobileCheck.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 27.18L17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mobile--download",
      "friendlyName": "Mobile download",
      "aliases": [
        "phone",
        "iphone",
        "responsive",
        "view port",
        "telephone",
        "roaming",
        "ux",
        "portable",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mobile--download.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mobile--download</title><polygon points=\"28 25 26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25\"/><path d=\"M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z\"/><path d=\"M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z\"/></svg>",
            "info": {},
            "path": "32/mobile--download.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MobileDownload32",
          "filepath": "mobile--download/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--download",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MobileDownload24",
          "filepath": "mobile--download/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--download",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MobileDownload20",
          "filepath": "mobile--download/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--download",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MobileDownload16",
          "filepath": "mobile--download/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
                }
              }
            ],
            "name": "mobile--download",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MobileDownload",
        "global": "MobileDownload",
        "filepath": "MobileDownload.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 25L26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mobile--landscape",
      "friendlyName": "Mobile landscape",
      "aliases": [
        "phone",
        "iphone",
        "responsive",
        "view port",
        "telephone",
        "roaming",
        "ux",
        "portable",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mobile--landscape.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mobile--landscape</title><path d=\"M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z\"/></svg>",
            "info": {},
            "path": "32/mobile--landscape.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MobileLandscape32",
          "filepath": "mobile--landscape/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
                }
              }
            ],
            "name": "mobile--landscape",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MobileLandscape24",
          "filepath": "mobile--landscape/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
                }
              }
            ],
            "name": "mobile--landscape",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MobileLandscape20",
          "filepath": "mobile--landscape/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
                }
              }
            ],
            "name": "mobile--landscape",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MobileLandscape16",
          "filepath": "mobile--landscape/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
                }
              }
            ],
            "name": "mobile--landscape",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "MobileLandscape",
        "global": "MobileLandscape",
        "filepath": "MobileLandscape.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mobility--services",
      "friendlyName": "Mobility services",
      "aliases": [
        "service",
        "mobility",
        "vehicle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mobility--services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.3379,19.9336l-7.7324-2.7783L18.374,13.0967A2.99,2.99,0,0,0,16.0537,12H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,17.2949A4.9884,4.9884,0,0,0,2,20.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V20.875A1,1,0,0,0,29.3379,19.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V20.1074A2.9977,2.9977,0,0,1,4.52,18.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,14h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,21.5781Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,2H24a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2V6H24V4Zm-4,8V8h4v4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z\"/></svg>",
            "info": {},
            "path": "32/mobility--services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MobilityServices32",
          "filepath": "mobility--services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
                }
              }
            ],
            "name": "mobility--services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MobilityServices24",
          "filepath": "mobility--services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
                }
              }
            ],
            "name": "mobility--services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MobilityServices20",
          "filepath": "mobility--services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
                }
              }
            ],
            "name": "mobility--services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MobilityServices16",
          "filepath": "mobility--services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
                }
              }
            ],
            "name": "mobility--services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "MobilityServices",
        "global": "MobilityServices",
        "filepath": "MobilityServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781zM28 2H24a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2V6H24V4zm-4 8V8h4v4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "model",
      "friendlyName": "Model",
      "aliases": [
        "reference",
        "3d",
        "prototype",
        "sketch",
        "illustrate",
        "assemble",
        "fabricate",
        "manufacture",
        "construct"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/model.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>model</title><path d=\"M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z\"/></svg>",
            "info": {},
            "path": "32/model.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Model32",
          "filepath": "model/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
                }
              }
            ],
            "name": "model",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Model24",
          "filepath": "model/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
                }
              }
            ],
            "name": "model",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Model20",
          "filepath": "model/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
                }
              }
            ],
            "name": "model",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Model16",
          "filepath": "model/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
                }
              }
            ],
            "name": "model",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Model",
        "global": "Model",
        "filepath": "Model.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "model--alt",
      "friendlyName": "Model alt",
      "aliases": [
        "model alt",
        "data",
        "prototype",
        "sketch",
        "illustrate",
        "assemble",
        "fabricate",
        "manufacture",
        "construct"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/model--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z\"/></svg>",
            "info": {},
            "path": "32/model--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ModelAlt32",
          "filepath": "model--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
                }
              }
            ],
            "name": "model--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ModelAlt24",
          "filepath": "model--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
                }
              }
            ],
            "name": "model--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ModelAlt20",
          "filepath": "model--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
                }
              }
            ],
            "name": "model--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ModelAlt16",
          "filepath": "model--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
                }
              }
            ],
            "name": "model--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ModelAlt",
        "global": "ModelAlt",
        "filepath": "ModelAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "model--reference",
      "friendlyName": "Model reference",
      "aliases": [
        "reference",
        "3d",
        "prototype",
        "sketch",
        "illustrate",
        "assemble",
        "fabricate",
        "manufacture",
        "construct"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/model--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>model--reference</title>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z\"/><path d=\"M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z\"/></svg>",
            "info": {},
            "path": "32/model--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ModelReference32",
          "filepath": "model--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
                }
              }
            ],
            "name": "model--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ModelReference24",
          "filepath": "model--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
                }
              }
            ],
            "name": "model--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ModelReference20",
          "filepath": "model--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
                }
              }
            ],
            "name": "model--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ModelReference16",
          "filepath": "model--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
                }
              }
            ],
            "name": "model--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ModelReference",
        "global": "ModelReference",
        "filepath": "ModelReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "model-builder",
      "friendlyName": "Model builder",
      "aliases": [
        "model builder",
        "analytics",
        "analysis"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/model-builder.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z\"/></svg>",
            "info": {},
            "path": "32/model-builder.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ModelBuilder32",
          "filepath": "model-builder/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
                }
              }
            ],
            "name": "model-builder",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ModelBuilder24",
          "filepath": "model-builder/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
                }
              }
            ],
            "name": "model-builder",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ModelBuilder20",
          "filepath": "model-builder/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
                }
              }
            ],
            "name": "model-builder",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ModelBuilder16",
          "filepath": "model-builder/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
                }
              }
            ],
            "name": "model-builder",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ModelBuilder",
        "global": "ModelBuilder",
        "filepath": "ModelBuilder.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "model-builder--reference",
      "friendlyName": "Model builder reference",
      "aliases": [
        "model builder reference",
        "analytics",
        "analysis",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/model-builder--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z\"/><path d=\"M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z\"/></svg>",
            "info": {},
            "path": "32/model-builder--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ModelBuilderReference32",
          "filepath": "model-builder--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
                }
              }
            ],
            "name": "model-builder--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ModelBuilderReference24",
          "filepath": "model-builder--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
                }
              }
            ],
            "name": "model-builder--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ModelBuilderReference20",
          "filepath": "model-builder--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
                }
              }
            ],
            "name": "model-builder--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ModelBuilderReference16",
          "filepath": "model-builder--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
                }
              }
            ],
            "name": "model-builder--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ModelBuilderReference",
        "global": "ModelBuilderReference",
        "filepath": "ModelBuilderReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "money",
      "friendlyName": "Money",
      "aliases": [
        "money",
        "currency",
        "cash"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/money.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>money</title><rect x=\"2\" y=\"22\" width=\"28\" height=\"2\"/><rect x=\"2\" y=\"26\" width=\"28\" height=\"2\"/><path d=\"M24,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z\"/><path d=\"M16,16a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,16Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,10Z\"/><path d=\"M8,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z\"/><path d=\"M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z\"/><path d=\"M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z\"/></svg>",
            "info": {},
            "path": "32/money.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Money32",
          "filepath": "money/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
                }
              }
            ],
            "name": "money",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Money24",
          "filepath": "money/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
                }
              }
            ],
            "name": "money",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Money20",
          "filepath": "money/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
                }
              }
            ],
            "name": "money",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Money16",
          "filepath": "money/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
                }
              }
            ],
            "name": "money",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Money",
        "global": "Money",
        "filepath": "Money.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 22H30V24H2zM2 26H30V28H2zM24 10a2 2 0 102 2 2 2 0 00-2-2zM16 16a4 4 0 114-4A4.0045 4.0045 0 0116 16zm0-6a2 2 0 102 2A2.002 2.002 0 0016 10zM8 10a2 2 0 102 2 2 2 0 00-2-2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "monster",
      "friendlyName": "Monster",
      "aliases": [
        "monster",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/monster.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"23 22 21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22\"/>\n  <path d=\"M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"9\" y=\"14\" width=\"5\" height=\"2\"/>\n  <rect x=\"18\" y=\"14\" width=\"5\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z\"/><path d=\"M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z\"/><path d=\"M9 14H14V16H9zM18 14H23V16H18z\"/></svg>",
            "info": {},
            "path": "32/monster.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Monster32",
          "filepath": "monster/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 14H14V16H9zM18 14H23V16H18z"
                }
              }
            ],
            "name": "monster",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Monster24",
          "filepath": "monster/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 14H14V16H9zM18 14H23V16H18z"
                }
              }
            ],
            "name": "monster",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Monster20",
          "filepath": "monster/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 14H14V16H9zM18 14H23V16H18z"
                }
              }
            ],
            "name": "monster",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Monster16",
          "filepath": "monster/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 14H14V16H9zM18 14H23V16H18z"
                }
              }
            ],
            "name": "monster",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Monster",
        "global": "Monster",
        "filepath": "Monster.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 22L21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 14H14V16H9zM18 14H23V16H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "monument",
      "friendlyName": "Monument",
      "aliases": [
        "marker",
        "legend",
        "memorial"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/monument.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>monument</title>\n  <path d=\"M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z\"/></svg>",
            "info": {},
            "path": "32/monument.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Monument32",
          "filepath": "monument/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
                }
              }
            ],
            "name": "monument",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Monument24",
          "filepath": "monument/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
                }
              }
            ],
            "name": "monument",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Monument20",
          "filepath": "monument/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
                }
              }
            ],
            "name": "monument",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Monument16",
          "filepath": "monument/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
                }
              }
            ],
            "name": "monument",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Monument",
        "global": "Monument",
        "filepath": "Monument.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "moon",
      "friendlyName": "Moon",
      "aliases": [
        "moon",
        "cresent",
        "phase"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/moon.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>asleep</title><path d=\"M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z\"/></svg>",
            "info": {},
            "path": "32/moon.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Moon32",
          "filepath": "moon/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "moon",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Moon24",
          "filepath": "moon/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "moon",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Moon20",
          "filepath": "moon/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "moon",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Moon16",
          "filepath": "moon/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                }
              }
            ],
            "name": "moon",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Moon",
        "global": "Moon",
        "filepath": "Moon.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "moonrise",
      "friendlyName": "Moonrise",
      "aliases": [
        "moonrise",
        "phase"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/moonrise.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/>\n  <path d=\"M26,26H24a7.987,7.987,0,0,0-2.0371-5.3335l1.49-1.334A9.9835,9.9835,0,0,1,26,26Z\"/>\n  <path d=\"M16,26H14a9.9268,9.9268,0,0,1,3.7539-7.804A7.89,7.89,0,0,0,16,18a8.0092,8.0092,0,0,0-8,8H6A10.0113,10.0113,0,0,1,16,16a9.8923,9.8923,0,0,1,4.4458,1.0515,1,1,0,0,1,0,1.79A7.9567,7.9567,0,0,0,16,26Z\"/>\n  <polygon points=\"16 2 11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z\"/></svg>",
            "info": {},
            "path": "32/moonrise.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Moonrise32",
          "filepath": "moonrise/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
                }
              }
            ],
            "name": "moonrise",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Moonrise24",
          "filepath": "moonrise/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
                }
              }
            ],
            "name": "moonrise",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Moonrise20",
          "filepath": "moonrise/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
                }
              }
            ],
            "name": "moonrise",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Moonrise16",
          "filepath": "moonrise/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
                }
              }
            ],
            "name": "moonrise",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Moonrise",
        "global": "Moonrise",
        "filepath": "Moonrise.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 2L11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "moonset",
      "friendlyName": "moonset",
      "aliases": [
        "moonset",
        "phase"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/moonset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/>\n  <path d=\"M26,26H24a7.987,7.987,0,0,0-2.0371-5.3335l1.49-1.334A9.9835,9.9835,0,0,1,26,26Z\"/>\n  <path d=\"M16,26H14a9.9268,9.9268,0,0,1,3.7539-7.804A7.89,7.89,0,0,0,16,18a8.0092,8.0092,0,0,0-8,8H6A10.0113,10.0113,0,0,1,16,16a9.8923,9.8923,0,0,1,4.4458,1.0515,1,1,0,0,1,0,1.79A7.9567,7.9567,0,0,0,16,26Z\"/>\n  <polygon points=\"16 14 11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z\"/></svg>",
            "info": {},
            "path": "32/moonset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Moonset32",
          "filepath": "moonset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
                }
              }
            ],
            "name": "moonset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Moonset24",
          "filepath": "moonset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
                }
              }
            ],
            "name": "moonset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Moonset20",
          "filepath": "moonset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
                }
              }
            ],
            "name": "moonset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Moonset16",
          "filepath": "moonset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
                }
              }
            ],
            "name": "moonset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Moonset",
        "global": "Moonset",
        "filepath": "Moonset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM26 26H24a7.987 7.987 0 00-2.0371-5.3335l1.49-1.334A9.9835 9.9835 0 0126 26zM16 26H14a9.9268 9.9268 0 013.7539-7.804A7.89 7.89 0 0016 18a8.0092 8.0092 0 00-8 8H6A10.0113 10.0113 0 0116 16a9.8923 9.8923 0 014.4458 1.0515 1 1 0 010 1.79A7.9567 7.9567 0 0016 26zM16 14L11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mostly-cloudy",
      "friendlyName": "Mostly cloudy",
      "aliases": [
        "mostly-cloudy",
        "sky",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mostly-cloudy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>partly-cloudy</title><path d=\"M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z\" transform=\"translate(0 0.0049)\"/><rect x=\"26\" y=\"13.0049\" width=\"4\" height=\"2\"/><rect x=\"23.0713\" y=\"5.9291\" width=\"3.9999\" height=\"1.9998\" transform=\"translate(2.4437 19.7624) rotate(-45)\"/><rect x=\"17\" y=\"2.0049\" width=\"2\" height=\"4\"/><rect x=\"9.9291\" y=\"4.9288\" width=\"1.9998\" height=\"4.0003\" transform=\"translate(-1.6985 9.7623) rotate(-45)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z\" transform=\"translate(0 .005)\"/><path d=\"M26 13.005H30V15.005H26z\"/><path d=\"M23.071 5.929H27.071V7.929H23.071z\" transform=\"rotate(-45 25.077 6.931)\"/><path d=\"M17 2.005H19V6.005H17z\"/><path d=\"M9.929 4.929H11.929V8.929H9.929z\" transform=\"rotate(-45 10.935 6.931)\"/></svg>",
            "info": {},
            "path": "32/mostly-cloudy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MostlyCloudy32",
          "filepath": "mostly-cloudy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13.005H30V15.005H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.071 5.929H27.071V7.929H23.071z",
                  "transform": "rotate(-45 25.077 6.931)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2.005H19V6.005H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.929 4.929H11.929V8.929H9.929z",
                  "transform": "rotate(-45 10.935 6.931)"
                }
              }
            ],
            "name": "mostly-cloudy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MostlyCloudy24",
          "filepath": "mostly-cloudy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13.005H30V15.005H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.071 5.929H27.071V7.929H23.071z",
                  "transform": "rotate(-45 25.077 6.931)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2.005H19V6.005H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.929 4.929H11.929V8.929H9.929z",
                  "transform": "rotate(-45 10.935 6.931)"
                }
              }
            ],
            "name": "mostly-cloudy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MostlyCloudy20",
          "filepath": "mostly-cloudy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13.005H30V15.005H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.071 5.929H27.071V7.929H23.071z",
                  "transform": "rotate(-45 25.077 6.931)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2.005H19V6.005H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.929 4.929H11.929V8.929H9.929z",
                  "transform": "rotate(-45 10.935 6.931)"
                }
              }
            ],
            "name": "mostly-cloudy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MostlyCloudy16",
          "filepath": "mostly-cloudy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13.005H30V15.005H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.071 5.929H27.071V7.929H23.071z",
                  "transform": "rotate(-45 25.077 6.931)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2.005H19V6.005H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.929 4.929H11.929V8.929H9.929z",
                  "transform": "rotate(-45 10.935 6.931)"
                }
              }
            ],
            "name": "mostly-cloudy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "MostlyCloudy",
        "global": "MostlyCloudy",
        "filepath": "MostlyCloudy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
                    "transform": "translate(0 .005)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 13.005H30V15.005H26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.071 5.929H27.071V7.929H23.071z",
                    "transform": "rotate(-45 25.077 6.931)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 2.005H19V6.005H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.929 4.929H11.929V8.929H9.929z",
                    "transform": "rotate(-45 10.935 6.931)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mostly-cloudy--night",
      "friendlyName": "Mostly cloudy night",
      "aliases": [
        "mostly-cloudy",
        "night",
        "sky",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mostly-cloudy--night.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>mostly-cloudy--night</title><path d=\"M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z\"/></svg>",
            "info": {},
            "path": "32/mostly-cloudy--night.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MostlyCloudyNight32",
          "filepath": "mostly-cloudy--night/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
                }
              }
            ],
            "name": "mostly-cloudy--night",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MostlyCloudyNight24",
          "filepath": "mostly-cloudy--night/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
                }
              }
            ],
            "name": "mostly-cloudy--night",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MostlyCloudyNight20",
          "filepath": "mostly-cloudy--night/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
                }
              }
            ],
            "name": "mostly-cloudy--night",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MostlyCloudyNight16",
          "filepath": "mostly-cloudy--night/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
                }
              }
            ],
            "name": "mostly-cloudy--night",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "MostlyCloudyNight",
        "global": "MostlyCloudyNight",
        "filepath": "MostlyCloudyNight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "mountain",
      "friendlyName": "Mountain",
      "aliases": [
        "mountain",
        "topography",
        "peak",
        "summit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/mountain.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>mountain</title>\n  <path d=\"M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z\"/></svg>",
            "info": {},
            "path": "32/mountain.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Mountain32",
          "filepath": "mountain/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
                }
              }
            ],
            "name": "mountain",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Mountain24",
          "filepath": "mountain/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
                }
              }
            ],
            "name": "mountain",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Mountain20",
          "filepath": "mountain/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
                }
              }
            ],
            "name": "mountain",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Mountain16",
          "filepath": "mountain/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
                }
              }
            ],
            "name": "mountain",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Mountain",
        "global": "Mountain",
        "filepath": "Mountain.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "MOV",
      "friendlyName": "MOV",
      "aliases": [
        "movie",
        "video",
        "file",
        "type",
        "film",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/MOV.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>MOV</title><polygon points=\"28 9 26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9\"/><path d=\"M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11V21h4V11Z\"/><polygon points=\"8 9 6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z\"/></svg>",
            "info": {},
            "path": "32/MOV.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Mov32",
          "filepath": "MOV/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MOV",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Mov24",
          "filepath": "MOV/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MOV",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Mov20",
          "filepath": "MOV/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MOV",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Mov16",
          "filepath": "MOV/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MOV",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Mov",
        "global": "Mov",
        "filepath": "Mov.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9L26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9zM18 23H14a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0118 23zM14 11V21h4V11zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "move",
      "friendlyName": "Move",
      "aliases": [
        "action",
        "transfer",
        "direction",
        "directional",
        "shift",
        "maneuver"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/move.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>move</title><polygon points=\"25 11 23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z\"/></svg>",
            "info": {},
            "path": "32/move.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Move32",
          "filepath": "move/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "move",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Move24",
          "filepath": "move/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "move",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Move20",
          "filepath": "move/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "move",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Move16",
          "filepath": "move/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                }
              }
            ],
            "name": "move",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Move",
        "global": "Move",
        "filepath": "Move.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 11L23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "movement",
      "friendlyName": "Movement",
      "aliases": [
        "action",
        "transfer",
        "direction",
        "directional",
        "shift",
        "maneuver"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/movement.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>movement</title><path d=\"M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z\"/></svg>",
            "info": {},
            "path": "32/movement.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Movement32",
          "filepath": "movement/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
                }
              }
            ],
            "name": "movement",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Movement24",
          "filepath": "movement/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
                }
              }
            ],
            "name": "movement",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Movement20",
          "filepath": "movement/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
                }
              }
            ],
            "name": "movement",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Movement16",
          "filepath": "movement/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
                }
              }
            ],
            "name": "movement",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Movement",
        "global": "Movement",
        "filepath": "Movement.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "MP3",
      "friendlyName": "MP3",
      "aliases": [
        "music",
        "audio",
        "song",
        "compress",
        "file",
        "type",
        "compression"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/MP3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>MP3</title><path d=\"M28,9H22v2h6v4H24v2h4v4H22v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9Z\"/><path d=\"M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z\"/><polygon points=\"8 9 6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z\"/></svg>",
            "info": {},
            "path": "32/MP3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Mp332",
          "filepath": "MP3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Mp324",
          "filepath": "MP3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Mp320",
          "filepath": "MP3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Mp316",
          "filepath": "MP3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Mp3",
        "global": "Mp3",
        "filepath": "Mp3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "MP4",
      "friendlyName": "MP4",
      "aliases": [
        "movie",
        "video",
        "file",
        "type",
        "film",
        "format",
        "compression"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/MP4.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#fff;}.cls-2{fill:none;}</style></defs><title>MP4</title><path d=\"M28,10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9Z\"/><path d=\"M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z\"/><polygon points=\"8 9 6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z\"/></svg>",
            "info": {},
            "path": "32/MP4.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Mp432",
          "filepath": "MP4/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP4",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Mp424",
          "filepath": "MP4/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP4",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Mp420",
          "filepath": "MP4/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP4",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Mp416",
          "filepath": "MP4/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                }
              }
            ],
            "name": "MP4",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Mp4",
        "global": "Mp4",
        "filepath": "Mp4.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "MPEG",
      "friendlyName": "MPEG",
      "aliases": [
        "MPEG",
        "movie",
        "video",
        "file",
        "type",
        "film",
        "format",
        "compression"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/MPEG.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>MPEG</title><path d=\"M32,21H28a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h4v2H28v6h2V17H29l0-2h3Z\"/><polygon points=\"24 13 24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13\"/><path d=\"M14,11H9V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,14,11Zm-3,5V13h3l.001,3Z\"/><polygon points=\"7 11 5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z\"/></svg>",
            "info": {},
            "path": "32/MPEG.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Mpeg32",
          "filepath": "MPEG/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPEG",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Mpeg24",
          "filepath": "MPEG/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPEG",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Mpeg20",
          "filepath": "MPEG/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPEG",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Mpeg16",
          "filepath": "MPEG/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPEG",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Mpeg",
        "global": "Mpeg",
        "filepath": "Mpeg.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "MPG2",
      "friendlyName": "MPG2",
      "aliases": [
        "MPG2",
        "movie",
        "video",
        "file",
        "type",
        "film",
        "format",
        "compression"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/MPG2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>MPG2</title><path d=\"M32,21H26V17a2.002,2.002,0,0,1,2-2h2V13H26V11h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H28v2h4Z\"/><path d=\"M24,21H20a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h4v2H20v6h2V17H21l0-2h3Z\"/><path d=\"M14,11H9V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,14,11Zm-3,5V13h3l.001,3Z\"/><polygon points=\"7 11 5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z\"/></svg>",
            "info": {},
            "path": "32/MPG2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Mpg232",
          "filepath": "MPG2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPG2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Mpg224",
          "filepath": "MPG2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPG2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Mpg220",
          "filepath": "MPG2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPG2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Mpg216",
          "filepath": "MPG2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                }
              }
            ],
            "name": "MPG2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Mpg2",
        "global": "Mpg2",
        "filepath": "Mpg2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "music",
      "friendlyName": "Music",
      "aliases": [
        "audio",
        "melody",
        "sound",
        "singing",
        "harmony",
        "beat",
        "rhythm"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/music.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>music</title><path d=\"M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z\"/></svg>",
            "info": {},
            "path": "32/music.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Music32",
          "filepath": "music/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
                }
              }
            ],
            "name": "music",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Music24",
          "filepath": "music/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
                }
              }
            ],
            "name": "music",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Music20",
          "filepath": "music/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
                }
              }
            ],
            "name": "music",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Music16",
          "filepath": "music/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
                }
              }
            ],
            "name": "music",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Music",
        "global": "Music",
        "filepath": "Music.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "music--add",
      "friendlyName": "Music add",
      "aliases": [
        "music add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/music--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 6 26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6\"/>\n  <path d=\"M24,15v7.5562A3.9552,3.9552,0,0,0,22,22a4,4,0,1,0,4,4V15ZM22,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,22,28Z\"/>\n  <path d=\"M17,6H10A2.002,2.002,0,0,0,8,8V22.5562A3.9557,3.9557,0,0,0,6,22a4,4,0,1,0,4,4V8h7ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z\"/></svg>",
            "info": {},
            "path": "32/music--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MusicAdd32",
          "filepath": "music--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MusicAdd24",
          "filepath": "music--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MusicAdd20",
          "filepath": "music--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MusicAdd16",
          "filepath": "music--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "MusicAdd",
        "global": "MusicAdd",
        "filepath": "MusicAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "music--remove",
      "friendlyName": "Music remove",
      "aliases": [
        "music remove"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/music--remove.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26.41 7 30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7\"/>\n  <path d=\"M24,15v7.5562A3.9552,3.9552,0,0,0,22,22a4,4,0,1,0,4,4V15ZM22,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,22,28Z\"/>\n  <path d=\"M17,6H10A2.002,2.002,0,0,0,8,8V22.5562A3.9557,3.9557,0,0,0,6,22a4,4,0,1,0,4,4V8h7ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z\"/></svg>",
            "info": {},
            "path": "32/music--remove.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "MusicRemove32",
          "filepath": "music--remove/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--remove",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "MusicRemove24",
          "filepath": "music--remove/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--remove",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "MusicRemove20",
          "filepath": "music--remove/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--remove",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "MusicRemove16",
          "filepath": "music--remove/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "music--remove",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "MusicRemove",
        "global": "MusicRemove",
        "filepath": "MusicRemove.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "name-space",
      "friendlyName": "Name space",
      "aliases": [
        "name",
        "space",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/name-space.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M7,12H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4H7V6H4v4H7Z\"/>\n  <rect x=\"9\" y=\"10\" width=\"6\" height=\"2\"/>\n  <rect x=\"17\" y=\"10\" width=\"6\" height=\"2\"/>\n  <path d=\"M28,12H25V10h3V6H25V4h3a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,12Z\"/>\n  <rect x=\"17\" y=\"4\" width=\"6\" height=\"2\"/>\n  <rect x=\"9\" y=\"4\" width=\"6\" height=\"2\"/>\n  <path d=\"M28,28H4a2.0023,2.0023,0,0,1-2-2V22a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,28ZM4,22v4H28V22Z\"/>\n  <rect x=\"2\" y=\"15\" width=\"28\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z\"/></svg>",
            "info": {},
            "path": "32/name-space.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NameSpace32",
          "filepath": "name-space/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
                }
              }
            ],
            "name": "name-space",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NameSpace24",
          "filepath": "name-space/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
                }
              }
            ],
            "name": "name-space",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NameSpace20",
          "filepath": "name-space/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
                }
              }
            ],
            "name": "name-space",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NameSpace16",
          "filepath": "name-space/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
                }
              }
            ],
            "name": "name-space",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "NameSpace",
        "global": "NameSpace",
        "filepath": "NameSpace.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--civil",
      "friendlyName": "Navaid civil",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "civil"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--civil.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/></svg>",
            "info": {},
            "path": "32/navaid--civil.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidCivil32",
          "filepath": "navaid--civil/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--civil",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidCivil24",
          "filepath": "navaid--civil/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--civil",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidCivil20",
          "filepath": "navaid--civil/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--civil",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidCivil16",
          "filepath": "navaid--civil/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--civil",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidCivil",
        "global": "NavaidCivil",
        "filepath": "NavaidCivil.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--dme",
      "friendlyName": "Navaid dme",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "dme"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--dme.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #171717;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z\"/><path d=\"M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z\"/><path d=\"M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z\"/></svg>",
            "info": {},
            "path": "32/navaid--dme.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidDme32",
          "filepath": "navaid--dme/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "navaid--dme",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidDme24",
          "filepath": "navaid--dme/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "navaid--dme",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidDme20",
          "filepath": "navaid--dme/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "navaid--dme",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidDme16",
          "filepath": "navaid--dme/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                }
              }
            ],
            "name": "navaid--dme",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidDme",
        "global": "NavaidDme",
        "filepath": "NavaidDme.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--helipad",
      "friendlyName": "Navaid helipad",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "helipad"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--helipad.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"18 9 18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/navaid--helipad.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidHelipad32",
          "filepath": "navaid--helipad/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--helipad",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidHelipad24",
          "filepath": "navaid--helipad/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--helipad",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidHelipad20",
          "filepath": "navaid--helipad/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--helipad",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidHelipad16",
          "filepath": "navaid--helipad/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--helipad",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidHelipad",
        "global": "NavaidHelipad",
        "filepath": "NavaidHelipad.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--military",
      "friendlyName": "Navaid military",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "military"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--military.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/><path d=\"M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/navaid--military.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidMilitary32",
          "filepath": "navaid--military/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--military",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidMilitary24",
          "filepath": "navaid--military/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--military",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidMilitary20",
          "filepath": "navaid--military/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--military",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidMilitary16",
          "filepath": "navaid--military/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--military",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidMilitary",
        "global": "NavaidMilitary",
        "filepath": "NavaidMilitary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--military-civil",
      "friendlyName": "Navaid military civil",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "military",
        "civil"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--military-civil.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z\"/><path d=\"M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/></svg>",
            "info": {},
            "path": "32/navaid--military-civil.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidMilitaryCivil32",
          "filepath": "navaid--military-civil/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--military-civil",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidMilitaryCivil24",
          "filepath": "navaid--military-civil/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--military-civil",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidMilitaryCivil20",
          "filepath": "navaid--military-civil/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--military-civil",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidMilitaryCivil16",
          "filepath": "navaid--military-civil/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--military-civil",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidMilitaryCivil",
        "global": "NavaidMilitaryCivil",
        "filepath": "NavaidMilitaryCivil.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--ndb",
      "friendlyName": "Navaid ndb",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "ndb"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--ndb.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <circle cx=\"16\" cy=\"4\" r=\"2\"/>\n  <circle cx=\"16\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"28\" cy=\"16\" r=\"2\"/>\n  <circle cx=\"4\" cy=\"16\" r=\"2\"/>\n  <circle cx=\"7.5147\" cy=\"7.5147\" r=\"2\"/>\n  <circle cx=\"24.4853\" cy=\"24.4853\" r=\"2\"/>\n  <circle cx=\"24.4853\" cy=\"7.5147\" r=\"2\"/>\n  <circle cx=\"7.5147\" cy=\"24.4853\" r=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><circle cx=\"16\" cy=\"4\" r=\"2\"/><circle cx=\"16\" cy=\"28\" r=\"2\"/><circle cx=\"28\" cy=\"16\" r=\"2\"/><circle cx=\"4\" cy=\"16\" r=\"2\"/><circle cx=\"7.515\" cy=\"7.515\" r=\"2\"/><circle cx=\"24.485\" cy=\"24.485\" r=\"2\"/><circle cx=\"24.485\" cy=\"7.515\" r=\"2\"/><circle cx=\"7.515\" cy=\"24.485\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/navaid--ndb.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidNdb32",
          "filepath": "navaid--ndb/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "24.485",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "24.485",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--ndb",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidNdb24",
          "filepath": "navaid--ndb/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "24.485",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "24.485",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--ndb",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidNdb20",
          "filepath": "navaid--ndb/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "24.485",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "24.485",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--ndb",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidNdb16",
          "filepath": "navaid--ndb/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "24.485",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.485",
                  "cy": "7.515",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.515",
                  "cy": "24.485",
                  "r": "2"
                }
              }
            ],
            "name": "navaid--ndb",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidNdb",
        "global": "NavaidNdb",
        "filepath": "NavaidNdb.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "4",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7.515",
                    "cy": "7.515",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24.485",
                    "cy": "24.485",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24.485",
                    "cy": "7.515",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7.515",
                    "cy": "24.485",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--ndb-dme",
      "friendlyName": "Navaid ndb dme",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "ndb",
        "dme"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--ndb-dme.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #171717;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M4,12H2V4A2.0021,2.0021,0,0,1,4,2h8V4H4Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M12,30H4a2.0021,2.0021,0,0,1-2-2V20H4v8h8Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M28,30H20V28h8V20h2v8A2.0021,2.0021,0,0,1,28,30Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M30,12H28V4H20V2h8a2.0021,2.0021,0,0,1,2,2Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <circle cx=\"16\" cy=\"7\" r=\"1\"/>\n  <circle cx=\"16\" cy=\"3\" r=\"1\"/>\n  <circle cx=\"16\" cy=\"25\" r=\"1\"/>\n  <circle cx=\"16\" cy=\"29\" r=\"1\"/>\n  <circle cx=\"25\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"29\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"3\" cy=\"16\" r=\"1\"/>\n  <circle cx=\"9.636\" cy=\"9.636\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"7\" r=\"1\"/>\n  <circle cx=\"22.364\" cy=\"22.364\" r=\"1\"/>\n  <circle cx=\"25\" cy=\"25\" r=\"1\"/>\n  <circle cx=\"22.364\" cy=\"9.636\" r=\"1\"/>\n  <circle cx=\"25\" cy=\"7\" r=\"1\"/>\n  <circle cx=\"9.636\" cy=\"22.364\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><circle cx=\"16\" cy=\"7\" r=\"1\"/><circle cx=\"16\" cy=\"3\" r=\"1\"/><circle cx=\"16\" cy=\"25\" r=\"1\"/><circle cx=\"16\" cy=\"29\" r=\"1\"/><circle cx=\"25\" cy=\"16\" r=\"1\"/><circle cx=\"29\" cy=\"16\" r=\"1\"/><circle cx=\"7\" cy=\"16\" r=\"1\"/><circle cx=\"3\" cy=\"16\" r=\"1\"/><circle cx=\"9.636\" cy=\"9.636\" r=\"1\"/><circle cx=\"7\" cy=\"7\" r=\"1\"/><circle cx=\"22.364\" cy=\"22.364\" r=\"1\"/><circle cx=\"25\" cy=\"25\" r=\"1\"/><circle cx=\"22.364\" cy=\"9.636\" r=\"1\"/><circle cx=\"25\" cy=\"7\" r=\"1\"/><circle cx=\"9.636\" cy=\"22.364\" r=\"1\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/navaid--ndb-dme.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidNdbDme32",
          "filepath": "navaid--ndb-dme/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "navaid--ndb-dme",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidNdbDme24",
          "filepath": "navaid--ndb-dme/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "navaid--ndb-dme",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidNdbDme20",
          "filepath": "navaid--ndb-dme/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "navaid--ndb-dme",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidNdbDme16",
          "filepath": "navaid--ndb-dme/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "3",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "29",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "29",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "16",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.364",
                  "cy": "9.636",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "25",
                  "cy": "7",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.636",
                  "cy": "22.364",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "navaid--ndb-dme",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidNdbDme",
        "global": "NavaidNdbDme",
        "filepath": "NavaidNdbDme.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "3",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "29",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "29",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "16",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9.636",
                    "cy": "9.636",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22.364",
                    "cy": "22.364",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22.364",
                    "cy": "9.636",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "25",
                    "cy": "7",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9.636",
                    "cy": "22.364",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--private",
      "friendlyName": "Navaid private",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "private"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--private.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/navaid--private.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidPrivate32",
          "filepath": "navaid--private/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--private",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidPrivate24",
          "filepath": "navaid--private/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--private",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidPrivate20",
          "filepath": "navaid--private/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--private",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidPrivate16",
          "filepath": "navaid--private/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "navaid--private",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidPrivate",
        "global": "NavaidPrivate",
        "filepath": "NavaidPrivate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--seaplane",
      "friendlyName": "Navaid seaplane",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "seaplane"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--seaplane.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z\"/><path d=\"M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/></svg>",
            "info": {},
            "path": "32/navaid--seaplane.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidSeaplane32",
          "filepath": "navaid--seaplane/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--seaplane",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidSeaplane24",
          "filepath": "navaid--seaplane/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--seaplane",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidSeaplane20",
          "filepath": "navaid--seaplane/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--seaplane",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidSeaplane16",
          "filepath": "navaid--seaplane/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "navaid--seaplane",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidSeaplane",
        "global": "NavaidSeaplane",
        "filepath": "NavaidSeaplane.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--tacan",
      "friendlyName": "Navaid tacan",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "tacan"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--tacan.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"14\" r=\"2\"/>\n  <path d=\"M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"14\" r=\"2\"/><path d=\"M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z\"/></svg>",
            "info": {},
            "path": "32/navaid--tacan.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidTacan32",
          "filepath": "navaid--tacan/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
                }
              }
            ],
            "name": "navaid--tacan",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidTacan24",
          "filepath": "navaid--tacan/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
                }
              }
            ],
            "name": "navaid--tacan",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidTacan20",
          "filepath": "navaid--tacan/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
                }
              }
            ],
            "name": "navaid--tacan",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidTacan16",
          "filepath": "navaid--tacan/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
                }
              }
            ],
            "name": "navaid--tacan",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidTacan",
        "global": "NavaidTacan",
        "filepath": "NavaidTacan.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--vhfor",
      "friendlyName": "Navaid vhfor",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "vhfor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--vhfor.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #171717;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z\"/><path d=\"M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z\"/></svg>",
            "info": {},
            "path": "32/navaid--vhfor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidVhfor32",
          "filepath": "navaid--vhfor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
                }
              }
            ],
            "name": "navaid--vhfor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidVhfor24",
          "filepath": "navaid--vhfor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
                }
              }
            ],
            "name": "navaid--vhfor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidVhfor20",
          "filepath": "navaid--vhfor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
                }
              }
            ],
            "name": "navaid--vhfor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidVhfor16",
          "filepath": "navaid--vhfor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
                }
              }
            ],
            "name": "navaid--vhfor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidVhfor",
        "global": "NavaidVhfor",
        "filepath": "NavaidVhfor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--vor",
      "friendlyName": "Navaid vor",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "vor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--vor.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #171717;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <path class=\"cls-1\" d=\"M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z\"/></svg>",
            "info": {},
            "path": "32/navaid--vor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidVor32",
          "filepath": "navaid--vor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
                }
              }
            ],
            "name": "navaid--vor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidVor24",
          "filepath": "navaid--vor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
                }
              }
            ],
            "name": "navaid--vor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidVor20",
          "filepath": "navaid--vor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
                }
              }
            ],
            "name": "navaid--vor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidVor16",
          "filepath": "navaid--vor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
                }
              }
            ],
            "name": "navaid--vor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidVor",
        "global": "NavaidVor",
        "filepath": "NavaidVor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--vordme",
      "friendlyName": "Navaid vordme",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "vordme"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--vordme.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #171717;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <path class=\"cls-1\" d=\"M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z\"/></svg>",
            "info": {},
            "path": "32/navaid--vordme.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidVordme32",
          "filepath": "navaid--vordme/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
                }
              }
            ],
            "name": "navaid--vordme",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidVordme24",
          "filepath": "navaid--vordme/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
                }
              }
            ],
            "name": "navaid--vordme",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidVordme20",
          "filepath": "navaid--vordme/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
                }
              }
            ],
            "name": "navaid--vordme",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidVordme16",
          "filepath": "navaid--vordme/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
                }
              }
            ],
            "name": "navaid--vordme",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidVordme",
        "global": "NavaidVordme",
        "filepath": "NavaidVordme.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "navaid--vortac",
      "friendlyName": "Navaid vortac",
      "aliases": [
        "travel",
        "navigation",
        "navaid",
        "vortac"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/navaid--vortac.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"14\" r=\"2\"/>\n  <path d=\"M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"14\" r=\"2\"/><path d=\"M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z\"/></svg>",
            "info": {},
            "path": "32/navaid--vortac.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NavaidVortac32",
          "filepath": "navaid--vortac/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
                }
              }
            ],
            "name": "navaid--vortac",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NavaidVortac24",
          "filepath": "navaid--vortac/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
                }
              }
            ],
            "name": "navaid--vortac",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NavaidVortac20",
          "filepath": "navaid--vortac/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
                }
              }
            ],
            "name": "navaid--vortac",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NavaidVortac16",
          "filepath": "navaid--vortac/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
                }
              }
            ],
            "name": "navaid--vortac",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "NavaidVortac",
        "global": "NavaidVortac",
        "filepath": "NavaidVortac.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "need",
      "friendlyName": "need",
      "aliases": [
        "need",
        "charity",
        "charitable",
        "contribution",
        "donation",
        "donate",
        "collect",
        "hand"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/need.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.1211,16.8789A2.98,2.98,0,0,0,27.01,16H27a2.9774,2.9774,0,0,0-2.1211.8789L19.9778,21.78A2.9943,2.9943,0,0,0,17,19H10a5.0059,5.0059,0,0,0-5,5v.667L2,28.6631l1.6,1.2L7,25.333V24a3.0033,3.0033,0,0,1,3-3h7a1,1,0,0,1,0,2H13v2h4.9287a3.9717,3.9717,0,0,0,2.8286-1.1719L26.293,18.293A.9929.9929,0,0,1,27,18h.0034a1,1,0,0,1,.7036,1.707l-7.414,7.4141A2.9791,2.9791,0,0,1,18.1714,28H11v2h7.1714a4.9665,4.9665,0,0,0,3.5356-1.4648l7.4141-7.4141a2.9989,2.9989,0,0,0,0-4.2422Z\"/>\n  <polygon points=\"21.586 8.586 18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z\"/></svg>",
            "info": {},
            "path": "32/need.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Need32",
          "filepath": "need/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
                }
              }
            ],
            "name": "need",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Need24",
          "filepath": "need/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
                }
              }
            ],
            "name": "need",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Need20",
          "filepath": "need/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
                }
              }
            ],
            "name": "need",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Need16",
          "filepath": "need/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
                }
              }
            ],
            "name": "need",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Need",
        "global": "Need",
        "filepath": "Need.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--1",
      "friendlyName": "Network 1",
      "aliases": [
        "network",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>network--1</title><path d=\"M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z\"/><path d=\"M5,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,5,20Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,5,14Z\"/><path d=\"M10,31a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,31Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,25Z\"/><path d=\"M22,31a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,31Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,22,25Z\"/><path d=\"M27,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,27,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,27,14Z\"/><path d=\"M22,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,22,3Z\"/><path d=\"M10,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z\"/></svg>",
            "info": {},
            "path": "32/network--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Network_132",
          "filepath": "network--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
                }
              }
            ],
            "name": "network--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Network_124",
          "filepath": "network--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
                }
              }
            ],
            "name": "network--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Network_120",
          "filepath": "network--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
                }
              }
            ],
            "name": "network--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Network_116",
          "filepath": "network--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
                }
              }
            ],
            "name": "network--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Network_1",
        "global": "Network_1",
        "filepath": "Network_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--2",
      "friendlyName": "Network 2",
      "aliases": [
        "network",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>network--2</title><path d=\"M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z\"/></svg>",
            "info": {},
            "path": "32/network--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Network_232",
          "filepath": "network--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
                }
              }
            ],
            "name": "network--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Network_224",
          "filepath": "network--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
                }
              }
            ],
            "name": "network--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Network_220",
          "filepath": "network--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
                }
              }
            ],
            "name": "network--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Network_216",
          "filepath": "network--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
                }
              }
            ],
            "name": "network--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Network_2",
        "global": "Network_2",
        "filepath": "Network_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--3",
      "friendlyName": "Network 3",
      "aliases": [
        "network",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>network--3</title><path d=\"M30,30H22V22h8Zm-6-2h4V24H24Z\"/><path d=\"M20,27H8A6,6,0,0,1,8,15h2v2H8a4,4,0,0,0,0,8H20Z\"/><path d=\"M20,20H12V12h8Zm-6-2h4V14H14Z\"/><path d=\"M24,17H22V15h2a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z\"/><path d=\"M10,10H2V2h8ZM4,8H8V4H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z\"/><path d=\"M20,20H12V12h8Zm-6-2h4V14H14Z\"/><path d=\"M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z\"/></svg>",
            "info": {},
            "path": "32/network--3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Network_332",
          "filepath": "network--3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20H12V12h8Zm-6-2h4V14H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Network_324",
          "filepath": "network--3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20H12V12h8Zm-6-2h4V14H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Network_320",
          "filepath": "network--3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20H12V12h8Zm-6-2h4V14H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Network_316",
          "filepath": "network--3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20H12V12h8Zm-6-2h4V14H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Network_3",
        "global": "Network_3",
        "filepath": "Network_3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,20H12V12h8Zm-6-2h4V14H14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--3--reference",
      "friendlyName": "Network 3 reference",
      "aliases": [
        "network 3 reference",
        "data",
        "source",
        "citation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--3--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M30,30H22V22h8Zm-6-2h4V24H24Z\"/>\n  <path d=\"M20,20H12V12h8Zm-6-2h4V14H14Z\"/>\n  <path d=\"M24,17H22V15h2a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z\"/>\n  <path d=\"M10,10H2V2h8ZM4,8H8V4H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z\"/><path d=\"M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z\"/></svg>",
            "info": {},
            "path": "32/network--3--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Network_3Reference32",
          "filepath": "network--3--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Network_3Reference24",
          "filepath": "network--3--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Network_3Reference20",
          "filepath": "network--3--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Network_3Reference16",
          "filepath": "network--3--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                }
              }
            ],
            "name": "network--3--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Network_3Reference",
        "global": "Network_3Reference",
        "filepath": "Network_3Reference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--4",
      "friendlyName": "Network 4",
      "aliases": [
        "network",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--4.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>network--4</title><circle cx=\"21\" cy=\"26\" r=\"2\"/><circle cx=\"21\" cy=\"6\" r=\"2\"/><circle cx=\"4\" cy=\"16\" r=\"2\"/><path d=\"M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"21\" cy=\"26\" r=\"2\"/><circle cx=\"21\" cy=\"6\" r=\"2\"/><circle cx=\"4\" cy=\"16\" r=\"2\"/><path d=\"M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z\"/></svg>",
            "info": {},
            "path": "32/network--4.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Network_432",
          "filepath": "network--4/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Network_424",
          "filepath": "network--4/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Network_420",
          "filepath": "network--4/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Network_416",
          "filepath": "network--4/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Network_4",
        "global": "Network_4",
        "filepath": "Network_4.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "26",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "6",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--4--reference",
      "friendlyName": "Network 4 reference",
      "aliases": [
        "network 4 reference",
        "data",
        "source",
        "citation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--4--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"21\" cy=\"26\" r=\"2\"/>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <circle cx=\"21\" cy=\"6\" r=\"2\"/>\n  <circle cx=\"4\" cy=\"16\" r=\"2\"/>\n  <path d=\"M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"21\" cy=\"26\" r=\"2\"/><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z\"/><circle cx=\"21\" cy=\"6\" r=\"2\"/><circle cx=\"4\" cy=\"16\" r=\"2\"/><path d=\"M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z\"/></svg>",
            "info": {},
            "path": "32/network--4--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Network_4Reference32",
          "filepath": "network--4--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Network_4Reference24",
          "filepath": "network--4--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Network_4Reference20",
          "filepath": "network--4--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Network_4Reference16",
          "filepath": "network--4--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "26",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "6",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                }
              }
            ],
            "name": "network--4--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Network_4Reference",
        "global": "Network_4Reference",
        "filepath": "Network_4Reference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "26",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "6",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--admin-control",
      "friendlyName": "Network admin control",
      "aliases": [
        "network",
        "administration",
        "control",
        "systems",
        "access",
        "allowed",
        "denied"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--admin-control.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"27 20.415 25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415\"/>\n  <path d=\"M24,4a4.0045,4.0045,0,0,0-4,4,3.951,3.951,0,0,0,.5669,2.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z\"/>\n  <polygon points=\"8 11.18 5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z\"/></svg>",
            "info": {},
            "path": "32/network--admin-control.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NetworkAdminControl32",
          "filepath": "network--admin-control/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
                }
              }
            ],
            "name": "network--admin-control",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NetworkAdminControl24",
          "filepath": "network--admin-control/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
                }
              }
            ],
            "name": "network--admin-control",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NetworkAdminControl20",
          "filepath": "network--admin-control/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
                }
              }
            ],
            "name": "network--admin-control",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NetworkAdminControl16",
          "filepath": "network--admin-control/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
                }
              }
            ],
            "name": "network--admin-control",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "NetworkAdminControl",
        "global": "NetworkAdminControl",
        "filepath": "NetworkAdminControl.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--enterprise",
      "friendlyName": "Network enterprise",
      "aliases": [
        "cloud",
        "business",
        "enterprise",
        "corporate",
        "network",
        "infrastructure"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--enterprise.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"20\" y=\"16\" width=\"2\" height=\"4\"/>\n  <rect x=\"24\" y=\"16\" width=\"2\" height=\"4\"/>\n  <rect x=\"20\" y=\"22\" width=\"2\" height=\"4\"/>\n  <rect x=\"24\" y=\"22\" width=\"2\" height=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z\"/><path d=\"M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z\"/><path d=\"M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z\"/></svg>",
            "info": {},
            "path": "32/network--enterprise.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NetworkEnterprise32",
          "filepath": "network--enterprise/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
                }
              }
            ],
            "name": "network--enterprise",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NetworkEnterprise24",
          "filepath": "network--enterprise/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
                }
              }
            ],
            "name": "network--enterprise",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NetworkEnterprise20",
          "filepath": "network--enterprise/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
                }
              }
            ],
            "name": "network--enterprise",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NetworkEnterprise16",
          "filepath": "network--enterprise/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
                }
              }
            ],
            "name": "network--enterprise",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "NetworkEnterprise",
        "global": "NetworkEnterprise",
        "filepath": "NetworkEnterprise.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--overlay",
      "friendlyName": "Network overlay",
      "aliases": [
        "cloud",
        "communications",
        "overlay",
        "network",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--overlay.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 23 13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23\"/>\n  <polygon points=\"11 13 19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13\"/>\n  <path d=\"M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z\"/><path d=\"M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z\"/></svg>",
            "info": {},
            "path": "32/network--overlay.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NetworkOverlay32",
          "filepath": "network--overlay/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "network--overlay",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NetworkOverlay24",
          "filepath": "network--overlay/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "network--overlay",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NetworkOverlay20",
          "filepath": "network--overlay/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "network--overlay",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NetworkOverlay16",
          "filepath": "network--overlay/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                }
              }
            ],
            "name": "network--overlay",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "NetworkOverlay",
        "global": "NetworkOverlay",
        "filepath": "NetworkOverlay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "network--public",
      "friendlyName": "Network public",
      "aliases": [
        "cloud",
        "global",
        "open",
        "network",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/network--public.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\n\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\n\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z\n\t M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\n\tC28.3,25,26.9,26.7,25.1,27.5z\"/>\n<path d=\"M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\n\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__232_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z\"/><path d=\"M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z\"/></svg>",
            "info": {},
            "path": "32/network--public.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NetworkPublic32",
          "filepath": "network--public/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
                }
              }
            ],
            "name": "network--public",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NetworkPublic24",
          "filepath": "network--public/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
                }
              }
            ],
            "name": "network--public",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NetworkPublic20",
          "filepath": "network--public/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
                }
              }
            ],
            "name": "network--public",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NetworkPublic16",
          "filepath": "network--public/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5\tC27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21\tc0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9\tC28.3,25,26.9,26.7,25.1,27.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5\tc-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
                }
              }
            ],
            "name": "network--public",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "NetworkPublic",
        "global": "NetworkPublic",
        "filepath": "NetworkPublic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5 C27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21 c0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9 C28.3,25,26.9,26.7,25.1,27.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5 c-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "new-tab",
      "friendlyName": "New tab",
      "aliases": [
        "open",
        "expand",
        "view",
        "browser",
        "window",
        "operations"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/new-tab.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>new-tab</title>\n<path d=\"M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z\"/>\n<polygon points=\"13,3 13,1 12,1 12,3 10,3 10,4 12,4 12,6 13,6 13,4 15,4 15,3 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z\"/><path d=\"M13 3L13 1 12 1 12 3 10 3 10 4 12 4 12 6 13 6 13 4 15 4 15 3z\"/></svg>",
            "info": {},
            "path": "16/new-tab.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/new-tab.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <g>\n    <path d=\"M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z\"/>\n    <path d=\"M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z\"/>\n  </g>\n  <polygon points=\"26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z\"/><path d=\"M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z\"/><path d=\"M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z\"/></svg>",
            "info": {},
            "path": "32/new-tab.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NewTab32",
          "filepath": "new-tab/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                }
              }
            ],
            "name": "new-tab",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NewTab24",
          "filepath": "new-tab/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                }
              }
            ],
            "name": "new-tab",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NewTab20",
          "filepath": "new-tab/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                }
              }
            ],
            "name": "new-tab",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NewTab16",
          "filepath": "new-tab/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 3L13 1 12 1 12 3 10 3 10 4 12 4 12 6 13 6 13 4 15 4 15 3z"
                }
              }
            ],
            "name": "new-tab",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "NewTab",
        "global": "NewTab",
        "filepath": "NewTab.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 3L13 1 12 1 12 3 10 3 10 4 12 4 12 6 13 6 13 4 15 4 15 3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "next--filled",
      "friendlyName": "Next filled",
      "aliases": [
        "next filled",
        "next"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/next--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z\"/>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"16 8 14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z\"/><path fill=\"none\" d=\"M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/next--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NextFilled32",
          "filepath": "next--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "next--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NextFilled24",
          "filepath": "next--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "next--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NextFilled20",
          "filepath": "next--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "next--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NextFilled16",
          "filepath": "next--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "next--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "NextFilled",
        "global": "NextFilled",
        "filepath": "NextFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "next--outline",
      "friendlyName": "Next outline",
      "aliases": [
        "next outline",
        "next"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/next--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 8 14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/next--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NextOutline32",
          "filepath": "next--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "next--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NextOutline24",
          "filepath": "next--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "next--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NextOutline20",
          "filepath": "next--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "next--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NextOutline16",
          "filepath": "next--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "next--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "NextOutline",
        "global": "NextOutline",
        "filepath": "NextOutline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "no-image",
      "friendlyName": "No image",
      "aliases": [
        "no image",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/no-image.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>no-image</title><path d=\"M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z\"/><path d=\"M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 3.4141L28.5859 2 2 28.5859 3.4141 30l2-2H26a2.0027 2.0027 0 002-2V5.4141zM26 26H7.4141l7.7929-7.793 2.3788 2.3787a2 2 0 002.8284 0L22 19l4 3.9973zm0-5.8318l-2.5858-2.5859a2 2 0 00-2.8284 0L19 19.1682l-2.377-2.3771L26 7.4141zM6 22V19l5-4.9966 1.3733 1.3733 1.4159-1.416-1.375-1.375a2 2 0 00-2.8284 0L6 16.1716V6H22V4H6A2.002 2.002 0 004 6V22z\"/></svg>",
            "info": {},
            "path": "32/no-image.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NoImage32",
          "filepath": "no-image/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l2-2H26a2.0027 2.0027 0 002-2V5.4141zM26 26H7.4141l7.7929-7.793 2.3788 2.3787a2 2 0 002.8284 0L22 19l4 3.9973zm0-5.8318l-2.5858-2.5859a2 2 0 00-2.8284 0L19 19.1682l-2.377-2.3771L26 7.4141zM6 22V19l5-4.9966 1.3733 1.3733 1.4159-1.416-1.375-1.375a2 2 0 00-2.8284 0L6 16.1716V6H22V4H6A2.002 2.002 0 004 6V22z"
                }
              }
            ],
            "name": "no-image",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NoImage24",
          "filepath": "no-image/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l2-2H26a2.0027 2.0027 0 002-2V5.4141zM26 26H7.4141l7.7929-7.793 2.3788 2.3787a2 2 0 002.8284 0L22 19l4 3.9973zm0-5.8318l-2.5858-2.5859a2 2 0 00-2.8284 0L19 19.1682l-2.377-2.3771L26 7.4141zM6 22V19l5-4.9966 1.3733 1.3733 1.4159-1.416-1.375-1.375a2 2 0 00-2.8284 0L6 16.1716V6H22V4H6A2.002 2.002 0 004 6V22z"
                }
              }
            ],
            "name": "no-image",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NoImage20",
          "filepath": "no-image/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l2-2H26a2.0027 2.0027 0 002-2V5.4141zM26 26H7.4141l7.7929-7.793 2.3788 2.3787a2 2 0 002.8284 0L22 19l4 3.9973zm0-5.8318l-2.5858-2.5859a2 2 0 00-2.8284 0L19 19.1682l-2.377-2.3771L26 7.4141zM6 22V19l5-4.9966 1.3733 1.3733 1.4159-1.416-1.375-1.375a2 2 0 00-2.8284 0L6 16.1716V6H22V4H6A2.002 2.002 0 004 6V22z"
                }
              }
            ],
            "name": "no-image",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NoImage16",
          "filepath": "no-image/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l2-2H26a2.0027 2.0027 0 002-2V5.4141zM26 26H7.4141l7.7929-7.793 2.3788 2.3787a2 2 0 002.8284 0L22 19l4 3.9973zm0-5.8318l-2.5858-2.5859a2 2 0 00-2.8284 0L19 19.1682l-2.377-2.3771L26 7.4141zM6 22V19l5-4.9966 1.3733 1.3733 1.4159-1.416-1.375-1.375a2 2 0 00-2.8284 0L6 16.1716V6H22V4H6A2.002 2.002 0 004 6V22z"
                }
              }
            ],
            "name": "no-image",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "NoImage",
        "global": "NoImage",
        "filepath": "NoImage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l2-2H26a2.0027 2.0027 0 002-2V5.4141zM26 26H7.4141l7.7929-7.793 2.3788 2.3787a2 2 0 002.8284 0L22 19l4 3.9973zm0-5.8318l-2.5858-2.5859a2 2 0 00-2.8284 0L19 19.1682l-2.377-2.3771L26 7.4141zM6 22V19l5-4.9966 1.3733 1.3733 1.4159-1.416-1.375-1.375a2 2 0 00-2.8284 0L6 16.1716V6H22V4H6A2.002 2.002 0 004 6V22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "no-ticket",
      "friendlyName": "No ticket",
      "aliases": [
        "no ticket",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/no-ticket.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>no-ticket</title><path d=\"M28,6h-.5859L30,3.4141,28.5859,2,2,28.5859,3.4141,30l4-4H28a2.0027,2.0027,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4,1,1,0,0,0,1-1V8A2.0023,2.0023,0,0,0,28,6Zm0,6.1265a4,4,0,0,0,0,7.7465V24H21V21H19v3H9.4141L19,14.4141V19h2V12.4141L25.4141,8H28Z\"/><path d=\"M4,12.1265V8H19V6H4A2.0023,2.0023,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5H4V19.873a4,4,0,0,0,0-7.7465Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 6h-.5859L30 3.4141 28.5859 2 2 28.5859 3.4141 30l4-4H28a2.0027 2.0027 0 002-2V19a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8A2.0023 2.0023 0 0028 6zm0 6.1265a4 4 0 000 7.7465V24H21V21H19v3H9.4141L19 14.4141V19h2V12.4141L25.4141 8H28zM4 12.1265V8H19V6H4A2.0023 2.0023 0 002 8v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5H4V19.873a4 4 0 000-7.7465z\"/></svg>",
            "info": {},
            "path": "32/no-ticket.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NoTicket32",
          "filepath": "no-ticket/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6h-.5859L30 3.4141 28.5859 2 2 28.5859 3.4141 30l4-4H28a2.0027 2.0027 0 002-2V19a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8A2.0023 2.0023 0 0028 6zm0 6.1265a4 4 0 000 7.7465V24H21V21H19v3H9.4141L19 14.4141V19h2V12.4141L25.4141 8H28zM4 12.1265V8H19V6H4A2.0023 2.0023 0 002 8v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5H4V19.873a4 4 0 000-7.7465z"
                }
              }
            ],
            "name": "no-ticket",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NoTicket24",
          "filepath": "no-ticket/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6h-.5859L30 3.4141 28.5859 2 2 28.5859 3.4141 30l4-4H28a2.0027 2.0027 0 002-2V19a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8A2.0023 2.0023 0 0028 6zm0 6.1265a4 4 0 000 7.7465V24H21V21H19v3H9.4141L19 14.4141V19h2V12.4141L25.4141 8H28zM4 12.1265V8H19V6H4A2.0023 2.0023 0 002 8v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5H4V19.873a4 4 0 000-7.7465z"
                }
              }
            ],
            "name": "no-ticket",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NoTicket20",
          "filepath": "no-ticket/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6h-.5859L30 3.4141 28.5859 2 2 28.5859 3.4141 30l4-4H28a2.0027 2.0027 0 002-2V19a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8A2.0023 2.0023 0 0028 6zm0 6.1265a4 4 0 000 7.7465V24H21V21H19v3H9.4141L19 14.4141V19h2V12.4141L25.4141 8H28zM4 12.1265V8H19V6H4A2.0023 2.0023 0 002 8v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5H4V19.873a4 4 0 000-7.7465z"
                }
              }
            ],
            "name": "no-ticket",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NoTicket16",
          "filepath": "no-ticket/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 6h-.5859L30 3.4141 28.5859 2 2 28.5859 3.4141 30l4-4H28a2.0027 2.0027 0 002-2V19a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8A2.0023 2.0023 0 0028 6zm0 6.1265a4 4 0 000 7.7465V24H21V21H19v3H9.4141L19 14.4141V19h2V12.4141L25.4141 8H28zM4 12.1265V8H19V6H4A2.0023 2.0023 0 002 8v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5H4V19.873a4 4 0 000-7.7465z"
                }
              }
            ],
            "name": "no-ticket",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "NoTicket",
        "global": "NoTicket",
        "filepath": "NoTicket.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 6h-.5859L30 3.4141 28.5859 2 2 28.5859 3.4141 30l4-4H28a2.0027 2.0027 0 002-2V19a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8A2.0023 2.0023 0 0028 6zm0 6.1265a4 4 0 000 7.7465V24H21V21H19v3H9.4141L19 14.4141V19h2V12.4141L25.4141 8H28zM4 12.1265V8H19V6H4A2.0023 2.0023 0 002 8v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5H4V19.873a4 4 0 000-7.7465z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "nominal",
      "friendlyName": "Nominal",
      "aliases": [
        "nominal data",
        "data"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/nominal.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 61 (89581) - https://sketch.com -->\n    <title>Nominal 16</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"Nominal-16\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 Z M4,8 C5.65685425,8 7,9.34314575 7,11 C7,12.6568542 5.65685425,14 4,14 C2.34314575,14 1,12.6568542 1,11 C1,9.34314575 2.34314575,8 4,8 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z M4,9 C2.8954305,9 2,9.8954305 2,11 C2,12.1045695 2.8954305,13 4,13 C5.1045695,13 6,12.1045695 6,11 C6,9.8954305 5.1045695,9 4,9 Z M8,2 C9.65685425,2 11,3.34314575 11,5 C11,6.65685425 9.65685425,8 8,8 C6.34314575,8 5,6.65685425 5,5 C5,3.34314575 6.34314575,2 8,2 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,6.1045695 6.8954305,7 8,7 C9.1045695,7 10,6.1045695 10,5 C10,3.8954305 9.1045695,3 8,3 Z\" id=\"Combined-Shape\" fill=\"#000000\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 Z M4,8 C5.65685425,8 7,9.34314575 7,11 C7,12.6568542 5.65685425,14 4,14 C2.34314575,14 1,12.6568542 1,11 C1,9.34314575 2.34314575,8 4,8 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z M4,9 C2.8954305,9 2,9.8954305 2,11 C2,12.1045695 2.8954305,13 4,13 C5.1045695,13 6,12.1045695 6,11 C6,9.8954305 5.1045695,9 4,9 Z M8,2 C9.65685425,2 11,3.34314575 11,5 C11,6.65685425 9.65685425,8 8,8 C6.34314575,8 5,6.65685425 5,5 C5,3.34314575 6.34314575,2 8,2 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,6.1045695 6.8954305,7 8,7 C9.1045695,7 10,6.1045695 10,5 C10,3.8954305 9.1045695,3 8,3 Z\"/></svg>",
            "info": {},
            "path": "16/nominal.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/nominal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>nominal</title><path d=\"M24,28a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,28Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,18Z\"/><path d=\"M8,28a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,8,28ZM8,18a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,8,18Z\"/><path d=\"M16,14a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,16,14ZM16,4a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 28a6 6 0 116-6A6.0069 6.0069 0 0124 28zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 18zM8 28a6 6 0 116-6A6.0069 6.0069 0 018 28zM8 18a4 4 0 104 4A4.0045 4.0045 0 008 18zM16 14a6 6 0 116-6A6.0069 6.0069 0 0116 14zM16 4a4 4 0 104 4A4.0045 4.0045 0 0016 4z\"/></svg>",
            "info": {},
            "path": "32/nominal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Nominal32",
          "filepath": "nominal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 28a6 6 0 116-6A6.0069 6.0069 0 0124 28zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 18zM8 28a6 6 0 116-6A6.0069 6.0069 0 018 28zM8 18a4 4 0 104 4A4.0045 4.0045 0 008 18zM16 14a6 6 0 116-6A6.0069 6.0069 0 0116 14zM16 4a4 4 0 104 4A4.0045 4.0045 0 0016 4z"
                }
              }
            ],
            "name": "nominal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Nominal24",
          "filepath": "nominal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 28a6 6 0 116-6A6.0069 6.0069 0 0124 28zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 18zM8 28a6 6 0 116-6A6.0069 6.0069 0 018 28zM8 18a4 4 0 104 4A4.0045 4.0045 0 008 18zM16 14a6 6 0 116-6A6.0069 6.0069 0 0116 14zM16 4a4 4 0 104 4A4.0045 4.0045 0 0016 4z"
                }
              }
            ],
            "name": "nominal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Nominal20",
          "filepath": "nominal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 28a6 6 0 116-6A6.0069 6.0069 0 0124 28zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 18zM8 28a6 6 0 116-6A6.0069 6.0069 0 018 28zM8 18a4 4 0 104 4A4.0045 4.0045 0 008 18zM16 14a6 6 0 116-6A6.0069 6.0069 0 0116 14zM16 4a4 4 0 104 4A4.0045 4.0045 0 0016 4z"
                }
              }
            ],
            "name": "nominal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Nominal16",
          "filepath": "nominal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 Z M4,8 C5.65685425,8 7,9.34314575 7,11 C7,12.6568542 5.65685425,14 4,14 C2.34314575,14 1,12.6568542 1,11 C1,9.34314575 2.34314575,8 4,8 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z M4,9 C2.8954305,9 2,9.8954305 2,11 C2,12.1045695 2.8954305,13 4,13 C5.1045695,13 6,12.1045695 6,11 C6,9.8954305 5.1045695,9 4,9 Z M8,2 C9.65685425,2 11,3.34314575 11,5 C11,6.65685425 9.65685425,8 8,8 C6.34314575,8 5,6.65685425 5,5 C5,3.34314575 6.34314575,2 8,2 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,6.1045695 6.8954305,7 8,7 C9.1045695,7 10,6.1045695 10,5 C10,3.8954305 9.1045695,3 8,3 Z"
                }
              }
            ],
            "name": "nominal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Nominal",
        "global": "Nominal",
        "filepath": "Nominal.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 Z M4,8 C5.65685425,8 7,9.34314575 7,11 C7,12.6568542 5.65685425,14 4,14 C2.34314575,14 1,12.6568542 1,11 C1,9.34314575 2.34314575,8 4,8 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z M4,9 C2.8954305,9 2,9.8954305 2,11 C2,12.1045695 2.8954305,13 4,13 C5.1045695,13 6,12.1045695 6,11 C6,9.8954305 5.1045695,9 4,9 Z M8,2 C9.65685425,2 11,3.34314575 11,5 C11,6.65685425 9.65685425,8 8,8 C6.34314575,8 5,6.65685425 5,5 C5,3.34314575 6.34314575,2 8,2 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,6.1045695 6.8954305,7 8,7 C9.1045695,7 10,6.1045695 10,5 C10,3.8954305 9.1045695,3 8,3 Z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 28a6 6 0 116-6A6.0069 6.0069 0 0124 28zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 18zM8 28a6 6 0 116-6A6.0069 6.0069 0 018 28zM8 18a4 4 0 104 4A4.0045 4.0045 0 008 18zM16 14a6 6 0 116-6A6.0069 6.0069 0 0116 14zM16 4a4 4 0 104 4A4.0045 4.0045 0 0016 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "nominate",
      "friendlyName": "Nominate",
      "aliases": [
        "nominate",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/nominate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>nominate</title><path d=\"M25,23H19a3,3,0,0,0-3,3v2h2V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V26A3,3,0,0,0,25,23Z\"/><path d=\"M18,18a4,4,0,1,0,4-4A4,4,0,0,0,18,18Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,24,18Z\"/><polygon points=\"10 18.59 7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59\"/><path d=\"M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z\"/><path d=\"M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/nominate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthNominate32",
          "filepath": "watson-health/nominate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "nominate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthNominate24",
          "filepath": "watson-health/nominate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "nominate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthNominate20",
          "filepath": "watson-health/nominate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "nominate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthNominate16",
          "filepath": "watson-health/nominate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                }
              }
            ],
            "name": "nominate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Nominate",
        "global": "WatsonHealthNominate",
        "filepath": "watson-health/Nominate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "non-certified",
      "friendlyName": "Non-certified",
      "aliases": [
        "non-certified",
        "file",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/non-certified.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"6\" y=\"8\" width=\"10\" height=\"2\"/>\n  <rect x=\"6\" y=\"12\" width=\"8\" height=\"2\"/>\n  <rect x=\"6\" y=\"16\" width=\"4\" height=\"2\"/>\n  <path d=\"M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 8H16V10H6zM6 12H14V14H6zM6 16H10V18H6z\"/><path d=\"M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z\"/></svg>",
            "info": {},
            "path": "32/non-certified.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NonCertified32",
          "filepath": "non-certified/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H14V14H6zM6 16H10V18H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
                }
              }
            ],
            "name": "non-certified",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NonCertified24",
          "filepath": "non-certified/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H14V14H6zM6 16H10V18H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
                }
              }
            ],
            "name": "non-certified",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NonCertified20",
          "filepath": "non-certified/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H14V14H6zM6 16H10V18H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
                }
              }
            ],
            "name": "non-certified",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NonCertified16",
          "filepath": "non-certified/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 8H16V10H6zM6 12H14V14H6zM6 16H10V18H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
                }
              }
            ],
            "name": "non-certified",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "NonCertified",
        "global": "NonCertified",
        "filepath": "NonCertified.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 8H16V10H6zM6 12H14V14H6zM6 16H10V18H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "noodle-bowl",
      "friendlyName": "Noodle bowl",
      "aliases": [
        "noodle bowl",
        "noodle",
        "commerce",
        "food"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/noodle-bowl.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>noodle-bowl</title><path d=\"M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z\"/><path d=\"M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z\"/><path d=\"M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z\"/></svg>",
            "info": {},
            "path": "32/noodle-bowl.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NoodleBowl32",
          "filepath": "noodle-bowl/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
                }
              }
            ],
            "name": "noodle-bowl",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NoodleBowl24",
          "filepath": "noodle-bowl/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
                }
              }
            ],
            "name": "noodle-bowl",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NoodleBowl20",
          "filepath": "noodle-bowl/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
                }
              }
            ],
            "name": "noodle-bowl",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NoodleBowl16",
          "filepath": "noodle-bowl/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
                }
              }
            ],
            "name": "noodle-bowl",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "NoodleBowl",
        "global": "NoodleBowl",
        "filepath": "NoodleBowl.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "not-available",
      "friendlyName": "Not available",
      "aliases": [
        "not available",
        "weather",
        "blank",
        "empty"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/not-available.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>unavailable</title><rect x=\"4\" y=\"15\" width=\"10\" height=\"2\"/><rect x=\"18\" y=\"15\" width=\"10\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 15H14V17H4zM18 15H28V17H18z\"/></svg>",
            "info": {},
            "path": "32/not-available.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotAvailable32",
          "filepath": "not-available/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 15H14V17H4zM18 15H28V17H18z"
                }
              }
            ],
            "name": "not-available",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotAvailable24",
          "filepath": "not-available/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 15H14V17H4zM18 15H28V17H18z"
                }
              }
            ],
            "name": "not-available",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotAvailable20",
          "filepath": "not-available/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 15H14V17H4zM18 15H28V17H18z"
                }
              }
            ],
            "name": "not-available",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotAvailable16",
          "filepath": "not-available/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 15H14V17H4zM18 15H28V17H18z"
                }
              }
            ],
            "name": "not-available",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "NotAvailable",
        "global": "NotAvailable",
        "filepath": "NotAvailable.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 15H14V17H4zM18 15H28V17H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "not-sent",
      "friendlyName": "Not sent",
      "aliases": [
        "failed",
        "failure",
        "incomplete",
        "sent",
        "send",
        "email",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/not-sent.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>not-sent</title><path d=\"M30,28.59,3.41,2,2,3.41l8,8L2.66,14.06a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,17,30h0a1,1,0,0,0,.92-.66L20.6,22l8,8ZM5.8,15,11.54,13l3.05,3-1.83,1.83ZM17,26.2l-2.79-7L16,17.41l3,3.05Z\"/><path d=\"M15.69,11.45l7.64-2.78-2.78,7.64,1.56,1.56L25.94,7.34a1,1,0,0,0-1.28-1.28L14.13,9.89Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l9.6 3.84 3.84 9.6A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM5.8 15L11.54 13l3.05 3-1.83 1.83zM17 26.2l-2.79-7L16 17.41l3 3.05zM15.69 11.45l7.64-2.78-2.78 7.64 1.56 1.56L25.94 7.34a1 1 0 00-1.28-1.28L14.13 9.89z\"/></svg>",
            "info": {},
            "path": "32/not-sent.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotSent32",
          "filepath": "not-sent/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l9.6 3.84 3.84 9.6A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM5.8 15L11.54 13l3.05 3-1.83 1.83zM17 26.2l-2.79-7L16 17.41l3 3.05zM15.69 11.45l7.64-2.78-2.78 7.64 1.56 1.56L25.94 7.34a1 1 0 00-1.28-1.28L14.13 9.89z"
                }
              }
            ],
            "name": "not-sent",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotSent24",
          "filepath": "not-sent/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l9.6 3.84 3.84 9.6A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM5.8 15L11.54 13l3.05 3-1.83 1.83zM17 26.2l-2.79-7L16 17.41l3 3.05zM15.69 11.45l7.64-2.78-2.78 7.64 1.56 1.56L25.94 7.34a1 1 0 00-1.28-1.28L14.13 9.89z"
                }
              }
            ],
            "name": "not-sent",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotSent20",
          "filepath": "not-sent/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l9.6 3.84 3.84 9.6A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM5.8 15L11.54 13l3.05 3-1.83 1.83zM17 26.2l-2.79-7L16 17.41l3 3.05zM15.69 11.45l7.64-2.78-2.78 7.64 1.56 1.56L25.94 7.34a1 1 0 00-1.28-1.28L14.13 9.89z"
                }
              }
            ],
            "name": "not-sent",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotSent16",
          "filepath": "not-sent/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l9.6 3.84 3.84 9.6A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM5.8 15L11.54 13l3.05 3-1.83 1.83zM17 26.2l-2.79-7L16 17.41l3 3.05zM15.69 11.45l7.64-2.78-2.78 7.64 1.56 1.56L25.94 7.34a1 1 0 00-1.28-1.28L14.13 9.89z"
                }
              }
            ],
            "name": "not-sent",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "NotSent",
        "global": "NotSent",
        "filepath": "NotSent.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l9.6 3.84 3.84 9.6A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM5.8 15L11.54 13l3.05 3-1.83 1.83zM17 26.2l-2.79-7L16 17.41l3 3.05zM15.69 11.45l7.64-2.78-2.78 7.64 1.56 1.56L25.94 7.34a1 1 0 00-1.28-1.28L14.13 9.89z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "not-sent--filled",
      "friendlyName": "Not sent filled",
      "aliases": [
        "failed",
        "failure",
        "incomplete",
        "sent",
        "send",
        "email",
        "operations",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/not-sent--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>not-sent--filled</title><path d=\"M30,28.59,3.41,2,2,3.41l8,8L2.66,14.06a1,1,0,0,0,0,1.87l8.59,3.43L14.59,16,16,17.41l-3.37,3.37,3.44,8.59A1,1,0,0,0,17,30h0a1,1,0,0,0,.92-.66L20.6,22l8,8Z\"/><path d=\"M22.49,16.83l3.45-9.49a1,1,0,0,0-1.28-1.28L15.17,9.51Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z\"/></svg>",
            "info": {},
            "path": "32/not-sent--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotSentFilled32",
          "filepath": "not-sent--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z"
                }
              }
            ],
            "name": "not-sent--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotSentFilled24",
          "filepath": "not-sent--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z"
                }
              }
            ],
            "name": "not-sent--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotSentFilled20",
          "filepath": "not-sent--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z"
                }
              }
            ],
            "name": "not-sent--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotSentFilled16",
          "filepath": "not-sent--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z"
                }
              }
            ],
            "name": "not-sent--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "NotSentFilled",
        "global": "NotSentFilled",
        "filepath": "NotSentFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "notebook",
      "friendlyName": "Notebook",
      "aliases": [
        "book",
        "notes",
        "diary",
        "journal",
        "binder",
        "log",
        "workbook",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/notebook.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>notebook</title><rect x=\"19\" y=\"10\" width=\"7\" height=\"2\"/><rect x=\"19\" y=\"15\" width=\"7\" height=\"2\"/><rect x=\"19\" y=\"20\" width=\"7\" height=\"2\"/><path d=\"M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z\"/><path d=\"M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z\"/></svg>",
            "info": {},
            "path": "32/notebook.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Notebook32",
          "filepath": "notebook/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
                }
              }
            ],
            "name": "notebook",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Notebook24",
          "filepath": "notebook/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
                }
              }
            ],
            "name": "notebook",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Notebook20",
          "filepath": "notebook/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
                }
              }
            ],
            "name": "notebook",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Notebook16",
          "filepath": "notebook/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
                }
              }
            ],
            "name": "notebook",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Notebook",
        "global": "Notebook",
        "filepath": "Notebook.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "notebook--reference",
      "friendlyName": "Notebook reference",
      "aliases": [
        "book",
        "notes",
        "diary",
        "journal",
        "binder",
        "log",
        "workbook",
        "file",
        "citation",
        "reference",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/notebook--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>notebook--reference</title><polygon points=\"4 20 4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20\"/><rect x=\"19\" y=\"10\" width=\"7\" height=\"2\"/><rect x=\"19\" y=\"15\" width=\"7\" height=\"2\"/><rect x=\"19\" y=\"20\" width=\"7\" height=\"2\"/><path d=\"M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z\"/><path d=\"M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z\"/></svg>",
            "info": {},
            "path": "32/notebook--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotebookReference32",
          "filepath": "notebook--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
                }
              }
            ],
            "name": "notebook--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotebookReference24",
          "filepath": "notebook--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
                }
              }
            ],
            "name": "notebook--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotebookReference20",
          "filepath": "notebook--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
                }
              }
            ],
            "name": "notebook--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotebookReference16",
          "filepath": "notebook--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
                }
              }
            ],
            "name": "notebook--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "NotebookReference",
        "global": "NotebookReference",
        "filepath": "NotebookReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "notification",
      "friendlyName": "Notification",
      "aliases": [
        "alert",
        "bell",
        "sound",
        "mute",
        "chime",
        "noise",
        "notify"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/notification.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>notification</title>\n<path d=\"M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12\n\tc0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5\n\tC14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4\n\tC3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12\tc0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5\tC14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4\tC3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z\"/></svg>",
            "info": {},
            "path": "16/notification.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/notification.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z\"/></svg>",
            "info": {},
            "path": "32/notification.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Notification32",
          "filepath": "notification/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
                }
              }
            ],
            "name": "notification",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Notification24",
          "filepath": "notification/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
                }
              }
            ],
            "name": "notification",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Notification20",
          "filepath": "notification/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
                }
              }
            ],
            "name": "notification",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Notification16",
          "filepath": "notification/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12\tc0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5\tC14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4\tC3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
                }
              }
            ],
            "name": "notification",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Notification",
        "global": "Notification",
        "filepath": "Notification.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12 c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5 C14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4 C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "notification--filled",
      "friendlyName": "Notification filled",
      "aliases": [
        "alert",
        "bell",
        "sound",
        "mute",
        "chime",
        "noise",
        "toggle",
        "notify",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/notification--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z\"/></svg>",
            "info": {},
            "path": "32/notification--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotificationFilled32",
          "filepath": "notification--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              }
            ],
            "name": "notification--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotificationFilled24",
          "filepath": "notification--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              }
            ],
            "name": "notification--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotificationFilled20",
          "filepath": "notification--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              }
            ],
            "name": "notification--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotificationFilled16",
          "filepath": "notification--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              }
            ],
            "name": "notification--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "NotificationFilled",
        "global": "NotificationFilled",
        "filepath": "NotificationFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "notification--new",
      "friendlyName": "Notification new",
      "aliases": [
        "alert",
        "bell",
        "sound",
        "mute",
        "chime",
        "noise",
        "toggle",
        "notify"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/notification--new.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z\"/>\n  <circle cx=\"26\" cy=\"8\" r=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z\"/><circle cx=\"26\" cy=\"8\" r=\"4\"/></svg>",
            "info": {},
            "path": "32/notification--new.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotificationNew32",
          "filepath": "notification--new/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "4"
                }
              }
            ],
            "name": "notification--new",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotificationNew24",
          "filepath": "notification--new/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "4"
                }
              }
            ],
            "name": "notification--new",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotificationNew20",
          "filepath": "notification--new/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "4"
                }
              }
            ],
            "name": "notification--new",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotificationNew16",
          "filepath": "notification--new/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "8",
                  "r": "4"
                }
              }
            ],
            "name": "notification--new",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "NotificationNew",
        "global": "NotificationNew",
        "filepath": "NotificationNew.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "8",
                    "r": "4"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "notification--off",
      "friendlyName": "Notification off",
      "aliases": [
        "alert",
        "bell",
        "sound",
        "mute",
        "chime",
        "noise",
        "toggle",
        "notify"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/notification--off.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>notification--off</title>\n<path d=\"M2.5,11.5v-0.8l1.3-1.4C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4c0.9,0,1.8,0.3,2.5,0.9l0.7-0.7C10.5,2,9.5,1.6,8.5,1.5v-1h-1\n\tv1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4v1H2.5z\"/>\n<path d=\"M13,8.8V6.5c0-0.8-0.2-1.6-0.5-2.2L15,1.7L14.3,1L1,14.3L1.7,15l2.5-2.5h1.3C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14\n\tc0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5c0-0.1-0.1-0.3-0.1-0.4L13,8.8z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z\n\t M13.5,11.5H5.2L11.7,5C11.9,5.5,12,6,12,6.5V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M2.5 11.5v-.8l1.3-1.4C3.9 9.3 4 9.1 4 9V6.5c0-2.2 1.8-4 4-4 .9 0 1.8.3 2.5.9l.7-.7C10.5 2 9.5 1.6 8.5 1.5v-1h-1v1C5 1.8 3 3.9 3 6.5v2.3l-1.4 1.3c-.1.1-.2.2-.1.4v1H2.5zM13 8.8V6.5c0-.8-.2-1.6-.5-2.2L15 1.7 14.3 1 1 14.3 1.7 15l2.5-2.5h1.3C5.5 13.9 6.6 15 8 15s2.5-1.1 2.5-2.5H14c.3 0 .5-.2.5-.4 0 0 0 0 0-.1v-1.5c0-.1-.1-.3-.1-.4L13 8.8zM8 14c-.8 0-1.5-.7-1.5-1.5h3C9.5 13.3 8.8 14 8 14zM13.5 11.5H5.2L11.7 5C11.9 5.5 12 6 12 6.5V9c0 .1.1.3.1.4l1.4 1.3V11.5z\"/></svg>",
            "info": {},
            "path": "16/notification--off.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/notification--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,16.5859V13a9.9217,9.9217,0,0,0-1.0833-4.5024L30,3.4141,28.5859,2,2,28.5859,3.4141,30l6-6H11v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H11.4141L23.4119,10.0024A7.949,7.949,0,0,1,24,13v4a1,1,0,0,0,.293.707L27,20.4141Z\"/>\n  <path d=\"M7.707,17.707A1,1,0,0,0,8,17V13a8.0092,8.0092,0,0,1,8-8,7.9253,7.9253,0,0,1,4.9857,1.7681l1.4264-1.4263A9.934,9.934,0,0,0,17,3.0508V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859l-3,3L4.4141,21Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 16.5859V13a9.9217 9.9217 0 00-1.0833-4.5024L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a1 1 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zm8-3H11.4141L23.4119 10.0024A7.949 7.949 0 0124 13v4a1 1 0 00.293.707L27 20.4141zM7.707 17.707A1 1 0 008 17V13a8.0092 8.0092 0 018-8 7.9253 7.9253 0 014.9857 1.7681l1.4264-1.4263A9.934 9.934 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859l-3 3L4.4141 21z\"/></svg>",
            "info": {},
            "path": "32/notification--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotificationOff32",
          "filepath": "notification--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16.5859V13a9.9217 9.9217 0 00-1.0833-4.5024L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a1 1 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zm8-3H11.4141L23.4119 10.0024A7.949 7.949 0 0124 13v4a1 1 0 00.293.707L27 20.4141zM7.707 17.707A1 1 0 008 17V13a8.0092 8.0092 0 018-8 7.9253 7.9253 0 014.9857 1.7681l1.4264-1.4263A9.934 9.934 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859l-3 3L4.4141 21z"
                }
              }
            ],
            "name": "notification--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotificationOff24",
          "filepath": "notification--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16.5859V13a9.9217 9.9217 0 00-1.0833-4.5024L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a1 1 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zm8-3H11.4141L23.4119 10.0024A7.949 7.949 0 0124 13v4a1 1 0 00.293.707L27 20.4141zM7.707 17.707A1 1 0 008 17V13a8.0092 8.0092 0 018-8 7.9253 7.9253 0 014.9857 1.7681l1.4264-1.4263A9.934 9.934 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859l-3 3L4.4141 21z"
                }
              }
            ],
            "name": "notification--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotificationOff20",
          "filepath": "notification--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16.5859V13a9.9217 9.9217 0 00-1.0833-4.5024L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a1 1 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zm8-3H11.4141L23.4119 10.0024A7.949 7.949 0 0124 13v4a1 1 0 00.293.707L27 20.4141zM7.707 17.707A1 1 0 008 17V13a8.0092 8.0092 0 018-8 7.9253 7.9253 0 014.9857 1.7681l1.4264-1.4263A9.934 9.934 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859l-3 3L4.4141 21z"
                }
              }
            ],
            "name": "notification--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotificationOff16",
          "filepath": "notification--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.5 11.5v-.8l1.3-1.4C3.9 9.3 4 9.1 4 9V6.5c0-2.2 1.8-4 4-4 .9 0 1.8.3 2.5.9l.7-.7C10.5 2 9.5 1.6 8.5 1.5v-1h-1v1C5 1.8 3 3.9 3 6.5v2.3l-1.4 1.3c-.1.1-.2.2-.1.4v1H2.5zM13 8.8V6.5c0-.8-.2-1.6-.5-2.2L15 1.7 14.3 1 1 14.3 1.7 15l2.5-2.5h1.3C5.5 13.9 6.6 15 8 15s2.5-1.1 2.5-2.5H14c.3 0 .5-.2.5-.4 0 0 0 0 0-.1v-1.5c0-.1-.1-.3-.1-.4L13 8.8zM8 14c-.8 0-1.5-.7-1.5-1.5h3C9.5 13.3 8.8 14 8 14zM13.5 11.5H5.2L11.7 5C11.9 5.5 12 6 12 6.5V9c0 .1.1.3.1.4l1.4 1.3V11.5z"
                }
              }
            ],
            "name": "notification--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "NotificationOff",
        "global": "NotificationOff",
        "filepath": "NotificationOff.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.5 11.5v-.8l1.3-1.4C3.9 9.3 4 9.1 4 9V6.5c0-2.2 1.8-4 4-4 .9 0 1.8.3 2.5.9l.7-.7C10.5 2 9.5 1.6 8.5 1.5v-1h-1v1C5 1.8 3 3.9 3 6.5v2.3l-1.4 1.3c-.1.1-.2.2-.1.4v1H2.5zM13 8.8V6.5c0-.8-.2-1.6-.5-2.2L15 1.7 14.3 1 1 14.3 1.7 15l2.5-2.5h1.3C5.5 13.9 6.6 15 8 15s2.5-1.1 2.5-2.5H14c.3 0 .5-.2.5-.4 0 0 0 0 0-.1v-1.5c0-.1-.1-.3-.1-.4L13 8.8zM8 14c-.8 0-1.5-.7-1.5-1.5h3C9.5 13.3 8.8 14 8 14zM13.5 11.5H5.2L11.7 5C11.9 5.5 12 6 12 6.5V9c0 .1.1.3.1.4l1.4 1.3V11.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 16.5859V13a9.9217 9.9217 0 00-1.0833-4.5024L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a1 1 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zm8-3H11.4141L23.4119 10.0024A7.949 7.949 0 0124 13v4a1 1 0 00.293.707L27 20.4141zM7.707 17.707A1 1 0 008 17V13a8.0092 8.0092 0 018-8 7.9253 7.9253 0 014.9857 1.7681l1.4264-1.4263A9.934 9.934 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859l-3 3L4.4141 21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "notification--off--filled",
      "friendlyName": "Notification off filled",
      "aliases": [
        "alert",
        "bell",
        "sound",
        "mute",
        "chime",
        "noise",
        "toggle",
        "notify",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/notification--off--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,16.5859V13a9.8828,9.8828,0,0,0-1.0869-4.499L30,3.4141,28.5859,2,2,28.5859,3.4141,30l6-6H11v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a.9993.9993,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z\"/>\n  <path d=\"M21.61,4.7383A9.9256,9.9256,0,0,0,17,3.0508V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a.9738.9738,0,0,0,.0585.29Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z\"/></svg>",
            "info": {},
            "path": "32/notification--off--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NotificationOffFilled32",
          "filepath": "notification--off--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z"
                }
              }
            ],
            "name": "notification--off--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NotificationOffFilled24",
          "filepath": "notification--off--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z"
                }
              }
            ],
            "name": "notification--off--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NotificationOffFilled20",
          "filepath": "notification--off--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z"
                }
              }
            ],
            "name": "notification--off--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NotificationOffFilled16",
          "filepath": "notification--off--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z"
                }
              }
            ],
            "name": "notification--off--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "NotificationOffFilled",
        "global": "NotificationOffFilled",
        "filepath": "NotificationOffFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--0",
      "friendlyName": "Number 0",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "toggle",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--0.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--0</title><path d=\"M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z\"/><rect x=\"15\" y=\"15\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z\"/><path d=\"M15 15H17V17H15z\"/></svg>",
            "info": {},
            "path": "32/number--0.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_032",
          "filepath": "number--0/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H17V17H15z"
                }
              }
            ],
            "name": "number--0",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_024",
          "filepath": "number--0/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H17V17H15z"
                }
              }
            ],
            "name": "number--0",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_020",
          "filepath": "number--0/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H17V17H15z"
                }
              }
            ],
            "name": "number--0",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_016",
          "filepath": "number--0/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 15H17V17H15z"
                }
              }
            ],
            "name": "number--0",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_0",
        "global": "Number_0",
        "filepath": "Number_0.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 15H17V17H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--1",
      "friendlyName": "Number 1",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#fff;}.cls-2{fill:none;}</style></defs><title>number--1</title><path d=\"M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z\"/></svg>",
            "info": {},
            "path": "32/number--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_132",
          "filepath": "number--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
                }
              }
            ],
            "name": "number--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_124",
          "filepath": "number--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
                }
              }
            ],
            "name": "number--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_120",
          "filepath": "number--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
                }
              }
            ],
            "name": "number--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_116",
          "filepath": "number--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
                }
              }
            ],
            "name": "number--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_1",
        "global": "Number_1",
        "filepath": "Number_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--2",
      "friendlyName": "Number 2",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--2</title><path d=\"M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z\"/></svg>",
            "info": {},
            "path": "32/number--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_232",
          "filepath": "number--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
                }
              }
            ],
            "name": "number--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_224",
          "filepath": "number--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
                }
              }
            ],
            "name": "number--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_220",
          "filepath": "number--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
                }
              }
            ],
            "name": "number--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_216",
          "filepath": "number--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
                }
              }
            ],
            "name": "number--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_2",
        "global": "Number_2",
        "filepath": "Number_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--3",
      "friendlyName": "Number 3",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--3</title><path d=\"M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z\"/></svg>",
            "info": {},
            "path": "32/number--3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_332",
          "filepath": "number--3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
                }
              }
            ],
            "name": "number--3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_324",
          "filepath": "number--3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
                }
              }
            ],
            "name": "number--3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_320",
          "filepath": "number--3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
                }
              }
            ],
            "name": "number--3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_316",
          "filepath": "number--3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
                }
              }
            ],
            "name": "number--3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_3",
        "global": "Number_3",
        "filepath": "Number_3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--4",
      "friendlyName": "Number 4",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--4.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#fff;}.cls-2{fill:none;}</style></defs><title>number--4</title><path d=\"M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z\"/></svg>",
            "info": {},
            "path": "32/number--4.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_432",
          "filepath": "number--4/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
                }
              }
            ],
            "name": "number--4",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_424",
          "filepath": "number--4/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
                }
              }
            ],
            "name": "number--4",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_420",
          "filepath": "number--4/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
                }
              }
            ],
            "name": "number--4",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_416",
          "filepath": "number--4/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
                }
              }
            ],
            "name": "number--4",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_4",
        "global": "Number_4",
        "filepath": "Number_4.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--5",
      "friendlyName": "Number 5",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--5.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--5</title><path d=\"M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z\"/></svg>",
            "info": {},
            "path": "32/number--5.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_532",
          "filepath": "number--5/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "number--5",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_524",
          "filepath": "number--5/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "number--5",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_520",
          "filepath": "number--5/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "number--5",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_516",
          "filepath": "number--5/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "number--5",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_5",
        "global": "Number_5",
        "filepath": "Number_5.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--6",
      "friendlyName": "Number 6",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--6.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--6</title><path d=\"M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z\"/></svg>",
            "info": {},
            "path": "32/number--6.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_632",
          "filepath": "number--6/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
                }
              }
            ],
            "name": "number--6",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_624",
          "filepath": "number--6/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
                }
              }
            ],
            "name": "number--6",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_620",
          "filepath": "number--6/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
                }
              }
            ],
            "name": "number--6",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_616",
          "filepath": "number--6/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
                }
              }
            ],
            "name": "number--6",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_6",
        "global": "Number_6",
        "filepath": "Number_6.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--7",
      "friendlyName": "Number 7",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--7.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--7</title><polygon points=\"20 9 12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z\"/></svg>",
            "info": {},
            "path": "32/number--7.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_732",
          "filepath": "number--7/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
                }
              }
            ],
            "name": "number--7",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_724",
          "filepath": "number--7/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
                }
              }
            ],
            "name": "number--7",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_720",
          "filepath": "number--7/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
                }
              }
            ],
            "name": "number--7",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_716",
          "filepath": "number--7/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
                }
              }
            ],
            "name": "number--7",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_7",
        "global": "Number_7",
        "filepath": "Number_7.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--8",
      "friendlyName": "Number 8",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--8.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--8</title><path d=\"M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z\"/></svg>",
            "info": {},
            "path": "32/number--8.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_832",
          "filepath": "number--8/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
                }
              }
            ],
            "name": "number--8",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_824",
          "filepath": "number--8/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
                }
              }
            ],
            "name": "number--8",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_820",
          "filepath": "number--8/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
                }
              }
            ],
            "name": "number--8",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_816",
          "filepath": "number--8/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
                }
              }
            ],
            "name": "number--8",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_8",
        "global": "Number_8",
        "filepath": "Number_8.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--9",
      "friendlyName": "Number 9",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--9.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--9</title><path d=\"M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z\"/></svg>",
            "info": {},
            "path": "32/number--9.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Number_932",
          "filepath": "number--9/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
                }
              }
            ],
            "name": "number--9",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Number_924",
          "filepath": "number--9/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
                }
              }
            ],
            "name": "number--9",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Number_920",
          "filepath": "number--9/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
                }
              }
            ],
            "name": "number--9",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Number_916",
          "filepath": "number--9/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
                }
              }
            ],
            "name": "number--9",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Number_9",
        "global": "Number_9",
        "filepath": "Number_9.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--0",
      "friendlyName": "Number small 0",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--0.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--0</title><path d=\"M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z\"/></svg>",
            "info": {},
            "path": "32/number--small--0.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_032",
          "filepath": "number--small--0/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
                }
              }
            ],
            "name": "number--small--0",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_024",
          "filepath": "number--small--0/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
                }
              }
            ],
            "name": "number--small--0",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_020",
          "filepath": "number--small--0/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
                }
              }
            ],
            "name": "number--small--0",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_016",
          "filepath": "number--small--0/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
                }
              }
            ],
            "name": "number--small--0",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_0",
        "global": "NumberSmall_0",
        "filepath": "NumberSmall_0.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--1",
      "friendlyName": "Number small 1",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--1</title><polygon points=\"17 19 17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z\"/></svg>",
            "info": {},
            "path": "32/number--small--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_132",
          "filepath": "number--small--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "number--small--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_124",
          "filepath": "number--small--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "number--small--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_120",
          "filepath": "number--small--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "number--small--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_116",
          "filepath": "number--small--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "number--small--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_1",
        "global": "NumberSmall_1",
        "filepath": "NumberSmall_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--2",
      "friendlyName": "Number small 2",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--2</title><path d=\"M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z\"/></svg>",
            "info": {},
            "path": "32/number--small--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_232",
          "filepath": "number--small--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
                }
              }
            ],
            "name": "number--small--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_224",
          "filepath": "number--small--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
                }
              }
            ],
            "name": "number--small--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_220",
          "filepath": "number--small--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
                }
              }
            ],
            "name": "number--small--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_216",
          "filepath": "number--small--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
                }
              }
            ],
            "name": "number--small--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_2",
        "global": "NumberSmall_2",
        "filepath": "NumberSmall_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--3",
      "friendlyName": "Number small 3",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--3</title><path d=\"M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z\"/></svg>",
            "info": {},
            "path": "32/number--small--3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_332",
          "filepath": "number--small--3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
                }
              }
            ],
            "name": "number--small--3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_324",
          "filepath": "number--small--3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
                }
              }
            ],
            "name": "number--small--3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_320",
          "filepath": "number--small--3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
                }
              }
            ],
            "name": "number--small--3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_316",
          "filepath": "number--small--3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
                }
              }
            ],
            "name": "number--small--3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_3",
        "global": "NumberSmall_3",
        "filepath": "NumberSmall_3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--4",
      "friendlyName": "Number small 4",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--4.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--4</title><polygon points=\"17 11 17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z\"/></svg>",
            "info": {},
            "path": "32/number--small--4.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_432",
          "filepath": "number--small--4/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
                }
              }
            ],
            "name": "number--small--4",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_424",
          "filepath": "number--small--4/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
                }
              }
            ],
            "name": "number--small--4",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_420",
          "filepath": "number--small--4/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
                }
              }
            ],
            "name": "number--small--4",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_416",
          "filepath": "number--small--4/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
                }
              }
            ],
            "name": "number--small--4",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_4",
        "global": "NumberSmall_4",
        "filepath": "NumberSmall_4.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--5",
      "friendlyName": "Number small 5",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--5.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--5</title><path d=\"M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z\"/></svg>",
            "info": {},
            "path": "32/number--small--5.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_532",
          "filepath": "number--small--5/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
                }
              }
            ],
            "name": "number--small--5",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_524",
          "filepath": "number--small--5/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
                }
              }
            ],
            "name": "number--small--5",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_520",
          "filepath": "number--small--5/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
                }
              }
            ],
            "name": "number--small--5",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_516",
          "filepath": "number--small--5/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
                }
              }
            ],
            "name": "number--small--5",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_5",
        "global": "NumberSmall_5",
        "filepath": "NumberSmall_5.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--6",
      "friendlyName": "Number small 6",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--6.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--6</title><path d=\"M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z\"/></svg>",
            "info": {},
            "path": "32/number--small--6.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_632",
          "filepath": "number--small--6/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
                }
              }
            ],
            "name": "number--small--6",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_624",
          "filepath": "number--small--6/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
                }
              }
            ],
            "name": "number--small--6",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_620",
          "filepath": "number--small--6/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
                }
              }
            ],
            "name": "number--small--6",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_616",
          "filepath": "number--small--6/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
                }
              }
            ],
            "name": "number--small--6",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_6",
        "global": "NumberSmall_6",
        "filepath": "NumberSmall_6.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--7",
      "friendlyName": "Number small 7",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--7.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--7</title><polygon points=\"16.44 21 14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z\"/></svg>",
            "info": {},
            "path": "32/number--small--7.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_732",
          "filepath": "number--small--7/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
                }
              }
            ],
            "name": "number--small--7",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_724",
          "filepath": "number--small--7/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
                }
              }
            ],
            "name": "number--small--7",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_720",
          "filepath": "number--small--7/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
                }
              }
            ],
            "name": "number--small--7",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_716",
          "filepath": "number--small--7/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
                }
              }
            ],
            "name": "number--small--7",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_7",
        "global": "NumberSmall_7",
        "filepath": "NumberSmall_7.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--8",
      "friendlyName": "Number small 8",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--8.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--8</title><path d=\"M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z\"/></svg>",
            "info": {},
            "path": "32/number--small--8.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_832",
          "filepath": "number--small--8/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
                }
              }
            ],
            "name": "number--small--8",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_824",
          "filepath": "number--small--8/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
                }
              }
            ],
            "name": "number--small--8",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_820",
          "filepath": "number--small--8/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
                }
              }
            ],
            "name": "number--small--8",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_816",
          "filepath": "number--small--8/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
                }
              }
            ],
            "name": "number--small--8",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_8",
        "global": "NumberSmall_8",
        "filepath": "NumberSmall_8.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "number--small--9",
      "friendlyName": "Number small 9",
      "aliases": [
        "count",
        "numeral",
        "digit",
        "statistic",
        "figure",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/number--small--9.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>number--small--9</title><path d=\"M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z\"/></svg>",
            "info": {},
            "path": "32/number--small--9.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "NumberSmall_932",
          "filepath": "number--small--9/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
                }
              }
            ],
            "name": "number--small--9",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "NumberSmall_924",
          "filepath": "number--small--9/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
                }
              }
            ],
            "name": "number--small--9",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "NumberSmall_920",
          "filepath": "number--small--9/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
                }
              }
            ],
            "name": "number--small--9",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "NumberSmall_916",
          "filepath": "number--small--9/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
                }
              }
            ],
            "name": "number--small--9",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "NumberSmall_9",
        "global": "NumberSmall_9",
        "filepath": "NumberSmall_9.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "object-storage",
      "friendlyName": "Object storage",
      "aliases": [
        "object",
        "storage"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/object-storage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <path d=\"M30,8H22v6H16v8h8V16h6ZM22,20H18V16h4Zm6-6H24V10h4Z\"/>\n  <path d=\"M18,10H10V2h8ZM12,8h4V4H12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z\"/></svg>",
            "info": {},
            "path": "32/object-storage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ObjectStorage32",
          "filepath": "object-storage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z"
                }
              }
            ],
            "name": "object-storage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ObjectStorage24",
          "filepath": "object-storage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z"
                }
              }
            ],
            "name": "object-storage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ObjectStorage20",
          "filepath": "object-storage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z"
                }
              }
            ],
            "name": "object-storage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ObjectStorage16",
          "filepath": "object-storage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z"
                }
              }
            ],
            "name": "object-storage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "ObjectStorage",
        "global": "ObjectStorage",
        "filepath": "ObjectStorage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "object-storage--alt",
      "friendlyName": "Object storage alt",
      "aliases": [
        "object",
        "storage"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/object-storage--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <path d=\"M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z\"/></svg>",
            "info": {},
            "path": "32/object-storage--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ObjectStorageAlt32",
          "filepath": "object-storage--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
                }
              }
            ],
            "name": "object-storage--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ObjectStorageAlt24",
          "filepath": "object-storage--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
                }
              }
            ],
            "name": "object-storage--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ObjectStorageAlt20",
          "filepath": "object-storage--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
                }
              }
            ],
            "name": "object-storage--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ObjectStorageAlt16",
          "filepath": "object-storage--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
                }
              }
            ],
            "name": "object-storage--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ObjectStorageAlt",
        "global": "ObjectStorageAlt",
        "filepath": "ObjectStorageAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "observed--hail",
      "friendlyName": "Observed hail",
      "aliases": [
        "weather",
        "observed",
        "hail",
        "warning",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/observed--hail.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"13.5\" cy=\"23.5\" r=\"1.5\"/>\n  <circle cx=\"10.5\" cy=\"19.5\" r=\"1.5\"/>\n  <circle cx=\"16.5\" cy=\"19.5\" r=\"1.5\"/>\n  <rect x=\"11.9644\" y=\"14.5001\" width=\"5.0716\" height=\"1.9994\" transform=\"translate(-6.713 14.793) rotate(-45)\"/>\n  <rect x=\"17.9644\" y=\"14.5001\" width=\"5.0716\" height=\"1.9994\" transform=\"translate(-4.9556 19.0356) rotate(-45)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/><circle cx=\"13.5\" cy=\"23.5\" r=\"1.5\"/><circle cx=\"10.5\" cy=\"19.5\" r=\"1.5\"/><circle cx=\"16.5\" cy=\"19.5\" r=\"1.5\"/><path d=\"M11.964 14.5H17.036V16.499H11.964z\" transform=\"rotate(-45 14.5 15.5)\"/><path d=\"M17.964 14.5H23.035999999999998V16.499H17.964z\" transform=\"rotate(-45 20.5 15.5)\"/></svg>",
            "info": {},
            "path": "32/observed--hail.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ObservedHail32",
          "filepath": "observed--hail/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.964 14.5H17.036V16.499H11.964z",
                  "transform": "rotate(-45 14.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.964 14.5H23.035999999999998V16.499H17.964z",
                  "transform": "rotate(-45 20.5 15.5)"
                }
              }
            ],
            "name": "observed--hail",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ObservedHail24",
          "filepath": "observed--hail/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.964 14.5H17.036V16.499H11.964z",
                  "transform": "rotate(-45 14.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.964 14.5H23.035999999999998V16.499H17.964z",
                  "transform": "rotate(-45 20.5 15.5)"
                }
              }
            ],
            "name": "observed--hail",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ObservedHail20",
          "filepath": "observed--hail/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.964 14.5H17.036V16.499H11.964z",
                  "transform": "rotate(-45 14.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.964 14.5H23.035999999999998V16.499H17.964z",
                  "transform": "rotate(-45 20.5 15.5)"
                }
              }
            ],
            "name": "observed--hail",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ObservedHail16",
          "filepath": "observed--hail/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13.5",
                  "cy": "23.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16.5",
                  "cy": "19.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.964 14.5H17.036V16.499H11.964z",
                  "transform": "rotate(-45 14.5 15.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.964 14.5H23.035999999999998V16.499H17.964z",
                  "transform": "rotate(-45 20.5 15.5)"
                }
              }
            ],
            "name": "observed--hail",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ObservedHail",
        "global": "ObservedHail",
        "filepath": "ObservedHail.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13.5",
                    "cy": "23.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16.5",
                    "cy": "19.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.964 14.5H17.036V16.499H11.964z",
                    "transform": "rotate(-45 14.5 15.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.964 14.5H23.035999999999998V16.499H17.964z",
                    "transform": "rotate(-45 20.5 15.5)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "observed--lightning",
      "friendlyName": "Observed lightning",
      "aliases": [
        "weather",
        "observed",
        "lightning",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/observed--lightning.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"15.67 24 13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24\"/>\n  <path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z\"/><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/></svg>",
            "info": {},
            "path": "32/observed--lightning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ObservedLightning32",
          "filepath": "observed--lightning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "observed--lightning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ObservedLightning24",
          "filepath": "observed--lightning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "observed--lightning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ObservedLightning20",
          "filepath": "observed--lightning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "observed--lightning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ObservedLightning16",
          "filepath": "observed--lightning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              }
            ],
            "name": "observed--lightning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ObservedLightning",
        "global": "ObservedLightning",
        "filepath": "ObservedLightning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "omega",
      "friendlyName": "Omega",
      "aliases": [
        "omega",
        "alphanumeric"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/omega.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z\"/></svg>",
            "info": {},
            "path": "32/omega.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Omega32",
          "filepath": "omega/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
                }
              }
            ],
            "name": "omega",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Omega24",
          "filepath": "omega/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
                }
              }
            ],
            "name": "omega",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Omega20",
          "filepath": "omega/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
                }
              }
            ],
            "name": "omega",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Omega16",
          "filepath": "omega/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
                }
              }
            ],
            "name": "omega",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Omega",
        "global": "Omega",
        "filepath": "Omega.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "opacity",
      "friendlyName": "Opacity",
      "aliases": [
        "transparency",
        "dim",
        "darkness",
        "shade",
        "color",
        "gradient",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/opacity.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>opacity</title><rect x=\"6\" y=\"6\" width=\"4\" height=\"4\"/><rect x=\"10\" y=\"10\" width=\"4\" height=\"4\"/><rect x=\"14\" y=\"6\" width=\"4\" height=\"4\"/><rect x=\"22\" y=\"6\" width=\"4\" height=\"4\"/><rect x=\"6\" y=\"14\" width=\"4\" height=\"4\"/><rect x=\"14\" y=\"14\" width=\"4\" height=\"4\"/><rect x=\"22\" y=\"14\" width=\"4\" height=\"4\"/><rect x=\"6\" y=\"22\" width=\"4\" height=\"4\"/><rect x=\"14\" y=\"22\" width=\"4\" height=\"4\"/><rect x=\"22\" y=\"22\" width=\"4\" height=\"4\"/><rect x=\"18\" y=\"10\" width=\"4\" height=\"4\"/><rect x=\"10\" y=\"18\" width=\"4\" height=\"4\"/><rect x=\"18\" y=\"18\" width=\"4\" height=\"4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z\"/></svg>",
            "info": {},
            "path": "32/opacity.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Opacity32",
          "filepath": "opacity/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z"
                }
              }
            ],
            "name": "opacity",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Opacity24",
          "filepath": "opacity/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z"
                }
              }
            ],
            "name": "opacity",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Opacity20",
          "filepath": "opacity/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z"
                }
              }
            ],
            "name": "opacity",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Opacity16",
          "filepath": "opacity/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z"
                }
              }
            ],
            "name": "opacity",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Opacity",
        "global": "Opacity",
        "filepath": "Opacity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--bottom",
      "friendlyName": "Open panel bottom",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--bottom.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--bottom</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--bottom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelBottom32",
          "filepath": "open-panel--bottom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
                }
              }
            ],
            "name": "open-panel--bottom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelBottom24",
          "filepath": "open-panel--bottom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
                }
              }
            ],
            "name": "open-panel--bottom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelBottom20",
          "filepath": "open-panel--bottom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
                }
              }
            ],
            "name": "open-panel--bottom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelBottom16",
          "filepath": "open-panel--bottom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
                }
              }
            ],
            "name": "open-panel--bottom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelBottom",
        "global": "OpenPanelBottom",
        "filepath": "OpenPanelBottom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--filled--bottom",
      "friendlyName": "Open panel filled bottom",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--filled--bottom.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--solid--bottom</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--filled--bottom.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelFilledBottom32",
          "filepath": "open-panel--filled--bottom/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
                }
              }
            ],
            "name": "open-panel--filled--bottom",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelFilledBottom24",
          "filepath": "open-panel--filled--bottom/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
                }
              }
            ],
            "name": "open-panel--filled--bottom",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelFilledBottom20",
          "filepath": "open-panel--filled--bottom/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
                }
              }
            ],
            "name": "open-panel--filled--bottom",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelFilledBottom16",
          "filepath": "open-panel--filled--bottom/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
                }
              }
            ],
            "name": "open-panel--filled--bottom",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelFilledBottom",
        "global": "OpenPanelFilledBottom",
        "filepath": "OpenPanelFilledBottom.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--filled--left",
      "friendlyName": "Open panel filled left",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--filled--left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--solid--left</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--filled--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelFilledLeft32",
          "filepath": "open-panel--filled--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--filled--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelFilledLeft24",
          "filepath": "open-panel--filled--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--filled--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelFilledLeft20",
          "filepath": "open-panel--filled--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--filled--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelFilledLeft16",
          "filepath": "open-panel--filled--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--filled--left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelFilledLeft",
        "global": "OpenPanelFilledLeft",
        "filepath": "OpenPanelFilledLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--filled--right",
      "friendlyName": "Open panel filled right",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--filled--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--solid--right</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--filled--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelFilledRight32",
          "filepath": "open-panel--filled--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
                }
              }
            ],
            "name": "open-panel--filled--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelFilledRight24",
          "filepath": "open-panel--filled--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
                }
              }
            ],
            "name": "open-panel--filled--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelFilledRight20",
          "filepath": "open-panel--filled--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
                }
              }
            ],
            "name": "open-panel--filled--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelFilledRight16",
          "filepath": "open-panel--filled--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
                }
              }
            ],
            "name": "open-panel--filled--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelFilledRight",
        "global": "OpenPanelFilledRight",
        "filepath": "OpenPanelFilledRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--filled--top",
      "friendlyName": "Open panel filled top",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--filled--top.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--solid--top</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--filled--top.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelFilledTop32",
          "filepath": "open-panel--filled--top/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--filled--top",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelFilledTop24",
          "filepath": "open-panel--filled--top/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--filled--top",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelFilledTop20",
          "filepath": "open-panel--filled--top/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--filled--top",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelFilledTop16",
          "filepath": "open-panel--filled--top/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--filled--top",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelFilledTop",
        "global": "OpenPanelFilledTop",
        "filepath": "OpenPanelFilledTop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--left",
      "friendlyName": "Open panel left",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--left</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelLeft32",
          "filepath": "open-panel--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelLeft24",
          "filepath": "open-panel--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelLeft20",
          "filepath": "open-panel--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelLeft16",
          "filepath": "open-panel--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
                }
              }
            ],
            "name": "open-panel--left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelLeft",
        "global": "OpenPanelLeft",
        "filepath": "OpenPanelLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--right",
      "friendlyName": "Open panel right",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--right</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelRight32",
          "filepath": "open-panel--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
                }
              }
            ],
            "name": "open-panel--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelRight24",
          "filepath": "open-panel--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
                }
              }
            ],
            "name": "open-panel--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelRight20",
          "filepath": "open-panel--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
                }
              }
            ],
            "name": "open-panel--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelRight16",
          "filepath": "open-panel--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
                }
              }
            ],
            "name": "open-panel--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelRight",
        "global": "OpenPanelRight",
        "filepath": "OpenPanelRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "open-panel--top",
      "friendlyName": "Open panel top",
      "aliases": [
        "open",
        "panel",
        "navigation",
        "side nav",
        "ui",
        "nav",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/open-panel--top.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>open-panel--top</title><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z\"/></svg>",
            "info": {},
            "path": "32/open-panel--top.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OpenPanelTop32",
          "filepath": "open-panel--top/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--top",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OpenPanelTop24",
          "filepath": "open-panel--top/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--top",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OpenPanelTop20",
          "filepath": "open-panel--top/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--top",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OpenPanelTop16",
          "filepath": "open-panel--top/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
                }
              }
            ],
            "name": "open-panel--top",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "OpenPanelTop",
        "global": "OpenPanelTop",
        "filepath": "OpenPanelTop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "operation",
      "friendlyName": "Operation",
      "aliases": [
        "meter",
        "gauge",
        "indicator",
        "bracket",
        "research"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/operation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--operation</title><polygon points=\"23 26 21 26 26 16 21 6 23 6 28 16 23 26\"/><rect x=\"4\" y=\"6\" width=\"2\" height=\"20\"/><path d=\"M16,9H12a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,16,9Zm0,12H12V11h4Z\"/><rect x=\"13\" y=\"15\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z\"/><path d=\"M13 15H15V17H13z\"/></svg>",
            "info": {},
            "path": "32/Q/operation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QOperation32",
          "filepath": "Q/operation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15H15V17H13z"
                }
              }
            ],
            "name": "operation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QOperation24",
          "filepath": "Q/operation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15H15V17H13z"
                }
              }
            ],
            "name": "operation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QOperation20",
          "filepath": "Q/operation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15H15V17H13z"
                }
              }
            ],
            "name": "operation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QOperation16",
          "filepath": "Q/operation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 15H15V17H13z"
                }
              }
            ],
            "name": "operation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "Operation",
        "global": "QOperation",
        "filepath": "Q/Operation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 15H15V17H13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "operation--gauge",
      "friendlyName": "Operation gauge",
      "aliases": [
        "meter",
        "gauge",
        "indicator",
        "bracket",
        "resear"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/operation--gauge.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--operation--gauge</title><polygon points=\"30 4 24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4\"/><path d=\"M20,17.62,22.08,14l-1.73-1-2.18,3.76A12,12,0,0,0,2,28H4a10,10,0,0,1,13.16-9.48L14,24a2,2,0,1,0,2,2,2,2,0,0,0-.27-1L19,19.35A10,10,0,0,1,24,28h2A12,12,0,0,0,20,17.62Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z\"/></svg>",
            "info": {},
            "path": "32/Q/operation--gauge.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QOperationGauge32",
          "filepath": "Q/operation--gauge/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z"
                }
              }
            ],
            "name": "operation--gauge",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QOperationGauge24",
          "filepath": "Q/operation--gauge/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z"
                }
              }
            ],
            "name": "operation--gauge",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QOperationGauge20",
          "filepath": "Q/operation--gauge/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z"
                }
              }
            ],
            "name": "operation--gauge",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QOperationGauge16",
          "filepath": "Q/operation--gauge/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z"
                }
              }
            ],
            "name": "operation--gauge",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "OperationGauge",
        "global": "QOperationGauge",
        "filepath": "Q/OperationGauge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "operation--if",
      "friendlyName": "Operation if",
      "aliases": [
        "meter",
        "gauge",
        "indicator",
        "bracket",
        "research"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/operation--if.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--operation--if</title><rect x=\"12\" y=\"13\" width=\"2\" height=\"10\"/><rect x=\"12\" y=\"9\" width=\"2\" height=\"2\"/><path d=\"M23,11V9H20a2,2,0,0,0-2,2v2H16v2h2v8h2V15h3V13H20V11Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z\"/></svg>",
            "info": {},
            "path": "32/Q/operation--if.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QOperationIf32",
          "filepath": "Q/operation--if/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z"
                }
              }
            ],
            "name": "operation--if",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QOperationIf24",
          "filepath": "Q/operation--if/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z"
                }
              }
            ],
            "name": "operation--if",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QOperationIf20",
          "filepath": "Q/operation--if/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z"
                }
              }
            ],
            "name": "operation--if",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QOperationIf16",
          "filepath": "Q/operation--if/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z"
                }
              }
            ],
            "name": "operation--if",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "OperationIf",
        "global": "QOperationIf",
        "filepath": "Q/OperationIf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "operations--field",
      "friendlyName": "Operations field",
      "aliases": [
        "field",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/operations--field.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>operations--field</title><rect x=\"16\" y=\"6\" width=\"10\" height=\"2\" transform=\"translate(14 28) rotate(-90)\"/><rect x=\"20\" y=\"6\" width=\"10\" height=\"2\" transform=\"translate(18 32) rotate(-90)\"/><rect x=\"24\" y=\"6\" width=\"10\" height=\"2\" transform=\"translate(22 36) rotate(-90)\"/><path d=\"M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z\"/><path d=\"M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 6H26V8H16z\" transform=\"rotate(-90 21 7)\"/><path d=\"M20 6H30V8H20z\" transform=\"rotate(-90 25 7)\"/><path d=\"M24 6H34V8H24z\" transform=\"rotate(-90 29 7)\"/><path d=\"M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z\"/><path d=\"M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z\"/></svg>",
            "info": {},
            "path": "32/operations--field.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OperationsField32",
          "filepath": "operations--field/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H26V8H16z",
                  "transform": "rotate(-90 21 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20z",
                  "transform": "rotate(-90 25 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 6H34V8H24z",
                  "transform": "rotate(-90 29 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
                }
              }
            ],
            "name": "operations--field",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OperationsField24",
          "filepath": "operations--field/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H26V8H16z",
                  "transform": "rotate(-90 21 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20z",
                  "transform": "rotate(-90 25 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 6H34V8H24z",
                  "transform": "rotate(-90 29 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
                }
              }
            ],
            "name": "operations--field",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OperationsField20",
          "filepath": "operations--field/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H26V8H16z",
                  "transform": "rotate(-90 21 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20z",
                  "transform": "rotate(-90 25 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 6H34V8H24z",
                  "transform": "rotate(-90 29 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
                }
              }
            ],
            "name": "operations--field",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OperationsField16",
          "filepath": "operations--field/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 6H26V8H16z",
                  "transform": "rotate(-90 21 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20z",
                  "transform": "rotate(-90 25 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 6H34V8H24z",
                  "transform": "rotate(-90 29 7)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
                }
              }
            ],
            "name": "operations--field",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "OperationsField",
        "global": "OperationsField",
        "filepath": "OperationsField.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 6H26V8H16z",
                    "transform": "rotate(-90 21 7)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 6H30V8H20z",
                    "transform": "rotate(-90 25 7)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 6H34V8H24z",
                    "transform": "rotate(-90 29 7)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "operations--record",
      "friendlyName": "Operations record",
      "aliases": [
        "operations",
        "record",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/operations--record.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>operations--record</title><rect x=\"20\" y=\"20\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"24\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"28\" width=\"10\" height=\"2\"/><path d=\"M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4,3.9123,3.9123,0,0,1,4,4h2a6,6,0,1,0-6,6Z\"/><path d=\"M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z\"/><path d=\"M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z\"/></svg>",
            "info": {},
            "path": "32/operations--record.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OperationsRecord32",
          "filepath": "operations--record/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "operations--record",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OperationsRecord24",
          "filepath": "operations--record/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "operations--record",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OperationsRecord20",
          "filepath": "operations--record/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "operations--record",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OperationsRecord16",
          "filepath": "operations--record/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "operations--record",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "OperationsRecord",
        "global": "OperationsRecord",
        "filepath": "OperationsRecord.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "order-details",
      "friendlyName": "Order details",
      "aliases": [
        "order",
        "details",
        "file",
        "record",
        "customer history"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/order-details.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19,21H13a3,3,0,0,0-3,3v2h2V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V24A3,3,0,0,0,19,21Z\"/>\n  <path d=\"M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z\"/>\n  <path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/></svg>",
            "info": {},
            "path": "32/order-details.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OrderDetails32",
          "filepath": "order-details/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "order-details",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OrderDetails24",
          "filepath": "order-details/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "order-details",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OrderDetails20",
          "filepath": "order-details/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "order-details",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OrderDetails16",
          "filepath": "order-details/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "order-details",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "OrderDetails",
        "global": "OrderDetails",
        "filepath": "OrderDetails.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ordinal",
      "friendlyName": "Ordinal",
      "aliases": [
        "ordinal data",
        "data"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/ordinal.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 61 (89581) - https://sketch.com -->\n    <title>Ordinal 16</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"Ordinal-16\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z\" id=\"Combined-Shape\" fill=\"#000000\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z\"/></svg>",
            "info": {},
            "path": "16/ordinal.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/ordinal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ordinal</title><path d=\"M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z\"/></svg>",
            "info": {},
            "path": "32/ordinal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Ordinal32",
          "filepath": "ordinal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
                }
              }
            ],
            "name": "ordinal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Ordinal24",
          "filepath": "ordinal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
                }
              }
            ],
            "name": "ordinal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Ordinal20",
          "filepath": "ordinal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
                }
              }
            ],
            "name": "ordinal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Ordinal16",
          "filepath": "ordinal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z"
                }
              }
            ],
            "name": "ordinal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Ordinal",
        "global": "Ordinal",
        "filepath": "Ordinal.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "outage",
      "friendlyName": "Outage",
      "aliases": [
        "outage",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/outage.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"12\" y=\"24\" width=\"9\" height=\"2\"/>\n  <rect x=\"13\" y=\"28\" width=\"6\" height=\"2\"/>\n  <path d=\"M8.7832,18.9746l1.4177-1.418A6.9206,6.9206,0,0,1,8,12,7.99,7.99,0,0,1,21.5273,6.2305l1.4136-1.4136A9.9884,9.9884,0,0,0,6,12,8.9411,8.9411,0,0,0,8.7832,18.9746Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,3.4141,28.5859,2,2,28.5859,3.4141,30,23.6606,9.7534A7.7069,7.7069,0,0,1,24,12a7.2032,7.2032,0,0,1-2.8223,6.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.193,9.193,0,0,0,26,12a9.8739,9.8739,0,0,0-.7764-3.81Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 24H21V26H12zM13 28H19V30H13z\"/><path d=\"M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z\"/></svg>",
            "info": {},
            "path": "32/outage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Outage32",
          "filepath": "outage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24H21V26H12zM13 28H19V30H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z"
                }
              }
            ],
            "name": "outage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Outage24",
          "filepath": "outage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24H21V26H12zM13 28H19V30H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z"
                }
              }
            ],
            "name": "outage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Outage20",
          "filepath": "outage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24H21V26H12zM13 28H19V30H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z"
                }
              }
            ],
            "name": "outage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Outage16",
          "filepath": "outage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 24H21V26H12zM13 28H19V30H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z"
                }
              }
            ],
            "name": "outage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Outage",
        "global": "Outage",
        "filepath": "Outage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 24H21V26H12zM13 28H19V30H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "outlook-severe",
      "friendlyName": "Outlook severe",
      "aliases": [
        "outlook",
        "severe",
        "weather",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/outlook-severe.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z\"/><path d=\"M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z\"/></svg>",
            "info": {},
            "path": "32/outlook-severe.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OutlookSevere32",
          "filepath": "outlook-severe/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
                }
              }
            ],
            "name": "outlook-severe",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OutlookSevere24",
          "filepath": "outlook-severe/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
                }
              }
            ],
            "name": "outlook-severe",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OutlookSevere20",
          "filepath": "outlook-severe/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
                }
              }
            ],
            "name": "outlook-severe",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OutlookSevere16",
          "filepath": "outlook-severe/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
                }
              }
            ],
            "name": "outlook-severe",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "OutlookSevere",
        "global": "OutlookSevere",
        "filepath": "OutlookSevere.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "overflow-menu--horizontal",
      "friendlyName": "Overflow menu horizontal",
      "aliases": [
        "show more",
        "options",
        "extra",
        "hidden",
        "navigation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/overflow-menu--horizontal.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>overflow-menu--horizontal</title>\n<circle cx=\"8\" cy=\"16\" r=\"2\"/>\n<circle cx=\"16\" cy=\"16\" r=\"2\"/>\n<circle cx=\"24\" cy=\"16\" r=\"2\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"8\" cy=\"16\" r=\"2\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><circle cx=\"24\" cy=\"16\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/overflow-menu--horizontal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OverflowMenuHorizontal32",
          "filepath": "overflow-menu--horizontal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--horizontal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OverflowMenuHorizontal24",
          "filepath": "overflow-menu--horizontal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--horizontal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OverflowMenuHorizontal20",
          "filepath": "overflow-menu--horizontal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--horizontal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OverflowMenuHorizontal16",
          "filepath": "overflow-menu--horizontal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "16",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--horizontal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "OverflowMenuHorizontal",
        "global": "OverflowMenuHorizontal",
        "filepath": "OverflowMenuHorizontal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "overflow-menu--vertical",
      "friendlyName": "Overflow menu vertical",
      "aliases": [
        "show more",
        "options",
        "extra",
        "hidden",
        "navigation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/overflow-menu--vertical.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>overflow-menu--vertical</title>\n<circle cx=\"16\" cy=\"8\" r=\"2\"/>\n<circle cx=\"16\" cy=\"16\" r=\"2\"/>\n<circle cx=\"16\" cy=\"24\" r=\"2\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"8\" r=\"2\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><circle cx=\"16\" cy=\"24\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/overflow-menu--vertical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "OverflowMenuVertical32",
          "filepath": "overflow-menu--vertical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--vertical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "OverflowMenuVertical24",
          "filepath": "overflow-menu--vertical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--vertical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "OverflowMenuVertical20",
          "filepath": "overflow-menu--vertical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--vertical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "OverflowMenuVertical16",
          "filepath": "overflow-menu--vertical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              }
            ],
            "name": "overflow-menu--vertical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "OverflowMenuVertical",
        "global": "OverflowMenuVertical",
        "filepath": "OverflowMenuVertical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "8",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "overlay",
      "friendlyName": "Overlay",
      "aliases": [
        "overlay",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/overlay.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z\"/></svg>",
            "info": {},
            "path": "32/overlay.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Overlay32",
          "filepath": "overlay/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
                }
              }
            ],
            "name": "overlay",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Overlay24",
          "filepath": "overlay/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
                }
              }
            ],
            "name": "overlay",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Overlay20",
          "filepath": "overlay/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
                }
              }
            ],
            "name": "overlay",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Overlay16",
          "filepath": "overlay/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
                }
              }
            ],
            "name": "overlay",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Overlay",
        "global": "Overlay",
        "filepath": "Overlay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "package",
      "friendlyName": "Package",
      "aliases": [
        "download",
        "kit",
        "packet",
        "assortment",
        "bunch",
        "load",
        "group",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/package.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>package</title><path d=\"M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z\"/><rect x=\"13\" y=\"20\" width=\"6\" height=\"2\"/><polygon points=\"20.59 8.59 17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z\"/><path d=\"M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z\"/></svg>",
            "info": {},
            "path": "32/package.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Package32",
          "filepath": "package/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
                }
              }
            ],
            "name": "package",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Package24",
          "filepath": "package/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
                }
              }
            ],
            "name": "package",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Package20",
          "filepath": "package/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
                }
              }
            ],
            "name": "package",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Package16",
          "filepath": "package/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
                }
              }
            ],
            "name": "package",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Package",
        "global": "Package",
        "filepath": "Package.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "page--first",
      "friendlyName": "Page first",
      "aliases": [
        "next",
        "forward",
        "backward",
        "read",
        "back",
        "navigation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/page--first.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"14,16 24,6 25.4,7.4 16.8,16 25.4,24.6 24,26 \"/>\n<rect x=\"8\" y=\"4\" width=\"2\" height=\"24\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z\"/></svg>",
            "info": {},
            "path": "32/page--first.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PageFirst32",
          "filepath": "page--first/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
                }
              }
            ],
            "name": "page--first",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PageFirst24",
          "filepath": "page--first/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
                }
              }
            ],
            "name": "page--first",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PageFirst20",
          "filepath": "page--first/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
                }
              }
            ],
            "name": "page--first",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PageFirst16",
          "filepath": "page--first/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
                }
              }
            ],
            "name": "page--first",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "PageFirst",
        "global": "PageFirst",
        "filepath": "PageFirst.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "page--last",
      "friendlyName": "Page last",
      "aliases": [
        "next",
        "forward",
        "backward",
        "read",
        "back",
        "navigation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/page--last.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"18,16 8,26 6.6,24.6 15.2,16 6.6,7.4 8,6 \"/>\n<rect x=\"22\" y=\"4\" width=\"2\" height=\"24\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z\"/></svg>",
            "info": {},
            "path": "32/page--last.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PageLast32",
          "filepath": "page--last/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
                }
              }
            ],
            "name": "page--last",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PageLast24",
          "filepath": "page--last/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
                }
              }
            ],
            "name": "page--last",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PageLast20",
          "filepath": "page--last/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
                }
              }
            ],
            "name": "page--last",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PageLast16",
          "filepath": "page--last/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
                }
              }
            ],
            "name": "page--last",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "PageLast",
        "global": "PageLast",
        "filepath": "PageLast.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "page-break",
      "friendlyName": "Page break",
      "aliases": [
        "page",
        "break",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/page-break.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"26\" y=\"18\" width=\"4\" height=\"2\"/>\n  <path d=\"M24,22v6H8V22H6v6a2.0058,2.0058,0,0,0,2,2H24a2.0058,2.0058,0,0,0,2-2V22Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8,16V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V16ZM18,4.4,23.6,10H18Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"10\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect x=\"18\" y=\"18\" width=\"4\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z\"/></svg>",
            "info": {},
            "path": "32/page-break.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PageBreak32",
          "filepath": "page-break/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
                }
              }
            ],
            "name": "page-break",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PageBreak24",
          "filepath": "page-break/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
                }
              }
            ],
            "name": "page-break",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PageBreak20",
          "filepath": "page-break/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
                }
              }
            ],
            "name": "page-break",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PageBreak16",
          "filepath": "page-break/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
                }
              }
            ],
            "name": "page-break",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "PageBreak",
        "global": "PageBreak",
        "filepath": "PageBreak.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "page-number",
      "friendlyName": "Page number",
      "aliases": [
        "page",
        "number",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/page-number.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 26 16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26\"/>\n  <path d=\"M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z\"/><path d=\"M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z\"/></svg>",
            "info": {},
            "path": "32/page-number.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PageNumber32",
          "filepath": "page-number/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "page-number",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PageNumber24",
          "filepath": "page-number/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "page-number",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PageNumber20",
          "filepath": "page-number/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "page-number",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PageNumber16",
          "filepath": "page-number/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                }
              }
            ],
            "name": "page-number",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "PageNumber",
        "global": "PageNumber",
        "filepath": "PageNumber.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "page-scroll",
      "friendlyName": "Page scroll",
      "aliases": [
        "pages",
        "stack",
        "flip",
        "browse",
        "shuffle",
        "sheets",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/page-scroll.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--page-scroll</title><path d=\"M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z\"/><path d=\"M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z\"/><path d=\"M26,14H24V6H16V4h8a1.89,1.89,0,0,1,2,2Z\"/><polygon points=\"24 17 24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z\"/><path d=\"M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z\"/><path d=\"M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z\"/></svg>",
            "info": {},
            "path": "32/watson-health/page-scroll.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthPageScroll32",
          "filepath": "watson-health/page-scroll/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
                }
              }
            ],
            "name": "page-scroll",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthPageScroll24",
          "filepath": "watson-health/page-scroll/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
                }
              }
            ],
            "name": "page-scroll",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthPageScroll20",
          "filepath": "watson-health/page-scroll/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
                }
              }
            ],
            "name": "page-scroll",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthPageScroll16",
          "filepath": "watson-health/page-scroll/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
                }
              }
            ],
            "name": "page-scroll",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "PageScroll",
        "global": "WatsonHealthPageScroll",
        "filepath": "watson-health/PageScroll.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "paint-brush",
      "friendlyName": "Paint brush",
      "aliases": [
        "brush",
        "paint",
        "color",
        "art",
        "artwork",
        "image",
        "portrait",
        "palette",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/paint-brush.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>paint-brush</title><path d=\"M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z\"/></svg>",
            "info": {},
            "path": "32/paint-brush.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PaintBrush32",
          "filepath": "paint-brush/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "paint-brush",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PaintBrush24",
          "filepath": "paint-brush/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "paint-brush",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PaintBrush20",
          "filepath": "paint-brush/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "paint-brush",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PaintBrush16",
          "filepath": "paint-brush/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "paint-brush",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "PaintBrush",
        "global": "PaintBrush",
        "filepath": "PaintBrush.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "paint-brush--alt",
      "friendlyName": "Paint brush alt",
      "aliases": [
        "brush",
        "paint",
        "color",
        "art",
        "artwork",
        "image",
        "portrait",
        "palette",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/paint-brush--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>paint-brush--alt</title><path d=\"M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z\"/></svg>",
            "info": {},
            "path": "32/paint-brush--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PaintBrushAlt32",
          "filepath": "paint-brush--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
                }
              }
            ],
            "name": "paint-brush--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PaintBrushAlt24",
          "filepath": "paint-brush--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
                }
              }
            ],
            "name": "paint-brush--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PaintBrushAlt20",
          "filepath": "paint-brush--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
                }
              }
            ],
            "name": "paint-brush--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PaintBrushAlt16",
          "filepath": "paint-brush--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
                }
              }
            ],
            "name": "paint-brush--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "PaintBrushAlt",
        "global": "PaintBrushAlt",
        "filepath": "PaintBrushAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "palm-tree",
      "friendlyName": "Palm tree",
      "aliases": [
        "palm tree",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/palm-tree.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z\"/></svg>",
            "info": {},
            "path": "32/palm-tree.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PalmTree32",
          "filepath": "palm-tree/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
                }
              }
            ],
            "name": "palm-tree",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PalmTree24",
          "filepath": "palm-tree/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
                }
              }
            ],
            "name": "palm-tree",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PalmTree20",
          "filepath": "palm-tree/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
                }
              }
            ],
            "name": "palm-tree",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PalmTree16",
          "filepath": "palm-tree/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
                }
              }
            ],
            "name": "palm-tree",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PalmTree",
        "global": "PalmTree",
        "filepath": "PalmTree.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pan--horizontal",
      "friendlyName": "Pan horizontal",
      "aliases": [
        "pan horizontal",
        "pan",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pan--horizontal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"24 10 22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z\"/></svg>",
            "info": {},
            "path": "32/pan--horizontal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PanHorizontal32",
          "filepath": "pan--horizontal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
                }
              }
            ],
            "name": "pan--horizontal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PanHorizontal24",
          "filepath": "pan--horizontal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
                }
              }
            ],
            "name": "pan--horizontal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PanHorizontal20",
          "filepath": "pan--horizontal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
                }
              }
            ],
            "name": "pan--horizontal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PanHorizontal16",
          "filepath": "pan--horizontal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
                }
              }
            ],
            "name": "pan--horizontal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "PanHorizontal",
        "global": "PanHorizontal",
        "filepath": "PanHorizontal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pan--vertical",
      "friendlyName": "Pan vertical",
      "aliases": [
        "pan vertical",
        "pan",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pan--vertical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"10 8 11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z\"/></svg>",
            "info": {},
            "path": "32/pan--vertical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PanVertical32",
          "filepath": "pan--vertical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
                }
              }
            ],
            "name": "pan--vertical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PanVertical24",
          "filepath": "pan--vertical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
                }
              }
            ],
            "name": "pan--vertical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PanVertical20",
          "filepath": "pan--vertical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
                }
              }
            ],
            "name": "pan--vertical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PanVertical16",
          "filepath": "pan--vertical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
                }
              }
            ],
            "name": "pan--vertical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "PanVertical",
        "global": "PanVertical",
        "filepath": "PanVertical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "panel-expansion",
      "friendlyName": "Panel expansion",
      "aliases": [
        "side",
        "navigation",
        "UI",
        "open",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/panel-expansion.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>panel-expansion</title><path d=\"M12,6H6A2,2,0,0,0,4,8v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V8A2,2,0,0,0,12,6ZM6,14V8h6v6Z\" transform=\"translate(0)\"/><path d=\"M26,6H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V8A2,2,0,0,0,26,6ZM20,24V8h6V24Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z\"/></svg>",
            "info": {},
            "path": "32/panel-expansion.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PanelExpansion32",
          "filepath": "panel-expansion/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
                }
              }
            ],
            "name": "panel-expansion",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PanelExpansion24",
          "filepath": "panel-expansion/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
                }
              }
            ],
            "name": "panel-expansion",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PanelExpansion20",
          "filepath": "panel-expansion/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
                }
              }
            ],
            "name": "panel-expansion",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PanelExpansion16",
          "filepath": "panel-expansion/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
                }
              }
            ],
            "name": "panel-expansion",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "PanelExpansion",
        "global": "PanelExpansion",
        "filepath": "PanelExpansion.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "paragraph",
      "friendlyName": "Paragraph",
      "aliases": [
        "paragraph",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/paragraph.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>paragraph</title><path class=\"cls-1\" d=\"M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z\"/></svg>",
            "info": {},
            "path": "32/paragraph.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Paragraph32",
          "filepath": "paragraph/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
                }
              }
            ],
            "name": "paragraph",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Paragraph24",
          "filepath": "paragraph/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
                }
              }
            ],
            "name": "paragraph",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Paragraph20",
          "filepath": "paragraph/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
                }
              }
            ],
            "name": "paragraph",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Paragraph16",
          "filepath": "paragraph/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
                }
              }
            ],
            "name": "paragraph",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Paragraph",
        "global": "Paragraph",
        "filepath": "Paragraph.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "parameter",
      "friendlyName": "Parameter",
      "aliases": [
        "parameter",
        "code",
        "snippet",
        "value",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/parameter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z\"/>\n  <path id=\"Combined-Shape\" class=\"cls-1\" d=\"M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z\"/>\n  <path d=\"M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z\"/><path fill-rule=\"evenodd\" d=\"M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z\"/><path d=\"M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z\"/></svg>",
            "info": {},
            "path": "32/parameter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Parameter32",
          "filepath": "parameter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
                }
              }
            ],
            "name": "parameter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Parameter24",
          "filepath": "parameter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
                }
              }
            ],
            "name": "parameter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Parameter20",
          "filepath": "parameter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
                }
              }
            ],
            "name": "parameter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Parameter16",
          "filepath": "parameter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill-rule": "evenodd",
                  "d": "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
                }
              }
            ],
            "name": "parameter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Parameter",
        "global": "Parameter",
        "filepath": "Parameter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill-rule": "evenodd",
                    "d": "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "parent-child",
      "friendlyName": "Parent child",
      "aliases": [
        "nested",
        "relation",
        "relationship",
        "tree",
        "org",
        "data",
        "hierarchy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/parent-child.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>parent-child</title><path d=\"M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z\"/></svg>",
            "info": {},
            "path": "32/parent-child.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ParentChild32",
          "filepath": "parent-child/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
                }
              }
            ],
            "name": "parent-child",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ParentChild24",
          "filepath": "parent-child/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
                }
              }
            ],
            "name": "parent-child",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ParentChild20",
          "filepath": "parent-child/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
                }
              }
            ],
            "name": "parent-child",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ParentChild16",
          "filepath": "parent-child/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
                }
              }
            ],
            "name": "parent-child",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ParentChild",
        "global": "ParentChild",
        "filepath": "ParentChild.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "partly-cloudy",
      "friendlyName": "Partly cloudy",
      "aliases": [
        "partly-cloudy",
        "weather",
        "sky"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/partly-cloudy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>partly-cloudy</title><rect x=\"27\" y=\"15\" width=\"4\" height=\"2\"/><rect x=\"23.0857\" y=\"5.7938\" width=\"4.2426\" height=\"1.9998\" transform=\"translate(2.5791 19.8139) rotate(-45)\"/><rect x=\"15\" y=\"1\" width=\"2\" height=\"4\"/><rect x=\"4.6716\" y=\"24.2078\" width=\"4.2426\" height=\"1.9998\" transform=\"translate(-15.8349 12.1865) rotate(-45)\"/><rect x=\"5.7931\" y=\"4.6723\" width=\"1.9998\" height=\"4.2426\" transform=\"translate(-2.8142 6.7932) rotate(-45)\"/><rect x=\"1\" y=\"15\" width=\"4\" height=\"2\"/><path d=\"M26.7939,20.3418a6.9617,6.9617,0,0,0-1.8681-3.2671A8.485,8.485,0,0,0,25,16a9,9,0,1,0-14.585,7.0332A4.9771,4.9771,0,0,0,15,30H25a4.9947,4.9947,0,0,0,1.7939-9.6582ZM9,16a6.9955,6.9955,0,0,1,13.9849-.2969A6.8883,6.8883,0,0,0,20,15a7.04,7.04,0,0,0-6.7944,5.3418A4.986,4.986,0,0,0,11.5618,21.39,6.9675,6.9675,0,0,1,9,16ZM25,28H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 15H31V17H27z\"/><path d=\"M23.086 5.794H27.329V7.794H23.086z\" transform=\"rotate(-45 25.207 6.794)\"/><path d=\"M15 1H17V5H15z\"/><path d=\"M4.672 24.208H8.915V26.208H4.672z\" transform=\"rotate(-45 6.793 25.208)\"/><path d=\"M5.793 4.672H7.793V8.915H5.793z\" transform=\"rotate(-45 6.793 6.794)\"/><path d=\"M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z\"/></svg>",
            "info": {},
            "path": "32/partly-cloudy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PartlyCloudy32",
          "filepath": "partly-cloudy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H31V17H27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.086 5.794H27.329V7.794H23.086z",
                  "transform": "rotate(-45 25.207 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 1H17V5H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.672 24.208H8.915V26.208H4.672z",
                  "transform": "rotate(-45 6.793 25.208)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.793 4.672H7.793V8.915H5.793z",
                  "transform": "rotate(-45 6.793 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
                }
              }
            ],
            "name": "partly-cloudy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PartlyCloudy24",
          "filepath": "partly-cloudy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H31V17H27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.086 5.794H27.329V7.794H23.086z",
                  "transform": "rotate(-45 25.207 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 1H17V5H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.672 24.208H8.915V26.208H4.672z",
                  "transform": "rotate(-45 6.793 25.208)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.793 4.672H7.793V8.915H5.793z",
                  "transform": "rotate(-45 6.793 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
                }
              }
            ],
            "name": "partly-cloudy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PartlyCloudy20",
          "filepath": "partly-cloudy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H31V17H27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.086 5.794H27.329V7.794H23.086z",
                  "transform": "rotate(-45 25.207 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 1H17V5H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.672 24.208H8.915V26.208H4.672z",
                  "transform": "rotate(-45 6.793 25.208)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.793 4.672H7.793V8.915H5.793z",
                  "transform": "rotate(-45 6.793 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
                }
              }
            ],
            "name": "partly-cloudy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PartlyCloudy16",
          "filepath": "partly-cloudy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 15H31V17H27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.086 5.794H27.329V7.794H23.086z",
                  "transform": "rotate(-45 25.207 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 1H17V5H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.672 24.208H8.915V26.208H4.672z",
                  "transform": "rotate(-45 6.793 25.208)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.793 4.672H7.793V8.915H5.793z",
                  "transform": "rotate(-45 6.793 6.794)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
                }
              }
            ],
            "name": "partly-cloudy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "PartlyCloudy",
        "global": "PartlyCloudy",
        "filepath": "PartlyCloudy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 15H31V17H27z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.086 5.794H27.329V7.794H23.086z",
                    "transform": "rotate(-45 25.207 6.794)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 1H17V5H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.672 24.208H8.915V26.208H4.672z",
                    "transform": "rotate(-45 6.793 25.208)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.793 4.672H7.793V8.915H5.793z",
                    "transform": "rotate(-45 6.793 6.794)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "partly-cloudy--night",
      "friendlyName": "Partly cloudy night",
      "aliases": [
        "partly-cloudy",
        "weather",
        "sky"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/partly-cloudy--night.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>partly-cloudy--night</title><path d=\"M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z\"/></svg>",
            "info": {},
            "path": "32/partly-cloudy--night.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PartlyCloudyNight32",
          "filepath": "partly-cloudy--night/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
                }
              }
            ],
            "name": "partly-cloudy--night",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PartlyCloudyNight24",
          "filepath": "partly-cloudy--night/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
                }
              }
            ],
            "name": "partly-cloudy--night",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PartlyCloudyNight20",
          "filepath": "partly-cloudy--night/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
                }
              }
            ],
            "name": "partly-cloudy--night",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PartlyCloudyNight16",
          "filepath": "partly-cloudy--night/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
                }
              }
            ],
            "name": "partly-cloudy--night",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "PartlyCloudyNight",
        "global": "PartlyCloudyNight",
        "filepath": "PartlyCloudyNight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "partnership",
      "friendlyName": "Partnership",
      "aliases": [
        "relationship",
        "handshake",
        "people",
        "business",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/partnership.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>partnership</title><path d=\"M8,9a4,4,0,1,1,4-4A4,4,0,0,1,8,9ZM8,3a2,2,0,1,0,2,2A2,2,0,0,0,8,3Z\" transform=\"translate(0)\"/><path d=\"M24,9a4,4,0,1,1,4-4A4,4,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,24,3Z\" transform=\"translate(0)\"/><path d=\"M26,30H22a2,2,0,0,1-2-2V21h2v7h4V19h2V13a1,1,0,0,0-1-1H20.58L16,20l-4.58-8H5a1,1,0,0,0-1,1v6H6v9h4V21h2v7a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V21a2,2,0,0,1-2-2V13a3,3,0,0,1,3-3h7.58L16,16l3.42-6H27a3,3,0,0,1,3,3v6a2,2,0,0,1-2,2v7A2,2,0,0,1,26,30Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z\"/></svg>",
            "info": {},
            "path": "32/partnership.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Partnership32",
          "filepath": "partnership/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
                }
              }
            ],
            "name": "partnership",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Partnership24",
          "filepath": "partnership/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
                }
              }
            ],
            "name": "partnership",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Partnership20",
          "filepath": "partnership/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
                }
              }
            ],
            "name": "partnership",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Partnership16",
          "filepath": "partnership/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
                }
              }
            ],
            "name": "partnership",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Partnership",
        "global": "Partnership",
        "filepath": "Partnership.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "passenger--drinks",
      "friendlyName": "Passenger drinks",
      "aliases": [
        "travel",
        "passenger",
        "drinks",
        "cabin service"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/passenger--drinks.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,4V2H22V4a3.9906,3.9906,0,0,0,3,3.8586V11H23v2h6V11H27V7.8586A3.9906,3.9906,0,0,0,30,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10.5,9A3.5,3.5,0,1,1,14,5.5,3.5042,3.5042,0,0,1,10.5,9Zm0-5A1.5,1.5,0,1,0,12,5.5,1.5017,1.5017,0,0,0,10.5,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22.4746,31.313,19.3408,24H12.2393A4.0073,4.0073,0,0,1,8.373,21.0293l-1.6337-6.126a3.8987,3.8987,0,0,1,7.5341-2.0092L15.1016,16H21v2H13.5645l-1.2227-4.5908a1.9,1.9,0,0,0-3.6709.979l1.6338,6.1255A2.0052,2.0052,0,0,0,12.2393,22h8.42l3.6543,8.5254Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z\"/><path d=\"M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z\"/></svg>",
            "info": {},
            "path": "32/passenger--drinks.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PassengerDrinks32",
          "filepath": "passenger--drinks/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
                }
              }
            ],
            "name": "passenger--drinks",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PassengerDrinks24",
          "filepath": "passenger--drinks/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
                }
              }
            ],
            "name": "passenger--drinks",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PassengerDrinks20",
          "filepath": "passenger--drinks/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
                }
              }
            ],
            "name": "passenger--drinks",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PassengerDrinks16",
          "filepath": "passenger--drinks/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
                }
              }
            ],
            "name": "passenger--drinks",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PassengerDrinks",
        "global": "PassengerDrinks",
        "filepath": "PassengerDrinks.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "passenger--plus",
      "friendlyName": "Passenger plus",
      "aliases": [
        "travel",
        "passenger",
        "plus"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/passenger--plus.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10.5,9A3.5,3.5,0,1,1,14,5.5,3.5042,3.5042,0,0,1,10.5,9Zm0-5A1.5,1.5,0,1,0,12,5.5,1.5017,1.5017,0,0,0,10.5,4Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22.4739,31.313,19.34,24H12.2385a4.0072,4.0072,0,0,1-3.8662-2.9707l-1.6338-6.126a3.8988,3.8988,0,0,1,7.5342-2.0092L15.1008,16H21v2H13.5637l-1.2226-4.5908a1.9,1.9,0,0,0-3.6709.979l1.6338,6.1255A2.0051,2.0051,0,0,0,12.2385,22h8.42l3.6543,8.5254Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"30 6 26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6\"/>\n  <path d=\"M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z\"/><path d=\"M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z\"/></svg>",
            "info": {},
            "path": "32/passenger--plus.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PassengerPlus32",
          "filepath": "passenger--plus/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
                }
              }
            ],
            "name": "passenger--plus",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PassengerPlus24",
          "filepath": "passenger--plus/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
                }
              }
            ],
            "name": "passenger--plus",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PassengerPlus20",
          "filepath": "passenger--plus/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
                }
              }
            ],
            "name": "passenger--plus",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PassengerPlus16",
          "filepath": "passenger--plus/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
                }
              }
            ],
            "name": "passenger--plus",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PassengerPlus",
        "global": "PassengerPlus",
        "filepath": "PassengerPlus.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "password",
      "friendlyName": "Password",
      "aliases": [
        "key",
        "code",
        "lock",
        "security",
        "user",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/password.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z\"/>\n  <circle cx=\"22\" cy=\"10\" r=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z\"/><circle cx=\"22\" cy=\"10\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/password.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Password32",
          "filepath": "password/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              }
            ],
            "name": "password",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Password24",
          "filepath": "password/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              }
            ],
            "name": "password",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Password20",
          "filepath": "password/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              }
            ],
            "name": "password",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Password16",
          "filepath": "password/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "10",
                  "r": "2"
                }
              }
            ],
            "name": "password",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Password",
        "global": "Password",
        "filepath": "Password.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "10",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "paste",
      "friendlyName": "Paste",
      "aliases": [
        "copy",
        "file",
        "text",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/paste.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>paste</title><path d=\"M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z\"/><path d=\"M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z\"/><path d=\"M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z\"/></svg>",
            "info": {},
            "path": "32/paste.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Paste32",
          "filepath": "paste/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
                }
              }
            ],
            "name": "paste",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Paste24",
          "filepath": "paste/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
                }
              }
            ],
            "name": "paste",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Paste20",
          "filepath": "paste/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
                }
              }
            ],
            "name": "paste",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Paste16",
          "filepath": "paste/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
                }
              }
            ],
            "name": "paste",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Paste",
        "global": "Paste",
        "filepath": "Paste.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pause",
      "friendlyName": "Pause",
      "aliases": [
        "stop",
        "play",
        "music",
        "controls",
        "control"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/pause.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>pause</title>\n<path d=\"M6,4v8H4V4H6 M6,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V4C7,3.4,6.6,3,6,3z\"/>\n<path d=\"M12,4v8h-2V4H12 M12,3h-2C9.4,3,9,3.4,9,4v8c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M6 4v8H4V4H6M6 3H4C3.4 3 3 3.4 3 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C7 3.4 6.6 3 6 3zM12 4v8h-2V4H12M12 3h-2C9.4 3 9 3.4 9 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C13 3.4 12.6 3 12 3z\"/></svg>",
            "info": {},
            "path": "16/pause.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/pause.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pause</title><path d=\"M12,8V24H8V8h4m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/><path d=\"M24,8V24H20V8h4m0-2H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/pause.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pause32",
          "filepath": "pause/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "pause",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pause24",
          "filepath": "pause/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "pause",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pause20",
          "filepath": "pause/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "pause",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pause16",
          "filepath": "pause/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 4v8H4V4H6M6 3H4C3.4 3 3 3.4 3 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C7 3.4 6.6 3 6 3zM12 4v8h-2V4H12M12 3h-2C9.4 3 9 3.4 9 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C13 3.4 12.6 3 12 3z"
                }
              }
            ],
            "name": "pause",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Pause",
        "global": "Pause",
        "filepath": "Pause.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 4v8H4V4H6M6 3H4C3.4 3 3 3.4 3 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C7 3.4 6.6 3 6 3zM12 4v8h-2V4H12M12 3h-2C9.4 3 9 3.4 9 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C13 3.4 12.6 3 12 3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pause--filled",
      "friendlyName": "Pause filled",
      "aliases": [
        "stop",
        "play",
        "music",
        "controls",
        "control"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pause--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pause--filled</title><path d=\"M12,6H10A2,2,0,0,0,8,8V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/><path d=\"M22,6H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/pause--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PauseFilled32",
          "filepath": "pause--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "pause--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PauseFilled24",
          "filepath": "pause--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "pause--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PauseFilled20",
          "filepath": "pause--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "pause--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PauseFilled16",
          "filepath": "pause--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "pause--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PauseFilled",
        "global": "PauseFilled",
        "filepath": "PauseFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pause--outline",
      "friendlyName": "Pause outline",
      "aliases": [
        "stop",
        "play",
        "music",
        "controls",
        "control"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/pause--outline.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>pause--outline</title>\n<polygon points=\"7,5 6,5 6,11 7,11 7,5 \"/>\n<polygon points=\"10,5 9,5 9,11 10,11 10,5 \"/>\n<path d=\"M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M7 5L6 5 6 11 7 11 7 5zM10 5L9 5 9 11 10 11 10 5z\"/><path d=\"M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z\"/></svg>",
            "info": {},
            "path": "16/pause--outline.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/pause--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pause--outline</title><polygon points=\"14 10 12 10 12 22 14 22 14 10 14 10\"/><polygon points=\"20 10 18 10 18 22 20 22 20 10 20 10\"/><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z\"/><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/pause--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PauseOutline32",
          "filepath": "pause--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "pause--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PauseOutline24",
          "filepath": "pause--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "pause--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PauseOutline20",
          "filepath": "pause--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "pause--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PauseOutline16",
          "filepath": "pause--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 5L6 5 6 11 7 11 7 5zM10 5L9 5 9 11 10 11 10 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
                }
              }
            ],
            "name": "pause--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PauseOutline",
        "global": "PauseOutline",
        "filepath": "PauseOutline.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 5L6 5 6 11 7 11 7 5zM10 5L9 5 9 11 10 11 10 5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pause--outline--filled",
      "friendlyName": "Pause outline filled",
      "aliases": [
        "stop",
        "play",
        "music",
        "controls",
        "control"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/pause--outline--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>pause--outline--filled</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z\"/></svg>",
            "info": {},
            "path": "16/pause--outline--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/pause--outline--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pause--outline--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z\"/></svg>",
            "info": {},
            "path": "32/pause--outline--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PauseOutlineFilled32",
          "filepath": "pause--outline--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
                }
              }
            ],
            "name": "pause--outline--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PauseOutlineFilled24",
          "filepath": "pause--outline--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
                }
              }
            ],
            "name": "pause--outline--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PauseOutlineFilled20",
          "filepath": "pause--outline--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
                }
              }
            ],
            "name": "pause--outline--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PauseOutlineFilled16",
          "filepath": "pause--outline--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z"
                }
              }
            ],
            "name": "pause--outline--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PauseOutlineFilled",
        "global": "PauseOutlineFilled",
        "filepath": "PauseOutlineFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pause-future",
      "friendlyName": "Pause future",
      "aliases": [
        "pause",
        "future",
        "operations",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pause-future.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 11 12 11 12 22 14 22 14 11 14 11\"/>\n  <polygon points=\"20 11 18 11 18 22 20 22 20 11 20 11\"/>\n  <path d=\"M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z\"/><path d=\"M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z\"/></svg>",
            "info": {},
            "path": "32/pause-future.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PauseFuture32",
          "filepath": "pause-future/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "pause-future",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PauseFuture24",
          "filepath": "pause-future/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "pause-future",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PauseFuture20",
          "filepath": "pause-future/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "pause-future",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PauseFuture16",
          "filepath": "pause-future/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "pause-future",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "PauseFuture",
        "global": "PauseFuture",
        "filepath": "PauseFuture.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pause-past",
      "friendlyName": "Pause past",
      "aliases": [
        "pause",
        "past",
        "operations",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pause-past.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 11 12 11 12 22 14 22 14 11 14 11\"/>\n  <polygon points=\"20 11 18 11 18 22 20 22 20 11 20 11\"/>\n  <path d=\"M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z\"/><path d=\"M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/pause-past.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PausePast32",
          "filepath": "pause-past/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "pause-past",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PausePast24",
          "filepath": "pause-past/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "pause-past",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PausePast20",
          "filepath": "pause-past/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "pause-past",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PausePast16",
          "filepath": "pause-past/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "pause-past",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "PausePast",
        "global": "PausePast",
        "filepath": "PausePast.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pcn--e-node",
      "friendlyName": "PCN E-Node",
      "aliases": [
        "protected core",
        "network",
        "node",
        "PCN",
        "E-Node"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pcn--e-node.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"20 11 20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/pcn--e-node.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PcnENode32",
          "filepath": "pcn--e-node/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--e-node",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PcnENode24",
          "filepath": "pcn--e-node/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--e-node",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PcnENode20",
          "filepath": "pcn--e-node/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--e-node",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PcnENode16",
          "filepath": "pcn--e-node/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--e-node",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "PcnENode",
        "global": "PcnENode",
        "filepath": "PcnENode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pcn--military",
      "friendlyName": "PCN military",
      "aliases": [
        "protected core",
        "network",
        "node",
        "PCN",
        "military"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pcn--military.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 16 14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16\"/>\n  <polygon points=\"12.414 17.414 16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414\"/>\n  <polygon points=\"12.414 12.414 16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z\"/><path d=\"M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z\"/><path d=\"M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/pcn--military.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PcnMilitary32",
          "filepath": "pcn--military/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--military",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PcnMilitary24",
          "filepath": "pcn--military/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--military",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PcnMilitary20",
          "filepath": "pcn--military/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--military",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PcnMilitary16",
          "filepath": "pcn--military/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--military",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "PcnMilitary",
        "global": "PcnMilitary",
        "filepath": "PcnMilitary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pcn--p-node",
      "friendlyName": "PCN P node",
      "aliases": [
        "protected core",
        "network",
        "node",
        "PCN",
        "P node"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pcn--p-node.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/pcn--p-node.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PcnPNode32",
          "filepath": "pcn--p-node/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--p-node",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PcnPNode24",
          "filepath": "pcn--p-node/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--p-node",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PcnPNode20",
          "filepath": "pcn--p-node/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--p-node",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PcnPNode16",
          "filepath": "pcn--p-node/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--p-node",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "PcnPNode",
        "global": "PcnPNode",
        "filepath": "PcnPNode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pcn--z-node",
      "friendlyName": "PCN Z node",
      "aliases": [
        "protected core",
        "network",
        "node",
        "PCN",
        "Z node"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pcn--z-node.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"20 9 12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9\"/>\n  <path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z\"/><path d=\"M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z\"/></svg>",
            "info": {},
            "path": "32/pcn--z-node.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PcnZNode32",
          "filepath": "pcn--z-node/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--z-node",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PcnZNode24",
          "filepath": "pcn--z-node/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--z-node",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PcnZNode20",
          "filepath": "pcn--z-node/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--z-node",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PcnZNode16",
          "filepath": "pcn--z-node/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                }
              }
            ],
            "name": "pcn--z-node",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "PcnZNode",
        "global": "PcnZNode",
        "filepath": "PcnZNode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "PDF",
      "friendlyName": "PDF",
      "aliases": [
        "document",
        "doc",
        "compress",
        "portable",
        "document",
        "format",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/PDF.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>PDF</title><polygon points=\"30 11 30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11\"/><path d=\"M8,9H2V23H4V18H8a2,2,0,0,0,2-2V11A2,2,0,0,0,8,9Zm0,7H4V11H8Z\"/><path d=\"M16,23H12V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,16,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H14Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z\"/></svg>",
            "info": {},
            "path": "32/PDF.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pdf32",
          "filepath": "PDF/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z"
                }
              }
            ],
            "name": "PDF",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pdf24",
          "filepath": "PDF/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z"
                }
              }
            ],
            "name": "PDF",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pdf20",
          "filepath": "PDF/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z"
                }
              }
            ],
            "name": "PDF",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pdf16",
          "filepath": "PDF/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z"
                }
              }
            ],
            "name": "PDF",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Pdf",
        "global": "Pdf",
        "filepath": "Pdf.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "PDF--reference",
      "friendlyName": "PDF reference",
      "aliases": [
        "document",
        "doc",
        "compress",
        "portable",
        "document",
        "format",
        "file",
        "reference",
        "source",
        "citation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/PDF--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <polygon points=\"22 16 24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16\"/>\n  <path d=\"M16,2H12V16h4a4,4,0,0,0,4-4V6A4,4,0,0,0,16,2Zm2,10a2,2,0,0,1-2,2H14V4h2a2,2,0,0,1,2,2Z\"/>\n  <path d=\"M8,2H2V16H4V11H8a2,2,0,0,0,2-2V4A2,2,0,0,0,8,2ZM8,9H4V4H8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z\"/></svg>",
            "info": {},
            "path": "32/PDF--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PdfReference32",
          "filepath": "PDF--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z"
                }
              }
            ],
            "name": "PDF--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PdfReference24",
          "filepath": "PDF--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z"
                }
              }
            ],
            "name": "PDF--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PdfReference20",
          "filepath": "PDF--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z"
                }
              }
            ],
            "name": "PDF--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PdfReference16",
          "filepath": "PDF--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z"
                }
              }
            ],
            "name": "PDF--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "PdfReference",
        "global": "PdfReference",
        "filepath": "PdfReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pedestrian",
      "friendlyName": "Pedestrian",
      "aliases": [
        "pedestrian",
        "people",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pedestrian.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pedestrian</title><path d=\"M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z\"/><polygon points=\"17.051 18.316 19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316\"/><path d=\"M16.5,8A3.5,3.5,0,1,1,20,4.5,3.5042,3.5042,0,0,1,16.5,8Zm0-5A1.5,1.5,0,1,0,18,4.5,1.5017,1.5017,0,0,0,16.5,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z\"/><path d=\"M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z\"/></svg>",
            "info": {},
            "path": "32/pedestrian.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pedestrian32",
          "filepath": "pedestrian/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
                }
              }
            ],
            "name": "pedestrian",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pedestrian24",
          "filepath": "pedestrian/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
                }
              }
            ],
            "name": "pedestrian",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pedestrian20",
          "filepath": "pedestrian/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
                }
              }
            ],
            "name": "pedestrian",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pedestrian16",
          "filepath": "pedestrian/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
                }
              }
            ],
            "name": "pedestrian",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Pedestrian",
        "global": "Pedestrian",
        "filepath": "Pedestrian.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pedestrian--family",
      "friendlyName": "Pedestrian family",
      "aliases": [
        "pedestrian",
        "people",
        "travel",
        "family"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pedestrian--family.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,30H17a2.0021,2.0021,0,0,1-2-2V23h2v5h3V23h2V19a1.0011,1.0011,0,0,0-1-1H12.2793l-2-6H4a1.0011,1.0011,0,0,0-1,1v6H5v9H9V21h2v7a2.0021,2.0021,0,0,1-2,2H5a2.0021,2.0021,0,0,1-2-2V21a2.0021,2.0021,0,0,1-2-2V13a3.0033,3.0033,0,0,1,3-3h6.2793a1.998,1.998,0,0,1,1.8975,1.3674L13.7207,16H21a3.0033,3.0033,0,0,1,3,3v4a2.0021,2.0021,0,0,1-2,2v3A2.0021,2.0021,0,0,1,20,30Z\"/>\n  <path d=\"M28,30H26V19h3V13a1.0011,1.0011,0,0,0-1-1H24V10h4a3.0033,3.0033,0,0,1,3,3v6a2.0021,2.0021,0,0,1-2,2H28Z\"/>\n  <path d=\"M7,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,7,9ZM7,3A2,2,0,1,0,9,5,2.0021,2.0021,0,0,0,7,3Z\"/>\n  <path d=\"M25,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,25,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,25,3Z\"/>\n  <path d=\"M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z\"/><path d=\"M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z\"/></svg>",
            "info": {},
            "path": "32/pedestrian--family.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PedestrianFamily32",
          "filepath": "pedestrian--family/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
                }
              }
            ],
            "name": "pedestrian--family",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PedestrianFamily24",
          "filepath": "pedestrian--family/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
                }
              }
            ],
            "name": "pedestrian--family",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PedestrianFamily20",
          "filepath": "pedestrian--family/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
                }
              }
            ],
            "name": "pedestrian--family",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PedestrianFamily16",
          "filepath": "pedestrian--family/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
                }
              }
            ],
            "name": "pedestrian--family",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PedestrianFamily",
        "global": "PedestrianFamily",
        "filepath": "PedestrianFamily.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pedestrian-child",
      "friendlyName": "Pedestrian child",
      "aliases": [
        "pedestrian-child",
        "people",
        "travel",
        "parent",
        "child"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pedestrian-child.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pedestrian-child</title><path d=\"M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z\"/><path d=\"M23.5,15A3.5,3.5,0,1,1,27,11.5,3.5042,3.5042,0,0,1,23.5,15Zm0-5A1.5,1.5,0,1,0,25,11.5,1.5017,1.5017,0,0,0,23.5,10Z\"/><path d=\"M8,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,8,9ZM8,3a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,8,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z\"/><path d=\"M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z\"/></svg>",
            "info": {},
            "path": "32/pedestrian-child.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PedestrianChild32",
          "filepath": "pedestrian-child/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
                }
              }
            ],
            "name": "pedestrian-child",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PedestrianChild24",
          "filepath": "pedestrian-child/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
                }
              }
            ],
            "name": "pedestrian-child",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PedestrianChild20",
          "filepath": "pedestrian-child/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
                }
              }
            ],
            "name": "pedestrian-child",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PedestrianChild16",
          "filepath": "pedestrian-child/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
                }
              }
            ],
            "name": "pedestrian-child",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PedestrianChild",
        "global": "PedestrianChild",
        "filepath": "PedestrianChild.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pen",
      "friendlyName": "Pen",
      "aliases": [
        "pen",
        "write"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pen.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z\"/>\n  <rect x=\"8.1359\" y=\"7.5001\" width=\"10.7281\" height=\"1.9998\" transform=\"translate(-2.0563 12.0355) rotate(-45)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z\"/><path d=\"M8.136 7.5H18.863999999999997V9.5H8.136z\" transform=\"rotate(-45 13.5 8.5)\"/></svg>",
            "info": {},
            "path": "32/pen.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pen32",
          "filepath": "pen/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.136 7.5H18.863999999999997V9.5H8.136z",
                  "transform": "rotate(-45 13.5 8.5)"
                }
              }
            ],
            "name": "pen",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pen24",
          "filepath": "pen/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.136 7.5H18.863999999999997V9.5H8.136z",
                  "transform": "rotate(-45 13.5 8.5)"
                }
              }
            ],
            "name": "pen",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pen20",
          "filepath": "pen/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.136 7.5H18.863999999999997V9.5H8.136z",
                  "transform": "rotate(-45 13.5 8.5)"
                }
              }
            ],
            "name": "pen",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pen16",
          "filepath": "pen/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.136 7.5H18.863999999999997V9.5H8.136z",
                  "transform": "rotate(-45 13.5 8.5)"
                }
              }
            ],
            "name": "pen",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Pen",
        "global": "Pen",
        "filepath": "Pen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.136 7.5H18.863999999999997V9.5H8.136z",
                    "transform": "rotate(-45 13.5 8.5)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pen--fountain",
      "friendlyName": "Pen fountain",
      "aliases": [
        "pen",
        "fountain"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pen--fountain.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z\"/></svg>",
            "info": {},
            "path": "32/pen--fountain.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PenFountain32",
          "filepath": "pen--fountain/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
                }
              }
            ],
            "name": "pen--fountain",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PenFountain24",
          "filepath": "pen--fountain/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
                }
              }
            ],
            "name": "pen--fountain",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PenFountain20",
          "filepath": "pen--fountain/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
                }
              }
            ],
            "name": "pen--fountain",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PenFountain16",
          "filepath": "pen--fountain/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
                }
              }
            ],
            "name": "pen--fountain",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "PenFountain",
        "global": "PenFountain",
        "filepath": "PenFountain.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pending",
      "friendlyName": "Pending",
      "aliases": [
        "pending",
        "status"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pending.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"9\" cy=\"16\" r=\"2\"/>\n  <circle cx=\"23\" cy=\"16\" r=\"2\"/>\n  <circle cx=\"16\" cy=\"16\" r=\"2\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9\" cy=\"16\" r=\"2\"/><circle cx=\"23\" cy=\"16\" r=\"2\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/pending.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pending32",
          "filepath": "pending/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "pending",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pending24",
          "filepath": "pending/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "pending",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pending20",
          "filepath": "pending/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "pending",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pending16",
          "filepath": "pending/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "pending",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Pending",
        "global": "Pending",
        "filepath": "Pending.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pending--filled",
      "friendlyName": "Pending filled",
      "aliases": [
        "pending filled",
        "status",
        "pending"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pending--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z\" transform=\"translate(0 0)\"/>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z\"/><path fill=\"none\" d=\"M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/pending--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PendingFilled32",
          "filepath": "pending--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "pending--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PendingFilled24",
          "filepath": "pending--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "pending--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PendingFilled20",
          "filepath": "pending--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "pending--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PendingFilled16",
          "filepath": "pending--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "pending--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "PendingFilled",
        "global": "PendingFilled",
        "filepath": "PendingFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "percentage",
      "friendlyName": "Percentage",
      "aliases": [
        "percentage",
        "formatting",
        "percent"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/percentage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>percentage</title><path d=\"M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z\"/><rect x=\"0.0293\" y=\"15.0001\" width=\"31.9413\" height=\"1.9998\" transform=\"translate(-6.6274 16) rotate(-45)\"/><path d=\"M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z\"/><path d=\"M0.029 15H31.97V17H0.029z\" transform=\"rotate(-45 16 16)\"/><path d=\"M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z\"/></svg>",
            "info": {},
            "path": "32/percentage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Percentage32",
          "filepath": "percentage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
                }
              }
            ],
            "name": "percentage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Percentage24",
          "filepath": "percentage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
                }
              }
            ],
            "name": "percentage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Percentage20",
          "filepath": "percentage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
                }
              }
            ],
            "name": "percentage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Percentage16",
          "filepath": "percentage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
                }
              }
            ],
            "name": "percentage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Percentage",
        "global": "Percentage",
        "filepath": "Percentage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M0.029 15H31.97V17H0.029z",
                    "transform": "rotate(-45 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "percentage--filled",
      "friendlyName": "Percentage filled",
      "aliases": [
        "percentage filled",
        "formatting",
        "percent"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/percentage--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>percentage--filled</title><path d=\"M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z\"/><rect x=\"0.0293\" y=\"15.0001\" width=\"31.9413\" height=\"1.9998\" transform=\"translate(-6.6274 16) rotate(-45)\"/><path d=\"M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z\"/><path d=\"M0.029 15H31.97V17H0.029z\" transform=\"rotate(-45 16 16)\"/><path d=\"M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z\"/></svg>",
            "info": {},
            "path": "32/percentage--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PercentageFilled32",
          "filepath": "percentage--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
                }
              }
            ],
            "name": "percentage--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PercentageFilled24",
          "filepath": "percentage--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
                }
              }
            ],
            "name": "percentage--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PercentageFilled20",
          "filepath": "percentage--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
                }
              }
            ],
            "name": "percentage--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PercentageFilled16",
          "filepath": "percentage--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M0.029 15H31.97V17H0.029z",
                  "transform": "rotate(-45 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
                }
              }
            ],
            "name": "percentage--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "PercentageFilled",
        "global": "PercentageFilled",
        "filepath": "PercentageFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M0.029 15H31.97V17H0.029z",
                    "transform": "rotate(-45 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "person",
      "friendlyName": "Person",
      "aliases": [
        "human",
        "male",
        "female",
        "figure",
        "user",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/person.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>person</title><path d=\"M18,30H14a2,2,0,0,1-2-2V21a2,2,0,0,1-2-2V13a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v6a2,2,0,0,1-2,2v7A2,2,0,0,1,18,30ZM13,12a.94.94,0,0,0-1,1v6h2v9h4V19h2V13a.94.94,0,0,0-1-1Z\"/><path d=\"M16,9a4,4,0,1,1,4-4h0A4,4,0,0,1,16,9Zm0-6a2,2,0,1,0,2,2h0a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/person.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Person32",
          "filepath": "person/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "person",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Person24",
          "filepath": "person/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "person",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Person20",
          "filepath": "person/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "person",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Person16",
          "filepath": "person/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "person",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Person",
        "global": "Person",
        "filepath": "Person.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "person--favorite",
      "friendlyName": "Person favorite",
      "aliases": [
        "human",
        "male",
        "female",
        "figure",
        "user",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/person--favorite.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>person--favorite</title><path d=\"M10,31H6a2.0059,2.0059,0,0,1-2-2V22a2.0059,2.0059,0,0,1-2-2V14a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,10,31ZM5,13a.9448.9448,0,0,0-1,1v6H6v9h4V20h2V14a.9448.9448,0,0,0-1-1Z\" transform=\"translate(0 0)\"/><path d=\"M8,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,8,10ZM8,4a2,2,0,1,0,2,2A2.002,2.002,0,0,0,8,4Z\" transform=\"translate(0 0)\"/><path d=\"M28.7663,4.2558A4.2121,4.2121,0,0,0,23,4.0321a4.2121,4.2121,0,0,0-5.7663.2237,4.319,4.319,0,0,0,0,6.0447L22.998,16.14,23,16.1376l.002.0019,5.7643-5.839A4.319,4.319,0,0,0,28.7663,4.2558ZM27.342,8.8948l-4.34,4.3973L23,13.29l-.002.002-4.34-4.3973a2.3085,2.3085,0,0,1,0-3.2338,2.2639,2.2639,0,0,1,3.1561,0l1.181,1.2074L23,6.8634l.0049.005,1.181-1.2074a2.2639,2.2639,0,0,1,3.1561,0A2.3085,2.3085,0,0,1,27.342,8.8948Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z\"/></svg>",
            "info": {},
            "path": "32/person--favorite.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PersonFavorite32",
          "filepath": "person--favorite/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
                }
              }
            ],
            "name": "person--favorite",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PersonFavorite24",
          "filepath": "person--favorite/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
                }
              }
            ],
            "name": "person--favorite",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PersonFavorite20",
          "filepath": "person--favorite/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
                }
              }
            ],
            "name": "person--favorite",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PersonFavorite16",
          "filepath": "person--favorite/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
                }
              }
            ],
            "name": "person--favorite",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "PersonFavorite",
        "global": "PersonFavorite",
        "filepath": "PersonFavorite.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pest",
      "friendlyName": "Pest",
      "aliases": [
        "weather",
        "pest",
        "crop",
        "agriculture",
        "food",
        "production"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pest.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"7.5\" cy=\"9.5\" r=\"1.5\"/>\n  <circle cx=\"13\" cy=\"13\" r=\"1\"/>\n  <circle cx=\"22\" cy=\"21\" r=\"1\"/>\n  <path d=\"M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"7.5\" cy=\"9.5\" r=\"1.5\"/><circle cx=\"13\" cy=\"13\" r=\"1\"/><circle cx=\"22\" cy=\"21\" r=\"1\"/><path d=\"M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z\"/></svg>",
            "info": {},
            "path": "32/pest.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pest32",
          "filepath": "pest/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
                }
              }
            ],
            "name": "pest",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pest24",
          "filepath": "pest/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
                }
              }
            ],
            "name": "pest",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pest20",
          "filepath": "pest/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
                }
              }
            ],
            "name": "pest",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pest16",
          "filepath": "pest/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
                }
              }
            ],
            "name": "pest",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Pest",
        "global": "Pest",
        "filepath": "Pest.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7.5",
                    "cy": "9.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13",
                    "cy": "13",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "21",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pet-image--B",
      "friendlyName": "PET image B",
      "aliases": [
        "cursor",
        "brightness",
        "contrast",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/pet-image--B.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>watson-health--pet-image-B</title><rect class=\"cls-1\" x=\"19\" y=\"21\" width=\"2\" height=\"3\"/><rect class=\"cls-1\" x=\"19\" width=\"2\" height=\"3\"/><rect class=\"cls-1\" x=\"8\" y=\"11\" width=\"3\" height=\"2\"/><rect class=\"cls-1\" x=\"29\" y=\"11\" width=\"3\" height=\"2\"/><rect class=\"cls-1\" x=\"11.59\" y=\"3.07\" width=\"1.98\" height=\"3\" transform=\"translate(0.45 10.24) rotate(-45)\"/><rect class=\"cls-1\" x=\"26.44\" y=\"17.92\" width=\"1.98\" height=\"3\" transform=\"translate(-5.69 25.08) rotate(-45)\"/><rect class=\"cls-1\" x=\"11.09\" y=\"18.42\" width=\"3\" height=\"1.98\" transform=\"translate(-10.04 14.59) rotate(-45)\"/><rect class=\"cls-1\" x=\"25.93\" y=\"3.58\" width=\"3\" height=\"1.98\" transform=\"translate(4.8 20.73) rotate(-45)\"/><path class=\"cls-1\" d=\"M20,5a7,7,0,1,0,7,7A7,7,0,0,0,20,5Zm0,12A5,5,0,0,1,20,7Z\"/><path class=\"cls-1\" d=\"M5,18H0V32H5a3,3,0,0,0,3-3V27a3,3,0,0,0-.78-2A3,3,0,0,0,8,23V21A3,3,0,0,0,5,18ZM2,20H5a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H2Zm4,9a1,1,0,0,1-1,1H2V26H5a1,1,0,0,1,1,1Z\"/><polygon class=\"cls-1\" points=\"2 2 9 2 9 0 0 0 0 9 2 9 2 2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z\"/><path d=\"M11.59 3.07H13.57V6.07H11.59z\" transform=\"rotate(-45 12.586 4.577)\"/><path d=\"M26.44 17.92H28.42V20.92H26.44z\" transform=\"rotate(-45 27.43 19.408)\"/><path d=\"M11.09 18.42H14.09V20.400000000000002H11.09z\" transform=\"rotate(-45 12.592 19.414)\"/><path d=\"M25.93 3.58H28.93V5.5600000000000005H25.93z\" transform=\"rotate(-45 27.423 4.57)\"/><path d=\"M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z\"/></svg>",
            "info": {},
            "path": "32/watson-health/pet-image--B.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthPetImageB32",
          "filepath": "watson-health/pet-image--B/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.59 3.07H13.57V6.07H11.59z",
                  "transform": "rotate(-45 12.586 4.577)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.44 17.92H28.42V20.92H26.44z",
                  "transform": "rotate(-45 27.43 19.408)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.09 18.42H14.09V20.400000000000002H11.09z",
                  "transform": "rotate(-45 12.592 19.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.93 3.58H28.93V5.5600000000000005H25.93z",
                  "transform": "rotate(-45 27.423 4.57)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
                }
              }
            ],
            "name": "pet-image--B",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthPetImageB24",
          "filepath": "watson-health/pet-image--B/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.59 3.07H13.57V6.07H11.59z",
                  "transform": "rotate(-45 12.586 4.577)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.44 17.92H28.42V20.92H26.44z",
                  "transform": "rotate(-45 27.43 19.408)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.09 18.42H14.09V20.400000000000002H11.09z",
                  "transform": "rotate(-45 12.592 19.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.93 3.58H28.93V5.5600000000000005H25.93z",
                  "transform": "rotate(-45 27.423 4.57)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
                }
              }
            ],
            "name": "pet-image--B",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthPetImageB20",
          "filepath": "watson-health/pet-image--B/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.59 3.07H13.57V6.07H11.59z",
                  "transform": "rotate(-45 12.586 4.577)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.44 17.92H28.42V20.92H26.44z",
                  "transform": "rotate(-45 27.43 19.408)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.09 18.42H14.09V20.400000000000002H11.09z",
                  "transform": "rotate(-45 12.592 19.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.93 3.58H28.93V5.5600000000000005H25.93z",
                  "transform": "rotate(-45 27.423 4.57)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
                }
              }
            ],
            "name": "pet-image--B",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthPetImageB16",
          "filepath": "watson-health/pet-image--B/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.59 3.07H13.57V6.07H11.59z",
                  "transform": "rotate(-45 12.586 4.577)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.44 17.92H28.42V20.92H26.44z",
                  "transform": "rotate(-45 27.43 19.408)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.09 18.42H14.09V20.400000000000002H11.09z",
                  "transform": "rotate(-45 12.592 19.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.93 3.58H28.93V5.5600000000000005H25.93z",
                  "transform": "rotate(-45 27.423 4.57)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
                }
              }
            ],
            "name": "pet-image--B",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "PetImageB",
        "global": "WatsonHealthPetImageB",
        "filepath": "watson-health/PetImageB.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.59 3.07H13.57V6.07H11.59z",
                    "transform": "rotate(-45 12.586 4.577)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.44 17.92H28.42V20.92H26.44z",
                    "transform": "rotate(-45 27.43 19.408)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.09 18.42H14.09V20.400000000000002H11.09z",
                    "transform": "rotate(-45 12.592 19.414)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.93 3.58H28.93V5.5600000000000005H25.93z",
                    "transform": "rotate(-45 27.423 4.57)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pet-image--O",
      "friendlyName": "PET image O",
      "aliases": [
        "cursor",
        "brightness",
        "contrast",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/pet-image--O.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--pet-image-O</title><rect x=\"11\" y=\"29\" width=\"2\" height=\"3\"/><rect x=\"11\" y=\"8\" width=\"2\" height=\"3\"/><rect y=\"19\" width=\"3\" height=\"2\"/><rect x=\"21\" y=\"19\" width=\"3\" height=\"2\"/><rect x=\"3.59\" y=\"11.09\" width=\"1.98\" height=\"3\" transform=\"translate(-7.56 6.93) rotate(-45)\"/><rect x=\"18.44\" y=\"25.93\" width=\"1.98\" height=\"3\" transform=\"translate(-13.7 21.77) rotate(-45)\"/><rect x=\"3.09\" y=\"26.44\" width=\"3\" height=\"1.98\" transform=\"translate(-18.05 11.28) rotate(-45)\"/><rect x=\"17.93\" y=\"11.59\" width=\"3\" height=\"1.98\" transform=\"translate(-3.21 17.42) rotate(-45)\"/><path d=\"M12,13a7,7,0,1,0,7,7A7,7,0,0,0,12,13Zm0,12a5,5,0,0,1,0-10Z\"/><polygon points=\"2 2 9 2 9 0 0 0 0 9 2 9 2 2\"/><path d=\"M30,0H26a2,2,0,0,0-2,2V12a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V2A2,2,0,0,0,30,0ZM26,12V2h4V12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z\"/><path d=\"M3.59 11.09H5.57V14.09H3.59z\" transform=\"rotate(-45 4.585 12.59)\"/><path d=\"M18.44 25.93H20.42V28.93H18.44z\" transform=\"rotate(-45 19.429 27.422)\"/><path d=\"M3.09 26.44H6.09V28.42H3.09z\" transform=\"rotate(-45 4.591 27.428)\"/><path d=\"M17.93 11.59H20.93V13.57H17.93z\" transform=\"rotate(-45 19.423 12.585)\"/><path d=\"M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z\"/></svg>",
            "info": {},
            "path": "32/watson-health/pet-image--O.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthPetImageO32",
          "filepath": "watson-health/pet-image--O/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.59 11.09H5.57V14.09H3.59z",
                  "transform": "rotate(-45 4.585 12.59)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.44 25.93H20.42V28.93H18.44z",
                  "transform": "rotate(-45 19.429 27.422)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.09 26.44H6.09V28.42H3.09z",
                  "transform": "rotate(-45 4.591 27.428)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.93 11.59H20.93V13.57H17.93z",
                  "transform": "rotate(-45 19.423 12.585)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
                }
              }
            ],
            "name": "pet-image--O",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthPetImageO24",
          "filepath": "watson-health/pet-image--O/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.59 11.09H5.57V14.09H3.59z",
                  "transform": "rotate(-45 4.585 12.59)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.44 25.93H20.42V28.93H18.44z",
                  "transform": "rotate(-45 19.429 27.422)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.09 26.44H6.09V28.42H3.09z",
                  "transform": "rotate(-45 4.591 27.428)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.93 11.59H20.93V13.57H17.93z",
                  "transform": "rotate(-45 19.423 12.585)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
                }
              }
            ],
            "name": "pet-image--O",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthPetImageO20",
          "filepath": "watson-health/pet-image--O/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.59 11.09H5.57V14.09H3.59z",
                  "transform": "rotate(-45 4.585 12.59)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.44 25.93H20.42V28.93H18.44z",
                  "transform": "rotate(-45 19.429 27.422)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.09 26.44H6.09V28.42H3.09z",
                  "transform": "rotate(-45 4.591 27.428)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.93 11.59H20.93V13.57H17.93z",
                  "transform": "rotate(-45 19.423 12.585)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
                }
              }
            ],
            "name": "pet-image--O",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthPetImageO16",
          "filepath": "watson-health/pet-image--O/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.59 11.09H5.57V14.09H3.59z",
                  "transform": "rotate(-45 4.585 12.59)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.44 25.93H20.42V28.93H18.44z",
                  "transform": "rotate(-45 19.429 27.422)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.09 26.44H6.09V28.42H3.09z",
                  "transform": "rotate(-45 4.591 27.428)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.93 11.59H20.93V13.57H17.93z",
                  "transform": "rotate(-45 19.423 12.585)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
                }
              }
            ],
            "name": "pet-image--O",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "PetImageO",
        "global": "WatsonHealthPetImageO",
        "filepath": "watson-health/PetImageO.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.59 11.09H5.57V14.09H3.59z",
                    "transform": "rotate(-45 4.585 12.59)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.44 25.93H20.42V28.93H18.44z",
                    "transform": "rotate(-45 19.429 27.422)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.09 26.44H6.09V28.42H3.09z",
                    "transform": "rotate(-45 4.591 27.428)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.93 11.59H20.93V13.57H17.93z",
                    "transform": "rotate(-45 19.423 12.585)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone",
      "friendlyName": "Phone",
      "aliases": [
        "call",
        "cell",
        "connect",
        "chat",
        "sound",
        "mute",
        "landline",
        "phone"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>phone</title><path d=\"M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z\"/></svg>",
            "info": {},
            "path": "32/phone.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Phone32",
          "filepath": "phone/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              }
            ],
            "name": "phone",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Phone24",
          "filepath": "phone/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              }
            ],
            "name": "phone",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Phone20",
          "filepath": "phone/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              }
            ],
            "name": "phone",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Phone16",
          "filepath": "phone/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              }
            ],
            "name": "phone",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Phone",
        "global": "Phone",
        "filepath": "Phone.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--application",
      "friendlyName": "Phone application",
      "aliases": [
        "call",
        "phone",
        "application",
        "app",
        "software",
        "interface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--application.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"26\" y=\"2\" width=\"4\" height=\"4\"/>\n  <rect x=\"26\" y=\"8\" width=\"4\" height=\"4\"/>\n  <rect x=\"20\" y=\"2\" width=\"4\" height=\"4\"/>\n  <rect x=\"20\" y=\"8\" width=\"4\" height=\"4\"/>\n  <path d=\"M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z\"/></svg>",
            "info": {},
            "path": "32/phone--application.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneApplication32",
          "filepath": "phone--application/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
                }
              }
            ],
            "name": "phone--application",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneApplication24",
          "filepath": "phone--application/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
                }
              }
            ],
            "name": "phone--application",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneApplication20",
          "filepath": "phone--application/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
                }
              }
            ],
            "name": "phone--application",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneApplication16",
          "filepath": "phone--application/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
                }
              }
            ],
            "name": "phone--application",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneApplication",
        "global": "PhoneApplication",
        "filepath": "PhoneApplication.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--block",
      "friendlyName": "Phone block",
      "aliases": [
        "phone block",
        "call block",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--block.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z\" transform=\"translate(0)\"/>\n  <polygon points=\"24.41 9 28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z\"/><path d=\"M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z\"/></svg>",
            "info": {},
            "path": "32/phone--block.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneBlock32",
          "filepath": "phone--block/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneBlock24",
          "filepath": "phone--block/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneBlock20",
          "filepath": "phone--block/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneBlock16",
          "filepath": "phone--block/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneBlock",
        "global": "PhoneBlock",
        "filepath": "PhoneBlock.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--block--filled",
      "friendlyName": "Phone block filled",
      "aliases": [
        "phone block filled",
        "call block",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--block--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z\" transform=\"translate(0)\"/>\n  <polygon points=\"24.41 9 28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z\"/><path d=\"M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z\"/></svg>",
            "info": {},
            "path": "32/phone--block--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneBlockFilled32",
          "filepath": "phone--block--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneBlockFilled24",
          "filepath": "phone--block--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneBlockFilled20",
          "filepath": "phone--block--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneBlockFilled16",
          "filepath": "phone--block--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                }
              }
            ],
            "name": "phone--block--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneBlockFilled",
        "global": "PhoneBlockFilled",
        "filepath": "PhoneBlockFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--filled",
      "friendlyName": "Phone filled",
      "aliases": [
        "call",
        "cell",
        "connect",
        "chat",
        "sound",
        "mute",
        "landline",
        "phone",
        "toggle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>phone--filled</title><path d=\"M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z\"/></svg>",
            "info": {},
            "path": "32/phone--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneFilled32",
          "filepath": "phone--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
                }
              }
            ],
            "name": "phone--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneFilled24",
          "filepath": "phone--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
                }
              }
            ],
            "name": "phone--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneFilled20",
          "filepath": "phone--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
                }
              }
            ],
            "name": "phone--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneFilled16",
          "filepath": "phone--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
                }
              }
            ],
            "name": "phone--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneFilled",
        "global": "PhoneFilled",
        "filepath": "PhoneFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--incoming",
      "friendlyName": "Phone incoming",
      "aliases": [
        "phone incoming",
        "phone call",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--incoming.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z\" transform=\"translate(0)\"/>\n  <polygon class=\"cls-1\" points=\"27 13 27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z\"/><path d=\"M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z\"/></svg>",
            "info": {},
            "path": "32/phone--incoming.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneIncoming32",
          "filepath": "phone--incoming/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneIncoming24",
          "filepath": "phone--incoming/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneIncoming20",
          "filepath": "phone--incoming/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneIncoming16",
          "filepath": "phone--incoming/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneIncoming",
        "global": "PhoneIncoming",
        "filepath": "PhoneIncoming.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--incoming--filled",
      "friendlyName": "Phone incoming filled",
      "aliases": [
        "phone incoming filled",
        "phone call",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--incoming--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z\" transform=\"translate(0)\"/>\n  <polygon class=\"cls-1\" points=\"27 13 27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z\"/><path d=\"M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z\"/></svg>",
            "info": {},
            "path": "32/phone--incoming--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneIncomingFilled32",
          "filepath": "phone--incoming--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneIncomingFilled24",
          "filepath": "phone--incoming--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneIncomingFilled20",
          "filepath": "phone--incoming--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneIncomingFilled16",
          "filepath": "phone--incoming--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                }
              }
            ],
            "name": "phone--incoming--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneIncomingFilled",
        "global": "PhoneIncomingFilled",
        "filepath": "PhoneIncomingFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--ip",
      "friendlyName": "Phone IP",
      "aliases": [
        "phone",
        "VOIP",
        "IP",
        "telecommunications",
        "handset"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--ip.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"16\" y=\"14\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"14\" width=\"2\" height=\"2\"/>\n  <rect x=\"24\" y=\"14\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"24\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"22\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"22\" width=\"2\" height=\"2\"/>\n  <rect x=\"24\" y=\"22\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"10\" width=\"10\" height=\"2\"/>\n  <path d=\"M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z\"/><path d=\"M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z\"/></svg>",
            "info": {},
            "path": "32/phone--ip.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneIp32",
          "filepath": "phone--ip/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
                }
              }
            ],
            "name": "phone--ip",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneIp24",
          "filepath": "phone--ip/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
                }
              }
            ],
            "name": "phone--ip",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneIp20",
          "filepath": "phone--ip/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
                }
              }
            ],
            "name": "phone--ip",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneIp16",
          "filepath": "phone--ip/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
                }
              }
            ],
            "name": "phone--ip",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "PhoneIp",
        "global": "PhoneIp",
        "filepath": "PhoneIp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--off",
      "friendlyName": "Phone off",
      "aliases": [
        "call",
        "cell",
        "connect",
        "chat",
        "sound",
        "mute",
        "phone",
        "toggle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>phone--off</title><path d=\"M9.19,18.56A25.66,25.66,0,0,1,5,6.08V6A1,1,0,0,1,6,5h5.28l1.5,3.77L9.94,11.64l.06.48a13,13,0,0,0,1.46,4.17l1.46-1.46a9.34,9.34,0,0,1-.84-2.52l2.13-2.15A2,2,0,0,0,14.65,8L13.13,4.26A2,2,0,0,0,11.27,3H5.76A3,3,0,0,0,3,6.23,28,28,0,0,0,7.79,20Z\"/><path d=\"M27.77,18.86,24,17.35a2,2,0,0,0-2.17.41l-2.17,2.15A9.17,9.17,0,0,1,15.45,18L30,3.41,28.59,2,2,28.59,3.41,30l7-7c3.38,3.18,8.28,5.62,15.39,6H26a3,3,0,0,0,3-3V20.72A2,2,0,0,0,27.77,18.86ZM27,26v.06a1,1,0,0,1-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14,19.44A10.77,10.77,0,0,0,19.88,22l.48.06,2.87-2.85L27,20.72Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z\"/></svg>",
            "info": {},
            "path": "32/phone--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneOff32",
          "filepath": "phone--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z"
                }
              }
            ],
            "name": "phone--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneOff24",
          "filepath": "phone--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z"
                }
              }
            ],
            "name": "phone--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneOff20",
          "filepath": "phone--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z"
                }
              }
            ],
            "name": "phone--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneOff16",
          "filepath": "phone--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z"
                }
              }
            ],
            "name": "phone--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneOff",
        "global": "PhoneOff",
        "filepath": "PhoneOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--off--filled",
      "friendlyName": "Phone off filled",
      "aliases": [
        "call",
        "cell",
        "connect",
        "chat",
        "sound",
        "mute",
        "toggle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--off--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>phone--off--filled</title><path d=\"M26.74,19.56l-2.52-1a2,2,0,0,0-2.15.44L20,21.06a9.93,9.93,0,0,1-5.35-2.29L30,3.41,28.59,2,2,28.59,3.41,30l7.93-7.92c3.24,3.12,7.89,5.5,14.55,5.92A2,2,0,0,0,28,26V21.41A2,2,0,0,0,26.74,19.56Z\" transform=\"translate(0 0)\"/><path d=\"M8.15,18.19l3.52-3.52A11.68,11.68,0,0,1,10.85,12l2.07-2.07a2,2,0,0,0,.44-2.15l-1-2.52A2,2,0,0,0,10.5,4H6A2,2,0,0,0,4,6.22,29,29,0,0,0,8.15,18.19Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z\"/></svg>",
            "info": {},
            "path": "32/phone--off--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneOffFilled32",
          "filepath": "phone--off--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z"
                }
              }
            ],
            "name": "phone--off--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneOffFilled24",
          "filepath": "phone--off--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z"
                }
              }
            ],
            "name": "phone--off--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneOffFilled20",
          "filepath": "phone--off--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z"
                }
              }
            ],
            "name": "phone--off--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneOffFilled16",
          "filepath": "phone--off--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z"
                }
              }
            ],
            "name": "phone--off--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneOffFilled",
        "global": "PhoneOffFilled",
        "filepath": "PhoneOffFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--outgoing",
      "friendlyName": "Phone outgoing",
      "aliases": [
        "phone outgoing",
        "phone call",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--outgoing.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:#231F20;}\n\t.st1{fill:none;}\n</style>\n<path d=\"M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8\n\tc0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26\n\tC29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3\n\tl-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z\"/>\n<polygon class=\"st0\" points=\"20,4 20,6 24.6,6 18,12.6 19.4,14 26,7.4 26,12 28,12 28,4 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__250_\" x=\"0\" class=\"st1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8\tc0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26\tC29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3\tl-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z\"/><path d=\"M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z\"/></svg>",
            "info": {},
            "path": "32/phone--outgoing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneOutgoing32",
          "filepath": "phone--outgoing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8\tc0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26\tC29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3\tl-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
                }
              }
            ],
            "name": "phone--outgoing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneOutgoing24",
          "filepath": "phone--outgoing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8\tc0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26\tC29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3\tl-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
                }
              }
            ],
            "name": "phone--outgoing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneOutgoing20",
          "filepath": "phone--outgoing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8\tc0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26\tC29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3\tl-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
                }
              }
            ],
            "name": "phone--outgoing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneOutgoing16",
          "filepath": "phone--outgoing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8\tc0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26\tC29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3\tl-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
                }
              }
            ],
            "name": "phone--outgoing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneOutgoing",
        "global": "PhoneOutgoing",
        "filepath": "PhoneOutgoing.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8 c0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26 C29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3 l-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--outgoing--filled",
      "friendlyName": "Phone outgoing filled",
      "aliases": [
        "phone outgoing filled",
        "phone call",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--outgoing--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z\" transform=\"translate(0)\"/>\n  <polygon class=\"cls-1\" points=\"20 4 20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z\"/><path d=\"M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z\"/></svg>",
            "info": {},
            "path": "32/phone--outgoing--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneOutgoingFilled32",
          "filepath": "phone--outgoing--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
                }
              }
            ],
            "name": "phone--outgoing--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneOutgoingFilled24",
          "filepath": "phone--outgoing--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
                }
              }
            ],
            "name": "phone--outgoing--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneOutgoingFilled20",
          "filepath": "phone--outgoing--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
                }
              }
            ],
            "name": "phone--outgoing--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneOutgoingFilled16",
          "filepath": "phone--outgoing--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
                }
              }
            ],
            "name": "phone--outgoing--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneOutgoingFilled",
        "global": "PhoneOutgoingFilled",
        "filepath": "PhoneOutgoingFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--settings",
      "friendlyName": "Phone settings",
      "aliases": [
        "call",
        "phone",
        "preferences",
        "settings",
        "gear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--settings.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z\"/><path d=\"M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z\"/></svg>",
            "info": {},
            "path": "32/phone--settings.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneSettings32",
          "filepath": "phone--settings/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
                }
              }
            ],
            "name": "phone--settings",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneSettings24",
          "filepath": "phone--settings/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
                }
              }
            ],
            "name": "phone--settings",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneSettings20",
          "filepath": "phone--settings/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
                }
              }
            ],
            "name": "phone--settings",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneSettings16",
          "filepath": "phone--settings/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
                }
              }
            ],
            "name": "phone--settings",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneSettings",
        "global": "PhoneSettings",
        "filepath": "PhoneSettings.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--voice",
      "friendlyName": "Phone voice",
      "aliases": [
        "phone voice",
        "phone call",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--voice.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z\" transform=\"translate(0)\"/>\n  <path d=\"M28,13H26a7.0078,7.0078,0,0,0-7-7V4A9.01,9.01,0,0,1,28,13Z\" transform=\"translate(0)\"/>\n  <path d=\"M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z\"/><path d=\"M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z\"/></svg>",
            "info": {},
            "path": "32/phone--voice.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneVoice32",
          "filepath": "phone--voice/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z"
                }
              }
            ],
            "name": "phone--voice",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneVoice24",
          "filepath": "phone--voice/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z"
                }
              }
            ],
            "name": "phone--voice",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneVoice20",
          "filepath": "phone--voice/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z"
                }
              }
            ],
            "name": "phone--voice",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneVoice16",
          "filepath": "phone--voice/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z"
                }
              }
            ],
            "name": "phone--voice",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneVoice",
        "global": "PhoneVoice",
        "filepath": "PhoneVoice.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phone--voice--filled",
      "friendlyName": "Phone voice filled",
      "aliases": [
        "phone voice filled",
        "phone call",
        "call"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phone--voice--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z\" transform=\"translate(0)\"/>\n  <path d=\"M28,13H26a7.0078,7.0078,0,0,0-7-7V4A9.01,9.01,0,0,1,28,13Z\" transform=\"translate(0)\"/>\n  <path d=\"M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z\"/><path d=\"M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z\"/></svg>",
            "info": {},
            "path": "32/phone--voice--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhoneVoiceFilled32",
          "filepath": "phone--voice--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z"
                }
              }
            ],
            "name": "phone--voice--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhoneVoiceFilled24",
          "filepath": "phone--voice--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z"
                }
              }
            ],
            "name": "phone--voice--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhoneVoiceFilled20",
          "filepath": "phone--voice--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z"
                }
              }
            ],
            "name": "phone--voice--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhoneVoiceFilled16",
          "filepath": "phone--voice--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z"
                }
              }
            ],
            "name": "phone--voice--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "PhoneVoiceFilled",
        "global": "PhoneVoiceFilled",
        "filepath": "PhoneVoiceFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "phrase-sentiment",
      "friendlyName": "Phrase sentiment",
      "aliases": [
        "emotion",
        "meaning",
        "understanding",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/phrase-sentiment.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>phrase-sentiment</title><path d=\"M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/></svg>",
            "info": {},
            "path": "32/phrase-sentiment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PhraseSentiment32",
          "filepath": "phrase-sentiment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "phrase-sentiment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PhraseSentiment24",
          "filepath": "phrase-sentiment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "phrase-sentiment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PhraseSentiment20",
          "filepath": "phrase-sentiment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "phrase-sentiment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PhraseSentiment16",
          "filepath": "phrase-sentiment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "phrase-sentiment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "PhraseSentiment",
        "global": "PhraseSentiment",
        "filepath": "PhraseSentiment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "picnic-area",
      "friendlyName": "Picnic area",
      "aliases": [
        "rest area",
        "table",
        "travel",
        "rest stop"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/picnic-area.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>picnic-area</title>\n  <path d=\"M24,12a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,12Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,6Z\"/>\n  <path d=\"M26,22H21.8472L21.18,18H24V16H8v2h2.82l-.6668,4H6v2H9.82l-.6668,4H11.18l.6668-4h8.3056l.6668,4h2.0276L22.18,24H26ZM12.18,22l.6665-4h6.3062l.6665,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z\"/></svg>",
            "info": {},
            "path": "32/picnic-area.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PicnicArea32",
          "filepath": "picnic-area/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z"
                }
              }
            ],
            "name": "picnic-area",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PicnicArea24",
          "filepath": "picnic-area/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z"
                }
              }
            ],
            "name": "picnic-area",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PicnicArea20",
          "filepath": "picnic-area/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z"
                }
              }
            ],
            "name": "picnic-area",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PicnicArea16",
          "filepath": "picnic-area/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z"
                }
              }
            ],
            "name": "picnic-area",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PicnicArea",
        "global": "PicnicArea",
        "filepath": "PicnicArea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "piggy-bank",
      "friendlyName": "Piggy bank",
      "aliases": [
        "piggy bank",
        "savings",
        "cash",
        "money",
        "currency"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/piggy-bank.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z\"/>\n  <path d=\"M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z\"/><path d=\"M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z\"/></svg>",
            "info": {},
            "path": "32/piggy-bank.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PiggyBank32",
          "filepath": "piggy-bank/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PiggyBank24",
          "filepath": "piggy-bank/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PiggyBank20",
          "filepath": "piggy-bank/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PiggyBank16",
          "filepath": "piggy-bank/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "PiggyBank",
        "global": "PiggyBank",
        "filepath": "PiggyBank.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "piggy-bank--slot",
      "friendlyName": "Piggy bank slot",
      "aliases": [
        "piggy bank",
        "savings",
        "cash",
        "money",
        "currency",
        "money slot"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/piggy-bank--slot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"13\" y=\"11\" width=\"7\" height=\"2\"/>\n  <path d=\"M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 11H20V13H13z\"/><path d=\"M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z\"/></svg>",
            "info": {},
            "path": "32/piggy-bank--slot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PiggyBankSlot32",
          "filepath": "piggy-bank--slot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H20V13H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank--slot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PiggyBankSlot24",
          "filepath": "piggy-bank--slot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H20V13H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank--slot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PiggyBankSlot20",
          "filepath": "piggy-bank--slot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H20V13H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank--slot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PiggyBankSlot16",
          "filepath": "piggy-bank--slot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H20V13H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                }
              }
            ],
            "name": "piggy-bank--slot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "PiggyBankSlot",
        "global": "PiggyBankSlot",
        "filepath": "PiggyBankSlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 11H20V13H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pills",
      "friendlyName": "Pills",
      "aliases": [
        "health",
        "medicine",
        "medication",
        "rx",
        "prescription"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pills.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pills</title><path d=\"M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z\"/></svg>",
            "info": {},
            "path": "32/pills.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pills32",
          "filepath": "pills/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
                }
              }
            ],
            "name": "pills",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pills24",
          "filepath": "pills/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
                }
              }
            ],
            "name": "pills",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pills20",
          "filepath": "pills/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
                }
              }
            ],
            "name": "pills",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pills16",
          "filepath": "pills/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
                }
              }
            ],
            "name": "pills",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Pills",
        "global": "Pills",
        "filepath": "Pills.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pills--add",
      "friendlyName": "Pills add",
      "aliases": [
        "health",
        "medicine",
        "medication",
        "rx",
        "prescription"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pills--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pills--add</title><path d=\"M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z\" transform=\"translate(0 0)\"/><polygon points=\"25 21 23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z\"/><path d=\"M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z\"/></svg>",
            "info": {},
            "path": "32/pills--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PillsAdd32",
          "filepath": "pills--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
                }
              }
            ],
            "name": "pills--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PillsAdd24",
          "filepath": "pills--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
                }
              }
            ],
            "name": "pills--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PillsAdd20",
          "filepath": "pills--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
                }
              }
            ],
            "name": "pills--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PillsAdd16",
          "filepath": "pills--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
                }
              }
            ],
            "name": "pills--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "PillsAdd",
        "global": "PillsAdd",
        "filepath": "PillsAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pills--subtract",
      "friendlyName": "Pills subtract",
      "aliases": [
        "health",
        "medicine",
        "medication",
        "rx",
        "prescription"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pills--subtract.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pills--subtract</title><path d=\"M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z\" transform=\"translate(0 0)\"/><rect x=\"19\" y=\"21\" width=\"6\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z\"/><path d=\"M19 21H25V23H19z\"/></svg>",
            "info": {},
            "path": "32/pills--subtract.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PillsSubtract32",
          "filepath": "pills--subtract/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H25V23H19z"
                }
              }
            ],
            "name": "pills--subtract",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PillsSubtract24",
          "filepath": "pills--subtract/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H25V23H19z"
                }
              }
            ],
            "name": "pills--subtract",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PillsSubtract20",
          "filepath": "pills--subtract/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H25V23H19z"
                }
              }
            ],
            "name": "pills--subtract",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PillsSubtract16",
          "filepath": "pills--subtract/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 21H25V23H19z"
                }
              }
            ],
            "name": "pills--subtract",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "PillsSubtract",
        "global": "PillsSubtract",
        "filepath": "PillsSubtract.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 21H25V23H19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pin",
      "friendlyName": "Pin",
      "aliases": [
        "save",
        "favorite",
        "operations",
        "keep",
        "pin"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pin.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>pin</title><path d=\"M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z\"/></svg>",
            "info": {},
            "path": "32/pin.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pin32",
          "filepath": "pin/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
                }
              }
            ],
            "name": "pin",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pin24",
          "filepath": "pin/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
                }
              }
            ],
            "name": "pin",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pin20",
          "filepath": "pin/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
                }
              }
            ],
            "name": "pin",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pin16",
          "filepath": "pin/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
                }
              }
            ],
            "name": "pin",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Pin",
        "global": "Pin",
        "filepath": "Pin.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pin--filled",
      "friendlyName": "Pin filled",
      "aliases": [
        "save",
        "favorite",
        "operations",
        "keep",
        "pin filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pin--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z\"/></svg>",
            "info": {},
            "path": "32/pin--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PinFilled32",
          "filepath": "pin--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
                }
              }
            ],
            "name": "pin--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PinFilled24",
          "filepath": "pin--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
                }
              }
            ],
            "name": "pin--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PinFilled20",
          "filepath": "pin--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
                }
              }
            ],
            "name": "pin--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PinFilled16",
          "filepath": "pin--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
                }
              }
            ],
            "name": "pin--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "PinFilled",
        "global": "PinFilled",
        "filepath": "PinFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "plan",
      "friendlyName": "plan",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/plan.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4\n\tC1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7\n\tl6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4\n\tl-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4\tC1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7\tl6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4\tl-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z\"/></svg>",
            "info": {},
            "path": "32/plan.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Plan32",
          "filepath": "plan/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4\tC1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7\tl6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4\tl-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
                }
              }
            ],
            "name": "plan",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Plan24",
          "filepath": "plan/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4\tC1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7\tl6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4\tl-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
                }
              }
            ],
            "name": "plan",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Plan20",
          "filepath": "plan/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4\tC1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7\tl6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4\tl-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
                }
              }
            ],
            "name": "plan",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Plan16",
          "filepath": "plan/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4\tC1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7\tl6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4\tl-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
                }
              }
            ],
            "name": "plan",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Plan",
        "global": "Plan",
        "filepath": "Plan.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4 C1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7 l6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4 l-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "plane",
      "friendlyName": "Plane",
      "aliases": [
        "airplane",
        "flight",
        "travel",
        "jet",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/plane.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>plane</title><path d=\"M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z\"/></svg>",
            "info": {},
            "path": "32/plane.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Plane32",
          "filepath": "plane/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
                }
              }
            ],
            "name": "plane",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Plane24",
          "filepath": "plane/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
                }
              }
            ],
            "name": "plane",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Plane20",
          "filepath": "plane/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
                }
              }
            ],
            "name": "plane",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Plane16",
          "filepath": "plane/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
                }
              }
            ],
            "name": "plane",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Plane",
        "global": "Plane",
        "filepath": "Plane.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "plane--private",
      "friendlyName": "Plane private",
      "aliases": [
        "airplane",
        "flight",
        "travel",
        "jet",
        "transportation",
        "private",
        "plane"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/plane--private.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z\"/><path d=\"M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z\"/></svg>",
            "info": {},
            "path": "32/plane--private.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PlanePrivate32",
          "filepath": "plane--private/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
                }
              }
            ],
            "name": "plane--private",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PlanePrivate24",
          "filepath": "plane--private/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
                }
              }
            ],
            "name": "plane--private",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PlanePrivate20",
          "filepath": "plane--private/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
                }
              }
            ],
            "name": "plane--private",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PlanePrivate16",
          "filepath": "plane--private/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
                }
              }
            ],
            "name": "plane--private",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PlanePrivate",
        "global": "PlanePrivate",
        "filepath": "PlanePrivate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "plane--sea",
      "friendlyName": "Plane sea",
      "aliases": [
        "airplane",
        "flight",
        "travel",
        "jet",
        "transportation",
        "plane",
        "sea plane"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/plane--sea.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,30H28a4.9316,4.9316,0,0,1-4-1.9873,5.0192,5.0192,0,0,1-8,0,5.0192,5.0192,0,0,1-8,0A4.9316,4.9316,0,0,1,4,30H2V28H4a3.44,3.44,0,0,0,3.0532-2.3215A.9712.9712,0,0,1,8,25a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,12,28a3.44,3.44,0,0,0,3.0532-2.3215A.99.99,0,0,1,16,25a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,20,28a3.44,3.44,0,0,0,3.0532-2.3215,1,1,0,0,1,1.8955.0053A3.4381,3.4381,0,0,0,28,28h2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,6v4H25.5L23.4,7.2A3.0129,3.0129,0,0,0,21,6H15a3.0033,3.0033,0,0,0-3,3v1H8.6182L7.8945,8.5527l-1-2A1,1,0,0,0,6,6H3A1,1,0,0,0,2,7v6a3.0033,3.0033,0,0,0,3,3h6.82l-.6666,4H7a1,1,0,0,0,0,2H27a1,1,0,0,0,0-2H22.847L22.18,16h.1629a4.9662,4.9662,0,0,0,3.5351-1.4648L28,12.4141V16h2V6ZM14,9a1.0009,1.0009,0,0,1,1-1h6a1.0045,1.0045,0,0,1,.8.4L23,10H14Zm6.82,11H13.18l.6666-4h6.306Zm1.5237-6H5a1.0009,1.0009,0,0,1-1-1V8H5.3818l.7237,1.4473L7.3818,12h18.204l-1.1214,1.1211A2.9789,2.9789,0,0,1,22.3433,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z\"/></svg>",
            "info": {},
            "path": "32/plane--sea.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PlaneSea32",
          "filepath": "plane--sea/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z"
                }
              }
            ],
            "name": "plane--sea",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PlaneSea24",
          "filepath": "plane--sea/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z"
                }
              }
            ],
            "name": "plane--sea",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PlaneSea20",
          "filepath": "plane--sea/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z"
                }
              }
            ],
            "name": "plane--sea",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PlaneSea16",
          "filepath": "plane--sea/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z"
                }
              }
            ],
            "name": "plane--sea",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "PlaneSea",
        "global": "PlaneSea",
        "filepath": "PlaneSea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "play",
      "friendlyName": "Play",
      "aliases": [
        "start",
        "stop",
        "music",
        "video",
        "audio",
        "control",
        "controls"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/play.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>play</title>\n<path d=\"M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7\n\tc0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7\tc0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z\"/></svg>",
            "info": {},
            "path": "16/play.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/play.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z\"/></svg>",
            "info": {},
            "path": "32/play.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Play32",
          "filepath": "play/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
                }
              }
            ],
            "name": "play",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Play24",
          "filepath": "play/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
                }
              }
            ],
            "name": "play",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Play20",
          "filepath": "play/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
                }
              }
            ],
            "name": "play",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Play16",
          "filepath": "play/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7\tc0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z"
                }
              }
            ],
            "name": "play",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Play",
        "global": "Play",
        "filepath": "Play.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7 c0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "play--filled",
      "friendlyName": "Play filled",
      "aliases": [
        "start",
        "stop",
        "music",
        "video",
        "audio",
        "control",
        "controls"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/play--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>play--solid--filled</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5\n\tc0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5\tc0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z\"/></svg>",
            "info": {},
            "path": "16/play--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/play--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z\"/>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z\"/></svg>",
            "info": {},
            "path": "32/play--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PlayFilled32",
          "filepath": "play--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                }
              }
            ],
            "name": "play--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PlayFilled24",
          "filepath": "play--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                }
              }
            ],
            "name": "play--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PlayFilled20",
          "filepath": "play--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                }
              }
            ],
            "name": "play--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PlayFilled16",
          "filepath": "play--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5\tc0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
                }
              }
            ],
            "name": "play--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PlayFilled",
        "global": "PlayFilled",
        "filepath": "PlayFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "play--filled--alt",
      "friendlyName": "Play filled alt",
      "aliases": [
        "start",
        "stop",
        "music",
        "video",
        "audio",
        "control",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/play--filled--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z\"/></svg>",
            "info": {},
            "path": "32/play--filled--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PlayFilledAlt32",
          "filepath": "play--filled--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
                }
              }
            ],
            "name": "play--filled--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PlayFilledAlt24",
          "filepath": "play--filled--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
                }
              }
            ],
            "name": "play--filled--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PlayFilledAlt20",
          "filepath": "play--filled--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
                }
              }
            ],
            "name": "play--filled--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PlayFilledAlt16",
          "filepath": "play--filled--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
                }
              }
            ],
            "name": "play--filled--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PlayFilledAlt",
        "global": "PlayFilledAlt",
        "filepath": "PlayFilledAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "play--outline",
      "friendlyName": "Play outline",
      "aliases": [
        "start",
        "stop",
        "music",
        "video",
        "audio",
        "control",
        "controls"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/play--outline.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>play--outline</title>\n<path d=\"M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z\"/>\n<path d=\"M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3\n\tC12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z\"/><path d=\"M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3\tC12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z\"/></svg>",
            "info": {},
            "path": "16/play--outline.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/play--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z\"/>\n  <path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z\"/><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/play--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PlayOutline32",
          "filepath": "play--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "play--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PlayOutline24",
          "filepath": "play--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "play--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PlayOutline20",
          "filepath": "play--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              }
            ],
            "name": "play--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PlayOutline16",
          "filepath": "play--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3\tC12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z"
                }
              }
            ],
            "name": "play--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PlayOutline",
        "global": "PlayOutline",
        "filepath": "PlayOutline.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3 C12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "play--outline--filled",
      "friendlyName": "Play outline filled",
      "aliases": [
        "start",
        "stop",
        "music",
        "video",
        "audio",
        "control",
        "controls"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/play--outline--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>play--outline--filled</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5\n\tc0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z\"/>\n<polygon points=\"6.5,10.2 10.5,8 6.5,5.8 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5\tc0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z\"/><path d=\"M6.5 10.2L10.5 8 6.5 5.8z\"/></svg>",
            "info": {},
            "path": "16/play--outline--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/play--outline--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z\"/>\n  <polygon points=\"12 20.382 20.764 16 12 11.618 12 20.382\"/>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z\"/><path d=\"M12 20.382L20.764 16 12 11.618 12 20.382z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z\"/></svg>",
            "info": {},
            "path": "32/play--outline--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PlayOutlineFilled32",
          "filepath": "play--outline--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 20.382L20.764 16 12 11.618 12 20.382z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                }
              }
            ],
            "name": "play--outline--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PlayOutlineFilled24",
          "filepath": "play--outline--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 20.382L20.764 16 12 11.618 12 20.382z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                }
              }
            ],
            "name": "play--outline--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PlayOutlineFilled20",
          "filepath": "play--outline--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 20.382L20.764 16 12 11.618 12 20.382z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                }
              }
            ],
            "name": "play--outline--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PlayOutlineFilled16",
          "filepath": "play--outline--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5\tc0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.5 10.2L10.5 8 6.5 5.8z"
                }
              }
            ],
            "name": "play--outline--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PlayOutlineFilled",
        "global": "PlayOutlineFilled",
        "filepath": "PlayOutlineFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.5 10.2L10.5 8 6.5 5.8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 20.382L20.764 16 12 11.618 12 20.382z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "playlist",
      "friendlyName": "Playlist",
      "aliases": [
        "music",
        "play",
        "dj",
        "file",
        "audio",
        "video"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/playlist.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>playlist</title><rect x=\"4\" y=\"6\" width=\"18\" height=\"2\"/><rect x=\"4\" y=\"12\" width=\"18\" height=\"2\"/><rect x=\"4\" y=\"18\" width=\"12\" height=\"2\"/><polygon points=\"21 18 28 23 21 28 21 18\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z\"/></svg>",
            "info": {},
            "path": "32/playlist.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Playlist32",
          "filepath": "playlist/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z"
                }
              }
            ],
            "name": "playlist",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Playlist24",
          "filepath": "playlist/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z"
                }
              }
            ],
            "name": "playlist",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Playlist20",
          "filepath": "playlist/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z"
                }
              }
            ],
            "name": "playlist",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Playlist16",
          "filepath": "playlist/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z"
                }
              }
            ],
            "name": "playlist",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Playlist",
        "global": "Playlist",
        "filepath": "Playlist.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "plug",
      "friendlyName": "Plug",
      "aliases": [
        "technology",
        "electric",
        "power",
        "charge",
        "charger"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/plug.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>plug</title>\n  <path d=\"M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z\"/></svg>",
            "info": {},
            "path": "32/plug.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Plug32",
          "filepath": "plug/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
                }
              }
            ],
            "name": "plug",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Plug24",
          "filepath": "plug/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
                }
              }
            ],
            "name": "plug",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Plug20",
          "filepath": "plug/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
                }
              }
            ],
            "name": "plug",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Plug16",
          "filepath": "plug/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
                }
              }
            ],
            "name": "plug",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Plug",
        "global": "Plug",
        "filepath": "Plug.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "plug--filled",
      "friendlyName": "Plug filled",
      "aliases": [
        "technology",
        "electric",
        "power",
        "charge",
        "charger"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/plug--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>plug--filled</title>\n  <path d=\"M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z\"/></svg>",
            "info": {},
            "path": "32/plug--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PlugFilled32",
          "filepath": "plug--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
                }
              }
            ],
            "name": "plug--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PlugFilled24",
          "filepath": "plug--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
                }
              }
            ],
            "name": "plug--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PlugFilled20",
          "filepath": "plug--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
                }
              }
            ],
            "name": "plug--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PlugFilled16",
          "filepath": "plug--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
                }
              }
            ],
            "name": "plug--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "PlugFilled",
        "global": "PlugFilled",
        "filepath": "PlugFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "PNG",
      "friendlyName": "PNG",
      "aliases": [
        "file",
        "type",
        "format",
        "pic",
        "picture",
        "photo",
        "image",
        "compress",
        "compression"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/PNG.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>PNG</title><path d=\"M30,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H24V21h4V17H26V15h4Z\" transform=\"translate(0 0)\"/><polygon points=\"18 19 14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19\"/><path d=\"M4,23H2V9H8a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H4Zm0-7H8V11H4Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z\"/></svg>",
            "info": {},
            "path": "32/PNG.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Png32",
          "filepath": "PNG/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z"
                }
              }
            ],
            "name": "PNG",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Png24",
          "filepath": "PNG/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z"
                }
              }
            ],
            "name": "PNG",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Png20",
          "filepath": "PNG/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z"
                }
              }
            ],
            "name": "PNG",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Png16",
          "filepath": "PNG/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z"
                }
              }
            ],
            "name": "PNG",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Png",
        "global": "Png",
        "filepath": "Png.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "point-of-presence",
      "friendlyName": "Point of presence",
      "aliases": [
        "point",
        "presence",
        "interface",
        "communications",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/point-of-presence.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H18a2.0021,2.0021,0,0,1-2-2V18a2.0021,2.0021,0,0,1,2-2h2v2H18V28H28V18H26V16h2a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,16H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H14a2.0021,2.0021,0,0,1,2,2V6H14V4H4V14H14V12h2v2A2.0021,2.0021,0,0,1,14,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z\"/><path d=\"M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z\"/></svg>",
            "info": {},
            "path": "32/point-of-presence.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PointOfPresence32",
          "filepath": "point-of-presence/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
                }
              }
            ],
            "name": "point-of-presence",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PointOfPresence24",
          "filepath": "point-of-presence/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
                }
              }
            ],
            "name": "point-of-presence",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PointOfPresence20",
          "filepath": "point-of-presence/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
                }
              }
            ],
            "name": "point-of-presence",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PointOfPresence16",
          "filepath": "point-of-presence/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
                }
              }
            ],
            "name": "point-of-presence",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "PointOfPresence",
        "global": "PointOfPresence",
        "filepath": "PointOfPresence.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pointer-text",
      "friendlyName": "Pointer text",
      "aliases": [
        "cursor",
        "text",
        "arrow"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/pointer-text.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--pointer-text</title><polygon points=\"13.71 12.29 7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29\"/><path d=\"M28,30H12a2,2,0,0,1-2-2V18h2V28H28V12H18V10H28a2,2,0,0,1,2,2V28A2,2,0,0,1,28,30Z\"/><path d=\"M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z\"/><path d=\"M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/pointer-text.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthPointerText32",
          "filepath": "watson-health/pointer-text/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
                }
              }
            ],
            "name": "pointer-text",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthPointerText24",
          "filepath": "watson-health/pointer-text/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
                }
              }
            ],
            "name": "pointer-text",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthPointerText20",
          "filepath": "watson-health/pointer-text/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
                }
              }
            ],
            "name": "pointer-text",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthPointerText16",
          "filepath": "watson-health/pointer-text/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
                }
              }
            ],
            "name": "pointer-text",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "PointerText",
        "global": "WatsonHealthPointerText",
        "filepath": "watson-health/PointerText.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "police",
      "friendlyName": "Police",
      "aliases": [
        "travel",
        "traffic",
        "enforcement",
        "security",
        "guard"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/police.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>police</title>\n  <rect x=\"10\" y=\"24\" width=\"2\" height=\"6\"/>\n  <path d=\"M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z\"/>\n  <path d=\"M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 24H12V30H10z\"/><path d=\"M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z\"/><path d=\"M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z\"/></svg>",
            "info": {},
            "path": "32/police.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Police32",
          "filepath": "police/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 24H12V30H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
                }
              }
            ],
            "name": "police",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Police24",
          "filepath": "police/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 24H12V30H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
                }
              }
            ],
            "name": "police",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Police20",
          "filepath": "police/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 24H12V30H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
                }
              }
            ],
            "name": "police",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Police16",
          "filepath": "police/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 24H12V30H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
                }
              }
            ],
            "name": "police",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Police",
        "global": "Police",
        "filepath": "Police.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 24H12V30H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "policy",
      "friendlyName": "Policy",
      "aliases": [
        "policy",
        "contract"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/policy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>policy</title><path d=\"M30,18A6,6,0,1,0,20,22.46v7.54l4-1.8926,4,1.8926V22.46A5.98,5.98,0,0,0,30,18Zm-4,8.84-2-.9467L22,26.84V23.65a5.8877,5.8877,0,0,0,4,0ZM24,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,22Z\"/><rect x=\"9\" y=\"14\" width=\"7\" height=\"2\"/><rect x=\"9\" y=\"8\" width=\"10\" height=\"2\"/><path d=\"M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z\"/><path d=\"M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z\"/></svg>",
            "info": {},
            "path": "32/policy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Policy32",
          "filepath": "policy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
                }
              }
            ],
            "name": "policy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Policy24",
          "filepath": "policy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
                }
              }
            ],
            "name": "policy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Policy20",
          "filepath": "policy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
                }
              }
            ],
            "name": "policy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Policy16",
          "filepath": "policy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
                }
              }
            ],
            "name": "policy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Policy",
        "global": "Policy",
        "filepath": "Policy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "popup",
      "friendlyName": "Pop-up",
      "aliases": [
        "modal",
        "overlay",
        "expand",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/popup.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>popup</title><path d=\"M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z\"/><path d=\"M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z\"/><path d=\"M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z\"/></svg>",
            "info": {},
            "path": "32/popup.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Popup32",
          "filepath": "popup/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
                }
              }
            ],
            "name": "popup",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Popup24",
          "filepath": "popup/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
                }
              }
            ],
            "name": "popup",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Popup20",
          "filepath": "popup/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
                }
              }
            ],
            "name": "popup",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Popup16",
          "filepath": "popup/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
                }
              }
            ],
            "name": "popup",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Popup",
        "global": "Popup",
        "filepath": "Popup.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "port--input",
      "friendlyName": "port--input",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/port--input.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z\"/>\n  <polygon points=\"23 16 16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z\"/><path d=\"M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z\"/></svg>",
            "info": {},
            "path": "32/port--input.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PortInput32",
          "filepath": "port--input/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
                }
              }
            ],
            "name": "port--input",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PortInput24",
          "filepath": "port--input/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
                }
              }
            ],
            "name": "port--input",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PortInput20",
          "filepath": "port--input/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
                }
              }
            ],
            "name": "port--input",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PortInput16",
          "filepath": "port--input/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
                }
              }
            ],
            "name": "port--input",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "PortInput",
        "global": "PortInput",
        "filepath": "PortInput.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "port--output",
      "friendlyName": "port--output",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/port--output.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 16 23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16\"/>\n  <path d=\"M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z\"/><path d=\"M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z\"/></svg>",
            "info": {},
            "path": "32/port--output.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PortOutput32",
          "filepath": "port--output/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
                }
              }
            ],
            "name": "port--output",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PortOutput24",
          "filepath": "port--output/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
                }
              }
            ],
            "name": "port--output",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PortOutput20",
          "filepath": "port--output/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
                }
              }
            ],
            "name": "port--output",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PortOutput16",
          "filepath": "port--output/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
                }
              }
            ],
            "name": "port--output",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "PortOutput",
        "global": "PortOutput",
        "filepath": "PortOutput.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "portfolio",
      "friendlyName": "Portfolio",
      "aliases": [
        "briefcase",
        "suitcase",
        "travel",
        "case",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/portfolio.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>portfolio</title><path d=\"M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z\"/></svg>",
            "info": {},
            "path": "32/portfolio.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Portfolio32",
          "filepath": "portfolio/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
                }
              }
            ],
            "name": "portfolio",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Portfolio24",
          "filepath": "portfolio/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
                }
              }
            ],
            "name": "portfolio",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Portfolio20",
          "filepath": "portfolio/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
                }
              }
            ],
            "name": "portfolio",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Portfolio16",
          "filepath": "portfolio/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
                }
              }
            ],
            "name": "portfolio",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Portfolio",
        "global": "Portfolio",
        "filepath": "Portfolio.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "power",
      "friendlyName": "Power",
      "aliases": [
        "on",
        "off",
        "start",
        "stop",
        "controls"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/power.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>power</title>\n<path d=\"M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9\n\tc-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z\"/>\n<rect x=\"7.5\" y=\"1\" width=\"1\" height=\"7\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9\tc-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z\"/><path d=\"M7.5 1H8.5V8H7.5z\"/></svg>",
            "info": {},
            "path": "16/power.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/power.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>power</title><path d=\"M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z\" transform=\"translate(0)\"/><rect x=\"15\" y=\"2\" width=\"2\" height=\"14\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z\"/><path d=\"M15 2H17V16H15z\"/></svg>",
            "info": {},
            "path": "32/power.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Power32",
          "filepath": "power/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V16H15z"
                }
              }
            ],
            "name": "power",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Power24",
          "filepath": "power/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V16H15z"
                }
              }
            ],
            "name": "power",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Power20",
          "filepath": "power/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V16H15z"
                }
              }
            ],
            "name": "power",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Power16",
          "filepath": "power/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9\tc-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 1H8.5V8H7.5z"
                }
              }
            ],
            "name": "power",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Power",
        "global": "Power",
        "filepath": "Power.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9 c-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 1H8.5V8H7.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V16H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "PPT",
      "friendlyName": "PPT",
      "aliases": [
        "PPT",
        "powerpoint",
        "presentation",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/PPT.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>PPT</title><polygon points=\"22 11 25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11\"/><path d=\"M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z\"/><path d=\"M4,23H2V9H8a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H4Zm0-7H8V10.9985H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z\"/></svg>",
            "info": {},
            "path": "32/PPT.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Ppt32",
          "filepath": "PPT/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
                }
              }
            ],
            "name": "PPT",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Ppt24",
          "filepath": "PPT/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
                }
              }
            ],
            "name": "PPT",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Ppt20",
          "filepath": "PPT/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
                }
              }
            ],
            "name": "PPT",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Ppt16",
          "filepath": "PPT/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
                }
              }
            ],
            "name": "PPT",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Ppt",
        "global": "Ppt",
        "filepath": "Ppt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "presentation-file",
      "friendlyName": "Presentation file",
      "aliases": [
        "keynote",
        "chart",
        "meeting",
        "graph",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/presentation-file.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>presentation-file</title><rect x=\"15\" y=\"10\" width=\"2\" height=\"8\"/><rect x=\"20\" y=\"14\" width=\"2\" height=\"4\"/><rect x=\"10\" y=\"12\" width=\"2\" height=\"6\"/><path d=\"M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z\"/><path d=\"M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z\"/></svg>",
            "info": {},
            "path": "32/presentation-file.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PresentationFile32",
          "filepath": "presentation-file/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
                }
              }
            ],
            "name": "presentation-file",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PresentationFile24",
          "filepath": "presentation-file/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
                }
              }
            ],
            "name": "presentation-file",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PresentationFile20",
          "filepath": "presentation-file/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
                }
              }
            ],
            "name": "presentation-file",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PresentationFile16",
          "filepath": "presentation-file/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
                }
              }
            ],
            "name": "presentation-file",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "PresentationFile",
        "global": "PresentationFile",
        "filepath": "PresentationFile.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pressure",
      "friendlyName": "Pressure",
      "aliases": [
        "weather",
        "atmosphere",
        "barometric",
        "air"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pressure.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>pressure</title>\n  <path d=\"M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z\"/></svg>",
            "info": {},
            "path": "32/pressure.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Pressure32",
          "filepath": "pressure/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
                }
              }
            ],
            "name": "pressure",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Pressure24",
          "filepath": "pressure/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
                }
              }
            ],
            "name": "pressure",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Pressure20",
          "filepath": "pressure/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
                }
              }
            ],
            "name": "pressure",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Pressure16",
          "filepath": "pressure/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
                }
              }
            ],
            "name": "pressure",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Pressure",
        "global": "Pressure",
        "filepath": "Pressure.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "pressure--filled",
      "friendlyName": "Pressure filled",
      "aliases": [
        "weather",
        "atmosphere"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/pressure--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>pressure--filled</title>\n  <path d=\"M22,30H10V25H6l10-9,10,9H22Z\"/>\n  <path d=\"M16,16,6,7h4V2H22V7h4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z\"/></svg>",
            "info": {},
            "path": "32/pressure--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PressureFilled32",
          "filepath": "pressure--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
                }
              }
            ],
            "name": "pressure--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PressureFilled24",
          "filepath": "pressure--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
                }
              }
            ],
            "name": "pressure--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PressureFilled20",
          "filepath": "pressure--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
                }
              }
            ],
            "name": "pressure--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PressureFilled16",
          "filepath": "pressure--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
                }
              }
            ],
            "name": "pressure--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "PressureFilled",
        "global": "PressureFilled",
        "filepath": "PressureFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "previous--filled",
      "friendlyName": "Previous filled",
      "aliases": [
        "previous filled",
        "previous"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/previous--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z\"/>\n  <polygon id=\"inner-path\" class=\"cls-1\" points=\"16 8 17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z\"/><path fill=\"none\" d=\"M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/previous--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PreviousFilled32",
          "filepath": "previous--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "previous--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PreviousFilled24",
          "filepath": "previous--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "previous--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PreviousFilled20",
          "filepath": "previous--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "previous--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PreviousFilled16",
          "filepath": "previous--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "previous--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PreviousFilled",
        "global": "PreviousFilled",
        "filepath": "PreviousFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "previous--outline",
      "friendlyName": "Previous outline",
      "aliases": [
        "previous outline",
        "previous"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/previous--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 8 17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/previous--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PreviousOutline32",
          "filepath": "previous--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "previous--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PreviousOutline24",
          "filepath": "previous--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "previous--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PreviousOutline20",
          "filepath": "previous--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "previous--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PreviousOutline16",
          "filepath": "previous--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "previous--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "PreviousOutline",
        "global": "PreviousOutline",
        "filepath": "PreviousOutline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "printer",
      "friendlyName": "Printer",
      "aliases": [
        "print",
        "copy",
        "file",
        "paper"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/printer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>printer</title><path d=\"M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z\"/></svg>",
            "info": {},
            "path": "32/printer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Printer32",
          "filepath": "printer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
                }
              }
            ],
            "name": "printer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Printer24",
          "filepath": "printer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
                }
              }
            ],
            "name": "printer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Printer20",
          "filepath": "printer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
                }
              }
            ],
            "name": "printer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Printer16",
          "filepath": "printer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
                }
              }
            ],
            "name": "printer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Printer",
        "global": "Printer",
        "filepath": "Printer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "product",
      "friendlyName": "Product",
      "aliases": [
        "product"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/product.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>product</title><rect x=\"8\" y=\"18\" width=\"6\" height=\"2\"/><rect x=\"8\" y=\"22\" width=\"10\" height=\"2\"/><path d=\"M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 18H14V20H8zM8 22H18V24H8z\"/><path d=\"M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z\"/></svg>",
            "info": {},
            "path": "32/product.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Product32",
          "filepath": "product/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H14V20H8zM8 22H18V24H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
                }
              }
            ],
            "name": "product",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Product24",
          "filepath": "product/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H14V20H8zM8 22H18V24H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
                }
              }
            ],
            "name": "product",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Product20",
          "filepath": "product/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H14V20H8zM8 22H18V24H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
                }
              }
            ],
            "name": "product",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Product16",
          "filepath": "product/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18H14V20H8zM8 22H18V24H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
                }
              }
            ],
            "name": "product",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Product",
        "global": "Product",
        "filepath": "Product.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 18H14V20H8zM8 22H18V24H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "progress-bar",
      "friendlyName": "Progress bar",
      "aliases": [
        "progress bar",
        "loading"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/progress-bar.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z\"/>\n  <rect x=\"6\" y=\"15\" width=\"14\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z\"/><path d=\"M6 15H20V17H6z\"/></svg>",
            "info": {},
            "path": "32/progress-bar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ProgressBar32",
          "filepath": "progress-bar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              }
            ],
            "name": "progress-bar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ProgressBar24",
          "filepath": "progress-bar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              }
            ],
            "name": "progress-bar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ProgressBar20",
          "filepath": "progress-bar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              }
            ],
            "name": "progress-bar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ProgressBar16",
          "filepath": "progress-bar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 15H20V17H6z"
                }
              }
            ],
            "name": "progress-bar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ProgressBar",
        "global": "ProgressBar",
        "filepath": "ProgressBar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 15H20V17H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "progress-bar--round",
      "friendlyName": "Progress bar round",
      "aliases": [
        "progreess bar round",
        "loading"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/progress-bar--round.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z\"/>\n  <path d=\"M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z\"/><path d=\"M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/progress-bar--round.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ProgressBarRound32",
          "filepath": "progress-bar--round/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "progress-bar--round",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ProgressBarRound24",
          "filepath": "progress-bar--round/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "progress-bar--round",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ProgressBarRound20",
          "filepath": "progress-bar--round/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "progress-bar--round",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ProgressBarRound16",
          "filepath": "progress-bar--round/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "progress-bar--round",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ProgressBarRound",
        "global": "ProgressBarRound",
        "filepath": "ProgressBarRound.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "promote",
      "friendlyName": "promote",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/promote.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"16,21 17.4,22.4 14.8,25 23,25 23,27 14.8,27 17.4,29.6 16,31 11,26 \"/>\n<rect x=\"6.3\" y=\"19\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -10.6274 14.3431)\" width=\"11.3\" height=\"2\"/>\n<path d=\"M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1\n\tC15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6\n\tl3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z\"/><path d=\"M6.3 19H17.6V21H6.3z\" transform=\"rotate(-45.001 12 20)\"/><path d=\"M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1\tC15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6\tl3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z\"/></svg>",
            "info": {},
            "path": "32/promote.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Promote32",
          "filepath": "promote/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3 19H17.6V21H6.3z",
                  "transform": "rotate(-45.001 12 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1\tC15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6\tl3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
                }
              }
            ],
            "name": "promote",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Promote24",
          "filepath": "promote/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3 19H17.6V21H6.3z",
                  "transform": "rotate(-45.001 12 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1\tC15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6\tl3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
                }
              }
            ],
            "name": "promote",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Promote20",
          "filepath": "promote/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3 19H17.6V21H6.3z",
                  "transform": "rotate(-45.001 12 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1\tC15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6\tl3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
                }
              }
            ],
            "name": "promote",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Promote16",
          "filepath": "promote/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3 19H17.6V21H6.3z",
                  "transform": "rotate(-45.001 12 20)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1\tC15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6\tl3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
                }
              }
            ],
            "name": "promote",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Promote",
        "global": "Promote",
        "filepath": "Promote.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.3 19H17.6V21H6.3z",
                    "transform": "rotate(-45.001 12 20)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1 C15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6 l3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "property-relationship",
      "friendlyName": "Property relationship",
      "aliases": [
        "property",
        "relationship",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/property-relationship.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"30,16 22,24 20.6,22.6 27.2,16 20.6,9.4 22,8 \"/>\n<rect x=\"12\" y=\"15\" width=\"8\" height=\"2\"/>\n<polygon points=\"2,16 10,8 11.4,9.4 4.8,16 11.4,22.6 10,24 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z\"/></svg>",
            "info": {},
            "path": "32/property-relationship.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "PropertyRelationship32",
          "filepath": "property-relationship/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
                }
              }
            ],
            "name": "property-relationship",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "PropertyRelationship24",
          "filepath": "property-relationship/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
                }
              }
            ],
            "name": "property-relationship",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "PropertyRelationship20",
          "filepath": "property-relationship/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
                }
              }
            ],
            "name": "property-relationship",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "PropertyRelationship16",
          "filepath": "property-relationship/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
                }
              }
            ],
            "name": "property-relationship",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "PropertyRelationship",
        "global": "PropertyRelationship",
        "filepath": "PropertyRelationship.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "purchase",
      "friendlyName": "Purchase",
      "aliases": [
        "charge",
        "card",
        "credit card",
        "debit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/purchase.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>purchase</title><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z\" transform=\"translate(0 0)\"/><rect x=\"6\" y=\"20\" width=\"10\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z\"/><path d=\"M6 20H16V22H6z\"/></svg>",
            "info": {},
            "path": "32/purchase.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Purchase32",
          "filepath": "purchase/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20H16V22H6z"
                }
              }
            ],
            "name": "purchase",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Purchase24",
          "filepath": "purchase/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20H16V22H6z"
                }
              }
            ],
            "name": "purchase",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Purchase20",
          "filepath": "purchase/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20H16V22H6z"
                }
              }
            ],
            "name": "purchase",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Purchase16",
          "filepath": "purchase/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 20H16V22H6z"
                }
              }
            ],
            "name": "purchase",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Purchase",
        "global": "Purchase",
        "filepath": "Purchase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 20H16V22H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "QC-launch",
      "friendlyName": "QC launch",
      "aliases": [
        "QC",
        "launch",
        "Watson Health®"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/QC-launch.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,22H19a2.0023,2.0023,0,0,1-2-2V10a2.002,2.002,0,0,1,2-2h6v2H19V20h6Z\"/>\n  <path d=\"M13,8H9a2.002,2.002,0,0,0-2,2V20a2.0023,2.0023,0,0,0,2,2h1v2a2.0023,2.0023,0,0,0,2,2h2V24H12V22h1a2.0023,2.0023,0,0,0,2-2V10A2.002,2.002,0,0,0,13,8ZM9,20V10h4V20Z\"/>\n  <path d=\"M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z\"/><path d=\"M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/QC-launch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthQcLaunch32",
          "filepath": "watson-health/QC-launch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "QC-launch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthQcLaunch24",
          "filepath": "watson-health/QC-launch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "QC-launch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthQcLaunch20",
          "filepath": "watson-health/QC-launch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "QC-launch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthQcLaunch16",
          "filepath": "watson-health/QC-launch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "QC-launch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "QcLaunch",
        "global": "WatsonHealthQcLaunch",
        "filepath": "watson-health/QcLaunch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "qq-plot",
      "friendlyName": "QQ plot",
      "aliases": [
        "chart",
        "data",
        "analytics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/qq-plot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>qq-plot</title>\n  <circle cx=\"20\" cy=\"4\" r=\"2\"/>\n  <circle cx=\"8\" cy=\"16\" r=\"2\"/>\n  <circle cx=\"28\" cy=\"12\" r=\"2\"/>\n  <circle cx=\"11\" cy=\"7\" r=\"2\"/>\n  <circle cx=\"16\" cy=\"24\" r=\"2\"/>\n  <path d=\"M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"20\" cy=\"4\" r=\"2\"/><circle cx=\"8\" cy=\"16\" r=\"2\"/><circle cx=\"28\" cy=\"12\" r=\"2\"/><circle cx=\"11\" cy=\"7\" r=\"2\"/><circle cx=\"16\" cy=\"24\" r=\"2\"/><path d=\"M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z\"/></svg>",
            "info": {},
            "path": "32/qq-plot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QqPlot32",
          "filepath": "qq-plot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
                }
              }
            ],
            "name": "qq-plot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QqPlot24",
          "filepath": "qq-plot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
                }
              }
            ],
            "name": "qq-plot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QqPlot20",
          "filepath": "qq-plot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
                }
              }
            ],
            "name": "qq-plot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QqPlot16",
          "filepath": "qq-plot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "20",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "8",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "7",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
                }
              }
            ],
            "name": "qq-plot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "QqPlot",
        "global": "QqPlot",
        "filepath": "QqPlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "20",
                    "cy": "4",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "8",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "7",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "qr-code",
      "friendlyName": "QR code",
      "aliases": [
        "qr code"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/qr-code.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>qr-code</title><rect x=\"24\" y=\"26\" width=\"2\" height=\"2\" transform=\"translate(-2 52) rotate(-90)\"/><rect x=\"18\" y=\"22\" width=\"2\" height=\"2\" transform=\"translate(-4 42) rotate(-90)\"/><polygon points=\"18 30 22 30 22 28 20 28 20 26 18 26 18 30\"/><rect x=\"24.9999\" y=\"23\" width=\"4\" height=\"2\" transform=\"translate(2.9999 50.9999) rotate(-90)\"/><polygon points=\"28 26 30 26 30 30 26 30 26 28 28 28 28 26\"/><polygon points=\"26 20 26 18 30 18 30 22 28 22 28 20 26 20\"/><polygon points=\"24 20 22 20 22 24 20 24 20 26 24 26 24 20\"/><rect x=\"19\" y=\"17\" width=\"2\" height=\"4\" transform=\"translate(1 39) rotate(-90)\"/><rect x=\"6\" y=\"22\" width=\"4\" height=\"4\"/><path d=\"M14,30H2V18H14ZM4,28h8V20H4Z\"/><rect x=\"22\" y=\"6\" width=\"4\" height=\"4\"/><path d=\"M30,14H18V2H30ZM20,12h8V4H20Z\"/><rect x=\"6\" y=\"6\" width=\"4\" height=\"4\"/><path d=\"M14,14H2V2H14ZM4,12h8V4H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 26H26V28H24z\" transform=\"rotate(-90 25 27)\"/><path d=\"M18 22H20V24H18z\" transform=\"rotate(-90 19 23)\"/><path d=\"M18 30L22 30 22 28 20 28 20 26 18 26 18 30z\"/><path d=\"M25 23H29V25H25z\" transform=\"rotate(-90 27 24)\"/><path d=\"M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z\"/><path d=\"M19 17H21V21H19z\" transform=\"rotate(-90 20 19)\"/><path d=\"M6 22H10V26H6z\"/><path d=\"M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z\"/><path d=\"M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z\"/><path d=\"M14,14H2V2H14ZM4,12h8V4H4Z\"/></svg>",
            "info": {},
            "path": "32/qr-code.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QrCode32",
          "filepath": "qr-code/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H26V28H24z",
                  "transform": "rotate(-90 25 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22H20V24H18z",
                  "transform": "rotate(-90 19 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H29V25H25z",
                  "transform": "rotate(-90 27 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H21V21H19z",
                  "transform": "rotate(-90 20 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22H10V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,14H2V2H14ZM4,12h8V4H4Z"
                }
              }
            ],
            "name": "qr-code",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QrCode24",
          "filepath": "qr-code/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H26V28H24z",
                  "transform": "rotate(-90 25 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22H20V24H18z",
                  "transform": "rotate(-90 19 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H29V25H25z",
                  "transform": "rotate(-90 27 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H21V21H19z",
                  "transform": "rotate(-90 20 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22H10V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,14H2V2H14ZM4,12h8V4H4Z"
                }
              }
            ],
            "name": "qr-code",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QrCode20",
          "filepath": "qr-code/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H26V28H24z",
                  "transform": "rotate(-90 25 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22H20V24H18z",
                  "transform": "rotate(-90 19 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H29V25H25z",
                  "transform": "rotate(-90 27 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H21V21H19z",
                  "transform": "rotate(-90 20 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22H10V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,14H2V2H14ZM4,12h8V4H4Z"
                }
              }
            ],
            "name": "qr-code",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QrCode16",
          "filepath": "qr-code/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H26V28H24z",
                  "transform": "rotate(-90 25 27)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22H20V24H18z",
                  "transform": "rotate(-90 19 23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23H29V25H25z",
                  "transform": "rotate(-90 27 24)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 17H21V21H19z",
                  "transform": "rotate(-90 20 19)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 22H10V26H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,14H2V2H14ZM4,12h8V4H4Z"
                }
              }
            ],
            "name": "qr-code",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "QrCode",
        "global": "QrCode",
        "filepath": "QrCode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 26H26V28H24z",
                    "transform": "rotate(-90 25 27)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 22H20V24H18z",
                    "transform": "rotate(-90 19 23)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 23H29V25H25z",
                    "transform": "rotate(-90 27 24)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 17H21V21H19z",
                    "transform": "rotate(-90 20 19)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 22H10V26H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,14H2V2H14ZM4,12h8V4H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "quadrant-plot",
      "friendlyName": "Quadrant plot",
      "aliases": [
        "quadrant plot",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/quadrant-plot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 15 17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15\"/>\n  <path d=\"M5,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,5,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,5,26Z\"/>\n  <path d=\"M8,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,8,8ZM8,4A1,1,0,1,0,9,5,1.001,1.001,0,0,0,8,4Z\"/>\n  <path d=\"M22,13a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,22,13Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,22,9Z\"/>\n  <circle cx=\"11\" cy=\"11\" r=\"2\"/>\n  <circle cx=\"11\" cy=\"21\" r=\"2\"/>\n  <circle cx=\"21\" cy=\"21\" r=\"2\"/>\n  <circle cx=\"22\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"28\" cy=\"24\" r=\"2\"/>\n  <circle cx=\"4\" cy=\"11\" r=\"2\"/>\n  <circle cx=\"28\" cy=\"4\" r=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z\"/><path d=\"M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z\"/><circle cx=\"11\" cy=\"11\" r=\"2\"/><circle cx=\"11\" cy=\"21\" r=\"2\"/><circle cx=\"21\" cy=\"21\" r=\"2\"/><circle cx=\"22\" cy=\"28\" r=\"2\"/><circle cx=\"28\" cy=\"24\" r=\"2\"/><circle cx=\"4\" cy=\"11\" r=\"2\"/><circle cx=\"28\" cy=\"4\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/quadrant-plot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QuadrantPlot32",
          "filepath": "quadrant-plot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              }
            ],
            "name": "quadrant-plot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QuadrantPlot24",
          "filepath": "quadrant-plot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              }
            ],
            "name": "quadrant-plot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QuadrantPlot20",
          "filepath": "quadrant-plot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              }
            ],
            "name": "quadrant-plot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QuadrantPlot16",
          "filepath": "quadrant-plot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "4",
                  "cy": "11",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "28",
                  "cy": "4",
                  "r": "2"
                }
              }
            ],
            "name": "quadrant-plot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "QuadrantPlot",
        "global": "QuadrantPlot",
        "filepath": "QuadrantPlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "11",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "21",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21",
                    "cy": "21",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "4",
                    "cy": "11",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "28",
                    "cy": "4",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "query",
      "friendlyName": "Query",
      "aliases": [
        "query",
        "operations",
        "search"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/query.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"11\" cy=\"15.5\" r=\"1.5\"/>\n  <path d=\"M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"11\" cy=\"15.5\" r=\"1.5\"/><path d=\"M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z\"/><path d=\"M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z\"/></svg>",
            "info": {},
            "path": "32/query.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Query32",
          "filepath": "query/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "query",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Query24",
          "filepath": "query/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "query",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Query20",
          "filepath": "query/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "query",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Query16",
          "filepath": "query/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "15.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "query",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Query",
        "global": "Query",
        "filepath": "Query.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "15.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "query-queue",
      "friendlyName": "Query queue",
      "aliases": [
        "list"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/query-queue.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>query-queue</title><rect x=\"10\" y=\"6\" width=\"18\" height=\"2\"/><rect x=\"10\" y=\"12\" width=\"18\" height=\"2\"/><rect x=\"15\" y=\"18\" width=\"13\" height=\"2\"/><rect x=\"10\" y=\"24\" width=\"18\" height=\"2\"/><polygon points=\"4 14 11 19 4 24 4 14\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z\"/></svg>",
            "info": {},
            "path": "32/query-queue.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QueryQueue32",
          "filepath": "query-queue/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
                }
              }
            ],
            "name": "query-queue",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QueryQueue24",
          "filepath": "query-queue/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
                }
              }
            ],
            "name": "query-queue",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QueryQueue20",
          "filepath": "query-queue/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
                }
              }
            ],
            "name": "query-queue",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QueryQueue16",
          "filepath": "query-queue/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
                }
              }
            ],
            "name": "query-queue",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "QueryQueue",
        "global": "QueryQueue",
        "filepath": "QueryQueue.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "queued",
      "friendlyName": "Queued",
      "aliases": [
        "queued",
        "status"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/queued.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #090909;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect class=\"cls-1\" x=\"22\" y=\"20\" width=\"8\" height=\"2\"/>\n  <rect class=\"cls-1\" x=\"22\" y=\"24\" width=\"8\" height=\"2\"/>\n  <rect class=\"cls-1\" x=\"22\" y=\"28\" width=\"8\" height=\"2\"/>\n  <rect class=\"cls-1\" x=\"18\" y=\"24\" width=\"2\" height=\"2\"/>\n  <rect class=\"cls-1\" x=\"18\" y=\"20\" width=\"2\" height=\"2\"/>\n  <rect class=\"cls-1\" x=\"18\" y=\"28\" width=\"2\" height=\"2\"/>\n  <path class=\"cls-1\" d=\"M6.8149,8.293A12.0777,12.0777,0,0,1,10.0068,5.62L9.0079,3.89A14.0845,14.0845,0,0,0,5.2841,7.0083Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M25.1851,8.293l1.5308-1.2847A14.0845,14.0845,0,0,0,22.9921,3.89l-.9989,1.73A12.0777,12.0777,0,0,1,25.1851,8.293Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M4.7366,11.9l-1.8772-.6831A13.9019,13.9019,0,0,0,2,16H4A11.917,11.917,0,0,1,4.7366,11.9Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M6.8149,23.707A11.9975,11.9975,0,0,1,4.7366,20.1l-1.8772.6831a13.99,13.99,0,0,0,2.4247,4.209Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M27.2634,11.9A11.917,11.917,0,0,1,28,16h2a13.8971,13.8971,0,0,0-.8594-4.7827Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M13.9182,27.8066A11.8894,11.8894,0,0,1,10.0068,26.38l-.9989,1.73a13.8673,13.8673,0,0,0,4.5633,1.664Z\" transform=\"translate(0 0)\"/>\n  <path class=\"cls-1\" d=\"M13.9182,4.1934a11.3012,11.3012,0,0,1,4.1636,0l.347-1.9678a13.187,13.187,0,0,0-4.8576,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z\"/></svg>",
            "info": {},
            "path": "32/queued.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Queued32",
          "filepath": "queued/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
                }
              }
            ],
            "name": "queued",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Queued24",
          "filepath": "queued/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
                }
              }
            ],
            "name": "queued",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Queued20",
          "filepath": "queued/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
                }
              }
            ],
            "name": "queued",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Queued16",
          "filepath": "queued/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
                }
              }
            ],
            "name": "queued",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Queued",
        "global": "Queued",
        "filepath": "Queued.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "quotes",
      "friendlyName": "Quotes",
      "aliases": [
        "mark",
        "punctuation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/quotes.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>quotes</title><path d=\"M12,15H6.11A9,9,0,0,1,10,8.86l1.79-1.2L10.69,6,8.9,7.2A11,11,0,0,0,4,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,12,15Z\"/><path d=\"M26,15H20.11A9,9,0,0,1,24,8.86l1.79-1.2L24.7,6,22.9,7.2A11,11,0,0,0,18,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,26,15Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z\"/></svg>",
            "info": {},
            "path": "32/quotes.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Quotes32",
          "filepath": "quotes/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
                }
              }
            ],
            "name": "quotes",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Quotes24",
          "filepath": "quotes/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
                }
              }
            ],
            "name": "quotes",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Quotes20",
          "filepath": "quotes/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
                }
              }
            ],
            "name": "quotes",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Quotes16",
          "filepath": "quotes/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
                }
              }
            ],
            "name": "quotes",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Quotes",
        "global": "Quotes",
        "filepath": "Quotes.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radar",
      "friendlyName": "Radar",
      "aliases": [
        "radar",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radar.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z\"/></svg>",
            "info": {},
            "path": "32/radar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Radar32",
          "filepath": "radar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
                }
              }
            ],
            "name": "radar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Radar24",
          "filepath": "radar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
                }
              }
            ],
            "name": "radar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Radar20",
          "filepath": "radar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
                }
              }
            ],
            "name": "radar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Radar16",
          "filepath": "radar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
                }
              }
            ],
            "name": "radar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Radar",
        "global": "Radar",
        "filepath": "Radar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radar--enhanced",
      "friendlyName": "Radar enhanced",
      "aliases": [
        "radar",
        "enhanced",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radar--enhanced.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z\"/></svg>",
            "info": {},
            "path": "32/radar--enhanced.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RadarEnhanced32",
          "filepath": "radar--enhanced/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--enhanced",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RadarEnhanced24",
          "filepath": "radar--enhanced/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--enhanced",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RadarEnhanced20",
          "filepath": "radar--enhanced/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--enhanced",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RadarEnhanced16",
          "filepath": "radar--enhanced/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--enhanced",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RadarEnhanced",
        "global": "RadarEnhanced",
        "filepath": "RadarEnhanced.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radar--weather",
      "friendlyName": "Radar weather",
      "aliases": [
        "radar",
        "weather",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radar--weather.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z\"/></svg>",
            "info": {},
            "path": "32/radar--weather.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RadarWeather32",
          "filepath": "radar--weather/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--weather",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RadarWeather24",
          "filepath": "radar--weather/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--weather",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RadarWeather20",
          "filepath": "radar--weather/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--weather",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RadarWeather16",
          "filepath": "radar--weather/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
                }
              }
            ],
            "name": "radar--weather",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RadarWeather",
        "global": "RadarWeather",
        "filepath": "RadarWeather.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radio",
      "friendlyName": "Radio",
      "aliases": [
        "music",
        "sound",
        "audio",
        "broadcast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radio.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>radio</title><path d=\"M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z\" transform=\"translate(0)\"/><path d=\"M10,26a4,4,0,1,1,4-4A4,4,0,0,1,10,26Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,20Z\" transform=\"translate(0)\"/><rect x=\"7\" y=\"14\" width=\"6\" height=\"2\"/><rect x=\"17\" y=\"16\" width=\"9\" height=\"2\"/><rect x=\"17\" y=\"20\" width=\"9\" height=\"2\"/><rect x=\"17\" y=\"24\" width=\"9\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z\"/><path d=\"M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z\"/></svg>",
            "info": {},
            "path": "32/radio.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Radio32",
          "filepath": "radio/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
                }
              }
            ],
            "name": "radio",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Radio24",
          "filepath": "radio/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
                }
              }
            ],
            "name": "radio",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Radio20",
          "filepath": "radio/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
                }
              }
            ],
            "name": "radio",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Radio16",
          "filepath": "radio/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
                }
              }
            ],
            "name": "radio",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Radio",
        "global": "Radio",
        "filepath": "Radio.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radio--combat",
      "friendlyName": "Radio combat",
      "aliases": [
        "radio",
        "combat",
        "military",
        "field",
        "communications"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radio--combat.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,20Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"17\" y=\"20\" width=\"9\" height=\"2\"/>\n  <rect x=\"17\" y=\"24\" width=\"9\" height=\"2\"/>\n  <path d=\"M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z\"/><path d=\"M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z\"/></svg>",
            "info": {},
            "path": "32/radio--combat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RadioCombat32",
          "filepath": "radio--combat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
                }
              }
            ],
            "name": "radio--combat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RadioCombat24",
          "filepath": "radio--combat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
                }
              }
            ],
            "name": "radio--combat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RadioCombat20",
          "filepath": "radio--combat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
                }
              }
            ],
            "name": "radio--combat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RadioCombat16",
          "filepath": "radio--combat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
                }
              }
            ],
            "name": "radio--combat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "RadioCombat",
        "global": "RadioCombat",
        "filepath": "RadioCombat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radio--push-to-talk",
      "friendlyName": "Radio push-to-talk",
      "aliases": [
        "radio",
        "push-to-talk",
        "communications",
        "walkie talkie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radio--push-to-talk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"13\" y=\"11\" width=\"6\" height=\"2\"/>\n  <rect x=\"13\" y=\"15\" width=\"6\" height=\"2\"/>\n  <circle cx=\"16\" cy=\"23\" r=\"2\"/>\n  <path d=\"M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 11H19V13H13zM13 15H19V17H13z\"/><circle cx=\"16\" cy=\"23\" r=\"2\"/><path d=\"M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z\"/></svg>",
            "info": {},
            "path": "32/radio--push-to-talk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RadioPushToTalk32",
          "filepath": "radio--push-to-talk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H19V13H13zM13 15H19V17H13z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
                }
              }
            ],
            "name": "radio--push-to-talk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RadioPushToTalk24",
          "filepath": "radio--push-to-talk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H19V13H13zM13 15H19V17H13z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
                }
              }
            ],
            "name": "radio--push-to-talk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RadioPushToTalk20",
          "filepath": "radio--push-to-talk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H19V13H13zM13 15H19V17H13z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
                }
              }
            ],
            "name": "radio--push-to-talk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RadioPushToTalk16",
          "filepath": "radio--push-to-talk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 11H19V13H13zM13 15H19V17H13z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "23",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
                }
              }
            ],
            "name": "radio--push-to-talk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "RadioPushToTalk",
        "global": "RadioPushToTalk",
        "filepath": "RadioPushToTalk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 11H19V13H13zM13 15H19V17H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "23",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radio-button",
      "friendlyName": "Radio button",
      "aliases": [
        "component",
        "circle",
        "travel",
        "case"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radio-button.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>radio-button</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/></svg>",
            "info": {},
            "path": "32/radio-button.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RadioButton32",
          "filepath": "radio-button/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "radio-button",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RadioButton24",
          "filepath": "radio-button/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "radio-button",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RadioButton20",
          "filepath": "radio-button/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "radio-button",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RadioButton16",
          "filepath": "radio-button/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              }
            ],
            "name": "radio-button",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "RadioButton",
        "global": "RadioButton",
        "filepath": "RadioButton.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "radio-button--checked",
      "friendlyName": "Radio button checked",
      "aliases": [
        "component",
        "circle",
        "travel",
        "case"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/radio-button--checked.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>radio-button--checked</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z\"/></svg>",
            "info": {},
            "path": "32/radio-button--checked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RadioButtonChecked32",
          "filepath": "radio-button--checked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
                }
              }
            ],
            "name": "radio-button--checked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RadioButtonChecked24",
          "filepath": "radio-button--checked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
                }
              }
            ],
            "name": "radio-button--checked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RadioButtonChecked20",
          "filepath": "radio-button--checked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
                }
              }
            ],
            "name": "radio-button--checked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RadioButtonChecked16",
          "filepath": "radio-button--checked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
                }
              }
            ],
            "name": "radio-button--checked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "RadioButtonChecked",
        "global": "RadioButtonChecked",
        "filepath": "RadioButtonChecked.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rain",
      "friendlyName": "Rain",
      "aliases": [
        "rain",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rain.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud--rain</title><path d=\"M23.5,22H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22ZM16,4a7,7,0,0,0-6.94,6.14L9,11,8.14,11a4.5,4.5,0,0,0,.36,9h15a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82A7,7,0,0,0,16,4Z\"/><path d=\"M14,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,14,30Z\"/><path d=\"M20,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,20,30Z\"/><path d=\"M8,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,8,30Z\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z\"/></svg>",
            "info": {},
            "path": "32/rain.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rain32",
          "filepath": "rain/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
                }
              }
            ],
            "name": "rain",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rain24",
          "filepath": "rain/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
                }
              }
            ],
            "name": "rain",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rain20",
          "filepath": "rain/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
                }
              }
            ],
            "name": "rain",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rain16",
          "filepath": "rain/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
                }
              }
            ],
            "name": "rain",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Rain",
        "global": "Rain",
        "filepath": "Rain.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rain--drizzle",
      "friendlyName": "Rain drizzle",
      "aliases": [
        "rain",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rain--drizzle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rain--drizzle</title><path d=\"M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z\"/></svg>",
            "info": {},
            "path": "32/rain--drizzle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RainDrizzle32",
          "filepath": "rain--drizzle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--drizzle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RainDrizzle24",
          "filepath": "rain--drizzle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--drizzle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RainDrizzle20",
          "filepath": "rain--drizzle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--drizzle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RainDrizzle16",
          "filepath": "rain--drizzle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--drizzle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RainDrizzle",
        "global": "RainDrizzle",
        "filepath": "RainDrizzle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rain--heavy",
      "friendlyName": "Rain heavy",
      "aliases": [
        "rain",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rain--heavy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rain--heavy</title><path d=\"M17,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,17,30Z\"/><path d=\"M8,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,8,30Z\"/><path d=\"M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z\"/><path d=\"M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z\"/></svg>",
            "info": {},
            "path": "32/rain--heavy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RainHeavy32",
          "filepath": "rain--heavy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--heavy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RainHeavy24",
          "filepath": "rain--heavy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--heavy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RainHeavy20",
          "filepath": "rain--heavy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--heavy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RainHeavy16",
          "filepath": "rain--heavy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                }
              }
            ],
            "name": "rain--heavy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RainHeavy",
        "global": "RainHeavy",
        "filepath": "RainHeavy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rain--scattered",
      "friendlyName": "Rain scattered",
      "aliases": [
        "rain",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rain--scattered.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rain--scattered</title><path d=\"M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z\"/><rect x=\"27.2324\" y=\"15.7329\" width=\"1.9998\" height=\"2.9998\" transform=\"translate(-3.9151 25.0157) rotate(-45.0092)\"/><rect x=\"29\" y=\"10\" width=\"3\" height=\"2\"/><rect x=\"26.7321\" y=\"3.7682\" width=\"3.0002\" height=\"2.0002\" transform=\"translate(4.8973 21.3598) rotate(-45)\"/><rect x=\"20\" width=\"2\" height=\"3\"/><rect x=\"12.7676\" y=\"3.2682\" width=\"2.0002\" height=\"3.0002\" transform=\"translate(0.6608 11.1319) rotate(-45)\"/><path d=\"M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z\"/><path d=\"M27.232 15.733H29.232V18.733H27.232z\" transform=\"rotate(-45.009 28.232 17.233)\"/><path d=\"M29 10H32V12H29z\"/><path d=\"M26.732 3.768H29.732V5.768H26.732z\" transform=\"rotate(-45 28.232 4.768)\"/><path d=\"M20 0H22V3H20z\"/><path d=\"M12.768 3.268H14.768V6.268H12.768z\" transform=\"rotate(-45 13.768 4.768)\"/><path d=\"M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z\"/></svg>",
            "info": {},
            "path": "32/rain--scattered.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RainScattered32",
          "filepath": "rain--scattered/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.232 15.733H29.232V18.733H27.232z",
                  "transform": "rotate(-45.009 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.768 3.268H14.768V6.268H12.768z",
                  "transform": "rotate(-45 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              }
            ],
            "name": "rain--scattered",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RainScattered24",
          "filepath": "rain--scattered/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.232 15.733H29.232V18.733H27.232z",
                  "transform": "rotate(-45.009 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.768 3.268H14.768V6.268H12.768z",
                  "transform": "rotate(-45 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              }
            ],
            "name": "rain--scattered",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RainScattered20",
          "filepath": "rain--scattered/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.232 15.733H29.232V18.733H27.232z",
                  "transform": "rotate(-45.009 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.768 3.268H14.768V6.268H12.768z",
                  "transform": "rotate(-45 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              }
            ],
            "name": "rain--scattered",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RainScattered16",
          "filepath": "rain--scattered/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.232 15.733H29.232V18.733H27.232z",
                  "transform": "rotate(-45.009 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.768 3.268H14.768V6.268H12.768z",
                  "transform": "rotate(-45 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              }
            ],
            "name": "rain--scattered",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RainScattered",
        "global": "RainScattered",
        "filepath": "RainScattered.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.232 15.733H29.232V18.733H27.232z",
                    "transform": "rotate(-45.009 28.232 17.233)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 10H32V12H29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.732 3.768H29.732V5.768H26.732z",
                    "transform": "rotate(-45 28.232 4.768)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 0H22V3H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.768 3.268H14.768V6.268H12.768z",
                    "transform": "rotate(-45 13.768 4.768)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rain--scattered--night",
      "friendlyName": "Rain scattered night",
      "aliases": [
        "rain",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rain--scattered--night.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rain--scattered--night</title><path d=\"M8.5084,32a1.0115,1.0115,0,0,1-.4485-.1055.9986.9986,0,0,1-.4486-1.3418l1.4934-3a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0015,1.0015,0,0,1,8.5084,32Z\"/><path d=\"M29.8442,13.0347a1.5184,1.5184,0,0,0-1.2309-.8658,5.3587,5.3587,0,0,1-3.4094-1.7163,6.4648,6.4648,0,0,1-1.285-6.393,1.6031,1.6031,0,0,0-.3-1.5459,1.4535,1.4535,0,0,0-1.3594-.4922l-.0191.0029a7.8549,7.8549,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9549,5.9549,0,0,0,5.88-7.1455,7.5,7.5,0,0,0,4.8672-3.3A1.5381,1.5381,0,0,0,29.8442,13.0347ZM19,23H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm5.1509-7.0479a5.9639,5.9639,0,0,0-3.5015-2.708A7.5076,7.5076,0,0,0,18.0286,9.55a6.01,6.01,0,0,1,3.77-5.334,8.4581,8.4581,0,0,0,1.9395,7.5972A7.4007,7.4007,0,0,0,27.64,14.041,5.4392,5.4392,0,0,1,24.1509,15.9521Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z\"/></svg>",
            "info": {},
            "path": "32/rain--scattered--night.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RainScatteredNight32",
          "filepath": "rain--scattered--night/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
                }
              }
            ],
            "name": "rain--scattered--night",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RainScatteredNight24",
          "filepath": "rain--scattered--night/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
                }
              }
            ],
            "name": "rain--scattered--night",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RainScatteredNight20",
          "filepath": "rain--scattered--night/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
                }
              }
            ],
            "name": "rain--scattered--night",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RainScatteredNight16",
          "filepath": "rain--scattered--night/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
                }
              }
            ],
            "name": "rain--scattered--night",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RainScatteredNight",
        "global": "RainScatteredNight",
        "filepath": "RainScatteredNight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rain-drop",
      "friendlyName": "Rain drop",
      "aliases": [
        "rain-drop",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rain-drop.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>rain-drop</title>\n  <path d=\"M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z\"/>\n  <path d=\"M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z\"/><path d=\"M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z\"/></svg>",
            "info": {},
            "path": "32/rain-drop.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RainDrop32",
          "filepath": "rain-drop/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              }
            ],
            "name": "rain-drop",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RainDrop24",
          "filepath": "rain-drop/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              }
            ],
            "name": "rain-drop",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RainDrop20",
          "filepath": "rain-drop/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              }
            ],
            "name": "rain-drop",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RainDrop16",
          "filepath": "rain-drop/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              }
            ],
            "name": "rain-drop",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RainDrop",
        "global": "RainDrop",
        "filepath": "RainDrop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "RAW",
      "friendlyName": "RAW",
      "aliases": [
        "format",
        "unedited"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/RAW.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>RAW</title><polygon points=\"29.2 9 28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9\"/><path d=\"M18,9H14a2,2,0,0,0-2,2V23h2V18h4v5h2V11A2,2,0,0,0,18,9Zm-4,7V11h4v5Z\"/><path d=\"M10,15V11A2,2,0,0,0,8,9H2V23H4V17H5.48l2.34,6H10L7.63,17H8A2,2,0,0,0,10,15ZM4,11H8v4H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z\"/></svg>",
            "info": {},
            "path": "32/RAW.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Raw32",
          "filepath": "RAW/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
                }
              }
            ],
            "name": "RAW",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Raw24",
          "filepath": "RAW/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
                }
              }
            ],
            "name": "RAW",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Raw20",
          "filepath": "RAW/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
                }
              }
            ],
            "name": "RAW",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Raw16",
          "filepath": "RAW/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
                }
              }
            ],
            "name": "RAW",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Raw",
        "global": "Raw",
        "filepath": "Raw.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "receipt",
      "friendlyName": "Receipt",
      "aliases": [
        "check",
        "bill",
        "total"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/receipt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>receipt</title><rect x=\"21\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"16\" width=\"8\" height=\"2\"/><rect x=\"21\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"12\" width=\"8\" height=\"2\"/><rect x=\"9\" y=\"8\" width=\"14\" height=\"2\"/><path d=\"M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z\"/><path d=\"M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z\"/></svg>",
            "info": {},
            "path": "32/receipt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Receipt32",
          "filepath": "receipt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
                }
              }
            ],
            "name": "receipt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Receipt24",
          "filepath": "receipt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
                }
              }
            ],
            "name": "receipt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Receipt20",
          "filepath": "receipt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
                }
              }
            ],
            "name": "receipt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Receipt16",
          "filepath": "receipt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
                }
              }
            ],
            "name": "receipt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Receipt",
        "global": "Receipt",
        "filepath": "Receipt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "recently-viewed",
      "friendlyName": "Recently viewed",
      "aliases": [
        "history",
        "version",
        "back",
        "recent"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/recently-viewed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>recently-viewed</title><polygon points=\"20.59 22 15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22\"/><path d=\"M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z\"/><path d=\"M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z\"/></svg>",
            "info": {},
            "path": "32/recently-viewed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RecentlyViewed32",
          "filepath": "recently-viewed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "recently-viewed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RecentlyViewed24",
          "filepath": "recently-viewed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "recently-viewed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RecentlyViewed20",
          "filepath": "recently-viewed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "recently-viewed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RecentlyViewed16",
          "filepath": "recently-viewed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                }
              }
            ],
            "name": "recently-viewed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "RecentlyViewed",
        "global": "RecentlyViewed",
        "filepath": "RecentlyViewed.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "recommend",
      "friendlyName": "Recommend",
      "aliases": [
        "suggest",
        "award",
        "favorite"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/recommend.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>recommend</title><path d=\"M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z\"/></svg>",
            "info": {},
            "path": "32/recommend.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Recommend32",
          "filepath": "recommend/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
                }
              }
            ],
            "name": "recommend",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Recommend24",
          "filepath": "recommend/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
                }
              }
            ],
            "name": "recommend",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Recommend20",
          "filepath": "recommend/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
                }
              }
            ],
            "name": "recommend",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Recommend16",
          "filepath": "recommend/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
                }
              }
            ],
            "name": "recommend",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Recommend",
        "global": "Recommend",
        "filepath": "Recommend.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "recording",
      "friendlyName": "Recording",
      "aliases": [
        "start",
        "music",
        "sound",
        "control"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/recording.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>recording</title><path class=\"cls-1\" d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\" transform=\"translate(0)\"/><path class=\"cls-1\" d=\"M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/><path d=\"M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\"/></svg>",
            "info": {},
            "path": "32/recording.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Recording32",
          "filepath": "recording/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "recording",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Recording24",
          "filepath": "recording/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "recording",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Recording20",
          "filepath": "recording/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "recording",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Recording16",
          "filepath": "recording/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                }
              }
            ],
            "name": "recording",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Recording",
        "global": "Recording",
        "filepath": "Recording.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "recording--filled",
      "friendlyName": "Recording filled",
      "aliases": [
        "start",
        "music",
        "sound",
        "control"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/recording--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n<g>\n\t<circle cx=\"16\" cy=\"16\" r=\"4\"/>\n\t<path d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6\n\t\tS19.3,22,16,22z\"/>\n</g>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"4\"/><path d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z\"/></svg>",
            "info": {},
            "path": "32/recording--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RecordingFilled32",
          "filepath": "recording--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
                }
              }
            ],
            "name": "recording--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RecordingFilled24",
          "filepath": "recording--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
                }
              }
            ],
            "name": "recording--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RecordingFilled20",
          "filepath": "recording--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
                }
              }
            ],
            "name": "recording--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RecordingFilled16",
          "filepath": "recording--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
                }
              }
            ],
            "name": "recording--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "RecordingFilled",
        "global": "RecordingFilled",
        "filepath": "RecordingFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "4"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "recording--filled--alt",
      "friendlyName": "Recording filled alt",
      "aliases": [
        "start",
        "music",
        "sound",
        "control"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/recording--filled--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;}\n</style>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n<path d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\n\tz\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz\"/><path d=\"M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "32/recording--filled--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RecordingFilledAlt32",
          "filepath": "recording--filled--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "recording--filled--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RecordingFilledAlt24",
          "filepath": "recording--filled--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "recording--filled--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RecordingFilledAlt20",
          "filepath": "recording--filled--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "recording--filled--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RecordingFilledAlt16",
          "filepath": "recording--filled--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "recording--filled--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "RecordingFilledAlt",
        "global": "RecordingFilledAlt",
        "filepath": "RecordingFilledAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22 z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "recycle",
      "friendlyName": "recycle",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/recycle.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.5081,22.2549l-2.0781-3.7402-1.7485,.9707,2.0781,3.7412c.3247,.584,.3162,1.2769-.0229,1.8535-.3391,.5762-.9407,.9199-1.6091,.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5,5,5,5,1.4102-1.4102-2.5801-2.5898h7.2974c1.3848,0,2.6306-.7124,3.3328-1.9058,.7024-1.1938,.7202-2.6284,.0479-3.8394Z\"/>\n  <path d=\"M5.8726,26c-.6685,0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004,1.0479,3.52,1.9121-.5664-2.0083-6.7798-6.7798,2.0083,.5664,1.9121,3.4934-1.0298-4.0913,7.3643c-.6724,1.2109-.6545,2.6455,.0479,3.8394,.7021,1.1934,1.948,1.9058,3.3328,1.9058h6.1274v-2H5.8726Z\"/>\n  <path d=\"M25.51,9.6538l-1.0476,3.519L19.3503,3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646,.7368-3.3503,1.9712l-3.0796,5.5435,1.7485,.9707,3.0796-5.543c.3276-.5898,.9265-.9424,1.6018-.9424s1.2742,.3525,1.6018,.9424l5.0925,9.167-3.4939-1.0298-.5664,1.9121,6.78,2.0083,2.0083-6.7798-1.9124-.5664Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.5081 22.2549l-2.0781-3.7402-1.7485.9707 2.0781 3.7412c.3247.584.3162 1.2769-.0229 1.8535-.3391.5762-.9407.9199-1.6091.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5 5 5 5 1.4102-1.4102-2.5801-2.5898h7.2974c1.3848 0 2.6306-.7124 3.3328-1.9058.7024-1.1938.7202-2.6284.0479-3.8394zM5.8726 26c-.6685 0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004 1.0479 3.52 1.9121-.5664-2.0083-6.7798-6.7798 2.0083.5664 1.9121 3.4934-1.0298-4.0913 7.3643c-.6724 1.2109-.6545 2.6455.0479 3.8394.7021 1.1934 1.948 1.9058 3.3328 1.9058h6.1274v-2H5.8726zM25.51 9.6538l-1.0476 3.519L19.3503 3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646.7368-3.3503 1.9712l-3.0796 5.5435 1.7485.9707 3.0796-5.543c.3276-.5898.9265-.9424 1.6018-.9424s1.2742.3525 1.6018.9424l5.0925 9.167-3.4939-1.0298-.5664 1.9121 6.78 2.0083 2.0083-6.7798-1.9124-.5664z\"/></svg>",
            "info": {},
            "path": "32/recycle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Recycle32",
          "filepath": "recycle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.5081 22.2549l-2.0781-3.7402-1.7485.9707 2.0781 3.7412c.3247.584.3162 1.2769-.0229 1.8535-.3391.5762-.9407.9199-1.6091.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5 5 5 5 1.4102-1.4102-2.5801-2.5898h7.2974c1.3848 0 2.6306-.7124 3.3328-1.9058.7024-1.1938.7202-2.6284.0479-3.8394zM5.8726 26c-.6685 0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004 1.0479 3.52 1.9121-.5664-2.0083-6.7798-6.7798 2.0083.5664 1.9121 3.4934-1.0298-4.0913 7.3643c-.6724 1.2109-.6545 2.6455.0479 3.8394.7021 1.1934 1.948 1.9058 3.3328 1.9058h6.1274v-2H5.8726zM25.51 9.6538l-1.0476 3.519L19.3503 3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646.7368-3.3503 1.9712l-3.0796 5.5435 1.7485.9707 3.0796-5.543c.3276-.5898.9265-.9424 1.6018-.9424s1.2742.3525 1.6018.9424l5.0925 9.167-3.4939-1.0298-.5664 1.9121 6.78 2.0083 2.0083-6.7798-1.9124-.5664z"
                }
              }
            ],
            "name": "recycle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Recycle24",
          "filepath": "recycle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.5081 22.2549l-2.0781-3.7402-1.7485.9707 2.0781 3.7412c.3247.584.3162 1.2769-.0229 1.8535-.3391.5762-.9407.9199-1.6091.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5 5 5 5 1.4102-1.4102-2.5801-2.5898h7.2974c1.3848 0 2.6306-.7124 3.3328-1.9058.7024-1.1938.7202-2.6284.0479-3.8394zM5.8726 26c-.6685 0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004 1.0479 3.52 1.9121-.5664-2.0083-6.7798-6.7798 2.0083.5664 1.9121 3.4934-1.0298-4.0913 7.3643c-.6724 1.2109-.6545 2.6455.0479 3.8394.7021 1.1934 1.948 1.9058 3.3328 1.9058h6.1274v-2H5.8726zM25.51 9.6538l-1.0476 3.519L19.3503 3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646.7368-3.3503 1.9712l-3.0796 5.5435 1.7485.9707 3.0796-5.543c.3276-.5898.9265-.9424 1.6018-.9424s1.2742.3525 1.6018.9424l5.0925 9.167-3.4939-1.0298-.5664 1.9121 6.78 2.0083 2.0083-6.7798-1.9124-.5664z"
                }
              }
            ],
            "name": "recycle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Recycle20",
          "filepath": "recycle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.5081 22.2549l-2.0781-3.7402-1.7485.9707 2.0781 3.7412c.3247.584.3162 1.2769-.0229 1.8535-.3391.5762-.9407.9199-1.6091.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5 5 5 5 1.4102-1.4102-2.5801-2.5898h7.2974c1.3848 0 2.6306-.7124 3.3328-1.9058.7024-1.1938.7202-2.6284.0479-3.8394zM5.8726 26c-.6685 0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004 1.0479 3.52 1.9121-.5664-2.0083-6.7798-6.7798 2.0083.5664 1.9121 3.4934-1.0298-4.0913 7.3643c-.6724 1.2109-.6545 2.6455.0479 3.8394.7021 1.1934 1.948 1.9058 3.3328 1.9058h6.1274v-2H5.8726zM25.51 9.6538l-1.0476 3.519L19.3503 3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646.7368-3.3503 1.9712l-3.0796 5.5435 1.7485.9707 3.0796-5.543c.3276-.5898.9265-.9424 1.6018-.9424s1.2742.3525 1.6018.9424l5.0925 9.167-3.4939-1.0298-.5664 1.9121 6.78 2.0083 2.0083-6.7798-1.9124-.5664z"
                }
              }
            ],
            "name": "recycle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Recycle16",
          "filepath": "recycle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.5081 22.2549l-2.0781-3.7402-1.7485.9707 2.0781 3.7412c.3247.584.3162 1.2769-.0229 1.8535-.3391.5762-.9407.9199-1.6091.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5 5 5 5 1.4102-1.4102-2.5801-2.5898h7.2974c1.3848 0 2.6306-.7124 3.3328-1.9058.7024-1.1938.7202-2.6284.0479-3.8394zM5.8726 26c-.6685 0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004 1.0479 3.52 1.9121-.5664-2.0083-6.7798-6.7798 2.0083.5664 1.9121 3.4934-1.0298-4.0913 7.3643c-.6724 1.2109-.6545 2.6455.0479 3.8394.7021 1.1934 1.948 1.9058 3.3328 1.9058h6.1274v-2H5.8726zM25.51 9.6538l-1.0476 3.519L19.3503 3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646.7368-3.3503 1.9712l-3.0796 5.5435 1.7485.9707 3.0796-5.543c.3276-.5898.9265-.9424 1.6018-.9424s1.2742.3525 1.6018.9424l5.0925 9.167-3.4939-1.0298-.5664 1.9121 6.78 2.0083 2.0083-6.7798-1.9124-.5664z"
                }
              }
            ],
            "name": "recycle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Recycle",
        "global": "Recycle",
        "filepath": "Recycle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.5081 22.2549l-2.0781-3.7402-1.7485.9707 2.0781 3.7412c.3247.584.3162 1.2769-.0229 1.8535-.3391.5762-.9407.9199-1.6091.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5 5 5 5 1.4102-1.4102-2.5801-2.5898h7.2974c1.3848 0 2.6306-.7124 3.3328-1.9058.7024-1.1938.7202-2.6284.0479-3.8394zM5.8726 26c-.6685 0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004 1.0479 3.52 1.9121-.5664-2.0083-6.7798-6.7798 2.0083.5664 1.9121 3.4934-1.0298-4.0913 7.3643c-.6724 1.2109-.6545 2.6455.0479 3.8394.7021 1.1934 1.948 1.9058 3.3328 1.9058h6.1274v-2H5.8726zM25.51 9.6538l-1.0476 3.519L19.3503 3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646.7368-3.3503 1.9712l-3.0796 5.5435 1.7485.9707 3.0796-5.543c.3276-.5898.9265-.9424 1.6018-.9424s1.2742.3525 1.6018.9424l5.0925 9.167-3.4939-1.0298-.5664 1.9121 6.78 2.0083 2.0083-6.7798-1.9124-.5664z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "redo",
      "friendlyName": "Redo",
      "aliases": [
        "restart",
        "return",
        "back",
        "revert",
        "undo"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/redo.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n  .cls-1{fill:none;}\n</style>\n<path id=\"_x31_6_px_3_\" d=\"M4,8c-1.2,0-2,0.8-2,2c0,1.2,0.8,2,2,2h3v1H4c-1.7,0-3-1.2-3-3c0-1.7,1.3-3,3-3l9.1,0l-2-2l0.7-0.7\n\tL15,7.5l-3.2,3.2L11.1,10l2-2L4,8z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4,8c-1.2,0-2,0.8-2,2c0,1.2,0.8,2,2,2h3v1H4c-1.7,0-3-1.2-3-3c0-1.7,1.3-3,3-3l9.1,0l-2-2l0.7-0.7\tL15,7.5l-3.2,3.2L11.1,10l2-2L4,8z\"/></svg>",
            "info": {},
            "path": "16/redo.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/redo.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:#F3F3F3;}\n\t.st1{fill:#F9E4C2;}\n\t.st2{fill:#C1D7FB;}\n  .cls-1{fill:none;}\n</style>\n<path id=\"_x32_0_px_4_\" d=\"M5,9.3c-1.5,0-2.8,1.3-2.8,2.7c0,1.5,1.3,2.7,2.8,2.7h4V16H5c-2.3,0-4-1.7-4-4c0-2.2,1.8-4,4-4h11.6\n\tl-2.5-2.5L15,4.6l4,4l-4,4l-0.9-0.9l2.5-2.5H5z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"20\" height=\"20\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5,9.3c-1.5,0-2.8,1.3-2.8,2.7c0,1.5,1.3,2.7,2.8,2.7h4V16H5c-2.3,0-4-1.7-4-4c0-2.2,1.8-4,4-4h11.6\tl-2.5-2.5L15,4.6l4,4l-4,4l-0.9-0.9l2.5-2.5H5z\"/></svg>",
            "info": {},
            "path": "20/redo.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/redo.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{display:none;}\n  .cls-1{fill:none;}\n</style>\n<path class=\"st0\" d=\"M6.5,9.8h12.7l-3-3l1.1-1.1l4.8,4.8l-4.8,4.8l-1.1-1.1l3-3H6.5c-1.7,0-3,1.5-3,3.2s1.3,3.2,3,3.2H10v1.5H6.5\n\tc-2.8,0-4.5-2-4.5-4.8C2,11.8,3.8,9.8,6.5,9.8z\"/>\n<path id=\"_x32_4_px\" d=\"M6.8,11.2c-1.8,0-3.2,1.7-3.2,3.3c0,1.5,1.5,3.2,3.2,3.2H10v1.5H6.8C4.6,19.2,2,17,2,14.5s2-4.8,4.8-4.8\n\th12.4l-3-3l1.1-1.1l4.8,4.8l-4.8,4.8l-1.1-1.1l3-3H6.8z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"24\" height=\"24\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M6.8,11.2c-1.8,0-3.2,1.7-3.2,3.3c0,1.5,1.5,3.2,3.2,3.2H10v1.5H6.8C4.6,19.2,2,17,2,14.5s2-4.8,4.8-4.8\th12.4l-3-3l1.1-1.1l4.8,4.8l-4.8,4.8l-1.1-1.1l3-3H6.8z\"/></svg>",
            "info": {},
            "path": "24/redo.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/redo.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z\"/></svg>",
            "info": {},
            "path": "32/redo.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Redo32",
          "filepath": "redo/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z"
                }
              }
            ],
            "name": "redo",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Redo24",
          "filepath": "redo/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.8,11.2c-1.8,0-3.2,1.7-3.2,3.3c0,1.5,1.5,3.2,3.2,3.2H10v1.5H6.8C4.6,19.2,2,17,2,14.5s2-4.8,4.8-4.8\th12.4l-3-3l1.1-1.1l4.8,4.8l-4.8,4.8l-1.1-1.1l3-3H6.8z"
                }
              }
            ],
            "name": "redo",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Redo20",
          "filepath": "redo/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5,9.3c-1.5,0-2.8,1.3-2.8,2.7c0,1.5,1.3,2.7,2.8,2.7h4V16H5c-2.3,0-4-1.7-4-4c0-2.2,1.8-4,4-4h11.6\tl-2.5-2.5L15,4.6l4,4l-4,4l-0.9-0.9l2.5-2.5H5z"
                }
              }
            ],
            "name": "redo",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Redo16",
          "filepath": "redo/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,8c-1.2,0-2,0.8-2,2c0,1.2,0.8,2,2,2h3v1H4c-1.7,0-3-1.2-3-3c0-1.7,1.3-3,3-3l9.1,0l-2-2l0.7-0.7\tL15,7.5l-3.2,3.2L11.1,10l2-2L4,8z"
                }
              }
            ],
            "name": "redo",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Redo",
        "global": "Redo",
        "filepath": "Redo.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,8c-1.2,0-2,0.8-2,2c0,1.2,0.8,2,2,2h3v1H4c-1.7,0-3-1.2-3-3c0-1.7,1.3-3,3-3l9.1,0l-2-2l0.7-0.7 L15,7.5l-3.2,3.2L11.1,10l2-2L4,8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5,9.3c-1.5,0-2.8,1.3-2.8,2.7c0,1.5,1.3,2.7,2.8,2.7h4V16H5c-2.3,0-4-1.7-4-4c0-2.2,1.8-4,4-4h11.6 l-2.5-2.5L15,4.6l4,4l-4,4l-0.9-0.9l2.5-2.5H5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.8,11.2c-1.8,0-3.2,1.7-3.2,3.3c0,1.5,1.5,3.2,3.2,3.2H10v1.5H6.8C4.6,19.2,2,17,2,14.5s2-4.8,4.8-4.8 h12.4l-3-3l1.1-1.1l4.8,4.8l-4.8,4.8l-1.1-1.1l3-3H6.8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ref-evapotranspiration",
      "friendlyName": "Ref evapotranspiration",
      "aliases": [
        "weather",
        "ref",
        "evapotranspiration"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ref-evapotranspiration.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,12a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L13.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L17.3154,6.11A3.9693,3.9693,0,0,1,18,8.223,3.8978,3.8978,0,0,1,14,12Zm.0005-7.2368L12.3438,7.2257A1.89,1.89,0,0,0,12,8.223,1.9,1.9,0,0,0,14,10a1.9,1.9,0,0,0,2-1.777,1.98,1.98,0,0,0-.375-1.0466Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M7.5,26A5.385,5.385,0,0,1,2,20.751,5.3837,5.3837,0,0,1,2.874,17.92L6.49,12.5383a1.2168,1.2168,0,0,1,2.02-.0006l3.55,5.2777A5.4923,5.4923,0,0,1,13,20.751,5.385,5.385,0,0,1,7.5,26Zm0-11.38L4.5649,18.9868A3.3586,3.3586,0,0,0,4,20.751,3.3855,3.3855,0,0,0,7.5,24,3.3855,3.3855,0,0,0,11,20.751a3.4354,3.4354,0,0,0-.63-1.867Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25,2,20,7l1.4141,1.4141L24,5.8281V16a4.0045,4.0045,0,0,1-4,4H16v2h4a6.0066,6.0066,0,0,0,6-6V5.8281l2.5859,2.586L30,7Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z\"/></svg>",
            "info": {},
            "path": "32/ref-evapotranspiration.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RefEvapotranspiration32",
          "filepath": "ref-evapotranspiration/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
                }
              }
            ],
            "name": "ref-evapotranspiration",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RefEvapotranspiration24",
          "filepath": "ref-evapotranspiration/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
                }
              }
            ],
            "name": "ref-evapotranspiration",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RefEvapotranspiration20",
          "filepath": "ref-evapotranspiration/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
                }
              }
            ],
            "name": "ref-evapotranspiration",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RefEvapotranspiration16",
          "filepath": "ref-evapotranspiration/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
                }
              }
            ],
            "name": "ref-evapotranspiration",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "RefEvapotranspiration",
        "global": "RefEvapotranspiration",
        "filepath": "RefEvapotranspiration.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reflect--horizontal",
      "friendlyName": "Reflect horizontal",
      "aliases": [
        "reflect horizontal",
        "reflect",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reflect--horizontal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #272425;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z\"/>\n  <rect class=\"cls-1\" x=\"15\" y=\"2\" width=\"2\" height=\"28\" transform=\"translate(32 32) rotate(-180)\"/>\n  <path class=\"cls-1\" d=\"M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z\"/><path d=\"M15 2H17V30H15z\" transform=\"rotate(-180 16 16)\"/><path d=\"M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z\"/></svg>",
            "info": {},
            "path": "32/reflect--horizontal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ReflectHorizontal32",
          "filepath": "reflect--horizontal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-180 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
                }
              }
            ],
            "name": "reflect--horizontal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ReflectHorizontal24",
          "filepath": "reflect--horizontal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-180 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
                }
              }
            ],
            "name": "reflect--horizontal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ReflectHorizontal20",
          "filepath": "reflect--horizontal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-180 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
                }
              }
            ],
            "name": "reflect--horizontal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ReflectHorizontal16",
          "filepath": "reflect--horizontal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-180 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
                }
              }
            ],
            "name": "reflect--horizontal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ReflectHorizontal",
        "global": "ReflectHorizontal",
        "filepath": "ReflectHorizontal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V30H15z",
                    "transform": "rotate(-180 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reflect--vertical",
      "friendlyName": "Reflect vertical",
      "aliases": [
        "reflect vertical",
        "reflect",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reflect--vertical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #272425;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z\"/>\n  <rect class=\"cls-1\" x=\"15\" y=\"2\" width=\"2\" height=\"28\" transform=\"translate(0 32) rotate(-90)\"/>\n  <path class=\"cls-1\" d=\"M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z\"/><path d=\"M15 2H17V30H15z\" transform=\"rotate(-90 16 16)\"/><path d=\"M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z\"/></svg>",
            "info": {},
            "path": "32/reflect--vertical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ReflectVertical32",
          "filepath": "reflect--vertical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-90 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
                }
              }
            ],
            "name": "reflect--vertical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ReflectVertical24",
          "filepath": "reflect--vertical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-90 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
                }
              }
            ],
            "name": "reflect--vertical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ReflectVertical20",
          "filepath": "reflect--vertical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-90 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
                }
              }
            ],
            "name": "reflect--vertical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ReflectVertical16",
          "filepath": "reflect--vertical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V30H15z",
                  "transform": "rotate(-90 16 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
                }
              }
            ],
            "name": "reflect--vertical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ReflectVertical",
        "global": "ReflectVertical",
        "filepath": "ReflectVertical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V30H15z",
                    "transform": "rotate(-90 16 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "region-analysis--area",
      "friendlyName": "Region analysis area",
      "aliases": [
        "circle",
        "hash",
        "select",
        "area"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/region-analysis--area.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>region-analysis--area</title><path class=\"cls-1\" d=\"M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z\"/><path class=\"cls-1\" d=\"M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z\"/><path d=\"M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/region-analysis--area.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthRegionAnalysisArea32",
          "filepath": "watson-health/region-analysis--area/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
                }
              }
            ],
            "name": "region-analysis--area",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthRegionAnalysisArea24",
          "filepath": "watson-health/region-analysis--area/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
                }
              }
            ],
            "name": "region-analysis--area",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthRegionAnalysisArea20",
          "filepath": "watson-health/region-analysis--area/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
                }
              }
            ],
            "name": "region-analysis--area",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthRegionAnalysisArea16",
          "filepath": "watson-health/region-analysis--area/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
                }
              }
            ],
            "name": "region-analysis--area",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "RegionAnalysisArea",
        "global": "WatsonHealthRegionAnalysisArea",
        "filepath": "watson-health/RegionAnalysisArea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "region-analysis--volume",
      "friendlyName": "Region analysis volume",
      "aliases": [
        "circle",
        "hash",
        "select",
        "area"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/region-analysis--volume.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>region-analysis--volume</title><path class=\"cls-1\" d=\"M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z\"/><path d=\"M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z\"/><path d=\"M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/region-analysis--volume.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthRegionAnalysisVolume32",
          "filepath": "watson-health/region-analysis--volume/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
                }
              }
            ],
            "name": "region-analysis--volume",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthRegionAnalysisVolume24",
          "filepath": "watson-health/region-analysis--volume/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
                }
              }
            ],
            "name": "region-analysis--volume",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthRegionAnalysisVolume20",
          "filepath": "watson-health/region-analysis--volume/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
                }
              }
            ],
            "name": "region-analysis--volume",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthRegionAnalysisVolume16",
          "filepath": "watson-health/region-analysis--volume/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
                }
              }
            ],
            "name": "region-analysis--volume",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "RegionAnalysisVolume",
        "global": "WatsonHealthRegionAnalysisVolume",
        "filepath": "watson-health/RegionAnalysisVolume.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "registration",
      "friendlyName": "Registration",
      "aliases": [
        "registration"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/registration.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>registration</title><path d=\"M28,25H20a2.0027,2.0027,0,0,1-2-2V20h2v3h8V9H20v3H18V9a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2V23A2.0027,2.0027,0,0,1,28,25Z\"/><rect x=\"8\" y=\"15\" width=\"4\" height=\"2\"/><rect x=\"20\" y=\"15\" width=\"4\" height=\"2\"/><rect x=\"14\" y=\"15\" width=\"4\" height=\"2\"/><path d=\"M12,25H4a2.0023,2.0023,0,0,1-2-2V9A2.002,2.002,0,0,1,4,7h8a2.002,2.002,0,0,1,2,2v3H12V9H4V23h8V20h2v3A2.0023,2.0023,0,0,1,12,25Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z\"/><path d=\"M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z\"/></svg>",
            "info": {},
            "path": "32/watson-health/registration.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthRegistration32",
          "filepath": "watson-health/registration/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
                }
              }
            ],
            "name": "registration",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthRegistration24",
          "filepath": "watson-health/registration/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
                }
              }
            ],
            "name": "registration",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthRegistration20",
          "filepath": "watson-health/registration/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
                }
              }
            ],
            "name": "registration",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthRegistration16",
          "filepath": "watson-health/registration/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
                }
              }
            ],
            "name": "registration",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Registration",
        "global": "WatsonHealthRegistration",
        "filepath": "watson-health/Registration.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reminder",
      "friendlyName": "Reminder",
      "aliases": [
        "reminder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reminder.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>reminder</title><path d=\"M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z\"/><path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z\"/><path d=\"M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z\"/></svg>",
            "info": {},
            "path": "32/reminder.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Reminder32",
          "filepath": "reminder/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "reminder",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Reminder24",
          "filepath": "reminder/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "reminder",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Reminder20",
          "filepath": "reminder/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "reminder",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Reminder16",
          "filepath": "reminder/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                }
              }
            ],
            "name": "reminder",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Reminder",
        "global": "Reminder",
        "filepath": "Reminder.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reminder--medical",
      "friendlyName": "Reminder medical",
      "aliases": [
        "reminder"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reminder--medical.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>reminder--medical</title><path d=\"M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z\"/><path d=\"M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z\"/><path d=\"M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z\"/></svg>",
            "info": {},
            "path": "32/reminder--medical.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ReminderMedical32",
          "filepath": "reminder--medical/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "reminder--medical",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ReminderMedical24",
          "filepath": "reminder--medical/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "reminder--medical",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ReminderMedical20",
          "filepath": "reminder--medical/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "reminder--medical",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ReminderMedical16",
          "filepath": "reminder--medical/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
                }
              }
            ],
            "name": "reminder--medical",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "ReminderMedical",
        "global": "ReminderMedical",
        "filepath": "ReminderMedical.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "renew",
      "friendlyName": "Renew",
      "aliases": [
        "refresh",
        "replay",
        "restart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/renew.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>renew</title><path d=\"M12,10H6.78A11,11,0,0,1,27,16h2A13,13,0,0,0,6,7.68V4H4v8h8Z\"/><path d=\"M20,22h5.22A11,11,0,0,1,5,16H3a13,13,0,0,0,23,8.32V28h2V20H20Z\"/><g id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z\"/></svg>",
            "info": {},
            "path": "32/renew.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Renew32",
          "filepath": "renew/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
                }
              }
            ],
            "name": "renew",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Renew24",
          "filepath": "renew/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
                }
              }
            ],
            "name": "renew",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Renew20",
          "filepath": "renew/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
                }
              }
            ],
            "name": "renew",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Renew16",
          "filepath": "renew/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
                }
              }
            ],
            "name": "renew",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Renew",
        "global": "Renew",
        "filepath": "Renew.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "repeat",
      "friendlyName": "Repeat",
      "aliases": [
        "repeat once",
        "music",
        "control"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/repeat.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M6,6H26.1719l-3.586-3.5859L24,1l6,6-6,6-1.4141-1.4141L26.1719,8H6v7H4V8A2.0024,2.0024,0,0,1,6,6Z\"/>\n  <path d=\"M9.4141,20.4141,5.8281,24H26V17h2v7a2.0024,2.0024,0,0,1-2,2H5.8281L9.414,29.5859,8,31,2,25l6-6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z\"/></svg>",
            "info": {},
            "path": "32/repeat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Repeat32",
          "filepath": "repeat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              }
            ],
            "name": "repeat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Repeat24",
          "filepath": "repeat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              }
            ],
            "name": "repeat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Repeat20",
          "filepath": "repeat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              }
            ],
            "name": "repeat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Repeat16",
          "filepath": "repeat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              }
            ],
            "name": "repeat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Repeat",
        "global": "Repeat",
        "filepath": "Repeat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "repeat--one",
      "friendlyName": "Repeat one",
      "aliases": [
        "repeat once",
        "music",
        "control"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/repeat--one.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M6,6H26.1719l-3.586-3.5859L24,1l6,6-6,6-1.4141-1.4141L26.1719,8H6v7H4V8A2.0024,2.0024,0,0,1,6,6Z\" transform=\"translate(0)\"/>\n  <path d=\"M9.4141,20.4141,5.8281,24H26V17h2v7a2.0024,2.0024,0,0,1-2,2H5.8281L9.414,29.5859,8,31,2,25l6-6Z\" transform=\"translate(0)\"/>\n  <polygon points=\"17 19 17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z\"/><path d=\"M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z\"/></svg>",
            "info": {},
            "path": "32/repeat--one.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RepeatOne32",
          "filepath": "repeat--one/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "repeat--one",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RepeatOne24",
          "filepath": "repeat--one/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "repeat--one",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RepeatOne20",
          "filepath": "repeat--one/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "repeat--one",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RepeatOne16",
          "filepath": "repeat--one/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                }
              }
            ],
            "name": "repeat--one",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "RepeatOne",
        "global": "RepeatOne",
        "filepath": "RepeatOne.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "replicate",
      "friendlyName": "Replicate",
      "aliases": [
        "replicate",
        "duplicate",
        "copy",
        "clone",
        "mirror",
        "reproduce",
        "simulate",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/replicate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,8h2V4a2.0021,2.0021,0,0,0-2-2H24V4h4Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"17\" y=\"2\" width=\"4\" height=\"2\"/>\n  <rect x=\"28\" y=\"11\" width=\"2\" height=\"4\"/>\n  <path d=\"M28,18v4H24V10a2.0023,2.0023,0,0,0-2-2H10V4h4V2H10A2.0023,2.0023,0,0,0,8,4V8H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24h4a2.0023,2.0023,0,0,0,2-2V18ZM22,28H4V10H22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z\"/></svg>",
            "info": {},
            "path": "32/replicate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Replicate32",
          "filepath": "replicate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
                }
              }
            ],
            "name": "replicate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Replicate24",
          "filepath": "replicate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
                }
              }
            ],
            "name": "replicate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Replicate20",
          "filepath": "replicate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
                }
              }
            ],
            "name": "replicate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Replicate16",
          "filepath": "replicate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
                }
              }
            ],
            "name": "replicate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Replicate",
        "global": "Replicate",
        "filepath": "Replicate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reply",
      "friendlyName": "Reply",
      "aliases": [
        "back",
        "respond",
        "email"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reply.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>reply</title><path d=\"M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z\"/></svg>",
            "info": {},
            "path": "32/reply.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Reply32",
          "filepath": "reply/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
                }
              }
            ],
            "name": "reply",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Reply24",
          "filepath": "reply/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
                }
              }
            ],
            "name": "reply",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Reply20",
          "filepath": "reply/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
                }
              }
            ],
            "name": "reply",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Reply16",
          "filepath": "reply/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
                }
              }
            ],
            "name": "reply",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Reply",
        "global": "Reply",
        "filepath": "Reply.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reply--all",
      "friendlyName": "Reply all",
      "aliases": [
        "back",
        "respond all",
        "email"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reply--all.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z\" transform=\"translate(0)\"/>\n  <path d=\"M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z\"/><path d=\"M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z\"/></svg>",
            "info": {},
            "path": "32/reply--all.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ReplyAll32",
          "filepath": "reply--all/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
                }
              }
            ],
            "name": "reply--all",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ReplyAll24",
          "filepath": "reply--all/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
                }
              }
            ],
            "name": "reply--all",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ReplyAll20",
          "filepath": "reply--all/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
                }
              }
            ],
            "name": "reply--all",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ReplyAll16",
          "filepath": "reply--all/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
                }
              }
            ],
            "name": "reply--all",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ReplyAll",
        "global": "ReplyAll",
        "filepath": "ReplyAll.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "repo--artifact",
      "friendlyName": "repo--artifact",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/repo--artifact.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1\n\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\n\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26\n\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z\"/>\n<path d=\"M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5\n\tC30,8.9,29.1,8,28,8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z\"/><path d=\"M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5\tC30,8.9,29.1,8,28,8z\"/></svg>",
            "info": {},
            "path": "32/repo--artifact.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RepoArtifact32",
          "filepath": "repo--artifact/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--artifact",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RepoArtifact24",
          "filepath": "repo--artifact/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--artifact",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RepoArtifact20",
          "filepath": "repo--artifact/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--artifact",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RepoArtifact16",
          "filepath": "repo--artifact/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--artifact",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "RepoArtifact",
        "global": "RepoArtifact",
        "filepath": "RepoArtifact.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5 C30,8.9,29.1,8,28,8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "repo--source-code",
      "friendlyName": "repo--source-code",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/repo--source-code.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"23.6,21.4 27.2,25 27.2,25 23.6,28.6 25,30 30,25 25,20 \"/>\n<polygon points=\"20.4,21.4 16.8,25 16.8,25 20.4,28.6 19,30 14,25 19,20 \"/>\n<path d=\"M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\n\tC30,8.9,29.1,8,28,8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20zM20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z\"/><path d=\"M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z\"/></svg>",
            "info": {},
            "path": "32/repo--source-code.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RepoSourceCode32",
          "filepath": "repo--source-code/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20zM20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--source-code",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RepoSourceCode24",
          "filepath": "repo--source-code/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20zM20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--source-code",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RepoSourceCode20",
          "filepath": "repo--source-code/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20zM20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--source-code",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RepoSourceCode16",
          "filepath": "repo--source-code/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20zM20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8\tC30,8.9,29.1,8,28,8z"
                }
              }
            ],
            "name": "repo--source-code",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "RepoSourceCode",
        "global": "RepoSourceCode",
        "filepath": "RepoSourceCode.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20zM20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8 C30,8.9,29.1,8,28,8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "report",
      "friendlyName": "Report",
      "aliases": [
        "clipboard",
        "paper",
        "chart",
        "summary"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/report.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>report--alt</title><rect x=\"10\" y=\"18\" width=\"8\" height=\"2\"/><rect x=\"10\" y=\"13\" width=\"12\" height=\"2\"/><rect x=\"10\" y=\"23\" width=\"5\" height=\"2\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/></svg>",
            "info": {},
            "path": "32/report.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Report32",
          "filepath": "report/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Report24",
          "filepath": "report/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Report20",
          "filepath": "report/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Report16",
          "filepath": "report/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Report",
        "global": "Report",
        "filepath": "Report.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "report--data",
      "friendlyName": "Report data",
      "aliases": [
        "clipboard",
        "paper",
        "chart",
        "summary"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/report--data.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>report</title><rect x=\"15\" y=\"20\" width=\"2\" height=\"4\"/><rect x=\"20\" y=\"18\" width=\"2\" height=\"6\"/><rect x=\"10\" y=\"14\" width=\"2\" height=\"10\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/></svg>",
            "info": {},
            "path": "32/report--data.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ReportData32",
          "filepath": "report--data/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report--data",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ReportData24",
          "filepath": "report--data/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report--data",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ReportData20",
          "filepath": "report--data/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report--data",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ReportData16",
          "filepath": "report--data/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "report--data",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ReportData",
        "global": "ReportData",
        "filepath": "ReportData.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "request-quote",
      "friendlyName": "Request quote",
      "aliases": [
        "edit",
        "pencil",
        "paper",
        "modify"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/request-quote.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>request-quote</title><path d=\"M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z\" transform=\"translate(0)\"/><path d=\"M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z\"/><path d=\"M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z\"/></svg>",
            "info": {},
            "path": "32/request-quote.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RequestQuote32",
          "filepath": "request-quote/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
                }
              }
            ],
            "name": "request-quote",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RequestQuote24",
          "filepath": "request-quote/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
                }
              }
            ],
            "name": "request-quote",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RequestQuote20",
          "filepath": "request-quote/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
                }
              }
            ],
            "name": "request-quote",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RequestQuote16",
          "filepath": "request-quote/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
                }
              }
            ],
            "name": "request-quote",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "RequestQuote",
        "global": "RequestQuote",
        "filepath": "RequestQuote.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reset",
      "friendlyName": "Reset",
      "aliases": [
        "refresh",
        "undo",
        "revert"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>reset</title><path d=\"M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z\"/></svg>",
            "info": {},
            "path": "32/reset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Reset32",
          "filepath": "reset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
                }
              }
            ],
            "name": "reset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Reset24",
          "filepath": "reset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
                }
              }
            ],
            "name": "reset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Reset20",
          "filepath": "reset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
                }
              }
            ],
            "name": "reset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Reset16",
          "filepath": "reset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
                }
              }
            ],
            "name": "reset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Reset",
        "global": "Reset",
        "filepath": "Reset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "reset--alt",
      "friendlyName": "Reset alt",
      "aliases": [
        "refresh",
        "undo",
        "revert"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/reset--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>reset--alt</title><path d=\"M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z\"/></svg>",
            "info": {},
            "path": "32/reset--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ResetAlt32",
          "filepath": "reset--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
                }
              }
            ],
            "name": "reset--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ResetAlt24",
          "filepath": "reset--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
                }
              }
            ],
            "name": "reset--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ResetAlt20",
          "filepath": "reset--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
                }
              }
            ],
            "name": "reset--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ResetAlt16",
          "filepath": "reset--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
                }
              }
            ],
            "name": "reset--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ResetAlt",
        "global": "ResetAlt",
        "filepath": "ResetAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "restart",
      "friendlyName": "Restart",
      "aliases": [
        "undo",
        "rever",
        "refresh"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/restart.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>restart</title>\n<path d=\"M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6\n\ts6-2.7,6-6H13z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6\ts6-2.7,6-6H13z\"/></svg>",
            "info": {},
            "path": "16/restart.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/restart.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z\"/></svg>",
            "info": {},
            "path": "32/restart.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Restart32",
          "filepath": "restart/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z"
                }
              }
            ],
            "name": "restart",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Restart24",
          "filepath": "restart/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z"
                }
              }
            ],
            "name": "restart",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Restart20",
          "filepath": "restart/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z"
                }
              }
            ],
            "name": "restart",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Restart16",
          "filepath": "restart/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6\ts6-2.7,6-6H13z"
                }
              }
            ],
            "name": "restart",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Restart",
        "global": "Restart",
        "filepath": "Restart.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6 s6-2.7,6-6H13z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "restaurant",
      "friendlyName": "Restaurant",
      "aliases": [
        "dining",
        "knife",
        "fork",
        "utensil",
        "dinner",
        "food",
        "cafe",
        "eat"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/restaurant.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>restaurant</title><rect x=\"9\" y=\"2\" width=\"2\" height=\"10\"/><path d=\"M14,11a4,4,0,0,1-8,0V2H4v9a6,6,0,0,0,5,5.91V30h2V16.91A6,6,0,0,0,16,11V2H14Z\"/><path d=\"M22,2H21V30h2V20h3a2,2,0,0,0,2-2V8A5.78,5.78,0,0,0,22,2Zm4,16H23V4.09c2.88.56,3,3.54,3,3.91Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9 2H11V12H9z\"/><path d=\"M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z\"/></svg>",
            "info": {},
            "path": "32/restaurant.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Restaurant32",
          "filepath": "restaurant/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 2H11V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
                }
              }
            ],
            "name": "restaurant",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Restaurant24",
          "filepath": "restaurant/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 2H11V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
                }
              }
            ],
            "name": "restaurant",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Restaurant20",
          "filepath": "restaurant/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 2H11V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
                }
              }
            ],
            "name": "restaurant",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Restaurant16",
          "filepath": "restaurant/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 2H11V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
                }
              }
            ],
            "name": "restaurant",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Restaurant",
        "global": "Restaurant",
        "filepath": "Restaurant.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 2H11V12H9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "restaurant--fine",
      "friendlyName": "Restaurant fine",
      "aliases": [
        "dining",
        "knife",
        "fork",
        "utensil",
        "dinner",
        "food",
        "cafe",
        "eat"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/restaurant--fine.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>restaurant--fine</title><path d=\"M30,11.0005v-8a1,1,0,0,0-1-1H19a1,1,0,0,0-1,1v8A6.0039,6.0039,0,0,0,23,16.91V28H19v2H29V28H25V16.91A6.0039,6.0039,0,0,0,30,11.0005Zm-10,0V4h8v7.0005a4,4,0,1,1-8,0Z\" transform=\"translate(0 0)\"/><path d=\"M12,2v9.02a3.9644,3.9644,0,0,1-3.96,3.96A4.0052,4.0052,0,0,1,4,11.02V2H2v9.02a5.9888,5.9888,0,0,0,5,5.8652V30H9V16.8953A5.9646,5.9646,0,0,0,14,11.02V2Z\" transform=\"translate(0 0)\"/><rect x=\"7\" y=\"2\" width=\"2\" height=\"9.98\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z\"/><path d=\"M7 2H9V11.98H7z\"/></svg>",
            "info": {},
            "path": "32/restaurant--fine.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RestaurantFine32",
          "filepath": "restaurant--fine/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 2H9V11.98H7z"
                }
              }
            ],
            "name": "restaurant--fine",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RestaurantFine24",
          "filepath": "restaurant--fine/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 2H9V11.98H7z"
                }
              }
            ],
            "name": "restaurant--fine",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RestaurantFine20",
          "filepath": "restaurant--fine/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 2H9V11.98H7z"
                }
              }
            ],
            "name": "restaurant--fine",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RestaurantFine16",
          "filepath": "restaurant--fine/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 2H9V11.98H7z"
                }
              }
            ],
            "name": "restaurant--fine",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "RestaurantFine",
        "global": "RestaurantFine",
        "filepath": "RestaurantFine.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 2H9V11.98H7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "result",
      "friendlyName": "Result",
      "aliases": [
        "clipboard",
        "result",
        "file"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/result.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"13.9999\" y=\"23\" width=\"8\" height=\"2\"/>\n  <rect x=\"9.9999\" y=\"23\" width=\"2\" height=\"2\"/>\n  <rect x=\"13.9999\" y=\"18\" width=\"8\" height=\"2\"/>\n  <rect x=\"9.9999\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"13.9999\" y=\"13\" width=\"8\" height=\"2\"/>\n  <rect x=\"9.9999\" y=\"13\" width=\"2\" height=\"2\"/>\n  <path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 23H22V25H14zM10 23H12V25H10zM14 18H22V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/></svg>",
            "info": {},
            "path": "32/result.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Result32",
          "filepath": "result/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H22V25H14zM10 23H12V25H10zM14 18H22V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "result",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Result24",
          "filepath": "result/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H22V25H14zM10 23H12V25H10zM14 18H22V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "result",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Result20",
          "filepath": "result/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H22V25H14zM10 23H12V25H10zM14 18H22V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "result",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Result16",
          "filepath": "result/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H22V25H14zM10 23H12V25H10zM14 18H22V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "result",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Result",
        "global": "Result",
        "filepath": "Result.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 23H22V25H14zM10 23H12V25H10zM14 18H22V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "result--new",
      "friendlyName": "Result new",
      "aliases": [
        "clipboard",
        "result",
        "file",
        "notification",
        "new"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/result--new.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"26\" cy=\"26\" r=\"4\"/>\n  <rect x=\"9.9999\" y=\"13\" width=\"2\" height=\"2\"/>\n  <rect x=\"9.9999\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"9.9999\" y=\"23\" width=\"2\" height=\"2\"/>\n  <rect x=\"13.9999\" y=\"13\" width=\"8\" height=\"2\"/>\n  <rect x=\"13.9999\" y=\"18\" width=\"8\" height=\"2\"/>\n  <rect x=\"13.9999\" y=\"23\" width=\"4.0001\" height=\"2\"/>\n  <path d=\"M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"26\" cy=\"26\" r=\"4\"/><path d=\"M10 13H12V15H10zM10 18H12V20H10zM10 23H12V25H10zM14 13H22V15H14zM14 18H22V20H14zM14 23H18V25H14z\"/><path d=\"M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z\"/></svg>",
            "info": {},
            "path": "32/result--new.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ResultNew32",
          "filepath": "result--new/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "26",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM10 18H12V20H10zM10 23H12V25H10zM14 13H22V15H14zM14 18H22V20H14zM14 23H18V25H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "result--new",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ResultNew24",
          "filepath": "result--new/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "26",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM10 18H12V20H10zM10 23H12V25H10zM14 13H22V15H14zM14 18H22V20H14zM14 23H18V25H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "result--new",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ResultNew20",
          "filepath": "result--new/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "26",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM10 18H12V20H10zM10 23H12V25H10zM14 13H22V15H14zM14 18H22V20H14zM14 23H18V25H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "result--new",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ResultNew16",
          "filepath": "result--new/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "26",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM10 18H12V20H10zM10 23H12V25H10zM14 13H22V15H14zM14 18H22V20H14zM14 23H18V25H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "result--new",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ResultNew",
        "global": "ResultNew",
        "filepath": "ResultNew.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "26",
                    "r": "4"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 13H12V15H10zM10 18H12V20H10zM10 23H12V25H10zM14 13H22V15H14zM14 18H22V20H14zM14 23H18V25H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "result--old",
      "friendlyName": "Result old",
      "aliases": [
        "clipboard",
        "result",
        "file",
        "previous",
        "old"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/result--old.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n  <rect x=\"10\" y=\"13\" width=\"2\" height=\"2\"/>\n  <rect x=\"14\" y=\"13\" width=\"8\" height=\"2\"/>\n  <rect x=\"10\" y=\"18\" width=\"2\" height=\"2\"/>\n  <rect x=\"10\" y=\"23\" width=\"2\" height=\"2\"/>\n  <path d=\"M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z\"/>\n  <path d=\"M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z\"/>\n  <rect id=\"_Transparent_Rectangle_2\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 13H12V15H10zM14 13H22V15H14zM10 18H12V20H10zM10 23H12V25H10z\"/><path d=\"M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z\"/><path d=\"M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z\"/></svg>",
            "info": {},
            "path": "32/result--old.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ResultOld32",
          "filepath": "result--old/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM14 13H22V15H14zM10 18H12V20H10zM10 23H12V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
                }
              }
            ],
            "name": "result--old",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ResultOld24",
          "filepath": "result--old/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM14 13H22V15H14zM10 18H12V20H10zM10 23H12V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
                }
              }
            ],
            "name": "result--old",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ResultOld20",
          "filepath": "result--old/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM14 13H22V15H14zM10 18H12V20H10zM10 23H12V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
                }
              }
            ],
            "name": "result--old",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ResultOld16",
          "filepath": "result--old/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 13H12V15H10zM14 13H22V15H14zM10 18H12V20H10zM10 23H12V25H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
                }
              }
            ],
            "name": "result--old",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ResultOld",
        "global": "ResultOld",
        "filepath": "ResultOld.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 13H12V15H10zM14 13H22V15H14zM10 18H12V20H10zM10 23H12V25H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "retry--failed",
      "friendlyName": "Retry failed",
      "aliases": [
        "retry",
        "failed",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/retry--failed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26.41 25 30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25\"/>\n  <path d=\"M18,2A12.0351,12.0351,0,0,0,6,14v6.2L2.4,16.6,1,18l6,6,6-6-1.4-1.4L8,20.2V14a10,10,0,0,1,20,0v3h2V14A12.0351,12.0351,0,0,0,18,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25zM18 2A12.0351 12.0351 0 006 14v6.2L2.4 16.6 1 18l6 6 6-6-1.4-1.4L8 20.2V14a10 10 0 0120 0v3h2V14A12.0351 12.0351 0 0018 2z\"/></svg>",
            "info": {},
            "path": "32/retry--failed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RetryFailed32",
          "filepath": "retry--failed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25zM18 2A12.0351 12.0351 0 006 14v6.2L2.4 16.6 1 18l6 6 6-6-1.4-1.4L8 20.2V14a10 10 0 0120 0v3h2V14A12.0351 12.0351 0 0018 2z"
                }
              }
            ],
            "name": "retry--failed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RetryFailed24",
          "filepath": "retry--failed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25zM18 2A12.0351 12.0351 0 006 14v6.2L2.4 16.6 1 18l6 6 6-6-1.4-1.4L8 20.2V14a10 10 0 0120 0v3h2V14A12.0351 12.0351 0 0018 2z"
                }
              }
            ],
            "name": "retry--failed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RetryFailed20",
          "filepath": "retry--failed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25zM18 2A12.0351 12.0351 0 006 14v6.2L2.4 16.6 1 18l6 6 6-6-1.4-1.4L8 20.2V14a10 10 0 0120 0v3h2V14A12.0351 12.0351 0 0018 2z"
                }
              }
            ],
            "name": "retry--failed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RetryFailed16",
          "filepath": "retry--failed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25zM18 2A12.0351 12.0351 0 006 14v6.2L2.4 16.6 1 18l6 6 6-6-1.4-1.4L8 20.2V14a10 10 0 0120 0v3h2V14A12.0351 12.0351 0 0018 2z"
                }
              }
            ],
            "name": "retry--failed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "RetryFailed",
        "global": "RetryFailed",
        "filepath": "RetryFailed.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25zM18 2A12.0351 12.0351 0 006 14v6.2L2.4 16.6 1 18l6 6 6-6-1.4-1.4L8 20.2V14a10 10 0 0120 0v3h2V14A12.0351 12.0351 0 0018 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "review",
      "friendlyName": "Review",
      "aliases": [
        "review",
        "reference",
        "opinion",
        "survey"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/review.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 8 17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8\"/>\n  <path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z\"/><path d=\"M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z\"/></svg>",
            "info": {},
            "path": "32/review.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Review32",
          "filepath": "review/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "review",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Review24",
          "filepath": "review/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "review",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Review20",
          "filepath": "review/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "review",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Review16",
          "filepath": "review/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                }
              }
            ],
            "name": "review",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Review",
        "global": "Review",
        "filepath": "Review.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rewind--10",
      "friendlyName": "Rewind 10",
      "aliases": [
        "back",
        "previous",
        "past",
        "reverse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rewind--10.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rewind--10</title><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/><path d=\"M19.63,22.13a2.84,2.84,0,0,1-1.28-.27,2.44,2.44,0,0,1-.89-.77,3.57,3.57,0,0,1-.52-1.25,7.69,7.69,0,0,1-.17-1.68,7.83,7.83,0,0,1,.17-1.68,3.65,3.65,0,0,1,.52-1.25,2.44,2.44,0,0,1,.89-.77,2.84,2.84,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.23,5.23,0,0,1,.7,2.93,5.23,5.23,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.63,22.13Zm0-1.22a1.07,1.07,0,0,0,1-.55A3.38,3.38,0,0,0,21,18.85V17.47a3.31,3.31,0,0,0-.29-1.5,1.23,1.23,0,0,0-2.06,0,3.31,3.31,0,0,0-.29,1.5v1.38a3.38,3.38,0,0,0,.29,1.51A1.06,1.06,0,0,0,19.63,20.91Z\"/><path d=\"M10.63,22V20.82h2V15.63l-1.86,1-.55-1.06,2.32-1.3H14v6.5h1.78V22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/><path d=\"M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z\"/></svg>",
            "info": {},
            "path": "32/rewind--10.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rewind_1032",
          "filepath": "rewind--10/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "rewind--10",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rewind_1024",
          "filepath": "rewind--10/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "rewind--10",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rewind_1020",
          "filepath": "rewind--10/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "rewind--10",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rewind_1016",
          "filepath": "rewind--10/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                }
              }
            ],
            "name": "rewind--10",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Rewind_10",
        "global": "Rewind_10",
        "filepath": "Rewind_10.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rewind--30",
      "friendlyName": "Rewind 30",
      "aliases": [
        "back",
        "previous",
        "past",
        "reverse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rewind--30.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rewind--30</title><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/><path d=\"M19.64,22.13a2.81,2.81,0,0,1-1.28-.27,2.36,2.36,0,0,1-.89-.77A3.39,3.39,0,0,1,17,19.84a7.12,7.12,0,0,1-.17-1.68A7.24,7.24,0,0,1,17,16.48a3.46,3.46,0,0,1,.52-1.25,2.36,2.36,0,0,1,.89-.77,2.81,2.81,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.31,5.31,0,0,1,.7,2.93,5.31,5.31,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.64,22.13Zm0-1.22a1,1,0,0,0,1-.55,3.24,3.24,0,0,0,.3-1.51V17.47a3.17,3.17,0,0,0-.3-1.5,1.22,1.22,0,0,0-2.05,0,3.18,3.18,0,0,0-.29,1.5v1.38a3.25,3.25,0,0,0,.29,1.51A1,1,0,0,0,19.64,20.91Z\"/><path d=\"M12.62,17.42a1.46,1.46,0,0,0,1-.27.84.84,0,0,0,.31-.68v-.08a.94.94,0,0,0-.3-.74,1.2,1.2,0,0,0-.83-.27,1.65,1.65,0,0,0-.89.24,2.1,2.1,0,0,0-.68.68l-.93-.83a5.37,5.37,0,0,1,.44-.51,2.7,2.7,0,0,1,.54-.4,2.55,2.55,0,0,1,.7-.27,3.25,3.25,0,0,1,.87-.1,3.94,3.94,0,0,1,1.06.14,2.33,2.33,0,0,1,.82.4,1.91,1.91,0,0,1,.54.63,1.87,1.87,0,0,1,.18.83,2,2,0,0,1-.11.67,1.82,1.82,0,0,1-.32.52,1.79,1.79,0,0,1-.47.36,2.27,2.27,0,0,1-.57.2V18a2.34,2.34,0,0,1,.63.21,1.7,1.7,0,0,1,.51.38,1.89,1.89,0,0,1,.34.55,2.07,2.07,0,0,1,.12.73,2,2,0,0,1-.2.92,2,2,0,0,1-.58.72,2.66,2.66,0,0,1-.89.45,3.76,3.76,0,0,1-1.15.16,4.1,4.1,0,0,1-1-.11A3.1,3.1,0,0,1,11,21.7a2.76,2.76,0,0,1-.56-.45A4.22,4.22,0,0,1,10,20.7l1.07-.81a3.07,3.07,0,0,0,.28.42,1.94,1.94,0,0,0,.36.34,1.57,1.57,0,0,0,.45.22,2,2,0,0,0,.57.07,1.45,1.45,0,0,0,1-.3,1.12,1.12,0,0,0,.34-.85v-.08a1,1,0,0,0-.37-.8,1.78,1.78,0,0,0-1.06-.28h-.76V17.42Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/><path d=\"M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z\"/></svg>",
            "info": {},
            "path": "32/rewind--30.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rewind_3032",
          "filepath": "rewind--30/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "rewind--30",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rewind_3024",
          "filepath": "rewind--30/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "rewind--30",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rewind_3020",
          "filepath": "rewind--30/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "rewind--30",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rewind_3016",
          "filepath": "rewind--30/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                }
              }
            ],
            "name": "rewind--30",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Rewind_30",
        "global": "Rewind_30",
        "filepath": "Rewind_30.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rewind--5",
      "friendlyName": "Rewind 5",
      "aliases": [
        "back",
        "previous",
        "past",
        "reverse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rewind--5.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rewind--5</title><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/><path d=\"M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z\"/><path d=\"M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z\"/></svg>",
            "info": {},
            "path": "32/rewind--5.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rewind_532",
          "filepath": "rewind--5/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "rewind--5",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rewind_524",
          "filepath": "rewind--5/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "rewind--5",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rewind_520",
          "filepath": "rewind--5/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "rewind--5",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rewind_516",
          "filepath": "rewind--5/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                }
              }
            ],
            "name": "rewind--5",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Rewind_5",
        "global": "Rewind_5",
        "filepath": "Rewind_5.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "road",
      "friendlyName": "Road",
      "aliases": [
        "road",
        "travel",
        "highway"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/road.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"13\" y=\"13\" width=\"6\" height=\"2\"/>\n  <path d=\"M25.4409,8,24.1687,3.45A2.009,2.009,0,0,0,22.2456,2H9.7544A2.0089,2.0089,0,0,0,7.8313,3.4507L6.5315,8H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V19H22v3h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM9.7544,4H22.2458l1.4285,5H8.3257ZM24,13H22v2h2v2H8V15h2V13H8V11H24Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"16\" width=\"2\" height=\"14\"/>\n  <rect x=\"28\" y=\"16\" width=\"2\" height=\"14\"/>\n  <rect x=\"15\" y=\"21\" width=\"2\" height=\"3\"/>\n  <rect x=\"15\" y=\"26\" width=\"2\" height=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 13H19V15H13z\"/><path d=\"M25.4409 8L24.1687 3.45A2.009 2.009 0 0022.2456 2H9.7544A2.0089 2.0089 0 007.8313 3.4507L6.5315 8H4v2H6v7a2.0025 2.0025 0 002 2v3h2V19H22v3h2V19a2.0025 2.0025 0 002-2V10h2V8zM9.7544 4H22.2458l1.4285 5H8.3257zM24 13H22v2h2v2H8V15h2V13H8V11H24zM2 16H4V30H2zM28 16H30V30H28z\"/><path d=\"M15 21H17V24H15zM15 26H17V30H15z\"/></svg>",
            "info": {},
            "path": "32/road.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Road32",
          "filepath": "road/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 13H19V15H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409 8L24.1687 3.45A2.009 2.009 0 0022.2456 2H9.7544A2.0089 2.0089 0 007.8313 3.4507L6.5315 8H4v2H6v7a2.0025 2.0025 0 002 2v3h2V19H22v3h2V19a2.0025 2.0025 0 002-2V10h2V8zM9.7544 4H22.2458l1.4285 5H8.3257zM24 13H22v2h2v2H8V15h2V13H8V11H24zM2 16H4V30H2zM28 16H30V30H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H17V24H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "road",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Road24",
          "filepath": "road/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 13H19V15H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409 8L24.1687 3.45A2.009 2.009 0 0022.2456 2H9.7544A2.0089 2.0089 0 007.8313 3.4507L6.5315 8H4v2H6v7a2.0025 2.0025 0 002 2v3h2V19H22v3h2V19a2.0025 2.0025 0 002-2V10h2V8zM9.7544 4H22.2458l1.4285 5H8.3257zM24 13H22v2h2v2H8V15h2V13H8V11H24zM2 16H4V30H2zM28 16H30V30H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H17V24H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "road",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Road20",
          "filepath": "road/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 13H19V15H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409 8L24.1687 3.45A2.009 2.009 0 0022.2456 2H9.7544A2.0089 2.0089 0 007.8313 3.4507L6.5315 8H4v2H6v7a2.0025 2.0025 0 002 2v3h2V19H22v3h2V19a2.0025 2.0025 0 002-2V10h2V8zM9.7544 4H22.2458l1.4285 5H8.3257zM24 13H22v2h2v2H8V15h2V13H8V11H24zM2 16H4V30H2zM28 16H30V30H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H17V24H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "road",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Road16",
          "filepath": "road/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 13H19V15H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.4409 8L24.1687 3.45A2.009 2.009 0 0022.2456 2H9.7544A2.0089 2.0089 0 007.8313 3.4507L6.5315 8H4v2H6v7a2.0025 2.0025 0 002 2v3h2V19H22v3h2V19a2.0025 2.0025 0 002-2V10h2V8zM9.7544 4H22.2458l1.4285 5H8.3257zM24 13H22v2h2v2H8V15h2V13H8V11H24zM2 16H4V30H2zM28 16H30V30H28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 21H17V24H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "road",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Road",
        "global": "Road",
        "filepath": "Road.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 13H19V15H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.4409 8L24.1687 3.45A2.009 2.009 0 0022.2456 2H9.7544A2.0089 2.0089 0 007.8313 3.4507L6.5315 8H4v2H6v7a2.0025 2.0025 0 002 2v3h2V19H22v3h2V19a2.0025 2.0025 0 002-2V10h2V8zM9.7544 4H22.2458l1.4285 5H8.3257zM24 13H22v2h2v2H8V15h2V13H8V11H24zM2 16H4V30H2zM28 16H30V30H28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 21H17V24H15zM15 26H17V30H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "road--weather",
      "friendlyName": "Road weather",
      "aliases": [
        "road",
        "travel",
        "weather",
        "caution",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/road--weather.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,31H14v-.228a3.0135,3.0135,0,0,0-1.9468-2.8091L8.5215,26.6384A3.9034,3.9034,0,0,1,6,23H8a1.8946,1.8946,0,0,0,1.2236,1.7659L12.7554,26.09A5.0226,5.0226,0,0,1,16,30.772Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,31H28v-.228a3.0135,3.0135,0,0,0-1.9468-2.8091l-3.5317-1.3245A3.9034,3.9034,0,0,1,20,23h2a1.8946,1.8946,0,0,0,1.2236,1.7659L26.7554,26.09A5.0226,5.0226,0,0,1,30,30.772Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"11\" y=\"13\" width=\"6\" height=\"2\"/>\n  <path d=\"M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 31H14v-.228a3.0135 3.0135 0 00-1.9468-2.8091L8.5215 26.6384A3.9034 3.9034 0 016 23H8a1.8946 1.8946 0 001.2236 1.7659L12.7554 26.09A5.0226 5.0226 0 0116 30.772zM30 31H28v-.228a3.0135 3.0135 0 00-1.9468-2.8091l-3.5317-1.3245A3.9034 3.9034 0 0120 23h2a1.8946 1.8946 0 001.2236 1.7659L26.7554 26.09A5.0226 5.0226 0 0130 30.772zM11 13H17V15H11z\"/><path d=\"M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z\"/></svg>",
            "info": {},
            "path": "32/road--weather.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RoadWeather32",
          "filepath": "road--weather/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 31H14v-.228a3.0135 3.0135 0 00-1.9468-2.8091L8.5215 26.6384A3.9034 3.9034 0 016 23H8a1.8946 1.8946 0 001.2236 1.7659L12.7554 26.09A5.0226 5.0226 0 0116 30.772zM30 31H28v-.228a3.0135 3.0135 0 00-1.9468-2.8091l-3.5317-1.3245A3.9034 3.9034 0 0120 23h2a1.8946 1.8946 0 001.2236 1.7659L26.7554 26.09A5.0226 5.0226 0 0130 30.772zM11 13H17V15H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
                }
              }
            ],
            "name": "road--weather",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RoadWeather24",
          "filepath": "road--weather/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 31H14v-.228a3.0135 3.0135 0 00-1.9468-2.8091L8.5215 26.6384A3.9034 3.9034 0 016 23H8a1.8946 1.8946 0 001.2236 1.7659L12.7554 26.09A5.0226 5.0226 0 0116 30.772zM30 31H28v-.228a3.0135 3.0135 0 00-1.9468-2.8091l-3.5317-1.3245A3.9034 3.9034 0 0120 23h2a1.8946 1.8946 0 001.2236 1.7659L26.7554 26.09A5.0226 5.0226 0 0130 30.772zM11 13H17V15H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
                }
              }
            ],
            "name": "road--weather",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RoadWeather20",
          "filepath": "road--weather/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 31H14v-.228a3.0135 3.0135 0 00-1.9468-2.8091L8.5215 26.6384A3.9034 3.9034 0 016 23H8a1.8946 1.8946 0 001.2236 1.7659L12.7554 26.09A5.0226 5.0226 0 0116 30.772zM30 31H28v-.228a3.0135 3.0135 0 00-1.9468-2.8091l-3.5317-1.3245A3.9034 3.9034 0 0120 23h2a1.8946 1.8946 0 001.2236 1.7659L26.7554 26.09A5.0226 5.0226 0 0130 30.772zM11 13H17V15H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
                }
              }
            ],
            "name": "road--weather",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RoadWeather16",
          "filepath": "road--weather/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 31H14v-.228a3.0135 3.0135 0 00-1.9468-2.8091L8.5215 26.6384A3.9034 3.9034 0 016 23H8a1.8946 1.8946 0 001.2236 1.7659L12.7554 26.09A5.0226 5.0226 0 0116 30.772zM30 31H28v-.228a3.0135 3.0135 0 00-1.9468-2.8091l-3.5317-1.3245A3.9034 3.9034 0 0120 23h2a1.8946 1.8946 0 001.2236 1.7659L26.7554 26.09A5.0226 5.0226 0 0130 30.772zM11 13H17V15H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
                }
              }
            ],
            "name": "road--weather",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "RoadWeather",
        "global": "RoadWeather",
        "filepath": "RoadWeather.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 31H14v-.228a3.0135 3.0135 0 00-1.9468-2.8091L8.5215 26.6384A3.9034 3.9034 0 016 23H8a1.8946 1.8946 0 001.2236 1.7659L12.7554 26.09A5.0226 5.0226 0 0116 30.772zM30 31H28v-.228a3.0135 3.0135 0 00-1.9468-2.8091l-3.5317-1.3245A3.9034 3.9034 0 0120 23h2a1.8946 1.8946 0 001.2236 1.7659L26.7554 26.09A5.0226 5.0226 0 0130 30.772zM11 13H17V15H11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "roadmap",
      "friendlyName": "Roadmap",
      "aliases": [
        "gantt chart",
        "project",
        "timeline"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/roadmap.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>roadmap</title>\n  <path d=\"M12,30H4a2.0023,2.0023,0,0,1-2-2V24a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,12,30ZM4,24v4h8V24Z\"/>\n  <path d=\"M28,20H12a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,20ZM12,14v4H28V14Z\"/>\n  <path d=\"M16,10H4A2.0023,2.0023,0,0,1,2,8V4A2.0023,2.0023,0,0,1,4,2H16a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,16,10ZM4,4V8H16V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z\"/></svg>",
            "info": {},
            "path": "32/roadmap.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Roadmap32",
          "filepath": "roadmap/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
                }
              }
            ],
            "name": "roadmap",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Roadmap24",
          "filepath": "roadmap/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
                }
              }
            ],
            "name": "roadmap",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Roadmap20",
          "filepath": "roadmap/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
                }
              }
            ],
            "name": "roadmap",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Roadmap16",
          "filepath": "roadmap/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
                }
              }
            ],
            "name": "roadmap",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Roadmap",
        "global": "Roadmap",
        "filepath": "Roadmap.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rocket",
      "friendlyName": "Rocket",
      "aliases": [
        "missile",
        "spaceship",
        "spacecraft",
        "boost",
        "launch",
        "deploy",
        "start",
        "send",
        "space",
        "orbit",
        "pitch",
        "propel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rocket.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rocket</title><rect x=\"6.34\" y=\"19\" width=\"11.31\" height=\"2\" transform=\"translate(-10.63 14.34) rotate(-45)\"/><path d=\"M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6.34 19H17.65V21H6.34z\" transform=\"rotate(-45 11.995 20.002)\"/><path d=\"M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z\"/></svg>",
            "info": {},
            "path": "32/rocket.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rocket32",
          "filepath": "rocket/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.34 19H17.65V21H6.34z",
                  "transform": "rotate(-45 11.995 20.002)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
                }
              }
            ],
            "name": "rocket",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rocket24",
          "filepath": "rocket/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.34 19H17.65V21H6.34z",
                  "transform": "rotate(-45 11.995 20.002)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
                }
              }
            ],
            "name": "rocket",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rocket20",
          "filepath": "rocket/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.34 19H17.65V21H6.34z",
                  "transform": "rotate(-45 11.995 20.002)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
                }
              }
            ],
            "name": "rocket",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rocket16",
          "filepath": "rocket/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.34 19H17.65V21H6.34z",
                  "transform": "rotate(-45 11.995 20.002)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
                }
              }
            ],
            "name": "rocket",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Rocket",
        "global": "Rocket",
        "filepath": "Rocket.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.34 19H17.65V21H6.34z",
                    "transform": "rotate(-45 11.995 20.002)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate",
      "friendlyName": "Rotate",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate</title><path d=\"M17.91,26.82l.35,2a12.9,12.9,0,0,0,4.24-1.54l-1-1.73A10.88,10.88,0,0,1,17.91,26.82Z\"/><path d=\"M24.42,23.07,26,24.35a13,13,0,0,0,2.24-3.91l-1.87-.68A11,11,0,0,1,24.42,23.07Z\"/><path d=\"M9.5,27.25a12.9,12.9,0,0,0,4.24,1.54l.35-2a10.88,10.88,0,0,1-3.59-1.3Z\"/><path d=\"M5.67,19.76l-1.87.68A13,13,0,0,0,6,24.35l.32-.26,1.22-1h0a11,11,0,0,1-1.91-3.31Z\"/><path d=\"M29,16a12.85,12.85,0,0,0-.8-4.44l-1.87.68A11.18,11.18,0,0,1,27,16Z\"/><path d=\"M26,7.65a13,13,0,0,0-20,0V4H4v8h8V10H6.81A11,11,0,0,1,24.42,8.93Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z\"/></svg>",
            "info": {},
            "path": "32/rotate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rotate32",
          "filepath": "rotate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
                }
              }
            ],
            "name": "rotate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rotate24",
          "filepath": "rotate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
                }
              }
            ],
            "name": "rotate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rotate20",
          "filepath": "rotate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
                }
              }
            ],
            "name": "rotate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rotate16",
          "filepath": "rotate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
                }
              }
            ],
            "name": "rotate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Rotate",
        "global": "Rotate",
        "filepath": "Rotate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--180",
      "friendlyName": "Rotate 180",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/rotate--180.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--180</title><path d=\"M14.0913,26.8235l-.3467,1.968a12.8956,12.8956,0,0,1-4.24-1.5418l1-1.7307A10.9086,10.9086,0,0,0,14.0913,26.8235Z\"/><path d=\"M7.5767,23.0682,6.0449,24.3533a12.9811,12.9811,0,0,1-2.25-3.9112l1.8775-.6834A10.9808,10.9808,0,0,0,7.5767,23.0682Z\"/><path d=\"M22.4951,27.25a12.8956,12.8956,0,0,1-4.24,1.5418l-.3467-1.968a10.9086,10.9086,0,0,0,3.5869-1.3045Z\"/><path d=\"M26.3271,19.7587l1.8775.6834a12.9811,12.9811,0,0,1-2.2495,3.9112l-.3115-.2614-1.22-1.0237h0a10.9822,10.9822,0,0,0,1.9038-3.3093Z\"/><path d=\"M13.6616,5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438,10.9438,0,0,0,5,16H3A12.9363,12.9363,0,0,1,6.05,7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331,12.9331,0,0,1,26,7.7031V4h2v8H20V10h5.1885A10.961,10.961,0,0,0,16,5a11.1114,11.1114,0,0,0-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575,5.165,13.907,5.2026,13.6616,5.2559Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z\"/></svg>",
            "info": {},
            "path": "32/watson-health/rotate--180.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthRotate_18032",
          "filepath": "watson-health/rotate--180/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
                }
              }
            ],
            "name": "rotate--180",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthRotate_18024",
          "filepath": "watson-health/rotate--180/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
                }
              }
            ],
            "name": "rotate--180",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthRotate_18020",
          "filepath": "watson-health/rotate--180/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
                }
              }
            ],
            "name": "rotate--180",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthRotate_18016",
          "filepath": "watson-health/rotate--180/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
                }
              }
            ],
            "name": "rotate--180",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Rotate_180",
        "global": "WatsonHealthRotate_180",
        "filepath": "watson-health/Rotate_180.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--360",
      "friendlyName": "Rotate 360",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/rotate--360.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--360</title><path d=\"M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/rotate--360.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthRotate_36032",
          "filepath": "watson-health/rotate--360/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
                }
              }
            ],
            "name": "rotate--360",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthRotate_36024",
          "filepath": "watson-health/rotate--360/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
                }
              }
            ],
            "name": "rotate--360",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthRotate_36020",
          "filepath": "watson-health/rotate--360/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
                }
              }
            ],
            "name": "rotate--360",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthRotate_36016",
          "filepath": "watson-health/rotate--360/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
                }
              }
            ],
            "name": "rotate--360",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Rotate_360",
        "global": "WatsonHealthRotate_360",
        "filepath": "watson-health/Rotate_360.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--clockwise",
      "friendlyName": "Rotate clockwise",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--clockwise.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--clockwise</title><path d=\"M28,30H16a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM16,16V28H28.0012L28,16Z\" transform=\"translate(0)\"/><path d=\"M15,2,13.59,3.41,16.17,6H11a7.0078,7.0078,0,0,0-7,7v5H6V13a5.0057,5.0057,0,0,1,5-5h5.17l-2.58,2.59L15,12l5-5Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z\"/></svg>",
            "info": {},
            "path": "32/rotate--clockwise.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateClockwise32",
          "filepath": "rotate--clockwise/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateClockwise24",
          "filepath": "rotate--clockwise/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateClockwise20",
          "filepath": "rotate--clockwise/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateClockwise16",
          "filepath": "rotate--clockwise/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateClockwise",
        "global": "RotateClockwise",
        "filepath": "RotateClockwise.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--clockwise--alt",
      "friendlyName": "Rotate clockwise alt",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--clockwise--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--counterclockwise--alt</title><path d=\"M16,30H4a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,16,30ZM4,16V28H16.0012L16,16Z\" transform=\"translate(0)\"/><path d=\"M30,15l-1.41-1.41L26,16.17V11a7.0078,7.0078,0,0,0-7-7H14V6h5a5.0057,5.0057,0,0,1,5,5v5.17l-2.59-2.58L20,15l5,5Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z\"/></svg>",
            "info": {},
            "path": "32/rotate--clockwise--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateClockwiseAlt32",
          "filepath": "rotate--clockwise--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateClockwiseAlt24",
          "filepath": "rotate--clockwise--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateClockwiseAlt20",
          "filepath": "rotate--clockwise--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateClockwiseAlt16",
          "filepath": "rotate--clockwise--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateClockwiseAlt",
        "global": "RotateClockwiseAlt",
        "filepath": "RotateClockwiseAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--clockwise--alt--filled",
      "friendlyName": "Rotate clockwise alt filled",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--clockwise--alt--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--clockwise--alt--filled</title><path d=\"M16,30H4a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,16,30Z\" transform=\"translate(0)\"/><path d=\"M30,15l-1.41-1.41L26,16.17V11a7.0078,7.0078,0,0,0-7-7H14V6h5a5.0057,5.0057,0,0,1,5,5v5.17l-2.59-2.58L20,15l5,5Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z\"/></svg>",
            "info": {},
            "path": "32/rotate--clockwise--alt--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateClockwiseAltFilled32",
          "filepath": "rotate--clockwise--alt--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateClockwiseAltFilled24",
          "filepath": "rotate--clockwise--alt--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateClockwiseAltFilled20",
          "filepath": "rotate--clockwise--alt--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateClockwiseAltFilled16",
          "filepath": "rotate--clockwise--alt--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                }
              }
            ],
            "name": "rotate--clockwise--alt--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateClockwiseAltFilled",
        "global": "RotateClockwiseAltFilled",
        "filepath": "RotateClockwiseAltFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--clockwise--filled",
      "friendlyName": "Rotate clockwise filled",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--clockwise--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--clockwise--filled</title><path d=\"M28,30H16a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30Z\"/><path d=\"M15,2,13.59,3.41,16.17,6H11a7.0078,7.0078,0,0,0-7,7v5H6V13a5.0057,5.0057,0,0,1,5-5h5.17l-2.58,2.59L15,12l5-5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z\"/></svg>",
            "info": {},
            "path": "32/rotate--clockwise--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateClockwiseFilled32",
          "filepath": "rotate--clockwise--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateClockwiseFilled24",
          "filepath": "rotate--clockwise--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateClockwiseFilled20",
          "filepath": "rotate--clockwise--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateClockwiseFilled16",
          "filepath": "rotate--clockwise--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                }
              }
            ],
            "name": "rotate--clockwise--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateClockwiseFilled",
        "global": "RotateClockwiseFilled",
        "filepath": "RotateClockwiseFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--counterclockwise",
      "friendlyName": "Rotate counterclockwise",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--counterclockwise.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--counterclockwise</title><path d=\"M2,28V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,28ZM4,16,3.9988,28H16V16Z\" transform=\"translate(0 0)\"/><path d=\"M17,2l1.41,1.41L15.83,6H21a7.0078,7.0078,0,0,1,7,7v5H26V13a5.0057,5.0057,0,0,0-5-5H15.83l2.58,2.59L17,12,12,7Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z\"/></svg>",
            "info": {},
            "path": "32/rotate--counterclockwise.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateCounterclockwise32",
          "filepath": "rotate--counterclockwise/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateCounterclockwise24",
          "filepath": "rotate--counterclockwise/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateCounterclockwise20",
          "filepath": "rotate--counterclockwise/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateCounterclockwise16",
          "filepath": "rotate--counterclockwise/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateCounterclockwise",
        "global": "RotateCounterclockwise",
        "filepath": "RotateCounterclockwise.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--counterclockwise--alt",
      "friendlyName": "Rotate counterclockwise alt",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--counterclockwise--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--counterclockwise--alt</title><path d=\"M14,28V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H16A2.0023,2.0023,0,0,1,14,28Zm2-12-.0012,12H28V16Z\" transform=\"translate(0 0)\"/><path d=\"M2,15l1.41-1.41L6,16.17V11a7.0078,7.0078,0,0,1,7-7h5V6H13a5.0057,5.0057,0,0,0-5,5v5.17l2.59-2.58L12,15,7,20Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z\"/></svg>",
            "info": {},
            "path": "32/rotate--counterclockwise--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateCounterclockwiseAlt32",
          "filepath": "rotate--counterclockwise--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateCounterclockwiseAlt24",
          "filepath": "rotate--counterclockwise--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateCounterclockwiseAlt20",
          "filepath": "rotate--counterclockwise--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateCounterclockwiseAlt16",
          "filepath": "rotate--counterclockwise--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateCounterclockwiseAlt",
        "global": "RotateCounterclockwiseAlt",
        "filepath": "RotateCounterclockwiseAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--counterclockwise--alt--filled",
      "friendlyName": "Rotate counterclockwise alt filled",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--counterclockwise--alt--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--counterclockwise--alt--filled</title><path d=\"M14,28V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H16A2.0023,2.0023,0,0,1,14,28Z\" transform=\"translate(0 0)\"/><path d=\"M2,15l1.41-1.41L6,16.17V11a7.0078,7.0078,0,0,1,7-7h5V6H13a5.0057,5.0057,0,0,0-5,5v5.17l2.59-2.58L12,15,7,20Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z\"/></svg>",
            "info": {},
            "path": "32/rotate--counterclockwise--alt--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateCounterclockwiseAltFilled32",
          "filepath": "rotate--counterclockwise--alt--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateCounterclockwiseAltFilled24",
          "filepath": "rotate--counterclockwise--alt--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateCounterclockwiseAltFilled20",
          "filepath": "rotate--counterclockwise--alt--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateCounterclockwiseAltFilled16",
          "filepath": "rotate--counterclockwise--alt--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                }
              }
            ],
            "name": "rotate--counterclockwise--alt--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateCounterclockwiseAltFilled",
        "global": "RotateCounterclockwiseAltFilled",
        "filepath": "RotateCounterclockwiseAltFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rotate--counterclockwise--filled",
      "friendlyName": "Rotate counterclockwise filled",
      "aliases": [
        "revolve",
        "circle",
        "circulate",
        "circle arrow",
        "launch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rotate--counterclockwise--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rotate--counterclockwise--filled</title><path d=\"M2,28V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,28Z\" transform=\"translate(0 0)\"/><path d=\"M17,2l1.41,1.41L15.83,6H21a7.0078,7.0078,0,0,1,7,7v5H26V13a5.0057,5.0057,0,0,0-5-5H15.83l2.58,2.59L17,12,12,7Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z\"/></svg>",
            "info": {},
            "path": "32/rotate--counterclockwise--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RotateCounterclockwiseFilled32",
          "filepath": "rotate--counterclockwise--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RotateCounterclockwiseFilled24",
          "filepath": "rotate--counterclockwise--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RotateCounterclockwiseFilled20",
          "filepath": "rotate--counterclockwise--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RotateCounterclockwiseFilled16",
          "filepath": "rotate--counterclockwise--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                }
              }
            ],
            "name": "rotate--counterclockwise--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RotateCounterclockwiseFilled",
        "global": "RotateCounterclockwiseFilled",
        "filepath": "RotateCounterclockwiseFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "router",
      "friendlyName": "Router",
      "aliases": [
        "arrows",
        "signal",
        "network",
        "hardware",
        "router"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/router.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"21 7 16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7\"/>\n  <polygon points=\"21 25 16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25\"/>\n  <polygon points=\"24 11 19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11\"/>\n  <polygon points=\"8 11 13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z\"/></svg>",
            "info": {},
            "path": "32/router.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Router32",
          "filepath": "router/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Router24",
          "filepath": "router/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Router20",
          "filepath": "router/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Router16",
          "filepath": "router/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Router",
        "global": "Router",
        "filepath": "Router.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "router--voice",
      "friendlyName": "Router voice",
      "aliases": [
        "arrows",
        "phone",
        "signal",
        "network",
        "hardware",
        "router"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/router--voice.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"21 25 16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25\"/>\n  <polygon points=\"24 11 19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11\"/>\n  <polygon points=\"8 11 13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11\"/>\n  <path d=\"M12.4289,5.8227v1.63a1.1269,1.1269,0,0,1-.6767,1.026l-1.39.5967A1.1218,1.1218,0,0,1,9.14,8.8424L7.3208,7.0233a1.1165,1.1165,0,0,1,.0125-1.579l.0348-.0328c7.393-6.527,14.6913-2.0374,17.2127-.0473a1.1166,1.1166,0,0,1,.1746,1.5693,1.1011,1.1011,0,0,1-.0873.0971L22.9108,8.7878a1.1114,1.1114,0,0,1-1.2225.2329l-1.39-.5967a1.1112,1.1112,0,0,1-.68-1.0223v-1.63S15.9726,3.0648,12.4289,5.8227Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11zM12.4289 5.8227v1.63a1.1269 1.1269 0 01-.6767 1.026l-1.39.5967A1.1218 1.1218 0 019.14 8.8424L7.3208 7.0233a1.1165 1.1165 0 01.0125-1.579l.0348-.0328c7.393-6.527 14.6913-2.0374 17.2127-.0473a1.1166 1.1166 0 01.1746 1.5693 1.1011 1.1011 0 01-.0873.0971L22.9108 8.7878a1.1114 1.1114 0 01-1.2225.2329l-1.39-.5967a1.1112 1.1112 0 01-.68-1.0223v-1.63S15.9726 3.0648 12.4289 5.8227z\"/></svg>",
            "info": {},
            "path": "32/router--voice.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RouterVoice32",
          "filepath": "router--voice/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11zM12.4289 5.8227v1.63a1.1269 1.1269 0 01-.6767 1.026l-1.39.5967A1.1218 1.1218 0 019.14 8.8424L7.3208 7.0233a1.1165 1.1165 0 01.0125-1.579l.0348-.0328c7.393-6.527 14.6913-2.0374 17.2127-.0473a1.1166 1.1166 0 01.1746 1.5693 1.1011 1.1011 0 01-.0873.0971L22.9108 8.7878a1.1114 1.1114 0 01-1.2225.2329l-1.39-.5967a1.1112 1.1112 0 01-.68-1.0223v-1.63S15.9726 3.0648 12.4289 5.8227z"
                }
              }
            ],
            "name": "router--voice",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RouterVoice24",
          "filepath": "router--voice/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11zM12.4289 5.8227v1.63a1.1269 1.1269 0 01-.6767 1.026l-1.39.5967A1.1218 1.1218 0 019.14 8.8424L7.3208 7.0233a1.1165 1.1165 0 01.0125-1.579l.0348-.0328c7.393-6.527 14.6913-2.0374 17.2127-.0473a1.1166 1.1166 0 01.1746 1.5693 1.1011 1.1011 0 01-.0873.0971L22.9108 8.7878a1.1114 1.1114 0 01-1.2225.2329l-1.39-.5967a1.1112 1.1112 0 01-.68-1.0223v-1.63S15.9726 3.0648 12.4289 5.8227z"
                }
              }
            ],
            "name": "router--voice",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RouterVoice20",
          "filepath": "router--voice/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11zM12.4289 5.8227v1.63a1.1269 1.1269 0 01-.6767 1.026l-1.39.5967A1.1218 1.1218 0 019.14 8.8424L7.3208 7.0233a1.1165 1.1165 0 01.0125-1.579l.0348-.0328c7.393-6.527 14.6913-2.0374 17.2127-.0473a1.1166 1.1166 0 01.1746 1.5693 1.1011 1.1011 0 01-.0873.0971L22.9108 8.7878a1.1114 1.1114 0 01-1.2225.2329l-1.39-.5967a1.1112 1.1112 0 01-.68-1.0223v-1.63S15.9726 3.0648 12.4289 5.8227z"
                }
              }
            ],
            "name": "router--voice",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RouterVoice16",
          "filepath": "router--voice/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11zM12.4289 5.8227v1.63a1.1269 1.1269 0 01-.6767 1.026l-1.39.5967A1.1218 1.1218 0 019.14 8.8424L7.3208 7.0233a1.1165 1.1165 0 01.0125-1.579l.0348-.0328c7.393-6.527 14.6913-2.0374 17.2127-.0473a1.1166 1.1166 0 01.1746 1.5693 1.1011 1.1011 0 01-.0873.0971L22.9108 8.7878a1.1114 1.1114 0 01-1.2225.2329l-1.39-.5967a1.1112 1.1112 0 01-.68-1.0223v-1.63S15.9726 3.0648 12.4289 5.8227z"
                }
              }
            ],
            "name": "router--voice",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "RouterVoice",
        "global": "RouterVoice",
        "filepath": "RouterVoice.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11zM12.4289 5.8227v1.63a1.1269 1.1269 0 01-.6767 1.026l-1.39.5967A1.1218 1.1218 0 019.14 8.8424L7.3208 7.0233a1.1165 1.1165 0 01.0125-1.579l.0348-.0328c7.393-6.527 14.6913-2.0374 17.2127-.0473a1.1166 1.1166 0 01.1746 1.5693 1.1011 1.1011 0 01-.0873.0971L22.9108 8.7878a1.1114 1.1114 0 01-1.2225.2329l-1.39-.5967a1.1112 1.1112 0 01-.68-1.0223v-1.63S15.9726 3.0648 12.4289 5.8227z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "router--wifi",
      "friendlyName": "Router WiFi",
      "aliases": [
        "arrows",
        "signal",
        "network",
        "hardware",
        "router",
        "wireless"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/router--wifi.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"16\" cy=\"13.5\" r=\"1.5\"/>\n  <path d=\"M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.0713,6.929a10,10,0,0,0-14.1426,0L7.5146,5.5144a12.0011,12.0011,0,0,1,16.9708,0Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"21 25 16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25\"/>\n  <polygon points=\"24 11 19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11\"/>\n  <polygon points=\"8 11 13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"13.5\" r=\"1.5\"/><path d=\"M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z\"/><path d=\"M23.0713 6.929a10 10 0 00-14.1426 0L7.5146 5.5144a12.0011 12.0011 0 0116.9708 0zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z\"/></svg>",
            "info": {},
            "path": "32/router--wifi.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RouterWifi32",
          "filepath": "router--wifi/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.0713 6.929a10 10 0 00-14.1426 0L7.5146 5.5144a12.0011 12.0011 0 0116.9708 0zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router--wifi",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RouterWifi24",
          "filepath": "router--wifi/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.0713 6.929a10 10 0 00-14.1426 0L7.5146 5.5144a12.0011 12.0011 0 0116.9708 0zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router--wifi",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RouterWifi20",
          "filepath": "router--wifi/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.0713 6.929a10 10 0 00-14.1426 0L7.5146 5.5144a12.0011 12.0011 0 0116.9708 0zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router--wifi",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RouterWifi16",
          "filepath": "router--wifi/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.0713 6.929a10 10 0 00-14.1426 0L7.5146 5.5144a12.0011 12.0011 0 0116.9708 0zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                }
              }
            ],
            "name": "router--wifi",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "RouterWifi",
        "global": "RouterWifi",
        "filepath": "RouterWifi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "13.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.0713 6.929a10 10 0 00-14.1426 0L7.5146 5.5144a12.0011 12.0011 0 0116.9708 0zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "row",
      "friendlyName": "Row",
      "aliases": [
        "line",
        "tier",
        "queue",
        "column",
        "composition",
        "layout",
        "horizontal",
        "template"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/row.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>row</title><rect x=\"4\" y=\"24\" width=\"24\" height=\"2\"/><path d=\"M26,18H6V14H26v4m2,0V14a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2Z\"/><rect x=\"4\" y=\"6\" width=\"24\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32) rotate(90)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z\"/></svg>",
            "info": {},
            "path": "32/row.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Row32",
          "filepath": "row/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
                }
              }
            ],
            "name": "row",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Row24",
          "filepath": "row/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
                }
              }
            ],
            "name": "row",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Row20",
          "filepath": "row/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
                }
              }
            ],
            "name": "row",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Row16",
          "filepath": "row/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
                }
              }
            ],
            "name": "row",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Row",
        "global": "Row",
        "filepath": "Row.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "row--collapse",
      "friendlyName": "Row collapse",
      "aliases": [
        "spreadsheet",
        "table",
        "data analytics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/row--collapse.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>row--collapse</title>\n  <path d=\"M26,20H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V22A2,2,0,0,0,26,20Zm0,6H6V22H26Z\"/>\n  <polygon points=\"17 7.828 19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z\"/></svg>",
            "info": {},
            "path": "32/row--collapse.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RowCollapse32",
          "filepath": "row--collapse/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
                }
              }
            ],
            "name": "row--collapse",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RowCollapse24",
          "filepath": "row--collapse/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
                }
              }
            ],
            "name": "row--collapse",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RowCollapse20",
          "filepath": "row--collapse/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
                }
              }
            ],
            "name": "row--collapse",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RowCollapse16",
          "filepath": "row--collapse/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
                }
              }
            ],
            "name": "row--collapse",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "RowCollapse",
        "global": "RowCollapse",
        "filepath": "RowCollapse.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "row--delete",
      "friendlyName": "Row delete",
      "aliases": [
        "row",
        "delete",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/row--delete.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,24,30ZM4,22H3.9985L4,28H24V22Z\"/>\n  <polygon points=\"30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41\"/>\n  <path d=\"M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0124 30zM4 22H3.9985L4 28H24V22zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z\"/><path d=\"M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z\"/></svg>",
            "info": {},
            "path": "32/row--delete.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RowDelete32",
          "filepath": "row--delete/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0124 30zM4 22H3.9985L4 28H24V22zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
                }
              }
            ],
            "name": "row--delete",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RowDelete24",
          "filepath": "row--delete/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0124 30zM4 22H3.9985L4 28H24V22zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
                }
              }
            ],
            "name": "row--delete",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RowDelete20",
          "filepath": "row--delete/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0124 30zM4 22H3.9985L4 28H24V22zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
                }
              }
            ],
            "name": "row--delete",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RowDelete16",
          "filepath": "row--delete/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0124 30zM4 22H3.9985L4 28H24V22zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
                }
              }
            ],
            "name": "row--delete",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RowDelete",
        "global": "RowDelete",
        "filepath": "RowDelete.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0124 30zM4 22H3.9985L4 28H24V22zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "row--expand",
      "friendlyName": "Row expand",
      "aliases": [
        "spreadsheet",
        "table",
        "data analytics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/row--expand.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>row--expand</title>\n  <polygon points=\"4 18 15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18\"/>\n  <path d=\"M26,4H6A2,2,0,0,0,4,6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,6H6V6H26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z\"/></svg>",
            "info": {},
            "path": "32/row--expand.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RowExpand32",
          "filepath": "row--expand/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
                }
              }
            ],
            "name": "row--expand",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RowExpand24",
          "filepath": "row--expand/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
                }
              }
            ],
            "name": "row--expand",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RowExpand20",
          "filepath": "row--expand/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
                }
              }
            ],
            "name": "row--expand",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RowExpand16",
          "filepath": "row--expand/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
                }
              }
            ],
            "name": "row--expand",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "RowExpand",
        "global": "RowExpand",
        "filepath": "RowExpand.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "row--insert",
      "friendlyName": "Row insert",
      "aliases": [
        "row",
        "insert",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/row--insert.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,12H10a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12ZM10,4v6H28V4Z\"/>\n  <path d=\"M28,30H10a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM10,22v6H28V22Z\"/>\n  <polygon points=\"9 16 3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 12H10a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 12zM10 4v6H28V4zM28 30H10a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM10 22v6H28V22zM9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z\"/></svg>",
            "info": {},
            "path": "32/row--insert.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RowInsert32",
          "filepath": "row--insert/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H10a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 12zM10 4v6H28V4zM28 30H10a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM10 22v6H28V22zM9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
                }
              }
            ],
            "name": "row--insert",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RowInsert24",
          "filepath": "row--insert/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H10a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 12zM10 4v6H28V4zM28 30H10a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM10 22v6H28V22zM9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
                }
              }
            ],
            "name": "row--insert",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RowInsert20",
          "filepath": "row--insert/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H10a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 12zM10 4v6H28V4zM28 30H10a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM10 22v6H28V22zM9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
                }
              }
            ],
            "name": "row--insert",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RowInsert16",
          "filepath": "row--insert/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 12H10a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 12zM10 4v6H28V4zM28 30H10a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM10 22v6H28V22zM9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
                }
              }
            ],
            "name": "row--insert",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "RowInsert",
        "global": "RowInsert",
        "filepath": "RowInsert.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 12H10a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 12zM10 4v6H28V4zM28 30H10a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM10 22v6H28V22zM9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rss",
      "friendlyName": "RSS",
      "aliases": [
        "web feed",
        "feed",
        "news",
        "reading",
        "subscribe",
        "subscription"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rss.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M8,18c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6C14,20.7,11.3,18,8,18z M8,28c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4\n\tC12,26.2,10.2,28,8,28z\"/>\n<path d=\"M30,24h-2C28,13,19,4,8,4V2C20.1,2,30,11.9,30,24z\"/>\n<path d=\"M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z\"/><path d=\"M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z\"/></svg>",
            "info": {},
            "path": "32/rss.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rss32",
          "filepath": "rss/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
                }
              }
            ],
            "name": "rss",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rss24",
          "filepath": "rss/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
                }
              }
            ],
            "name": "rss",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rss20",
          "filepath": "rss/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
                }
              }
            ],
            "name": "rss",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rss16",
          "filepath": "rss/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
                }
              }
            ],
            "name": "rss",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Rss",
        "global": "Rss",
        "filepath": "Rss.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rule",
      "friendlyName": "Rule",
      "aliases": [
        "rule",
        "governance",
        "control",
        "policy",
        "security",
        "shield"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rule.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>rule</title><rect x=\"10\" y=\"16\" width=\"12\" height=\"2\"/><rect x=\"10\" y=\"10\" width=\"12\" height=\"2\"/><path d=\"M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 16H22V18H10zM10 10H22V12H10z\"/><path d=\"M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z\"/></svg>",
            "info": {},
            "path": "32/rule.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Rule32",
          "filepath": "rule/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 10H22V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "rule",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Rule24",
          "filepath": "rule/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 10H22V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "rule",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Rule20",
          "filepath": "rule/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 10H22V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "rule",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Rule16",
          "filepath": "rule/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 10H22V12H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "rule",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Rule",
        "global": "Rule",
        "filepath": "Rule.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 16H22V18H10zM10 10H22V12H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rule--cancelled",
      "friendlyName": "Rule cancelled",
      "aliases": [
        "rule",
        "governance",
        "control",
        "policy",
        "cancel",
        "security",
        "shield"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rule--cancelled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"8\" y=\"16\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n  <path d=\"M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z\"/><path d=\"M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z\"/></svg>",
            "info": {},
            "path": "32/rule--cancelled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RuleCancelled32",
          "filepath": "rule--cancelled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "rule--cancelled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RuleCancelled24",
          "filepath": "rule--cancelled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "rule--cancelled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RuleCancelled20",
          "filepath": "rule--cancelled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "rule--cancelled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RuleCancelled16",
          "filepath": "rule--cancelled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                }
              }
            ],
            "name": "rule--cancelled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "RuleCancelled",
        "global": "RuleCancelled",
        "filepath": "RuleCancelled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rule--data-quality",
      "friendlyName": "Rule data quality",
      "aliases": [
        "rule",
        "governance",
        "control",
        "policy",
        "quality",
        "security",
        "shield",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rule--data-quality.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:#040602;}\n\t.st1{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<path class=\"st0\" d=\"M30,28.6l-2.8-2.8C27.7,25,28,24,28,23c0-2.8-2.2-5-5-5s-5,2.2-5,5s2.2,5,5,5c1,0,2-0.3,2.8-0.8l2.8,2.8\n\t\t\tL30,28.6z M20,23c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3S20,24.7,20,23z\"/>\n\t\t<rect x=\"8\" y=\"16\" width=\"10\" height=\"2\"/>\n\t\t<rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n\t\t<path d=\"M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30\n\t\t\tV27.7z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st1\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYzJkEnvyFnAwqsNhQCm1AhxN98quMDxxL1wnE461trWYzkyK7e2dpirmsIOg/6HCzswMO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\n\t]]>\n\t<![CDATA[\n\t4MIECzhwcLAgAMOCDSZQoMAwMIBggUIFRQDGBRYqNFTO4wIKFSZsYEECBh4kAxAOHBxGysMCCgTA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\n\t]]>\n\t<![CDATA[\n\t48AbGfV+mb3HyqHlwJxBtFDW+d/giW+UKnv/R3O0Fs33Q7kaRblDw/wTa7BuEg2vVyNdsyt4HcEa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\n\t]]>\n\t<![CDATA[\n\t7GjDOtY2ipRXd0SUWpWcULJG8fMqSazhz8sSbW4rCyWxzStEq6LK5pQt8zXSDsn2wZpk+jf7JLPI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\n\t]]>\n\t<![CDATA[\n\tQeaz/+f5fzc98rAPAbeFIboHl895MvdR3p/DibiMo6m4qmKclehzLwNNHJBA+rLFfveOqQ2JUwZI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\n\t]]>\n\t<![CDATA[\n\tMl0gYQlNK5AT9VcKAoN/KwMb8nLiGEwGgloByOGwJy1Zl0+2h6qqOqWSOWRCKmrsMq0WMWRedTCC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\n\t]]>\n\t<![CDATA[\n\tl48VvesoUzZMxVNMdQveWb0gurR/hnhJnOTPY++FE9dQvaE4d0Cu2eC26u7uU131KJ5+NGYMBiXO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\n\t]]>\n\t<![CDATA[\n\tldhdli+kw4YKsJQgJOnt8E0yAQqd9Mx4RirlRB/JJ9gAlsseb23QPhAin32b6I3Tmd4we7mHnu7g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\n\t]]>\n\t<![CDATA[\n\tP7oxATIGaIxrLwBC/nJDgfrvV5PyL5oq8C/TM9PmWaZQFANpwKZF2hpthtLHFREtiuMyWq+/fO2O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\n\t]]>\n\t<![CDATA[\n\tfIOoHgXgZ0Q4JYOdCSZYgWUVfDZwm4B19v8l1RTs8aM6CZViOvNZbQU7cTQeodbTARRUuVKv2Fx5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\n\t]]>\n\t<![CDATA[\n\tiLVThVu3nFvToca2OJ5BZQoyVk04+lW110R5oWNHoeuJKSlVkctUMVWCXcjGr5rySf5ulKJgxcau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\n\t]]>\n\t<![CDATA[\n\tkS302ufUVKblZoCd9HpxFBvyi5K6SgTR9Qtn8MiPPtwEgsxhgr0h98ebp0AJlnxsgMyDsu37Q+Hs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\n\t]]>\n\t<![CDATA[\n\t4gdy5Lj6wcByr/NuFoYZd4lDU5Q+WTQE0tcR+DXRDcL7uEW1FbHSGFn25oZO5TXo/uAf9vh926mP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\n\t]]>\n\t<![CDATA[\n\tQ9TEKFV66FaMntHD4cUogx5izhglPQ8Lx+jBeSjlMSo0D59ARvnloSkyelYeziSjbPIQw8ko46YM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\n\t]]>\n\t<![CDATA[\n\tIgjZ8RorAyGqrzEgEPqBjeUAISPDxrlFRL3kG0CXLE/0sQnoDzDwMt76wQ+zoYofbDkbpuwDmKFN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\n\t]]>\n\t<![CDATA[\n\t4OXELeofLXxTbxmMOAx5kPA3glCgsGMX9Mm4wWeqzGc4EocUwQ95jupGBWGGwG9IKA6BH0i+7oCX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\n\t]]>\n\t<![CDATA[\n\tUb/1094yganEZCFKR9p7PifJO6WV9t40sr2mED5+THtTq8tjqmnvMPMTb8Be0HTzp705rFL3QGFB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\n\t]]>\n\t<![CDATA[\n\tNCVhEX4Bg3im9ewdtKta0WA1dq/VjU9l5GwFfdimwa0+rTvRWyUyJHoG1xQHC8e4HvuC46vJVaCc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\n\t]]>\n\t<![CDATA[\n\t3CMImDE/dkwi0E+Mx5aNjcKac5j0WCoP81Cio94qeEbsYXztWRb7VOv4IXEs6YEQVyUC41tsqaJw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\n\t]]>\n\t<![CDATA[\n\tkYD3T2Le3zGEk6kro7kMBnZ1k8WYTLt9gwGq2awfnLJSpvcbUQZ+Gz63fk3byjldODtpU9DOGYz7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\n\t]]>\n\t<![CDATA[\n\tJpLss4seBW0jSsBbp0vXbwLfes9hnS0EyfePMP3uIUg+W8dL13W8cjaReM8movT7SJaCNlLm4Cei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\n\t]]>\n\t<![CDATA[\n\tWfygFSv0IZYB1JmoU+A8KZd4RRebMIp+tuplusCihtkjyxmlkS5bzQKwqHluOumr7P6IcQnuYaJT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\n\t]]>\n\t<![CDATA[\n\tlMoRhlzSDWhM0lIlDDsCFYnfikakR6AiwQlFWwKPzfmrCernsES0Z2j9rEFkSaW5qJzOGFhH5QYy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\n\t]]>\n\t<![CDATA[\n\toNJVKihroMQ9b4c21+zB0aeF/wdRz1/TtlmYso7ldjYLU0ZjuS32xUNY6MCvGGTxr62toEw+rYEW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\n\t]]>\n\t<![CDATA[\n\tWAsIBWMWHGpO0FXgdF4L+IYETByBDxGf4Tc7MkLcwpUDHUs8LwMmGLNYRDRlDldQZayUEd6m4sLL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\n\t]]>\n\t<![CDATA[\n\tg3gOt+E2MlwmhsfU8BpOc+UxM7yGx/AZzvkNv+E6vOdqxCMwaHD9U9sSQmHIFWGco0PeGADYy/Dq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\n\t]]>\n\t<![CDATA[\n\tL76hwocrmy1DwEHZQWgpIW+xkspWNCa7ghaNXcrEISfXU504/FCnhUGKf37JkogR8I5Z29Ic+xWC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\n\t]]>\n\t<![CDATA[\n\ttYJ0yhu2nMpaTDjlqRKJNHxpNO9aMK4VIWJmb01rpOn3lT4HPdDiXs8hjKtzCOfmG65c1ucxTxYS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\n\t]]>\n\t<![CDATA[\n\tA6SxlJtIQP44gsFKQjqFvw8Inl3E8leRxzrU9lj2mTfWyEoAhUYBLGh3P7upsZcoHzlUvp4NrjSa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\n\t]]>\n\t<![CDATA[\n\tAcMDVwgUK1CEAP3RWDVxd9JgNIcrCNYpJ9s0jkUtopX8LMYmo5eQ6kVbXbjdshZDu89KRA4Kb2ou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\n\t]]>\n\t<![CDATA[\n\ty3Tu63pbmbTYUurzMVmpnr83fWprzRu7nk91zexjstb6k1JLJW3dX+fFZPWq+iB0tsk2G9Um22QZ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\n\t]]>\n\t<![CDATA[\n\tqhMIzm4Uu1EEwW4UQxA8zRAEH+/8+84NRFNxOQQPcCFHJijJ0+ZxqI1TwAxB8AuZIQjOEAQ9EE7c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\n\t]]>\n\t<![CDATA[\n\tzSInaOocdOy29/geziF1HHHM8lA145iYe81/O/AxFmiEW7h8GYycTlAH3WiBzDc00cu8Poyst7aU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\n\t]]>\n\t<![CDATA[\n\tsIMTADWFH8nD9A3mTxsA3WeSbCY1S8lwv39/j1P7GmwMrOkoyS0MrQQww/hNFo1sxdm1DPvWDEA4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\n\t]]>\n\t<![CDATA[\n\tRO1yQWK/IM6RUGKqF3XHPEnWGl1+og+7a0zJfKT4WYk+rFQmJlPLrUTHGW0eT62tIBUo4AQZJy8Q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\n\t]]>\n\t<![CDATA[\n\tcUBQpaJJh/2Q+Yrie8U+PJ10yoBmwSUQ8V2A2Ilaarl5BCZie9qhQFjOFwRrnFdsDSmmAADYAVRk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\n\t]]>\n\t<![CDATA[\n\tLjb2kgtPqw817O79GGjCOJpU/h/kqAekw3B1fwH2oQrXIM/KDMKTET/M6zpMO//UkF9rm7dTQeeM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\n\t]]>\n\t<![CDATA[\n\tRrkwS9Up+vcLRZMQrfQe/Iw/hSVQ79HzBYXfhPo3TEGiHk9cGl/4KtOw8ZlqwkZ8e6BwLRUyNrP5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\n\t]]>\n\t<![CDATA[\n\twPcJuGcTC7Dd6V9wLfY5P84Z/4btpD99gHbfy6oZgoR40JY6yXUl4eSy9hH/5kj/1ibn+FHSJRk8\ni/G7WKf+ZVQZVn80vZQI4fvfV0jWXti2o4SFLnBQsyISh1beizT+lb8EZvq3YhcZx6Qn8O/tqWh6\neR6FisC/ivlyCNS/VSp1lqAXjjfAtfuQGgyByigJ/oX/S1BDr8+kf8n6A+R0iZ0mU6d/L9vwIwP+\npRypPlK4ZGpfx18fhH9/lkUfVOLSNkYNV95QcQ1n3pVl3rItUgEM0emJYAqqaRMs6Y4xcmYNT7h8\nvNDqq8hTbPqbxwJePP0nqLw/nvz4hXA3gf3GiORvd8yN69NvyBTwWIkEJtAlNDtO3csVX1lFAybJ\nmGkCBT5dSRyGYLhKgauI9iD15vYazDtlDsbCSLOI4yYDQTPIzc8ULfmEeARv5a4mIDv3xvelXA7M\n5JPFO8WQfAxOT/EBpqRJQo0hXJuTba62SMFlFr8wo7dXWTP2vKgcBJ/wXPZcydvVYvfLsW8n2LDi\nOFcye9a3ZGGO6leacmsgND6dqxF74tEn303eg419tNVDEs+Cgb21V4aF3kKSR1ZvOEqLJt8or7TA\nMyNP/dH0wSi6gsy6xMBKbtJcJfSpW5gJvRePUyChzuS1M00E2rBeCqNVffbahWo4ZEelxxQ7Ykcg\nhi5h0fUrYByd/GaxqfKC9u6C78WbQyj0dZfEDOH9zduYbRpRitIxgmDB8xP2kp0nvE9EZKhL5LXc\nlLWTKLFb229zQEuoioO5uB5owLXDSAcMao4CJRlwr0XpH6WQQzkw1Ps5db2Zh2QXo7d5b0C92+eQ\nxTykKK2NoN6N55lf6m0ZmXT13DWdE9SrLmSpvsfGNTRDvcD24ykbzFfb0fKWek+uZEeGLN92kxxD\nkJ9OF1Evkx0kUK/eF7Iygq1qieTlWl7qEmDjydHrfF0f2HjsFJGN1/jr7JIx3oeobaUWbGSOaUj3\nBydwRfTi6YcjxHhqTxoi81zWh35CTf5a5oxaHL2PDX2qjtLyJcIZeUnk81KmDsJBj61whgB1SJ2E\ndVvJr7JMyzSi2yFsQVb/SgoW5IbLgIbo+gzIMiYH3BvsvbqjJiDdGhSDPF8G9PUAG3HLhDdWvLOM\nrztbCD0HimHifDdFjs2HLhcoFJtOaFPLeDau+JvcrXv5ViCFOJbcjuKAJpZFCPGXKg6rroqbMriC\nEXJU1ehE33Gdbm8RfsdSscH3qOorYC1MM+E4P4wjD+aEXE39LWYFrBfZAPCgunfRc6bd6LPZTnh7\nYIoqMujNn7cI3XpwTsR5Ic42CxL5JnUohIjXL4KakP0FvmVhD3gMAefnAjzeewhjc21p/9nGLG/c\nJktXb7ysZAE=\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z\"/><path d=\"M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z\"/></g></switch></svg>",
            "info": {},
            "path": "32/rule--data-quality.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RuleDataQuality32",
          "filepath": "rule--data-quality/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "rule--data-quality",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RuleDataQuality24",
          "filepath": "rule--data-quality/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "rule--data-quality",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RuleDataQuality20",
          "filepath": "rule--data-quality/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "rule--data-quality",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RuleDataQuality16",
          "filepath": "rule--data-quality/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z"
                        }
                      },
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "rule--data-quality",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "RuleDataQuality",
        "global": "RuleDataQuality",
        "filepath": "RuleDataQuality.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z"
                          },
                          "children": []
                        },
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rule--draft",
      "friendlyName": "Rule draft",
      "aliases": [
        "rule",
        "governance",
        "control",
        "policy",
        "draft",
        "security",
        "shield"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rule--draft.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"8\" y=\"16\" width=\"10\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n  <path d=\"M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z\"/><path d=\"M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z\"/></svg>",
            "info": {},
            "path": "32/rule--draft.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RuleDraft32",
          "filepath": "rule--draft/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--draft",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RuleDraft24",
          "filepath": "rule--draft/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--draft",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RuleDraft20",
          "filepath": "rule--draft/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--draft",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RuleDraft16",
          "filepath": "rule--draft/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--draft",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "RuleDraft",
        "global": "RuleDraft",
        "filepath": "RuleDraft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rule--filled",
      "friendlyName": "Rule filled",
      "aliases": [
        "rule",
        "governance",
        "control",
        "policy",
        "filled",
        "security",
        "shield"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rule--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect id=\"inner-path\" class=\"cls-1\" x=\"9\" y=\"16\" width=\"14\" height=\"2\"/>\n  <rect id=\"inner-path-2\" data-name=\"inner-path\" class=\"cls-1\" x=\"9\" y=\"10\" width=\"14\" height=\"2\"/>\n  <path d=\"M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M9 16H23V18H9z\" data-icon-path=\"inner-path\"/><path fill=\"none\" d=\"M9 10H23V12H9z\"/><path d=\"M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z\"/></svg>",
            "info": {},
            "path": "32/rule--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RuleFilled32",
          "filepath": "rule--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 16H23V18H9z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 10H23V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
                }
              }
            ],
            "name": "rule--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RuleFilled24",
          "filepath": "rule--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 16H23V18H9z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 10H23V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
                }
              }
            ],
            "name": "rule--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RuleFilled20",
          "filepath": "rule--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 16H23V18H9z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 10H23V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
                }
              }
            ],
            "name": "rule--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RuleFilled16",
          "filepath": "rule--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 16H23V18H9z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M9 10H23V12H9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
                }
              }
            ],
            "name": "rule--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "RuleFilled",
        "global": "RuleFilled",
        "filepath": "RuleFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M9 16H23V18H9z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M9 10H23V12H9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "rule--test",
      "friendlyName": "Rule test",
      "aliases": [
        "rule",
        "governance",
        "control",
        "policy",
        "test",
        "security",
        "shield"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/rule--test.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"26 24.586 24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586\"/>\n  <rect x=\"8\" y=\"16\" width=\"6\" height=\"2\"/>\n  <rect x=\"8\" y=\"10\" width=\"12\" height=\"2\"/>\n  <path d=\"M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z\"/><path d=\"M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z\"/><path d=\"M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z\"/></svg>",
            "info": {},
            "path": "32/rule--test.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RuleTest32",
          "filepath": "rule--test/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--test",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RuleTest24",
          "filepath": "rule--test/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--test",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RuleTest20",
          "filepath": "rule--test/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--test",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RuleTest16",
          "filepath": "rule--test/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                }
              }
            ],
            "name": "rule--test",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "RuleTest",
        "global": "RuleTest",
        "filepath": "RuleTest.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ruler",
      "friendlyName": "Ruler",
      "aliases": [
        "measure",
        "tool",
        "school",
        "office",
        "length",
        "scale"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ruler.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ruler</title><path d=\"M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z\"/></svg>",
            "info": {},
            "path": "32/ruler.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Ruler32",
          "filepath": "ruler/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
                }
              }
            ],
            "name": "ruler",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Ruler24",
          "filepath": "ruler/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
                }
              }
            ],
            "name": "ruler",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Ruler20",
          "filepath": "ruler/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
                }
              }
            ],
            "name": "ruler",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Ruler16",
          "filepath": "ruler/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
                }
              }
            ],
            "name": "ruler",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Ruler",
        "global": "Ruler",
        "filepath": "Ruler.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ruler--alt",
      "friendlyName": "Ruler alt",
      "aliases": [
        "measure",
        "tool",
        "school",
        "office",
        "length",
        "scale"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ruler--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ruler--alt</title><path d=\"M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z\"/></svg>",
            "info": {},
            "path": "32/ruler--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RulerAlt32",
          "filepath": "ruler--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
                }
              }
            ],
            "name": "ruler--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RulerAlt24",
          "filepath": "ruler--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
                }
              }
            ],
            "name": "ruler--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RulerAlt20",
          "filepath": "ruler--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
                }
              }
            ],
            "name": "ruler--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RulerAlt16",
          "filepath": "ruler--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
                }
              }
            ],
            "name": "ruler--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "RulerAlt",
        "global": "RulerAlt",
        "filepath": "RulerAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "run",
      "friendlyName": "Run",
      "aliases": [
        "start",
        "play",
        "program"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/run.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>run</title><path d=\"M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z\"/><polygon points=\"19 19 19 25 24 22 19 19\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z\"/><path d=\"M19 19L19 25 24 22 19 19z\"/></svg>",
            "info": {},
            "path": "32/run.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Run32",
          "filepath": "run/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 19L19 25 24 22 19 19z"
                }
              }
            ],
            "name": "run",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Run24",
          "filepath": "run/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 19L19 25 24 22 19 19z"
                }
              }
            ],
            "name": "run",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Run20",
          "filepath": "run/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 19L19 25 24 22 19 19z"
                }
              }
            ],
            "name": "run",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Run16",
          "filepath": "run/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 19L19 25 24 22 19 19z"
                }
              }
            ],
            "name": "run",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Run",
        "global": "Run",
        "filepath": "Run.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 19L19 25 24 22 19 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "run--mirror",
      "friendlyName": "run--mirror",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/run--mirror.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"9,19 9,25 14,22 \"/>\n<path d=\"M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14\n\tL11,14z\"/>\n<path d=\"M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9 19L9 25 14 22z\"/><path d=\"M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14\tL11,14z\"/><path d=\"M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z\"/></svg>",
            "info": {},
            "path": "32/run--mirror.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "RunMirror32",
          "filepath": "run--mirror/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 19L9 25 14 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14\tL11,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
                }
              }
            ],
            "name": "run--mirror",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "RunMirror24",
          "filepath": "run--mirror/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 19L9 25 14 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14\tL11,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
                }
              }
            ],
            "name": "run--mirror",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "RunMirror20",
          "filepath": "run--mirror/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 19L9 25 14 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14\tL11,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
                }
              }
            ],
            "name": "run--mirror",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "RunMirror16",
          "filepath": "run--mirror/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 19L9 25 14 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14\tL11,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
                }
              }
            ],
            "name": "run--mirror",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "RunMirror",
        "global": "RunMirror",
        "filepath": "RunMirror.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 19L9 25 14 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14 L11,14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "S",
      "friendlyName": "S",
      "aliases": [
        "standard",
        "letter",
        "alphabet",
        "alt"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/S.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--S</title><path d=\"M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z\"/></svg>",
            "info": {},
            "path": "32/Q/S.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QS32",
          "filepath": "Q/S/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "S",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QS24",
          "filepath": "Q/S/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "S",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QS20",
          "filepath": "Q/S/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "S",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QS16",
          "filepath": "Q/S/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                }
              }
            ],
            "name": "S",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "S",
        "global": "QS",
        "filepath": "Q/S.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "S--alt",
      "friendlyName": "S alt",
      "aliases": [
        "standard",
        "letter",
        "alphabet",
        "alt"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/S--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--S--alt</title><polygon points=\"24 9 22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9\"/><path d=\"M14,23H8V21h6V17H10a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H10v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,14,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z\"/></svg>",
            "info": {},
            "path": "32/Q/S--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QSAlt32",
          "filepath": "Q/S--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
                }
              }
            ],
            "name": "S--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QSAlt24",
          "filepath": "Q/S--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
                }
              }
            ],
            "name": "S--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QSAlt20",
          "filepath": "Q/S--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
                }
              }
            ],
            "name": "S--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QSAlt16",
          "filepath": "Q/S--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
                }
              }
            ],
            "name": "S--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "SAlt",
        "global": "QSAlt",
        "filepath": "Q/SAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sailboat--coastal",
      "friendlyName": "Sailboat coastal",
      "aliases": [
        "sailboat",
        "coastal",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sailboat--coastal.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z\"/></svg>",
            "info": {},
            "path": "32/sailboat--coastal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SailboatCoastal32",
          "filepath": "sailboat--coastal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
                }
              }
            ],
            "name": "sailboat--coastal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SailboatCoastal24",
          "filepath": "sailboat--coastal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
                }
              }
            ],
            "name": "sailboat--coastal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SailboatCoastal20",
          "filepath": "sailboat--coastal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
                }
              }
            ],
            "name": "sailboat--coastal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SailboatCoastal16",
          "filepath": "sailboat--coastal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
                }
              }
            ],
            "name": "sailboat--coastal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SailboatCoastal",
        "global": "SailboatCoastal",
        "filepath": "SailboatCoastal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sailboat--offshore",
      "friendlyName": "Sailboat offshore",
      "aliases": [
        "sailboat",
        "offshore",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sailboat--offshore.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z\"/><path d=\"M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z\"/></svg>",
            "info": {},
            "path": "32/sailboat--offshore.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SailboatOffshore32",
          "filepath": "sailboat--offshore/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              }
            ],
            "name": "sailboat--offshore",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SailboatOffshore24",
          "filepath": "sailboat--offshore/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              }
            ],
            "name": "sailboat--offshore",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SailboatOffshore20",
          "filepath": "sailboat--offshore/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              }
            ],
            "name": "sailboat--offshore",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SailboatOffshore16",
          "filepath": "sailboat--offshore/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                }
              }
            ],
            "name": "sailboat--offshore",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SailboatOffshore",
        "global": "SailboatOffshore",
        "filepath": "SailboatOffshore.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sankey-diagram",
      "friendlyName": "Sankey diagram",
      "aliases": [
        "Sankey diagram",
        "data",
        "Sankey"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sankey-diagram.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z\"/></svg>",
            "info": {},
            "path": "32/sankey-diagram.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SankeyDiagram32",
          "filepath": "sankey-diagram/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
                }
              }
            ],
            "name": "sankey-diagram",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SankeyDiagram24",
          "filepath": "sankey-diagram/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
                }
              }
            ],
            "name": "sankey-diagram",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SankeyDiagram20",
          "filepath": "sankey-diagram/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
                }
              }
            ],
            "name": "sankey-diagram",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SankeyDiagram16",
          "filepath": "sankey-diagram/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
                }
              }
            ],
            "name": "sankey-diagram",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SankeyDiagram",
        "global": "SankeyDiagram",
        "filepath": "SankeyDiagram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sankey-diagram--alt",
      "friendlyName": "Sankey diagram alt",
      "aliases": [
        "Sankey diagram alt",
        "data",
        "Sankey alt"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sankey-diagram--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z\"/></svg>",
            "info": {},
            "path": "32/sankey-diagram--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SankeyDiagramAlt32",
          "filepath": "sankey-diagram--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
                }
              }
            ],
            "name": "sankey-diagram--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SankeyDiagramAlt24",
          "filepath": "sankey-diagram--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
                }
              }
            ],
            "name": "sankey-diagram--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SankeyDiagramAlt20",
          "filepath": "sankey-diagram--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
                }
              }
            ],
            "name": "sankey-diagram--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SankeyDiagramAlt16",
          "filepath": "sankey-diagram--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
                }
              }
            ],
            "name": "sankey-diagram--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SankeyDiagramAlt",
        "global": "SankeyDiagramAlt",
        "filepath": "SankeyDiagramAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "satellite",
      "friendlyName": "Satellite",
      "aliases": [
        "satellite",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/satellite.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z\"/></svg>",
            "info": {},
            "path": "32/satellite.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Satellite32",
          "filepath": "satellite/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
                }
              }
            ],
            "name": "satellite",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Satellite24",
          "filepath": "satellite/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
                }
              }
            ],
            "name": "satellite",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Satellite20",
          "filepath": "satellite/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
                }
              }
            ],
            "name": "satellite",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Satellite16",
          "filepath": "satellite/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
                }
              }
            ],
            "name": "satellite",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Satellite",
        "global": "Satellite",
        "filepath": "Satellite.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "satellite--radar",
      "friendlyName": "Satellite radar",
      "aliases": [
        "satellite",
        "radar",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/satellite--radar.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,14H24a6.0067,6.0067,0,0,0-6-6V6A8.0092,8.0092,0,0,1,26,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,28V24.96a9.9124,9.9124,0,0,0,7.3179-2.208,1.8482,1.8482,0,0,0,.6777-1.3344,1.8,1.8,0,0,0-.5239-1.36L18.4141,15,21,12.4141,19.5859,11,17,13.5859,11.9419,8.5273a1.8145,1.8145,0,0,0-1.36-.5229,1.845,1.845,0,0,0-1.3339.6782,9.9566,9.9566,0,0,0-.5127,11.95L6.2793,28H2v2H30V28ZM10.68,10.0938,21.9058,21.32A8.0011,8.0011,0,0,1,10.68,10.0938ZM14,28H8.3875l1.8757-5.627A9.9894,9.9894,0,0,0,14,24.5435Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z\"/><path d=\"M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z\"/></svg>",
            "info": {},
            "path": "32/satellite--radar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SatelliteRadar32",
          "filepath": "satellite--radar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z"
                }
              }
            ],
            "name": "satellite--radar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SatelliteRadar24",
          "filepath": "satellite--radar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z"
                }
              }
            ],
            "name": "satellite--radar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SatelliteRadar20",
          "filepath": "satellite--radar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z"
                }
              }
            ],
            "name": "satellite--radar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SatelliteRadar16",
          "filepath": "satellite--radar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z"
                }
              }
            ],
            "name": "satellite--radar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SatelliteRadar",
        "global": "SatelliteRadar",
        "filepath": "SatelliteRadar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "satellite--weather",
      "friendlyName": "Satellite weather",
      "aliases": [
        "satellite",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/satellite--weather.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26.5,12H19a4,4,0,0,1,0-8h.0835A4.7864,4.7864,0,0,1,23,2a4.9816,4.9816,0,0,1,4.6543,3.2034A3.4667,3.4667,0,0,1,30,8.5,3.5041,3.5041,0,0,1,26.5,12ZM19,6a2,2,0,0,0,0,4h7.5A1.5017,1.5017,0,0,0,28,8.5a1.4855,1.4855,0,0,0-1.2778-1.4739L26.061,6.927l-.1616-.6487a2.9568,2.9568,0,0,0-5.4873-.7121L20.1143,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M13,28V24.8882a7.9363,7.9363,0,0,0,4.707-2.2818.9995.9995,0,0,0,0-1.414L13.4644,16.95,16,14.4141,14.5859,13,12.05,15.5356,7.8076,11.293a.9994.9994,0,0,0-1.414,0,7.9993,7.9993,0,0,0,0,11.3134c.1621.1622.3327.3125.5058.459L4.4321,28H2v2H30V28Zm-2,0H6.6685L8.59,24.1567A7.8927,7.8927,0,0,0,11,24.873ZM7.8076,21.1924a6.0036,6.0036,0,0,1-.6489-7.72l8.3686,8.3681a6.0026,6.0026,0,0,1-7.72-.6484Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z\"/></svg>",
            "info": {},
            "path": "32/satellite--weather.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SatelliteWeather32",
          "filepath": "satellite--weather/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z"
                }
              }
            ],
            "name": "satellite--weather",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SatelliteWeather24",
          "filepath": "satellite--weather/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z"
                }
              }
            ],
            "name": "satellite--weather",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SatelliteWeather20",
          "filepath": "satellite--weather/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z"
                }
              }
            ],
            "name": "satellite--weather",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SatelliteWeather16",
          "filepath": "satellite--weather/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z"
                }
              }
            ],
            "name": "satellite--weather",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SatelliteWeather",
        "global": "SatelliteWeather",
        "filepath": "SatelliteWeather.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "save",
      "friendlyName": "Save",
      "aliases": [
        "floppy",
        "floppy disk",
        "progress",
        "safe",
        "memory",
        "intact",
        "preserve"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/save.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>save</title>\n<path d=\"M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5\n\tC14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1\n\th4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5\tC14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1\th4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z\"/></svg>",
            "info": {},
            "path": "16/save.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/save.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<path d=\"M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1\n\tC18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3\n\tc0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4\n\tL14,16.7L14,16.7z\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1\tC18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3\tc0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4\tL14,16.7L14,16.7z\"/></svg>",
            "info": {},
            "path": "20/save.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/save.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<path d=\"M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12\n\tC21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6\n\th-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12\tC21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6\th-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z\"/></svg>",
            "info": {},
            "path": "24/save.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/save.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>save</title><path d=\"M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z\"/></svg>",
            "info": {},
            "path": "32/save.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Save32",
          "filepath": "save/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"
                }
              }
            ],
            "name": "save",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Save24",
          "filepath": "save/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12\tC21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6\th-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"
                }
              }
            ],
            "name": "save",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Save20",
          "filepath": "save/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1\tC18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3\tc0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4\tL14,16.7L14,16.7z"
                }
              }
            ],
            "name": "save",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Save16",
          "filepath": "save/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5\tC14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1\th4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"
                }
              }
            ],
            "name": "save",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Save",
        "global": "Save",
        "filepath": "Save.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5 C14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1 h4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1 C18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3 c0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4 L14,16.7L14,16.7z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12 C21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6 h-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "save--annotation",
      "friendlyName": "Save annotation",
      "aliases": [
        "floppy",
        "floppy disk",
        "progress",
        "safe",
        "memory",
        "intact",
        "preserve"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/save--annotation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--save--annotation</title><path d=\"M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z\"/><path d=\"M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z\"/><rect x=\"20\" y=\"6\" width=\"6\" height=\"2\"/><rect x=\"22\" y=\"10\" width=\"4\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z\"/><path d=\"M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z\"/><path d=\"M20 6H26V8H20zM22 10H26V12H22z\"/></svg>",
            "info": {},
            "path": "32/watson-health/save--annotation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSaveAnnotation32",
          "filepath": "watson-health/save--annotation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H26V8H20zM22 10H26V12H22z"
                }
              }
            ],
            "name": "save--annotation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSaveAnnotation24",
          "filepath": "watson-health/save--annotation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H26V8H20zM22 10H26V12H22z"
                }
              }
            ],
            "name": "save--annotation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSaveAnnotation20",
          "filepath": "watson-health/save--annotation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H26V8H20zM22 10H26V12H22z"
                }
              }
            ],
            "name": "save--annotation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSaveAnnotation16",
          "filepath": "watson-health/save--annotation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H26V8H20zM22 10H26V12H22z"
                }
              }
            ],
            "name": "save--annotation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "SaveAnnotation",
        "global": "WatsonHealthSaveAnnotation",
        "filepath": "watson-health/SaveAnnotation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 6H26V8H20zM22 10H26V12H22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "save--image",
      "friendlyName": "Save image",
      "aliases": [
        "floppy",
        "floppy disk",
        "progress",
        "safe",
        "memory",
        "intact",
        "preserve"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/save--image.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--save--image</title><path d=\"M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z\"/><path d=\"M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z\"/><path d=\"M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/save--image.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSaveImage32",
          "filepath": "watson-health/save--image/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              }
            ],
            "name": "save--image",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSaveImage24",
          "filepath": "watson-health/save--image/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              }
            ],
            "name": "save--image",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSaveImage20",
          "filepath": "watson-health/save--image/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              }
            ],
            "name": "save--image",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSaveImage16",
          "filepath": "watson-health/save--image/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                }
              }
            ],
            "name": "save--image",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "SaveImage",
        "global": "WatsonHealthSaveImage",
        "filepath": "watson-health/SaveImage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "save--model",
      "friendlyName": "Save model",
      "aliases": [
        "save",
        "model",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/save--model.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>save--model</title><path d=\"M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z\"/><path d=\"M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z\"/><path d=\"M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z\"/></svg>",
            "info": {},
            "path": "32/save--model.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SaveModel32",
          "filepath": "save--model/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
                }
              }
            ],
            "name": "save--model",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SaveModel24",
          "filepath": "save--model/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
                }
              }
            ],
            "name": "save--model",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SaveModel20",
          "filepath": "save--model/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
                }
              }
            ],
            "name": "save--model",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SaveModel16",
          "filepath": "save--model/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
                }
              }
            ],
            "name": "save--model",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SaveModel",
        "global": "SaveModel",
        "filepath": "SaveModel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "save--series",
      "friendlyName": "Save series",
      "aliases": [
        "floppy",
        "floppy disk",
        "progress",
        "safe",
        "memory",
        "intact",
        "preserve"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/save--series.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--save--series</title><path d=\"M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z\"/><path d=\"M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z\"/><path d=\"M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z\"/><path d=\"M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z\"/><path d=\"M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/save--series.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSaveSeries32",
          "filepath": "watson-health/save--series/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "save--series",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSaveSeries24",
          "filepath": "watson-health/save--series/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "save--series",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSaveSeries20",
          "filepath": "watson-health/save--series/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "save--series",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSaveSeries16",
          "filepath": "watson-health/save--series/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "save--series",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "SaveSeries",
        "global": "WatsonHealthSaveSeries",
        "filepath": "watson-health/SaveSeries.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scale",
      "friendlyName": "Scale",
      "aliases": [
        "scalable",
        "ratio",
        "proportion",
        "scope",
        "spectrum",
        "resize",
        "design",
        "square",
        "tool"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scale.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scale</title><path d=\"M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z\"/><path d=\"M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z\"/><path d=\"M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21\"/></svg>",
            "info": {},
            "path": "32/scale.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Scale32",
          "filepath": "scale/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
                }
              }
            ],
            "name": "scale",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Scale24",
          "filepath": "scale/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
                }
              }
            ],
            "name": "scale",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Scale20",
          "filepath": "scale/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
                }
              }
            ],
            "name": "scale",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Scale16",
          "filepath": "scale/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
                }
              }
            ],
            "name": "scale",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Scale",
        "global": "Scale",
        "filepath": "Scale.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scales",
      "friendlyName": "Scales",
      "aliases": [
        "instruments",
        "scales",
        "balance",
        "justice"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scales.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z\"/></svg>",
            "info": {},
            "path": "32/scales.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Scales32",
          "filepath": "scales/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
                }
              }
            ],
            "name": "scales",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Scales24",
          "filepath": "scales/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
                }
              }
            ],
            "name": "scales",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Scales20",
          "filepath": "scales/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
                }
              }
            ],
            "name": "scales",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Scales16",
          "filepath": "scales/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
                }
              }
            ],
            "name": "scales",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Scales",
        "global": "Scales",
        "filepath": "Scales.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scales--tipped",
      "friendlyName": "Scales tipped",
      "aliases": [
        "scales",
        "tipped",
        "instruments",
        "unequal"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scales--tipped.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z\"/></svg>",
            "info": {},
            "path": "32/scales--tipped.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScalesTipped32",
          "filepath": "scales--tipped/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
                }
              }
            ],
            "name": "scales--tipped",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScalesTipped24",
          "filepath": "scales--tipped/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
                }
              }
            ],
            "name": "scales--tipped",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScalesTipped20",
          "filepath": "scales--tipped/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
                }
              }
            ],
            "name": "scales--tipped",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScalesTipped16",
          "filepath": "scales--tipped/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
                }
              }
            ],
            "name": "scales--tipped",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "ScalesTipped",
        "global": "ScalesTipped",
        "filepath": "ScalesTipped.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scalpel",
      "friendlyName": "Scalpel",
      "aliases": [
        "blade",
        "cutter",
        "knife",
        "cut",
        "tool",
        "surgery",
        "sharp",
        "health",
        "hospital",
        "medical"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scalpel.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scalpel</title><path d=\"M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z\"/></svg>",
            "info": {},
            "path": "32/scalpel.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Scalpel32",
          "filepath": "scalpel/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "scalpel",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Scalpel24",
          "filepath": "scalpel/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "scalpel",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Scalpel20",
          "filepath": "scalpel/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "scalpel",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Scalpel16",
          "filepath": "scalpel/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
                }
              }
            ],
            "name": "scalpel",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Scalpel",
        "global": "Scalpel",
        "filepath": "Scalpel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scalpel--cursor",
      "friendlyName": "Scalpel cursor",
      "aliases": [
        "blade",
        "cutter",
        "knife",
        "cut",
        "tool",
        "surgery",
        "sharp",
        "health",
        "hospital",
        "medical"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/scalpel--cursor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scalpel--cursor</title><path d=\"M28.8281,7.1338a4.0941,4.0941,0,0,0-5.6562,0L.3433,29.9619H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.79a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8406l2.086-2.0858,2.8293,2.8293L15.1224,23.67ZM11.71,27.083a2.9824,2.9824,0,0,1-2.1215.8789H5.1714l5.7073-5.7072,2.83,2.83ZM27.4141,11.376,18.6221,20.17l-2.8293-2.8292,8.7931-8.7928a2.0471,2.0471,0,0,1,2.8282,0,1.9993,1.9993,0,0,1,0,2.8281Z\"/><polygon points=\"13 4 4 4 4 13 6 13 6 6 13 6 13 4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z\"/></svg>",
            "info": {},
            "path": "32/watson-health/scalpel--cursor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthScalpelCursor32",
          "filepath": "watson-health/scalpel--cursor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
                }
              }
            ],
            "name": "scalpel--cursor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthScalpelCursor24",
          "filepath": "watson-health/scalpel--cursor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
                }
              }
            ],
            "name": "scalpel--cursor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthScalpelCursor20",
          "filepath": "watson-health/scalpel--cursor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
                }
              }
            ],
            "name": "scalpel--cursor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthScalpelCursor16",
          "filepath": "watson-health/scalpel--cursor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
                }
              }
            ],
            "name": "scalpel--cursor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ScalpelCursor",
        "global": "WatsonHealthScalpelCursor",
        "filepath": "watson-health/ScalpelCursor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scalpel--lasso",
      "friendlyName": "Scalpel lasso",
      "aliases": [
        "blade",
        "cutter",
        "knife",
        "cut",
        "tool",
        "surgery",
        "sharp",
        "health",
        "hospital",
        "medical"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/scalpel--lasso.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scalpel--lasso</title><path d=\"M28.8281,7.1338a4.0941,4.0941,0,0,0-5.6562,0L.3433,29.9619H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.79a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8406l2.086-2.0858,2.8293,2.8293L15.1224,23.67ZM11.71,27.083a2.9824,2.9824,0,0,1-2.1215.8789H5.1714l5.7073-5.7072,2.83,2.83ZM27.4141,11.376,18.6221,20.17l-2.8293-2.8292,8.7931-8.7928a2.0471,2.0471,0,0,1,2.8282,0,1.9993,1.9993,0,0,1,0,2.8281Z\"/><path d=\"M11,2H7a4.9843,4.9843,0,0,0-3.8633,8.1528A2.9586,2.9586,0,0,0,3,11a2.9945,2.9945,0,0,0,2,2.8154V14a2.0025,2.0025,0,0,1-2,2H2v2H3a4.0045,4.0045,0,0,0,4-4v-.1841A2.9959,2.9959,0,0,0,8.8157,12H11A5,5,0,0,0,11,2ZM6,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,12Zm5-2H8.8157A2.974,2.974,0,0,0,4.394,8.4746,2.9908,2.9908,0,0,1,7,4h4a3,3,0,0,1,0,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z\"/></svg>",
            "info": {},
            "path": "32/watson-health/scalpel--lasso.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthScalpelLasso32",
          "filepath": "watson-health/scalpel--lasso/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
                }
              }
            ],
            "name": "scalpel--lasso",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthScalpelLasso24",
          "filepath": "watson-health/scalpel--lasso/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
                }
              }
            ],
            "name": "scalpel--lasso",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthScalpelLasso20",
          "filepath": "watson-health/scalpel--lasso/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
                }
              }
            ],
            "name": "scalpel--lasso",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthScalpelLasso16",
          "filepath": "watson-health/scalpel--lasso/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
                }
              }
            ],
            "name": "scalpel--lasso",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ScalpelLasso",
        "global": "WatsonHealthScalpelLasso",
        "filepath": "watson-health/ScalpelLasso.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scalpel--select",
      "friendlyName": "Scalpel select",
      "aliases": [
        "blade",
        "cutter",
        "knife",
        "cut",
        "tool",
        "surgery",
        "sharp",
        "health",
        "hospital",
        "medical"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/scalpel--select.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scalpel--select</title><path d=\"M28.8281,7.1719a4.0941,4.0941,0,0,0-5.6562,0L.3433,30H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.8281a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8787l2.086-2.0859,2.8293,2.8294-2.0857,2.0862ZM11.71,27.1211A2.9824,2.9824,0,0,1,9.5889,28H5.1714l5.7073-5.7072,2.83,2.83Zm15.7037-15.707-8.792,8.7939-2.8293-2.8292,8.7931-8.7929a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z\"/><path d=\"M15,2a2.9948,2.9948,0,0,0-2.8157,2H7.8156A2.9925,2.9925,0,1,0,4,7.8154v4.3687a3,3,0,1,0,2,0V7.8159A2.9959,2.9959,0,0,0,7.8156,6h4.3686A2.9947,2.9947,0,1,0,15,2ZM5,16a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,5,16ZM5,6A1,1,0,1,1,6,5,1.0008,1.0008,0,0,1,5,6ZM15,6a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,15,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z\"/></svg>",
            "info": {},
            "path": "32/watson-health/scalpel--select.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthScalpelSelect32",
          "filepath": "watson-health/scalpel--select/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
                }
              }
            ],
            "name": "scalpel--select",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthScalpelSelect24",
          "filepath": "watson-health/scalpel--select/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
                }
              }
            ],
            "name": "scalpel--select",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthScalpelSelect20",
          "filepath": "watson-health/scalpel--select/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
                }
              }
            ],
            "name": "scalpel--select",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthScalpelSelect16",
          "filepath": "watson-health/scalpel--select/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
                }
              }
            ],
            "name": "scalpel--select",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ScalpelSelect",
        "global": "WatsonHealthScalpelSelect",
        "filepath": "watson-health/ScalpelSelect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scan",
      "friendlyName": "Scan",
      "aliases": [
        "scanner",
        "code",
        "barcode",
        "detect",
        "examine",
        "check",
        "qr"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scan.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scan</title><path d=\"M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z\" transform=\"translate(0 0)\"/><rect x=\"15\" y=\"9\" width=\"2\" height=\"14\"/><rect x=\"27\" y=\"9\" width=\"2\" height=\"14\"/><rect x=\"21\" y=\"9\" width=\"2\" height=\"14\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z\"/><path d=\"M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z\"/></svg>",
            "info": {},
            "path": "32/scan.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Scan32",
          "filepath": "scan/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
                }
              }
            ],
            "name": "scan",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Scan24",
          "filepath": "scan/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
                }
              }
            ],
            "name": "scan",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Scan20",
          "filepath": "scan/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
                }
              }
            ],
            "name": "scan",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Scan16",
          "filepath": "scan/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
                }
              }
            ],
            "name": "scan",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Scan",
        "global": "Scan",
        "filepath": "Scan.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scan--alt",
      "friendlyName": "Scan alt",
      "aliases": [
        "scan",
        "alternate",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scan--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,24H10a2,2,0,0,1-2-2V19h2v3H22V19h2v3A2,2,0,0,1,22,24Z\" transform=\"translate(0 -0.0001)\"/>\n  <rect x=\"2\" y=\"14.9999\" width=\"28\" height=\"2\"/>\n  <path d=\"M24,13H22V10H10v3H8V10a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2Z\" transform=\"translate(0 -0.0001)\"/>\n  <polygon points=\"30 10 28 10 28 4 22 4 22 2 30 2 30 10\"/>\n  <polygon points=\"4 10 2 10 2 2 10 2 10 4 4 4 4 10\"/>\n  <polygon points=\"10 30 2 30 2 22 4 22 4 28 10 28 10 30\"/>\n  <polygon points=\"30 30 22 30 22 28 28 28 28 22 30 22 30 30\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z\"/></svg>",
            "info": {},
            "path": "32/scan--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScanAlt32",
          "filepath": "scan--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
                }
              }
            ],
            "name": "scan--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScanAlt24",
          "filepath": "scan--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
                }
              }
            ],
            "name": "scan--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScanAlt20",
          "filepath": "scan--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
                }
              }
            ],
            "name": "scan--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScanAlt16",
          "filepath": "scan--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
                }
              }
            ],
            "name": "scan--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ScanAlt",
        "global": "ScanAlt",
        "filepath": "ScanAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scan--disabled",
      "friendlyName": "Scan disabled",
      "aliases": [
        "scan",
        "disabled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scan--disabled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.3826,2.0762a.9993.9993,0,0,0-1.09.2168l-26,26A1,1,0,0,0,3,30h8V28H5.4143l4-4H22a2.0021,2.0021,0,0,0,2-2V9.4146l4-4V11h2V3A1,1,0,0,0,29.3826,2.0762ZM22,22H11.4143L22,11.4146Z\"/>\n  <path d=\"M10,17.7554V10h7.7554l2-2H10a2.0025,2.0025,0,0,0-2,2v9.7554Z\"/>\n  <polygon points=\"11 2 2 2 2 11 4 11 4 4 11 4 11 2\"/>\n  <polygon points=\"21 30 30 30 30 21 28 21 28 28 21 28 21 30\"/>\n  <polygon points=\"4 23.755 4 21 2 21 2 25.754 4 23.755\"/>\n  <polygon points=\"25.755 2 21 2 21 4 23.755 4 25.755 2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z\"/></svg>",
            "info": {},
            "path": "32/scan--disabled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScanDisabled32",
          "filepath": "scan--disabled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z"
                }
              }
            ],
            "name": "scan--disabled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScanDisabled24",
          "filepath": "scan--disabled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z"
                }
              }
            ],
            "name": "scan--disabled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScanDisabled20",
          "filepath": "scan--disabled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z"
                }
              }
            ],
            "name": "scan--disabled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScanDisabled16",
          "filepath": "scan--disabled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z"
                }
              }
            ],
            "name": "scan--disabled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ScanDisabled",
        "global": "ScanDisabled",
        "filepath": "ScanDisabled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scatter-matrix",
      "friendlyName": "Scatter matrix",
      "aliases": [
        "chart",
        "data",
        "data analytics",
        "plot"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scatter-matrix.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>scatter-matrix</title>\n  <circle cx=\"9.5\" cy=\"9.5\" r=\"2.5\"/>\n  <circle cx=\"9.5\" cy=\"22.5\" r=\"2.5\"/>\n  <circle cx=\"22.5\" cy=\"22.5\" r=\"2.5\"/>\n  <path d=\"M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"9.5\" cy=\"9.5\" r=\"2.5\"/><circle cx=\"9.5\" cy=\"22.5\" r=\"2.5\"/><circle cx=\"22.5\" cy=\"22.5\" r=\"2.5\"/><path d=\"M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z\"/></svg>",
            "info": {},
            "path": "32/scatter-matrix.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScatterMatrix32",
          "filepath": "scatter-matrix/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "9.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
                }
              }
            ],
            "name": "scatter-matrix",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScatterMatrix24",
          "filepath": "scatter-matrix/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "9.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
                }
              }
            ],
            "name": "scatter-matrix",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScatterMatrix20",
          "filepath": "scatter-matrix/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "9.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
                }
              }
            ],
            "name": "scatter-matrix",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScatterMatrix16",
          "filepath": "scatter-matrix/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "9.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22.5",
                  "cy": "22.5",
                  "r": "2.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
                }
              }
            ],
            "name": "scatter-matrix",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ScatterMatrix",
        "global": "ScatterMatrix",
        "filepath": "ScatterMatrix.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9.5",
                    "cy": "9.5",
                    "r": "2.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9.5",
                    "cy": "22.5",
                    "r": "2.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22.5",
                    "cy": "22.5",
                    "r": "2.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "schematics",
      "friendlyName": "Schematics",
      "aliases": [
        "schematics",
        "flow",
        "process"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/schematics.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>schematics</title><path d=\"M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z\"/></svg>",
            "info": {},
            "path": "32/schematics.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Schematics32",
          "filepath": "schematics/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
                }
              }
            ],
            "name": "schematics",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Schematics24",
          "filepath": "schematics/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
                }
              }
            ],
            "name": "schematics",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Schematics20",
          "filepath": "schematics/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
                }
              }
            ],
            "name": "schematics",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Schematics16",
          "filepath": "schematics/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
                }
              }
            ],
            "name": "schematics",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Schematics",
        "global": "Schematics",
        "filepath": "Schematics.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scis--control-tower",
      "friendlyName": "IBM® Supply Chain Intelligence Suite Control Tower",
      "aliases": [
        "IBM",
        "supply chain intelligence suite",
        "control tower",
        "blockchain",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scis--control-tower.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2\n\tC5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3\n\tc-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6\n\tc0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1\n\ts0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1\n\ts1,0.4,1,1S27.6,23,27,23z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2\tC5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3\tc-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6\tc0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1\ts0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,23,27,23z\"/></svg>",
            "info": {},
            "path": "32/scis--control-tower.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScisControlTower32",
          "filepath": "scis--control-tower/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2\tC5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3\tc-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6\tc0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1\ts0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,23,27,23z"
                }
              }
            ],
            "name": "scis--control-tower",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScisControlTower24",
          "filepath": "scis--control-tower/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2\tC5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3\tc-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6\tc0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1\ts0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,23,27,23z"
                }
              }
            ],
            "name": "scis--control-tower",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScisControlTower20",
          "filepath": "scis--control-tower/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2\tC5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3\tc-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6\tc0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1\ts0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,23,27,23z"
                }
              }
            ],
            "name": "scis--control-tower",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScisControlTower16",
          "filepath": "scis--control-tower/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2\tC5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3\tc-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6\tc0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1\ts0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,23,27,23z"
                }
              }
            ],
            "name": "scis--control-tower",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "ScisControlTower",
        "global": "ScisControlTower",
        "filepath": "ScisControlTower.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2 C5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3 c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6 c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1 s0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,23,27,23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scis--transparent-supply",
      "friendlyName": "IBM® Supply Chain Intelligence Suite transparent supply",
      "aliases": [
        "IBM",
        "supply chain intelligence suite",
        "transparent supply",
        "blockchain",
        "app"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scis--transparent-supply.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z\"/>\n  <path d=\"M21,22H19V19H13v3H11V19a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z\"/>\n  <path d=\"M16,16a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,16Zm0-4a1,1,0,1,0,1,1A1.0013,1.0013,0,0,0,16,12Z\"/>\n  <path d=\"M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z\"/><path d=\"M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z\"/><path d=\"M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z\"/></svg>",
            "info": {},
            "path": "32/scis--transparent-supply.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScisTransparentSupply32",
          "filepath": "scis--transparent-supply/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
                }
              }
            ],
            "name": "scis--transparent-supply",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScisTransparentSupply24",
          "filepath": "scis--transparent-supply/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
                }
              }
            ],
            "name": "scis--transparent-supply",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScisTransparentSupply20",
          "filepath": "scis--transparent-supply/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
                }
              }
            ],
            "name": "scis--transparent-supply",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScisTransparentSupply16",
          "filepath": "scis--transparent-supply/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
                }
              }
            ],
            "name": "scis--transparent-supply",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "ScisTransparentSupply",
        "global": "ScisTransparentSupply",
        "filepath": "ScisTransparentSupply.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scooter",
      "friendlyName": "Scooter",
      "aliases": [
        "scooter",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scooter.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scooter</title><path d=\"M26,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,26,28Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,26,22Z\"/><path d=\"M24,8H18v2h6a1,1,0,0,1,0,2H21a1,1,0,0,0-.98,1.1963l.9241,4.6211L18.4338,22h-2.69l-2.5723-8.5752A1.988,1.988,0,0,0,11.2559,12H6v2h5.2561l.6,2H7a5.0057,5.0057,0,0,0-5,5v2a1,1,0,0,0,1,1H4a4,4,0,0,0,8,0h7a1,1,0,0,0,.8574-.4854l3-5a1,1,0,0,0,.1231-.7109L22.22,14H24a3,3,0,0,0,0-6ZM8,26a2.0025,2.0025,0,0,1-2-2h4A2.0025,2.0025,0,0,1,8,26ZM4,22V21a3.0033,3.0033,0,0,1,3-3h5.4561l1.2,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z\"/></svg>",
            "info": {},
            "path": "32/scooter.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Scooter32",
          "filepath": "scooter/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
                }
              }
            ],
            "name": "scooter",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Scooter24",
          "filepath": "scooter/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
                }
              }
            ],
            "name": "scooter",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Scooter20",
          "filepath": "scooter/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
                }
              }
            ],
            "name": "scooter",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Scooter16",
          "filepath": "scooter/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
                }
              }
            ],
            "name": "scooter",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Scooter",
        "global": "Scooter",
        "filepath": "Scooter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "scooter--front",
      "friendlyName": "Scooter front",
      "aliases": [
        "scooter",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/scooter--front.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>scooter--front</title><rect x=\"15\" y=\"19\" width=\"2\" height=\"9\"/><path d=\"M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 19H17V28H15z\"/><path d=\"M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z\"/></svg>",
            "info": {},
            "path": "32/scooter--front.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScooterFront32",
          "filepath": "scooter--front/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V28H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
                }
              }
            ],
            "name": "scooter--front",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScooterFront24",
          "filepath": "scooter--front/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V28H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
                }
              }
            ],
            "name": "scooter--front",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScooterFront20",
          "filepath": "scooter--front/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V28H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
                }
              }
            ],
            "name": "scooter--front",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScooterFront16",
          "filepath": "scooter--front/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 19H17V28H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
                }
              }
            ],
            "name": "scooter--front",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "ScooterFront",
        "global": "ScooterFront",
        "filepath": "ScooterFront.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 19H17V28H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "screen",
      "friendlyName": "Screen",
      "aliases": [
        "computer",
        "display",
        "monitor",
        "desktop",
        "device",
        "technology",
        "pc",
        "mac"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/screen.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>desktop</title><path d=\"M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z\"/></svg>",
            "info": {},
            "path": "32/screen.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Screen32",
          "filepath": "screen/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
                }
              }
            ],
            "name": "screen",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Screen24",
          "filepath": "screen/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
                }
              }
            ],
            "name": "screen",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Screen20",
          "filepath": "screen/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
                }
              }
            ],
            "name": "screen",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Screen16",
          "filepath": "screen/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
                }
              }
            ],
            "name": "screen",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Screen",
        "global": "Screen",
        "filepath": "Screen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "screen--off",
      "friendlyName": "Screen off",
      "aliases": [
        "computer",
        "display",
        "monitor",
        "desktop",
        "device",
        "technology",
        "pc",
        "mac"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/screen--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>screen--off</title><path d=\"M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z\"/></svg>",
            "info": {},
            "path": "32/screen--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScreenOff32",
          "filepath": "screen--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "screen--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScreenOff24",
          "filepath": "screen--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "screen--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScreenOff20",
          "filepath": "screen--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "screen--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScreenOff16",
          "filepath": "screen--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
                }
              }
            ],
            "name": "screen--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ScreenOff",
        "global": "ScreenOff",
        "filepath": "ScreenOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "screen-map",
      "friendlyName": "screen-map",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/screen-map.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"22\" y=\"25\" width=\"8\" height=\"2\"/>\n  <rect x=\"22\" y=\"21\" width=\"8\" height=\"2\"/>\n  <polygon points=\"18.4141 11 23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11\"/>\n  <path d=\"M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z\"/><path d=\"M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z\"/></svg>",
            "info": {},
            "path": "32/screen-map.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScreenMap32",
          "filepath": "screen-map/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
                }
              }
            ],
            "name": "screen-map",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScreenMap24",
          "filepath": "screen-map/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
                }
              }
            ],
            "name": "screen-map",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScreenMap20",
          "filepath": "screen-map/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
                }
              }
            ],
            "name": "screen-map",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScreenMap16",
          "filepath": "screen-map/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
                }
              }
            ],
            "name": "screen-map",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ScreenMap",
        "global": "ScreenMap",
        "filepath": "ScreenMap.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "screen-map--set",
      "friendlyName": "screen-map--set",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/screen-map--set.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"24\" y=\"26\" width=\"7\" height=\"2\"/>\n  <rect x=\"24\" y=\"22\" width=\"7\" height=\"2\"/>\n  <polygon points=\"20.4141 12 25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12\"/>\n  <path d=\"M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z\"/>\n  <path d=\"M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z\"/><path d=\"M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z\"/><path d=\"M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z\"/></svg>",
            "info": {},
            "path": "32/screen-map--set.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScreenMapSet32",
          "filepath": "screen-map--set/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
                }
              }
            ],
            "name": "screen-map--set",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScreenMapSet24",
          "filepath": "screen-map--set/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
                }
              }
            ],
            "name": "screen-map--set",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScreenMapSet20",
          "filepath": "screen-map--set/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
                }
              }
            ],
            "name": "screen-map--set",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScreenMapSet16",
          "filepath": "screen-map--set/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
                }
              }
            ],
            "name": "screen-map--set",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ScreenMapSet",
        "global": "ScreenMapSet",
        "filepath": "ScreenMapSet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "script",
      "friendlyName": "Script",
      "aliases": [
        "code",
        "development"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/script.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>script</title><polygon points=\"18.83 26 21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26\"/><polygon points=\"27.17 26 24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26\"/><path d=\"M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z\"/><path d=\"M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/script.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Script32",
          "filepath": "script/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "script",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Script24",
          "filepath": "script/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "script",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Script20",
          "filepath": "script/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "script",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Script16",
          "filepath": "script/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "script",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Script",
        "global": "Script",
        "filepath": "Script.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "script--reference",
      "friendlyName": "Script reference",
      "aliases": [
        "script",
        "reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/script--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <polygon points=\"27.17 26 24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26\"/>\n  <polygon points=\"18.83 26 21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26\"/>\n  <path d=\"M25.7,9.3l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V16H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10A.9092.9092,0,0,0,25.7,9.3ZM18,10V4.4L23.6,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z\"/></svg>",
            "info": {},
            "path": "32/script--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ScriptReference32",
          "filepath": "script--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
                }
              }
            ],
            "name": "script--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ScriptReference24",
          "filepath": "script--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
                }
              }
            ],
            "name": "script--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ScriptReference20",
          "filepath": "script--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
                }
              }
            ],
            "name": "script--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ScriptReference16",
          "filepath": "script--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
                }
              }
            ],
            "name": "script--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ScriptReference",
        "global": "ScriptReference",
        "filepath": "ScriptReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "SDK",
      "friendlyName": "SDK",
      "aliases": [
        "SDK",
        "software",
        "development",
        "kit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/SDK.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>SDK</title><polygon points=\"30 9 27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9\"/><path d=\"M16,23H12V9h4a4.0118,4.0118,0,0,1,4,4v6A4.0118,4.0118,0,0,1,16,23Zm-2-2h2a2.0059,2.0059,0,0,0,2-2V13a2.0059,2.0059,0,0,0-2-2H14Z\"/><path d=\"M8,23H2V21H8V17H4a2.0059,2.0059,0,0,1-2-2V11A2.0059,2.0059,0,0,1,4,9h6v2H4v4H8a2.0059,2.0059,0,0,1,2,2v4A2.0059,2.0059,0,0,1,8,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z\"/></svg>",
            "info": {},
            "path": "32/SDK.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sdk32",
          "filepath": "SDK/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
                }
              }
            ],
            "name": "SDK",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sdk24",
          "filepath": "SDK/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
                }
              }
            ],
            "name": "SDK",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sdk20",
          "filepath": "SDK/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
                }
              }
            ],
            "name": "SDK",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sdk16",
          "filepath": "SDK/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
                }
              }
            ],
            "name": "SDK",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Sdk",
        "global": "Sdk",
        "filepath": "Sdk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "search",
      "friendlyName": "Search",
      "aliases": [
        "find",
        "investigate",
        "explore",
        "look"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/search.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>search</title>\n<path d=\"M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5\n\tC2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5\tC2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z\"/></svg>",
            "info": {},
            "path": "16/search.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/search.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z\"/></svg>",
            "info": {},
            "path": "32/search.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Search32",
          "filepath": "search/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
                }
              }
            ],
            "name": "search",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Search24",
          "filepath": "search/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
                }
              }
            ],
            "name": "search",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Search20",
          "filepath": "search/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
                }
              }
            ],
            "name": "search",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Search16",
          "filepath": "search/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5\tC2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z"
                }
              }
            ],
            "name": "search",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Search",
        "global": "Search",
        "filepath": "Search.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5 C2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "search--advanced",
      "friendlyName": "Search advanced",
      "aliases": [
        "find",
        "investigate",
        "explore",
        "look",
        "advanced"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/search--advanced.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 6 26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6\"/>\n  <path d=\"M24,28.5859l-5.9751-5.9751a9.0234,9.0234,0,1,0-1.4141,1.4141L22.5859,30ZM4,17a7,7,0,1,1,7,7A7.0078,7.0078,0,0,1,4,17Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 28.5859l-5.9751-5.9751a9.0234 9.0234 0 10-1.4141 1.4141L22.5859 30zM4 17a7 7 0 117 7A7.0078 7.0078 0 014 17z\"/></svg>",
            "info": {},
            "path": "32/search--advanced.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SearchAdvanced32",
          "filepath": "search--advanced/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 28.5859l-5.9751-5.9751a9.0234 9.0234 0 10-1.4141 1.4141L22.5859 30zM4 17a7 7 0 117 7A7.0078 7.0078 0 014 17z"
                }
              }
            ],
            "name": "search--advanced",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SearchAdvanced24",
          "filepath": "search--advanced/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 28.5859l-5.9751-5.9751a9.0234 9.0234 0 10-1.4141 1.4141L22.5859 30zM4 17a7 7 0 117 7A7.0078 7.0078 0 014 17z"
                }
              }
            ],
            "name": "search--advanced",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SearchAdvanced20",
          "filepath": "search--advanced/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 28.5859l-5.9751-5.9751a9.0234 9.0234 0 10-1.4141 1.4141L22.5859 30zM4 17a7 7 0 117 7A7.0078 7.0078 0 014 17z"
                }
              }
            ],
            "name": "search--advanced",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SearchAdvanced16",
          "filepath": "search--advanced/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 28.5859l-5.9751-5.9751a9.0234 9.0234 0 10-1.4141 1.4141L22.5859 30zM4 17a7 7 0 117 7A7.0078 7.0078 0 014 17z"
                }
              }
            ],
            "name": "search--advanced",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SearchAdvanced",
        "global": "SearchAdvanced",
        "filepath": "SearchAdvanced.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 28.5859l-5.9751-5.9751a9.0234 9.0234 0 10-1.4141 1.4141L22.5859 30zM4 17a7 7 0 117 7A7.0078 7.0078 0 014 17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "search--locate",
      "friendlyName": "Search locate",
      "aliases": [
        "find",
        "investigate",
        "explore",
        "look",
        "locate",
        "discover",
        "identify"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/search--locate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,28.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L28.5859,30ZM19,25a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,19,25Z\"/>\n  <rect x=\"2\" y=\"12\" width=\"8\" height=\"2\"/>\n  <rect x=\"2\" y=\"2\" width=\"16\" height=\"2\"/>\n  <rect x=\"2\" y=\"7\" width=\"16\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 28.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L28.5859 30zM19 25a6 6 0 116-6A6.0066 6.0066 0 0119 25zM2 12H10V14H2zM2 2H18V4H2zM2 7H18V9H2z\"/></svg>",
            "info": {},
            "path": "32/search--locate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SearchLocate32",
          "filepath": "search--locate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L28.5859 30zM19 25a6 6 0 116-6A6.0066 6.0066 0 0119 25zM2 12H10V14H2zM2 2H18V4H2zM2 7H18V9H2z"
                }
              }
            ],
            "name": "search--locate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SearchLocate24",
          "filepath": "search--locate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L28.5859 30zM19 25a6 6 0 116-6A6.0066 6.0066 0 0119 25zM2 12H10V14H2zM2 2H18V4H2zM2 7H18V9H2z"
                }
              }
            ],
            "name": "search--locate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SearchLocate20",
          "filepath": "search--locate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L28.5859 30zM19 25a6 6 0 116-6A6.0066 6.0066 0 0119 25zM2 12H10V14H2zM2 2H18V4H2zM2 7H18V9H2z"
                }
              }
            ],
            "name": "search--locate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SearchLocate16",
          "filepath": "search--locate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L28.5859 30zM19 25a6 6 0 116-6A6.0066 6.0066 0 0119 25zM2 12H10V14H2zM2 2H18V4H2zM2 7H18V9H2z"
                }
              }
            ],
            "name": "search--locate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SearchLocate",
        "global": "SearchLocate",
        "filepath": "SearchLocate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 28.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L28.5859 30zM19 25a6 6 0 116-6A6.0066 6.0066 0 0119 25zM2 12H10V14H2zM2 2H18V4H2zM2 7H18V9H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "search--locate--mirror",
      "friendlyName": "search--locate--mirror",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/search--locate--mirror.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M21,28.6l-4.7-4.7c1.1-1.4,1.7-3.1,1.7-4.9c0-4.4-3.6-8-8-8s-8,3.6-8,8s3.6,8,8,8c1.8,0,3.5-0.6,4.9-1.7l4.7,4.7L21,28.6z\n\t M10,25c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S13.3,25,10,25z\"/>\n<rect x=\"22\" y=\"12\" width=\"8\" height=\"2\"/>\n<rect x=\"14\" y=\"7\" width=\"16\" height=\"2\"/>\n<rect x=\"14\" y=\"2\" width=\"16\" height=\"2\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 28.6l-4.7-4.7c1.1-1.4 1.7-3.1 1.7-4.9 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l4.7 4.7L21 28.6zM10 25c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6S13.3 25 10 25zM22 12H30V14H22zM14 7H30V9H14zM14 2H30V4H14z\"/></svg>",
            "info": {},
            "path": "32/search--locate--mirror.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SearchLocateMirror32",
          "filepath": "search--locate--mirror/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.6l-4.7-4.7c1.1-1.4 1.7-3.1 1.7-4.9 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l4.7 4.7L21 28.6zM10 25c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6S13.3 25 10 25zM22 12H30V14H22zM14 7H30V9H14zM14 2H30V4H14z"
                }
              }
            ],
            "name": "search--locate--mirror",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SearchLocateMirror24",
          "filepath": "search--locate--mirror/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.6l-4.7-4.7c1.1-1.4 1.7-3.1 1.7-4.9 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l4.7 4.7L21 28.6zM10 25c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6S13.3 25 10 25zM22 12H30V14H22zM14 7H30V9H14zM14 2H30V4H14z"
                }
              }
            ],
            "name": "search--locate--mirror",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SearchLocateMirror20",
          "filepath": "search--locate--mirror/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.6l-4.7-4.7c1.1-1.4 1.7-3.1 1.7-4.9 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l4.7 4.7L21 28.6zM10 25c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6S13.3 25 10 25zM22 12H30V14H22zM14 7H30V9H14zM14 2H30V4H14z"
                }
              }
            ],
            "name": "search--locate--mirror",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SearchLocateMirror16",
          "filepath": "search--locate--mirror/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.6l-4.7-4.7c1.1-1.4 1.7-3.1 1.7-4.9 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l4.7 4.7L21 28.6zM10 25c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6S13.3 25 10 25zM22 12H30V14H22zM14 7H30V9H14zM14 2H30V4H14z"
                }
              }
            ],
            "name": "search--locate--mirror",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SearchLocateMirror",
        "global": "SearchLocateMirror",
        "filepath": "SearchLocateMirror.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 28.6l-4.7-4.7c1.1-1.4 1.7-3.1 1.7-4.9 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l4.7 4.7L21 28.6zM10 25c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6S13.3 25 10 25zM22 12H30V14H22zM14 7H30V9H14zM14 2H30V4H14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "security",
      "friendlyName": "Security",
      "aliases": [
        "file",
        "security"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/security.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 16.59 11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59\"/>\n  <path d=\"M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z\"/><path d=\"M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z\"/></svg>",
            "info": {},
            "path": "32/security.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Security32",
          "filepath": "security/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "security",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Security24",
          "filepath": "security/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "security",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Security20",
          "filepath": "security/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "security",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Security16",
          "filepath": "security/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                }
              }
            ],
            "name": "security",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Security",
        "global": "Security",
        "filepath": "Security.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "security-services",
      "friendlyName": "Security services",
      "aliases": [
        "shield",
        "gear",
        "systems",
        "services",
        "security",
        "preferences",
        "settings"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/security-services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z\"/><path d=\"M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z\"/></svg>",
            "info": {},
            "path": "32/security-services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SecurityServices32",
          "filepath": "security-services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
                }
              }
            ],
            "name": "security-services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SecurityServices24",
          "filepath": "security-services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
                }
              }
            ],
            "name": "security-services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SecurityServices20",
          "filepath": "security-services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
                }
              }
            ],
            "name": "security-services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SecurityServices16",
          "filepath": "security-services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
                }
              }
            ],
            "name": "security-services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SecurityServices",
        "global": "SecurityServices",
        "filepath": "SecurityServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "select--01",
      "friendlyName": "Select 01",
      "aliases": [
        "select 01",
        "formatting",
        "marquee"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/select--01.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"12 6 8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6\"/>\n  <rect x=\"16\" y=\"6\" width=\"4\" height=\"2\"/>\n  <path d=\"M24,6V8h4v4h2V8a2,2,0,0,0-2-2Z\"/>\n  <rect x=\"6\" y=\"16\" width=\"2\" height=\"4\"/>\n  <path d=\"M8,28V24H6v4a2,2,0,0,0,2,2h4V28Z\"/>\n  <rect x=\"28\" y=\"16\" width=\"2\" height=\"4\"/>\n  <rect x=\"16\" y=\"28\" width=\"4\" height=\"2\"/>\n  <path d=\"M28,24v4H24v2h4a2,2,0,0,0,2-2V24Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z\"/></svg>",
            "info": {},
            "path": "32/select--01.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Select_0132",
          "filepath": "select--01/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
                }
              }
            ],
            "name": "select--01",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Select_0124",
          "filepath": "select--01/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
                }
              }
            ],
            "name": "select--01",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Select_0120",
          "filepath": "select--01/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
                }
              }
            ],
            "name": "select--01",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Select_0116",
          "filepath": "select--01/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
                }
              }
            ],
            "name": "select--01",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Select_01",
        "global": "Select_01",
        "filepath": "Select_01.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "select--02",
      "friendlyName": "Select 02",
      "aliases": [
        "select 02",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/select--02.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"12 6 8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6\"/>\n  <path d=\"M30,10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10ZM8,28H6V26H8Zm20,0H26V26h2ZM26,6h2V8H26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z\"/></svg>",
            "info": {},
            "path": "32/select--02.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Select_0232",
          "filepath": "select--02/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
                }
              }
            ],
            "name": "select--02",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Select_0224",
          "filepath": "select--02/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
                }
              }
            ],
            "name": "select--02",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Select_0220",
          "filepath": "select--02/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
                }
              }
            ],
            "name": "select--02",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Select_0216",
          "filepath": "select--02/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
                }
              }
            ],
            "name": "select--02",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Select_02",
        "global": "Select_02",
        "filepath": "Select_02.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "select--window",
      "friendlyName": "Select window",
      "aliases": [
        "select",
        "formatting",
        "window",
        "pointer",
        "arrow"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/select--window.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z\"/>\n  <rect x=\"2\" y=\"12\" width=\"2\" height=\"4\"/>\n  <path d=\"M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z\"/>\n  <rect x=\"12\" y=\"2\" width=\"4\" height=\"2\"/>\n  <path d=\"M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z\"/>\n  <path d=\"M27,32a.9967.9967,0,0,1-.707-.293l-6.1377-6.1377L16.832,30.5547a1,1,0,0,1-1.79-.2676l-6-20A1,1,0,0,1,10.2871,9.042l20,6a1,1,0,0,1,.2676,1.79l-4.9854,3.3233L31.707,26.293a.9994.9994,0,0,1,0,1.414l-4,4A.9967.9967,0,0,1,27,32Zm0-2.4141L29.5859,27,22.431,19.845l5.2458-3.4978L11.4917,11.4917l4.8555,16.1851L19.845,22.431Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM27 32a.9967.9967 0 01-.707-.293l-6.1377-6.1377L16.832 30.5547a1 1 0 01-1.79-.2676l-6-20A1 1 0 0110.2871 9.042l20 6a1 1 0 01.2676 1.79l-4.9854 3.3233L31.707 26.293a.9994.9994 0 010 1.414l-4 4A.9967.9967 0 0127 32zm0-2.4141L29.5859 27 22.431 19.845l5.2458-3.4978L11.4917 11.4917l4.8555 16.1851L19.845 22.431z\"/></svg>",
            "info": {},
            "path": "32/select--window.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SelectWindow32",
          "filepath": "select--window/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM27 32a.9967.9967 0 01-.707-.293l-6.1377-6.1377L16.832 30.5547a1 1 0 01-1.79-.2676l-6-20A1 1 0 0110.2871 9.042l20 6a1 1 0 01.2676 1.79l-4.9854 3.3233L31.707 26.293a.9994.9994 0 010 1.414l-4 4A.9967.9967 0 0127 32zm0-2.4141L29.5859 27 22.431 19.845l5.2458-3.4978L11.4917 11.4917l4.8555 16.1851L19.845 22.431z"
                }
              }
            ],
            "name": "select--window",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SelectWindow24",
          "filepath": "select--window/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM27 32a.9967.9967 0 01-.707-.293l-6.1377-6.1377L16.832 30.5547a1 1 0 01-1.79-.2676l-6-20A1 1 0 0110.2871 9.042l20 6a1 1 0 01.2676 1.79l-4.9854 3.3233L31.707 26.293a.9994.9994 0 010 1.414l-4 4A.9967.9967 0 0127 32zm0-2.4141L29.5859 27 22.431 19.845l5.2458-3.4978L11.4917 11.4917l4.8555 16.1851L19.845 22.431z"
                }
              }
            ],
            "name": "select--window",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SelectWindow20",
          "filepath": "select--window/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM27 32a.9967.9967 0 01-.707-.293l-6.1377-6.1377L16.832 30.5547a1 1 0 01-1.79-.2676l-6-20A1 1 0 0110.2871 9.042l20 6a1 1 0 01.2676 1.79l-4.9854 3.3233L31.707 26.293a.9994.9994 0 010 1.414l-4 4A.9967.9967 0 0127 32zm0-2.4141L29.5859 27 22.431 19.845l5.2458-3.4978L11.4917 11.4917l4.8555 16.1851L19.845 22.431z"
                }
              }
            ],
            "name": "select--window",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SelectWindow16",
          "filepath": "select--window/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM27 32a.9967.9967 0 01-.707-.293l-6.1377-6.1377L16.832 30.5547a1 1 0 01-1.79-.2676l-6-20A1 1 0 0110.2871 9.042l20 6a1 1 0 01.2676 1.79l-4.9854 3.3233L31.707 26.293a.9994.9994 0 010 1.414l-4 4A.9967.9967 0 0127 32zm0-2.4141L29.5859 27 22.431 19.845l5.2458-3.4978L11.4917 11.4917l4.8555 16.1851L19.845 22.431z"
                }
              }
            ],
            "name": "select--window",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "SelectWindow",
        "global": "SelectWindow",
        "filepath": "SelectWindow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM27 32a.9967.9967 0 01-.707-.293l-6.1377-6.1377L16.832 30.5547a1 1 0 01-1.79-.2676l-6-20A1 1 0 0110.2871 9.042l20 6a1 1 0 01.2676 1.79l-4.9854 3.3233L31.707 26.293a.9994.9994 0 010 1.414l-4 4A.9967.9967 0 0127 32zm0-2.4141L29.5859 27 22.431 19.845l5.2458-3.4978L11.4917 11.4917l4.8555 16.1851L19.845 22.431z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "send",
      "friendlyName": "Send",
      "aliases": [
        "mail",
        "message",
        "paper plane",
        "sending",
        "message",
        "arrow",
        "deliver",
        "letter",
        "email"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/send.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>send</title><path d=\"M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z\"/></svg>",
            "info": {},
            "path": "32/send.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Send32",
          "filepath": "send/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
                }
              }
            ],
            "name": "send",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Send24",
          "filepath": "send/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
                }
              }
            ],
            "name": "send",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Send20",
          "filepath": "send/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
                }
              }
            ],
            "name": "send",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Send16",
          "filepath": "send/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
                }
              }
            ],
            "name": "send",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Send",
        "global": "Send",
        "filepath": "Send.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "send--alt",
      "friendlyName": "Send alt",
      "aliases": [
        "mail",
        "message",
        "paper plane",
        "sending",
        "message",
        "arrow",
        "deliver",
        "letter",
        "email"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/send--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>send--alt</title><path d=\"M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z\"/></svg>",
            "info": {},
            "path": "32/send--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SendAlt32",
          "filepath": "send--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
                }
              }
            ],
            "name": "send--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SendAlt24",
          "filepath": "send--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
                }
              }
            ],
            "name": "send--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SendAlt20",
          "filepath": "send--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
                }
              }
            ],
            "name": "send--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SendAlt16",
          "filepath": "send--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
                }
              }
            ],
            "name": "send--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SendAlt",
        "global": "SendAlt",
        "filepath": "SendAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "send--alt--filled",
      "friendlyName": "Send alt filled",
      "aliases": [
        "mail",
        "message",
        "paper plane",
        "sending",
        "message",
        "arrow",
        "deliver",
        "letter",
        "email"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/send--alt--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>send--alt--filled</title><path d=\"M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z\"/></svg>",
            "info": {},
            "path": "32/send--alt--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SendAltFilled32",
          "filepath": "send--alt--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
                }
              }
            ],
            "name": "send--alt--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SendAltFilled24",
          "filepath": "send--alt--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
                }
              }
            ],
            "name": "send--alt--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SendAltFilled20",
          "filepath": "send--alt--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
                }
              }
            ],
            "name": "send--alt--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SendAltFilled16",
          "filepath": "send--alt--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
                }
              }
            ],
            "name": "send--alt--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SendAltFilled",
        "global": "SendAltFilled",
        "filepath": "SendAltFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "send--filled",
      "friendlyName": "Send filled",
      "aliases": [
        "mail",
        "message",
        "paper plane",
        "sending",
        "message",
        "arrow",
        "deliver",
        "letter",
        "email"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/send--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>send--filled</title><path d=\"M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z\"/></svg>",
            "info": {},
            "path": "32/send--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SendFilled32",
          "filepath": "send--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
                }
              }
            ],
            "name": "send--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SendFilled24",
          "filepath": "send--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
                }
              }
            ],
            "name": "send--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SendFilled20",
          "filepath": "send--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
                }
              }
            ],
            "name": "send--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SendFilled16",
          "filepath": "send--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
                }
              }
            ],
            "name": "send--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SendFilled",
        "global": "SendFilled",
        "filepath": "SendFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "send-backward",
      "friendlyName": "Send backward",
      "aliases": [
        "send",
        "backward",
        "formatting",
        "group",
        "layer",
        "order",
        "arrange"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/send-backward.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,7H2V4A2.0023,2.0023,0,0,1,4,2H7V4H4Z\"/>\n  <path d=\"M7,22H4a2.0023,2.0023,0,0,1-2-2V17H4v3H7Z\"/>\n  <rect x=\"2\" y=\"10\" width=\"2\" height=\"4\"/>\n  <path d=\"M22,7H20V4H17V2h3a2.0023,2.0023,0,0,1,2,2Z\"/>\n  <rect x=\"10\" y=\"2\" width=\"4\" height=\"2\"/>\n  <path d=\"M28,30H12a2.0023,2.0023,0,0,1-2-2V12a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM12,12V28H28V12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 7H2V4A2.0023 2.0023 0 014 2H7V4H4zM7 22H4a2.0023 2.0023 0 01-2-2V17H4v3H7zM2 10H4V14H2zM22 7H20V4H17V2h3a2.0023 2.0023 0 012 2zM10 2H14V4H10zM28 30H12a2.0023 2.0023 0 01-2-2V12a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM12 12V28H28V12z\"/></svg>",
            "info": {},
            "path": "32/send-backward.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SendBackward32",
          "filepath": "send-backward/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 7H2V4A2.0023 2.0023 0 014 2H7V4H4zM7 22H4a2.0023 2.0023 0 01-2-2V17H4v3H7zM2 10H4V14H2zM22 7H20V4H17V2h3a2.0023 2.0023 0 012 2zM10 2H14V4H10zM28 30H12a2.0023 2.0023 0 01-2-2V12a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM12 12V28H28V12z"
                }
              }
            ],
            "name": "send-backward",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SendBackward24",
          "filepath": "send-backward/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 7H2V4A2.0023 2.0023 0 014 2H7V4H4zM7 22H4a2.0023 2.0023 0 01-2-2V17H4v3H7zM2 10H4V14H2zM22 7H20V4H17V2h3a2.0023 2.0023 0 012 2zM10 2H14V4H10zM28 30H12a2.0023 2.0023 0 01-2-2V12a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM12 12V28H28V12z"
                }
              }
            ],
            "name": "send-backward",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SendBackward20",
          "filepath": "send-backward/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 7H2V4A2.0023 2.0023 0 014 2H7V4H4zM7 22H4a2.0023 2.0023 0 01-2-2V17H4v3H7zM2 10H4V14H2zM22 7H20V4H17V2h3a2.0023 2.0023 0 012 2zM10 2H14V4H10zM28 30H12a2.0023 2.0023 0 01-2-2V12a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM12 12V28H28V12z"
                }
              }
            ],
            "name": "send-backward",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SendBackward16",
          "filepath": "send-backward/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 7H2V4A2.0023 2.0023 0 014 2H7V4H4zM7 22H4a2.0023 2.0023 0 01-2-2V17H4v3H7zM2 10H4V14H2zM22 7H20V4H17V2h3a2.0023 2.0023 0 012 2zM10 2H14V4H10zM28 30H12a2.0023 2.0023 0 01-2-2V12a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM12 12V28H28V12z"
                }
              }
            ],
            "name": "send-backward",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "SendBackward",
        "global": "SendBackward",
        "filepath": "SendBackward.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 7H2V4A2.0023 2.0023 0 014 2H7V4H4zM7 22H4a2.0023 2.0023 0 01-2-2V17H4v3H7zM2 10H4V14H2zM22 7H20V4H17V2h3a2.0023 2.0023 0 012 2zM10 2H14V4H10zM28 30H12a2.0023 2.0023 0 01-2-2V12a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM12 12V28H28V12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "send-to-back",
      "friendlyName": "Send to back",
      "aliases": [
        "send",
        "back",
        "formatting",
        "group",
        "layer",
        "order",
        "arrange"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/send-to-back.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z\"/></svg>",
            "info": {},
            "path": "32/send-to-back.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SendToBack32",
          "filepath": "send-to-back/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
                }
              }
            ],
            "name": "send-to-back",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SendToBack24",
          "filepath": "send-to-back/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
                }
              }
            ],
            "name": "send-to-back",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SendToBack20",
          "filepath": "send-to-back/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
                }
              }
            ],
            "name": "send-to-back",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SendToBack16",
          "filepath": "send-to-back/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
                }
              }
            ],
            "name": "send-to-back",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "SendToBack",
        "global": "SendToBack",
        "filepath": "SendToBack.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "server--dns",
      "friendlyName": "Server DNS",
      "aliases": [
        "systems",
        "server",
        "DNS",
        "domain",
        "name",
        "global"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/server--dns.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,2Zm5.91,7H19.4724a15.2457,15.2457,0,0,0-.7917-4.36A6.0088,6.0088,0,0,1,21.91,9ZM16.022,15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952,14.1763,16.3711,15.877,16.022,15.999ZM14.5354,9c.1694-3.1763,1.0935-4.877,1.4426-4.999h.0076c.3813.1206,1.3091,1.8213,1.479,4.999ZM13.3193,4.64A15.2457,15.2457,0,0,0,12.5276,9H10.09A6.0088,6.0088,0,0,1,13.3193,4.64ZM10.09,11h2.4373a15.2457,15.2457,0,0,0,.7917,4.36A6.0088,6.0088,0,0,1,10.09,11Zm8.59,4.36A15.2457,15.2457,0,0,0,19.4724,11H21.91A6.0088,6.0088,0,0,1,18.6807,15.36Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 2a8 8 0 108 8A8.0092 8.0092 0 0016 2zm5.91 7H19.4724a15.2457 15.2457 0 00-.7917-4.36A6.0088 6.0088 0 0121.91 9zM16.022 15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952 14.1763 16.3711 15.877 16.022 15.999zM14.5354 9c.1694-3.1763 1.0935-4.877 1.4426-4.999h.0076c.3813.1206 1.3091 1.8213 1.479 4.999zM13.3193 4.64A15.2457 15.2457 0 0012.5276 9H10.09A6.0088 6.0088 0 0113.3193 4.64zM10.09 11h2.4373a15.2457 15.2457 0 00.7917 4.36A6.0088 6.0088 0 0110.09 11zm8.59 4.36A15.2457 15.2457 0 0019.4724 11H21.91A6.0088 6.0088 0 0118.6807 15.36zM28 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM4 22v6H28V22z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/server--dns.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ServerDns32",
          "filepath": "server--dns/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2a8 8 0 108 8A8.0092 8.0092 0 0016 2zm5.91 7H19.4724a15.2457 15.2457 0 00-.7917-4.36A6.0088 6.0088 0 0121.91 9zM16.022 15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952 14.1763 16.3711 15.877 16.022 15.999zM14.5354 9c.1694-3.1763 1.0935-4.877 1.4426-4.999h.0076c.3813.1206 1.3091 1.8213 1.479 4.999zM13.3193 4.64A15.2457 15.2457 0 0012.5276 9H10.09A6.0088 6.0088 0 0113.3193 4.64zM10.09 11h2.4373a15.2457 15.2457 0 00.7917 4.36A6.0088 6.0088 0 0110.09 11zm8.59 4.36A15.2457 15.2457 0 0019.4724 11H21.91A6.0088 6.0088 0 0118.6807 15.36zM28 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM4 22v6H28V22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "server--dns",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ServerDns24",
          "filepath": "server--dns/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2a8 8 0 108 8A8.0092 8.0092 0 0016 2zm5.91 7H19.4724a15.2457 15.2457 0 00-.7917-4.36A6.0088 6.0088 0 0121.91 9zM16.022 15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952 14.1763 16.3711 15.877 16.022 15.999zM14.5354 9c.1694-3.1763 1.0935-4.877 1.4426-4.999h.0076c.3813.1206 1.3091 1.8213 1.479 4.999zM13.3193 4.64A15.2457 15.2457 0 0012.5276 9H10.09A6.0088 6.0088 0 0113.3193 4.64zM10.09 11h2.4373a15.2457 15.2457 0 00.7917 4.36A6.0088 6.0088 0 0110.09 11zm8.59 4.36A15.2457 15.2457 0 0019.4724 11H21.91A6.0088 6.0088 0 0118.6807 15.36zM28 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM4 22v6H28V22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "server--dns",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ServerDns20",
          "filepath": "server--dns/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2a8 8 0 108 8A8.0092 8.0092 0 0016 2zm5.91 7H19.4724a15.2457 15.2457 0 00-.7917-4.36A6.0088 6.0088 0 0121.91 9zM16.022 15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952 14.1763 16.3711 15.877 16.022 15.999zM14.5354 9c.1694-3.1763 1.0935-4.877 1.4426-4.999h.0076c.3813.1206 1.3091 1.8213 1.479 4.999zM13.3193 4.64A15.2457 15.2457 0 0012.5276 9H10.09A6.0088 6.0088 0 0113.3193 4.64zM10.09 11h2.4373a15.2457 15.2457 0 00.7917 4.36A6.0088 6.0088 0 0110.09 11zm8.59 4.36A15.2457 15.2457 0 0019.4724 11H21.91A6.0088 6.0088 0 0118.6807 15.36zM28 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM4 22v6H28V22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "server--dns",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ServerDns16",
          "filepath": "server--dns/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2a8 8 0 108 8A8.0092 8.0092 0 0016 2zm5.91 7H19.4724a15.2457 15.2457 0 00-.7917-4.36A6.0088 6.0088 0 0121.91 9zM16.022 15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952 14.1763 16.3711 15.877 16.022 15.999zM14.5354 9c.1694-3.1763 1.0935-4.877 1.4426-4.999h.0076c.3813.1206 1.3091 1.8213 1.479 4.999zM13.3193 4.64A15.2457 15.2457 0 0012.5276 9H10.09A6.0088 6.0088 0 0113.3193 4.64zM10.09 11h2.4373a15.2457 15.2457 0 00.7917 4.36A6.0088 6.0088 0 0110.09 11zm8.59 4.36A15.2457 15.2457 0 0019.4724 11H21.91A6.0088 6.0088 0 0118.6807 15.36zM28 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM4 22v6H28V22z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              }
            ],
            "name": "server--dns",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ServerDns",
        "global": "ServerDns",
        "filepath": "ServerDns.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 2a8 8 0 108 8A8.0092 8.0092 0 0016 2zm5.91 7H19.4724a15.2457 15.2457 0 00-.7917-4.36A6.0088 6.0088 0 0121.91 9zM16.022 15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952 14.1763 16.3711 15.877 16.022 15.999zM14.5354 9c.1694-3.1763 1.0935-4.877 1.4426-4.999h.0076c.3813.1206 1.3091 1.8213 1.479 4.999zM13.3193 4.64A15.2457 15.2457 0 0012.5276 9H10.09A6.0088 6.0088 0 0113.3193 4.64zM10.09 11h2.4373a15.2457 15.2457 0 00.7917 4.36A6.0088 6.0088 0 0110.09 11zm8.59 4.36A15.2457 15.2457 0 0019.4724 11H21.91A6.0088 6.0088 0 0118.6807 15.36zM28 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM4 22v6H28V22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "server--proxy",
      "friendlyName": "Server proxy",
      "aliases": [
        "system",
        "proxy",
        "server"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/server--proxy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"9\" cy=\"25\" r=\"1\"/>\n  <path d=\"M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z\"/><circle cx=\"9\" cy=\"25\" r=\"1\"/><path d=\"M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z\"/></svg>",
            "info": {},
            "path": "32/server--proxy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ServerProxy32",
          "filepath": "server--proxy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
                }
              }
            ],
            "name": "server--proxy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ServerProxy24",
          "filepath": "server--proxy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
                }
              }
            ],
            "name": "server--proxy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ServerProxy20",
          "filepath": "server--proxy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
                }
              }
            ],
            "name": "server--proxy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ServerProxy16",
          "filepath": "server--proxy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
                }
              }
            ],
            "name": "server--proxy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ServerProxy",
        "global": "ServerProxy",
        "filepath": "ServerProxy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "server--time",
      "friendlyName": "Server time",
      "aliases": [
        "server",
        "time",
        "clock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/server--time.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <polygon points=\"19 11.586 17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586\"/>\n  <path d=\"M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z\"/><path d=\"M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/server--time.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ServerTime32",
          "filepath": "server--time/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
                }
              }
            ],
            "name": "server--time",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ServerTime24",
          "filepath": "server--time/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
                }
              }
            ],
            "name": "server--time",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ServerTime20",
          "filepath": "server--time/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
                }
              }
            ],
            "name": "server--time",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ServerTime16",
          "filepath": "server--time/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
                }
              }
            ],
            "name": "server--time",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ServerTime",
        "global": "ServerTime",
        "filepath": "ServerTime.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "service-desk",
      "friendlyName": "Service desk",
      "aliases": [
        "service-desk",
        "concierge",
        "front desk"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/service-desk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>service-desk</title><path d=\"M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z\" transform=\"translate(0 0.0049)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z\" transform=\"translate(0 .005)\"/></svg>",
            "info": {},
            "path": "32/service-desk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ServiceDesk32",
          "filepath": "service-desk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "service-desk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ServiceDesk24",
          "filepath": "service-desk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "service-desk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ServiceDesk20",
          "filepath": "service-desk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "service-desk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ServiceDesk16",
          "filepath": "service-desk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "service-desk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "ServiceDesk",
        "global": "ServiceDesk",
        "filepath": "ServiceDesk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
                    "transform": "translate(0 .005)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "service-id",
      "friendlyName": "Service ID",
      "aliases": [
        "service ID",
        "identification",
        "settings",
        "badge",
        "gear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/service-id.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M30,24v-2h-2.101c-0.13-0.637-0.384-1.229-0.732-1.753l1.49-1.49l-1.414-1.414l-1.49,1.49\n\tc-0.524-0.348-1.116-0.602-1.753-0.732V16h-2v2.101c-0.637,0.13-1.229,0.384-1.753,0.732l-1.49-1.49l-1.414,1.414l1.49,1.49\n\tc-0.348,0.524-0.602,1.116-0.732,1.753H16v2h2.101c0.13,0.637,0.384,1.229,0.732,1.753l-1.49,1.49l1.414,1.414l1.49-1.49\n\tc0.524,0.348,1.116,0.602,1.753,0.732V30h2v-2.101c0.637-0.13,1.229-0.384,1.753-0.732l1.49,1.49l1.414-1.414l-1.49-1.49\n\tc0.348-0.524,0.602-1.116,0.732-1.753H30z M23,26c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S24.654,26,23,26z\"/>\n<rect x=\"12\" y=\"6\" width=\"4\" height=\"2\"/>\n<path d=\"M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 24v-2h-2.101c-.13-.637-.384-1.229-.732-1.753l1.49-1.49-1.414-1.414-1.49 1.49c-.524-.348-1.116-.602-1.753-.732V16h-2v2.101c-.637.13-1.229.384-1.753.732l-1.49-1.49-1.414 1.414 1.49 1.49c-.348.524-.602 1.116-.732 1.753H16v2h2.101c.13.637.384 1.229.732 1.753l-1.49 1.49 1.414 1.414 1.49-1.49c.524.348 1.116.602 1.753.732V30h2v-2.101c.637-.13 1.229-.384 1.753-.732l1.49 1.49 1.414-1.414-1.49-1.49c.348-.524.602-1.116.732-1.753H30zM23 26c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S24.654 26 23 26zM12 6H16V8H12z\"/><path d=\"M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z\"/></svg>",
            "info": {},
            "path": "32/service-id.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ServiceId32",
          "filepath": "service-id/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24v-2h-2.101c-.13-.637-.384-1.229-.732-1.753l1.49-1.49-1.414-1.414-1.49 1.49c-.524-.348-1.116-.602-1.753-.732V16h-2v2.101c-.637.13-1.229.384-1.753.732l-1.49-1.49-1.414 1.414 1.49 1.49c-.348.524-.602 1.116-.732 1.753H16v2h2.101c.13.637.384 1.229.732 1.753l-1.49 1.49 1.414 1.414 1.49-1.49c.524.348 1.116.602 1.753.732V30h2v-2.101c.637-.13 1.229-.384 1.753-.732l1.49 1.49 1.414-1.414-1.49-1.49c.348-.524.602-1.116.732-1.753H30zM23 26c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S24.654 26 23 26zM12 6H16V8H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
                }
              }
            ],
            "name": "service-id",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ServiceId24",
          "filepath": "service-id/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24v-2h-2.101c-.13-.637-.384-1.229-.732-1.753l1.49-1.49-1.414-1.414-1.49 1.49c-.524-.348-1.116-.602-1.753-.732V16h-2v2.101c-.637.13-1.229.384-1.753.732l-1.49-1.49-1.414 1.414 1.49 1.49c-.348.524-.602 1.116-.732 1.753H16v2h2.101c.13.637.384 1.229.732 1.753l-1.49 1.49 1.414 1.414 1.49-1.49c.524.348 1.116.602 1.753.732V30h2v-2.101c.637-.13 1.229-.384 1.753-.732l1.49 1.49 1.414-1.414-1.49-1.49c.348-.524.602-1.116.732-1.753H30zM23 26c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S24.654 26 23 26zM12 6H16V8H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
                }
              }
            ],
            "name": "service-id",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ServiceId20",
          "filepath": "service-id/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24v-2h-2.101c-.13-.637-.384-1.229-.732-1.753l1.49-1.49-1.414-1.414-1.49 1.49c-.524-.348-1.116-.602-1.753-.732V16h-2v2.101c-.637.13-1.229.384-1.753.732l-1.49-1.49-1.414 1.414 1.49 1.49c-.348.524-.602 1.116-.732 1.753H16v2h2.101c.13.637.384 1.229.732 1.753l-1.49 1.49 1.414 1.414 1.49-1.49c.524.348 1.116.602 1.753.732V30h2v-2.101c.637-.13 1.229-.384 1.753-.732l1.49 1.49 1.414-1.414-1.49-1.49c.348-.524.602-1.116.732-1.753H30zM23 26c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S24.654 26 23 26zM12 6H16V8H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
                }
              }
            ],
            "name": "service-id",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ServiceId16",
          "filepath": "service-id/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24v-2h-2.101c-.13-.637-.384-1.229-.732-1.753l1.49-1.49-1.414-1.414-1.49 1.49c-.524-.348-1.116-.602-1.753-.732V16h-2v2.101c-.637.13-1.229.384-1.753.732l-1.49-1.49-1.414 1.414 1.49 1.49c-.348.524-.602 1.116-.732 1.753H16v2h2.101c.13.637.384 1.229.732 1.753l-1.49 1.49 1.414 1.414 1.49-1.49c.524.348 1.116.602 1.753.732V30h2v-2.101c.637-.13 1.229-.384 1.753-.732l1.49 1.49 1.414-1.414-1.49-1.49c.348-.524.602-1.116.732-1.753H30zM23 26c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S24.654 26 23 26zM12 6H16V8H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
                }
              }
            ],
            "name": "service-id",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "ServiceId",
        "global": "ServiceId",
        "filepath": "ServiceId.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 24v-2h-2.101c-.13-.637-.384-1.229-.732-1.753l1.49-1.49-1.414-1.414-1.49 1.49c-.524-.348-1.116-.602-1.753-.732V16h-2v2.101c-.637.13-1.229.384-1.753.732l-1.49-1.49-1.414 1.414 1.49 1.49c-.348.524-.602 1.116-.732 1.753H16v2h2.101c.13.637.384 1.229.732 1.753l-1.49 1.49 1.414 1.414 1.49-1.49c.524.348 1.116.602 1.753.732V30h2v-2.101c.637-.13 1.229-.384 1.753-.732l1.49 1.49 1.414-1.414-1.49-1.49c.348-.524.602-1.116.732-1.753H30zM23 26c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S24.654 26 23 26zM12 6H16V8H12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "session-border-control",
      "friendlyName": "Session border control",
      "aliases": [
        "systems",
        "control",
        "border",
        "access",
        "perimeter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/session-border-control.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z\"/></svg>",
            "info": {},
            "path": "32/session-border-control.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SessionBorderControl32",
          "filepath": "session-border-control/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
                }
              }
            ],
            "name": "session-border-control",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SessionBorderControl24",
          "filepath": "session-border-control/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
                }
              }
            ],
            "name": "session-border-control",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SessionBorderControl20",
          "filepath": "session-border-control/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
                }
              }
            ],
            "name": "session-border-control",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SessionBorderControl16",
          "filepath": "session-border-control/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
                }
              }
            ],
            "name": "session-border-control",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SessionBorderControl",
        "global": "SessionBorderControl",
        "filepath": "SessionBorderControl.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "settings",
      "friendlyName": "Settings",
      "aliases": [
        "preferences",
        "options",
        "alternatives",
        "gear"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/settings.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>settings</title>\n<path d=\"M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3\n\tc-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1\n\tC5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4\n\tc0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4\n\tc0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4\n\tc0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8\n\tL9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6\n\tC5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z\"/>\n<path d=\"M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8\n\tc0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3\tc-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1\tC5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4\tc0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4\tc0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4\tc0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8\tL9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6\tC5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z\"/><path d=\"M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8\tc0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z\"/></svg>",
            "info": {},
            "path": "16/settings.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/settings.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>settings</title><path d=\"M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z\" transform=\"translate(0 0)\"/><path d=\"M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z\"/><path d=\"M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z\"/></svg>",
            "info": {},
            "path": "32/settings.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Settings32",
          "filepath": "settings/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
                }
              }
            ],
            "name": "settings",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Settings24",
          "filepath": "settings/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
                }
              }
            ],
            "name": "settings",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Settings20",
          "filepath": "settings/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
                }
              }
            ],
            "name": "settings",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Settings16",
          "filepath": "settings/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3\tc-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1\tC5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4\tc0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4\tc0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4\tc0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8\tL9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6\tC5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8\tc0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z"
                }
              }
            ],
            "name": "settings",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Settings",
        "global": "Settings",
        "filepath": "Settings.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3 c-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1 C5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4 c0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8 L9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6 C5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8 c0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "settings--adjust",
      "friendlyName": "Settings adjust",
      "aliases": [
        "preferences",
        "options",
        "alternatives",
        "gear",
        "controls"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/settings--adjust.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>settings--adjust</title>\n<path d=\"M30,8h-4.1c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2v2h14.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30V8z M21,12c-1.7,0-3-1.3-3-3\n\ts1.3-3,3-3s3,1.3,3,3S22.7,12,21,12z\"/>\n<path d=\"M2,24h4.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30v-2H15.9c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2V24z M11,20c1.7,0,3,1.3,3,3\n\ts-1.3,3-3,3s-3-1.3-3-3S9.3,20,11,20z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z\"/></svg>",
            "info": {},
            "path": "32/settings--adjust.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SettingsAdjust32",
          "filepath": "settings--adjust/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
                }
              }
            ],
            "name": "settings--adjust",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SettingsAdjust24",
          "filepath": "settings--adjust/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
                }
              }
            ],
            "name": "settings--adjust",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SettingsAdjust20",
          "filepath": "settings--adjust/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
                }
              }
            ],
            "name": "settings--adjust",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SettingsAdjust16",
          "filepath": "settings--adjust/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
                }
              }
            ],
            "name": "settings--adjust",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SettingsAdjust",
        "global": "SettingsAdjust",
        "filepath": "SettingsAdjust.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "settings--check",
      "friendlyName": "Settings check",
      "aliases": [
        "settings",
        "controls",
        "check"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/settings--check.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"23 26.18 20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z\"/><path d=\"M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z\"/><path d=\"M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z\"/></svg>",
            "info": {},
            "path": "32/settings--check.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SettingsCheck32",
          "filepath": "settings--check/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
                }
              }
            ],
            "name": "settings--check",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SettingsCheck24",
          "filepath": "settings--check/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
                }
              }
            ],
            "name": "settings--check",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SettingsCheck20",
          "filepath": "settings--check/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
                }
              }
            ],
            "name": "settings--check",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SettingsCheck16",
          "filepath": "settings--check/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
                }
              }
            ],
            "name": "settings--check",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SettingsCheck",
        "global": "SettingsCheck",
        "filepath": "SettingsCheck.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "settings--services",
      "friendlyName": "Settings services",
      "aliases": [
        "settings",
        "controls",
        "services",
        "gear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/settings--services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z\"/>\n  <path d=\"M24,30H18a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,24,30Zm-5-2h4V24H19Z\"/>\n  <path d=\"M15,19.8579A3.9934,3.9934,0,1,1,20,16h2a6,6,0,1,0-7,5.91Z\"/>\n  <path d=\"M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z\"/><path d=\"M24 30H18a1 1 0 01-1-1V23a1 1 0 011-1h6a1 1 0 011 1v6A1 1 0 0124 30zm-5-2h4V24H19zM15 19.8579A3.9934 3.9934 0 1120 16h2a6 6 0 10-7 5.91z\"/><path d=\"M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z\"/></svg>",
            "info": {},
            "path": "32/settings--services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SettingsServices32",
          "filepath": "settings--services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H18a1 1 0 01-1-1V23a1 1 0 011-1h6a1 1 0 011 1v6A1 1 0 0124 30zm-5-2h4V24H19zM15 19.8579A3.9934 3.9934 0 1120 16h2a6 6 0 10-7 5.91z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
                }
              }
            ],
            "name": "settings--services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SettingsServices24",
          "filepath": "settings--services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H18a1 1 0 01-1-1V23a1 1 0 011-1h6a1 1 0 011 1v6A1 1 0 0124 30zm-5-2h4V24H19zM15 19.8579A3.9934 3.9934 0 1120 16h2a6 6 0 10-7 5.91z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
                }
              }
            ],
            "name": "settings--services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SettingsServices20",
          "filepath": "settings--services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H18a1 1 0 01-1-1V23a1 1 0 011-1h6a1 1 0 011 1v6A1 1 0 0124 30zm-5-2h4V24H19zM15 19.8579A3.9934 3.9934 0 1120 16h2a6 6 0 10-7 5.91z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
                }
              }
            ],
            "name": "settings--services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SettingsServices16",
          "filepath": "settings--services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30H18a1 1 0 01-1-1V23a1 1 0 011-1h6a1 1 0 011 1v6A1 1 0 0124 30zm-5-2h4V24H19zM15 19.8579A3.9934 3.9934 0 1120 16h2a6 6 0 10-7 5.91z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
                }
              }
            ],
            "name": "settings--services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SettingsServices",
        "global": "SettingsServices",
        "filepath": "SettingsServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 30H18a1 1 0 01-1-1V23a1 1 0 011-1h6a1 1 0 011 1v6A1 1 0 0124 30zm-5-2h4V24H19zM15 19.8579A3.9934 3.9934 0 1120 16h2a6 6 0 10-7 5.91z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "settings--view",
      "friendlyName": "Settings view",
      "aliases": [
        "settings",
        "controls",
        "view",
        "gear",
        "eye"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/settings--view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"23\" cy=\"23.9999\" r=\"2\"/>\n  <path d=\"M30.7769,23.4785A8.64,8.64,0,0,0,23,18a8.64,8.64,0,0,0-7.7769,5.4785L15,24l.2231.5215A8.64,8.64,0,0,0,23,30a8.64,8.64,0,0,0,7.7769-5.4785L31,24ZM23,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,23,28Z\" transform=\"translate(0 -0.0001)\"/>\n  <path d=\"M12.3989,20.8A6,6,0,1,1,22,16H20a4,4,0,1,0-6.4,3.2Z\" transform=\"translate(0 -0.0001)\"/>\n  <path d=\"M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z\" transform=\"translate(0 -0.0001)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"24\" r=\"2\"/><path d=\"M30.7769 23.4785A8.64 8.64 0 0023 18a8.64 8.64 0 00-7.7769 5.4785L15 24l.2231.5215A8.64 8.64 0 0023 30a8.64 8.64 0 007.7769-5.4785L31 24zM23 28a4 4 0 114-4A4.0045 4.0045 0 0123 28zM12.3989 20.8A6 6 0 1122 16H20a4 4 0 10-6.4 3.2z\"/><path d=\"M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z\"/></svg>",
            "info": {},
            "path": "32/settings--view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SettingsView32",
          "filepath": "settings--view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.7769 23.4785A8.64 8.64 0 0023 18a8.64 8.64 0 00-7.7769 5.4785L15 24l.2231.5215A8.64 8.64 0 0023 30a8.64 8.64 0 007.7769-5.4785L31 24zM23 28a4 4 0 114-4A4.0045 4.0045 0 0123 28zM12.3989 20.8A6 6 0 1122 16H20a4 4 0 10-6.4 3.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "settings--view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SettingsView24",
          "filepath": "settings--view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.7769 23.4785A8.64 8.64 0 0023 18a8.64 8.64 0 00-7.7769 5.4785L15 24l.2231.5215A8.64 8.64 0 0023 30a8.64 8.64 0 007.7769-5.4785L31 24zM23 28a4 4 0 114-4A4.0045 4.0045 0 0123 28zM12.3989 20.8A6 6 0 1122 16H20a4 4 0 10-6.4 3.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "settings--view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SettingsView20",
          "filepath": "settings--view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.7769 23.4785A8.64 8.64 0 0023 18a8.64 8.64 0 00-7.7769 5.4785L15 24l.2231.5215A8.64 8.64 0 0023 30a8.64 8.64 0 007.7769-5.4785L31 24zM23 28a4 4 0 114-4A4.0045 4.0045 0 0123 28zM12.3989 20.8A6 6 0 1122 16H20a4 4 0 10-6.4 3.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "settings--view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SettingsView16",
          "filepath": "settings--view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.7769 23.4785A8.64 8.64 0 0023 18a8.64 8.64 0 00-7.7769 5.4785L15 24l.2231.5215A8.64 8.64 0 0023 30a8.64 8.64 0 007.7769-5.4785L31 24zM23 28a4 4 0 114-4A4.0045 4.0045 0 0123 28zM12.3989 20.8A6 6 0 1122 16H20a4 4 0 10-6.4 3.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                }
              }
            ],
            "name": "settings--view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SettingsView",
        "global": "SettingsView",
        "filepath": "SettingsView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.7769 23.4785A8.64 8.64 0 0023 18a8.64 8.64 0 00-7.7769 5.4785L15 24l.2231.5215A8.64 8.64 0 0023 30a8.64 8.64 0 007.7769-5.4785L31 24zM23 28a4 4 0 114-4A4.0045 4.0045 0 0123 28zM12.3989 20.8A6 6 0 1122 16H20a4 4 0 10-6.4 3.2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shape--except",
      "friendlyName": "Shape except",
      "aliases": [
        "shape except",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shape--except.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z\"/></svg>",
            "info": {},
            "path": "32/shape--except.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShapeExcept32",
          "filepath": "shape--except/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
                }
              }
            ],
            "name": "shape--except",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShapeExcept24",
          "filepath": "shape--except/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
                }
              }
            ],
            "name": "shape--except",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShapeExcept20",
          "filepath": "shape--except/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
                }
              }
            ],
            "name": "shape--except",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShapeExcept16",
          "filepath": "shape--except/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
                }
              }
            ],
            "name": "shape--except",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ShapeExcept",
        "global": "ShapeExcept",
        "filepath": "ShapeExcept.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shape--exclude",
      "friendlyName": "Shape exclude",
      "aliases": [
        "shape exclude",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shape--exclude.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z\"/>\n  <path d=\"M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z\"/><path d=\"M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z\"/></svg>",
            "info": {},
            "path": "32/shape--exclude.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShapeExclude32",
          "filepath": "shape--exclude/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--exclude",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShapeExclude24",
          "filepath": "shape--exclude/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--exclude",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShapeExclude20",
          "filepath": "shape--exclude/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--exclude",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShapeExclude16",
          "filepath": "shape--exclude/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--exclude",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ShapeExclude",
        "global": "ShapeExclude",
        "filepath": "ShapeExclude.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shape--intersect",
      "friendlyName": "Shape intersect",
      "aliases": [
        "shape intersect",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shape--intersect.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z\"/></svg>",
            "info": {},
            "path": "32/shape--intersect.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShapeIntersect32",
          "filepath": "shape--intersect/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
                }
              }
            ],
            "name": "shape--intersect",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShapeIntersect24",
          "filepath": "shape--intersect/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
                }
              }
            ],
            "name": "shape--intersect",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShapeIntersect20",
          "filepath": "shape--intersect/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
                }
              }
            ],
            "name": "shape--intersect",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShapeIntersect16",
          "filepath": "shape--intersect/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
                }
              }
            ],
            "name": "shape--intersect",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ShapeIntersect",
        "global": "ShapeIntersect",
        "filepath": "ShapeIntersect.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shape--join",
      "friendlyName": "Shape join",
      "aliases": [
        "shape",
        "join",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shape--join.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z\"/></svg>",
            "info": {},
            "path": "32/shape--join.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShapeJoin32",
          "filepath": "shape--join/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
                }
              }
            ],
            "name": "shape--join",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShapeJoin24",
          "filepath": "shape--join/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
                }
              }
            ],
            "name": "shape--join",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShapeJoin20",
          "filepath": "shape--join/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
                }
              }
            ],
            "name": "shape--join",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShapeJoin16",
          "filepath": "shape--join/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
                }
              }
            ],
            "name": "shape--join",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ShapeJoin",
        "global": "ShapeJoin",
        "filepath": "ShapeJoin.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shape--unite",
      "friendlyName": "Shape unite",
      "aliases": [
        "shape unite",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shape--unite.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z\"/></svg>",
            "info": {},
            "path": "32/shape--unite.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShapeUnite32",
          "filepath": "shape--unite/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--unite",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShapeUnite24",
          "filepath": "shape--unite/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--unite",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShapeUnite20",
          "filepath": "shape--unite/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--unite",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShapeUnite16",
          "filepath": "shape--unite/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                }
              }
            ],
            "name": "shape--unite",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "ShapeUnite",
        "global": "ShapeUnite",
        "filepath": "ShapeUnite.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "share",
      "friendlyName": "Share",
      "aliases": [
        "social media",
        "facebook",
        "twitter",
        "media",
        "social",
        "network",
        "nodes",
        "connect"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/share.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>share</title><path d=\"M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(0 32) rotate(-90)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z\"/></svg>",
            "info": {},
            "path": "32/share.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Share32",
          "filepath": "share/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
                }
              }
            ],
            "name": "share",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Share24",
          "filepath": "share/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
                }
              }
            ],
            "name": "share",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Share20",
          "filepath": "share/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
                }
              }
            ],
            "name": "share",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Share16",
          "filepath": "share/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
                }
              }
            ],
            "name": "share",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Share",
        "global": "Share",
        "filepath": "Share.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "share-knowledge",
      "friendlyName": "Share knowledge",
      "aliases": [
        "people",
        "communicate",
        "idea",
        "contribution",
        "brainstorm",
        "thinking",
        "knowledge",
        "exchange"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/share-knowledge.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>share-knowledge</title><path d=\"M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z\" transform=\"translate(0 0)\"/><path d=\"M20,20a4,4,0,1,0,4-4A4,4,0,0,0,20,20Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,26,20Z\" transform=\"translate(0 0)\"/><path d=\"M6,21V20H4v1a7,7,0,0,0,7,7h3V26H11A5,5,0,0,1,6,21Z\" transform=\"translate(0 0)\"/><rect x=\"19\" y=\"10\" width=\"7\" height=\"2\"/><rect x=\"19\" y=\"6\" width=\"10\" height=\"2\"/><rect x=\"19\" y=\"2\" width=\"10\" height=\"2\"/><path d=\"M11,11H5a3,3,0,0,0-3,3v2H4V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V14A3,3,0,0,0,11,11Z\" transform=\"translate(0 0)\"/><path d=\"M8,10A4,4,0,1,0,4,6,4,4,0,0,0,8,10ZM8,4A2,2,0,1,1,6,6,2,2,0,0,1,8,4Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z\"/></svg>",
            "info": {},
            "path": "32/share-knowledge.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShareKnowledge32",
          "filepath": "share-knowledge/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
                }
              }
            ],
            "name": "share-knowledge",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShareKnowledge24",
          "filepath": "share-knowledge/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
                }
              }
            ],
            "name": "share-knowledge",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShareKnowledge20",
          "filepath": "share-knowledge/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
                }
              }
            ],
            "name": "share-knowledge",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShareKnowledge16",
          "filepath": "share-knowledge/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
                }
              }
            ],
            "name": "share-knowledge",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ShareKnowledge",
        "global": "ShareKnowledge",
        "filepath": "ShareKnowledge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--bag",
      "friendlyName": "Shopping bag",
      "aliases": [
        "bag",
        "cart",
        "shop",
        "buy",
        "e-commerce",
        "purchase",
        "store",
        "retail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--bag.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>shopping--bag</title><path d=\"M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z\"/></svg>",
            "info": {},
            "path": "32/shopping--bag.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingBag32",
          "filepath": "shopping--bag/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
                }
              }
            ],
            "name": "shopping--bag",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingBag24",
          "filepath": "shopping--bag/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
                }
              }
            ],
            "name": "shopping--bag",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingBag20",
          "filepath": "shopping--bag/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
                }
              }
            ],
            "name": "shopping--bag",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingBag16",
          "filepath": "shopping--bag/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
                }
              }
            ],
            "name": "shopping--bag",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingBag",
        "global": "ShoppingBag",
        "filepath": "ShoppingBag.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--cart",
      "friendlyName": "Shopping cart",
      "aliases": [
        "bag",
        "cart",
        "shop",
        "buy",
        "e-commerce",
        "purchase",
        "store",
        "retail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--cart.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>shopping--cart</title><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z\"/></svg>",
            "info": {},
            "path": "32/shopping--cart.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCart32",
          "filepath": "shopping--cart/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
                }
              }
            ],
            "name": "shopping--cart",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCart24",
          "filepath": "shopping--cart/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
                }
              }
            ],
            "name": "shopping--cart",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCart20",
          "filepath": "shopping--cart/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
                }
              }
            ],
            "name": "shopping--cart",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCart16",
          "filepath": "shopping--cart/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
                }
              }
            ],
            "name": "shopping--cart",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCart",
        "global": "ShoppingCart",
        "filepath": "ShoppingCart.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--cart--arrow-down",
      "friendlyName": "Shopping cart arrow down",
      "aliases": [
        "cart",
        "shop",
        "buy",
        "e-commerce",
        "purchase",
        "store",
        "retail",
        "add to cart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--cart--arrow-down.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"10\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"24\" cy=\"28\" r=\"2\"/>\n  <path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\" transform=\"translate(0)\"/>\n  <polygon points=\"21.586 6.586 18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\"/><path d=\"M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z\"/></svg>",
            "info": {},
            "path": "32/shopping--cart--arrow-down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCartArrowDown32",
          "filepath": "shopping--cart--arrow-down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
                }
              }
            ],
            "name": "shopping--cart--arrow-down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCartArrowDown24",
          "filepath": "shopping--cart--arrow-down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
                }
              }
            ],
            "name": "shopping--cart--arrow-down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCartArrowDown20",
          "filepath": "shopping--cart--arrow-down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
                }
              }
            ],
            "name": "shopping--cart--arrow-down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCartArrowDown16",
          "filepath": "shopping--cart--arrow-down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
                }
              }
            ],
            "name": "shopping--cart--arrow-down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCartArrowDown",
        "global": "ShoppingCartArrowDown",
        "filepath": "ShoppingCartArrowDown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--cart--arrow-up",
      "friendlyName": "Shopping cart arrow up",
      "aliases": [
        "cart",
        "shop",
        "remove",
        "e-commerce",
        "purchase",
        "store",
        "retail",
        "remove from cart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--cart--arrow-up.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"10\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"24\" cy=\"28\" r=\"2\"/>\n  <path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\" transform=\"translate(0)\"/>\n  <polygon points=\"21.586 9.414 18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\"/><path d=\"M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z\"/></svg>",
            "info": {},
            "path": "32/shopping--cart--arrow-up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCartArrowUp32",
          "filepath": "shopping--cart--arrow-up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
                }
              }
            ],
            "name": "shopping--cart--arrow-up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCartArrowUp24",
          "filepath": "shopping--cart--arrow-up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
                }
              }
            ],
            "name": "shopping--cart--arrow-up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCartArrowUp20",
          "filepath": "shopping--cart--arrow-up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
                }
              }
            ],
            "name": "shopping--cart--arrow-up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCartArrowUp16",
          "filepath": "shopping--cart--arrow-up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
                }
              }
            ],
            "name": "shopping--cart--arrow-up",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCartArrowUp",
        "global": "ShoppingCartArrowUp",
        "filepath": "ShoppingCartArrowUp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--cart--clear",
      "friendlyName": "Shopping cart clear",
      "aliases": [
        "cart",
        "shop",
        "empty",
        "e-commerce",
        "remove",
        "store",
        "retail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--cart--clear.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"10\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"24\" cy=\"28\" r=\"2\"/>\n  <path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\" transform=\"translate(0)\"/>\n  <polygon points=\"18.41 8 22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\"/><path d=\"M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z\"/></svg>",
            "info": {},
            "path": "32/shopping--cart--clear.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCartClear32",
          "filepath": "shopping--cart--clear/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
                }
              }
            ],
            "name": "shopping--cart--clear",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCartClear24",
          "filepath": "shopping--cart--clear/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
                }
              }
            ],
            "name": "shopping--cart--clear",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCartClear20",
          "filepath": "shopping--cart--clear/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
                }
              }
            ],
            "name": "shopping--cart--clear",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCartClear16",
          "filepath": "shopping--cart--clear/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
                }
              }
            ],
            "name": "shopping--cart--clear",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCartClear",
        "global": "ShoppingCartClear",
        "filepath": "ShoppingCartClear.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--cart--error",
      "friendlyName": "Shopping cart error",
      "aliases": [
        "cart",
        "shop",
        "error",
        "e-commerce",
        "incomplete",
        "store",
        "retail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--cart--error.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"10\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"24\" cy=\"28\" r=\"2\"/>\n  <path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\" transform=\"translate(0)\"/>\n  <path d=\"M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\"/><path d=\"M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z\"/></svg>",
            "info": {},
            "path": "32/shopping--cart--error.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCartError32",
          "filepath": "shopping--cart--error/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
                }
              }
            ],
            "name": "shopping--cart--error",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCartError24",
          "filepath": "shopping--cart--error/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
                }
              }
            ],
            "name": "shopping--cart--error",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCartError20",
          "filepath": "shopping--cart--error/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
                }
              }
            ],
            "name": "shopping--cart--error",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCartError16",
          "filepath": "shopping--cart--error/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
                }
              }
            ],
            "name": "shopping--cart--error",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCartError",
        "global": "ShoppingCartError",
        "filepath": "ShoppingCartError.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--cart--minus",
      "friendlyName": "Shopping cart minus",
      "aliases": [
        "cart",
        "shop",
        "remove",
        "e-commerce",
        "store",
        "retail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--cart--minus.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"10\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"24\" cy=\"28\" r=\"2\"/>\n  <path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\" transform=\"translate(0)\"/>\n  <polygon points=\"12 6 12 8 22 8 22 6 12 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\"/><path d=\"M12 6L12 8 22 8 22 6 12 6z\"/></svg>",
            "info": {},
            "path": "32/shopping--cart--minus.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCartMinus32",
          "filepath": "shopping--cart--minus/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L12 8 22 8 22 6 12 6z"
                }
              }
            ],
            "name": "shopping--cart--minus",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCartMinus24",
          "filepath": "shopping--cart--minus/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L12 8 22 8 22 6 12 6z"
                }
              }
            ],
            "name": "shopping--cart--minus",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCartMinus20",
          "filepath": "shopping--cart--minus/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L12 8 22 8 22 6 12 6z"
                }
              }
            ],
            "name": "shopping--cart--minus",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCartMinus16",
          "filepath": "shopping--cart--minus/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6L12 8 22 8 22 6 12 6z"
                }
              }
            ],
            "name": "shopping--cart--minus",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCartMinus",
        "global": "ShoppingCartMinus",
        "filepath": "ShoppingCartMinus.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 6L12 8 22 8 22 6 12 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--cart--plus",
      "friendlyName": "Shopping cart plus",
      "aliases": [
        "cart",
        "shop",
        "buy",
        "e-commerce",
        "purchase",
        "store",
        "retail",
        "cart plus",
        "add to cart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--cart--plus.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"10\" cy=\"28\" r=\"2\"/>\n  <circle cx=\"24\" cy=\"28\" r=\"2\"/>\n  <path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\" transform=\"translate(0)\"/>\n  <polygon points=\"18 6 18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"28\" r=\"2\"/><circle cx=\"24\" cy=\"28\" r=\"2\"/><path d=\"M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z\"/><path d=\"M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z\"/></svg>",
            "info": {},
            "path": "32/shopping--cart--plus.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCartPlus32",
          "filepath": "shopping--cart--plus/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
                }
              }
            ],
            "name": "shopping--cart--plus",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCartPlus24",
          "filepath": "shopping--cart--plus/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
                }
              }
            ],
            "name": "shopping--cart--plus",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCartPlus20",
          "filepath": "shopping--cart--plus/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
                }
              }
            ],
            "name": "shopping--cart--plus",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCartPlus16",
          "filepath": "shopping--cart--plus/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
                }
              }
            ],
            "name": "shopping--cart--plus",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCartPlus",
        "global": "ShoppingCartPlus",
        "filepath": "ShoppingCartPlus.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shopping--catalog",
      "friendlyName": "Shopping catalog",
      "aliases": [
        "bag",
        "cart",
        "shop",
        "buy",
        "e-commerce",
        "purchase",
        "store",
        "retail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shopping--catalog.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>catalog</title>\n<rect x=\"17\" y=\"24\" width=\"4\" height=\"4\"/>\n<rect x=\"24\" y=\"24\" width=\"4\" height=\"4\"/>\n<rect x=\"17\" y=\"17\" width=\"4\" height=\"4\"/>\n<rect x=\"24\" y=\"17\" width=\"4\" height=\"4\"/>\n<path d=\"M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\n\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z\"/><path d=\"M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z\"/></svg>",
            "info": {},
            "path": "32/shopping--catalog.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShoppingCatalog32",
          "filepath": "shopping--catalog/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
                }
              }
            ],
            "name": "shopping--catalog",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShoppingCatalog24",
          "filepath": "shopping--catalog/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
                }
              }
            ],
            "name": "shopping--catalog",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShoppingCatalog20",
          "filepath": "shopping--catalog/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
                }
              }
            ],
            "name": "shopping--catalog",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShoppingCatalog16",
          "filepath": "shopping--catalog/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
                }
              }
            ],
            "name": "shopping--catalog",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ShoppingCatalog",
        "global": "ShoppingCatalog",
        "filepath": "ShoppingCatalog.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2 H6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "show-data--cards",
      "friendlyName": "Show-data cards",
      "aliases": [
        "cards",
        "show-data",
        "show",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/show-data--cards.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,10H4A2.0022,2.0022,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V8A2.0022,2.0022,0,0,1,28,10ZM4,4V8H28V4Z\" transform=\"translate(0 -0.0001)\"/>\n  <path d=\"M28,30H4a2.0022,2.0022,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v4A2.0022,2.0022,0,0,1,28,30ZM4,24v4H28V24Z\" transform=\"translate(0 -0.0001)\"/>\n  <path d=\"M28,20H4a2.0022,2.0022,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v4A2.0022,2.0022,0,0,1,28,20ZM4,14v4H28V14Z\" transform=\"translate(0 -0.0001)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 10H4A2.0022 2.0022 0 012 8V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2V8A2.0022 2.0022 0 0128 10zM4 4V8H28V4zM28 30H4a2.0022 2.0022 0 01-2-2V24a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 30zM4 24v4H28V24zM28 20H4a2.0022 2.0022 0 01-2-2V14a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 20zM4 14v4H28V14z\"/></svg>",
            "info": {},
            "path": "32/show-data--cards.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShowDataCards32",
          "filepath": "show-data--cards/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H4A2.0022 2.0022 0 012 8V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2V8A2.0022 2.0022 0 0128 10zM4 4V8H28V4zM28 30H4a2.0022 2.0022 0 01-2-2V24a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 30zM4 24v4H28V24zM28 20H4a2.0022 2.0022 0 01-2-2V14a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 20zM4 14v4H28V14z"
                }
              }
            ],
            "name": "show-data--cards",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShowDataCards24",
          "filepath": "show-data--cards/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H4A2.0022 2.0022 0 012 8V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2V8A2.0022 2.0022 0 0128 10zM4 4V8H28V4zM28 30H4a2.0022 2.0022 0 01-2-2V24a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 30zM4 24v4H28V24zM28 20H4a2.0022 2.0022 0 01-2-2V14a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 20zM4 14v4H28V14z"
                }
              }
            ],
            "name": "show-data--cards",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShowDataCards20",
          "filepath": "show-data--cards/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H4A2.0022 2.0022 0 012 8V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2V8A2.0022 2.0022 0 0128 10zM4 4V8H28V4zM28 30H4a2.0022 2.0022 0 01-2-2V24a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 30zM4 24v4H28V24zM28 20H4a2.0022 2.0022 0 01-2-2V14a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 20zM4 14v4H28V14z"
                }
              }
            ],
            "name": "show-data--cards",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShowDataCards16",
          "filepath": "show-data--cards/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 10H4A2.0022 2.0022 0 012 8V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2V8A2.0022 2.0022 0 0128 10zM4 4V8H28V4zM28 30H4a2.0022 2.0022 0 01-2-2V24a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 30zM4 24v4H28V24zM28 20H4a2.0022 2.0022 0 01-2-2V14a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 20zM4 14v4H28V14z"
                }
              }
            ],
            "name": "show-data--cards",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ShowDataCards",
        "global": "ShowDataCards",
        "filepath": "ShowDataCards.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 10H4A2.0022 2.0022 0 012 8V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2V8A2.0022 2.0022 0 0128 10zM4 4V8H28V4zM28 30H4a2.0022 2.0022 0 01-2-2V24a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 30zM4 24v4H28V24zM28 20H4a2.0022 2.0022 0 01-2-2V14a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 20zM4 14v4H28V14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shrink-screen",
      "friendlyName": "Shrink screen",
      "aliases": [
        "minimize",
        "resize",
        "arrow",
        "smaller",
        "reduce",
        "shrink",
        "screen",
        "zoom out"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shrink-screen.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>shrink-screen</title><path d=\"M28,28H17a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2H28a2.0027,2.0027,0,0,1,2,2v6A2.0027,2.0027,0,0,1,28,28ZM17,20v6H28.002L28,20Z\"/><polygon points=\"12 10 12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10\"/><path d=\"M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z\"/><path d=\"M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z\"/></svg>",
            "info": {},
            "path": "32/shrink-screen.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShrinkScreen32",
          "filepath": "shrink-screen/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShrinkScreen24",
          "filepath": "shrink-screen/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShrinkScreen20",
          "filepath": "shrink-screen/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShrinkScreen16",
          "filepath": "shrink-screen/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "ShrinkScreen",
        "global": "ShrinkScreen",
        "filepath": "ShrinkScreen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shrink-screen--filled",
      "friendlyName": "Shrink screen filled",
      "aliases": [
        "minimize",
        "resize",
        "arrow",
        "smaller",
        "reduce",
        "shrink",
        "screen",
        "zoom out"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shrink-screen--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>shrink-screen--filled</title><rect x=\"15\" y=\"18\" width=\"15\" height=\"10\" rx=\"2\"/><polygon points=\"12 10 12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10\"/><path d=\"M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><rect width=\"15\" height=\"10\" x=\"15\" y=\"18\" rx=\"2\"/><path d=\"M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z\"/><path d=\"M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z\"/></svg>",
            "info": {},
            "path": "32/shrink-screen--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ShrinkScreenFilled32",
          "filepath": "shrink-screen--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "15",
                  "height": "10",
                  "x": "15",
                  "y": "18",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ShrinkScreenFilled24",
          "filepath": "shrink-screen--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "15",
                  "height": "10",
                  "x": "15",
                  "y": "18",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ShrinkScreenFilled20",
          "filepath": "shrink-screen--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "15",
                  "height": "10",
                  "x": "15",
                  "y": "18",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ShrinkScreenFilled16",
          "filepath": "shrink-screen--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "15",
                  "height": "10",
                  "x": "15",
                  "y": "18",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                }
              }
            ],
            "name": "shrink-screen--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "ShrinkScreenFilled",
        "global": "ShrinkScreenFilled",
        "filepath": "ShrinkScreenFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "rect",
                  "attributes": {
                    "width": "15",
                    "height": "10",
                    "x": "15",
                    "y": "18",
                    "rx": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shuffle",
      "friendlyName": "Shuffle",
      "aliases": [
        "move",
        "reorder",
        "cross arrows",
        "randomize",
        "random",
        "songs",
        "player",
        "music",
        "multimedia"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shuffle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>shuffle</title><path d=\"M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z\"/></svg>",
            "info": {},
            "path": "32/shuffle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Shuffle32",
          "filepath": "shuffle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
                }
              }
            ],
            "name": "shuffle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Shuffle24",
          "filepath": "shuffle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
                }
              }
            ],
            "name": "shuffle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Shuffle20",
          "filepath": "shuffle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
                }
              }
            ],
            "name": "shuffle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Shuffle16",
          "filepath": "shuffle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
                }
              }
            ],
            "name": "shuffle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Shuffle",
        "global": "Shuffle",
        "filepath": "Shuffle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "shuttle",
      "friendlyName": "Shuttle",
      "aliases": [
        "bus",
        "truck",
        "transportation",
        "transit",
        "vehicle",
        "delivery",
        "car"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/shuttle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>shuttle</title><path d=\"M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z\"/></svg>",
            "info": {},
            "path": "32/shuttle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Shuttle32",
          "filepath": "shuttle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
                }
              }
            ],
            "name": "shuttle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Shuttle24",
          "filepath": "shuttle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
                }
              }
            ],
            "name": "shuttle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Shuttle20",
          "filepath": "shuttle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
                }
              }
            ],
            "name": "shuttle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Shuttle16",
          "filepath": "shuttle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
                }
              }
            ],
            "name": "shuttle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Shuttle",
        "global": "Shuttle",
        "filepath": "Shuttle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "side-panel--close",
      "friendlyName": "side-panel--close",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/side-panel--close.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8\n\tl3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8\tl3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z\"/></svg>",
            "info": {},
            "path": "32/side-panel--close.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SidePanelClose32",
          "filepath": "side-panel--close/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8\tl3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SidePanelClose24",
          "filepath": "side-panel--close/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8\tl3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SidePanelClose20",
          "filepath": "side-panel--close/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8\tl3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SidePanelClose16",
          "filepath": "side-panel--close/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8\tl3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SidePanelClose",
        "global": "SidePanelClose",
        "filepath": "SidePanelClose.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8 l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "side-panel--close--filled",
      "friendlyName": "side-panel--close--filled",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/side-panel--close--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6\n\tl1.4-1.4L17.8,17H28v9H12V6h16V15z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6\tl1.4-1.4L17.8,17H28v9H12V6h16V15z\"/></svg>",
            "info": {},
            "path": "32/side-panel--close--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SidePanelCloseFilled32",
          "filepath": "side-panel--close--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6\tl1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SidePanelCloseFilled24",
          "filepath": "side-panel--close--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6\tl1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SidePanelCloseFilled20",
          "filepath": "side-panel--close--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6\tl1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SidePanelCloseFilled16",
          "filepath": "side-panel--close--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6\tl1.4-1.4L17.8,17H28v9H12V6h16V15z"
                }
              }
            ],
            "name": "side-panel--close--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SidePanelCloseFilled",
        "global": "SidePanelCloseFilled",
        "filepath": "SidePanelCloseFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6 l1.4-1.4L17.8,17H28v9H12V6h16V15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "side-panel--open",
      "friendlyName": "side-panel--open",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/side-panel--open.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2\n\tl-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2\tl-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z\"/></svg>",
            "info": {},
            "path": "32/side-panel--open.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SidePanelOpen32",
          "filepath": "side-panel--open/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2\tl-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SidePanelOpen24",
          "filepath": "side-panel--open/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2\tl-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SidePanelOpen20",
          "filepath": "side-panel--open/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2\tl-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SidePanelOpen16",
          "filepath": "side-panel--open/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2\tl-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SidePanelOpen",
        "global": "SidePanelOpen",
        "filepath": "SidePanelOpen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2 l-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "side-panel--open--filled",
      "friendlyName": "side-panel--open--filled",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/side-panel--open--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22\n\tl6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22\tl6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z\"/></svg>",
            "info": {},
            "path": "32/side-panel--open--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SidePanelOpenFilled32",
          "filepath": "side-panel--open--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22\tl6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SidePanelOpenFilled24",
          "filepath": "side-panel--open--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22\tl6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SidePanelOpenFilled20",
          "filepath": "side-panel--open--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22\tl6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SidePanelOpenFilled16",
          "filepath": "side-panel--open--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22\tl6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                }
              }
            ],
            "name": "side-panel--open--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SidePanelOpenFilled",
        "global": "SidePanelOpenFilled",
        "filepath": "SidePanelOpenFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22 l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sight",
      "friendlyName": "Sight",
      "aliases": [
        "sight",
        "vision",
        "see",
        "eyescan",
        "visual",
        "user"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sight.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"10\" y=\"12\" width=\"2\" height=\"2\"/>\n  <rect x=\"6\" y=\"12\" width=\"2\" height=\"2\"/>\n  <rect x=\"2\" y=\"12\" width=\"2\" height=\"2\"/>\n  <path d=\"M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z\"/>\n  <rect x=\"19.0001\" y=\"12\" width=\"4\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 12H12V14H10zM6 12H8V14H6zM2 12H4V14H2zM26 30H24V27H20a5.0055 5.0055 0 01-5-5V20.7207l-2.3162-.772a1 1 0 01-.5412-1.4631L15 13.7229V11a9.01 9.01 0 019-9h5V4H24a7.0078 7.0078 0 00-7 7v3a.9991.9991 0 01-.1426.5144l-2.3586 3.9312 1.8174.6057A1 1 0 0117 20v2a3.0033 3.0033 0 003 3h5a1 1 0 011 1z\"/><path d=\"M19 12H23V14H19z\"/></svg>",
            "info": {},
            "path": "32/sight.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sight32",
          "filepath": "sight/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H12V14H10zM6 12H8V14H6zM2 12H4V14H2zM26 30H24V27H20a5.0055 5.0055 0 01-5-5V20.7207l-2.3162-.772a1 1 0 01-.5412-1.4631L15 13.7229V11a9.01 9.01 0 019-9h5V4H24a7.0078 7.0078 0 00-7 7v3a.9991.9991 0 01-.1426.5144l-2.3586 3.9312 1.8174.6057A1 1 0 0117 20v2a3.0033 3.0033 0 003 3h5a1 1 0 011 1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "sight",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sight24",
          "filepath": "sight/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H12V14H10zM6 12H8V14H6zM2 12H4V14H2zM26 30H24V27H20a5.0055 5.0055 0 01-5-5V20.7207l-2.3162-.772a1 1 0 01-.5412-1.4631L15 13.7229V11a9.01 9.01 0 019-9h5V4H24a7.0078 7.0078 0 00-7 7v3a.9991.9991 0 01-.1426.5144l-2.3586 3.9312 1.8174.6057A1 1 0 0117 20v2a3.0033 3.0033 0 003 3h5a1 1 0 011 1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "sight",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sight20",
          "filepath": "sight/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H12V14H10zM6 12H8V14H6zM2 12H4V14H2zM26 30H24V27H20a5.0055 5.0055 0 01-5-5V20.7207l-2.3162-.772a1 1 0 01-.5412-1.4631L15 13.7229V11a9.01 9.01 0 019-9h5V4H24a7.0078 7.0078 0 00-7 7v3a.9991.9991 0 01-.1426.5144l-2.3586 3.9312 1.8174.6057A1 1 0 0117 20v2a3.0033 3.0033 0 003 3h5a1 1 0 011 1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "sight",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sight16",
          "filepath": "sight/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H12V14H10zM6 12H8V14H6zM2 12H4V14H2zM26 30H24V27H20a5.0055 5.0055 0 01-5-5V20.7207l-2.3162-.772a1 1 0 01-.5412-1.4631L15 13.7229V11a9.01 9.01 0 019-9h5V4H24a7.0078 7.0078 0 00-7 7v3a.9991.9991 0 01-.1426.5144l-2.3586 3.9312 1.8174.6057A1 1 0 0117 20v2a3.0033 3.0033 0 003 3h5a1 1 0 011 1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19z"
                }
              }
            ],
            "name": "sight",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Sight",
        "global": "Sight",
        "filepath": "Sight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 12H12V14H10zM6 12H8V14H6zM2 12H4V14H2zM26 30H24V27H20a5.0055 5.0055 0 01-5-5V20.7207l-2.3162-.772a1 1 0 01-.5412-1.4631L15 13.7229V11a9.01 9.01 0 019-9h5V4H24a7.0078 7.0078 0 00-7 7v3a.9991.9991 0 01-.1426.5144l-2.3586 3.9312 1.8174.6057A1 1 0 0117 20v2a3.0033 3.0033 0 003 3h5a1 1 0 011 1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 12H23V14H19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sigma",
      "friendlyName": "Sigma",
      "aliases": [
        "sigma",
        "summary"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sigma.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"24 5 7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z\"/></svg>",
            "info": {},
            "path": "32/sigma.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sigma32",
          "filepath": "sigma/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
                }
              }
            ],
            "name": "sigma",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sigma24",
          "filepath": "sigma/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
                }
              }
            ],
            "name": "sigma",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sigma20",
          "filepath": "sigma/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
                }
              }
            ],
            "name": "sigma",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sigma16",
          "filepath": "sigma/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
                }
              }
            ],
            "name": "sigma",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Alphanumeric",
      "moduleInfo": {
        "local": "Sigma",
        "global": "Sigma",
        "filepath": "Sigma.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "signal-strength",
      "friendlyName": "Signal strength",
      "aliases": [
        "signal strength",
        "technology"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/signal-strength.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #1d1d1d;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect class=\"cls-1\" x=\"26\" y=\"6\" width=\"2\" height=\"20\"/>\n  <rect class=\"cls-1\" x=\"18\" y=\"11\" width=\"2\" height=\"15\"/>\n  <rect class=\"cls-1\" x=\"11\" y=\"16\" width=\"2\" height=\"10\"/>\n  <rect class=\"cls-1\" x=\"4\" y=\"20\" width=\"2\" height=\"6\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 6H28V26H26zM18 11H20V26H18zM11 16H13V26H11zM4 20H6V26H4z\"/></svg>",
            "info": {},
            "path": "32/signal-strength.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SignalStrength32",
          "filepath": "signal-strength/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6H28V26H26zM18 11H20V26H18zM11 16H13V26H11zM4 20H6V26H4z"
                }
              }
            ],
            "name": "signal-strength",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SignalStrength24",
          "filepath": "signal-strength/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6H28V26H26zM18 11H20V26H18zM11 16H13V26H11zM4 20H6V26H4z"
                }
              }
            ],
            "name": "signal-strength",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SignalStrength20",
          "filepath": "signal-strength/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6H28V26H26zM18 11H20V26H18zM11 16H13V26H11zM4 20H6V26H4z"
                }
              }
            ],
            "name": "signal-strength",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SignalStrength16",
          "filepath": "signal-strength/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6H28V26H26zM18 11H20V26H18zM11 16H13V26H11zM4 20H6V26H4z"
                }
              }
            ],
            "name": "signal-strength",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "SignalStrength",
        "global": "SignalStrength",
        "filepath": "SignalStrength.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 6H28V26H26zM18 11H20V26H18zM11 16H13V26H11zM4 20H6V26H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sim-card",
      "friendlyName": "SIM card",
      "aliases": [
        "SIM",
        "chip",
        "subscriber",
        "identity",
        "module"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sim-card.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z\"/><path d=\"M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z\"/></svg>",
            "info": {},
            "path": "32/sim-card.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SimCard32",
          "filepath": "sim-card/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
                }
              }
            ],
            "name": "sim-card",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SimCard24",
          "filepath": "sim-card/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
                }
              }
            ],
            "name": "sim-card",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SimCard20",
          "filepath": "sim-card/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
                }
              }
            ],
            "name": "sim-card",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SimCard16",
          "filepath": "sim-card/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
                }
              }
            ],
            "name": "sim-card",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "SimCard",
        "global": "SimCard",
        "filepath": "SimCard.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skill-level",
      "friendlyName": "Skill level",
      "aliases": [
        "skill level",
        "scale"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skill-level.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>skill-level</title><path d=\"M30,30H22V4h8Zm-6-2h4V6H24Z\"/><path d=\"M20,30H12V12h8Zm-6-2h4V14H14Z\"/><path d=\"M10,30H2V18h8ZM4,28H8V20H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8zM4 28H8V20H4z\"/></svg>",
            "info": {},
            "path": "32/skill-level.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkillLevel32",
          "filepath": "skill-level/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8zM4 28H8V20H4z"
                }
              }
            ],
            "name": "skill-level",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkillLevel24",
          "filepath": "skill-level/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8zM4 28H8V20H4z"
                }
              }
            ],
            "name": "skill-level",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkillLevel20",
          "filepath": "skill-level/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8zM4 28H8V20H4z"
                }
              }
            ],
            "name": "skill-level",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkillLevel16",
          "filepath": "skill-level/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8zM4 28H8V20H4z"
                }
              }
            ],
            "name": "skill-level",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SkillLevel",
        "global": "SkillLevel",
        "filepath": "SkillLevel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8zM4 28H8V20H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skill-level--advanced",
      "friendlyName": "Skill level advanced",
      "aliases": [
        "skill level advanced",
        "scale"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skill-level--advanced.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>skill-level--advanced</title>\n  <path d=\"M30,30H22V4h8Z\"/>\n  <path d=\"M20,30H12V12h8Z\"/>\n  <path d=\"M10,30H2V18h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H22V4h8zM20 30H12V12h8zM10 30H2V18h8z\"/></svg>",
            "info": {},
            "path": "32/skill-level--advanced.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkillLevelAdvanced32",
          "filepath": "skill-level--advanced/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--advanced",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkillLevelAdvanced24",
          "filepath": "skill-level--advanced/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--advanced",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkillLevelAdvanced20",
          "filepath": "skill-level--advanced/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--advanced",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkillLevelAdvanced16",
          "filepath": "skill-level--advanced/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--advanced",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SkillLevelAdvanced",
        "global": "SkillLevelAdvanced",
        "filepath": "SkillLevelAdvanced.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H22V4h8zM20 30H12V12h8zM10 30H2V18h8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skill-level--basic",
      "friendlyName": "Skill level basic",
      "aliases": [
        "skill level basic",
        "scale"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skill-level--basic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>skill-level--basic</title>\n  <path d=\"M30,30H22V4h8Zm-6-2h4V6H24Z\"/>\n  <path d=\"M20,30H12V12h8Zm-6-2h4V14H14Z\"/>\n  <path d=\"M10,30H2V18h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8z\"/></svg>",
            "info": {},
            "path": "32/skill-level--basic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkillLevelBasic32",
          "filepath": "skill-level--basic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--basic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkillLevelBasic24",
          "filepath": "skill-level--basic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--basic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkillLevelBasic20",
          "filepath": "skill-level--basic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--basic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkillLevelBasic16",
          "filepath": "skill-level--basic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--basic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SkillLevelBasic",
        "global": "SkillLevelBasic",
        "filepath": "SkillLevelBasic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skill-level--intermediate",
      "friendlyName": "Skill level intermediate",
      "aliases": [
        "skill level intermediate",
        "scale"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skill-level--intermediate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>skill-level--intermediate</title>\n  <path d=\"M30,30H22V4h8Zm-6-2h4V6H24Z\"/>\n  <path d=\"M20,30H12V12h8Z\"/>\n  <path d=\"M10,30H2V18h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zM10 30H2V18h8z\"/></svg>",
            "info": {},
            "path": "32/skill-level--intermediate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkillLevelIntermediate32",
          "filepath": "skill-level--intermediate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--intermediate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkillLevelIntermediate24",
          "filepath": "skill-level--intermediate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--intermediate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkillLevelIntermediate20",
          "filepath": "skill-level--intermediate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--intermediate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkillLevelIntermediate16",
          "filepath": "skill-level--intermediate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zM10 30H2V18h8z"
                }
              }
            ],
            "name": "skill-level--intermediate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SkillLevelIntermediate",
        "global": "SkillLevelIntermediate",
        "filepath": "SkillLevelIntermediate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zM10 30H2V18h8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--back",
      "friendlyName": "Skip back",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip back"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--back.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>skip--back</title><path d=\"M27,28a1,1,0,0,1-.5-.13l-19-11a1,1,0,0,1,0-1.74l19-11a1,1,0,0,1,1,0A1,1,0,0,1,28,5V27a1,1,0,0,1-1,1ZM10,16l16,9.27V6.73Z\" transform=\"translate(0 0)\"/><rect x=\"2\" y=\"4\" width=\"2\" height=\"24\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 28a1 1 0 01-.5-.13l-19-11a1 1 0 010-1.74l19-11a1 1 0 011 0A1 1 0 0128 5V27a1 1 0 01-1 1zM10 16l16 9.27V6.73zM2 4H4V28H2z\"/></svg>",
            "info": {},
            "path": "32/skip--back.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipBack32",
          "filepath": "skip--back/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a1 1 0 01-.5-.13l-19-11a1 1 0 010-1.74l19-11a1 1 0 011 0A1 1 0 0128 5V27a1 1 0 01-1 1zM10 16l16 9.27V6.73zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipBack24",
          "filepath": "skip--back/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a1 1 0 01-.5-.13l-19-11a1 1 0 010-1.74l19-11a1 1 0 011 0A1 1 0 0128 5V27a1 1 0 01-1 1zM10 16l16 9.27V6.73zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipBack20",
          "filepath": "skip--back/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a1 1 0 01-.5-.13l-19-11a1 1 0 010-1.74l19-11a1 1 0 011 0A1 1 0 0128 5V27a1 1 0 01-1 1zM10 16l16 9.27V6.73zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipBack16",
          "filepath": "skip--back/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a1 1 0 01-.5-.13l-19-11a1 1 0 010-1.74l19-11a1 1 0 011 0A1 1 0 0128 5V27a1 1 0 01-1 1zM10 16l16 9.27V6.73zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipBack",
        "global": "SkipBack",
        "filepath": "SkipBack.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 28a1 1 0 01-.5-.13l-19-11a1 1 0 010-1.74l19-11a1 1 0 011 0A1 1 0 0128 5V27a1 1 0 01-1 1zM10 16l16 9.27V6.73zM2 4H4V28H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--back--filled",
      "friendlyName": "Skip back filled",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip back filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--back--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>skip--back--filled</title><path d=\"M27,28a.9975.9975,0,0,1-.501-.1348l-19-11a1,1,0,0,1,0-1.73l19-11A1,1,0,0,1,28,5V27a1,1,0,0,1-1,1Z\"/><rect x=\"2\" y=\"4\" width=\"2\" height=\"24\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 28a.9975.9975 0 01-.501-.1348l-19-11a1 1 0 010-1.73l19-11A1 1 0 0128 5V27a1 1 0 01-1 1zM2 4H4V28H2z\"/></svg>",
            "info": {},
            "path": "32/skip--back--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipBackFilled32",
          "filepath": "skip--back--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a.9975.9975 0 01-.501-.1348l-19-11a1 1 0 010-1.73l19-11A1 1 0 0128 5V27a1 1 0 01-1 1zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipBackFilled24",
          "filepath": "skip--back--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a.9975.9975 0 01-.501-.1348l-19-11a1 1 0 010-1.73l19-11A1 1 0 0128 5V27a1 1 0 01-1 1zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipBackFilled20",
          "filepath": "skip--back--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a.9975.9975 0 01-.501-.1348l-19-11a1 1 0 010-1.73l19-11A1 1 0 0128 5V27a1 1 0 01-1 1zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipBackFilled16",
          "filepath": "skip--back--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 28a.9975.9975 0 01-.501-.1348l-19-11a1 1 0 010-1.73l19-11A1 1 0 0128 5V27a1 1 0 01-1 1zM2 4H4V28H2z"
                }
              }
            ],
            "name": "skip--back--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipBackFilled",
        "global": "SkipBackFilled",
        "filepath": "SkipBackFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 28a.9975.9975 0 01-.501-.1348l-19-11a1 1 0 010-1.73l19-11A1 1 0 0128 5V27a1 1 0 01-1 1zM2 4H4V28H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--back--outline",
      "friendlyName": "Skip back outline",
      "aliases": [
        "arrow",
        "back",
        "rewind",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip back outline"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--back--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z\"/>\n  <rect x=\"9\" y=\"10\" width=\"2\" height=\"12\" transform=\"translate(20 32) rotate(-180)\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z\"/><path d=\"M9 10H11V22H9z\" transform=\"rotate(-180 10 16)\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/skip--back--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipBackOutline32",
          "filepath": "skip--back--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipBackOutline24",
          "filepath": "skip--back--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipBackOutline20",
          "filepath": "skip--back--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipBackOutline16",
          "filepath": "skip--back--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipBackOutline",
        "global": "SkipBackOutline",
        "filepath": "SkipBackOutline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 10H11V22H9z",
                    "transform": "rotate(-180 10 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--back--outline--filled",
      "friendlyName": "Skip back outline filled",
      "aliases": [
        "arrow",
        "back",
        "rewind",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip back outline filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--back--outline--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z\"/>\n  <polygon points=\"22 19.301 22 12.699 16.059 16 22 19.301\"/>\n  <path id=\"inner-path_2\" data-name=\"inner-path 2\" class=\"cls-1\" d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z\"/>\n  <rect id=\"inner-path_1\" data-name=\"inner-path 1\" class=\"cls-1\" x=\"8\" y=\"10\" width=\"2\" height=\"12\" transform=\"translate(18 32) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z\"/><path d=\"M22 19.301L22 12.699 16.059 16 22 19.301z\"/><path fill=\"none\" d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z\"/><path fill=\"none\" d=\"M8 10H10V22H8z\" transform=\"rotate(-180 9 16)\"/></svg>",
            "info": {},
            "path": "32/skip--back--outline--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipBackOutlineFilled32",
          "filepath": "skip--back--outline--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19.301L22 12.699 16.059 16 22 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--outline--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipBackOutlineFilled24",
          "filepath": "skip--back--outline--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19.301L22 12.699 16.059 16 22 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--outline--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipBackOutlineFilled20",
          "filepath": "skip--back--outline--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19.301L22 12.699 16.059 16 22 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--outline--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipBackOutlineFilled16",
          "filepath": "skip--back--outline--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 19.301L22 12.699 16.059 16 22 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--outline--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipBackOutlineFilled",
        "global": "SkipBackOutlineFilled",
        "filepath": "SkipBackOutlineFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 19.301L22 12.699 16.059 16 22 19.301z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M8 10H10V22H8z",
                    "transform": "rotate(-180 9 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--back--outline--solid",
      "friendlyName": "Skip back outline solid",
      "aliases": [
        "arrow",
        "back",
        "rewind",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip back outline solid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--back--outline--solid.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z\"/>\n  <rect x=\"9\" y=\"10\" width=\"2\" height=\"12\" transform=\"translate(20 31.9999) rotate(-180)\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z\"/><path d=\"M9 10H11V22H9z\" transform=\"rotate(-180 10 16)\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/skip--back--outline--solid.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipBackOutlineSolid32",
          "filepath": "skip--back--outline--solid/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline--solid",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipBackOutlineSolid24",
          "filepath": "skip--back--outline--solid/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline--solid",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipBackOutlineSolid20",
          "filepath": "skip--back--outline--solid/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline--solid",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipBackOutlineSolid16",
          "filepath": "skip--back--outline--solid/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V22H9z",
                  "transform": "rotate(-180 10 16)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--back--outline--solid",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipBackOutlineSolid",
        "global": "SkipBackOutlineSolid",
        "filepath": "SkipBackOutlineSolid.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 10H11V22H9z",
                    "transform": "rotate(-180 10 16)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--back--solid--filled",
      "friendlyName": "Skip back solid filled",
      "aliases": [
        "arrow",
        "back",
        "rewind",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip back solid filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--back--solid--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z\"/>\n  <path id=\"inner-path_2\" data-name=\"inner-path 2\" class=\"cls-1\" d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z\"/>\n  <rect id=\"inner-path_1\" data-name=\"inner-path 1\" class=\"cls-1\" x=\"8\" y=\"10\" width=\"2\" height=\"12\" transform=\"translate(18 32) rotate(-180)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z\"/><path fill=\"none\" d=\"M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z\"/><path fill=\"none\" d=\"M8 10H10V22H8z\" transform=\"rotate(-180 9 16)\"/></svg>",
            "info": {},
            "path": "32/skip--back--solid--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipBackSolidFilled32",
          "filepath": "skip--back--solid--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--solid--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipBackSolidFilled24",
          "filepath": "skip--back--solid--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--solid--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipBackSolidFilled20",
          "filepath": "skip--back--solid--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--solid--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipBackSolidFilled16",
          "filepath": "skip--back--solid--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8 10H10V22H8z",
                  "transform": "rotate(-180 9 16)"
                }
              }
            ],
            "name": "skip--back--solid--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipBackSolidFilled",
        "global": "SkipBackSolidFilled",
        "filepath": "SkipBackSolidFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M8 10H10V22H8z",
                    "transform": "rotate(-180 9 16)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--forward",
      "friendlyName": "Skip forward",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip forward"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--forward.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>skip--forward</title><path d=\"M5,28a1,1,0,0,1-1-1V5a1,1,0,0,1,.5-.87,1,1,0,0,1,1,0l19,11a1,1,0,0,1,0,1.74l-19,11A1,1,0,0,1,5,28ZM6,6.73V25.27L22,16Z\" transform=\"translate(0)\"/><rect x=\"28\" y=\"4\" width=\"2\" height=\"24\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5 28a1 1 0 01-1-1V5a1 1 0 01.5-.87 1 1 0 011 0l19 11a1 1 0 010 1.74l-19 11A1 1 0 015 28zM6 6.73V25.27L22 16zM28 4H30V28H28z\"/></svg>",
            "info": {},
            "path": "32/skip--forward.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipForward32",
          "filepath": "skip--forward/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 28a1 1 0 01-1-1V5a1 1 0 01.5-.87 1 1 0 011 0l19 11a1 1 0 010 1.74l-19 11A1 1 0 015 28zM6 6.73V25.27L22 16zM28 4H30V28H28z"
                }
              }
            ],
            "name": "skip--forward",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipForward24",
          "filepath": "skip--forward/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 28a1 1 0 01-1-1V5a1 1 0 01.5-.87 1 1 0 011 0l19 11a1 1 0 010 1.74l-19 11A1 1 0 015 28zM6 6.73V25.27L22 16zM28 4H30V28H28z"
                }
              }
            ],
            "name": "skip--forward",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipForward20",
          "filepath": "skip--forward/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 28a1 1 0 01-1-1V5a1 1 0 01.5-.87 1 1 0 011 0l19 11a1 1 0 010 1.74l-19 11A1 1 0 015 28zM6 6.73V25.27L22 16zM28 4H30V28H28z"
                }
              }
            ],
            "name": "skip--forward",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipForward16",
          "filepath": "skip--forward/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 28a1 1 0 01-1-1V5a1 1 0 01.5-.87 1 1 0 011 0l19 11a1 1 0 010 1.74l-19 11A1 1 0 015 28zM6 6.73V25.27L22 16zM28 4H30V28H28z"
                }
              }
            ],
            "name": "skip--forward",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipForward",
        "global": "SkipForward",
        "filepath": "SkipForward.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 28a1 1 0 01-1-1V5a1 1 0 01.5-.87 1 1 0 011 0l19 11a1 1 0 010 1.74l-19 11A1 1 0 015 28zM6 6.73V25.27L22 16zM28 4H30V28H28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--forward--filled",
      "friendlyName": "Skip forward filled",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip forward filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--forward--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>skip--forward--filled</title><rect x=\"28\" y=\"4\" width=\"2\" height=\"24\"/><path d=\"M5,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.501-.8652l19,11a1,1,0,0,1,0,1.73l-19,11A.9975.9975,0,0,1,5,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 4H30V28H28zM5 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 015 28z\"/></svg>",
            "info": {},
            "path": "32/skip--forward--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipForwardFilled32",
          "filepath": "skip--forward--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 4H30V28H28zM5 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 015 28z"
                }
              }
            ],
            "name": "skip--forward--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipForwardFilled24",
          "filepath": "skip--forward--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 4H30V28H28zM5 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 015 28z"
                }
              }
            ],
            "name": "skip--forward--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipForwardFilled20",
          "filepath": "skip--forward--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 4H30V28H28zM5 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 015 28z"
                }
              }
            ],
            "name": "skip--forward--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipForwardFilled16",
          "filepath": "skip--forward--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 4H30V28H28zM5 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 015 28z"
                }
              }
            ],
            "name": "skip--forward--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipForwardFilled",
        "global": "SkipForwardFilled",
        "filepath": "SkipForwardFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 4H30V28H28zM5 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 015 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--forward--outline",
      "friendlyName": "Skip forward outline",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip forward outline"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--forward--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"21\" y=\"10\" width=\"2\" height=\"12\"/>\n  <path d=\"M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8742l9,5a1,1,0,0,1,0,1.7485l-9,5a1.0009,1.0009,0,0,1-.9931-.0125ZM10,12.7v6.6011L15.9409,16Z\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.6011L15.9409 16z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/skip--forward--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipForwardOutline32",
          "filepath": "skip--forward--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.6011L15.9409 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipForwardOutline24",
          "filepath": "skip--forward--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.6011L15.9409 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipForwardOutline20",
          "filepath": "skip--forward--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.6011L15.9409 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipForwardOutline16",
          "filepath": "skip--forward--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.6011L15.9409 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipForwardOutline",
        "global": "SkipForwardOutline",
        "filepath": "SkipForwardOutline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.6011L15.9409 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--forward--outline--filled",
      "friendlyName": "Skip forward outline filled",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip forward outline filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--forward--outline--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"10 19.301 15.941 16 10 12.699 10 19.301\"/>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z\"/>\n  <rect id=\"inner-path_2\" data-name=\"inner-path 2\" class=\"cls-1\" x=\"22\" y=\"10\" width=\"2\" height=\"12\"/>\n  <path id=\"inner_path_1\" data-name=\"inner path 1\" class=\"cls-1\" d=\"M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8743l9,5a1,1,0,0,1,0,1.7486l-9,5a1.0009,1.0009,0,0,1-.9931-.0125ZM10,12.7v6.601L15.9409,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 19.301L15.941 16 10 12.699 10 19.301z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z\"/><path fill=\"none\" d=\"M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.601L15.9409 16z\"/></svg>",
            "info": {},
            "path": "32/skip--forward--outline--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipForwardOutlineFilled32",
          "filepath": "skip--forward--outline--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19.301L15.941 16 10 12.699 10 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.601L15.9409 16z"
                }
              }
            ],
            "name": "skip--forward--outline--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipForwardOutlineFilled24",
          "filepath": "skip--forward--outline--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19.301L15.941 16 10 12.699 10 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.601L15.9409 16z"
                }
              }
            ],
            "name": "skip--forward--outline--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipForwardOutlineFilled20",
          "filepath": "skip--forward--outline--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19.301L15.941 16 10 12.699 10 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.601L15.9409 16z"
                }
              }
            ],
            "name": "skip--forward--outline--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipForwardOutlineFilled16",
          "filepath": "skip--forward--outline--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19.301L15.941 16 10 12.699 10 19.301z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.601L15.9409 16z"
                }
              }
            ],
            "name": "skip--forward--outline--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipForwardOutlineFilled",
        "global": "SkipForwardOutlineFilled",
        "filepath": "SkipForwardOutlineFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 19.301L15.941 16 10 12.699 10 19.301z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125zM10 12.7v6.601L15.9409 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--forward--outline--solid",
      "friendlyName": "Skip forward outline solid",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip forward outline solid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--forward--outline--solid.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"21\" y=\"10\" width=\"2\" height=\"12\"/>\n  <path d=\"M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8742l9,5a1,1,0,0,1,0,1.7485l-9,5a1.0009,1.0009,0,0,1-.9931-.0125Z\"/>\n  <path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125z\"/><path d=\"M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z\"/></svg>",
            "info": {},
            "path": "32/skip--forward--outline--solid.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipForwardOutlineSolid32",
          "filepath": "skip--forward--outline--solid/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline--solid",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipForwardOutlineSolid24",
          "filepath": "skip--forward--outline--solid/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline--solid",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipForwardOutlineSolid20",
          "filepath": "skip--forward--outline--solid/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline--solid",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipForwardOutlineSolid16",
          "filepath": "skip--forward--outline--solid/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                }
              }
            ],
            "name": "skip--forward--outline--solid",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipForwardOutlineSolid",
        "global": "SkipForwardOutlineSolid",
        "filepath": "SkipForwardOutlineSolid.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 10H23V22H21zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8742l9 5a1 1 0 010 1.7485l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "skip--forward--solid--filled",
      "friendlyName": "Skip forward solid filled",
      "aliases": [
        "arrow",
        "next",
        "forward",
        "button",
        "music",
        "media",
        "multi-media",
        "player",
        "song",
        "music",
        "skip forward solid filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/skip--forward--solid--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z\"/>\n  <rect id=\"inner-path_2\" data-name=\"inner-path 2\" class=\"cls-1\" x=\"22\" y=\"10\" width=\"2\" height=\"12\"/>\n  <path id=\"inner-path_1\" data-name=\"inner-path 1\" class=\"cls-1\" d=\"M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8743l9,5a1,1,0,0,1,0,1.7486l-9,5a1.0009,1.0009,0,0,1-.9931-.0125Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z\"/><path fill=\"none\" d=\"M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125z\"/></svg>",
            "info": {},
            "path": "32/skip--forward--solid--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SkipForwardSolidFilled32",
          "filepath": "skip--forward--solid--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              }
            ],
            "name": "skip--forward--solid--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SkipForwardSolidFilled24",
          "filepath": "skip--forward--solid--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              }
            ],
            "name": "skip--forward--solid--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SkipForwardSolidFilled20",
          "filepath": "skip--forward--solid--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              }
            ],
            "name": "skip--forward--solid--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SkipForwardSolidFilled16",
          "filepath": "skip--forward--solid--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                }
              }
            ],
            "name": "skip--forward--solid--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "SkipForwardSolidFilled",
        "global": "SkipForwardSolidFilled",
        "filepath": "SkipForwardSolidFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M22 10H24V22H22zM8.4927 21.8618A1 1 0 018 21V11a1 1 0 011.4858-.8743l9 5a1 1 0 010 1.7486l-9 5a1.0009 1.0009 0 01-.9931-.0125z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sleet",
      "friendlyName": "Sleet",
      "aliases": [
        "sleet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sleet.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>sleet</title><rect x=\"6\" y=\"24\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"24\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"28\" width=\"2\" height=\"2\"/><path d=\"M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,21,30Z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22h8.8818L16.106,24.5527a1,1,0,1,0,1.7885.8946L19.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 24H8V26H6zM8 26H10V28H8zM10 28H12V30H10zM10 24H12V26H10zM6 28H8V30H6z\"/><path d=\"M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0A6.4973 6.4973 0 008.5 22h8.8818L16.106 24.5527a1 1 0 101.7885.8946L19.6177 22H23.5A6.4974 6.4974 0 0024.8008 9.1362zM23.5 20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20z\"/></svg>",
            "info": {},
            "path": "32/sleet.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sleet32",
          "filepath": "sleet/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24H8V26H6zM8 26H10V28H8zM10 28H12V30H10zM10 24H12V26H10zM6 28H8V30H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0A6.4973 6.4973 0 008.5 22h8.8818L16.106 24.5527a1 1 0 101.7885.8946L19.6177 22H23.5A6.4974 6.4974 0 0024.8008 9.1362zM23.5 20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20z"
                }
              }
            ],
            "name": "sleet",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sleet24",
          "filepath": "sleet/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24H8V26H6zM8 26H10V28H8zM10 28H12V30H10zM10 24H12V26H10zM6 28H8V30H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0A6.4973 6.4973 0 008.5 22h8.8818L16.106 24.5527a1 1 0 101.7885.8946L19.6177 22H23.5A6.4974 6.4974 0 0024.8008 9.1362zM23.5 20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20z"
                }
              }
            ],
            "name": "sleet",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sleet20",
          "filepath": "sleet/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24H8V26H6zM8 26H10V28H8zM10 28H12V30H10zM10 24H12V26H10zM6 28H8V30H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0A6.4973 6.4973 0 008.5 22h8.8818L16.106 24.5527a1 1 0 101.7885.8946L19.6177 22H23.5A6.4974 6.4974 0 0024.8008 9.1362zM23.5 20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20z"
                }
              }
            ],
            "name": "sleet",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sleet16",
          "filepath": "sleet/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 24H8V26H6zM8 26H10V28H8zM10 28H12V30H10zM10 24H12V26H10zM6 28H8V30H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0A6.4973 6.4973 0 008.5 22h8.8818L16.106 24.5527a1 1 0 101.7885.8946L19.6177 22H23.5A6.4974 6.4974 0 0024.8008 9.1362zM23.5 20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20z"
                }
              }
            ],
            "name": "sleet",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Sleet",
        "global": "Sleet",
        "filepath": "Sleet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 24H8V26H6zM8 26H10V28H8zM10 28H12V30H10zM10 24H12V26H10zM6 28H8V30H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM24.8008 9.1362a8.9943 8.9943 0 00-17.6006 0A6.4973 6.4973 0 008.5 22h8.8818L16.106 24.5527a1 1 0 101.7885.8946L19.6177 22H23.5A6.4974 6.4974 0 0024.8008 9.1362zM23.5 20H8.5a4.4975 4.4975 0 01-.356-8.981l.8155-.0639.0991-.812a6.9938 6.9938 0 0113.8838 0l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "slisor",
      "friendlyName": "slicestor",
      "aliases": [
        "analysis",
        "slisor",
        "slicestor",
        "communication",
        "messaging",
        "systems"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/slisor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"7\" cy=\"25\" r=\"1\"/>\n  <path d=\"M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z\"/><circle cx=\"7\" cy=\"25\" r=\"1\"/><path d=\"M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z\"/><path d=\"M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z\"/></svg>",
            "info": {},
            "path": "32/slisor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Slisor32",
          "filepath": "slisor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
                }
              }
            ],
            "name": "slisor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Slisor24",
          "filepath": "slisor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
                }
              }
            ],
            "name": "slisor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Slisor20",
          "filepath": "slisor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
                }
              }
            ],
            "name": "slisor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Slisor16",
          "filepath": "slisor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
                }
              }
            ],
            "name": "slisor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Slisor",
        "global": "Slisor",
        "filepath": "Slisor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "SLM",
      "friendlyName": "SLM",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/SLM.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"28,9 26.5,14 26,16 25.5,14 24,9 22,9 22,23 24,23 24,15 23.8,13 24.4,15 26,19.6 27.6,15 28.2,13 28,15 28,23 \n\t30,23 30,9 \"/>\n<polygon points=\"14,21 14,9 12,9 12,23 20,23 20,21 \"/>\n<path d=\"M8,23H2v-2h6v-4H4c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h6v2H4v4h4c1.1,0,2,0.9,2,2v4C10,22.1,9.1,23,8,23z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9zM14 21L14 9 12 9 12 23 20 23 20 21zM8 23H2v-2h6v-4H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6v2H4v4h4c1.1 0 2 .9 2 2v4C10 22.1 9.1 23 8 23z\"/></svg>",
            "info": {},
            "path": "32/SLM.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Slm32",
          "filepath": "SLM/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9zM14 21L14 9 12 9 12 23 20 23 20 21zM8 23H2v-2h6v-4H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6v2H4v4h4c1.1 0 2 .9 2 2v4C10 22.1 9.1 23 8 23z"
                }
              }
            ],
            "name": "SLM",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Slm24",
          "filepath": "SLM/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9zM14 21L14 9 12 9 12 23 20 23 20 21zM8 23H2v-2h6v-4H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6v2H4v4h4c1.1 0 2 .9 2 2v4C10 22.1 9.1 23 8 23z"
                }
              }
            ],
            "name": "SLM",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Slm20",
          "filepath": "SLM/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9zM14 21L14 9 12 9 12 23 20 23 20 21zM8 23H2v-2h6v-4H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6v2H4v4h4c1.1 0 2 .9 2 2v4C10 22.1 9.1 23 8 23z"
                }
              }
            ],
            "name": "SLM",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Slm16",
          "filepath": "SLM/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9zM14 21L14 9 12 9 12 23 20 23 20 21zM8 23H2v-2h6v-4H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6v2H4v4h4c1.1 0 2 .9 2 2v4C10 22.1 9.1 23 8 23z"
                }
              }
            ],
            "name": "SLM",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Slm",
        "global": "Slm",
        "filepath": "Slm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9zM14 21L14 9 12 9 12 23 20 23 20 21zM8 23H2v-2h6v-4H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6v2H4v4h4c1.1 0 2 .9 2 2v4C10 22.1 9.1 23 8 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "smell",
      "friendlyName": "Smell",
      "aliases": [
        "nose",
        "scent",
        "odor",
        "fragrance",
        "nostril",
        "senses"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/smell.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>smell</title><path d=\"M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z\"/></svg>",
            "info": {},
            "path": "32/smell.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Smell32",
          "filepath": "smell/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
                }
              }
            ],
            "name": "smell",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Smell24",
          "filepath": "smell/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
                }
              }
            ],
            "name": "smell",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Smell20",
          "filepath": "smell/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
                }
              }
            ],
            "name": "smell",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Smell16",
          "filepath": "smell/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
                }
              }
            ],
            "name": "smell",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Smell",
        "global": "Smell",
        "filepath": "Smell.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "smoke",
      "friendlyName": "Smoke",
      "aliases": [
        "smoke"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/smoke.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>smoke</title><path d=\"M27.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L23.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L27.8,26.4A1,1,0,0,1,27.001,28Z\"/><path d=\"M22.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L18.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L22.8,26.4A1,1,0,0,1,22.001,28Z\"/><path d=\"M17.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L13.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L17.8,26.4A1,1,0,0,1,17.001,28Z\"/><path d=\"M12.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762A6.9956,6.9956,0,0,0,9.0142,6.6855L8.2,5.6A1,1,0,1,1,9.8,4.4l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L12.8,26.4A1,1,0,0,1,12.001,28Z\"/><path d=\"M7.001,28A.998.998,0,0,1,6.2,27.6l-.8145-1.086a8.9976,8.9976,0,0,1-1.6-7.2856l1.4736-6.8762A6.9956,6.9956,0,0,0,4.0142,6.6855L3.2,5.6A1,1,0,1,1,4.8,4.4l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856L5.7412,19.6474a6.9956,6.9956,0,0,0,1.2446,5.6668L7.8,26.4A1,1,0,0,1,7.001,28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L23.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L27.8 26.4A1 1 0 0127.001 28zM22.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L18.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L22.8 26.4A1 1 0 0122.001 28zM17.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L13.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L17.8 26.4A1 1 0 0117.001 28zM12.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762A6.9956 6.9956 0 009.0142 6.6855L8.2 5.6A1 1 0 119.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L12.8 26.4A1 1 0 0112.001 28zM7.001 28A.998.998 0 016.2 27.6l-.8145-1.086a8.9976 8.9976 0 01-1.6-7.2856l1.4736-6.8762A6.9956 6.9956 0 004.0142 6.6855L3.2 5.6A1 1 0 114.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856L5.7412 19.6474a6.9956 6.9956 0 001.2446 5.6668L7.8 26.4A1 1 0 017.001 28z\"/></svg>",
            "info": {},
            "path": "32/smoke.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Smoke32",
          "filepath": "smoke/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L23.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L27.8 26.4A1 1 0 0127.001 28zM22.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L18.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L22.8 26.4A1 1 0 0122.001 28zM17.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L13.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L17.8 26.4A1 1 0 0117.001 28zM12.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762A6.9956 6.9956 0 009.0142 6.6855L8.2 5.6A1 1 0 119.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L12.8 26.4A1 1 0 0112.001 28zM7.001 28A.998.998 0 016.2 27.6l-.8145-1.086a8.9976 8.9976 0 01-1.6-7.2856l1.4736-6.8762A6.9956 6.9956 0 004.0142 6.6855L3.2 5.6A1 1 0 114.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856L5.7412 19.6474a6.9956 6.9956 0 001.2446 5.6668L7.8 26.4A1 1 0 017.001 28z"
                }
              }
            ],
            "name": "smoke",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Smoke24",
          "filepath": "smoke/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L23.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L27.8 26.4A1 1 0 0127.001 28zM22.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L18.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L22.8 26.4A1 1 0 0122.001 28zM17.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L13.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L17.8 26.4A1 1 0 0117.001 28zM12.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762A6.9956 6.9956 0 009.0142 6.6855L8.2 5.6A1 1 0 119.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L12.8 26.4A1 1 0 0112.001 28zM7.001 28A.998.998 0 016.2 27.6l-.8145-1.086a8.9976 8.9976 0 01-1.6-7.2856l1.4736-6.8762A6.9956 6.9956 0 004.0142 6.6855L3.2 5.6A1 1 0 114.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856L5.7412 19.6474a6.9956 6.9956 0 001.2446 5.6668L7.8 26.4A1 1 0 017.001 28z"
                }
              }
            ],
            "name": "smoke",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Smoke20",
          "filepath": "smoke/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L23.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L27.8 26.4A1 1 0 0127.001 28zM22.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L18.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L22.8 26.4A1 1 0 0122.001 28zM17.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L13.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L17.8 26.4A1 1 0 0117.001 28zM12.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762A6.9956 6.9956 0 009.0142 6.6855L8.2 5.6A1 1 0 119.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L12.8 26.4A1 1 0 0112.001 28zM7.001 28A.998.998 0 016.2 27.6l-.8145-1.086a8.9976 8.9976 0 01-1.6-7.2856l1.4736-6.8762A6.9956 6.9956 0 004.0142 6.6855L3.2 5.6A1 1 0 114.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856L5.7412 19.6474a6.9956 6.9956 0 001.2446 5.6668L7.8 26.4A1 1 0 017.001 28z"
                }
              }
            ],
            "name": "smoke",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Smoke16",
          "filepath": "smoke/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L23.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L27.8 26.4A1 1 0 0127.001 28zM22.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L18.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L22.8 26.4A1 1 0 0122.001 28zM17.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L13.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L17.8 26.4A1 1 0 0117.001 28zM12.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762A6.9956 6.9956 0 009.0142 6.6855L8.2 5.6A1 1 0 119.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L12.8 26.4A1 1 0 0112.001 28zM7.001 28A.998.998 0 016.2 27.6l-.8145-1.086a8.9976 8.9976 0 01-1.6-7.2856l1.4736-6.8762A6.9956 6.9956 0 004.0142 6.6855L3.2 5.6A1 1 0 114.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856L5.7412 19.6474a6.9956 6.9956 0 001.2446 5.6668L7.8 26.4A1 1 0 017.001 28z"
                }
              }
            ],
            "name": "smoke",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Smoke",
        "global": "Smoke",
        "filepath": "Smoke.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L23.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L27.8 26.4A1 1 0 0127.001 28zM22.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L18.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L22.8 26.4A1 1 0 0122.001 28zM17.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762a6.9956 6.9956 0 00-1.2446-5.6668L13.2 5.6a1 1 0 111.6-1.2l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L17.8 26.4A1 1 0 0117.001 28zM12.001 28a.998.998 0 01-.8008-.4l-.8145-1.086a8.9976 8.9976 0 01-1.6005-7.2856l1.4736-6.8762A6.9956 6.9956 0 009.0142 6.6855L8.2 5.6A1 1 0 119.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856l-1.4736 6.8762a6.9956 6.9956 0 001.2446 5.6668L12.8 26.4A1 1 0 0112.001 28zM7.001 28A.998.998 0 016.2 27.6l-.8145-1.086a8.9976 8.9976 0 01-1.6-7.2856l1.4736-6.8762A6.9956 6.9956 0 004.0142 6.6855L3.2 5.6A1 1 0 114.8 4.4l.8145 1.0857a8.9976 8.9976 0 011.6005 7.2856L5.7412 19.6474a6.9956 6.9956 0 001.2446 5.6668L7.8 26.4A1 1 0 017.001 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "smoothing",
      "friendlyName": "Smoothing",
      "aliases": [
        "even"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/smoothing.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>smoothing</title><circle cx=\"16\" cy=\"16\" r=\"5\"/><path class=\"cls-1\" d=\"M7.7,4.7a14.7029,14.7029,0,0,0-3,3.1L6.3,9A13.2634,13.2634,0,0,1,8.9,6.3Z\"/><path class=\"cls-1\" d=\"M4.6,12.3l-1.9-.6A12.5111,12.5111,0,0,0,2,16H4A11.4756,11.4756,0,0,1,4.6,12.3Z\"/><path class=\"cls-1\" d=\"M2.7,20.4a14.4029,14.4029,0,0,0,2,3.9l1.6-1.2a12.8867,12.8867,0,0,1-1.7-3.3Z\"/><path class=\"cls-1\" d=\"M7.8,27.3a14.4029,14.4029,0,0,0,3.9,2l.6-1.9A12.8867,12.8867,0,0,1,9,25.7Z\"/><path class=\"cls-1\" d=\"M11.7,2.7l.6,1.9A11.4756,11.4756,0,0,1,16,4V2A12.5111,12.5111,0,0,0,11.7,2.7Z\"/><path class=\"cls-1\" d=\"M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.526,11.526,0,0,1,23,25.7Z\"/><path class=\"cls-1\" d=\"M27.4,19.7l1.9.6A15.4747,15.4747,0,0,0,30,16H28A11.4756,11.4756,0,0,1,27.4,19.7Z\"/><path class=\"cls-1\" d=\"M29.2,11.6a14.4029,14.4029,0,0,0-2-3.9L25.6,8.9a12.8867,12.8867,0,0,1,1.7,3.3Z\"/><path class=\"cls-1\" d=\"M24.1,4.6a14.4029,14.4029,0,0,0-3.9-2l-.6,1.9a12.8867,12.8867,0,0,1,3.3,1.7Z\"/><path class=\"cls-1\" d=\"M20.3,29.3l-.6-1.9A11.4756,11.4756,0,0,1,16,28v2A21.4206,21.4206,0,0,0,20.3,29.3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"5\"/><path d=\"M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3z\"/></svg>",
            "info": {},
            "path": "32/watson-health/smoothing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSmoothing32",
          "filepath": "watson-health/smoothing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3z"
                }
              }
            ],
            "name": "smoothing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSmoothing24",
          "filepath": "watson-health/smoothing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3z"
                }
              }
            ],
            "name": "smoothing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSmoothing20",
          "filepath": "watson-health/smoothing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3z"
                }
              }
            ],
            "name": "smoothing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSmoothing16",
          "filepath": "watson-health/smoothing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3z"
                }
              }
            ],
            "name": "smoothing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Smoothing",
        "global": "WatsonHealthSmoothing",
        "filepath": "watson-health/Smoothing.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "smoothing--cursor",
      "friendlyName": "Smoothing cursor",
      "aliases": [
        "even"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/smoothing--cursor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>smoothing--cursor</title><circle cx=\"18\" cy=\"18\" r=\"4\"/><path d=\"M18,30a11.8932,11.8932,0,0,1-4.1035-.72L14.58,27.4A9.9725,9.9725,0,0,0,18,28Z\"/><path d=\"M22.1484,29.2637l-.6914-1.877a9.9556,9.9556,0,0,0,2.9973-1.748l1.2916,1.5268A11.9525,11.9525,0,0,1,22.1484,29.2637Z\"/><path d=\"M10.2893,27.1951A12.0141,12.0141,0,0,1,7.61,24.0078l1.73-1.0029a10.0236,10.0236,0,0,0,2.2347,2.6584Z\"/><path d=\"M28.4133,23.967l-1.7343-.9956a9.9159,9.9159,0,0,0,1.176-3.2641l1.9712.3388A11.8956,11.8956,0,0,1,28.4133,23.967Z\"/><path d=\"M6.1821,20.0925A12.1282,12.1282,0,0,1,6.1777,15.93l1.9707.3423a10.1214,10.1214,0,0,0,.0035,3.4738Z\"/><path d=\"M27.8447,16.2339a9.9019,9.9019,0,0,0-1.1953-3.2564l1.7285-1.0063a11.9029,11.9029,0,0,1,1.4361,3.9121Z\"/><path d=\"M9.3313,13.0107l-1.7324-.999a12.01,12.01,0,0,1,2.6738-3.1931l1.2886,1.53A10.01,10.01,0,0,0,9.3313,13.0107Z\"/><path d=\"M24.4094,10.3237a9.96,9.96,0,0,0-3.0088-1.7309l.68-1.8809a11.9491,11.9491,0,0,1,3.6118,2.0772Z\"/><path d=\"M14.562,8.6064l-.6875-1.8779A12.1031,12.1031,0,0,1,18,6V8A10.0875,10.0875,0,0,0,14.562,8.6064Z\"/><polygon points=\"11 2 2 2 2 11 4 11 4 4 11 4 11 2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"18\" cy=\"18\" r=\"4\"/><path d=\"M18 30a11.8932 11.8932 0 01-4.1035-.72L14.58 27.4A9.9725 9.9725 0 0018 28zM22.1484 29.2637l-.6914-1.877a9.9556 9.9556 0 002.9973-1.748l1.2916 1.5268A11.9525 11.9525 0 0122.1484 29.2637zM10.2893 27.1951A12.0141 12.0141 0 017.61 24.0078l1.73-1.0029a10.0236 10.0236 0 002.2347 2.6584zM28.4133 23.967l-1.7343-.9956a9.9159 9.9159 0 001.176-3.2641l1.9712.3388A11.8956 11.8956 0 0128.4133 23.967zM6.1821 20.0925A12.1282 12.1282 0 016.1777 15.93l1.9707.3423a10.1214 10.1214 0 00.0035 3.4738zM27.8447 16.2339a9.9019 9.9019 0 00-1.1953-3.2564l1.7285-1.0063a11.9029 11.9029 0 011.4361 3.9121zM9.3313 13.0107l-1.7324-.999a12.01 12.01 0 012.6738-3.1931l1.2886 1.53A10.01 10.01 0 009.3313 13.0107zM24.4094 10.3237a9.96 9.96 0 00-3.0088-1.7309l.68-1.8809a11.9491 11.9491 0 013.6118 2.0772zM14.562 8.6064l-.6875-1.8779A12.1031 12.1031 0 0118 6V8A10.0875 10.0875 0 0014.562 8.6064zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z\"/></svg>",
            "info": {},
            "path": "32/watson-health/smoothing--cursor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSmoothingCursor32",
          "filepath": "watson-health/smoothing--cursor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "18",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30a11.8932 11.8932 0 01-4.1035-.72L14.58 27.4A9.9725 9.9725 0 0018 28zM22.1484 29.2637l-.6914-1.877a9.9556 9.9556 0 002.9973-1.748l1.2916 1.5268A11.9525 11.9525 0 0122.1484 29.2637zM10.2893 27.1951A12.0141 12.0141 0 017.61 24.0078l1.73-1.0029a10.0236 10.0236 0 002.2347 2.6584zM28.4133 23.967l-1.7343-.9956a9.9159 9.9159 0 001.176-3.2641l1.9712.3388A11.8956 11.8956 0 0128.4133 23.967zM6.1821 20.0925A12.1282 12.1282 0 016.1777 15.93l1.9707.3423a10.1214 10.1214 0 00.0035 3.4738zM27.8447 16.2339a9.9019 9.9019 0 00-1.1953-3.2564l1.7285-1.0063a11.9029 11.9029 0 011.4361 3.9121zM9.3313 13.0107l-1.7324-.999a12.01 12.01 0 012.6738-3.1931l1.2886 1.53A10.01 10.01 0 009.3313 13.0107zM24.4094 10.3237a9.96 9.96 0 00-3.0088-1.7309l.68-1.8809a11.9491 11.9491 0 013.6118 2.0772zM14.562 8.6064l-.6875-1.8779A12.1031 12.1031 0 0118 6V8A10.0875 10.0875 0 0014.562 8.6064zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "smoothing--cursor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSmoothingCursor24",
          "filepath": "watson-health/smoothing--cursor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "18",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30a11.8932 11.8932 0 01-4.1035-.72L14.58 27.4A9.9725 9.9725 0 0018 28zM22.1484 29.2637l-.6914-1.877a9.9556 9.9556 0 002.9973-1.748l1.2916 1.5268A11.9525 11.9525 0 0122.1484 29.2637zM10.2893 27.1951A12.0141 12.0141 0 017.61 24.0078l1.73-1.0029a10.0236 10.0236 0 002.2347 2.6584zM28.4133 23.967l-1.7343-.9956a9.9159 9.9159 0 001.176-3.2641l1.9712.3388A11.8956 11.8956 0 0128.4133 23.967zM6.1821 20.0925A12.1282 12.1282 0 016.1777 15.93l1.9707.3423a10.1214 10.1214 0 00.0035 3.4738zM27.8447 16.2339a9.9019 9.9019 0 00-1.1953-3.2564l1.7285-1.0063a11.9029 11.9029 0 011.4361 3.9121zM9.3313 13.0107l-1.7324-.999a12.01 12.01 0 012.6738-3.1931l1.2886 1.53A10.01 10.01 0 009.3313 13.0107zM24.4094 10.3237a9.96 9.96 0 00-3.0088-1.7309l.68-1.8809a11.9491 11.9491 0 013.6118 2.0772zM14.562 8.6064l-.6875-1.8779A12.1031 12.1031 0 0118 6V8A10.0875 10.0875 0 0014.562 8.6064zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "smoothing--cursor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSmoothingCursor20",
          "filepath": "watson-health/smoothing--cursor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "18",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30a11.8932 11.8932 0 01-4.1035-.72L14.58 27.4A9.9725 9.9725 0 0018 28zM22.1484 29.2637l-.6914-1.877a9.9556 9.9556 0 002.9973-1.748l1.2916 1.5268A11.9525 11.9525 0 0122.1484 29.2637zM10.2893 27.1951A12.0141 12.0141 0 017.61 24.0078l1.73-1.0029a10.0236 10.0236 0 002.2347 2.6584zM28.4133 23.967l-1.7343-.9956a9.9159 9.9159 0 001.176-3.2641l1.9712.3388A11.8956 11.8956 0 0128.4133 23.967zM6.1821 20.0925A12.1282 12.1282 0 016.1777 15.93l1.9707.3423a10.1214 10.1214 0 00.0035 3.4738zM27.8447 16.2339a9.9019 9.9019 0 00-1.1953-3.2564l1.7285-1.0063a11.9029 11.9029 0 011.4361 3.9121zM9.3313 13.0107l-1.7324-.999a12.01 12.01 0 012.6738-3.1931l1.2886 1.53A10.01 10.01 0 009.3313 13.0107zM24.4094 10.3237a9.96 9.96 0 00-3.0088-1.7309l.68-1.8809a11.9491 11.9491 0 013.6118 2.0772zM14.562 8.6064l-.6875-1.8779A12.1031 12.1031 0 0118 6V8A10.0875 10.0875 0 0014.562 8.6064zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "smoothing--cursor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSmoothingCursor16",
          "filepath": "watson-health/smoothing--cursor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "18",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 30a11.8932 11.8932 0 01-4.1035-.72L14.58 27.4A9.9725 9.9725 0 0018 28zM22.1484 29.2637l-.6914-1.877a9.9556 9.9556 0 002.9973-1.748l1.2916 1.5268A11.9525 11.9525 0 0122.1484 29.2637zM10.2893 27.1951A12.0141 12.0141 0 017.61 24.0078l1.73-1.0029a10.0236 10.0236 0 002.2347 2.6584zM28.4133 23.967l-1.7343-.9956a9.9159 9.9159 0 001.176-3.2641l1.9712.3388A11.8956 11.8956 0 0128.4133 23.967zM6.1821 20.0925A12.1282 12.1282 0 016.1777 15.93l1.9707.3423a10.1214 10.1214 0 00.0035 3.4738zM27.8447 16.2339a9.9019 9.9019 0 00-1.1953-3.2564l1.7285-1.0063a11.9029 11.9029 0 011.4361 3.9121zM9.3313 13.0107l-1.7324-.999a12.01 12.01 0 012.6738-3.1931l1.2886 1.53A10.01 10.01 0 009.3313 13.0107zM24.4094 10.3237a9.96 9.96 0 00-3.0088-1.7309l.68-1.8809a11.9491 11.9491 0 013.6118 2.0772zM14.562 8.6064l-.6875-1.8779A12.1031 12.1031 0 0118 6V8A10.0875 10.0875 0 0014.562 8.6064zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                }
              }
            ],
            "name": "smoothing--cursor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "SmoothingCursor",
        "global": "WatsonHealthSmoothingCursor",
        "filepath": "watson-health/SmoothingCursor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18",
                    "cy": "18",
                    "r": "4"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 30a11.8932 11.8932 0 01-4.1035-.72L14.58 27.4A9.9725 9.9725 0 0018 28zM22.1484 29.2637l-.6914-1.877a9.9556 9.9556 0 002.9973-1.748l1.2916 1.5268A11.9525 11.9525 0 0122.1484 29.2637zM10.2893 27.1951A12.0141 12.0141 0 017.61 24.0078l1.73-1.0029a10.0236 10.0236 0 002.2347 2.6584zM28.4133 23.967l-1.7343-.9956a9.9159 9.9159 0 001.176-3.2641l1.9712.3388A11.8956 11.8956 0 0128.4133 23.967zM6.1821 20.0925A12.1282 12.1282 0 016.1777 15.93l1.9707.3423a10.1214 10.1214 0 00.0035 3.4738zM27.8447 16.2339a9.9019 9.9019 0 00-1.1953-3.2564l1.7285-1.0063a11.9029 11.9029 0 011.4361 3.9121zM9.3313 13.0107l-1.7324-.999a12.01 12.01 0 012.6738-3.1931l1.2886 1.53A10.01 10.01 0 009.3313 13.0107zM24.4094 10.3237a9.96 9.96 0 00-3.0088-1.7309l.68-1.8809a11.9491 11.9491 0 013.6118 2.0772zM14.562 8.6064l-.6875-1.8779A12.1031 12.1031 0 0118 6V8A10.0875 10.0875 0 0014.562 8.6064zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snooze",
      "friendlyName": "Snooze",
      "aliases": [
        "snooze",
        "alarm",
        "timer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snooze.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>snooze</title><polygon points=\"20 14 20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14\"/><rect x=\"24.4999\" y=\"3.9648\" width=\"1.9993\" height=\"5.0718\" transform=\"translate(2.859 19.913) rotate(-44.9446)\"/><path d=\"M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z\"/><rect x=\"3.9646\" y=\"5.501\" width=\"5.0718\" height=\"1.9993\" transform=\"translate(-2.6927 6.5094) rotate(-45.0554)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z\"/><path d=\"M24.5 3.965H26.499V9.036999999999999H24.5z\" transform=\"rotate(-44.945 25.5 6.5)\"/><path d=\"M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z\"/><path d=\"M3.965 5.501H9.036999999999999V7.5H3.965z\" transform=\"rotate(-45.055 6.5 6.5)\"/></svg>",
            "info": {},
            "path": "32/snooze.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Snooze32",
          "filepath": "snooze/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.965H26.499V9.036999999999999H24.5z",
                  "transform": "rotate(-44.945 25.5 6.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.965 5.501H9.036999999999999V7.5H3.965z",
                  "transform": "rotate(-45.055 6.5 6.5)"
                }
              }
            ],
            "name": "snooze",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Snooze24",
          "filepath": "snooze/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.965H26.499V9.036999999999999H24.5z",
                  "transform": "rotate(-44.945 25.5 6.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.965 5.501H9.036999999999999V7.5H3.965z",
                  "transform": "rotate(-45.055 6.5 6.5)"
                }
              }
            ],
            "name": "snooze",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Snooze20",
          "filepath": "snooze/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.965H26.499V9.036999999999999H24.5z",
                  "transform": "rotate(-44.945 25.5 6.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.965 5.501H9.036999999999999V7.5H3.965z",
                  "transform": "rotate(-45.055 6.5 6.5)"
                }
              }
            ],
            "name": "snooze",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Snooze16",
          "filepath": "snooze/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 3.965H26.499V9.036999999999999H24.5z",
                  "transform": "rotate(-44.945 25.5 6.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M3.965 5.501H9.036999999999999V7.5H3.965z",
                  "transform": "rotate(-45.055 6.5 6.5)"
                }
              }
            ],
            "name": "snooze",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Snooze",
        "global": "Snooze",
        "filepath": "Snooze.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5 3.965H26.499V9.036999999999999H24.5z",
                    "transform": "rotate(-44.945 25.5 6.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3.965 5.501H9.036999999999999V7.5H3.965z",
                    "transform": "rotate(-45.055 6.5 6.5)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snow",
      "friendlyName": "Snow",
      "aliases": [
        "snow",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snow.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud--snow</title><path d=\"M23.5,22H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22ZM16,4a7,7,0,0,0-6.94,6.14L9,11,8.14,11a4.5,4.5,0,0,0,.36,9h15a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82A7,7,0,0,0,16,4Z\"/><polygon points=\"12 25.05 10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05\"/><polygon points=\"26 25.05 24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05\"/><polygon points=\"19 27.05 17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z\"/></svg>",
            "info": {},
            "path": "32/snow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Snow32",
          "filepath": "snow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
                }
              }
            ],
            "name": "snow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Snow24",
          "filepath": "snow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
                }
              }
            ],
            "name": "snow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Snow20",
          "filepath": "snow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
                }
              }
            ],
            "name": "snow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Snow16",
          "filepath": "snow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
                }
              }
            ],
            "name": "snow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Snow",
        "global": "Snow",
        "filepath": "Snow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snow--blizzard",
      "friendlyName": "Snow blizzard",
      "aliases": [
        "snow",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snow--blizzard.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>snow--blizzard</title><rect x=\"13\" y=\"10\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"10\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"3\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"5\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"7\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"7\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"3\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"23\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"25\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"27\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"27\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"23\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"12\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"12\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"20\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"22\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"22\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"30\" width=\"2\" height=\"2\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 10H15V12H13zM15 12H17V14H15zM17 14H19V16H17zM17 10H19V12H17zM13 14H15V16H13zM3 26H5V28H3zM5 28H7V30H5zM7 30H9V32H7zM7 26H9V28H7zM3 30H5V32H3zM23 26H25V28H23zM25 28H27V30H25zM27 30H29V32H27zM27 26H29V28H27zM23 30H25V32H23zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM13 26H15V28H13zM15 28H17V30H15zM17 30H19V32H17zM17 26H19V28H17zM13 30H15V32H13z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z\"/></svg>",
            "info": {},
            "path": "32/snow--blizzard.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SnowBlizzard32",
          "filepath": "snow--blizzard/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 10H15V12H13zM15 12H17V14H15zM17 14H19V16H17zM17 10H19V12H17zM13 14H15V16H13zM3 26H5V28H3zM5 28H7V30H5zM7 30H9V32H7zM7 26H9V28H7zM3 30H5V32H3zM23 26H25V28H23zM25 28H27V30H25zM27 30H29V32H27zM27 26H29V28H27zM23 30H25V32H23zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM13 26H15V28H13zM15 28H17V30H15zM17 30H19V32H17zM17 26H19V28H17zM13 30H15V32H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--blizzard",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SnowBlizzard24",
          "filepath": "snow--blizzard/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 10H15V12H13zM15 12H17V14H15zM17 14H19V16H17zM17 10H19V12H17zM13 14H15V16H13zM3 26H5V28H3zM5 28H7V30H5zM7 30H9V32H7zM7 26H9V28H7zM3 30H5V32H3zM23 26H25V28H23zM25 28H27V30H25zM27 30H29V32H27zM27 26H29V28H27zM23 30H25V32H23zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM13 26H15V28H13zM15 28H17V30H15zM17 30H19V32H17zM17 26H19V28H17zM13 30H15V32H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--blizzard",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SnowBlizzard20",
          "filepath": "snow--blizzard/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 10H15V12H13zM15 12H17V14H15zM17 14H19V16H17zM17 10H19V12H17zM13 14H15V16H13zM3 26H5V28H3zM5 28H7V30H5zM7 30H9V32H7zM7 26H9V28H7zM3 30H5V32H3zM23 26H25V28H23zM25 28H27V30H25zM27 30H29V32H27zM27 26H29V28H27zM23 30H25V32H23zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM13 26H15V28H13zM15 28H17V30H15zM17 30H19V32H17zM17 26H19V28H17zM13 30H15V32H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--blizzard",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SnowBlizzard16",
          "filepath": "snow--blizzard/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 10H15V12H13zM15 12H17V14H15zM17 14H19V16H17zM17 10H19V12H17zM13 14H15V16H13zM3 26H5V28H3zM5 28H7V30H5zM7 30H9V32H7zM7 26H9V28H7zM3 30H5V32H3zM23 26H25V28H23zM25 28H27V30H25zM27 30H29V32H27zM27 26H29V28H27zM23 30H25V32H23zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM13 26H15V28H13zM15 28H17V30H15zM17 30H19V32H17zM17 26H19V28H17zM13 30H15V32H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--blizzard",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SnowBlizzard",
        "global": "SnowBlizzard",
        "filepath": "SnowBlizzard.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 10H15V12H13zM15 12H17V14H15zM17 14H19V16H17zM17 10H19V12H17zM13 14H15V16H13zM3 26H5V28H3zM5 28H7V30H5zM7 30H9V32H7zM7 26H9V28H7zM3 30H5V32H3zM23 26H25V28H23zM25 28H27V30H25zM27 30H29V32H27zM27 26H29V28H27zM23 30H25V32H23zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM13 26H15V28H13zM15 28H17V30H15zM17 30H19V32H17zM17 26H19V28H17zM13 30H15V32H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snow--heavy",
      "friendlyName": "Snow heavy",
      "aliases": [
        "snow",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snow--heavy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>snow--heavy</title><rect x=\"4\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"4\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"12\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"12\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"20\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"22\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"22\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"22\" width=\"2\" height=\"2\"/><rect x=\"14\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"16\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"18\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"14\" y=\"30\" width=\"2\" height=\"2\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H6V28H4zM6 28H8V30H6zM8 30H10V32H8zM8 26H10V28H8zM4 30H6V32H4zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM14 26H16V28H14zM16 28H18V30H16zM18 30H20V32H18zM18 26H20V28H18zM14 30H16V32H14z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z\"/></svg>",
            "info": {},
            "path": "32/snow--heavy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SnowHeavy32",
          "filepath": "snow--heavy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H6V28H4zM6 28H8V30H6zM8 30H10V32H8zM8 26H10V28H8zM4 30H6V32H4zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM14 26H16V28H14zM16 28H18V30H16zM18 30H20V32H18zM18 26H20V28H18zM14 30H16V32H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--heavy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SnowHeavy24",
          "filepath": "snow--heavy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H6V28H4zM6 28H8V30H6zM8 30H10V32H8zM8 26H10V28H8zM4 30H6V32H4zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM14 26H16V28H14zM16 28H18V30H16zM18 30H20V32H18zM18 26H20V28H18zM14 30H16V32H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--heavy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SnowHeavy20",
          "filepath": "snow--heavy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H6V28H4zM6 28H8V30H6zM8 30H10V32H8zM8 26H10V28H8zM4 30H6V32H4zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM14 26H16V28H14zM16 28H18V30H16zM18 30H20V32H18zM18 26H20V28H18zM14 30H16V32H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--heavy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SnowHeavy16",
          "filepath": "snow--heavy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H6V28H4zM6 28H8V30H6zM8 30H10V32H8zM8 26H10V28H8zM4 30H6V32H4zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM14 26H16V28H14zM16 28H18V30H16zM18 30H20V32H18zM18 26H20V28H18zM14 30H16V32H14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "snow--heavy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SnowHeavy",
        "global": "SnowHeavy",
        "filepath": "SnowHeavy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H6V28H4zM6 28H8V30H6zM8 30H10V32H8zM8 26H10V28H8zM4 30H6V32H4zM8 18H10V20H8zM10 20H12V22H10zM12 22H14V24H12zM12 18H14V20H12zM8 22H10V24H8zM18 18H20V20H18zM20 20H22V22H20zM22 22H24V24H22zM22 18H24V20H22zM18 22H20V24H18zM14 26H16V28H14zM16 28H18V30H16zM18 30H20V32H18zM18 26H20V28H18zM14 30H16V32H14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snow--scattered",
      "friendlyName": "Snow scattered",
      "aliases": [
        "snow",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snow--scattered.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>snow--scattered</title><rect x=\"2\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"4\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"2\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"20\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"22\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"20\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"11\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"11\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"20\" width=\"2\" height=\"3\"/><rect x=\"29\" y=\"10.0007\" width=\"3\" height=\"2\"/><rect x=\"26.7322\" y=\"3.7684\" width=\"3\" height=\"2\" transform=\"translate(4.8972 21.3598) rotate(-45)\"/><rect x=\"26.7322\" y=\"16.2329\" width=\"3\" height=\"2\" transform=\"translate(36.0099 49.3816) rotate(-135)\"/><rect x=\"12.2678\" y=\"3.7684\" width=\"3\" height=\"2\" transform=\"translate(20.1312 17.8755) rotate(-135)\"/><path d=\"M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM20 0H22V3H20zM29 10.001H32V12.001H29z\"/><path d=\"M26.732 3.768H29.732V5.768H26.732z\" transform=\"rotate(-45 28.232 4.768)\"/><path d=\"M26.732 16.233H29.732V18.233H26.732z\" transform=\"rotate(-135 28.232 17.233)\"/><path d=\"M12.268 3.768H15.268V5.768H12.268z\" transform=\"rotate(-135 13.768 4.768)\"/><path d=\"M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z\"/></svg>",
            "info": {},
            "path": "32/snow--scattered.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SnowScattered32",
          "filepath": "snow--scattered/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM20 0H22V3H20zM29 10.001H32V12.001H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
                }
              }
            ],
            "name": "snow--scattered",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SnowScattered24",
          "filepath": "snow--scattered/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM20 0H22V3H20zM29 10.001H32V12.001H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
                }
              }
            ],
            "name": "snow--scattered",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SnowScattered20",
          "filepath": "snow--scattered/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM20 0H22V3H20zM29 10.001H32V12.001H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
                }
              }
            ],
            "name": "snow--scattered",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SnowScattered16",
          "filepath": "snow--scattered/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM20 0H22V3H20zM29 10.001H32V12.001H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
                }
              }
            ],
            "name": "snow--scattered",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SnowScattered",
        "global": "SnowScattered",
        "filepath": "SnowScattered.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM20 0H22V3H20zM29 10.001H32V12.001H29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.732 3.768H29.732V5.768H26.732z",
                    "transform": "rotate(-45 28.232 4.768)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.732 16.233H29.732V18.233H26.732z",
                    "transform": "rotate(-135 28.232 17.233)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.268 3.768H15.268V5.768H12.268z",
                    "transform": "rotate(-135 13.768 4.768)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snow--scattered--night",
      "friendlyName": "Snow scattered night",
      "aliases": [
        "snow",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snow--scattered--night.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>snow--scattered--night</title><rect x=\"2\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"4\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"2\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"20\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"22\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"24\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"20\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"11\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"11\" y=\"30\" width=\"2\" height=\"2\"/><path d=\"M29.8439,13.0347a1.517,1.517,0,0,0-1.23-.8658,5.3552,5.3552,0,0,1-3.4095-1.7158,6.4655,6.4655,0,0,1-1.286-6.3926,1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.7685,7.7685,0,0,0-5.8847,5.5737A7.3706,7.3706,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a6.0066,6.0066,0,0,0,6-6c0-.0571-.0123-.1113-.0139-.1685a7.5076,7.5076,0,0,0,4.7611-3.2768A1.5369,1.5369,0,0,0,29.8439,13.0347ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm5.5974-6.1289a5.9661,5.9661,0,0,0-3.948-3.627,7.49,7.49,0,0,0-2.489-3.58,5.9018,5.9018,0,0,1,3.6381-4.4473,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,14.041,5.4487,5.4487,0,0,1,24.5974,15.8711Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM29.8439 13.0347a1.517 1.517 0 00-1.23-.8658 5.3552 5.3552 0 01-3.4095-1.7158 6.4655 6.4655 0 01-1.286-6.3926 1.6025 1.6025 0 00-.2989-1.5459 1.4543 1.4543 0 00-1.36-.4931l-.0191.0039a7.7685 7.7685 0 00-5.8847 5.5737A7.3706 7.3706 0 0013.5 7a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 24H19a6.0066 6.0066 0 006-6c0-.0571-.0123-.1113-.0139-.1685a7.5076 7.5076 0 004.7611-3.2768A1.5369 1.5369 0 0029.8439 13.0347zM19 22H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 22zm5.5974-6.1289a5.9661 5.9661 0 00-3.948-3.627 7.49 7.49 0 00-2.489-3.58 5.9018 5.9018 0 013.6381-4.4473 8.4577 8.4577 0 001.94 7.5967A7.4007 7.4007 0 0027.64 14.041 5.4487 5.4487 0 0124.5974 15.8711z\"/></svg>",
            "info": {},
            "path": "32/snow--scattered--night.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SnowScatteredNight32",
          "filepath": "snow--scattered--night/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM29.8439 13.0347a1.517 1.517 0 00-1.23-.8658 5.3552 5.3552 0 01-3.4095-1.7158 6.4655 6.4655 0 01-1.286-6.3926 1.6025 1.6025 0 00-.2989-1.5459 1.4543 1.4543 0 00-1.36-.4931l-.0191.0039a7.7685 7.7685 0 00-5.8847 5.5737A7.3706 7.3706 0 0013.5 7a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 24H19a6.0066 6.0066 0 006-6c0-.0571-.0123-.1113-.0139-.1685a7.5076 7.5076 0 004.7611-3.2768A1.5369 1.5369 0 0029.8439 13.0347zM19 22H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 22zm5.5974-6.1289a5.9661 5.9661 0 00-3.948-3.627 7.49 7.49 0 00-2.489-3.58 5.9018 5.9018 0 013.6381-4.4473 8.4577 8.4577 0 001.94 7.5967A7.4007 7.4007 0 0027.64 14.041 5.4487 5.4487 0 0124.5974 15.8711z"
                }
              }
            ],
            "name": "snow--scattered--night",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SnowScatteredNight24",
          "filepath": "snow--scattered--night/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM29.8439 13.0347a1.517 1.517 0 00-1.23-.8658 5.3552 5.3552 0 01-3.4095-1.7158 6.4655 6.4655 0 01-1.286-6.3926 1.6025 1.6025 0 00-.2989-1.5459 1.4543 1.4543 0 00-1.36-.4931l-.0191.0039a7.7685 7.7685 0 00-5.8847 5.5737A7.3706 7.3706 0 0013.5 7a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 24H19a6.0066 6.0066 0 006-6c0-.0571-.0123-.1113-.0139-.1685a7.5076 7.5076 0 004.7611-3.2768A1.5369 1.5369 0 0029.8439 13.0347zM19 22H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 22zm5.5974-6.1289a5.9661 5.9661 0 00-3.948-3.627 7.49 7.49 0 00-2.489-3.58 5.9018 5.9018 0 013.6381-4.4473 8.4577 8.4577 0 001.94 7.5967A7.4007 7.4007 0 0027.64 14.041 5.4487 5.4487 0 0124.5974 15.8711z"
                }
              }
            ],
            "name": "snow--scattered--night",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SnowScatteredNight20",
          "filepath": "snow--scattered--night/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM29.8439 13.0347a1.517 1.517 0 00-1.23-.8658 5.3552 5.3552 0 01-3.4095-1.7158 6.4655 6.4655 0 01-1.286-6.3926 1.6025 1.6025 0 00-.2989-1.5459 1.4543 1.4543 0 00-1.36-.4931l-.0191.0039a7.7685 7.7685 0 00-5.8847 5.5737A7.3706 7.3706 0 0013.5 7a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 24H19a6.0066 6.0066 0 006-6c0-.0571-.0123-.1113-.0139-.1685a7.5076 7.5076 0 004.7611-3.2768A1.5369 1.5369 0 0029.8439 13.0347zM19 22H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 22zm5.5974-6.1289a5.9661 5.9661 0 00-3.948-3.627 7.49 7.49 0 00-2.489-3.58 5.9018 5.9018 0 013.6381-4.4473 8.4577 8.4577 0 001.94 7.5967A7.4007 7.4007 0 0027.64 14.041 5.4487 5.4487 0 0124.5974 15.8711z"
                }
              }
            ],
            "name": "snow--scattered--night",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SnowScatteredNight16",
          "filepath": "snow--scattered--night/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM29.8439 13.0347a1.517 1.517 0 00-1.23-.8658 5.3552 5.3552 0 01-3.4095-1.7158 6.4655 6.4655 0 01-1.286-6.3926 1.6025 1.6025 0 00-.2989-1.5459 1.4543 1.4543 0 00-1.36-.4931l-.0191.0039a7.7685 7.7685 0 00-5.8847 5.5737A7.3706 7.3706 0 0013.5 7a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 24H19a6.0066 6.0066 0 006-6c0-.0571-.0123-.1113-.0139-.1685a7.5076 7.5076 0 004.7611-3.2768A1.5369 1.5369 0 0029.8439 13.0347zM19 22H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 22zm5.5974-6.1289a5.9661 5.9661 0 00-3.948-3.627 7.49 7.49 0 00-2.489-3.58 5.9018 5.9018 0 013.6381-4.4473 8.4577 8.4577 0 001.94 7.5967A7.4007 7.4007 0 0027.64 14.041 5.4487 5.4487 0 0124.5974 15.8711z"
                }
              }
            ],
            "name": "snow--scattered--night",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SnowScatteredNight",
        "global": "SnowScatteredNight",
        "filepath": "SnowScatteredNight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2zM20 26H22V28H20zM22 28H24V30H22zM24 30H26V32H24zM24 26H26V28H24zM20 30H22V32H20zM11 26H13V28H11zM13 28H15V30H13zM15 30H17V32H15zM15 26H17V28H15zM11 30H13V32H11zM29.8439 13.0347a1.517 1.517 0 00-1.23-.8658 5.3552 5.3552 0 01-3.4095-1.7158 6.4655 6.4655 0 01-1.286-6.3926 1.6025 1.6025 0 00-.2989-1.5459 1.4543 1.4543 0 00-1.36-.4931l-.0191.0039a7.7685 7.7685 0 00-5.8847 5.5737A7.3706 7.3706 0 0013.5 7a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 24H19a6.0066 6.0066 0 006-6c0-.0571-.0123-.1113-.0139-.1685a7.5076 7.5076 0 004.7611-3.2768A1.5369 1.5369 0 0029.8439 13.0347zM19 22H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 22zm5.5974-6.1289a5.9661 5.9661 0 00-3.948-3.627 7.49 7.49 0 00-2.489-3.58 5.9018 5.9018 0 013.6381-4.4473 8.4577 8.4577 0 001.94 7.5967A7.4007 7.4007 0 0027.64 14.041 5.4487 5.4487 0 0124.5974 15.8711z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snow-density",
      "friendlyName": "Snow density",
      "aliases": [
        "weather",
        "snow",
        "density",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snow-density.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"20.6 16.8 19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z\"/><path d=\"M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z\"/></svg>",
            "info": {},
            "path": "32/snow-density.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SnowDensity32",
          "filepath": "snow-density/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
                }
              }
            ],
            "name": "snow-density",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SnowDensity24",
          "filepath": "snow-density/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
                }
              }
            ],
            "name": "snow-density",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SnowDensity20",
          "filepath": "snow-density/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
                }
              }
            ],
            "name": "snow-density",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SnowDensity16",
          "filepath": "snow-density/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
                }
              }
            ],
            "name": "snow-density",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SnowDensity",
        "global": "SnowDensity",
        "filepath": "SnowDensity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "snowflake",
      "friendlyName": "Snowflake",
      "aliases": [
        "snowflake",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/snowflake.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>snowflake</title><path d=\"M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z\"/></svg>",
            "info": {},
            "path": "32/snowflake.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Snowflake32",
          "filepath": "snowflake/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
                }
              }
            ],
            "name": "snowflake",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Snowflake24",
          "filepath": "snowflake/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
                }
              }
            ],
            "name": "snowflake",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Snowflake20",
          "filepath": "snowflake/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
                }
              }
            ],
            "name": "snowflake",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Snowflake16",
          "filepath": "snowflake/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
                }
              }
            ],
            "name": "snowflake",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Snowflake",
        "global": "Snowflake",
        "filepath": "Snowflake.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "soccer",
      "friendlyName": "Soccer",
      "aliases": [
        "soccer",
        "sports",
        "football"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/soccer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>soccer</title><circle cx=\"17\" cy=\"28\" r=\"2\"/><rect x=\"7.5501\" y=\"17.5001\" width=\"7.8997\" height=\"1.9998\" transform=\"translate(-9.7132 13.5503) rotate(-45)\"/><path d=\"M28,16.584,19.4143,8H6v2H18.5857l3,3L6,28.5859,7.4141,30,23,14.415,26.584,18,23,21.5859,24.4141,23,28,19.416A2.0044,2.0044,0,0,0,28,16.584Z\"/><path d=\"M24.5,9A3.5,3.5,0,1,1,28,5.5,3.504,3.504,0,0,1,24.5,9Zm0-5A1.5,1.5,0,1,0,26,5.5,1.5017,1.5017,0,0,0,24.5,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"17\" cy=\"28\" r=\"2\"/><path d=\"M7.55 17.5H15.45V19.5H7.55z\" transform=\"rotate(-45 11.5 18.5)\"/><path d=\"M28 16.584L19.4143 8H6v2H18.5857l3 3L6 28.5859 7.4141 30 23 14.415 26.584 18 23 21.5859 24.4141 23 28 19.416A2.0044 2.0044 0 0028 16.584zM24.5 9A3.5 3.5 0 1128 5.5 3.504 3.504 0 0124.5 9zm0-5A1.5 1.5 0 1026 5.5 1.5017 1.5017 0 0024.5 4z\"/></svg>",
            "info": {},
            "path": "32/soccer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Soccer32",
          "filepath": "soccer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 17.5H15.45V19.5H7.55z",
                  "transform": "rotate(-45 11.5 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16.584L19.4143 8H6v2H18.5857l3 3L6 28.5859 7.4141 30 23 14.415 26.584 18 23 21.5859 24.4141 23 28 19.416A2.0044 2.0044 0 0028 16.584zM24.5 9A3.5 3.5 0 1128 5.5 3.504 3.504 0 0124.5 9zm0-5A1.5 1.5 0 1026 5.5 1.5017 1.5017 0 0024.5 4z"
                }
              }
            ],
            "name": "soccer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Soccer24",
          "filepath": "soccer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 17.5H15.45V19.5H7.55z",
                  "transform": "rotate(-45 11.5 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16.584L19.4143 8H6v2H18.5857l3 3L6 28.5859 7.4141 30 23 14.415 26.584 18 23 21.5859 24.4141 23 28 19.416A2.0044 2.0044 0 0028 16.584zM24.5 9A3.5 3.5 0 1128 5.5 3.504 3.504 0 0124.5 9zm0-5A1.5 1.5 0 1026 5.5 1.5017 1.5017 0 0024.5 4z"
                }
              }
            ],
            "name": "soccer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Soccer20",
          "filepath": "soccer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 17.5H15.45V19.5H7.55z",
                  "transform": "rotate(-45 11.5 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16.584L19.4143 8H6v2H18.5857l3 3L6 28.5859 7.4141 30 23 14.415 26.584 18 23 21.5859 24.4141 23 28 19.416A2.0044 2.0044 0 0028 16.584zM24.5 9A3.5 3.5 0 1128 5.5 3.504 3.504 0 0124.5 9zm0-5A1.5 1.5 0 1026 5.5 1.5017 1.5017 0 0024.5 4z"
                }
              }
            ],
            "name": "soccer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Soccer16",
          "filepath": "soccer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "28",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 17.5H15.45V19.5H7.55z",
                  "transform": "rotate(-45 11.5 18.5)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 16.584L19.4143 8H6v2H18.5857l3 3L6 28.5859 7.4141 30 23 14.415 26.584 18 23 21.5859 24.4141 23 28 19.416A2.0044 2.0044 0 0028 16.584zM24.5 9A3.5 3.5 0 1128 5.5 3.504 3.504 0 0124.5 9zm0-5A1.5 1.5 0 1026 5.5 1.5017 1.5017 0 0024.5 4z"
                }
              }
            ],
            "name": "soccer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Soccer",
        "global": "Soccer",
        "filepath": "Soccer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17",
                    "cy": "28",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.55 17.5H15.45V19.5H7.55z",
                    "transform": "rotate(-45 11.5 18.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 16.584L19.4143 8H6v2H18.5857l3 3L6 28.5859 7.4141 30 23 14.415 26.584 18 23 21.5859 24.4141 23 28 19.416A2.0044 2.0044 0 0028 16.584zM24.5 9A3.5 3.5 0 1128 5.5 3.504 3.504 0 0124.5 9zm0-5A1.5 1.5 0 1026 5.5 1.5017 1.5017 0 0024.5 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "software-resource",
      "friendlyName": "Software resource",
      "aliases": [
        "software",
        "systems",
        "resource",
        "diamond"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/software-resource.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\n\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\n\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__00000119812012335990934660000018356235523389216153_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z\"/></svg>",
            "info": {},
            "path": "32/software-resource.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoftwareResource32",
          "filepath": "software-resource/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "software-resource",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoftwareResource24",
          "filepath": "software-resource/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "software-resource",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoftwareResource20",
          "filepath": "software-resource/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "software-resource",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoftwareResource16",
          "filepath": "software-resource/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "software-resource",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SoftwareResource",
        "global": "SoftwareResource",
        "filepath": "SoftwareResource.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "software-resource--cluster",
      "friendlyName": "Software resource cluster",
      "aliases": [
        "software",
        "systems",
        "resource",
        "diamond",
        "cluster"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/software-resource--cluster.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M24,21c-0.5,0-1-0.2-1.4-0.6l-3-3C19.2,17,19,16.5,19,16s0.2-1,0.6-1.4l3-3C23,11.2,23.5,11,24,11c0.5,0,1,0.2,1.4,0.6l3,3\n\tC28.8,15,29,15.5,29,16c0,0.5-0.2,1-0.6,1.4l-3,3C25,20.8,24.5,21,24,21z M24,13l-3,3l3,3l3-3L24,13z\"/>\n<path d=\"M16,13c-0.5,0-1-0.2-1.4-0.6l-3-3C11.2,9,11,8.5,11,8s0.2-1,0.6-1.4l3-3C15,3.2,15.5,3,16,3c0.5,0,1,0.2,1.4,0.6l3,3\n\tC20.8,7,21,7.5,21,8c0,0.5-0.2,1-0.6,1.4l-3,3C17,12.8,16.5,13,16,13z M16,5l-3,3l3,3l3-3L16,5z\"/>\n<path d=\"M16,29c-0.5,0-1-0.2-1.4-0.6l-3-3C11.2,25,11,24.5,11,24s0.2-1,0.6-1.4l3-3C15,19.2,15.5,19,16,19c0.5,0,1,0.2,1.4,0.6l3,3\n\tC20.8,23,21,23.5,21,24c0,0.5-0.2,1-0.6,1.4l-3,3C17,28.8,16.5,29,16,29z M16,21l-3,3l3,3l3-3L16,21z\"/>\n<path d=\"M8,21c-0.5,0-1-0.2-1.4-0.6l-3-3C3.2,17,3,16.5,3,16s0.2-1,0.6-1.4l3-3C7,11.2,7.5,11,8,11c0.5,0,1,0.2,1.4,0.6l3,3\n\tC12.8,15,13,15.5,13,16c0,0.5-0.2,1-0.6,1.4l-3,3C9,20.8,8.5,21,8,21z M8,13l-3,3l3,3l3-3L8,13z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 21c-.5 0-1-.2-1.4-.6l-3-3C19.2 17 19 16.5 19 16s.2-1 .6-1.4l3-3C23 11.2 23.5 11 24 11c.5 0 1 .2 1.4.6l3 3C28.8 15 29 15.5 29 16c0 .5-.2 1-.6 1.4l-3 3C25 20.8 24.5 21 24 21zM24 13l-3 3 3 3 3-3L24 13zM16 13c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3C15 3.2 15.5 3 16 3c.5 0 1 .2 1.4.6l3 3C20.8 7 21 7.5 21 8c0 .5-.2 1-.6 1.4l-3 3C17 12.8 16.5 13 16 13zM16 5l-3 3 3 3 3-3L16 5zM16 29c-.5 0-1-.2-1.4-.6l-3-3C11.2 25 11 24.5 11 24s.2-1 .6-1.4l3-3C15 19.2 15.5 19 16 19c.5 0 1 .2 1.4.6l3 3C20.8 23 21 23.5 21 24c0 .5-.2 1-.6 1.4l-3 3C17 28.8 16.5 29 16 29zM16 21l-3 3 3 3 3-3L16 21zM8 21c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3C7 11.2 7.5 11 8 11c.5 0 1 .2 1.4.6l3 3C12.8 15 13 15.5 13 16c0 .5-.2 1-.6 1.4l-3 3C9 20.8 8.5 21 8 21zM8 13l-3 3 3 3 3-3L8 13z\"/></svg>",
            "info": {},
            "path": "32/software-resource--cluster.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoftwareResourceCluster32",
          "filepath": "software-resource--cluster/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21c-.5 0-1-.2-1.4-.6l-3-3C19.2 17 19 16.5 19 16s.2-1 .6-1.4l3-3C23 11.2 23.5 11 24 11c.5 0 1 .2 1.4.6l3 3C28.8 15 29 15.5 29 16c0 .5-.2 1-.6 1.4l-3 3C25 20.8 24.5 21 24 21zM24 13l-3 3 3 3 3-3L24 13zM16 13c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3C15 3.2 15.5 3 16 3c.5 0 1 .2 1.4.6l3 3C20.8 7 21 7.5 21 8c0 .5-.2 1-.6 1.4l-3 3C17 12.8 16.5 13 16 13zM16 5l-3 3 3 3 3-3L16 5zM16 29c-.5 0-1-.2-1.4-.6l-3-3C11.2 25 11 24.5 11 24s.2-1 .6-1.4l3-3C15 19.2 15.5 19 16 19c.5 0 1 .2 1.4.6l3 3C20.8 23 21 23.5 21 24c0 .5-.2 1-.6 1.4l-3 3C17 28.8 16.5 29 16 29zM16 21l-3 3 3 3 3-3L16 21zM8 21c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3C7 11.2 7.5 11 8 11c.5 0 1 .2 1.4.6l3 3C12.8 15 13 15.5 13 16c0 .5-.2 1-.6 1.4l-3 3C9 20.8 8.5 21 8 21zM8 13l-3 3 3 3 3-3L8 13z"
                }
              }
            ],
            "name": "software-resource--cluster",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoftwareResourceCluster24",
          "filepath": "software-resource--cluster/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21c-.5 0-1-.2-1.4-.6l-3-3C19.2 17 19 16.5 19 16s.2-1 .6-1.4l3-3C23 11.2 23.5 11 24 11c.5 0 1 .2 1.4.6l3 3C28.8 15 29 15.5 29 16c0 .5-.2 1-.6 1.4l-3 3C25 20.8 24.5 21 24 21zM24 13l-3 3 3 3 3-3L24 13zM16 13c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3C15 3.2 15.5 3 16 3c.5 0 1 .2 1.4.6l3 3C20.8 7 21 7.5 21 8c0 .5-.2 1-.6 1.4l-3 3C17 12.8 16.5 13 16 13zM16 5l-3 3 3 3 3-3L16 5zM16 29c-.5 0-1-.2-1.4-.6l-3-3C11.2 25 11 24.5 11 24s.2-1 .6-1.4l3-3C15 19.2 15.5 19 16 19c.5 0 1 .2 1.4.6l3 3C20.8 23 21 23.5 21 24c0 .5-.2 1-.6 1.4l-3 3C17 28.8 16.5 29 16 29zM16 21l-3 3 3 3 3-3L16 21zM8 21c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3C7 11.2 7.5 11 8 11c.5 0 1 .2 1.4.6l3 3C12.8 15 13 15.5 13 16c0 .5-.2 1-.6 1.4l-3 3C9 20.8 8.5 21 8 21zM8 13l-3 3 3 3 3-3L8 13z"
                }
              }
            ],
            "name": "software-resource--cluster",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoftwareResourceCluster20",
          "filepath": "software-resource--cluster/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21c-.5 0-1-.2-1.4-.6l-3-3C19.2 17 19 16.5 19 16s.2-1 .6-1.4l3-3C23 11.2 23.5 11 24 11c.5 0 1 .2 1.4.6l3 3C28.8 15 29 15.5 29 16c0 .5-.2 1-.6 1.4l-3 3C25 20.8 24.5 21 24 21zM24 13l-3 3 3 3 3-3L24 13zM16 13c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3C15 3.2 15.5 3 16 3c.5 0 1 .2 1.4.6l3 3C20.8 7 21 7.5 21 8c0 .5-.2 1-.6 1.4l-3 3C17 12.8 16.5 13 16 13zM16 5l-3 3 3 3 3-3L16 5zM16 29c-.5 0-1-.2-1.4-.6l-3-3C11.2 25 11 24.5 11 24s.2-1 .6-1.4l3-3C15 19.2 15.5 19 16 19c.5 0 1 .2 1.4.6l3 3C20.8 23 21 23.5 21 24c0 .5-.2 1-.6 1.4l-3 3C17 28.8 16.5 29 16 29zM16 21l-3 3 3 3 3-3L16 21zM8 21c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3C7 11.2 7.5 11 8 11c.5 0 1 .2 1.4.6l3 3C12.8 15 13 15.5 13 16c0 .5-.2 1-.6 1.4l-3 3C9 20.8 8.5 21 8 21zM8 13l-3 3 3 3 3-3L8 13z"
                }
              }
            ],
            "name": "software-resource--cluster",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoftwareResourceCluster16",
          "filepath": "software-resource--cluster/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21c-.5 0-1-.2-1.4-.6l-3-3C19.2 17 19 16.5 19 16s.2-1 .6-1.4l3-3C23 11.2 23.5 11 24 11c.5 0 1 .2 1.4.6l3 3C28.8 15 29 15.5 29 16c0 .5-.2 1-.6 1.4l-3 3C25 20.8 24.5 21 24 21zM24 13l-3 3 3 3 3-3L24 13zM16 13c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3C15 3.2 15.5 3 16 3c.5 0 1 .2 1.4.6l3 3C20.8 7 21 7.5 21 8c0 .5-.2 1-.6 1.4l-3 3C17 12.8 16.5 13 16 13zM16 5l-3 3 3 3 3-3L16 5zM16 29c-.5 0-1-.2-1.4-.6l-3-3C11.2 25 11 24.5 11 24s.2-1 .6-1.4l3-3C15 19.2 15.5 19 16 19c.5 0 1 .2 1.4.6l3 3C20.8 23 21 23.5 21 24c0 .5-.2 1-.6 1.4l-3 3C17 28.8 16.5 29 16 29zM16 21l-3 3 3 3 3-3L16 21zM8 21c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3C7 11.2 7.5 11 8 11c.5 0 1 .2 1.4.6l3 3C12.8 15 13 15.5 13 16c0 .5-.2 1-.6 1.4l-3 3C9 20.8 8.5 21 8 21zM8 13l-3 3 3 3 3-3L8 13z"
                }
              }
            ],
            "name": "software-resource--cluster",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SoftwareResourceCluster",
        "global": "SoftwareResourceCluster",
        "filepath": "SoftwareResourceCluster.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 21c-.5 0-1-.2-1.4-.6l-3-3C19.2 17 19 16.5 19 16s.2-1 .6-1.4l3-3C23 11.2 23.5 11 24 11c.5 0 1 .2 1.4.6l3 3C28.8 15 29 15.5 29 16c0 .5-.2 1-.6 1.4l-3 3C25 20.8 24.5 21 24 21zM24 13l-3 3 3 3 3-3L24 13zM16 13c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3C15 3.2 15.5 3 16 3c.5 0 1 .2 1.4.6l3 3C20.8 7 21 7.5 21 8c0 .5-.2 1-.6 1.4l-3 3C17 12.8 16.5 13 16 13zM16 5l-3 3 3 3 3-3L16 5zM16 29c-.5 0-1-.2-1.4-.6l-3-3C11.2 25 11 24.5 11 24s.2-1 .6-1.4l3-3C15 19.2 15.5 19 16 19c.5 0 1 .2 1.4.6l3 3C20.8 23 21 23.5 21 24c0 .5-.2 1-.6 1.4l-3 3C17 28.8 16.5 29 16 29zM16 21l-3 3 3 3 3-3L16 21zM8 21c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3C7 11.2 7.5 11 8 11c.5 0 1 .2 1.4.6l3 3C12.8 15 13 15.5 13 16c0 .5-.2 1-.6 1.4l-3 3C9 20.8 8.5 21 8 21zM8 13l-3 3 3 3 3-3L8 13z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "software-resource--resource",
      "friendlyName": "Software resource reference",
      "aliases": [
        "software",
        "systems",
        "resource",
        "diamond",
        "reference",
        "dashed"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/software-resource--resource.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"6.9\" y=\"8.3\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -3.8493 9.2931)\" width=\"4.8\" height=\"2\"/>\n<path d=\"M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z\"/>\n<rect x=\"8.3\" y=\"20.3\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -13.3343 13.2219)\" width=\"2\" height=\"4.8\"/>\n<path d=\"M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z\"/>\n<rect x=\"20.3\" y=\"21.7\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -9.4055 22.7069)\" width=\"4.8\" height=\"2\"/>\n<path d=\"M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z\"/>\n<rect x=\"21.7\" y=\"6.9\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 7.949218e-02 18.7781)\" width=\"2\" height=\"4.8\"/>\n<path d=\"M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6.9 8.3H11.7V10.3H6.9z\" transform=\"rotate(-45.001 9.293 9.293)\"/><path d=\"M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z\"/><path d=\"M8.3 20.3H10.3V25.1H8.3z\" transform=\"rotate(-45.001 9.293 22.707)\"/><path d=\"M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z\"/><path d=\"M20.3 21.7H25.1V23.7H20.3z\" transform=\"rotate(-45.001 22.707 22.707)\"/><path d=\"M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z\"/><path d=\"M21.7 6.9H23.7V11.7H21.7z\" transform=\"rotate(-45.001 22.707 9.293)\"/><path d=\"M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z\"/></svg>",
            "info": {},
            "path": "32/software-resource--resource.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoftwareResourceResource32",
          "filepath": "software-resource--resource/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9 8.3H11.7V10.3H6.9z",
                  "transform": "rotate(-45.001 9.293 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.3 20.3H10.3V25.1H8.3z",
                  "transform": "rotate(-45.001 9.293 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3 21.7H25.1V23.7H20.3z",
                  "transform": "rotate(-45.001 22.707 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7 6.9H23.7V11.7H21.7z",
                  "transform": "rotate(-45.001 22.707 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
                }
              }
            ],
            "name": "software-resource--resource",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoftwareResourceResource24",
          "filepath": "software-resource--resource/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9 8.3H11.7V10.3H6.9z",
                  "transform": "rotate(-45.001 9.293 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.3 20.3H10.3V25.1H8.3z",
                  "transform": "rotate(-45.001 9.293 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3 21.7H25.1V23.7H20.3z",
                  "transform": "rotate(-45.001 22.707 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7 6.9H23.7V11.7H21.7z",
                  "transform": "rotate(-45.001 22.707 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
                }
              }
            ],
            "name": "software-resource--resource",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoftwareResourceResource20",
          "filepath": "software-resource--resource/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9 8.3H11.7V10.3H6.9z",
                  "transform": "rotate(-45.001 9.293 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.3 20.3H10.3V25.1H8.3z",
                  "transform": "rotate(-45.001 9.293 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3 21.7H25.1V23.7H20.3z",
                  "transform": "rotate(-45.001 22.707 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7 6.9H23.7V11.7H21.7z",
                  "transform": "rotate(-45.001 22.707 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
                }
              }
            ],
            "name": "software-resource--resource",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoftwareResourceResource16",
          "filepath": "software-resource--resource/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9 8.3H11.7V10.3H6.9z",
                  "transform": "rotate(-45.001 9.293 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.3 20.3H10.3V25.1H8.3z",
                  "transform": "rotate(-45.001 9.293 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.3 21.7H25.1V23.7H20.3z",
                  "transform": "rotate(-45.001 22.707 22.707)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.7 6.9H23.7V11.7H21.7z",
                  "transform": "rotate(-45.001 22.707 9.293)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
                }
              }
            ],
            "name": "software-resource--resource",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SoftwareResourceResource",
        "global": "SoftwareResourceResource",
        "filepath": "SoftwareResourceResource.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.9 8.3H11.7V10.3H6.9z",
                    "transform": "rotate(-45.001 9.293 9.293)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.3 20.3H10.3V25.1H8.3z",
                    "transform": "rotate(-45.001 9.293 22.707)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.3 21.7H25.1V23.7H20.3z",
                    "transform": "rotate(-45.001 22.707 22.707)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.7 6.9H23.7V11.7H21.7z",
                    "transform": "rotate(-45.001 22.707 9.293)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "soil-moisture",
      "friendlyName": "Soil moisture",
      "aliases": [
        "soil",
        "moisture",
        "agriculture"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/soil-moisture.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"5\" cy=\"13\" r=\"1\"/>\n  <circle cx=\"11\" cy=\"19\" r=\"1\"/>\n  <circle cx=\"15\" cy=\"25\" r=\"1\"/>\n  <circle cx=\"17\" cy=\"15\" r=\"1\"/>\n  <circle cx=\"13\" cy=\"11\" r=\"1\"/>\n  <circle cx=\"27\" cy=\"11\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"27\" r=\"1\"/>\n  <circle cx=\"3\" cy=\"21\" r=\"1\"/>\n  <rect x=\"2\" y=\"6\" width=\"28\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z\"/><circle cx=\"5\" cy=\"13\" r=\"1\"/><circle cx=\"11\" cy=\"19\" r=\"1\"/><circle cx=\"15\" cy=\"25\" r=\"1\"/><circle cx=\"17\" cy=\"15\" r=\"1\"/><circle cx=\"13\" cy=\"11\" r=\"1\"/><circle cx=\"27\" cy=\"11\" r=\"1\"/><circle cx=\"9\" cy=\"27\" r=\"1\"/><circle cx=\"3\" cy=\"21\" r=\"1\"/><path d=\"M2 6H30V8H2z\"/></svg>",
            "info": {},
            "path": "32/soil-moisture.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoilMoisture32",
          "filepath": "soil-moisture/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-moisture",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoilMoisture24",
          "filepath": "soil-moisture/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-moisture",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoilMoisture20",
          "filepath": "soil-moisture/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-moisture",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoilMoisture16",
          "filepath": "soil-moisture/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "27",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-moisture",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SoilMoisture",
        "global": "SoilMoisture",
        "filepath": "SoilMoisture.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "5",
                    "cy": "13",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "19",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17",
                    "cy": "15",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "27",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "27",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "21",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 6H30V8H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "soil-moisture--field",
      "friendlyName": "Soil moisture field",
      "aliases": [
        "soil",
        "moisture",
        "agriculture",
        "field"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/soil-moisture--field.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24.5,30a5.202,5.202,0,0,1-4.626-8.08L23.49,16.5382a1.217,1.217,0,0,1,2.02,0L29.06,21.8154A5.4921,5.4921,0,0,1,30,24.751,5.385,5.385,0,0,1,24.5,30Zm0-11.38-2.9356,4.3672A3.2079,3.2079,0,0,0,24.5,28,3.3855,3.3855,0,0,0,28,24.751a3.4354,3.4354,0,0,0-.63-1.867Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,16V11h1a4.0045,4.0045,0,0,0,4-4V4H13a3.9779,3.9779,0,0,0-2.7468,1.1067A6.0034,6.0034,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.002,2.002,0,0,1,13,6ZM8,9A4.0045,4.0045,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"21\" width=\"14\" height=\"2\"/>\n  <rect x=\"2\" y=\"26\" width=\"14\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.5 30a5.202 5.202 0 01-4.626-8.08L23.49 16.5382a1.217 1.217 0 012.02 0L29.06 21.8154A5.4921 5.4921 0 0130 24.751 5.385 5.385 0 0124.5 30zm0-11.38l-2.9356 4.3672A3.2079 3.2079 0 0024.5 28 3.3855 3.3855 0 0028 24.751a3.4354 3.4354 0 00-.63-1.867zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2z\"/></svg>",
            "info": {},
            "path": "32/soil-moisture--field.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoilMoistureField32",
          "filepath": "soil-moisture--field/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 30a5.202 5.202 0 01-4.626-8.08L23.49 16.5382a1.217 1.217 0 012.02 0L29.06 21.8154A5.4921 5.4921 0 0130 24.751 5.385 5.385 0 0124.5 30zm0-11.38l-2.9356 4.3672A3.2079 3.2079 0 0024.5 28 3.3855 3.3855 0 0028 24.751a3.4354 3.4354 0 00-.63-1.867zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2z"
                }
              }
            ],
            "name": "soil-moisture--field",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoilMoistureField24",
          "filepath": "soil-moisture--field/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 30a5.202 5.202 0 01-4.626-8.08L23.49 16.5382a1.217 1.217 0 012.02 0L29.06 21.8154A5.4921 5.4921 0 0130 24.751 5.385 5.385 0 0124.5 30zm0-11.38l-2.9356 4.3672A3.2079 3.2079 0 0024.5 28 3.3855 3.3855 0 0028 24.751a3.4354 3.4354 0 00-.63-1.867zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2z"
                }
              }
            ],
            "name": "soil-moisture--field",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoilMoistureField20",
          "filepath": "soil-moisture--field/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 30a5.202 5.202 0 01-4.626-8.08L23.49 16.5382a1.217 1.217 0 012.02 0L29.06 21.8154A5.4921 5.4921 0 0130 24.751 5.385 5.385 0 0124.5 30zm0-11.38l-2.9356 4.3672A3.2079 3.2079 0 0024.5 28 3.3855 3.3855 0 0028 24.751a3.4354 3.4354 0 00-.63-1.867zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2z"
                }
              }
            ],
            "name": "soil-moisture--field",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoilMoistureField16",
          "filepath": "soil-moisture--field/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.5 30a5.202 5.202 0 01-4.626-8.08L23.49 16.5382a1.217 1.217 0 012.02 0L29.06 21.8154A5.4921 5.4921 0 0130 24.751 5.385 5.385 0 0124.5 30zm0-11.38l-2.9356 4.3672A3.2079 3.2079 0 0024.5 28 3.3855 3.3855 0 0028 24.751a3.4354 3.4354 0 00-.63-1.867zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2z"
                }
              }
            ],
            "name": "soil-moisture--field",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SoilMoistureField",
        "global": "SoilMoistureField",
        "filepath": "SoilMoistureField.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.5 30a5.202 5.202 0 01-4.626-8.08L23.49 16.5382a1.217 1.217 0 012.02 0L29.06 21.8154A5.4921 5.4921 0 0130 24.751 5.385 5.385 0 0124.5 30zm0-11.38l-2.9356 4.3672A3.2079 3.2079 0 0024.5 28 3.3855 3.3855 0 0028 24.751a3.4354 3.4354 0 00-.63-1.867zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "soil-moisture--global",
      "friendlyName": "Soil moisture global",
      "aliases": [
        "soil",
        "moisture",
        "agriculture",
        "global"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/soil-moisture--global.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,30a4.7347,4.7347,0,0,1-4.2075-7.35l3.3687-5.1942a1,1,0,0,1,1.6779,0l3.3152,5.11A4.9753,4.9753,0,0,1,30,25.2231,4.8979,4.8979,0,0,1,25,30Zm0-10.1629-2.5078,3.8662A2.9264,2.9264,0,1,0,28,25.2231a2.96,2.96,0,0,0-.5444-1.6028Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 30a4.7347 4.7347 0 01-4.2075-7.35l3.3687-5.1942a1 1 0 011.6779 0l3.3152 5.11A4.9753 4.9753 0 0130 25.2231 4.8979 4.8979 0 0125 30zm0-10.1629l-2.5078 3.8662A2.9264 2.9264 0 1028 25.2231a2.96 2.96 0 00-.5444-1.6028zM11 24H9A17.0192 17.0192 0 0126 7h4V9H26A15.017 15.017 0 0011 24z\"/><path d=\"M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z\"/><path d=\"M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z\"/></svg>",
            "info": {},
            "path": "32/soil-moisture--global.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoilMoistureGlobal32",
          "filepath": "soil-moisture--global/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.7347 4.7347 0 01-4.2075-7.35l3.3687-5.1942a1 1 0 011.6779 0l3.3152 5.11A4.9753 4.9753 0 0130 25.2231 4.8979 4.8979 0 0125 30zm0-10.1629l-2.5078 3.8662A2.9264 2.9264 0 1028 25.2231a2.96 2.96 0 00-.5444-1.6028zM11 24H9A17.0192 17.0192 0 0126 7h4V9H26A15.017 15.017 0 0011 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-moisture--global",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoilMoistureGlobal24",
          "filepath": "soil-moisture--global/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.7347 4.7347 0 01-4.2075-7.35l3.3687-5.1942a1 1 0 011.6779 0l3.3152 5.11A4.9753 4.9753 0 0130 25.2231 4.8979 4.8979 0 0125 30zm0-10.1629l-2.5078 3.8662A2.9264 2.9264 0 1028 25.2231a2.96 2.96 0 00-.5444-1.6028zM11 24H9A17.0192 17.0192 0 0126 7h4V9H26A15.017 15.017 0 0011 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-moisture--global",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoilMoistureGlobal20",
          "filepath": "soil-moisture--global/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.7347 4.7347 0 01-4.2075-7.35l3.3687-5.1942a1 1 0 011.6779 0l3.3152 5.11A4.9753 4.9753 0 0130 25.2231 4.8979 4.8979 0 0125 30zm0-10.1629l-2.5078 3.8662A2.9264 2.9264 0 1028 25.2231a2.96 2.96 0 00-.5444-1.6028zM11 24H9A17.0192 17.0192 0 0126 7h4V9H26A15.017 15.017 0 0011 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-moisture--global",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoilMoistureGlobal16",
          "filepath": "soil-moisture--global/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.7347 4.7347 0 01-4.2075-7.35l3.3687-5.1942a1 1 0 011.6779 0l3.3152 5.11A4.9753 4.9753 0 0130 25.2231 4.8979 4.8979 0 0125 30zm0-10.1629l-2.5078 3.8662A2.9264 2.9264 0 1028 25.2231a2.96 2.96 0 00-.5444-1.6028zM11 24H9A17.0192 17.0192 0 0126 7h4V9H26A15.017 15.017 0 0011 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-moisture--global",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SoilMoistureGlobal",
        "global": "SoilMoistureGlobal",
        "filepath": "SoilMoistureGlobal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 30a4.7347 4.7347 0 01-4.2075-7.35l3.3687-5.1942a1 1 0 011.6779 0l3.3152 5.11A4.9753 4.9753 0 0130 25.2231 4.8979 4.8979 0 0125 30zm0-10.1629l-2.5078 3.8662A2.9264 2.9264 0 1028 25.2231a2.96 2.96 0 00-.5444-1.6028zM11 24H9A17.0192 17.0192 0 0126 7h4V9H26A15.017 15.017 0 0011 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "soil-temperature",
      "friendlyName": "Soil temperature",
      "aliases": [
        "soil",
        "temperature",
        "agriculture"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/soil-temperature.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"5\" cy=\"13\" r=\"1\"/>\n  <circle cx=\"11\" cy=\"19\" r=\"1\"/>\n  <circle cx=\"15\" cy=\"25\" r=\"1\"/>\n  <circle cx=\"17\" cy=\"15\" r=\"1\"/>\n  <circle cx=\"13\" cy=\"11\" r=\"1\"/>\n  <circle cx=\"9\" cy=\"27\" r=\"1\"/>\n  <circle cx=\"3\" cy=\"21\" r=\"1\"/>\n  <path d=\"M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"6\" width=\"28\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"5\" cy=\"13\" r=\"1\"/><circle cx=\"11\" cy=\"19\" r=\"1\"/><circle cx=\"15\" cy=\"25\" r=\"1\"/><circle cx=\"17\" cy=\"15\" r=\"1\"/><circle cx=\"13\" cy=\"11\" r=\"1\"/><circle cx=\"9\" cy=\"27\" r=\"1\"/><circle cx=\"3\" cy=\"21\" r=\"1\"/><path d=\"M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM2 6H30V8H2z\"/></svg>",
            "info": {},
            "path": "32/soil-temperature.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoilTemperature32",
          "filepath": "soil-temperature/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-temperature",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoilTemperature24",
          "filepath": "soil-temperature/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-temperature",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoilTemperature20",
          "filepath": "soil-temperature/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-temperature",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoilTemperature16",
          "filepath": "soil-temperature/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "5",
                  "cy": "13",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "11",
                  "cy": "19",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "15",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "17",
                  "cy": "15",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "13",
                  "cy": "11",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "27",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "3",
                  "cy": "21",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM2 6H30V8H2z"
                }
              }
            ],
            "name": "soil-temperature",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SoilTemperature",
        "global": "SoilTemperature",
        "filepath": "SoilTemperature.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "5",
                    "cy": "13",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "11",
                    "cy": "19",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "15",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "17",
                    "cy": "15",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "13",
                    "cy": "11",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "27",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "3",
                    "cy": "21",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM2 6H30V8H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "soil-temperature--field",
      "friendlyName": "Soil temperature field",
      "aliases": [
        "soil",
        "temperature",
        "agriculture",
        "field"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/soil-temperature--field.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M11,16V11h1a4.0045,4.0045,0,0,0,4-4V4H13a3.9779,3.9779,0,0,0-2.7468,1.1067A6.0034,6.0034,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.002,2.002,0,0,1,13,6ZM8,9A4.0045,4.0045,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"2\" y=\"21\" width=\"14\" height=\"2\"/>\n  <rect x=\"2\" y=\"26\" width=\"14\" height=\"2\"/>\n  <path d=\"M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2zM25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14z\"/></svg>",
            "info": {},
            "path": "32/soil-temperature--field.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoilTemperatureField32",
          "filepath": "soil-temperature--field/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2zM25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14z"
                }
              }
            ],
            "name": "soil-temperature--field",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoilTemperatureField24",
          "filepath": "soil-temperature--field/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2zM25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14z"
                }
              }
            ],
            "name": "soil-temperature--field",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoilTemperatureField20",
          "filepath": "soil-temperature--field/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2zM25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14z"
                }
              }
            ],
            "name": "soil-temperature--field",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoilTemperatureField16",
          "filepath": "soil-temperature--field/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2zM25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14z"
                }
              }
            ],
            "name": "soil-temperature--field",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SoilTemperatureField",
        "global": "SoilTemperatureField",
        "filepath": "SoilTemperatureField.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9zM2 21H16V23H2zM2 26H16V28H2zM25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "soil-temperature--global",
      "friendlyName": "Soil temperature global",
      "aliases": [
        "global",
        "soil",
        "temperature",
        "agriculture"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/soil-temperature--global.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,24H14a11.89,11.89,0,0,1,3.7642-8.7271l1.373,1.4542A9.909,9.909,0,0,0,16,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM16 24H14a11.89 11.89 0 013.7642-8.7271l1.373 1.4542A9.909 9.909 0 0016 24z\"/><path d=\"M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z\"/><path d=\"M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z\"/></svg>",
            "info": {},
            "path": "32/soil-temperature--global.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SoilTemperatureGlobal32",
          "filepath": "soil-temperature--global/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM16 24H14a11.89 11.89 0 013.7642-8.7271l1.373 1.4542A9.909 9.909 0 0016 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-temperature--global",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SoilTemperatureGlobal24",
          "filepath": "soil-temperature--global/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM16 24H14a11.89 11.89 0 013.7642-8.7271l1.373 1.4542A9.909 9.909 0 0016 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-temperature--global",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SoilTemperatureGlobal20",
          "filepath": "soil-temperature--global/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM16 24H14a11.89 11.89 0 013.7642-8.7271l1.373 1.4542A9.909 9.909 0 0016 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-temperature--global",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SoilTemperatureGlobal16",
          "filepath": "soil-temperature--global/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM16 24H14a11.89 11.89 0 013.7642-8.7271l1.373 1.4542A9.909 9.909 0 0016 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                }
              }
            ],
            "name": "soil-temperature--global",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SoilTemperatureGlobal",
        "global": "SoilTemperatureGlobal",
        "filepath": "SoilTemperatureGlobal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 30a4.9863 4.9863 0 01-3-8.98V15a3 3 0 016 0v6.02A4.9863 4.9863 0 0125 30zm0-16a1.0011 1.0011 0 00-1 1v7.13l-.4971.2893A2.9676 2.9676 0 0022 25a3 3 0 006 0 2.9676 2.9676 0 00-1.5029-2.5811L26 22.13V15A1.0011 1.0011 0 0025 14zM16 24H14a11.89 11.89 0 013.7642-8.7271l1.373 1.4542A9.909 9.909 0 0016 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "solar-panel",
      "friendlyName": "Solar panel",
      "aliases": [
        "weather",
        "solar",
        "panel",
        "green",
        "energy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/solar-panel.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,26V14H13V26h5v2H2v2H30V28H25V26Zm-5-2V21h3v3Zm-2-3v3H20V21Zm-3-2V16h3v3Zm8,0H25V16h3ZM18,16v3H15V16Zm-3,8V21h3v3Zm8,4H20V26h3Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9.3328,14.981A4,4,0,1,1,16,12H14a2,2,0,1,0-3.3333,1.4907Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"11\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"2\" y=\"11\" width=\"4\" height=\"2\"/>\n  <rect x=\"5.3431\" y=\"4.3431\" width=\"2\" height=\"4\" transform=\"translate(-2.6274 6.3431) rotate(-45)\"/>\n  <rect x=\"16.6569\" y=\"4.3431\" width=\"2\" height=\"4\" transform=\"translate(25.6569 23.3137) rotate(-135)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 26V14H13V26h5v2H2v2H30V28H25V26zm-5-2V21h3v3zm-2-3v3H20V21zm-3-2V16h3v3zm8 0H25V16h3zM18 16v3H15V16zm-3 8V21h3v3zm8 4H20V26h3zM9.3328 14.981A4 4 0 1116 12H14a2 2 0 10-3.3333 1.4907zM11 2H13V6H11zM2 11H6V13H2z\"/><path d=\"M5.343 4.343H7.343V8.343H5.343z\" transform=\"rotate(-45 6.343 6.343)\"/><path d=\"M16.657 4.343H18.657V8.343H16.657z\" transform=\"rotate(-135 17.657 6.343)\"/></svg>",
            "info": {},
            "path": "32/solar-panel.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SolarPanel32",
          "filepath": "solar-panel/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26V14H13V26h5v2H2v2H30V28H25V26zm-5-2V21h3v3zm-2-3v3H20V21zm-3-2V16h3v3zm8 0H25V16h3zM18 16v3H15V16zm-3 8V21h3v3zm8 4H20V26h3zM9.3328 14.981A4 4 0 1116 12H14a2 2 0 10-3.3333 1.4907zM11 2H13V6H11zM2 11H6V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.343 4.343H7.343V8.343H5.343z",
                  "transform": "rotate(-45 6.343 6.343)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.657 4.343H18.657V8.343H16.657z",
                  "transform": "rotate(-135 17.657 6.343)"
                }
              }
            ],
            "name": "solar-panel",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SolarPanel24",
          "filepath": "solar-panel/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26V14H13V26h5v2H2v2H30V28H25V26zm-5-2V21h3v3zm-2-3v3H20V21zm-3-2V16h3v3zm8 0H25V16h3zM18 16v3H15V16zm-3 8V21h3v3zm8 4H20V26h3zM9.3328 14.981A4 4 0 1116 12H14a2 2 0 10-3.3333 1.4907zM11 2H13V6H11zM2 11H6V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.343 4.343H7.343V8.343H5.343z",
                  "transform": "rotate(-45 6.343 6.343)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.657 4.343H18.657V8.343H16.657z",
                  "transform": "rotate(-135 17.657 6.343)"
                }
              }
            ],
            "name": "solar-panel",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SolarPanel20",
          "filepath": "solar-panel/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26V14H13V26h5v2H2v2H30V28H25V26zm-5-2V21h3v3zm-2-3v3H20V21zm-3-2V16h3v3zm8 0H25V16h3zM18 16v3H15V16zm-3 8V21h3v3zm8 4H20V26h3zM9.3328 14.981A4 4 0 1116 12H14a2 2 0 10-3.3333 1.4907zM11 2H13V6H11zM2 11H6V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.343 4.343H7.343V8.343H5.343z",
                  "transform": "rotate(-45 6.343 6.343)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.657 4.343H18.657V8.343H16.657z",
                  "transform": "rotate(-135 17.657 6.343)"
                }
              }
            ],
            "name": "solar-panel",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SolarPanel16",
          "filepath": "solar-panel/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26V14H13V26h5v2H2v2H30V28H25V26zm-5-2V21h3v3zm-2-3v3H20V21zm-3-2V16h3v3zm8 0H25V16h3zM18 16v3H15V16zm-3 8V21h3v3zm8 4H20V26h3zM9.3328 14.981A4 4 0 1116 12H14a2 2 0 10-3.3333 1.4907zM11 2H13V6H11zM2 11H6V13H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.343 4.343H7.343V8.343H5.343z",
                  "transform": "rotate(-45 6.343 6.343)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.657 4.343H18.657V8.343H16.657z",
                  "transform": "rotate(-135 17.657 6.343)"
                }
              }
            ],
            "name": "solar-panel",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "SolarPanel",
        "global": "SolarPanel",
        "filepath": "SolarPanel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 26V14H13V26h5v2H2v2H30V28H25V26zm-5-2V21h3v3zm-2-3v3H20V21zm-3-2V16h3v3zm8 0H25V16h3zM18 16v3H15V16zm-3 8V21h3v3zm8 4H20V26h3zM9.3328 14.981A4 4 0 1116 12H14a2 2 0 10-3.3333 1.4907zM11 2H13V6H11zM2 11H6V13H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.343 4.343H7.343V8.343H5.343z",
                    "transform": "rotate(-45 6.343 6.343)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.657 4.343H18.657V8.343H16.657z",
                    "transform": "rotate(-135 17.657 6.343)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sort--ascending",
      "friendlyName": "Sort ascending",
      "aliases": [
        "sort order",
        "order",
        "ascending",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sort--ascending.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"18 22 19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22\"/>\n  <rect x=\"2\" y=\"18\" width=\"14\" height=\"2\"/>\n  <rect x=\"6\" y=\"12\" width=\"10\" height=\"2\"/>\n  <rect x=\"10\" y=\"6\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 18H16V20H2zM6 12H16V14H6zM10 6H16V8H10z\"/></svg>",
            "info": {},
            "path": "32/sort--ascending.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SortAscending32",
          "filepath": "sort--ascending/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 18H16V20H2zM6 12H16V14H6zM10 6H16V8H10z"
                }
              }
            ],
            "name": "sort--ascending",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SortAscending24",
          "filepath": "sort--ascending/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 18H16V20H2zM6 12H16V14H6zM10 6H16V8H10z"
                }
              }
            ],
            "name": "sort--ascending",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SortAscending20",
          "filepath": "sort--ascending/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 18H16V20H2zM6 12H16V14H6zM10 6H16V8H10z"
                }
              }
            ],
            "name": "sort--ascending",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SortAscending16",
          "filepath": "sort--ascending/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 18H16V20H2zM6 12H16V14H6zM10 6H16V8H10z"
                }
              }
            ],
            "name": "sort--ascending",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SortAscending",
        "global": "SortAscending",
        "filepath": "SortAscending.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 18H16V20H2zM6 12H16V14H6zM10 6H16V8H10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sort--descending",
      "friendlyName": "Sort descending",
      "aliases": [
        "sort order",
        "order",
        "descending",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sort--descending.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"18 22 19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22\"/>\n  <rect x=\"2\" y=\"6\" width=\"14\" height=\"2\"/>\n  <rect x=\"6\" y=\"12\" width=\"10\" height=\"2\"/>\n  <rect x=\"10\" y=\"18\" width=\"6\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 6H16V8H2zM6 12H16V14H6zM10 18H16V20H10z\"/></svg>",
            "info": {},
            "path": "32/sort--descending.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SortDescending32",
          "filepath": "sort--descending/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 6H16V8H2zM6 12H16V14H6zM10 18H16V20H10z"
                }
              }
            ],
            "name": "sort--descending",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SortDescending24",
          "filepath": "sort--descending/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 6H16V8H2zM6 12H16V14H6zM10 18H16V20H10z"
                }
              }
            ],
            "name": "sort--descending",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SortDescending20",
          "filepath": "sort--descending/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 6H16V8H2zM6 12H16V14H6zM10 18H16V20H10z"
                }
              }
            ],
            "name": "sort--descending",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SortDescending16",
          "filepath": "sort--descending/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 6H16V8H2zM6 12H16V14H6zM10 18H16V20H10z"
                }
              }
            ],
            "name": "sort--descending",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SortDescending",
        "global": "SortDescending",
        "filepath": "SortDescending.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22zM2 6H16V8H2zM6 12H16V14H6zM10 18H16V20H10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sort--remove",
      "friendlyName": "Sort remove",
      "aliases": [
        "sort order",
        "order",
        "remove",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sort--remove.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 19.415 28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415\"/>\n  <rect x=\"10\" y=\"18\" width=\"6\" height=\"2\"/>\n  <rect x=\"2\" y=\"6\" width=\"14\" height=\"2\"/>\n  <rect x=\"6\" y=\"12\" width=\"10\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415zM10 18H16V20H10zM2 6H16V8H2zM6 12H16V14H6z\"/></svg>",
            "info": {},
            "path": "32/sort--remove.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SortRemove32",
          "filepath": "sort--remove/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415zM10 18H16V20H10zM2 6H16V8H2zM6 12H16V14H6z"
                }
              }
            ],
            "name": "sort--remove",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SortRemove24",
          "filepath": "sort--remove/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415zM10 18H16V20H10zM2 6H16V8H2zM6 12H16V14H6z"
                }
              }
            ],
            "name": "sort--remove",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SortRemove20",
          "filepath": "sort--remove/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415zM10 18H16V20H10zM2 6H16V8H2zM6 12H16V14H6z"
                }
              }
            ],
            "name": "sort--remove",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SortRemove16",
          "filepath": "sort--remove/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415zM10 18H16V20H10zM2 6H16V8H2zM6 12H16V14H6z"
                }
              }
            ],
            "name": "sort--remove",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SortRemove",
        "global": "SortRemove",
        "filepath": "SortRemove.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415zM10 18H16V20H10zM2 6H16V8H2zM6 12H16V14H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "spell-check",
      "friendlyName": "Spell check",
      "aliases": [
        "check",
        "correction",
        "spelling",
        "type",
        "tool",
        "school",
        "writing",
        "grammar",
        "education"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/spell-check.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>spell-check</title><path d=\"M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z\"/><path d=\"M12,28H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V17H26V6H6V26h6Z\"/><polygon points=\"23 27.18 20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z\"/><path d=\"M12 28H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2V17H26V6H6V26h6zM23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z\"/></svg>",
            "info": {},
            "path": "32/spell-check.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SpellCheck32",
          "filepath": "spell-check/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 28H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2V17H26V6H6V26h6zM23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              }
            ],
            "name": "spell-check",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SpellCheck24",
          "filepath": "spell-check/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 28H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2V17H26V6H6V26h6zM23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              }
            ],
            "name": "spell-check",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SpellCheck20",
          "filepath": "spell-check/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 28H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2V17H26V6H6V26h6zM23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              }
            ],
            "name": "spell-check",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SpellCheck16",
          "filepath": "spell-check/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 28H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2V17H26V6H6V26h6zM23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                }
              }
            ],
            "name": "spell-check",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "SpellCheck",
        "global": "SpellCheck",
        "filepath": "SpellCheck.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 28H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2V17H26V6H6V26h6zM23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "spine-label",
      "friendlyName": "Spine label",
      "aliases": [
        "backbone",
        "stack",
        "pointer",
        "gap",
        "annotate"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/spine-label.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--spine-label</title><polygon points=\"3 11 3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11\"/><path d=\"M26,13H23V12H21v1H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h3v1h2V19h3a2,2,0,0,0,2-2V15A2,2,0,0,0,26,13Zm-8,4V15h8v2Z\"/><path d=\"M26,23H23V22H21v1H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h3v1h2V29h3a2,2,0,0,0,2-2V25A2,2,0,0,0,26,23Zm-8,4V25h8v2Z\"/><path d=\"M26,3H23V2H21V3H18a2,2,0,0,0-2,2V7a2,2,0,0,0,2,2h3v1h2V9h3a2,2,0,0,0,2-2V5A2,2,0,0,0,26,3ZM18,7V5h8V7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11zM26 13H23V12H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V19h3a2 2 0 002-2V15A2 2 0 0026 13zm-8 4V15h8v2zM26 23H23V22H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V29h3a2 2 0 002-2V25A2 2 0 0026 23zm-8 4V25h8v2zM26 3H23V2H21V3H18a2 2 0 00-2 2V7a2 2 0 002 2h3v1h2V9h3a2 2 0 002-2V5A2 2 0 0026 3zM18 7V5h8V7z\"/></svg>",
            "info": {},
            "path": "32/watson-health/spine-label.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSpineLabel32",
          "filepath": "watson-health/spine-label/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11zM26 13H23V12H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V19h3a2 2 0 002-2V15A2 2 0 0026 13zm-8 4V15h8v2zM26 23H23V22H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V29h3a2 2 0 002-2V25A2 2 0 0026 23zm-8 4V25h8v2zM26 3H23V2H21V3H18a2 2 0 00-2 2V7a2 2 0 002 2h3v1h2V9h3a2 2 0 002-2V5A2 2 0 0026 3zM18 7V5h8V7z"
                }
              }
            ],
            "name": "spine-label",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSpineLabel24",
          "filepath": "watson-health/spine-label/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11zM26 13H23V12H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V19h3a2 2 0 002-2V15A2 2 0 0026 13zm-8 4V15h8v2zM26 23H23V22H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V29h3a2 2 0 002-2V25A2 2 0 0026 23zm-8 4V25h8v2zM26 3H23V2H21V3H18a2 2 0 00-2 2V7a2 2 0 002 2h3v1h2V9h3a2 2 0 002-2V5A2 2 0 0026 3zM18 7V5h8V7z"
                }
              }
            ],
            "name": "spine-label",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSpineLabel20",
          "filepath": "watson-health/spine-label/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11zM26 13H23V12H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V19h3a2 2 0 002-2V15A2 2 0 0026 13zm-8 4V15h8v2zM26 23H23V22H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V29h3a2 2 0 002-2V25A2 2 0 0026 23zm-8 4V25h8v2zM26 3H23V2H21V3H18a2 2 0 00-2 2V7a2 2 0 002 2h3v1h2V9h3a2 2 0 002-2V5A2 2 0 0026 3zM18 7V5h8V7z"
                }
              }
            ],
            "name": "spine-label",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSpineLabel16",
          "filepath": "watson-health/spine-label/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11zM26 13H23V12H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V19h3a2 2 0 002-2V15A2 2 0 0026 13zm-8 4V15h8v2zM26 23H23V22H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V29h3a2 2 0 002-2V25A2 2 0 0026 23zm-8 4V25h8v2zM26 3H23V2H21V3H18a2 2 0 00-2 2V7a2 2 0 002 2h3v1h2V9h3a2 2 0 002-2V5A2 2 0 0026 3zM18 7V5h8V7z"
                }
              }
            ],
            "name": "spine-label",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "SpineLabel",
        "global": "WatsonHealthSpineLabel",
        "filepath": "watson-health/SpineLabel.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11zM26 13H23V12H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V19h3a2 2 0 002-2V15A2 2 0 0026 13zm-8 4V15h8v2zM26 23H23V22H21v1H18a2 2 0 00-2 2v2a2 2 0 002 2h3v1h2V29h3a2 2 0 002-2V25A2 2 0 0026 23zm-8 4V25h8v2zM26 3H23V2H21V3H18a2 2 0 00-2 2V7a2 2 0 002 2h3v1h2V9h3a2 2 0 002-2V5A2 2 0 0026 3zM18 7V5h8V7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "split",
      "friendlyName": "Split",
      "aliases": [
        "break",
        "divide"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/split.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>split</title>\n  <rect x=\"15\" y=\"20\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"14\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"8\" width=\"2\" height=\"4\"/>\n  <path d=\"M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 20H17V24H15zM15 14H17V18H15zM15 8H17V12H15z\"/><path d=\"M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z\"/></svg>",
            "info": {},
            "path": "32/split.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Split32",
          "filepath": "split/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM15 14H17V18H15zM15 8H17V12H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "split",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Split24",
          "filepath": "split/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM15 14H17V18H15zM15 8H17V12H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "split",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Split20",
          "filepath": "split/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM15 14H17V18H15zM15 8H17V12H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "split",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Split16",
          "filepath": "split/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 20H17V24H15zM15 14H17V18H15zM15 8H17V12H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                }
              }
            ],
            "name": "split",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Split",
        "global": "Split",
        "filepath": "Split.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 20H17V24H15zM15 14H17V18H15zM15 8H17V12H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "split--discard",
      "friendlyName": "Split discard",
      "aliases": [
        "split discard",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/split--discard.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/split--discard.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSplitDiscard32",
          "filepath": "watson-health/split--discard/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z"
                }
              }
            ],
            "name": "split--discard",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSplitDiscard24",
          "filepath": "watson-health/split--discard/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z"
                }
              }
            ],
            "name": "split--discard",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSplitDiscard20",
          "filepath": "watson-health/split--discard/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z"
                }
              }
            ],
            "name": "split--discard",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSplitDiscard16",
          "filepath": "watson-health/split--discard/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z"
                }
              }
            ],
            "name": "split--discard",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "SplitDiscard",
        "global": "WatsonHealthSplitDiscard",
        "filepath": "watson-health/SplitDiscard.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "split-screen",
      "friendlyName": "Split screen",
      "aliases": [
        "divide",
        "dual",
        "split",
        "screen",
        "multitask",
        "view",
        "half",
        "even"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/split-screen.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>split-screen</title><rect x=\"15\" y=\"4\" width=\"2\" height=\"24\"/><path d=\"M10,7V25H4V7h6m0-2H4A2,2,0,0,0,2,7V25a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2Z\"/><path d=\"M28,7V25H22V7h6m0-2H22a2,2,0,0,0-2,2V25a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 4H17V28H15zM10 7V25H4V7h6m0-2H4A2 2 0 002 7V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zM28 7V25H22V7h6m0-2H22a2 2 0 00-2 2V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/split-screen.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SplitScreen32",
          "filepath": "split-screen/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V28H15zM10 7V25H4V7h6m0-2H4A2 2 0 002 7V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zM28 7V25H22V7h6m0-2H22a2 2 0 00-2 2V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "split-screen",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SplitScreen24",
          "filepath": "split-screen/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V28H15zM10 7V25H4V7h6m0-2H4A2 2 0 002 7V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zM28 7V25H22V7h6m0-2H22a2 2 0 00-2 2V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "split-screen",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SplitScreen20",
          "filepath": "split-screen/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V28H15zM10 7V25H4V7h6m0-2H4A2 2 0 002 7V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zM28 7V25H22V7h6m0-2H22a2 2 0 00-2 2V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "split-screen",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SplitScreen16",
          "filepath": "split-screen/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V28H15zM10 7V25H4V7h6m0-2H4A2 2 0 002 7V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zM28 7V25H22V7h6m0-2H22a2 2 0 00-2 2V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "split-screen",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "SplitScreen",
        "global": "SplitScreen",
        "filepath": "SplitScreen.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 4H17V28H15zM10 7V25H4V7h6m0-2H4A2 2 0 002 7V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zM28 7V25H22V7h6m0-2H22a2 2 0 00-2 2V25a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "spray-paint",
      "friendlyName": "Spray paint",
      "aliases": [
        "paint",
        "spray",
        "spray can",
        "aerosol",
        "art",
        "bottle",
        "half"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/spray-paint.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>spray-paint</title><path d=\"M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z\"/><path d=\"M28,8H26V3H19V8H17a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM21,5h3V8H21ZM17,28V10H28l.002,18Z\"/><rect x=\"2\" y=\"14\" width=\"3\" height=\"3\"/><rect x=\"7\" y=\"9\" width=\"3\" height=\"3\"/><rect x=\"2\" y=\"9\" width=\"3\" height=\"3\"/><rect x=\"12\" y=\"4\" width=\"3\" height=\"3\"/><rect x=\"7\" y=\"4\" width=\"3\" height=\"3\"/><rect x=\"2\" y=\"4\" width=\"3\" height=\"3\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z\"/><path d=\"M28 8H26V3H19V8H17a2.002 2.002 0 00-2 2V28a2.0023 2.0023 0 002 2H28a2.0027 2.0027 0 002-2V10A2.0023 2.0023 0 0028 8zM21 5h3V8H21zM17 28V10H28l.002 18zM2 14H5V17H2zM7 9H10V12H7zM2 9H5V12H2zM12 4H15V7H12zM7 4H10V7H7zM2 4H5V7H2z\"/></svg>",
            "info": {},
            "path": "32/spray-paint.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SprayPaint32",
          "filepath": "spray-paint/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H26V3H19V8H17a2.002 2.002 0 00-2 2V28a2.0023 2.0023 0 002 2H28a2.0027 2.0027 0 002-2V10A2.0023 2.0023 0 0028 8zM21 5h3V8H21zM17 28V10H28l.002 18zM2 14H5V17H2zM7 9H10V12H7zM2 9H5V12H2zM12 4H15V7H12zM7 4H10V7H7zM2 4H5V7H2z"
                }
              }
            ],
            "name": "spray-paint",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SprayPaint24",
          "filepath": "spray-paint/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H26V3H19V8H17a2.002 2.002 0 00-2 2V28a2.0023 2.0023 0 002 2H28a2.0027 2.0027 0 002-2V10A2.0023 2.0023 0 0028 8zM21 5h3V8H21zM17 28V10H28l.002 18zM2 14H5V17H2zM7 9H10V12H7zM2 9H5V12H2zM12 4H15V7H12zM7 4H10V7H7zM2 4H5V7H2z"
                }
              }
            ],
            "name": "spray-paint",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SprayPaint20",
          "filepath": "spray-paint/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H26V3H19V8H17a2.002 2.002 0 00-2 2V28a2.0023 2.0023 0 002 2H28a2.0027 2.0027 0 002-2V10A2.0023 2.0023 0 0028 8zM21 5h3V8H21zM17 28V10H28l.002 18zM2 14H5V17H2zM7 9H10V12H7zM2 9H5V12H2zM12 4H15V7H12zM7 4H10V7H7zM2 4H5V7H2z"
                }
              }
            ],
            "name": "spray-paint",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SprayPaint16",
          "filepath": "spray-paint/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H26V3H19V8H17a2.002 2.002 0 00-2 2V28a2.0023 2.0023 0 002 2H28a2.0027 2.0027 0 002-2V10A2.0023 2.0023 0 0028 8zM21 5h3V8H21zM17 28V10H28l.002 18zM2 14H5V17H2zM7 9H10V12H7zM2 9H5V12H2zM12 4H15V7H12zM7 4H10V7H7zM2 4H5V7H2z"
                }
              }
            ],
            "name": "spray-paint",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "SprayPaint",
        "global": "SprayPaint",
        "filepath": "SprayPaint.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 8H26V3H19V8H17a2.002 2.002 0 00-2 2V28a2.0023 2.0023 0 002 2H28a2.0027 2.0027 0 002-2V10A2.0023 2.0023 0 0028 8zM21 5h3V8H21zM17 28V10H28l.002 18zM2 14H5V17H2zM7 9H10V12H7zM2 9H5V12H2zM12 4H15V7H12zM7 4H10V7H7zM2 4H5V7H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sprout",
      "friendlyName": "Sprout",
      "aliases": [
        "sprout",
        "farming",
        "agriculture",
        "grow"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sprout.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>sprout</title><path d=\"M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z\"/></svg>",
            "info": {},
            "path": "32/sprout.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sprout32",
          "filepath": "sprout/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "sprout",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sprout24",
          "filepath": "sprout/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "sprout",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sprout20",
          "filepath": "sprout/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "sprout",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sprout16",
          "filepath": "sprout/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z"
                }
              }
            ],
            "name": "sprout",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Sprout",
        "global": "Sprout",
        "filepath": "Sprout.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "SQL",
      "friendlyName": "SQL",
      "aliases": [
        "database",
        "query"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/SQL.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>SQL</title><polygon points=\"24 21 24 9 22 9 22 23 30 23 30 21 24 21\"/><path d=\"M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h1v2a2,2,0,0,0,2,2h2V25H17V23h1a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9ZM14,21V11h4V21Z\"/><path d=\"M8,23H2V21H8V17H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9h6v2H4v4H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9H14a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H17V23h1a2 2 0 002-2V11A2 2 0 0018 9zM14 21V11h4V21zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z\"/></svg>",
            "info": {},
            "path": "32/SQL.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sql32",
          "filepath": "SQL/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9H14a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H17V23h1a2 2 0 002-2V11A2 2 0 0018 9zM14 21V11h4V21zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SQL",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sql24",
          "filepath": "SQL/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9H14a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H17V23h1a2 2 0 002-2V11A2 2 0 0018 9zM14 21V11h4V21zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SQL",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sql20",
          "filepath": "SQL/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9H14a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H17V23h1a2 2 0 002-2V11A2 2 0 0018 9zM14 21V11h4V21zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SQL",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sql16",
          "filepath": "SQL/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9H14a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H17V23h1a2 2 0 002-2V11A2 2 0 0018 9zM14 21V11h4V21zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SQL",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Sql",
        "global": "Sql",
        "filepath": "Sql.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9H14a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H17V23h1a2 2 0 002-2V11A2 2 0 0018 9zM14 21V11h4V21zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "square-fill",
      "friendlyName": "Square fill",
      "aliases": [
        "square",
        "filled",
        "box"
      ],
      "sizes": [
        "glyph"
      ],
      "namespace": [],
      "assets": [
        {
          "size": "glyph",
          "filepath": "square-fill.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"3\" y=\"3\" width=\"10\" height=\"10\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M3 3H13V13H3z\"/></svg>",
            "info": {},
            "path": "square-fill.svg"
          }
        }
      ],
      "output": [
        {
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": "16",
              "height": "16"
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 3H13V13H3z"
                }
              }
            ],
            "name": "square-fill",
            "size": "glyph"
          },
          "moduleName": "SquareFillGlyph",
          "filepath": "square-fill/index.js",
          "size": "glyph"
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "SquareFill",
        "global": "SquareFill",
        "filepath": "SquareFill.js",
        "sizes": [
          {
            "size": "glyph",
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 3H13V13H3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stack-limitation",
      "friendlyName": "Stack limitation",
      "aliases": [
        "stack limitation",
        "caution",
        "warning",
        "limit",
        "packaging",
        "handling",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stack-limitation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"22\" width=\"8\" height=\"8\"/>\n  <path d=\"M24,12H20v2h4v2H21v2h3v2H20v2h4a2.0027,2.0027,0,0,0,2-2V14A2.0023,2.0023,0,0,0,24,12Z\"/>\n  <path d=\"M16,20H8V12h8Zm-6-2h4V14H10Z\"/>\n  <polygon points=\"16 3.41 14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 22H16V30H8zM24 12H20v2h4v2H21v2h3v2H20v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0024 12zM16 20H8V12h8zm-6-2h4V14H10zM16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z\"/></svg>",
            "info": {},
            "path": "32/stack-limitation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StackLimitation32",
          "filepath": "stack-limitation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H16V30H8zM24 12H20v2h4v2H21v2h3v2H20v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0024 12zM16 20H8V12h8zm-6-2h4V14H10zM16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z"
                }
              }
            ],
            "name": "stack-limitation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StackLimitation24",
          "filepath": "stack-limitation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H16V30H8zM24 12H20v2h4v2H21v2h3v2H20v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0024 12zM16 20H8V12h8zm-6-2h4V14H10zM16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z"
                }
              }
            ],
            "name": "stack-limitation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StackLimitation20",
          "filepath": "stack-limitation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H16V30H8zM24 12H20v2h4v2H21v2h3v2H20v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0024 12zM16 20H8V12h8zm-6-2h4V14H10zM16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z"
                }
              }
            ],
            "name": "stack-limitation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StackLimitation16",
          "filepath": "stack-limitation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 22H16V30H8zM24 12H20v2h4v2H21v2h3v2H20v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0024 12zM16 20H8V12h8zm-6-2h4V14H10zM16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z"
                }
              }
            ],
            "name": "stack-limitation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "StackLimitation",
        "global": "StackLimitation",
        "filepath": "StackLimitation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 22H16V30H8zM24 12H20v2h4v2H21v2h3v2H20v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0024 12zM16 20H8V12h8zm-6-2h4V14H10zM16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stacked-move",
      "friendlyName": "Stacked move",
      "aliases": [
        "stack",
        "pages",
        "sheet",
        "migrate",
        "drag"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/stacked-move.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stacked--move</title><path d=\"M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z\" transform=\"translate(0)\"/><path d=\"M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z\"/><path d=\"M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/stacked-move.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStackedMove32",
          "filepath": "watson-health/stacked-move/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z"
                }
              }
            ],
            "name": "stacked-move",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStackedMove24",
          "filepath": "watson-health/stacked-move/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z"
                }
              }
            ],
            "name": "stacked-move",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStackedMove20",
          "filepath": "watson-health/stacked-move/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z"
                }
              }
            ],
            "name": "stacked-move",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStackedMove16",
          "filepath": "watson-health/stacked-move/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z"
                }
              }
            ],
            "name": "stacked-move",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StackedMove",
        "global": "WatsonHealthStackedMove",
        "filepath": "watson-health/StackedMove.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stacked-scrolling--1",
      "friendlyName": "Stacked scrolling 1",
      "aliases": [
        "stack",
        "pages",
        "sheet",
        "browse",
        "thick",
        "tall"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/stacked-scrolling--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--stacked-scrolling--1</title><path d=\"M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z\"/><path d=\"M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z\"/><path d=\"M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z\"/><path d=\"M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z\"/><path d=\"M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/stacked-scrolling--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStackedScrolling_132",
          "filepath": "watson-health/stacked-scrolling--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStackedScrolling_124",
          "filepath": "watson-health/stacked-scrolling--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStackedScrolling_120",
          "filepath": "watson-health/stacked-scrolling--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStackedScrolling_116",
          "filepath": "watson-health/stacked-scrolling--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StackedScrolling_1",
        "global": "WatsonHealthStackedScrolling_1",
        "filepath": "watson-health/StackedScrolling_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stacked-scrolling--2",
      "friendlyName": "Stacked scrolling 2",
      "aliases": [
        "stack",
        "pages",
        "sheet",
        "browse",
        "thick",
        "tall"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/stacked-scrolling--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stacked-scrolling--2</title><path d=\"M8,30H2a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2V28A2,2,0,0,1,8,30ZM2,14V28H8V14Z\"/><path d=\"M20,30H14a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,20,30ZM14,14V28h6V14Z\"/><path d=\"M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z\"/><path d=\"M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z\"/><path d=\"M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z\"/><path d=\"M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/stacked-scrolling--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStackedScrolling_232",
          "filepath": "watson-health/stacked-scrolling--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStackedScrolling_224",
          "filepath": "watson-health/stacked-scrolling--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStackedScrolling_220",
          "filepath": "watson-health/stacked-scrolling--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStackedScrolling_216",
          "filepath": "watson-health/stacked-scrolling--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stacked-scrolling--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StackedScrolling_2",
        "global": "WatsonHealthStackedScrolling_2",
        "filepath": "watson-health/StackedScrolling_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 30H2a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2V28A2 2 0 018 30zM2 14V28H8V14zM20 30H14a2 2 0 01-2-2V14a2 2 0 012-2h6a2 2 0 012 2V28A2 2 0 0120 30zM14 14V28h6V14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stamp",
      "friendlyName": "Stamp",
      "aliases": [
        "stamp",
        "mark",
        "approve"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stamp.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stamp</title><path d=\"M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z\"/></svg>",
            "info": {},
            "path": "32/stamp.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Stamp32",
          "filepath": "stamp/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
                }
              }
            ],
            "name": "stamp",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Stamp24",
          "filepath": "stamp/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
                }
              }
            ],
            "name": "stamp",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Stamp20",
          "filepath": "stamp/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
                }
              }
            ],
            "name": "stamp",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Stamp16",
          "filepath": "stamp/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
                }
              }
            ],
            "name": "stamp",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Stamp",
        "global": "Stamp",
        "filepath": "Stamp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "star",
      "friendlyName": "Star",
      "aliases": [
        "favorite",
        "progress",
        "rate",
        "rating",
        "saved",
        "starred"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/star.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>star</title>\n<path d=\"M8,3.3l1.4,2.8l0.2,0.5l0.5,0.1l3.1,0.4L11,9.2l-0.4,0.4l0.1,0.5l0.5,3.1l-2.8-1.4L8,11.5l-0.5,0.2l-2.8,1.4l0.5-3.1\n\tl0.1-0.5L5,9.2L2.8,7l3.1-0.4l0.5-0.1L6.6,6L8,3.3 M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7\n\tL8,1z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,3.3l1.4,2.8l0.2,0.5l0.5,0.1l3.1,0.4L11,9.2l-0.4,0.4l0.1,0.5l0.5,3.1l-2.8-1.4L8,11.5l-0.5,0.2l-2.8,1.4l0.5-3.1\tl0.1-0.5L5,9.2L2.8,7l3.1-0.4l0.5-0.1L6.6,6L8,3.3 M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7\tL8,1z\"/></svg>",
            "info": {},
            "path": "16/star.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/star.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>star</title><path d=\"M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z\"/></svg>",
            "info": {},
            "path": "32/star.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Star32",
          "filepath": "star/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                }
              }
            ],
            "name": "star",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Star24",
          "filepath": "star/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                }
              }
            ],
            "name": "star",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Star20",
          "filepath": "star/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                }
              }
            ],
            "name": "star",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Star16",
          "filepath": "star/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,3.3l1.4,2.8l0.2,0.5l0.5,0.1l3.1,0.4L11,9.2l-0.4,0.4l0.1,0.5l0.5,3.1l-2.8-1.4L8,11.5l-0.5,0.2l-2.8,1.4l0.5-3.1\tl0.1-0.5L5,9.2L2.8,7l3.1-0.4l0.5-0.1L6.6,6L8,3.3 M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7\tL8,1z"
                }
              }
            ],
            "name": "star",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Star",
        "global": "Star",
        "filepath": "Star.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,3.3l1.4,2.8l0.2,0.5l0.5,0.1l3.1,0.4L11,9.2l-0.4,0.4l0.1,0.5l0.5,3.1l-2.8-1.4L8,11.5l-0.5,0.2l-2.8,1.4l0.5-3.1 l0.1-0.5L5,9.2L2.8,7l3.1-0.4l0.5-0.1L6.6,6L8,3.3 M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7 L8,1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "star--filled",
      "friendlyName": "Star filled",
      "aliases": [
        "favorite",
        "progress",
        "rate",
        "rating",
        "saved",
        "starred"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/star--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>star--filled</title>\n<path d=\"M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7L8,1z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7L8,1z\"/></svg>",
            "info": {},
            "path": "16/star--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/star--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>star--filled</title><path d=\"M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z\"/></svg>",
            "info": {},
            "path": "32/star--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StarFilled32",
          "filepath": "star--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                }
              }
            ],
            "name": "star--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StarFilled24",
          "filepath": "star--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                }
              }
            ],
            "name": "star--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StarFilled20",
          "filepath": "star--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                }
              }
            ],
            "name": "star--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StarFilled16",
          "filepath": "star--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7L8,1z"
                }
              }
            ],
            "name": "star--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "StarFilled",
        "global": "StarFilled",
        "filepath": "StarFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7L8,1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "star--half",
      "friendlyName": "Star half",
      "aliases": [
        "favorite",
        "progress",
        "rate",
        "rating",
        "saved",
        "starred"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/star--half.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>star--half</title>\n<polygon points=\"5.7,5.6 0.6,6.3 4.3,9.9 3.5,15 8,12.6 8,1 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M5.7 5.6L0.6 6.3 4.3 9.9 3.5 15 8 12.6 8 1z\"/></svg>",
            "info": {},
            "path": "16/star--half.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/star--half.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>star--half</title><polygon points=\"11.45 11.22 1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z\"/></svg>",
            "info": {},
            "path": "32/star--half.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StarHalf32",
          "filepath": "star--half/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
                }
              }
            ],
            "name": "star--half",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StarHalf24",
          "filepath": "star--half/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
                }
              }
            ],
            "name": "star--half",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StarHalf20",
          "filepath": "star--half/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
                }
              }
            ],
            "name": "star--half",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StarHalf16",
          "filepath": "star--half/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.7 5.6L0.6 6.3 4.3 9.9 3.5 15 8 12.6 8 1z"
                }
              }
            ],
            "name": "star--half",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "StarHalf",
        "global": "StarHalf",
        "filepath": "StarHalf.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.7 5.6L0.6 6.3 4.3 9.9 3.5 15 8 12.6 8 1z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "star--review",
      "friendlyName": "Star review",
      "aliases": [
        "rating",
        "rate",
        "comment"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/star--review.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>star--review</title>\n  <rect x=\"18\" y=\"26\" width=\"8\" height=\"2\"/>\n  <rect x=\"18\" y=\"22\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"18\" width=\"12\" height=\"2\"/>\n  <polygon points=\"20.549 11.217 16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z\"/><path d=\"M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z\"/></svg>",
            "info": {},
            "path": "32/star--review.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StarReview32",
          "filepath": "star--review/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
                }
              }
            ],
            "name": "star--review",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StarReview24",
          "filepath": "star--review/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
                }
              }
            ],
            "name": "star--review",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StarReview20",
          "filepath": "star--review/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
                }
              }
            ],
            "name": "star--review",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StarReview16",
          "filepath": "star--review/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
                }
              }
            ],
            "name": "star--review",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "StarReview",
        "global": "StarReview",
        "filepath": "StarReview.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 26H26V28H18zM18 22H30V24H18zM18 18H30V20H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "status--acknowledge",
      "friendlyName": "Status acknowledge",
      "aliases": [
        "status",
        "acknowledge",
        "checkmark",
        "Watson Health®"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/status--acknowledge.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,30a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z\"/>\n  <polygon points=\"12 15.59 9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59\"/>\n  <path d=\"M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z\"/><path d=\"M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/status--acknowledge.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStatusAcknowledge32",
          "filepath": "watson-health/status--acknowledge/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              }
            ],
            "name": "status--acknowledge",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStatusAcknowledge24",
          "filepath": "watson-health/status--acknowledge/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              }
            ],
            "name": "status--acknowledge",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStatusAcknowledge20",
          "filepath": "watson-health/status--acknowledge/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              }
            ],
            "name": "status--acknowledge",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStatusAcknowledge16",
          "filepath": "watson-health/status--acknowledge/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                }
              }
            ],
            "name": "status--acknowledge",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StatusAcknowledge",
        "global": "WatsonHealthStatusAcknowledge",
        "filepath": "watson-health/StatusAcknowledge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "status--change",
      "friendlyName": "Status change",
      "aliases": [
        "status",
        "change",
        "Watson Health®"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/status--change.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M7,30a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z\"/>\n  <path d=\"M23,30a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,23,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,22Z\"/>\n  <path d=\"M24,7v7l3.5859-3.4141L29,12l-6,6-6-6,1.4141-1.4141L22,14V7a1.0009,1.0009,0,0,0-1-1H9A1.0006,1.0006,0,0,0,8,7V18H6V7A3.0033,3.0033,0,0,1,9,4H21A3.0033,3.0033,0,0,1,24,7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z\"/></svg>",
            "info": {},
            "path": "32/watson-health/status--change.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStatusChange32",
          "filepath": "watson-health/status--change/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
                }
              }
            ],
            "name": "status--change",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStatusChange24",
          "filepath": "watson-health/status--change/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
                }
              }
            ],
            "name": "status--change",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStatusChange20",
          "filepath": "watson-health/status--change/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
                }
              }
            ],
            "name": "status--change",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStatusChange16",
          "filepath": "watson-health/status--change/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
                }
              }
            ],
            "name": "status--change",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StatusChange",
        "global": "WatsonHealthStatusChange",
        "filepath": "watson-health/StatusChange.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 30a5 5 0 115-5A5.0057 5.0057 0 017 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 007 22zM23 30a5 5 0 115-5A5.0057 5.0057 0 0123 30zm0-8a3 3 0 103 3A3.0033 3.0033 0 0023 22zM24 7v7l3.5859-3.4141L29 12l-6 6-6-6 1.4141-1.4141L22 14V7a1.0009 1.0009 0 00-1-1H9A1.0006 1.0006 0 008 7V18H6V7A3.0033 3.0033 0 019 4H21A3.0033 3.0033 0 0124 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "status--partial-fail",
      "friendlyName": "Status partial fail",
      "aliases": [
        "status",
        "fail",
        "partial",
        "Watson Health®",
        "exclamation point"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/status--partial-fail.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.1407,23.7642l1.5315,1.2851a13.976,13.976,0,0,0,2.4408-4.1821l-1.8776-.6836A11.9729,11.9729,0,0,1,25.1407,23.7642Z\"/>\n  <path d=\"M18,27.81l.4128,1.9677A13.8888,13.8888,0,0,0,22.9543,28.14L22,26.4087A12.52,12.52,0,0,1,18,27.81Z\"/>\n  <path d=\"M10,26.4087,9,28.14a14.14,14.14,0,0,0,4.5872,1.6382l.3469-1.9677A12.1519,12.1519,0,0,1,10,26.4087Z\"/>\n  <path d=\"M4.7646,20.1836l-1.8776.6836a13.976,13.976,0,0,0,2.4408,4.1821l1.5315-1.2851A11.9729,11.9729,0,0,1,4.7646,20.1836Z\"/>\n  <path d=\"M16,22a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,22Z\"/>\n  <rect x=\"15\" y=\"8\" width=\"2\" height=\"11\"/>\n  <path d=\"M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z\"/><path d=\"M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/status--partial-fail.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStatusPartialFail32",
          "filepath": "watson-health/status--partial-fail/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
                }
              }
            ],
            "name": "status--partial-fail",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStatusPartialFail24",
          "filepath": "watson-health/status--partial-fail/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
                }
              }
            ],
            "name": "status--partial-fail",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStatusPartialFail20",
          "filepath": "watson-health/status--partial-fail/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
                }
              }
            ],
            "name": "status--partial-fail",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStatusPartialFail16",
          "filepath": "watson-health/status--partial-fail/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
                }
              }
            ],
            "name": "status--partial-fail",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StatusPartialFail",
        "global": "WatsonHealthStatusPartialFail",
        "filepath": "watson-health/StatusPartialFail.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.1407 23.7642l1.5315 1.2851a13.976 13.976 0 002.4408-4.1821l-1.8776-.6836A11.9729 11.9729 0 0125.1407 23.7642zM18 27.81l.4128 1.9677A13.8888 13.8888 0 0022.9543 28.14L22 26.4087A12.52 12.52 0 0118 27.81zM10 26.4087L9 28.14a14.14 14.14 0 004.5872 1.6382l.3469-1.9677A12.1519 12.1519 0 0110 26.4087zM4.7646 20.1836l-1.8776.6836a13.976 13.976 0 002.4408 4.1821l1.5315-1.2851A11.9729 11.9729 0 014.7646 20.1836zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22zM15 8H17V19H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "status--resolved",
      "friendlyName": "Status resolved",
      "aliases": [
        "status",
        "fail",
        "partial",
        "Watson Health®",
        "checkmark"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/status--resolved.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"21 28.414 16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414\"/>\n  <polygon points=\"12 15.59 9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59\"/>\n  <path d=\"M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z\"/><path d=\"M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/status--resolved.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStatusResolved32",
          "filepath": "watson-health/status--resolved/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
                }
              }
            ],
            "name": "status--resolved",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStatusResolved24",
          "filepath": "watson-health/status--resolved/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
                }
              }
            ],
            "name": "status--resolved",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStatusResolved20",
          "filepath": "watson-health/status--resolved/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
                }
              }
            ],
            "name": "status--resolved",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStatusResolved16",
          "filepath": "watson-health/status--resolved/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
                }
              }
            ],
            "name": "status--resolved",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StatusResolved",
        "global": "WatsonHealthStatusResolved",
        "filepath": "watson-health/StatusResolved.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414zM12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stay-inside",
      "friendlyName": "Stay inside",
      "aliases": [
        "stay inside",
        "weather",
        "warning"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stay-inside.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,30H21V28a3.0033,3.0033,0,0,0-3-3H14a3.0033,3.0033,0,0,0-3,3v2H9V28a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,13a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,16,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z\"/><path d=\"M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z\"/></svg>",
            "info": {},
            "path": "32/stay-inside.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StayInside32",
          "filepath": "stay-inside/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
                }
              }
            ],
            "name": "stay-inside",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StayInside24",
          "filepath": "stay-inside/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
                }
              }
            ],
            "name": "stay-inside",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StayInside20",
          "filepath": "stay-inside/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
                }
              }
            ],
            "name": "stay-inside",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StayInside16",
          "filepath": "stay-inside/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
                }
              }
            ],
            "name": "stay-inside",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "StayInside",
        "global": "StayInside",
        "filepath": "StayInside.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stem-leaf-plot",
      "friendlyName": "Stem leaf plot",
      "aliases": [
        "chart",
        "data",
        "data analytics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stem-leaf-plot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>stem-leaf-plot</title>\n  <path d=\"M19,10a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,19,10Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,19,6Z\"/>\n  <path d=\"M19,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,19,19Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,19,15Z\"/>\n  <path d=\"M27,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,27,19Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,27,15Z\"/>\n  <path d=\"M19,28a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,19,28Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,19,24Z\"/>\n  <rect x=\"12\" y=\"2\" width=\"2\" height=\"28\"/>\n  <path d=\"M7,28a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,28Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,7,24Z\"/>\n  <path d=\"M7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,7,15Z\"/>\n  <path d=\"M7,10a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,10ZM7,6A1,1,0,1,0,8,7,1.0011,1.0011,0,0,0,7,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z\"/></svg>",
            "info": {},
            "path": "32/stem-leaf-plot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StemLeafPlot32",
          "filepath": "stem-leaf-plot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
                }
              }
            ],
            "name": "stem-leaf-plot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StemLeafPlot24",
          "filepath": "stem-leaf-plot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
                }
              }
            ],
            "name": "stem-leaf-plot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StemLeafPlot20",
          "filepath": "stem-leaf-plot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
                }
              }
            ],
            "name": "stem-leaf-plot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StemLeafPlot16",
          "filepath": "stem-leaf-plot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
                }
              }
            ],
            "name": "stem-leaf-plot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "StemLeafPlot",
        "global": "StemLeafPlot",
        "filepath": "StemLeafPlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 10a3 3 0 113-3A3.0033 3.0033 0 0119 10zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 6zM19 19a3 3 0 113-3A3.0033 3.0033 0 0119 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 15zM27 19a3 3 0 113-3A3.0033 3.0033 0 0127 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 0027 15zM19 28a3 3 0 113-3A3.0033 3.0033 0 0119 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 0019 24zM12 2H14V30H12zM7 28a3 3 0 113-3A3.0033 3.0033 0 017 28zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 24zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19zm0-4a1 1 0 101 1A1.0011 1.0011 0 007 15zM7 10a3 3 0 113-3A3.0033 3.0033 0 017 10zM7 6A1 1 0 108 7 1.0011 1.0011 0 007 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stethoscope",
      "friendlyName": "Stethoscope",
      "aliases": [
        "healthcare",
        "medical",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stethoscope.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>stethoscope</title>\n  <path d=\"M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z\"/></svg>",
            "info": {},
            "path": "32/stethoscope.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Stethoscope32",
          "filepath": "stethoscope/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
                }
              }
            ],
            "name": "stethoscope",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Stethoscope24",
          "filepath": "stethoscope/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
                }
              }
            ],
            "name": "stethoscope",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Stethoscope20",
          "filepath": "stethoscope/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
                }
              }
            ],
            "name": "stethoscope",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Stethoscope16",
          "filepath": "stethoscope/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
                }
              }
            ],
            "name": "stethoscope",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Stethoscope",
        "global": "Stethoscope",
        "filepath": "Stethoscope.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stop",
      "friendlyName": "Stop",
      "aliases": [
        "block",
        "break",
        "close",
        "cease",
        "control",
        "pause",
        "conclude"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/stop.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>stop</title>\n<path d=\"M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z\"/></svg>",
            "info": {},
            "path": "16/stop.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/stop.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stop</title><path d=\"M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/></svg>",
            "info": {},
            "path": "32/stop.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Stop32",
          "filepath": "stop/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Stop24",
          "filepath": "stop/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Stop20",
          "filepath": "stop/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Stop16",
          "filepath": "stop/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
                }
              }
            ],
            "name": "stop",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "Stop",
        "global": "Stop",
        "filepath": "Stop.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stop--filled",
      "friendlyName": "Stop filled",
      "aliases": [
        "block",
        "break",
        "close",
        "cease",
        "control",
        "pause",
        "conclude"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/stop--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>stop--solid--filled</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\n\tc0.6,0,1,0.4,1,1V10z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z\"/></svg>",
            "info": {},
            "path": "16/stop--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/stop--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stop--solid--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/stop--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StopFilled32",
          "filepath": "stop--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stop--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StopFilled24",
          "filepath": "stop--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stop--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StopFilled20",
          "filepath": "stop--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                }
              }
            ],
            "name": "stop--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StopFilled16",
          "filepath": "stop--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z"
                }
              }
            ],
            "name": "stop--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "StopFilled",
        "global": "StopFilled",
        "filepath": "StopFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4 c0.6,0,1,0.4,1,1V10z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stop--filled--alt",
      "friendlyName": "Stop filled alt",
      "aliases": [
        "block",
        "break",
        "close",
        "cease",
        "control",
        "pause",
        "conclude"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stop--filled--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stop--filled</title><path d=\"M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z\"/></svg>",
            "info": {},
            "path": "32/stop--filled--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StopFilledAlt32",
          "filepath": "stop--filled--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop--filled--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StopFilledAlt24",
          "filepath": "stop--filled--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop--filled--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StopFilledAlt20",
          "filepath": "stop--filled--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop--filled--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StopFilledAlt16",
          "filepath": "stop--filled--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop--filled--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "StopFilledAlt",
        "global": "StopFilledAlt",
        "filepath": "StopFilledAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stop--outline",
      "friendlyName": "Stop outline",
      "aliases": [
        "block",
        "break",
        "close",
        "cease",
        "control",
        "pause",
        "conclude"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/stop--outline.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>stop--outline</title>\n<path d=\"M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z\"/>\n<path d=\"M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z\"/><path d=\"M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z\"/></svg>",
            "info": {},
            "path": "16/stop--outline.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/stop--outline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stop--outline</title><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\" transform=\"translate(0)\"/><path d=\"M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z\"/><path d=\"M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z\"/></svg>",
            "info": {},
            "path": "32/stop--outline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StopOutline32",
          "filepath": "stop--outline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop--outline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StopOutline24",
          "filepath": "stop--outline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop--outline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StopOutline20",
          "filepath": "stop--outline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
                }
              }
            ],
            "name": "stop--outline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StopOutline16",
          "filepath": "stop--outline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z"
                }
              }
            ],
            "name": "stop--outline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "StopOutline",
        "global": "StopOutline",
        "filepath": "StopOutline.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stop--outline--filled",
      "friendlyName": "Stop outline filled",
      "aliases": [
        "block",
        "break",
        "close",
        "cease",
        "control",
        "pause",
        "conclude"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/stop--outline--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>stop--outline--filled</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\n\tc0.6,0,1,0.4,1,1V10z\"/>\n<rect x=\"6\" y=\"6\" width=\"4\" height=\"4\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z\"/><path d=\"M6 6H10V10H6z\"/></svg>",
            "info": {},
            "path": "16/stop--outline--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/stop--outline--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>stop--outline--filled</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z\"/><rect x=\"12\" y=\"12\" width=\"8\" height=\"8\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z\"/><path d=\"M12 12H20V20H12z\"/></svg>",
            "info": {},
            "path": "32/stop--outline--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StopOutlineFilled32",
          "filepath": "stop--outline--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H20V20H12z"
                }
              }
            ],
            "name": "stop--outline--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StopOutlineFilled24",
          "filepath": "stop--outline--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H20V20H12z"
                }
              }
            ],
            "name": "stop--outline--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StopOutlineFilled20",
          "filepath": "stop--outline--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H20V20H12z"
                }
              }
            ],
            "name": "stop--outline--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StopOutlineFilled16",
          "filepath": "stop--outline--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4\tc0.6,0,1,0.4,1,1V10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H10V10H6z"
                }
              }
            ],
            "name": "stop--outline--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "StopOutlineFilled",
        "global": "StopOutlineFilled",
        "filepath": "StopOutlineFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4 c0.6,0,1,0.4,1,1V10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H10V10H6z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 12H20V20H12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stop-sign",
      "friendlyName": "Stop sign",
      "aliases": [
        "stop sign",
        "travel",
        "naviation",
        "map",
        "direction",
        "road"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stop-sign.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z\"/></svg>",
            "info": {},
            "path": "32/stop-sign.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StopSign32",
          "filepath": "stop-sign/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
                }
              }
            ],
            "name": "stop-sign",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StopSign24",
          "filepath": "stop-sign/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
                }
              }
            ],
            "name": "stop-sign",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StopSign20",
          "filepath": "stop-sign/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
                }
              }
            ],
            "name": "stop-sign",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StopSign16",
          "filepath": "stop-sign/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
                }
              }
            ],
            "name": "stop-sign",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "StopSign",
        "global": "StopSign",
        "filepath": "StopSign.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stop-sign--filled",
      "friendlyName": "Stop sign filled",
      "aliases": [
        "stop sign filled",
        "travel",
        "naviation",
        "map",
        "direction",
        "road"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/stop-sign--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\" Transparent Rectangle \" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z\"/></svg>",
            "info": {},
            "path": "32/stop-sign--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StopSignFilled32",
          "filepath": "stop-sign--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
                }
              }
            ],
            "name": "stop-sign--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StopSignFilled24",
          "filepath": "stop-sign--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
                }
              }
            ],
            "name": "stop-sign--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StopSignFilled20",
          "filepath": "stop-sign--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
                }
              }
            ],
            "name": "stop-sign--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StopSignFilled16",
          "filepath": "stop-sign--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
                }
              }
            ],
            "name": "stop-sign--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "StopSignFilled",
        "global": "StopSignFilled",
        "filepath": "StopSignFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "storage-pool",
      "friendlyName": "Storage pool",
      "aliases": [
        "data",
        "storage pool",
        "pool"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/storage-pool.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/>\n  <path d=\"M17.5,13A3.5,3.5,0,1,1,21,9.5,3.5041,3.5041,0,0,1,17.5,13Zm0-5A1.5,1.5,0,1,0,19,9.5,1.5017,1.5017,0,0,0,17.5,8Z\"/>\n  <path d=\"M14.5,26A3.5,3.5,0,1,1,18,22.5,3.5041,3.5041,0,0,1,14.5,26Zm0-5A1.5,1.5,0,1,0,16,22.5,1.5017,1.5017,0,0,0,14.5,21Z\"/>\n  <path d=\"M9.5,18A3.5,3.5,0,1,1,13,14.5,3.5041,3.5041,0,0,1,9.5,18Zm0-5A1.5,1.5,0,1,0,11,14.5,1.5017,1.5017,0,0,0,9.5,13Z\"/>\n  <path d=\"M22.5,21A3.5,3.5,0,1,1,26,17.5,3.5041,3.5041,0,0,1,22.5,21Zm0-5A1.5,1.5,0,1,0,24,17.5,1.5017,1.5017,0,0,0,22.5,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/><path d=\"M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z\"/></svg>",
            "info": {},
            "path": "32/storage-pool.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StoragePool32",
          "filepath": "storage-pool/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
                }
              }
            ],
            "name": "storage-pool",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StoragePool24",
          "filepath": "storage-pool/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
                }
              }
            ],
            "name": "storage-pool",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StoragePool20",
          "filepath": "storage-pool/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
                }
              }
            ],
            "name": "storage-pool",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StoragePool16",
          "filepath": "storage-pool/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
                }
              }
            ],
            "name": "storage-pool",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "StoragePool",
        "global": "StoragePool",
        "filepath": "StoragePool.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.5 13A3.5 3.5 0 1121 9.5 3.5041 3.5041 0 0117.5 13zm0-5A1.5 1.5 0 1019 9.5 1.5017 1.5017 0 0017.5 8zM14.5 26A3.5 3.5 0 1118 22.5 3.5041 3.5041 0 0114.5 26zm0-5A1.5 1.5 0 1016 22.5 1.5017 1.5017 0 0014.5 21zM9.5 18A3.5 3.5 0 1113 14.5 3.5041 3.5041 0 019.5 18zm0-5A1.5 1.5 0 1011 14.5 1.5017 1.5017 0 009.5 13zM22.5 21A3.5 3.5 0 1126 17.5 3.5041 3.5041 0 0122.5 21zm0-5A1.5 1.5 0 1024 17.5 1.5017 1.5017 0 0022.5 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "storage-request",
      "friendlyName": "Storage request",
      "aliases": [
        "storage request"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/storage-request.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M4,21H2v3a2.0059,2.0059,0,0,0,2,2H7V24H4Z\"/>\n  <path d=\"M4,8H7V6H4A2.0059,2.0059,0,0,0,2,8v3H4Z\"/>\n  <rect x=\"17\" y=\"6\" width=\"6\" height=\"2\"/>\n  <rect x=\"9\" y=\"6\" width=\"6\" height=\"2\"/>\n  <rect x=\"17\" y=\"24\" width=\"6\" height=\"2\"/>\n  <polygon points=\"28 15 4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15\"/>\n  <path d=\"M28,24H25v2h3a2.0059,2.0059,0,0,0,2-2V21H28Z\"/>\n  <path d=\"M28,6H25V8h3v3h2V8A2.0059,2.0059,0,0,0,28,6Z\"/>\n  <rect x=\"9\" y=\"24\" width=\"6\" height=\"2\"/>\n  <circle cx=\"7\" cy=\"12\" r=\"1\"/>\n  <circle cx=\"7\" cy=\"20\" r=\"1\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z\"/><circle cx=\"7\" cy=\"12\" r=\"1\"/><circle cx=\"7\" cy=\"20\" r=\"1\"/></svg>",
            "info": {},
            "path": "32/storage-request.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StorageRequest32",
          "filepath": "storage-request/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "1"
                }
              }
            ],
            "name": "storage-request",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StorageRequest24",
          "filepath": "storage-request/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "1"
                }
              }
            ],
            "name": "storage-request",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StorageRequest20",
          "filepath": "storage-request/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "1"
                }
              }
            ],
            "name": "storage-request",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StorageRequest16",
          "filepath": "storage-request/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "12",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "7",
                  "cy": "20",
                  "r": "1"
                }
              }
            ],
            "name": "storage-request",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "StorageRequest",
        "global": "StorageRequest",
        "filepath": "StorageRequest.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 21H2v3a2.0059 2.0059 0 002 2H7V24H4zM4 8H7V6H4A2.0059 2.0059 0 002 8v3H4zM17 6H23V8H17zM9 6H15V8H9zM17 24H23V26H17zM28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15zM28 24H25v2h3a2.0059 2.0059 0 002-2V21H28zM28 6H25V8h3v3h2V8A2.0059 2.0059 0 0028 6zM9 24H15V26H9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "12",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "7",
                    "cy": "20",
                    "r": "1"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "store",
      "friendlyName": "Store",
      "aliases": [
        "building",
        "shop",
        "house",
        "retail",
        "buisness",
        "online",
        "ecommerce",
        "market",
        "buy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/store.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>shop</title><path d=\"M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z\"/></svg>",
            "info": {},
            "path": "32/store.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Store32",
          "filepath": "store/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
                }
              }
            ],
            "name": "store",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Store24",
          "filepath": "store/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
                }
              }
            ],
            "name": "store",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Store20",
          "filepath": "store/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
                }
              }
            ],
            "name": "store",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Store16",
          "filepath": "store/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
                }
              }
            ],
            "name": "store",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Store",
        "global": "Store",
        "filepath": "Store.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "storm-tracker",
      "friendlyName": "Storm tracker",
      "aliases": [
        "storm tracker",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/storm-tracker.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z\"/></svg>",
            "info": {},
            "path": "32/storm-tracker.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StormTracker32",
          "filepath": "storm-tracker/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
                }
              }
            ],
            "name": "storm-tracker",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StormTracker24",
          "filepath": "storm-tracker/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
                }
              }
            ],
            "name": "storm-tracker",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StormTracker20",
          "filepath": "storm-tracker/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
                }
              }
            ],
            "name": "storm-tracker",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StormTracker16",
          "filepath": "storm-tracker/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
                }
              }
            ],
            "name": "storm-tracker",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "StormTracker",
        "global": "StormTracker",
        "filepath": "StormTracker.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "strawberry",
      "friendlyName": "Strawberry",
      "aliases": [
        "strawberry",
        "fruit",
        "food"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/strawberry.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>strawberry</title><rect x=\"9\" y=\"10\" width=\"2\" height=\"2\"/><rect x=\"9\" y=\"14\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"12\" width=\"2\" height=\"2\"/><path d=\"M9,28a5.169,5.169,0,0,1-.7441-.054A5.0935,5.0935,0,0,1,4,22.8669V11.1985a7.1615,7.1615,0,0,1,6.31-7.1653,6.9607,6.9607,0,0,1,4.4643,1.0706l7.9688,4.9807a6.98,6.98,0,0,1-.6885,12.19l-10.88,5.2285A4.9765,4.9765,0,0,1,9,28ZM11.002,6q-.2484,0-.5005.0241A5.1463,5.1463,0,0,0,6,11.1985V22.8669a3.0839,3.0839,0,0,0,2.5435,3.1,3.0266,3.0266,0,0,0,1.7622-.2649l10.8828-5.23a4.9807,4.9807,0,0,0,.4887-8.6958L13.7046,6.7935A4.9687,4.9687,0,0,0,11.002,6Z\"/><path d=\"M26,7H22a4.0045,4.0045,0,0,1-4-4V2h2V3a2.0021,2.0021,0,0,0,2,2h4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z\"/><path d=\"M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z\"/></svg>",
            "info": {},
            "path": "32/strawberry.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Strawberry32",
          "filepath": "strawberry/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
                }
              }
            ],
            "name": "strawberry",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Strawberry24",
          "filepath": "strawberry/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
                }
              }
            ],
            "name": "strawberry",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Strawberry20",
          "filepath": "strawberry/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
                }
              }
            ],
            "name": "strawberry",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Strawberry16",
          "filepath": "strawberry/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
                }
              }
            ],
            "name": "strawberry",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Strawberry",
        "global": "Strawberry",
        "filepath": "Strawberry.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 10H11V12H9zM9 14H11V16H9zM13 12H15V14H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 28a5.169 5.169 0 01-.7441-.054A5.0935 5.0935 0 014 22.8669V11.1985a7.1615 7.1615 0 016.31-7.1653 6.9607 6.9607 0 014.4643 1.0706l7.9688 4.9807a6.98 6.98 0 01-.6885 12.19l-10.88 5.2285A4.9765 4.9765 0 019 28zM11.002 6q-.2484 0-.5005.0241A5.1463 5.1463 0 006 11.1985V22.8669a3.0839 3.0839 0 002.5435 3.1 3.0266 3.0266 0 001.7622-.2649l10.8828-5.23a4.9807 4.9807 0 00.4887-8.6958L13.7046 6.7935A4.9687 4.9687 0 0011.002 6zM26 7H22a4.0045 4.0045 0 01-4-4V2h2V3a2.0021 2.0021 0 002 2h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "stress-breath-editor",
      "friendlyName": "Stress breath editor",
      "aliases": [
        "air",
        "gas",
        "blow",
        "flow",
        "breathalyzer"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/stress-breath-editor.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--stress-breath-editor</title><path d=\"M20,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,20,2Z\"/><path d=\"M30,30H28V25a5,5,0,0,0-5-5H17a5,5,0,0,0-5,5v5H10V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\"/><path d=\"M11,8H5A3,3,0,0,1,2,5V3H4V5A1,1,0,0,0,5,6h6Z\"/><path d=\"M4,15H2V13a3,3,0,0,1,3-3h6v2H5a1,1,0,0,0-1,1Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z\"/></svg>",
            "info": {},
            "path": "32/watson-health/stress-breath-editor.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStressBreathEditor32",
          "filepath": "watson-health/stress-breath-editor/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
                }
              }
            ],
            "name": "stress-breath-editor",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStressBreathEditor24",
          "filepath": "watson-health/stress-breath-editor/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
                }
              }
            ],
            "name": "stress-breath-editor",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStressBreathEditor20",
          "filepath": "watson-health/stress-breath-editor/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
                }
              }
            ],
            "name": "stress-breath-editor",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStressBreathEditor16",
          "filepath": "watson-health/stress-breath-editor/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
                }
              }
            ],
            "name": "stress-breath-editor",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StressBreathEditor",
        "global": "WatsonHealthStressBreathEditor",
        "filepath": "watson-health/StressBreathEditor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7zM11 8H5A3 3 0 012 5V3H4V5A1 1 0 005 6h6zM4 15H2V13a3 3 0 013-3h6v2H5a1 1 0 00-1 1z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "string-integer",
      "friendlyName": "String integer",
      "aliases": [
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/string-integer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>string-integer</title>\n  <path d=\"M26,12H22v2h4v2H23v2h3v2H22v2h4a2.0027,2.0027,0,0,0,2-2V14A2.0023,2.0023,0,0,0,26,12Z\"/>\n  <path d=\"M19,22H13V18a2.002,2.002,0,0,1,2-2h2V14H13V12h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H15v2h4Z\"/>\n  <polygon points=\"8 20 8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z\"/></svg>",
            "info": {},
            "path": "32/string-integer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StringInteger32",
          "filepath": "string-integer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
                }
              }
            ],
            "name": "string-integer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StringInteger24",
          "filepath": "string-integer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
                }
              }
            ],
            "name": "string-integer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StringInteger20",
          "filepath": "string-integer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
                }
              }
            ],
            "name": "string-integer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StringInteger16",
          "filepath": "string-integer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
                }
              }
            ],
            "name": "string-integer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "StringInteger",
        "global": "StringInteger",
        "filepath": "StringInteger.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 12H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0026 12zM19 22H13V18a2.002 2.002 0 012-2h2V14H13V12h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H15v2h4zM8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "string-text",
      "friendlyName": "String text",
      "aliases": [
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/string-text.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>string-text</title>\n  <path d=\"M29,22H24a2.0027,2.0027,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2h5v2H24v6h5Z\"/>\n  <path d=\"M18,12H14V8H12V22h6a2.0027,2.0027,0,0,0,2-2V14A2.0023,2.0023,0,0,0,18,12Zm-4,8V14h4v6Z\"/>\n  <path d=\"M8,12H3v2H8v2H4a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V14A2.0023,2.0023,0,0,0,8,12Zm0,8H4V18H8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z\"/></svg>",
            "info": {},
            "path": "32/string-text.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "StringText32",
          "filepath": "string-text/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
                }
              }
            ],
            "name": "string-text",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "StringText24",
          "filepath": "string-text/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
                }
              }
            ],
            "name": "string-text",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "StringText20",
          "filepath": "string-text/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
                }
              }
            ],
            "name": "string-text",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "StringText16",
          "filepath": "string-text/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
                }
              }
            ],
            "name": "string-text",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "StringText",
        "global": "StringText",
        "filepath": "StringText.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "study--next",
      "friendlyName": "Study next",
      "aliases": [
        "patient",
        "user",
        "profile",
        "next",
        "study"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/study--next.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--study--next</title><polygon points=\"23.93 21 30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\"/><path d=\"M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z\"/></svg>",
            "info": {},
            "path": "32/watson-health/study--next.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStudyNext32",
          "filepath": "watson-health/study--next/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--next",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStudyNext24",
          "filepath": "watson-health/study--next/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--next",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStudyNext20",
          "filepath": "watson-health/study--next/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--next",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStudyNext16",
          "filepath": "watson-health/study--next/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--next",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StudyNext",
        "global": "WatsonHealthStudyNext",
        "filepath": "watson-health/StudyNext.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "study--previous",
      "friendlyName": "Study previous",
      "aliases": [
        "patient",
        "user",
        "profile",
        "previous",
        "study"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/study--previous.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--study--previous</title><polygon points=\"8.07 21 2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21\"/><path d=\"M20,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,20,2Z\"/><path d=\"M30,30H28V25a5,5,0,0,0-5-5H17a5,5,0,0,0-5,5v5H10V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z\"/></svg>",
            "info": {},
            "path": "32/watson-health/study--previous.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStudyPrevious32",
          "filepath": "watson-health/study--previous/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--previous",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStudyPrevious24",
          "filepath": "watson-health/study--previous/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--previous",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStudyPrevious20",
          "filepath": "watson-health/study--previous/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--previous",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStudyPrevious16",
          "filepath": "watson-health/study--previous/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "study--previous",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StudyPrevious",
        "global": "WatsonHealthStudyPrevious",
        "filepath": "watson-health/StudyPrevious.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21zM20 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0020 2zM30 30H28V25a5 5 0 00-5-5H17a5 5 0 00-5 5v5H10V25a7 7 0 017-7h6a7 7 0 017 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "study--read",
      "friendlyName": "Study read",
      "aliases": [
        "study",
        "read",
        "checkmark"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/study--read.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"21 29.414 16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414\"/>\n  <polygon points=\"20 14 20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14\"/>\n  <path d=\"M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z\"/><path d=\"M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/study--read.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStudyRead32",
          "filepath": "watson-health/study--read/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
                }
              }
            ],
            "name": "study--read",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStudyRead24",
          "filepath": "watson-health/study--read/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
                }
              }
            ],
            "name": "study--read",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStudyRead20",
          "filepath": "watson-health/study--read/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
                }
              }
            ],
            "name": "study--read",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStudyRead16",
          "filepath": "watson-health/study--read/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
                }
              }
            ],
            "name": "study--read",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StudyRead",
        "global": "WatsonHealthStudyRead",
        "filepath": "watson-health/StudyRead.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "study--skip",
      "friendlyName": "Study skip",
      "aliases": [
        "patient",
        "user",
        "profile",
        "skip",
        "study"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/study--skip.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--study--skip</title><path d=\"M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z\"/><path d=\"M16,12a3,3,0,1,1-3,3,2.95,2.95,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,16,10Z\"/><path d=\"M23,30H21V27a3,3,0,0,0-3-3H14a3,3,0,0,0-3,3v3H9V27a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z\"/><path d=\"M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z\"/></svg>",
            "info": {},
            "path": "32/watson-health/study--skip.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStudySkip32",
          "filepath": "watson-health/study--skip/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
                }
              }
            ],
            "name": "study--skip",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStudySkip24",
          "filepath": "watson-health/study--skip/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
                }
              }
            ],
            "name": "study--skip",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStudySkip20",
          "filepath": "watson-health/study--skip/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
                }
              }
            ],
            "name": "study--skip",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStudySkip16",
          "filepath": "watson-health/study--skip/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
                }
              }
            ],
            "name": "study--skip",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StudySkip",
        "global": "WatsonHealthStudySkip",
        "filepath": "watson-health/StudySkip.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 12a3 3 0 11-3 3 2.95 2.95 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 10zM23 30H21V27a3 3 0 00-3-3H14a3 3 0 00-3 3v3H9V27a5 5 0 015-5h4a5 5 0 015 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "study--transfer",
      "friendlyName": "Study transfer",
      "aliases": [
        "study",
        "transfer",
        "move forward"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/study--transfer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"8.586 19.414 13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414\"/>\n  <polygon points=\"2.586 19.414 7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414\"/>\n  <polygon points=\"12 14 12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14\"/>\n  <path d=\"M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z\"/><path d=\"M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z\"/><path d=\"M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/study--transfer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStudyTransfer32",
          "filepath": "watson-health/study--transfer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
                }
              }
            ],
            "name": "study--transfer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStudyTransfer24",
          "filepath": "watson-health/study--transfer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
                }
              }
            ],
            "name": "study--transfer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStudyTransfer20",
          "filepath": "watson-health/study--transfer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
                }
              }
            ],
            "name": "study--transfer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStudyTransfer16",
          "filepath": "watson-health/study--transfer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
                }
              }
            ],
            "name": "study--transfer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StudyTransfer",
        "global": "WatsonHealthStudyTransfer",
        "filepath": "watson-health/StudyTransfer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414zM12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "study--unread",
      "friendlyName": "Study unread",
      "aliases": [
        "study",
        "unread",
        "open circle"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/study--unread.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,30a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z\"/>\n  <polygon points=\"20 14 20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14\"/>\n  <path d=\"M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z\"/><path d=\"M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/study--unread.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStudyUnread32",
          "filepath": "watson-health/study--unread/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
                }
              }
            ],
            "name": "study--unread",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStudyUnread24",
          "filepath": "watson-health/study--unread/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
                }
              }
            ],
            "name": "study--unread",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStudyUnread20",
          "filepath": "watson-health/study--unread/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
                }
              }
            ],
            "name": "study--unread",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStudyUnread16",
          "filepath": "watson-health/study--unread/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
                }
              }
            ],
            "name": "study--unread",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StudyUnread",
        "global": "WatsonHealthStudyUnread",
        "filepath": "watson-health/StudyUnread.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "study--view",
      "friendlyName": "Study view",
      "aliases": [
        "study",
        "view"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/study--view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,20H25V18h3V4H14V7H12V4a2.002,2.002,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20Z\"/>\n  <polygon points=\"17 22 17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22\"/>\n  <path d=\"M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z\"/><path d=\"M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/study--view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthStudyView32",
          "filepath": "watson-health/study--view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
                }
              }
            ],
            "name": "study--view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthStudyView24",
          "filepath": "watson-health/study--view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
                }
              }
            ],
            "name": "study--view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthStudyView20",
          "filepath": "watson-health/study--view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
                }
              }
            ],
            "name": "study--view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthStudyView16",
          "filepath": "watson-health/study--view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
                }
              }
            ],
            "name": "study--view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "StudyView",
        "global": "WatsonHealthStudyView",
        "filepath": "watson-health/StudyView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 20H25V18h3V4H14V7H12V4a2.002 2.002 0 012-2H28a2.0023 2.0023 0 012 2V18A2.0027 2.0027 0 0128 20zM17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sub-volume",
      "friendlyName": "Sub volume",
      "aliases": [
        "sub volume",
        "health",
        "layers"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/sub-volume.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/sub-volume.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthSubVolume32",
          "filepath": "watson-health/sub-volume/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
                }
              }
            ],
            "name": "sub-volume",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthSubVolume24",
          "filepath": "watson-health/sub-volume/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
                }
              }
            ],
            "name": "sub-volume",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthSubVolume20",
          "filepath": "watson-health/sub-volume/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
                }
              }
            ],
            "name": "sub-volume",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthSubVolume16",
          "filepath": "watson-health/sub-volume/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
                }
              }
            ],
            "name": "sub-volume",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "SubVolume",
        "global": "WatsonHealthSubVolume",
        "filepath": "watson-health/SubVolume.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "subflow",
      "friendlyName": "Subflow",
      "aliases": [
        "subflow",
        "data",
        "node",
        "integration"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/subflow.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z\"/>\n  <path d=\"M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z\"/>\n  <path d=\"M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z\"/><path d=\"M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z\"/><path d=\"M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z\"/></svg>",
            "info": {},
            "path": "32/subflow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Subflow32",
          "filepath": "subflow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
                }
              }
            ],
            "name": "subflow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Subflow24",
          "filepath": "subflow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
                }
              }
            ],
            "name": "subflow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Subflow20",
          "filepath": "subflow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
                }
              }
            ],
            "name": "subflow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Subflow16",
          "filepath": "subflow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
                }
              }
            ],
            "name": "subflow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Subflow",
        "global": "Subflow",
        "filepath": "Subflow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "subflow--local",
      "friendlyName": "Subflow local",
      "aliases": [
        "subflow",
        "local",
        "node",
        "integration"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/subflow--local.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M15.3472,29.9851a13.9282,13.9282,0,0,1-4.2051-.8516l.6943-1.8754a11.929,11.929,0,0,0,3.6026.729Zm4.2651-.4558-.5146-1.9326a11.915,11.915,0,0,0,3.3632-1.4827l1.0782,1.6846A13.915,13.915,0,0,1,19.6123,29.5293ZM7.395,27.0439a14.0632,14.0632,0,0,1-2.94-3.1218l1.6484-1.1333a12.0521,12.0521,0,0,0,2.522,2.6785ZM2.5967,20.0544A14.0512,14.0512,0,0,1,2.0005,16H4a12.0412,12.0412,0,0,0,.5117,3.4763Z\"/>\n  <path d=\"M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z\"/>\n  <path d=\"M28,16a12.0412,12.0412,0,0,0-.5117-3.4763l1.915-.5781A14.0551,14.0551,0,0,1,30,16ZM25.8965,9.2112a12.0521,12.0521,0,0,0-2.522-2.6785l1.23-1.5766a14.0632,14.0632,0,0,1,2.94,3.1218ZM9.5391,5.886,8.4609,4.2014a13.915,13.915,0,0,1,3.9268-1.7307l.5146,1.9326A11.915,11.915,0,0,0,9.5391,5.886ZM20.1636,4.7419a11.929,11.929,0,0,0-3.6026-.729l.0918-1.998a13.9282,13.9282,0,0,1,4.2051.8516Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z\"/></svg>",
            "info": {},
            "path": "32/subflow--local.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SubflowLocal32",
          "filepath": "subflow--local/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
                }
              }
            ],
            "name": "subflow--local",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SubflowLocal24",
          "filepath": "subflow--local/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
                }
              }
            ],
            "name": "subflow--local",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SubflowLocal20",
          "filepath": "subflow--local/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
                }
              }
            ],
            "name": "subflow--local",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SubflowLocal16",
          "filepath": "subflow--local/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
                }
              }
            ],
            "name": "subflow--local",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SubflowLocal",
        "global": "SubflowLocal",
        "filepath": "SubflowLocal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.3472 29.9851a13.9282 13.9282 0 01-4.2051-.8516l.6943-1.8754a11.929 11.929 0 003.6026.729zm4.2651-.4558l-.5146-1.9326a11.915 11.915 0 003.3632-1.4827l1.0782 1.6846A13.915 13.915 0 0119.6123 29.5293zM7.395 27.0439a14.0632 14.0632 0 01-2.94-3.1218l1.6484-1.1333a12.0521 12.0521 0 002.522 2.6785zM2.5967 20.0544A14.0512 14.0512 0 012.0005 16H4a12.0412 12.0412 0 00.5117 3.4763zM26 17l-1.4141 1.4141L26.1719 20H15.8157a2.9874 2.9874 0 00-.2742-.5762l4.481-5.601A2.9676 2.9676 0 0021 14a3 3 0 10-2.8157-4H13.8157a2.982 2.982 0 00-5.6314 0H2v2H8.1843a2.982 2.982 0 005.6314 0h4.3686a2.9874 2.9874 0 00.2742.5762l-4.481 5.601A2.9676 2.9676 0 0013 18a3 3 0 102.8157 4H26.1719l-1.586 1.5859L26 25l4-4zm-5-7a1 1 0 11-1 1A1.0009 1.0009 0 0121 10zM11 12a1 1 0 111-1A1.0009 1.0009 0 0111 12zm2 10a1 1 0 111-1A1.0009 1.0009 0 0113 22zM28 16a12.0412 12.0412 0 00-.5117-3.4763l1.915-.5781A14.0551 14.0551 0 0130 16zM25.8965 9.2112a12.0521 12.0521 0 00-2.522-2.6785l1.23-1.5766a14.0632 14.0632 0 012.94 3.1218zM9.5391 5.886L8.4609 4.2014a13.915 13.915 0 013.9268-1.7307l.5146 1.9326A11.915 11.915 0 009.5391 5.886zM20.1636 4.7419a11.929 11.929 0 00-3.6026-.729l.0918-1.998a13.9282 13.9282 0 014.2051.8516z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "subnet-acl-rules",
      "friendlyName": "Subnet ACL rules",
      "aliases": [
        "lock",
        "ACL",
        "rules",
        "network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/subnet-acl-rules.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"18\" y=\"14\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"19\" width=\"8\" height=\"2\"/>\n  <rect x=\"18\" y=\"9\" width=\"12\" height=\"2\"/>\n  <path d=\"M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z\"/><path d=\"M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z\"/></svg>",
            "info": {},
            "path": "32/subnet-acl-rules.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SubnetAclRules32",
          "filepath": "subnet-acl-rules/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
                }
              }
            ],
            "name": "subnet-acl-rules",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SubnetAclRules24",
          "filepath": "subnet-acl-rules/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
                }
              }
            ],
            "name": "subnet-acl-rules",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SubnetAclRules20",
          "filepath": "subnet-acl-rules/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
                }
              }
            ],
            "name": "subnet-acl-rules",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SubnetAclRules16",
          "filepath": "subnet-acl-rules/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
                }
              }
            ],
            "name": "subnet-acl-rules",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SubnetAclRules",
        "global": "SubnetAclRules",
        "filepath": "SubnetAclRules.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 14H30V16H18zM18 19H26V21H18zM18 9H30V11H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "subtract",
      "friendlyName": "Subtract",
      "aliases": [
        "minus",
        "remove",
        "deduct",
        "withold",
        "decrease",
        "diminish",
        "discount",
        "remove",
        "take",
        "delete"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/subtract.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"8\" y=\"15\" width=\"16\" height=\"2\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 15H24V17H8z\"/></svg>",
            "info": {},
            "path": "32/subtract.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Subtract32",
          "filepath": "subtract/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Subtract24",
          "filepath": "subtract/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Subtract20",
          "filepath": "subtract/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Subtract16",
          "filepath": "subtract/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Subtract",
        "global": "Subtract",
        "filepath": "Subtract.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 15H24V17H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "subtract--alt",
      "friendlyName": "Subtract alt",
      "aliases": [
        "minus",
        "remove",
        "deduct",
        "withold",
        "decrease",
        "diminish",
        "discount",
        "remove",
        "take",
        "delete"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/subtract--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\n\tS23.7,2,16,2z\"/>\n<rect x=\"8\" y=\"15\" width=\"16\" height=\"2\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z\"/><path d=\"M8 15H24V17H8z\"/></svg>",
            "info": {},
            "path": "32/subtract--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SubtractAlt32",
          "filepath": "subtract--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SubtractAlt24",
          "filepath": "subtract--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SubtractAlt20",
          "filepath": "subtract--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SubtractAlt16",
          "filepath": "subtract--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 15H24V17H8z"
                }
              }
            ],
            "name": "subtract--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "SubtractAlt",
        "global": "SubtractAlt",
        "filepath": "SubtractAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14 S23.7,2,16,2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 15H24V17H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "summary--KPI",
      "friendlyName": "Summary KPI",
      "aliases": [
        "summary KPI",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/summary--KPI.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M7.6667,27.5027,2,22.4484l1.3311-1.4927,5.6411,5.0316,7.6906-7.4449a1.9282,1.9282,0,0,1,2.6736-.0084L22.96,21.9983l5.5791-5.9735L30,17.3905l-5.5812,5.9758a1.996,1.996,0,0,1-2.8379.08l-3.5765-3.4191-7.666,7.4206A1.9629,1.9629,0,0,1,7.6667,27.5027Z\"/>\n  <polygon points=\"30 11 26 11 28 8 30 11\"/>\n  <path d=\"M22,4H18V6h4V8H19v2h3v2H18v2h4a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Z\"/>\n  <path d=\"M16,14H10V10a2.002,2.002,0,0,1,2-2h2V6H10V4h4a2.0023,2.0023,0,0,1,2,2V8a2.0023,2.0023,0,0,1-2,2H12v2h4Z\"/>\n  <polygon points=\"6 12 6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z\"/></svg>",
            "info": {},
            "path": "32/summary--KPI.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SummaryKpi32",
          "filepath": "summary--KPI/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
                }
              }
            ],
            "name": "summary--KPI",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SummaryKpi24",
          "filepath": "summary--KPI/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
                }
              }
            ],
            "name": "summary--KPI",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SummaryKpi20",
          "filepath": "summary--KPI/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
                }
              }
            ],
            "name": "summary--KPI",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SummaryKpi16",
          "filepath": "summary--KPI/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
                }
              }
            ],
            "name": "summary--KPI",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SummaryKpi",
        "global": "SummaryKpi",
        "filepath": "SummaryKpi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.6667 27.5027L2 22.4484l1.3311-1.4927 5.6411 5.0316 7.6906-7.4449a1.9282 1.9282 0 012.6736-.0084L22.96 21.9983l5.5791-5.9735L30 17.3905l-5.5812 5.9758a1.996 1.996 0 01-2.8379.08l-3.5765-3.4191-7.666 7.4206A1.9629 1.9629 0 017.6667 27.5027zM30 11L26 11 28 8 30 11zM22 4H18V6h4V8H19v2h3v2H18v2h4a2.0027 2.0027 0 002-2V6A2.0023 2.0023 0 0022 4zM16 14H10V10a2.002 2.002 0 012-2h2V6H10V4h4a2.0023 2.0023 0 012 2V8a2.0023 2.0023 0 01-2 2H12v2h4zM6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "summary--KPI--mirror",
      "friendlyName": "summary--KPI--mirror",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/summary--KPI--mirror.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M24.3,27.5l5.7-5.1L28.7,21L23,26l-7.7-7.4c-0.7-0.7-1.9-0.7-2.7,0L9,22l-5.6-6L2,17.4l5.6,6c0.8,0.8,2,0.8,2.8,0.1L14,20\n\tl7.7,7.4C22.4,28.2,23.6,28.2,24.3,27.5z\"/>\n<polygon points=\"28,12 28,4 26,4 26,5 24,5 24,7 26,7 26,12 24,12 24,14 30,14 30,12 \"/>\n<path d=\"M22,14h-6v-4c0-1.1,0.9-2,2-2h2V6h-4V4h4c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2h-2v2h4V14z\"/>\n<path d=\"M12,4H8v2h4v2H9v2h3v2H8v2h4c1.1,0,2-0.9,2-2V6C14,4.9,13.1,4,12,4z\"/>\n<polygon points=\"6,11 2,11 4,8 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z\"/></svg>",
            "info": {},
            "path": "32/summary--KPI--mirror.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SummaryKpiMirror32",
          "filepath": "summary--KPI--mirror/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
                }
              }
            ],
            "name": "summary--KPI--mirror",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SummaryKpiMirror24",
          "filepath": "summary--KPI--mirror/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
                }
              }
            ],
            "name": "summary--KPI--mirror",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SummaryKpiMirror20",
          "filepath": "summary--KPI--mirror/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
                }
              }
            ],
            "name": "summary--KPI--mirror",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SummaryKpiMirror16",
          "filepath": "summary--KPI--mirror/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
                }
              }
            ],
            "name": "summary--KPI--mirror",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SummaryKpiMirror",
        "global": "SummaryKpiMirror",
        "filepath": "SummaryKpiMirror.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.3 27.5l5.7-5.1L28.7 21 23 26l-7.7-7.4c-.7-.7-1.9-.7-2.7 0L9 22l-5.6-6L2 17.4l5.6 6c.8.8 2 .8 2.8.1L14 20l7.7 7.4C22.4 28.2 23.6 28.2 24.3 27.5zM28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12zM22 14h-6v-4c0-1.1.9-2 2-2h2V6h-4V4h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V14zM12 4H8v2h4v2H9v2h3v2H8v2h4c1.1 0 2-.9 2-2V6C14 4.9 13.1 4 12 4zM6 11L2 11 4 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sun",
      "friendlyName": "Sun",
      "aliases": [
        "sun",
        "solar"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sun.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>sunny</title><path d=\"M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\" transform=\"translate(0 0.0049)\"/><rect x=\"6.8536\" y=\"5.3745\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-3.253 7.8584) rotate(-45)\"/><rect x=\"2\" y=\"15.0049\" width=\"5\" height=\"2\"/><rect x=\"5.3745\" y=\"23.1466\" width=\"4.958\" height=\"1.9998\" transform=\"translate(-14.7739 12.6305) rotate(-45)\"/><rect x=\"15\" y=\"25.0049\" width=\"2\" height=\"5\"/><rect x=\"23.1466\" y=\"21.6675\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-10.0018 24.1514) rotate(-45)\"/><rect x=\"25\" y=\"15.0049\" width=\"5\" height=\"2\"/><rect x=\"21.6675\" y=\"6.8536\" width=\"4.958\" height=\"1.9998\" transform=\"translate(1.5191 19.3793) rotate(-45)\"/><rect x=\"15\" y=\"2.0049\" width=\"2\" height=\"5\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z\" transform=\"translate(0 .005)\"/><path d=\"M6.854 5.375H8.854V10.333H6.854z\" transform=\"rotate(-45 7.86 7.856)\"/><path d=\"M2 15.005H7V17.005000000000003H2z\"/><path d=\"M5.375 23.147H10.333V25.147H5.375z\" transform=\"rotate(-45 7.86 24.149)\"/><path d=\"M15 25.005H17V30.005H15z\"/><path d=\"M23.147 21.668H25.147V26.625999999999998H23.147z\" transform=\"rotate(-45 24.152 24.149)\"/><path d=\"M25 15.005H30V17.005000000000003H25z\"/><path d=\"M21.668 6.854H26.625999999999998V8.854H21.668z\" transform=\"rotate(-45 24.152 7.856)\"/><path d=\"M15 2.005H17V7.005H15z\"/></svg>",
            "info": {},
            "path": "32/sun.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sun32",
          "filepath": "sun/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.86 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15.005H7V17.005000000000003H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.86 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25.005H17V30.005H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.152 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15.005H30V17.005000000000003H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.152 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2.005H17V7.005H15z"
                }
              }
            ],
            "name": "sun",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sun24",
          "filepath": "sun/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.86 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15.005H7V17.005000000000003H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.86 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25.005H17V30.005H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.152 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15.005H30V17.005000000000003H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.152 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2.005H17V7.005H15z"
                }
              }
            ],
            "name": "sun",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sun20",
          "filepath": "sun/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.86 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15.005H7V17.005000000000003H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.86 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25.005H17V30.005H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.152 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15.005H30V17.005000000000003H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.152 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2.005H17V7.005H15z"
                }
              }
            ],
            "name": "sun",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sun16",
          "filepath": "sun/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.86 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 15.005H7V17.005000000000003H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.375 23.147H10.333V25.147H5.375z",
                  "transform": "rotate(-45 7.86 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 25.005H17V30.005H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                  "transform": "rotate(-45 24.152 24.149)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15.005H30V17.005000000000003H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.152 7.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2.005H17V7.005H15z"
                }
              }
            ],
            "name": "sun",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Sun",
        "global": "Sun",
        "filepath": "Sun.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
                    "transform": "translate(0 .005)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.854 5.375H8.854V10.333H6.854z",
                    "transform": "rotate(-45 7.86 7.856)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 15.005H7V17.005000000000003H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.375 23.147H10.333V25.147H5.375z",
                    "transform": "rotate(-45 7.86 24.149)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 25.005H17V30.005H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.147 21.668H25.147V26.625999999999998H23.147z",
                    "transform": "rotate(-45 24.152 24.149)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 15.005H30V17.005000000000003H25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                    "transform": "rotate(-45 24.152 7.856)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2.005H17V7.005H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sunrise",
      "friendlyName": "Sunrise",
      "aliases": [
        "sunrise"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sunrise.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>sunrise</title><rect x=\"2\" y=\"27\" width=\"27.9985\" height=\"2\"/><path d=\"M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z\"/><rect x=\"25\" y=\"22\" width=\"5\" height=\"2\"/><rect x=\"21.6675\" y=\"14.8536\" width=\"4.958\" height=\"1.9998\" transform=\"translate(-4.1378 21.7175) rotate(-45)\"/><polygon points=\"16 4 11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4\"/><rect x=\"6.8536\" y=\"13.3745\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-8.9099 10.1967) rotate(-45)\"/><rect x=\"2\" y=\"22\" width=\"5\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z\"/><path d=\"M21.668 14.854H26.625999999999998V16.854H21.668z\" transform=\"rotate(-45 24.146 15.854)\"/><path d=\"M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z\"/><path d=\"M6.854 13.374H8.854V18.332H6.854z\" transform=\"rotate(-45 7.854 15.854)\"/><path d=\"M2 22H7V24H2z\"/></svg>",
            "info": {},
            "path": "32/sunrise.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sunrise32",
          "filepath": "sunrise/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.146 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.854 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H7V24H2z"
                }
              }
            ],
            "name": "sunrise",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sunrise24",
          "filepath": "sunrise/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.146 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.854 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H7V24H2z"
                }
              }
            ],
            "name": "sunrise",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sunrise20",
          "filepath": "sunrise/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.146 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.854 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H7V24H2z"
                }
              }
            ],
            "name": "sunrise",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sunrise16",
          "filepath": "sunrise/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.146 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.854 15.854)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22H7V24H2z"
                }
              }
            ],
            "name": "sunrise",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Sunrise",
        "global": "Sunrise",
        "filepath": "Sunrise.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                    "transform": "rotate(-45 24.146 15.854)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.854 13.374H8.854V18.332H6.854z",
                    "transform": "rotate(-45 7.854 15.854)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 22H7V24H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sunset",
      "friendlyName": "Sunset",
      "aliases": [
        "sunset"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sunset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>sunset</title><rect x=\"2\" y=\"27.0049\" width=\"27.9985\" height=\"2\"/><path d=\"M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z\" transform=\"translate(0 0.0049)\"/><rect x=\"25\" y=\"22.0049\" width=\"5\" height=\"2\"/><rect x=\"21.6675\" y=\"14.8536\" width=\"4.958\" height=\"1.9998\" transform=\"translate(-4.1378 21.7224) rotate(-45)\"/><polygon points=\"19.59 9.595 17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595\"/><rect x=\"6.8536\" y=\"13.3745\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-8.9099 10.2015) rotate(-45)\"/><rect x=\"2\" y=\"22.0049\" width=\"5\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 27.005H29.998V29.005H2z\"/><path d=\"M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z\" transform=\"translate(0 .005)\"/><path d=\"M25 22.005H30V24.005H25z\"/><path d=\"M21.668 14.854H26.625999999999998V16.854H21.668z\" transform=\"rotate(-45 24.152 15.856)\"/><path d=\"M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z\"/><path d=\"M6.854 13.374H8.854V18.332H6.854z\" transform=\"rotate(-45 7.86 15.856)\"/><path d=\"M2 22.005H7V24.005H2z\"/></svg>",
            "info": {},
            "path": "32/sunset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Sunset32",
          "filepath": "sunset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27.005H29.998V29.005H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22.005H30V24.005H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.152 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.86 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22.005H7V24.005H2z"
                }
              }
            ],
            "name": "sunset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Sunset24",
          "filepath": "sunset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27.005H29.998V29.005H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22.005H30V24.005H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.152 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.86 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22.005H7V24.005H2z"
                }
              }
            ],
            "name": "sunset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Sunset20",
          "filepath": "sunset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27.005H29.998V29.005H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22.005H30V24.005H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.152 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.86 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22.005H7V24.005H2z"
                }
              }
            ],
            "name": "sunset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Sunset16",
          "filepath": "sunset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 27.005H29.998V29.005H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
                  "transform": "translate(0 .005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 22.005H30V24.005H25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                  "transform": "rotate(-45 24.152 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 13.374H8.854V18.332H6.854z",
                  "transform": "rotate(-45 7.86 15.856)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 22.005H7V24.005H2z"
                }
              }
            ],
            "name": "sunset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Sunset",
        "global": "Sunset",
        "filepath": "Sunset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 27.005H29.998V29.005H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
                    "transform": "translate(0 .005)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 22.005H30V24.005H25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.668 14.854H26.625999999999998V16.854H21.668z",
                    "transform": "rotate(-45 24.152 15.856)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.854 13.374H8.854V18.332H6.854z",
                    "transform": "rotate(-45 7.86 15.856)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 22.005H7V24.005H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "SVG",
      "friendlyName": "SVG",
      "aliases": [
        "format",
        "image",
        "vector"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/SVG.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>SVG</title><path d=\"M30,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H24V21h4V17H26V15h4Z\" transform=\"translate(0 0)\"/><polygon points=\"18 9 16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9\"/><path d=\"M8,23H2V21H8V17H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9h6v2H4v4H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,23Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z\"/></svg>",
            "info": {},
            "path": "32/SVG.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Svg32",
          "filepath": "SVG/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SVG",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Svg24",
          "filepath": "SVG/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SVG",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Svg20",
          "filepath": "SVG/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SVG",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Svg16",
          "filepath": "SVG/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                }
              }
            ],
            "name": "SVG",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Svg",
        "global": "Svg",
        "filepath": "Svg.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "swim",
      "friendlyName": "Swim",
      "aliases": [
        "travel",
        "sports"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/swim.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>swim</title>\n  <path d=\"M30,26H28a4.9316,4.9316,0,0,1-4-1.9873,5.0192,5.0192,0,0,1-8,0,5.0192,5.0192,0,0,1-8,0A4.9316,4.9316,0,0,1,4,26H2V24H4a3.44,3.44,0,0,0,3.0532-2.3215A.9712.9712,0,0,1,8,21a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,12,24a3.44,3.44,0,0,0,3.0532-2.3215A.99.99,0,0,1,16,21a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,20,24a3.44,3.44,0,0,0,3.0532-2.3215,1,1,0,0,1,1.8955.0053A3.4381,3.4381,0,0,0,28,24h2Z\"/>\n  <path d=\"M23,17.5859l-8.707-8.707A2.9791,2.9791,0,0,0,12.1714,8H4v2h8.1714a.9933.9933,0,0,1,.7075.293L15.5859,13,10,18.5859,11.4141,20,17,14.4141,21.5859,19Z\"/>\n  <path d=\"M20,10a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,20,10Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,22,10Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z\"/></svg>",
            "info": {},
            "path": "32/swim.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Swim32",
          "filepath": "swim/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
                }
              }
            ],
            "name": "swim",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Swim24",
          "filepath": "swim/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
                }
              }
            ],
            "name": "swim",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Swim20",
          "filepath": "swim/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
                }
              }
            ],
            "name": "swim",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Swim16",
          "filepath": "swim/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
                }
              }
            ],
            "name": "swim",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Swim",
        "global": "Swim",
        "filepath": "Swim.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "switch-layer-2",
      "friendlyName": "Switch layer 2",
      "aliases": [
        "switch",
        "layer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/switch-layer-2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 26 16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26\"/>\n  <polygon points=\"16 14 16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14\"/>\n  <polygon points=\"16 6 16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6\"/>\n  <polygon points=\"16 18 16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z\"/></svg>",
            "info": {},
            "path": "32/switch-layer-2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SwitchLayer_232",
          "filepath": "switch-layer-2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
                }
              }
            ],
            "name": "switch-layer-2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SwitchLayer_224",
          "filepath": "switch-layer-2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
                }
              }
            ],
            "name": "switch-layer-2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SwitchLayer_220",
          "filepath": "switch-layer-2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
                }
              }
            ],
            "name": "switch-layer-2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SwitchLayer_216",
          "filepath": "switch-layer-2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
                }
              }
            ],
            "name": "switch-layer-2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SwitchLayer_2",
        "global": "SwitchLayer_2",
        "filepath": "SwitchLayer_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26zM16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14zM16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6zM16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "switch-layer-3",
      "friendlyName": "Switch layer 3",
      "aliases": [
        "switch",
        "layer"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/switch-layer-3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 4 22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4\"/>\n  <polygon points=\"10 4 10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4\"/>\n  <polygon points=\"20 5 16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5\"/>\n  <polygon points=\"22 28 22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28\"/>\n  <polygon points=\"10 28 10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28\"/>\n  <polygon points=\"20 27 16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27\"/>\n  <polygon points=\"5 12 1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12\"/>\n  <polygon points=\"27 12 31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z\"/></svg>",
            "info": {},
            "path": "32/switch-layer-3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SwitchLayer_332",
          "filepath": "switch-layer-3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
                }
              }
            ],
            "name": "switch-layer-3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SwitchLayer_324",
          "filepath": "switch-layer-3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
                }
              }
            ],
            "name": "switch-layer-3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SwitchLayer_320",
          "filepath": "switch-layer-3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
                }
              }
            ],
            "name": "switch-layer-3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SwitchLayer_316",
          "filepath": "switch-layer-3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
                }
              }
            ],
            "name": "switch-layer-3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "SwitchLayer_3",
        "global": "SwitchLayer_3",
        "filepath": "SwitchLayer_3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4zM10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4zM20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5zM22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28zM10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28zM20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27zM5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12zM27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "switcher",
      "friendlyName": "Switcher",
      "aliases": [
        "switcher",
        "selector"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/switcher.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect class=\"st0\" width=\"32\" height=\"32\"/>\n<rect x=\"14\" y=\"4\" width=\"4\" height=\"4\"/>\n<rect x=\"4\" y=\"4\" width=\"4\" height=\"4\"/>\n<rect x=\"24\" y=\"4\" width=\"4\" height=\"4\"/>\n<rect x=\"14\" y=\"14\" width=\"4\" height=\"4\"/>\n<rect x=\"4\" y=\"14\" width=\"4\" height=\"4\"/>\n<rect x=\"24\" y=\"14\" width=\"4\" height=\"4\"/>\n<rect x=\"14\" y=\"24\" width=\"4\" height=\"4\"/>\n<rect x=\"4\" y=\"24\" width=\"4\" height=\"4\"/>\n<rect x=\"24\" y=\"24\" width=\"4\" height=\"4\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z\"/></svg>",
            "info": {},
            "path": "32/switcher.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Switcher32",
          "filepath": "switcher/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
                }
              }
            ],
            "name": "switcher",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Switcher24",
          "filepath": "switcher/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
                }
              }
            ],
            "name": "switcher",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Switcher20",
          "filepath": "switcher/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
                }
              }
            ],
            "name": "switcher",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Switcher16",
          "filepath": "switcher/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
                }
              }
            ],
            "name": "switcher",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "Switcher",
        "global": "Switcher",
        "filepath": "Switcher.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "sys-provision",
      "friendlyName": "Sys provision",
      "aliases": [
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/sys-provision.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>sys-provision</title><polygon points=\"21 20 21 30 30 25 21 20\"/><circle cx=\"14\" cy=\"14\" r=\"2\"/><path d=\"M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z\"/><path d=\"M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 20L21 30 30 25 21 20z\"/><circle cx=\"14\" cy=\"14\" r=\"2\"/><path d=\"M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z\"/><path d=\"M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z\"/></svg>",
            "info": {},
            "path": "32/sys-provision.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "SysProvision32",
          "filepath": "sys-provision/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20L21 30 30 25 21 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
                }
              }
            ],
            "name": "sys-provision",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "SysProvision24",
          "filepath": "sys-provision/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20L21 30 30 25 21 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
                }
              }
            ],
            "name": "sys-provision",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "SysProvision20",
          "filepath": "sys-provision/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20L21 30 30 25 21 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
                }
              }
            ],
            "name": "sys-provision",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "SysProvision16",
          "filepath": "sys-provision/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 20L21 30 30 25 21 20z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "14",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
                }
              }
            ],
            "name": "sys-provision",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "SysProvision",
        "global": "SysProvision",
        "filepath": "SysProvision.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 20L21 30 30 25 21 20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "14",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "T",
      "friendlyName": "T",
      "aliases": [
        "letter",
        "alphabet",
        "alt"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/T.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--T</title><polygon points=\"12 11 15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z\"/></svg>",
            "info": {},
            "path": "32/Q/T.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QT32",
          "filepath": "Q/T/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "T",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QT24",
          "filepath": "Q/T/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "T",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QT20",
          "filepath": "Q/T/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "T",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QT16",
          "filepath": "Q/T/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
                }
              }
            ],
            "name": "T",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "T",
        "global": "QT",
        "filepath": "Q/T.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "T--alt",
      "friendlyName": "T alt",
      "aliases": [
        "letter",
        "alphabet",
        "alt"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/T--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--T--alt</title><polygon points=\"8 11 11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11\"/><polygon points=\"24 9 22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z\"/></svg>",
            "info": {},
            "path": "32/Q/T--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QTAlt32",
          "filepath": "Q/T--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
                }
              }
            ],
            "name": "T--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QTAlt24",
          "filepath": "Q/T--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
                }
              }
            ],
            "name": "T--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QTAlt20",
          "filepath": "Q/T--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
                }
              }
            ],
            "name": "T--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QTAlt16",
          "filepath": "Q/T--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
                }
              }
            ],
            "name": "T--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "TAlt",
        "global": "QTAlt",
        "filepath": "Q/TAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "table",
      "friendlyName": "Table",
      "aliases": [
        "data",
        "spreadsheet",
        "excel",
        "chart",
        "rows",
        "grid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/table.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>table</title><path d=\"M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z\"/></svg>",
            "info": {},
            "path": "32/table.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Table32",
          "filepath": "table/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
                }
              }
            ],
            "name": "table",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Table24",
          "filepath": "table/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
                }
              }
            ],
            "name": "table",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Table20",
          "filepath": "table/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
                }
              }
            ],
            "name": "table",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Table16",
          "filepath": "table/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
                }
              }
            ],
            "name": "table",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Table",
        "global": "Table",
        "filepath": "Table.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "table--alias",
      "friendlyName": "Table alias",
      "aliases": [
        "data",
        "spreadsheet",
        "excel",
        "chart",
        "rows",
        "grid",
        "alias",
        "shortcut"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/table--alias.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z\"/>\n  <path d=\"M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z\"/><path d=\"M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z\"/></svg>",
            "info": {},
            "path": "32/table--alias.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TableAlias32",
          "filepath": "table--alias/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--alias",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TableAlias24",
          "filepath": "table--alias/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--alias",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TableAlias20",
          "filepath": "table--alias/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--alias",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TableAlias16",
          "filepath": "table--alias/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--alias",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TableAlias",
        "global": "TableAlias",
        "filepath": "TableAlias.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "table--built",
      "friendlyName": "Table built",
      "aliases": [
        "data",
        "spreadsheet",
        "excel",
        "chart",
        "rows",
        "grid",
        "table built"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/table--built.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z\"/></svg>",
            "info": {},
            "path": "32/table--built.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TableBuilt32",
          "filepath": "table--built/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z"
                }
              }
            ],
            "name": "table--built",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TableBuilt24",
          "filepath": "table--built/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z"
                }
              }
            ],
            "name": "table--built",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TableBuilt20",
          "filepath": "table--built/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z"
                }
              }
            ],
            "name": "table--built",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TableBuilt16",
          "filepath": "table--built/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z"
                }
              }
            ],
            "name": "table--built",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TableBuilt",
        "global": "TableBuilt",
        "filepath": "TableBuilt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "table--shortcut",
      "friendlyName": "Table shortcut",
      "aliases": [
        "data",
        "spreadsheet",
        "excel",
        "chart",
        "rows",
        "grid",
        "shortcut",
        "direct"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/table--shortcut.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"5 18 5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18\"/>\n  <path d=\"M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5 18L5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18z\"/><path d=\"M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z\"/></svg>",
            "info": {},
            "path": "32/table--shortcut.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TableShortcut32",
          "filepath": "table--shortcut/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 18L5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--shortcut",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TableShortcut24",
          "filepath": "table--shortcut/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 18L5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--shortcut",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TableShortcut20",
          "filepath": "table--shortcut/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 18L5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--shortcut",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TableShortcut16",
          "filepath": "table--shortcut/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 18L5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                }
              }
            ],
            "name": "table--shortcut",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TableShortcut",
        "global": "TableShortcut",
        "filepath": "TableShortcut.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 18L5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "table--split",
      "friendlyName": "Table split",
      "aliases": [
        "data",
        "spreadsheet",
        "excel",
        "chart",
        "rows",
        "grid",
        "table split"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/table--split.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>table--split</title><path d=\"M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z\"/></svg>",
            "info": {},
            "path": "32/table--split.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TableSplit32",
          "filepath": "table--split/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
                }
              }
            ],
            "name": "table--split",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TableSplit24",
          "filepath": "table--split/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
                }
              }
            ],
            "name": "table--split",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TableSplit20",
          "filepath": "table--split/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
                }
              }
            ],
            "name": "table--split",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TableSplit16",
          "filepath": "table--split/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
                }
              }
            ],
            "name": "table--split",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TableSplit",
        "global": "TableSplit",
        "filepath": "TableSplit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "table-of-contents",
      "friendlyName": "Table of contents",
      "aliases": [
        "list",
        "chart",
        "schedule",
        "record",
        "appendix",
        "index",
        "summary",
        "bullet point",
        "content",
        "menu"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/table-of-contents.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>table-of-contents</title><rect x=\"4\" y=\"6\" width=\"18\" height=\"2\"/><rect x=\"4\" y=\"12\" width=\"18\" height=\"2\"/><rect x=\"4\" y=\"18\" width=\"18\" height=\"2\"/><rect x=\"4\" y=\"24\" width=\"18\" height=\"2\"/><rect x=\"26\" y=\"6\" width=\"2\" height=\"2\"/><rect x=\"26\" y=\"12\" width=\"2\" height=\"2\"/><rect x=\"26\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"26\" y=\"24\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z\"/></svg>",
            "info": {},
            "path": "32/table-of-contents.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TableOfContents32",
          "filepath": "table-of-contents/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
                }
              }
            ],
            "name": "table-of-contents",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TableOfContents24",
          "filepath": "table-of-contents/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
                }
              }
            ],
            "name": "table-of-contents",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TableOfContents20",
          "filepath": "table-of-contents/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
                }
              }
            ],
            "name": "table-of-contents",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TableOfContents16",
          "filepath": "table-of-contents/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
                }
              }
            ],
            "name": "table-of-contents",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TableOfContents",
        "global": "TableOfContents",
        "filepath": "TableOfContents.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tablet",
      "friendlyName": "Tablet",
      "aliases": [
        "tablet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tablet.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tablet</title><rect x=\"15\" y=\"22\" width=\"2\" height=\"6\" transform=\"translate(41 9) rotate(90)\"/><path d=\"M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 22H17V28H15z\" transform=\"rotate(90 16 25)\"/><path d=\"M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z\"/></svg>",
            "info": {},
            "path": "32/tablet.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tablet32",
          "filepath": "tablet/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 22H17V28H15z",
                  "transform": "rotate(90 16 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
                }
              }
            ],
            "name": "tablet",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tablet24",
          "filepath": "tablet/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 22H17V28H15z",
                  "transform": "rotate(90 16 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
                }
              }
            ],
            "name": "tablet",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tablet20",
          "filepath": "tablet/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 22H17V28H15z",
                  "transform": "rotate(90 16 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
                }
              }
            ],
            "name": "tablet",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tablet16",
          "filepath": "tablet/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 22H17V28H15z",
                  "transform": "rotate(90 16 25)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
                }
              }
            ],
            "name": "tablet",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Tablet",
        "global": "Tablet",
        "filepath": "Tablet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 22H17V28H15z",
                    "transform": "rotate(90 16 25)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tablet--landscape",
      "friendlyName": "Tablet landscape",
      "aliases": [
        "tablet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tablet--landscape.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tablet--landscape</title><rect x=\"24\" y=\"13\" width=\"2\" height=\"6\"/><path d=\"M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 13H26V19H24z\"/><path d=\"M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z\"/></svg>",
            "info": {},
            "path": "32/tablet--landscape.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TabletLandscape32",
          "filepath": "tablet--landscape/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H26V19H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
                }
              }
            ],
            "name": "tablet--landscape",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TabletLandscape24",
          "filepath": "tablet--landscape/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H26V19H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
                }
              }
            ],
            "name": "tablet--landscape",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TabletLandscape20",
          "filepath": "tablet--landscape/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H26V19H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
                }
              }
            ],
            "name": "tablet--landscape",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TabletLandscape16",
          "filepath": "tablet--landscape/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 13H26V19H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
                }
              }
            ],
            "name": "tablet--landscape",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "TabletLandscape",
        "global": "TabletLandscape",
        "filepath": "TabletLandscape.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 13H26V19H24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tag",
      "friendlyName": "Tag",
      "aliases": [
        "label",
        "mark",
        "price",
        "sale",
        "shop",
        "marker"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tag.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z\"/><path d=\"M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z\"/></svg>",
            "info": {},
            "path": "32/tag.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tag32",
          "filepath": "tag/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z"
                }
              }
            ],
            "name": "tag",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tag24",
          "filepath": "tag/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z"
                }
              }
            ],
            "name": "tag",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tag20",
          "filepath": "tag/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z"
                }
              }
            ],
            "name": "tag",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tag16",
          "filepath": "tag/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z"
                }
              }
            ],
            "name": "tag",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Tag",
        "global": "Tag",
        "filepath": "Tag.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tag--edit",
      "friendlyName": "Tag edit",
      "aliases": [
        "label",
        "mark",
        "price",
        "sale",
        "shop",
        "marker"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tag--edit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.707,7.293l-3-3a.9994.9994,0,0,0-1.414,0L16,13.5859V18h4.4141L29.707,8.707A.9994.9994,0,0,0,29.707,7.293ZM19.5859,16H18V14.4141l5-5L24.5859,11ZM26,9.5859,24.4141,8,26,6.4141,27.5859,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z\"/><path d=\"M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z\"/></svg>",
            "info": {},
            "path": "32/tag--edit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TagEdit32",
          "filepath": "tag--edit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z"
                }
              }
            ],
            "name": "tag--edit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TagEdit24",
          "filepath": "tag--edit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z"
                }
              }
            ],
            "name": "tag--edit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TagEdit20",
          "filepath": "tag--edit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z"
                }
              }
            ],
            "name": "tag--edit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TagEdit16",
          "filepath": "tag--edit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z"
                }
              }
            ],
            "name": "tag--edit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "TagEdit",
        "global": "TagEdit",
        "filepath": "TagEdit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tag--export",
      "friendlyName": "Tag export",
      "aliases": [
        "label",
        "mark",
        "price",
        "sale",
        "shop",
        "marker",
        "export"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tag--export.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"31 18 25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18\"/>\n  <path d=\"M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 18L25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z\"/><path d=\"M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z\"/></svg>",
            "info": {},
            "path": "32/tag--export.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TagExport32",
          "filepath": "tag--export/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 18L25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z"
                }
              }
            ],
            "name": "tag--export",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TagExport24",
          "filepath": "tag--export/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 18L25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z"
                }
              }
            ],
            "name": "tag--export",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TagExport20",
          "filepath": "tag--export/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 18L25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z"
                }
              }
            ],
            "name": "tag--export",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TagExport16",
          "filepath": "tag--export/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 18L25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z"
                }
              }
            ],
            "name": "tag--export",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "TagExport",
        "global": "TagExport",
        "filepath": "TagExport.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 18L25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tag--group",
      "friendlyName": "Tag group",
      "aliases": [
        "label",
        "mark",
        "price",
        "sale",
        "shop",
        "marker"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tag--group.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tag--group</title><circle cx=\"10\" cy=\"14\" r=\"2\"/><path d=\"M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z\"/><path d=\"M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10\" cy=\"14\" r=\"2\"/><path d=\"M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z\"/><path d=\"M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z\"/></svg>",
            "info": {},
            "path": "32/tag--group.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TagGroup32",
          "filepath": "tag--group/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
                }
              }
            ],
            "name": "tag--group",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TagGroup24",
          "filepath": "tag--group/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
                }
              }
            ],
            "name": "tag--group",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TagGroup20",
          "filepath": "tag--group/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
                }
              }
            ],
            "name": "tag--group",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TagGroup16",
          "filepath": "tag--group/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10",
                  "cy": "14",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
                }
              }
            ],
            "name": "tag--group",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "TagGroup",
        "global": "TagGroup",
        "filepath": "TagGroup.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10",
                    "cy": "14",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tag--import",
      "friendlyName": "Tag import",
      "aliases": [
        "label",
        "mark",
        "price",
        "sale",
        "shop",
        "marker",
        "import"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tag--import.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"16 18 22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18\"/>\n  <path d=\"M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 18L22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z\"/><path d=\"M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z\"/></svg>",
            "info": {},
            "path": "32/tag--import.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TagImport32",
          "filepath": "tag--import/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z"
                }
              }
            ],
            "name": "tag--import",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TagImport24",
          "filepath": "tag--import/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z"
                }
              }
            ],
            "name": "tag--import",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TagImport20",
          "filepath": "tag--import/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z"
                }
              }
            ],
            "name": "tag--import",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TagImport16",
          "filepath": "tag--import/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 18L22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z"
                }
              }
            ],
            "name": "tag--import",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "TagImport",
        "global": "TagImport",
        "filepath": "TagImport.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 18L22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tag--none",
      "friendlyName": "Tag none",
      "aliases": [
        "label",
        "mark",
        "price",
        "sale",
        "shop",
        "marker",
        "none"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tag--none.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23.092,10.3218,30,3.4141,28.5859,2,2,28.5859,3.4141,30l6.9077-6.9077,6.3218,6.3223a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286ZM18.0579,28l-6.3218-6.3223,9.9419-9.9419L28,18.0576Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.092 10.3218L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6.9077-6.9077 6.3218 6.3223a2.001 2.001 0 002.8286 0l9.9424-9.9424a2.001 2.001 0 000-2.8286zM18.0579 28l-6.3218-6.3223 9.9419-9.9419L28 18.0576zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z\"/><path d=\"M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z\"/></svg>",
            "info": {},
            "path": "32/tag--none.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TagNone32",
          "filepath": "tag--none/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.092 10.3218L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6.9077-6.9077 6.3218 6.3223a2.001 2.001 0 002.8286 0l9.9424-9.9424a2.001 2.001 0 000-2.8286zM18.0579 28l-6.3218-6.3223 9.9419-9.9419L28 18.0576zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z"
                }
              }
            ],
            "name": "tag--none",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TagNone24",
          "filepath": "tag--none/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.092 10.3218L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6.9077-6.9077 6.3218 6.3223a2.001 2.001 0 002.8286 0l9.9424-9.9424a2.001 2.001 0 000-2.8286zM18.0579 28l-6.3218-6.3223 9.9419-9.9419L28 18.0576zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z"
                }
              }
            ],
            "name": "tag--none",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TagNone20",
          "filepath": "tag--none/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.092 10.3218L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6.9077-6.9077 6.3218 6.3223a2.001 2.001 0 002.8286 0l9.9424-9.9424a2.001 2.001 0 000-2.8286zM18.0579 28l-6.3218-6.3223 9.9419-9.9419L28 18.0576zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z"
                }
              }
            ],
            "name": "tag--none",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TagNone16",
          "filepath": "tag--none/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.092 10.3218L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6.9077-6.9077 6.3218 6.3223a2.001 2.001 0 002.8286 0l9.9424-9.9424a2.001 2.001 0 000-2.8286zM18.0579 28l-6.3218-6.3223 9.9419-9.9419L28 18.0576zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z"
                }
              }
            ],
            "name": "tag--none",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "TagNone",
        "global": "TagNone",
        "filepath": "TagNone.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.092 10.3218L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6.9077-6.9077 6.3218 6.3223a2.001 2.001 0 002.8286 0l9.9424-9.9424a2.001 2.001 0 000-2.8286zM18.0579 28l-6.3218-6.3223 9.9419-9.9419L28 18.0576zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 101.998 2.0044A2.002 2.002 0 0010 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tank",
      "friendlyName": "Tank",
      "aliases": [
        "tank",
        "travel",
        "military",
        "vehicle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tank.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z\"/></svg>",
            "info": {},
            "path": "32/tank.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tank32",
          "filepath": "tank/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z"
                }
              }
            ],
            "name": "tank",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tank24",
          "filepath": "tank/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z"
                }
              }
            ],
            "name": "tank",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tank20",
          "filepath": "tank/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z"
                }
              }
            ],
            "name": "tank",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tank16",
          "filepath": "tank/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z"
                }
              }
            ],
            "name": "tank",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Tank",
        "global": "Tank",
        "filepath": "Tank.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task",
      "friendlyName": "Task",
      "aliases": [
        "clipboard",
        "checkmark",
        "checklist",
        "assignment",
        "to do list",
        "list",
        "chore"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>task</title><polygon points=\"14 20.18 10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z\"/><path d=\"M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z\"/></svg>",
            "info": {},
            "path": "32/task.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Task32",
          "filepath": "task/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "task",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Task24",
          "filepath": "task/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "task",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Task20",
          "filepath": "task/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "task",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Task16",
          "filepath": "task/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                }
              }
            ],
            "name": "task",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Task",
        "global": "Task",
        "filepath": "Task.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--add",
      "friendlyName": "Task add",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "plus",
        "add"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"31 24 27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 24L27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskAdd32",
          "filepath": "task--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 24L27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskAdd24",
          "filepath": "task--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 24L27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskAdd20",
          "filepath": "task--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 24L27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskAdd16",
          "filepath": "task--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 24L27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskAdd",
        "global": "TaskAdd",
        "filepath": "TaskAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 24L27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--approved",
      "friendlyName": "Task approved",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "seal",
        "certificate",
        "approved",
        "approve",
        "approval"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--approved.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--approved.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskApproved32",
          "filepath": "task--approved/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--approved",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskApproved24",
          "filepath": "task--approved/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--approved",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskApproved20",
          "filepath": "task--approved/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--approved",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskApproved16",
          "filepath": "task--approved/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--approved",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskApproved",
        "global": "TaskApproved",
        "filepath": "TaskApproved.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--asset-view",
      "friendlyName": "Task asset-view",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "target",
        "asset-view"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--asset-view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z\"/>\n  <path d=\"M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z\"/><path d=\"M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--asset-view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskAssetView32",
          "filepath": "task--asset-view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--asset-view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskAssetView24",
          "filepath": "task--asset-view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--asset-view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskAssetView20",
          "filepath": "task--asset-view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--asset-view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskAssetView16",
          "filepath": "task--asset-view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--asset-view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskAssetView",
        "global": "TaskAssetView",
        "filepath": "TaskAssetView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--complete",
      "friendlyName": "Task complete",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "check",
        "checkmark",
        "complete"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--complete.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"22 27.18 19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--complete.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskComplete32",
          "filepath": "task--complete/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--complete",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskComplete24",
          "filepath": "task--complete/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--complete",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskComplete20",
          "filepath": "task--complete/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--complete",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskComplete16",
          "filepath": "task--complete/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--complete",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskComplete",
        "global": "TaskComplete",
        "filepath": "TaskComplete.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--location",
      "friendlyName": "Task location",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "pin",
        "location"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--location.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"24\" cy=\"21\" r=\"2\"/>\n  <path d=\"M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"24\" cy=\"21\" r=\"2\"/><path d=\"M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--location.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskLocation32",
          "filepath": "task--location/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--location",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskLocation24",
          "filepath": "task--location/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--location",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskLocation20",
          "filepath": "task--location/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--location",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskLocation16",
          "filepath": "task--location/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "21",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--location",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskLocation",
        "global": "TaskLocation",
        "filepath": "TaskLocation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "21",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--remove",
      "friendlyName": "Task remove",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "cross out",
        "remove"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--remove.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26.41 25 30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--remove.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskRemove32",
          "filepath": "task--remove/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--remove",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskRemove24",
          "filepath": "task--remove/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--remove",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskRemove20",
          "filepath": "task--remove/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--remove",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskRemove16",
          "filepath": "task--remove/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--remove",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskRemove",
        "global": "TaskRemove",
        "filepath": "TaskRemove.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--settings",
      "friendlyName": "Task settings",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "settings",
        "gear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--settings.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--settings.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskSettings32",
          "filepath": "task--settings/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--settings",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskSettings24",
          "filepath": "task--settings/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--settings",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskSettings20",
          "filepath": "task--settings/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--settings",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskSettings16",
          "filepath": "task--settings/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--settings",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskSettings",
        "global": "TaskSettings",
        "filepath": "TaskSettings.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--star",
      "friendlyName": "Task star",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "star"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--star.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"23 17 25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--star.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskStar32",
          "filepath": "task--star/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--star",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskStar24",
          "filepath": "task--star/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--star",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskStar20",
          "filepath": "task--star/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--star",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskStar16",
          "filepath": "task--star/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--star",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskStar",
        "global": "TaskStar",
        "filepath": "TaskStar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--tools",
      "friendlyName": "Task tools",
      "aliases": [
        "file",
        "task",
        "clipboard",
        "settings",
        "wrench",
        "tools"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--tools.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z\"/>\n  <path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z\"/><path d=\"M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z\"/></svg>",
            "info": {},
            "path": "32/task--tools.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskTools32",
          "filepath": "task--tools/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--tools",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskTools24",
          "filepath": "task--tools/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--tools",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskTools20",
          "filepath": "task--tools/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--tools",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskTools16",
          "filepath": "task--tools/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                }
              }
            ],
            "name": "task--tools",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskTools",
        "global": "TaskTools",
        "filepath": "TaskTools.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "task--view",
      "friendlyName": "Task view",
      "aliases": [
        "insights",
        "review",
        "study",
        "analyze",
        "analytics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/task--view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>task--view</title><circle cx=\"22\" cy=\"24\" r=\"2\"/><path id=\"_inner_path_\" data-name=\"&lt;inner path&gt;\" class=\"cls-1\" d=\"M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z\"/><path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/><path d=\"M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"22\" cy=\"24\" r=\"2\"/><path fill=\"none\" d=\"M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z\"/><path d=\"M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z\"/><path d=\"M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z\"/></svg>",
            "info": {},
            "path": "32/task--view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TaskView32",
          "filepath": "task--view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "task--view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TaskView24",
          "filepath": "task--view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "task--view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TaskView20",
          "filepath": "task--view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "task--view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TaskView16",
          "filepath": "task--view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "22",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
                }
              }
            ],
            "name": "task--view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TaskView",
        "global": "TaskView",
        "filepath": "TaskView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "22",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "taste",
      "friendlyName": "Taste",
      "aliases": [
        "tongue",
        "mouth",
        "eat",
        "senses"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/taste.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>taste</title><path d=\"M4,4V6H8v8a8,8,0,0,0,16,0V6h4V4ZM22,14a6,6,0,0,1-12,0V6h5v8h2V6h5Z\"/><rect x=\"11\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"7\" y=\"24\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"24\" width=\"2\" height=\"2\"/><rect x=\"19\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"23\" y=\"24\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z\"/></svg>",
            "info": {},
            "path": "32/taste.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Taste32",
          "filepath": "taste/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
                }
              }
            ],
            "name": "taste",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Taste24",
          "filepath": "taste/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
                }
              }
            ],
            "name": "taste",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Taste20",
          "filepath": "taste/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
                }
              }
            ],
            "name": "taste",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Taste16",
          "filepath": "taste/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
                }
              }
            ],
            "name": "taste",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Taste",
        "global": "Taste",
        "filepath": "Taste.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "taxi",
      "friendlyName": "Taxi",
      "aliases": [
        "car",
        "cab",
        "transportation",
        "transit",
        "vehicle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/taxi.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>taxi</title><path d=\"M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z\"/></svg>",
            "info": {},
            "path": "32/taxi.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Taxi32",
          "filepath": "taxi/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
                }
              }
            ],
            "name": "taxi",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Taxi24",
          "filepath": "taxi/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
                }
              }
            ],
            "name": "taxi",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Taxi20",
          "filepath": "taxi/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
                }
              }
            ],
            "name": "taxi",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Taxi16",
          "filepath": "taxi/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
                }
              }
            ],
            "name": "taxi",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Taxi",
        "global": "Taxi",
        "filepath": "Taxi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tcp-ip-service",
      "friendlyName": "tcp-ip-service",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tcp-ip-service.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"16\" y=\"28\" width=\"14\" height=\"2\"/>\n  <path d=\"M27,26h-8c-1.1028,0-2-.8972-2-2v-5c0-1.1028,.8972-2,2-2h8c1.1028,0,2,.8972,2,2v5c0,1.1028-.8972,2-2,2Zm-8-7v5h8v-5h-8Z\"/>\n  <path d=\"M15,23h-5c-1.1028,0-2-.8972-2-2v-4h2v4h5v2Z\"/>\n  <rect x=\"2\" y=\"13\" width=\"14\" height=\"2\"/>\n  <path d=\"M13,11H5c-1.1028,0-2-.8972-2-2V4c0-1.1028,.8972-2,2-2H13c1.1028,0,2,.8972,2,2v5c0,1.1028-.8972,2-2,2ZM5,4v5H13V4H5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 28H30V30H16zM27 26h-8c-1.1028 0-2-.8972-2-2v-5c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zm-8-7v5h8v-5h-8zM15 23h-5c-1.1028 0-2-.8972-2-2v-4h2v4h5v2zM2 13H16V15H2zM13 11H5c-1.1028 0-2-.8972-2-2V4c0-1.1028.8972-2 2-2H13c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zM5 4v5H13V4H5z\"/></svg>",
            "info": {},
            "path": "32/tcp-ip-service.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TcpIpService32",
          "filepath": "tcp-ip-service/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM27 26h-8c-1.1028 0-2-.8972-2-2v-5c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zm-8-7v5h8v-5h-8zM15 23h-5c-1.1028 0-2-.8972-2-2v-4h2v4h5v2zM2 13H16V15H2zM13 11H5c-1.1028 0-2-.8972-2-2V4c0-1.1028.8972-2 2-2H13c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zM5 4v5H13V4H5z"
                }
              }
            ],
            "name": "tcp-ip-service",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TcpIpService24",
          "filepath": "tcp-ip-service/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM27 26h-8c-1.1028 0-2-.8972-2-2v-5c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zm-8-7v5h8v-5h-8zM15 23h-5c-1.1028 0-2-.8972-2-2v-4h2v4h5v2zM2 13H16V15H2zM13 11H5c-1.1028 0-2-.8972-2-2V4c0-1.1028.8972-2 2-2H13c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zM5 4v5H13V4H5z"
                }
              }
            ],
            "name": "tcp-ip-service",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TcpIpService20",
          "filepath": "tcp-ip-service/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM27 26h-8c-1.1028 0-2-.8972-2-2v-5c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zm-8-7v5h8v-5h-8zM15 23h-5c-1.1028 0-2-.8972-2-2v-4h2v4h5v2zM2 13H16V15H2zM13 11H5c-1.1028 0-2-.8972-2-2V4c0-1.1028.8972-2 2-2H13c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zM5 4v5H13V4H5z"
                }
              }
            ],
            "name": "tcp-ip-service",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TcpIpService16",
          "filepath": "tcp-ip-service/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM27 26h-8c-1.1028 0-2-.8972-2-2v-5c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zm-8-7v5h8v-5h-8zM15 23h-5c-1.1028 0-2-.8972-2-2v-4h2v4h5v2zM2 13H16V15H2zM13 11H5c-1.1028 0-2-.8972-2-2V4c0-1.1028.8972-2 2-2H13c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zM5 4v5H13V4H5z"
                }
              }
            ],
            "name": "tcp-ip-service",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "TcpIpService",
        "global": "TcpIpService",
        "filepath": "TcpIpService.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 28H30V30H16zM27 26h-8c-1.1028 0-2-.8972-2-2v-5c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zm-8-7v5h8v-5h-8zM15 23h-5c-1.1028 0-2-.8972-2-2v-4h2v4h5v2zM2 13H16V15H2zM13 11H5c-1.1028 0-2-.8972-2-2V4c0-1.1028.8972-2 2-2H13c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zM5 4v5H13V4H5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature",
      "friendlyName": "Temperature",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>temperature</title><path d=\"M13,17.26V6A4,4,0,0,0,5,6V17.26a7,7,0,1,0,8,0ZM9,4a2,2,0,0,1,2,2v7H7V6A2,2,0,0,1,9,4ZM9,28a5,5,0,0,1-2.5-9.33l.5-.28V15h4v3.39l.5.28A5,5,0,0,1,9,28Z\" transform=\"translate(0 0)\"/><rect x=\"20\" y=\"4\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"10\" width=\"7\" height=\"2\"/><rect x=\"20\" y=\"16\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"22\" width=\"7\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z\"/></svg>",
            "info": {},
            "path": "32/temperature.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Temperature32",
          "filepath": "temperature/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
                }
              }
            ],
            "name": "temperature",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Temperature24",
          "filepath": "temperature/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
                }
              }
            ],
            "name": "temperature",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Temperature20",
          "filepath": "temperature/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
                }
              }
            ],
            "name": "temperature",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Temperature16",
          "filepath": "temperature/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
                }
              }
            ],
            "name": "temperature",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Temperature",
        "global": "Temperature",
        "filepath": "Temperature.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--celsius",
      "friendlyName": "Temperature Celsius",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold",
        "Celsius",
        "centigrade"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--celsius.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"18\" cy=\"4\" r=\"2\"/>\n  <path d=\"M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z\"/><circle cx=\"18\" cy=\"4\" r=\"2\"/><path d=\"M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z\"/><path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\"/></svg>",
            "info": {},
            "path": "32/temperature--celsius.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureCelsius32",
          "filepath": "temperature--celsius/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--celsius",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureCelsius24",
          "filepath": "temperature--celsius/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--celsius",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureCelsius20",
          "filepath": "temperature--celsius/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--celsius",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureCelsius16",
          "filepath": "temperature--celsius/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--celsius",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureCelsius",
        "global": "TemperatureCelsius",
        "filepath": "TemperatureCelsius.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18",
                    "cy": "4",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--celsius--alt",
      "friendlyName": "Temperature Celsius alt",
      "aliases": [
        "weather",
        "C",
        "degree",
        "heat",
        "hot",
        "cold",
        "Celsius",
        "centigrade"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--celsius--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,27H17a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h9v2H17V25h9Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M8,13a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,8,13ZM8,7a2,2,0,1,0,2,2h0A2.0059,2.0059,0,0,0,8,7Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 27H17a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h9v2H17V25h9zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z\"/></svg>",
            "info": {},
            "path": "32/temperature--celsius--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureCelsiusAlt32",
          "filepath": "temperature--celsius--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 27H17a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h9v2H17V25h9zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--celsius--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureCelsiusAlt24",
          "filepath": "temperature--celsius--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 27H17a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h9v2H17V25h9zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--celsius--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureCelsiusAlt20",
          "filepath": "temperature--celsius--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 27H17a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h9v2H17V25h9zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--celsius--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureCelsiusAlt16",
          "filepath": "temperature--celsius--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 27H17a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h9v2H17V25h9zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--celsius--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureCelsiusAlt",
        "global": "TemperatureCelsiusAlt",
        "filepath": "TemperatureCelsiusAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 27H17a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h9v2H17V25h9zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--fahrenheit",
      "friendlyName": "Temperature Fahrenheit",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold",
        "Fahrenheit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--fahrenheit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 6 30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6\"/>\n  <circle cx=\"18\" cy=\"4\" r=\"2\"/>\n  <path d=\"M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z\"/><circle cx=\"18\" cy=\"4\" r=\"2\"/><path d=\"M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z\"/><path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\"/></svg>",
            "info": {},
            "path": "32/temperature--fahrenheit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureFahrenheit32",
          "filepath": "temperature--fahrenheit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--fahrenheit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureFahrenheit24",
          "filepath": "temperature--fahrenheit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--fahrenheit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureFahrenheit20",
          "filepath": "temperature--fahrenheit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--fahrenheit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureFahrenheit16",
          "filepath": "temperature--fahrenheit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "4",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--fahrenheit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureFahrenheit",
        "global": "TemperatureFahrenheit",
        "filepath": "TemperatureFahrenheit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18",
                    "cy": "4",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--fahrenheit--alt",
      "friendlyName": "Temperature Fahrenheit alt",
      "aliases": [
        "weather",
        "F",
        "degree",
        "heat",
        "hot",
        "cold",
        "Fahrenheit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--fahrenheit--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26 11 26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11\"/>\n  <path d=\"M8,13a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,8,13ZM8,7a2,2,0,1,0,2,2h0A2.0059,2.0059,0,0,0,8,7Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z\"/></svg>",
            "info": {},
            "path": "32/temperature--fahrenheit--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureFahrenheitAlt32",
          "filepath": "temperature--fahrenheit--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--fahrenheit--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureFahrenheitAlt24",
          "filepath": "temperature--fahrenheit--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--fahrenheit--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureFahrenheitAlt20",
          "filepath": "temperature--fahrenheit--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--fahrenheit--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureFahrenheitAlt16",
          "filepath": "temperature--fahrenheit--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                }
              }
            ],
            "name": "temperature--fahrenheit--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureFahrenheitAlt",
        "global": "TemperatureFahrenheitAlt",
        "filepath": "TemperatureFahrenheitAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--feels-like",
      "friendlyName": "Temperature feels-like",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold",
        "feels like"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--feels-like.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H22a2.0059,2.0059,0,0,1-2-2V21a2.0059,2.0059,0,0,1-2-2V13a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,26,30ZM21,12a.9448.9448,0,0,0-1,1v6h2v9h4V19h2V13a.9448.9448,0,0,0-1-1Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24,9a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10,20.1839V12H8v8.1839a3,3,0,1,0,2,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z\"/><path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\"/></svg>",
            "info": {},
            "path": "32/temperature--feels-like.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureFeelsLike32",
          "filepath": "temperature--feels-like/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--feels-like",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureFeelsLike24",
          "filepath": "temperature--feels-like/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--feels-like",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureFeelsLike20",
          "filepath": "temperature--feels-like/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--feels-like",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureFeelsLike16",
          "filepath": "temperature--feels-like/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--feels-like",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureFeelsLike",
        "global": "TemperatureFeelsLike",
        "filepath": "TemperatureFeelsLike.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--frigid",
      "friendlyName": "Temperature frigid",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--frigid.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"27.167 16.89 21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89\"/>\n  <path d=\"M12,23a3,3,0,0,1-6,0Z\"/>\n  <path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z\"/><path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\"/></svg>",
            "info": {},
            "path": "32/temperature--frigid.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureFrigid32",
          "filepath": "temperature--frigid/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--frigid",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureFrigid24",
          "filepath": "temperature--frigid/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--frigid",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureFrigid20",
          "filepath": "temperature--frigid/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--frigid",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureFrigid16",
          "filepath": "temperature--frigid/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--frigid",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureFrigid",
        "global": "TemperatureFrigid",
        "filepath": "TemperatureFrigid.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--hot",
      "friendlyName": "Temperature hot",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--hot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"26\" y=\"13\" width=\"4\" height=\"2\"/>\n  <rect x=\"23.1214\" y=\"5.879\" width=\"3.9999\" height=\"1.9998\" transform=\"translate(2.4937 19.7783) rotate(-45)\"/>\n  <rect x=\"24.1212\" y=\"19.1214\" width=\"1.9998\" height=\"3.9999\" transform=\"translate(-7.5773 23.9496) rotate(-45)\"/>\n  <rect x=\"17\" y=\"2\" width=\"2\" height=\"4\"/>\n  <path d=\"M18,8a6.0365,6.0365,0,0,0-1,.09v2.0518A3.9567,3.9567,0,0,1,18,10a4,4,0,0,1,0,8v2A6,6,0,0,0,18,8Z\"/>\n  <path d=\"M10,20.1839V7H8V20.1839a3,3,0,1,0,2,0Z\"/>\n  <path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 13H30V15H26z\"/><path d=\"M23.121 5.879H27.121V7.879H23.121z\" transform=\"rotate(-45 25.121 6.879)\"/><path d=\"M24.121 19.121H26.121V23.121H24.121z\" transform=\"rotate(-45 25.121 21.121)\"/><path d=\"M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z\"/><path d=\"M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z\"/></svg>",
            "info": {},
            "path": "32/temperature--hot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureHot32",
          "filepath": "temperature--hot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13H30V15H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.121 5.879H27.121V7.879H23.121z",
                  "transform": "rotate(-45 25.121 6.879)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.121 19.121H26.121V23.121H24.121z",
                  "transform": "rotate(-45 25.121 21.121)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--hot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureHot24",
          "filepath": "temperature--hot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13H30V15H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.121 5.879H27.121V7.879H23.121z",
                  "transform": "rotate(-45 25.121 6.879)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.121 19.121H26.121V23.121H24.121z",
                  "transform": "rotate(-45 25.121 21.121)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--hot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureHot20",
          "filepath": "temperature--hot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13H30V15H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.121 5.879H27.121V7.879H23.121z",
                  "transform": "rotate(-45 25.121 6.879)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.121 19.121H26.121V23.121H24.121z",
                  "transform": "rotate(-45 25.121 21.121)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--hot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureHot16",
          "filepath": "temperature--hot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 13H30V15H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.121 5.879H27.121V7.879H23.121z",
                  "transform": "rotate(-45 25.121 6.879)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.121 19.121H26.121V23.121H24.121z",
                  "transform": "rotate(-45 25.121 21.121)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                }
              }
            ],
            "name": "temperature--hot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureHot",
        "global": "TemperatureHot",
        "filepath": "TemperatureHot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 13H30V15H26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.121 5.879H27.121V7.879H23.121z",
                    "transform": "rotate(-45 25.121 6.879)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.121 19.121H26.121V23.121H24.121z",
                    "transform": "rotate(-45 25.121 21.121)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--inversion",
      "friendlyName": "Temperature inversion",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold",
        "inversion",
        "temperature",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--inversion.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,8H24v6h2V11.541A5.939,5.939,0,0,1,28,16a6.0039,6.0039,0,0,1-5.0945,5.9243A7.0273,7.0273,0,0,0,20,17.2617V6a4,4,0,0,0-8,0V17.2617a6.996,6.996,0,1,0,10.9292,6.68A7.9794,7.9794,0,0,0,27.2651,10H30ZM14,6a2,2,0,0,1,4,0v7H14Zm2,22a4.9965,4.9965,0,0,1-2.499-9.3252L14,18.3857V15h4v3.3857l.499.2891A4.9965,4.9965,0,0,1,16,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M2,10a8.04,8.04,0,0,0,2.7349,6H2v2H8V12H6v2.4592A5.94,5.94,0,0,1,4,10a6.0066,6.0066,0,0,1,6-6V2A8.0092,8.0092,0,0,0,2,10Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z\"/></svg>",
            "info": {},
            "path": "32/temperature--inversion.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureInversion32",
          "filepath": "temperature--inversion/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
                }
              }
            ],
            "name": "temperature--inversion",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureInversion24",
          "filepath": "temperature--inversion/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
                }
              }
            ],
            "name": "temperature--inversion",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureInversion20",
          "filepath": "temperature--inversion/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
                }
              }
            ],
            "name": "temperature--inversion",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureInversion16",
          "filepath": "temperature--inversion/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
                }
              }
            ],
            "name": "temperature--inversion",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureInversion",
        "global": "TemperatureInversion",
        "filepath": "TemperatureInversion.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--max",
      "friendlyName": "Temperature max",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold",
        "max",
        "temperature",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--max.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"20\" y=\"10\" width=\"7\" height=\"2\"/>\n  <rect x=\"20\" y=\"16\" width=\"10\" height=\"2\"/>\n  <rect x=\"20\" y=\"22\" width=\"7\" height=\"2\"/>\n  <path d=\"M10,20.1839V7H8V20.1839a3,3,0,1,0,2,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z\"/><path d=\"M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z\"/></svg>",
            "info": {},
            "path": "32/temperature--max.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureMax32",
          "filepath": "temperature--max/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--max",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureMax24",
          "filepath": "temperature--max/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--max",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureMax20",
          "filepath": "temperature--max/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--max",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureMax16",
          "filepath": "temperature--max/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--max",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureMax",
        "global": "TemperatureMax",
        "filepath": "TemperatureMax.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--min",
      "friendlyName": "Temperature min",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold",
        "min",
        "temperature",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--min.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"20\" y=\"4\" width=\"7\" height=\"2\"/>\n  <rect x=\"20\" y=\"10\" width=\"10\" height=\"2\"/>\n  <rect x=\"20\" y=\"16\" width=\"7\" height=\"2\"/>\n  <path d=\"M12,23a3,3,0,0,1-6,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z\"/><path d=\"M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z\"/></svg>",
            "info": {},
            "path": "32/temperature--min.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureMin32",
          "filepath": "temperature--min/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--min",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureMin24",
          "filepath": "temperature--min/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--min",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureMin20",
          "filepath": "temperature--min/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--min",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureMin16",
          "filepath": "temperature--min/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--min",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureMin",
        "global": "TemperatureMin",
        "filepath": "TemperatureMin.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "temperature--water",
      "friendlyName": "Temperature water",
      "aliases": [
        "weather",
        "thermometer",
        "degree",
        "heat",
        "hot",
        "cold",
        "water",
        "temperature",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/temperature--water.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z\"/></svg>",
            "info": {},
            "path": "32/temperature--water.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TemperatureWater32",
          "filepath": "temperature--water/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--water",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TemperatureWater24",
          "filepath": "temperature--water/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--water",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TemperatureWater20",
          "filepath": "temperature--water/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--water",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TemperatureWater16",
          "filepath": "temperature--water/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
                }
              }
            ],
            "name": "temperature--water",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TemperatureWater",
        "global": "TemperatureWater",
        "filepath": "TemperatureWater.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "template",
      "friendlyName": "Template",
      "aliases": [
        "dashboard",
        "arrange",
        "layout",
        "wireframe",
        "pattern"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/template.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>template</title><path d=\"M26,6v4H6V6H26m0-2H6A2,2,0,0,0,4,6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><path d=\"M10,16V26H6V16h4m0-2H6a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2Z\"/><path d=\"M26,16V26H16V16H26m0-2H16a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2Z\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/template.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Template32",
          "filepath": "template/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "template",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Template24",
          "filepath": "template/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "template",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Template20",
          "filepath": "template/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "template",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Template16",
          "filepath": "template/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "template",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Template",
        "global": "Template",
        "filepath": "Template.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tennis",
      "friendlyName": "Tennis",
      "aliases": [
        "tennis",
        "sports"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tennis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tennis</title><rect x=\"20\" y=\"2\" width=\"4\" height=\"4\" rx=\"2\"/><path d=\"M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z\"/><path d=\"M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><rect width=\"4\" height=\"4\" x=\"20\" y=\"2\" rx=\"2\"/><path d=\"M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z\"/><path d=\"M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z\"/></svg>",
            "info": {},
            "path": "32/tennis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tennis32",
          "filepath": "tennis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "4",
                  "height": "4",
                  "x": "20",
                  "y": "2",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
                }
              }
            ],
            "name": "tennis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tennis24",
          "filepath": "tennis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "4",
                  "height": "4",
                  "x": "20",
                  "y": "2",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
                }
              }
            ],
            "name": "tennis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tennis20",
          "filepath": "tennis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "4",
                  "height": "4",
                  "x": "20",
                  "y": "2",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
                }
              }
            ],
            "name": "tennis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tennis16",
          "filepath": "tennis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "rect",
                "attrs": {
                  "width": "4",
                  "height": "4",
                  "x": "20",
                  "y": "2",
                  "rx": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
                }
              }
            ],
            "name": "tennis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Tennis",
        "global": "Tennis",
        "filepath": "Tennis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "rect",
                  "attributes": {
                    "width": "4",
                    "height": "4",
                    "x": "20",
                    "y": "2",
                    "rx": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tennis-ball",
      "friendlyName": "Tennis ball",
      "aliases": [
        "tennis-ball",
        "sports"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tennis-ball.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tennis-ball</title><path d=\"M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z\"/></svg>",
            "info": {},
            "path": "32/tennis-ball.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TennisBall32",
          "filepath": "tennis-ball/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
                }
              }
            ],
            "name": "tennis-ball",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TennisBall24",
          "filepath": "tennis-ball/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
                }
              }
            ],
            "name": "tennis-ball",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TennisBall20",
          "filepath": "tennis-ball/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
                }
              }
            ],
            "name": "tennis-ball",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TennisBall16",
          "filepath": "tennis-ball/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
                }
              }
            ],
            "name": "tennis-ball",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "TennisBall",
        "global": "TennisBall",
        "filepath": "TennisBall.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "term",
      "friendlyName": "Term",
      "aliases": [
        "term"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/term.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>term</title><path d=\"M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z\"/><circle cx=\"23\" cy=\"16\" r=\"2\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><circle cx=\"9\" cy=\"16\" r=\"2\"/><path d=\"M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z\"/><circle cx=\"23\" cy=\"16\" r=\"2\"/><circle cx=\"16\" cy=\"16\" r=\"2\"/><circle cx=\"9\" cy=\"16\" r=\"2\"/><path d=\"M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z\"/></svg>",
            "info": {},
            "path": "32/term.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Term32",
          "filepath": "term/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
                }
              }
            ],
            "name": "term",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Term24",
          "filepath": "term/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
                }
              }
            ],
            "name": "term",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Term20",
          "filepath": "term/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
                }
              }
            ],
            "name": "term",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Term16",
          "filepath": "term/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "16",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
                }
              }
            ],
            "name": "term",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Term",
        "global": "Term",
        "filepath": "Term.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "16",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "terminal",
      "friendlyName": "Terminal",
      "aliases": [
        "code",
        "code editor",
        "command line"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/terminal.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>terminal</title><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z\" transform=\"translate(0 0.01)\"/><polygon points=\"10.76 16.18 13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z\" transform=\"translate(0 .01)\"/><path d=\"M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z\"/></svg>",
            "info": {},
            "path": "32/terminal.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Terminal32",
          "filepath": "terminal/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
                  "transform": "translate(0 .01)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
                }
              }
            ],
            "name": "terminal",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Terminal24",
          "filepath": "terminal/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
                  "transform": "translate(0 .01)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
                }
              }
            ],
            "name": "terminal",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Terminal20",
          "filepath": "terminal/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
                  "transform": "translate(0 .01)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
                }
              }
            ],
            "name": "terminal",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Terminal16",
          "filepath": "terminal/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
                  "transform": "translate(0 .01)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
                }
              }
            ],
            "name": "terminal",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Terminal",
        "global": "Terminal",
        "filepath": "Terminal.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
                    "transform": "translate(0 .01)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "terminal--3270",
      "friendlyName": "Terminal 3270",
      "aliases": [
        "terminal",
        "3270"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/terminal--3270.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"10\" y=\"21\" width=\"6\" height=\"2\"/>\n  <path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 21H16V23H10z\"/><path d=\"M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z\"/></svg>",
            "info": {},
            "path": "32/terminal--3270.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Terminal_327032",
          "filepath": "terminal--3270/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 21H16V23H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
                }
              }
            ],
            "name": "terminal--3270",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Terminal_327024",
          "filepath": "terminal--3270/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 21H16V23H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
                }
              }
            ],
            "name": "terminal--3270",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Terminal_327020",
          "filepath": "terminal--3270/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 21H16V23H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
                }
              }
            ],
            "name": "terminal--3270",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Terminal_327016",
          "filepath": "terminal--3270/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 21H16V23H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
                }
              }
            ],
            "name": "terminal--3270",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Terminal_3270",
        "global": "Terminal_3270",
        "filepath": "Terminal_3270.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 21H16V23H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "test-tool",
      "friendlyName": "test-tool",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/test-tool.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"23,9.2 20.4,6.6 19,8 23,12 30,5 28.6,3.6 \"/>\n<polygon points=\"12,5.4 10.6,4 8,6.6 5.4,4 4,5.4 6.6,8 4,10.6 5.4,12 8,9.4 10.6,12 12,10.6 9.4,8 \"/>\n<polygon points=\"12,21.4 10.6,20 8,22.6 5.4,20 4,21.4 6.6,24 4,26.6 5.4,28 8,25.4 10.6,28 12,26.6 9.4,24 \"/>\n<polygon points=\"17,15 17,2 15,2 15,15 2,15 2,17 15,17 15,30 17,30 17,17 30,17 30,15 \"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6zM12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8zM12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z\"/><path d=\"M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z\"/></svg>",
            "info": {},
            "path": "32/test-tool.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TestTool32",
          "filepath": "test-tool/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6zM12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8zM12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              }
            ],
            "name": "test-tool",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TestTool24",
          "filepath": "test-tool/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6zM12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8zM12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              }
            ],
            "name": "test-tool",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TestTool20",
          "filepath": "test-tool/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6zM12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8zM12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              }
            ],
            "name": "test-tool",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TestTool16",
          "filepath": "test-tool/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6zM12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8zM12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              }
            ],
            "name": "test-tool",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "TestTool",
        "global": "TestTool",
        "filepath": "TestTool.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6zM12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8zM12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--align--center",
      "friendlyName": "Text align center",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--align--center.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--center</title><rect x=\"6\" y=\"6\" width=\"20\" height=\"2\"/><rect x=\"10\" y=\"12\" width=\"12\" height=\"2\"/><rect x=\"6\" y=\"18\" width=\"20\" height=\"2\"/><rect x=\"10\" y=\"24\" width=\"12\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z\"/></svg>",
            "info": {},
            "path": "32/text--align--center.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextAlignCenter32",
          "filepath": "text--align--center/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
                }
              }
            ],
            "name": "text--align--center",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextAlignCenter24",
          "filepath": "text--align--center/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
                }
              }
            ],
            "name": "text--align--center",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextAlignCenter20",
          "filepath": "text--align--center/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
                }
              }
            ],
            "name": "text--align--center",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextAlignCenter16",
          "filepath": "text--align--center/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
                }
              }
            ],
            "name": "text--align--center",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextAlignCenter",
        "global": "TextAlignCenter",
        "filepath": "TextAlignCenter.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--align--justify",
      "friendlyName": "Text align justify",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--align--justify.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--align--justify</title><rect x=\"6\" y=\"6\" width=\"20\" height=\"2\"/><rect x=\"6\" y=\"12\" width=\"20\" height=\"2\"/><rect x=\"6\" y=\"18\" width=\"20\" height=\"2\"/><rect x=\"6\" y=\"24\" width=\"20\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z\"/></svg>",
            "info": {},
            "path": "32/text--align--justify.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextAlignJustify32",
          "filepath": "text--align--justify/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
                }
              }
            ],
            "name": "text--align--justify",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextAlignJustify24",
          "filepath": "text--align--justify/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
                }
              }
            ],
            "name": "text--align--justify",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextAlignJustify20",
          "filepath": "text--align--justify/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
                }
              }
            ],
            "name": "text--align--justify",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextAlignJustify16",
          "filepath": "text--align--justify/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
                }
              }
            ],
            "name": "text--align--justify",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextAlignJustify",
        "global": "TextAlignJustify",
        "filepath": "TextAlignJustify.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--align--left",
      "friendlyName": "Text align left",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--align--left.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--left</title><rect x=\"12\" y=\"6\" width=\"14\" height=\"2\"/><rect x=\"12\" y=\"12\" width=\"10\" height=\"2\"/><rect x=\"12\" y=\"18\" width=\"14\" height=\"2\"/><rect x=\"12\" y=\"24\" width=\"10\" height=\"2\"/><rect x=\"6\" y=\"4\" width=\"2\" height=\"24\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z\"/></svg>",
            "info": {},
            "path": "32/text--align--left.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextAlignLeft32",
          "filepath": "text--align--left/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
                }
              }
            ],
            "name": "text--align--left",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextAlignLeft24",
          "filepath": "text--align--left/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
                }
              }
            ],
            "name": "text--align--left",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextAlignLeft20",
          "filepath": "text--align--left/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
                }
              }
            ],
            "name": "text--align--left",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextAlignLeft16",
          "filepath": "text--align--left/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
                }
              }
            ],
            "name": "text--align--left",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextAlignLeft",
        "global": "TextAlignLeft",
        "filepath": "TextAlignLeft.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--align--mixed",
      "friendlyName": "Text align mixed",
      "aliases": [
        "text",
        "align",
        "mixed",
        "typography"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--align--mixed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M14,4H9V6h5V8H10a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V6A2.0023,2.0023,0,0,0,14,4Zm0,8H10V10h4Z\"/>\n  <polygon points=\"22 26 22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26\"/>\n  <rect x=\"2\" y=\"2\" width=\"2\" height=\"14\"/>\n  <rect x=\"28\" y=\"16\" width=\"2\" height=\"14\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 4H9V6h5V8H10a2 2 0 00-2 2v2a2 2 0 002 2h6V6A2.0023 2.0023 0 0014 4zm0 8H10V10h4zM22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26zM2 2H4V16H2zM28 16H30V30H28z\"/></svg>",
            "info": {},
            "path": "32/text--align--mixed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextAlignMixed32",
          "filepath": "text--align--mixed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H9V6h5V8H10a2 2 0 00-2 2v2a2 2 0 002 2h6V6A2.0023 2.0023 0 0014 4zm0 8H10V10h4zM22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26zM2 2H4V16H2zM28 16H30V30H28z"
                }
              }
            ],
            "name": "text--align--mixed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextAlignMixed24",
          "filepath": "text--align--mixed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H9V6h5V8H10a2 2 0 00-2 2v2a2 2 0 002 2h6V6A2.0023 2.0023 0 0014 4zm0 8H10V10h4zM22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26zM2 2H4V16H2zM28 16H30V30H28z"
                }
              }
            ],
            "name": "text--align--mixed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextAlignMixed20",
          "filepath": "text--align--mixed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H9V6h5V8H10a2 2 0 00-2 2v2a2 2 0 002 2h6V6A2.0023 2.0023 0 0014 4zm0 8H10V10h4zM22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26zM2 2H4V16H2zM28 16H30V30H28z"
                }
              }
            ],
            "name": "text--align--mixed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextAlignMixed16",
          "filepath": "text--align--mixed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 4H9V6h5V8H10a2 2 0 00-2 2v2a2 2 0 002 2h6V6A2.0023 2.0023 0 0014 4zm0 8H10V10h4zM22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26zM2 2H4V16H2zM28 16H30V30H28z"
                }
              }
            ],
            "name": "text--align--mixed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextAlignMixed",
        "global": "TextAlignMixed",
        "filepath": "TextAlignMixed.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 4H9V6h5V8H10a2 2 0 00-2 2v2a2 2 0 002 2h6V6A2.0023 2.0023 0 0014 4zm0 8H10V10h4zM22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26zM2 2H4V16H2zM28 16H30V30H28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--align--right",
      "friendlyName": "Text align right",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--align--right.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>align--right</title><rect x=\"6\" y=\"6\" width=\"14\" height=\"2\"/><rect x=\"10\" y=\"12\" width=\"10\" height=\"2\"/><rect x=\"6\" y=\"18\" width=\"14\" height=\"2\"/><rect x=\"10\" y=\"24\" width=\"10\" height=\"2\"/><rect x=\"24\" y=\"4\" width=\"2\" height=\"24\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z\"/></svg>",
            "info": {},
            "path": "32/text--align--right.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextAlignRight32",
          "filepath": "text--align--right/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
                }
              }
            ],
            "name": "text--align--right",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextAlignRight24",
          "filepath": "text--align--right/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
                }
              }
            ],
            "name": "text--align--right",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextAlignRight20",
          "filepath": "text--align--right/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
                }
              }
            ],
            "name": "text--align--right",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextAlignRight16",
          "filepath": "text--align--right/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
                }
              }
            ],
            "name": "text--align--right",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextAlignRight",
        "global": "TextAlignRight",
        "filepath": "TextAlignRight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--all-caps",
      "friendlyName": "Text all caps",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--all-caps.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--all-caps</title><polygon points=\"1 8 1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8\"/><polygon points=\"17 8 17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z\"/></svg>",
            "info": {},
            "path": "32/text--all-caps.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextAllCaps32",
          "filepath": "text--all-caps/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
                }
              }
            ],
            "name": "text--all-caps",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextAllCaps24",
          "filepath": "text--all-caps/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
                }
              }
            ],
            "name": "text--all-caps",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextAllCaps20",
          "filepath": "text--all-caps/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
                }
              }
            ],
            "name": "text--all-caps",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextAllCaps16",
          "filepath": "text--all-caps/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
                }
              }
            ],
            "name": "text--all-caps",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextAllCaps",
        "global": "TextAllCaps",
        "filepath": "TextAllCaps.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--bold",
      "friendlyName": "Text bold",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--bold.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-bold</title><path d=\"M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z\"/></svg>",
            "info": {},
            "path": "32/text--bold.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextBold32",
          "filepath": "text--bold/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
                }
              }
            ],
            "name": "text--bold",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextBold24",
          "filepath": "text--bold/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
                }
              }
            ],
            "name": "text--bold",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextBold20",
          "filepath": "text--bold/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
                }
              }
            ],
            "name": "text--bold",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextBold16",
          "filepath": "text--bold/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
                }
              }
            ],
            "name": "text--bold",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextBold",
        "global": "TextBold",
        "filepath": "TextBold.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--clear-format",
      "friendlyName": "Text clear format",
      "aliases": [
        "clear",
        "format",
        "text"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--clear-format.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z\"/></svg>",
            "info": {},
            "path": "32/text--clear-format.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextClearFormat32",
          "filepath": "text--clear-format/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
                }
              }
            ],
            "name": "text--clear-format",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextClearFormat24",
          "filepath": "text--clear-format/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
                }
              }
            ],
            "name": "text--clear-format",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextClearFormat20",
          "filepath": "text--clear-format/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
                }
              }
            ],
            "name": "text--clear-format",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextClearFormat16",
          "filepath": "text--clear-format/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
                }
              }
            ],
            "name": "text--clear-format",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextClearFormat",
        "global": "TextClearFormat",
        "filepath": "TextClearFormat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--color",
      "friendlyName": "Text color",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--color.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-color</title><path d=\"M22,21h2L17,4H15L8,21h2l1.61-4h8.74Zm-9.57-6,3.44-8.37h.26L19.54,15Z\"/><rect x=\"6\" y=\"24\" width=\"20\" height=\"4\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z\"/></svg>",
            "info": {},
            "path": "32/text--color.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextColor32",
          "filepath": "text--color/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
                }
              }
            ],
            "name": "text--color",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextColor24",
          "filepath": "text--color/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
                }
              }
            ],
            "name": "text--color",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextColor20",
          "filepath": "text--color/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
                }
              }
            ],
            "name": "text--color",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextColor16",
          "filepath": "text--color/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
                }
              }
            ],
            "name": "text--color",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextColor",
        "global": "TextColor",
        "filepath": "TextColor.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--creation",
      "friendlyName": "Text creation",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--creation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-creation</title><path d=\"M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/><polygon points=\"21 11 11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z\"/><path d=\"M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z\"/></svg>",
            "info": {},
            "path": "32/text--creation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextCreation32",
          "filepath": "text--creation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
                }
              }
            ],
            "name": "text--creation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextCreation24",
          "filepath": "text--creation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
                }
              }
            ],
            "name": "text--creation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextCreation20",
          "filepath": "text--creation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
                }
              }
            ],
            "name": "text--creation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextCreation16",
          "filepath": "text--creation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
                }
              }
            ],
            "name": "text--creation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextCreation",
        "global": "TextCreation",
        "filepath": "TextCreation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--fill",
      "friendlyName": "Text fill",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--fill.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-fill</title><rect x=\"4\" y=\"26\" width=\"24\" height=\"4\"/><path d=\"M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H28V30H4z\"/><path d=\"M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z\"/></svg>",
            "info": {},
            "path": "32/text--fill.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextFill32",
          "filepath": "text--fill/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
                }
              }
            ],
            "name": "text--fill",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextFill24",
          "filepath": "text--fill/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
                }
              }
            ],
            "name": "text--fill",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextFill20",
          "filepath": "text--fill/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
                }
              }
            ],
            "name": "text--fill",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextFill16",
          "filepath": "text--fill/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V30H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
                }
              }
            ],
            "name": "text--fill",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextFill",
        "global": "TextFill",
        "filepath": "TextFill.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H28V30H4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--font",
      "friendlyName": "Text font",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor",
        "font",
        "typeface"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--font.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,12H20v2h5a1.0008,1.0008,0,0,1,1,1v2H22a3.0033,3.0033,0,0,0-3,3v1a3.0033,3.0033,0,0,0,3,3h6V15A3.0033,3.0033,0,0,0,25,12ZM22,22a1.0008,1.0008,0,0,1-1-1V20a1.0008,1.0008,0,0,1,1-1h4v3Z\"/>\n  <path d=\"M16,24h2L12,7H10L4,24H6l1.6936-5h6.6135ZM8.3711,17l2.4966-7.3711.2668.0005L13.63,17Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 12H20v2h5a1.0008 1.0008 0 011 1v2H22a3.0033 3.0033 0 00-3 3v1a3.0033 3.0033 0 003 3h6V15A3.0033 3.0033 0 0025 12zM22 22a1.0008 1.0008 0 01-1-1V20a1.0008 1.0008 0 011-1h4v3zM16 24h2L12 7H10L4 24H6l1.6936-5h6.6135zM8.3711 17l2.4966-7.3711.2668.0005L13.63 17z\"/></svg>",
            "info": {},
            "path": "32/text--font.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextFont32",
          "filepath": "text--font/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 12H20v2h5a1.0008 1.0008 0 011 1v2H22a3.0033 3.0033 0 00-3 3v1a3.0033 3.0033 0 003 3h6V15A3.0033 3.0033 0 0025 12zM22 22a1.0008 1.0008 0 01-1-1V20a1.0008 1.0008 0 011-1h4v3zM16 24h2L12 7H10L4 24H6l1.6936-5h6.6135zM8.3711 17l2.4966-7.3711.2668.0005L13.63 17z"
                }
              }
            ],
            "name": "text--font",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextFont24",
          "filepath": "text--font/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 12H20v2h5a1.0008 1.0008 0 011 1v2H22a3.0033 3.0033 0 00-3 3v1a3.0033 3.0033 0 003 3h6V15A3.0033 3.0033 0 0025 12zM22 22a1.0008 1.0008 0 01-1-1V20a1.0008 1.0008 0 011-1h4v3zM16 24h2L12 7H10L4 24H6l1.6936-5h6.6135zM8.3711 17l2.4966-7.3711.2668.0005L13.63 17z"
                }
              }
            ],
            "name": "text--font",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextFont20",
          "filepath": "text--font/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 12H20v2h5a1.0008 1.0008 0 011 1v2H22a3.0033 3.0033 0 00-3 3v1a3.0033 3.0033 0 003 3h6V15A3.0033 3.0033 0 0025 12zM22 22a1.0008 1.0008 0 01-1-1V20a1.0008 1.0008 0 011-1h4v3zM16 24h2L12 7H10L4 24H6l1.6936-5h6.6135zM8.3711 17l2.4966-7.3711.2668.0005L13.63 17z"
                }
              }
            ],
            "name": "text--font",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextFont16",
          "filepath": "text--font/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 12H20v2h5a1.0008 1.0008 0 011 1v2H22a3.0033 3.0033 0 00-3 3v1a3.0033 3.0033 0 003 3h6V15A3.0033 3.0033 0 0025 12zM22 22a1.0008 1.0008 0 01-1-1V20a1.0008 1.0008 0 011-1h4v3zM16 24h2L12 7H10L4 24H6l1.6936-5h6.6135zM8.3711 17l2.4966-7.3711.2668.0005L13.63 17z"
                }
              }
            ],
            "name": "text--font",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextFont",
        "global": "TextFont",
        "filepath": "TextFont.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 12H20v2h5a1.0008 1.0008 0 011 1v2H22a3.0033 3.0033 0 00-3 3v1a3.0033 3.0033 0 003 3h6V15A3.0033 3.0033 0 0025 12zM22 22a1.0008 1.0008 0 01-1-1V20a1.0008 1.0008 0 011-1h4v3zM16 24h2L12 7H10L4 24H6l1.6936-5h6.6135zM8.3711 17l2.4966-7.3711.2668.0005L13.63 17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--footnote",
      "friendlyName": "Text footnote",
      "aliases": [
        "text",
        "footnote",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--footnote.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"2 7 2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7\"/>\n  <polygon points=\"30 11.076 29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7zM30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z\"/></svg>",
            "info": {},
            "path": "32/text--footnote.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextFootnote32",
          "filepath": "text--footnote/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7zM30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
                }
              }
            ],
            "name": "text--footnote",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextFootnote24",
          "filepath": "text--footnote/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7zM30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
                }
              }
            ],
            "name": "text--footnote",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextFootnote20",
          "filepath": "text--footnote/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7zM30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
                }
              }
            ],
            "name": "text--footnote",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextFootnote16",
          "filepath": "text--footnote/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7zM30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
                }
              }
            ],
            "name": "text--footnote",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextFootnote",
        "global": "TextFootnote",
        "filepath": "TextFootnote.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7zM30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--highlight",
      "friendlyName": "Text highlight",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--highlight.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-highlight</title><path d=\"M12,15H5a3,3,0,0,1-3-3V10A3,3,0,0,1,5,7h5V5A1,1,0,0,0,9,4H3V2H9a3,3,0,0,1,3,3ZM5,9a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h5V9Z\"/><path d=\"M20,23v2a1,1,0,0,0,1,1h5V22H21A1,1,0,0,0,20,23Z\"/><path d=\"M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z\"/><path d=\"M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z\"/></svg>",
            "info": {},
            "path": "32/text--highlight.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextHighlight32",
          "filepath": "text--highlight/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "text--highlight",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextHighlight24",
          "filepath": "text--highlight/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "text--highlight",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextHighlight20",
          "filepath": "text--highlight/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "text--highlight",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextHighlight16",
          "filepath": "text--highlight/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
                }
              }
            ],
            "name": "text--highlight",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextHighlight",
        "global": "TextHighlight",
        "filepath": "TextHighlight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--indent",
      "friendlyName": "Text indent",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--indent.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--indent</title><rect x=\"14\" y=\"6\" width=\"14\" height=\"2\"/><rect x=\"14\" y=\"12\" width=\"14\" height=\"2\"/><rect x=\"7\" y=\"18\" width=\"21\" height=\"2\"/><rect x=\"7\" y=\"24\" width=\"21\" height=\"2\"/><polygon points=\"4 13.59 7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z\"/></svg>",
            "info": {},
            "path": "32/text--indent.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextIndent32",
          "filepath": "text--indent/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
                }
              }
            ],
            "name": "text--indent",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextIndent24",
          "filepath": "text--indent/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
                }
              }
            ],
            "name": "text--indent",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextIndent20",
          "filepath": "text--indent/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
                }
              }
            ],
            "name": "text--indent",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextIndent16",
          "filepath": "text--indent/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
                }
              }
            ],
            "name": "text--indent",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextIndent",
        "global": "TextIndent",
        "filepath": "TextIndent.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--indent--less",
      "friendlyName": "Text indent less",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--indent--less.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>indent--less</title><rect x=\"2\" y=\"6\" width=\"10\" height=\"2\"/><rect x=\"5\" y=\"12\" width=\"7\" height=\"2\"/><rect x=\"2\" y=\"18\" width=\"10\" height=\"2\"/><rect x=\"5\" y=\"24\" width=\"7\" height=\"2\"/><rect x=\"16\" y=\"4\" width=\"2\" height=\"24\"/><polygon points=\"28.15 23.5 29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z\"/></svg>",
            "info": {},
            "path": "32/text--indent--less.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextIndentLess32",
          "filepath": "text--indent--less/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
                }
              }
            ],
            "name": "text--indent--less",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextIndentLess24",
          "filepath": "text--indent--less/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
                }
              }
            ],
            "name": "text--indent--less",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextIndentLess20",
          "filepath": "text--indent--less/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
                }
              }
            ],
            "name": "text--indent--less",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextIndentLess16",
          "filepath": "text--indent--less/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
                }
              }
            ],
            "name": "text--indent--less",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextIndentLess",
        "global": "TextIndentLess",
        "filepath": "TextIndentLess.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--indent--more",
      "friendlyName": "Text indent more",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--indent--more.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>indent--more</title><rect x=\"20\" y=\"6\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"12\" width=\"7\" height=\"2\"/><rect x=\"20\" y=\"18\" width=\"10\" height=\"2\"/><rect x=\"20\" y=\"24\" width=\"7\" height=\"2\"/><rect x=\"14\" y=\"4\" width=\"2\" height=\"24\"/><polygon points=\"3.85 22.5 2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z\"/></svg>",
            "info": {},
            "path": "32/text--indent--more.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextIndentMore32",
          "filepath": "text--indent--more/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
                }
              }
            ],
            "name": "text--indent--more",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextIndentMore24",
          "filepath": "text--indent--more/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
                }
              }
            ],
            "name": "text--indent--more",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextIndentMore20",
          "filepath": "text--indent--more/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
                }
              }
            ],
            "name": "text--indent--more",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextIndentMore16",
          "filepath": "text--indent--more/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
                }
              }
            ],
            "name": "text--indent--more",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextIndentMore",
        "global": "TextIndentMore",
        "filepath": "TextIndentMore.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--italic",
      "friendlyName": "Text italic",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--italic.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-italic</title><polygon points=\"25 9 25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z\"/></svg>",
            "info": {},
            "path": "32/text--italic.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextItalic32",
          "filepath": "text--italic/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
                }
              }
            ],
            "name": "text--italic",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextItalic24",
          "filepath": "text--italic/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
                }
              }
            ],
            "name": "text--italic",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextItalic20",
          "filepath": "text--italic/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
                }
              }
            ],
            "name": "text--italic",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextItalic16",
          "filepath": "text--italic/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
                }
              }
            ],
            "name": "text--italic",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextItalic",
        "global": "TextItalic",
        "filepath": "TextItalic.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--kerning",
      "friendlyName": "Text kerning",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--kerning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--kerning</title><polygon points=\"30 24 18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24\"/><polygon points=\"14 21 20 4 18 4 12 21 14 21\"/><polygon points=\"13 4 9 16 5 4 3 4 8 18 10 18 15 4 13 4\"/><path d=\"M28,18h2L25,4H23L18,18h2l1-3h6Zm-6.33-5L24,6l2.33,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z\"/></svg>",
            "info": {},
            "path": "32/text--kerning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextKerning32",
          "filepath": "text--kerning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
                }
              }
            ],
            "name": "text--kerning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextKerning24",
          "filepath": "text--kerning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
                }
              }
            ],
            "name": "text--kerning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextKerning20",
          "filepath": "text--kerning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
                }
              }
            ],
            "name": "text--kerning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextKerning16",
          "filepath": "text--kerning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
                }
              }
            ],
            "name": "text--kerning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextKerning",
        "global": "TextKerning",
        "filepath": "TextKerning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--leading",
      "friendlyName": "Text leading",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--leading.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--leading</title><rect x=\"14\" y=\"13\" width=\"16\" height=\"2\"/><rect x=\"15\" y=\"28\" width=\"15\" height=\"2\"/><path d=\"M25.85,27H28L23.64,17H21.36L17,27h2.15l.8-2h5.1Zm-5.1-4,1.75-4.37L24.25,23Z\"/><path d=\"M25.85,12H28L23.64,2H21.36L17,12h2.15l.8-2h5.1Zm-5.1-4L22.5,3.63,24.25,8Z\"/><polygon points=\"6 15.83 8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83\"/><polygon points=\"6 27.17 3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z\"/></svg>",
            "info": {},
            "path": "32/text--leading.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextLeading32",
          "filepath": "text--leading/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
                }
              }
            ],
            "name": "text--leading",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextLeading24",
          "filepath": "text--leading/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
                }
              }
            ],
            "name": "text--leading",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextLeading20",
          "filepath": "text--leading/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
                }
              }
            ],
            "name": "text--leading",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextLeading16",
          "filepath": "text--leading/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
                }
              }
            ],
            "name": "text--leading",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextLeading",
        "global": "TextLeading",
        "filepath": "TextLeading.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--line-spacing",
      "friendlyName": "Text line spacing",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--line-spacing.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>indent</title><rect x=\"17\" y=\"6\" width=\"13\" height=\"2\"/><rect x=\"17\" y=\"12\" width=\"10\" height=\"2\"/><rect x=\"17\" y=\"18\" width=\"13\" height=\"2\"/><rect x=\"17\" y=\"24\" width=\"10\" height=\"2\"/><polygon points=\"11.59 13.41 8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41\"/><polygon points=\"11.59 18.59 8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z\"/></svg>",
            "info": {},
            "path": "32/text--line-spacing.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextLineSpacing32",
          "filepath": "text--line-spacing/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
                }
              }
            ],
            "name": "text--line-spacing",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextLineSpacing24",
          "filepath": "text--line-spacing/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
                }
              }
            ],
            "name": "text--line-spacing",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextLineSpacing20",
          "filepath": "text--line-spacing/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
                }
              }
            ],
            "name": "text--line-spacing",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextLineSpacing16",
          "filepath": "text--line-spacing/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
                }
              }
            ],
            "name": "text--line-spacing",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextLineSpacing",
        "global": "TextLineSpacing",
        "filepath": "TextLineSpacing.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--new-line",
      "friendlyName": "Text new line",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--new-line.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>new-line</title><path d=\"M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z\"/></svg>",
            "info": {},
            "path": "32/text--new-line.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextNewLine32",
          "filepath": "text--new-line/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
                }
              }
            ],
            "name": "text--new-line",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextNewLine24",
          "filepath": "text--new-line/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
                }
              }
            ],
            "name": "text--new-line",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextNewLine20",
          "filepath": "text--new-line/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
                }
              }
            ],
            "name": "text--new-line",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextNewLine16",
          "filepath": "text--new-line/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
                }
              }
            ],
            "name": "text--new-line",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextNewLine",
        "global": "TextNewLine",
        "filepath": "TextNewLine.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--scale",
      "friendlyName": "Text scale",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--scale.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--scale</title><polygon points=\"30 5 30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5\"/><polygon points=\"7 26 7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z\"/><path d=\"M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z\"/></svg>",
            "info": {},
            "path": "32/text--scale.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextScale32",
          "filepath": "text--scale/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
                }
              }
            ],
            "name": "text--scale",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextScale24",
          "filepath": "text--scale/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
                }
              }
            ],
            "name": "text--scale",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextScale20",
          "filepath": "text--scale/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
                }
              }
            ],
            "name": "text--scale",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextScale16",
          "filepath": "text--scale/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
                }
              }
            ],
            "name": "text--scale",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextScale",
        "global": "TextScale",
        "filepath": "TextScale.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--selection",
      "friendlyName": "Text selection",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--selection.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-selection</title><path d=\"M28,27H21a3,3,0,0,1-3-3V22a3,3,0,0,1,3-3h5V17a1,1,0,0,0-1-1H19V14h6a3,3,0,0,1,3,3Zm-7-6a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h5V21Z\"/><path d=\"M13,7h3V5H13a4,4,0,0,0-3,1.38A4,4,0,0,0,7,5H4V7H7A2,2,0,0,1,9,9v5H5v2H9v7a2,2,0,0,1-2,2H4v2H7a4,4,0,0,0,3-1.38A4,4,0,0,0,13,27h3V25H13a2,2,0,0,1-2-2V16h4V14H11V9A2,2,0,0,1,13,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z\"/></svg>",
            "info": {},
            "path": "32/text--selection.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextSelection32",
          "filepath": "text--selection/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
                }
              }
            ],
            "name": "text--selection",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextSelection24",
          "filepath": "text--selection/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
                }
              }
            ],
            "name": "text--selection",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextSelection20",
          "filepath": "text--selection/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
                }
              }
            ],
            "name": "text--selection",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextSelection16",
          "filepath": "text--selection/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
                }
              }
            ],
            "name": "text--selection",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextSelection",
        "global": "TextSelection",
        "filepath": "TextSelection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--small-caps",
      "friendlyName": "Text small caps",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--small-caps.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--small-caps</title><polygon points=\"23 27 23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27\"/><polygon points=\"11 27 11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z\"/><path d=\"M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z\"/></svg>",
            "info": {},
            "path": "32/text--small-caps.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextSmallCaps32",
          "filepath": "text--small-caps/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
                }
              }
            ],
            "name": "text--small-caps",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextSmallCaps24",
          "filepath": "text--small-caps/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
                }
              }
            ],
            "name": "text--small-caps",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextSmallCaps20",
          "filepath": "text--small-caps/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
                }
              }
            ],
            "name": "text--small-caps",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextSmallCaps16",
          "filepath": "text--small-caps/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
                }
              }
            ],
            "name": "text--small-caps",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextSmallCaps",
        "global": "TextSmallCaps",
        "filepath": "TextSmallCaps.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--strikethrough",
      "friendlyName": "Text strikethrough",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--strikethrough.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--strikethrough</title><path d=\"M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z\"/></svg>",
            "info": {},
            "path": "32/text--strikethrough.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextStrikethrough32",
          "filepath": "text--strikethrough/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
                }
              }
            ],
            "name": "text--strikethrough",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextStrikethrough24",
          "filepath": "text--strikethrough/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
                }
              }
            ],
            "name": "text--strikethrough",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextStrikethrough20",
          "filepath": "text--strikethrough/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
                }
              }
            ],
            "name": "text--strikethrough",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextStrikethrough16",
          "filepath": "text--strikethrough/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
                }
              }
            ],
            "name": "text--strikethrough",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextStrikethrough",
        "global": "TextStrikethrough",
        "filepath": "TextStrikethrough.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--subscript",
      "friendlyName": "Text subscript",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--subscript.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--subscript</title><polygon points=\"26 25 20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25\"/><polygon points=\"5 7 5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z\"/></svg>",
            "info": {},
            "path": "32/text--subscript.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextSubscript32",
          "filepath": "text--subscript/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
                }
              }
            ],
            "name": "text--subscript",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextSubscript24",
          "filepath": "text--subscript/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
                }
              }
            ],
            "name": "text--subscript",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextSubscript20",
          "filepath": "text--subscript/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
                }
              }
            ],
            "name": "text--subscript",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextSubscript16",
          "filepath": "text--subscript/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
                }
              }
            ],
            "name": "text--subscript",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextSubscript",
        "global": "TextSubscript",
        "filepath": "TextSubscript.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--superscript",
      "friendlyName": "Text superscript",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--superscript.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--superscript</title><polygon points=\"29 17 23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17\"/><polygon points=\"4 7 4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z\"/></svg>",
            "info": {},
            "path": "32/text--superscript.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextSuperscript32",
          "filepath": "text--superscript/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
                }
              }
            ],
            "name": "text--superscript",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextSuperscript24",
          "filepath": "text--superscript/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
                }
              }
            ],
            "name": "text--superscript",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextSuperscript20",
          "filepath": "text--superscript/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
                }
              }
            ],
            "name": "text--superscript",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextSuperscript16",
          "filepath": "text--superscript/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
                }
              }
            ],
            "name": "text--superscript",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextSuperscript",
        "global": "TextSuperscript",
        "filepath": "TextSuperscript.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--tracking",
      "friendlyName": "Text tracking",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--tracking.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--tracking</title><polygon points=\"25.29 19.29 23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29\"/><path d=\"M26,17h2L23,3H21L16,17h2l1-3h6Zm-6.33-5L22,5l2.33,7Z\"/><polygon points=\"14 3 10 15 6 3 4 3 9 17 11 17 16 3 14 3\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z\"/></svg>",
            "info": {},
            "path": "32/text--tracking.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextTracking32",
          "filepath": "text--tracking/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
                }
              }
            ],
            "name": "text--tracking",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextTracking24",
          "filepath": "text--tracking/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
                }
              }
            ],
            "name": "text--tracking",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextTracking20",
          "filepath": "text--tracking/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
                }
              }
            ],
            "name": "text--tracking",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextTracking16",
          "filepath": "text--tracking/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
                }
              }
            ],
            "name": "text--tracking",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextTracking",
        "global": "TextTracking",
        "filepath": "TextTracking.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--underline",
      "friendlyName": "Text underline",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--underline.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-underline</title><rect x=\"4\" y=\"26\" width=\"24\" height=\"2\"/><path d=\"M16,23a7,7,0,0,1-7-7V5h2V16a5,5,0,0,0,10,0V5h2V16A7,7,0,0,1,16,23Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z\"/></svg>",
            "info": {},
            "path": "32/text--underline.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextUnderline32",
          "filepath": "text--underline/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
                }
              }
            ],
            "name": "text--underline",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextUnderline24",
          "filepath": "text--underline/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
                }
              }
            ],
            "name": "text--underline",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextUnderline20",
          "filepath": "text--underline/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
                }
              }
            ],
            "name": "text--underline",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextUnderline16",
          "filepath": "text--underline/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
                }
              }
            ],
            "name": "text--underline",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextUnderline",
        "global": "TextUnderline",
        "filepath": "TextUnderline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--vertical-alignment",
      "friendlyName": "Text vertical alignment",
      "aliases": [
        "text vertical alignment",
        "align",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--vertical-alignment.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>text--vertical-alignment</title>\n  <rect x=\"16\" y=\"28\" width=\"14\" height=\"2\"/>\n  <rect x=\"16\" y=\"23\" width=\"14\" height=\"2\"/>\n  <path d=\"M10.8458,30H13L8.64,20H6.36L2,30H4.1542l.8-2h5.0916ZM5.7541,26,7.5,21.6347,9.2459,26Z\"/>\n  <rect x=\"2\" y=\"15\" width=\"28\" height=\"2\"/>\n  <rect x=\"16\" y=\"7\" width=\"14\" height=\"2\"/>\n  <rect x=\"16\" y=\"2\" width=\"14\" height=\"2\"/>\n  <path d=\"M10.8458,12H13L8.64,2H6.36L2,12H4.1542l.8-2h5.0916ZM5.7541,8,7.5,3.6347,9.2459,8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z\"/></svg>",
            "info": {},
            "path": "32/text--vertical-alignment.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextVerticalAlignment32",
          "filepath": "text--vertical-alignment/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
                }
              }
            ],
            "name": "text--vertical-alignment",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextVerticalAlignment24",
          "filepath": "text--vertical-alignment/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
                }
              }
            ],
            "name": "text--vertical-alignment",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextVerticalAlignment20",
          "filepath": "text--vertical-alignment/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
                }
              }
            ],
            "name": "text--vertical-alignment",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextVerticalAlignment16",
          "filepath": "text--vertical-alignment/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
                }
              }
            ],
            "name": "text--vertical-alignment",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextVerticalAlignment",
        "global": "TextVerticalAlignment",
        "filepath": "TextVerticalAlignment.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text--wrap",
      "friendlyName": "Text wrap",
      "aliases": [
        "letter",
        "typography",
        "alphabet",
        "editor"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text--wrap.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text--wrap</title><rect x=\"4\" y=\"23\" width=\"8\" height=\"2\"/><path d=\"M24.5232,14H4v2H24.5a3.5,3.5,0,0,1,0,7H18.8281l2.586-2.5859L20,19l-5,5,5,5,1.4141-1.4141L18.8281,25H24.533a5.5,5.5,0,0,0-.01-11Z\"/><rect x=\"4\" y=\"5\" width=\"24\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z\"/></svg>",
            "info": {},
            "path": "32/text--wrap.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextWrap32",
          "filepath": "text--wrap/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
                }
              }
            ],
            "name": "text--wrap",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextWrap24",
          "filepath": "text--wrap/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
                }
              }
            ],
            "name": "text--wrap",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextWrap20",
          "filepath": "text--wrap/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
                }
              }
            ],
            "name": "text--wrap",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextWrap16",
          "filepath": "text--wrap/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
                }
              }
            ],
            "name": "text--wrap",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TextWrap",
        "global": "TextWrap",
        "filepath": "TextWrap.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text-annotation-toggle",
      "friendlyName": "Text annotation toggle",
      "aliases": [
        "text annotation toggle"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/text-annotation-toggle.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-annotation-toggle</title><path d=\"M29.537,13.76,26.24,10.463a1.5862,1.5862,0,0,0-2.24,0L10,24.4674V30h5.5326L29.537,16a1.5862,1.5862,0,0,0,0-2.24ZM14.7042,28H12V25.2958l9.4409-9.4409,2.7042,2.7042ZM25.5591,17.145,22.855,14.4409l2.2672-2.2672,2.7042,2.7042Z\"/><polygon points=\"11 17 13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17\"/><path d=\"M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z\"/><path d=\"M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/text-annotation-toggle.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthTextAnnotationToggle32",
          "filepath": "watson-health/text-annotation-toggle/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
                }
              }
            ],
            "name": "text-annotation-toggle",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthTextAnnotationToggle24",
          "filepath": "watson-health/text-annotation-toggle/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
                }
              }
            ],
            "name": "text-annotation-toggle",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthTextAnnotationToggle20",
          "filepath": "watson-health/text-annotation-toggle/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
                }
              }
            ],
            "name": "text-annotation-toggle",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthTextAnnotationToggle16",
          "filepath": "watson-health/text-annotation-toggle/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
                }
              }
            ],
            "name": "text-annotation-toggle",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "TextAnnotationToggle",
        "global": "WatsonHealthTextAnnotationToggle",
        "filepath": "watson-health/TextAnnotationToggle.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text-link",
      "friendlyName": "Text link",
      "aliases": [
        "text-link"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text-link.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-link</title><path d=\"M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z\"/><path d=\"M10.2642,29.9971A5.2619,5.2619,0,0,1,6.542,21.0137l6.03-6.03a5.2636,5.2636,0,1,1,7.4438,7.4438l-1.414-1.414a3.2639,3.2639,0,1,0-4.6158-4.6158l-6.03,6.03a3.264,3.264,0,0,0,4.6157,4.6162l1.414,1.4141A5.2452,5.2452,0,0,1,10.2642,29.9971Z\"/><rect x=\"2\" y=\"10\" width=\"8\" height=\"2\"/><rect x=\"2\" y=\"6\" width=\"12\" height=\"2\"/><rect x=\"2\" y=\"2\" width=\"12\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z\"/><path d=\"M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z\"/></svg>",
            "info": {},
            "path": "32/text-link.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextLink32",
          "filepath": "text-link/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
                }
              }
            ],
            "name": "text-link",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextLink24",
          "filepath": "text-link/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
                }
              }
            ],
            "name": "text-link",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextLink20",
          "filepath": "text-link/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
                }
              }
            ],
            "name": "text-link",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextLink16",
          "filepath": "text-link/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
                }
              }
            ],
            "name": "text-link",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TextLink",
        "global": "TextLink",
        "filepath": "TextLink.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text-link--analysis",
      "friendlyName": "Text link analysis",
      "aliases": [
        "text link"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text-link--analysis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-link--analysis</title><rect x=\"8\" y=\"10\" width=\"8\" height=\"2\"/><rect x=\"8\" y=\"6\" width=\"12\" height=\"2\"/><rect x=\"8\" y=\"2\" width=\"12\" height=\"2\"/><path d=\"M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z\"/><path d=\"M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z\"/></svg>",
            "info": {},
            "path": "32/text-link--analysis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextLinkAnalysis32",
          "filepath": "text-link--analysis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "text-link--analysis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextLinkAnalysis24",
          "filepath": "text-link--analysis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "text-link--analysis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextLinkAnalysis20",
          "filepath": "text-link--analysis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "text-link--analysis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextLinkAnalysis16",
          "filepath": "text-link--analysis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                }
              }
            ],
            "name": "text-link--analysis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TextLinkAnalysis",
        "global": "TextLinkAnalysis",
        "filepath": "TextLinkAnalysis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text-mining",
      "friendlyName": "Text mining",
      "aliases": [
        "text-mining"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text-mining.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-mining</title><rect x=\"18\" y=\"28\" width=\"8\" height=\"2\"/><rect x=\"18\" y=\"24\" width=\"12\" height=\"2\"/><rect x=\"18\" y=\"20\" width=\"12\" height=\"2\"/><polygon points=\"16.001 26.473 16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z\"/><path d=\"M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z\"/></svg>",
            "info": {},
            "path": "32/text-mining.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextMining32",
          "filepath": "text-mining/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              }
            ],
            "name": "text-mining",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextMining24",
          "filepath": "text-mining/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              }
            ],
            "name": "text-mining",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextMining20",
          "filepath": "text-mining/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              }
            ],
            "name": "text-mining",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextMining16",
          "filepath": "text-mining/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              }
            ],
            "name": "text-mining",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TextMining",
        "global": "TextMining",
        "filepath": "TextMining.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "text-mining--applier",
      "friendlyName": "Text mining applier",
      "aliases": [
        "text mining"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/text-mining--applier.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>text-mining--applier</title><polygon points=\"16.001 26.473 16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473\"/><polygon points=\"20 19 27 24 20 29 20 19\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z\"/><path d=\"M20 19L27 24 20 29 20 19z\"/></svg>",
            "info": {},
            "path": "32/text-mining--applier.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TextMiningApplier32",
          "filepath": "text-mining--applier/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19L27 24 20 29 20 19z"
                }
              }
            ],
            "name": "text-mining--applier",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TextMiningApplier24",
          "filepath": "text-mining--applier/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19L27 24 20 29 20 19z"
                }
              }
            ],
            "name": "text-mining--applier",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TextMiningApplier20",
          "filepath": "text-mining--applier/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19L27 24 20 29 20 19z"
                }
              }
            ],
            "name": "text-mining--applier",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TextMiningApplier16",
          "filepath": "text-mining--applier/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 19L27 24 20 29 20 19z"
                }
              }
            ],
            "name": "text-mining--applier",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TextMiningApplier",
        "global": "TextMiningApplier",
        "filepath": "TextMiningApplier.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 19L27 24 20 29 20 19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "theater",
      "friendlyName": "Theater",
      "aliases": [
        "destination"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/theater.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>theater</title>\n  <path d=\"M20,25a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,20,25Z\"/>\n  <path d=\"M24,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,24,14Z\"/>\n  <path d=\"M16,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,16,14Z\"/>\n  <path d=\"M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z\"/><path d=\"M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z\"/></svg>",
            "info": {},
            "path": "32/theater.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Theater32",
          "filepath": "theater/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
                }
              }
            ],
            "name": "theater",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Theater24",
          "filepath": "theater/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
                }
              }
            ],
            "name": "theater",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Theater20",
          "filepath": "theater/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
                }
              }
            ],
            "name": "theater",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Theater16",
          "filepath": "theater/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
                }
              }
            ],
            "name": "theater",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Theater",
        "global": "Theater",
        "filepath": "Theater.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "this-side-up",
      "friendlyName": "This side up",
      "aliases": [
        "this side up",
        "packaging",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/this-side-up.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/>\n  <polygon points=\"7 5.828 7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828\"/>\n  <polygon points=\"23 5.828 23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z\"/></svg>",
            "info": {},
            "path": "32/this-side-up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThisSideUp32",
          "filepath": "this-side-up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
                }
              }
            ],
            "name": "this-side-up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThisSideUp24",
          "filepath": "this-side-up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
                }
              }
            ],
            "name": "this-side-up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThisSideUp20",
          "filepath": "this-side-up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
                }
              }
            ],
            "name": "this-side-up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThisSideUp16",
          "filepath": "this-side-up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
                }
              }
            ],
            "name": "this-side-up",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "ThisSideUp",
        "global": "ThisSideUp",
        "filepath": "ThisSideUp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "threshold",
      "friendlyName": "Threshold",
      "aliases": [
        "chart",
        "plot",
        "analytics"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/threshold.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z\"/>\n  <rect x=\"8\" y=\"20\" width=\"2\" height=\"2\"/>\n  <rect x=\"12\" y=\"20\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"20\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"20\" width=\"2\" height=\"2\"/>\n  <rect x=\"8\" y=\"16\" width=\"2\" height=\"2\"/>\n  <rect x=\"16\" y=\"16\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"16\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"12\" width=\"2\" height=\"2\"/>\n  <rect x=\"20\" y=\"8\" width=\"2\" height=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z\"/><path d=\"M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z\"/></svg>",
            "info": {},
            "path": "32/watson-health/threshold.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthThreshold32",
          "filepath": "watson-health/threshold/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z"
                }
              }
            ],
            "name": "threshold",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthThreshold24",
          "filepath": "watson-health/threshold/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z"
                }
              }
            ],
            "name": "threshold",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthThreshold20",
          "filepath": "watson-health/threshold/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z"
                }
              }
            ],
            "name": "threshold",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthThreshold16",
          "filepath": "watson-health/threshold/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z"
                }
              }
            ],
            "name": "threshold",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "Threshold",
        "global": "WatsonHealthThreshold",
        "filepath": "watson-health/Threshold.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thumbnail--1",
      "friendlyName": "Thumbnail 1",
      "aliases": [
        "preview",
        "carousel",
        "grid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thumbnail--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>thumbnail--1</title><path d=\"M8,30H4a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,30ZM4,24v4H8V24Z\"/><path d=\"M18,30H14a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,30Zm-4-6v4h4V24Z\"/><path d=\"M28,30H24a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,30Zm-4-6v4h4V24Z\"/><path d=\"M28,20H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20ZM4,4V18H28V4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z\"/></svg>",
            "info": {},
            "path": "32/thumbnail--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Thumbnail_132",
          "filepath": "thumbnail--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z"
                }
              }
            ],
            "name": "thumbnail--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Thumbnail_124",
          "filepath": "thumbnail--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z"
                }
              }
            ],
            "name": "thumbnail--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Thumbnail_120",
          "filepath": "thumbnail--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z"
                }
              }
            ],
            "name": "thumbnail--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Thumbnail_116",
          "filepath": "thumbnail--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z"
                }
              }
            ],
            "name": "thumbnail--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Thumbnail_1",
        "global": "Thumbnail_1",
        "filepath": "Thumbnail_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thumbnail--2",
      "friendlyName": "Thumbnail 2",
      "aliases": [
        "preview",
        "carousel",
        "grid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thumbnail--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>thumbnail--2</title><path d=\"M8,30H4a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,30ZM4,24v4H8V24Z\"/><path d=\"M18,30H14a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,30Zm-4-6v4h4V24Z\"/><path d=\"M28,30H24a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,30Zm-4-6v4h4V24Z\"/><path d=\"M8,20H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,20ZM4,14v4H8V14Z\"/><path d=\"M18,20H14a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,20Zm-4-6v4h4V14Z\"/><path d=\"M28,20H24a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,20Zm-4-6v4h4V14Z\"/><path d=\"M8,10H4A2,2,0,0,1,2,8V4A2,2,0,0,1,4,2H8a2,2,0,0,1,2,2V8A2,2,0,0,1,8,10ZM4,4V8H8V4Z\"/><path d=\"M18,10H14a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V8A2,2,0,0,1,18,10ZM14,4V8h4V4Z\"/><path d=\"M28,10H24a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V8A2,2,0,0,1,28,10ZM24,4V8h4V4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z\"/></svg>",
            "info": {},
            "path": "32/thumbnail--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Thumbnail_232",
          "filepath": "thumbnail--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z"
                }
              }
            ],
            "name": "thumbnail--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Thumbnail_224",
          "filepath": "thumbnail--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z"
                }
              }
            ],
            "name": "thumbnail--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Thumbnail_220",
          "filepath": "thumbnail--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z"
                }
              }
            ],
            "name": "thumbnail--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Thumbnail_216",
          "filepath": "thumbnail--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z"
                }
              }
            ],
            "name": "thumbnail--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Thumbnail_2",
        "global": "Thumbnail_2",
        "filepath": "Thumbnail_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thumbnail-preview",
      "friendlyName": "Thumbnail preview",
      "aliases": [
        "thumbnail preview"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/thumbnail-preview.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>thumbnail-preview</title><path d=\"M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z\"/><path d=\"M16,23a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,16,23Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,16,17Z\"/><path d=\"M30,4V8a2.0027,2.0027,0,0,1-2,2H24a2.0027,2.0027,0,0,1-2-2V4a2.0027,2.0027,0,0,1,2-2h4A2.0027,2.0027,0,0,1,30,4ZM28,8l.002-4H24V8Z\"/><path d=\"M20,4V8a2.0027,2.0027,0,0,1-2,2H14a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h4A2.0027,2.0027,0,0,1,20,4ZM18,8l.002-4H14V8Z\"/><path d=\"M10,4V8a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,8V4A2.0023,2.0023,0,0,1,4,2H8A2.0023,2.0023,0,0,1,10,4ZM8,8l.0015-4H4V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z\"/><path d=\"M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/thumbnail-preview.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthThumbnailPreview32",
          "filepath": "watson-health/thumbnail-preview/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z"
                }
              }
            ],
            "name": "thumbnail-preview",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthThumbnailPreview24",
          "filepath": "watson-health/thumbnail-preview/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z"
                }
              }
            ],
            "name": "thumbnail-preview",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthThumbnailPreview20",
          "filepath": "watson-health/thumbnail-preview/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z"
                }
              }
            ],
            "name": "thumbnail-preview",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthThumbnailPreview16",
          "filepath": "watson-health/thumbnail-preview/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z"
                }
              }
            ],
            "name": "thumbnail-preview",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ThumbnailPreview",
        "global": "WatsonHealthThumbnailPreview",
        "filepath": "watson-health/ThumbnailPreview.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thumbs-down",
      "friendlyName": "Thumbs down",
      "aliases": [
        "dislike",
        "hand",
        "down vote",
        "no",
        "disagree"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thumbs-down.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z\"/></svg>",
            "info": {},
            "path": "32/thumbs-down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThumbsDown32",
          "filepath": "thumbs-down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
                }
              }
            ],
            "name": "thumbs-down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThumbsDown24",
          "filepath": "thumbs-down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
                }
              }
            ],
            "name": "thumbs-down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThumbsDown20",
          "filepath": "thumbs-down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
                }
              }
            ],
            "name": "thumbs-down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThumbsDown16",
          "filepath": "thumbs-down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
                }
              }
            ],
            "name": "thumbs-down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ThumbsDown",
        "global": "ThumbsDown",
        "filepath": "ThumbsDown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thumbs-down--filled",
      "friendlyName": "Thumbs down filled",
      "aliases": [
        "dislike",
        "hand",
        "down vote",
        "no",
        "disagree",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thumbs-down--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"2\" width=\"5\" height=\"14\"/>\n  <path d=\"M23,2H9V16.8027l3.0422,4.5635.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H15a3.0033,3.0033,0,0,0,3-3V20h8a4.0045,4.0045,0,0,0,4-4V9A7.0078,7.0078,0,0,0,23,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z\"/></svg>",
            "info": {},
            "path": "32/thumbs-down--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThumbsDownFilled32",
          "filepath": "thumbs-down--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z"
                }
              }
            ],
            "name": "thumbs-down--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThumbsDownFilled24",
          "filepath": "thumbs-down--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z"
                }
              }
            ],
            "name": "thumbs-down--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThumbsDownFilled20",
          "filepath": "thumbs-down--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z"
                }
              }
            ],
            "name": "thumbs-down--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThumbsDownFilled16",
          "filepath": "thumbs-down--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z"
                }
              }
            ],
            "name": "thumbs-down--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ThumbsDownFilled",
        "global": "ThumbsDownFilled",
        "filepath": "ThumbsDownFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thumbs-up",
      "friendlyName": "Thumbs up",
      "aliases": [
        "like",
        "hand",
        "up vote",
        "yes",
        "agree"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thumbs-up.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z\"/></svg>",
            "info": {},
            "path": "32/thumbs-up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThumbsUp32",
          "filepath": "thumbs-up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
                }
              }
            ],
            "name": "thumbs-up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThumbsUp24",
          "filepath": "thumbs-up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
                }
              }
            ],
            "name": "thumbs-up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThumbsUp20",
          "filepath": "thumbs-up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
                }
              }
            ],
            "name": "thumbs-up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThumbsUp16",
          "filepath": "thumbs-up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
                }
              }
            ],
            "name": "thumbs-up",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ThumbsUp",
        "global": "ThumbsUp",
        "filepath": "ThumbsUp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thumbs-up--filled",
      "friendlyName": "Thumbs up filled",
      "aliases": [
        "like",
        "hand",
        "up vote",
        "yes",
        "agree",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thumbs-up--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"16\" width=\"5\" height=\"14\"/>\n  <path d=\"M23,30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094,2.0094,0,0,1,14.8672,3H15a3.0033,3.0033,0,0,1,3,3v6h8a4.0045,4.0045,0,0,1,4,4v7A7.0078,7.0078,0,0,1,23,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z\"/></svg>",
            "info": {},
            "path": "32/thumbs-up--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThumbsUpFilled32",
          "filepath": "thumbs-up--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z"
                }
              }
            ],
            "name": "thumbs-up--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThumbsUpFilled24",
          "filepath": "thumbs-up--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z"
                }
              }
            ],
            "name": "thumbs-up--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThumbsUpFilled20",
          "filepath": "thumbs-up--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z"
                }
              }
            ],
            "name": "thumbs-up--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThumbsUpFilled16",
          "filepath": "thumbs-up--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z"
                }
              }
            ],
            "name": "thumbs-up--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ThumbsUpFilled",
        "global": "ThumbsUpFilled",
        "filepath": "ThumbsUpFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thunderstorm",
      "friendlyName": "Thunderstorm",
      "aliases": [
        "thunderstorm",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thunderstorm.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>cloud--lightning</title><path d=\"M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z\"/><polygon points=\"15.87 30.5 14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z\"/><path d=\"M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z\"/></svg>",
            "info": {},
            "path": "32/thunderstorm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Thunderstorm32",
          "filepath": "thunderstorm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
                }
              }
            ],
            "name": "thunderstorm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Thunderstorm24",
          "filepath": "thunderstorm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
                }
              }
            ],
            "name": "thunderstorm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Thunderstorm20",
          "filepath": "thunderstorm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
                }
              }
            ],
            "name": "thunderstorm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Thunderstorm16",
          "filepath": "thunderstorm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
                }
              }
            ],
            "name": "thunderstorm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Thunderstorm",
        "global": "Thunderstorm",
        "filepath": "Thunderstorm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thunderstorm--scattered",
      "friendlyName": "Thunderstorm scattered",
      "aliases": [
        "thunderstorm",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thunderstorm--scattered.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>thunderstorm--scattered</title><polygon points=\"13.338 30 11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30\"/><path d=\"M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z\"/><rect x=\"26.7322\" y=\"16.2329\" width=\"3\" height=\"2\" transform=\"translate(36.0099 49.3816) rotate(-135)\"/><rect x=\"29\" y=\"10\" width=\"3\" height=\"2\"/><rect x=\"26.7322\" y=\"3.7684\" width=\"3\" height=\"2\" transform=\"translate(4.8972 21.3598) rotate(-45)\"/><rect x=\"20\" width=\"2\" height=\"3\"/><rect x=\"12.2678\" y=\"3.7684\" width=\"3\" height=\"2\" transform=\"translate(20.1312 17.8755) rotate(-135)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z\"/><path d=\"M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z\"/><path d=\"M26.732 16.233H29.732V18.233H26.732z\" transform=\"rotate(-135 28.232 17.233)\"/><path d=\"M29 10H32V12H29z\"/><path d=\"M26.732 3.768H29.732V5.768H26.732z\" transform=\"rotate(-45 28.232 4.768)\"/><path d=\"M20 0H22V3H20z\"/><path d=\"M12.268 3.768H15.268V5.768H12.268z\" transform=\"rotate(-135 13.768 4.768)\"/></svg>",
            "info": {},
            "path": "32/thunderstorm--scattered.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThunderstormScattered32",
          "filepath": "thunderstorm--scattered/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              }
            ],
            "name": "thunderstorm--scattered",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThunderstormScattered24",
          "filepath": "thunderstorm--scattered/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              }
            ],
            "name": "thunderstorm--scattered",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThunderstormScattered20",
          "filepath": "thunderstorm--scattered/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              }
            ],
            "name": "thunderstorm--scattered",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThunderstormScattered16",
          "filepath": "thunderstorm--scattered/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 16.233H29.732V18.233H26.732z",
                  "transform": "rotate(-135 28.232 17.233)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 10H32V12H29z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.732 3.768H29.732V5.768H26.732z",
                  "transform": "rotate(-45 28.232 4.768)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 0H22V3H20z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.268 3.768H15.268V5.768H12.268z",
                  "transform": "rotate(-135 13.768 4.768)"
                }
              }
            ],
            "name": "thunderstorm--scattered",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ThunderstormScattered",
        "global": "ThunderstormScattered",
        "filepath": "ThunderstormScattered.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.732 16.233H29.732V18.233H26.732z",
                    "transform": "rotate(-135 28.232 17.233)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 10H32V12H29z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.732 3.768H29.732V5.768H26.732z",
                    "transform": "rotate(-45 28.232 4.768)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 0H22V3H20z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.268 3.768H15.268V5.768H12.268z",
                    "transform": "rotate(-135 13.768 4.768)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thunderstorm--scattered--night",
      "friendlyName": "Thunderstorm scattered night",
      "aliases": [
        "thunderstorm",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thunderstorm--scattered--night.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>thunderstorm--scattered--night</title><polygon points=\"13.338 30 11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30\"/><path d=\"M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z\"/><path d=\"M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z\"/></svg>",
            "info": {},
            "path": "32/thunderstorm--scattered--night.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThunderstormScatteredNight32",
          "filepath": "thunderstorm--scattered--night/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
                }
              }
            ],
            "name": "thunderstorm--scattered--night",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThunderstormScatteredNight24",
          "filepath": "thunderstorm--scattered--night/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
                }
              }
            ],
            "name": "thunderstorm--scattered--night",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThunderstormScatteredNight20",
          "filepath": "thunderstorm--scattered--night/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
                }
              }
            ],
            "name": "thunderstorm--scattered--night",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThunderstormScatteredNight16",
          "filepath": "thunderstorm--scattered--night/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
                }
              }
            ],
            "name": "thunderstorm--scattered--night",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ThunderstormScatteredNight",
        "global": "ThunderstormScatteredNight",
        "filepath": "ThunderstormScatteredNight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thunderstorm--severe",
      "friendlyName": "Thunderstorm severe",
      "aliases": [
        "thunderstorm",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thunderstorm--severe.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>thunderstorm--severe</title><path d=\"M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7887.8947l-2,4A.9981.9981,0,0,1,21,30Z\"/><path d=\"M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7887.8947l-2,4A.9981.9981,0,0,1,9,32Z\"/><polygon points=\"15.901 30.496 14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496\"/><path d=\"M27.9516,15A4.399,4.399,0,0,1,28,15.5,4.5049,4.5049,0,0,1,23.5,20H23v2h.5A6.5075,6.5075,0,0,0,30,15.5c0-.17-.0312-.333-.0444-.5Z\"/><path id=\"_Inner_path_\" data-name=\"&lt;Inner path&gt;\" class=\"cls-1\" d=\"M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z\"/><path d=\"M31.9115,11.9355,25.6283.3706a.7181.7181,0,0,0-1.2568,0L18.0883,11.9355A.72.72,0,0,0,18.72,13H31.28A.72.72,0,0,0,31.9115,11.9355ZM24.25,4h1.5V8h-1.5ZM25,11a1,1,0,1,1,1-1A1,1,0,0,1,25,11Z\"/><path d=\"M8.144,11.019l.8154-.0639.0991-.812a6.9863,6.9863,0,0,1,9.97-5.45L20,2.9468A8.9777,8.9777,0,0,0,7.2,9.1362,6.4929,6.4929,0,0,0,7.43,21.9043L6.1059,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.4471-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.3559-8.981Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z\"/><path fill=\"none\" d=\"M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z\"/><path d=\"M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z\"/></svg>",
            "info": {},
            "path": "32/thunderstorm--severe.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThunderstormSevere32",
          "filepath": "thunderstorm--severe/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z"
                }
              }
            ],
            "name": "thunderstorm--severe",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThunderstormSevere24",
          "filepath": "thunderstorm--severe/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z"
                }
              }
            ],
            "name": "thunderstorm--severe",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThunderstormSevere20",
          "filepath": "thunderstorm--severe/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z"
                }
              }
            ],
            "name": "thunderstorm--severe",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThunderstormSevere16",
          "filepath": "thunderstorm--severe/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z"
                }
              }
            ],
            "name": "thunderstorm--severe",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ThunderstormSevere",
        "global": "ThunderstormSevere",
        "filepath": "ThunderstormSevere.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "thunderstorm--strong",
      "friendlyName": "Thunderstorm strong",
      "aliases": [
        "thunderstorm",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/thunderstorm--strong.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>thunderstorm--strong</title><path d=\"M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,21,30Z\"/><path d=\"M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,9,32Z\"/><polygon points=\"15.901 30.496 14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z\"/></svg>",
            "info": {},
            "path": "32/thunderstorm--strong.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ThunderstormStrong32",
          "filepath": "thunderstorm--strong/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "thunderstorm--strong",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ThunderstormStrong24",
          "filepath": "thunderstorm--strong/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "thunderstorm--strong",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ThunderstormStrong20",
          "filepath": "thunderstorm--strong/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "thunderstorm--strong",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ThunderstormStrong16",
          "filepath": "thunderstorm--strong/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "thunderstorm--strong",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "ThunderstormStrong",
        "global": "ThunderstormStrong",
        "filepath": "ThunderstormStrong.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ticket",
      "friendlyName": "Ticket",
      "aliases": [
        "stub",
        "admission",
        "destination"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ticket.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ticket</title><path d=\"M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z\" transform=\"translate(0 0)\"/><rect x=\"19\" y=\"13\" width=\"2\" height=\"6\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z\"/><path d=\"M19 13H21V19H19z\"/></svg>",
            "info": {},
            "path": "32/ticket.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Ticket32",
          "filepath": "ticket/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H21V19H19z"
                }
              }
            ],
            "name": "ticket",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Ticket24",
          "filepath": "ticket/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H21V19H19z"
                }
              }
            ],
            "name": "ticket",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Ticket20",
          "filepath": "ticket/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H21V19H19z"
                }
              }
            ],
            "name": "ticket",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Ticket16",
          "filepath": "ticket/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H21V19H19z"
                }
              }
            ],
            "name": "ticket",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Ticket",
        "global": "Ticket",
        "filepath": "Ticket.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 13H21V19H19z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tides",
      "friendlyName": "Tides",
      "aliases": [
        "tides",
        "weather",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tides.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"14 7 9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7\"/>\n  <polygon points=\"26.586 7.586 24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586\"/>\n  <path d=\"M20,20a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,17a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,20a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,17a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,20H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,20,22H30V20Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,24,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,20,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,28H2v2H12a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,28,30h2V28Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z\"/></svg>",
            "info": {},
            "path": "32/tides.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tides32",
          "filepath": "tides/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z"
                }
              }
            ],
            "name": "tides",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tides24",
          "filepath": "tides/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z"
                }
              }
            ],
            "name": "tides",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tides20",
          "filepath": "tides/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z"
                }
              }
            ],
            "name": "tides",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tides16",
          "filepath": "tides/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z"
                }
              }
            ],
            "name": "tides",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Tides",
        "global": "Tides",
        "filepath": "Tides.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "TIF",
      "friendlyName": "TIF",
      "aliases": [
        "format",
        "image"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/TIF.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>TIF</title><polygon points=\"30 11 30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11\"/><polygon points=\"12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11\"/><polygon points=\"2 11 5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z\"/></svg>",
            "info": {},
            "path": "32/TIF.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tif32",
          "filepath": "TIF/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TIF",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tif24",
          "filepath": "TIF/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TIF",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tif20",
          "filepath": "TIF/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TIF",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tif16",
          "filepath": "TIF/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TIF",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Tif",
        "global": "Tif",
        "filepath": "Tif.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "time",
      "friendlyName": "Time",
      "aliases": [
        "clock",
        "hour",
        "minute",
        "watch"
      ],
      "sizes": [
        20,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 20,
          "filepath": "20/time.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7\n\tS14.3,2.3,10,2.3z\"/>\n<polygon points=\"13,13.9 9.4,10.3 9.4,4 10.6,4 10.6,9.7 13.9,13 \"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"20\" height=\"20\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7\tS14.3,2.3,10,2.3z\"/><path d=\"M13 13.9L9.4 10.3 9.4 4 10.6 4 10.6 9.7 13.9 13z\"/></svg>",
            "info": {},
            "path": "20/time.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/time.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>time</title><path d=\"M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z\"/><polygon points=\"20.59 22 15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z\"/><path d=\"M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z\"/></svg>",
            "info": {},
            "path": "32/time.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Time32",
          "filepath": "time/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                }
              }
            ],
            "name": "time",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Time24",
          "filepath": "time/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                }
              }
            ],
            "name": "time",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Time20",
          "filepath": "time/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7\tS14.3,2.3,10,2.3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 13.9L9.4 10.3 9.4 4 10.6 4 10.6 9.7 13.9 13z"
                }
              }
            ],
            "name": "time",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Time16",
          "filepath": "time/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                }
              }
            ],
            "name": "time",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Time",
        "global": "Time",
        "filepath": "Time.js",
        "sizes": [
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7 S14.3,2.3,10,2.3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 13.9L9.4 10.3 9.4 4 10.6 4 10.6 9.7 13.9 13z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "time-plot",
      "friendlyName": "Time plot",
      "aliases": [
        "time plot",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/time-plot.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"23.586 13 21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13\"/>\n  <path d=\"M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z\"/>\n  <path d=\"M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z\"/><path d=\"M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z\"/><path d=\"M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z\"/></svg>",
            "info": {},
            "path": "32/time-plot.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TimePlot32",
          "filepath": "time-plot/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
                }
              }
            ],
            "name": "time-plot",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TimePlot24",
          "filepath": "time-plot/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
                }
              }
            ],
            "name": "time-plot",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TimePlot20",
          "filepath": "time-plot/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
                }
              }
            ],
            "name": "time-plot",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TimePlot16",
          "filepath": "time-plot/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
                }
              }
            ],
            "name": "time-plot",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TimePlot",
        "global": "TimePlot",
        "filepath": "TimePlot.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "timer",
      "friendlyName": "Timer",
      "aliases": [
        "alarm",
        "alert",
        "stop watch"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/timer.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>timer</title><rect x=\"15\" y=\"11\" width=\"2\" height=\"9\"/><rect class=\"cls-1\" x=\"13\" y=\"2\" width=\"6\" height=\"2\"/><path d=\"M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z\"/><rect class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 11H17V20H15zM13 2H19V4H13z\"/><path d=\"M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z\"/></svg>",
            "info": {},
            "path": "32/timer.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Timer32",
          "filepath": "timer/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V20H15zM13 2H19V4H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
                }
              }
            ],
            "name": "timer",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Timer24",
          "filepath": "timer/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V20H15zM13 2H19V4H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
                }
              }
            ],
            "name": "timer",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Timer20",
          "filepath": "timer/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V20H15zM13 2H19V4H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
                }
              }
            ],
            "name": "timer",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Timer16",
          "filepath": "timer/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 11H17V20H15zM13 2H19V4H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
                }
              }
            ],
            "name": "timer",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Time",
      "moduleInfo": {
        "local": "Timer",
        "global": "Timer",
        "filepath": "Timer.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 11H17V20H15zM13 2H19V4H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tool-box",
      "friendlyName": "Tool box",
      "aliases": [
        "kit",
        "container"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tool-box.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tool-box</title><path d=\"M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z\"/></svg>",
            "info": {},
            "path": "32/tool-box.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ToolBox32",
          "filepath": "tool-box/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
                }
              }
            ],
            "name": "tool-box",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ToolBox24",
          "filepath": "tool-box/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
                }
              }
            ],
            "name": "tool-box",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ToolBox20",
          "filepath": "tool-box/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
                }
              }
            ],
            "name": "tool-box",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ToolBox16",
          "filepath": "tool-box/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
                }
              }
            ],
            "name": "tool-box",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "ToolBox",
        "global": "ToolBox",
        "filepath": "ToolBox.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tool-kit",
      "friendlyName": "Tool kit",
      "aliases": [
        "tools",
        "kit",
        "wrench",
        "screwdriver"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tool-kit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z\"/>\n  <path d=\"M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z\"/>\n  <path d=\"M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z\"/><path d=\"M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z\"/><path d=\"M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z\"/></svg>",
            "info": {},
            "path": "32/tool-kit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ToolKit32",
          "filepath": "tool-kit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
                }
              }
            ],
            "name": "tool-kit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ToolKit24",
          "filepath": "tool-kit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
                }
              }
            ],
            "name": "tool-kit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ToolKit20",
          "filepath": "tool-kit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
                }
              }
            ],
            "name": "tool-kit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ToolKit16",
          "filepath": "tool-kit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
                }
              }
            ],
            "name": "tool-kit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "ToolKit",
        "global": "ToolKit",
        "filepath": "ToolKit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tools",
      "friendlyName": "Tools",
      "aliases": [
        "wrench",
        "fix",
        "setting",
        "customize"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tools.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tools</title><path d=\"M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z\"/></svg>",
            "info": {},
            "path": "32/tools.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tools32",
          "filepath": "tools/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
                }
              }
            ],
            "name": "tools",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tools24",
          "filepath": "tools/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
                }
              }
            ],
            "name": "tools",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tools20",
          "filepath": "tools/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
                }
              }
            ],
            "name": "tools",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tools16",
          "filepath": "tools/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
                }
              }
            ],
            "name": "tools",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Tools",
        "global": "Tools",
        "filepath": "Tools.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tools--alt",
      "friendlyName": "Tools alt",
      "aliases": [
        "tools",
        "instruments"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tools--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8\n\tc-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4\n\tL28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1\n\tl4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E_\" x=\"0\" y=\"0\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8\tc-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4\tL28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1\tl4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z\"/></svg>",
            "info": {},
            "path": "32/tools--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ToolsAlt32",
          "filepath": "tools--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8\tc-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4\tL28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1\tl4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
                }
              }
            ],
            "name": "tools--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ToolsAlt24",
          "filepath": "tools--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8\tc-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4\tL28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1\tl4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
                }
              }
            ],
            "name": "tools--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ToolsAlt20",
          "filepath": "tools--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8\tc-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4\tL28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1\tl4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
                }
              }
            ],
            "name": "tools--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ToolsAlt16",
          "filepath": "tools--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8\tc-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4\tL28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1\tl4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
                }
              }
            ],
            "name": "tools--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "ToolsAlt",
        "global": "ToolsAlt",
        "filepath": "ToolsAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8 c-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4 L28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1 l4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tornado",
      "friendlyName": "Tornado",
      "aliases": [
        "tornado"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tornado.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tornado</title><rect x=\"16\" y=\"26\" width=\"4\" height=\"2\"/><rect x=\"12\" y=\"22\" width=\"6\" height=\"2\"/><rect x=\"8\" y=\"18\" width=\"10\" height=\"2\"/><rect x=\"8\" y=\"14\" width=\"12\" height=\"2\"/><rect x=\"10\" y=\"10\" width=\"14\" height=\"2\"/><rect x=\"8\" y=\"6\" width=\"18\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z\"/></svg>",
            "info": {},
            "path": "32/tornado.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tornado32",
          "filepath": "tornado/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z"
                }
              }
            ],
            "name": "tornado",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tornado24",
          "filepath": "tornado/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z"
                }
              }
            ],
            "name": "tornado",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tornado20",
          "filepath": "tornado/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z"
                }
              }
            ],
            "name": "tornado",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tornado16",
          "filepath": "tornado/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z"
                }
              }
            ],
            "name": "tornado",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Tornado",
        "global": "Tornado",
        "filepath": "Tornado.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tornado-warning",
      "friendlyName": "Tornado warning",
      "aliases": [
        "tornado",
        "warning",
        "weather",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tornado-warning.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"4\" width=\"16\" height=\"2\"/>\n  <rect x=\"4\" y=\"8\" width=\"12\" height=\"2\"/>\n  <rect x=\"2\" y=\"12\" width=\"12\" height=\"2\"/>\n  <rect x=\"2\" y=\"16\" width=\"10\" height=\"2\"/>\n  <rect x=\"4\" y=\"20\" width=\"8\" height=\"2\"/>\n  <rect x=\"8\" y=\"24\" width=\"6\" height=\"2\"/>\n  <rect x=\"12\" y=\"28\" width=\"4\" height=\"2\"/>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z\"/><path fill=\"none\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\"/><path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\"/></svg>",
            "info": {},
            "path": "32/tornado-warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TornadoWarning32",
          "filepath": "tornado-warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tornado-warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TornadoWarning24",
          "filepath": "tornado-warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tornado-warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TornadoWarning20",
          "filepath": "tornado-warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tornado-warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TornadoWarning16",
          "filepath": "tornado-warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tornado-warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TornadoWarning",
        "global": "TornadoWarning",
        "filepath": "TornadoWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "touch--1",
      "friendlyName": "Touch 1",
      "aliases": [
        "hand",
        "tap",
        "press",
        "click",
        "mobile",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/touch--1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>touch-1</title><path d=\"M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z\"/><path d=\"M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z\"/><path d=\"M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z\"/></svg>",
            "info": {},
            "path": "32/touch--1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Touch_132",
          "filepath": "touch--1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
                }
              }
            ],
            "name": "touch--1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Touch_124",
          "filepath": "touch--1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
                }
              }
            ],
            "name": "touch--1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Touch_120",
          "filepath": "touch--1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
                }
              }
            ],
            "name": "touch--1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Touch_116",
          "filepath": "touch--1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
                }
              }
            ],
            "name": "touch--1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Touch_1",
        "global": "Touch_1",
        "filepath": "Touch_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "touch--1--filled",
      "friendlyName": "Touch 1 filled",
      "aliases": [
        "hand",
        "tap",
        "press",
        "click",
        "mobile",
        "device",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/touch--1--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z\"/>\n  <path d=\"M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z\"/><path d=\"M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z\"/></svg>",
            "info": {},
            "path": "32/touch--1--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Touch_1Filled32",
          "filepath": "touch--1--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
                }
              }
            ],
            "name": "touch--1--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Touch_1Filled24",
          "filepath": "touch--1--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
                }
              }
            ],
            "name": "touch--1--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Touch_1Filled20",
          "filepath": "touch--1--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
                }
              }
            ],
            "name": "touch--1--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Touch_1Filled16",
          "filepath": "touch--1--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
                }
              }
            ],
            "name": "touch--1--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Touch_1Filled",
        "global": "Touch_1Filled",
        "filepath": "Touch_1Filled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "touch--1-down",
      "friendlyName": "Touch 1 down",
      "aliases": [
        "hand",
        "tap",
        "depress",
        "click",
        "mobile",
        "device",
        "down",
        "hold"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/touch--1-down.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z\"/>\n  <path d=\"M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z\"/><path d=\"M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z\"/></svg>",
            "info": {},
            "path": "32/touch--1-down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Touch_1Down32",
          "filepath": "touch--1-down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
                }
              }
            ],
            "name": "touch--1-down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Touch_1Down24",
          "filepath": "touch--1-down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
                }
              }
            ],
            "name": "touch--1-down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Touch_1Down20",
          "filepath": "touch--1-down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
                }
              }
            ],
            "name": "touch--1-down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Touch_1Down16",
          "filepath": "touch--1-down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
                }
              }
            ],
            "name": "touch--1-down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Touch_1Down",
        "global": "Touch_1Down",
        "filepath": "Touch_1Down.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "touch--1-down--filled",
      "friendlyName": "Touch 1 down filled",
      "aliases": [
        "hand",
        "tap",
        "depress",
        "click",
        "mobile",
        "device",
        "down",
        "hold",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/touch--1-down--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z\"/>\n  <path d=\"M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z\"/><path d=\"M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z\"/></svg>",
            "info": {},
            "path": "32/touch--1-down--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Touch_1DownFilled32",
          "filepath": "touch--1-down--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
                }
              }
            ],
            "name": "touch--1-down--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Touch_1DownFilled24",
          "filepath": "touch--1-down--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
                }
              }
            ],
            "name": "touch--1-down--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Touch_1DownFilled20",
          "filepath": "touch--1-down--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
                }
              }
            ],
            "name": "touch--1-down--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Touch_1DownFilled16",
          "filepath": "touch--1-down--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
                }
              }
            ],
            "name": "touch--1-down--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Touch_1DownFilled",
        "global": "Touch_1DownFilled",
        "filepath": "Touch_1DownFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "touch--2",
      "friendlyName": "Touch 2",
      "aliases": [
        "hand",
        "tap",
        "press",
        "click",
        "mobile",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/touch--2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>touch-2</title><path d=\"M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z\"/><path d=\"M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z\"/><path d=\"M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z\"/><path d=\"M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z\"/><path d=\"M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z\"/></svg>",
            "info": {},
            "path": "32/touch--2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Touch_232",
          "filepath": "touch--2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
                }
              }
            ],
            "name": "touch--2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Touch_224",
          "filepath": "touch--2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
                }
              }
            ],
            "name": "touch--2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Touch_220",
          "filepath": "touch--2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
                }
              }
            ],
            "name": "touch--2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Touch_216",
          "filepath": "touch--2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
                }
              }
            ],
            "name": "touch--2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Touch_2",
        "global": "Touch_2",
        "filepath": "Touch_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "touch--2--filled",
      "friendlyName": "Touch 2 filled",
      "aliases": [
        "hand",
        "tap",
        "press",
        "click",
        "mobile",
        "device",
        "filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/touch--2--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z\"/>\n  <path d=\"M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z\"/>\n  <path d=\"M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z\"/><path d=\"M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z\"/><path d=\"M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z\"/></svg>",
            "info": {},
            "path": "32/touch--2--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Touch_2Filled32",
          "filepath": "touch--2--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              }
            ],
            "name": "touch--2--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Touch_2Filled24",
          "filepath": "touch--2--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              }
            ],
            "name": "touch--2--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Touch_2Filled20",
          "filepath": "touch--2--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              }
            ],
            "name": "touch--2--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Touch_2Filled16",
          "filepath": "touch--2--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                }
              }
            ],
            "name": "touch--2--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "Touch_2Filled",
        "global": "Touch_2Filled",
        "filepath": "Touch_2Filled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "touch--interaction",
      "friendlyName": "Touch interaction",
      "aliases": [
        "mobile",
        "device"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/touch--interaction.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>touch--interaction</title>\n  <path d=\"M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z\"/>\n  <path d=\"M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z\"/><path d=\"M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z\"/></svg>",
            "info": {},
            "path": "32/touch--interaction.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TouchInteraction32",
          "filepath": "touch--interaction/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
                }
              }
            ],
            "name": "touch--interaction",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TouchInteraction24",
          "filepath": "touch--interaction/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
                }
              }
            ],
            "name": "touch--interaction",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TouchInteraction20",
          "filepath": "touch--interaction/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
                }
              }
            ],
            "name": "touch--interaction",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TouchInteraction16",
          "filepath": "touch--interaction/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
                }
              }
            ],
            "name": "touch--interaction",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "Senses",
      "moduleInfo": {
        "local": "TouchInteraction",
        "global": "TouchInteraction",
        "filepath": "TouchInteraction.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "traffic--event",
      "friendlyName": "Traffic event",
      "aliases": [
        "traffic event",
        "travel",
        "crowd",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/traffic--event.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"11\" y=\"21\" width=\"6\" height=\"2\"/>\n  <path d=\"M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 21H17V23H11z\"/><path d=\"M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z\"/></svg>",
            "info": {},
            "path": "32/traffic--event.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrafficEvent32",
          "filepath": "traffic--event/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H17V23H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
                }
              }
            ],
            "name": "traffic--event",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrafficEvent24",
          "filepath": "traffic--event/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H17V23H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
                }
              }
            ],
            "name": "traffic--event",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrafficEvent20",
          "filepath": "traffic--event/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H17V23H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
                }
              }
            ],
            "name": "traffic--event",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrafficEvent16",
          "filepath": "traffic--event/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 21H17V23H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
                }
              }
            ],
            "name": "traffic--event",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrafficEvent",
        "global": "TrafficEvent",
        "filepath": "TrafficEvent.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 21H17V23H11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "traffic--flow",
      "friendlyName": "Traffic flow",
      "aliases": [
        "traffic flow",
        "travel",
        "flow",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/traffic--flow.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26 8 22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8\"/>\n  <polygon points=\"12.59 22.58 11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58\"/>\n  <rect x=\"2\" y=\"2\" width=\"2\" height=\"28\"/>\n  <rect x=\"28\" y=\"2\" width=\"2\" height=\"28\"/>\n  <rect x=\"15\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"10\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"18\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"26\" width=\"2\" height=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z\"/></svg>",
            "info": {},
            "path": "32/traffic--flow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrafficFlow32",
          "filepath": "traffic--flow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrafficFlow24",
          "filepath": "traffic--flow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrafficFlow20",
          "filepath": "traffic--flow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrafficFlow16",
          "filepath": "traffic--flow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrafficFlow",
        "global": "TrafficFlow",
        "filepath": "TrafficFlow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "traffic--flow-incident",
      "friendlyName": "Traffic flow incident",
      "aliases": [
        "traffic flow incident",
        "travel",
        "accident",
        "flow",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/traffic--flow-incident.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"26 9.42 24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42\"/>\n  <polygon points=\"14 17.42 12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42\"/>\n  <rect x=\"2\" y=\"2\" width=\"2\" height=\"28\"/>\n  <rect x=\"28\" y=\"2\" width=\"2\" height=\"28\"/>\n  <rect x=\"15\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"10\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"18\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"26\" width=\"2\" height=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z\"/></svg>",
            "info": {},
            "path": "32/traffic--flow-incident.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrafficFlowIncident32",
          "filepath": "traffic--flow-incident/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow-incident",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrafficFlowIncident24",
          "filepath": "traffic--flow-incident/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow-incident",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrafficFlowIncident20",
          "filepath": "traffic--flow-incident/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow-incident",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrafficFlowIncident16",
          "filepath": "traffic--flow-incident/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                }
              }
            ],
            "name": "traffic--flow-incident",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrafficFlowIncident",
        "global": "TrafficFlowIncident",
        "filepath": "TrafficFlowIncident.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "traffic--incident",
      "friendlyName": "Traffic incident",
      "aliases": [
        "traffic incident",
        "travel",
        "accident",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/traffic--incident.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"28\" width=\"28\" height=\"2\"/>\n  <rect x=\"11.3137\" y=\"11.5145\" width=\"6\" height=\"2\" transform=\"translate(-4.6567 13.7867) rotate(-45)\"/>\n  <path d=\"M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 28H30V30H2z\"/><path d=\"M11.314 11.514H17.314V13.514H11.314z\" transform=\"rotate(-45 14.314 12.514)\"/><path d=\"M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z\"/></svg>",
            "info": {},
            "path": "32/traffic--incident.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrafficIncident32",
          "filepath": "traffic--incident/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.314 11.514H17.314V13.514H11.314z",
                  "transform": "rotate(-45 14.314 12.514)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
                }
              }
            ],
            "name": "traffic--incident",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrafficIncident24",
          "filepath": "traffic--incident/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.314 11.514H17.314V13.514H11.314z",
                  "transform": "rotate(-45 14.314 12.514)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
                }
              }
            ],
            "name": "traffic--incident",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrafficIncident20",
          "filepath": "traffic--incident/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.314 11.514H17.314V13.514H11.314z",
                  "transform": "rotate(-45 14.314 12.514)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
                }
              }
            ],
            "name": "traffic--incident",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrafficIncident16",
          "filepath": "traffic--incident/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 28H30V30H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11.314 11.514H17.314V13.514H11.314z",
                  "transform": "rotate(-45 14.314 12.514)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
                }
              }
            ],
            "name": "traffic--incident",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrafficIncident",
        "global": "TrafficIncident",
        "filepath": "TrafficIncident.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 28H30V30H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11.314 11.514H17.314V13.514H11.314z",
                    "transform": "rotate(-45 14.314 12.514)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "traffic--weather-incident",
      "friendlyName": "Traffic weather incident",
      "aliases": [
        "traffic weather incident",
        "weather",
        "travel",
        "incident",
        "transportation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/traffic--weather-incident.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"2\" y=\"24\" width=\"2\" height=\"6\"/>\n  <rect x=\"28\" y=\"2\" width=\"2\" height=\"28\"/>\n  <rect x=\"15\" y=\"2\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"10\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"18\" width=\"2\" height=\"4\"/>\n  <rect x=\"15\" y=\"26\" width=\"2\" height=\"4\"/>\n  <path d=\"M6,12A3.8978,3.8978,0,0,1,2,8.223a3.9017,3.9017,0,0,1,.6533-2.0639L5.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L9.3154,6.11A3.9693,3.9693,0,0,1,10,8.223,3.8978,3.8978,0,0,1,6,12Zm0-7.2368L4.3438,7.2257A1.89,1.89,0,0,0,4,8.223a1.9007,1.9007,0,0,0,2,1.7775A1.9007,1.9007,0,0,0,8,8.223a1.98,1.98,0,0,0-.375-1.0466Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,11.7627,9.3438,14.2253A1.89,1.89,0,0,0,9,15.2226,1.9007,1.9007,0,0,0,11,17a1.9007,1.9007,0,0,0,2-1.7774,1.98,1.98,0,0,0-.375-1.0467Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M6,15.7627,4.3438,18.2253A1.89,1.89,0,0,0,4,19.2226,1.9007,1.9007,0,0,0,6,21a1.9007,1.9007,0,0,0,2-1.7774,1.98,1.98,0,0,0-.375-1.0467Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z\"/></svg>",
            "info": {},
            "path": "32/traffic--weather-incident.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrafficWeatherIncident32",
          "filepath": "traffic--weather-incident/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z"
                }
              }
            ],
            "name": "traffic--weather-incident",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrafficWeatherIncident24",
          "filepath": "traffic--weather-incident/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z"
                }
              }
            ],
            "name": "traffic--weather-incident",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrafficWeatherIncident20",
          "filepath": "traffic--weather-incident/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z"
                }
              }
            ],
            "name": "traffic--weather-incident",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrafficWeatherIncident16",
          "filepath": "traffic--weather-incident/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z"
                }
              }
            ],
            "name": "traffic--weather-incident",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrafficWeatherIncident",
        "global": "TrafficWeatherIncident",
        "filepath": "TrafficWeatherIncident.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "traffic-cone",
      "friendlyName": "Traffic cone",
      "aliases": [
        "traffic flow incident",
        "travel",
        "incident",
        "transportation",
        "traffic cone",
        "traffic",
        "cone",
        "travel",
        "transportation",
        "roadwork",
        "construction"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/traffic-cone.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #241f20;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z\"/></svg>",
            "info": {},
            "path": "32/traffic-cone.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrafficCone32",
          "filepath": "traffic-cone/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
                }
              }
            ],
            "name": "traffic-cone",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrafficCone24",
          "filepath": "traffic-cone/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
                }
              }
            ],
            "name": "traffic-cone",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrafficCone20",
          "filepath": "traffic-cone/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
                }
              }
            ],
            "name": "traffic-cone",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrafficCone16",
          "filepath": "traffic-cone/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
                }
              }
            ],
            "name": "traffic-cone",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrafficCone",
        "global": "TrafficCone",
        "filepath": "TrafficCone.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "train",
      "friendlyName": "Train",
      "aliases": [
        "subway",
        "metro",
        "underground",
        "transportation",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/train.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>train</title><path d=\"M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z\"/></svg>",
            "info": {},
            "path": "32/train.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Train32",
          "filepath": "train/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
                }
              }
            ],
            "name": "train",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Train24",
          "filepath": "train/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
                }
              }
            ],
            "name": "train",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Train20",
          "filepath": "train/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
                }
              }
            ],
            "name": "train",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Train16",
          "filepath": "train/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
                }
              }
            ],
            "name": "train",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Train",
        "global": "Train",
        "filepath": "Train.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "train--heart",
      "friendlyName": "Train heart",
      "aliases": [
        "train",
        "heart",
        "transportation",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/train--heart.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27.303,2a2.6613,2.6613,0,0,0-1.9079.8059l-.3932.4053-.397-.4053a2.6612,2.6612,0,0,0-3.8157,0,2.7991,2.7991,0,0,0,0,3.8963L25.0019,11l4.2089-4.2978a2.7991,2.7991,0,0,0,0-3.8963A2.6613,2.6613,0,0,0,27.303,2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22,13v3H6V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V13Zm0,7H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z\"/></svg>",
            "info": {},
            "path": "32/train--heart.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrainHeart32",
          "filepath": "train--heart/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z"
                }
              }
            ],
            "name": "train--heart",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrainHeart24",
          "filepath": "train--heart/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z"
                }
              }
            ],
            "name": "train--heart",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrainHeart20",
          "filepath": "train--heart/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z"
                }
              }
            ],
            "name": "train--heart",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrainHeart16",
          "filepath": "train--heart/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z"
                }
              }
            ],
            "name": "train--heart",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrainHeart",
        "global": "TrainHeart",
        "filepath": "TrainHeart.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "train--profile",
      "friendlyName": "Train profile",
      "aliases": [
        "train",
        "transportation",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/train--profile.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 25 2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25\"/>\n  <path d=\"M8,16H2V14H8V12H2V10H8a2.0021,2.0021,0,0,1,2,2v2A2.0021,2.0021,0,0,1,8,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z\"/><path d=\"M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z\"/></svg>",
            "info": {},
            "path": "32/train--profile.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrainProfile32",
          "filepath": "train--profile/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
                }
              }
            ],
            "name": "train--profile",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrainProfile24",
          "filepath": "train--profile/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
                }
              }
            ],
            "name": "train--profile",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrainProfile20",
          "filepath": "train--profile/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
                }
              }
            ],
            "name": "train--profile",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrainProfile16",
          "filepath": "train--profile/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
                }
              }
            ],
            "name": "train--profile",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrainProfile",
        "global": "TrainProfile",
        "filepath": "TrainProfile.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "train--speed",
      "friendlyName": "Train speed",
      "aliases": [
        "train",
        "fast",
        "transportation",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/train--speed.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"30 25 2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25\"/>\n  <path d=\"M29.7144,16.59,18.1494,8.64A14.9327,14.9327,0,0,0,9.6519,6H2V8H9.6519a12.9459,12.9459,0,0,1,7.3647,2.2871L18.0532,11H9v2H20.9624l7.6187,5.2378A.966.966,0,0,1,28.0342,20H2v2H28.0342a2.9661,2.9661,0,0,0,1.68-5.41Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z\"/></svg>",
            "info": {},
            "path": "32/train--speed.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrainSpeed32",
          "filepath": "train--speed/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z"
                }
              }
            ],
            "name": "train--speed",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrainSpeed24",
          "filepath": "train--speed/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z"
                }
              }
            ],
            "name": "train--speed",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrainSpeed20",
          "filepath": "train--speed/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z"
                }
              }
            ],
            "name": "train--speed",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrainSpeed16",
          "filepath": "train--speed/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z"
                }
              }
            ],
            "name": "train--speed",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrainSpeed",
        "global": "TrainSpeed",
        "filepath": "TrainSpeed.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "train--ticket",
      "friendlyName": "Train ticket",
      "aliases": [
        "train",
        "ticket",
        "transportation",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/train--ticket.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z\"/><path d=\"M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z\"/></svg>",
            "info": {},
            "path": "32/train--ticket.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrainTicket32",
          "filepath": "train--ticket/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
                }
              }
            ],
            "name": "train--ticket",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrainTicket24",
          "filepath": "train--ticket/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
                }
              }
            ],
            "name": "train--ticket",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrainTicket20",
          "filepath": "train--ticket/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
                }
              }
            ],
            "name": "train--ticket",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrainTicket16",
          "filepath": "train--ticket/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
                }
              }
            ],
            "name": "train--ticket",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrainTicket",
        "global": "TrainTicket",
        "filepath": "TrainTicket.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "train--time",
      "friendlyName": "Train time",
      "aliases": [
        "train",
        "time",
        "schedule",
        "transportation",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/train--time.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" points=\"25.496 10.088 22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088\"/>\n  <path d=\"M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z\"/><path d=\"M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z\"/><path d=\"M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z\"/></svg>",
            "info": {},
            "path": "32/train--time.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrainTime32",
          "filepath": "train--time/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
                }
              }
            ],
            "name": "train--time",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrainTime24",
          "filepath": "train--time/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
                }
              }
            ],
            "name": "train--time",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrainTime20",
          "filepath": "train--time/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
                }
              }
            ],
            "name": "train--time",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrainTime16",
          "filepath": "train--time/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
                }
              }
            ],
            "name": "train--time",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "TrainTime",
        "global": "TrainTime",
        "filepath": "TrainTime.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tram",
      "friendlyName": "Tram",
      "aliases": [
        "tram",
        "transportation",
        "travel"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tram.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tram</title><path d=\"M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z\"/></svg>",
            "info": {},
            "path": "32/tram.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tram32",
          "filepath": "tram/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
                }
              }
            ],
            "name": "tram",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tram24",
          "filepath": "tram/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
                }
              }
            ],
            "name": "tram",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tram20",
          "filepath": "tram/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
                }
              }
            ],
            "name": "tram",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tram16",
          "filepath": "tram/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
                }
              }
            ],
            "name": "tram",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Tram",
        "global": "Tram",
        "filepath": "Tram.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "transform--binary",
      "friendlyName": "transform--binary",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/transform--binary.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M23,20h-2c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v4C25,19.1,24.1,20,23,20z M21,14v4h2v-4H21z\"/>\n<rect x=\"15\" y=\"12\" width=\"2\" height=\"8\"/>\n<path d=\"M11,20H9c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v4C13,19.1,12.1,20,11,20z M9,14v4h2v-4H9z\"/>\n<path d=\"M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z\"/>\n<path d=\"M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z\"/>\n<path d=\"M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z\"/>\n<path d=\"M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z\"/>\n<path d=\"M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z\"/><path d=\"M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z\"/></svg>",
            "info": {},
            "path": "32/transform--binary.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TransformBinary32",
          "filepath": "transform--binary/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--binary",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TransformBinary24",
          "filepath": "transform--binary/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--binary",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TransformBinary20",
          "filepath": "transform--binary/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--binary",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TransformBinary16",
          "filepath": "transform--binary/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--binary",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TransformBinary",
        "global": "TransformBinary",
        "filepath": "TransformBinary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "transform--instructions",
      "friendlyName": "transform--instructions",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/transform--instructions.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1\n\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\n\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19\n\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z\"/>\n<path d=\"M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z\"/>\n<path d=\"M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z\"/>\n<path d=\"M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z\"/>\n<path d=\"M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z\"/>\n<path d=\"M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z\"/><path d=\"M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z\"/></svg>",
            "info": {},
            "path": "32/transform--instructions.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TransformInstructions32",
          "filepath": "transform--instructions/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--instructions",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TransformInstructions24",
          "filepath": "transform--instructions/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--instructions",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TransformInstructions20",
          "filepath": "transform--instructions/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--instructions",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TransformInstructions16",
          "filepath": "transform--instructions/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4\tl1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19\tc-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--instructions",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TransformInstructions",
        "global": "TransformInstructions",
        "filepath": "TransformInstructions.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "transform--language",
      "friendlyName": "transform--language",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/transform--language.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"10\" y=\"19\" width=\"8\" height=\"2\"/>\n<rect x=\"10\" y=\"15\" width=\"12\" height=\"2\"/>\n<rect x=\"10\" y=\"11\" width=\"12\" height=\"2\"/>\n<path d=\"M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z\"/>\n<path d=\"M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z\"/>\n<path d=\"M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z\"/>\n<path d=\"M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z\"/>\n<path d=\"M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__363_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z\"/><path d=\"M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z\"/></svg>",
            "info": {},
            "path": "32/transform--language.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TransformLanguage32",
          "filepath": "transform--language/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--language",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TransformLanguage24",
          "filepath": "transform--language/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--language",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TransformLanguage20",
          "filepath": "transform--language/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--language",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TransformLanguage16",
          "filepath": "transform--language/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                }
              }
            ],
            "name": "transform--language",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TransformLanguage",
        "global": "TransformLanguage",
        "filepath": "TransformLanguage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "transgender",
      "friendlyName": "Transgender",
      "aliases": [
        "gender",
        "transgender",
        "person",
        "human"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/transgender.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z\"/></svg>",
            "info": {},
            "path": "32/transgender.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Transgender32",
          "filepath": "transgender/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
                }
              }
            ],
            "name": "transgender",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Transgender24",
          "filepath": "transgender/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
                }
              }
            ],
            "name": "transgender",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Transgender20",
          "filepath": "transgender/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
                }
              }
            ],
            "name": "transgender",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Transgender16",
          "filepath": "transgender/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
                }
              }
            ],
            "name": "transgender",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "Transgender",
        "global": "Transgender",
        "filepath": "Transgender.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "translate",
      "friendlyName": "Translate",
      "aliases": [
        "language",
        "localization",
        "interpret"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/translate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>translate</title><path d=\"M27.85,29H30L24,14H21.65l-6,15H17.8l1.6-4h6.85ZM20.2,23l2.62-6.56L25.45,23Z\"/><path d=\"M18,7V5H11V2H9V5H2V7H12.74a14.71,14.71,0,0,1-3.19,6.18A13.5,13.5,0,0,1,7.26,9H5.16a16.47,16.47,0,0,0,3,5.58A16.84,16.84,0,0,1,3,18l.75,1.86A18.47,18.47,0,0,0,9.53,16a16.92,16.92,0,0,0,5.76,3.84L16,18a14.48,14.48,0,0,1-5.12-3.37A17.64,17.64,0,0,0,14.8,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z\"/></svg>",
            "info": {},
            "path": "32/translate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Translate32",
          "filepath": "translate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z"
                }
              }
            ],
            "name": "translate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Translate24",
          "filepath": "translate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z"
                }
              }
            ],
            "name": "translate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Translate20",
          "filepath": "translate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z"
                }
              }
            ],
            "name": "translate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Translate16",
          "filepath": "translate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z"
                }
              }
            ],
            "name": "translate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Translate",
        "global": "Translate",
        "filepath": "Translate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "transmission-lte",
      "friendlyName": "Transmission LTE",
      "aliases": [
        "cellular",
        "communications",
        "tower",
        "transmission",
        "microwave",
        "signal",
        "LTE",
        "wireless",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/transmission-lte.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10.57,30l.9333-2h8.9928l.9333,2h2.2072L17,15.7778V11H15v4.7778L8.3631,30ZM16,18.3647,17.6965,22h-3.393ZM13.37,24h5.26l.9333,2H12.4369Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10.7832,9.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z\"/><path d=\"M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z\"/></svg>",
            "info": {},
            "path": "32/transmission-lte.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TransmissionLte32",
          "filepath": "transmission-lte/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
                }
              }
            ],
            "name": "transmission-lte",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TransmissionLte24",
          "filepath": "transmission-lte/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
                }
              }
            ],
            "name": "transmission-lte",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TransmissionLte20",
          "filepath": "transmission-lte/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
                }
              }
            ],
            "name": "transmission-lte",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TransmissionLte16",
          "filepath": "transmission-lte/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
                }
              }
            ],
            "name": "transmission-lte",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "TransmissionLte",
        "global": "TransmissionLte",
        "filepath": "TransmissionLte.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "transpose",
      "friendlyName": "Transpose",
      "aliases": [
        "operation",
        "transpose"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/transpose.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M19,26H14V24h5a5.0055,5.0055,0,0,0,5-5V14h2v5A7.0078,7.0078,0,0,1,19,26Z\"/>\n  <path d=\"M8,30H4a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H8a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,8,30ZM4,14V28H8V14Z\"/>\n  <path d=\"M28,10H14a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,28,10ZM14,4V8H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z\"/></svg>",
            "info": {},
            "path": "32/transpose.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Transpose32",
          "filepath": "transpose/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z"
                }
              }
            ],
            "name": "transpose",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Transpose24",
          "filepath": "transpose/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z"
                }
              }
            ],
            "name": "transpose",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Transpose20",
          "filepath": "transpose/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z"
                }
              }
            ],
            "name": "transpose",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Transpose16",
          "filepath": "transpose/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z"
                }
              }
            ],
            "name": "transpose",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Transpose",
        "global": "Transpose",
        "filepath": "Transpose.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "trash-can",
      "friendlyName": "Trash can",
      "aliases": [
        "trash",
        "waste",
        "delete",
        "litter",
        "bin",
        "wastebin",
        "destroy",
        "remove"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/trash-can.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>trash-can</title><rect x=\"12\" y=\"12\" width=\"2\" height=\"12\"/><rect x=\"18\" y=\"12\" width=\"2\" height=\"12\"/><path d=\"M4,6V8H6V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8h2V6ZM8,28V8H24V28Z\"/><rect x=\"12\" y=\"2\" width=\"8\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 12H14V24H12zM18 12H20V24H18z\"/><path d=\"M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z\"/></svg>",
            "info": {},
            "path": "32/trash-can.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrashCan32",
          "filepath": "trash-can/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H14V24H12zM18 12H20V24H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
                }
              }
            ],
            "name": "trash-can",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrashCan24",
          "filepath": "trash-can/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H14V24H12zM18 12H20V24H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
                }
              }
            ],
            "name": "trash-can",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrashCan20",
          "filepath": "trash-can/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H14V24H12zM18 12H20V24H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
                }
              }
            ],
            "name": "trash-can",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrashCan16",
          "filepath": "trash-can/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 12H14V24H12zM18 12H20V24H18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
                }
              }
            ],
            "name": "trash-can",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "TrashCan",
        "global": "TrashCan",
        "filepath": "TrashCan.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 12H14V24H12zM18 12H20V24H18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tree",
      "friendlyName": "Tree",
      "aliases": [
        "tree",
        "grow",
        "agriculture"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tree.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tree</title><path d=\"M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z\"/><path d=\"M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z\"/><path d=\"M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z\"/></svg>",
            "info": {},
            "path": "32/tree.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tree32",
          "filepath": "tree/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
                }
              }
            ],
            "name": "tree",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tree24",
          "filepath": "tree/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
                }
              }
            ],
            "name": "tree",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tree20",
          "filepath": "tree/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
                }
              }
            ],
            "name": "tree",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tree16",
          "filepath": "tree/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
                }
              }
            ],
            "name": "tree",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Tree",
        "global": "Tree",
        "filepath": "Tree.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tree--fall-risk",
      "friendlyName": "Tree fall risk",
      "aliases": [
        "tree",
        "danger",
        "caution",
        "risk",
        "fall"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tree--fall-risk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\"/>\n  <path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\"/>\n  <path d=\"M26,19V17H17V28a2.0027,2.0027,0,0,0,2,2h3V28H19V19Z\"/>\n  <path d=\"M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0024,2.0024,0,0,1,12,30Z\"/>\n  <path d=\"M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\" data-icon-path=\"inner-path\"/><path d=\"M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z\"/><path d=\"M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z\"/></svg>",
            "info": {},
            "path": "32/tree--fall-risk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TreeFallRisk32",
          "filepath": "tree--fall-risk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
                }
              }
            ],
            "name": "tree--fall-risk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TreeFallRisk24",
          "filepath": "tree--fall-risk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
                }
              }
            ],
            "name": "tree--fall-risk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TreeFallRisk20",
          "filepath": "tree--fall-risk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
                }
              }
            ],
            "name": "tree--fall-risk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TreeFallRisk16",
          "filepath": "tree--fall-risk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
                }
              }
            ],
            "name": "tree--fall-risk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TreeFallRisk",
        "global": "TreeFallRisk",
        "filepath": "TreeFallRisk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tree-view",
      "friendlyName": "Tree view",
      "aliases": [
        "flow chart",
        "data analytics",
        "chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tree-view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tree-view</title><path d=\"M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z\"/></svg>",
            "info": {},
            "path": "32/tree-view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TreeView32",
          "filepath": "tree-view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
                }
              }
            ],
            "name": "tree-view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TreeView24",
          "filepath": "tree-view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
                }
              }
            ],
            "name": "tree-view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TreeView20",
          "filepath": "tree-view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
                }
              }
            ],
            "name": "tree-view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TreeView16",
          "filepath": "tree-view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
                }
              }
            ],
            "name": "tree-view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TreeView",
        "global": "TreeView",
        "filepath": "TreeView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tree-view--alt",
      "friendlyName": "Tree view alt",
      "aliases": [
        "flow chart",
        "data analytics",
        "chart"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tree-view--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tree-view--alt</title><path d=\"M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z\" transform=\"translate(0 0.0049)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z\" transform=\"translate(0 .005)\"/></svg>",
            "info": {},
            "path": "32/tree-view--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TreeViewAlt32",
          "filepath": "tree-view--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "tree-view--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TreeViewAlt24",
          "filepath": "tree-view--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "tree-view--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TreeViewAlt20",
          "filepath": "tree-view--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "tree-view--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TreeViewAlt16",
          "filepath": "tree-view--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
                  "transform": "translate(0 .005)"
                }
              }
            ],
            "name": "tree-view--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TreeViewAlt",
        "global": "TreeViewAlt",
        "filepath": "TreeViewAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
                    "transform": "translate(0 .005)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "trophy",
      "friendlyName": "Trophy",
      "aliases": [
        "trophy",
        "award",
        "sports",
        "champion",
        "winner"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/trophy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>trophy</title><path d=\"M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z\"/></svg>",
            "info": {},
            "path": "32/trophy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Trophy32",
          "filepath": "trophy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Trophy24",
          "filepath": "trophy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Trophy20",
          "filepath": "trophy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Trophy16",
          "filepath": "trophy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Trophy",
        "global": "Trophy",
        "filepath": "Trophy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "trophy--filled",
      "friendlyName": "Trophy filled",
      "aliases": [
        "trophy",
        "award",
        "sports",
        "champion",
        "winner"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/trophy--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>trophy--filled</title><path d=\"M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z\"/></svg>",
            "info": {},
            "path": "32/trophy--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TrophyFilled32",
          "filepath": "trophy--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TrophyFilled24",
          "filepath": "trophy--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TrophyFilled20",
          "filepath": "trophy--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TrophyFilled16",
          "filepath": "trophy--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                }
              }
            ],
            "name": "trophy--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "TrophyFilled",
        "global": "TrophyFilled",
        "filepath": "TrophyFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tropical-storm",
      "friendlyName": "Tropical storm",
      "aliases": [
        "tropical storm",
        "precipitation",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tropical-storm.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>tropical-storm</title><path d=\"M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z\"/><path d=\"M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z\"/><path d=\"M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z\"/></svg>",
            "info": {},
            "path": "32/tropical-storm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TropicalStorm32",
          "filepath": "tropical-storm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "tropical-storm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TropicalStorm24",
          "filepath": "tropical-storm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "tropical-storm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TropicalStorm20",
          "filepath": "tropical-storm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "tropical-storm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TropicalStorm16",
          "filepath": "tropical-storm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                }
              }
            ],
            "name": "tropical-storm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TropicalStorm",
        "global": "TropicalStorm",
        "filepath": "TropicalStorm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tropical-storm--model-tracks",
      "friendlyName": "Tropical storm model tracks",
      "aliases": [
        "tropical storm",
        "precipitation",
        "model",
        "weather",
        "tracks",
        "storm"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tropical-storm--model-tracks.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14.8188,6.65c.1163-.1211,1.8643-1.919,2.8882-2.9434A1,1,0,0,0,17,2C11.812,2,2,4.2988,2,13a7.8938,7.8938,0,0,0,3.1812,6.35c-.1612.1675-1.9507,2.0054-2.8882,2.9429A1,1,0,0,0,3,24c5.188,0,15-2.2988,15-11A7.8927,7.8927,0,0,0,14.8188,6.65ZM9.7065,20.793a20.94,20.94,0,0,1-4.0932.9853c.1621-.166,2.7685-2.9053,2.7685-2.9053l-1.1743-.6074A5.9064,5.9064,0,0,1,4,13c0-3.667,2.1177-6.2886,6.2935-7.793a20.94,20.94,0,0,1,4.0932-.9853c-.227.2324-2.769,2.9057-2.769,2.9057l1.1748.607A5.9075,5.9075,0,0,1,16,13C16,16.667,13.8823,19.2886,9.7065,20.793Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,17l-5-5-5,5,1.4126,1.4155L24,15.8325V19a9.01,9.01,0,0,1-9,9H12v2h3A11.0125,11.0125,0,0,0,26,19V15.8325l2.5859,2.5816Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z\"/><path d=\"M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z\"/></svg>",
            "info": {},
            "path": "32/tropical-storm--model-tracks.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TropicalStormModelTracks32",
          "filepath": "tropical-storm--model-tracks/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z"
                }
              }
            ],
            "name": "tropical-storm--model-tracks",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TropicalStormModelTracks24",
          "filepath": "tropical-storm--model-tracks/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z"
                }
              }
            ],
            "name": "tropical-storm--model-tracks",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TropicalStormModelTracks20",
          "filepath": "tropical-storm--model-tracks/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z"
                }
              }
            ],
            "name": "tropical-storm--model-tracks",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TropicalStormModelTracks16",
          "filepath": "tropical-storm--model-tracks/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z"
                }
              }
            ],
            "name": "tropical-storm--model-tracks",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TropicalStormModelTracks",
        "global": "TropicalStormModelTracks",
        "filepath": "TropicalStormModelTracks.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tropical-storm--tracks",
      "friendlyName": "tropical-storm--tracks",
      "aliases": [
        "tropical storm",
        "precipitation",
        "model",
        "weather",
        "tracks",
        "storm"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tropical-storm--tracks.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z\"/><path d=\"M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z\"/></svg>",
            "info": {},
            "path": "32/tropical-storm--tracks.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TropicalStormTracks32",
          "filepath": "tropical-storm--tracks/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
                }
              }
            ],
            "name": "tropical-storm--tracks",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TropicalStormTracks24",
          "filepath": "tropical-storm--tracks/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
                }
              }
            ],
            "name": "tropical-storm--tracks",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TropicalStormTracks20",
          "filepath": "tropical-storm--tracks/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
                }
              }
            ],
            "name": "tropical-storm--tracks",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TropicalStormTracks16",
          "filepath": "tropical-storm--tracks/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
                }
              }
            ],
            "name": "tropical-storm--tracks",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TropicalStormTracks",
        "global": "TropicalStormTracks",
        "filepath": "TropicalStormTracks.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tropical-warning",
      "friendlyName": "Tropical warning",
      "aliases": [
        "tropical warning",
        "precipitation",
        "warning",
        "weather",
        "storm"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tropical-warning.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z\" transform=\"translate(0 0)\"/>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z\"/><path fill=\"none\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\"/><path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\"/></svg>",
            "info": {},
            "path": "32/tropical-warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TropicalWarning32",
          "filepath": "tropical-warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tropical-warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TropicalWarning24",
          "filepath": "tropical-warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tropical-warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TropicalWarning20",
          "filepath": "tropical-warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tropical-warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TropicalWarning16",
          "filepath": "tropical-warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "tropical-warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "TropicalWarning",
        "global": "TropicalWarning",
        "filepath": "TropicalWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tsq",
      "friendlyName": "tsq",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tsq.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"19\" y=\"26\" width=\"11\" height=\"2\"/>\n  <rect x=\"19\" y=\"22\" width=\"11\" height=\"2\"/>\n  <path d=\"M30,20h-11V12h11v8Zm-9-2h7v-4h-7v4Z\"/>\n  <rect x=\"19\" y=\"8\" width=\"11\" height=\"2\"/>\n  <rect x=\"19\" y=\"4\" width=\"11\" height=\"2\"/>\n  <polygon points=\"10.293 18.707 8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707\"/>\n  <path d=\"M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z\"/><path d=\"M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z\"/></svg>",
            "info": {},
            "path": "32/tsq.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tsq32",
          "filepath": "tsq/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
                }
              }
            ],
            "name": "tsq",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tsq24",
          "filepath": "tsq/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
                }
              }
            ],
            "name": "tsq",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tsq20",
          "filepath": "tsq/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
                }
              }
            ],
            "name": "tsq",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tsq16",
          "filepath": "tsq/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
                }
              }
            ],
            "name": "tsq",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Tsq",
        "global": "Tsq",
        "filepath": "Tsq.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "tsunami",
      "friendlyName": "Tsunami",
      "aliases": [
        "weather",
        "forecast",
        "storm",
        "tropical storm",
        "wave"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/tsunami.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z\"/></svg>",
            "info": {},
            "path": "32/tsunami.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tsunami32",
          "filepath": "tsunami/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
                }
              }
            ],
            "name": "tsunami",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tsunami24",
          "filepath": "tsunami/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
                }
              }
            ],
            "name": "tsunami",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tsunami20",
          "filepath": "tsunami/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
                }
              }
            ],
            "name": "tsunami",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tsunami16",
          "filepath": "tsunami/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
                }
              }
            ],
            "name": "tsunami",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Tsunami",
        "global": "Tsunami",
        "filepath": "Tsunami.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "TSV",
      "friendlyName": "TSV",
      "aliases": [
        "format",
        "data",
        "database",
        "spreadsheet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/TSV.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>TSV</title><polygon points=\"28 9 26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9\"/><path d=\"M18,23H12V21h6V17H14a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H14v4h4a2.002,2.002,0,0,1,2,2v4A2.002,2.002,0,0,1,18,23Z\"/><polygon points=\"2 11 5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z\"/></svg>",
            "info": {},
            "path": "32/TSV.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Tsv32",
          "filepath": "TSV/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TSV",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Tsv24",
          "filepath": "TSV/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TSV",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Tsv20",
          "filepath": "TSV/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TSV",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Tsv16",
          "filepath": "TSV/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                }
              }
            ],
            "name": "TSV",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Tsv",
        "global": "Tsv",
        "filepath": "Tsv.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "two-factor-authentication",
      "friendlyName": "Two-factor authentication",
      "aliases": [
        "2FA",
        "two factor",
        "authentication",
        "ID",
        "identity",
        "security",
        "password",
        "access"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/two-factor-authentication.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"11 23.18 9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18\"/>\n  <path d=\"M28,30H24V28h4V16H24V8a4.0045,4.0045,0,0,0-4-4V2a6.0067,6.0067,0,0,1,6,6v6h2a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z\"/><path d=\"M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z\"/></svg>",
            "info": {},
            "path": "32/two-factor-authentication.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TwoFactorAuthentication32",
          "filepath": "two-factor-authentication/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
                }
              }
            ],
            "name": "two-factor-authentication",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TwoFactorAuthentication24",
          "filepath": "two-factor-authentication/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
                }
              }
            ],
            "name": "two-factor-authentication",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TwoFactorAuthentication20",
          "filepath": "two-factor-authentication/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
                }
              }
            ],
            "name": "two-factor-authentication",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TwoFactorAuthentication16",
          "filepath": "two-factor-authentication/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
                }
              }
            ],
            "name": "two-factor-authentication",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "TwoFactorAuthentication",
        "global": "TwoFactorAuthentication",
        "filepath": "TwoFactorAuthentication.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "two-person-lift",
      "friendlyName": "Two-person lift",
      "aliases": [
        "two person lift",
        "packaging",
        "handling",
        "commerce"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/two-person-lift.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26.96,30l-1.9215-6.7253a1.0008,1.0008,0,0,1,.3369-1.0554L29.874,18.62,28.52,13.2014l-2.7382,3.4234A1.0026,1.0026,0,0,1,25,17H20V15h4.52l3.6993-4.6248a1,1,0,0,1,1.7509.3824l2,8a.9989.9989,0,0,1-.3447,1.0232l-4.48,3.5845,1.7389,6.0854Z\"/>\n  <path d=\"M23,5.5A3.5,3.5,0,1,1,26.5,9,3.5042,3.5042,0,0,1,23,5.5Zm2,0A1.5,1.5,0,1,0,26.5,4,1.5017,1.5017,0,0,0,25,5.5Z\"/>\n  <path d=\"M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z\"/>\n  <path d=\"M5.04,30l1.9215-6.7253a1.0013,1.0013,0,0,0-.3369-1.0555L2.126,18.62l1.3545-5.4185,2.7382,3.4234A1.0026,1.0026,0,0,0,7,17h5V15H7.4805L3.7812,10.3752a1,1,0,0,0-1.7509.3824l-2,8A.9989.9989,0,0,0,.375,19.7808l4.4805,3.5844-1.739,6.0855Z\"/>\n  <path d=\"M5.5,9A3.5,3.5,0,1,1,9,5.5,3.5042,3.5042,0,0,1,5.5,9Zm0-5A1.5,1.5,0,1,0,7,5.5,1.5017,1.5017,0,0,0,5.5,4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z\"/><path d=\"M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z\"/><path d=\"M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z\"/></svg>",
            "info": {},
            "path": "32/two-person-lift.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TwoPersonLift32",
          "filepath": "two-person-lift/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z"
                }
              }
            ],
            "name": "two-person-lift",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TwoPersonLift24",
          "filepath": "two-person-lift/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z"
                }
              }
            ],
            "name": "two-person-lift",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TwoPersonLift20",
          "filepath": "two-person-lift/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z"
                }
              }
            ],
            "name": "two-person-lift",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TwoPersonLift16",
          "filepath": "two-person-lift/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z"
                }
              }
            ],
            "name": "two-person-lift",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "TwoPersonLift",
        "global": "TwoPersonLift",
        "filepath": "TwoPersonLift.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "TXT",
      "friendlyName": "TXT",
      "aliases": [
        "text",
        "format",
        "string"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/TXT.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>TXT</title><polygon points=\"21 11 24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11\"/><polygon points=\"20 9 18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9\"/><polygon points=\"3 11 6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z\"/></svg>",
            "info": {},
            "path": "32/TXT.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Txt32",
          "filepath": "TXT/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
                }
              }
            ],
            "name": "TXT",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Txt24",
          "filepath": "TXT/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
                }
              }
            ],
            "name": "TXT",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Txt20",
          "filepath": "TXT/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
                }
              }
            ],
            "name": "TXT",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Txt16",
          "filepath": "TXT/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
                }
              }
            ],
            "name": "TXT",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Txt",
        "global": "Txt",
        "filepath": "Txt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "TXT--reference",
      "friendlyName": "TXT reference",
      "aliases": [
        "TXT reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/TXT--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <polygon points=\"21 4 24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4\"/>\n  <polygon points=\"20 2 18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2\"/>\n  <polygon points=\"3 4 6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z\"/></svg>",
            "info": {},
            "path": "32/TXT--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TxtReference32",
          "filepath": "TXT--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
                }
              }
            ],
            "name": "TXT--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TxtReference24",
          "filepath": "TXT--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
                }
              }
            ],
            "name": "TXT--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TxtReference20",
          "filepath": "TXT--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
                }
              }
            ],
            "name": "TXT--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TxtReference16",
          "filepath": "TXT--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
                }
              }
            ],
            "name": "TXT--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "TxtReference",
        "global": "TxtReference",
        "filepath": "TxtReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "type-pattern",
      "friendlyName": "Type pattern",
      "aliases": [
        "type-pattern"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/type-pattern.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>type-pattern</title><polygon points=\"30 15 17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15\"/><polygon points=\"25.586 20 27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20\"/><path d=\"M11,30H3a1,1,0,0,1-.8945-1.4473l4-8a1.0412,1.0412,0,0,1,1.789,0l4,8A1,1,0,0,1,11,30ZM4.6182,28H9.3818L7,23.2363Z\"/><path d=\"M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6.001L28,4Z\"/><path d=\"M7,12a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,12ZM7,4a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z\"/><path d=\"M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z\"/></svg>",
            "info": {},
            "path": "32/type-pattern.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "TypePattern32",
          "filepath": "type-pattern/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z"
                }
              }
            ],
            "name": "type-pattern",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "TypePattern24",
          "filepath": "type-pattern/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z"
                }
              }
            ],
            "name": "type-pattern",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "TypePattern20",
          "filepath": "type-pattern/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z"
                }
              }
            ],
            "name": "type-pattern",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "TypePattern16",
          "filepath": "type-pattern/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z"
                }
              }
            ],
            "name": "type-pattern",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "TypePattern",
        "global": "TypePattern",
        "filepath": "TypePattern.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "types",
      "friendlyName": "Types",
      "aliases": [
        "types"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/types.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>types</title><polygon points=\"30 16 22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16\"/><path d=\"M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z\"/><polygon points=\"2 16 10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z\"/><path d=\"M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z\"/><path d=\"M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z\"/></svg>",
            "info": {},
            "path": "32/types.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Types32",
          "filepath": "types/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
                }
              }
            ],
            "name": "types",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Types24",
          "filepath": "types/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
                }
              }
            ],
            "name": "types",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Types20",
          "filepath": "types/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
                }
              }
            ],
            "name": "types",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Types16",
          "filepath": "types/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
                }
              }
            ],
            "name": "types",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "Types",
        "global": "Types",
        "filepath": "Types.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "U1",
      "friendlyName": "U1",
      "aliases": [
        "Q"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/U1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--U1</title><path d=\"M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z\"/><polygon points=\"22 21 22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z\"/></svg>",
            "info": {},
            "path": "32/Q/U1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QU132",
          "filepath": "Q/U1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
                }
              }
            ],
            "name": "U1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QU124",
          "filepath": "Q/U1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
                }
              }
            ],
            "name": "U1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QU120",
          "filepath": "Q/U1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
                }
              }
            ],
            "name": "U1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QU116",
          "filepath": "Q/U1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
                }
              }
            ],
            "name": "U1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "U1",
        "global": "QU1",
        "filepath": "Q/U1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "U2",
      "friendlyName": "U2",
      "aliases": [
        "Q"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/U2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--U2</title><path d=\"M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z\"/><path d=\"M25,23H17V17a2,2,0,0,1,2-2h4V11H17V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H19v4h6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z\"/></svg>",
            "info": {},
            "path": "32/Q/U2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QU232",
          "filepath": "Q/U2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z"
                }
              }
            ],
            "name": "U2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QU224",
          "filepath": "Q/U2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z"
                }
              }
            ],
            "name": "U2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QU220",
          "filepath": "Q/U2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z"
                }
              }
            ],
            "name": "U2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QU216",
          "filepath": "Q/U2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z"
                }
              }
            ],
            "name": "U2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "U2",
        "global": "QU2",
        "filepath": "Q/U2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "U3",
      "friendlyName": "U3",
      "aliases": [
        "Q"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/U3.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--U3</title><path d=\"M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z\"/><path d=\"M23,9H17v2h6v4H18v2h5v4H17v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,23,9Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z\"/></svg>",
            "info": {},
            "path": "32/Q/U3.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QU332",
          "filepath": "Q/U3/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z"
                }
              }
            ],
            "name": "U3",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QU324",
          "filepath": "Q/U3/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z"
                }
              }
            ],
            "name": "U3",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QU320",
          "filepath": "Q/U3/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z"
                }
              }
            ],
            "name": "U3",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QU316",
          "filepath": "Q/U3/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z"
                }
              }
            ],
            "name": "U3",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "U3",
        "global": "QU3",
        "filepath": "Q/U3.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "umbrella",
      "friendlyName": "Umbrella",
      "aliases": [
        "protection",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/umbrella.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>umbrella</title>\n  <path d=\"M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z\"/></svg>",
            "info": {},
            "path": "32/umbrella.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Umbrella32",
          "filepath": "umbrella/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
                }
              }
            ],
            "name": "umbrella",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Umbrella24",
          "filepath": "umbrella/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
                }
              }
            ],
            "name": "umbrella",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Umbrella20",
          "filepath": "umbrella/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
                }
              }
            ],
            "name": "umbrella",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Umbrella16",
          "filepath": "umbrella/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
                }
              }
            ],
            "name": "umbrella",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Instruments",
      "moduleInfo": {
        "local": "Umbrella",
        "global": "Umbrella",
        "filepath": "Umbrella.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "undefined",
      "friendlyName": "Undefined",
      "aliases": [
        "undefined"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/undefined.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<rect x=\"11\" y=\"14\" width=\"10\" height=\"4\"/>\n<path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\n\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\n\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__00000047043459972075101980000012870844918251172286_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M11 14H21V18H11z\"/><path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z\"/></svg>",
            "info": {},
            "path": "32/undefined.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Undefined32",
          "filepath": "undefined/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 14H21V18H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "undefined",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Undefined24",
          "filepath": "undefined/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 14H21V18H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "undefined",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Undefined20",
          "filepath": "undefined/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 14H21V18H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "undefined",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Undefined16",
          "filepath": "undefined/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 14H21V18H11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "undefined",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Undefined",
        "global": "Undefined",
        "filepath": "Undefined.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 14H21V18H11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "undefined--filled",
      "friendlyName": "Undefined filled",
      "aliases": [
        "undefined filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/undefined--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\n\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\n\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z\"/>\n<rect id=\"inner-path\" x=\"11\" y=\"14\" class=\"st0\" width=\"10\" height=\"4\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__00000047043459972075101980000012870844918251172286_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z\"/><path fill=\"none\" d=\"M11 14H21V18H11z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/undefined--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UndefinedFilled32",
          "filepath": "undefined--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11 14H21V18H11z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "undefined--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UndefinedFilled24",
          "filepath": "undefined--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11 14H21V18H11z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "undefined--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UndefinedFilled20",
          "filepath": "undefined--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11 14H21V18H11z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "undefined--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UndefinedFilled16",
          "filepath": "undefined--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M11 14H21V18H11z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "undefined--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "UndefinedFilled",
        "global": "UndefinedFilled",
        "filepath": "UndefinedFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M11 14H21V18H11z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "undo",
      "friendlyName": "Undo",
      "aliases": [
        "go back",
        "revert",
        "back"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/undo.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n  .cls-1{fill:none;}\n</style>\n<path id=\"_x31_6_px_4_\" d=\"M12,8c1.2,0,2,0.8,2,2c0,1.2-0.8,2-2,2H9v1h3c1.7,0,3-1.2,3-3c0-1.7-1.3-3-3-3L2.9,7l2-2L4.2,4.3L1,7.5\n\tl3.2,3.2L4.9,10l-2-2L12,8z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12,8c1.2,0,2,0.8,2,2c0,1.2-0.8,2-2,2H9v1h3c1.7,0,3-1.2,3-3c0-1.7-1.3-3-3-3L2.9,7l2-2L4.2,4.3L1,7.5\tl3.2,3.2L4.9,10l-2-2L12,8z\"/></svg>",
            "info": {},
            "path": "16/undo.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/undo.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:#F3F3F3;}\n\t.st1{fill:#F9E4C2;}\n\t.st2{fill:#C1D7FB;}\n  .cls-1{fill:none;}\n</style>\n<path id=\"_x32_0_px_2_\" d=\"M15,9.3c1.5,0,2.8,1.3,2.8,2.7c0,1.5-1.3,2.7-2.8,2.7h-4V16h4c2.3,0,4-1.7,4-4c0-2.2-1.8-4-4-4H3.4\n\tl2.5-2.5L5,4.6l-4,4l4,4l0.9-0.9L3.4,9.3H15z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"20\" height=\"20\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M15,9.3c1.5,0,2.8,1.3,2.8,2.7c0,1.5-1.3,2.7-2.8,2.7h-4V16h4c2.3,0,4-1.7,4-4c0-2.2-1.8-4-4-4H3.4\tl2.5-2.5L5,4.6l-4,4l4,4l0.9-0.9L3.4,9.3H15z\"/></svg>",
            "info": {},
            "path": "20/undo.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/undo.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n  .cls-1{fill:none;}\n</style>\n<path id=\"_x32_4_px\" d=\"M17.2,11.2c1.8,0,3.2,1.7,3.2,3.3c0,1.5-1.5,3.2-3.2,3.2H14v1.5h3.2c2.2,0,4.8-2.3,4.8-4.8s-2-4.8-4.8-4.8\n\tH4.8l3-3L6.8,5.7L2,10.5l4.8,4.8l1.1-1.1l-3-3H17.2z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"24\" height=\"24\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M17.2,11.2c1.8,0,3.2,1.7,3.2,3.3c0,1.5-1.5,3.2-3.2,3.2H14v1.5h3.2c2.2,0,4.8-2.3,4.8-4.8s-2-4.8-4.8-4.8\tH4.8l3-3L6.8,5.7L2,10.5l4.8,4.8l1.1-1.1l-3-3H17.2z\"/></svg>",
            "info": {},
            "path": "24/undo.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/undo.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z\"/></svg>",
            "info": {},
            "path": "32/undo.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Undo32",
          "filepath": "undo/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z"
                }
              }
            ],
            "name": "undo",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Undo24",
          "filepath": "undo/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.2,11.2c1.8,0,3.2,1.7,3.2,3.3c0,1.5-1.5,3.2-3.2,3.2H14v1.5h3.2c2.2,0,4.8-2.3,4.8-4.8s-2-4.8-4.8-4.8\tH4.8l3-3L6.8,5.7L2,10.5l4.8,4.8l1.1-1.1l-3-3H17.2z"
                }
              }
            ],
            "name": "undo",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Undo20",
          "filepath": "undo/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15,9.3c1.5,0,2.8,1.3,2.8,2.7c0,1.5-1.3,2.7-2.8,2.7h-4V16h4c2.3,0,4-1.7,4-4c0-2.2-1.8-4-4-4H3.4\tl2.5-2.5L5,4.6l-4,4l4,4l0.9-0.9L3.4,9.3H15z"
                }
              }
            ],
            "name": "undo",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Undo16",
          "filepath": "undo/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,8c1.2,0,2,0.8,2,2c0,1.2-0.8,2-2,2H9v1h3c1.7,0,3-1.2,3-3c0-1.7-1.3-3-3-3L2.9,7l2-2L4.2,4.3L1,7.5\tl3.2,3.2L4.9,10l-2-2L12,8z"
                }
              }
            ],
            "name": "undo",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Undo",
        "global": "Undo",
        "filepath": "Undo.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,8c1.2,0,2,0.8,2,2c0,1.2-0.8,2-2,2H9v1h3c1.7,0,3-1.2,3-3c0-1.7-1.3-3-3-3L2.9,7l2-2L4.2,4.3L1,7.5 l3.2,3.2L4.9,10l-2-2L12,8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15,9.3c1.5,0,2.8,1.3,2.8,2.7c0,1.5-1.3,2.7-2.8,2.7h-4V16h4c2.3,0,4-1.7,4-4c0-2.2-1.8-4-4-4H3.4 l2.5-2.5L5,4.6l-4,4l4,4l0.9-0.9L3.4,9.3H15z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.2,11.2c1.8,0,3.2,1.7,3.2,3.3c0,1.5-1.5,3.2-3.2,3.2H14v1.5h3.2c2.2,0,4.8-2.3,4.8-4.8s-2-4.8-4.8-4.8 H4.8l3-3L6.8,5.7L2,10.5l4.8,4.8l1.1-1.1l-3-3H17.2z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ungroup-objects",
      "friendlyName": "Ungroup objects",
      "aliases": [
        "formatting",
        "objects",
        "ungroup",
        "separate"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ungroup-objects.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z\"/></svg>",
            "info": {},
            "path": "32/ungroup-objects.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UngroupObjects32",
          "filepath": "ungroup-objects/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
                }
              }
            ],
            "name": "ungroup-objects",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UngroupObjects24",
          "filepath": "ungroup-objects/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
                }
              }
            ],
            "name": "ungroup-objects",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UngroupObjects20",
          "filepath": "ungroup-objects/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
                }
              }
            ],
            "name": "ungroup-objects",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UngroupObjects16",
          "filepath": "ungroup-objects/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
                }
              }
            ],
            "name": "ungroup-objects",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "UngroupObjects",
        "global": "UngroupObjects",
        "filepath": "UngroupObjects.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "unknown",
      "friendlyName": "Unknown",
      "aliases": [
        "unknown"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/unknown.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<circle cx=\"16\" cy=\"22.5\" r=\"1.5\"/>\n<path d=\"M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2\n\tc2.206,0,4,1.794,4,4s-1.794,4-4,4V19z\"/>\n<path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\n\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\n\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__00000047043459972075101980000012870844918251172286_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"22.5\" r=\"1.5\"/><path d=\"M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2\tc2.206,0,4,1.794,4,4s-1.794,4-4,4V19z\"/><path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z\"/></svg>",
            "info": {},
            "path": "32/unknown.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Unknown32",
          "filepath": "unknown/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2\tc2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "unknown",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Unknown24",
          "filepath": "unknown/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2\tc2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "unknown",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Unknown20",
          "filepath": "unknown/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2\tc2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "unknown",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Unknown16",
          "filepath": "unknown/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "22.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2\tc2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527\tC2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609\tl11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                }
              }
            ],
            "name": "unknown",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Unknown",
        "global": "Unknown",
        "filepath": "Unknown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "22.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2 c2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "unknown--filled",
      "friendlyName": "Unknown filled",
      "aliases": [
        "unknown filled"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/unknown--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\n\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\n\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5\n\tS16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2\n\tc-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125\n\tC21.125,15.358,19.342,17.182,17.125,17.248z\"/>\n<path id=\"inner-path\" class=\"st0\" d=\"M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21\n\tz M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5\n\tc0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__00000047043459972075101980000012870844918251172286_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5\tS16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2\tc-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125\tC21.125,15.358,19.342,17.182,17.125,17.248z\"/><path fill=\"none\" d=\"M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21\tz M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5\tc0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/unknown--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UnknownFilled32",
          "filepath": "unknown--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5\tS16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2\tc-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125\tC21.125,15.358,19.342,17.182,17.125,17.248z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21\tz M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5\tc0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "unknown--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UnknownFilled24",
          "filepath": "unknown--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5\tS16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2\tc-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125\tC21.125,15.358,19.342,17.182,17.125,17.248z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21\tz M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5\tc0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "unknown--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UnknownFilled20",
          "filepath": "unknown--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5\tS16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2\tc-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125\tC21.125,15.358,19.342,17.182,17.125,17.248z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21\tz M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5\tc0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "unknown--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UnknownFilled16",
          "filepath": "unknown--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16\ts0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917\tC29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5\tS16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2\tc-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125\tC21.125,15.358,19.342,17.182,17.125,17.248z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21\tz M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5\tc0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "unknown--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "UnknownFilled",
        "global": "UnknownFilled",
        "filepath": "UnknownFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5 S16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2 c-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125 C21.125,15.358,19.342,17.182,17.125,17.248z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21 z M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5 c0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "unlink",
      "friendlyName": "Unlink",
      "aliases": [
        "detach",
        "break"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/unlink.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>unlink</title><rect x=\"5\" y=\"3.59\" width=\"2\" height=\"4.83\" transform=\"translate(-2.49 6) rotate(-45.01)\"/><rect x=\"25\" y=\"23.58\" width=\"2\" height=\"4.83\" transform=\"translate(-10.77 25.99) rotate(-44.99)\"/><rect x=\"11\" y=\"2\" width=\"2\" height=\"4\"/><rect x=\"2\" y=\"11\" width=\"4\" height=\"2\"/><rect x=\"26\" y=\"19\" width=\"4\" height=\"2\"/><rect x=\"19\" y=\"26\" width=\"2\" height=\"4\"/><path d=\"M16.58,21.07l-3.71,3.72a4,4,0,1,1-5.66-5.66l3.72-3.72L9.51,14,5.8,17.72a6,6,0,0,0-.06,8.54A6,6,0,0,0,10,28a6.07,6.07,0,0,0,4.32-1.8L18,22.49Z\"/><path d=\"M15.41,10.93l3.72-3.72a4,4,0,1,1,5.66,5.66l-3.72,3.72L22.49,18l3.71-3.72a6,6,0,0,0,.06-8.54A6,6,0,0,0,22,4a6.07,6.07,0,0,0-4.32,1.8L14,9.51Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5 3.59H7V8.42H5z\" transform=\"rotate(-45.01 5.996 6.005)\"/><path d=\"M25 23.58H27V28.409999999999997H25z\" transform=\"rotate(-44.99 25.995 25.999)\"/><path d=\"M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z\"/></svg>",
            "info": {},
            "path": "32/unlink.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Unlink32",
          "filepath": "unlink/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 3.59H7V8.42H5z",
                  "transform": "rotate(-45.01 5.996 6.005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23.58H27V28.409999999999997H25z",
                  "transform": "rotate(-44.99 25.995 25.999)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z"
                }
              }
            ],
            "name": "unlink",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Unlink24",
          "filepath": "unlink/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 3.59H7V8.42H5z",
                  "transform": "rotate(-45.01 5.996 6.005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23.58H27V28.409999999999997H25z",
                  "transform": "rotate(-44.99 25.995 25.999)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z"
                }
              }
            ],
            "name": "unlink",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Unlink20",
          "filepath": "unlink/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 3.59H7V8.42H5z",
                  "transform": "rotate(-45.01 5.996 6.005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23.58H27V28.409999999999997H25z",
                  "transform": "rotate(-44.99 25.995 25.999)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z"
                }
              }
            ],
            "name": "unlink",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Unlink16",
          "filepath": "unlink/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5 3.59H7V8.42H5z",
                  "transform": "rotate(-45.01 5.996 6.005)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23.58H27V28.409999999999997H25z",
                  "transform": "rotate(-44.99 25.995 25.999)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z"
                }
              }
            ],
            "name": "unlink",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Unlink",
        "global": "Unlink",
        "filepath": "Unlink.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5 3.59H7V8.42H5z",
                    "transform": "rotate(-45.01 5.996 6.005)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 23.58H27V28.409999999999997H25z",
                    "transform": "rotate(-44.99 25.995 25.999)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "unlocked",
      "friendlyName": "Unlocked",
      "aliases": [
        "open",
        "lock",
        "opened"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/unlocked.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>unlocked</title>\n<path d=\"M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1\n\tV8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1\tV8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z\"/></svg>",
            "info": {},
            "path": "16/unlocked.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/unlocked.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>unlocked</title><path d=\"M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z\"/></svg>",
            "info": {},
            "path": "32/unlocked.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Unlocked32",
          "filepath": "unlocked/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
                }
              }
            ],
            "name": "unlocked",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Unlocked24",
          "filepath": "unlocked/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
                }
              }
            ],
            "name": "unlocked",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Unlocked20",
          "filepath": "unlocked/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
                }
              }
            ],
            "name": "unlocked",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Unlocked16",
          "filepath": "unlocked/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1\tV8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z"
                }
              }
            ],
            "name": "unlocked",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Unlocked",
        "global": "Unlocked",
        "filepath": "Unlocked.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1 V8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "unsaved",
      "friendlyName": "unsaved",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/unsaved.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<polygon points=\"30,19.4 28.6,18 25,21.6 21.4,18 20,19.4 23.6,23 20,26.6 21.4,28 25,24.4 28.6,28 30,26.6 26.4,23 \"/>\n<path d=\"M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6\n\tc0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z\"/>\n<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z\"/><path d=\"M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6\tc0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z\"/></svg>",
            "info": {},
            "path": "32/unsaved.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Unsaved32",
          "filepath": "unsaved/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6\tc0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
                }
              }
            ],
            "name": "unsaved",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Unsaved24",
          "filepath": "unsaved/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6\tc0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
                }
              }
            ],
            "name": "unsaved",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Unsaved20",
          "filepath": "unsaved/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6\tc0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
                }
              }
            ],
            "name": "unsaved",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Unsaved16",
          "filepath": "unsaved/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6\tc0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
                }
              }
            ],
            "name": "unsaved",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "Unsaved",
        "global": "Unsaved",
        "filepath": "Unsaved.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6 c0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "up-to-top",
      "friendlyName": "Up to top",
      "aliases": [
        "top",
        "top of page",
        "page up",
        "up chevron",
        "up"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/up-to-top.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 24.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>up-to-top</title>\n<polygon points=\"16,14 6,24 7.4,25.4 16,16.8 24.6,25.4 26,24 \"/>\n<rect x=\"4\" y=\"8\" width=\"24\" height=\"2\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z\"/></svg>",
            "info": {},
            "path": "32/up-to-top.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UpToTop32",
          "filepath": "up-to-top/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z"
                }
              }
            ],
            "name": "up-to-top",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UpToTop24",
          "filepath": "up-to-top/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z"
                }
              }
            ],
            "name": "up-to-top",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UpToTop20",
          "filepath": "up-to-top/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z"
                }
              }
            ],
            "name": "up-to-top",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UpToTop16",
          "filepath": "up-to-top/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z"
                }
              }
            ],
            "name": "up-to-top",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "UpToTop",
        "global": "UpToTop",
        "filepath": "UpToTop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "update-now",
      "friendlyName": "Update now",
      "aliases": [
        "operations",
        "update",
        "clock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/update-now.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"27 25.586 25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586\"/>\n  <path d=\"M24,31a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,24,31Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,24,19Z\"/>\n  <path d=\"M16,28A12.0134,12.0134,0,0,1,4,16H2A14.0158,14.0158,0,0,0,16,30Z\"/>\n  <path d=\"M12,8H7.0784A11.9843,11.9843,0,0,1,28,16h2A13.9778,13.9778,0,0,0,6,6.2344V2H4v8h8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z\"/><path d=\"M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z\"/></svg>",
            "info": {},
            "path": "32/update-now.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UpdateNow32",
          "filepath": "update-now/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z"
                }
              }
            ],
            "name": "update-now",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UpdateNow24",
          "filepath": "update-now/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z"
                }
              }
            ],
            "name": "update-now",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UpdateNow20",
          "filepath": "update-now/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z"
                }
              }
            ],
            "name": "update-now",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UpdateNow16",
          "filepath": "update-now/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z"
                }
              }
            ],
            "name": "update-now",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "UpdateNow",
        "global": "UpdateNow",
        "filepath": "UpdateNow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "upgrade",
      "friendlyName": "Upgrade",
      "aliases": [
        "up",
        "improve"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/upgrade.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>upgrade</title>\n  <path d=\"M21,24H11a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V26A2,2,0,0,0,21,24Zm0,4H11V26H21Z\"/>\n  <path d=\"M28.707,14.293l-12-12a.9994.9994,0,0,0-1.414,0l-12,12A1,1,0,0,0,4,16H9v4a2.0023,2.0023,0,0,0,2,2H21a2.0027,2.0027,0,0,0,2-2V16h5a1,1,0,0,0,.707-1.707ZM21,14v6H11V14H6.4141L16,4.4141,25.5859,14Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z\"/></svg>",
            "info": {},
            "path": "32/upgrade.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Upgrade32",
          "filepath": "upgrade/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z"
                }
              }
            ],
            "name": "upgrade",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Upgrade24",
          "filepath": "upgrade/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z"
                }
              }
            ],
            "name": "upgrade",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Upgrade20",
          "filepath": "upgrade/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z"
                }
              }
            ],
            "name": "upgrade",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Upgrade16",
          "filepath": "upgrade/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z"
                }
              }
            ],
            "name": "upgrade",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "Upgrade",
        "global": "Upgrade",
        "filepath": "Upgrade.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "upload",
      "friendlyName": "Upload",
      "aliases": [
        "transfer",
        "connect",
        "exchange",
        "send",
        "sync",
        "transmit",
        "load"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/upload.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>upload</title>\n<polygon points=\"3,9 3.7,9.7 7.5,5.9 7.5,15 8.5,15 8.5,5.9 12.3,9.7 13,9 8,4 \"/>\n<path d=\"M3,4V2h10v2h1V2c0-0.6-0.4-1-1-1H3C2.4,1,2,1.4,2,2v2H3z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4zM3 4V2h10v2h1V2c0-.6-.4-1-1-1H3C2.4 1 2 1.4 2 2v2H3z\"/></svg>",
            "info": {},
            "path": "16/upload.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/upload.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"6 18 7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18\"/>\n  <path d=\"M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18zM6 8V4H26V8h2V4a2 2 0 00-2-2H6A2 2 0 004 4V8z\"/></svg>",
            "info": {},
            "path": "32/upload.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Upload32",
          "filepath": "upload/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18zM6 8V4H26V8h2V4a2 2 0 00-2-2H6A2 2 0 004 4V8z"
                }
              }
            ],
            "name": "upload",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Upload24",
          "filepath": "upload/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18zM6 8V4H26V8h2V4a2 2 0 00-2-2H6A2 2 0 004 4V8z"
                }
              }
            ],
            "name": "upload",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Upload20",
          "filepath": "upload/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18zM6 8V4H26V8h2V4a2 2 0 00-2-2H6A2 2 0 004 4V8z"
                }
              }
            ],
            "name": "upload",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Upload16",
          "filepath": "upload/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4zM3 4V2h10v2h1V2c0-.6-.4-1-1-1H3C2.4 1 2 1.4 2 2v2H3z"
                }
              }
            ],
            "name": "upload",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Upload",
        "global": "Upload",
        "filepath": "Upload.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4zM3 4V2h10v2h1V2c0-.6-.4-1-1-1H3C2.4 1 2 1.4 2 2v2H3z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18zM6 8V4H26V8h2V4a2 2 0 00-2-2H6A2 2 0 004 4V8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "USB",
      "friendlyName": "USB",
      "aliases": [
        "connector",
        "protocol",
        "connection",
        "bus",
        "port"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/USB.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>USB</title><path d=\"M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z\" transform=\"translate(0 0)\"/><rect x=\"12\" y=\"10\" width=\"3\" height=\"2\"/><rect x=\"17\" y=\"10\" width=\"3\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z\"/><path d=\"M12 10H15V12H12zM17 10H20V12H17z\"/></svg>",
            "info": {},
            "path": "32/USB.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Usb32",
          "filepath": "USB/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H15V12H12zM17 10H20V12H17z"
                }
              }
            ],
            "name": "USB",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Usb24",
          "filepath": "USB/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H15V12H12zM17 10H20V12H17z"
                }
              }
            ],
            "name": "USB",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Usb20",
          "filepath": "USB/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H15V12H12zM17 10H20V12H17z"
                }
              }
            ],
            "name": "USB",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Usb16",
          "filepath": "USB/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 10H15V12H12zM17 10H20V12H17z"
                }
              }
            ],
            "name": "USB",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Usb",
        "global": "Usb",
        "filepath": "Usb.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 10H15V12H12zM17 10H20V12H17z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user",
      "friendlyName": "User",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/user.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>user</title>\n<path d=\"M8,2c1.4,0,2.5,1.1,2.5,2.5S9.4,7,8,7S5.5,5.9,5.5,4.5S6.6,2,8,2 M8,1C6.1,1,4.5,2.6,4.5,4.5S6.1,8,8,8s3.5-1.6,3.5-3.5\n\tS9.9,1,8,1z\"/>\n<path d=\"M13,15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1,10,4,11.1,4,12.5V15H3v-2.5C3,10.6,4.6,9,6.5,9h3c1.9,0,3.5,1.6,3.5,3.5V15z\"\n\t/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8 2c1.4 0 2.5 1.1 2.5 2.5S9.4 7 8 7 5.5 5.9 5.5 4.5 6.6 2 8 2M8 1C6.1 1 4.5 2.6 4.5 4.5S6.1 8 8 8s3.5-1.6 3.5-3.5S9.9 1 8 1zM13 15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1 10 4 11.1 4 12.5V15H3v-2.5C3 10.6 4.6 9 6.5 9h3c1.9 0 3.5 1.6 3.5 3.5V15z\"/></svg>",
            "info": {},
            "path": "16/user.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/user.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user</title><path d=\"M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z\"/><path d=\"M26,30H24V25a5,5,0,0,0-5-5H13a5,5,0,0,0-5,5v5H6V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z\"/></svg>",
            "info": {},
            "path": "32/user.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "User32",
          "filepath": "user/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "user",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "User24",
          "filepath": "user/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "user",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "User20",
          "filepath": "user/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "user",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "User16",
          "filepath": "user/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 2c1.4 0 2.5 1.1 2.5 2.5S9.4 7 8 7 5.5 5.9 5.5 4.5 6.6 2 8 2M8 1C6.1 1 4.5 2.6 4.5 4.5S6.1 8 8 8s3.5-1.6 3.5-3.5S9.9 1 8 1zM13 15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1 10 4 11.1 4 12.5V15H3v-2.5C3 10.6 4.6 9 6.5 9h3c1.9 0 3.5 1.6 3.5 3.5V15z"
                }
              }
            ],
            "name": "user",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "User",
        "global": "User",
        "filepath": "User.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 2c1.4 0 2.5 1.1 2.5 2.5S9.4 7 8 7 5.5 5.9 5.5 4.5 6.6 2 8 2M8 1C6.1 1 4.5 2.6 4.5 4.5S6.1 8 8 8s3.5-1.6 3.5-3.5S9.9 1 8 1zM13 15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1 10 4 11.1 4 12.5V15H3v-2.5C3 10.6 4.6 9 6.5 9h3c1.9 0 3.5 1.6 3.5 3.5V15z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--access",
      "friendlyName": "User access",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account",
        "access"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--access.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\"/>\n  <path d=\"M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z\"/>\n  <path d=\"M30,12a1.9922,1.9922,0,0,0-.5117.0742L28.4331,11.019a3.8788,3.8788,0,0,0,0-4.038l1.0552-1.0552a2.0339,2.0339,0,1,0-1.4141-1.4141L27.019,5.5669a3.8788,3.8788,0,0,0-4.038,0L21.9258,4.5117a2.0339,2.0339,0,1,0-1.4141,1.4141L21.5669,6.981a3.8788,3.8788,0,0,0,0,4.038l-1.0552,1.0552a2.0339,2.0339,0,1,0,1.4141,1.4141l1.0552-1.0552a3.8788,3.8788,0,0,0,4.038,0l1.0552,1.0552A1.9957,1.9957,0,1,0,30,12ZM23,9a2,2,0,1,1,2,2A2.0025,2.0025,0,0,1,23,9Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z\"/></svg>",
            "info": {},
            "path": "32/user--access.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserAccess32",
          "filepath": "user--access/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z"
                }
              }
            ],
            "name": "user--access",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserAccess24",
          "filepath": "user--access/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z"
                }
              }
            ],
            "name": "user--access",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserAccess20",
          "filepath": "user--access/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z"
                }
              }
            ],
            "name": "user--access",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserAccess16",
          "filepath": "user--access/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z"
                }
              }
            ],
            "name": "user--access",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserAccess",
        "global": "UserAccess",
        "filepath": "UserAccess.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--activity",
      "friendlyName": "User activity",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--activity.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--activity</title><path d=\"M25,23h-.0215a1.0016,1.0016,0,0,1-.94-.7256L20.8711,11.19l-1.9346,5.1607A1.0005,1.0005,0,0,1,18,17H14V15h3.3066l2.7569-7.3511a1.0005,1.0005,0,0,1,1.8984.0762l3.1113,10.8921,1.9786-5.9336A.9988.9988,0,0,1,28,12h4v2H28.7207l-2.7725,8.3164A.9984.9984,0,0,1,25,23Z\" transform=\"translate(0 0)\"/><path d=\"M15,30H13V23a3.0033,3.0033,0,0,0-3-3H6a3.0033,3.0033,0,0,0-3,3v7H1V23a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/><path d=\"M8,8a3,3,0,1,1-3,3A3,3,0,0,1,8,8M8,6a5,5,0,1,0,5,5A5,5,0,0,0,8,6Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z\"/></svg>",
            "info": {},
            "path": "32/user--activity.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserActivity32",
          "filepath": "user--activity/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z"
                }
              }
            ],
            "name": "user--activity",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserActivity24",
          "filepath": "user--activity/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z"
                }
              }
            ],
            "name": "user--activity",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserActivity20",
          "filepath": "user--activity/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z"
                }
              }
            ],
            "name": "user--activity",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserActivity16",
          "filepath": "user--activity/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z"
                }
              }
            ],
            "name": "user--activity",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserActivity",
        "global": "UserActivity",
        "filepath": "UserActivity.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--admin",
      "friendlyName": "User admin",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--admin.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--admin</title><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\" transform=\"translate(0 0)\"/><path d=\"M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\" transform=\"translate(0 0)\"/><polygon points=\"25 16.18 22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z\"/></svg>",
            "info": {},
            "path": "32/user--admin.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserAdmin32",
          "filepath": "user--admin/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
                }
              }
            ],
            "name": "user--admin",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserAdmin24",
          "filepath": "user--admin/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
                }
              }
            ],
            "name": "user--admin",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserAdmin20",
          "filepath": "user--admin/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
                }
              }
            ],
            "name": "user--admin",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserAdmin16",
          "filepath": "user--admin/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
                }
              }
            ],
            "name": "user--admin",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserAdmin",
        "global": "UserAdmin",
        "filepath": "UserAdmin.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--avatar",
      "friendlyName": "User avatar",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/user--avatar.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>user--avatar</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5\n\tC9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5\n\ts6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z\"/>\n<path d=\"M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5\n\tS8.8,7,8,7z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5\tC9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5\ts6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z\"/><path d=\"M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5\tS8.8,7,8,7z\"/></svg>",
            "info": {},
            "path": "16/user--avatar.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/user--avatar.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z\"/>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z\"/></svg>",
            "info": {},
            "path": "32/user--avatar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserAvatar32",
          "filepath": "user--avatar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                }
              }
            ],
            "name": "user--avatar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserAvatar24",
          "filepath": "user--avatar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                }
              }
            ],
            "name": "user--avatar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserAvatar20",
          "filepath": "user--avatar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                }
              }
            ],
            "name": "user--avatar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserAvatar16",
          "filepath": "user--avatar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5\tC9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5\ts6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5\tS8.8,7,8,7z"
                }
              }
            ],
            "name": "user--avatar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserAvatar",
        "global": "UserAvatar",
        "filepath": "UserAvatar.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5 C9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5 s6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5 S8.8,7,8,7z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--avatar--filled",
      "friendlyName": "User avatar filled",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--avatar--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z\"/>\n  <path d=\"M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z\"/><path d=\"M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z\"/></svg>",
            "info": {},
            "path": "32/user--avatar--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserAvatarFilled32",
          "filepath": "user--avatar--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
                }
              }
            ],
            "name": "user--avatar--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserAvatarFilled24",
          "filepath": "user--avatar--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
                }
              }
            ],
            "name": "user--avatar--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserAvatarFilled20",
          "filepath": "user--avatar--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
                }
              }
            ],
            "name": "user--avatar--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserAvatarFilled16",
          "filepath": "user--avatar--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
                }
              }
            ],
            "name": "user--avatar--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserAvatarFilled",
        "global": "UserAvatarFilled",
        "filepath": "UserAvatarFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--avatar--filled--alt",
      "friendlyName": "User avatar filled alt",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--avatar--filled--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z\"/><path d=\"M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z\"/></svg>",
            "info": {},
            "path": "32/user--avatar--filled--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserAvatarFilledAlt32",
          "filepath": "user--avatar--filled--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                }
              }
            ],
            "name": "user--avatar--filled--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserAvatarFilledAlt24",
          "filepath": "user--avatar--filled--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                }
              }
            ],
            "name": "user--avatar--filled--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserAvatarFilledAlt20",
          "filepath": "user--avatar--filled--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                }
              }
            ],
            "name": "user--avatar--filled--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserAvatarFilledAlt16",
          "filepath": "user--avatar--filled--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                }
              }
            ],
            "name": "user--avatar--filled--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserAvatarFilledAlt",
        "global": "UserAvatarFilledAlt",
        "filepath": "UserAvatarFilledAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--certification",
      "friendlyName": "User certification",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--certification.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--certification</title><polygon points=\"25 10 26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10\"/><path d=\"M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z\"/></svg>",
            "info": {},
            "path": "32/user--certification.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserCertification32",
          "filepath": "user--certification/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--certification",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserCertification24",
          "filepath": "user--certification/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--certification",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserCertification20",
          "filepath": "user--certification/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--certification",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserCertification16",
          "filepath": "user--certification/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--certification",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserCertification",
        "global": "UserCertification",
        "filepath": "UserCertification.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--data",
      "friendlyName": "User data",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--data.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--data</title><rect x=\"28\" y=\"8\" width=\"2\" height=\"8\"/><rect x=\"23\" y=\"5\" width=\"2\" height=\"11\"/><rect x=\"18\" y=\"10\" width=\"2\" height=\"6\"/><path d=\"M16,30H14V24a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v6H2V24a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/><path d=\"M9,9a3,3,0,1,1-3,3A3,3,0,0,1,9,9M9,7a5,5,0,1,0,5,5A5,5,0,0,0,9,7Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z\"/></svg>",
            "info": {},
            "path": "32/user--data.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserData32",
          "filepath": "user--data/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z"
                }
              }
            ],
            "name": "user--data",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserData24",
          "filepath": "user--data/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z"
                }
              }
            ],
            "name": "user--data",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserData20",
          "filepath": "user--data/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z"
                }
              }
            ],
            "name": "user--data",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserData16",
          "filepath": "user--data/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z"
                }
              }
            ],
            "name": "user--data",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserData",
        "global": "UserData",
        "filepath": "UserData.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--favorite",
      "friendlyName": "User favorite",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--favorite.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--favorite</title><path d=\"M27.303,12a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L25.0019,21l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,27.303,12Z\" transform=\"translate(0 0)\"/><path d=\"M2,30H4V25a5.0059,5.0059,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v5h2V25a7.0082,7.0082,0,0,0-7-7H9a7.0082,7.0082,0,0,0-7,7Z\" transform=\"translate(0 0)\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z\"/></svg>",
            "info": {},
            "path": "32/user--favorite.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserFavorite32",
          "filepath": "user--favorite/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--favorite",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserFavorite24",
          "filepath": "user--favorite/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--favorite",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserFavorite20",
          "filepath": "user--favorite/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--favorite",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserFavorite16",
          "filepath": "user--favorite/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--favorite",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserFavorite",
        "global": "UserFavorite",
        "filepath": "UserFavorite.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--favorite--alt",
      "friendlyName": "User favorite alt",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--favorite--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--favorite--alt</title><path d=\"M28.7663,4.2558A4.2121,4.2121,0,0,0,23,4.0321a4.2121,4.2121,0,0,0-5.7663.2237,4.319,4.319,0,0,0,0,6.0447L22.998,16.14,23,16.1376l.002.0019,5.7643-5.839A4.319,4.319,0,0,0,28.7663,4.2558ZM27.342,8.8948l-4.34,4.3973L23,13.29l-.002.002-4.34-4.3973a2.3085,2.3085,0,0,1,0-3.2338,2.2639,2.2639,0,0,1,3.1561,0l1.181,1.2074L23,6.8634l.0049.005,1.181-1.2074a2.2639,2.2639,0,0,1,3.1561,0A2.3085,2.3085,0,0,1,27.342,8.8948Z\" transform=\"translate(0 0)\"/><path d=\"M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/><path d=\"M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z\"/></svg>",
            "info": {},
            "path": "32/user--favorite--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserFavoriteAlt32",
          "filepath": "user--favorite--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserFavoriteAlt24",
          "filepath": "user--favorite--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserFavoriteAlt20",
          "filepath": "user--favorite--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserFavoriteAlt16",
          "filepath": "user--favorite--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserFavoriteAlt",
        "global": "UserFavoriteAlt",
        "filepath": "UserFavoriteAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--favorite--alt--filled",
      "friendlyName": "User favorite alt filled",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--favorite--alt--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--favorite--alt--filled</title><path d=\"M26.4938,3a3.4735,3.4735,0,0,0-2.48,1.0393l-.5111.5228-.5161-.5228a3.4792,3.4792,0,0,0-4.96,0,3.59,3.59,0,0,0,0,5.0251l5.4766,5.5427,5.4716-5.5427a3.59,3.59,0,0,0,0-5.0251A3.4738,3.4738,0,0,0,26.4938,3Z\" transform=\"translate(0 0)\"/><path d=\"M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/><path d=\"M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z\"/></svg>",
            "info": {},
            "path": "32/user--favorite--alt--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserFavoriteAltFilled32",
          "filepath": "user--favorite--alt--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserFavoriteAltFilled24",
          "filepath": "user--favorite--alt--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserFavoriteAltFilled20",
          "filepath": "user--favorite--alt--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserFavoriteAltFilled16",
          "filepath": "user--favorite--alt--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--favorite--alt--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserFavoriteAltFilled",
        "global": "UserFavoriteAltFilled",
        "filepath": "UserFavoriteAltFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--filled",
      "friendlyName": "User filled",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--filled</title><path d=\"M6,30H26V25a7.0082,7.0082,0,0,0-7-7H13a7.0082,7.0082,0,0,0-7,7Z\" transform=\"translate(0 0)\"/><path d=\"M9,9a7,7,0,1,0,7-7A7,7,0,0,0,9,9Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z\"/></svg>",
            "info": {},
            "path": "32/user--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserFilled32",
          "filepath": "user--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z"
                }
              }
            ],
            "name": "user--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserFilled24",
          "filepath": "user--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z"
                }
              }
            ],
            "name": "user--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserFilled20",
          "filepath": "user--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z"
                }
              }
            ],
            "name": "user--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserFilled16",
          "filepath": "user--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z"
                }
              }
            ],
            "name": "user--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserFilled",
        "global": "UserFilled",
        "filepath": "UserFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--follow",
      "friendlyName": "User follow",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--follow.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--follow</title><polygon points=\"32 14 28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\" transform=\"translate(0 0)\"/><path d=\"M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z\"/></svg>",
            "info": {},
            "path": "32/user--follow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserFollow32",
          "filepath": "user--follow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "user--follow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserFollow24",
          "filepath": "user--follow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "user--follow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserFollow20",
          "filepath": "user--follow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "user--follow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserFollow16",
          "filepath": "user--follow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                }
              }
            ],
            "name": "user--follow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserFollow",
        "global": "UserFollow",
        "filepath": "UserFollow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--identification",
      "friendlyName": "User identification",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--identification.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--identification</title><path d=\"M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z\"/><circle cx=\"24\" cy=\"8\" r=\"2\"/><path d=\"M30,18H18a2.0023,2.0023,0,0,1-2-2V4a2.002,2.002,0,0,1,2-2H30a2.0023,2.0023,0,0,1,2,2V16A2.0027,2.0027,0,0,1,30,18ZM18,4V16H30.001L30,4Z\" transform=\"translate(0 0)\"/><path d=\"M15,30H13V26a2.9465,2.9465,0,0,0-3-3H6a2.9465,2.9465,0,0,0-3,3v4H1V26a4.9514,4.9514,0,0,1,5-5h4a4.9514,4.9514,0,0,1,5,5Z\" transform=\"translate(0 0)\"/><path d=\"M8,11a3,3,0,0,1,0,6,3,3,0,0,1,0-6M8,9A5,5,0,0,0,8,19,5,5,0,0,0,8,9Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z\"/><circle cx=\"24\" cy=\"8\" r=\"2\"/><path d=\"M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z\"/></svg>",
            "info": {},
            "path": "32/user--identification.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserIdentification32",
          "filepath": "user--identification/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--identification",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserIdentification24",
          "filepath": "user--identification/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--identification",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserIdentification20",
          "filepath": "user--identification/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--identification",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserIdentification16",
          "filepath": "user--identification/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "8",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--identification",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserIdentification",
        "global": "UserIdentification",
        "filepath": "UserIdentification.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "8",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--military",
      "friendlyName": "user--military",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "rank",
        "military"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--military.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"25 13 23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13\"/>\n  <polygon points=\"21.414 13.414 25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414\"/>\n  <polygon points=\"21.414 8.414 25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414\"/>\n  <path d=\"M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z\"/><path d=\"M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z\"/><path d=\"M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z\"/></svg>",
            "info": {},
            "path": "32/user--military.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserMilitary32",
          "filepath": "user--military/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--military",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserMilitary24",
          "filepath": "user--military/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--military",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserMilitary20",
          "filepath": "user--military/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--military",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserMilitary16",
          "filepath": "user--military/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--military",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserMilitary",
        "global": "UserMilitary",
        "filepath": "UserMilitary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--multiple",
      "friendlyName": "User multiple",
      "aliases": [
        "users",
        "people"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--multiple.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>user--multiple</title>\n  <path d=\"M30,30H28V25a5.0057,5.0057,0,0,0-5-5V18a7.0078,7.0078,0,0,1,7,7Z\"/>\n  <path d=\"M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z\"/>\n  <path d=\"M20,2V4a5,5,0,0,1,0,10v2A7,7,0,0,0,20,2Z\"/>\n  <path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z\"/></svg>",
            "info": {},
            "path": "32/user--multiple.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserMultiple32",
          "filepath": "user--multiple/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--multiple",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserMultiple24",
          "filepath": "user--multiple/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--multiple",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserMultiple20",
          "filepath": "user--multiple/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--multiple",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserMultiple16",
          "filepath": "user--multiple/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--multiple",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserMultiple",
        "global": "UserMultiple",
        "filepath": "UserMultiple.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--online",
      "friendlyName": "User online",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--online.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--online</title><circle cx=\"26\" cy=\"16\" r=\"4\"/><path d=\"M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\" transform=\"translate(0)\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"26\" cy=\"16\" r=\"4\"/><path d=\"M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z\"/></svg>",
            "info": {},
            "path": "32/user--online.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserOnline32",
          "filepath": "user--online/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--online",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserOnline24",
          "filepath": "user--online/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--online",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserOnline20",
          "filepath": "user--online/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--online",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserOnline16",
          "filepath": "user--online/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "26",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--online",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserOnline",
        "global": "UserOnline",
        "filepath": "UserOnline.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "26",
                    "cy": "16",
                    "r": "4"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--profile",
      "friendlyName": "User profile",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--profile.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--profile</title><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\"/><path d=\"M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\"/><rect x=\"22\" y=\"4\" width=\"10\" height=\"2\"/><rect x=\"22\" y=\"9\" width=\"10\" height=\"2\"/><rect x=\"22\" y=\"14\" width=\"7\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z\"/></svg>",
            "info": {},
            "path": "32/user--profile.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserProfile32",
          "filepath": "user--profile/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z"
                }
              }
            ],
            "name": "user--profile",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserProfile24",
          "filepath": "user--profile/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z"
                }
              }
            ],
            "name": "user--profile",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserProfile20",
          "filepath": "user--profile/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z"
                }
              }
            ],
            "name": "user--profile",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserProfile16",
          "filepath": "user--profile/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z"
                }
              }
            ],
            "name": "user--profile",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserProfile",
        "global": "UserProfile",
        "filepath": "UserProfile.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--role",
      "friendlyName": "User role",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--role.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--role</title><polygon points=\"28.07 21 22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21\"/><path d=\"M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z\"/></svg>",
            "info": {},
            "path": "32/user--role.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserRole32",
          "filepath": "user--role/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--role",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserRole24",
          "filepath": "user--role/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--role",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserRole20",
          "filepath": "user--role/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--role",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserRole16",
          "filepath": "user--role/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                }
              }
            ],
            "name": "user--role",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserRole",
        "global": "UserRole",
        "filepath": "UserRole.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--service-desk",
      "friendlyName": "User service desk",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "service desk",
        "customer service",
        "phone"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--service-desk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.334,11.95l1.2055-1.206a1.178,1.178,0,0,1,1.2593-.2584l1.4693.5868A1.1736,1.1736,0,0,1,30,12.1489v2.692A1.1681,1.1681,0,0,1,28.8229,16l-.05-.0015C18.4775,15.3578,16.4,6.6357,16.0073,3.2976a1.1681,1.1681,0,0,1,1.0315-1.29A1.1492,1.1492,0,0,1,17.1751,2h2.5994a1.1626,1.1626,0,0,1,1.0764.7322l.5866,1.47a1.1635,1.1635,0,0,1-.2529,1.26L19.9791,6.668S20.6733,11.3682,25.334,11.95Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z\"/></svg>",
            "info": {},
            "path": "32/user--service-desk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserServiceDesk32",
          "filepath": "user--service-desk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--service-desk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserServiceDesk24",
          "filepath": "user--service-desk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--service-desk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserServiceDesk20",
          "filepath": "user--service-desk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--service-desk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserServiceDesk16",
          "filepath": "user--service-desk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--service-desk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserServiceDesk",
        "global": "UserServiceDesk",
        "filepath": "UserServiceDesk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--settings",
      "friendlyName": "User settings",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "settings",
        "preferences",
        "gear"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--settings.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z\"/></svg>",
            "info": {},
            "path": "32/user--settings.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserSettings32",
          "filepath": "user--settings/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--settings",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserSettings24",
          "filepath": "user--settings/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--settings",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserSettings20",
          "filepath": "user--settings/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--settings",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserSettings16",
          "filepath": "user--settings/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                }
              }
            ],
            "name": "user--settings",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserSettings",
        "global": "UserSettings",
        "filepath": "UserSettings.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--simulation",
      "friendlyName": "User simulation",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--simulation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--simulation</title><rect x=\"25.2321\" y=\"12.866\" width=\"4\" height=\"2\" transform=\"translate(10.5814 -11.7583) rotate(30)\"/><rect x=\"26\" y=\"8\" width=\"4\" height=\"2\"/><rect x=\"2.7679\" y=\"12.866\" width=\"4\" height=\"2\" transform=\"translate(15.8301 23.4904) rotate(150)\"/><path d=\"M26,30H24V25a5.0059,5.0059,0,0,0-5-5H13a5.0059,5.0059,0,0,0-5,5v5H6V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z\"/><path d=\"M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z\"/><rect x=\"25.2321\" y=\"3.134\" width=\"4\" height=\"2\" transform=\"translate(1.5814 14.1699) rotate(-30)\"/><rect x=\"2\" y=\"8\" width=\"4\" height=\"2\"/><rect x=\"2.7679\" y=\"3.134\" width=\"4\" height=\"2\" transform=\"translate(6.8301 10.0981) rotate(-150)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.232 12.866H29.232V14.866H25.232z\" transform=\"rotate(30 27.232 13.866)\"/><path d=\"M26 8H30V10H26z\"/><path d=\"M2.768 12.866H6.768V14.866H2.768z\" transform=\"rotate(150 4.768 13.866)\"/><path d=\"M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z\"/><path d=\"M25.232 3.134H29.232V5.134H25.232z\" transform=\"rotate(-30 27.232 4.134)\"/><path d=\"M2 8H6V10H2z\"/><path d=\"M2.768 3.134H6.768V5.134H2.768z\" transform=\"rotate(-150 4.768 4.134)\"/></svg>",
            "info": {},
            "path": "32/user--simulation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserSimulation32",
          "filepath": "user--simulation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 12.866H29.232V14.866H25.232z",
                  "transform": "rotate(30 27.232 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8H30V10H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 12.866H6.768V14.866H2.768z",
                  "transform": "rotate(150 4.768 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 3.134H29.232V5.134H25.232z",
                  "transform": "rotate(-30 27.232 4.134)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 8H6V10H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 3.134H6.768V5.134H2.768z",
                  "transform": "rotate(-150 4.768 4.134)"
                }
              }
            ],
            "name": "user--simulation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserSimulation24",
          "filepath": "user--simulation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 12.866H29.232V14.866H25.232z",
                  "transform": "rotate(30 27.232 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8H30V10H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 12.866H6.768V14.866H2.768z",
                  "transform": "rotate(150 4.768 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 3.134H29.232V5.134H25.232z",
                  "transform": "rotate(-30 27.232 4.134)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 8H6V10H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 3.134H6.768V5.134H2.768z",
                  "transform": "rotate(-150 4.768 4.134)"
                }
              }
            ],
            "name": "user--simulation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserSimulation20",
          "filepath": "user--simulation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 12.866H29.232V14.866H25.232z",
                  "transform": "rotate(30 27.232 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8H30V10H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 12.866H6.768V14.866H2.768z",
                  "transform": "rotate(150 4.768 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 3.134H29.232V5.134H25.232z",
                  "transform": "rotate(-30 27.232 4.134)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 8H6V10H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 3.134H6.768V5.134H2.768z",
                  "transform": "rotate(-150 4.768 4.134)"
                }
              }
            ],
            "name": "user--simulation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserSimulation16",
          "filepath": "user--simulation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 12.866H29.232V14.866H25.232z",
                  "transform": "rotate(30 27.232 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 8H30V10H26z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 12.866H6.768V14.866H2.768z",
                  "transform": "rotate(150 4.768 13.866)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.232 3.134H29.232V5.134H25.232z",
                  "transform": "rotate(-30 27.232 4.134)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2 8H6V10H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.768 3.134H6.768V5.134H2.768z",
                  "transform": "rotate(-150 4.768 4.134)"
                }
              }
            ],
            "name": "user--simulation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserSimulation",
        "global": "UserSimulation",
        "filepath": "UserSimulation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.232 12.866H29.232V14.866H25.232z",
                    "transform": "rotate(30 27.232 13.866)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 8H30V10H26z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.768 12.866H6.768V14.866H2.768z",
                    "transform": "rotate(150 4.768 13.866)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.232 3.134H29.232V5.134H25.232z",
                    "transform": "rotate(-30 27.232 4.134)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2 8H6V10H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.768 3.134H6.768V5.134H2.768z",
                    "transform": "rotate(-150 4.768 4.134)"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--speaker",
      "friendlyName": "User speaker",
      "aliases": [
        "presenter"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--speaker.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--speaker</title><path d=\"M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z\"/><path d=\"M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z\"/></svg>",
            "info": {},
            "path": "32/user--speaker.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserSpeaker32",
          "filepath": "user--speaker/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
                }
              }
            ],
            "name": "user--speaker",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserSpeaker24",
          "filepath": "user--speaker/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
                }
              }
            ],
            "name": "user--speaker",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserSpeaker20",
          "filepath": "user--speaker/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
                }
              }
            ],
            "name": "user--speaker",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserSpeaker16",
          "filepath": "user--speaker/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
                }
              }
            ],
            "name": "user--speaker",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserSpeaker",
        "global": "UserSpeaker",
        "filepath": "UserSpeaker.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user--x-ray",
      "friendlyName": "User x-ray",
      "aliases": [
        "person",
        "avatar",
        "man",
        "woman",
        "figure",
        "profile",
        "account",
        "my account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user--x-ray.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user--x-ray</title><polygon class=\"cls-1\" points=\"28 9 28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9\"/><path d=\"M31,3H17a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V4A1,1,0,0,0,31,3ZM28,9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3Z\" transform=\"translate(0 0)\"/><path d=\"M15,30H13V26a2.9465,2.9465,0,0,0-3-3H6a2.9465,2.9465,0,0,0-3,3v4H1V26a4.9514,4.9514,0,0,1,5-5h4a4.9514,4.9514,0,0,1,5,5Z\" transform=\"translate(0 0)\"/><path d=\"M8,11a3,3,0,0,1,0,6,3,3,0,0,1,0-6M8,9A5,5,0,0,0,8,19,5,5,0,0,0,8,9Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z\"/><path d=\"M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z\"/></svg>",
            "info": {},
            "path": "32/user--x-ray.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserXRay32",
          "filepath": "user--x-ray/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--x-ray",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserXRay24",
          "filepath": "user--x-ray/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--x-ray",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserXRay20",
          "filepath": "user--x-ray/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--x-ray",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserXRay16",
          "filepath": "user--x-ray/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                }
              }
            ],
            "name": "user--x-ray",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserXRay",
        "global": "UserXRay",
        "filepath": "UserXRay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "user-profile--alt",
      "friendlyName": "User profile alt",
      "aliases": [
        "person",
        "account"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/user-profile--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>user-profile--alt</title><rect x=\"19\" y=\"13\" width=\"7\" height=\"2\"/><rect x=\"19\" y=\"8\" width=\"11\" height=\"2\"/><rect x=\"19\" y=\"3\" width=\"11\" height=\"2\"/><path d=\"M11,30H7a2.0059,2.0059,0,0,1-2-2V21a2.0059,2.0059,0,0,1-2-2V13a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,11,30ZM6,12a.9448.9448,0,0,0-1,1v6H7v9h4V19h2V13a.9448.9448,0,0,0-1-1Z\" transform=\"translate(0 0)\"/><path d=\"M9,9a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,9,9ZM9,3a2,2,0,1,0,2,2h0A2.0059,2.0059,0,0,0,9,3Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z\"/></svg>",
            "info": {},
            "path": "32/user-profile--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UserProfileAlt32",
          "filepath": "user-profile--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z"
                }
              }
            ],
            "name": "user-profile--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UserProfileAlt24",
          "filepath": "user-profile--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z"
                }
              }
            ],
            "name": "user-profile--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UserProfileAlt20",
          "filepath": "user-profile--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z"
                }
              }
            ],
            "name": "user-profile--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UserProfileAlt16",
          "filepath": "user-profile--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z"
                }
              }
            ],
            "name": "user-profile--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "UserProfileAlt",
        "global": "UserProfileAlt",
        "filepath": "UserProfileAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "uv-index",
      "friendlyName": "UV index",
      "aliases": [
        "sun exposure",
        "uv",
        "index",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/uv-index.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>uv-index</title>\n  <path d=\"M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z\"/></svg>",
            "info": {},
            "path": "32/uv-index.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UvIndex32",
          "filepath": "uv-index/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
                }
              }
            ],
            "name": "uv-index",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UvIndex24",
          "filepath": "uv-index/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
                }
              }
            ],
            "name": "uv-index",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UvIndex20",
          "filepath": "uv-index/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
                }
              }
            ],
            "name": "uv-index",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UvIndex16",
          "filepath": "uv-index/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
                }
              }
            ],
            "name": "uv-index",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "UvIndex",
        "global": "UvIndex",
        "filepath": "UvIndex.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "uv-index--alt",
      "friendlyName": "UV index alt",
      "aliases": [
        "uv",
        "index",
        "sun exposure",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/uv-index--alt.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M13,30H9a2.0027,2.0027,0,0,1-2-2V20H9v8h4V20h2v8A2.0027,2.0027,0,0,1,13,30Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"25 20 23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20\"/>\n  <rect x=\"15\" y=\"2\" width=\"2\" height=\"5\"/>\n  <rect x=\"21.6675\" y=\"6.8536\" width=\"4.958\" height=\"1.9998\" transform=\"translate(1.5191 19.3744) rotate(-45)\"/>\n  <rect x=\"25\" y=\"15\" width=\"5\" height=\"2\"/>\n  <rect x=\"2\" y=\"15\" width=\"5\" height=\"2\"/>\n  <rect x=\"6.8536\" y=\"5.3745\" width=\"1.9998\" height=\"4.958\" transform=\"translate(-3.253 7.8535) rotate(-45)\"/>\n  <path d=\"M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z\"/><path d=\"M21.668 6.854H26.625999999999998V8.854H21.668z\" transform=\"rotate(-45 24.147 7.853)\"/><path d=\"M25 15H30V17H25zM2 15H7V17H2z\"/><path d=\"M6.854 5.375H8.854V10.333H6.854z\" transform=\"rotate(-45 7.854 7.853)\"/><path d=\"M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z\"/></svg>",
            "info": {},
            "path": "32/uv-index--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UvIndexAlt32",
          "filepath": "uv-index--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25zM2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
                }
              }
            ],
            "name": "uv-index--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UvIndexAlt24",
          "filepath": "uv-index--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25zM2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
                }
              }
            ],
            "name": "uv-index--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UvIndexAlt20",
          "filepath": "uv-index--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25zM2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
                }
              }
            ],
            "name": "uv-index--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UvIndexAlt16",
          "filepath": "uv-index--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                  "transform": "rotate(-45 24.147 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 15H30V17H25zM2 15H7V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.854 5.375H8.854V10.333H6.854z",
                  "transform": "rotate(-45 7.854 7.853)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
                }
              }
            ],
            "name": "uv-index--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "UvIndexAlt",
        "global": "UvIndexAlt",
        "filepath": "UvIndexAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.668 6.854H26.625999999999998V8.854H21.668z",
                    "transform": "rotate(-45 24.147 7.853)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 15H30V17H25zM2 15H7V17H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.854 5.375H8.854V10.333H6.854z",
                    "transform": "rotate(-45 7.854 7.853)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "uv-index--filled",
      "friendlyName": "UV index filled",
      "aliases": [
        "sun exposure",
        "uv",
        "index",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/uv-index--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>uv-index--filled</title>\n  <path d=\"M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z\"/></svg>",
            "info": {},
            "path": "32/uv-index--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "UvIndexFilled32",
          "filepath": "uv-index--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
                }
              }
            ],
            "name": "uv-index--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "UvIndexFilled24",
          "filepath": "uv-index--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
                }
              }
            ],
            "name": "uv-index--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "UvIndexFilled20",
          "filepath": "uv-index--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
                }
              }
            ],
            "name": "uv-index--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "UvIndexFilled16",
          "filepath": "uv-index--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
                }
              }
            ],
            "name": "uv-index--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "UvIndexFilled",
        "global": "UvIndexFilled",
        "filepath": "UvIndexFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "value--variable",
      "friendlyName": "Value variable",
      "aliases": [
        "value",
        "figure",
        "amount",
        "number",
        "variable"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/value--variable.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,28H22V26h4V6H22V4h4a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28Z\"/>\n  <polygon points=\"20 11 18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11\"/>\n  <path d=\"M10,28H6a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,6,4h4V6H6V26h4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z\"/></svg>",
            "info": {},
            "path": "32/value--variable.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ValueVariable32",
          "filepath": "value--variable/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"
                }
              }
            ],
            "name": "value--variable",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ValueVariable24",
          "filepath": "value--variable/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"
                }
              }
            ],
            "name": "value--variable",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ValueVariable20",
          "filepath": "value--variable/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"
                }
              }
            ],
            "name": "value--variable",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ValueVariable16",
          "filepath": "value--variable/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"
                }
              }
            ],
            "name": "value--variable",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "ValueVariable",
        "global": "ValueVariable",
        "filepath": "ValueVariable.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "van",
      "friendlyName": "Van",
      "aliases": [
        "vehicle",
        "car",
        "delivery",
        "truck",
        "cargo"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/van.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>van</title><path d=\"M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z\"/></svg>",
            "info": {},
            "path": "32/van.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Van32",
          "filepath": "van/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
                }
              }
            ],
            "name": "van",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Van24",
          "filepath": "van/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
                }
              }
            ],
            "name": "van",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Van20",
          "filepath": "van/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
                }
              }
            ],
            "name": "van",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Van16",
          "filepath": "van/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
                }
              }
            ],
            "name": "van",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Van",
        "global": "Van",
        "filepath": "Van.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vegetation--asset",
      "friendlyName": "Vegetation asset",
      "aliases": [
        "vegetation",
        "asset",
        "tree",
        "resource"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vegetation--asset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"21.5\" cy=\"10.5\" r=\"1.5\"/>\n  <path d=\"M28.5,1a2.4518,2.4518,0,0,0-1.2061.3105L18.9834,5.6084l.0027.0054a5.497,5.497,0,1,0,7.3257,7.5444l.0031.0015,4.4-8.5A2.5,2.5,0,0,0,28.5,1Zm-7,13A3.5,3.5,0,1,1,25,10.5,3.5042,3.5042,0,0,1,21.5,14ZM28.9414,3.7354,26.5571,8.3408A5.5279,5.5279,0,0,0,23.658,5.4424l4.5949-2.377A.5165.5165,0,0,1,29,3.5.4985.4985,0,0,1,28.9414,3.7354Z\"/>\n  <path d=\"M19,20h7V18H17V28a2.0027,2.0027,0,0,0,2,2h3V28H19Z\"/>\n  <path d=\"M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0024,2.0024,0,0,1,12,30Z\"/>\n  <path d=\"M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"21.5\" cy=\"10.5\" r=\"1.5\"/><path d=\"M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z\"/><path d=\"M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z\"/></svg>",
            "info": {},
            "path": "32/vegetation--asset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VegetationAsset32",
          "filepath": "vegetation--asset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "10.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
                }
              }
            ],
            "name": "vegetation--asset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VegetationAsset24",
          "filepath": "vegetation--asset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "10.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
                }
              }
            ],
            "name": "vegetation--asset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VegetationAsset20",
          "filepath": "vegetation--asset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "10.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
                }
              }
            ],
            "name": "vegetation--asset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VegetationAsset16",
          "filepath": "vegetation--asset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "21.5",
                  "cy": "10.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
                }
              }
            ],
            "name": "vegetation--asset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "VegetationAsset",
        "global": "VegetationAsset",
        "filepath": "VegetationAsset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "21.5",
                    "cy": "10.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vehicle--api",
      "friendlyName": "Vehicle API",
      "aliases": [
        "vehicle",
        "car",
        "application",
        "app",
        "programming",
        "interface",
        "API"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vehicle--api.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,11a1.9907,1.9907,0,0,0-.8247.1821L24.8337,9.51A3.45,3.45,0,0,0,25,8.5a3.45,3.45,0,0,0-.1663-1.01l2.3416-1.6723A1.9975,1.9975,0,1,0,26,4c0,.064.0129.124.0188.1865L23.7273,5.8232A3.4652,3.4652,0,0,0,21.5,5a3.5,3.5,0,0,0,0,7,3.4652,3.4652,0,0,0,2.2273-.8232l2.2915,1.6367C26.0129,12.876,26,12.936,26,13a2,2,0,1,0,2-2Zm-6.5-1A1.5,1.5,0,1,1,23,8.5,1.5017,1.5017,0,0,1,21.5,10Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.3379,19.9336l-7.7324-2.7783L18.374,13.0967A2.99,2.99,0,0,0,16.0537,12H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,17.2949A4.9884,4.9884,0,0,0,2,20.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V20.875A1,1,0,0,0,29.3379,19.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V20.1074A2.9977,2.9977,0,0,1,4.52,18.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,14h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,21.5781Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z\"/></svg>",
            "info": {},
            "path": "32/vehicle--api.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VehicleApi32",
          "filepath": "vehicle--api/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z"
                }
              }
            ],
            "name": "vehicle--api",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VehicleApi24",
          "filepath": "vehicle--api/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z"
                }
              }
            ],
            "name": "vehicle--api",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VehicleApi20",
          "filepath": "vehicle--api/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z"
                }
              }
            ],
            "name": "vehicle--api",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VehicleApi16",
          "filepath": "vehicle--api/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z"
                }
              }
            ],
            "name": "vehicle--api",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VehicleApi",
        "global": "VehicleApi",
        "filepath": "VehicleApi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vehicle--connected",
      "friendlyName": "Vehicle connected",
      "aliases": [
        "vehicle",
        "car",
        "signal",
        "interface",
        "wireless"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vehicle--connected.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25,11H23a2.0021,2.0021,0,0,0-2-2V7A4.0045,4.0045,0,0,1,25,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z\"/><path d=\"M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z\"/></svg>",
            "info": {},
            "path": "32/vehicle--connected.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VehicleConnected32",
          "filepath": "vehicle--connected/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
                }
              }
            ],
            "name": "vehicle--connected",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VehicleConnected24",
          "filepath": "vehicle--connected/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
                }
              }
            ],
            "name": "vehicle--connected",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VehicleConnected20",
          "filepath": "vehicle--connected/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
                }
              }
            ],
            "name": "vehicle--connected",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VehicleConnected16",
          "filepath": "vehicle--connected/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
                }
              }
            ],
            "name": "vehicle--connected",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VehicleConnected",
        "global": "VehicleConnected",
        "filepath": "VehicleConnected.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vehicle--insights",
      "friendlyName": "Vehicle insights",
      "aliases": [
        "vehicle",
        "car",
        "log",
        "data"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vehicle--insights.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"28\" y=\"2\" width=\"2\" height=\"7\"/>\n  <rect x=\"24\" y=\"6\" width=\"2\" height=\"3\"/>\n  <rect x=\"20\" y=\"4\" width=\"2\" height=\"5\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z\"/></svg>",
            "info": {},
            "path": "32/vehicle--insights.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VehicleInsights32",
          "filepath": "vehicle--insights/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z"
                }
              }
            ],
            "name": "vehicle--insights",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VehicleInsights24",
          "filepath": "vehicle--insights/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z"
                }
              }
            ],
            "name": "vehicle--insights",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VehicleInsights20",
          "filepath": "vehicle--insights/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z"
                }
              }
            ],
            "name": "vehicle--insights",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VehicleInsights16",
          "filepath": "vehicle--insights/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z"
                }
              }
            ],
            "name": "vehicle--insights",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VehicleInsights",
        "global": "VehicleInsights",
        "filepath": "VehicleInsights.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vehicle--services",
      "friendlyName": "Vehicle services",
      "aliases": [
        "vehicle",
        "car",
        "services",
        "wrench",
        "maintenance",
        "repair"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vehicle--services.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M24.5547,6a2,2,0,0,1,2-2H30a3.9756,3.9756,0,0,0-7.304,1H16V7h6.696A3.9756,3.9756,0,0,0,30,8H26.5547A2,2,0,0,1,24.5547,6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z\"/></svg>",
            "info": {},
            "path": "32/vehicle--services.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VehicleServices32",
          "filepath": "vehicle--services/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z"
                }
              }
            ],
            "name": "vehicle--services",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VehicleServices24",
          "filepath": "vehicle--services/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z"
                }
              }
            ],
            "name": "vehicle--services",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VehicleServices20",
          "filepath": "vehicle--services/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z"
                }
              }
            ],
            "name": "vehicle--services",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VehicleServices16",
          "filepath": "vehicle--services/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z"
                }
              }
            ],
            "name": "vehicle--services",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VehicleServices",
        "global": "VehicleServices",
        "filepath": "VehicleServices.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "version",
      "friendlyName": "Version",
      "aliases": [
        "file",
        "document",
        "version"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/version.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z\"/><path d=\"M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z\"/><path d=\"M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z\"/></svg>",
            "info": {},
            "path": "32/version.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Version32",
          "filepath": "version/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
                }
              }
            ],
            "name": "version",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Version24",
          "filepath": "version/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
                }
              }
            ],
            "name": "version",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Version20",
          "filepath": "version/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
                }
              }
            ],
            "name": "version",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Version16",
          "filepath": "version/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
                }
              }
            ],
            "name": "version",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Version",
        "global": "Version",
        "filepath": "Version.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vertical-view",
      "friendlyName": "Vertical view",
      "aliases": [
        "Vertical",
        "view",
        "orientation",
        "formatting"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vertical-view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2h8a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,12,30ZM4,4V28h8V4Z\"/>\n  <path d=\"M28,30H20a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM20,4V28h8V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z\"/></svg>",
            "info": {},
            "path": "32/vertical-view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VerticalView32",
          "filepath": "vertical-view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z"
                }
              }
            ],
            "name": "vertical-view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VerticalView24",
          "filepath": "vertical-view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z"
                }
              }
            ],
            "name": "vertical-view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VerticalView20",
          "filepath": "vertical-view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z"
                }
              }
            ],
            "name": "vertical-view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VerticalView16",
          "filepath": "vertical-view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z"
                }
              }
            ],
            "name": "vertical-view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Formatting",
      "moduleInfo": {
        "local": "VerticalView",
        "global": "VerticalView",
        "filepath": "VerticalView.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "video",
      "friendlyName": "Video",
      "aliases": [
        "camera",
        "recorder",
        "movie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/video.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>video</title><path d=\"M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z\"/></svg>",
            "info": {},
            "path": "32/video.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Video32",
          "filepath": "video/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Video24",
          "filepath": "video/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Video20",
          "filepath": "video/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Video16",
          "filepath": "video/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "Video",
        "global": "Video",
        "filepath": "Video.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "video--add",
      "friendlyName": "Video add",
      "aliases": [
        "camera",
        "recorder",
        "movie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/video--add.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>video--add</title><polygon points=\"18 15 14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15\"/><path d=\"M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z\"/><path d=\"M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z\"/></svg>",
            "info": {},
            "path": "32/video--add.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VideoAdd32",
          "filepath": "video--add/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--add",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VideoAdd24",
          "filepath": "video--add/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--add",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VideoAdd20",
          "filepath": "video--add/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--add",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VideoAdd16",
          "filepath": "video--add/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--add",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VideoAdd",
        "global": "VideoAdd",
        "filepath": "VideoAdd.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "video--chat",
      "friendlyName": "Video chat",
      "aliases": [
        "camera",
        "recorder",
        "movie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/video--chat.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>video--chat</title><rect x=\"8\" y=\"12\" width=\"9\" height=\"2\"/><rect x=\"8\" y=\"17\" width=\"5\" height=\"2\"/><path d=\"M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 12H17V14H8zM8 17H13V19H8z\"/><path d=\"M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z\"/></svg>",
            "info": {},
            "path": "32/video--chat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VideoChat32",
          "filepath": "video--chat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H17V14H8zM8 17H13V19H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--chat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VideoChat24",
          "filepath": "video--chat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H17V14H8zM8 17H13V19H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--chat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VideoChat20",
          "filepath": "video--chat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H17V14H8zM8 17H13V19H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--chat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VideoChat16",
          "filepath": "video--chat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H17V14H8zM8 17H13V19H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                }
              }
            ],
            "name": "video--chat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VideoChat",
        "global": "VideoChat",
        "filepath": "VideoChat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 12H17V14H8zM8 17H13V19H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "video--filled",
      "friendlyName": "Video filled",
      "aliases": [
        "camera",
        "recorder",
        "movie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/video--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>video--filled</title><path d=\"M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z\"/></svg>",
            "info": {},
            "path": "32/video--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VideoFilled32",
          "filepath": "video--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
                }
              }
            ],
            "name": "video--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VideoFilled24",
          "filepath": "video--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
                }
              }
            ],
            "name": "video--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VideoFilled20",
          "filepath": "video--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
                }
              }
            ],
            "name": "video--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VideoFilled16",
          "filepath": "video--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
                }
              }
            ],
            "name": "video--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "VideoFilled",
        "global": "VideoFilled",
        "filepath": "VideoFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "video--off",
      "friendlyName": "Video off",
      "aliases": [
        "camera",
        "recorder",
        "movie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/video--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>video--off</title><path d=\"M29.46,8.11a1,1,0,0,0-1,.08L23,12.06V10.44l7-7L28.56,2,2,28.56,3.44,30l4-4H21a2,2,0,0,0,2-2V19.94l5.42,3.87A1,1,0,0,0,30,23V9A1,1,0,0,0,29.46,8.11ZM28,21.06l-5.42-3.87A1,1,0,0,0,21,18v6H9.44L21,12.44V14a1,1,0,0,0,1.58.81L28,10.94Z\"/><path d=\"M4,24V8H20V6H4A2,2,0,0,0,2,8V24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z\"/></svg>",
            "info": {},
            "path": "32/video--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VideoOff32",
          "filepath": "video--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z"
                }
              }
            ],
            "name": "video--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VideoOff24",
          "filepath": "video--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z"
                }
              }
            ],
            "name": "video--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VideoOff20",
          "filepath": "video--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z"
                }
              }
            ],
            "name": "video--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VideoOff16",
          "filepath": "video--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z"
                }
              }
            ],
            "name": "video--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "VideoOff",
        "global": "VideoOff",
        "filepath": "VideoOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "video--off--filled",
      "friendlyName": "Video off filled",
      "aliases": [
        "camera",
        "recorder",
        "movie"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/video--off--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>video--off--filled</title><path d=\"M20.31,6H4A2,2,0,0,0,2,8V24a2.85,2.85,0,0,0,0,.29Z\"/><path d=\"M29.46,8.11a1,1,0,0,0-1,.08L23,12.06V10.44l7-7L28.56,2,2,28.56,3.44,30l4-4H21a2,2,0,0,0,2-2V19.94l5.42,3.87A1,1,0,0,0,30,23V9A1,1,0,0,0,29.46,8.11Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z\"/></svg>",
            "info": {},
            "path": "32/video--off--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VideoOffFilled32",
          "filepath": "video--off--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z"
                }
              }
            ],
            "name": "video--off--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VideoOffFilled24",
          "filepath": "video--off--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z"
                }
              }
            ],
            "name": "video--off--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VideoOffFilled20",
          "filepath": "video--off--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z"
                }
              }
            ],
            "name": "video--off--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VideoOffFilled16",
          "filepath": "video--off--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z"
                }
              }
            ],
            "name": "video--off--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "VideoOffFilled",
        "global": "VideoOffFilled",
        "filepath": "VideoOffFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "view",
      "friendlyName": "View",
      "aliases": [
        "eye",
        "eyeball",
        "examine",
        "look",
        "inspect",
        "visible"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/view.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>view</title>\n<path d=\"M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3\n\tc3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5\n\tC13.4,10.5,10.6,12.5,8,12.5z\"/>\n<path d=\"M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3\tc3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5\tC13.4,10.5,10.6,12.5,8,12.5z\"/><path d=\"M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z\"/></svg>",
            "info": {},
            "path": "16/view.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/view.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>view</title><path d=\"M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z\" transform=\"translate(0 0)\"/><path d=\"M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z\"/><path d=\"M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z\"/></svg>",
            "info": {},
            "path": "32/view.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "View32",
          "filepath": "view/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              }
            ],
            "name": "view",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "View24",
          "filepath": "view/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              }
            ],
            "name": "view",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "View20",
          "filepath": "view/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                }
              }
            ],
            "name": "view",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "View16",
          "filepath": "view/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3\tc3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5\tC13.4,10.5,10.6,12.5,8,12.5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z"
                }
              }
            ],
            "name": "view",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "View",
        "global": "View",
        "filepath": "View.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3 c3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5 C13.4,10.5,10.6,12.5,8,12.5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "view--filled",
      "friendlyName": "View filled",
      "aliases": [
        "eye",
        "eyeball",
        "examine",
        "look",
        "inspect",
        "visible"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/view--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>view--filled</title><circle cx=\"16\" cy=\"16\" r=\"4\"/><path d=\"M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"16\" r=\"4\"/><path d=\"M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z\"/></svg>",
            "info": {},
            "path": "32/view--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ViewFilled32",
          "filepath": "view--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
                }
              }
            ],
            "name": "view--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ViewFilled24",
          "filepath": "view--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
                }
              }
            ],
            "name": "view--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ViewFilled20",
          "filepath": "view--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
                }
              }
            ],
            "name": "view--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ViewFilled16",
          "filepath": "view--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "16",
                  "r": "4"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
                }
              }
            ],
            "name": "view--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ViewFilled",
        "global": "ViewFilled",
        "filepath": "ViewFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "16",
                    "r": "4"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "view--mode-1",
      "friendlyName": "View mode 1",
      "aliases": [
        "eye",
        "eyeball",
        "examine",
        "look",
        "inspect",
        "visible"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/view--mode-1.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>view--mode-1</title><rect x=\"4\" y=\"26\" width=\"24\" height=\"2\"/><rect x=\"4\" y=\"19\" width=\"24\" height=\"2\"/><path d=\"M26,6v6H6V6H26m0-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/view--mode-1.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ViewMode_132",
          "filepath": "view--mode-1/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-1",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ViewMode_124",
          "filepath": "view--mode-1/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-1",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ViewMode_120",
          "filepath": "view--mode-1/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-1",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ViewMode_116",
          "filepath": "view--mode-1/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-1",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ViewMode_1",
        "global": "ViewMode_1",
        "filepath": "ViewMode_1.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "view--mode-2",
      "friendlyName": "View mode 2",
      "aliases": [
        "eye",
        "eyeball",
        "examine",
        "look",
        "inspect",
        "visible"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/view--mode-2.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>view--mode-2</title><rect x=\"4\" y=\"26\" width=\"24\" height=\"2\"/><rect x=\"4\" y=\"19\" width=\"24\" height=\"2\"/><path d=\"M12,6v6H6V6h6m0-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><path d=\"M26,6v6H20V6h6m0-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/view--mode-2.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ViewMode_232",
          "filepath": "view--mode-2/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-2",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ViewMode_224",
          "filepath": "view--mode-2/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-2",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ViewMode_220",
          "filepath": "view--mode-2/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-2",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ViewMode_216",
          "filepath": "view--mode-2/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "view--mode-2",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ViewMode_2",
        "global": "ViewMode_2",
        "filepath": "ViewMode_2.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "view--off",
      "friendlyName": "View off",
      "aliases": [
        "eye",
        "eyeball",
        "examine",
        "look",
        "inspect",
        "visible"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/view--off.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>view--off</title>\n<path d=\"M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5\n\tC4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z\"/>\n<path d=\"M6,7.9c0.1-1,0.9-1.8,1.8-1.8l0.9-0.9C7.2,4.7,5.5,5.6,5.1,7.2C5,7.7,5,8.3,5.1,8.8L6,7.9z\"/>\n<path d=\"M15.5,7.8c-0.6-1.5-1.6-2.8-2.9-3.7L15,1.7L14.3,1L1,14.3L1.7,15l2.6-2.6c1.1,0.7,2.4,1,3.7,1.1c3.3-0.1,6.3-2.2,7.5-5.3\n\tC15.5,8.1,15.5,7.9,15.5,7.8z M10,8c0,1.1-0.9,2-2,2c-0.3,0-0.7-0.1-1-0.3L9.7,7C9.9,7.3,10,7.6,10,8z M8,12.5c-1,0-2.1-0.3-3-0.8\n\tl1.3-1.3c1.4,0.9,3.2,0.6,4.2-0.8c0.7-1,0.7-2.4,0-3.4l1.4-1.4c1.1,0.8,2,1.9,2.6,3.2C13.4,10.5,10.6,12.5,8,12.5z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5\tC4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z\"/><path d=\"M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z\"/></svg>",
            "info": {},
            "path": "16/view--off.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/view--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>view--off</title><path d=\"M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z\"/><path d=\"M12,15.73a4,4,0,0,1,3.7-3.7l1.81-1.82a6,6,0,0,0-7.33,7.33Z\"/><path d=\"M30.94,15.66A16.4,16.4,0,0,0,25.2,8.22L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.1A15.29,15.29,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM20,16a4,4,0,0,1-6,3.44L19.44,14A4,4,0,0,1,20,16Zm-4,9a13.05,13.05,0,0,1-6-1.58l2.54-2.54a6,6,0,0,0,8.35-8.35l2.87-2.87A14.54,14.54,0,0,1,28.93,16C26.9,21.07,21.3,25,16,25Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z\"/><path d=\"M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z\"/></svg>",
            "info": {},
            "path": "32/view--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ViewOff32",
          "filepath": "view--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z"
                }
              }
            ],
            "name": "view--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ViewOff24",
          "filepath": "view--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z"
                }
              }
            ],
            "name": "view--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ViewOff20",
          "filepath": "view--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z"
                }
              }
            ],
            "name": "view--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ViewOff16",
          "filepath": "view--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5\tC4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z"
                }
              }
            ],
            "name": "view--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ViewOff",
        "global": "ViewOff",
        "filepath": "ViewOff.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5 C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "view--off--filled",
      "friendlyName": "View off filled",
      "aliases": [
        "eye",
        "eyeball",
        "examine",
        "look",
        "inspect",
        "visible"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/view--off--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>view--off--filled</title><path d=\"M30.94,15.66a16.4,16.4,0,0,0-5.73-7.45L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.09A15.38,15.38,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5a6.46,6.46,0,0,1-3.83-1.26L14,19.43A4,4,0,0,0,19.43,14l1.81-1.81A6.49,6.49,0,0,1,16,22.5Z\"/><path d=\"M4.53,21.81l5-5A6.84,6.84,0,0,1,9.5,16,6.51,6.51,0,0,1,16,9.5a6.84,6.84,0,0,1,.79.05l3.78-3.77A14.39,14.39,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A15.86,15.86,0,0,0,4.53,21.81Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z\"/></svg>",
            "info": {},
            "path": "32/view--off--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ViewOffFilled32",
          "filepath": "view--off--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
                }
              }
            ],
            "name": "view--off--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ViewOffFilled24",
          "filepath": "view--off--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
                }
              }
            ],
            "name": "view--off--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ViewOffFilled20",
          "filepath": "view--off--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
                }
              }
            ],
            "name": "view--off--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ViewOffFilled16",
          "filepath": "view--off--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
                }
              }
            ],
            "name": "view--off--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Toggle",
      "moduleInfo": {
        "local": "ViewOffFilled",
        "global": "ViewOffFilled",
        "filepath": "ViewOffFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "view-next",
      "friendlyName": "View next",
      "aliases": [
        "view",
        "view next",
        "next",
        "operations",
        "forward"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/view-next.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"20.587 22 15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22\"/>\n  <path d=\"M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z\"/><path d=\"M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z\"/></svg>",
            "info": {},
            "path": "32/view-next.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ViewNext32",
          "filepath": "view-next/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "view-next",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ViewNext24",
          "filepath": "view-next/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "view-next",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ViewNext20",
          "filepath": "view-next/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "view-next",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ViewNext16",
          "filepath": "view-next/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                }
              }
            ],
            "name": "view-next",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ViewNext",
        "global": "ViewNext",
        "filepath": "ViewNext.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "virtual-column",
      "friendlyName": "Virtual column",
      "aliases": [
        "virtual column"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/virtual-column.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>virtual-column</title><polygon points=\"25 11 26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11\"/><path d=\"M30,28H20a2.0023,2.0023,0,0,1-2-2V6a2.0023,2.0023,0,0,1,2-2H30V6H20V26H30Z\"/><path d=\"M12,28H2V26H12V6H2V4H12a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,12,28Z\"/><polygon points=\"7 11 5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z\"/><path d=\"M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z\"/><path d=\"M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z\"/></svg>",
            "info": {},
            "path": "32/virtual-column.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VirtualColumn32",
          "filepath": "virtual-column/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
                }
              }
            ],
            "name": "virtual-column",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VirtualColumn24",
          "filepath": "virtual-column/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
                }
              }
            ],
            "name": "virtual-column",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VirtualColumn20",
          "filepath": "virtual-column/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
                }
              }
            ],
            "name": "virtual-column",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VirtualColumn16",
          "filepath": "virtual-column/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
                }
              }
            ],
            "name": "virtual-column",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "VirtualColumn",
        "global": "VirtualColumn",
        "filepath": "VirtualColumn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "virtual-column--key",
      "friendlyName": "Virtual column key",
      "aliases": [
        "virtual column key"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/virtual-column--key.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>virtual-column--key</title><circle cx=\"24.5\" cy=\"9.5\" r=\"1.5\"/><path d=\"M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z\"/><path d=\"M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"24.5\" cy=\"9.5\" r=\"1.5\"/><path d=\"M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z\"/><path d=\"M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z\"/></svg>",
            "info": {},
            "path": "32/virtual-column--key.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VirtualColumnKey32",
          "filepath": "virtual-column--key/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
                }
              }
            ],
            "name": "virtual-column--key",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VirtualColumnKey24",
          "filepath": "virtual-column--key/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
                }
              }
            ],
            "name": "virtual-column--key",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VirtualColumnKey20",
          "filepath": "virtual-column--key/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
                }
              }
            ],
            "name": "virtual-column--key",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VirtualColumnKey16",
          "filepath": "virtual-column--key/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24.5",
                  "cy": "9.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
                }
              }
            ],
            "name": "virtual-column--key",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "VirtualColumnKey",
        "global": "VirtualColumnKey",
        "filepath": "VirtualColumnKey.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24.5",
                    "cy": "9.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "virtual-desktop",
      "friendlyName": "Virtual desktop",
      "aliases": [
        "cloud",
        "monitor",
        "desktop",
        "virtual"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/virtual-desktop.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z\"/><path d=\"M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z\"/></svg>",
            "info": {},
            "path": "32/virtual-desktop.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VirtualDesktop32",
          "filepath": "virtual-desktop/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
                }
              }
            ],
            "name": "virtual-desktop",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VirtualDesktop24",
          "filepath": "virtual-desktop/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
                }
              }
            ],
            "name": "virtual-desktop",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VirtualDesktop20",
          "filepath": "virtual-desktop/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
                }
              }
            ],
            "name": "virtual-desktop",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VirtualDesktop16",
          "filepath": "virtual-desktop/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
                }
              }
            ],
            "name": "virtual-desktop",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VirtualDesktop",
        "global": "VirtualDesktop",
        "filepath": "VirtualDesktop.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "virtual-machine",
      "friendlyName": "Virtual machine",
      "aliases": [
        "virtual machine"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/virtual-machine.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>virtual-machine</title><path d=\"M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z\"/><path d=\"M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z\"/><path d=\"M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z\"/></svg>",
            "info": {},
            "path": "32/virtual-machine.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VirtualMachine32",
          "filepath": "virtual-machine/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
                }
              }
            ],
            "name": "virtual-machine",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VirtualMachine24",
          "filepath": "virtual-machine/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
                }
              }
            ],
            "name": "virtual-machine",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VirtualMachine20",
          "filepath": "virtual-machine/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
                }
              }
            ],
            "name": "virtual-machine",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VirtualMachine16",
          "filepath": "virtual-machine/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
                }
              }
            ],
            "name": "virtual-machine",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "VirtualMachine",
        "global": "VirtualMachine",
        "filepath": "VirtualMachine.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "virtual-private-cloud",
      "friendlyName": "Virtual private cloud",
      "aliases": [
        "virtual private cloud",
        "VPC",
        "cloud",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/virtual-private-cloud.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>virtual-private-cloud</title><path d=\"M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z\" transform=\"translate(0)\"/><path d=\"M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z\"/><path d=\"M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z\"/></svg>",
            "info": {},
            "path": "32/virtual-private-cloud.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VirtualPrivateCloud32",
          "filepath": "virtual-private-cloud/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
                }
              }
            ],
            "name": "virtual-private-cloud",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VirtualPrivateCloud24",
          "filepath": "virtual-private-cloud/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
                }
              }
            ],
            "name": "virtual-private-cloud",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VirtualPrivateCloud20",
          "filepath": "virtual-private-cloud/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
                }
              }
            ],
            "name": "virtual-private-cloud",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VirtualPrivateCloud16",
          "filepath": "virtual-private-cloud/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
                }
              }
            ],
            "name": "virtual-private-cloud",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "VirtualPrivateCloud",
        "global": "VirtualPrivateCloud",
        "filepath": "VirtualPrivateCloud.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "virtual-private-cloud--alt",
      "friendlyName": "IBM Cloud® VPC",
      "aliases": [
        "virtual private cloud",
        "VPC",
        "cloud",
        "hybrid"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/virtual-private-cloud--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>virtual-private-cloud--alt</title><path d=\"M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z\" transform=\"translate(0 0)\"/><path d=\"M30,6a3.9915,3.9915,0,0,0-7.8579-1H13V7h9.1421A3.9945,3.9945,0,0,0,25,9.8579V19h2V9.8579A3.9962,3.9962,0,0,0,30,6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z\" transform=\"translate(0 0)\"/><path d=\"M19,25H9.8579A3.9945,3.9945,0,0,0,7,22.1421V13H5v9.1421A3.9915,3.9915,0,1,0,9.8579,27H19ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z\"/><path d=\"M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z\"/></svg>",
            "info": {},
            "path": "32/virtual-private-cloud--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VirtualPrivateCloudAlt32",
          "filepath": "virtual-private-cloud--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "virtual-private-cloud--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VirtualPrivateCloudAlt24",
          "filepath": "virtual-private-cloud--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "virtual-private-cloud--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VirtualPrivateCloudAlt20",
          "filepath": "virtual-private-cloud--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "virtual-private-cloud--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VirtualPrivateCloudAlt16",
          "filepath": "virtual-private-cloud--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                }
              }
            ],
            "name": "virtual-private-cloud--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "VirtualPrivateCloudAlt",
        "global": "VirtualPrivateCloudAlt",
        "filepath": "VirtualPrivateCloudAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "visual-recognition",
      "friendlyName": "Visual recognition",
      "aliases": [
        "picture",
        "ai"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/visual-recognition.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>visual-recognition</title><circle cx=\"23\" cy=\"12\" r=\"2\"/><path d=\"M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"23\" cy=\"12\" r=\"2\"/><path d=\"M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z\"/></svg>",
            "info": {},
            "path": "32/visual-recognition.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VisualRecognition32",
          "filepath": "visual-recognition/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
                }
              }
            ],
            "name": "visual-recognition",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VisualRecognition24",
          "filepath": "visual-recognition/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
                }
              }
            ],
            "name": "visual-recognition",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VisualRecognition20",
          "filepath": "visual-recognition/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
                }
              }
            ],
            "name": "visual-recognition",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VisualRecognition16",
          "filepath": "visual-recognition/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "23",
                  "cy": "12",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
                }
              }
            ],
            "name": "visual-recognition",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "VisualRecognition",
        "global": "VisualRecognition",
        "filepath": "VisualRecognition.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "23",
                    "cy": "12",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vlan",
      "friendlyName": "VLAN",
      "aliases": [
        "virtual",
        "LAN",
        "network",
        "local area network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vlan.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z\"/></svg>",
            "info": {},
            "path": "32/vlan.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Vlan32",
          "filepath": "vlan/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
                }
              }
            ],
            "name": "vlan",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Vlan24",
          "filepath": "vlan/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
                }
              }
            ],
            "name": "vlan",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Vlan20",
          "filepath": "vlan/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
                }
              }
            ],
            "name": "vlan",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Vlan16",
          "filepath": "vlan/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
                }
              }
            ],
            "name": "vlan",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Vlan",
        "global": "Vlan",
        "filepath": "Vlan.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vlan--ibm",
      "friendlyName": "IBM Cloud® VLAN",
      "aliases": [
        "virtual",
        "LAN",
        "network",
        "local area network"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vlan--ibm.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,22a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,22Zm0,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,16,28Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,5a3,3,0,1,0-4,2.8154V15H17V9H15v6H6V7.8159a3.0007,3.0007,0,1,0-2,0V15a2.002,2.002,0,0,0,2,2h9v3h2V17h9a2.002,2.002,0,0,0,2-2V7.8159A2.9958,2.9958,0,0,0,30,5ZM5,4A1,1,0,1,1,4,5,1.0013,1.0013,0,0,1,5,4ZM27,6a1,1,0,1,1,1-1A1.0013,1.0013,0,0,1,27,6Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"16\" cy=\"5\" r=\"2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z\"/><circle cx=\"16\" cy=\"5\" r=\"2\"/></svg>",
            "info": {},
            "path": "32/vlan--ibm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VlanIbm32",
          "filepath": "vlan--ibm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "5",
                  "r": "2"
                }
              }
            ],
            "name": "vlan--ibm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VlanIbm24",
          "filepath": "vlan--ibm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "5",
                  "r": "2"
                }
              }
            ],
            "name": "vlan--ibm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VlanIbm20",
          "filepath": "vlan--ibm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "5",
                  "r": "2"
                }
              }
            ],
            "name": "vlan--ibm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VlanIbm16",
          "filepath": "vlan--ibm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "5",
                  "r": "2"
                }
              }
            ],
            "name": "vlan--ibm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "App catalogue",
      "moduleInfo": {
        "local": "VlanIbm",
        "global": "VlanIbm",
        "filepath": "VlanIbm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "5",
                    "r": "2"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vmdk-disk",
      "friendlyName": "VMDK disk",
      "aliases": [
        "vmdk-disk"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vmdk-disk.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>vmdk-disk</title><circle cx=\"10.5\" cy=\"24.5\" r=\"1.5\"/><rect x=\"19.5\" y=\"14.9645\" width=\"2\" height=\"5.0711\" transform=\"translate(-6.3701 19.6213) rotate(-45)\"/><circle cx=\"16\" cy=\"13\" r=\"2\"/><path d=\"M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z\"/><path d=\"M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"10.5\" cy=\"24.5\" r=\"1.5\"/><path d=\"M19.5 14.964H21.5V20.035H19.5z\" transform=\"rotate(-45 20.5 17.5)\"/><circle cx=\"16\" cy=\"13\" r=\"2\"/><path d=\"M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z\"/><path d=\"M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z\"/></svg>",
            "info": {},
            "path": "32/vmdk-disk.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VmdkDisk32",
          "filepath": "vmdk-disk/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 14.964H21.5V20.035H19.5z",
                  "transform": "rotate(-45 20.5 17.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
                }
              }
            ],
            "name": "vmdk-disk",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VmdkDisk24",
          "filepath": "vmdk-disk/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 14.964H21.5V20.035H19.5z",
                  "transform": "rotate(-45 20.5 17.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
                }
              }
            ],
            "name": "vmdk-disk",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VmdkDisk20",
          "filepath": "vmdk-disk/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 14.964H21.5V20.035H19.5z",
                  "transform": "rotate(-45 20.5 17.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
                }
              }
            ],
            "name": "vmdk-disk",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VmdkDisk16",
          "filepath": "vmdk-disk/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "10.5",
                  "cy": "24.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19.5 14.964H21.5V20.035H19.5z",
                  "transform": "rotate(-45 20.5 17.5)"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "13",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
                }
              }
            ],
            "name": "vmdk-disk",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "VmdkDisk",
        "global": "VmdkDisk",
        "filepath": "VmdkDisk.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "10.5",
                    "cy": "24.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19.5 14.964H21.5V20.035H19.5z",
                    "transform": "rotate(-45 20.5 17.5)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "13",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "voice-activate",
      "friendlyName": "Voice activate",
      "aliases": [
        "voice",
        "activate",
        "user",
        "input"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/voice-activate.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z\"/>\n  <rect x=\"19\" y=\"12\" width=\"4\" height=\"2\"/>\n  <path d=\"M9.3325,25.2168a7.0007,7.0007,0,0,1,0-10.4341l1.334,1.49a5,5,0,0,0,0,7.4537Z\"/>\n  <path d=\"M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z\"/><path d=\"M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z\"/><path d=\"M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z\"/></svg>",
            "info": {},
            "path": "32/voice-activate.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VoiceActivate32",
          "filepath": "voice-activate/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
                }
              }
            ],
            "name": "voice-activate",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VoiceActivate24",
          "filepath": "voice-activate/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
                }
              }
            ],
            "name": "voice-activate",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VoiceActivate20",
          "filepath": "voice-activate/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
                }
              }
            ],
            "name": "voice-activate",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VoiceActivate16",
          "filepath": "voice-activate/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
                }
              }
            ],
            "name": "voice-activate",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Person",
      "subcategory": "User",
      "moduleInfo": {
        "local": "VoiceActivate",
        "global": "VoiceActivate",
        "filepath": "VoiceActivate.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "voicemail",
      "friendlyName": "Voicemail",
      "aliases": [
        "recording",
        "audio",
        "tape"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/voicemail.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>voicemail</title><path d=\"M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z\"/></svg>",
            "info": {},
            "path": "32/voicemail.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Voicemail32",
          "filepath": "voicemail/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
                }
              }
            ],
            "name": "voicemail",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Voicemail24",
          "filepath": "voicemail/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
                }
              }
            ],
            "name": "voicemail",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Voicemail20",
          "filepath": "voicemail/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
                }
              }
            ],
            "name": "voicemail",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Voicemail16",
          "filepath": "voicemail/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
                }
              }
            ],
            "name": "voicemail",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Voicemail",
        "global": "Voicemail",
        "filepath": "Voicemail.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--block-storage",
      "friendlyName": "Block volume",
      "aliases": [
        "systems",
        "volume",
        "block",
        "storage"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--block-storage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,21H10V14h7Zm-5-2h3V16H12Z\"/>\n  <path d=\"M17,30H10V23h7Zm-5-2h3V25H12Z\"/>\n  <path d=\"M26,21H19V14h7Zm-5-2h3V16H21Z\"/>\n  <path d=\"M26,30H19V23h7Zm-5-2h3V25H21Z\"/>\n  <path d=\"M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z\"/><path d=\"M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z\"/></svg>",
            "info": {},
            "path": "32/volume--block-storage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeBlockStorage32",
          "filepath": "volume--block-storage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--block-storage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeBlockStorage24",
          "filepath": "volume--block-storage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--block-storage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeBlockStorage20",
          "filepath": "volume--block-storage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--block-storage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeBlockStorage16",
          "filepath": "volume--block-storage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--block-storage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VolumeBlockStorage",
        "global": "VolumeBlockStorage",
        "filepath": "VolumeBlockStorage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--down",
      "friendlyName": "Volume down",
      "aliases": [
        "sound",
        "noise",
        "soft"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--down.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>volume--down</title><path d=\"M25.1,10.66,23.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z\"/><path d=\"M20,30a1,1,0,0,1-.71-.3L11.67,22H5a1,1,0,0,1-1-1H4V11a1,1,0,0,1,1-1h6.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,21,3V29A1,1,0,0,1,20,30ZM6,20h6a1.17,1.17,0,0,1,.79.3L19,26.57V5.43L12.79,11.7A1.17,1.17,0,0,1,12,12H6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z\"/></svg>",
            "info": {},
            "path": "32/volume--down.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeDown32",
          "filepath": "volume--down/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
                }
              }
            ],
            "name": "volume--down",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeDown24",
          "filepath": "volume--down/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
                }
              }
            ],
            "name": "volume--down",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeDown20",
          "filepath": "volume--down/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
                }
              }
            ],
            "name": "volume--down",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeDown16",
          "filepath": "volume--down/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
                }
              }
            ],
            "name": "volume--down",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeDown",
        "global": "VolumeDown",
        "filepath": "VolumeDown.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--down--alt",
      "friendlyName": "Volume down alt",
      "aliases": [
        "volume",
        "sound",
        "noise",
        "soft"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--down--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"22\" y=\"15\" width=\"10\" height=\"2\"/>\n  <path d=\"M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30ZM4,20h6a1.2008,1.2008,0,0,1,.7939.2969L17,26.5684V5.4316l-6.2061,6.2715A1.2013,1.2013,0,0,1,10,12H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z\"/></svg>",
            "info": {},
            "path": "32/volume--down--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeDownAlt32",
          "filepath": "volume--down--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--down--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeDownAlt24",
          "filepath": "volume--down--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--down--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeDownAlt20",
          "filepath": "volume--down--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--down--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeDownAlt16",
          "filepath": "volume--down--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--down--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeDownAlt",
        "global": "VolumeDownAlt",
        "filepath": "VolumeDownAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--down--filled",
      "friendlyName": "Volume down filled",
      "aliases": [
        "sound",
        "noise",
        "soft"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--down--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>volume--down--filled</title><path d=\"M25.1,10.66,23.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z\"/><path d=\"M20,30a1,1,0,0,1-.71-.3L11.67,22H5a1,1,0,0,1-1-1H4V11a1,1,0,0,1,1-1h6.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,21,3V29A1,1,0,0,1,20,30Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z\"/></svg>",
            "info": {},
            "path": "32/volume--down--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeDownFilled32",
          "filepath": "volume--down--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
                }
              }
            ],
            "name": "volume--down--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeDownFilled24",
          "filepath": "volume--down--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
                }
              }
            ],
            "name": "volume--down--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeDownFilled20",
          "filepath": "volume--down--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
                }
              }
            ],
            "name": "volume--down--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeDownFilled16",
          "filepath": "volume--down--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
                }
              }
            ],
            "name": "volume--down--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeDownFilled",
        "global": "VolumeDownFilled",
        "filepath": "VolumeDownFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--down--filled--alt",
      "friendlyName": "Volume down filled alt",
      "aliases": [
        "volume",
        "sound",
        "noise",
        "soft"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--down--filled--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"22\" y=\"15\" width=\"10\" height=\"2\"/>\n  <path d=\"M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z\"/></svg>",
            "info": {},
            "path": "32/volume--down--filled--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeDownFilledAlt32",
          "filepath": "volume--down--filled--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--down--filled--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeDownFilledAlt24",
          "filepath": "volume--down--filled--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--down--filled--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeDownFilledAlt20",
          "filepath": "volume--down--filled--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--down--filled--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeDownFilledAlt16",
          "filepath": "volume--down--filled--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--down--filled--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeDownFilledAlt",
        "global": "VolumeDownFilledAlt",
        "filepath": "VolumeDownFilledAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--file-storage",
      "friendlyName": "File system",
      "aliases": [
        "systems",
        "volume",
        "file",
        "storage",
        "document"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--file-storage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z\"/>\n  <path d=\"M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z\"/><path d=\"M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z\"/></svg>",
            "info": {},
            "path": "32/volume--file-storage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeFileStorage32",
          "filepath": "volume--file-storage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
                }
              }
            ],
            "name": "volume--file-storage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeFileStorage24",
          "filepath": "volume--file-storage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
                }
              }
            ],
            "name": "volume--file-storage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeFileStorage20",
          "filepath": "volume--file-storage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
                }
              }
            ],
            "name": "volume--file-storage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeFileStorage16",
          "filepath": "volume--file-storage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
                }
              }
            ],
            "name": "volume--file-storage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VolumeFileStorage",
        "global": "VolumeFileStorage",
        "filepath": "VolumeFileStorage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--mute",
      "friendlyName": "Volume mute",
      "aliases": [
        "sound",
        "noise"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--mute.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>volume--mute</title><polygon points=\"31 12.41 29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41\"/><path d=\"M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30ZM4,20h6a1.17,1.17,0,0,1,.79.3L17,26.57V5.43L10.79,11.7A1.17,1.17,0,0,1,10,12H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z\"/></svg>",
            "info": {},
            "path": "32/volume--mute.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeMute32",
          "filepath": "volume--mute/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--mute",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeMute24",
          "filepath": "volume--mute/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--mute",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeMute20",
          "filepath": "volume--mute/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--mute",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeMute16",
          "filepath": "volume--mute/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--mute",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeMute",
        "global": "VolumeMute",
        "filepath": "VolumeMute.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--mute--filled",
      "friendlyName": "Volume mute filled",
      "aliases": [
        "sound",
        "noise"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--mute--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>volume--mute--filled</title><polygon points=\"31 12.41 29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41\"/><path d=\"M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z\"/></svg>",
            "info": {},
            "path": "32/volume--mute--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeMuteFilled32",
          "filepath": "volume--mute--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--mute--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeMuteFilled24",
          "filepath": "volume--mute--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--mute--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeMuteFilled20",
          "filepath": "volume--mute--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--mute--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeMuteFilled16",
          "filepath": "volume--mute--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--mute--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeMuteFilled",
        "global": "VolumeMuteFilled",
        "filepath": "VolumeMuteFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--object-storage",
      "friendlyName": "Object bucket",
      "aliases": [
        "systems",
        "volume",
        "file",
        "storage",
        "object"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--object-storage.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z\"/>\n  <path d=\"M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z\"/><path d=\"M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z\"/></svg>",
            "info": {},
            "path": "32/volume--object-storage.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeObjectStorage32",
          "filepath": "volume--object-storage/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--object-storage",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeObjectStorage24",
          "filepath": "volume--object-storage/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--object-storage",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeObjectStorage20",
          "filepath": "volume--object-storage/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--object-storage",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeObjectStorage16",
          "filepath": "volume--object-storage/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                }
              }
            ],
            "name": "volume--object-storage",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VolumeObjectStorage",
        "global": "VolumeObjectStorage",
        "filepath": "VolumeObjectStorage.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--up",
      "friendlyName": "Volume up",
      "aliases": [
        "sound",
        "noise"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--up.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>volume--up</title><path d=\"M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z\"/><path d=\"M21.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z\"/><path class=\"cls-1\" d=\"M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30ZM4,20h6.08a1,1,0,0,1,.71.3L17,26.57V5.43L10.79,11.7a1,1,0,0,1-.71.3H4Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z\"/><path d=\"M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z\"/></svg>",
            "info": {},
            "path": "32/volume--up.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeUp32",
          "filepath": "volume--up/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
                }
              }
            ],
            "name": "volume--up",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeUp24",
          "filepath": "volume--up/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
                }
              }
            ],
            "name": "volume--up",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeUp20",
          "filepath": "volume--up/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
                }
              }
            ],
            "name": "volume--up",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeUp16",
          "filepath": "volume--up/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
                }
              }
            ],
            "name": "volume--up",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeUp",
        "global": "VolumeUp",
        "filepath": "VolumeUp.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--up--alt",
      "friendlyName": "Volume up alt",
      "aliases": [
        "sound",
        "noise",
        "loud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--up--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"32 15 28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15\"/>\n  <path d=\"M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30ZM4,20h6a1.2008,1.2008,0,0,1,.7939.2969L17,26.5684V5.4316l-6.2061,6.2715A1.2013,1.2013,0,0,1,10,12H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z\"/></svg>",
            "info": {},
            "path": "32/volume--up--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeUpAlt32",
          "filepath": "volume--up--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--up--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeUpAlt24",
          "filepath": "volume--up--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--up--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeUpAlt20",
          "filepath": "volume--up--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--up--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeUpAlt16",
          "filepath": "volume--up--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                }
              }
            ],
            "name": "volume--up--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeUpAlt",
        "global": "VolumeUpAlt",
        "filepath": "VolumeUpAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--up--filled",
      "friendlyName": "Volume up filled",
      "aliases": [
        "sound",
        "noise",
        "loud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--up--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>volume--up--filled</title><path d=\"M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z\"/><path d=\"M21.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z\"/><path class=\"cls-1\" d=\"M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z\"/><path d=\"M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z\"/></svg>",
            "info": {},
            "path": "32/volume--up--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeUpFilled32",
          "filepath": "volume--up--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeUpFilled24",
          "filepath": "volume--up--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeUpFilled20",
          "filepath": "volume--up--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeUpFilled16",
          "filepath": "volume--up--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeUpFilled",
        "global": "VolumeUpFilled",
        "filepath": "VolumeUpFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "volume--up--filled--alt",
      "friendlyName": "Volume up filled alt",
      "aliases": [
        "sound",
        "noise",
        "loud"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/volume--up--filled--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"32 15 28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15\"/>\n  <path d=\"M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z\"/></svg>",
            "info": {},
            "path": "32/volume--up--filled--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VolumeUpFilledAlt32",
          "filepath": "volume--up--filled--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VolumeUpFilledAlt24",
          "filepath": "volume--up--filled--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VolumeUpFilledAlt20",
          "filepath": "volume--up--filled--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VolumeUpFilledAlt16",
          "filepath": "volume--up--filled--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                }
              }
            ],
            "name": "volume--up--filled--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Controls",
      "moduleInfo": {
        "local": "VolumeUpFilledAlt",
        "global": "VolumeUpFilledAlt",
        "filepath": "VolumeUpFilledAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "VPN",
      "friendlyName": "VPN",
      "aliases": [
        "protocol",
        "virtual",
        "network",
        "connection",
        "secure",
        "internet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/VPN.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>VPN</title><path d=\"M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z\" transform=\"translate(0 0)\"/><polygon points=\"28 19 24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19\"/><polygon points=\"8 9 6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 32) rotate(-180)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z\"/></svg>",
            "info": {},
            "path": "32/VPN.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Vpn32",
          "filepath": "VPN/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
                }
              }
            ],
            "name": "VPN",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Vpn24",
          "filepath": "VPN/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
                }
              }
            ],
            "name": "VPN",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Vpn20",
          "filepath": "VPN/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
                }
              }
            ],
            "name": "VPN",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Vpn16",
          "filepath": "VPN/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
                }
              }
            ],
            "name": "VPN",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Vpn",
        "global": "Vpn",
        "filepath": "Vpn.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vpn--connection",
      "friendlyName": "VPN connection",
      "aliases": [
        "lock",
        "virtual",
        "connection",
        "network",
        "private"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vpn--connection.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z\"/></svg>",
            "info": {},
            "path": "32/vpn--connection.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VpnConnection32",
          "filepath": "vpn--connection/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
                }
              }
            ],
            "name": "vpn--connection",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VpnConnection24",
          "filepath": "vpn--connection/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
                }
              }
            ],
            "name": "vpn--connection",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VpnConnection20",
          "filepath": "vpn--connection/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
                }
              }
            ],
            "name": "vpn--connection",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VpnConnection16",
          "filepath": "vpn--connection/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
                }
              }
            ],
            "name": "vpn--connection",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VpnConnection",
        "global": "VpnConnection",
        "filepath": "VpnConnection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "vpn--policy",
      "friendlyName": "VPN policy",
      "aliases": [
        "lock",
        "virtual",
        "connection",
        "network",
        "private",
        "certificate",
        "policy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/vpn--policy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z\"/><path d=\"M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z\"/></svg>",
            "info": {},
            "path": "32/vpn--policy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "VpnPolicy32",
          "filepath": "vpn--policy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
                }
              }
            ],
            "name": "vpn--policy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "VpnPolicy24",
          "filepath": "vpn--policy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
                }
              }
            ],
            "name": "vpn--policy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "VpnPolicy20",
          "filepath": "vpn--policy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
                }
              }
            ],
            "name": "vpn--policy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "VpnPolicy16",
          "filepath": "vpn--policy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
                }
              }
            ],
            "name": "vpn--policy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "VpnPolicy",
        "global": "VpnPolicy",
        "filepath": "VpnPolicy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wallet",
      "friendlyName": "Wallet",
      "aliases": [
        "money",
        "purse"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wallet.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>wallet</title><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/><rect x=\"22\" y=\"17\" width=\"2\" height=\"2\"/><path d=\"M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 17H24V19H22z\"/><path d=\"M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z\"/></svg>",
            "info": {},
            "path": "32/wallet.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Wallet32",
          "filepath": "wallet/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 17H24V19H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
                }
              }
            ],
            "name": "wallet",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Wallet24",
          "filepath": "wallet/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 17H24V19H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
                }
              }
            ],
            "name": "wallet",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Wallet20",
          "filepath": "wallet/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 17H24V19H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
                }
              }
            ],
            "name": "wallet",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Wallet16",
          "filepath": "wallet/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 17H24V19H22z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
                }
              }
            ],
            "name": "wallet",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Wallet",
        "global": "Wallet",
        "filepath": "Wallet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 17H24V19H22z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning",
      "friendlyName": "Warning",
      "aliases": [
        "halt",
        "stop",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/warning.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>warning</title>\n<path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/>\n<rect x=\"7.5\" y=\"4\" width=\"1\" height=\"5\"/>\n<path d=\"M8,10.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8S8.4,10.2,8,10.2z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z\"/><path d=\"M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z\"/></svg>",
            "info": {},
            "path": "16/warning.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/warning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>warning</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\" transform=\"translate(0 0)\"/><rect x=\"15\" y=\"8\" width=\"2\" height=\"11\"/><path d=\"M16,22a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,22Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z\"/><path d=\"M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z\"/></svg>",
            "info": {},
            "path": "32/warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Warning32",
          "filepath": "warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
                }
              }
            ],
            "name": "warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Warning24",
          "filepath": "warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
                }
              }
            ],
            "name": "warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Warning20",
          "filepath": "warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
                }
              }
            ],
            "name": "warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Warning16",
          "filepath": "warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z"
                }
              }
            ],
            "name": "warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "Warning",
        "global": "Warning",
        "filepath": "Warning.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--alt",
      "friendlyName": "Warning alt",
      "aliases": [
        "halt",
        "stop",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/warning--alt.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>warning--alt</title>\n<path d=\"M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12\n\tc0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z\"/>\n<rect x=\"7.5\" y=\"6\" width=\"1\" height=\"3.5\"/>\n<path d=\"M8,10.8c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8S8.4,10.8,8,10.8z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12\tc0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z\"/><path d=\"M7.5 6H8.5V9.5H7.5zM8 10.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.8 8 10.8z\"/></svg>",
            "info": {},
            "path": "16/warning--alt.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/warning--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,23a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,23Z\"/>\n  <rect x=\"15\" y=\"12\" width=\"2\" height=\"9\"/>\n  <path d=\"M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z\"/><path d=\"M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z\"/></svg>",
            "info": {},
            "path": "32/warning--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningAlt32",
          "filepath": "warning--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                }
              }
            ],
            "name": "warning--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningAlt24",
          "filepath": "warning--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                }
              }
            ],
            "name": "warning--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningAlt20",
          "filepath": "warning--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                }
              }
            ],
            "name": "warning--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningAlt16",
          "filepath": "warning--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12\tc0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5 6H8.5V9.5H7.5zM8 10.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.8 8 10.8z"
                }
              }
            ],
            "name": "warning--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningAlt",
        "global": "WarningAlt",
        "filepath": "WarningAlt.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12 c0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5 6H8.5V9.5H7.5zM8 10.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.8 8 10.8z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--alt--filled",
      "friendlyName": "Warning alt filled",
      "aliases": [
        "halt",
        "stop",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning--alt--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z\"/>\n  <path d=\"M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z\"/>\n  <path d=\"M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z\" data-icon-path=\"inner-path\"/><path d=\"M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z\"/><path d=\"M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z\"/></svg>",
            "info": {},
            "path": "32/warning--alt--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningAltFilled32",
          "filepath": "warning--alt--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                }
              }
            ],
            "name": "warning--alt--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningAltFilled24",
          "filepath": "warning--alt--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                }
              }
            ],
            "name": "warning--alt--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningAltFilled20",
          "filepath": "warning--alt--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                }
              }
            ],
            "name": "warning--alt--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningAltFilled16",
          "filepath": "warning--alt--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                }
              }
            ],
            "name": "warning--alt--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningAltFilled",
        "global": "WarningAltFilled",
        "filepath": "WarningAltFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--alt-inverted",
      "friendlyName": "Warning alt inverted",
      "aliases": [
        "halt",
        "stop",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning--alt-inverted.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,17a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,17Z\"/>\n  <rect x=\"15\" y=\"6\" width=\"2\" height=\"9\"/>\n  <path d=\"M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z\"/><path d=\"M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z\"/></svg>",
            "info": {},
            "path": "32/warning--alt-inverted.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningAltInverted32",
          "filepath": "warning--alt-inverted/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningAltInverted24",
          "filepath": "warning--alt-inverted/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningAltInverted20",
          "filepath": "warning--alt-inverted/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningAltInverted16",
          "filepath": "warning--alt-inverted/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningAltInverted",
        "global": "WarningAltInverted",
        "filepath": "WarningAltInverted.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--alt-inverted--filled",
      "friendlyName": "Warning alt inverted filled",
      "aliases": [
        "halt",
        "stop",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning--alt-inverted--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z\"/>\n  <path d=\"M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z\"/>\n  <path d=\"M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z\" data-icon-path=\"inner-path\"/><path d=\"M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z\"/><path d=\"M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z\"/></svg>",
            "info": {},
            "path": "32/warning--alt-inverted--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningAltInvertedFilled32",
          "filepath": "warning--alt-inverted--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningAltInvertedFilled24",
          "filepath": "warning--alt-inverted--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningAltInvertedFilled20",
          "filepath": "warning--alt-inverted--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningAltInvertedFilled16",
          "filepath": "warning--alt-inverted--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                }
              }
            ],
            "name": "warning--alt-inverted--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningAltInvertedFilled",
        "global": "WarningAltInvertedFilled",
        "filepath": "WarningAltInvertedFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--filled",
      "friendlyName": "Warning filled",
      "aliases": [
        "halt",
        "stop",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        16,
        20,
        24,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/warning--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;}\n</style>\n<rect id=\"Transparent_Rectangle\" class=\"st0\" width=\"16\" height=\"16\"/>\n<path id=\"Compound_Path\" d=\"M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2\n\tc-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8\n\tc0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2\tc-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z\"/><path d=\"M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8\tc0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "16/warning--filled.svg"
          }
        },
        {
          "size": 20,
          "filepath": "20/warning--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;}\n</style>\n<rect id=\"Transparent_Rectangle\" class=\"st0\" width=\"20\" height=\"20\"/>\n<path id=\"Compound_Path\" d=\"M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1\n\ts1,0.4,1,1S10.6,16,10,16z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S10.6,16,10,16z\"/><path d=\"M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "20/warning--filled.svg"
          }
        },
        {
          "size": 24,
          "filepath": "24/warning--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"Transparent_Rectangle\" class=\"st0\" width=\"24\" height=\"24\"/>\n<path id=\"Compound_Path\" d=\"M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2\n\tc-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6\n\th-1.8v8h1.8V6z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2\tc-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z\"/><path fill=\"none\" d=\"M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6\th-1.8v8h1.8V6z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "24/warning--filled.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/warning--filled.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n\t.st1{opacity:0;fill-opacity:0;}\n</style>\n<rect id=\"Transparent_Rectangle\" class=\"st0\" width=\"32\" height=\"32\"/>\n<path id=\"Compound_Path\" d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25\n\tc-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z\"/>\n<path id=\"inner-path\" class=\"st1\" d=\"M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22\n\tC16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25\tc-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z\"/><path fill=\"none\" d=\"M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22\tC16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z\" data-icon-path=\"inner-path\" opacity=\"0\"/></svg>",
            "info": {},
            "path": "32/warning--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningFilled32",
          "filepath": "warning--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25\tc-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22\tC16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "warning--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningFilled24",
          "filepath": "warning--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2\tc-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6\th-1.8v8h1.8V6z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "warning--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningFilled20",
          "filepath": "warning--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 20 20",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S10.6,16,10,16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "warning--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningFilled16",
          "filepath": "warning--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2\tc-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8\tc0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
                  "data-icon-path": "inner-path",
                  "opacity": "0"
                }
              }
            ],
            "name": "warning--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningFilled",
        "global": "WarningFilled",
        "filepath": "WarningFilled.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2 c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8 c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 20,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 20 20",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S10.6,16,10,16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 24,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2 c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6 h-1.8v8h1.8V6z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25 c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22 C16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z",
                    "data-icon-path": "inner-path",
                    "opacity": "0"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--hex",
      "friendlyName": "Warning hex",
      "aliases": [
        "warning hex",
        "status",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning--hex.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M16,21a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,21Z\"/>\n  <rect x=\"15\" y=\"8\" width=\"2\" height=\"10\"/>\n  <path d=\"M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z\"/><path d=\"M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z\"/></svg>",
            "info": {},
            "path": "32/warning--hex.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningHex32",
          "filepath": "warning--hex/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
                }
              }
            ],
            "name": "warning--hex",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningHex24",
          "filepath": "warning--hex/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
                }
              }
            ],
            "name": "warning--hex",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningHex20",
          "filepath": "warning--hex/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
                }
              }
            ],
            "name": "warning--hex",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningHex16",
          "filepath": "warning--hex/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
                }
              }
            ],
            "name": "warning--hex",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningHex",
        "global": "WarningHex",
        "filepath": "WarningHex.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--hex--filled",
      "friendlyName": "Warning hex filled",
      "aliases": [
        "warning hex filled",
        "status",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning--hex--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path id=\"inner-path\" class=\"cls-1\" d=\"M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z\"/>\n  <path d=\"M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z\" data-icon-path=\"inner-path\"/><path d=\"M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z\"/></svg>",
            "info": {},
            "path": "32/warning--hex--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningHexFilled32",
          "filepath": "warning--hex--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
                }
              }
            ],
            "name": "warning--hex--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningHexFilled24",
          "filepath": "warning--hex--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
                }
              }
            ],
            "name": "warning--hex--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningHexFilled20",
          "filepath": "warning--hex--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
                }
              }
            ],
            "name": "warning--hex--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningHexFilled16",
          "filepath": "warning--hex--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
                  "data-icon-path": "inner-path"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
                }
              }
            ],
            "name": "warning--hex--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningHexFilled",
        "global": "WarningHexFilled",
        "filepath": "WarningHexFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning--other",
      "friendlyName": "Warning other",
      "aliases": [
        "warning",
        "caution",
        "danger",
        "warn",
        "alert",
        "notification"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning--other.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"18\" y=\"20\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"24\" width=\"12\" height=\"2\"/>\n  <rect x=\"18\" y=\"28\" width=\"12\" height=\"2\"/>\n  <path d=\"M14,18a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,14,18Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"13\" y=\"7\" width=\"2\" height=\"9\"/>\n  <path d=\"M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z\"/><path d=\"M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z\"/></svg>",
            "info": {},
            "path": "32/warning--other.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningOther32",
          "filepath": "warning--other/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
                }
              }
            ],
            "name": "warning--other",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningOther24",
          "filepath": "warning--other/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
                }
              }
            ],
            "name": "warning--other",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningOther20",
          "filepath": "warning--other/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
                }
              }
            ],
            "name": "warning--other",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningOther16",
          "filepath": "warning--other/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
                }
              }
            ],
            "name": "warning--other",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningOther",
        "global": "WarningOther",
        "filepath": "WarningOther.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning-square",
      "friendlyName": "Warning square",
      "aliases": [
        "warning-square"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning-square.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>warning-square</title><path d=\"M16,20a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,20Z\"/><rect x=\"15\" y=\"9\" width=\"2\" height=\"9\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z\"/><path d=\"M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z\"/></svg>",
            "info": {},
            "path": "32/warning-square.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningSquare32",
          "filepath": "warning-square/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "warning-square",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningSquare24",
          "filepath": "warning-square/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "warning-square",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningSquare20",
          "filepath": "warning-square/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "warning-square",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningSquare16",
          "filepath": "warning-square/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                }
              }
            ],
            "name": "warning-square",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningSquare",
        "global": "WarningSquare",
        "filepath": "WarningSquare.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "warning-square--filled",
      "friendlyName": "Warning square filled",
      "aliases": [
        "warning-square"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/warning-square--filled.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>warning-square--filled</title><path d=\"M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z\"/><path id=\"inner-path\" class=\"cls-1\" d=\"M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z\"/><path fill=\"none\" d=\"M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z\" data-icon-path=\"inner-path\"/></svg>",
            "info": {},
            "path": "32/warning-square--filled.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WarningSquareFilled32",
          "filepath": "warning-square--filled/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "warning-square--filled",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WarningSquareFilled24",
          "filepath": "warning-square--filled/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "warning-square--filled",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WarningSquareFilled20",
          "filepath": "warning-square--filled/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "warning-square--filled",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WarningSquareFilled16",
          "filepath": "warning-square--filled/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
                  "data-icon-path": "inner-path"
                }
              }
            ],
            "name": "warning-square--filled",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Status",
      "moduleInfo": {
        "local": "WarningSquareFilled",
        "global": "WarningSquareFilled",
        "filepath": "WarningSquareFilled.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
                    "data-icon-path": "inner-path"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "watch",
      "friendlyName": "Watch",
      "aliases": [
        "time",
        "clock"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watch.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:#000000;}.cls-2{fill:none;}</style></defs><title>watch</title><path class=\"cls-1\" d=\"M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h1v6h2V24h6v6h2V24h1a2,2,0,0,0,2-2V10A2,2,0,0,0,22,8ZM10,22V10H22V22Z\" transform=\"translate(0 0)\"/><rect class=\"cls-1\" x=\"25\" y=\"14\" width=\"2\" height=\"4\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z\"/></svg>",
            "info": {},
            "path": "32/watch.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Watch32",
          "filepath": "watch/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
                }
              }
            ],
            "name": "watch",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Watch24",
          "filepath": "watch/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
                }
              }
            ],
            "name": "watch",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Watch20",
          "filepath": "watch/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
                }
              }
            ],
            "name": "watch",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Watch16",
          "filepath": "watch/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
                }
              }
            ],
            "name": "watch",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Watch",
        "global": "Watch",
        "filepath": "Watch.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "watson",
      "friendlyName": "Watson™",
      "aliases": [
        "ai"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson</title><path d=\"M21.74,9.49h0A11.41,11.41,0,0,0,16,8h0a.76.76,0,1,0,0,1.51,10.15,10.15,0,0,1,1.91.21c-2.26,1.08-4.76,3.58-6.73,7a22.48,22.48,0,0,0-2,4.44A9.58,9.58,0,0,1,7,17.22a3.43,3.43,0,0,1,.28-2.66v0h0c.79-1.37,2.44-2.15,4.63-2.2a.76.76,0,0,0,.74-.78.75.75,0,0,0-.78-.74C9.19,10.88,7.1,11.92,6,13.74H6v0s0,0,0,0a4.84,4.84,0,0,0-.44,3.79,12,12,0,0,0,3.2,5.22A11.36,11.36,0,0,0,8.52,26a10,10,0,0,1-2-3.48A.75.75,0,0,0,5.57,22a.76.76,0,0,0-.49,1,11.45,11.45,0,0,0,5.18,6.38h0A11.42,11.42,0,0,0,16,30.92a11.74,11.74,0,0,0,3-.39,11.48,11.48,0,0,0,2.77-21ZM18.58,29.06a9.9,9.9,0,0,1-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85,18.85,0,0,0,2.48,1.72,13.92,13.92,0,0,0,6.93,2,11,11,0,0,0,2.42-.28A9.78,9.78,0,0,1,18.58,29.06Zm6.06-4.66c-2,2-6.66,2.74-11.32.05a17.36,17.36,0,0,1-2.89-2.12,21.08,21.08,0,0,1,2.08-4.91c2.94-5.08,6.83-7.57,8.47-6.62h0A10,10,0,0,1,24.64,24.4Z\"/><path d=\"M4.16,11.72,1.14,10a.76.76,0,1,0-.76,1.31L3.4,13a.86.86,0,0,0,.38.1.77.77,0,0,0,.66-.38A.76.76,0,0,0,4.16,11.72Z\"/><path d=\"M8.29,7.59A.74.74,0,0,0,8.94,8a.75.75,0,0,0,.38-.1.76.76,0,0,0,.28-1l-1.74-3a.76.76,0,0,0-1-.27.75.75,0,0,0-.28,1Z\"/><path d=\"M16,6.08a.76.76,0,0,0,.76-.76V1.83a.76.76,0,0,0-1.52,0V5.32A.76.76,0,0,0,16,6.08Z\"/><path d=\"M22.68,7.87a.75.75,0,0,0,1-.28l1.75-3a.75.75,0,0,0-.28-1,.76.76,0,0,0-1,.27l-1.74,3A.76.76,0,0,0,22.68,7.87Z\"/><path d=\"M31.9,10.25a.76.76,0,0,0-1-.27l-3,1.74a.76.76,0,0,0-.28,1,.77.77,0,0,0,.66.38.86.86,0,0,0,.38-.1l3-1.75A.76.76,0,0,0,31.9,10.25Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z\"/></svg>",
            "info": {},
            "path": "32/watson.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Watson32",
          "filepath": "watson/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
                }
              }
            ],
            "name": "watson",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Watson24",
          "filepath": "watson/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
                }
              }
            ],
            "name": "watson",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Watson20",
          "filepath": "watson/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
                }
              }
            ],
            "name": "watson",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Watson16",
          "filepath": "watson/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
                }
              }
            ],
            "name": "watson",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "Watson",
        "global": "Watson",
        "filepath": "Watson.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "watson--machine-learning",
      "friendlyName": "IBM Watson® Machine Learning",
      "aliases": [
        "ai"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson--machine-learning.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson--machine-learning</title><path d=\"M22,26H20V17.76l-3.23,3.88a1,1,0,0,1-1.54,0L12,17.76V26H10V15a1,1,0,0,1,.66-.94,1,1,0,0,1,1.11.3L16,19.44l4.23-5.08a1,1,0,0,1,1.11-.3A1,1,0,0,1,22,15Z\" transform=\"translate(0)\"/><path d=\"M4.16,14.65l-3-1.75a.76.76,0,1,0-.76,1.32L3.4,16a.76.76,0,1,0,.76-1.31Z\" transform=\"translate(0)\"/><path d=\"M8.29,10.52a.73.73,0,0,0,1,.27.75.75,0,0,0,.28-1l-1.74-3a.76.76,0,1,0-1.32.76Z\" transform=\"translate(0)\"/><path d=\"M16,9a.76.76,0,0,0,.76-.76V4.76a.76.76,0,1,0-1.52,0V8.25A.76.76,0,0,0,16,9Z\" transform=\"translate(0)\"/><path d=\"M22.68,10.79a.75.75,0,0,0,.37.11.76.76,0,0,0,.66-.38l1.75-3a.76.76,0,0,0-1.32-.76l-1.74,3A.75.75,0,0,0,22.68,10.79Z\" transform=\"translate(0)\"/><path d=\"M31.9,13.18a.76.76,0,0,0-1-.28l-3,1.75A.76.76,0,0,0,28.6,16l3-1.74A.77.77,0,0,0,31.9,13.18Z\" transform=\"translate(0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z\"/></svg>",
            "info": {},
            "path": "32/watson--machine-learning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonMachineLearning32",
          "filepath": "watson--machine-learning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
                }
              }
            ],
            "name": "watson--machine-learning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonMachineLearning24",
          "filepath": "watson--machine-learning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
                }
              }
            ],
            "name": "watson--machine-learning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonMachineLearning20",
          "filepath": "watson--machine-learning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
                }
              }
            ],
            "name": "watson--machine-learning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonMachineLearning16",
          "filepath": "watson--machine-learning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
                }
              }
            ],
            "name": "watson--machine-learning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Brand",
      "subcategory": "IBM",
      "moduleInfo": {
        "local": "WatsonMachineLearning",
        "global": "WatsonMachineLearning",
        "filepath": "WatsonMachineLearning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wave-direction",
      "friendlyName": "Wave direction",
      "aliases": [
        "weather",
        "wave",
        "direction",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wave-direction.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"18\" cy=\"8\" r=\"1\"/>\n  <path d=\"M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z\"/><path d=\"M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z\"/><circle cx=\"18\" cy=\"8\" r=\"1\"/><path d=\"M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z\"/></svg>",
            "info": {},
            "path": "32/wave-direction.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WaveDirection32",
          "filepath": "wave-direction/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
                }
              }
            ],
            "name": "wave-direction",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WaveDirection24",
          "filepath": "wave-direction/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
                }
              }
            ],
            "name": "wave-direction",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WaveDirection20",
          "filepath": "wave-direction/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
                }
              }
            ],
            "name": "wave-direction",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WaveDirection16",
          "filepath": "wave-direction/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "18",
                  "cy": "8",
                  "r": "1"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
                }
              }
            ],
            "name": "wave-direction",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WaveDirection",
        "global": "WaveDirection",
        "filepath": "WaveDirection.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "18",
                    "cy": "8",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wave-height",
      "friendlyName": "Wave height",
      "aliases": [
        "weather",
        "wave",
        "height",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wave-height.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"24\" y=\"2\" width=\"6\" height=\"2\"/>\n  <rect x=\"24\" y=\"8\" width=\"4\" height=\"2\"/>\n  <rect x=\"24\" y=\"14\" width=\"6\" height=\"2\"/>\n  <rect x=\"24\" y=\"20\" width=\"4\" height=\"2\"/>\n  <path d=\"M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z\"/><path d=\"M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z\"/></svg>",
            "info": {},
            "path": "32/wave-height.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WaveHeight32",
          "filepath": "wave-height/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
                }
              }
            ],
            "name": "wave-height",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WaveHeight24",
          "filepath": "wave-height/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
                }
              }
            ],
            "name": "wave-height",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WaveHeight20",
          "filepath": "wave-height/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
                }
              }
            ],
            "name": "wave-height",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WaveHeight16",
          "filepath": "wave-height/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
                }
              }
            ],
            "name": "wave-height",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WaveHeight",
        "global": "WaveHeight",
        "filepath": "WaveHeight.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wave-period",
      "friendlyName": "Wave period",
      "aliases": [
        "weather",
        "wave",
        "period",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wave-period.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7935,6.7935,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0717,10.0717,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z\" transform=\"translate(0 0)\"/>\n  <rect x=\"17\" y=\"8\" width=\"2\" height=\"8\"/>\n  <path d=\"M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z\"/><path d=\"M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z\"/></svg>",
            "info": {},
            "path": "32/wave-period.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WavePeriod32",
          "filepath": "wave-period/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
                }
              }
            ],
            "name": "wave-period",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WavePeriod24",
          "filepath": "wave-period/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
                }
              }
            ],
            "name": "wave-period",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WavePeriod20",
          "filepath": "wave-period/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
                }
              }
            ],
            "name": "wave-period",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WavePeriod16",
          "filepath": "wave-period/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
                }
              }
            ],
            "name": "wave-period",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WavePeriod",
        "global": "WavePeriod",
        "filepath": "WavePeriod.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "weather-front--cold",
      "friendlyName": "Weather front cold",
      "aliases": [
        "weather",
        "front",
        "cold",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/weather-front--cold.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.1655,2a13.0289,13.0289,0,0,0-12.542,9.5791l-1.1767,4.3154A11.0237,11.0237,0,0,1,3.8345,24H2v2H3.8345c.2975,0,.5918-.0171.8853-.0371l7.9291,2.9736A1,1,0,0,0,14,28V21.0923a12.9311,12.9311,0,0,0,.9121-1.313l6.3628-1.8179a1,1,0,0,0,.5059-1.5864L17.7843,11.38a10.9268,10.9268,0,0,1,1.1516-2.3472l5.7477,1.916A1,1,0,0,0,26,10V4.2251A10.8956,10.8956,0,0,1,28.1655,4H30V2ZM8.3354,25.1826A13.047,13.047,0,0,0,12,23.0943v3.4624Zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28,16.4512ZM24,8.6123l-3.7411-1.247A11.0712,11.0712,0,0,1,24,4.8306Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"10 4 10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z\"/></svg>",
            "info": {},
            "path": "32/weather-front--cold.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WeatherFrontCold32",
          "filepath": "weather-front--cold/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--cold",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WeatherFrontCold24",
          "filepath": "weather-front--cold/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--cold",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WeatherFrontCold20",
          "filepath": "weather-front--cold/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--cold",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WeatherFrontCold16",
          "filepath": "weather-front--cold/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--cold",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WeatherFrontCold",
        "global": "WeatherFrontCold",
        "filepath": "WeatherFrontCold.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "weather-front--stationary",
      "friendlyName": "Weather front stationary",
      "aliases": [
        "weather",
        "front",
        "stationery",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/weather-front--stationary.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.1655,2a12.9848,12.9848,0,0,0-8.4074,3.1065A3.9947,3.9947,0,1,0,15.583,11.728l-1.1362,4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864,3.9864,0,0,0-5.1547,6.0054A10.9541,10.9541,0,0,1,3.8345,24H2v2H3.8345c.2975,0,.5918-.0171.8853-.0371l7.9291,2.9736A1,1,0,0,0,14,28V21.0923a12.9311,12.9311,0,0,0,.9121-1.313l6.3628-1.8179a1,1,0,0,0,.5059-1.5864L17.7843,11.38a10.9268,10.9268,0,0,1,1.1516-2.3472l5.7477,1.916A1,1,0,0,0,26,10V4.2251A10.8956,10.8956,0,0,1,28.1655,4H30V2ZM17,6a1.98,1.98,0,0,1,1.3237.53A12.9413,12.9413,0,0,0,16.24,9.8482,1.9988,1.9988,0,0,1,17,6ZM10,20a1.9879,1.9879,0,0,1,3.3374-1.4717,11.0157,11.0157,0,0,1-2.5959,3.0147A1.9975,1.9975,0,0,1,10,20ZM8.3354,25.1826A13.047,13.047,0,0,0,12,23.0943v3.4624Zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28,16.4512ZM24,8.6123l-3.7411-1.247A11.0712,11.0712,0,0,1,24,4.8306Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"22 22 22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22\"/>\n  <polygon points=\"2 2 2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z\"/></svg>",
            "info": {},
            "path": "32/weather-front--stationary.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WeatherFrontStationary32",
          "filepath": "weather-front--stationary/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
                }
              }
            ],
            "name": "weather-front--stationary",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WeatherFrontStationary24",
          "filepath": "weather-front--stationary/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
                }
              }
            ],
            "name": "weather-front--stationary",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WeatherFrontStationary20",
          "filepath": "weather-front--stationary/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
                }
              }
            ],
            "name": "weather-front--stationary",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WeatherFrontStationary16",
          "filepath": "weather-front--stationary/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
                }
              }
            ],
            "name": "weather-front--stationary",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WeatherFrontStationary",
        "global": "WeatherFrontStationary",
        "filepath": "WeatherFrontStationary.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "weather-front--warm",
      "friendlyName": "Weather front warm",
      "aliases": [
        "weather",
        "front",
        "warm",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/weather-front--warm.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M28.1655,2a13.0289,13.0289,0,0,0-12.542,9.5791l-1.1767,4.3154A11.0237,11.0237,0,0,1,3.8345,24H2v2H3.8345a12.9139,12.9139,0,0,0,3.4687-.4819,3.9979,3.9979,0,1,0,6.5818-4.2866,12.9671,12.9671,0,0,0,1.6209-2.5269,3.9944,3.9944,0,1,0,2.3772-7.5991,10.95,10.95,0,0,1,1.7253-3.01,3.9825,3.9825,0,0,0,6.9058-3.9648A10.9435,10.9435,0,0,1,28.1655,4H30V2ZM11,26a1.9983,1.9983,0,0,1-1.8118-1.1655,13.0811,13.0811,0,0,0,3.2969-2.1426A1.9773,1.9773,0,0,1,11,26Zm8-11a1.9926,1.9926,0,0,1-2.759,1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301,13.03A1.9976,1.9976,0,0,1,19,15Zm6-9a1.9942,1.9942,0,0,1-3.9011.5894,11.0511,11.0511,0,0,1,3.3623-1.9385A1.995,1.995,0,0,1,25,6Z\" transform=\"translate(0 0)\"/>\n  <polygon points=\"10 4 10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z\"/></svg>",
            "info": {},
            "path": "32/weather-front--warm.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WeatherFrontWarm32",
          "filepath": "weather-front--warm/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--warm",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WeatherFrontWarm24",
          "filepath": "weather-front--warm/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--warm",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WeatherFrontWarm20",
          "filepath": "weather-front--warm/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--warm",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WeatherFrontWarm16",
          "filepath": "weather-front--warm/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                }
              }
            ],
            "name": "weather-front--warm",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WeatherFrontWarm",
        "global": "WeatherFrontWarm",
        "filepath": "WeatherFrontWarm.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "weather-station",
      "friendlyName": "Weather station",
      "aliases": [
        "weather station",
        "weather"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/weather-station.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M9.3325,18.2168a7.0007,7.0007,0,0,1,0-10.4341l1.334,1.49a5,5,0,0,0,0,7.4537Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M22.667,18.2168l-1.334-1.49a4.9995,4.9995,0,0,0,0-7.4537l1.334-1.49a7,7,0,0,1,0,10.4341Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M6.3994,21.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,5.8a9.0009,9.0009,0,0,0,0,14.4014Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25.6006,21.8008l-1.2012-1.6a9.001,9.001,0,0,0,0-14.4019l1.2012-1.6a11.002,11.002,0,0,1,0,17.6011Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z\"/><path d=\"M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z\"/><path d=\"M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z\"/></svg>",
            "info": {},
            "path": "32/weather-station.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WeatherStation32",
          "filepath": "weather-station/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
                }
              }
            ],
            "name": "weather-station",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WeatherStation24",
          "filepath": "weather-station/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
                }
              }
            ],
            "name": "weather-station",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WeatherStation20",
          "filepath": "weather-station/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
                }
              }
            ],
            "name": "weather-station",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WeatherStation16",
          "filepath": "weather-station/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
                }
              }
            ],
            "name": "weather-station",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WeatherStation",
        "global": "WeatherStation",
        "filepath": "WeatherStation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "webhook",
      "friendlyName": "Webhook",
      "aliases": [
        "webhook",
        "callback"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/webhook.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z\"/>\n  <path d=\"M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z\"/>\n  <path d=\"M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z\"/><path d=\"M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z\"/><path d=\"M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z\"/></svg>",
            "info": {},
            "path": "32/webhook.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Webhook32",
          "filepath": "webhook/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z"
                }
              }
            ],
            "name": "webhook",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Webhook24",
          "filepath": "webhook/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z"
                }
              }
            ],
            "name": "webhook",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Webhook20",
          "filepath": "webhook/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z"
                }
              }
            ],
            "name": "webhook",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Webhook16",
          "filepath": "webhook/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z"
                }
              }
            ],
            "name": "webhook",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Webhook",
        "global": "Webhook",
        "filepath": "Webhook.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "websheet",
      "friendlyName": "Websheet",
      "aliases": [
        "file",
        "websheet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/websheet.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <circle cx=\"24\" cy=\"24\" r=\"2\"/>\n  <path d=\"M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z\"/>\n  <path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"24\" cy=\"24\" r=\"2\"/><path d=\"M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z\"/><path d=\"M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z\"/></svg>",
            "info": {},
            "path": "32/websheet.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Websheet32",
          "filepath": "websheet/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "websheet",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Websheet24",
          "filepath": "websheet/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "websheet",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Websheet20",
          "filepath": "websheet/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "websheet",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Websheet16",
          "filepath": "websheet/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "24",
                  "cy": "24",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                }
              }
            ],
            "name": "websheet",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Websheet",
        "global": "Websheet",
        "filepath": "Websheet.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "24",
                    "cy": "24",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wheat",
      "friendlyName": "Wheat",
      "aliases": [
        "wheat",
        "food",
        "crop",
        "agriculture"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wheat.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>wheat</title><path d=\"M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z\"/></svg>",
            "info": {},
            "path": "32/wheat.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Wheat32",
          "filepath": "wheat/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
                }
              }
            ],
            "name": "wheat",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Wheat24",
          "filepath": "wheat/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
                }
              }
            ],
            "name": "wheat",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Wheat20",
          "filepath": "wheat/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
                }
              }
            ],
            "name": "wheat",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Wheat16",
          "filepath": "wheat/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
                }
              }
            ],
            "name": "wheat",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "Wheat",
        "global": "Wheat",
        "filepath": "Wheat.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wifi",
      "friendlyName": "WiFi",
      "aliases": [
        "wifi",
        "internet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wifi.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>wifi</title><circle cx=\"16\" cy=\"25\" r=\"2\"/><path d=\"M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z\"/><path d=\"M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z\"/><path d=\"M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"25\" r=\"2\"/><path d=\"M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z\"/><path d=\"M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z\"/><path d=\"M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z\"/></svg>",
            "info": {},
            "path": "32/wifi.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Wifi32",
          "filepath": "wifi/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
                }
              }
            ],
            "name": "wifi",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Wifi24",
          "filepath": "wifi/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
                }
              }
            ],
            "name": "wifi",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Wifi20",
          "filepath": "wifi/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
                }
              }
            ],
            "name": "wifi",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Wifi16",
          "filepath": "wifi/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
                }
              }
            ],
            "name": "wifi",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Wifi",
        "global": "Wifi",
        "filepath": "Wifi.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "25",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wifi--controller",
      "friendlyName": "WiFi controller",
      "aliases": [
        "wifi",
        "internet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wifi--controller.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z\" transform=\"translate(0 0)\"/>\n  <circle cx=\"9\" cy=\"25\" r=\"1\"/>\n  <circle cx=\"16\" cy=\"14.5\" r=\"1.5\"/>\n  <path d=\"M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z\"/><circle cx=\"9\" cy=\"25\" r=\"1\"/><circle cx=\"16\" cy=\"14.5\" r=\"1.5\"/><path d=\"M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z\"/><path d=\"M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z\"/></svg>",
            "info": {},
            "path": "32/wifi--controller.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WifiController32",
          "filepath": "wifi--controller/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z"
                }
              }
            ],
            "name": "wifi--controller",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WifiController24",
          "filepath": "wifi--controller/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z"
                }
              }
            ],
            "name": "wifi--controller",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WifiController20",
          "filepath": "wifi--controller/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z"
                }
              }
            ],
            "name": "wifi--controller",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WifiController16",
          "filepath": "wifi--controller/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "9",
                  "cy": "25",
                  "r": "1"
                }
              },
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "14.5",
                  "r": "1.5"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z"
                }
              }
            ],
            "name": "wifi--controller",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "WifiController",
        "global": "WifiController",
        "filepath": "WifiController.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "9",
                    "cy": "25",
                    "r": "1"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "14.5",
                    "r": "1.5"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wifi--not-secure",
      "friendlyName": "WiFi not secure",
      "aliases": [
        "wifi",
        "internet",
        "unlocked",
        "open"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wifi--not-secure.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,20H14V17a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm0,8H12V22h8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 20H14V17a2 2 0 014 0h2a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm0 8H12V22h8zM16 8a8.9709 8.9709 0 00-6.3608 2.6392l1.4133 1.4135a6.9887 6.9887 0 019.895 0l1.4135-1.4135A8.9717 8.9717 0 0016 8z\"/><path d=\"M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z\"/></svg>",
            "info": {},
            "path": "32/wifi--not-secure.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WifiNotSecure32",
          "filepath": "wifi--not-secure/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H14V17a2 2 0 014 0h2a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm0 8H12V22h8zM16 8a8.9709 8.9709 0 00-6.3608 2.6392l1.4133 1.4135a6.9887 6.9887 0 019.895 0l1.4135-1.4135A8.9717 8.9717 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
                }
              }
            ],
            "name": "wifi--not-secure",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WifiNotSecure24",
          "filepath": "wifi--not-secure/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H14V17a2 2 0 014 0h2a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm0 8H12V22h8zM16 8a8.9709 8.9709 0 00-6.3608 2.6392l1.4133 1.4135a6.9887 6.9887 0 019.895 0l1.4135-1.4135A8.9717 8.9717 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
                }
              }
            ],
            "name": "wifi--not-secure",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WifiNotSecure20",
          "filepath": "wifi--not-secure/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H14V17a2 2 0 014 0h2a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm0 8H12V22h8zM16 8a8.9709 8.9709 0 00-6.3608 2.6392l1.4133 1.4135a6.9887 6.9887 0 019.895 0l1.4135-1.4135A8.9717 8.9717 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
                }
              }
            ],
            "name": "wifi--not-secure",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WifiNotSecure16",
          "filepath": "wifi--not-secure/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20H14V17a2 2 0 014 0h2a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm0 8H12V22h8zM16 8a8.9709 8.9709 0 00-6.3608 2.6392l1.4133 1.4135a6.9887 6.9887 0 019.895 0l1.4135-1.4135A8.9717 8.9717 0 0016 8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
                }
              }
            ],
            "name": "wifi--not-secure",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "WifiNotSecure",
        "global": "WifiNotSecure",
        "filepath": "WifiNotSecure.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20H14V17a2 2 0 014 0h2a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm0 8H12V22h8zM16 8a8.9709 8.9709 0 00-6.3608 2.6392l1.4133 1.4135a6.9887 6.9887 0 019.895 0l1.4135-1.4135A8.9717 8.9717 0 0016 8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wifi--off",
      "friendlyName": "WiFi off",
      "aliases": [
        "wifi",
        "internet",
        "off",
        "unavailable"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wifi--off.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>wifi--off</title><circle cx=\"16\" cy=\"25\" r=\"2\"/><path d=\"M30,3.4141,28.5859,2,2,28.5859,3.4141,30,14.0962,19.3179a5.9359,5.9359,0,0,1,6.01,1.3193L21.52,19.2236a7.9669,7.9669,0,0,0-5.125-2.2041l3.3875-3.3877a11.9908,11.9908,0,0,1,4.5647,2.7647L25.76,14.9829A13.975,13.975,0,0,0,21.334,12.08L24.3308,9.083a17.9364,17.9364,0,0,1,4.2546,3.0747L30,10.7432v-.002a20.02,20.02,0,0,0-4.1895-3.1377Z\"/><path d=\"M14.68,13.0776l2.0415-2.0415C16.481,11.0234,16.2437,11,16,11a13.9447,13.9447,0,0,0-9.771,3.9927l1.4136,1.4136A11.97,11.97,0,0,1,14.68,13.0776Z\"/><path d=\"M16,7a17.87,17.87,0,0,1,4.2324.5254L21.875,5.8828A19.9537,19.9537,0,0,0,2,10.7412v.0225L3.4043,12.168A17.9193,17.9193,0,0,1,16,7Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle cx=\"16\" cy=\"25\" r=\"2\"/><path d=\"M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z\"/></svg>",
            "info": {},
            "path": "32/wifi--off.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WifiOff32",
          "filepath": "wifi--off/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
                }
              }
            ],
            "name": "wifi--off",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WifiOff24",
          "filepath": "wifi--off/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
                }
              }
            ],
            "name": "wifi--off",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WifiOff20",
          "filepath": "wifi--off/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
                }
              }
            ],
            "name": "wifi--off",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WifiOff16",
          "filepath": "wifi--off/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "circle",
                "attrs": {
                  "cx": "16",
                  "cy": "25",
                  "r": "2"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
                }
              }
            ],
            "name": "wifi--off",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "WifiOff",
        "global": "WifiOff",
        "filepath": "WifiOff.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "circle",
                  "attributes": {
                    "cx": "16",
                    "cy": "25",
                    "r": "2"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wifi--secure",
      "friendlyName": "WiFi secure",
      "aliases": [
        "wifi",
        "internet",
        "locked",
        "secure"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wifi--secure.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8v6Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 20V17a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm-6-3a2 2 0 014 0v3H14zM12 28V22h8v6zM6.105 7.105L7.5188 8.5186a11.9808 11.9808 0 0116.9624 0L25.8949 7.105a13.9782 13.9782 0 00-19.79 0z\"/><path d=\"M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z\"/></svg>",
            "info": {},
            "path": "32/wifi--secure.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WifiSecure32",
          "filepath": "wifi--secure/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20V17a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm-6-3a2 2 0 014 0v3H14zM12 28V22h8v6zM6.105 7.105L7.5188 8.5186a11.9808 11.9808 0 0116.9624 0L25.8949 7.105a13.9782 13.9782 0 00-19.79 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
                }
              }
            ],
            "name": "wifi--secure",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WifiSecure24",
          "filepath": "wifi--secure/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20V17a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm-6-3a2 2 0 014 0v3H14zM12 28V22h8v6zM6.105 7.105L7.5188 8.5186a11.9808 11.9808 0 0116.9624 0L25.8949 7.105a13.9782 13.9782 0 00-19.79 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
                }
              }
            ],
            "name": "wifi--secure",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WifiSecure20",
          "filepath": "wifi--secure/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20V17a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm-6-3a2 2 0 014 0v3H14zM12 28V22h8v6zM6.105 7.105L7.5188 8.5186a11.9808 11.9808 0 0116.9624 0L25.8949 7.105a13.9782 13.9782 0 00-19.79 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
                }
              }
            ],
            "name": "wifi--secure",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WifiSecure16",
          "filepath": "wifi--secure/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 20V17a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm-6-3a2 2 0 014 0v3H14zM12 28V22h8v6zM6.105 7.105L7.5188 8.5186a11.9808 11.9808 0 0116.9624 0L25.8949 7.105a13.9782 13.9782 0 00-19.79 0z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
                }
              }
            ],
            "name": "wifi--secure",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "WifiSecure",
        "global": "WifiSecure",
        "filepath": "WifiSecure.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 20V17a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm-6-3a2 2 0 014 0v3H14zM12 28V22h8v6zM6.105 7.105L7.5188 8.5186a11.9808 11.9808 0 0116.9624 0L25.8949 7.105a13.9782 13.9782 0 00-19.79 0z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wifi-bridge",
      "friendlyName": "WiFi bridge",
      "aliases": [
        "wifi",
        "internet",
        "connection",
        "bridge"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wifi-bridge.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M10.4854,24.4854,9.0713,23.0713a10.0011,10.0011,0,0,0,0-14.1426l1.4141-1.4141a12.0006,12.0006,0,0,1,0,16.9708Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M25.0508,20.95a7,7,0,0,1,0-9.9l1.414,1.4146a5,5,0,0,0,0,7.0715Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M21.5146,24.4854a12.0006,12.0006,0,0,1,0-16.9708l1.4141,1.4141a10.0011,10.0011,0,0,0,0,14.1426Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M3,15H2V4H0V28H2V17H3a1,1,0,0,0,0-2Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M30,4V15H29a1,1,0,0,0,0,2h1V28h2V4Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z\"/><path d=\"M10.4854 24.4854L9.0713 23.0713a10.0011 10.0011 0 000-14.1426l1.4141-1.4141a12.0006 12.0006 0 010 16.9708zM25.0508 20.95a7 7 0 010-9.9l1.414 1.4146a5 5 0 000 7.0715z\"/><path d=\"M21.5146 24.4854a12.0006 12.0006 0 010-16.9708l1.4141 1.4141a10.0011 10.0011 0 000 14.1426zM3 15H2V4H0V28H2V17H3a1 1 0 000-2zM30 4V15H29a1 1 0 000 2h1V28h2V4z\"/></svg>",
            "info": {},
            "path": "32/wifi-bridge.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WifiBridge32",
          "filepath": "wifi-bridge/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.4854 24.4854L9.0713 23.0713a10.0011 10.0011 0 000-14.1426l1.4141-1.4141a12.0006 12.0006 0 010 16.9708zM25.0508 20.95a7 7 0 010-9.9l1.414 1.4146a5 5 0 000 7.0715z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5146 24.4854a12.0006 12.0006 0 010-16.9708l1.4141 1.4141a10.0011 10.0011 0 000 14.1426zM3 15H2V4H0V28H2V17H3a1 1 0 000-2zM30 4V15H29a1 1 0 000 2h1V28h2V4z"
                }
              }
            ],
            "name": "wifi-bridge",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WifiBridge24",
          "filepath": "wifi-bridge/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.4854 24.4854L9.0713 23.0713a10.0011 10.0011 0 000-14.1426l1.4141-1.4141a12.0006 12.0006 0 010 16.9708zM25.0508 20.95a7 7 0 010-9.9l1.414 1.4146a5 5 0 000 7.0715z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5146 24.4854a12.0006 12.0006 0 010-16.9708l1.4141 1.4141a10.0011 10.0011 0 000 14.1426zM3 15H2V4H0V28H2V17H3a1 1 0 000-2zM30 4V15H29a1 1 0 000 2h1V28h2V4z"
                }
              }
            ],
            "name": "wifi-bridge",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WifiBridge20",
          "filepath": "wifi-bridge/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.4854 24.4854L9.0713 23.0713a10.0011 10.0011 0 000-14.1426l1.4141-1.4141a12.0006 12.0006 0 010 16.9708zM25.0508 20.95a7 7 0 010-9.9l1.414 1.4146a5 5 0 000 7.0715z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5146 24.4854a12.0006 12.0006 0 010-16.9708l1.4141 1.4141a10.0011 10.0011 0 000 14.1426zM3 15H2V4H0V28H2V17H3a1 1 0 000-2zM30 4V15H29a1 1 0 000 2h1V28h2V4z"
                }
              }
            ],
            "name": "wifi-bridge",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WifiBridge16",
          "filepath": "wifi-bridge/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.4854 24.4854L9.0713 23.0713a10.0011 10.0011 0 000-14.1426l1.4141-1.4141a12.0006 12.0006 0 010 16.9708zM25.0508 20.95a7 7 0 010-9.9l1.414 1.4146a5 5 0 000 7.0715z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5146 24.4854a12.0006 12.0006 0 010-16.9708l1.4141 1.4141a10.0011 10.0011 0 000 14.1426zM3 15H2V4H0V28H2V17H3a1 1 0 000-2zM30 4V15H29a1 1 0 000 2h1V28h2V4z"
                }
              }
            ],
            "name": "wifi-bridge",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "WifiBridge",
        "global": "WifiBridge",
        "filepath": "WifiBridge.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.4854 24.4854L9.0713 23.0713a10.0011 10.0011 0 000-14.1426l1.4141-1.4141a12.0006 12.0006 0 010 16.9708zM25.0508 20.95a7 7 0 010-9.9l1.414 1.4146a5 5 0 000 7.0715z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.5146 24.4854a12.0006 12.0006 0 010-16.9708l1.4141 1.4141a10.0011 10.0011 0 000 14.1426zM3 15H2V4H0V28H2V17H3a1 1 0 000-2zM30 4V15H29a1 1 0 000 2h1V28h2V4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wifi-bridge--alt",
      "friendlyName": "WiFi bridge alt",
      "aliases": [
        "wifi",
        "internet",
        "connection",
        "bridge"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wifi-bridge--alt.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M18,26H16A10.0113,10.0113,0,0,0,6,16V14A12.0137,12.0137,0,0,1,18,26Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,13a7.0078,7.0078,0,0,1-7-7h2a5.0057,5.0057,0,0,0,5,5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,18A12.0137,12.0137,0,0,1,14,6h2A10.0113,10.0113,0,0,0,26,16Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M7.707,24.293a.9994.9994,0,0,0-1.414,0L2,28.5859,3.4143,30,7.707,25.707A.9994.9994,0,0,0,7.707,24.293Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M28.5859,2,24.293,6.293a1,1,0,0,0,1.414,1.414L30,3.4141Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z\"/><path d=\"M18 26H16A10.0113 10.0113 0 006 16V14A12.0137 12.0137 0 0118 26zM26 13a7.0078 7.0078 0 01-7-7h2a5.0057 5.0057 0 005 5z\"/><path d=\"M26 18A12.0137 12.0137 0 0114 6h2A10.0113 10.0113 0 0026 16zM7.707 24.293a.9994.9994 0 00-1.414 0L2 28.5859 3.4143 30 7.707 25.707A.9994.9994 0 007.707 24.293zM28.5859 2L24.293 6.293a1 1 0 001.414 1.414L30 3.4141z\"/></svg>",
            "info": {},
            "path": "32/wifi-bridge--alt.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WifiBridgeAlt32",
          "filepath": "wifi-bridge--alt/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H16A10.0113 10.0113 0 006 16V14A12.0137 12.0137 0 0118 26zM26 13a7.0078 7.0078 0 01-7-7h2a5.0057 5.0057 0 005 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18A12.0137 12.0137 0 0114 6h2A10.0113 10.0113 0 0026 16zM7.707 24.293a.9994.9994 0 00-1.414 0L2 28.5859 3.4143 30 7.707 25.707A.9994.9994 0 007.707 24.293zM28.5859 2L24.293 6.293a1 1 0 001.414 1.414L30 3.4141z"
                }
              }
            ],
            "name": "wifi-bridge--alt",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WifiBridgeAlt24",
          "filepath": "wifi-bridge--alt/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H16A10.0113 10.0113 0 006 16V14A12.0137 12.0137 0 0118 26zM26 13a7.0078 7.0078 0 01-7-7h2a5.0057 5.0057 0 005 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18A12.0137 12.0137 0 0114 6h2A10.0113 10.0113 0 0026 16zM7.707 24.293a.9994.9994 0 00-1.414 0L2 28.5859 3.4143 30 7.707 25.707A.9994.9994 0 007.707 24.293zM28.5859 2L24.293 6.293a1 1 0 001.414 1.414L30 3.4141z"
                }
              }
            ],
            "name": "wifi-bridge--alt",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WifiBridgeAlt20",
          "filepath": "wifi-bridge--alt/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H16A10.0113 10.0113 0 006 16V14A12.0137 12.0137 0 0118 26zM26 13a7.0078 7.0078 0 01-7-7h2a5.0057 5.0057 0 005 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18A12.0137 12.0137 0 0114 6h2A10.0113 10.0113 0 0026 16zM7.707 24.293a.9994.9994 0 00-1.414 0L2 28.5859 3.4143 30 7.707 25.707A.9994.9994 0 007.707 24.293zM28.5859 2L24.293 6.293a1 1 0 001.414 1.414L30 3.4141z"
                }
              }
            ],
            "name": "wifi-bridge--alt",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WifiBridgeAlt16",
          "filepath": "wifi-bridge--alt/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 26H16A10.0113 10.0113 0 006 16V14A12.0137 12.0137 0 0118 26zM26 13a7.0078 7.0078 0 01-7-7h2a5.0057 5.0057 0 005 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 18A12.0137 12.0137 0 0114 6h2A10.0113 10.0113 0 0026 16zM7.707 24.293a.9994.9994 0 00-1.414 0L2 28.5859 3.4143 30 7.707 25.707A.9994.9994 0 007.707 24.293zM28.5859 2L24.293 6.293a1 1 0 001.414 1.414L30 3.4141z"
                }
              }
            ],
            "name": "wifi-bridge--alt",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "WifiBridgeAlt",
        "global": "WifiBridgeAlt",
        "filepath": "WifiBridgeAlt.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 26H16A10.0113 10.0113 0 006 16V14A12.0137 12.0137 0 0118 26zM26 13a7.0078 7.0078 0 01-7-7h2a5.0057 5.0057 0 005 5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 18A12.0137 12.0137 0 0114 6h2A10.0113 10.0113 0 0026 16zM7.707 24.293a.9994.9994 0 00-1.414 0L2 28.5859 3.4143 30 7.707 25.707A.9994.9994 0 007.707 24.293zM28.5859 2L24.293 6.293a1 1 0 001.414 1.414L30 3.4141z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wikis",
      "friendlyName": "Wikis",
      "aliases": [
        "globe",
        "wikipedia",
        "earth",
        "world",
        "international"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wikis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>wikis</title><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\" transform=\"translate(32 0) rotate(90)\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z\"/></svg>",
            "info": {},
            "path": "32/wikis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Wikis32",
          "filepath": "wikis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
                }
              }
            ],
            "name": "wikis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Wikis24",
          "filepath": "wikis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
                }
              }
            ],
            "name": "wikis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Wikis20",
          "filepath": "wikis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
                }
              }
            ],
            "name": "wikis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Wikis16",
          "filepath": "wikis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
                }
              }
            ],
            "name": "wikis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Tools",
      "subcategory": "Technology",
      "moduleInfo": {
        "local": "Wikis",
        "global": "Wikis",
        "filepath": "Wikis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wind-gusts",
      "friendlyName": "Wind gusts",
      "aliases": [
        "weather",
        "wind",
        "gusts",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wind-gusts.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z\"/><path d=\"M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z\"/><path d=\"M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z\"/></svg>",
            "info": {},
            "path": "32/wind-gusts.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WindGusts32",
          "filepath": "wind-gusts/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
                }
              }
            ],
            "name": "wind-gusts",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WindGusts24",
          "filepath": "wind-gusts/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
                }
              }
            ],
            "name": "wind-gusts",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WindGusts20",
          "filepath": "wind-gusts/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
                }
              }
            ],
            "name": "wind-gusts",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WindGusts16",
          "filepath": "wind-gusts/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
                }
              }
            ],
            "name": "wind-gusts",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WindGusts",
        "global": "WindGusts",
        "filepath": "WindGusts.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wind-power",
      "friendlyName": "Wind power",
      "aliases": [
        "turbine",
        "wind energy",
        "energy",
        "alternative",
        "green"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wind-power.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z\"/></svg>",
            "info": {},
            "path": "32/wind-power.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WindPower32",
          "filepath": "wind-power/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z"
                }
              }
            ],
            "name": "wind-power",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WindPower24",
          "filepath": "wind-power/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z"
                }
              }
            ],
            "name": "wind-power",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WindPower20",
          "filepath": "wind-power/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z"
                }
              }
            ],
            "name": "wind-power",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WindPower16",
          "filepath": "wind-power/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z"
                }
              }
            ],
            "name": "wind-power",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WindPower",
        "global": "WindPower",
        "filepath": "WindPower.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wind-stream",
      "friendlyName": "Wind stream",
      "aliases": [
        "weather",
        "wind",
        "stream",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wind-stream.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z\"/><path d=\"M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z\"/><path d=\"M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z\"/></svg>",
            "info": {},
            "path": "32/wind-stream.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WindStream32",
          "filepath": "wind-stream/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
                }
              }
            ],
            "name": "wind-stream",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WindStream24",
          "filepath": "wind-stream/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
                }
              }
            ],
            "name": "wind-stream",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WindStream20",
          "filepath": "wind-stream/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
                }
              }
            ],
            "name": "wind-stream",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WindStream16",
          "filepath": "wind-stream/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
                }
              }
            ],
            "name": "wind-stream",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WindStream",
        "global": "WindStream",
        "filepath": "WindStream.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "window--auto",
      "friendlyName": "Window auto",
      "aliases": [
        "brightness",
        "contrast",
        "sun"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/window--auto.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--auto-window-level</title><rect x=\"15\" y=\"4\" width=\"2\" height=\"3\"/><rect x=\"25\" y=\"15\" width=\"3\" height=\"2\"/><rect x=\"15\" y=\"25\" width=\"2\" height=\"3\"/><rect x=\"4\" y=\"15\" width=\"3\" height=\"2\"/><rect x=\"7.55\" y=\"7.04\" width=\"2\" height=\"3\" transform=\"translate(-3.54 8.55) rotate(-45)\"/><rect x=\"21.96\" y=\"7.55\" width=\"3\" height=\"2\" transform=\"translate(0.82 19.09) rotate(-45)\"/><rect x=\"22.45\" y=\"21.95\" width=\"2\" height=\"3\" transform=\"translate(-9.71 23.45) rotate(-45)\"/><rect x=\"7.05\" y=\"22.45\" width=\"3\" height=\"2\" transform=\"translate(-14.08 12.91) rotate(-45)\"/><rect x=\"4\" y=\"30\" width=\"24\" height=\"2\"/><rect x=\"4\" width=\"24\" height=\"2\"/><path d=\"M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm-4,6a4,4,0,0,1,4-4v8A4,4,0,0,1,12,16Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z\"/><path d=\"M7.55 7.04H9.55V10.04H7.55z\" transform=\"rotate(-45 8.55 8.548)\"/><path d=\"M21.96 7.55H24.96V9.55H21.96z\" transform=\"rotate(-45 23.454 8.555)\"/><path d=\"M22.45 21.95H24.45V24.95H22.45z\" transform=\"rotate(-45 23.452 23.446)\"/><path d=\"M7.05 22.45H10.05V24.45H7.05z\" transform=\"rotate(-45 8.544 23.451)\"/><path d=\"M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z\"/></svg>",
            "info": {},
            "path": "32/watson-health/window--auto.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthWindowAuto32",
          "filepath": "watson-health/window--auto/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 7.04H9.55V10.04H7.55z",
                  "transform": "rotate(-45 8.55 8.548)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 7.55H24.96V9.55H21.96z",
                  "transform": "rotate(-45 23.454 8.555)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45 21.95H24.45V24.95H22.45z",
                  "transform": "rotate(-45 23.452 23.446)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.05 22.45H10.05V24.45H7.05z",
                  "transform": "rotate(-45 8.544 23.451)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
                }
              }
            ],
            "name": "window--auto",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthWindowAuto24",
          "filepath": "watson-health/window--auto/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 7.04H9.55V10.04H7.55z",
                  "transform": "rotate(-45 8.55 8.548)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 7.55H24.96V9.55H21.96z",
                  "transform": "rotate(-45 23.454 8.555)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45 21.95H24.45V24.95H22.45z",
                  "transform": "rotate(-45 23.452 23.446)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.05 22.45H10.05V24.45H7.05z",
                  "transform": "rotate(-45 8.544 23.451)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
                }
              }
            ],
            "name": "window--auto",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthWindowAuto20",
          "filepath": "watson-health/window--auto/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 7.04H9.55V10.04H7.55z",
                  "transform": "rotate(-45 8.55 8.548)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 7.55H24.96V9.55H21.96z",
                  "transform": "rotate(-45 23.454 8.555)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45 21.95H24.45V24.95H22.45z",
                  "transform": "rotate(-45 23.452 23.446)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.05 22.45H10.05V24.45H7.05z",
                  "transform": "rotate(-45 8.544 23.451)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
                }
              }
            ],
            "name": "window--auto",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthWindowAuto16",
          "filepath": "watson-health/window--auto/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 7.04H9.55V10.04H7.55z",
                  "transform": "rotate(-45 8.55 8.548)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 7.55H24.96V9.55H21.96z",
                  "transform": "rotate(-45 23.454 8.555)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.45 21.95H24.45V24.95H22.45z",
                  "transform": "rotate(-45 23.452 23.446)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.05 22.45H10.05V24.45H7.05z",
                  "transform": "rotate(-45 8.544 23.451)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
                }
              }
            ],
            "name": "window--auto",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "WindowAuto",
        "global": "WatsonHealthWindowAuto",
        "filepath": "watson-health/WindowAuto.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.55 7.04H9.55V10.04H7.55z",
                    "transform": "rotate(-45 8.55 8.548)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.96 7.55H24.96V9.55H21.96z",
                    "transform": "rotate(-45 23.454 8.555)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.45 21.95H24.45V24.95H22.45z",
                    "transform": "rotate(-45 23.452 23.446)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.05 22.45H10.05V24.45H7.05z",
                    "transform": "rotate(-45 8.544 23.451)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "window--base",
      "friendlyName": "Window base",
      "aliases": [
        "brightness",
        "contrast",
        "sun"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/window--base.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--window--base</title><rect x=\"15\" y=\"2\" width=\"2\" height=\"3\"/><rect x=\"25\" y=\"13\" width=\"3\" height=\"2\"/><rect x=\"15\" y=\"23\" width=\"2\" height=\"3\"/><rect x=\"4\" y=\"13\" width=\"3\" height=\"2\"/><rect x=\"7.55\" y=\"5.03\" width=\"2\" height=\"3\" transform=\"translate(-2.12 7.97) rotate(-45)\"/><rect x=\"21.96\" y=\"5.54\" width=\"3\" height=\"2\" transform=\"translate(2.25 18.51) rotate(-45)\"/><rect x=\"22.46\" y=\"19.94\" width=\"2\" height=\"3\" transform=\"translate(-8.29 22.87) rotate(-45)\"/><rect x=\"7.04\" y=\"20.45\" width=\"3\" height=\"2\" transform=\"translate(-12.66 12.33) rotate(-45)\"/><rect x=\"4\" y=\"28\" width=\"24\" height=\"2\"/><path d=\"M16,20a6,6,0,1,0-6-6A6,6,0,0,0,16,20Zm0-10v8a4,4,0,0,1,0-8Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z\"/><path d=\"M7.55 5.03H9.55V8.030000000000001H7.55z\" transform=\"rotate(-45 8.56 6.544)\"/><path d=\"M21.96 5.54H24.96V7.54H21.96z\" transform=\"rotate(-45 23.469 6.539)\"/><path d=\"M22.46 19.94H24.46V22.94H22.46z\" transform=\"rotate(-45 23.462 21.442)\"/><path d=\"M7.04 20.45H10.04V22.45H7.04z\" transform=\"rotate(-45 8.554 21.447)\"/><path d=\"M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/window--base.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthWindowBase32",
          "filepath": "watson-health/window--base/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 5.03H9.55V8.030000000000001H7.55z",
                  "transform": "rotate(-45 8.56 6.544)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 5.54H24.96V7.54H21.96z",
                  "transform": "rotate(-45 23.469 6.539)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 19.94H24.46V22.94H22.46z",
                  "transform": "rotate(-45 23.462 21.442)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 20.45H10.04V22.45H7.04z",
                  "transform": "rotate(-45 8.554 21.447)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--base",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthWindowBase24",
          "filepath": "watson-health/window--base/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 5.03H9.55V8.030000000000001H7.55z",
                  "transform": "rotate(-45 8.56 6.544)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 5.54H24.96V7.54H21.96z",
                  "transform": "rotate(-45 23.469 6.539)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 19.94H24.46V22.94H22.46z",
                  "transform": "rotate(-45 23.462 21.442)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 20.45H10.04V22.45H7.04z",
                  "transform": "rotate(-45 8.554 21.447)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--base",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthWindowBase20",
          "filepath": "watson-health/window--base/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 5.03H9.55V8.030000000000001H7.55z",
                  "transform": "rotate(-45 8.56 6.544)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 5.54H24.96V7.54H21.96z",
                  "transform": "rotate(-45 23.469 6.539)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 19.94H24.46V22.94H22.46z",
                  "transform": "rotate(-45 23.462 21.442)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 20.45H10.04V22.45H7.04z",
                  "transform": "rotate(-45 8.554 21.447)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--base",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthWindowBase16",
          "filepath": "watson-health/window--base/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 5.03H9.55V8.030000000000001H7.55z",
                  "transform": "rotate(-45 8.56 6.544)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 5.54H24.96V7.54H21.96z",
                  "transform": "rotate(-45 23.469 6.539)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 19.94H24.46V22.94H22.46z",
                  "transform": "rotate(-45 23.462 21.442)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 20.45H10.04V22.45H7.04z",
                  "transform": "rotate(-45 8.554 21.447)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--base",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "WindowBase",
        "global": "WatsonHealthWindowBase",
        "filepath": "watson-health/WindowBase.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.55 5.03H9.55V8.030000000000001H7.55z",
                    "transform": "rotate(-45 8.56 6.544)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.96 5.54H24.96V7.54H21.96z",
                    "transform": "rotate(-45 23.469 6.539)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.46 19.94H24.46V22.94H22.46z",
                    "transform": "rotate(-45 23.462 21.442)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.04 20.45H10.04V22.45H7.04z",
                    "transform": "rotate(-45 8.554 21.447)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "window--black-saturation",
      "friendlyName": "Window black saturation",
      "aliases": [
        "Watson",
        "IBM Watson",
        "Watson Health",
        "contour",
        "outline",
        "imaging",
        "image"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/window--black-saturation.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15\" y=\"2\" width=\"2\" height=\"3\"/>\n  <rect x=\"27\" y=\"15\" width=\"3\" height=\"2\"/>\n  <rect x=\"15\" y=\"27\" width=\"2\" height=\"3\"/>\n  <rect x=\"2\" y=\"15\" width=\"3\" height=\"2\"/>\n  <rect x=\"6.2249\" y=\"5.7288\" width=\"2.0034\" height=\"3.0034\" transform=\"translate(-2.9961 7.2278) rotate(-45)\"/>\n  <rect x=\"23.2674\" y=\"6.2273\" width=\"3\" height=\"2\" transform=\"translate(2.1437 19.63) rotate(-45)\"/>\n  <rect x=\"23.7687\" y=\"23.2686\" width=\"2.0016\" height=\"3.0016\" transform=\"translate(-10.2598 24.7686) rotate(-44.9986)\"/>\n  <polygon points=\"5.47 25.126 7.591 23 9 24.419 6.884 26.54 5.47 25.126\"/>\n  <rect x=\"15\" y=\"13\" width=\"2\" height=\"2\"/>\n  <rect x=\"19\" y=\"13\" width=\"2\" height=\"2\"/>\n  <rect x=\"17\" y=\"11\" width=\"2\" height=\"2\"/>\n  <rect x=\"17\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"17\" y=\"19\" width=\"2\" height=\"2\"/>\n  <rect x=\"15\" y=\"17\" width=\"2\" height=\"2\"/>\n  <rect x=\"19\" y=\"17\" width=\"2\" height=\"2\"/>\n  <path d=\"M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z\"/><path d=\"M6.225 5.729H8.228V8.732H6.225z\" transform=\"rotate(-45 7.227 7.23)\"/><path d=\"M23.267 6.227H26.267V8.227H23.267z\" transform=\"rotate(-45 24.767 7.227)\"/><path d=\"M23.769 23.269H25.770999999999997V26.270999999999997H23.769z\" transform=\"rotate(-44.999 24.77 24.77)\"/><path d=\"M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126zM15 13H17V15H15zM19 13H21V15H19zM17 11H19V13H17zM17 15H19V17H17zM17 19H19V21H17zM15 17H17V19H15zM19 17H21V19H19z\"/><path d=\"M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/window--black-saturation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthWindowBlackSaturation32",
          "filepath": "watson-health/window--black-saturation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.225 5.729H8.228V8.732H6.225z",
                  "transform": "rotate(-45 7.227 7.23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.267 6.227H26.267V8.227H23.267z",
                  "transform": "rotate(-45 24.767 7.227)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.769 23.269H25.770999999999997V26.270999999999997H23.769z",
                  "transform": "rotate(-44.999 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126zM15 13H17V15H15zM19 13H21V15H19zM17 11H19V13H17zM17 15H19V17H17zM17 19H19V21H17zM15 17H17V19H15zM19 17H21V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z"
                }
              }
            ],
            "name": "window--black-saturation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthWindowBlackSaturation24",
          "filepath": "watson-health/window--black-saturation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.225 5.729H8.228V8.732H6.225z",
                  "transform": "rotate(-45 7.227 7.23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.267 6.227H26.267V8.227H23.267z",
                  "transform": "rotate(-45 24.767 7.227)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.769 23.269H25.770999999999997V26.270999999999997H23.769z",
                  "transform": "rotate(-44.999 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126zM15 13H17V15H15zM19 13H21V15H19zM17 11H19V13H17zM17 15H19V17H17zM17 19H19V21H17zM15 17H17V19H15zM19 17H21V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z"
                }
              }
            ],
            "name": "window--black-saturation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthWindowBlackSaturation20",
          "filepath": "watson-health/window--black-saturation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.225 5.729H8.228V8.732H6.225z",
                  "transform": "rotate(-45 7.227 7.23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.267 6.227H26.267V8.227H23.267z",
                  "transform": "rotate(-45 24.767 7.227)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.769 23.269H25.770999999999997V26.270999999999997H23.769z",
                  "transform": "rotate(-44.999 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126zM15 13H17V15H15zM19 13H21V15H19zM17 11H19V13H17zM17 15H19V17H17zM17 19H19V21H17zM15 17H17V19H15zM19 17H21V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z"
                }
              }
            ],
            "name": "window--black-saturation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthWindowBlackSaturation16",
          "filepath": "watson-health/window--black-saturation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M6.225 5.729H8.228V8.732H6.225z",
                  "transform": "rotate(-45 7.227 7.23)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.267 6.227H26.267V8.227H23.267z",
                  "transform": "rotate(-45 24.767 7.227)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M23.769 23.269H25.770999999999997V26.270999999999997H23.769z",
                  "transform": "rotate(-44.999 24.77 24.77)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126zM15 13H17V15H15zM19 13H21V15H19zM17 11H19V13H17zM17 15H19V17H17zM17 19H19V21H17zM15 17H17V19H15zM19 17H21V19H19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z"
                }
              }
            ],
            "name": "window--black-saturation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "WindowBlackSaturation",
        "global": "WatsonHealthWindowBlackSaturation",
        "filepath": "watson-health/WindowBlackSaturation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M6.225 5.729H8.228V8.732H6.225z",
                    "transform": "rotate(-45 7.227 7.23)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.267 6.227H26.267V8.227H23.267z",
                    "transform": "rotate(-45 24.767 7.227)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23.769 23.269H25.770999999999997V26.270999999999997H23.769z",
                    "transform": "rotate(-44.999 24.77 24.77)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126zM15 13H17V15H15zM19 13H21V15H19zM17 11H19V13H17zM17 15H19V17H17zM17 19H19V21H17zM15 17H17V19H15zM19 17H21V19H19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "window--overlay",
      "friendlyName": "Window overlay",
      "aliases": [
        "brightness",
        "contrast",
        "sun"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/window--overlay.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>watson-health--window--overlay</title><rect x=\"15\" y=\"6\" width=\"2\" height=\"3\"/><rect x=\"25\" y=\"17\" width=\"3\" height=\"2\"/><rect x=\"15\" y=\"27\" width=\"2\" height=\"3\"/><rect x=\"4\" y=\"17\" width=\"3\" height=\"2\"/><rect x=\"7.55\" y=\"9.03\" width=\"2\" height=\"3\" transform=\"translate(-4.95 9.14) rotate(-45)\"/><rect x=\"21.96\" y=\"9.54\" width=\"3\" height=\"2\" transform=\"translate(-0.58 19.68) rotate(-45)\"/><rect x=\"22.46\" y=\"23.94\" width=\"2\" height=\"3\" transform=\"translate(-11.12 24.04) rotate(-45)\"/><rect x=\"7.04\" y=\"24.45\" width=\"3\" height=\"2\" transform=\"translate(-15.49 13.5) rotate(-45)\"/><rect x=\"4\" y=\"2\" width=\"24\" height=\"2\"/><path d=\"M16,24a6,6,0,1,0-6-6A6,6,0,0,0,16,24Zm0-10v8a4,4,0,0,1,0-8Z\" transform=\"translate(0 0)\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z\"/><path d=\"M7.55 9.03H9.55V12.03H7.55z\" transform=\"rotate(-45 8.558 10.545)\"/><path d=\"M21.96 9.54H24.96V11.54H21.96z\" transform=\"rotate(-45 23.466 10.54)\"/><path d=\"M22.46 23.94H24.46V26.94H22.46z\" transform=\"rotate(-45 23.459 25.443)\"/><path d=\"M7.04 24.45H10.04V26.45H7.04z\" transform=\"rotate(-45 8.55 25.448)\"/><path d=\"M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z\"/></svg>",
            "info": {},
            "path": "32/watson-health/window--overlay.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthWindowOverlay32",
          "filepath": "watson-health/window--overlay/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 9.03H9.55V12.03H7.55z",
                  "transform": "rotate(-45 8.558 10.545)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 9.54H24.96V11.54H21.96z",
                  "transform": "rotate(-45 23.466 10.54)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 23.94H24.46V26.94H22.46z",
                  "transform": "rotate(-45 23.459 25.443)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 24.45H10.04V26.45H7.04z",
                  "transform": "rotate(-45 8.55 25.448)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--overlay",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthWindowOverlay24",
          "filepath": "watson-health/window--overlay/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 9.03H9.55V12.03H7.55z",
                  "transform": "rotate(-45 8.558 10.545)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 9.54H24.96V11.54H21.96z",
                  "transform": "rotate(-45 23.466 10.54)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 23.94H24.46V26.94H22.46z",
                  "transform": "rotate(-45 23.459 25.443)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 24.45H10.04V26.45H7.04z",
                  "transform": "rotate(-45 8.55 25.448)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--overlay",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthWindowOverlay20",
          "filepath": "watson-health/window--overlay/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 9.03H9.55V12.03H7.55z",
                  "transform": "rotate(-45 8.558 10.545)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 9.54H24.96V11.54H21.96z",
                  "transform": "rotate(-45 23.466 10.54)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 23.94H24.46V26.94H22.46z",
                  "transform": "rotate(-45 23.459 25.443)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 24.45H10.04V26.45H7.04z",
                  "transform": "rotate(-45 8.55 25.448)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--overlay",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthWindowOverlay16",
          "filepath": "watson-health/window--overlay/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.55 9.03H9.55V12.03H7.55z",
                  "transform": "rotate(-45 8.558 10.545)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.96 9.54H24.96V11.54H21.96z",
                  "transform": "rotate(-45 23.466 10.54)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.46 23.94H24.46V26.94H22.46z",
                  "transform": "rotate(-45 23.459 25.443)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M7.04 24.45H10.04V26.45H7.04z",
                  "transform": "rotate(-45 8.55 25.448)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
                }
              }
            ],
            "name": "window--overlay",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "WindowOverlay",
        "global": "WatsonHealthWindowOverlay",
        "filepath": "watson-health/WindowOverlay.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.55 9.03H9.55V12.03H7.55z",
                    "transform": "rotate(-45 8.558 10.545)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.96 9.54H24.96V11.54H21.96z",
                    "transform": "rotate(-45 23.466 10.54)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.46 23.94H24.46V26.94H22.46z",
                    "transform": "rotate(-45 23.459 25.443)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M7.04 24.45H10.04V26.45H7.04z",
                    "transform": "rotate(-45 8.55 25.448)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "window--preset",
      "friendlyName": "Window preset",
      "aliases": [
        "window preset",
        "health"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/window--preset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: #272425;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"15\" y=\"6\" width=\"2\" height=\"2\"/>\n  <rect x=\"24\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"15\" y=\"24\" width=\"2\" height=\"2\"/>\n  <rect x=\"6\" y=\"15\" width=\"2\" height=\"2\"/>\n  <rect x=\"8.5858\" y=\"8.5858\" width=\"2\" height=\"2\" transform=\"translate(-3.9706 9.5858) rotate(-45)\"/>\n  <rect x=\"21.4142\" y=\"8.5858\" width=\"2\" height=\"2\" transform=\"translate(-0.2132 18.6569) rotate(-45)\"/>\n  <rect x=\"21.4142\" y=\"21.4142\" width=\"2\" height=\"2\" transform=\"translate(-9.2843 22.4142) rotate(-45)\"/>\n  <rect x=\"8.5858\" y=\"21.4142\" width=\"2\" height=\"2\" transform=\"translate(-13.0416 13.3431) rotate(-45)\"/>\n  <path d=\"M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z\"/>\n  <path class=\"cls-1\" d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-2\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z\"/><path d=\"M8.586 8.586H10.586V10.586H8.586z\" transform=\"rotate(-45 9.586 9.586)\"/><path d=\"M21.414 8.586H23.414V10.586H21.414z\" transform=\"rotate(-45 22.414 9.586)\"/><path d=\"M21.414 21.414H23.414V23.414H21.414z\" transform=\"rotate(-45 22.414 22.414)\"/><path d=\"M8.586 21.414H10.586V23.414H8.586z\" transform=\"rotate(-45 9.586 22.414)\"/><path d=\"M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z\"/><path d=\"M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z\"/></svg>",
            "info": {},
            "path": "32/watson-health/window--preset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthWindowPreset32",
          "filepath": "watson-health/window--preset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 8.586H10.586V10.586H8.586z",
                  "transform": "rotate(-45 9.586 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.586H23.414V10.586H21.414z",
                  "transform": "rotate(-45 22.414 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 21.414H23.414V23.414H21.414z",
                  "transform": "rotate(-45 22.414 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 21.414H10.586V23.414H8.586z",
                  "transform": "rotate(-45 9.586 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "window--preset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthWindowPreset24",
          "filepath": "watson-health/window--preset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 8.586H10.586V10.586H8.586z",
                  "transform": "rotate(-45 9.586 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.586H23.414V10.586H21.414z",
                  "transform": "rotate(-45 22.414 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 21.414H23.414V23.414H21.414z",
                  "transform": "rotate(-45 22.414 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 21.414H10.586V23.414H8.586z",
                  "transform": "rotate(-45 9.586 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "window--preset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthWindowPreset20",
          "filepath": "watson-health/window--preset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 8.586H10.586V10.586H8.586z",
                  "transform": "rotate(-45 9.586 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.586H23.414V10.586H21.414z",
                  "transform": "rotate(-45 22.414 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 21.414H23.414V23.414H21.414z",
                  "transform": "rotate(-45 22.414 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 21.414H10.586V23.414H8.586z",
                  "transform": "rotate(-45 9.586 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "window--preset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthWindowPreset16",
          "filepath": "watson-health/window--preset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 8.586H10.586V10.586H8.586z",
                  "transform": "rotate(-45 9.586 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 8.586H23.414V10.586H21.414z",
                  "transform": "rotate(-45 22.414 9.586)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.414 21.414H23.414V23.414H21.414z",
                  "transform": "rotate(-45 22.414 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M8.586 21.414H10.586V23.414H8.586z",
                  "transform": "rotate(-45 9.586 22.414)"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                }
              }
            ],
            "name": "window--preset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "WindowPreset",
        "global": "WatsonHealthWindowPreset",
        "filepath": "watson-health/WindowPreset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.586 8.586H10.586V10.586H8.586z",
                    "transform": "rotate(-45 9.586 9.586)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.414 8.586H23.414V10.586H21.414z",
                    "transform": "rotate(-45 22.414 9.586)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.414 21.414H23.414V23.414H21.414z",
                    "transform": "rotate(-45 22.414 22.414)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8.586 21.414H10.586V23.414H8.586z",
                    "transform": "rotate(-45 9.586 22.414)"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "windy",
      "friendlyName": "Windy",
      "aliases": [
        "windy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/windy.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>windy</title><path d=\"M21,15H8V13H21a3,3,0,1,0-3-3H16a5,5,0,1,1,5,5Z\"/><path d=\"M23,28a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V18H23a5,5,0,0,1,0,10Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z\"/></svg>",
            "info": {},
            "path": "32/windy.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Windy32",
          "filepath": "windy/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
                }
              }
            ],
            "name": "windy",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Windy24",
          "filepath": "windy/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
                }
              }
            ],
            "name": "windy",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Windy20",
          "filepath": "windy/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
                }
              }
            ],
            "name": "windy",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Windy16",
          "filepath": "windy/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
                }
              }
            ],
            "name": "windy",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "Windy",
        "global": "Windy",
        "filepath": "Windy.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "windy--dust",
      "friendlyName": "Windy dust",
      "aliases": [
        "windy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/windy--dust.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>windy--dust</title><path d=\"M23,28a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H22V18h1a5,5,0,0,1,0,10Z\"/><rect x=\"16\" y=\"18\" width=\"4\" height=\"2\"/><rect x=\"10\" y=\"18\" width=\"4\" height=\"2\"/><rect x=\"4\" y=\"18\" width=\"4\" height=\"2\"/><path d=\"M21,15H20V13h1a3,3,0,1,0-3-3H16a5,5,0,1,1,5,5Z\"/><rect x=\"14\" y=\"13\" width=\"4\" height=\"2\"/><rect x=\"8\" y=\"13\" width=\"4\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z\"/></svg>",
            "info": {},
            "path": "32/windy--dust.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WindyDust32",
          "filepath": "windy--dust/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
                }
              }
            ],
            "name": "windy--dust",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WindyDust24",
          "filepath": "windy--dust/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
                }
              }
            ],
            "name": "windy--dust",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WindyDust20",
          "filepath": "windy--dust/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
                }
              }
            ],
            "name": "windy--dust",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WindyDust16",
          "filepath": "windy--dust/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
                }
              }
            ],
            "name": "windy--dust",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WindyDust",
        "global": "WindyDust",
        "filepath": "WindyDust.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "windy--snow",
      "friendlyName": "Windy snow",
      "aliases": [
        "windy",
        "precipitation"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/windy--snow.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>windy--snow</title><path d=\"M25,28a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H6V18H25a5,5,0,0,1,0,10Z\"/><path d=\"M23,15H10V13H23a3,3,0,1,0-3-3H18a5,5,0,1,1,5,5Z\"/><rect x=\"11\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"25\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"27\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"23\" width=\"2\" height=\"2\"/><rect x=\"11\" y=\"27\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"4\" width=\"2\" height=\"2\"/><rect x=\"8\" y=\"6\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"10\" y=\"4\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"8\" width=\"2\" height=\"2\"/><rect x=\"2\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"4\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"6\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"2\" y=\"30\" width=\"2\" height=\"2\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z\"/><path d=\"M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z\"/></svg>",
            "info": {},
            "path": "32/windy--snow.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WindySnow32",
          "filepath": "windy--snow/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
                }
              }
            ],
            "name": "windy--snow",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WindySnow24",
          "filepath": "windy--snow/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
                }
              }
            ],
            "name": "windy--snow",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WindySnow20",
          "filepath": "windy--snow/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
                }
              }
            ],
            "name": "windy--snow",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WindySnow16",
          "filepath": "windy--snow/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
                }
              }
            ],
            "name": "windy--snow",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WindySnow",
        "global": "WindySnow",
        "filepath": "WindySnow.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "windy--strong",
      "friendlyName": "Windy strong",
      "aliases": [
        "windy"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/windy--strong.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>windy--strong</title><path d=\"M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z\"/><path d=\"M25,25a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H2V15H25a5,5,0,0,1,0,10Z\"/><path d=\"M21,12H6V10H21a3,3,0,1,0-3-3H16a5,5,0,1,1,5,5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z\"/><path d=\"M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z\"/></svg>",
            "info": {},
            "path": "32/windy--strong.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WindyStrong32",
          "filepath": "windy--strong/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
                }
              }
            ],
            "name": "windy--strong",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WindyStrong24",
          "filepath": "windy--strong/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
                }
              }
            ],
            "name": "windy--strong",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WindyStrong20",
          "filepath": "windy--strong/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
                }
              }
            ],
            "name": "windy--strong",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WindyStrong16",
          "filepath": "windy--strong/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
                }
              }
            ],
            "name": "windy--strong",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WindyStrong",
        "global": "WindyStrong",
        "filepath": "WindyStrong.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "winter-warning",
      "friendlyName": "Winter warning",
      "aliases": [
        "weather",
        "winter",
        "warning",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/winter-warning.svg",
          "source": "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"21.684 19.051 19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051\"/>\n  <path id=\"_inner-path_\" data-name=\"&lt;inner-path&gt;\" class=\"cls-1\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\" transform=\"translate(0 0)\"/>\n  <path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\" transform=\"translate(0 0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z\"/><path fill=\"none\" d=\"M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z\"/><path d=\"M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z\"/></svg>",
            "info": {},
            "path": "32/winter-warning.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WinterWarning32",
          "filepath": "winter-warning/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "winter-warning",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WinterWarning24",
          "filepath": "winter-warning/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "winter-warning",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WinterWarning20",
          "filepath": "winter-warning/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "winter-warning",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WinterWarning16",
          "filepath": "winter-warning/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "fill": "none",
                  "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                }
              }
            ],
            "name": "winter-warning",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WinterWarning",
        "global": "WinterWarning",
        "filepath": "WinterWarning.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "fill": "none",
                    "d": "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wintry-mix",
      "friendlyName": "Wintry mix",
      "aliases": [
        "wintry-mix",
        "precipitation",
        "forecast"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wintry-mix.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>wintry-mix</title><rect x=\"15\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"28\" width=\"2\" height=\"2\"/><rect x=\"19\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"19\" y=\"26\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"30\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"15\" y=\"18\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"20\" width=\"2\" height=\"2\"/><rect x=\"17\" y=\"16\" width=\"2\" height=\"2\"/><rect x=\"13\" y=\"20\" width=\"2\" height=\"2\"/><path d=\"M10,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,10,30Z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z\"/><path d=\"M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z\"/></svg>",
            "info": {},
            "path": "32/wintry-mix.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WintryMix32",
          "filepath": "wintry-mix/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "wintry-mix",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WintryMix24",
          "filepath": "wintry-mix/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "wintry-mix",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WintryMix20",
          "filepath": "wintry-mix/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "wintry-mix",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WintryMix16",
          "filepath": "wintry-mix/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
                }
              }
            ],
            "name": "wintry-mix",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Weather",
      "moduleInfo": {
        "local": "WintryMix",
        "global": "WintryMix",
        "filepath": "WintryMix.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "wireless-checkout",
      "friendlyName": "Wireless checkout",
      "aliases": [
        "shopping bag",
        "buy",
        "tote",
        "WiFi"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/wireless-checkout.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>wireless-checkout</title><path d=\"M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z\"/><path d=\"M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z\"/><path d=\"M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z\"/><path d=\"M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z\"/><path d=\"M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z\"/></svg>",
            "info": {},
            "path": "32/wireless-checkout.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WirelessCheckout32",
          "filepath": "wireless-checkout/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
                }
              }
            ],
            "name": "wireless-checkout",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WirelessCheckout24",
          "filepath": "wireless-checkout/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
                }
              }
            ],
            "name": "wireless-checkout",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WirelessCheckout20",
          "filepath": "wireless-checkout/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
                }
              }
            ],
            "name": "wireless-checkout",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WirelessCheckout16",
          "filepath": "wireless-checkout/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
                }
              }
            ],
            "name": "wireless-checkout",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Commerce",
      "moduleInfo": {
        "local": "WirelessCheckout",
        "global": "WirelessCheckout",
        "filepath": "WirelessCheckout.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "WMV",
      "friendlyName": "WMV",
      "aliases": [
        "format",
        "music",
        "video",
        "codec"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/WMV.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>WMV</title><polygon points=\"29 9 27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9\"/><polygon points=\"19 9 17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9\"/><polygon points=\"9.2 9 8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z\"/></svg>",
            "info": {},
            "path": "32/WMV.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Wmv32",
          "filepath": "WMV/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
                }
              }
            ],
            "name": "WMV",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Wmv24",
          "filepath": "WMV/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
                }
              }
            ],
            "name": "WMV",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Wmv20",
          "filepath": "WMV/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
                }
              }
            ],
            "name": "WMV",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Wmv16",
          "filepath": "WMV/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
                }
              }
            ],
            "name": "WMV",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Wmv",
        "global": "Wmv",
        "filepath": "Wmv.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "word-cloud",
      "friendlyName": "Word cloud",
      "aliases": [
        "chart",
        "plot",
        "data analytics"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/word-cloud.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>word-cloud</title>\n  <rect x=\"10\" y=\"16\" width=\"12\" height=\"2\"/>\n  <rect x=\"10\" y=\"20\" width=\"8\" height=\"2\"/>\n  <path d=\"M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M10 16H22V18H10zM10 20H18V22H10z\"/><path d=\"M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z\"/></svg>",
            "info": {},
            "path": "32/word-cloud.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WordCloud32",
          "filepath": "word-cloud/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 20H18V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
                }
              }
            ],
            "name": "word-cloud",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WordCloud24",
          "filepath": "word-cloud/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 20H18V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
                }
              }
            ],
            "name": "word-cloud",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WordCloud20",
          "filepath": "word-cloud/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 20H18V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
                }
              }
            ],
            "name": "word-cloud",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WordCloud16",
          "filepath": "word-cloud/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 16H22V18H10zM10 20H18V22H10z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
                }
              }
            ],
            "name": "word-cloud",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Data",
      "moduleInfo": {
        "local": "WordCloud",
        "global": "WordCloud",
        "filepath": "WordCloud.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 16H22V18H10zM10 20H18V22H10z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "workflow-automation",
      "friendlyName": "Workflow automation",
      "aliases": [
        "workflow",
        "automation",
        "gear",
        "arrows",
        "cycle"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/workflow-automation.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\" [\n\t<!ENTITY ns_extend \"http://ns.adobe.com/Extensibility/1.0/\">\n\t<!ENTITY ns_ai \"http://ns.adobe.com/AdobeIllustrator/10.0/\">\n\t<!ENTITY ns_graphs \"http://ns.adobe.com/Graphs/1.0/\">\n\t<!ENTITY ns_vars \"http://ns.adobe.com/Variables/1.0/\">\n\t<!ENTITY ns_imrep \"http://ns.adobe.com/ImageReplacement/1.0/\">\n\t<!ENTITY ns_sfw \"http://ns.adobe.com/SaveForWeb/1.0/\">\n\t<!ENTITY ns_custom \"http://ns.adobe.com/GenericCustomNamespace/1.0/\">\n\t<!ENTITY ns_adobe_xpath \"http://ns.adobe.com/XPath/1.0/\">\n]>\n<svg version=\"1.1\" id=\"icon\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\"\n\t style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<switch>\n\t<foreignObject requiredExtensions=\"&ns_ai;\" x=\"0\" y=\"0\" width=\"1\" height=\"1\">\n\t\t<i:aipgfRef  xlink:href=\"#adobe_illustrator_pgf\">\n\t\t</i:aipgfRef>\n\t</foreignObject>\n\t<g i:extraneous=\"self\">\n\t\t<path d=\"M16,27c-3.6,0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5,3,6.1,4.7,10,4.7V27z\"/>\n\t\t<path d=\"M31,23v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V15h-2v2.1\n\t\t\tc-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H17v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5\n\t\t\tl1.4,1.4l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V29h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8\n\t\t\tH31z M24,25c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S25.7,25,24,25z\"/>\n\t\t<path d=\"M20,10h5.2C21.9,4.9,15.1,3.5,10,6.8c-3.1,2-5,5.5-5,9.2H3C3,8.8,8.8,3,16,3c3.9,0,7.5,1.7,10,4.7V4h2v8h-8V10z\"/>\n\t\t<rect id=\"_x3C_Transparent_Rectangle_x3E__589_\" class=\"st0\" width=\"32\" height=\"32\"/>\n\t</g>\n</switch>\n<i:aipgf  id=\"adobe_illustrator_pgf\" i:pgfEncoding=\"zstd/base64\" i:pgfVersion=\"24\">\n\t<![CDATA[\n\tKLUv/QBYjJkE7vwFnAwqwNZQCm2UADcFGkK2ET22eQqL4PLWtlYkn0mR3b0zccDy6fJXFAUMRdGB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\n\t]]>\n\t<![CDATA[\n\tkMGFCRZw4OBQQQBGBRtMoECBYVwAwQKFCooADAssVGionIcFFCpM2MCCBAw8SAYgHDg4jJRHBRQI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\n\t]]>\n\t<![CDATA[\n\tk+PAGxn1fpm9x8qh5cCcQbRQ1vnf4IlvlCp7/0dztBbN90O5GkW5Q8P8E2uwbhINr1cjXbMreB3B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\n\t]]>\n\t<![CDATA[\n\tDetY2yhSXt0RUWpVckLJGsXPqySxhj8vS7S5rSyUxDavEK2KKptTtszXSDsk2wdrkunf7JPMIida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\n\t]]>\n\t<![CDATA[\n\tC0p0Dy2fS2TuE9+f44m4AUfTuqpMOCuRM14G8j5AYvVlW353iKkNi1O0kCCz3aMOAdsNkYQzRwyY\nrHRCRc49+i8qqi6tpzM+N40jnlVlyGpWZh3gONwI2ghBkTG7zJz0v2Inclzif9pS8xPfw9n7DNxs\nDk0kTI+O+/FMF0C7U50kCdGGMoU9GOJvY4tFAFTCIqwYsYBRIZdFNfD1kSExsXkSwTi2g2kOwO94\nGg2ov9wRrIyQ2DG1vsm11Lj+wjwA9yZMlP83znte9KXiDVfEUWuPP9tivSJOZn9Kk295YaRFwS2T\nesODHH8ScmUGbWLcYfCU+GF5M/tGN5YXUbU6sLqy2fFxuJH68nG2vJAB6+9OE9MmsZZPHczBYuPc\nIYOVk2Oh1+ruvXGmtd2XHRrqGLKGJH1zh52fClzyKzKTtgiICydBiRuiW8QxG15YjGPeYfVTLpiJ\n/ziP3bssPeecC+/obBPN0QkUr+Gwd4TAQJPUIWUjfap2JDvzF+XHHxRvydrfMGmkzZ+wdkfrk+Fl\n6ZUPxSploSmRQl7DnxQEoTZvs1PBUDBipCxBDJNmS2HosGXEfRoxwRuHzEHn7otKIn/xOII7FjxT\n4HXmxgm6S7xn0/42PJonoDXNT6tjOPXfFt4tnzVup8vn4QGMJb6ak8102pM4eWELkSigvHVu4kxD\nz8kfkr7G6Wyf5vuy0lP2WqGBt45//VaLm7yScQOw3VWgFiZeKxbPxZKmjRVVDL9Jq34AFuiv68D2\nWSfP2VvkjqPp1KPrvt8H0RIfuJdredK6VMR2HebWbYQjhwtLICIqpRyQZTIbZISIJCfyjwDx5U4+\n11otowo62FsgDYO7oVoGU1jTMSTYusPKXpin0SL+zTKgrq+uHIGhB880CApiQI2GRNAWW41W3HeK\nZ42FcQL61vUH8KTf8iGDZVbKi3Bt6J3yUg9DGqKJd2YGd24o9do25/PfdRq8w8zauXvkCS2Qa8b7\ncja4YSHmqxYIhEQny/FPWqbZZ9sjEoawl7fBexVZlteILkUvfPEi6uNn1WaviIAOrsezKaglndHh\nGvVolKxZ1wxK725wrNMyNxbBGgFU26y3vUAskBoh9c6D3Mth9xRCXoyZbZuDJu8LSBkiOxhfpQCZ\nWgT5VCC5ioBiE6UFIlNHIj/KFBrmBfFY9xInD1CrpiUDLOrvwybbGMcpIBaS68nALcfWaTipMWo0\npRie7v+ucy4yMtp2oDA08SnbbVF+Uy/AIUDO2IDJXcGEQKbmWjYMaOX1RuieNAGOHkMD2LQfuPp0\nWVQByWzYPVy699zJe5k8alvqLJbaC6hNLObylWjcKmIymq8gA0OgemUYm/sEDzfoCljWmzgC6sGW\nBvqC+Cyxvi3o9u7srU8oO8QfFvd+jWKL5A3aG4wTwI4ZhnY/+9QuVwXMuZdtdb/Ex0m+qbH9qIL4\no54Z4zX5g60VhVzXKoVTT+Kt5eVmk+sALAtZ2jMvNCoolTRw72UZk1k+lNnKE4WAaTipS4ddCTrx\nUJbbjVw5jA7vnE3B7AM3W5fu3gD2UX/w934Q9aDoOkX0mRNBhw/6S2dVbg6F4nLOdU8A33eLBy3H\nsj/VA3e6bMLlty9znjUVZQOoY4BoQUKl5Nhvmj3tn97rmeSUi8PqnRvxKPGUWKIyH9GLHOQd51eL\nN5YK5qxsJOSS2eeiTSkpxnTNp8ze7MDV0Tae7XvfsOi/sgE0Et1pHFIGXMvEj1diIShrOiSH5Ht5\n/wELITs0wotKTv25x4/fLNV2tQGLzIuwNIplqC2L7phCpTWNuNk6ORdVZDzf/QAQQe9bEAyhddUQ\nUGCCXEPO+PSfdz+HHGgxxEQ7GdjJeTa6b8uxjrFBX09UIc+Fr0zAIwqVWEZAHIVCGoxjM8a9oTha\nLKSfuw3tGuQESdvMpx63IPuZsRhL60jgKYcs0cHh563f2BeUw+1QI/djngU7u+MHrlVUyHltWd8x\nLo6wLwJ6Koqu80RYDN3ApfICy42s/mBb7GHXW7EwiOAZQBQ+xVUV1rIvNnw/+DfUtdq7zZ6AfBp/\nK9u8qcA7uWaguWnez9LqEV6iKY1HRdZATig/FPNNkQgTElAeu2/lTN03Ril0VgZO9yusiPwtwksF\ndebloWiZ1T0YZDmltzdOYPsR3zrMu7Xc+mHA/eKhl1pjdrItH8/pJutj6Lk5ejJeiH26Zkqyf8Xt\ndv9Mn6H0DX59+Cip2e/yDW/1vx76lWnszx1XSvatuJZG+6gW1Yhp2Hdia30dr4eMWIN5daCiiwLB\nFIEzcALKpQO4JsRJAYC5bVFNkY4oxYGbXdQBlBI6zWhmFKPEgTmTYW4L2iTZahnW4IJ1FzCMC+13\n1y8JLKAVIK8+tGEsI5BusCvPo64mLjTlZzsYu19viegx1lm180w12nNI8an+oIz/R46iDdHQSufn\ngwz9gc7LjWJg9opn6aU4Qrmz+WvCe2gMHlZV1y0OeQp6XkmZ7CadN6vYoO+SP02/3QsCL6HcyEf8\nXAe4+8S20MV9CP/Lk2ZoI6nWi1i4WnBGRJV2Ib+YpTwfLGt+gB6ZD4amt3rnRbIUZWQlVg6YVObo\nFPItVXAtFnIEu9hd693Q5rlQDzl+zpUC47GsRnSDVqo4olTgRtRfdwwsM3hD13DaEnyoDFktT9CP\nBG7fa3uqXVMbzlM0U7O6KSxgmwh7EpKT46ewQoBVr568MBJGmdUjU74WUmXrKxYY4ww+imBV/WvR\nk+XgvTvDdad3S7MRZGSuFcPSQ3bM+/yoZoNwY3HmgLOptCJ5IycaGCuDfBGrvAFHCVm/LnrCZZes\nSx35wXSJAUGmh62TvIMj53Pwo9/bb1Cr2SDWvZf/RbVz8HnEEHB8DMOcSmadHRedG9Rmmk0s5Se3\npKoT24c2LX4lJ2XuTtZI273ttMMgA2eN5i2gwpp34BM7tzJIuDL8tLgITqxxIvKShC6kNa27jnOi\nAJAom0skXq40R8jCe9GKyy7CmMdyUJYun4/md0hcTsjo6sQcoJAK7j5ZT7yBgq7bFNSdzrBKU9Ps\n7yi+GpwIiL6/5Zv3t4rXWunbxIVEBY8zXMnvYFvA0x9LH24eLtUFuUIQyy8aStg5ci5XARWWVbnc\nP8E5YsimIg9sMGH8zdOUiiDNlOs08uWvbqXnHJbGagp38jHkVf/94g+jB80mweSK57fjqEuMQAYI\nVIeeohMZRw7rt4jb5y8HlF10vZbN8iZQdafJ9fL8ijlm9ubIRNjgeDhzI1SFA1Fgm7NRJlW+EWgm\no8uH1jOhQHM5/BuT4IO88+RksBrVXEqAIEB3pLd7iILSBSIJjA6QdtRvMvNKQpx1ECSZPlKt/N/x\njGOIjUOzwADWwGfIW/8my84vzsEJ4M4xSBauOBqxu6pxwnKfUyLAb08AYJaTBcUiWQpS65t8mS/M\noAjSvLqS7yxKq5MSaNyIDzNKCTdfLoHKIVP4iQjRy1JJlpXobFsT5C1yCO4abesRV3ylwOAHPBwS\nGlyUg/gxAhQEK3U1vCO+ZfbcSAxoVe/tv+rkLn6JELc7khIEOrWxA8LO4TtlgrlewEllO4eB6xyL\nEcFL0sbOXkFaI/Y3uypysNM03ni4RgPnMFNjXoRBlTtrHU4j3e5wKkpxEBtOsfytHgKccQWpZIfV\noYZNIp1AvftE4Xi0O12LzuO/7kPB+Adsq2OBePRCgeo6dXFU3IPBWU84Dsd50yxRklE9LVH7x9AC\nZ08GC83s4OIlASCsvhnoLkwUEYIy7P5JzgcQSF5RJcBFDmVP+5LRDrzIKQ1FSe+X/RU98zjEeLMv\nkO55juNGgywn34ODTTOCN3aOLkZwmIoBC8kpWXulgYBvvYAjERXQcICtS62iHS8WzJiXIkUv1pAo\n23wBYaBTa2X7xnbYmxp6ucLgsTFli2JiJhzOBp8FgtjSzw7xAXJO6TVUd6GdqYSgTP5LJRqMiCAF\njuNWX4a+0lX3ksoci5e3OvDgIJJyFXWmy+ca1aIddNdtvgNBi9mPBJIFbTuVgXmZJ7wxN/mcmx82\ntmqE9FAD1N1/XmpIHThCV9KFaRQYGqANmbdWpynXLHMBl7CM6Ox2eJsaCj9L6vQLPRZ3vzLqJ6IA\nBwZePwKh5BtUGCRrW2bwxRo3fJ1uZTZHODUOzewoAjrC1DeChvMUm9k5hY5euWDISMqgQpmMds7/\nk4zNoIvlpyBKdhS431YTTqYNrhnoRSRtlEhBu6CPwS26qAd1Vkck2HwwBXjNwZtM7eg7l1T+wUNw\nvf0+yUvRooQW6LASSK7qtbtdIAg2+++leuAfsg2x2HfarV99BaykwmqB5kn7GpO9GwvNyw8wuFAi\nWgoGxiu0bL5pm7jrXk6asSE7Ivpnvd8AhuQo4A+xg9ffqi7ZM8uFgwR4PKNQV9gk//q0wJPDg7Ql\nbZahBxnBBq1m9uZCRMO3CWE4ONok1twQFfYNwXbxsGfBuKiUimdfD5LmrqxwJUWjOy+1tCNoKCPI\nezRFVpdDjhaW2G6wEoqyDXJssaBfJrUOw6wIlyCyA78SHKosEBH739BMP9IlFZO0bqYKM3HVsDRl\nBRVw70m+KNGIeGXEqcalv0XJdAanKhLula9+GbxEegZatEEXLCoEEgLlkxiVH2K9bzVMOD91z/sQ\nORVAVQmgrnDPjet6vEByYZTVfJC8cpK2VsLW1BKArLboVIXNOFWjqREU1RlfskLbfbqF5mbNzfjj\npgcrBSUi/ZfT5WclZ0bSu+hkURtXu1XXxtbrQzV6Tf1pJe7Pl7Xdoiut6l1ALSBuJ4v9dyzCRyAe\nOyFBFxaB8BbCy5k2p001SFvoCQYd3mcCw3LhFHFfVMaiB8NqBccI0UIb6L3tOMQQmG+MgKFZOezI\nretHKEPT2qsZ5PM7Aj8ntuQs+pN8vaI0fEwWj6FpoSbUU4RQXwACKMv+HGbV4AV3AoWzGcVE41PS\nE0rPL9j9edvTl8UqG+3/Z576e8ywDUaPeCYNW/9QnHabyUd8uzgAxWPezAnSTpgxJ1CDgvEf9pPz\n9AZnAcMWxea1j0o2OECH1YGzPOAyaPUFkJzNkyOBhcHoAem6JbKMEilTlbhCaLBggBUVjr/Wzfc4\nZCMgnYflbOB4Sy5BHvWufL1Ykxnd5X58diicPXZy/g/+q9kEq+Dx4N20fNu6fvkbxSw5YvEisGSo\n/BqJ3tt/f8x4s8QkzRWg8/71wjYKPH9pAiOFrKxxALzLnw2dApURwU4qd8SgI0LeUiKYQclM9qfC\nD8n6wZnebM+IZhhmDfbF2cNLdYlu6E2x9Wb3mVBxIesRTJTLSQD3fqjWKuL31c6GZDak3URaCaKx\njQOE6OQu2iTxxQtffGvp7JoxAZ6tcH69VbkzigzQiYzL3MvGUoRgCNH+i62dBAZd2J5tnvZBSfsV\nRBc7MoSh+eYTYEU36Ba7xvGA+QQhLIF+G+OFjD1ITcJfvbvNqs90AQYlNFkgq6i/+g==\n\t]]>\n\t<![CDATA[\n\tCAz2WxltyLuJY4wMFO0KQJnDHv5kXSDZHq6qsiUVechkq6hRyrQWYoB5VWAEeQK3hkKTdAq4nWIj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\n\t]]>\n\t<![CDATA[\n\tjPEUX7fgL6t3RFf2Z8iQ9JN8eexN8GsN1W4oTg7IlQPcVt3dfeqrHsXTH40dg4HE2QcMqkVdqStY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\n\t]]>\n\t<![CDATA[\n\tIZUShCS9Hj5KJkAhxJ4fz0ClnMgk+QYbwHDZQ64N2gdC5L5vE71xOtMbZq/20NML3KCsciAiSIDF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\n\t]]>\n\t<![CDATA[\n\trQVAyFduKFD//WpS/o2mBPrFf2b6PMspFAUgDdi0yLdGLFf6OEVERXFQRkfpL6/dkRT1Q/Aed4XJ\nXGKtniUh04iVPOznPUCjEDOhT8rt02GiirVw+Y54+P5urujbrN0G13N5tSn00TPyNGE1nT2wkE5K\nCYykwXkBTUQ1jjHIEc+h0yOSWVS7GL0VAZIQo8h+6EaS3xetvxj4AIt/zSdJKFAGQf6t/Q1NREoZ\nBkqChvZUNZkZZxnEhSH/Ls7oK/qMhXa2gGuOolOweXC4hrgm3gZ/8xo8p2R+ZBL+ZF6+95hDirkj\nLVqxisixFO2HSGpJ0z7VXJ5gtKrCjsDiJO+rI2QJYzUg2MKepgRW5dTVjjotegj6Feceiuj9i1Fi\nR6UVjnuYALkQrQRPv7UP0ZGL8pqP6uXAYMmGgwRKIU4oy+62aFloJxyjrzBPNJuVNCsXoPKoTi+i\nE4LZLE7dW3DShpn1HuJ1tpT2NTF2mErZcckH4ncQjy+FuFQ5BZYdeSKG3Yg7qan3ATNXbaLECfjh\nBJEgMPUMXtTKCFoSoqH3jISaIGVJtGlc4ASlPtEqUUgXo85+FsWVPJb5k7wXW4K8XuqTE9Isg1eT\nD87KKH1WoeqJEC6pCW6zvQZra06ZaIXKwfZL98rdbmF59u3Nrg0hKMiBjnMPYKG28VJpCo+WBVmm\nzXndQR0BupqAdjNTegt0r0ATDnQqxCsFrZEe8Hs0wtLmmBYr9Jo8ydGRjoSYYDQz45Eho3hQ6zEy\nFuHoI4ndCSAJUtWW1Iyxbc7WHyw27f2G/udvAZyMbdISRq9bwwfVMDdnedyM70Pt+kzIJhhasff7\ndUjMpo9w50fGjjzffvlcMFjQVDDoC+xYQQb0NW2lWewEckEtsiPlJk12gXMzYSYtcShkNoXTBudL\nkw+rNAwsPbhO/EfX/IuhLSFW6GrggABlSa6HCVKQX8xdolO2+rPUqsH+u9FuW+0S8fxdAMxxO48I\ncQsJwbcZPsPFyGFphQZaz/J2xhCtNNTWgFa8Zb8/+FdcNixiIfp/cpnSIMNPZVxTZAEvQMycwZNd\n8HWmCC5VTXJynHMjfv//kJGEjyujEYojA8tlFkn7velNXS8UrFBenrpOh5w/2XPApBCyOjD8CsNN\nayqSkMuPKnb+qsYfssFvUGf6bOGjclEZTP0wDxVmFnO6pRQ42pxuYkrsalPXZoTmUv1BPEq1bAmS\nQDMgVd0AEQ6N6jBRgXHn3mjcRtDrSmoIdWDeCYx35bvjbffGv7z9ijjMT41KUnMHRCa5LzCqcoPQ\nX785P8iaqdT5QKFBmPK4B2rIdylvHqhHHkjhwfc7qNsdEDySbJcCGUyxcAWJppjopXjPQSOIm8Ll\nIEfJwfNx0MFNp1cMgqVS0/Tapb69qQeTwYEi3X839V4BuuF3zrq0K5efxW/QA8rOK/zhQEX1FaCR\nv5RXQh8ZdALAGwBWEcoOIjmSNFz31fTG4TcyojQJWIuhjf5z8Ava688D+6VU7zMRpkezQfRCPV/w\nkt5awqL5UUgClufnxJPkybOR/q7r4NLHCSUmRyoai3i+hEwwuU4l9nwlr49S1NcmY1zaj2JBFlKS\nWbk/Ksvahxm7mutHVO8GJN3cqkULKkUBGvIu0X+jNK+3/n7sr5/DcfdHCf6zO/4KONt3EsTeWIpj\noYNZ0SqfzCze9DDhSpEls0VMcroR6OdT58mMI5Aw8WWwws3zv1Fh6iHQg3t711XpQwx0nOQ5VXtR\nqTZNUar89Vrkmegs1otpIwSHH0R8AeuHLyEEqeMI1Lz/OKcLwUmFKJgQ/wWL7aa5FoJQeVhABOjb\nxAxxd4i8aKu6BX+VxRiKoKkiNiYinUTM6Rkf/dVXhI85C4G1DKgJxY84odxpMuJJDZ+Z+gtaaCWB\ndSLUxEUjPE58GUu7jVjvcjab+aikey4GNj2OWDFtI9TtLCud9YLsB10/0AsdyAfI1yzyIJgl/1z9\nkNnf98lZbslHtZYfvSMsvRrFzK0rV6bMEOXH8XNlL6XeCzgBO5ZI3/fbkdov9hf8wgmyR5Vz7PP9\negj5nSHdHQxPdYXJhnLVIVYvgx7YwMdDiND5wAIBm6rP/4QxOsKeP4bJf8BkoyGJVjhmaAsKaMwe\n1TWfvoY9CmBpNI2kiWIulWobwHShOs0sRRiLRPMQwxl4aHR/zqM6BqAtoEUBgyRsdVe0cUf3ikkB\nohGeiQVghVoCiCyh/0FZzasMb1Ox5Ybsctx9OdqFOVWZM0mXW+NBx/n0M/gq52sSHRQZg3s4XLY9\no6KCMWgpOyLnWG5ppXZ2Sr5fchRjDvtHT4bBX3l1ZTFrhwjA2DEP2yWO08qEPJKVPa/sghNEm0pw\nCDdCHSSd+ko1W1Jde3Plx7tbDZk2DunbWnTjkaY0lk97e3aSFfZIh6lGolwJUGqV9iE61kYllldH\netgS9WtC82aRsW48yscLrjRDa2CS65c43ktWCQxUHG26dTuxhN1Xys5LVdriiLA4udOIzT7XDyol\nmgAZ7gZE+RT4xE1iY70Yb0uTJ0ArdZnCsDg2bDqavFIfj/r2fHtfgx5TTI/7cuitZgLOIL1ODiiI\njHKcwdUMvr6cvsNAiFpWlA3m7P8x+ZF5EwzPjTBQTOPoCBjdQloWprtbrjerXUW6+2KRBZX3LRPK\ndG6CQIKfcX2XGG29uxZpFvNyt++8P84PtUVC7LKd78MiQcwsCoopKR6bKZJrVv6r2b/TLJ8uMq0P\nFM3a+8yeNLMcl9k6k5nGx6xaitmNsDPMWoMZ8y9D7mW0XcbMZQ707dUyylk2x7IMV7bGymSkQKEy\n2J7w9w5bQJngZoz4I6oBkoRPO0R5e5KvdzK9pkEaxXiUjV9Ki5HEmU3Fbn7AZctJ2ZcnKVZPkJbv\nO9x7tDMLit3YOSvZxyITFnM8yLKwckRY8XDe/lx5Z8CyEZQAygXrZHUZw7GkmdWOygp2A7ntHXcr\ngAc1KjpyIOmXOS7EJIYMJkXvTBNMjq/uQtzKw1HMflTl/XWuQxXKRkt1CwBwVagU6racjRZkQ+Jr\n4hUCxhYAwgVolpLTERmGCCei+5i3yl1cTgsRF7RsYGPXEN4kB7ZYEufrth2uHEoqd5MXonCdIUXA\nW0nTAvqDMSeAL0nBO7FBYxNhiO1IPxD8rmK77hivmo/O5hr/d4Sd3sz9ddwnSDnI8TmYHsMQ/BbA\nFV8IZGofg1VkB0kGRKhcuuVaVGaAsINCuAguaMARPROky4LLljiqk66uANZYiOsw2E2tjDrZoGZP\n2rPLPWftRdZGqm2Pw13VuAPhxCgsNyTyyH77vzNpbOl0P+dWxj+M/XEPgrtmxrzgRxAdJ4kpwiLu\nIaJrasDdR57URE0V1PCeBhWnYTQdAsPEgSDkmnYKjmZkNIE/TKU6873l8wMuIoE1n4CdYNMwnpav\n/XiRz3YAOUAApbztWwxCBJ/+3lx3CqhIZiapFihOKVynumYQnz/HQsAoC43ycBRd7igwSfF0SbFT\nyjFGIOAVGBhFKNuKdGSA/yfjujkrpzQHkNOFGeHCEBplXAKxtED8aQYCWSm2sF+cQXYzujVjzIxY\nzNh5GVLLKLcyPmXETsZSMhQUnN54KgBw1RzGfjQlja2dt0cawRd5jGDskXZ6VLHS5i8dsQKahKAy\nHRQ2tPzgoqX3roOwSyeoEQseRYp0ZuzuNCw6GtKs8rsKsmhoygufAlNCBFwrxsJyMpq1aWGJ2XIc\ndceL3SOkJvui6hyjrogCSsVY2FMR5We98Jp+YeX4zI3vJ+Rj3up9D+06Ukc4TAK9OoAcDYCkeIoH\nljD15QklNICMAF2A0fyILhkgCwyzxQXGLOcIPjndayq8NOQMoDEt2isYvRZyfVonoU1C/laozqF0\n0CZy+b9hg4WeYywOnB40fe+UvTILYRNDi5QXC8Vt45xB+z5kZ8hJrsGjSADZfkJhVGQkM7NsgSOM\n+bLM8NLAg5VKrwVBXgKoxxKWCdLhT8X/QxQm4IxkE9IxKTVRTBp1gnvdwDeKUWZyVeWkFa3oPjQL\n5GyZOfcOp1cwkyJK3GoKsSQ1/IUbTBx8StvGYOAC+ze4ftOC32zNmdY4k/Ve7rxHxRsxbnHpPGKg\naqQb3p27RXIPcTdLcOPh9lf21wYVrcJGbSSRdvefvcxQqlx2o1Q2fWSj8rFbQezp4GmUSQUCPipy\n0xFzCEC++GZbvny9NLKm6dlRAg78/wAhew/kGLKoWI4aKYSBHvtBfkhPxPOWoKNcITo4BFY0j6TS\niP6HSdCeaPbdQGWdwDoKeYc1Y0gQUDtwfhjyiN6R48RZyaLolotSL+UEDXtUwb7Tr3nUa0u7kMLK\nwxHBbQEhtfoTBFesIVsx37oroJU+GMtOVSzFwRL5u24qN2/Ycajjs0CgLU1DJVR5FeANzMy+oa8k\nbIixPeCznryQtMq+GvPVpjvWw1ZFPukHJX2a8Te9fnL3LQb5m6F7aR6jwIGdeXwuKp44XfAXcI7g\nznTa+333VFtFqzWDLpe1IJpA2bFPNLHXkkYlh068QfdDkTpIm6kxk9pwG5+fOd774UU8qpNLHClG\n1THuM19CLilHVHj4yoLmC5H/x5GDTP8ZRw89Bxp2LIIzy4NgRDTE2+9JMXSliT4l5aVZYaBHs+Fq\nWrmu8QqtGn9Yp5UpOtSU4NPgm1BYTZ6x3aJLbuqe0/FYiprRaAVffK6mKTV8QAomhjyFoU4HNm2E\ng30yrSEwDdrS6ZQWZOE5H5MuKNLKgbHcuXxifhS2AKUsDSwZtY/8mxbFJp88i+cYXVy+XVS8oq1J\neKLfFqMSecxJ0cWN3nBbSMhdn2iXDEouEVQaxTRFtBwtBila1RErSqrw3axBofirbv2n5Z6DtRmP\nuHRmsZOgxUTGJT1KykNWk8v7oNxRvhdNJEaTFAbvHr7KW6bjGfEjsuviGCoqMFR+ROnB+PzmYTb0\ns0cc6JQIAFaChRwKD0JAPGAihm6O0JQINjhHBNHw0khADR5KCHA69ke8YRiYQ343DTQj5P8HhZif\n+jcT9e5rdlVYr0c6UjrPZOE9w2lyWohTEmrMA1k2kXUOUU+z8cVpFG8Uvvu9YoUdXPpNFIJ8ohqx\n1HdAbd0rhvqDIBmm0iCxoSTCVO2AUmUfwZK0PmZ1q/l9Kp55++TTKNmA/ViheHxqcevNt0UyOKt+\nYbIwflFmBcF2l3M3wqWxUWjPASVQwoMl2UwIoebSS3mTpANJxBpCj/3YLUraS/FqyakgqvalZ2vS\nSLUYstSaTCUozZrDgXAs4dCmZoy6rPU01EQhl1fkkiKqPTLuRwJaEkNE06T7x/v7oHQP+crjTnf0\nU4fuOYA+UEkBVc4Civ9ztwmUSoVQLEgg9kK7GkwGkcFWGRGAG6hWpkxwnuZ9YOC3jZ1rf3qfwCTQ\n3MEF3h0jE6hizHf0FTB8D4rTXREMkTYWsw+n05vi++AYHiRLByXMAZ7dIKpHOfCFCA==\n\t]]>\n\t<![CDATA[\n\tZ8ZgB8FkSWDpgg8G7hWwhvJ/ppqaPcKoXkKlYWdOVlsWTxzGI2xtOg4FJVfolYArEy4juqhdMDGC\nuDvfrU9wpghXc0F/QckKkNmSS0oxK8EMbopaIa7kNtAwAeRhai3azlKUh9UqLp9DRQ8VB9Q7b5jO\nlZHuAU3t92xrIxghmYHAq64ziJEdv74HnBhHPsf2ko5UbCmtfNN4QS6xnQ5LFedAu4Ipm0IjyrA5\nN3Eb1Y8cGzZlI51jQlCQQlZVKXaP2rY2v+1i5Q6+M3Tn3IB1dxQU/Ku9AonXbLcPadbzF/wRBaIu\nbmOuAlF3TXyjijRiOI33YWFJcLjB09jxGPL8IyN1wN31fkzX6Zdc8ahupCj8o+Z6jSPFNfouiIsM\no1gIyM1MJeE+t2Lc1RbU/1YijGykBaRHaveoiw7xK4IS2LXM+WvvVtsuTzvsRtMKH7ztVm9nfo3i\nXOMxXmcuYfOSys19e9rUvzqhtjBZ1W536G226/szlGOJyTi/wqVbenO45fFsPFll4vRntaW3NDKQ\nEpU0IBU9GGqfo0ZpzxdUZroiotZh80QN/O44hLliDGy65MZtx59FxlUHRlSaD7WI+dedJiLklkEm\nOYnMPliggJapeZM1pgXP+I3GKt35IGT3gReVQM1bDyhvM6HkWrRD6Uj9UFyVvbBSnABrj0mjKXJe\nvZ8AJYmFJpjcFf/5DtE/b8FeELPjUI0LsgTz5KotDDCkFa2kOuG+zjrCeuwe4NTQwyl6iCmmey1o\nlA6lF/XCtAFXt2riv9toE6ObssEppUcpYyvG8Ve1anG7exTpqs71fGtMqBe5tVY2jWIFsV0grgOR\nGM6Lum4J6fWh++Dg0Jsvyq2rZlw1QrYMPAB9IyQoa/9Ov9cF4i6oi6yBc51lluWe16DoDqewL+G2\nVR37zRl9JaAQSAzBWNSJRjX2lWMwhQDjwlSxxWAtUAYUzHDIVWmC1ASh4p+YAH301R9dO1pMogTT\nDdgxUJp2e+TEEK3E3LofQumK5S67RQti3P5DQSfLEJ8G0wJKRVqkUeC1s5Uzgyg1mC+Kbo/iHc7F\nVD/YYkvUS6BoV/odka2fCa89YECfqXudwB57BaS1BArezlMfUE2SQgerNjw85ZwDdLFSBlWllCkl\nmUrwQfludncqBDAFHAUcBa6QfHUFfglNS6RSvN6+Tdzex6FX05eMgnORQvWaafVxIiSiRlSQHkWa\nIkRz5ihGJrPQKweN2gmnYhNDIVWLdmJsZzFi3Uanp1RLr2qpJDM6SmRixenUW6EKVZwYvVNRMkRM\n5o1xXpEpoREXrROj2sjwm/lEG6UIP+zHU3rJr1bRWFXlUFVVq3Re4blDxNYTFkZpm10WFbqNVTEb\nY9PRUhTv0HwhlHFMqjXSCUMPQZ3FplpVr1ddRTGxVyKQp/4xeTyyw7jM18OYXrUf6lDvtR3ijkb4\niYLNoekj8YTCdDqtlCSMF33wjFAC55+RV8grjwnyBR/qHj/CaDycCZ/NeD4TgcZVBlI5JWFobGC9\numrLb12HEUq+WYdBmjA1tXJ4FcxVISQjsRPNYvj7htv3rZ6QxatwE1Hao/FSjLeRmGZfUMVM0Cro\n58R1qt2OMlZym4ifGE/FbmfRTqt6DsVkhmMKsRvZ5m5RqiemKuHESRxYQq3aHAvhkITMZEN5TKZK\nLnlMZNJZrEqCUJRLyhRMJVMolfyihxPVLLhAxgycKKj4PO3l32JD+fKHcXH2/XOGLvAy0wJPmz0m\n5hOzWVWEzaZGEmI8JCoxBJFolBA0prsTPtMJsqEhulufTeszS0MfEvpH6ENPIRF6XkZoRQ/yKCSw\nKGjEtJqgCYqhYZSxepXEKP9qqkY5Zorz2MQ+JY4wRyY8QVOK177wKm93kv2nTL5RfYI5lh/rxVtj\n3xqL1fNIubsp6kh4NGMNPZUPh7NyPKFk+HJHpg9f0hGNLtJ9LKRxQqyLTE4HH15IESMYMt4LPhwV\nsjGdfM5LOHnIvDqjWObFxkZ2IhGe6MLV1fr3OOabP0NzOAxizGyfJzHFrchKjHzlxjc1EqMqptt0\napZ5rE4UHV5Ya93ZEjdjJnNasfYjMbPFBDsV22IUpCZIVR6k3gepBympnoLUS/y4Os9IIBJSKYJQ\nKRiEhBZWocpSmZpYYxSBqhhcs1pwkcE1V4PrrR1T/7MtxltlNGmsXoyIGpqOqCjaytsiqmoqpnqy\nGzKrXqRGqK9W/8yJo8U8K5KqTqf9RMm8OBG5T5mYV0iViEXxizLWrH9Z/cs24tc9v4gr+msfSDa9\nrALJqqqTEq9jz6EcH4un09JFREiIAoUygUIhBpJhQ1QCxTQpgnlTxAumA6WEE1+DA6XRCkMSklAx\nodBMCE6IAhmSKURJrRBCERYoFEkMwTM8gkSIl4wQgxAkcYZoCGmRpQRzrHIx3K8wU6GE30Iw2AjB\nCalQoUIECl0donyIGXmIaAiThGiHIcL9koV4iEeIUBvDJZwOOliCCH8JFxELhSJxoWgXhSIlRITd\nRAJJWANbmVUFtxrq1Y461HVdk/0QnhnC9myXb7ApLsG2aT8Ywus0UEcNtGkKtOmqTj0LrpRmw5hG\nCjYlxq5gR7iFFm5iyYTzYQrnpQsUCW1Yo9WHaIi+bJDO91Ad/+uIRw61xIsSyDZ5HEGB/CKFcu/p\nTA9SEjZJPEyRZcLUFDkVpqioHDWBFU4FdWDVjMLUAgBAoAAFyY27E1HSqAkKdxYj2ixmCWlZdSg6\nY0IViypkHHfrlUSJE6sha0RMMQ877Ua2iWCgqlDDnUEonDhz+lsTVi0KK88qrKpBFFbVmbDqK5ho\nOjQUaqaooWbVCDVeRKiRqUWCzDkPty1mQ10WL4gXxKZgUxh3ZBbu8dRwEqQMUi5Ig3SmogLbMs0E\napQzs+cyFGcMxbKmwkigL6sQp9fDXBJOCudswimvh9MB3YUxOrhWcy9IkD7VGmkxlxJHXhPaRsQl\nNLpoDlerRq3JODg41GDRSHK0ajwGBi3icL0epJaD8xXH87CQNw6l47imxHmg4M4z6EsnSt5cVuK9\nUOb0yQON893DjsZfWlFDN3y8tBpDUoGktD6ckAdJMDkJqckZKVIwuem4jSyRMRoSFpFUy6koqQiR\nsNJRUiRSMKyke0ohSpbwNVMlNidrLVlUKHKGNh/FvU4oI0nUwp0sVFJTslYnTTsqOjhSQUh5jbOb\npBVksEXSRDSiKc8kkJCE4aiFQlKyJ2f4DlsmhTJSkpUOsaXXnBXq1cnanI5CcDLLzMOwquY1KuLM\nr4yFIYfmNZ+F4UnnSnVOGzF0f6ScWWwkYZ8ZjYccJlsYmYhFav4y8ksoiFjh3R0k+raK3dFkNE4f\nSsYaEl91F6abCSXr2Yg59XW9I69dEsIy17wZcpkalOB8WTTKJYduuIkyDSEPZfIqGikiOKITh42R\nsY2ELzX+LFG6Fq7Qb6EEfuWi2WuXZ+NbB62dtyy1B7dykF00kRqhvWRGsjB7qU/KDp1RZtPJoxpq\nkdxkyVVXzELOES1+5fLXKEg3UpcXWw/SUQlfE6VAXfRtxIssXQhPNn7FTITKeu+v1yuIjPaLrOLx\nIZKC/0yyb+zQziV5BaHsPGnmL6opCroQ/TVRESaT06txWpiMM/TJWGnFdQkJpX2Kgt1eD3lsrxqc\nVFluTqBa/FrLOWXmdoxYUYvgGIr2GLIm0+CajCEjsnMPKsnwjV24YY0q6tEs9KHgNARNbgaZ7v9Z\nfMEKnJl4y4z8EIXTRkgeiCbe76A21GwiMyUTqcU8RRJV0i2Z2BEuuqMQY1ELm2ZU9YwTq33z9SIy\n8qk6NMg+WFGOW2ooHpQZqfhMK4gmPEizFaf3TvmscRmDphe9mpLGILGBxgudxs6M2/GXyvgtEZr1\nET6S9CPlbdmfECQ55CSzidw1BBnkaE4jXQiSahRq60MSaPxYE0QLMXrCUexbNL41c5NJpOT8zOtb\nFUqphvp5iCMtJR7d1KrpafZXaSI6gTVSFrKZ5Bpd3SMQjSjxqNOJihSkLBtYlmXjn3xMl1p9V7fz\n/zENMS1yiKHx1M/OqIAShDxExRVQFqElJUUuE0UnuMYKUxyRigYpKSIiUn2iickkVB7LDD0SPBNG\nJcIQ9JrwGXrQ8C4D0YpWYRVWr7AqGnEqkCPYdbtMu6o1CnGg6aI4FiIWIhiiEoJlBLeMsBgKZ7hB\nyBGl5RBGwiVI2+AQIWjycKGFMWfC8Ay0QBEoAkWgVYOBZk+YriR4YsrgBZs4C15wgUtohoayGhHO\n0zhfOM1wFikNFSmJhZIwwtqUFkgkkJSlMi4dXOq8CGK+hEEsjpJ+qZOST7jCXrVQ2Pe6fUOYdacU\n6hIf/stwygfOuKqBM5w+3LTIHW+Ik0RD3PG4VCZUW6vwtmZNKJFoEBETLYiIsLwgIkJRCSIhnmCp\nCRdqPZSE6KbucOFDOQwfl6lwsiqc50kx4dzI4ZybDAxmZ9kE2gMRhQMFcgwD0cPj4RNqs9CJ8JKa\nKLEfd9tmQviYb1L12qqeKCryFE1MBP3FoaioxWxBothMTKMSi2HMZY55yEi4C6Pl2TlyiqgRy2a4\njOX9/llBQ/G6RFFPKlbhWeqhrmdhVbgbuaj6mqAJJO/icc8xMSK1Dyk+NjtrVf8arnLPxy/PUU/r\n+DPjW0Y1nzh5NhMUqhY1OvPX2pBFWDUSj/nukrxi4ZEK8SAKUZeoVYjGrKb4ERF/QnWIa0Z5GKdo\nFNKCtjogWIDgwOIGXOHTI+xTUHKGFbVCGKCAgslCLEQBVVcTFMFoVyF9CBaJYqKHKJB6pEFgAHHA\n/BGqeGCqgyhgSAcEB1BAQRQCBBFQQEEQDKAgCAIwVIABAKAbkUsUYWQ2YepUjqyj90NDrhHx+aki\nS5SiE6t4BtXzmZPCDscQVbXzkKhiuDNWnaPEKOZw7CokQiQWiYpQ1m4W2e2OM1KNkjTL5imtIdmc\nIUVioZggg9LeUsWSKOuLj2nRC8fohS6jFTSHwWhR8ULL4o6IxYKGLWo4nCR9UWvUMGqzaBeTYbVG\nJa0YnhOaKpVHGikz0qiCE6vFdOEa1RSrei4hi0n8zjX5R1vHbjYSvlQjuHE1FS0ZP0K7K0HBmbk1\nnz1qXE2bUxmUrhKnlVwVQx4ykV0jI5+1GWWzwIgnVvKJpvMivqVhZ4ZibxQ356H4VpHQ6SJl0GSf\nqmJQCS/9OnKR2SG7mmZIXudYm1GQpWBnOPyYaC4833zmn7r8+effBD8d1ezNlO9jB0l07EPlGVdl\nVR8nzOcYCY0VC2WEUZZSL+5F8BzPsqoltefdo/NYohV5NDrpsL54rLLxhcV/I3+Cce8yf3xqzp/+\n0QyJxiSZM1boZkNmdHPFQCrG1GSIJfFlYpxBmfbjTGLGLaiqXiOMOqerwGDpae5K8RjyoqjXBCKV\nZn2lRG284iimupHOkkko6TDtjklCWZIhSnQinwWFC4vkiFkydxERaUlvJLqMUFpCNg==\n\t]]>\n\t<![CDATA[\n\t3hpi7VTh1i3n1nSosS2OZ1CZgoxVE45+Ve01UV7o2FHoemJKSlXkMlVMlWAXsvGrpnySvxulKFix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\n\t]]>\n\t<![CDATA[\n\t5h7ZYqt9TmllWm4G2EnvF0exkF+UqKtIEFy/aAaP/OjBTSDJHGbYE3J/rHkKvGDJx0bIPCrb3j4V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\n\t]]>\n\t<![CDATA[\n\tTn+gjYyr/wRY7ujfzSkzYy5xdIqyLIvGR4qOQL0melKyj5uer4iVNiMLb+7QqUCDDin8wx6/pwj1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\n\t]]>\n\t<![CDATA[\n\tYVhOPTIRw+/poaKJ0Ss9/FaMitHD8mIUBj0kzxi9nocJjlHCefjzGC2ah5tARv/l4SsyqlYe9iSj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\n\t]]>\n\t<![CDATA[\n\tsDwfxoIQRNc4Igh18RpLBkKrrzEgEPoDG+sAoSaGjbtFJL3kGkAHWZ76scnpDxDlZfz6wQ9mQ4kf\nXDkbQtkHsKFNKfRBvmlT6vhgH0YT+eChr037PUCibWbbgy9uQ7QePNXb8EkPEMJNH82D5ripRh48\nXG6KwwPiaCX6HVypGybdwSp2Q1TtANXdFGEH0eFNwTr4zbxpPx3A1Rv3S0bre+N6DoSHvsmEqSLh\nN9gJxsPfqCsH6ACOHmMiB7YwIkYOgAFwXBKpXOPg5IMHmkYcuBwSB3aehANpAI4XwEHpf29gttwN\njN1vbHKDHoDj2DZofaUNPPqSDRxNYAN/c1sDHQkcv0dUUTHJdBM4BEgNGDycBrrZkwaCVkUDW4FT\nDTRoTHCMeAYiDk75ZmCNcBozA1VYOA0vA6eGU1AZiPHhdFreSkiczI/iOIIMaFocE8egT4zjfTGw\n1ziViYGBjtN1GFjbx+mxhxwA8pHzdsDkmBYGsEI5/l/QZOV4mKscUBYt5/R6OVZaY47CYAB95rxE\nbM5VUzjHBqlz7jF6zpNwPwcPGJBo0GnCuQED6KFjNMXoeMmQjri40nH0C4TRdLoZMDAboK4y6vzN\nnzo+D6sjtWAdY4OB5LROz8p1cAsDdK/TLY+xDgk7JQuDdGOnMBiMLDtdps+OKmCARe2c/NjOVavb\nsQIM1g53uoAcA2VJ5Q68AMF0B0FewHJ3GvyCQHmn3K/YuXeS8gLsfWdqF/wAPFR0wW2ChwK5AJ7w\nNH8LKoenb1vwrMTTWwv4Lh6LtKDGjcfq4eSsgO7H45AsaEPyuC+siKI8v8QCVi2P91dAHvOYdgU8\no62gCZvHK3QeB1nB1OfppT8HDT2ENyJFNYXi6KOHAXpYyGDG0oRT5YVctW0UEhEE2RR+jz4DdptE\nolEqeGhjc5HYezHmBhVAzuXTDJa66oIZueSDCiSIVysxr2MzBvWAAAAVpB4xrSQEKkDlAE8EBioQ\nG1HP3bUr+N4U5MUGekkr9rPvXQpA1aGWVikl3yUFSC/IQuyloEynbL8ZjD+WbVJAnk6twi8TvJvI\npOAw68OD4nC02WtSAH+GW8+VxK+aFPTgZTaZMkwKlr+3H0fVvmabFLhdTYNOZUiFDDQpSKPsStUm\nBYCEnLzBRCuLR5oUzDlakWyDTRK8pMCorJbktC1WUuAbyJvcSFb+L74yLbSkwNTpSwmYxiopYIjy\nMqZutzkFPZSNdyqPNWg7Kdq5PQE0AyEIlKSCjaHlTRRU52syxESBcBT2j2twIuedKCDePQ9mi+hE\nAcTvbMVlt/pPFPz5b0JoK8tNq1AQMIezTRScdngZRwFdqEWDJ9Zh9hwFrRqAd9vPHdDpNd4k77Py\nZqJAHIOowIyAwIgJPylBLRl/aaBWZIUCVJZJsMDkVheu6Ka5+AQTIo/+hfGTd4LCJ5VndXsizsQw\nYdrtnQDRLVH7TkC6+ivvdw7AcYJRhTnm3lvFhY4TWFAHA6zJCOpMfr6NJ7HHCZbpIm0WO8GR5tk1\nYXaCSWgPJtZYv5g9dgJmcoLZQMLH1OOcl9rxw04w3uLHFUeerIMZJ4BPhPgAUtWea22C/MYls5dC\nO0CgCWJTHB8podQjxwTTljCoEdKP1XstLxLgS5C0sqIKon4g46sl4I9ZmPIMJqyAkQRrnPNsleH/\nRdnUfxUYJXBb/lkfYZGMR+tj5c0Ww69ODIlqEvAHlS4rXrgncpAmwezPhNqVp7qfA4HWvTDGBU/S\n85CA8f0nAoqRcjskgA60pgcQyFdWHwFSE2Ijoy5DJ6KpWdARlIXmmtNRIFG8GiennYGOgJaznGYj\nNlQaaY0AUOxAJEzMrWRI7p6GDqDbMvgWQduzeERTyvZplSIQ45v5NAcwicCdkkkiWPeSv+gERMDT\nlA9FOR/beGD8GwTUwrsvvvbB7ULAS8FnvJjRoCUE7j+88v1OpQc8zQao+Hk90IWZgJaWCQKsqQBc\nuwaOrZkCQdKilaQdxQXiKYDAGMFuUHnK03wENDGX/9D4zYUfcDdHdXeAU/qDPuB1JAqX/t8DejWJ\n5ITsnt+krQfU4DnvsEZ1HjgaIGC6K/6E77T4F3VMDRxZAg9DcxwdkIkLfnYgr4Vy2teqUwbM42s/\ndEDTdyjcjDkgfLsG9qCx4+NATAvQcCDBlSIqNOEr2EvfAMR6LxUDi3a6AaZaG09/1sfxIGoDzma2\n0NWEhg1MruT2X2LMWKQvwRqYgzIWTfan2xZQIfFBwmlA/Ul6pJ6podOAhGhPB9pBoBhs56KBSjuQ\n5gES8wzsrnDuE/DxDGh2EB36QfFFtHGwmQFIqLyygh7vVQbC8kHuavbaaQoygLAsBHpDVUc6QJKk\n+LwYiLNQzAJdRTkMWJ8I697tACIuGFgl3Womgv4qv4BybI/h7r31f/rzArYyFgaFhXfrG+3UBWp5\na8fTUZsn+CS8hmh/oqXKGdVcgoRcGVsAjjHTlkU5y3paSC81ooZNfrZvGgtEq8JlP4KT8xPgzO6t\njksrEEPvcUR0We+qwILx3rp/i4UKdPbSsNgx8RRTgK3TrPd8uLYzpAC0dLa309EFiIgoAD8d3hdm\nY3cLNH8CSp5zlvPNPwG6346zXpvm9JGdAIhpBatxUrlNIEouVMWlTSA2OV1ep7qsK2IygQXKYEK7\nti0BHEO1UpzNXpTZLyVAkfmqTEhJIMfj+dk6RMipQQLSi0+hvL1zHAGmvPCjuOA4Ai7pQxRRk5fu\ni0C5ssiEn6mL3ghGFcCUwCjlITA7jeErBGANJEXN3fBLFIPA0uHDc78vBwGBe4wMja2ra7JYfgD9\nV+GzyFoFHcMHeKizp3JMt1bQuwFjBGtycRjVAA8Q29tyeqlXAdcBV8e5zyFmd3QOCGmkee9AlXmI\nqVAuWp7QFkcRGXkDGOGxzBpCBaL++nO11NmA6NwWh050SApUA1rXQ5TXTC5DA1Z1Mh0z4AJ1C6nh\nKh/Z4DGAISW1rtvLvwJPVi45DQ4+X8nUfF+AbHtKrZDAgARLF1D7jDu+k8VXHbrUAkgazW+AV0cN\nC5h+w5UnYhonIxTDCtCazcmsABqlzcfZRqqHCtCUCjBE9ewAho4C0voDcRPIZ/zis5biYFJ7TYC6\nesiy7uYSlgAa/soKx98S4IKvN37ojE3nIwG0aEL72YVyjw3CjWkETEKZ4YHiIwKsAeI2WRPIEAJy\nBaM7EZIdMZzlPsHOP0DQF0d6YcyLYT3AAi4+Cygp2AGwXXOxqECaJRoHyF9WAZqEGCIRtQFWxymH\nHTK9t+9oAGrpAiObbAMiA8A8CC1tyyvPF8ASSrTPOSAujfNqAVDvO/Y2ajOEFYDSyBNjDiKKlBQA\nl60C4aJBv5sAnXcaMNKMK7ueDbZnCws8ouGoFQEYkrHbUOjdwznOFCqdQyM3MErGSzwAN2phdBvO\nPlfzDWCtxdKAd28AmpmPX2hAbwCopRk77vTTrO4yAM2qIaLxR0TPcAG4u47Tf8o8z4wpgEhOpSwt\nV4bEuioiok4gm4z6XiEA3eAw1wcBrhDEAotwXdIQUEZPiL+/mNzDoP4EQEi1kjcyld64iR4A7ug0\n4FGEFQAG2Gx7Ma00xQCAttPxvLZjETV9AGAEe2Spx8rRnaP1/5K6r9JKywnxf62Zhl2Fu8WPDv1P\nqkRl2K2nGtiOfYTefyaGBVZhhdbmbv1XUOR6WnL5dcwAmv9POjdvBj3npiLxP3wWgBXF0zfs/mEt\nBoir6twu+8c3NlTBVsLK/itpSPZv9sCdSuhHkar3L4lj6j/npoz8yz+A/ot1okluNaPlY0QRzENw\n1/ivbBbdbKYhlBP+LzzD373/OXDN3VR9AWWjQn5b/tKuyRJQ/Zs61/4qCM0gUQ8jxf7Uek2FWyT1\nUJb1fzzlR9J6gIb6871A6aQraqeP/lKshqlNH90lCZ8/K49OQ4SjXfNXy0D4Q5G6tPyn6d9cIT5o\nk/x5UuBq43963GdUUMedGR/++u0o/VcWBS06+Ouqt/L/XgJl9N+v8ApzvYnxKpa29/PBXyOi5+/9\nNd5vgT9n3VkovfsZr0kfNznR/cud0NMJ3f3B/eBzQwJcFwGv/WrTHCYSUU2qzhh05GrOfiB8ipz0\nGJJKZbF/wxZi9ZWFr4h115+kOAFgb9XYam+yfr74p8xlkqSp/kmF/J0IXahB/YftRacJNImrKKbf\nr0mAA+kH0lE+0o9L7CxzO5q1w87bczwf5j/Ce39+TLTNZy+QLMC08ycesdzgrtv8FlzoppRXDJH5\nD/Oa7GEk8dryg+9pZZOJGgC3/EBckNXIKpY35WeHjO2hok6bkEn+lfbf/4QBFeGPHZA/2STI3/q3\nRhzHTwXUK6dauGyX9sWfhGXEpXBM/EmHGOzwHzgLEyPIAAq/3ex63N6iIEpDJgRhCiwBiGTjSsDP\nBQ1yDcFtRsthpPWQ31cOy561yPDD9+HPQCaR+kJ6yDTqe95nEGftABVY7DC6vPvIjvneyKXKqu5H\n4WWwlLmvAu5mAjCKZlUz3K8fAFHGevogypfg6CqCnxNgJu5XOkpB0/812DGDvx+AhhXEdftyp5gn\n7hdym24r2secvu72zWqTkXLJ9k/wGcWB47PUPhBZO+na1+FXFiC1/7HXO+19nc8gOEs6oPa1eCDz\nUl/UvhEFMmur5lD7+EFShbGsUjRq/yYhQP14Uv9R+yyqSJFC7ac0CJcn2tTZgFH7XLUnjQOO2LEB\ntR/DsSwp5rjsJ/Q++3MWleSmJOmXIuRn30Cxn8+I0mLksw9JeUlPTzcdn/1GFPixfemsmWWVfZ8j\nXeqO9H6uyn4jASASzXtAQ4Cxrx2+aGVf4eAs2D+RVzlVpqS4LdjPG58laQklKY6C/bTSRmDSNHgk\n2FfrgtZ9/lIfk2AfGGvqA4G9EOyXyRZbUDW3NLCvrOdfcmBfwHFArWZ0NeL14aGsMF/JAd76kNvj\nSmHcgvRo1tckXKxUKvgw6wNpBQ5v+v2U7WxmfVQrasTZ2aw/I+TGBjeR2fxDQW03FY2QHVZ4Wk31\nOzfZTvV1V3NiAGpaMk6pDy7Upqr6AeqtUhjU/46UvkmwP9mM018JPx8PchHbpT/9UsuYCRlsDWIl\nfVCikOVpHKqkT6f3W+pv9Hn6KNUVFa/wOkQ/Z5k51cqZEKKfvztxnXUHEdUP+sqTy9cshmtb/Pz5\nGLHJi+PcTk2m598sTmQSdP5rRS6NymZklVp983+lAc7/2qXhEu5br/lFEkIR3qFf0MOZj6AnS/Vg\nnU/LSzQU81uEYbKMgKAiSl6+zPX8zkBYpvDrr2MBzIu2dYjGrspXGJCsA+io6eOoFoRlc0Ht8cwd\nj8LkT0+wqpvFl5pIG/JlM3yXEtHHn6bAJdL6dqx0/FSeWZktGCZvFLC6xBBsRqKI8WcduvF2g71m\nCGbxo7oDcgg8UxlaFP/06/zeSmRlptO1kfj6hR/04FGTsFRT+uE7WjxEzXEgBuQhtw==\n\t]]>\n\t<![CDATA[\n\t4XupoA1/XA9eaB1R/9zCt3jLgIXDsIOEvxSEIgg7BtAnqQ0+w2Q+c5I4ygh+oOaoOCqIQAR+X0Ih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\n\t]]>\n\t<![CDATA[\n\t20/TlNm0dwYS9Vsm7a0SmMpLNkQppL3Hc5K8U7pp71sj20tKwsfDtDe1vjwmm/YOMz+xDdgFTTdo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\n\t]]>\n\t<![CDATA[\n\tmcM3GpJre+djaMrDIrwCBr9M69o7aFO14sFq7F6rjE/l6GwF+rBtg1u1p7ugtwpkSPQOrgkOFsa4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\n\t]]>\n\t<![CDATA[\n\tccuyP7bqA9Iu9wgCZviPHZMINBLj8WNjo7DmFCY9jspDPZTIaLcKlhF7GV+7mcU+1Tp+SBwLeyDE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\n\t]]>\n\t<![CDATA[\n\t/NH9HS7eL4oEvH8S8/6OIZxMXRnNZTCwq5ssxmTa7RsMUM1m/eCUlTK934gy8NvwufVr2lbO6cLZ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\n\t]]>\n\t<![CDATA[\n\t9gnn3UGJfTaRZJ9d9ChoG1EC3jpdun4T+NZ7DutsIUi+f4Tpdw9B8tk6Xrqu45WzicR7NhGl30ey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\n\t]]>\n\t<![CDATA[\n\tRr6MGULJ4getWKEPsQygzkSdAudJucQrutiEUfSzVS/TBRY1zB5ZziiNdNlqFoBFzXPTSV9l90eM\nS3APE52aSP48K5N0P0uf2EE+2XJ/kTT5gFSadC8UJ74RSZZbVBPKnyZhkVNPRCOWoZZKBj1XRHFT\nTKKE7K9ViI1WgB+zh3GLsAOsliHscRQR3AQSkAuTLNALkyjQ88YFELMbA0DsbPxFRD3u0uXHXLzu\ncRcve6wlxNj4igi8sQDExCewqF0SKtnUBEOR1FS98jZ4Zcv8CWBEzIoV9EvocxAM6NPvq2kG4xeW\nAqhfXuMcYIc7moypVjr5arKwsgaopAq99qVV7G1MRUwcg8vZJQora49JFPiEWbbUfgLQIidSMcBj\n1tCCZmlji1mmiiprnamtc6KorHaWq6xnaQEowHshwMSMFoAYflFK6+0IpcodCUXLLa6R5QzSh5at\nOLXVDTPUiZ0lqJM6TEskgZZhIKeWYCKcmYlIGjUrkwxCzuhC1j1gAXlvvAA2LgFcxNrGWsK+WQIw\nZ6rIsoY5+ER0su8JkMrAJSsqvUZIKweVmKgERIJDsu9JD8m+Jz1OJZmA8YoY8X9GnnRMF1fUSk9I\noRvxqMRxhGOSSNEUUOIcV61s6xZo1YoY6wATMf4hovvFy8ypworbZ+IRyc9P1jxPyyaCl2EgpJiG\nQDQ5FYs8Zp6YwuY2hoLNjnWIebVcoT0ZjTRmhoV8akom8WpKGgFjLhpZvGQc0nh5KETsuGplG6jE\niN33ZMjvY0LEjpvCwx8mUbI1ZKXiG6MY8C1HUHGzDK9qirlEVFxyhdTQ7Aq5IQ4sgqNycFVGpSAS\nFZSCSUxQCiYxIfYy2dRkdBLudGQFc6qw0vZtYqVHDulyg6JGofMEM8nU9DLp9Lxk/bt0kQUt0gkA\n7EohXMgwd2xBqwSyhezzhBS4UFAoeYRQWP3fMqPukICqNsuJZ7ZrACXkNyk7vBiIlDJRsZKuKOOR\nxkImS+6zBHDUeFV62HpQfNxpU2LYWtZUewOXUnmDl1RtHZQfv1IIlTJHIE/IwEKIkNm1+rDPsLC4\nzbq8sL8XFn5rrJpFQGQyzI9XwSB5HLDNbERieEloBPTyW4T08otE1LJLxEVlYJIakn5Mdkj6Ndkh\n2ffEh2QflBySfU96TPoxASIWTLLiMqwkMrMyih/mCSxrmyqwsGUWkCVNEciW+7KAK2imqK14oolO\nGkEhlxCKf3Qhi0zS5UYcwrqFW8Ljy1VqyNkBFJAVvBKlFiPZQjZJpMt2kQoCnlCLF1rSyAG2JJMu\nd7jKlW4Y5Yp/ZN1y61lZ9bQCLGr6iqrNBYDQOswAVW9mJcb/W2DUWQVS1NkEtJix4xnZOgM0kcUz\nsJwxLvHyI3N0GcscfUKnqbj6aPldPa0cXH1BGUiEyKQfEiOTf0lWI/uUIInsW0JkEvBIj8m/JEAg\n96CsSvYx2VEpyCSF2GvktNIQyWMlpBNBS0YlhppiKICko6x5ni2muFnOoIK2mWJK26KOJ2R2RoL4\n7ZIWP0SVEXUYa6nd1lrDrqNCpJa7IqQO1BKlvryRBe1SiBYzPSlB/gQDTMOwsIyCdRjfEBE2/gHm\nhgAkclsBlmjvAxDBviEghF5UYuUGPdEa96naSgdq2mrHOaI1DvEKALrf+Et2EYoBX6y1RKdbV/S2\nJzXsPSU+bronOG64JzXuMi8F1HNdiNBhLVp6JQwtZpiZTvguE480Wi4OabxcNIJoCT7SWck9YoJy\ncEmquJvkFJPwCSVmohPEUMknX3GQLmV4U5rQiEKi3KKOTAw1v0lAPR2ZhD8dmRR6ekLRq1z9Mma4\npMp3XLWy5SwAy1pnjSps4FUmt/yFhtxgiBhb5QNSbiCkUqtBAKjaMi0zPPfI6k24emQsTgoO24MB\nqnOEIJjzhSOdvWsK6K1tcjomRyHxZSkl/B2FxTe78uJ7ZUmts1YzZQhAIrsCGIregxfSmkyKCxss\ngRL1BgKkCGMrgJIspQwuZZcjpLhxhkK5s4SRBa1RigK/ccoB/lEKAvbkkQTuzBZY1DxDW/E8IZeA\nOxOXNG6Cj3RmEhoR1TyNEudGAFas13jHF4YCsPjS8oIaBkFJKZgHAbgQC1xV8i9nXEHDvLEFzdsE\nS82mwBJtnpQjNZyUIPWcpYY2jAAysmMH9NDGWRFSNya5clsGyWKW6OSKTfgkiqdMsmWMcwYVts0C\nrKgtJpGyrRUoQMsgSSWWwRBImYMBTuU2KzNuvCU0yD4kYEpPzQjXFLB4aj0skDqHGL/A+nl5Ul/i\nuILW2NrFhkTS5c48MaXN0gWWNMhVLzdmaCvdJXgIqWWXyApLL5HUzMMilJviJoFiGFrOIn0ccE/y\n+DJmuSJL2uVo6xwmI5HFy8IhnZmORgwzU6fAEUKh0uOe3Lh/FBR3GCuJfnckx3ZxRxMyvSE6tmNP\nXHwxKKp/bkXR15rQ+IpCnIx5wojSRkoKJe8TxZS4yxxWzs6auLCfTHD/VY2m+ViXCBpANKyBAgqz\nW+MWX2ULANECsibxmDmsoGHWsJLG2INJmXjHlLPIH1TI2L70qCMYEBrWVIBXa4A0/CMIEdNdXUx7\nlxdVGkOV0LnptPuDJO9sBjUcaxEEgIGFC8ASbVjLlzpyh5exy1Qpb5qgUOwuN5nobXo6ydscbaXr\nPDHlDfPGFrTKH1nIvEpae52UIZ2MSw66b8nqNzwSxVZU4uVn4uCSttniCpsnCSlxniqquFUCwVKW\niIR161XC5AceOWKrScHR+5UXNdYLDFnEAirkMyoyfpuUGbZckxv23BMeXy0Kjt6x1JC3VWZ0e0qM\nuiyJirGzJC22Y09U3GlHXGzpitzY6hnBMab2pIAPtqVE7WUAiTkCE8u5QY5I2sGPSRlsS4l6mwUH\nbVflCP3IeoCdCQOLmmSSA27FJ198oAFV6LYEjmjVAkBEJjMAkWzZAYhkAatIoRuhZLETW7n4RChY\nfmQSLtvIIli2hk6m/DUuQGaxMQ0sVwJSYB8s0cRKtWDMTsBSKjYWJUavQ9LDriPC4447cuN2c3LD\nNruig1azgqPbQdlh0zH58emY4LjzWof8Qx5JyAaTELn9kAC576QI+XGtOnxg66r9KCQKWR+UIbaN\nhUY9f2lBr2nJ4d2iyNhyi/Qgo4Ny487gZVTWsACqNu0Ljq72RUdNh2VIvWeFCc3ISuV2jKLFFg/J\nQqbZosoaJCsX2zsAL/PlCStsmYdFKDcdjRhejrbOiVOluEGuerHDXLzUiFwA0BefHOAVsQSgL1Y5\nwDsS+WI7DjnA7iKwhT5TQIgcFoAX2qwlm9ol00A7ghExDaILaefiMkpzyEI6e9hiSn9FOfViVFL/\nZ0Vxwy2xYQMS2UEG9jHE7AtkdcwPiI+tW5IVZXIU1C2IL6B/ggKe2QhbMrVbAkjN0l5myDUCOLRe\nCqCQPSxwIrsgBmTdgQnnvXdDhtqeER/3bcWF34AAEtgqJZPYoUc/O8rU8F/1sJyzgmjOCmA80kOW\nfrQRJqB3UGOSBnHAiDlti476z4qTWg+BJ7PaeAmWbtyqfXzyxaYc0mXMkPWKz4vipEZj5UH7VhZe\nyyWGrK3CYv5bbMy2lRh1jeVFbXuxMdtZQVLjVTlSz2EZUt9ZKdLpsgTpaQDYQW+53JhnLDHkLBUX\nszzlRBdhgAq5CwAm5rIpNXwZlBY2PSWFF2GFBC2GBQVdR0nh34rQ2N4JuUG2diTGFkwKqt9g5VT2\nkpJa9ycsehnrC9umAqPTVljUfYqLzuGAUtnCFFAZxJdUWqtFBV1WpYA6sAiSrziEyp24OuWmw1Kk\nLjugx+wTwKEdU0DHnEaAHnMbAj9qui1D6rosROq1Lj7otAN21G5TePQzKgX4ziUGvd1So3bDssPX\nTfHht11o0NoEYsghCKBCG/fkxu3G5MYnY3VhY6OkoD1YKa27pJR2LiqjdAcrpvRWiYmxNCQoyrRK\nTLdhrKn/Kwqq78pi2itA4aS1lGjO8pYTnW3Ji232Cgk/QYqnlisBVHmrhIVdJyRGWd8OHGZxRV6U\nkS1Jsb2jqPh2T3Bs/5wIsd2y7PBmANBB2wbYmAuRNLk7b0xhExe5QgbpxMqWsUqW/9jEi51pYoqb\nmIUWNEghX+6vAlxosAFc6r4EWue5BJbIiVe6eEcmXWw+A2jRvo1ZsfLYRxiGAqRiLShAitXqwqnd\nSiA1uyGLKA2iyujvokL6sYRIdgQqEL8VDkePtYOyVzjSSUcQIqYPrEjsRJd/tQIZi70ry2n/yoL6\nu1pHPe1E9Z6lpN6fygl7u8WFH8uy4tMZKWDb54PHGBcCqlqeRjpZJu9MLCbODLthymcnE0LC7AIT\nzt6hi2i/s7jwtwE3ZgcwIn2EHZY1hBuT9dUOyp6BVXQGoQW1FtGqWm+RqLjlgtAg0wuSgywQyaqd\nJ2XVewDYkMkQ4EO7ZsCOTiMwQ/4CgAutCAC0yILgckKLvbKCtqPA6GatMOytkxd+nqKi+ygovtmV\nF59NS45+G2Bj7lle0GZbavRtFxk1mAEpZhEGnJhDeEkhi8BiggbBRZXm8GVEVoOWUxlDlVFZqwin\njIH1c/6QZbR/yHJKZ2AVnTssKa39ERPbeYnq9uvJqQejkupBXDmtu6SU+g5XTOkMVETnCEMuaQc6\nImsLTkDlDFhI5S0spHIFJqHaDlRIazIkMP6dkBtkaEte3HYri/+jxOhZLCtomoqKLuZFxSxmgIn6\nCwAqZDAvK+T6Sou6nrKiY6mU6BmulGopOPGcO3hBnWcqJL7alBt+rQmNb0alRvdRXPQ+xUUX62Ki\nBqNSouYQpZSeMGRzvrDkc5bgI5PGumFZR9BB6aVOwWNAhndkR5CCt4FOQjIDpOHPgAbj7zDl889N\nTMnEWk3tDFI+6wU0IucGNCZpCkc2aw6sofWHJp83VxLOG7ukdHumZMVYHBMaWzgnNmy7Sw36e5lB\nq22x4QeXHLEJV41s76oA+XBcevQ6LUfowQOi1IhVsvjABKTQZ2MjWbMDDNGqKcCDLhuAD/lWAMes\nLUANLdeYRZhVk80wAy8K5SZVQnoJ1UsbffbVUywOa6whlTSILKM/rMnoVotIJl01Q/FLIHJZ5YLx\nRwAy2ZdIBz+NX1p3jV4gIxFDk84aAxRQmkEBi5/KReF34COS7gCAUjpNiYoxNCQsxjC0gtJAknn0\nTmLd7OCHWKshCmg9hXpoF0n63ROQaNbaLCm6l9LCczjSaWsBuaybQr92Uufgn0qBWG9JQdWC0HJK\ny0tG3DMUFP5MyYv7bUmNu195QWNAIBUr4Umm7CCI5GxFRHKur7ToZFBcfFnKitqzpvha1hR9bImK\n2z9p4WspJ3wtpUW91lrDjrPio99VAfLHstSoOyyQKk+Qwqm9sGU0K1dZUfsnLTy29UTdpUWV1lCl\ndM5ARXTOCqI5SxiSSU9A0ilXUOI5T1DSKVdQ8jlbcAIqa2gVpUM8OfVgrKn/A+sprQ==\n\t]]>\n\t<![CDATA[\n\tgXV01lClVI4w5JJuQGOSliph2BGoSPxWNCI9AhUJTijaEnhszl9NUD+HJaI9Q+tnDSJLKs1F5XTG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\n\t]]>\n\t<![CDATA[\n\tyh6ooNJVKihroMQ9b4c21+zB0aeF/wdRz1/TtlmYso7ldjYLU0ZjuS32xUNY6MCvGGTxr62toEw+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\n\t]]>\n\t<![CDATA[\n\tAV/0WAsIBWMWHGpO0FXgdF4L+IYETByBDxGf4Tc7MkLcwpUDHUs8LwMmGLNYRDRlDldQZayUEd6m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\n\t]]>\n\t<![CDATA[\n\tI77Dg3gOt+E2MlwmhsfU8BpOc+UxM7yGx/AZzvkNv+E6vOdqxCMwaHD9U9sSQmHIFWGco0PeGADY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\n\t]]>\n\t<![CDATA[\n\touuLb6jw4cpmyxBwUHYQWkrIW6ykshWNya6gRWOXMnHIyfVUJw4/1GlhkOKfX7IkYgS8Y9a2NMd+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\n\t]]>\n\t<![CDATA[\n\tNHatIJ3yhi2nshYTTnmqRCINXxrNuxaMa0WImNlb0xpp+n2lz0EPtLjXcwjj6hzCufmGK5f1ecyT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\n\t]]>\n\t<![CDATA[\n\t9itOAS4x6SA2QBpLuYkE5I8jGKwMpFP4+4Di2UUsfxV5rAPtj2VfeuOBrAYoVBfAAnf3y02NPXn5\nzqHydd3gotFElLm3V2491xAXLzrM66Grrm8ppZuYVjx8H9tpxyVOGxd9KydLCM/+bBA5P0j8rUSV\n8nP76rHHLpfGqTa7qxylxzXdzEpmtasBTYkwTiAN9lX/Y3cnlraVt/rP2AIA+RHrlkuOSZ1D/2zd\nKt4qRGjfQzTZHCGzPTX6GfiEafU+VeY8ope4w6gOmj3VWL+8NK3wuyv6N55bYIlRVOHvpSiurGtF\nVFhuYej4PircDDNgdRsaw6gXA+CMd0r1KR+TYyKwbDu/T2CmDJidpLxTZvKzoyxYTQNvmqvZpSSJ\nmxVpOFVhgLVCNnGjYjTs1KpwqJ8MDH16H8zDJsrNAMfVzlHrTbPuLKoi6iWBAUbUAczD7nwHExWo\niU1BoXTi1keM3QcfVu5gAslkNcUr8aNFvR7XFkFv+6u3Ibmv7FZfyC+BK7CuhvgUWOQKrolI0SRg\nGAeV2fX9aln8I8hdVHvkqb90RlToTtObgka+YScASNC5wMXzJr4JAU+EFB59xFmb8MesR8WOn2OC\nSAHPn9CgsZKaxU6wJZOVTX5YbeKsHNBducCs8iIHgagsygZr3zBPJ9ujLswuVDzlJxjPQzltJAJH\nDeQJAHQKtDkxMmM2OWI0NC01NTc4LTQ4N2MtYTlmZi0wYzBjZDY1OGNiZjJlNWFlYmE2Mi05NWEx\nLTQ3YmItYjMzMy02YjBkMzg4ZDVjMjM3NCA2NjIuMjUyMzhhNzMzZjgyNy01YjMyLTRlMTMtODZi\nNC03OTVlMzIyNTJjYjlkZTBkM2EyNC01NmY1LTQwYTktOTRkNC02NzU2Y2MxZDc4MGM0Ny40NjEy\nNTMuIEEFyyEiPLB8Mrn95nSQBmCtRg2u1fjzPIDhkXMIp2r8BW1zToJvZwRsYGEaIP+CcgIhBLGG\nsU41PzV/MJ0HzdoOWhdomqgdPNLHMX/w4JffTtFjggO40z2462TYuDMbOtZMAZ7gnFF4MWuMxn9z\nEegNLlwDpAcWTsGA/+YHwEsiRvTmLfCQPo75/83BM6/3gg2szQBafSwWNYApaQMzMAMzMAMzABBr\nv21U+W2T/tzWyJLd0v+BHvqBEFpmkW2g65BLK3un5Ev8FxyPZSsaegFiATsBEQ+FIDnBqGARBpEH\nIog+6JQPJFIdqNPK4XAsl9RGXvnURi7UiYR97ATk2gOt4tUE28iJiIdS0IbmjUUgcekBb/9nzlqE\nFuEj+piI6pVVKojqQyELqSiwEEEyikCWQad0riQyMYHAtY+d6nkmUUSSYFJIZIHCU6hwSjUiqFoF\nElCNJiRq48pHMikkomkaSyOOk4A6lYI6NFHE4ZKnAZI1EpFIiBapFsEjoymv0xbsUIcBEyZU2ElT\nnWEMMABolG6fgOq1kbwUYqFaJyDyQtB5JTZiAapRjVjIwzKoIyDCQk9lMDGjGkUi16snE6ISCfQ+\n0Ih0OK4kWogeSYReAbygkcRRbxTJX4hQChnNBA8JBNHbPHViLuiE6CNxXAkDOpH3MgyATCKXPJLi\nISHaWEjRxkLPo8JZSASYNhZB4wCEAYkAD0iXRk99gHAQ0f48HEmbs7jpaByOkq6l+ul4anGwG+jM\n5vuZc7xxRKYc11HJ/qbmO1y1f7MXGV2F7ny1c/PmIvwkIfD7c9fwsSX+e3PeWHPuX3NwgdGxjrBj\nktCoXkshH7hpGBbSYx2PSXMDDEoDFVBcyyvRWPvAOQO99eFSB4I3NC8LYkKSh3fgkNGEJA9OBJKX\nQQRRyBlcydMAeVhGhUrQE3kh3t05xog0BCZRnRJieRFhysfRWPs4jbXPg21c64pIRhGMAYbVq1vF\nxNUzh/A19H67e7dzeh9vHgV9KJQ8KgVZHRwkr1009C4i+thKsbAStYHqgkoexwKi9EosJtjnoRMa\nkThOdVj0c//CcbuJfBQ8tKIqmA1UHdpA1SGSFEIvhX3QWx9IxBewsy/62Tkvup+7f+Gc+xfOviww\n7zX2Frj0PYhxgLzCqYbHWoZjzulzTjjnnHP6hHM25yItQR30RrVpJAVKr/M81bGRjSSF6rNwYD5y\nQhaSPCRzStc87HUmcsIjr4wi9CJ4VEg6e7RWbyQPMEwWTPrQtT4RkTFK+vbLwff+fz1GYRToGvwW\n5vGtTg243FMjrqYe7CJ8vh67TxIC+4ORue6Oqxl6bHE1v48MWYhhgT1BjMIojMIojMIojMIojMIo\njMIojMIojMIojMIojMIojMIo6cEojPJSA4GbOzVITmIwFplF/3fLU4MX1my1e3aueVyPX+zV+P3i\nXP/6xGjO0C3PmUqNxHimnCn3irVe0NXi6sW1KG4qMV655thaXrnFHHvda0lzec6Xc3aPtedpNlNr\n8fhtsWffLDW4OVwUt7iw5W5ZTa1mr8W44qcGW69aVAzjw+hWe47F1kiMZ86t9svy4GIPWVvN+bO4\nmqfpfjVnHXu1N8cWTA2XGvzYL8tdKbjcv1pRxdWu0nTNsU9zsVeLK24P9mIfW/fqV/8O/a2omL3W\nlnv/tloxZIpbDJ9Dxe5csSt2z6UGO8VPKXbpALf3Fl5UevDjt6QGP8VPPbXA1W81f2Td0JdezSwy\nF+ESF2cPflvNrGOMDd/das1D6wONpEMzbPy8kRj8UkNFV4/4SqWG8y8Pfs7xkwM3g//VSwz+5/eK\n/2FkjC1XDmP8FV+lhkqP999cyeCoNvQynDF07sfNPYf97t9T3D+5XSluy0uMh9sZfsPB1Rw9NQiQ\nGhq4k9OeN8wGdn/3iv8BgR90yN6e4n/FniQa2Dsqbk+OhtR43N5KtSte3rm3oDO1PMXfMcYV+Rf3\nVuzm9viQnaUHL+wsOXA7iRF7aTE1eFH8/Iwdu3PsX80aicHuDF9xjHG1/4r8vMAI+5VKDfjpwe4K\nfpLgbk+SAJdSWAayUSRpaKoEgj4OCXV0LaSiAKMwcE29EBJQhzqoM+uxUwzRkIwkSakDUxFAQEAk\nDigJZYOhHKgZyQcTwEAGAzFhLBKJAoNwIBwGgiAIQsAgDEJREIJALMVhEMQwCAp90wG08cjhuTgm\ncfQU6/WIAxUosPSp94aJTY0kKovLWhTDdZZZPr8+yWc+6M0GS9+PaQC3H8xXIe8HkEAacVNLOCnk\nFGu9lwYVJaL7Bt65CssZ0NnUiyjUnYnyALhtVNFf1Pu+rfin9NXy8QvQkF/WNlEKU0y3CnaE6aru\nmNi/nrcFBuRYnEcsNDZzE1hrYQokDd4Kcn8pvmblwLQoeckE2qa5jy54JQmEMNfWSWTepq6YDSba\n7gbNuK9ghfU7w0zHvk7riJvbgY+TKBDw7OssK0SXo7QhcCGbgwq8rhfPX3Y/RdAd0pCUs849k9vw\nFtw3m8SE9HNnleRYUooHVPpcmtslzAs4mv1lzh5lg3h9fxU4DCD1AjDnlYjobJBntU/WBH24KYdt\ngoK5IJigOSlIoLkMbTQ1AAO+uAJqPWTXLL2i88lAUmhYHgV0tLy7gbO2gGrPZXWgo2+B4aX4/sqh\nGyeu/hug5c48lBiicAtYb9kmE7kcnrkyOnmVEI/lfTXn8og5efHpI8aJPmW1aeYnBrJafYQzuDmQ\nsMcGapaX07Cf9sjeDBR0LxQ/iF+tJmSuaQHxcXDFgYfsG7z+klOcH4eeWdT41A49ujNo3UtOAr85\n9INjTcedm3MrNwRoK8W9WRT7KU4sBv9xlTsGjp41GPitzt4gAAnjYpuW6qQsVNJhy5LPrCW0xmb2\nxlnwW0g5dL8TXeHf/iqwYMZv5u6OCO38TOnuYTthmh6mhu2MVRFsgPrKuwaq8ekdJkWZvOuT/OrQ\nteJFWx0A0tMuDmY0Z6RgubQYNYkJDaHG1bzqyG8epgS/ZylwNMHNFFQDwV019ZT2cE5ETP+B9lme\n6CmAyYdk4OsjE51fLAzD1YRqExKwvkK3V7VpP0gW1W9hGjKmWs5aUIJ02LUMl/hZnkKKC2ccrVpU\n0dRBkbRF18uIhHYVkW92ZnrH3h5b/gN7pJrXXXxlYMLfHkfQkURoLRwVIsWDw2FPJastHH8UoXyH\nU487uZYdGKJO6UV05EKZA/0hp6URZ7qqgACOanECz7yJXsgNriJtSm9sdB58sTXHjKhp50uTFxq8\n+p7OeDQqRsyMaVIGnRQydXGNEQ2JwRCmvwoGd8CsM77kGmST8rIr0QVSWVyqbigrdIr6RIoQrIXk\nKMPm1pHXmZD5mM0l7RO8ZNz7xjOLj9Q6T6OZuLaXz4DGJDgbNxs5cpotL8YJp1iYyRjCuIQTyrNM\ncPeww5YETCSKkgz43cyBJw3Ic3ifIm4A5YXrk8oQ0NfdPjbzXb9RmBEFt6C8aSqXkF5wevrCPuwC\nuNpU96b6bbbRh/jnzaSbb6TPQRTVNFzcHLr17f9N6eIxRLUi204rSlNqoo6wl5l3SWVnSFiLdTe5\nSkUrcKNpd5Ka0wOgqPoLQzU2bR6tfS9/EIl1cQpiZoTgyzbg2O1YpPkIXM4KdJfP2A4li0PmY1oz\nVxi5ohHQAn/g9lNVy5C1KOebMwPMFTwrgzN+3gdg2SoUy45Uw27tJHSTcG0CXrkxTuSI6foP9FOL\nu50v6kPc9g3Xno+o9AFMbXAKSFZdQkj+xQ9G4yfS7josT0fAu3xqQgrCnQ/mha6mqB0A3dbKY2zS\nYaeRyMe+6LZvYslofCFPuWMF90IZ+Cs9tA6jqD6inUdkWn7eghtAWp1Av8M4c3d5VdIHQk2KSgLL\nA1jvfKjmw3a+5wZg44VSlhS/cSRXCwC1ldP+ud0SbRhdH5DaaYDH0Cy5zHA1Jgy1vU1MFr8Wp61C\nzdybwtYGnL9xvyOZAvaZc8o7Yz4vz4xTDxI2mCIMvpoXJwfc4g7qgf+qPQHgYgI7xgC6VwdGnWa9\ngArIsERhCkOL8UTnI3EVLOqJNprL4HZ+JpL2Ix9EBhnYvNITL7in2glBbEYLLU21Zh2hwseW9oQR\ncQXFatpMs+Nsk2hSLsmHFYuewyBBoMNzoUTpXwhD+uGPAwehcKI4ORyMhVSEUH1wsnjPZubjr5hH\nhj9XccQeu5SStrcvs+hQkCDGGkdX9ku9JBk0W2UorP6hC66LvjdFC6dlNCDjB0/7qoQLlbCosIAo\ntmS5vzGFBRghBdwhoiBGA4cyq/2wA2lCT0Klol8YGza4mfn0XoUUsxoqq5/zAGbiRrFSgQq/8VcN\nnQ4InSfU8CXDzSisbFiYNRSQQ0HCMpYWkMGK4AQtngM352A3n8o9VoTMVm0RsTRceJK601cOIx+a\nbmLtqapIRrCHgMRR2FkeKPLfhWhQLUlWbt+MBjKz9QNoFuqnzvg4UG5F16RZKgqbJhM8FMw7wyeC\nXsgwAc/ofokVvqdf5MmG1ZKKo1WIKxvZHkeIttt4lNQqcJzFiNTuK6+ssmkX3WxhOA==\n\t]]>\n\t<![CDATA[\n\t3wi1uz9KuyXrb5d6C5N8DaXKzA7V96LI4Ext9pHYgYWyDCt2Av5DlB2YQyBQcgCmxZfCPPkHWTrx\naPgq5W1buyhgzrlCwK4gIPvcGDaxiuTjXSAhEuMgJkWu7Ln20Ug1YZCoXU1XCK3pzaDskwNc/ws0\nJaJgWYwEQ4NBQrCgQVapxbj+03mkcGM3CrPHWlUrC1iQnUHyPkkT4eKKkVClKO879127pH6DXNv8\n51EoZSqAGgd8Fti0t5iYtaLcmP5uBd5cxfG3OFaWhg/cChedQJn/4WCVKBweAWFQVZQhZgHIEsOe\nam9lB21Bqqx3Hv0TpYhVFaMv2zJkMBkJoT0bsG29W3+MDDr+pQkDKAxLyRF/g21sm14rBgHDR/lO\nri+Oq77Z9z18DmQwgX1HniiZhxT1bdMGeDZtwX/4kLIGC6ByPLIYVRt+NiS8qRq8Hk+OVJga+bak\n1rRWopFwGTUSxQkTPKiT1TNKfSCZHJUEjcDxhORaXMOZg+t9RE6Zh456aihBJ6jiU8PZa+hCYzUr\nzJdBIHtsv9UcqAI1T0rkVou2EhOLaJMlexINCobtO5pI+MCgxzuh0dGGweuY/rVRW4/WpuOPGkZF\na7GMZCkAnFmSS2QFJzGl0Vr7WqODBYegq5z5BTNCzUYvaifP1eg+wcZAmAtCjkGzM2xLCJEcBQYo\nfVMOqelRSfFsiSzRgBzC7eoEOQ4hI/RxwSMtvvI3C+CAgXwzu5Te5a5JyySWB4BHZop7MGIrW3mw\nDN54SKv2WgymOAiJuGC9sNWhD4iQZUENOqlcvWrp/WJhMMlRsZRtEk3qWk8wdgnTDXBNTnEpaR/Q\nCKlQgdaMwfJMGlZSxgfGhuoIg4VYAqzGHwfsgTszpc3IRxNoyhhi3KNZB5WpEdDIXmwXPsqNtlyW\nnZd5dWEgY2Csmnpmn87UsnhoZoAO2dWmiJLV9CX1/Uhwo3N4AftRTTnMgU3/IhDWnoXjKU8JFNUj\nlfYX5gGk4NVIpbAFwEaERap/FWnbyUKV0WZ2piPpLzct5LAge+iXFsaPbdKS2Xex1tzYTgx1RMSi\n6Qdu48BcWxFq4ZrdyeXKcAMN7ktF59Acp402QR2MsYxDEAU+tW4WmmtIg11sJ3s+GhByIzKeWCH8\nsn4v3LyMAEmarJFffqaAdys8Ccy3sTJBU07hlwT5qP2w08wGJnjFW0x6c6iU80fro4IS3if0/lnn\n0jszs4I552CnE0cJyqoqLqjxmbSHn7xFwtBo9iXKe+ZXgPB0+8TR4jKVYN0Gemit9MirAQcQbVwb\nVtDU8QBt4eap/UP1YdPkAKa/DSPCbEWw6DakrvJHzggYd8YXQYt1ABjtvTyU9IXQmOJKij2HRy8u\nNk+jV06xwb0zoRhd3JOA5lCNpPzS6jnU8SoLNh5bmJkwxCiZKY2dzfli616CgFT0iw6Hka8xUSMd\n4mCIDnoy/fS9mBhj8H8MiaSibTL1I87Pd3oOivWU4OTFEpPBLkITnCYsa2AIkBgMCb8Yr2oROi3c\nykYaFuRo8AhJweCYFDnBIsvJd3DxZtqNVGNSFg/bHEp8u4YWU7x/igI+gTQ76iUia9TN38fKRiAl\n9aVwqA89sZ9MmJDiG1AfzflAxPp7AhsmEf8L+K+WsqQ6lwL8W831HSV1wD4COlfTgJZz7NB/GOe8\nalO2kaqrPFUTQwuKDYq795db397ADpvX0sojh+p4GJBIIta7JtxalLXH2JXkMik2aGrKcuhHvoOi\nkQhEfo8ChZgX2eS6MouNrLAWnLo4S/DFmlZkHVMf+d5v+IWE/v4mdSwAcUxezFfbaQn2ECjQR+aP\nTXH4jYThtUtSYBLZmN8tJt9HNZd43IcCVM+p+s4/2gcNIYoKc9DJmdQ5kDYrekEqcqTFu5XUJdnR\nWRo6KQ97Hq6FKi4A1PuKJxaYAHy9vQlxmR8vwWx9/fdrcTzo7rKZIsKNuIqm/4tHKq2+jdSpT1Vd\nmSVfal4U27Pc3rj24UJOarpB06/biGYQCqsO7u6oTEmPf1CeXfj2Tah3VHu3lf22OpmUanGKJkII\nLfPbrgLTLUnkL9D7C5aTIhtOj7XYrB5oTCLBuoPxESif6YtglgY4eB3BLAqfpkmWvpxGcYTRJ6Ic\nYIstRCXKqb6RqaA887ohPhUytPwPMMdAZzLZYGBOMSQO419giqGwmfk2aac8dcHEqPOb59l4PYtT\ntfc739hmGqV+GgaIWq3saiZzOtDameOoyX3cl6s++uJCOhnAsgpacSUSkZ7FMPGVtNkshYtjVlUf\n4kDCIqw05vYW264KHnkgvAjJdg8DhLIV4UkA8tAATGxY/GwYtC7kakb8F46dr9lEL9pzkjs0RKjh\nbIvVCw5SLZzCAhaoki5tJ4y6goTf4aaWPFA55A87DgsTGuFIfDaTCdELGaVPmUHtRUVaAyVlrEG4\nl0LSJPjhhPYWphZc9YRAsWThEwKi9MnRRppo8ha3XV5ZQqvoNF98sEmmSM4AhSxgIHPK7/dHqNHF\nUzQDIUAEm40LJy4p6KZmohsJ7YL9Rcti32jOVTASwE96pI6IRlqIWkuEFFEmP3tTmwIzcAc8in7k\n50w0yubKO9lE0/Q15mnCv82QnCYpw9fVzZUHHEErGyrv0OMstTwjgUoiy3EFLe2My4v+TVfnKUiE\nM2Wryp+kzrjWAW3+WjVixVzrE3EXSGGCCbvOas0RoCxamZAOpWAA8ztT4aODYmNGKWbejjGOacUe\nwTrjcGT7rtK/dtXPYINMFDD1nOBUh5vEh+lfqFtIrDClitXtFOHYd3alm78QW6N9NRUrsjqqZcNF\n1mRqPATep45X2wJ09Hk7kO8WtJonX3i9hk3arJBvF8QTFs7DYz1ydgZ3iBAZ4BA6NksB3zabjwJs\nReL231GH4TOcR+KlIghA2g89CtBqphExrPoInZlYMSJTYQ+T/kaWjm5hAXbMu0fW01A5nOGXvVa5\nGEl2QgZmDUD4hgXIN8rAmXQdgoc1ouMNN1jTQYcUM9Cq0RxI6EyI62naM9rxEkCeZdBAeaFF3ODe\n3W+EEBtmMw8WdMzQ5mMn0+2S1C9tRHPtVhXRaRyvpjqXNOuLhs9waE/VgdgNLa+W21daFzgAXW2a\ne3MATAe0yLojJNtyzIyRTSduykoApurp18lQJcPiTbDbX5BwvIgvuujv9OKQprTVAkswtYpInGcw\nRgnSdYApAzGnIwtGl0LVKAvRgDU55xYj/oQRhQsDVvfA15nxemKDzUOuYLevyS5cazJZJBk3w9k8\nZ+dNdj+TBOZnUOtYkC5kBgMUdD3F9Gcwa0NSnQ1AvhVw0RliH89PE2N9aAG9LcUlBIgI+sVg/k9S\nWM1n4aJoG0hkg3GIuZxO4AgoT0Q2mlh+fOwbY9QtG89mu8KmMltLwXplIL0jGAVuVEKRHEAKTAB8\n2C6hLFMVZDZfliEJVVaVmFbZ+lUPZWA9hR3Fti7h4xDpobUhQg6gfpE6jPWBaS7Lh2wU0Nr+BHax\nNpzSSGdt8afFZFLCM5mLhoiV7tShfMIchG4CBIQx0gTsEoObE2M0dhRYzOYKq3OyruwZekG5/off\nIP2SIAscBgVKrg7OsvNIGq8uq2/kDgKOWiPWDZ2PWmibZVqMvs55g8flkl4VcnKTti5enOWPMxoY\nUu6CRVHEZ7h5HxiZCFw0HZU5ajXRF9kNY1dQkJnskCDbR2g4S7zUjTPrUlDKMs0JjCk6RP7MFR/g\n/kPLJQKoNZqjqAoetGyYLi7CJ0ocmmK7K0zWcGJ53IWRQ2R+gCD8eT7/4Ad36gMjq1I5Cpos3bZ8\nEAiJApj7hMAXJc9+ljqDSdSnGs5P3t6C52c7eU4Y1RwdRJlNNTI7UpuBbqP95yhRA+pGB22tvgNI\nbFh4zIAj4QIlWZcpT+rrYNoprUJRBGJ9G/2BgNL2PiDwICjMQXuWcoG4Ot1bD6aNxTgWd+wLMDXF\nSuW3hC/gOvAP4zI7jIvwVQWuFyXjsCtQ8ZqBpRSQDkWwa7ok0sHB8lRsvFZNJHUDSwWG05iMNAvI\nPej0j/Ehwd3PrQ9c21IDvZles2A67YCJ1BK/nFtsWnD9c3JuqJAe4BSws/n7kmYZwThnBrewdEB6\nTixhOrQSqv3Iywqk8zPpwxzcbVGxzkRXqKgFp2F0IDh4DINqkGp4T9WHIwrsDXLVjII0uExDp9g7\nj81XlT7MewPZB1/jKWkPfgTEAHTWa5iIBcGts8peDh5Z04qkV6/ybNb1C4ZiWyGVDvjfhQN2foNK\njBCytmcqfGRH1k9CQ6NxvfNE/wSLR9E2cWo3z8zjsCUo6ymIQ/RX2689MEaCmNp/xQjDAM+RFiHZ\npXPf3AVXQ46oX385RGZgHCKL+5qTQfvNRBASaJASTvBB6GC/Gbtn0LC2TSDTAHnzZq9IaEmnptUs\n0Xm6MAY6D4rWO3Wl6wgl7CgD2rqmg0cwRaQ4B4BcKPd2DQUFgcI/DAzQhYGBBfjKiptIQyQjTWKe\nta8ugVAUBvHqUk1Sbf+3xf8SISmllFLKpNem8SoGIT4wgAiBDzMHPQfPCLNq7ZdeKNe1Wl0961qt\nrtjeqKzJTrO71/uXXphOW2XXvu7E1NJKL1np/JE2XqGmGWkY1G+e92sm5aqpdVqhbp6WkjLG8zPF\nmeqKZPO8f+krq/J966zvfNT0vzJpqf4KVWe9ML2eTfsVCmfzZbVuJ74qlEur8Z1fkeT9Ktt7T+v7\n539mqdwY+8SbzlsvXK8quxm7Kn1699x/bXrlz+6kkm4q6c13Op1ffeqvsJ+6zpd225/uVd/50tL3\n9w81TH4if2mdd9tdZ87z2k3/klTYY6t/6gr7r/qnpn/1Vxi1s76d+KqX/Fphf9WXLzfGd9LfFVap\ntLJWt3X+tFS+pNevO19m63rPp35Jva3Pei+MsZ31kpdeuELVToXtx5fq66nTSS9ppb052ywfzyzt\n3tVOijH288qd32J6p1/53Wud+6W9l9oKk9bSuyf+umemfu/E18+bM90yw5TZm6W9lMrPV76TvhZZ\nncgSWV11OvNbjGfe73nmr/+azkz/qvhOLXO9ZLZec5Zf7+6o/Z/1+vyzyr3f3omptDvjSaXNV9XJ\nnKV1a//+6/n/uN496f9VoWZ9mT8lQgq1LaTv/D3fyrr3rF9h1efnueW+5FeZnrtOfMl7q8X10tMv\nrKfTiausTlyh9NyVqcoqDE8qt/6MJ72uXKdju99Ol7ja+bLaqyL9rD/rJfWlW0+r/TqdmdoMV53x\n3NLe1z5rFW0dKeRIFWnaPG9FuvBb0tvfW9574amztBjfO20oBKr6b9XJt5beunWm152YXlV21c+Y\n/mcoeWfO8mOdb5ZlmlmvuOpqIx1BzTAr9XNcetKKdF0VdmW859fL4pynxvDVuTp9S6eln2GaH8+L\nkviS9KnHhX9tNVlqO0m/VpmsUJJe8k5N67/fz7Zr5n5ab61Orytz13fSevUlKd0Vkw==\n\t]]>\n\t<![CDATA[\n\tl+JasaQ637kpaterCpF+yf9L6l1lFSaz9jx1rTLp2Z1Y3ul5us1T1+uilVYZ6noVIt0+BTPA73Pf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\n\t]]>\n\t<![CDATA[\n\tTDCBt5G8lEn0PG2KYSlETTz03i/xkBoPaBs9bqJIpwNQpG+iSBsqZBP/fkQGGzubj0Q6UOdADeN8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\n\t]]>\n\t<![CDATA[\n\taD05AzULheNyCeW750mIbVQXJrKy/UuUOkKbFqF+/+k9vLt76mhS5pZw0U2ngRhtNQGOd/GZDUiB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\n\t]]>\n\t<![CDATA[\n\t9+ka3Xg/cDKWgspga/Pn923YxYEauSQqw5MovwdHy4vj1YAPmMx1EQyTaK0OZJM4MtP3CLaojjLw\nTErX4vxkAt7PGPQXcLhap6H3eyQv7++JUZ4IjIQEHx/jl5+g84Opi4P2qBZe67zleFQFB8Zr8eJM\nk3CpJSCP1gb3IjXuaIs/JfYeX8HETmStu4a7+F5WP0NCRmO8eG1kLv7kGBGNGvkujPPYgyRwx8HE\n1kzQP1KuaowWtqyVhEM0vGwdo8bkHgPFHkPv3fHaRRxoZ7BBjAHW1+2vV4wYukFBVzmoWwnD0qUf\nx2bhXL1TnKiwn0xrejNvhLcXP+Hqq2D+jGcZhze0NxPYmbOQw8EdHk37sNmFCUPHzyFNOewdX5MY\nR8PR7M1gSHv1JbbiBDLBZj8dZKpfaTAi7yhAjpyMVHofzUaPNRDv3V9FwIGGZ/gvdrNnwntMBhgB\nRkKWiG29HXuAUnJl2UVeaNcHQeNSH+s5vYPDGgE3On0PbianTPXKXoYVs8A9vozJuGn3iRPwJYB4\nLUyPEV928iICFl+YuOBkk9jHS3jxXjLfL+4WBScO3p3pKzxaVPhGxM+DsVLSIqSPGHtl6+ylnCH/\nZ7gix0JtuGm5wIsPKOuhRv3VVLjNr4HFfKeCNRx2qoadVkb7yTIVJri2dE8XK96Xcua8QZFxWLaY\nnQkpAlPAFs4tNCcYdOkiSfsyIRJpVRvHep0GxfNBoecSHasrEZv5g1YVOFuh/ZSFVrctgk0Tj2ZO\nq045wl+9u9TXlYriB90zj0+vsiLcAnEascUHa6cFrnQLitSKQZKVGww50wbzhan1gXkNaRY5TxMU\neB6mvNnzB1/8WEa9MNi+LvXzMZhqWy6S62xHBBydpdHtwWdeiwlJnYCrcpkj877CfImR2Fgxy4cz\naVyODLs7CFrq8q/j4RAKIgOtjYR09KAvl7/KxEJcXYjqAorU23a61FCSSxXUK4ChD1rRijuLJjdu\ntUfFg6bvKrBAXxNAXdFZa612F6nU8J0Q1UxMyujxKGS3p8GZ4UaVpaTYC/NuO6W9+VFZGx9UmMXs\nNTLOuWUYXbylwgmioEijNziLcpqzPhZ/ZuGCxdnf1coZeZO58D87wCgpezIpXOolUJ4PQXipLiYr\nYBd0g4Y2pS2elG5LXnmKlpkX/akrduWAv3Yy4A/oVBQCVZc7s6r09DKRkD8IKu5KIsqHbFw7veoC\nXtNYxc+CuIuqlZDiX+X0d+7nsVFgANUVEMuf3waontcW5QWK4N7euA3zDtwIo6YiKdGEqmZAihCv\nZIUTqRqMG2sPyO0/SsnBdp+pnaP6vyQOhGUntY81LTgjfTAW+8aw0yQUceRve0FXFQ9dAWUJgGTe\nA28XIUOae9fJRFMRInRJaRIFm5HmsIYS0wHqY6gJARigIwBPCKqSWx0RwY0gooqvqxus9MzT+kPz\nmHBfkF5kQ+R1BbuSUSNcI3D9WmQJI1EYsN8aR+fGZgDKtcsdizC+y12keKtIu/pSuxC7UgxYsuq9\nf0b2+ZZq48A22VojpBXyMxPQhNm+mADXRlZwh1wAf1gAPRWjqlnlzDbVpoAuiuR5YpBZsW+w+REi\nDFCBi3AvWqLBB9fkLTSqTSv5wHFLd3/uC+F7HdJuzNChBDGeXaS6HtNtSiD68ugH0Dzxv/MRFYrA\nGAGs0TPlLUAsV+AadQdXtEhOgbORA2p59bMY4GWuTB43eVTx4giceZ+ShQTj3i8Xzy/lrQGS/CIH\nwVV6n6fICr+VJQvU78wV+IekuuER6G2AHDH68AHN/cc2jE3ywupXeDS3Y0FDuN3ogTswyNK53owc\nL1YPdN3EYz/tp0UKaNEx3AiyuVpamjd/ak8kz8ERwUTJmF898k67ZxNN/YzEJYeAZjPbceyqoI6Z\njhS0nssn6hSVsqQxFhyX0KvF9q/8RDY2wRYC96S+CyWn0vwSC4nKN2kqGpxMiIc4mBuLMzsH0/34\ntpP46FVX6a6feO2fadzV4bo0ZH3pq9fPPA6vybLcqxx7Q4p5Xk0MkqN16jMHQNJIqGgIaEBhC+Qw\nZuqGKbVPwGD5bpzeLDFQ1DoJ5efUQ05DQ80Dlk8A3uZH4sgq7stauUQ0kyREuMHXmU5LQsdK9sW5\nsL3l9syZ/n/UAOkoCTDExlwqS73sW+e4PUnnOUFrQYnEQpTqTvqrPoS7lvNJxpjUd8Tqg2GeCSkj\nY0fAGXfNyc7TAkRMpApbMJiXaqqi8nqQXsaQjTQ0C3WLzE0Rsw+6o8KTaSxc2XfqeabpbcG2tqp4\nCbnovxBCF4cnY53Ogq+VoQthlsnANmyHKrr1OLhjBT4R+24FYgbILfSqKkvDYPvUTZJVrPS/hPhQ\nLN6tulRCqppCgL5j2qUHcGnbeVg/1BfTuO4hQ56YT9EtgXgpL8bw/5CAZjlaJq058QXigCiS9joG\nTShk9oaPItNMTRgoRwnRkkaG1WXFZy6k4Gk1ItbB4qnhXneQGNtU+Zxi1Zjo5b1tI7qaef2LOabi\nn6T+IRS9J5UV9f3KopQlPLYY3dYFP4XcQh72l7faOrvU3yE7PjdANeZI3wZNAvWWV28ocs0vt5VQ\nTN4qgmkwpJjPEpSbhJ1wJ1KAqPJiKqZ8pS5NmAXypm0t4oTJl+mNvJ7qZDwoaDWBP1OcoYrDTJos\nqyg0u3XMYeX7eUzdAynjRpVZwTxY6HqA1mZ+pQxvjBp/uQpml9tYECOOq8VBPid9xTc90E7t576Y\nCp0U7XpBLdsD7S6vSSqUHnl8wVXawRdie68HJa1tulG5HQaITuJxP9syg4MfaQmgf6rx0XFA57cL\nrU6ZfRovx56ZYfDC/uYTzHzs3w+TBmwPEd5riOeLDk+hsHKbygoIQ+KBaObNmiSLVE7/3qHAT7xU\n6hKCb61iOoR/9nMF557vd8hv7aR9w3TIgwsuw7MUM/9Y0eEfhVWg/iSCQ6ZYiTPGhH0QeQl3sAO+\nbFl8g4aahmUy779w+j5QffssT+QY74o1E8hTctfNX1/QrR4GScUVXSQ5brX08gXi1ehXlOsyqGqe\nwogdGdpFIiqZz/ZNRpMNCeEWNWcXUTvIOqUd35Y62XOT5dgnEm93xvMIwE52Q6ZuYB2iQJgjF24o\nsf7IguN/tGlTUOrXUWO7v1yRpWxDyaKAwX6OYAigdeC/vqTblDYodUILKtEGnm8EwpC6JnF8aR1N\nHotULoVtsz92LuNBByt5Fgs4tdPfwx1sVTKqJDYYPSyRjEsSZPRz3YG6ZT6AwbOQT2CcvjBSESiw\np4qLYYHCzGj4fsPBdWDZr0lnGTtQAtGa7OKiYIT+IQBYT5UU2XC0+6RWByt2QRkYrDYZZEI51tEV\ngNuTWX3hX2soguueXyE+iG/t+3tzv8fdBGVvl4xXt3Az9ENdBcFTYoSVjmhU1KBqliX7ULj2lhWa\nbRk3mnQoZa83QVOaV7XQ+OjPIPv77Mv0AeigcnceqAS4KG/A7JWZjU/fjxDDBcDUVAAWwkP5RFoD\nzmmKTqB6dmgZ5SjI2MXKhY10rEJRyMHWgOb8x1OcIT0hQBYUb1hhKAt1TdnIMQJuCEHiIwJ2sZPR\ngGASNltzjYI+qU7aPxMw9zAPir/m9GJgY0LrWYBLb19ZvlLlqQJLMw1COsdfQvOXc+m1Qgk9WFD+\n0gyDrZnbyvdwYClYlFTm8NlGH0hsf3MJWwz25JuXLZJ08gdcy0aDUnABR+A/6jJCCyV0bIt/rYXf\noD3Fb0KTKxo4EIzie4ieHdgGjQQAzQbB1HSTxhgLxRBTFhT0ENaH/nKFZnQKcdqE1CaZrpTl3OxI\nGKmbMWmB7xd1LDIAypzdHUq/JGAmTe+UtJxMutQRbbrx7ueeyu7erGPZJGtsYPJGngX8PQhKrveR\n96AzN9RCgaf/RfQcOGwzgJnwy+C3vZB0QfnuTAO9ASbtS2DwRLIR/6DfnCzyeFyuJAHwAW3kQAH8\nm1FbwCnYX/EA5E5MgslTaK1Y5vXyQi3BcCk4ZbprcUH5e6wi9sE/aJS6FhcHjJLvcUaKrTGlcVP2\nNVp+Tc0p3v7dr1Zva+kf1ni34tiNcXMsy/uMryujPg1GTOO6UDUtjQdPCezGH8YNCCB02/6gfsJn\nWl5wSB+u4ucM/kKjMLPpM7pfssHlg6YEiwbV69P1qovDqdIH/UscrkyORloQm04ZWuRN9FiPdskS\nejIeLDtm257F+IJFtC9wlrJUba+R9c9uVtlPbAa37NkcF9huEtWbv/FCgj14npgdm4oqhNjKLr0X\nDCWUum6cm0LKzNsjl3FLzZ8CglAlOjAzD2nMNroNiHIwKhQ5hszCrrVXBW8L8XL/LkGrKlNE1fZv\nyJ3pUA6o3TkyMJHn7g+5UB0yyZxXs9A+e6JD4ANDCBSUh4ktKg1qTA0rKtF0TgQmApNWYn4n64FD\njBV00j6yg3BAaZSyJFmtZmXPin+ZkNjX2zffejuY5CrIXRJBdObwAqvyuIR7T36Se7s54mpS0dab\nftFyhNbmUMTpcDp7OIXhROtXDq+/yo+BcZT8hBFsdGnw1aJ1o6n+xrk3VvNtFpKgYNDoJaN1ctP+\nK685WEC0iMFYKkc6z9oXfwSimdIlmSTNwIqc9SZgJmwYmjQAk8vGhL9kW4XxnvKfJyDK/4gs9gHh\n2ERM2aNnB/9T5w3ghWbtp6iwbqBaZ6TgWOAebGiYGb0UiJDLJg8cKEi/wcOHGeBaqhgn0+cA+N+o\nQv6IjmisCMIFxlR0E8bLcoARab0gsfBAgCVdOSUof13HwFbIMoQZgO+ntyj2JGTjIQwht/tL60h0\n/kRUN4S3lRI1hrwVnVc1I+zV6Z1fsH/Pt+oNKlk6WKtiUksWvx/NASQv3i5aQEp1UbWK6KZorALg\nNIZ1+pdVMi4oTA+1xPnXMjKXCFbifLO/TcNMMwJpIfqLfnPyl4ElSTfvSyca6nUYJTMOCuWPW3br\nS7RWKx7yD62T9UHbWR3oe8M6a9GRv6uPeIYtULGDwMkGHhJIQM5HIg2MV0p2extHHfw+oYJaXi4I\ngBDDLF0f3IofPstS3HnlXh+dnP+z/FfMMurzXWJ1YNCOeP6HNJ9za/VeTE89duxvEYbz4J0gyF8a\nbCr1ZZRCoP1LkEAu3UF9yJ2kU+EV8otB1T3nK8zI+sEdTSy0gc6tsOHOCcE0Aj0QnRBRTG/KNTGF\nYT7lE2eewEMjFLsIw1OluKHoX7fxeESgpDtLWT+7PZFC5GOs+PifmlVhLBoJJMqnOyRqywqmMsl9\nitNCDkTonYofKJzrZGvwmoj5z+A5y+qcC4ZD151+/yT09irt6gxq7rsjQIYupomA/7vCLcO+j0J5\nBD607/IwCPdOKRL8Qd+NzcI9dA3KBxfNYK2PiCIYApqOqAXQ8Bzi9A8v5dApM4XQ0tYjHPX6KVnh\niL+ilpus2uKKub1Nj8tOn3QsLDAg04rouWqeyjphXQLeE6yIJtSdZn04HvrTCbQK4A==\n\t]]>\n\t<![CDATA[\n\tCtpW2MEHZ14VfIhqdClhRaSmaYa+Uq2eobeKFoy+EGWGDYJQ0jBSOMlU084YGwQAID44mbhXnrp/\nsU3zb/8ftRXlFgrAQxkcX06g7UHMty1WjYDZ9M0az94t2N4ah2WsHNQhHg+/1uADB7A9kV5ddp45\n3Y/FKFkNY97n/H0f29n4JRrj/3dwItwP90AigbwH6dp0nOOKXmbABSC5cUfkLD111WnboAcPXk7h\nAgZRF6hKYPCiOwydZP0EmZ+ujHqNjdxHbqa1VSHPtwT3a6EEdtwE7XHuawOkQDe7kAlOgvhrcVhu\nhPdIutdUb1zrQusiucTcS82CBB8vRywDmNOev27m07oLok1XhmDZ834ZE5nYJ/P/piH70D8iY9Zj\n3bZ8C1+WKT5+28IXJ/h2k5j7QDTloVklRYhV7cdZg0v5owH+B6FQ4F2UdCG9p3OrcZyKUvg2n6R3\n/K8i/TLxq2L6c9u5kkF30WaAQNHdpLpyY2Sjr1OouBFOWdm2ZdRouWqLaWQkb+9jHWoVLBT21UF0\nTQcqcTnbY1KMhiCoIWGSmOcSxtRQQGyJr1pPUjVRZ8MAvsHAhN7bdOdTgIUgftv2ZHr+qh21jyVG\nPL0ql4O/L4/CAOHHVDj0/RVm8QbfqHeicZI7ZORfcV58TDkQAYvoGE7AwzcuBBRtyCJMSq1k+vxS\nJnuj0svYhZMXZUDWCR1ddyS4VXTVm/YKvfxUEnyccQKd7E942TbSpgBTK/hlFV+8TPGFqBShbuCT\nqn8TXrUue9Cbg0oKxAHipsQ2u73SKZpVevZZVT3CrEFudHCT5o1/anEkrFw4HexTxZ8KAGf+Uh8W\nrhKWE3WYJFVEmqcUxEoJmWhfuryzrXouzd642T91tQgmoZJW3EDoqFdlfvI66IOuL7e5fv2uXjPI\n09QG3AqdcvsGWRT/QM4zr3UjJ82Rr0nsuoY+fF0RrCb3tC83sGgR1SqFG33GHNzC5Fx8JijAeUE7\nsV/O4RYwHoFNaAkD6uZlL3hrUnnFG0eIlH+5w07TqDqUe2aKbxWbpamrycimDa1NsZ90nOoZ7IEG\nEOH8hmMVqvL1KndDNxH7mACQjmWUj6QxhEO+9YbLw5OiBYNhE8xO3WPZG0LPoJowAFTgG/OT3vZ6\nCLsH0r51tFzfhFSc5T3pfuWXTjdL5NvTMX1Kz0K0+EsReUboaZPfseJmgCFgo2IPj+r+Bi/qpc0S\nRC1fbDDpTRzIR0+hsU/KzLJ8ZlELKRu26ZOMR7H7J19Pme7JOSrbUJWeSAHRg9pUI9VxGqdB+sKS\niodBhlNKQXG05O9nQaCV+N01P7jopAOCGjj9nS5S8PUoPaPDUIQ+omwSMOcppFGgFBDYY7YjIn0P\nL5OHgAHHSQFWdJZX1t6HxSWZiU6eRCFmsc5nU7xhMZvuIdWrnoxLTcWVunTF/g8kE0lzDU/2rjXr\newRs+xq7MC1E/GVXEx878GnqpbK/pvZrkOqhbeuzltsvg2N9vC7SvFYmwnYdIy7YKdWtVGEKGawT\nBDUFfXi6GjXBY3VB+CKXUtSyrdiuvV0fx6uxZ1N7WG1MWH2Co9ZkunSLs4s8QaUC9wGUvoDn2sFq\nCOuBISc0ZB/E+VPiaAqZLWJNBML2OIcLfDVYGge/vFZGfzGmuGFGNhC7gyh83EUmkQP1fQ+RLBGb\n7uFpCkCk8NIBn5jVTSq3ymXdLTgqbHpOQWKBoZI4ye4Kt+2OjHaVHuww1Eglo/XolYh7xtq6wbo3\n6oys4GbVdycxf1GRhwIwNYR/ztrwmmkhqcEoqC59k+kqrh604endSoGVoBjbCkHH6lDqxRVjSPcF\nKZ8h0FkrJwWN4EeTodplbRHW3FyZJhanZMzyMHe0qqvzwRF5L0xnK+gEQOmXC+vi93s0IlC0p3jE\n1M/RlFAQQi+IL7RRxMwpMR/oYF2S0MmU0inF9eHVZSILLYvs7a1MMEMnaxnsZc/tz26QVQYqIRbY\n/GgRNvexTSNFdgs3HAdhIU14NkEqJZrKrRrUtK7FE28yXHQKpfdrnZFPDq2g3+agesT0PhBl77Uk\nsKhIRf1ONeTA7hTBvxEV/FzGRDFN79z8v+LXKv4UcysCwlqs1TSy/B8lTdepubh8yKrSUeKeHhav\nn2jdUl6udWuiKq/RvX84Eq/80C3QowtKk3FDaEat4FNQe0VFEGemM5MT55hfAwU5RbzqZNH7n/r4\nj8Rc2HR4XauMYv0FoJNqUHo7jVB+uu5P/N7eKGn/p0oyrGQTx9lQe/GqEzw4FRFTHUJFLz6wP8MU\n0ztYIendIbP/RqDe9G0W+XZ98iFsDherfN6uDj+MYAs3FPPyfpJ/MZ8G2F09n5ZeCBvfS56j/e9J\nUG74lj4wbwmIKalpbQFG/sLlEHnoPU//7sNtMo0xIqiQDWJBpCqS70eKi6RzyaKsFPouVEX/qQd2\n7AS4udo5ZwfUlPfWlfVtENgmJujVu1y1i5dW1Y0+NbxfcWBfIrDTAIBQWzdJvw/iPNdcT9DW2laF\nSFVJPCJlfUeo5ItfNoG2Rwwbg2N5CFygZp41CSinIDepyDWqSJy3nMxg04UEE2cE4jutvrL8vJuR\nokeJJ5iJMB3NV6bhacCH8c/SNP78EC5u+XmuPqDLRXk3rpkn55YkWkWozZNXBDyRb1UKwjFkyw7G\nMJCcBtk1VZsZJZztClNi30Lgxr5xbpxZP4oNK9HQeQ8W0kMqnQDwqMVRme4wWIK2zqLyiKC9sxXx\nroRyChxPEWiVeWgt5Jx5ojAXV+AxR7FQvwhdCmq9cJ9UEwwoCi4oGdARkZYxkWbAX4mQonAbFqvS\nvAc+mihg1I1TsI0nHrFO8LsVI5gb1OivIaGFhVHUvrcXkEWaoXaLdDFhYZCilO17vMlpAJkde6RE\nTOl3x4oKxP7MCAQjuDwf5AmZ1vhIYsysMdFR9wH/F9kvNRCCEhcOmzd+NxJxxk4LFkuK3fZbO8Fs\ng/8yDbs8nKBujwyeHluNCXHv2yk8onvPdKyFfDv8Au7UI/b/TvrJHHk1JsWsiI+5z4OBnWV79eSW\n3LfpDPwTfRItyWA8jv3OxoDkUya5CKTKGIwaEE9YxGYa7/J6hr1Aw5kKio08ikv5vFZ5R63c1lGu\nAazK7BO/1ShdZdA7oW03ViHBn0HhQ9IBx56RKtm/4uoqgk+vb8A9rYMGOPyntHDjAkCeCXjJkgud\nATdwYpJnJ37w/sMgTsWdBzsQeJv9ir3XR5XYb7/mrYjvyRqiJvyuKo6XZM5xx+UbFtkxF7ZYm82t\nwcRKdV2cMbn3ZhlAF/hd2t4cSS9wxOVB4d2CAU5ElZWY94IRD+0Bwvo+raVtyaWh4ioDBGqDGFgd\nEhUEPB2BIPQ6vv4OpdYh3shn70E5rncySPL6L1OBF695c4zdAFm9KppZQfUIBY7pL2xFTkPUp0YR\nwRIooNaKiDZDB8YrxMDJCCkptdtc0JvBKP8KQILl+B3OsamMQAaF3wDi8+/YHqrwuTZug9/og+nB\no7rog2f8USje5VxZk0RW0T3l/KDBpU9Ne1pExtbMZXpEmMGXa/aZyzWDZQdk2TqGYeODE0kzNkBu\n/jSXhi+JTTHnk6Hl/IpMlF/jKluaJ5qdg2DjdsjjkGwwF8mgrN3mZVGzg1BkZeOuy7y0OTtUDTZr\nOv6iPbzL+Nh7DADq5RUN07igIovAoe0fgcvurSYlx52vYCxiEYH7A2ncqgFkhp0OzmjAfb8/8R88\nGTewyYAu01xsbY7PBiYUoLMpOB/6vdCT7X3yy739yhLfPuF0YiW0cWAnmahSKm9HE3b123kiYsX+\n2vE/cRBWQ6KebR1U12A0RpUElNZjCO+8I0Y8A9fOlue9jymrvAOrG/96nHWbhsIoLEZxX7OQ9NCi\nkLYJQuOvEXXAqOvP6dJ0XbHvCUIQGpd7LtgLVgawjRZC1urAxPTvw/XcOHEPRPdacceGarwVqwBR\nI0yBDOy0E15Dovpu6yAIO189ur4v5ZeiwoIWZ5DUcItbyF20AyWkHnRkoMYmLwHqmFg2xk9BUg0/\nRKHoiR2sInhf94py3ytK8lAavSGdrIMsSKztfd9MTnZZWYu9fri1ahjd+hw25croo9uyxeRoKaI2\nT35eldDF7jDSiluXeetwv8VxQQUh2PII46o8MXKC281rt+taSnfIRUfdQIO12FcxKw3CzyzXnvMv\nTcmm4bWulIYawLYNf1DOE8ISmnDEFQJHVt0snNXM22ncejoTEyQDdJxtETR6HEltCHzmOaJGk/Cy\nQWmE5M5kvAuXsLgiN3gcSg4yxqXuNTfdm2sTdTTgKyIBlqQm73UsJ6K84fXpo8Sd5NH9owlfcvbw\nZk5qK8HNTCVywBZ3bLTSEN7rmWdA1qwQSW1q4qkp6KWSmXW1dp+a5BCN3Ew6smOoHf0cn4ZtMikP\nQ7M4MqVwyNqteWKDlUVDk5YQKyxF6UGrVJdnKQ+uQQZKW6LqwnUUM3ETA261l+yg52y9j8bzhOoy\n6DcW9czk269Jk4dd3w1TohWLu8Q/HJT69tIoVY3SQ5g3BLBjW+8SI107sIQD5haXOH9S4vAVfEy8\nx9jzTHqyWXDADZOYXwhNT/15NUGQAsevRF29OPy0C2w9C7g6aAiA8XbtFbCgvIDa/IoIK2cU8nVR\nQyScqCvcu4oM4kH87SprP6Q1ncKKHdwQGLMsu6L784OS4r5FdaGyjI8+1TmWcOio6XPF8Ctm0a72\n04WqBlhopA9KfJORNPFdh3sQaVI47AhryjXZueG+YeWhyBOySFaAw0GZFhYr28HAAtkGD0FwnyiG\nKo+ODvdwKa8Cb6Ddb3JOiQS1qkB8jgsRRAkxzDsCwIkyEgjYDHeCOYA1qJJC+Cs//qG0jKk+V/CA\nj19qYRP2z8mX2zVglP3loVdgsf3CsMSeBs8hSS0hevBiFYcIemNkpfLP6a1KmyuGnpjgtpKksZfL\nlnT/bzsD29su2F3j0X3EkqFwYirO5/aExNjkvvIjekJmfB/gdiMjKcd0rWIKpK5C9AsHOJ391v+o\nHFz1DA+WTEme9GJFIZjDBrwXwW0LME4Eb+3QMuQjLPVUthWIFvbc9vb5XUeN468goZvGvnZIuWLY\nQjqRzrPwi94GrmjekIxIkjsNHKPQMYWjfiGsWbMEYLugbIQWT7m0U0LaHevssakOMzqTiEg5lWov\n8xJn189E88EV4TwrnDJICqkoKlurtyMarpqez2xh5cyt+eqsLj931UO+VSpwG6EerOF1Y+ABZ4LA\nvfStcu5HpP6yOU2dEEQEzgl69+7IyG315j7MhPPzWXKaxg8bQlyQzrFjS+DDSl+t5289uB2k5f82\nnrAjYeHTVGTzsMAUwkNP7RpDhIKq1Lar+3F3XAkh0lffqBi4mGgbF1Jtc6a/XtYh33vmLUtfz6HN\nQNGHKkZMbo/IUfEe93Pu7J7T7oIVXCWxzQdYWcxyPZzn2vdt4xkjBjTB4LNhcEexjg==\n\t]]>\n\t<![CDATA[\n\t41mhPvyFCx7SoGnvqDltoEhgkIgg2giAxWiE0PcbHcfS4VbPPJo9nxYxMfkKM3XZLOWuXpivfZom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\n\t]]>\n\t<![CDATA[\n\tOI9ELbzRpeftmPxxMfkZXgD/LvBzLbV3glIvZjCvyuE6Polt8e58WYKp+ofvoEN9jv4mZA0JOwoX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\n\t]]>\n\t<![CDATA[\n\tiWuUoN3e8My5W8M9/I0+V7G7JUnmbAgmOH7TZBS9NjIqvaNGkVETUUQ1y/1b3EGYkl6yykuQIjYK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\n\t]]>\n\t<![CDATA[\n\tl7lRCvMV3vUhzbV14r9f7XqNCWRbrbUJDHtb9yWan5th2GVQapLvf/dhf9zWtPsSn11B26fNxCBd\nUDpHvzfxqbhnjV5AOXLrLteEeeJgvLx3if04MTknRYGAJ7jej3EmVCIov87Cq6Y8EOgpcUGp/Ri4\nUPi2X2KTK/APU0D82vs0EqihYd0diBTCmtTuzk8808BI2pLqxO1q1Y8/SNdFRz6DoHLmZXvZvJMT\nknIZHqWknP7nZ1UEx/pjJboQ+vzZ720sK5mVD8HxJT0rScO8oCyPaP4eWxaiJd3l3LMRQcRcQYvi\n7AVVtaMupFHNb+Lff/XvAIZXOuRJmpvSN2GSGGdFw0YpsvN62PmC4PaHL1kHCaTlpwWY+t4ylmGK\nam7SevGY/dYU8S8b6tC/J1VilDccSvybDP1LQk0KxIP013eAf3diVU8L25wT/4ar/uVs4Aq0Gpjz\nCeuzSRJYWfrXKxY7Pz9Mx797d1LUfQBt37PU9IKENmilTiJFJSHuMkTEv5tJ/5om53WjKiZZYRbz\nuti+/nXIMqT+aLieiOf6Hy5o6F5oniPGQntQvFm9iGOyvPMd/2a9BO/6d7qLwseULfDvIqL6efkS\nhRzFv6H78jrq38UrdThBL0xvgJX3OW2wQsugB/61xSV4Q6+4pn/h9Te5dAnnk0FY/4ZC4dcq/LtL\nUh1duOjWPvK/ho5/yZIFSVRi6DZGNFdmUHFTZhIaFpNxW44NGDzSU/INqCaWWlgfQ9pMcU9F+zig\n1XeRp/b3R9iCGnt6PCgFeTzd+4VwVQIDkBFJvt0ptwKnn6aUGFqJp6qgS9h2nO7LL74aRUNXxJih\nFAVeXskdhnCDpwBKi/bi9IZKGsx4yqyJBdVZmNsrgIADa+YnBZYUdCuC0+EuH5CZegP/0kwODOiT\nfaZiiMUM0uL4OKak5qHGLKfNuWauDlzBJZBf85fYq0x77UGssAefYAQ+W/CT1GKVpdu3U3dYe8CO\nWfYsnes8Iatr9OoQASjuC68RZ/n+Jt9X3otFe7S9WNh1BwPjdMoIh95V/AnEU3KUxCdfSK2zwAVm\n0rOU6pqGmg/zG8LAZ6turj/XqRukh95cwsn/V2ei0JkmLm0YD4zRKm72Gl81kN+jsMdUHDFnEDUm\nYZEOEDGOT4672DT5PXtp8LWi5qAS+l5LQotwv8hr7DZFlKrsGETZOPwEjmQtEK58EtkzJfJSbOp6\nE+VX1rb+HDALVVo2F2sDjWjt7NUBg+aqoyTLj7UI+EfF5dBlhXrLUdc48RCeYm5v2gqoNwM4xFsP\neUz1LKgX+/MYLPXGjwwdKq41JwDqpRmyHNwTVjWfoN6F/dwuG3eq0mink3oHr6SdIa9s+3qOWXPU\nTifOGMkWCai39gsZEMG4aUmxck1I2l6w8eboQ7qeIthwe4riwGvwOjtTGB+q3LZvADaMx5QM90ek\nuSJ5id3qI0T9tSflSK1d1k8+IZH/Wl5G7eW/j0KfdJZ0+bJ+Rt7y8vmKUQfmUo/FnQmjOmAnocpX\n8lQsE5yLiHaELfjrX6OBBRFjGQDbazsDFo3hiHut3oMwrjHTLX8AU/Nlf18PlEJ8PuHOirUsmtSd\nLKHcRTGeOK+jyC37KBBChGKnE1p8mU+5K8aRu8Ui2woUIO59xqM4rImBLiE+DsUjb2F5U2KrYDR3\nvJoc0TejTpS3iLJj0ST4shfrCh0LokyQyk9wkMcyMXFTf8pZwQGNNCA/qHJwkTmjOX/Z4C68M4qi\niiTrzTEtgj0wOLfDvNnONk1E95BaHBKP61eQJlD9wlvZFQaeg4Bz7wOv1D2EoLmS239CnuUgbhPv\n1fsvnXBMERk=\n\t]]>\n</i:aipgf>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><switch><g><path d=\"M16 27c-3.6 0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5 3 6.1 4.7 10 4.7V27zM31 23v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V15h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H17v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V29h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H31zM24 25c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 25 24 25zM20 10h5.2C21.9 4.9 15.1 3.5 10 6.8c-3.1 2-5 5.5-5 9.2H3C3 8.8 8.8 3 16 3c3.9 0 7.5 1.7 10 4.7V4h2v8h-8V10z\"/></g></switch></svg>",
            "info": {},
            "path": "32/workflow-automation.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WorkflowAutomation32",
          "filepath": "workflow-automation/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 27c-3.6 0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5 3 6.1 4.7 10 4.7V27zM31 23v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V15h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H17v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V29h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H31zM24 25c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 25 24 25zM20 10h5.2C21.9 4.9 15.1 3.5 10 6.8c-3.1 2-5 5.5-5 9.2H3C3 8.8 8.8 3 16 3c3.9 0 7.5 1.7 10 4.7V4h2v8h-8V10z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "workflow-automation",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WorkflowAutomation24",
          "filepath": "workflow-automation/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 27c-3.6 0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5 3 6.1 4.7 10 4.7V27zM31 23v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V15h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H17v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V29h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H31zM24 25c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 25 24 25zM20 10h5.2C21.9 4.9 15.1 3.5 10 6.8c-3.1 2-5 5.5-5 9.2H3C3 8.8 8.8 3 16 3c3.9 0 7.5 1.7 10 4.7V4h2v8h-8V10z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "workflow-automation",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WorkflowAutomation20",
          "filepath": "workflow-automation/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 27c-3.6 0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5 3 6.1 4.7 10 4.7V27zM31 23v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V15h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H17v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V29h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H31zM24 25c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 25 24 25zM20 10h5.2C21.9 4.9 15.1 3.5 10 6.8c-3.1 2-5 5.5-5 9.2H3C3 8.8 8.8 3 16 3c3.9 0 7.5 1.7 10 4.7V4h2v8h-8V10z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "workflow-automation",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WorkflowAutomation16",
          "filepath": "workflow-automation/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "switch",
                "attrs": {},
                "content": [
                  {
                    "elem": "g",
                    "attrs": {},
                    "content": [
                      {
                        "elem": "path",
                        "attrs": {
                          "d": "M16 27c-3.6 0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5 3 6.1 4.7 10 4.7V27zM31 23v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V15h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H17v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V29h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H31zM24 25c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 25 24 25zM20 10h5.2C21.9 4.9 15.1 3.5 10 6.8c-3.1 2-5 5.5-5 9.2H3C3 8.8 8.8 3 16 3c3.9 0 7.5 1.7 10 4.7V4h2v8h-8V10z"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "name": "workflow-automation",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "WorkflowAutomation",
        "global": "WorkflowAutomation",
        "filepath": "WorkflowAutomation.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "switch",
                  "attributes": {},
                  "children": [
                    {
                      "type": "element",
                      "tagName": "g",
                      "attributes": {},
                      "children": [
                        {
                          "type": "element",
                          "tagName": "path",
                          "attributes": {
                            "d": "M16 27c-3.6 0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5 3 6.1 4.7 10 4.7V27zM31 23v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V15h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H17v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V29h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H31zM24 25c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 25 24 25zM20 10h5.2C21.9 4.9 15.1 3.5 10 6.8c-3.1 2-5 5.5-5 9.2H3C3 8.8 8.8 3 16 3c3.9 0 7.5 1.7 10 4.7V4h2v8h-8V10z"
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "workspace",
      "friendlyName": "Workspace",
      "aliases": [
        "tiles",
        "dashboard",
        "apps"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/workspace.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>workspace</title><path d=\"M16,17v8H6V17H16m0-2H6a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V17a2,2,0,0,0-2-2Z\"/><path d=\"M27,6v5H17V6H27m0-2H17a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><path d=\"M27,17v5H22V17h5m0-2H22a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V17a2,2,0,0,0-2-2Z\"/><path d=\"M11,6v5H6V6h5m0-2H6A2,2,0,0,0,4,6v5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/><g id=\"_Rectangle_\" data-name=\"&lt;Rectangle&gt;\"><rect class=\"cls-1\" width=\"32\" height=\"32\"/></g></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 17v8H6V17H16m0-2H6a2 2 0 00-2 2v8a2 2 0 002 2H16a2 2 0 002-2V17a2 2 0 00-2-2zM27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM27 17v5H22V17h5m0-2H22a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V17a2 2 0 00-2-2zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/workspace.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Workspace32",
          "filepath": "workspace/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17v8H6V17H16m0-2H6a2 2 0 00-2 2v8a2 2 0 002 2H16a2 2 0 002-2V17a2 2 0 00-2-2zM27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM27 17v5H22V17h5m0-2H22a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V17a2 2 0 00-2-2zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Workspace24",
          "filepath": "workspace/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17v8H6V17H16m0-2H6a2 2 0 00-2 2v8a2 2 0 002 2H16a2 2 0 002-2V17a2 2 0 00-2-2zM27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM27 17v5H22V17h5m0-2H22a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V17a2 2 0 00-2-2zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Workspace20",
          "filepath": "workspace/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17v8H6V17H16m0-2H6a2 2 0 00-2 2v8a2 2 0 002 2H16a2 2 0 002-2V17a2 2 0 00-2-2zM27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM27 17v5H22V17h5m0-2H22a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V17a2 2 0 00-2-2zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Workspace16",
          "filepath": "workspace/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 17v8H6V17H16m0-2H6a2 2 0 00-2 2v8a2 2 0 002 2H16a2 2 0 002-2V17a2 2 0 00-2-2zM27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM27 17v5H22V17h5m0-2H22a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V17a2 2 0 00-2-2zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Workspace",
        "global": "Workspace",
        "filepath": "Workspace.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 17v8H6V17H16m0-2H6a2 2 0 00-2 2v8a2 2 0 002 2H16a2 2 0 002-2V17a2 2 0 00-2-2zM27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM27 17v5H22V17h5m0-2H22a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V17a2 2 0 00-2-2zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "workspace--import",
      "friendlyName": "Workspace import",
      "aliases": [
        "workspace import",
        "operations"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/workspace--import.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,6v5H17V6H27m0-2H17a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/>\n  <path d=\"M12,25H6V17h6V15H6a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h6Z\"/>\n  <polygon points=\"30 20 16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20\"/>\n  <path d=\"M11,6v5H6V6h5m0-2H6A2,2,0,0,0,4,6v5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM12 25H6V17h6V15H6a2 2 0 00-2 2v8a2 2 0 002 2h6zM30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z\"/></svg>",
            "info": {},
            "path": "32/workspace--import.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WorkspaceImport32",
          "filepath": "workspace--import/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM12 25H6V17h6V15H6a2 2 0 00-2 2v8a2 2 0 002 2h6zM30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace--import",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WorkspaceImport24",
          "filepath": "workspace--import/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM12 25H6V17h6V15H6a2 2 0 00-2 2v8a2 2 0 002 2h6zM30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace--import",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WorkspaceImport20",
          "filepath": "workspace--import/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM12 25H6V17h6V15H6a2 2 0 00-2 2v8a2 2 0 002 2h6zM30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace--import",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WorkspaceImport16",
          "filepath": "workspace--import/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM12 25H6V17h6V15H6a2 2 0 00-2 2v8a2 2 0 002 2h6zM30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                }
              }
            ],
            "name": "workspace--import",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "WorkspaceImport",
        "global": "WorkspaceImport",
        "filepath": "WorkspaceImport.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM12 25H6V17h6V15H6a2 2 0 00-2 2v8a2 2 0 002 2h6zM30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "worship",
      "friendlyName": "Worship",
      "aliases": [
        "religion",
        "faith"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/worship.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>worship</title>\n  <path d=\"M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z\"/>\n  <path d=\"M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z\"/>\n  <path d=\"M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z\"/><path d=\"M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z\"/><path d=\"M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z\"/></svg>",
            "info": {},
            "path": "32/worship.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Worship32",
          "filepath": "worship/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z"
                }
              }
            ],
            "name": "worship",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Worship24",
          "filepath": "worship/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z"
                }
              }
            ],
            "name": "worship",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Worship20",
          "filepath": "worship/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z"
                }
              }
            ],
            "name": "worship",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Worship16",
          "filepath": "worship/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z"
                }
              }
            ],
            "name": "worship",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "Worship",
        "global": "Worship",
        "filepath": "Worship.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "worship--christian",
      "friendlyName": "Worship Christian",
      "aliases": [
        "religion",
        "faith"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/worship--christian.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>worship--christian</title>\n  <path d=\"M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z\"/></svg>",
            "info": {},
            "path": "32/worship--christian.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WorshipChristian32",
          "filepath": "worship--christian/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z"
                }
              }
            ],
            "name": "worship--christian",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WorshipChristian24",
          "filepath": "worship--christian/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z"
                }
              }
            ],
            "name": "worship--christian",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WorshipChristian20",
          "filepath": "worship--christian/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z"
                }
              }
            ],
            "name": "worship--christian",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WorshipChristian16",
          "filepath": "worship--christian/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z"
                }
              }
            ],
            "name": "worship--christian",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "WorshipChristian",
        "global": "WorshipChristian",
        "filepath": "WorshipChristian.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "worship--jewish",
      "friendlyName": "Worship Jewish",
      "aliases": [
        "religion",
        "faith"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/worship--jewish.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>worship--jewish</title>\n  <path d=\"M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z\"/></svg>",
            "info": {},
            "path": "32/worship--jewish.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WorshipJewish32",
          "filepath": "worship--jewish/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z"
                }
              }
            ],
            "name": "worship--jewish",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WorshipJewish24",
          "filepath": "worship--jewish/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z"
                }
              }
            ],
            "name": "worship--jewish",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WorshipJewish20",
          "filepath": "worship--jewish/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z"
                }
              }
            ],
            "name": "worship--jewish",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WorshipJewish16",
          "filepath": "worship--jewish/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z"
                }
              }
            ],
            "name": "worship--jewish",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "WorshipJewish",
        "global": "WorshipJewish",
        "filepath": "WorshipJewish.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "worship--muslim",
      "friendlyName": "Worship Muslim",
      "aliases": [
        "religion",
        "faith"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/worship--muslim.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <title>worship--muslim</title>\n  <path d=\"M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z\"/>\n  <path d=\"M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z\"/><path d=\"M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z\"/></svg>",
            "info": {},
            "path": "32/worship--muslim.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WorshipMuslim32",
          "filepath": "worship--muslim/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z"
                }
              }
            ],
            "name": "worship--muslim",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WorshipMuslim24",
          "filepath": "worship--muslim/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z"
                }
              }
            ],
            "name": "worship--muslim",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WorshipMuslim20",
          "filepath": "worship--muslim/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z"
                }
              }
            ],
            "name": "worship--muslim",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WorshipMuslim16",
          "filepath": "worship--muslim/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z"
                }
              }
            ],
            "name": "worship--muslim",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Planning",
      "subcategory": "Travel",
      "moduleInfo": {
        "local": "WorshipMuslim",
        "global": "WorshipMuslim",
        "filepath": "WorshipMuslim.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "X",
      "friendlyName": "X",
      "aliases": [
        "alphabet",
        "letter",
        "cross"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/X.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--X</title><polygon points=\"20 9 18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9\"/><rect class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z\"/></svg>",
            "info": {},
            "path": "32/Q/X.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QX32",
          "filepath": "Q/X/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
                }
              }
            ],
            "name": "X",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QX24",
          "filepath": "Q/X/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
                }
              }
            ],
            "name": "X",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QX20",
          "filepath": "Q/X/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
                }
              }
            ],
            "name": "X",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QX16",
          "filepath": "Q/X/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
                }
              }
            ],
            "name": "X",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "X",
        "global": "QX",
        "filepath": "Q/X.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "x-axis",
      "friendlyName": "X axis",
      "aliases": [
        "horizontal",
        "data",
        "right",
        "angle",
        "corner",
        "turn"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/x-axis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>x-axis</title><path d=\"M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z\"/></svg>",
            "info": {},
            "path": "32/x-axis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "XAxis32",
          "filepath": "x-axis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z"
                }
              }
            ],
            "name": "x-axis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "XAxis24",
          "filepath": "x-axis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z"
                }
              }
            ],
            "name": "x-axis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "XAxis20",
          "filepath": "x-axis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z"
                }
              }
            ],
            "name": "x-axis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "XAxis16",
          "filepath": "x-axis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z"
                }
              }
            ],
            "name": "x-axis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "XAxis",
        "global": "XAxis",
        "filepath": "XAxis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "XLS",
      "friendlyName": "XLS",
      "aliases": [
        "excel",
        "format",
        "spreadsheet"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/XLS.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>XLS</title><path d=\"M28,23H22V21h6V17H24a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H24v4h4a2.002,2.002,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,23Z\"/><polygon points=\"14 21 14 9 12 9 12 23 20 23 20 21 14 21\"/><polygon points=\"10 9 8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 23H22V21h6V17H24a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0128 23zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z\"/></svg>",
            "info": {},
            "path": "32/XLS.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Xls32",
          "filepath": "XLS/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H22V21h6V17H24a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0128 23zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z"
                }
              }
            ],
            "name": "XLS",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Xls24",
          "filepath": "XLS/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H22V21h6V17H24a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0128 23zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z"
                }
              }
            ],
            "name": "XLS",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Xls20",
          "filepath": "XLS/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H22V21h6V17H24a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0128 23zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z"
                }
              }
            ],
            "name": "XLS",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Xls16",
          "filepath": "XLS/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 23H22V21h6V17H24a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0128 23zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z"
                }
              }
            ],
            "name": "XLS",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Xls",
        "global": "Xls",
        "filepath": "Xls.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 23H22V21h6V17H24a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0128 23zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "XML",
      "friendlyName": "XML",
      "aliases": [
        "format",
        "markup",
        "language",
        "HTML"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/XML.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>XML</title><polygon points=\"24 21 24 9 22 9 22 23 30 23 30 21 24 21\"/><polygon points=\"18 9 16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9\"/><polygon points=\"10 9 8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9zM10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z\"/></svg>",
            "info": {},
            "path": "32/XML.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Xml32",
          "filepath": "XML/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9zM10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z"
                }
              }
            ],
            "name": "XML",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Xml24",
          "filepath": "XML/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9zM10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z"
                }
              }
            ],
            "name": "XML",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Xml20",
          "filepath": "XML/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9zM10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z"
                }
              }
            ],
            "name": "XML",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Xml16",
          "filepath": "XML/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9zM10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z"
                }
              }
            ],
            "name": "XML",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Xml",
        "global": "Xml",
        "filepath": "Xml.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9zM10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "Y",
      "friendlyName": "Y",
      "aliases": [
        "alphabet",
        "letter"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/Y.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--Y</title><polygon points=\"20 9 18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z\"/></svg>",
            "info": {},
            "path": "32/Q/Y.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QY32",
          "filepath": "Q/Y/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z"
                }
              }
            ],
            "name": "Y",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QY24",
          "filepath": "Q/Y/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z"
                }
              }
            ],
            "name": "Y",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QY20",
          "filepath": "Q/Y/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z"
                }
              }
            ],
            "name": "Y",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QY16",
          "filepath": "Q/Y/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z"
                }
              }
            ],
            "name": "Y",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "Y",
        "global": "QY",
        "filepath": "Q/Y.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "y-axis",
      "friendlyName": "Y axis",
      "aliases": [
        "verticle",
        "data",
        "up",
        "angle",
        "corner",
        "turn"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/y-axis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>y-axis</title><path d=\"M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z\"/></svg>",
            "info": {},
            "path": "32/y-axis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "YAxis32",
          "filepath": "y-axis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z"
                }
              }
            ],
            "name": "y-axis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "YAxis24",
          "filepath": "y-axis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z"
                }
              }
            ],
            "name": "y-axis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "YAxis20",
          "filepath": "y-axis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z"
                }
              }
            ],
            "name": "y-axis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "YAxis16",
          "filepath": "y-axis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z"
                }
              }
            ],
            "name": "y-axis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "YAxis",
        "global": "YAxis",
        "filepath": "YAxis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "Z",
      "friendlyName": "Z",
      "aliases": [
        "alphabet",
        "letter"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "Q"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/Q/Z.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>Q-research--Z</title><polygon points=\"20 9 12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z\"/></svg>",
            "info": {},
            "path": "32/Q/Z.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "QZ32",
          "filepath": "Q/Z/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              }
            ],
            "name": "Z",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "QZ24",
          "filepath": "Q/Z/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              }
            ],
            "name": "Z",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "QZ20",
          "filepath": "Q/Z/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              }
            ],
            "name": "Z",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "QZ16",
          "filepath": "Q/Z/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                }
              }
            ],
            "name": "Z",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Research",
      "moduleInfo": {
        "local": "Z",
        "global": "QZ",
        "filepath": "Q/Z.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "z--lpar",
      "friendlyName": "z--lpar",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/z--lpar.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z\"/></svg>",
            "info": {},
            "path": "32/z--lpar.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZLpar32",
          "filepath": "z--lpar/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z"
                }
              }
            ],
            "name": "z--lpar",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZLpar24",
          "filepath": "z--lpar/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z"
                }
              }
            ],
            "name": "z--lpar",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZLpar20",
          "filepath": "z--lpar/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z"
                }
              }
            ],
            "name": "z--lpar",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZLpar16",
          "filepath": "z--lpar/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z"
                }
              }
            ],
            "name": "z--lpar",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ZLpar",
        "global": "ZLpar",
        "filepath": "ZLpar.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "z--systems",
      "friendlyName": "z--systems",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/z--systems.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M27,3h-8c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2V5c0-1.1025-.8972-2-2-2Zm.0002,6.9194l-6.1494-4.9194h6.1492l.0002,4.9194Zm-.6011,2.0806l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-8.0005,8.0005l6.1492,4.9194h-6.1492v-4.9194Z\"/>\n  <path d=\"M13,3H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2H13c1.1028,0,2-.8975,2-2V5c0-1.1025-.8972-2-2-2Zm.0002,6.9194L6.8508,5h6.1492l.0002,4.9194Zm-.6011,2.0806l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199ZM5,22.0806l6.1492,4.9194H5v-4.9194Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27 3h-8c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194l-6.1494-4.9194h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zm-8.0005 8.0005l6.1492 4.9194h-6.1492v-4.9194zM13 3H5c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2H13c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194L6.8508 5h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zM5 22.0806l6.1492 4.9194H5v-4.9194z\"/></svg>",
            "info": {},
            "path": "32/z--systems.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZSystems32",
          "filepath": "z--systems/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3h-8c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194l-6.1494-4.9194h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zm-8.0005 8.0005l6.1492 4.9194h-6.1492v-4.9194zM13 3H5c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2H13c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194L6.8508 5h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zM5 22.0806l6.1492 4.9194H5v-4.9194z"
                }
              }
            ],
            "name": "z--systems",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZSystems24",
          "filepath": "z--systems/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3h-8c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194l-6.1494-4.9194h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zm-8.0005 8.0005l6.1492 4.9194h-6.1492v-4.9194zM13 3H5c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2H13c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194L6.8508 5h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zM5 22.0806l6.1492 4.9194H5v-4.9194z"
                }
              }
            ],
            "name": "z--systems",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZSystems20",
          "filepath": "z--systems/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3h-8c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194l-6.1494-4.9194h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zm-8.0005 8.0005l6.1492 4.9194h-6.1492v-4.9194zM13 3H5c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2H13c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194L6.8508 5h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zM5 22.0806l6.1492 4.9194H5v-4.9194z"
                }
              }
            ],
            "name": "z--systems",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZSystems16",
          "filepath": "z--systems/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27 3h-8c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194l-6.1494-4.9194h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zm-8.0005 8.0005l6.1492 4.9194h-6.1492v-4.9194zM13 3H5c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2H13c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194L6.8508 5h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zM5 22.0806l6.1492 4.9194H5v-4.9194z"
                }
              }
            ],
            "name": "z--systems",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ZSystems",
        "global": "ZSystems",
        "filepath": "ZSystems.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27 3h-8c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194l-6.1494-4.9194h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zm-8.0005 8.0005l6.1492 4.9194h-6.1492v-4.9194zM13 3H5c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2H13c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194L6.8508 5h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zM5 22.0806l6.1492 4.9194H5v-4.9194z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "z-axis",
      "friendlyName": "Z axis",
      "aliases": [
        "depth",
        "3D",
        "dimension",
        "3"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/z-axis.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>z-axis</title><polygon points=\"26 22 26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z\"/></svg>",
            "info": {},
            "path": "32/z-axis.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZAxis32",
          "filepath": "z-axis/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z"
                }
              }
            ],
            "name": "z-axis",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZAxis24",
          "filepath": "z-axis/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z"
                }
              }
            ],
            "name": "z-axis",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZAxis20",
          "filepath": "z-axis/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z"
                }
              }
            ],
            "name": "z-axis",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZAxis16",
          "filepath": "z-axis/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z"
                }
              }
            ],
            "name": "z-axis",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Operations",
      "moduleInfo": {
        "local": "ZAxis",
        "global": "ZAxis",
        "filepath": "ZAxis.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ZIP",
      "friendlyName": "ZIP",
      "aliases": [
        "compress",
        "format"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ZIP.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>ZIP</title><path d=\"M28,9H22V23h2V18h4a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9Zm0,7H24V11h4Z\"/><polygon points=\"12 9 12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9\"/><polygon points=\"10 9 2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M28 9H22V23h2V18h4a2 2 0 002-2V11A2 2 0 0028 9zm0 7H24V11h4zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9zM10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z\"/></svg>",
            "info": {},
            "path": "32/ZIP.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Zip32",
          "filepath": "ZIP/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22V23h2V18h4a2 2 0 002-2V11A2 2 0 0028 9zm0 7H24V11h4zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9zM10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z"
                }
              }
            ],
            "name": "ZIP",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Zip24",
          "filepath": "ZIP/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22V23h2V18h4a2 2 0 002-2V11A2 2 0 0028 9zm0 7H24V11h4zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9zM10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z"
                }
              }
            ],
            "name": "ZIP",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Zip20",
          "filepath": "ZIP/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22V23h2V18h4a2 2 0 002-2V11A2 2 0 0028 9zm0 7H24V11h4zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9zM10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z"
                }
              }
            ],
            "name": "ZIP",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Zip16",
          "filepath": "ZIP/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M28 9H22V23h2V18h4a2 2 0 002-2V11A2 2 0 0028 9zm0 7H24V11h4zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9zM10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z"
                }
              }
            ],
            "name": "ZIP",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "Zip",
        "global": "Zip",
        "filepath": "Zip.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M28 9H22V23h2V18h4a2 2 0 002-2V11A2 2 0 0028 9zm0 7H24V11h4zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9zM10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ZIP--reference",
      "friendlyName": "ZIP reference",
      "aliases": [
        "ZIP reference",
        "citation",
        "source"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/ZIP--reference.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20\"/>\n  <path d=\"M28,2H22V16h2V11h4a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2Zm0,7H24V4h4Z\"/>\n  <polygon points=\"12 4 15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4\"/>\n  <polygon points=\"2 4 8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 2H22V16h2V11h4a2 2 0 002-2V4A2 2 0 0028 2zm0 7H24V4h4zM12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4zM2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z\"/></svg>",
            "info": {},
            "path": "32/ZIP--reference.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZipReference32",
          "filepath": "ZIP--reference/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 2H22V16h2V11h4a2 2 0 002-2V4A2 2 0 0028 2zm0 7H24V4h4zM12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4zM2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z"
                }
              }
            ],
            "name": "ZIP--reference",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZipReference24",
          "filepath": "ZIP--reference/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 2H22V16h2V11h4a2 2 0 002-2V4A2 2 0 0028 2zm0 7H24V4h4zM12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4zM2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z"
                }
              }
            ],
            "name": "ZIP--reference",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZipReference20",
          "filepath": "ZIP--reference/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 2H22V16h2V11h4a2 2 0 002-2V4A2 2 0 0028 2zm0 7H24V4h4zM12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4zM2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z"
                }
              }
            ],
            "name": "ZIP--reference",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZipReference16",
          "filepath": "ZIP--reference/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 2H22V16h2V11h4a2 2 0 002-2V4A2 2 0 0028 2zm0 7H24V4h4zM12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4zM2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z"
                }
              }
            ],
            "name": "ZIP--reference",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "File",
      "moduleInfo": {
        "local": "ZipReference",
        "global": "ZipReference",
        "filepath": "ZipReference.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 2H22V16h2V11h4a2 2 0 002-2V4A2 2 0 0028 2zm0 7H24V4h4zM12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4zM2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom--area",
      "friendlyName": "Zoom area",
      "aliases": [
        "expand",
        "inspect",
        "size",
        "enlarge",
        "detail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/zoom--area.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M31,29.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L29.5859,31ZM20,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,20,26Z\"/>\n  <path d=\"M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z\"/>\n  <rect x=\"2\" y=\"12\" width=\"2\" height=\"4\"/>\n  <path d=\"M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z\"/>\n  <rect x=\"12\" y=\"2\" width=\"4\" height=\"2\"/>\n  <path d=\"M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4z\"/></svg>",
            "info": {},
            "path": "32/zoom--area.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZoomArea32",
          "filepath": "zoom--area/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4z"
                }
              }
            ],
            "name": "zoom--area",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZoomArea24",
          "filepath": "zoom--area/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4z"
                }
              }
            ],
            "name": "zoom--area",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZoomArea20",
          "filepath": "zoom--area/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4z"
                }
              }
            ],
            "name": "zoom--area",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZoomArea16",
          "filepath": "zoom--area/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4z"
                }
              }
            ],
            "name": "zoom--area",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ZoomArea",
        "global": "ZoomArea",
        "filepath": "ZoomArea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom--fit",
      "friendlyName": "Zoom fit",
      "aliases": [
        "expand",
        "inspect",
        "size",
        "enlarge",
        "detail",
        "fit"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/zoom--fit.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z\"/>\n  <path d=\"M10,12H8V10a2.0023,2.0023,0,0,1,2-2h2v2H10Z\"/>\n  <path d=\"M18,12H16V10H14V8h2a2.0023,2.0023,0,0,1,2,2Z\"/>\n  <path d=\"M12,18H10a2.0023,2.0023,0,0,1-2-2V14h2v2h2Z\"/>\n  <path d=\"M16,18H14V16h2V14h2v2A2.0023,2.0023,0,0,1,16,18Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z\"/><path d=\"M10 12H8V10a2.0023 2.0023 0 012-2h2v2H10zM18 12H16V10H14V8h2a2.0023 2.0023 0 012 2zM12 18H10a2.0023 2.0023 0 01-2-2V14h2v2h2zM16 18H14V16h2V14h2v2A2.0023 2.0023 0 0116 18z\"/></svg>",
            "info": {},
            "path": "32/zoom--fit.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZoomFit32",
          "filepath": "zoom--fit/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H8V10a2.0023 2.0023 0 012-2h2v2H10zM18 12H16V10H14V8h2a2.0023 2.0023 0 012 2zM12 18H10a2.0023 2.0023 0 01-2-2V14h2v2h2zM16 18H14V16h2V14h2v2A2.0023 2.0023 0 0116 18z"
                }
              }
            ],
            "name": "zoom--fit",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZoomFit24",
          "filepath": "zoom--fit/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H8V10a2.0023 2.0023 0 012-2h2v2H10zM18 12H16V10H14V8h2a2.0023 2.0023 0 012 2zM12 18H10a2.0023 2.0023 0 01-2-2V14h2v2h2zM16 18H14V16h2V14h2v2A2.0023 2.0023 0 0116 18z"
                }
              }
            ],
            "name": "zoom--fit",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZoomFit20",
          "filepath": "zoom--fit/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H8V10a2.0023 2.0023 0 012-2h2v2H10zM18 12H16V10H14V8h2a2.0023 2.0023 0 012 2zM12 18H10a2.0023 2.0023 0 01-2-2V14h2v2h2zM16 18H14V16h2V14h2v2A2.0023 2.0023 0 0116 18z"
                }
              }
            ],
            "name": "zoom--fit",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZoomFit16",
          "filepath": "zoom--fit/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10 12H8V10a2.0023 2.0023 0 012-2h2v2H10zM18 12H16V10H14V8h2a2.0023 2.0023 0 012 2zM12 18H10a2.0023 2.0023 0 01-2-2V14h2v2h2zM16 18H14V16h2V14h2v2A2.0023 2.0023 0 0116 18z"
                }
              }
            ],
            "name": "zoom--fit",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ZoomFit",
        "global": "ZoomFit",
        "filepath": "ZoomFit.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10 12H8V10a2.0023 2.0023 0 012-2h2v2H10zM18 12H16V10H14V8h2a2.0023 2.0023 0 012 2zM12 18H10a2.0023 2.0023 0 01-2-2V14h2v2h2zM16 18H14V16h2V14h2v2A2.0023 2.0023 0 0116 18z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom--in",
      "friendlyName": "Zoom in",
      "aliases": [
        "expand",
        "inspect",
        "size",
        "enlarge",
        "detail"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/zoom--in.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>zoom--in</title>\n<polygon points=\"9,6 7,6 7,4 6,4 6,6 4,6 4,7 6,7 6,9 7,9 7,7 9,7 \"/>\n<path d=\"M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7\n\tL10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M9 6L7 6 7 4 6 4 6 6 4 6 4 7 6 7 6 9 7 9 7 7 9 7z\"/><path d=\"M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7\tL10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z\"/></svg>",
            "info": {},
            "path": "16/zoom--in.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/zoom--in.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"18 12 14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12\"/>\n  <path d=\"M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M18 12L14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12z\"/><path d=\"M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z\"/></svg>",
            "info": {},
            "path": "32/zoom--in.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZoomIn32",
          "filepath": "zoom--in/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 12L14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              }
            ],
            "name": "zoom--in",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZoomIn24",
          "filepath": "zoom--in/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 12L14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              }
            ],
            "name": "zoom--in",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZoomIn20",
          "filepath": "zoom--in/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M18 12L14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              }
            ],
            "name": "zoom--in",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZoomIn16",
          "filepath": "zoom--in/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M9 6L7 6 7 4 6 4 6 6 4 6 4 7 6 7 6 9 7 9 7 7 9 7z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7\tL10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
                }
              }
            ],
            "name": "zoom--in",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ZoomIn",
        "global": "ZoomIn",
        "filepath": "ZoomIn.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M9 6L7 6 7 4 6 4 6 6 4 6 4 7 6 7 6 9 7 9 7 7 9 7z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7 L10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M18 12L14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom--in-area",
      "friendlyName": "Zoom in area",
      "aliases": [
        "expand",
        "inspect",
        "size",
        "enlarge",
        "detail",
        "zoom in area"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/zoom--in-area.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon points=\"24 19 21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19\"/>\n  <path d=\"M31,29.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L29.5859,31ZM20,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,20,26Z\"/>\n  <path d=\"M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z\"/>\n  <path d=\"M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z\"/>\n  <rect x=\"12\" y=\"2\" width=\"4\" height=\"2\"/>\n  <path d=\"M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z\"/>\n  <rect x=\"2\" y=\"12\" width=\"2\" height=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z\"/><path d=\"M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z\"/></svg>",
            "info": {},
            "path": "32/zoom--in-area.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZoomInArea32",
          "filepath": "zoom--in-area/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--in-area",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZoomInArea24",
          "filepath": "zoom--in-area/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--in-area",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZoomInArea20",
          "filepath": "zoom--in-area/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--in-area",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZoomInArea16",
          "filepath": "zoom--in-area/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--in-area",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ZoomInArea",
        "global": "ZoomInArea",
        "filepath": "ZoomInArea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom--out",
      "friendlyName": "Zoom out",
      "aliases": [
        "expand",
        "inspect",
        "size",
        "enlarge",
        "detail"
      ],
      "sizes": [
        16,
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 16,
          "filepath": "16/zoom--out.svg",
          "source": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;}\n</style>\n<title>zoom--out</title>\n<rect x=\"4\" y=\"6\" width=\"5\" height=\"1\"/>\n<path d=\"M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7\n\tL10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z\"/>\n<rect id=\"_Transparent_Rectangle_\" class=\"st0\" width=\"16\" height=\"16\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4 6H9V7H4z\"/><path d=\"M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7\tL10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z\"/></svg>",
            "info": {},
            "path": "16/zoom--out.svg"
          }
        },
        {
          "size": 32,
          "filepath": "32/zoom--out.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"8\" y=\"12\" width=\"10\" height=\"2\"/>\n  <path d=\"M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z\" transform=\"translate(0)\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M8 12H18V14H8z\"/><path d=\"M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z\"/></svg>",
            "info": {},
            "path": "32/zoom--out.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZoomOut32",
          "filepath": "zoom--out/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H18V14H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              }
            ],
            "name": "zoom--out",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZoomOut24",
          "filepath": "zoom--out/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H18V14H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              }
            ],
            "name": "zoom--out",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZoomOut20",
          "filepath": "zoom--out/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M8 12H18V14H8z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                }
              }
            ],
            "name": "zoom--out",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZoomOut16",
          "filepath": "zoom--out/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 16 16",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M4 6H9V7H4z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7\tL10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
                }
              }
            ],
            "name": "zoom--out",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ZoomOut",
        "global": "ZoomOut",
        "filepath": "ZoomOut.js",
        "sizes": [
          {
            "size": 16,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 16 16",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M4 6H9V7H4z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7 L10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
                  },
                  "children": []
                }
              ]
            }
          },
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M8 12H18V14H8z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom--out-area",
      "friendlyName": "Zoom out area",
      "aliases": [
        "reduce",
        "inspect",
        "size",
        "detail",
        "zoom out area"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/zoom--out-area.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <rect x=\"16\" y=\"19\" width=\"8\" height=\"2\"/>\n  <path d=\"M31,29.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L29.5859,31ZM20,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,20,26Z\"/>\n  <path d=\"M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z\"/>\n  <path d=\"M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z\"/>\n  <rect x=\"12\" y=\"2\" width=\"4\" height=\"2\"/>\n  <path d=\"M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z\"/>\n  <rect x=\"2\" y=\"12\" width=\"2\" height=\"4\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>\n",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M16 19H24V21H16z\"/><path d=\"M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z\"/></svg>",
            "info": {},
            "path": "32/zoom--out-area.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZoomOutArea32",
          "filepath": "zoom--out-area/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19H24V21H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--out-area",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZoomOutArea24",
          "filepath": "zoom--out-area/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19H24V21H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--out-area",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZoomOutArea20",
          "filepath": "zoom--out-area/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19H24V21H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--out-area",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZoomOutArea16",
          "filepath": "zoom--out-area/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M16 19H24V21H16z"
                }
              },
              {
                "elem": "path",
                "attrs": {
                  "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                }
              }
            ],
            "name": "zoom--out-area",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ZoomOutArea",
        "global": "ZoomOutArea",
        "filepath": "ZoomOutArea.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M16 19H24V21H16z"
                  },
                  "children": []
                },
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom--reset",
      "friendlyName": "Zoom reset",
      "aliases": [
        "expand",
        "inspect",
        "size",
        "enlarge",
        "detail"
      ],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/zoom--reset.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>zoom--reset</title><path d=\"M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z\"/></svg>",
            "info": {},
            "path": "32/zoom--reset.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZoomReset32",
          "filepath": "zoom--reset/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "zoom--reset",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZoomReset24",
          "filepath": "zoom--reset/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "zoom--reset",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZoomReset20",
          "filepath": "zoom--reset/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "zoom--reset",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZoomReset16",
          "filepath": "zoom--reset/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"
                }
              }
            ],
            "name": "zoom--reset",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Actions",
      "subcategory": "Navigation",
      "moduleInfo": {
        "local": "ZoomReset",
        "global": "ZoomReset",
        "filepath": "ZoomReset.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zoom-pan",
      "friendlyName": "Zoom pan",
      "aliases": [
        "track",
        "move",
        "view",
        "zoom",
        "magnifying glass",
        "search"
      ],
      "sizes": [
        32
      ],
      "namespace": [
        "watson-health"
      ],
      "assets": [
        {
          "size": 32,
          "filepath": "32/watson-health/zoom-pan.svg",
          "source": "<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><defs><style>.cls-1{fill:none;}</style></defs><title>zoom-pan</title><polygon points=\"27.01 12 25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12\"/><polygon points=\"6.41 13.42 5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42\"/><polygon points=\"16 28.17 13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17\"/><polygon points=\"16 3.83 18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83\"/><path d=\"M22,16a6,6,0,1,0-2.53,4.89l3.82,3.82,1.42-1.42-3.82-3.82A6,6,0,0,0,22,16Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z\"/><rect id=\"_Transparent_Rectangle_\" data-name=\"&lt;Transparent Rectangle&gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/></svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12zM6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42zM16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17zM16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83zM22 16a6 6 0 10-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0022 16zm-6 4a4 4 0 114-4A4 4 0 0116 20z\"/></svg>",
            "info": {},
            "path": "32/watson-health/zoom-pan.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "WatsonHealthZoomPan32",
          "filepath": "watson-health/zoom-pan/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12zM6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42zM16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17zM16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83zM22 16a6 6 0 10-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0022 16zm-6 4a4 4 0 114-4A4 4 0 0116 20z"
                }
              }
            ],
            "name": "zoom-pan",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "WatsonHealthZoomPan24",
          "filepath": "watson-health/zoom-pan/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12zM6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42zM16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17zM16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83zM22 16a6 6 0 10-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0022 16zm-6 4a4 4 0 114-4A4 4 0 0116 20z"
                }
              }
            ],
            "name": "zoom-pan",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "WatsonHealthZoomPan20",
          "filepath": "watson-health/zoom-pan/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12zM6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42zM16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17zM16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83zM22 16a6 6 0 10-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0022 16zm-6 4a4 4 0 114-4A4 4 0 0116 20z"
                }
              }
            ],
            "name": "zoom-pan",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "WatsonHealthZoomPan16",
          "filepath": "watson-health/zoom-pan/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12zM6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42zM16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17zM16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83zM22 16a6 6 0 10-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0022 16zm-6 4a4 4 0 114-4A4 4 0 0116 20z"
                }
              }
            ],
            "name": "zoom-pan",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Enterprise",
      "subcategory": "Health",
      "moduleInfo": {
        "local": "ZoomPan",
        "global": "WatsonHealthZoomPan",
        "filepath": "watson-health/ZoomPan.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12zM6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42zM16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17zM16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83zM22 16a6 6 0 10-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0022 16zm-6 4a4 4 0 114-4A4 4 0 0116 20z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zos",
      "friendlyName": "zos",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/zos.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M30,22h-5v-2h5v-3h-3c-1.1028,0-2-.8972-2-2v-3c0-1.1028,.8972-2,2-2h5v2h-5v3h3c1.1028,0,2,.8972,2,2v3c0,1.1028-.8972,2-2,2Z\"/>\n  <path d=\"M21,22h-3c-1.1028,0-2-.8972-2-2V12c0-1.1028,.8972-2,2-2h3c1.1028,0,2,.8972,2,2v8c0,1.1028-.8972,2-2,2Zm-3-10v8h3V12h-3Z\"/>\n  <polygon points=\"11.9458 10 7.9458 22 10.0542 22 14.0542 10 11.9458 10\"/>\n  <polygon points=\"6 22 0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" x=\"0\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-3c-1.1028 0-2-.8972-2-2V12c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-3-10v8h3V12h-3zM11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z\"/></svg>",
            "info": {},
            "path": "32/zos.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "Zos32",
          "filepath": "zos/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-3c-1.1028 0-2-.8972-2-2V12c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-3-10v8h3V12h-3zM11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
                }
              }
            ],
            "name": "zos",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "Zos24",
          "filepath": "zos/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-3c-1.1028 0-2-.8972-2-2V12c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-3-10v8h3V12h-3zM11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
                }
              }
            ],
            "name": "zos",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "Zos20",
          "filepath": "zos/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-3c-1.1028 0-2-.8972-2-2V12c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-3-10v8h3V12h-3zM11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
                }
              }
            ],
            "name": "zos",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "Zos16",
          "filepath": "zos/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-3c-1.1028 0-2-.8972-2-2V12c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-3-10v8h3V12h-3zM11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
                }
              }
            ],
            "name": "zos",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "Zos",
        "global": "Zos",
        "filepath": "Zos.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-3c-1.1028 0-2-.8972-2-2V12c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-3-10v8h3V12h-3zM11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    },
    {
      "name": "zos--sysplex",
      "friendlyName": "zos--sysplex",
      "aliases": [],
      "sizes": [
        32
      ],
      "namespace": [],
      "assets": [
        {
          "size": 32,
          "filepath": "32/zos--sysplex.svg",
          "source": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg id=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path d=\"M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z\"/>\n  <rect id=\"_Transparent_Rectangle_\" data-name=\"&amp;lt;Transparent Rectangle&amp;gt;\" class=\"cls-1\" width=\"32\" height=\"32\"/>\n</svg>",
          "optimized": {
            "data": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z\"/></svg>",
            "info": {},
            "path": "32/zos--sysplex.svg"
          }
        }
      ],
      "output": [
        {
          "moduleName": "ZosSysplex32",
          "filepath": "zos--sysplex/32.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 32,
              "height": 32
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z"
                }
              }
            ],
            "name": "zos--sysplex",
            "size": 32
          },
          "size": 32
        },
        {
          "moduleName": "ZosSysplex24",
          "filepath": "zos--sysplex/24.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 24,
              "height": 24
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z"
                }
              }
            ],
            "name": "zos--sysplex",
            "size": 24
          },
          "size": 24
        },
        {
          "moduleName": "ZosSysplex20",
          "filepath": "zos--sysplex/20.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 20,
              "height": 20
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z"
                }
              }
            ],
            "name": "zos--sysplex",
            "size": 20
          },
          "size": 20
        },
        {
          "moduleName": "ZosSysplex16",
          "filepath": "zos--sysplex/16.js",
          "descriptor": {
            "elem": "svg",
            "attrs": {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 32 32",
              "fill": "currentColor",
              "width": 16,
              "height": 16
            },
            "content": [
              {
                "elem": "path",
                "attrs": {
                  "d": "M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z"
                }
              }
            ],
            "name": "zos--sysplex",
            "size": 16
          },
          "size": 16
        }
      ],
      "category": "Organization",
      "subcategory": "Systems",
      "moduleInfo": {
        "local": "ZosSysplex",
        "global": "ZosSysplex",
        "filepath": "ZosSysplex.js",
        "sizes": [
          {
            "size": 32,
            "ast": {
              "type": "element",
              "tagName": "svg",
              "attributes": {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 32 32",
                "fill": "currentColor"
              },
              "children": [
                {
                  "type": "element",
                  "tagName": "path",
                  "attributes": {
                    "d": "M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z"
                  },
                  "children": []
                }
              ]
            }
          }
        ]
      }
    }
  ],
  "categories": [
    {
      "name": "Actions",
      "subcategories": [
        {
          "name": "Controls",
          "members": [
            "center-to-fit",
            "continue",
            "continue--filled",
            "dashboard",
            "dashboard--reference",
            "fit-to-height",
            "fit-to-width",
            "fit-to-screen",
            "forward--10",
            "forward--30",
            "forward--5",
            "next--filled",
            "next--outline",
            "open-panel--bottom",
            "open-panel--filled--bottom",
            "open-panel--filled--left",
            "open-panel--filled--right",
            "open-panel--filled--top",
            "open-panel--left",
            "open-panel--right",
            "open-panel--top",
            "pause",
            "pause--filled",
            "pause--outline",
            "pause--outline--filled",
            "play",
            "play--filled",
            "play--filled--alt",
            "play--outline",
            "play--outline--filled",
            "power",
            "previous--filled",
            "previous--outline",
            "recording",
            "recording--filled",
            "recording--filled--alt",
            "rewind--10",
            "rewind--30",
            "rewind--5",
            "settings",
            "settings--adjust",
            "settings--check",
            "settings--services",
            "settings--view",
            "shrink-screen",
            "shrink-screen--filled",
            "side-panel--close",
            "side-panel--close--filled",
            "side-panel--open",
            "side-panel--open--filled",
            "skip--back",
            "skip--back--filled",
            "skip--back--outline",
            "skip--back--outline--filled",
            "skip--back--outline--solid",
            "skip--back--solid--filled",
            "skip--forward",
            "skip--forward--filled",
            "skip--forward--outline",
            "skip--forward--outline--filled",
            "skip--forward--outline--solid",
            "skip--forward--solid--filled",
            "stop",
            "stop--filled",
            "stop--filled--alt",
            "stop--outline",
            "stop--outline--filled",
            "video--add",
            "video--chat",
            "volume--down",
            "volume--down--alt",
            "volume--down--filled",
            "volume--down--filled--alt",
            "volume--mute",
            "volume--mute--filled",
            "volume--up",
            "volume--up--alt",
            "volume--up--filled",
            "volume--up--filled--alt"
          ]
        },
        {
          "name": "Formatting",
          "members": [
            "align-box--bottom-center",
            "align-box--bottom-left",
            "align-box--bottom-right",
            "align-box--middle-center",
            "align-box--middle-left",
            "align-box--middle-right",
            "align-box--top-center",
            "align-box--top-left",
            "align-box--top-right",
            "align--horizontal-center",
            "align--horizontal-left",
            "align--horizontal-right",
            "align--vertical-bottom",
            "align--vertical-center",
            "align--vertical-top",
            "attachment",
            "asterisk",
            "border--bottom",
            "border--full",
            "border--left",
            "border--none",
            "border--right",
            "border--top",
            "brightness-contrast",
            "bring-forward",
            "bring-to-front",
            "button--centered",
            "button--flush-left",
            "circle--solid",
            "color-palette",
            "color-switch",
            "column--delete",
            "column--insert",
            "contrast",
            "corner",
            "crop",
            "cut",
            "cut-out",
            "distribute--horizontal-center",
            "distribute--horizontal-left",
            "distribute--horizontal-right",
            "distribute--vertical-bottom",
            "distribute--vertical-center",
            "distribute--vertical-top",
            "document--horizontal",
            "document--vertical",
            "dot-mark",
            "draw",
            "drop-photo",
            "drop-photo--filled",
            "edit",
            "edit--off",
            "erase",
            "eyedropper",
            "gradient",
            "group-objects",
            "group-objects--new",
            "group-objects--save",
            "horizontal-view",
            "image",
            "image--copy",
            "image--reference",
            "label",
            "language",
            "lasso",
            "lasso--polygon",
            "link",
            "list--boxes",
            "list--bulleted",
            "list--checked",
            "list--checked--mirror",
            "list--numbered",
            "list--numbered--mirror",
            "magic-wand",
            "magic-wand--filled",
            "no-image",
            "opacity",
            "page-break",
            "page-number",
            "paint-brush",
            "paint-brush--alt",
            "paragraph",
            "pen",
            "pen--fountain",
            "percentage",
            "percentage--filled",
            "quotes",
            "reflect--horizontal",
            "reflect--vertical",
            "rotate--clockwise",
            "rotate--clockwise--alt",
            "rotate--clockwise--alt--filled",
            "rotate--clockwise--filled",
            "rotate--counterclockwise",
            "rotate--counterclockwise--alt",
            "rotate--counterclockwise--alt--filled",
            "rotate--counterclockwise--filled",
            "row--delete",
            "row--insert",
            "save",
            "select--01",
            "select--02",
            "send-backward",
            "send-to-back",
            "shape--except",
            "shape--exclude",
            "shape--intersect",
            "shape--join",
            "shape--unite",
            "spell-check",
            "spray-paint",
            "text--align--center",
            "text--align--left",
            "text--align--justify",
            "text--align--mixed",
            "text--align--right",
            "text--all-caps",
            "text--bold",
            "text--clear-format",
            "text--color",
            "text--creation",
            "text--fill",
            "text--font",
            "text--footnote",
            "text--highlight",
            "text--indent",
            "text--indent--less",
            "text--indent--more",
            "text--italic",
            "text--kerning",
            "text--leading",
            "text--line-spacing",
            "text--new-line",
            "text--scale",
            "text--selection",
            "text--small-caps",
            "text--strikethrough",
            "text--subscript",
            "text--superscript",
            "text--tracking",
            "text--underline",
            "text--vertical-alignment",
            "text--wrap",
            "trash-can",
            "ungroup-objects",
            "unlink",
            "unsaved",
            "vertical-view"
          ]
        },
        {
          "name": "Navigation",
          "members": [
            "add",
            "add--alt",
            "add--filled",
            "apps",
            "arrow--down",
            "arrow--down-left",
            "arrow--down-right",
            "arrow--left",
            "arrow--right",
            "arrow--up",
            "arrow--up-left",
            "arrow--up-right",
            "caret--down",
            "caret--left",
            "caret--right",
            "caret--up",
            "chevron--down",
            "chevron--left",
            "chevron--right",
            "chevron--up",
            "close",
            "close--filled",
            "close--outline",
            "down-to-bottom",
            "draggable",
            "home",
            "menu",
            "overflow-menu--horizontal",
            "overflow-menu--vertical",
            "page--first",
            "page--last",
            "select--window",
            "subtract",
            "subtract--alt",
            "switcher",
            "up-to-top",
            "zoom--area",
            "zoom--fit",
            "zoom--in",
            "zoom--in-area",
            "zoom--out",
            "zoom--out-area",
            "zoom--reset"
          ]
        },
        {
          "name": "Operations",
          "members": [
            "add-comment",
            "area",
            "area--custom",
            "arrow-shift-down",
            "arrows--horizontal",
            "arrows--vertical",
            "automatic",
            "bookmark",
            "bookmark--add",
            "bookmark--filled",
            "branch",
            "build-tool",
            "caret--sort",
            "caret--sort--down",
            "caret--sort--up",
            "catalog--publish",
            "center--circle",
            "center--square",
            "change-catalog",
            "chat",
            "chat--launch",
            "chat--off",
            "chevron--mini",
            "chevron--sort",
            "chevron--sort--down",
            "chevron--sort--up",
            "choices",
            "choose-item",
            "circle-dash",
            "clean",
            "collapse-all",
            "collapse-categories",
            "commit",
            "compare",
            "connect",
            "connect--recursive",
            "connect--reference",
            "connect--source",
            "connect--target",
            "continuous-deployment",
            "continuous-integration",
            "convert-to-cloud",
            "deploy",
            "deploy-rules",
            "drag--horizontal",
            "drag--vertical",
            "drill-back",
            "drill-down",
            "drill-through",
            "exit",
            "expand-all",
            "expand-categories",
            "explore",
            "fade",
            "filter",
            "filter--edit",
            "filter--remove",
            "filter--reset",
            "flag",
            "flag--filled",
            "fork",
            "function-math",
            "image--search",
            "image--search--alt",
            "insert",
            "insert--page",
            "insert-syntax",
            "inspection",
            "intersect",
            "jump-link",
            "launch",
            "layers",
            "login",
            "logout",
            "loop",
            "mac--command",
            "mac--option",
            "mac--shift",
            "manage-protection",
            "maximize",
            "migrate",
            "migrate--alt",
            "minimize",
            "move",
            "new-tab",
            "not-sent",
            "not-sent--filled",
            "operations--field",
            "operations--record",
            "overlay",
            "package",
            "pan--horizontal",
            "pan--vertical",
            "pause-future",
            "pause-past",
            "pin",
            "pin--filled",
            "promote",
            "query",
            "recently-viewed",
            "recommend",
            "redo",
            "renew",
            "repeat",
            "repeat--one",
            "replicate",
            "reply",
            "reply--all",
            "request-quote",
            "reset",
            "reset--alt",
            "restart",
            "retry--failed",
            "review",
            "rotate",
            "run",
            "run--mirror",
            "save--model",
            "scan",
            "scan--alt",
            "scan--disabled",
            "search",
            "search--advanced",
            "search--locate",
            "search--locate--mirror",
            "send",
            "send--alt",
            "send--alt--filled",
            "send--filled",
            "shuffle",
            "sort--ascending",
            "sort--descending",
            "sort--remove",
            "split",
            "split-screen",
            "tag",
            "tag--edit",
            "tag--export",
            "tag--group",
            "tag--import",
            "tag--none",
            "test-tool",
            "translate",
            "transpose",
            "undo",
            "update-now",
            "upgrade",
            "view-next",
            "workspace--import",
            "x-axis",
            "y-axis",
            "z-axis"
          ]
        },
        {
          "name": "Toggle",
          "members": [
            "asleep",
            "asleep--filled",
            "awake",
            "carousel--horizontal",
            "carousel--vertical",
            "checkbox",
            "checkbox--checked",
            "checkbox--checked--filled",
            "checkbox--indeterminate",
            "checkbox--indeterminate--filled",
            "column",
            "favorite",
            "favorite--filled",
            "favorite--half",
            "flash",
            "flash--filled",
            "flash--off",
            "flash--off--filled",
            "grid",
            "light",
            "light--filled",
            "list",
            "locked",
            "microphone",
            "microphone--filled",
            "microphone--off",
            "microphone--off--filled",
            "notification",
            "notification--filled",
            "notification--new",
            "notification--off",
            "notification--off--filled",
            "phone",
            "phone--application",
            "phone--filled",
            "phone--block",
            "phone--block--filled",
            "phone--incoming",
            "phone--incoming--filled",
            "phone--off",
            "phone--off--filled",
            "phone--outgoing",
            "phone--outgoing--filled",
            "phone--settings",
            "phone--voice",
            "phone--voice--filled",
            "radio-button",
            "radio-button--checked",
            "row",
            "screen",
            "screen--off",
            "star",
            "star--filled",
            "star--half",
            "thumbnail--1",
            "thumbnail--2",
            "thumbs-down",
            "thumbs-down--filled",
            "thumbs-up",
            "thumbs-up--filled",
            "trophy",
            "trophy--filled",
            "unlocked",
            "video",
            "video--filled",
            "video--off",
            "video--off--filled",
            "view",
            "view--filled",
            "view--mode-1",
            "view--mode-2",
            "view--off",
            "view--off--filled"
          ]
        }
      ]
    },
    {
      "name": "Brand",
      "subcategories": [
        {
          "name": "Design and development",
          "members": [
            "logo--angular",
            "logo--ansible-community",
            "logo--figma",
            "logo--invision",
            "logo--jupyter",
            "logo--keybase",
            "logo--kubernetes",
            "logo--npm",
            "logo--openshift",
            "logo--python",
            "logo--r-script",
            "logo--react",
            "logo--red-hat-ansible",
            "logo--sketch",
            "logo--svelte",
            "logo--vmware",
            "logo--vmware--alt",
            "logo--vue"
          ]
        },
        {
          "name": "IBM",
          "members": [
            "bee",
            "carbon",
            "carbon-for-ibm-dotcom",
            "carbon-for-ibm-product",
            "carbon--ui-builder",
            "cloud-app",
            "edt-loop",
            "ibm-cloud",
            "ibm-security",
            "watson",
            "watson--machine-learning"
          ]
        },
        {
          "name": "Social",
          "members": [
            "logo--digg",
            "logo--discord",
            "logo--facebook",
            "logo--flickr",
            "logo--github",
            "logo--glassdoor",
            "logo--instagram",
            "logo--linkedin",
            "logo--livestream",
            "logo--medium",
            "logo--pinterest",
            "logo--quora",
            "logo--skype",
            "logo--slack",
            "logo--snapchat",
            "logo--tumblr",
            "logo--twitter",
            "logo--wechat",
            "logo--xing",
            "logo--yelp",
            "logo--youtube"
          ]
        }
      ]
    },
    {
      "name": "Enterprise",
      "subcategories": [
        {
          "name": "App catalogue",
          "members": [
            "autoscaling",
            "block-storage",
            "object-storage",
            "cics--transaction-server-zos",
            "cloud--auditing",
            "cloud--logging",
            "cloud--monitoring",
            "cloud-foundry--1",
            "cloud-registry",
            "cloud-satellite",
            "cloud-satellite--config",
            "cloud-satellite--link",
            "cloud-satellite--services",
            "content-delivery-network",
            "database--datastax",
            "database--elastic",
            "database--enterprise-db2",
            "database--etcd",
            "database--mongodb",
            "database--postgreSQL",
            "database--rabbit",
            "database--redis",
            "direct-link",
            "dns-services",
            "flow-logs-vpc",
            "ibm--bluepay",
            "ibm--content-services",
            "ibm--data-replication",
            "ibm--datastage",
            "ibm--db2",
            "ibm--db2--alt",
            "ibm--match-360",
            "ibm--mq",
            "ibm--open-enterprise-languages",
            "ibm--power-vs",
            "ibm--telehealth",
            "ibm--tenet",
            "ibm--toolchain",
            "ibm-cloud--app-id",
            "ibm-cloud--citrix-daas",
            "ibm-cloud--continuous-delivery",
            "ibm-cloud--dedicated-host",
            "ibm-cloud--direct-link-1--connect",
            "ibm-cloud--direct-link-1--dedicated",
            "ibm-cloud--direct-link-1--dedicated-hosting",
            "ibm-cloud--direct-link-1--exchange",
            "ibm-cloud--direct-link-2--connect",
            "ibm-cloud--direct-link-2--dedicated",
            "ibm-cloud--direct-link-2--dedicated-hosting",
            "ibm-cloud--event-notification",
            "ibm-cloud--event-streams",
            "ibm-cloud--for-education",
            "ibm-cloud--HSM",
            "ibm-cloud--hyper-protect-crypto-services",
            "ibm-cloud--hyper-protect-dbaas",
            "ibm-cloud--hyper-protect-vs",
            "ibm-cloud--internet-services",
            "ibm-cloud--ipsec-vpn",
            "ibm-cloud--key-protect",
            "ibm-cloud--kubernetes-service",
            "ibm-cloud--logging",
            "ibm-cloud--mass-data-migration",
            "ibm-cloud--pal",
            "ibm-cloud--privileged-access-gateway",
            "ibm-cloud--secrets-manager",
            "ibm-cloud--security-compliance-center",
            "ibm-cloud--subnets",
            "ibm-cloud--sysdig-secure",
            "ibm-cloud--transit-gateway",
            "ibm-cloud--vpc-endpoints",
            "ibm-cloud-pak--applications",
            "ibm-cloud-pak--business-automation",
            "ibm-cloud-pak--data",
            "ibm-cloud-pak--integration",
            "ibm-cloud-pak--MANTA-automated-data-lineage",
            "ibm-cloud-pak--multicloud-mgmt",
            "ibm-cloud-pak--netezza",
            "ibm-cloud-pak--network-automation",
            "ibm-cloud-pak--security",
            "ibm-cloud-pak--system",
            "ibm-cloud-pak--watson-aiops",
            "ibm-security--services",
            "ibm-watson--assistant",
            "ibm-watson--discovery",
            "ibm-watson--knowledge-catalog",
            "ibm-watson--knowledge-studio",
            "ibm-watson--language-translator",
            "ibm-watson--machine-learning",
            "ibm-watson--natural-language-classifier",
            "ibm-watson--natural-language-understanding",
            "ibm-watson--openscale",
            "ibm-watson--orders",
            "ibm-watson--query",
            "ibm-watson--speech-to-text",
            "ibm-watson--studio",
            "ibm-watson--text-to-speech",
            "ibm-watson--tone-analyzer",
            "ibm-z--cloud-mod-stack",
            "ibm-z-cloud--provisioning",
            "ibm-z-os--package-manager",
            "infrastructure--classic",
            "load-balancer--vpc",
            "scis--control-tower",
            "scis--transparent-supply",
            "virtual-private-cloud--alt",
            "vlan--ibm"
          ]
        },
        {
          "name": "Commerce",
          "members": [
            "apple",
            "apple--dash",
            "account",
            "basketball",
            "bat",
            "bee-bat",
            "bottles--01",
            "bottles--01--dash",
            "bottles--02",
            "bottles--02--dash",
            "bottles--container",
            "building",
            "corn",
            "currency",
            "currency--baht",
            "currency--dollar",
            "currency--euro",
            "currency--lira",
            "currency--pound",
            "currency--ruble",
            "currency--rupee",
            "currency--shekel",
            "currency--won",
            "currency--yen",
            "delivery",
            "delivery--add",
            "delivery--parcel",
            "drink--01",
            "drink--02",
            "enterprise",
            "finance",
            "fish",
            "fish--multiple",
            "fragile",
            "fruit-bowl",
            "gift",
            "industry",
            "inventory-management",
            "keep-dry",
            "money",
            "monster",
            "noodle-bowl",
            "piggy-bank",
            "piggy-bank--slot",
            "purchase",
            "receipt",
            "recycle",
            "shopping--bag",
            "shopping--cart",
            "shopping--cart--arrow-down",
            "shopping--cart--arrow-up",
            "shopping--cart--clear",
            "shopping--cart--error",
            "shopping--cart--minus",
            "shopping--cart--plus",
            "shopping--catalog",
            "soccer",
            "sprout",
            "stack-limitation",
            "store",
            "strawberry",
            "tennis",
            "tennis-ball",
            "this-side-up",
            "tree",
            "two-person-lift",
            "wallet",
            "wheat",
            "wireless-checkout"
          ]
        },
        {
          "name": "Health",
          "members": [
            "3D-Cursor",
            "3D-cursor--alt",
            "3D-curve--auto-colon",
            "3D-curve--auto-vessels",
            "3D-curve--manual",
            "3D-iCa",
            "3D-MPR-Toggle",
            "3D-print-mesh",
            "3rd-party-connected",
            "3D-software",
            "ai-results",
            "ai-results--high",
            "ai-results--low",
            "ai-results--medium",
            "ai-results--urgent",
            "ai-results--very-high",
            "ai-status",
            "ai-status--complete",
            "ai-status--failed",
            "ai-status--in-progress",
            "ai-status--queued",
            "ai-status--rejected",
            "angle",
            "annotation-visibility",
            "arrow--annotation",
            "auto-scroll",
            "brush-freehand",
            "brush-polygon",
            "cd--archive",
            "cd--create-archive",
            "cd--create-exchange",
            "chemistry",
            "chemistry--reference",
            "circle-measurement",
            "cobb-angle",
            "contour--draw",
            "contour--edit",
            "contour-finding",
            "coronavirus",
            "cross-reference",
            "cut-in-half",
            "denominate",
            "dicom--6000",
            "dicom--overlay",
            "dna",
            "download-study",
            "edge-enhancement",
            "edge-enhancement--01",
            "edge-enhancement--02",
            "edge-enhancement--03",
            "erase--3D",
            "exam-mode",
            "fusion-blender",
            "hanging-protocol",
            "health-cross",
            "HL7-attributes",
            "hole-filling",
            "hole-filling--cursor",
            "iCA-2D",
            "image--medical",
            "image-availability--local",
            "image-availability--retrieving",
            "image-availability--unavailable",
            "interactive-segmentation-cursor",
            "launch-study--1",
            "launch-study--2",
            "launch-study--3",
            "magnify",
            "mammogram",
            "medication",
            "medication--alert",
            "medication--reminder",
            "nominate",
            "page-scroll",
            "pet-image--B",
            "pet-image--O",
            "pills",
            "pills--add",
            "pills--subtract",
            "pointer-text",
            "QC-launch",
            "region-analysis--area",
            "region-analysis--volume",
            "registration",
            "rotate--180",
            "rotate--360",
            "save--annotation",
            "save--image",
            "save--series",
            "scalpel--cursor",
            "scalpel--lasso",
            "scalpel--select",
            "smoothing",
            "smoothing--cursor",
            "spine-label",
            "split--discard",
            "stacked-move",
            "stacked-scrolling--1",
            "stacked-scrolling--2",
            "status--acknowledge",
            "status--change",
            "status--partial-fail",
            "status--resolved",
            "stress-breath-editor",
            "study--next",
            "study--previous",
            "study--read",
            "study--skip",
            "study--transfer",
            "study--unread",
            "study--view",
            "sub-volume",
            "threshold",
            "thumbnail-preview",
            "text-annotation-toggle",
            "window--auto",
            "window--base",
            "window--black-saturation",
            "window--overlay",
            "window--preset",
            "zoom-pan"
          ]
        },
        {
          "name": "Research",
          "members": [
            "barrier",
            "bloch-sphere",
            "ccX",
            "circuit-composer",
            "composer-edit",
            "cU1",
            "cU3",
            "cY",
            "cZ",
            "H",
            "hinton-plot",
            "iD",
            "matrix",
            "operation",
            "operation--gauge",
            "operation--if",
            "S",
            "S--alt",
            "T",
            "T--alt",
            "U1",
            "U2",
            "U3",
            "X",
            "Y",
            "Z"
          ]
        }
      ]
    },
    {
      "name": "Organization",
      "subcategories": [
        {
          "name": "Alphanumeric",
          "members": [
            "character--decimal",
            "character--fraction",
            "character--integer",
            "character--lower-case",
            "character--negative-number",
            "character--sentence-case",
            "character--upper-case",
            "character--whole-number",
            "letter--Aa",
            "letter--Bb",
            "letter--Cc",
            "letter--Dd",
            "letter--Ee",
            "letter--Ff",
            "letter--Gg",
            "letter--Hh",
            "letter--Ii",
            "letter--Jj",
            "letter--Kk",
            "letter--Ll",
            "letter--Mm",
            "letter--Nn",
            "letter--Oo",
            "letter--Pp",
            "letter--Qq",
            "letter--Rr",
            "letter--Ss",
            "letter--Tt",
            "letter--Uu",
            "letter--Vv",
            "letter--Ww",
            "letter--Xx",
            "letter--Yy",
            "letter--Zz",
            "number--0",
            "number--1",
            "number--2",
            "number--3",
            "number--4",
            "number--5",
            "number--6",
            "number--7",
            "number--8",
            "number--9",
            "number--small--0",
            "number--small--1",
            "number--small--2",
            "number--small--3",
            "number--small--4",
            "number--small--5",
            "number--small--6",
            "number--small--7",
            "number--small--8",
            "number--small--9",
            "beta",
            "omega",
            "sigma"
          ]
        },
        {
          "name": "Data",
          "members": [
            "activity",
            "analytics",
            "analytics--custom",
            "analytics--reference",
            "app-connectivity",
            "archive",
            "blockchain",
            "boolean",
            "boot-volume",
            "boot-volume--alt",
            "box-plot",
            "calculation",
            "calculation--alt",
            "calendar--heat-map",
            "character-patterns",
            "chart--3D",
            "chart--area",
            "chart--area-smooth",
            "chart--area-stepper",
            "chart--average",
            "chart--bar",
            "chart--bar-floating",
            "chart--bar-overlay",
            "chart--bar-stacked",
            "chart--bar-target",
            "chart--bubble",
            "chart--bubble-packed",
            "chart--bullet",
            "chart--candlestick",
            "chart--cluster-bar",
            "chart--column",
            "chart--column-floating",
            "chart--column-target",
            "chart--combo",
            "chart--combo-stacked",
            "chart--custom",
            "chart--error-bar",
            "chart--error-bar--alt",
            "chart--evaluation",
            "chart--high-low",
            "chart--histogram",
            "chart--line",
            "chart--line--data",
            "chart--line-smooth",
            "chart--marimekko",
            "chart--maximum",
            "chart--minimum",
            "chart--median",
            "chart--multi-line",
            "chart--multitype",
            "chart--network",
            "chart--parallel",
            "chart--pie",
            "chart--point",
            "chart--population",
            "chart--radar",
            "chart--radial",
            "chart--relationship",
            "chart--ring",
            "chart--river",
            "chart--rose",
            "chart--scatter",
            "chart--spiral",
            "chart--stacked",
            "chart--stepper",
            "chart--sunburst",
            "chart--treemap",
            "chart--t-sne",
            "chart--venn-diagram",
            "chart--violin-plot",
            "chart--waterfall",
            "chart--win-loss",
            "choropleth-map",
            "circle-packing",
            "circle--filled",
            "classifier--language",
            "column-dependency",
            "concept",
            "container-software",
            "cost",
            "cost--total",
            "covariate",
            "cross-tab",
            "data--1",
            "data--2",
            "data--base",
            "data--base--alt",
            "data--check",
            "data--connected",
            "data--error",
            "data--format",
            "data--reference",
            "data--set",
            "data--structured",
            "data--unstructured",
            "data--view",
            "data--view--alt",
            "data-bin",
            "data-class",
            "data-collection",
            "data-definition",
            "data-enrichment",
            "data-enrichment--add",
            "data-player",
            "data-quality-definition",
            "data-refinery",
            "data-refinery--reference",
            "data-share",
            "data-table",
            "data-table--reference",
            "data-vis--1",
            "data-vis--2",
            "data-vis--3",
            "data-vis--4",
            "data-volume",
            "data-volume--alt",
            "datastore",
            "decision-tree",
            "diagram",
            "diagram--reference",
            "document-sentiment",
            "double-integer",
            "driver-analysis",
            "factor",
            "flow",
            "flow--connection",
            "flow--data",
            "flow--modeler",
            "flow--modeler--reference",
            "flow--stream",
            "flow--stream--reference",
            "graphical-data-flow",
            "growth",
            "hashtag",
            "heat-map",
            "heat-map--02",
            "heat-map--03",
            "heat-map--stocks",
            "hybrid-networking",
            "improve-relevance",
            "interactions",
            "increase-level",
            "join--full",
            "join--inner",
            "join--left",
            "join--outer",
            "join--right",
            "linux",
            "linux--alt",
            "managed-solutions",
            "math-curve",
            "model-builder",
            "model-builder--reference",
            "name-space",
            "network--1",
            "network--2",
            "network--3",
            "network--3--reference",
            "network--4",
            "network--4--reference",
            "nominal",
            "ordinal",
            "parent-child",
            "parameter",
            "phrase-sentiment",
            "presentation-file",
            "progress-bar",
            "progress-bar--round",
            "qq-plot",
            "quadrant-plot",
            "query-queue",
            "report",
            "report--data",
            "row--collapse",
            "row--expand",
            "sankey-diagram",
            "sankey-diagram--alt",
            "scatter-matrix",
            "schematics",
            "share-knowledge",
            "show-data--cards",
            "skill-level",
            "skill-level--advanced",
            "skill-level--basic",
            "skill-level--intermediate",
            "stem-leaf-plot",
            "storage-pool",
            "storage-request",
            "string-integer",
            "string-text",
            "subflow",
            "subflow--local",
            "summary--KPI",
            "summary--KPI--mirror",
            "sys-provision",
            "table",
            "table--alias",
            "table--built",
            "table--shortcut",
            "table--split",
            "term",
            "text-link",
            "text-link--analysis",
            "text-mining",
            "text-mining--applier",
            "time-plot",
            "transform--binary",
            "transform--instructions",
            "transform--language",
            "tree-view",
            "tree-view--alt",
            "type-pattern",
            "types",
            "value--variable",
            "virtual-column",
            "virtual-column--key",
            "virtual-machine",
            "virtual-private-cloud",
            "visual-recognition",
            "vmdk-disk",
            "word-cloud"
          ]
        },
        {
          "name": "File",
          "members": [
            "4K",
            "4K--filled",
            "api",
            "API--1",
            "app",
            "application",
            "badge",
            "book",
            "CAD",
            "catalog",
            "categories",
            "category",
            "category--add",
            "category--and",
            "category--new",
            "category--new-each",
            "CDA",
            "certificate",
            "certificate--check",
            "classification",
            "closed-caption",
            "closed-caption--alt",
            "closed-caption--filled",
            "cloud-foundry--2",
            "content-view",
            "copy",
            "copy--file",
            "copy--link",
            "course",
            "CSV",
            "cube",
            "cube-view",
            "DOC",
            "document",
            "document--add",
            "document--attachment",
            "document--audio",
            "document--blank",
            "document--download",
            "document--epdf",
            "document--export",
            "document--import",
            "document--pdf",
            "document--preliminary",
            "document--protected",
            "document--security",
            "document--signed",
            "document--sketch",
            "document--subtract",
            "document--tasks",
            "document--unknown",
            "document--unprotected",
            "document--video",
            "document--view",
            "document--word-processor",
            "document--word-processor--reference",
            "download",
            "DVR",
            "export",
            "floorplan",
            "folder",
            "folder--add",
            "folder--details",
            "folder--details--reference",
            "folder--move-to",
            "folder--off",
            "folder--open",
            "folder--parent",
            "folder--shared",
            "folders",
            "gamification",
            "GIF",
            "generate-pdf",
            "HD",
            "HD--filled",
            "HDR",
            "HTML",
            "HTML--reference",
            "HTTP",
            "import-export",
            "ISO",
            "ISO--filled",
            "ISO--outline",
            "JPG",
            "JSON",
            "JSON--reference",
            "legend",
            "license",
            "license--draft",
            "license--global",
            "license--maintenance",
            "license--maintenance-draft",
            "license--third-party",
            "license--third-party-draft",
            "list--dropdown",
            "media--library",
            "media--library--filled",
            "model",
            "model--alt",
            "model--reference",
            "MOV",
            "MP3",
            "MP4",
            "MPEG",
            "MPG2",
            "music",
            "music--add",
            "music--remove",
            "no-ticket",
            "non-certified",
            "notebook",
            "notebook--reference",
            "order-details",
            "panel-expansion",
            "paste",
            "PDF",
            "PDF--reference",
            "plan",
            "playlist",
            "PNG",
            "policy",
            "popup",
            "PPT",
            "product",
            "RAW",
            "repo--artifact",
            "repo--source-code",
            "roadmap",
            "rule",
            "rule--cancelled",
            "rule--data-quality",
            "rule--draft",
            "rule--filled",
            "rule--test",
            "result",
            "result--new",
            "result--old",
            "scale",
            "script",
            "script--reference",
            "SDK",
            "security",
            "SLM",
            "SQL",
            "star--review",
            "SVG",
            "table-of-contents",
            "task",
            "task--add",
            "task--approved",
            "task--asset-view",
            "task--complete",
            "task--location",
            "task--remove",
            "task--settings",
            "task--star",
            "task--tools",
            "task--view",
            "template",
            "ticket",
            "TIF",
            "TSV",
            "TXT",
            "TXT--reference",
            "upload",
            "version",
            "websheet",
            "WMV",
            "workspace",
            "XLS",
            "XML",
            "ZIP",
            "ZIP--reference"
          ]
        },
        {
          "name": "Status",
          "members": [
            "caution",
            "caution-inverted",
            "checkmark",
            "checkmark--filled",
            "checkmark--filled--error",
            "checkmark--filled--warning",
            "checkmark--outline",
            "checkmark--outline--error",
            "checkmark--outline--warning",
            "circle-fill",
            "circle-stroke",
            "condition--point",
            "condition--wait-point",
            "critical",
            "critical-severity",
            "diamond-fill",
            "error",
            "error--filled",
            "error--outline",
            "low-severity",
            "help",
            "help--filled",
            "in-progress",
            "in-progress--error",
            "in-progress--warning",
            "incomplete",
            "incomplete--cancel",
            "incomplete--error",
            "incomplete--warning",
            "information",
            "information--disabled",
            "information--filled",
            "information--square",
            "information--square--filled",
            "misuse",
            "misuse--outline",
            "pending",
            "pending--filled",
            "queued",
            "square-fill",
            "undefined",
            "undefined--filled",
            "unknown",
            "unknown--filled",
            "warning",
            "warning--alt",
            "warning--alt--filled",
            "warning--alt-inverted",
            "warning--alt-inverted--filled",
            "warning--filled",
            "warning--hex",
            "warning--hex--filled",
            "warning--other",
            "warning-square",
            "warning-square--filled"
          ]
        },
        {
          "name": "Systems",
          "members": [
            "application--mobile",
            "application--virtual",
            "application--web",
            "assembly",
            "assembly--cluster",
            "assembly--reference",
            "bare-metal-server",
            "bare-metal-server--01",
            "bare-metal-server--02",
            "bastion-host",
            "batch-job",
            "batch-job--step",
            "block-storage--alt",
            "box--extra-large",
            "box--large",
            "box--medium",
            "box--small",
            "cics--cmas",
            "cics--db2-connection",
            "cics--explorer",
            "cics--program",
            "cics--sit",
            "cics--sit-overrides",
            "cics--system-group",
            "cics--wui-region",
            "cics-region",
            "cics-region--alt",
            "cics-region--routing",
            "cics-region--target",
            "cicsplex",
            "cloud--alerting",
            "cloud--data-ops",
            "cloud-services",
            "cloud--service-management",
            "chat--operational",
            "code-signing-service",
            "communication--unified",
            "container-registry",
            "container-services",
            "data--center",
            "data-accessor",
            "data-backup",
            "data-blob",
            "data-diode",
            "db2--buffer-pool",
            "db2--data-sharing-group",
            "db2--database",
            "deployment-unit--data",
            "deployment-unit--execution",
            "deployment-unit--installation",
            "deployment-unit--presentation",
            "deployment-unit--technical--data",
            "deployment-unit--technical--execution",
            "deployment-unit--technical--installation",
            "deployment-unit--technical--presentation",
            "directory-domain",
            "edge-node--alt",
            "encryption",
            "executable-program",
            "file-storage",
            "firewall",
            "firewall--classic",
            "floating-ip",
            "gateway",
            "gateway--api",
            "gateway--mail",
            "gateway--public",
            "gateway--security",
            "gateway--user-access",
            "gateway--vpn",
            "group--access",
            "group--account",
            "group--resource",
            "group--security",
            "gui",
            "gui--management",
            "hardware-security-module",
            "hybrid-networking--alt",
            "id-management",
            "image-service",
            "instance--bx",
            "instance--classic",
            "instance--cx",
            "instance--mx",
            "instance--virtual",
            "intent-request--active",
            "intent-request--create",
            "intent-request--heal",
            "intent-request--inactive",
            "intent-request--scale-in",
            "intent-request--scale-out",
            "intent-request--uninstall",
            "intent-request--upgrade",
            "intrusion-prevention",
            "kubernetes",
            "load-balancer--application",
            "load-balancer--classic",
            "load-balancer--global",
            "load-balancer--listener",
            "load-balancer--local",
            "load-balancer--network",
            "load-balancer--pool",
            "logical-partition",
            "message-queue",
            "microservices--1",
            "microservices--2",
            "mobility--services",
            "network--admin-control",
            "network--enterprise",
            "network--overlay",
            "network--public",
            "object-storage--alt",
            "pcn--e-node",
            "pcn--military",
            "pcn--p-node",
            "pcn--z-node",
            "point-of-presence",
            "property-relationship",
            "router",
            "router--voice",
            "router--wifi",
            "screen-map",
            "screen-map--set",
            "security-services",
            "server--dns",
            "server--proxy",
            "server--time",
            "session-border-control",
            "slisor",
            "software-resource",
            "software-resource--cluster",
            "software-resource--resource",
            "subnet-acl-rules",
            "switch-layer-2",
            "switch-layer-3",
            "tcp-ip-service",
            "terminal--3270",
            "tsq",
            "two-factor-authentication",
            "vehicle--api",
            "vehicle--connected",
            "vehicle--insights",
            "vehicle--services",
            "virtual-desktop",
            "vlan",
            "volume--block-storage",
            "volume--file-storage",
            "volume--object-storage",
            "vpn--connection",
            "vpn--policy",
            "wifi-bridge",
            "wifi-bridge--alt",
            "wifi--not-secure",
            "wifi--secure",
            "workflow-automation",
            "z--lpar",
            "z--systems",
            "zos",
            "zos--sysplex"
          ]
        }
      ]
    },
    {
      "name": "Person",
      "subcategories": [
        {
          "name": "Senses",
          "members": [
            "cognitive",
            "hearing",
            "idea",
            "movement",
            "need",
            "smell",
            "taste",
            "touch--1",
            "touch--1-down",
            "touch--1-down--filled",
            "touch--1--filled",
            "touch--2",
            "touch--2--filled",
            "touch--interaction"
          ]
        },
        {
          "name": "User",
          "members": [
            "accessibility",
            "accessibility--alt",
            "accessibility--color",
            "accessibility--color--filled",
            "collaborate",
            "cough",
            "credentials",
            "dog-walker",
            "education",
            "events",
            "events--alt",
            "face--activated",
            "face--activated--add",
            "face--activated--filled",
            "face--add",
            "face--cool",
            "face--dissatisfied",
            "face--dissatisfied--filled",
            "face--dizzy",
            "face--dizzy--filled",
            "face--mask",
            "face--neutral",
            "face--neutral--filled",
            "face--pending",
            "face--pending--filled",
            "face--satisfied",
            "face--satisfied--filled",
            "face--wink",
            "face--wink--filled",
            "friendship",
            "gender--female",
            "gender--male",
            "group",
            "group--presentation",
            "identification",
            "partnership",
            "person",
            "person--favorite",
            "sight",
            "transgender",
            "user",
            "user--access",
            "user--activity",
            "user--admin",
            "user--avatar",
            "user--avatar--filled",
            "user--avatar--filled--alt",
            "user--certification",
            "user--data",
            "user--favorite",
            "user--favorite--alt",
            "user--favorite--alt--filled",
            "user--filled",
            "user--follow",
            "user--identification",
            "user--military",
            "user--multiple",
            "user--online",
            "user--profile",
            "user--role",
            "user--service-desk",
            "user--settings",
            "user--simulation",
            "user--speaker",
            "user--x-ray",
            "user-profile--alt",
            "voice-activate"
          ]
        }
      ]
    },
    {
      "name": "Planning",
      "subcategories": [
        {
          "name": "Time",
          "members": [
            "alarm",
            "alarm--add",
            "alarm--subtract",
            "calendar",
            "calendar--add",
            "calendar--add--alt",
            "calendar--settings",
            "calendar--tools",
            "event",
            "event--schedule",
            "hourglass",
            "reminder",
            "reminder--medical",
            "snooze",
            "time",
            "timer"
          ]
        },
        {
          "name": "Travel",
          "members": [
            "airline--digital-gate",
            "airline--manage-gates",
            "airline--passenger-care",
            "airline--rapid-board",
            "airport--01",
            "airport--02",
            "airport-location",
            "arrival",
            "baggage-claim",
            "bar",
            "bicycle",
            "boot",
            "bus",
            "cabin-care",
            "cabin-care--alert",
            "cabin-care--alt",
            "cafe",
            "campsite",
            "car",
            "car--front",
            "charging-station",
            "charging-station--filled",
            "compass",
            "construction",
            "crossroads",
            "crowd-report",
            "crowd-report--filled",
            "cyclist",
            "delivery-truck",
            "departure",
            "direction--bear-right--01",
            "direction--bear-right--01--filled",
            "direction--bear-right--02",
            "direction--bear-right--02--filled",
            "direction--curve",
            "direction--curve--filled",
            "direction--fork",
            "direction--fork--filled",
            "direction--loop-left",
            "direction--loop-left--filled",
            "direction--loop-right",
            "direction--loop-right--filled",
            "direction--merge",
            "direction--merge--filled",
            "direction--right--01",
            "direction--right--01--filled",
            "direction--right--02",
            "direction--right--02--filled",
            "direction--rotary--first-right",
            "direction--rotary--first-right--filled",
            "direction--rotary--right",
            "direction--rotary--right--filled",
            "direction--rotary--straight",
            "direction--rotary--straight--filled",
            "direction--sharp-turn",
            "direction--sharp-turn--filled",
            "direction--straight",
            "direction--straight--filled",
            "direction--straight--right",
            "direction--straight--right--filled",
            "direction--u-turn",
            "direction--u-turn--filled",
            "earth",
            "earth--americas",
            "earth--americas--filled",
            "earth--europe-africa",
            "earth--europe-africa--filled",
            "earth--filled",
            "earth--southeast-asia",
            "earth--southeast-asia--filled",
            "fire",
            "flagging-taxi",
            "flight--international",
            "flight--roster",
            "flight--schedule",
            "gas-station",
            "gas-station--filled",
            "globe",
            "harbor",
            "helicopter",
            "help-desk",
            "hospital",
            "hospital-bed",
            "hotel",
            "lifesaver",
            "location",
            "location--company",
            "location--company--filled",
            "location--filled",
            "location--hazard",
            "location--hazard--filled",
            "location--heart",
            "location--heart--filled",
            "location--person",
            "location--person--filled",
            "location--save",
            "location--star",
            "location--star--filled",
            "map",
            "map--center",
            "map--identify",
            "map-boundary",
            "milestone",
            "military-camp",
            "monument",
            "mountain",
            "navaid--civil",
            "navaid--dme",
            "navaid--helipad",
            "navaid--military",
            "navaid--military-civil",
            "navaid--ndb",
            "navaid--ndb-dme",
            "navaid--private",
            "navaid--seaplane",
            "navaid--tacan",
            "navaid--vhfor",
            "navaid--vor",
            "navaid--vordme",
            "navaid--vortac",
            "palm-tree",
            "passenger--drinks",
            "passenger--plus",
            "pedestrian",
            "pedestrian-child",
            "pedestrian--family",
            "picnic-area",
            "plane",
            "plane--private",
            "plane--sea",
            "police",
            "restaurant",
            "restaurant--fine",
            "road",
            "road--weather",
            "scooter",
            "scooter--front",
            "service-desk",
            "shuttle",
            "stop-sign",
            "stop-sign--filled",
            "swim",
            "tank",
            "taxi",
            "theater",
            "traffic--event",
            "traffic--flow",
            "traffic--flow-incident",
            "traffic--incident",
            "traffic--weather-incident",
            "traffic-cone",
            "train",
            "train--heart",
            "train--profile",
            "train--speed",
            "train--ticket",
            "train--time",
            "tram",
            "van",
            "worship",
            "worship--christian",
            "worship--jewish",
            "worship--muslim"
          ]
        },
        {
          "name": "Weather",
          "members": [
            "accumulation--ice",
            "accumulation--precipitation",
            "accumulation--rain",
            "accumulation--snow",
            "agriculture-analytics",
            "buoy",
            "carbon-accounting",
            "cloud",
            "cloud-ceiling",
            "cloudy",
            "crop-growth",
            "crop-health",
            "dew-point",
            "dew-point--filled",
            "drought",
            "earthquake",
            "energy--renewable",
            "flood",
            "flood--warning",
            "fog",
            "forecast--hail",
            "forecast--hail-30",
            "forecast--lightning",
            "forecast--lightning-30",
            "hail",
            "haze",
            "haze--night",
            "humidity",
            "humidity--alt",
            "hurricane",
            "ice--accretion",
            "ice--vision",
            "lightning",
            "map-boundary--vegetation",
            "marine-warning",
            "mixed-rain-hail",
            "moon",
            "moonrise",
            "moonset",
            "mostly-cloudy",
            "mostly-cloudy--night",
            "not-available",
            "observed--hail",
            "observed--lightning",
            "outlook-severe",
            "partly-cloudy",
            "partly-cloudy--night",
            "pest",
            "pressure",
            "pressure--filled",
            "radar--enhanced",
            "radar--weather",
            "rain",
            "rain--drizzle",
            "rain--heavy",
            "rain--scattered",
            "rain--scattered--night",
            "rain-drop",
            "ref-evapotranspiration",
            "sailboat--coastal",
            "sailboat--offshore",
            "satellite--radar",
            "satellite--weather",
            "sleet",
            "smoke",
            "snow",
            "snow--blizzard",
            "snow--heavy",
            "snow--scattered",
            "snow--scattered--night",
            "snow-density",
            "snowflake",
            "soil-moisture",
            "soil-moisture--field",
            "soil-moisture--global",
            "soil-temperature",
            "soil-temperature--field",
            "soil-temperature--global",
            "solar-panel",
            "stay-inside",
            "storm-tracker",
            "sun",
            "sunrise",
            "sunset",
            "temperature",
            "temperature--celsius",
            "temperature--celsius--alt",
            "temperature--fahrenheit",
            "temperature--fahrenheit--alt",
            "temperature--feels-like",
            "temperature--frigid",
            "temperature--hot",
            "temperature--inversion",
            "temperature--max",
            "temperature--min",
            "temperature--water",
            "thunderstorm",
            "thunderstorm--scattered",
            "thunderstorm--scattered--night",
            "thunderstorm--severe",
            "thunderstorm--strong",
            "tides",
            "tornado",
            "tornado-warning",
            "tree--fall-risk",
            "tropical-storm",
            "tropical-storm--model-tracks",
            "tropical-storm--tracks",
            "tropical-warning",
            "tsunami",
            "uv-index",
            "uv-index--alt",
            "uv-index--filled",
            "vegetation--asset",
            "wave-direction",
            "wave-height",
            "wave-period",
            "weather-front--cold",
            "weather-front--stationary",
            "weather-front--warm",
            "weather-station",
            "wind-gusts",
            "wind-power",
            "wind-stream",
            "windy",
            "windy--dust",
            "windy--snow",
            "windy--strong",
            "winter-warning",
            "wintry-mix"
          ]
        }
      ]
    },
    {
      "name": "Tools",
      "subcategories": [
        {
          "name": "Technology",
          "members": [
            "airplay",
            "airplay--filled",
            "aperture",
            "asset",
            "asset--confirm",
            "asset--digital-twin",
            "asset--view",
            "at",
            "audio-console",
            "augmented-reality",
            "barcode",
            "battery--charging",
            "battery--empty",
            "battery--full",
            "battery--half",
            "battery--low",
            "battery--quarter",
            "blog",
            "bluetooth",
            "bluetooth--off",
            "bot",
            "breaking-change",
            "building--insights-1",
            "building--insights-2",
            "building--insights-3",
            "calculator",
            "calculator--check",
            "camera",
            "camera--action",
            "cell-tower",
            "chat-bot",
            "chip",
            "cloud--download",
            "cloud--offline",
            "cloud--upload",
            "code",
            "code--hide",
            "code--reference",
            "connection-signal",
            "connection-signal--off",
            "connection--receive",
            "connection--send",
            "connection--two-way",
            "cookie",
            "debug",
            "deployment-pattern",
            "deployment-policy",
            "desk--adjustable",
            "development",
            "devices",
            "drone",
            "drone--delivery",
            "drone--front",
            "drone--video",
            "edge-cluster",
            "edge-device",
            "edge-node",
            "edge-service",
            "email",
            "email--new",
            "equalizer",
            "fetch-upload",
            "fetch-upload--cloud",
            "fingerprint-recognition",
            "forum",
            "function",
            "game--console",
            "game--wireless",
            "headphones",
            "headset",
            "integration",
            "iot--connect",
            "iot--platform",
            "keyboard",
            "keyboard--off",
            "laptop",
            "location--current",
            "machine-learning",
            "machine-learning-model",
            "mail--all",
            "mail--reply",
            "media-cast",
            "mobile",
            "mobile--add",
            "mobile--audio",
            "mobile--check",
            "mobile--download",
            "mobile--landscape",
            "outage",
            "password",
            "phone--ip",
            "plug",
            "plug--filled",
            "port--input",
            "port--output",
            "printer",
            "qr-code",
            "radio",
            "radio--combat",
            "radio--push-to-talk",
            "rocket",
            "rss",
            "satellite",
            "share",
            "signal-strength",
            "sim-card",
            "service-id",
            "tablet",
            "tablet--landscape",
            "terminal",
            "transmission-lte",
            "USB",
            "voicemail",
            "VPN",
            "watch",
            "webhook",
            "wifi",
            "wifi--controller",
            "wifi--off",
            "wikis"
          ]
        },
        {
          "name": "Instruments",
          "members": [
            "binoculars",
            "box",
            "bullhorn",
            "calibrate",
            "cursor--1",
            "cursor--2",
            "meter",
            "meter--alt",
            "microscope",
            "portfolio",
            "radar",
            "ruler",
            "ruler--alt",
            "scales",
            "scales--tipped",
            "scalpel",
            "stamp",
            "stethoscope",
            "tool-box",
            "tool-kit",
            "tools",
            "tools--alt",
            "umbrella"
          ]
        }
      ]
    }
  ]
}
